// @__NO_SIDE_EFFECTS__
function $0(n) {
  const e = /* @__PURE__ */ Object.create(null);
  for (const t of n.split(",")) e[t] = 1;
  return (t) => t in e;
}
const Yt = {}, Er = [], Ur = () => {
}, t5 = () => !1, vf = (n) => n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110 && // uppercase letter
(n.charCodeAt(2) > 122 || n.charCodeAt(2) < 97), yf = (n) => n.startsWith("onUpdate:"), li = Object.assign, n5 = (n, e) => {
  const t = n.indexOf(e);
  t > -1 && n.splice(t, 1);
}, jA = Object.prototype.hasOwnProperty, Nt = (n, e) => jA.call(n, e), pt = Array.isArray, Mo = (n) => Hc(n) === "[object Map]", dl = (n) => Hc(n) === "[object Set]", rx = (n) => Hc(n) === "[object Date]", Ot = (n) => typeof n == "function", en = (n) => typeof n == "string", ji = (n) => typeof n == "symbol", jt = (n) => n !== null && typeof n == "object", i5 = (n) => (jt(n) || Ot(n)) && Ot(n.then) && Ot(n.catch), s5 = Object.prototype.toString, Hc = (n) => s5.call(n), HA = (n) => Hc(n).slice(8, -1), o5 = (n) => Hc(n) === "[object Object]", D0 = (n) => en(n) && n !== "NaN" && n[0] !== "-" && "" + parseInt(n, 10) === n, Ud = /* @__PURE__ */ $0(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), xf = (n) => {
  const e = /* @__PURE__ */ Object.create(null);
  return ((t) => e[t] || (e[t] = n(t)));
}, VA = /-\w/g, Yn = xf(
  (n) => n.replace(VA, (e) => e.slice(1).toUpperCase())
), WA = /\B([A-Z])/g, qo = xf(
  (n) => n.replace(WA, "-$1").toLowerCase()
), wf = xf((n) => n.charAt(0).toUpperCase() + n.slice(1)), cm = xf(
  (n) => n ? `on${wf(n)}` : ""
), ss = (n, e) => !Object.is(n, e), Gh = (n, ...e) => {
  for (let t = 0; t < n.length; t++)
    n[t](...e);
}, r5 = (n, e, t, i = !1) => {
  Object.defineProperty(n, e, {
    configurable: !0,
    enumerable: !1,
    writable: i,
    value: t
  });
}, O0 = (n) => {
  const e = parseFloat(n);
  return isNaN(e) ? n : e;
}, qA = (n) => {
  const e = en(n) ? Number(n) : NaN;
  return isNaN(e) ? n : e;
};
let ax;
const kf = () => ax || (ax = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : {});
function de(n) {
  if (pt(n)) {
    const e = {};
    for (let t = 0; t < n.length; t++) {
      const i = n[t], s = en(i) ? JA(i) : de(i);
      if (s)
        for (const o in s)
          e[o] = s[o];
    }
    return e;
  } else if (en(n) || jt(n))
    return n;
}
const KA = /;(?![^(]*\))/g, YA = /:([^]+)/, XA = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function JA(n) {
  const e = {};
  return n.replace(XA, (t) => t.startsWith("/*") ? "" : t).split(KA).forEach((t) => {
    if (t) {
      const i = t.split(YA);
      i.length > 1 && (e[i[0].trim()] = i[1].trim());
    }
  }), e;
}
function U(n) {
  let e = "";
  if (en(n))
    e = n;
  else if (pt(n))
    for (let t = 0; t < n.length; t++) {
      const i = U(n[t]);
      i && (e += i + " ");
    }
  else if (jt(n))
    for (const t in n)
      n[t] && (e += t + " ");
  return e.trim();
}
const ZA = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", QA = /* @__PURE__ */ $0(ZA);
function a5(n) {
  return !!n || n === "";
}
function eP(n, e, t) {
  if (n.length !== e.length) return !1;
  let i = !0;
  for (let s = 0; i && s < n.length; s++)
    i = Il(n[s], e[s], t);
  return i;
}
function lx(n, e, t) {
  if (n.size !== e.size) return !1;
  const i = Array.from(e), s = new Uint8Array(i.length);
  for (const o of n) {
    let r = -1;
    for (let a = 0; a < i.length; a++)
      if (!s[a] && Il(o, i[a], t)) {
        r = a;
        break;
      }
    if (r < 0) return !1;
    s[r] = 1;
  }
  return !0;
}
function tP(n, e, t) {
  let i = Mo(n), s = Mo(e);
  if (i || s || (i = dl(n), s = dl(e), i || s))
    return i && s ? lx(n, e, t) : !1;
  const o = Object.keys(n).length, r = Object.keys(e).length;
  if (o !== r)
    return !1;
  for (const a in n) {
    const l = n.hasOwnProperty(a), d = e.hasOwnProperty(a);
    if (l && !d || !l && d || !Il(n[a], e[a], t))
      return !1;
  }
  return String(n) === String(e);
}
function dx(n, e, t, i) {
  t || (t = [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map()]);
  const [s, o] = t;
  if (s.has(n) || o.has(e))
    return s.get(n) === e && o.get(e) === n;
  s.set(n, e), o.set(e, n);
  const r = i(n, e, t);
  return s.delete(n), o.delete(e), r;
}
function Il(n, e, t) {
  if (n === e) return !0;
  let i = rx(n), s = rx(e);
  return i || s ? i && s ? n.getTime() === e.getTime() : !1 : (i = ji(n), s = ji(e), i || s ? n === e : (i = pt(n), s = pt(e), i || s ? i && s ? dx(n, e, t, eP) : !1 : (i = jt(n), s = jt(e), i || s ? !i || !s ? !1 : dx(n, e, t, tP) : String(n) === String(e))));
}
function l5(n, e) {
  return n.findIndex((t) => Il(t, e));
}
const d5 = (n) => !!(n && n.__v_isRef === !0), A = (n) => en(n) ? n : n == null ? "" : pt(n) || jt(n) && (n.toString === s5 || !Ot(n.toString)) ? d5(n) ? A(n.value) : JSON.stringify(n, c5, 2) : String(n), c5 = (n, e) => d5(e) ? c5(n, e.value) : Mo(e) ? {
  [`Map(${e.size})`]: [...e.entries()].reduce(
    (t, [i, s], o) => (t[um(i, o) + " =>"] = s, t),
    {}
  )
} : dl(e) ? {
  [`Set(${e.size})`]: [...e.values()].map((t) => um(t))
} : ji(e) ? um(e) : jt(e) && !pt(e) && !o5(e) ? String(e) : e, um = (n, e = "") => {
  var t;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    ji(n) ? `Symbol(${(t = n.description) != null ? t : e})` : n
  );
};
let Pn;
class u5 {
  // TODO isolatedDeclarations "__v_skip"
  constructor(e = !1) {
    this.detached = e, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this._warnOnRun = !0, this.__v_skip = !0, !e && Pn && (Pn.active ? (this.parent = Pn, this.index = (Pn.scopes || (Pn.scopes = [])).push(
      this
    ) - 1) : (this._active = !1, this._warnOnRun = !1));
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let e, t;
      if (this.scopes) {
        const i = this.scopes.slice();
        for (e = 0, t = i.length; e < t; e++)
          i[e].pause();
      }
      for (e = 0, t = this.effects.length; e < t; e++)
        this.effects[e].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let e, t;
      if (this.scopes) {
        const s = this.scopes.slice();
        for (e = 0, t = s.length; e < t; e++)
          s[e].resume();
      }
      const i = this.effects.slice();
      for (e = 0, t = i.length; e < t; e++)
        i[e].resume();
    }
  }
  run(e) {
    if (this._active) {
      const t = Pn;
      try {
        return Pn = this, e();
      } finally {
        Pn = t;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = Pn, Pn = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    if (this._on > 0 && --this._on === 0) {
      if (Pn === this)
        Pn = this.prevScope;
      else {
        let e = Pn;
        for (; e; ) {
          if (e.prevScope === this) {
            e.prevScope = this.prevScope;
            break;
          }
          e = e.prevScope;
        }
      }
      this.prevScope = void 0;
    }
  }
  stop(e) {
    if (this._active) {
      this._active = !1;
      let t, i;
      for (t = 0, i = this.effects.length; t < i; t++)
        this.effects[t].stop();
      for (this.effects.length = 0, t = 0, i = this.cleanups.length; t < i; t++)
        this.cleanups[t]();
      if (this.cleanups.length = 0, this.scopes) {
        const s = this.scopes.slice();
        for (t = 0, i = s.length; t < i; t++)
          s[t].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !e) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function L0(n) {
  return new u5(n);
}
function nP() {
  return Pn;
}
let Ut;
const hm = /* @__PURE__ */ new WeakSet();
class h5 {
  constructor(e) {
    this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Pn && (Pn.active ? Pn.effects.push(this) : this.flags &= -2);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, hm.has(this) && (hm.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || f5(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, cx(this), m5(this);
    const e = Ut, t = Fi;
    Ut = this, Fi = !0;
    try {
      return this.fn();
    } finally {
      g5(this), Ut = e, Fi = t, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let e = this.deps; e; e = e.nextDep)
        N0(e);
      this.deps = this.depsTail = void 0, cx(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? hm.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Db(this) && this.run();
  }
  get dirty() {
    return Db(this);
  }
}
let p5 = 0, Gd, jd;
function f5(n, e = !1) {
  if (n.flags |= 8, e) {
    n.next = jd, jd = n;
    return;
  }
  n.next = Gd, Gd = n;
}
function B0() {
  p5++;
}
function F0() {
  if (--p5 > 0)
    return;
  if (jd) {
    let e = jd;
    for (jd = void 0; e; ) {
      const t = e.next;
      e.next = void 0, e.flags &= -9, e = t;
    }
  }
  let n;
  for (; Gd; ) {
    let e = Gd;
    for (Gd = void 0; e; ) {
      const t = e.next;
      if (e.next = void 0, e.flags &= -9, e.flags & 1)
        try {
          e.trigger();
        } catch (i) {
          n || (n = i);
        }
      e = t;
    }
  }
  if (n) throw n;
}
function m5(n) {
  for (let e = n.deps; e; e = e.nextDep)
    e.version = -1, e.prevActiveLink = e.dep.activeLink, e.dep.activeLink = e;
}
function g5(n) {
  let e, t = n.depsTail, i = t;
  for (; i; ) {
    const s = i.prevDep;
    i.version === -1 ? (i === t && (t = s), N0(i), iP(i)) : e = i, i.dep.activeLink = i.prevActiveLink, i.prevActiveLink = void 0, i = s;
  }
  n.deps = e, n.depsTail = t;
}
function Db(n) {
  for (let e = n.deps; e; e = e.nextDep)
    if (e.dep.version !== e.version || e.dep.computed && (b5(e.dep.computed) || e.dep.version !== e.version))
      return !0;
  return !!n._dirty;
}
function b5(n) {
  if (n.flags & 4 && !(n.flags & 16) || (n.flags &= -17, n.globalVersion === cc) || (n.globalVersion = cc, !n.isSSR && n.flags & 128 && (!n.deps && !n._dirty || !Db(n))))
    return;
  n.flags |= 2;
  const e = n.dep, t = Ut, i = Fi;
  Ut = n, Fi = !0;
  try {
    m5(n);
    const s = n.fn(n._value);
    (e.version === 0 || ss(s, n._value)) && (n.flags |= 128, n._value = s, e.version++);
  } catch (s) {
    throw e.version++, s;
  } finally {
    Ut = t, Fi = i, g5(n), n.flags &= -3;
  }
}
function N0(n, e = !1) {
  const { dep: t, prevSub: i, nextSub: s } = n;
  if (i && (i.nextSub = s, n.prevSub = void 0), s && (s.prevSub = i, n.nextSub = void 0), t.subs === n && (t.subs = i, !i && t.computed)) {
    t.computed.flags &= -5;
    for (let o = t.computed.deps; o; o = o.nextDep)
      N0(o, !0);
  }
  !e && !--t.sc && t.map && t.map.delete(t.key);
}
function iP(n) {
  const { prevDep: e, nextDep: t } = n;
  e && (e.nextDep = t, n.prevDep = void 0), t && (t.prevDep = e, n.nextDep = void 0);
}
let Fi = !0;
const v5 = [];
function Oo() {
  v5.push(Fi), Fi = !1;
}
function Lo() {
  const n = v5.pop();
  Fi = n === void 0 ? !0 : n;
}
function cx(n) {
  const { cleanup: e } = n;
  if (n.cleanup = void 0, e) {
    const t = Ut;
    Ut = void 0;
    try {
      e();
    } finally {
      Ut = t;
    }
  }
}
let cc = 0, sP = class {
  constructor(e, t) {
    this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
};
class U0 {
  // TODO isolatedDeclarations "__v_skip"
  constructor(e) {
    this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
  }
  track(e) {
    if (!Ut || !Fi || Ut === this.computed)
      return;
    let t = this.activeLink;
    if (t === void 0 || t.sub !== Ut)
      t = this.activeLink = new sP(Ut, this), Ut.deps ? (t.prevDep = Ut.depsTail, Ut.depsTail.nextDep = t, Ut.depsTail = t) : Ut.deps = Ut.depsTail = t, y5(t);
    else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
      const i = t.nextDep;
      i.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = i), t.prevDep = Ut.depsTail, t.nextDep = void 0, Ut.depsTail.nextDep = t, Ut.depsTail = t, Ut.deps === t && (Ut.deps = i);
    }
    return t;
  }
  trigger(e) {
    this.version++, cc++, this.notify(e);
  }
  notify(e) {
    B0();
    try {
      for (let t = this.subs; t; t = t.prevSub)
        t.sub.notify() && t.sub.dep.notify();
    } finally {
      F0();
    }
  }
}
function y5(n) {
  if (n.dep.sc++, n.sub.flags & 4) {
    const e = n.dep.computed;
    if (e && !n.dep.subs) {
      e.flags |= 20;
      for (let i = e.deps; i; i = i.nextDep)
        y5(i);
    }
    const t = n.dep.subs;
    t !== n && (n.prevSub = t, t && (t.nextSub = n)), n.dep.subs = n;
  }
}
const Ob = /* @__PURE__ */ new WeakMap(), Gr = /* @__PURE__ */ Symbol(
  ""
), Lb = /* @__PURE__ */ Symbol(
  ""
), uc = /* @__PURE__ */ Symbol(
  ""
);
function Bn(n, e, t) {
  if (Fi && Ut) {
    let i = Ob.get(n);
    i || Ob.set(n, i = /* @__PURE__ */ new Map());
    let s = i.get(t);
    s || (i.set(t, s = new U0()), s.map = i, s.key = t), s.track();
  }
}
function Os(n, e, t, i, s, o) {
  const r = Ob.get(n);
  if (!r) {
    cc++;
    return;
  }
  const a = (l) => {
    l && l.trigger();
  };
  if (B0(), e === "clear")
    r.forEach(a);
  else {
    const l = pt(n), d = l && D0(t);
    if (l && t === "length") {
      const c = Number(i);
      r.forEach((u, p) => {
        (p === "length" || p === uc || !ji(p) && p >= c) && a(u);
      });
    } else
      switch ((t !== void 0 || r.has(void 0)) && a(r.get(t)), d && a(r.get(uc)), e) {
        case "add":
          l ? d && a(r.get("length")) : (a(r.get(Gr)), Mo(n) && a(r.get(Lb)));
          break;
        case "delete":
          l || (a(r.get(Gr)), Mo(n) && a(r.get(Lb)));
          break;
        case "set":
          Mo(n) && a(r.get(Gr));
          break;
      }
  }
  F0();
}
function sa(n) {
  const e = /* @__PURE__ */ At(n);
  return e === n || (Bn(e, "iterate", uc), /* @__PURE__ */ Ii(n)) ? e : /* @__PURE__ */ cs(n) ? /* @__PURE__ */ Co(n) ? e.map((t) => Bo(Ai(t))) : e.map(Bo) : e.map(Ai);
}
function _f(n) {
  return Bn(n = /* @__PURE__ */ At(n), "iterate", uc), n;
}
function ns(n, e) {
  return /* @__PURE__ */ cs(n) ? Bo(/* @__PURE__ */ Co(n) ? Ai(e) : e) : Ai(e);
}
const oP = {
  __proto__: null,
  [Symbol.iterator]() {
    return pm(this, Symbol.iterator, (n) => ns(this, n));
  },
  concat(...n) {
    return sa(this).concat(
      ...n.map((e) => pt(e) ? sa(e) : e)
    );
  },
  entries() {
    return pm(this, "entries", (n) => (n[1] = ns(this, n[1]), n));
  },
  every(n, e) {
    return vs(this, "every", n, e, void 0, arguments);
  },
  filter(n, e) {
    return vs(
      this,
      "filter",
      n,
      e,
      (t) => t.map((i) => ns(this, i)),
      arguments
    );
  },
  find(n, e) {
    return vs(
      this,
      "find",
      n,
      e,
      (t) => ns(this, t),
      arguments
    );
  },
  findIndex(n, e) {
    return vs(this, "findIndex", n, e, void 0, arguments);
  },
  findLast(n, e) {
    return vs(
      this,
      "findLast",
      n,
      e,
      (t) => ns(this, t),
      arguments
    );
  },
  findLastIndex(n, e) {
    return vs(this, "findLastIndex", n, e, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(n, e) {
    return vs(this, "forEach", n, e, void 0, arguments);
  },
  includes(...n) {
    return fm(this, "includes", n);
  },
  indexOf(...n) {
    return fm(this, "indexOf", n);
  },
  join(n) {
    return sa(this).join(n);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...n) {
    return fm(this, "lastIndexOf", n);
  },
  map(n, e) {
    return vs(this, "map", n, e, void 0, arguments);
  },
  pop() {
    return jl(this, "pop");
  },
  push(...n) {
    return jl(this, "push", n);
  },
  reduce(n, ...e) {
    return ux(this, "reduce", n, e);
  },
  reduceRight(n, ...e) {
    return ux(this, "reduceRight", n, e);
  },
  shift() {
    return jl(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(n, e) {
    return vs(this, "some", n, e, void 0, arguments);
  },
  splice(...n) {
    return jl(this, "splice", n);
  },
  toReversed() {
    return sa(this).toReversed();
  },
  toSorted(n) {
    return sa(this).toSorted(n);
  },
  toSpliced(...n) {
    return sa(this).toSpliced(...n);
  },
  unshift(...n) {
    return jl(this, "unshift", n);
  },
  values() {
    return pm(this, "values", (n) => ns(this, n));
  }
};
function pm(n, e, t) {
  const i = _f(n), s = i[e]();
  return i !== n && !/* @__PURE__ */ Ii(n) && (s._next = s.next, s.next = () => {
    const o = s._next();
    return o.done || (o.value = t(o.value)), o;
  }), s;
}
const rP = Array.prototype;
function vs(n, e, t, i, s, o) {
  const r = _f(n), a = r !== n && !/* @__PURE__ */ Ii(n), l = r[e];
  if (l !== rP[e]) {
    const u = l.apply(n, o);
    return a ? Ai(u) : u;
  }
  let d = t;
  r !== n && (a ? d = function(u, p) {
    return t.call(this, ns(n, u), p, n);
  } : t.length > 2 && (d = function(u, p) {
    return t.call(this, u, p, n);
  }));
  const c = l.call(r, d, i);
  return a && s ? s(c) : c;
}
function ux(n, e, t, i) {
  const s = _f(n), o = s !== n && !/* @__PURE__ */ Ii(n);
  let r = t, a = !1;
  s !== n && (o ? (a = i.length === 0, r = function(d, c, u) {
    return a && (a = !1, d = ns(n, d)), t.call(this, d, ns(n, c), u, n);
  }) : t.length > 3 && (r = function(d, c, u) {
    return t.call(this, d, c, u, n);
  }));
  const l = s[e](r, ...i);
  return a ? ns(n, l) : l;
}
function fm(n, e, t) {
  const i = /* @__PURE__ */ At(n);
  Bn(i, "iterate", uc);
  const s = i[e](...t);
  return (s === -1 || s === !1) && /* @__PURE__ */ H0(t[0]) ? (t[0] = /* @__PURE__ */ At(t[0]), i[e](...t)) : s;
}
function jl(n, e, t = []) {
  Oo(), B0();
  const i = (/* @__PURE__ */ At(n))[e].apply(n, t);
  return F0(), Lo(), i;
}
const aP = /* @__PURE__ */ $0("__proto__,__v_isRef,__isVue"), x5 = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((n) => n !== "arguments" && n !== "caller").map((n) => Symbol[n]).filter(ji)
);
function lP(n) {
  ji(n) || (n = String(n));
  const e = /* @__PURE__ */ At(this);
  return Bn(e, "has", n), e.hasOwnProperty(n);
}
class w5 {
  constructor(e = !1, t = !1) {
    this._isReadonly = e, this._isShallow = t;
  }
  get(e, t, i) {
    if (t === "__v_skip") return e.__v_skip;
    const s = this._isReadonly, o = this._isShallow;
    if (t === "__v_isReactive")
      return !s;
    if (t === "__v_isReadonly")
      return s;
    if (t === "__v_isShallow")
      return o;
    if (t === "__v_raw")
      return i === (s ? o ? vP : T5 : o ? S5 : _5).get(e) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(e) === Object.getPrototypeOf(i) ? e : void 0;
    const r = pt(e);
    if (!s) {
      let l;
      if (r && (l = oP[t]))
        return l;
      if (t === "hasOwnProperty")
        return lP;
    }
    const a = Reflect.get(
      e,
      t,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      /* @__PURE__ */ Xn(e) ? e : i
    );
    if ((ji(t) ? x5.has(t) : aP(t)) || (s || Bn(e, "get", t), o))
      return a;
    if (/* @__PURE__ */ Xn(a)) {
      const l = r && D0(t) ? a : a.value;
      return s && jt(l) ? /* @__PURE__ */ Fb(l) : l;
    }
    return jt(a) ? s ? /* @__PURE__ */ Fb(a) : /* @__PURE__ */ Xt(a) : a;
  }
}
class k5 extends w5 {
  constructor(e = !1) {
    super(!1, e);
  }
  set(e, t, i, s) {
    let o = e[t];
    const r = pt(e) && D0(t);
    if (!this._isShallow) {
      const d = /* @__PURE__ */ cs(o);
      if (!/* @__PURE__ */ Ii(i) && !/* @__PURE__ */ cs(i) && (o = /* @__PURE__ */ At(o), i = /* @__PURE__ */ At(i)), !r && /* @__PURE__ */ Xn(o) && !/* @__PURE__ */ Xn(i))
        return d || (o.value = i), !0;
    }
    const a = r ? Number(t) < e.length : Nt(e, t), l = Reflect.set(
      e,
      t,
      i,
      /* @__PURE__ */ Xn(e) ? e : s
    );
    return e === /* @__PURE__ */ At(s) && l && (a ? ss(i, o) && Os(e, "set", t, i) : Os(e, "add", t, i)), l;
  }
  deleteProperty(e, t) {
    const i = Nt(e, t);
    e[t];
    const s = Reflect.deleteProperty(e, t);
    return s && i && Os(e, "delete", t, void 0), s;
  }
  has(e, t) {
    const i = Reflect.has(e, t);
    return (!ji(t) || !x5.has(t)) && Bn(e, "has", t), i;
  }
  ownKeys(e) {
    return Bn(
      e,
      "iterate",
      pt(e) ? "length" : Gr
    ), Reflect.ownKeys(e);
  }
}
class dP extends w5 {
  constructor(e = !1) {
    super(!0, e);
  }
  set(e, t) {
    return !0;
  }
  deleteProperty(e, t) {
    return !0;
  }
}
const cP = /* @__PURE__ */ new k5(), uP = /* @__PURE__ */ new dP(), hP = /* @__PURE__ */ new k5(!0);
const Bb = (n) => n, ou = (n) => Reflect.getPrototypeOf(n);
function pP(n, e, t) {
  return function(...i) {
    const s = this.__v_raw, o = /* @__PURE__ */ At(s), r = Mo(o), a = n === "entries" || n === Symbol.iterator && r, l = n === "keys" && r, d = s[n](...i), c = t ? Bb : e ? Bo : Ai;
    return !e && Bn(
      o,
      "iterate",
      l ? Lb : Gr
    ), li(
      // inheriting all iterator properties
      Object.create(d),
      {
        // iterator protocol
        next() {
          const { value: u, done: p } = d.next();
          return p ? { value: u, done: p } : {
            value: a ? [c(u[0]), c(u[1])] : c(u),
            done: p
          };
        }
      }
    );
  };
}
function ru(n) {
  return function(...e) {
    return n === "delete" ? !1 : n === "clear" ? void 0 : this;
  };
}
function fP(n, e) {
  const t = {
    get(s) {
      const o = this.__v_raw, r = /* @__PURE__ */ At(o), a = /* @__PURE__ */ At(s);
      n || (ss(s, a) && Bn(r, "get", s), Bn(r, "get", a));
      const { has: l } = ou(r), d = e ? Bb : n ? Bo : Ai;
      if (l.call(r, s))
        return d(o.get(s));
      if (l.call(r, a))
        return d(o.get(a));
      o !== r && o.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !n && Bn(/* @__PURE__ */ At(s), "iterate", Gr), s.size;
    },
    has(s) {
      const o = this.__v_raw, r = /* @__PURE__ */ At(o), a = /* @__PURE__ */ At(s);
      return n || (ss(s, a) && Bn(r, "has", s), Bn(r, "has", a)), s === a ? o.has(s) : o.has(s) || o.has(a);
    },
    forEach(s, o) {
      const r = this, a = r.__v_raw, l = /* @__PURE__ */ At(a), d = e ? Bb : n ? Bo : Ai;
      return !n && Bn(l, "iterate", Gr), a.forEach((c, u) => s.call(o, d(c), d(u), r));
    }
  };
  return li(
    t,
    n ? {
      add: ru("add"),
      set: ru("set"),
      delete: ru("delete"),
      clear: ru("clear")
    } : {
      add(s) {
        const o = /* @__PURE__ */ At(this), r = ou(o), a = /* @__PURE__ */ At(s), l = !e && !/* @__PURE__ */ Ii(s) && !/* @__PURE__ */ cs(s) ? a : s;
        return r.has.call(o, l) || ss(s, l) && r.has.call(o, s) || ss(a, l) && r.has.call(o, a) || (o.add(l), Os(o, "add", l, l)), this;
      },
      set(s, o) {
        !e && !/* @__PURE__ */ Ii(o) && !/* @__PURE__ */ cs(o) && (o = /* @__PURE__ */ At(o));
        const r = /* @__PURE__ */ At(this), { has: a, get: l } = ou(r);
        let d = a.call(r, s);
        d || (s = /* @__PURE__ */ At(s), d = a.call(r, s));
        const c = l.call(r, s);
        return r.set(s, o), d ? ss(o, c) && Os(r, "set", s, o) : Os(r, "add", s, o), this;
      },
      delete(s) {
        const o = /* @__PURE__ */ At(this), { has: r, get: a } = ou(o);
        let l = r.call(o, s);
        l || (s = /* @__PURE__ */ At(s), l = r.call(o, s)), a && a.call(o, s);
        const d = o.delete(s);
        return l && Os(o, "delete", s, void 0), d;
      },
      clear() {
        const s = /* @__PURE__ */ At(this), o = s.size !== 0, r = s.clear();
        return o && Os(
          s,
          "clear",
          void 0,
          void 0
        ), r;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    t[s] = pP(s, n, e);
  }), t;
}
function G0(n, e) {
  const t = fP(n, e);
  return (i, s, o) => s === "__v_isReactive" ? !n : s === "__v_isReadonly" ? n : s === "__v_raw" ? i : Reflect.get(
    Nt(t, s) && s in i ? t : i,
    s,
    o
  );
}
const mP = {
  get: /* @__PURE__ */ G0(!1, !1)
}, gP = {
  get: /* @__PURE__ */ G0(!1, !0)
}, bP = {
  get: /* @__PURE__ */ G0(!0, !1)
};
const _5 = /* @__PURE__ */ new WeakMap(), S5 = /* @__PURE__ */ new WeakMap(), T5 = /* @__PURE__ */ new WeakMap(), vP = /* @__PURE__ */ new WeakMap();
function yP(n) {
  switch (n) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
// @__NO_SIDE_EFFECTS__
function Xt(n) {
  return /* @__PURE__ */ cs(n) ? n : j0(
    n,
    !1,
    cP,
    mP,
    _5
  );
}
// @__NO_SIDE_EFFECTS__
function M5(n) {
  return j0(
    n,
    !1,
    hP,
    gP,
    S5
  );
}
// @__NO_SIDE_EFFECTS__
function Fb(n) {
  return j0(
    n,
    !0,
    uP,
    bP,
    T5
  );
}
function j0(n, e, t, i, s) {
  if (!jt(n) || n.__v_raw && !(e && n.__v_isReactive) || n.__v_skip || !Object.isExtensible(n))
    return n;
  const o = s.get(n);
  if (o)
    return o;
  const r = yP(HA(n));
  if (r === 0)
    return n;
  const a = new Proxy(
    n,
    r === 2 ? i : t
  );
  return s.set(n, a), a;
}
// @__NO_SIDE_EFFECTS__
function Co(n) {
  return /* @__PURE__ */ cs(n) ? /* @__PURE__ */ Co(n.__v_raw) : !!(n && n.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function cs(n) {
  return !!(n && n.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function Ii(n) {
  return !!(n && n.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function H0(n) {
  return n ? !!n.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function At(n) {
  const e = n && n.__v_raw;
  return e ? /* @__PURE__ */ At(e) : n;
}
function Nb(n) {
  return !Nt(n, "__v_skip") && Object.isExtensible(n) && r5(n, "__v_skip", !0), n;
}
const Ai = (n) => jt(n) ? /* @__PURE__ */ Xt(n) : n, Bo = (n) => jt(n) ? /* @__PURE__ */ Fb(n) : n;
// @__NO_SIDE_EFFECTS__
function Xn(n) {
  return n ? n.__v_isRef === !0 : !1;
}
// @__NO_SIDE_EFFECTS__
function K(n) {
  return C5(n, !1);
}
// @__NO_SIDE_EFFECTS__
function We(n) {
  return C5(n, !0);
}
function C5(n, e) {
  return /* @__PURE__ */ Xn(n) ? n : new xP(n, e);
}
class xP {
  constructor(e, t) {
    this.dep = new U0(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? e : /* @__PURE__ */ At(e), this._value = t ? e : Ai(e), this.__v_isShallow = t;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(e) {
    const t = this._rawValue, i = this.__v_isShallow || /* @__PURE__ */ Ii(e) || /* @__PURE__ */ cs(e);
    e = i ? e : /* @__PURE__ */ At(e), ss(e, t) && (this._rawValue = e, this._value = i ? e : Ai(e), this.dep.trigger());
  }
}
function os(n) {
  n.dep && n.dep.trigger();
}
function m(n) {
  return /* @__PURE__ */ Xn(n) ? n.value : n;
}
const wP = {
  get: (n, e, t) => e === "__v_raw" ? n : m(Reflect.get(n, e, t)),
  set: (n, e, t, i) => {
    const s = n[e];
    return /* @__PURE__ */ Xn(s) && !/* @__PURE__ */ Xn(t) ? (s.value = t, !0) : Reflect.set(n, e, t, i);
  }
};
function I5(n) {
  return /* @__PURE__ */ Co(n) ? n : new Proxy(n, wP);
}
class kP {
  constructor(e, t, i) {
    this.fn = e, this.setter = t, this._value = void 0, this.dep = new U0(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = cc - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = i;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    Ut !== this)
      return f5(this, !0), !0;
  }
  get value() {
    const e = this.dep.track();
    return b5(this), e && (e.version = this.dep.version), this._value;
  }
  set value(e) {
    this.setter && this.setter(e);
  }
}
// @__NO_SIDE_EFFECTS__
function _P(n, e, t = !1) {
  let i, s;
  return Ot(n) ? i = n : (i = n.get, s = n.set), new kP(i, s, t);
}
const au = {}, mp = /* @__PURE__ */ new WeakMap();
let mr;
function SP(n, e = !1, t = mr) {
  if (t) {
    let i = mp.get(t);
    i || mp.set(t, i = []), i.push(n);
  }
}
function TP(n, e, t = Yt) {
  const { immediate: i, deep: s, once: o, scheduler: r, augmentJob: a, call: l } = t, d = (x) => s ? x : /* @__PURE__ */ Ii(x) || s === !1 || s === 0 ? Ls(x, 1) : Ls(x);
  let c, u, p, f, y = !1, b = !1;
  if (/* @__PURE__ */ Xn(n) ? (u = () => n.value, y = /* @__PURE__ */ Ii(n)) : /* @__PURE__ */ Co(n) ? (u = () => d(n), y = !0) : pt(n) ? (b = !0, y = n.some((x) => /* @__PURE__ */ Co(x) || /* @__PURE__ */ Ii(x)), u = () => n.map((x) => {
    if (/* @__PURE__ */ Xn(x))
      return x.value;
    if (/* @__PURE__ */ Co(x))
      return d(x);
    if (Ot(x))
      return l ? l(x, 2) : x();
  })) : Ot(n) ? e ? u = l ? () => l(n, 2) : n : u = () => {
    if (p) {
      Oo();
      try {
        p();
      } finally {
        Lo();
      }
    }
    const x = mr;
    mr = c;
    try {
      return l ? l(n, 3, [f]) : n(f);
    } finally {
      mr = x;
    }
  } : u = Ur, e && s) {
    const x = u, T = s === !0 ? 1 / 0 : s;
    u = () => Ls(x(), T);
  }
  const w = nP(), k = () => {
    c.stop(), w && w.active && n5(w.effects, c);
  };
  if (o && e) {
    const x = e;
    e = (...T) => {
      const M = x(...T);
      return k(), M;
    };
  }
  let S = b ? new Array(n.length).fill(au) : au;
  const _ = (x) => {
    if (!(!(c.flags & 1) || !c.dirty && !x))
      if (e) {
        const T = c.run();
        if (x || s || y || (b ? T.some((M, z) => ss(M, S[z])) : ss(T, S))) {
          p && p();
          const M = mr;
          mr = c;
          try {
            const z = [
              T,
              // pass undefined as the old value when it's changed for the first time
              S === au ? void 0 : b && S[0] === au ? [] : S,
              f
            ];
            S = T, l ? l(e, 3, z) : (
              // @ts-expect-error
              e(...z)
            );
          } finally {
            mr = M;
          }
        }
      } else
        c.run();
  };
  return a && a(_), c = new h5(u), c.scheduler = r ? () => r(_, !1) : _, f = (x) => SP(x, !1, c), p = c.onStop = () => {
    const x = mp.get(c);
    if (x) {
      if (l)
        l(x, 4);
      else
        for (const T of x) T();
      mp.delete(c);
    }
  }, e ? i ? _(!0) : S = c.run() : r ? r(_.bind(null, !0), !0) : c.run(), k.pause = c.pause.bind(c), k.resume = c.resume.bind(c), k.stop = k, k;
}
function Ls(n, e = 1 / 0, t) {
  if (e <= 0 || !jt(n) || n.__v_skip || (t = t || /* @__PURE__ */ new Map(), (t.get(n) || 0) >= e))
    return n;
  if (t.set(n, e), e--, /* @__PURE__ */ Xn(n))
    Ls(n.value, e, t);
  else if (pt(n))
    for (let i = 0; i < n.length; i++)
      Ls(n[i], e, t);
  else if (dl(n) || Mo(n))
    n.forEach((i) => {
      Ls(i, e, t);
    });
  else if (o5(n)) {
    for (const i in n)
      Ls(n[i], e, t);
    for (const i of Object.getOwnPropertySymbols(n))
      Object.prototype.propertyIsEnumerable.call(n, i) && Ls(n[i], e, t);
  }
  return n;
}
function Vc(n, e, t, i) {
  try {
    return i ? n(...i) : n();
  } catch (s) {
    Sf(s, e, t);
  }
}
function Hi(n, e, t, i) {
  if (Ot(n)) {
    const s = Vc(n, e, t, i);
    return s && i5(s) && s.catch((o) => {
      Sf(o, e, t);
    }), s;
  }
  if (pt(n)) {
    const s = [];
    for (let o = 0; o < n.length; o++)
      s.push(Hi(n[o], e, t, i));
    return s;
  }
}
function Sf(n, e, t, i = !0) {
  const s = e ? e.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: r } = e && e.appContext.config || Yt;
  if (e) {
    let a = e.parent;
    const l = e.proxy, d = `https://vuejs.org/error-reference/#runtime-${t}`;
    for (; a; ) {
      const c = a.ec;
      if (c) {
        for (let u = 0; u < c.length; u++)
          if (c[u](n, l, d) === !1)
            return;
      }
      a = a.parent;
    }
    if (o) {
      Oo(), Vc(o, null, 10, [
        n,
        l,
        d
      ]), Lo();
      return;
    }
  }
  MP(n, t, s, i, r);
}
function MP(n, e, t, i = !0, s = !1) {
  if (s)
    throw n;
  console.error(n);
}
const qn = [];
let Zi = -1;
const Wa = [];
let mo = null, Aa = 0;
const A5 = /* @__PURE__ */ Promise.resolve();
let gp = null;
function it(n) {
  const e = gp || A5;
  return n ? e.then(this ? n.bind(this) : n) : e;
}
function CP(n) {
  let e = Zi + 1, t = qn.length;
  for (; e < t; ) {
    const i = e + t >>> 1, s = qn[i], o = hc(s);
    o < n || o === n && s.flags & 2 ? e = i + 1 : t = i;
  }
  return e;
}
function V0(n) {
  if (!(n.flags & 1)) {
    const e = hc(n), t = qn[qn.length - 1];
    !t || // fast path when the job id is larger than the tail
    !(n.flags & 2) && e >= hc(t) ? qn.push(n) : qn.splice(CP(e), 0, n), n.flags |= 1, P5();
  }
}
function P5() {
  gp || (gp = A5.then(R5));
}
function IP(n) {
  if (!pt(n))
    mo && n.id === -1 ? mo.splice(Aa + 1, 0, n) : n.flags & 1 || (Wa.push(n), n.flags |= 1);
  else
    for (let e = 0; e < n.length; e++)
      Wa.push(n[e]);
  P5();
}
function hx(n, e, t = Zi + 1) {
  for (; t < qn.length; t++) {
    const i = qn[t];
    if (i && i.flags & 2) {
      if (n && i.id !== n.uid)
        continue;
      qn.splice(t, 1), t--, i.flags & 4 && (i.flags &= -2), i(), i.flags & 4 || (i.flags &= -2);
    }
  }
}
function E5(n) {
  if (Wa.length) {
    const e = [...new Set(Wa)].sort(
      (t, i) => hc(t) - hc(i)
    );
    if (Wa.length = 0, mo) {
      for (let t = 0; t < e.length; t++)
        mo.push(e[t]);
      return;
    }
    for (mo = e, Aa = 0; Aa < mo.length; Aa++) {
      const t = mo[Aa];
      t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2;
    }
    mo = null, Aa = 0;
  }
}
const hc = (n) => n.id == null ? n.flags & 2 ? -1 : 1 / 0 : n.id;
function R5(n) {
  try {
    for (Zi = 0; Zi < qn.length; Zi++) {
      const e = qn[Zi];
      e && !(e.flags & 8) && (e.flags & 4 && (e.flags &= -2), Vc(
        e,
        e.i,
        e.i ? 15 : 14
      ), e.flags & 4 || (e.flags &= -2));
    }
  } finally {
    for (; Zi < qn.length; Zi++) {
      const e = qn[Zi];
      e && (e.flags &= -2);
    }
    Zi = -1, qn.length = 0, E5(), gp = null, (qn.length || Wa.length) && R5();
  }
}
let zn = null, z5 = null;
function bp(n) {
  const e = zn;
  return zn = n, z5 = n && n.type.__scopeId || null, e;
}
function et(n, e = zn, t) {
  if (!e || n._n)
    return n;
  const i = (...s) => {
    i._d && xp(-1);
    const o = bp(e), r = Us.length;
    let a;
    try {
      a = n(...s);
    } finally {
      for (let l = Us.length; l > r; l--) Z0();
      bp(o), i._d && xp(1);
    }
    return a;
  };
  return i._n = !0, i._c = !0, i._d = !0, i;
}
function xt(n, e) {
  if (zn === null)
    return n;
  const t = Pf(zn), i = n.dirs || (n.dirs = []);
  for (let s = 0; s < e.length; s++) {
    let [o, r, a, l = Yt] = e[s];
    o && (Ot(o) && (o = {
      mounted: o,
      updated: o
    }), o.deep && Ls(r), i.push({
      dir: o,
      instance: t,
      value: r,
      oldValue: void 0,
      arg: a,
      modifiers: l
    }));
  }
  return n;
}
function er(n, e, t, i) {
  const s = n.dirs, o = e && e.dirs;
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    o && (a.oldValue = o[r].value);
    let l = a.dir[i];
    l && (Oo(), Hi(l, t, 8, [
      n.el,
      a,
      n,
      e
    ]), Lo());
  }
}
function $5(n, e) {
  if (si) {
    let t = si.provides;
    const i = si.parent && si.parent.provides;
    i === t && (t = si.provides = Object.create(i)), t[n] = e;
  }
}
function Tf(n, e, t = !1) {
  const i = Al();
  if (i || Ka) {
    let s = Ka ? Ka._context.provides : i ? i.parent == null || i.ce ? i.vnode.appContext && i.vnode.appContext.provides : i.parent.provides : void 0;
    if (s && n in s)
      return s[n];
    if (arguments.length > 1)
      return t && Ot(e) ? e.call(i && i.proxy) : e;
  }
}
const AP = /* @__PURE__ */ Symbol.for("v-scx"), PP = () => Tf(AP);
function EP(n, e) {
  return D5(n, null, e);
}
function $e(n, e, t) {
  return D5(n, e, t);
}
function D5(n, e, t = Yt) {
  const { immediate: i, deep: s, flush: o, once: r } = t, a = li({}, t), l = e && i || !e && o !== "post";
  let d;
  if (bc) {
    if (o === "sync") {
      const f = PP();
      d = f.__watcherHandles || (f.__watcherHandles = []);
    } else if (!l) {
      const f = () => {
      };
      return f.stop = Ur, f.resume = Ur, f.pause = Ur, f;
    }
  }
  const c = si;
  a.call = (f, y, b) => Hi(f, c, y, b);
  let u = !1;
  o === "post" ? a.scheduler = (f) => {
    Vn(f, c && c.suspense);
  } : o !== "sync" && (u = !0, a.scheduler = (f, y) => {
    y ? f() : V0(f);
  }), a.augmentJob = (f) => {
    e && (f.flags |= 4), u && (f.flags |= 2, c && (f.id = c.uid, f.i = c));
  };
  const p = TP(n, e, a);
  return bc && (d ? d.push(p) : l && p()), p;
}
const uo = /* @__PURE__ */ new WeakMap(), O5 = /* @__PURE__ */ Symbol("_vte"), Mf = (n) => n.__isTeleport, Mr = (n) => n && (n.disabled || n.disabled === ""), RP = (n) => n && (n.defer || n.defer === ""), px = (n) => typeof SVGElement != "undefined" && n instanceof SVGElement, fx = (n) => typeof MathMLElement == "function" && n instanceof MathMLElement, Ub = (n, e) => {
  const t = n && n.to;
  return en(t) ? e ? e(t) : null : t;
}, zP = {
  name: "Teleport",
  __isTeleport: !0,
  process(n, e, t, i, s, o, r, a, l, d) {
    const {
      mc: c,
      pc: u,
      pbc: p,
      o: { insert: f, querySelector: y, createText: b, createComment: w, parentNode: k }
    } = d, S = Mr(e.props);
    let { dynamicChildren: _ } = e;
    const x = (z, P, D) => {
      z.shapeFlag & 16 && c(
        z.children,
        P,
        D,
        s,
        o,
        r,
        a,
        l
      );
    }, T = (z = e) => {
      const P = Mr(z.props), D = z.target = Ub(z.props, y), $ = Gb(D, z, b, f);
      D && (r !== "svg" && px(D) ? r = "svg" : r !== "mathml" && fx(D) && (r = "mathml"), s && s.isCE && (s.ce._teleportTargets || (s.ce._teleportTargets = /* @__PURE__ */ new Set())).add(D), P || (x(z, D, $), Td(z, !1)));
    }, M = (z) => {
      const P = () => {
        if (uo.get(z) === P) {
          if (uo.delete(z), Mr(z.props)) {
            const D = k(z.el) || t;
            x(z, D, z.anchor), Td(z, !0);
          }
          T(z);
        }
      };
      uo.set(z, P), Vn(P, o);
    };
    if (n == null) {
      const z = e.el = b(""), P = e.anchor = b("");
      if (f(z, t, i), f(P, t, i), RP(e.props) || o && o.pendingBranch) {
        M(e);
        return;
      }
      S && (x(e, t, P), Td(e, !0)), T();
    } else {
      e.el = n.el;
      const z = e.anchor = n.anchor, P = uo.get(n);
      if (P) {
        P.flags |= 8, uo.delete(n), M(e);
        return;
      }
      e.targetStart = n.targetStart;
      const D = e.target = n.target, $ = e.targetAnchor = n.targetAnchor, O = Mr(n.props), L = O ? t : D, Z = O ? z : $;
      if (r === "svg" || px(D) ? r = "svg" : (r === "mathml" || fx(D)) && (r = "mathml"), _ ? (p(
        n.dynamicChildren,
        _,
        L,
        s,
        o,
        r,
        a
      ), J0(n, e, !0)) : l || u(
        n,
        e,
        L,
        Z,
        s,
        o,
        r,
        a,
        !1
      ), S)
        O ? e.props && n.props && e.props.to !== n.props.to && (e.props.to = n.props.to) : lu(
          e,
          t,
          z,
          d,
          1
        );
      else if ((e.props && e.props.to) !== (n.props && n.props.to)) {
        const J = Ub(e.props, y);
        J && (e.target = J, lu(
          e,
          J,
          null,
          d,
          0
        ));
      } else O && lu(
        e,
        D,
        $,
        d,
        1
      );
      Td(e, S);
    }
  },
  remove(n, e, t, { um: i, o: { remove: s } }, o) {
    const {
      shapeFlag: r,
      children: a,
      anchor: l,
      targetStart: d,
      targetAnchor: c,
      target: u,
      props: p
    } = n, f = Mr(p), y = o || !f, b = uo.get(n);
    if (b && (b.flags |= 8, uo.delete(n)), u && (s(d), s(c)), o && s(l), !b && (f || u) && r & 16)
      for (let w = 0; w < a.length; w++) {
        const k = a[w];
        i(
          k,
          e,
          t,
          y,
          !!k.dynamicChildren
        );
      }
  },
  move: lu,
  hydrate: $P
};
function lu(n, e, t, { o: { insert: i }, m: s }, o = 2) {
  o === 0 && i(n.targetAnchor, e, t);
  const { el: r, anchor: a, shapeFlag: l, children: d, props: c } = n, u = o === 2;
  if (u && i(r, e, t), !uo.has(n) && (!u || Mr(c)) && l & 16)
    for (let p = 0; p < d.length; p++)
      s(
        d[p],
        e,
        t,
        2
      );
  u && i(a, e, t);
}
function $P(n, e, t, i, s, o, {
  o: { nextSibling: r, parentNode: a, querySelector: l, insert: d, createText: c }
}, u) {
  function p(w, k) {
    let S = k;
    for (; S; ) {
      if (S && S.nodeType === 8) {
        if (S.data === "teleport start anchor")
          e.targetStart = S;
        else if (S.data === "teleport anchor") {
          e.targetAnchor = S, w._lpa = e.targetAnchor && r(e.targetAnchor);
          break;
        }
      }
      S = r(S);
    }
  }
  function f(w, k) {
    k.anchor = u(
      r(w),
      k,
      a(w),
      t,
      i,
      s,
      o
    );
  }
  const y = e.target = Ub(
    e.props,
    l
  ), b = Mr(e.props);
  if (y) {
    const w = y._lpa || y.firstChild;
    e.shapeFlag & 16 && (b ? (f(n, e), p(y, w), e.targetAnchor || Gb(
      y,
      e,
      c,
      d,
      // if target is the same as the main view, insert anchors before current node
      // to avoid hydrating mismatch
      a(n) === y ? n : null
    )) : (e.anchor = r(n), p(y, w), e.targetAnchor || Gb(y, e, c, d), u(
      w && r(w),
      e,
      y,
      t,
      i,
      s,
      o
    ))), Td(e, b);
  } else b && e.shapeFlag & 16 && (f(n, e), e.targetStart = n, e.targetAnchor = r(n));
  return e.anchor && r(e.anchor);
}
const L5 = zP;
function Td(n, e) {
  const t = n.ctx;
  if (t && t.ut) {
    let i, s;
    for (e ? (i = n.el, s = n.anchor) : (i = n.targetStart, s = n.targetAnchor); i && i !== s; )
      i.nodeType === 1 && i.setAttribute("data-v-owner", t.uid), i = i.nextSibling;
    t.ut();
  }
}
function Gb(n, e, t, i, s = null) {
  const o = e.targetStart = t(""), r = e.targetAnchor = t("");
  return o[O5] = r, n && (i(o, n, s), i(r, n, s)), r;
}
const Si = /* @__PURE__ */ Symbol("_leaveCb"), Hl = /* @__PURE__ */ Symbol("_enterCb");
function B5() {
  const n = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return ot(() => {
    n.isMounted = !0;
  }), Ve(() => {
    n.isUnmounting = !0;
  }), n;
}
const _i = [Function, Array], F5 = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: _i,
  onEnter: _i,
  onAfterEnter: _i,
  onEnterCancelled: _i,
  // leave
  onBeforeLeave: _i,
  onLeave: _i,
  onAfterLeave: _i,
  onLeaveCancelled: _i,
  // appear
  onBeforeAppear: _i,
  onAppear: _i,
  onAfterAppear: _i,
  onAppearCancelled: _i
}, N5 = (n) => {
  const e = n.subTree;
  return e.component ? N5(e.component) : e;
}, DP = {
  name: "BaseTransition",
  props: F5,
  setup(n, { slots: e }) {
    const t = Al(), i = B5();
    return () => {
      const s = e.default && W0(e.default(), !0), o = s && s.length ? U5(s) : (
        // Keep explicit default-slot conditionals on the same transition path
        // as regular v-if branches, which render a comment placeholder.
        t.subTree ? E() : void 0
      );
      if (!o)
        return;
      const r = /* @__PURE__ */ At(n), { mode: a } = r;
      if (i.isLeaving)
        return mm(o);
      const l = vp(o);
      if (!l)
        return mm(o);
      let d = pc(
        l,
        r,
        i,
        t,
        // #11061, ensure enterHooks is fresh after clone
        (u) => d = u
      );
      l.type !== Nn && Kr(l, d);
      let c = t.subTree && vp(t.subTree);
      if (c && c.type !== Nn && !Cr(c, l) && N5(t).type !== Nn) {
        let u = pc(
          c,
          r,
          i,
          t
        );
        if (Kr(c, u), a === "out-in" && l.type !== Nn)
          return i.isLeaving = !0, u.afterLeave = () => {
            i.isLeaving = !1, t.job.flags & 8 || t.update(), delete u.afterLeave, c = void 0;
          }, mm(o);
        a === "in-out" && l.type !== Nn ? u.delayLeave = (p, f, y) => {
          const b = G5(
            i,
            c
          );
          b[String(c.key)] = c, p[Si] = () => {
            f(), p[Si] = void 0, delete d.delayedLeave, c = void 0;
          }, d.delayedLeave = () => {
            y(), delete d.delayedLeave, c = void 0;
          };
        } : c = void 0;
      } else c && (c = void 0);
      return o;
    };
  }
};
function U5(n) {
  let e = n[0];
  if (n.length > 1) {
    for (const t of n)
      if (t.type !== Nn) {
        e = t;
        break;
      }
  }
  return e;
}
const OP = DP;
function G5(n, e) {
  const { leavingVNodes: t } = n;
  let i = t.get(e.type);
  return i || (i = /* @__PURE__ */ Object.create(null), t.set(e.type, i)), i;
}
function pc(n, e, t, i, s) {
  const {
    appear: o,
    mode: r,
    persisted: a = !1,
    onBeforeEnter: l,
    onEnter: d,
    onAfterEnter: c,
    onEnterCancelled: u,
    onBeforeLeave: p,
    onLeave: f,
    onAfterLeave: y,
    onLeaveCancelled: b,
    onBeforeAppear: w,
    onAppear: k,
    onAfterAppear: S,
    onAppearCancelled: _
  } = e, x = String(n.key), T = G5(t, n), M = (D, $) => {
    D && Hi(
      D,
      i,
      9,
      $
    );
  }, z = (D, $) => {
    const O = $[1];
    M(D, $), pt(D) ? D.every((L) => L.length <= 1) && O() : D.length <= 1 && O();
  }, P = {
    mode: r,
    persisted: a,
    beforeEnter(D) {
      let $ = l;
      if (!t.isMounted)
        if (o)
          $ = w || l;
        else
          return;
      D[Si] && D[Si](
        !0
        /* cancelled */
      );
      const O = T[x];
      O && Cr(n, O) && O.el[Si] && O.el[Si](), M($, [D]);
    },
    enter(D) {
      if (T[x] === n) return;
      let $ = d, O = c, L = u;
      if (!t.isMounted)
        if (o)
          $ = k || d, O = S || c, L = _ || u;
        else
          return;
      let Z = !1;
      D[Hl] = (re) => {
        Z || (Z = !0, re ? M(L, [D]) : M(O, [D]), P.delayedLeave && P.delayedLeave(), D[Hl] = void 0);
      };
      const J = D[Hl].bind(null, !1);
      $ ? z($, [D, J]) : J();
    },
    leave(D, $) {
      const O = String(n.key);
      if (D[Hl] && D[Hl](
        !0
        /* cancelled */
      ), t.isUnmounting)
        return $();
      M(p, [D]);
      let L = !1;
      D[Si] = (J) => {
        L || (L = !0, $(), J ? M(b, [D]) : M(y, [D]), D[Si] = void 0, T[O] === n && delete T[O]);
      };
      const Z = D[Si].bind(null, !1);
      T[O] = n, f ? z(f, [D, Z]) : Z();
    },
    clone(D) {
      const $ = pc(
        D,
        e,
        t,
        i,
        s
      );
      return s && s($), $;
    }
  };
  return P;
}
function mm(n) {
  if (q0(n))
    return n = Fo(n), n.children = null, n;
}
function vp(n) {
  if (!q0(n))
    return Mf(n.type) && n.children ? U5(n.children) : n;
  if (n.component)
    return n.component.subTree;
  const { shapeFlag: e, children: t } = n;
  if (t) {
    if (e & 16)
      return t[0];
    if (e & 32 && Ot(t.default))
      return t.default();
  }
}
function Kr(n, e) {
  if (n.shapeFlag & 6 && n.component) {
    n.transition = e;
    const t = n.component.subTree;
    Kr(
      Mf(t.type) && vp(t) || t,
      e
    );
  } else n.shapeFlag & 128 ? (n.ssContent.transition = e.clone(n.ssContent), n.ssFallback.transition = e.clone(n.ssFallback)) : n.transition = e;
}
function W0(n, e = !1, t) {
  let i = [], s = 0;
  for (let o = 0; o < n.length; o++) {
    let r = n[o];
    const a = t == null ? r.key : String(t) + String(r.key != null ? r.key : o);
    r.type === H ? (r.patchFlag & 128 && s++, i = i.concat(
      W0(r.children, e, a)
    )) : (e || r.type !== Nn) && i.push(a != null ? Fo(r, { key: a }) : r);
  }
  if (s > 1)
    for (let o = 0; o < i.length; o++)
      i[o].patchFlag = -2;
  return i;
}
// @__NO_SIDE_EFFECTS__
function Re(n, e) {
  return Ot(n) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    li({ name: n.name }, e, { setup: n })
  ) : n;
}
function LP() {
  const n = Al();
  return n ? (n.appContext.config.idPrefix || "v") + "-" + n.ids[0] + n.ids[1]++ : "";
}
function BP(n) {
  n.ids = [n.ids[0] + n.ids[2]++ + "-", 0, 0];
}
function mx(n, e) {
  let t;
  return !!((t = Object.getOwnPropertyDescriptor(n, e)) && !t.configurable);
}
const yp = /* @__PURE__ */ new WeakMap();
function Hd(n, e, t, i, s = !1) {
  if (pt(n)) {
    n.forEach(
      (b, w) => Hd(
        b,
        e && (pt(e) ? e[w] : e),
        t,
        i,
        s
      )
    );
    return;
  }
  if (qa(i) && !s) {
    i.shapeFlag & 512 && i.type.__asyncResolved && i.component.subTree.component && Hd(n, e, t, i.component.subTree);
    return;
  }
  const o = i.shapeFlag & 4 ? Pf(i.component) : i.el, r = s ? null : o, { i: a, r: l } = n, d = e && e.r, c = a.refs === Yt ? a.refs = {} : a.refs, u = a.setupState, p = /* @__PURE__ */ At(u), f = u === Yt ? t5 : (b) => mx(c, b) ? !1 : Nt(p, b), y = (b, w) => !(w && mx(c, w));
  if (d != null && d !== l) {
    if (gx(e), en(d))
      c[d] = null, f(d) && (u[d] = null);
    else if (/* @__PURE__ */ Xn(d)) {
      const b = e;
      y(d, b.k) && (d.value = null), b.k && (c[b.k] = null);
    }
  }
  if (Ot(l))
    Vc(l, a, 12, [r, c]);
  else {
    const b = en(l), w = /* @__PURE__ */ Xn(l);
    if (b || w) {
      const k = () => {
        if (n.f) {
          const S = b ? f(l) ? u[l] : c[l] : y() || !n.k ? l.value : c[n.k];
          if (s)
            pt(S) && n5(S, o);
          else if (pt(S))
            S.includes(o) || S.push(o);
          else if (b)
            c[l] = [o], f(l) && (u[l] = c[l]);
          else {
            const _ = [o];
            y(l, n.k) && (l.value = _), n.k && (c[n.k] = _);
          }
        } else b ? (c[l] = r, f(l) && (u[l] = r)) : w && (y(l, n.k) && (l.value = r), n.k && (c[n.k] = r));
      };
      if (r) {
        const S = () => {
          k(), yp.delete(n);
        };
        S.id = -1, yp.set(n, S), Vn(S, t);
      } else
        gx(n), k();
    }
  }
}
function gx(n) {
  const e = yp.get(n);
  e && (e.flags |= 8, yp.delete(n));
}
kf().requestIdleCallback;
kf().cancelIdleCallback;
const qa = (n) => !!n.type.__asyncLoader, q0 = (n) => n.type.__isKeepAlive;
function FP(n, e, t = si, i = !1) {
  if (t) {
    const s = t[n] || (t[n] = []), o = e.__weh || (e.__weh = (...r) => {
      Oo();
      const a = Q0(t), l = Hi(e, t, n, r);
      return a(), Lo(), l;
    });
    return i ? s.unshift(o) : s.push(o), o;
  }
}
const K0 = (n) => (e, t = si) => {
  (!bc || n === "sp") && FP(n, (...i) => e(...i), t);
}, ot = K0("m"), j5 = K0("u"), Ve = K0(
  "bum"
), NP = "components", H5 = /* @__PURE__ */ Symbol.for("v-ndc");
function Yr(n) {
  return en(n) ? UP(NP, n, !1) || n : n || H5;
}
function UP(n, e, t = !0, i = !1) {
  const s = zn || si;
  if (s) {
    const o = s.type;
    {
      const a = yE(
        o,
        !1
      );
      if (a && (a === e || a === Yn(e) || a === wf(Yn(e))))
        return o;
    }
    const r = (
      // local registration
      // check instance[type] first which is resolved for options API
      bx(s[n] || o[n], e) || // global registration
      bx(s.appContext[n], e)
    );
    return !r && i ? o : r;
  }
}
function bx(n, e) {
  return n && (n[e] || n[Yn(e)] || n[wf(Yn(e))]);
}
function me(n, e, t, i) {
  let s;
  const o = t, r = pt(n);
  if (r || en(n)) {
    const a = r && /* @__PURE__ */ Co(n);
    let l = !1, d = !1;
    a && (l = !/* @__PURE__ */ Ii(n), d = /* @__PURE__ */ cs(n), n = _f(n)), s = new Array(n.length);
    for (let c = 0, u = n.length; c < u; c++)
      s[c] = e(
        l ? d ? Bo(Ai(n[c])) : Ai(n[c]) : n[c],
        c,
        void 0,
        o
      );
  } else if (typeof n == "number") {
    s = new Array(n);
    for (let a = 0; a < n; a++)
      s[a] = e(a + 1, a, void 0, o);
  } else if (jt(n))
    if (n[Symbol.iterator])
      s = Array.from(
        n,
        (a, l) => e(a, l, void 0, o)
      );
    else {
      const a = Object.keys(n);
      s = new Array(a.length);
      for (let l = 0, d = a.length; l < d; l++) {
        const c = a[l];
        s[l] = e(n[c], c, l, o);
      }
    }
  else
    s = [];
  return s;
}
function V5(n, e) {
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    if (pt(i))
      for (let s = 0; s < i.length; s++)
        n[i[s].name] = i[s].fn;
    else i && (n[i.name] = i.key ? (...s) => {
      const o = i.fn(...s);
      return o && (o.key = i.key), o;
    } : i.fn);
  }
  return n;
}
function Ws(n, e, t, i, s, o) {
  if (t == null && (t = {}), zn.ce || zn.parent && qa(zn.parent) && zn.parent.ce) {
    const d = t, c = Object.keys(d).length > 0;
    return e !== "default" && (d.name = e), g(), Ce(
      H,
      null,
      [C("slot", d, i)],
      c ? -2 : 64
    );
  }
  let r = n[e];
  r && r._c && (r._d = !1);
  const a = Us.length;
  g();
  let l;
  try {
    const d = r && W5(r(t)), c = t.key || o || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    d && d.key;
    l = Ce(
      H,
      {
        key: (c && !ji(c) ? c : `_${e}`) + // #7256 force differentiate fallback content from actual content
        (!d && i ? "_fb" : "")
      },
      d || (i ? i() : []),
      d && n._ === 1 ? 64 : -2
    );
  } catch (d) {
    for (let c = Us.length; c > a; c--) Z0();
    throw d;
  } finally {
    r && r._c && (r._d = !0);
  }
  return l.scopeId && (l.slotScopeIds = [l.scopeId + "-s"]), l;
}
function W5(n) {
  return n.some((e) => mc(e) ? !(e.type === Nn || e.type === H && !W5(e.children)) : !0) ? n : null;
}
const jb = (n) => n ? l3(n) ? Pf(n) : jb(n.parent) : null, Vd = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ li(/* @__PURE__ */ Object.create(null), {
    $: (n) => n,
    $el: (n) => n.vnode.el,
    $data: (n) => n.data,
    $props: (n) => n.props,
    $attrs: (n) => n.attrs,
    $slots: (n) => n.slots,
    $refs: (n) => n.refs,
    $parent: (n) => jb(n.parent),
    $root: (n) => jb(n.root),
    $host: (n) => n.ce,
    $emit: (n) => n.emit,
    $options: (n) => n.type,
    $forceUpdate: (n) => n.f || (n.f = () => {
      V0(n.update);
    }),
    $nextTick: (n) => n.n || (n.n = it.bind(n.proxy)),
    $watch: (n) => Ur
  })
), gm = (n, e) => n !== Yt && !n.__isScriptSetup && Nt(n, e), GP = {
  get({ _: n }, e) {
    if (e === "__v_skip")
      return !0;
    const { ctx: t, setupState: i, data: s, props: o, accessCache: r, type: a, appContext: l } = n;
    if (e[0] !== "$") {
      const p = r[e];
      if (p !== void 0)
        switch (p) {
          case 1:
            return i[e];
          case 2:
            return s[e];
          case 4:
            return t[e];
          case 3:
            return o[e];
        }
      else {
        if (gm(i, e))
          return r[e] = 1, i[e];
        if (Nt(o, e))
          return r[e] = 3, o[e];
        if (t !== Yt && Nt(t, e))
          return r[e] = 4, t[e];
        r[e] = 0;
      }
    }
    const d = Vd[e];
    let c, u;
    if (d)
      return e === "$attrs" && Bn(n.attrs, "get", ""), d(n);
    if (
      // css module (injected by vue-loader)
      (c = a.__cssModules) && (c = c[e])
    )
      return c;
    if (t !== Yt && Nt(t, e))
      return r[e] = 4, t[e];
    if (
      // global properties
      u = l.config.globalProperties, Nt(u, e)
    )
      return u[e];
  },
  set({ _: n }, e, t) {
    const { data: i, setupState: s, ctx: o } = n;
    return gm(s, e) ? (s[e] = t, !0) : Nt(n.props, e) || e[0] === "$" && e.slice(1) in n ? !1 : (o[e] = t, !0);
  },
  has({
    _: { data: n, setupState: e, accessCache: t, ctx: i, appContext: s, props: o, type: r }
  }, a) {
    let l;
    return !!(t[a] || gm(e, a) || Nt(o, a) || Nt(i, a) || Nt(Vd, a) || Nt(s.config.globalProperties, a) || (l = r.__cssModules) && l[a]);
  },
  defineProperty(n, e, t) {
    return t.get != null ? n._.accessCache[e] = 0 : Nt(t, "value") && this.set(n, e, t.value, null), Reflect.defineProperty(n, e, t);
  }
};
function jP() {
  return HP().slots;
}
function HP(n) {
  const e = Al();
  return e.setupContext || (e.setupContext = c3(e));
}
function q5() {
  return {
    app: null,
    config: {
      isNativeTag: t5,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let VP = 0;
function WP(n, e) {
  return function(i, s = null) {
    Ot(i) || (i = li({}, i)), s != null && !jt(s) && (s = null);
    const o = q5(), r = /* @__PURE__ */ new WeakSet(), a = [];
    let l = !1;
    const d = o.app = {
      _uid: VP++,
      _component: i,
      _props: s,
      _container: null,
      _context: o,
      _instance: null,
      version: wE,
      get config() {
        return o.config;
      },
      set config(c) {
      },
      use(c, ...u) {
        return r.has(c) || (c && Ot(c.install) ? (r.add(c), c.install(d, ...u)) : Ot(c) && (r.add(c), c(d, ...u))), d;
      },
      mixin(c) {
        return d;
      },
      component(c, u) {
        return u ? (o.components[c] = u, d) : o.components[c];
      },
      directive(c, u) {
        return u ? (o.directives[c] = u, d) : o.directives[c];
      },
      mount(c, u, p) {
        if (!l) {
          const f = d._ceVNode || C(i, s);
          return f.appContext = o, p === !0 ? p = "svg" : p === !1 && (p = void 0), n(f, c, p), l = !0, d._container = c, c.__vue_app__ = d, Pf(f.component);
        }
      },
      onUnmount(c) {
        a.push(c);
      },
      unmount() {
        l && (Hi(
          a,
          d._instance,
          16
        ), n(null, d._container), delete d._container.__vue_app__);
      },
      provide(c, u) {
        return o.provides[c] = u, d;
      },
      runWithContext(c) {
        const u = Ka;
        Ka = d;
        try {
          return c();
        } finally {
          Ka = u;
        }
      }
    };
    return d;
  };
}
let Ka = null;
const qP = (n, e) => e === "modelValue" || e === "model-value" ? n.modelModifiers : n[`${e}Modifiers`] || n[`${Yn(e)}Modifiers`] || n[`${qo(e)}Modifiers`];
function KP(n, e, ...t) {
  if (n.isUnmounted) return;
  const i = n.vnode.props || Yt;
  let s = t;
  const o = e.startsWith("update:"), r = o && qP(i, e.slice(7));
  r && (r.trim && (s = t.map((c) => en(c) ? c.trim() : c)), r.number && (s = s.map(O0)));
  let a, l = i[a = cm(e)] || // also try camelCase event handler (#2249)
  i[a = cm(Yn(e))];
  !l && o && (l = i[a = cm(qo(e))]), l && Hi(
    l,
    n,
    6,
    s
  );
  const d = i[a + "Once"];
  if (d) {
    if (!n.emitted)
      n.emitted = {};
    else if (n.emitted[a])
      return;
    n.emitted[a] = !0, Hi(
      d,
      n,
      6,
      s
    );
  }
}
function YP(n, e, t = !1) {
  const i = e.emitsCache, s = i.get(n);
  if (s !== void 0)
    return s;
  const o = n.emits;
  let r = {};
  return o ? (pt(o) ? o.forEach((a) => r[a] = null) : li(r, o), jt(n) && i.set(n, r), r) : (jt(n) && i.set(n, null), null);
}
function Cf(n, e) {
  return !n || !vf(e) ? !1 : (e = e.slice(2), e = e === "Once" ? e : e.replace(/Once$/, ""), Nt(n, e[0].toLowerCase() + e.slice(1)) || Nt(n, qo(e)) || Nt(n, e));
}
function vx(n) {
  const {
    type: e,
    vnode: t,
    proxy: i,
    withProxy: s,
    propsOptions: [o],
    slots: r,
    attrs: a,
    emit: l,
    render: d,
    renderCache: c,
    props: u,
    data: p,
    setupState: f,
    ctx: y,
    inheritAttrs: b
  } = n, w = bp(n);
  let k, S;
  try {
    if (t.shapeFlag & 4) {
      const x = s || i, T = x;
      k = is(
        d.call(
          T,
          x,
          c,
          u,
          f,
          p,
          y
        )
      ), S = a;
    } else {
      const x = e;
      k = is(
        x.length > 1 ? x(
          u,
          { attrs: a, slots: r, emit: l }
        ) : x(
          u,
          null
        )
      ), S = e.props ? a : XP(a);
    }
  } catch (x) {
    Us.length = 0, Sf(x, n, 1), k = C(Nn);
  }
  let _ = k;
  if (S && b !== !1) {
    const x = Object.keys(S), { shapeFlag: T } = _;
    x.length && T & 7 && (o && x.some(yf) && (S = JP(
      S,
      o
    )), _ = Fo(_, S, !1, !0));
  }
  if (t.dirs && (_ = Fo(_, null, !1, !0), _.dirs = _.dirs ? _.dirs.concat(t.dirs) : t.dirs), t.transition) {
    const x = Mf(_.type) && vp(_) || _;
    Kr(x, t.transition);
  }
  return k = _, bp(w), k;
}
const XP = (n) => {
  let e;
  for (const t in n)
    (t === "class" || t === "style" || vf(t)) && ((e || (e = {}))[t] = n[t]);
  return e;
}, JP = (n, e) => {
  const t = {};
  for (const i in n)
    (!yf(i) || !(i.slice(9) in e)) && (t[i] = n[i]);
  return t;
};
function ZP(n, e, t) {
  const { props: i, children: s, component: o } = n, { props: r, children: a, patchFlag: l } = e, d = o.emitsOptions;
  if (e.dirs || e.transition)
    return !0;
  if (t && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return i ? yx(i, r, d) : !!r;
    if (l & 8) {
      const c = e.dynamicProps;
      for (let u = 0; u < c.length; u++) {
        const p = c[u];
        if (K5(r, i, p) && !Cf(d, p))
          return !0;
      }
    }
  } else
    return (s || a) && (!a || !a.$stable) ? !0 : i === r ? !1 : i ? r ? yx(i, r, d) : !0 : !!r;
  return !1;
}
function yx(n, e, t) {
  const i = Object.keys(e);
  if (i.length !== Object.keys(n).length)
    return !0;
  for (let s = 0; s < i.length; s++) {
    const o = i[s];
    if (K5(e, n, o) && !Cf(t, o))
      return !0;
  }
  return !1;
}
function K5(n, e, t) {
  const i = n[t], s = e[t];
  return t === "style" && jt(i) && jt(s) ? !Il(i, s) : i !== s;
}
function QP({ vnode: n, parent: e, suspense: t }, i) {
  for (; e; ) {
    const s = e.subTree;
    if (s.suspense && s.suspense.activeBranch === n && (s.suspense.vnode.el = s.el = i, n = s), s === n)
      (n = e.vnode).el = i, e = e.parent;
    else
      break;
  }
  t && t.activeBranch === n && (t.vnode.el = i);
}
const Y5 = {}, X5 = () => Object.create(Y5), J5 = (n) => Object.getPrototypeOf(n) === Y5;
function eE(n, e, t, i = !1) {
  const s = {}, o = X5();
  n.propsDefaults = /* @__PURE__ */ Object.create(null), Z5(n, e, s, o);
  for (const r in n.propsOptions[0])
    r in s || (s[r] = void 0);
  t ? n.props = i ? s : /* @__PURE__ */ M5(s) : n.type.props ? n.props = s : n.props = o, n.attrs = o;
}
function tE(n, e, t, i) {
  const {
    props: s,
    attrs: o,
    vnode: { patchFlag: r }
  } = n, a = /* @__PURE__ */ At(s), [l] = n.propsOptions;
  let d = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (i || r > 0) && !(r & 16)
  ) {
    if (r & 8) {
      const c = n.vnode.dynamicProps;
      for (let u = 0; u < c.length; u++) {
        let p = c[u];
        if (Cf(n.emitsOptions, p))
          continue;
        const f = e[p];
        if (l)
          if (Nt(o, p))
            f !== o[p] && (o[p] = f, d = !0);
          else {
            const y = Yn(p);
            s[y] = Hb(
              l,
              a,
              y,
              f,
              n,
              !1
            );
          }
        else
          f !== o[p] && (o[p] = f, d = !0);
      }
    }
  } else {
    Z5(n, e, s, o) && (d = !0);
    let c;
    for (const u in a)
      (!e || // for camelCase
      !Nt(e, u) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = qo(u)) === u || !Nt(e, c))) && (l ? t && // for camelCase
      (t[u] !== void 0 || // for kebab-case
      t[c] !== void 0) && (s[u] = Hb(
        l,
        a,
        u,
        void 0,
        n,
        !0
      )) : delete s[u]);
    if (o !== a)
      for (const u in o)
        (!e || !Nt(e, u)) && (delete o[u], d = !0);
  }
  d && Os(n.attrs, "set", "");
}
function Z5(n, e, t, i) {
  const [s, o] = n.propsOptions;
  let r = !1, a;
  if (e)
    for (let l in e) {
      if (Ud(l))
        continue;
      const d = e[l];
      let c;
      s && Nt(s, c = Yn(l)) ? !o || !o.includes(c) ? t[c] = d : (a || (a = {}))[c] = d : Cf(n.emitsOptions, l) || (!(l in i) || d !== i[l]) && (i[l] = d, r = !0);
    }
  if (o) {
    const l = /* @__PURE__ */ At(t), d = a || Yt;
    for (let c = 0; c < o.length; c++) {
      const u = o[c];
      t[u] = Hb(
        s,
        l,
        u,
        d[u],
        n,
        !Nt(d, u)
      );
    }
  }
  return r;
}
function Hb(n, e, t, i, s, o) {
  const r = n[t];
  if (r != null) {
    const a = Nt(r, "default");
    if (a && i === void 0) {
      const l = r.default;
      if (r.type !== Function && !r.skipFactory && Ot(l)) {
        const { propsDefaults: d } = s;
        if (t in d)
          i = d[t];
        else {
          const c = Q0(s);
          i = d[t] = l.call(
            null,
            e
          ), c();
        }
      } else
        i = l;
      s.ce && s.ce._setProp(t, i);
    }
    r[
      0
      /* shouldCast */
    ] && (o && !a ? i = !1 : r[
      1
      /* shouldCastTrue */
    ] && (i === "" || i === qo(t)) && (i = !0));
  }
  return i;
}
function nE(n, e, t = !1) {
  const i = e.propsCache, s = i.get(n);
  if (s)
    return s;
  const o = n.props, r = {}, a = [];
  if (!o)
    return jt(n) && i.set(n, Er), Er;
  if (pt(o))
    for (let d = 0; d < o.length; d++) {
      const c = Yn(o[d]);
      xx(c) && (r[c] = Yt);
    }
  else if (o)
    for (const d in o) {
      const c = Yn(d);
      if (xx(c)) {
        const u = o[d], p = r[c] = pt(u) || Ot(u) ? { type: u } : li({}, u), f = p.type;
        let y = !1, b = !0;
        if (pt(f))
          for (let w = 0; w < f.length; ++w) {
            const k = f[w], S = Ot(k) && k.name;
            if (S === "Boolean") {
              y = !0;
              break;
            } else S === "String" && (b = !1);
          }
        else
          y = Ot(f) && f.name === "Boolean";
        p[
          0
          /* shouldCast */
        ] = y, p[
          1
          /* shouldCastTrue */
        ] = b, (y || Nt(p, "default")) && a.push(c);
      }
    }
  const l = [r, a];
  return jt(n) && i.set(n, l), l;
}
function xx(n) {
  return n[0] !== "$" && !Ud(n);
}
const Y0 = (n) => n === "_" || n === "_ctx" || n === "$stable", X0 = (n) => pt(n) ? n.map(is) : [is(n)], iE = (n, e, t) => {
  if (e._n)
    return e;
  const i = et((...s) => X0(e(...s)), t);
  return i._c = !1, i;
}, Q5 = (n, e, t) => {
  const i = n._ctx;
  for (const s in n) {
    if (Y0(s)) continue;
    const o = n[s];
    if (Ot(o))
      e[s] = iE(s, o, i);
    else if (o != null) {
      const r = X0(o);
      e[s] = () => r;
    }
  }
}, e3 = (n, e) => {
  const t = X0(e);
  n.slots.default = () => t;
}, t3 = (n, e, t) => {
  for (const i in e)
    (t || !Y0(i)) && (n[i] = e[i]);
}, sE = (n, e, t) => {
  const i = n.slots = X5();
  if (n.vnode.shapeFlag & 32) {
    const s = e._;
    s ? (t3(i, e, t), t && r5(i, "_", s, !0)) : Q5(e, i);
  } else e && e3(n, e);
}, oE = (n, e, t) => {
  const { vnode: i, slots: s } = n;
  let o = !0, r = Yt;
  if (i.shapeFlag & 32) {
    const a = e._;
    a ? t && a === 1 ? o = !1 : t3(s, e, t) : (o = !e.$stable, Q5(e, s)), r = e;
  } else e && (e3(n, e), r = { default: 1 });
  if (o)
    for (const a in s)
      !Y0(a) && r[a] == null && delete s[a];
}, Vn = cE;
function rE(n) {
  return aE(n);
}
function aE(n, e) {
  const t = kf();
  t.__VUE__ = !0;
  const {
    insert: i,
    remove: s,
    patchProp: o,
    createElement: r,
    createText: a,
    createComment: l,
    setText: d,
    setElementText: c,
    parentNode: u,
    nextSibling: p,
    setScopeId: f = Ur,
    insertStaticContent: y
  } = n, b = (j, V, Q, oe = null, ue = null, Ie = null, he = void 0, ye = null, fe = !!V.dynamicChildren) => {
    if (j === V)
      return;
    j && !Cr(j, V) && (oe = ie(j), q(j, ue, Ie, !0), j = null), V.patchFlag === -2 && (fe = !1, V.dynamicChildren = null), V.dynamicChildren && j && j.dynamicChildren && j.dynamicChildren.hasOnce && (V.dynamicChildren === Er && (V.dynamicChildren = []), V.dynamicChildren.hasOnce = !0);
    const { type: ze, ref: He, shapeFlag: ce } = V;
    switch (ze) {
      case If:
        w(j, V, Q, oe);
        break;
      case Nn:
        k(j, V, Q, oe);
        break;
      case jh:
        j == null && S(V, Q, oe, he);
        break;
      case H:
        L(
          j,
          V,
          Q,
          oe,
          ue,
          Ie,
          he,
          ye,
          fe
        );
        break;
      default:
        ce & 1 ? T(
          j,
          V,
          Q,
          oe,
          ue,
          Ie,
          he,
          ye,
          fe
        ) : ce & 6 ? Z(
          j,
          V,
          Q,
          oe,
          ue,
          Ie,
          he,
          ye,
          fe
        ) : (ce & 64 || ce & 128) && ze.process(
          j,
          V,
          Q,
          oe,
          ue,
          Ie,
          he,
          ye,
          fe,
          Oe
        );
    }
    He != null && ue ? Hd(He, j && j.ref, Ie, V || j, !V) : He == null && j && j.ref != null && Hd(j.ref, null, Ie, j, !0);
  }, w = (j, V, Q, oe) => {
    if (j == null)
      i(
        V.el = a(V.children),
        Q,
        oe
      );
    else {
      const ue = V.el = j.el;
      V.children !== j.children && d(ue, V.children);
    }
  }, k = (j, V, Q, oe) => {
    j == null ? i(
      V.el = l(V.children || ""),
      Q,
      oe
    ) : V.el = j.el;
  }, S = (j, V, Q, oe) => {
    [j.el, j.anchor] = y(
      j.children,
      V,
      Q,
      oe,
      j.el,
      j.anchor
    );
  }, _ = ({ el: j, anchor: V }, Q, oe) => {
    let ue;
    for (; j && j !== V; )
      ue = p(j), i(j, Q, oe), j = ue;
    i(V, Q, oe);
  }, x = ({ el: j, anchor: V }) => {
    let Q;
    for (; j && j !== V; )
      Q = p(j), s(j), j = Q;
    s(V);
  }, T = (j, V, Q, oe, ue, Ie, he, ye, fe) => {
    if (V.type === "svg" ? he = "svg" : V.type === "math" && (he = "mathml"), j == null)
      M(
        V,
        Q,
        oe,
        ue,
        Ie,
        he,
        ye,
        fe
      );
    else {
      const ze = j.el && j.el._isVueCE ? j.el : null;
      try {
        ze && ze._beginPatch(), D(
          j,
          V,
          ue,
          Ie,
          he,
          ye,
          fe
        );
      } finally {
        ze && ze._endPatch();
      }
    }
  }, M = (j, V, Q, oe, ue, Ie, he, ye) => {
    let fe, ze;
    const { props: He, shapeFlag: ce, transition: be, dirs: Be } = j;
    if (fe = j.el = r(
      j.type,
      Ie,
      He && He.is,
      He
    ), ce & 8 ? c(fe, j.children) : ce & 16 && P(
      j.children,
      fe,
      null,
      oe,
      ue,
      bm(j, Ie),
      he,
      ye
    ), Be && er(j, null, oe, "created"), z(fe, j, j.scopeId, he, oe), He) {
      for (const Ke in He)
        Ke !== "value" && !Ud(Ke) && o(fe, Ke, null, He[Ke], Ie, oe);
      "value" in He && o(fe, "value", null, He.value, Ie), (ze = He.onVnodeBeforeMount) && qi(ze, oe, j);
    }
    Be && er(j, null, oe, "beforeMount");
    const Fe = lE(ue, be);
    Fe && be.beforeEnter(fe), i(fe, V, Q), ((ze = He && He.onVnodeMounted) || Fe || Be) && Vn(() => {
      ze && qi(ze, oe, j), Fe && be.enter(fe), Be && er(j, null, oe, "mounted");
    }, ue);
  }, z = (j, V, Q, oe, ue) => {
    if (Q && f(j, Q), oe)
      for (let Ie = 0; Ie < oe.length; Ie++)
        f(j, oe[Ie]);
    if (ue) {
      let Ie = ue.subTree;
      if (V === Ie || s3(Ie.type) && (Ie.ssContent === V || Ie.ssFallback === V)) {
        const he = ue.vnode;
        z(
          j,
          he,
          he.scopeId,
          he.slotScopeIds,
          ue.parent
        );
      }
    }
  }, P = (j, V, Q, oe, ue, Ie, he, ye, fe = 0) => {
    for (let ze = fe; ze < j.length; ze++) {
      const He = j[ze] = ye ? Rs(j[ze]) : is(j[ze]);
      b(
        null,
        He,
        V,
        Q,
        oe,
        ue,
        Ie,
        he,
        ye
      );
    }
  }, D = (j, V, Q, oe, ue, Ie, he) => {
    const ye = V.el = j.el;
    let { patchFlag: fe, dynamicChildren: ze, dirs: He } = V;
    fe |= j.patchFlag & 16;
    const ce = j.props || Yt, be = V.props || Yt;
    let Be;
    if (Q && tr(Q, !1), (Be = be.onVnodeBeforeUpdate) && qi(Be, Q, V, j), He && er(V, j, Q, "beforeUpdate"), Q && tr(Q, !0), // #6385 the old vnode may be a user-wrapped non-isomorphic block
    // Force full diff when block metadata is unstable.
    ze && (!j.dynamicChildren || j.dynamicChildren.length !== ze.length) && (fe = 0, he = !1, ze = null), (ce.innerHTML && be.innerHTML == null || ce.textContent && be.textContent == null) && c(ye, ""), ze ? $(
      j.dynamicChildren,
      ze,
      ye,
      Q,
      oe,
      bm(V, ue),
      Ie
    ) : he || ee(
      j,
      V,
      ye,
      null,
      Q,
      oe,
      bm(V, ue),
      Ie,
      !1
    ), fe > 0) {
      if (fe & 16)
        O(ye, ce, be, Q, ue);
      else if (fe & 2 && ce.class !== be.class && o(ye, "class", null, be.class, ue), fe & 4 && o(ye, "style", ce.style, be.style, ue), fe & 8) {
        const Fe = V.dynamicProps;
        for (let Ke = 0; Ke < Fe.length; Ke++) {
          const Qe = Fe[Ke], ht = ce[Qe], Le = be[Qe];
          (Le !== ht || Qe === "value") && o(ye, Qe, ht, Le, ue, Q);
        }
      }
      fe & 1 && j.children !== V.children && c(ye, V.children);
    } else !he && ze == null && O(ye, ce, be, Q, ue);
    ((Be = be.onVnodeUpdated) || He) && Vn(() => {
      Be && qi(Be, Q, V, j), He && er(V, j, Q, "updated");
    }, oe);
  }, $ = (j, V, Q, oe, ue, Ie, he) => {
    for (let ye = 0; ye < V.length; ye++) {
      const fe = j[ye], ze = V[ye], He = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        fe.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (fe.type === H || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Cr(fe, ze) || // - In the case of a component, it could contain anything.
        fe.shapeFlag & 198) ? u(fe.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          Q
        )
      );
      b(
        fe,
        ze,
        He,
        null,
        oe,
        ue,
        Ie,
        he,
        !0
      );
    }
  }, O = (j, V, Q, oe, ue) => {
    if (V !== Q) {
      if (V !== Yt)
        for (const Ie in V)
          !Ud(Ie) && !(Ie in Q) && o(
            j,
            Ie,
            V[Ie],
            null,
            ue,
            oe
          );
      for (const Ie in Q) {
        if (Ud(Ie)) continue;
        const he = Q[Ie], ye = V[Ie];
        he !== ye && Ie !== "value" && o(j, Ie, ye, he, ue, oe);
      }
      "value" in Q && o(j, "value", V.value, Q.value, ue);
    }
  }, L = (j, V, Q, oe, ue, Ie, he, ye, fe) => {
    const ze = V.el = j ? j.el : a(""), He = V.anchor = j ? j.anchor : a("");
    let { patchFlag: ce, dynamicChildren: be, slotScopeIds: Be } = V;
    Be && (ye = ye ? ye.concat(Be) : Be), j == null ? (i(ze, Q, oe), i(He, Q, oe), P(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      V.children || [],
      Q,
      He,
      ue,
      Ie,
      he,
      ye,
      fe
    )) : ce > 0 && ce & 64 && be && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    j.dynamicChildren && j.dynamicChildren.length === be.length ? ($(
      j.dynamicChildren,
      be,
      Q,
      ue,
      Ie,
      he,
      ye
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (V.key != null || ue && V === ue.subTree) && J0(
      j,
      V,
      !0
      /* shallow */
    )) : ee(
      j,
      V,
      Q,
      He,
      ue,
      Ie,
      he,
      ye,
      fe
    );
  }, Z = (j, V, Q, oe, ue, Ie, he, ye, fe) => {
    V.slotScopeIds = ye, j == null ? V.shapeFlag & 512 ? ue.ctx.activate(
      V,
      Q,
      oe,
      he,
      fe
    ) : J(
      V,
      Q,
      oe,
      ue,
      Ie,
      he,
      fe
    ) : re(j, V, fe);
  }, J = (j, V, Q, oe, ue, Ie, he) => {
    const ye = j.component = mE(
      j,
      oe,
      ue
    );
    if (q0(j) && (ye.ctx.renderer = Oe), gE(ye, !1, he), ye.asyncDep) {
      if (ue && ue.registerDep(ye, F, he), !j.el) {
        const fe = ye.subTree = C(Nn);
        k(null, fe, V, Q), j.placeholder = fe.el;
      }
    } else
      F(
        ye,
        j,
        V,
        Q,
        ue,
        Ie,
        he
      );
  }, re = (j, V, Q) => {
    const oe = V.component = j.component;
    if (ZP(j, V, Q))
      if (oe.asyncDep && !oe.asyncResolved) {
        V.el = j.el, W(oe, V, Q);
        return;
      } else
        oe.next = V, oe.update();
    else
      V.el = j.el, oe.vnode = V;
  }, F = (j, V, Q, oe, ue, Ie, he) => {
    const ye = () => {
      if (j.isMounted) {
        let { next: ce, bu: be, u: Be, parent: Fe, vnode: Ke } = j;
        {
          const le = n3(j);
          if (le) {
            ce && (ce.el = Ke.el, W(j, ce, he)), le.asyncDep.then(() => {
              Vn(() => {
                j.isUnmounted || ze();
              }, ue);
            });
            return;
          }
        }
        let Qe = ce, ht;
        tr(j, !1), ce ? (ce.el = Ke.el, W(j, ce, he)) : ce = Ke, be && Gh(be), (ht = ce.props && ce.props.onVnodeBeforeUpdate) && qi(ht, Fe, ce, Ke), tr(j, !0);
        const Le = vx(j), Ne = j.subTree;
        j.subTree = Le, b(
          Ne,
          Le,
          // parent may have changed if it's in a teleport
          u(Ne.el),
          // anchor may have changed if it's in a fragment
          ie(Ne),
          j,
          ue,
          Ie
        ), ce.el = Le.el, Qe === null && QP(j, Le.el), Be && Vn(Be, ue), (ht = ce.props && ce.props.onVnodeUpdated) && Vn(
          () => qi(ht, Fe, ce, Ke),
          ue
        );
      } else {
        let ce;
        const { el: be, props: Be } = V, { bm: Fe, m: Ke, parent: Qe, root: ht, type: Le } = j, Ne = qa(V);
        tr(j, !1), Fe && Gh(Fe), !Ne && (ce = Be && Be.onVnodeBeforeMount) && qi(ce, Qe, V), tr(j, !0);
        {
          ht.ce && ht.ce._hasShadowRoot() && ht.ce._injectChildStyle(
            Le,
            j.parent ? j.parent.type : void 0
          );
          const le = j.subTree = vx(j);
          b(
            null,
            le,
            Q,
            oe,
            j,
            ue,
            Ie
          ), V.el = le.el;
        }
        if (Ke && Vn(Ke, ue), !Ne && (ce = Be && Be.onVnodeMounted)) {
          const le = V;
          Vn(
            () => qi(ce, Qe, le),
            ue
          );
        }
        (V.shapeFlag & 256 || Qe && qa(Qe.vnode) && Qe.vnode.shapeFlag & 256) && j.a && Vn(j.a, ue), j.isMounted = !0, V = Q = oe = null;
      }
    };
    j.scope.on();
    const fe = j.effect = new h5(ye);
    j.scope.off();
    const ze = j.update = fe.run.bind(fe), He = j.job = fe.runIfDirty.bind(fe);
    He.i = j, He.id = j.uid, fe.scheduler = () => V0(He), tr(j, !0), ze();
  }, W = (j, V, Q) => {
    V.component = j;
    const oe = j.vnode.props;
    j.vnode = V, j.next = null, tE(j, V.props, oe, Q), oE(j, V.children, Q), Oo(), hx(j), Lo();
  }, ee = (j, V, Q, oe, ue, Ie, he, ye, fe = !1) => {
    const ze = j && j.children, He = j ? j.shapeFlag : 0, ce = V.children, { patchFlag: be, shapeFlag: Be } = V;
    if (be > 0) {
      if (be & 128) {
        te(
          ze,
          ce,
          Q,
          oe,
          ue,
          Ie,
          he,
          ye,
          fe
        );
        return;
      } else if (be & 256) {
        N(
          ze,
          ce,
          Q,
          oe,
          ue,
          Ie,
          he,
          ye,
          fe
        );
        return;
      }
    }
    Be & 8 ? (He & 16 && Y(ze, ue, Ie), ce !== ze && c(Q, ce)) : He & 16 ? Be & 16 ? te(
      ze,
      ce,
      Q,
      oe,
      ue,
      Ie,
      he,
      ye,
      fe
    ) : Y(ze, ue, Ie, !0) : (He & 8 && c(Q, ""), Be & 16 && P(
      ce,
      Q,
      oe,
      ue,
      Ie,
      he,
      ye,
      fe
    ));
  }, N = (j, V, Q, oe, ue, Ie, he, ye, fe) => {
    j = j || Er, V = V || Er;
    const ze = j.length, He = V.length, ce = Math.min(ze, He);
    let be;
    for (be = 0; be < ce; be++) {
      const Be = V[be] = fe ? Rs(V[be]) : is(V[be]);
      b(
        j[be],
        Be,
        Q,
        null,
        ue,
        Ie,
        he,
        ye,
        fe
      );
    }
    ze > He ? Y(
      j,
      ue,
      Ie,
      !0,
      !1,
      ce
    ) : P(
      V,
      Q,
      oe,
      ue,
      Ie,
      he,
      ye,
      fe,
      ce
    );
  }, te = (j, V, Q, oe, ue, Ie, he, ye, fe) => {
    let ze = 0;
    const He = V.length;
    let ce = j.length - 1, be = He - 1;
    for (; ze <= ce && ze <= be; ) {
      const Be = j[ze], Fe = V[ze] = fe ? Rs(V[ze]) : is(V[ze]);
      if (Cr(Be, Fe))
        b(
          Be,
          Fe,
          Q,
          null,
          ue,
          Ie,
          he,
          ye,
          fe
        );
      else
        break;
      ze++;
    }
    for (; ze <= ce && ze <= be; ) {
      const Be = j[ce], Fe = V[be] = fe ? Rs(V[be]) : is(V[be]);
      if (Cr(Be, Fe))
        b(
          Be,
          Fe,
          Q,
          null,
          ue,
          Ie,
          he,
          ye,
          fe
        );
      else
        break;
      ce--, be--;
    }
    if (ze > ce) {
      if (ze <= be) {
        const Be = be + 1, Fe = Be < He ? V[Be].el : oe;
        for (; ze <= be; )
          b(
            null,
            V[ze] = fe ? Rs(V[ze]) : is(V[ze]),
            Q,
            Fe,
            ue,
            Ie,
            he,
            ye,
            fe
          ), ze++;
      }
    } else if (ze > be)
      for (; ze <= ce; )
        q(j[ze], ue, Ie, !0), ze++;
    else {
      const Be = ze, Fe = ze, Ke = /* @__PURE__ */ new Map();
      for (ze = Fe; ze <= be; ze++) {
        const je = V[ze] = fe ? Rs(V[ze]) : is(V[ze]);
        je.key != null && Ke.set(je.key, ze);
      }
      let Qe, ht = 0;
      const Le = be - Fe + 1;
      let Ne = !1, le = 0;
      const ve = new Array(Le);
      for (ze = 0; ze < Le; ze++) ve[ze] = 0;
      for (ze = Be; ze <= ce; ze++) {
        const je = j[ze];
        if (ht >= Le) {
          q(je, ue, Ie, !0);
          continue;
        }
        let Se;
        if (je.key != null)
          Se = Ke.get(je.key);
        else
          for (Qe = Fe; Qe <= be; Qe++)
            if (ve[Qe - Fe] === 0 && Cr(je, V[Qe])) {
              Se = Qe;
              break;
            }
        Se === void 0 ? q(je, ue, Ie, !0) : (ve[Se - Fe] = ze + 1, Se >= le ? le = Se : Ne = !0, b(
          je,
          V[Se],
          Q,
          null,
          ue,
          Ie,
          he,
          ye,
          fe
        ), ht++);
      }
      const we = Ne ? dE(ve) : Er;
      for (Qe = we.length - 1, ze = Le - 1; ze >= 0; ze--) {
        const je = Fe + ze, Se = V[je], Te = V[je + 1], ae = je + 1 < He ? (
          // #13559, #14173 fallback to el placeholder for unresolved async component
          Te.el || i3(Te)
        ) : oe;
        ve[ze] === 0 ? b(
          null,
          Se,
          Q,
          ae,
          ue,
          Ie,
          he,
          ye,
          fe
        ) : Ne && (Qe < 0 || ze !== we[Qe] ? G(Se, Q, ae, 2) : Qe--);
      }
    }
  }, G = (j, V, Q, oe, ue = null) => {
    const { el: Ie, type: he, transition: ye, children: fe, shapeFlag: ze } = j;
    if (ze & 6) {
      G(j.component.subTree, V, Q, oe);
      return;
    }
    if (ze & 128) {
      j.suspense.move(V, Q, oe);
      return;
    }
    if (ze & 64) {
      he.move(j, V, Q, Oe);
      return;
    }
    if (he === H) {
      i(Ie, V, Q);
      for (let ce = 0; ce < fe.length; ce++)
        G(fe[ce], V, Q, oe);
      i(j.anchor, V, Q);
      return;
    }
    if (he === jh) {
      _(j, V, Q);
      return;
    }
    if (oe !== 2 && ze & 1 && ye)
      if (oe === 0)
        ye.persisted && !Ie[Si] ? i(Ie, V, Q) : (ye.beforeEnter(Ie), i(Ie, V, Q), Vn(() => ye.enter(Ie), ue));
      else {
        const { leave: ce, delayLeave: be, afterLeave: Be } = ye, Fe = () => {
          j.ctx.isUnmounted ? s(Ie) : i(Ie, V, Q);
        }, Ke = () => {
          const Qe = Ie._isLeaving || !!Ie[Si];
          Ie._isLeaving && Ie[Si](
            !0
            /* cancelled */
          ), ye.persisted && !Qe ? Fe() : ce(Ie, () => {
            Fe(), Be && Be();
          });
        };
        be ? be(Ie, Fe, Ke) : Ke();
      }
    else
      i(Ie, V, Q);
  }, q = (j, V, Q, oe = !1, ue = !1) => {
    const {
      type: Ie,
      props: he,
      ref: ye,
      children: fe,
      dynamicChildren: ze,
      shapeFlag: He,
      patchFlag: ce,
      dirs: be,
      cacheIndex: Be,
      memo: Fe
    } = j;
    if ((ce === -2 || ze && ze.hasOnce) && (ue = !1), ye != null && (Oo(), Hd(ye, null, Q, j, !0), Lo()), Be != null && (!j.ctx || j.ctx === V) && (V.renderCache[Be] = void 0), He & 256) {
      V.ctx.deactivate(j);
      return;
    }
    const Ke = He & 1 && be, Qe = !qa(j);
    let ht;
    if (Qe && (ht = he && he.onVnodeBeforeUnmount) && qi(ht, V, j), He & 6)
      se(j.component, Q, oe);
    else {
      if (He & 128) {
        j.suspense.unmount(Q, oe);
        return;
      }
      Ke && er(j, null, V, "beforeUnmount"), He & 64 ? j.type.remove(
        j,
        V,
        Q,
        Oe,
        oe
      ) : ze && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !ze.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (Ie !== H || ce > 0 && ce & 64) ? Y(
        ze,
        V,
        Q,
        !1,
        !0
      ) : (Ie === H && ce & 384 || !ue && He & 16) && Y(fe, V, Q), oe && B(j);
    }
    const Le = Fe != null && Be == null;
    (Qe && (ht = he && he.onVnodeUnmounted) || Ke || Le) && Vn(() => {
      ht && qi(ht, V, j), Ke && er(j, null, V, "unmounted"), Le && (j.el = null);
    }, Q);
  }, B = (j) => {
    const { type: V, el: Q, anchor: oe, transition: ue } = j;
    if (V === H) {
      ne(Q, oe);
      return;
    }
    if (V === jh) {
      x(j), ue && !ue.persisted && ue.afterLeave && ue.afterLeave();
      return;
    }
    const Ie = () => {
      s(Q), ue && !ue.persisted && ue.afterLeave && ue.afterLeave();
    };
    if (j.shapeFlag & 1 && ue && !ue.persisted) {
      const { leave: he, delayLeave: ye } = ue, fe = () => he(Q, Ie);
      ye ? ye(j.el, Ie, fe) : fe();
    } else
      Ie();
  }, ne = (j, V) => {
    let Q;
    for (; j !== V; )
      Q = p(j), s(j), j = Q;
    s(V);
  }, se = (j, V, Q) => {
    const { bum: oe, scope: ue, job: Ie, subTree: he, um: ye, m: fe, a: ze } = j;
    wx(fe), wx(ze), oe && Gh(oe), ue.stop(), Ie ? (Ie.flags |= 8, q(he, j, V, Q)) : j.vnode.el && he && (he.transition = j.vnode.transition, q(he, j, V, Q)), ye && Vn(ye, V), Vn(() => {
      j.isUnmounted = !0;
    }, V);
  }, Y = (j, V, Q, oe = !1, ue = !1, Ie = 0) => {
    for (let he = Ie; he < j.length; he++)
      q(j[he], V, Q, oe, ue);
  }, ie = (j) => {
    if (j.shapeFlag & 6)
      return ie(j.component.subTree);
    if (j.shapeFlag & 128)
      return j.suspense.next();
    const V = p(j.anchor || j.el), Q = V && V[O5];
    return Q ? p(Q) : V;
  };
  let De = !1;
  const xe = (j, V, Q) => {
    let oe;
    j == null ? V._vnode && (q(V._vnode, null, null, !0), oe = V._vnode.component) : b(
      V._vnode || null,
      j,
      V,
      null,
      null,
      null,
      Q
    ), V._vnode = j, De || (De = !0, hx(oe), E5(), De = !1);
  }, Oe = {
    p: b,
    um: q,
    m: G,
    r: B,
    mt: J,
    mc: P,
    pc: ee,
    pbc: $,
    n: ie,
    o: n
  };
  return {
    render: xe,
    hydrate: void 0,
    createApp: WP(xe)
  };
}
function bm({ type: n, props: e }, t) {
  return t === "svg" && n === "foreignObject" || t === "mathml" && n === "annotation-xml" && e && e.encoding && e.encoding.includes("html") ? void 0 : t;
}
function tr({ effect: n, job: e }, t) {
  t ? (n.flags |= 32, e.flags |= 4) : (n.flags &= -33, e.flags &= -5);
}
function lE(n, e) {
  return (!n || n && !n.pendingBranch) && e && !e.persisted;
}
function J0(n, e, t = !1) {
  const i = n.children, s = e.children;
  if (pt(i) && pt(s))
    for (let o = 0; o < i.length; o++) {
      const r = i[o];
      let a = s[o];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = s[o] = Rs(s[o]), a.el = r.el), !t && a.patchFlag !== -2 && J0(r, a)), a.type === If && (a.patchFlag === -1 && (a = s[o] = Rs(a)), a.el = r.el), a.type === Nn && !a.el && (a.el = r.el);
    }
}
function dE(n) {
  const e = n.slice(), t = [0];
  let i, s, o, r, a;
  const l = n.length;
  for (i = 0; i < l; i++) {
    const d = n[i];
    if (d !== 0) {
      if (s = t[t.length - 1], n[s] < d) {
        e[i] = s, t.push(i);
        continue;
      }
      for (o = 0, r = t.length - 1; o < r; )
        a = o + r >> 1, n[t[a]] < d ? o = a + 1 : r = a;
      d < n[t[o]] && (o > 0 && (e[i] = t[o - 1]), t[o] = i);
    }
  }
  for (o = t.length, r = t[o - 1]; o-- > 0; )
    t[o] = r, r = e[r];
  return t;
}
function n3(n) {
  const e = n.subTree.component;
  if (e)
    return e.asyncDep && !e.asyncResolved ? e : n3(e);
}
function wx(n) {
  if (n)
    for (let e = 0; e < n.length; e++)
      n[e].flags |= 8;
}
function i3(n) {
  if (n.placeholder)
    return n.placeholder;
  const e = n.component;
  return e ? i3(e.subTree) : null;
}
const s3 = (n) => n.__isSuspense;
function cE(n, e) {
  e && e.pendingBranch ? pt(n) ? e.effects.push(...n) : e.effects.push(n) : IP(n);
}
const H = /* @__PURE__ */ Symbol.for("v-fgt"), If = /* @__PURE__ */ Symbol.for("v-txt"), Nn = /* @__PURE__ */ Symbol.for("v-cmt"), jh = /* @__PURE__ */ Symbol.for("v-stc"), Us = [];
let wi = null;
function g(n = !1) {
  Us.push(wi = n ? null : []);
}
function Z0() {
  Us.pop(), wi = Us[Us.length - 1] || null;
}
let fc = 1;
function xp(n, e = !1) {
  fc += n, n < 0 && wi && e && (wi.hasOnce = !0);
}
function o3(n) {
  return n.dynamicChildren = fc > 0 ? wi || Er : null, Z0(), fc > 0 && wi && wi.push(n), n;
}
function v(n, e, t, i, s, o) {
  return o3(
    h(
      n,
      e,
      t,
      i,
      s,
      o,
      !0
    )
  );
}
function Ce(n, e, t, i, s) {
  return o3(
    C(
      n,
      e,
      t,
      i,
      s,
      !0
    )
  );
}
function mc(n) {
  return n ? n.__v_isVNode === !0 : !1;
}
function Cr(n, e) {
  return n.type === e.type && n.key === e.key;
}
const r3 = ({ key: n }) => n != null ? n : null, Hh = ({
  ref: n,
  ref_key: e,
  ref_for: t
}) => (typeof n == "number" && (n = "" + n), n != null ? en(n) || /* @__PURE__ */ Xn(n) || Ot(n) ? { i: zn, r: n, k: e, f: !!t } : n : null);
function h(n, e = null, t = null, i = 0, s = null, o = n === H ? 0 : 1, r = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: n,
    props: e,
    key: e && r3(e),
    ref: e && Hh(e),
    scopeId: z5,
    slotScopeIds: null,
    children: t,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: i,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: zn
  };
  return a ? (wp(l, t), o & 128 && n.normalize(l)) : t && (l.shapeFlag |= en(t) ? 8 : 16), fc > 0 && // avoid a block node from tracking itself
  !r && // has current parent block
  wi && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && wi.push(l), l;
}
const C = uE;
function uE(n, e = null, t = null, i = 0, s = null, o = !1) {
  if ((!n || n === H5) && (n = Nn), mc(n)) {
    const a = Fo(
      n,
      e,
      !0
      /* mergeRef: true */
    );
    return t && wp(a, t), fc > 0 && !o && wi && (a.shapeFlag & 6 ? wi[wi.indexOf(n)] = a : wi.push(a)), a.patchFlag = -2, a;
  }
  if (xE(n) && (n = n.__vccOpts), e) {
    e = hE(e);
    let { class: a, style: l } = e;
    a && !en(a) && (e.class = U(a)), jt(l) && (/* @__PURE__ */ H0(l) && !pt(l) && (l = li({}, l)), e.style = de(l));
  }
  const r = en(n) ? 1 : s3(n) ? 128 : Mf(n) ? 64 : jt(n) ? 4 : Ot(n) ? 2 : 0;
  return h(
    n,
    e,
    t,
    i,
    s,
    r,
    o,
    !0
  );
}
function hE(n) {
  return n ? /* @__PURE__ */ H0(n) || J5(n) ? li({}, n) : n : null;
}
function Fo(n, e, t = !1, i = !1) {
  const { props: s, ref: o, patchFlag: r, children: a, transition: l } = n, d = e ? a3(s || {}, e) : s, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: n.type,
    props: d,
    key: d && r3(d),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      t && o ? pt(o) ? o.concat(Hh(e)) : [o, Hh(e)] : Hh(e)
    ) : o,
    scopeId: n.scopeId,
    slotScopeIds: n.slotScopeIds,
    children: a,
    target: n.target,
    targetStart: n.targetStart,
    targetAnchor: n.targetAnchor,
    staticCount: n.staticCount,
    shapeFlag: n.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && n.type !== H ? r === -1 ? 16 : r | 16 : r,
    dynamicProps: n.dynamicProps,
    dynamicChildren: n.dynamicChildren,
    appContext: n.appContext,
    dirs: n.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: n.component,
    suspense: n.suspense,
    ssContent: n.ssContent && Fo(n.ssContent),
    ssFallback: n.ssFallback && Fo(n.ssFallback),
    placeholder: n.placeholder,
    el: n.el,
    anchor: n.anchor,
    ctx: n.ctx,
    ce: n.ce,
    cacheIndex: n.cacheIndex
  };
  return l && i && Kr(
    c,
    l.clone(c)
  ), c;
}
function X(n = " ", e = 0) {
  return C(If, null, n, e);
}
function Af(n, e) {
  const t = C(jh, null, n);
  return t.staticCount = e, t;
}
function E(n = "", e = !1) {
  return e ? (g(), Ce(Nn, null, n)) : C(Nn, null, n);
}
function is(n) {
  return n == null || typeof n == "boolean" ? C(Nn) : pt(n) ? C(
    H,
    null,
    // #3666, avoid reference pollution when reusing vnode
    n.slice()
  ) : mc(n) ? Rs(n) : C(If, null, String(n));
}
function Rs(n) {
  return n.el === null && n.patchFlag !== -1 || n.memo ? n : Fo(n);
}
function wp(n, e) {
  let t = 0;
  const { shapeFlag: i } = n;
  if (e == null)
    e = null;
  else if (pt(e))
    t = 16;
  else if (typeof e == "object")
    if (i & 65) {
      const s = e.default;
      s && (s._c && (s._d = !1), wp(n, s()), s._c && (s._d = !0));
      return;
    } else {
      t = 32;
      const s = e._;
      !s && !J5(e) ? e._ctx = zn : s === 3 && zn && (zn.slots._ === 1 ? e._ = 1 : (e._ = 2, n.patchFlag |= 1024));
    }
  else if (Ot(e)) {
    if (i & 65) {
      wp(n, { default: e });
      return;
    }
    e = { default: e, _ctx: zn }, t = 32;
  } else
    e = String(e), i & 64 ? (t = 16, e = [X(e)]) : t = 8;
  n.children = e, n.shapeFlag |= t;
}
function a3(...n) {
  const e = {};
  for (let t = 0; t < n.length; t++) {
    const i = n[t];
    for (const s in i)
      if (s === "class")
        e.class !== i.class && (e.class = U([e.class, i.class]));
      else if (s === "style")
        e.style = de([e.style, i.style]);
      else if (vf(s)) {
        const o = e[s], r = i[s];
        r && o !== r && !(pt(o) && o.includes(r)) ? e[s] = o ? [].concat(o, r) : r : r == null && o == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
        // the model listener.
        !yf(s) && (e[s] = r);
      } else s !== "" && (e[s] = i[s]);
  }
  return e;
}
function qi(n, e, t, i = null) {
  Hi(n, e, 7, [
    t,
    i
  ]);
}
const pE = q5();
let fE = 0;
function mE(n, e, t) {
  const i = n.type, s = (e ? e.appContext : n.appContext) || pE, o = {
    uid: fE++,
    vnode: n,
    type: i,
    parent: e,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new u5(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: e ? e.provides : Object.create(s.provides),
    ids: e ? e.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: nE(i, s),
    emitsOptions: YP(i, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: Yt,
    // inheritAttrs
    inheritAttrs: i.inheritAttrs,
    // state
    ctx: Yt,
    data: Yt,
    props: Yt,
    attrs: Yt,
    slots: Yt,
    refs: Yt,
    setupState: Yt,
    setupContext: null,
    // suspense related
    suspense: t,
    suspenseId: t ? t.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return o.ctx = { _: o }, o.root = e ? e.root : o, o.emit = KP.bind(null, o), n.ce && n.ce(o), o;
}
let si = null;
const Al = () => si || zn;
let kp, gc;
{
  const n = kf(), e = (t, i) => {
    let s;
    return (s = n[t]) || (s = n[t] = []), s.push(i), (o) => {
      s.length > 1 ? s.forEach((r) => r(o)) : s[0](o);
    };
  };
  kp = e(
    "__VUE_INSTANCE_SETTERS__",
    (t) => si = t
  ), gc = e(
    "__VUE_SSR_SETTERS__",
    (t) => bc = t
  );
}
const Q0 = (n) => {
  const e = si;
  return kp(n), n.scope.on(), () => {
    n.scope.off(), kp(e);
  };
}, kx = () => {
  si && si.scope.off(), kp(null);
};
function l3(n) {
  return n.vnode.shapeFlag & 4;
}
let bc = !1;
function gE(n, e = !1, t = !1) {
  e && gc(e);
  const { props: i, children: s } = n.vnode, o = l3(n);
  eE(n, i, o, e), sE(n, s, t || e);
  const r = o ? bE(n, e) : void 0;
  return e && gc(!1), r;
}
function bE(n, e) {
  const t = n.type;
  n.accessCache = /* @__PURE__ */ Object.create(null), n.proxy = new Proxy(n.ctx, GP);
  const { setup: i } = t;
  if (i) {
    Oo();
    const s = n.setupContext = i.length > 1 ? c3(n) : null, o = Q0(n), r = Vc(
      i,
      n,
      0,
      [
        n.props,
        s
      ]
    ), a = i5(r);
    if (Lo(), o(), (a || n.sp) && !qa(n) && BP(n), a) {
      if (r.then(kx, kx), e)
        return r.then((l) => {
          gc(!0);
          try {
            _x(n, l, e);
          } finally {
            gc(!1);
          }
        }).catch((l) => {
          Sf(l, n, 0);
        });
      n.asyncDep = r;
    } else
      _x(n, r);
  } else
    d3(n);
}
function _x(n, e, t) {
  Ot(e) ? n.type.__ssrInlineRender ? n.ssrRender = e : n.render = e : jt(e) && (n.setupState = I5(e)), d3(n);
}
function d3(n, e, t) {
  const i = n.type;
  n.render || (n.render = i.render || Ur);
}
const vE = {
  get(n, e) {
    return Bn(n, "get", ""), n[e];
  }
};
function c3(n) {
  const e = (t) => {
    n.exposed = t || {};
  };
  return {
    attrs: new Proxy(n.attrs, vE),
    slots: n.slots,
    emit: n.emit,
    expose: e
  };
}
function Pf(n) {
  return n.exposed ? n.exposeProxy || (n.exposeProxy = new Proxy(I5(Nb(n.exposed)), {
    get(e, t) {
      if (t in e)
        return e[t];
      if (t in Vd)
        return Vd[t](n);
    },
    has(e, t) {
      return t in e || t in Vd;
    }
  })) : n.proxy;
}
function yE(n, e = !0) {
  return Ot(n) ? n.displayName || n.name : n.name || e && n.__name;
}
function xE(n) {
  return Ot(n) && "__vccOpts" in n;
}
const I = (n, e) => /* @__PURE__ */ _P(n, e, bc);
function cl(n, e, t) {
  try {
    xp(-1);
    const i = arguments.length;
    return i === 2 ? jt(e) && !pt(e) ? mc(e) ? C(n, null, [e]) : C(n, e) : C(n, null, e) : (i > 3 ? t = Array.prototype.slice.call(arguments, 2) : i === 3 && mc(t) && (t = [t]), C(n, e, t));
  } finally {
    xp(1);
  }
}
const wE = "3.5.43";
let Vb;
const Sx = typeof window != "undefined" && window.trustedTypes;
if (Sx)
  try {
    Vb = /* @__PURE__ */ Sx.createPolicy("vue", {
      createHTML: (n) => n
    });
  } catch {
  }
const u3 = Vb ? (n) => Vb.createHTML(n) : (n) => n, kE = "http://www.w3.org/2000/svg", _E = "http://www.w3.org/1998/Math/MathML", Ps = typeof document != "undefined" ? document : null, Tx = Ps && /* @__PURE__ */ Ps.createElement("template"), SE = {
  insert: (n, e, t) => {
    e.insertBefore(n, t || null);
  },
  remove: (n) => {
    const e = n.parentNode;
    e && e.removeChild(n);
  },
  createElement: (n, e, t, i) => {
    const s = e === "svg" ? Ps.createElementNS(kE, n) : e === "mathml" ? Ps.createElementNS(_E, n) : t ? Ps.createElement(n, { is: t }) : Ps.createElement(n);
    return n === "select" && i && i.multiple != null && s.setAttribute("multiple", i.multiple), s;
  },
  createText: (n) => Ps.createTextNode(n),
  createComment: (n) => Ps.createComment(n),
  setText: (n, e) => {
    n.nodeValue = e;
  },
  setElementText: (n, e) => {
    n.textContent = e;
  },
  parentNode: (n) => n.parentNode,
  nextSibling: (n) => n.nextSibling,
  querySelector: (n) => Ps.querySelector(n),
  setScopeId(n, e) {
    n.setAttribute(e, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(n, e, t, i, s, o) {
    const r = t ? t.previousSibling : e.lastChild;
    if (s && (s === o || s.nextSibling))
      for (; e.insertBefore(s.cloneNode(!0), t), !(s === o || !(s = s.nextSibling)); )
        ;
    else {
      Tx.innerHTML = u3(
        i === "svg" ? `<svg>${n}</svg>` : i === "mathml" ? `<math>${n}</math>` : n
      );
      const a = Tx.content;
      if (i === "svg" || i === "mathml") {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      e.insertBefore(a, t);
    }
    return [
      // first
      r ? r.nextSibling : e.firstChild,
      // last
      t ? t.previousSibling : e.lastChild
    ];
  }
}, eo = "transition", Vl = "animation", ul = /* @__PURE__ */ Symbol("_vtc"), h3 = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, p3 = /* @__PURE__ */ li(
  {},
  F5,
  h3
), TE = (n) => (n.displayName = "Transition", n.props = p3, n), vt = /* @__PURE__ */ TE(
  (n, { slots: e }) => cl(OP, f3(n), e)
), nr = (n, e = []) => {
  pt(n) ? n.forEach((t) => t(...e)) : n && n(...e);
}, Mx = (n) => n ? pt(n) ? n.some((e) => e.length > 1) : n.length > 1 : !1;
function f3(n) {
  const e = {};
  for (const L in n)
    L in h3 || (e[L] = n[L]);
  if (n.css === !1)
    return e;
  const {
    name: t = "v",
    type: i,
    duration: s,
    enterFromClass: o = `${t}-enter-from`,
    enterActiveClass: r = `${t}-enter-active`,
    enterToClass: a = `${t}-enter-to`,
    appearFromClass: l = o,
    appearActiveClass: d = r,
    appearToClass: c = a,
    leaveFromClass: u = `${t}-leave-from`,
    leaveActiveClass: p = `${t}-leave-active`,
    leaveToClass: f = `${t}-leave-to`
  } = n, y = ME(s), b = y && y[0], w = y && y[1], {
    onBeforeEnter: k,
    onEnter: S,
    onEnterCancelled: _,
    onLeave: x,
    onLeaveCancelled: T,
    onBeforeAppear: M = k,
    onAppear: z = S,
    onAppearCancelled: P = _
  } = e, D = (L, Z, J, re) => {
    L._enterCancelled = re, ho(L, Z ? c : a), ho(L, Z ? d : r), J && J();
  }, $ = (L, Z) => {
    L._isLeaving = !1, ho(L, u), ho(L, f), ho(L, p), Z && Z();
  }, O = (L) => (Z, J) => {
    const re = L ? z : S, F = () => D(Z, L, J);
    nr(re, [Z, F]), Cx(() => {
      ho(Z, L ? l : o), Ki(Z, L ? c : a), Mx(re) || Ix(Z, i, b, F);
    });
  };
  return li(e, {
    onBeforeEnter(L) {
      nr(k, [L]), Ki(L, o), Ki(L, r);
    },
    onBeforeAppear(L) {
      nr(M, [L]), Ki(L, l), Ki(L, d);
    },
    onEnter: O(!1),
    onAppear: O(!0),
    onLeave(L, Z) {
      L._isLeaving = !0;
      const J = () => $(L, Z);
      Ki(L, u), L._enterCancelled ? (Ki(L, p), Wb(L)) : (Wb(L), Ki(L, p)), Cx(() => {
        L._isLeaving && (ho(L, u), Ki(L, f), Mx(x) || Ix(L, i, w, J));
      }), nr(x, [L, J]);
    },
    onEnterCancelled(L) {
      D(L, !1, void 0, !0), nr(_, [L]);
    },
    onAppearCancelled(L) {
      D(L, !0, void 0, !0), nr(P, [L]);
    },
    onLeaveCancelled(L) {
      $(L), nr(T, [L]);
    }
  });
}
function ME(n) {
  if (n == null)
    return null;
  if (jt(n))
    return [vm(n.enter), vm(n.leave)];
  {
    const e = vm(n);
    return [e, e];
  }
}
function vm(n) {
  return qA(n);
}
function Ki(n, e) {
  e.split(/\s+/).forEach((t) => t && n.classList.add(t)), (n[ul] || (n[ul] = /* @__PURE__ */ new Set())).add(e);
}
function ho(n, e) {
  e.split(/\s+/).forEach((i) => i && n.classList.remove(i));
  const t = n[ul];
  t && (t.delete(e), t.size || (n[ul] = void 0));
}
function Cx(n) {
  requestAnimationFrame(() => {
    requestAnimationFrame(n);
  });
}
let CE = 0;
function Ix(n, e, t, i) {
  const s = n._endId = ++CE, o = () => {
    s === n._endId && i();
  };
  if (t != null)
    return setTimeout(o, t);
  const { type: r, timeout: a, propCount: l } = m3(n, e);
  if (!r)
    return i();
  const d = r + "end";
  let c = 0;
  const u = () => {
    n.removeEventListener(d, p), o();
  }, p = (f) => {
    f.target === n && ++c >= l && u();
  };
  setTimeout(() => {
    c < l && u();
  }, a + 1), n.addEventListener(d, p);
}
function m3(n, e) {
  const t = window.getComputedStyle(n), i = (y) => (t[y] || "").split(", "), s = i(`${eo}Delay`), o = i(`${eo}Duration`), r = Ax(s, o), a = i(`${Vl}Delay`), l = i(`${Vl}Duration`), d = Ax(a, l);
  let c = null, u = 0, p = 0;
  e === eo ? r > 0 && (c = eo, u = r, p = o.length) : e === Vl ? d > 0 && (c = Vl, u = d, p = l.length) : (u = Math.max(r, d), c = u > 0 ? r > d ? eo : Vl : null, p = c ? c === eo ? o.length : l.length : 0);
  const f = c === eo && /\b(?:transform|all)(?:,|$)/.test(
    i(`${eo}Property`).toString()
  );
  return {
    type: c,
    timeout: u,
    propCount: p,
    hasTransform: f
  };
}
function Ax(n, e) {
  for (; n.length < e.length; )
    n = n.concat(n);
  return Math.max(...e.map((t, i) => Px(t) + Px(n[i])));
}
function Px(n) {
  return n === "auto" ? 0 : Number(n.slice(0, -1).replace(",", ".")) * 1e3;
}
function Wb(n) {
  return (n ? n.ownerDocument : document).body.offsetHeight;
}
function IE(n, e, t) {
  const i = n[ul];
  i && (e = (e ? [e, ...i] : [...i]).join(" ")), e == null ? n.removeAttribute("class") : t ? n.setAttribute("class", e) : n.className = e;
}
const _p = /* @__PURE__ */ Symbol("_vod"), e1 = /* @__PURE__ */ Symbol("_vsh"), qb = {
  // used for prop mismatch check during hydration
  name: "show",
  beforeMount(n, { value: e }, { transition: t }) {
    n[_p] = n.style.display === "none" ? "" : n.style.display, t && e ? t.beforeEnter(n) : Wl(n, e);
  },
  mounted(n, { value: e }, { transition: t }) {
    t && e && t.enter(n);
  },
  updated(n, { value: e, oldValue: t }, { transition: i }) {
    !e != !t && (i ? e ? (i.beforeEnter(n), Wl(n, !0), i.enter(n)) : i.leave(n, () => {
      Wl(n, !1);
    }) : Wl(n, e));
  },
  beforeUnmount(n, { value: e }) {
    Wl(n, e);
  }
};
function Wl(n, e) {
  n.style.display = e ? n[_p] : "none", n[e1] = !e;
}
const AE = /* @__PURE__ */ Symbol(""), PE = /(?:^|;)\s*display\s*:/;
function EE(n, e, t) {
  const i = n.style, s = en(t);
  let o = !1;
  if (t && !s) {
    if (e)
      if (en(e))
        for (const r of e.split(";")) {
          const a = r.slice(0, r.indexOf(":")).trim();
          t[a] == null && Md(i, a, "");
        }
      else
        for (const r in e)
          t[r] == null && Md(i, r, "");
    for (const r in t) {
      r === "display" && (o = !0);
      const a = t[r];
      a != null ? zE(
        n,
        r,
        !en(e) && e ? e[r] : void 0,
        a
      ) || Md(i, r, a) : Md(i, r, "");
    }
  } else if (s) {
    if (e !== t) {
      const r = i[AE];
      r && (t += ";" + r), i.cssText = t, o = PE.test(t);
    }
  } else e && n.removeAttribute("style");
  _p in n && (n[_p] = o ? i.display : "", n[e1] && (i.display = "none"));
}
const du = /\s*!important$/;
function Md(n, e, t) {
  if (pt(t))
    t.forEach((i) => Md(n, e, i));
  else if (t == null && (t = ""), e.startsWith("--"))
    du.test(t) ? n.setProperty(e, t.replace(du, ""), "important") : n.setProperty(e, t);
  else {
    const i = RE(n, e);
    du.test(t) ? n.setProperty(
      qo(i),
      t.replace(du, ""),
      "important"
    ) : n[i] = t;
  }
}
const Ex = ["Webkit", "Moz", "ms"], ym = {};
function RE(n, e) {
  const t = ym[e];
  if (t)
    return t;
  let i = Yn(e);
  if (i !== "filter" && i in n)
    return ym[e] = i;
  i = wf(i);
  for (let s = 0; s < Ex.length; s++) {
    const o = Ex[s] + i;
    if (o in n)
      return ym[e] = o;
  }
  return e;
}
function zE(n, e, t, i) {
  return n.tagName === "TEXTAREA" && (e === "width" || e === "height") && en(i) && t === i;
}
const Rx = "http://www.w3.org/1999/xlink";
function zx(n, e, t, i, s, o = QA(e)) {
  i && e.startsWith("xlink:") ? t == null ? n.removeAttributeNS(Rx, e.slice(6, e.length)) : n.setAttributeNS(Rx, e, t) : t == null || o && !a5(t) ? n.removeAttribute(e) : n.setAttribute(
    e,
    o ? "" : ji(t) ? String(t) : t
  );
}
function $x(n, e, t, i, s) {
  if (e === "innerHTML" || e === "textContent") {
    t != null && (n[e] = e === "innerHTML" ? u3(t) : t);
    return;
  }
  const o = n.tagName;
  if (e === "value" && o !== "PROGRESS" && // custom elements may use _value internally
  !o.includes("-")) {
    const a = o === "OPTION" ? n.getAttribute("value") || "" : n.value, l = t == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      n.type === "checkbox" ? "on" : ""
    ) : String(t);
    (a !== l || !("_value" in n)) && (n.value = l), t == null && n.removeAttribute(e), n._value = t;
    return;
  }
  let r = !1;
  if (t === "" || t == null) {
    const a = typeof n[e];
    a === "boolean" ? t = a5(t) : t == null && a === "string" ? (t = "", r = !0) : a === "number" && (t = 0, r = !0);
  }
  try {
    n[e] = t;
  } catch {
  }
  r && n.removeAttribute(s || e);
}
function Ir(n, e, t, i) {
  n.addEventListener(e, t, i);
}
function $E(n, e, t, i) {
  n.removeEventListener(e, t, i);
}
const Dx = /* @__PURE__ */ Symbol("_vei");
function DE(n, e, t, i, s = null) {
  const o = n[Dx] || (n[Dx] = {}), r = o[e];
  if (i && r)
    r.value = i;
  else {
    const [a, l] = BE(e);
    if (i) {
      const d = o[e] = UE(
        i,
        s
      );
      Ir(n, a, d, l);
    } else r && ($E(n, a, r, l), o[e] = void 0);
  }
}
const OE = /(Once|Passive|Capture)$/, LE = /^on:?(?:Once|Passive|Capture)$/;
function BE(n) {
  let e, t;
  for (; (t = n.match(OE)) && !LE.test(n); )
    e || (e = {}), n = n.slice(0, n.length - t[1].length), e[t[1].toLowerCase()] = !0;
  return [n[2] === ":" ? n.slice(3) : qo(n.slice(2)), e];
}
let xm = 0;
const FE = /* @__PURE__ */ Promise.resolve(), NE = () => xm || (FE.then(() => xm = 0), xm = Date.now());
function UE(n, e) {
  const t = (i) => {
    if (!i._vts)
      i._vts = Date.now();
    else if (i._vts <= t.attached)
      return;
    const s = t.value;
    if (pt(s)) {
      const o = i.stopImmediatePropagation;
      i.stopImmediatePropagation = () => {
        o.call(i), i._stopped = !0;
      };
      const r = s.slice(), a = [i];
      for (let l = 0; l < r.length && !i._stopped; l++) {
        const d = r[l];
        d && Hi(
          d,
          e,
          5,
          a
        );
      }
    } else
      Hi(
        s,
        e,
        5,
        [i]
      );
  };
  return t.value = n, t.attached = NE(), t;
}
const Ox = (n) => n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110 && // lowercase letter
n.charCodeAt(2) > 96 && n.charCodeAt(2) < 123, GE = (n, e, t, i, s, o) => {
  const r = s === "svg";
  e === "class" ? IE(n, i, r) : e === "style" ? EE(n, t, i) : vf(e) ? yf(e) || DE(n, e, t, i, o) : (e[0] === "." ? (e = e.slice(1), !0) : e[0] === "^" ? (e = e.slice(1), !1) : jE(n, e, i, r)) ? ($x(n, e, i), !n.tagName.includes("-") && (e === "value" || e === "checked" || e === "selected") && zx(n, e, i, r, o, e !== "value")) : /* #11081 force set props for possible async custom element */ n._isVueCE && // #12408 check if it's declared prop or it's async custom element
  (HE(n, e) || // @ts-expect-error _def is private
  n._def.__asyncLoader && (/[A-Z]/.test(e) || !en(i))) ? $x(n, Yn(e), i, o, e) : (e === "true-value" ? n._trueValue = i : e === "false-value" && (n._falseValue = i), zx(n, e, i, r));
};
function jE(n, e, t, i) {
  if (i)
    return !!(e === "innerHTML" || e === "textContent" || e in n && Ox(e) && Ot(t));
  if (e === "spellcheck" || e === "draggable" || e === "translate" || e === "autocorrect" || e === "sandbox" && n.tagName === "IFRAME" || e === "form" || e === "list" && n.tagName === "INPUT" || e === "type" && n.tagName === "TEXTAREA")
    return !1;
  if (e === "width" || e === "height") {
    const s = n.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return Ox(e) && en(t) ? !1 : e in n;
}
function HE(n, e) {
  const t = (
    // @ts-expect-error _def is private
    n._def.props
  );
  if (!t)
    return !1;
  const i = Yn(e);
  return Array.isArray(t) ? t.some((s) => Yn(s) === i) : Object.keys(t).some((s) => Yn(s) === i);
}
const g3 = /* @__PURE__ */ new WeakMap(), b3 = /* @__PURE__ */ new WeakMap(), Sp = /* @__PURE__ */ Symbol("_moveCb"), Lx = /* @__PURE__ */ Symbol("_enterCb"), VE = (n) => (delete n.props.mode, n), WE = /* @__PURE__ */ VE({
  name: "TransitionGroup",
  props: /* @__PURE__ */ li({}, p3, {
    tag: String,
    moveClass: String
  }),
  setup(n, { slots: e }) {
    const t = Al(), i = B5();
    let s, o;
    return j5(() => {
      if (!s.length)
        return;
      const r = n.moveClass || `${n.name || "v"}-move`;
      if (!XE(
        s[0].el,
        t.vnode.el,
        r
      )) {
        s = [];
        return;
      }
      s.forEach(qE), s.forEach(KE);
      const a = s.filter(YE);
      Wb(t.vnode.el), a.forEach((l) => {
        const d = l.el, c = d.style;
        Ki(d, r), c.transform = c.webkitTransform = c.transitionDuration = "";
        const u = d[Sp] = (p) => {
          p && p.target !== d || (!p || p.propertyName.endsWith("transform")) && (d.removeEventListener("transitionend", u), d[Sp] = null, ho(d, r));
        };
        d.addEventListener("transitionend", u);
      }), s = [];
    }), () => {
      const r = /* @__PURE__ */ At(n), a = f3(r);
      let l = r.tag || H;
      if (s = [], o)
        for (let d = 0; d < o.length; d++) {
          const c = o[d];
          c.el && c.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
          !c.el[e1] && (s.push(c), Kr(
            c,
            pc(
              c,
              a,
              i,
              t
            )
          ), g3.set(c, v3(c.el)));
        }
      o = e.default ? W0(e.default()) : [];
      for (let d = 0; d < o.length; d++) {
        const c = o[d];
        c.key != null && Kr(
          c,
          pc(c, a, i, t)
        );
      }
      return C(l, null, o);
    };
  }
}), Tp = WE;
function qE(n) {
  const e = n.el;
  e[Sp] && e[Sp](), e[Lx] && e[Lx]();
}
function KE(n) {
  b3.set(n, v3(n.el));
}
function YE(n) {
  const e = g3.get(n), t = b3.get(n), i = e.left - t.left, s = e.top - t.top;
  if (i || s) {
    const o = n.el, r = o.style, a = o.getBoundingClientRect();
    let l = 1, d = 1;
    return o.offsetWidth && (l = a.width / o.offsetWidth), o.offsetHeight && (d = a.height / o.offsetHeight), (!Number.isFinite(l) || l === 0) && (l = 1), (!Number.isFinite(d) || d === 0) && (d = 1), Math.abs(l - 1) < 0.01 && (l = 1), Math.abs(d - 1) < 0.01 && (d = 1), r.transform = r.webkitTransform = `translate(${i / l}px,${s / d}px)`, r.transitionDuration = "0s", n;
  }
}
function v3(n) {
  const e = n.getBoundingClientRect();
  return {
    left: e.left,
    top: e.top
  };
}
function XE(n, e, t) {
  const i = n.cloneNode(), s = n[ul];
  s && s.forEach((a) => {
    a.split(/\s+/).forEach((l) => l && i.classList.remove(l));
  }), t.split(/\s+/).forEach((a) => a && i.classList.add(a)), i.style.display = "none";
  const o = e.nodeType === 1 ? e : e.parentNode;
  o.appendChild(i);
  const { hasTransform: r } = m3(i);
  return o.removeChild(i), r;
}
const Mp = (n) => {
  const e = n.props["onUpdate:modelValue"] || !1;
  return pt(e) ? (t) => Gh(e, t) : e;
};
function JE(n) {
  n.target.composing = !0;
}
function Bx(n) {
  const e = n.target;
  e.composing && (e.composing = !1, e.dispatchEvent(new Event("input")));
}
const Rr = /* @__PURE__ */ Symbol("_assign"), cu = /* @__PURE__ */ Symbol("_initialValue");
function wm(n, e, t) {
  return e && (n = n.trim()), t && (n = O0(n)), n;
}
const Jt = {
  created(n, { modifiers: { lazy: e, trim: t, number: i } }, s) {
    n.parentNode && (n.type === "text" ? n[cu] = n.defaultValue.replace(/[\r\n]/g, "") : n.type === "textarea" && (n[cu] = n.defaultValue.replace(/\r\n?/g, `
`))), n[Rr] = Mp(s);
    const o = i || s.props && s.props.type === "number";
    Ir(n, e ? "change" : "input", (r) => {
      r.target.composing || n[Rr](wm(n.value, t, o));
    }), (t || o) && Ir(n, "change", () => {
      n.value = wm(n.value, t, o);
    }), e || (Ir(n, "compositionstart", JE), Ir(n, "compositionend", Bx), Ir(n, "change", Bx));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(n, { value: e, modifiers: { trim: t, number: i } }) {
    const s = e == null ? "" : e, o = n[cu];
    delete n[cu], o !== void 0 && (n.type === "text" || n.type === "textarea") && n.value !== o ? n[Rr](wm(n.value, t, i)) : n.value = s;
  },
  beforeUpdate(n, { value: e, oldValue: t, modifiers: { lazy: i, trim: s, number: o } }, r) {
    if (n[Rr] = Mp(r), n.composing) return;
    const a = (o || n.type === "number") && !/^0\d/.test(n.value) ? O0(n.value) : n.value, l = e == null ? "" : e;
    if (a === l)
      return;
    const d = n.getRootNode();
    (d instanceof Document || d instanceof ShadowRoot) && d.activeElement === n && n.type !== "range" && (i && e === t || s && n.value.trim() === l) || (n.value = l);
  }
}, Na = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(n, e, t) {
    n[Rr] = Mp(t), Ir(n, "change", () => {
      const i = n._modelValue, s = ZE(n), o = n.checked, r = n[Rr];
      if (pt(i)) {
        const a = l5(i, s), l = a !== -1;
        if (o && !l)
          r(i.concat(s));
        else if (!o && l) {
          const d = [...i];
          d.splice(a, 1), r(d);
        }
      } else if (dl(i)) {
        const a = new Set(i);
        o ? a.add(s) : a.delete(s), r(a);
      } else
        r(y3(n, o));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: Fx,
  beforeUpdate(n, e, t) {
    n[Rr] = Mp(t), Fx(n, e, t);
  }
};
function Fx(n, { value: e, oldValue: t }, i) {
  n._modelValue = e;
  let s;
  if (pt(e))
    s = l5(e, i.props.value) > -1;
  else if (dl(e))
    s = e.has(i.props.value);
  else {
    if (e === t) return;
    s = Il(e, y3(n, !0));
  }
  n.checked !== s && (n.checked = s);
}
function ZE(n) {
  return "_value" in n ? n._value : n.value;
}
function y3(n, e) {
  const t = e ? "_trueValue" : "_falseValue";
  return t in n ? n[t] : e;
}
const QE = ["ctrl", "shift", "alt", "meta"], e9 = {
  stop: (n) => n.stopPropagation(),
  prevent: (n) => n.preventDefault(),
  self: (n) => n.target !== n.currentTarget,
  ctrl: (n) => !n.ctrlKey,
  shift: (n) => !n.shiftKey,
  alt: (n) => !n.altKey,
  meta: (n) => !n.metaKey,
  left: (n) => "button" in n && n.button !== 0,
  middle: (n) => "button" in n && n.button !== 1,
  right: (n) => "button" in n && n.button !== 2,
  exact: (n, e) => QE.some((t) => n[`${t}Key`] && !e.includes(t))
}, Pe = (n, e) => {
  if (!n) return n;
  const t = n._withMods || (n._withMods = {}), i = e.join(".");
  return t[i] || (t[i] = ((s, ...o) => {
    for (let r = 0; r < e.length; r++) {
      const a = e9[e[r]];
      if (a && a(s, e)) return;
    }
    return n(s, ...o);
  }));
}, t9 = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, tn = (n, e) => {
  const t = n._withKeys || (n._withKeys = {}), i = e.join(".");
  return t[i] || (t[i] = ((s) => {
    if (!("key" in s))
      return;
    const o = qo(s.key);
    if (e.some(
      (r) => r === o || t9[r] === o
    ))
      return n(s);
  }));
}, n9 = /* @__PURE__ */ li({ patchProp: GE }, SE);
let Nx;
function i9() {
  return Nx || (Nx = rE(n9));
}
const x3 = ((...n) => {
  const e = i9().createApp(...n), { mount: t } = e;
  return e.mount = (i) => {
    const s = o9(i);
    if (!s) return;
    const o = e._component;
    !Ot(o) && !o.render && !o.template && (o.template = s.innerHTML), s.nodeType === 1 && (s.textContent = "");
    const r = t(s, !1, s9(s));
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), r;
  }, e;
});
function s9(n) {
  if (n instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && n instanceof MathMLElement)
    return "mathml";
}
function o9(n) {
  return en(n) ? document.querySelector(n) : n;
}
const ir = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const Ux = (...n) => n.filter((e, t, i) => !!e && e.trim() !== "" && i.indexOf(e) === t).join(" ").trim();
function km(n) {
  return n != null;
}
function r9(n, e = {}) {
  var p, f, y, b, w, k, S, _, x, T, M, z, P, D, $;
  const t = (p = e.attributeNames) != null ? p : {}, i = (O) => {
    var L;
    return (L = t[O]) != null ? L : O;
  }, s = (y = (f = n.size) != null ? f : n.width) != null ? y : ir.width, o = (w = (b = n.size) != null ? b : n.height) != null ? w : ir.height, r = (S = (k = n.aliases) == null ? void 0 : k.filter((O) => typeof O == "string" && O.trim() !== "").map((O) => `lucide-${O}`)) != null ? S : [], a = [...n.name ? [`lucide-${n.name}`] : [], ...r], l = (x = (_ = e.className) == null ? void 0 : _.split(" ").filter(Boolean)) != null ? x : [], d = e.includeDefaultClasses === !1 ? Ux(...l) : Ux("lucide", ...a, ...l), c = e.absoluteStrokeWidth ? Number((T = e.strokeWidth) != null ? T : ir["stroke-width"]) * Number((z = (M = n.size) != null ? M : n.width) != null ? z : ir.width) / Number((D = (P = e.size) != null ? P : e.width) != null ? D : ir.width) : ($ = e.strokeWidth) != null ? $ : ir["stroke-width"];
  return [
    "svg",
    {
      ...Object.entries(ir).reduce((O, [L, Z]) => (O[i(L)] = Z, O), {}),
      ..."color" in e && e.color && {
        [i("stroke")]: e.color
      },
      ..."size" in e && km(e.size) && {
        [i("width")]: e.size,
        [i("height")]: e.size
      },
      ..."width" in e && km(e.width) && {
        [i("width")]: e.width
      },
      ..."height" in e && km(e.height) && {
        [i("height")]: e.height
      },
      [i("stroke-width")]: c,
      ...d && {
        [i("class")]: d
      },
      [i("viewBox")]: `0 0 ${s} ${o}`,
      ...e.hasA11yProp === !1 ? {
        [i("aria-hidden")]: "true"
      } : {},
      ..."attributes" in e && e.attributes
    },
    n.node.map((O) => {
      const [L, Z, J] = O, re = e.nonScalingStroke ? { [i("vector-effect")]: "non-scaling-stroke", ...Z } : Z;
      return J ? [L, re, J] : [L, re];
    })
  ];
}
const a9 = (n) => {
  for (const e in n)
    if (e.startsWith("aria-") || e === "role" || e === "title")
      return !0;
  return !1;
};
const uu = (n) => n === "";
const l9 = (n) => n == null ? void 0 : n.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const d9 = /* @__PURE__ */ Symbol("lucide-icons");
function c9() {
  return Tf(d9, {});
}
const u9 = ({
  name: n,
  iconNode: e,
  "icon-node": t,
  icon: i = {
    name: n && l9(n),
    node: ((w) => (w = e != null ? e : t) != null ? w : [])(),
    size: 24,
    aliases: []
  },
  absoluteStrokeWidth: s,
  "absolute-stroke-width": o,
  nonScalingStroke: r,
  "non-scaling-stroke": a,
  strokeWidth: l,
  "stroke-width": d,
  size: c,
  width: u = c,
  height: p = c,
  color: f,
  ...y
}, { slots: b }) => {
  var L, Z, J, re;
  const {
    size: k,
    color: S,
    strokeWidth: _ = 2,
    absoluteStrokeWidth: x = !1,
    nonScalingStroke: T = !1,
    class: M = ""
  } = c9(), z = uu(s) || uu(o) || s === !0 || o === !0 || x === !0, P = uu(r) || uu(a) || r === !0 || a === !0 || T === !0;
  delete y.class;
  const D = (L = b.default) == null ? void 0 : L.call(b), [, $, O = []] = r9(i, {
    color: f != null ? f : S,
    width: (Z = u != null ? u : c) != null ? Z : k,
    height: (J = p != null ? p : c) != null ? J : k,
    strokeWidth: (re = l != null ? l : d) != null ? re : _,
    absoluteStrokeWidth: z,
    nonScalingStroke: P,
    className: M,
    hasA11yProp: D != null && D.length > 0 || a9(y),
    attributes: y
  });
  return cl("svg", $, [
    ...O.map(([F, W]) => cl(F, W)),
    ...D != null ? D : []
  ]);
};
function ke(n, e = []) {
  const t = typeof n == "string" ? {
    name: n,
    node: e
  } : n;
  return (i, { slots: s }) => cl(
    u9,
    {
      ...i,
      icon: t
    },
    s.default ? { default: s.default } : void 0
  );
}
const h9 = {
  name: "align-center-horizontal",
  size: 24,
  node: [
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
    ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
    ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
    ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
    ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
  ]
}, p9 = ke(h9);
const f9 = {
  name: "align-horizontal-distribute-center",
  size: 24,
  node: [
    ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
    ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
    ["path", { d: "M17 22v-5", key: "4b6g73" }],
    ["path", { d: "M17 7V2", key: "hnrr36" }],
    ["path", { d: "M7 22v-3", key: "1r4jpn" }],
    ["path", { d: "M7 5V2", key: "liy1u9" }]
  ]
}, m9 = ke(f9);
const g9 = {
  name: "align-start-horizontal",
  size: 24,
  node: [
    ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
    ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
    ["path", { d: "M22 2H2", key: "fhrpnj" }]
  ]
}, b9 = ke(g9);
const v9 = {
  name: "align-start-vertical",
  size: 24,
  node: [
    ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
    ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
    ["path", { d: "M2 2v20", key: "1ivd8o" }]
  ]
}, y9 = ke(v9);
const x9 = {
  name: "aperture",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
    ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
    ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
    ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
    ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
    ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
  ]
}, w9 = ke(x9);
const k9 = {
  name: "arrow-down-to-line",
  size: 24,
  node: [
    ["path", { d: "M12 17V3", key: "1cwfxf" }],
    ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
    ["path", { d: "M19 21H5", key: "150jfl" }]
  ]
}, _9 = ke(k9);
const S9 = {
  name: "arrow-down",
  size: 24,
  node: [
    ["path", { d: "M12 5v14", key: "s699le" }],
    ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
  ]
}, T9 = ke(S9);
const M9 = {
  name: "arrow-left",
  size: 24,
  node: [
    ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
    ["path", { d: "M19 12H5", key: "x3x0zl" }]
  ]
}, C9 = ke(M9);
const I9 = {
  name: "arrow-right",
  size: 24,
  node: [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
  ]
}, w3 = ke(I9);
const A9 = {
  name: "arrow-up-down",
  size: 24,
  node: [
    ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
    ["path", { d: "M17 20V4", key: "1ejh1v" }],
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }]
  ]
}, P9 = ke(A9);
const E9 = {
  name: "arrow-up-right",
  size: 24,
  node: [
    ["path", { d: "M7 7h10v10", key: "1tivn9" }],
    ["path", { d: "M7 17 17 7", key: "1vkiza" }]
  ]
}, k3 = ke(E9);
const R9 = {
  name: "arrow-up",
  size: 24,
  node: [
    ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
    ["path", { d: "M12 19V5", key: "x0mq9r" }]
  ]
}, _3 = ke(R9);
const z9 = {
  name: "at-sign",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
  ]
}, $9 = ke(z9);
const D9 = {
  name: "bell-off",
  size: 24,
  node: [
    ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
    [
      "path",
      {
        d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
        key: "178tsu"
      }
    ],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05", key: "1hqiys" }]
  ]
}, O9 = ke(D9);
const L9 = {
  name: "bell",
  size: 24,
  node: [
    ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
    [
      "path",
      {
        d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
        key: "11g9vi"
      }
    ]
  ]
}, B9 = ke(L9);
const F9 = {
  name: "blend",
  size: 24,
  node: [
    ["circle", { cx: "15", cy: "9", r: "7", key: "1i12rt" }],
    ["circle", { cx: "9", cy: "15", r: "7", key: "19bs8k" }]
  ]
}, N9 = ke(F9);
const U9 = {
  name: "bookmark-plus",
  size: 24,
  node: [
    ["path", { d: "M12 7v6", key: "lw1j43" }],
    ["path", { d: "M15 10H9", key: "o6yqo3" }],
    [
      "path",
      {
        d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
        key: "oz39mx"
      }
    ]
  ]
}, G9 = ke(U9);
const j9 = {
  name: "bookmark",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
        key: "oz39mx"
      }
    ]
  ]
}, H9 = ke(j9);
const V9 = {
  name: "box",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
        key: "hh9hay"
      }
    ],
    ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
    ["path", { d: "M12 22V12", key: "d0xqtd" }]
  ]
}, W9 = ke(V9);
const q9 = {
  name: "bring-to-front",
  size: 24,
  node: [
    ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
    ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
    ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
  ]
}, K9 = ke(q9);
const Y9 = {
  name: "brush",
  size: 24,
  node: [
    ["path", { d: "m11 10 3 3", key: "fzmg1i" }],
    [
      "path",
      {
        d: "M6.5 21A3.5 3.5 0 1 0 3 17.5a2.62 2.62 0 0 1-.708 1.792A1 1 0 0 0 3 21z",
        key: "p4q2r7"
      }
    ],
    ["path", { d: "M9.969 17.031 21.378 5.624a1 1 0 0 0-3.002-3.002L6.967 14.031", key: "wy6l02" }]
  ]
}, X9 = ke(Y9);
const J9 = {
  name: "bug",
  size: 24,
  node: [
    ["path", { d: "M12 20v-9", key: "1qisl0" }],
    ["path", { d: "M14 7a4 4 0 0 1 4 4v3a6 6 0 0 1-12 0v-3a4 4 0 0 1 4-4z", key: "uouzyp" }],
    ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
    ["path", { d: "M21 21a4 4 0 0 0-3.81-4", key: "1b0z45" }],
    ["path", { d: "M21 5a4 4 0 0 1-3.55 3.97", key: "5cxbf6" }],
    ["path", { d: "M22 13h-4", key: "1jl80f" }],
    ["path", { d: "M3 21a4 4 0 0 1 3.81-4", key: "1fjd4g" }],
    ["path", { d: "M3 5a4 4 0 0 0 3.55 3.97", key: "1d7oge" }],
    ["path", { d: "M6 13H2", key: "82j7cp" }],
    ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
    ["path", { d: "M9 7.13V6a3 3 0 1 1 6 0v1.13", key: "1vgav8" }]
  ]
}, Z9 = ke(J9);
const Q9 = {
  name: "building-complex",
  size: 24,
  node: [
    ["path", { d: "M10 12h4", key: "a56b0p" }],
    ["path", { d: "M10 8h4", key: "1sr2af" }],
    ["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3", key: "1rgiei" }],
    [
      "path",
      {
        d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
        key: "secmi2"
      }
    ],
    ["path", { d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16", key: "16ra0t" }]
  ],
  aliases: ["building-2"]
}, eR = ke(Q9);
const tR = {
  name: "camera",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
        key: "18u6gg"
      }
    ],
    ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
  ]
}, nR = ke(tR);
const iR = {
  name: "check-check",
  size: 24,
  node: [
    ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
    ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
  ]
}, sR = ke(iR);
const oR = {
  name: "check",
  size: 24,
  node: [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]
}, S3 = ke(oR);
const rR = {
  name: "chevron-down",
  size: 24,
  node: [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]]
}, T3 = ke(rR);
const aR = {
  name: "chevron-left",
  size: 24,
  node: [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]]
}, M3 = ke(aR);
const lR = {
  name: "chevron-right",
  size: 24,
  node: [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]]
}, C3 = ke(lR);
const dR = {
  name: "chevron-up",
  size: 24,
  node: [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]
}, cR = ke(dR);
const uR = {
  name: "chevrons-up",
  size: 24,
  node: [
    ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
    ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
  ]
}, hR = ke(uR);
const pR = {
  name: "circle-alert",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
    ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
  ],
  aliases: ["alert-circle"]
}, Kb = ke(pR);
const fR = {
  name: "circle-check",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m16 9-5.5 5.5L8 12", key: "xofnsj" }]
  ],
  aliases: ["check-circle-2"]
}, I3 = ke(fR);
const mR = {
  name: "circle-minus",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }]
  ],
  aliases: ["minus-circle"]
}, gR = ke(mR);
const bR = {
  name: "circle-play",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
        key: "kmsa83"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["play-circle"]
}, vR = ke(bR);
const yR = {
  name: "circle-question-mark",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
    ["path", { d: "M12 17h.01", key: "p32p05" }]
  ],
  aliases: ["help-circle", "circle-help"]
}, Gx = ke(yR);
const xR = {
  name: "circle-stop",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
  ],
  aliases: ["stop-circle"]
}, wR = ke(xR);
const kR = {
  name: "circle",
  size: 24,
  node: [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]]
}, _R = ke(kR);
const SR = {
  name: "circle-x",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "m9 9 6 6", key: "z0biqf" }]
  ],
  aliases: ["x-circle"]
}, A3 = ke(SR);
const TR = {
  name: "clapperboard",
  size: 24,
  node: [
    ["path", { d: "m12.296 3.464 3.02 3.956", key: "qash78" }],
    [
      "path",
      {
        d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3z",
        key: "1h7j8b"
      }
    ],
    ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", key: "4lm6w1" }],
    ["path", { d: "m6.18 5.276 3.1 3.899", key: "zjj9t3" }]
  ]
}, MR = ke(TR);
const CR = {
  name: "clipboard",
  size: 24,
  node: [
    ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196"
      }
    ]
  ]
}, IR = ke(CR);
const AR = {
  name: "clock",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }]
  ]
}, PR = ke(AR);
const ER = {
  name: "cloud-off",
  size: 24,
  node: [
    [
      "path",
      { d: "M10.94 5.274A7 7 0 0 1 15.71 10h1.79a4.5 4.5 0 0 1 4.222 6.057", key: "1uxyv8" }
    ],
    ["path", { d: "M18.796 18.81A4.5 4.5 0 0 1 17.5 19H9A7 7 0 0 1 5.79 5.78", key: "99tcn7" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }]
  ]
}, RR = ke(ER);
const zR = {
  name: "coffee",
  size: 24,
  node: [
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
    ["path", { d: "M14 2v2", key: "6buw04" }],
    [
      "path",
      {
        d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
        key: "pwadti"
      }
    ],
    ["path", { d: "M6 2v2", key: "colzsn" }]
  ]
}, $R = ke(zR);
const DR = {
  name: "columns-2",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M12 3v18", key: "108xh3" }]
  ],
  aliases: ["columns"]
}, OR = ke(DR);
const LR = {
  name: "columns-3",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }]
  ],
  aliases: ["panels-left-right"]
}, BR = ke(LR);
const FR = {
  name: "contrast",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
  ]
}, NR = ke(FR);
const UR = {
  name: "copy",
  size: 24,
  node: [
    ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
    ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
  ]
}, P3 = ke(UR);
const GR = {
  name: "corner-down-left",
  size: 24,
  node: [
    ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }],
    ["path", { d: "m9 10-5 5 5 5", key: "1kshq7" }]
  ]
}, jR = ke(GR);
const HR = {
  name: "corner-down-right",
  size: 24,
  node: [
    ["path", { d: "m15 10 5 5-5 5", key: "qqa56n" }],
    ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
  ]
}, VR = ke(HR);
const WR = {
  name: "cpu",
  size: 24,
  node: [
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M17 20v2", key: "1rnc9c" }],
    ["path", { d: "M17 2v2", key: "11trls" }],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "M2 17h2", key: "7oei6x" }],
    ["path", { d: "M2 7h2", key: "asdhe0" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "M20 17h2", key: "1fpfkl" }],
    ["path", { d: "M20 7h2", key: "1o8tra" }],
    ["path", { d: "M7 20v2", key: "4gnj0m" }],
    ["path", { d: "M7 2v2", key: "1i4yhu" }],
    ["rect", { x: "4", y: "4", width: "16", height: "16", rx: "2", key: "1vbyd7" }],
    ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1", key: "z9xiuo" }]
  ]
}, qR = ke(WR);
const KR = {
  name: "crop",
  size: 24,
  node: [
    ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
    ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
  ]
}, YR = ke(KR);
const XR = {
  name: "dice-5",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
    ["path", { d: "M16 8h.01", key: "cr5u4v" }],
    ["path", { d: "M8 8h.01", key: "1e4136" }],
    ["path", { d: "M8 16h.01", key: "18s6g9" }],
    ["path", { d: "M16 16h.01", key: "1f9h7w" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }]
  ]
}, JR = ke(XR);
const ZR = {
  name: "download",
  size: 24,
  node: [
    ["path", { d: "M12 15V3", key: "m9g1x1" }],
    ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
    ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
  ]
}, E3 = ke(ZR);
const QR = {
  name: "droplet",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
        key: "c7niix"
      }
    ]
  ]
}, ez = ke(QR);
const tz = {
  name: "ellipsis-vertical",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
    ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
  ],
  aliases: ["more-vertical"]
}, nz = ke(tz);
const iz = {
  name: "ellipsis",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
    ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
  ],
  aliases: ["more-horizontal"]
}, R3 = ke(iz);
const sz = {
  name: "eraser",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21",
        key: "g5wo59"
      }
    ],
    ["path", { d: "m5.082 11.09 8.828 8.828", key: "1wx5vj" }]
  ]
}, oz = ke(sz);
const rz = {
  name: "expand",
  size: 24,
  node: [
    ["path", { d: "m15 15 6 6", key: "1s409w" }],
    ["path", { d: "m15 9 6-6", key: "ko1vev" }],
    ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
    ["path", { d: "M21 8V3h-5", key: "1qoq8a" }],
    ["path", { d: "M3 16v5h5", key: "1t08am" }],
    ["path", { d: "m3 21 6-6", key: "wwnumi" }],
    ["path", { d: "M3 8V3h5", key: "1ln10m" }],
    ["path", { d: "M9 9 3 3", key: "v551iv" }]
  ]
}, az = ke(rz);
const lz = {
  name: "external-link",
  size: 24,
  node: [
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
    ["path", { d: "M10 14 21 3", key: "gplh6r" }],
    ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
  ]
}, z3 = ke(lz);
const dz = {
  name: "eye-off",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
        key: "ct8e1f"
      }
    ],
    ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
    [
      "path",
      {
        d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
        key: "13bj9a"
      }
    ],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }]
  ]
}, cz = ke(dz);
const uz = {
  name: "eye",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
        key: "1nclc0"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, hz = ke(uz);
const pz = {
  name: "face-slightly-smiling-plus",
  size: 24,
  node: [
    ["path", { d: "M13.267 2.08a10 10 0 108.653 8.653", key: "1wbpyh" }],
    ["path", { d: "M15 10V9", key: "4dkmfx" }],
    ["path", { d: "M16 5h6", key: "1vod17" }],
    ["path", { d: "M16.472 15a6 6 0 01-8.943 0", key: "7qomzy" }],
    ["path", { d: "M19 2v6", key: "4bpg5p" }],
    ["path", { d: "M9 10V9", key: "1lazqi" }]
  ],
  aliases: ["smile-plus"]
}, fz = ke(pz);
const mz = {
  name: "face-slightly-smiling",
  size: 24,
  node: [
    ["path", { d: "M15 10V9", key: "4dkmfx" }],
    ["path", { d: "M16.472 15a6 6 0 01-8.943 0", key: "7qomzy" }],
    ["path", { d: "M9 10V9", key: "1lazqi" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["smile"]
}, gz = ke(mz);
const bz = {
  name: "file-box",
  size: 24,
  node: [
    ["path", { d: "M14 2v5a1 1 0 001 1h5", key: "9v5fu7" }],
    [
      "path",
      {
        d: "M14.692 22H18a2 2 0 002-2V8a2.4 2.4 0 00-.706-1.706l-3.588-3.588A2.4 2.4 0 0014 2H6a2 2 0 00-2 2v3.804",
        key: "1ne0j7"
      }
    ],
    ["path", { d: "M2.264 13.752 7 16.5l4.737-2.748", key: "t73mg3" }],
    [
      "path",
      {
        d: "M2.995 13.014A2 2 0 002 14.744v3.516a2 2 0 00.996 1.73l3 1.74a2 2 0 002.008 0l3-1.74A2 2 0 0012 18.26v-3.517a2 2 0 00-.995-1.73l-3-1.742a2 2 0 00-1.892-.064z",
        key: "h4qck"
      }
    ],
    ["path", { d: "M7 16.5V22", key: "1i1gou" }]
  ]
}, vz = ke(bz);
const yz = {
  name: "film",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M7 3v18", key: "bbkbws" }],
    ["path", { d: "M3 7.5h4", key: "zfgn84" }],
    ["path", { d: "M3 12h18", key: "1i2n21" }],
    ["path", { d: "M3 16.5h4", key: "1230mu" }],
    ["path", { d: "M17 3v18", key: "in4fa5" }],
    ["path", { d: "M17 7.5h4", key: "myr1c1" }],
    ["path", { d: "M17 16.5h4", key: "go4c1d" }]
  ]
}, xz = ke(yz);
const wz = {
  name: "flag",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
        key: "1jaruq"
      }
    ]
  ]
}, kz = ke(wz);
const _z = {
  name: "focus",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
  ]
}, Sz = ke(_z);
const Tz = {
  name: "folder-open",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
        key: "usdka0"
      }
    ]
  ]
}, Mz = ke(Tz);
const Cz = {
  name: "frame",
  size: 24,
  node: [
    ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
    ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
    ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
    ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
  ]
}, $3 = ke(Cz);
const Iz = {
  name: "gauge",
  size: 24,
  node: [
    ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
    ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
  ]
}, Az = ke(Iz);
const Pz = {
  name: "globe",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
    ["path", { d: "M2 12h20", key: "9i4pu4" }]
  ]
}, D3 = ke(Pz);
const Ez = {
  name: "grid-3x3",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M3 15h18", key: "5xshup" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }]
  ],
  aliases: ["grid", "grid-3-x-3"]
}, Rz = ke(Ez);
const zz = {
  name: "group",
  size: 24,
  node: [
    ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
    ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
    ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
    ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
    ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
    ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
  ]
}, $z = ke(zz);
const Dz = {
  name: "hand",
  size: 24,
  node: [
    ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
    ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
    ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
    [
      "path",
      {
        d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
        key: "1s1gnw"
      }
    ]
  ]
}, O3 = ke(Dz);
const Oz = {
  name: "heart",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
        key: "mvr1a0"
      }
    ]
  ]
}, L3 = ke(Oz);
const Lz = {
  name: "image-off",
  size: 24,
  node: [
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
    ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
    ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
    ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
    [
      "path",
      {
        d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
        key: "mmje98"
      }
    ],
    ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
  ]
}, Bz = ke(Lz);
const Fz = {
  name: "image-plus",
  size: 24,
  node: [
    ["path", { d: "M16 5h6", key: "1vod17" }],
    ["path", { d: "M19 2v6", key: "4bpg5p" }],
    ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
  ]
}, B3 = ke(Fz);
const Nz = {
  name: "image",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
  ]
}, F3 = ke(Nz);
const Uz = {
  name: "images",
  size: 24,
  node: [
    ["path", { d: "m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16", key: "9kzy35" }],
    ["path", { d: "M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2", key: "1t0f0t" }],
    ["circle", { cx: "13", cy: "7", r: "1", fill: "currentColor", key: "1obus6" }],
    ["rect", { x: "8", y: "2", width: "14", height: "14", rx: "2", key: "1gvhby" }]
  ]
}, Gz = ke(Uz);
const jz = {
  name: "inbox",
  size: 24,
  node: [
    ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
    [
      "path",
      {
        d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
        key: "oot6mr"
      }
    ]
  ]
}, Hz = ke(jz);
const Vz = {
  name: "info",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 16v-4", key: "1dtifu" }],
    ["path", { d: "M12 8h.01", key: "e9boi3" }]
  ]
}, Wz = ke(Vz);
const qz = {
  name: "keyboard",
  size: 24,
  node: [
    ["path", { d: "M10 8h.01", key: "1r9ogq" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
    ["path", { d: "M14 8h.01", key: "1primd" }],
    ["path", { d: "M16 12h.01", key: "1l6xoz" }],
    ["path", { d: "M18 8h.01", key: "emo2bl" }],
    ["path", { d: "M6 8h.01", key: "x9i8wu" }],
    ["path", { d: "M7 16h10", key: "wp8him" }],
    ["path", { d: "M8 12h.01", key: "czm47f" }],
    ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
  ]
}, Kz = ke(qz);
const Yz = {
  name: "lamp",
  size: 24,
  node: [
    ["path", { d: "M12 12v6", key: "3ahymv" }],
    [
      "path",
      {
        d: "M4.077 10.615A1 1 0 0 0 5 12h14a1 1 0 0 0 .923-1.385l-3.077-7.384A2 2 0 0 0 15 2H9a2 2 0 0 0-1.846 1.23Z",
        key: "1l7kg2"
      }
    ],
    [
      "path",
      { d: "M8 20a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1z", key: "1mmzpi" }
    ]
  ]
}, Xz = ke(Yz);
const Jz = {
  name: "lasso-select",
  size: 24,
  node: [
    ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
    ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
    [
      "path",
      {
        d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
        key: "gt5e1w"
      }
    ],
    ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
    [
      "path",
      {
        d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
        key: "72q637"
      }
    ]
  ]
}, Zz = ke(Jz);
const Qz = {
  name: "layers",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
        key: "zw3jo"
      }
    ],
    [
      "path",
      {
        d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
        key: "1wduqc"
      }
    ],
    [
      "path",
      {
        d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
        key: "kqbvx6"
      }
    ]
  ],
  aliases: ["layers-3"]
}, e$ = ke(Qz);
const t$ = {
  name: "layout-dashboard",
  size: 24,
  node: [
    ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
    ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
    ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
    ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
  ]
}, n$ = ke(t$);
const i$ = {
  name: "layout-grid",
  size: 24,
  node: [
    ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
    ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
    ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
    ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
  ]
}, N3 = ke(i$);
const s$ = {
  name: "layout-template",
  size: 24,
  node: [
    ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
    ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
    ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
  ]
}, U3 = ke(s$);
const o$ = {
  name: "leaf",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11 20a10 10 0 0010-10 25.9 25.9 0 00-1.04-7.281 1 1 0 00-1.755-.325C15.833 5.5 13 5.5 9.8 6.1A7 7 0 0011 20",
        key: "1wjnjv"
      }
    ],
    ["path", { d: "M2 21a5 5 0 012.911-4.544C7.613 15.212 8.351 15.24 11 13", key: "c1ejpn" }]
  ]
}, r$ = ke(o$);
const a$ = {
  name: "library",
  size: 24,
  node: [
    ["path", { d: "m16 6 4 14", key: "ji33uf" }],
    ["path", { d: "M12 6v14", key: "1n7gus" }],
    ["path", { d: "M8 8v12", key: "1gg7y9" }],
    ["path", { d: "M4 4v16", key: "6qkkli" }]
  ]
}, l$ = ke(a$);
const d$ = {
  name: "lightbulb",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
        key: "1gvzjb"
      }
    ],
    ["path", { d: "M9 18h6", key: "x1upvd" }],
    ["path", { d: "M10 22h4", key: "ceow96" }]
  ]
}, c$ = ke(d$);
const u$ = {
  name: "link",
  size: 24,
  node: [
    ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
    ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
  ]
}, h$ = ke(u$);
const p$ = {
  name: "link-2",
  size: 24,
  node: [
    ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
    ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
    ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
  ]
}, f$ = ke(p$);
const m$ = {
  name: "loader-circle",
  size: 24,
  node: [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]],
  aliases: ["loader-2"]
}, G3 = ke(m$);
const g$ = {
  name: "locate-fixed",
  size: 24,
  node: [
    ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
    ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
    ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
    ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, b$ = ke(g$);
const v$ = {
  name: "lock-open",
  size: 24,
  node: [
    ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
    ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
  ],
  aliases: ["unlock"]
}, y$ = ke(v$);
const x$ = {
  name: "lock",
  size: 24,
  node: [
    ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
    ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
  ]
}, j3 = ke(x$);
const w$ = {
  name: "log-out",
  size: 24,
  node: [
    ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
    ["path", { d: "M21 12H9", key: "dn1m92" }],
    ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
  ]
}, k$ = ke(w$);
const _$ = {
  name: "map-pin",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
        key: "1r0f0z"
      }
    ],
    ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
  ]
}, S$ = ke(_$);
const T$ = {
  name: "map",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
        key: "169xi5"
      }
    ],
    ["path", { d: "M15 5.764v15", key: "1pn4in" }],
    ["path", { d: "M9 3.236v15", key: "1uimfh" }]
  ]
}, M$ = ke(T$);
const C$ = {
  name: "maximize-2",
  size: 24,
  node: [
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
    ["path", { d: "m21 3-7 7", key: "1l2asr" }],
    ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
    ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
  ]
}, H3 = ke(C$);
const I$ = {
  name: "message-circle-plus",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        key: "1sd12s"
      }
    ],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "M12 8v8", key: "napkw2" }]
  ]
}, A$ = ke(I$);
const P$ = {
  name: "message-circle",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        key: "1sd12s"
      }
    ]
  ]
}, E$ = ke(P$);
const R$ = {
  name: "message-square-dot",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12.7 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4.7",
        key: "wjb7ig"
      }
    ],
    ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }]
  ]
}, z$ = ke(R$);
const $$ = {
  name: "message-square-plus",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        key: "18887p"
      }
    ],
    ["path", { d: "M12 8v6", key: "1ib9pf" }],
    ["path", { d: "M9 11h6", key: "1fldmi" }]
  ]
}, D$ = ke($$);
const O$ = {
  name: "message-square-warning",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        key: "18887p"
      }
    ],
    ["path", { d: "M12 15h.01", key: "q59x07" }],
    ["path", { d: "M12 7v4", key: "xawao1" }]
  ]
}, L$ = ke(O$);
const B$ = {
  name: "message-square",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        key: "18887p"
      }
    ]
  ]
}, F$ = ke(B$);
const N$ = {
  name: "messages-square",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
        key: "1n2ejm"
      }
    ],
    [
      "path",
      {
        d: "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1",
        key: "1qfcsi"
      }
    ]
  ]
}, U$ = ke(N$);
const G$ = {
  name: "minimize-2",
  size: 24,
  node: [
    ["path", { d: "m14 10 7-7", key: "oa77jy" }],
    ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
    ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
    ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
  ]
}, j$ = ke(G$);
const H$ = {
  name: "minus",
  size: 24,
  node: [["path", { d: "M5 12h14", key: "1ays0h" }]]
}, V3 = ke(H$);
const V$ = {
  name: "moon",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
        key: "kfwtm"
      }
    ]
  ]
}, W$ = ke(V$);
const q$ = {
  name: "mountain",
  size: 24,
  node: [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]]
}, K$ = ke(q$);
const Y$ = {
  name: "mouse-pointer-2",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
        key: "edeuup"
      }
    ]
  ]
}, W3 = ke(Y$);
const X$ = {
  name: "mouse-pointer-click",
  size: 24,
  node: [
    ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
    ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
    ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
    ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
    [
      "path",
      {
        d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
        key: "s0h3yz"
      }
    ]
  ]
}, J$ = ke(X$);
const Z$ = {
  name: "move",
  size: 24,
  node: [
    ["path", { d: "M12 2v20", key: "t6zp3m" }],
    ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
    ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
    ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
    ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
  ]
}, Q$ = ke(Z$);
const e7 = {
  name: "orbit",
  size: 24,
  node: [
    ["path", { d: "M20.341 6.484A10 10 0 0 1 10.266 21.85", key: "1enhxb" }],
    ["path", { d: "M3.659 17.516A10 10 0 0 1 13.74 2.152", key: "1crzgf" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
    ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }]
  ]
}, t7 = ke(e7);
const n7 = {
  name: "paint-bucket",
  size: 24,
  node: [
    ["path", { d: "M11 7 6 2", key: "1jwth8" }],
    ["path", { d: "M18.992 12H2.041", key: "xw1gg" }],
    [
      "path",
      {
        d: "M21.145 18.38A3.34 3.34 0 0 1 20 16.5a3.3 3.3 0 0 1-1.145 1.88c-.575.46-.855 1.02-.855 1.595A2 2 0 0 0 20 22a2 2 0 0 0 2-2.025c0-.58-.285-1.13-.855-1.595",
        key: "1nkol4"
      }
    ],
    [
      "path",
      {
        d: "m8.5 4.5 2.148-2.148a1.205 1.205 0 0 1 1.704 0l7.296 7.296a1.205 1.205 0 0 1 0 1.704l-7.592 7.592a3.615 3.615 0 0 1-5.112 0l-3.888-3.888a3.615 3.615 0 0 1 0-5.112L5.67 7.33",
        key: "1nk1rd"
      }
    ]
  ]
}, i7 = ke(n7);
const s7 = {
  name: "paintbrush",
  size: 24,
  node: [
    ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
    [
      "path",
      {
        d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
        key: "18tc5c"
      }
    ],
    [
      "path",
      {
        d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
        key: "ytzfxy"
      }
    ]
  ]
}, o7 = ke(s7);
const r7 = {
  name: "palette",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
        key: "e79jfc"
      }
    ],
    ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
    ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
    ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
    ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
  ]
}, a7 = ke(r7);
const l7 = {
  name: "panel-left",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }]
  ],
  aliases: ["sidebar"]
}, d7 = ke(l7);
const c7 = {
  name: "panel-right-close",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
    ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
  ]
}, u7 = ke(c7);
const h7 = {
  name: "panel-right-open",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
    ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
  ]
}, p7 = ke(h7);
const f7 = {
  name: "pause",
  size: 24,
  node: [
    ["rect", { x: "14", y: "3", width: "5", height: "18", rx: "1", key: "kaeet6" }],
    ["rect", { x: "5", y: "3", width: "5", height: "18", rx: "1", key: "1wsw3u" }]
  ]
}, m7 = ke(f7);
const g7 = {
  name: "pencil",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
        key: "1a8usu"
      }
    ],
    ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
  ]
}, q3 = ke(g7);
const b7 = {
  name: "pin-off",
  size: 24,
  node: [
    ["path", { d: "M12 17v5", key: "bb1du9" }],
    ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    [
      "path",
      {
        d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
        key: "c9qhm2"
      }
    ]
  ]
}, v7 = ke(b7);
const y7 = {
  name: "pin",
  size: 24,
  node: [
    ["path", { d: "M12 17v5", key: "bb1du9" }],
    [
      "path",
      {
        d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
        key: "1nkz8b"
      }
    ]
  ]
}, x7 = ke(y7);
const w7 = {
  name: "pipette",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12",
        key: "1y3wsu"
      }
    ],
    [
      "path",
      {
        d: "m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z",
        key: "110lr1"
      }
    ],
    ["path", { d: "m2 22 .414-.414", key: "jhxm08" }]
  ]
}, K3 = ke(w7);
const k7 = {
  name: "plane",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
        key: "1v9wt8"
      }
    ]
  ]
}, _7 = ke(k7);
const S7 = {
  name: "play",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
        key: "10ikf1"
      }
    ]
  ]
}, Y3 = ke(S7);
const T7 = {
  name: "plus",
  size: 24,
  node: [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "M12 5v14", key: "s699le" }]
  ]
}, X3 = ke(T7);
const M7 = {
  name: "proportions",
  size: 24,
  node: [
    ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
    ["path", { d: "M12 9v11", key: "1fnkrn" }],
    ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
  ]
}, C7 = ke(M7);
const I7 = {
  name: "rainbow",
  size: 24,
  node: [
    ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
    ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
    ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
  ]
}, A7 = ke(I7);
const P7 = {
  name: "rectangle-vertical",
  size: 24,
  node: [["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]]
}, J3 = ke(P7);
const E7 = {
  name: "rectangle-horizontal",
  size: 24,
  node: [["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]]
}, R7 = ke(E7);
const z7 = {
  name: "redo-2",
  size: 24,
  node: [
    ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
    ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
  ]
}, $7 = ke(z7);
const D7 = {
  name: "refresh-cw",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
    ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
    ["path", { d: "M8 16H3v5", key: "1cv678" }]
  ]
}, O7 = ke(D7);
const L7 = {
  name: "repeat",
  size: 24,
  node: [
    ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
    ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
    ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
    ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
  ]
}, B7 = ke(L7);
const F7 = {
  name: "replace",
  size: 24,
  node: [
    ["path", { d: "M14 4a1 1 0 0 1 1-1", key: "dhj8ez" }],
    ["path", { d: "M15 10a1 1 0 0 1-1-1", key: "1mnyi5" }],
    ["path", { d: "M21 4a1 1 0 0 0-1-1", key: "sfs9ap" }],
    ["path", { d: "M21 9a1 1 0 0 1-1 1", key: "mp6qeo" }],
    ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
    ["path", { d: "M6 10V5a2 2 0 0 1 2-2h2", key: "15xut4" }],
    ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }]
  ]
}, N7 = ke(F7);
const U7 = {
  name: "rotate-3d",
  size: 24,
  node: [
    ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
    ["path", { d: "M16.47214 7.52786 A 5 10 0 1 0 13 21.79796", key: "1245p8" }],
    ["path", { d: "M21.79796 11 A 10 5 0 1 0 19 15.57071", key: "1i40ks" }]
  ],
  aliases: ["rotate-3-d"]
}, G7 = ke(U7);
const j7 = {
  name: "rotate-ccw-clock",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
    ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
    ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
  ],
  aliases: ["history"]
}, H7 = ke(j7);
const V7 = {
  name: "rotate-ccw",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
    ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
  ]
}, W7 = ke(V7);
const q7 = {
  name: "rotate-cw",
  size: 24,
  node: [
    ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
  ]
}, K7 = ke(q7);
const Y7 = {
  name: "route",
  size: 24,
  node: [
    ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
    ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
  ]
}, X7 = ke(Y7);
const J7 = {
  name: "rows-3",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M21 9H3", key: "1338ky" }],
    ["path", { d: "M21 15H3", key: "9uk58r" }]
  ],
  aliases: ["panels-top-bottom"]
}, Z7 = ke(J7);
const Q7 = {
  name: "scan-face",
  size: 24,
  node: [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
    ["path", { d: "M9 9h.01", key: "1q5me6" }],
    ["path", { d: "M15 9h.01", key: "x1ddxp" }]
  ]
}, eD = ke(Q7);
const tD = {
  name: "scan",
  size: 24,
  node: [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
  ]
}, nD = ke(tD);
const iD = {
  name: "search",
  size: 24,
  node: [
    ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
  ]
}, Z3 = ke(iD);
const sD = {
  name: "send",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
        key: "1ffxy3"
      }
    ],
    ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
  ]
}, oD = ke(sD);
const rD = {
  name: "send-to-back",
  size: 24,
  node: [
    ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
    ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
    ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
    ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
  ]
}, aD = ke(rD);
const lD = {
  name: "settings-2",
  size: 24,
  node: [
    ["path", { d: "M14 17H5", key: "gfn3mx" }],
    ["path", { d: "M19 7h-9", key: "6i9tg" }],
    ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
    ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
  ]
}, dD = ke(lD);
const cD = {
  name: "settings",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
        key: "1i5ecw"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, Q3 = ke(cD);
const uD = {
  name: "share-2",
  size: 24,
  node: [
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
    ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
    ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
    ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
    ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
  ]
}, hD = ke(uD);
const pD = {
  name: "shield-check",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y"
      }
    ],
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
  ]
}, fD = ke(pD);
const mD = {
  name: "slash",
  size: 24,
  node: [["path", { d: "M22 2 2 22", key: "y4kqgn" }]]
}, gD = ke(mD);
const bD = {
  name: "sliders-horizontal",
  size: 24,
  node: [
    ["path", { d: "M10 5H3", key: "1qgfaw" }],
    ["path", { d: "M12 19H3", key: "yhmn1j" }],
    ["path", { d: "M14 3v4", key: "1sua03" }],
    ["path", { d: "M16 17v4", key: "1q0r14" }],
    ["path", { d: "M21 12h-9", key: "1o4lsq" }],
    ["path", { d: "M21 19h-5", key: "1rlt1p" }],
    ["path", { d: "M21 5h-7", key: "1oszz2" }],
    ["path", { d: "M8 10v4", key: "tgpxqk" }],
    ["path", { d: "M8 12H3", key: "a7s4jb" }]
  ]
}, e6 = ke(bD);
const vD = {
  name: "sofa",
  size: 24,
  node: [
    ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
    [
      "path",
      {
        d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
        key: "xacw8m"
      }
    ],
    ["path", { d: "M4 18v2", key: "jwo5n2" }],
    ["path", { d: "M20 18v2", key: "1ar1qi" }],
    ["path", { d: "M12 4v9", key: "oqhhn3" }]
  ]
}, yD = ke(vD);
const xD = {
  name: "sparkle",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
        key: "1s2grr"
      }
    ]
  ]
}, wD = ke(xD);
const kD = {
  name: "sparkles",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
        key: "1s2grr"
      }
    ],
    ["path", { d: "M20 2v4", key: "1rf3ol" }],
    ["path", { d: "M22 4h-4", key: "gwowj6" }],
    ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
  ],
  aliases: ["stars"]
}, Yb = ke(kD);
const _D = {
  name: "spotlight",
  size: 24,
  node: [
    ["path", { d: "M15.295 19.562 16 22", key: "31jsb7" }],
    ["path", { d: "m17 16 3.758 2.098", key: "121ar7" }],
    ["path", { d: "m19 12.5 3.026-.598", key: "19ukd3" }],
    [
      "path",
      {
        d: "M7.61 6.3a3 3 0 0 0-3.92 1.3l-1.38 2.79a3 3 0 0 0 1.3 3.91l6.89 3.597a1 1 0 0 0 1.342-.447l3.106-6.211a1 1 0 0 0-.447-1.341z",
        key: "lwb9l9"
      }
    ],
    ["path", { d: "M8 9V2", key: "1xa0v7" }]
  ]
}, SD = ke(_D);
const TD = {
  name: "square-check",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "m16 9-5.5 5.5L8 12", key: "xofnsj" }]
  ],
  aliases: ["check-square-2"]
}, MD = ke(TD);
const CD = {
  name: "square-dashed",
  size: 24,
  node: [
    ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
    ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
    ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
    ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
    ["path", { d: "M9 3h1", key: "1yesri" }],
    ["path", { d: "M9 21h1", key: "15o7lz" }],
    ["path", { d: "M14 3h1", key: "1ec4yj" }],
    ["path", { d: "M14 21h1", key: "v9vybs" }],
    ["path", { d: "M3 9v1", key: "1r0deq" }],
    ["path", { d: "M21 9v1", key: "mxsmne" }],
    ["path", { d: "M3 14v1", key: "vnatye" }],
    ["path", { d: "M21 14v1", key: "169vum" }]
  ],
  aliases: ["box-select"]
}, ID = ke(CD);
const AD = {
  name: "square",
  size: 24,
  node: [["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]]
}, t6 = ke(AD);
const PD = {
  name: "sticky-note",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
        key: "1dfntj"
      }
    ],
    ["path", { d: "M15 3v5a1 1 0 0 0 1 1h5", key: "6s6qgf" }]
  ]
}, n6 = ke(PD);
const ED = {
  name: "sun",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
    ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
    ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
  ]
}, RD = ke(ED);
const zD = {
  name: "swatch-book",
  size: 24,
  node: [
    ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
    ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
    ["path", { d: "M 7 17h.01", key: "1euzgo" }],
    [
      "path",
      {
        d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
        key: "o2gii7"
      }
    ]
  ]
}, $D = ke(zD);
const DD = {
  name: "table-2",
  size: 24,
  node: [
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
  ]
}, OD = ke(DD);
const LD = {
  name: "thermometer",
  size: 24,
  node: [["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]]
}, BD = ke(LD);
const FD = {
  name: "trash",
  size: 24,
  node: [
    ["path", { d: "M10 11v6", key: "nco0om" }],
    ["path", { d: "M14 11v6", key: "outv1u" }],
    ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
    ["path", { d: "M3 6h18", key: "d0wm0j" }],
    ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
  ],
  aliases: ["trash-2"]
}, i6 = ke(FD);
const ND = {
  name: "trees",
  size: 24,
  node: [
    [
      "path",
      { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }
    ],
    ["path", { d: "M7 16v6", key: "1a82de" }],
    ["path", { d: "M13 19v3", key: "13sx9i" }],
    [
      "path",
      {
        d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
        key: "1sj9kv"
      }
    ]
  ]
}, UD = ke(ND);
const GD = {
  name: "triangles-centerline-dashed-horizontal",
  size: 24,
  node: [
    ["path", { d: "M10 12H8", key: "s88cx1" }],
    ["path", { d: "M16 12h-2", key: "10asgb" }],
    ["path", { d: "M22 12h-2", key: "14jgyd" }],
    ["path", { d: "M4 12H2", key: "rhcxmi" }],
    [
      "path",
      {
        d: "M7.298 20.288A1 1 0 008 22h8a1 1 0 00.703-1.712l-3.991-3.99a1 1 0 00-1.424-.001z",
        key: "15ue1v"
      }
    ],
    [
      "path",
      {
        d: "M7.298 3.712A1 1 0 018 2h8a1 1 0 01.703 1.712l-3.991 3.99a1 1 0 01-1.424.001z",
        key: "lzh03e"
      }
    ]
  ],
  aliases: ["flip-horizontal-2"]
}, jD = ke(GD);
const HD = {
  name: "triangles-centerline-dashed-vertical",
  size: 24,
  node: [
    ["path", { d: "M12 14v2", key: "8jcxud" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 8v2", key: "1woqiv" }],
    [
      "path",
      {
        d: "M20.288 16.703A1 1 0 0022 16V8a1 1 0 00-1.712-.703l-3.99 3.991a1 1 0 00-.001 1.424z",
        key: "1ewq2t"
      }
    ],
    [
      "path",
      {
        d: "M3.712 16.703A1 1 0 012 16V8a1 1 0 011.712-.703l3.99 3.991a1 1 0 01.001 1.424z",
        key: "1c1klx"
      }
    ]
  ],
  aliases: ["flip-vertical-2"]
}, VD = ke(HD);
const WD = {
  name: "trophy",
  size: 24,
  node: [
    ["path", { d: "M10 14.66V17a1 1 0 0 1-1 1 2 2 0 0 0-2 2v2", key: "pwuv1l" }],
    ["path", { d: "M14 14.66V17a1 1 0 0 0 1 1 2 2 0 0 1 2 2v2", key: "1y54w1" }],
    ["path", { d: "M17.916 10H19.5A2.5 2.5 0 0 0 22 7.5V5a1 1 0 0 0-1-1h-3", key: "e30mpu" }],
    ["path", { d: "M4 22h16", key: "57wxv0" }],
    ["path", { d: "M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z", key: "1mhfuq" }],
    ["path", { d: "M6.084 10H4.5A2.5 2.5 0 0 1 2 7.5V5a1 1 0 0 1 1-1h3", key: "i0yafy" }]
  ]
}, qD = ke(WD);
const KD = {
  name: "type",
  size: 24,
  node: [
    ["path", { d: "M12 4v16", key: "1654pz" }],
    ["path", { d: "M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2", key: "e0r10z" }],
    ["path", { d: "M9 20h6", key: "s66wpe" }]
  ]
}, YD = ke(KD);
const XD = {
  name: "undo-2",
  size: 24,
  node: [
    ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
    ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
  ]
}, JD = ke(XD);
const ZD = {
  name: "upload",
  size: 24,
  node: [
    ["path", { d: "M12 3v12", key: "1x0j5s" }],
    ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
    ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
  ]
}, QD = ke(ZD);
const eO = {
  name: "user-check",
  size: 24,
  node: [
    ["path", { d: "m16 11 2 2 4-4", key: "9rsbq5" }],
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
  ]
}, tO = ke(eO);
const nO = {
  name: "user-plus",
  size: 24,
  node: [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
    ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
  ]
}, s6 = ke(nO);
const iO = {
  name: "user-round-cog",
  size: 24,
  node: [
    ["path", { d: "m14.305 19.53.923-.382", key: "3m78fa" }],
    ["path", { d: "m15.228 16.852-.923-.383", key: "npixar" }],
    ["path", { d: "m16.852 15.228-.383-.923", key: "5xggr7" }],
    ["path", { d: "m16.852 20.772-.383.924", key: "dpfhf9" }],
    ["path", { d: "m19.148 15.228.383-.923", key: "1reyyz" }],
    ["path", { d: "m19.53 21.696-.382-.924", key: "1goivc" }],
    ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
    ["path", { d: "m20.772 16.852.924-.383", key: "htqkph" }],
    ["path", { d: "m20.772 19.148.924.383", key: "9w9pjp" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
  ],
  aliases: ["user-cog-2"]
}, sO = ke(iO);
const oO = {
  name: "user-round",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
    ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
  ],
  aliases: ["user-2"]
}, rO = ke(oO);
const aO = {
  name: "users",
  size: 24,
  node: [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["path", { d: "M16 3.128a4 4 0 0 1 0 7.744", key: "16gr8j" }],
    ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
  ]
}, o6 = ke(aO);
const lO = {
  name: "video",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
        key: "ftymec"
      }
    ],
    ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
  ]
}, r6 = ke(lO);
const dO = {
  name: "wand-sparkles",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
        key: "ul74o6"
      }
    ],
    ["path", { d: "m14 7 3 3", key: "1r5n42" }],
    ["path", { d: "M5 6v4", key: "ilb8ba" }],
    ["path", { d: "M19 14v4", key: "blhpug" }],
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
    ["path", { d: "M7 8H3", key: "zfb6yr" }],
    ["path", { d: "M21 16h-4", key: "1cnmox" }],
    ["path", { d: "M11 3H9", key: "1obp7u" }]
  ],
  aliases: ["wand-2"]
}, a6 = ke(dO);
const cO = {
  name: "x",
  size: 24,
  node: [
    ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
    ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
  ]
}, l6 = ke(cO);
const uO = {
  name: "zoom-in",
  size: 24,
  node: [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
    ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
    ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
  ]
}, hO = ke(uO);
const pO = {
  name: "zoom-out",
  size: 24,
  node: [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
    ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
  ]
}, fO = ke(pO), mO = [
  "M7.61988 8.70002C9.40944 8.70002 10.8599 7.97426 10.8599 7.08002C10.8599 6.18578 9.40944 5.46002 7.61988 5.46002C5.83032 5.46002 4.37988 6.18578 4.37988 7.08002C4.37988 7.97426 5.83032 8.70002 7.61988 8.70002Z",
  "M4.37988 7.08002V9.24002C4.37988 10.1343 5.83032 10.86 7.61988 10.86C9.40944 10.86 10.8599 10.1343 10.8599 9.24002V7.08002",
  "M4.37989 4.38001C6.16945 4.38001 7.61989 3.65425 7.61989 2.76001C7.61989 1.86577 6.16945 1.14001 4.37989 1.14001C2.59033 1.14001 1.13989 1.86577 1.13989 2.76001C1.13989 3.65425 2.59033 4.38001 4.37989 4.38001Z",
  "M1.13989 2.76001V8.16001C1.13989 8.63953 1.55677 9.07045 2.21989 9.36745",
  "M1.13989 5.46002C1.13989 5.93954 1.55677 6.37046 2.21989 6.66746"
], d6 = (n) => cl(
  "svg",
  { width: n.size || 16, height: n.size || 16, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
  mO.map((e) => cl("path", { d: e, stroke: "currentColor", "stroke-width": 1.2, "stroke-linecap": "round", "stroke-linejoin": "round" }))
);
d6.props = ["size"];
const R = /* @__PURE__ */ Re({
  __name: "Icon",
  props: {
    name: {},
    size: { default: 16 },
    stroke: { default: 2 },
    spin: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = {
      MousePointer2: W3,
      Hand: O3,
      Image: F3,
      StickyNote: n6,
      Frame: $3,
      ChevronDown: T3,
      ChevronUp: cR,
      ChevronRight: C3,
      ChevronLeft: M3,
      X: l6,
      Square: t6,
      Circle: _R,
      Slash: gD,
      ArrowUpRight: k3,
      ArrowRight: w3,
      Check: S3,
      Search: Z3,
      Plus: X3,
      Minus: V3,
      Scan: nD,
      Sun: RD,
      Moon: W$,
      Map: M$,
      PanelRightOpen: p7,
      PanelRightClose: u7,
      Trash2: i6,
      Play: Y3,
      Heart: L3,
      Link2: f$,
      Info: Wz,
      Wand2: a6,
      AlignStartVertical: y9,
      AlignCenterHorizontal: p9,
      AlignStartHorizontal: b9,
      AlignHorizontalDistributeCenter: m9,
      BringToFront: K9,
      SendToBack: aD,
      Settings: Q3,
      Settings2: dD,
      ImagePlus: B3,
      Clock: PR,
      Loader2: G3,
      Type: YD,
      Images: Gz,
      MessageSquare: F$,
      Clipboard: IR,
      Share2: hD,
      Download: E3,
      Maximize2: H3,
      ArrowDownToLine: _9,
      Repeat: B7,
      RotateCcw: W7,
      HelpCircle: Gx,
      CircleHelp: Gx,
      Video: r6,
      Box: W9,
      Layers: e$,
      Sparkles: Yb,
      RectangleVertical: J3,
      RectangleHorizontal: R7,
      Building2: eR,
      Sofa: yD,
      Rows3: Z7,
      LayoutGrid: N3,
      Copy: P3,
      Undo2: JD,
      Redo2: $7,
      Group: $z,
      AlertCircle: Kb,
      CircleAlert: Kb,
      Upload: QD,
      FolderOpen: Mz,
      Ellipsis: R3,
      EllipsisVertical: nz,
      Pencil: q3,
      ArrowLeft: C9,
      Gauge: Az,
      ImageOff: Bz,
      Trees: UD,
      Eye: hz,
      Mountain: K$,
      Lightbulb: c$,
      Camera: nR,
      Palette: a7,
      LocateFixed: b$,
      Clapperboard: MR,
      Keyboard: Kz,
      EyeOff: cz,
      Users: o6,
      Lock: j3,
      Globe: D3,
      UserPlus: s6,
      ExternalLink: z3,
      Library: l$,
      LogOut: k$,
      // the Studios view
      Brush: X9,
      MapPin: S$,
      Eraser: oz,
      BookmarkPlus: G9,
      CornerDownLeft: jR,
      Rotate3d: G7,
      Cpu: qR,
      SquareCheck: MD,
      Replace: N7,
      FileBox: vz,
      // the Library
      Grid3x3: Rz,
      LayoutDashboard: n$,
      SlidersHorizontal: e6,
      Columns3: BR,
      // the prompt library (its sidebar opens from PanelLeft when the panel is narrow)
      LayoutTemplate: U3,
      ChevronsUp: hR,
      CloudOff: RR,
      Bookmark: H9,
      PanelLeft: d7,
      // pinned sessions
      Pin: x7,
      PinOff: v7,
      // the eyedropper
      Pipette: K3,
      // the board's history, on the side rail
      History: H7,
      // beta feedback
      MessageSquareWarning: L$,
      Bug: Z9,
      Send: oD,
      // unlocking a frame
      LockOpen: y$,
      // the Edit side's tools (IL-073)
      Crop: YR,
      Smile: gz,
      LassoSelect: Zz,
      MousePointerClick: J$,
      Expand: az,
      FlipHorizontal2: jD,
      FlipVertical2: VD,
      RotateCw: K7,
      Contrast: NR,
      Droplet: ez,
      Paintbrush: o7,
      Aperture: w9,
      Film: xz,
      Blend: N9,
      SquareDashed: ID,
      Sparkle: wD,
      Move: Q$,
      Thermometer: BD,
      Columns2: OR,
      Spotlight: SD,
      Orbit: t7,
      ZoomIn: hO,
      ZoomOut: fO,
      Proportions: C7,
      ScanFace: eD,
      Dice5: JR,
      Lamp: Xz,
      SwatchBook: $D,
      Rainbow: A7,
      PaintBucket: i7,
      // comments (IL-092) and the emoji picker's categories
      SmilePlus: fz,
      AtSign: $9,
      Bell: B9,
      BellOff: O9,
      CircleCheck: I3,
      MessageCircle: E$,
      MessageCirclePlus: A$,
      MessagesSquare: U$,
      MessageSquareDot: z$,
      Leaf: r$,
      Coffee: $R,
      Plane: _7,
      Trophy: qD,
      Flag: kz,
      ArrowUp: _3,
      CheckCheck: sR,
      Inbox: Hz,
      // chat sessions in frames (Smart Frames)
      MessageSquarePlus: D$,
      Route: X7,
      CornerDownRight: VR,
      CircleX: A3,
      CircleStop: wR,
      Focus: Sz,
      // RunDiffusion's own mark for token costs
      Tokens: d6
    }, t = n, i = I(() => e[t.name] || e.Sparkles);
    return (s, o) => (g(), v("span", {
      class: U(["licon", { "licon-spin": n.spin }]),
      "aria-hidden": "true"
    }, [
      (g(), Ce(Yr(i.value), {
        size: n.size,
        "stroke-width": n.stroke
      }, null, 8, ["size", "stroke-width"]))
    ], 2));
  }
}), c6 = /* @__PURE__ */ Symbol("board");
function gO(n) {
  $5(c6, n);
}
function tt() {
  const n = Tf(c6);
  if (!n) throw new Error("useBoard() outside a board");
  return n;
}
function ps(n) {
  const { board: e } = tt(), t = I(() => {
    const i = n();
    e.rev(i).value;
    const s = e.store.get(i);
    return s ? { ...s } : null;
  });
  return Ve(() => {
    e.store.get(n()) || e.releaseRev(n());
  }), t;
}
const bO = { class: "cv-atmo" }, vO = /* @__PURE__ */ Re({
  __name: "Atmosphere",
  setup(n) {
    const { board: e } = tt(), t = /* @__PURE__ */ K(null);
    function i(o) {
      const r = t.value;
      if (!r) return;
      let l = 30 * (Number.isFinite(o.zoom) && o.zoom > 0 ? o.zoom : 1);
      for (let d = 0; d < 24 && l < 16; d++) l *= 2;
      for (let d = 0; d < 24 && l > 64; d++) l /= 2;
      r.style.backgroundSize = l + "px " + l + "px", r.style.backgroundPosition = o.x % l + "px " + (o.y + e.view.top) % l + "px";
    }
    let s = null;
    return ot(() => {
      s = e.onCameraFrame(i), i(e.cam.value);
    }), Ve(() => {
      s && s();
    }), (o, r) => (g(), v("div", bO, [
      r[0] || (r[0] = h("div", { class: "cv-atmo-glow" }, null, -1)),
      r[1] || (r[1] = h("div", { class: "cv-atmo-orb-a" }, null, -1)),
      r[2] || (r[2] = h("div", { class: "cv-atmo-orb-b" }, null, -1)),
      h("div", {
        ref_key: "grid",
        ref: t,
        class: "cv-grid"
      }, null, 512)
    ]));
  }
}), t1 = !1;
function n1(n) {
  const e = Math.max(0, Math.floor(n / 1e3));
  return Math.floor(e / 60) + ":" + String(e % 60).padStart(2, "0");
}
function yO(n) {
  const e = Math.max(1, Math.round(n / 1e3));
  if (e < 60) return e + " s";
  const t = Math.floor(e / 60);
  return t < 60 ? t + " min" + (e % 60 ? " " + e % 60 + " s" : "") : Math.floor(t / 60) + " h" + (t % 60 ? " " + t % 60 + " min" : "");
}
const hu = /* @__PURE__ */ We(Date.now());
let jx = 0, Hx = 0;
function Ko() {
  return Al() && (jx++ === 0 && (Hx = window.setInterval(() => {
    hu.value = Date.now();
  }, 1e3)), hu.value = Date.now(), Ve(() => {
    --jx === 0 && clearInterval(Hx);
  })), hu;
}
function Jn(n, e = Date.now()) {
  const t = Math.max(0, Math.round((e - n) / 1e3));
  if (t < 45) return "just now";
  const i = Math.round(t / 60);
  if (i < 60) return i + "m ago";
  const s = Math.round(i / 60);
  if (s < 24) return s + "h ago";
  const o = Math.round(s / 24);
  return o < 7 ? o + "d ago" : new Date(n).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
function i1(n) {
  const e = new Date(n), t = e.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  let i = e.getHours();
  const s = i >= 12 ? "pm" : "am";
  return i = i % 12 || 12, t + " @ " + i + ":" + String(e.getMinutes()).padStart(2, "0") + " " + s;
}
const u6 = 24 * 3600 * 1e3;
function Cp(n, e = Date.now()) {
  const t = new Date(n), i = t.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).toLowerCase(), s = new Date(e);
  if (s.setHours(0, 0, 0, 0), n >= s.getTime()) return "today, " + i;
  if (n >= s.getTime() - u6) return "yesterday, " + i;
  const o = t.getFullYear() === s.getFullYear() ? { month: "short", day: "numeric" } : { month: "short", day: "numeric", year: "numeric" };
  return t.toLocaleDateString("en-US", o) + ", " + i;
}
function xO(n, e = Date.now()) {
  const t = Math.max(1, Math.ceil((n - e) / u6));
  return t === 1 ? "1 day" : t + " days";
}
function Xb(n) {
  return String(n || "").split(/\s+/).filter(Boolean).map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function ta(n) {
  const e = String(n || "").trim(), t = (e.includes("@") ? e.split("@")[0].replace(/[._+-]+/g, " ") : e).split(/\s+/).filter(Boolean);
  return t.length ? t.length === 1 ? t[0].slice(0, 2).toUpperCase() : (t[0][0] + t[t.length - 1][0]).toUpperCase() : "YOU";
}
const Vx = [
  ["1:1", 1],
  ["4:3", 4 / 3],
  ["3:2", 1.5],
  ["16:9", 16 / 9],
  ["3:4", 0.75],
  ["2:3", 2 / 3],
  ["9:16", 9 / 16]
];
function wO(n, e) {
  const t = n / Math.max(1, e);
  let i = Vx[0];
  for (const s of Vx) Math.abs(s[1] - t) < Math.abs(i[1] - t) && (i = s);
  return i[0];
}
const Wx = null, kO = "";
function _O(n, e) {
  return SO(e.type) ? MO(n, e) : e.type === "SINGLE_SELECT" ? IO(n, e) : e.type === "WIDTH_HEIGHT" ? AO(n, e) : { valid: !0 };
}
function SO(n) {
  return n === "SLIDER" || n === "UPSCALE_FACTOR_SLIDER" || n === "CFG" || n === "STEPS";
}
function TO(n) {
  if (typeof n == "number" && Number.isFinite(n)) return n;
  if (n && typeof n == "object" && "value" in n) {
    const e = n.value;
    if (typeof e == "number" && Number.isFinite(e)) return e;
  }
  return typeof n == "string" && !isNaN(Number(n)) ? Number(n) : null;
}
function MO(n, e) {
  const t = e.display || {}, i = TO(n);
  if (i === null)
    return { valid: !1, reason: "Invalid numeric value" };
  if (Array.isArray(t.options) && t.options.length > 0)
    return t.options.some(
      (c) => Number(c.value) === i || c.value === i
    ) ? { valid: !0 } : { valid: !1, reason: "Value is not one of the allowed options" };
  if (i < t.min)
    return { valid: !1, reason: `Value below minimum (${t.min})` };
  if (i > t.max)
    return { valid: !1, reason: `Value above maximum (${t.max})` };
  const s = typeof t.step == "number" ? t.step : 1, o = (i - t.min) / s, r = Math.round(o), a = t.min + r * s, l = s * 1e-4;
  return Math.abs(i - a) > l ? { valid: !1, reason: `Value doesn't align with step (${s})` } : { valid: !0 };
}
function CO(n) {
  return n ? n.text && Array.isArray(n.text.options) ? n.text.options : n.radio && Array.isArray(n.radio.options) ? n.radio.options : n.image && Array.isArray(n.image.options) ? n.image.options : [] : [];
}
function IO(n, e) {
  const t = CO(e.display);
  if (t.length === 0)
    return { valid: !1, reason: "No valid options available" };
  let i = n;
  return n && typeof n == "object" && "value" in n && (i = n.value), t.some((o) => o.value === i) ? { valid: !0 } : typeof i != "string" && typeof i != "number" ? { valid: !1, reason: "Invalid option format" } : t.some(
    (o) => (typeof o.value == "string" || typeof o.value == "number") && String(o.value) === String(i)
  ) ? { valid: !0 } : { valid: !1, reason: "Invalid option" };
}
function AO(n, e) {
  const t = e.display, i = t && t.select;
  if (!i) return { valid: !0 };
  const s = Array.isArray(i.options) ? i.options : [];
  if (s.length === 0)
    return { valid: !1, reason: "No valid resolution options available" };
  if (i.format === "wh") {
    if (n && typeof n == "object" && !Array.isArray(n) && typeof n.width == "number" && typeof n.height == "number") {
      const a = n.width, l = n.height;
      return s.some((c) => c.width === a && c.height === l) ? { valid: !0 } : { valid: !1, reason: "Invalid width/height combination" };
    }
    return { valid: !1, reason: "Invalid width/height format" };
  }
  let o = n;
  return n && typeof n == "object" && "value" in n && (o = n.value), typeof o != "string" && typeof o != "number" ? { valid: !1, reason: "Invalid resolution option format" } : s.some(
    (a) => a.value === o || String(a.value) === String(o)
  ) ? { valid: !0 } : { valid: !1, reason: "Invalid resolution option" };
}
function Io(n) {
  return n !== null && (typeof n == "object" || typeof n == "function");
}
function sn(n, e) {
  let t = n;
  for (const i of e.replace(/\[(\d+)\]/g, ".$1").split(".")) {
    if (t == null) return;
    t = t[i];
  }
  return t;
}
const Cd = (n, e) => n === !0 && !!e || Array.isArray(n) && n.some((t) => t === e), qx = {
  "720p": { width: 1280, height: 720 },
  "1080p": { width: 1920, height: 1080 },
  "1440p": { width: 2560, height: 1440 },
  "2160p": { width: 3840, height: 2160 },
  "4k": { width: 3840, height: 2160 }
};
function s1(n) {
  return Io(n) && "value" in n ? n.value : n;
}
function oa(n) {
  if (!Io(n)) return null;
  const e = n.width, t = n.height;
  return !e || !t ? null : { width: e, height: t };
}
function h6(n) {
  const e = s1(n);
  if (typeof e != "string" && typeof e != "number") return null;
  const t = String(e).trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(qx, t) ? qx[t] : null;
}
function Pl(n) {
  if (!Io(n)) return null;
  const e = Io(n.image) ? n.image : {}, t = Io(n.video) ? n.video : {};
  return t.nodeRunResult ? oa(sn(t, "nodeRunResult.file")) : t.upload ? oa(t.upload) : e.nodeRunResult ? oa(sn(e, "nodeRunResult.file")) : n.nodeRunResult ? oa(sn(n, "nodeRunResult.file")) : e.upload ? oa(e.upload) : n.upload ? oa(n.upload) : null;
}
const p6 = (n, e) => n.width >= e.width || n.height >= e.height;
function PO(n, e) {
  let t = null, i = 1 / 0;
  for (const s of e) {
    const o = h6(s);
    if (!o || p6(n, o)) continue;
    const r = o.width * o.height;
    r >= i || (i = r, t = String(s1(s)));
  }
  return t;
}
function EO(n, e, t, i, s) {
  if (!n.width || !n.height) return null;
  const o = h6(e);
  if (!o || !p6(n, o)) return null;
  const r = i ? i + ": " : "";
  if (s) return r + s;
  const a = n.width + "x" + n.height, l = PO(n, t), d = l ? "Choose " + l + " or higher." : "No available option is larger than your " + a + " input.";
  return r + String(s1(e)) + " targets " + o.width + "x" + o.height + ", which is not larger than your " + a + " input. " + d;
}
function f6(n) {
  return n ? n.text && Array.isArray(n.text.options) ? n.text.options : n.radio && Array.isArray(n.radio.options) ? n.radio.options : n.image && Array.isArray(n.image.options) ? n.image.options : [] : [];
}
function Wc(n, e) {
  const t = { allDisables: [], allShows: [], allRequires: [], triggeredDisables: [], triggeredShows: [], triggeredRequires: [] }, i = n.logic && n.logic.field || {};
  for (const s of Object.keys(i)) {
    const o = (e || {})[s] || null, { disable: r, show: a, autoSet: l, require: d, enforceTargetLargerThanInput: c } = i[s];
    if (r && t.allDisables.push(r), a && t.allShows.push(a), d && t.allRequires.push(d), r && Cd(r.onValue, o) && t.triggeredDisables.push(r), a && Cd(a.onValue, o) && t.triggeredShows.push(a), d && Cd(d.onValue, o) && t.triggeredRequires.push(d), c) {
      const y = Pl(o);
      if (y) {
        const b = f6(n.display).map((k) => k ? k.value : void 0), w = EO(y, (e || {})[n.fieldDefUuid || ""], b, n.label, c.message);
        w && (t.targetLargerThanInputError = w);
      }
    }
    if (!l || l.onValue !== null && l.onValue !== void 0 && !Cd(l.onValue, o)) continue;
    t.autoSetAllowEdit = l.allowEdit || !1, t.autoSetVisible = l.visible || l.allowEdit || !1;
    const u = e[s];
    if (!u) continue;
    const p = l.dataFieldKey;
    let f = null;
    if (p ? (sn(u, "image.nodeRunResult") ? f = sn(u, "image.nodeRunResult.file." + p) : sn(u, "nodeRunResult") ? f = sn(u, "nodeRunResult.file." + p) : sn(u, "image.upload") ? f = sn(u, "image.upload." + p) : sn(u, "upload") && (f = sn(u, "upload." + p)), sn(u, "video.nodeRunResult") ? f = sn(u, "video.nodeRunResult.file." + p) : sn(u, "video.upload") && (f = sn(u, "video.upload." + p)), f == null && (f = sn(u, p))) : f = u, f != null)
      t.autoSetValue = l.setToValue !== void 0 ? l.setToValue : f;
    else {
      const y = sn(u, "image.nodeRunResult") || sn(u, "image.upload") || sn(u, "video.nodeRunResult") || sn(u, "video.upload") || sn(u, "upload") || sn(u, "nodeRunResult");
      p && y && (t.autoSetError = l.errorMessage || "Unable to extract " + p + " from input data");
    }
  }
  return t;
}
function o1(n, e, t = !1) {
  if (!n.logic) return !0;
  const i = Wc(n, e), s = !i.allShows.length || i.triggeredShows.length > 0, o = s && i.triggeredDisables.length > 0;
  return !i.autoSetVisible && !i.autoSetAllowEdit && t ? !1 : s && !o;
}
function m6(n, e) {
  return n.required ? !0 : n.logic ? Wc(n, e).triggeredRequires.length > 0 : !1;
}
function qc(n) {
  const e = [];
  for (const t of n || [])
    t && (t.__rgroup ? e.push(...qc(t.fields)) : t.__rfield && e.push(t));
  return e;
}
function r1(n, e, t = !1) {
  const i = [];
  for (const s of n || [])
    !s || !o1(s, e, t) || (s.__rgroup ? i.push(...r1(s.fields, e, t)) : s.__rfield && i.push(s));
  return i;
}
function g6(n, e) {
  const t = [];
  for (const i of n || [])
    !i || !i.__rgroup || !o1(i, e) || (i.required && !r1(i.fields, e).some((s) => e[s.fieldDefUuid || ""]) && t.push(i), t.push(...g6(i.fields, e)));
  return t;
}
function Kx(n, e) {
  if (e === !0 && n) return !0;
  if (Array.isArray(e)) {
    if (e.includes(n)) return !0;
    if (Io(n))
      return e.some((t) => Io(t) && Object.keys(t).every((i) => n[i] === t[i]));
  }
  return !1;
}
function RO(n, e, t, i, s) {
  let o = n || 0;
  if (t && i)
    for (const r of t)
      for (const [a, l] of Object.entries(r.field)) {
        const d = i[a];
        if (s) {
          const f = qc(s).find((y) => y.fieldDefUuid === a);
          if (f && !o1(f, i)) continue;
        }
        let c = l.operand;
        if (l.operandIsFieldValue) {
          const f = Number(d);
          Number.isFinite(f) && (c = f);
        }
        let u = null;
        l.logicPerArrayItem && (Array.isArray(d) ? u = d : Io(d) && (Array.isArray(d.uploads) || Array.isArray(d.nodeRunResults)) && (u = [...d.uploads || [], ...d.nodeRunResults || []]));
        const p = u !== null ? u.filter((f) => Kx(f, l.onValue)).length : Kx(d, l.onValue) ? 1 : 0;
        for (let f = 0; f < p; f++)
          l.operator === "ADD" ? o += c : l.operator === "MULTIPLY" ? o *= c : l.operator === "SET" && (o = c);
      }
  return zO(o, e || 1);
}
function Yx(n) {
  const [e, t] = String(n).toLowerCase().split("e"), i = e[0] === "-", [s, o = ""] = (i ? e.slice(1) : e).split("."), r = BigInt(s + o);
  return { digits: i ? -r : r, scale: o.length - (t ? Number(t) : 0) };
}
function zO(n, e) {
  if (!Number.isFinite(n) || !Number.isFinite(e)) return Math.floor(n * e);
  const t = Yx(n), i = Yx(e), s = t.digits * i.digits, o = t.scale + i.scale, r = BigInt(10);
  if (o <= 0) return Number(s * r ** BigInt(-o));
  const a = r ** BigInt(o);
  let l = s / a;
  return s < BigInt(0) && l * a !== s && (l -= BigInt(1)), Number(l);
}
const a1 = "__boardUrls", b6 = 0.8;
function Ip(n) {
  return "strength:" + n;
}
function $O(n) {
  return n.raw && n.raw.display || {};
}
function DO(n) {
  const e = $O(n);
  return n.kind === "video" ? !!e.hasStrength : !!(e.hasStrength || e.hasInpainting);
}
function v6(n) {
  return n.fields.filter((e) => e.placement === "reference");
}
function OO(n, e, t) {
  const i = t.inputs ? t.inputs[e.key] : void 0;
  if (e.kind === "images" && Array.isArray(i)) {
    const o = i.filter((r) => typeof r == "string" && !!r);
    if (o.length) return o;
  }
  const s = v6(n)[0] === e ? t.ref : i;
  return typeof s == "string" && s ? s : null;
}
function Xx(n) {
  return { boardUrl: n };
}
function go(n, e, t = "run") {
  const i = {}, s = [], o = {}, r = e.assets || {}, a = t === "rules";
  for (const d of n.fields) {
    if (d.kind === "header") continue;
    if (d.placement === "reference") {
      const u = OO(n, d, e);
      if (!u || Array.isArray(u) && !u.length) continue;
      if (d.kind === "images") {
        const y = [].concat(u), b = [], w = [], k = [];
        for (const S of y) {
          const _ = r[S];
          _ ? "upload" in _ ? b.push(_.upload) : w.push(_.nodeRunResult) : a ? b.push(Xx(S)) : k.push(S);
        }
        (b.length || w.length) && (i[d.key] = { uploads: b, nodeRunResults: w }), k.length && (s.push(...k), o[d.key] = k);
        continue;
      }
      const p = Array.isArray(u) ? u[0] : u, f = r[p] || (a ? Xx(p) : null);
      if (!f) {
        s.push(p), o[d.key] = p;
        continue;
      }
      if (DO(d)) {
        const y = e.inputs && e.inputs[Ip(d.key)], b = typeof y == "number" ? y : b6, w = e.masks && e.masks[d.key];
        i[d.key] = d.kind === "video" ? { video: f, strength: b } : { image: f, inpainting: w ? { mask: w } : null, strength: b };
      } else
        i[d.key] = f;
      continue;
    }
    const c = d.placement === "prompt" ? e.prompt : e.inputs && e.inputs[d.key] !== void 0 ? e.inputs[d.key] : d.defaultValue;
    c == null || c === "" || (i[d.key] = d.kind === "prompt" ? { value: c } : c);
  }
  const l = n.raw && n.raw.fields;
  if (l) {
    const d = new Set(n.fields.map((c) => c.key));
    for (const c of qc(l)) {
      const u = c.fieldDefUuid;
      !u || d.has(u) || u in i || c.defaultValue !== void 0 && c.defaultValue !== null && (i[u] = c.defaultValue);
    }
  }
  return t === "draft" && Object.keys(o).length && (i[a1] = o), { inputs: i, pending: s };
}
function LO(n) {
  return typeof n == "string" ? n : n && typeof n == "object" && "value" in n ? String(n.value || "") : "";
}
function Jb(n) {
  if (!n || typeof n != "object") return null;
  const e = n;
  return e.upload && typeof e.upload == "object" ? { upload: e.upload } : e.nodeRunResult && typeof e.nodeRunResult == "object" ? { nodeRunResult: e.nodeRunResult } : e.image ? Jb(e.image) : e.video ? Jb(e.video) : null;
}
function Ap(n, e, t) {
  const i = { prompt: "", ref: null, inputs: {}, assets: {} }, s = i.inputs, o = i.assets, r = e[a1] || {}, a = v6(n), l = (d, c) => {
    const u = [].concat(c);
    u.length > 1 && (s[d.key] = u), a[0] === d ? i.ref = u[0] : u.length === 1 && (s[d.key] = u[0]);
  };
  for (const d of n.fields) {
    if (d.kind === "header") continue;
    const c = e[d.key];
    if (d.placement === "prompt") {
      i.prompt = LO(c);
      continue;
    }
    if (d.placement === "reference") {
      if (d.kind === "images") {
        const p = [], f = c || {};
        for (const b of f.uploads || []) {
          const w = { upload: b }, k = t(w);
          o[k] = w, p.push(k);
        }
        for (const b of f.nodeRunResults || []) {
          const w = { nodeRunResult: b }, k = t(w);
          o[k] = w, p.push(k);
        }
        const y = r[d.key];
        y && p.push(...[].concat(y)), p.length && l(d, p);
        continue;
      }
      const u = Jb(c);
      if (u) {
        const p = t(u);
        o[p] = u, l(d, p);
        const f = c && typeof c == "object" ? c.strength : void 0;
        typeof f == "number" && (s[Ip(d.key)] = f);
      } else typeof r[d.key] == "string" && l(d, r[d.key]);
      continue;
    }
    c !== void 0 && (s[d.key] = c);
  }
  return i;
}
function BO(n, e) {
  const t = (i) => JSON.stringify({
    prompt: i && i.prompt || "",
    ref: i && i.ref || null,
    n: i && i.n || null,
    inputs: FO(i && i.inputs || {})
  });
  return t(n) === t(e);
}
function FO(n) {
  const e = {};
  for (const t of Object.keys(n).sort()) n[t] !== void 0 && n[t] !== null && n[t] !== "" && (e[t] = n[t]);
  return e;
}
const NO = { shown: !0, locked: !1, why: "", required: !1, problem: "" };
function Pa(n) {
  return /[.!?]$/.test(n) ? n : n + ".";
}
function Ar(n, e) {
  return n.fields.get(e) || NO;
}
function Oi(n) {
  return !!n && typeof n == "object";
}
function UO(n, e) {
  const t = n.display || {};
  if (n.type === "SINGLE_SELECT") {
    const i = f6(t).find((s) => !!s && s.value === e);
    return i ? i.value : void 0;
  }
  if (n.type === "WIDTH_HEIGHT" && t.select) {
    const i = t.select.options || [], s = typeof e == "string" ? i.find((o) => !!o && o.value === e) : Oi(e) && e.width && e.height ? i.find((o) => !!o && o.width === e.width && o.height === e.height) : void 0;
    return s ? t.select.format === "value" ? s.value : { width: s.width, height: s.height } : void 0;
  }
  if (n.type === "SLIDER") {
    const i = Number(e);
    if (!Number.isFinite(i)) return;
    const s = t.min == null ? 1 : t.min, o = t.max || 30, r = t.step || 1;
    return s + Math.round((Math.min(o, Math.max(s, i)) - s) / r) * r;
  }
  return e;
}
function Zb(n, e, t) {
  const i = n.raw && n.raw.fields;
  if (!i) return { values: e, errors: [] };
  const s = qc(i).filter((a) => !!a.logic && !!a.fieldDefUuid);
  if (!s.length) return { values: e, errors: [] };
  let o = e;
  const r = [];
  for (let a = 0; a < 4; a++) {
    let l = !1;
    for (const d of s) {
      const c = d.fieldDefUuid, u = Wc(d, o);
      if (u.autoSetError && !r.includes(u.autoSetError) && r.push(u.autoSetError), u.autoSetValue === null || u.autoSetValue === void 0 || u.autoSetAllowEdit && t && t.inputs && t.inputs[c] !== void 0) continue;
      const p = UO(d, u.autoSetValue);
      if (p === void 0) {
        const f = u.autoSetError || (d.label || "A setting") + " couldn't be set to match your other settings.";
        r.includes(f) || r.push(f);
        continue;
      }
      JSON.stringify(o[c]) !== JSON.stringify(p) && (o = { ...o, [c]: p }, l = !0);
    }
    if (!l) break;
  }
  return { values: o, errors: r };
}
const Jx = [
  ["3:1", 3],
  ["2.5:1", 2.5],
  ["21:9", 2.3],
  ["16:9", 1.8],
  ["3:2", 1.5],
  ["4:3", 1.33],
  ["5:4", 1.25],
  ["1:1", 1],
  ["3:4", 0.75],
  ["2:3", 0.67],
  ["9:16", 0.6],
  ["9:21", 0.4],
  ["1:3", 0.33]
];
function GO(n) {
  const e = Pl(n);
  if (!e) return null;
  const t = Math.round(e.width / e.height * 10) / 10;
  let i = Jx[0];
  for (const s of Jx) Math.abs(s[1] - t) < Math.abs(i[1] - t) && (i = s);
  return i[0];
}
function jO(n, e, t, i) {
  const s = n.logic && n.logic.field || {}, o = e.triggeredDisables[0];
  if (!o) {
    let l = "";
    for (const d of Object.keys(s)) {
      const c = s[d].autoSet;
      c && (c.onValue === null || c.onValue === void 0 || Cd(c.onValue, t[d] || null)) && (l = i.get(d) || "");
    }
    return l ? "Set to match your " + l.toLowerCase() : "Set for you by your other settings";
  }
  const r = Object.keys(s).find((l) => s[l].disable === o) || "";
  if (n.type === "WIDTH_HEIGHT" && o.imageAspectRatioOverride && r) {
    const l = GO(t[r]);
    if (l) return "Aspect Ratio will match input image (" + l + ")";
  }
  if (o.message) return o.message;
  const a = i.get(r);
  return a ? "Turned off by your " + a.toLowerCase() : "Another setting turned this off";
}
function y6(n, e, t) {
  const { values: i, isAdmin: s, labels: o, out: r } = e;
  for (const a of n) {
    if (!a) continue;
    const l = a.logic ? Wc(a, i) : null, d = a.logic && a.logic.field || {}, c = !!l && l.autoSetVisible === !1 && Object.keys(d).some((y) => !!d[y].autoSet), u = t.shown && (!l || !l.allShows.length || l.triggeredShows.length > 0) && (!a.adminOnly || s) && !c, p = u && !!l && (l.triggeredDisables.length > 0 || l.autoSetValue !== void 0 && !!l.autoSetVisible && !l.autoSetAllowEdit), f = {
      shown: u,
      locked: t.locked || p,
      why: p && l ? jO(a, l, i, o) : t.why
    };
    a.__rgroup ? y6(a.fields || [], e, f) : a.__rfield && a.fieldDefUuid && r.set(a.fieldDefUuid, {
      ...f,
      required: m6(a, i),
      problem: u && !f.locked && l && l.targetLargerThanInputError ? l.targetLargerThanInputError : ""
    });
  }
}
const HO = 2e3;
function Zx(n) {
  return Oi(n) ? Oi(n.nodeRunResult) && Oi(n.nodeRunResult.file) ? n.nodeRunResult.file : Oi(n.upload) ? n.upload : null : null;
}
function Qx(n, e, t) {
  if (!e || !e.width || !e.height) return "";
  const i = t || 3, s = e.width / e.height;
  return s > i ? n + " aspect ratio (" + s.toFixed(2) + ":1) is too wide. Maximum allowed is " + i + ":1" : s < 1 / i ? n + " aspect ratio (1:" + (1 / s).toFixed(2) + ") is too tall. Maximum allowed is 1:" + i : "";
}
function ew(n, e, t) {
  return !e || !t ? "" : e.width !== void 0 && e.width < t ? n + " width (" + e.width + "px) is too small. Minimum required is " + t + "px" : e.height !== void 0 && e.height < t ? n + " height (" + e.height + "px) is too small. Minimum required is " + t + "px" : "";
}
function tw(n) {
  return typeof n == "string" ? n : Oi(n) && typeof n.value == "string" ? n.value : "";
}
const VO = /* @__PURE__ */ new Set(["IMG", "IMGS", "VIDEO", "ASSET_3D"]);
function x6(n, e, t) {
  if (t) return "Write a prompt first";
  if (n === "MODEL_SINGLE_SELECT") return "Choose a trained model first";
  const i = (e || "a setting").toLowerCase();
  return (n && VO.has(n) ? "Add " : "Set ") + i + " first";
}
function WO(n, e) {
  const t = [], i = e[n.fieldDefUuid || ""], s = n.display || {}, o = n.label || n.fieldDefUuid || "A field";
  if (m6(n, e) && (!i || n.type === "PROMPT" && !tw(i).trim())) {
    const a = n.type === "PROMPT" || (n.type === "TEXT" || n.type === "TEXT_AREA") && s.primaryForm === "PROMPT";
    t.push(x6(n.type, n.label, a));
  }
  if (n.type === "IMG") {
    const a = Zx(i), l = Qx("Image", a, s.maxAspectRatio);
    l && t.push(l);
    const d = ew("Image", a, s.minDimension);
    d && t.push(d), s.hasInpainting && s.inpaintingRequired && !(Oi(i) && Oi(i.inpainting) && i.inpainting.mask) && t.push("Mask is required");
  }
  if (n.type === "IMGS" && s.maxImages && Oi(i) && (Array.isArray(i.uploads) ? i.uploads.length : 0) + (Array.isArray(i.nodeRunResults) ? i.nodeRunResults.length : 0) > s.maxImages && t.push("Maximum of " + s.maxImages + " images allowed"), n.type === "VIDEO") {
    const a = Zx(Oi(i) && i.video ? i.video : i), l = Qx("Video", a, s.maxAspectRatio);
    l && t.push(l);
    const d = ew("Video", a, s.minDimension);
    d && t.push(d), a && a.width && s.maxWidth && a.width > s.maxWidth && t.push("Video width (" + a.width + "px) exceeds maximum allowed width of " + s.maxWidth + "px"), a && a.height && s.maxHeight && a.height > s.maxHeight && t.push("Video height (" + a.height + "px) exceeds maximum allowed height of " + s.maxHeight + "px"), a && a.duration && s.maxDuration && a.duration > s.maxDuration && t.push("Video duration (" + a.duration + "s) exceeds maximum allowed duration of " + s.maxDuration + "s");
  }
  if (n.type === "PROMPT") {
    const a = s.maxLength || HO;
    tw(i).length > a && t.push("Maximum of " + a + " characters allowed");
  }
  if (n.type === "UPSCALE_FACTOR_SLIDER") {
    const a = typeof i == "number" ? i : Oi(i) && typeof i.value == "number" ? i.value : null, l = s.dataFieldDefUuid ? Pl(e[s.dataFieldDefUuid]) : null;
    if (a !== null && l) {
      const d = Math.round(l.width * a), c = Math.round(l.height * a), u = s.maxWidth || 3840, p = s.maxHeight || 2160;
      d > u ? t.push("Final width (" + d + "px) exceeds maximum allowed width of " + u + "px") : c > p && t.push("Final height (" + c + "px) exceeds maximum allowed height of " + p + "px");
    }
  }
  if (n.type === "SINGLE_SELECT") {
    const a = Wc(n, e).targetLargerThanInputError;
    a && t.push(a);
  }
  if ((n.type === "UPSCALE_FACTOR_SLIDER" || !!i && (n.type === "WIDTH_HEIGHT" || n.type === "SINGLE_SELECT" || n.type === "SLIDER" || n.type === "CFG" || n.type === "STEPS")) && n.type) {
    const a = _O(i, { type: n.type, display: n.display, label: n.label, fieldDefUuid: n.fieldDefUuid });
    a.valid || t.push((a.reason || "Invalid value") + " for " + o);
  }
  return t;
}
function Li(n, e, t, i = !1) {
  const { values: s, errors: o } = Zb(n, go(n, e, "rules").inputs, e), r = n.raw, a = r && r.fields, l = /* @__PURE__ */ new Map(), d = [];
  if (a) {
    const u = /* @__PURE__ */ new Map();
    for (const p of qc(a)) p.fieldDefUuid && p.label && u.set(p.fieldDefUuid, p.label);
    y6(a, { values: s, isAdmin: i, labels: u, out: l }, { shown: !0, locked: !1, why: "" });
    for (const p of r1(a, s)) d.push(...WO(p, s));
    for (const p of g6(a, s)) d.push("Select at least one: " + (p.label || "option"));
  } else
    for (const u of n.fields) {
      if (!u.required) continue;
      const p = u.placement === "prompt";
      (p ? !(e.prompt || "").trim() : !s[u.key]) && d.push(x6(u.placement === "reference" ? "IMG" : void 0, u.label, p));
    }
  let c = null;
  return r && (!r.pricingType || r.pricingType === "COST") && r.costPerResult > 0 ? c = RO(r.costPerResult, t, r.costPerResultLogics, s, a) : !r && n.tokensPerResult != null && (c = Math.round(n.tokensPerResult * t * 100)), { fields: l, values: s, problems: d, price: c, autoErrors: o };
}
function mn(n) {
  if (n && typeof n == "object") {
    const e = n;
    return e.width != null && e.height != null ? e.width + "x" + e.height : JSON.stringify(n);
  }
  return String(n);
}
function as(n, e) {
  return mn(n) === mn(e);
}
function Qb(n) {
  if (!n || typeof n != "object") return !1;
  const e = n;
  return e.width != null && e.height != null;
}
function Wd(n, e) {
  const t = typeof e == "number" ? e : typeof e == "string" && e.trim() !== "" ? Number(e) : NaN;
  if (!Number.isFinite(t)) return null;
  const i = n.min == null ? 1 : n.min, s = n.max == null ? 30 : n.max, o = n.step && n.step > 0 ? n.step : 1;
  let r = i + Math.round((Math.min(s, Math.max(i, t)) - i) / o) * o;
  r > s + 1e-9 && (r -= o);
  const a = (String(o).split(".")[1] || "").length;
  return Number(r.toFixed(a));
}
function Pp(n, e) {
  if (n.placement === "prompt") return e.prompt != null ? e.prompt : n.defaultValue;
  const t = e.inputs ? e.inputs[n.key] : void 0;
  return t !== void 0 ? t : n.defaultValue;
}
function Gs(n) {
  return n.kind === "images" ? Math.max(1, n.maxImages || 4) : 1;
}
function hl(n) {
  const e = n / 100;
  return e >= 100 ? String(Math.round(e)) : String(Math.round(e * 10) / 10);
}
function w6(n, e, t) {
  if (!n) return "";
  if (n.raw && t) {
    const i = Li(n, t, e).price;
    if (i != null) return hl(i);
  }
  return n.tokensPerResult != null ? String(Math.round(n.tokensPerResult * e * 100) / 100) : n.tokensLabel || "";
}
const qO = { class: "cv-topbar-left" }, KO = ["value"], YO = { class: "cv-topbar-right" }, XO = ["title"], JO = ["title"], ZO = {
  key: 0,
  class: "cv-feedback-dot",
  "data-testid": "feedback-draft-dot"
}, QO = { class: "cv-board-menu-wrap" }, eL = ["aria-expanded"], tL = {
  key: 0,
  class: "cv-topbar-dot",
  "data-testid": "board-menu-dot"
}, nL = {
  key: 0,
  class: "cv-board-menu",
  role: "menu",
  "data-testid": "board-menu"
}, iL = {
  key: 0,
  class: "cv-board-menu-count",
  "data-testid": "trash-count"
}, sL = /* @__PURE__ */ Re({
  __name: "TopBar",
  props: {
    onHome: { type: Function },
    onIndex: { type: Function }
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = /* @__PURE__ */ K(!1), s = /* @__PURE__ */ K(null), o = I(() => {
      const k = t.balance.value;
      if (!k) return null;
      const S = k.tokens / 100, _ = Math.abs(S) >= 1e3 ? Math.floor(S).toLocaleString("en-US") : hl(k.tokens), x = (k.team ? "Runs on this board are paid from these tokens" : "Your tokens") + (t.canGetTokens ? ". Get more" : "");
      return { text: _, title: x, empty: k.tokens <= 0 };
    }), r = I(() => t.trash.value.length);
    function a(k) {
      t.ui.boardMenu = !1, t.ui[k] = !0;
    }
    const l = t.feedback, d = I(() => !!l && l.state.mode === "closed" && l.hasDraft);
    function c(k) {
      t.ui.boardMenu = !1, l && l.start(k);
    }
    function u() {
      t.ui.boardMenu = !1, t.openTour();
    }
    function p() {
      t.ui.boardMenu = !1;
      const k = t.promptTool.value;
      t.promptLibrary.open(k ? k.id : null);
    }
    function f(k) {
      t.ui.boardMenu && !k.target.closest(".cv-board-menu-wrap") && (t.ui.boardMenu = !1);
    }
    ot(() => window.addEventListener("pointerdown", f, !0)), Ve(() => window.removeEventListener("pointerdown", f, !0));
    const y = I(() => {
      const k = t.saveState.value;
      return k === "saving" ? { cls: "is-saving", text: "Saving…" } : k === "error" ? { cls: "is-error", text: "Not saved: retrying" } : k === "offline" ? { cls: "is-error", text: "Offline: changes kept here" } : { cls: "", text: "Saved" };
    });
    function b() {
      i.value = !0, it(() => {
        s.value && (s.value.focus({ preventScroll: !0 }), s.value.select());
      });
    }
    function w(k) {
      if (!i.value) return;
      const S = s.value ? s.value.value : "";
      i.value = !1, k && t.renameBoard(S);
    }
    return (k, S) => (g(), v("div", {
      class: "cv-topbar",
      onPointerdown: S[11] || (S[11] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", qO, [
        h("button", {
          class: "cv-mark",
          title: "RunDiffusion",
          "aria-label": "RunDiffusion",
          onClick: S[0] || (S[0] = (_) => e.onHome())
        }, [...S[12] || (S[12] = [
          h("svg", {
            viewBox: "1 33 239 173",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            h("path", {
              d: "M160.973 91.1044H105.586C103.271 91.1044 101.134 89.8671 99.9766 87.8597L74.5215 43.7307C72.0284 39.4055 75.1448 33.9999 80.1311 33.9999H135.518C137.833 33.9999 139.97 35.2372 141.128 37.2447L166.579 81.3772C169.072 85.7024 165.956 91.108 160.97 91.108L160.973 91.1044Z",
              fill: "#CC5FD1"
            }),
            h("path", {
              d: "M160.974 205.317H105.587C103.271 205.317 101.134 204.079 99.9769 202.072L74.5254 157.939C72.0323 153.614 75.1487 148.209 80.135 148.209H135.522C137.837 148.209 139.974 149.446 141.132 151.453L166.583 195.586C169.076 199.911 165.96 205.317 160.974 205.317Z",
              fill: "#B0B3F6"
            }),
            h("path", {
              d: "M150.485 148.213H205.872C208.187 148.213 210.324 146.975 211.481 144.968L236.933 100.835C239.426 96.5102 236.31 91.1046 231.323 91.1046H175.936C173.621 91.1046 171.484 92.3419 170.327 94.3494L144.875 138.482C142.382 142.807 145.498 148.213 150.485 148.213Z",
              fill: "#9A6ADF"
            }),
            h("path", {
              d: "M40.7394 200.572L67.1953 151.857C68.2994 149.821 68.2389 147.35 67.0279 145.371L40.4581 101.905C37.8545 97.6479 31.6216 97.8048 29.2389 102.194L2.78656 150.909C1.68245 152.945 1.74299 155.416 2.95395 157.395L29.5238 200.86C32.1274 205.118 38.3603 204.961 40.743 200.572H40.7394Z",
              fill: "#A691DF"
            })
          ], -1)
        ])]),
        h("button", {
          class: "cv-crumb",
          title: "All boards",
          onClick: S[1] || (S[1] = (_) => e.onIndex())
        }, "Boards"),
        S[13] || (S[13] = h("span", { class: "cv-crumb cv-crumb-sep" }, "/", -1)),
        i.value ? (g(), v("input", {
          key: 0,
          ref_key: "inputEl",
          ref: s,
          class: "cv-board-title-input",
          value: m(t).meta.title,
          spellcheck: "false",
          maxlength: "120",
          onKeydown: [
            S[2] || (S[2] = tn(Pe((_) => w(!0), ["prevent"]), ["enter"])),
            S[3] || (S[3] = tn(Pe((_) => w(!1), ["stop", "prevent"]), ["esc"]))
          ],
          onBlur: S[4] || (S[4] = (_) => w(!0))
        }, null, 40, KO)) : (g(), v("span", {
          key: 1,
          class: "cv-board-title",
          title: "Rename board",
          onClick: b
        }, A(m(t).meta.title), 1))
      ]),
      h("div", YO, [
        m(Wx) ? (g(), Ce(Yr(m(Wx)), {
          key: 0,
          board: m(t)
        }, null, 8, ["board"])) : E("", !0),
        o.value ? (g(), Ce(Yr(m(t).canGetTokens ? "button" : "span"), {
          key: 1,
          class: U(["cv-tokens", { "is-empty": o.value.empty, "is-link": m(t).canGetTokens }]),
          title: o.value.title,
          "data-testid": "token-balance",
          onClick: S[5] || (S[5] = (_) => m(t).getTokens())
        }, {
          default: et(() => [
            C(R, {
              name: "Tokens",
              size: 13
            }),
            X(A(o.value.text), 1)
          ]),
          _: 1
        }, 8, ["class", "title"])) : E("", !0),
        h("span", {
          class: U(["cv-save-state", y.value.cls]),
          title: y.value.text
        }, [
          S[14] || (S[14] = h("span", { class: "dot" }, null, -1)),
          X(A(y.value.text), 1)
        ], 10, XO),
        m(l) ? (g(), v("button", {
          key: 2,
          class: "cv-feedback",
          title: d.value ? "Your report is waiting: open it to finish and send" : "Report a bug or share an idea (`)",
          "data-testid": "feedback-button",
          onClick: S[6] || (S[6] = (_) => c("button"))
        }, [
          C(R, {
            name: "MessageSquareWarning",
            size: 13
          }),
          S[15] || (S[15] = X("Feedback ", -1)),
          d.value ? (g(), v("span", ZO)) : E("", !0)
        ], 8, JO)) : E("", !0),
        h("div", QO, [
          h("button", {
            class: U(["cv-topbar-btn", { on: m(t).ui.boardMenu }]),
            title: "Board menu",
            "aria-label": "Board menu",
            "aria-haspopup": "menu",
            "aria-expanded": m(t).ui.boardMenu,
            "data-testid": "board-menu-button",
            onClick: S[7] || (S[7] = (_) => m(t).ui.boardMenu = !m(t).ui.boardMenu)
          }, [
            C(R, {
              name: "EllipsisVertical",
              size: 16
            }),
            r.value && !m(t).ui.boardMenu ? (g(), v("span", tL)) : E("", !0)
          ], 10, eL),
          m(t).ui.boardMenu ? (g(), v("div", nL, [
            h("button", {
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "library-menu-item",
              onClick: p
            }, [
              C(R, {
                name: "LayoutTemplate",
                size: 17
              }),
              S[16] || (S[16] = h("span", { class: "cv-board-menu-text" }, [
                h("span", { class: "cv-board-menu-title" }, "Prompt Library"),
                h("span", { class: "cv-board-menu-desc" }, "Browse Featured prompts and start a session from one")
              ], -1))
            ]),
            h("button", {
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "trash-button",
              onClick: S[8] || (S[8] = (_) => a("trashOpen"))
            }, [
              C(R, {
                name: "Trash2",
                size: 17
              }),
              S[17] || (S[17] = h("span", { class: "cv-board-menu-text" }, [
                h("span", { class: "cv-board-menu-title" }, "Recently Deleted"),
                h("span", { class: "cv-board-menu-desc" }, "Recover what was deleted from this board, or delete it for good")
              ], -1)),
              r.value ? (g(), v("span", iL, A(r.value > 99 ? "99+" : r.value), 1)) : E("", !0)
            ]),
            h("button", {
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "shortcuts-button",
              onClick: S[9] || (S[9] = (_) => a("keysOpen"))
            }, [
              C(R, {
                name: "Keyboard",
                size: 17
              }),
              S[18] || (S[18] = h("span", { class: "cv-board-menu-text" }, [
                h("span", { class: "cv-board-menu-title" }, "Keyboard Shortcuts"),
                h("span", { class: "cv-board-menu-desc" }, "Every key the board answers to")
              ], -1)),
              S[19] || (S[19] = h("kbd", { class: "cv-board-menu-kbd" }, "?", -1))
            ]),
            m(t).canOpenTour ? (g(), v("button", {
              key: 0,
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "tour-menu-item",
              onClick: u
            }, [
              C(R, {
                name: "CircleHelp",
                size: 17
              }),
              S[20] || (S[20] = h("span", { class: "cv-board-menu-text" }, [
                h("span", { class: "cv-board-menu-title" }, "Take the Tour"),
                h("span", { class: "cv-board-menu-desc" }, "Two minutes on sessions, Tab, Studio view and Edit")
              ], -1))
            ])) : E("", !0),
            m(l) ? (g(), v("button", {
              key: 1,
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "feedback-menu-item",
              onClick: S[10] || (S[10] = (_) => c("menu"))
            }, [
              C(R, {
                name: "MessageSquareWarning",
                size: 17
              }),
              S[21] || (S[21] = h("span", { class: "cv-board-menu-text" }, [
                h("span", { class: "cv-board-menu-title" }, "Send Feedback"),
                h("span", { class: "cv-board-menu-desc" }, "Report a bug or share an idea, with a screenshot")
              ], -1)),
              S[22] || (S[22] = h("kbd", { class: "cv-board-menu-kbd" }, "`", -1))
            ])) : E("", !0)
          ])) : E("", !0)
        ])
      ])
    ], 32));
  }
});
function oL(n) {
  const e = [n.userAgentData && n.userAgentData.platform || "", n.platform || "", n.userAgent || ""].join(" ").toLowerCase();
  return /mac|iphone|ipad|ipod/.test(e) ? "mac" : /\bwin/.test(e) ? "windows" : /cros|chrome os|chromeos/.test(e) ? "chromeos" : /linux|x11|android/.test(e) ? "linux" : "other";
}
const rs = typeof navigator == "undefined" ? "other" : oL(navigator);
function vn(n, e = rs) {
  return e === "mac" ? n.metaKey : n.ctrlKey;
}
function rL(n, e = rs) {
  return e === "mac" ? n.ctrlKey : n.metaKey;
}
function Ef(n = rs) {
  return n === "mac" ? { mod: "⌘", shift: "⇧", alt: "⌥", enter: "↵", del: "⌫", esc: "Esc" } : { mod: "Ctrl", shift: "Shift", alt: "Alt", enter: "Enter", del: "Del", esc: "Esc" };
}
function dn(n, e = rs) {
  const t = Ef(e), s = (e === "mac" ? ["alt", "shift", "mod"] : ["mod", "alt", "shift"]).filter((r) => n.includes(r)).map((r) => t[r]), o = n.filter((r) => r !== "mod" && r !== "shift" && r !== "alt").map((r) => r === "enter" ? t.enter : r === "del" ? t.del : r === "esc" ? t.esc : r);
  return s.concat(o);
}
function Tn(n, e = rs) {
  return dn(n, e).join(e === "mac" ? "" : "+");
}
function l1(n = rs) {
  return n === "mac" ? ["shift", "mod", "Z"] : ["mod", "Y"];
}
const aL = ["aria-label", "aria-expanded"], lL = {
  class: "caret",
  "aria-hidden": "true"
}, dL = ["aria-checked", "data-testid", "onClick"], cL = { class: "tick" }, uL = { class: "lb" }, hL = { class: "k" }, pL = /* @__PURE__ */ Re({
  __name: "ShapeTool",
  setup(n) {
    const { board: e } = tt(), t = [
      { id: "rect", label: "Rectangle", icon: "Square", key: "M" },
      { id: "ellipse", label: "Ellipse", icon: "Circle", key: "L" },
      { id: "line", label: "Line", icon: "Slash", key: "\\" },
      { id: "arrow", label: "Arrow", icon: "ArrowUpRight", key: Tn(["shift", "\\"]) }
    ], i = I(() => t.find((o) => o.id === e.ui.shapeKind) || t[0]);
    function s() {
      e.ui.addMenu = !1, e.ui.shapeMenu = !e.ui.shapeMenu;
    }
    return (o, r) => (g(), v("div", {
      class: U(["v2-shapetool", { on: m(e).ui.shapeArmed, "is-open": m(e).ui.shapeMenu }])
    }, [
      h("button", {
        class: "face cv-tool",
        "aria-label": "Shapes: " + i.value.label,
        "aria-haspopup": "menu",
        "aria-expanded": m(e).ui.shapeMenu,
        "data-testid": "shape-tool",
        onClick: s
      }, [
        C(R, {
          name: i.value.icon,
          size: 15
        }, null, 8, ["name"]),
        h("span", lL, [
          C(R, {
            name: "ChevronUp",
            size: 9,
            stroke: 2.5
          })
        ]),
        r[1] || (r[1] = h("span", { class: "tip" }, "Shapes", -1))
      ], 8, aL),
      m(e).ui.shapeMenu ? (g(), v("div", {
        key: 0,
        class: "v2-shapemenu",
        role: "menu",
        "data-testid": "shape-menu",
        onPointerdown: r[0] || (r[0] = Pe(() => {
        }, ["stop"]))
      }, [
        r[2] || (r[2] = h("div", { class: "hd" }, "Shapes", -1)),
        (g(), v(H, null, me(t, (a) => h("button", {
          key: a.id,
          class: U(["row", { on: a.id === m(e).ui.shapeKind }]),
          role: "menuitemradio",
          "aria-checked": m(e).ui.shapeArmed && a.id === m(e).ui.shapeKind,
          "data-testid": "shape-" + a.id,
          onClick: (l) => m(e).armShape(a.id)
        }, [
          h("span", cL, [
            a.id === m(e).ui.shapeKind ? (g(), Ce(R, {
              key: 0,
              name: "Check",
              size: 13
            })) : E("", !0)
          ]),
          C(R, {
            name: a.icon,
            size: 15
          }, null, 8, ["name"]),
          h("span", uL, A(a.label), 1),
          h("span", hL, A(a.key), 1)
        ], 10, dL)), 64))
      ], 32)) : E("", !0)
    ], 2));
  }
}), fL = { class: "cv-badge" }, mL = { class: "cv-badge is-lib" }, gL = /* @__PURE__ */ Re({
  __name: "PlaceMenu",
  emits: ["computer"],
  setup(n, { emit: e }) {
    const t = e, { board: i } = tt(), s = /* @__PURE__ */ K(null);
    function o() {
      i.ui.placeMenu = !1, t("computer");
    }
    function r() {
      i.openLibrary({ purpose: "place" });
    }
    function a(l) {
      const d = l.target;
      !s.value || !d || s.value.contains(d) || d.closest("[data-place-toggle]") || (i.ui.placeMenu = !1);
    }
    return ot(() => window.addEventListener("pointerdown", a, !0)), Ve(() => window.removeEventListener("pointerdown", a, !0)), (l, d) => (g(), v("div", {
      ref_key: "el",
      ref: s,
      class: "v2-placemenu",
      role: "menu",
      "aria-label": "Place images",
      "data-testid": "place-menu"
    }, [
      h("button", {
        class: "am-row",
        role: "menuitem",
        "data-testid": "place-computer",
        onClick: o
      }, [
        h("span", fL, [
          C(R, {
            name: "Upload",
            size: 15
          })
        ]),
        d[0] || (d[0] = h("span", { class: "am-main" }, [
          h("span", { class: "am-name" }, "From your computer"),
          h("span", { class: "am-sub" }, "Or drop images anywhere on the board")
        ], -1))
      ]),
      h("button", {
        class: "am-row",
        role: "menuitem",
        "data-testid": "place-library",
        onClick: r
      }, [
        h("span", mL, [
          C(R, {
            name: "Library",
            size: 15
          })
        ]),
        d[1] || (d[1] = h("span", { class: "am-main" }, [
          h("span", { class: "am-name" }, "From your Library"),
          h("span", { class: "am-sub" }, "Your generations, uploads and favorites")
        ], -1))
      ])
    ], 512));
  }
}), bL = ["aria-label", "data-testid"], vL = { class: "dp-card" }, yL = { class: "dp-media" }, xL = ["poster", "autoplay", "data-slide"], wL = ["src"], kL = ["src"], _L = ["src", "data-slide"], SL = { class: "dp-tag" }, TL = { class: "dp-body" }, ML = { class: "dp-foot" }, CL = {
  class: "dp-dots",
  role: "tablist",
  "aria-label": "Slides"
}, IL = ["aria-selected", "aria-label", "onClick"], AL = { class: "dp-cta" }, PL = 500, EL = 160, _m = 3400, Sm = 8e3, k6 = /* @__PURE__ */ Re({
  __name: "DemoPopout",
  props: {
    slides: {},
    media: {},
    tag: {},
    tagIcon: {},
    cta: {},
    placement: { default: "above" },
    disabled: { type: Boolean, default: !1 },
    testid: { default: "demo-popout" }
  },
  emits: ["open"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches, o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(0), a = /* @__PURE__ */ K(_m / 1e3), l = I(() => t.slides[r.value]);
    let d = 0, c = 0, u = 0;
    function p() {
      clearTimeout(c), !(o.value || t.disabled) && (clearTimeout(d), d = window.setTimeout(b, PL));
    }
    function f() {
      clearTimeout(d), clearTimeout(c), c = window.setTimeout(y, EL);
    }
    function y() {
      clearTimeout(d), clearTimeout(u), o.value = !1;
    }
    function b() {
      t.disabled || !t.slides.length || (k(), r.value = 0, o.value = !0, S());
    }
    let w = !1;
    function k() {
      if (!w) {
        w = !0;
        for (const z of t.slides) {
          const P = new Image();
          P.src = t.media + z.id + ".jpg";
        }
      }
    }
    function S() {
      if (clearTimeout(u), s) return;
      const z = l.value;
      a.value = (z.video ? Sm : _m) / 1e3, u = window.setTimeout(x, z.video ? Sm : _m);
    }
    function _(z) {
      r.value = (z + t.slides.length) % t.slides.length, S();
    }
    function x() {
      _(r.value + 1);
    }
    function T(z) {
      if (s) return;
      const P = z.target;
      Number.isFinite(P.duration) && P.duration > 0 && (a.value = Math.min(Sm / 1e3, P.duration + 0.6), clearTimeout(u), u = window.setTimeout(x, a.value * 1e3));
    }
    function M() {
      y(), i("open");
    }
    return $e(() => t.disabled, (z) => {
      z && y();
    }), Ve(() => {
      clearTimeout(d), clearTimeout(c), clearTimeout(u);
    }), (z, P) => (g(), v("span", {
      class: U(["dp-wrap", "is-" + n.placement]),
      onMouseenter: p,
      onMouseleave: f,
      onFocusin: p,
      onFocusout: f,
      onClick: y
    }, [
      Ws(z.$slots, "default", { open: o.value }),
      C(vt, { name: "dp-pop" }, {
        default: et(() => [
          o.value ? (g(), v("div", {
            key: 0,
            class: "dp-pop",
            role: "dialog",
            "aria-label": n.tag,
            "data-testid": n.testid,
            onClick: Pe(M, ["stop"])
          }, [
            h("div", vL, [
              h("div", yL, [
                C(vt, { name: "dp-slide" }, {
                  default: et(() => [
                    l.value.video ? (g(), v("video", {
                      key: l.value.id,
                      poster: n.media + l.value.id + ".jpg",
                      autoplay: !m(s),
                      muted: "",
                      playsinline: "",
                      preload: "auto",
                      disablepictureinpicture: "",
                      "data-slide": l.value.id,
                      onLoadedmetadata: T
                    }, [
                      h("source", {
                        src: n.media + l.value.id + ".webm",
                        type: "video/webm"
                      }, null, 8, wL),
                      h("source", {
                        src: n.media + l.value.id + ".mp4",
                        type: "video/mp4"
                      }, null, 8, kL)
                    ], 40, xL)) : (g(), v("img", {
                      key: l.value.id,
                      src: n.media + l.value.id + ".jpg",
                      alt: "",
                      "data-slide": l.value.id,
                      draggable: "false"
                    }, null, 8, _L))
                  ]),
                  _: 1
                }),
                h("span", SL, [
                  C(R, {
                    name: n.tagIcon,
                    size: 10
                  }, null, 8, ["name"]),
                  X(A(n.tag), 1)
                ])
              ]),
              h("div", TL, [
                C(vt, {
                  name: "dp-words",
                  mode: "out-in"
                }, {
                  default: et(() => [
                    (g(), v("div", {
                      key: l.value.id,
                      class: "dp-words"
                    }, [
                      h("b", null, A(l.value.title), 1),
                      h("span", null, A(l.value.text), 1)
                    ]))
                  ]),
                  _: 1
                }),
                h("div", ML, [
                  h("span", CL, [
                    (g(!0), v(H, null, me(n.slides, (D, $) => (g(), v("button", {
                      key: D.id,
                      role: "tab",
                      "aria-selected": $ === r.value,
                      "aria-label": D.title,
                      class: U({ on: $ === r.value }),
                      style: de($ === r.value ? { "--d": a.value + "s" } : void 0),
                      onClick: Pe((O) => _($), ["stop"])
                    }, [
                      (g(), v("i", {
                        key: r.value + ":" + $
                      }))
                    ], 14, IL))), 128))
                  ]),
                  h("span", AL, [
                    X(A(n.cta), 1),
                    C(R, {
                      name: "ChevronRight",
                      size: 12
                    })
                  ])
                ])
              ])
            ])
          ], 8, bL)) : E("", !0)
        ]),
        _: 1
      })
    ], 34));
  }
});
function Ep(n) {
  if (!n.detail) return;
  const e = n.target instanceof Element ? n.target.closest("button") : null;
  e && e === document.activeElement && e.blur();
}
const _6 = "/img/board/prompt-library/", S6 = [
  { id: "start", video: !0, title: "Start from a prompt", text: "Open the prompt library from the toolbar, or from Start from a prompt when you add a session." },
  { id: "browse", video: !0, title: "Browse by picture", text: "Pick a kind and a category on the left, or search. Hover a tile to see the images it starts from." },
  { id: "use", video: !0, title: "Use it, or remix it", text: "Use prompt puts the words in your session. Remix sets up the whole example, images included." },
  { id: "session", video: !1, title: "On every session", text: "The same icon sits beside every session's prompt. A prompt picked there goes straight into it." },
  { id: "save", video: !0, title: "Save your own", text: "Keep the prompt behind a result you like, just for you or shared with the people you work with." },
  { id: "kinds", video: !1, title: "Generate or edit", text: "Image and Video each split in two: Generate starts from words, Edit from your own image." }
], T6 = "rd-board-prompt-library-seen";
function RL() {
  try {
    return window.localStorage.getItem(T6) === "1";
  } catch {
    return !1;
  }
}
const vc = /* @__PURE__ */ K(typeof window != "undefined" && RL());
function zL() {
  if (!vc.value) {
    vc.value = !0;
    try {
      window.localStorage.setItem(T6, "1");
    } catch {
    }
  }
}
const $L = ["aria-expanded"], DL = {
  key: 0,
  class: "lib-new",
  "aria-hidden": "true"
}, OL = ["aria-label", "onClick"], LL = { class: "tip" }, BL = { class: "key" }, FL = { class: "v2-placewrap" }, NL = ["aria-expanded"], UL = {
  key: 0,
  class: "tip"
}, GL = ["aria-pressed"], jL = /* @__PURE__ */ Re({
  __name: "ToolRail",
  props: {
    away: { type: Boolean },
    onImage: { type: Function }
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = I(() => t.ui.library.open && !t.ui.library.sessionId);
    function s() {
      t.ui.addMenu = !1, t.ui.placeMenu = !1, t.promptLibrary.toggle(null);
    }
    const o = [
      { id: "select", icon: "MousePointer2", label: "Select", key: "V" },
      { id: "hand", icon: "Hand", label: "Pan", key: "H" }
    ];
    function r() {
      if (!t.hasLibrary) {
        e.onImage();
        return;
      }
      t.ui.addMenu = !1, t.ui.placeMenu = !t.ui.placeMenu;
    }
    return (a, l) => (g(), v("div", {
      class: U(["v2-railwrap", { "is-away": e.away }]),
      onPointerdown: l[7] || (l[7] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", {
        class: "v2-rail",
        "data-testid": "tool-rail",
        onClick: l[6] || (l[6] = //@ts-ignore
        (...d) => m(Ep) && m(Ep)(...d))
      }, [
        h("div", {
          class: U(["v2-addtool", { on: m(t).ui.addMenu }])
        }, [
          h("button", {
            class: "main",
            title: "Add an image generator",
            "data-testid": "image-gen",
            onClick: l[0] || (l[0] = (d) => m(t).addElement("image-gen"))
          }, [...l[8] || (l[8] = [
            Af('<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h7"></path><circle cx="8.5" cy="9.5" r="1.5"></circle><path d="m3 17 4.5-4.5a2 2 0 0 1 2.8 0L16 18"></path><path d="M18.5 2.5 19.6 5l2.5 1.1-2.5 1.1-1.1 2.5-1.1-2.5L14.9 6l2.5-1.1z"></path></svg><span>Image Gen</span>', 2)
          ])]),
          h("button", {
            class: "chev",
            title: "All tools",
            "aria-label": "All tools",
            "data-testid": "all-tools",
            onClick: l[1] || (l[1] = (d) => m(t).addElement("tool"))
          }, [
            C(R, {
              name: "ChevronDown",
              size: 13
            })
          ])
        ], 2),
        C(k6, {
          slides: m(S6),
          media: m(_6),
          tag: "Prompt library",
          "tag-icon": "LayoutTemplate",
          cta: "Open the prompt library",
          disabled: i.value,
          testid: "rail-prompts-demo",
          onOpen: s
        }, {
          default: et(() => [
            h("button", {
              class: U(["cv-tool v2-prompts", { on: i.value }]),
              "aria-label": "Start from a prompt",
              "aria-expanded": i.value,
              "data-testid": "rail-prompts",
              onClick: s
            }, [
              C(R, {
                name: "LayoutTemplate",
                size: 15
              }),
              m(vc) ? E("", !0) : (g(), v("span", DL))
            ], 10, $L)
          ]),
          _: 1
        }, 8, ["slides", "media", "disabled"]),
        l[13] || (l[13] = h("span", { class: "sep" }, null, -1)),
        (g(), v(H, null, me(o, (d) => h("button", {
          key: d.id,
          class: U(["cv-tool", { on: m(t).ui.mode === d.id && !m(t).ui.shapeArmed && !m(t).comments.ui.armed }]),
          "aria-label": d.label,
          onClick: (c) => m(t).setMode(d.id)
        }, [
          C(R, {
            name: d.icon,
            size: 15
          }, null, 8, ["name"]),
          h("span", LL, [
            X(A(d.label), 1),
            h("span", BL, A(d.key), 1)
          ])
        ], 10, OL)), 64)),
        l[14] || (l[14] = h("span", { class: "sep" }, null, -1)),
        h("span", FL, [
          h("button", {
            class: U(["cv-tool", { on: m(t).ui.placeMenu }]),
            "aria-label": "Place image",
            "aria-expanded": m(t).hasLibrary ? m(t).ui.placeMenu : void 0,
            "data-place-toggle": "",
            "data-testid": "place-image",
            onClick: r
          }, [
            C(R, {
              name: "Image",
              size: 15
            }),
            m(t).ui.placeMenu ? E("", !0) : (g(), v("span", UL, "Place image"))
          ], 10, NL),
          C(vt, { name: "v2-placemenu" }, {
            default: et(() => [
              m(t).ui.placeMenu ? (g(), Ce(gL, {
                key: 0,
                onComputer: l[2] || (l[2] = (d) => e.onImage())
              })) : E("", !0)
            ]),
            _: 1
          })
        ]),
        h("button", {
          class: "cv-tool",
          "aria-label": "Add note",
          onClick: l[3] || (l[3] = (d) => m(t).addElement("note"))
        }, [
          C(R, {
            name: "StickyNote",
            size: 15
          }),
          l[9] || (l[9] = h("span", { class: "tip" }, [
            X("Add note"),
            h("span", { class: "key" }, "N")
          ], -1))
        ]),
        h("button", {
          class: "cv-tool",
          "aria-label": "Add frame",
          onClick: l[4] || (l[4] = (d) => m(t).addElement("frame"))
        }, [
          C(R, {
            name: "Frame",
            size: 15
          }),
          l[10] || (l[10] = h("span", { class: "tip" }, [
            X("Add frame"),
            h("span", { class: "key" }, "F")
          ], -1))
        ]),
        C(pL),
        m(t).comments.enabled ? (g(), v(H, { key: 0 }, [
          l[12] || (l[12] = h("span", { class: "sep" }, null, -1)),
          h("button", {
            class: U(["cv-tool", { on: m(t).comments.ui.armed }]),
            "aria-label": "Comment",
            "aria-pressed": m(t).comments.ui.armed,
            "data-testid": "comment-tool",
            onClick: l[5] || (l[5] = (d) => m(t).comments.arm())
          }, [
            C(R, {
              name: "MessageCirclePlus",
              size: 15
            }),
            l[11] || (l[11] = h("span", { class: "tip" }, [
              X("Comment"),
              h("span", { class: "key" }, "C")
            ], -1))
          ], 10, GL)
        ], 64)) : E("", !0)
      ])
    ], 34));
  }
});
function d1(n) {
  const e = /^(.*\/o\/)([^?#]+)(\?[^#]*)?$/.exec(n || "");
  if (!e) return null;
  let t;
  try {
    t = decodeURIComponent(e[2]);
  } catch {
    return null;
  }
  if (!/^(runnitResults|runnitUploads)\//.test(t) || t.includes("/thumbs/")) return null;
  const i = t.lastIndexOf("/"), s = t.slice(0, i) + "/thumbs/" + t.slice(i + 1).replace(/\.[^/.]+$/, "_512x512.webp");
  return e[1] + encodeURIComponent(s) + (e[3] || "");
}
const Tm = /* @__PURE__ */ Xt(/* @__PURE__ */ new Map()), nw = /* @__PURE__ */ new Set();
function Wt(n) {
  const e = Tm.get(n);
  if (e) return e;
  const t = d1(n);
  if (!t) return n;
  if (!nw.has(n) && typeof Image != "undefined") {
    nw.add(n);
    const i = new Image();
    i.onload = () => Tm.set(n, t), i.onerror = () => Tm.set(n, n), i.src = t;
  }
  return t;
}
const Rf = [
  { id: "all", label: "All" },
  { id: "pinned", label: "Pinned" },
  { id: "image", label: "Image", match: /image/i },
  { id: "video", label: "Video", match: /video/i },
  { id: "threed", label: "3D", match: /3d/i },
  { id: "upscale", label: "Upscale", match: /upscale|enhance/i }
];
function M6(n, e, t, i) {
  const s = Rf.find((r) => r.id === e), o = t.trim().toLowerCase();
  return n.filter((r) => e === "pinned" && !i(r.id) || s && s.match && !s.match.test((r.kind || "") + " " + (r.name || "")) ? !1 : !o || ((r.kind || "") + " " + (r.name || "") + " " + (r.model || "")).toLowerCase().includes(o));
}
const HL = "start from a prompt prompts library featured saved my templates ideas";
function C6(n) {
  return n.trim().toLowerCase().split(/\s+/).filter(Boolean).every((e) => HL.includes(e));
}
function I6(n, e, t) {
  if (e === "pinned") return [];
  const i = Rf.find((o) => o.id === e), s = t.trim().toLowerCase();
  return n.filter((o) => i && i.match && !i.match.test(o.name) ? !1 : !s || (o.name + " " + o.desc + " " + o.models.map((r) => r.name).join(" ")).toLowerCase().includes(s));
}
const VL = { class: "rs-empty-body" }, WL = { class: "rs-empty-kinds" }, qL = ["tabindex"], KL = { class: "rs-head" }, YL = { class: "rs-count" }, XL = { class: "rs-tools" }, JL = { class: "v2-dock-search rs-search" }, ZL = ["tabindex"], QL = { class: "v2-dock-filters rs-filters" }, eB = ["tabindex", "onClick"], tB = ["data-ref-session", "title", "onClick"], nB = {
  key: 1,
  class: "busy"
}, iB = { class: "k" }, sB = {
  key: 2,
  class: "pin"
}, oB = { class: "rs-meta" }, rB = { class: "rs-name" }, aB = { class: "rs-sub" }, lB = { class: "kind" }, dB = {
  key: 0,
  class: "rs-n"
}, cB = ["title", "aria-label", "aria-pressed", "tabindex", "data-testid", "onClick"], uB = {
  key: 0,
  class: "rs-none"
}, hB = {
  key: 0,
  class: "rs-more"
}, iw = 4, Mm = 40, pB = /* @__PURE__ */ Re({
  __name: "RecentSessions",
  setup(n) {
    const { board: e } = tt(), t = /* @__PURE__ */ K(!1), i = /* @__PURE__ */ K(!1), s = /* @__PURE__ */ K(""), o = /* @__PURE__ */ K("all");
    let r = 0;
    const a = () => {
      clearTimeout(r), r = window.setTimeout(() => {
        t.value = !0;
      }, 90);
    }, l = () => {
      clearTimeout(r), !i.value && (r = window.setTimeout(() => {
        t.value = !1;
      }, 240));
    };
    Ve(() => clearTimeout(r));
    const d = I(() => (e.docRev.value, e.ui.recentIds.length, e.recentTools())), c = I(() => e.promptTool.value ? e.promptTool.value.id : null), u = I(() => t.value ? M6(d.value, o.value, s.value, (S) => e.isPinned(S)) : d.value), p = I(() => d.value.length - iw), f = /* @__PURE__ */ K(Mm), y = I(() => t.value ? u.value.slice(0, f.value) : u.value.slice(0, iw));
    $e([s, o, t], () => {
      f.value = Mm;
    });
    function b(S) {
      const _ = S.target;
      _.scrollTop + _.clientHeight > _.scrollHeight - 150 && f.value < u.value.length && (f.value += Mm);
    }
    function w(S) {
      S.stopPropagation(), S.key === "Escape" ? (s.value = "", S.target.blur(), t.value = !1) : S.key === "Enter" && u.value.length && e.openSession(u.value[0]);
    }
    function k() {
      e.openAddMenu(), t.value = !1;
    }
    return (S, _) => d.value.length ? (g(), v("div", {
      key: 1,
      class: U(["rs", { "is-open": t.value }]),
      "data-testid": "recent-sessions",
      onMouseenter: a,
      onMouseleave: l,
      onPointerdown: _[5] || (_[5] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", KL, [
        _[10] || (_[10] = h("span", { class: "rs-eyebrow" }, "Tool sessions", -1)),
        h("span", YL, A(d.value.length), 1)
      ]),
      h("div", XL, [
        h("div", JL, [
          C(R, {
            name: "Search",
            size: 13
          }),
          xt(h("input", {
            "onUpdate:modelValue": _[1] || (_[1] = (x) => s.value = x),
            type: "text",
            placeholder: "Search tool sessions",
            tabindex: t.value ? 0 : -1,
            onFocus: _[2] || (_[2] = (x) => i.value = !0),
            onBlur: _[3] || (_[3] = (x) => {
              i.value = !1, l();
            }),
            onKeydown: w
          }, null, 40, ZL), [
            [Jt, s.value]
          ]),
          s.value ? (g(), v("button", {
            key: 0,
            class: "cv-iconbtn",
            style: { width: "22px", height: "22px" },
            onClick: _[4] || (_[4] = (x) => s.value = "")
          }, [
            C(R, {
              name: "X",
              size: 11
            })
          ])) : E("", !0)
        ]),
        h("div", QL, [
          (g(!0), v(H, null, me(m(Rf), (x) => (g(), v("button", {
            key: x.id,
            class: U(["v2-fchip", { on: o.value === x.id }]),
            tabindex: t.value ? 0 : -1,
            onClick: (T) => o.value = x.id
          }, A(x.label), 11, eB))), 128))
        ])
      ]),
      h("div", {
        class: "rs-list",
        onScrollPassive: b
      }, [
        (g(!0), v(H, null, me(y.value, (x) => (g(), v("div", {
          key: x.id,
          class: U(["rs-item", { "is-pinned": m(e).isPinned(x.id) }])
        }, [
          h("button", {
            class: U(["rs-row", { on: x.id === c.value, "is-ref-target": m(e).ui.refSession === x.id }]),
            "data-ref-session": x.id,
            "data-ref-reveal": "",
            title: t.value ? void 0 : x.name,
            onClick: (T) => m(e).openSession(x)
          }, [
            h("span", {
              class: "rs-shot",
              style: de(x.thumbs && x.thumbs.length ? { backgroundImage: 'url("' + m(Wt)(x.thumbs[0]) + '")' } : void 0)
            }, [
              !x.thumbs || !x.thumbs.length ? (g(), Ce(R, {
                key: 0,
                name: x.icon,
                size: 15
              }, null, 8, ["name"])) : E("", !0),
              m(e).generating[x.id] ? (g(), v("span", nB)) : E("", !0),
              h("span", iB, [
                C(R, {
                  name: x.icon,
                  size: 9
                }, null, 8, ["name"])
              ]),
              m(e).isPinned(x.id) ? (g(), v("span", sB, [
                C(R, {
                  name: "Pin",
                  size: 8
                })
              ])) : E("", !0)
            ], 4),
            h("span", oB, [
              h("span", rB, A(x.name), 1),
              h("span", aB, [
                h("span", lB, A(x.kind), 1),
                x.model ? (g(), v(H, { key: 0 }, [
                  _[11] || (_[11] = h("span", { class: "sep" }, "·", -1)),
                  X(A(x.model), 1)
                ], 64)) : E("", !0)
              ])
            ]),
            x.count ? (g(), v("span", dB, A(x.count), 1)) : E("", !0)
          ], 10, tB),
          h("button", {
            class: U(["rs-pin", { on: m(e).isPinned(x.id) }]),
            title: m(e).isPinned(x.id) ? "Unpin" : "Pin to the top",
            "aria-label": (m(e).isPinned(x.id) ? "Unpin " : "Pin ") + x.name,
            "aria-pressed": m(e).isPinned(x.id),
            tabindex: t.value ? 0 : -1,
            "data-testid": "rs-pin-" + x.id,
            onClick: Pe((T) => m(e).togglePinned(x.id), ["stop"])
          }, [
            C(R, {
              name: "Pin",
              size: 12
            })
          ], 10, cB)
        ], 2))), 128)),
        t.value && !u.value.length ? (g(), v("div", uB, A(o.value === "pinned" && !s.value.trim() ? "Nothing pinned yet. Pin a session to keep it at the top." : "No tool sessions match"), 1)) : E("", !0)
      ], 32),
      !t.value && p.value > 0 ? (g(), v("span", hB, "+" + A(p.value), 1)) : E("", !0),
      _[12] || (_[12] = h("div", { class: "rs-pad" }, null, -1))
    ], 34)) : (g(), v("div", {
      key: 0,
      class: U(["rs rs-empty", { "is-open": t.value }]),
      "data-testid": "recent-sessions",
      onMouseenter: a,
      onMouseleave: l,
      onPointerdown: _[0] || (_[0] = Pe(() => {
      }, ["stop"]))
    }, [
      _[8] || (_[8] = h("div", { class: "rs-head" }, [
        h("span", { class: "rs-eyebrow" }, "Tool sessions"),
        h("span", { class: "rs-count" }, "0")
      ], -1)),
      h("div", VL, [
        h("button", {
          class: "rs-empty-slot",
          title: "Start a tool session",
          onClick: k
        }, [
          C(R, {
            name: "Plus",
            size: 16
          })
        ]),
        _[6] || (_[6] = h("span", { class: "rs-empty-txt" }, [
          h("span", { class: "t" }, "No tool sessions yet"),
          h("span", { class: "s" }, "Each generator you add to the board keeps its prompts and results here.")
        ], -1))
      ]),
      h("div", WL, [
        (g(), v(H, null, me([["Image", "Image"], ["Video", "Video"], ["Box", "3D"], ["Maximize2", "Upscale"]], (x) => h("span", {
          key: x[1],
          class: "rs-empty-kind"
        }, [
          C(R, {
            name: x[0],
            size: 12
          }, null, 8, ["name"]),
          X(A(x[1]), 1)
        ])), 64))
      ]),
      h("button", {
        class: "rs-empty-cta",
        tabindex: t.value ? 0 : -1,
        onClick: k
      }, [
        C(R, {
          name: "Plus",
          size: 13
        }),
        _[7] || (_[7] = X(" Start a tool session", -1))
      ], 8, qL),
      _[9] || (_[9] = h("div", { class: "rs-pad" }, null, -1))
    ], 34));
  }
});
function ls(n) {
  return n.models.find((e) => e.id === n.defaultModelId) || n.models[0] || null;
}
function Rp(n, e, t = [], i = []) {
  const s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  for (const a of e)
    for (const l of a.models)
      s.set(l.id, l), o.has(l.name) || o.set(l.name, l);
  for (const a of t)
    s.has(a.id) || (s.set(a.id, a), o.has(a.name) || o.set(a.name, a));
  const r = [...s.values()].sort((a, l) => a.name.localeCompare(l.name, void 0, { numeric: !0, sensitivity: "base" }));
  return { source: n, kits: e, all: r, byId: s, byName: o, tools: i };
}
function Ya(n) {
  return n === "imageEdit" ? "image" : n === "videoEdit" ? "video" : n || "";
}
function zp(n, e, t) {
  const i = Ya(e.id);
  let s = !1;
  for (const o of n.kits)
    if (o.models.some((r) => r.id === t.id)) {
      if (Ya(o.id) === i) return !0;
      s = !0;
    }
  return !s && Ya(t.kitId) === i;
}
function ev(n, e, t) {
  const i = t && n.kits.find((s) => s.id === t) || null;
  return i && zp(n, i, e) ? i : n.kits.find((s) => s.models.some((o) => o.id === e.id)) || n.kits.find((s) => s.id === e.kitId) || n.kits.find((s) => Ya(s.id) === Ya(e.kitId)) || null;
}
const fB = { class: "am-view fwd" }, mB = { class: "am-searchrow" }, gB = { class: "am-search" }, bB = { class: "am-rows" }, vB = {
  key: 0,
  class: "am-eyebrow"
}, yB = ["onMouseenter", "onClick"], xB = { class: "cv-badge" }, wB = { class: "am-main" }, kB = { class: "am-name" }, _B = { class: "am-sub" }, SB = { class: "am-go" }, TB = { class: "cv-badge is-prompts" }, MB = { class: "am-go" }, CB = {
  key: 2,
  class: "am-none"
}, IB = /* @__PURE__ */ Re({
  __name: "AddToolMenu",
  setup(n) {
    const { board: e } = tt(), t = /* @__PURE__ */ K(""), i = /* @__PURE__ */ K(0), s = /* @__PURE__ */ K(null), o = I(() => I6(e.catalog.value.kits, "all", t.value)), r = I(() => C6(t.value)), a = I(() => o.value.length + (r.value ? 1 : 0));
    $e(t, () => {
      i.value = 0;
    }), ot(() => {
      s.value && s.value.focus({ preventScroll: !0 });
    });
    function l(u) {
      if (u === o.value.length && r.value) {
        d();
        return;
      }
      const p = o.value[u];
      if (!p) return;
      const f = ls(p);
      f && e.pickModel(p, f);
    }
    function d() {
      e.ui.addMenu = !1, e.promptLibrary.open(null);
    }
    function c(u) {
      u.key === "Escape" ? (u.stopPropagation(), t.value ? t.value = "" : e.ui.addMenu = !1) : u.key === "ArrowDown" ? (u.preventDefault(), i.value = Math.min(a.value - 1, i.value + 1)) : u.key === "ArrowUp" ? (u.preventDefault(), i.value = Math.max(0, i.value - 1)) : u.key === "Enter" && (u.preventDefault(), l(i.value));
    }
    return (u, p) => (g(), v("div", {
      class: "cv-addmenu at-rail",
      "data-testid": "add-menu",
      onPointerdown: p[4] || (p[4] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", fB, [
        h("div", mB, [
          h("div", gB, [
            C(R, {
              name: "Search",
              size: 13
            }),
            xt(h("input", {
              ref_key: "inputEl",
              ref: s,
              "onUpdate:modelValue": p[0] || (p[0] = (f) => t.value = f),
              type: "text",
              placeholder: "Search generators",
              onKeydown: c
            }, null, 544), [
              [Jt, t.value]
            ]),
            t.value ? (g(), v("button", {
              key: 0,
              class: "cv-iconbtn",
              style: { width: "22px", height: "22px" },
              title: "Clear",
              onClick: p[1] || (p[1] = (f) => t.value = "")
            }, [
              C(R, {
                name: "X",
                size: 11
              })
            ])) : E("", !0)
          ]),
          h("button", {
            class: "am-close",
            title: "Close",
            onClick: p[2] || (p[2] = (f) => m(e).ui.addMenu = !1)
          }, [
            C(R, {
              name: "X",
              size: 14
            })
          ])
        ]),
        h("div", bB, [
          o.value.length ? (g(), v("div", vB, "New tool session")) : E("", !0),
          (g(!0), v(H, null, me(o.value, (f, y) => (g(), v("button", {
            key: f.id,
            class: U(["am-row", { "is-active": i.value === y }]),
            onMouseenter: (b) => i.value = y,
            onClick: (b) => l(y)
          }, [
            h("span", xB, [
              C(R, {
                name: f.icon,
                size: 15
              }, null, 8, ["name"])
            ]),
            h("span", wB, [
              h("div", kB, A(f.name), 1),
              h("div", _B, A(f.desc), 1)
            ]),
            h("span", SB, [
              C(R, {
                name: "Plus",
                size: 13
              })
            ])
          ], 42, yB))), 128)),
          r.value ? (g(), v(H, { key: 1 }, [
            h("div", {
              class: U(["am-eyebrow", { "is-apart": o.value.length }])
            }, "Start from a prompt", 2),
            h("button", {
              class: U(["am-row", { "is-active": i.value === o.value.length }]),
              "data-testid": "add-menu-prompts",
              onMouseenter: p[3] || (p[3] = (f) => i.value = o.value.length),
              onClick: d
            }, [
              h("span", TB, [
                C(R, {
                  name: "LayoutTemplate",
                  size: 15
                })
              ]),
              p[5] || (p[5] = h("span", { class: "am-main" }, [
                h("div", { class: "am-name" }, "Prompt library"),
                h("div", { class: "am-sub" }, "Featured prompts and your saved ones")
              ], -1)),
              h("span", MB, [
                C(R, {
                  name: "ChevronRight",
                  size: 14
                })
              ])
            ], 34)
          ], 64)) : E("", !0),
          a.value ? E("", !0) : (g(), v("div", CB, "Nothing matches “" + A(t.value.trim()) + "”", 1))
        ])
      ])
    ], 32));
  }
}), ra = 2, Ts = 10, tv = 52;
function AB(n, e, t) {
  let i = n.x + ra, s = !1;
  i + e.w > t.w - Ts && (n.x - ra - e.w >= Ts ? (i = n.x - ra - e.w, s = !0) : i = Math.max(Ts, t.w - Ts - e.w));
  let o = n.y + ra, r = !1;
  return o + e.h > t.h - Ts && (n.y - ra - e.h >= tv + Ts ? (o = n.y - ra - e.h, r = !0) : o = Math.max(tv + Ts, t.h - Ts - e.h)), { left: i, top: o, up: r, leftward: s };
}
function PB(n, e) {
  return Math.max(160, Math.min(e, n - tv - Ts * 2));
}
function A6(n, e, t, i = {}) {
  const s = (o) => {
    const r = o.target;
    n.value && r && n.value.contains(r) || t();
  };
  ot(() => {
    const o = n.value;
    if (!o) return;
    const a = (o.offsetParent || document.body).getBoundingClientRect(), l = { w: a.width, h: a.height }, d = e();
    i.maxH && (o.style.maxHeight = PB(l.h, i.maxH) + "px");
    const c = AB({ x: d.x - a.left, y: d.y - a.top }, { w: o.offsetWidth, h: o.offsetHeight }, l);
    o.style.left = c.left + "px", o.style.top = c.top + "px", i.fixHeight && (o.style.height = o.offsetHeight + "px"), o.style.setProperty("--pm-origin", (c.up ? "bottom" : "top") + " " + (c.leftward ? "right" : "left")), window.addEventListener("pointerdown", s, !0), i.keepOnResize || window.addEventListener("resize", t);
  }), Ve(() => {
    window.removeEventListener("pointerdown", s, !0), window.removeEventListener("resize", t);
  });
}
function EB(n, e, t, i, s) {
  const o = t + i;
  if (!o || n < 0 || n >= o) return 0;
  const r = n < t, a = Math.floor((t - 1) / s) * s;
  return e === "ArrowRight" ? r ? Math.min(t - 1, n + 1) : n : e === "ArrowLeft" ? r ? Math.max(0, n - 1) : n : e === "ArrowDown" ? r ? n < a ? Math.min(t - 1, n + s) : i ? t : n : Math.min(o - 1, n + 1) : r ? n >= s ? n - s : n : n === t ? t ? a : n : n - 1;
}
const RB = {
  key: 0,
  class: "bd-pm-eyebrow"
}, zB = ["data-testid", "onClick"], $B = { class: "bd-pm-ic" }, DB = { class: "lbl" }, OB = {
  class: "bd-pm-add",
  "aria-hidden": "true"
}, LB = {
  key: 1,
  class: "bd-pm-sep",
  role: "separator"
}, BB = { class: "bd-pm-ic is-prompts" }, FB = ["data-testid", "onClick"], NB = { class: "bd-pm-ic is-plain" }, UB = { class: "lbl" }, GB = { key: 0 }, jB = /* @__PURE__ */ Re({
  __name: "CanvasMenu",
  props: {
    menu: {},
    onImage: { type: Function }
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = /* @__PURE__ */ K(null), s = I(() => t.catalog.value.kits.filter((p) => ls(p)).map((p) => ({
      id: "kit-" + p.id,
      icon: p.icon,
      label: p.name,
      run: () => {
        const f = ls(p);
        f && t.pickModel(p, f, e.menu.at);
      }
    }))), o = {
      rect: { label: "Rectangle", icon: "Square", key: "M" },
      ellipse: { label: "Ellipse", icon: "Circle", key: "L" },
      line: { label: "Line", icon: "Slash", key: "\\" },
      arrow: { label: "Arrow", icon: "ArrowUpRight", key: "" }
    }, r = I(() => o[t.ui.shapeKind] || o.rect), a = I(() => {
      const p = e.menu.at, f = [
        { id: "note", icon: "StickyNote", label: "Sticky note", key: "N", plain: !0, run: () => t.addElement("note", p) },
        { id: "frame", icon: "Frame", label: "Frame", key: "F", plain: !0, run: () => t.addElement("frame", p) },
        { id: "shape", icon: r.value.icon, label: r.value.label, key: r.value.key, plain: !0, run: () => {
          l(), t.addShape(p);
        } }
      ];
      if (e.onImage) {
        const y = e.onImage;
        f.push({ id: "image", icon: "ImagePlus", label: "Image from computer", plain: !0, run: () => {
          l(), y(p);
        } });
      }
      return t.hasLibrary && f.push({ id: "library", icon: "Library", label: "Image from Library", plain: !0, run: () => {
        l(), t.openLibrary({ purpose: "place", at: p });
      } }), f;
    }), l = () => {
      t.ui.canvasMenu = null;
    };
    A6(i, () => e.menu, l);
    function d() {
      const p = e.menu.at;
      l(), t.promptLibrary.open(null, { at: p });
    }
    ot(() => {
      i.value && i.value.focus({ preventScroll: !0 });
    });
    function c() {
      return i.value ? Array.from(i.value.querySelectorAll(".bd-pm-row")) : [];
    }
    function u(p) {
      const f = p.key;
      if (f === "ArrowDown" || f === "ArrowUp" || f === "Home" || f === "End") {
        p.preventDefault(), p.stopPropagation();
        const y = c(), b = y.indexOf(document.activeElement), w = f === "Home" ? 0 : f === "End" ? y.length - 1 : b < 0 ? f === "ArrowDown" ? 0 : y.length - 1 : (b + (f === "ArrowDown" ? 1 : -1) + y.length) % y.length;
        y[w] && y[w].focus();
      } else if (f === "Escape")
        p.preventDefault(), p.stopPropagation(), l();
      else if (!p.metaKey && !p.ctrlKey && !p.altKey && (f === "n" || f === "N" || f === "f" || f === "F")) {
        p.preventDefault(), p.stopPropagation();
        const y = a.value.find((b) => b.id === (f.toLowerCase() === "n" ? "note" : "frame"));
        y && y.run();
      } else f === "Tab" ? p.preventDefault() : f === "Enter" || f === " " ? p.stopPropagation() : f !== "Shift" && f !== "Meta" && f !== "Control" && f !== "Alt" && l();
    }
    return (p, f) => (g(), v("div", {
      ref_key: "el",
      ref: i,
      class: "bd-pointmenu bd-canvasmenu",
      role: "menu",
      "aria-label": "Add to the board here",
      tabindex: "-1",
      "data-testid": "canvas-menu",
      onKeydown: u,
      onPointerdown: f[3] || (f[3] = Pe(() => {
      }, ["stop"])),
      onContextmenu: f[4] || (f[4] = Pe(() => {
      }, ["prevent"]))
    }, [
      s.value.length ? (g(), v("div", RB, "New tool session")) : E("", !0),
      (g(!0), v(H, null, me(s.value, (y) => (g(), v("button", {
        key: y.id,
        class: "bd-pm-row",
        role: "menuitem",
        tabindex: "-1",
        "data-testid": "canvas-menu-" + y.id,
        onMouseenter: f[0] || (f[0] = (b) => b.currentTarget.focus({ preventScroll: !0 })),
        onClick: (b) => y.run()
      }, [
        h("span", $B, [
          C(R, {
            name: y.icon,
            size: 13
          }, null, 8, ["name"])
        ]),
        h("span", DB, A(y.label), 1),
        h("span", OB, [
          C(R, {
            name: "Plus",
            size: 12
          })
        ])
      ], 40, zB))), 128)),
      s.value.length ? (g(), v("div", LB)) : E("", !0),
      f[6] || (f[6] = h("div", { class: "bd-pm-eyebrow" }, "Start from a prompt", -1)),
      h("button", {
        class: "bd-pm-row",
        role: "menuitem",
        tabindex: "-1",
        "data-testid": "canvas-menu-prompts",
        onMouseenter: f[1] || (f[1] = (y) => y.currentTarget.focus({ preventScroll: !0 })),
        onClick: d
      }, [
        h("span", BB, [
          C(R, {
            name: "LayoutTemplate",
            size: 13
          })
        ]),
        f[5] || (f[5] = h("span", { class: "lbl" }, "Prompt library", -1))
      ], 32),
      f[7] || (f[7] = h("div", {
        class: "bd-pm-sep",
        role: "separator"
      }, null, -1)),
      (g(!0), v(H, null, me(a.value, (y) => (g(), v("button", {
        key: y.id,
        class: "bd-pm-row",
        role: "menuitem",
        tabindex: "-1",
        "data-testid": "canvas-menu-" + y.id,
        onMouseenter: f[2] || (f[2] = (b) => b.currentTarget.focus({ preventScroll: !0 })),
        onClick: (b) => y.run()
      }, [
        h("span", NB, [
          C(R, {
            name: y.icon,
            size: 13
          }, null, 8, ["name"])
        ]),
        h("span", UB, A(y.label), 1),
        y.key ? (g(), v("kbd", GB, A(y.key), 1)) : E("", !0)
      ], 40, FB))), 128))
    ], 544));
  }
}), HB = { class: "am-searchrow sf-searchrow" }, VB = { class: "am-search" }, WB = { class: "v2-dock-filters sf-filters" }, qB = ["onClick"], KB = { class: "sf-kits" }, YB = ["data-i", "title", "aria-label", "data-testid", "onMousemove", "onClick"], XB = { class: "bd-pm-ic sf-kit-ic" }, JB = {
  class: "sf-add",
  "aria-hidden": "true"
}, ZB = { class: "nm" }, QB = ["data-i"], eF = { class: "bd-pm-ic is-prompts" }, tF = { class: "sf-eyebrow" }, nF = { class: "n" }, iF = ["data-i", "data-testid", "onMousemove", "onClick"], sF = {
  key: 1,
  class: "busy"
}, oF = { class: "k" }, rF = { class: "sf-meta" }, aF = { class: "rs-name" }, lF = { class: "rs-sub" }, dF = { class: "kind" }, cF = {
  key: 0,
  class: "sf-n"
}, uF = ["title", "aria-label", "aria-pressed", "onClick"], hF = {
  key: 3,
  class: "sf-none"
}, pF = { class: "sf-foot" }, fF = { key: 0 }, mF = 3, pu = 40, gF = /* @__PURE__ */ Re({
  __name: "SessionFinder",
  props: {
    menu: {}
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = dn(["enter"])[0], a = /* @__PURE__ */ K(""), l = /* @__PURE__ */ K("all"), d = /* @__PURE__ */ K(0), c = I(() => I6(t.catalog.value.kits.filter((D) => ls(D)), l.value, a.value)), u = I(() => (t.docRev.value, t.ui.recentIds.length, t.ui.pinnedIds.length, t.recentTools())), p = I(() => M6(u.value, l.value, a.value, (D) => t.isPinned(D))), f = /* @__PURE__ */ K(pu), y = I(() => p.value.slice(0, f.value));
    function b(D) {
      const $ = D.target;
      $.scrollTop + $.clientHeight > $.scrollHeight - 150 && f.value < p.value.length && (f.value += pu);
    }
    $e([a, l], () => {
      d.value = 0, f.value = pu, s.value && (s.value.scrollTop = 0);
    });
    const w = I(() => ["all", "image", "video"].includes(l.value) && C6(a.value)), k = I(() => c.value.length + (w.value ? 1 : 0)), S = I(() => d.value < k.value), _ = I(() => !k.value && !p.value.length), x = () => {
      t.ui.finder = null;
    };
    A6(i, () => e.menu, x, { maxH: 500, fixHeight: !0, keepOnResize: !0 }), ot(() => {
      o.value && o.value.focus({ preventScroll: !0 });
    });
    function T() {
      const D = e.menu.at, $ = l.value === "image" || l.value === "video" ? l.value : null;
      x(), t.promptLibrary.open(null, { at: D, kind: $ });
    }
    function M(D) {
      const $ = c.value.length;
      if (D < $) {
        const L = c.value[D], Z = ls(L);
        Z && t.pickModel(L, Z, e.menu.at);
        return;
      }
      if (D === $ && w.value) {
        T();
        return;
      }
      const O = p.value[D - k.value];
      O && (x(), t.openSession(O));
    }
    async function z() {
      await it();
      const D = s.value && s.value.querySelector('[data-i="' + d.value + '"]');
      D && D.scrollIntoView({ block: "nearest" });
    }
    function P(D) {
      D.stopPropagation();
      const $ = D.key, O = k.value;
      if ($ === "Escape")
        D.preventDefault(), a.value ? a.value = "" : x();
      else if ($ === "ArrowDown" || $ === "ArrowUp" || ($ === "ArrowLeft" || $ === "ArrowRight") && S.value && O > 0) {
        D.preventDefault();
        const L = EB(d.value, $, O, p.value.length, mF);
        L - O >= f.value && (f.value += pu), d.value = L, z();
      } else $ === "Enter" && (D.preventDefault(), M(d.value));
    }
    return (D, $) => (g(), v("div", {
      ref_key: "el",
      ref: i,
      class: "bd-pointmenu bd-finder",
      role: "dialog",
      "aria-label": "Find or start a tool session",
      "data-testid": "session-finder",
      onPointerdown: $[10] || ($[10] = Pe(() => {
      }, ["stop"])),
      onContextmenu: $[11] || ($[11] = Pe(() => {
      }, ["prevent"]))
    }, [
      h("div", HB, [
        h("div", VB, [
          C(R, {
            name: "Search",
            size: 13
          }),
          xt(h("input", {
            ref_key: "inputEl",
            ref: o,
            "onUpdate:modelValue": $[0] || ($[0] = (O) => a.value = O),
            type: "text",
            placeholder: "Search sessions and generators",
            "aria-label": "Search sessions and generators",
            "data-testid": "session-finder-search",
            onKeydown: P
          }, null, 544), [
            [Jt, a.value]
          ]),
          a.value ? (g(), v("button", {
            key: 0,
            class: "cv-iconbtn",
            style: { width: "22px", height: "22px" },
            title: "Clear",
            onMousedown: $[1] || ($[1] = Pe(() => {
            }, ["prevent"])),
            onClick: $[2] || ($[2] = (O) => a.value = "")
          }, [
            C(R, {
              name: "X",
              size: 11
            })
          ], 32)) : E("", !0)
        ]),
        h("button", {
          class: "am-close",
          title: "Close",
          onClick: x
        }, [
          C(R, {
            name: "X",
            size: 14
          })
        ])
      ]),
      h("div", WB, [
        (g(!0), v(H, null, me(m(Rf), (O) => (g(), v("button", {
          key: O.id,
          class: U(["v2-fchip", { on: l.value === O.id }]),
          onMousedown: $[3] || ($[3] = Pe(() => {
          }, ["prevent"])),
          onClick: (L) => l.value = O.id
        }, A(O.label), 43, qB))), 128))
      ]),
      h("div", {
        ref_key: "body",
        ref: s,
        class: "sf-body",
        onScrollPassive: b
      }, [
        c.value.length ? (g(), v(H, { key: 0 }, [
          $[12] || ($[12] = h("div", { class: "sf-eyebrow" }, "New tool session", -1)),
          h("div", KB, [
            (g(!0), v(H, null, me(c.value, (O, L) => (g(), v("button", {
              key: O.id,
              class: U(["sf-kit", { "is-active": d.value === L }]),
              "data-i": L,
              title: O.desc,
              "aria-label": "New " + O.name + " session",
              "data-testid": "finder-kit-" + O.id,
              onMousemove: (Z) => d.value = L,
              onMousedown: $[4] || ($[4] = Pe(() => {
              }, ["prevent"])),
              onClick: (Z) => M(L)
            }, [
              h("span", XB, [
                C(R, {
                  name: O.icon,
                  size: 13
                }, null, 8, ["name"]),
                h("span", JB, [
                  C(R, {
                    name: "Plus",
                    size: 9
                  })
                ])
              ]),
              h("span", ZB, A(O.name), 1)
            ], 42, YB))), 128))
          ])
        ], 64)) : E("", !0),
        w.value ? (g(), v(H, { key: 1 }, [
          $[15] || ($[15] = h("div", { class: "sf-eyebrow" }, "Start from a prompt", -1)),
          h("button", {
            class: U(["sf-prompts", { "is-active": d.value === c.value.length }]),
            "data-i": c.value.length,
            title: "Featured prompts and your saved ones",
            "data-testid": "finder-prompts",
            onMousemove: $[5] || ($[5] = (O) => d.value = c.value.length),
            onMousedown: $[6] || ($[6] = Pe(() => {
            }, ["prevent"])),
            onClick: $[7] || ($[7] = (O) => M(c.value.length))
          }, [
            h("span", eF, [
              C(R, {
                name: "LayoutTemplate",
                size: 13
              })
            ]),
            $[13] || ($[13] = h("span", { class: "nm" }, "Prompt library", -1)),
            $[14] || ($[14] = h("span", { class: "sub" }, "Featured prompts and your saved ones", -1))
          ], 42, QB)
        ], 64)) : E("", !0),
        p.value.length ? (g(), v(H, { key: 2 }, [
          h("div", tF, [
            $[16] || ($[16] = X("Tool sessions", -1)),
            h("span", nF, A(p.value.length), 1)
          ]),
          (g(!0), v(H, null, me(y.value, (O, L) => (g(), v("div", {
            key: O.id,
            class: U(["sf-item", { "is-active": d.value === k.value + L, "is-pinned": m(t).isPinned(O.id) }])
          }, [
            h("button", {
              class: "sf-row",
              "data-i": k.value + L,
              "data-testid": "finder-session-" + O.id,
              onMousemove: (Z) => d.value = k.value + L,
              onMousedown: $[8] || ($[8] = Pe(() => {
              }, ["prevent"])),
              onClick: (Z) => M(k.value + L)
            }, [
              h("span", {
                class: "rs-shot",
                style: de(O.thumbs && O.thumbs.length ? { backgroundImage: 'url("' + m(Wt)(O.thumbs[0]) + '")' } : void 0)
              }, [
                !O.thumbs || !O.thumbs.length ? (g(), Ce(R, {
                  key: 0,
                  name: O.icon,
                  size: 15
                }, null, 8, ["name"])) : E("", !0),
                m(t).generating[O.id] ? (g(), v("span", sF)) : E("", !0),
                h("span", oF, [
                  C(R, {
                    name: O.icon,
                    size: 9
                  }, null, 8, ["name"])
                ])
              ], 4),
              h("span", rF, [
                h("span", aF, A(O.name), 1),
                h("span", lF, [
                  h("span", dF, A(O.kind), 1),
                  O.model ? (g(), v(H, { key: 0 }, [
                    $[17] || ($[17] = h("span", { class: "sep" }, "·", -1)),
                    X(A(O.model), 1)
                  ], 64)) : E("", !0)
                ])
              ]),
              O.count ? (g(), v("span", cF, A(O.count), 1)) : E("", !0)
            ], 40, iF),
            h("button", {
              class: U(["sf-pin", { on: m(t).isPinned(O.id) }]),
              title: m(t).isPinned(O.id) ? "Unpin" : "Pin to the top",
              "aria-label": (m(t).isPinned(O.id) ? "Unpin " : "Pin ") + O.name,
              "aria-pressed": m(t).isPinned(O.id),
              tabindex: "-1",
              onMousedown: $[9] || ($[9] = Pe(() => {
              }, ["prevent"])),
              onClick: Pe((Z) => m(t).togglePinned(O.id), ["stop"])
            }, [
              C(R, {
                name: "Pin",
                size: 12
              })
            ], 42, uF)
          ], 2))), 128))
        ], 64)) : E("", !0),
        _.value ? (g(), v("div", hF, A(a.value.trim() ? "Nothing matches “" + a.value.trim() + "”" : l.value === "pinned" ? "Nothing pinned yet. Pin a session to keep it at the top." : "No tool sessions match"), 1)) : E("", !0)
      ], 544),
      h("div", pF, [
        $[18] || ($[18] = h("span", null, [
          h("kbd", null, "↑"),
          h("kbd", null, "↓"),
          X("Move")
        ], -1)),
        _.value ? E("", !0) : (g(), v("span", fF, [
          h("kbd", null, A(m(r)), 1),
          X(A(S.value ? "Start here" : "Open"), 1)
        ])),
        $[19] || ($[19] = h("span", null, [
          h("kbd", null, "Esc"),
          X("Close")
        ], -1))
      ])
    ], 544));
  }
});
function qd(n) {
  return !!n && n.type === "frame" && !!n.locked;
}
const bF = [
  { id: "amethyst", label: "Amethyst" },
  { id: "vista", label: "Vista" },
  { id: "sky", label: "Sky" },
  { id: "mint", label: "Mint" },
  { id: "amber", label: "Amber" },
  { id: "rose", label: "Rose" },
  { id: "glass", label: "Glass" }
], Tt = { w: 252, h: 160 };
function qe(n) {
  if (n.type === "tool") {
    const e = n.scale || 1;
    return { x: n.x, y: n.y, w: Math.round(Tt.w * e), h: Math.round(Tt.h * e) };
  }
  return { x: n.x, y: n.y, w: n.w, h: n.h };
}
function Id(n, e) {
  return n.x < e.x + e.w && n.x + n.w > e.x && n.y < e.y + e.h && n.y + n.h > e.y;
}
function P6(n) {
  if (!n.length) return null;
  let e = 1 / 0, t = 1 / 0, i = -1 / 0, s = -1 / 0;
  for (const o of n)
    o.x < e && (e = o.x), o.y < t && (t = o.y), o.x + o.w > i && (i = o.x + o.w), o.y + o.h > s && (s = o.y + o.h);
  return { x: e, y: t, w: i - e, h: s - t };
}
const nv = {
  frame: "frames",
  image: "content",
  shape: "annotations",
  note: "annotations",
  tool: "annotations",
  chat: "annotations",
  // never in the store (studio/records.ts); named so the table stays whole
  studio: "annotations"
}, Ua = { w: 252, h: 160 }, vF = 0.01, yF = 4;
function No(n) {
  return Number.isFinite(n) ? Math.min(yF, Math.max(vF, n)) : 1;
}
function iv(n, e, t) {
  return { x: (e - n.x) / n.zoom, y: (t - n.y) / n.zoom };
}
function sv(n, e, t, i) {
  const s = No(n.zoom * i), o = s / n.zoom;
  return { zoom: s, x: e - (e - n.x) * o, y: t - (t - n.y) * o };
}
function xF(n, e) {
  const t = No(n * e), i = 5e-3;
  return n < 1 - i && t > 1 || n > 1 + i && t < 1 ? 1 : t;
}
function zf(n, e, t, i = 120, s = 1) {
  const o = Math.max(1, n.w), r = Math.max(1, n.h), a = No(Math.min(s, (e - i * 2) / o, (t - i * 2) / r));
  return {
    zoom: a,
    x: (e - o * a) / 2 - n.x * a,
    y: (t - r * a) / 2 - n.y * a
  };
}
function Ga(n, e, t, i, s) {
  const o = No(t);
  return { zoom: o, x: i / 2 - n * o, y: s / 2 - e * o };
}
function Xa(n, e, t, i = 0) {
  const s = i / n.zoom;
  return {
    x: -n.x / n.zoom - s,
    y: -n.y / n.zoom - s,
    w: e / n.zoom + s * 2,
    h: t / n.zoom + s * 2
  };
}
function Cm(n) {
  return wF(0.16, 1, 0.3, 1, n);
}
function wF(n, e, t, i, s) {
  let o = s;
  for (let r = 0; r < 6; r++) {
    const a = sw(n, t, o) - s, l = kF(n, t, o);
    if (Math.abs(a) < 1e-5 || Math.abs(l) < 1e-6) break;
    o -= a / l;
  }
  return o = Math.min(1, Math.max(0, o)), sw(e, i, o);
}
function sw(n, e, t) {
  return ((1 - 3 * e + 3 * n) * t + (3 * e - 6 * n)) * t * t + 3 * n * t;
}
function kF(n, e, t) {
  return 3 * (1 - 3 * e + 3 * n) * t * t + 2 * (3 * e - 6 * n) * t + 3 * n;
}
function _F(n, e, t, i, s) {
  const o = iv(n, i / 2, s / 2), r = iv(e, i / 2, s / 2), a = Math.exp(Math.log(n.zoom) + (Math.log(e.zoom) - Math.log(n.zoom)) * t), l = o.x + (r.x - o.x) * t, d = o.y + (r.y - o.y) * t;
  return { zoom: a, x: i / 2 - l * a, y: s / 2 - d * a };
}
const ql = 188, fu = 124, ow = 28, SF = /* @__PURE__ */ Re({
  __name: "Minimap",
  setup(n) {
    const { board: e } = tt(), t = /* @__PURE__ */ K(null), i = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(!1), o = /* @__PURE__ */ We(null);
    let r = 0;
    function a() {
      !e.engine || e.view.w < 2 || e.view.h < 2 || (o.value = Xa(e.cam.value, e.view.w, e.view.h, 0));
    }
    $e(() => e.cam.value, () => {
      if (!o.value) {
        a();
        return;
      }
      clearTimeout(r), r = window.setTimeout(a, 240);
    }, { immediate: !0 });
    const l = I(() => {
      e.docRev.value;
      const S = e.store.bounds(), _ = o.value;
      let x = S || _ || { x: 0, y: 0, w: 1200, h: 800 };
      if (S && _) {
        const O = Math.min(S.x, _.x), L = Math.min(S.y, _.y);
        x = { x: O, y: L, w: Math.max(S.x + S.w, _.x + _.w) - O, h: Math.max(S.y + S.h, _.y + _.h) - L };
      }
      const T = Math.max(80, Math.max(x.w, x.h) * 0.06), M = x.x - T, z = x.y - T, P = x.w + T * 2, D = x.h + T * 2, $ = Math.min(ql / P, fu / D);
      return { bx: M, by: z, k: $, ox: (ql - P * $) / 2, oy: (fu - D * $) / 2 };
    }), d = I(() => {
      const S = l.value, _ = e.cam.value, x = -_.x / _.zoom, T = -_.y / _.zoom;
      return {
        left: (x - S.bx) * S.k + S.ox,
        top: (T - S.by) * S.k + S.oy,
        width: e.view.w / _.zoom * S.k,
        height: e.view.h / _.zoom * S.k
      };
    });
    let c = 0, u = 0;
    function p() {
      if (c) return;
      const S = Math.max(0, 90 - (performance.now() - u));
      c = window.setTimeout(() => {
        c = 0, u = performance.now(), f();
      }, S);
    }
    function f() {
      const S = t.value;
      if (!S) return;
      const _ = Math.min(2, window.devicePixelRatio || 1);
      S.width !== ql * _ && (S.width = ql * _, S.height = fu * _);
      const x = S.getContext("2d");
      if (!x) return;
      x.setTransform(_, 0, 0, _, 0, 0), x.clearRect(0, 0, ql, fu);
      const T = l.value, M = e.ui.lightCanvas, z = [];
      for (const P of e.store.all()) {
        const D = qe(P), $ = (D.x - T.bx) * T.k + T.ox, O = (D.y - T.by) * T.k + T.oy, L = Math.max(2, D.w * T.k), Z = Math.max(2, D.h * T.k), J = P.type === "frame" ? 0 : P.type === "image" ? 1 : 2;
        z.push([J, () => {
          P.type === "frame" ? (x.fillStyle = M ? "rgba(19,24,40,0.05)" : "rgba(255,255,255,0.08)", x.fillRect($, O, L, Z), x.strokeStyle = M ? "rgba(19,24,40,0.16)" : "rgba(255,255,255,0.14)", x.lineWidth = 1, x.strokeRect($ + 0.5, O + 0.5, L - 1, Z - 1)) : P.type === "shape" ? (x.strokeStyle = P.stroke || (M ? "rgba(19,24,40,0.35)" : "rgba(255,255,255,0.3)"), x.lineWidth = 1, x.strokeRect($ + 0.5, O + 0.5, Math.max(1, L - 1), Math.max(1, Z - 1))) : (x.fillStyle = P.type === "tool" ? "rgba(153,104,223,0.65)" : P.type === "chat" ? "rgba(194,164,236,0.8)" : P.type === "note" ? "rgba(163,167,245,0.55)" : M ? "rgba(19,24,40,0.28)" : "rgba(255,255,255,0.30)", x.fillRect($, O, L, Z));
        }]);
      }
      z.sort((P, D) => P[0] - D[0]);
      for (const P of z) P[1]();
    }
    $e(() => e.docRev.value, p), $e(() => e.ui.lightCanvas, p), $e(l, p), ot(() => {
      a(), f();
    }), Ve(() => {
      clearTimeout(c), clearTimeout(r);
    });
    function y(S) {
      const _ = i.value;
      if (!_) return;
      const x = _.getBoundingClientRect(), T = l.value, M = (S.clientX - x.left - T.ox) / T.k + T.bx, z = (S.clientY - x.top - T.oy) / T.k + T.by, P = e.cam.value;
      e.setCamera({ zoom: P.zoom, x: e.view.w / 2 - M * P.zoom, y: e.view.h / 2 - z * P.zoom });
    }
    function b(S) {
      e.ui.miniGoing || (s.value = !0, S.currentTarget.setPointerCapture(S.pointerId), y(S));
    }
    function w() {
      const S = i.value, _ = S && S.parentElement ? S.parentElement.querySelector(".cv-zoomhud") : null;
      if (!S || !_) {
        e.ui.miniOpen = !1;
        return;
      }
      const x = S.getBoundingClientRect(), T = _.getBoundingClientRect(), M = T.right - 5 - ow / 2 - (x.left + x.width / 2), z = T.top + T.height / 2 - (x.top + x.height / 2);
      e.ui.miniGoing = !0, S.classList.add("is-going"), S.offsetWidth, S.style.transform = "translate(" + M + "px, " + z + "px) scale(" + (ow / x.width).toFixed(3) + ")", S.style.opacity = "0", S.style.borderRadius = "40px";
    }
    function k(S) {
      e.ui.miniGoing && S.propertyName === "transform" && (e.ui.miniOpen = !1, e.ui.miniGoing = !1);
    }
    return (S, _) => (g(), v("div", {
      ref_key: "self",
      ref: i,
      class: "cv-minimap",
      "data-testid": "minimap",
      onTransitionend: k,
      onPointerdown: Pe(b, ["stop"]),
      onPointermove: _[1] || (_[1] = (x) => s.value && y(x)),
      onPointerup: _[2] || (_[2] = (x) => s.value = !1),
      onPointercancel: _[3] || (_[3] = (x) => s.value = !1)
    }, [
      h("canvas", {
        ref_key: "canvas",
        ref: t
      }, null, 512),
      h("button", {
        class: "mm-hide",
        title: "Hide minimap",
        onPointerdown: _[0] || (_[0] = Pe(() => {
        }, ["stop"])),
        onClick: Pe(w, ["stop"])
      }, [
        C(R, {
          name: "Minus",
          size: 12
        })
      ], 32),
      h("span", {
        class: "mm-view",
        style: de({ left: d.value.left + "px", top: d.value.top + "px", width: d.value.width + "px", height: d.value.height + "px" })
      }, null, 4)
    ], 544));
  }
}), TF = ["title", "aria-label"], MF = ["disabled"], CF = /* @__PURE__ */ Re({
  __name: "ZoomHud",
  setup(n) {
    const { board: e } = tt(), t = I(() => Math.round(e.cam.value.zoom * 100) + "%");
    return (i, s) => (g(), v("div", {
      class: "cv-zoomhud",
      "data-testid": "zoom-hud",
      onPointerdown: s[6] || (s[6] = Pe(() => {
      }, ["stop"])),
      onClick: s[7] || (s[7] = //@ts-ignore
      (...o) => m(Ep) && m(Ep)(...o))
    }, [
      h("button", {
        title: "Zoom out",
        "aria-label": "Zoom out",
        onClick: s[0] || (s[0] = (o) => m(e).zoomBy(1 / 1.25))
      }, [
        C(R, {
          name: "Minus",
          size: 14
        })
      ]),
      h("button", {
        class: "pct",
        title: "Reset to 100%",
        "data-testid": "zoom-pct",
        onClick: s[1] || (s[1] = (o) => m(e).zoomTo(1))
      }, A(t.value), 1),
      h("button", {
        title: "Zoom in",
        "aria-label": "Zoom in",
        onClick: s[2] || (s[2] = (o) => m(e).zoomBy(1.25))
      }, [
        C(R, {
          name: "Plus",
          size: 14
        })
      ]),
      h("button", {
        title: "Fit to content",
        "aria-label": "Fit to content",
        onClick: s[3] || (s[3] = (o) => m(e).fit())
      }, [
        C(R, {
          name: "Scan",
          size: 14
        })
      ]),
      s[9] || (s[9] = h("span", { class: "sep" }, null, -1)),
      h("button", {
        title: m(e).ui.lightCanvas ? "Dark canvas" : "Light canvas",
        "aria-label": m(e).ui.lightCanvas ? "Dark canvas" : "Light canvas",
        "data-testid": "light-toggle",
        onClick: s[4] || (s[4] = (o) => m(e).ui.lightCanvas = !m(e).ui.lightCanvas)
      }, [
        C(R, {
          name: m(e).ui.lightCanvas ? "Moon" : "Sun",
          size: 14
        }, null, 8, ["name"])
      ], 8, TF),
      !m(e).ui.miniOpen || m(e).ui.miniGoing ? (g(), v(H, { key: 0 }, [
        s[8] || (s[8] = h("span", { class: "sep" }, null, -1)),
        h("button", {
          class: U(["mm-slot", { "is-landing": m(e).ui.miniGoing }]),
          disabled: m(e).ui.miniGoing,
          title: "Show minimap",
          "aria-label": "Show minimap",
          onClick: s[5] || (s[5] = (o) => m(e).ui.miniOpen = !0)
        }, [
          C(R, {
            name: "Map",
            size: 14
          })
        ], 10, MF)
      ], 64)) : E("", !0)
    ], 32));
  }
}), qs = { stroke: "#9968df", sw: 3 };
function $f(n) {
  const e = Math.max(0, n.w), t = Math.max(0, n.h), i = n.sc || [0, 0];
  return { x1: i[0] * e, y1: i[1] * t, x2: (1 - i[0]) * e, y2: (1 - i[1]) * t };
}
function E6(n) {
  const { x1: e, y1: t, x2: i, y2: s } = $f(n), o = n.sw == null ? qs.sw : n.sw, r = Math.atan2(s - t, i - e), a = Math.max(11, o * 3.6), l = 0.44;
  return [
    [i - a * Math.cos(r - l), s - a * Math.sin(r - l)],
    [i, s],
    [i - a * Math.cos(r + l), s - a * Math.sin(r + l)]
  ];
}
function IF(n) {
  return /^#[0-9a-f]{6}$/i.test(n) ? parseInt(n.slice(1), 16) : /^#[0-9a-f]{3}$/i.test(n) ? parseInt(n.slice(1).split("").map((e) => e + e).join(""), 16) : 10053855;
}
function rw(n, e) {
  const t = Math.max(0, e.w), i = Math.max(0, e.h), s = e.sw == null ? qs.sw : e.sw, o = IF(e.stroke || qs.stroke), r = { width: s, color: o, cap: "round", join: "round" };
  if (n.clear(), e.shape === "rect")
    n.roundRect(0, 0, t, i, Math.min(10, t / 8, i / 8)), n.stroke(r);
  else if (e.shape === "ellipse")
    n.ellipse(t / 2, i / 2, Math.max(0.01, t / 2), Math.max(0.01, i / 2)), n.stroke(r);
  else {
    const { x1: a, y1: l, x2: d, y2: c } = $f(e);
    if (n.moveTo(a, l), n.lineTo(d, c), n.stroke(r), e.shape === "arrow") {
      const u = E6(e);
      n.moveTo(u[0][0], u[0][1]), n.lineTo(u[1][0], u[1][1]), n.lineTo(u[2][0], u[2][1]), n.stroke(r);
    }
  }
}
function Im(n, e, t, i, s, o) {
  const r = s - t, a = o - i, l = r * r + a * a;
  let d = l ? ((n - t) * r + (e - i) * a) / l : 0;
  d = Math.max(0, Math.min(1, d));
  const c = t + d * r, u = i + d * a;
  return Math.hypot(n - c, e - u);
}
function AF(n, e, t, i) {
  const s = e - n.x, o = t - n.y, r = Math.max(0, n.w), a = Math.max(0, n.h);
  if (n.shape === "rect") {
    const p = s >= -i && o >= -i && s <= r + i && o <= a + i, f = s > i && o > i && s < r - i && o < a - i;
    return p && !f;
  }
  if (n.shape === "ellipse") {
    const p = Math.max(0.01, r / 2), f = Math.max(0.01, a / 2), y = s - p, b = o - f, w = y * y / (p * p) + b * b / (f * f) - 1, k = 2 * y / (p * p), S = 2 * b / (f * f), _ = Math.hypot(k, S);
    return _ ? Math.abs(w) / _ <= i : Math.min(p, f) <= i;
  }
  const { x1: l, y1: d, x2: c, y2: u } = $f(n);
  if (Im(s, o, l, d, c, u) <= i) return !0;
  if (n.shape === "arrow") {
    const p = E6(n);
    if (Im(s, o, p[0][0], p[0][1], p[1][0], p[1][1]) <= i || Im(s, o, p[1][0], p[1][1], p[2][0], p[2][1]) <= i) return !0;
  }
  return !1;
}
const jn = {
  /** a pin control, off */
  pin: "Pin for yourself (only you see your pins)",
  /** a pin control, on */
  unpin: "Unpin",
  /** the badge on a pinned picture */
  badge: "Pinned by you (only you see it)",
  /** the toast on your first pin, once */
  first: "Pinned for you. Only you see your pins: find them under Pinned in the board's history."
};
function Df(n) {
  return {
    url: n.url,
    w: n.w,
    h: n.h,
    label: n.label || n.prompt || "Result",
    asset: n.asset || null,
    resultId: n.id,
    sessionId: n.sessionId,
    video: !!n.video,
    videoSrc: n.videoSrc || null,
    dur: n.dur || null
  };
}
function R6(n, e) {
  if (e && e.url === n.src) return Df(e);
  const t = Pl(n.asset);
  return {
    url: n.src,
    w: t ? t.width : n.w,
    h: t ? t.height : n.h,
    label: n.label || "Image",
    asset: n.asset || null,
    resultId: n.resultId || null,
    sessionId: n.sessionId || null,
    video: !!n.video,
    videoSrc: n.videoSrc || null,
    dur: n.dur || null
  };
}
function PF(n) {
  return {
    url: n.url,
    w: n.w || 4,
    h: n.h || 3,
    label: n.label || "Image",
    asset: n.asset || null,
    video: !!n.video,
    videoSrc: n.video && n.videoSrc || null
  };
}
const EF = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function kt() {
  const n = new Uint8Array(20);
  crypto.getRandomValues(n);
  let e = "";
  for (let t = 0; t < 20; t++) e += EF[n[t] % 62];
  return e;
}
var RF = Object.defineProperty, zF = (n, e, t) => e in n ? RF(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, mu = (n, e, t) => zF(n, typeof e != "symbol" ? e + "" : e, t);
function $F(n, e = 30) {
  const t = /^(\d+(?:\.\d+)?)\s*(s|m)$/.exec((n || "").trim());
  return t ? Math.round(Number(t[1]) * (t[2] === "m" ? 60 : 1)) : e;
}
function pl(n) {
  return String(n || "").toLowerCase().replace(/[^a-z0-9.\s]+/g, " ").replace(/\s+/g, " ").trim();
}
function DF(n) {
  return n.fields.find((e) => e.placement === "reference" && (e.kind === "image" || e.kind === "images")) || null;
}
class z6 {
  constructor(e, t = !1) {
    mu(this, "catalog", e), mu(this, "isAdmin", t), mu(this, "list", []), mu(this, "byIdMap", /* @__PURE__ */ new Map());
    for (const i of e.kits)
      for (const s of i.models) {
        const o = this.byIdMap.get(s.id);
        if (o) {
          o.kits.push(i);
          continue;
        }
        const r = DF(s), a = {
          id: s.id,
          name: s.name,
          desc: s.desc,
          model: s,
          kits: [i],
          imageField: r,
          maxImages: r ? r.kind === "images" ? Math.max(1, r.maxImages || 4) : 1 : 0,
          needsImage: !!r && !!r.required,
          secs: $F(s.time)
        };
        this.byIdMap.set(s.id, a), this.list.push(a);
      }
  }
  entries() {
    return this.list;
  }
  get(e) {
    return this.byIdMap.get(e) || null;
  }
  /** It's on this board's tool list. */
  has(e) {
    return this.byIdMap.has(e);
  }
  /**
   * Tools whose names match what someone typed: every word they typed starts
   * a word of the name ("chatgpt image 2.5" finds both ChatGPT Image 2.5
   * tools, "flux 3" finds Flux 3 Image). Exact names first, then shorter ones.
   */
  search(e) {
    const t = pl(e);
    if (!t) return [];
    const i = t.split(" "), s = [];
    for (const o of this.list) {
      const r = pl(o.name);
      if (r === t) {
        s.push({ e: o, score: 0 });
        continue;
      }
      const a = r.split(" ");
      i.every((d) => a.some((c) => c.startsWith(d))) && s.push({ e: o, score: 1 + a.length - i.length });
    }
    return s.sort((o, r) => o.score - r.score || o.e.name.localeCompare(r.e.name)).map((o) => o.e);
  }
  /** The kit a job wants it in: an edit in Image Edit, a new picture in Image, else its first. */
  kitFor(e, t) {
    const i = t === "edit" ? ["imageEdit", "image"] : ["image", "imageEdit"];
    for (const s of i) {
      const o = e.kits.find((r) => r.id === s);
      if (o) return o;
    }
    return e.kits[0];
  }
  /** What `runs` runs of `n` results cost with this prompt state, in tokens (the price rules v1's Run button uses); null when it has none. */
  price(e, t, i, s = 1) {
    const o = Li(e.model, t, i, this.isAdmin).price;
    return o == null ? null : o * s / 100;
  }
  /** Why a run of this prompt state couldn't go (a required field, a bad value); empty when it can. */
  problems(e, t, i) {
    return Li(e.model, t, i, this.isAdmin).problems;
  }
  /** The results a run makes: n clamped to what the tool allows. */
  results(e, t) {
    const i = e.model.numResults;
    return Math.max(i.min, Math.min(i.max, Math.round(t) || i.def || 1));
  }
  /** A field by its label ("Quality"), any case. */
  field(e, t) {
    const i = t.trim().toLowerCase();
    return e.model.fields.find((s) => (s.label || "").trim().toLowerCase() === i) || null;
  }
  /** The size option nearest an image's shape, in the size tier the tool starts at. */
  sizeFor(e, t, i) {
    const s = e.model.fields.find((w) => w.kind === "size" && w.options && w.options.length);
    if (!s || !s.options || !t || !i) return null;
    const o = (w) => {
      const k = w;
      return k && k.width && k.height ? k.width * k.height : 0;
    }, r = (w) => {
      const k = w;
      return k && k.width && k.height ? k.width / k.height : 1;
    }, a = s.defaultValue != null ? s.defaultValue : s.options[0].value, l = s.options.find((w) => mn(w.value) === mn(a)), d = l ? (/^(\d+(?:\.\d+)?K)\b/i.exec(l.label) || [])[1] : void 0, c = o(a), u = d ? s.options.filter((w) => w.label.toUpperCase().startsWith(d.toUpperCase() + " ")) : [], p = s.options.filter((w) => c && Math.abs(o(w.value) - c) / c < 0.34), f = u.length ? u : p.length ? p : s.options, y = Math.log(t / i);
    let b = f[0];
    for (const w of f) Math.abs(Math.log(r(w.value)) - y) < Math.abs(Math.log(r(b.value)) - y) && (b = w);
    return { field: s, value: b.value, label: b.label };
  }
  /** An option of a select field by its value or its label, any case; null when it has no such option. */
  option(e, t) {
    const i = e.options || [], s = mn(t).toLowerCase(), o = i.find((r) => mn(r.value).toLowerCase() === s || r.label.toLowerCase() === s);
    return o ? { value: o.value, label: o.label } : null;
  }
}
function Am(n) {
  return {
    get: (e) => n.store.get(e),
    childrenOf: (e) => n.childrenOf(e),
    framesIn: (e) => n.store.query(qe(e)).filter((t) => {
      if (t.type !== "frame" || t.id === e.id) return !1;
      const i = t.x + t.w / 2, s = t.y + t.h / 2;
      return i > e.x && i < e.x + e.w && s > e.y && s < e.y + e.h;
    }),
    promptOf: (e) => n.promptOf(e),
    result: (e) => n.results.get(e),
    modelOf: (e) => n.modelFor(e).model,
    generating: (e) => !!n.generating[e]
  };
}
function OF(n) {
  const e = (t) => {
    const i = n.ui.selection.slice(), s = t();
    return n.ui.selection = i.filter((o) => !!n.store.get(o)), s;
  };
  return {
    element: (t) => n.store.get(t),
    contents: (t) => n.childrenOf(t).map((i) => n.store.get(i)).filter(Boolean).map((i) => qe(i)),
    modelOf: (t, i) => {
      const s = n.catalog.value, o = s.kits.find((a) => a.id === t && a.models.some((l) => l.id === i)) || s.kits.find((a) => a.models.some((l) => l.id === i)), r = o ? o.models.find((a) => a.id === i) : null;
      return o && r ? { kit: o, model: r } : null;
    },
    imageFields: (t) => {
      const i = n.store.get(t);
      if (!i || i.type !== "tool") return [];
      const { model: s } = n.modelFor(i);
      return s ? s.fields.filter((o) => o.placement === "reference" && (o.kind === "image" || o.kind === "images")) : [];
    },
    assetOf: (t, i) => {
      const s = n.store.get(t);
      return s && s.type === "image" && s.asset || n.assetFor(i);
    },
    promptOf: (t) => n.promptOf(t),
    // a second "Night versions" in the frame is "Night versions 2", as the board names a copy
    addSession: (t, i, s, o) => n.addSession(t, i, n.uniqueSessionName(s), o, { quiet: !0 }),
    move: (t, i, s) => n.patch(t, { x: i, y: s }, "Move"),
    resizeFrame: (t, i) => n.patch(t, { x: i.x, y: i.y, w: i.w, h: i.h }, "Resize frame"),
    setPrompt: (t, i) => n.setPrompt(t, i),
    setRefInput: (t, i, s, o) => n.setRefInput(t, i, s, o),
    generate: (t) => n.generate(t),
    submitting: (t) => n.submitting(t),
    generating: (t) => !!n.generating[t],
    error: (t) => {
      const i = n.store.get(t);
      return i && i.type === "tool" && i.error || null;
    },
    results: (t) => n.results.list(t),
    place: (t, i) => e(() => n.placeImages([{
      url: t.url,
      w: i.w,
      h: i.h,
      x: i.x,
      y: i.y,
      label: t.label || "result",
      resultId: t.id,
      sessionId: t.sessionId,
      video: t.video,
      dur: t.dur,
      videoSrc: t.videoSrc,
      previewSrc: t.previewSrc,
      asset: t.asset,
      download: t.download,
      kind: t.kind
    }], { x: i.x + i.w / 2, y: i.y + i.h / 2 })[0] || null),
    wait: (t) => new Promise((i) => window.setTimeout(i, t))
  };
}
function Kl(n) {
  const e = n.slice().sort((i, s) => i.y - s.y || i.x - s.x), t = [];
  for (; e.length; ) {
    const i = e[0], s = i.y + i.h / 2, o = e.filter((r) => r.y <= s && r.y + r.h >= s).sort((r, a) => r.x - a.x);
    for (const r of o) e.splice(e.indexOf(r), 1);
    t.push(...o);
  }
  return t;
}
function LF(n) {
  return !!n && n.fields.some((e) => e.placement === "reference" && (e.kind === "image" || e.kind === "images"));
}
const Pm = (n) => ({ x: n.x + n.w / 2, y: n.y + n.h / 2 }), Em = (n, e, t = 0) => n.x > e.x - t && n.x < e.x + e.w + t && n.y > e.y - t && n.y < e.y + e.h + t, to = (n) => n.w * n.h, BF = 4, FF = 32, NF = /* @__PURE__ */ new Set(["select", "size", "boolean", "slider", "text", "seed"]);
function c1(n, e) {
  const t = n.replace(/\s+/g, " ").trim();
  return t.length > e ? t.slice(0, e - 1) + "…" : t;
}
function UF(n, e) {
  if (e == null || e === "") return null;
  if (n.options && n.options.length) {
    const t = n.options.find((i) => mn(i.value) === mn(e));
    return t ? t.label : null;
  }
  return n.kind === "boolean" ? e ? "on" : "off" : typeof e == "number" ? String(e) : typeof e == "string" ? c1(e, 80) : null;
}
function GF(n, e) {
  if (!n) return [];
  const t = [], i = e.inputs || {};
  for (const s of n.fields) {
    const o = Object.prototype.hasOwnProperty.call(i, s.key) ? i[s.key] : void 0;
    if (s.kind === "negPrompt") {
      typeof o == "string" && o.trim() && t.push({ label: s.label || "Negative prompt", value: c1(o, 200) });
      continue;
    }
    if (!NF.has(s.kind) || s.placement === "reference" || s.placement === "prompt") continue;
    const r = o !== void 0 && mn(o) !== mn(s.defaultValue);
    if (s.placement !== "chip" && !r) continue;
    const a = UF(s, o !== void 0 ? o : s.defaultValue);
    a != null && t.push({ label: s.label, value: a });
  }
  return t;
}
function jF(n, e) {
  const t = [];
  e.ref && t.push(e.ref);
  for (const i of n && n.fields || []) {
    if (i.placement !== "reference" || i.kind !== "image" && i.kind !== "images") continue;
    const s = e.inputs ? e.inputs[i.key] : void 0;
    if (typeof s == "string" && s) t.push(s);
    else if (Array.isArray(s))
      for (const o of s) typeof o == "string" && o && t.push(o);
  }
  return Array.from(new Set(t));
}
function HF(n, e) {
  const t = e.w / 2, i = e.h / 2;
  if (t <= 0 || i <= 0) return !1;
  const s = (n.x - (e.x + t)) / t, o = (n.y - (e.y + i)) / i;
  return s * s + o * o <= 1;
}
function Rm(n, e, t) {
  const i = [], s = [], o = [], r = [], a = [];
  let l = 0;
  for (const M of n.childrenOf(e)) {
    if (M === t) continue;
    const z = n.get(M);
    z && (z.type === "image" ? i.push(z) : z.type === "tool" ? s.push(z) : z.type === "note" ? o.push(z) : z.type === "shape" ? r.push(z) : z.type === "chat" ? a.push(z.name || "Chat") : l++);
  }
  const d = qe(e), c = n.framesIn(e).filter((M) => M.id !== e.id && to(qe(M)) < to(d)).sort((M, z) => to(qe(M)) - to(qe(z))), u = Kl(c.map((M) => ({ ...qe(M), g: M }))).map(({ g: M }) => ({ id: M.id, title: (M.title || "").trim() || "Untitled frame", members: [] })), p = (M) => {
    const z = Pm(M), P = c.find((D) => Em(z, qe(D)));
    return P && u.find((D) => D.id === P.id) || null;
  }, f = (M, z) => {
    const P = p(z);
    if (P)
      return P.members.push(M), P.title;
  }, y = /* @__PURE__ */ new Map();
  for (const M of i) {
    y.set(M.src, M.id);
    for (const z of Object.values(M.tiers || {})) y.has(z) || y.set(z, M.id);
  }
  const b = Kl(i).map((M) => {
    const z = M.resultId ? n.result(M.resultId) : void 0, P = !z && M.sessionId ? n.get(M.sessionId) : void 0, D = { id: M.id, url: M.src, w: M.w, h: M.h, hasAsset: !!M.asset };
    M.label && M.label !== "placed_image" && (D.label = M.label), M.video ? D.video = !0 : (M.kind === "3d" || M.kind === "layers") && (D.kind = M.kind), M.fav && (D.fav = !0), M.sessionId && (D.sessionId = M.sessionId), z ? (z.prompt && (D.prompt = z.prompt), z.model && (D.model = z.model), z.modelId && (D.modelId = z.modelId)) : P && P.type === "tool" && (D.model = P.model);
    const $ = f(M.id, qe(M));
    return $ && (D.group = $), D;
  }), w = Kl(s.map((M) => ({ ...M, ...qe(M) }))).map((M) => {
    const z = n.modelOf(M), P = n.promptOf(M.id), D = [];
    let $ = 0;
    for (const Z of jF(z, P)) {
      const J = y.get(Z);
      J ? D.push(J) : $++;
    }
    const O = {
      id: M.id,
      name: M.name,
      kind: M.kind,
      kitId: M.kitId,
      model: z && z.name || M.model,
      nodeDefId: z && z.id || M.nodeDefId,
      prompt: (P.prompt || "").trim(),
      n: P.n || (z ? z.numResults.def : 1) || 1,
      results: M.count || 0,
      takesImages: LF(z),
      generating: n.generating(M.id),
      settings: GF(z, P),
      inputs: D,
      otherInputs: $,
      thumbs: (M.thumbs || []).filter(Boolean).slice(0, BF)
    };
    M.error && (O.error = c1(String(M.error), 200));
    const L = f(M.id, qe(M));
    return L && (O.group = L), O;
  }), k = Kl(o).filter((M) => !!(M.text || "").trim()).map((M) => {
    const z = { id: M.id, text: (M.text || "").trim() };
    M.author && (z.author = M.author), M.tint && M.tint !== "glass" && (z.tint = M.tint);
    const P = f(M.id, qe(M));
    return P && (z.group = P), z;
  }), S = [
    ...i.map((M) => ({ id: M.id, rect: qe(M) })),
    ...s.map((M) => ({ id: M.id, rect: qe(M) })),
    ...o.filter((M) => !!(M.text || "").trim()).map((M) => ({ id: M.id, rect: qe(M) })),
    ...c.map((M) => ({ id: M.id, rect: qe(M) }))
  ], _ = (M) => {
    let z = null;
    for (const P of S)
      Em(M, P.rect, FF) && (!z || to(P.rect) < to(z.rect)) && (z = P);
    return z ? z.id : null;
  }, x = [], T = [];
  for (const M of Kl(r)) {
    if (M.shape === "line" || M.shape === "arrow") {
      const D = $f(M), $ = _({ x: M.x + D.x1, y: M.y + D.y1 }), O = _({ x: M.x + D.x2, y: M.y + D.y2 });
      !$ && !O ? l++ : x.push({ id: M.id, kind: M.shape, from: $, to: O });
      continue;
    }
    const z = qe(M), P = S.filter((D) => to(D.rect) < to(z) && (M.shape === "ellipse" ? HF(Pm(D.rect), z) : Em(Pm(D.rect), z))).map((D) => D.id);
    P.length ? T.push({ id: M.id, kind: M.shape === "ellipse" ? "ellipse" : "rect", around: P }) : l++;
  }
  return {
    frameId: e.id,
    title: e.title || "Untitled frame",
    rect: d,
    images: b,
    sessions: w,
    notes: k,
    groups: u,
    links: x,
    marks: T,
    chats: a,
    ignored: l
  };
}
function zm(n, e, t = e + "s") {
  return n + " " + (n === 1 ? e : t);
}
function $6(n) {
  return n.images.length + n.sessions.length + n.notes.length;
}
function D6(n) {
  const e = [];
  return n.images.length && e.push(zm(n.images.length, "image")), n.sessions.length && e.push(zm(n.sessions.length, "session")), n.notes.length && e.push(zm(n.notes.length, "note")), e.length ? e.join(", ") : "Empty";
}
function VF(n) {
  return n ? n.images.length ? "Ask about " + (n.images.length === 1 ? "this image" : "these " + n.images.length + " images") + "…" : n.sessions.length ? "Ask about " + (n.sessions.length === 1 ? "this session" : "these " + n.sessions.length + " sessions") + "…" : "What should we build here?" : "Move this chat into a frame to give it something to work with";
}
function WF(n, e) {
  const t = qe(e), i = t.x + t.w / 2, s = t.y + t.h / 2;
  let o = null;
  for (const r of n)
    i > r.x && i < r.x + r.w && s > r.y && s < r.y + r.h && (!o || r.w * r.h < o.w * o.h || r.w * r.h === o.w * o.h && r.z > o.z) && (o = r);
  return o;
}
const qF = "draft", KF = "Draft guidance: placeholder recommendations that RunDiffusion will tune", nt = {
  flare: { id: "50XKlkMz7r9kmipyspRQ", name: "ChatGPT Image 2.5 Flare" },
  sunburst: { id: "s9ShIto8LPgdOSImFC39", name: "ChatGPT Image 2.5 Sunburst" },
  nb2: { id: "6BJyvazKHGTilS1yWk76", name: "Nano Banana 2" },
  nbPro: { id: "eILT27MJkTwxnVSPQP2x", name: "Nano Banana Pro" },
  nb2Lite: { id: "VpkLvmqERLkoU2vBNTJ7" },
  nb1: { id: "umNAyCPJkWXmSrTUevOM" },
  flux3: { id: "JcDKjRIyFolGJVEOIgya", name: "Flux 3 Image" },
  flux2Max: { id: "vMzpgBA14pAFuBgU8yby", name: "Flux 2 Max" },
  kontextPro: { id: "bKkjGeP6wjLsl1314ybn", name: "Flux Kontext Pro" },
  seedream5: { id: "B9nbLi2HgM7XHeaBoOJD", name: "Seedream V5 Pro" },
  seedream45: { id: "sI3TYrxuB8l4st8KXHSH" },
  rdPhoto: { id: "4Qsc76pSm5HKYRMnClef", name: "RunDiffusion Photo FLUX" },
  zTurbo: { id: "cnedcdG4HabkoZGBu1Fs", name: "Z Image Turbo" },
  juggLightning: { id: "2t5JQGvAIiSr669KYnVq", name: "Juggernaut Lightning Flux" },
  klein4b: { id: "UNuq3Ia9Wlos2DWSFrlv", name: "Flux 2 Klein 4B" },
  ideoEdit: { id: "uW9DvVweUX4OoA3n8Brt" },
  ideoReframe: { id: "F4QfdOqv9ehwMR4Z0qNW" },
  layers: { id: "px6klFXH0N11egFiDoVB", name: "Image-to-Layers" },
  wanPro: { id: "seBwSSKFPpNZMYycG7i5" }
}, YF = {
  status: qF,
  jobs: {
    compare: {
      id: "compare",
      label: "Comparing one prompt across tools",
      intro: "For a fair comparison, use strong all-rounders that take a prompt on its own and finish in about the same time.",
      suggest: 3,
      picks: [
        { ...nt.flare, why: "follows long, detailed prompts closely and lights scenes naturally" },
        { ...nt.nb2, why: "photoreal materials and geometry, a strong all-rounder for architecture" },
        { ...nt.flux3, why: "crisp detail up to 4K, and the cleanest text of the group" },
        { ...nt.seedream5, why: "cinematic light and colour, up to six results a run" },
        { ...nt.nbPro, why: "the highest fidelity here, slower and the most expensive" },
        { ...nt.flux2Max, why: "sharp, high-resolution renders with tight prompt control" }
      ]
    },
    photoreal: {
      id: "photoreal",
      label: "Photoreal renders",
      intro: "For photoreal architecture and interiors:",
      picks: [
        { ...nt.nbPro, why: "the most convincing materials and light, for finals" },
        { ...nt.nb2, why: "nearly as real for half the price, and quick to iterate" },
        { ...nt.rdPhoto, why: "RunDiffusion's own photographic model, for natural daylight" },
        { ...nt.seedream5, why: "cinematic mood and colour grading" }
      ]
    },
    text: {
      id: "text",
      label: "Text and signage",
      intro: "For legible words in the picture (signage, posters, labels):",
      picks: [
        { ...nt.flux3, why: "the most reliable lettering here, up to 4K" },
        { ...nt.sunburst, why: "precise layout and tight revisions, with transparent backgrounds" },
        { ...nt.nbPro, why: "good short signage inside a photoreal scene" }
      ]
    },
    edit: {
      id: "edit",
      label: "Editing images you have",
      intro: "For changing an image while keeping the building and camera:",
      picks: [
        { ...nt.flare, why: "relights and restyles naturally while holding the layout" },
        { ...nt.nb2, why: "keeps geometry and materials steady through big changes" },
        { ...nt.kontextPro, why: "fast, faithful single-image edits" },
        { ...nt.seedream5, why: "mood and colour changes with up to ten reference images" }
      ]
    },
    drafts: {
      id: "drafts",
      label: "Fast, cheap drafts",
      intro: "For quick drafts while you find the idea:",
      picks: [
        { ...nt.zTurbo, why: "about five seconds and 12 tokens a picture" },
        { ...nt.juggLightning, why: "about 3 tokens a picture, good for volume" },
        { ...nt.klein4b, why: "cheap, and it takes reference images" }
      ]
    },
    design: {
      id: "design",
      label: "Design and vector-style graphics",
      intro: "For logos, icons and flat graphics (no true vector tool is on this board yet):",
      picks: [
        { ...nt.sunburst, why: "transparent backgrounds and tight control of layout" },
        { ...nt.flux3, why: "clean type and graphic layouts" },
        { ...nt.layers, why: "splits a finished design into editable layers (it needs the image)" }
      ]
    }
  },
  families: [
    {
      name: "ChatGPT Image 2.5",
      match: /\b(chat\s*gpt|gpt)[\s-]*image(?:[\s-]*2\.5)?\b|\bchatgpt\b/i,
      members: [nt.flare.id, nt.sunburst.id],
      pick: {
        edit: { id: nt.flare.id, why: "it relights scenes naturally and keeps the layout, which suits a time-of-day change" },
        text: { id: nt.sunburst.id, why: "it has tighter revision control and the most detail, which lettering needs" },
        design: { id: nt.sunburst.id, why: "it has tighter revision control and supports transparent backgrounds" },
        default: { id: nt.flare.id, why: "it's the faster of the two and the better all-rounder" }
      }
    },
    {
      name: "Nano Banana",
      match: /\bnano[\s-]*banana\b/i,
      members: [nt.nb2.id, nt.nbPro.id, nt.nb1.id, nt.nb2Lite.id],
      pick: {
        photoreal: { id: nt.nbPro.id, why: "it's the highest-fidelity Nano Banana" },
        default: { id: nt.nb2.id, why: "it's the best balance of quality and price of the Nano Banana tools" }
      }
    },
    {
      name: "Flux 3",
      match: /\bflux[\s-]*3\b/i,
      members: [nt.flux3.id],
      pick: { default: { id: nt.flux3.id, why: "it's the Flux 3 tool on this board" } }
    },
    {
      name: "Seedream",
      match: /\bseedream\b/i,
      members: [nt.seedream5.id, nt.seedream45.id],
      pick: { default: { id: nt.seedream5.id, why: "it's the newest Seedream and takes reference images" } }
    },
    {
      name: "Flux Kontext",
      match: /\b(flux[\s-]*)?kontext\b/i,
      members: [nt.kontextPro.id],
      pick: { default: { id: nt.kontextPro.id, why: "Pro is the balanced Kontext" } }
    },
    {
      name: "Wan",
      match: /\bwan(?:[\s-]*2\.7)?\b/i,
      members: [nt.wanPro.id],
      pick: { default: { id: nt.wanPro.id, why: "Pro is the sharper Wan image tool" } }
    },
    {
      name: "Ideogram",
      match: /\bideogram\b/i,
      members: [nt.ideoEdit.id, nt.ideoReframe.id],
      pick: {
        edit: { id: nt.ideoEdit.id, why: "it edits an image (with a mask), and it's the Ideogram that does" }
      },
      note: "Ideogram v4, the Ideogram that makes a picture from a prompt alone, isn't on this board's tool list. The Ideogram tools here (v3 Edit and V3 Reframe) need an image to start from."
    }
  ],
  tools: [
    {
      ids: [nt.flare.id, nt.sunburst.id],
      name: "ChatGPT Image 2.5",
      tips: [
        'Say what changes first, then what must stay: "same building, same camera angle, same materials".',
        "Name the light: the time of day, where it comes from and its colour.",
        "Quality sets the price: Medium for drafts, High for finals, Extra High only for print.",
        "Pick the size that matches your source image's shape, so nothing gets cropped."
      ],
      settings: [{ field: "Quality", value: "high", say: "High quality" }],
      sizeFromInput: !0,
      tuned: "{prompt}. Natural, physically accurate light and a precise, well-balanced composition."
    },
    {
      ids: [nt.nb2.id, nt.nbPro.id, nt.nb1.id, nt.nb2Lite.id],
      name: "Nano Banana",
      tips: [
        "Write plain, complete sentences: it follows them closely.",
        "Name materials and finishes (board-formed concrete, oiled oak, bronze mullions).",
        "For an edit, attach the image and describe only what should change."
      ],
      tuned: "A photograph of {prompt}. Real materials and finishes, accurate geometry, natural light."
    },
    {
      ids: [nt.flux3.id],
      name: "Flux 3 Image",
      tips: [
        "Put exact words in double quotes and name the type style.",
        "Choose the size first: it sets the price.",
        'Concrete nouns beat adjectives: "cedar slats" says more than "warm and natural".'
      ],
      tuned: "{prompt}, highly detailed, sharp focus, professional architectural photography"
    },
    {
      ids: [nt.seedream5.id, nt.seedream45.id],
      name: "Seedream",
      tips: [
        "Describe mood and light like a cinematographer: golden hour, low sun, long shadows.",
        "Reference images steer style and palette: add one or two."
      ],
      tuned: "{prompt}, cinematic lighting, rich colour, atmospheric depth"
    },
    {
      ids: [nt.ideoEdit.id, nt.ideoReframe.id],
      name: "Ideogram",
      tips: [
        "Put the exact sign text in double quotes, and keep it short: one to four words read best.",
        "Name the lettering: bold geometric sans serif, brushed steel channel letters, hand-painted serif.",
        "Say where the sign is and how it's lit: on the canopy fascia, backlit, facing the street.",
        "Ask for clean, legible typography, and leave other words out of the prompt so they don't end up on the sign.",
        "Choose a Design or Typography style when the tool offers one."
      ]
    },
    {
      ids: [nt.kontextPro.id],
      name: "Flux Kontext Pro",
      tips: [
        'Describe the change as an instruction: "make it night", "replace the cladding with zinc".',
        "One change per run edits most faithfully."
      ]
    }
  ],
  edits: [
    { match: /night|nighttime|night-time|evening|after dark/i, name: "Night versions", change: "a nighttime scene", light: "Deep blue night sky, warm light glowing from the interior windows, soft uplighting on the facade, realistic reflections and gentle street lighting." },
    { match: /dusk|twilight|blue hour/i, name: "Dusk versions", change: "dusk", light: "Blue-hour sky fading to warm orange at the horizon, interior lights coming on, soft even light on the facade." },
    { match: /sunset|golden hour/i, name: "Golden hour versions", change: "golden hour", light: "Low warm sun, long soft shadows, glowing highlights on the facade, a clear gradient sky." },
    { match: /\bfog|\bmist/i, name: "Fog versions", change: "a foggy morning", light: "Dense soft fog fading the background, muted colours, diffuse light." },
    { match: /dawn|sunrise|morning/i, name: "Morning versions", change: "early morning", light: "Cool soft dawn light, a pale sky with warm first light on the upper floors, light mist at street level." },
    { match: /snow|winter/i, name: "Winter versions", change: "a snowy winter scene", light: "Fresh snow on the ground and ledges, overcast soft light, cool tones with warm windows." },
    { match: /\brain|\bwet\b|storm/i, name: "Rainy day versions", change: "a rainy day", light: "Wet reflective pavement, overcast sky, soft diffuse light, rain streaks in the air." },
    { match: /autumn|\bfall\b/i, name: "Autumn versions", change: "autumn", light: "Trees in full autumn colour, low warm sun, fallen leaves on the ground." }
  ]
};
function Of(n, e) {
  return n.tools.find((t) => t.ids.includes(e)) || null;
}
function O6(n, e, t) {
  const i = Of(n, e), s = t.trim().replace(/[.\s]+$/, "");
  return i && i.tuned ? i.tuned.replace("{prompt}", s) : s;
}
function L6(n, e, t, i, s) {
  const o = { prompt: e, n: t, inputs: { ...i } }, r = n.imageField;
  if (r && s.length) {
    const a = n.model.fields.find((l) => l.placement === "reference") === r;
    s.length > 1 && r.kind === "images" ? o.inputs[r.key] = s.slice() : a ? o.ref = s[0] : o.inputs[r.key] = s[0];
  }
  return o;
}
function XF(n, e, t, i) {
  const s = {}, o = [];
  for (const [r, a] of Object.entries(t.settings || {})) {
    if (r.toLowerCase() === "size") {
      if (a !== "match" || !i) continue;
      const d = n.sizeFor(e, i.w, i.h);
      if (!d) continue;
      s[d.field.key] = d.value, o.push(d.label.replace(/\s*-\s*\d+x\d+$/, ""));
      continue;
    }
    const l = n.field(e, r);
    if (!l) return e.name + " has no " + r + " setting.";
    if (l.options && l.options.length) {
      const d = n.option(l, a);
      if (!d) return r + " can't be " + String(a) + " in " + e.name + ".";
      s[l.key] = d.value, o.push(d.label + " " + r.toLowerCase());
    } else
      s[l.key] = a, o.push(r + " " + String(a));
  }
  return { inputs: s, said: o };
}
function JF(n) {
  let e = 0;
  for (const t of n) e = Math.max(e, t.secs + 4 * Math.max(0, t.runs - 1));
  return Math.round(e);
}
function ov(n, e, t) {
  if (!n.sessions.length) return { ok: !1, error: "The plan has nothing to run." };
  const i = new Map(e.images.map((a) => [a.id, a])), s = [], o = [];
  let r = 0;
  for (const a of n.sessions) {
    const l = t.get(a.modelId);
    if (!l) return { ok: !1, error: "That tool isn't on this board's tool list, so the plan can't use it." };
    let d;
    if (a.toolId) {
      const k = e.sessions.find((S) => S.id === a.toolId);
      if (!k) return { ok: !1, error: "A session the plan uses is no longer in this frame." };
      d = k.kitId;
    } else
      d = t.kitFor(l, a.job || "generate").id;
    const c = (a.runs && a.runs.length ? a.runs : [{ imageIds: [] }]).map((k) => {
      const S = [];
      for (const _ of k.imageIds || []) {
        const x = i.get(_);
        x && S.push(x);
      }
      return S;
    });
    if (c.some((k, S) => k.length !== (a.runs && a.runs[S] && a.runs[S].imageIds || []).length))
      return { ok: !1, error: "An image the plan uses is no longer in this frame." };
    const u = c.some((k) => k.length);
    if (u && !l.imageField) return { ok: !1, error: l.name + " can't take an image as input." };
    if (c.some((k) => k.length > l.maxImages)) return { ok: !1, error: l.name + " takes up to " + l.maxImages + (l.maxImages === 1 ? " image" : " images") + " a run." };
    if (!u && l.needsImage) return { ok: !1, error: l.name + " needs an image to start from." };
    const p = t.results(l, a.n || 1), f = c.find((k) => k.length) ? c.find((k) => k.length)[0] : null, y = XF(t, l, a, f);
    if (typeof y == "string") return { ok: !1, error: y };
    let b = 0, w = !0;
    for (const k of c) {
      const S = L6(l, a.prompt, p, y.inputs, k.map((T) => T.url)), _ = t.problems(l, S, p);
      if (_.length) return { ok: !1, error: _[0] };
      const x = t.price(l, S, p);
      x == null ? w = !1 : b += x;
    }
    if (!w) return { ok: !1, error: l.name + " has no price the board can show, so the plan can't include it." };
    b = Math.round(b * 10) / 10, r += b, o.push({ secs: l.secs, runs: c.length }), s.push({
      key: "s" + (s.length + 1),
      ...a.toolId ? { toolId: a.toolId } : {},
      name: a.name,
      kitId: d,
      modelId: l.id,
      model: l.name,
      prompt: a.prompt,
      n: p,
      runs: c.map((k) => k.length ? { images: k.map((S) => ({ id: S.id, url: S.url })) } : {}),
      ...Object.keys(y.inputs).length ? { inputs: y.inputs } : {},
      ...y.said.length ? { settings: y.said.join(" · ") } : {},
      tokens: b,
      ...a.why ? { why: a.why } : {}
    });
  }
  return {
    ok: !0,
    plan: {
      id: kt(),
      title: n.title,
      ...n.summary ? { summary: n.summary } : {},
      status: "proposed",
      tokens: Math.round(r * 10) / 10,
      secs: JF(o),
      sessions: s,
      ...n.place ? { place: !0 } : {}
    }
  };
}
function ZF(n) {
  let e = 0, t = 0, i = 0;
  for (const s of n.sessions)
    e += s.runs.length, t += s.runs.length * s.n, s.toolId || i++;
  return { runs: e, results: t, sessions: n.sessions.length, added: i };
}
function Kd(n) {
  return (n >= 100 ? Math.round(n) : Math.round(n * 10) / 10).toLocaleString("en-US");
}
function B6(n) {
  return Kd(n) + (n === 1 ? " token" : " tokens");
}
function aw(n) {
  return n < 90 ? Math.max(1, Math.round(n)) + "s" : Math.round(n / 60) + " min";
}
var QF = Object.defineProperty, eN = (n, e, t) => e in n ? QF(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, $m = (n, e, t) => eN(n, typeof e != "symbol" ? e + "" : e, t);
const F6 = "/__smart-frames", N6 = { url: F6 }, tN = { "Content-Type": "application/json", "X-Smart-Frames": "1" }, Dm = 16, nN = 384, iN = 1, sN = 4, U6 = (n) => n.url === F6, Om = (n) => U6(n) ? "The assistant runs in the web app's dev server, which didn't answer here." : "The chat couldn't be reached. Try again in a little while.";
async function G6(n, e, t, i) {
  const s = { ...tN };
  if (n.token) {
    const r = await n.token();
    r && (s.Authorization = "Bearer " + r);
  }
  const o = n.url + e + (n.teamId ? "?team=" + encodeURIComponent(n.teamId) : "");
  return i(o, { ...t, headers: s });
}
async function oN(n = N6, e = fetch) {
  try {
    const t = await G6(n, "/status", {}, e);
    let i = null;
    try {
      i = await t.json();
    } catch {
      i = null;
    }
    if (!t.ok || !i) return { ready: !1, reason: i && i.reason || Om(n) };
    const s = Array.isArray(i.models) ? i.models.filter((o) => o && o.id && o.label) : [];
    return i.ready && s.length ? { ready: !0, models: s } : { ready: !1, reason: i.reason || Om(n) };
  } catch {
    return { ready: !1, reason: Om(n) };
  }
}
function Lm(n, e, t, i = []) {
  return n.price(e, L6(e, "x", 1, t, i), 1);
}
const lw = /* @__PURE__ */ new WeakMap();
function rN(n, e) {
  let t = lw.get(n.catalog);
  t || (t = /* @__PURE__ */ new Map(), lw.set(n.catalog, t));
  const i = t.get(e.id);
  if (i) return i;
  const s = [], o = Lm(n, e, {});
  if (o != null) {
    for (const r of e.model.fields) {
      if (r.kind !== "select" && r.kind !== "size" || !r.options || r.options.length < 2 || r.options.length > 10) continue;
      const a = r.options.map((l) => ({ label: l.label, p: Lm(n, e, { [r.key]: l.value }) }));
      a.some((l) => l.p == null) || a.every((l) => l.p === a[0].p) || s.push(r.label + ": " + a.map((l) => l.label + " " + Math.round(l.p * 10) / 10).join(", ") + " tokens a result");
    }
    if (e.imageField) {
      const r = Lm(n, e, {}, ["https://board.invalid/a.png"]);
      r != null && r !== o && s.push("each input image adds " + Math.round((r - o) * 10) / 10 + " tokens a result");
    }
  }
  return t.set(e.id, s), s;
}
function aN(n) {
  const e = [];
  for (const t of n.entries()) {
    const i = n.price(t, { prompt: "x", n: 1 }, 1), s = t.model.fields.find((r) => r.placement === "reference" && r.kind === "video"), o = rN(n, t);
    e.push({
      id: t.id,
      name: t.name,
      ...t.desc ? { desc: t.desc.slice(0, 240) } : {},
      kits: t.kits.map((r) => r.id),
      ...t.model.kitTags && t.model.kitTags.length ? { tags: t.model.kitTags.slice(0, 6) } : {},
      ...t.model.labels && t.model.labels.length ? { labels: t.model.labels.map((r) => r.label).slice(0, 6) } : {},
      images: t.imageField ? t.needsImage ? "required" : "optional" : "none",
      maxImages: t.maxImages,
      ...s ? { video: s.required ? "required" : "optional" } : {},
      maxResults: t.model.numResults.max,
      perResult: i == null ? null : Math.round(i * 10) / 10,
      priceVaries: o.length > 0,
      ...o.length ? { priceNotes: o } : {},
      secs: t.secs,
      settings: t.model.fields.filter((r) => (r.kind === "select" || r.kind === "size") && r.options && r.options.length).map((r) => {
        const a = r.options.find((l) => mn(l.value) === mn(r.defaultValue));
        return {
          label: r.label,
          kind: r.kind,
          options: r.options.map((l) => l.label),
          values: r.options.map((l) => mn(l.value)),
          ...a ? { default: a.label } : {}
        };
      })
    });
  }
  return { kits: n.catalog.kits.map((t) => ({ id: t.id, name: t.name, ...t.desc ? { desc: t.desc } : {} })), tools: e };
}
function lN(n) {
  return {
    status: n.status,
    jobs: n.jobs,
    families: n.families.map((e) => ({ ...e, match: e.match.source })),
    tools: n.tools,
    edits: n.edits.map((e) => ({ ...e, match: e.match.source }))
  };
}
function j6(n) {
  return {
    title: n.title,
    status: n.status,
    ...n.results != null ? { results: n.results } : {},
    ...n.error ? { error: n.error } : {},
    sessions: n.sessions.map((e) => ({
      name: e.name,
      model: e.model,
      modelId: e.modelId,
      ...e.toolId || e.addedId ? { toolId: e.toolId || e.addedId } : {},
      prompt: e.prompt,
      runs: e.runs.length,
      n: e.n,
      images: e.runs.reduce((t, i) => t + (i.images ? i.images.length : 0), 0)
    }))
  };
}
function dN(n) {
  return n.map((e) => ({
    role: e.role,
    author: e.role === "agent" ? "Assistant" : e.author,
    text: e.text || "",
    ...e.plan ? { plan: j6(e.plan) } : {},
    ...e.picks && e.picks.length ? { picks: e.picks.map((t) => t.name) } : {},
    ...e.ideas && e.ideas.length ? { ideas: e.ideas.map((t) => t.title) } : {}
  }));
}
const aa = /* @__PURE__ */ new Map();
function dw(n) {
  return new Promise((e) => {
    if (typeof Image == "undefined" || typeof document == "undefined") {
      e(null);
      return;
    }
    const t = new Image();
    t.crossOrigin = "anonymous", t.decoding = "async";
    const i = window.setTimeout(() => e(null), 8e3);
    t.onload = () => {
      window.clearTimeout(i);
      try {
        const s = t.naturalWidth, o = t.naturalHeight;
        if (!s || !o) return e(null);
        const r = Math.min(1, nN / Math.max(s, o)), a = document.createElement("canvas");
        a.width = Math.max(1, Math.round(s * r)), a.height = Math.max(1, Math.round(o * r));
        const l = a.getContext("2d");
        if (!l) return e(null);
        l.drawImage(t, 0, 0, a.width, a.height), e({ data: a.toDataURL("image/jpeg", 0.85), w: s, h: o });
      } catch {
        e(null);
      }
    }, t.onerror = () => {
      window.clearTimeout(i), e(null);
    }, t.src = n;
  });
}
function cN(n) {
  const e = aa.get(n);
  if (e) return e;
  const t = d1(n), i = (t ? dw(t) : Promise.resolve(null)).then((s) => s || dw(n)).then((s) => (s || aa.delete(n), s));
  return aa.set(n, i), aa.size > 96 && aa.delete(aa.keys().next().value), i;
}
async function uN(n) {
  try {
    const e = await crypto.subtle.digest("SHA-256", new TextEncoder().encode("smart-frames:" + n));
    return Array.from(new Uint8Array(e)).slice(0, 16).map((t) => t.toString(16).padStart(2, "0")).join("");
  } catch {
    return;
  }
}
function hN(n, e = /* @__PURE__ */ new Set()) {
  const t = n.sessions.map((a) => Math.min(a.thumbs.length, a.id && e.has(a.id) ? sN : iN)), i = t.reduce((a, l) => a + l, 0), s = Math.min(n.images.length, i ? Dm - Math.min(i, 4) : Dm);
  let o = Dm - s;
  const r = t.map((a) => {
    const l = Math.max(0, Math.min(a, o));
    return o -= l, l;
  });
  return { images: s, sessions: r };
}
async function pN(n, e, t = cN) {
  const i = n.context, s = new Set(n.input.kind === "plan-ended" ? n.input.plan.sessions.map((l) => l.toolId || l.addedId || "").filter(Boolean) : []), o = hN(i, s), r = await Promise.all(i.images.map((l, d) => d < o.images ? t(l.url) : Promise.resolve(null))), a = await Promise.all(i.sessions.map((l, d) => Promise.all(l.thumbs.slice(0, o.sessions[d]).map((c) => t(c)))));
  return {
    v: 2,
    model: e.model,
    ...e.boardId ? { board: { id: e.boardId } } : {},
    ...n.chatId ? { chat: { id: n.chatId } } : {},
    ...e.user ? { user: e.user } : {},
    input: n.input.kind === "message" ? { kind: "message", text: n.input.text, author: n.input.author } : { kind: "plan-ended", plan: j6(n.input.plan) },
    frame: {
      title: i.title,
      images: i.images.map((l, d) => {
        const c = d1(l.url), u = r[d];
        return {
          id: l.id,
          url: l.url,
          w: l.w,
          h: l.h,
          ...c ? { thumb: c } : {},
          ...u ? { thumbData: u.data, px: { w: u.w, h: u.h } } : {},
          ...l.label ? { label: l.label } : {},
          ...l.prompt ? { prompt: l.prompt } : {},
          ...l.model ? { model: l.model } : {},
          ...l.sessionId ? { session: l.sessionId } : {},
          ...l.video ? { video: !0 } : {},
          ...l.kind ? { kind: l.kind } : {},
          ...l.fav ? { fav: !0 } : {},
          ...l.group ? { group: l.group } : {}
        };
      }),
      sessions: i.sessions.map((l, d) => ({
        id: l.id,
        name: l.name,
        kit: l.kind,
        kitId: l.kitId,
        model: l.model,
        ...l.nodeDefId ? { modelId: l.nodeDefId } : {},
        prompt: l.prompt,
        n: l.n,
        results: l.results,
        takesImages: l.takesImages,
        generating: l.generating,
        settings: l.settings,
        inputs: l.inputs,
        otherInputs: l.otherInputs,
        ...l.error ? { error: l.error } : {},
        ...l.group ? { group: l.group } : {},
        ...o.sessions[d] ? {
          latest: l.thumbs.slice(0, o.sessions[d]).map((c, u) => {
            const p = a[d][u];
            return { url: c, ...p ? { thumbData: p.data } : {} };
          })
        } : {}
      })),
      notes: i.notes.map((l) => ({ id: l.id, text: l.text, ...l.author ? { author: l.author } : {}, ...l.tint ? { tint: l.tint } : {}, ...l.group ? { group: l.group } : {} })),
      groups: i.groups,
      links: i.links.map((l) => ({ kind: l.kind, from: l.from, to: l.to })),
      marks: i.marks.map((l) => ({ kind: l.kind, around: l.around })),
      chats: i.chats,
      ignored: i.ignored
    },
    history: dN(n.history),
    ...n.dropped ? { dropped: n.dropped } : {},
    catalog: aN(n.catalog),
    guidance: lN(n.guidance)
  };
}
async function* fN(n, e) {
  const t = n.getReader(), i = new TextDecoder();
  let s = "";
  try {
    for (; !(e && e.aborted); ) {
      const { done: o, value: r } = await t.read();
      s += i.decode(r || new Uint8Array(), { stream: !o });
      const a = s.split(/\r?\n\r?\n/);
      s = o ? "" : a.pop() || "";
      for (const l of a) {
        const d = l.split(/\r?\n/).filter((c) => c.startsWith("data:")).map((c) => c.slice(5).trimStart()).join(`
`);
        if (d)
          try {
            yield JSON.parse(d);
          } catch {
          }
      }
      if (o) break;
    }
  } finally {
    e && e.aborted ? t.cancel().catch(() => {
    }) : t.releaseLock();
  }
}
class mN {
  constructor(e) {
    $m(this, "opts", e), $m(this, "id"), $m(this, "label"), this.id = "model:" + e.model.id, this.label = e.model.label;
  }
  async *turn(e, t) {
    const i = this.opts.fetchImpl || fetch, s = this.opts.endpoint || N6;
    yield { type: "status", text: e.context.images.length && e.input.kind === "message" ? "Looking at the frame…" : "Thinking…" };
    let o;
    try {
      const a = await pN(e, { model: this.opts.model.id, boardId: this.opts.boardId, user: this.opts.uid ? await uN(this.opts.uid) : void 0 }, this.opts.draw);
      if (t.aborted) return;
      o = await G6(s, "/turn", { method: "POST", body: JSON.stringify(a), signal: t }, i);
    } catch {
      if (t.aborted) return;
      yield { type: "text", delta: U6(s) ? "The assistant couldn't be reached. Is the dev server still running?" : "The chat couldn't be reached. Check your connection and try again." };
      return;
    }
    if (!o.ok || !o.body) {
      let a = "";
      try {
        a = (await o.json()).error || "";
      } catch {
        a = "";
      }
      yield { type: "text", delta: a || "The assistant couldn't answer (HTTP " + o.status + ")." };
      return;
    }
    let r = !1;
    for await (const a of fN(o.body, t))
      if (a.type === "status") yield a;
      else if (a.type === "text")
        r = !0, yield a;
      else if (a.type === "plan") yield { type: "plan", plan: a.plan };
      else if (a.type === "picks" || a.type === "ideas" || a.type === "chips") yield a;
      else if (a.type === "error")
        yield { type: "text", delta: (r ? `

` : "") + a.message }, r = !0;
      else if (a.type === "done") {
        a.usage && (yield { type: "usage", usage: a.usage });
        return;
      }
  }
}
const Bs = 40, Lf = 24, H6 = 56;
function gN(n, e) {
  return { x: n.x - e, y: n.y - e, w: n.w + e * 2, h: n.h + e * 2 };
}
function rv(n, e, t, i, s = Lf, o = 16) {
  const r = n.x + Bs, a = n.y + Bs;
  for (let l = a; l + i <= n.y + n.h - Bs; l += o)
    for (let d = r; d + t <= n.x + n.w - Bs; d += o) {
      const c = gN({ x: d, y: l, w: t, h: i }, s - 1);
      if (!e.some((u) => Id(c, u))) return { x: d, y: l };
    }
  return null;
}
function av(n, e, t = Lf) {
  const i = P6(e);
  return { x: n.x + Bs, y: i ? Math.max(n.y + Bs, i.y + i.h + t) : n.y + Bs };
}
function bN(n, e, t, i, s, o = H6) {
  if (t <= 0) return [];
  const r = t * i + (t - 1) * o, l = rv(n, e, r, s, o) || av(n, e, o), d = [];
  for (let c = 0; c < t; c++) d.push({ x: l.x + c * (i + o), y: l.y, w: i, h: s });
  return d;
}
function lv(n, e) {
  let t = n.x + n.w, i = n.y + n.h;
  for (const s of e)
    t = Math.max(t, s.x + s.w + Bs), i = Math.max(i, s.y + s.h + Bs);
  return t === n.x + n.w && i === n.y + n.h ? null : { x: n.x, y: n.y, w: Math.round(t - n.x), h: Math.round(i - n.y) };
}
function vN(n, e, t, i, s = Lf) {
  let o = n.y + n.h;
  for (const r of e)
    r.x < n.x + n.w && r.x + r.w > n.x && r.y >= n.y && r.y + r.h > o && (o = r.y + r.h);
  return { x: n.x, y: o + s, w: t, h: i };
}
function yN(n, e, t, i = 400) {
  if (!e || !t) return { w: n, h: Math.round(n * 0.75) };
  const s = Math.round(n * t / e);
  return s <= i ? { w: n, h: s } : { w: Math.round(i * e / t), h: i };
}
var xN = Object.defineProperty, wN = (n, e, t) => e in n ? xN(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Qn = (n, e, t) => wN(n, typeof e != "symbol" ? e + "" : e, t);
const kN = Tt.w;
function sr(n) {
  return "“" + n + "”";
}
function gu(n, e, t = e + "s") {
  return n + " " + (n === 1 ? e : t);
}
class _N {
  constructor(e, t, i, s = () => {
  }, o = {}) {
    Qn(this, "cmd", e), Qn(this, "plan", t), Qn(this, "frameId", i), Qn(this, "onUpdate", s), Qn(this, "cancelled", !1), Qn(this, "steps", []), Qn(this, "added", {}), Qn(this, "results", 0), Qn(this, "pollMs"), Qn(this, "timeoutMs"), Qn(this, "sendTimeoutMs"), Qn(this, "columns", []), Qn(this, "rowY", null), Qn(this, "nextY", /* @__PURE__ */ new Map()), this.pollMs = o.pollMs || 400, this.timeoutMs = o.timeoutMs || 600 * 1e3, this.sendTimeoutMs = o.sendTimeoutMs || 120 * 1e3;
  }
  /** Stop before the next step. Runs already sent finish anyway (they're paid for). */
  cancel() {
    this.cancelled = !0;
  }
  step(e) {
    return this.steps.find((t) => t.id === e);
  }
  set(e, t) {
    Object.assign(this.step(e), t), this.emit();
  }
  emit() {
    this.onUpdate({ steps: this.steps.map((e) => ({ ...e })), added: { ...this.added }, results: this.results });
  }
  outcome(e, t) {
    return { status: e, steps: this.steps.map((i) => ({ ...i })), added: { ...this.added }, results: this.results, ...t ? { error: t } : {} };
  }
  fail(e, t) {
    return this.set(e, { status: "failed", detail: t }), this.outcome("failed", t);
  }
  stopIfCancelled(e) {
    return this.cancelled ? (this.set(e, { status: "failed", detail: "Stopped before this step" }), this.outcome("cancelled", "Stopped")) : null;
  }
  frame() {
    const e = this.cmd.element(this.frameId);
    return e && e.type === "frame" ? e : null;
  }
  /** Grow the frame to hold these rects, when it doesn't. */
  fit(e) {
    const t = this.frame();
    if (!t) return;
    const i = lv(qe(t), e);
    i && this.cmd.resizeFrame(t.id, i);
  }
  toolOf(e) {
    const t = e.toolId || this.added[e.key], i = t ? this.cmd.element(t) : void 0;
    return i && i.type === "tool" ? t : null;
  }
  async until(e, t) {
    const i = Math.max(1, Math.ceil(t / this.pollMs));
    for (let s = 0; s < i; s++) {
      if (e()) return !0;
      await this.cmd.wait(this.pollMs);
    }
    return e();
  }
  async run() {
    const e = this.plan, t = e.sessions, i = t.filter((x) => !x.toolId), s = t.reduce((x, T) => x + T.runs.length, 0), o = t.reduce((x, T) => x + T.runs.reduce((M, z) => M + (z.images ? z.images.length : 0), 0), 0), r = t.some((x) => x.inputs && Object.keys(x.inputs).length);
    for (const x of i) this.steps.push({ id: "add:" + x.key, text: "Add " + sr(x.name) + " to the frame", status: "pending" });
    if (this.steps.push({ id: "prompt", text: t.length > 1 ? "Set the prompt in " + t.length + " sessions" : "Set the prompt" + (r ? " and recommended settings" : ""), status: "pending" }), o && this.steps.push({ id: "attach", text: "Attach " + gu(o, "image") + (o === s ? ", one per run" : ""), status: "pending" }), this.steps.push({ id: "run", text: s === 1 ? "Run it" : "Run " + s + " times", status: "pending" }), e.place && this.steps.push({ id: "place", text: "Set the results out under their sessions", status: "pending" }), this.emit(), !this.frame()) return this.fail(this.steps[0].id, "The frame is gone, so there's nowhere to put the work.");
    if (i.length) {
      const x = this.frame(), T = bN(qe(x), this.cmd.contents(x), i.length, Tt.w, Tt.h, H6);
      this.fit(T);
      for (let M = 0; M < i.length; M++) {
        const z = i[M], P = "add:" + z.key, D = this.stopIfCancelled(P);
        if (D) return D;
        this.set(P, { status: "running" });
        const $ = this.cmd.modelOf(z.kitId, z.modelId);
        if (!$) return this.fail(P, z.model + " isn't on this board's tool list any more.");
        const O = T[M], L = this.cmd.addSession($.kit, $.model, z.name, { x: O.x + O.w / 2, y: O.y + O.h / 2 });
        (L.x !== O.x || L.y !== O.y) && this.cmd.move(L.id, O.x, O.y), this.added[z.key] = L.id, this.set(P, { status: "done", text: "Added " + sr(L.name || z.name) + " to the frame" });
      }
    }
    {
      const x = this.stopIfCancelled("prompt");
      if (x) return x;
      this.set("prompt", { status: "running" });
      for (const T of t) {
        const M = this.toolOf(T);
        if (!M) return this.fail("prompt", sr(T.name) + " is no longer on the board.");
        const z = this.cmd.promptOf(M);
        this.cmd.setPrompt(M, { prompt: T.prompt, n: T.n, inputs: { ...z.inputs || {}, ...T.inputs || {} } });
      }
      this.set("prompt", { status: "done", text: t.length > 1 ? "Set the prompt in " + t.length + " sessions" : "Set the prompt" + (r ? " and recommended settings" : "") });
    }
    const a = /* @__PURE__ */ new Map();
    for (const x of t) {
      const T = this.toolOf(x);
      a.set(T, new Set(this.cmd.results(T).map((M) => M.id)));
    }
    let l = 0, d = 0;
    const c = /* @__PURE__ */ new Set();
    this.set("run", { status: "running", text: "Running 0 of " + s });
    for (const x of t) {
      const T = this.toolOf(x);
      if (!T) return this.fail("run", sr(x.name) + " is no longer on the board.");
      for (const M of x.runs) {
        const z = this.stopIfCancelled("run");
        if (z) return z;
        if (!await this.until(() => !this.cmd.submitting(T), this.sendTimeoutMs)) return this.fail("run", "The last run in " + sr(x.name) + " is still being sent.");
        const D = this.cmd.error(T);
        if (c.has(T) && D) return this.fail("run", D);
        if (M.images && M.images.length) {
          const O = this.cmd.imageFields(T)[0];
          if (!O) return this.fail("attach", x.model + " takes no images.");
          d === 0 && this.set("attach", { status: "running" }), this.cmd.setRefInput(T, O.key, null);
          for (const L of M.images) {
            if (!this.cmd.setRefInput(T, O.key, L.url, this.cmd.assetOf(L.id, L.url))) return this.fail("attach", "An image couldn't be attached to " + sr(x.name) + ".");
            d++;
          }
          this.set("attach", d >= o ? { status: "done", text: "Attached " + gu(o, "image") + (o === s ? ", one per run" : "") } : { text: "Attaching " + d + " of " + o });
        }
        const $ = this.cmd.generate(T);
        if ($) return this.fail("run", $);
        c.add(T), l++, this.set("run", { text: "Running " + l + " of " + s });
      }
    }
    const u = t.reduce((x, T) => x + T.runs.length * T.n, 0);
    this.columns = t.map((x) => this.toolOf(x)).filter((x) => !!x);
    const p = /* @__PURE__ */ new Set(), f = (x) => this.cmd.results(x).filter((T) => T.status === "done" && !!T.url && !a.get(x).has(T.id)), y = () => {
      let x = 0;
      for (const T of t) x += f(this.toolOf(T) || "").length;
      return x;
    }, b = () => {
      let x = !1;
      for (const M of t) {
        const z = this.toolOf(M);
        if (z) {
          if (this.cmd.submitting(z) || this.cmd.generating(z)) {
            x = !0;
            continue;
          }
          e.place && this.placeFor(z, f(z), p);
        }
      }
      const T = y();
      return T !== this.results && (this.results = T, this.emit()), !x;
    }, w = await this.until(b, this.timeoutMs), k = t.map((x) => this.toolOf(x)).filter((x) => !!x).map((x) => this.cmd.error(x)).filter((x) => !!x);
    if (!w)
      return this.fail("run", "Still running after " + Math.round(this.timeoutMs / 6e4) + " minutes. The results will land in their sessions when they finish.");
    if (k.length && this.results < u)
      return this.fail("run", k[0]);
    const S = t.length === 1 ? this.cmd.element(this.toolOf(t[0]) || "") : void 0, _ = S && S.type === "tool" ? S.name : t[0].name;
    return this.set("run", { status: "done", text: gu(this.results, "result") + " landed" + (t.length === 1 ? " in " + sr(_) : "") }), e.place && this.set("place", { status: p.size ? "done" : "failed", text: p.size ? "Set " + gu(p.size, "result") + " out under " + (t.length === 1 ? "the session" : "their sessions") : "Set the results out under their sessions", ...p.size ? {} : { detail: "No results to place" } }), this.outcome("done");
  }
  /**
   * Where this plan's results start: one row, under whatever is already in
   * every one of its sessions' columns, so a comparison reads as a grid (a
   * row per prompt, a column per tool). Worked out when the first result is
   * ready, so a run started before anything else was placed starts higher.
   */
  firstRow() {
    if (this.rowY != null) return this.rowY;
    const e = this.frame(), t = e ? this.cmd.contents(e) : [];
    let i = -1 / 0;
    for (const s of this.columns) {
      const o = this.cmd.element(s);
      o && (i = Math.max(i, vN(qe(o), t, 0, 0).y));
    }
    return this.rowY = Number.isFinite(i) ? i : 0, this.rowY;
  }
  /** A session's new results onto the board, in its column from the plan's row down, the frame growing to hold them. */
  placeFor(e, t, i) {
    const s = this.frame(), o = this.cmd.element(e);
    if (!s || !o) return;
    const r = qe(o), a = t.filter((l) => !i.has(l.id)).sort((l, d) => l.createdAt - d.createdAt);
    if (a.length) {
      this.step("place").status === "pending" && this.set("place", { status: "running" });
      for (const l of a) {
        const d = yN(Math.min(kN, r.w), l.w, l.h), c = this.nextY.has(e) ? this.nextY.get(e) : this.firstRow(), u = { x: r.x, y: c, w: d.w, h: d.h };
        this.fit([u]), this.cmd.place(l, u) && (i.add(l.id), this.nextY.set(e, c + d.h + Lf));
      }
    }
  }
}
function V6(n) {
  for (let e = n.length - 1; e >= 0; e--) {
    const t = n[e];
    if (t.role === "agent") return t.memo || null;
  }
  return null;
}
var SN = Object.defineProperty, TN = (n, e, t) => e in n ? SN(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, bu = (n, e, t) => TN(n, typeof e != "symbol" ? e + "" : e, t);
const Bf = [
  "A glass pavilion in a pine forest at dawn",
  "A timber library on a lake at dusk",
  "A rooftop garden café in the rain"
], W6 = /* @__PURE__ */ new Set(["image", "imageEdit"]), MN = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10, twelve: 12 };
function yo(n) {
  const e = /\b(\d{1,2}|one|two|three|four|five|six|seven|eight|nine|ten|twelve)\b/i.exec(n);
  if (!e) return null;
  const t = /\d/.test(e[1]) ? Number(e[1]) : MN[e[1].toLowerCase()];
  return Number.isFinite(t) && t > 0 ? t : null;
}
function Ni(n, e, t = e + "s") {
  return n + " " + (n === 1 ? e : t);
}
function Xr(n) {
  return n && n.charAt(0).toUpperCase() + n.slice(1);
}
function Uo(n) {
  return n.length <= 1 ? n.join("") : n.slice(0, -1).join(", ") + " and " + n[n.length - 1];
}
function Un(n) {
  return "**" + n + "**";
}
function Ja(n) {
  return n.trim().replace(/^(now\s+)?(try|run|do|prompt|another( one)?|next)\s*[:,-]\s*/i, "").replace(/^["“'‘]+|["”'’]+$/g, "").trim();
}
function El(n, e, t) {
  const i = " " + pl(n) + " ", s = [], o = [], r = (l, d) => !o.some(([c, u]) => l < u && d > c), a = e.entries().filter((l) => l.kits.some((d) => W6.has(d.id))).map((l) => ({ e: l, n: pl(l.name) })).filter((l) => l.n.length >= 4).sort((l, d) => d.n.length - l.n.length);
  for (const { e: l, n: d } of a) {
    const c = i.indexOf(" " + d + " ");
    c < 0 || !r(c, c + d.length + 2) || (o.push([c, c + d.length + 2]), s.push({ at: c, entry: l }));
  }
  for (const l of t.families) {
    const d = new RegExp(l.match.source, "gi");
    let c;
    for (; c = d.exec(i); )
      if (r(c.index, c.index + c[0].length)) {
        o.push([c.index, c.index + c[0].length]), s.push({ at: c.index, family: l });
        break;
      }
  }
  return s.sort((l, d) => l.at - d.at);
}
function Ff(n, e, t) {
  if (n.entry) return { entry: n.entry, others: [] };
  const i = n.family, s = i.members.map((r) => t.get(r)).filter((r) => !!r), o = i.pick[e] || i.pick.default;
  return o && t.has(o.id) ? { entry: t.get(o.id), why: o.why, family: i, others: s.filter((r) => r.id !== o.id) } : { entry: null, family: i, others: s, note: i.note };
}
function Ui(n, e, t) {
  return t.jobs[n].picks.filter((i) => e.has(i.id)).map((i) => ({ entry: e.get(i.id), why: i.why }));
}
function CN(n, e) {
  const t = n.price(e, { prompt: "x", n: 1 }, 1);
  return t == null ? "" : "about " + B6(t) + " a picture";
}
function Vh(n) {
  return /\b(sign|signage|text|lettering|typograph|poster|logo type|wordmark|label)/i.test(n) ? "text" : /\b(logo|icon|vector|flat|graphic|illustration|design)/i.test(n) ? "design" : /\b(draft|quick|fast|cheap|rough|sketch)/i.test(n) ? "drafts" : /\b(edit|change|relight|restyle|retouch)/i.test(n) ? "edit" : /\b(compar|side by side|shoot-?out)/i.test(n) ? "compare" : "photoreal";
}
function q6(n) {
  return n.notes.map((e) => e.text.replace(/^\s*(client|note|brief|nb|todo)\s*:\s*/i, "").replace(/\s+/g, " ").trim()).filter(Boolean);
}
function K6(n) {
  const e = n.trim();
  return e ? Xr(e) + (/[.!?]$/.test(e) ? "" : ".") : "";
}
function Ao(n) {
  const e = [];
  return n.images.length && e.push({ label: "Make these night scenes", send: "Change " + (n.images.length === 1 ? "this image" : "all " + n.images.length + " of these images") + " to a nighttime scene with ChatGPT Image 2.5. Use recommended settings." }), n.sessions.length && e.push({ label: "Run a new prompt here", send: "Now try: " + Bf[0].toLowerCase() }), e.push({ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }), e.push({ label: "Prompting tips", send: "How should I prompt Ideogram for signage text?" }), {
    text: `I can't do that one in this prototype. Here's what I can do with this frame:
- change the images in it with a tool you name
- recommend tools and set up a side-by-side comparison
- run a new prompt through the sessions in it
- make new pictures from a prompt
- give prompting tips for a tool

Every plan shows its token cost, and nothing runs until you press Run plan.`,
    chips: e
  };
}
function IN(n) {
  const e = D6(n), t = e === "Empty" ? "which is empty so far" : "which holds " + e, i = n.images.length ? [{ label: "Make these night scenes", send: "Change " + (n.images.length === 1 ? "this image" : "all " + n.images.length + " of these images") + " to a nighttime scene with ChatGPT Image 2.5. Use recommended settings." }, { label: "What's in this frame?" }] : [{ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }, { label: "Make 4 concept images", send: "Make 4 concept images of a timber pavilion on a lake at dusk" }];
  return i.push({ label: "Which tools are best for photoreal?" }), {
    text: "Hi! I work on what's in “" + n.title + "”, " + t + ". I set up tool sessions here and run them for you, always with a priced plan you approve first. What should we do?",
    chips: i
  };
}
function AN(n) {
  const e = ["Here's what's in “" + n.title + "”:"];
  n.images.forEach((t, i) => {
    const s = t.model ? t.prompt ? ": made with " + t.model + " from “" + js(t.prompt, 90) + "”" : ": made with " + t.model : ": an image I have no record of";
    e.push(i + 1 + ". Image " + (i + 1) + s);
  });
  for (const t of n.sessions) e.push("- Session " + Un(t.name) + " (" + t.model + ")" + (t.prompt ? ", prompt “" + js(t.prompt, 70) + "”" : "") + ", " + Ni(t.results, "result"));
  for (const t of n.notes) e.push("- Note: “" + js(t.text, 100) + "” (I treat notes as standing instructions)");
  return e.length === 1 && e.push("Nothing yet. Add images, sessions or notes to the frame and I'll read them."), n.ignored && e.push(`
I leave out ` + Ni(n.ignored, "shape or nested frame", "shapes and nested frames") + "."), { text: e.join(`
`) };
}
function js(n, e) {
  const t = n.replace(/\s+/g, " ").trim();
  return t.length > e ? t.slice(0, e - 1).trimEnd() + "…" : t;
}
function cw(n) {
  return /\b(change|turn|make|convert|edit|transform|restyle|relight|redo|update|switch)\b/i.test(n) && /\b(these|this|them|those|all|every|each|the)\b(\s+\w+){0,3}\s*\b(images?|pictures?|renders?|photos?|shots?|views?|ones)\b|\b(them|these|all of (them|these)|each of (them|these))\b/i.test(n);
}
function PN(n) {
  const e = /\b(?:to|into|as)\s+(.+?)(?:\s+\b(?:with|using|in|via|on)\b\s+.*|[.!?\n]|$)/i.exec(n);
  return e ? e[1].trim().replace(/^(an?|the)\s+/i, (t) => t.toLowerCase()) : "";
}
function EN(n, e, t) {
  const i = n.edits.findIndex((a) => a.match.test(e)), s = i >= 0 ? n.edits[i] : null, r = [
    "Turn this image into " + (s ? s.change : e || "the change described") + ".",
    "Keep the same building, camera angle, framing and materials."
  ];
  s && r.push(s.light);
  for (const a of t) r.push(K6(a));
  return r.push("Photorealistic architectural photograph."), { prompt: r.join(" "), name: s ? s.name : Xr(js(e || "Edited", 24)) + (s ? "" : " versions"), recipe: i };
}
function Yd(n) {
  return Math.max(1, n.model.numResults.max);
}
function Wh(n, e, t, i, s) {
  const o = Math.min(s.n, Yd(i)), r = q6(e), { prompt: a, name: l, recipe: d } = EN(n, s.change, r), c = Of(n, i.id), u = {};
  for (const f of c && c.settings || []) u[f.field] = f.value;
  s.quality && (u.Quality = s.quality), c && c.sizeFromInput && (u.size = "match");
  const p = {
    name: l,
    modelId: i.id,
    job: "edit",
    prompt: a,
    n: o,
    runs: t.map((f) => ({ imageIds: [f.id] })),
    settings: u,
    ...s.why ? { why: s.why } : {}
  };
  return {
    plan: {
      title: l,
      summary: "One session, one run per image, each with that image as its input" + (o > 1 ? ", " + o + " results a run" : "") + ".",
      sessions: [p]
    },
    recipe: d,
    name: l
  };
}
function RN(n, e, t) {
  const { context: i, catalog: s, guidance: o } = n;
  if (!i.images.length)
    return {
      text: "There are no images in “" + i.title + "” to change. Drag some into the frame, or ask me to make new ones.",
      chips: [{ label: "Make 4 concept images", send: "Make 4 concept images of a timber pavilion on a lake at dusk" }]
    };
  const r = yo(e.replace(/\b2\.5\b/g, "")), l = (r && r < i.images.length && /\b(first|these|the)\b/i.test(e) ? i.images.slice(0, r) : i.images).filter((L) => !L.video);
  if (!l.length) return { text: "Those are videos, and this prototype only edits still images." };
  const d = /(\d+|two|three|four)\s+(versions?|results?|options?|variations?)\s+(each|per image|of each)/i.exec(e), c = d && yo(d[1]) || 1, u = PN(e) || t && t.change || "", p = El(e, s, o), f = [];
  let y = null, b = "";
  if (p.length) {
    const L = Ff(p[0], "edit", s);
    if (L.entry && L.entry.imageField)
      y = L.entry, L.family && L.others.length ? (b = L.why || "", f.push(L.family.name + " comes in " + Ks(L.others.length + 1) + " versions here, " + Uo([L.entry, ...L.others].map((Z) => Z.name.replace(L.family.name, "").trim() || Z.name)) + ". I picked " + Un(L.entry.name) + ": " + b + ".")) : f.push("I'll use " + Un(L.entry.name) + ".");
    else {
      const Z = L.entry ? L.entry.name : L.family ? L.family.name : "That tool", J = Ui("edit", s, o)[0];
      if (!J) return Ao(i);
      y = J.entry, b = J.why, f.push((L.note || Z + " can't take an image as input, so it can't change these.") + " " + Un(y.name) + " can: " + J.why + ". I've used it instead.");
    }
  } else {
    const L = Ui("edit", s, o)[0];
    if (!L) return Ao(i);
    y = L.entry, b = L.why, f.push("I'll use " + Un(y.name) + ", RunDiffusion's pick for edits: it " + L.why + ".");
  }
  const w = Wh(o, i, l, y, { change: u, n: c, quality: void 0, why: b }), k = ov(w.plan, i, s);
  let S = w.plan;
  if (!k.ok) {
    const L = Ui("edit", s, o).find((Z) => Z.entry.id !== y.id && ov(Wh(o, i, l, Z.entry, { change: u, n: c }).plan, i, s).ok);
    if (!L) return { text: y.name + " can't run this: " + k.error + " I couldn't find another tool here that can." };
    f.length = 0, f.push(y.name + " can't run this as asked (" + k.error.replace(/\.$/, "") + "). " + Un(L.entry.name) + " can: it " + L.why + ". I've used it instead."), y = L.entry, S = Wh(o, i, l, y, { change: u, n: c }).plan;
  }
  const _ = l.length, x = _ === 1 ? "I'll edit this image with the change you asked for." : "I'll edit each image on its own so the " + Ks(_) + " stay comparable: one session, one run per image, each with that image as its input.", T = q6(i);
  T.length && f.push("I kept " + (T.length === 1 ? "your note" : "your notes") + " in the prompt: " + T.map((L) => "“" + js(L, 80).replace(/[.!]+$/, "") + "”").join(", ") + ".");
  const M = Of(o, y.id), z = (M && M.settings ? M.settings.map((L) => L.say) : []).concat(M && M.sizeFromInput ? ["sized to match your images"] : []);
  z.length && f.push((/recommended/i.test(e) ? "Recommended settings, as you asked: " : "Recommended settings: ") + Uo(z) + ".");
  const P = [], D = o.families.find((L) => L.members.includes(y.id) && L.members.length > 1) || null, $ = D ? D.members.map((L) => s.get(L)).find((L) => L && L.id !== y.id && !!L.imageField) : null;
  D && $ && P.push({ label: "Use " + ($.name.replace(D.name, "").trim() || $.name) + " instead", send: "Use " + $.name + " instead" });
  const O = S.sessions[0] ? S.sessions[0].n : 1;
  return O === 1 && Yd(y) > 1 && P.push({ label: "2 versions per image", send: "Make 2 versions per image" }), s.field(y, "Quality") && P.push({ label: "Medium quality, cheaper", send: "Use medium quality" }), {
    status: "Reading the frame…",
    text: [x, ...f].join(`

`),
    plan: S,
    chips: P,
    memo: { flow: "edit", step: "proposed", modelId: y.id, imageIds: l.map((L) => L.id), change: u, n: O, quality: t ? t.quality : void 0 }
  };
}
function zN(n, e, t) {
  const { context: i, catalog: s, guidance: o } = n;
  let r = t.modelId ? s.get(t.modelId) : null;
  if (!r) return null;
  const a = [];
  let l = t.n || 1, d = t.quality;
  const c = El(e, s, o);
  let u = !1;
  if (/\b(instead|switch|swap|use)\b/i.test(e) && c.length) {
    const w = Ff(c[0], "edit", s);
    if (w.entry && w.entry.imageField && w.entry.id !== r.id)
      r = w.entry, a.push("Switched to " + Un(r.name) + "."), u = !0;
    else if (w.entry && !w.entry.imageField)
      return { text: w.entry.name + " can't take an image as input, so I've kept " + r.name + "." };
  }
  const p = /(\d+|two|three|four)\s+(versions?|results?|options?|variations?)/i.exec(e);
  if (p) {
    const w = Math.max(1, Math.min(4, yo(p[1]) || 1));
    l = Math.min(w, Yd(r)), a.push(l < w ? r.name + " makes " + Ni(Yd(r), "result") + " a run, so it stays at " + Ni(l, "result") + " per image." : Ni(l, "result") + " per image."), u = !0;
  }
  const f = /\b(low|medium|high|extra high|xhigh|max)\b\s*quality|\bquality\s*(low|medium|high|max)\b|\bcheaper\b/i.exec(e);
  if (f && s.field(r, "Quality")) {
    const w = (f[1] || f[2] || "medium").toLowerCase().replace("extra high", "xhigh");
    d = f[0].toLowerCase().includes("cheaper") && !f[1] && !f[2] ? "medium" : w, a.push(Xr(d === "xhigh" ? "extra high" : d) + " quality."), u = !0;
  }
  if (!u) return null;
  const y = (t.imageIds || []).map((w) => i.images.find((k) => k.id === w)).filter((w) => !!w);
  if (!y.length) return null;
  const b = Wh(o, i, y, r, { change: t.change || "", n: l, quality: d });
  return {
    text: "Here's the plan again with that change. " + a.join(" "),
    plan: b.plan,
    chips: b.plan.sessions[0].n === 1 && Yd(r) > 1 ? [{ label: "2 versions per image", send: "Make 2 versions per image" }] : [],
    memo: { ...t, modelId: r.id, n: b.plan.sessions[0].n, quality: d }
  };
}
function $N(n) {
  return /\bcompar(e|ing|ison)\b|\bside[- ]by[- ]side\b|\bshoot-?out\b|\bhead[- ]to[- ]head\b|\bacross\s+(\d+|two|three|four)\s+(different\s+)?(image\s+)?(tools|models)\b/i.test(n);
}
function uw(n, e) {
  const { catalog: t, guidance: i } = n, s = i.jobs.compare, o = Ui("compare", t, i);
  if (o.length < 2) return { text: "There aren't enough image tools on this board's tool list to compare." };
  const r = Math.min(o.length, yo(e) && yo(e) >= 2 && yo(e) <= 5 ? yo(e) : s.suggest || 3), a = [s.intro + " From RunDiffusion's guidance:", ""];
  return o.forEach((l, d) => {
    const c = CN(t, l.entry);
    a.push(d + 1 + ". " + Un(l.entry.name) + ": " + l.why + (c ? ". " + Xr(c) + "." : "."));
  }), a.push("", "My " + Ks(r) + ": " + Uo(o.slice(0, r).map((l) => l.entry.name)) + ", a good spread of strengths at a fair price. Pick yours below, or name them."), {
    status: "Checking the tool list…",
    text: a.join(`
`),
    chips: [{ label: "Use your top " + r, send: "Use your top " + r }].concat(o.map((l) => ({ label: l.entry.name, send: l.entry.name }))),
    memo: { flow: "rig", step: "pick", picks: [], n: r }
  };
}
function Ad(n) {
  return /\b(tuned?|tuning|per[- ]tool|optimi[sz]ed?|each its own|adapt)/i.test(n) ? "tuned" : /\b(exact|same|identical|fair|verbatim|as[- ]is|one prompt)\b/i.test(n) ? "exact" : null;
}
function Pd(n) {
  const e = n.indexOf(":");
  return e >= 0 ? Ja(n.slice(e + 1)) : "";
}
function qh(n) {
  const e = n.trim();
  return e.length < 8 || /\?$/.test(e) || /^(yes|yeah|yep|no|nope|ok|okay|sure|thanks|thank you|cool|great|nice|done|that'?s it)\b/i.test(e) ? !1 : /\b(a|an|the)\b/i.test(e) || e.split(/\s+/).length >= 4;
}
function hw(n, e, t) {
  const { catalog: i, guidance: s } = n, o = t.n || s.jobs.compare.suggest || 3;
  let r = (t.picks || []).filter((l) => i.has(l));
  const a = [];
  if (t.step === "pick") {
    if (/\b(top|your|recommended|suggested|default)\b.*\b(\d|three|two|four|picks?|ones)\b|\byour picks\b|\bgo with yours\b|\bsounds good\b/i.test(e))
      r = Ui("compare", i, s).slice(0, o).map((c) => c.entry.id);
    else {
      const c = El(e, i, s);
      if (!c.length && !/\b(that'?s it|just these|done|only these)\b/i.test(e)) return null;
      const u = c.map((f) => Ff(f, "compare", i)), p = new Set(u.filter((f) => f.entry && !f.entry.needsImage).map((f) => f.entry.id));
      for (const f of u) {
        if (f.entry && !f.entry.needsImage) {
          r.includes(f.entry.id) || r.push(f.entry.id), f.family && f.others.length && f.why && a.push("For " + f.family.name + " I took " + Un(f.entry.name) + ": " + f.why + ".");
          continue;
        }
        const y = Ui("compare", i, s).find((k) => !r.includes(k.entry.id) && !p.has(k.entry.id)), b = f.entry ? f.entry.name : f.family ? f.family.name : "That tool", w = f.note || b + " needs an image to start from, so it can't run a prompt on its own.";
        y ? (r.push(y.entry.id), p.add(y.entry.id), a.push(w + " I've put " + Un(y.entry.name) + " in its place: " + y.why + ".")) : a.push(w);
      }
      if (r.length < 2 || r.length < o && !/\b(that'?s it|just these|done|only these)\b/i.test(e)) {
        const f = Ui("compare", i, s).filter((b) => !r.includes(b.entry.id)), y = r.map((b) => i.get(b).name);
        return {
          text: [a.join(" "), (y.length ? Uo(y) + ", noted. " : "") + (o - r.length === 1 ? "One more: pick it below, or name it." : o - r.length + " more: pick them below, or name them.") + (r.length >= 2 ? " Or say “that's it” to compare just these." : "")].filter(Boolean).join(`

`),
          chips: f.map((b) => ({ label: b.entry.name, send: b.entry.name })),
          memo: { ...t, picks: r }
        };
      }
    }
    const l = Ad(e), d = Pd(e);
    return vu(n, { ...t, picks: r, mode: l || void 0, prompt: d || void 0 }, a);
  }
  if (t.step === "mode") {
    const l = Ad(e), d = Pd(e) || (!l && qh(e) ? Ja(e) : "");
    if (!l && !d) return null;
    const c = !l && d ? ["I'll keep the exact same prompt for all of them, the fairest test. Say “tuned” to word it for each tool instead."] : [];
    return vu(n, { ...t, mode: l || "exact", prompt: d || t.prompt }, c);
  }
  if (t.step === "prompt") {
    const l = Ad(e), d = /:/.test(e) ? Pd(e) : Ja(e);
    return !qh(d) && !(d && d.split(/\s+/).length >= 2) ? null : vu(n, { ...t, mode: l || t.mode, prompt: d }, []);
  }
  if (t.step === "proposed") {
    const l = Ad(e), d = /:/.test(e) ? Pd(e) : qh(e) && !l ? Ja(e) : "";
    return !l && !d ? null : vu(n, { ...t, mode: l || t.mode, prompt: d || t.prompt }, ["Here's the rig again with that change."]);
  }
  return null;
}
function vu(n, e, t) {
  const { catalog: i, guidance: s } = n, o = (e.picks || []).map((d) => i.get(d)).filter((d) => !!d), r = Uo(o.map((d) => Un(d.name)));
  if (!e.mode)
    return {
      text: [t.join(" "), r + " it is. Should " + (o.length === 2 ? "both" : "all " + Ks(o.length)) + " get the exact same prompt, which is the fairest test, or should I tune the wording for each tool, closer to how each is best used? Then tell me the prompt."].filter(Boolean).join(`

`),
      chips: [{ label: "Exact prompt" }, { label: "Tuned per tool" }],
      memo: { ...e, flow: "rig", step: "mode" }
    };
  if (!e.prompt)
    return {
      text: [t.join(" "), (e.mode === "exact" ? "Exact prompt it is: every tool gets the same words." : "Tuned it is: I'll word the prompt for each tool, from RunDiffusion's prompt tips.") + " What's the prompt?"].filter(Boolean).join(`

`),
      chips: Bf.map((d) => ({ label: d })),
      memo: { ...e, flow: "rig", step: "prompt" }
    };
  const a = e.prompt, l = o.map((d) => ({
    name: d.name,
    modelId: d.id,
    job: "generate",
    prompt: e.mode === "tuned" ? O6(s, d.id, a) : a,
    n: 1,
    why: (s.jobs.compare.picks.find((c) => c.id === d.id) || { why: "" }).why
  }));
  return {
    status: "Laying out the rig…",
    text: [
      t.join(" "),
      "Here's the rig: " + Ks(o.length) + " sessions side by side in this frame, " + (e.mode === "tuned" ? "each with the prompt worded for its tool" : "the same prompt in each") + ", one picture apiece. Results land under their tools, so you can compare them right here.",
      e.mode === "tuned" ? "Each session's wording is on the plan; open any session to change it." : ""
    ].filter(Boolean).join(`

`),
    plan: {
      title: "Compare " + o.length + " tools",
      summary: o.length + " sessions side by side under one prompt: “" + js(a, 80) + "”.",
      place: !0,
      sessions: l
    },
    memo: { ...e, flow: "rig", step: "proposed" }
  };
}
function DN(n, e) {
  return /^\s*(now\s+)?(try|run|do)\s*[:,-]/i.test(n) || /^\s*now try\b/i.test(n) || /^\s*(another( one)?|next( prompt)?)\s*:/i.test(n) || /\brun\b.*\b(across|through|in)\b.*\b(all|each|every|these|the)\b.*\b(sessions?|tools?)\b/i.test(n) ? !0 : !!e && e.step === "ready" && qh(n) && !/\b(how|what|which|why)\b/i.test(n);
}
function ON(n, e, t) {
  const { context: i, catalog: s, guidance: o } = n, r = /:/.test(e) ? Pd(e) : Ja(e.replace(/\brun\b.*\b(across|through)\b.*?\b(sessions?|tools?)\b[:,]?/i, ""));
  if (!r) return { text: "What's the prompt? Write it after “Now try:” and I'll run it through every session here." };
  const a = [], l = [];
  for (const p of i.sessions) {
    const f = p.nodeDefId ? s.get(p.nodeDefId) : null;
    !f || f.needsImage || !W6.has(p.kitId) ? l.push(p.name) : a.push(p);
  }
  if (!a.length)
    return { text: "None of the sessions here can run a prompt on its own" + (l.length ? " (" + Uo(l) + " need an image to start from)" : "") + ". Want me to set up a comparison instead?", chips: [{ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }] };
  const d = Ad(e) || t && t.mode || "exact", c = a.map((p) => ({
    toolId: p.id,
    name: p.name,
    modelId: p.nodeDefId,
    prompt: d === "tuned" ? O6(o, p.nodeDefId, r) : r,
    n: 1
  })), u = a.length === 1 ? "the session" : a.length === 2 ? "both sessions" : "all " + Ks(a.length) + " sessions";
  return {
    status: "Reading the frame…",
    text: [
      "I'll run it through " + u + " in this frame, " + (d === "tuned" ? "with the wording tuned for each tool" : "the exact same prompt in each") + (t && t.mode ? ", as before" : "") + ". The results land in a new row under each tool.",
      l.length ? "I've left out " + Uo(l) + ": " + (l.length === 1 ? "it needs" : "they need") + " an image to start from." : "",
      !t || !t.mode ? "Say “tuned” to word it for each tool instead." : ""
    ].filter(Boolean).join(`

`),
    plan: {
      title: "New prompt across " + Ni(a.length, "session"),
      summary: "“" + js(r, 90) + "”, through " + u + " here.",
      place: !0,
      sessions: c
    },
    memo: { flow: "reuse", step: "proposed", mode: d, prompt: r }
  };
}
function LN(n) {
  return /\?\s*$/.test(n) || /^(how|what|which|why|when|should|can|could|is|are|do|does|any)\b/i.test(n.trim()) || /\b(tips?|advice|best way)\b/i.test(n);
}
function BN(n, e) {
  const { catalog: t, guidance: i } = n, s = El(e, t, i), o = Vh(e);
  if (/\bprompt|tips?|advice|best way|write\b/i.test(e) && s.length) {
    const r = s[0], a = r.entry ? r.entry.id : r.family ? r.family.members[0] : "", l = a ? Of(i, a) : null, d = r.entry ? r.entry.name : r.family ? r.family.name : "";
    if (l) {
      const c = [(l.tips.length > 3 ? Xr(Ks(l.tips.length)) + " things" : "A few things") + " that help " + d + (o === "text" ? " with signage and lettering" : "") + ":"];
      for (const f of l.tips) c.push("- " + f);
      const u = r.family && r.family.note, p = Ui(o, t, i)[0];
      return u && c.push("", "On this board: " + u + (p && o !== "edit" ? " For a new picture with " + (o === "text" ? "signage" : "this kind of work") + ", " + Un(p.entry.name) + " is the strongest here: " + p.why + "." : "")), { status: "Looking it up…", text: c.join(`
`), chips: o === "text" ? [{ label: "Which tools are best for text?" }] : [] };
    }
  }
  if (/\b(best|which|recommend|good)\b/i.test(e)) {
    const r = i.jobs[o], a = Ui(o, t, i);
    if (a.length) {
      const l = [r.intro];
      for (const d of a) l.push("- " + Un(d.entry.name) + ": " + d.why + ".");
      return {
        status: "Checking the tool list…",
        text: l.join(`
`),
        chips: [{ label: "Compare the top 3", send: "Compare " + Uo(a.slice(0, 3).map((d) => d.entry.name)) + " side by side" }]
      };
    }
  }
  return Ao(n.context);
}
function Ks(n) {
  return ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"][n] || String(n);
}
function FN(n) {
  return /\b(make|create|generate|render|draw|design|imagine|give me|show me|produce)\b/i.test(n);
}
function NN(n, e) {
  const { catalog: t, guidance: i } = n, s = El(e, t, i), o = Vh(e) === "edit" || Vh(e) === "compare" ? "photoreal" : Vh(e);
  let r = null, a = "";
  const l = [];
  if (s.length) {
    const y = Ff(s[0], o, t);
    if (y.entry && !y.entry.needsImage)
      r = y.entry, a = y.why || "", y.family && y.others.length && a && l.push("For " + y.family.name + " I took " + Un(r.name) + ": " + a + ".");
    else {
      const b = Ui(o, t, i)[0];
      if (!b) return Ao(n.context);
      l.push((y.note || (y.entry ? y.entry.name : "That tool") + " needs an image to start from.") + " I've used " + Un(b.entry.name) + " instead: " + b.why + "."), r = b.entry;
    }
  } else {
    const y = Ui(o, t, i)[0];
    if (!y) return Ao(n.context);
    r = y.entry, a = y.why, l.push("I'll use " + Un(r.name) + ", RunDiffusion's pick for " + i.jobs[o].label.toLowerCase() + ": " + a + ".");
  }
  const d = Ja(e.replace(/^\s*(please\s+)?(can you\s+)?(make|create|generate|render|draw|design|imagine|give me|show me|produce)\s+(me\s+)?/i, "").replace(/^(\d+|one|two|three|four|five|six|seven|eight|nine|ten|twelve|a|an|some)\s+/i, "").replace(/^((concept|new|quick|fresh)\s+)*(images?|pictures?|renders?|options?|versions?|concepts?|variations?|shots?)\s+(of\s+)?/i, "").replace(/\s+(with|using|in)\s+[^,]*?(nano banana|chatgpt|flux|seedream|ideogram|gpt)[^,.]*$/i, ""));
  if (!d || d.split(/\s+/).length < 2)
    return { text: "What should the pictures show? Describe the subject and I'll plan it.", chips: Bf.map((y) => ({ label: y, send: "Make 4 images of " + y.charAt(0).toLowerCase() + y.slice(1) })) };
  const c = Math.max(1, Math.min(12, yo(e.replace(/\b\d\.\d\b/g, "")) || 1)), u = t.results(r, c), p = Math.ceil(c / u), f = K6(d).replace(/\.$/, "") + ". " + (o === "photoreal" ? "Photorealistic architectural photograph, natural light." : "");
  return {
    status: "Reading the frame…",
    text: [
      "I'll add a session to this frame and make " + Ni(c, "picture") + (p > 1 ? " in " + p + " runs of " + u : "") + ". They'll land under the session.",
      ...l
    ].join(`

`),
    plan: {
      title: Xr(js(d, 32)),
      summary: "One new session, " + Ni(c, "picture") + ".",
      place: !0,
      sessions: [{ name: Xr(js(d.split(/[,.]/)[0], 28)), modelId: r.id, job: "generate", prompt: f.trim(), n: u, runs: Array.from({ length: p }, () => ({ imageIds: [] })), ...a ? { why: a } : {} }]
    },
    memo: { flow: "make", step: "proposed" }
  };
}
function UN(n, e) {
  const t = V6(n.history) || {}, i = e.results || 0;
  if (e.status === "cancelled") return null;
  if (e.status === "failed" || e.status === "stopped")
    return {
      text: "The plan stopped" + (e.error ? ": " + e.error.replace(/\.$/, "") : "") + "." + (i ? " " + Ni(i, "result") + " made it before it did." : " Nothing was charged for the steps that didn't run."),
      chips: [{ label: "What's in this frame?" }],
      memo: t
    };
  const s = e.sessions.some((r) => r.runs.some((a) => a.images && a.images.length));
  if (!s && (e.sessions.length > 1 || e.sessions.every((r) => !!r.toolId))) {
    const r = e.sessions.length, a = e.sessions.map((d) => pl(d.prompt)), l = Bf.filter((d) => !a.some((c) => c.includes(pl(d))));
    return {
      text: (r === 2 ? "Both are" : r === 1 ? "It's" : "All " + Ks(r) + " are") + " in, side by side under " + (r === 1 ? "the session" : "their tools") + ". Want to run another prompt across " + (r === 2 ? "both" : r === 1 ? "it" : "all " + Ks(r)) + "? Just type it, like “Now try: " + l[0].toLowerCase() + "”.",
      chips: l.slice(0, 2).map((d) => ({ label: "Now try: " + d.toLowerCase() })),
      memo: { flow: "rig", step: "ready", mode: t.mode || "exact" }
    };
  }
  if (s) {
    const r = e.sessions[0];
    return {
      text: "Done: " + Ni(i, "result") + " in “" + (r ? r.name : e.title) + "”. Click a thumbnail on the session to see one full size, or drag it onto the board.",
      chips: [{ label: "Make them dusk instead", send: "Change all of these images to dusk" }, { label: "What's in this frame?" }],
      memo: { flow: "edit", step: "ready" }
    };
  }
  return {
    text: "Done: " + Ni(i, "result") + " in the frame.",
    chips: [{ label: "What's in this frame?" }],
    memo: t
  };
}
function GN(n) {
  if (n.input.kind === "plan-ended") return UN(n, n.input.plan);
  const e = n.input.text.trim(), t = n.context, i = V6(n.history);
  if (!e) return Ao(t);
  if (/^(hi|hello|hey|hiya|yo|good (morning|afternoon|evening))\b[\s!.,]*$/i.test(e)) return IN(t);
  const s = /\bhow (should|do|can) i\b|\btips?\b|\badvice\b/i.test(e);
  if (i && i.flow === "rig" && (i.step === "pick" || i.step === "mode" || i.step === "prompt" || i.step === "proposed") && !s && !cw(e)) {
    const o = hw(n, e, i);
    if (o) return o;
  }
  if (i && i.flow === "edit" && i.step === "proposed" && !s) {
    const o = zN(n, e, i);
    if (o) return o;
  }
  if (/\bwhat('?s| is| are)?\s+(in|on)\s+(this|the)\s+frame\b|\bwhat do you see\b|\bdescribe (these|this|the)\b|\bwhat are these\b/i.test(e)) return AN(t);
  if (cw(e) && !s) return RN(n, e, null);
  if ($N(e) && !s) {
    const o = El(e, n.catalog, n.guidance);
    return o.length >= 2 && hw(n, e, { flow: "rig", step: "pick", picks: [], n: o.length }) || uw(n, e);
  }
  if (t.sessions.length && DN(e, i)) return ON(n, e, i);
  if (LN(e)) return BN(n, e);
  if (/\b(video|animate|animation|upscale|3d|mesh)\b/i.test(e)) {
    const o = Ao(t);
    return { ...o, text: "Video, upscale and 3D tools aren't part of this prototype's plans. " + o.text.replace("I can't do that one in this prototype. ", "") };
  }
  return FN(e) ? NN(n, e) : Ao(t);
}
const jN = (n) => new Promise((e) => window.setTimeout(e, n));
function Y6(n) {
  const e = [], t = n.split(/(\s+)/);
  let i = "", s = 0;
  for (const o of t)
    i += o, /\S/.test(o) && s++, (s >= 2 || o.includes(`
`)) && (e.push(i), i = "", s = 0);
  return i && e.push(i), e;
}
class HN {
  constructor(e = {}) {
    bu(this, "id", "simulated"), bu(this, "label", "Simulated assistant"), bu(this, "sleep"), bu(this, "pace"), this.sleep = e.sleep || jN, this.pace = e.pace == null ? 1 : e.pace;
  }
  wait(e) {
    return this.pace > 0 ? this.sleep(e * this.pace) : Promise.resolve();
  }
  async *turn(e, t) {
    const i = GN(e);
    if (i) {
      yield { type: "status", text: i.status || "Thinking…" }, await this.wait(500 + Math.min(700, i.text.length * 1.5));
      for (const s of Y6(i.text)) {
        if (t.aborted) return;
        yield { type: "text", delta: s }, await this.wait(16 + Math.random() * 22);
      }
      if (!t.aborted) {
        if (i.plan) {
          if (yield { type: "status", text: "Pricing the plan…" }, await this.wait(420), t.aborted) return;
          yield { type: "plan", plan: i.plan };
        }
        i.chips && i.chips.length && (yield { type: "chips", chips: i.chips }), i.memo && (yield { type: "memo", memo: i.memo });
      }
    }
  }
}
var VN = Object.defineProperty, WN = (n, e, t) => e in n ? VN(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, yu = (n, e, t) => WN(n, typeof e != "symbol" ? e + "" : e, t);
const X6 = 1, qN = 400, KN = 300 * 1024, dv = 90, u1 = dv * 24 * 3600 * 1e3, J6 = ["deletedAt", "hardDeleteAt", "deletedBy", "deletedByEmail", "shelvedAt"];
function yc(n) {
  if (n === null || typeof n != "object") return JSON.stringify(n === void 0 ? null : n);
  if (Array.isArray(n)) return "[" + n.map(yc).join(",") + "]";
  const e = n;
  return "{" + Object.keys(e).filter((i) => e[i] !== void 0).sort().map((i) => JSON.stringify(i) + ":" + yc(e[i])).join(",") + "}";
}
function $p(n) {
  if (Array.isArray(n)) return n.map((e) => $p(e));
  if (n && typeof n == "object" && Object.getPrototypeOf(n) === Object.prototype) {
    const e = {};
    for (const [t, i] of Object.entries(n))
      i !== void 0 && (e[t] = $p(i));
    return e;
  }
  return n;
}
function fl(n) {
  return yc(n).length;
}
function Kh(n, e, t, i = {}) {
  const s = $p({ ...n, createdBy: n.createdBy || e, updatedBy: e, updatedAt: t, ...i });
  for (const o of J6) s[o] == null && delete s[o];
  return s;
}
function Z6(n, e) {
  const t = { ...e };
  for (const i of J6) delete t[i];
  return { ...t, id: n };
}
function YN(n, e, t) {
  return { deletedAt: t, hardDeleteAt: t + u1, deletedBy: n, deletedByEmail: e || null, updatedBy: n, updatedAt: t };
}
function Bm(n) {
  return !n || n.deletedAt ? "deleted" : n.shelvedAt ? "shelved" : "live";
}
function Xd(n) {
  return !!(n && n.deletedAt);
}
function h1(n) {
  return !n || !n.deletedAt ? null : typeof n.hardDeleteAt == "number" ? n.hardDeleteAt : n.deletedAt + u1;
}
function Q6(n) {
  let e = null;
  for (const t of Object.values(n)) {
    const i = h1(t);
    i != null && (e == null || i < e) && (e = i);
  }
  return e;
}
function XN(n, e, t) {
  let i = null;
  for (const [s, o] of e) {
    if (Xd(s) || !Xd(o)) continue;
    const r = h1(o);
    r != null && (i == null || r < i) && (i = r);
  }
  return i != null ? n != null && n < i ? n : i : n != null ? null : Q6(t);
}
function JN(n, e, t) {
  const i = h1(e);
  return !e || i == null || i <= t ? null : {
    el: Z6(n, e),
    deletedAt: e.deletedAt,
    hardDeleteAt: i,
    deletedBy: e.deletedBy || void 0,
    deletedByEmail: e.deletedByEmail || void 0
  };
}
class e8 {
  constructor(e = qN, t = KN) {
    yu(this, "maxElements", e), yu(this, "maxBytes", t), yu(this, "home", /* @__PURE__ */ new Map()), yu(this, "use", /* @__PURE__ */ new Map());
  }
  /** What a bucket holds now, from its document (a load, or anyone's write). */
  setBucket(e, t) {
    let i = 0, s = 0;
    for (const [o, r] of Object.entries(t))
      r && (s++, i += fl(r), this.home.has(o) || this.home.set(o, e));
    this.use.set(e, { count: s, bytes: i });
  }
  bucketOf(e) {
    return this.home.get(e);
  }
  buckets() {
    return Array.from(this.use.keys());
  }
  usage(e) {
    return this.use.get(e);
  }
  /** A home for a new element; `newBucketId` names a bucket when none has room. */
  place(e, t, i) {
    const s = this.home.get(e);
    if (s) return s;
    let o = null, r = -1;
    for (const [d, c] of this.use)
      c.count + 1 > this.maxElements || c.bytes + t > this.maxBytes || c.count > r && (o = d, r = c.count);
    const a = o || i(), l = this.use.get(a) || { count: 0, bytes: 0 };
    return this.use.set(a, { count: l.count + 1, bytes: l.bytes + t }), this.home.set(e, a), a;
  }
  /** An element's size changed (a long note, more thumbnails). */
  grow(e, t) {
    const i = this.home.get(e), s = i ? this.use.get(i) : void 0;
    s && (s.bytes = Math.max(0, s.bytes + t));
  }
}
function pw(n, e, t, i = /* @__PURE__ */ new Set()) {
  const s = { upserted: [], removed: [], trash: !1 }, o = /* @__PURE__ */ new Set();
  for (const [r, a] of Object.entries(t)) {
    if (!a || (o.add(r), e.add(r), i.has(r))) continue;
    const l = n.get(r);
    if (l && yc(l) === yc(a)) continue;
    n.set(r, a), (Xd(l) || Xd(a)) && (s.trash = !0);
    const d = Bm(l);
    Bm(a) === "live" ? s.upserted.push(Z6(r, a)) : d === "live" && s.removed.push(r);
  }
  for (const r of Array.from(e)) {
    if (o.has(r) || i.has(r)) continue;
    e.delete(r);
    const a = n.get(r);
    n.delete(r), Xd(a) && (s.trash = !0), Bm(a) === "live" && s.removed.push(r);
  }
  return s;
}
function xu(n, e) {
  if (!n) return e;
  if (e.kind === "patch") {
    if (n.kind === "put") {
      const t = { ...n.data };
      for (const [i, s] of Object.entries(e.fields))
        s === void 0 ? delete t[i] : t[i] = s;
      return { kind: "put", data: t };
    }
    return n.kind === "patch" ? { kind: "patch", fields: { ...n.fields, ...e.fields } } : n;
  }
  return e;
}
function Fm(n, e) {
  if (e.kind === "put") return e.data;
  if (e.kind === "delete" || !n) return;
  const t = { ...n };
  for (const [i, s] of Object.entries(e.fields))
    s === void 0 ? delete t[i] : t[i] = s;
  return t;
}
const ZN = 40 * 1024, cv = 2e3;
function QN(n, e = 0) {
  let t = n.slice(-60), i = e + (n.length - t.length), s = fl(t);
  for (; t.length > 1 && s > ZN; )
    s -= fl(t[0]) + 1, t = t.slice(1), i++;
  return { messages: t, dropped: i };
}
function eU(n) {
  const e = String(n || "").replace(/\r\n/g, `
`).trim();
  return e.length > cv ? e.slice(0, cv - 1).trimEnd() + "…" : e;
}
function Yl(n, e) {
  const t = n.messages || [];
  for (let i = t.length - 1; i >= 0; i--) {
    const s = t[i].plan;
    if (s && s.id === e) return { index: i, message: t[i], plan: s };
  }
  return null;
}
function wu(n, e, t) {
  return n.map((i) => i.plan && i.plan.id === e ? { ...i, plan: { ...i.plan, ...t } } : i);
}
function tU(n) {
  return n.map((e) => e.plan && e.plan.status === "proposed" ? { ...e, plan: { ...e.plan, status: "cancelled", error: "Replaced by a newer plan" } } : e);
}
function nU(n) {
  const e = n.messages || [];
  for (let t = e.length - 1; t >= 0; t--) {
    const i = e[t], s = (i.text || "").replace(/\*\*/g, "").replace(/\s+/g, " ").trim();
    if (s) return { who: i.role === "agent" ? "Assistant" : i.author || "Someone", text: s };
    if (i.plan) return { who: "Assistant", text: "Plan: " + i.plan.title };
  }
  return null;
}
function iU(n) {
  const e = n.messages || [];
  for (let t = e.length - 1; t >= 0; t--) if (e[t].plan) return e[t].plan;
  return null;
}
function t8(n) {
  return (n.messages ? n.messages.length : 0) + (n.dropped || 0);
}
function n8(n) {
  return String(n || "").replace(/^([ \t]*)—[ \t]*/gm, "$1- ").replace(/[ \t]*—[ \t]*/g, ", ").replace(/,([ \t]*,)+/g, ",").replace(/\bcoming soon\b/gi, (e) => e[0] === "C" ? "In development" : "in development");
}
function sU(n, e) {
  const t = n ? { usd: n.usd, credits: n.credits, turns: n.turns, byModel: { ...n.byModel } } : { usd: 0, credits: 0, turns: 0, byModel: {} };
  t.usd += e.usd || 0, t.credits += e.credits || 0, t.turns += 1;
  const i = t.byModel[e.model] || { usd: 0, turns: 0 };
  return t.byModel[e.model] = { usd: i.usd + (e.usd || 0), turns: i.turns + 1 }, t;
}
function Nm(n) {
  return n === 0 ? "$0" : "$" + (n < 0.1 ? n.toFixed(4) : n.toFixed(2));
}
var oU = Object.defineProperty, rU = (n, e, t) => e in n ? oU(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, fn = (n, e, t) => rU(n, typeof e != "symbol" ? e + "" : e, t);
const aU = 464, yi = "simulated", uv = "unavailable";
class fw {
  constructor(e) {
    fn(this, "reason", e), fn(this, "id", uv), fn(this, "label", "Unavailable");
  }
  // eslint-disable-next-line require-yield
  async *turn() {
    yield { type: "text", delta: this.reason };
  }
}
const mw = (n) => "rd-smart-frames-model:" + n;
class lU {
  constructor(e, t) {
    fn(this, "board", e), fn(this, "live", /* @__PURE__ */ Xt({})), fn(this, "brain", /* @__PURE__ */ We(yi)), fn(this, "agentStatus", /* @__PURE__ */ We(null)), fn(this, "canSimulate"), fn(this, "showCosts"), fn(this, "endpoint"), fn(this, "asksAgent"), fn(this, "agentReady", null), fn(this, "usage", /* @__PURE__ */ Xt({})), fn(this, "driver"), fn(this, "simulated"), fn(this, "running", /* @__PURE__ */ new Map()), fn(this, "aborts", /* @__PURE__ */ new Map()), fn(this, "scope", L0(!0)), fn(this, "disposed", !1), fn(this, "open"), this.simulated = t || new HN(), this.canSimulate = !!t || t1, this.showCosts = !!e.user.isAdmin, this.endpoint = t ? null : e.agent ? { url: e.agent.url, token: e.agent.token, teamId: e.user.teamId || null } : null, this.asksAgent = !!this.endpoint, this.driver = this.canSimulate ? this.simulated : new fw("The chat isn't available here."), this.brain.value = this.canSimulate ? yi : uv, this.endpoint && (this.agentReady = this.refreshAgent().catch(() => {
    })), this.open = this.scope.run(() => I(() => {
      const i = e.ui.chatOpen;
      if (!i) return null;
      e.rev(i).value;
      const s = e.store.get(i);
      return s && s.type === "chat" ? { ...s } : null;
    })), this.scope.run(() => {
      $e(() => e.docRev.value, () => {
        const i = e.ui.chatOpen;
        i && !e.store.get(i) && (e.ui.chatOpen = null);
      }), $e(() => e.ui.chatOpen, (i, s) => {
        i && (e.ui.boardHistory && (e.ui.boardHistory = !1), e.comments.ui.panelOpen && (e.comments.ui.panelOpen = !1), i !== s && this.onOpen(i));
      }), $e(() => e.ui.boardHistory || e.comments.ui.panelOpen, (i) => {
        i && e.ui.chatOpen && (e.ui.chatOpen = null);
      }), $e(() => e.ui.selection.slice(), (i) => {
        if (i.length !== 1 || e.ui.marquee) return;
        const s = e.store.get(i[0]);
        s && s.type === "chat" && e.ui.chatOpen !== s.id && (e.ui.chatOpen = s.id);
      }), $e(() => e.loaded.value, (i) => {
        i && this.recover();
      }, { immediate: !0 });
    });
  }
  setDriver(e) {
    this.driver = e;
  }
  get driverLabel() {
    return this.answerer().label;
  }
  /** A tour drives this board (src/onboarding): its scripted brain answers, and there's no model to pick. */
  get guided() {
    return !!(this.board.tour && this.board.tour.chat);
  }
  /** Who answers the next turn: the tour's brain while one drives the board, else this person's pick. */
  answerer() {
    const e = this.board.tour;
    return e && e.chat || this.driver;
  }
  /** Ask the agent again, and answer with this person's model (the default one, unless they picked another or the simulated brain). */
  async refreshAgent() {
    if (!this.endpoint) return;
    const e = await oN(this.endpoint);
    if (this.disposed) return;
    this.agentStatus.value = e;
    let t = null;
    try {
      t = window.localStorage.getItem(mw(this.board.user.uid));
    } catch {
      t = null;
    }
    const i = e.ready && e.models || [];
    this.useBrain(t === yi && this.canSimulate || !i.length ? yi : (i.find((s) => s.id === t) || i[0]).id);
  }
  /** The models the agent offers (none until it's asked, or without a key). */
  get models() {
    const e = this.agentStatus.value;
    return e && e.ready && e.models || [];
  }
  useBrain(e) {
    const t = this.models.find((i) => i.id === e);
    if (t)
      this.driver = new mN({ model: t, boardId: this.board.meta.id, uid: this.board.user.uid, endpoint: this.endpoint || void 0 }), this.brain.value = t.id;
    else if (this.canSimulate)
      this.driver = this.simulated, this.brain.value = yi;
    else {
      const i = this.agentStatus.value;
      this.driver = new fw(i && i.reason || "The chat isn't available right now. Try again in a little while."), this.brain.value = uv;
    }
  }
  /** This person's pick of brain (SIMULATED or a model's id), kept in this browser. */
  setBrain(e) {
    if (!(e === yi && !this.canSimulate)) {
      try {
        window.localStorage.setItem(mw(this.board.user.uid), e);
      } catch {
      }
      this.useBrain(e);
    }
  }
  // ------------------------------------------------------------ reading
  chat(e) {
    const t = this.board.store.get(e);
    return t && t.type === "chat" ? t : null;
  }
  /** The frame a chat's card sits in: its context. */
  frameOf(e) {
    const t = qe(e), i = this.board.store.query(t).filter((s) => s.type === "frame");
    return WF(i, e);
  }
  /** What the chat sees now. Reactive: it follows the board, its results and its prompts. */
  contextOf(e) {
    this.board.docRev.value, this.board.results.rev.value, this.board.promptRev.value;
    const t = this.frameOf(e);
    return t ? Rm(Am(this.board), t, e.id) : null;
  }
  /** The chats in a frame, in reading order. */
  chatsIn(e) {
    return this.board.childrenOf(e).map((t) => this.board.store.get(t)).filter((t) => !!t && t.type === "chat");
  }
  /** Every chat on the board, the most recently active first. */
  allChats() {
    this.board.docRev.value;
    const e = [];
    for (const i of this.board.store.all()) i.type === "chat" && e.push(i);
    const t = (i) => (i.messages && i.messages.length ? i.messages[i.messages.length - 1].at : 0) || i.updatedAt || 0;
    return e.sort((i, s) => t(s) - t(i));
  }
  busy(e) {
    return !!this.live[e];
  }
  /** A plan this page is running. */
  isRunningHere(e) {
    return this.running.has(e);
  }
  // ------------------------------------------------------------ chats in frames
  /** "Chat 1", "Chat 2"… per frame. */
  nextName(e) {
    let t = 0;
    for (const i of this.chatsIn(e)) {
      const s = /^Chat (\d+)$/.exec(i.name || "");
      s && (t = Math.max(t, Number(s[1])));
    }
    return "Chat " + (t + 1);
  }
  /** A new chat card in the frame's first clear spot (the frame grows when it has none), selected and open. */
  createChat(e) {
    const t = this.board, i = t.store.get(e);
    if (!i || i.type !== "frame") return null;
    const s = i, o = t.childrenOf(s).map((c) => t.store.get(c)).filter(Boolean).map((c) => qe(c)), r = qe(s), a = rv(r, o, Ua.w, Ua.h) || av(r, o), l = {
      id: kt(),
      type: "chat",
      x: a.x,
      y: a.y,
      w: Ua.w,
      h: Ua.h,
      z: 0,
      name: this.nextName(s),
      messages: [],
      createdBy: t.user.uid
    };
    l.z = t.store.nextZ(l);
    const d = lv(r, [qe(l)]);
    return t.store.batch("Add chat", () => {
      d && t.store.update(s.id, { w: d.w, h: d.h }), t.store.add([l]);
    }), t.ui.selection = [l.id], t.ui.chatOpen = l.id, l;
  }
  close() {
    this.board.ui.chatOpen = null;
  }
  /**
   * A recommended tool, tried: a new session with it in the chat's frame (in
   * its first clear spot, the frame growing when it has none), selected so
   * its prompt opens. Nothing runs: the person writes the prompt.
   */
  addTool(e, t) {
    const i = this.board, s = this.chat(e), o = s ? this.frameOf(s) : null, r = this.catalogView(), a = r.get(t);
    if (!o || !a) return null;
    const l = r.kitFor(a, "generate"), d = qe(o), c = i.childrenOf(o).map((f) => i.store.get(f)).filter(Boolean).map((f) => qe(f)), u = rv(d, c, Tt.w, Tt.h) || av(d, c);
    let p = null;
    return i.store.batch("Add session", () => {
      p = i.addSession(l, a.model, i.uniqueSessionName(a.name), { x: u.x + Tt.w / 2, y: u.y + Tt.h / 2 }, { quiet: !0 }), i.store.update(p.id, { x: u.x, y: u.y });
      const f = lv(d, [{ x: u.x, y: u.y, w: Tt.w, h: Tt.h }]);
      f && i.store.update(o.id, { x: f.x, y: f.y, w: f.w, h: f.h });
    }), p && (i.ui.selection = [p.id]), p;
  }
  /** Opening a chat: its frame comes into view beside the panel, and its images' records are read for the context. */
  onOpen(e) {
    const t = this.chat(e);
    if (!t) return;
    const i = this.frameOf(t);
    if (i) {
      this.showFrame(i, !1);
      for (const s of this.board.childrenOf(i)) {
        const o = this.board.store.get(s);
        o && o.type === "image" && o.resultId && !this.board.results.get(o.resultId) && this.board.loadRecord(o.resultId).catch(() => {
        });
      }
    }
  }
  /** Where the board can be seen beside the chat panel, in the stage's pixels. */
  freeArea() {
    const e = this.board.view;
    return { x: 76, y: 16, w: Math.max(240, e.w - 76 - aU), h: Math.max(200, e.h - 16 - 110) };
  }
  /** Bring a frame into view beside the panel; `always`, even when it's already in view. */
  showFrame(e, t) {
    const i = this.board.engine;
    if (!i) return;
    const s = qe(e), o = this.board.cam.value, r = this.freeArea(), a = s.x * o.zoom + o.x, l = s.y * o.zoom + o.y;
    if (a >= r.x && l >= r.y + 24 && a + s.w * o.zoom <= r.x + r.w && l + s.h * o.zoom <= r.y + r.h && s.w * o.zoom > r.w * 0.3 && !t) return;
    const c = zf(s, r.w, r.h, 48, 1);
    i.animateCamera({ zoom: No(c.zoom), x: c.x + r.x, y: c.y + r.y + 12 }, 460);
  }
  // ------------------------------------------------------------ the transcript
  /** Change a chat's transcript (capped), outside the undo history: a conversation isn't undone. `also` patches the chat with it (its spend). */
  write(e, t, i = {}) {
    const s = this.chat(e);
    if (!s) return;
    const o = QN(t((s.messages || []).slice()), s.dropped || 0);
    this.board.store.update(e, { ...i, messages: o.messages, dropped: o.dropped || void 0 }, { history: !1 });
  }
  catalogView() {
    return new z6(this.board.catalog.value, !!this.board.user.isAdmin);
  }
  /** A person's message, and the agent's answer to it. */
  async send(e, t) {
    const i = eU(t), s = this.chat(e);
    if (!i || !s || this.busy(e)) return;
    const o = this.frameOf(s);
    if (!o) {
      this.board.toast("Move this chat into a frame first: everything in its frame is what it works with.");
      return;
    }
    const r = Rm(Am(this.board), o, s.id), a = (s.messages || []).slice(), l = this.board.user;
    this.write(e, (d) => d.concat({
      id: kt(),
      role: "user",
      author: l.name || l.initials || "You",
      authorId: l.uid,
      at: Date.now(),
      text: i,
      context: D6(r)
    })), await this.answer(e, { kind: "message", text: i, author: l.name || "You" }, a, r);
  }
  /** Ask the agent for its next message, stream it, and put it in the transcript. */
  async answer(e, t, i, s) {
    const o = this.catalogView(), r = { status: "Thinking…", text: "", plan: null, chips: [], picks: [], ideas: [] };
    this.live[e] = r;
    const a = new AbortController();
    this.aborts.set(e, a);
    let l, d, c = "";
    try {
      if (this.agentReady && !this.guided && await this.agentReady, this.disposed || a.signal.aborted) return;
      const b = this.chat(e), w = { input: t, context: s, history: i, dropped: b && b.dropped || 0, chatId: e, catalog: o, guidance: YF };
      for await (const k of this.answerer().turn(w, a.signal)) {
        if (this.disposed || a.signal.aborted) return;
        const S = this.live[e];
        if (!S) return;
        if (k.type === "status") S.status = k.text;
        else if (k.type === "text")
          S.status = null, S.text += k.delta;
        else if (k.type === "plan") {
          const _ = ov(k.plan, s, o);
          _.ok ? S.plan = _.plan : S.text += (S.text ? `

` : "") + "I couldn't put that plan together: " + _.error, S.status = null;
        } else if (k.type === "chips") S.chips = k.chips;
        else if (k.type === "picks")
          S.picks = k.picks.filter((_) => o.has(_.modelId)), S.status = null;
        else if (k.type === "ideas")
          S.ideas = k.ideas.map((_) => _.modelId && !o.has(_.modelId) ? { title: _.title, pitch: _.pitch } : _), S.status = null;
        else if (k.type === "usage") {
          this.usage[e] = k.usage;
          const _ = k.usage;
          d = { model: _.model, usd: _.usd, credits: _.credits, input: _.input, cached: _.cached, output: _.output, ms: _.ms };
        } else k.type === "memo" && (l = k.memo);
      }
    } catch (b) {
      console.error("[board] the chat's answer failed", b), c = "Something went wrong while I was answering. Please try again.";
    } finally {
      this.aborts.delete(e);
    }
    const u = this.live[e];
    if (delete this.live[e], this.disposed || !u || !this.chat(e)) return;
    const p = n8(u.text.trim() || c).trim();
    if (!p && !u.plan && !u.picks.length && !u.ideas.length) return;
    const f = { id: kt(), role: "agent", author: "Assistant", at: Date.now(), text: p };
    u.plan && (f.plan = u.plan), u.picks.length && (f.picks = u.picks), u.ideas.length && (f.ideas = u.ideas), u.chips.length && (f.chips = u.chips), l && (f.memo = l), d && (f.usage = d);
    const y = this.chat(e);
    this.write(e, (b) => (u.plan ? tU(b) : b).concat(f), d && y ? { spend: sU(y.spend, d) } : {});
  }
  /** Stop an answer on its way (the chat closed, the card was deleted). */
  stopAnswer(e) {
    const t = this.aborts.get(e);
    t && t.abort(), delete this.live[e];
  }
  // ------------------------------------------------------------ plans
  /** Run a proposed plan: one click, the board's own commands, progress in the transcript as it goes. */
  async runPlan(e, t) {
    const i = this.chat(e), s = i ? Yl(i, t) : null;
    if (!i || !s || s.plan.status !== "proposed") return;
    const o = this.frameOf(i);
    if (!o) {
      this.board.toast("Move this chat back into a frame to run its plan.");
      return;
    }
    const r = this.board.user;
    this.write(e, (b) => wu(b, t, { status: "running", ranBy: r.name || r.initials || "You", ranById: r.uid, ranAt: Date.now(), steps: [] }));
    const a = Yl(this.chat(e), t).plan, l = new _N(OF(this.board), a, o.id, (b) => this.onProgress(e, t, o.id, b));
    this.running.set(t, { chatId: e, runner: l });
    let d;
    try {
      d = await l.run();
    } catch (b) {
      console.error("[board] the plan failed", b), d = { status: "failed", steps: [], added: {}, results: 0, error: "Something went wrong while it ran." };
    } finally {
      this.running.delete(t);
    }
    if (this.disposed || !this.chat(e)) return;
    const c = d.status === "cancelled" ? "cancelled" : d.status;
    this.write(e, (b) => wu(b, t, {
      status: c,
      endedAt: Date.now(),
      results: d.results,
      ...d.steps.length ? { steps: d.steps } : {},
      ...d.error ? { error: d.error } : {},
      sessions: a.sessions.map((w) => this.withAdded(w, d.added[w.key]))
    }));
    const u = this.board.store.get(o.id);
    u && u.type === "frame" && this.showFrame(u, !1);
    const p = this.chat(e), f = p ? Yl(p, t) : null, y = p ? this.frameOf(p) : null;
    p && f && y && c !== "cancelled" && await this.answer(e, { kind: "plan-ended", plan: f.plan }, (p.messages || []).slice(), Rm(Am(this.board), y, p.id));
  }
  onProgress(e, t, i, s) {
    if (this.disposed) return;
    const o = this.chat(e), r = o ? Yl(o, t) : null;
    if (!r) return;
    this.write(e, (l) => wu(l, t, {
      steps: s.steps,
      results: s.results,
      sessions: r.plan.sessions.map((d) => this.withAdded(d, s.added[d.key]))
    }));
    const a = this.board.store.get(i);
    a && a.type === "frame" && this.board.ui.chatOpen === e && this.showFrame(a, !1);
  }
  /** A plan's session with the one it added, under the name the board gave it ("Night versions 2"). */
  withAdded(e, t) {
    if (!t) return e;
    const i = this.board.store.get(t);
    return { ...e, addedId: t, ...i && i.type === "tool" ? { name: i.name } : {} };
  }
  /** Cancel a plan not yet run; stop one running here before its next step. */
  cancelPlan(e, t) {
    const i = this.chat(e), s = i ? Yl(i, t) : null;
    if (!s) return;
    if (s.plan.status === "proposed") {
      this.write(e, (r) => wu(r, t, { status: "cancelled", endedAt: Date.now() }));
      return;
    }
    const o = this.running.get(t);
    o && o.runner.cancel();
  }
  /**
   * Plans this person started that were running when their page closed: a
   * runner lives in the page that started it, so they're stopped where they
   * were (what ran stays on the board).
   */
  recover() {
    const e = this.board.user.uid;
    for (const t of this.board.store.all()) {
      if (t.type !== "chat") continue;
      const i = t, s = (i.messages || []).filter((o) => o.plan && o.plan.status === "running" && o.plan.ranById === e && !this.running.has(o.plan.id));
      s.length && this.write(i.id, (o) => o.map((r) => s.some((a) => a.id === r.id) && r.plan ? { ...r, plan: { ...r.plan, status: "stopped", error: "The page running it closed before it finished", endedAt: Date.now() } } : r));
    }
  }
  dispose() {
    this.disposed = !0;
    for (const e of this.running.values()) e.runner.cancel();
    this.running.clear();
    for (const e of this.aborts.values()) e.abort();
    this.aborts.clear(), this.scope.stop();
  }
}
const Dp = /* @__PURE__ */ new WeakMap();
function fs(n) {
  let e = Dp.get(n);
  return e || (e = new lU(n), Dp.set(n, e)), e;
}
function dU(n) {
  const e = Dp.get(n);
  e && e.dispose(), Dp.delete(n);
}
const cU = ["aria-pressed"], uU = { class: "tip" }, hU = ["aria-label", "aria-pressed", "data-testid", "onClick"], pU = { class: "tip" }, fU = { class: "tip" }, mU = { style: { opacity: ".5", "margin-left": "6px" } }, gU = { class: "tip" }, bU = { style: { opacity: ".5", "margin-left": "6px" } }, vU = ["aria-expanded"], yU = {
  key: 0,
  class: "tip"
}, xU = {
  key: 0,
  class: "bd-pm-sep",
  role: "separator"
}, wU = ["disabled", "data-testid", "onClick"], kU = { class: "bd-pm-ic is-plain is-bare" }, _U = { class: "lbl" }, SU = { key: 0 }, TU = /* @__PURE__ */ Re({
  __name: "ContextToolbar",
  setup(n) {
    const { board: e } = tt(), t = /* @__PURE__ */ K(null), i = /* @__PURE__ */ K(160), s = I(() => e.selectedEls.value), o = I(() => s.value.length > 1), r = I(() => s.value.length === 1 ? s.value[0] : null), a = I(() => !!r.value && r.value.type === "image"), l = I(() => !!r.value && r.value.type === "shape"), d = I(() => !!r.value && r.value.type === "frame");
    function c() {
      r.value && fs(e).createChat(r.value.id);
    }
    const u = I(() => s.value.some((se) => se.type === "note")), p = I(() => {
      const se = new Set(s.value.filter((Y) => Y.type === "note").map((Y) => Y.tint || "glass"));
      return se.size === 1 ? Array.from(se)[0] : null;
    }), f = I(() => s.value.length > 0 && !(s.value.length === 1 && s.value[0].type === "frame")), y = I(() => s.value.length === 1 && qd(s.value[0])), b = I(() => s.value.filter((se) => se.type === "frame")), w = I(() => b.value.length > 0 && b.value.every((se) => se.locked)), k = Tn(["mod", "shift", "L"]), S = I(() => l.value ? r.value.stroke || qs.stroke : ""), _ = I(() => s.value.length > 0 && !e.ui.marquee && !e.ui.dragging && !e.ui.studio), x = I(() => !!e.ui.editingNote);
    function T(se) {
      x.value && se.preventDefault();
    }
    const M = I(() => a.value && !r.value.video), z = I(() => a.value && e.isPinnedImage(r.value.src));
    function P() {
      const se = r.value;
      e.togglePinImage(R6(se, se.resultId && e.results.get(se.resultId) || null));
    }
    const D = I(() => {
      if (!a.value || !e.promptLibrary.canSave) return !1;
      const se = r.value.resultId;
      if (!se) return !1;
      const Y = e.results.get(se);
      return !Y || !!Y.prompt && Y.status === "done";
    }), $ = I(() => {
      e.docRev.value;
      const se = e.cam.value;
      let Y = 1 / 0, ie = 1 / 0, De = -1 / 0, xe = -1 / 0;
      for (const Oe of s.value) {
        const Ee = qe(Oe);
        Y = Math.min(Y, Ee.x), ie = Math.min(ie, Ee.y), De = Math.max(De, Ee.x + Ee.w), xe = Math.max(xe, Ee.y + Ee.h);
      }
      return {
        cx: (Y + De) / 2 * se.zoom + se.x + e.view.left,
        top: ie * se.zoom + se.y + e.view.top,
        bottom: xe * se.zoom + se.y + e.view.top
      };
    }), O = I(() => {
      const se = i.value, Y = Math.min(Math.max(8, $.value.cx - se / 2), window.innerWidth - se - 8), ie = $.value.top - 50, De = ie < 62 ? Math.min(window.innerHeight - 60, $.value.bottom + 12) : ie;
      return { left: Y, top: De };
    });
    $e(() => [_.value, s.value.length, a.value, l.value, d.value, u.value, o.value, y.value, D.value], () => {
      it(() => {
        t.value && (i.value = t.value.offsetWidth);
      });
    }, { immediate: !0 });
    function L() {
      const se = s.value[0];
      se && (e.ui.selection = [], e.comments.draftOn(se));
    }
    function Z(se) {
      e.ctxAction(se);
    }
    const J = /* @__PURE__ */ K(null), re = I(() => _.value && e.ui.ctxMenu), F = /* @__PURE__ */ K({ w: 220, h: 0, barH: 42 }), W = I(() => {
      const se = [
        { id: "copy", icon: "Clipboard", label: "Copy", keys: Tn(["mod", "C"]) },
        { id: "duplicate", icon: "Copy", label: "Duplicate", keys: Tn(["mod", "D"]) }
      ];
      return r.value && r.value.type === "frame" && se.push({ id: "rename", icon: "Pencil", label: "Rename" }), b.value.length && se.push({ id: "lock", icon: w.value ? "LockOpen" : "Lock", label: w.value ? "Unlock" : "Lock", keys: k, sepBefore: !0 }), se.push({ id: "delete", icon: "Trash2", label: "Delete", keys: Tn(["del"]), off: s.value.every((Y) => e.isHeld(Y)), danger: !0, sepBefore: !0 }), se;
    }), ee = I(() => {
      const se = F.value, Y = Math.min(Math.max(8, O.value.left + i.value - se.w), window.innerWidth - se.w - 8), ie = O.value.top + se.barH + 6, De = ie + se.h > window.innerHeight - 8 && O.value.top - 6 - se.h >= 8;
      return { left: Y, top: De ? O.value.top - 6 - se.h : ie, up: De };
    });
    function N() {
      e.ui.ctxMenu = !1;
    }
    function te() {
      e.ui.ctxMenu = !e.ui.ctxMenu;
    }
    function G(se) {
      const Y = se.target;
      Y && (J.value && J.value.contains(Y) || t.value && t.value.contains(Y)) || N();
    }
    $e(re, (se) => {
      if (!se) {
        window.removeEventListener("pointerdown", G, !0);
        return;
      }
      window.addEventListener("pointerdown", G, !0), it(() => {
        const Y = J.value;
        Y && (F.value = { w: Y.offsetWidth, h: Y.offsetHeight, barH: t.value ? t.value.offsetHeight : 42 }, Y.focus({ preventScroll: !0 }));
      });
    }), $e(() => e.ui.selection, N), $e(_, (se) => {
      se || N();
    }), Ve(() => {
      window.removeEventListener("pointerdown", G, !0), N();
    });
    function q(se) {
      se.off || (N(), Z(se.id));
    }
    function B() {
      return J.value ? Array.from(J.value.querySelectorAll(".bd-pm-row:not(:disabled)")) : [];
    }
    function ne(se) {
      const Y = se.key;
      if (Y === "ArrowDown" || Y === "ArrowUp" || Y === "Home" || Y === "End") {
        se.preventDefault(), se.stopPropagation();
        const ie = B(), De = ie.indexOf(document.activeElement), xe = Y === "Home" ? 0 : Y === "End" ? ie.length - 1 : De < 0 ? Y === "ArrowDown" ? 0 : ie.length - 1 : (De + (Y === "ArrowDown" ? 1 : -1) + ie.length) % ie.length;
        ie[xe] && ie[xe].focus();
      } else Y === "Escape" ? (se.preventDefault(), se.stopPropagation(), N()) : Y === "Tab" ? se.preventDefault() : (Y === "Enter" || Y === " ") && se.stopPropagation();
    }
    return (se, Y) => (g(), v(H, null, [
      _.value ? (g(), v("div", {
        ref_key: "bar",
        ref: t,
        key: s.value.length + (a.value ? "i" : "") + (l.value ? "s" : "") + (d.value ? "f" : "") + (o.value ? "m" : "") + (y.value ? "l" : ""),
        class: "cv-ctxbar",
        "data-testid": "context-toolbar",
        style: de({ left: O.value.left + "px", top: O.value.top + "px" }),
        onPointerdown: Pe(T, ["stop"])
      }, [
        a.value ? (g(), v(H, { key: 0 }, [
          M.value ? (g(), v("button", {
            key: 0,
            class: "cv-ctx-info",
            title: "Edit in Studio view, in its session",
            "data-testid": "ctx-edit",
            onClick: Y[0] || (Y[0] = (ie) => Z("edit"))
          }, [
            C(R, {
              name: "Wand2",
              size: 13
            }),
            Y[19] || (Y[19] = X(" Edit", -1))
          ])) : E("", !0),
          h("button", {
            class: "cv-ctx-info",
            title: "Image info",
            onClick: Y[1] || (Y[1] = (ie) => Z("info"))
          }, [
            C(R, {
              name: "Info",
              size: 13
            }),
            Y[20] || (Y[20] = X(" Info", -1))
          ]),
          h("button", {
            title: "Download",
            onClick: Y[2] || (Y[2] = (ie) => Z("download"))
          }, [
            C(R, {
              name: "Download",
              size: 14
            }),
            Y[21] || (Y[21] = h("span", { class: "tip" }, "Download", -1))
          ]),
          h("button", {
            title: "Use as reference",
            onClick: Y[3] || (Y[3] = (ie) => Z("reference"))
          }, [
            C(R, {
              name: "ImagePlus",
              size: 14
            }),
            Y[22] || (Y[22] = h("span", { class: "tip" }, "Use as reference", -1))
          ]),
          h("button", {
            class: U(["is-pin", { on: z.value }]),
            "aria-pressed": z.value,
            "data-testid": "ctx-pin",
            onClick: P
          }, [
            C(R, {
              name: "Pin",
              size: 14
            }),
            h("span", uU, A(z.value ? m(jn).unpin : m(jn).pin), 1)
          ], 10, cU),
          D.value ? (g(), v("button", {
            key: 1,
            title: "Save to the prompt library",
            "data-testid": "ctx-save-prompt",
            onClick: Y[4] || (Y[4] = (ie) => Z("save-prompt"))
          }, [
            C(R, {
              name: "Bookmark",
              size: 14
            }),
            Y[23] || (Y[23] = h("span", { class: "tip" }, "Save to the prompt library", -1))
          ])) : E("", !0),
          Y[24] || (Y[24] = h("span", { class: "sep" }, null, -1))
        ], 64)) : E("", !0),
        d.value ? (g(), v(H, { key: 1 }, [
          h("button", {
            class: "cv-ctx-info is-chat",
            title: "Start a chat about everything in this frame",
            "data-testid": "ctx-chat",
            onClick: c
          }, [
            C(R, {
              name: "MessageSquarePlus",
              size: 13
            }),
            Y[25] || (Y[25] = X(" Chat", -1))
          ]),
          Y[26] || (Y[26] = h("span", { class: "sep" }, null, -1))
        ], 64)) : E("", !0),
        l.value ? (g(), v(H, { key: 2 }, [
          h("button", {
            class: "cv-ctx-edit",
            title: "Stroke colour and width",
            onClick: Y[5] || (Y[5] = (ie) => Z("style"))
          }, [
            h("span", {
              class: "swatch",
              style: de({ background: S.value })
            }, null, 4),
            Y[27] || (Y[27] = X(" Stroke ", -1))
          ]),
          Y[28] || (Y[28] = h("span", { class: "sep" }, null, -1))
        ], 64)) : E("", !0),
        o.value ? (g(), v(H, { key: 3 }, [
          h("button", {
            onClick: Y[6] || (Y[6] = (ie) => Z("align-left"))
          }, [
            C(R, {
              name: "AlignStartVertical",
              size: 14
            }),
            Y[29] || (Y[29] = h("span", { class: "tip" }, "Align left", -1))
          ]),
          h("button", {
            onClick: Y[7] || (Y[7] = (ie) => Z("align-center"))
          }, [
            C(R, {
              name: "AlignCenterHorizontal",
              size: 14
            }),
            Y[30] || (Y[30] = h("span", { class: "tip" }, "Align centres", -1))
          ]),
          h("button", {
            onClick: Y[8] || (Y[8] = (ie) => Z("align-top"))
          }, [
            C(R, {
              name: "AlignStartHorizontal",
              size: 14
            }),
            Y[31] || (Y[31] = h("span", { class: "tip" }, "Align top", -1))
          ]),
          h("button", {
            onClick: Y[9] || (Y[9] = (ie) => Z("distribute-h"))
          }, [
            C(R, {
              name: "AlignHorizontalDistributeCenter",
              size: 14
            }),
            Y[32] || (Y[32] = h("span", { class: "tip" }, "Distribute horizontally", -1))
          ]),
          Y[33] || (Y[33] = h("span", { class: "sep" }, null, -1))
        ], 64)) : E("", !0),
        u.value ? (g(), v(H, { key: 4 }, [
          (g(!0), v(H, null, me(m(bF), (ie) => (g(), v("button", {
            key: ie.id,
            class: U(["is-swatch", { on: p.value === ie.id }]),
            "aria-label": ie.label,
            "aria-pressed": p.value === ie.id,
            "data-testid": "note-tint-" + ie.id,
            onClick: (De) => Z("tint-" + ie.id)
          }, [
            h("span", {
              class: U(["swatch", "tint-" + ie.id])
            }, null, 2),
            h("span", pU, A(ie.label), 1)
          ], 10, hU))), 128)),
          Y[34] || (Y[34] = h("span", { class: "sep" }, null, -1))
        ], 64)) : E("", !0),
        y.value ? (g(), v("button", {
          key: 5,
          class: "cv-ctx-info is-locked",
          "aria-label": "Unlock frame",
          "data-testid": "ctx-unlock",
          onClick: Y[10] || (Y[10] = (ie) => Z("lock"))
        }, [
          C(R, {
            name: "Lock",
            size: 13
          }),
          Y[36] || (Y[36] = X(" Locked", -1)),
          h("span", fU, [
            Y[35] || (Y[35] = X("Unlock", -1)),
            h("span", mU, A(m(k)), 1)
          ])
        ])) : (g(), v(H, { key: 6 }, [
          f.value ? (g(), v("button", {
            key: 0,
            onClick: Y[11] || (Y[11] = (ie) => Z("frame"))
          }, [
            C(R, {
              name: "Frame",
              size: 14
            }),
            Y[37] || (Y[37] = h("span", { class: "tip" }, "Group into frame", -1))
          ])) : E("", !0),
          h("button", {
            onClick: Y[12] || (Y[12] = (ie) => Z("duplicate"))
          }, [
            C(R, {
              name: "Copy",
              size: 14
            }),
            h("span", gU, [
              Y[38] || (Y[38] = X("Duplicate", -1)),
              h("span", bU, A(m(Tn)(["mod", "D"])), 1)
            ])
          ]),
          h("button", {
            onClick: Y[13] || (Y[13] = (ie) => Z("forward"))
          }, [
            C(R, {
              name: "BringToFront",
              size: 14
            }),
            Y[39] || (Y[39] = h("span", { class: "tip" }, "Bring forward", -1))
          ]),
          h("button", {
            onClick: Y[14] || (Y[14] = (ie) => Z("back"))
          }, [
            C(R, {
              name: "SendToBack",
              size: 14
            }),
            Y[40] || (Y[40] = h("span", { class: "tip" }, "Send back", -1))
          ]),
          Y[42] || (Y[42] = h("span", { class: "sep" }, null, -1)),
          h("button", {
            class: "danger",
            "data-testid": "ctx-delete",
            onClick: Y[15] || (Y[15] = (ie) => Z("delete"))
          }, [
            C(R, {
              name: "Trash2",
              size: 14
            }),
            Y[41] || (Y[41] = h("span", { class: "tip" }, "Delete", -1))
          ])
        ], 64)),
        !o.value && m(e).comments.enabled ? (g(), v("button", {
          key: 7,
          "data-testid": "ctx-comment",
          onClick: L
        }, [
          C(R, {
            name: "MessageCirclePlus",
            size: 14
          }),
          Y[43] || (Y[43] = h("span", { class: "tip" }, [
            X("Comment"),
            h("span", { style: { opacity: ".5", "margin-left": "6px" } }, "C")
          ], -1))
        ])) : E("", !0),
        h("button", {
          class: U(["is-more", { on: re.value }]),
          "aria-label": "More",
          "aria-haspopup": "menu",
          "aria-expanded": re.value,
          "data-testid": "ctx-more",
          onClick: te
        }, [
          C(R, {
            name: "EllipsisVertical",
            size: 14
          }),
          re.value ? E("", !0) : (g(), v("span", yU, "More"))
        ], 10, vU)
      ], 36)) : E("", !0),
      re.value ? (g(), v("div", {
        key: 1,
        ref_key: "menu",
        ref: J,
        class: "bd-pointmenu bd-ctxmenu",
        role: "menu",
        "aria-label": "More",
        tabindex: "-1",
        "data-testid": "ctx-menu",
        style: de({ left: ee.value.left + "px", top: ee.value.top + "px", "--pm-origin": (ee.value.up ? "bottom" : "top") + " right" }),
        onKeydown: ne,
        onPointerdown: Y[17] || (Y[17] = Pe(() => {
        }, ["stop"])),
        onContextmenu: Y[18] || (Y[18] = Pe(() => {
        }, ["prevent"]))
      }, [
        (g(!0), v(H, null, me(W.value, (ie) => (g(), v(H, {
          key: ie.id
        }, [
          ie.sepBefore ? (g(), v("div", xU)) : E("", !0),
          h("button", {
            class: U(["bd-pm-row", { "is-danger": ie.danger }]),
            role: "menuitem",
            tabindex: "-1",
            disabled: ie.off,
            "data-testid": "ctx-menu-" + ie.id,
            onMouseenter: Y[16] || (Y[16] = (De) => De.currentTarget.focus({ preventScroll: !0 })),
            onClick: (De) => q(ie)
          }, [
            h("span", kU, [
              C(R, {
                name: ie.icon,
                size: 14
              }, null, 8, ["name"])
            ]),
            h("span", _U, A(ie.label), 1),
            ie.keys ? (g(), v("kbd", SU, A(ie.keys), 1)) : E("", !0)
          ], 42, wU)
        ], 64))), 128))
      ], 36)) : E("", !0)
    ], 64));
  }
}), MU = { class: "hd" }, CU = { class: "sw-grid" }, IU = ["title", "onClick"], AU = { class: "wrow" }, PU = ["value"], EU = { class: "num" }, RU = { class: "stp" }, zU = { class: "prev" }, $U = {
  width: "100%",
  height: "26",
  viewBox: "0 0 250 26",
  fill: "none",
  preserveAspectRatio: "none"
}, DU = ["stroke", "stroke-width"], Um = 306, gw = 168, bw = 62, OU = /* @__PURE__ */ Re({
  __name: "ShapeStyleBar",
  setup(n) {
    const e = ["#9968df", "#a3a7f5", "#c750ce", "#37d399", "#ffb347", "#ff5c7a", "#ffffff", "#8b93ad", "#0b0d14"], { board: t } = tt(), i = I(() => {
      t.docRev.value;
      const l = t.ui.selection.length === 1 ? t.store.get(t.ui.selection[0]) : null;
      return l && l.type === "shape" ? { ...l } : null;
    }), s = I(() => i.value && i.value.sw != null ? i.value.sw : qs.sw), o = I(() => i.value && i.value.stroke || qs.stroke), r = I(() => {
      const l = i.value;
      if (!l) return { left: 0, top: 0 };
      const d = t.cam.value, c = qe(l), u = (c.x + c.w / 2) * d.zoom + d.x + t.view.left, p = c.y * d.zoom + d.y + t.view.top, f = p + c.h * d.zoom, y = p - 50;
      let b;
      return y >= bw ? b = y - gw - 8 >= bw ? y - gw - 8 : f + 12 : b = f + 12 + 46, {
        left: Math.min(Math.max(8, u - Um / 2), window.innerWidth - Um - 8),
        top: b
      };
    });
    function a(l) {
      i.value && t.patchShape(i.value.id, { sw: Math.max(1, Math.min(32, Math.round(l))) });
    }
    return (l, d) => i.value && m(t).ui.styleOpen && !m(t).ui.dragging ? (g(), v("div", {
      key: 0,
      class: "v2-stylebar",
      "data-testid": "stroke-popover",
      style: de({ left: r.value.left + "px", top: r.value.top + "px", width: Um + "px" }),
      onPointerdown: d[4] || (d[4] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", MU, [
        d[5] || (d[5] = h("span", null, "Stroke", -1)),
        h("button", {
          class: "x",
          "aria-label": "Close",
          onClick: d[0] || (d[0] = (c) => m(t).ui.styleOpen = !1)
        }, [
          C(R, {
            name: "X",
            size: 12
          })
        ])
      ]),
      h("div", CU, [
        (g(), v(H, null, me(e, (c) => h("button", {
          key: c,
          class: U(["sw", { on: c === o.value }]),
          title: c,
          onClick: (u) => m(t).patchShape(i.value.id, { stroke: c })
        }, [
          h("span", {
            style: de({ background: c })
          }, null, 4)
        ], 10, IU)), 64))
      ]),
      h("div", AU, [
        d[6] || (d[6] = h("span", { class: "lb" }, "Width", -1)),
        h("input", {
          type: "range",
          min: "1",
          max: "32",
          step: "1",
          value: s.value,
          onInput: d[1] || (d[1] = (c) => a(+c.target.value))
        }, null, 40, PU),
        h("div", EU, [
          h("span", null, A(s.value), 1),
          h("div", RU, [
            h("button", {
              "aria-label": "Thicker",
              onClick: d[2] || (d[2] = (c) => a(s.value + 1))
            }, [
              C(R, {
                name: "ChevronUp",
                size: 10
              })
            ]),
            h("button", {
              "aria-label": "Thinner",
              onClick: d[3] || (d[3] = (c) => a(s.value - 1))
            }, [
              C(R, {
                name: "ChevronDown",
                size: 10
              })
            ])
          ])
        ])
      ]),
      h("div", zU, [
        (g(), v("svg", $U, [
          h("path", {
            d: "M6 13 H244",
            stroke: o.value,
            "stroke-width": s.value,
            "stroke-linecap": "round"
          }, null, 8, DU)
        ]))
      ])
    ], 36)) : E("", !0);
  }
}), LU = { class: "v2-hist-head" }, BU = { class: "n" }, FU = { class: "t" }, NU = {
  key: 0,
  class: "v2-hist-empty"
}, UU = ["data-testid", "onMouseenter"], GU = ["title", "onPointerdown"], jU = {
  key: 1,
  class: "v2-hist-withheld"
}, HU = {
  key: 0,
  class: "v2-hist-time"
}, VU = {
  key: 1,
  class: "v2-hist-vid"
}, WU = {
  key: 2,
  class: "v2-hist-fav"
}, qU = ["title"], KU = {
  key: 1,
  class: "v2-hist-more"
}, YU = ["src"], XU = { class: "cap" }, JU = { class: "n" }, ZU = {
  key: 0,
  class: "m"
}, QU = { class: "v2-hist-acts" }, eG = ["aria-pressed"], tG = { class: "tip" }, vw = 300, ku = 8, nG = /* @__PURE__ */ Re({
  __name: "ToolHistory",
  props: {
    tool: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = tt(), s = Ko(), o = /* @__PURE__ */ K(!1);
    async function r() {
      if (!(o.value || t.historyDone(e.tool.id))) {
        o.value = !0;
        try {
          await t.loadHistory(e.tool.id);
        } finally {
          o.value = !1;
        }
      }
    }
    $e(() => e.tool.id, () => {
      r();
    }, { immediate: !0 });
    function a(re) {
      const F = re.target;
      c.value = F.scrollTop, z(), F.scrollHeight - F.scrollTop - F.clientHeight < 400 && r();
    }
    const l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(0), u = /* @__PURE__ */ K(600), p = /* @__PURE__ */ K(274), f = /* @__PURE__ */ K(null);
    let y = 0;
    const b = I(() => (t.results.rev.value, t.results.list(e.tool.id))), w = I(() => new Set(b.value.slice(0, t.ui.newThumbs[e.tool.id] || 0).map((re) => re.id))), k = I(() => {
      const re = (p.value - ku) / 2;
      return { w: re, h: Math.round(re * 3 / 4) };
    }), S = I(() => Math.ceil(b.value.length / 2) * (k.value.h + ku)), _ = I(() => {
      const re = k.value.h + ku, F = Math.max(0, Math.floor(c.value / re) - 2), W = Math.ceil((c.value + u.value) / re) + 2, ee = [];
      for (let N = F; N <= W; N++)
        for (let te = 0; te < 2; te++) {
          const G = N * 2 + te, q = b.value[G];
          q && ee.push({ it: q, i: G, x: te * (k.value.w + ku), y: N * re });
        }
      return ee;
    });
    let x = null;
    ot(() => {
      d.value && (x = new ResizeObserver(() => {
        d.value && (u.value = d.value.clientHeight, p.value = d.value.clientWidth - 2);
      }), x.observe(d.value));
    }), Ve(() => {
      x && x.disconnect(), clearTimeout(y);
    });
    const T = () => clearTimeout(y), M = () => {
      clearTimeout(y), y = window.setTimeout(() => {
        f.value = null;
      }, 180);
    }, z = () => {
      clearTimeout(y), f.value = null;
    };
    function P(re, F) {
      if (T(), re.status !== "done") return;
      const W = l.value;
      if (!W) return;
      const ee = F.currentTarget.getBoundingClientRect(), N = W.getBoundingClientRect(), te = Math.round(vw * ((re.h || 3) / (re.w || 4))), G = Math.min(Math.max(8 - N.top, ee.top - N.top + ee.height / 2 - te / 2), window.innerHeight - 8 - te - N.top);
      f.value = { id: re.id, it: re, top: G, h: te };
    }
    function D(re) {
      if (re.status !== "done") return;
      const F = t.placedFor(re.id);
      t.ui.infoSession = e.tool.id, t.ui.infoAt = F ? F.id : "result:" + re.id;
    }
    function $(re, F) {
      if (z(), re.status !== "done") return;
      if (t.ui.eyedropper) {
        F.preventDefault(), t.eyedrop(re.url, re.asset || null, !!re.video);
        return;
      }
      const W = Math.min(360, Math.max(200, re.w || 300)), ee = Math.round(W * (re.h || 3) / (re.w || 4));
      i.dragResultOut({ url: re.url, w: W, h: ee, result: re, sessionId: e.tool.id }, F, {
        keepSelection: e.tool.id,
        onClick: () => D(re)
      });
    }
    function O(re) {
      z();
      const F = t.placedFor(re.id);
      F && (t.ui.selection = [F.id], t.jumpTo(F.x + F.w / 2, F.y + F.h / 2, Math.max(t.cam.value.zoom, 0.6)));
    }
    function L(re) {
      t.setPrompt(e.tool.id, { prompt: re.prompt || "" }), t.toast("Prompt loaded into " + e.tool.name);
    }
    function Z(re) {
      t.addReference(e.tool.id, re.url, re.asset || null);
    }
    function J(re) {
      D(re), t.ui.infoSave = !0;
    }
    return (re, F) => (g(), v("div", {
      ref_key: "panel",
      ref: l,
      class: "v2-hist",
      "data-testid": "results-gallery",
      onPointerdown: F[8] || (F[8] = Pe(() => {
      }, ["stop"])),
      onWheel: F[9] || (F[9] = Pe(() => {
      }, ["stop"])),
      onMouseleave: M
    }, [
      h("div", LU, [
        h("span", BU, A(b.value.length), 1),
        h("span", FU, A(n.tool.name), 1),
        h("button", {
          class: "v2-hist-close",
          title: "Hide the gallery",
          onClick: F[0] || (F[0] = (W) => m(t).ui.histOpen = !1)
        }, [
          C(R, {
            name: "PanelRightClose",
            size: 13
          })
        ])
      ]),
      F[16] || (F[16] = h("div", { class: "v2-hist-hint" }, "Click for the full record · drag onto the canvas", -1)),
      h("div", {
        ref_key: "grid",
        ref: d,
        class: "v2-hist-grid",
        onScroll: a
      }, [
        !b.value.length && !o.value ? (g(), v("div", NU, "Results from this session will collect here. Write a prompt and Run.")) : E("", !0),
        h("div", {
          style: de({ height: S.value + "px", position: "relative" })
        }, [
          (g(!0), v(H, null, me(_.value, (W) => (g(), v("div", {
            key: W.it.id,
            class: U(["v2-hist-item", {
              "is-on": f.value && f.value.id === W.it.id,
              "is-new": w.value.has(W.it.id),
              "is-pending": W.it.status === "pending",
              "is-failed": W.it.status === "failed",
              "is-withheld": W.it.status === "moderated"
            }]),
            style: de({ left: W.x + "px", top: W.y + "px", width: k.value.w + "px", height: k.value.h + "px" }),
            "data-testid": "gallery-item-" + W.it.status,
            onMouseenter: (ee) => P(W.it, ee)
          }, [
            h("button", {
              class: "shot",
              title: W.it.status === "moderated" ? "Withheld by the safety check" : W.it.label,
              onPointerdown: (ee) => $(W.it, ee)
            }, [
              h("span", {
                class: "art",
                style: de(W.it.url && W.it.status === "done" ? { backgroundImage: 'url("' + m(Wt)(W.it.url) + '")' } : void 0)
              }, [
                W.it.status === "failed" ? (g(), Ce(R, {
                  key: 0,
                  name: "AlertCircle",
                  size: 16
                })) : W.it.status === "moderated" ? (g(), v("span", jU, [
                  C(R, {
                    name: "EyeOff",
                    size: 14
                  }),
                  F[10] || (F[10] = X("Withheld", -1))
                ])) : E("", !0)
              ], 4),
              W.it.status === "pending" && W.it.startedAt ? (g(), v("span", HU, A(m(n1)(m(s) - W.it.startedAt)), 1)) : E("", !0),
              W.it.video && W.it.status === "done" ? (g(), v("span", VU, [
                C(R, {
                  name: "Play",
                  size: 8
                }),
                X(" " + A(W.it.dur || "0:05"), 1)
              ])) : E("", !0),
              m(t).isFav(W.it) ? (g(), v("span", WU, [
                C(R, {
                  name: "Heart",
                  size: 8
                })
              ])) : E("", !0),
              W.it.status === "done" && m(t).isPinnedImage(W.it.url) ? (g(), v("span", {
                key: 3,
                class: "v2-hist-pin",
                title: m(jn).badge
              }, [
                C(R, {
                  name: "Pin",
                  size: 9
                })
              ], 8, qU)) : E("", !0)
            ], 40, GU)
          ], 46, UU))), 128))
        ], 4),
        o.value ? (g(), v("div", KU, [...F[11] || (F[11] = [
          h("span", { class: "bd-spinner is-sm" }, null, -1)
        ])])) : E("", !0)
      ], 544),
      f.value ? (g(), v("div", {
        key: 0,
        class: "v2-hist-pop",
        style: de({ top: f.value.top + "px", width: vw + "px", height: f.value.h + "px" }),
        onMouseenter: T,
        onMouseleave: M
      }, [
        h("button", {
          class: "art",
          title: "Open the full record",
          style: de({ backgroundImage: 'url("' + f.value.it.url + '")' }),
          onClick: F[2] || (F[2] = (W) => D(f.value.it))
        }, [
          f.value.it.video && f.value.it.videoSrc ? (g(), v("video", {
            key: f.value.it.videoSrc,
            class: "art-vid",
            src: f.value.it.videoSrc,
            "data-testid": "gallery-video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            preload: "auto",
            disablepictureinpicture: "",
            onPlaying: F[1] || (F[1] = (W) => W.target.classList.add("is-shown"))
          }, null, 40, YU)) : E("", !0)
        ], 4),
        h("span", XU, [
          h("span", JU, A(f.value.it.label || f.value.it.prompt), 1),
          f.value.it.video ? (g(), v("span", ZU, [
            C(R, {
              name: "Play",
              size: 10
            }),
            X(" " + A(f.value.it.dur || "0:05"), 1)
          ])) : E("", !0)
        ]),
        h("span", QU, [
          h("button", {
            class: U(["find is-pin", { on: m(t).isPinnedImage(f.value.it.url) }]),
            "aria-pressed": m(t).isPinnedImage(f.value.it.url),
            "data-testid": "gallery-pin",
            onClick: F[3] || (F[3] = Pe((W) => m(t).togglePinImage(m(Df)(f.value.it)), ["stop"]))
          }, [
            C(R, {
              name: "Pin",
              size: 13
            }),
            h("span", tG, A(m(t).isPinnedImage(f.value.it.url) ? m(jn).unpin : m(jn).pin), 1)
          ], 10, eG),
          m(t).placedFor(f.value.it.id) ? (g(), v("button", {
            key: 0,
            class: "find",
            onClick: F[4] || (F[4] = Pe((W) => O(f.value.it), ["stop"]))
          }, [
            C(R, {
              name: "Search",
              size: 13
            }),
            F[12] || (F[12] = h("span", { class: "tip" }, "Find it on the board", -1))
          ])) : E("", !0),
          h("button", {
            class: "find",
            onClick: F[5] || (F[5] = Pe((W) => L(f.value.it), ["stop"]))
          }, [
            C(R, {
              name: "Type",
              size: 13
            }),
            F[13] || (F[13] = h("span", { class: "tip" }, "Use the prompt", -1))
          ]),
          h("button", {
            class: "find",
            onClick: F[6] || (F[6] = Pe((W) => Z(f.value.it), ["stop"]))
          }, [
            C(R, {
              name: "ImagePlus",
              size: 13
            }),
            F[14] || (F[14] = h("span", { class: "tip" }, "Use as reference image", -1))
          ]),
          m(t).promptLibrary.canSave && f.value.it.prompt ? (g(), v("button", {
            key: 1,
            class: "find",
            "data-testid": "gallery-save-prompt",
            onClick: F[7] || (F[7] = Pe((W) => J(f.value.it), ["stop"]))
          }, [
            C(R, {
              name: "Bookmark",
              size: 13
            }),
            F[15] || (F[15] = h("span", { class: "tip" }, "Save to the prompt library", -1))
          ])) : E("", !0)
        ])
      ], 36)) : E("", !0)
    ], 544));
  }
});
var iG = Object.defineProperty, sG = (n, e, t) => e in n ? iG(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, la = (n, e, t) => sG(n, typeof e != "symbol" ? e + "" : e, t);
const Pr = 1, Jd = 5, hv = 2;
function p1(n) {
  if (n.allSessions()) return "All sessions";
  const e = n.pickedSessions();
  if (e.length > 1) return e.length + " sessions";
  const t = n.historySessions.value.find((i) => i.id === e[0]);
  return t ? t.name : "All sessions";
}
const i8 = (n) => "rd-board-studio-history:" + n;
function s8(n) {
  try {
    const e = Number(JSON.parse(localStorage.getItem(i8(n)) || "{}").columns);
    return e >= Pr && e <= Jd ? Math.round(e) : hv;
  } catch {
    return hv;
  }
}
function o8(n, e) {
  try {
    localStorage.setItem(i8(n), JSON.stringify({ columns: e }));
  } catch {
  }
}
function r8(n) {
  const e = Math.round(n);
  return Number.isFinite(e) ? Math.max(Pr, Math.min(Jd, e)) : hv;
}
function oG(n) {
  return n.status !== "moderated" && !(n.status === "done" && !n.url);
}
class rG {
  constructor(e) {
    la(this, "board", e), la(this, "s"), la(this, "boardItems"), la(this, "historySessions"), la(this, "shown"), la(this, "scope", L0(!0)), this.s = /* @__PURE__ */ Xt({ sessions: [], columns: s8(e.user.uid), pinned: !1 });
    const t = this.scope.run(() => {
      const i = I(() => {
        e.docRev.value;
        const a = [];
        for (const l of e.store.all()) l.type === "tool" && a.push(l.id);
        return a.join(" ");
      }), s = I(() => {
        e.results.rev.value;
        const a = [];
        for (const l of i.value ? i.value.split(" ") : [])
          for (const d of e.results.list(l)) oG(d) && a.push(d);
        return a.sort((l, d) => d.createdAt - l.createdAt);
      }), o = I(() => {
        const a = /* @__PURE__ */ new Map();
        for (const l of s.value) a.set(l.sessionId, (a.get(l.sessionId) || 0) + 1);
        return e.recentTools().filter((l) => a.has(l.id) || e.isPinned(l.id)).map((l) => ({ id: l.id, name: l.name, icon: l.icon || "Image", count: a.get(l.id) || 0, here: !1, pinned: e.isPinned(l.id) }));
      }), r = I(() => {
        const a = this.pickedSessions();
        return a.length ? s.value.filter((l) => a.includes(l.sessionId)) : s.value;
      });
      return { boardItems: s, historySessions: o, shown: r };
    });
    this.boardItems = t.boardItems, this.historySessions = t.historySessions, this.shown = t.shown;
  }
  pickedSessions() {
    const e = this.historySessions.value;
    return this.s.sessions.filter((t) => e.some((i) => i.id === t));
  }
  allSessions() {
    const e = this.pickedSessions();
    return !e.length || e.length === this.historySessions.value.length;
  }
  toggleSession(e) {
    const t = this.pickedSessions();
    this.s.sessions = t.includes(e) ? t.filter((i) => i !== e) : [...t, e];
  }
  onlySession(e) {
    this.s.sessions = e ? [e] : [];
  }
  /** History's columns, remembered for the next visit and the next board (the Studios view's too). */
  setColumns(e) {
    const t = r8(e);
    t !== this.s.columns && (this.s.columns = t, o8(this.board.user.uid, t));
  }
  /** The session a result came from, while it's on the board. */
  sessionOf(e) {
    const t = this.board.store.get(e.sessionId);
    return t && t.type === "tool" ? t : null;
  }
  dispose() {
    this.scope.stop();
  }
}
const yw = /* @__PURE__ */ new WeakMap();
function a8(n) {
  let e = yw.get(n);
  return e || (e = new rG(n), yw.set(n, e)), e;
}
const aG = ["aria-pressed"], lG = {
  key: 0,
  class: "badge is-unread",
  "data-testid": "comments-badge"
}, dG = {
  key: 1,
  class: "cm-rail-dot",
  "data-testid": "comments-elsewhere-dot"
}, cG = { class: "tip" }, uG = ["aria-pressed"], hG = {
  key: 0,
  class: "badge",
  "data-testid": "board-history-badge"
}, pG = ["aria-pressed"], fG = {
  key: 0,
  class: "badge"
}, mG = { class: "tip" }, gG = /* @__PURE__ */ Re({
  __name: "SideRail",
  setup(n) {
    const { board: e } = tt(), t = a8(e), i = I(() => t.boardItems.value.length), s = e.comments, o = I(() => s.unreadCount.value), r = I(() => s.elsewhereUnread.value);
    function a() {
      s.ui.panelOpen = !s.ui.panelOpen;
    }
    const l = fs(e), d = I(() => l.allChats());
    function c() {
      if (e.ui.chatOpen) {
        e.ui.chatOpen = null;
        return;
      }
      const u = d.value[0];
      u && (e.ui.selection = [u.id], e.ui.chatOpen = u.id);
    }
    return (u, p) => (g(), v("nav", {
      class: "bd-siderail",
      "aria-label": "Board panels",
      "data-testid": "side-rail",
      onPointerdown: p[1] || (p[1] = Pe(() => {
      }, ["stop"]))
    }, [
      m(s).enabled ? (g(), v("button", {
        key: 0,
        class: U(["bd-siderail-btn", { on: m(s).ui.panelOpen }]),
        "aria-pressed": m(s).ui.panelOpen,
        "aria-label": "Comments",
        "data-testid": "comments-toggle",
        onClick: a
      }, [
        C(R, {
          name: "MessageCircle",
          size: 16
        }),
        o.value ? (g(), v("span", lG, A(o.value > 99 ? "99+" : o.value), 1)) : r.value ? (g(), v("span", dG)) : E("", !0),
        h("span", cG, "Comments" + A(o.value ? ": " + o.value + " unread" : r.value ? ": news on other boards" : ""), 1)
      ], 10, aG)) : E("", !0),
      h("button", {
        class: U(["bd-siderail-btn", { on: m(e).ui.boardHistory }]),
        "aria-pressed": m(e).ui.boardHistory,
        "aria-label": "Board history",
        "data-testid": "board-history-toggle",
        onClick: p[0] || (p[0] = (f) => m(e).ui.boardHistory = !m(e).ui.boardHistory)
      }, [
        C(R, {
          name: "History",
          size: 16
        }),
        i.value ? (g(), v("span", hG, A(i.value > 99 ? "99+" : i.value), 1)) : E("", !0),
        p[2] || (p[2] = h("span", { class: "tip" }, "Board history", -1))
      ], 10, uG),
      d.value.length ? (g(), v("button", {
        key: 1,
        class: U(["bd-siderail-btn", { on: !!m(e).ui.chatOpen }]),
        "aria-pressed": !!m(e).ui.chatOpen,
        "aria-label": "Chats",
        "data-testid": "chat-toggle",
        onClick: c
      }, [
        C(R, {
          name: "MessagesSquare",
          size: 16
        }),
        d.value.length > 1 ? (g(), v("span", fG, A(d.value.length), 1)) : E("", !0),
        h("span", mG, A(d.value.length === 1 ? d.value[0].name : "Chats: the latest opens"), 1)
      ], 10, pG)) : E("", !0)
    ], 32));
  }
}), bG = { "data-testid": "elapsed" }, Nf = /* @__PURE__ */ Re({
  __name: "Elapsed",
  props: {
    since: {}
  },
  setup(n) {
    const e = n, t = Ko(), i = I(() => n1(t.value - e.since));
    return (s, o) => (g(), v("span", bG, A(i.value), 1));
  }
}), vG = ["title"], yG = { class: "sv-hist-cols-track" }, xG = ["min", "max", "value", "aria-valuetext", "data-testid"], l8 = /* @__PURE__ */ Re({
  __name: "HistoryColumns",
  props: {
    columns: {},
    testid: {}
  },
  emits: ["set"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = Array.from({ length: Jd - Pr + 1 }, (a, l) => Pr + l), o = (a) => (a - Pr) / (Jd - Pr), r = I(() => t.columns + (t.columns === 1 ? " column" : " columns"));
    return (a, l) => (g(), v("div", {
      class: "sv-hist-cols",
      title: r.value
    }, [
      C(R, {
        name: "Square",
        size: 11
      }),
      h("span", yG, [
        l[1] || (l[1] = h("span", { class: "rail" }, null, -1)),
        h("span", {
          class: "fill",
          style: de({ width: "calc((100% - 12px) * " + o(n.columns) + ")" })
        }, null, 4),
        (g(!0), v(H, null, me(m(s), (d) => (g(), v("i", {
          key: d,
          class: U({ on: d <= n.columns }),
          style: de({ left: "calc(6px + (100% - 12px) * " + o(d) + ")" })
        }, null, 6))), 128)),
        h("input", {
          type: "range",
          min: m(Pr),
          max: m(Jd),
          step: "1",
          value: n.columns,
          "aria-label": "Columns",
          "aria-valuetext": r.value,
          "data-testid": n.testid,
          onInput: l[0] || (l[0] = (d) => i("set", +d.target.value))
        }, null, 40, xG)
      ]),
      C(R, {
        name: "Grid3x3",
        size: 11
      })
    ], 8, vG));
  }
}), wG = { class: "sv-hist-filterrow" }, kG = ["aria-expanded", "disabled", "title", "data-testid"], _G = { class: "lb" }, SG = ["data-testid"], TG = {
  key: 0,
  class: "sv-hist-filter-pop",
  role: "menu",
  "aria-label": "Sessions in history"
}, MG = { class: "sv-hist-search" }, CG = ["data-testid", "onKeydown"], IG = ["aria-checked", "data-testid"], AG = { class: "ck" }, PG = { class: "ct" }, EG = { class: "sv-hist-opts" }, RG = ["data-testid"], zG = ["aria-checked", "data-testid", "onClick"], $G = { class: "ck" }, DG = { class: "ic" }, OG = { class: "tx" }, LG = { key: 0 }, BG = { class: "ct" }, FG = { class: "sv-hist-opt-acts" }, NG = ["title", "data-testid", "onClick"], UG = ["aria-checked", "title", "aria-label", "data-testid", "onClick"], GG = {
  key: 0,
  class: "sv-hist-opt-none"
}, jG = {
  key: 1,
  class: "sv-hist-opt-none"
}, HG = ["aria-pressed", "title", "data-testid"], VG = ["data-testid"], d8 = /* @__PURE__ */ Re({
  __name: "HistorySessions",
  props: {
    filter: {},
    tid: {},
    pinned: { type: Boolean },
    pinCount: {}
  },
  emits: ["pinned"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = tt(), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(null), a = I(() => t.filter.historySessions.value), l = I(() => t.filter.pickedSessions()), d = I(() => t.filter.allSessions()), c = I(() => p1(t.filter)), u = /* @__PURE__ */ K(""), p = /* @__PURE__ */ K(null), f = I(() => {
      const S = u.value.trim().toLowerCase(), _ = a.value.filter((T) => !S || T.name.toLowerCase().includes(S)), x = _.filter((T) => !T.here && T.pinned);
      return [
        { id: "here", label: "", rows: _.filter((T) => T.here) },
        { id: "pinned", label: x.length ? "Pinned" : "", rows: x },
        { id: "rest", label: x.length ? "Sessions" : "", rows: _.filter((T) => !T.here && !T.pinned) }
      ].map((T) => ({ ...T, label: T.rows.length ? T.label : "" }));
    });
    function y() {
      const S = f.value.flatMap((_) => _.rows)[0];
      S && t.filter.toggleSession(S.id);
    }
    function b() {
      u.value = "", p.value && p.value.focus();
    }
    function w(S) {
      r.value && !r.value.contains(S.target) && (o.value = !1);
    }
    $e(o, async (S) => {
      S ? window.addEventListener("pointerdown", w, !0) : window.removeEventListener("pointerdown", w, !0), u.value = "", S && (await it(), p.value && p.value.focus());
    }), Ve(() => window.removeEventListener("pointerdown", w, !0));
    function k(S) {
      S.key === "Escape" && o.value && (S.preventDefault(), S.stopPropagation(), o.value = !1);
    }
    return (S, _) => (g(), v("div", wG, [
      h("div", {
        ref_key: "menuEl",
        ref: r,
        class: U(["sv-hist-filter", { "is-resting": n.pinned }]),
        onKeydown: k
      }, [
        h("button", {
          class: U(["sv-hist-filter-btn", { on: o.value, "is-narrowed": !d.value && !n.pinned }]),
          "aria-expanded": o.value,
          "aria-haspopup": "menu",
          disabled: n.pinned,
          title: n.pinned ? "Showing your pinned images, which only you see: turn Pinned off to pick sessions" : void 0,
          "data-testid": n.tid + "-sessions",
          onClick: _[0] || (_[0] = (x) => o.value = !o.value)
        }, [
          C(R, {
            name: n.pinned ? "Pin" : "Layers",
            size: 13
          }, null, 8, ["name"]),
          h("span", _G, A(n.pinned ? "Your pinned images" : c.value), 1),
          n.pinned ? (g(), v("span", {
            key: 0,
            class: "sv-hist-private",
            "data-testid": n.tid + "-pinned-private"
          }, [
            C(R, {
              name: "Lock",
              size: 10
            }),
            _[4] || (_[4] = X("Only you", -1))
          ], 8, SG)) : (g(), Ce(R, {
            key: 1,
            name: "ChevronDown",
            size: 12,
            class: "chev"
          }))
        ], 10, kG),
        o.value ? (g(), v("div", TG, [
          h("div", MG, [
            C(R, {
              name: "Search",
              size: 13
            }),
            xt(h("input", {
              ref_key: "searchEl",
              ref: p,
              "onUpdate:modelValue": _[1] || (_[1] = (x) => u.value = x),
              type: "text",
              placeholder: "Search sessions",
              "aria-label": "Search sessions",
              "data-testid": n.tid + "-sessions-search",
              onKeydown: tn(Pe(y, ["prevent"]), ["enter"])
            }, null, 40, CG), [
              [Jt, u.value]
            ]),
            u.value ? (g(), v("button", {
              key: 0,
              class: "x",
              "aria-label": "Clear the search",
              onClick: b
            }, [
              C(R, {
                name: "X",
                size: 11
              })
            ])) : E("", !0)
          ]),
          h("button", {
            role: "menuitemcheckbox",
            "aria-checked": d.value,
            class: U(["sv-hist-opt is-all", { on: d.value }]),
            "data-testid": n.tid + "-sessions-all",
            onClick: _[2] || (_[2] = (x) => n.filter.onlySession(null))
          }, [
            h("span", AG, [
              d.value ? (g(), Ce(R, {
                key: 0,
                name: "Check",
                size: 11
              })) : E("", !0)
            ]),
            _[5] || (_[5] = h("span", { class: "tx" }, [
              h("b", null, "All sessions"),
              h("small", null, "Everything made on this board")
            ], -1)),
            h("span", PG, A(n.filter.boardItems.value.length), 1)
          ], 10, IG),
          _[6] || (_[6] = h("div", {
            class: "sv-hist-opt-sep",
            role: "separator"
          }, null, -1)),
          h("div", EG, [
            (g(!0), v(H, null, me(f.value, (x) => (g(), v(H, {
              key: x.id
            }, [
              x.label ? (g(), v("div", {
                key: 0,
                class: "sv-hist-opt-label",
                "data-testid": n.tid + "-sessions-" + x.id
              }, A(x.label), 9, RG)) : E("", !0),
              (g(!0), v(H, null, me(x.rows, (T) => (g(), v("div", {
                key: T.id,
                class: U(["sv-hist-opt-line", { "is-pinned": T.pinned }])
              }, [
                h("button", {
                  role: "menuitemcheckbox",
                  "aria-checked": l.value.includes(T.id),
                  class: U(["sv-hist-opt", { on: l.value.includes(T.id) }]),
                  "data-testid": n.tid + "-session-" + T.id,
                  onClick: (M) => n.filter.toggleSession(T.id)
                }, [
                  h("span", $G, [
                    l.value.includes(T.id) ? (g(), Ce(R, {
                      key: 0,
                      name: "Check",
                      size: 11
                    })) : E("", !0)
                  ]),
                  h("span", DG, [
                    C(R, {
                      name: T.icon,
                      size: 12
                    }, null, 8, ["name"])
                  ]),
                  h("span", OG, [
                    h("b", null, A(T.name), 1),
                    T.here ? (g(), v("small", LG, "This session")) : E("", !0)
                  ]),
                  h("span", BG, A(T.count), 1)
                ], 10, zG),
                h("span", FG, [
                  h("button", {
                    role: "menuitem",
                    class: "sv-hist-only",
                    title: "Show only " + T.name,
                    "data-testid": n.tid + "-session-only-" + T.id,
                    onClick: (M) => n.filter.onlySession(T.id)
                  }, "Only", 8, NG),
                  h("button", {
                    role: "menuitemcheckbox",
                    "aria-checked": T.pinned,
                    class: U(["sv-hist-pin", { on: T.pinned }]),
                    title: T.pinned ? "Unpin" : "Pin to the top",
                    "aria-label": (T.pinned ? "Unpin " : "Pin ") + T.name,
                    "data-testid": n.tid + "-session-pin-" + T.id,
                    onClick: (M) => m(s).togglePinned(T.id)
                  }, [
                    C(R, {
                      name: "Pin",
                      size: 12
                    })
                  ], 10, UG)
                ])
              ], 2))), 128))
            ], 64))), 128)),
            u.value && !f.value.some((x) => x.rows.length) ? (g(), v("div", GG, "No sessions match")) : E("", !0),
            !u.value && !a.value.length ? (g(), v("div", jG, "No sessions have made anything yet")) : E("", !0)
          ])
        ])) : E("", !0)
      ], 34),
      h("button", {
        class: U(["sv-hist-pinned", { on: n.pinned }]),
        "aria-pressed": n.pinned,
        title: n.pinned ? "Back to everything" : "Your pinned images (only you see them)",
        "data-testid": n.tid + "-pinned",
        onClick: _[3] || (_[3] = (x) => {
          o.value = !1, i("pinned", !n.pinned);
        })
      }, [
        C(R, {
          name: "Pin",
          size: 13
        }),
        n.pinCount ? (g(), v("span", {
          key: 0,
          class: "ct",
          "data-testid": n.tid + "-pinned-count"
        }, A(n.pinCount), 9, VG)) : E("", !0)
      ], 10, HG)
    ]));
  }
}), WG = ["data-testid"], qG = {
  class: "pe-art",
  "aria-hidden": "true"
}, KG = { class: "pe-pin" }, YG = { class: "pe-private" }, XG = {
  key: 0,
  class: "pe-body"
}, JG = { class: "pe-hint" }, ZG = { class: "pe-key" }, f1 = /* @__PURE__ */ Re({
  __name: "PinnedEmpty",
  props: {
    compact: { type: Boolean, default: !1 },
    kind: { default: "image" }
  },
  setup(n) {
    const e = n, t = I(() => e.kind === "video" ? "videos" : "images");
    return (i, s) => (g(), v("div", {
      class: U(["pe", { "is-compact": n.compact }]),
      "data-testid": n.compact ? "ref-pinned-empty" : "pinned-empty"
    }, [
      h("div", qG, [
        s[0] || (s[0] = Af('<span class="pe-glow"></span><span class="pe-card c1"><i class="sun"></i><i class="hill"></i></span><span class="pe-card c3"><i class="sun"></i><i class="hill"></i></span><span class="pe-card c2"><i class="sun"></i><i class="hill"></i><i class="hill b"></i></span><span class="pe-ring"></span>', 5)),
        h("span", KG, [
          C(R, {
            name: "Pin",
            size: 12
          })
        ])
      ]),
      h("span", YG, [
        C(R, {
          name: "Lock",
          size: 10
        }),
        s[1] || (s[1] = X("Only you see your pins", -1))
      ]),
      s[5] || (s[5] = h("b", { class: "pe-title" }, "Pin your go-to references", -1)),
      n.compact ? (g(), v("p", XG, "Pin the " + A(t.value) + " you reach for as references and they wait here, one click away.", 1)) : (g(), v(H, { key: 1 }, [
        s[2] || (s[2] = h("p", { class: "pe-body" }, "Keep the images you reach for again and again one click away: a mood shot, a material, the site photo you're matching. Use them as references in any prompt on this board.", -1)),
        s[3] || (s[3] = h("p", { class: "pe-note" }, "They're personal: everyone on this board has their own. And unlike favorites, which gather in your Library from every board, pins stay with this board.", -1))
      ], 64)),
      h("span", JG, [
        s[4] || (s[4] = X("Look for ", -1)),
        h("span", ZG, [
          C(R, {
            name: "Pin",
            size: 11
          })
        ]),
        X(" on any " + A(n.kind), 1)
      ])
    ], 10, WG));
  }
}), QG = { class: "sv-hist-head" }, ej = { class: "t" }, tj = {
  class: "n",
  "data-testid": "board-history-count"
}, nj = ["title", "data-testid", "data-result", "data-url", "onMouseenter", "onPointerdown"], ij = { class: "frame" }, sj = {
  key: 0,
  class: "sv-art"
}, oj = ["src"], rj = {
  key: 1,
  class: "sv-cell-fail"
}, aj = {
  key: 0,
  class: "bd-boardhist-vid"
}, lj = ["title"], dj = { class: "sv-cell-cap" }, cj = {
  key: 1,
  class: "sv-hist-empty"
}, uj = {
  key: 2,
  class: "sv-hist-empty"
}, hj = ["title"], pj = { class: "sv-art" }, fj = ["src"], mj = ["src"], gj = { class: "cap" }, bj = { class: "n" }, vj = { class: "m" }, yj = { class: "sv-hist-acts" }, xj = ["aria-pressed"], wj = { class: "tip" }, kj = { class: "tip" }, Gm = 60, _j = 300, Sj = 380, Tj = 52, Mj = /* @__PURE__ */ Re({
  __name: "BoardHistory",
  setup(n) {
    const { board: e, input: t } = tt(), i = a8(e), s = i.s, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null);
    function a(B) {
      return {
        id: B.id,
        url: B.url,
        w: B.w || 4,
        h: B.h || 3,
        status: B.status === "moderated" ? "failed" : B.status,
        label: B.label || B.prompt || "Result",
        createdAt: B.createdAt,
        video: !!B.video,
        videoSrc: B.videoSrc || null,
        dur: B.dur || null,
        sessionId: B.sessionId,
        result: B,
        asset: B.asset || null
      };
    }
    function l(B) {
      const ne = B.resultId && e.results.get(B.resultId) || null;
      return {
        id: "pin:" + B.id,
        url: B.url,
        w: B.pw,
        h: B.ph,
        status: "done",
        label: B.label,
        createdAt: B.createdAt,
        video: !!B.video,
        videoSrc: B.videoSrc || null,
        dur: B.dur || null,
        sessionId: B.fromSession || (ne ? ne.sessionId : null),
        result: ne,
        asset: B.asset || null
      };
    }
    const d = I(() => s.pinned ? (e.results.rev.value, e.pinnedImages.value.map(l)) : i.shown.value.map(a)), c = I(() => i.allSessions()), u = I(() => p1(i)), p = I(() => (c.value ? i.historySessions.value.length : i.pickedSessions().length) > 1), f = I(() => {
      e.docRev.value;
      const B = /* @__PURE__ */ new Map(), ne = /* @__PURE__ */ new Map();
      for (const se of e.store.all()) {
        if (se.type !== "image") continue;
        const Y = se;
        Y.resultId && !B.has(Y.resultId) && B.set(Y.resultId, Y), ne.has(Y.src) || ne.set(Y.src, Y);
      }
      return { byResult: B, byUrl: ne };
    });
    function y(B) {
      return B.result && f.value.byResult.get(B.result.id) || f.value.byUrl.get(B.url) || null;
    }
    function b(B) {
      const ne = B.sessionId ? e.store.get(B.sessionId) : null;
      return ne && ne.type === "tool" ? ne : null;
    }
    const w = /* @__PURE__ */ K(Gm), k = I(() => d.value.slice(0, w.value)), S = /* @__PURE__ */ K(!1);
    async function _() {
      if (!(s.pinned || S.value || e.boardHistoryDone())) {
        S.value = !0;
        try {
          await e.loadBoardHistory();
        } finally {
          S.value = !1;
        }
      }
    }
    $e(() => i.pickedSessions().join(" ") + (s.pinned ? " pinned" : ""), () => {
      w.value = Gm, $(), r.value && (r.value.scrollTop = 0);
    });
    function x(B) {
      $();
      const ne = B.target;
      ne.scrollHeight - ne.scrollTop - ne.clientHeight > 400 || (w.value < d.value.length ? w.value += Gm : _());
    }
    ot(() => {
      _();
    });
    function T(B) {
      if (B.status === "pending") return "Making…";
      if (B.status === "failed") return "Failed";
      if (s.pinned || p.value) {
        const ne = b(B);
        if (ne) return ne.name;
        if (s.pinned) return B.label;
      }
      return Jn(B.createdAt);
    }
    const M = /* @__PURE__ */ K(null);
    let z = 0;
    const P = () => clearTimeout(z), D = () => {
      clearTimeout(z), z = window.setTimeout(() => {
        M.value = null;
      }, 180);
    }, $ = () => {
      clearTimeout(z), M.value = null;
    };
    Ve(() => clearTimeout(z));
    function O(B, ne) {
      if (P(), B.status !== "done" || !o.value) {
        M.value = null;
        return;
      }
      const se = ne.currentTarget.getBoundingClientRect(), Y = o.value.getBoundingClientRect(), ie = Math.min(_j / B.w, Sj / B.h), De = Math.round(B.w * ie), xe = Math.round(B.h * ie), Oe = Math.min(Math.max(Tj + 8 - Y.top, se.top - Y.top + se.height / 2 - xe / 2), window.innerHeight - 8 - xe - Y.top);
      M.value = { c: B, top: Oe, w: De, h: xe };
    }
    function L(B) {
      return B.status === "done" && (!!B.result || !!y(B));
    }
    function Z(B) {
      if (!L(B)) return;
      const ne = y(B);
      e.ui.infoSession = B.result ? B.result.sessionId : null, e.ui.infoAt = ne ? ne.id : "result:" + B.result.id;
    }
    function J(B, ne) {
      if ($(), B.status !== "done") return;
      if (e.ui.eyedropper) {
        ne.preventDefault(), e.eyedrop(B.url, B.asset, B.video);
        return;
      }
      const se = Math.min(360, Math.max(200, B.w || 300)), Y = Math.round(se * B.h / B.w);
      t.dragResultOut({ url: B.url, w: se, h: Y, result: B.result, label: B.label, sessionId: B.sessionId || void 0 }, ne, { onClick: () => Z(B) });
    }
    function re(B) {
      B(), $();
    }
    function F(B) {
      return B.result ? Df(B.result) : { url: B.url, w: B.w, h: B.h, label: B.label, asset: B.asset, sessionId: B.sessionId, video: B.video, videoSrc: B.videoSrc, dur: B.dur };
    }
    function W(B) {
      const ne = y(B);
      ne && (e.ui.selection = [ne.id], e.jumpTo(ne.x + ne.w / 2, ne.y + ne.h / 2, Math.max(e.cam.value.zoom, 0.6)));
    }
    const ee = I(() => e.promptTool.value);
    function N(B) {
      const ne = ee.value;
      ne && e.addReference(ne.id, B.url, B.asset) && e.toast("Added to " + ne.name + " as a reference");
    }
    function te(B) {
      B.result && B.result.url === B.url ? e.placeResult(B.result) : e.placeImages([{ url: B.url, w: Math.min(360, B.w), h: Math.round(Math.min(360, B.w) * B.h / B.w), label: B.label, asset: B.asset || void 0, video: B.video || void 0, videoSrc: B.videoSrc || void 0, dur: B.dur || void 0 }]);
    }
    function G(B) {
      const ne = b(B);
      return (ne ? ne.name + " · " : "") + Jn(B.createdAt);
    }
    function q(B) {
      s.pinned = B;
    }
    return (B, ne) => (g(), v("aside", {
      ref_key: "panel",
      ref: o,
      class: U(["sv-hist bd-boardhist", ["cols-" + m(s).columns, { "is-pinned-view": m(s).pinned }]]),
      "aria-label": "Board history",
      "data-testid": "board-history",
      onPointerdown: ne[10] || (ne[10] = Pe(() => {
      }, ["stop"])),
      onWheel: ne[11] || (ne[11] = Pe(() => {
      }, ["stop"])),
      onMouseleave: D
    }, [
      h("div", QG, [
        h("span", ej, A(m(s).pinned ? "Pinned" : "History"), 1),
        h("span", tj, A(d.value.length), 1),
        ne[12] || (ne[12] = h("span", { class: "sv-grow" }, null, -1)),
        m(e).hasLibrary ? (g(), v("button", {
          key: 0,
          class: "sv-hist-lib",
          title: "Place pictures from your Library",
          "data-testid": "board-history-library",
          onClick: ne[0] || (ne[0] = (se) => m(e).openLibrary())
        }, [
          C(R, {
            name: "Library",
            size: 14
          })
        ])) : E("", !0),
        C(l8, {
          columns: m(s).columns,
          testid: "board-history-cols",
          onSet: ne[1] || (ne[1] = (se) => m(i).setColumns(se))
        }, null, 8, ["columns"]),
        h("button", {
          class: "bd-boardhist-close",
          title: "Close (Esc)",
          "aria-label": "Close the board history",
          "data-testid": "board-history-close",
          onClick: ne[2] || (ne[2] = (se) => m(e).ui.boardHistory = !1)
        }, [
          C(R, {
            name: "X",
            size: 14
          })
        ])
      ]),
      C(d8, {
        filter: m(i),
        tid: "board-history",
        pinned: m(s).pinned,
        "pin-count": m(e).pinnedImages.value.length,
        onPinned: q
      }, null, 8, ["filter", "pinned", "pin-count"]),
      h("div", {
        ref_key: "grid",
        ref: r,
        class: "sv-hist-grid",
        style: de({ "--cols": m(s).columns }),
        onScroll: x
      }, [
        (g(!0), v(H, null, me(k.value, (se) => (g(), v("div", {
          key: se.id,
          class: U(["sv-cell", {
            "is-pending": se.status === "pending",
            "is-failed": se.status === "failed",
            "is-new": Date.now() - se.createdAt < 4e3,
            "is-on": M.value && M.value.c.id === se.id
          }]),
          title: se.status === "done" ? void 0 : T(se),
          "data-testid": (m(s).pinned ? "board-history-pinned-" : "board-history-item-") + se.status,
          "data-result": se.result ? se.result.id : void 0,
          "data-url": se.url,
          onMouseenter: (Y) => O(se, Y),
          onMouseleave: D,
          onPointerdown: (Y) => J(se, Y)
        }, [
          h("span", ij, [
            se.status === "done" ? (g(), v("span", sj, [
              h("img", {
                src: m(Wt)(se.url),
                alt: "",
                draggable: "false",
                loading: "lazy"
              }, null, 8, oj)
            ])) : se.status === "failed" ? (g(), v("span", rj, [
              C(R, {
                name: "AlertCircle",
                size: 16
              })
            ])) : se.status === "pending" ? (g(), Ce(Nf, {
              key: 2,
              class: "sv-cell-time",
              since: se.result && se.result.startedAt || se.createdAt
            }, null, 8, ["since"])) : E("", !0)
          ]),
          se.video && se.status === "done" ? (g(), v("span", aj, [
            C(R, {
              name: "Play",
              size: 8
            }),
            X(A(se.dur || "0:05"), 1)
          ])) : E("", !0),
          !m(s).pinned && se.status === "done" && m(e).isPinnedImage(se.url) ? (g(), v("span", {
            key: 1,
            class: "sv-cell-pin",
            title: m(jn).badge
          }, [
            C(R, {
              name: "Pin",
              size: 10
            })
          ], 8, lj)) : E("", !0),
          h("span", dj, A(T(se)), 1)
        ], 42, nj))), 128)),
        m(s).pinned && !d.value.length ? (g(), Ce(f1, { key: 0 })) : !d.value.length && !S.value ? (g(), v("div", cj, A(c.value ? "What the board's sessions make collects here, newest first." : "Nothing from " + u.value + " yet."), 1)) : E("", !0),
        S.value && !m(s).pinned ? (g(), v("div", uj, [...ne[13] || (ne[13] = [
          h("span", { class: "bd-spinner is-sm" }, null, -1)
        ])])) : E("", !0)
      ], 36),
      M.value ? (g(), v("div", {
        key: 0,
        class: "sv-hist-pop",
        style: de({ top: M.value.top + "px", width: M.value.w + "px", height: M.value.h + "px" }),
        "data-testid": "board-history-preview",
        onMouseenter: P,
        onMouseleave: D
      }, [
        h("button", {
          class: "art",
          title: L(M.value.c) ? "Open the full record" : M.value.c.label,
          onClick: ne[3] || (ne[3] = (se) => re(() => Z(M.value.c)))
        }, [
          h("span", pj, [
            h("img", {
              src: M.value.c.url,
              alt: "",
              draggable: "false"
            }, null, 8, fj)
          ]),
          M.value.c.video && M.value.c.videoSrc ? (g(), v("video", {
            key: M.value.c.videoSrc,
            class: "bd-boardhist-play",
            src: M.value.c.videoSrc,
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            preload: "auto",
            disablepictureinpicture: ""
          }, null, 8, mj)) : E("", !0)
        ], 8, hj),
        h("span", gj, [
          h("span", bj, A(M.value.c.label), 1),
          h("span", vj, A(G(M.value.c)), 1)
        ]),
        h("span", yj, [
          h("button", {
            class: U(["is-pin", { on: m(e).isPinnedImage(M.value.c.url) }]),
            "aria-pressed": m(e).isPinnedImage(M.value.c.url),
            "data-testid": "board-history-pin",
            onClick: ne[4] || (ne[4] = Pe((se) => m(e).togglePinImage(F(M.value.c)), ["stop"]))
          }, [
            C(R, {
              name: "Pin",
              size: 13
            }),
            h("span", wj, A(m(e).isPinnedImage(M.value.c.url) ? m(jn).unpin : m(jn).pin), 1)
          ], 10, xj),
          ee.value && !M.value.c.video ? (g(), v("button", {
            key: 0,
            "data-testid": "board-history-use-ref",
            onClick: ne[5] || (ne[5] = Pe((se) => re(() => N(M.value.c)), ["stop"]))
          }, [
            C(R, {
              name: "ImagePlus",
              size: 13
            }),
            h("span", kj, "Use as reference in " + A(ee.value.name), 1)
          ])) : E("", !0),
          y(M.value.c) ? (g(), v("button", {
            key: 1,
            "data-testid": "board-history-find",
            onClick: ne[6] || (ne[6] = Pe((se) => re(() => W(M.value.c)), ["stop"]))
          }, [
            C(R, {
              name: "LocateFixed",
              size: 13
            }),
            ne[14] || (ne[14] = h("span", { class: "tip" }, "Find it on the board", -1))
          ])) : E("", !0),
          b(M.value.c) ? (g(), v("button", {
            key: 2,
            "data-testid": "board-history-session",
            onClick: ne[7] || (ne[7] = Pe((se) => re(() => m(e).openSession(b(M.value.c))), ["stop"]))
          }, [
            C(R, {
              name: "LayoutGrid",
              size: 13
            }),
            ne[15] || (ne[15] = h("span", { class: "tip" }, "Open its session", -1))
          ])) : E("", !0),
          h("button", {
            "data-testid": "board-history-place",
            onClick: ne[8] || (ne[8] = Pe((se) => re(() => te(M.value.c)), ["stop"]))
          }, [
            C(R, {
              name: "ArrowDownToLine",
              size: 13
            }),
            ne[16] || (ne[16] = h("span", { class: "tip" }, "Place on the board", -1))
          ]),
          M.value.c.result && !M.value.c.video ? (g(), v("button", {
            key: 3,
            "data-testid": "board-history-edit",
            onClick: ne[9] || (ne[9] = Pe((se) => re(() => m(e).openStudio({ resultId: M.value.c.result.id })), ["stop"]))
          }, [
            C(R, {
              name: "Wand2",
              size: 13
            }),
            ne[17] || (ne[17] = h("span", { class: "tip" }, "Edit in Studio view", -1))
          ])) : E("", !0)
        ])
      ], 36)) : E("", !0)
    ], 34));
  }
});
function hn(n) {
  if (n == null) return;
  if (typeof n == "number") return n;
  if (n instanceof Date) return n.getTime();
  const e = n;
  if (typeof e.toMillis == "function") return e.toMillis();
}
function Po(n) {
  return n && typeof n == "object" && "code" in n && typeof n.code == "string" ? n.code : "";
}
function $t(n) {
  return typeof n == "string" ? n : "";
}
function jr(n) {
  return n && typeof n == "object" && !Array.isArray(n) ? n : null;
}
function Cj(n) {
  const e = jr(n);
  return !e || !$t(e.url) ? null : { label: $t(e.label), role: $t(e.role), title: $t(e.title) || void 0, kind: e.kind === "markup" ? "markup" : "reference", url: $t(e.url) };
}
function Ij(n) {
  const e = jr(n), t = e && jr(e.tool), i = e && jr(e.output);
  if (!e || !t || !i || !$t(e.id) || !$t(e.name) || !$t(e.prompt) || !$t(i.url)) return null;
  const s = {
    id: $t(e.id),
    name: $t(e.name),
    category: $t(e.category),
    description: $t(e.description),
    prompt: $t(e.prompt),
    mode: $t(e.mode),
    tags: Array.isArray(e.tags) ? e.tags.filter((o) => typeof o == "string") : [],
    kind: e.kind === "video" ? "video" : "image",
    tool: { nodeDefId: $t(t.nodeDefId), name: $t(t.name) },
    output: { url: $t(i.url), w: Number(i.w) || 0, h: Number(i.h) || 0, video: $t(i.video) || void 0 },
    inputs: Array.isArray(e.inputs) ? e.inputs.map(Cj).filter((o) => !!o) : []
  };
  return $t(e.line) && (s.line = $t(e.line)), s;
}
function Aj(n) {
  const e = jr(n);
  if (!e || !Array.isArray(e.prompts)) return null;
  const t = e.prompts.map(Ij).filter((s) => !!s), i = Array.isArray(e.categories) ? e.categories.map((s) => jr(s)).filter((s) => !!s && !!$t(s.label)).map((s) => ({ id: $t(s.id) || $t(s.label), label: $t(s.label), description: $t(s.description) })) : [];
  return { id: $t(e.id), name: $t(e.name), source: $t(e.source) || void 0, categories: i, prompts: t };
}
function m1(n) {
  return (n || "").toLowerCase().split(/\s+/).filter(Boolean);
}
function c8(n, e, t) {
  let i = 0;
  const s = n.name.toLowerCase(), o = [n.category, n.tool.name, n.tags.join(" ")].join(" ").toLowerCase(), r = n.description.toLowerCase(), a = n.prompt.toLowerCase();
  for (const l of e) {
    const d = s.includes(l) ? 8 : o.includes(l) ? 4 : r.includes(l) ? 2 : a.includes(l) ? 1 : 0;
    if (!d) return null;
    i += d;
  }
  return t && n.kind === t ? i + 100 : i;
}
function Pj(n, e = {}) {
  const t = m1(e.query), i = [];
  return n.forEach((s, o) => {
    if (e.category && s.category !== e.category || e.only && s.kind !== e.only || e.action && Jr(s) !== e.action) return;
    const r = c8(s, t, e.kind);
    r !== null && i.push({ p: s, score: r, at: o });
  }), i.sort((s, o) => o.score - s.score || s.at - o.at).map((s) => s.p);
}
function Jr(n) {
  return n.inputs.length ? "edit" : "generate";
}
const Ej = ["image", "video"], Rj = ["generate", "edit"];
function xw(n) {
  const e = /* @__PURE__ */ new Map();
  for (const t of n) {
    const i = { kind: t.kind, action: Jr(t), label: t.category || "" }, s = i.kind + "|" + i.action + "|" + i.label, o = e.get(s);
    o ? o.count++ : e.set(s, { ...i, count: 1 });
  }
  return Array.from(e.values()).sort((t, i) => i.count - t.count || t.label.localeCompare(i.label));
}
function _u(n, e = [], t) {
  const i = (o) => {
    const r = e.indexOf(o);
    return r < 0 ? e.length : r;
  }, s = Ej.map((o) => {
    const r = Rj.map((a) => {
      const l = n.filter((u) => u.kind === o && u.action === a && u.count > 0), d = l.reduce((u, p) => u + p.count, 0), c = l.filter((u) => !!u.label).sort((u, p) => i(u.label) - i(p.label) || p.count - u.count || u.label.localeCompare(p.label)).map((u) => ({ label: u.label, count: u.count }));
      return { action: a, count: t ? t[o][a] : d, categories: c };
    });
    return { kind: o, count: r.reduce((a, l) => a + l.count, 0), actions: r };
  });
  return { total: s.reduce((o, r) => o + r.count, 0), kinds: s };
}
function zj(n) {
  return n ? n.charAt(0).toUpperCase() + n.slice(1) : "";
}
function Ea(n, e) {
  return n.byId.get(e.nodeDefId) || n.source === "demo" && n.byName.get(e.name) || null;
}
function ww(n, e, t) {
  return ev(n, e, t);
}
function Ra(n) {
  return n === "image" || n === "imageEdit" ? "image" : n === "video" || n === "videoEdit" ? "video" : null;
}
function kw(n) {
  return /^(Image|Video|3D|Upscale|Image Edit|Video Edit) Tool \d+$/.test(n || "");
}
const $j = /^\s*(\d+(?:\.\d+)?)\s*[:x×]\s*(\d+(?:\.\d+)?)\s*$/;
function u8(n) {
  const e = jr(n.value);
  if (e && Number(e.width) > 0 && Number(e.height) > 0) return Number(e.width) / Number(e.height);
  for (const t of [typeof n.value == "string" ? n.value : "", n.meta || "", n.label]) {
    const i = $j.exec(t);
    if (i && Number(i[2]) > 0) return Number(i[1]) / Number(i[2]);
  }
  return null;
}
function Dj(n) {
  return n.fields.find((e) => e.placement === "chip" && !!e.options && (e.kind === "size" || e.kind === "select" && /aspect|ratio|size/i.test(e.label) && e.options.filter((t) => u8(t) != null).length >= 2)) || null;
}
function Oj(n, e, t) {
  if (!e || !t || !n.options) return;
  const i = e / t;
  let s = null;
  for (const o of n.options) {
    const r = u8(o);
    if (r == null) continue;
    const a = Math.abs(Math.log(r / i));
    (!s || a < s.d) && (s = { v: o.value, d: a });
  }
  return s && s.d < Math.log(1.12) ? s.v : void 0;
}
function Lj(n, e) {
  const t = n.fields.filter((l) => l.placement === "reference"), i = e.inputs.map((l) => l.url), s = {}, o = { prompt: e.prompt, ref: null, inputs: s, n: 1 };
  let r = 0;
  for (const l of t) {
    if (r >= i.length) break;
    if (l.kind !== "image" && l.kind !== "images") continue;
    const d = l.kind === "images" ? i.slice(r, r + Math.max(1, l.maxImages || i.length)) : [i[r]];
    r += d.length, l === t[0] && (o.ref = d[0]), d.length > 1 ? s[l.key] = d : l !== t[0] && (s[l.key] = d[0]);
  }
  const a = Dj(n);
  if (a) {
    const l = Oj(a, e.output.w, e.output.h);
    l !== void 0 && (s[a.key] = l);
  }
  return { up: o, dropped: i.length - r };
}
function Bj(n, e, t) {
  return e ? n.filter((i) => !!i.line && i.kind === e && (t || !i.inputs.length)).map((i) => ({ id: i.id, text: i.line })) : [];
}
function Fj(n, e) {
  if (!e) return 0;
  let t = 0;
  for (let i = 0; i < n.length; i++) t = t * 31 + n.charCodeAt(i) >>> 0;
  return t % e;
}
const Ht = (n) => typeof n == "string" ? n : "", da = (n) => n && typeof n == "object" && !Array.isArray(n) ? n : null;
function Nj(n, e) {
  const t = da(e), i = t && da(t.tool);
  if (!t || !i || t.deletedAt || !Ht(t.authorId) || !Ht(t.prompt)) return null;
  const s = da(t.output) || {}, o = Array.isArray(t.inputs) ? t.inputs.map(da).filter((a) => !!a && !!Ht(a.url)).map((a) => ({ label: Ht(a.label), role: Ht(a.role), title: Ht(a.title) || void 0, kind: a.kind === "markup" ? "markup" : "reference", url: Ht(a.url) })) : [], r = da(t.run);
  return {
    id: n,
    name: Ht(t.name) || "Untitled prompt",
    category: Ht(t.category),
    description: Ht(t.description),
    prompt: Ht(t.prompt),
    mode: Ht(t.mode) || Kc(o.length),
    tags: Array.isArray(t.tags) ? t.tags.filter((a) => typeof a == "string") : [],
    kind: t.kind === "video" ? "video" : "image",
    tool: { nodeDefId: Ht(i.nodeDefId), name: Ht(i.name) },
    output: { url: Ht(s.url), w: Number(s.w) || 0, h: Number(s.h) || 0, thumb: Ht(s.thumb) || void 0, video: Ht(s.video) || void 0 },
    inputs: o,
    authorId: Ht(t.authorId),
    authorName: Ht(t.authorName),
    boardId: Ht(t.boardId) || null,
    teamId: Ht(t.teamId) || null,
    companyId: Ht(t.companyId) || null,
    values: da(t.values),
    run: r && Ht(r.runId) ? { runId: Ht(r.runId), uuid: Ht(r.uuid) } : null,
    createdAt: hn(t.createdAt) || 0,
    updatedAt: hn(t.updatedAt) || hn(t.createdAt) || 0
  };
}
function Op(n, e) {
  const t = [];
  return n.boardId && n.boardId === e && t.push("board"), n.teamId && t.push("team"), n.companyId && t.push("company"), t.length || n.boardId ? t : ["me"];
}
function h8(n, e) {
  return !!n.boardId && n.boardId !== e;
}
function Kc(n) {
  return n === 0 ? "text only" : n === 1 ? "one image" : "multiple images";
}
const Uj = 2e4;
function Gj(n) {
  const e = n ? n.fields.find((i) => i.kind === "prompt") : void 0, t = e && e.raw && e.raw.display ? e.raw.display.maxLength : void 0;
  return Math.min(typeof t == "number" && t > 0 ? t : 2e3, Uj);
}
function _w(n, e) {
  if (e && !/^(Image|Video|3D|Upscale|Image Edit|Video Edit) Tool \d+$/.test(e)) return e;
  const t = String(n || "").replace(/([.!?])\s+/g, `$1
`).split(/\n+/).map((o) => o.trim()).filter(Boolean);
  let s = (t.find((o) => !/^create one finished architectural/i.test(o) && !/^image \d+ is /i.test(o)) || t[0] || "").replace(/[.!?]+$/, "").split(/[,;:]/)[0].trim();
  return s.length > 42 && (s = s.slice(0, 42).replace(/\s\S*$/, "")), s ? s.charAt(0).toUpperCase() + s.slice(1) : "Untitled prompt";
}
function p8(n, e, t, i) {
  const s = [];
  if (n && e) {
    const o = Ap(n, e, i);
    n.fields.filter((a) => a.placement === "reference").forEach((a, l) => {
      const d = o.inputs ? o.inputs[a.key] : void 0, c = Array.isArray(d) ? d.filter((p) => typeof p == "string") : [], u = l === 0 ? o.ref : typeof d == "string" ? d : null;
      for (const p of c.length ? c : u ? [u] : []) s.push({ url: p, role: a.label });
    });
  }
  if (!s.length) for (const o of t) s.push({ url: o, role: "Input image" });
  return s.map((o, r) => ({ label: "Image " + (r + 1), role: o.role, kind: "reference", url: o.url }));
}
function jj(n, e) {
  if (!e) return null;
  const t = { ...e };
  if (delete t[a1], n)
    for (const i of n.fields) i.placement === "reference" && delete t[i.key];
  return t;
}
function Hj(n, e, t) {
  const i = n.inputs ? JSON.parse(JSON.stringify(n.inputs)) : null, s = p8(e, i, n.refs || [], t);
  return {
    name: "",
    category: "",
    description: "",
    prompt: n.prompt || "",
    mode: Kc(s.length),
    tags: [],
    kind: n.video ? "video" : "image",
    tool: { nodeDefId: n.modelId || (e ? e.id : ""), name: e && e.name || n.model || "" },
    output: { url: n.url, w: n.w || 0, h: n.h || 0, thumb: n.thumb, video: n.videoSrc },
    inputs: s,
    boardId: null,
    teamId: null,
    companyId: null,
    values: i,
    run: n.runId && n.uuid ? { runId: n.runId, uuid: n.uuid } : null
  };
}
function Sw(n, e, t, i) {
  const s = new Set(e.filter((a) => a.authorId === t && a.id !== i).map((a) => a.name.trim().toLowerCase())), o = n.trim();
  if (!s.has(o.toLowerCase())) return o;
  let r = 2;
  for (; s.has((o + " " + r).toLowerCase()); ) r++;
  return o + " " + r;
}
function Tw(n, e, t, i, s) {
  const o = t.trim();
  return n.find((r) => r.authorId === e && r.id !== s && r.tool.nodeDefId === i && r.prompt.trim() === o) || null;
}
function Vj(n) {
  const e = /* @__PURE__ */ new Map();
  for (const t of n) t.category && e.set(t.category, (e.get(t.category) || 0) + 1);
  return Array.from(e.entries()).sort((t, i) => i[1] - t[1] || t[0].localeCompare(i[0])).map(([t]) => t);
}
const g1 = 200, f8 = 12, Wj = 100;
function qj(n) {
  return m1(n.slice(0, g1)).slice(0, f8);
}
function Kj(n) {
  const e = Array.from(new Set(m1(n))).sort((s, o) => o.length - s.length), t = [];
  let i = 0;
  for (const s of e) {
    if (t.length === f8) break;
    const o = (t.length ? 1 : 0) + s.length;
    i + o > g1 || (t.push(s), i += o);
  }
  return t.join(" ");
}
function Yj(n, e) {
  return e.levels.length && !Op(n, e.boardId).some((t) => e.levels.includes(t)) || e.onlyKind && n.kind !== e.onlyKind || e.onlyAction && Jr(n) !== e.onlyAction || e.category && n.category !== e.category || e.mine && n.authorId !== e.uid || e.toolId && n.tool.nodeDefId !== e.toolId ? !1 : c8(n, qj(e.query)) !== null;
}
function Xj(n) {
  return Array.from(n.entries()).filter(([, e]) => e > 0).sort((e, t) => t[1] - e[1] || e[0].localeCompare(t[0])).slice(0, Wj).map(([e, t]) => ({ label: e, count: t }));
}
function Jj(n, e, t) {
  const i = { kind: e.kind, action: Jr(e), label: e.category || "" }, s = n.findIndex((r) => r.kind === i.kind && r.action === i.action && r.label === i.label), o = n.slice();
  return s < 0 ? t > 0 && o.push({ ...i, count: t }) : o[s] = { ...o[s], count: Math.max(0, o[s].count + t) }, o.filter((r) => r.count > 0).sort((r, a) => a.count - r.count || r.label.localeCompare(a.label));
}
function jm(n, e, t, i) {
  if (!n) return n;
  const s = { ...n.levels }, o = n.kinds ? { ...n.kinds } : void 0, r = n.actions ? { image: { ...n.actions.image }, video: { ...n.actions.video } } : void 0;
  let a = n.groups;
  const l = new Map(n.categories.map((u) => [u.label, u.count]));
  let d = n.total;
  const c = (u, p) => {
    d = Math.max(0, d + p);
    for (const f of Op(u, i)) s[f] = Math.max(0, s[f] + p);
    o && (o[u.kind] = Math.max(0, o[u.kind] + p)), r && (r[u.kind][Jr(u)] = Math.max(0, r[u.kind][Jr(u)] + p)), a && (a = Jj(a, u, p)), u.category && l.set(u.category, Math.max(0, (l.get(u.category) || 0) + p));
  };
  return e && c(e, -1), t && c(t, 1), { total: d, levels: s, ...o ? { kinds: o } : {}, ...r ? { actions: r } : {}, categories: Xj(l), ...a ? { groups: a } : {} };
}
function m8(n) {
  const e = /* @__PURE__ */ K(!1), t = () => {
    const s = n.value;
    e.value = !!s && s.scrollHeight - s.scrollTop - s.clientHeight > 4;
  }, i = typeof ResizeObserver != "undefined" ? new ResizeObserver(t) : null;
  return $e(n, (s, o) => {
    i && o && i.unobserve(o), i && s && i.observe(s), t();
  }, { flush: "post" }), j5(t), Ve(() => {
    i && i.disconnect();
  }), { more: e, measure: t };
}
const Zj = { class: "ps-head" }, Qj = { class: "ps-mark" }, eH = { class: "ps-title" }, tH = { class: "ps-field" }, nH = { class: "ps-field" }, iH = {
  class: "ps-audience",
  "data-testid": "save-audience"
}, sH = { class: "ps-levels" }, oH = ["aria-checked"], rH = { class: "ps-level-text" }, aH = ["aria-checked", "disabled"], lH = { class: "ps-level-text" }, dH = ["aria-checked", "disabled"], cH = { class: "ps-level-text" }, uH = { class: "ps-field" }, hH = { class: "ps-cats" }, pH = ["onClick"], fH = { class: "ps-field" }, mH = { class: "ps-field" }, gH = { class: "pl-pills" }, bH = { class: "pl-pill" }, vH = { class: "pl-pill is-quiet" }, yH = {
  key: 0,
  class: "ps-check",
  "data-testid": "save-inputs"
}, xH = { class: "ps-thumbs" }, wH = {
  key: 0,
  class: "ps-dup",
  "data-testid": "save-duplicate"
}, kH = ["disabled"], _H = { class: "ps-foot" }, SH = ["disabled"], g8 = /* @__PURE__ */ Re({
  __name: "SavePromptSheet",
  props: {
    draft: {},
    editingId: {}
  },
  emits: ["done", "cancel"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = tt(), o = s.promptLibrary, r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), { more: l, measure: d } = m8(a), c = /* @__PURE__ */ K(t.draft.name), u = /* @__PURE__ */ K(!1), p = /* @__PURE__ */ K(t.draft.category), f = /* @__PURE__ */ K(""), y = /* @__PURE__ */ K(t.draft.prompt), b = /* @__PURE__ */ K(!0), w = { levels: o.levelsFor(t.draft), boardId: t.draft.boardId, teamId: t.draft.teamId, companyId: t.draft.companyId }, k = /* @__PURE__ */ Xt({ ...w.levels }), S = I(() => !k.board && h8(t.draft, s.meta.id)), _ = /* @__PURE__ */ K(!1), x = I(() => o.team.value), T = I(() => o.company()), M = I(() => o.managesTeam() || !!t.editingId && w.levels.team), z = I(() => o.managesCompany() || !!t.editingId && w.levels.company), P = I(() => k.team && M.value), D = I(() => k.company && z.value), $ = I(() => s.labels.team), O = I(() => s.meta.title || "this board"), L = I(() => !!s.meta.teamId), Z = I(() => {
      o.myPrompts.counts.value, o.mine.value;
      const oe = o.mineCategories();
      return t.draft.category && !oe.includes(t.draft.category) ? [t.draft.category].concat(oe) : oe;
    }), J = I(() => f.value.trim() || p.value), re = I(() => s.catalog.value.byId.get(t.draft.tool.nodeDefId) || null), F = I(() => Gj(re.value)), W = I(() => y.value.length > F.value), ee = I(() => !!c.value.trim() && !!y.value.trim() && !W.value && !_.value), N = I(() => x.value && x.value.name ? "Everyone in " + x.value.name : "Everyone in your " + $.value), te = I(() => "Only people who manage " + (x.value && x.value.name ? x.value.name + "'s" : "your " + $.value + "'s") + " prompts can share here"), G = I(() => T.value && T.value.name ? "Everyone at " + T.value.name : "Everyone in your company"), q = I(() => "Only people who manage " + (T.value && T.value.name ? T.value.name + "'s" : "your company's") + " prompts can share here"), B = I(() => S.value ? "On another board now: turn this on to move it here" : L.value ? "Everyone who can open this board" : "Only you can open this board"), ne = I(() => {
      const oe = k.board ? O.value : S.value ? "the board it's filed on" : "";
      return D.value && T.value ? G.value + (oe ? ", and kept with " + oe : "") : P.value && x.value ? N.value + (oe ? ", and kept with " + oe : "") : k.board ? L.value ? "Everyone who can open " + O.value : "Kept with " + O.value + ", which only you can open" : S.value ? "Everyone who can open the board it's filed on" : "Only you, on every board";
    }), se = /* @__PURE__ */ K(null);
    let Y = 0, ie = null;
    function De() {
      const oe = ++Y;
      o.duplicateFor(y.value, t.draft.tool.nodeDefId, t.editingId).then((ue) => {
        oe === Y && (se.value = ue);
      }).catch(() => {
        oe === Y && (se.value = null);
      });
    }
    $e(y, () => {
      ie && clearTimeout(ie), ie = setTimeout(De, 300);
    });
    function xe() {
      const oe = b.value ? t.draft.inputs : [], ue = b.value ? t.draft.values : jj(re.value, t.draft.values);
      return o.withLevels({
        ...t.draft,
        name: c.value.trim(),
        category: J.value,
        prompt: y.value,
        inputs: oe,
        mode: Kc(oe.length),
        values: ue
      }, { board: k.board, team: P.value, company: D.value }, w);
    }
    async function Oe() {
      if (!ee.value) return;
      _.value = !0;
      const oe = await o.save(xe(), t.editingId);
      _.value = !1, oe && i("done", oe);
    }
    async function Ee() {
      const oe = se.value;
      if (!oe || _.value) return;
      _.value = !0;
      const ue = await o.save({ ...xe(), name: oe.name, category: oe.category, boardId: oe.boardId, teamId: oe.teamId, companyId: oe.companyId }, oe.id);
      _.value = !1, ue && i("done", ue);
    }
    function j(oe) {
      oe.stopPropagation(), oe.key === "Escape" ? (oe.preventDefault(), i("cancel")) : oe.key === "Enter" && vn(oe) && (oe.preventDefault(), Oe());
    }
    function V() {
      if (t.editingId) return;
      const oe = c.value;
      o.freshNameFor(oe).then((ue) => {
        u.value || _.value || c.value !== oe || ue === oe || (c.value = ue, it(() => {
          r.value && document.activeElement === r.value && r.value.select();
        }));
      }).catch(() => {
      });
    }
    function Q(oe) {
      p.value = p.value === oe && !f.value ? "" : oe, f.value = "";
    }
    return Ve(() => {
      ie && clearTimeout(ie), Y++;
    }), ot(() => {
      o.startMine(), V(), De(), it(() => {
        const oe = r.value;
        oe && (oe.focus({ preventScroll: !0 }), oe.select());
      });
    }), (oe, ue) => (g(), v("form", {
      class: "ps",
      "data-testid": "save-prompt",
      onSubmit: Pe(Oe, ["prevent"]),
      onKeydown: j,
      onPointerdown: ue[10] || (ue[10] = Pe(() => {
      }, ["stop"]))
    }, [
      h("header", Zj, [
        h("span", Qj, [
          C(R, {
            name: "Bookmark",
            size: 15
          })
        ]),
        h("span", eH, [
          h("b", null, A(n.editingId ? "Edit prompt" : "Save to the prompt library"), 1),
          h("em", null, A(n.editingId ? "Changes reach everyone it's shared with." : "Keep it for any board, or share it."), 1)
        ])
      ]),
      h("div", {
        ref_key: "bodyEl",
        ref: a,
        class: U(["ps-body", { "is-more": m(l) }]),
        onScrollPassive: ue[8] || (ue[8] = //@ts-ignore
        (...Ie) => m(d) && m(d)(...Ie))
      }, [
        h("label", tH, [
          ue[11] || (ue[11] = h("span", { class: "pl-label" }, "Name", -1)),
          xt(h("input", {
            ref_key: "nameEl",
            ref: r,
            "onUpdate:modelValue": ue[0] || (ue[0] = (Ie) => c.value = Ie),
            class: "ps-input",
            maxlength: "80",
            placeholder: "Name this prompt",
            "data-testid": "save-name",
            onInput: ue[1] || (ue[1] = (Ie) => u.value = !0)
          }, null, 544), [
            [Jt, c.value]
          ])
        ]),
        h("div", nH, [
          ue[17] || (ue[17] = h("span", { class: "pl-label" }, "Who can use it", -1)),
          h("p", iH, [
            C(R, {
              name: k.board || P.value || D.value || S.value ? "Users" : "Lock",
              size: 12
            }, null, 8, ["name"]),
            X(A(ne.value), 1)
          ]),
          h("div", sH, [
            h("button", {
              type: "button",
              class: U(["ps-level", { on: k.board }]),
              role: "switch",
              "aria-checked": k.board,
              "data-testid": "level-board",
              onClick: ue[2] || (ue[2] = (Ie) => k.board = !k.board)
            }, [
              C(R, {
                name: "LayoutGrid",
                size: 14
              }),
              h("span", rH, [
                ue[12] || (ue[12] = h("b", null, "This board", -1)),
                h("em", null, A(B.value), 1)
              ]),
              ue[13] || (ue[13] = h("span", { class: "ps-switch" }, null, -1))
            ], 10, oH),
            x.value ? (g(), v("button", {
              key: 0,
              type: "button",
              class: U(["ps-level", { on: P.value, "is-off": !M.value }]),
              role: "switch",
              "aria-checked": P.value,
              disabled: !M.value,
              "data-testid": "level-team",
              onClick: ue[3] || (ue[3] = (Ie) => k.team = !k.team)
            }, [
              C(R, {
                name: "Users",
                size: 14
              }),
              h("span", lH, [
                h("b", null, A(m(Xb)($.value)), 1),
                h("em", null, A(M.value ? N.value : te.value), 1)
              ]),
              ue[14] || (ue[14] = h("span", { class: "ps-switch" }, null, -1))
            ], 10, aH)) : E("", !0),
            T.value ? (g(), v("button", {
              key: 1,
              type: "button",
              class: U(["ps-level", { on: D.value, "is-off": !z.value }]),
              role: "switch",
              "aria-checked": D.value,
              disabled: !z.value,
              "data-testid": "level-company",
              onClick: ue[4] || (ue[4] = (Ie) => k.company = !k.company)
            }, [
              C(R, {
                name: "Building2",
                size: 14
              }),
              h("span", cH, [
                ue[15] || (ue[15] = h("b", null, "Company", -1)),
                h("em", null, A(z.value ? G.value : q.value), 1)
              ]),
              ue[16] || (ue[16] = h("span", { class: "ps-switch" }, null, -1))
            ], 10, dH)) : E("", !0)
          ])
        ]),
        h("div", uH, [
          ue[18] || (ue[18] = h("span", { class: "pl-label" }, "Category", -1)),
          h("div", hH, [
            (g(!0), v(H, null, me(Z.value, (Ie) => (g(), v("button", {
              key: Ie,
              type: "button",
              class: U(["pl-chip", { on: !f.value.trim() && p.value === Ie }]),
              onClick: (he) => Q(Ie)
            }, A(Ie), 11, pH))), 128)),
            xt(h("input", {
              "onUpdate:modelValue": ue[5] || (ue[5] = (Ie) => f.value = Ie),
              class: "ps-input is-chip",
              maxlength: "40",
              placeholder: "New category",
              "data-testid": "save-new-category"
            }, null, 512), [
              [Jt, f.value]
            ])
          ])
        ]),
        h("label", fH, [
          ue[19] || (ue[19] = h("span", { class: "pl-label" }, "Prompt", -1)),
          xt(h("textarea", {
            "onUpdate:modelValue": ue[6] || (ue[6] = (Ie) => y.value = Ie),
            class: "ps-input ps-text",
            rows: "5",
            "data-testid": "save-prompt-text"
          }, null, 512), [
            [Jt, y.value]
          ]),
          h("span", {
            class: U(["ps-hint", { "is-bad": W.value }])
          }, A(W.value ? y.value.length.toLocaleString() + " characters: " + (n.draft.tool.name || "its tool") + " takes up to " + F.value.toLocaleString() + "." : "Edit it to take out anything only this project needs."), 3)
        ]),
        h("div", mH, [
          ue[21] || (ue[21] = h("span", { class: "pl-label" }, "Comes with", -1)),
          h("div", gH, [
            h("span", bH, [
              C(R, {
                name: "Sparkles",
                size: 12
              }),
              X(A(n.draft.tool.name || "Its tool"), 1)
            ]),
            h("span", vH, [
              C(R, {
                name: "Settings2",
                size: 12
              }),
              ue[20] || (ue[20] = X("Its settings", -1))
            ])
          ]),
          n.draft.inputs.length ? (g(), v("label", yH, [
            xt(h("input", {
              "onUpdate:modelValue": ue[7] || (ue[7] = (Ie) => b.value = Ie),
              type: "checkbox"
            }, null, 512), [
              [Na, b.value]
            ]),
            h("span", null, "Its " + A(n.draft.inputs.length === 1 ? "input image" : n.draft.inputs.length + " input images"), 1),
            h("span", xH, [
              (g(!0), v(H, null, me(n.draft.inputs.slice(0, 5), (Ie, he) => (g(), v("span", {
                key: he,
                style: de({ backgroundImage: 'url("' + m(Wt)(Ie.url) + '")' })
              }, null, 4))), 128))
            ])
          ])) : E("", !0)
        ]),
        se.value ? (g(), v("p", wH, [
          C(R, {
            name: "Info",
            size: 12
          }),
          h("span", null, "You saved this prompt before as “" + A(se.value.name) + "”.", 1),
          h("button", {
            type: "button",
            class: "ps-link",
            disabled: _.value,
            onClick: Ee
          }, "Update that one instead", 8, kH)
        ])) : E("", !0)
      ], 34),
      h("footer", _H, [
        h("button", {
          type: "submit",
          class: "pl-cta",
          disabled: !ee.value,
          "data-testid": "save-submit"
        }, A(_.value ? "Saving…" : n.editingId ? "Save changes" : "Save prompt"), 9, SH),
        h("button", {
          type: "button",
          class: "pl-btn is-glass is-lg",
          "data-testid": "save-cancel",
          onClick: ue[9] || (ue[9] = (Ie) => i("cancel"))
        }, "Cancel")
      ])
    ], 32));
  }
}), TH = "Bonneville Tower", MH = { team: [{ initials: "KB", name: "Kira Bennett" }, { initials: "JR", name: "Jonah Reyes" }, { initials: "MT", name: "Mei Tanaka" }] }, CH = /* @__PURE__ */ JSON.parse('[{"id":"f1","type":"frame","x":200,"y":200,"w":1400,"h":548,"title":"Site photos","z":0},{"id":"f2","type":"frame","x":1720,"y":200,"w":1400,"h":626,"title":"Massing sketches","z":1},{"id":"f3","type":"frame","x":3240,"y":200,"w":1400,"h":389,"title":"Site plans & analysis","z":2},{"id":"f4","type":"frame","x":4760,"y":200,"w":1400,"h":575,"title":"White card models","z":3},{"id":"f5","type":"frame","x":200,"y":858,"w":1400,"h":573,"title":"Direction renders","z":4},{"id":"f6","type":"frame","x":1720,"y":936,"w":1400,"h":997,"title":"Bench Gardens","z":5},{"id":"f7","type":"frame","x":3240,"y":699,"w":1400,"h":575,"title":"Hero options","z":6},{"id":"f8","type":"frame","x":4760,"y":885,"w":1400,"h":1473,"title":"Facade iterations","z":7},{"id":"f9","type":"frame","x":200,"y":1541,"w":1400,"h":1075,"title":"Material studies","z":8},{"id":"f10","type":"frame","x":1720,"y":2043,"w":1400,"h":650,"title":"Lobby","z":9},{"id":"f11","type":"frame","x":3240,"y":1384,"w":1400,"h":532,"title":"Sky lounge","z":10},{"id":"f12","type":"frame","x":4760,"y":2468,"w":1400,"h":1022,"title":"Camera set","z":11},{"id":"f13","type":"frame","x":200,"y":2726,"w":1400,"h":600,"title":"Corner residence","z":12},{"id":"f14","type":"frame","x":1720,"y":2803,"w":1400,"h":1473,"title":"Seasons & light","z":13},{"id":"f15","type":"frame","x":3240,"y":2026,"w":1400,"h":530,"title":"Masterplan views","z":14},{"id":"f16","type":"frame","x":4760,"y":3600,"w":1400,"h":1473,"title":"Motion","z":15},{"id":"f17","type":"frame","x":200,"y":3436,"w":1400,"h":575,"title":"Print upscales","z":16},{"id":"b1","type":"tool","x":244,"y":296,"name":"Site photos","kind":"Image","model":"Nano Banana 2","icon":"Map","count":3,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s02-existing-depot-street-7c94e0-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s03-existing-buried-creek-channel-160598-800w.webp"],"z":17},{"id":"n11","type":"note","x":244,"y":492,"w":184,"h":184,"tint":"amethyst","text":"Site walk done. The buried creek is the opportunity.","author":"KB","z":18},{"id":"x1","type":"image","x":540,"y":296,"w":316,"h":176,"label":"existing_site_aerial","tid":"s01","z":19,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","pw":800,"ph":447},{"id":"x2","type":"image","x":882,"y":304,"w":316,"h":176,"label":"existing_depot_street","tid":"s02","z":20,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s02-existing-depot-street-7c94e0-800w.webp","pw":800,"ph":447},{"id":"x3","type":"image","x":1224,"y":292,"w":316,"h":176,"label":"existing_buried_creek_ch","tid":"s03","z":21,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s03-existing-buried-creek-channel-160598-800w.webp","pw":800,"ph":447},{"id":"b2","type":"tool","x":1764,"y":296,"name":"Massing sketches","kind":"Image","model":"Nano Banana 2","icon":"Building2","count":3,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e02-option-b-sketch-canyon-374663-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e03-option-c-sketch-salt-11df63-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e01-option-a-sketch-shoreline-c101a0-800w.webp"],"z":22},{"id":"x4","type":"image","x":2060,"y":296,"w":316,"h":423,"label":"option_b_sketch_canyon","tid":"e02","z":23,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e02-option-b-sketch-canyon-374663-800w.webp","pw":800,"ph":1071},{"id":"x5","type":"image","x":2402,"y":304,"w":316,"h":421,"label":"option_c_sketch_salt","tid":"e03","z":24,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e03-option-c-sketch-salt-11df63-800w.webp","pw":800,"ph":1067},{"id":"x6","type":"image","x":2744,"y":292,"w":316,"h":474,"label":"option_a_sketch_shorelin","tid":"e01","z":25,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e01-option-a-sketch-shoreline-c101a0-800w.webp","pw":800,"ph":1200},{"id":"b3","type":"tool","x":3284,"y":296,"name":"Site plans","kind":"Image","model":"ChatGPT Image 2","icon":"Map","count":2,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s04-existing-site-plan-ee31f8-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s05-concept-drivers-board-25e1a7-800w.webp"],"z":26},{"id":"x7","type":"image","x":3580,"y":296,"w":316,"h":237,"label":"existing_site_plan","tid":"s04","z":27,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s04-existing-site-plan-ee31f8-800w.webp","pw":800,"ph":600},{"id":"x8","type":"image","x":3922,"y":304,"w":316,"h":178,"label":"concept_drivers_board","tid":"s05","z":28,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s05-concept-drivers-board-25e1a7-800w.webp","pw":800,"ph":450},{"id":"b4","type":"tool","x":4804,"y":296,"name":"White card","kind":"Image","model":"Seedream 5 Lite","icon":"Building2","count":2,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e04-white-card-options-a-b-c-1713cd-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e05-option-a-white-card-model-c61989-800w.webp"],"z":29},{"id":"n41","type":"note","x":4804,"y":492,"w":184,"h":184,"tint":"amethyst","text":"Client leaning A. The shorelines story lands.","author":"JR","z":30},{"id":"x9","type":"image","x":5100,"y":296,"w":316,"h":178,"label":"white_card_options_a_b_c","tid":"e04","z":31,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e04-white-card-options-a-b-c-1713cd-800w.webp","pw":800,"ph":450},{"id":"x10","type":"image","x":5442,"y":304,"w":316,"h":423,"label":"option_a_white_card_mode","tid":"e05","z":32,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e05-option-a-white-card-model-c61989-800w.webp","pw":800,"ph":1071},{"id":"b5","type":"tool","x":244,"y":954,"name":"Direction renders","kind":"Image","model":"ChatGPT Image 2","icon":"Building2","count":3,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e06-option-b-render-parked-80d4c0-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e07-option-c-render-parked-e0c191-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e08-option-a-watercolor-db5917-800w.webp"],"z":33},{"id":"x11","type":"image","x":540,"y":954,"w":316,"h":421,"label":"option_b_render_parked","tid":"e06","z":34,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e06-option-b-render-parked-80d4c0-800w.webp","pw":800,"ph":1067},{"id":"x12","type":"image","x":882,"y":962,"w":316,"h":421,"label":"option_c_render_parked","tid":"e07","z":35,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e07-option-c-render-parked-e0c191-800w.webp","pw":800,"ph":1067},{"id":"x13","type":"image","x":1224,"y":950,"w":316,"h":421,"label":"option_a_watercolor","tid":"e08","z":36,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e08-option-a-watercolor-db5917-800w.webp","pw":800,"ph":1067},{"id":"b6","type":"tool","x":1764,"y":1032,"name":"Bench Gardens","kind":"Image","model":"Nano Banana 2","icon":"Trees","count":12,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l01-rendered-landscape-masterplan-0b3979-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l09-greener-depot-street-a56204-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l03-creek-walk-engine-export-d0559e-800w.webp"],"z":37},{"id":"x14","type":"image","x":2060,"y":1032,"w":316,"h":237,"label":"rendered_landscape_maste","tid":"l01","z":38,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l01-rendered-landscape-masterplan-0b3979-800w.webp","pw":800,"ph":600},{"id":"x15","type":"image","x":2402,"y":1040,"w":316,"h":237,"label":"watercolor_masterplan","tid":"l02","z":39,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","pw":800,"ph":600},{"id":"x16","type":"image","x":2744,"y":1028,"w":316,"h":176,"label":"greener_depot_street","tid":"l09","z":40,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l09-greener-depot-street-a56204-800w.webp","pw":800,"ph":447},{"id":"x17","type":"image","x":2060,"y":1295,"w":316,"h":178,"label":"creek_walk_engine_export","tid":"l03","z":41,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l03-creek-walk-engine-export-d0559e-800w.webp","pw":800,"ph":450},{"id":"x18","type":"image","x":2402,"y":1303,"w":316,"h":176,"label":"creek_walk_marketing_her","tid":"l04","fav":true,"z":42,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l04-creek-walk-marketing-hero-92d17d-800w.webp","pw":800,"ph":447},{"id":"x19","type":"image","x":2744,"y":1291,"w":316,"h":176,"label":"swap_trees_to_gambel_oak","tid":"l05","z":43,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l05-swap-trees-to-gambel-oak-2f2873-800w.webp","pw":800,"ph":447},{"id":"x20","type":"image","x":2060,"y":1499,"w":316,"h":176,"label":"markup_benches_and_overl","tid":"l06","z":44,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l06-markup-benches-and-overlook-11b969-800w.webp","pw":800,"ph":447},{"id":"x21","type":"image","x":2402,"y":1507,"w":316,"h":176,"label":"benches_and_overlook_add","tid":"l07","z":45,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l07-benches-and-overlook-added-ca8f6c-800w.webp","pw":800,"ph":447},{"id":"x22","type":"image","x":2744,"y":1495,"w":316,"h":176,"label":"level_24_terrace_empty","tid":"l10","z":46,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l10-level-24-terrace-empty-788189-800w.webp","pw":800,"ph":447},{"id":"x23","type":"image","x":2060,"y":1701,"w":316,"h":176,"label":"terrace_built_in_seating","tid":"l11","z":47,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l11-terrace-built-in-seating-56f47f-800w.webp","pw":800,"ph":447},{"id":"x24","type":"image","x":2402,"y":1709,"w":316,"h":176,"label":"taller_planters_trailing","tid":"l12","z":48,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l12-taller-planters-trailing-plants-0310f9-800w.webp","pw":800,"ph":447},{"id":"x25","type":"image","x":2744,"y":1697,"w":316,"h":176,"label":"daytime_gardens_with_peo","tid":"l08","fav":true,"z":49,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l08-daytime-gardens-with-people-8fb7f2-800w.webp","pw":800,"ph":447},{"id":"b7","type":"tool","x":3284,"y":795,"name":"Hero options","kind":"Image","model":"Nano Banana Pro","icon":"Building2","count":2,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e09-hero-v1-model-to-photo-0725c1-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e21-hero-as-fine-pen-colour-sketch-92581b-800w.webp"],"z":50},{"id":"n71","type":"note","x":3284,"y":991,"w":184,"h":184,"tint":"amethyst","text":"Client review Thursday. Pick two for the cover spread.","author":"JR","z":51},{"id":"x26","type":"image","x":3580,"y":795,"w":316,"h":423,"label":"hero_v1_model_to_photo","tid":"e09","fav":true,"z":52,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e09-hero-v1-model-to-photo-0725c1-800w.webp","pw":800,"ph":1071},{"id":"x27","type":"image","x":3922,"y":803,"w":316,"h":423,"label":"hero_as_fine_pen_colour_","tid":"e21","z":53,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e21-hero-as-fine-pen-colour-sketch-92581b-800w.webp","pw":800,"ph":1071},{"id":"b8","type":"tool","x":4804,"y":981,"name":"Facade iterations","kind":"Image","model":"Nano Banana 2","icon":"Building2","count":7,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e10-hero-v2-open-crown-4a3b4d-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e11-markup-terraces-8b641f-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e12-hero-v3-deeper-terraces-1c4ede-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e13-markup-crown-louvres-c1ed86-800w.webp"],"z":54},{"id":"n81","type":"note","x":4804,"y":1177,"w":184,"h":184,"tint":"vista","text":"Crown feels heavy. Open it up.","author":"JR","z":55},{"id":"n82","type":"note","x":4804,"y":1377,"w":184,"h":184,"tint":"glass","text":"Plum crown? Fun, but reads Vegas. Staying sandstone.","author":"MT","z":56},{"id":"x28","type":"image","x":5100,"y":981,"w":316,"h":423,"label":"hero_v2_open_crown","tid":"e10","z":57,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e10-hero-v2-open-crown-4a3b4d-800w.webp","pw":800,"ph":1071},{"id":"x29","type":"image","x":5442,"y":989,"w":316,"h":423,"label":"markup_terraces","tid":"e11","z":58,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e11-markup-terraces-8b641f-800w.webp","pw":800,"ph":1071},{"id":"x30","type":"image","x":5784,"y":977,"w":316,"h":423,"label":"hero_v3_deeper_terraces","tid":"e12","z":59,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e12-hero-v3-deeper-terraces-1c4ede-800w.webp","pw":800,"ph":1071},{"id":"x31","type":"image","x":5100,"y":1430,"w":316,"h":423,"label":"markup_crown_louvres","tid":"e13","z":60,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e13-markup-crown-louvres-c1ed86-800w.webp","pw":800,"ph":1071},{"id":"x32","type":"image","x":5442,"y":1438,"w":316,"h":423,"label":"option_plum_crown_reject","tid":"e14","z":61,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e14-option-plum-crown-rejected-0a7466-800w.webp","pw":800,"ph":1071},{"id":"x33","type":"image","x":5784,"y":1426,"w":316,"h":423,"label":"hero_v4_brick_podium","tid":"e15","fav":true,"z":62,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp","pw":800,"ph":1071},{"id":"x34","type":"image","x":5100,"y":1879,"w":316,"h":423,"label":"option_east_face_balconi","tid":"e23","z":63,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e23-option-east-face-balconies-21b33e-800w.webp","pw":800,"ph":1071},{"id":"b9","type":"tool","x":244,"y":1637,"name":"Material studies","kind":"Image","model":"Nano Banana 2","icon":"Layers","count":8,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m05-lobby-floor-red-rock-terrazzo-5379b6-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m06-match-paving-to-the-benches-f8aac0-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m02-louvre-option-oxide-red-3b9834-800w.webp"],"z":64},{"id":"n91","type":"note","x":244,"y":1833,"w":184,"h":184,"tint":"glass","text":"Try oxide red on the west face?","author":"MT","z":65},{"id":"x35","type":"image","x":540,"y":1637,"w":316,"h":237,"label":"material_sample_flat_lay","tid":"m01","z":66,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp","pw":800,"ph":600},{"id":"x36","type":"image","x":882,"y":1645,"w":316,"h":236,"label":"lobby_floor_red_rock_ter","tid":"m05","z":67,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m05-lobby-floor-red-rock-terrazzo-5379b6-800w.webp","pw":800,"ph":597},{"id":"x37","type":"image","x":1224,"y":1633,"w":316,"h":176,"label":"match_paving_to_the_benc","tid":"m06","z":68,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m06-match-paving-to-the-benches-f8aac0-800w.webp","pw":800,"ph":447},{"id":"x38","type":"image","x":540,"y":1900,"w":316,"h":423,"label":"louvre_option_oxide_red","tid":"m02","z":69,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m02-louvre-option-oxide-red-3b9834-800w.webp","pw":800,"ph":1071},{"id":"x39","type":"image","x":882,"y":1908,"w":316,"h":423,"label":"louvre_option_pale_limes","tid":"m03","z":70,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m03-louvre-option-pale-limestone-b2566c-800w.webp","pw":800,"ph":1071},{"id":"x40","type":"image","x":1224,"y":1896,"w":316,"h":176,"label":"local_sandstone_podium_a","tid":"m04","z":71,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m04-local-sandstone-podium-and-walls-34452a-800w.webp","pw":800,"ph":447},{"id":"x41","type":"image","x":540,"y":2349,"w":316,"h":211,"label":"residence_palette_from_r","tid":"m07","z":72,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m07-residence-palette-from-reference-371621-800w.webp","pw":800,"ph":534},{"id":"x42","type":"image","x":882,"y":2357,"w":316,"h":211,"label":"island_countertop_and_re","tid":"m08","z":73,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m08-island-countertop-and-render-polish-c79356-800w.webp","pw":800,"ph":534},{"id":"b10","type":"tool","x":1764,"y":2139,"name":"Lobby","kind":"Image","model":"Nano Banana 2","icon":"Sofa","count":6,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i01-lobby-white-model-d9fd93-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i02-lobby-v1-geometry-materials-ef49f9-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i03-lobby-v2-artwork-sconces-7284ac-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i04-markup-longer-desk-260c81-800w.webp"],"z":74},{"id":"n101","type":"note","x":1764,"y":2335,"w":184,"h":184,"tint":"amethyst","text":"Desk needs to be twice as long. Marked it up.","author":"KB","z":75},{"id":"x43","type":"image","x":2060,"y":2139,"w":316,"h":178,"label":"lobby_white_model","tid":"i01","z":76,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i01-lobby-white-model-d9fd93-800w.webp","pw":800,"ph":450},{"id":"x44","type":"image","x":2402,"y":2147,"w":316,"h":236,"label":"lobby_v1_geometry_materi","tid":"i02","z":77,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i02-lobby-v1-geometry-materials-ef49f9-800w.webp","pw":800,"ph":597},{"id":"x45","type":"image","x":2744,"y":2135,"w":316,"h":236,"label":"lobby_v2_artwork_sconces","tid":"i03","z":78,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i03-lobby-v2-artwork-sconces-7284ac-800w.webp","pw":800,"ph":597},{"id":"x46","type":"image","x":2060,"y":2401,"w":316,"h":236,"label":"markup_longer_desk","tid":"i04","z":79,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i04-markup-longer-desk-260c81-800w.webp","pw":800,"ph":597},{"id":"x47","type":"image","x":2402,"y":2409,"w":316,"h":236,"label":"lobby_v3_stone_desk_plac","tid":"i05","z":80,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i05-lobby-v3-stone-desk-placed-c250ca-800w.webp","pw":800,"ph":597},{"id":"x48","type":"image","x":2744,"y":2397,"w":316,"h":236,"label":"lobby_v4_competition_bri","tid":"i06","fav":true,"z":81,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i06-lobby-v4-competition-brightening-34918a-800w.webp","pw":800,"ph":597},{"id":"b11","type":"tool","x":3284,"y":1480,"name":"Sky lounge","kind":"Image","model":"Nano Banana 2","icon":"Sofa","count":5,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i07-sky-lounge-engine-export-f60a11-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i08-sky-lounge-engine-to-photo-a7f5c1-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i09-sky-lounge-staged-from-reference-8b3de4-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i10-sky-lounge-borrow-evening-light-667177-800w.webp"],"z":82},{"id":"x49","type":"image","x":3580,"y":1480,"w":316,"h":178,"label":"sky_lounge_engine_export","tid":"i07","z":83,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i07-sky-lounge-engine-export-f60a11-800w.webp","pw":800,"ph":450},{"id":"x50","type":"image","x":3922,"y":1488,"w":316,"h":178,"label":"sky_lounge_engine_to_pho","tid":"i08","z":84,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i08-sky-lounge-engine-to-photo-a7f5c1-800w.webp","pw":800,"ph":450},{"id":"x51","type":"image","x":4264,"y":1476,"w":316,"h":176,"label":"sky_lounge_staged_from_r","tid":"i09","z":85,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i09-sky-lounge-staged-from-reference-8b3de4-800w.webp","pw":800,"ph":447},{"id":"x52","type":"image","x":3580,"y":1684,"w":316,"h":176,"label":"sky_lounge_borrow_evenin","tid":"i10","z":86,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i10-sky-lounge-borrow-evening-light-667177-800w.webp","pw":800,"ph":447},{"id":"x53","type":"image","x":3922,"y":1692,"w":316,"h":176,"label":"sky_lounge_evening_gathe","tid":"i11","fav":true,"z":87,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i11-sky-lounge-evening-gathering-b786e8-800w.webp","pw":800,"ph":447},{"id":"b12","type":"tool","x":4804,"y":2564,"name":"Camera set","kind":"Image","model":"Nano Banana 2","icon":"Building2","count":5,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e16-raise-camera-reveal-the-gardens-4fe978-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e17-top-down-drone-over-the-crown-87d397-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e19-cutaway-axonometric-22df20-800w.webp"],"z":88},{"id":"x54","type":"image","x":5100,"y":2564,"w":316,"h":176,"label":"raise_camera_reveal_the_","tid":"e16","z":89,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e16-raise-camera-reveal-the-gardens-4fe978-800w.webp","pw":800,"ph":447},{"id":"x55","type":"image","x":5442,"y":2572,"w":316,"h":316,"label":"top_down_drone_over_the_","tid":"e17","z":90,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e17-top-down-drone-over-the-crown-87d397-800w.webp","pw":800,"ph":800},{"id":"x56","type":"image","x":5784,"y":2560,"w":316,"h":423,"label":"terrace_edge_detail_with","tid":"e18","z":91,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","pw":800,"ph":1071},{"id":"x57","type":"image","x":5100,"y":3013,"w":316,"h":421,"label":"cutaway_axonometric","tid":"e19","z":92,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e19-cutaway-axonometric-22df20-800w.webp","pw":800,"ph":1067},{"id":"x58","type":"image","x":5442,"y":3021,"w":316,"h":176,"label":"lunchtime_people_in_the_","tid":"e20","z":93,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e20-lunchtime-people-in-the-gardens-280901-800w.webp","pw":800,"ph":447},{"id":"b13","type":"tool","x":244,"y":2822,"name":"Corner residence","kind":"Image","model":"Nano Banana 2","icon":"Sofa","count":4,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i12-corner-residence-sketch-400d0d-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i14-residence-curated-styling-f59e05-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i15-residence-winter-view-2b49f6-800w.webp"],"z":94},{"id":"x59","type":"image","x":540,"y":2822,"w":316,"h":211,"label":"corner_residence_sketch","tid":"i12","z":95,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i12-corner-residence-sketch-400d0d-800w.webp","pw":800,"ph":533},{"id":"x60","type":"image","x":882,"y":2830,"w":316,"h":211,"label":"residence_sketch_to_rend","tid":"i13","z":96,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","pw":800,"ph":534},{"id":"x61","type":"image","x":1224,"y":2818,"w":316,"h":211,"label":"residence_curated_stylin","tid":"i14","z":97,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i14-residence-curated-styling-f59e05-800w.webp","pw":800,"ph":534},{"id":"x62","type":"image","x":540,"y":3059,"w":316,"h":211,"label":"residence_winter_view","tid":"i15","z":98,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i15-residence-winter-view-2b49f6-800w.webp","pw":800,"ph":534},{"id":"b14","type":"tool","x":1764,"y":2899,"name":"Seasons & light","kind":"Image","model":"Nano Banana 2","icon":"Sun","count":8,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t02-summer-monsoon-afternoon-8923fc-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t07-alpenglow-dusk-1d0baa-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t01-spring-noon-3be8a4-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t03-autumn-golden-hour-3768d6-800w.webp"],"z":99},{"id":"n141","type":"note","x":1764,"y":3095,"w":184,"h":184,"tint":"vista","text":"Winter set is for the ski-season brochure.","author":"MT","z":100},{"id":"x63","type":"image","x":2060,"y":2899,"w":316,"h":423,"label":"summer_monsoon_afternoon","tid":"t02","z":101,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t02-summer-monsoon-afternoon-8923fc-800w.webp","pw":800,"ph":1071},{"id":"x64","type":"image","x":2402,"y":2907,"w":316,"h":423,"label":"alpenglow_dusk","tid":"t07","fav":true,"z":102,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t07-alpenglow-dusk-1d0baa-800w.webp","pw":800,"ph":1071},{"id":"x65","type":"image","x":2744,"y":2895,"w":316,"h":423,"label":"spring_noon","tid":"t01","z":103,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t01-spring-noon-3be8a4-800w.webp","pw":800,"ph":1071},{"id":"x66","type":"image","x":2060,"y":3348,"w":316,"h":423,"label":"autumn_golden_hour","tid":"t03","z":104,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t03-autumn-golden-hour-3768d6-800w.webp","pw":800,"ph":1071},{"id":"x67","type":"image","x":2402,"y":3356,"w":316,"h":423,"label":"winter_inversion_haze","tid":"t05","z":105,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t05-winter-inversion-haze-c734b0-800w.webp","pw":800,"ph":1071},{"id":"x68","type":"image","x":2744,"y":3344,"w":316,"h":423,"label":"winter_blue_hour","tid":"t04","fav":true,"z":106,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t04-winter-blue-hour-50f063-800w.webp","pw":800,"ph":1071},{"id":"x69","type":"image","x":2060,"y":3797,"w":316,"h":423,"label":"night_facade_lighting","tid":"t06","z":107,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t06-night-facade-lighting-69ccb0-800w.webp","pw":800,"ph":1071},{"id":"x70","type":"image","x":2402,"y":3805,"w":316,"h":423,"label":"soft_glow_behind_glazing","tid":"t08","z":108,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t08-soft-glow-behind-glazing-6fc036-800w.webp","pw":800,"ph":1071},{"id":"b15","type":"tool","x":3284,"y":2122,"name":"Masterplan views","kind":"Image","model":"Nano Banana Pro","icon":"Map","count":4,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s06-masterplan-aerial-55b63e-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s09-masterplan-twilight-glow-1694c9-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s07-markup-eye-level-camera-spot-e6cfa2-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s08-eye-level-view-from-site-markup-96d820-800w.webp"],"z":109},{"id":"x71","type":"image","x":3580,"y":2122,"w":316,"h":176,"label":"masterplan_aerial","tid":"s06","fav":true,"z":110,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s06-masterplan-aerial-55b63e-800w.webp","pw":800,"ph":447},{"id":"x72","type":"image","x":3922,"y":2130,"w":316,"h":176,"label":"masterplan_twilight_glow","tid":"s09","z":111,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s09-masterplan-twilight-glow-1694c9-800w.webp","pw":800,"ph":447},{"id":"x73","type":"image","x":4264,"y":2118,"w":316,"h":176,"label":"markup_eye_level_camera_","tid":"s07","z":112,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s07-markup-eye-level-camera-spot-e6cfa2-800w.webp","pw":800,"ph":447},{"id":"x74","type":"image","x":3580,"y":2324,"w":316,"h":176,"label":"eye_level_view_from_site","tid":"s08","z":113,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s08-eye-level-view-from-site-markup-96d820-800w.webp","pw":800,"ph":447},{"id":"b16","type":"tool","x":4804,"y":3696,"name":"Motion","kind":"Video","model":"Kling 2.6 Pro","icon":"Video","count":8,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v01-white-card-model-orbit-b46495aa-poster-400w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-poster-400w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v05-detail-to-tower-pull-out-reveal-024b9c3f-poster-400w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-poster-400w.webp"],"z":114},{"id":"x75","type":"image","x":5100,"y":3696,"w":316,"h":423,"label":"white_card_model_orbit","tid":"v01","video":true,"dur":"0:05","kind":"video","z":115,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v01-white-card-model-orbit-b46495aa-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v01-white-card-model-orbit-b46495aa-optimized.mp4"},{"id":"x76","type":"image","x":5442,"y":3704,"w":316,"h":178,"label":"creek_walk_evening_strol","tid":"v07","video":true,"dur":"0:10","kind":"video","z":116,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-optimized.mp4"},{"id":"x77","type":"image","x":5784,"y":3692,"w":316,"h":423,"label":"detail_to_tower_pull_out","tid":"v05","video":true,"dur":"0:05","kind":"video","z":117,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v05-detail-to-tower-pull-out-reveal-024b9c3f-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v05-detail-to-tower-pull-out-reveal-024b9c3f-optimized.mp4"},{"id":"x78","type":"image","x":5100,"y":4145,"w":316,"h":423,"label":"hero_dolly_in","tid":"v02","video":true,"dur":"0:05","kind":"video","z":118,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-optimized.mp4"},{"id":"x79","type":"image","x":5442,"y":4153,"w":316,"h":178,"label":"sky_lounge_sunset_time_l","tid":"v06","video":true,"dur":"0:08","kind":"video","z":119,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v06-sky-lounge-sunset-time-lapse-a0a91aee-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v06-sky-lounge-sunset-time-lapse-a0a91aee-optimized.mp4"},{"id":"x80","type":"image","x":5784,"y":4141,"w":316,"h":177,"label":"bring_the_gardens_to_lif","tid":"v04","video":true,"dur":"0:05","kind":"video","z":120,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v04-bring-the-gardens-to-life-1cb39008-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v04-bring-the-gardens-to-life-1cb39008-optimized.mp4"},{"id":"x81","type":"image","x":5100,"y":4594,"w":316,"h":178,"label":"aerial_day_to_night_time","tid":"v03","video":true,"dur":"0:08","kind":"video","z":121,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v03-aerial-day-to-night-time-lapse-744df3b5-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v03-aerial-day-to-night-time-lapse-744df3b5-optimized.mp4"},{"id":"x82","type":"image","x":5442,"y":4602,"w":316,"h":423,"label":"white_card_to_photo_tran","tid":"v08","video":true,"dur":"0:05","kind":"video","z":122,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v08-white-card-to-photo-transition-ad34593f-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v08-white-card-to-photo-transition-ad34593f-optimized.mp4"},{"id":"b17","type":"tool","x":244,"y":3532,"name":"Print upscales","kind":"Image","model":"Nano Banana Pro","icon":"Building2","count":1,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp"],"z":123},{"id":"x83","type":"image","x":540,"y":3532,"w":316,"h":423,"label":"hero_final_editorial_upg","tid":"e22","fav":true,"z":124,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp","pw":800,"ph":1071},{"id":"lg1","type":"note","x":204,"y":-132,"w":184,"h":184,"tint":"amethyst","text":"1 - CANVAS\\n\\n- Tools\\n- Generations\\n- Organization","author":"You","z":125},{"id":"lga1","type":"shape","shape":"arrow","x":425,"y":-41,"w":38,"h":0,"sc":[0,0],"stroke":"#ffffff","sw":7,"z":126},{"id":"lg2","type":"note","x":499,"y":-132,"w":184,"h":184,"tint":"vista","text":"2 - PROMPT LIBRARY","author":"You","z":127},{"id":"lga2","type":"shape","shape":"arrow","x":717,"y":-41,"w":36,"h":0,"sc":[0,0],"stroke":"#ffffff","sw":7,"z":128},{"id":"lg3","type":"note","x":796,"y":-131,"w":184,"h":212,"tint":"glass","text":"3 - INTEGRATIONS\\n\\n- Revit\\n- Photoshop\\n- Rhino\\n- Sketchup\\n- Miro","author":"You","z":129},{"id":"lga3","type":"shape","shape":"arrow","x":1022,"y":-40,"w":33,"h":0,"sc":[0,0],"stroke":"#ffffff","sw":7,"z":130},{"id":"lg4","type":"note","x":1101,"y":-131,"w":184,"h":212,"tint":"amethyst","text":"4 - CHAT\\n\\n- Tutorials/Questions\\n- Prompts\\n- Generations\\n- Workflows","author":"You","z":131}]'), IH = /* @__PURE__ */ JSON.parse(`[{"id":"bm1","name":"Existing site aerial","model":"Nano Banana Pro","prompt":"Create a realistic oblique aerial drone photograph of Depot Yards, a 4-acre former rail yard block at the west edge of downtown Salt Lake City, Utah, with a restored red-brick freight depot, rusted rail spurs and a buried creek channel crossing the block diagonally, looking east. The block is empty: gravel lots, rail spurs, the restored brick depot with a gabled roof in the lower left, and a dry, overgrown creek channel cutting diagonally across it. Surround it with low brick warehouses, a light rail line along the north edge and mid-rise downtown buildings beyond, with the snow-capped Wasatch Range rising to the east behind. Use a clear spring morning with long soft shadows and crisp, dry high-desert light under a deep blue sky. Retain the utilitarian character of a real site photograph, with no diagram overlays, labels or proposed buildings.","author":"KB","at":"2026-09-01","board":"Site photos","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","inputs":[]},{"id":"bm2","name":"Existing site plan","model":"ChatGPT Image 2","prompt":"Create a clean top-down architectural site plan drawing of Depot Yards, a 4-acre former rail yard block at the west edge of downtown Salt Lake City, Utah, with a restored red-brick freight depot, rusted rail spurs and a buried creek channel crossing the block diagonally as it exists today. Show the city block outline and surrounding streets, the brick depot footprint in the lower left, rail spurs, the buried creek alignment as a dashed line crossing the block diagonally, the light rail line along the top edge and adjacent warehouse footprints. Use thin black linework on white, light grey hatching for existing buildings, a north arrow, a scale bar and small neat labels: 'DEPOT YARDS', 'FREIGHT DEPOT', 'CREEK (CULVERTED)', 'LIGHT RAIL', '400 WEST'. No colour, no rendering and no proposed buildings.","author":"MT","at":"2026-09-02","board":"Site plans & analysis","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s04-existing-site-plan-ee31f8-800w.webp","inputs":[]},{"id":"bm3","name":"Masterplan aerial","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the existing Depot Yards site aerial and is the primary scene to edit. Image 2 is the Bench Gardens landscape masterplan, supplied only for the specific reference role described below. Image 3 is the Bonneville Tower design render, supplied only for the specific reference role described below.\\n\\nRender the proposed project into the aerial in Image 1. Use Image 2 for the site layout: the daylighted creek, curved limestone terraces, cottonwood grove, water-mirror plaza, depot plaza and paths. Use Image 3 for the tower's design, placing it in the northeast corner of the block with its four planted setbacks, terracotta bands, open crown and brick podium. Keep the surrounding city, the brick depot, the light rail line, the mountains, the camera and the morning light unchanged. Make the new landscape and tower read as built and mature, at correct scale.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-12","board":"Masterplan views","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s06-masterplan-aerial-55b63e-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm4","name":"Eye-level view from site markup","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the annotated masterplan aerial with a camera position and view arrow and is the primary scene to edit. Image 2 is the Bonneville Tower design render, supplied only for the specific reference role described below.\\n\\nFollow and remove the annotations marked on the image; create an eye-level view at the red dot looking along the arrow toward the tower. Show the daylighted creek and curved limestone terraces in the foreground, the cottonwood grove and the tower from Image 2 rising behind, with the snow-capped Wasatch Range rising to the east beyond. This is a reimagining of the site as built. Photo reference: documentary-style architectural photography in late-afternoon spring light.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-13","board":"Masterplan views","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s08-eye-level-view-from-site-markup-96d820-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s07-markup-eye-level-camera-spot-e6cfa2-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm5","name":"Option B sketch: Canyon","model":"Nano Banana 2","prompt":"Create an architectural concept marker sketch on white trace paper of a 52-storey skyscraper split top to bottom by a narrow slot-canyon void, its two halves clad in curved vertical fins. Render it in warm red-rock and ochre marker tones with black fineliner linework. Use a street-level perspective with loose people silhouettes at the base and a mountain range hinted behind in grey marker. A designer's quick ideation sketch with energetic line weight and white paper showing through.","author":"MT","at":"2026-09-02","board":"Massing sketches","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e02-option-b-sketch-canyon-374663-800w.webp","inputs":[]},{"id":"bm6","name":"White card options A / B / C","model":"Seedream 5 Lite","prompt":"Create a photograph of an architecture studio's white card massing models on a large worktable: three alternative skyscraper options side by side on one shared site base, each about 60 cm tall and built from white foam board and basswood. Option A is a slender tower tapering through four stepped setbacks with horizontal banding. Option B is a tower split top to bottom by a narrow vertical slot with vertical fin ribs. Option C is a faceted crystalline tower with folded facets and a sharp crown. The site base shows a city block with a diagonal creek channel cut into it, small white context buildings and one tiny brick-red depot building. Small folded paper tags in front read 'A', 'B' and 'C'. Soft overhead studio daylight, shallow depth of field, with a cutting mat and rolls of trace paper at the edge of the frame.","author":"JR","at":"2026-09-03","board":"White card models","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e04-white-card-options-a-b-c-1713cd-800w.webp","inputs":[]},{"id":"bm7","name":"Hero v1: model to photo","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the white card model of Bonneville Tower and is the primary scene to edit. Image 2 is the existing Depot Yards street photograph, supplied only for the specific reference role described below.\\n\\nRender Image 1 as the completed Bonneville Tower in Salt Lake City. Use Image 2 only for site context, photographic atmosphere and material realism, not its building geometry. Preserve the model's silhouette, four stepped setbacks and undulating horizontal bands. Clad the bands in warm sandstone-coloured terracotta louvres alternating with low-iron glass, with bronze soffits and native trees and grasses on every setback terrace. Show the tower rising beyond the restored brick depot, with a light rail line and a few pedestrians in the foreground and the snow-capped Wasatch Range rising to the east behind. Late-afternoon spring light, crisp, dry high-desert light under a deep blue sky. Keep the camera level with corrected verticals, a restrained 24 mm architectural lens character and deep focus.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-05","board":"Hero options","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e09-hero-v1-model-to-photo-0725c1-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e05-option-a-white-card-model-c61989-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s02-existing-depot-street-7c94e0-800w.webp"]},{"id":"bm8","name":"Hero v4: brick podium","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the Bonneville Tower render with deepened terraces and is the primary scene to edit. Image 2 is the tight brick facade rhythm reference, supplied only for the specific reference role described below.\\n\\nApply the tight vertical pier rhythm from Image 2 only to the five-storey podium at the base of the tower in Image 1: close-spaced warm brick piers with deep-set glazing that relate the podium to the neighbouring brick freight depot. Keep the tower above the podium, its setbacks, crown, terracotta bands, street, light and camera unchanged. Use Image 2 only for facade rhythm and brick character, not its building form. Keep the full tower in frame from the street to the top of the open crown, with the same portrait composition as Image 1.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-09","board":"Facade iterations","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e12-hero-v3-deeper-terraces-1c4ede-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r117-tight-facade-rhythm-reference-a4ddff-800w.webp"]},{"id":"bm9","name":"Hero final: editorial upgrade","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit. Image 2 is the residential tower comparison photograph, supplied only for the specific reference role described below.\\n\\nUpgrade Image 1 to an editorial architectural photograph, using Image 2 only as a realism reference. Preserve the tower design, setback terraces, crown, podium rhythm, street context and camera. Use warm late-afternoon sunlight, soft shadows, a subtle deep-blue sky gradient and the snow-capped Wasatch Range crisp behind. Refine glass reflections, terracotta material response and planting with balanced colour and controlled contrast. Keep the building crisp, without exaggerated sharpening or artificial saturation.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-13","board":"Print upscales","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r143-residential-tower-comparison-reference-620572-800w.webp"]},{"id":"bm10","name":"Terrace edge detail with bokeh","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nCreate a close-up detail photograph of one setback terrace edge: warm sandstone terracotta louvres, a bronze soffit, a low-iron glass guardrail and native grasses spilling over the planter lip, with the upper tower bands blurred into soft bokeh behind. Keep the materials, colours and afternoon light consistent with Image 1. Shallow depth of field with an 85 mm lens character.\\n\\nResolve the requested composition into one coherent image with appropriate scale, clear spatial relationships and consistent light. Include no unrelated annotations, labels or extra panels unless the brief explicitly calls for them.","author":"KB","at":"2026-09-10","board":"Camera set","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm11","name":"Watercolor masterplan","model":"ChatGPT Image 2","prompt":"Create one finished architectural image. Image 1 is the rendered landscape masterplan and is the primary scene to edit.\\n\\nMake this plan a clean architectural watercolor sketch: loose ink linework, soft transparent washes for the planting and water, white paper left for the paths, and the existing labels kept neat and legible.\\n\\nResolve the requested composition into one coherent image with appropriate scale, clear spatial relationships and consistent light. Include no unrelated annotations, labels or extra panels unless the brief explicitly calls for them.","author":"MT","at":"2026-09-05","board":"Bench Gardens","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l01-rendered-landscape-masterplan-0b3979-800w.webp"]},{"id":"bm12","name":"Creek walk marketing hero","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the Bench Gardens creek walk engine render and is the primary scene to edit. Image 2 is the Bonneville Tower design render, supplied only for the specific reference role described below.\\n\\nStrengthen this engine render into a marketing hero image: photorealistic limestone, clear rippling creek water, lush native grasses, sagebrush and flowering purple penstemon, mature cottonwoods, and natural people walking and sitting on the benches. Replace the placeholder striped tower at the right edge of the frame with the tower from Image 2 (its brick podium, warm terracotta bands and planted setback terraces) at the same position and scale, using Image 2 only for the tower's design. Late-afternoon spring light, crisp, dry high-desert light under a deep blue sky, with the snow-capped Wasatch Range rising to the east glimpsed beyond. Top-tier architectural visualization quality with verticals corrected.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-09","board":"Bench Gardens","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l04-creek-walk-marketing-hero-92d17d-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l03-creek-walk-engine-export-d0559e-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm13","name":"Daytime gardens with people","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the Bench Gardens creek walk render and is the primary scene to edit. Image 2 is the pavilion terrace people and placement reference, supplied only for the specific reference role described below.\\n\\nRender Image 1 in bright daytime and add people inspired by the placement and activity in Image 2: small groups sitting on the new benches, a couple leaning on the boardwalk rail and people strolling the path, all at correct scale. Use Image 2 only for people and placement. Keep the architecture, landscape, boardwalk and camera unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-12","board":"Bench Gardens","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l08-daytime-gardens-with-people-8fb7f2-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l07-benches-and-overlook-added-ca8f6c-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r123-pavilion-terrace-people-reference-crop-a239be-800w.webp"]},{"id":"bm14","name":"Louvre option: pale limestone","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the terrace-edge louvre detail photograph and is the primary scene to edit. Image 2 is the material sample board, supplied only for the specific reference role described below.\\n\\nReplace only the sandstone terracotta louvre finish in Image 1 with the pale limestone glazed terracotta sample from Image 2. Follow every louvre edge and profile with consistent glaze and realistic joints, and preserve the louvre geometry exactly. Keep the bronze soffit, glass guardrail, planting, bokeh background, camera and lighting unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-11","board":"Material studies","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m03-louvre-option-pale-limestone-b2566c-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp"]},{"id":"bm15","name":"Residence palette from reference","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the corner residence living room render and is the primary scene to edit. Image 2 is the amber and rose lounge atmosphere reference, supplied only for the specific reference role described below.\\n\\nTransfer the warm amber-and-rose material palette and moody lighting of Image 2 onto the residence in Image 1: warm walnut millwork, rust and rose upholstery, bronze accents and soft amber lamp light. Use Image 2 only for palette and lighting, not its layout. Keep the room geometry, windows, mountain view, furniture layout and camera unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-12","board":"Material studies","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m07-residence-palette-from-reference-371621-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r044-amber-and-rose-lounge-atmosphere-396273-800w.webp"]},{"id":"bm16","name":"Lobby v1: geometry + materials","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the white clay model of the lobby geometry and is the primary scene to edit. Image 2 is the material sample board, supplied only for the specific reference role described below.\\n\\nRender Image 1 as a finished photorealistic lobby while keeping its geometry, openings and camera exactly. Use Image 2 only for materials: the rammed-earth sample for the long curved feature wall, with horizontal strata like ancient shorelines; warm sandstone terracotta for the fin walls; red-rock terrazzo for the floor; walnut for the reception desk; and bronze trim. Warm afternoon light through the window wall onto the garden, with a few natural people.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-09","board":"Lobby","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i02-lobby-v1-geometry-materials-ef49f9-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i01-lobby-white-model-d9fd93-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp"]},{"id":"bm17","name":"Lobby v4: competition brightening","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the lobby photograph and is the primary scene to edit.\\n\\nBrighten this lobby for a competition board: lift the interior exposure, add soft daylight bouncing off the floor, keep the sconces and artwork warm, and make the colours clean and inviting without losing material detail. Keep everything else unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-11","board":"Lobby","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i06-lobby-v4-competition-brightening-34918a-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i05-lobby-v3-stone-desk-placed-c250ca-800w.webp"]},{"id":"bm18","name":"Sky lounge: evening gathering","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the evening sky lounge photograph and is the primary scene to edit. Image 2 is the casual evening gathering people reference, supplied only for the specific reference role described below.\\n\\nStage a lively evening gathering in Image 1, with people inspired by the mix, clothing and activity in Image 2: small groups talking with drinks, people seated in the lounge chairs and someone photographing the view. Use Image 2 only for people. Keep the architecture, furniture, lighting and camera unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-12","board":"Sky lounge","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i11-sky-lounge-evening-gathering-b786e8-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i10-sky-lounge-borrow-evening-light-667177-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r095-casual-workplace-evening-gathering-0bce32-800w.webp"]},{"id":"bm19","name":"Residence: sketch to render","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the fine-pen corner residence sketch and is the primary scene to edit.\\n\\nPlease transform this sketch into a hyper realistic render. Recognize the different textures from the sketch and translate them into warm walnut, pale limestone floors, linen upholstery and bronze fixtures. Maintain the point of view. Show the snow-capped Wasatch Range through the corner windows in afternoon light.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-11","board":"Corner residence","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i12-corner-residence-sketch-400d0d-800w.webp"]},{"id":"bm20","name":"Winter blue hour","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nKeep image exactly how it is. Only change the season and time to a deep winter blue hour: fresh snow on the terraces, street and depot roof, light snow falling, the mountains fully white and warm glowing windows.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-12","board":"Seasons & light","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t04-winter-blue-hour-50f063-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm21","name":"Alpenglow dusk","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nReveal the full horizon behind the tower: show the whole Wasatch Range glowing pink and orange with alpenglow just after sunset, under a clear peach-to-deep-blue sky. Keep the tower, street context and camera exactly the same.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-11","board":"Seasons & light","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t07-alpenglow-dusk-1d0baa-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm22","name":"Autumn golden hour","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nSet the scene at golden hour in early October, with the building's interior lights glowing warmly and spilling outward into the fading light. The foothills behind are red and orange with autumn scrub oak, and the terrace trees have turned gold. You can't see the sun.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-12","board":"Seasons & light","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t03-autumn-golden-hour-3768d6-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm23","name":"Hero dolly-in","model":"Kling 2.6 Pro","prompt":"Do a gentle, smooth cinematic dolly forward toward the tower, as if the viewer is slowly walking up the street. Keep the architecture perfectly stable and verticals straight, with subtle natural motion in the trees and a few pedestrians.","author":"KB","at":"2026-09-14","board":"Motion","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-poster-400w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp"]},{"id":"bm24","name":"Creek walk evening stroll","model":"LTX 2.3","prompt":"People stroll along the creek path and sit on the benches as the evening light warms. Slight, slow camera push in. The water ripples and the grasses sway. The architecture and landscape remain stable.","author":"MT","at":"2026-09-14","board":"Motion","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-poster-400w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l07-benches-and-overlook-added-ca8f6c-800w.webp"]},{"id":"sm1","name":"Ink + wet watercolour board","model":"Seedream 5 Lite","prompt":"Create one finished architectural image. Image 1 is the timber riverside pavilion at sunset and is the primary scene to edit. Image 2 is the watercolor stepped public courtyard, supplied only for the specific reference role described below. Image 3 is the watercolor stone and glass entrance, supplied only for the specific reference role described below. Image 4 is the forest cabin pencil and wash study, supplied only for the specific reference role described below. Image 5 is the watercolor glass pavilion and pool, supplied only for the specific reference role described below. Image 6 is the sepia civic pavilion beside water, supplied only for the specific reference role described below. Image 7 is the glass pavilion landscape watercolor, supplied only for the specific reference role described below. Image 8 is the raw timber building concept sketch, supplied only for the specific reference role described below. Image 9 is the red urban building watercolor, supplied only for the specific reference role described below. Image 10 is the orange modular building sketch, supplied only for the specific reference role described below. Image 11 is the slender red tower concept sketch, supplied only for the specific reference role described below. Image 12 is the three sculptural facade studies, supplied only for the specific reference role described below. Image 13 is the three colorful massing studies, supplied only for the specific reference role described below.\\n\\nRestyle Image 1 as a single architectural illustration. Use Images 2 through 13 solely as references for ink and watercolor technique; do not combine their buildings or make a collage. Draw structural edges in medium black ink with loose wet-in-wet washes, soft bleeds, pigment blooms and light paper grain. Use transparent blues, warm ochres and greens, darker pooled shadows and untouched white highlights. Simplify the existing people into loose silhouettes while preserving the pavilion, river landscape and composition from Image 1.\\n\\nPreserve the source design and spatial relationships except for the requested transformation. Keep linework, color and surface treatment consistent with the specified illustration style. Include no unrelated labels or graphic marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f015-ink-and-wet-watercolor-8fee6e-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r016-timber-riverside-pavilion-at-sunset-fa0780-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r017-watercolor-stepped-public-courtyard-7fc530-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r018-watercolor-stone-and-glass-entrance-09e1b4-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r019-forest-cabin-pencil-and-wash-study-aee0f0-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r020-watercolor-glass-pavilion-and-pool-9ae5e5-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r021-sepia-civic-pavilion-beside-water-118403-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r022-glass-pavilion-landscape-watercolor-ec8063-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r023-raw-timber-building-concept-sketch-863af3-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r024-red-urban-building-watercolor-225c95-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r025-orange-modular-building-sketch-88edb7-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r026-slender-red-tower-concept-sketch-4ccc34-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r027-three-sculptural-facade-studies-e88423-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r028-three-colorful-massing-studies-f239ea-original.webp"]},{"id":"sm2","name":"White model → render","model":"GPT Image 1.5","prompt":"Create one finished architectural image. Image 1 is the white office model interior and is the primary scene to edit. Image 2 is the warm workplace interior mood board, supplied only for the specific reference role described below. Image 3 is the office materials and furniture board, supplied only for the specific reference role described below. Image 4 is the sunlit industrial office lounge, supplied only for the specific reference role described below.\\n\\nRender the white office model in Image 1 with the warm workplace palette and furnishings suggested by Images 2 and 3. Use Image 4 for the rhythm of the exposed ceiling structure, translated into smooth warm concrete as the specified finish. Preserve the office layout, workstation positions, window arrangement and camera. Produce a coherent photorealistic workplace with credible material scale, daylight and contact shadows.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f009-white-model-look-transfer-820fb4-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r005-white-office-model-interior-ace253-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r006-warm-workplace-interior-mood-board-1dc35d-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r007-office-materials-and-furniture-board-95471b-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r008-sunlit-industrial-office-lounge-59d45b-original.webp"]},{"id":"sm3","name":"Magazine-grade upgrade","model":"ChatGPT Image 2","prompt":"Create one finished architectural image. Image 1 is the residential tower street render and is the primary scene to edit. Image 2 is the residential tower comparison reference, supplied only for the specific reference role described below.\\n\\nUpgrade Image 1 to an editorial architectural photograph, using Image 2 only as a realism reference. Preserve the tower design, facade proportions, balcony rhythm, street context and camera. Use warm natural sunlight, soft shadows, a subtle sky gradient and mild atmospheric depth. Refine glass reflections, material response and planting with balanced color and controlled contrast. Keep the building crisp without exaggerated sharpening or artificial saturation.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f093-magazine-grade-photoreal-upgrade-bd0a54-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r142-residential-tower-street-render-359681-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r143-residential-tower-comparison-reference-29add0-original.webp"]},{"id":"sm4","name":"Colour-coded markup edits","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the new annotated color-coded multi-markup edits and is the primary scene to edit.\\n\\nReplace the surface within the red outline with a perforated metal panel system fitted to the existing stair-tower facade. Turn the ground-level bay within the white outline into a vehicle exit with a proportionate exit barrier arm. Preserve the garage structure, other openings, street, people, trees and camera. Remove the red and white annotations from the completed scene.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f087-color-coded-multi-markup-edits-76f768-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/a087-color-coded-multi-markup-edits-annotation-4043aa-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r131-urban-parking-garage-street-approach-fabe37-original.webp"]},{"id":"sm5","name":"Remove the CGI look","model":"GPT Image 1.5","prompt":"Create one finished architectural image. Image 1 is the neutral stone elevator lobby render and is the primary scene to edit.\\n\\nRefine the lighting in the render view - True-to-life color grading, architectural digest style. No cgi look, no over-sharpening, no artificial symmetry perfection. 4000k lighting. Keep everything else the same.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f094-remove-the-cgi-look-532569-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r144-neutral-stone-elevator-lobby-render-a2ae6f-original.webp"]},{"id":"sm6","name":"Raise camera, reveal plaza","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the residential courtyard street elevation and is the primary scene to edit.\\n\\nRaise the camera upward and look slightly down so more of the central plaza and foreground public space become visible.\\n\\nResolve the requested composition into one coherent image with appropriate scale, clear spatial relationships and consistent light. Include no unrelated annotations, labels or extra panels unless the brief explicitly calls for them.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f072-raise-camera-reveal-the-plaza-7d8009-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r102-residential-courtyard-street-elevation-fe3a75-original.webp"]}]`), AH = [{ id: "image", name: "Image", icon: "Image", desc: "Create images with AI-powered models", models: [{ name: "Nano Banana Pro", desc: "Best-in-class prompt adherence and editing", time: "50s", tokens: "240", g: 4 }, { name: "Nano Banana 2", desc: "Improved text, realism, and editing (Gemini 3.1)", time: "45s", tokens: "173", g: 8 }, { name: "ChatGPT Image 2", desc: "Prompt-perfect generation and surgical editing", time: "24s", tokens: "22–484", g: 10 }, { name: "GPT Image 1.5", desc: "Fast, faithful edits with strong text", time: "20s", tokens: "120", g: 1 }, { name: "Seedream 5 Lite", desc: "Bytedance’s fast, low-cost image model", time: "8s", tokens: "40", g: 2 }, { name: "Flux 2 Pro", desc: "FLUX 2 by Black Forest Labs", time: "15s", tokens: "70–700", g: 15 }] }, { id: "video", name: "Video", icon: "Video", desc: "Generate dynamic videos and animations", models: [{ name: "Kling 2.6 Pro", desc: "Expressive motion with strong camera control", time: "2m", tokens: "210", g: 6 }, { name: "LTX 2.3", desc: "Fast open video generation", time: "70s", tokens: "90", g: 12 }, { name: "Veo 3 Fast", desc: "Cinematic motion, quick turnaround", time: "90s", tokens: "260", g: 0 }, { name: "Hailuo 02", desc: "Strong physics and camera control", time: "2m", tokens: "210", g: 14 }] }, { id: "threed", name: "3D", icon: "Box", desc: "Generate 3D models from images or prompts", models: [{ name: "Hunyuan3D 2.1", desc: "Textured meshes from a single image", time: "2m", tokens: "240", g: 5 }, { name: "Trellis", desc: "Detailed geometry for hard-surface objects", time: "90s", tokens: "150", g: 9 }, { name: "Rodin Gen-2", desc: "Production-ready meshes with clean topology", time: "4m", tokens: "360", g: 3 }] }, { id: "upscale", name: "Upscale", icon: "Maximize2", desc: "Upscale your images and videos", models: [{ name: "Clarity Upscale", desc: "Crisp detail for print and large format", time: "30s", tokens: "40", g: 17 }, { name: "SUPIR", desc: "Restoration-grade photo upscaling", time: "50s", tokens: "55", g: 2 }, { name: "Topaz Video AI", desc: "Footage upscaling to 4k", time: "6m", tokens: "310", g: 10 }] }], Hr = {
  title: TH,
  project: MH,
  elements: CH,
  templates: IH,
  kits: AH
}, PH = { image: "image", video: "video", "3d": "threed", upscale: "upscale" };
function EH(n) {
  return PH[String(n || "").toLowerCase()] || "image";
}
function Mw(n, e) {
  return n.x >= e.x && n.y >= e.y && n.x < e.x + e.w && n.y < e.y + e.h;
}
function Rl() {
  const n = Hr.elements, e = n.map((d) => {
    const c = { id: d.id, x: d.x, y: d.y, z: d.z };
    switch (d.type) {
      case "frame":
        return { ...c, type: "frame", w: d.w, h: d.h, title: d.title };
      case "note":
        return { ...c, type: "note", w: d.w, h: d.h, text: d.text, tint: d.tint || "glass", author: d.author };
      case "shape":
        return { ...c, type: "shape", w: d.w, h: d.h, shape: d.shape, stroke: d.stroke, sw: d.sw, sc: d.sc || [0, 0] };
      case "tool":
        return {
          ...c,
          type: "tool",
          w: 252,
          h: 160,
          name: d.name,
          kind: d.kind,
          kitId: EH(d.kind),
          model: d.model,
          icon: d.icon || "Image",
          count: d.count || 0,
          thumbs: d.thumbs || [],
          up: {},
          lastRunAt: Date.UTC(2026, 8, 1 + d.z % 14, 15, d.z * 7 % 60)
        };
      default:
        return {
          ...c,
          type: "image",
          w: d.w,
          h: d.h,
          src: d.src,
          label: d.label,
          fav: !!d.fav || void 0,
          video: !!d.video || void 0,
          dur: d.dur,
          videoSrc: d.videoSrc
        };
    }
  }), t = e.filter((d) => d.type === "frame"), i = e.filter((d) => d.type === "tool"), s = Hr.templates, o = /* @__PURE__ */ new Map();
  for (const d of n) d.type === "image" && d.pw && d.ph && o.set(d.id, { pw: d.pw, ph: d.ph });
  const r = [], a = Date.UTC(2026, 8, 1, 14, 0);
  let l = 0;
  for (const d of e) {
    if (d.type !== "image") continue;
    const c = d, u = t.find((w) => Mw(qe(c), qe(w))), p = u ? i.find((w) => Mw(qe(w), qe(u))) : void 0;
    if (!p) continue;
    const f = s.find((w) => w.img === c.src) || s.find((w) => w.board === p.name), y = "r-" + c.id, b = o.get(c.id);
    c.resultId = y, c.sessionId = p.id, r.push({
      id: y,
      sessionId: p.id,
      status: "done",
      url: c.src,
      w: b ? b.pw : c.w,
      h: b ? b.ph : c.h,
      video: c.video,
      dur: c.dur,
      videoSrc: c.videoSrc,
      prompt: f ? f.prompt : "",
      model: f && f.model || p.model,
      author: f ? f.author : "KB",
      createdAt: a + l++ * 3.7 * 3600 * 1e3,
      label: c.label,
      fav: c.fav,
      refs: f ? f.inputs : [],
      parents: f ? f.inputs : []
    });
  }
  return { title: Hr.title, elements: e, results: r };
}
function RH(n) {
  const e = /* @__PURE__ */ new Set();
  for (const t of n) {
    const i = t.type === "image" ? t.resultId : void 0;
    i && i.startsWith("r-") && !i.includes(":") && e.add(i);
  }
  return e.size ? Rl().results.filter((t) => e.has(t.id)) : [];
}
function b8() {
  const n = /* @__PURE__ */ new Set();
  for (const e of Hr.elements) e.type === "image" && e.src && !e.video && n.add(e.src);
  return Array.from(n);
}
function zH() {
  return Hr.elements.filter((n) => n.type === "image" && n.video && n.videoSrc).map((n) => ({ poster: n.src, src: n.videoSrc }));
}
function $H() {
  return Hr.project.team || [];
}
const Cw = 600;
function v8(n, e) {
  const t = n.elements.filter((f) => f.type === "image").length, i = Math.max(1, Math.ceil(Math.max(1, e) / Math.max(1, t)));
  let s = 1 / 0, o = 1 / 0, r = -1 / 0, a = -1 / 0;
  for (const f of n.elements) {
    const y = qe(f);
    s = Math.min(s, y.x), o = Math.min(o, y.y), r = Math.max(r, y.x + y.w), a = Math.max(a, y.y + y.h);
  }
  const l = r - s, d = a - o, c = Math.max(1, Math.min(i, Math.round(Math.sqrt(i * 1.6 * d / l)))), u = Math.ceil(i / c), p = [];
  for (let f = 0; f < i; f++)
    p.push({ x: s + f % c * (l + Cw), y: o + Math.floor(f / c) * (d + Cw), w: l, h: d });
  return { perCopy: t, copies: i, cols: c, rows: u, tiles: p };
}
function Iw(n) {
  return v8(Rl(), n);
}
function DH(n) {
  const e = Rl(), t = v8(e, n), { copies: i, tiles: s } = t;
  let o = 0;
  for (const d of e.elements) o = Math.max(o, d.z + 1);
  const r = [], a = [];
  for (let d = 0; d < i; d++) {
    const c = d === 0 ? "" : "~" + d, u = s[d].x - s[0].x, p = s[d].y - s[0].y;
    for (const f of e.elements) {
      const y = JSON.parse(JSON.stringify(f));
      y.id = f.id + c, y.x = f.x + u, y.y = f.y + p, y.z = f.z + d * o, y.resultId && (y.resultId += c), y.sessionId && (y.sessionId += c), y.type === "frame" && i > 1 && (y.title = y.title + " · " + (d + 1)), r.push(y);
    }
    for (const f of e.results) {
      const y = JSON.parse(JSON.stringify(f));
      y.id = f.id + c, y.sessionId = f.sessionId + c, a.push(y);
    }
  }
  return { title: "Stress test: " + (t.perCopy * i).toLocaleString("en-US") + " images", elements: r, results: a, layout: t };
}
function OH(n, e) {
  const t = [], i = [], s = b8(), o = 24, r = 6, a = 316, l = 26, d = Math.ceil(n / o), c = Math.max(1, Math.round(Math.sqrt(d * 0.7))), u = 300 + r * (a + l) + 60, p = Math.ceil(o / r);
  let f = 0, y = 0;
  for (let b = 0; b < d; b++) {
    const w = b % c * (u + 140), k = Math.floor(b / c) * (p * 300 + 260), S = p * 300 + 100;
    t.push({ id: "sf" + b, type: "frame", x: w, y: k, w: u, h: S, z: f++, title: "Study " + (b + 1) });
    const _ = "st" + b, x = [];
    for (let T = 0; T < o && y < n; T++, y++) {
      const M = T % r, z = Math.floor(T / r), P = [176, 211, 316, 236][(b + T) % 4], D = e ? "synthetic://" + (y + 1) + "/800x" + Math.round(800 * P / a) : s[y % s.length], $ = "si" + y;
      t.push({
        id: $,
        type: "image",
        x: w + 300 + M * (a + l),
        y: k + 50 + z * 300,
        w: a,
        h: P,
        z: f++,
        src: D,
        label: "study_" + (b + 1) + "_v" + String(T + 1).padStart(2, "0"),
        resultId: "r-" + $,
        sessionId: _
      }), x.length < 4 && x.push(D), i.push({
        id: "r-" + $,
        sessionId: _,
        status: "done",
        url: D,
        w: a,
        h: P,
        prompt: "Study " + (b + 1) + ", variation " + (T + 1),
        model: "Nano Banana 2",
        createdAt: Date.now() - y * 6e4,
        label: "study_" + (b + 1) + "_v" + String(T + 1).padStart(2, "0")
      });
    }
    t.push({
      id: _,
      type: "tool",
      x: w + 30,
      y: k + 50,
      w: 252,
      h: 160,
      z: f++,
      name: "Study " + (b + 1),
      kind: "Image",
      kitId: "image",
      model: "Nano Banana 2",
      icon: "Image",
      count: o,
      thumbs: x,
      up: {}
    }), b % 3 === 0 && t.push({
      id: "sn" + b,
      type: "note",
      x: w + 30,
      y: k + 260,
      w: 184,
      h: 184,
      z: f++,
      tint: ["amethyst", "vista", "glass"][b % 3],
      text: "Review notes for study " + (b + 1) + ".",
      author: "KB"
    }), b % 4 === 1 && t.push({
      id: "ss" + b,
      type: "shape",
      shape: "arrow",
      x: w + 120,
      y: k + 470,
      w: 160,
      h: 0,
      z: f++,
      stroke: "#a3a7f5",
      sw: 4,
      sc: [0, 0]
    });
  }
  return { title: n + " image benchmark", elements: t, results: i };
}
function y8(n) {
  return n === "INIT" || n === "QUEUED";
}
function LH(n) {
  return n === "DONE" || n === "ERROR" || n === "NSFW";
}
const Aw = 512;
function Pw(n, e) {
  return "thumbs/" + n.replace(/\.[^/.]+$/, `_${Aw}x${Aw}.${e}`);
}
function b1(n) {
  const e = n.templateOriginalData || null, t = e && e.nodeRunId || n.nodeRunId || "", i = e && e.teamId || n.teamId || null, s = e && e.userId || n.userId || "", o = i ? `runnitResults/teams/${i}/runs/${t}/` : `runnitResults/users/${s}/runs/${t}/`, r = n.type === "LAYERS" && n.displayFile ? n.displayFile : n.file, a = r && r.name || "", l = n.downloadFile && n.downloadFile.name ? o + n.downloadFile.name : null;
  return { file: o + a, thumb: o + Pw(a, "webp"), mp4: o + Pw(a, "mp4"), download: l };
}
function v1(n) {
  return (n.teamId ? `runnitUploads/teams/${n.teamId}/uploads/` : `runnitUploads/users/${n.userId || ""}/uploads/`) + (n.name || "");
}
function x8(n) {
  const e = n.teamId ? `avatars/teams/${n.teamId}/uploads/` : `avatars/users/${n.userId || ""}/uploads/`, t = n.name || "avatar";
  return { file: e + t, thumb: e + "thumbs/" + t.replace(/\.[^/.]+$/, "_256x256.webp") };
}
function BH(n) {
  return "nodeRunResult" in n ? b1(n.nodeRunResult).file : "upload" in n ? v1(n.upload) : null;
}
function* w8(n) {
  for (const e of n || []) {
    const t = e;
    t && (t.__rgroup ? yield* w8(t.fields) : t.__rfield && (yield t));
  }
}
function FH(n) {
  return typeof n == "string" ? n : n && typeof n == "object" && "value" in n ? String(n.value || "") : "";
}
function NH(n) {
  let e = "", t = null;
  const i = n.inputs || {};
  for (const s of w8(n.fields)) {
    const o = String(s.fieldDefUuid || s.uuid || "");
    !e && s.type === "PROMPT" && (e = FH(i[o])), t == null && s.type === "SEED" && Number.isFinite(Number(i[o])) && (t = Number(i[o]));
  }
  return { prompt: e, seed: t };
}
function UH(n) {
  const e = [], t = (i) => {
    if (!i || typeof i != "object") return;
    const s = i;
    s.nodeRunResult && typeof s.nodeRunResult == "object" ? e.push(b1(s.nodeRunResult).file) : s.upload && typeof s.upload == "object" && e.push(v1(s.upload));
    for (const o of ["image", "video"]) s[o] && t(s[o]);
    for (const o of ["uploads", "nodeRunResults"]) {
      const r = s[o];
      if (Array.isArray(r)) for (const a of r) t(o === "uploads" ? { upload: a } : { nodeRunResult: a });
    }
  };
  for (const i of Object.values(n.inputs || {})) t(i);
  return e;
}
function y1(n, e, t) {
  const i = t.split("?")[0], s = i.lastIndexOf("."), o = s > i.lastIndexOf("/") && s > i.lastIndexOf("%2F") ? i.slice(s) : "", r = String(n || "").replace(/@{MODEL-(\S{12,36})}/g, "MODEL").slice(0, 100).replace(/[^a-zA-Z0-9_-]+/g, "_").replace(/^_+|_+$/g, "");
  return (r ? r + "-" + e : e) + o;
}
function GH(n) {
  if (!n || !Number.isFinite(n)) return;
  const e = Math.round(n);
  return Math.floor(e / 60) + ":" + String(e % 60).padStart(2, "0");
}
function jH(n, e) {
  return (String(n || "result").toLowerCase().replace(/[^a-z0-9 ]+/g, " ").trim().split(/\s+/).slice(0, 4).join("_") || "result").slice(0, 24) + "_v" + String(e + 1).padStart(2, "0");
}
function HH(n) {
  return n.initAt && n.doneAt && n.doneAt >= n.initAt ? n.doneAt - n.initAt : void 0;
}
function k8(n, e) {
  if (n.deletedAt) return [];
  const { prompt: t, seed: i } = NH(n), s = n.initAt || Date.now(), o = {
    sessionId: n.nodeId,
    prompt: t,
    model: e.modelName(n.nodeDefId),
    modelId: n.nodeDefId,
    inputs: n.inputs,
    refs: UH(n).map((a) => e.storageUrl(a)),
    seed: i,
    author: e.authorName(n.userId, n.email),
    userId: n.userId,
    authorEmail: n.email,
    runId: n.id
  };
  if (y8(n.state)) {
    const a = Math.max(1, Number(n.staticInputs && n.staticInputs.numResults) || 1), l = [];
    for (let d = 0; d < a; d++)
      l.push({ ...o, id: `${n.id}:p${d}`, status: "pending", url: "", w: 0, h: 0, createdAt: s + d, startedAt: s });
    return l;
  }
  if (n.state !== "DONE" && n.state !== "NSFW") return [];
  const r = [];
  return (n.results || []).forEach((a, l) => {
    if (!a || a.deletedAt) return;
    const d = b1({ ...a, nodeRunId: a.nodeRunId || n.id, userId: a.userId || n.userId, teamId: a.teamId !== void 0 ? a.teamId : n.teamId }), c = a.type === "LAYERS" && a.displayFile || a.file || {}, u = a.type === "VID", p = a.type === "ASSET_3D" || a.type === "MODEL", f = c.width || 1024, y = c.height || (c.aspectRatio ? Math.round(f / c.aspectRatio) : f);
    r.push({
      ...o,
      id: `${n.id}:${a.uuid}`,
      uuid: a.uuid,
      status: a.isNsfw ? "moderated" : "done",
      kind: u ? "video" : p ? "3d" : a.type === "LAYERS" ? "layers" : "image",
      // a video shows its first frame and a 3D model its preview until opened
      url: e.storageUrl(u || p ? d.thumb : d.file),
      thumb: u || p ? void 0 : e.storageUrl(d.thumb),
      video: u || void 0,
      videoSrc: u ? e.storageUrl(d.file) : void 0,
      previewSrc: u ? e.storageUrl(d.mp4) : void 0,
      dur: u ? GH(c.duration) : void 0,
      download: p ? e.storageUrl(d.file) : d.download ? e.storageUrl(d.download) : void 0,
      w: f,
      h: y,
      createdAt: (n.initAt || n.doneAt || 0) + l,
      took: HH(n),
      label: jH(t, l),
      asset: { nodeRunResult: { ...a, nodeRunId: a.nodeRunId || n.id } }
    });
  }), r;
}
const VH = ["disabled"], WH = ["disabled"], qH = ["src", "poster", "aria-label"], KH = ["src", "alt"], YH = {
  key: 2,
  class: "v2-info-play",
  "aria-hidden": "true"
}, XH = { class: "v2-info-zoom" }, JH = { class: "v2-info-side" }, ZH = { class: "v2-info-top" }, QH = ["title"], eV = ["title"], tV = ["title"], nV = {
  key: 0,
  class: "v2-info-confirm"
}, iV = {
  key: 0,
  class: "v2-info-card is-form"
}, sV = {
  key: 1,
  class: "v2-info-card is-record"
}, oV = { class: "v2-info-strip" }, rV = { class: "n" }, aV = { class: "when" }, lV = ["title", "aria-pressed"], dV = ["title", "aria-pressed"], cV = { class: "v2-info-block" }, uV = { class: "v2-info-block-head" }, hV = {
  key: 0,
  class: "v2-info-prompt is-reading",
  "data-testid": "info-reading"
}, pV = {
  key: 0,
  class: "v2-info-specs",
  "data-testid": "info-settings"
}, fV = ["title"], mV = {
  key: 1,
  class: "v2-info-specs"
}, gV = {
  key: 1,
  class: "none"
}, bV = {
  key: 1,
  class: "none"
}, vV = ["title"], yV = { class: "body" }, xV = { class: "v2-info-acts" }, wV = { class: "v2-info-pair" }, kV = /* @__PURE__ */ Re({
  __name: "ImageInfoModal",
  setup(n) {
    const { board: e } = tt(), t = /* @__PURE__ */ K(1), i = /* @__PURE__ */ K(!1), s = /* @__PURE__ */ K(""), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(1.3), a = I(() => {
      e.docRev.value, e.results.rev.value;
      const ce = e.ui.infoAt;
      if (!ce) return null;
      if (ce.startsWith("result:")) {
        const Fe = e.results.get(ce.slice(7)) || null;
        return Fe ? { el: null, result: Fe } : null;
      }
      const be = e.store.get(ce);
      if (!be || be.type !== "image") return null;
      const Be = be;
      return { el: { ...Be }, result: Be.resultId && e.results.get(Be.resultId) || null };
    }), l = I(() => !!e.ui.infoSession), d = I(() => {
      e.docRev.value, e.results.rev.value;
      const ce = e.ui.infoSession;
      if (ce) {
        const be = /* @__PURE__ */ new Map();
        for (const Be of e.store.all()) {
          const Fe = Be.type === "image" ? Be.resultId : void 0;
          Fe && !be.has(Fe) && be.set(Fe, Be.id);
        }
        return e.results.list(ce).filter((Be) => Be.status === "done").map((Be) => ({ key: be.get(Be.id) || "result:" + Be.id }));
      }
      return e.imagesInOrder().map((be) => ({ key: be.id }));
    }), c = I(() => d.value.findIndex((ce) => ce.key === e.ui.infoAt)), u = I(() => a.value ? a.value.el ? a.value.el.src : a.value.result.url : ""), p = I(() => a.value && (a.value.el ? a.value.el.w : a.value.result.w) || 4), f = I(() => a.value && (a.value.el ? a.value.el.h : a.value.result.h) || 3), y = I(() => !!(a.value && (a.value.el && a.value.el.video || a.value.result && a.value.result.video))), b = I(() => {
      const ce = a.value;
      return !ce || !y.value ? "" : ce.el && ce.el.videoSrc || ce.result && ce.result.videoSrc || "";
    }), w = I(() => a.value ? a.value.el && a.value.el.label || a.value.result && a.value.result.label || "image" : ""), k = I(() => !!a.value && e.isFav(a.value.result, a.value.el)), S = I(() => !!a.value && e.canFav(a.value.result, a.value.el)), _ = I(() => {
      const ce = a.value;
      if (!ce) return null;
      if (ce.el) return e.toolFor(ce.el);
      const be = e.store.get(ce.result.sessionId);
      return be && be.type === "tool" ? be : null;
    }), x = I(() => a.value ? a.value.result : null), T = I(() => {
      const ce = a.value;
      return ce && ce.el && ce.el.resultId && !ce.result ? ce.el.resultId : null;
    });
    $e(T, (ce) => {
      ce && e.loadRecord(ce);
    }, { immediate: !0 });
    const M = I(() => !!T.value && e.readingRecord(T.value)), z = $H(), P = I(() => {
      const ce = x.value;
      if (ce && ce.userId) {
        const Ke = ce.userId === e.user.uid, Qe = (Ke ? e.user.email : ce.authorEmail) || ce.author || "Someone else", ht = Ke && e.user.name || Qe;
        return { initials: Ke && e.user.initials || ta(ht), name: ht, mail: Qe };
      }
      const be = ce && ce.author || e.user.initials || "YOU", Be = z.find((Ke) => Ke.initials === be), Fe = Be ? Be.name : ce && ce.author && ce.author !== e.user.initials ? ce.author : e.user.name || "You";
      return { initials: be, name: Fe, mail: Be ? Be.name.split(" ")[0].toLowerCase() + "@rundiffusion.com" : e.user.email || Fe };
    }), D = I(() => x.value ? i1(x.value.createdAt) : M.value ? "" : "Not recorded"), $ = I(() => {
      const ce = x.value, be = ce && ce.modelId ? e.toolModel(ce.modelId) : null;
      return be && be.name || (ce && ce.model !== "Tool" ? ce.model : "") || _.value && _.value.model || (M.value ? "" : "Not recorded");
    }), O = I(() => x.value ? "No prompt: this run didn't use one." : T.value ? "Its run's record couldn't be read." : "No prompt recorded: this image was placed on the board rather than generated here."), L = I(() => wO(p.value, f.value)), Z = I(() => /upgrade|upscal|editorial|print/i.test(w.value) ? "4K" : y.value ? "1080p" : "1K"), J = I(() => x.value && x.value.refs || []), re = I(() => {
      const ce = x.value;
      if (!ce || !ce.inputs || !ce.modelId) return null;
      const be = e.catalog.value.byId.get(ce.modelId), Be = [];
      if (ce.w && ce.h && ce.status === "done" && Be.push({ label: "Size", value: ce.w + " × " + ce.h + (ce.dur ? " · " + ce.dur : "") }), ce.took && Be.push({ label: "Generation time", value: yO(ce.took) }), be)
        for (const Fe of be.fields) {
          if (Fe.placement === "prompt" || Fe.placement === "reference" || Fe.kind === "header") continue;
          const Ke = ce.inputs[Fe.key];
          Ke == null || Ke === "" || Be.push({ label: Fe.label || "Setting", value: F(Fe, Ke) });
        }
      return Be;
    });
    function F(ce, be) {
      if (typeof be == "boolean") return be ? "On" : "Off";
      const Be = (ce.options || []).find((Fe) => as(Fe.value, be));
      if (Be) return Be.label;
      if (be && typeof be == "object") {
        const Fe = be;
        return Fe.width && Fe.height ? Fe.width + " × " + Fe.height : Fe.value !== void 0 ? String(Fe.value) : Fe.model && Fe.model.name ? Fe.model.name : "";
      }
      return String(be);
    }
    const W = I(() => {
      const ce = x.value, be = J.value;
      if (!ce || !ce.modelId || !be.length) return [];
      const Be = e.catalog.value.byId.get(ce.modelId), Fe = Be ? Be.fields.filter((Ke) => Ke.placement === "reference").map((Ke) => Ke.label) : [];
      return be.slice(0, 4).map((Ke, Qe) => ({ label: Fe[Qe] || "Input " + (Qe + 1), url: Ke }));
    }), ee = I(() => e.canDelete(x.value)), N = /* @__PURE__ */ K(!1);
    async function te() {
      const ce = x.value;
      if (!ce) return;
      if (!N.value) {
        N.value = !0;
        return;
      }
      N.value = !1;
      const be = e.ui.infoAt, Be = e.ui.infoSession;
      if (l.value) {
        const Ke = d.value, Qe = c.value;
        e.ui.infoAt = Ke.length > 1 && Qe >= 0 ? Ke[Qe + 1 < Ke.length ? Qe + 1 : Qe - 1].key : null;
      }
      const Fe = e.ui.infoAt;
      !await e.deleteResult(ce) && e.ui.infoAt === Fe && (e.ui.infoSession = Be, e.ui.infoAt = be);
    }
    const G = /* @__PURE__ */ K(null), { more: q, measure: B } = m8(G);
    $e(() => e.ui.infoAt, (ce, be) => {
      t.value = 1, i.value = !1, N.value = !1, G.value && (G.value.scrollTop = 0), be && ce !== be && (e.ui.infoSave = !1);
    });
    const ne = I(() => e.promptLibrary.canSave && !!x.value && !!x.value.prompt && x.value.status === "done"), se = /* @__PURE__ */ We(null);
    $e(() => [e.ui.infoSave, x.value ? x.value.id : null], ([ce]) => {
      const be = x.value;
      se.value = ce && be && ne.value ? e.promptLibrary.draftForResult(be) : null;
    }, { immediate: !0 });
    function Y() {
      e.ui.infoSave = !0;
    }
    function ie() {
      e.ui.infoSave = !1;
    }
    function De(ce) {
      const be = d.value;
      if (!be.length) return;
      const Be = c.value < 0 ? 0 : (c.value + ce + be.length) % be.length;
      e.ui.infoAt = be[Be].key, l.value || (e.ui.selection = [be[Be].key]);
    }
    function xe(ce) {
      ce.target.tagName === "INPUT" || ce.target.tagName === "TEXTAREA" || (ce.key === "ArrowRight" ? De(1) : ce.key === "ArrowLeft" ? De(-1) : ce.key === "+" || ce.key === "=" ? t.value = Math.min(2, +(t.value + 0.2).toFixed(2)) : ce.key === "-" && (t.value = Math.max(0.6, +(t.value - 0.2).toFixed(2))));
    }
    let Oe = null;
    ot(() => {
      window.addEventListener("keydown", xe), o.value && (Oe = new ResizeObserver(() => {
        if (!o.value) return;
        const ce = o.value.getBoundingClientRect();
        ce.height && (r.value = ce.width / ce.height);
      }), Oe.observe(o.value));
    }), Ve(() => {
      window.removeEventListener("keydown", xe), Oe && Oe.disconnect(), e.ui.infoSession = null;
    });
    function Ee() {
      const ce = x.value ? x.value.prompt : "";
      try {
        navigator.clipboard.writeText(ce).catch(() => {
        });
      } catch {
      }
      i.value = !0, setTimeout(() => {
        i.value = !1;
      }, 1400);
    }
    function j() {
      e.ui.infoAt = null;
    }
    function V() {
      const ce = a.value;
      ce && (ce.el ? e.toggleFav(ce.el.id) : ce.result && e.toggleResultFav(ce.result));
    }
    const Q = I(() => !!u.value && e.isPinnedImage(u.value));
    function oe() {
      const ce = a.value;
      ce && e.togglePinImage(ce.el ? R6(ce.el, ce.result) : Df(ce.result));
    }
    const ue = I(() => {
      e.docRev.value;
      const ce = a.value;
      return ce ? ce.el ? ce.el : ce.result ? e.placedFor(ce.result.id) : null : null;
    });
    function Ie() {
      const ce = a.value;
      if (!ce) return;
      const be = ue.value;
      if (be) {
        e.ui.infoAt = null, e.ui.selection = [be.id], e.jumpTo(be.x + be.w / 2, be.y + be.h / 2, Math.max(e.cam.value.zoom, 0.6));
        return;
      }
      ce.result && (e.ui.infoAt = null, e.placeResult(ce.result));
    }
    function he() {
      const ce = a.value;
      if (!ce) return;
      const be = ce.el || { id: "", type: "image", x: 0, y: 0, w: p.value, h: f.value, z: 0, src: u.value, video: y.value };
      e.remixFrom(be, x.value);
    }
    function ye() {
      const ce = a.value;
      if (!ce) return;
      const be = x.value, Be = be && be.download || ce.el && ce.el.download || b.value || u.value, Fe = be && be.uuid ? y1(be.prompt, be.uuid, Be) : w.value;
      e.saveFile(Be, Fe), be && be.runId && e.trackDownload(be);
    }
    function fe() {
      const ce = _.value;
      !ce || !e.store.get(ce.id) || (e.ui.infoAt = null, e.openSession(ce));
    }
    const ze = I(() => !y.value && !!a.value);
    function He() {
      const ce = a.value;
      ce && (ce.result ? e.openStudio({ resultId: ce.result.id }) : ce.el && e.openStudio({ elementId: ce.el.id }));
    }
    return (ce, be) => a.value ? (g(), v("div", {
      key: 0,
      class: "v2-info",
      "data-testid": "info-modal",
      onPointerdown: Pe(j, ["self"])
    }, [
      h("button", {
        class: "v2-info-nav at-left",
        title: "Previous",
        disabled: d.value.length < 2,
        onClick: be[0] || (be[0] = (Be) => De(-1))
      }, [
        C(R, {
          name: "ChevronLeft",
          size: 22
        })
      ], 8, VH),
      h("button", {
        class: "v2-info-nav at-right",
        title: "Next",
        disabled: d.value.length < 2,
        onClick: be[1] || (be[1] = (Be) => De(1))
      }, [
        C(R, {
          name: "ChevronRight",
          size: 22
        })
      ], 8, WH),
      h("div", {
        class: "v2-info-shell",
        onPointerdown: be[8] || (be[8] = Pe(() => {
        }, ["stop"]))
      }, [
        h("div", {
          ref_key: "stage",
          ref: o,
          class: "v2-info-stage"
        }, [
          b.value ? (g(), v("video", {
            key: b.value,
            class: U(["v2-info-art is-video", { "is-loading": s.value !== u.value }]),
            src: b.value,
            poster: u.value,
            "aria-label": w.value,
            style: de({
              width: p.value / f.value > r.value ? "calc(100% - 36px)" : "auto",
              height: p.value / f.value > r.value ? "auto" : "calc(100% - 36px)",
              aspectRatio: p.value + " / " + f.value,
              transform: "scale(" + t.value + ")"
            }),
            "data-testid": "info-video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            controls: "",
            controlslist: "nodownload noplaybackrate",
            disablepictureinpicture: "",
            onLoadeddata: be[2] || (be[2] = (Be) => s.value = u.value)
          }, null, 46, qH)) : (g(), v("img", {
            key: u.value,
            class: U(["v2-info-art", { "is-loading": s.value !== u.value }]),
            src: u.value,
            alt: w.value,
            style: de({
              width: p.value / f.value > r.value ? "calc(100% - 36px)" : "auto",
              height: p.value / f.value > r.value ? "auto" : "calc(100% - 36px)",
              aspectRatio: p.value + " / " + f.value,
              transform: "scale(" + t.value + ")"
            }),
            draggable: "false",
            onLoad: be[3] || (be[3] = (Be) => s.value = u.value)
          }, null, 46, KH)),
          y.value && !b.value ? (g(), v("span", YH, [
            C(R, {
              name: "Play",
              size: 24
            })
          ])) : E("", !0),
          h("div", XH, [
            h("button", {
              title: "Zoom out",
              onClick: be[4] || (be[4] = (Be) => t.value = Math.max(0.6, +(t.value - 0.2).toFixed(2)))
            }, [
              C(R, {
                name: "Minus",
                size: 13
              })
            ]),
            h("span", null, A(Math.round(t.value * 100)) + "%", 1),
            h("button", {
              title: "Zoom in",
              onClick: be[5] || (be[5] = (Be) => t.value = Math.min(2, +(t.value + 0.2).toFixed(2)))
            }, [
              C(R, {
                name: "Plus",
                size: 13
              })
            ])
          ])
        ], 512),
        h("div", JH, [
          h("div", ZH, [
            h("span", {
              class: "v2-info-avatar",
              title: P.value.name
            }, A(P.value.initials), 9, QH),
            h("span", {
              class: "v2-info-mail",
              title: P.value.name
            }, A(P.value.mail), 9, eV),
            h("button", {
              class: "v2-info-act",
              title: "Download",
              "data-testid": "info-download",
              onClick: ye
            }, [
              C(R, {
                name: "Download",
                size: 14
              })
            ]),
            ee.value ? (g(), v("button", {
              key: 0,
              class: U(["v2-info-act is-danger", { "is-confirming": N.value }]),
              title: N.value ? "Click again to delete it from this session's history" + (ue.value ? " (its card stays on the board)" : "") : "Delete from history",
              "data-testid": "info-delete",
              onClick: te,
              onBlur: be[6] || (be[6] = (Be) => N.value = !1)
            }, [
              C(R, {
                name: N.value ? "Check" : "Trash2",
                size: 14
              }, null, 8, ["name"]),
              N.value ? (g(), v("span", nV, "Delete?")) : E("", !0)
            ], 42, tV)) : E("", !0),
            h("button", {
              class: "v2-info-act",
              title: "Close",
              "data-testid": "info-close",
              onClick: j
            }, [
              C(R, {
                name: "X",
                size: 14
              })
            ])
          ]),
          m(e).ui.infoSave && se.value ? (g(), v("div", iV, [
            (g(), Ce(g8, {
              key: se.value.output.url,
              draft: se.value,
              "editing-id": null,
              onDone: ie,
              onCancel: ie
            }, null, 8, ["draft"]))
          ])) : (g(), v("div", sV, [
            h("div", {
              ref_key: "detailsEl",
              ref: G,
              class: U(["v2-info-scroll", { "is-more": m(q) }]),
              onScrollPassive: be[7] || (be[7] = //@ts-ignore
              (...Be) => m(B) && m(B)(...Be))
            }, [
              h("div", oV, [
                h("span", rV, [
                  C(R, {
                    name: "Images",
                    size: 13
                  }),
                  X(" " + A(c.value >= 0 ? c.value + 1 : "–") + " of " + A(d.value.length), 1)
                ]),
                h("span", aV, A(D.value), 1),
                h("button", {
                  class: U(["v2-info-star is-pin", { on: Q.value }]),
                  title: Q.value ? m(jn).unpin : "Pin for yourself: one click away under Pinned, and only you see your pins",
                  "aria-pressed": Q.value,
                  "data-testid": "info-pin",
                  onClick: oe
                }, [
                  C(R, {
                    name: "Pin",
                    size: 15
                  })
                ], 10, lV),
                S.value ? (g(), v("button", {
                  key: 0,
                  class: U(["v2-info-star", { on: k.value }]),
                  title: k.value ? "Remove from your favorites" : "Add to your favorites",
                  "aria-pressed": k.value,
                  "data-testid": "info-fav",
                  onClick: V
                }, [
                  C(R, {
                    name: "Heart",
                    size: 15
                  })
                ], 10, dV)) : E("", !0)
              ]),
              h("div", cV, [
                h("div", uV, [
                  h("span", null, [
                    C(R, {
                      name: "MessageSquare",
                      size: 13
                    }),
                    be[9] || (be[9] = X(" Prompt", -1))
                  ]),
                  x.value && x.value.prompt ? (g(), v("button", {
                    key: 0,
                    title: "Copy prompt",
                    onClick: Ee
                  }, [
                    C(R, {
                      name: i.value ? "Check" : "Clipboard",
                      size: 13
                    }, null, 8, ["name"])
                  ])) : E("", !0)
                ]),
                M.value && !x.value ? (g(), v("p", hV, "Loading its record…")) : (g(), v("p", {
                  key: 1,
                  class: U(["v2-info-prompt", { "is-none": !(x.value && x.value.prompt) }]),
                  "data-testid": "info-prompt"
                }, A(x.value && x.value.prompt ? x.value.prompt : O.value), 3))
              ]),
              re.value ? (g(), v("div", pV, [
                (g(!0), v(H, null, me(W.value, (Be) => (g(), v("div", {
                  key: Be.label + Be.url
                }, [
                  h("span", null, A(Be.label), 1),
                  h("em", {
                    style: de({ backgroundImage: 'url("' + m(Wt)(Be.url) + '")' })
                  }, null, 4)
                ]))), 128)),
                (g(!0), v(H, null, me(re.value, (Be) => (g(), v("div", {
                  key: Be.label
                }, [
                  h("span", null, A(Be.label), 1),
                  h("b", {
                    title: Be.value
                  }, A(Be.value), 9, fV)
                ]))), 128)),
                h("div", null, [
                  be[10] || (be[10] = h("span", null, "Session", -1)),
                  h("b", null, A(_.value ? _.value.name : "Removed"), 1)
                ])
              ])) : (g(), v("div", mV, [
                h("div", null, [
                  be[11] || (be[11] = h("span", null, "Image to edit", -1)),
                  J.value[0] ? (g(), v("em", {
                    key: 0,
                    style: de({ backgroundImage: 'url("' + m(Wt)(J.value[0]) + '")' })
                  }, null, 4)) : (g(), v("b", gV, "none"))
                ]),
                h("div", null, [
                  be[12] || (be[12] = h("span", null, "Second image", -1)),
                  J.value[1] ? (g(), v("em", {
                    key: 0,
                    style: de({ backgroundImage: 'url("' + m(Wt)(J.value[1]) + '")' })
                  }, null, 4)) : (g(), v("b", bV, "none"))
                ]),
                h("div", null, [
                  be[13] || (be[13] = h("span", null, "Aspect ratio", -1)),
                  h("b", null, A(L.value), 1)
                ]),
                h("div", null, [
                  be[14] || (be[14] = h("span", null, "Resolution", -1)),
                  h("b", null, A(Z.value), 1)
                ]),
                h("div", null, [
                  be[15] || (be[15] = h("span", null, "File", -1)),
                  h("b", { title: w.value }, A(w.value), 9, vV)
                ]),
                h("div", null, [
                  be[16] || (be[16] = h("span", null, "Session", -1)),
                  h("b", null, A(_.value ? _.value.name : "None"), 1)
                ])
              ])),
              (g(), Ce(Yr(_.value && m(e).store.get(_.value.id) ? "button" : "div"), {
                class: "v2-info-tool",
                title: _.value && m(e).store.get(_.value.id) ? "Open this session" : void 0,
                onClick: fe
              }, {
                default: et(() => [
                  h("span", {
                    class: "thumb",
                    style: de({ backgroundImage: 'url("' + m(Wt)(_.value && _.value.thumbs && _.value.thumbs[0] || u.value) + '")' })
                  }, null, 4),
                  h("span", yV, [
                    be[17] || (be[17] = h("em", null, "Tool", -1)),
                    h("b", null, A($.value), 1)
                  ]),
                  _.value && m(e).store.get(_.value.id) ? (g(), Ce(R, {
                    key: 0,
                    class: "go",
                    name: "ChevronRight",
                    size: 15
                  })) : E("", !0)
                ]),
                _: 1
              }, 8, ["title"]))
            ], 34),
            h("div", xV, [
              h("button", {
                class: "v2-info-place",
                "data-testid": "info-place",
                onClick: Ie
              }, [
                ue.value ? (g(), v(H, { key: 0 }, [
                  C(R, {
                    name: "LocateFixed",
                    size: 15
                  }),
                  be[18] || (be[18] = X(" Show on canvas", -1))
                ], 64)) : (g(), v(H, { key: 1 }, [
                  C(R, {
                    name: "ArrowDownToLine",
                    size: 15
                  }),
                  be[19] || (be[19] = X(" Place on canvas", -1))
                ], 64))
              ]),
              h("div", wV, [
                h("button", {
                  class: "v2-info-remix",
                  onClick: he
                }, [
                  C(R, {
                    name: "Repeat",
                    size: 14
                  }),
                  X(" Remix this " + A(y.value ? "video" : "image"), 1)
                ]),
                ne.value ? (g(), v("button", {
                  key: 0,
                  class: "v2-info-remix",
                  title: "Save its prompt, tool, settings and images to the prompt library",
                  "data-testid": "info-save-prompt",
                  onClick: Y
                }, [
                  C(R, {
                    name: "Bookmark",
                    size: 14
                  }),
                  be[20] || (be[20] = X(" Save prompt ", -1))
                ])) : E("", !0),
                ze.value ? (g(), v("button", {
                  key: 1,
                  class: "v2-info-remix",
                  "data-testid": "info-edit",
                  onClick: He
                }, [
                  C(R, {
                    name: "Wand2",
                    size: 14
                  }),
                  be[21] || (be[21] = X(" Edit in Studio view", -1))
                ])) : E("", !0)
              ])
            ])
          ]))
        ])
      ], 32)
    ], 32)) : E("", !0);
  }
}), _V = { class: "ks-head" }, SV = { class: "ks-mark" }, TV = { class: "ks-titles" }, MV = { id: "ks-title" }, CV = {
  key: 0,
  class: "ks-os",
  "data-testid": "shortcuts-os"
}, IV = { class: "ks-grid" }, AV = { class: "ks-label" }, PV = { key: 0 }, EV = { class: "ks-keys" }, RV = /* @__PURE__ */ Re({
  __name: "ShortcutsPanel",
  setup(n) {
    const { board: e } = tt(), t = /* @__PURE__ */ K(null), i = Ef().shift, s = rs === "mac" ? "Mac" : rs === "windows" ? "Windows" : rs === "chromeos" ? "ChromeOS" : rs === "linux" ? "Linux" : "", o = [
      {
        title: "Tools",
        area: "tools",
        rows: [
          { label: "Select", keys: ["V"] },
          { label: "Hand", keys: ["H"] },
          { label: "Pan while held", keys: ["Space"] },
          { label: "Note", keys: ["N"] },
          { label: "Frame", keys: ["F"] },
          { label: "Rectangle", keys: ["M"] },
          { label: "Ellipse", keys: ["L"] },
          { label: "Line", keys: ["\\"] },
          { label: "Arrow", keys: dn(["shift", "\\"]) },
          { label: "Pick from the board", keys: ["I"], hint: "Into the open prompt's images" },
          { label: "Comment", keys: ["C"], hint: "Then click anything on the board" },
          { label: "Show or hide comments", keys: dn(["shift", "C"]) }
        ]
      },
      {
        title: "View",
        area: "view",
        rows: [
          { label: "Pan", keys: ["Scroll"], hint: "Or drag with two fingers" },
          { label: "Pan sideways", keys: dn(["shift", "Scroll"]) },
          { label: "Zoom", keys: dn(["mod", "Scroll"]), hint: "Or pinch" },
          { label: "Zoom in", keys: ["+"] },
          { label: "Zoom out", keys: ["−"] },
          { label: "Zoom to 100%", keys: ["0"] },
          { label: "Fit the board", keys: ["1"] }
        ]
      },
      {
        title: "Board",
        area: "board",
        rows: [
          { label: "Find or start a session", keys: ["Double-click"], hint: "On the empty board; it starts one there" },
          { label: "Add a session, note or frame there", keys: ["Right-click"] },
          { label: "Use an image as a reference", keys: dn(["shift", "Drag"]), hint: "Onto a session, or the open prompt" },
          { label: "Run the prompt", keys: dn(["mod", "enter"]) },
          { label: "Edit a note, open an image", keys: dn(["enter"]) },
          { label: "Close, then deselect", keys: dn(["esc"]) },
          { label: "These shortcuts", keys: ["?"] },
          { label: "Send feedback", keys: ["`"], hint: "With a screenshot of what's open" }
        ]
      },
      {
        title: "Edit",
        area: "edit",
        rows: [
          { label: "Undo", keys: dn(["mod", "Z"]) },
          { label: "Redo", keys: dn(l1()) },
          { label: "Copy", keys: dn(["mod", "C"]) },
          { label: "Cut", keys: dn(["mod", "X"]) },
          { label: "Paste", keys: dn(["mod", "V"]) },
          { label: "Duplicate", keys: dn(["mod", "D"]) },
          { label: "Select all", keys: dn(["mod", "A"]) },
          { label: "Delete", keys: dn(["del"]) },
          { label: "Lock or unlock a frame", keys: dn(["mod", "shift", "L"]) },
          { label: "Nudge", keys: ["←", "↑", "↓", "→"], hint: `Hold ${i} for 10 px` },
          { label: "Drag without snapping", keys: dn(["mod", "Drag"]) }
        ]
      }
    ];
    function r() {
      e.ui.keysOpen = !1;
    }
    let a = null;
    return ot(() => {
      a = document.activeElement, t.value && t.value.focus({ preventScroll: !0 });
    }), Ve(() => {
      a && document.contains(a) && a.focus({ preventScroll: !0 });
    }), (l, d) => (g(), v("div", {
      class: "ks",
      "data-testid": "shortcuts",
      onPointerdown: Pe(r, ["self"]),
      onWheel: d[1] || (d[1] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", {
        ref_key: "card",
        ref: t,
        class: "ks-card",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "ks-title",
        tabindex: "-1",
        onPointerdown: d[0] || (d[0] = Pe(() => {
        }, ["stop"]))
      }, [
        h("header", _V, [
          h("span", SV, [
            C(R, {
              name: "Keyboard",
              size: 17
            })
          ]),
          h("div", TV, [
            h("h2", MV, [
              d[2] || (d[2] = X("Keyboard shortcuts", -1)),
              m(s) ? (g(), v("span", CV, A(m(s)), 1)) : E("", !0)
            ]),
            d[3] || (d[3] = h("p", null, [
              X("Press "),
              h("kbd", { class: "ks-key is-inline" }, "?"),
              X(" on the board to bring these up any time.")
            ], -1))
          ]),
          h("button", {
            class: "ks-close",
            title: "Close",
            "aria-label": "Close",
            "data-testid": "shortcuts-close",
            onClick: r
          }, [
            C(R, {
              name: "X",
              size: 15
            })
          ])
        ]),
        h("div", IV, [
          (g(), v(H, null, me(o, (c) => h("section", {
            key: c.title,
            class: "ks-group",
            style: de({ gridArea: c.area })
          }, [
            h("h3", null, A(c.title), 1),
            h("ul", null, [
              (g(!0), v(H, null, me(c.rows, (u) => (g(), v("li", {
                key: u.label
              }, [
                h("span", AV, [
                  X(A(u.label) + " ", 1),
                  u.hint ? (g(), v("small", PV, A(u.hint), 1)) : E("", !0)
                ]),
                h("span", EV, [
                  (g(!0), v(H, null, me(u.keys, (p, f) => (g(), v("kbd", {
                    key: f,
                    class: U(["ks-key", { "is-word": p.length > 1 }])
                  }, A(p), 3))), 128))
                ])
              ]))), 128))
            ])
          ], 4)), 64))
        ])
      ], 544)
    ], 32));
  }
});
var zV = Object.defineProperty, $V = (n, e, t) => e in n ? zV(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Su = (n, e, t) => $V(n, typeof e != "symbol" ? e + "" : e, t);
const Tu = 32768;
class DV {
  constructor(e = 512) {
    Su(this, "cell"), Su(this, "cells", /* @__PURE__ */ new Map()), Su(this, "items", /* @__PURE__ */ new Map()), Su(this, "mark", 0), this.cell = e;
  }
  get size() {
    return this.items.size;
  }
  has(e) {
    return this.items.has(e);
  }
  rectOf(e) {
    const t = this.items.get(e);
    return t ? t.r : void 0;
  }
  keysFor(e) {
    const t = this.cell, i = Math.floor(e.x / t), s = Math.floor(e.y / t), o = Math.floor((e.x + Math.max(0, e.w)) / t), r = Math.floor((e.y + Math.max(0, e.h)) / t), a = [];
    for (let l = i; l <= o; l++)
      for (let d = s; d <= r; d++) a.push((l + Tu) * 65536 + (d + Tu));
    return a;
  }
  insert(e, t) {
    if (this.items.has(e)) {
      this.update(e, t);
      return;
    }
    const i = this.keysFor(t);
    this.items.set(e, { r: { x: t.x, y: t.y, w: t.w, h: t.h }, keys: i, mark: 0 });
    for (const s of i) {
      let o = this.cells.get(s);
      o || (o = /* @__PURE__ */ new Set(), this.cells.set(s, o)), o.add(e);
    }
  }
  update(e, t) {
    const i = this.items.get(e);
    if (!i) {
      this.insert(e, t);
      return;
    }
    const s = this.keysFor(t);
    if (i.r.x = t.x, i.r.y = t.y, i.r.w = t.w, i.r.h = t.h, !(s.length === i.keys.length && s.every((o, r) => o === i.keys[r]))) {
      for (const o of i.keys) {
        const r = this.cells.get(o);
        r && (r.delete(e), r.size || this.cells.delete(o));
      }
      i.keys = s;
      for (const o of s) {
        let r = this.cells.get(o);
        r || (r = /* @__PURE__ */ new Set(), this.cells.set(o, r)), r.add(e);
      }
    }
  }
  remove(e) {
    const t = this.items.get(e);
    if (t) {
      for (const i of t.keys) {
        const s = this.cells.get(i);
        s && (s.delete(e), s.size || this.cells.delete(i));
      }
      this.items.delete(e);
    }
  }
  clear() {
    this.cells.clear(), this.items.clear();
  }
  /** Ids whose rects intersect r (touching edges count). Unordered. */
  query(e, t = []) {
    const i = ++this.mark, s = this.cell, o = Math.floor(e.x / s), r = Math.floor(e.y / s), a = Math.floor((e.x + e.w) / s), l = Math.floor((e.y + e.h) / s), d = e.x + e.w, c = e.y + e.h;
    if ((a - o + 1) * (l - r + 1) > this.cells.size) {
      for (const [u, p] of this.items) {
        const f = p.r;
        f.x <= d && f.x + f.w >= e.x && f.y <= c && f.y + f.h >= e.y && t.push(u);
      }
      return t;
    }
    for (let u = o; u <= a; u++)
      for (let p = r; p <= l; p++) {
        const f = this.cells.get((u + Tu) * 65536 + (p + Tu));
        if (f)
          for (const y of f) {
            const b = this.items.get(y);
            if (b.mark === i) continue;
            b.mark = i;
            const w = b.r;
            w.x <= d && w.x + w.w >= e.x && w.y <= c && w.y + w.h >= e.y && t.push(y);
          }
      }
    return t;
  }
  queryPoint(e, t, i = 0, s = []) {
    return this.query({ x: e - i, y: t - i, w: i * 2, h: i * 2 }, s);
  }
}
var OV = Object.defineProperty, LV = (n, e, t) => e in n ? OV(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, ei = (n, e, t) => LV(n, typeof e != "symbol" ? e + "" : e, t);
const BV = 100;
function Yi(n) {
  return n == null || typeof n != "object" ? n : JSON.parse(JSON.stringify(n));
}
function Hm(n) {
  const e = {};
  for (const t of Object.keys(n)) e[t] = Yi(n[t]);
  return e;
}
function Vm(n, e) {
  return n === e ? !0 : n && e && typeof n == "object" && typeof e == "object" ? JSON.stringify(n) === JSON.stringify(e) : !1;
}
class FV {
  constructor() {
    ei(this, "elements", /* @__PURE__ */ new Map()), ei(this, "index", new DV(512)), ei(this, "listeners", /* @__PURE__ */ new Set()), ei(this, "undoStack", []), ei(this, "redoStack", []), ei(this, "depth", 0), ei(this, "batchLabel", ""), ei(this, "batchPatches", []), ei(this, "batchSet", null), ei(this, "batchHistory", !0), ei(this, "gesture", null), ei(this, "maxZ", { frames: 0, content: 0, annotations: 0 }), ei(this, "minZ", { frames: 0, content: 0, annotations: 0 }), ei(this, "version", 0);
  }
  // ---------------------------------------------------------------- reads
  get(e) {
    return this.elements.get(e);
  }
  all() {
    return this.elements.values();
  }
  get size() {
    return this.elements.size;
  }
  /** Elements intersecting a world rect, unordered. */
  query(e) {
    const t = this.index.query(e), i = [];
    for (const s of t) {
      const o = this.elements.get(s);
      o && i.push(o);
    }
    return i;
  }
  bounds(e) {
    let t = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0;
    const r = (a) => {
      const l = qe(a);
      l.x < t && (t = l.x), l.y < i && (i = l.y), l.x + l.w > s && (s = l.x + l.w), l.y + l.h > o && (o = l.y + l.h);
    };
    if (e)
      for (const a of e) {
        const l = this.elements.get(a);
        l && r(l);
      }
    else
      for (const a of this.elements.values()) r(a);
    return t === 1 / 0 ? null : { x: t, y: i, w: s - t, h: o - i };
  }
  nextZ(e, t = !1) {
    const i = nv[e.type];
    return t ? this.minZ[i] - 1 : this.maxZ[i] + 1;
  }
  get canUndo() {
    return this.undoStack.length > 0;
  }
  get canRedo() {
    return this.redoStack.length > 0;
  }
  get inGesture() {
    return !!this.gesture;
  }
  // -------------------------------------------------------------- events
  subscribe(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
  emit(e) {
    if (!(!e.added.length && !e.updated.length && !e.removed.length)) {
      this.version++;
      for (const t of this.listeners)
        try {
          t(e);
        } catch (i) {
          console.error("[board] change listener failed", i);
        }
    }
  }
  // ------------------------------------------------------------ batching
  /** Run fn as one undo step and one change set. Nestable. */
  batch(e, t, i = {}) {
    this.open(e, i);
    try {
      return t();
    } finally {
      this.close();
    }
  }
  open(e, t) {
    this.depth++ === 0 && (this.batchLabel = e, this.batchPatches = [], this.batchHistory = t.history !== !1 && (t.origin || "local") === "local", this.batchSet = {
      origin: t.origin || "local",
      ephemeral: !!this.gesture && (t.origin || "local") === "local",
      label: e,
      added: [],
      updated: [],
      removed: []
    });
  }
  close() {
    if (--this.depth > 0) return;
    const e = this.batchSet, t = this.batchPatches;
    this.batchSet = null, this.batchPatches = [], this.batchHistory && t.length && !this.gesture && this.pushHistory({ label: this.batchLabel, patches: t }), this.emit(e);
  }
  pushHistory(e) {
    this.undoStack.push(e), this.undoStack.length > BV && this.undoStack.shift(), this.redoStack = [];
  }
  // ----------------------------------------------------------- mutations
  add(e, t = {}) {
    this.batch("Add", () => {
      for (const i of e) {
        if (this.elements.has(i.id)) continue;
        const s = i;
        this.elements.set(s.id, s), this.index.insert(s.id, qe(s)), this.trackZ(s), this.batchSet.added.push(s), this.batchPatches.push({ op: "add", el: Yi(s) }), this.gesture && this.batchSet.origin === "local" && this.gesture.added.add(s.id);
      }
    }, t);
  }
  update(e, t, i = {}) {
    this.updateMany([[e, t]], i);
  }
  updateMany(e, t = {}) {
    this.batch("Edit", () => {
      for (const [i, s] of e) {
        const o = this.elements.get(i);
        if (!o) continue;
        const r = {}, a = {};
        let l = !1;
        for (const c of Object.keys(s)) {
          if (c === "id" || c === "type") continue;
          const u = s[c];
          Vm(o[c], u) || (r[c] = Yi(o[c]), a[c] = Yi(u), o[c] = u === void 0 ? void 0 : Yi(u), u === void 0 && delete o[c], l = !0);
        }
        if (!l) continue;
        if (("x" in a || "y" in a || "w" in a || "h" in a || "scale" in a) && this.index.update(i, qe(o)), "z" in a && this.trackZ(o), this.gesture && this.batchSet.origin === "local" && !this.gesture.added.has(i)) {
          const c = this.gesture.before.get(i) || {};
          for (const u of Object.keys(r)) u in c || (c[u] = r[u]);
          this.gesture.before.set(i, c);
        }
        const d = this.batchSet.updated.find((c) => c.id === i);
        if (d)
          for (const c of Object.keys(a))
            c in d.before || (d.before[c] = r[c]), d.after[c] = a[c];
        else
          this.batchSet.updated.push({ id: i, el: o, before: r, after: a });
        this.batchPatches.push({ op: "update", id: i, before: r, after: a });
      }
    }, t);
  }
  remove(e, t = {}) {
    this.batch("Delete", () => {
      for (const i of e) {
        const s = this.elements.get(i);
        s && (this.elements.delete(i), this.index.remove(i), this.batchSet.removed.push(s), this.batchPatches.push({ op: "remove", el: Yi(s) }));
      }
    }, t);
  }
  /** Replace everything (initial load). No history. */
  load(e) {
    const t = Array.from(this.elements.values());
    this.elements.clear(), this.index.clear(), this.maxZ = { frames: 0, content: 0, annotations: 0 }, this.minZ = { frames: 0, content: 0, annotations: 0 }, this.undoStack = [], this.redoStack = [];
    for (const i of e)
      this.elements.set(i.id, i), this.index.insert(i.id, qe(i)), this.trackZ(i);
    this.emit({ origin: "load", ephemeral: !1, label: "Load", added: e, updated: [], removed: t });
  }
  trackZ(e) {
    const t = nv[e.type];
    e.z > this.maxZ[t] && (this.maxZ[t] = e.z), e.z < this.minZ[t] && (this.minZ[t] = e.z);
  }
  // ------------------------------------------------------------ gestures
  beginGesture(e) {
    this.gesture && this.endGesture(), this.gesture = { label: e, before: /* @__PURE__ */ new Map(), added: /* @__PURE__ */ new Set() };
  }
  /** Commit the gesture: one persisted change set, one undo step. */
  endGesture() {
    const e = this.gesture;
    if (!e) return;
    this.gesture = null;
    const t = { origin: "local", ephemeral: !1, label: e.label, added: [], updated: [], removed: [] }, i = [];
    for (const s of e.added) {
      const o = this.elements.get(s);
      o && (t.added.push(o), i.push({ op: "add", el: Yi(o) }));
    }
    for (const [s, o] of e.before) {
      const r = this.elements.get(s);
      if (!r) continue;
      const a = {}, l = {};
      for (const d of Object.keys(o))
        Vm(o[d], r[d]) || (l[d] = o[d], a[d] = Yi(r[d]));
      Object.keys(a).length && (t.updated.push({ id: s, el: r, before: l, after: a }), i.push({ op: "update", id: s, before: l, after: a }));
    }
    i.length && this.pushHistory({ label: e.label, patches: i }), this.emit(t);
  }
  /** Abandon the gesture and put everything back. */
  cancelGesture() {
    const e = this.gesture;
    e && (this.gesture = null, this.batch("Cancel", () => {
      this.remove(e.added, { history: !1 });
      const t = [];
      for (const [i, s] of e.before) t.push([i, s]);
      this.updateMany(t, { history: !1 });
    }, { history: !1 }));
  }
  // ------------------------------------------------------------- history
  /**
   * Record an undo step for an edit already applied without history (text
   * typed into a note, saved as you type): one step for the whole edit.
   */
  recordEdit(e, t, i, s) {
    !Object.keys(s).some((r) => !Vm(i[r], s[r])) || !this.elements.has(t) || this.pushHistory({ label: e, patches: [{ op: "update", id: t, before: Hm(i), after: Hm(s) }] });
  }
  undo() {
    this.gesture && this.endGesture();
    const e = this.undoStack.pop();
    return e ? (this.applyPatches(e.patches, !0, "Undo " + e.label), this.redoStack.push(e), !0) : !1;
  }
  redo() {
    this.gesture && this.endGesture();
    const e = this.redoStack.pop();
    return e ? (this.applyPatches(e.patches, !1, "Redo " + e.label), this.undoStack.push(e), !0) : !1;
  }
  /**
   * Elements gone for good (deleted from Recently Deleted): no undo or redo
   * step brings them back or changes them. Their part of each step goes, and
   * a step left with nothing goes too; the rest of a step stays, so Undo
   * still takes back whatever else it did.
   */
  forget(e) {
    if (!e.length) return;
    const t = new Set(e), i = (s) => s.map((o) => ({ ...o, patches: o.patches.filter((r) => !t.has(r.op === "update" ? r.id : r.el.id)) })).filter((o) => o.patches.length > 0);
    this.undoStack = i(this.undoStack), this.redoStack = i(this.redoStack);
  }
  /** The elements an Undo (or a Redo) would put back on the board: what an undoable step removed, or Undo took away. */
  restorableIds() {
    const e = /* @__PURE__ */ new Set();
    for (const t of this.undoStack) for (const i of t.patches) i.op === "remove" && e.add(i.el.id);
    for (const t of this.redoStack) for (const i of t.patches) i.op === "add" && e.add(i.el.id);
    return Array.from(e);
  }
  /** The labels on the undo stack, oldest first: what Undo would take back, in turn from the end. */
  undoLabels() {
    return this.undoStack.map((e) => e.label);
  }
  applyPatches(e, t, i) {
    const s = t ? e.slice().reverse() : e;
    this.batch(i, () => {
      for (const o of s)
        o.op === "add" ? t ? this.remove([o.el.id], { history: !1, origin: "local" }) : this.add([Yi(o.el)], { history: !1, origin: "local" }) : o.op === "remove" ? t ? this.add([Yi(o.el)], { history: !1, origin: "local" }) : this.remove([o.el.id], { history: !1, origin: "local" }) : this.update(o.id, Hm(t ? o.before : o.after), { history: !1, origin: "local" });
    }, { history: !1, origin: "local" });
  }
}
var Ae = /* @__PURE__ */ ((n) => (n.Application = "application", n.WebGLPipes = "webgl-pipes", n.WebGLPipesAdaptor = "webgl-pipes-adaptor", n.WebGLSystem = "webgl-system", n.WebGLLoader = "webgl-loader", n.WebGPUPipes = "webgpu-pipes", n.WebGPUPipesAdaptor = "webgpu-pipes-adaptor", n.WebGPUSystem = "webgpu-system", n.WebGPULoader = "webgpu-loader", n.CanvasSystem = "canvas-system", n.CanvasPipesAdaptor = "canvas-pipes-adaptor", n.CanvasPipes = "canvas-pipes", n.CanvasLoader = "canvas-loader", n.Asset = "asset", n.LoadParser = "load-parser", n.ResolveParser = "resolve-parser", n.CacheParser = "cache-parser", n.DetectionParser = "detection-parser", n.MaskEffect = "mask-effect", n.BlendMode = "blend-mode", n.TextureSource = "texture-source", n.TextureUploaderWebGL = "texture-uploader-webgl", n.TextureUploaderWebGPU = "texture-uploader-webgpu", n.Environment = "environment", n.ShapeBuilder = "shape-builder", n.Batcher = "batcher", n))(Ae || {});
const pv = (n) => {
  if (typeof n == "function" || typeof n == "object" && n.extension) {
    if (!n.extension)
      throw new Error("Extension class must have an extension object");
    n = { ...typeof n.extension != "object" ? { type: n.extension } : n.extension, ref: n };
  }
  if (typeof n == "object")
    n = { ...n };
  else
    throw new Error("Invalid extension type");
  return typeof n.type == "string" && (n.type = [n.type]), n;
}, Mu = (n, e) => {
  var t;
  return (t = pv(n).priority) != null ? t : e;
}, ct = {
  /** @ignore */
  _addHandlers: {},
  /** @ignore */
  _removeHandlers: {},
  /** @ignore */
  _queue: {},
  /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed. Can be:
   * - Extension class with static `extension` property
   * - Extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns {extensions} this for chaining
   * @example
   * ```ts
   * // Remove a single extension
   * extensions.remove(MyRendererPlugin);
   *
   * // Remove multiple extensions
   * extensions.remove(
   *     MyRendererPlugin,
   *     MySystemPlugin
   * );
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   */
  remove(...n) {
    return n.map(pv).forEach((e) => {
      e.type.forEach((t) => {
        var i, s;
        return (s = (i = this._removeHandlers)[t]) == null ? void 0 : s.call(i, e);
      });
    }), this;
  },
  /**
   * Register new extensions with PixiJS. Extensions can be registered in multiple formats:
   * - As a class with a static `extension` property
   * - As an extension format object
   * - As multiple extensions passed as separate arguments
   * @param extensions - Extensions to add to PixiJS. Each can be:
   * - A class with static `extension` property
   * - An extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns This extensions instance for chaining
   * @example
   * ```ts
   * // Register a simple extension
   * extensions.add(MyRendererPlugin);
   *
   * // Register multiple extensions
   * extensions.add(
   *     MyRendererPlugin,
   *     MySystemPlugin,
   * });
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   * @see {@link extensions.remove} For removing registered extensions
   */
  add(...n) {
    return n.map(pv).forEach((e) => {
      e.type.forEach((t) => {
        var o, r;
        const i = this._addHandlers, s = this._queue;
        i[t] ? (r = i[t]) == null || r.call(i, e) : (s[t] = s[t] || [], (o = s[t]) == null || o.push(e));
      });
    }), this;
  },
  /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns this for chaining.
   * @internal
   * @ignore
   */
  handle(n, e, t) {
    var r;
    const i = this._addHandlers, s = this._removeHandlers;
    if (i[n] || s[n])
      throw new Error(`Extension type ${n} already has a handler`);
    i[n] = e, s[n] = t;
    const o = this._queue;
    return o[n] && ((r = o[n]) == null || r.forEach((a) => e(a)), delete o[n]), this;
  },
  /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns this for chaining.
   * @ignore
   */
  handleByMap(n, e) {
    return this.handle(
      n,
      (t) => {
        t.name && (e[t.name] = t.ref);
      },
      (t) => {
        t.name && delete e[t.name];
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns this for chaining.
   * @ignore
   */
  handleByNamedList(n, e, t = -1) {
    return this.handle(
      n,
      (i) => {
        e.findIndex((o) => o.name === i.name) >= 0 || (e.push({ name: i.name, value: i.ref }), e.sort((o, r) => Mu(r.value, t) - Mu(o.value, t)));
      },
      (i) => {
        const s = e.findIndex((o) => o.name === i.name);
        s !== -1 && e.splice(s, 1);
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns this for chaining.
   * @ignore
   */
  handleByList(n, e, t = -1) {
    return this.handle(
      n,
      (i) => {
        e.includes(i.ref) || (e.push(i.ref), e.sort((s, o) => Mu(o, t) - Mu(s, t)));
      },
      (i) => {
        const s = e.indexOf(i.ref);
        s !== -1 && e.splice(s, 1);
      }
    );
  },
  /**
   * Mixin the source object(s) properties into the target class's prototype.
   * Copies all property descriptors from source objects to the target's prototype.
   * @param Target - The target class to mix properties into
   * @param sources - One or more source objects containing properties to mix in
   * @example
   * ```ts
   * // Create a mixin with shared properties
   * const moveable = {
   *     x: 0,
   *     y: 0,
   *     move(x: number, y: number) {
   *         this.x += x;
   *         this.y += y;
   *     }
   * };
   *
   * // Create a mixin with computed properties
   * const scalable = {
   *     scale: 1,
   *     get scaled() {
   *         return this.scale > 1;
   *     }
   * };
   *
   * // Apply mixins to a class
   * extensions.mixin(Sprite, moveable, scalable);
   *
   * // Use mixed-in properties
   * const sprite = new Sprite();
   * sprite.move(10, 20);
   * console.log(sprite.x, sprite.y); // 10, 20
   * ```
   * @remarks
   * - Copies all properties including getters/setters
   * - Does not modify source objects
   * - Preserves property descriptors
   * @see {@link Object.defineProperties} For details on property descriptors
   * @see {@link Object.getOwnPropertyDescriptors} For details on property copying
   */
  mixin(n, ...e) {
    for (const t of e)
      Object.defineProperties(n.prototype, Object.getOwnPropertyDescriptors(t));
  }
}, NV = {
  extension: {
    type: Ae.Environment,
    name: "browser",
    priority: -1
  },
  test: () => !0,
  load: async () => {
    await Promise.resolve().then(() => jAe);
  }
}, UV = {
  extension: {
    type: Ae.Environment,
    name: "webworker",
    priority: 0
  },
  test: () => typeof self != "undefined" && self.WorkerGlobalScope !== void 0,
  load: async () => {
    await Promise.resolve().then(() => HAe);
  }
};
class En {
  /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e, t, i) {
    this._x = t || 0, this._y = i || 0, this._observer = e;
  }
  /**
   * Creates a clone of this point.
   * @example
   * ```ts
   * // Basic cloning
   * const point = new ObservablePoint(observer, 100, 200);
   * const copy = point.clone();
   *
   * // Clone with new observer
   * const newObserver = {
   *     _onUpdate: (p) => console.log(`Clone updated: (${p.x}, ${p.y})`)
   * };
   * const watched = point.clone(newObserver);
   *
   * // Verify independence
   * watched.set(300, 400); // Only triggers new observer
   * ```
   * @param observer - Optional observer to pass to the new observable point
   * @returns A copy of this observable point
   * @see {@link ObservablePoint.copyFrom} For copying into existing point
   * @see {@link Observer} For observer interface details
   */
  clone(e) {
    return new En(e != null ? e : this._observer, this._x, this._y);
  }
  /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new ObservablePoint(observer);
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.equals} For comparing positions
   */
  set(e = 0, t = e) {
    return (this._x !== e || this._y !== t) && (this._x = e, this._y = t, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(observer, 100, 200);
   * const target = new ObservablePoint();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new ObservablePoint()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyTo} For copying to another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */
  copyFrom(e) {
    return (this._x !== e.x || this._y !== e.y) && (this._x = e.x, this._y = e.y, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(100, 200);
   * const target = new ObservablePoint();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */
  copyTo(e) {
    return e.set(this._x, this._y), e;
  }
  /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new ObservablePoint(100, 200);
   * const p2 = new ObservablePoint(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new ObservablePoint(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link ObservablePoint.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */
  equals(e) {
    return e.x === this._x && e.y === this._y;
  }
  toString() {
    return `[pixi.js/math:ObservablePoint x=${this._x} y=${this._y} scope=${this._observer}]`;
  }
  /**
   * Position of the observable point on the x axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic x position
   * const point = new ObservablePoint(observer);
   * point.x = 100; // Triggers observer
   *
   * // Use in calculations
   * const width = rightPoint.x - leftPoint.x;
   * ```
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x !== e && (this._x = e, this._observer._onUpdate(this));
  }
  /**
   * Position of the observable point on the y axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic y position
   * const point = new ObservablePoint(observer);
   * point.y = 200; // Triggers observer
   *
   * // Use in calculations
   * const height = bottomPoint.y - topPoint.y;
   * ```
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y !== e && (this._y = e, this._observer._onUpdate(this));
  }
}
function GV(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Wm = { exports: {} }, Ew;
function jV() {
  return Ew || (Ew = 1, (function(n) {
    var e = Object.prototype.hasOwnProperty, t = "~";
    function i() {
    }
    Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (t = !1));
    function s(l, d, c) {
      this.fn = l, this.context = d, this.once = c || !1;
    }
    function o(l, d, c, u, p) {
      if (typeof c != "function")
        throw new TypeError("The listener must be a function");
      var f = new s(c, u || l, p), y = t ? t + d : d;
      return l._events[y] ? l._events[y].fn ? l._events[y] = [l._events[y], f] : l._events[y].push(f) : (l._events[y] = f, l._eventsCount++), l;
    }
    function r(l, d) {
      --l._eventsCount === 0 ? l._events = new i() : delete l._events[d];
    }
    function a() {
      this._events = new i(), this._eventsCount = 0;
    }
    a.prototype.eventNames = function() {
      var d = [], c, u;
      if (this._eventsCount === 0) return d;
      for (u in c = this._events)
        e.call(c, u) && d.push(t ? u.slice(1) : u);
      return Object.getOwnPropertySymbols ? d.concat(Object.getOwnPropertySymbols(c)) : d;
    }, a.prototype.listeners = function(d) {
      var c = t ? t + d : d, u = this._events[c];
      if (!u) return [];
      if (u.fn) return [u.fn];
      for (var p = 0, f = u.length, y = new Array(f); p < f; p++)
        y[p] = u[p].fn;
      return y;
    }, a.prototype.listenerCount = function(d) {
      var c = t ? t + d : d, u = this._events[c];
      return u ? u.fn ? 1 : u.length : 0;
    }, a.prototype.emit = function(d, c, u, p, f, y) {
      var b = t ? t + d : d;
      if (!this._events[b]) return !1;
      var w = this._events[b], k = arguments.length, S, _;
      if (w.fn) {
        switch (w.once && this.removeListener(d, w.fn, void 0, !0), k) {
          case 1:
            return w.fn.call(w.context), !0;
          case 2:
            return w.fn.call(w.context, c), !0;
          case 3:
            return w.fn.call(w.context, c, u), !0;
          case 4:
            return w.fn.call(w.context, c, u, p), !0;
          case 5:
            return w.fn.call(w.context, c, u, p, f), !0;
          case 6:
            return w.fn.call(w.context, c, u, p, f, y), !0;
        }
        for (_ = 1, S = new Array(k - 1); _ < k; _++)
          S[_ - 1] = arguments[_];
        w.fn.apply(w.context, S);
      } else {
        var x = w.length, T;
        for (_ = 0; _ < x; _++)
          switch (w[_].once && this.removeListener(d, w[_].fn, void 0, !0), k) {
            case 1:
              w[_].fn.call(w[_].context);
              break;
            case 2:
              w[_].fn.call(w[_].context, c);
              break;
            case 3:
              w[_].fn.call(w[_].context, c, u);
              break;
            case 4:
              w[_].fn.call(w[_].context, c, u, p);
              break;
            default:
              if (!S) for (T = 1, S = new Array(k - 1); T < k; T++)
                S[T - 1] = arguments[T];
              w[_].fn.apply(w[_].context, S);
          }
      }
      return !0;
    }, a.prototype.on = function(d, c, u) {
      return o(this, d, c, u, !1);
    }, a.prototype.once = function(d, c, u) {
      return o(this, d, c, u, !0);
    }, a.prototype.removeListener = function(d, c, u, p) {
      var f = t ? t + d : d;
      if (!this._events[f]) return this;
      if (!c)
        return r(this, f), this;
      var y = this._events[f];
      if (y.fn)
        y.fn === c && (!p || y.once) && (!u || y.context === u) && r(this, f);
      else {
        for (var b = 0, w = [], k = y.length; b < k; b++)
          (y[b].fn !== c || p && !y[b].once || u && y[b].context !== u) && w.push(y[b]);
        w.length ? this._events[f] = w.length === 1 ? w[0] : w : r(this, f);
      }
      return this;
    }, a.prototype.removeAllListeners = function(d) {
      var c;
      return d ? (c = t ? t + d : d, this._events[c] && r(this, c)) : (this._events = new i(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, n.exports = a;
  })(Wm)), Wm.exports;
}
var HV = jV();
const di = /* @__PURE__ */ GV(HV), VV = Math.PI * 2, WV = 180 / Math.PI, qV = Math.PI / 180;
class Gt {
  /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e = 0, t = 0) {
    this.x = 0, this.y = 0, this.x = e, this.y = t;
  }
  /**
   * Creates a clone of this point, which is a new instance with the same `x` and `y` values.
   * @example
   * ```ts
   * // Basic point cloning
   * const original = new Point(100, 200);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.set(300, 400);
   *
   * // Verify independence
   * console.log(original); // Point(100, 200)
   * console.log(modified); // Point(300, 400)
   * ```
   * @remarks
   * - Creates new Point instance
   * - Deep copies x and y values
   * - Independent from original
   * - Useful for preserving values
   * @returns A clone of this point
   * @see {@link Point.copyFrom} For copying into existing point
   * @see {@link Point.copyTo} For copying to existing point
   */
  clone() {
    return new Gt(this.x, this.y);
  }
  /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new Point()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link Point.copyTo} For copying to another point
   * @see {@link Point.clone} For creating new point copy
   */
  copyFrom(e) {
    return this.set(e.x, e.y), this;
  }
  /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.clone} For creating new point copy
   */
  copyTo(e) {
    return e.set(this.x, this.y), e;
  }
  /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new Point(100, 200);
   * const p2 = new Point(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new Point(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link Point.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new Point();
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   *
   * // Chain with other operations
   * point
   *     .set(10, 20)
   *     .copyTo(otherPoint);
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.equals} For comparing positions
   */
  set(e = 0, t = e) {
    return this.x = e, this.y = t, this;
  }
  toString() {
    return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
  }
  /**
   * A static Point object with `x` and `y` values of `0`.
   *
   * This shared instance is reset to zero values when accessed.
   *
   * > [!IMPORTANT] This point is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempPoint = Point.shared;
   * tempPoint.set(100, 200);
   * matrix.apply(tempPoint);
   *
   * // Will be reset to (0,0) on next access
   * const fresh = Point.shared; // x=0, y=0
   * ```
   * @readonly
   * @returns A fresh zeroed point for temporary use
   * @see {@link Point.constructor} For creating new points
   * @see {@link PointData} For basic point interface
   */
  static get shared() {
    return qm.x = 0, qm.y = 0, qm;
  }
}
const qm = new Gt();
class st {
  /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */
  constructor(e = 1, t = 0, i = 0, s = 1, o = 0, r = 0) {
    this.array = null, this.a = e, this.b = t, this.c = i, this.d = s, this.tx = o, this.ty = r;
  }
  /**
   * Creates a Matrix object based on the given array.
   * Populates matrix components from a flat array in column-major order.
   *
   * > [!NOTE] Array mapping order:
   * > ```
   * > array[0] = a  (x scale)
   * > array[1] = b  (y skew)
   * > array[2] = tx (x translation)
   * > array[3] = c  (x skew)
   * > array[4] = d  (y scale)
   * > array[5] = ty (y translation)
   * > ```
   * @example
   * ```ts
   * // Create matrix from array
   * const matrix = new Matrix();
   * matrix.fromArray([
   *     2, 0,  100,  // a, b, tx
   *     0, 2,  100   // c, d, ty
   * ]);
   *
   * // Create matrix from typed array
   * const float32Array = new Float32Array([
   *     1, 0, 0,     // Scale x1, no skew
   *     0, 1, 0      // No skew, scale x1
   * ]);
   * matrix.fromArray(float32Array);
   * ```
   * @param array - The array to populate the matrix from
   * @see {@link Matrix.toArray} For converting matrix to array
   * @see {@link Matrix.set} For setting values directly
   */
  fromArray(e) {
    this.a = e[0], this.b = e[1], this.c = e[3], this.d = e[4], this.tx = e[2], this.ty = e[5];
  }
  /**
   * Sets the matrix properties directly.
   * All matrix components can be set in one call.
   * @example
   * ```ts
   * // Set to identity matrix
   * matrix.set(1, 0, 0, 1, 0, 0);
   *
   * // Set to scale matrix
   * matrix.set(2, 0, 0, 2, 0, 0); // Scale 2x
   *
   * // Set to translation matrix
   * matrix.set(1, 0, 0, 1, 100, 50); // Move 100,50
   * ```
   * @param a - Scale on x axis
   * @param b - Shear on y axis
   * @param c - Shear on x axis
   * @param d - Scale on y axis
   * @param tx - Translation on x axis
   * @param ty - Translation on y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.fromArray} For setting from array
   */
  set(e, t, i, s, o, r) {
    return this.a = e, this.b = t, this.c = i, this.d = s, this.tx = o, this.ty = r, this;
  }
  /**
   * Creates an array from the current Matrix object.
   *
   * > [!NOTE] The array format is:
   * > ```
   * > Non-transposed:
   * > [a, c, tx,
   * > b, d, ty,
   * > 0, 0, 1]
   * >
   * > Transposed:
   * > [a, b, 0,
   * > c, d, 0,
   * > tx,ty,1]
   * > ```
   * @example
   * ```ts
   * // Basic array conversion
   * const matrix = new Matrix(2, 0, 0, 2, 100, 100);
   * const array = matrix.toArray();
   *
   * // Using existing array
   * const float32Array = new Float32Array(9);
   * matrix.toArray(false, float32Array);
   *
   * // Get transposed array
   * const transposed = matrix.toArray(true);
   * ```
   * @param transpose - Whether to transpose the matrix
   * @param out - Optional Float32Array to store the result
   * @returns The array containing the matrix values
   * @see {@link Matrix.fromArray} For creating matrix from array
   * @see {@link Matrix.array} For cached array storage
   */
  toArray(e, t) {
    this.array || (this.array = new Float32Array(9));
    const i = t || this.array;
    return e ? (i[0] = this.a, i[1] = this.b, i[2] = 0, i[3] = this.c, i[4] = this.d, i[5] = 0, i[6] = this.tx, i[7] = this.ty, i[8] = 1) : (i[0] = this.a, i[1] = this.c, i[2] = this.tx, i[3] = this.b, i[4] = this.d, i[5] = this.ty, i[6] = 0, i[7] = 0, i[8] = 1), i;
  }
  /**
   * Get a new position with the current transformation applied.
   *
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @example
   * ```ts
   * // Basic point transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const point = new Point(10, 20);
   * const transformed = matrix.apply(point);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.apply(point, output);
   * ```
   * @param pos - The origin point to transform
   * @param newPos - Optional point to store the result
   * @returns The transformed point
   * @see {@link Matrix.applyInverse} For inverse transformation
   * @see {@link Point} For point operations
   */
  apply(e, t) {
    t = t || new Gt();
    const i = e.x, s = e.y;
    return t.x = this.a * i + this.c * s + this.tx, t.y = this.b * i + this.d * s + this.ty, t;
  }
  /**
   * Get a new position with the inverse of the current transformation applied.
   *
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @example
   * ```ts
   * // Basic inverse transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const worldPoint = new Point(150, 100);
   * const localPoint = matrix.applyInverse(worldPoint);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.applyInverse(worldPoint, output);
   *
   * // Convert mouse position to local space
   * const mousePoint = new Point(mouseX, mouseY);
   * const localMouse = matrix.applyInverse(mousePoint);
   * ```
   * @param pos - The origin point to inverse-transform
   * @param newPos - Optional point to store the result
   * @returns The inverse-transformed point
   * @see {@link Matrix.apply} For forward transformation
   * @see {@link Matrix.invert} For getting inverse matrix
   */
  applyInverse(e, t) {
    t = t || new Gt();
    const i = this.a, s = this.b, o = this.c, r = this.d, a = this.tx, l = this.ty, d = 1 / (i * r + o * -s), c = e.x, u = e.y;
    return t.x = r * d * c + -o * d * u + (l * o - a * r) * d, t.y = i * d * u + -s * d * c + (-l * i + a * s) * d, t;
  }
  /**
   * Translates the matrix on the x and y axes.
   * Adds to the position values while preserving scale, rotation and skew.
   * @example
   * ```ts
   * // Basic translation
   * const matrix = new Matrix();
   * matrix.translate(100, 50); // Move right 100, down 50
   *
   * // Chain with other transformations
   * matrix
   *     .scale(2, 2)
   *     .translate(100, 0)
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - How much to translate on the x axis
   * @param y - How much to translate on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.set} For setting position directly
   * @see {@link Matrix.setTransform} For complete transform setup
   */
  translate(e, t) {
    return this.tx += e, this.ty += t, this;
  }
  /**
   * Applies a scale transformation to the matrix.
   * Multiplies the scale values with existing matrix components.
   * @example
   * ```ts
   * // Basic scaling
   * const matrix = new Matrix();
   * matrix.scale(2, 3); // Scale 2x horizontally, 3x vertically
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100)
   *     .scale(2, 2)     // Scales after translation
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting scale directly
   * @see {@link Matrix.append} For combining transformations
   */
  scale(e, t) {
    return this.a *= e, this.d *= t, this.c *= e, this.b *= t, this.tx *= e, this.ty *= t, this;
  }
  /**
   * Applies a rotation transformation to the matrix.
   *
   * Rotates around the origin (0,0) by the given angle in radians.
   * @example
   * ```ts
   * // Basic rotation
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // Rotate 45 degrees
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100) // Move to rotation center
   *     .rotate(Math.PI)     // Rotate 180 degrees
   *     .scale(2, 2);        // Scale after rotation
   *
   * // Common angles
   * matrix.rotate(Math.PI / 2);  // 90 degrees
   * matrix.rotate(Math.PI);      // 180 degrees
   * matrix.rotate(Math.PI * 2);  // 360 degrees
   * ```
   * @remarks
   * - Rotates around origin point (0,0)
   * - Affects position if translation was set
   * - Uses counter-clockwise rotation
   * - Order of operations matters when chaining
   * @param angle - The angle in radians
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting rotation directly
   * @see {@link Matrix.append} For combining transformations
   */
  rotate(e) {
    const t = Math.cos(e), i = Math.sin(e), s = this.a, o = this.c, r = this.tx;
    return this.a = s * t - this.b * i, this.b = s * i + this.b * t, this.c = o * t - this.d * i, this.d = o * i + this.d * t, this.tx = r * t - this.ty * i, this.ty = r * i + this.ty * t, this;
  }
  /**
   * Appends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = this * matrix
   * @example
   * ```ts
   * // Basic matrix combination
   * const matrix = new Matrix();
   * const other = new Matrix().translate(100, 0).rotate(Math.PI / 4);
   * matrix.append(other);
   * ```
   * @remarks
   * - Order matters: A.append(B) !== B.append(A)
   * - Modifies current matrix
   * - Preserves transformation order
   * - Commonly used for combining transforms
   * @param matrix - The matrix to append
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.prepend} For prepending transformations
   * @see {@link Matrix.appendFrom} For appending two external matrices
   */
  append(e) {
    const t = this.a, i = this.b, s = this.c, o = this.d;
    return this.a = e.a * t + e.b * s, this.b = e.a * i + e.b * o, this.c = e.c * t + e.d * s, this.d = e.c * i + e.d * o, this.tx = e.tx * t + e.ty * s + this.tx, this.ty = e.tx * i + e.ty * o + this.ty, this;
  }
  /**
   * Appends two matrices and sets the result to this matrix.
   * Performs matrix multiplication: this = A * B
   * @example
   * ```ts
   * // Basic matrix multiplication
   * const result = new Matrix();
   * const matrixA = new Matrix().scale(2, 2);
   * const matrixB = new Matrix().rotate(Math.PI / 4);
   * result.appendFrom(matrixA, matrixB);
   * ```
   * @remarks
   * - Order matters: A * B !== B * A
   * - Creates a new transformation from two others
   * - More efficient than append() for multiple operations
   * - Does not modify input matrices
   * @param a - The first matrix to multiply
   * @param b - The second matrix to multiply
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For single matrix combination
   * @see {@link Matrix.prepend} For reverse order multiplication
   */
  appendFrom(e, t) {
    const i = e.a, s = e.b, o = e.c, r = e.d, a = e.tx, l = e.ty, d = t.a, c = t.b, u = t.c, p = t.d;
    return this.a = i * d + s * u, this.b = i * c + s * p, this.c = o * d + r * u, this.d = o * c + r * p, this.tx = a * d + l * u + t.tx, this.ty = a * c + l * p + t.ty, this;
  }
  /**
   * Sets the matrix based on all the available properties.
   * Combines position, scale, rotation, skew and pivot in a single operation.
   * @example
   * ```ts
   * // Basic transform setup
   * const matrix = new Matrix();
   * matrix.setTransform(
   *     100, 100,    // position
   *     0, 0,        // pivot
   *     2, 2,        // scale
   *     Math.PI / 4, // rotation (45 degrees)
   *     0, 0         // skew
   * );
   * ```
   * @remarks
   * - Updates all matrix components at once
   * - More efficient than separate transform calls
   * - Uses radians for rotation and skew
   * - Pivot affects rotation center
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.decompose} For extracting transform properties
   * @see {@link TransformableObject} For transform data structure
   */
  setTransform(e, t, i, s, o, r, a, l, d) {
    return this.a = Math.cos(a + d) * o, this.b = Math.sin(a + d) * o, this.c = -Math.sin(a - l) * r, this.d = Math.cos(a - l) * r, this.tx = e - (i * this.a + s * this.c), this.ty = t - (i * this.b + s * this.d), this;
  }
  /**
   * Prepends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = matrix * this
   * @example
   * ```ts
   * // Basic matrix prepend
   * const matrix = new Matrix().scale(2, 2);
   * const other = new Matrix().translate(100, 0);
   * matrix.prepend(other); // Translation happens before scaling
   * ```
   * @remarks
   * - Order matters: A.prepend(B) !== B.prepend(A)
   * - Modifies current matrix
   * - Reverses transformation order compared to append()
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For appending transformations
   * @see {@link Matrix.appendFrom} For combining external matrices
   */
  prepend(e) {
    const t = this.tx;
    if (e.a !== 1 || e.b !== 0 || e.c !== 0 || e.d !== 1) {
      const i = this.a, s = this.c;
      this.a = i * e.a + this.b * e.c, this.b = i * e.b + this.b * e.d, this.c = s * e.a + this.d * e.c, this.d = s * e.b + this.d * e.d;
    }
    return this.tx = t * e.a + this.ty * e.c + e.tx, this.ty = t * e.b + this.ty * e.d + e.ty, this;
  }
  /**
   * Decomposes the matrix into its individual transform components.
   * Extracts position, scale, rotation and skew values from the matrix.
   * @example
   * ```ts
   * // Basic decomposition
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * const transform = {
   *     position: new Point(),
   *     scale: new Point(),
   *     pivot: new Point(),
   *     skew: new Point(),
   *     rotation: 0
   * };
   *
   * matrix.decompose(transform);
   * console.log(transform.position); // Point(100, 100)
   * console.log(transform.rotation); // ~0.785 (PI/4)
   * console.log(transform.scale); // Point(2, 2)
   * ```
   * @remarks
   * - Handles combined transformations
   * - Accounts for pivot points
   * - Chooses between rotation/skew based on transform type
   * - Uses radians for rotation and skew
   * @param transform - The transform object to store the decomposed values
   * @returns The transform with the newly applied properties
   * @see {@link Matrix.setTransform} For composing from components
   * @see {@link TransformableObject} For transform structure
   */
  decompose(e) {
    const t = this.a, i = this.b, s = this.c, o = this.d, r = e.pivot, a = -Math.atan2(-s, o), l = Math.atan2(i, t), d = Math.abs(a + l);
    let c = Math.sqrt(t * t + i * i);
    return d < 1e-5 || Math.abs(VV - d) < 1e-5 ? (e.rotation = l, e.skew.x = e.skew.y = 0) : Math.abs(Math.PI - d) < 1e-5 ? (e.rotation = l - Math.PI, e.skew.x = e.skew.y = 0, c = -c) : (e.rotation = 0, e.skew.x = a, e.skew.y = l), e.scale.x = c, e.scale.y = Math.sqrt(s * s + o * o), e.position.x = this.tx + (r.x * t + r.y * s), e.position.y = this.ty + (r.x * i + r.y * o), e;
  }
  /**
   * Inverts this matrix.
   * Creates the matrix that when multiplied with this matrix results in an identity matrix.
   * @example
   * ```ts
   * // Basic matrix inversion
   * const matrix = new Matrix()
   *     .translate(100, 50)
   *     .scale(2, 2);
   *
   * matrix.invert(); // Now transforms in opposite direction
   *
   * // Verify inversion
   * const point = new Point(50, 50);
   * const transformed = matrix.apply(point);
   * const original = matrix.invert().apply(transformed);
   * // original ≈ point
   * ```
   * @remarks
   * - Modifies the current matrix
   * - Useful for reversing transformations
   * - Cannot invert matrices with zero determinant
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.applyInverse} For inverse transformations
   */
  invert() {
    const e = this.a, t = this.b, i = this.c, s = this.d, o = this.tx, r = e * s - t * i;
    return this.a = s / r, this.b = -t / r, this.c = -i / r, this.d = e / r, this.tx = (i * this.ty - s * o) / r, this.ty = -(e * this.ty - t * o) / r, this;
  }
  /**
   * Checks if this matrix is an identity matrix.
   *
   * An identity matrix has no transformations applied (default state).
   * @example
   * ```ts
   * // Check if matrix is identity
   * const matrix = new Matrix();
   * console.log(matrix.isIdentity()); // true
   *
   * // Check after transformations
   * matrix.translate(100, 0);
   * console.log(matrix.isIdentity()); // false
   *
   * // Reset and verify
   * matrix.identity();
   * console.log(matrix.isIdentity()); // true
   * ```
   * @remarks
   * - Verifies a = 1, d = 1 (no scale)
   * - Verifies b = 0, c = 0 (no skew)
   * - Verifies tx = 0, ty = 0 (no translation)
   * @returns True if matrix has no transformations
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   */
  isIdentity() {
    return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
  }
  /**
   * Resets this Matrix to an identity (default) matrix.
   * Sets all components to their default values: scale=1, no skew, no translation.
   * @example
   * ```ts
   * // Reset transformed matrix
   * const matrix = new Matrix()
   *     .scale(2, 2)
   *     .rotate(Math.PI / 4);
   * matrix.identity(); // Back to default state
   *
   * // Chain after reset
   * matrix
   *     .identity()
   *     .translate(100, 100)
   *     .scale(2, 2);
   *
   * // Compare with identity constant
   * const isDefault = matrix.equals(Matrix.IDENTITY);
   * ```
   * @remarks
   * - Sets a=1, d=1 (default scale)
   * - Sets b=0, c=0 (no skew)
   * - Sets tx=0, ty=0 (no translation)
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   * @see {@link Matrix.isIdentity} For checking identity state
   */
  identity() {
    return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */
  clone() {
    const e = new st();
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @param matrix
   * @example
   * ```ts
   * // Basic matrix cloning
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const copy = matrix.clone();
   *
   * // Clone and modify
   * const modified = matrix.clone()
   *     .scale(2, 2);
   *
   * // Compare matrices
   * console.log(matrix.equals(copy));     // true
   * console.log(matrix.equals(modified)); // false
   * ```
   * @returns A copy of this matrix. Good for chaining method calls.
   * @see {@link Matrix.copyTo} For copying to existing matrix
   * @see {@link Matrix.copyFrom} For copying from another matrix
   */
  copyTo(e) {
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Changes the values of the matrix to be the same as the ones in given matrix.
   * @example
   * ```ts
   * // Basic matrix copying
   * const source = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const target = new Matrix();
   * target.copyFrom(source);
   * ```
   * @param matrix - The matrix to copy from
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.clone} For creating new matrix copy
   * @see {@link Matrix.copyTo} For copying to another matrix
   */
  copyFrom(e) {
    return this.a = e.a, this.b = e.b, this.c = e.c, this.d = e.d, this.tx = e.tx, this.ty = e.ty, this;
  }
  /**
   * Checks if this matrix equals another matrix.
   * Compares all components for exact equality.
   * @example
   * ```ts
   * // Basic equality check
   * const m1 = new Matrix();
   * const m2 = new Matrix();
   * console.log(m1.equals(m2)); // true
   *
   * // Compare transformed matrices
   * const transform = new Matrix()
   *     .translate(100, 100)
   * const clone = new Matrix()
   *     .scale(2, 2);
   * console.log(transform.equals(clone)); // false
   * ```
   * @param matrix - The matrix to compare to
   * @returns True if matrices are identical
   * @see {@link Matrix.copyFrom} For copying matrix values
   * @see {@link Matrix.isIdentity} For identity comparison
   */
  equals(e) {
    return e.a === this.a && e.b === this.b && e.c === this.c && e.d === this.d && e.tx === this.tx && e.ty === this.ty;
  }
  toString() {
    return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
  }
  /**
   * A default (identity) matrix with no transformations applied.
   *
   * > [!IMPORTANT] This is a shared read-only object. Create a new Matrix if you need to modify it.
   * @example
   * ```ts
   * // Get identity matrix reference
   * const identity = Matrix.IDENTITY;
   * console.log(identity.isIdentity()); // true
   *
   * // Compare with identity
   * const matrix = new Matrix();
   * console.log(matrix.equals(Matrix.IDENTITY)); // true
   *
   * // Create new matrix instead of modifying IDENTITY
   * const transform = new Matrix()
   *     .copyFrom(Matrix.IDENTITY)
   *     .translate(100, 100);
   * ```
   * @readonly
   * @returns A read-only identity matrix
   * @see {@link Matrix.shared} For temporary calculations
   * @see {@link Matrix.identity} For resetting matrices
   */
  static get IDENTITY() {
    return YV.identity();
  }
  /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   *
   * > [!IMPORTANT] This matrix is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempMatrix = Matrix.shared;
   * tempMatrix.translate(100, 100).rotate(Math.PI / 4);
   * const point = tempMatrix.apply({ x: 10, y: 20 });
   *
   * // Will be reset to identity on next access
   * const fresh = Matrix.shared; // Back to identity
   * ```
   * @remarks
   * - Always returns identity matrix
   * - Safe to modify temporarily
   * - Not safe to store references
   * - Useful for one-off calculations
   * @readonly
   * @returns A fresh identity matrix for temporary use
   * @see {@link Matrix.IDENTITY} For immutable identity matrix
   * @see {@link Matrix.identity} For resetting matrices
   */
  static get shared() {
    return KV.identity();
  }
}
const KV = new st(), YV = new st(), gr = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1], br = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1], vr = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1], yr = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1], fv = [], _8 = [], Cu = Math.sign;
function XV() {
  for (let n = 0; n < 16; n++) {
    const e = [];
    fv.push(e);
    for (let t = 0; t < 16; t++) {
      const i = Cu(gr[n] * gr[t] + vr[n] * br[t]), s = Cu(br[n] * gr[t] + yr[n] * br[t]), o = Cu(gr[n] * vr[t] + vr[n] * yr[t]), r = Cu(br[n] * vr[t] + yr[n] * yr[t]);
      for (let a = 0; a < 16; a++)
        if (gr[a] === i && br[a] === s && vr[a] === o && yr[a] === r) {
          e.push(a);
          break;
        }
    }
  }
  for (let n = 0; n < 16; n++) {
    const e = new st();
    e.set(gr[n], br[n], vr[n], yr[n], 0, 0), _8.push(e);
  }
}
XV();
const wt = {
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  E: 0,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  SE: 1,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  S: 2,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  SW: 3,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  W: 4,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  NW: 5,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  N: 6,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  NE: 7,
  /**
   * Reflection about Y-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MIRROR_VERTICAL: 8,
  /**
   * Reflection about the main diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MAIN_DIAGONAL: 10,
  /**
   * Reflection about X-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MIRROR_HORIZONTAL: 12,
  /**
   * Reflection about reverse diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  REVERSE_DIAGONAL: 14,
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */
  uX: (n) => gr[n],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */
  uY: (n) => br[n],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */
  vX: (n) => vr[n],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */
  vY: (n) => yr[n],
  /**
   * @group groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */
  inv: (n) => n & 8 ? n & 15 : -n & 7,
  /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */
  add: (n, e) => fv[n][e],
  /**
   * Reverse of `add`.
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */
  sub: (n, e) => fv[n][wt.inv(e)],
  /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @group groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */
  rotate180: (n) => n ^ 4,
  /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @group groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */
  isVertical: (n) => (n & 3) === 2,
  // rotation % 4 === 2
  /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @group groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */
  byDirection: (n, e) => Math.abs(n) * 2 <= Math.abs(e) ? e >= 0 ? wt.S : wt.N : Math.abs(e) * 2 <= Math.abs(n) ? n > 0 ? wt.E : wt.W : e > 0 ? n > 0 ? wt.SE : wt.SW : n > 0 ? wt.NE : wt.NW,
  /**
   * Helps sprite to compensate texture packer rotation.
   * @group groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   * @param {number} dw - sprite width
   * @param {number} dh - sprite height
   */
  matrixAppendRotationInv: (n, e, t = 0, i = 0, s = 0, o = 0) => {
    const r = _8[wt.inv(e)], a = r.a, l = r.b, d = r.c, c = r.d, u = t - Math.min(0, a * s, d * o, a * s + d * o), p = i - Math.min(0, l * s, c * o, l * s + c * o), f = n.a, y = n.b, b = n.c, w = n.d;
    n.a = a * f + l * b, n.b = a * y + l * w, n.c = d * f + c * b, n.d = d * y + c * w, n.tx = u * f + p * b + n.tx, n.ty = u * y + p * w + n.ty;
  },
  /**
   * Transforms rectangle coordinates based on texture packer rotation.
   * Used when texture atlas pages are rotated and coordinates need to be adjusted.
   * @group groupD8
   * @param {RectangleLike} rect - Rectangle with original coordinates to transform
   * @param {RectangleLike} sourceFrame - Source texture frame (includes offset and dimensions)
   * @param {GD8Symmetry} rotation - The groupD8 rotation value
   * @param {Rectangle} out - Rectangle to store the result
   * @returns {Rectangle} Transformed coordinates (includes source frame offset)
   */
  transformRectCoords: (n, e, t, i) => {
    const { x: s, y: o, width: r, height: a } = n, { x: l, y: d, width: c, height: u } = e;
    return t === wt.E ? (i.set(s + l, o + d, r, a), i) : t === wt.S ? i.set(
      c - o - a + l,
      s + d,
      a,
      r
    ) : t === wt.W ? i.set(
      c - s - r + l,
      u - o - a + d,
      r,
      a
    ) : t === wt.N ? i.set(
      o + l,
      u - s - r + d,
      a,
      r
    ) : i.set(s + l, o + d, r, a);
  }
}, Iu = [new Gt(), new Gt(), new Gt(), new Gt()];
class _t {
  /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */
  constructor(e = 0, t = 0, i = 0, s = 0) {
    this.type = "rectangle", this.x = Number(e), this.y = Number(t), this.width = Number(i), this.height = Number(s);
  }
  /**
   * Returns the left edge (x-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get left edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.left); // 100
   *
   * // Use in alignment calculations
   * sprite.x = rect.left + padding;
   *
   * // Compare positions
   * if (point.x > rect.left) {
   *     console.log('Point is right of rectangle');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the left edge
   * @see {@link Rectangle.right} For right edge position
   * @see {@link Rectangle.x} For direct x-coordinate access
   */
  get left() {
    return this.x;
  }
  /**
   * Returns the right edge (x + width) of the rectangle.
   * @example
   * ```ts
   * // Get right edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.right); // 300
   *
   * // Align to right edge
   * sprite.x = rect.right - sprite.width;
   *
   * // Check boundaries
   * if (point.x < rect.right) {
   *     console.log('Point is inside right bound');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the right edge
   * @see {@link Rectangle.left} For left edge position
   * @see {@link Rectangle.width} For width value
   */
  get right() {
    return this.x + this.width;
  }
  /**
   * Returns the top edge (y-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get top edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.top); // 100
   *
   * // Position above rectangle
   * sprite.y = rect.top - sprite.height;
   *
   * // Check vertical position
   * if (point.y > rect.top) {
   *     console.log('Point is below top edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the top edge
   * @see {@link Rectangle.bottom} For bottom edge position
   * @see {@link Rectangle.y} For direct y-coordinate access
   */
  get top() {
    return this.y;
  }
  /**
   * Returns the bottom edge (y + height) of the rectangle.
   * @example
   * ```ts
   * // Get bottom edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.bottom); // 250
   *
   * // Stack below rectangle
   * sprite.y = rect.bottom + margin;
   *
   * // Check vertical bounds
   * if (point.y < rect.bottom) {
   *     console.log('Point is above bottom edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the bottom edge
   * @see {@link Rectangle.top} For top edge position
   * @see {@link Rectangle.height} For height value
   */
  get bottom() {
    return this.y + this.height;
  }
  /**
   * Determines whether the Rectangle is empty (has no area).
   * @example
   * ```ts
   * // Check zero dimensions
   * const rect = new Rectangle(100, 100, 0, 50);
   * console.log(rect.isEmpty()); // true
   * ```
   * @returns True if the rectangle has no area
   * @see {@link Rectangle.width} For width value
   * @see {@link Rectangle.height} For height value
   */
  isEmpty() {
    return this.left === this.right || this.top === this.bottom;
  }
  /**
   * A constant empty rectangle. This is a new object every time the property is accessed.
   * @example
   * ```ts
   * // Get fresh empty rectangle
   * const empty = Rectangle.EMPTY;
   * console.log(empty.isEmpty()); // true
   * ```
   * @returns A new empty rectangle instance
   * @see {@link Rectangle.isEmpty} For empty state testing
   */
  static get EMPTY() {
    return new _t(0, 0, 0, 0);
  }
  /**
   * Creates a clone of this Rectangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Rectangle(100, 100, 200, 150);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.width *= 2;
   * modified.height += 50;
   *
   * // Verify independence
   * console.log(original.width);  // 200
   * console.log(modified.width);  // 400
   * ```
   * @returns A copy of the rectangle
   * @see {@link Rectangle.copyFrom} For copying into existing rectangle
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   */
  clone() {
    return new _t(this.x, this.y, this.width, this.height);
  }
  /**
   * Converts a Bounds object to a Rectangle object.
   * @example
   * ```ts
   * // Convert bounds to rectangle
   * const bounds = container.getBounds();
   * const rect = new Rectangle().copyFromBounds(bounds);
   * ```
   * @param bounds - The bounds to copy and convert to a rectangle
   * @returns Returns itself
   * @see {@link Bounds} For bounds object structure
   * @see {@link Rectangle.getBounds} For getting rectangle bounds
   */
  copyFromBounds(e) {
    return this.x = e.minX, this.y = e.minY, this.width = e.maxX - e.minX, this.height = e.maxY - e.minY, this;
  }
  /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new Rectangle()
   *     .copyFrom(source)
   *     .pad(10);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this;
  }
  /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Rectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isInside = rect.contains(150, 125); // true
   * // Check edge cases
   * console.log(rect.contains(100, 100)); // true (on edge)
   * console.log(rect.contains(300, 250)); // false (outside)
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   * @see {@link Rectangle.containsRect} For rectangle containment
   * @see {@link Rectangle.strokeContains} For checking stroke intersection
   */
  contains(e, t) {
    return this.width <= 0 || this.height <= 0 ? !1 : e >= this.x && e < this.x + this.width && t >= this.y && t < this.y + this.height;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link Rectangle.contains} For checking fill containment
   * @see {@link Rectangle.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    const { width: o, height: r } = this;
    if (o <= 0 || r <= 0) return !1;
    const a = this.x, l = this.y, d = i * (1 - s), c = i - d, u = a - d, p = a + o + d, f = l - d, y = l + r + d, b = a + c, w = a + o - c, k = l + c, S = l + r - c;
    return e >= u && e <= p && t >= f && t <= y && !(e > b && e < w && t > k && t < S);
  }
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   *
   * Returns true only if the area of the intersection is greater than 0.
   * This means that rectangles sharing only a side are not considered intersecting.
   * @example
   * ```ts
   * // Basic intersection check
   * const rect1 = new Rectangle(0, 0, 100, 100);
   * const rect2 = new Rectangle(50, 50, 100, 100);
   * console.log(rect1.intersects(rect2)); // true
   *
   * // With transformation matrix
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // 45 degrees
   * console.log(rect1.intersects(rect2, matrix)); // Checks with rotation
   *
   * // Edge cases
   * const zeroWidth = new Rectangle(0, 0, 0, 100);
   * console.log(rect1.intersects(zeroWidth)); // false (no area)
   * ```
   * @remarks
   * - Returns true only if intersection area is > 0
   * - Rectangles sharing only a side are not intersecting
   * - Zero-area rectangles cannot intersect anything
   * - Supports optional transformation matrix
   * @param other - The Rectangle to intersect with `this`
   * @param transform - Optional transformation matrix of `other`
   * @returns True if the transformed `other` Rectangle intersects with `this`
   * @see {@link Rectangle.containsRect} For containment testing
   * @see {@link Rectangle.contains} For point testing
   */
  intersects(e, t) {
    if (!t) {
      const P = this.x < e.x ? e.x : this.x;
      if ((this.right > e.right ? e.right : this.right) <= P)
        return !1;
      const $ = this.y < e.y ? e.y : this.y;
      return (this.bottom > e.bottom ? e.bottom : this.bottom) > $;
    }
    const i = this.left, s = this.right, o = this.top, r = this.bottom;
    if (s <= i || r <= o)
      return !1;
    const a = Iu[0].set(e.left, e.top), l = Iu[1].set(e.left, e.bottom), d = Iu[2].set(e.right, e.top), c = Iu[3].set(e.right, e.bottom);
    if (d.x <= a.x || l.y <= a.y)
      return !1;
    const u = Math.sign(t.a * t.d - t.b * t.c);
    if (u === 0 || (t.apply(a, a), t.apply(l, l), t.apply(d, d), t.apply(c, c), Math.max(a.x, l.x, d.x, c.x) <= i || Math.min(a.x, l.x, d.x, c.x) >= s || Math.max(a.y, l.y, d.y, c.y) <= o || Math.min(a.y, l.y, d.y, c.y) >= r))
      return !1;
    const p = u * (l.y - a.y), f = u * (a.x - l.x), y = p * i + f * o, b = p * s + f * o, w = p * i + f * r, k = p * s + f * r;
    if (Math.max(y, b, w, k) <= p * a.x + f * a.y || Math.min(y, b, w, k) >= p * c.x + f * c.y)
      return !1;
    const S = u * (a.y - d.y), _ = u * (d.x - a.x), x = S * i + _ * o, T = S * s + _ * o, M = S * i + _ * r, z = S * s + _ * r;
    return !(Math.max(x, T, M, z) <= S * a.x + _ * a.y || Math.min(x, T, M, z) >= S * c.x + _ * c.y);
  }
  /**
   * Pads the rectangle making it grow in all directions.
   *
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * // Basic padding
   * const rect = new Rectangle(100, 100, 200, 150);
   * rect.pad(10); // Adds 10px padding on all sides
   *
   * // Different horizontal and vertical padding
   * const uiRect = new Rectangle(0, 0, 100, 50);
   * uiRect.pad(20, 10); // 20px horizontal, 10px vertical
   * ```
   * @remarks
   * - Adjusts x/y by subtracting padding
   * - Increases width/height by padding * 2
   * - Common in UI layout calculations
   * - Chainable with other methods
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   */
  pad(e = 0, t = e) {
    return this.x -= e, this.y -= t, this.width += e * 2, this.height += t * 2, this;
  }
  /**
   * Fits this rectangle around the passed one.
   * @example
   * ```ts
   * // Basic fitting
   * const container = new Rectangle(0, 0, 100, 100);
   * const content = new Rectangle(25, 25, 200, 200);
   * content.fit(container); // Clips to container bounds
   * ```
   * @param rectangle - The rectangle to fit around
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */
  fit(e) {
    const t = Math.max(this.x, e.x), i = Math.min(this.x + this.width, e.x + e.width), s = Math.max(this.y, e.y), o = Math.min(this.y + this.height, e.y + e.height);
    return this.x = t, this.width = Math.max(i - t, 0), this.y = s, this.height = Math.max(o - s, 0), this;
  }
  /**
   * Enlarges rectangle so that its corners lie on a grid defined by resolution.
   * @example
   * ```ts
   * // Basic grid alignment
   * const rect = new Rectangle(10.2, 10.6, 100.8, 100.4);
   * rect.ceil(); // Aligns to whole pixels
   *
   * // Custom resolution grid
   * const uiRect = new Rectangle(5.3, 5.7, 50.2, 50.8);
   * uiRect.ceil(0.5); // Aligns to half pixels
   *
   * // Use with precision value
   * const preciseRect = new Rectangle(20.001, 20.999, 100.001, 100.999);
   * preciseRect.ceil(1, 0.01); // Handles small decimal variations
   * ```
   * @param resolution - The grid size to align to (1 = whole pixels)
   * @param eps - Small number to prevent floating point errors
   * @returns Returns itself
   * @see {@link Rectangle.fit} For constraining to bounds
   * @see {@link Rectangle.enlarge} For growing dimensions
   */
  ceil(e = 1, t = 1e-3) {
    const i = Math.ceil((this.x + this.width - t) * e) / e, s = Math.ceil((this.y + this.height - t) * e) / e;
    return this.x = Math.floor((this.x + t) * e) / e, this.y = Math.floor((this.y + t) * e) / e, this.width = i - this.x, this.height = s - this.y, this;
  }
  /**
   * Scales the rectangle's dimensions and position by the specified factors.
   * @example
   * ```ts
   * const rect = new Rectangle(50, 50, 100, 100);
   *
   * // Scale uniformly
   * rect.scale(0.5, 0.5);
   * // rect is now: x=25, y=25, width=50, height=50
   *
   * // non-uniformly
   * rect.scale(0.5, 1);
   * // rect is now: x=25, y=50, width=50, height=100
   * ```
   * @param x - The factor by which to scale the horizontal properties (x, width).
   * @param y - The factor by which to scale the vertical properties (y, height).
   * @returns Returns itself
   */
  scale(e, t = e) {
    return this.x *= e, this.y *= t, this.width *= e, this.height *= t, this;
  }
  /**
   * Enlarges this rectangle to include the passed rectangle.
   * @example
   * ```ts
   * // Basic enlargement
   * const rect = new Rectangle(50, 50, 100, 100);
   * const other = new Rectangle(0, 0, 200, 75);
   * rect.enlarge(other);
   * // rect is now: x=0, y=0, width=200, height=150
   *
   * // Use for bounding box calculation
   * const bounds = new Rectangle();
   * objects.forEach((obj) => {
   *     bounds.enlarge(obj.getBounds());
   * });
   * ```
   * @param rectangle - The rectangle to include
   * @returns Returns itself
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */
  enlarge(e) {
    const t = Math.min(this.x, e.x), i = Math.max(this.x + this.width, e.x + e.width), s = Math.min(this.y, e.y), o = Math.max(this.y + this.height, e.y + e.height);
    return this.x = t, this.width = i - t, this.y = s, this.height = o - s, this;
  }
  /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds retrieval
   * const rect = new Rectangle(100, 100, 200, 150);
   * const bounds = rect.getBounds();
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle.copyFrom} For direct copying
   * @see {@link Rectangle.clone} For creating new copy
   */
  getBounds(e) {
    return e || (e = new _t()), e.copyFrom(this), e;
  }
  /**
   * Determines whether another Rectangle is fully contained within this Rectangle.
   *
   * Rectangles that occupy the same space are considered to be containing each other.
   *
   * Rectangles without area (width or height equal to zero) can't contain anything,
   * not even other arealess rectangles.
   * @example
   * ```ts
   * // Check if one rectangle contains another
   * const container = new Rectangle(0, 0, 100, 100);
   * const inner = new Rectangle(25, 25, 50, 50);
   *
   * console.log(container.containsRect(inner)); // true
   *
   * // Check overlapping rectangles
   * const partial = new Rectangle(75, 75, 50, 50);
   * console.log(container.containsRect(partial)); // false
   *
   * // Zero-area rectangles can't contain anything
   * const empty = new Rectangle(0, 0, 0, 100);
   * console.log(empty.containsRect(inner)); // false
   * ```
   * @param other - The Rectangle to check for containment
   * @returns True if other is fully contained within this Rectangle
   * @see {@link Rectangle.contains} For point containment
   * @see {@link Rectangle.intersects} For overlap testing
   */
  containsRect(e) {
    if (this.width <= 0 || this.height <= 0) return !1;
    const t = e.x, i = e.y, s = e.x + e.width, o = e.y + e.height;
    return t >= this.x && t < this.x + this.width && i >= this.y && i < this.y + this.height && s >= this.x && s <= this.x + this.width && o >= this.y && o <= this.y + this.height;
  }
  /**
   * Sets the position and dimensions of the rectangle.
   * @example
   * ```ts
   * // Basic usage
   * const rect = new Rectangle();
   * rect.set(100, 100, 200, 150);
   *
   * // Chain with other operations
   * const bounds = new Rectangle()
   *     .set(0, 0, 100, 100)
   *     .pad(10);
   * ```
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   * @returns Returns itself for method chaining
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating a new copy
   */
  set(e, t, i, s) {
    return this.x = e, this.y = t, this.width = i, this.height = s, this;
  }
  toString() {
    return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
  }
}
const Km = {
  default: -1
};
function Lt(n = "default") {
  return Km[n] === void 0 && (Km[n] = -1), ++Km[n];
}
const Rw = /* @__PURE__ */ new Set(), on = "8.0.0", JV = "8.3.4", zs = "8.21.0", ZV = "8.22.0", ja = {
  quiet: !1,
  noColor: !1
}, rt = ((n, e, t = 3) => {
  if (ja.quiet || Rw.has(e)) return;
  let i = new Error().stack;
  const s = `${e}
Deprecated since v${n}`, o = typeof console.groupCollapsed == "function" && !ja.noColor;
  typeof i == "undefined" ? console.warn("PixiJS Deprecation Warning: ", s) : (i = i.split(`
`).splice(t).join(`
`), o ? (console.groupCollapsed(
    "%cPixiJS Deprecation Warning: %c%s",
    "color:#614108;background:#fffbe6",
    "font-weight:normal;color:#614108;background:#fffbe6",
    s
  ), console.warn(i), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", s), console.warn(i))), Rw.add(e);
});
Object.defineProperties(rt, {
  quiet: {
    get: () => ja.quiet,
    set: (n) => {
      ja.quiet = n;
    },
    enumerable: !0,
    configurable: !1
  },
  noColor: {
    get: () => ja.noColor,
    set: (n) => {
      ja.noColor = n;
    },
    enumerable: !0,
    configurable: !1
  }
});
const S8 = () => {
};
function mv(n) {
  return n.endsWith("int");
}
function Lp(n) {
  return n += n === 0 ? 1 : 0, --n, n |= n >>> 1, n |= n >>> 2, n |= n >>> 4, n |= n >>> 8, n |= n >>> 16, n + 1;
}
function ml(n) {
  return !(n & n - 1) && !!n;
}
function T8(n) {
  const e = {};
  for (const t in n)
    n[t] !== void 0 && (e[t] = n[t]);
  return e;
}
const zw = /* @__PURE__ */ Object.create(null);
function QV(n) {
  const e = zw[n];
  return e === void 0 && (zw[n] = Lt("resource")), e;
}
const M8 = class C8 extends di {
  /**
   * @param options - options for the style
   */
  constructor(e = {}) {
    var t, i, s, o, r, a, l;
    super(), this._resourceType = "textureSampler", this._maxAnisotropy = 1, this.destroyed = !1, e = { ...C8.defaultOptions, ...e }, this.addressMode = e.addressMode, this.addressModeU = (t = e.addressModeU) != null ? t : this.addressModeU, this.addressModeV = (i = e.addressModeV) != null ? i : this.addressModeV, this.addressModeW = (s = e.addressModeW) != null ? s : this.addressModeW, this.scaleMode = e.scaleMode, this.magFilter = (o = e.magFilter) != null ? o : this.magFilter, this.minFilter = (r = e.minFilter) != null ? r : this.minFilter, this.mipmapFilter = (a = e.mipmapFilter) != null ? a : this.mipmapFilter, this.lodMinClamp = e.lodMinClamp, this.lodMaxClamp = e.lodMaxClamp, this.compare = e.compare, this.maxAnisotropy = (l = e.maxAnisotropy) != null ? l : 1;
  }
  set addressMode(e) {
    this.addressModeU = e, this.addressModeV = e, this.addressModeW = e;
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this.addressModeU;
  }
  set wrapMode(e) {
    rt(on, "TextureStyle.wrapMode is now TextureStyle.addressMode"), this.addressMode = e;
  }
  get wrapMode() {
    return this.addressMode;
  }
  set scaleMode(e) {
    this.magFilter = e, this.minFilter = e, this.mipmapFilter = e;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this.magFilter;
  }
  /** Specifies the maximum anisotropy value clamp used by the sampler. */
  set maxAnisotropy(e) {
    this._maxAnisotropy = Math.min(e, 16), this._maxAnisotropy > 1 && (this.scaleMode = "linear");
  }
  get maxAnisotropy() {
    return this._maxAnisotropy;
  }
  // TODO - move this to WebGL?
  get _resourceId() {
    return this._sharedResourceId || this._generateResourceId();
  }
  update() {
    this._sharedResourceId = null, this.emit("change", this);
  }
  _generateResourceId() {
    const e = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
    return this._sharedResourceId = QV(e), this._resourceId;
  }
  /** Destroys the style */
  destroy() {
    this.destroyed = !0, this.emit("destroy", this), this.emit("change", this), this.removeAllListeners();
  }
};
M8.defaultOptions = {
  addressMode: "clamp-to-edge",
  scaleMode: "linear"
};
let Yh = M8;
const I8 = class A8 extends di {
  /**
   * @param options - options for creating a new TextureSource
   */
  constructor(e = {}) {
    var o, r, a, l, d, c;
    super(), this.options = e, this._gpuData = /* @__PURE__ */ Object.create(null), this._gcLastUsed = -1, this.uid = Lt("textureSource"), this._resourceType = "textureSource", this._resourceId = Lt("resource"), this.uploadMethodId = "unknown", this._resolution = 1, this.pixelWidth = 1, this.pixelHeight = 1, this.width = 1, this.height = 1, this.sampleCount = 1, this.mipLevelCount = 1, this.autoGenerateMipmaps = !1, this.format = "rgba8unorm", this.dimension = "2d", this.viewDimension = "2d", this.arrayLayerCount = 1, this.depth = 1, this._ownsStyle = !1, this.antialias = !1, this.transient = !1, this.storage = !1, this._batchTick = -1, this._textureBindLocation = -1;
    const t = e;
    e = { ...A8.defaultOptions, ...e };
    const i = eW(e), s = i === "3d" || i === "1d" ? i : "2d";
    tW(t, i, s), this.label = (o = e.label) != null ? o : "", this.resource = e.resource, this.autoGarbageCollect = e.autoGarbageCollect, this._resolution = e.resolution, e.width ? this.pixelWidth = e.width * this._resolution : this.pixelWidth = this.resource && (r = this.resourceWidth) != null ? r : 1, e.height ? this.pixelHeight = e.height * this._resolution : this.pixelHeight = this.resource && (a = this.resourceHeight) != null ? a : 1, this.width = this.pixelWidth / this._resolution, this.height = this.pixelHeight / this._resolution, this.format = e.format, this.dimension = s, this.viewDimension = i, this.arrayLayerCount = e.arrayLayerCount, this.depth = s === "3d" && (l = e.depth) != null ? l : 1, this.mipLevelCount = e.mipLevelCount, this.autoGenerateMipmaps = e.autoGenerateMipmaps, this.sampleCount = e.sampleCount, this.antialias = s === "3d" ? !1 : e.antialias, this.transient = (d = e.transient) != null ? d : !1, this.storage = (c = e.storage) != null ? c : !1, this.alphaMode = e.alphaMode, this.style = new Yh(T8(e)), this._ownsStyle = !0, this.destroyed = !1, this._refreshPOT();
  }
  /**
   * The size along z that the GPU allocates: {@link TextureSource#depth} for a 3D texture,
   * {@link TextureSource#arrayLayerCount} otherwise. WebGPU's `depthOrArrayLayers`.
   */
  get depthOrArrayLayers() {
    return this.dimension === "3d" ? this.depth : this.arrayLayerCount || 1;
  }
  /** returns itself */
  get source() {
    return this;
  }
  /** the style of the texture */
  get style() {
    return this._style;
  }
  set style(e) {
    var t, i;
    this.style !== e && (this._ownsStyle = !1, (t = this._style) == null || t.off("change", this._onStyleChange, this), this._style = e, (i = this._style) == null || i.on("change", this._onStyleChange, this), this._onStyleChange());
  }
  /** Specifies the maximum anisotropy value clamp used by the sampler. */
  set maxAnisotropy(e) {
    this._style.maxAnisotropy = e;
  }
  get maxAnisotropy() {
    return this._style.maxAnisotropy;
  }
  /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this._style.addressMode;
  }
  set addressMode(e) {
    this._style.addressMode = e;
  }
  /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */
  get repeatMode() {
    return this._style.addressMode;
  }
  set repeatMode(e) {
    this._style.addressMode = e;
  }
  /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */
  get magFilter() {
    return this._style.magFilter;
  }
  set magFilter(e) {
    this._style.magFilter = e;
  }
  /** Specifies the sampling behavior when the sample footprint is larger than one texel. */
  get minFilter() {
    return this._style.minFilter;
  }
  set minFilter(e) {
    this._style.minFilter = e;
  }
  /** Specifies behavior for sampling between mipmap levels. */
  get mipmapFilter() {
    return this._style.mipmapFilter;
  }
  set mipmapFilter(e) {
    this._style.mipmapFilter = e;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMinClamp() {
    return this._style.lodMinClamp;
  }
  set lodMinClamp(e) {
    this._style.lodMinClamp = e;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMaxClamp() {
    return this._style.lodMaxClamp;
  }
  set lodMaxClamp(e) {
    this._style.lodMaxClamp = e;
  }
  _onStyleChange() {
    this.emit("styleChange", this);
  }
  /** call this if you have modified the texture outside of the constructor */
  update() {
    if (this.resource) {
      const e = this._resolution;
      if (this.resize(this.resourceWidth / e, this.resourceHeight / e)) return;
    }
    this.emit("update", this);
  }
  /** Destroys this texture source */
  destroy() {
    this.destroyed = !0, this.unload(), this.emit("destroy", this), this._style && (this._ownsStyle && this._style.destroy(), this._style = null), this.uploadMethodId = null, this.resource = null, this.removeAllListeners();
  }
  /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */
  unload() {
    var e, t;
    this._resourceId = Lt("resource"), this.emit("change", this), this.emit("unload", this);
    for (const i in this._gpuData)
      (t = (e = this._gpuData[i]) == null ? void 0 : e.destroy) == null || t.call(e);
    this._gpuData = /* @__PURE__ */ Object.create(null);
  }
  /** the width of the resource. This is the REAL pure number, not accounting resolution   */
  get resourceWidth() {
    const { resource: e } = this;
    return e.naturalWidth || e.videoWidth || e.displayWidth || e.width;
  }
  /** the height of the resource. This is the REAL pure number, not accounting resolution */
  get resourceHeight() {
    const { resource: e } = this;
    return e.naturalHeight || e.videoHeight || e.displayHeight || e.height;
  }
  /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(e) {
    this._resolution !== e && (this._resolution = e, this.width = this.pixelWidth / e, this.height = this.pixelHeight / e);
  }
  /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */
  resize(e, t, i) {
    i || (i = this._resolution), e || (e = this.width), t || (t = this.height);
    const s = Math.round(e * i), o = Math.round(t * i);
    return this.width = s / i, this.height = o / i, this._resolution = i, this.pixelWidth === s && this.pixelHeight === o ? !1 : (this._refreshPOT(), this.pixelWidth = s, this.pixelHeight = o, this.emit("resize", this), this._resourceId = Lt("resource"), this.emit("change", this), !0);
  }
  /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */
  updateMipmaps() {
    this.autoGenerateMipmaps && this.mipLevelCount > 1 && this.emit("updateMipmaps", this);
  }
  set wrapMode(e) {
    this._style.wrapMode = e;
  }
  get wrapMode() {
    return this._style.wrapMode;
  }
  set scaleMode(e) {
    this._style.scaleMode = e;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this._style.scaleMode;
  }
  /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */
  _refreshPOT() {
    this.isPowerOfTwo = ml(this.pixelWidth) && ml(this.pixelHeight);
  }
  static test(e) {
    throw new Error("Unimplemented");
  }
};
I8.defaultOptions = {
  resolution: 1,
  format: "bgra8unorm",
  alphaMode: "premultiply-alpha-on-upload",
  arrayLayerCount: 1,
  mipLevelCount: 1,
  autoGenerateMipmaps: !1,
  sampleCount: 1,
  antialias: !1,
  autoGarbageCollect: !1
};
let an = I8;
function eW(n) {
  return n.viewDimension ? n.viewDimension : n.depth ? "3d" : n.arrayLayerCount > 1 ? "2d-array" : "2d";
}
function tW(n, e, t) {
  if (n.depth !== void 0 && typeof n.depth != "number")
    throw new Error(`[TextureSource] depth is a 3D texture's depth in texels, but got ${n.depth}. For a depth buffer, use the depth option of a RenderTarget or the renderer.`);
  if (n.depth && n.arrayLayerCount > 1)
    throw new Error("[TextureSource] depth and arrayLayerCount can't be combined: use depth for a 3D texture or arrayLayerCount for a 2D array.");
  if (n.depth && e !== "3d")
    throw new Error(`[TextureSource] depth makes a 3D texture, but viewDimension is '${e}'. Use arrayLayerCount for layered textures.`);
  if (e === "3d" && n.arrayLayerCount > 1)
    throw new Error("[TextureSource] a 3D texture takes depth, not arrayLayerCount.");
  if (n.dimensions && n.dimensions !== t)
    throw new Error(`[TextureSource] dimensions '${n.dimensions}' doesn't match viewDimension '${e}'. Leave dimensions out; it is derived from the view.`);
  if (n.dimensions && rt(ZV, "TextureSource dimensions is derived from viewDimension and depth; leave it out."), t === "3d" && n.antialias)
    throw new Error("[TextureSource] a 3D texture can't be antialiased: WebGPU has no multisampled 3D textures.");
}
class x1 extends an {
  constructor(e) {
    var r, a;
    const t = (a = (r = e.depth) != null ? r : e.arrayLayerCount) != null ? a : 1, i = e.resource || new Float32Array(e.width * e.height * t * 4);
    let s = e.format;
    s || (i instanceof Float32Array ? s = "rgba32float" : i instanceof Int32Array || i instanceof Uint32Array ? s = "rgba32uint" : i instanceof Int16Array || i instanceof Uint16Array ? s = "rgba16uint" : (i instanceof Int8Array, s = "bgra8unorm"));
    const o = mv(s) || t > 1;
    super({
      ...o && { alphaMode: "no-premultiply-alpha" },
      ...e,
      resource: i,
      format: s
    }), this.uploadMethodId = "buffer", this._updateStart = 0, this._updateEnd = 1 / 0;
  }
  /**
   * Uploads the buffer to the GPU. Call this after changing the data in {@link TextureSource#resource}.
   *
   * The buffer is a flat list of texels in row-major order, so texel `i` sits at
   * `x = i % width`, `y = floor(i / width)`. Pass a texel range to upload only that part of
   * the texture; leave it out to upload everything.
   *
   * The upload happens immediately for every renderer that already holds the texture, and the
   * range applies to this call only. If you change several parts of the buffer, track the dirty
   * span yourself and call `update` once with the combined range. Each call has a fixed cost on
   * top of the bytes it moves, which reaches tens of microseconds on some mobile GPUs. One span
   * usually beats many small calls.
   *
   * Partial uploads assume the buffer holds exactly `width * height` texels. A 3D texture or 2D array
   * always uploads whole, so it takes no range.
   * @example
   * ```ts
   * const data = new Float32Array(4096 * 64 * 4);
   * const source = new BufferImageSource({ resource: data, width: 4096, height: 64 });
   *
   * // change texels 100 to 115 (4 floats per rgba32float texel)
   * data.fill(1, 100 * 4, 116 * 4);
   *
   * // upload only those 16 texels
   * source.update(100, 116);
   * ```
   * @param start - index of the first texel to upload
   * @param end - index one past the last texel to upload (exclusive, like `TypedArray.subarray`)
   */
  update(e = 0, t = 1 / 0) {
    if ((e > 0 || t < 1 / 0) && this.depthOrArrayLayers > 1)
      throw new Error("[BufferImageSource] a 3D texture or 2D array uploads whole: call update() with no range.");
    this._updateStart = e, this._updateEnd = t, super.update(), this._updateStart = 0, this._updateEnd = 1 / 0;
  }
  static test(e) {
    return e instanceof Int8Array || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array;
  }
}
x1.extension = Ae.TextureSource;
const $w = new st();
class P8 {
  /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */
  constructor(e, t) {
    this.mapCoord = new st(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._updateID = 0, this.clampOffset = 0, typeof t == "undefined" ? this.clampMargin = e.width < 10 ? 0 : 0.5 : this.clampMargin = t, this.isSimple = !1, this.texture = e;
  }
  /** Texture property. */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    var t;
    this._texture !== e && ((t = this._texture) == null || t.removeListener("update", this.update, this), this._texture = e, this._texture.addListener("update", this.update, this)), this.update();
  }
  /** Releases the observed texture, removing the `update` listener from it. */
  destroy() {
    var e;
    (e = this._texture) == null || e.removeListener("update", this.update, this), this._texture = null;
  }
  /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */
  multiplyUvs(e, t) {
    t === void 0 && (t = e);
    const i = this.mapCoord;
    for (let s = 0; s < e.length; s += 2) {
      const o = e[s], r = e[s + 1];
      t[s] = o * i.a + r * i.c + i.tx, t[s + 1] = o * i.b + r * i.d + i.ty;
    }
    return t;
  }
  /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */
  update() {
    const e = this._texture;
    this._updateID++;
    const t = e.uvs;
    this.mapCoord.set(t.x1 - t.x0, t.y1 - t.y0, t.x3 - t.x0, t.y3 - t.y0, t.x0, t.y0);
    const i = e.orig, s = e.trim;
    s && ($w.set(
      i.width / s.width,
      0,
      0,
      i.height / s.height,
      -s.x / s.width,
      -s.y / s.height
    ), this.mapCoord.append($w));
    const o = e.source, r = this.uClampFrame, a = this.clampMargin / o._resolution, l = this.clampOffset / o._resolution;
    return r[0] = (e.frame.x + a + l) / o.width, r[1] = (e.frame.y + a + l) / o.height, r[2] = (e.frame.x + e.frame.width - a + l) / o.width, r[3] = (e.frame.y + e.frame.height - a + l) / o.height, this.uClampOffset[0] = this.clampOffset / o.pixelWidth, this.uClampOffset[1] = this.clampOffset / o.pixelHeight, this.isSimple = e.frame.width === o.width && e.frame.height === o.height && e.rotate === 0, !0;
  }
}
class Ze extends di {
  /**
   * @param {TextureOptions} options - Options for the texture
   */
  constructor({
    source: e,
    label: t,
    frame: i,
    orig: s,
    trim: o,
    defaultAnchor: r,
    defaultBorders: a,
    rotate: l,
    dynamic: d
  } = {}) {
    var c;
    if (super(), this.uid = Lt("texture"), this.uvs = { x0: 0, y0: 0, x1: 0, y1: 0, x2: 0, y2: 0, x3: 0, y3: 0 }, this.frame = new _t(), this.noFrame = !1, this.dynamic = !1, this.isTexture = !0, this.label = t, this.source = (c = e == null ? void 0 : e.source) != null ? c : new an(), this.noFrame = !i, i)
      this.frame.copyFrom(i);
    else {
      const { width: u, height: p } = this._source;
      this.frame.width = u, this.frame.height = p;
    }
    this.orig = s || this.frame, this.trim = o, this.rotate = l != null ? l : 0, this.defaultAnchor = r, this.defaultBorders = a, this.destroyed = !1, this.dynamic = d || !1, this.updateUvs();
  }
  set source(e) {
    this._source && this._source.off("resize", this.update, this), this._source = e, e.on("resize", this.update, this), this.emit("update", this);
  }
  /** the underlying source of the texture (equivalent of baseTexture in v7) */
  get source() {
    return this._source;
  }
  /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */
  get textureMatrix() {
    return this._textureMatrix || (this._textureMatrix = new P8(this)), this._textureMatrix;
  }
  /** The width of the Texture in pixels. */
  get width() {
    return this.orig.width;
  }
  /** The height of the Texture in pixels. */
  get height() {
    return this.orig.height;
  }
  /** Call this function when you have modified the frame of this texture. */
  updateUvs() {
    const { uvs: e, frame: t } = this, { width: i, height: s } = this._source, o = t.x / i, r = t.y / s, a = t.width / i, l = t.height / s;
    let d = this.rotate;
    if (d) {
      const c = a / 2, u = l / 2, p = o + c, f = r + u;
      d = wt.add(d, wt.NW), e.x0 = p + c * wt.uX(d), e.y0 = f + u * wt.uY(d), d = wt.add(d, 2), e.x1 = p + c * wt.uX(d), e.y1 = f + u * wt.uY(d), d = wt.add(d, 2), e.x2 = p + c * wt.uX(d), e.y2 = f + u * wt.uY(d), d = wt.add(d, 2), e.x3 = p + c * wt.uX(d), e.y3 = f + u * wt.uY(d);
    } else
      e.x0 = o, e.y0 = r, e.x1 = o + a, e.y1 = r, e.x2 = o + a, e.y2 = r + l, e.x3 = o, e.y3 = r + l;
  }
  /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */
  destroy(e = !1) {
    this._source && (this._source.off("resize", this.update, this), e && (this._source.destroy(), this._source = null)), this._textureMatrix = null, this.destroyed = !0, this.emit("destroy", this), this.removeAllListeners();
  }
  /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */
  update() {
    this.noFrame && (this.frame.width = this._source.width, this.frame.height = this._source.height), this.updateUvs(), this.emit("update", this);
  }
  /** @deprecated since 8.0.0 */
  get baseTexture() {
    return rt(on, "Texture.baseTexture is now Texture.source"), this._source;
  }
}
Ze.EMPTY = new Ze({
  label: "EMPTY",
  source: new an({
    label: "EMPTY"
  })
});
Ze.EMPTY.destroy = S8;
Ze.WHITE = new Ze({
  source: new x1({
    resource: new Uint8Array([255, 255, 255, 255]),
    width: 1,
    height: 1,
    alphaMode: "premultiply-alpha-on-upload",
    label: "WHITE"
  }),
  label: "WHITE"
});
Ze.WHITE.destroy = S8;
function nW(n, e, t) {
  const { width: i, height: s } = t.orig, o = t.trim;
  if (o) {
    const r = o.width, a = o.height;
    n.minX = o.x - e._x * i, n.maxX = n.minX + r, n.minY = o.y - e._y * s, n.maxY = n.minY + a;
  } else
    n.minX = -e._x * i, n.maxX = n.minX + i, n.minY = -e._y * s, n.maxY = n.minY + s;
}
const Dw = new st();
class On {
  /**
   * Creates a new Bounds object.
   * @param minX - The minimum X coordinate of the bounds.
   * @param minY - The minimum Y coordinate of the bounds.
   * @param maxX - The maximum X coordinate of the bounds.
   * @param maxY - The maximum Y coordinate of the bounds.
   */
  constructor(e = 1 / 0, t = 1 / 0, i = -1 / 0, s = -1 / 0) {
    this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = Dw, this.minX = e, this.minY = t, this.maxX = i, this.maxY = s;
  }
  /**
   * Checks if bounds are empty, meaning either width or height is zero or negative.
   * Empty bounds occur when min values exceed max values on either axis.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Check if newly created bounds are empty
   * console.log(bounds.isEmpty()); // true, default bounds are empty
   *
   * // Add frame and check again
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false, bounds now have area
   *
   * // Clear bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true, bounds are empty again
   * ```
   * @returns True if bounds are empty (have no area)
   * @see {@link Bounds#clear} For resetting bounds
   * @see {@link Bounds#isValid} For checking validity
   */
  isEmpty() {
    return this.minX > this.maxX || this.minY > this.maxY;
  }
  /**
   * The bounding rectangle representation of these bounds.
   * Lazily creates and updates a Rectangle instance based on the current bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Get rectangle representation
   * const rect = bounds.rectangle;
   * console.log(rect.x, rect.y, rect.width, rect.height);
   *
   * // Use for hit testing
   * if (bounds.rectangle.contains(mouseX, mouseY)) {
   *     console.log('Mouse is inside bounds!');
   * }
   * ```
   * @see {@link Rectangle} For rectangle methods
   * @see {@link Bounds.isEmpty} For bounds validation
   */
  get rectangle() {
    this._rectangle || (this._rectangle = new _t());
    const e = this._rectangle;
    return this.minX > this.maxX || this.minY > this.maxY ? (e.x = 0, e.y = 0, e.width = 0, e.height = 0) : e.copyFromBounds(this), e;
  }
  /**
   * Clears the bounds and resets all coordinates to their default values.
   * Resets the transformation matrix back to identity.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false
   * // Clear the bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true
   * ```
   * @returns This bounds object for chaining
   */
  clear() {
    return this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = Dw, this;
  }
  /**
   * Sets the bounds directly using coordinate values.
   * Provides a way to set all bounds values at once.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(0, 0, 100, 100);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @see {@link Bounds#addFrame} For matrix-aware bounds setting
   * @see {@link Bounds#clear} For resetting bounds
   */
  set(e, t, i, s) {
    this.minX = e, this.minY = t, this.maxX = i, this.maxY = s;
  }
  /**
   * Adds a rectangular frame to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the new frame coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.addFrame(0, 0, 100, 100);
   *
   * // Add transformed frame
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addFrame(0, 0, 100, 100, matrix);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addRect} For adding Rectangle objects
   * @see {@link Bounds#addBounds} For adding other Bounds
   */
  addFrame(e, t, i, s, o) {
    o || (o = this.matrix);
    const r = o.a, a = o.b, l = o.c, d = o.d, c = o.tx, u = o.ty;
    let p = this.minX, f = this.minY, y = this.maxX, b = this.maxY, w = r * e + l * t + c, k = a * e + d * t + u;
    w < p && (p = w), k < f && (f = k), w > y && (y = w), k > b && (b = k), w = r * i + l * t + c, k = a * i + d * t + u, w < p && (p = w), k < f && (f = k), w > y && (y = w), k > b && (b = k), w = r * e + l * s + c, k = a * e + d * s + u, w < p && (p = w), k < f && (f = k), w > y && (y = w), k > b && (b = k), w = r * i + l * s + c, k = a * i + d * s + u, w < p && (p = w), k < f && (f = k), w > y && (y = w), k > b && (b = k), this.minX = p, this.minY = f, this.maxX = y, this.maxY = b;
  }
  /**
   * Adds a rectangle to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the given rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * // Add simple rectangle
   * const rect = new Rectangle(0, 0, 100, 100);
   * bounds.addRect(rect);
   *
   * // Add transformed rectangle
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addRect(rect, matrix);
   * ```
   * @param rect - The rectangle to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addBounds} For adding other bounds
   */
  addRect(e, t) {
    this.addFrame(e.x, e.y, e.x + e.width, e.y + e.height, t);
  }
  /**
   * Adds another bounds object to this one, optionally transformed by a matrix.
   * Expands the bounds to include the given bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add child bounds
   * const childBounds = sprite.getBounds();
   * bounds.addBounds(childBounds);
   *
   * // Add transformed bounds
   * const matrix = new Matrix()
   *     .scale(2, 2);
   * bounds.addBounds(childBounds, matrix);
   * ```
   * @param bounds - The bounds to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addRect} For adding rectangles
   */
  addBounds(e, t) {
    this.addFrame(e.minX, e.minY, e.maxX, e.maxY, t);
  }
  /**
   * Adds other Bounds as a mask, creating an intersection of the two bounds.
   * Only keeps the overlapping region between current bounds and mask bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Create mask bounds
   * const mask = new Bounds();
   * mask.addFrame(50, 50, 150, 150);
   * // Apply mask - results in bounds of (50,50,100,100)
   * bounds.addBoundsMask(mask);
   * ```
   * @param mask - The Bounds to use as a mask
   * @see {@link Bounds#addBounds} For union operation
   * @see {@link Bounds#fit} For fitting to rectangle
   */
  addBoundsMask(e) {
    this.minX = this.minX > e.minX ? this.minX : e.minX, this.minY = this.minY > e.minY ? this.minY : e.minY, this.maxX = this.maxX < e.maxX ? this.maxX : e.maxX, this.maxY = this.maxY < e.maxY ? this.maxY : e.maxY;
  }
  /**
   * Applies a transformation matrix to the bounds, updating its coordinates.
   * Transforms all corners of the bounds using the given matrix.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Apply translation
   * const translateMatrix = new Matrix()
   *     .translate(50, 50);
   * bounds.applyMatrix(translateMatrix);
   * ```
   * @param matrix - The matrix to apply to the bounds
   * @see {@link Matrix} For matrix operations
   * @see {@link Bounds#addFrame} For adding transformed frames
   */
  applyMatrix(e) {
    const t = this.minX, i = this.minY, s = this.maxX, o = this.maxY, { a: r, b: a, c: l, d, tx: c, ty: u } = e;
    let p = r * t + l * i + c, f = a * t + d * i + u;
    this.minX = p, this.minY = f, this.maxX = p, this.maxY = f, p = r * s + l * i + c, f = a * s + d * i + u, this.minX = p < this.minX ? p : this.minX, this.minY = f < this.minY ? f : this.minY, this.maxX = p > this.maxX ? p : this.maxX, this.maxY = f > this.maxY ? f : this.maxY, p = r * t + l * o + c, f = a * t + d * o + u, this.minX = p < this.minX ? p : this.minX, this.minY = f < this.minY ? f : this.minY, this.maxX = p > this.maxX ? p : this.maxX, this.maxY = f > this.maxY ? f : this.maxY, p = r * s + l * o + c, f = a * s + d * o + u, this.minX = p < this.minX ? p : this.minX, this.minY = f < this.minY ? f : this.minY, this.maxX = p > this.maxX ? p : this.maxX, this.maxY = f > this.maxY ? f : this.maxY;
  }
  /**
   * Resizes the bounds object to fit within the given rectangle.
   * Clips the bounds if they extend beyond the rectangle's edges.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit within viewport
   * const viewport = new Rectangle(50, 50, 100, 100);
   * bounds.fit(viewport);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param rect - The rectangle to fit within
   * @returns This bounds object for chaining
   * @see {@link Bounds#addBoundsMask} For intersection
   * @see {@link Bounds#pad} For expanding bounds
   */
  fit(e) {
    return this.minX < e.left && (this.minX = e.left), this.maxX > e.right && (this.maxX = e.right), this.minY < e.top && (this.minY = e.top), this.maxY > e.bottom && (this.maxY = e.bottom), this;
  }
  /**
   * Resizes the bounds object to include the given bounds.
   * Similar to fit() but works with raw coordinate values instead of a Rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit to specific coordinates
   * bounds.fitBounds(50, 150, 50, 150);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param left - The left value of the bounds
   * @param right - The right value of the bounds
   * @param top - The top value of the bounds
   * @param bottom - The bottom value of the bounds
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For fitting to Rectangle
   * @see {@link Bounds#addBoundsMask} For intersection
   */
  fitBounds(e, t, i, s) {
    return this.minX < e && (this.minX = e), this.maxX > t && (this.maxX = t), this.minY < i && (this.minY = i), this.maxY > s && (this.maxY = s), this;
  }
  /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Add equal padding
   * bounds.pad(10);
   * // bounds are now (-10, -10, 110, 110)
   *
   * // Add different padding for x and y
   * bounds.pad(20, 10);
   * // bounds are now (-30, -20, 130, 120)
   * ```
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For constraining bounds
   * @see {@link Bounds#scale} For uniform scaling
   */
  pad(e, t = e) {
    return this.minX -= e, this.maxX += e, this.minY -= t, this.maxY += t, this;
  }
  /**
   * Ceils the bounds by rounding up max values and rounding down min values.
   * Useful for pixel-perfect calculations and avoiding fractional pixels.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(10.2, 10.9, 50.1, 50.8);
   *
   * // Round to whole pixels
   * bounds.ceil();
   * // bounds are now (10, 10, 51, 51)
   * ```
   * @returns This bounds object for chaining
   * @see {@link Bounds#scale} For size adjustments
   * @see {@link Bounds#fit} For constraining bounds
   */
  ceil() {
    return this.minX = Math.floor(this.minX), this.minY = Math.floor(this.minY), this.maxX = Math.ceil(this.maxX), this.maxY = Math.ceil(this.maxY), this;
  }
  /**
   * Creates a new Bounds instance with the same values.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Create a copy
   * const copy = bounds.clone();
   *
   * // Original and copy are independent
   * bounds.pad(10);
   * console.log(copy.width === bounds.width); // false
   * ```
   * @returns A new Bounds instance with the same values
   * @see {@link Bounds#copyFrom} For reusing existing bounds
   */
  clone() {
    return new On(this.minX, this.minY, this.maxX, this.maxY);
  }
  /**
   * Scales the bounds by the given values, adjusting all edges proportionally.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Scale uniformly
   * bounds.scale(2);
   * // bounds are now (0, 0, 200, 200)
   *
   * // Scale non-uniformly
   * bounds.scale(0.5, 2);
   * // bounds are now (0, 0, 100, 400)
   * ```
   * @param x - The X value to scale by
   * @param y - The Y value to scale by (defaults to x)
   * @returns This bounds object for chaining
   * @see {@link Bounds#pad} For adding padding
   * @see {@link Bounds#fit} For constraining size
   */
  scale(e, t = e) {
    return this.minX *= e, this.minY *= t, this.maxX *= e, this.maxY *= t, this;
  }
  /**
   * The x position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its width.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get x position
   * console.log(bounds.x); // 0
   *
   * // Move bounds horizontally
   * bounds.x = 50;
   * console.log(bounds.minX, bounds.maxX); // 50, 150
   *
   * // Width stays the same
   * console.log(bounds.width); // Still 100
   * ```
   */
  get x() {
    return this.minX;
  }
  set x(e) {
    const t = this.maxX - this.minX;
    this.minX = e, this.maxX = e + t;
  }
  /**
   * The y position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its height.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get y position
   * console.log(bounds.y); // 0
   *
   * // Move bounds vertically
   * bounds.y = 50;
   * console.log(bounds.minY, bounds.maxY); // 50, 150
   *
   * // Height stays the same
   * console.log(bounds.height); // Still 100
   * ```
   */
  get y() {
    return this.minY;
  }
  set y(e) {
    const t = this.maxY - this.minY;
    this.minY = e, this.maxY = e + t;
  }
  /**
   * The width value of the bounds.
   * Represents the distance between minX and maxX coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get width
   * console.log(bounds.width); // 100
   * // Resize width
   * bounds.width = 200;
   * console.log(bounds.maxX - bounds.minX); // 200
   * ```
   */
  get width() {
    return this.maxX - this.minX;
  }
  set width(e) {
    this.maxX = this.minX + e;
  }
  /**
   * The height value of the bounds.
   * Represents the distance between minY and maxY coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get height
   * console.log(bounds.height); // 100
   * // Resize height
   * bounds.height = 150;
   * console.log(bounds.maxY - bounds.minY); // 150
   * ```
   */
  get height() {
    return this.maxY - this.minY;
  }
  set height(e) {
    this.maxY = this.minY + e;
  }
  /**
   * The left edge coordinate of the bounds.
   * Alias for minX.
   * @example
   * ```ts
   * const bounds = new Bounds(50, 0, 150, 100);
   * console.log(bounds.left); // 50
   * console.log(bounds.left === bounds.minX); // true
   * ```
   * @readonly
   */
  get left() {
    return this.minX;
  }
  /**
   * The right edge coordinate of the bounds.
   * Alias for maxX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.right); // 100
   * console.log(bounds.right === bounds.maxX); // true
   * ```
   * @readonly
   */
  get right() {
    return this.maxX;
  }
  /**
   * The top edge coordinate of the bounds.
   * Alias for minY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 25, 100, 125);
   * console.log(bounds.top); // 25
   * console.log(bounds.top === bounds.minY); // true
   * ```
   * @readonly
   */
  get top() {
    return this.minY;
  }
  /**
   * The bottom edge coordinate of the bounds.
   * Alias for maxY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 200);
   * console.log(bounds.bottom); // 200
   * console.log(bounds.bottom === bounds.maxY); // true
   * ```
   * @readonly
   */
  get bottom() {
    return this.maxY;
  }
  /**
   * Whether the bounds has positive width and height.
   * Checks if both dimensions are greater than zero.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Check if bounds are positive
   * console.log(bounds.isPositive); // true
   *
   * // Negative bounds
   * bounds.maxX = bounds.minX;
   * console.log(bounds.isPositive); // false, width is 0
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isValid} For checking validity
   */
  get isPositive() {
    return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
  }
  /**
   * Whether the bounds has valid coordinates.
   * Checks if the bounds has been initialized with real values.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * console.log(bounds.isValid); // false, default state
   *
   * // Set valid bounds
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isValid); // true
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isPositive} For checking dimensions
   */
  get isValid() {
    return this.minX + this.minY !== 1 / 0;
  }
  /**
   * Adds vertices from a Float32Array to the bounds, optionally transformed by a matrix.
   * Used for efficiently updating bounds from raw vertex data.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add vertices from geometry
   * const vertices = new Float32Array([
   *     0, 0,    // Vertex 1
   *     100, 0,  // Vertex 2
   *     100, 100 // Vertex 3
   * ]);
   * bounds.addVertexData(vertices, 0, 6);
   *
   * // Add transformed vertices
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addVertexData(vertices, 0, 6, matrix);
   *
   * // Add subset of vertices
   * bounds.addVertexData(vertices, 2, 4); // Only second vertex
   * ```
   * @param vertexData - The array of vertices to add
   * @param beginOffset - Starting index in the vertex array
   * @param endOffset - Ending index in the vertex array (excluded)
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding rectangular frames
   * @see {@link Matrix} For transformation details
   */
  addVertexData(e, t, i, s) {
    let o = this.minX, r = this.minY, a = this.maxX, l = this.maxY;
    s || (s = this.matrix);
    const d = s.a, c = s.b, u = s.c, p = s.d, f = s.tx, y = s.ty;
    for (let b = t; b < i; b += 2) {
      const w = e[b], k = e[b + 1], S = d * w + u * k + f, _ = c * w + p * k + y;
      o = S < o ? S : o, r = _ < r ? _ : r, a = S > a ? S : a, l = _ > l ? _ : l;
    }
    this.minX = o, this.minY = r, this.maxX = a, this.maxY = l;
  }
  /**
   * Checks if a point is contained within the bounds.
   * Returns true if the point's coordinates fall within the bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Basic point check
   * console.log(bounds.containsPoint(50, 50)); // true
   * console.log(bounds.containsPoint(150, 150)); // false
   *
   * // Check edges
   * console.log(bounds.containsPoint(0, 0));   // true, includes edges
   * console.log(bounds.containsPoint(100, 100)); // true, includes edges
   * ```
   * @param x - x coordinate to check
   * @param y - y coordinate to check
   * @returns True if the point is inside the bounds
   * @see {@link Bounds#isPositive} For valid bounds check
   * @see {@link Bounds#rectangle} For Rectangle representation
   */
  containsPoint(e, t) {
    return this.minX <= e && this.minY <= t && this.maxX >= e && this.maxY >= t;
  }
  /**
   * Returns a string representation of the bounds.
   * Useful for debugging and logging bounds information.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.toString()); // "[pixi.js:Bounds minX=0 minY=0 maxX=100 maxY=100 width=100 height=100]"
   * ```
   * @returns A string describing the bounds
   * @see {@link Bounds#copyFrom} For copying bounds
   * @see {@link Bounds#clone} For creating a new instance
   */
  toString() {
    return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
  }
  /**
   * Copies the bounds from another bounds object.
   * Useful for reusing bounds objects and avoiding allocations.
   * @example
   * ```ts
   * const sourceBounds = new Bounds(0, 0, 100, 100);
   * // Copy bounds
   * const targetBounds = new Bounds();
   * targetBounds.copyFrom(sourceBounds);
   * ```
   * @param bounds - The bounds to copy from
   * @returns This bounds object for chaining
   * @see {@link Bounds#clone} For creating new instances
   */
  copyFrom(e) {
    return this.minX = e.minX, this.minY = e.minY, this.maxX = e.maxX, this.maxY = e.maxY, this;
  }
}
var iW = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, ys = function(n) {
  return typeof n == "string" ? n.length > 0 : typeof n == "number";
}, _n = function(n, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = Math.pow(10, e)), Math.round(t * n) / t + 0;
}, Mi = function(n, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = 1), n > t ? t : n > e ? n : e;
}, E8 = function(n) {
  return (n = isFinite(n) ? n % 360 : 0) > 0 ? n : n + 360;
}, Ow = function(n) {
  return { r: Mi(n.r, 0, 255), g: Mi(n.g, 0, 255), b: Mi(n.b, 0, 255), a: Mi(n.a) };
}, Ym = function(n) {
  return { r: _n(n.r), g: _n(n.g), b: _n(n.b), a: _n(n.a, 3) };
}, sW = /^#([0-9a-f]{3,8})$/i, Au = function(n) {
  var e = n.toString(16);
  return e.length < 2 ? "0" + e : e;
}, R8 = function(n) {
  var e = n.r, t = n.g, i = n.b, s = n.a, o = Math.max(e, t, i), r = o - Math.min(e, t, i), a = r ? o === e ? (t - i) / r : o === t ? 2 + (i - e) / r : 4 + (e - t) / r : 0;
  return { h: 60 * (a < 0 ? a + 6 : a), s: o ? r / o * 100 : 0, v: o / 255 * 100, a: s };
}, z8 = function(n) {
  var e = n.h, t = n.s, i = n.v, s = n.a;
  e = e / 360 * 6, t /= 100, i /= 100;
  var o = Math.floor(e), r = i * (1 - t), a = i * (1 - (e - o) * t), l = i * (1 - (1 - e + o) * t), d = o % 6;
  return { r: 255 * [i, a, r, r, l, i][d], g: 255 * [l, i, i, a, r, r][d], b: 255 * [r, r, l, i, i, a][d], a: s };
}, Lw = function(n) {
  return { h: E8(n.h), s: Mi(n.s, 0, 100), l: Mi(n.l, 0, 100), a: Mi(n.a) };
}, Bw = function(n) {
  return { h: _n(n.h), s: _n(n.s), l: _n(n.l), a: _n(n.a, 3) };
}, Fw = function(n) {
  return z8((t = (e = n).s, { h: e.h, s: (t *= ((i = e.l) < 50 ? i : 100 - i) / 100) > 0 ? 2 * t / (i + t) * 100 : 0, v: i + t, a: e.a }));
  var e, t, i;
}, Zd = function(n) {
  return { h: (e = R8(n)).h, s: (s = (200 - (t = e.s)) * (i = e.v) / 100) > 0 && s < 200 ? t * i / 100 / (s <= 100 ? s : 200 - s) * 100 : 0, l: s / 2, a: e.a };
  var e, t, i, s;
}, oW = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, rW = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, aW = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, lW = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, gv = { string: [[function(n) {
  var e = sW.exec(n);
  return e ? (n = e[1]).length <= 4 ? { r: parseInt(n[0] + n[0], 16), g: parseInt(n[1] + n[1], 16), b: parseInt(n[2] + n[2], 16), a: n.length === 4 ? _n(parseInt(n[3] + n[3], 16) / 255, 2) : 1 } : n.length === 6 || n.length === 8 ? { r: parseInt(n.substr(0, 2), 16), g: parseInt(n.substr(2, 2), 16), b: parseInt(n.substr(4, 2), 16), a: n.length === 8 ? _n(parseInt(n.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(n) {
  var e = aW.exec(n) || lW.exec(n);
  return e ? e[2] !== e[4] || e[4] !== e[6] ? null : Ow({ r: Number(e[1]) / (e[2] ? 100 / 255 : 1), g: Number(e[3]) / (e[4] ? 100 / 255 : 1), b: Number(e[5]) / (e[6] ? 100 / 255 : 1), a: e[7] === void 0 ? 1 : Number(e[7]) / (e[8] ? 100 : 1) }) : null;
}, "rgb"], [function(n) {
  var e = oW.exec(n) || rW.exec(n);
  if (!e) return null;
  var t, i, s = Lw({ h: (t = e[1], i = e[2], i === void 0 && (i = "deg"), Number(t) * (iW[i] || 1)), s: Number(e[3]), l: Number(e[4]), a: e[5] === void 0 ? 1 : Number(e[5]) / (e[6] ? 100 : 1) });
  return Fw(s);
}, "hsl"]], object: [[function(n) {
  var e = n.r, t = n.g, i = n.b, s = n.a, o = s === void 0 ? 1 : s;
  return ys(e) && ys(t) && ys(i) ? Ow({ r: Number(e), g: Number(t), b: Number(i), a: Number(o) }) : null;
}, "rgb"], [function(n) {
  var e = n.h, t = n.s, i = n.l, s = n.a, o = s === void 0 ? 1 : s;
  if (!ys(e) || !ys(t) || !ys(i)) return null;
  var r = Lw({ h: Number(e), s: Number(t), l: Number(i), a: Number(o) });
  return Fw(r);
}, "hsl"], [function(n) {
  var e = n.h, t = n.s, i = n.v, s = n.a, o = s === void 0 ? 1 : s;
  if (!ys(e) || !ys(t) || !ys(i)) return null;
  var r = (function(a) {
    return { h: E8(a.h), s: Mi(a.s, 0, 100), v: Mi(a.v, 0, 100), a: Mi(a.a) };
  })({ h: Number(e), s: Number(t), v: Number(i), a: Number(o) });
  return z8(r);
}, "hsv"]] }, Nw = function(n, e) {
  for (var t = 0; t < e.length; t++) {
    var i = e[t][0](n);
    if (i) return [i, e[t][1]];
  }
  return [null, void 0];
}, dW = function(n) {
  return typeof n == "string" ? Nw(n.trim(), gv.string) : typeof n == "object" && n !== null ? Nw(n, gv.object) : [null, void 0];
}, Xm = function(n, e) {
  var t = Zd(n);
  return { h: t.h, s: Mi(t.s + 100 * e, 0, 100), l: t.l, a: t.a };
}, Jm = function(n) {
  return (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 / 255;
}, Uw = function(n, e) {
  var t = Zd(n);
  return { h: t.h, s: t.s, l: Mi(t.l + 100 * e, 0, 100), a: t.a };
}, bv = (function() {
  function n(e) {
    this.parsed = dW(e)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return n.prototype.isValid = function() {
    return this.parsed !== null;
  }, n.prototype.brightness = function() {
    return _n(Jm(this.rgba), 2);
  }, n.prototype.isDark = function() {
    return Jm(this.rgba) < 0.5;
  }, n.prototype.isLight = function() {
    return Jm(this.rgba) >= 0.5;
  }, n.prototype.toHex = function() {
    return e = Ym(this.rgba), t = e.r, i = e.g, s = e.b, r = (o = e.a) < 1 ? Au(_n(255 * o)) : "", "#" + Au(t) + Au(i) + Au(s) + r;
    var e, t, i, s, o, r;
  }, n.prototype.toRgb = function() {
    return Ym(this.rgba);
  }, n.prototype.toRgbString = function() {
    return e = Ym(this.rgba), t = e.r, i = e.g, s = e.b, (o = e.a) < 1 ? "rgba(" + t + ", " + i + ", " + s + ", " + o + ")" : "rgb(" + t + ", " + i + ", " + s + ")";
    var e, t, i, s, o;
  }, n.prototype.toHsl = function() {
    return Bw(Zd(this.rgba));
  }, n.prototype.toHslString = function() {
    return e = Bw(Zd(this.rgba)), t = e.h, i = e.s, s = e.l, (o = e.a) < 1 ? "hsla(" + t + ", " + i + "%, " + s + "%, " + o + ")" : "hsl(" + t + ", " + i + "%, " + s + "%)";
    var e, t, i, s, o;
  }, n.prototype.toHsv = function() {
    return e = R8(this.rgba), { h: _n(e.h), s: _n(e.s), v: _n(e.v), a: _n(e.a, 3) };
    var e;
  }, n.prototype.invert = function() {
    return Xi({ r: 255 - (e = this.rgba).r, g: 255 - e.g, b: 255 - e.b, a: e.a });
    var e;
  }, n.prototype.saturate = function(e) {
    return e === void 0 && (e = 0.1), Xi(Xm(this.rgba, e));
  }, n.prototype.desaturate = function(e) {
    return e === void 0 && (e = 0.1), Xi(Xm(this.rgba, -e));
  }, n.prototype.grayscale = function() {
    return Xi(Xm(this.rgba, -1));
  }, n.prototype.lighten = function(e) {
    return e === void 0 && (e = 0.1), Xi(Uw(this.rgba, e));
  }, n.prototype.darken = function(e) {
    return e === void 0 && (e = 0.1), Xi(Uw(this.rgba, -e));
  }, n.prototype.rotate = function(e) {
    return e === void 0 && (e = 15), this.hue(this.hue() + e);
  }, n.prototype.alpha = function(e) {
    return typeof e == "number" ? Xi({ r: (t = this.rgba).r, g: t.g, b: t.b, a: e }) : _n(this.rgba.a, 3);
    var t;
  }, n.prototype.hue = function(e) {
    var t = Zd(this.rgba);
    return typeof e == "number" ? Xi({ h: e, s: t.s, l: t.l, a: t.a }) : _n(t.h);
  }, n.prototype.isEqual = function(e) {
    return this.toHex() === Xi(e).toHex();
  }, n;
})(), Xi = function(n) {
  return n instanceof bv ? n : new bv(n);
}, Gw = [], cW = function(n) {
  n.forEach(function(e) {
    Gw.indexOf(e) < 0 && (e(bv, gv), Gw.push(e));
  });
};
function uW(n, e) {
  var t = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, i = {};
  for (var s in t) i[t[s]] = s;
  var o = {};
  n.prototype.toName = function(r) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var a, l, d = i[this.toHex()];
    if (d) return d;
    if (r != null && r.closest) {
      var c = this.toRgb(), u = 1 / 0, p = "black";
      if (!o.length) for (var f in t) o[f] = new n(t[f]).toRgb();
      for (var y in t) {
        var b = (a = c, l = o[y], Math.pow(a.r - l.r, 2) + Math.pow(a.g - l.g, 2) + Math.pow(a.b - l.b, 2));
        b < u && (u = b, p = y);
      }
      return p;
    }
  }, e.string.push([function(r) {
    var a = r.toLowerCase(), l = a === "transparent" ? "#0000" : t[a];
    return l ? new n(l).toRgb() : null;
  }, "name"]);
}
cW([uW]);
const gl = class Ed {
  /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */
  constructor(e = 16777215) {
    this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = e;
  }
  /**
   * Get the red component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.red); // 1
   *
   * const green = new Color('#00ff00');
   * console.log(green.red); // 0
   * ```
   */
  get red() {
    return this._components[0];
  }
  /**
   * Get the green component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('lime');
   * console.log(color.green); // 1
   *
   * const red = new Color('#ff0000');
   * console.log(red.green); // 0
   * ```
   */
  get green() {
    return this._components[1];
  }
  /**
   * Get the blue component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('blue');
   * console.log(color.blue); // 1
   *
   * const yellow = new Color('#ffff00');
   * console.log(yellow.blue); // 0
   * ```
   */
  get blue() {
    return this._components[2];
  }
  /**
   * Get the alpha component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.alpha); // 1 (fully opaque)
   *
   * const transparent = new Color('rgba(255, 0, 0, 0.5)');
   * console.log(transparent.alpha); // 0.5 (semi-transparent)
   * ```
   */
  get alpha() {
    return this._components[3];
  }
  /**
   * Sets the color value and returns the instance for chaining.
   *
   * This is a chainable version of setting the `value` property.
   * @param value - The color to set. Accepts various formats:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA values (arrays, objects)
   * - CSS color names
   * - HSL/HSLA values
   * - HSV/HSVA values
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic usage
   * const color = new Color();
   * color.setValue('#ff0000')
   *     .setAlpha(0.5)
   *     .premultiply(0.8);
   *
   * // Different formats
   * color.setValue(0xff0000);          // Hex number
   * color.setValue('#ff0000');         // Hex string
   * color.setValue([1, 0, 0]);         // RGB array
   * color.setValue([1, 0, 0, 0.5]);    // RGBA array
   * color.setValue({ r: 1, g: 0, b: 0 }); // RGB object
   *
   * // Copy from another color
   * const red = new Color('red');
   * color.setValue(red);
   * ```
   * @throws {Error} If the color value is invalid or null
   * @see {@link Color.value} For the underlying value property
   */
  setValue(e) {
    return this.value = e, this;
  }
  /**
   * The current color source. This property allows getting and setting the color value
   * while preserving the original format where possible.
   * @remarks
   * When setting:
   * - Setting to a `Color` instance copies its source and components
   * - Setting to other valid sources normalizes and stores the value
   * - Setting to `null` throws an Error
   * - The color remains unchanged if normalization fails
   *
   * When getting:
   * - Returns `null` if color was modified by {@link Color.multiply} or {@link Color.premultiply}
   * - Otherwise returns the original color source
   * @example
   * ```ts
   * // Setting different color formats
   * const color = new Color();
   *
   * color.value = 0xff0000;         // Hex number
   * color.value = '#ff0000';        // Hex string
   * color.value = [1, 0, 0];        // RGB array
   * color.value = [1, 0, 0, 0.5];   // RGBA array
   * color.value = { r: 1, g: 0, b: 0 }; // RGB object
   *
   * // Copying from another color
   * const red = new Color('red');
   * color.value = red;  // Copies red's components
   *
   * // Getting the value
   * console.log(color.value);  // Returns original format
   *
   * // After modifications
   * color.multiply([0.5, 0.5, 0.5]);
   * console.log(color.value);  // Returns null
   * ```
   * @throws {Error} When attempting to set `null`
   */
  set value(e) {
    if (e instanceof Ed)
      this._value = this._cloneSource(e._value), this._int = e._int, this._components.set(e._components);
    else {
      if (e === null)
        throw new Error("Cannot set Color#value to null");
      (this._value === null || !this._isSourceEqual(this._value, e)) && (this._value = this._cloneSource(e), this._normalize(this._value));
    }
  }
  get value() {
    return this._value;
  }
  /**
   * Copy a color source internally.
   * @param value - Color source
   */
  _cloneSource(e) {
    return typeof e == "string" || typeof e == "number" || e instanceof Number || e === null ? e : Array.isArray(e) || ArrayBuffer.isView(e) ? e.slice(0) : typeof e == "object" && e !== null ? { ...e } : e;
  }
  /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */
  _isSourceEqual(e, t) {
    const i = typeof e;
    if (i !== typeof t)
      return !1;
    if (i === "number" || i === "string" || e instanceof Number)
      return e === t;
    if (Array.isArray(e) && Array.isArray(t) || ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return e.length !== t.length ? !1 : e.every((o, r) => o === t[r]);
    if (e !== null && t !== null) {
      const o = Object.keys(e), r = Object.keys(t);
      return o.length !== r.length ? !1 : o.every((a) => e[a] === t[a]);
    }
    return e === t;
  }
  /**
   * Convert to a RGBA color object with normalized components (0-1).
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA objects
   * new Color('white').toRgba();     // returns { r: 1, g: 1, b: 1, a: 1 }
   * new Color('#ff0000').toRgba();   // returns { r: 1, g: 0, b: 0, a: 1 }
   *
   * // With transparency
   * new Color('rgba(255,0,0,0.5)').toRgba(); // returns { r: 1, g: 0, b: 0, a: 0.5 }
   * ```
   * @returns An RGBA object with normalized components
   */
  toRgba() {
    const [e, t, i, s] = this._components;
    return { r: e, g: t, b: i, a: s };
  }
  /**
   * Convert to a RGB color object with normalized components (0-1).
   *
   * Alpha component is omitted in the output.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGB objects
   * new Color('white').toRgb();     // returns { r: 1, g: 1, b: 1 }
   * new Color('#ff0000').toRgb();   // returns { r: 1, g: 0, b: 0 }
   *
   * // Alpha is ignored
   * new Color('rgba(255,0,0,0.5)').toRgb(); // returns { r: 1, g: 0, b: 0 }
   * ```
   * @returns An RGB object with normalized components
   */
  toRgb() {
    const [e, t, i] = this._components;
    return { r: e, g: t, b: i };
  }
  /**
   * Convert to a CSS-style rgba string representation.
   *
   * RGB components are scaled to 0-255 range, alpha remains 0-1.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA strings
   * new Color('white').toRgbaString();     // returns "rgba(255,255,255,1)"
   * new Color('#ff0000').toRgbaString();   // returns "rgba(255,0,0,1)"
   *
   * // With transparency
   * new Color([1, 0, 0, 0.5]).toRgbaString(); // returns "rgba(255,0,0,0.5)"
   * ```
   * @returns A CSS-compatible rgba string
   */
  toRgbaString() {
    const [e, t, i] = this.toUint8RgbArray();
    return `rgba(${e},${t},${i},${this.alpha})`;
  }
  /**
   * Convert to an [R, G, B] array of clamped uint8 values (0 to 255).
   * @param {number[]|Uint8Array|Uint8ClampedArray} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as integers between 0-255
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toUint8RgbArray(); // returns [255, 255, 255]
   * new Color('#ff0000').toUint8RgbArray(); // returns [255, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Uint8Array(3);
   * new Color('blue').toUint8RgbArray(rgb); // rgb is now [0, 0, 255]
   *
   * // Using different array types
   * new Color('red').toUint8RgbArray(new Uint8ClampedArray(3)); // [255, 0, 0]
   * new Color('red').toUint8RgbArray([]); // [255, 0, 0]
   * ```
   * @remarks
   * - Output values are always clamped between 0-255
   * - Alpha component is not included in output
   * - Reuses internal cache array if no output array provided
   */
  toUint8RgbArray(e) {
    const [t, i, s] = this._components;
    return this._arrayRgb || (this._arrayRgb = []), e || (e = this._arrayRgb), e[0] = Math.round(t * 255), e[1] = Math.round(i * 255), e[2] = Math.round(s * 255), e;
  }
  /**
   * Convert to an [R, G, B, A] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGBA components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toArray();  // returns [1, 1, 1, 1]
   * new Color('red').toArray();    // returns [1, 0, 0, 1]
   *
   * // With alpha
   * new Color('rgba(255,0,0,0.5)').toArray(); // returns [1, 0, 0, 0.5]
   *
   * // Using custom output array
   * const rgba = new Float32Array(4);
   * new Color('blue').toArray(rgba); // rgba is now [0, 0, 1, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Includes alpha component as the fourth value
   * - Reuses internal cache array if no output array provided
   */
  toArray(e) {
    this._arrayRgba || (this._arrayRgba = []), e || (e = this._arrayRgba);
    const [t, i, s, o] = this._components;
    return e[0] = t, e[1] = i, e[2] = s, e[3] = o, e;
  }
  /**
   * Convert to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toRgbArray(); // returns [1, 1, 1]
   * new Color('red').toRgbArray();   // returns [1, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Float32Array(3);
   * new Color('blue').toRgbArray(rgb); // rgb is now [0, 0, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Alpha component is omitted from output
   * - Reuses internal cache array if no output array provided
   */
  toRgbArray(e) {
    this._arrayRgb || (this._arrayRgb = []), e || (e = this._arrayRgb);
    const [t, i, s] = this._components;
    return e[0] = t, e[1] = i, e[2] = s, e;
  }
  /**
   * Convert to a hexadecimal number.
   * @returns The color as a 24-bit RGB integer
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toNumber(); // returns 0xffffff
   * new Color('red').toNumber();   // returns 0xff0000
   *
   * // Store as hex
   * const color = new Color('blue');
   * const hex = color.toNumber(); // 0x0000ff
   * ```
   */
  toNumber() {
    return this._int;
  }
  /**
   * Convert to a BGR number.
   *
   * Useful for platforms that expect colors in BGR format.
   * @returns The color as a 24-bit BGR integer
   * @example
   * ```ts
   * // Convert RGB to BGR
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   *
   * // Common use case: platform-specific color format
   * const color = new Color('orange');
   * const bgrColor = color.toBgrNumber(); // Color with swapped R/B channels
   * ```
   * @remarks
   * This swaps the red and blue channels compared to the normal RGB format:
   * - RGB 0xRRGGBB becomes BGR 0xBBGGRR
   */
  toBgrNumber() {
    const [e, t, i] = this.toUint8RgbArray();
    return (i << 16) + (t << 8) + e;
  }
  /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   *
   * Useful for platforms that expect colors in little endian byte order.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert RGB color to little endian format
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   *
   * // Common use cases:
   * const color = new Color('orange');
   * const leColor = color.toLittleEndianNumber(); // Swaps byte order for LE systems
   *
   * // Multiple conversions
   * const colors = {
   *     normal: 0xffcc99,
   *     littleEndian: new Color(0xffcc99).toLittleEndianNumber(), // 0x99ccff
   *     backToNormal: new Color(0x99ccff).toLittleEndianNumber()  // 0xffcc99
   * };
   * ```
   * @remarks
   * - Swaps R and B channels in the color value
   * - RGB 0xRRGGBB becomes 0xBBGGRR
   * - Useful for systems that use little endian byte order
   * - Can be used to convert back and forth between formats
   * @returns The color as a number in little endian format (BBGGRR)
   * @see {@link Color.toBgrNumber} For BGR format without byte swapping
   */
  toLittleEndianNumber() {
    const e = this._int;
    return (e >> 16) + (e & 65280) + ((e & 255) << 16);
  }
  /**
   * Multiply with another color.
   *
   * This action is destructive and modifies the original color.
   * @param {ColorSource} value - The color to multiply by. Accepts any valid color format:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA arrays ([1, 0, 0], [1, 0, 0, 1])
   * - Color objects ({ r: 1, g: 0, b: 0 })
   * - CSS color names ('red', 'blue')
   * @returns this - The Color instance for chaining
   * @example
   * ```ts
   * // Basic multiplication
   * const color = new Color('#ff0000');
   * color.multiply(0x808080); // 50% darker red
   *
   * // With transparency
   * color.multiply([1, 1, 1, 0.5]); // 50% transparent
   *
   * // Chain operations
   * color
   *     .multiply('#808080')
   *     .multiply({ r: 1, g: 1, b: 1, a: 0.5 });
   * ```
   * @remarks
   * - Multiplies each RGB component and alpha separately
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */
  multiply(e) {
    const [t, i, s, o] = Ed._temp.setValue(e)._components;
    return this._components[0] *= t, this._components[1] *= i, this._components[2] *= s, this._components[3] *= o, this._refreshInt(), this._value = null, this;
  }
  /**
   * Converts color to a premultiplied alpha format.
   *
   * This action is destructive and modifies the original color.
   * @param alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {Color} The Color instance for chaining
   * @example
   * ```ts
   * // Basic premultiplication
   * const color = new Color('red');
   * color.premultiply(0.5); // 50% transparent red with premultiplied RGB
   *
   * // Alpha only (RGB unchanged)
   * color.premultiply(0.5, false); // 50% transparent, original RGB
   *
   * // Chain with other operations
   * color
   *     .multiply(0x808080)
   *     .premultiply(0.5)
   *     .toNumber();
   * ```
   * @remarks
   * - RGB channels are multiplied by alpha when applyToRGB is true
   * - Alpha is always set to the provided value
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */
  premultiply(e, t = !0) {
    return t && (this._components[0] *= e, this._components[1] *= e, this._components[2] *= e), this._components[3] = e, this._refreshInt(), this._value = null, this;
  }
  /**
   * Returns the color as a 32-bit premultiplied alpha integer.
   *
   * Format: 0xAARRGGBB
   * @param {number} alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {number} The premultiplied color as a 32-bit integer
   * @example
   * ```ts
   * // Convert to premultiplied format
   * const color = new Color('red');
   *
   * // Full opacity (0xFFRRGGBB)
   * color.toPremultiplied(1.0); // 0xFFFF0000
   *
   * // 50% transparency with premultiplied RGB
   * color.toPremultiplied(0.5); // 0x7F7F0000
   *
   * // 50% transparency without RGB premultiplication
   * color.toPremultiplied(0.5, false); // 0x7FFF0000
   * ```
   * @remarks
   * - Returns full opacity (0xFF000000) when alpha is 1.0
   * - Returns 0 when alpha is 0.0 and applyToRGB is true
   * - RGB values are rounded during premultiplication
   */
  toPremultiplied(e, t = !0) {
    if (e === 1)
      return (255 << 24) + this._int;
    if (e === 0)
      return t ? 0 : this._int;
    let i = this._int >> 16 & 255, s = this._int >> 8 & 255, o = this._int & 255;
    return t && (i = i * e + 0.5 | 0, s = s * e + 0.5 | 0, o = o * e + 0.5 | 0), (e * 255 << 24) + (i << 16) + (s << 8) + o;
  }
  /**
   * Convert to a hexadecimal string (6 characters).
   * @returns A CSS-compatible hex color string (e.g., "#ff0000")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Basic colors
   * new Color('red').toHex();    // returns "#ff0000"
   * new Color('white').toHex();  // returns "#ffffff"
   * new Color('black').toHex();  // returns "#000000"
   *
   * // From different formats
   * new Color(0xff0000).toHex(); // returns "#ff0000"
   * new Color([1, 0, 0]).toHex(); // returns "#ff0000"
   * new Color({ r: 1, g: 0, b: 0 }).toHex(); // returns "#ff0000"
   * ```
   * @remarks
   * - Always returns a 6-character hex string
   * - Includes leading "#" character
   * - Alpha channel is ignored
   * - Values are rounded to nearest hex value
   */
  toHex() {
    const e = this._int.toString(16);
    return `#${"000000".substring(0, 6 - e.length) + e}`;
  }
  /**
   * Convert to a hexadecimal string with alpha (8 characters).
   * @returns A CSS-compatible hex color string with alpha (e.g., "#ff0000ff")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Fully opaque colors
   * new Color('red').toHexa();   // returns "#ff0000ff"
   * new Color('white').toHexa(); // returns "#ffffffff"
   *
   * // With transparency
   * new Color('rgba(255, 0, 0, 0.5)').toHexa(); // returns "#ff00007f"
   * new Color([1, 0, 0, 0]).toHexa(); // returns "#ff000000"
   * ```
   * @remarks
   * - Returns an 8-character hex string
   * - Includes leading "#" character
   * - Alpha is encoded in last two characters
   * - Values are rounded to nearest hex value
   */
  toHexa() {
    const t = Math.round(this._components[3] * 255).toString(16);
    return this.toHex() + "00".substring(0, 2 - t.length) + t;
  }
  /**
   * Set alpha (transparency) value while preserving color components.
   *
   * Provides a chainable interface for setting alpha.
   * @param alpha - Alpha value between 0 (fully transparent) and 1 (fully opaque)
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic alpha setting
   * const color = new Color('red');
   * color.setAlpha(0.5);  // 50% transparent red
   *
   * // Chain with other operations
   * color
   *     .setValue('#ff0000')
   *     .setAlpha(0.8)    // 80% opaque
   *     .premultiply(0.5); // Further modify alpha
   *
   * // Reset to fully opaque
   * color.setAlpha(1);
   * ```
   * @remarks
   * - Alpha value is clamped between 0-1
   * - Can be chained with other color operations
   */
  setAlpha(e) {
    return this._components[3] = this._clamp(e), this._value = null, this;
  }
  /**
   * Normalize the input value into rgba
   * @param value - Input value
   */
  _normalize(e) {
    let t, i, s, o;
    if ((typeof e == "number" || e instanceof Number) && e >= 0 && e <= 16777215) {
      const r = e;
      t = (r >> 16 & 255) / 255, i = (r >> 8 & 255) / 255, s = (r & 255) / 255, o = 1;
    } else if ((Array.isArray(e) || e instanceof Float32Array) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e), [t, i, s, o = 1] = e;
    else if ((e instanceof Uint8Array || e instanceof Uint8ClampedArray) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e, 0, 255), [t, i, s, o = 255] = e, t /= 255, i /= 255, s /= 255, o /= 255;
    else if (typeof e == "string" || typeof e == "object") {
      if (typeof e == "string") {
        const a = Ed.HEX_PATTERN.exec(e);
        a && (e = `#${a[2]}`);
      }
      const r = Xi(e);
      r.isValid() && ({ r: t, g: i, b: s, a: o } = r.rgba, t /= 255, i /= 255, s /= 255);
    }
    if (t !== void 0)
      this._components[0] = t, this._components[1] = i, this._components[2] = s, this._components[3] = o, this._refreshInt();
    else
      throw new Error(`Unable to convert color ${e}`);
  }
  /** Refresh the internal color rgb number */
  _refreshInt() {
    this._clamp(this._components);
    const [e, t, i] = this._components;
    this._int = (e * 255 << 16) + (t * 255 << 8) + (i * 255 | 0);
  }
  /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */
  _clamp(e, t = 0, i = 1) {
    return typeof e == "number" ? Math.min(Math.max(e, t), i) : (e.forEach((s, o) => {
      e[o] = Math.min(Math.max(s, t), i);
    }), e);
  }
  /**
   * Check if a value can be interpreted as a valid color format.
   * Supports all color formats that can be used with the Color class.
   * @param value - Value to check
   * @returns True if the value can be used as a color
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // CSS colors and hex values
   * Color.isColorLike('red');          // true
   * Color.isColorLike('#ff0000');      // true
   * Color.isColorLike(0xff0000);       // true
   *
   * // Arrays (RGB/RGBA)
   * Color.isColorLike([1, 0, 0]);      // true
   * Color.isColorLike([1, 0, 0, 0.5]); // true
   *
   * // TypedArrays
   * Color.isColorLike(new Float32Array([1, 0, 0]));          // true
   * Color.isColorLike(new Uint8Array([255, 0, 0]));          // true
   * Color.isColorLike(new Uint8ClampedArray([255, 0, 0]));   // true
   *
   * // Object formats
   * Color.isColorLike({ r: 1, g: 0, b: 0 });            // true (RGB)
   * Color.isColorLike({ r: 1, g: 0, b: 0, a: 0.5 });    // true (RGBA)
   * Color.isColorLike({ h: 0, s: 100, l: 50 });         // true (HSL)
   * Color.isColorLike({ h: 0, s: 100, l: 50, a: 0.5 }); // true (HSLA)
   * Color.isColorLike({ h: 0, s: 100, v: 100 });        // true (HSV)
   * Color.isColorLike({ h: 0, s: 100, v: 100, a: 0.5 });// true (HSVA)
   *
   * // Color instances
   * Color.isColorLike(new Color('red')); // true
   *
   * // Invalid values
   * Color.isColorLike(null);           // false
   * Color.isColorLike(undefined);      // false
   * Color.isColorLike({});             // false
   * Color.isColorLike([]);             // false
   * Color.isColorLike('not-a-color');  // false
   * ```
   * @remarks
   * Checks for the following formats:
   * - Numbers (0x000000 to 0xffffff)
   * - CSS color strings
   * - RGB/RGBA arrays and objects
   * - HSL/HSLA objects
   * - HSV/HSVA objects
   * - TypedArrays (Float32Array, Uint8Array, Uint8ClampedArray)
   * - Color instances
   * @see {@link ColorSource} For supported color format types
   * @see {@link Color.setValue} For setting color values
   * @category utility
   */
  static isColorLike(e) {
    return typeof e == "number" || typeof e == "string" || e instanceof Number || e instanceof Ed || Array.isArray(e) || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Float32Array || e.r !== void 0 && e.g !== void 0 && e.b !== void 0 || e.r !== void 0 && e.g !== void 0 && e.b !== void 0 && e.a !== void 0 || e.h !== void 0 && e.s !== void 0 && e.l !== void 0 || e.h !== void 0 && e.s !== void 0 && e.l !== void 0 && e.a !== void 0 || e.h !== void 0 && e.s !== void 0 && e.v !== void 0 || e.h !== void 0 && e.s !== void 0 && e.v !== void 0 && e.a !== void 0;
  }
};
gl.shared = new gl();
gl._temp = new gl();
gl.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let pn = gl;
const hW = {
  cullArea: null,
  cullable: !1,
  cullableChildren: !0
};
let Zm = 0;
const jw = 500;
function at(...n) {
  Zm !== jw && (Zm++, Zm === jw ? console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.") : console.warn("PixiJS Warning: ", ...n));
}
const zl = {
  /**
   * Set of registered pools and cleanable objects.
   * @private
   */
  _registeredResources: /* @__PURE__ */ new Set(),
  /**
   * Registers a pool or cleanable object for cleanup.
   * @param {Cleanable} pool - The pool or object to register.
   */
  register(n) {
    this._registeredResources.add(n);
  },
  /**
   * Unregisters a pool or cleanable object from cleanup.
   * @param {Cleanable} pool - The pool or object to unregister.
   */
  unregister(n) {
    this._registeredResources.delete(n);
  },
  /** Clears all registered pools and cleanable objects. This will call clear() on each registered item. */
  release() {
    this._registeredResources.forEach((n) => n.clear());
  },
  /**
   * Gets the number of registered pools and cleanable objects.
   * @returns {number} The count of registered items.
   */
  get registeredCount() {
    return this._registeredResources.size;
  },
  /**
   * Checks if a specific pool or cleanable object is registered.
   * @param {Cleanable} pool - The pool or object to check.
   * @returns {boolean} True if the item is registered, false otherwise.
   */
  isRegistered(n) {
    return this._registeredResources.has(n);
  },
  /**
   * Removes all registrations without clearing the pools.
   * Useful if you want to reset the collector without affecting the pools.
   */
  reset() {
    this._registeredResources.clear();
  }
};
class pW {
  /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */
  constructor(e, t) {
    this._pool = [], this._count = 0, this._index = 0, this._classType = e, t && this.prepopulate(t);
  }
  /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */
  prepopulate(e) {
    for (let t = 0; t < e; t++)
      this._pool[this._index++] = new this._classType();
    this._count += e;
  }
  /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {I} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(e) {
    var i;
    let t;
    return this._index > 0 ? t = this._pool[--this._index] : (t = new this._classType(), this._count++), (i = t.init) == null || i.call(t, e), t;
  }
  /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */
  return(e) {
    var t;
    (t = e.reset) == null || t.call(e), this._pool[this._index++] = e;
  }
  /**
   * Gets the number of items in the pool.
   * @readonly
   */
  get totalSize() {
    return this._count;
  }
  /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   */
  get totalFree() {
    return this._index;
  }
  /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   */
  get totalUsed() {
    return this._count - this._index;
  }
  /** clears the pool */
  clear() {
    if (this._pool.length > 0 && this._pool[0].destroy)
      for (let e = 0; e < this._index; e++)
        this._pool[e].destroy();
    this._pool.length = 0, this._count = 0, this._index = 0;
  }
}
class fW {
  constructor() {
    this._poolsByClass = /* @__PURE__ */ new Map();
  }
  /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */
  prepopulate(e, t) {
    this.getPool(e).prepopulate(t);
  }
  /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(e, t) {
    return this.getPool(e).get(t);
  }
  /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */
  return(e) {
    this.getPool(e.constructor).return(e);
  }
  /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */
  getPool(e) {
    return this._poolsByClass.has(e) || this._poolsByClass.set(e, new pW(e)), this._poolsByClass.get(e);
  }
  /** gets the usage stats of each pool in the system */
  stats() {
    const e = {};
    return this._poolsByClass.forEach((t) => {
      const i = e[t._classType.name] ? t._classType.name + t._classType.ID : t._classType.name;
      e[i] = {
        free: t.totalFree,
        used: t.totalUsed,
        size: t.totalSize
      };
    }), e;
  }
  /** Clears all pools in the group. This will reset all pools and free their resources. */
  clear() {
    this._poolsByClass.forEach((e) => e.clear()), this._poolsByClass.clear();
  }
}
const Mn = new fW();
zl.register(Mn);
const mW = {
  get isCachedAsTexture() {
    var n;
    return !!((n = this.renderGroup) != null && n.isCachedAsTexture);
  },
  cacheAsTexture(n) {
    typeof n == "boolean" && n === !1 ? this.disableRenderGroup() : (this.enableRenderGroup(), this.renderGroup.enableCacheAsTexture(n === !0 ? {} : n));
  },
  updateCacheTexture() {
    var n;
    (n = this.renderGroup) == null || n.updateCacheTexture();
  },
  get cacheAsBitmap() {
    return this.isCachedAsTexture;
  },
  set cacheAsBitmap(n) {
    rt("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead."), this.cacheAsTexture(n);
  }
};
function $8(n, e, t) {
  const i = n.length;
  let s;
  if (e >= i || t === 0)
    return;
  t = e + t > i ? i - e : t;
  const o = i - t;
  for (s = e; s < o; ++s)
    n[s] = n[s + t];
  n.length = o;
}
const gW = {
  allowChildren: !0,
  removeChildren(n = 0, e) {
    var o;
    const t = e != null ? e : this.children.length, i = t - n, s = [];
    if (i > 0 && i <= t) {
      for (let a = t - 1; a >= n; a--) {
        const l = this.children[a];
        l && (s.push(l), l.parent = null);
      }
      $8(this.children, n, t);
      const r = this.renderGroup || this.parentRenderGroup;
      r && r.removeChildren(s);
      for (let a = 0; a < s.length; ++a) {
        const l = s[a];
        (o = l.parentRenderLayer) == null || o.detach(l), this.emit("childRemoved", l, this, a), s[a].emit("removed", this);
      }
      return s.length > 0 && this._didViewChangeTick++, s;
    } else if (i === 0 && this.children.length === 0)
      return s;
    throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
  },
  removeChildAt(n) {
    const e = this.getChildAt(n);
    return this.removeChild(e);
  },
  getChildAt(n) {
    if (n < 0 || n >= this.children.length)
      throw new Error(`getChildAt: Index (${n}) does not exist.`);
    return this.children[n];
  },
  setChildIndex(n, e) {
    if (e < 0 || e >= this.children.length)
      throw new Error(`The index ${e} supplied is out of bounds ${this.children.length}`);
    this.getChildIndex(n), this.addChildAt(n, e);
  },
  getChildIndex(n) {
    const e = this.children.indexOf(n);
    if (e === -1)
      throw new Error("The supplied Container must be a child of the caller");
    return e;
  },
  addChildAt(n, e) {
    this.allowChildren || rt(on, "addChildAt: Only Containers will be allowed to add children in v8.0.0");
    const { children: t } = this;
    if (e < 0 || e > t.length)
      throw new Error(`${n}addChildAt: The index ${e} supplied is out of bounds ${t.length}`);
    const i = n.parent === this;
    if (n.parent) {
      const o = n.parent.children.indexOf(n);
      if (i) {
        if (o === e)
          return n;
        n.parent.children.splice(o, 1);
      } else
        n.removeFromParent();
    }
    e === t.length ? t.push(n) : t.splice(e, 0, n);
    const s = this.renderGroup || this.parentRenderGroup;
    return this.sortableChildren && (this.sortDirty = !0), i ? (s && (s.structureDidChange = !0), n) : (n.parent = this, n.didChange = !0, n._updateFlags = 15, s && s.addChild(n), this.emit("childAdded", n, this, e), n.emit("added", this), n);
  },
  swapChildren(n, e) {
    if (n === e)
      return;
    const t = this.getChildIndex(n), i = this.getChildIndex(e);
    this.children[t] = e, this.children[i] = n;
    const s = this.renderGroup || this.parentRenderGroup;
    s && (s.structureDidChange = !0), this._didContainerChangeTick++;
  },
  removeFromParent() {
    var n;
    (n = this.parent) == null || n.removeChild(this);
  },
  reparentChild(...n) {
    return n.length === 1 ? this.reparentChildAt(n[0], this.children.length) : (n.forEach((e) => this.reparentChildAt(e, this.children.length)), n[0]);
  },
  reparentChildAt(n, e) {
    if (n.parent === this)
      return this.setChildIndex(n, e), n;
    const t = n.worldTransform.clone();
    n.removeFromParent(), this.addChildAt(n, e);
    const i = this.worldTransform.clone();
    return i.invert(), t.prepend(i), n.setFromMatrix(t), n;
  },
  replaceChild(n, e) {
    n.updateLocalTransform(), this.addChildAt(e, this.getChildIndex(n)), e.setFromMatrix(n.localTransform), e.updateLocalTransform(), this.removeChild(n);
  }
}, bW = {
  collectRenderables(n, e, t) {
    this.parentRenderLayer && this.parentRenderLayer !== t || this.globalDisplayStatus < 7 || !this.includeInBuild || (this.sortableChildren && this.sortChildren(), this.isSimple ? this.collectRenderablesSimple(n, e, t) : this.renderGroup ? e.renderPipes.renderGroup.addRenderGroup(this.renderGroup, n) : this.collectRenderablesWithEffects(n, e, t));
  },
  collectRenderablesSimple(n, e, t) {
    const i = this.children, s = i.length;
    for (let o = 0; o < s; o++)
      i[o].collectRenderables(n, e, t);
  },
  collectRenderablesWithEffects(n, e, t) {
    const { renderPipes: i } = e;
    for (let s = 0; s < this.effects.length; s++) {
      const o = this.effects[s];
      i[o.pipe].push(o, this, n);
    }
    this.collectRenderablesSimple(n, e, t);
    for (let s = this.effects.length - 1; s >= 0; s--) {
      const o = this.effects[s];
      i[o.pipe].pop(o, this, n);
    }
  }
};
class Bp {
  constructor() {
    this.pipe = "filter", this.priority = 1;
  }
  destroy() {
    for (let e = 0; e < this.filters.length; e++)
      this.filters[e].destroy();
    this.filters = null, this.filterArea = null;
  }
}
class vW {
  constructor() {
    this._effectClasses = [], this._tests = [], this._initialized = !1;
  }
  init() {
    this._initialized || (this._initialized = !0, this._effectClasses.forEach((e) => {
      this.add({
        test: e.test,
        maskClass: e
      });
    }));
  }
  add(e) {
    this._tests.push(e);
  }
  getMaskEffect(e) {
    this._initialized || this.init();
    for (let t = 0; t < this._tests.length; t++) {
      const i = this._tests[t];
      if (i.test(e))
        return Mn.get(i.maskClass, e);
    }
    return e;
  }
  returnMaskEffect(e) {
    Mn.return(e);
  }
}
const vv = new vW();
ct.handleByList(Ae.MaskEffect, vv._effectClasses);
const yW = {
  _maskEffect: null,
  _maskOptions: {
    inverse: !1,
    channel: "red"
  },
  _filterEffect: null,
  effects: [],
  _markStructureAsChanged() {
    const n = this.renderGroup || this.parentRenderGroup;
    n && (n.structureDidChange = !0);
  },
  addEffect(n) {
    this.effects.indexOf(n) === -1 && (this.effects.push(n), this.effects.sort((t, i) => t.priority - i.priority), this._markStructureAsChanged(), this._updateIsSimple());
  },
  removeEffect(n) {
    const e = this.effects.indexOf(n);
    e !== -1 && (this.effects.splice(e, 1), this._markStructureAsChanged(), this._updateIsSimple());
  },
  set mask(n) {
    const e = this._maskEffect;
    (e == null ? void 0 : e.mask) !== n && (e && (this.removeEffect(e), vv.returnMaskEffect(e), this._maskEffect = null), n != null && (this._maskEffect = vv.getMaskEffect(n), this.addEffect(this._maskEffect)));
  },
  get mask() {
    var n;
    return (n = this._maskEffect) == null ? void 0 : n.mask;
  },
  setMask(n) {
    this._maskOptions = {
      ...this._maskOptions,
      ...n
    }, n.mask && (this.mask = n.mask), this._markStructureAsChanged();
  },
  set filters(n) {
    var o;
    !Array.isArray(n) && n && (n = [n]);
    const e = this._filterEffect || (this._filterEffect = new Bp());
    n = n;
    const t = (n == null ? void 0 : n.length) > 0, i = ((o = e.filters) == null ? void 0 : o.length) > 0, s = t !== i;
    n = Array.isArray(n) ? n.slice(0) : n, e.filters = Object.freeze(n), s && (t ? this.addEffect(e) : (this.removeEffect(e), e.filters = n != null ? n : null));
  },
  get filters() {
    var n;
    return (n = this._filterEffect) == null ? void 0 : n.filters;
  },
  set filterArea(n) {
    this._filterEffect || (this._filterEffect = new Bp()), this._filterEffect.filterArea = n;
  },
  get filterArea() {
    var n;
    return (n = this._filterEffect) == null ? void 0 : n.filterArea;
  }
}, xW = {
  label: null,
  get name() {
    return rt(on, "Container.name property has been removed, use Container.label instead"), this.label;
  },
  set name(n) {
    rt(on, "Container.name property has been removed, use Container.label instead"), this.label = n;
  },
  getChildByName(n, e = !1) {
    return this.getChildByLabel(n, e);
  },
  getChildByLabel(n, e = !1) {
    const t = this.children;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      if (s.label === n || n instanceof RegExp && n.test(s.label)) return s;
    }
    if (e)
      for (let i = 0; i < t.length; i++) {
        const o = t[i].getChildByLabel(n, !0);
        if (o)
          return o;
      }
    return null;
  },
  getChildrenByLabel(n, e = !1, t = []) {
    const i = this.children;
    for (let s = 0; s < i.length; s++) {
      const o = i[s];
      (o.label === n || n instanceof RegExp && n.test(o.label)) && t.push(o);
    }
    if (e)
      for (let s = 0; s < i.length; s++)
        i[s].getChildrenByLabel(n, !0, t);
    return t;
  }
}, Kn = Mn.getPool(st), Hs = Mn.getPool(On), wW = new st(), kW = {
  getFastGlobalBounds(n, e) {
    e || (e = new On()), e.clear(), this._getGlobalBoundsRecursive(!!n, e, this.parentRenderLayer), e.isValid || e.set(0, 0, 0, 0);
    const t = this.renderGroup || this.parentRenderGroup;
    return e.applyMatrix(t.worldTransform), e;
  },
  _getGlobalBoundsRecursive(n, e, t) {
    let i = e;
    if (n && this.parentRenderLayer && this.parentRenderLayer !== t || this.localDisplayStatus !== 7 || !this.measurable)
      return;
    const s = !!this.effects.length;
    if ((this.renderGroup || s) && (i = Hs.get().clear()), this.boundsArea)
      e.addRect(this.boundsArea, this.worldTransform);
    else {
      if (this.renderPipeId) {
        const r = this.bounds;
        i.addFrame(
          r.minX,
          r.minY,
          r.maxX,
          r.maxY,
          this.groupTransform
        );
      }
      const o = this.children;
      for (let r = 0; r < o.length; r++)
        o[r]._getGlobalBoundsRecursive(n, i, t);
    }
    if (s) {
      let o = !1;
      const r = this.renderGroup || this.parentRenderGroup;
      for (let a = 0; a < this.effects.length; a++)
        this.effects[a].addBounds && (o || (o = !0, i.applyMatrix(r.worldTransform)), this.effects[a].addBounds(i, !0));
      o && i.applyMatrix(r.worldTransform.copyTo(wW).invert()), e.addBounds(i), Hs.return(i);
    } else this.renderGroup && (e.addBounds(i, this.relativeGroupTransform), Hs.return(i));
  }
};
function w1(n, e, t) {
  t.clear();
  let i, s;
  return n.parent ? e ? i = n.parent.worldTransform : (s = Kn.get().identity(), i = k1(n, s)) : i = st.IDENTITY, D8(n, t, i, e), s && Kn.return(s), t.isValid || t.set(0, 0, 0, 0), t;
}
function D8(n, e, t, i) {
  var a, l;
  if (!n.visible || !n.measurable) return;
  let s;
  i ? s = n.worldTransform : (n.updateLocalTransform(), s = Kn.get(), s.appendFrom(n.localTransform, t));
  const o = e, r = !!n.effects.length;
  if (r && (e = Hs.get().clear()), n.boundsArea)
    e.addRect(n.boundsArea, s);
  else {
    const d = n.bounds;
    d && !d.isEmpty() && (e.matrix = s, e.addBounds(d));
    for (let c = 0; c < n.children.length; c++)
      D8(n.children[c], e, s, i);
  }
  if (r) {
    for (let d = 0; d < n.effects.length; d++)
      (l = (a = n.effects[d]).addBounds) == null || l.call(a, e);
    o.addBounds(e, st.IDENTITY), Hs.return(e);
  }
  i || Kn.return(s);
}
function k1(n, e) {
  const t = n.parent;
  return t && (k1(t, e), t.updateLocalTransform(), e.append(t.localTransform)), e;
}
function Vr(n, e) {
  if (n === 16777215 || !e) return e;
  if (e === 16777215 || !n) return n;
  const t = n >> 16 & 255, i = n >> 8 & 255, s = n & 255, o = e >> 16 & 255, r = e >> 8 & 255, a = e & 255, l = t * o / 255 | 0, d = i * r / 255 | 0, c = s * a / 255 | 0;
  return (l << 16) + (d << 8) + c;
}
const Hw = 16777215;
function Fp(n, e) {
  return n === Hw ? e : e === Hw ? n : Vr(n, e);
}
function Wr(n) {
  return ((n & 255) << 16) + (n & 65280) + (n >> 16 & 255);
}
const _W = {
  getGlobalAlpha(n) {
    if (n)
      return this.renderGroup ? this.renderGroup.worldAlpha : this.parentRenderGroup ? this.parentRenderGroup.worldAlpha * this.alpha : this.alpha;
    let e = this.alpha, t = this.parent;
    for (; t; )
      e *= t.alpha, t = t.parent;
    return e;
  },
  getGlobalTransform(n = new st(), e) {
    if (e)
      return n.copyFrom(this.worldTransform);
    this.updateLocalTransform();
    const t = k1(this, Kn.get().identity());
    return n.appendFrom(this.localTransform, t), Kn.return(t), n;
  },
  getGlobalTint(n) {
    if (n)
      return this.renderGroup ? Wr(this.renderGroup.worldColor) : this.parentRenderGroup ? Wr(
        Fp(this.localColor, this.parentRenderGroup.worldColor)
      ) : this.tint;
    let e = this.localColor, t = this.parent;
    for (; t; )
      e = Fp(e, t.localColor), t = t.parent;
    return Wr(e);
  }
};
function _1(n, e, t) {
  return e.clear(), t || (t = st.IDENTITY), O8(n, e, t, n, !0), e.isValid || e.set(0, 0, 0, 0), e;
}
function O8(n, e, t, i, s) {
  var l, d;
  let o;
  if (s)
    o = Kn.get(), o = t.copyTo(o);
  else {
    if (!n.visible || !n.measurable) return;
    n.updateLocalTransform();
    const c = n.localTransform;
    o = Kn.get(), o.appendFrom(c, t);
  }
  const r = e, a = !!n.effects.length;
  if (a && (e = Hs.get().clear()), n.boundsArea)
    e.addRect(n.boundsArea, o);
  else {
    n.renderPipeId && (e.matrix = o, e.addBounds(n.bounds));
    const c = n.children;
    for (let u = 0; u < c.length; u++)
      O8(c[u], e, o, i, !1);
  }
  if (a) {
    for (let c = 0; c < n.effects.length; c++)
      (d = (l = n.effects[c]).addLocalBounds) == null || d.call(l, e, i);
    r.addBounds(e, st.IDENTITY), Hs.return(e);
  }
  Kn.return(o);
}
function L8(n, e) {
  const t = n.children;
  for (let i = 0; i < t.length; i++) {
    const s = t[i], o = s.uid, r = (s._didViewChangeTick & 65535) << 16 | s._didContainerChangeTick & 65535, a = e.index;
    (e.data[a] !== o || e.data[a + 1] !== r) && (e.data[e.index] = o, e.data[e.index + 1] = r, e.didChange = !0), e.index = a + 2, s.children.length && L8(s, e);
  }
  return e.didChange;
}
const SW = new st(), TW = {
  _localBoundsCacheId: -1,
  _localBoundsCacheData: null,
  _setWidth(n, e) {
    const t = Math.sign(this.scale.x) || 1;
    e !== 0 ? this.scale.x = n / e * t : this.scale.x = t;
  },
  _setHeight(n, e) {
    const t = Math.sign(this.scale.y) || 1;
    e !== 0 ? this.scale.y = n / e * t : this.scale.y = t;
  },
  getLocalBounds() {
    this._localBoundsCacheData || (this._localBoundsCacheData = {
      data: [],
      index: 1,
      didChange: !1,
      localBounds: new On()
    });
    const n = this._localBoundsCacheData;
    return n.index = 1, n.didChange = !1, n.data[0] !== this._didViewChangeTick && (n.didChange = !0, n.data[0] = this._didViewChangeTick), L8(this, n), n.didChange && _1(this, n.localBounds, SW), n.localBounds;
  },
  getBounds(n, e) {
    return w1(this, n, e || new On());
  }
}, MW = {
  _onRender: null,
  set onRender(n) {
    const e = this.renderGroup || this.parentRenderGroup;
    if (!n) {
      this._onRender && (e == null || e.removeOnRender(this)), this._onRender = null;
      return;
    }
    this._onRender || e == null || e.addOnRender(this), this._onRender = n;
  },
  get onRender() {
    return this._onRender;
  }
}, CW = {
  _zIndex: 0,
  sortDirty: !1,
  sortableChildren: !1,
  get zIndex() {
    return this._zIndex;
  },
  set zIndex(n) {
    this._zIndex !== n && (this._zIndex = n, this.depthOfChildModified());
  },
  depthOfChildModified() {
    this.parent && (this.parent.sortableChildren = !0, this.parent.sortDirty = !0), this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0);
  },
  sortChildren() {
    this.sortDirty && (this.sortDirty = !1, this.children.sort(IW));
  }
};
function IW(n, e) {
  return n._zIndex - e._zIndex;
}
const AW = {
  getGlobalPosition(n = new Gt(), e = !1) {
    return this.parent ? this.parent.toGlobal(this._position, n, e) : (n.x = this._position.x, n.y = this._position.y), n;
  },
  toGlobal(n, e, t = !1) {
    const i = this.getGlobalTransform(Kn.get(), t);
    return e = i.apply(n, e), Kn.return(i), e;
  },
  toLocal(n, e, t, i) {
    e && (n = e.toGlobal(n, t, i));
    const s = this.getGlobalTransform(Kn.get(), i);
    return t = s.applyInverse(n, t), Kn.return(s), t;
  }
};
class S1 {
  constructor() {
    this.uid = Lt("instructionSet"), this.instructions = [], this.instructionSize = 0, this.renderables = [], this.gcTick = 0;
  }
  /** reset the instruction set so it can be reused set size back to 0 */
  reset() {
    this.instructionSize = 0;
  }
  /**
   * Destroy the instruction set, clearing the instructions and renderables and notifying
   * each render pipe so it can release any per-InstructionSet cached resources.
   * @internal
   */
  destroy() {
    var e, t;
    if (this.renderPipes)
      for (const i in this.renderPipes)
        (t = (e = this.renderPipes[i]).destroyInstructionSet) == null || t.call(e, this);
    this.instructions.length = 0, this.renderables.length = 0, this.renderPipes = null, this.gcTick = 0;
  }
  /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */
  add(e) {
    this.instructions[this.instructionSize++] = e;
  }
  /**
   * Log the instructions to the console (for debugging)
   * @internal
   */
  log() {
    this.instructions.length = this.instructionSize, console.table(this.instructions, ["type", "action"]);
  }
}
class B8 {
  constructor() {
    this._screenSizes = /* @__PURE__ */ new Map(), this._widths = [], this._heights = [];
  }
  /** The number of renderers with a registered screen. */
  get size() {
    return this._screenSizes.size;
  }
  /**
   * Registers, or updates, the screen size of a renderer.
   * @param rendererUid - The uid of the renderer, used to update or remove this screen later.
   * @param pixelWidth - The width of the screen in physical pixels.
   * @param pixelHeight - The height of the screen in physical pixels.
   * @returns `true` if this changed the registered screens, `false` if the size was already registered.
   */
  set(e, t, i) {
    const s = this._screenSizes.get(e);
    return s && s.pixelWidth === t && s.pixelHeight === i ? !1 : (this._screenSizes.set(e, { pixelWidth: t, pixelHeight: i }), this._update(), !0);
  }
  /**
   * Removes the screen of a renderer.
   * @param rendererUid - The uid the screen was registered with.
   * @returns `true` if a screen was removed, `false` if the renderer had none registered.
   */
  remove(e) {
    return this._screenSizes.delete(e) ? (this._update(), !0) : !1;
  }
  /**
   * The smallest registered screen width the request fits in.
   * @param pixelWidth - The requested width in physical pixels.
   * @returns The smallest live screen width that is at least `pixelWidth`, or `undefined` if none.
   */
  getFittingWidth(e) {
    return this._getFittingAxis(e, this._widths);
  }
  /**
   * The smallest registered screen height the request fits in.
   * @param pixelHeight - The requested height in physical pixels.
   * @returns The smallest live screen height that is at least `pixelHeight`, or `undefined` if none.
   */
  getFittingHeight(e) {
    return this._getFittingAxis(e, this._heights);
  }
  /**
   * Whether a live screen uses this width.
   * @param width - The width in physical pixels.
   */
  hasWidth(e) {
    return this._widths.includes(e);
  }
  /**
   * Whether a live screen uses this height.
   * @param height - The height in physical pixels.
   */
  hasHeight(e) {
    return this._heights.includes(e);
  }
  /**
   * The smallest registered screen on this axis that the request still fits in.
   * @param pixelSize - The requested size on this axis in physical pixels.
   * @param screenSizes - The live screen sizes on this axis, sorted ascending.
   * @returns The smallest screen size that is at least `pixelSize`, or `undefined` if none.
   */
  _getFittingAxis(e, t) {
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      if (s >= e) return s;
    }
  }
  /** Rebuilds the sorted unique sizes for each axis. */
  _update() {
    this._widths = [...this._screenSizes.values()].map((e) => e.pixelWidth).filter((e, t, i) => i.indexOf(e) === t).sort((e, t) => e - t), this._heights = [...this._screenSizes.values()].map((e) => e.pixelHeight).filter((e, t, i) => i.indexOf(e) === t).sort((e, t) => e - t);
  }
}
let PW = 0;
const Qm = 32767, EW = 4294967296, RW = 8589934592, Vw = /* @__PURE__ */ Object.create(null);
let zW = 0;
function $W(n) {
  const e = Vw[n];
  return e !== void 0 ? e : Vw[n] = zW++;
}
function DW(n, e, t, i, s, o) {
  return (n << 17) + (e << 2) + ((i ? 1 : 0) << 1) + (t ? 1 : 0) + (o === "nearest" ? 1 : 0) * EW + $W(s) * RW;
}
class OW {
  /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */
  constructor(e) {
    this._buckets = /* @__PURE__ */ new Map(), this._poolKey = /* @__PURE__ */ Object.create(null), this._poolStyle = /* @__PURE__ */ Object.create(null), this._screens = new B8(), this._enableFullScreen = !1, this.textureOptions = e || {};
  }
  /**
   * A style built from the pool options. The pool no longer applies it to anything.
   * @deprecated since 8.21.0, pooled textures carry their own style; pass `scaleMode` in the request instead.
   */
  get textureStyle() {
    return rt(zs, "TexturePool.textureStyle is no longer used, pooled textures carry their own style. Pass scaleMode in the request instead."), this._textureStyle || (this._textureStyle = new Yh(this.textureOptions)), this._textureStyle;
  }
  set textureStyle(e) {
    rt(zs, "TexturePool.textureStyle is no longer used, pooled textures carry their own style. Pass scaleMode in the request instead."), this._textureStyle = e;
  }
  /**
   * Has no effect. The pool sizes textures to the screens registered with
   * {@link TexturePoolClass#setScreenSize|setScreenSize}.
   * @deprecated since 8.21.0
   */
  get enableFullScreen() {
    return rt(zs, "TexturePool.enableFullScreen is no longer used, the pool sizes textures to the screens registered with setScreenSize."), this._enableFullScreen;
  }
  set enableFullScreen(e) {
    rt(zs, "TexturePool.enableFullScreen is no longer used, the pool sizes textures to the screens registered with setScreenSize."), this._enableFullScreen = e;
  }
  createTexture(...e) {
    var r, a, l, d, c, u, p, f;
    let t = e[0];
    typeof t == "number" && (rt(zs, "TexturePool.createTexture params are now an options object. See params: { width, height, antialias, autoGenerateMipmaps }"), t = {
      width: t,
      height: e[1],
      antialias: (r = e[2]) != null ? r : !1,
      autoGenerateMipmaps: (a = e[3]) != null ? a : !1
    });
    const i = (d = (l = t.format) != null ? l : this.textureOptions.format) != null ? d : an.defaultOptions.format, s = (u = (c = t.scaleMode) != null ? c : this.textureOptions.scaleMode) != null ? u : Yh.defaultOptions.scaleMode, o = new an({
      ...this.textureOptions,
      width: t.width,
      height: t.height,
      resolution: 1,
      antialias: (p = t.antialias) != null ? p : !1,
      autoGarbageCollect: !1,
      autoGenerateMipmaps: (f = t.autoGenerateMipmaps) != null ? f : !1,
      format: i,
      scaleMode: s
    });
    return new Ze({
      source: o,
      label: `texturePool_${PW++}`
    });
  }
  getOptimalTexture(...e) {
    var b, w, k, S, _, x, T, M, z, P;
    let t = e[0];
    typeof t == "number" && (rt(zs, "TexturePool.getOptimalTexture params are now an options object. See params: { width, height, resolution, antialias, autoGenerateMipmaps }"), t = {
      width: t,
      height: e[1],
      resolution: (b = e[2]) != null ? b : 1,
      antialias: (w = e[3]) != null ? w : !1,
      autoGenerateMipmaps: (k = e[4]) != null ? k : !1
    });
    const i = t.width, s = t.height, o = (S = t.resolution) != null ? S : 1, r = (_ = t.antialias) != null ? _ : !1, a = (x = t.autoGenerateMipmaps) != null ? x : !1, l = (M = (T = t.format) != null ? T : this.textureOptions.format) != null ? M : an.defaultOptions.format, d = (P = (z = t.scaleMode) != null ? z : this.textureOptions.scaleMode) != null ? P : Yh.defaultOptions.scaleMode, { width: c, height: u } = this.getOptimalSize(
      i,
      s,
      o
    );
    (c > Qm || u > Qm) && at(`TexturePool: ${c}x${u} is larger than the ${Qm}px pool key limit, textures of this size may be pooled together`);
    const p = DW(c, u, r, a, l, d);
    let f = this._buckets.get(p);
    f || (f = [], this._buckets.set(p, f));
    let y = f.pop();
    return y || (y = this.createTexture({
      width: c,
      height: u,
      antialias: r,
      autoGenerateMipmaps: a,
      format: l,
      scaleMode: d
    }), this._poolStyle[y.uid] = y.source.style), y.source._resolution = o, y.source.width = c / o, y.source.height = u / o, y.source.pixelWidth = c, y.source.pixelHeight = u, y.frame.x = 0, y.frame.y = 0, y.frame.width = i, y.frame.height = s, y.updateUvs(), this._poolKey[y.uid] = p, y;
  }
  /**
   * The backing size, in physical pixels, that {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * would allocate for a request, without taking a texture from the pool.
   *
   * Each axis is the next power of two, or the smallest registered screen the request fits inside
   * (see {@link TexturePoolClass#setScreenSize|setScreenSize}). Use it when a consumer needs to know
   * where a request's content will sit inside its pooled texture before it has one, such as a uniform
   * that maps content space onto texture space.
   * @param frameWidth - The minimum width of the texture.
   * @param frameHeight - The minimum height of the texture.
   * @param resolution - The resolution of the texture.
   * @returns The width and height the pooled texture would have, in physical pixels.
   */
  getOptimalSize(e, t, i = 1) {
    const s = Math.ceil(e * i - 1e-6), o = Math.ceil(t * i - 1e-6), r = Lp(s), a = this._screens.getFittingWidth(s), l = Lp(o), d = this._screens.getFittingHeight(o);
    return {
      width: a !== void 0 ? Math.min(a, r) : r,
      height: d !== void 0 ? Math.min(d, l) : l
    };
  }
  /**
   * Gets a pooled texture matching the dimensions and resolution of the given texture.
   *
   * This is a convenience wrapper around {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * that copies width, height, and resolution from an existing texture. Useful when a filter needs
   * a temporary texture the same size as its input (e.g., for multi-pass blur).
   * @param texture - The texture whose dimensions to match.
   * @param antialias - Whether to use antialias on the pooled texture. Defaults to `false`.
   * @returns A pooled texture with power-of-two or screen sized backing dimensions at the source resolution.
   */
  getSameSizeTexture(e, t = !1) {
    const i = e.source;
    return this.getOptimalTexture({
      width: e.width,
      height: e.height,
      resolution: i._resolution,
      antialias: t
    });
  }
  /**
   * Returns a texture to the pool so it can be reused by future
   * {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * or {@link TexturePoolClass#getSameSizeTexture|getSameSizeTexture} calls.
   *
   * If you gave the texture a style of your own after obtaining it (a different address mode, anisotropy
   * or similar), pass `resetStyle = true` so the pool puts its own style back. Otherwise your style stays
   * on the texture and the next consumer inherits it.
   * @param renderTexture - The texture to return to the pool.
   * @param resetStyle - When `true`, restores the style the pool created for this texture. Defaults to `false`.
   */
  returnTexture(e, t = !1) {
    const i = e.uid, s = this._poolKey[i];
    if (s === void 0) {
      at("TexturePool: returnTexture was passed a texture that did not come from this pool, ignoring it");
      return;
    }
    const o = this._poolStyle[i];
    t && e.source.style !== o && (e.source.style = o);
    const r = this._buckets.get(s);
    if (!r) {
      delete this._poolKey[i], delete this._poolStyle[i], e.destroy(!0);
      return;
    }
    r.push(e);
  }
  /**
   * Registers the screen size of a renderer with the pool, in physical pixels.
   *
   * While a screen is registered, a request that fits inside it on an axis is given that screen's size on
   * that axis instead of the next power of two, which stops a full screen filter from allocating a texture
   * far larger than the screen. Requests larger than every registered screen on an axis keep the power of
   * two size - the pool never rounds a request up to a screen it does not fit in.
   * @param rendererUid - The uid of the renderer, used to update or remove this screen later.
   * @param pixelWidth - The width of the screen in physical pixels.
   * @param pixelHeight - The height of the screen in physical pixels.
   */
  setScreenSize(e, t, i) {
    this._screens.set(e, t, i) && this._pruneScreenTextures();
  }
  /**
   * Removes a screen previously registered with
   * {@link TexturePoolClass#setScreenSize|setScreenSize}, destroying any idle textures that were
   * only being kept for it.
   * @param rendererUid - The uid the screen was registered with.
   */
  removeScreen(e) {
    this._screens.remove(e) && this._pruneScreenTextures();
  }
  /**
   * Destroys the idle textures in every bucket that has a non power of two dimension matching no live
   * screen. Power of two buckets are always kept, as any request can fall back to them.
   */
  _pruneScreenTextures() {
    for (const [e, t] of this._buckets) {
      const i = e >>> 0, s = i >>> 17, o = i >>> 2 & 32767;
      (ml(s) || this._screens.hasWidth(s)) && (ml(o) || this._screens.hasHeight(o)) || (this._dropTextures(t, !0), this._buckets.delete(e));
    }
  }
  /**
   * Forgets idle textures were ever handed out, so a later return is ignored, and optionally destroys them.
   * @param textures - The textures of one bucket.
   * @param destroy - Whether to destroy the textures as well.
   */
  _dropTextures(e, t) {
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      delete this._poolKey[s.uid], delete this._poolStyle[s.uid], t && s.destroy(!0);
    }
  }
  /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */
  clear(e) {
    for (const t of this._buckets.values())
      this._dropTextures(t, e !== !1);
    this._buckets.clear();
  }
}
const Rn = new OW();
zl.register(Rn);
class yv {
  constructor() {
    this.renderPipeId = "renderGroup", this.root = null, this.canBundle = !1, this.renderGroupParent = null, this.renderGroupChildren = [], this.worldTransform = new st(), this.worldColorAlpha = 4294967295, this.worldColor = 16777215, this.worldAlpha = 1, this.childrenToUpdate = /* @__PURE__ */ Object.create(null), this.updateTick = 0, this.gcTick = 0, this.childrenRenderablesToUpdate = { list: [], index: 0 }, this.structureDidChange = !0, this.instructionSet = new S1(), this._onRenderContainers = [], this.textureNeedsUpdate = !0, this.isCachedAsTexture = !1, this._matrixDirty = 7;
  }
  init(e) {
    this.root = e, e._onRender && this.addOnRender(e), e.didChange = !0;
    const t = e.children;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      s._updateFlags = 15, this.addChild(s);
    }
  }
  enableCacheAsTexture(e = {}) {
    this.textureOptions = e, this.isCachedAsTexture = !0, this.textureNeedsUpdate = !0;
  }
  disableCacheAsTexture() {
    this.isCachedAsTexture = !1, this.texture && (Rn.returnTexture(this.texture), this.texture = null);
  }
  updateCacheTexture() {
    this.textureNeedsUpdate = !0;
    const e = this._parentCacheAsTextureRenderGroup;
    e && !e.textureNeedsUpdate && e.updateCacheTexture();
  }
  reset() {
    this.renderGroupChildren.length = 0;
    for (const e in this.childrenToUpdate) {
      const t = this.childrenToUpdate[e];
      t.list.fill(null), t.index = 0;
    }
    this.childrenRenderablesToUpdate.index = 0, this.childrenRenderablesToUpdate.list.fill(null), this.root = null, this.updateTick = 0, this.structureDidChange = !0, this._onRenderContainers.length = 0, this.renderGroupParent = null, this.disableCacheAsTexture();
  }
  get localTransform() {
    return this.root.localTransform;
  }
  addRenderGroupChild(e) {
    e.renderGroupParent && e.renderGroupParent._removeRenderGroupChild(e), e.renderGroupParent = this, this.renderGroupChildren.push(e);
  }
  _removeRenderGroupChild(e) {
    const t = this.renderGroupChildren.indexOf(e);
    t > -1 && this.renderGroupChildren.splice(t, 1), e.renderGroupParent = null;
  }
  addChild(e) {
    if (this.structureDidChange = !0, e.parentRenderGroup = this, e.updateTick = -1, e.parent === this.root ? e.relativeRenderGroupDepth = 1 : e.relativeRenderGroupDepth = e.parent.relativeRenderGroupDepth + 1, e.didChange = !0, this.onChildUpdate(e), e.renderGroup) {
      this.addRenderGroupChild(e.renderGroup);
      return;
    }
    e._onRender && this.addOnRender(e);
    const t = e.children;
    for (let i = 0; i < t.length; i++)
      this.addChild(t[i]);
  }
  removeChild(e) {
    if (this.structureDidChange = !0, e._onRender && (e.renderGroup || this.removeOnRender(e)), e.parentRenderGroup = null, e.renderGroup) {
      this._removeRenderGroupChild(e.renderGroup);
      return;
    }
    const t = e.children;
    for (let i = 0; i < t.length; i++)
      this.removeChild(t[i]);
  }
  removeChildren(e) {
    for (let t = 0; t < e.length; t++)
      this.removeChild(e[t]);
  }
  onChildUpdate(e) {
    let t = this.childrenToUpdate[e.relativeRenderGroupDepth];
    t || (t = this.childrenToUpdate[e.relativeRenderGroupDepth] = {
      index: 0,
      list: []
    }), t.list[t.index++] = e;
  }
  updateRenderable(e) {
    e.globalDisplayStatus < 7 || (this.instructionSet.renderPipes[e.renderPipeId].updateRenderable(e), e.didViewUpdate = !1);
  }
  onChildViewUpdate(e) {
    this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = e;
  }
  get isRenderable() {
    return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
  }
  /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */
  addOnRender(e) {
    this._onRenderContainers.indexOf(e) === -1 && this._onRenderContainers.push(e);
  }
  removeOnRender(e) {
    const t = this._onRenderContainers.indexOf(e);
    t !== -1 && this._onRenderContainers.splice(t, 1);
  }
  runOnRender(e) {
    for (let t = 0; t < this._onRenderContainers.length; t++)
      this._onRenderContainers[t]._onRender(e);
  }
  destroy() {
    var e;
    this.disableCacheAsTexture(), this.renderGroupParent = null, this.root = null, this.childrenRenderablesToUpdate = null, this.childrenToUpdate = null, this.renderGroupChildren = null, this._onRenderContainers = null, (e = this.instructionSet) == null || e.destroy(), this.instructionSet = null;
  }
  getChildren(e = []) {
    const t = this.root.children;
    for (let i = 0; i < t.length; i++)
      this._getChildren(t[i], e);
    return e;
  }
  _getChildren(e, t = []) {
    if (t.push(e), e.renderGroup) return t;
    const i = e.children;
    for (let s = 0; s < i.length; s++)
      this._getChildren(i[s], t);
    return t;
  }
  invalidateMatrices() {
    this._matrixDirty = 7;
  }
  /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */
  get inverseWorldTransform() {
    return (this._matrixDirty & 1) === 0 ? this._inverseWorldTransform : (this._matrixDirty &= -2, this._inverseWorldTransform || (this._inverseWorldTransform = new st()), this._inverseWorldTransform.copyFrom(this.worldTransform).invert());
  }
  /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */
  get textureOffsetInverseTransform() {
    return (this._matrixDirty & 2) === 0 ? this._textureOffsetInverseTransform : (this._matrixDirty &= -3, this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new st()), this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(
      -this._textureBounds.x,
      -this._textureBounds.y
    ));
  }
  /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */
  get inverseParentTextureTransform() {
    if ((this._matrixDirty & 4) === 0) return this._inverseParentTextureTransform;
    this._matrixDirty &= -5;
    const e = this._parentCacheAsTextureRenderGroup;
    return e ? (this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new st()), this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(e.inverseWorldTransform).translate(
      -e._textureBounds.x,
      -e._textureBounds.y
    )) : this.worldTransform;
  }
  /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */
  get cacheToLocalTransform() {
    return this.isCachedAsTexture ? this.textureOffsetInverseTransform : this._parentCacheAsTextureRenderGroup ? this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform : null;
  }
}
function LW(n, e, t = {}) {
  for (const i in e)
    !t[i] && e[i] !== void 0 && (n[i] = e[i]);
}
const eg = new En(null), Pu = new En(null), tg = new En(null, 1, 1), Eu = new En(null), Np = 1, T1 = 2, Qd = 4;
class un extends di {
  constructor(e = {}) {
    var t, i;
    super(), this.uid = Lt("renderable"), this._updateFlags = 15, this.renderGroup = null, this.parentRenderGroup = null, this.parentRenderGroupIndex = 0, this.didChange = !1, this.didViewUpdate = !1, this.relativeRenderGroupDepth = 0, this.children = [], this.parent = null, this.includeInBuild = !0, this.measurable = !0, this.isSimple = !0, this.parentRenderLayer = null, this.updateTick = -1, this.localTransform = new st(), this.relativeGroupTransform = new st(), this.groupTransform = this.relativeGroupTransform, this.destroyed = !1, this._position = new En(this, 0, 0), this._scale = tg, this._pivot = Pu, this._origin = Eu, this._skew = eg, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._rotation = 0, this.localColor = 16777215, this.localAlpha = 1, this.groupAlpha = 1, this.groupColor = 16777215, this.groupColorAlpha = 4294967295, this.localBlendMode = "inherit", this.groupBlendMode = "normal", this.localDisplayStatus = 7, this.globalDisplayStatus = 7, this._didContainerChangeTick = 0, this._didViewChangeTick = 0, this._didLocalTransformChangeId = -1, this.effects = [], LW(this, e, {
      children: !0,
      parent: !0,
      effects: !0
    }), (t = e.children) == null || t.forEach((s) => this.addChild(s)), (i = e.parent) == null || i.addChild(this);
  }
  /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */
  static mixin(e) {
    rt("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead."), ct.mixin(un, e);
  }
  // = 'default';
  /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */
  set _didChangeId(e) {
    this._didViewChangeTick = e >> 12 & 4095, this._didContainerChangeTick = e & 4095;
  }
  /** @ignore */
  get _didChangeId() {
    return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
  }
  /**
   * Adds one or more children to the container.
   * The children will be rendered as part of this container's display list.
   * @example
   * ```ts
   * // Add a single child
   * container.addChild(sprite);
   *
   * // Add multiple children
   * container.addChild(background, player, foreground);
   *
   * // Add with type checking
   * const sprite = container.addChild<Sprite>(new Sprite(texture));
   * sprite.tint = 'red';
   * ```
   * @param children - The Container(s) to add to the container
   * @returns The first child that was added
   * @see {@link Container#removeChild} For removing children
   * @see {@link Container#addChildAt} For adding at specific index
   */
  addChild(...e) {
    if (this.allowChildren || rt(on, "addChild: Only Containers will be allowed to add children in v8.0.0"), e.length > 1) {
      for (let s = 0; s < e.length; s++)
        this.addChild(e[s]);
      return e[0];
    }
    const t = e[0], i = this.renderGroup || this.parentRenderGroup;
    return t.parent === this ? (this.children.splice(this.children.indexOf(t), 1), this.children.push(t), i && (i.structureDidChange = !0), t) : (t.parent && t.parent.removeChild(t), this.children.push(t), this.sortableChildren && (this.sortDirty = !0), t.parent = this, t.didChange = !0, t._updateFlags = 15, i && i.addChild(t), this.emit("childAdded", t, this, this.children.length - 1), t.emit("added", this), this._didViewChangeTick++, t._zIndex !== 0 && t.depthOfChildModified(), t);
  }
  /**
   * Removes one or more children from the container.
   * When removing multiple children, events will be triggered for each child in sequence.
   * @example
   * ```ts
   * // Remove a single child
   * const removed = container.removeChild(sprite);
   *
   * // Remove multiple children
   * const bg = container.removeChild(background, player, userInterface);
   *
   * // Remove with type checking
   * const sprite = container.removeChild<Sprite>(childSprite);
   * sprite.texture = newTexture;
   * ```
   * @param children - The Container(s) to remove
   * @returns The first child that was removed
   * @see {@link Container#addChild} For adding children
   * @see {@link Container#removeChildren} For removing multiple children
   */
  removeChild(...e) {
    if (e.length > 1) {
      for (let s = 0; s < e.length; s++)
        this.removeChild(e[s]);
      return e[0];
    }
    const t = e[0], i = this.children.indexOf(t);
    return i > -1 && (this._didViewChangeTick++, this.children.splice(i, 1), this.renderGroup ? this.renderGroup.removeChild(t) : this.parentRenderGroup && this.parentRenderGroup.removeChild(t), t.parentRenderLayer && t.parentRenderLayer.detach(t), t.parent = null, this.emit("childRemoved", t, this, i), t.emit("removed", this)), t;
  }
  /** @ignore */
  _onUpdate(e) {
    e && e === this._skew && this._updateSkew(), this._didContainerChangeTick++, !this.didChange && (this.didChange = !0, this.parentRenderGroup && this.parentRenderGroup.onChildUpdate(this));
  }
  set isRenderGroup(e) {
    !!this.renderGroup !== e && (e ? this.enableRenderGroup() : this.disableRenderGroup());
  }
  /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   * @advanced
   */
  get isRenderGroup() {
    return !!this.renderGroup;
  }
  /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   * @advanced
   */
  enableRenderGroup() {
    if (this.renderGroup) return;
    const e = this.parentRenderGroup;
    e == null || e.removeChild(this), this.renderGroup = Mn.get(yv, this), this.groupTransform = st.IDENTITY, e == null || e.addChild(this), this._updateIsSimple();
  }
  /**
   * This will disable the render group for this container.
   * @advanced
   */
  disableRenderGroup() {
    if (!this.renderGroup) return;
    const e = this.parentRenderGroup;
    e == null || e.removeChild(this), Mn.return(this.renderGroup), this.renderGroup = null, this.groupTransform = this.relativeGroupTransform, e == null || e.addChild(this), this._updateIsSimple();
  }
  /** @ignore */
  _updateIsSimple() {
    this.isSimple = !this.renderGroup && this.effects.length === 0;
  }
  /**
   * Current transform of the object based on world (parent) factors.
   *
   * This matrix represents the absolute transformation in the scene graph.
   * @example
   * ```ts
   * // Get world position
   * const worldPos = container.worldTransform;
   * console.log(`World position: (${worldPos.tx}, ${worldPos.ty})`);
   * ```
   * @readonly
   * @see {@link Container#localTransform} For local space transform
   */
  get worldTransform() {
    return this._worldTransform || (this._worldTransform = new st()), this.renderGroup ? this._worldTransform.copyFrom(this.renderGroup.worldTransform) : this.parentRenderGroup && this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform), this._worldTransform;
  }
  /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   *
   * An alias to position.x
   * @example
   * ```ts
   * // Basic position
   * container.x = 100;
   * ```
   */
  get x() {
    return this._position.x;
  }
  set x(e) {
    this._position.x = e;
  }
  /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   *
   * An alias to position.y
   * @example
   * ```ts
   * // Basic position
   * container.y = 200;
   * ```
   */
  get y() {
    return this._position.y;
  }
  set y(e) {
    this._position.y = e;
  }
  /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @example
   * ```ts
   * // Basic position setting
   * container.position.set(100, 200);
   * container.position.set(100); // Sets both x and y to 100
   * // Using point data
   * container.position = { x: 50, y: 75 };
   * ```
   * @since 4.0.0
   */
  get position() {
    return this._position;
  }
  set position(e) {
    this._position.copyFrom(e);
  }
  /**
   * The rotation of the object in radians.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   *
   * // Convert from degrees
   * const degrees = 45;
   * container.rotation = degrees * Math.PI / 180;
   *
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   *
   * // Rotate around center with origin
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   * ```
   */
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation !== e && (this._rotation = e, this._onUpdate(this._skew));
  }
  /**
   * The angle of the object in degrees.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic angle rotation
   * sprite.angle = 45; // 45 degrees
   *
   * // Rotate around center
   * sprite.pivot.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Rotate around center with origin
   * sprite.origin.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Reset rotation
   * sprite.angle = 0;
   * ```
   */
  get angle() {
    return this.rotation * WV;
  }
  set angle(e) {
    this.rotation = e * qV;
  }
  /**
   * The center of rotation, scaling, and skewing for this display object in its local space.
   * The `position` is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @example
   * ```ts
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   * ```
   * @since 4.0.0
   */
  get pivot() {
    return this._pivot === Pu && (this._pivot = new En(this, 0, 0)), this._pivot;
  }
  set pivot(e) {
    this._pivot === Pu && (this._pivot = new En(this, 0, 0), this._origin !== Eu && at("Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.")), typeof e == "number" ? this._pivot.set(e) : this._pivot.copyFrom(e);
  }
  /**
   * The skew factor for the object in radians. Skewing is a transformation that distorts
   * the object by rotating it differently at each point, creating a non-uniform shape.
   * @example
   * ```ts
   * // Basic skewing
   * container.skew.set(0.5, 0); // Skew horizontally
   * container.skew.set(0, 0.5); // Skew vertically
   *
   * // Skew with point data
   * container.skew = { x: 0.3, y: 0.3 }; // Diagonal skew
   *
   * // Reset skew
   * container.skew.set(0, 0);
   *
   * // Animate skew
   * app.ticker.add(() => {
   *     // Create wave effect
   *     container.skew.x = Math.sin(Date.now() / 1000) * 0.3;
   * });
   *
   * // Combine with rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   * container.skew.set(0.2, 0.2); // Skew the rotated object
   * ```
   * @since 4.0.0
   * @type {ObservablePoint} Point-like object with x/y properties in radians
   * @default {x: 0, y: 0}
   */
  get skew() {
    return this._skew === eg && (this._skew = new En(this, 0, 0)), this._skew;
  }
  set skew(e) {
    this._skew === eg && (this._skew = new En(this, 0, 0)), this._skew.copyFrom(e);
  }
  /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @example
   * ```ts
   * // Basic scaling
   * container.scale.set(2, 2); // Scales to double size
   * container.scale.set(2); // Scales uniformly to double size
   * container.scale = 2; // Scales uniformly to double size
   * // Scale to a specific width and height
   * container.setSize(200, 100); // Sets width to 200 and height to 100
   * ```
   * @since 4.0.0
   */
  get scale() {
    return this._scale === tg && (this._scale = new En(this, 1, 1)), this._scale;
  }
  set scale(e) {
    this._scale === tg && (this._scale = new En(this, 0, 0)), typeof e == "string" && (e = parseFloat(e)), typeof e == "number" ? this._scale.set(e) : this._scale.copyFrom(e);
  }
  /**
   * @experimental
   * The origin point around which the container rotates and scales without affecting its position.
   * Unlike pivot, changing the origin will not move the container's position.
   * @example
   * ```ts
   * // Rotate around center point
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   *
   * // Reset origin
   * container.origin.set(0, 0);
   * ```
   */
  get origin() {
    return this._origin === Eu && (this._origin = new En(this, 0, 0)), this._origin;
  }
  set origin(e) {
    this._origin === Eu && (this._origin = new En(this, 0, 0), this._pivot !== Pu && at("Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.")), typeof e == "number" ? this._origin.set(e) : this._origin.copyFrom(e);
  }
  /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * > [!NOTE] Changing the width will adjust the scale.x property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic width setting
   * container.width = 100;
   * // Optimized width setting
   * container.setSize(100, 100);
   * ```
   */
  get width() {
    return Math.abs(this.scale.x * this.getLocalBounds().width);
  }
  set width(e) {
    const t = this.getLocalBounds().width;
    this._setWidth(e, t);
  }
  /**
   * The height of the Container,
   * > [!NOTE] Changing the height will adjust the scale.y property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic height setting
   * container.height = 200;
   * // Optimized height setting
   * container.setSize(100, 200);
   * ```
   */
  get height() {
    return Math.abs(this.scale.y * this.getLocalBounds().height);
  }
  set height(e) {
    const t = this.getLocalBounds().height;
    this._setHeight(e, t);
  }
  /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   *
   * This is faster than get the width and height separately.
   * @example
   * ```ts
   * // Basic size retrieval
   * const size = container.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * container.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in.
   * @returns The size of the container.
   */
  getSize(e) {
    e || (e = {});
    const t = this.getLocalBounds();
    return e.width = Math.abs(this.scale.x * t.width), e.height = Math.abs(this.scale.y * t.height), e;
  }
  /**
   * Sets the size of the container to the specified width and height.
   * This is more efficient than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * container.setSize(100, 200);
   *
   * // Set uniform size
   * container.setSize(100); // Sets both width and height to 100
   * ```
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */
  setSize(e, t) {
    var s;
    const i = this.getLocalBounds();
    typeof e == "object" ? (t = (s = e.height) != null ? s : e.width, e = e.width) : t != null || (t = e), e !== void 0 && this._setWidth(e, i.width), t !== void 0 && this._setHeight(t, i.height);
  }
  /** Called when the skew or the rotation changes. */
  _updateSkew() {
    const e = this._rotation, t = this._skew;
    this._cx = Math.cos(e + t._y), this._sx = Math.sin(e + t._y), this._cy = -Math.sin(e - t._x), this._sy = Math.cos(e - t._x);
  }
  /**
   * Updates the transform properties of the container.
   * Allows partial updates of transform properties for optimized manipulation.
   * @example
   * ```ts
   * // Basic transform update
   * container.updateTransform({
   *     x: 100,
   *     y: 200,
   *     rotation: Math.PI / 4
   * });
   *
   * // Scale and rotate around center
   * sprite.updateTransform({
   *     pivotX: sprite.width / 2,
   *     pivotY: sprite.height / 2,
   *     scaleX: 2,
   *     scaleY: 2,
   *     rotation: Math.PI
   * });
   *
   * // Update position only
   * button.updateTransform({
   *     x: button.x + 10, // Move right
   *     y: button.y      // Keep same y
   * });
   * ```
   * @param opts - Transform options to update
   * @param opts.x - The x position
   * @param opts.y - The y position
   * @param opts.scaleX - The x-axis scale factor
   * @param opts.scaleY - The y-axis scale factor
   * @param opts.rotation - The rotation in radians
   * @param opts.skewX - The x-axis skew factor
   * @param opts.skewY - The y-axis skew factor
   * @param opts.pivotX - The x-axis pivot point
   * @param opts.pivotY - The y-axis pivot point
   * @returns This container, for chaining
   * @see {@link Container#setFromMatrix} For matrix-based transforms
   * @see {@link Container#position} For direct position access
   */
  updateTransform(e) {
    return this.position.set(
      typeof e.x == "number" ? e.x : this.position.x,
      typeof e.y == "number" ? e.y : this.position.y
    ), this.scale.set(
      typeof e.scaleX == "number" ? e.scaleX : this.scale.x,
      typeof e.scaleY == "number" ? e.scaleY : this.scale.y
    ), this.rotation = typeof e.rotation == "number" ? e.rotation : this.rotation, this.skew.set(
      typeof e.skewX == "number" ? e.skewX : this.skew.x,
      typeof e.skewY == "number" ? e.skewY : this.skew.y
    ), this.pivot.set(
      typeof e.pivotX == "number" ? e.pivotX : this.pivot.x,
      typeof e.pivotY == "number" ? e.pivotY : this.pivot.y
    ), this.origin.set(
      typeof e.originX == "number" ? e.originX : this.origin.x,
      typeof e.originY == "number" ? e.originY : this.origin.y
    ), this;
  }
  /**
   * Updates the local transform properties by decomposing the given matrix.
   * Extracts position, scale, rotation, and skew from a transformation matrix.
   * @example
   * ```ts
   * // Basic matrix transform
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * container.setFromMatrix(matrix);
   *
   * // Copy transform from another container
   * const source = new Container();
   * source.position.set(100, 100);
   * source.rotation = Math.PI / 2;
   *
   * target.setFromMatrix(source.localTransform);
   *
   * // Reset transform
   * container.setFromMatrix(Matrix.IDENTITY);
   * ```
   * @param matrix - The matrix to use for updating the transform
   * @see {@link Container#updateTransform} For property-based updates
   * @see {@link Matrix#decompose} For matrix decomposition details
   */
  setFromMatrix(e) {
    e.decompose(this);
  }
  /** Updates the local transform. */
  updateLocalTransform() {
    const e = this._didContainerChangeTick;
    if (this._didLocalTransformChangeId === e) return;
    this._didLocalTransformChangeId = e;
    const t = this.localTransform, i = this._scale, s = this._pivot, o = this._origin, r = this._position, a = i._x, l = i._y, d = s._x, c = s._y, u = -o._x, p = -o._y;
    t.a = this._cx * a, t.b = this._sx * a, t.c = this._cy * l, t.d = this._sy * l, t.tx = r._x - (d * t.a + c * t.c) + (u * t.a + p * t.c) - u, t.ty = r._y - (d * t.b + c * t.d) + (u * t.b + p * t.d) - p;
  }
  // / ///// color related stuff
  set alpha(e) {
    e !== this.localAlpha && (this.localAlpha = e, this._updateFlags |= Np, this._onUpdate());
  }
  /**
   * The opacity of the object relative to its parent's opacity.
   * Value ranges from 0 (fully transparent) to 1 (fully opaque).
   * @example
   * ```ts
   * // Basic transparency
   * sprite.alpha = 0.5; // 50% opacity
   *
   * // Inherited opacity
   * container.alpha = 0.5;
   * const child = new Sprite(texture);
   * child.alpha = 0.5;
   * container.addChild(child);
   * // child's effective opacity is 0.25 (0.5 * 0.5)
   * ```
   * @default 1
   * @see {@link Container#visible} For toggling visibility
   * @see {@link Container#renderable} For render control
   */
  get alpha() {
    return this.localAlpha;
  }
  set tint(e) {
    const i = pn.shared.setValue(e != null ? e : 16777215).toBgrNumber();
    i !== this.localColor && (this.localColor = i, this._updateFlags |= Np, this._onUpdate());
  }
  /**
   * The tint applied to the sprite.
   *
   * This can be any valid {@link ColorSource}.
   * @example
   * ```ts
   * // Basic color tinting
   * container.tint = 0xff0000; // Red tint
   * container.tint = 'red';    // Same as above
   * container.tint = '#00ff00'; // Green
   * container.tint = 'rgb(0,0,255)'; // Blue
   *
   * // Remove tint
   * container.tint = 0xffffff; // White = no tint
   * container.tint = null;     // Also removes tint
   * ```
   * @default 0xFFFFFF
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#visible} For visibility control
   */
  get tint() {
    return Wr(this.localColor);
  }
  // / //////////////// blend related stuff
  set blendMode(e) {
    this.localBlendMode !== e && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= T1, this.localBlendMode = e, this._onUpdate());
  }
  /**
   * The blend mode to be applied to the sprite. Controls how pixels are blended when rendering.
   *
   * Setting to 'normal' will reset to default blending.
   * > [!NOTE] More blend modes are available after importing the `pixi.js/advanced-blend-modes` sub-export.
   * @example
   * ```ts
   * // Basic blend modes
   * sprite.blendMode = 'add';        // Additive blending
   * sprite.blendMode = 'multiply';   // Multiply colors
   * sprite.blendMode = 'screen';     // Screen blend
   *
   * // Reset blend mode
   * sprite.blendMode = 'normal';     // Normal blending
   * ```
   * @default 'normal'
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#tint} For color adjustments
   */
  get blendMode() {
    return this.localBlendMode;
  }
  // / ///////// VISIBILITY / RENDERABLE /////////////////
  /**
   * The visibility of the object. If false the object will not be drawn,
   * and the transform will not be updated.
   * @example
   * ```ts
   * // Basic visibility toggle
   * sprite.visible = false; // Hide sprite
   * sprite.visible = true;  // Show sprite
   * ```
   * @default true
   * @see {@link Container#renderable} For render-only control
   * @see {@link Container#alpha} For transparency
   */
  get visible() {
    return !!(this.localDisplayStatus & 2);
  }
  set visible(e) {
    const t = e ? 2 : 0;
    (this.localDisplayStatus & 2) !== t && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= Qd, this.localDisplayStatus ^= 2, this._onUpdate(), this.emit("visibleChanged", e));
  }
  /** @ignore */
  get culled() {
    return !(this.localDisplayStatus & 4);
  }
  /** @ignore */
  set culled(e) {
    const t = e ? 0 : 4;
    (this.localDisplayStatus & 4) !== t && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= Qd, this.localDisplayStatus ^= 4, this._onUpdate());
  }
  /**
   * Controls whether this object can be rendered. If false the object will not be drawn,
   * but the transform will still be updated. This is different from visible, which skips
   * transform updates.
   * @example
   * ```ts
   * // Basic render control
   * sprite.renderable = false; // Skip rendering
   * sprite.renderable = true;  // Enable rendering
   * ```
   * @default true
   * @see {@link Container#visible} For skipping transform updates
   * @see {@link Container#alpha} For transparency
   */
  get renderable() {
    return !!(this.localDisplayStatus & 1);
  }
  set renderable(e) {
    const t = e ? 1 : 0;
    (this.localDisplayStatus & 1) !== t && (this._updateFlags |= Qd, this.localDisplayStatus ^= 1, this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._onUpdate());
  }
  /**
   * Whether or not the object should be rendered.
   * @advanced
   */
  get isRenderable() {
    return this.localDisplayStatus === 7 && this.groupAlpha > 0;
  }
  /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * ```ts
   * container.destroy();
   * container.destroy(true);
   * container.destroy({ children: true });
   * container.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */
  destroy(e = !1) {
    var s;
    if (this.destroyed) return;
    this.destroyed = !0;
    let t;
    if (this.children.length && (t = this.removeChildren(0, this.children.length)), this.removeFromParent(), this.parent = null, this._maskEffect = null, this._filterEffect = null, this.effects = null, this._position = null, this._scale = null, this._pivot = null, this._origin = null, this._skew = null, this.emit("destroyed", this), this.removeAllListeners(), (typeof e == "boolean" ? e : e == null ? void 0 : e.children) && t)
      for (let o = 0; o < t.length; ++o)
        t[o].destroy(e);
    (s = this.renderGroup) == null || s.destroy(), this.renderGroup = null;
  }
}
ct.mixin(
  un,
  gW,
  kW,
  AW,
  MW,
  TW,
  yW,
  xW,
  CW,
  hW,
  mW,
  _W,
  bW
);
class M1 extends un {
  constructor(e) {
    var t;
    super(e), this.canBundle = !0, this.allowChildren = !1, this._roundPixels = 0, this._lastUsed = -1, this._gpuData = /* @__PURE__ */ Object.create(null), this.autoGarbageCollect = !0, this._gcLastUsed = -1, this._bounds = new On(0, 1, 0, 0), this._boundsDirty = !0, this.autoGarbageCollect = (t = e.autoGarbageCollect) != null ? t : !0;
  }
  /**
   * The local bounds of the view in its own coordinate space.
   * Bounds are automatically updated when the view's content changes.
   * @example
   * ```ts
   * // Get bounds dimensions
   * const bounds = view.bounds;
   * console.log(`Width: ${bounds.maxX - bounds.minX}`);
   * console.log(`Height: ${bounds.maxY - bounds.minY}`);
   * ```
   * @returns The rectangular bounds of the view
   * @see {@link Bounds} For bounds operations
   */
  get bounds() {
    return this._boundsDirty ? (this.updateBounds(), this._boundsDirty = !1, this._bounds) : this._bounds;
  }
  /**
   * Whether or not to round the x/y position of the sprite.
   * @example
   * ```ts
   * // Enable pixel rounding for crisp rendering
   * view.roundPixels = true;
   * ```
   * @default false
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  set roundPixels(e) {
    this._roundPixels = e ? 1 : 0;
  }
  /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the view's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = view.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the view's bounds
   * @see {@link ViewContainer#bounds} For the bounds used in hit testing
   * @see {@link Container#toLocal} For converting global coordinates to local
   */
  containsPoint(e) {
    const t = this.bounds, { x: i, y: s } = e;
    return i >= t.minX && i <= t.maxX && s >= t.minY && s <= t.maxY;
  }
  /** @private */
  onViewUpdate() {
    if (this._didViewChangeTick++, this._boundsDirty = !0, this.didViewUpdate) return;
    this.didViewUpdate = !0;
    const e = this.renderGroup || this.parentRenderGroup;
    e && e.onChildViewUpdate(this);
  }
  /** Unloads the GPU data from the view. */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null), this.onViewUpdate();
  }
  destroy(e) {
    this.unload(), super.destroy(e), this._bounds = null;
  }
  /**
   * Collects renderables for the view container.
   * @param instructionSet - The instruction set to collect renderables for.
   * @param renderer - The renderer to collect renderables for.
   * @param currentLayer - The current render layer.
   * @internal
   */
  collectRenderablesSimple(e, t, i) {
    const { renderPipes: s } = t;
    s.blendMode.pushBlendMode(this, this.groupBlendMode, e);
    const r = s[this.renderPipeId];
    r != null && r.addRenderable && r.addRenderable(this, e), this.didViewUpdate = !1;
    const a = this.children, l = a.length;
    for (let d = 0; d < l; d++)
      a[d].collectRenderables(e, t, i);
    s.blendMode.popBlendMode(e);
  }
}
class ds extends M1 {
  /**
   * @param options - The options for creating the sprite.
   */
  constructor(e = Ze.EMPTY) {
    e instanceof Ze && (e = { texture: e });
    const { texture: t = Ze.EMPTY, anchor: i, roundPixels: s, width: o, height: r, ...a } = e;
    super({
      label: "Sprite",
      ...a
    }), this.renderPipeId = "sprite", this.batched = !0, this._visualBounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 }, this._anchor = new En(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), i ? this.anchor = i : t.defaultAnchor && (this.anchor = t.defaultAnchor), this.texture = t, this.allowChildren = !1, this.roundPixels = s != null ? s : !1, o !== void 0 && (this.width = o), r !== void 0 && (this.height = r);
  }
  /**
   * Creates a new sprite based on a source texture, image, video, or canvas element.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create from path or URL
   * const sprite = Sprite.from('assets/image.png');
   *
   * // Create from existing texture
   * const sprite = Sprite.from(texture);
   *
   * // Create from canvas
   * const canvas = document.createElement('canvas');
   * const sprite = Sprite.from(canvas, true); // Skip caching new texture
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image, a texture,
   * or any valid texture source (canvas, video, etc.)
   * @param skipCache - Whether to skip adding to the texture cache when creating a new texture
   * @returns A new sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */
  static from(e, t = !1) {
    return e instanceof Ze ? new ds(e) : new ds(Ze.from(e, t));
  }
  set texture(e) {
    e || (e = Ze.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this._texture = e, this._width && this._setWidth(this._width, this._texture.orig.width), this._height && this._setHeight(this._height, this._texture.orig.height), this.onViewUpdate());
  }
  /**
   * The texture that is displayed by the sprite. When changed, automatically updates
   * the sprite dimensions and manages texture event listeners.
   * @example
   * ```ts
   * // Create sprite with texture
   * const sprite = new Sprite({
   *     texture: Texture.from('sprite.png')
   * });
   *
   * // Update texture
   * sprite.texture = Texture.from('newSprite.png');
   *
   * // Use texture from spritesheet
   * const sheet = await Assets.load('spritesheet.json');
   * sprite.texture = sheet.textures['frame1.png'];
   *
   * // Reset to empty texture
   * sprite.texture = Texture.EMPTY;
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link Assets} For asset loading
   */
  get texture() {
    return this._texture;
  }
  /**
   * The bounds of the sprite, taking into account the texture's trim area.
   * @example
   * ```ts
   * const texture = new Texture({
   *     source: new TextureSource({ width: 300, height: 300 }),
   *     frame: new Rectangle(196, 66, 58, 56),
   *     trim: new Rectangle(4, 4, 58, 56),
   *     orig: new Rectangle(0, 0, 64, 64),
   *     rotate: 2,
   * });
   * const sprite = new Sprite(texture);
   * const visualBounds = sprite.visualBounds;
   * // console.log(visualBounds); // { minX: -4, maxX: 62, minY: -4, maxY: 60 }
   */
  get visualBounds() {
    return nW(this._visualBounds, this._anchor, this._texture), this._visualBounds;
  }
  /**
   * @deprecated
   * @ignore
   */
  get sourceBounds() {
    return rt("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead."), this.visualBounds;
  }
  /** @private */
  updateBounds() {
    const e = this._anchor, t = this._texture, i = this._bounds, { width: s, height: o } = t.orig;
    i.minX = -e._x * s, i.maxX = i.minX + s, i.minY = -e._y * o, i.maxY = i.minY + o;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * sprite.destroy();
   * sprite.destroy(true);
   * sprite.destroy({ texture: true, textureSource: true });
   */
  destroy(e = !1) {
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const i = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(i);
    }
    this._texture = null, this._visualBounds = null, this._bounds = null, this._anchor = null;
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * sprite.width = 200;
   * console.log(sprite.scale.x); // Scale adjusted to match width
   *
   * // Set width while preserving aspect ratio
   * const ratio = sprite.height / sprite.width;
   * sprite.width = 300;
   * sprite.height = 300 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.width = sprite.texture.orig.width;
   * ```
   */
  get width() {
    return Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(e) {
    this._setWidth(e, this._texture.orig.width), this._width = e;
  }
  /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * sprite.height = 150;
   * console.log(sprite.scale.y); // Scale adjusted to match height
   *
   * // Set height while preserving aspect ratio
   * const ratio = sprite.width / sprite.height;
   * sprite.height = 200;
   * sprite.width = 200 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.height = sprite.texture.orig.height;
   * ```
   */
  get height() {
    return Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(e) {
    this._setHeight(e, this._texture.orig.height), this._height = e;
  }
  /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Sprite#width} For getting just the width
   * @see {@link Sprite#height} For getting just the height
   * @see {@link Sprite#setSize} For setting both width and height
   */
  getSize(e) {
    return e || (e = {}), e.width = Math.abs(this.scale.x) * this._texture.orig.width, e.height = Math.abs(this.scale.y) * this._texture.orig.height, e;
  }
  /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * sprite.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * sprite.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * sprite.setSize({
   *     width: 200,
   *     height: 300
   * });
   *
   * // Reset to texture size
   * sprite.setSize(
   *     sprite.texture.orig.width,
   *     sprite.texture.orig.height
   * );
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Sprite#width} For setting width only
   * @see {@link Sprite#height} For setting height only
   * @see {@link Sprite#texture} For the source dimensions
   */
  setSize(e, t) {
    var i;
    typeof e == "object" ? (t = (i = e.height) != null ? i : e.width, e = e.width) : t != null || (t = e), e !== void 0 && this._setWidth(e, this._texture.orig.width), t !== void 0 && this._setHeight(t, this._texture.orig.height);
  }
}
const BW = new On();
function F8(n, e, t) {
  const i = BW;
  n.measurable = !0, w1(n, t, i), e.addBoundsMask(i), n.measurable = !1;
}
function N8(n, e, t) {
  const i = Hs.get();
  n.measurable = !0;
  const s = Kn.get().identity(), o = U8(n, t, s);
  _1(n, i, o), n.measurable = !1, e.addBoundsMask(i), Kn.return(s), Hs.return(i);
}
function U8(n, e, t) {
  return n ? (n !== e && (U8(n.parent, e, t), n.updateLocalTransform(), t.append(n.localTransform)), t) : (at("Mask bounds, renderable is not inside the root container"), t);
}
class G8 {
  constructor(e) {
    this.priority = 0, this.inverse = !1, this.channel = "red", this.pipe = "alphaMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e, this.renderMaskToTexture = !(e instanceof ds), this.mask.renderable = this.renderMaskToTexture, this.mask.includeInBuild = !this.renderMaskToTexture, this.mask.measurable = !1;
  }
  reset() {
    this.mask !== null && (this.mask.measurable = !0, this.mask = null);
  }
  addBounds(e, t) {
    this.inverse || F8(this.mask, e, t);
  }
  addLocalBounds(e, t) {
    N8(this.mask, e, t);
  }
  containsPoint(e, t) {
    const i = this.mask;
    return t(i, e);
  }
  destroy() {
    this.reset();
  }
  static test(e) {
    return e instanceof ds;
  }
}
G8.extension = Ae.MaskEffect;
class j8 {
  constructor(e) {
    this.priority = 0, this.pipe = "colorMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e;
  }
  destroy() {
  }
  static test(e) {
    return typeof e == "number";
  }
}
j8.extension = Ae.MaskEffect;
class H8 {
  constructor(e) {
    this.priority = 0, this.pipe = "stencilMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e, this.mask.includeInBuild = !1, this.mask.measurable = !1;
  }
  reset() {
    this.mask !== null && (this.mask.measurable = !0, this.mask.includeInBuild = !0, this.mask = null);
  }
  addBounds(e, t) {
    F8(this.mask, e, t);
  }
  addLocalBounds(e, t) {
    N8(this.mask, e, t);
  }
  containsPoint(e, t) {
    const i = this.mask;
    return t(i, e);
  }
  destroy() {
    this.reset();
  }
  static test(e) {
    return e instanceof un;
  }
}
H8.extension = Ae.MaskEffect;
const FW = {
  createCanvas: (n, e) => {
    const t = document.createElement("canvas");
    return t.width = n, t.height = e, t;
  },
  createImage: () => new Image(),
  getCanvasRenderingContext2D: () => CanvasRenderingContext2D,
  getWebGLRenderingContext: () => WebGLRenderingContext,
  getNavigator: () => navigator,
  getBaseUrl: () => {
    var n;
    return (n = document.baseURI) != null ? n : window.location.href;
  },
  getFontFaceSet: () => document.fonts,
  fetch: (n, e) => fetch(n, e),
  parseXML: (n) => new DOMParser().parseFromString(n, "text/xml")
};
let Ww = FW;
const Pt = {
  /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */
  get() {
    return Ww;
  },
  /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */
  set(n) {
    Ww = n;
  }
};
class ki extends an {
  constructor(e) {
    e.resource || (e.resource = Pt.get().createCanvas()), e.width || (e.width = e.resource.width, e.autoDensity || (e.width /= e.resolution)), e.height || (e.height = e.resource.height, e.autoDensity || (e.height /= e.resolution)), super(e), this.uploadMethodId = "image", this.autoDensity = e.autoDensity, this.resizeCanvas(), this.transparent = !!e.transparent;
  }
  resizeCanvas() {
    this.autoDensity && "style" in this.resource && (this.resource.style.width = `${this.width}px`, this.resource.style.height = `${this.height}px`), (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) && (this.resource.width = this.pixelWidth, this.resource.height = this.pixelHeight);
  }
  resize(e = this.width, t = this.height, i = this._resolution) {
    const s = super.resize(e, t, i);
    return s && this.resizeCanvas(), s;
  }
  static test(e) {
    return globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && e instanceof OffscreenCanvas;
  }
  /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */
  get context2D() {
    return this._context2D || (this._context2D = this.resource.getContext("2d"));
  }
}
ki.extension = Ae.TextureSource;
class xc extends an {
  constructor(e) {
    super(e), this.uploadMethodId = "image", this.autoGarbageCollect = !0;
  }
  static test(e) {
    return globalThis.HTMLImageElement && e instanceof HTMLImageElement || typeof ImageBitmap != "undefined" && e instanceof ImageBitmap || globalThis.VideoFrame && e instanceof VideoFrame;
  }
}
xc.extension = Ae.TextureSource;
var bl = /* @__PURE__ */ ((n) => (n[n.INTERACTION = 50] = "INTERACTION", n[n.HIGH = 25] = "HIGH", n[n.NORMAL = 0] = "NORMAL", n[n.LOW = -25] = "LOW", n[n.UTILITY = -50] = "UTILITY", n))(bl || {});
class ng {
  /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */
  constructor(e, t = null, i = 0, s = !1) {
    this.next = null, this.previous = null, this._destroyed = !1, this._fn = e, this._context = t, this.priority = i, this._once = s;
  }
  /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */
  match(e, t = null) {
    return this._fn === e && this._context === t;
  }
  /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */
  emit(e) {
    this._fn && (this._context ? this._fn.call(this._context, e) : this._fn(e));
    const t = this.next;
    return this._once && this.destroy(!0), this._destroyed && (this.next = null), t;
  }
  /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */
  connect(e) {
    this.previous = e, e.next && (e.next.previous = this), this.next = e.next, e.next = this;
  }
  /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */
  destroy(e = !1) {
    this._destroyed = !0, this._fn = null, this._context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
    const t = this.next;
    return this.next = e ? null : t, this.previous = null, t;
  }
}
const V8 = class hi {
  constructor() {
    this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new ng(null, null, 1 / 0), this.deltaMS = 1 / hi.targetFPMS, this.elapsedMS = 1 / hi.targetFPMS, this._tick = (e) => {
      this._requestId = null, this.started && (this.update(e), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
    };
  }
  /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   */
  _requestIfNeeded() {
    this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
  }
  /** Conditionally cancels a pending animation frame. */
  _cancelIfNeeded() {
    this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
  }
  /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   */
  _startIfPossible() {
    this.started ? this._requestIfNeeded() : this.autoStart && this.start();
  }
  /**
   * Register a handler for tick events.
   * @param fn - The listener function to add. Receives the Ticker instance as parameter
   * @param context - The context for the listener
   * @param priority - The priority of the listener
   * @example
   * ```ts
   * // Access time properties through the ticker parameter
   * ticker.add((ticker) => {
   *     // Use deltaTime (dimensionless scalar) for frame-independent animations
   *     sprite.rotation += 0.1 * ticker.deltaTime;
   *
   *     // Use deltaMS (milliseconds) for time-based calculations
   *     const progress = ticker.deltaMS / animationDuration;
   *
   *     // Use elapsedMS for raw timing measurements
   *     console.log(`Raw frame time: ${ticker.elapsedMS}ms`);
   * });
   * ```
   */
  add(e, t, i = bl.NORMAL) {
    return this._addListener(new ng(e, t, i));
  }
  /**
   * Add a handler for the tick event which is only executed once on the next frame.
   * @example
   * ```ts
   * // Basic one-time update
   * ticker.addOnce(() => {
   *     console.log('Runs next frame only');
   * });
   *
   * // With specific context
   * const game = {
   *     init(ticker) {
   *         this.loadResources();
   *         console.log('Game initialized');
   *     }
   * };
   * ticker.addOnce(game.init, game);
   *
   * // With priority
   * ticker.addOnce(
   *     () => {
   *         // High priority one-time setup
   *         physics.init();
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For continuous updates
   * @see {@link Ticker#remove} For removing handlers
   */
  addOnce(e, t, i = bl.NORMAL) {
    return this._addListener(new ng(e, t, i, !0));
  }
  /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */
  _addListener(e) {
    let t = this._head.next, i = this._head;
    if (!t)
      e.connect(i);
    else {
      for (; t; ) {
        if (e.priority > t.priority) {
          e.connect(i);
          break;
        }
        i = t, t = t.next;
      }
      e.previous || e.connect(i);
    }
    return this._startIfPossible(), this;
  }
  /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @example
   * ```ts
   * // Basic removal
   * const onTick = () => {
   *     sprite.rotation += 0.1;
   * };
   * ticker.add(onTick);
   * ticker.remove(onTick);
   *
   * // Remove with context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   * ticker.remove(game.update, game);
   *
   * // Remove all matching handlers
   * // (if same function was added multiple times)
   * ticker.add(onTick);
   * ticker.add(onTick);
   * ticker.remove(onTick); // Removes all instances
   * ```
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For adding handlers
   * @see {@link Ticker#addOnce} For one-time handlers
   */
  remove(e, t) {
    let i = this._head.next;
    for (; i; )
      i.match(e, t) ? i = i.destroy() : i = i.next;
    return this._head.next || this._cancelIfNeeded(), this;
  }
  /**
   * The number of listeners on this ticker, calculated by walking through linked list.
   * @example
   * ```ts
   * // Check number of active listeners
   * const ticker = new Ticker();
   * console.log(ticker.count); // 0
   *
   * // Add some listeners
   * ticker.add(() => {});
   * ticker.add(() => {});
   * console.log(ticker.count); // 2
   *
   * // Check after cleanup
   * ticker.destroy();
   * console.log(ticker.count); // 0
   * ```
   * @readonly
   * @see {@link Ticker#add} For adding listeners
   * @see {@link Ticker#remove} For removing listeners
   */
  get count() {
    if (!this._head)
      return 0;
    let e = 0, t = this._head;
    for (; t = t.next; )
      e++;
    return e;
  }
  /**
   * Starts the ticker. If the ticker has listeners a new animation frame is requested at this point.
   * @example
   * ```ts
   * // Basic manual start
   * const ticker = new Ticker();
   * ticker.add(() => {
   *     // Animation code here
   * });
   * ticker.start();
   * ```
   * @see {@link Ticker#stop} For stopping the ticker
   * @see {@link Ticker#autoStart} For automatic starting
   * @see {@link Ticker#started} For checking ticker state
   */
  start() {
    this.started || (this.started = !0, this._requestIfNeeded());
  }
  /**
   * Stops the ticker. If the ticker has requested an animation frame it is canceled at this point.
   * @example
   * ```ts
   * // Basic stop
   * const ticker = new Ticker();
   * ticker.stop();
   * ```
   * @see {@link Ticker#start} For starting the ticker
   * @see {@link Ticker#started} For checking ticker state
   * @see {@link Ticker#destroy} For cleaning up the ticker
   */
  stop() {
    this.started && (this.started = !1, this._cancelIfNeeded());
  }
  /**
   * Destroy the ticker and don't use after this. Calling this method removes all references to internal events.
   * @example
   * ```ts
   * // Clean up with active listeners
   * const ticker = new Ticker();
   * ticker.add(() => {});
   * ticker.destroy(); // Removes all listeners
   * ```
   * @see {@link Ticker#stop} For stopping without destroying
   * @see {@link Ticker#remove} For removing specific listeners
   */
  destroy() {
    if (!this._protected) {
      this.stop();
      let e = this._head.next;
      for (; e; )
        e = e.destroy(!0);
      this._head.destroy(), this._head = null;
    }
  }
  /**
   * Triggers an update.
   *
   * An update entails setting the
   * current {@link Ticker#elapsedMS|elapsedMS},
   * the current {@link Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   *
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @example
   * ```ts
   * // Basic manual update
   * const ticker = new Ticker();
   * ticker.update(performance.now());
   * ```
   * @param currentTime - The current time of execution (defaults to performance.now())
   * @see {@link Ticker#deltaTime} For frame delta value
   * @see {@link Ticker#elapsedMS} For raw elapsed time
   */
  update(e = performance.now()) {
    let t;
    if (e > this.lastTime) {
      if (t = this.elapsedMS = e - this.lastTime, t > this._maxElapsedMS && (t = this._maxElapsedMS), t *= this.speed, this._minElapsedMS) {
        const o = e - this._lastFrame | 0;
        if (o < this._minElapsedMS)
          return;
        this._lastFrame = e - o % this._minElapsedMS;
      }
      this.deltaMS = t, this.deltaTime = this.deltaMS * hi.targetFPMS;
      const i = this._head;
      let s = i.next;
      for (; s; )
        s = s.emit(this);
      i.next || this._cancelIfNeeded();
    } else
      this.deltaTime = this.deltaMS = this.elapsedMS = 0;
    this.lastTime = e;
  }
  /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * > [!NOTE] This does not factor in the value of
   * > {@link Ticker#speed|speed}, which is specific
   * > to scaling {@link Ticker#deltaTime|deltaTime}.
   * @example
   * ```ts
   * // Basic FPS monitoring
   * ticker.add(() => {
   *     console.log(`Current FPS: ${Math.round(ticker.FPS)}`);
   * });
   * ```
   * @readonly
   */
  get FPS() {
    return 1e3 / this.elapsedMS;
  }
  /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This value is used to cap {@link Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000` (typically 60).
   *
   * If `maxFPS` is currently set (non-zero) and `minFPS` is set above it,
   * `maxFPS` is automatically raised to match. This keeps the two limits consistent.
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.minFPS = 30; // Never go below 30 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // minFPS above maxFPS pushes maxFPS up
   * ticker.minFPS = 50; // maxFPS is raised to 50
   * ```
   * @default 10
   */
  get minFPS() {
    return 1e3 / this._maxElapsedMS;
  }
  set minFPS(e) {
    const t = Math.min(Math.max(0, e) / 1e3, hi.targetFPMS);
    this._maxElapsedMS = 1 / t, this._minElapsedMS && e > this.maxFPS && (this.maxFPS = e);
  }
  /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This will effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`.
   *
   * If `maxFPS` is set below the current `minFPS`, `minFPS` is automatically lowered to match.
   * This keeps the two limits consistent.
   * @example
   * ```ts
   * // Cap the frame rate
   * const ticker = new Ticker();
   * ticker.maxFPS = 60; // Never go above 60 FPS
   *
   * // Use with minFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // maxFPS below minFPS pushes minFPS down
   * ticker.maxFPS = 20; // minFPS is now also 20
   * ```
   * @default 0
   */
  get maxFPS() {
    return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
  }
  set maxFPS(e) {
    e === 0 ? this._minElapsedMS = 0 : (e < this.minFPS && (this.minFPS = e), this._minElapsedMS = 1 / (e / 1e3));
  }
  /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoSource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @type {Ticker}
   * @readonly
   */
  static get shared() {
    if (!hi._shared) {
      const e = hi._shared = new hi();
      e.autoStart = !0, e._protected = !0;
    }
    return hi._shared;
  }
  /**
   * The system ticker instance used by {@link PrepareBase} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @type {Ticker}
   * @readonly
   * @advanced
   */
  static get system() {
    if (!hi._system) {
      const e = hi._system = new hi();
      e.autoStart = !0, e._protected = !0;
    }
    return hi._system;
  }
};
V8.targetFPMS = 0.06;
let Ci = V8, Xl;
async function NW() {
  return Xl != null || (Xl = (async () => {
    var r;
    const e = Pt.get().createCanvas(1, 1).getContext("webgl");
    if (!e)
      return "premultiply-alpha-on-upload";
    const t = await new Promise((a) => {
      const l = document.createElement("video");
      l.onloadeddata = () => a(l), l.onerror = () => a(null), l.autoplay = !1, l.crossOrigin = "anonymous", l.preload = "auto", l.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", l.load();
    });
    if (!t)
      return "premultiply-alpha-on-upload";
    const i = e.createTexture();
    e.bindTexture(e.TEXTURE_2D, i);
    const s = e.createFramebuffer();
    e.bindFramebuffer(e.FRAMEBUFFER, s), e.framebufferTexture2D(
      e.FRAMEBUFFER,
      e.COLOR_ATTACHMENT0,
      e.TEXTURE_2D,
      i,
      0
    ), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, e.NONE), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, t);
    const o = new Uint8Array(4);
    return e.readPixels(0, 0, 1, 1, e.RGBA, e.UNSIGNED_BYTE, o), e.deleteFramebuffer(s), e.deleteTexture(i), (r = e.getExtension("WEBGL_lose_context")) == null || r.loseContext(), o[0] <= o[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
  })()), Xl;
}
const Uf = class W8 extends an {
  constructor(e) {
    var t;
    super(e), this.isReady = !1, this.uploadMethodId = "video", e = {
      ...W8.defaultOptions,
      ...e
    }, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = e.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = e.autoPlay !== !1, this.alphaMode = (t = e.alphaMode) != null ? t : "premultiply-alpha-on-upload", this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onCanPlayThrough = this._onCanPlayThrough.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), this._onLoadedMetadata = this._onLoadedMetadata.bind(this), e.autoLoad !== !1 && this.load();
  }
  /** Update the video frame if the source is not destroyed and meets certain conditions. */
  updateFrame() {
    if (!this.destroyed) {
      if (this._updateFPS) {
        const e = Ci.shared.elapsedMS * this.resource.playbackRate;
        this._msToNextUpdate = Math.floor(this._msToNextUpdate - e);
      }
      (!this._updateFPS || this._msToNextUpdate <= 0) && (this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0), this.isValid && this.update();
    }
  }
  /** Callback to update the video frame and potentially request the next frame update. */
  _videoFrameRequestCallback() {
    this.updateFrame(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    );
  }
  /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */
  get isValid() {
    return !!this.resource.videoWidth && !!this.resource.videoHeight;
  }
  /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */
  async load() {
    if (this._load)
      return this._load;
    const e = this.resource, t = this.options;
    return (e.readyState === e.HAVE_ENOUGH_DATA || e.readyState === e.HAVE_FUTURE_DATA) && e.width && e.height && (e.complete = !0), e.addEventListener("play", this._onPlayStart), e.addEventListener("pause", this._onPlayStop), e.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._mediaReady() : (t.preload || e.addEventListener("canplay", this._onCanPlay), e.addEventListener("canplaythrough", this._onCanPlayThrough), e.addEventListener("error", this._onError, !0)), this.isValid || e.addEventListener("loadedmetadata", this._onLoadedMetadata), this.alphaMode = await NW(), this._load = new Promise((i, s) => {
      this.isValid ? i(this) : (this._resolve = i, this._reject = s, t.preloadTimeoutMs !== void 0 && (this._preloadTimeout = setTimeout(() => {
        this._onError(new ErrorEvent(`Preload exceeded timeout of ${t.preloadTimeoutMs}ms`));
      })), e.load());
    }), this._load;
  }
  /**
   * Handle video error events.
   * @param event - The error event
   */
  _onError(e) {
    this.resource.removeEventListener("error", this._onError, !0), this.emit("error", e), this._reject && (this._reject(e), this._reject = null, this._resolve = null);
  }
  /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */
  _isSourcePlaying() {
    const e = this.resource;
    return !e.paused && !e.ended;
  }
  /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */
  _isSourceReady() {
    return this.resource.readyState > 2;
  }
  /** Runs the update loop when the video is ready to play. */
  _onPlayStart() {
    this._configureAutoUpdate();
  }
  /** Stops the update loop when a pause event is triggered. */
  _onPlayStop() {
    this._configureAutoUpdate();
  }
  /** Handles behavior when the video completes seeking to the current playback position. */
  _onSeeked() {
    this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0);
  }
  /** When intrinsic size becomes known after play / canplay (common with MediaStream). */
  _onLoadedMetadata() {
    this.isValid && this._mediaReady();
  }
  _onCanPlay() {
    this.resource.removeEventListener("canplay", this._onCanPlay), this._mediaReady();
  }
  _onCanPlayThrough() {
    this.resource.removeEventListener("canplaythrough", this._onCanPlayThrough), this._preloadTimeout && (clearTimeout(this._preloadTimeout), this._preloadTimeout = void 0), this._mediaReady();
  }
  /** Fired when the video is loaded and ready to play. */
  _mediaReady() {
    const e = this.resource;
    this.isValid && (this.isReady = !0, this.resize(e.videoWidth, e.videoHeight)), this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0, this._resolve && this.isValid && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && this.resource.play();
  }
  /** Cleans up resources and event listeners associated with this texture. */
  destroy() {
    this._configureAutoUpdate();
    const e = this.resource;
    e && (e.removeEventListener("play", this._onPlayStart), e.removeEventListener("pause", this._onPlayStop), e.removeEventListener("seeked", this._onSeeked), e.removeEventListener("canplay", this._onCanPlay), e.removeEventListener("canplaythrough", this._onCanPlayThrough), e.removeEventListener("loadedmetadata", this._onLoadedMetadata), e.removeEventListener("error", this._onError, !0), e.pause(), e.src = "", e.load()), super.destroy();
  }
  /** Should the base texture automatically update itself, set to true by default. */
  get autoUpdate() {
    return this._autoUpdate;
  }
  set autoUpdate(e) {
    e !== this._autoUpdate && (this._autoUpdate = e, this._configureAutoUpdate());
  }
  /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */
  get updateFPS() {
    return this._updateFPS;
  }
  set updateFPS(e) {
    e !== this._updateFPS && (this._updateFPS = e, this._configureAutoUpdate());
  }
  /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */
  _configureAutoUpdate() {
    this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.resource.requestVideoFrameCallback ? (this._isConnectedToTicker && (Ci.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    ))) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || (Ci.shared.add(this.updateFrame, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && (Ci.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
  }
  static test(e) {
    return globalThis.HTMLVideoElement && e instanceof HTMLVideoElement;
  }
};
Uf.extension = Ae.TextureSource;
Uf.defaultOptions = {
  ...an.defaultOptions,
  /** If true, the video will start loading immediately. */
  autoLoad: !0,
  /** If true, the video will start playing as soon as it is loaded. */
  autoPlay: !0,
  /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */
  updateFPS: 0,
  /** If true, the video will be loaded with the `crossorigin` attribute. */
  crossorigin: !0,
  /** If true, the video will loop when it ends. */
  loop: !1,
  /** If true, the video will be muted. */
  muted: !0,
  /** If true, the video will play inline. */
  playsinline: !0,
  /** If true, the video will be preloaded. */
  preload: !1
};
Uf.MIME_TYPES = {
  ogv: "video/ogg",
  mov: "video/quicktime",
  m4v: "video/mp4"
};
let UW = Uf;
const za = (n, e, t = !1) => (Array.isArray(n) || (n = [n]), e ? n.map((i) => typeof i == "string" || t ? e(i) : i) : n);
class GW {
  constructor() {
    this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
  }
  /** Clear all entries. */
  reset() {
    this._cacheMap.clear(), this._cache.clear();
  }
  /**
   * Check if the key exists
   * @param key - The key to check
   */
  has(e) {
    return this._cache.has(e);
  }
  /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */
  get(e) {
    const t = this._cache.get(e);
    return t || at(`[Assets] Asset id ${e} was not found in the Cache`), t;
  }
  /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */
  set(e, t) {
    const i = za(e);
    let s;
    for (let l = 0; l < this.parsers.length; l++) {
      const d = this.parsers[l];
      if (d.test(t)) {
        s = d.getCacheableAssets(i, t);
        break;
      }
    }
    const o = new Map(Object.entries(s || {}));
    s || i.forEach((l) => {
      o.set(l, t);
    });
    const r = [...o.keys()], a = {
      cacheKeys: r,
      keys: i
    };
    i.forEach((l) => {
      this._cacheMap.set(l, a);
    }), r.forEach((l) => {
      const d = s ? s[l] : t;
      this._cache.has(l) && this._cache.get(l) !== d && at("[Cache] already has key:", l), this._cache.set(l, o.get(l));
    });
  }
  /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */
  remove(e) {
    if (!this._cacheMap.has(e)) {
      at(`[Assets] Asset id ${e} was not found in the Cache`);
      return;
    }
    const t = this._cacheMap.get(e);
    t.cacheKeys.forEach((s) => {
      this._cache.delete(s);
    }), t.keys.forEach((s) => {
      this._cacheMap.delete(s);
    });
  }
  /**
   * All loader parsers registered
   * @advanced
   */
  get parsers() {
    return this._parsers;
  }
}
const $a = new GW(), xv = [];
ct.handleByList(Ae.TextureSource, xv);
function q8(n = {}) {
  const e = n && n.resource, t = e ? n.resource : n, i = e ? n : { resource: n };
  for (let s = 0; s < xv.length; s++) {
    const o = xv[s];
    if (o.test(t))
      return new o(i);
  }
  throw new Error(`Could not find a source type for resource: ${i.resource}`);
}
function jW(n = {}, e = !1) {
  const t = n && n.resource, i = t ? n.resource : n, s = t ? n : { resource: n };
  if (!e && $a.has(i))
    return $a.get(i);
  const o = new Ze({ source: q8(s) });
  return o.on("destroy", () => {
    $a.has(i) && $a.remove(i);
  }), e || $a.set(i, o), o;
}
function HW(n, e = !1) {
  return typeof n == "string" ? $a.get(n) : n instanceof an ? new Ze({ source: n }) : jW(n, e);
}
Ze.from = HW;
an.from = q8;
ct.add(
  G8,
  j8,
  H8,
  UW,
  xc,
  ki,
  x1
);
var K8 = /* @__PURE__ */ ((n) => (n[n.Low = 0] = "Low", n[n.Normal = 1] = "Normal", n[n.High = 2] = "High", n))(K8 || {});
function Ei(n) {
  if (typeof n != "string")
    throw new TypeError(`Path must be a string. Received ${JSON.stringify(n)}`);
}
function Jl(n) {
  return n.split("?")[0].split("#")[0];
}
function VW(n) {
  return n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function WW(n, e, t) {
  return n.replace(new RegExp(VW(e), "g"), t);
}
function qW(n, e) {
  let t = "", i = 0, s = -1, o = 0, r = -1;
  for (let a = 0; a <= n.length; ++a) {
    if (a < n.length)
      r = n.charCodeAt(a);
    else {
      if (r === 47)
        break;
      r = 47;
    }
    if (r === 47) {
      if (!(s === a - 1 || o === 1)) if (s !== a - 1 && o === 2) {
        if (t.length < 2 || i !== 2 || t.charCodeAt(t.length - 1) !== 46 || t.charCodeAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            const l = t.lastIndexOf("/");
            if (l !== t.length - 1) {
              l === -1 ? (t = "", i = 0) : (t = t.slice(0, l), i = t.length - 1 - t.lastIndexOf("/")), s = a, o = 0;
              continue;
            }
          } else if (t.length === 2 || t.length === 1) {
            t = "", i = 0, s = a, o = 0;
            continue;
          }
        }
      } else
        t.length > 0 ? t += `/${n.slice(s + 1, a)}` : t = n.slice(s + 1, a), i = a - s - 1;
      s = a, o = 0;
    } else r === 46 && o !== -1 ? ++o : o = -1;
  }
  return t;
}
const wc = {
  /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   * @example
   * ```ts
   * // Convert a Windows path to POSIX format
   * path.toPosix('C:\\Users\\User\\Documents\\file.txt');
   * // -> 'C:/Users/User/Documents/file.txt'
   * ```
   */
  toPosix(n) {
    return WW(n, "\\", "/");
  },
  /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a URL
   * path.isUrl('http://www.example.com');
   * // -> true
   * path.isUrl('C:/Users/User/Documents/file.txt');
   * // -> false
   * ```
   */
  isUrl(n) {
    return /^https?:/.test(this.toPosix(n));
  },
  /**
   * Checks if the path is a data URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a data URL
   * path.isDataUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...');
   * // -> true
   * ```
   */
  isDataUrl(n) {
    return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(n);
  },
  /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a blob URL
   * path.isBlobUrl('blob:http://www.example.com/12345678-1234-1234-1234-123456789012');
   * // -> true
   * ```
   */
  isBlobUrl(n) {
    return n.startsWith("blob:");
  },
  /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path has a protocol
   * path.hasProtocol('http://www.example.com');
   * // -> true
   * path.hasProtocol('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */
  hasProtocol(n) {
    return /^[^/:]+:/.test(this.toPosix(n));
  },
  /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   * @example
   * ```ts
   * // Get the protocol from a URL
   * path.getProtocol('http://www.example.com/path/to/resource');
   * // -> 'http://'
   * // Get the protocol from a file path
   * path.getProtocol('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */
  getProtocol(n) {
    Ei(n), n = this.toPosix(n);
    const e = /^file:\/\/\//.exec(n);
    if (e)
      return e[0];
    const t = /^[^/:]+:\/{0,2}/.exec(n);
    return t ? t[0] : "";
  },
  /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   * @example
   * ```ts
   * // Convert a relative URL to an absolute path
   * path.toAbsolute('images/texture.png', 'http://example.com/assets/');
   * // -> 'http://example.com/assets/images/texture.png'
   * ```
   */
  toAbsolute(n, e, t) {
    if (Ei(n), this.isDataUrl(n) || this.isBlobUrl(n)) return n;
    const i = Jl(this.toPosix(e != null ? e : Pt.get().getBaseUrl())), s = Jl(this.toPosix(t != null ? t : this.rootname(i)));
    return n = this.toPosix(n), n.startsWith("/") ? wc.join(s, n.slice(1)) : this.isAbsolute(n) ? n : this.join(i, n);
  },
  /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   * @example
   * ```ts
   * // Normalize a path with relative segments
   * path.normalize('http://www.example.com/foo/bar/../baz');
   * // -> 'http://www.example.com/foo/baz'
   * // Normalize a file path with relative segments
   * path.normalize('C:\\Users\\User\\Documents\\..\\file.txt');
   * // -> 'C:/Users/User/file.txt'
   * ```
   */
  normalize(n) {
    if (Ei(n), n.length === 0) return ".";
    if (this.isDataUrl(n) || this.isBlobUrl(n)) return n;
    n = this.toPosix(n);
    let e = "";
    const t = n.startsWith("/");
    this.hasProtocol(n) && (e = this.rootname(n), n = n.slice(e.length));
    const i = n.endsWith("/");
    return n = qW(n), n.length > 0 && i && (n += "/"), t ? `/${n}` : e + n;
  },
  /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   * @example
   * ```ts
   * // Check if a path is absolute
   * path.isAbsolute('http://www.example.com/foo/bar');
   * // -> true
   * path.isAbsolute('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */
  isAbsolute(n) {
    return Ei(n), n = this.toPosix(n), this.hasProtocol(n) ? !0 : n.startsWith("/");
  },
  /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   * @example
   * ```ts
   * // Join multiple path segments
   * path.join('assets', 'images', 'sprite.png');
   * // -> 'assets/images/sprite.png'
   * // Join with relative segments
   * path.join('assets', 'images', '../textures', 'sprite.png');
   * // -> 'assets/textures/sprite.png'
   * ```
   */
  join(...n) {
    var t;
    if (n.length === 0)
      return ".";
    let e;
    for (let i = 0; i < n.length; ++i) {
      const s = n[i];
      if (Ei(s), s.length > 0)
        if (e === void 0) e = s;
        else {
          const o = (t = n[i - 1]) != null ? t : "";
          this.joinExtensions.includes(this.extname(o).toLowerCase()) ? e += `/../${s}` : e += `/${s}`;
        }
    }
    return e === void 0 ? "." : this.normalize(e);
  },
  /**
   * Returns the directory name of a path
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the directory name of a path
   * path.dirname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/foo/bar'
   * // Get the directory name of a file path
   * path.dirname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/Users/User/Documents'
   * ```
   */
  dirname(n) {
    if (Ei(n), n.length === 0) return ".";
    n = this.toPosix(n);
    let e = n.charCodeAt(0);
    const t = e === 47;
    let i = -1, s = !0;
    const o = this.getProtocol(n), r = n;
    n = n.slice(o.length);
    for (let a = n.length - 1; a >= 1; --a)
      if (e = n.charCodeAt(a), e === 47) {
        if (!s) {
          i = a;
          break;
        }
      } else
        s = !1;
    return i === -1 ? t ? "/" : this.isUrl(r) ? o + n : o : t && i === 1 ? "//" : o + n.slice(0, i);
  },
  /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the root of a URL
   * path.rootname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/'
   * // Get the root of a file path
   * path.rootname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */
  rootname(n) {
    Ei(n), n = this.toPosix(n);
    let e = "";
    if (n.startsWith("/") ? e = "/" : e = this.getProtocol(n), this.isUrl(n)) {
      const t = n.indexOf("/", e.length);
      t !== -1 ? e = n.slice(0, t) : e = n, e.endsWith("/") || (e += "/");
    }
    return e;
  },
  /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   * @example
   * ```ts
   * // Get the basename of a URL
   * path.basename('http://www.example.com/foo/bar/baz.png');
   * // -> 'baz.png'
   * // Get the basename of a file path
   * path.basename('C:/Users/User/Documents/file.txt');
   * // -> 'file.txt'
   * ```
   */
  basename(n, e) {
    Ei(n), e && Ei(e), n = Jl(this.toPosix(n));
    let t = 0, i = -1, s = !0, o;
    if (e !== void 0 && e.length > 0 && e.length <= n.length) {
      if (e.length === n.length && e === n) return "";
      let r = e.length - 1, a = -1;
      for (o = n.length - 1; o >= 0; --o) {
        const l = n.charCodeAt(o);
        if (l === 47) {
          if (!s) {
            t = o + 1;
            break;
          }
        } else
          a === -1 && (s = !1, a = o + 1), r >= 0 && (l === e.charCodeAt(r) ? --r === -1 && (i = o) : (r = -1, i = a));
      }
      return t === i ? i = a : i === -1 && (i = n.length), n.slice(t, i);
    }
    for (o = n.length - 1; o >= 0; --o)
      if (n.charCodeAt(o) === 47) {
        if (!s) {
          t = o + 1;
          break;
        }
      } else i === -1 && (s = !1, i = o + 1);
    return i === -1 ? "" : n.slice(t, i);
  },
  /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the extension of a URL
   * path.extname('http://www.example.com/foo/bar/baz.png');
   * // -> '.png'
   * // Get the extension of a file path
   * path.extname('C:/Users/User/Documents/file.txt');
   * // -> '.txt'
   * ```
   */
  extname(n) {
    Ei(n), n = Jl(this.toPosix(n));
    let e = -1, t = 0, i = -1, s = !0, o = 0;
    for (let r = n.length - 1; r >= 0; --r) {
      const a = n.charCodeAt(r);
      if (a === 47) {
        if (!s) {
          t = r + 1;
          break;
        }
        continue;
      }
      i === -1 && (s = !1, i = r + 1), a === 46 ? e === -1 ? e = r : o !== 1 && (o = 1) : e !== -1 && (o = -1);
    }
    return e === -1 || i === -1 || o === 0 || o === 1 && e === i - 1 && e === t + 1 ? "" : n.slice(e, i);
  },
  /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Parse a URL
   * const parsed = path.parse('http://www.example.com/foo/bar/baz.png');
   * // -> {
   * //   root: 'http://www.example.com/',
   * //   dir: 'http://www.example.com/foo/bar',
   * //   base: 'baz.png',
   * //   ext: '.png',
   * //   name: 'baz'
   * // }
   * // Parse a file path
   * const parsedFile = path.parse('C:/Users/User/Documents/file.txt');
   * // -> {
   * //   root: 'C:/',
   * //   dir: 'C:/Users/User/Documents',
   * //   base: 'file.txt',
   * //   ext: '.txt',
   * //   name: 'file'
   * // }
   * ```
   */
  parse(n) {
    Ei(n);
    const e = { root: "", dir: "", base: "", ext: "", name: "" };
    if (n.length === 0) return e;
    n = Jl(this.toPosix(n));
    let t = n.charCodeAt(0);
    const i = this.isAbsolute(n);
    let s;
    e.root = this.rootname(n), i || this.hasProtocol(n) ? s = 1 : s = 0;
    let o = -1, r = 0, a = -1, l = !0, d = n.length - 1, c = 0;
    for (; d >= s; --d) {
      if (t = n.charCodeAt(d), t === 47) {
        if (!l) {
          r = d + 1;
          break;
        }
        continue;
      }
      a === -1 && (l = !1, a = d + 1), t === 46 ? o === -1 ? o = d : c !== 1 && (c = 1) : o !== -1 && (c = -1);
    }
    return o === -1 || a === -1 || c === 0 || c === 1 && o === a - 1 && o === r + 1 ? a !== -1 && (r === 0 && i ? e.base = e.name = n.slice(1, a) : e.base = e.name = n.slice(r, a)) : (r === 0 && i ? (e.name = n.slice(1, o), e.base = n.slice(1, a)) : (e.name = n.slice(r, o), e.base = n.slice(r, a)), e.ext = n.slice(o, a)), e.dir = this.dirname(n), e;
  },
  sep: "/",
  delimiter: ":",
  joinExtensions: [".html"]
};
function Y8(n, e, t, i, s) {
  const o = e[t];
  for (let r = 0; r < o.length; r++) {
    const a = o[r];
    t < e.length - 1 ? Y8(n.replace(i[t], a), e, t + 1, i, s) : s.push(n.replace(i[t], a));
  }
}
function KW(n) {
  const e = /\{(.*?)\}/g, t = n.match(e), i = [];
  if (t) {
    const s = [];
    t.forEach((o) => {
      const r = o.substring(1, o.length - 1).split(",");
      s.push(r);
    }), Y8(n, s, 0, t, i);
  } else
    i.push(n);
  return i;
}
const qw = (n) => !Array.isArray(n);
class X8 {
  constructor() {
    this._defaultBundleIdentifierOptions = {
      connector: "-",
      createBundleAssetId: (e, t) => `${e}${this._bundleIdConnector}${t}`,
      extractAssetIdFromBundle: (e, t) => t.replace(`${e}${this._bundleIdConnector}`, "")
    }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
  }
  /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */
  setBundleIdentifier(e) {
    var t, i, s;
    if (this._bundleIdConnector = (t = e.connector) != null ? t : this._bundleIdConnector, this._createBundleAssetId = (i = e.createBundleAssetId) != null ? i : this._createBundleAssetId, this._extractAssetIdFromBundle = (s = e.extractAssetIdFromBundle) != null ? s : this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar")
      throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
  }
  /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */
  prefer(...e) {
    e.forEach((t) => {
      this._preferredOrder.push(t), t.priority || (t.priority = Object.keys(t.params));
    }), this._resolverHash = {};
  }
  /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */
  set basePath(e) {
    this._basePath = e;
  }
  get basePath() {
    return this._basePath;
  }
  /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */
  set rootPath(e) {
    this._rootPath = e;
  }
  get rootPath() {
    return this._rootPath;
  }
  /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */
  get parsers() {
    return this._parsers;
  }
  /** Used for testing, this resets the resolver to its initial state */
  reset() {
    this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
  }
  /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */
  setDefaultSearchParams(e) {
    if (typeof e == "string")
      this._defaultSearchParams = e;
    else {
      const t = e;
      this._defaultSearchParams = Object.keys(t).map((i) => `${encodeURIComponent(i)}=${encodeURIComponent(t[i])}`).join("&");
    }
  }
  /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */
  getAlias(e) {
    const { alias: t, src: i } = e;
    return za(
      t || i,
      (o) => typeof o == "string" ? o : Array.isArray(o) ? o.map((r) => {
        var a;
        return (a = r == null ? void 0 : r.src) != null ? a : r;
      }) : o != null && o.src ? o.src : o,
      !0
    );
  }
  /**
   * Removes the specified alias for an asset.
   *
   * This only removes the alias mapping. It does **not** remove, unload, or destroy the
   * underlying asset. If the asset is already cached, it stays in memory until you call
   * `Assets.unload`.
   *
   * If `asset` is provided, the alias is only removed when the resolver's current mapping for
   * that alias matches the given `ResolvedAsset`. This lets you avoid accidentally removing an
   * alias that has been reassigned.
   *
   * Silently returns if the alias does not exist or the asset does not match.
   * @param alias - the alias to remove
   * @param asset - only remove the alias if it is currently assigned to this asset
   * @example
   * ```ts
   * resolver.add({ alias: 'hero', src: 'hero.png' });
   *
   * // Simple removal
   * resolver.removeAlias('hero');
   *
   * // Conditional removal — only if alias currently maps to a specific asset
   * const resolved = resolver.resolve('hero');
   * resolver.removeAlias('hero', resolved);
   * ```
   */
  removeAlias(e, t) {
    this._assetMap[e] && (t && t !== this._resolverHash[e] || (delete this._resolverHash[e], delete this._assetMap[e]));
  }
  /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */
  addManifest(e) {
    this._manifest && at("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = e, e.bundles.forEach((t) => {
      this.addBundle(t.name, t.assets);
    });
  }
  /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(e, t) {
    const i = [];
    let s = t;
    Array.isArray(t) || (s = Object.entries(t).map(([o, r]) => typeof r == "string" || Array.isArray(r) ? { alias: o, src: r } : { alias: o, ...r })), s.forEach((o) => {
      const r = o.src, a = o.alias;
      let l;
      if (typeof a == "string") {
        const d = this._createBundleAssetId(e, a);
        i.push(d), l = [a, d];
      } else {
        const d = a.map((c) => this._createBundleAssetId(e, c));
        i.push(...d), l = [...a, ...d];
      }
      this.add({
        ...o,
        alias: l,
        src: r
      });
    }), this._bundles[e] = i;
  }
  /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */
  add(e) {
    const t = [];
    Array.isArray(e) ? t.push(...e) : t.push(e);
    let i;
    i = (o) => {
      this.hasKey(o) && at(`[Resolver] already has key: ${o} overwriting`);
    }, za(t).forEach((o) => {
      const { src: r } = o;
      let {
        data: a,
        format: l,
        loadParser: d,
        parser: c
      } = o;
      const u = za(r).map((b) => typeof b == "string" ? KW(b) : Array.isArray(b) ? b : [b]), p = this.getAlias(o);
      Array.isArray(p) ? p.forEach(i) : i(p);
      const f = [], y = (b) => {
        const w = this._parsers.find((k) => k.test(b));
        return {
          src: b,
          ...w == null ? void 0 : w.parse(b)
        };
      };
      u.forEach((b) => {
        b.forEach((w) => {
          var S, _, x, T;
          let k = {};
          if (typeof w != "object" ? k = y(w) : (a = (S = w.data) != null ? S : a, l = (_ = w.format) != null ? _ : l, (w.loadParser || w.parser) && (d = (x = w.loadParser) != null ? x : d, c = (T = w.parser) != null ? T : c), k = {
            ...y(w.src),
            ...w
          }), !p)
            throw new Error(`[Resolver] alias is undefined for this asset: ${k.src}`);
          k = this._buildResolvedAsset(k, {
            aliases: p,
            data: a,
            format: l,
            loadParser: d,
            parser: c,
            progressSize: o.progressSize
          }), f.push(k);
        });
      }), p.forEach((b) => {
        this._assetMap[b] = f;
      });
    });
  }
  // TODO: this needs an overload like load did in Assets
  /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */
  resolveBundle(e) {
    const t = qw(e);
    e = za(e);
    const i = {};
    return e.forEach((s) => {
      const o = this._bundles[s];
      if (o) {
        const r = this.resolve(o), a = {};
        for (const l in r) {
          const d = r[l];
          a[this._extractAssetIdFromBundle(s, l)] = d;
        }
        i[s] = a;
      }
    }), t ? i[e[0]] : i;
  }
  /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */
  resolveUrl(e) {
    const t = this.resolve(e);
    if (typeof e != "string") {
      const i = {};
      for (const s in t)
        i[s] = t[s].src;
      return i;
    }
    return t.src;
  }
  resolve(e) {
    const t = qw(e);
    e = za(e);
    const i = {};
    return e.forEach((s) => {
      if (!this._resolverHash[s])
        if (this._assetMap[s]) {
          let o = this._assetMap[s];
          const r = this._getPreferredOrder(o);
          r == null || r.priority.forEach((a) => {
            r.params[a].forEach((l) => {
              const d = o.filter((c) => c[a] ? c[a] === l : !1);
              d.length && (o = d);
            });
          }), this._resolverHash[s] = o[0];
        } else
          this._resolverHash[s] = this._buildResolvedAsset({
            alias: [s],
            src: s
          }, {});
      i[s] = this._resolverHash[s];
    }), t ? i[e[0]] : i;
  }
  /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */
  hasKey(e) {
    return !!this._assetMap[e];
  }
  /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */
  hasBundle(e) {
    return !!this._bundles[e];
  }
  /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */
  _getPreferredOrder(e) {
    for (let t = 0; t < e.length; t++) {
      const i = e[t], s = this._preferredOrder.find((o) => o.params.format.includes(i.format));
      if (s)
        return s;
    }
    return this._preferredOrder[0];
  }
  /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */
  _appendDefaultSearchParams(e) {
    if (!this._defaultSearchParams) return e;
    const t = /\?/.test(e) ? "&" : "?";
    return `${e}${t}${this._defaultSearchParams}`;
  }
  _buildResolvedAsset(e, t) {
    var d, c;
    const { aliases: i, data: s, loadParser: o, parser: r, format: a, progressSize: l } = t;
    return (this._basePath || this._rootPath) && (e.src = wc.toAbsolute(e.src, this._basePath, this._rootPath)), e.alias = (d = i != null ? i : e.alias) != null ? d : [e.src], e.src = this._appendDefaultSearchParams(e.src), e.data = { ...s || {}, ...e.data }, e.loadParser = o != null ? o : e.loadParser, e.parser = r != null ? r : e.parser, e.format = (c = a != null ? a : e.format) != null ? c : YW(e.src), l !== void 0 && (e.progressSize = l), e;
  }
}
X8.RETINA_PREFIX = /@([0-9\.]+)x/;
function YW(n) {
  return n.split(".").pop().split("?").shift().split("#").shift();
}
const Kw = (n, e) => {
  const t = e.split("?")[1];
  return t && (n += `?${t}`), n;
}, J8 = class Rd {
  constructor(e, t) {
    this.linkedSheets = [];
    let i = e;
    (e == null ? void 0 : e.source) instanceof an && (i = {
      texture: e,
      data: t
    });
    const { texture: s, data: o, cachePrefix: r = "" } = i;
    this.cachePrefix = r, this._texture = s instanceof Ze ? s : null, this.textureSource = s.source, this.textures = {}, this.animations = {}, this.data = o;
    const a = parseFloat(o.meta.scale);
    a ? (this.resolution = a, s.source.resolution = this.resolution) : this.resolution = s.source._resolution, this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
  }
  /**
   * Parse spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */
  parse() {
    return new Promise((e) => {
      this._callback = e, this._batchIndex = 0, this._frameKeys.length <= Rd.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
    });
  }
  /**
   * Parse spritesheet from loaded data. This is done synchronously
   * and is only suitable for smaller spritesheets (less than ~1000 frames)
   * or may cause too many Texture within a single process. However, synchronous parsing may be
   * more convenient since the called does not need to be asynchronous and is safe for
   * small-to-medium sized spritesheets.
   *
   * Other than being synchronous, `parseSync` is otherwise identical to `.parse()`.
   */
  parseSync() {
    return this._processFrames(0, !0), this._processAnimations(), this.textures;
  }
  /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   * @param processAll - if true will process all frames in a single batch, ignoring BATCH_SIZE - this
   * is used for synchronous parsing.
   */
  _processFrames(e, t = !1) {
    let i = e;
    const s = t ? 1 / 0 : Rd.BATCH_SIZE;
    for (; i - e < s && i < this._frameKeys.length; ) {
      const o = this._frameKeys[i], r = this._frames[o], a = r.frame;
      if (a) {
        let l = null, d = null;
        const c = r.trimmed !== !1 && r.sourceSize ? r.sourceSize : r.frame, u = new _t(
          0,
          0,
          Math.floor(c.w) / this.resolution,
          Math.floor(c.h) / this.resolution
        );
        r.rotated ? l = new _t(
          Math.floor(a.x) / this.resolution,
          Math.floor(a.y) / this.resolution,
          Math.floor(a.h) / this.resolution,
          Math.floor(a.w) / this.resolution
        ) : l = new _t(
          Math.floor(a.x) / this.resolution,
          Math.floor(a.y) / this.resolution,
          Math.floor(a.w) / this.resolution,
          Math.floor(a.h) / this.resolution
        ), r.trimmed !== !1 && r.spriteSourceSize && (d = new _t(
          Math.floor(r.spriteSourceSize.x) / this.resolution,
          Math.floor(r.spriteSourceSize.y) / this.resolution,
          Math.floor(a.w) / this.resolution,
          Math.floor(a.h) / this.resolution
        )), this.textures[o] = new Ze({
          source: this.textureSource,
          frame: l,
          orig: u,
          trim: d,
          rotate: r.rotated ? 2 : 0,
          defaultAnchor: r.anchor,
          defaultBorders: r.borders,
          label: o.toString()
        });
      }
      i++;
    }
  }
  /** Parse animations config. */
  _processAnimations() {
    const e = this.data.animations || {};
    for (const t in e) {
      this.animations[t] = [];
      for (let i = 0; i < e[t].length; i++) {
        const s = e[t][i];
        this.animations[t].push(this.textures[s]);
      }
    }
  }
  /** The parse has completed. */
  _parseComplete() {
    const e = this._callback;
    this._callback = null, this._batchIndex = 0, e.call(this, this.textures);
  }
  /** Begin the next batch of textures. */
  _nextBatch() {
    this._processFrames(this._batchIndex * Rd.BATCH_SIZE), this._batchIndex++, setTimeout(() => {
      this._batchIndex * Rd.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
    }, 0);
  }
  /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */
  destroy(e = !1) {
    var t;
    for (const i in this.textures)
      this.textures[i].destroy();
    this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, e && ((t = this._texture) == null || t.destroy(), this.textureSource.destroy()), this._texture = null, this.textureSource = null, this.linkedSheets = [];
  }
};
J8.BATCH_SIZE = 1e3;
let Yw = J8;
const XW = [
  "jpg",
  "png",
  "jpeg",
  "avif",
  "webp",
  "basis",
  "etc2",
  "bc7",
  "bc6h",
  "bc5",
  "bc4",
  "bc3",
  "bc2",
  "bc1",
  "eac",
  "astc"
];
function Z8(n, e, t) {
  const i = {};
  if (n.forEach((s) => {
    i[s] = e;
  }), Object.keys(e.textures).forEach((s) => {
    i[`${e.cachePrefix}${s}`] = e.textures[s];
  }), !t) {
    const s = wc.dirname(n[0]);
    e.linkedSheets.forEach((o, r) => {
      const a = Z8([`${s}/${e.data.meta.related_multi_packs[r]}`], o, !0);
      Object.assign(i, a);
    });
  }
  return i;
}
const JW = {
  extension: Ae.Asset,
  /** Handle the caching of the related Spritesheet Textures */
  cache: {
    test: (n) => n instanceof Yw,
    getCacheableAssets: (n, e) => Z8(n, e, !1)
  },
  /** Resolve the resolution of the asset. */
  resolver: {
    extension: {
      type: Ae.ResolveParser,
      name: "resolveSpritesheet"
    },
    test: (n) => {
      const t = n.split("?")[0].split("."), i = t.pop(), s = t.pop();
      return i === "json" && XW.includes(s);
    },
    parse: (n) => {
      var t, i;
      const e = n.split(".");
      return {
        resolution: parseFloat((i = (t = X8.RETINA_PREFIX.exec(n)) == null ? void 0 : t[1]) != null ? i : "1"),
        format: e[e.length - 2],
        src: n
      };
    }
  },
  /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */
  loader: {
    /** used for deprecation purposes */
    name: "spritesheetLoader",
    id: "spritesheet",
    extension: {
      type: Ae.LoadParser,
      priority: K8.Normal,
      name: "spritesheetLoader"
    },
    async testParse(n, e) {
      return wc.extname(e.src).toLowerCase() === ".json" && !!n.frames;
    },
    async parse(n, e, t) {
      var u, p, f;
      const {
        texture: i,
        // if user need to use preloaded texture
        imageFilename: s,
        // if user need to use custom filename (not from jsonFile.meta.image)
        textureOptions: o,
        // if user need to set texture options on texture
        cachePrefix: r
        // if user need to use custom cache prefix
      } = (u = e == null ? void 0 : e.data) != null ? u : {};
      let a = wc.dirname(e.src);
      a && a.lastIndexOf("/") !== a.length - 1 && (a += "/");
      let l;
      if (i instanceof Ze)
        l = i;
      else {
        const y = Kw(a + (s != null ? s : n.meta.image), e.src);
        l = (await t.load([{ src: y, data: o }]))[y];
      }
      const d = new Yw({
        texture: l.source,
        data: n,
        cachePrefix: r
      });
      await d.parse();
      const c = (p = n == null ? void 0 : n.meta) == null ? void 0 : p.related_multi_packs;
      if (Array.isArray(c)) {
        const y = [];
        for (const w of c) {
          if (typeof w != "string")
            continue;
          let k = a + w;
          (f = e.data) != null && f.ignoreMultiPack || (k = Kw(k, e.src), y.push(t.load({
            src: k,
            data: {
              textureOptions: o,
              ignoreMultiPack: !0
            }
          })));
        }
        const b = await Promise.all(y);
        d.linkedSheets = b, b.forEach((w) => {
          w.linkedSheets = [d].concat(d.linkedSheets.filter((k) => k !== w));
        });
      }
      return d;
    },
    async unload(n, e, t) {
      await t.unload(n.textureSource._sourceOrigin), n.destroy(!1);
    }
  }
};
ct.add(JW);
class Q8 {
  constructor(e) {
    this._lastTransform = "", this._observer = null, this._tickerAttached = !1, this.updateTranslation = () => {
      if (!this._canvas) return;
      const t = this._canvas.getBoundingClientRect(), i = this._canvas.width, s = this._canvas.height, o = t.width / i * this._renderer.resolution, r = t.height / s * this._renderer.resolution, a = t.left, l = t.top, d = `translate(${a}px, ${l}px) scale(${o}, ${r})`;
      d !== this._lastTransform && (this._domElement.style.transform = d, this._lastTransform = d);
    }, this._domElement = e.domElement, this._renderer = e.renderer, !(globalThis.OffscreenCanvas && this._renderer.canvas instanceof OffscreenCanvas) && (this._canvas = this._renderer.canvas, this._attachObserver());
  }
  /** The canvas element that this CanvasObserver is associated with. */
  get canvas() {
    return this._canvas;
  }
  /** Attaches the DOM element to the canvas parent if it is not already attached. */
  ensureAttached() {
    !this._domElement.parentNode && this._canvas.parentNode && (this._canvas.parentNode.appendChild(this._domElement), this.updateTranslation());
  }
  /** Sets up a ResizeObserver if available. This ensures that the DOM element is kept in sync with the canvas size . */
  _attachObserver() {
    "ResizeObserver" in globalThis ? (this._observer && (this._observer.disconnect(), this._observer = null), this._observer = new ResizeObserver((e) => {
      for (const t of e) {
        if (t.target !== this._canvas)
          continue;
        const i = this.canvas.width, s = this.canvas.height, o = t.contentRect.width / i * this._renderer.resolution, r = t.contentRect.height / s * this._renderer.resolution;
        (this._lastScaleX !== o || this._lastScaleY !== r) && (this.updateTranslation(), this._lastScaleX = o, this._lastScaleY = r);
      }
    }), this._observer.observe(this._canvas)) : this._tickerAttached || Ci.shared.add(this.updateTranslation, this, bl.HIGH);
  }
  /** Destroys the CanvasObserver instance, cleaning up observers and Ticker. */
  destroy() {
    this._observer ? (this._observer.disconnect(), this._observer = null) : this._tickerAttached && Ci.shared.remove(this.updateTranslation), this._domElement = null, this._renderer = null, this._canvas = null, this._tickerAttached = !1, this._lastTransform = "", this._lastScaleX = null, this._lastScaleY = null;
  }
}
class Yc {
  /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */
  constructor(e) {
    this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = Yc.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new Gt(), this.page = new Gt(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = e;
  }
  /** @readonly */
  get layerX() {
    return this.layer.x;
  }
  /** @readonly */
  get layerY() {
    return this.layer.y;
  }
  /** @readonly */
  get pageX() {
    return this.page.x;
  }
  /** @readonly */
  get pageY() {
    return this.page.y;
  }
  /**
   * Fallback for the deprecated `InteractionEvent.data`.
   * @deprecated since 7.0.0
   */
  get data() {
    return this;
  }
  /**
   * The propagation path for this event. Alias for {@link EventBoundary.propagationPath}.
   * @advanced
   */
  composedPath() {
    return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
  }
  /**
   * Unimplemented method included for implementing the DOM interface `Event`. It will throw an `Error`.
   * @deprecated
   * @ignore
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */
  initEvent(e, t, i) {
    throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Unimplemented method included for implementing the DOM interface `UIEvent`. It will throw an `Error`.
   * @ignore
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */
  initUIEvent(e, t, i, s, o) {
    throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Prevent default behavior of both PixiJS and the user agent.
   * @example
   * ```ts
   * sprite.on('click', (event) => {
   *     // Prevent both browser's default click behavior
   *     // and PixiJS's default handling
   *     event.preventDefault();
   *
   *     // Custom handling
   *     customClickHandler();
   * });
   * ```
   * @remarks
   * - Only works if the native event is cancelable
   * - Does not stop event propagation
   */
  preventDefault() {
    this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
  }
  /**
   * Stop this event from propagating to any additional listeners, including those
   * on the current target and any following targets in the propagation path.
   * @example
   * ```ts
   * container.on('pointerdown', (event) => {
   *     // Stop all further event handling
   *     event.stopImmediatePropagation();
   *
   *     // These handlers won't be called:
   *     // - Other pointerdown listeners on this container
   *     // - Any pointerdown listeners on parent containers
   * });
   * ```
   * @remarks
   * - Immediately stops all event propagation
   * - Prevents other listeners on same target from being called
   * - More aggressive than stopPropagation()
   */
  stopImmediatePropagation() {
    this.propagationImmediatelyStopped = !0;
  }
  /**
   * Stop this event from propagating to the next target in the propagation path.
   * The rest of the listeners on the current target will still be notified.
   * @example
   * ```ts
   * child.on('pointermove', (event) => {
   *     // Handle event on child
   *     updateChild();
   *
   *     // Prevent parent handlers from being called
   *     event.stopPropagation();
   * });
   *
   * // This won't be called if child handles the event
   * parent.on('pointermove', (event) => {
   *     updateParent();
   * });
   * ```
   * @remarks
   * - Stops event bubbling to parent containers
   * - Does not prevent other listeners on same target
   * - Less aggressive than stopImmediatePropagation()
   */
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
var ig = /iPhone/i, Xw = /iPod/i, Jw = /iPad/i, Zw = /\biOS-universal(?:.+)Mac\b/i, sg = /\bAndroid(?:.+)Mobile\b/i, Qw = /Android/i, ca = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i, Ru = /Silk/i, xs = /Windows Phone/i, ek = /\bWindows(?:.+)ARM\b/i, tk = /BlackBerry/i, nk = /BB10/i, ik = /Opera Mini/i, sk = /\b(CriOS|Chrome)(?:.+)Mobile/i, ok = /Mobile(?:.+)Firefox\b/i, rk = function(n) {
  return typeof n != "undefined" && n.platform === "MacIntel" && typeof n.maxTouchPoints == "number" && n.maxTouchPoints > 1 && typeof MSStream == "undefined";
};
function ZW(n) {
  return function(e) {
    return e.test(n);
  };
}
function ak(n) {
  var e = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  !n && typeof navigator != "undefined" ? e = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints || 0
  } : typeof n == "string" ? e.userAgent = n : n && n.userAgent && (e = {
    userAgent: n.userAgent,
    platform: n.platform,
    maxTouchPoints: n.maxTouchPoints || 0
  });
  var t = e.userAgent, i = t.split("[FBAN");
  typeof i[1] != "undefined" && (t = i[0]), i = t.split("Twitter"), typeof i[1] != "undefined" && (t = i[0]);
  var s = ZW(t), o = {
    apple: {
      phone: s(ig) && !s(xs),
      ipod: s(Xw),
      tablet: !s(ig) && (s(Jw) || rk(e)) && !s(xs),
      universal: s(Zw),
      device: (s(ig) || s(Xw) || s(Jw) || s(Zw) || rk(e)) && !s(xs)
    },
    amazon: {
      phone: s(ca),
      tablet: !s(ca) && s(Ru),
      device: s(ca) || s(Ru)
    },
    android: {
      phone: !s(xs) && s(ca) || !s(xs) && s(sg),
      tablet: !s(xs) && !s(ca) && !s(sg) && (s(Ru) || s(Qw)),
      device: !s(xs) && (s(ca) || s(Ru) || s(sg) || s(Qw)) || s(/\bokhttp\b/i)
    },
    windows: {
      phone: s(xs),
      tablet: s(ek),
      device: s(xs) || s(ek)
    },
    other: {
      blackberry: s(tk),
      blackberry10: s(nk),
      opera: s(ik),
      firefox: s(ok),
      chrome: s(sk),
      device: s(tk) || s(nk) || s(ik) || s(ok) || s(sk)
    },
    any: !1,
    phone: !1,
    tablet: !1
  };
  return o.any = o.apple.device || o.android.device || o.windows.device || o.other.device, o.phone = o.apple.phone || o.android.phone || o.windows.phone, o.tablet = o.apple.tablet || o.android.tablet || o.windows.tablet, o;
}
var Q4;
const QW = (Q4 = ak.default) != null ? Q4 : ak, eq = QW(globalThis.navigator), tq = 9, lk = 100, nq = 0, iq = 0, dk = 2, ck = 1, sq = -1e3, oq = -1e3, rq = 2, C1 = class eS {
  // eslint-disable-next-line jsdoc/require-param
  /**
   * @param {WebGLRenderer|WebGPURenderer} renderer - A reference to the current renderer
   */
  constructor(e, t = eq) {
    this._mobileInfo = t, this.debug = !1, this._activateOnTab = !0, this._deactivateOnMouseMove = !0, this._isActive = !1, this._isMobileAccessibility = !1, this._div = null, this._pools = {}, this._renderId = 0, this._children = [], this._androidUpdateCount = 0, this._androidUpdateFrequency = 500, this._isRunningTests = !1, this._boundOnKeyDown = this._onKeyDown.bind(this), this._boundOnMouseMove = this._onMouseMove.bind(this), this._hookDiv = null, (t.tablet || t.phone) && this._createTouchHook(), this._renderer = e;
  }
  /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @type {boolean}
   * @readonly
   */
  get isActive() {
    return this._isActive;
  }
  /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @type {boolean}
   * @readonly
   */
  get isMobileAccessibility() {
    return this._isMobileAccessibility;
  }
  /**
   * Button element for handling touch hooks.
   * @readonly
   */
  get hookDiv() {
    return this._hookDiv;
  }
  /**
   * The DOM element that will sit over the PixiJS element. This is where the div overlays will go.
   * @readonly
   */
  get div() {
    return this._div;
  }
  /**
   * Creates the touch hooks.
   * @private
   */
  _createTouchHook() {
    const e = document.createElement("button");
    e.style.width = `${ck}px`, e.style.height = `${ck}px`, e.style.position = "absolute", e.style.top = `${sq}px`, e.style.left = `${oq}px`, e.style.zIndex = rq.toString(), e.style.backgroundColor = "#FF0000", e.title = "select to enable accessibility for this content", e.addEventListener("focus", () => {
      this._isMobileAccessibility = !0, this._activate(), this._destroyTouchHook();
    }), document.body.appendChild(e), this._hookDiv = e;
  }
  /**
   * Destroys the touch hooks.
   * @private
   */
  _destroyTouchHook() {
    this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
  }
  /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */
  _activate() {
    if (this._isActive)
      return;
    this._isActive = !0, this._div || (this._div = document.createElement("div"), this._div.style.position = "absolute", this._div.style.top = `${nq}px`, this._div.style.left = `${iq}px`, this._div.style.pointerEvents = "none", this._div.style.zIndex = dk.toString(), this._canvasObserver = new Q8({
      domElement: this._div,
      renderer: this._renderer
    })), this._deactivateOnMouseMove && globalThis.document.addEventListener("mousemove", this._boundOnMouseMove, !0);
    const e = this._renderer.view.canvas;
    if (e.parentNode)
      this._canvasObserver.ensureAttached(), this._initAccessibilitySetup();
    else {
      const t = new MutationObserver(() => {
        e.parentNode && (t.disconnect(), this._canvasObserver.ensureAttached(), this._initAccessibilitySetup());
      });
      t.observe(document.body, { childList: !0, subtree: !0 });
    }
  }
  // New method to handle initialization after div is ready
  _initAccessibilitySetup() {
    this._renderer.runners.postrender.add(this), this._renderer.lastObjectRendered && this._updateAccessibleObjects(this._renderer.lastObjectRendered);
  }
  /**
   * Deactivates the accessibility system. Removes listeners and accessibility elements.
   * @private
   */
  _deactivate() {
    var e, t;
    if (!(!this._isActive || this._isMobileAccessibility)) {
      this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._boundOnMouseMove, !0), this._renderer.runners.postrender.remove(this);
      for (const i of this._children)
        (e = i._accessibleDiv) != null && e.parentNode && (i._accessibleDiv.parentNode.removeChild(i._accessibleDiv), i._accessibleDiv = null), i._accessibleActive = !1;
      for (const i in this._pools)
        this._pools[i].forEach((o) => {
          o.parentNode && o.parentNode.removeChild(o);
        }), delete this._pools[i];
      (t = this._div) != null && t.parentNode && this._div.parentNode.removeChild(this._div), this._pools = {}, this._children = [];
    }
  }
  /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {Container} container - The Container to check.
   */
  _updateAccessibleObjects(e) {
    if (!e.visible || !e.accessibleChildren)
      return;
    e.accessible && (e._accessibleActive || this._addChild(e), e._renderId = this._renderId);
    const t = e.children;
    if (t)
      for (let i = 0; i < t.length; i++)
        this._updateAccessibleObjects(t[i]);
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(e) {
    const i = {
      accessibilityOptions: {
        ...eS.defaultOptions,
        ...(e == null ? void 0 : e.accessibilityOptions) || {}
      }
    };
    this.debug = i.accessibilityOptions.debug, this._activateOnTab = i.accessibilityOptions.activateOnTab, this._deactivateOnMouseMove = i.accessibilityOptions.deactivateOnMouseMove, this._activateOnTab && globalThis.addEventListener("keydown", this._boundOnKeyDown, !1), i.accessibilityOptions.enabledByDefault && this._activate(), this._renderer.runners.postrender.remove(this);
  }
  /**
   * Updates the accessibility layer during rendering.
   * - Removes divs for containers no longer in the scene
   * - Updates the position and dimensions of the root div
   * - Updates positions of active accessibility divs
   * Only fires while the accessibility system is active.
   * @ignore
   */
  postrender() {
    const e = performance.now();
    if (this._mobileInfo.android.device && e < this._androidUpdateCount || (this._androidUpdateCount = e + this._androidUpdateFrequency, (!this._renderer.renderingToScreen || !this._renderer.view.canvas) && !this._isRunningTests))
      return;
    const t = /* @__PURE__ */ new Set();
    if (this._renderer.lastObjectRendered) {
      this._updateAccessibleObjects(this._renderer.lastObjectRendered);
      for (const i of this._children)
        i._renderId === this._renderId && t.add(this._children.indexOf(i));
    }
    for (let i = this._children.length - 1; i >= 0; i--) {
      const s = this._children[i];
      t.has(i) || (s._accessibleDiv && s._accessibleDiv.parentNode && (s._accessibleDiv.parentNode.removeChild(s._accessibleDiv), this._getPool(s.accessibleType).push(s._accessibleDiv), s._accessibleDiv = null), s._accessibleActive = !1, $8(this._children, i, 1));
    }
    this._renderer.renderingToScreen && this._canvasObserver.ensureAttached();
    for (let i = 0; i < this._children.length; i++) {
      const s = this._children[i];
      if (!s._accessibleActive || !s._accessibleDiv)
        continue;
      const o = s._accessibleDiv, r = s.hitArea || s.getBounds().rectangle;
      if (s.hitArea) {
        const a = s.worldTransform;
        o.style.left = `${a.tx + r.x * a.a}px`, o.style.top = `${a.ty + r.y * a.d}px`, o.style.width = `${r.width * a.a}px`, o.style.height = `${r.height * a.d}px`;
      } else
        this._capHitArea(r), o.style.left = `${r.x}px`, o.style.top = `${r.y}px`, o.style.width = `${r.width}px`, o.style.height = `${r.height}px`;
    }
    this._renderId++;
  }
  /**
   * private function that will visually add the information to the
   * accessibility div
   * @param {HTMLElement} div -
   */
  _updateDebugHTML(e) {
    e.innerHTML = `type: ${e.type}</br> title : ${e.title}</br> tabIndex: ${e.tabIndex}`;
  }
  /**
   * Adjust the hit area based on the bounds of a display object
   * @param {Rectangle} hitArea - Bounds of the child
   */
  _capHitArea(e) {
    e.x < 0 && (e.width += e.x, e.x = 0), e.y < 0 && (e.height += e.y, e.y = 0);
    const { width: t, height: i } = this._renderer;
    e.x + e.width > t && (e.width = t - e.x), e.y + e.height > i && (e.height = i - e.y);
  }
  /**
   * Creates or reuses a div element for a Container and adds it to the accessibility layer.
   * Sets up ARIA attributes, event listeners, and positioning based on the container's properties.
   * @private
   * @param {Container} container - The child to make accessible.
   */
  _addChild(e) {
    let i = this._getPool(e.accessibleType).pop();
    i ? (i.innerHTML = "", i.removeAttribute("title"), i.removeAttribute("aria-label"), i.tabIndex = 0) : (e.accessibleType === "button" ? (i = document.createElement("button"), this.debug || (i.style.color = "transparent")) : (i = document.createElement(e.accessibleType), i.style.cssText = `
                        color: transparent;
                        pointer-events: none;
                        padding: 0;
                        margin: 0;
                        border: 0;
                        outline: 0;
                        background: transparent;
                        box-sizing: border-box;
                        user-select: none;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                    `), i.style.width = `${lk}px`, i.style.height = `${lk}px`, i.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", i.style.position = "absolute", i.style.zIndex = dk.toString(), i.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? i.setAttribute("aria-live", "off") : i.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? i.setAttribute("aria-relevant", "additions") : i.setAttribute("aria-relevant", "text"), i.addEventListener("click", this._onClick.bind(this)), i.addEventListener("focus", this._onFocus.bind(this)), i.addEventListener("focusout", this._onFocusOut.bind(this))), i.style.pointerEvents = e.accessiblePointerEvents, i.type = e.accessibleType, e.accessibleText && (i.innerText = e.accessibleText), e.accessibleTitle && e.accessibleTitle !== null ? i.title = e.accessibleTitle : (!e.accessibleHint || e.accessibleHint === null) && (i.title = `container ${e.tabIndex}`), e.accessibleHint && e.accessibleHint !== null && i.setAttribute("aria-label", e.accessibleHint), e.interactive ? i.tabIndex = e.tabIndex : i.tabIndex = 0, this.debug && this._updateDebugHTML(i), e._accessibleActive = !0, e._accessibleDiv = i, i.container = e, this._children.push(e), this._div.appendChild(e._accessibleDiv);
  }
  /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */
  _dispatchEvent(e, t) {
    const { container: i } = e.target, s = this._renderer.events.rootBoundary, o = Object.assign(new Yc(s), { target: i });
    s.rootTarget = this._renderer.lastObjectRendered, t.forEach((r) => s.dispatchEvent(o, r));
  }
  /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */
  _onClick(e) {
    this._dispatchEvent(e, ["click", "pointertap", "tap"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */
  _onFocus(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(e, ["mouseover"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */
  _onFocusOut(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "polite"), this._dispatchEvent(e, ["mouseout"]);
  }
  /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */
  _onKeyDown(e) {
    e.keyCode !== tq || !this._activateOnTab || this._activate();
  }
  /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */
  _onMouseMove(e) {
    e.movementX === 0 && e.movementY === 0 || this._deactivate();
  }
  /**
   * Destroys the accessibility system. Removes all elements and listeners.
   * > [!IMPORTANT] This is typically called automatically when the {@link Application} is destroyed.
   * > A typically user should not need to call this method directly.
   */
  destroy() {
    var e;
    this._deactivate(), this._destroyTouchHook(), (e = this._canvasObserver) == null || e.destroy(), this._canvasObserver = null, this._div = null, this._pools = null, this._children = null, this._renderer = null, this._hookDiv = null, globalThis.removeEventListener("keydown", this._boundOnKeyDown), this._boundOnKeyDown = null, globalThis.document.removeEventListener("mousemove", this._boundOnMouseMove, !0), this._boundOnMouseMove = null;
  }
  /**
   * Enables or disables the accessibility system.
   * @param enabled - Whether to enable or disable accessibility.
   * @example
   * ```js
   * app.renderer.accessibility.setAccessibilityEnabled(true); // Enable accessibility
   * app.renderer.accessibility.setAccessibilityEnabled(false); // Disable accessibility
   * ```
   */
  setAccessibilityEnabled(e) {
    e ? this._activate() : this._deactivate();
  }
  _getPool(e) {
    return this._pools[e] || (this._pools[e] = []), this._pools[e];
  }
};
C1.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "accessibility"
};
C1.defaultOptions = {
  /**
   * Whether to enable accessibility features on initialization
   * @default false
   */
  enabledByDefault: !1,
  /**
   * Whether to visually show the accessibility divs for debugging
   * @default false
   */
  debug: !1,
  /**
   * Whether to activate accessibility when tab key is pressed
   * @default true
   */
  activateOnTab: !0,
  /**
   * Whether to deactivate accessibility when mouse moves
   * @default true
   */
  deactivateOnMouseMove: !0
};
let aq = C1;
const lq = {
  accessible: !1,
  accessibleTitle: null,
  accessibleHint: null,
  tabIndex: 0,
  accessibleType: "button",
  accessibleText: null,
  accessiblePointerEvents: "auto",
  accessibleChildren: !0,
  _accessibleActive: !1,
  _accessibleDiv: null,
  _renderId: -1
}, og = /* @__PURE__ */ Object.create(null), uk = /* @__PURE__ */ Object.create(null);
function vl(n, e) {
  let t = uk[n];
  return t === void 0 && (og[e] === void 0 && (og[e] = 1), uk[n] = t = og[e]++), t;
}
let ua;
function tS() {
  return (!ua || ua != null && ua.isContextLost()) && (ua = Pt.get().createCanvas().getContext("webgl", {})), ua;
}
let zu;
function dq() {
  if (!zu) {
    zu = "mediump";
    const n = tS();
    n && n.getShaderPrecisionFormat && (zu = n.getShaderPrecisionFormat(n.FRAGMENT_SHADER, n.HIGH_FLOAT).precision ? "highp" : "mediump");
  }
  return zu;
}
function cq(n, e, t) {
  return e ? n : t ? (n = n.replace("out vec4 finalColor;", ""), `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${n}
        `) : `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${n}
        `;
}
const uq = /\buniform\s+([iu]?sampler\w+)/g, hq = /\bprecision\s+\w+\s+([iu]?sampler\w+)\s*;/g, pq = {
  sampler2D: "lowp",
  samplerCube: "lowp"
};
function fq(n, e, t) {
  const i = t ? e.maxSupportedFragmentPrecision : e.maxSupportedVertexPrecision;
  if (n.substring(0, 9) !== "precision") {
    let o = t ? e.requestedFragmentPrecision : e.requestedVertexPrecision;
    o === "highp" && i !== "highp" && (o = "mediump"), n = `precision ${o} float;
${n}`;
  } else i !== "highp" && n.substring(0, 15) === "precision highp" && (n = n.replace("precision highp", "precision mediump"));
  const s = e.maxSupportedFragmentPrecision === "highp" ? "highp" : "mediump";
  return mq(n, s);
}
function mq(n, e) {
  var s;
  const t = /* @__PURE__ */ new Set();
  let i = "";
  for (const [, o] of n.matchAll(hq)) t.add(o);
  for (const [, o] of n.matchAll(uq))
    t.has(o) || (t.add(o), i += `precision ${(s = pq[o]) != null ? s : e} ${o};
`);
  return i + n;
}
function gq(n, e) {
  return e ? `#version 300 es
${n}` : n;
}
const bq = {}, vq = {};
function yq(n, { name: e = "pixi-program" }, t = !0) {
  e = e.replace(/\s+/g, "-"), e += t ? "-fragment" : "-vertex";
  const i = t ? bq : vq;
  return i[e] ? (i[e]++, e += `-${i[e]}`) : i[e] = 1, n.indexOf("#define SHADER_NAME") !== -1 ? n : `${`#define SHADER_NAME ${e}`}
${n}`;
}
function xq(n, e) {
  return e ? n.replace("#version 300 es", "") : n;
}
const rg = {
  // strips any version headers..
  stripVersion: xq,
  // adds precision string if not already present
  ensurePrecision: fq,
  // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
  addProgramDefines: cq,
  // add the program name to the shader
  setProgramName: yq,
  // add the version string to the shader header
  insertVersion: gq
}, Zl = /* @__PURE__ */ Object.create(null), nS = class wv {
  /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */
  constructor(e) {
    e = { ...wv.defaultOptions, ...e };
    const t = e.fragment.indexOf("#version 300 es") !== -1, i = {
      stripVersion: t,
      ensurePrecision: {
        requestedFragmentPrecision: e.preferredFragmentPrecision,
        requestedVertexPrecision: e.preferredVertexPrecision,
        maxSupportedVertexPrecision: "highp",
        maxSupportedFragmentPrecision: dq()
      },
      setProgramName: {
        name: e.name
      },
      addProgramDefines: t,
      insertVersion: t
    };
    let s = e.fragment, o = e.vertex;
    Object.keys(rg).forEach((r) => {
      const a = i[r];
      s = rg[r](s, a, !0), o = rg[r](o, a, !1);
    }), this.fragment = s, this.vertex = o, this.transformFeedbackVaryings = e.transformFeedbackVaryings, this._key = vl(`${this.vertex}:${this.fragment}`, "gl-program");
  }
  /** destroys the program */
  destroy() {
    this.fragment = null, this.vertex = null, this._attributeData = null, this._uniformData = null, this._uniformBlockData = null, this.transformFeedbackVaryings = null, Zl[this._cacheKey] = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(e) {
    const t = `${e.vertex}:${e.fragment}`;
    return Zl[t] || (Zl[t] = new wv(e), Zl[t]._cacheKey = t), Zl[t];
  }
};
nS.defaultOptions = {
  preferredVertexPrecision: "highp",
  preferredFragmentPrecision: "mediump"
};
let $l = nS;
const hk = {
  uint8x2: { size: 2, stride: 2, normalised: !1 },
  uint8x4: { size: 4, stride: 4, normalised: !1 },
  sint8x2: { size: 2, stride: 2, normalised: !1 },
  sint8x4: { size: 4, stride: 4, normalised: !1 },
  unorm8x2: { size: 2, stride: 2, normalised: !0 },
  unorm8x4: { size: 4, stride: 4, normalised: !0 },
  snorm8x2: { size: 2, stride: 2, normalised: !0 },
  snorm8x4: { size: 4, stride: 4, normalised: !0 },
  uint16x2: { size: 2, stride: 4, normalised: !1 },
  uint16x4: { size: 4, stride: 8, normalised: !1 },
  sint16x2: { size: 2, stride: 4, normalised: !1 },
  sint16x4: { size: 4, stride: 8, normalised: !1 },
  unorm16x2: { size: 2, stride: 4, normalised: !0 },
  unorm16x4: { size: 4, stride: 8, normalised: !0 },
  snorm16x2: { size: 2, stride: 4, normalised: !0 },
  snorm16x4: { size: 4, stride: 8, normalised: !0 },
  float16x2: { size: 2, stride: 4, normalised: !1 },
  float16x4: { size: 4, stride: 8, normalised: !1 },
  float32: { size: 1, stride: 4, normalised: !1 },
  float32x2: { size: 2, stride: 8, normalised: !1 },
  float32x3: { size: 3, stride: 12, normalised: !1 },
  float32x4: { size: 4, stride: 16, normalised: !1 },
  uint32: { size: 1, stride: 4, normalised: !1 },
  uint32x2: { size: 2, stride: 8, normalised: !1 },
  uint32x3: { size: 3, stride: 12, normalised: !1 },
  uint32x4: { size: 4, stride: 16, normalised: !1 },
  sint32: { size: 1, stride: 4, normalised: !1 },
  sint32x2: { size: 2, stride: 8, normalised: !1 },
  sint32x3: { size: 3, stride: 12, normalised: !1 },
  sint32x4: { size: 4, stride: 16, normalised: !1 }
};
function kc(n) {
  var e;
  return (e = hk[n]) != null ? e : hk.float32;
}
const wq = {
  f32: "float32",
  "vec2<f32>": "float32x2",
  "vec3<f32>": "float32x3",
  "vec4<f32>": "float32x4",
  vec2f: "float32x2",
  vec3f: "float32x3",
  vec4f: "float32x4",
  i32: "sint32",
  "vec2<i32>": "sint32x2",
  "vec3<i32>": "sint32x3",
  "vec4<i32>": "sint32x4",
  vec2i: "sint32x2",
  vec3i: "sint32x3",
  vec4i: "sint32x4",
  u32: "uint32",
  "vec2<u32>": "uint32x2",
  "vec3<u32>": "uint32x3",
  "vec4<u32>": "uint32x4",
  vec2u: "uint32x2",
  vec3u: "uint32x3",
  vec4u: "uint32x4",
  bool: "uint32",
  "vec2<bool>": "uint32x2",
  "vec3<bool>": "uint32x3",
  "vec4<bool>": "uint32x4"
}, pk = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|\)|$)/g;
function fk(n, e) {
  var i;
  let t;
  for (; (t = pk.exec(n)) !== null; ) {
    const s = (i = wq[t[3]]) != null ? i : "float32";
    e[t[2]] = {
      location: parseInt(t[1], 10),
      format: s,
      stride: kc(s).stride,
      offset: 0,
      instance: !1,
      start: 0
    };
  }
  pk.lastIndex = 0;
}
function kq(n) {
  return n.replace(/\/\/.*$/gm, "").replace(/\/\*[\s\S]*?\*\//g, "");
}
function _q({ source: n, entryPoint: e }) {
  const t = {}, i = kq(n), s = i.indexOf(`fn ${e}(`);
  if (s === -1)
    return t;
  const o = i.indexOf("->", s);
  if (o === -1)
    return t;
  const r = i.substring(s, o);
  if (fk(r, t), Object.keys(t).length === 0) {
    const a = r.match(/\(\s*\w+\s*:\s*(\w+)/);
    if (a) {
      const l = a[1], d = new RegExp(`struct\\s+${l}\\s*\\{([^}]+)\\}`, "s"), c = i.match(d);
      c && fk(c[1], t);
    }
  }
  return t;
}
function ag(n) {
  var u, p, f;
  const e = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g, t = /@group\((\d+)\)/, i = /@binding\((\d+)\)/, s = /var(<[^>]+>)? (\w+)/, o = /:\s*([\w<>]+)/, r = /struct\s+(\w+)\s*{([^}]+)}/g, a = /(\w+)\s*:\s*([\w\<\>]+)/g, l = /struct\s+(\w+)/, d = (u = n.match(e)) == null ? void 0 : u.map((y) => {
    var S;
    const b = y.match(s), w = (S = b == null ? void 0 : b[1]) != null ? S : "";
    let k;
    return w === "<uniform>" ? k = "uniform" : w.startsWith("<storage") && (k = "storage"), {
      group: parseInt(y.match(t)[1], 10),
      binding: parseInt(y.match(i)[1], 10),
      name: b[2],
      accessMode: k,
      type: y.match(o)[1]
    };
  });
  if (!d)
    return {
      groups: [],
      structs: []
    };
  const c = (f = (p = n.match(r)) == null ? void 0 : p.map((y) => {
    const b = y.match(l)[1], w = y.match(a).reduce((k, S) => {
      const [_, x] = S.split(":");
      return k[_.trim()] = x.trim(), k;
    }, {});
    return w ? { name: b, members: w } : null;
  }).filter(({ name: y }) => d.some(
    (b) => (
      // Handle both direct type matches and generic types like array<StructName>
      b.type === y || b.type.includes(`<${y}>`)
    )
  ))) != null ? f : [];
  return {
    groups: d,
    structs: c
  };
}
var ln = /* @__PURE__ */ ((n) => (n[n.VERTEX = 1] = "VERTEX", n[n.FRAGMENT = 2] = "FRAGMENT", n[n.COMPUTE = 4] = "COMPUTE", n))(ln || {});
function $u(n) {
  return n.endsWith("<u32>") ? "uint" : n.endsWith("<i32>") ? "sint" : "float";
}
function Sq({ groups: n }) {
  const e = [];
  for (let t = 0; t < n.length; t++) {
    const i = n[t];
    e[i.group] || (e[i.group] = []), i.accessMode === "uniform" ? e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      buffer: {
        type: "uniform"
      }
    }) : i.accessMode === "storage" ? e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      buffer: {
        type: "read-only-storage"
      }
    }) : i.type === "sampler" ? e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      sampler: {
        type: "filtering"
      }
    }) : i.type === "sampler_comparison" ? e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      sampler: {
        type: "comparison"
      }
    }) : i.type === "texture_2d" || i.type.startsWith("texture_2d<") ? e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      texture: {
        sampleType: $u(i.type),
        viewDimension: "2d",
        multisampled: !1
      }
    }) : i.type === "texture_depth_2d" ? e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      texture: {
        sampleType: "depth",
        viewDimension: "2d",
        multisampled: !1
      }
    }) : i.type === "texture_depth_2d_array" ? e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      texture: {
        sampleType: "depth",
        viewDimension: "2d-array",
        multisampled: !1
      }
    }) : i.type === "texture_2d_array" || i.type.startsWith("texture_2d_array<") ? e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      texture: {
        sampleType: $u(i.type),
        viewDimension: "2d-array",
        multisampled: !1
      }
    }) : i.type === "texture_3d" || i.type.startsWith("texture_3d<") ? e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      texture: {
        sampleType: $u(i.type),
        viewDimension: "3d",
        multisampled: !1
      }
    }) : (i.type === "texture_cube" || i.type.startsWith("texture_cube<")) && e[i.group].push({
      binding: i.binding,
      visibility: ln.VERTEX | ln.FRAGMENT,
      texture: {
        sampleType: $u(i.type),
        viewDimension: "cube",
        multisampled: !1
      }
    });
  }
  for (let t = 0; t < e.length; t++)
    e[t] || (e[t] = []);
  return e;
}
function Tq({ groups: n }) {
  const e = [];
  for (let t = 0; t < n.length; t++) {
    const i = n[t];
    e[i.group] || (e[i.group] = {}), e[i.group][i.name] = i.binding;
  }
  return e;
}
function Mq(n, e) {
  const t = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), s = [...n.structs, ...e.structs].filter((r) => t.has(r.name) ? !1 : (t.add(r.name), !0)), o = [...n.groups, ...e.groups].filter((r) => {
    const a = `${r.name}-${r.binding}`;
    return i.has(a) ? !1 : (i.add(a), !0);
  });
  return { structs: s, groups: o };
}
const Ql = /* @__PURE__ */ Object.create(null);
class na {
  /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */
  constructor(e) {
    var a, l;
    this._layoutKey = 0, this._attributeLocationsKey = 0;
    const { fragment: t, vertex: i, layout: s, gpuLayout: o, name: r } = e;
    if (this.name = r, this.fragment = t, this.vertex = i, t.source === i.source) {
      const d = ag(t.source);
      this.structsAndGroups = d;
    } else {
      const d = ag(i.source), c = ag(t.source);
      this.structsAndGroups = Mq(d, c);
    }
    this.layout = s != null ? s : Tq(this.structsAndGroups), this.gpuLayout = o != null ? o : Sq(this.structsAndGroups), this.autoAssignGlobalUniforms = ((a = this.layout[0]) == null ? void 0 : a.globalUniforms) !== void 0, this.autoAssignLocalUniforms = ((l = this.layout[1]) == null ? void 0 : l.localUniforms) !== void 0, this._generateProgramKey();
  }
  // TODO maker this pure
  _generateProgramKey() {
    const { vertex: e, fragment: t } = this, i = e.source + t.source + e.entryPoint + t.entryPoint;
    this._layoutKey = vl(i, "program");
  }
  get attributeData() {
    var e;
    return (e = this._attributeData) != null || (this._attributeData = _q(this.vertex)), this._attributeData;
  }
  /** destroys the program */
  destroy() {
    this.gpuLayout = null, this.layout = null, this.structsAndGroups = null, this.fragment = null, this.vertex = null, Ql[this._cacheKey] = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(e) {
    const t = `${e.vertex.source}:${e.fragment.source}:${e.fragment.entryPoint}:${e.vertex.entryPoint}`;
    return Ql[t] || (Ql[t] = new na(e), Ql[t]._cacheKey = t), Ql[t];
  }
}
const iS = [
  "f32",
  "i32",
  "u32",
  "vec2<f32>",
  "vec3<f32>",
  "vec4<f32>",
  "mat2x2<f32>",
  "mat3x3<f32>",
  "mat4x4<f32>",
  "mat3x2<f32>",
  "mat4x2<f32>",
  "mat2x3<f32>",
  "mat4x3<f32>",
  "mat2x4<f32>",
  "mat3x4<f32>",
  "vec2<i32>",
  "vec3<i32>",
  "vec4<i32>",
  "vec2<u32>",
  "vec3<u32>",
  "vec4<u32>"
], Cq = iS.reduce((n, e) => (n[e] = !0, n), {});
function Iq(n, e) {
  switch (n) {
    case "f32":
      return 0;
    case "vec2<f32>":
      return new Float32Array(2 * e);
    case "vec3<f32>":
      return new Float32Array(3 * e);
    case "vec4<f32>":
      return new Float32Array(4 * e);
    case "mat2x2<f32>":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3x3<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4x4<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
const sS = class oS extends di {
  /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */
  constructor(e, t) {
    var s, o;
    super(), this.uid = Lt("uniform"), this._resourceType = "uniformGroup", this._resourceId = Lt("resource"), this.isUniformGroup = !0, this._dirtyId = 0, this.destroyed = !1, t = { ...oS.defaultOptions, ...t }, this.uniformStructures = e;
    const i = {};
    for (const r in e) {
      const a = e[r];
      if (a.name = r, a.size = (s = a.size) != null ? s : 1, !Cq[a.type]) {
        const l = a.type.match(/^array<(\w+(?:<\w+>)?),\s*(\d+)>$/);
        if (l) {
          const [, d, c] = l;
          throw new Error(
            `Uniform type ${a.type} is not supported. Use type: '${d}', size: ${c} instead.`
          );
        }
        throw new Error(`Uniform type ${a.type} is not supported. Supported uniform types are: ${iS.join(", ")}`);
      }
      (o = a.value) != null || (a.value = Iq(a.type, a.size)), i[r] = a.value;
    }
    this.uniforms = i, this._dirtyId = 1, this.ubo = t.ubo, this.isStatic = t.isStatic, this._signature = vl(Object.keys(i).map(
      (r) => `${r}-${e[r].type}`
    ).join("-"), "uniform-group");
  }
  /**
   * an underlying buffer that will be uploaded to the GPU when using this UniformGroup.
   * It is created lazily by the renderer's ubo system on first use.
   */
  get buffer() {
    return this._buffer;
  }
  set buffer(e) {
    var t;
    this._buffer !== e && ((t = this._buffer) == null || t.off("change", this.onBufferChange, this), this._buffer = e, e == null || e.on("change", this.onBufferChange, this));
  }
  /**
   * The GC tracks this group's underlying buffer, not the group itself — a GC stamp on the
   * group (see BindGroup._touch) must land on the buffer, or the GC collects it while
   * cached bind groups still reference it.
   * @internal
   */
  get _gcLastUsed() {
    var e, t;
    return (t = (e = this._buffer) == null ? void 0 : e._gcLastUsed) != null ? t : -1;
  }
  set _gcLastUsed(e) {
    this._buffer && (this._buffer._gcLastUsed = e);
  }
  /**
   * Bind group keys are built from this group's _resourceId, not the buffer's — so when the
   * buffer re-keys (it resized, or the GC unloaded its GPU copy), this group must re-key too,
   * or cached GPUBindGroups keep referencing the destroyed GPU buffer.
   */
  onBufferChange() {
    this._resourceId = Lt("resource"), this.emit("change", this);
  }
  /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */
  update() {
    this._dirtyId++;
  }
};
sS.defaultOptions = {
  /** if true the UniformGroup is handled as an Uniform buffer object. */
  ubo: !1,
  /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */
  isStatic: !1
};
let ms = sS;
class Eo {
  /**
   * Create a new instance of the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */
  constructor(e) {
    this.resources = /* @__PURE__ */ Object.create(null), this._resourceKeysValue = null, this._dirty = !0;
    let t = 0;
    for (const i in e) {
      const s = e[i];
      this.setResource(s, t++);
    }
  }
  /**
   * The binding numbers in use in {@link BindGroup#resources}, ascending. Binding numbers can
   * have gaps, so per-draw loops index this list instead of running `for...in` over
   * `resources`, which builds a fresh key list on every call for integer keys.
   * @internal
   */
  get _resourceKeys() {
    var e;
    return (e = this._resourceKeysValue) != null || (this._resourceKeysValue = Object.keys(this.resources).map(Number)), this._resourceKeysValue;
  }
  /**
   * A key used internally to match it up to a WebGPU BindGroup.
   * Lazily rebuilt from resource IDs when dirty.
   * @internal
   */
  get _key() {
    if (this._dirty) {
      this._dirty = !1;
      const e = [];
      let t = 0;
      for (const i in this.resources)
        e[t++] = this.resources[i] ? this.resources[i]._resourceId : -1;
      this._keyValue = e.join("|");
    }
    return this._keyValue;
  }
  /**
   * Set a resource at a given index. This function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */
  setResource(e, t) {
    var s, o;
    const i = this.resources[t];
    e !== i && (i && ((s = i.off) == null || s.call(i, "change", this.onResourceChange, this)), (o = e.on) == null || o.call(e, "change", this.onResourceChange, this), i === void 0 && (this._resourceKeysValue = null), this.resources[t] = e, this._dirty = !0);
  }
  /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */
  getResource(e) {
    return this.resources[e];
  }
  /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param now - The current time in milliseconds.
   * @internal
   */
  _touch(e) {
    const t = this.resources, i = this._resourceKeys;
    for (let s = 0; s < i.length; s++) {
      const o = t[i[s]];
      o && (o._gcLastUsed = e);
    }
  }
  /** Destroys this bind group and removes all listeners. */
  destroy() {
    var t;
    const e = this.resources;
    for (const i in e) {
      const s = e[i];
      (t = s == null ? void 0 : s.off) == null || t.call(s, "change", this.onResourceChange, this);
    }
    this.resources = null, this._resourceKeysValue = null;
  }
  onResourceChange(e) {
    if (this._dirty = !0, e.destroyed) {
      const t = this.resources;
      for (const i in t)
        t[i] === e && (t[i] = null);
      at(`[BindGroup] a '${e._resourceType}' was destroyed while still bound to a shader. Remove it from the shader before destroying it.`);
    }
  }
}
var Vi = /* @__PURE__ */ ((n) => (n[n.WEBGL = 1] = "WEBGL", n[n.WEBGPU = 2] = "WEBGPU", n[n.CANVAS = 4] = "CANVAS", n[n.BOTH = 3] = "BOTH", n))(Vi || {});
class _c {
  /**
   * @param data - A dictionary of constants to set on the shader.
   * Keys should match the constant names in the WGSL shader.
   */
  constructor(e) {
    this.data = { ...e };
    const t = Object.keys(e).sort().map((i) => `${i}:${e[i]}`).join("|");
    this.id = vl(t, "shader-overrides");
  }
  /**
   * Creates a ShaderOverrides instance from a plain object or existing instance.
   * @param overrides - The overrides to convert.
   * @returns A ShaderOverrides instance.
   */
  static from(e) {
    return e instanceof _c ? e : new _c(e);
  }
}
class Js extends di {
  constructor(e) {
    super(), this.uid = Lt("shader"), this._uniformBindMap = /* @__PURE__ */ Object.create(null), this._ownedBindGroups = [], this._destroyed = !1;
    let {
      gpuProgram: t,
      glProgram: i,
      groups: s,
      resources: o,
      compatibleRenderers: r,
      groupMap: a,
      overrides: l
    } = e;
    this._overrides = l ? _c.from(l) : null, this.gpuProgram = t, this.glProgram = i, r === void 0 && (r = 0, t && (r |= Vi.WEBGPU), i && (r |= Vi.WEBGL)), this.compatibleRenderers = r;
    const d = {};
    if (a)
      for (const c in a)
        for (const u in a[c]) {
          const p = a[c][u];
          d[p] = {
            group: c,
            binding: u,
            name: p
          };
        }
    if (!o && !s && (o = {}), o && s)
      throw new Error("[Shader] Cannot have both resources and groups");
    if (!t && s && !a)
      throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
    if (t && s && !a) {
      const c = t.structsAndGroups.groups;
      a = {}, c.forEach((u) => {
        a[u.group] = a[u.group] || {}, a[u.group][u.binding] = u.name, d[u.name] = u;
      });
    } else if (o) {
      s = {}, a || (a = {}), t && t.structsAndGroups.groups.forEach((p) => {
        a[p.group] = a[p.group] || {}, a[p.group][p.binding] = p.name, d[p.name] = p;
      });
      let c = 0;
      for (const u in o)
        d[u] || (t && !i && at(`[Shader] the resource '${u}' matches no binding in the WGSL source — is the name correct?`), s[99] || (s[99] = new Eo(), this._ownedBindGroups.push(s[99])), d[u] = { group: 99, binding: c, name: u }, a[99] = a[99] || {}, a[99][c] = u, c++);
      for (const u in o) {
        const p = u;
        let f = o[u];
        !f.source && !f._resourceType && (f = new ms(f));
        const y = d[p];
        y && (s[y.group] || (s[y.group] = new Eo(), this._ownedBindGroups.push(s[y.group])), s[y.group].setResource(f, y.binding));
      }
    }
    this.groups = s, this._uniformBindMap = a, this.resources = this._buildResourceAccessor(s, d);
  }
  /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */
  addResource(e, t, i) {
    var s, o;
    (s = this._uniformBindMap)[t] || (s[t] = {}), (o = this._uniformBindMap[t])[i] || (o[i] = e), this.groups[t] || (this.groups[t] = new Eo(), this._ownedBindGroups.push(this.groups[t]));
  }
  _buildResourceAccessor(e, t) {
    const i = {};
    for (const s in t) {
      const o = t[s];
      Object.defineProperty(i, o.name, {
        get() {
          return e[o.group].getResource(o.binding);
        },
        set(r) {
          e[o.group].setResource(r, o.binding);
        }
      });
    }
    return i;
  }
  /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */
  destroy(e = !1) {
    var t, i;
    this._destroyed || (this._destroyed = !0, this.emit("destroy", this), e && ((t = this.gpuProgram) == null || t.destroy(), (i = this.glProgram) == null || i.destroy()), this.gpuProgram = null, this.glProgram = null, this.removeAllListeners(), this._uniformBindMap = null, this._ownedBindGroups.forEach((s) => {
      s.destroy();
    }), this._ownedBindGroups = null, this.resources = null, this.groups = null, this._overrides = null);
  }
  static from(e) {
    const { gpu: t, gl: i, ...s } = e;
    let o, r;
    return t && (o = na.from(t)), i && (r = $l.from(i)), new Js({
      gpuProgram: o,
      glProgram: r,
      ...s
    });
  }
}
const Aq = {
  normal: 0,
  add: 1,
  multiply: 2,
  screen: 3,
  overlay: 4,
  erase: 5,
  "normal-npm": 6,
  "add-npm": 7,
  "screen-npm": 8,
  min: 9,
  max: 10
}, rS = {
  BLEND: 0,
  OFFSET: 1,
  CULLING: 2,
  DEPTH_TEST: 3,
  WINDING: 4,
  DEPTH_MASK: 5
}, { BLEND: lg, OFFSET: dg, CULLING: cg, DEPTH_TEST: ug, WINDING: hg, DEPTH_MASK: pg } = rS, kv = class aS {
  constructor() {
    this.data = 0, this.blendMode = "normal", this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
  }
  /**
   * Activates blending of the computed fragment color values.
   * @default true
   */
  get blend() {
    return !!(this.data & 1 << lg);
  }
  set blend(e) {
    !!(this.data & 1 << lg) !== e && (this.data ^= 1 << lg);
  }
  /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */
  get offsets() {
    return !!(this.data & 1 << dg);
  }
  set offsets(e) {
    !!(this.data & 1 << dg) !== e && (this.data ^= 1 << dg);
  }
  /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */
  set cullMode(e) {
    if (e === "none") {
      this.culling = !1;
      return;
    }
    this.culling = !0, this.clockwiseFrontFace = e === "front";
  }
  get cullMode() {
    return this.culling ? this.clockwiseFrontFace ? "front" : "back" : "none";
  }
  /**
   * Activates culling of polygons.
   * @default false
   */
  get culling() {
    return !!(this.data & 1 << cg);
  }
  set culling(e) {
    !!(this.data & 1 << cg) !== e && (this.data ^= 1 << cg);
  }
  /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */
  get depthTest() {
    return !!(this.data & 1 << ug);
  }
  set depthTest(e) {
    !!(this.data & 1 << ug) !== e && (this.data ^= 1 << ug);
  }
  /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */
  get depthMask() {
    return !!(this.data & 1 << pg);
  }
  set depthMask(e) {
    !!(this.data & 1 << pg) !== e && (this.data ^= 1 << pg);
  }
  /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */
  get clockwiseFrontFace() {
    return !!(this.data & 1 << hg);
  }
  set clockwiseFrontFace(e) {
    !!(this.data & 1 << hg) !== e && (this.data ^= 1 << hg);
  }
  /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */
  get blendMode() {
    return this._blendMode;
  }
  set blendMode(e) {
    this.blend = e !== "none", this._blendMode = e, this._blendModeId = Aq[e] || 0;
  }
  /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */
  get polygonOffset() {
    return this._polygonOffset;
  }
  set polygonOffset(e) {
    this.offsets = !!e, this._polygonOffset = e;
  }
  toString() {
    return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
  }
  /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */
  static for2d() {
    const e = new aS();
    return e.depthTest = !1, e.depthMask = !1, e.blend = !0, e;
  }
};
kv.default2d = kv.for2d();
let Zs = kv;
const lS = class _v extends Js {
  /**
   * @param options - The optional parameters of this filter.
   */
  constructor(e) {
    e = { ..._v.defaultOptions, ...e }, super(e), this.enabled = !0, this._state = Zs.for2d(), this.blendMode = e.blendMode, this.padding = e.padding, typeof e.antialias == "boolean" ? this.antialias = e.antialias ? "on" : "off" : this.antialias = e.antialias, this.resolution = e.resolution, this.blendRequired = e.blendRequired, this.clipToViewport = e.clipToViewport, this.addResource("uTexture", 0, 1), e.blendRequired && this.addResource("uBackTexture", 0, 3);
  }
  /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */
  apply(e, t, i, s) {
    e.applyFilter(this, t, i, s);
  }
  /**
   * Get the blend mode of the filter.
   * @default "normal"
   */
  get blendMode() {
    return this._state.blendMode;
  }
  /** Sets the blend mode of the filter. */
  set blendMode(e) {
    this._state.blendMode = e;
  }
  /**
   * A short hand function to create a filter based of a vertex and fragment shader src.
   * @param options
   * @returns A shiny new PixiJS filter!
   */
  static from(e) {
    const { gpu: t, gl: i, ...s } = e;
    let o, r;
    return t && (o = na.from(t)), i && (r = $l.from(i)), new _v({
      gpuProgram: o,
      glProgram: r,
      ...s
    });
  }
};
lS.defaultOptions = {
  blendMode: "normal",
  resolution: 1,
  padding: 0,
  antialias: "off",
  blendRequired: !1,
  clipToViewport: !0
};
let dS = lS;
const Sv = [];
ct.handleByNamedList(Ae.Environment, Sv);
async function Pq(n) {
  if (!n)
    for (let e = 0; e < Sv.length; e++) {
      const t = Sv[e];
      if (t.value.test()) {
        await t.value.load();
        return;
      }
    }
}
let ed;
function cS() {
  if (typeof ed == "boolean")
    return ed;
  try {
    ed = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({ a: "b" }, "a", "b") === !0;
  } catch {
    ed = !1;
  }
  return ed;
}
const Sc = /* @__PURE__ */ new Set();
let Tv = !1;
function mk(n, e, t = 2) {
  const i = e && e.length, s = i ? e[0] * t : n.length;
  Sc.size && Sc.clear();
  let o = uS(n, 0, s, t, !0);
  const r = [];
  if (!o || o.next === o.prev) return r;
  let a = 0, l = 0, d = 0;
  if (i && (o = Dq(n, e, o, t)), n.length > 80 * t) {
    a = n[0], l = n[1];
    let c = a, u = l;
    for (let p = t; p < s; p += t) {
      const f = n[p], y = n[p + 1];
      f < a && (a = f), y < l && (l = y), f > c && (c = f), y > u && (u = y);
    }
    d = Math.max(c - a, u - l), d = d !== 0 ? 32767 / d : 0;
  }
  return Mv(o, r, a, l, d), r;
}
function uS(n, e, t, i, s) {
  let o = null;
  if (s === Kq(n, e, t, i) > 0)
    for (let r = e; r < t; r += i) o = vk(r / i | 0, n[r], n[r + 1], o);
  else
    for (let r = t - i; r >= e; r -= i) o = vk(r / i | 0, n[r], n[r + 1], o);
  return o && Tc(o, o.next) && (Cc(o), o = o.next), o;
}
function Zr(n, e = n) {
  const t = e === n;
  let i = n, s;
  do
    s = !1, i !== i.next && (Sc.size === 0 || !Sc.has(i)) && (Tc(i, i.next) || gn(i.prev, i, i.next) === 0) ? ((t || i === e) && (e = i.prev), Tv = !0, Cc(i), i = i.prev, s = !0) : (t || i !== e) && (i = i.next, s = !t);
  while (s || i !== e);
  return e;
}
function Mv(n, e, t, i, s) {
  s && Gq(n, t, i, s);
  let o = n, r = !1;
  for (; n.prev !== n.next; ) {
    const a = n.prev, l = n.next;
    if (gn(a, n, l) < 0 && (s ? Rq(n, t, i, s) : Eq(n))) {
      e.push(a.i, n.i, l.i), Cc(n), n = l, o = l;
      continue;
    }
    if (n = l, n === o) {
      if (Tv = !1, n = Zr(n), Tv) {
        o = n;
        continue;
      }
      if (!r) {
        n = zq(n, e), o = n, r = !0;
        continue;
      }
      $q(n, e, t, i, s);
      break;
    }
  }
}
function Eq(n) {
  const e = n.prev, t = n, i = n.next, s = e.x, o = t.x, r = i.x, a = e.y, l = t.y, d = i.y, c = Math.min(s, o, r), u = Math.min(a, l, d), p = Math.max(s, o, r), f = Math.max(a, l, d);
  let y = i.next;
  for (; y !== e; ) {
    if (y.x >= c && y.x <= p && y.y >= u && y.y <= f && !(s === y.x && a === y.y) && Gp(s, a, o, l, r, d, y.x, y.y) && gn(y.prev, y, y.next) >= 0) return !1;
    y = y.next;
  }
  return !0;
}
function Rq(n, e, t, i) {
  const s = n.prev, o = n, r = n.next, a = s.x, l = o.x, d = r.x, c = s.y, u = o.y, p = r.y, f = Math.min(a, l, d), y = Math.min(c, u, p), b = Math.max(a, l, d), w = Math.max(c, u, p), k = Pv(f, y, e, t, i), S = Pv(b, w, e, t, i);
  let _ = n.prevZ;
  for (; _ && _.z >= k; ) {
    if (_.x >= f && _.x <= b && _.y >= y && _.y <= w && _ !== r && !(a === _.x && c === _.y) && Gp(a, c, l, u, d, p, _.x, _.y) && gn(_.prev, _, _.next) >= 0) return !1;
    _ = _.prevZ;
  }
  let x = n.nextZ;
  for (; x && x.z <= S; ) {
    if (x.x >= f && x.x <= b && x.y >= y && x.y <= w && x !== r && !(a === x.x && c === x.y) && Gp(a, c, l, u, d, p, x.x, x.y) && gn(x.prev, x, x.next) >= 0) return !1;
    x = x.nextZ;
  }
  return !0;
}
function zq(n, e) {
  let t = n, i = !1;
  do {
    const s = t.prev, o = t.next.next;
    fS(s, t, t.next, o, !1) && Mc(s, o) && Mc(o, s) && (e.push(s.i, t.i, o.i), Cc(t), Cc(t.next), t = n = o, i = !0), t = t.next;
  } while (t !== n);
  return i ? Zr(t) : t;
}
function $q(n, e, t, i, s) {
  let o = n;
  do {
    let r = o.next.next;
    for (; r !== o.prev; ) {
      if (o.i !== r.i && Vq(o, r)) {
        let a = mS(o, r);
        o = Zr(o, o.next), a = Zr(a, a.next), Mv(o, e, t, i, s), Mv(a, e, t, i, s);
        return;
      }
      r = r.next;
    }
    o = o.next;
  } while (o !== n);
}
let Cv = !1;
function Dq(n, e, t, i) {
  const s = [];
  for (let o = 0, r = e.length; o < r; o++) {
    const a = e[o] * i, l = o < r - 1 ? e[o + 1] * i : n.length, d = (
      /** @type {Node} */
      uS(n, a, l, i, !1)
    );
    d === d.next && Sc.add(d), s.push(Hq(d));
  }
  s.sort(Oq), Bq(n.length / i, e.length), pS(t, t), Cv = !0;
  for (let o = 0; o < s.length; o++)
    t = Lq(s[o], t);
  return Cv = !1, Zr(t);
}
function Oq(n, e) {
  return n.x - e.x || n.y - e.y || (n.next.y - n.y) / (n.next.x - n.x) - (e.next.y - e.y) / (e.next.x - e.x);
}
function Lq(n, e) {
  const t = Nq(n, e);
  if (!t)
    return e;
  const i = mS(t, n), s = i.next;
  return pS(t, s.next), Zr(i, i.next), Zr(t, t.next);
}
const hS = 16;
let rn = new Float64Array(0), Up = 0;
const Iv = [], Av = [];
function Bq(n, e) {
  const t = Math.ceil((n + 2 * e) / hS) + e + 2;
  rn.length < t * 4 && (rn = new Float64Array(t * 4)), Up = 0;
}
function pS(n, e) {
  let t = n;
  do {
    const i = Up++;
    Iv[i] = t;
    let s = t.x, o = t.y, r = t.x, a = t.y, l = 0;
    do {
      const c = t.next;
      t.z = i, c.x < s && (s = c.x), c.x > r && (r = c.x), c.y < o && (o = c.y), c.y > a && (a = c.y), t = c;
    } while (++l < hS && t !== e);
    Av[i] = t;
    const d = i * 4;
    rn[d] = s, rn[d + 1] = o, rn[d + 2] = r, rn[d + 3] = a;
  } while (t !== e);
}
function Fq(n, e) {
  const t = n.z * 4;
  e.x < rn[t] && (rn[t] = e.x), e.y < rn[t + 1] && (rn[t + 1] = e.y), e.x > rn[t + 2] && (rn[t + 2] = e.x), e.y > rn[t + 3] && (rn[t + 3] = e.y);
}
function gk(n) {
  let e = Av[n];
  for (; e.prev.next !== e; ) e = e.next;
  return Av[n] = e, e;
}
function bk(n) {
  let e = Iv[n];
  for (; e.prev.next !== e; ) e = e.next;
  return Iv[n] = e, e;
}
function Nq(n, e) {
  let t = e;
  const i = n.x, s = n.y;
  let o = -1 / 0, r;
  if (Tc(n, t)) return t;
  for (let p = 0, f = 0; p < Up; p++, f += 4) {
    if (s < rn[f + 1] || s > rn[f + 3] || rn[f] > i || rn[f + 2] <= o) continue;
    const y = gk(p);
    t = bk(p);
    do {
      if (t.prev.next === t) {
        if (Tc(n, t.next)) return t.next;
        if (s <= t.y && s >= t.next.y && t.next.y !== t.y) {
          const b = t.x + (s - t.y) * (t.next.x - t.x) / (t.next.y - t.y);
          if (b <= i && b > o && (o = b, r = t.x < t.next.x ? t : t.next, b === i))
            return r;
        }
      }
      t = t.next;
    } while (t !== y);
  }
  if (!r) return null;
  const a = r.x, l = r.y, d = Math.min(s, l), c = Math.max(s, l);
  let u = 1 / 0;
  for (let p = 0, f = 0; p < Up; p++, f += 4) {
    if (rn[f + 2] < a || rn[f] > i || rn[f + 3] < d || rn[f + 1] > c) continue;
    const y = gk(p);
    t = bk(p);
    do {
      if (t.prev.next === t && i >= t.x && t.x >= a && i !== t.x && // skip dead nodes
      Gp(s < l ? i : o, s, a, l, s < l ? o : i, s, t.x, t.y)) {
        const b = Math.abs(s - t.y) / (i - t.x);
        (Mc(t, n) || t.y === s && t.next.y === s && t.next.x > i) && (b < u || b === u && (t.x > r.x || t.x === r.x && Uq(r, t))) && (r = t, u = b);
      }
      t = t.next;
    } while (t !== y);
  }
  return r;
}
function Uq(n, e) {
  return gn(n.prev, n, e.prev) < 0 && gn(e.next, n, n.next) < 0;
}
const bi = [];
let Da = [], or = new Uint32Array(0), td = new Uint32Array(0);
const nd = new Uint32Array(256);
function Gq(n, e, t, i) {
  let s = n, o = 0;
  do
    s.z = Pv(s.x, s.y, e, t, i), bi[o++] = s, s = s.next;
  while (s !== n);
  jq(o);
  let r = null;
  for (let a = 0; a < o; a++) {
    const l = bi[a];
    l.prevZ = r, r && (r.nextZ = l), r = l;
  }
  r.nextZ = null, bi.fill(
    /** @type {Node} */
    /** @type {unknown} */
    null,
    0,
    o
  ), Da.fill(
    /** @type {Node} */
    /** @type {unknown} */
    null,
    0,
    o
  );
}
function jq(n) {
  if (n <= 32) {
    for (let e = 1; e < n; e++) {
      const t = bi[e], i = t.z;
      let s = e - 1;
      for (; s >= 0 && bi[s].z > i; )
        bi[s + 1] = bi[s], s--;
      bi[s + 1] = t;
    }
    return;
  }
  or.length < n && (or = new Uint32Array(n), td = new Uint32Array(n), Da = new Array(n));
  for (let e = 0; e < n; e++) or[e] = bi[e].z;
  Du(n, bi, or, Da, td, 0), Du(n, Da, td, bi, or, 8), Du(n, bi, or, Da, td, 16), Du(n, Da, td, bi, or, 24);
}
function Du(n, e, t, i, s, o) {
  nd.fill(0);
  for (let a = 0; a < n; a++) nd[t[a] >>> o & 255]++;
  let r = 0;
  for (let a = 0; a < 256; a++) {
    const l = nd[a];
    nd[a] = r, r += l;
  }
  for (let a = 0; a < n; a++) {
    const l = t[a], d = nd[l >>> o & 255]++;
    i[d] = e[a], s[d] = l;
  }
}
function Pv(n, e, t, i, s) {
  return n = (n - t) * s | 0, e = (e - i) * s | 0, n = (n | n << 8) & 16711935, n = (n | n << 4) & 252645135, n = (n | n << 2) & 858993459, n = (n | n << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, n | e << 1;
}
function Hq(n) {
  let e = n, t = n;
  do
    (e.x < t.x || e.x === t.x && e.y < t.y) && (t = e), e = e.next;
  while (e !== n);
  return t;
}
function Gp(n, e, t, i, s, o, r, a) {
  return (s - r) * (e - a) >= (n - r) * (o - a) && (n - r) * (i - a) >= (t - r) * (e - a) && (t - r) * (o - a) >= (s - r) * (i - a);
}
function Vq(n, e) {
  const t = Tc(n, e) && gn(n.prev, n, n.next) > 0 && gn(e.prev, e, e.next) > 0;
  return n.next.i !== e.i && (t || Mc(n, e) && Mc(e, n) && // // locally visible
  (gn(n.prev, n, e.prev) !== 0 || gn(n, e.prev, e) !== 0)) && // no opposite-facing sectors
  !Wq(n, e) && (t || qq(n, e));
}
function gn(n, e, t) {
  return (e.y - n.y) * (t.x - e.x) - (e.x - n.x) * (t.y - e.y);
}
function Tc(n, e) {
  return n.x === e.x && n.y === e.y;
}
function fS(n, e, t, i, s = !0) {
  const o = gn(n, e, t), r = gn(n, e, i), a = gn(t, i, n), l = gn(t, i, e);
  return (o > 0 && r < 0 || o < 0 && r > 0) && (a > 0 && l < 0 || a < 0 && l > 0) ? !0 : s ? !!(o === 0 && Ou(n, t, e) || r === 0 && Ou(n, i, e) || a === 0 && Ou(t, n, i) || l === 0 && Ou(t, e, i)) : !1;
}
function Ou(n, e, t) {
  return e.x <= Math.max(n.x, t.x) && e.x >= Math.min(n.x, t.x) && e.y <= Math.max(n.y, t.y) && e.y >= Math.min(n.y, t.y);
}
function Wq(n, e) {
  const t = Math.min(n.x, e.x), i = Math.max(n.x, e.x), s = Math.min(n.y, e.y), o = Math.max(n.y, e.y);
  let r = n;
  do {
    const a = r.next;
    if (r.x > i && a.x > i || r.x < t && a.x < t || r.y > o && a.y > o || r.y < s && a.y < s) {
      r = a;
      continue;
    }
    if (r.i !== n.i && a.i !== n.i && r.i !== e.i && a.i !== e.i && fS(r, a, n, e)) return !0;
    r = a;
  } while (r !== n);
  return !1;
}
function Mc(n, e) {
  return gn(n.prev, n, n.next) < 0 ? gn(n, e, n.next) >= 0 && gn(n, n.prev, e) >= 0 : gn(n, e, n.prev) < 0 || gn(n, n.next, e) < 0;
}
function qq(n, e) {
  let t = n, i = !1;
  const s = (n.x + e.x) / 2, o = (n.y + e.y) / 2;
  do {
    const r = t.next;
    t.y > o != r.y > o && s < (r.x - t.x) * (o - t.y) / (r.y - t.y) + t.x && (i = !i), t = r;
  } while (t !== n);
  return i;
}
function mS(n, e) {
  const t = Ev(n.i, n.x, n.y), i = Ev(e.i, e.x, e.y), s = n.next, o = e.prev;
  return n.next = e, e.prev = n, t.next = s, s.prev = t, i.next = t, t.prev = i, o.next = i, i.prev = o, i;
}
function vk(n, e, t, i) {
  const s = Ev(n, e, t);
  return i ? (s.next = i.next, s.prev = i, i.next.prev = s, i.next = s) : (s.prev = s, s.next = s), s;
}
function Cc(n) {
  n.next.prev = n.prev, n.prev.next = n.next, n.prevZ && (n.prevZ.nextZ = n.nextZ), n.nextZ && (n.nextZ.prevZ = n.prevZ), Cv && Fq(n.prev, n.next);
}
function Ev(n, e, t) {
  return (
    /** @type {Node} */
    /** @type {unknown} */
    {
      i: n,
      // vertex index in coordinates array
      x: e,
      y: t,
      // vertex coordinates
      prev: null,
      // previous and next vertex nodes in a polygon ring
      next: null,
      z: 0,
      // z-order curve value; doubles as owning block in the hole-bridge index during eliminateHoles
      prevZ: null,
      // previous and next nodes in z-order
      nextZ: null
    }
  );
}
function Kq(n, e, t, i) {
  let s = 0;
  for (let o = e, r = t - i; o < t; o += i)
    s += (n[r] - n[o]) * (n[o + 1] + n[r + 1]), r = o;
  return s;
}
const Yq = mk.default || mk;
var wn = /* @__PURE__ */ ((n) => (n[n.NONE = 0] = "NONE", n[n.COLOR = 16384] = "COLOR", n[n.STENCIL = 1024] = "STENCIL", n[n.DEPTH = 256] = "DEPTH", n[n.COLOR_DEPTH = 16640] = "COLOR_DEPTH", n[n.COLOR_STENCIL = 17408] = "COLOR_STENCIL", n[n.DEPTH_STENCIL = 1280] = "DEPTH_STENCIL", n[n.ALL = 17664] = "ALL", n))(wn || {});
class gS {
  /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */
  constructor(e) {
    this.items = [], this._name = e;
  }
  /* jsdoc/check-param-names */
  /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */
  /* jsdoc/check-param-names */
  emit(e, t, i, s, o, r, a, l) {
    const { name: d, items: c } = this;
    for (let u = 0, p = c.length; u < p; u++)
      c[u][d](e, t, i, s, o, r, a, l);
    return this;
  }
  /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */
  add(e) {
    return e[this._name] && (this.remove(e), this.items.push(e)), this;
  }
  /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */
  remove(e) {
    const t = this.items.indexOf(e);
    return t !== -1 && this.items.splice(t, 1), this;
  }
  /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */
  contains(e) {
    return this.items.indexOf(e) !== -1;
  }
  /** Remove all listeners from the Runner */
  removeAll() {
    return this.items.length = 0, this;
  }
  /** Remove all references, don't use after this. */
  destroy() {
    this.removeAll(), this.items = null, this._name = null;
  }
  /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */
  get empty() {
    return this.items.length === 0;
  }
  /**
   * The name of the runner.
   * @readonly
   */
  get name() {
    return this._name;
  }
}
const Xq = [
  "init",
  "destroy",
  "contextChange",
  "resolutionChange",
  "resetState",
  "renderEnd",
  "renderStart",
  "render",
  "update",
  "postrender",
  "prerender"
], bS = class vS extends di {
  /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */
  constructor(e) {
    var i;
    super(), this.tick = 0, this.uid = Lt("renderer"), this.runners = /* @__PURE__ */ Object.create(null), this.renderPipes = /* @__PURE__ */ Object.create(null), this._initOptions = {}, this._systemsHash = /* @__PURE__ */ Object.create(null), this.type = e.type, this.name = e.name, this.config = e;
    const t = [...Xq, ...(i = this.config.runners) != null ? i : []];
    this._addRunners(...t), this._unsafeEvalCheck();
  }
  /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */
  async init(e = {}) {
    const t = e.skipExtensionImports === !0 ? !0 : e.manageImports === !1;
    await Pq(t), !t && this.config.loaders && await Promise.all(this.config.loaders.map((i) => i.value.load())), this._addSystems(this.config.systems), this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
    for (const i in this._systemsHash)
      e = { ...this._systemsHash[i].constructor.defaultOptions, ...e };
    e = { ...vS.defaultOptions, ...e }, this._roundPixels = e.roundPixels ? 1 : 0;
    for (let i = 0; i < this.runners.init.items.length; i++)
      await this.runners.init.items[i].init(e);
    this._initOptions = e;
  }
  render(e, t) {
    var s, o;
    this.tick++;
    let i = e;
    if (i instanceof un && (i = { container: i }, t && (rt(on, "passing a second argument is deprecated, please use render options instead"), i.target = t.renderTexture)), i.target || (i.target = this.view.renderTarget), i.target === this.view.renderTarget && (this._lastObjectRendered = i.container, (s = i.clearColor) != null || (i.clearColor = this.background.colorRgba), (o = i.clear) != null || (i.clear = this.background.clearBeforeRender)), i.clearColor) {
      const r = Array.isArray(i.clearColor) && i.clearColor.length === 4;
      i.clearColor = r ? i.clearColor : pn.shared.setValue(i.clearColor).toArray();
    }
    i.transform || (i.container.updateLocalTransform(), i.transform = i.container.localTransform), i.container.visible && (i.container.enableRenderGroup(), this.runners.prerender.emit(i), this.runners.renderStart.emit(i), this.runners.render.emit(i), this.runners.renderEnd.emit(i), this.runners.postrender.emit(i));
  }
  /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */
  resize(e, t, i) {
    const s = this.view.resolution;
    this.view.resize(e, t, i), this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution), i !== void 0 && i !== s && this.runners.resolutionChange.emit(i);
  }
  /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */
  clear(e = {}) {
    var l;
    const t = this;
    e.target || (e.target = t.renderTarget.renderTarget), e.clearColor || (e.clearColor = this.background.colorRgba), (l = e.clear) != null || (e.clear = wn.ALL);
    const { clear: i, clearColor: s, target: o, mipLevel: r, layer: a } = e;
    pn.shared.setValue(s != null ? s : this.background.colorRgba), t.renderTarget.clear(o, i, pn.shared.toArray(), r != null ? r : 0, a != null ? a : 0);
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.view.resolution;
  }
  set resolution(e) {
    this.view.resolution = e, this.runners.resolutionChange.emit(e);
  }
  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */
  get width() {
    return this.view.texture.frame.width;
  }
  /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */
  get height() {
    return this.view.texture.frame.height;
  }
  // NOTE: this was `view` in v7
  /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */
  get canvas() {
    return this.view.canvas;
  }
  /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */
  get lastObjectRendered() {
    return this._lastObjectRendered;
  }
  /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */
  get renderingToScreen() {
    return this.renderTarget.renderingToScreen;
  }
  /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */
  get screen() {
    return this.view.screen;
  }
  /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */
  _addRunners(...e) {
    e.forEach((t) => {
      this.runners[t] = new gS(t);
    });
  }
  _addSystems(e) {
    let t;
    for (t in e) {
      const i = e[t];
      this._addSystem(i.value, i.name);
    }
  }
  /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */
  _addSystem(e, t) {
    const i = new e(this);
    if (this[t])
      throw new Error(`Whoops! The name "${t}" is already in use`);
    this[t] = i, this._systemsHash[t] = i;
    for (const s in this.runners)
      this.runners[s].add(i);
    return this;
  }
  _addPipes(e, t) {
    const i = t.reduce((s, o) => (s[o.name] = o.value, s), {});
    e.forEach((s) => {
      const o = s.value, r = s.name, a = i[r];
      this.renderPipes[r] = new o(
        this,
        a ? new a() : null
      ), this.runners.destroy.add(this.renderPipes[r]);
    });
  }
  destroy(e = !1) {
    this.runners.destroy.items.reverse(), this.runners.destroy.emit(e), (e === !0 || typeof e == "object" && e.releaseGlobalResources) && zl.release(), Object.values(this.runners).forEach((t) => {
      t.destroy();
    }), this._systemsHash = null, this.renderPipes = null, this.removeAllListeners();
  }
  /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */
  generateTexture(e) {
    return this.textureGenerator.generateTexture(e);
  }
  /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */
  _unsafeEvalCheck() {
    if (!cS())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */
  resetState() {
    this.runners.resetState.emit();
  }
};
bS.defaultOptions = {
  /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */
  resolution: 1,
  /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */
  failIfMajorPerformanceCaveat: !1,
  /**
   * Should round pixels be forced when rendering?
   * @default false
   */
  roundPixels: !1
};
let Xc = bS, Lu;
function Jq(n) {
  return Lu !== void 0 || (Lu = (() => {
    var t;
    const e = {
      stencil: !0,
      failIfMajorPerformanceCaveat: n != null ? n : Xc.defaultOptions.failIfMajorPerformanceCaveat
    };
    try {
      if (!Pt.get().getWebGLRenderingContext())
        return !1;
      let s = Pt.get().createCanvas().getContext("webgl", e);
      const o = !!((t = s == null ? void 0 : s.getContextAttributes()) != null && t.stencil);
      if (s) {
        const r = s.getExtension("WEBGL_lose_context");
        r && r.loseContext();
      }
      return s = null, o;
    } catch {
      return !1;
    }
  })()), Lu;
}
let Bu;
async function Zq(n = {}) {
  return Bu !== void 0 || (Bu = await (async () => {
    const e = Pt.get().getNavigator().gpu;
    if (!e)
      return !1;
    try {
      return await (await e.requestAdapter(n)).requestDevice(), !0;
    } catch {
      return !1;
    }
  })()), Bu;
}
const yk = ["webgl", "webgpu", "canvas"];
async function Qq(n) {
  var o;
  let e = [];
  n.preference ? Array.isArray(n.preference) ? e = n.preference.slice() : (e.push(n.preference), yk.forEach((r) => {
    r !== n.preference && e.push(r);
  })) : e = yk.slice();
  let t, i = {};
  for (let r = 0; r < e.length; r++) {
    const a = e[r];
    if (a === "webgpu" && await Zq()) {
      const { WebGPURenderer: l } = await Promise.resolve().then(() => RZ);
      t = l, i = { ...n, ...n.webgpu };
      break;
    } else if (a === "webgl" && Jq(
      (o = n.failIfMajorPerformanceCaveat) != null ? o : Xc.defaultOptions.failIfMajorPerformanceCaveat
    )) {
      const { WebGLRenderer: l } = await Promise.resolve().then(() => QJ);
      t = l, i = { ...n, ...n.webgl };
      break;
    } else if (a === "canvas") {
      const { CanvasRenderer: l } = await Promise.resolve().then(() => ZX);
      t = l, i = { ...n, ...n.canvasOptions };
      break;
    }
  }
  if (delete i.webgpu, delete i.webgl, delete i.canvasOptions, !t)
    throw new Error("No available renderer for the current environment");
  const s = new t();
  return await s.init(i), s;
}
const jp = "8.22.0";
class yS {
  static init() {
    var e;
    (e = globalThis.__PIXI_APP_INIT__) == null || e.call(globalThis, this, jp);
  }
  static destroy() {
  }
}
yS.extension = Ae.Application;
class xS {
  constructor(e) {
    this._renderer = e;
  }
  init() {
    var e;
    (e = globalThis.__PIXI_RENDERER_INIT__) == null || e.call(globalThis, this._renderer, jp);
  }
  destroy() {
    this._renderer = null;
  }
}
xS.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "initHook",
  priority: -10
};
class wS {
  /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    Object.defineProperty(
      this,
      "resizeTo",
      {
        configurable: !0,
        set(t) {
          globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = t, t && (globalThis.addEventListener("resize", this.queueResize), this.resize());
        },
        get() {
          return this._resizeTo;
        }
      }
    ), this.queueResize = () => {
      this._resizeTo && (this._cancelResize(), this._resizeId = requestAnimationFrame(() => this.resize()));
    }, this._cancelResize = () => {
      this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
    }, this.resize = () => {
      if (!this._resizeTo)
        return;
      this._cancelResize();
      let t, i;
      if (this._resizeTo === globalThis.window)
        t = globalThis.innerWidth, i = globalThis.innerHeight;
      else {
        const { clientWidth: s, clientHeight: o } = this._resizeTo;
        t = s, i = o;
      }
      this.renderer.resize(t, i), this.render();
    }, this._resizeId = null, this._resizeTo = null, this.resizeTo = e.resizeTo || null;
  }
  /**
   * Clean up the ticker, scoped to application
   * @private
   */
  static destroy() {
    globalThis.removeEventListener("resize", this.queueResize), this._cancelResize(), this._cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
  }
}
wS.extension = Ae.Application;
class kS {
  /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    e = Object.assign({
      autoStart: !0,
      sharedTicker: !1
    }, e), Object.defineProperty(
      this,
      "ticker",
      {
        configurable: !0,
        set(t) {
          this._ticker && this._ticker.remove(this.render, this), this._ticker = t, t && t.add(this.render, this, bl.LOW);
        },
        get() {
          return this._ticker;
        }
      }
    ), this.stop = () => {
      this._ticker.stop();
    }, this.start = () => {
      this._ticker.start();
    }, this._ticker = null, this.ticker = e.sharedTicker ? Ci.shared : new Ci(), e.autoStart && this.start();
  }
  /**
   * Clean up the ticker, scoped to application.
   * @private
   */
  static destroy() {
    if (this._ticker) {
      const e = this._ticker;
      this.ticker = null, e.destroy();
    }
  }
}
kS.extension = Ae.Application;
ct.add(wS);
ct.add(kS);
const _S = class Rv {
  constructor(...e) {
    this.stage = new un(), e[0] !== void 0 && rt(on, "Application constructor options are deprecated, please use Application.init() instead.");
  }
  /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */
  async init(e) {
    e = { ...e }, this.stage || (this.stage = new un()), this.renderer = await Qq(e), Rv._plugins.forEach((t) => {
      t.init.call(this, e);
    });
  }
  /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */
  render() {
    this.renderer.render({ container: this.stage });
  }
  /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */
  get canvas() {
    return this.renderer.canvas;
  }
  /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */
  get view() {
    return rt(on, "Application.view is deprecated, please use Application.canvas instead."), this.renderer.canvas;
  }
  /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */
  get screen() {
    return this.renderer.screen;
  }
  /**
   * Get the html div element that holds all DOM Container elements.
   * @readonly
   * @type {HTMLDivElement}
   */
  get domContainerRoot() {
    var e;
    return (e = this.renderer.renderPipes.dom) == null ? void 0 : e._domElement;
  }
  /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */
  destroy(e = !1, t = !1) {
    const i = Rv._plugins.slice(0);
    i.reverse(), i.forEach((s) => {
      s.destroy.call(this);
    }), this.stage.destroy(t), this.stage = null, this.renderer.destroy(e), this.renderer = null;
  }
};
_S._plugins = [];
let SS = _S;
ct.handleByList(Ae.Application, SS._plugins);
ct.add(yS);
const fg = {
  a: 7,
  c: 6,
  h: 1,
  l: 2,
  m: 2,
  q: 4,
  s: 4,
  t: 2,
  v: 1,
  z: 0
}, eK = /([astvzqmhlc])([^astvzqmhlc]*)/gi, tK = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
function nK(n) {
  const e = [];
  return n.replace(eK, (t, i, s) => {
    let o = i.toLowerCase(), r = i;
    const a = iK(s);
    for (o === "m" && a.length > 2 && (e.push([r, ...a.splice(0, 2)]), o = "l", r = r === "m" ? "l" : "L"); ; ) {
      if (a.length === fg[o])
        return e.push([r, ...a]), "";
      if (a.length < fg[o]) throw new Error("malformed path data");
      e.push([r, ...a.splice(0, fg[o])]);
    }
  }), e;
}
function iK(n) {
  const e = n.match(tK);
  return e ? e.map(Number) : [];
}
function sK(n, e) {
  const t = nK(n), i = [];
  let s = null, o = 0, r = 0;
  for (let a = 0; a < t.length; a++) {
    const l = t[a], d = l[0], c = l;
    switch (d) {
      case "M":
        o = c[1], r = c[2], e.moveTo(o, r);
        break;
      case "m":
        o += c[1], r += c[2], e.moveTo(o, r);
        break;
      case "H":
        o = c[1], e.lineTo(o, r);
        break;
      case "h":
        o += c[1], e.lineTo(o, r);
        break;
      case "V":
        r = c[1], e.lineTo(o, r);
        break;
      case "v":
        r += c[1], e.lineTo(o, r);
        break;
      case "L":
        o = c[1], r = c[2], e.lineTo(o, r);
        break;
      case "l":
        o += c[1], r += c[2], e.lineTo(o, r);
        break;
      case "C":
        o = c[5], r = c[6], e.bezierCurveTo(
          c[1],
          c[2],
          // First control point
          c[3],
          c[4],
          // Second control point
          o,
          r
          // End point
        );
        break;
      case "c":
        e.bezierCurveTo(
          o + c[1],
          r + c[2],
          // First control point
          o + c[3],
          r + c[4],
          // Second control point
          o + c[5],
          r + c[6]
          // End point
        ), o += c[5], r += c[6];
        break;
      case "S":
        o = c[3], r = c[4], e.bezierCurveToShort(
          c[1],
          c[2],
          // Control point
          o,
          r
          // End point
        );
        break;
      case "s":
        e.bezierCurveToShort(
          o + c[1],
          r + c[2],
          // Control point
          o + c[3],
          r + c[4]
          // End point
        ), o += c[3], r += c[4];
        break;
      case "Q":
        o = c[3], r = c[4], e.quadraticCurveTo(
          c[1],
          c[2],
          // Control point
          o,
          r
          // End point
        );
        break;
      case "q":
        e.quadraticCurveTo(
          o + c[1],
          r + c[2],
          // Control point
          o + c[3],
          r + c[4]
          // End point
        ), o += c[3], r += c[4];
        break;
      case "T":
        o = c[1], r = c[2], e.quadraticCurveToShort(
          o,
          r
          // End point
        );
        break;
      case "t":
        o += c[1], r += c[2], e.quadraticCurveToShort(
          o,
          r
          // End point
        );
        break;
      case "A":
        o = c[6], r = c[7], e.arcToSvg(
          c[1],
          // rx
          c[2],
          // ry
          c[3],
          // x-axis-rotation
          c[4],
          // large-arc-flag
          c[5],
          // sweep-flag
          o,
          r
          // End point
        );
        break;
      case "a":
        o += c[6], r += c[7], e.arcToSvg(
          c[1],
          // rx
          c[2],
          // ry
          c[3],
          // x-axis-rotation
          c[4],
          // large-arc-flag
          c[5],
          // sweep-flag
          o,
          r
          // End point
        );
        break;
      case "Z":
      // Close Path
      case "z":
        e.closePath(), i.length > 0 && (s = i.pop(), s ? (o = s.startX, r = s.startY) : (o = 0, r = 0)), s = null;
        break;
      default:
        at(`Unknown SVG path command: ${d}`);
    }
    d !== "Z" && d !== "z" && s === null && (s = { startX: o, startY: r }, i.push(s));
  }
  return e;
}
class I1 {
  /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */
  constructor(e = 0, t = 0, i = 0) {
    this.type = "circle", this.x = e, this.y = t, this.radius = i;
  }
  /**
   * Creates a clone of this Circle instance.
   * @example
   * ```ts
   * // Basic circle cloning
   * const original = new Circle(100, 100, 50);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 75;
   *
   * // Verify independence
   * console.log(original.radius); // 50
   * console.log(modified.radius); // 75
   * ```
   * @returns A copy of the Circle
   * @see {@link Circle.copyFrom} For copying into existing circle
   * @see {@link Circle.copyTo} For copying to another circle
   */
  clone() {
    return new I1(this.x, this.y, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle.
   *
   * Uses the distance formula to determine if a point is inside the circle's radius.
   *
   * Commonly used for hit testing in PixiJS events and graphics.
   * @example
   * ```ts
   * // Basic containment check
   * const circle = new Circle(100, 100, 50);
   * const isInside = circle.contains(120, 120);
   *
   * // Check mouse position
   * const circle = new Circle(0, 0, 100);
   * container.hitArea = circle;
   * container.on('pointermove', (e) => {
   *     // only called if pointer is within circle
   * });
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   * @see {@link Circle.strokeContains} For checking stroke intersection
   * @see {@link Circle.getBounds} For getting bounding box
   */
  contains(e, t) {
    if (this.radius <= 0) return !1;
    const i = this.radius * this.radius;
    let s = this.x - e, o = this.y - t;
    return s *= s, o *= o, s + o <= i;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const circle = new Circle(100, 100, 50);
   * const isOnStroke = circle.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = circle.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = circle.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = circle.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle's stroke
   * @see {@link Circle.contains} For checking fill containment
   * @see {@link Circle.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    if (this.radius === 0) return !1;
    const o = this.x - e, r = this.y - t, a = this.radius, l = (1 - s) * i, d = Math.sqrt(o * o + r * r);
    return d <= a + l && d > a - (i - l);
  }
  /**
   * Returns the framing rectangle of the circle as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const circle = new Circle(100, 100, 50);
   * const bounds = circle.getBounds();
   * // bounds: x=50, y=50, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * circle.getBounds(rect);
   * ```
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Circle.contains} For point containment
   */
  getBounds(e) {
    return e || (e = new _t()), e.x = this.x - this.radius, e.y = this.y - this.radius, e.width = this.radius * 2, e.height = this.radius * 2, e;
  }
  /**
   * Copies another circle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * target.copyFrom(source);
   * ```
   * @param circle - The circle to copy from
   * @returns Returns itself
   * @see {@link Circle.copyTo} For copying to another circle
   * @see {@link Circle.clone} For creating new circle copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.radius = e.radius, this;
  }
  /**
   * Copies this circle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * source.copyTo(target);
   * ```
   * @param circle - The circle to copy to
   * @returns Returns given parameter
   * @see {@link Circle.copyFrom} For copying from another circle
   * @see {@link Circle.clone} For creating new circle copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
  }
}
class A1 {
  /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */
  constructor(e = 0, t = 0, i = 0, s = 0) {
    this.type = "ellipse", this.x = e, this.y = t, this.halfWidth = i, this.halfHeight = s;
  }
  /**
   * Creates a clone of this Ellipse instance.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Ellipse(100, 100, 50, 25);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.halfWidth *= 2;
   * modified.halfHeight *= 2;
   *
   * // Verify independence
   * console.log(original.halfWidth);  // 50
   * console.log(modified.halfWidth);  // 100
   * ```
   * @returns A copy of the ellipse
   * @see {@link Ellipse.copyFrom} For copying into existing ellipse
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   */
  clone() {
    return new A1(this.x, this.y, this.halfWidth, this.halfHeight);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse.
   * Uses normalized coordinates and the ellipse equation to determine containment.
   * @example
   * ```ts
   * // Basic containment check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isInside = ellipse.contains(120, 110);
   * ```
   * @remarks
   * - Uses ellipse equation (x²/a² + y²/b² ≤ 1)
   * - Returns false if dimensions are 0 or negative
   * - Normalized to center (0,0) for calculation
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   * @see {@link Ellipse.strokeContains} For checking stroke intersection
   * @see {@link Ellipse.getBounds} For getting containing rectangle
   */
  contains(e, t) {
    if (this.halfWidth <= 0 || this.halfHeight <= 0)
      return !1;
    let i = (e - this.x) / this.halfWidth, s = (t - this.y) / this.halfHeight;
    return i *= i, s *= s, i + s <= 1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isOnStroke = ellipse.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = ellipse.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = ellipse.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = ellipse.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @remarks
   * - Uses normalized ellipse equations
   * - Considers stroke alignment
   * - Returns false if dimensions are 0
   * - A stroke wider than the shape covers it entirely, leaving no unstroked interior
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coords are within this ellipse's stroke
   * @see {@link Ellipse.contains} For checking fill containment
   * @see {@link Ellipse.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    const { halfWidth: o, halfHeight: r } = this;
    if (o <= 0 || r <= 0)
      return !1;
    const a = i * (1 - s), l = i - a, d = o - l, c = r - l, u = o + a, p = r + a, f = e - this.x, y = t - this.y;
    return f * f / (u * u) + y * y / (p * p) > 1 ? !1 : d <= 0 || c <= 0 ? !0 : f * f / (d * d) + y * y / (c * c) > 1;
  }
  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const bounds = ellipse.getBounds();
   * // bounds: x=50, y=75, width=100, height=50
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * ellipse.getBounds(rect);
   * ```
   * @remarks
   * - Creates Rectangle if none provided
   * - Top-left is (x-halfWidth, y-halfHeight)
   * - Width is halfWidth * 2
   * - Height is halfHeight * 2
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Ellipse.contains} For checking if a point is inside
   */
  getBounds(e) {
    return e || (e = new _t()), e.x = this.x - this.halfWidth, e.y = this.y - this.halfHeight, e.width = this.halfWidth * 2, e.height = this.halfHeight * 2, e;
  }
  /**
   * Copies another ellipse to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * target.copyFrom(source);
   * ```
   * @param ellipse - The ellipse to copy from
   * @returns Returns itself
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.halfWidth = e.halfWidth, this.halfHeight = e.halfHeight, this;
  }
  /**
   * Copies this ellipse to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * source.copyTo(target);
   * ```
   * @param ellipse - The ellipse to copy to
   * @returns Returns given parameter
   * @see {@link Ellipse.copyFrom} For copying from another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
  }
}
function TS(n) {
  const e = n.length;
  if (e < 6)
    return 1;
  let t = 0;
  for (let i = 0, s = n[e - 2], o = n[e - 1]; i < e; i += 2) {
    const r = n[i], a = n[i + 1];
    t += (r - s) * (a + o), s = r, o = a;
  }
  return t < 0 ? -1 : 1;
}
function oK(n, e, t, i, s, o) {
  const r = n - t, a = e - i, l = s - t, d = o - i, c = r * l + a * d, u = l * l + d * d;
  let p = -1;
  u !== 0 && (p = c / u);
  let f, y;
  p < 0 ? (f = t, y = i) : p > 1 ? (f = s, y = o) : (f = t + p * l, y = i + p * d);
  const b = n - f, w = e - y;
  return b * b + w * w;
}
let rK, aK;
class ec {
  /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */
  constructor(...e) {
    this.type = "polygon";
    let t = Array.isArray(e[0]) ? e[0] : e;
    if (typeof t[0] != "number") {
      const i = [];
      for (let s = 0, o = t.length; s < o; s++)
        i.push(t[s].x, t[s].y);
      t = i;
    }
    this.points = t, this.closePath = !0;
  }
  /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * Uses the shoelace formula (surveyor's formula) to calculate the signed area.
   *
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @example
   * ```ts
   * // Check polygon winding
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * console.log(polygon.isClockwise()); // Check direction
   *
   * // Use in path construction
   * const hole = new Polygon([25, 25, 75, 25, 75, 75, 25, 75]);
   * if (hole.isClockwise() === shape.isClockwise()) {
   *     hole.points.reverse(); // Reverse for proper hole winding
   * }
   * ```
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */
  isClockwise() {
    let e = 0;
    const t = this.points, i = t.length;
    for (let s = 0; s < i; s += 2) {
      const o = t[s], r = t[s + 1], a = t[(s + 2) % i], l = t[(s + 3) % i];
      e += (a - o) * (l + r);
    }
    return e < 0;
  }
  /**
   * Checks if this polygon completely contains another polygon.
   * Used for detecting holes in shapes, like when parsing SVG paths.
   * @example
   * ```ts
   * // Basic containment check
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @remarks
   * - Uses bounds check for quick rejection
   * - Tests all points for containment
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   * @see {@link Polygon.contains} For single point testing
   * @see {@link Polygon.getBounds} For bounds calculation
   */
  containsPolygon(e) {
    const t = this.getBounds(rK), i = e.getBounds(aK);
    if (!t.containsRect(i))
      return !1;
    const s = e.points;
    for (let o = 0; o < s.length; o += 2) {
      const r = s[o], a = s[o + 1];
      if (!this.contains(r, a))
        return !1;
    }
    return !0;
  }
  /**
   * Creates a clone of this polygon.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Polygon([0, 0, 100, 0, 50, 100]);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.points[0] = 10; // Modify first x coordinate
   * ```
   * @returns A copy of the polygon
   * @see {@link Polygon.copyFrom} For copying into existing polygon
   * @see {@link Polygon.copyTo} For copying to another polygon
   */
  clone() {
    const e = this.points.slice(), t = new ec(e);
    return t.closePath = this.closePath, t;
  }
  /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * Uses raycasting algorithm for point-in-polygon testing.
   * @example
   * ```ts
   * // Basic containment check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isInside = polygon.contains(25, 25); // true
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this polygon
   * @see {@link Polygon.strokeContains} For checking stroke intersection
   * @see {@link Polygon.containsPolygon} For polygon-in-polygon testing
   */
  contains(e, t) {
    let i = !1;
    const s = this.points.length / 2;
    for (let o = 0, r = s - 1; o < s; r = o++) {
      const a = this.points[o * 2], l = this.points[o * 2 + 1], d = this.points[r * 2], c = this.points[r * 2 + 1];
      l > t != c > t && e < (d - a) * ((t - l) / (c - l)) + a && (i = !i);
    }
    return i;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isOnStroke = polygon.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = polygon.strokeContains(25, 25, 4, 1);   // Inside
   * const centerStroke = polygon.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = polygon.strokeContains(25, 25, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this polygon's stroke
   * @see {@link Polygon.contains} For checking fill containment
   * @see {@link Polygon.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    const { points: o } = this, r = s === 0.5 ? s : (s - 0.5) * TS(o) + 0.5, a = i * r, l = i - a, d = a * a, c = l * l, u = o.length - (this.closePath ? 0 : 2);
    for (let p = 0; p < u; p += 2) {
      const f = o[p], y = o[p + 1], b = o[(p + 2) % o.length], w = o[(p + 3) % o.length], k = oK(e, t, f, y, b, w), S = Math.sign((b - f) * (t - y) - (w - y) * (e - f));
      if (k <= (S < 0 ? d : c))
        return !0;
    }
    return !1;
  }
  /**
   * Returns the framing rectangle of the polygon as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const bounds = polygon.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * polygon.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Polygon.contains} For checking if a point is inside
   */
  getBounds(e) {
    e || (e = new _t());
    const t = this.points;
    let i = 1 / 0, s = -1 / 0, o = 1 / 0, r = -1 / 0;
    for (let a = 0, l = t.length; a < l; a += 2) {
      const d = t[a], c = t[a + 1];
      i = d < i ? d : i, s = d > s ? d : s, o = c < o ? c : o, r = c > r ? c : r;
    }
    return e.x = i, e.width = s - i, e.y = o, e.height = r - o, e;
  }
  /**
   * Copies another polygon to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * target.copyFrom(source);
   * ```
   * @param polygon - The polygon to copy from
   * @returns Returns itself
   * @see {@link Polygon.copyTo} For copying to another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */
  copyFrom(e) {
    return this.points = e.points.slice(), this.closePath = e.closePath, this;
  }
  /**
   * Copies this polygon to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * source.copyTo(target);
   * ```
   * @param polygon - The polygon to copy to
   * @returns Returns given parameter
   * @see {@link Polygon.copyFrom} For copying from another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((e, t) => `${e}, ${t}`, "")}]`;
  }
  /**
   * Get the last X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastX); // 300
   * ```
   * @readonly
   * @returns The x-coordinate of the last vertex
   * @see {@link Polygon.lastY} For last Y coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get lastX() {
    return this.points[this.points.length - 2];
  }
  /**
   * Get the last Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastY); // 400
   * ```
   * @readonly
   * @returns The y-coordinate of the last vertex
   * @see {@link Polygon.lastX} For last X coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get lastY() {
    return this.points[this.points.length - 1];
  }
  /**
   * Get the last X coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastX} instead.
   */
  get x() {
    return rt("8.11.0", "Polygon.lastX is deprecated, please use Polygon.lastX instead."), this.points[this.points.length - 2];
  }
  /**
   * Get the last Y coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastY} instead.
   */
  get y() {
    return rt("8.11.0", "Polygon.y is deprecated, please use Polygon.lastY instead."), this.points[this.points.length - 1];
  }
  /**
   * Get the first X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.x); // 0
   * ```
   * @readonly
   * @returns The x-coordinate of the first vertex
   * @see {@link Polygon.startY} For first Y coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get startX() {
    return this.points[0];
  }
  /**
   * Get the first Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.y); // 0
   * ```
   * @readonly
   * @returns The y-coordinate of the first vertex
   * @see {@link Polygon.startX} For first X coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get startY() {
    return this.points[1];
  }
}
const Fu = (n, e, t, i, s, o, r) => {
  const a = n - t, l = e - i, d = Math.sqrt(a * a + l * l);
  return d >= s - o && d <= s + r;
};
class P1 {
  /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */
  constructor(e = 0, t = 0, i = 0, s = 0, o = 20) {
    this.type = "roundedRectangle", this.x = e, this.y = t, this.width = i, this.height = s, this.radius = o;
  }
  /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const bounds = rect.getBounds();
   * // bounds: x=100, y=100, width=200, height=150
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @remarks
   * - Rectangle matches outer dimensions
   * - Ignores corner radius
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link RoundedRectangle.contains} For checking if a point is inside
   */
  getBounds(e) {
    return e || (e = new _t()), e.x = this.x, e.y = this.y, e.width = this.width, e.height = this.height, e;
  }
  /**
   * Creates a clone of this Rounded Rectangle.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new RoundedRectangle(100, 100, 200, 150, 20);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 30;
   * modified.width *= 2;
   *
   * // Verify independence
   * console.log(original.radius);  // 20
   * console.log(modified.radius);  // 30
   * ```
   * @returns A copy of the rounded rectangle
   * @see {@link RoundedRectangle.copyFrom} For copying into existing rectangle
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   */
  clone() {
    return new P1(this.x, this.y, this.width, this.height, this.radius);
  }
  /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new RoundedRectangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this.radius = e.radius, this;
  }
  /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new RoundedRectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link RoundedRectangle.copyFrom} For copying from another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isInside = rect.contains(150, 125); // true
   * // Check corner radius
   * const corner = rect.contains(100, 100); // false if within corner curve
   * ```
   * @remarks
   * - Returns false if width/height is 0 or negative
   * - Handles rounded corners with radius check
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rounded Rectangle
   * @see {@link RoundedRectangle.strokeContains} For checking stroke intersection
   * @see {@link RoundedRectangle.getBounds} For getting containing rectangle
   */
  contains(e, t) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    if (e >= this.x && e <= this.x + this.width && t >= this.y && t <= this.y + this.height) {
      const i = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
      if (t >= this.y + i && t <= this.y + this.height - i || e >= this.x + i && e <= this.x + this.width - i)
        return !0;
      let s = e - (this.x + i), o = t - (this.y + i);
      const r = i * i;
      if (s * s + o * o <= r || (s = e - (this.x + this.width - i), s * s + o * o <= r) || (o = t - (this.y + this.height - i), s * s + o * o <= r) || (s = e - (this.x + i), s * s + o * o <= r))
        return !0;
    }
    return !1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link RoundedRectangle.contains} For checking fill containment
   * @see {@link RoundedRectangle.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    const { x: o, y: r, width: a, height: l, radius: d } = this, c = i * (1 - s), u = i - c, p = o + d, f = r + d, y = a - d * 2, b = l - d * 2, w = o + a, k = r + l;
    return (e >= o - c && e <= o + u || e >= w - u && e <= w + c) && t >= f && t <= f + b || (t >= r - c && t <= r + u || t >= k - u && t <= k + c) && e >= p && e <= p + y ? !0 : (
      // Top-left
      e < p && t < f && Fu(
        e,
        t,
        p,
        f,
        d,
        u,
        c
      ) || e > w - d && t < f && Fu(
        e,
        t,
        w - d,
        f,
        d,
        u,
        c
      ) || e > w - d && t > k - d && Fu(
        e,
        t,
        w - d,
        k - d,
        d,
        u,
        c
      ) || e < p && t > k - d && Fu(
        e,
        t,
        p,
        k - d,
        d,
        u,
        c
      )
    );
  }
  toString() {
    return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
  }
}
const MS = {};
function E1(n, e, t) {
  let i = 2166136261;
  for (let s = 0; s < e; s++)
    i ^= n[s].uid, i = Math.imul(i, 16777619), i >>>= 0;
  return MS[i] || lK(n, e, i, t);
}
function lK(n, e, t, i) {
  const s = {};
  let o = 0;
  for (let a = 0; a < i; a++) {
    const l = a < e ? n[a] : Ze.EMPTY.source;
    s[o++] = l.source, s[o++] = l.style;
  }
  const r = new Eo(s);
  return MS[t] = r, r;
}
class xk {
  constructor(e) {
    typeof e == "number" ? this.rawBinaryData = new ArrayBuffer(e) : e instanceof Uint8Array ? this.rawBinaryData = e.buffer : this.rawBinaryData = e, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData), this.size = this.rawBinaryData.byteLength;
  }
  /** View on the raw binary data as a `Int8Array`. */
  get int8View() {
    return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
  }
  /** View on the raw binary data as a `Uint8Array`. */
  get uint8View() {
    return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
  }
  /**  View on the raw binary data as a `Int16Array`. */
  get int16View() {
    return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
  }
  /** View on the raw binary data as a `Int32Array`. */
  get int32View() {
    return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
  }
  /** View on the raw binary data as a `Float64Array`. */
  get float64View() {
    return this._float64Array || (this._float64Array = new Float64Array(this.rawBinaryData)), this._float64Array;
  }
  /** View on the raw binary data as a `BigUint64Array`. */
  get bigUint64View() {
    return this._bigUint64Array || (this._bigUint64Array = new BigUint64Array(this.rawBinaryData)), this._bigUint64Array;
  }
  /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */
  view(e) {
    return this[`${e}View`];
  }
  /** Destroys all buffer references. Do not use after calling this. */
  destroy() {
    this.rawBinaryData = null, this.uint32View = null, this.float32View = null, this.uint16View = null, this._int8View = null, this._uint8View = null, this._int16View = null, this._int32View = null, this._float64Array = null, this._bigUint64Array = null;
  }
  /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */
  static sizeOf(e) {
    switch (e) {
      case "int8":
      case "uint8":
        return 1;
      case "int16":
      case "uint16":
        return 2;
      case "int32":
      case "uint32":
      case "float32":
        return 4;
      default:
        throw new Error(`${e} isn't a valid view type`);
    }
  }
}
function zv(n, e, t, i) {
  if (t != null || (t = 0), i != null || (i = Math.min(n.byteLength - t, e.byteLength)), !(t & 7) && !(i & 7)) {
    const s = i / 8;
    new Float64Array(e, 0, s).set(new Float64Array(n, t, s));
  } else if (!(t & 3) && !(i & 3)) {
    const s = i / 4;
    new Float32Array(e, 0, s).set(new Float32Array(n, t, s));
  } else
    new Uint8Array(e).set(new Uint8Array(n, t, i));
}
const dK = {
  normal: "normal-npm",
  add: "add-npm",
  screen: "screen-npm"
};
var cn = /* @__PURE__ */ ((n) => (n[n.DISABLED = 0] = "DISABLED", n[n.RENDERING_MASK_ADD = 1] = "RENDERING_MASK_ADD", n[n.MASK_ACTIVE = 2] = "MASK_ACTIVE", n[n.INVERSE_MASK_ACTIVE = 3] = "INVERSE_MASK_ACTIVE", n[n.RENDERING_MASK_REMOVE = 4] = "RENDERING_MASK_REMOVE", n[n.NONE = 5] = "NONE", n))(cn || {});
function wk(n, e) {
  return e.alphaMode === "no-premultiply-alpha" && dK[n] || n;
}
const cK = [
  "precision mediump float;",
  "void main(void){",
  "float test = 0.1;",
  "%forloop%",
  "gl_FragColor = vec4(0.0);",
  "}"
].join(`
`);
function uK(n) {
  let e = "";
  for (let t = 0; t < n; ++t)
    t > 0 && (e += `
else `), t < n - 1 && (e += `if(test == ${t}.0){}`);
  return e;
}
function CS(n, e) {
  if (n === 0)
    throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
  const t = e.createShader(e.FRAGMENT_SHADER);
  try {
    for (; ; ) {
      const i = cK.replace(/%forloop%/gi, uK(n));
      if (e.shaderSource(t, i), e.compileShader(t), !e.getShaderParameter(t, e.COMPILE_STATUS))
        n = n / 2 | 0;
      else
        break;
    }
  } finally {
    e.deleteShader(t);
  }
  return n;
}
let ha = null;
function hK() {
  var e;
  if (ha) return ha;
  const n = tS();
  return ha = n.getParameter(n.MAX_TEXTURE_IMAGE_UNITS), ha = CS(
    ha,
    n
  ), (e = n.getExtension("WEBGL_lose_context")) == null || e.loseContext(), ha;
}
class pK {
  constructor() {
    this.ids = /* @__PURE__ */ Object.create(null), this.textures = [], this.count = 0;
  }
  /** Clear the textures and their locations. */
  clear() {
    for (let e = 0; e < this.count; e++) {
      const t = this.textures[e];
      this.textures[e] = null, this.ids[t.uid] = null;
    }
    this.count = 0;
  }
}
class fK {
  constructor() {
    this.renderPipeId = "batch", this.action = "startBatch", this.start = 0, this.size = 0, this.textures = new pK(), this.blendMode = "normal", this.topology = "triangle-strip", this.canBundle = !0;
  }
  destroy() {
    this.textures = null, this.gpuBindGroup = null, this.bindGroup = null, this.batcher = null, this.elements = null;
  }
}
const tc = [];
let Hp = 0;
zl.register({
  clear: () => {
    if (tc.length > 0)
      for (const n of tc)
        n && n.destroy();
    tc.length = 0, Hp = 0;
  }
});
function kk() {
  return Hp > 0 ? tc[--Hp] : new fK();
}
function _k(n) {
  n.elements = null, tc[Hp++] = n;
}
let id = 0;
const IS = class AS {
  constructor(e) {
    this.uid = Lt("batcher"), this.dirty = !0, this.batchIndex = 0, this.batches = [], this._elements = [], e = { ...AS.defaultOptions, ...e }, e.maxTextures || (rt("v8.8.0", "maxTextures is a required option for Batcher now, please pass it in the options"), e.maxTextures = hK());
    const { maxTextures: t, attributesInitialSize: i, indicesInitialSize: s } = e;
    this.attributeBuffer = new xk(i * 4), this.indexBuffer = new Uint16Array(s), this.maxTextures = t;
  }
  begin() {
    this.elementSize = 0, this.elementStart = 0, this.indexSize = 0, this.attributeSize = 0;
    for (let e = 0; e < this.batchIndex; e++)
      _k(this.batches[e]);
    this.batchIndex = 0, this._batchIndexStart = 0, this._batchIndexSize = 0, this.dirty = !0;
  }
  add(e) {
    this._elements[this.elementSize++] = e, e._indexStart = this.indexSize, e._attributeStart = this.attributeSize, e._batcher = this, this.indexSize += e.indexSize, this.attributeSize += e.attributeSize * this.vertexSize;
  }
  checkAndUpdateTexture(e, t) {
    const i = e._batch.textures.ids[t._source.uid];
    return !i && i !== 0 ? !1 : (e._textureId = i, e.texture = t, !0);
  }
  updateElement(e) {
    this.dirty = !0;
    const t = this.attributeBuffer;
    e.packAsQuad ? this.packQuadAttributes(
      e,
      t.float32View,
      t.uint32View,
      e._attributeStart,
      e._textureId
    ) : this.packAttributes(
      e,
      t.float32View,
      t.uint32View,
      e._attributeStart,
      e._textureId
    );
  }
  /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */
  break(e) {
    const t = this._elements;
    if (!t[this.elementStart]) return;
    let i = kk(), s = i.textures;
    s.clear();
    const o = t[this.elementStart];
    let r = wk(o.blendMode, o.texture._source), a = o.topology;
    this.attributeSize * 4 > this.attributeBuffer.size && this._resizeAttributeBuffer(this.attributeSize * 4), this.indexSize > this.indexBuffer.length && this._resizeIndexBuffer(this.indexSize);
    const l = this.attributeBuffer.float32View, d = this.attributeBuffer.uint32View, c = this.indexBuffer;
    let u = this._batchIndexSize, p = this._batchIndexStart, f = "startBatch", y = [];
    const b = this.maxTextures;
    for (let w = this.elementStart; w < this.elementSize; ++w) {
      const k = t[w];
      t[w] = null;
      const _ = k.texture._source, x = wk(k.blendMode, _), T = r !== x || a !== k.topology;
      if (_._batchTick === id && !T) {
        k._textureId = _._textureBindLocation, u += k.indexSize, k.packAsQuad ? (this.packQuadAttributes(
          k,
          l,
          d,
          k._attributeStart,
          k._textureId
        ), this.packQuadIndex(
          c,
          k._indexStart,
          k._attributeStart / this.vertexSize
        )) : (this.packAttributes(
          k,
          l,
          d,
          k._attributeStart,
          k._textureId
        ), this.packIndex(
          k,
          c,
          k._indexStart,
          k._attributeStart / this.vertexSize
        )), k._batch = i, y.push(k);
        continue;
      }
      _._batchTick = id, (s.count >= b || T) && (this._finishBatch(
        i,
        p,
        u - p,
        s,
        r,
        a,
        e,
        f,
        y
      ), f = "renderBatch", p = u, r = x, a = k.topology, i = kk(), s = i.textures, s.clear(), y = [], ++id), k._textureId = _._textureBindLocation = s.count, s.ids[_.uid] = s.count, s.textures[s.count++] = _, k._batch = i, y.push(k), u += k.indexSize, k.packAsQuad ? (this.packQuadAttributes(
        k,
        l,
        d,
        k._attributeStart,
        k._textureId
      ), this.packQuadIndex(
        c,
        k._indexStart,
        k._attributeStart / this.vertexSize
      )) : (this.packAttributes(
        k,
        l,
        d,
        k._attributeStart,
        k._textureId
      ), this.packIndex(
        k,
        c,
        k._indexStart,
        k._attributeStart / this.vertexSize
      ));
    }
    s.count > 0 && (this._finishBatch(
      i,
      p,
      u - p,
      s,
      r,
      a,
      e,
      f,
      y
    ), p = u, ++id), this.elementStart = this.elementSize, this._batchIndexStart = p, this._batchIndexSize = u;
  }
  _finishBatch(e, t, i, s, o, r, a, l, d) {
    e.gpuBindGroup = null, e.bindGroup = null, e.action = l, e.batcher = this, e.textures = s, e.blendMode = o, e.topology = r, e.start = t, e.size = i, e.elements = d, ++id, this.batches[this.batchIndex++] = e, a.add(e);
  }
  finish(e) {
    this.break(e);
  }
  /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureAttributeBuffer(e) {
    e * 4 <= this.attributeBuffer.size || this._resizeAttributeBuffer(e * 4);
  }
  /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureIndexBuffer(e) {
    e <= this.indexBuffer.length || this._resizeIndexBuffer(e);
  }
  _resizeAttributeBuffer(e) {
    const t = Math.max(e, this.attributeBuffer.size * 2), i = new xk(t);
    zv(this.attributeBuffer.rawBinaryData, i.rawBinaryData), this.attributeBuffer = i;
  }
  _resizeIndexBuffer(e) {
    const t = this.indexBuffer;
    let i = Math.max(e, t.length * 1.5);
    i += i % 2;
    const s = i > 65535 ? new Uint32Array(i) : new Uint16Array(i);
    if (s.BYTES_PER_ELEMENT !== t.BYTES_PER_ELEMENT)
      for (let o = 0; o < t.length; o++)
        s[o] = t[o];
    else
      zv(t.buffer, s.buffer);
    this.indexBuffer = s;
  }
  packQuadIndex(e, t, i) {
    e[t] = i + 0, e[t + 1] = i + 1, e[t + 2] = i + 2, e[t + 3] = i + 0, e[t + 4] = i + 2, e[t + 5] = i + 3;
  }
  packIndex(e, t, i, s) {
    const o = e.indices, r = e.indexSize, a = e.indexOffset, l = e.attributeOffset;
    for (let d = 0; d < r; d++)
      t[i++] = s + o[d + a] - l;
  }
  /**
   * Destroys the batch and its resources.
   * @param options - destruction options
   * @param options.shader - whether to destroy the associated shader
   */
  destroy(e = {}) {
    var t;
    if (this.batches !== null) {
      for (let i = 0; i < this.batchIndex; i++)
        _k(this.batches[i]);
      this.batches = null, this.geometry.destroy(!0), this.geometry = null, e.shader && ((t = this.shader) == null || t.destroy(), this.shader = null);
      for (let i = 0; i < this._elements.length; i++)
        this._elements[i] && (this._elements[i]._batch = null);
      this._elements = null, this.indexBuffer = null, this.attributeBuffer.destroy(), this.attributeBuffer = null;
    }
  }
};
IS.defaultOptions = {
  maxTextures: null,
  attributesInitialSize: 4,
  indicesInitialSize: 6
};
let mK = IS;
var Et = /* @__PURE__ */ ((n) => (n[n.MAP_READ = 1] = "MAP_READ", n[n.MAP_WRITE = 2] = "MAP_WRITE", n[n.COPY_SRC = 4] = "COPY_SRC", n[n.COPY_DST = 8] = "COPY_DST", n[n.INDEX = 16] = "INDEX", n[n.VERTEX = 32] = "VERTEX", n[n.UNIFORM = 64] = "UNIFORM", n[n.STORAGE = 128] = "STORAGE", n[n.INDIRECT = 256] = "INDIRECT", n[n.QUERY_RESOLVE = 512] = "QUERY_RESOLVE", n[n.STATIC = 1024] = "STATIC", n))(Et || {});
class Gi extends di {
  /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */
  constructor(e) {
    let { data: t, size: i } = e;
    const { usage: s, label: o, shrinkToFit: r } = e;
    super(), this._gpuData = /* @__PURE__ */ Object.create(null), this._gcLastUsed = -1, this.autoGarbageCollect = !0, this.uid = Lt("buffer"), this._resourceType = "buffer", this._resourceId = Lt("resource"), this._updateID = 1, this._updateOffset = 0, this._dataInt32 = null, this.shrinkToFit = !0, this.destroyed = !1, t instanceof Array && (t = new Float32Array(t)), this._data = t, i != null || (i = t == null ? void 0 : t.byteLength);
    const a = !!t;
    this.descriptor = {
      size: i,
      usage: s,
      mappedAtCreation: a,
      label: o
    }, this.shrinkToFit = r != null ? r : !0;
  }
  /** the data in the buffer */
  get data() {
    return this._data;
  }
  set data(e) {
    this.setDataWithSize(e, e.length, !0);
  }
  get dataInt32() {
    return this._dataInt32 || (this._dataInt32 = new Int32Array(this.data.buffer)), this._dataInt32;
  }
  /** whether the buffer is static or not */
  get static() {
    return !!(this.descriptor.usage & Et.STATIC);
  }
  set static(e) {
    e ? this.descriptor.usage |= Et.STATIC : this.descriptor.usage &= ~Et.STATIC;
  }
  /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */
  setDataWithSize(e, t, i) {
    if (this._updateID++, this._updateSize = t * e.BYTES_PER_ELEMENT, this._updateOffset = 0, this._data === e) {
      i && this.emit("update", this);
      return;
    }
    const s = this._data;
    if (this._data = e, this._dataInt32 = null, !s || s.length !== e.length) {
      !this.shrinkToFit && s && e.byteLength < s.byteLength ? i && this.emit("update", this) : (this.descriptor.size = e.byteLength, this._resourceId = Lt("resource"), this.emit("change", this));
      return;
    }
    i && this.emit("update", this);
  }
  /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   * @param offsetInBytes - the offset to start updating from
   */
  update(e, t) {
    this._updateSize = e != null ? e : this._updateSize, this._updateOffset = t || 0, this._updateID++, this.emit("update", this);
  }
  /** Unloads the buffer from the GPU */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null), this.destroyed || (this._resourceId = Lt("resource"), this.emit("change", this));
  }
  /** Destroys the buffer */
  destroy() {
    this.destroyed = !0, this.unload(), this.emit("destroy", this), this.emit("change", this), this._data = null, this.descriptor = null, this.removeAllListeners();
  }
}
function PS(n, e) {
  if (!(n instanceof Gi)) {
    let t = e ? Et.INDEX : Et.VERTEX;
    n instanceof Array && (e ? (n = new Uint32Array(n), t = Et.INDEX | Et.COPY_DST) : (n = new Float32Array(n), t = Et.VERTEX | Et.COPY_DST)), n = new Gi({
      data: n,
      label: e ? "index-mesh-buffer" : "vertex-mesh-buffer",
      usage: t
    });
  }
  return n;
}
function gK(n, e, t) {
  const i = n.getAttribute(e);
  if (!i)
    return t.minX = 0, t.minY = 0, t.maxX = 0, t.maxY = 0, t;
  const s = i.buffer.data;
  let o = 1 / 0, r = 1 / 0, a = -1 / 0, l = -1 / 0;
  const d = s.BYTES_PER_ELEMENT, c = (i.offset || 0) / d, u = (i.stride || 8) / d;
  for (let p = c; p < s.length; p += u) {
    const f = s[p], y = s[p + 1];
    f > a && (a = f), y > l && (l = y), f < o && (o = f), y < r && (r = y);
  }
  return t.minX = o, t.minY = r, t.maxX = a, t.maxY = l, t;
}
function bK(n) {
  return (n instanceof Gi || Array.isArray(n) || n.BYTES_PER_ELEMENT) && (n = {
    buffer: n
  }), n.buffer = PS(n.buffer, !1), n;
}
class Gf extends di {
  /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */
  constructor(e = {}) {
    var o, r;
    super(), this._gpuData = /* @__PURE__ */ Object.create(null), this.autoGarbageCollect = !0, this._gcLastUsed = -1, this.uid = Lt("geometry"), this._layoutKey = 0, this.instanceCount = 1, this.indexCount = 0, this._bounds = new On(), this._boundsDirty = !0, this._vertexCount = 0, this._vertexCountDirty = !0;
    const { attributes: t, indexBuffer: i, topology: s } = e;
    if (this.buffers = [], this.attributes = {}, t)
      for (const a in t)
        this.addAttribute(a, t[a]);
    this.instanceCount = (o = e.instanceCount) != null ? o : 1, this.indexCount = (r = e.indexCount) != null ? r : 0, i && this.addIndex(i), this.topology = s || "triangle-list";
  }
  onBufferUpdate() {
    this._boundsDirty = !0, this._vertexCountDirty = !0, this.emit("update", this);
  }
  /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Returns the index buffer
   * @returns - The index buffer.
   */
  getIndex() {
    return this.indexBuffer;
  }
  /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */
  getBuffer(e) {
    return this.getAttribute(e).buffer;
  }
  /**
   * The number of vertices in this geometry, derived from the first non-instanced attribute.
   * The value is cached and only recalculated when the geometry's buffers or attributes change.
   */
  get vertexCount() {
    if (!this._vertexCountDirty) return this._vertexCount;
    this._vertexCountDirty = !1;
    const e = this.attributes;
    for (const t in e) {
      const i = e[t];
      if (i.instance) continue;
      const s = i.buffer;
      return this._vertexCount = s.data.length / (i.stride / 4 || i.size), this._vertexCount;
    }
    return this._vertexCount = 0, 0;
  }
  /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   * @deprecated since 8.20.0, use {@link Geometry.vertexCount} instead
   */
  getSize() {
    return rt("8.20.0", "Geometry.getSize is deprecated, please use Geometry.vertexCount instead."), this.vertexCount;
  }
  /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */
  addAttribute(e, t) {
    const i = bK(t);
    this.buffers.indexOf(i.buffer) === -1 && (this.buffers.push(i.buffer), i.buffer.on("update", this.onBufferUpdate, this), i.buffer.on("change", this.onBufferUpdate, this)), this.attributes[e] = i, this._vertexCountDirty = !0;
  }
  /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */
  addIndex(e) {
    this.indexBuffer = PS(e, !0), this.buffers.push(this.indexBuffer);
  }
  /** Returns the bounds of the geometry. */
  get bounds() {
    return this._boundsDirty ? (this._boundsDirty = !1, gK(this, "aPosition", this._bounds)) : this._bounds;
  }
  /** Unloads the geometry from the GPU. */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null);
  }
  /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */
  destroy(e = !1) {
    this.emit("destroy", this);
    for (const t of this.buffers)
      t.off("update", this.onBufferUpdate, this), t.off("change", this.onBufferUpdate, this), e && t.destroy();
    this.unload(), this.removeAllListeners(), this.attributes = null, this.buffers = null, this.indexBuffer = null, this._bounds = null;
  }
}
const vK = new Float32Array(1), yK = new Uint32Array(1);
class xK extends Gf {
  constructor() {
    const t = new Gi({
      data: vK,
      label: "attribute-batch-buffer",
      usage: Et.VERTEX | Et.COPY_DST,
      shrinkToFit: !1
    }), i = new Gi({
      data: yK,
      label: "index-batch-buffer",
      usage: Et.INDEX | Et.COPY_DST,
      // | BufferUsage.STATIC,
      shrinkToFit: !1
    }), s = 24;
    super({
      attributes: {
        aPosition: {
          buffer: t,
          format: "float32x2",
          stride: s,
          offset: 0
        },
        aUV: {
          buffer: t,
          format: "float32x2",
          stride: s,
          offset: 8
        },
        aColor: {
          buffer: t,
          format: "unorm8x4",
          stride: s,
          offset: 16
        },
        aTextureIdAndRound: {
          buffer: t,
          format: "uint16x2",
          stride: s,
          offset: 20
        }
      },
      indexBuffer: i
    });
  }
}
function Sk(n, e, t) {
  if (n)
    for (const i in n) {
      const s = i.toLocaleLowerCase(), o = e[s];
      if (o) {
        let r = n[i];
        i === "header" && (r = r.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "")), t && o.push(`//----${t}----//`), o.push(r);
      } else
        at(`${i} placement hook does not exist in shader`);
    }
}
const wK = /\{\{(.*?)\}\}/g;
function Tk(n) {
  var i, s;
  const e = {};
  return ((s = (i = n.match(wK)) == null ? void 0 : i.map((o) => o.replace(/[{()}]/g, ""))) != null ? s : []).forEach((o) => {
    e[o] = [];
  }), e;
}
function Mk(n, e) {
  let t;
  const i = /@in\s+([^;]+);/g;
  for (; (t = i.exec(n)) !== null; )
    e.push(t[1]);
}
function Ck(n, e, t = !1) {
  const i = [];
  Mk(e, i), n.forEach((a) => {
    a.header && Mk(a.header, i);
  });
  const s = i;
  t && s.sort();
  const o = s.map((a, l) => `       @location(${l}) ${a},`).join(`
`);
  let r = e.replace(/@in\s+[^;]+;\s*/g, "");
  return r = r.replace("{{in}}", `
${o}
`), r;
}
function Ik(n, e) {
  let t;
  const i = /@out\s+([^;]+);/g;
  for (; (t = i.exec(n)) !== null; )
    e.push(t[1]);
}
function kK(n) {
  const t = /\b(\w+)\s*:/g.exec(n);
  return t ? t[1] : "";
}
function _K(n) {
  const e = /@.*?\s+/g;
  return n.replace(e, "");
}
function SK(n, e) {
  const t = [];
  Ik(e, t), n.forEach((l) => {
    l.header && Ik(l.header, t);
  });
  let i = 0;
  const s = t.sort().map((l) => l.indexOf("builtin") > -1 ? l : `@location(${i++}) ${l}`).join(`,
`), o = t.sort().map((l) => `       var ${_K(l)};`).join(`
`), r = `return VSOutput(
            ${t.sort().map((l) => ` ${kK(l)}`).join(`,
`)});`;
  let a = e.replace(/@out\s+[^;]+;\s*/g, "");
  return a = a.replace("{{struct}}", `
${s}
`), a = a.replace("{{start}}", `
${o}
`), a = a.replace("{{return}}", `
${r}
`), a;
}
function Ak(n, e) {
  let t = n;
  for (const i in e) {
    const s = e[i];
    s.join(`
`).length ? t = t.replace(`{{${i}}}`, `//-----${i} START-----//
${s.join(`
`)}
//----${i} FINISH----//`) : t = t.replace(`{{${i}}}`, "");
  }
  return t;
}
const xo = /* @__PURE__ */ Object.create(null), mg = /* @__PURE__ */ new Map();
let TK = 0;
function MK({
  template: n,
  bits: e
}) {
  const t = ES(n, e);
  if (xo[t]) return xo[t];
  const { vertex: i, fragment: s } = IK(n, e);
  return xo[t] = RS(i, s, e), xo[t];
}
function CK({
  template: n,
  bits: e
}) {
  const t = ES(n, e);
  return xo[t] || (xo[t] = RS(n.vertex, n.fragment, e)), xo[t];
}
function IK(n, e) {
  const t = e.map((r) => r.vertex).filter((r) => !!r), i = e.map((r) => r.fragment).filter((r) => !!r);
  let s = Ck(t, n.vertex, !0);
  s = SK(t, s);
  const o = Ck(i, n.fragment, !0);
  return {
    vertex: s,
    fragment: o
  };
}
function ES(n, e) {
  return e.map((t) => (mg.has(t) || mg.set(t, TK++), mg.get(t))).sort((t, i) => t - i).join("-") + n.vertex + n.fragment;
}
function RS(n, e, t) {
  const i = Tk(n), s = Tk(e);
  return t.forEach((o) => {
    Sk(o.vertex, i, o.name), Sk(o.fragment, s, o.name);
  }), {
    vertex: Ak(n, i),
    fragment: Ak(e, s)
  };
}
const AK = (
  /* wgsl */
  `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}

        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);

        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`
), PK = (
  /* wgsl */
  `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;

    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {

        {{start}}

        var outColor:vec4<f32>;

        {{main}}

        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`
), EK = (
  /* glsl */
  `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;

        {{start}}

        vColor = vec4(1.);

        {{main}}

        vUV = uv;

        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`
), RK = (
  /* glsl */
  `

    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {

        {{start}}

        vec4 outColor;

        {{main}}

        finalColor = outColor * vColor;

        {{end}}
    }
`
), zK = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* wgsl */
      `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    )
  }
}, $K = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* glsl */
      `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    )
  }
};
function R1({ bits: n, name: e }) {
  const t = MK({
    template: {
      fragment: PK,
      vertex: AK
    },
    bits: [
      zK,
      ...n
    ]
  });
  return na.from({
    name: e,
    vertex: {
      source: t.vertex,
      entryPoint: "main"
    },
    fragment: {
      source: t.fragment,
      entryPoint: "main"
    }
  });
}
function z1({ bits: n, name: e }) {
  return new $l({
    name: e,
    ...CK({
      template: {
        vertex: EK,
        fragment: RK
      },
      bits: [
        $K,
        ...n
      ]
    })
  });
}
const zS = {
  name: "color-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            @in aColor: vec4<f32>;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, $S = {
  name: "color-bit",
  vertex: {
    header: (
      /* glsl */
      `
            in vec4 aColor;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, gg = {};
function DK(n) {
  const e = [];
  if (n === 1)
    e.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;"), e.push("@group(1) @binding(1) var textureSampler1: sampler;");
  else {
    let t = 0;
    for (let i = 0; i < n; i++)
      e.push(`@group(1) @binding(${t++}) var textureSource${i + 1}: texture_2d<f32>;`), e.push(`@group(1) @binding(${t++}) var textureSampler${i + 1}: sampler;`);
  }
  return e.join(`
`);
}
function OK(n) {
  const e = [];
  if (n === 1)
    e.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
  else {
    e.push("switch vTextureId {");
    for (let t = 0; t < n; t++)
      t === n - 1 ? e.push("  default:{") : e.push(`  case ${t}:{`), e.push(`      outColor = textureSampleGrad(textureSource${t + 1}, textureSampler${t + 1}, vUV, uvDx, uvDy);`), e.push("      break;}");
    e.push("}");
  }
  return e.join(`
`);
}
function DS(n) {
  return gg[n] || (gg[n] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
    },
    fragment: {
      header: `
                @in @interpolate(flat) vTextureId: u32;

                ${DK(n)}
            `,
      main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${OK(n)}
            `
    }
  }), gg[n];
}
const bg = {};
function LK(n) {
  const e = [];
  for (let t = 0; t < n; t++)
    t > 0 && e.push("else"), t < n - 1 && e.push(`if(vTextureId < ${t}.5)`), e.push("{"), e.push(`	outColor = texture(uTextures[${t}], vUV);`), e.push("}");
  return e.join(`
`);
}
function OS(n) {
  return bg[n] || (bg[n] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
    },
    fragment: {
      header: `
                in float vTextureId;

                uniform sampler2D uTextures[${n}];

            `,
      main: `

                ${LK(n)}
            `
    }
  }), bg[n];
}
const $1 = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, D1 = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* glsl */
      `
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, Pk = {};
function LS(n) {
  let e = Pk[n];
  if (e) return e;
  const t = new Int32Array(n);
  for (let i = 0; i < n; i++)
    t[i] = i;
  return e = Pk[n] = new ms({
    uTextures: { value: t, type: "i32", size: n }
  }, { isStatic: !0 }), e;
}
class Ek extends Js {
  constructor(e) {
    const t = z1({
      name: "batch",
      bits: [
        $S,
        OS(e),
        D1
      ]
    }), i = R1({
      name: "batch",
      bits: [
        zS,
        DS(e),
        $1
      ]
    });
    super({
      glProgram: t,
      gpuProgram: i,
      resources: {
        batchSamplers: LS(e)
      }
    }), this.maxTextures = e;
  }
}
let rr = null;
const BS = class FS extends mK {
  constructor(e) {
    super(e), this.geometry = new xK(), this.name = FS.extension.name, this.vertexSize = 6, rr != null || (rr = new Ek(e.maxTextures)), this.shader = rr;
  }
  /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packAttributes(e, t, i, s, o) {
    const r = o << 16 | e.roundPixels & 65535, a = e.transform, l = a.a, d = a.b, c = a.c, u = a.d, p = a.tx, f = a.ty, { positions: y, uvs: b } = e, w = e.color, k = e.attributeOffset, S = k + e.attributeSize;
    for (let _ = k; _ < S; _++) {
      const x = _ * 2, T = y[x], M = y[x + 1];
      t[s++] = l * T + c * M + p, t[s++] = u * M + d * T + f, t[s++] = b[x], t[s++] = b[x + 1], i[s++] = w, i[s++] = r;
    }
  }
  /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packQuadAttributes(e, t, i, s, o) {
    const r = e.texture, a = e.transform, l = a.a, d = a.b, c = a.c, u = a.d, p = a.tx, f = a.ty, y = e.bounds, b = y.maxX, w = y.minX, k = y.maxY, S = y.minY, _ = r.uvs, x = e.color, T = o << 16 | e.roundPixels & 65535;
    t[s + 0] = l * w + c * S + p, t[s + 1] = u * S + d * w + f, t[s + 2] = _.x0, t[s + 3] = _.y0, i[s + 4] = x, i[s + 5] = T, t[s + 6] = l * b + c * S + p, t[s + 7] = u * S + d * b + f, t[s + 8] = _.x1, t[s + 9] = _.y1, i[s + 10] = x, i[s + 11] = T, t[s + 12] = l * b + c * k + p, t[s + 13] = u * k + d * b + f, t[s + 14] = _.x2, t[s + 15] = _.y2, i[s + 16] = x, i[s + 17] = T, t[s + 18] = l * w + c * k + p, t[s + 19] = u * k + d * w + f, t[s + 20] = _.x3, t[s + 21] = _.y3, i[s + 22] = x, i[s + 23] = T;
  }
  /**
   * Updates the maximum number of textures that can be used in the shader.
   * @param maxTextures - The maximum number of textures that can be used in the shader.
   * @internal
   */
  _updateMaxTextures(e) {
    this.shader.maxTextures !== e && (rr = new Ek(e), this.shader = rr);
  }
  destroy() {
    this.shader = null, super.destroy();
  }
};
BS.extension = {
  type: [
    Ae.Batcher
  ],
  name: "default"
};
let O1 = BS;
class gs {
  constructor(e) {
    this.items = /* @__PURE__ */ Object.create(null);
    const { renderer: t, type: i, onUnload: s, priority: o, name: r } = e;
    this._renderer = t, t.gc.addResourceHash(this, "items", i, o != null ? o : 0), this._onUnload = s, this.name = r;
  }
  /**
   * Add an item to the hash. No-op if already added.
   * @param item
   * @returns true if the item was added, false if it was already in the hash
   */
  add(e) {
    return this.items[e.uid] ? !1 : (this.items[e.uid] = e, e.once("unload", this.remove, this), e._gcLastUsed = this._renderer.gc.now, !0);
  }
  remove(e, ...t) {
    var s;
    if (!this.items[e.uid]) return;
    const i = e._gpuData[this._renderer.uid];
    i && ((s = this._onUnload) == null || s.call(this, e, ...t), e.off("unload", this.remove, this), i.destroy(), e._gpuData[this._renderer.uid] = null, this.items[e.uid] = null);
  }
  removeAll(...e) {
    Object.values(this.items).forEach((t) => t && this.remove(t, ...e));
  }
  destroy(...e) {
    this.removeAll(...e), this.items = /* @__PURE__ */ Object.create(null), this._renderer = null, this._onUnload = null;
  }
}
function BK(n, e, t, i, s, o, r, a = null) {
  let l = 0;
  t *= e, s *= o;
  const d = a.a, c = a.b, u = a.c, p = a.d, f = a.tx, y = a.ty;
  for (; l < r; ) {
    const b = n[t], w = n[t + 1];
    i[s] = d * b + u * w + f, i[s + 1] = c * b + p * w + y, s += o, t += e, l++;
  }
}
function FK(n, e, t, i) {
  let s = 0;
  for (e *= t; s < i; )
    n[e] = 0, n[e + 1] = 0, e += t, s++;
}
function NS(n, e, t, i, s) {
  const o = e.a, r = e.b, a = e.c, l = e.d, d = e.tx, c = e.ty;
  t || (t = 0), i || (i = 2), s || (s = n.length / i - t);
  let u = t * i;
  for (let p = 0; p < s; p++) {
    const f = n[u], y = n[u + 1];
    n[u] = o * f + a * y + d, n[u + 1] = r * f + l * y + c, u += i;
  }
}
const NK = new st();
class L1 {
  constructor() {
    this.packAsQuad = !1, this.batcherName = "default", this.topology = "triangle-list", this.applyTransform = !0, this.roundPixels = 0, this._batcher = null, this._batch = null;
  }
  get uvs() {
    return this.geometryData.uvs;
  }
  get positions() {
    return this.geometryData.vertices;
  }
  get indices() {
    return this.geometryData.indices;
  }
  get blendMode() {
    return this.renderable && this.applyTransform ? this.renderable.groupBlendMode : "normal";
  }
  get color() {
    const e = this.baseColor, t = e >> 16 | e & 65280 | (e & 255) << 16, i = this.renderable;
    return i ? Vr(t, i.groupColor) + (this.alpha * i.groupAlpha * 255 << 24) : t + (this.alpha * 255 << 24);
  }
  get transform() {
    var e;
    return ((e = this.renderable) == null ? void 0 : e.groupTransform) || NK;
  }
  copyTo(e) {
    e.indexOffset = this.indexOffset, e.indexSize = this.indexSize, e.attributeOffset = this.attributeOffset, e.attributeSize = this.attributeSize, e.baseColor = this.baseColor, e.alpha = this.alpha, e.texture = this.texture, e.geometryData = this.geometryData, e.topology = this.topology;
  }
  reset() {
    this.applyTransform = !0, this.renderable = null, this.topology = "triangle-list";
  }
  destroy() {
    this.renderable = null, this.texture = null, this.geometryData = null, this._batcher = null, this._batch = null;
  }
}
const Ic = {
  extension: {
    type: Ae.ShapeBuilder,
    name: "circle"
  },
  build(n, e) {
    let t, i, s, o, r, a;
    if (n.type === "circle") {
      const x = n;
      if (r = a = x.radius, r <= 0)
        return !1;
      t = x.x, i = x.y, s = o = 0;
    } else if (n.type === "ellipse") {
      const x = n;
      if (r = x.halfWidth, a = x.halfHeight, r <= 0 || a <= 0)
        return !1;
      t = x.x, i = x.y, s = o = 0;
    } else {
      const x = n, T = x.width / 2, M = x.height / 2;
      t = x.x + T, i = x.y + M, r = a = Math.max(0, Math.min(x.radius, Math.min(T, M))), s = T - r, o = M - a;
    }
    if (s < 0 || o < 0)
      return !1;
    const l = Math.ceil(2.3 * Math.sqrt(r + a)), d = l * 8 + (s ? 4 : 0) + (o ? 4 : 0);
    if (d === 0)
      return !1;
    if (l === 0)
      return e[0] = e[6] = t + s, e[1] = e[3] = i + o, e[2] = e[4] = t - s, e[5] = e[7] = i - o, !0;
    let c = 0, u = l * 4 + (s ? 2 : 0) + 2, p = u, f = d, y = s + r, b = o, w = t + y, k = t - y, S = i + b;
    if (e[c++] = w, e[c++] = S, e[--u] = S, e[--u] = k, o) {
      const x = i - b;
      e[p++] = k, e[p++] = x, e[--f] = x, e[--f] = w;
    }
    for (let x = 1; x < l; x++) {
      const T = Math.PI / 2 * (x / l), M = s + Math.cos(T) * r, z = o + Math.sin(T) * a, P = t + M, D = t - M, $ = i + z, O = i - z;
      e[c++] = P, e[c++] = $, e[--u] = $, e[--u] = D, e[p++] = D, e[p++] = O, e[--f] = O, e[--f] = P;
    }
    y = s, b = o + a, w = t + y, k = t - y, S = i + b;
    const _ = i - b;
    return e[c++] = w, e[c++] = S, e[--f] = _, e[--f] = w, s && (e[c++] = k, e[c++] = S, e[--f] = _, e[--f] = k), !0;
  },
  triangulate(n, e, t, i, s, o) {
    if (n.length === 0)
      return;
    let r = 0, a = 0;
    for (let c = 0; c < n.length; c += 2)
      r += n[c], a += n[c + 1];
    r /= n.length / 2, a /= n.length / 2;
    let l = i;
    e[l * t] = r, e[l * t + 1] = a;
    const d = l++;
    for (let c = 0; c < n.length; c += 2)
      e[l * t] = n[c], e[l * t + 1] = n[c + 1], c > 0 && (s[o++] = l, s[o++] = d, s[o++] = l - 1), l++;
    s[o++] = d + 1, s[o++] = d, s[o++] = l - 1;
  }
}, UK = { ...Ic, extension: { ...Ic.extension, name: "ellipse" } }, GK = { ...Ic, extension: { ...Ic.extension, name: "roundedRectangle" } }, US = 1e-4, Rk = 1e-4;
function zk(n, e, t, i, s, o, r, a) {
  const l = n - t * s, d = e - i * s, c = n + t * o, u = e + i * o;
  let p, f;
  r ? (p = i, f = -t) : (p = -i, f = t);
  const y = l + p, b = d + f, w = c + p, k = u + f;
  return a.push(y, b), a.push(w, k), 2;
}
function ar(n, e, t, i, s, o, r, a) {
  const l = t - n, d = i - e;
  let c = Math.atan2(l, d), u = Math.atan2(s - n, o - e);
  a && c < u ? c += Math.PI * 2 : !a && c > u && (u += Math.PI * 2);
  let p = c;
  const f = u - c, y = Math.abs(f), b = Math.sqrt(l * l + d * d), w = (15 * y * Math.sqrt(b) / Math.PI >> 0) + 1, k = f / w;
  if (p += k, a) {
    r.push(n, e), r.push(t, i);
    for (let S = 1, _ = p; S < w; S++, _ += k)
      r.push(n, e), r.push(
        n + Math.sin(_) * b,
        e + Math.cos(_) * b
      );
    r.push(n, e), r.push(s, o);
  } else {
    r.push(t, i), r.push(n, e);
    for (let S = 1, _ = p; S < w; S++, _ += k)
      r.push(
        n + Math.sin(_) * b,
        e + Math.cos(_) * b
      ), r.push(n, e);
    r.push(s, o), r.push(n, e);
  }
  return w * 2;
}
function B1(n, e, t, i, s, o) {
  const r = US;
  if (n.length === 0)
    return;
  const a = e;
  let l = a.alignment;
  if (e.alignment !== 0.5) {
    let N = TS(n);
    l = (l - 0.5) * N + 0.5;
  }
  const d = new Gt(n[0], n[1]), c = new Gt(n[n.length - 2], n[n.length - 1]), u = i, p = Math.abs(d.x - c.x) < r && Math.abs(d.y - c.y) < r;
  if (u) {
    n = n.slice(), p && (n.pop(), n.pop(), c.set(n[n.length - 2], n[n.length - 1]));
    const N = (d.x + c.x) * 0.5, te = (c.y + d.y) * 0.5;
    n.unshift(N, te), n.push(N, te);
  }
  const f = s, y = n.length / 2;
  let b = n.length;
  const w = f.length / 2, k = a.width / 2, S = k * k, _ = a.miterLimit * a.miterLimit;
  let x = n[0], T = n[1], M = n[2], z = n[3], P = 0, D = 0, $ = -(T - z), O = x - M, L = 0, Z = 0, J = Math.sqrt($ * $ + O * O);
  $ /= J, O /= J, $ *= k, O *= k;
  const re = l, F = (1 - re) * 2, W = re * 2;
  u || (a.cap === "round" ? b += ar(
    x - $ * (F - W) * 0.5,
    T - O * (F - W) * 0.5,
    x - $ * F,
    T - O * F,
    x + $ * W,
    T + O * W,
    f,
    !0
  ) + 2 : a.cap === "square" && (b += zk(x, T, $, O, F, W, !0, f))), f.push(
    x - $ * F,
    T - O * F
  ), f.push(
    x + $ * W,
    T + O * W
  );
  for (let N = 1; N < y - 1; ++N) {
    x = n[(N - 1) * 2], T = n[(N - 1) * 2 + 1], M = n[N * 2], z = n[N * 2 + 1], P = n[(N + 1) * 2], D = n[(N + 1) * 2 + 1], $ = -(T - z), O = x - M, J = Math.sqrt($ * $ + O * O), $ /= J, O /= J, $ *= k, O *= k, L = -(z - D), Z = M - P, J = Math.sqrt(L * L + Z * Z), L /= J, Z /= J, L *= k, Z *= k;
    const te = M - x, G = T - z, q = M - P, B = D - z, ne = te * q + G * B, se = G * q - B * te, Y = se < 0;
    if (Math.abs(se) < 1e-3 * Math.abs(ne)) {
      f.push(
        M - $ * F,
        z - O * F
      ), f.push(
        M + $ * W,
        z + O * W
      ), ne >= 0 && (a.join === "round" ? b += ar(
        M,
        z,
        M - $ * F,
        z - O * F,
        M - L * F,
        z - Z * F,
        f,
        !1
      ) + 4 : b += 2, f.push(
        M - L * W,
        z - Z * W
      ), f.push(
        M + L * F,
        z + Z * F
      ));
      continue;
    }
    const ie = (-$ + x) * (-O + z) - (-$ + M) * (-O + T), De = (-L + P) * (-Z + z) - (-L + M) * (-Z + D), xe = (te * De - q * ie) / se, Oe = (B * ie - G * De) / se, Ee = (xe - M) * (xe - M) + (Oe - z) * (Oe - z), j = M + (xe - M) * F, V = z + (Oe - z) * F, Q = M - (xe - M) * W, oe = z - (Oe - z) * W, ue = Math.min(te * te + G * G, q * q + B * B), Ie = Y ? F : W, he = ue + Ie * Ie * S;
    Ee <= he ? a.join === "bevel" || Ee / S > _ ? (Y ? (f.push(j, V), f.push(M + $ * W, z + O * W), f.push(j, V), f.push(M + L * W, z + Z * W)) : (f.push(M - $ * F, z - O * F), f.push(Q, oe), f.push(M - L * F, z - Z * F), f.push(Q, oe)), b += 2) : a.join === "round" ? Y ? (f.push(j, V), f.push(M + $ * W, z + O * W), b += ar(
      M,
      z,
      M + $ * W,
      z + O * W,
      M + L * W,
      z + Z * W,
      f,
      !0
    ) + 4, f.push(j, V), f.push(M + L * W, z + Z * W)) : (f.push(M - $ * F, z - O * F), f.push(Q, oe), b += ar(
      M,
      z,
      M - $ * F,
      z - O * F,
      M - L * F,
      z - Z * F,
      f,
      !1
    ) + 4, f.push(M - L * F, z - Z * F), f.push(Q, oe)) : (f.push(j, V), f.push(Q, oe)) : (f.push(M - $ * F, z - O * F), f.push(M + $ * W, z + O * W), a.join === "round" ? Y ? b += ar(
      M,
      z,
      M + $ * W,
      z + O * W,
      M + L * W,
      z + Z * W,
      f,
      !0
    ) + 2 : b += ar(
      M,
      z,
      M - $ * F,
      z - O * F,
      M - L * F,
      z - Z * F,
      f,
      !1
    ) + 2 : a.join === "miter" && Ee / S <= _ && (Y ? (f.push(Q, oe), f.push(Q, oe)) : (f.push(j, V), f.push(j, V)), b += 2), f.push(M - L * F, z - Z * F), f.push(M + L * W, z + Z * W), b += 2);
  }
  x = n[(y - 2) * 2], T = n[(y - 2) * 2 + 1], M = n[(y - 1) * 2], z = n[(y - 1) * 2 + 1], $ = -(T - z), O = x - M, J = Math.sqrt($ * $ + O * O), $ /= J, O /= J, $ *= k, O *= k, f.push(M - $ * F, z - O * F), f.push(M + $ * W, z + O * W), u || (a.cap === "round" ? b += ar(
    M - $ * (F - W) * 0.5,
    z - O * (F - W) * 0.5,
    M - $ * F,
    z - O * F,
    M + $ * W,
    z + O * W,
    f,
    !1
  ) + 2 : a.cap === "square" && (b += zk(M, z, $, O, F, W, !1, f)));
  const ee = Rk * Rk;
  for (let N = w; N < b + w - 2; ++N)
    x = f[N * 2], T = f[N * 2 + 1], M = f[(N + 1) * 2], z = f[(N + 1) * 2 + 1], P = f[(N + 2) * 2], D = f[(N + 2) * 2 + 1], !(Math.abs(x * (z - D) + M * (D - T) + P * (T - z)) < ee) && o.push(N, N + 1, N + 2);
}
function jK(n, e, t, i) {
  const s = US;
  if (n.length === 0)
    return;
  const o = n[0], r = n[1], a = n[n.length - 2], l = n[n.length - 1], d = e || Math.abs(o - a) < s && Math.abs(r - l) < s, c = t, u = n.length / 2, p = c.length / 2;
  for (let f = 0; f < u; f++)
    c.push(n[f * 2]), c.push(n[f * 2 + 1]);
  for (let f = 0; f < u - 1; f++)
    i.push(p + f, p + f + 1);
  d && i.push(p + u - 1, p);
}
function GS(n, e, t, i, s, o, r) {
  const a = Yq(n, e, 2);
  if (!a)
    return;
  for (let d = 0; d < a.length; d += 3)
    o[r++] = a[d] + s, o[r++] = a[d + 1] + s, o[r++] = a[d + 2] + s;
  let l = s * i;
  for (let d = 0; d < n.length; d += 2)
    t[l] = n[d], t[l + 1] = n[d + 1], l += i;
}
const HK = [], VK = {
  extension: {
    type: Ae.ShapeBuilder,
    name: "polygon"
  },
  build(n, e) {
    for (let t = 0; t < n.points.length; t++)
      e[t] = n.points[t];
    return !0;
  },
  triangulate(n, e, t, i, s, o) {
    GS(n, HK, e, t, i, s, o);
  }
}, WK = {
  extension: {
    type: Ae.ShapeBuilder,
    name: "rectangle"
  },
  build(n, e) {
    const t = n, i = t.x, s = t.y, o = t.width, r = t.height;
    return o > 0 && r > 0 ? (e[0] = i, e[1] = s, e[2] = i + o, e[3] = s, e[4] = i + o, e[5] = s + r, e[6] = i, e[7] = s + r, !0) : !1;
  },
  triangulate(n, e, t, i, s, o) {
    let r = 0;
    i *= t, e[i + r] = n[0], e[i + r + 1] = n[1], r += t, e[i + r] = n[2], e[i + r + 1] = n[3], r += t, e[i + r] = n[6], e[i + r + 1] = n[7], r += t, e[i + r] = n[4], e[i + r + 1] = n[5], r += t;
    const a = i / t;
    s[o++] = a, s[o++] = a + 1, s[o++] = a + 2, s[o++] = a + 1, s[o++] = a + 3, s[o++] = a + 2;
  }
}, qK = {
  extension: {
    type: Ae.ShapeBuilder,
    name: "triangle"
  },
  build(n, e) {
    return e[0] = n.x, e[1] = n.y, e[2] = n.x2, e[3] = n.y2, e[4] = n.x3, e[5] = n.y3, !0;
  },
  triangulate(n, e, t, i, s, o) {
    let r = 0;
    i *= t, e[i + r] = n[0], e[i + r + 1] = n[1], r += t, e[i + r] = n[2], e[i + r + 1] = n[3], r += t, e[i + r] = n[4], e[i + r + 1] = n[5];
    const a = i / t;
    s[o++] = a, s[o++] = a + 1, s[o++] = a + 2;
  }
}, $k = [{ offset: 0, color: "white" }, { offset: 1, color: "black" }], F1 = class $v {
  constructor(...e) {
    var s;
    this.uid = Lt("fillGradient"), this._tick = 0, this.type = "linear", this.colorStops = [];
    let t = KK(e);
    t = { ...t.type === "radial" ? $v.defaultRadialOptions : $v.defaultLinearOptions, ...T8(t) }, this._textureSize = t.textureSize, this._wrapMode = t.wrapMode, t.type === "radial" ? (this.center = t.center, this.outerCenter = (s = t.outerCenter) != null ? s : this.center, this.innerRadius = t.innerRadius, this.outerRadius = t.outerRadius, this.scale = t.scale, this.rotation = t.rotation) : (this.start = t.start, this.end = t.end), this.textureSpace = t.textureSpace, this.type = t.type, t.colorStops.forEach((o) => {
      this.addColorStop(o.offset, o.color);
    });
  }
  /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */
  addColorStop(e, t) {
    return this.colorStops.push({ offset: e, color: pn.shared.setValue(t).toHexa() }), this;
  }
  /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildLinearGradient() {
    if (this.texture) return;
    let { x: e, y: t } = this.start, { x: i, y: s } = this.end, o = i - e, r = s - t;
    const a = o < 0 || r < 0;
    if (this._wrapMode === "clamp-to-edge") {
      if (o < 0) {
        const w = e;
        e = i, i = w, o *= -1;
      }
      if (r < 0) {
        const w = t;
        t = s, s = w, r *= -1;
      }
    }
    const l = this.colorStops.length ? this.colorStops : $k, d = this._textureSize, { canvas: c, context: u } = Ok(d, 1), p = a ? u.createLinearGradient(this._textureSize, 0, 0, 0) : u.createLinearGradient(0, 0, this._textureSize, 0);
    Dk(p, l), u.fillStyle = p, u.fillRect(0, 0, d, 1), this.texture = new Ze({
      source: new xc({
        resource: c,
        addressMode: this._wrapMode
      })
    });
    const f = Math.sqrt(o * o + r * r), y = Math.atan2(r, o), b = new st();
    b.scale(f / d, 1), b.rotate(y), b.translate(e, t), this.textureSpace === "local" && b.scale(d, d), this.transform = b;
  }
  /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildGradient() {
    this.texture || this._tick++, this.type === "linear" ? this.buildLinearGradient() : this.buildRadialGradient();
  }
  /**
   * Builds the internal texture and transform for the radial gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildRadialGradient() {
    if (this.texture) return;
    const e = this.colorStops.length ? this.colorStops : $k, t = this._textureSize, { canvas: i, context: s } = Ok(t, t), { x: o, y: r } = this.center, { x: a, y: l } = this.outerCenter, d = this.innerRadius, c = this.outerRadius, u = a - c, p = l - c, f = t / (c * 2), y = (o - u) * f, b = (r - p) * f, w = s.createRadialGradient(
      y,
      b,
      d * f,
      (a - u) * f,
      (l - p) * f,
      c * f
    );
    Dk(w, e), s.fillStyle = e[e.length - 1].color, s.fillRect(0, 0, t, t), s.fillStyle = w, s.translate(y, b), s.rotate(this.rotation), s.scale(1, this.scale), s.translate(-y, -b), s.fillRect(0, 0, t, t), this.texture = new Ze({
      source: new xc({
        resource: i,
        addressMode: this._wrapMode
      })
    });
    const k = new st();
    this.textureSpace === "local" ? k.scale(2 * c, 2 * c) : k.scale(1 / f, 1 / f), k.translate(u, p), this.transform = k;
  }
  /** Destroys the gradient, releasing resources. This will also destroy the internal texture. */
  destroy() {
    var e;
    (e = this.texture) == null || e.destroy(!0), this.texture = null, this.transform = null, this.colorStops = [], this.start = null, this.end = null, this.center = null, this.outerCenter = null;
  }
  /**
   * Returns a unique key for this gradient instance.
   * This key is used for caching and texture management.
   * @returns {string} Unique key for the gradient
   */
  get styleKey() {
    return `fill-gradient-${this.uid}-${this._tick}`;
  }
};
F1.defaultLinearOptions = {
  start: { x: 0, y: 0 },
  end: { x: 0, y: 1 },
  colorStops: [],
  textureSpace: "local",
  type: "linear",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
F1.defaultRadialOptions = {
  center: { x: 0.5, y: 0.5 },
  innerRadius: 0,
  outerRadius: 0.5,
  colorStops: [],
  scale: 1,
  rotation: 0,
  textureSpace: "local",
  type: "radial",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
let Dl = F1;
function Dk(n, e) {
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    n.addColorStop(i.offset, i.color);
  }
}
function Ok(n, e) {
  const t = Pt.get().createCanvas(n, e), i = t.getContext("2d");
  return { canvas: t, context: i };
}
function KK(n) {
  var t, i;
  let e = (t = n[0]) != null ? t : {};
  return (typeof e == "number" || n[1]) && (rt("8.5.2", "use options object instead"), e = {
    type: "linear",
    start: { x: n[0], y: n[1] },
    end: { x: n[2], y: n[3] },
    textureSpace: n[4],
    textureSize: (i = n[5]) != null ? i : Dl.defaultLinearOptions.textureSize
  }), e;
}
const YK = new st(), XK = new _t(), JK = new st();
function jS(n, e, t, i) {
  const s = e.matrix ? n.copyFrom(e.matrix).invert() : n.identity();
  if (e.textureSpace === "local") {
    const r = t.getBounds(XK);
    e.width && r.pad(e.width);
    const { x: a, y: l } = r, d = 1 / r.width, c = 1 / r.height, u = -a * d, p = -l * c, f = s.a, y = s.b, b = s.c, w = s.d;
    s.a *= d, s.b *= d, s.c *= c, s.d *= c, s.tx = u * f + p * b + s.tx, s.ty = u * y + p * w + s.ty;
  } else if (e.texture.rotate) {
    const { uvs: r, orig: a } = e.texture;
    s.scale(1 / a.width, 1 / a.height), s.prepend(JK.set(
      r.x1 - r.x0,
      r.y1 - r.y0,
      r.x3 - r.x0,
      r.y3 - r.y0,
      r.x0,
      r.y0
    ));
  } else
    s.translate(e.texture.frame.x, e.texture.frame.y), s.scale(1 / e.texture.source.width, 1 / e.texture.source.height);
  const o = e.texture.source.style;
  return !(e.fill instanceof Dl) && o.addressMode === "clamp-to-edge" && (o.addressMode = "repeat", o.update()), i && s.append(YK.copyFrom(i).invert()), s;
}
const Ol = {};
ct.handleByMap(Ae.ShapeBuilder, Ol);
ct.add(WK, VK, qK, Ic, UK, GK);
const ZK = new _t(), QK = new st();
function eY(n, e) {
  const { geometryData: t, batches: i } = e;
  i.length = 0, t.indices.length = 0, t.vertices.length = 0, t.uvs.length = 0;
  for (let s = 0; s < n.instructions.length; s++) {
    const o = n.instructions[s];
    if (o.action === "texture")
      tY(o.data, i, t);
    else if (o.action === "fill" || o.action === "stroke") {
      const r = o.action === "stroke", a = o.data.path.shapePath, l = o.data.style, d = o.data.hole;
      r && d && Lk(d.shapePath, l, !0, i, t), d && (a.shapePrimitives[a.shapePrimitives.length - 1].holes = d.shapePath.shapePrimitives), Lk(a, l, r, i, t);
    }
  }
}
function tY(n, e, t) {
  const i = [], s = Ol.rectangle, o = ZK;
  o.x = n.dx, o.y = n.dy, o.width = n.dw, o.height = n.dh;
  const r = n.transform;
  if (!s.build(o, i))
    return;
  const { vertices: a, uvs: l, indices: d } = t, c = d.length, u = a.length / 2;
  r && NS(i, r), s.triangulate(i, a, 2, u, d, c);
  const p = n.image, f = p.uvs;
  l.push(
    f.x0,
    f.y0,
    f.x1,
    f.y1,
    f.x3,
    f.y3,
    f.x2,
    f.y2
  );
  const y = Mn.get(L1);
  y.indexOffset = c, y.indexSize = d.length - c, y.attributeOffset = u, y.attributeSize = a.length / 2 - u, y.baseColor = n.style, y.alpha = n.alpha, y.texture = p, y.geometryData = t, e.push(y);
}
function Lk(n, e, t, i, s) {
  const { vertices: o, uvs: r, indices: a } = s;
  n.shapePrimitives.forEach(({ shape: l, transform: d, holes: c }) => {
    var _;
    const u = [], p = Ol[l.type];
    if (!p.build(l, u))
      return;
    const f = a.length, y = o.length / 2;
    let b = "triangle-list";
    if (d && NS(u, d), t) {
      const x = (_ = l.closePath) != null ? _ : !0, T = e;
      T.pixelLine ? (jK(u, x, o, a), b = "line-list") : B1(u, T, !1, x, o, a);
    } else if (c) {
      const x = [], T = u.slice();
      nY(c).forEach((z) => {
        x.push(T.length / 2), T.push(...z);
      }), GS(T, x, o, 2, y, a, f);
    } else
      p.triangulate(u, o, 2, y, a, f);
    const w = r.length / 2, k = e.texture;
    if (k !== Ze.WHITE) {
      const x = jS(QK, e, l, d);
      BK(o, 2, y, r, w, 2, o.length / 2 - y, x);
    } else
      FK(r, w, 2, o.length / 2 - y);
    const S = Mn.get(L1);
    S.indexOffset = f, S.indexSize = a.length - f, S.attributeOffset = y, S.attributeSize = o.length / 2 - y, S.baseColor = e.color, S.alpha = e.alpha, S.texture = k, S.geometryData = s, S.topology = b, i.push(S);
  });
}
function nY(n) {
  const e = [];
  for (let t = 0; t < n.length; t++) {
    const i = n[t].shape, s = [];
    Ol[i.type].build(i, s) && e.push(s);
  }
  return e;
}
class iY {
  constructor() {
    this.batches = [], this.geometryData = {
      vertices: [],
      uvs: [],
      indices: []
    };
  }
  reset() {
    this.batches && this.batches.forEach((e) => {
      Mn.return(e);
    }), this.graphicsData && Mn.return(this.graphicsData), this.isBatchable = !1, this.context = null, this.batches.length = 0, this.geometryData.indices.length = 0, this.geometryData.vertices.length = 0, this.geometryData.uvs.length = 0, this.graphicsData = null;
  }
  destroy() {
    this.reset(), this.batches = null, this.geometryData = null;
  }
}
class sY {
  constructor() {
    this.instructions = new S1();
  }
  init(e) {
    const t = e.maxTextures;
    this.batcher ? this.batcher._updateMaxTextures(t) : this.batcher = new O1({ maxTextures: t }), this.instructions.reset();
  }
  /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */
  get geometry() {
    return rt(JV, "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead."), this.batcher.geometry;
  }
  destroy() {
    this.batcher.destroy(), this.instructions.destroy(), this.batcher = null, this.instructions = null;
  }
}
const N1 = class Dv {
  constructor(e) {
    this._renderer = e, this._managedContexts = new gs({ renderer: e, type: "resource", name: "graphicsContext" });
  }
  /**
   * Runner init called, update the default options
   * @ignore
   */
  init(e) {
    var t;
    Dv.defaultOptions.bezierSmoothness = (t = e == null ? void 0 : e.bezierSmoothness) != null ? t : Dv.defaultOptions.bezierSmoothness;
  }
  /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */
  getContextRenderData(e) {
    return e._gpuData[this._renderer.uid].graphicsData || this._initContextRenderData(e);
  }
  /**
   * Updates the GPU context for a given GraphicsContext.
   * If the context is dirty, it will rebuild the batches and geometry data.
   * @param context - The GraphicsContext to update.
   * @returns The updated GpuGraphicsContext.
   * @internal
   */
  updateGpuContext(e) {
    const t = !!e._gpuData[this._renderer.uid], i = e._gpuData[this._renderer.uid] || this._initContext(e);
    if (e.dirty || !t) {
      t && i.reset(), eY(e, i);
      const s = e.batchMode;
      e.customShader || s === "no-batch" ? i.isBatchable = !1 : s === "auto" ? i.isBatchable = i.geometryData.vertices.length < 400 : i.isBatchable = !0, e.dirty = !1;
    }
    return i;
  }
  /**
   * Returns the GpuGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the GpuGraphicsContext for.
   * @returns The GpuGraphicsContext for the given GraphicsContext.
   * @internal
   */
  getGpuContext(e) {
    return e._gpuData[this._renderer.uid] || this._initContext(e);
  }
  _initContextRenderData(e) {
    const t = Mn.get(sY, {
      maxTextures: this._renderer.limits.maxBatchableTextures
    }), i = e._gpuData[this._renderer.uid], { batches: s, geometryData: o } = i;
    i.graphicsData = t;
    const r = o.vertices.length, a = o.indices.length;
    for (let u = 0; u < s.length; u++)
      s[u].applyTransform = !1;
    const l = t.batcher;
    l.ensureAttributeBuffer(r), l.ensureIndexBuffer(a), l.begin();
    for (let u = 0; u < s.length; u++) {
      const p = s[u];
      l.add(p);
    }
    l.finish(t.instructions);
    const d = l.geometry;
    d.indexBuffer.setDataWithSize(l.indexBuffer, l.indexSize, !0), d.buffers[0].setDataWithSize(l.attributeBuffer.float32View, l.attributeSize, !0);
    const c = l.batches;
    for (let u = 0; u < l.batchIndex; u++) {
      const p = c[u];
      p.bindGroup = E1(
        p.textures.textures,
        p.textures.count,
        this._renderer.limits.maxBatchableTextures
      );
    }
    return t;
  }
  _initContext(e) {
    const t = new iY();
    return t.context = e, e._gpuData[this._renderer.uid] = t, this._managedContexts.add(e), t;
  }
  destroy() {
    this._managedContexts.destroy(), this._renderer = null;
  }
};
N1.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "graphicsContext"
};
N1.defaultOptions = {
  /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */
  bezierSmoothness: 0.5
};
let U1 = N1;
const oY = 8, Nu = 11920929e-14, rY = 1;
function HS(n, e, t, i, s, o, r, a, l, d) {
  const u = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, d != null ? d : U1.defaultOptions.bezierSmoothness)
  );
  let p = (rY - u) / 1;
  return p *= p, aY(e, t, i, s, o, r, a, l, n, p), n;
}
function aY(n, e, t, i, s, o, r, a, l, d) {
  Ov(n, e, t, i, s, o, r, a, l, d, 0), l.push(r, a);
}
function Ov(n, e, t, i, s, o, r, a, l, d, c) {
  if (c > oY)
    return;
  const u = (n + t) / 2, p = (e + i) / 2, f = (t + s) / 2, y = (i + o) / 2, b = (s + r) / 2, w = (o + a) / 2, k = (u + f) / 2, S = (p + y) / 2, _ = (f + b) / 2, x = (y + w) / 2, T = (k + _) / 2, M = (S + x) / 2;
  if (c > 0) {
    let z = r - n, P = a - e;
    const D = Math.abs((t - r) * P - (i - a) * z), $ = Math.abs((s - r) * P - (o - a) * z);
    if (D > Nu && $ > Nu) {
      if ((D + $) * (D + $) <= d * (z * z + P * P)) {
        l.push(T, M);
        return;
      }
    } else if (D > Nu) {
      if (D * D <= d * (z * z + P * P)) {
        l.push(T, M);
        return;
      }
    } else if ($ > Nu) {
      if ($ * $ <= d * (z * z + P * P)) {
        l.push(T, M);
        return;
      }
    } else if (z = T - (n + r) / 2, P = M - (e + a) / 2, z * z + P * P <= d) {
      l.push(T, M);
      return;
    }
  }
  Ov(n, e, u, p, k, S, T, M, l, d, c + 1), Ov(T, M, _, x, b, w, r, a, l, d, c + 1);
}
const lY = 8, dY = 11920929e-14, cY = 1;
function uY(n, e, t, i, s, o, r, a) {
  const d = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, a != null ? a : U1.defaultOptions.bezierSmoothness)
  );
  let c = (cY - d) / 1;
  return c *= c, hY(e, t, i, s, o, r, n, c), n;
}
function hY(n, e, t, i, s, o, r, a) {
  Lv(r, n, e, t, i, s, o, a, 0), r.push(s, o);
}
function Lv(n, e, t, i, s, o, r, a, l) {
  if (l > lY)
    return;
  const d = (e + i) / 2, c = (t + s) / 2, u = (i + o) / 2, p = (s + r) / 2, f = (d + u) / 2, y = (c + p) / 2;
  let b = o - e, w = r - t;
  const k = Math.abs((i - o) * w - (s - r) * b);
  if (k > dY) {
    if (k * k <= a * (b * b + w * w)) {
      n.push(f, y);
      return;
    }
  } else if (b = f - (e + o) / 2, w = y - (t + r) / 2, b * b + w * w <= a) {
    n.push(f, y);
    return;
  }
  Lv(n, e, t, d, c, f, y, a, l + 1), Lv(n, f, y, u, p, o, r, a, l + 1);
}
function VS(n, e, t, i, s, o, r, a) {
  let l = Math.abs(s - o);
  (!r && s > o || r && o > s) && (l = 2 * Math.PI - l), a || (a = Math.max(6, Math.floor(6 * Math.pow(i, 1 / 3) * (l / Math.PI)))), a = Math.max(a, 3);
  let d = l / a, c = s;
  d *= r ? -1 : 1;
  for (let u = 0; u < a + 1; u++) {
    const p = Math.cos(c), f = Math.sin(c), y = e + p * i, b = t + f * i;
    n.push(y, b), c += d;
  }
}
function pY(n, e, t, i, s, o) {
  const r = n[n.length - 2], l = n[n.length - 1] - t, d = r - e, c = s - t, u = i - e, p = Math.abs(l * u - d * c);
  if (p < 1e-8 || o === 0) {
    (n[n.length - 2] !== e || n[n.length - 1] !== t) && n.push(e, t);
    return;
  }
  const f = l * l + d * d, y = c * c + u * u, b = l * c + d * u, w = o * Math.sqrt(f) / p, k = o * Math.sqrt(y) / p, S = w * b / f, _ = k * b / y, x = w * u + k * d, T = w * c + k * l, M = d * (k + S), z = l * (k + S), P = u * (w + _), D = c * (w + _), $ = Math.atan2(z - T, M - x), O = Math.atan2(D - T, P - x);
  VS(
    n,
    x + e,
    T + t,
    o,
    $,
    O,
    d * c > u * l
  );
}
const nc = Math.PI * 2, vg = {
  centerX: 0,
  centerY: 0,
  ang1: 0,
  ang2: 0
}, yg = ({ x: n, y: e }, t, i, s, o, r, a, l) => {
  n *= t, e *= i;
  const d = s * n - o * e, c = o * n + s * e;
  return l.x = d + r, l.y = c + a, l;
};
function fY(n, e) {
  const t = e === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(e / 4), i = e === 1.5707963267948966 ? 0.551915024494 : t, s = Math.cos(n), o = Math.sin(n), r = Math.cos(n + e), a = Math.sin(n + e);
  return [
    {
      x: s - o * i,
      y: o + s * i
    },
    {
      x: r + a * i,
      y: a - r * i
    },
    {
      x: r,
      y: a
    }
  ];
}
const Bk = (n, e, t, i) => {
  const s = n * i - e * t < 0 ? -1 : 1;
  let o = n * t + e * i;
  return o > 1 && (o = 1), o < -1 && (o = -1), s * Math.acos(o);
}, mY = (n, e, t, i, s, o, r, a, l, d, c, u, p) => {
  const f = Math.pow(s, 2), y = Math.pow(o, 2), b = Math.pow(c, 2), w = Math.pow(u, 2);
  let k = f * y - f * w - y * b;
  k < 0 && (k = 0), k /= f * w + y * b, k = Math.sqrt(k) * (r === a ? -1 : 1);
  const S = k * s / o * u, _ = k * -o / s * c, x = d * S - l * _ + (n + t) / 2, T = l * S + d * _ + (e + i) / 2, M = (c - S) / s, z = (u - _) / o, P = (-c - S) / s, D = (-u - _) / o, $ = Bk(1, 0, M, z);
  let O = Bk(M, z, P, D);
  a === 0 && O > 0 && (O -= nc), a === 1 && O < 0 && (O += nc), p.centerX = x, p.centerY = T, p.ang1 = $, p.ang2 = O;
};
function gY(n, e, t, i, s, o, r, a = 0, l = 0, d = 0) {
  if (o === 0 || r === 0)
    return;
  const c = Math.sin(a * nc / 360), u = Math.cos(a * nc / 360), p = u * (e - i) / 2 + c * (t - s) / 2, f = -c * (e - i) / 2 + u * (t - s) / 2;
  if (p === 0 && f === 0)
    return;
  o = Math.abs(o), r = Math.abs(r);
  const y = Math.pow(p, 2) / Math.pow(o, 2) + Math.pow(f, 2) / Math.pow(r, 2);
  y > 1 && (o *= Math.sqrt(y), r *= Math.sqrt(y)), mY(
    e,
    t,
    i,
    s,
    o,
    r,
    l,
    d,
    c,
    u,
    p,
    f,
    vg
  );
  let { ang1: b, ang2: w } = vg;
  const { centerX: k, centerY: S } = vg;
  let _ = Math.abs(w) / (nc / 4);
  Math.abs(1 - _) < 1e-7 && (_ = 1);
  const x = Math.max(Math.ceil(_), 1);
  w /= x;
  let T = n[n.length - 2], M = n[n.length - 1];
  const z = { x: 0, y: 0 };
  for (let P = 0; P < x; P++) {
    const D = fY(b, w), { x: $, y: O } = yg(D[0], o, r, u, c, k, S, z), { x: L, y: Z } = yg(D[1], o, r, u, c, k, S, z), { x: J, y: re } = yg(D[2], o, r, u, c, k, S, z);
    HS(
      n,
      T,
      M,
      $,
      O,
      L,
      Z,
      J,
      re
    ), T = J, M = re, b += w;
  }
}
function bY(n, e, t) {
  var r;
  const i = (a, l) => {
    const d = l.x - a.x, c = l.y - a.y, u = Math.sqrt(d * d + c * c), p = d / u, f = c / u;
    return { len: u, nx: p, ny: f };
  }, s = (a, l) => {
    a === 0 ? n.moveTo(l.x, l.y) : n.lineTo(l.x, l.y);
  };
  let o = e[e.length - 1];
  for (let a = 0; a < e.length; a++) {
    const l = e[a % e.length], d = (r = l.radius) != null ? r : t;
    if (d <= 0) {
      s(a, l), o = l;
      continue;
    }
    const c = e[(a + 1) % e.length], u = i(l, o), p = i(l, c);
    if (u.len < 1e-4 || p.len < 1e-4) {
      s(a, l), o = l;
      continue;
    }
    let f = Math.asin(u.nx * p.ny - u.ny * p.nx), y = 1, b = !1;
    u.nx * p.nx - u.ny * -p.ny < 0 ? f < 0 ? f = Math.PI + f : (f = Math.PI - f, y = -1, b = !0) : f > 0 && (y = -1, b = !0);
    const w = f / 2;
    let k, S = Math.abs(
      Math.cos(w) * d / Math.sin(w)
    );
    S > Math.min(u.len / 2, p.len / 2) ? (S = Math.min(u.len / 2, p.len / 2), k = Math.abs(S * Math.sin(w) / Math.cos(w))) : k = d;
    const _ = l.x + p.nx * S + -p.ny * k * y, x = l.y + p.ny * S + p.nx * k * y, T = Math.atan2(u.ny, u.nx) + Math.PI / 2 * y, M = Math.atan2(p.ny, p.nx) - Math.PI / 2 * y;
    a === 0 && n.moveTo(
      _ + Math.cos(T) * k,
      x + Math.sin(T) * k
    ), n.arc(_, x, k, T, M, b), o = l;
  }
}
function vY(n, e, t, i) {
  var a;
  const s = (l, d) => Math.sqrt((l.x - d.x) ** 2 + (l.y - d.y) ** 2), o = (l, d, c) => ({
    x: l.x + (d.x - l.x) * c,
    y: l.y + (d.y - l.y) * c
  }), r = e.length;
  for (let l = 0; l < r; l++) {
    const d = e[(l + 1) % r], c = (a = d.radius) != null ? a : t;
    if (c <= 0) {
      l === 0 ? n.moveTo(d.x, d.y) : n.lineTo(d.x, d.y);
      continue;
    }
    const u = e[l], p = e[(l + 2) % r], f = s(u, d);
    let y;
    if (f < 1e-4)
      y = d;
    else {
      const k = Math.min(f / 2, c);
      y = o(
        d,
        u,
        k / f
      );
    }
    const b = s(p, d);
    let w;
    if (b < 1e-4)
      w = d;
    else {
      const k = Math.min(b / 2, c);
      w = o(
        d,
        p,
        k / b
      );
    }
    l === 0 ? n.moveTo(y.x, y.y) : n.lineTo(y.x, y.y), n.quadraticCurveTo(d.x, d.y, w.x, w.y, i);
  }
}
const yY = new _t();
class xY {
  constructor(e) {
    this.shapePrimitives = [], this._currentPoly = null, this._bounds = new On(), this._graphicsPath2D = e, this.signed = e.checkForHoles;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(e, t) {
    return this.startPoly(e, t), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(e, t) {
    this._ensurePoly();
    const i = this._currentPoly.points, s = i[i.length - 2], o = i[i.length - 1];
    return (s !== e || o !== t) && i.push(e, t), this;
  }
  /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */
  arc(e, t, i, s, o, r) {
    this._ensurePoly(!1);
    const a = this._currentPoly.points;
    return VS(a, e, t, i, s, o, r), this;
  }
  /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */
  arcTo(e, t, i, s, o) {
    this._ensurePoly();
    const r = this._currentPoly.points;
    return pY(r, e, t, i, s, o), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(e, t, i, s, o, r, a) {
    const l = this._currentPoly.points;
    return gY(
      l,
      this._currentPoly.lastX,
      this._currentPoly.lastY,
      r,
      a,
      e,
      t,
      i,
      s,
      o
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(e, t, i, s, o, r, a) {
    this._ensurePoly();
    const l = this._currentPoly;
    return HS(
      this._currentPoly.points,
      l.lastX,
      l.lastY,
      e,
      t,
      i,
      s,
      o,
      r,
      a
    ), this;
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(e, t, i, s, o) {
    this._ensurePoly();
    const r = this._currentPoly;
    return uY(
      this._currentPoly.points,
      r.lastX,
      r.lastY,
      e,
      t,
      i,
      s,
      o
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.endPoly(!0), this;
  }
  /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */
  addPath(e, t) {
    this.endPoly(), t && !t.isIdentity() && (e = e.clone(!0), e.transform(t));
    const i = this.shapePrimitives, s = i.length;
    for (let o = 0; o < e.instructions.length; o++) {
      const r = e.instructions[o];
      this[r.action](...r.data);
    }
    if (e.checkForHoles && i.length - s > 1) {
      let o = null;
      for (let r = s; r < i.length; r++) {
        const a = i[r];
        if (a.shape.type === "polygon") {
          const l = a.shape, d = o == null ? void 0 : o.shape;
          d && d.containsPolygon(l) ? (o.holes || (o.holes = []), o.holes.push(a), i.copyWithin(r, r + 1), i.length--, r--) : o = a;
        }
      }
    }
    return this;
  }
  /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */
  finish(e = !1) {
    this.endPoly(e);
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, i, s, o) {
    return this.drawShape(new _t(e, t, i, s), o), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, i, s) {
    return this.drawShape(new I1(e, t, i), s), this;
  }
  /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  poly(e, t, i) {
    const s = new ec(e);
    return s.closePath = t, this.drawShape(s, i), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(e, t, i, s, o = 0, r) {
    s = Math.max(s | 0, 3);
    const a = -1 * Math.PI / 2 + o, l = Math.PI * 2 / s, d = [];
    for (let c = 0; c < s; c++) {
      const u = a - c * l;
      d.push(
        e + i * Math.cos(u),
        t + i * Math.sin(u)
      );
    }
    return this.poly(d, !0, r), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(e, t, i, s, o, r = 0, a) {
    if (s = Math.max(s | 0, 3), o <= 0)
      return this.regularPoly(e, t, i, s, r);
    const l = i * Math.sin(Math.PI / s) - 1e-3;
    o = Math.min(o, l);
    const d = -1 * Math.PI / 2 + r, c = Math.PI * 2 / s, u = (s - 2) * Math.PI / s / 2;
    for (let p = 0; p < s; p++) {
      const f = p * c + d, y = e + i * Math.cos(f), b = t + i * Math.sin(f), w = f + Math.PI + u, k = f - Math.PI - u, S = y + o * Math.cos(w), _ = b + o * Math.sin(w), x = y + o * Math.cos(k), T = b + o * Math.sin(k);
      p === 0 ? this.moveTo(S, _) : this.lineTo(S, _), this.quadraticCurveTo(y, b, x, T, a);
    }
    return this.closePath();
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(e, t, i = !1, s) {
    return e.length < 3 ? this : (i ? vY(this, e, t, s) : bY(this, e, t), this.closePath());
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(e, t, i, s, o) {
    if (o === 0)
      return this.rect(e, t, i, s);
    const r = Math.min(i, s) / 2, a = Math.min(r, Math.max(-r, o)), l = e + i, d = t + s, c = a < 0 ? -a : 0, u = Math.abs(a);
    return this.moveTo(e, t + u).arcTo(e + c, t + c, e + u, t, u).lineTo(l - u, t).arcTo(l - c, t + c, l, t + u, u).lineTo(l, d - u).arcTo(l - c, d - c, e + i - u, d, u).lineTo(e + u, d).arcTo(e + c, d - c, e, d - u, u).closePath();
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(e, t, i, s, o, r) {
    if (o <= 0)
      return this.rect(e, t, i, s);
    const a = Math.min(o, Math.min(i, s) / 2), l = e + i, d = t + s, c = [
      e + a,
      t,
      l - a,
      t,
      l,
      t + a,
      l,
      d - a,
      l - a,
      d,
      e + a,
      d,
      e,
      d - a,
      e,
      t + a
    ];
    for (let u = c.length - 1; u >= 2; u -= 2)
      c[u] === c[u - 2] && c[u - 1] === c[u - 3] && c.splice(u - 1, 2);
    return this.poly(c, !0, r);
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */
  ellipse(e, t, i, s, o) {
    return this.drawShape(new A1(e, t, i, s), o), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  roundRect(e, t, i, s, o, r) {
    return this.drawShape(new P1(e, t, i, s, o), r), this;
  }
  /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */
  drawShape(e, t) {
    return this.endPoly(), this.shapePrimitives.push({ shape: e, transform: t }), this;
  }
  /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */
  startPoly(e, t) {
    let i = this._currentPoly;
    return i && this.endPoly(), i = new ec(), i.points.push(e, t), this._currentPoly = i, this;
  }
  /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */
  endPoly(e = !1) {
    const t = this._currentPoly;
    return t && t.points.length > 2 && (t.closePath = e, this.shapePrimitives.push({ shape: t })), this._currentPoly = null, this;
  }
  _ensurePoly(e = !0) {
    if (!this._currentPoly && (this._currentPoly = new ec(), e)) {
      const t = this.shapePrimitives[this.shapePrimitives.length - 1];
      if (t) {
        let i = t.shape.x, s = t.shape.y;
        if (t.transform && !t.transform.isIdentity()) {
          const o = t.transform, r = i;
          i = o.a * i + o.c * s + o.tx, s = o.b * r + o.d * s + o.ty;
        }
        this._currentPoly.points.push(i, s);
      } else
        this._currentPoly.points.push(0, 0);
    }
  }
  /** Builds the path. */
  buildPath() {
    const e = this._graphicsPath2D;
    this.shapePrimitives.length = 0, this._currentPoly = null;
    for (let t = 0; t < e.instructions.length; t++) {
      const i = e.instructions[t];
      this[i.action](...i.data);
    }
    this.finish();
  }
  /** Gets the bounds of the path. */
  get bounds() {
    const e = this._bounds;
    e.clear();
    const t = this.shapePrimitives;
    for (let i = 0; i < t.length; i++) {
      const s = t[i], o = s.shape.getBounds(yY);
      s.transform ? e.addRect(o, s.transform) : e.addRect(o);
    }
    return e;
  }
}
class Vs {
  /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */
  constructor(e, t = !1) {
    var i;
    this.instructions = [], this.uid = Lt("graphicsPath"), this._dirty = !0, this.checkForHoles = t, typeof e == "string" ? sK(e, this) : this.instructions = (i = e == null ? void 0 : e.slice()) != null ? i : [];
  }
  /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */
  get shapePath() {
    return this._shapePath || (this._shapePath = new xY(this)), this._dirty && (this._dirty = !1, this._shapePath.buildPath()), this._shapePath;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */
  addPath(e, t) {
    return e = e.clone(), this.instructions.push({ action: "addPath", data: [e, t] }), this._dirty = !0, this;
  }
  arc(...e) {
    return this.instructions.push({ action: "arc", data: e }), this._dirty = !0, this;
  }
  arcTo(...e) {
    return this.instructions.push({ action: "arcTo", data: e }), this._dirty = !0, this;
  }
  arcToSvg(...e) {
    return this.instructions.push({ action: "arcToSvg", data: e }), this._dirty = !0, this;
  }
  bezierCurveTo(...e) {
    return this.instructions.push({ action: "bezierCurveTo", data: e }), this._dirty = !0, this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveToShort(e, t, i, s, o) {
    const r = this.instructions[this.instructions.length - 1], a = this.getLastPoint(Gt.shared);
    let l = 0, d = 0;
    if (!r || r.action !== "bezierCurveTo")
      l = a.x, d = a.y;
    else {
      l = r.data[2], d = r.data[3];
      const c = a.x, u = a.y;
      l = c + (c - l), d = u + (u - d);
    }
    return this.instructions.push({ action: "bezierCurveTo", data: [l, d, e, t, i, s, o] }), this._dirty = !0, this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.instructions.push({ action: "closePath", data: [] }), this._dirty = !0, this;
  }
  ellipse(...e) {
    return this.instructions.push({ action: "ellipse", data: e }), this._dirty = !0, this;
  }
  lineTo(...e) {
    return this.instructions.push({ action: "lineTo", data: e }), this._dirty = !0, this;
  }
  moveTo(...e) {
    return this.instructions.push({ action: "moveTo", data: e }), this;
  }
  quadraticCurveTo(...e) {
    return this.instructions.push({ action: "quadraticCurveTo", data: e }), this._dirty = !0, this;
  }
  /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveToShort(e, t, i) {
    const s = this.instructions[this.instructions.length - 1], o = this.getLastPoint(Gt.shared);
    let r = 0, a = 0;
    if (!s || s.action !== "quadraticCurveTo")
      r = o.x, a = o.y;
    else {
      r = s.data[0], a = s.data[1];
      const l = o.x, d = o.y;
      r = l + (l - r), a = d + (d - a);
    }
    return this.instructions.push({ action: "quadraticCurveTo", data: [r, a, e, t, i] }), this._dirty = !0, this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, i, s, o) {
    return this.instructions.push({ action: "rect", data: [e, t, i, s, o] }), this._dirty = !0, this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, i, s) {
    return this.instructions.push({ action: "circle", data: [e, t, i, s] }), this._dirty = !0, this;
  }
  roundRect(...e) {
    return this.instructions.push({ action: "roundRect", data: e }), this._dirty = !0, this;
  }
  poly(...e) {
    return this.instructions.push({ action: "poly", data: e }), this._dirty = !0, this;
  }
  regularPoly(...e) {
    return this.instructions.push({ action: "regularPoly", data: e }), this._dirty = !0, this;
  }
  roundPoly(...e) {
    return this.instructions.push({ action: "roundPoly", data: e }), this._dirty = !0, this;
  }
  roundShape(...e) {
    return this.instructions.push({ action: "roundShape", data: e }), this._dirty = !0, this;
  }
  filletRect(...e) {
    return this.instructions.push({ action: "filletRect", data: e }), this._dirty = !0, this;
  }
  chamferRect(...e) {
    return this.instructions.push({ action: "chamferRect", data: e }), this._dirty = !0, this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  // eslint-disable-next-line max-len
  star(e, t, i, s, o, r, a) {
    o || (o = s / 2);
    const l = -1 * Math.PI / 2 + r, d = i * 2, c = Math.PI * 2 / d, u = [];
    for (let p = 0; p < d; p++) {
      const f = p % 2 ? o : s, y = p * c + l;
      u.push(
        e + f * Math.cos(y),
        t + f * Math.sin(y)
      );
    }
    return this.poly(u, !0, a), this;
  }
  /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */
  clone(e = !1) {
    const t = new Vs();
    if (t.checkForHoles = this.checkForHoles, !e)
      t.instructions = this.instructions.slice();
    else
      for (let i = 0; i < this.instructions.length; i++) {
        const s = this.instructions[i];
        t.instructions.push({ action: s.action, data: s.data.slice() });
      }
    return t;
  }
  clear() {
    return this.instructions.length = 0, this._dirty = !0, this;
  }
  /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */
  transform(e) {
    if (e.isIdentity()) return this;
    const t = e.a, i = e.b, s = e.c, o = e.d, r = e.tx, a = e.ty;
    let l = 0, d = 0, c = 0, u = 0, p = 0, f = 0, y = 0, b = 0;
    for (let w = 0; w < this.instructions.length; w++) {
      const k = this.instructions[w], S = k.data;
      switch (k.action) {
        case "moveTo":
        case "lineTo":
          l = S[0], d = S[1], S[0] = t * l + s * d + r, S[1] = i * l + o * d + a;
          break;
        case "bezierCurveTo":
          c = S[0], u = S[1], p = S[2], f = S[3], l = S[4], d = S[5], S[0] = t * c + s * u + r, S[1] = i * c + o * u + a, S[2] = t * p + s * f + r, S[3] = i * p + o * f + a, S[4] = t * l + s * d + r, S[5] = i * l + o * d + a;
          break;
        case "quadraticCurveTo":
          c = S[0], u = S[1], l = S[2], d = S[3], S[0] = t * c + s * u + r, S[1] = i * c + o * u + a, S[2] = t * l + s * d + r, S[3] = i * l + o * d + a;
          break;
        case "arcToSvg":
          l = S[5], d = S[6], y = S[0], b = S[1], S[0] = t * y + s * b, S[1] = i * y + o * b, S[5] = t * l + s * d + r, S[6] = i * l + o * d + a;
          break;
        case "circle":
          S[4] = pa(S[3], e);
          break;
        case "rect":
          S[4] = pa(S[4], e);
          break;
        case "ellipse":
          S[8] = pa(S[8], e);
          break;
        case "roundRect":
          S[5] = pa(S[5], e);
          break;
        case "addPath":
          S[0].transform(e);
          break;
        case "poly":
          S[2] = pa(S[2], e);
          break;
        case "regularPoly":
        case "chamferRect":
          S[5] = pa(S[5], e);
          break;
        case "closePath":
          break;
        default:
          at("unknown transform action", k.action);
          break;
      }
    }
    return this._dirty = !0, this;
  }
  get bounds() {
    return this.shapePath.bounds;
  }
  /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */
  getLastPoint(e) {
    let t = this.instructions.length - 1, i = this.instructions[t];
    if (!i)
      return e.x = 0, e.y = 0, e;
    for (; i.action === "closePath"; ) {
      if (t--, t < 0)
        return e.x = 0, e.y = 0, e;
      i = this.instructions[t];
    }
    switch (i.action) {
      case "moveTo":
      case "lineTo":
        e.x = i.data[0], e.y = i.data[1];
        break;
      case "quadraticCurveTo":
        e.x = i.data[2], e.y = i.data[3];
        break;
      case "bezierCurveTo":
        e.x = i.data[4], e.y = i.data[5];
        break;
      case "arc":
      case "arcToSvg":
        e.x = i.data[5], e.y = i.data[6];
        break;
      case "addPath":
        i.data[0].getLastPoint(e);
        break;
    }
    return e;
  }
}
function pa(n, e) {
  return n ? n.prepend(e) : e.clone();
}
function kn(n, e, t) {
  const i = n.getAttribute(e);
  return i ? Number(i) : t;
}
function wY(n, e) {
  const t = n.querySelectorAll("defs");
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    for (let o = 0; o < s.children.length; o++) {
      const r = s.children[o];
      switch (r.nodeName.toLowerCase()) {
        case "lineargradient":
          e.defs[r.id] = kY(r);
          break;
        case "radialgradient":
          e.defs[r.id] = _Y(r);
          break;
      }
    }
  }
}
function Di(n, e, t) {
  const i = n.getAttribute(e);
  if (i != null && i.trim().endsWith("%")) {
    const s = Number(i.trim().slice(0, -1));
    return Number.isNaN(s) ? t : s / 100;
  }
  return kn(n, e, t);
}
function WS(n) {
  return (n.getAttribute("gradientUnits") || "objectBoundingBox") === "objectBoundingBox" ? "local" : "global";
}
function qS(n) {
  const e = [];
  for (let t = 0; t < n.children.length; t++) {
    const i = n.children[t], s = Di(i, "offset", 0), o = pn.shared.setValue(i.getAttribute("stop-color")).toNumber();
    e.push({ offset: s, color: o });
  }
  return e;
}
function kY(n) {
  const e = Di(n, "x1", 0), t = Di(n, "y1", 0), i = Di(n, "x2", 1), s = Di(n, "y2", 0);
  return new Dl({
    type: "linear",
    start: { x: e, y: t },
    end: { x: i, y: s },
    textureSpace: WS(n),
    colorStops: qS(n)
  });
}
function _Y(n) {
  const e = Di(n, "cx", 0.5), t = Di(n, "cy", 0.5), i = Di(n, "r", 0.5), s = Di(n, "fx", e), o = Di(n, "fy", t), r = Di(n, "fr", 0);
  return new Dl({
    type: "radial",
    center: { x: s, y: o },
    innerRadius: r,
    outerCenter: { x: e, y: t },
    outerRadius: i,
    textureSpace: WS(n),
    colorStops: qS(n)
  });
}
function Fk(n) {
  const e = n.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
  return e ? e[1] : "";
}
const Nk = {
  // Fill properties
  fill: { type: "paint", default: 0 },
  // Fill color/gradient
  "fill-opacity": { type: "number", default: 1 },
  // Fill transparency
  // Stroke properties
  stroke: { type: "paint", default: 0 },
  // Stroke color/gradient
  "stroke-width": { type: "number", default: 1 },
  // Width of stroke
  "stroke-opacity": { type: "number", default: 1 },
  // Stroke transparency
  "stroke-linecap": { type: "string", default: "butt" },
  // End cap style: butt, round, square
  "stroke-linejoin": { type: "string", default: "miter" },
  // Join style: miter, round, bevel
  "stroke-miterlimit": { type: "number", default: 10 },
  // Limit on miter join sharpness
  "stroke-dasharray": { type: "string", default: "none" },
  // Dash pattern
  "stroke-dashoffset": { type: "number", default: 0 },
  // Offset for dash pattern
  // Global properties
  opacity: { type: "number", default: 1 }
  // Overall opacity
};
function KS(n, e) {
  const t = n.getAttribute("style"), i = {}, s = {}, o = {
    strokeStyle: i,
    fillStyle: s,
    useFill: !1,
    useStroke: !1
  };
  for (const r in Nk) {
    const a = n.getAttribute(r);
    a && Uk(e, o, r, a.trim());
  }
  if (t) {
    const r = t.split(";");
    for (let a = 0; a < r.length; a++) {
      const l = r[a].trim(), [d, c] = l.split(":");
      Nk[d] && Uk(e, o, d, c.trim());
    }
  }
  return {
    strokeStyle: o.useStroke ? i : null,
    fillStyle: o.useFill ? s : null,
    useFill: o.useFill,
    useStroke: o.useStroke
  };
}
function Uk(n, e, t, i) {
  switch (t) {
    case "stroke":
      if (i !== "none") {
        if (i.startsWith("url(")) {
          const s = Fk(i);
          e.strokeStyle.fill = n.defs[s];
        } else
          e.strokeStyle.color = pn.shared.setValue(i).toNumber();
        e.useStroke = !0;
      }
      break;
    case "stroke-width":
      e.strokeStyle.width = Number(i);
      break;
    case "fill":
      if (i !== "none") {
        if (i.startsWith("url(")) {
          const s = Fk(i);
          e.fillStyle.fill = n.defs[s];
        } else
          e.fillStyle.color = pn.shared.setValue(i).toNumber();
        e.useFill = !0;
      }
      break;
    case "fill-opacity":
      e.fillStyle.alpha = Number(i);
      break;
    case "stroke-opacity":
      e.strokeStyle.alpha = Number(i);
      break;
    case "opacity":
      e.fillStyle.alpha = Number(i), e.strokeStyle.alpha = Number(i);
      break;
  }
}
function SY(n) {
  if (n.length <= 2)
    return !0;
  const e = n.map((a) => a.area).sort((a, l) => l - a), [t, i] = e, s = e[e.length - 1], o = t / i, r = i / s;
  return !(o > 3 && r < 2);
}
function TY(n) {
  return n.split(/(?=[Mm])/).filter((i) => i.trim().length > 0);
}
function MY(n) {
  const e = n.match(/[-+]?[0-9]*\.?[0-9]+/g);
  if (!e || e.length < 4) return 0;
  const t = e.map(Number), i = [], s = [];
  for (let c = 0; c < t.length; c += 2)
    c + 1 < t.length && (i.push(t[c]), s.push(t[c + 1]));
  if (i.length === 0 || s.length === 0) return 0;
  const o = Math.min(...i), r = Math.max(...i), a = Math.min(...s), l = Math.max(...s);
  return (r - o) * (l - a);
}
function Gk(n, e) {
  const t = new Vs(n, !1);
  for (const i of t.instructions)
    e.instructions.push(i);
}
function CY(n, e) {
  if (typeof n == "string") {
    const r = document.createElement("div");
    r.innerHTML = n.trim(), n = r.querySelector("svg");
  }
  const t = {
    context: e,
    defs: {},
    path: new Vs()
  };
  wY(n, t);
  const i = n.children, { fillStyle: s, strokeStyle: o } = KS(n, t);
  for (let r = 0; r < i.length; r++) {
    const a = i[r];
    a.nodeName.toLowerCase() !== "defs" && YS(a, t, s, o);
  }
  return e;
}
function YS(n, e, t, i) {
  const s = n.children, { fillStyle: o, strokeStyle: r } = KS(n, e);
  o && t ? t = { ...t, ...o } : o && (t = o), r && i ? i = { ...i, ...r } : r && (i = r);
  const a = !t && !i;
  a && (t = { color: 0 });
  let l, d, c, u, p, f, y, b, w, k, S, _, x, T, M, z, P;
  switch (n.nodeName.toLowerCase()) {
    case "path": {
      T = n.getAttribute("d");
      const D = n.getAttribute("fill-rule"), $ = TY(T), O = D === "evenodd", L = $.length > 1;
      if (O && L) {
        const J = $.map((F) => ({
          path: F,
          area: MY(F)
        }));
        if (J.sort((F, W) => W.area - F.area), $.length > 3 || !SY(J))
          for (let F = 0; F < J.length; F++) {
            const W = J[F], ee = F === 0;
            e.context.beginPath();
            const N = new Vs(void 0, !0);
            Gk(W.path, N), e.context.path(N), ee ? (t && e.context.fill(t), i && e.context.stroke(i)) : e.context.cut();
          }
        else
          for (let F = 0; F < J.length; F++) {
            const W = J[F], ee = F % 2 === 1;
            e.context.beginPath();
            const N = new Vs(void 0, !0);
            Gk(W.path, N), e.context.path(N), ee ? e.context.cut() : (t && e.context.fill(t), i && e.context.stroke(i));
          }
      } else {
        const J = D ? D === "evenodd" : !0;
        M = new Vs(T, J), e.context.path(M), t && e.context.fill(t), i && e.context.stroke(i);
      }
      break;
    }
    case "circle":
      y = kn(n, "cx", 0), b = kn(n, "cy", 0), w = kn(n, "r", 0), e.context.ellipse(y, b, w, w), t && e.context.fill(t), i && e.context.stroke(i);
      break;
    case "rect":
      l = kn(n, "x", 0), d = kn(n, "y", 0), z = kn(n, "width", 0), P = kn(n, "height", 0), k = kn(n, "rx", 0), S = kn(n, "ry", 0), k || S ? e.context.roundRect(l, d, z, P, k || S) : e.context.rect(l, d, z, P), t && e.context.fill(t), i && e.context.stroke(i);
      break;
    case "ellipse":
      y = kn(n, "cx", 0), b = kn(n, "cy", 0), k = kn(n, "rx", 0), S = kn(n, "ry", 0), e.context.beginPath(), e.context.ellipse(y, b, k, S), t && e.context.fill(t), i && e.context.stroke(i);
      break;
    case "line":
      c = kn(n, "x1", 0), u = kn(n, "y1", 0), p = kn(n, "x2", 0), f = kn(n, "y2", 0), e.context.beginPath(), e.context.moveTo(c, u), e.context.lineTo(p, f), i && e.context.stroke(i);
      break;
    case "polygon":
      x = n.getAttribute("points"), _ = x.match(/-?\d+/g).map((D) => parseInt(D, 10)), e.context.poly(_, !0), t && e.context.fill(t), i && e.context.stroke(i);
      break;
    case "polyline":
      x = n.getAttribute("points"), _ = x.match(/-?\d+/g).map((D) => parseInt(D, 10)), e.context.poly(_, !1), i && e.context.stroke(i);
      break;
    // Group elements - just process children
    case "g":
    case "svg":
      break;
    default: {
      at(`[SVG parser] <${n.nodeName}> elements unsupported`);
      break;
    }
  }
  a && (t = null);
  for (let D = 0; D < s.length; D++)
    YS(s[D], e, t, i);
}
function IY(n) {
  return n.texture !== void 0;
}
const jk = {
  repeat: {
    addressModeU: "repeat",
    addressModeV: "repeat"
  },
  "repeat-x": {
    addressModeU: "repeat",
    addressModeV: "clamp-to-edge"
  },
  "repeat-y": {
    addressModeU: "clamp-to-edge",
    addressModeV: "repeat"
  },
  "no-repeat": {
    addressModeU: "clamp-to-edge",
    addressModeV: "clamp-to-edge"
  }
};
class XS {
  constructor(e, t) {
    var o;
    this.uid = Lt("fillPattern"), this._tick = 0, this.transform = new st();
    const i = IY(e) ? e : { texture: e, repetition: t };
    this.texture = i.texture, this.textureSpace = (o = i.textureSpace) != null ? o : "global";
    const s = i.repetition;
    s && (this.texture.source.style.addressModeU = jk[s].addressModeU, this.texture.source.style.addressModeV = jk[s].addressModeV);
  }
  /**
   * Sets the transform for the pattern
   * @param transform - The transform matrix to apply to the pattern.
   * If not provided, the pattern will use the default transform.
   */
  setTransform(e) {
    if (e) {
      if (this.transform.equals(e)) return;
      this.transform.copyFrom(e);
    } else {
      if (this.transform.isIdentity()) return;
      this.transform.identity();
    }
    this._tick++;
  }
  /** Internal texture used to render the gradient */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    this._texture !== e && (this._texture = e, this._tick++);
  }
  /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */
  get styleKey() {
    return `fill-pattern-${this.uid}-${this._tick}`;
  }
  /** Destroys the fill pattern, releasing resources. This will also destroy the internal texture. */
  destroy() {
    this.texture.destroy(!0), this.texture = null;
  }
}
function AY(n) {
  return pn.isColorLike(n);
}
function Hk(n) {
  return n instanceof XS;
}
function Vk(n) {
  return n instanceof Dl;
}
function PY(n) {
  return n instanceof Ze;
}
function EY(n, e, t) {
  const i = pn.shared.setValue(e != null ? e : 0);
  return n.color = i.toNumber(), n.alpha = i.alpha === 1 ? t.alpha : i.alpha, n.texture = Ze.WHITE, { ...t, ...n };
}
function RY(n, e, t) {
  return n.texture = e, { ...t, ...n };
}
function Wk(n, e, t) {
  return n.fill = e, n.color = 16777215, n.texture = e.texture, n.matrix = e.transform, n.textureSpace = e.textureSpace, { ...t, ...n };
}
function qk(n, e, t) {
  return e.buildGradient(), n.fill = e, n.color = 16777215, n.texture = e.texture, n.matrix = e.transform, n.textureSpace = e.textureSpace, { ...t, ...n };
}
function zY(n, e) {
  const t = { ...e, ...n }, i = pn.shared.setValue(t.color);
  return t.alpha *= i.alpha, t.color = i.toNumber(), t;
}
function zd(n, e) {
  if (n == null)
    return null;
  const t = {}, i = n;
  return AY(n) ? EY(t, n, e) : PY(n) ? RY(t, n, e) : Hk(n) ? Wk(t, n, e) : Vk(n) ? qk(t, n, e) : i.fill && Hk(i.fill) ? Wk(i, i.fill, e) : i.fill && Vk(i.fill) ? qk(i, i.fill, e) : zY(i, e);
}
function Kk(n, e) {
  const { width: t, alignment: i, miterLimit: s, cap: o, join: r, pixelLine: a, ...l } = e, d = zd(n, l);
  return d ? {
    width: t,
    alignment: i,
    miterLimit: s,
    cap: o,
    join: r,
    pixelLine: a,
    ...d
  } : null;
}
function $Y(n, e) {
  let t = 1;
  const i = n.shapePath.shapePrimitives;
  for (let s = 0; s < i.length; s++) {
    const o = i[s].shape;
    if (o.type !== "polygon") continue;
    const r = o.points, a = r.length;
    if (a < 6) continue;
    const l = o.closePath;
    for (let d = 0; d < a; d += 2) {
      if (!l && (d === 0 || d === a - 2)) continue;
      const c = (d - 2 + a) % a, u = (d + 2) % a, p = r[c], f = r[c + 1], y = r[d], b = r[d + 1], w = r[u], k = r[u + 1], S = p - y, _ = f - b, x = w - y, T = k - b, M = S * S + _ * _, z = x * x + T * T;
      if (M < 1e-12 || z < 1e-12) continue;
      let $ = (S * x + _ * T) / Math.sqrt(M * z);
      $ < -1 ? $ = -1 : $ > 1 && ($ = 1);
      const O = Math.sqrt((1 - $) * 0.5);
      if (O < 1e-6) continue;
      const L = Math.min(1 / O, e);
      L > t && (t = L);
    }
  }
  return t;
}
const DY = new Gt(), Yk = new st(), G1 = class Ji extends di {
  constructor() {
    super(...arguments), this._gpuData = /* @__PURE__ */ Object.create(null), this.autoGarbageCollect = !0, this._gcLastUsed = -1, this.uid = Lt("graphicsContext"), this.dirty = !0, this.batchMode = "auto", this.instructions = [], this.destroyed = !1, this._activePath = new Vs(), this._transform = new st(), this._fillStyle = { ...Ji.defaultFillStyle }, this._strokeStyle = { ...Ji.defaultStrokeStyle }, this._stateStack = [], this._tick = 0, this._bounds = new On(), this._boundsDirty = !0;
  }
  /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */
  clone() {
    const e = new Ji();
    return e.batchMode = this.batchMode, e.instructions = this.instructions.slice(), e._activePath = this._activePath.clone(), e._transform = this._transform.clone(), e._fillStyle = { ...this._fillStyle }, e._strokeStyle = { ...this._strokeStyle }, e._stateStack = this._stateStack.slice(), e._bounds = this._bounds.clone(), e._boundsDirty = !0, e;
  }
  /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */
  get fillStyle() {
    return this._fillStyle;
  }
  set fillStyle(e) {
    this._fillStyle = zd(e, Ji.defaultFillStyle);
  }
  /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */
  get strokeStyle() {
    return this._strokeStyle;
  }
  set strokeStyle(e) {
    this._strokeStyle = Kk(e, Ji.defaultStrokeStyle);
  }
  /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setFillStyle(e) {
    return this._fillStyle = zd(e, Ji.defaultFillStyle), this;
  }
  /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setStrokeStyle(e) {
    return this._strokeStyle = zd(e, Ji.defaultStrokeStyle), this;
  }
  texture(e, t, i, s, o, r) {
    return this.instructions.push({
      action: "texture",
      data: {
        image: e,
        dx: i || 0,
        dy: s || 0,
        dw: o || e.frame.width,
        dh: r || e.frame.height,
        transform: this._transform.clone(),
        alpha: this._fillStyle.alpha,
        style: t || t === 0 ? pn.shared.setValue(t).toNumber() : 16777215
      }
    }), this.onUpdate(), this;
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  beginPath() {
    return this._activePath = new Vs(), this;
  }
  fill(e, t) {
    let i;
    const s = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && (s == null ? void 0 : s.action) === "stroke" ? i = s.data.path : i = this._activePath.clone(), i ? (e != null && (t !== void 0 && typeof e == "number" && (rt(on, "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead"), e = { color: e, alpha: t }), this._fillStyle = zd(e, Ji.defaultFillStyle)), this.instructions.push({
      action: "fill",
      // TODO copy fill style!
      data: { style: this.fillStyle, path: i }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  _initNextPathLocation() {
    const { x: e, y: t } = this._activePath.getLastPoint(Gt.shared);
    this._activePath.clear(), this._activePath.moveTo(e, t);
  }
  /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  stroke(e) {
    let t;
    const i = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && (i == null ? void 0 : i.action) === "fill" ? t = i.data.path : t = this._activePath.clone(), t ? (e != null && (this._strokeStyle = Kk(e, Ji.defaultStrokeStyle)), this.instructions.push({
      action: "stroke",
      // TODO copy fill style!
      data: { style: this.strokeStyle, path: t }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  cut() {
    for (let e = 0; e < 2; e++) {
      const t = this.instructions[this.instructions.length - 1 - e], i = this._activePath.clone();
      if (t && (t.action === "stroke" || t.action === "fill"))
        if (t.data.hole)
          t.data.hole.addPath(i);
        else {
          t.data.hole = i;
          break;
        }
    }
    return this._initNextPathLocation(), this;
  }
  /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arc(e, t, i, s, o, r) {
    this._tick++;
    const a = this._transform;
    return this._activePath.arc(
      a.a * e + a.c * t + a.tx,
      a.b * e + a.d * t + a.ty,
      i,
      s,
      o,
      r
    ), this;
  }
  /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arcTo(e, t, i, s, o) {
    this._tick++;
    const r = this._transform;
    return this._activePath.arcTo(
      r.a * e + r.c * t + r.tx,
      r.b * e + r.d * t + r.ty,
      r.a * i + r.c * s + r.tx,
      r.b * i + r.d * s + r.ty,
      o
    ), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(e, t, i, s, o, r, a) {
    this._tick++;
    const l = this._transform;
    return this._activePath.arcToSvg(
      e,
      t,
      i,
      // should we rotate this with transform??
      s,
      o,
      l.a * r + l.c * a + l.tx,
      l.b * r + l.d * a + l.ty
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(e, t, i, s, o, r, a) {
    this._tick++;
    const l = this._transform;
    return this._activePath.bezierCurveTo(
      l.a * e + l.c * t + l.tx,
      l.b * e + l.d * t + l.ty,
      l.a * i + l.c * s + l.tx,
      l.b * i + l.d * s + l.ty,
      l.a * o + l.c * r + l.tx,
      l.b * o + l.d * r + l.ty,
      a
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    var e;
    return this._tick++, (e = this._activePath) == null || e.closePath(), this;
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */
  ellipse(e, t, i, s) {
    return this._tick++, this._activePath.ellipse(e, t, i, s, this._transform.clone()), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, i) {
    return this._tick++, this._activePath.circle(e, t, i, this._transform.clone()), this;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */
  path(e) {
    return this._tick++, this._activePath.addPath(e, this._transform.clone()), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(e, t) {
    this._tick++;
    const i = this._transform;
    return this._activePath.lineTo(
      i.a * e + i.c * t + i.tx,
      i.b * e + i.d * t + i.ty
    ), this;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(e, t) {
    this._tick++;
    const i = this._transform, s = this._activePath.instructions, o = i.a * e + i.c * t + i.tx, r = i.b * e + i.d * t + i.ty;
    return s.length === 1 && s[0].action === "moveTo" ? (s[0].data[0] = o, s[0].data[1] = r, this) : (this._activePath.moveTo(
      o,
      r
    ), this);
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(e, t, i, s, o) {
    this._tick++;
    const r = this._transform;
    return this._activePath.quadraticCurveTo(
      r.a * e + r.c * t + r.tx,
      r.b * e + r.d * t + r.ty,
      r.a * i + r.c * s + r.tx,
      r.b * i + r.d * s + r.ty,
      o
    ), this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, i, s) {
    return this._tick++, this._activePath.rect(e, t, i, s, this._transform.clone()), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */
  roundRect(e, t, i, s, o) {
    return this._tick++, this._activePath.roundRect(e, t, i, s, o, this._transform.clone()), this;
  }
  /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */
  poly(e, t) {
    return this._tick++, this._activePath.poly(e, t, this._transform.clone()), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(e, t, i, s, o = 0, r) {
    return this._tick++, this._activePath.regularPoly(e, t, i, s, o, r), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(e, t, i, s, o, r) {
    return this._tick++, this._activePath.roundPoly(e, t, i, s, o, r), this;
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(e, t, i, s) {
    return this._tick++, this._activePath.roundShape(e, t, i, s), this;
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(e, t, i, s, o) {
    return this._tick++, this._activePath.filletRect(e, t, i, s, o), this;
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(e, t, i, s, o, r) {
    return this._tick++, this._activePath.chamferRect(e, t, i, s, o, r), this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  star(e, t, i, s, o = 0, r = 0) {
    return this._tick++, this._activePath.star(e, t, i, s, o, r, this._transform.clone()), this;
  }
  /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */
  svg(e) {
    return this._tick++, CY(e, this), this;
  }
  /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */
  restore() {
    const e = this._stateStack.pop();
    return e && (this._transform = e.transform, this._fillStyle = e.fillStyle, this._strokeStyle = e.strokeStyle), this;
  }
  /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */
  save() {
    return this._stateStack.push({
      transform: this._transform.clone(),
      fillStyle: { ...this._fillStyle },
      strokeStyle: { ...this._strokeStyle }
    }), this;
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */
  getTransform() {
    return this._transform;
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  resetTransform() {
    return this._transform.identity(), this;
  }
  /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  rotate(e) {
    return this._transform.rotate(e), this;
  }
  /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  scale(e, t = e) {
    return this._transform.scale(e, t), this;
  }
  setTransform(e, t, i, s, o, r) {
    return e instanceof st ? (this._transform.set(e.a, e.b, e.c, e.d, e.tx, e.ty), this) : (this._transform.set(e, t, i, s, o, r), this);
  }
  transform(e, t, i, s, o, r) {
    return e instanceof st ? (this._transform.append(e), this) : (Yk.set(e, t, i, s, o, r), this._transform.append(Yk), this);
  }
  /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  translate(e, t = e) {
    return this._transform.translate(e, t), this;
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  clear() {
    return this._activePath.clear(), this.instructions.length = 0, this.resetTransform(), this.onUpdate(), this;
  }
  onUpdate() {
    this._boundsDirty = !0, this.dirty = !0, this.emit("update", this, 16);
  }
  /** The bounds of the graphic shape. */
  get bounds() {
    if (!this._boundsDirty) return this._bounds;
    this._boundsDirty = !1;
    const e = this._bounds;
    e.clear();
    for (let t = 0; t < this.instructions.length; t++) {
      const i = this.instructions[t], s = i.action;
      if (s === "fill") {
        const o = i.data;
        e.addBounds(o.path.bounds);
      } else if (s === "texture") {
        const o = i.data;
        e.addFrame(o.dx, o.dy, o.dx + o.dw, o.dy + o.dh, o.transform);
      }
      if (s === "stroke") {
        const o = i.data, r = o.style.alignment;
        let a = o.style.width * (1 - r);
        o.style.join === "miter" && (a *= $Y(o.path, o.style.miterLimit));
        const l = o.path.bounds;
        e.addFrame(
          l.minX - a,
          l.minY - a,
          l.maxX + a,
          l.maxY + a
        );
      }
    }
    return e.isValid || e.set(0, 0, 0, 0), e;
  }
  /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */
  containsPoint(e) {
    var s;
    if (!this.bounds.containsPoint(e.x, e.y)) return !1;
    const t = this.instructions;
    let i = !1;
    for (let o = 0; o < t.length; o++) {
      const r = t[o], a = r.data, l = a.path;
      if (!r.action || !l) continue;
      const d = a.style, c = l.shapePath.shapePrimitives;
      for (let u = 0; u < c.length; u++) {
        const p = c[u].shape;
        if (!d || !p) continue;
        const f = c[u].transform, y = f ? f.applyInverse(e, DY) : e;
        if (r.action === "fill")
          i = p.contains(y.x, y.y);
        else {
          const w = d;
          i = p.strokeContains(y.x, y.y, w.width, w.alignment);
        }
        const b = a.hole;
        if (b) {
          const w = (s = b.shapePath) == null ? void 0 : s.shapePrimitives;
          if (w)
            for (let k = 0; k < w.length; k++)
              w[k].shape.contains(y.x, y.y) && (i = !1);
        }
        if (i)
          return !0;
      }
    }
    return i;
  }
  /** Unloads the GPU data from the graphics context. */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null);
  }
  /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * context.destroy();
   * context.destroy(true);
   * context.destroy({ texture: true, textureSource: true });
   */
  destroy(e = !1) {
    if (this.destroyed) return;
    if (this.destroyed = !0, this._stateStack.length = 0, this._transform = null, this.unload(), this.emit("destroy", this), this.removeAllListeners(), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const i = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._fillStyle.texture && (this._fillStyle.fill && "uid" in this._fillStyle.fill ? this._fillStyle.fill.destroy() : this._fillStyle.texture.destroy(i)), this._strokeStyle.texture && (this._strokeStyle.fill && "uid" in this._strokeStyle.fill ? this._strokeStyle.fill.destroy() : this._strokeStyle.texture.destroy(i));
    }
    this._fillStyle = null, this._strokeStyle = null, this.instructions = null, this._activePath = null, this._bounds = null, this._stateStack = null, this.customShader = null, this._transform = null;
  }
};
G1.defaultFillStyle = {
  /** The color to use for the fill. */
  color: 16777215,
  /** The alpha value to use for the fill. */
  alpha: 1,
  /** The texture to use for the fill. */
  texture: Ze.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local"
};
G1.defaultStrokeStyle = {
  /** The width of the stroke. */
  width: 1,
  /** The color to use for the stroke. */
  color: 16777215,
  /** The alpha value to use for the stroke. */
  alpha: 1,
  /** The alignment of the stroke. */
  alignment: 0.5,
  /** The miter limit to use. */
  miterLimit: 10,
  /** The line cap style to use. */
  cap: "butt",
  /** The line join style to use. */
  join: "miter",
  /** The texture to use for the fill. */
  texture: Ze.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local",
  /** If the stroke is a pixel line. */
  pixelLine: !1
};
let sd = G1;
class JS {
  /**
   * Constructor for the DOMPipe class.
   * @param renderer - The renderer instance that this DOMPipe will be associated with.
   */
  constructor(e) {
    this._attachedDomElements = [], this._renderer = e, this._renderer.runners.postrender.add(this), this._renderer.runners.init.add(this), this._domElement = document.createElement("div"), this._domElement.style.position = "absolute", this._domElement.style.top = "0", this._domElement.style.left = "0", this._domElement.style.pointerEvents = "none", this._domElement.style.zIndex = "1000";
  }
  /** Initializes the DOMPipe, setting up the main DOM element and adding it to the document body. */
  init() {
    this._canvasObserver = new Q8({
      domElement: this._domElement,
      renderer: this._renderer
    });
  }
  /**
   * Adds a renderable DOM container to the list of attached elements.
   * @param domContainer - The DOM container to be added.
   * @param _instructionSet - The instruction set (unused).
   */
  addRenderable(e, t) {
    this._attachedDomElements.includes(e) || this._attachedDomElements.push(e);
  }
  /**
   * Updates a renderable DOM container.
   * @param _domContainer - The DOM container to be updated (unused).
   */
  updateRenderable(e) {
  }
  /**
   * Validates a renderable DOM container.
   * @param _domContainer - The DOM container to be validated (unused).
   * @returns Always returns true as validation is not required.
   */
  validateRenderable(e) {
    return !0;
  }
  /** Handles the post-rendering process, ensuring DOM elements are correctly positioned and visible. */
  postrender() {
    const e = this._attachedDomElements;
    if (e.length === 0) {
      this._domElement.remove();
      return;
    }
    this._canvasObserver.ensureAttached();
    for (let t = 0; t < e.length; t++) {
      const i = e[t], s = i.element;
      if (!i.parent || i.globalDisplayStatus < 7)
        s == null || s.remove(), e.splice(t, 1), t--;
      else {
        this._domElement.contains(s) || (s.style.position = "absolute", s.style.pointerEvents = "auto", this._domElement.appendChild(s));
        const o = i.worldTransform, r = i._anchor, a = i.width * r.x, l = i.height * r.y;
        s.style.transformOrigin = `${a}px ${l}px`, s.style.transform = `matrix(${o.a}, ${o.b}, ${o.c}, ${o.d}, ${o.tx - a}, ${o.ty - l})`, s.style.opacity = i.groupAlpha.toString();
      }
    }
  }
  /** Destroys the DOMPipe, removing all attached DOM elements and cleaning up resources. */
  destroy() {
    var e;
    this._renderer.runners.postrender.remove(this);
    for (let t = 0; t < this._attachedDomElements.length; t++)
      (e = this._attachedDomElements[t].element) == null || e.remove();
    this._attachedDomElements.length = 0, this._domElement.remove(), this._canvasObserver.destroy(), this._renderer = null;
  }
}
JS.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "dom"
};
class OY {
  constructor() {
    this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /**
   * Initializes the event ticker.
   * @param events - The event system.
   */
  init(e) {
    this.removeTickerListener(), this.events = e, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /** Whether to pause the update checks or not. */
  get pauseUpdate() {
    return this._pauseUpdate;
  }
  set pauseUpdate(e) {
    this._pauseUpdate = e;
  }
  /** Adds the ticker listener. */
  addTickerListener() {
    this._tickerAdded || !this.domElement || (Ci.system.add(this._tickerUpdate, this, bl.INTERACTION), this._tickerAdded = !0);
  }
  /** Removes the ticker listener. */
  removeTickerListener() {
    this._tickerAdded && (Ci.system.remove(this._tickerUpdate, this), this._tickerAdded = !1);
  }
  /** Sets flag to not fire extra events when the user has already moved there mouse */
  pointerMoved() {
    this._didMove = !0;
  }
  /** Updates the state of interactive objects. */
  _update() {
    if (!this.domElement || this._pauseUpdate)
      return;
    if (this._didMove) {
      this._didMove = !1;
      return;
    }
    const e = this.events._rootPointerEvent;
    this.events.supportsTouchEvents && e.pointerType === "touch" || globalThis.document.dispatchEvent(this.events.supportsPointerEvents ? new PointerEvent("pointermove", {
      clientX: e.clientX,
      clientY: e.clientY,
      pointerType: e.pointerType,
      pointerId: e.pointerId
    }) : new MouseEvent("mousemove", {
      clientX: e.clientX,
      clientY: e.clientY
    }));
  }
  /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link Ticker.system}.
   * @param ticker - The throttled ticker.
   */
  _tickerUpdate(e) {
    this._deltaTime += e.deltaTime, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this._update());
  }
  /** Destroys the event ticker. */
  destroy() {
    this.removeTickerListener(), this.events = null, this.domElement = null, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
}
const $s = new OY();
class Vp extends Yc {
  constructor() {
    super(...arguments), this.client = new Gt(), this.movement = new Gt(), this.offset = new Gt(), this.global = new Gt(), this.screen = new Gt();
  }
  /** @readonly */
  get clientX() {
    return this.client.x;
  }
  /** @readonly */
  get clientY() {
    return this.client.y;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */
  get x() {
    return this.clientX;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */
  get y() {
    return this.clientY;
  }
  /** @readonly */
  get movementX() {
    return this.movement.x;
  }
  /** @readonly */
  get movementY() {
    return this.movement.y;
  }
  /** @readonly */
  get offsetX() {
    return this.offset.x;
  }
  /** @readonly */
  get offsetY() {
    return this.offset.y;
  }
  /** @readonly */
  get globalX() {
    return this.global.x;
  }
  /** @readonly */
  get globalY() {
    return this.global.y;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.x`.
   * @readonly
   */
  get screenX() {
    return this.screen.x;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.y`.
   * @readonly
   */
  get screenY() {
    return this.screen.y;
  }
  /**
   * Converts global coordinates into container-local coordinates.
   *
   * This method transforms coordinates from world space to a container's local space,
   * useful for precise positioning and hit testing.
   * @param container - The Container to get local coordinates for
   * @param point - Optional Point object to store the result. If not provided, a new Point will be created
   * @param globalPos - Optional custom global coordinates. If not provided, the event's global position is used
   * @returns The local coordinates as a Point object
   * @example
   * ```ts
   * // Basic usage - get local coordinates relative to a container
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Get position relative to the sprite
   *     const localPos = event.getLocalPosition(sprite);
   *     console.log('Local position:', localPos.x, localPos.y);
   * });
   * // Using custom global coordinates
   * const customGlobal = new Point(100, 100);
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Transform custom coordinates
   *     const localPos = event.getLocalPosition(sprite, undefined, customGlobal);
   *     console.log('Custom local position:', localPos.x, localPos.y);
   * });
   * ```
   * @see {@link Container.worldTransform} For the transformation matrix
   * @see {@link Point} For the point class used to store coordinates
   */
  getLocalPosition(e, t, i) {
    return e.worldTransform.applyInverse(i || this.global, t);
  }
  /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */
  getModifierState(e) {
    return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(e);
  }
  /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   * @ignore
   */
  // eslint-disable-next-line max-params
  initMouseEvent(e, t, i, s, o, r, a, l, d, c, u, p, f, y, b) {
    throw new Error("Method not implemented.");
  }
}
class mi extends Vp {
  constructor() {
    super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1, this.persistentDeviceId = 0;
  }
  /**
   * Only included for completeness for now
   * @ignore
   */
  getCoalescedEvents() {
    return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [this] : [];
  }
  /**
   * Only included for completeness for now
   * @ignore
   */
  getPredictedEvents() {
    throw new Error("getPredictedEvents is not supported!");
  }
}
class yl extends Vp {
  constructor() {
    super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
  }
}
yl.DOM_DELTA_PIXEL = 0;
yl.DOM_DELTA_LINE = 1;
yl.DOM_DELTA_PAGE = 2;
const LY = 2048, BY = new Gt(), od = new Gt();
class FY {
  /**
   * @param rootTarget - The holder of the event boundary.
   */
  constructor(e) {
    this.dispatch = new di(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
      trackingData: {}
    }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = e, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mapContextMenu = this.mapContextMenu.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel), this.addEventMapping("contextmenu", this.mapContextMenu);
  }
  /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */
  addEventMapping(e, t) {
    this.mappingTable[e] || (this.mappingTable[e] = []), this.mappingTable[e].push({
      fn: t,
      priority: 0
    }), this.mappingTable[e].sort((i, s) => i.priority - s.priority);
  }
  /**
   * Dispatches the given event
   * @param e - The event to dispatch.
   * @param type - The type of event to dispatch. Defaults to `e.type`.
   */
  dispatchEvent(e, t) {
    e.propagationStopped = !1, e.propagationImmediatelyStopped = !1, this.propagate(e, t), this.dispatch.emit(t || e.type, e);
  }
  /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e - The event to map.
   */
  mapEvent(e) {
    if (!this.rootTarget)
      return;
    const t = this.mappingTable[e.type];
    if (t)
      for (let i = 0, s = t.length; i < s; i++)
        t[i].fn(e);
    else
      at(`[EventBoundary]: Event mapping not defined for ${e.type}`);
  }
  /**
   * Finds the Container that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x - The x coordinate of the event.
   * @param y - The y coordinate of the event.
   */
  hitTest(e, t) {
    $s.pauseUpdate = !0;
    const s = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", o = this[s](
      this.rootTarget,
      this.rootTarget.eventMode,
      BY.set(e, t),
      this.hitTestFn,
      this.hitPruneFn
    );
    return o && o[0];
  }
  /**
   * Propagate the passed event from from {@link EventBoundary.rootTarget this.rootTarget} to its
   * target `e.target`.
   * @param e - The event to propagate.
   * @param type - The type of event to propagate. Defaults to `e.type`.
   */
  propagate(e, t) {
    if (!e.target)
      return;
    const i = e.composedPath();
    e.eventPhase = e.CAPTURING_PHASE;
    for (let s = 0, o = i.length - 1; s < o; s++)
      if (e.currentTarget = i[s], this.notifyTarget(e, t), e.propagationStopped || e.propagationImmediatelyStopped) return;
    if (e.eventPhase = e.AT_TARGET, e.currentTarget = e.target, this.notifyTarget(e, t), !(e.propagationStopped || e.propagationImmediatelyStopped)) {
      e.eventPhase = e.BUBBLING_PHASE;
      for (let s = i.length - 2; s >= 0; s--)
        if (e.currentTarget = i[s], this.notifyTarget(e, t), e.propagationStopped || e.propagationImmediatelyStopped) return;
    }
  }
  /**
   * Emits the event `e` to all interactive containers. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */
  all(e, t, i = this._allInteractiveElements) {
    if (i.length === 0) return;
    e.eventPhase = e.BUBBLING_PHASE;
    const s = Array.isArray(t) ? t : [t];
    for (let o = i.length - 1; o >= 0; o--)
      s.forEach((r) => {
        e.currentTarget = i[o], this.notifyTarget(e, r);
      });
  }
  /**
   * Finds the propagation path from {@link EventBoundary.rootTarget rootTarget} to the passed
   * `target`. The last element in the path is `target`.
   * @param target - The target to find the propagation path to.
   */
  propagationPath(e) {
    const t = [e];
    for (let i = 0; i < LY && e !== this.rootTarget && e.parent; i++) {
      if (!e.parent)
        throw new Error("Cannot find propagation path to disconnected target");
      t.push(e.parent), e = e.parent;
    }
    return t.reverse(), t;
  }
  hitTestMoveRecursive(e, t, i, s, o, r = !1) {
    let a = !1;
    if (this._interactivePrune(e)) return null;
    if ((e.eventMode === "dynamic" || t === "dynamic") && ($s.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const c = e.children;
      for (let u = c.length - 1; u >= 0; u--) {
        const p = c[u], f = this.hitTestMoveRecursive(
          p,
          this._isInteractive(t) ? t : p.eventMode,
          i,
          s,
          o,
          r || o(e, i)
        );
        if (f) {
          if (f.length > 0 && !f[f.length - 1].parent)
            continue;
          const y = e.isInteractive();
          (f.length > 0 || y) && (y && this._allInteractiveElements.push(e), f.push(e)), this._hitElements.length === 0 && (this._hitElements = f), a = !0;
        }
      }
    }
    const l = this._isInteractive(t), d = e.isInteractive();
    return d && d && this._allInteractiveElements.push(e), r || this._hitElements.length > 0 ? null : a ? this._hitElements : l && !o(e, i) && s(e, i) ? d ? [e] : [] : null;
  }
  /**
   * Recursive implementation for {@link EventBoundary.hitTest hitTest}.
   * @param currentTarget - The Container that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the container.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */
  hitTestRecursive(e, t, i, s, o) {
    if (this._interactivePrune(e) || o(e, i))
      return null;
    if ((e.eventMode === "dynamic" || t === "dynamic") && ($s.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const l = e.children, d = i;
      for (let c = l.length - 1; c >= 0; c--) {
        const u = l[c], p = this.hitTestRecursive(
          u,
          this._isInteractive(t) ? t : u.eventMode,
          d,
          s,
          o
        );
        if (p) {
          if (p.length > 0 && !p[p.length - 1].parent)
            continue;
          const f = e.isInteractive();
          return (p.length > 0 || f) && p.push(e), p;
        }
      }
    }
    const r = this._isInteractive(t), a = e.isInteractive();
    return r && s(e, i) ? a ? [e] : [] : null;
  }
  _isInteractive(e) {
    return e === "static" || e === "dynamic";
  }
  _interactivePrune(e) {
    return !e || !e.visible || !e.renderable || !e.measurable || e.eventMode === "none" || e.eventMode === "passive" && !e.interactiveChildren;
  }
  /**
   * Checks whether the container or any of its children cannot pass the hit test at all.
   *
   * {@link EventBoundary}'s implementation uses the {@link Container.hitArea hitArea}
   * and {@link Container._maskEffect} for pruning.
   * @param container - The container to prune.
   * @param location - The location to test for overlap.
   */
  hitPruneFn(e, t) {
    if (e.hitArea && (e.worldTransform.applyInverse(t, od), !e.hitArea.contains(od.x, od.y)))
      return !0;
    if (e.effects && e.effects.length)
      for (let i = 0; i < e.effects.length; i++) {
        const s = e.effects[i];
        if (s.containsPoint && !s.containsPoint(t, this.hitTestFn))
          return !0;
      }
    return !1;
  }
  /**
   * Checks whether the container passes hit testing for the given location.
   * @param container - The container to test.
   * @param location - The location to test for overlap.
   * @returns - Whether `container` passes hit testing for `location`.
   */
  hitTestFn(e, t) {
    return e.hitArea ? !0 : e != null && e.containsPoint ? (e.worldTransform.applyInverse(t, od), e.containsPoint(od)) : !1;
  }
  /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type - The type of event to notify. Defaults to `e.type`.
   */
  notifyTarget(e, t) {
    var o, r;
    if (!e.currentTarget.isInteractive())
      return;
    t != null || (t = e.type);
    const i = `on${t}`;
    (r = (o = e.currentTarget)[i]) == null || r.call(o, e);
    const s = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${t}capture` : t;
    this._notifyListeners(e, s), e.eventPhase === e.AT_TARGET && this._notifyListeners(e, t);
  }
  /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from - The upstream `pointerdown` event.
   */
  mapPointerDown(e) {
    if (!(e instanceof mi)) {
      at("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.createPointerEvent(e);
    if (this.dispatchEvent(t, "pointerdown"), t.pointerType === "touch")
      this.dispatchEvent(t, "touchstart");
    else if (t.pointerType === "mouse" || t.pointerType === "pen") {
      const s = t.button === 2;
      this.dispatchEvent(t, s ? "rightdown" : "mousedown");
    }
    const i = this.trackingData(e.pointerId);
    i.pressTargetsByButton[e.button] = t.composedPath(), this.freeEvent(t);
  }
  /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */
  mapPointerMove(e) {
    var l, d, c;
    if (!(e instanceof mi)) {
      at("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
    const t = this.createPointerEvent(e);
    this._isPointerMoveEvent = !1;
    const i = t.pointerType === "mouse" || t.pointerType === "pen", s = this.trackingData(e.pointerId), o = this.findMountedTarget(s.overTargets);
    if (((l = s.overTargets) == null ? void 0 : l.length) > 0 && o !== t.target) {
      const u = e.type === "mousemove" ? "mouseout" : "pointerout", p = this.createPointerEvent(e, u, o);
      if (this.dispatchEvent(p, "pointerout"), i && this.dispatchEvent(p, "mouseout"), !t.composedPath().includes(o)) {
        const f = this.createPointerEvent(e, "pointerleave", o);
        for (f.eventPhase = f.AT_TARGET; f.target && !t.composedPath().includes(f.target); )
          f.currentTarget = f.target, this.notifyTarget(f), i && this.notifyTarget(f, "mouseleave"), f.target = f.target.parent;
        this.freeEvent(f);
      }
      this.freeEvent(p);
    }
    if (o !== t.target) {
      const u = e.type === "mousemove" ? "mouseover" : "pointerover", p = this.clonePointerEvent(t, u);
      this.dispatchEvent(p, "pointerover"), i && this.dispatchEvent(p, "mouseover");
      let f = o == null ? void 0 : o.parent;
      for (; f && f !== this.rootTarget.parent && f !== t.target; )
        f = f.parent;
      if (!f || f === this.rootTarget.parent) {
        const b = this.clonePointerEvent(t, "pointerenter");
        for (b.eventPhase = b.AT_TARGET; b.target && b.target !== o && b.target !== this.rootTarget.parent; )
          b.currentTarget = b.target, this.notifyTarget(b), i && this.notifyTarget(b, "mouseenter"), b.target = b.target.parent;
        this.freeEvent(b);
      }
      this.freeEvent(p);
    }
    const r = [], a = (d = this.enableGlobalMoveEvents) != null ? d : !0;
    this.moveOnAll ? r.push("pointermove") : this.dispatchEvent(t, "pointermove"), a && r.push("globalpointermove"), t.pointerType === "touch" && (this.moveOnAll ? r.splice(1, 0, "touchmove") : this.dispatchEvent(t, "touchmove"), a && r.push("globaltouchmove")), i && (this.moveOnAll ? r.splice(1, 0, "mousemove") : this.dispatchEvent(t, "mousemove"), a && r.push("globalmousemove"), this.cursor = (c = t.target) == null ? void 0 : c.cursor), r.length > 0 && this.all(t, r), this._allInteractiveElements.length = 0, this._hitElements.length = 0, s.overTargets = t.composedPath(), this.freeEvent(t);
  }
  /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */
  mapPointerOver(e) {
    var r;
    if (!(e instanceof mi)) {
      at("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId), i = this.createPointerEvent(e), s = i.pointerType === "mouse" || i.pointerType === "pen";
    this.dispatchEvent(i, "pointerover"), s && this.dispatchEvent(i, "mouseover"), i.pointerType === "mouse" && (this.cursor = (r = i.target) == null ? void 0 : r.cursor);
    const o = this.clonePointerEvent(i, "pointerenter");
    for (o.eventPhase = o.AT_TARGET; o.target && o.target !== this.rootTarget.parent; )
      o.currentTarget = o.target, this.notifyTarget(o), s && this.notifyTarget(o, "mouseenter"), o.target = o.target.parent;
    t.overTargets = i.composedPath(), this.freeEvent(i), this.freeEvent(o);
  }
  /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */
  mapPointerOut(e) {
    if (!(e instanceof mi)) {
      at("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId);
    if (t.overTargets) {
      const i = e.pointerType === "mouse" || e.pointerType === "pen", s = this.findMountedTarget(t.overTargets), o = this.createPointerEvent(e, "pointerout", s);
      this.dispatchEvent(o), i && this.dispatchEvent(o, "mouseout");
      const r = this.createPointerEvent(e, "pointerleave", s);
      for (r.eventPhase = r.AT_TARGET; r.target && r.target !== this.rootTarget.parent; )
        r.currentTarget = r.target, this.notifyTarget(r), i && this.notifyTarget(r, "mouseleave"), r.target = r.target.parent;
      t.overTargets = null, this.freeEvent(o), this.freeEvent(r);
    }
    this.cursor = null;
  }
  /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */
  mapPointerUp(e) {
    if (!(e instanceof mi)) {
      at("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = performance.now(), i = this.createPointerEvent(e);
    if (this.dispatchEvent(i, "pointerup"), i.pointerType === "touch")
      this.dispatchEvent(i, "touchend");
    else if (i.pointerType === "mouse" || i.pointerType === "pen") {
      const a = i.button === 2;
      this.dispatchEvent(i, a ? "rightup" : "mouseup");
    }
    const s = this.trackingData(e.pointerId), o = this.findMountedTarget(s.pressTargetsByButton[e.button]);
    let r = o;
    if (o && !i.composedPath().includes(o)) {
      let a = o;
      for (; a && !i.composedPath().includes(a); ) {
        if (i.currentTarget = a, this.notifyTarget(i, "pointerupoutside"), i.pointerType === "touch")
          this.notifyTarget(i, "touchendoutside");
        else if (i.pointerType === "mouse" || i.pointerType === "pen") {
          const l = i.button === 2;
          this.notifyTarget(i, l ? "rightupoutside" : "mouseupoutside");
        }
        a = a.parent;
      }
      delete s.pressTargetsByButton[e.button], r = a;
    }
    if (r) {
      const a = this.clonePointerEvent(i, "click");
      a.target = r, a.path = null, s.clicksByButton[e.button] || (s.clicksByButton[e.button] = {
        clickCount: 0,
        target: a.target,
        timeStamp: t
      });
      const l = s.clicksByButton[e.button];
      if (l.target === a.target && t - l.timeStamp < 200 ? ++l.clickCount : l.clickCount = 1, l.target = a.target, l.timeStamp = t, a.detail = l.clickCount, a.pointerType === "mouse") {
        const d = a.button === 2;
        this.dispatchEvent(a, d ? "rightclick" : "click");
      } else a.pointerType === "touch" && this.dispatchEvent(a, "tap");
      this.dispatchEvent(a, "pointertap"), this.freeEvent(a);
    }
    this.freeEvent(i);
  }
  /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */
  mapPointerUpOutside(e) {
    if (!(e instanceof mi)) {
      at("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId), i = this.findMountedTarget(t.pressTargetsByButton[e.button]), s = this.createPointerEvent(e);
    if (i) {
      let o = i;
      for (; o; )
        s.currentTarget = o, this.notifyTarget(s, "pointerupoutside"), s.pointerType === "touch" ? this.notifyTarget(s, "touchendoutside") : (s.pointerType === "mouse" || s.pointerType === "pen") && this.notifyTarget(s, s.button === 2 ? "rightupoutside" : "mouseupoutside"), o = o.parent;
      delete t.pressTargetsByButton[e.button];
    }
    this.freeEvent(s);
  }
  /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */
  mapWheel(e) {
    if (!(e instanceof yl)) {
      at("EventBoundary cannot map a non-wheel event as a wheel event");
      return;
    }
    const t = this.createWheelEvent(e);
    this.dispatchEvent(t), this.freeEvent(t);
  }
  /**
   * Maps the upstream `contextmenu` event to a downstream `contextmenu` event.
   * @param from - The upstream `contextmenu` event.
   */
  mapContextMenu(e) {
    if (!(e instanceof mi)) {
      at("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.createPointerEvent(e);
    this.dispatchEvent(t, "contextmenu"), this.freeEvent(t);
  }
  /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */
  findMountedTarget(e) {
    if (!e)
      return null;
    let t = e[0];
    for (let i = 1; i < e.length && e[i].parent === t; i++)
      t = e[i];
    return t;
  }
  /**
   * Creates an event whose `originalEvent` is `from`, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The `originalEvent` for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */
  createPointerEvent(e, t, i) {
    var o;
    const s = this.allocateEvent(mi);
    return this.copyPointerData(e, s), this.copyMouseData(e, s), this.copyData(e, s), s.nativeEvent = e.nativeEvent, s.originalEvent = e, s.target = (o = i != null ? i : this.hitTest(s.global.x, s.global.y)) != null ? o : this._hitElements[0], typeof t == "string" && (s.type = t), s;
  }
  /**
   * Creates a wheel event whose `originalEvent` is `from`.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */
  createWheelEvent(e) {
    const t = this.allocateEvent(yl);
    return this.copyWheelData(e, t), this.copyMouseData(e, t), this.copyData(e, t), t.nativeEvent = e.nativeEvent, t.originalEvent = e, t.target = this.hitTest(t.global.x, t.global.y), t;
  }
  /**
   * Clones the event `from`, with an optional `type` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */
  clonePointerEvent(e, t) {
    const i = this.allocateEvent(mi);
    return i.nativeEvent = e.nativeEvent, i.originalEvent = e.originalEvent, this.copyPointerData(e, i), this.copyMouseData(e, i), this.copyData(e, i), i.target = e.target, i.path = e.composedPath().slice(), i.type = t != null ? t : i.type, i;
  }
  /**
   * Copies wheel {@link FederatedWheelEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyWheelData(e, t) {
    t.deltaMode = e.deltaMode, t.deltaX = e.deltaX, t.deltaY = e.deltaY, t.deltaZ = e.deltaZ;
  }
  /**
   * Copies pointer {@link FederatedPointerEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyPointerData(e, t) {
    e instanceof mi && t instanceof mi && (t.pointerId = e.pointerId, t.width = e.width, t.height = e.height, t.isPrimary = e.isPrimary, t.pointerType = e.pointerType, t.pressure = e.pressure, t.tangentialPressure = e.tangentialPressure, t.tiltX = e.tiltX, t.tiltY = e.tiltY, t.twist = e.twist, t.persistentDeviceId = e.persistentDeviceId);
  }
  /**
   * Copies mouse {@link FederatedMouseEvent} data from `from` to `to`.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyMouseData(e, t) {
    e instanceof Vp && t instanceof Vp && (t.altKey = e.altKey, t.button = e.button, t.buttons = e.buttons, t.client.copyFrom(e.client), t.ctrlKey = e.ctrlKey, t.metaKey = e.metaKey, t.movement.copyFrom(e.movement), t.screen.copyFrom(e.screen), t.shiftKey = e.shiftKey, t.global.copyFrom(e.global));
  }
  /**
   * Copies base {@link FederatedEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyData(e, t) {
    t.isTrusted = e.isTrusted, t.srcElement = e.srcElement, t.timeStamp = performance.now(), t.type = e.type, t.detail = e.detail, t.view = e.view, t.which = e.which, t.layer.copyFrom(e.layer), t.page.copyFrom(e.page);
  }
  /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */
  trackingData(e) {
    return this.mappingState.trackingData[e] || (this.mappingState.trackingData[e] = {
      pressTargetsByButton: {},
      clicksByButton: {},
      overTarget: null
    }), this.mappingState.trackingData[e];
  }
  /**
   * Allocate a specific type of event from {@link EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   * @returns An event of the given type.
   */
  allocateEvent(e) {
    this.eventPool.has(e) || this.eventPool.set(e, []);
    const t = this.eventPool.get(e).pop() || new e(this);
    return t.eventPhase = t.NONE, t.currentTarget = null, t.defaultPrevented = !1, t.path = null, t.target = null, t;
  }
  /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */
  freeEvent(e) {
    if (e.manager !== this) throw new Error("It is illegal to free an event not managed by this EventBoundary!");
    const t = e.constructor;
    this.eventPool.has(t) || this.eventPool.set(t, []), this.eventPool.get(t).push(e);
  }
  /**
   * Similar to {@link EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */
  _notifyListeners(e, t) {
    const i = e.currentTarget._events[t];
    if (i)
      if ("fn" in i)
        i.once && e.currentTarget.removeListener(t, i.fn, void 0, !0), i.fn.call(i.context, e);
      else
        for (let s = 0, o = i.length; s < o && !e.propagationImmediatelyStopped; s++)
          i[s].once && e.currentTarget.removeListener(t, i[s].fn, void 0, !0), i[s].fn.call(i[s].context, e);
  }
}
const NY = 1, UY = {
  touchstart: "pointerdown",
  touchend: "pointerup",
  touchendoutside: "pointerupoutside",
  touchmove: "pointermove",
  touchcancel: "pointercancel"
}, j1 = class Bv {
  /**
   * @param {Renderer} renderer
   */
  constructor(e) {
    this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = e, this.rootBoundary = new FY(null), $s.init(this), this.autoPreventDefault = !0, this._eventsAdded = !1, this._rootPointerEvent = new mi(null), this._rootWheelEvent = new yl(null), this._rootContextMenuEvent = new mi(null), this.cursorStyles = {
      default: "inherit",
      pointer: "pointer"
    }, this.features = new Proxy({ ...Bv.defaultEventFeatures }, {
      set: (t, i, s) => (i === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = s), t[i] = s, !0)
    }), this._onPointerDown = this._onPointerDown.bind(this), this._onPointerMove = this._onPointerMove.bind(this), this._onPointerUp = this._onPointerUp.bind(this), this._onPointerOverOut = this._onPointerOverOut.bind(this), this._onContextMenu = this._onContextMenu.bind(this), this.onWheel = this.onWheel.bind(this);
  }
  /**
   * The default interaction mode for all display objects.
   * @see Container.eventMode
   * @type {EventMode}
   * @readonly
   * @since 7.2.0
   */
  static get defaultEventMode() {
    return this._defaultEventMode;
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(e) {
    var s, o;
    const { canvas: t, resolution: i } = this.renderer;
    this.setTargetElement(t), this.resolution = i, Bv._defaultEventMode = (s = e.eventMode) != null ? s : "passive", Object.assign(this.features, (o = e.eventFeatures) != null ? o : {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
  }
  /**
   * Handle changing resolution.
   * @ignore
   */
  resolutionChange(e) {
    this.resolution = e;
  }
  /** Destroys all event listeners and detaches the renderer. */
  destroy() {
    $s.destroy(), this.setTargetElement(null), this.renderer = null, this._currentCursor = null;
  }
  /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * The cursor can be a CSS cursor string, a custom callback function, or a key from the cursorStyles dictionary.
   * @param mode - Cursor mode to set. Can be:
   * - A CSS cursor string (e.g., 'pointer', 'grab')
   * - A key from the cursorStyles dictionary
   * - null/undefined to reset to default
   * @example
   * ```ts
   * // Using predefined cursor styles
   * app.renderer.events.setCursor('pointer');    // Set standard pointer cursor
   * app.renderer.events.setCursor('grab');       // Set grab cursor
   * app.renderer.events.setCursor(null);         // Reset to default
   *
   * // Using custom cursor styles
   * app.renderer.events.cursorStyles.custom = 'url("cursor.png"), auto';
   * app.renderer.events.setCursor('custom');     // Apply custom cursor
   *
   * // Using callback-based cursor
   * app.renderer.events.cursorStyles.dynamic = (mode) => {
   *     document.body.style.cursor = mode === 'hover' ? 'pointer' : 'default';
   * };
   * app.renderer.events.setCursor('dynamic');    // Trigger cursor callback
   * ```
   * @remarks
   * - Has no effect on OffscreenCanvas except for callback-based cursors
   * - Caches current cursor to avoid unnecessary DOM updates
   * - Supports CSS cursor values, style objects, and callback functions
   * @see {@link EventSystem.cursorStyles} For defining custom cursor styles
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/cursor} MDN Cursor Reference
   */
  setCursor(e) {
    e || (e = "default");
    let t = !0;
    if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (t = !1), this._currentCursor === e)
      return;
    this._currentCursor = e;
    const i = this.cursorStyles[e];
    if (i)
      switch (typeof i) {
        case "string":
          t && (this.domElement.style.cursor = i);
          break;
        case "function":
          i(e);
          break;
        case "object":
          t && Object.assign(this.domElement.style, i);
          break;
      }
    else t && typeof e == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, e) && (this.domElement.style.cursor = e);
  }
  /**
   * The global pointer event instance containing the most recent pointer state.
   * This is useful for accessing pointer information without listening to events.
   * @example
   * ```ts
   * // Access current pointer position at any time
   * const eventSystem = app.renderer.events;
   * const pointer = eventSystem.pointer;
   *
   * // Get global coordinates
   * console.log('Position:', pointer.global.x, pointer.global.y);
   *
   * // Check button state
   * console.log('Buttons pressed:', pointer.buttons);
   *
   * // Get pointer type and pressure
   * console.log('Type:', pointer.pointerType);
   * console.log('Pressure:', pointer.pressure);
   * ```
   * @readonly
   * @since 7.2.0
   * @see {@link FederatedPointerEvent} For all available pointer properties
   */
  get pointer() {
    return this._rootPointerEvent;
  }
  /**
   * Event handler for pointer down events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerDown(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    this.autoPreventDefault && t[0].isNormalized && (e.cancelable || !("cancelable" in e)) && e.preventDefault();
    for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i], r = this._bootstrapEvent(this._rootPointerEvent, o);
      this.rootBoundary.mapEvent(r);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer move events on on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */
  _onPointerMove(e) {
    if (!this.features.move) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, $s.pointerMoved();
    const t = this._normalizeToPointerData(e);
    for (let i = 0, s = t.length; i < s; i++) {
      const o = this._bootstrapEvent(this._rootPointerEvent, t[i]);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer up events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerUp(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    let t = e.target;
    e.composedPath && e.composedPath().length > 0 && (t = e.composedPath()[0]);
    const i = t !== this.domElement ? "outside" : "", s = this._normalizeToPointerData(e);
    for (let o = 0, r = s.length; o < r; o++) {
      const a = this._bootstrapEvent(this._rootPointerEvent, s[o]);
      a.type += i, this.rootBoundary.mapEvent(a);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer over & out events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerOverOut(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    for (let i = 0, s = t.length; i < s; i++) {
      const o = this._bootstrapEvent(this._rootPointerEvent, t[i]);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for `contextmenu` events on {@link EventSystem#domElement this.domElement}.
   *
   * {@link EventSystem#autoPreventDefault autoPreventDefault} does not apply, so the browser menu
   * opens unless a listener calls `preventDefault()`.
   * @param nativeEvent - The native mouse/pointer event.
   */
  _onContextMenu(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    for (let i = 0, s = t.length; i < s; i++) {
      const o = this._bootstrapEvent(this._rootContextMenuEvent, t[i]);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Passive handler for `wheel` events on {@link EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */
  onWheel(e) {
    if (!this.features.wheel) return;
    const t = this.normalizeWheelEvent(e);
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(t);
  }
  /**
   * Sets the {@link EventSystem#domElement domElement} and binds event listeners.
   * This method manages the DOM event bindings for the event system, allowing you to
   * change or remove the target element that receives input events.
   * > [!IMPORTANT] This will default to the canvas element of the renderer, so you
   * > should not need to call this unless you are using a custom element.
   * @param element - The new DOM element to bind events to, or null to remove all event bindings
   * @example
   * ```ts
   * // Set a new canvas element as the target
   * const canvas = document.createElement('canvas');
   * app.renderer.events.setTargetElement(canvas);
   *
   * // Remove all event bindings
   * app.renderer.events.setTargetElement(null);
   *
   * // Switch to a different canvas
   * const newCanvas = document.querySelector('#game-canvas');
   * app.renderer.events.setTargetElement(newCanvas);
   * ```
   * @remarks
   * - Automatically removes event listeners from previous element
   * - Required for the event system to function
   * - Safe to call multiple times
   * @see {@link EventSystem#domElement} The current DOM element
   * @see {@link EventsTicker} For the ticker system that tracks pointer movement
   */
  setTargetElement(e) {
    this._removeEvents(), this.domElement = e, $s.domElement = e, this._addEvents();
  }
  /** Register event listeners on {@link Renderer#domElement this.domElement}. */
  _addEvents() {
    if (this._eventsAdded || !this.domElement)
      return;
    $s.addTickerListener();
    const e = this.domElement.style;
    e && (globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "none", e.msTouchAction = "none") : this.supportsPointerEvents && (e.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this._onPointerMove, !0), this.domElement.addEventListener("pointerdown", this._onPointerDown, !0), this.domElement.addEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this._onPointerOverOut, !0), globalThis.addEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this._onPointerMove, !0), this.domElement.addEventListener("mousedown", this._onPointerDown, !0), this.domElement.addEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this._onPointerOverOut, !0), globalThis.addEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this._onPointerDown, !0), this.domElement.addEventListener("touchend", this._onPointerUp, !0), this.domElement.addEventListener("touchmove", this._onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
      passive: !0,
      capture: !0
    }), this.domElement.addEventListener("contextmenu", this._onContextMenu, !0), this._eventsAdded = !0;
  }
  /** Unregister event listeners on {@link EventSystem#domElement this.domElement}. */
  _removeEvents() {
    if (!this._eventsAdded || !this.domElement)
      return;
    $s.removeTickerListener();
    const e = this.domElement.style;
    e && (globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "", e.msTouchAction = "") : this.supportsPointerEvents && (e.touchAction = "")), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this._onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this._onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this._onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this._onPointerMove, !0), this.domElement.removeEventListener("mousedown", this._onPointerDown, !0), this.domElement.removeEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this._onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this._onPointerDown, !0), this.domElement.removeEventListener("touchend", this._onPointerUp, !0), this.domElement.removeEventListener("touchmove", this._onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement.removeEventListener("contextmenu", this._onContextMenu, !0), this.domElement = null, this._eventsAdded = !1;
  }
  /**
   * Maps coordinates from DOM/screen space into PixiJS normalized coordinates.
   * This takes into account the current scale, position, and resolution of the DOM element.
   * @param point - The point to store the mapped coordinates in
   * @param x - The x coordinate in DOM/client space
   * @param y - The y coordinate in DOM/client space
   * @example
   * ```ts
   * // Map mouse coordinates to PixiJS space
   * const point = new Point();
   * app.renderer.events.mapPositionToPoint(
   *     point,
   *     event.clientX,
   *     event.clientY
   * );
   * console.log('Mapped position:', point.x, point.y);
   *
   * // Using with pointer events
   * sprite.on('pointermove', (event) => {
   *     // event.global already contains mapped coordinates
   *     console.log('Global:', event.global.x, event.global.y);
   *
   *     // Map to local coordinates
   *     const local = event.getLocalPosition(sprite);
   *     console.log('Local:', local.x, local.y);
   * });
   * ```
   * @remarks
   * - Accounts for element scaling and positioning
   * - Adjusts for device pixel ratio/resolution
   */
  mapPositionToPoint(e, t, i) {
    const s = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
      width: this.domElement.width,
      height: this.domElement.height,
      left: 0,
      top: 0
    }, o = 1 / this.resolution;
    e.x = (t - s.left) * (this.domElement.width / s.width) * o, e.y = (i - s.top) * (this.domElement.height / s.height) * o;
  }
  /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */
  _normalizeToPointerData(e) {
    var i, s, o, r;
    const t = [];
    if (this.supportsTouchEvents && e instanceof TouchEvent)
      for (let a = 0, l = e.changedTouches.length; a < l; a++) {
        const d = e.changedTouches[a];
        typeof d.button == "undefined" && (d.button = 0), typeof d.buttons == "undefined" && (d.buttons = 1), typeof d.isPrimary == "undefined" && (d.isPrimary = e.touches.length === 1 && e.type === "touchstart"), typeof d.width == "undefined" && (d.width = d.radiusX || 1), typeof d.height == "undefined" && (d.height = d.radiusY || 1), typeof d.tiltX == "undefined" && (d.tiltX = 0), typeof d.tiltY == "undefined" && (d.tiltY = 0), typeof d.pointerType == "undefined" && (d.pointerType = "touch"), typeof d.pointerId == "undefined" && (d.pointerId = d.identifier || 0), typeof d.pressure == "undefined" && (d.pressure = d.force || 0.5), typeof d.twist == "undefined" && (d.twist = 0), typeof d.tangentialPressure == "undefined" && (d.tangentialPressure = 0), typeof d.layerX == "undefined" && (d.layerX = d.offsetX = d.clientX), typeof d.layerY == "undefined" && (d.layerY = d.offsetY = d.clientY), d.isNormalized = !0, d.type = e.type, (i = d.altKey) != null || (d.altKey = e.altKey), (s = d.ctrlKey) != null || (d.ctrlKey = e.ctrlKey), (o = d.metaKey) != null || (d.metaKey = e.metaKey), (r = d.shiftKey) != null || (d.shiftKey = e.shiftKey), t.push(d);
      }
    else if (!globalThis.MouseEvent || e instanceof MouseEvent && (!this.supportsPointerEvents || !(e instanceof globalThis.PointerEvent))) {
      const a = e;
      typeof a.isPrimary == "undefined" && (a.isPrimary = !0), typeof a.width == "undefined" && (a.width = 1), typeof a.height == "undefined" && (a.height = 1), typeof a.tiltX == "undefined" && (a.tiltX = 0), typeof a.tiltY == "undefined" && (a.tiltY = 0), typeof a.pointerType == "undefined" && (a.pointerType = "mouse"), typeof a.pointerId == "undefined" && (a.pointerId = NY), typeof a.pressure == "undefined" && (a.pressure = 0.5), typeof a.twist == "undefined" && (a.twist = 0), typeof a.tangentialPressure == "undefined" && (a.tangentialPressure = 0), a.isNormalized = !0, t.push(a);
    } else
      t.push(e);
    return t;
  }
  /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */
  normalizeWheelEvent(e) {
    const t = this._rootWheelEvent;
    return this._transferMouseData(t, e), t.deltaX = e.deltaX, t.deltaY = e.deltaY, t.deltaZ = e.deltaZ, t.deltaMode = e.deltaMode, this.mapPositionToPoint(t.screen, e.clientX, e.clientY), t.global.copyFrom(t.screen), t.offset.copyFrom(t.screen), t.nativeEvent = e, t.type = e.type, t;
  }
  /**
   * Normalizes the `nativeEvent` into a federateed {@link FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */
  _bootstrapEvent(e, t) {
    return e.originalEvent = null, e.nativeEvent = t, e.pointerId = t.pointerId, e.width = t.width, e.height = t.height, e.isPrimary = t.isPrimary, e.pointerType = t.pointerType, e.pressure = t.pressure, e.tangentialPressure = t.tangentialPressure, e.tiltX = t.tiltX, e.tiltY = t.tiltY, e.twist = t.twist, this._transferMouseData(e, t), this.mapPositionToPoint(e.screen, t.clientX, t.clientY), e.global.copyFrom(e.screen), e.offset.copyFrom(e.screen), e.isTrusted = t.isTrusted, e.type === "pointerleave" && (e.type = "pointerout"), e.type.startsWith("mouse") && (e.type = e.type.replace("mouse", "pointer")), e.type.startsWith("touch") && (e.type = UY[e.type] || e.type), e;
  }
  /**
   * Transfers base & mouse event data from the `nativeEvent` to the federated event.
   * @param event
   * @param nativeEvent
   */
  _transferMouseData(e, t) {
    e.isTrusted = t.isTrusted, e.srcElement = t.srcElement, e.timeStamp = performance.now(), e.type = t.type, e.altKey = t.altKey, e.button = t.button, e.buttons = t.buttons, e.client.x = t.clientX, e.client.y = t.clientY, e.ctrlKey = t.ctrlKey, e.metaKey = t.metaKey, e.movement.x = t.movementX, e.movement.y = t.movementY, e.page.x = t.pageX, e.page.y = t.pageY, e.relatedTarget = null, e.shiftKey = t.shiftKey;
  }
};
j1.extension = {
  name: "events",
  type: [
    Ae.WebGLSystem,
    Ae.CanvasSystem,
    Ae.WebGPUSystem
  ],
  priority: -1
};
j1.defaultEventFeatures = {
  /** Enables pointer events associated with pointer movement. */
  move: !0,
  /** Enables global pointer move events. */
  globalMove: !0,
  /** Enables pointer events associated with clicking. */
  click: !0,
  /** Enables wheel events. */
  wheel: !0
};
let ZS = j1;
const GY = {
  onclick: null,
  oncontextmenu: null,
  onmousedown: null,
  onmouseenter: null,
  onmouseleave: null,
  onmousemove: null,
  onglobalmousemove: null,
  onmouseout: null,
  onmouseover: null,
  onmouseup: null,
  onmouseupoutside: null,
  onpointercancel: null,
  onpointerdown: null,
  onpointerenter: null,
  onpointerleave: null,
  onpointermove: null,
  onglobalpointermove: null,
  onpointerout: null,
  onpointerover: null,
  onpointertap: null,
  onpointerup: null,
  onpointerupoutside: null,
  onrightclick: null,
  onrightdown: null,
  onrightup: null,
  onrightupoutside: null,
  ontap: null,
  ontouchcancel: null,
  ontouchend: null,
  ontouchendoutside: null,
  ontouchmove: null,
  onglobaltouchmove: null,
  ontouchstart: null,
  onwheel: null,
  get interactive() {
    return this.eventMode === "dynamic" || this.eventMode === "static";
  },
  set interactive(n) {
    this.eventMode = n ? "static" : "passive";
  },
  _internalEventMode: void 0,
  get eventMode() {
    var n;
    return (n = this._internalEventMode) != null ? n : ZS.defaultEventMode;
  },
  set eventMode(n) {
    this._internalEventMode = n;
  },
  isInteractive() {
    return this.eventMode === "static" || this.eventMode === "dynamic";
  },
  interactiveChildren: !0,
  hitArea: null,
  addEventListener(n, e, t) {
    const i = typeof t == "boolean" && t || typeof t == "object" && t.capture, s = typeof t == "object" ? t.signal : void 0, o = typeof t == "object" ? t.once === !0 : !1, r = typeof e == "function" ? void 0 : e;
    n = i ? `${n}capture` : n;
    const a = typeof e == "function" ? e : e.handleEvent, l = this;
    s && s.addEventListener("abort", () => {
      l.off(n, a, r);
    }), o ? l.once(n, a, r) : l.on(n, a, r);
  },
  removeEventListener(n, e, t) {
    const i = typeof t == "boolean" && t || typeof t == "object" && t.capture, s = typeof e == "function" ? void 0 : e;
    n = i ? `${n}capture` : n, e = typeof e == "function" ? e : e.handleEvent, this.off(n, e, s);
  },
  dispatchEvent(n) {
    if (!(n instanceof Yc))
      throw new Error("Container cannot propagate events outside of the Federated Events API");
    return n.defaultPrevented = !1, n.path = null, n.target = this, n.manager.dispatchEvent(n), !n.defaultPrevented;
  }
};
let fa;
function Xk(n) {
  const e = Pt.get().createCanvas(6, 1), t = e.getContext("2d");
  return t.fillStyle = n, t.fillRect(0, 0, 6, 1), e;
}
function QS() {
  if (fa !== void 0)
    return fa;
  try {
    const n = Xk("#ff00ff"), e = Xk("#ffff00"), i = Pt.get().createCanvas(6, 1).getContext("2d");
    i.globalCompositeOperation = "multiply", i.drawImage(n, 0, 0), i.drawImage(e, 2, 0);
    const s = i.getImageData(2, 0, 1, 1);
    if (!s)
      fa = !1;
    else {
      const o = s.data;
      fa = o[0] === 255 && o[1] === 0 && o[2] === 0;
    }
  } catch {
    fa = !1;
  }
  return fa;
}
const yt = {
  canvas: null,
  convertTintToImage: !1,
  cacheStepsPerColorChannel: 8,
  canUseMultiply: QS(),
  tintMethod: null,
  _canvasSourceCache: /* @__PURE__ */ new WeakMap(),
  _unpremultipliedCache: /* @__PURE__ */ new WeakMap(),
  getCanvasSource: (n) => {
    var a, l;
    const e = n.source, t = e == null ? void 0 : e.resource;
    if (!t)
      return null;
    const i = e.alphaMode === "premultiplied-alpha", s = (a = e.resourceWidth) != null ? a : e.pixelWidth, o = (l = e.resourceHeight) != null ? l : e.pixelHeight, r = s !== e.pixelWidth || o !== e.pixelHeight;
    if (i) {
      if ((t instanceof HTMLCanvasElement || typeof OffscreenCanvas != "undefined" && t instanceof OffscreenCanvas) && !r)
        return t;
      const d = yt._unpremultipliedCache.get(e);
      if ((d == null ? void 0 : d.resourceId) === e._resourceId)
        return d.canvas;
    }
    if (t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int8Array || t instanceof Uint16Array || t instanceof Int16Array || t instanceof Uint32Array || t instanceof Int32Array || t instanceof Float32Array || t instanceof ArrayBuffer) {
      const d = yt._canvasSourceCache.get(e);
      if ((d == null ? void 0 : d.resourceId) === e._resourceId)
        return d.canvas;
      const c = Pt.get().createCanvas(e.pixelWidth, e.pixelHeight), u = c.getContext("2d"), p = u.createImageData(e.pixelWidth, e.pixelHeight), f = p.data, y = t instanceof ArrayBuffer ? new Uint8Array(t) : new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
      if (e.format === "bgra8unorm")
        for (let b = 0; b < f.length && b + 3 < y.length; b += 4)
          f[b] = y[b + 2], f[b + 1] = y[b + 1], f[b + 2] = y[b], f[b + 3] = y[b + 3];
      else
        f.set(y.subarray(0, f.length));
      return u.putImageData(p, 0, 0), yt._canvasSourceCache.set(e, { canvas: c, resourceId: e._resourceId }), c;
    }
    if (i) {
      const d = Pt.get().createCanvas(e.pixelWidth, e.pixelHeight), c = d.getContext("2d", { willReadFrequently: !0 });
      d.width = e.pixelWidth, d.height = e.pixelHeight, c.drawImage(t, 0, 0);
      const u = c.getImageData(0, 0, d.width, d.height), p = u.data;
      for (let f = 0; f < p.length; f += 4) {
        const y = p[f + 3];
        if (y > 0) {
          const b = 255 / y;
          p[f] = Math.min(255, p[f] * b + 0.5), p[f + 1] = Math.min(255, p[f + 1] * b + 0.5), p[f + 2] = Math.min(255, p[f + 2] * b + 0.5);
        }
      }
      return c.putImageData(u, 0, 0), yt._unpremultipliedCache.set(e, { canvas: d, resourceId: e._resourceId }), d;
    }
    if (r) {
      const d = yt._canvasSourceCache.get(e);
      if ((d == null ? void 0 : d.resourceId) === e._resourceId)
        return d.canvas;
      const c = Pt.get().createCanvas(e.pixelWidth, e.pixelHeight), u = c.getContext("2d");
      return c.width = e.pixelWidth, c.height = e.pixelHeight, u.drawImage(t, 0, 0), yt._canvasSourceCache.set(e, { canvas: c, resourceId: e._resourceId }), c;
    }
    return t;
  },
  getTintedCanvas: (n, e) => {
    const t = n.texture, i = pn.shared.setValue(e).toHex(), s = t.tintCache || (t.tintCache = {}), o = s[i], r = t.source._resourceId;
    if ((o == null ? void 0 : o.tintId) === r)
      return o;
    const a = o && "getContext" in o ? o : Pt.get().createCanvas();
    return yt.tintMethod(t, e, a), a.tintId = r, s[i] = a, s[i];
  },
  getTintedPattern: (n, e) => {
    const t = pn.shared.setValue(e).toHex(), i = n.patternCache || (n.patternCache = {}), s = n.source._resourceId;
    let o = i[t];
    return (o == null ? void 0 : o.tintId) === s || (yt.canvas || (yt.canvas = Pt.get().createCanvas()), yt.tintMethod(n, e, yt.canvas), o = yt.canvas.getContext("2d").createPattern(yt.canvas, "repeat"), o.tintId = s, i[t] = o), o;
  },
  /**
   * Applies a transform to a CanvasPattern.
   * @param pattern - The pattern to apply the transform to.
   * @param matrix - The matrix to apply.
   * @param matrix.a
   * @param matrix.b
   * @param matrix.c
   * @param matrix.d
   * @param matrix.tx
   * @param matrix.ty
   * @param invert
   */
  applyPatternTransform: (n, e, t = !0) => {
    if (!e) return;
    const i = n;
    if (!i.setTransform) return;
    const s = globalThis.DOMMatrix;
    if (!s) return;
    const o = new s([e.a, e.b, e.c, e.d, e.tx, e.ty]);
    i.setTransform(t ? o.inverse() : o);
  },
  tintWithMultiply: (n, e, t) => {
    var u, p;
    const i = t.getContext("2d"), s = n.frame.clone(), o = (p = (u = n.source._resolution) != null ? u : n.source.resolution) != null ? p : 1, r = n.rotate;
    s.x *= o, s.y *= o, s.width *= o, s.height *= o;
    const a = wt.isVertical(r), l = a ? s.height : s.width, d = a ? s.width : s.height;
    t.width = Math.ceil(l), t.height = Math.ceil(d), i.save(), e !== 16777215 && (i.fillStyle = pn.shared.setValue(e).toHex(), i.fillRect(0, 0, l, d), i.globalCompositeOperation = "multiply");
    const c = yt.getCanvasSource(n);
    if (!c) {
      i.restore();
      return;
    }
    r && yt._applyInverseRotation(i, r, s.width, s.height), i.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    ), e !== 16777215 && (i.globalCompositeOperation = "destination-atop", i.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    )), i.restore();
  },
  tintWithOverlay: (n, e, t) => {
    var u, p;
    const i = t.getContext("2d"), s = n.frame.clone(), o = (p = (u = n.source._resolution) != null ? u : n.source.resolution) != null ? p : 1, r = n.rotate;
    s.x *= o, s.y *= o, s.width *= o, s.height *= o;
    const a = wt.isVertical(r), l = a ? s.height : s.width, d = a ? s.width : s.height;
    t.width = Math.ceil(l), t.height = Math.ceil(d), i.save(), i.globalCompositeOperation = "copy", i.fillStyle = pn.shared.setValue(e).toHex(), i.fillRect(0, 0, l, d), i.globalCompositeOperation = "destination-atop";
    const c = yt.getCanvasSource(n);
    if (!c) {
      i.restore();
      return;
    }
    r && yt._applyInverseRotation(i, r, s.width, s.height), i.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    ), i.restore();
  },
  tintWithPerPixel: (n, e, t) => {
    var w, k;
    const i = t.getContext("2d"), s = n.frame.clone(), o = (k = (w = n.source._resolution) != null ? w : n.source.resolution) != null ? k : 1, r = n.rotate;
    s.x *= o, s.y *= o, s.width *= o, s.height *= o;
    const a = wt.isVertical(r), l = a ? s.height : s.width, d = a ? s.width : s.height;
    t.width = Math.ceil(l), t.height = Math.ceil(d), i.save(), i.globalCompositeOperation = "copy";
    const c = yt.getCanvasSource(n);
    if (!c) {
      i.restore();
      return;
    }
    r && yt._applyInverseRotation(i, r, s.width, s.height), i.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    ), i.restore();
    const u = e >> 16 & 255, p = e >> 8 & 255, f = e & 255, y = i.getImageData(0, 0, l, d), b = y.data;
    for (let S = 0; S < b.length; S += 4)
      b[S] = b[S] * u / 255, b[S + 1] = b[S + 1] * p / 255, b[S + 2] = b[S + 2] * f / 255;
    i.putImageData(y, 0, 0);
  },
  /**
   * Applies inverse rotation transform to context for texture packer rotation compensation.
   * Supports all 16 groupD8 symmetries (rotations and reflections).
   * @param context - Canvas 2D context
   * @param rotate - The groupD8 rotation value
   * @param srcWidth - Source crop width (before rotation)
   * @param srcHeight - Source crop height (before rotation)
   */
  _applyInverseRotation: (n, e, t, i) => {
    const s = wt.inv(e), o = wt.uX(s), r = wt.uY(s), a = wt.vX(s), l = wt.vY(s), d = -Math.min(0, o * t, a * i, o * t + a * i), c = -Math.min(0, r * t, l * i, r * t + l * i);
    n.transform(o, r, a, l, d, c);
  }
};
yt.tintMethod = yt.canUseMultiply ? yt.tintWithMultiply : yt.tintWithPerPixel;
const xg = 32767;
function Jk(n, e) {
  return (n << 17) + (e << 2);
}
class jY {
  constructor(e) {
    this._buckets = /* @__PURE__ */ new Map(), this._screens = new B8(), this._enableFullScreen = !1, this.canvasOptions = e || {};
  }
  /**
   * Has no effect. The pool sizes canvases to the screens registered with
   * {@link CanvasPoolClass#setScreenSize|setScreenSize}.
   * @deprecated since 8.21.0
   */
  get enableFullScreen() {
    return rt(zs, "CanvasPool.enableFullScreen is no longer used, the pool sizes canvases to the screens registered with setScreenSize."), this._enableFullScreen;
  }
  set enableFullScreen(e) {
    rt(zs, "CanvasPool.enableFullScreen is no longer used, the pool sizes canvases to the screens registered with setScreenSize."), this._enableFullScreen = e;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */
  _createCanvasAndContext(e, t) {
    const i = Pt.get().createCanvas();
    i.width = e, i.height = t;
    const s = i.getContext("2d");
    return { canvas: i, context: s };
  }
  /**
   * Gets a Power-of-Two canvas or screen sized canvas
   * @param minWidth - The minimum width of the canvas.
   * @param minHeight - The minimum height of the canvas.
   * @param resolution - The resolution of the canvas.
   * @returns The new canvas and its context.
   */
  getOptimalCanvasAndContext(e, t, i = 1) {
    const { width: s, height: o } = this.getOptimalSize(e, t, i);
    (s > xg || o > xg) && at(`CanvasPool: ${s}x${o} is larger than the ${xg}px pool key limit, canvases of this size may be pooled together`);
    const r = Jk(s, o);
    let a = this._buckets.get(r);
    a || (a = [], this._buckets.set(r, a));
    let l = a.pop();
    return l || (l = this._createCanvasAndContext(s, o)), l;
  }
  /**
   * The backing size, in physical pixels, that
   * {@link CanvasPoolClass#getOptimalCanvasAndContext|getOptimalCanvasAndContext} would allocate for a request,
   * without taking a canvas from the pool.
   *
   * Each axis is the next power of two, or the smallest registered screen the request fits inside
   * (see {@link CanvasPoolClass#setScreenSize|setScreenSize}).
   * @param minWidth - The minimum width of the canvas.
   * @param minHeight - The minimum height of the canvas.
   * @param resolution - The resolution of the canvas.
   * @returns The width and height the pooled canvas would have, in physical pixels.
   */
  getOptimalSize(e, t, i = 1) {
    const s = Math.ceil(e * i - 1e-6), o = Math.ceil(t * i - 1e-6), r = Lp(s), a = this._screens.getFittingWidth(s), l = Lp(o), d = this._screens.getFittingHeight(o);
    return {
      width: a !== void 0 ? Math.min(a, r) : r,
      height: d !== void 0 ? Math.min(d, l) : l
    };
  }
  /**
   * Place a canvas back into the pool.
   * @param canvasAndContext
   */
  returnCanvasAndContext(e) {
    const t = e.canvas, { width: i, height: s } = t, o = this._buckets.get(Jk(i, s));
    o && (e.context.resetTransform(), e.context.clearRect(0, 0, i, s), o.push(e));
  }
  /**
   * Registers the screen size of a renderer with the pool, in physical pixels.
   *
   * While a screen is registered, a request that fits inside it on an axis is given that screen's size on
   * that axis instead of the next power of two, which stops a full screen canvas from being allocated far
   * larger than the screen. Requests larger than every registered screen on an axis keep the power of two
   * size - the pool never rounds a request up to a screen it does not fit in.
   * @param rendererUid - The uid of the renderer, used to update or remove this screen later.
   * @param pixelWidth - The width of the screen in physical pixels.
   * @param pixelHeight - The height of the screen in physical pixels.
   */
  setScreenSize(e, t, i) {
    this._screens.set(e, t, i) && this._pruneScreenCanvases();
  }
  /**
   * Removes a screen previously registered with
   * {@link CanvasPoolClass#setScreenSize|setScreenSize}, dropping any idle canvases that were
   * only being kept for it.
   * @param rendererUid - The uid the screen was registered with.
   */
  removeScreen(e) {
    this._screens.remove(e) && this._pruneScreenCanvases();
  }
  /** Clears the pool. */
  clear() {
    this._buckets.clear();
  }
  /**
   * Drops the idle canvases in every bucket that has a non power of two dimension matching no live
   * screen. Power of two buckets are always kept, as any request can fall back to them.
   */
  _pruneScreenCanvases() {
    for (const [e] of this._buckets) {
      const t = e >>> 17, i = e >>> 2 & 32767;
      (ml(t) || this._screens.hasWidth(t)) && (ml(i) || this._screens.hasHeight(i)) || this._buckets.delete(e);
    }
  }
}
const xl = new jY();
zl.register(xl);
const Zk = new st();
function eT(n, e) {
  var i;
  e.clear();
  const t = e.matrix;
  for (let s = 0; s < n.length; s++) {
    const o = n[s];
    if (o.globalDisplayStatus < 7)
      continue;
    const r = (i = o.renderGroup) != null ? i : o.parentRenderGroup;
    r != null && r.isCachedAsTexture ? e.matrix = Zk.copyFrom(r.textureOffsetInverseTransform).append(o.worldTransform) : r != null && r._parentCacheAsTextureRenderGroup ? e.matrix = Zk.copyFrom(r._parentCacheAsTextureRenderGroup.inverseWorldTransform).append(o.groupTransform) : e.matrix = o.worldTransform, e.addBounds(o.bounds);
  }
  return e.matrix = t, e;
}
const HY = new On();
function VY(n, e, t, i, s = !1, o) {
  const r = HY;
  r.minX = 0, r.minY = 0, r.maxX = n.width / i | 0, r.maxY = n.height / i | 0;
  const a = Rn.getOptimalTexture({
    width: r.width,
    height: r.height,
    resolution: i,
    autoGenerateMipmaps: s,
    scaleMode: o
  });
  return a.source.uploadMethodId = "image", a.source.resource = n, a.source.alphaMode = "premultiply-alpha-on-upload", a.frame.width = e / i, a.frame.height = t / i, a.source.emit("update", a.source), a.updateUvs(), a;
}
function Qk(n) {
  return typeof n.getCanvasFilterString == "function";
}
class WY {
  constructor() {
    this.skip = !1, this.useClip = !1, this.filters = null, this.container = null, this.bounds = new On(), this.cssFilterString = "";
  }
}
class tT {
  /**
   * @param renderer - The Canvas renderer
   * @param renderer.canvasContext
   * @param renderer.canvasContext.activeContext
   * @param renderer.canvasContext.activeResolution
   */
  constructor(e) {
    this._filterStack = [], this._filterStackIndex = 0, this._savedStates = [], this._alphaMultiplier = 1, this._warnedFilterTypes = /* @__PURE__ */ new Set(), this.renderer = e;
  }
  /**
   * Push a filter instruction onto the stack.
   * Called when entering a filtered container.
   * @param instruction - The filter instruction from FilterPipe
   */
  push(e) {
    const t = this._pushFilterFrame(), i = e.filterEffect.filters;
    if (t.skip = !1, t.useClip = !1, t.filters = i, t.container = e.container, t.cssFilterString = "", i.every((l) => !l.enabled)) {
      t.skip = !0;
      return;
    }
    const s = [], o = 1;
    for (const l of i) {
      if (!l.enabled) continue;
      if (!Qk(l)) {
        this._warnUnsupportedFilter(l);
        continue;
      }
      const d = l.getCanvasFilterString();
      if (d === null) {
        this._warnUnsupportedFilter(l);
        continue;
      }
      d && s.push(d);
    }
    if (s.length === 0 && o === 1) {
      t.skip = !0;
      return;
    }
    t.cssFilterString = s.join(" "), this._calculateFilterArea(e, t.bounds), t.useClip = !!e.filterEffect.filterArea;
    const r = this.renderer.canvasContext.activeContext, a = r.filter || "none";
    if (this._savedStates.push({ filter: a, alphaMultiplier: this._alphaMultiplier }), t.useClip && Number.isFinite(t.bounds.width) && Number.isFinite(t.bounds.height) && t.bounds.width > 0 && t.bounds.height > 0) {
      const l = this.renderer.canvasContext.activeResolution || 1;
      r.save(), r.setTransform(1, 0, 0, 1, 0, 0), r.beginPath(), r.rect(
        t.bounds.x * l,
        t.bounds.y * l,
        t.bounds.width * l,
        t.bounds.height * l
      ), r.clip();
    } else
      t.useClip = !1;
    t.cssFilterString && (r.filter = a !== "none" ? `${a} ${t.cssFilterString}` : t.cssFilterString);
  }
  /** Pop a filter from the stack. Called when exiting a filtered container. */
  pop() {
    const e = this._popFilterFrame();
    if (e.skip)
      return;
    const t = this._savedStates.pop();
    if (!t)
      return;
    const i = this.renderer.canvasContext.activeContext;
    e.useClip ? i.restore() : i.filter = t.filter, this._alphaMultiplier = t.alphaMultiplier;
  }
  /**
   * Applies supported filters to a texture and returns a new texture.
   * Unsupported filters are skipped with a warn-once message.
   * @param params - The parameters for applying filters.
   * @param params.texture
   * @param params.filters
   * @returns The resulting texture after filters are applied.
   */
  generateFilteredTexture({ texture: e, filters: t }) {
    var k, S;
    if (!(t != null && t.length) || t.every((_) => !_.enabled))
      return e;
    const i = [], s = 1;
    for (const _ of t) {
      if (!_.enabled) continue;
      if (!Qk(_)) {
        this._warnUnsupportedFilter(_);
        continue;
      }
      const x = _.getCanvasFilterString();
      if (x === null) {
        this._warnUnsupportedFilter(_);
        continue;
      }
      x && i.push(x);
    }
    if (i.length === 0 && s === 1)
      return e;
    const o = yt.getCanvasSource(e);
    if (!o)
      return e;
    const r = e.frame, a = (S = (k = e.source._resolution) != null ? k : e.source.resolution) != null ? S : 1, l = r.width, d = r.height, c = xl.getOptimalCanvasAndContext(l, d, a), { canvas: u, context: p } = c;
    p.setTransform(1, 0, 0, 1, 0, 0), p.clearRect(0, 0, u.width, u.height), i.length && (p.filter = i.join(" "));
    const f = r.x * a, y = r.y * a, b = l * a, w = d * a;
    return p.drawImage(
      o,
      f,
      y,
      b,
      w,
      0,
      0,
      b,
      w
    ), p.filter = "none", p.globalAlpha = 1, VY(u, l, d, a);
  }
  /**
   * Calculate the filter area bounds.
   * @param instruction - Filter instruction
   * @param bounds - Bounds object to populate
   */
  _calculateFilterArea(e, t) {
    if (e.renderables ? eT(e.renderables, t) : e.filterEffect.filterArea ? (t.clear(), t.addRect(e.filterEffect.filterArea), t.applyMatrix(e.container.worldTransform)) : e.container.getFastGlobalBounds(!0, t), e.container) {
      const i = e.container.renderGroup || e.container.parentRenderGroup, s = i == null ? void 0 : i.cacheToLocalTransform;
      s && t.applyMatrix(s);
    }
  }
  _warnUnsupportedFilter(e) {
    var i;
    const t = ((i = e == null ? void 0 : e.constructor) == null ? void 0 : i.name) || "Filter";
    this._warnedFilterTypes.has(t) || (this._warnedFilterTypes.add(t), console.warn(
      `CanvasRenderer: filter "${t}" is not supported in Canvas2D and will be skipped.`
    ));
  }
  get alphaMultiplier() {
    return this._alphaMultiplier;
  }
  _pushFilterFrame() {
    let e = this._filterStack[this._filterStackIndex];
    return e || (e = this._filterStack[this._filterStackIndex] = new WY()), this._filterStackIndex++, e;
  }
  _popFilterFrame() {
    return this._filterStackIndex <= 0 ? this._filterStack[0] : (this._filterStackIndex--, this._filterStack[this._filterStackIndex]);
  }
  /** Destroys the system */
  destroy() {
    this._filterStack = null, this._savedStates = null, this._warnedFilterTypes = null, this._alphaMultiplier = 1;
  }
}
tT.extension = {
  type: [Ae.CanvasSystem],
  name: "filter"
};
var qY = `in vec2 aPosition;
out vec2 vTextureCoord;

uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;

vec4 filterVertexPosition( void )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`, KY = `in vec2 vTextureCoord;
out vec4 finalColor;
uniform sampler2D uTexture;
void main() {
    finalColor = texture(uTexture, vTextureCoord);
}
`, e2 = `struct GlobalFilterUniforms {
  uInputSize: vec4<f32>,
  uInputPixel: vec4<f32>,
  uInputClamp: vec4<f32>,
  uOutputFrame: vec4<f32>,
  uGlobalFrame: vec4<f32>,
  uOutputTexture: vec4<f32>,
};

@group(0) @binding(0) var <uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler: sampler;

struct VSOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) uv: vec2<f32>
};

fn filterVertexPosition(aPosition: vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0 * gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord(aPosition: vec2<f32>) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

@vertex
fn mainVertex(
  @location(0) aPosition: vec2<f32>,
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
) -> @location(0) vec4<f32> {
    return textureSample(uTexture, uSampler, uv);
}
`;
class YY extends dS {
  constructor() {
    const e = na.from({
      vertex: { source: e2, entryPoint: "mainVertex" },
      fragment: { source: e2, entryPoint: "mainFragment" },
      name: "passthrough-filter"
    }), t = $l.from({
      vertex: qY,
      fragment: KY,
      name: "passthrough-filter"
    });
    super({
      gpuProgram: e,
      glProgram: t
    });
  }
}
class nT {
  constructor(e) {
    this._renderer = e;
  }
  push(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "filter",
      canBundle: !1,
      action: "pushFilter",
      container: t,
      filterEffect: e
    });
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  execute(e) {
    e.action === "pushFilter" ? this._renderer.filter.push(e) : e.action === "popFilter" && this._renderer.filter.pop();
  }
  destroy() {
    this._renderer = null;
  }
}
nT.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "filter"
};
const XY = new Gf({
  attributes: {
    aPosition: {
      buffer: new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]),
      format: "float32x2",
      stride: 8,
      offset: 0
    }
  },
  indexBuffer: new Uint32Array([0, 1, 2, 0, 2, 3])
});
class JY {
  constructor() {
    this.skip = !1, this.inputTexture = null, this.backTexture = null, this.filters = null, this.bounds = new On(), this.container = null, this.blendRequired = !1, this.outputRenderSurface = null, this.firstEnabledIndex = -1, this.lastEnabledIndex = -1;
  }
}
class iT {
  constructor(e) {
    this._filterStackIndex = 0, this._filterStack = [], this._filterGlobalUniforms = new ms({
      uInputSize: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputPixel: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputClamp: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uGlobalFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputTexture: { value: new Float32Array(4), type: "vec4<f32>" }
    }), this._globalFilterBindGroup = new Eo({}), this.renderer = e;
  }
  /**
   * The back texture of the currently active filter. Requires the filter to have `blendRequired` set to true.
   * @readonly
   */
  get activeBackTexture() {
    var e;
    return (e = this._activeFilterData) == null ? void 0 : e.backTexture;
  }
  /**
   * Pushes a filter instruction onto the filter stack.
   * @param instruction - The instruction containing the filter effect and container.
   * @internal
   */
  push(e) {
    const t = this.renderer, i = e.filterEffect.filters, s = this._pushFilterData();
    s.skip = !1, s.filters = i, s.container = e.container, s.outputRenderSurface = t.renderTarget.renderSurface;
    const o = t.renderTarget.renderTarget.colorTexture.source, r = o.resolution, a = o.antialias;
    if (i.every((c) => !c.enabled)) {
      s.skip = !0;
      return;
    }
    const l = s.bounds;
    if (this._calculateFilterArea(e, l), this._calculateFilterBounds(s, t.renderTarget.rootViewPort, a, r, 1), s.skip)
      return;
    const d = this._getPreviousFilterData();
    this._setupFilterTextures(s, l, t, d);
  }
  /**
   * Applies filters to a texture.
   *
   * This method takes a texture and a list of filters, applies the filters to the texture,
   * and returns the resulting texture.
   * @param {object} params - The parameters for applying filters.
   * @param {Texture} params.texture - The texture to apply filters to.
   * @param {Filter[]} params.filters - The filters to apply.
   * @returns {Texture} The resulting texture after all filters have been applied.
   * @example
   *
   * ```ts
   * // Create a texture and a list of filters
   * const texture = new Texture(...);
   * const filters = [new BlurFilter(), new ColorMatrixFilter()];
   *
   * // Apply the filters to the texture
   * const resultTexture = renderer.filter.generateFilteredTexture({ texture, filters });
   *
   * // Use the resulting texture
   * sprite.texture = resultTexture;
   * ```
   *
   * Key Points:
   * 1. padding is not currently supported here - so clipping may occur with filters that use padding.
   * 2. If all filters are disabled or skipped, the original texture is returned.
   */
  generateFilteredTexture({ texture: e, filters: t }) {
    if (t.every((c) => !c.enabled))
      return e;
    const i = this._pushFilterData();
    this._activeFilterData = i, i.skip = !1, i.filters = t;
    const s = e.source, o = s.resolution, r = s.antialias, a = i.bounds;
    if (a.clear(), a.addRect(e.frame), this._calculateFilterBounds(i, a.rectangle, r, o, 0), i.skip)
      return this._popFilterData(), e;
    i.outputRenderSurface = Rn.getOptimalTexture({
      width: a.width,
      height: a.height,
      resolution: i.resolution,
      antialias: i.antialias
    }), i.backTexture = Ze.EMPTY, i.inputTexture = e, this.renderer.renderTarget.finishRenderPass(), this._applyFiltersToTexture(i, !0);
    const d = i.outputRenderSurface;
    return d.source.alphaMode = "premultiplied-alpha", this._popFilterData(), d;
  }
  /** @internal */
  pop() {
    const e = this.renderer, t = this._popFilterData();
    t.skip || (e.globalUniforms.pop(), e.renderTarget.finishRenderPass(), this._activeFilterData = t, this._applyFiltersToTexture(t, !1), t.blendRequired && Rn.returnTexture(t.backTexture), Rn.returnTexture(t.inputTexture));
  }
  /**
   * Copies the last render surface to a texture.
   * @param lastRenderSurface - The last render surface to copy from.
   * @param bounds - The bounds of the area to copy.
   * @param previousBounds - The previous bounds to use for offsetting the copy.
   */
  getBackTexture(e, t, i) {
    const s = e.colorTexture.source._resolution, o = Rn.getOptimalTexture({
      width: t.width,
      height: t.height,
      resolution: s
    });
    let r = t.minX, a = t.minY;
    i && (r -= i.minX, a -= i.minY), r = Math.floor(r * s), a = Math.floor(a * s);
    const l = Math.ceil(t.width * s), d = Math.ceil(t.height * s);
    return this.renderer.renderTarget.copyToTexture(
      e,
      o,
      { x: r, y: a },
      { width: l, height: d },
      { x: 0, y: 0 }
    ), o;
  }
  /**
   * Applies a filter to a texture.
   * @param filter - The filter to apply.
   * @param input - The input texture.
   * @param output - The output render surface.
   * @param clear - Whether to clear the output surface before applying the filter.
   */
  applyFilter(e, t, i, s) {
    const o = this.renderer, r = this._activeFilterData, l = r.outputRenderSurface === i, d = this._findClosestFilterData(), c = d ? d.inputTexture.source._resolution : o.renderTarget.rootRenderTarget.colorTexture.source._resolution;
    let u = 0, p = 0;
    l && d && (u = d.bounds.minX, p = d.bounds.minY), this._updateFilterUniforms(t, i, r, u, p, c, l, s);
    const f = e.enabled ? e : this._getPassthroughFilter();
    this._setupBindGroupsAndRender(f, t, o);
  }
  /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */
  calculateSpriteMatrix(e, t) {
    const i = this._activeFilterData, s = e.set(
      i.inputTexture._source.width,
      0,
      0,
      i.inputTexture._source.height,
      i.bounds.minX,
      i.bounds.minY
    ), o = t.worldTransform.copyTo(st.shared), r = t.renderGroup || t.parentRenderGroup;
    return r && r.cacheToLocalTransform && o.prepend(r.cacheToLocalTransform), o.invert(), s.prepend(o), s.scale(
      1 / t.texture.orig.width,
      1 / t.texture.orig.height
    ), s.translate(t.anchor.x, t.anchor.y), s;
  }
  destroy() {
    var e;
    (e = this._passthroughFilter) == null || e.destroy(!0), this._passthroughFilter = null;
  }
  _getPassthroughFilter() {
    var e;
    return (e = this._passthroughFilter) != null || (this._passthroughFilter = new YY()), this._passthroughFilter;
  }
  /**
   * Sets up the bind groups and renders the filter.
   * @param filter - The filter to apply
   * @param input - The input texture
   * @param renderer - The renderer instance
   */
  _setupBindGroupsAndRender(e, t, i) {
    if (i.renderPipes.uniformBatch) {
      const s = i.renderPipes.uniformBatch.getUboResource(this._filterGlobalUniforms);
      this._globalFilterBindGroup.setResource(s, 0);
    } else
      this._globalFilterBindGroup.setResource(this._filterGlobalUniforms, 0);
    this._globalFilterBindGroup.setResource(t.source, 1), this._globalFilterBindGroup.setResource(t.source.style, 2), e.groups[0] = this._globalFilterBindGroup, i.encoder.draw({
      geometry: XY,
      shader: e,
      state: e._state,
      topology: "triangle-list"
    }), i.type === Vi.WEBGL && i.renderTarget.finishRenderPass();
  }
  /**
   * Sets up the filter textures including input texture and back texture if needed.
   * @param filterData - The filter data to update
   * @param bounds - The bounds for the texture
   * @param renderer - The renderer instance
   * @param previousFilterData - The previous filter data for back texture calculation
   */
  _setupFilterTextures(e, t, i, s) {
    if (e.backTexture = Ze.EMPTY, e.inputTexture = Rn.getOptimalTexture({
      width: t.width,
      height: t.height,
      resolution: e.resolution,
      antialias: e.antialias
    }), e.blendRequired) {
      i.renderTarget.finishRenderPass();
      const o = i.renderTarget.getRenderTarget(e.outputRenderSurface);
      e.backTexture = this.getBackTexture(o, t, s == null ? void 0 : s.bounds);
    }
    i.renderTarget.bind({ target: e.inputTexture, clear: !0 }), i.globalUniforms.push({
      offset: t
    });
  }
  /**
   * Updates the filter uniforms with the current filter state.
   * @param input - The input texture
   * @param output - The output render surface
   * @param filterData - The current filter data
   * @param offsetX - The X offset for positioning
   * @param offsetY - The Y offset for positioning
   * @param resolution - The current resolution
   * @param isFinalTarget - Whether this is the final render target
   * @param clear - Whether to clear the output surface
   */
  _updateFilterUniforms(e, t, i, s, o, r, a, l) {
    const d = this._filterGlobalUniforms.uniforms, c = d.uOutputFrame, u = d.uInputSize, p = d.uInputPixel, f = d.uInputClamp, y = d.uGlobalFrame, b = d.uOutputTexture;
    a ? (c[0] = i.bounds.minX - s, c[1] = i.bounds.minY - o) : (c[0] = 0, c[1] = 0), c[2] = e.frame.width, c[3] = e.frame.height, u[0] = e.source.width, u[1] = e.source.height, u[2] = 1 / u[0], u[3] = 1 / u[1], p[0] = e.source.pixelWidth, p[1] = e.source.pixelHeight, p[2] = 1 / p[0], p[3] = 1 / p[1], f[0] = 0.5 * p[2], f[1] = 0.5 * p[3], f[2] = e.frame.width * u[2] - 0.5 * p[2], f[3] = e.frame.height * u[3] - 0.5 * p[3];
    const w = this.renderer.renderTarget.rootRenderTarget.colorTexture;
    y[0] = s * r, y[1] = o * r, y[2] = w.source.width * r, y[3] = w.source.height * r, t instanceof Ze && (t.source.resource = null);
    const k = this.renderer.renderTarget.getRenderTarget(t);
    this.renderer.renderTarget.bind({ target: t, clear: !!l }), t instanceof Ze ? (b[0] = t.frame.width, b[1] = t.frame.height) : (b[0] = k.width, b[1] = k.height), b[2] = k.isRoot ? -1 : 1, this._filterGlobalUniforms.update();
  }
  /**
   * Finds the non-skipped entry closest to the top of the filter stack.
   *
   * `pop()` removes its entry before it applies the filters, so the result is the enclosing filter's entry.
   * `generateFilteredTexture()` applies the filters while its entry is still on the stack, so the result is that entry.
   * @returns The entry, or null if there is none
   */
  _findClosestFilterData() {
    for (let e = this._filterStackIndex - 1; e >= 0; e--) {
      const t = this._filterStack[e];
      if (!t.skip) return t;
    }
    return null;
  }
  /**
   * Calculates the filter area bounds based on the instruction type.
   * @param instruction - The filter instruction
   * @param bounds - The bounds object to populate
   */
  _calculateFilterArea(e, t) {
    if (e.renderables ? eT(e.renderables, t) : e.filterEffect.filterArea ? (t.clear(), t.addRect(e.filterEffect.filterArea), t.applyMatrix(e.container.worldTransform)) : e.container.getFastGlobalBounds(!0, t), e.container) {
      const s = (e.container.renderGroup || e.container.parentRenderGroup).cacheToLocalTransform;
      s && t.applyMatrix(s);
    }
  }
  _applyFiltersToTexture(e, t) {
    const i = e.inputTexture, s = e.bounds, o = e.filters, r = e.firstEnabledIndex, a = e.lastEnabledIndex;
    if (this._globalFilterBindGroup.setResource(i.source.style, 2), this._globalFilterBindGroup.setResource(e.backTexture.source, 3), r === a)
      o[r].apply(this, i, e.outputRenderSurface, t);
    else {
      let l = e.inputTexture;
      const d = Rn.getOptimalTexture({
        width: s.width,
        height: s.height,
        resolution: l.source._resolution
      });
      let c = d;
      for (let u = r; u < a; u++) {
        const p = o[u];
        if (!p.enabled) continue;
        p.apply(this, l, c, !0);
        const f = l;
        l = c, c = f;
      }
      o[a].apply(this, l, e.outputRenderSurface, t), Rn.returnTexture(d);
    }
  }
  _calculateFilterBounds(e, t, i, s, o) {
    var k, S;
    const r = this.renderer, a = e.bounds, l = e.filters;
    let d = 1 / 0, c = 0, u = !0, p = !1, f = !1, y = !0, b = -1, w = -1;
    for (let _ = 0; _ < l.length; _++) {
      const x = l[_];
      if (!x.enabled) continue;
      if (b === -1 && (b = _), w = _, d = Math.min(d, x.resolution === "inherit" ? s : x.resolution), c += x.padding, x.antialias === "off" ? u = !1 : x.antialias === "inherit" && u && (u = i), x.clipToViewport || (y = !1), !!!(x.compatibleRenderers & r.type)) {
        f = !1;
        break;
      }
      if (x.blendRequired && !((S = (k = r.backBuffer) == null ? void 0 : k.useBackBuffer) == null || S)) {
        at("Blend filter requires backBuffer on WebGL renderer to be enabled. Set `useBackBuffer: true` in the renderer options."), f = !1;
        break;
      }
      f = !0, p || (p = x.blendRequired);
    }
    if (!f) {
      e.skip = !0;
      return;
    }
    if (y && a.fitBounds(0, t.width / s, 0, t.height / s), a.scale(d).ceil().scale(1 / d).pad((c | 0) * o), !a.isPositive) {
      e.skip = !0;
      return;
    }
    e.antialias = u, e.resolution = d, e.blendRequired = p, e.firstEnabledIndex = b, e.lastEnabledIndex = w;
  }
  _popFilterData() {
    return this._filterStackIndex--, this._filterStack[this._filterStackIndex];
  }
  /**
   * Finds the closest non-skipped entry that encloses the filter being pushed.
   *
   * `push()` has already added that filter's own entry, so the search starts one entry below it.
   * @returns The entry, or null if there is none
   */
  _getPreviousFilterData() {
    for (let e = this._filterStackIndex - 2; e >= 0; e--) {
      const t = this._filterStack[e];
      if (!t.skip) return t;
    }
    return null;
  }
  _pushFilterData() {
    let e = this._filterStack[this._filterStackIndex];
    return e || (e = this._filterStack[this._filterStackIndex] = new JY()), this._filterStackIndex++, e;
  }
}
iT.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "filter"
};
var ZY = `in vec2 vMaskCoord;
in vec2 vTextureCoord;

uniform sampler2D uTexture;
uniform sampler2D uMaskTexture;

uniform float uAlpha;
uniform vec4 uMaskClamp;
uniform float uInverse;
uniform float uChannel;

out vec4 finalColor;

void main(void)
{
    float clip = step(3.5,
        step(uMaskClamp.x, vMaskCoord.x) +
        step(uMaskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, uMaskClamp.z) +
        step(vMaskCoord.y, uMaskClamp.w));

    // TODO look into why this is needed
    float npmAlpha = uAlpha;
    vec4 original = texture(uTexture, vTextureCoord);
    vec4 masky = texture(uMaskTexture, vMaskCoord);

    float a;
    if (uChannel == 1.0) {
        a = masky.a * npmAlpha * clip;
    } else {
        float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);
        a = alphaMul * masky.r * npmAlpha * clip;
    }

    if (uInverse == 1.0) {
        a = 1.0 - a;
    }

    finalColor = original * a;
}
`, QY = `in vec2 aPosition;

out vec2 vTextureCoord;
out vec2 vMaskCoord;


uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;
uniform mat3 uFilterMatrix;

vec4 filterVertexPosition(  vec2 aPosition )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
       
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord(  vec2 aPosition )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

vec2 getFilterCoord( vec2 aPosition )
{
    return  ( uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}   

void main(void)
{
    gl_Position = filterVertexPosition(aPosition);
    vTextureCoord = filterTextureCoord(aPosition);
    vMaskCoord = getFilterCoord(aPosition);
}
`, t2 = `struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct MaskUniforms {
  uFilterMatrix:mat3x3<f32>,
  uMaskClamp:vec4<f32>,
  uAlpha:f32,
  uInverse:f32,
  uChannel:f32,
};

@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;

@group(1) @binding(0) var<uniform> filterUniforms : MaskUniforms;
@group(1) @binding(1) var uMaskTexture: texture_2d<f32>;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>,
    @location(1) filterUv : vec2<f32>,
};

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);
}

fn getFilterCoord(aPosition:vec2<f32> ) -> vec2<f32>
{
  return ( filterUniforms.uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}

fn getSize() -> vec2<f32>
{
  return gfu.uGlobalFrame.zw;
}

@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>,
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition),
   getFilterCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @location(1) filterUv: vec2<f32>,
  @builtin(position) position: vec4<f32>
) -> @location(0) vec4<f32> {

    var maskClamp = filterUniforms.uMaskClamp;
    var uAlpha = filterUniforms.uAlpha;

    var clip = step(3.5,
      step(maskClamp.x, filterUv.x) +
      step(maskClamp.y, filterUv.y) +
      step(filterUv.x, maskClamp.z) +
      step(filterUv.y, maskClamp.w));

    var mask = textureSample(uMaskTexture, uSampler, filterUv);
    var source = textureSample(uTexture, uSampler, uv);

    var a: f32;
    if (filterUniforms.uChannel == 1.0) {
        a = mask.a * uAlpha * clip;
    } else {
        var alphaMul = 1.0 - uAlpha * (1.0 - mask.a);
        a = alphaMul * mask.r * uAlpha * clip;
    }

    if (filterUniforms.uInverse == 1.0) {
        a = 1.0 - a;
    }

    return source * a;
}
`;
class eX extends dS {
  constructor(e) {
    const { sprite: t, ...i } = e, s = new P8(t.texture), o = new ms({
      uFilterMatrix: { value: new st(), type: "mat3x3<f32>" },
      uMaskClamp: { value: s.uClampFrame, type: "vec4<f32>" },
      uAlpha: { value: 1, type: "f32" },
      uInverse: { value: e.inverse ? 1 : 0, type: "f32" },
      uChannel: { value: e.channel === "alpha" ? 1 : 0, type: "f32" }
    }), r = na.from({
      vertex: {
        source: t2,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: t2,
        entryPoint: "mainFragment"
      }
    }), a = $l.from({
      vertex: QY,
      fragment: ZY,
      name: "mask-filter"
    });
    super({
      ...i,
      gpuProgram: r,
      glProgram: a,
      clipToViewport: !1,
      resources: {
        filterUniforms: o,
        uMaskTexture: t.texture.source
      }
    }), this.sprite = t, this._textureMatrix = s;
  }
  /**
   * Rebinds the filter to a new mask sprite, moving the texture-matrix `update`
   * listener and the bind group's `change` subscription over to the new sprite's
   * texture. `apply` refreshes the same bindings on every use — this method exists
   * to release the previous sprite's texture immediately, without waiting for
   * (or requiring) another `apply`.
   * @param sprite - the sprite to mask with from now on.
   */
  setSprite(e) {
    this.sprite = e;
    const t = this._getSafeTexture();
    this._textureMatrix.texture = t, this.resources.uMaskTexture = t.source;
  }
  set inverse(e) {
    this.resources.filterUniforms.uniforms.uInverse = e ? 1 : 0;
  }
  get inverse() {
    return this.resources.filterUniforms.uniforms.uInverse === 1;
  }
  set channel(e) {
    this.resources.filterUniforms.uniforms.uChannel = e === "alpha" ? 1 : 0;
  }
  get channel() {
    return this.resources.filterUniforms.uniforms.uChannel === 1 ? "alpha" : "red";
  }
  apply(e, t, i, s) {
    const o = this._getSafeTexture();
    this._textureMatrix.texture = o, e.calculateSpriteMatrix(
      this.resources.filterUniforms.uniforms.uFilterMatrix,
      this.sprite
    ).prepend(this._textureMatrix.mapCoord), this.resources.uMaskTexture = o.source, e.applyFilter(this, t, i, s);
  }
  /**
   * The sprite's texture, or `Texture.EMPTY` when that texture has been destroyed —
   * a destroyed texture has no source left to sample, so the mask degrades to empty
   * rather than crashing the render.
   */
  _getSafeTexture() {
    const e = this.sprite.texture;
    return e.destroyed || !e.source || e.source.destroyed ? (at("[MaskFilter] The mask texture was destroyed while the mask is still in use. Remove the mask before destroying its texture."), Ze.EMPTY) : e;
  }
  destroy(e = !1) {
    this._textureMatrix.destroy(), super.destroy(e);
  }
}
class tX {
  constructor() {
    this.isBatchable = !1;
  }
  /**
   * Reset cached canvas data.
   * @advanced
   */
  reset() {
    this.isBatchable = !1, this.context = null, this.graphicsData && (this.graphicsData.destroy(), this.graphicsData = null);
  }
  /**
   * Destroy the cached data.
   * @advanced
   */
  destroy() {
    this.reset();
  }
}
class nX {
  constructor() {
    this.instructions = new S1();
  }
  /**
   * Initialize render data.
   * @advanced
   */
  init() {
    this.instructions.reset();
  }
  /**
   * Destroy render data.
   * @advanced
   */
  destroy() {
    this.instructions.destroy(), this.instructions = null;
  }
}
const H1 = class Fv {
  constructor(e) {
    this._renderer = e, this._managedContexts = new gs({ renderer: e, type: "resource", name: "graphicsContext" });
  }
  /**
   * Runner init called, update the default options
   * @ignore
   */
  init(e) {
    var t;
    Fv.defaultOptions.bezierSmoothness = (t = e == null ? void 0 : e.bezierSmoothness) != null ? t : Fv.defaultOptions.bezierSmoothness;
  }
  /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */
  getContextRenderData(e) {
    return this.getGpuContext(e).graphicsData || this._initContextRenderData(e);
  }
  /**
   * Updates the GPU context for a given GraphicsContext.
   * @param context - The GraphicsContext to update.
   * @returns The updated CanvasGraphicsContext.
   * @internal
   */
  updateGpuContext(e) {
    const t = e._gpuData, i = !!t[this._renderer.uid], s = t[this._renderer.uid] || this._initContext(e);
    return (e.dirty || !i) && (i && s.reset(), s.isBatchable = !1, e.dirty = !1), s;
  }
  /**
   * Returns the CanvasGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the CanvasGraphicsContext for.
   * @returns The CanvasGraphicsContext for the given GraphicsContext.
   * @internal
   */
  getGpuContext(e) {
    return e._gpuData[this._renderer.uid] || this._initContext(e);
  }
  _initContextRenderData(e) {
    const t = new nX(), i = this.getGpuContext(e);
    return i.graphicsData = t, t.init(), t;
  }
  _initContext(e) {
    const t = new tX();
    return t.context = e, e._gpuData[this._renderer.uid] = t, this._managedContexts.add(e), t;
  }
  destroy() {
    this._managedContexts.destroy(), this._renderer = null;
  }
};
H1.extension = {
  type: [
    Ae.CanvasSystem
  ],
  name: "graphicsContext"
};
H1.defaultOptions = {
  /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */
  bezierSmoothness: 0.5
};
let iX = H1;
class sT {
  constructor(e, t) {
    this.state = Zs.for2d(), this.renderer = e, this._adaptor = t, this.renderer.runners.contextChange.add(this), this._managedGraphics = new gs({ renderer: e, type: "renderable", priority: -1, name: "graphics" });
  }
  contextChange() {
    this._adaptor.contextChange(this.renderer);
  }
  validateRenderable(e) {
    return !1;
  }
  addRenderable(e, t) {
    this._managedGraphics.add(e), this.renderer.renderPipes.batch.break(t), t.add(e);
  }
  updateRenderable(e) {
  }
  execute(e) {
    e.isRenderable && this._adaptor.execute(this, e);
  }
  destroy() {
    this._managedGraphics.destroy(), this.renderer = null, this._adaptor.destroy(), this._adaptor = null;
  }
}
sT.extension = {
  type: [
    Ae.CanvasPipes
  ],
  name: "graphics"
};
function oT(n, e, t) {
  const i = (n >> 24 & 255) / 255;
  e[t++] = (n & 255) / 255 * i, e[t++] = (n >> 8 & 255) / 255 * i, e[t++] = (n >> 16 & 255) / 255 * i, e[t++] = i;
}
class sX {
  constructor() {
    this.batches = [], this.batched = !1;
  }
  destroy() {
    this.batches.forEach((e) => {
      Mn.return(e);
    }), this.batches.length = 0;
  }
}
class rT {
  constructor(e, t) {
    this.state = Zs.for2d(), this.renderer = e, this._adaptor = t, this.renderer.runners.contextChange.add(this), this._managedGraphics = new gs({ renderer: e, type: "renderable", priority: -1, name: "graphics" });
  }
  contextChange() {
    this._adaptor.contextChange(this.renderer);
  }
  validateRenderable(e) {
    const t = e.context, i = !!e._gpuData, o = this.renderer.graphicsContext.updateGpuContext(t);
    return !!(o.isBatchable || i !== o.isBatchable);
  }
  addRenderable(e, t) {
    const s = this.renderer.graphicsContext.updateGpuContext(e.context);
    (e.didViewUpdate || !e._gpuData[this.renderer.uid]) && this._rebuild(e), s.isBatchable ? this._addToBatcher(e, t) : (this.renderer.renderPipes.batch.break(t), t.add(e));
  }
  updateRenderable(e) {
    const i = this._getGpuDataForRenderable(e).batches;
    for (let s = 0; s < i.length; s++) {
      const o = i[s];
      o._batcher.updateElement(o);
    }
  }
  execute(e) {
    if (!e.isRenderable) return;
    const t = this.renderer, i = e.context;
    if (!t.graphicsContext.getGpuContext(i).batches.length)
      return;
    const o = i.customShader || this._adaptor.shader;
    this.state.blendMode = e.groupBlendMode;
    const r = o.resources.localUniforms.uniforms;
    r.uTransformMatrix = e.groupTransform, r.uRound = t._roundPixels | e._roundPixels, oT(
      e.groupColorAlpha,
      r.uColor,
      0
    ), this._adaptor.execute(this, e);
  }
  _rebuild(e) {
    const t = this._getGpuDataForRenderable(e), s = this.renderer.graphicsContext.updateGpuContext(e.context);
    t.destroy(), s.isBatchable && this._updateBatchesForRenderable(e, t);
  }
  _addToBatcher(e, t) {
    const i = this.renderer.renderPipes.batch, s = this._getGpuDataForRenderable(e).batches;
    for (let o = 0; o < s.length; o++) {
      const r = s[o];
      i.addToBatch(r, t);
    }
  }
  _getGpuDataForRenderable(e) {
    return e._gpuData[this.renderer.uid] || this._initGpuDataForRenderable(e);
  }
  _initGpuDataForRenderable(e) {
    const t = new sX();
    return e._gpuData[this.renderer.uid] = t, this._managedGraphics.add(e), t;
  }
  _updateBatchesForRenderable(e, t) {
    const i = e.context, o = this.renderer.graphicsContext.getGpuContext(i), r = this.renderer._roundPixels | e._roundPixels;
    t.batches = o.batches.map((a) => {
      const l = Mn.get(L1);
      return a.copyTo(l), l.renderable = e, l.roundPixels = r, l;
    });
  }
  destroy() {
    this._managedGraphics.destroy(), this.renderer = null, this._adaptor.destroy(), this._adaptor = null, this.state = null;
  }
}
rT.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes
  ],
  name: "graphics"
};
ct.add(sT);
ct.add(rT);
ct.add(iX);
ct.add(U1);
class Ro extends M1 {
  /**
   * Creates a new Graphics object.
   * @param options - Options for the Graphics.
   */
  constructor(e) {
    e instanceof sd && (e = { context: e });
    const { context: t, roundPixels: i, ...s } = e || {};
    super({
      label: "Graphics",
      ...s
    }), this.renderPipeId = "graphics", t ? this.context = t : (this.context = this._ownedContext = new sd(), this.context.autoGarbageCollect = this.autoGarbageCollect), this.didViewUpdate = !0, this.allowChildren = !1, this.roundPixels = i != null ? i : !1;
  }
  set context(e) {
    e !== this._context && (this._context && (this._context.off("update", this.onViewUpdate, this), this._context.off("unload", this.unload, this)), this._context = e, this._context.on("update", this.onViewUpdate, this), this._context.on("unload", this.unload, this), this.onViewUpdate());
  }
  /**
   * The underlying graphics context used for drawing operations.
   * Controls how shapes and paths are rendered.
   * @example
   * ```ts
   * // Create a shared context
   * const sharedContext = new GraphicsContext();
   *
   * // Create graphics objects sharing the same context
   * const graphics1 = new Graphics();
   * const graphics2 = new Graphics();
   *
   * // Assign shared context
   * graphics1.context = sharedContext;
   * graphics2.context = sharedContext;
   *
   * // Both graphics will show the same shapes
   * sharedContext
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   * ```
   * @see {@link GraphicsContext} For drawing operations
   * @see {@link GraphicsOptions} For context configuration
   */
  get context() {
    return this._context;
  }
  /**
   * The local bounds of the graphics object.
   * Returns the boundaries after all graphical operations but before any transforms.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Get bounds information
   * const bounds = graphics.bounds;
   * console.log(bounds.width);  // 100
   * console.log(bounds.height); // 100
   * ```
   * @readonly
   * @see {@link Bounds} For bounds operations
   * @see {@link Container#getBounds} For transformed bounds
   */
  get bounds() {
    return this._context.bounds;
  }
  /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */
  updateBounds() {
  }
  /**
   * Checks if the object contains the given point.
   * Returns true if the point lies within the Graphics object's rendered area.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Check point intersection
   * if (graphics.containsPoint({ x: 50, y: 50 })) {
   *     console.log('Point is inside rectangle!');
   * }
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is inside the Graphics object
   * @see {@link Graphics#bounds} For bounding box checks
   * @see {@link PointData} For point data structure
   */
  containsPoint(e) {
    return this._context.containsPoint(e);
  }
  /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @example
   * ```ts
   * // Destroy the graphics and its context
   * graphics.destroy();
   * graphics.destroy(true);
   * graphics.destroy({ context: true, texture: true, textureSource: true });
   * ```
   */
  destroy(e) {
    var t, i;
    this._ownedContext && !e ? this._ownedContext.destroy(e) : (e === !0 || (e == null ? void 0 : e.context) === !0) && this._context.destroy(e), (t = this._context) == null || t.off("update", this.onViewUpdate, this), (i = this._context) == null || i.off("unload", this.unload, this), this._ownedContext = null, this._context = null, super.destroy(e);
  }
  /**
   * @param now - The current time in milliseconds.
   * @internal
   */
  _onTouch(e) {
    this._gcLastUsed = e, this._context._gcLastUsed = e;
  }
  _callContextMethod(e, t) {
    return this.context[e](...t), this;
  }
  // --------------------------------------- GraphicsContext methods ---------------------------------------
  /**
   * Sets the current fill style of the graphics context.
   * The fill style can be a color, gradient, pattern, or a complex style object.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics
   *     .setFillStyle({ color: 0xff0000 }) // Red fill
   *     .rect(0, 0, 100, 100)
   *     .fill();
   *
   * // Gradient fill
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setFillStyle(gradient)
   *     .circle(100, 100, 50)
   *     .fill();
   *
   * // Pattern fill
   * const pattern = new FillPattern(texture);
   * graphics
   *     .setFillStyle({
   *         fill: pattern,
   *         alpha: 0.5
   *     })
   *     .rect(0, 0, 200, 200)
   *     .fill();
   * ```
   * @param {FillInput} args - The fill style to apply
   * @returns The Graphics instance for chaining
   * @see {@link FillStyle} For fill style options
   * @see {@link FillGradient} For gradient fills
   * @see {@link FillPattern} For pattern fills
   */
  setFillStyle(...e) {
    return this._callContextMethod("setFillStyle", e);
  }
  /**
   * Sets the current stroke style of the graphics context.
   * Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color stroke
   * graphics
   *     .setStrokeStyle({
   *         width: 2,
   *         color: 0x000000
   *     })
   *     .rect(0, 0, 100, 100)
   *     .stroke();
   *
   * // Complex stroke style
   * graphics
   *     .setStrokeStyle({
   *         width: 4,
   *         color: 0xff0000,
   *         alpha: 0.5,
   *         join: 'round',
   *         cap: 'round',
   *         alignment: 0.5
   *     })
   *     .circle(100, 100, 50)
   *     .stroke();
   *
   * // Gradient stroke
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setStrokeStyle({
   *         width: 10,
   *         fill: gradient
   *     })
   *     .poly([0,0, 100,50, 0,100])
   *     .stroke();
   * ```
   * @param {StrokeInput} args - The stroke style to apply
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link FillPattern} For pattern strokes
   */
  setStrokeStyle(...e) {
    return this._callContextMethod("setStrokeStyle", e);
  }
  fill(...e) {
    return this._callContextMethod("fill", e);
  }
  /**
   * Strokes the current path with the current stroke style or specified style.
   * Outlines the shape using the stroke settings.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Stroke with direct color
   * graphics
   *     .circle(50, 50, 25)
   *     .stroke({
   *         width: 2,
   *         color: 0xff0000
   *     }); // 2px red stroke
   *
   * // Fill with texture
   * graphics
   *    .rect(0, 0, 100, 100)
   *    .stroke(myTexture); // Fill with texture
   *
   * // Stroke with gradient
   * const gradient = new FillGradient({
   *     end: { x: 1, y: 0 },
   *     colorStops: [
   *         { offset: 0, color: 0xff0000 },
   *         { offset: 0.5, color: 0x00ff00 },
   *         { offset: 1, color: 0x0000ff },
   *     ],
   * });
   *
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .stroke({
   *         width: 4,
   *         fill: gradient,
   *         alignment: 0.5,
   *         join: 'round'
   *     });
   * ```
   * @param {StrokeStyle} args - Optional stroke style to apply. Can be:
   * - A stroke style object with width, color, etc.
   * - A gradient
   * - A pattern
   * If omitted, uses current stroke style.
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link setStrokeStyle} For setting default stroke style
   */
  stroke(...e) {
    return this._callContextMethod("stroke", e);
  }
  texture(...e) {
    return this._callContextMethod("texture", e);
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @example
   * ```ts
   * const graphics = new Graphics();
   * graphics
   *     .circle(150, 150, 50)
   *     .fill({ color: 0x00ff00 })
   *     .beginPath() // Starts a new path
   *     .circle(250, 150, 50)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for chaining
   * @see {@link Graphics#moveTo} For starting a new subpath
   * @see {@link Graphics#closePath} For closing the current path
   */
  beginPath() {
    return this._callContextMethod("beginPath", []);
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path.
   *
   * If a hole is not completely in a shape, it will fail to cut correctly.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw outer circle
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *     .circle(100, 100, 25) // Inner circle
   *     .cut() // Cuts out the inner circle from the outer circle
   * ```
   */
  cut() {
    return this._callContextMethod("cut", []);
  }
  arc(...e) {
    return this._callContextMethod("arc", e);
  }
  arcTo(...e) {
    return this._callContextMethod("arcTo", e);
  }
  arcToSvg(...e) {
    return this._callContextMethod("arcToSvg", e);
  }
  bezierCurveTo(...e) {
    return this._callContextMethod("bezierCurveTo", e);
  }
  /**
   * Closes the current path by drawing a straight line back to the start point.
   *
   * This is useful for completing shapes and ensuring they are properly closed for fills.
   * @example
   * ```ts
   * // Create a triangle with closed path
   * const graphics = new Graphics();
   * graphics
   *     .moveTo(50, 50)
   *     .lineTo(100, 100)
   *     .lineTo(0, 100)
   *     .closePath()
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path
   * @see {@link Graphics#fill} For filling closed paths
   * @see {@link Graphics#stroke} For stroking paths
   */
  closePath() {
    return this._callContextMethod("closePath", []);
  }
  ellipse(...e) {
    return this._callContextMethod("ellipse", e);
  }
  circle(...e) {
    return this._callContextMethod("circle", e);
  }
  path(...e) {
    return this._callContextMethod("path", e);
  }
  lineTo(...e) {
    return this._callContextMethod("lineTo", e);
  }
  moveTo(...e) {
    return this._callContextMethod("moveTo", e);
  }
  quadraticCurveTo(...e) {
    return this._callContextMethod("quadraticCurveTo", e);
  }
  rect(...e) {
    return this._callContextMethod("rect", e);
  }
  roundRect(...e) {
    return this._callContextMethod("roundRect", e);
  }
  poly(...e) {
    return this._callContextMethod("poly", e);
  }
  regularPoly(...e) {
    return this._callContextMethod("regularPoly", e);
  }
  roundPoly(...e) {
    return this._callContextMethod("roundPoly", e);
  }
  roundShape(...e) {
    return this._callContextMethod("roundShape", e);
  }
  filletRect(...e) {
    return this._callContextMethod("filletRect", e);
  }
  chamferRect(...e) {
    return this._callContextMethod("chamferRect", e);
  }
  star(...e) {
    return this._callContextMethod("star", e);
  }
  svg(...e) {
    return this._callContextMethod("svg", e);
  }
  restore(...e) {
    return this._callContextMethod("restore", e);
  }
  /**
   * Saves the current graphics state onto a stack. The state includes:
   * - Current transformation matrix
   * - Current fill style
   * - Current stroke style
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Save state before complex operations
   * graphics.save();
   *
   * // Create transformed and styled shape
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4)
   *     .setFillStyle({
   *         color: 0xff0000,
   *         alpha: 0.5
   *     })
   *     .rect(-25, -25, 50, 50)
   *     .fill();
   *
   * // Restore to original state
   * graphics.restore();
   *
   * // Continue drawing with previous state
   * graphics
   *     .circle(50, 50, 25)
   *     .fill();
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#restore} For restoring the saved state
   * @see {@link Graphics#setTransform} For setting transformations
   */
  save() {
    return this._callContextMethod("save", []);
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * This matrix represents all accumulated transformations including translate, scale, and rotate.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply some transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4);
   *
   * // Get the current transform matrix
   * const matrix = graphics.getTransform();
   * console.log(matrix.tx, matrix.ty); // 100, 100
   *
   * // Use the matrix for other operations
   * graphics
   *     .setTransform(matrix)
   *     .circle(0, 0, 50)
   *     .fill({ color: 0xff0000 });
   * ```
   * @returns The current transformation matrix.
   * @see {@link Graphics#setTransform} For setting the transform matrix
   * @see {@link Matrix} For matrix operations
   */
  getTransform() {
    return this.context.getTransform();
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .scaleTransform(2, 2)
   *     .circle(0, 0, 25)
   *     .fill({ color: 0xff0000 });
   * // Reset transform to default state
   * graphics
   *     .resetTransform()
   *     .circle(50, 50, 25) // Will draw at actual coordinates
   *     .fill({ color: 0x00ff00 });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#getTransform} For getting the current transform
   * @see {@link Graphics#setTransform} For setting a specific transform
   * @see {@link Graphics#save} For saving the current transform state
   * @see {@link Graphics#restore} For restoring a previous transform state
   */
  resetTransform() {
    return this._callContextMethod("resetTransform", []);
  }
  rotateTransform(...e) {
    return this._callContextMethod("rotate", e);
  }
  scaleTransform(...e) {
    return this._callContextMethod("scale", e);
  }
  setTransform(...e) {
    return this._callContextMethod("setTransform", e);
  }
  transform(...e) {
    return this._callContextMethod("transform", e);
  }
  translateTransform(...e) {
    return this._callContextMethod("translate", e);
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it.
   * This includes clearing the current path, fill style, stroke style, and transformations.
   *
   * > [!NOTE] Graphics objects are not designed to be continuously cleared and redrawn.
   * > Instead, they are intended to be used for static or semi-static graphics that
   * > can be redrawn as needed. Frequent clearing and redrawing may lead to performance issues.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw some shapes
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 })
   *     .rect(200, 100, 100, 50)
   *     .fill({ color: 0x00ff00 });
   *
   * // Clear all graphics
   * graphics.clear();
   *
   * // Start fresh with new shapes
   * graphics
   *     .circle(150, 150, 30)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path without clearing styles
   * @see {@link Graphics#save} For saving the current state
   * @see {@link Graphics#restore} For restoring a previous state
   */
  clear() {
    return this._callContextMethod("clear", []);
  }
  /**
   * Gets or sets the current fill style for the graphics context. The fill style determines
   * how shapes are filled when using the fill() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics.fillStyle = {
   *     color: 0xff0000,  // Red
   *     alpha: 1
   * };
   *
   * // Using gradients
   * const gradient = new FillGradient({
   *     end: { x: 0, y: 1 }, // Vertical gradient
   *     stops: [
   *         { offset: 0, color: 0xff0000, alpha: 1 }, // Start color
   *         { offset: 1, color: 0x0000ff, alpha: 1 }  // End color
   *     ]
   * });
   *
   * graphics.fillStyle = {
   *     fill: gradient,
   *     alpha: 0.8
   * };
   *
   * // Using patterns
   * graphics.fillStyle = {
   *     texture: myTexture,
   *     alpha: 1,
   *     matrix: new Matrix()
   *         .scale(0.5, 0.5)
   *         .rotate(Math.PI / 4)
   * };
   * ```
   * @type {ConvertedFillStyle}
   * @see {@link FillStyle} For all available fill style options
   * @see {@link FillGradient} For creating gradient fills
   * @see {@link Graphics#fill} For applying the fill to paths
   */
  get fillStyle() {
    return this._context.fillStyle;
  }
  set fillStyle(e) {
    this._context.fillStyle = e;
  }
  /**
   * Gets or sets the current stroke style for the graphics context. The stroke style determines
   * how paths are outlined when using the stroke() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic stroke style
   * graphics.strokeStyle = {
   *     width: 2,
   *     color: 0xff0000,
   *     alpha: 1
   * };
   *
   * // Using with gradients
   * const gradient = new FillGradient({
   *   end: { x: 0, y: 1 },
   *   stops: [
   *       { offset: 0, color: 0xff0000, alpha: 1 },
   *       { offset: 1, color: 0x0000ff, alpha: 1 }
   *   ]
   * });
   *
   * graphics.strokeStyle = {
   *     width: 4,
   *     fill: gradient,
   *     alignment: 0.5,
   *     join: 'round',
   *     cap: 'round'
   * };
   *
   * // Complex stroke settings
   * graphics.strokeStyle = {
   *     width: 6,
   *     color: 0x00ff00,
   *     alpha: 0.5,
   *     join: 'miter',
   *     miterLimit: 10,
   * };
   * ```
   * @see {@link StrokeStyle} For all available stroke style options
   * @see {@link Graphics#stroke} For applying the stroke to paths
   */
  get strokeStyle() {
    return this._context.strokeStyle;
  }
  set strokeStyle(e) {
    this._context.strokeStyle = e;
  }
  /**
   * Creates a new Graphics object that copies the current graphics content.
   * The clone can either share the same context (shallow clone) or have its own independent
   * context (deep clone).
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Create original graphics content
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *
   * // Create a shallow clone (shared context)
   * const shallowClone = graphics.clone();
   *
   * // Changes to original affect the clone
   * graphics
   *     .circle(200, 100, 30)
   *     .fill({ color: 0x00ff00 });
   *
   * // Create a deep clone (independent context)
   * const deepClone = graphics.clone(true);
   *
   * // Modify deep clone independently
   * deepClone
   *     .translateTransform(100, 100)
   *     .circle(0, 0, 40)
   *     .fill({ color: 0x0000ff });
   * ```
   * @param deep - Whether to create a deep clone of the graphics object.
   *              If false (default), the context will be shared between objects.
   *              If true, creates an independent copy of the context.
   * @returns A new Graphics instance with either shared or copied context
   * @see {@link Graphics#context} For accessing the underlying graphics context
   * @see {@link GraphicsContext} For understanding the shared context behavior
   */
  clone(e = !1) {
    return e ? new Ro(this._context.clone()) : (this._ownedContext = null, new Ro(this._context));
  }
  // -------- v7 deprecations ---------
  /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */
  lineStyle(e, t, i) {
    rt(on, "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
    const s = {};
    return e && (s.width = e), t && (s.color = t), i && (s.alpha = i), this.context.strokeStyle = s, this;
  }
  /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  beginFill(e, t) {
    rt(on, "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
    const i = {};
    return e !== void 0 && (i.color = e), t !== void 0 && (i.alpha = t), this.context.fillStyle = i, this;
  }
  /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  endFill() {
    rt(on, "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style."), this.context.fill();
    const e = this.context.strokeStyle;
    return (e.width !== sd.defaultStrokeStyle.width || e.color !== sd.defaultStrokeStyle.color || e.alpha !== sd.defaultStrokeStyle.alpha) && this.context.stroke(), this;
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */
  drawCircle(...e) {
    return rt(on, "Graphics#drawCircle has been renamed to Graphics#circle"), this._callContextMethod("circle", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */
  drawEllipse(...e) {
    return rt(on, "Graphics#drawEllipse has been renamed to Graphics#ellipse"), this._callContextMethod("ellipse", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */
  drawPolygon(...e) {
    return rt(on, "Graphics#drawPolygon has been renamed to Graphics#poly"), this._callContextMethod("poly", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */
  drawRect(...e) {
    return rt(on, "Graphics#drawRect has been renamed to Graphics#rect"), this._callContextMethod("rect", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */
  drawRoundedRect(...e) {
    return rt(on, "Graphics#drawRoundedRect has been renamed to Graphics#roundRect"), this._callContextMethod("roundRect", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */
  drawStar(...e) {
    return rt(on, "Graphics#drawStar has been renamed to Graphics#star"), this._callContextMethod("star", e);
  }
}
const aT = class lT extends Gf {
  constructor(...e) {
    var c;
    let t = (c = e[0]) != null ? c : {};
    t instanceof Float32Array && (rt(on, "use new MeshGeometry({ positions, uvs, indices }) instead"), t = {
      positions: t,
      uvs: e[1],
      indices: e[2]
    }), t = { ...lT.defaultOptions, ...t };
    const i = t.positions || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
    let s = t.uvs;
    s || (t.positions ? s = new Float32Array(i.length) : s = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]));
    const o = t.indices || new Uint32Array([0, 1, 2, 0, 2, 3]), r = t.shrinkBuffersToFit, a = new Gi({
      data: i,
      label: "attribute-mesh-positions",
      shrinkToFit: r,
      usage: Et.VERTEX | Et.COPY_DST
    }), l = new Gi({
      data: s,
      label: "attribute-mesh-uvs",
      shrinkToFit: r,
      usage: Et.VERTEX | Et.COPY_DST
    }), d = new Gi({
      data: o,
      label: "index-mesh-buffer",
      shrinkToFit: r,
      usage: Et.INDEX | Et.COPY_DST
    });
    super({
      attributes: {
        aPosition: {
          buffer: a,
          format: "float32x2",
          stride: 8,
          offset: 0
        },
        aUV: {
          buffer: l,
          format: "float32x2",
          stride: 8,
          offset: 0
        }
      },
      indexBuffer: d,
      topology: t.topology
    }), this.batchMode = "auto";
  }
  /** The positions of the mesh. */
  get positions() {
    return this.attributes.aPosition.buffer.data;
  }
  /**
   * Set the positions of the mesh.
   * When setting the positions, its important that the uvs array is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The positions of the mesh.
   */
  set positions(e) {
    this.attributes.aPosition.buffer.data = e;
  }
  /** The UVs of the mesh. */
  get uvs() {
    return this.attributes.aUV.buffer.data;
  }
  /**
   * Set the UVs of the mesh.
   * Its important that the uvs array you set is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The UVs of the mesh.
   */
  set uvs(e) {
    this.attributes.aUV.buffer.data = e;
  }
  /** The indices of the mesh. */
  get indices() {
    return this.indexBuffer.data;
  }
  set indices(e) {
    this.indexBuffer.data = e;
  }
};
aT.defaultOptions = {
  topology: "triangle-list",
  shrinkBuffersToFit: !1
};
let oX = aT;
class rX {
  constructor() {
    this.batcherName = "default", this.packAsQuad = !1, this.indexOffset = 0, this.attributeOffset = 0, this.roundPixels = 0, this._batcher = null, this._batch = null, this._textureMatrixUpdateId = -1, this._uvUpdateId = -1;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get topology() {
    return this._topology || this.geometry.topology;
  }
  set topology(e) {
    this._topology = e;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.geometry = null, this._uvUpdateId = -1, this._textureMatrixUpdateId = -1;
  }
  /**
   * Sets the texture for the batchable mesh.
   * As it does so, it resets the texture matrix update ID.
   * this is to ensure that the texture matrix is recalculated when the uvs are referenced
   * @param value - The texture to set.
   */
  setTexture(e) {
    this.texture !== e && (this.texture = e, this._textureMatrixUpdateId = -1);
  }
  get uvs() {
    const t = this.geometry.getBuffer("aUV"), i = t.data;
    let s = i;
    const o = this.texture.textureMatrix;
    return o.isSimple || (s = this._transformedUvs, (this._textureMatrixUpdateId !== o._updateID || this._uvUpdateId !== t._updateID) && ((!s || s.length < i.length) && (s = this._transformedUvs = new Float32Array(i.length)), this._textureMatrixUpdateId = o._updateID, this._uvUpdateId = t._updateID, o.multiplyUvs(i, s))), s;
  }
  get positions() {
    return this.geometry.positions;
  }
  get indices() {
    return this.geometry.indices;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  get groupTransform() {
    return this.renderable.groupTransform;
  }
  get attributeSize() {
    return this.geometry.positions.length / 2;
  }
  get indexSize() {
    return this.geometry.indices.length;
  }
}
const Xh = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* wgsl */
      `

            struct LocalUniforms {
                uTransformMatrix:mat3x3<f32>,
                uColor:vec4<f32>,
                uRound:f32,
            }

            @group(1) @binding(0) var<uniform> localUniforms : LocalUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= localUniforms.uColor;
            modelMatrix *= localUniforms.uTransformMatrix;
        `
    ),
    end: (
      /* wgsl */
      `
            if(localUniforms.uRound == 1)
            {
                vPosition = vec4(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
            }
        `
    )
  }
}, aX = {
  ...Xh,
  vertex: {
    ...Xh.vertex,
    // replace the group!
    header: Xh.vertex.header.replace("group(1)", "group(2)")
  }
}, dT = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* glsl */
      `

            uniform mat3 uTransformMatrix;
            uniform vec4 uColor;
            uniform float uRound;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= uColor;
            modelMatrix = uTransformMatrix;
        `
    ),
    end: (
      /* glsl */
      `
            if(uRound == 1.)
            {
                gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
            }
        `
    )
  }
};
class cT {
  constructor() {
    this.batcherName = "default", this.topology = "triangle-list", this.attributeSize = 4, this.indexSize = 6, this.packAsQuad = !0, this.roundPixels = 0, this._attributeStart = 0, this._batcher = null, this._batch = null;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.bounds = null;
  }
  destroy() {
    this.reset();
  }
}
function lX() {
  const { userAgent: n } = Pt.get().getNavigator();
  return /^((?!chrome|android).)*safari/i.test(n);
}
const V1 = class xr {
  static _getPatternRepeat(e, t) {
    const i = e && e !== "clamp-to-edge", s = t && t !== "clamp-to-edge";
    return i && s ? "repeat" : i ? "repeat-x" : s ? "repeat-y" : "no-repeat";
  }
  start(e, t, i) {
  }
  execute(e, t) {
    var a, l, d, c, u, p, f, y, b, w;
    const i = t.elements;
    if (!i || !i.length) return;
    const s = e.renderer, o = s.canvasContext, r = o.activeContext;
    for (let k = 0; k < i.length; k++) {
      const S = i[k];
      if (!S.packAsQuad) continue;
      const _ = S, x = _.texture, T = x ? yt.getCanvasSource(x) : null;
      if (!T) continue;
      const M = x.source.style, z = o.smoothProperty, P = M.scaleMode !== "nearest";
      r[z] !== P && (r[z] = P), o.setBlendMode(t.blendMode);
      const D = (l = (a = s.globalUniforms.globalUniformData) == null ? void 0 : a.worldColor) != null ? l : 4294967295, $ = _.color, O = (D >>> 24 & 255) / 255, L = ($ >>> 24 & 255) / 255, Z = (c = (d = s.filter) == null ? void 0 : d.alphaMultiplier) != null ? c : 1, J = O * L * Z;
      if (J <= 0) continue;
      r.globalAlpha = J;
      const re = D & 16777215, F = $ & 16777215, W = Wr(Vr(F, re)), ee = x.frame, N = (u = M.addressModeU) != null ? u : M.addressMode, te = (p = M.addressModeV) != null ? p : M.addressMode, G = xr._getPatternRepeat(N, te), q = (y = (f = x.source._resolution) != null ? f : x.source.resolution) != null ? y : 1, B = (w = (b = _.renderable) == null ? void 0 : b.renderGroup) == null ? void 0 : w.isCachedAsTexture, ne = ee.x * q, se = ee.y * q, Y = ee.width * q, ie = ee.height * q, De = _.bounds, xe = s.renderTarget.renderTarget.isRoot, Oe = De.minX, Ee = De.minY, j = De.maxX - De.minX, V = De.maxY - De.minY, Q = x.rotate, oe = x.uvs, ue = Math.min(oe.x0, oe.x1, oe.x2, oe.x3, oe.y0, oe.y1, oe.y2, oe.y3), Ie = Math.max(oe.x0, oe.x1, oe.x2, oe.x3, oe.y0, oe.y1, oe.y2, oe.y3), he = G !== "no-repeat" && (ue < 0 || Ie > 1), fe = Q && !(!he && (W !== 16777215 || Q));
      fe ? (xr._tempPatternMatrix.copyFrom(_.transform), wt.matrixAppendRotationInv(
        xr._tempPatternMatrix,
        Q,
        Oe,
        Ee,
        j,
        V
      ), o.setContextTransform(
        xr._tempPatternMatrix,
        _.roundPixels === 1,
        void 0,
        B && xe
      )) : o.setContextTransform(
        _.transform,
        _.roundPixels === 1,
        void 0,
        B && xe
      );
      const ze = j, He = V;
      let ce = fe ? 0 : Oe, be = fe ? 0 : Ee;
      if (!fe && _.roundPixels === 1 && (ce |= 0, be |= 0), he) {
        let Be = T;
        const Fe = W !== 16777215 && !Q, Ke = ee.width <= x.source.width && ee.height <= x.source.height;
        Fe && Ke && (Be = yt.getTintedCanvas({ texture: x }, W));
        const Qe = r.createPattern(Be, G);
        if (!Qe) continue;
        const ht = ze, Le = He;
        if (ht === 0 || Le === 0) continue;
        const Ne = 1 / ht, le = 1 / Le, ve = (oe.x1 - oe.x0) * Ne, we = (oe.y1 - oe.y0) * Ne, je = (oe.x3 - oe.x0) * le, Se = (oe.y3 - oe.y0) * le, Te = oe.x0 - ve * ce - je * be, ae = oe.y0 - we * ce - Se * be, Me = x.source.pixelWidth, Xe = x.source.pixelHeight;
        xr._tempPatternMatrix.set(
          ve * Me,
          we * Xe,
          je * Me,
          Se * Xe,
          Te * Me,
          ae * Xe
        ), yt.applyPatternTransform(Qe, xr._tempPatternMatrix), r.fillStyle = Qe, r.fillRect(ce, be, ze, He);
      } else {
        const Fe = W !== 16777215 || Q ? yt.getTintedCanvas({ texture: x }, W) : T, Ke = Fe !== T;
        r.drawImage(
          Fe,
          Ke ? 0 : ne,
          Ke ? 0 : se,
          Ke ? Fe.width : Y,
          Ke ? Fe.height : ie,
          ce,
          be,
          ze,
          He
        );
      }
    }
  }
};
V1._tempPatternMatrix = new st();
V1.extension = {
  type: [
    Ae.CanvasPipesAdaptor
  ],
  name: "batch"
};
let dX = V1;
class uT {
  constructor() {
    this._tempState = Zs.for2d(), this._didUploadHash = {};
  }
  init(e) {
    e.renderer.runners.contextChange.add(this);
  }
  contextChange() {
    this._didUploadHash = {};
  }
  start(e, t, i) {
    const s = e.renderer, o = this._didUploadHash[i.uid];
    s.shader.bind(i, o), o || (this._didUploadHash[i.uid] = !0), s.shader.updateUniformGroup(s.globalUniforms.uniformGroup), s.geometry.bind(t, i.glProgram);
  }
  execute(e, t) {
    const i = e.renderer;
    this._tempState.blendMode = t.blendMode, i.state.set(this._tempState);
    const s = t.textures.textures;
    for (let o = 0; o < t.textures.count; o++)
      i.texture.bind(s[o], o);
    i.texture.unbindIntegerTextures(t.textures.count), i.geometry.draw(t.topology, t.size, t.start);
  }
}
uT.extension = {
  type: [
    Ae.WebGLPipesAdaptor
  ],
  name: "batch"
};
const Uu = Zs.for2d();
class hT {
  start(e, t, i) {
    const s = e.renderer, o = s.encoder, r = i.gpuProgram;
    this._shader = i, this._geometry = t, o.setGeometry(t, r), Uu.blendMode = "normal", s.pipeline.getPipeline(
      t,
      r,
      Uu,
      void 0,
      i._overrides
    );
    const a = s.globalUniforms.bindGroup;
    o.resetBindGroup(1), o.setBindGroup(0, a, r);
  }
  execute(e, t) {
    const i = this._shader.gpuProgram, s = e.renderer, o = s.encoder;
    if (!t.bindGroup) {
      const l = t.textures;
      t.bindGroup = E1(
        l.textures,
        l.count,
        s.limits.maxBatchableTextures
      );
    }
    Uu.blendMode = t.blendMode;
    const r = s.bindGroup.getBindGroup(
      t.bindGroup,
      i,
      1
    ), a = s.pipeline.getPipeline(
      this._geometry,
      i,
      Uu,
      t.topology,
      this._shader._overrides
    );
    t.bindGroup._touch(s.gc.now), o.setPipeline(a), o.renderPassEncoder.setBindGroup(1, r), o.renderPassEncoder.drawIndexed(t.size, 1, t.start);
  }
}
hT.extension = {
  type: [
    Ae.WebGPUPipesAdaptor
  ],
  name: "batch"
};
const W1 = class pT {
  constructor(e, t) {
    var i, s;
    this.state = Zs.for2d(), this._batchersByInstructionSet = /* @__PURE__ */ Object.create(null), this._activeBatches = /* @__PURE__ */ Object.create(null), this.renderer = e, this._adaptor = t, (s = (i = this._adaptor).init) == null || s.call(i, this);
  }
  static getBatcher(e, t) {
    return new this._availableBatchers[e]({ maxTextures: t });
  }
  buildStart(e) {
    let t = this._batchersByInstructionSet[e.uid];
    t || (t = this._batchersByInstructionSet[e.uid] = /* @__PURE__ */ Object.create(null), t.default || (t.default = new O1({
      maxTextures: this.renderer.limits.maxBatchableTextures
    }))), this._activeBatches = t, this._activeBatch = this._activeBatches.default;
    for (const i in this._activeBatches)
      this._activeBatches[i].begin();
  }
  addToBatch(e, t) {
    if (this._activeBatch.name !== e.batcherName) {
      this._activeBatch.break(t);
      let i = this._activeBatches[e.batcherName];
      i || (i = this._activeBatches[e.batcherName] = pT.getBatcher(e.batcherName, this.renderer.limits.maxBatchableTextures), i.begin()), this._activeBatch = i;
    }
    this._activeBatch.add(e);
  }
  break(e) {
    this._activeBatch.break(e);
  }
  buildEnd(e) {
    this._activeBatch.break(e);
    const t = this._activeBatches;
    for (const i in t) {
      const s = t[i], o = s.geometry;
      o.indexBuffer.setDataWithSize(s.indexBuffer, s.indexSize, !0), o.buffers[0].setDataWithSize(s.attributeBuffer.float32View, s.attributeSize, !1);
    }
  }
  upload(e) {
    const t = this._batchersByInstructionSet[e.uid];
    for (const i in t) {
      const s = t[i], o = s.geometry;
      s.dirty && (s.dirty = !1, o.buffers[0].update(s.attributeSize * 4));
    }
  }
  execute(e) {
    if (e.action === "startBatch") {
      const t = e.batcher, i = t.geometry, s = t.shader;
      this._adaptor.start(this, i, s);
    }
    this._adaptor.execute(this, e);
  }
  /**
   * Releases all batchers cached for the given InstructionSet. Called from
   * `InstructionSet.destroy()` so that batchers (and their GPU geometry / attribute
   * buffers / referenced textures) do not leak when the owning RenderGroup is destroyed.
   * @param instructionSet - the instruction set being destroyed
   */
  destroyInstructionSet(e) {
    const t = this._batchersByInstructionSet[e.uid];
    if (t) {
      for (const i in t)
        t[i].destroy();
      delete this._batchersByInstructionSet[e.uid], this._activeBatches === t && (this._activeBatches = /* @__PURE__ */ Object.create(null), this._activeBatch = null);
    }
  }
  destroy() {
    this.state = null, this.renderer = null, this._adaptor = null;
    for (const e in this._activeBatches)
      this._activeBatches[e].destroy();
    this._activeBatches = null;
  }
};
W1.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "batch"
};
W1._availableBatchers = /* @__PURE__ */ Object.create(null);
let q1 = W1;
ct.handleByMap(Ae.Batcher, q1._availableBatchers);
ct.add(O1);
const cX = {
  name: "texture-bit",
  vertex: {
    header: (
      /* wgsl */
      `

        struct TextureUniforms {
            uTextureMatrix:mat3x3<f32>,
        }

        @group(2) @binding(2) var<uniform> textureUniforms : TextureUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            uv = (textureUniforms.uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* wgsl */
      `
            @group(2) @binding(0) var uTexture: texture_2d<f32>;
            @group(2) @binding(1) var uSampler: sampler;


        `
    ),
    main: (
      /* wgsl */
      `
            outColor = textureSample(uTexture, uSampler, vUV);
        `
    )
  }
}, uX = {
  name: "texture-bit",
  vertex: {
    header: (
      /* glsl */
      `
            uniform mat3 uTextureMatrix;
        `
    ),
    main: (
      /* glsl */
      `
            uv = (uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* glsl */
      `
        uniform sampler2D uTexture;


        `
    ),
    main: (
      /* glsl */
      `
            outColor = texture(uTexture, vUV);
        `
    )
  }
}, hX = new On();
class pX extends Bp {
  constructor() {
    super(), this._placeholderSprite = new ds(Ze.EMPTY), this.filters = [new eX({
      sprite: this._placeholderSprite,
      inverse: !1,
      resolution: "inherit",
      antialias: "inherit"
    })];
  }
  get sprite() {
    return this.filters[0].sprite;
  }
  set sprite(e) {
    this.filters[0].setSprite(e);
  }
  get inverse() {
    return this.filters[0].inverse;
  }
  set inverse(e) {
    this.filters[0].inverse = e;
  }
  get channel() {
    return this.filters[0].channel;
  }
  set channel(e) {
    this.filters[0].channel = e;
  }
  /**
   * Called by {@link BigPool} when the pipe returns the effect: parks the filter
   * on the empty placeholder so a pooled effect keeps no bindings to the last
   * mask it applied. Without this, the pooled filter pins the mask sprite and
   * its texture for as long as the effect sits in the pool, and destroying that
   * texture's source hits a bind group subscription the user cannot release.
   */
  reset() {
    this._placeholderSprite.texture = Ze.EMPTY, this.sprite = this._placeholderSprite;
  }
}
class K1 {
  constructor(e) {
    this._activeMaskStage = [], this._usedEffects = [], this._renderer = e, e.runners.postrender.add(this);
  }
  push(e, t, i) {
    var o;
    const s = this._renderer;
    if (s.renderPipes.batch.break(i), i.add({
      renderPipeId: "alphaMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1,
      maskedContainer: t
    }), e.inverse = t._maskOptions.inverse, e.channel = (o = t._maskOptions.channel) != null ? o : "red", e.renderMaskToTexture) {
      const r = e.mask;
      r.includeInBuild = !0, r.collectRenderables(
        i,
        s,
        null
      ), r.includeInBuild = !1;
    }
    s.renderPipes.batch.break(i), i.add({
      renderPipeId: "alphaMask",
      action: "pushMaskEnd",
      mask: e,
      maskedContainer: t,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "alphaMask",
      action: "popMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  execute(e) {
    const t = this._renderer, i = e.mask.renderMaskToTexture;
    if (e.action === "pushMaskBegin") {
      const s = Mn.get(pX);
      if (s.inverse = e.inverse, s.channel = e.mask.channel, i) {
        e.mask.mask.measurable = !0;
        const o = w1(e.mask.mask, !0, hX);
        e.mask.mask.measurable = !1, o.ceil();
        const r = t.renderTarget.renderTarget.colorTexture.source, a = Rn.getOptimalTexture({
          width: o.width,
          height: o.height,
          resolution: r._resolution,
          antialias: r.antialias
        });
        t.renderTarget.push({ target: a, clear: !0 }), t.globalUniforms.push({
          offset: o,
          worldColor: 4294967295
        });
        const l = s.sprite;
        l.texture = a, l.worldTransform.tx = o.minX, l.worldTransform.ty = o.minY, this._activeMaskStage.push({
          filterEffect: s,
          maskedContainer: e.maskedContainer,
          filterTexture: a
        });
      } else
        s.sprite = e.mask.mask, this._activeMaskStage.push({
          filterEffect: s,
          maskedContainer: e.maskedContainer
        });
    } else if (e.action === "pushMaskEnd") {
      const s = this._activeMaskStage[this._activeMaskStage.length - 1];
      i && (t.type === Vi.WEBGL && t.renderTarget.finishRenderPass(), t.renderTarget.pop(), t.globalUniforms.pop()), t.filter.push({
        renderPipeId: "filter",
        action: "pushFilter",
        container: s.maskedContainer,
        filterEffect: s.filterEffect,
        canBundle: !1
      });
    } else if (e.action === "popMaskEnd") {
      t.filter.pop();
      const s = this._activeMaskStage.pop();
      i && Rn.returnTexture(s.filterTexture), this._usedEffects.push(s.filterEffect);
    }
  }
  postrender() {
    const e = this._usedEffects;
    for (let t = 0; t < e.length; t++)
      Mn.return(e[t]);
    e.length = 0;
  }
  destroy() {
    this.postrender(), this._renderer.runners.postrender.remove(this), this._renderer = null, this._activeMaskStage = null, this._usedEffects = null;
  }
}
K1.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "alphaMask"
};
class fT {
  constructor(e) {
    this._colorStack = [], this._colorStackIndex = 0, this._currentColor = 0, this._renderer = e;
  }
  buildStart() {
    this._colorStack[0] = 15, this._colorStackIndex = 1, this._currentColor = 15;
  }
  push(e, t, i) {
    this._renderer.renderPipes.batch.break(i);
    const s = this._colorStack;
    s[this._colorStackIndex] = s[this._colorStackIndex - 1] & e.mask;
    const o = this._colorStack[this._colorStackIndex];
    o !== this._currentColor && (this._currentColor = o, i.add({
      renderPipeId: "colorMask",
      colorMask: o,
      canBundle: !1
    })), this._colorStackIndex++;
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i);
    const s = this._colorStack;
    this._colorStackIndex--;
    const o = s[this._colorStackIndex - 1];
    o !== this._currentColor && (this._currentColor = o, i.add({
      renderPipeId: "colorMask",
      colorMask: o,
      canBundle: !1
    }));
  }
  execute(e) {
  }
  destroy() {
    this._renderer = null, this._colorStack = null;
  }
}
fT.extension = {
  type: [
    Ae.CanvasPipes
  ],
  name: "colorMask"
};
class mT {
  constructor(e) {
    this._colorStack = [], this._colorStackIndex = 0, this._currentColor = 0, this._renderer = e;
  }
  buildStart() {
    this._colorStack[0] = 15, this._colorStackIndex = 1, this._currentColor = 15;
  }
  push(e, t, i) {
    this._renderer.renderPipes.batch.break(i);
    const o = this._colorStack;
    o[this._colorStackIndex] = o[this._colorStackIndex - 1] & e.mask;
    const r = this._colorStack[this._colorStackIndex];
    r !== this._currentColor && (this._currentColor = r, i.add({
      renderPipeId: "colorMask",
      colorMask: r,
      canBundle: !1
    })), this._colorStackIndex++;
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i);
    const o = this._colorStack;
    this._colorStackIndex--;
    const r = o[this._colorStackIndex - 1];
    r !== this._currentColor && (this._currentColor = r, i.add({
      renderPipeId: "colorMask",
      colorMask: r,
      canBundle: !1
    }));
  }
  execute(e) {
    this._renderer.colorMask.setMask(e.colorMask);
  }
  destroy() {
    this._renderer = null, this._colorStack = null;
  }
}
mT.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes
  ],
  name: "colorMask"
};
function fX(n, e, t, i, s, o) {
  o = Math.max(0, Math.min(o, Math.min(i, s) / 2)), n.moveTo(e + o, t), n.lineTo(e + i - o, t), n.quadraticCurveTo(e + i, t, e + i, t + o), n.lineTo(e + i, t + s - o), n.quadraticCurveTo(e + i, t + s, e + i - o, t + s), n.lineTo(e + o, t + s), n.quadraticCurveTo(e, t + s, e, t + s - o), n.lineTo(e, t + o), n.quadraticCurveTo(e, t, e + o, t);
}
function gT(n, e) {
  switch (e.type) {
    case "rectangle": {
      const t = e;
      n.rect(t.x, t.y, t.width, t.height);
      break;
    }
    case "roundedRectangle": {
      const t = e;
      fX(n, t.x, t.y, t.width, t.height, t.radius);
      break;
    }
    case "circle": {
      const t = e;
      n.moveTo(t.x + t.radius, t.y), n.arc(t.x, t.y, t.radius, 0, Math.PI * 2);
      break;
    }
    case "ellipse": {
      const t = e;
      n.ellipse ? (n.moveTo(t.x + t.halfWidth, t.y), n.ellipse(t.x, t.y, t.halfWidth, t.halfHeight, 0, 0, Math.PI * 2)) : (n.save(), n.translate(t.x, t.y), n.scale(t.halfWidth, t.halfHeight), n.moveTo(1, 0), n.arc(0, 0, 1, 0, Math.PI * 2), n.restore());
      break;
    }
    case "triangle": {
      const t = e;
      n.moveTo(t.x, t.y), n.lineTo(t.x2, t.y2), n.lineTo(t.x3, t.y3), n.closePath();
      break;
    }
    default: {
      const t = e, i = t.points;
      if (!(i != null && i.length)) break;
      n.moveTo(i[0], i[1]);
      for (let s = 2; s < i.length; s += 2)
        n.lineTo(i[s], i[s + 1]);
      t.closePath && n.closePath();
      break;
    }
  }
}
function mX(n, e, t) {
  var l;
  const i = [], s = [], o = [], r = Ol[e.type];
  if (!(r != null && r.build(e, i))) return !1;
  const a = (l = e.closePath) != null ? l : !0;
  B1(i, t, !1, a, s, o);
  for (let d = 0; d < o.length; d += 3) {
    const c = o[d] * 2, u = o[d + 1] * 2, p = o[d + 2] * 2;
    n.moveTo(s[c], s[c + 1]), n.lineTo(s[u], s[u + 1]), n.lineTo(s[p], s[p + 1]), n.closePath();
  }
  return !0;
}
function gX(n, e) {
  if (!(e != null && e.length)) return !1;
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    if (!(i != null && i.shape)) continue;
    const s = i.transform, o = s && !s.isIdentity();
    o && (n.save(), n.transform(s.a, s.b, s.c, s.d, s.tx, s.ty)), gT(n, i.shape), o && n.restore();
  }
  return !0;
}
class bT {
  constructor(e) {
    this._warnedMaskTypes = /* @__PURE__ */ new Set(), this._canvasMaskStack = [], this._renderer = e;
  }
  push(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "stencilMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "stencilMask",
      action: "popMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  execute(e) {
    var c, u, p;
    if (e.action !== "pushMaskBegin" && e.action !== "popMaskEnd")
      return;
    const t = this._renderer, i = t.canvasContext, s = i == null ? void 0 : i.activeContext;
    if (!s) return;
    if (e.action === "popMaskEnd") {
      this._canvasMaskStack.pop() && s.restore();
      return;
    }
    e.inverse && this._warnOnce(
      "inverse",
      "CanvasRenderer: inverse masks are not supported on Canvas2D; ignoring inverse flag."
    );
    const o = e.mask.mask;
    if (!(o instanceof Ro)) {
      this._warnOnce(
        "nonGraphics",
        "CanvasRenderer: only Graphics masks are supported in Canvas2D; skipping mask."
      ), this._canvasMaskStack.push(!1);
      return;
    }
    const r = o, a = (c = r.context) == null ? void 0 : c.instructions;
    if (!(a != null && a.length)) {
      this._canvasMaskStack.push(!1);
      return;
    }
    s.save(), i.setContextTransform(
      r.groupTransform,
      (t._roundPixels | r._roundPixels) === 1
    ), s.beginPath();
    let l = !1, d = !1;
    for (let f = 0; f < a.length; f++) {
      const y = a[f], b = y.action;
      if (b !== "fill" && b !== "stroke") continue;
      const w = y.data, k = (u = w == null ? void 0 : w.path) == null ? void 0 : u.shapePath;
      if (!((p = k == null ? void 0 : k.shapePrimitives) != null && p.length)) continue;
      const S = b === "stroke", _ = k.shapePrimitives;
      for (let x = 0; x < _.length; x++) {
        const T = _[x];
        if (!(T != null && T.shape)) continue;
        const M = T.transform, z = M && !M.isIdentity();
        z && (s.save(), s.transform(M.a, M.b, M.c, M.d, M.tx, M.ty)), S && w.style ? l = mX(
          s,
          T.shape,
          w.style
        ) || l : (gT(s, T.shape), d = gX(s, T.holes) || d, l = !0), z && s.restore();
      }
    }
    if (!l) {
      s.restore(), this._canvasMaskStack.push(!1);
      return;
    }
    d ? s.clip("evenodd") : s.clip(), this._canvasMaskStack.push(!0);
  }
  destroy() {
    this._renderer = null, this._warnedMaskTypes = null, this._canvasMaskStack = null;
  }
  _warnOnce(e, t) {
    this._warnedMaskTypes.has(e) || (this._warnedMaskTypes.add(e), at(t));
  }
}
bT.extension = {
  type: [
    Ae.CanvasPipes
  ],
  name: "stencilMask"
};
class vT {
  constructor(e) {
    this._maskHash = /* @__PURE__ */ new WeakMap(), this._renderer = e;
  }
  push(e, t, i) {
    const s = e, o = this._renderer;
    o.renderPipes.batch.break(i), o.renderPipes.blendMode.setBlendMode(s.mask, "none", i), i.add({
      renderPipeId: "stencilMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const r = s.mask;
    r.includeInBuild = !0, this._maskHash.has(s) || this._maskHash.set(s, {
      instructionsStart: 0,
      instructionsLength: 0
    });
    const a = this._maskHash.get(s);
    a.instructionsStart = i.instructionSize, r.collectRenderables(
      i,
      o,
      null
    ), r.includeInBuild = !1, o.renderPipes.batch.break(i), i.add({
      renderPipeId: "stencilMask",
      action: "pushMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const l = i.instructionSize - a.instructionsStart - 1;
    a.instructionsLength = l;
  }
  pop(e, t, i) {
    const s = e, o = this._renderer;
    o.renderPipes.batch.break(i), o.renderPipes.blendMode.setBlendMode(s.mask, "none", i), i.add({
      renderPipeId: "stencilMask",
      action: "popMaskBegin",
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const r = this._maskHash.get(e);
    for (let a = 0; a < r.instructionsLength; a++)
      i.instructions[i.instructionSize++] = i.instructions[r.instructionsStart++];
    i.add({
      renderPipeId: "stencilMask",
      action: "popMaskEnd",
      canBundle: !1
    });
  }
  execute(e) {
    const i = this._renderer, s = i.renderTarget.getGpuRenderTarget(i.renderTarget.renderTarget);
    let o = s.maskStackIndex;
    e.action === "pushMaskBegin" ? (i.renderTarget.ensureDepthStencil(), i.stencil.setStencilMode(cn.RENDERING_MASK_ADD, o), o++, i.colorMask.setMask(0)) : e.action === "pushMaskEnd" ? (e.inverse ? i.stencil.setStencilMode(cn.INVERSE_MASK_ACTIVE, o) : i.stencil.setStencilMode(cn.MASK_ACTIVE, o), i.colorMask.setMask(15)) : e.action === "popMaskBegin" ? (i.colorMask.setMask(0), o !== 0 ? i.stencil.setStencilMode(cn.RENDERING_MASK_REMOVE, o) : (i.renderTarget.clear(null, wn.STENCIL), i.stencil.setStencilMode(cn.DISABLED, o)), o--) : e.action === "popMaskEnd" && (e.inverse ? i.stencil.setStencilMode(cn.INVERSE_MASK_ACTIVE, o) : i.stencil.setStencilMode(cn.MASK_ACTIVE, o), i.colorMask.setMask(15)), s.maskStackIndex = o;
  }
  destroy() {
    this._renderer = null, this._maskHash = null;
  }
}
vT.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes
  ],
  name: "stencilMask"
};
const Ft = "source-over";
function bX() {
  const n = QS(), e = /* @__PURE__ */ Object.create(null);
  return e.inherit = Ft, e.none = Ft, e.normal = "source-over", e.add = "lighter", e.multiply = n ? "multiply" : Ft, e.screen = n ? "screen" : Ft, e.overlay = n ? "overlay" : Ft, e.darken = n ? "darken" : Ft, e.lighten = n ? "lighten" : Ft, e["color-dodge"] = n ? "color-dodge" : Ft, e["color-burn"] = n ? "color-burn" : Ft, e["hard-light"] = n ? "hard-light" : Ft, e["soft-light"] = n ? "soft-light" : Ft, e.difference = n ? "difference" : Ft, e.exclusion = n ? "exclusion" : Ft, e.saturation = n ? "saturation" : Ft, e.color = n ? "color" : Ft, e.luminosity = n ? "luminosity" : Ft, e["linear-burn"] = n ? "color-burn" : Ft, e["linear-dodge"] = n ? "color-dodge" : Ft, e["linear-light"] = n ? "hard-light" : Ft, e["pin-light"] = n ? "hard-light" : Ft, e["vivid-light"] = n ? "hard-light" : Ft, e["hard-mix"] = Ft, e.negation = n ? "difference" : Ft, e["normal-npm"] = e.normal, e["add-npm"] = e.add, e["screen-npm"] = e.screen, e.erase = "destination-out", e.subtract = Ft, e.divide = Ft, e.min = Ft, e.max = Ft, e;
}
const vX = new st();
class yT {
  /**
   * @param renderer - The owning CanvasRenderer.
   */
  constructor(e) {
    this.activeResolution = 1, this.smoothProperty = "imageSmoothingEnabled", this.blendModes = bX(), this._activeBlendMode = "normal", this._projTransform = null, this._outerBlend = !1, this._warnedBlendModes = /* @__PURE__ */ new Set(), this._renderer = e;
  }
  resolutionChange(e) {
    this.activeResolution = e;
  }
  /** Initializes the root context and smoothing flag selection. */
  init() {
    const e = this._renderer.background.alpha < 1;
    if (this.rootContext = this._renderer.canvas.getContext(
      "2d",
      { alpha: e }
    ), this.activeContext = this.rootContext, this.activeResolution = this._renderer.resolution, !this.rootContext.imageSmoothingEnabled) {
      const t = this.rootContext;
      t.webkitImageSmoothingEnabled ? this.smoothProperty = "webkitImageSmoothingEnabled" : t.mozImageSmoothingEnabled ? this.smoothProperty = "mozImageSmoothingEnabled" : t.oImageSmoothingEnabled ? this.smoothProperty = "oImageSmoothingEnabled" : t.msImageSmoothingEnabled && (this.smoothProperty = "msImageSmoothingEnabled");
    }
  }
  /**
   * Sets the current transform on the active context.
   * @param transform - Transform to apply.
   * @param roundPixels - Whether to round translation to integers.
   * @param localResolution - Optional local resolution multiplier.
   * @param skipGlobalTransform - If true, skip applying the global world transform matrix.
   */
  setContextTransform(e, t, i, s) {
    var d;
    const o = s ? st.IDENTITY : ((d = this._renderer.globalUniforms.globalUniformData) == null ? void 0 : d.worldTransformMatrix) || st.IDENTITY;
    let r = vX;
    r.copyFrom(o), r.append(e);
    const a = this._projTransform, l = this.activeResolution;
    if (i = i || l, a) {
      const c = st.shared;
      c.copyFrom(r), c.prepend(a), r = c;
    }
    t ? this.activeContext.setTransform(
      r.a * i,
      r.b * i,
      r.c * i,
      r.d * i,
      r.tx * l | 0,
      r.ty * l | 0
    ) : this.activeContext.setTransform(
      r.a * i,
      r.b * i,
      r.c * i,
      r.d * i,
      r.tx * l,
      r.ty * l
    );
  }
  /**
   * Clears the current render target, optionally filling with a color.
   * @param clearColor - Color to fill after clearing.
   * @param alpha - Alpha override for the clear color.
   */
  clear(e, t) {
    const i = this.activeContext, s = this._renderer;
    if (i.clearRect(0, 0, s.width, s.height), e) {
      const o = pn.shared.setValue(e);
      i.globalAlpha = t != null ? t : o.alpha, i.fillStyle = o.toHex(), i.fillRect(0, 0, s.width, s.height), i.globalAlpha = 1;
    }
  }
  /**
   * Sets the active blend mode.
   * @param blendMode - Pixi blend mode.
   */
  setBlendMode(e) {
    if (this._activeBlendMode === e) return;
    this._activeBlendMode = e, this._outerBlend = !1;
    const t = this.blendModes[e];
    if (!t) {
      this._warnedBlendModes.has(e) || (console.warn(
        `CanvasRenderer: blend mode "${e}" is not supported in Canvas2D; falling back to "source-over".`
      ), this._warnedBlendModes.add(e)), this.activeContext.globalCompositeOperation = "source-over";
      return;
    }
    this.activeContext.globalCompositeOperation = t;
  }
  /** Releases context references. */
  destroy() {
    this.rootContext = null, this.activeContext = null, this._warnedBlendModes.clear();
  }
}
yT.extension = {
  type: [
    Ae.CanvasSystem
  ],
  name: "canvasContext"
};
class xT {
  constructor() {
    this.maxTextures = 16, this.maxBatchableTextures = 16, this.maxUniformBindings = 0;
  }
  init() {
  }
}
xT.extension = {
  type: [
    Ae.CanvasSystem
  ],
  name: "limits"
};
class Y1 {
  constructor(e) {
    this._renderer = e;
  }
  updateRenderable() {
  }
  destroyRenderable() {
  }
  validateRenderable() {
    return !1;
  }
  addRenderable(e, t) {
    this._renderer.renderPipes.batch.break(t), t.add(e);
  }
  execute(e) {
    e.isRenderable && e.render(this._renderer);
  }
  destroy() {
    this._renderer = null;
  }
}
Y1.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "customRender"
};
function Nv(n, e) {
  const t = n.instructionSet, i = t.instructions;
  for (let s = 0; s < t.instructionSize; s++) {
    const o = i[s];
    e[o.renderPipeId].execute(o);
  }
}
class X1 {
  constructor(e) {
    this._renderer = e;
  }
  addRenderGroup(e, t) {
    e.isCachedAsTexture ? this._addRenderableCacheAsTexture(e, t) : this._addRenderableDirect(e, t);
  }
  execute(e) {
    e.isRenderable && (e.isCachedAsTexture ? this._executeCacheAsTexture(e) : this._executeDirect(e));
  }
  destroy() {
    this._renderer = null;
  }
  _addRenderableDirect(e, t) {
    this._renderer.renderPipes.batch.break(t), e._batchableRenderGroup && (Mn.return(e._batchableRenderGroup), e._batchableRenderGroup = null), t.add(e);
  }
  _addRenderableCacheAsTexture(e, t) {
    var s;
    const i = (s = e._batchableRenderGroup) != null ? s : e._batchableRenderGroup = Mn.get(cT);
    i.renderable = e.root, i.transform = e.root.relativeGroupTransform, i.texture = e.texture, i.bounds = e._textureBounds, t.add(e), this._renderer.renderPipes.blendMode.pushBlendMode(e, e.root.groupBlendMode, t), this._renderer.renderPipes.batch.addToBatch(i, t), this._renderer.renderPipes.blendMode.popBlendMode(t);
  }
  _executeCacheAsTexture(e) {
    if (e.textureNeedsUpdate) {
      e.textureNeedsUpdate = !1;
      const t = new st().translate(
        -e._textureBounds.x,
        -e._textureBounds.y
      );
      this._renderer.renderTarget.push({
        target: e.texture,
        clear: !0,
        frame: e.texture.frame
      }), this._renderer.globalUniforms.push({
        worldTransformMatrix: t,
        worldColor: 4294967295,
        offset: { x: 0, y: 0 }
      }), Nv(e, this._renderer.renderPipes), this._renderer.renderTarget.finishRenderPass(), this._renderer.renderTarget.pop(), this._renderer.globalUniforms.pop();
    }
    e._batchableRenderGroup._batcher.updateElement(e._batchableRenderGroup), e._batchableRenderGroup._batcher.geometry.buffers[0].update();
  }
  _executeDirect(e) {
    this._renderer.globalUniforms.push({
      worldTransformMatrix: e.inverseParentTextureTransform,
      worldColor: e.worldColorAlpha
    }), Nv(e, this._renderer.renderPipes), this._renderer.globalUniforms.pop();
  }
}
X1.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "renderGroup"
};
const yX = "#808080", Gu = new st(), xX = new st(), wX = new st(), wg = new st(), kX = new st();
function _X(n, e, t) {
  n.beginPath();
  for (let i = 0; i < t.length; i += 3) {
    const s = t[i] * 2, o = t[i + 1] * 2, r = t[i + 2] * 2;
    n.moveTo(e[s], e[s + 1]), n.lineTo(e[o], e[o + 1]), n.lineTo(e[r], e[r + 1]), n.closePath();
  }
  n.fill();
}
function SX(n) {
  return `#${(n & 16777215).toString(16).padStart(6, "0")}`;
}
function TX(n, e, t, i, s, o) {
  o = Math.max(0, Math.min(o, Math.min(i, s) / 2)), n.moveTo(e + o, t), n.lineTo(e + i - o, t), n.quadraticCurveTo(e + i, t, e + i, t + o), n.lineTo(e + i, t + s - o), n.quadraticCurveTo(e + i, t + s, e + i - o, t + s), n.lineTo(e + o, t + s), n.quadraticCurveTo(e, t + s, e, t + s - o), n.lineTo(e, t + o), n.quadraticCurveTo(e, t, e + o, t);
}
function Jh(n, e) {
  switch (e.type) {
    case "rectangle": {
      const t = e;
      n.rect(t.x, t.y, t.width, t.height);
      break;
    }
    case "roundedRectangle": {
      const t = e;
      TX(n, t.x, t.y, t.width, t.height, t.radius);
      break;
    }
    case "circle": {
      const t = e;
      n.arc(t.x, t.y, t.radius, 0, Math.PI * 2);
      break;
    }
    case "ellipse": {
      const t = e;
      n.ellipse ? n.ellipse(t.x, t.y, t.halfWidth, t.halfHeight, 0, 0, Math.PI * 2) : (n.save(), n.translate(t.x, t.y), n.scale(t.halfWidth, t.halfHeight), n.arc(0, 0, 1, 0, Math.PI * 2), n.restore());
      break;
    }
    case "triangle": {
      const t = e;
      n.moveTo(t.x, t.y), n.lineTo(t.x2, t.y2), n.lineTo(t.x3, t.y3), n.closePath();
      break;
    }
    default: {
      const t = e, i = t.points;
      if (!(i != null && i.length)) break;
      n.moveTo(i[0], i[1]);
      for (let s = 2; s < i.length; s += 2)
        n.lineTo(i[s], i[s + 1]);
      t.closePath && n.closePath();
      break;
    }
  }
}
function MX(n, e) {
  if (!(e != null && e.length)) return !1;
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    if (!(i != null && i.shape)) continue;
    const s = i.transform, o = s && !s.isIdentity();
    o && (n.save(), n.transform(s.a, s.b, s.c, s.d, s.tx, s.ty)), Jh(n, i.shape), o && n.restore();
  }
  return !0;
}
function CX(n, e, t, i) {
  const s = n.fill;
  if (s instanceof Dl) {
    s.buildGradient();
    const r = s.texture;
    if (r) {
      const a = yt.getTintedPattern(r, e), l = t ? wg.copyFrom(t).scale(r.source.pixelWidth, r.source.pixelHeight) : wg.copyFrom(s.transform);
      return i && !n.textureSpace && l.append(i), yt.applyPatternTransform(a, l), a;
    }
  }
  if (s instanceof XS) {
    const r = yt.getTintedPattern(s.texture, e);
    return yt.applyPatternTransform(r, s.transform, !1), r;
  }
  const o = n.texture;
  if (o && o !== Ze.WHITE) {
    if (!o.source.resource)
      return yX;
    const r = yt.getTintedPattern(o, e);
    let a = n.matrix;
    if (t) {
      const { resolution: l } = o.source;
      if (a = wg.copyFrom(t), o.rotate) {
        const { uvs: d, orig: c } = o;
        a.prepend(kX.set(
          d.x1 - d.x0,
          d.y1 - d.y0,
          d.x3 - d.x0,
          d.y3 - d.y0,
          d.x0,
          d.y0
        ).invert()).scale(c.width * l, c.height * l);
      } else
        a.scale(o.source.pixelWidth, o.source.pixelHeight).translate(-o.frame.x * l, -o.frame.y * l);
    }
    return yt.applyPatternTransform(r, a), r;
  }
  return SX(e);
}
class wT {
  constructor() {
    this.shader = null;
  }
  contextChange(e) {
  }
  execute(e, t) {
    var S, _, x, T, M, z, P, D, $, O, L, Z;
    const i = e.renderer, s = i.canvasContext, o = s.activeContext, r = t.groupTransform, a = (_ = (S = i.globalUniforms.globalUniformData) == null ? void 0 : S.worldColor) != null ? _ : 4294967295, l = t.groupColorAlpha, d = (a >>> 24 & 255) / 255, c = (l >>> 24 & 255) / 255, u = (T = (x = i.filter) == null ? void 0 : x.alphaMultiplier) != null ? T : 1, p = d * c * u;
    if (p <= 0) return;
    const f = a & 16777215, y = l & 16777215, b = Wr(Vr(y, f)), w = i._roundPixels | t._roundPixels;
    o.save(), s.setContextTransform(r, w === 1), s.setBlendMode(t.groupBlendMode);
    const k = t.context.instructions;
    for (let J = 0; J < k.length; J++) {
      const re = k[J];
      if (re.action === "texture") {
        const B = re.data, ne = B.image, se = ne ? yt.getCanvasSource(ne) : null;
        if (!se) continue;
        const Y = B.alpha * p;
        if (Y <= 0) continue;
        const ie = Vr(B.style, b);
        o.globalAlpha = Y;
        let De = se;
        ie !== 16777215 && (De = yt.getTintedCanvas({ texture: ne }, ie));
        const xe = ne.frame, Oe = (z = (M = ne.source._resolution) != null ? M : ne.source.resolution) != null ? z : 1;
        let Ee = xe.x * Oe, j = xe.y * Oe;
        const V = xe.width * Oe, Q = xe.height * Oe;
        De !== se && (Ee = 0, j = 0);
        const oe = B.transform, ue = oe && !oe.isIdentity(), Ie = ne.rotate;
        ue || Ie ? (Gu.copyFrom(r), ue && Gu.append(oe), Ie && wt.matrixAppendRotationInv(Gu, Ie, B.dx, B.dy, B.dw, B.dh), s.setContextTransform(Gu, w === 1)) : s.setContextTransform(r, w === 1), o.drawImage(
          De,
          Ee,
          j,
          De === se ? V : De.width,
          De === se ? Q : De.height,
          Ie ? 0 : B.dx,
          Ie ? 0 : B.dy,
          B.dw,
          B.dh
        ), (ue || Ie) && s.setContextTransform(r, w === 1);
        continue;
      }
      const F = re.data, W = (P = F == null ? void 0 : F.path) == null ? void 0 : P.shapePath;
      if (!((D = W == null ? void 0 : W.shapePrimitives) != null && D.length)) continue;
      const ee = F.style, N = Vr(ee.color, b), te = ee.alpha * p;
      if (te <= 0) continue;
      const G = re.action === "stroke";
      if (o.globalAlpha = te, G) {
        const B = ee;
        o.lineWidth = B.width, o.lineCap = B.cap, o.lineJoin = B.join, o.miterLimit = B.miterLimit;
      }
      const q = W.shapePrimitives;
      if (!G && ((L = (O = ($ = F.hole) == null ? void 0 : $.shapePath) == null ? void 0 : O.shapePrimitives) != null && L.length)) {
        const B = q[q.length - 1];
        B.holes = F.hole.shapePath.shapePrimitives;
      }
      for (let B = 0; B < q.length; B++) {
        const ne = q[B];
        if (!(ne != null && ne.shape)) continue;
        const se = ne.transform, Y = se && !se.isIdentity(), ie = ee.texture && ee.texture !== Ze.WHITE, De = ee.textureSpace === "global" ? se : null, xe = ie ? jS(xX, ee, ne.shape, De) : null, Oe = Y ? wX.copyFrom(r).append(se) : r, Ee = CX(
          ee,
          N,
          xe,
          Oe
        );
        if (Y && (o.save(), o.transform(se.a, se.b, se.c, se.d, se.tx, se.ty)), G) {
          const j = ee;
          if (j.alignment !== 0.5 && !j.pixelLine) {
            const Q = [], oe = [], ue = [], Ie = Ol[ne.shape.type];
            if (Ie != null && Ie.build(ne.shape, Q)) {
              const he = (Z = ne.shape.closePath) != null ? Z : !0;
              B1(Q, j, !1, he, oe, ue), o.fillStyle = Ee, _X(o, oe, ue);
            } else
              o.strokeStyle = Ee, o.beginPath(), Jh(o, ne.shape), o.stroke();
          } else
            o.strokeStyle = Ee, o.beginPath(), Jh(o, ne.shape), o.stroke();
        } else
          o.fillStyle = Ee, o.beginPath(), Jh(o, ne.shape), MX(o, ne.holes) ? o.fill("evenodd") : o.fill();
        Y && o.restore();
      }
    }
    o.restore();
  }
  destroy() {
    this.shader = null;
  }
}
wT.extension = {
  type: [
    Ae.CanvasPipesAdaptor
  ],
  name: "graphics"
};
class J1 {
  constructor(e) {
    this._renderer = e;
  }
  addRenderable(e, t) {
    const i = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, i), this._renderer.renderPipes.batch.addToBatch(i, t);
  }
  updateRenderable(e) {
    const t = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, t), t._batcher.updateElement(t);
  }
  validateRenderable(e) {
    const t = this._getGpuSprite(e);
    return !t._batcher.checkAndUpdateTexture(
      t,
      e._texture
    );
  }
  _updateBatchableSprite(e, t) {
    t.bounds = e.visualBounds, t.texture = e._texture;
  }
  _getGpuSprite(e) {
    return e._gpuData[this._renderer.uid] || this._initGPUSprite(e);
  }
  _initGPUSprite(e) {
    const t = new cT();
    return t.renderable = e, t.transform = e.groupTransform, t.texture = e._texture, t.bounds = e.visualBounds, t.roundPixels = this._renderer._roundPixels | e._roundPixels, e._gpuData[this._renderer.uid] = t, t;
  }
  destroy() {
    this._renderer = null;
  }
}
J1.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "sprite"
};
const ic = {};
ct.handle(Ae.BlendMode, (n) => {
  if (!n.name)
    throw new Error("BlendMode extension must have a name property");
  ic[n.name] = n.ref;
}, (n) => {
  delete ic[n.name];
});
class Z1 {
  constructor(e) {
    this._blendModeStack = [], this._isAdvanced = !1, this._filterHash = /* @__PURE__ */ Object.create(null), this._renderer = e, this._renderer.runners.prerender.add(this);
  }
  prerender() {
    this._activeBlendMode = "normal", this._isAdvanced = !1;
  }
  /**
   * Push a blend mode onto the internal stack and apply it to the instruction set if needed.
   * @param renderable - The renderable or {@link RenderGroup} associated with the change.
   * @param blendMode - The blend mode to activate.
   * @param instructionSet - The instruction set being built.
   */
  pushBlendMode(e, t, i) {
    this._blendModeStack.push(t), this.setBlendMode(e, t, i);
  }
  /**
   * Pop the last blend mode from the stack and apply the new top-of-stack mode.
   * @param instructionSet - The instruction set being built.
   */
  popBlendMode(e) {
    var i;
    this._blendModeStack.pop();
    const t = (i = this._blendModeStack[this._activeBlendMode.length - 1]) != null ? i : "normal";
    this.setBlendMode(null, t, e);
  }
  /**
   * Ensure a blend mode switch is added to the instruction set when the mode changes.
   * If an advanced blend mode is active, subsequent renderables will be collected so they can be
   * rendered within a single filter pass.
   * @param renderable - The renderable or {@link RenderGroup} to associate with the change, or null when unwinding.
   * @param blendMode - The target blend mode.
   * @param instructionSet - The instruction set being built.
   */
  setBlendMode(e, t, i) {
    var o;
    const s = e instanceof yv;
    if (this._activeBlendMode === t) {
      this._isAdvanced && e && !s && ((o = this._renderableList) == null || o.push(e));
      return;
    }
    this._isAdvanced && this._endAdvancedBlendMode(i), this._activeBlendMode = t, e && (this._isAdvanced = !!ic[t], this._isAdvanced && this._beginAdvancedBlendMode(e, i));
  }
  _beginAdvancedBlendMode(e, t) {
    this._renderer.renderPipes.batch.break(t);
    const i = this._activeBlendMode;
    if (!ic[i]) {
      at(`Unable to assign BlendMode: '${i}'. You may want to include: import 'pixi.js/advanced-blend-modes'`);
      return;
    }
    const s = this._ensureFilterEffect(i), o = e instanceof yv, r = {
      renderPipeId: "filter",
      action: "pushFilter",
      filterEffect: s,
      renderables: o ? null : [e],
      container: o ? e.root : null,
      canBundle: !1
    };
    this._renderableList = r.renderables, t.add(r);
  }
  _ensureFilterEffect(e) {
    let t = this._filterHash[e];
    return t || (t = this._filterHash[e] = new Bp(), t.filters = [new ic[e]()]), t;
  }
  _endAdvancedBlendMode(e) {
    this._isAdvanced = !1, this._renderableList = null, this._renderer.renderPipes.batch.break(e), e.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  /**
   * called when the instruction build process is starting this will reset internally to the default blend mode
   * @internal
   */
  buildStart() {
    this._isAdvanced = !1;
  }
  /**
   * called when the instruction build process is finished, ensuring that if there is an advanced blend mode
   * active, we add the final render instructions added to the instruction set
   * @param instructionSet - The instruction set we are adding to
   * @internal
   */
  buildEnd(e) {
    this._isAdvanced && this._endAdvancedBlendMode(e);
  }
  /** @internal */
  destroy() {
    this._renderer = null, this._renderableList = null;
    for (const e in this._filterHash)
      this._filterHash[e].destroy();
    this._filterHash = null;
  }
}
Z1.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "blendMode"
};
function Uv(n, e) {
  e || (e = 0);
  for (let t = e; t < n.length && n[t]; t++)
    n[t] = null;
}
const IX = new un(), n2 = Qd | Np | T1;
function kT(n, e = !1) {
  AX(n);
  const t = n.childrenToUpdate, i = n.updateTick++;
  for (const s in t) {
    const o = Number(s), r = t[s], a = r.list, l = r.index;
    for (let d = 0; d < l; d++) {
      const c = a[d];
      c.parentRenderGroup === n && c.relativeRenderGroupDepth === o && _T(c, i, 0);
    }
    Uv(a, l), r.index = 0;
  }
  if (e)
    for (let s = 0; s < n.renderGroupChildren.length; s++)
      kT(n.renderGroupChildren[s], e);
}
function AX(n) {
  const e = n.root;
  let t;
  if (n.renderGroupParent) {
    const i = n.renderGroupParent;
    n.worldTransform.appendFrom(
      e.relativeGroupTransform,
      i.worldTransform
    ), n.worldColor = Fp(
      e.groupColor,
      i.worldColor
    ), t = e.groupAlpha * i.worldAlpha;
  } else
    n.worldTransform.copyFrom(e.localTransform), n.worldColor = e.localColor, t = e.localAlpha;
  t = t < 0 ? 0 : t > 1 ? 1 : t, n.worldAlpha = t, n.worldColorAlpha = n.worldColor + ((t * 255 | 0) << 24);
}
function _T(n, e, t) {
  if (e === n.updateTick) return;
  n.updateTick = e, n.didChange = !1;
  const i = n.localTransform;
  n.updateLocalTransform();
  const s = n.parent;
  if (s && !s.renderGroup ? (t |= n._updateFlags, n.relativeGroupTransform.appendFrom(
    i,
    s.relativeGroupTransform
  ), t & n2 && i2(n, s, t)) : (t = n._updateFlags, n.relativeGroupTransform.copyFrom(i), t & n2 && i2(n, IX, t)), !n.renderGroup) {
    const o = n.children, r = o.length;
    for (let d = 0; d < r; d++)
      _T(o[d], e, t);
    const a = n.parentRenderGroup, l = n;
    l.renderPipeId && !a.structureDidChange && a.updateRenderable(l);
  }
}
function i2(n, e, t) {
  if (t & Np) {
    n.groupColor = Fp(
      n.localColor,
      e.groupColor
    );
    let i = n.localAlpha * e.groupAlpha;
    i = i < 0 ? 0 : i > 1 ? 1 : i, n.groupAlpha = i, n.groupColorAlpha = n.groupColor + ((i * 255 | 0) << 24);
  }
  t & T1 && (n.groupBlendMode = n.localBlendMode === "inherit" ? e.groupBlendMode : n.localBlendMode), t & Qd && (n.globalDisplayStatus = n.localDisplayStatus & e.globalDisplayStatus), n._updateFlags = 0;
}
function PX(n, e) {
  const { list: t } = n.childrenRenderablesToUpdate;
  let i = !1;
  for (let s = 0; s < n.childrenRenderablesToUpdate.index; s++) {
    const o = t[s];
    if (i = e[o.renderPipeId].validateRenderable(o), i)
      break;
  }
  return n.structureDidChange = i, i;
}
const EX = new st();
class ST {
  constructor(e) {
    this._renderer = e;
  }
  render({ container: e, transform: t }) {
    const i = e.parent, s = e.renderGroup.renderGroupParent;
    e.parent = null, e.renderGroup.renderGroupParent = null;
    const o = this._renderer, r = EX;
    t && (r.copyFrom(e.renderGroup.localTransform), e.renderGroup.localTransform.copyFrom(t));
    const a = o.renderPipes;
    this._updateCachedRenderGroups(e.renderGroup, null), this._updateRenderGroups(e.renderGroup), o.globalUniforms.start({
      worldTransformMatrix: t ? e.renderGroup.localTransform : e.renderGroup.worldTransform,
      worldColor: e.renderGroup.worldColorAlpha
    }), Nv(e.renderGroup, a), a.uniformBatch && a.uniformBatch.renderEnd(), t && e.renderGroup.localTransform.copyFrom(r), e.parent = i, e.renderGroup.renderGroupParent = s;
  }
  destroy() {
    this._renderer = null;
  }
  _updateCachedRenderGroups(e, t) {
    var i, s;
    if (e._parentCacheAsTextureRenderGroup = t, e.isCachedAsTexture) {
      if (!e.textureNeedsUpdate) return;
      t = e;
    }
    for (let o = e.renderGroupChildren.length - 1; o >= 0; o--)
      this._updateCachedRenderGroups(e.renderGroupChildren[o], t);
    if (e.invalidateMatrices(), e.isCachedAsTexture) {
      if (e.textureNeedsUpdate) {
        const o = e.root.getLocalBounds(), r = this._renderer, a = e.textureOptions.resolution || r.view.resolution, l = (i = e.textureOptions.antialias) != null ? i : r.view.antialias, d = (s = e.textureOptions.scaleMode) != null ? s : "linear", c = e.texture;
        o.ceil(), e.texture && Rn.returnTexture(e.texture);
        const u = Rn.getOptimalTexture({
          width: o.width,
          height: o.height,
          resolution: a,
          antialias: l,
          scaleMode: d
        });
        e.texture = u, e._textureBounds || (e._textureBounds = new On()), e._textureBounds.copyFrom(o), c !== e.texture && e.renderGroupParent && (e.renderGroupParent.structureDidChange = !0);
      }
    } else e.texture && (Rn.returnTexture(e.texture), e.texture = null);
  }
  _updateRenderGroups(e) {
    const t = this._renderer, i = t.renderPipes;
    if (e.runOnRender(t), e.instructionSet.renderPipes = i, e.structureDidChange ? Uv(e.childrenRenderablesToUpdate.list, 0) : PX(e, i), kT(e), e.structureDidChange ? (e.structureDidChange = !1, this._buildInstructions(e, t)) : this._updateRenderables(e), e.childrenRenderablesToUpdate.index = 0, t.renderPipes.batch.upload(e.instructionSet), !(e.isCachedAsTexture && !e.textureNeedsUpdate))
      for (let s = 0; s < e.renderGroupChildren.length; s++)
        this._updateRenderGroups(e.renderGroupChildren[s]);
  }
  _updateRenderables(e) {
    const { list: t, index: i } = e.childrenRenderablesToUpdate;
    for (let s = 0; s < i; s++) {
      const o = t[s];
      o.didViewUpdate && e.updateRenderable(o);
    }
    Uv(t, i);
  }
  _buildInstructions(e, t) {
    const i = e.root, s = e.instructionSet;
    s.reset();
    const o = t.renderPipes ? t : t.batch.renderer, r = o.renderPipes;
    r.batch.buildStart(s), r.blendMode.buildStart(), r.colorMask.buildStart(), i.sortableChildren && i.sortChildren(), i.collectRenderablesWithEffects(s, o, null), r.batch.buildEnd(s), r.blendMode.buildEnd(s);
  }
}
ST.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "renderGroup"
};
const Q1 = class TT {
  constructor() {
    this.clearBeforeRender = !0, this._backgroundColor = new pn(0), this.color = this._backgroundColor, this.alpha = 1;
  }
  /**
   * initiates the background system
   * @param options - the options for the background colors
   */
  init(e) {
    e = { ...TT.defaultOptions, ...e }, this.clearBeforeRender = e.clearBeforeRender, this.color = e.background || e.backgroundColor || this._backgroundColor, this.alpha = e.backgroundAlpha, this._backgroundColor.setAlpha(e.backgroundAlpha);
  }
  /** The background color to fill if not transparent */
  get color() {
    return this._backgroundColor;
  }
  set color(e) {
    pn.shared.setValue(e).alpha < 1 && this._backgroundColor.alpha === 1 && at(
      "Cannot set a transparent background on an opaque canvas. To enable transparency, set backgroundAlpha < 1 when initializing your Application."
    ), this._backgroundColor.setValue(e);
  }
  /** The background color alpha. Setting this to 0 will make the canvas transparent. */
  get alpha() {
    return this._backgroundColor.alpha;
  }
  set alpha(e) {
    this._backgroundColor.setAlpha(e);
  }
  /** The background color as an [R, G, B, A] array. */
  get colorRgba() {
    return this._backgroundColor.toArray();
  }
  /**
   * destroys the background system
   * @internal
   */
  destroy() {
  }
};
Q1.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "background",
  priority: 0
};
Q1.defaultOptions = {
  /**
   * {@link WebGLOptions.backgroundAlpha}
   * @default 1
   */
  backgroundAlpha: 1,
  /**
   * {@link WebGLOptions.backgroundColor}
   * @default 0x000000
   */
  backgroundColor: 0,
  /**
   * {@link WebGLOptions.clearBeforeRender}
   * @default true
   */
  clearBeforeRender: !0
};
let RX = Q1;
const kg = {
  png: "image/png",
  jpg: "image/jpeg",
  webp: "image/webp"
}, ey = class MT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e;
  }
  _normalizeOptions(e, t = {}) {
    return e instanceof un || e instanceof Ze ? {
      target: e,
      ...t
    } : {
      ...t,
      ...e
    };
  }
  /**
   * Creates an IImage from a display object or texture.
   * @param options - Options for creating the image, or the target to extract
   * @returns Promise that resolves with the generated IImage
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const image = await renderer.extract.image(sprite);
   * document.body.appendChild(image);
   *
   * // Advanced usage with options
   * const image = await renderer.extract.image({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2,
   *     clearColor: '#ff0000',
   *     antialias: true
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const image = await renderer.extract.image(texture);
   * ```
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.base64} For base64 string output
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ImageLike} For the image interface
   * @category rendering
   */
  async image(e) {
    const t = Pt.get().createImage();
    return t.src = await this.base64(e), t;
  }
  /**
   * Converts the target into a base64 encoded string.
   *
   * This method works by first creating
   * a canvas using `Extract.canvas` and then converting it to a base64 string.
   * @param options - The options for creating the base64 string, or the target to extract
   * @returns Promise that resolves with the base64 encoded string
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const base64 = await renderer.extract.base64(sprite);
   * console.log(base64); // data:image/png;base64,...
   *
   * // Advanced usage with options
   * const base64 = await renderer.extract.base64({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2
   * });
   * ```
   * @throws Will throw an error if the platform doesn't support any of:
   * - ICanvas.toDataURL
   * - ICanvas.toBlob
   * - ICanvas.convertToBlob
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @category rendering
   */
  async base64(e) {
    e = this._normalizeOptions(
      e,
      MT.defaultImageOptions
    );
    const { format: t, quality: i } = e, s = this.canvas(e);
    if (s.toBlob !== void 0)
      return new Promise((o, r) => {
        s.toBlob((a) => {
          if (!a) {
            r(new Error("ICanvas.toBlob failed!"));
            return;
          }
          const l = new FileReader();
          l.onload = () => o(l.result), l.onerror = r, l.readAsDataURL(a);
        }, kg[t], i);
      });
    if (s.toDataURL !== void 0)
      return s.toDataURL(kg[t], i);
    if (s.convertToBlob !== void 0) {
      const o = await s.convertToBlob({ type: kg[t], quality: i });
      return new Promise((r, a) => {
        const l = new FileReader();
        l.onload = () => r(l.result), l.onerror = a, l.readAsDataURL(o);
      });
    }
    throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
  }
  /**
   * Creates a Canvas element, renders the target to it and returns it.
   * This method is useful for creating static images or when you need direct canvas access.
   * @param options - The options for creating the canvas, or the target to extract
   * @returns A Canvas element with the texture rendered on
   * @example
   * ```ts
   * // Basic canvas extraction from a sprite
   * const sprite = new Sprite(texture);
   * const canvas = renderer.extract.canvas(sprite);
   * document.body.appendChild(canvas);
   *
   * // Extract with custom region
   * const canvas = renderer.extract.canvas({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const canvas = renderer.extract.canvas({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const canvas = renderer.extract.canvas(texture);
   *
   * // Extract with anti-aliasing
   * const canvas = renderer.extract.canvas({
   *     target: graphics,
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   */
  canvas(e) {
    e = this._normalizeOptions(e);
    const t = e.target, i = this._renderer;
    if (t instanceof Ze)
      return i.texture.generateCanvas(t);
    const s = i.textureGenerator.generateTexture(e), o = i.texture.generateCanvas(s);
    return s.destroy(!0), o;
  }
  /**
   * Returns a one-dimensional array containing the pixel data of the entire texture in RGBA order,
   * with integer values between 0 and 255 (inclusive).
   * > [!NOE] The returned array is a flat Uint8Array where every 4 values represent RGBA
   * @param options - The options for extracting the image, or the target to extract
   * @returns One-dimensional Uint8Array containing the pixel data in RGBA format
   * @example
   * ```ts
   * // Basic pixel extraction
   * const sprite = new Sprite(texture);
   * const pixels = renderer.extract.pixels(sprite);
   * console.log(pixels[0], pixels[1], pixels[2], pixels[3]); // R,G,B,A values
   *
   * // Extract with custom region
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     resolution: 2
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For image output
   * @category rendering
   */
  pixels(e) {
    e = this._normalizeOptions(e);
    const t = e.target, i = this._renderer, s = t instanceof Ze ? t : i.textureGenerator.generateTexture(e), o = i.texture.getPixels(s);
    return t instanceof un && s.destroy(!0), o;
  }
  /**
   * Creates a texture from a display object or existing texture.
   *
   * This is useful for creating
   * reusable textures from rendered content or making copies of existing textures.
   * > [!NOTE] The returned texture should be destroyed when no longer needed
   * @param options - The options for creating the texture, or the target to extract
   * @returns A new texture containing the extracted content
   * @example
   * ```ts
   * // Basic texture extraction from a sprite
   * const sprite = new Sprite(texture);
   * const extractedTexture = renderer.extract.texture(sprite);
   *
   * // Extract with custom region
   * const regionTexture = renderer.extract.texture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const hiResTexture = renderer.extract.texture({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Create a new sprite from extracted texture
   * const newSprite = new Sprite(
   *     renderer.extract.texture({
   *         target: graphics,
   *         antialias: true
   *     })
   * );
   *
   * // Clean up when done
   * extractedTexture.destroy(true);
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link Texture} For texture management
   * @see {@link GenerateTextureSystem} For texture generation
   * @category rendering
   */
  texture(e) {
    return e = this._normalizeOptions(e), e.target instanceof Ze ? e.target : this._renderer.textureGenerator.generateTexture(e);
  }
  /**
   * Extracts and downloads content from the renderer as an image file.
   * This is a convenient way to save screenshots or export rendered content.
   * > [!NOTE] The download will use PNG format regardless of the filename extension
   * @param options - The options for downloading and extracting the image, or the target to extract
   * @example
   * ```ts
   * // Basic download with default filename
   * const sprite = new Sprite(texture);
   * renderer.extract.download(sprite); // Downloads as 'image.png'
   *
   * // Download with custom filename
   * renderer.extract.download({
   *     target: sprite,
   *     filename: 'screenshot.png'
   * });
   *
   * // Download with custom region
   * renderer.extract.download({
   *     target: container,
   *     filename: 'region.png',
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Download with high resolution and background
   * renderer.extract.download({
   *     target: stage,
   *     filename: 'hd-screenshot.png',
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Download with anti-aliasing
   * renderer.extract.download({
   *     target: graphics,
   *     filename: 'smooth.png',
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractDownloadOptions} For detailed options
   * @see {@link ExtractSystem.image} For creating images without download
   * @see {@link ExtractSystem.canvas} For canvas output
   * @category rendering
   */
  download(e) {
    var s;
    e = this._normalizeOptions(e);
    const t = this.canvas(e), i = document.createElement("a");
    i.download = (s = e.filename) != null ? s : "image.png", i.href = t.toDataURL("image/png"), document.body.appendChild(i), i.click(), document.body.removeChild(i);
  }
  /**
   * Logs the target to the console as an image. This is a useful way to debug what's happening in the renderer.
   * The image will be displayed in the browser's console using CSS background images.
   * @param options - The options for logging the image, or the target to log
   * @param options.width - The width of the logged image preview in the console (in pixels)
   * @example
   * ```ts
   * // Basic usage
   * const sprite = new Sprite(texture);
   * renderer.extract.log(sprite);
   * ```
   * @see {@link ExtractSystem.canvas} For getting raw canvas output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   * @advanced
   */
  log(e) {
    var r;
    const t = (r = e.width) != null ? r : 200;
    e = this._normalizeOptions(e);
    const i = this.canvas(e), s = i.toDataURL();
    console.log(`[Pixi Texture] ${i.width}px ${i.height}px`);
    const o = [
      "font-size: 1px;",
      `padding: ${t}px 300px;`,
      `background: url(${s}) no-repeat;`,
      "background-size: contain;"
    ].join(" ");
    console.log("%c ", o);
  }
  destroy() {
    this._renderer = null;
  }
};
ey.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "extract"
};
ey.defaultImageOptions = {
  format: "png",
  quality: 1
};
let zX = ey;
class ty extends Ze {
  /**
   * Creates a RenderTexture. Pass `dynamic: true` in options to allow resizing after creation.
   * @param options - Options for the RenderTexture, including width, height, textureOptions, and dynamic.
   * @returns A new RenderTexture instance.
   * @example
   * const textureOptions = { defaultAnchor: { x: 0.5, y: 0.5 } };
   * const rt = RenderTexture.create({ width: 100, height: 100, dynamic: true, textureOptions });
   * rt.resize(500, 500);
   */
  static create(e) {
    const { dynamic: t, textureOptions: i, ...s } = e;
    return new ty({
      ...i,
      source: new an(s),
      dynamic: t != null ? t : !1
    });
  }
  /**
   * Resizes the render texture.
   * @param width - The new width of the render texture.
   * @param height - The new height of the render texture.
   * @param resolution - The new resolution of the render texture.
   * @returns This texture.
   */
  resize(e, t, i) {
    return this.source.resize(e, t, i), this;
  }
}
const $X = new _t(), DX = new On(), OX = [0, 0, 0, 0];
class CT {
  constructor(e) {
    this._renderer = e;
  }
  /**
   * Creates a texture from a display object that can be used for creating sprites and other textures.
   * This is particularly useful for optimizing performance when a complex container needs to be reused.
   * @param options - Generate texture options or a container to convert to texture
   * @returns A new RenderTexture containing the rendered display object
   * @example
   * ```ts
   * // Basic usage with a container
   * const container = new Container();
   * container.addChild(
   *     new Graphics()
   *         .circle(0, 0, 50)
   *         .fill('red')
   * );
   *
   * const texture = renderer.textureGenerator.generateTexture(container);
   *
   * // Advanced usage with options
   * const texture = renderer.textureGenerator.generateTexture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100), // Specific region
   *     resolution: 2,                        // High DPI
   *     clearColor: '#ff0000',               // Red background
   *     antialias: true                      // Smooth edges
   * });
   *
   * // Create a sprite from the generated texture
   * const sprite = new Sprite(texture);
   *
   * // Clean up when done
   * texture.destroy(true);
   * ```
   * @see {@link GenerateTextureOptions} For detailed texture generation options
   * @see {@link RenderTexture} For the type of texture created
   * @category rendering
   */
  generateTexture(e) {
    var c;
    e instanceof un && (e = {
      target: e,
      frame: void 0,
      textureSourceOptions: {},
      resolution: void 0
    });
    const t = e.resolution || this._renderer.resolution, i = e.antialias || this._renderer.view.antialias, s = e.target;
    let o = e.clearColor;
    o ? o = Array.isArray(o) && o.length === 4 ? o : pn.shared.setValue(o).toArray() : o = OX;
    const r = ((c = e.frame) == null ? void 0 : c.copyTo($X)) || _1(s, DX).rectangle, a = e.defaultAnchor && {
      defaultAnchor: e.defaultAnchor
    };
    r.width = Math.max(r.width, 1 / t) | 0, r.height = Math.max(r.height, 1 / t) | 0;
    const l = ty.create({
      ...e.textureSourceOptions,
      width: r.width,
      height: r.height,
      resolution: t,
      antialias: i,
      textureOptions: a
    }), d = st.shared.translate(-r.x, -r.y);
    return this._renderer.render({
      container: s,
      transform: d,
      target: l,
      clearColor: o
    }), l.source.updateMipmaps(), l;
  }
  destroy() {
    this._renderer = null;
  }
}
CT.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "textureGenerator"
};
function LX(n) {
  let e = !1;
  for (const i in n)
    if (n[i] == null) {
      e = !0;
      break;
    }
  if (!e) return n;
  const t = /* @__PURE__ */ Object.create(null);
  for (const i in n) {
    const s = n[i];
    s && (t[i] = s);
  }
  return t;
}
function BX(n) {
  let e = 0;
  for (let t = 0; t < n.length; t++)
    n[t] == null ? e++ : n[t - e] = n[t];
  return n.length -= e, n;
}
const ny = class IT {
  /**
   * Creates a new GCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */
  constructor(e) {
    this._managedResources = [], this._managedResourceHashes = [], this._managedCollections = [], this._ready = !1, this._running = !1, this._renderer = e;
  }
  /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options
   */
  init(e) {
    e = { ...IT.defaultOptions, ...e }, this.maxUnusedTime = e.gcMaxUnusedTime, this._frequency = e.gcFrequency, this.enabled = e.gcActive, this.now = performance.now();
  }
  /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */
  get enabled() {
    return !!this._handler;
  }
  /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */
  set enabled(e) {
    this.enabled !== e && (e ? (this._handler = this._renderer.scheduler.repeat(
      () => {
        this._ready = !0;
      },
      this._frequency,
      !1
    ), this._collectionsHandler = this._renderer.scheduler.repeat(
      () => {
        for (const t of this._managedCollections) {
          const { context: i, collection: s, type: o } = t;
          o === "hash" ? i[s] = LX(i[s]) : i[s] = BX(i[s]);
        }
      },
      this._frequency
    )) : (this._renderer.scheduler.cancel(this._handler), this._renderer.scheduler.cancel(this._collectionsHandler), this._handler = 0, this._collectionsHandler = 0));
  }
  /**
   * Called before rendering. Updates the current timestamp.
   * @param options - The render options
   * @param options.container - The container to render
   */
  prerender({ container: e }) {
    this.now = performance.now(), e.renderGroup.gcTick = this._renderer.tick++, this._updateInstructionGCTick(e.renderGroup, e.renderGroup.gcTick);
  }
  /** Performs garbage collection after rendering. */
  postrender() {
    !this._ready || !this.enabled || (this.run(), this._ready = !1);
  }
  /**
   * Updates the GC tick counter for a render group and its children.
   * @param renderGroup - The render group to update
   * @param gcTick - The new tick value
   */
  _updateInstructionGCTick(e, t) {
    e.instructionSet.gcTick = t, e.gcTick = t;
    for (const i of e.renderGroupChildren)
      this._updateInstructionGCTick(i, t);
  }
  /**
   * Registers a collection for garbage collection tracking.
   * @param context - The object containing the collection
   * @param collection - The property name on context that holds the collection
   * @param type - The type of collection to track ('hash' or 'array')
   */
  addCollection(e, t, i) {
    this._managedCollections.push({
      context: e,
      collection: t,
      type: i
    });
  }
  /**
   * Registers a resource for garbage collection tracking.
   * @param resource - The resource to track
   * @param type - The type of resource to track
   */
  addResource(e, t) {
    var s, o;
    if (e._gcLastUsed !== -1) {
      e._gcLastUsed = this.now, (s = e._onTouch) == null || s.call(e, this.now);
      return;
    }
    const i = this._managedResources.length;
    e._gcData = {
      index: i,
      type: t
    }, e._gcLastUsed = this.now, (o = e._onTouch) == null || o.call(e, this.now), e.once("unload", this.removeResource, this), this._managedResources.push(e);
  }
  /**
   * Removes a resource from garbage collection tracking.
   * Call this when manually destroying a resource.
   * @param resource - The resource to stop tracking
   */
  removeResource(e) {
    const t = e._gcData;
    if (!t) return;
    const i = t.index, s = this._managedResources.length - 1;
    if (this._running)
      this._managedResources[i] = null;
    else {
      if (i !== s) {
        const o = this._managedResources[s];
        this._managedResources[i] = o, o._gcData.index = i;
      }
      this._managedResources.length--;
    }
    e._gcData = null, e._gcLastUsed = -1;
  }
  /**
   * Registers a hash-based resource collection for garbage collection tracking.
   * Resources in the hash will be automatically tracked and cleaned up when unused.
   * @param context - The object containing the hash property
   * @param hash - The property name on context that holds the resource hash
   * @param type - The type of resources in the hash ('resource' or 'renderable')
   * @param priority - Processing priority (lower values are processed first)
   */
  addResourceHash(e, t, i, s = 0) {
    this._managedResourceHashes.push({
      context: e,
      hash: t,
      type: i,
      priority: s
    }), this._managedResourceHashes.sort((o, r) => o.priority - r.priority);
  }
  /**
   * Performs garbage collection by cleaning up unused resources.
   * Removes resources that haven't been used for longer than maxUnusedTime.
   */
  run() {
    if (this._running) return;
    const e = performance.now(), t = this._managedResourceHashes, i = this._managedResources;
    this._running = !0;
    try {
      for (const o of t)
        this.runOnHash(o, e);
      const s = i.length;
      for (let o = 0; o < s; o++) {
        const r = i[o];
        r && this.runOnResource(r, e);
      }
    } finally {
      let s = 0;
      for (let o = 0; o < i.length; o++) {
        const r = i[o];
        r && (s !== o && (i[s] = r, r._gcData.index = s), s++);
      }
      i.length = s, this._running = !1;
    }
  }
  updateRenderableGCTick(e, t) {
    var o, r, a, l, d;
    const i = (o = e.renderGroup) != null ? o : e.parentRenderGroup, s = (a = (r = i == null ? void 0 : i.instructionSet) == null ? void 0 : r.gcTick) != null ? a : -1;
    ((l = i == null ? void 0 : i.gcTick) != null ? l : 0) === s && (e._gcLastUsed = t, (d = e._onTouch) == null || d.call(e, t));
  }
  runOnResource(e, t) {
    e._gcData.type === "renderable" && this.updateRenderableGCTick(e, t), !(t - e._gcLastUsed < this.maxUnusedTime || !e.autoGarbageCollect) && (e.off("unload", this.removeResource, this), e.unload(), this.removeResource(e));
  }
  /**
   * Creates a clone of the hash, copying all non-null entries up to (but not including) the stop key.
   * @param hashValue - The original hash to clone from
   * @param stopKey - The key to stop at (exclusive)
   * @returns A new hash object with copied entries
   */
  _createHashClone(e, t) {
    const i = /* @__PURE__ */ Object.create(null);
    for (const s in e) {
      if (s === t) break;
      e[s] !== null && (i[s] = e[s]);
    }
    return i;
  }
  runOnHash(e, t) {
    var d, c;
    const { context: i, hash: s, type: o } = e, r = i[s];
    let a = null, l = 0;
    for (const u in r) {
      const p = r[u];
      if (p === null) {
        l++, l === 1e4 && !a && (a = this._createHashClone(r, u));
        continue;
      }
      if (p._gcLastUsed === -1) {
        p._gcLastUsed = t, (d = p._onTouch) == null || d.call(p, t), a && (a[u] = p);
        continue;
      }
      if (o === "renderable" && this.updateRenderableGCTick(p, t), !(t - p._gcLastUsed < this.maxUnusedTime) && p.autoGarbageCollect) {
        if (o === "renderable") {
          const y = p, b = (c = y.renderGroup) != null ? c : y.parentRenderGroup;
          b && (b.structureDidChange = !0);
        }
        p.unload(), p._gcData = null, p._gcLastUsed = -1, a || (l + 1 !== 1e4 ? (r[u] = null, l++) : a = this._createHashClone(r, u));
      } else a && (a[u] = p);
    }
    a && (i[s] = a);
  }
  /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */
  destroy() {
    this.enabled = !1, this._managedResources.forEach((e) => {
      e == null || e.off("unload", this.removeResource, this);
    }), this._managedResources.length = 0, this._managedResourceHashes.length = 0, this._managedCollections.length = 0, this._renderer = null;
  }
};
ny.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "gc",
  priority: 0
};
ny.defaultOptions = {
  /** Enable/disable the garbage collector */
  gcActive: !0,
  /** Time in ms before an unused resource is collected (default 1 minute) */
  gcMaxUnusedTime: 6e4,
  /** How often to run garbage collection in ms (default 30 seconds) */
  gcFrequency: 3e4
};
let FX = ny;
class AT {
  constructor(e) {
    this._stackIndex = 0, this._globalUniformDataStack = [], this._uniformsPool = [], this._activeUniforms = [], this._bindGroupPool = [], this._activeBindGroups = [], this._renderer = e;
  }
  reset() {
    this._stackIndex = 0;
    for (let e = 0; e < this._activeUniforms.length; e++)
      this._uniformsPool.push(this._activeUniforms[e]);
    for (let e = 0; e < this._activeBindGroups.length; e++)
      this._bindGroupPool.push(this._activeBindGroups[e]);
    this._activeUniforms.length = 0, this._activeBindGroups.length = 0;
  }
  start(e) {
    this.reset(), this.push(e);
  }
  bind({
    size: e,
    projectionMatrix: t,
    worldTransformMatrix: i,
    worldColor: s,
    offset: o
  }) {
    const r = this._renderer.renderTarget.renderTarget, a = this._stackIndex ? this._globalUniformDataStack[this._stackIndex - 1] : {
      worldTransformMatrix: new st(),
      worldColor: 4294967295,
      offset: new Gt()
    }, l = {
      projectionMatrix: t || this._renderer.renderTarget.projectionMatrix,
      resolution: e || r.size,
      worldTransformMatrix: i || a.worldTransformMatrix,
      worldColor: s || a.worldColor,
      offset: o || a.offset,
      bindGroup: null
    }, d = this._uniformsPool.pop() || this._createUniforms();
    this._activeUniforms.push(d);
    const c = d.uniforms;
    c.uProjectionMatrix = l.projectionMatrix, c.uResolution = l.resolution, c.uWorldTransformMatrix.copyFrom(l.worldTransformMatrix), c.uWorldTransformMatrix.tx -= l.offset.x, c.uWorldTransformMatrix.ty -= l.offset.y, oT(
      l.worldColor,
      c.uWorldColorAlpha,
      0
    ), d.update();
    let u;
    this._renderer.renderPipes.uniformBatch ? u = this._renderer.renderPipes.uniformBatch.getUniformBindGroup(d, !1) : (u = this._bindGroupPool.pop() || new Eo(), this._activeBindGroups.push(u), u.setResource(d, 0)), l.bindGroup = u, this._currentGlobalUniformData = l;
  }
  push(e) {
    this.bind(e), this._globalUniformDataStack[this._stackIndex++] = this._currentGlobalUniformData;
  }
  pop() {
    this._currentGlobalUniformData = this._globalUniformDataStack[--this._stackIndex - 1], this._renderer.type === Vi.WEBGL && this._currentGlobalUniformData.bindGroup.resources[0].update();
  }
  get bindGroup() {
    return this._currentGlobalUniformData.bindGroup;
  }
  get globalUniformData() {
    return this._currentGlobalUniformData;
  }
  get uniformGroup() {
    return this._currentGlobalUniformData.bindGroup.resources[0];
  }
  _createUniforms() {
    return new ms({
      uProjectionMatrix: { value: new st(), type: "mat3x3<f32>" },
      uWorldTransformMatrix: { value: new st(), type: "mat3x3<f32>" },
      // TODO - someone smart - set this to be a unorm8x4 rather than a vec4<f32>
      uWorldColorAlpha: { value: new Float32Array(4), type: "vec4<f32>" },
      uResolution: { value: [0, 0], type: "vec2<f32>" }
    }, {
      isStatic: !0
    });
  }
  destroy() {
    this._renderer = null, this._globalUniformDataStack.length = 0, this._uniformsPool.length = 0, this._activeUniforms.length = 0, this._bindGroupPool.length = 0, this._activeBindGroups.length = 0, this._currentGlobalUniformData = null;
  }
}
AT.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "globalUniforms"
};
let NX = 1;
class PT {
  constructor() {
    this._tasks = [], this._offset = 0;
  }
  /** Initializes the scheduler system and starts the ticker. */
  init() {
    Ci.system.add(this._update, this);
  }
  /**
   * Schedules a repeating task.
   * @param func - The function to execute.
   * @param duration - The interval duration in milliseconds.
   * @param useOffset - this will spread out tasks so that they do not all run at the same time
   * @returns The unique identifier for the scheduled task.
   */
  repeat(e, t, i = !0) {
    const s = NX++;
    let o = 0;
    return i && (this._offset += 1e3, o = this._offset), this._tasks.push({
      func: e,
      duration: t,
      start: performance.now(),
      offset: o,
      last: performance.now(),
      repeat: !0,
      id: s
    }), s;
  }
  /**
   * Cancels a scheduled task.
   * @param id - The unique identifier of the task to cancel.
   */
  cancel(e) {
    for (let t = 0; t < this._tasks.length; t++)
      if (this._tasks[t].id === e) {
        this._tasks.splice(t, 1);
        return;
      }
  }
  /**
   * Updates and executes the scheduled tasks.
   * @private
   */
  _update() {
    const e = performance.now();
    for (let t = 0; t < this._tasks.length; t++) {
      const i = this._tasks[t];
      if (e - i.offset - i.last >= i.duration) {
        const s = e - i.start;
        i.func(s), i.last = e;
      }
    }
  }
  /**
   * Destroys the scheduler system and removes all tasks.
   * @internal
   */
  destroy() {
    Ci.system.remove(this._update, this), this._tasks.length = 0;
  }
}
PT.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "scheduler",
  priority: 0
};
let s2 = !1;
function UX(n) {
  if (!s2) {
    if (Pt.get().getNavigator().userAgent.toLowerCase().indexOf("chrome") > -1) {
      const e = [
        `%c  %c  %c  %c  %c PixiJS %c v${jp} (${n}) http://www.pixijs.com/

`,
        "background: #E72264; padding:5px 0;",
        "background: #6CA2EA; padding:5px 0;",
        "background: #B5D33D; padding:5px 0;",
        "background: #FED23F; padding:5px 0;",
        "color: #FFFFFF; background: #E72264; padding:5px 0;",
        "color: #E72264; background: #FFFFFF; padding:5px 0;"
      ];
      globalThis.console.log(...e);
    } else globalThis.console && globalThis.console.log(`PixiJS ${jp} - ${n} - http://www.pixijs.com/`);
    s2 = !0;
  }
}
class iy {
  constructor(e) {
    this._renderer = e;
  }
  /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */
  init(e) {
    if (e.hello) {
      let t = this._renderer.name;
      this._renderer.type === Vi.WEBGL && (t += ` ${this._renderer.context.webGLVersion}`), UX(t);
    }
  }
}
iy.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "hello",
  priority: -2
};
iy.defaultOptions = {
  /** {@link WebGLOptions.hello} */
  hello: !1
};
const sy = class ET {
  /**
   * Creates a new RenderableGCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */
  constructor(e) {
    this._renderer = e;
  }
  /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options for the renderer
   */
  init(e) {
    e = { ...ET.defaultOptions, ...e }, this.maxUnusedTime = e.renderableGCMaxUnusedTime;
  }
  /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */
  get enabled() {
    return rt("8.15.0", "RenderableGCSystem.enabled is deprecated, please use the GCSystem.enabled instead."), this._renderer.gc.enabled;
  }
  /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */
  set enabled(e) {
    rt("8.15.0", "RenderableGCSystem.enabled is deprecated, please use the GCSystem.enabled instead."), this._renderer.gc.enabled = e;
  }
  /**
   * Adds a hash table to be managed by the garbage collector.
   * @param context - The object containing the hash table
   * @param hash - The property name of the hash table
   */
  addManagedHash(e, t) {
    rt("8.15.0", "RenderableGCSystem.addManagedHash is deprecated, please use the GCSystem.addCollection instead."), this._renderer.gc.addCollection(e, t, "hash");
  }
  /**
   * Adds an array to be managed by the garbage collector.
   * @param context - The object containing the array
   * @param hash - The property name of the array
   */
  addManagedArray(e, t) {
    rt("8.15.0", "RenderableGCSystem.addManagedArray is deprecated, please use the GCSystem.addCollection instead."), this._renderer.gc.addCollection(e, t, "array");
  }
  /**
   * Starts tracking a renderable for garbage collection.
   * @param _renderable - The renderable to track
   * @deprecated since 8.15.0
   */
  addRenderable(e) {
    rt("8.15.0", "RenderableGCSystem.addRenderable is deprecated, please use the GCSystem instead."), this._renderer.gc.addResource(e, "renderable");
  }
  /**
   * Performs garbage collection by cleaning up unused renderables.
   * Removes renderables that haven't been used for longer than maxUnusedTime.
   */
  run() {
    rt("8.15.0", "RenderableGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.run();
  }
  /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */
  destroy() {
    this._renderer = null;
  }
};
sy.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "renderableGC",
  priority: 0
};
sy.defaultOptions = {
  /** Enable/disable the garbage collector */
  renderableGCActive: !0,
  /** Time in ms before an unused resource is collected (default 1 minute) */
  renderableGCMaxUnusedTime: 6e4,
  /** How often to run garbage collection in ms (default 30 seconds) */
  renderableGCFrequency: 3e4
};
let GX = sy;
const oy = class Zh {
  /**
   * Frame count since started.
   * @readonly
   * @deprecated since 8.15.0
   */
  get count() {
    return this._renderer.tick;
  }
  /**
   * Frame count since last garbage collection.
   * @readonly
   * @deprecated since 8.15.0
   */
  get checkCount() {
    return this._checkCount;
  }
  set checkCount(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._checkCount = e;
  }
  /**
   * Maximum idle frames before a texture is destroyed by garbage collection.
   * @see TextureGCSystem.defaultMaxIdle
   * @deprecated since 8.15.0
   */
  get maxIdle() {
    return this._renderer.gc.maxUnusedTime / 1e3 * 60;
  }
  set maxIdle(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.maxUnusedTime = e / 60 * 1e3;
  }
  /**
   * Frames between two garbage collections.
   * @see TextureGCSystem.defaultCheckCountMax
   * @deprecated since 8.15.0
   */
  // eslint-disable-next-line dot-notation
  get checkCountMax() {
    return Math.floor(this._renderer.gc._frequency / 1e3);
  }
  set checkCountMax(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead.");
  }
  /**
   * Current garbage collection mode.
   * @see TextureGCSystem.defaultMode
   * @deprecated since 8.15.0
   */
  get active() {
    return this._renderer.gc.enabled;
  }
  set active(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.enabled = e;
  }
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e, this._checkCount = 0;
  }
  init(e) {
    e.textureGCActive !== Zh.defaultOptions.textureGCActive && (this.active = e.textureGCActive), e.textureGCMaxIdle !== Zh.defaultOptions.textureGCMaxIdle && (this.maxIdle = e.textureGCMaxIdle), e.textureGCCheckCountMax !== Zh.defaultOptions.textureGCCheckCountMax && (this.checkCountMax = e.textureGCCheckCountMax);
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   * @deprecated since 8.15.0
   */
  run() {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.run();
  }
  destroy() {
    this._renderer = null;
  }
};
oy.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "textureGC"
};
oy.defaultOptions = {
  /**
   * If set to true, this will enable the garbage collector on the GPU.
   * @default true
   */
  textureGCActive: !0,
  /**
   * @deprecated since 8.3.0
   * @see {@link TextureGCSystemOptions.textureGCMaxIdle}
   */
  textureGCAMaxIdle: null,
  /**
   * The maximum idle frames before a texture is destroyed by garbage collection.
   * @default 60 * 60
   */
  textureGCMaxIdle: 3600,
  /**
   * Frames between two garbage collections.
   * @default 600
   */
  textureGCCheckCountMax: 600
};
let jX = oy;
const RT = class zT extends di {
  /**
   * @param options - Options for creating a render target, or a WebGPU-flavored descriptor.
   */
  constructor(e = {}) {
    var i;
    super(), this.uid = Lt("renderTarget"), this.colorAttachments = [], this.dirtyId = 0, this.isRoot = !1, this._size = new Float32Array(2), this._managedColorTextures = !1, this._depth = !1, this._stencil = !1, this._colorTextures = null;
    const t = "colorAttachments" in e ? e : this._normalizeOptions(e);
    if (this.isRoot = (i = t.isRoot) != null ? i : !1, this.label = t.label, this.colorAttachments = t.colorAttachments, this.depthStencilAttachment = t.depthStencilAttachment, this.depthStencilAttachment) {
      const s = this.depthStencilAttachment.texture.format;
      this._depth || (this._depth = s.includes("depth")), this._stencil || (this._stencil = s.includes("stencil"));
    }
    if (this.colorAttachments.length === 0 && !this.depthStencilAttachment)
      throw new Error("[RenderTarget] no color textures or depth textures were provided. Provide a depthStencilTexture or set depth/stencil to true when using colorTextures: 0.");
    if (this.colorAttachments.length > 0) {
      const s = this.colorTexture;
      this.resize(s.width, s.height, s._resolution);
    }
    this.sizeSource && this.sizeSource.on("resize", this.onSourceResize, this);
  }
  _normalizeOptions(e) {
    const t = { ...zT.defaultOptions, ...e }, i = [];
    let s;
    if (typeof t.colorTextures == "number") {
      if (t.colorTextures > 0) {
        this._managedColorTextures = !0;
        for (let r = 0; r < t.colorTextures; r++)
          i.push({
            texture: new an({
              width: t.width,
              height: t.height,
              resolution: t.resolution,
              antialias: t.antialias
            }),
            loadOp: "clear",
            storeOp: "store"
          });
      }
    } else
      t.colorTextures.forEach((r) => {
        i.push({
          texture: r.source,
          loadOp: "clear",
          storeOp: "store"
        });
      });
    const o = t.depthStencilTexture === !0;
    if (this._depth = !!(t.depth || o), this._stencil = !!(t.stencil || o), t.depthStencilTexture instanceof Ze || t.depthStencilTexture instanceof an) {
      if (t.isRoot)
        throw new Error("[RenderTarget] cannot attach a depth-stencil texture to the screen — the canvas owns its own depth/stencil buffers. Render to a texture target instead.");
      s = {
        texture: t.depthStencilTexture.source
      };
    } else (o && !t.isRoot || (t.stencil || t.depth) && i.length === 0) && (s = this._createDepthStencilTexture(t.width, t.height, t.resolution));
    return {
      colorAttachments: i,
      depthStencilAttachment: s,
      isRoot: t.isRoot,
      label: t.label
    };
  }
  get size() {
    const e = this._size;
    return e[0] = this.pixelWidth, e[1] = this.pixelHeight, e;
  }
  get width() {
    return this.sizeSource.width;
  }
  get height() {
    return this.sizeSource.height;
  }
  get pixelWidth() {
    return this.sizeSource.pixelWidth;
  }
  get pixelHeight() {
    return this.sizeSource.pixelHeight;
  }
  get resolution() {
    return this.sizeSource._resolution;
  }
  /**
   * An array of textures that can be written to by the GPU - mostly this has one texture in Pixi, but you could
   * write to multiple if required! (eg deferred lighting).
   * This is a backwards-compatible getter that extracts the textures from `colorAttachments`.
   */
  get colorTextures() {
    return this._colorTextures || (this._colorTextures = this.colorAttachments.map((e) => e.texture)), this._colorTextures;
  }
  /** The stencil and depth buffer will write to this texture in WebGPU. */
  get depthStencilTexture() {
    var e, t;
    return (t = (e = this.depthStencilAttachment) == null ? void 0 : e.texture) != null ? t : null;
  }
  /** Whether this target provides a depth buffer — requested via options or implied by its attachment's format. */
  get depth() {
    return this._depth;
  }
  /** Whether this target provides a stencil buffer — requested via options or implied by its attachment's format. */
  get stencil() {
    return this._stencil;
  }
  get colorTexture() {
    var e;
    return (e = this.colorAttachments[0]) == null ? void 0 : e.texture;
  }
  /**
   * The texture that drives size, resolution, and resize events.
   * For standard targets this is `colorAttachments[0].texture`;
   * for depth-only targets it is `depthStencilAttachment.texture`.
   */
  get sizeSource() {
    var e, t, i;
    return (i = (e = this.colorAttachments[0]) == null ? void 0 : e.texture) != null ? i : (t = this.depthStencilAttachment) == null ? void 0 : t.texture;
  }
  onSourceResize(e) {
    this.resize(e.width, e.height, e._resolution, !0);
  }
  /**
   * This will ensure a depthStencil texture is created for this render target.
   * Most likely called by the mask system to make sure we have stencil buffer added.
   * @internal
   */
  ensureDepthStencilTexture() {
    this._createDepthStencilTexture(this.sizeSource.width, this.sizeSource.height, this.sizeSource._resolution), this._depth = !0, this._stencil = !0;
  }
  resize(e, t, i = this.resolution, s = !1) {
    if (this.dirtyId++, this.colorAttachments.forEach((o, r) => {
      s && r === 0 || o.texture.resize(e, t, i);
    }), this.depthStencilAttachment) {
      if (s && this.colorAttachments.length === 0) return;
      this.depthStencilAttachment.texture.resize(e, t, i);
    }
  }
  destroy() {
    !this.colorAttachments && !this.depthStencilAttachment || (this.emit("destroy", this), this.sizeSource.off("resize", this.onSourceResize, this), this._managedColorTextures && this.colorAttachments.forEach((e) => {
      e.texture.destroy();
    }), this.depthStencilAttachment && (this.depthStencilAttachment.texture.destroy(), delete this.depthStencilAttachment), this.colorAttachments = null, this._colorTextures = null, this.removeAllListeners());
  }
  /**
   * The single recipe for internally-created depth-stencil textures.
   * @param width
   * @param height
   * @param resolution
   */
  _createDepthStencilTexture(e, t, i) {
    var s;
    return (s = this.depthStencilAttachment) != null || (this.depthStencilAttachment = {
      texture: new an({
        width: e,
        height: t,
        resolution: i,
        format: "depth24plus-stencil8",
        autoGenerateMipmaps: !1,
        antialias: !1,
        mipLevelCount: 1
        // sampleCount: handled by the render target system..
      })
    }), this.depthStencilAttachment;
  }
};
RT.defaultOptions = {
  /** the width of the RenderTarget */
  width: 0,
  /** the height of the RenderTarget */
  height: 0,
  /** the resolution of the RenderTarget */
  resolution: 1,
  /** an array of textures, or a number indicating how many color textures there should be */
  colorTextures: 1,
  /** should this render target have a stencil buffer? */
  stencil: !1,
  /** should this render target have a depth buffer? */
  depth: !1,
  /** should this render target be antialiased? */
  antialias: !1,
  // save on perf by default!
  /** is this a root element, true if this is gl context owners render target */
  isRoot: !1
};
let Qh = RT;
const Oa = /* @__PURE__ */ new Map();
zl.register(Oa);
function $T(n, e) {
  if (!Oa.has(n)) {
    const t = new Ze({
      source: new ki({
        resource: n,
        ...e
      })
    }), i = () => {
      Oa.get(n) === t && Oa.delete(n);
    };
    t.once("destroy", i), t.source.once("destroy", i), Oa.set(n, t);
  }
  return Oa.get(n);
}
const ry = class DT {
  /**
   * Whether CSS dimensions of canvas view should be resized to screen dimensions automatically.
   * This is only supported for HTMLCanvasElement and will be ignored if the canvas is an OffscreenCanvas.
   * @type {boolean}
   */
  get autoDensity() {
    return this.texture.source.autoDensity;
  }
  set autoDensity(e) {
    this.texture.source.autoDensity = e;
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.texture.source._resolution;
  }
  set resolution(e) {
    this.texture.source.resize(
      this.texture.source.width,
      this.texture.source.height,
      e
    );
  }
  constructor(e) {
    this._renderer = e;
  }
  /**
   * initiates the view system
   * @param options - the options for the view
   */
  init(e) {
    e = {
      ...DT.defaultOptions,
      ...e
    }, e.view && (rt(on, "ViewSystem.view has been renamed to ViewSystem.canvas"), e.canvas = e.view), this.screen = new _t(0, 0, e.width, e.height), this.canvas = e.canvas || Pt.get().createCanvas(), this.antialias = !!e.antialias;
    const { depth: t, ...i } = e;
    this.texture = $T(this.canvas, i), this.renderTarget = new Qh({
      colorTextures: [this.texture],
      depth: !!t,
      isRoot: !0
    }), this.texture.source.transparent = e.backgroundAlpha < 1, this.texture.source.on("resize", this._updateScreenSize, this), this.resolution = e.resolution, this._updateScreenSize();
  }
  /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   * @param resolution
   */
  resize(e, t, i) {
    this.texture.source.resize(e, t, i), this.screen.width = this.texture.frame.width, this.screen.height = this.texture.frame.height;
  }
  /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {options | false} options - The options for destroying the view, or "false".
   * @example
   * viewSystem.destroy();
   * viewSystem.destroy(true);
   * viewSystem.destroy({ removeView: true });
   */
  destroy(e = !1) {
    (typeof e == "boolean" ? e : e != null && e.removeView) && this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas), this.texture.source.off("resize", this._updateScreenSize, this), Rn.removeScreen(this._renderer.uid), xl.removeScreen(this._renderer.uid), this.texture.destroy();
  }
  /**
   * Tells the texture and canvas pools how big this renderer's screen is, in physical pixels, so they
   * can hand out screen sized resources instead of rounding every request up to a power of two.
   */
  _updateScreenSize() {
    const { pixelWidth: e, pixelHeight: t } = this.texture.source, i = this._renderer.uid;
    Rn.setScreenSize(i, e, t), xl.setScreenSize(i, e, t);
  }
};
ry.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "view",
  priority: 0
};
ry.defaultOptions = {
  /**
   * {@link WebGLOptions.width}
   * @default 800
   */
  width: 800,
  /**
   * {@link WebGLOptions.height}
   * @default 600
   */
  height: 600,
  /**
   * {@link WebGLOptions.autoDensity}
   * @default false
   */
  autoDensity: !1,
  /**
   * {@link WebGLOptions.antialias}
   * @default false
   */
  antialias: !1
};
let HX = ry;
const ay = [
  RX,
  AT,
  iy,
  HX,
  ST,
  FX,
  jX,
  CT,
  zX,
  xS,
  GX,
  PT
], OT = [
  Z1,
  q1,
  J1,
  X1,
  K1,
  vT,
  mT,
  Y1
];
function VX(n, e, t, i, s, o) {
  const r = o ? 1 : -1;
  return n.identity(), n.a = 1 / i * 2, n.d = r * (1 / s * 2), n.tx = -1 - e * n.a, n.ty = -r - t * n.d, n;
}
function WX(n) {
  if (n.colorAttachments.length === 0) return !1;
  const e = n.colorTexture.resource;
  return globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement && document.body.contains(e);
}
class ly {
  constructor(e) {
    this.rootViewPort = new _t(), this.viewport = new _t(), this.onRenderTargetChange = new gS("onRenderTargetChange"), this.projectionMatrix = new st(), this.defaultClearColor = [0, 0, 0, 0], this._renderSurfaceToRenderTargetHash = /* @__PURE__ */ new Map(), this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null), this._renderTargetStack = [], this._bindState = {
      target: null,
      frame: void 0,
      mipLevel: 0,
      layer: 0,
      flipY: !1
    }, this._bindFrame = new _t(), this._renderer = e, e.gc.addCollection(this, "_gpuRenderTargetHash", "hash");
  }
  /** the current active render surface that the render target is created from */
  get renderSurface() {
    return this._bindState.target;
  }
  /** the current mip level being rendered to (for texture subresources) */
  get mipLevel() {
    return this._bindState.mipLevel;
  }
  /** the current array layer being rendered to (for array-backed targets) */
  get layer() {
    return this._bindState.layer;
  }
  /** called when dev wants to finish a render pass */
  finishRenderPass() {
    this.adaptor.finishRenderPass(this.renderTarget);
  }
  /**
   * called when the renderer starts to render a scene: resets the bind stack and binds the
   * root render surface
   * @param options - the {@link BindOptions} for the root binding
   */
  renderStart(e) {
    var t, i;
    this._renderTargetStack.length = 0, this.push(e), this.rootViewPort.copyFrom(this.viewport), this.rootRenderTarget = this.renderTarget, this.renderingToScreen = WX(this.rootRenderTarget), (i = (t = this.adaptor).prerender) == null || i.call(t, this.rootRenderTarget);
  }
  postrender() {
    var e, t;
    (t = (e = this.adaptor).postrender) == null || t.call(e, this.rootRenderTarget);
  }
  bind(e, t = !0, i, s, o = 0, r = 0, a) {
    var _, x, T, M, z;
    let l;
    "target" in e ? l = e : (rt("8.20.0", "RenderTargetSystem.bind: positional arguments are deprecated, please use an options object instead: bind({ target, clear, clearColor, frame, mipLevel, layer, flipY })"), l = { target: e, clear: t, clearColor: i, frame: s, mipLevel: o, layer: r, flipY: a });
    const d = l.target;
    t = (_ = l.clear) != null ? _ : !0, i = l.clearColor, o = ((x = l.mipLevel) != null ? x : 0) | 0, r = ((T = l.layer) != null ? T : 0) | 0, a = l.flipY, s = l.frame;
    const c = this.getRenderTarget(d), u = this.renderTarget !== c || !!c.flipY != !!a;
    this.renderTarget = c;
    const p = this.getGpuRenderTarget(c);
    (c.pixelWidth !== p.width || c.pixelHeight !== p.height) && (this.adaptor.resizeGpuRenderTarget(c), p.width = c.pixelWidth, p.height = c.pixelHeight);
    const f = ((M = c.colorAttachments[0]) == null ? void 0 : M.texture) || ((z = c.depthStencilAttachment) == null ? void 0 : z.texture), y = this.viewport, b = f.dimension === "3d" ? Math.max(f.depth >> o, 1) : f.depthOrArrayLayers;
    if (r < 0 || r >= b)
      throw new Error(`[RenderTargetSystem] layer ${r} is out of bounds (layer count=${b}).`);
    const w = this._bindState;
    w.target = d, w.frame = s ? this._bindFrame.copyFrom(s) : void 0, w.mipLevel = o, w.layer = r, w.flipY = a;
    const k = Math.max(f.pixelWidth >> o, 1), S = Math.max(f.pixelHeight >> o, 1);
    if (!s && d instanceof Ze && (s = d.frame), s) {
      const P = f._resolution, D = 1 << Math.max(o, 0), $ = s.x * P + 0.5 | 0, O = s.y * P + 0.5 | 0, L = s.width * P + 0.5 | 0, Z = s.height * P + 0.5 | 0;
      let J = Math.floor($ / D), re = Math.floor(O / D), F = Math.ceil(L / D), W = Math.ceil(Z / D);
      J < 0 && (F += J, J = 0), re < 0 && (W += re, re = 0), J = Math.min(J, k - 1), re = Math.min(re, S - 1), F = Math.min(F, k - J), W = Math.min(W, S - re), F = Math.max(F, 1), W = Math.max(W, 1), y.x = J, y.y = re, y.width = F, y.height = W;
    } else
      y.x = 0, y.y = 0, y.width = k, y.height = S;
    return c.flipY = a, VX(
      this.projectionMatrix,
      0,
      0,
      y.width / f.resolution,
      y.height / f.resolution,
      !c.isRoot != !!c.flipY
    ), this.adaptor.startRenderPass(c, t, i, y, o, r), u && this.onRenderTargetChange.emit(c), c;
  }
  /**
   * Captures the current binding as a {@link BindOptions} that can be passed back to
   * {@link RenderTargetSystem.bind} to restore it. The capture replays non-destructively:
   * its `clear` is `CLEAR.NONE`, so restoring never wipes the target.
   *
   * ```js
   * const saved = renderer.renderTarget.getBindState();
   *
   * renderer.renderTarget.bind({ target: scratchTexture, clear: true });
   * // ... draw ...
   * renderer.renderTarget.bind(saved);
   *
   * // or compose: the saved binding, but into mip 1
   * renderer.renderTarget.bind({ ...saved, mipLevel: 1 });
   * ```
   *
   * The capture is a snapshot owned by the caller — later binds cannot change it — and holds
   * `target` and `frame` as they were passed, so a Texture bound without an explicit frame
   * replays through its frame fallback. It stays valid for as long as its target does.
   * Pass `out` to reuse one object across captures; every field of it is overwritten.
   * @param out - an optional object to write the bind state into; allocated when omitted
   * @returns the captured bind state (`out` when provided)
   */
  getBindState(e) {
    if (!this.renderTarget)
      throw new Error("[RenderTargetSystem] getBindState is only valid while a render surface is bound");
    const t = this._bindState;
    return e != null || (e = {}), e.target = t.target, e.clear = wn.NONE, e.clearColor = void 0, t.frame ? e.frame ? e.frame.copyFrom(t.frame) : e.frame = t.frame.clone() : e.frame = void 0, e.mipLevel = t.mipLevel, e.layer = t.layer, e.flipY = !!t.flipY, e;
  }
  /**
   * Whether pixi inverts the front face for a bind — `true` when a front-facing triangle ends up
   * wound the opposite way on the surface, so the winding/cull has been inverted to compensate.
   *
   * With no arguments, answers for the current bind. With a target, answers for that target as if
   * it were bound with the given `flipY` (defaulting to `false`, exactly as {@link bind} would), so
   * a consumer can choose a projection or a `flipY` before binding.
   *
   * This is the requested `flipY` combined with the backend's inherent orientation, not the raw request:
   *
   * ```text
   * inverted = flipY XOR (isWebGL && !isRoot)
   * ```
   *
   * WebGL's non-root FBOs carry an inherent Y-flip vs the root (the classic render-texture flip), so the
   * same requested `flipY` lands with the opposite winding depending on `isRoot`. WebGPU has no such
   * inherent flip, so there it is simply `flipY`. This is the one spelling of the rule: the winding each
   * backend bakes at bind ({@link GlStateSystem} / {@link PipelineSystem}) comes from here too, so
   * consumers (e.g. 3D pipelines) read the resolved orientation instead of re-deriving it.
   * @param renderTarget - the target to ask about; omit for the current bind
   * @param flipY - the `flipY` the target would be bound with; ignored when `renderTarget` is omitted
   * @returns whether the front face is inverted
   */
  isFrontFaceInverted(e, t) {
    if (!e) {
      if (e = this.renderTarget, !e) return !1;
      t = e.flipY;
    }
    return !!t != (this._renderer.type === Vi.WEBGL && !e.isRoot);
  }
  /**
   * The effective front-face orientation of the current bind.
   * @deprecated since 8.21.0, use {@link isFrontFaceInverted} instead
   * @returns whether the current bind's front face is inverted
   */
  get frontFaceInverted() {
    return rt(zs, "RenderTargetSystem.frontFaceInverted is deprecated, use isFrontFaceInverted() instead"), this.isFrontFaceInverted();
  }
  clear(e, t = wn.ALL, i, s = this.mipLevel, o = this.layer) {
    t && (e && (e = this.getRenderTarget(e)), this.adaptor.clear(
      e || this.renderTarget,
      t,
      i,
      this.viewport,
      s,
      o
    ));
  }
  contextChange() {
    this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  push(e, t = wn.ALL, i, s, o = 0, r = 0, a) {
    let l;
    "target" in e ? l = e : (rt("8.20.0", "RenderTargetSystem.push: positional arguments are deprecated, please use an options object instead: push({ target, clear, clearColor, frame, mipLevel, layer, flipY })"), l = { target: e, clear: t, clearColor: i, frame: s, mipLevel: o, layer: r, flipY: a });
    const d = this.bind(l);
    return this._renderTargetStack.push({
      target: l.target,
      clear: !1,
      clearColor: void 0,
      frame: l.frame ? l.frame.clone() : void 0,
      mipLevel: l.mipLevel,
      layer: l.layer,
      flipY: l.flipY
    }), d;
  }
  /**
   * Pops the current render target and restores the previous binding.
   * @returns the render target that was restored
   */
  pop() {
    this._renderTargetStack.pop();
    const e = this._renderTargetStack[this._renderTargetStack.length - 1];
    if (!e)
      throw new Error("[RenderTargetSystem] pop: no previous binding to restore (unbalanced pop)");
    return this.bind(e);
  }
  /**
   * Gets the render target from the provide render surface. Eg if its a texture,
   * it will return the render target for the texture.
   * If its a render target, it will return the same render target.
   * @param renderSurface - the render surface to get the render target for
   * @returns the render target for the render surface
   */
  getRenderTarget(e) {
    var t;
    return e.isTexture && (e = e.source), (t = this._renderSurfaceToRenderTargetHash.get(e)) != null ? t : this._initRenderTarget(e);
  }
  /**
   * Copies a render surface to another texture.
   *
   * NOTE:
   * for sourceRenderSurfaceTexture, The render target must be something that is written too by the renderer
   *
   * The following is not valid:
   * @example
   * const canvas = document.createElement('canvas')
   * canvas.width = 200;
   * canvas.height = 200;
   *
   * const ctx = canvas2.getContext('2d')!
   * ctx.fillStyle = 'red'
   * ctx.fillRect(0, 0, 200, 200);
   *
   * const texture = RenderTexture.create({
   *   width: 200,
   *   height: 200,
   * })
   * const renderTarget = renderer.renderTarget.getRenderTarget(canvas2);
   *
   * renderer.renderTarget.copyToTexture(renderTarget,texture, {x:0,y:0},{width:200,height:200},{x:0,y:0});
   *
   * The best way to copy a canvas is to create a texture from it. Then render with that.
   *
   * Parsing in a RenderTarget canvas context (with a 2d context)
   * @param sourceRenderSurface - the render surface (render target, texture, or canvas) to copy from
   * @param {Texture} destinationTexture - the texture to copy to
   * @param {object} originSrc - the origin of the copy
   * @param {number} originSrc.x - the x origin of the copy
   * @param {number} originSrc.y - the y origin of the copy
   * @param {object} size - the size of the copy
   * @param {number} size.width - the width of the copy
   * @param {number} size.height - the height of the copy
   * @param {object} originDest - the destination origin (top left to paste from!)
   * @param {number} originDest.x - the x origin of the paste
   * @param {number} originDest.y - the y origin of the paste
   */
  copyToTexture(e, t, i, s, o) {
    const r = this.getRenderTarget(e);
    i.x < 0 && (s.width += i.x, o.x -= i.x, i.x = 0), i.y < 0 && (s.height += i.y, o.y -= i.y, i.y = 0);
    const { pixelWidth: a, pixelHeight: l } = r;
    return s.width = Math.min(s.width, a - i.x), s.height = Math.min(s.height, l - i.y), this.adaptor.copyToTexture(
      r,
      t,
      i,
      s,
      o
    );
  }
  /**
   * Copies the depth attachment from one render target to another.
   * Both source and destination must have a depthStencilAttachment.
   *
   * **Important Note:** When using the copied depth buffer in a subsequent render pass,
   * you must ensure you do not clear the depth buffer again. If you need to clear the color
   * buffer of the destination render target, use `clear: CLEAR.COLOR` to preserve the copied depth data.
   * @example
   * ```js
   * renderer.renderTarget.copyDepthTexture(
   *   sourceRT, destRT, { x: 0, y: 0 }, { width: 200, height: 200 }, { x: 0, y: 0 }
   * );
   *
   * // In the subsequent render pass, clear ONLY the color buffer!
   * renderer.render({
   *   target: destRT,
   *   container: myMesh,
   *   clear: CLEAR.COLOR, // Preserves the copied depth
   *   clearColor: [0, 0, 0, 1]
   * });
   * ```
   * @param source - the render surface (render target, depth texture, or canvas) to copy depth from
   * @param destination - the depth/stencil texture to copy depth to
   * @param {object} originSrc - the origin of the copy
   * @param {number} originSrc.x - the x origin of the copy
   * @param {number} originSrc.y - the y origin of the copy
   * @param {object} size - the size of the copy
   * @param {number} size.width - the width of the copy
   * @param {number} size.height - the height of the copy
   * @param {object} originDest - the destination origin (top left to paste from!)
   * @param {number} originDest.x - the x origin of the paste
   * @param {number} originDest.y - the y origin of the paste
   */
  copyDepthTexture(e, t, i, s, o = { x: 0, y: 0 }) {
    const r = this.getRenderTarget(e);
    if (!r.depthStencilAttachment) {
      at("[RenderTargetSystem] copyDepthTexture: the source render target has no depth attachment to copy from");
      return;
    }
    const a = t.source;
    if (!a.format.includes("depth") && !a.format.includes("stencil")) {
      at(`[RenderTargetSystem] copyDepthTexture: the destination texture must have a depth/stencil format (got '${a.format}')`);
      return;
    }
    let l = i.x, d = i.y, c = o.x, u = o.y, p = s.width, f = s.height;
    l < 0 && (p += l, c -= l, l = 0), d < 0 && (f += d, u -= d, d = 0), p = Math.min(p, r.pixelWidth - l), f = Math.min(f, r.pixelHeight - d), p = Math.min(p, a.pixelWidth - c), f = Math.min(f, a.pixelHeight - u), !(p <= 0 || f <= 0) && this.adaptor.copyDepthTexture(
      r,
      t,
      { x: l, y: d },
      { width: p, height: f },
      { x: c, y: u }
    );
  }
  /**
   * ensures that we have a depth stencil buffer available to render to
   * This is used by the mask system to make sure we have a stencil buffer.
   */
  ensureDepthStencil() {
    if (!this.renderTarget.stencil) {
      if (this.renderTarget.depthStencilTexture) {
        at(`[RenderTargetSystem] a stencil mask is being used, but the render target's depthStencilTexture format '${this.renderTarget.depthStencilTexture.format}' has no stencil aspect, so masking cannot work here. Use a 'depth24plus-stencil8' texture instead.`);
        return;
      }
      this.renderTarget._depth = !0, this.renderTarget._stencil = !0, this.adaptor.startRenderPass(this.renderTarget, !1, null, this.viewport, 0, this.layer);
    }
  }
  /** nukes the render target system */
  destroy() {
    this._renderer = null, this._renderSurfaceToRenderTargetHash.forEach((e, t) => {
      e !== t ? this._releaseRenderTarget(t, e) : e.off("destroy", this._onRenderTargetDestroy, this);
    }), this._renderSurfaceToRenderTargetHash.clear();
    for (const e of Object.values(this._gpuRenderTargetHash))
      e && this.adaptor.destroyGpuRenderTarget(e);
    this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  _initRenderTarget(e) {
    let t = null;
    if (ki.test(e) && (e = $T(e).source), e instanceof Qh)
      t = e, e.once("destroy", this._onRenderTargetDestroy, this);
    else if (e instanceof an) {
      const i = e.format;
      t = i.includes("depth") || i.includes("stencil") ? new Qh({ colorTextures: 0, depthStencilTexture: e }) : new Qh({ colorTextures: [e] }), e.source instanceof ki && (t.isRoot = !0), e.once("destroy", this._onRenderSurfaceDestroy, this);
    }
    return this._renderSurfaceToRenderTargetHash.set(e, t), t;
  }
  _onRenderSurfaceDestroy(e) {
    const t = this._renderSurfaceToRenderTargetHash.get(e);
    t && this._releaseRenderTarget(e, t);
  }
  /**
   * A caller-owned render target is tearing itself down. It releases its own attachments,
   * so only the system's references to it and the backend objects built for it go here.
   * @param renderTarget - the render target being destroyed
   */
  _onRenderTargetDestroy(e) {
    this._renderSurfaceToRenderTargetHash.delete(e), this._releaseGpuRenderTarget(e);
  }
  /**
   * Tears down a render target that wraps a texture source, removing every reference the
   * system holds to it so neither the system's own teardown nor the source's `destroy`
   * event can destroy it a second time.
   * @param renderSurface - the texture source the render target wraps
   * @param renderTarget - the render target to release
   */
  _releaseRenderTarget(e, t) {
    t.destroy(), this._renderSurfaceToRenderTargetHash.delete(e), e.off("destroy", this._onRenderSurfaceDestroy, this), this._releaseGpuRenderTarget(t);
  }
  /**
   * Frees the backend objects (framebuffers, renderbuffers, MSAA textures) cached for a render target.
   * @param renderTarget - the render target whose backend counterpart is no longer needed
   */
  _releaseGpuRenderTarget(e) {
    const t = this._gpuRenderTargetHash[e.uid];
    t && (this._gpuRenderTargetHash[e.uid] = null, this.adaptor.destroyGpuRenderTarget(t));
  }
  getGpuRenderTarget(e) {
    return this._gpuRenderTargetHash[e.uid] || (this._gpuRenderTargetHash[e.uid] = this.adaptor.initGpuRenderTarget(e));
  }
  resetState() {
    this.renderTarget = null, this._bindState.target = null;
  }
}
class qX {
  /**
   * Initializes the adaptor.
   * @param renderer - Canvas renderer instance.
   * @param renderTargetSystem - The render target system.
   * @advanced
   */
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t;
  }
  /**
   * Creates a GPU render target for canvas.
   * @param renderTarget - Render target to initialize.
   * @advanced
   */
  initGpuRenderTarget(e) {
    const t = e.colorTexture, { canvas: i, context: s } = this._ensureCanvas(t);
    return {
      canvas: i,
      context: s,
      width: i.width,
      height: i.height
    };
  }
  /**
   * Resizes the backing canvas for a render target.
   * @param renderTarget - Render target to resize.
   * @advanced
   */
  resizeGpuRenderTarget(e) {
    const t = e.colorTexture, { canvas: i } = this._ensureCanvas(t);
    i.width = e.pixelWidth, i.height = e.pixelHeight;
  }
  /**
   * Starts a render pass on the canvas target.
   * @param renderTarget - Target to render to.
   * @param clear - Clear mode.
   * @param clearColor - Optional clear color.
   * @param viewport - Optional viewport.
   * @advanced
   */
  startRenderPass(e, t, i, s) {
    const o = this._renderTargetSystem.getGpuRenderTarget(e);
    this._renderer.canvasContext.activeContext = o.context, this._renderer.canvasContext.activeResolution = e.resolution, t && this.clear(e, t, i, s);
  }
  /**
   * Clears the render target.
   * @param renderTarget - Target to clear.
   * @param _clear - Clear mode (unused).
   * @param clearColor - Optional clear color.
   * @param viewport - Optional viewport rectangle.
   * @advanced
   */
  clear(e, t, i, s) {
    const r = this._renderTargetSystem.getGpuRenderTarget(e).context, a = s || { x: 0, y: 0, width: e.pixelWidth, height: e.pixelHeight };
    if (r.setTransform(1, 0, 0, 1, 0, 0), r.clearRect(a.x, a.y, a.width, a.height), i) {
      const l = pn.shared.setValue(i);
      l.alpha > 0 && (r.globalAlpha = l.alpha, r.fillStyle = l.toHex(), r.fillRect(a.x, a.y, a.width, a.height), r.globalAlpha = 1);
    }
  }
  /**
   * Finishes the render pass (no-op for canvas).
   * @advanced
   */
  finishRenderPass() {
  }
  /**
   * Copies a render target into a texture source.
   * @param {RenderTarget} sourceRenderSurfaceTexture - Source render target.
   * @param {Texture} destinationTexture - Destination texture.
   * @param {object} originSrc - Source origin.
   * @param {number} originSrc.x - Source x origin.
   * @param {number} originSrc.y - Source y origin.
   * @param {object} size - Copy size.
   * @param {number} size.width - Copy width.
   * @param {number} size.height - Copy height.
   * @param {object} [originDest] - Destination origin.
   * @param {number} originDest.x - Destination x origin.
   * @param {number} originDest.y - Destination y origin.
   * @advanced
   */
  copyToTexture(e, t, i, s, o) {
    var p, f;
    const a = this._renderTargetSystem.getGpuRenderTarget(e).canvas, l = t.source, { context: d } = this._ensureCanvas(l), c = (p = o == null ? void 0 : o.x) != null ? p : 0, u = (f = o == null ? void 0 : o.y) != null ? f : 0;
    return d.drawImage(
      a,
      i.x,
      i.y,
      s.width,
      s.height,
      c,
      u,
      s.width,
      s.height
    ), l.update(), t;
  }
  /**
   * Copies the depth attachment of a render target into a texture (not supported in canvas).
   * @param _source - Source render target.
   * @param _destination - Destination depth/stencil texture.
   * @param _originSrc - Source origin of the copy.
   * @param _originSrc.x
   * @param _originSrc.y
   * @param _size - Size of the copy.
   * @param _size.width
   * @param _size.height
   * @param _originDest - Destination origin of the copy.
   * @param _originDest.x
   * @param _originDest.y
   * @advanced
   */
  copyDepthTexture(e, t, i, s, o) {
    at("[CanvasRenderTargetAdaptor] copyDepthTexture is not supported in the canvas renderer");
  }
  /**
   * Destroys a GPU render target (no-op for canvas).
   * @param _gpuRenderTarget - Target to destroy.
   * @advanced
   */
  destroyGpuRenderTarget(e) {
  }
  _ensureCanvas(e) {
    let t = e.resource;
    (!t || !ki.test(t)) && (t = Pt.get().createCanvas(e.pixelWidth, e.pixelHeight), e.resource = t), (t.width !== e.pixelWidth || t.height !== e.pixelHeight) && (t.width = e.pixelWidth, t.height = e.pixelHeight);
    const i = t.getContext("2d");
    return { canvas: t, context: i };
  }
}
class LT extends ly {
  constructor(e) {
    super(e), this.adaptor = new qX(), this.adaptor.init(e, this);
  }
}
LT.extension = {
  type: [Ae.CanvasSystem],
  name: "renderTarget"
};
class BT {
  /**
   * @param renderer - The owning CanvasRenderer.
   */
  constructor(e) {
  }
  /** Initializes the system (no-op for canvas). */
  init() {
  }
  /**
   * Initializes a texture source (no-op for canvas).
   * @param _source - Texture source.
   */
  initSource(e) {
  }
  /**
   * Creates a canvas containing the texture's frame.
   * @param texture - Texture to render.
   */
  generateCanvas(e) {
    var u, p;
    const t = Pt.get().createCanvas(), i = t.getContext("2d"), s = yt.getCanvasSource(e);
    if (!s)
      return t;
    const o = e.frame, r = (p = (u = e.source._resolution) != null ? u : e.source.resolution) != null ? p : 1, a = o.x * r, l = o.y * r, d = o.width * r, c = o.height * r;
    return t.width = Math.ceil(d), t.height = Math.ceil(c), i.drawImage(
      s,
      a,
      l,
      d,
      c,
      0,
      0,
      d,
      c
    ), t;
  }
  /**
   * Reads pixel data from a texture.
   * @param texture - Texture to read.
   */
  getPixels(e) {
    const t = this.generateCanvas(e);
    return {
      pixels: t.getContext("2d", { willReadFrequently: !0 }).getImageData(0, 0, t.width, t.height).data,
      width: t.width,
      height: t.height
    };
  }
  /** Destroys the system (no-op for canvas). */
  destroy() {
  }
}
BT.extension = {
  type: [
    Ae.CanvasSystem
  ],
  name: "texture"
};
const KX = [
  ...ay,
  yT,
  xT,
  BT,
  LT
], YX = [
  Z1,
  q1,
  J1,
  X1,
  K1,
  bT,
  fT,
  Y1
], XX = [
  dX,
  wT
], FT = [], NT = [], UT = [], GT = [];
ct.handleByNamedList(Ae.CanvasSystem, FT);
ct.handleByNamedList(Ae.CanvasPipes, NT);
ct.handleByNamedList(Ae.CanvasPipesAdaptor, UT);
ct.handleByNamedList(Ae.CanvasLoader, GT);
ct.add(...KX, ...YX, ...XX);
class JX extends Xc {
  constructor() {
    const e = {
      name: "canvas",
      type: Vi.CANVAS,
      systems: FT,
      renderPipes: NT,
      renderPipeAdaptors: UT,
      loaders: GT
    };
    super(e);
  }
}
const ZX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CanvasRenderer: JX
}, Symbol.toStringTag, { value: "Module" }));
var ep = /* @__PURE__ */ ((n) => (n[n.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", n[n.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", n[n.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", n))(ep || {});
class QX {
  constructor(e, t) {
    this._lastBindBaseLocation = -1, this._lastBindCallId = -1, this.buffer = e || null, this.updateID = -1, this.byteLength = -1, this.type = t;
  }
  destroy() {
    this.buffer = null, this.updateID = -1, this.byteLength = -1, this.type = -1, this._lastBindBaseLocation = -1, this._lastBindCallId = -1;
  }
}
class jT {
  /**
   * @param {Renderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    this._boundBufferBases = /* @__PURE__ */ Object.create(null), this._minBaseLocation = 0, this._nextBindBaseIndex = this._minBaseLocation, this._bindCallId = 0, this._renderer = e, this._managedBuffers = new gs({
      renderer: e,
      type: "resource",
      onUnload: this.onBufferUnload.bind(this),
      name: "glBuffer"
    });
  }
  /** @ignore */
  destroy() {
    this._managedBuffers.destroy(), this._renderer = null, this._gl = null, this._boundBufferBases = {};
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this._gl = this._renderer.gl, this.destroyAll(!0), this._maxBindings = this._renderer.limits.maxUniformBindings;
  }
  getGlBuffer(e) {
    return e._gcLastUsed = this._renderer.gc.now, e._gpuData[this._renderer.uid] || this.createGLBuffer(e);
  }
  /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */
  bind(e) {
    const { _gl: t } = this, i = this.getGlBuffer(e);
    t.bindBuffer(i.type, i.buffer);
  }
  /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind it to.
   */
  bindBufferBase(e, t) {
    const { _gl: i } = this;
    this._boundBufferBases[t] !== e && (this._boundBufferBases[t] = e, e._lastBindBaseLocation = t, i.bindBufferBase(i.UNIFORM_BUFFER, t, e.buffer));
  }
  nextBindBase(e) {
    this._bindCallId++, this._minBaseLocation = 0, e && (this._boundBufferBases[0] = null, this._minBaseLocation = 1, this._nextBindBaseIndex < 1 && (this._nextBindBaseIndex = 1));
  }
  freeLocationForBufferBase(e) {
    let t = this.getLastBindBaseLocation(e);
    if (t >= this._minBaseLocation)
      return e._lastBindCallId = this._bindCallId, t;
    let i = 0, s = this._nextBindBaseIndex;
    for (; i < 2; ) {
      s >= this._maxBindings && (s = this._minBaseLocation, i++);
      const o = this._boundBufferBases[s];
      if (o && o._lastBindCallId === this._bindCallId) {
        s++;
        continue;
      }
      break;
    }
    return t = s, this._nextBindBaseIndex = s + 1, i >= 2 ? -1 : (e._lastBindCallId = this._bindCallId, this._boundBufferBases[t] = null, t);
  }
  getLastBindBaseLocation(e) {
    const t = e._lastBindBaseLocation;
    return this._boundBufferBases[t] === e ? t : -1;
  }
  /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   * @param size - the size to bind at (this is blocks of 256).
   */
  bindBufferRange(e, t, i, s) {
    const { _gl: o } = this;
    i || (i = 0), t || (t = 0), this._boundBufferBases[t] = null, o.bindBufferRange(o.UNIFORM_BUFFER, t || 0, e.buffer, i * 256, s || 256);
  }
  /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {Buffer} buffer - the buffer to update
   */
  updateBuffer(e) {
    const { _gl: t } = this, i = this.getGlBuffer(e);
    if (e._updateID === i.updateID)
      return i;
    i.updateID = e._updateID, t.bindBuffer(i.type, i.buffer);
    const s = e.data, o = e.descriptor.usage & Et.STATIC ? t.STATIC_DRAW : t.DYNAMIC_DRAW;
    return s ? i.byteLength >= s.byteLength ? t.bufferSubData(
      i.type,
      e._updateOffset,
      s,
      e._updateOffset / s.BYTES_PER_ELEMENT,
      (e._updateSize || s.byteLength) / s.BYTES_PER_ELEMENT
    ) : (i.byteLength = s.byteLength, t.bufferData(i.type, s, o)) : (i.byteLength = e.descriptor.size, t.bufferData(i.type, i.byteLength, o)), i;
  }
  /**
   * dispose all WebGL resources of all managed buffers
   * @param contextLost
   */
  destroyAll(e = !1) {
    this._managedBuffers.removeAll(e);
  }
  onBufferUnload(e, t = !1) {
    const i = e._gpuData[this._renderer.uid];
    i && (t || this._gl.deleteBuffer(i.buffer));
  }
  /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */
  createGLBuffer(e) {
    const { _gl: t } = this;
    let i = ep.ARRAY_BUFFER;
    e.descriptor.usage & Et.INDEX ? i = ep.ELEMENT_ARRAY_BUFFER : e.descriptor.usage & Et.UNIFORM && (i = ep.UNIFORM_BUFFER);
    const s = new QX(t.createBuffer(), i);
    return e._gpuData[this._renderer.uid] = s, this._managedBuffers.add(e), s;
  }
  resetState() {
    this._boundBufferBases = /* @__PURE__ */ Object.create(null);
  }
}
jT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "buffer"
};
const dy = class HT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this.supports = {
      /** Support for 32-bit indices buffer. */
      uint32Indices: !0,
      /** Support for UniformBufferObjects */
      uniformBufferObject: !0,
      /** Support for VertexArrayObjects */
      vertexArrayObject: !0,
      /** Support for SRGB texture format */
      srgbTextures: !0,
      /** Support for wrapping modes if a texture is non-power of two */
      nonPowOf2wrapping: !0,
      /** Support for MSAA (antialiasing of dynamic textures) */
      msaa: !0,
      /** Support for mipmaps if a texture is non-power of two */
      nonPowOf2mipmaps: !0
    }, this._renderer = e, this.extensions = /* @__PURE__ */ Object.create(null), this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
  }
  /**
   * `true` if the context is lost
   * @readonly
   */
  get isLost() {
    return !this.gl || this.gl.isContextLost();
  }
  /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */
  contextChange(e) {
    this.gl = e, this._renderer.gl = e;
  }
  init(e) {
    var i, s;
    e = { ...HT.defaultOptions, ...e };
    let t = this.multiView = e.multiView;
    if (e.context && t && (at("Renderer created with both a context and multiview enabled. Disabling multiView as both cannot work together."), t = !1), t ? this.canvas = Pt.get().createCanvas(this._renderer.canvas.width, this._renderer.canvas.height) : this.canvas = this._renderer.view.canvas, e.context)
      this.initFromContext(e.context);
    else {
      const o = this._renderer.background.alpha < 1, r = (i = e.premultipliedAlpha) != null ? i : !0, a = e.antialias && !this._renderer.backBuffer.useBackBuffer;
      this.createContext(e.preferWebGLVersion, {
        alpha: o,
        premultipliedAlpha: r,
        antialias: a,
        stencil: !0,
        preserveDrawingBuffer: e.preserveDrawingBuffer,
        powerPreference: (s = e.powerPreference) != null ? s : "default"
      });
    }
  }
  ensureCanvasSize(e) {
    if (!this.multiView) {
      e !== this.canvas && at("multiView is disabled, but targetCanvas is not the main canvas");
      return;
    }
    const { canvas: t } = this;
    (t.width < e.width || t.height < e.height) && (t.width = Math.max(e.width, e.width), t.height = Math.max(e.height, e.height));
  }
  /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */
  initFromContext(e) {
    this.gl = e, this.webGLVersion = e instanceof Pt.get().getWebGLRenderingContext() ? 1 : 2, this.getExtensions(), this.validateContext(e), this._renderer.runners.contextChange.emit(e);
    const t = this._renderer.view.canvas;
    t.addEventListener("webglcontextlost", this.handleContextLost, !1), t.addEventListener("webglcontextrestored", this.handleContextRestored, !1);
  }
  /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param preferWebGLVersion
   * @param {object} options - context attributes
   */
  createContext(e, t) {
    let i;
    const s = this.canvas;
    if (e === 2 && (i = s.getContext("webgl2", t)), !i && (i = s.getContext("webgl", t), !i))
      throw new Error("This browser does not support WebGL. Try using the canvas renderer");
    this.gl = i, this.initFromContext(this.gl);
  }
  /** Auto-populate the {@link GlContextSystem.extensions extensions}. */
  getExtensions() {
    const { gl: e } = this, t = {
      anisotropicFiltering: e.getExtension("EXT_texture_filter_anisotropic"),
      floatTextureLinear: e.getExtension("OES_texture_float_linear"),
      s3tc: e.getExtension("WEBGL_compressed_texture_s3tc"),
      s3tc_sRGB: e.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
      // eslint-disable-line camelcase
      etc: e.getExtension("WEBGL_compressed_texture_etc"),
      etc1: e.getExtension("WEBGL_compressed_texture_etc1"),
      pvrtc: e.getExtension("WEBGL_compressed_texture_pvrtc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
      atc: e.getExtension("WEBGL_compressed_texture_atc"),
      astc: e.getExtension("WEBGL_compressed_texture_astc"),
      bptc: e.getExtension("EXT_texture_compression_bptc"),
      rgtc: e.getExtension("EXT_texture_compression_rgtc"),
      loseContext: e.getExtension("WEBGL_lose_context")
    };
    if (this.webGLVersion === 1)
      this.extensions = {
        ...t,
        drawBuffers: e.getExtension("WEBGL_draw_buffers"),
        depthTexture: e.getExtension("WEBGL_depth_texture"),
        vertexArrayObject: e.getExtension("OES_vertex_array_object") || e.getExtension("MOZ_OES_vertex_array_object") || e.getExtension("WEBKIT_OES_vertex_array_object"),
        uint32ElementIndex: e.getExtension("OES_element_index_uint"),
        // Floats and half-floats
        floatTexture: e.getExtension("OES_texture_float"),
        floatTextureLinear: e.getExtension("OES_texture_float_linear"),
        textureHalfFloat: e.getExtension("OES_texture_half_float"),
        textureHalfFloatLinear: e.getExtension("OES_texture_half_float_linear"),
        vertexAttribDivisorANGLE: e.getExtension("ANGLE_instanced_arrays"),
        srgb: e.getExtension("EXT_sRGB")
      };
    else {
      this.extensions = {
        ...t,
        colorBufferFloat: e.getExtension("EXT_color_buffer_float")
      };
      const i = e.getExtension("WEBGL_provoking_vertex");
      i && i.provokingVertexWEBGL(i.FIRST_VERTEX_CONVENTION_WEBGL);
    }
  }
  /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */
  handleContextLost(e) {
    e.preventDefault(), this._contextLossForced && (this._contextLossForced = !1, setTimeout(() => {
      var t;
      this.gl.isContextLost() && ((t = this.extensions.loseContext) == null || t.restoreContext());
    }, 0));
  }
  /** Handles a restored webgl context. */
  handleContextRestored() {
    this.getExtensions(), this._renderer.runners.contextChange.emit(this.gl);
  }
  destroy() {
    var t;
    const e = this._renderer.view.canvas;
    this._renderer = null, e.removeEventListener("webglcontextlost", this.handleContextLost), e.removeEventListener("webglcontextrestored", this.handleContextRestored), this.gl.useProgram(null), (t = this.extensions.loseContext) == null || t.loseContext();
  }
  /**
   * this function can be called to force a webGL context loss
   * this will release all resources on the GPU.
   * Useful if you need to put Pixi to sleep, and save some GPU memory
   *
   * As soon as render is called - all resources will be created again.
   */
  forceContextLoss() {
    var e;
    (e = this.extensions.loseContext) == null || e.loseContext(), this._contextLossForced = !0;
  }
  /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */
  validateContext(e) {
    const t = e.getContextAttributes();
    t && !t.stencil && at("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
    const i = this.supports, s = this.webGLVersion === 2, o = this.extensions;
    i.uint32Indices = s || !!o.uint32ElementIndex, i.uniformBufferObject = s, i.vertexArrayObject = s || !!o.vertexArrayObject, i.srgbTextures = s || !!o.srgb, i.nonPowOf2wrapping = s, i.nonPowOf2mipmaps = s, i.msaa = s, i.uint32Indices || at("Provided WebGL context does not support 32 index buffer, large scenes may not render correctly");
  }
};
dy.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "context"
};
dy.defaultOptions = {
  /**
   * {@link WebGLOptions.context}
   * @default null
   */
  context: null,
  /**
   * {@link WebGLOptions.premultipliedAlpha}
   * @default true
   */
  premultipliedAlpha: !0,
  /**
   * {@link WebGLOptions.preserveDrawingBuffer}
   * @default false
   */
  preserveDrawingBuffer: !1,
  /**
   * {@link WebGLOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * {@link WebGLOptions.webGLVersion}
   * @default 2
   */
  preferWebGLVersion: 2,
  /**
   * {@link WebGLOptions.multiView}
   * @default false
   */
  multiView: !1
};
let eJ = dy;
function Gv(n, e) {
  var t, i, s;
  for (const o in n.attributes) {
    const r = n.attributes[o], a = e[o];
    a ? ((t = r.format) != null || (r.format = a.format), (i = r.offset) != null || (r.offset = a.offset), (s = r.instance) != null || (r.instance = a.instance)) : r.format || at(`Attribute ${o} is not present in the shader, but is present in the geometry. Unable to infer attribute details.`);
  }
  tJ(n);
}
function tJ(n) {
  var o, r;
  const { buffers: e, attributes: t } = n, i = {}, s = {};
  for (const a in e) {
    const l = e[a];
    i[l.uid] = 0, s[l.uid] = 0;
  }
  for (const a in t) {
    const l = t[a];
    i[l.buffer.uid] += kc(l.format).stride;
  }
  for (const a in t) {
    const l = t[a];
    (o = l.stride) != null || (l.stride = i[l.buffer.uid]), (r = l.start) != null || (l.start = s[l.buffer.uid]), s[l.buffer.uid] += kc(l.format).stride;
  }
}
var jv = /* @__PURE__ */ ((n) => (n[n.RGBA = 6408] = "RGBA", n[n.RGB = 6407] = "RGB", n[n.RG = 33319] = "RG", n[n.RED = 6403] = "RED", n[n.RGBA_INTEGER = 36249] = "RGBA_INTEGER", n[n.RGB_INTEGER = 36248] = "RGB_INTEGER", n[n.RG_INTEGER = 33320] = "RG_INTEGER", n[n.RED_INTEGER = 36244] = "RED_INTEGER", n[n.ALPHA = 6406] = "ALPHA", n[n.LUMINANCE = 6409] = "LUMINANCE", n[n.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", n[n.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", n[n.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", n))(jv || {}), Ac = /* @__PURE__ */ ((n) => (n[n.TEXTURE_2D = 3553] = "TEXTURE_2D", n[n.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", n[n.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", n[n.TEXTURE_3D = 32879] = "TEXTURE_3D", n[n.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", n[n.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", n[n.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", n[n.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", n[n.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", n[n.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", n))(Ac || {}), Ct = /* @__PURE__ */ ((n) => (n[n.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", n[n.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", n[n.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", n[n.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", n[n.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", n[n.UNSIGNED_INT = 5125] = "UNSIGNED_INT", n[n.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", n[n.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", n[n.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", n[n.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", n[n.BYTE = 5120] = "BYTE", n[n.SHORT = 5122] = "SHORT", n[n.INT = 5124] = "INT", n[n.FLOAT = 5126] = "FLOAT", n[n.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", n[n.HALF_FLOAT = 36193] = "HALF_FLOAT", n))(Ct || {});
const o2 = {
  uint8x2: Ct.UNSIGNED_BYTE,
  uint8x4: Ct.UNSIGNED_BYTE,
  sint8x2: Ct.BYTE,
  sint8x4: Ct.BYTE,
  unorm8x2: Ct.UNSIGNED_BYTE,
  unorm8x4: Ct.UNSIGNED_BYTE,
  snorm8x2: Ct.BYTE,
  snorm8x4: Ct.BYTE,
  uint16x2: Ct.UNSIGNED_SHORT,
  uint16x4: Ct.UNSIGNED_SHORT,
  sint16x2: Ct.SHORT,
  sint16x4: Ct.SHORT,
  unorm16x2: Ct.UNSIGNED_SHORT,
  unorm16x4: Ct.UNSIGNED_SHORT,
  snorm16x2: Ct.SHORT,
  snorm16x4: Ct.SHORT,
  float16x2: Ct.HALF_FLOAT,
  float16x4: Ct.HALF_FLOAT,
  float32: Ct.FLOAT,
  float32x2: Ct.FLOAT,
  float32x3: Ct.FLOAT,
  float32x4: Ct.FLOAT,
  uint32: Ct.UNSIGNED_INT,
  uint32x2: Ct.UNSIGNED_INT,
  uint32x3: Ct.UNSIGNED_INT,
  uint32x4: Ct.UNSIGNED_INT,
  sint32: Ct.INT,
  sint32x2: Ct.INT,
  sint32x3: Ct.INT,
  sint32x4: Ct.INT
};
function nJ(n) {
  var e;
  return (e = o2[n]) != null ? e : o2.float32;
}
const iJ = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 3,
  "triangle-list": 4,
  "triangle-strip": 5
};
class sJ {
  constructor() {
    this.vaoCache = /* @__PURE__ */ Object.create(null);
  }
  destroy() {
    this.vaoCache = /* @__PURE__ */ Object.create(null);
  }
}
class VT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this._managedGeometries = new gs({
      renderer: e,
      type: "resource",
      onUnload: this.onGeometryUnload.bind(this),
      name: "glGeometry"
    });
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    const e = this.gl = this._renderer.gl;
    if (!this._renderer.context.supports.vertexArrayObject)
      throw new Error("[PixiJS] Vertex Array Objects are not supported on this device");
    this.destroyAll(!0);
    const t = this._renderer.context.extensions.vertexArrayObject;
    t && (e.createVertexArray = () => t.createVertexArrayOES(), e.bindVertexArray = (s) => t.bindVertexArrayOES(s), e.deleteVertexArray = (s) => t.deleteVertexArrayOES(s));
    const i = this._renderer.context.extensions.vertexAttribDivisorANGLE;
    i && (e.drawArraysInstanced = (s, o, r, a) => {
      i.drawArraysInstancedANGLE(s, o, r, a);
    }, e.drawElementsInstanced = (s, o, r, a, l) => {
      i.drawElementsInstancedANGLE(s, o, r, a, l);
    }, e.vertexAttribDivisor = (s, o) => i.vertexAttribDivisorANGLE(s, o)), this._activeGeometry = null, this._activeVao = null;
  }
  /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param program - Instance of program to use vao for.
   */
  bind(e, t) {
    const i = this.gl;
    this._activeGeometry = e;
    const s = this.getVao(e, t);
    this._activeVao !== s && (this._activeVao = s, i.bindVertexArray(s)), this.updateBuffers();
  }
  /** Reset and unbind any active VAO and geometry. */
  resetState() {
    this.unbind();
  }
  /** Update buffers of the currently bound geometry. */
  updateBuffers() {
    const e = this._activeGeometry, t = this._renderer.buffer;
    for (let i = 0; i < e.buffers.length; i++) {
      const s = e.buffers[i];
      t.updateBuffer(s);
    }
    e._gcLastUsed = this._renderer.gc.now;
  }
  /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */
  checkCompatibility(e, t) {
    const i = e.attributes, s = t._attributeData;
    for (const o in s)
      if (!i[o])
        throw new Error(`shader and geometry incompatible, geometry missing the "${o}" attribute`);
  }
  /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */
  getSignature(e, t) {
    const i = e.attributes, s = t._attributeData, o = ["g", e.uid];
    for (const r in i)
      s[r] && o.push(r, s[r].location);
    return o.join("-");
  }
  getVao(e, t) {
    var i;
    return ((i = e._gpuData[this._renderer.uid]) == null ? void 0 : i.vaoCache[t._key]) || this.initGeometryVao(e, t);
  }
  /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param program
   * @param _incRefCount - Increment refCount of all geometry buffers.
   */
  initGeometryVao(e, t, i = !0) {
    const s = this._renderer.gl, o = this._renderer.buffer;
    this._renderer.shader._getProgramData(t), this.checkCompatibility(e, t);
    const r = this.getSignature(e, t);
    let a = e._gpuData[this._renderer.uid];
    a || (a = new sJ(), e._gpuData[this._renderer.uid] = a, this._managedGeometries.add(e));
    const l = a.vaoCache;
    let d = l[r];
    if (d)
      return l[t._key] = d, d;
    Gv(e, t._attributeData);
    const c = e.buffers;
    d = s.createVertexArray(), s.bindVertexArray(d);
    for (let u = 0; u < c.length; u++) {
      const p = c[u];
      o.bind(p);
    }
    return this.activateVao(e, t), l[t._key] = d, l[r] = d, s.bindVertexArray(null), d;
  }
  onGeometryUnload(e, t = !1) {
    const i = e._gpuData[this._renderer.uid];
    if (!i) return;
    const s = i.vaoCache;
    if (!t)
      for (const o in s)
        this._activeVao === s[o] && this.resetState(), this.gl.deleteVertexArray(s[o]);
  }
  /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */
  destroyAll(e = !1) {
    this._managedGeometries.removeAll(e);
  }
  /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */
  activateVao(e, t) {
    var a, l;
    const i = this._renderer.gl, s = this._renderer.buffer, o = e.attributes;
    e.indexBuffer && s.bind(e.indexBuffer);
    let r = null;
    for (const d in o) {
      const c = o[d], u = c.buffer, p = s.getGlBuffer(u), f = t._attributeData[d];
      if (f) {
        r !== p && (s.bind(u), r = p);
        const y = f.location;
        i.enableVertexAttribArray(y);
        const b = kc(c.format), w = nJ(c.format);
        if (((a = f.format) == null ? void 0 : a.substring(1, 4)) === "int" ? i.vertexAttribIPointer(
          y,
          b.size,
          w,
          c.stride,
          c.offset
        ) : i.vertexAttribPointer(
          y,
          b.size,
          w,
          b.normalised,
          c.stride,
          c.offset
        ), c.instance)
          if (this.hasInstance) {
            const k = (l = c.divisor) != null ? l : 1;
            i.vertexAttribDivisor(y, k);
          } else
            throw new Error("geometry error, GPU Instancing is not supported on this device");
      }
    }
  }
  /**
   * Draws the currently bound geometry.
   * @param topology - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, an indexed geometry
   *  falls back to {@link Geometry.indexCount} and then to its whole index buffer, and a
   *  non-indexed one to {@link Geometry.vertexCount}.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   * @returns This instance of the geometry system.
   */
  draw(e, t, i, s) {
    const { gl: o } = this._renderer, r = this._activeGeometry, a = iJ[e || r.topology];
    if (s != null || (s = r.instanceCount), r.indexBuffer) {
      const l = r.indexBuffer.data.BYTES_PER_ELEMENT, d = l === 2 ? o.UNSIGNED_SHORT : o.UNSIGNED_INT, c = t || r.indexCount || r.indexBuffer.data.length, u = (i || 0) * l;
      s !== 1 ? o.drawElementsInstanced(a, c, d, u, s) : o.drawElements(a, c, d, u);
    } else s !== 1 ? o.drawArraysInstanced(a, i || 0, t || r.vertexCount, s) : o.drawArrays(a, i || 0, t || r.vertexCount);
    return this;
  }
  /** Unbind/reset everything. */
  unbind() {
    this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
  }
  destroy() {
    this._managedGeometries.destroy(), this._renderer = null, this.gl = null, this._activeVao = null, this._activeGeometry = null;
  }
}
VT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "geometry"
};
const oJ = new Gf({
  attributes: {
    aPosition: [
      -1,
      -1,
      // Bottom left corner
      3,
      -1,
      // Bottom right corner, extending beyond right edge
      -1,
      3
      // Top left corner, extending beyond top edge
    ]
  }
}), cy = class WT {
  constructor(e) {
    this.useBackBuffer = !1, this._useBackBufferThisRender = !1, this._renderer = e;
  }
  init(e = {}) {
    const { useBackBuffer: t, antialias: i } = { ...WT.defaultOptions, ...e };
    this.useBackBuffer = t, this._antialias = i, this._renderer.context.supports.msaa || (at("antialiasing, is not supported on when using the back buffer"), this._antialias = !1), this._state = Zs.for2d();
    const s = new $l({
      vertex: `
                attribute vec2 aPosition;
                out vec2 vUv;

                void main() {
                    gl_Position = vec4(aPosition, 0.0, 1.0);

                    vUv = (aPosition + 1.0) / 2.0;

                    // flip dem UVs
                    vUv.y = 1.0 - vUv.y;
                }`,
      fragment: `
                in vec2 vUv;
                out vec4 finalColor;

                uniform sampler2D uTexture;

                void main() {
                    finalColor = texture(uTexture, vUv);
                }`,
      name: "big-triangle"
    });
    this._bigTriangleShader = new Js({
      glProgram: s,
      resources: {
        uTexture: Ze.WHITE.source
      }
    });
  }
  /**
   * This is called before the RenderTargetSystem is started. This is where
   * we replace the target with the back buffer if required.
   * @param options - The options for this render.
   */
  renderStart(e) {
    const t = this._renderer.renderTarget.getRenderTarget(e.target);
    if (this._useBackBufferThisRender = this.useBackBuffer && !!t.isRoot, this._useBackBufferThisRender) {
      const i = this._renderer.renderTarget.getRenderTarget(e.target);
      this._targetTexture = i.colorTexture, e.target = this._getBackBufferTexture(i.colorTexture);
    }
  }
  renderEnd() {
    this._presentBackBuffer();
  }
  _presentBackBuffer() {
    const e = this._renderer;
    e.renderTarget.finishRenderPass(), this._useBackBufferThisRender && (e.renderTarget.bind({ target: this._targetTexture, clear: !1 }), this._bigTriangleShader.resources.uTexture = this._backBufferTexture.source, e.encoder.draw({
      geometry: oJ,
      shader: this._bigTriangleShader,
      state: this._state
    }));
  }
  _getBackBufferTexture(e) {
    return this._backBufferTexture = this._backBufferTexture || new Ze({
      source: new an({
        width: e.width,
        height: e.height,
        resolution: e._resolution,
        antialias: this._antialias
      })
    }), this._backBufferTexture.source.resize(
      e.width,
      e.height,
      e._resolution
    ), this._backBufferTexture;
  }
  /** destroys the back buffer */
  destroy() {
    this._backBufferTexture && (this._backBufferTexture.destroy(), this._backBufferTexture = null);
  }
};
cy.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "backBuffer",
  priority: 1
};
cy.defaultOptions = {
  /** if true will use the back buffer where required */
  useBackBuffer: !1
};
let rJ = cy;
class qT {
  constructor(e) {
    this._colorMaskCache = 15, this._renderer = e;
  }
  setMask(e) {
    this._colorMaskCache !== e && (this._colorMaskCache = e, this._renderer.gl.colorMask(
      !!(e & 8),
      !!(e & 4),
      !!(e & 2),
      !!(e & 1)
    ));
  }
}
qT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "colorMask"
};
class KT {
  constructor(e) {
    this.commandFinished = Promise.resolve(), this._renderer = e;
  }
  setGeometry(e, t) {
    this._renderer.geometry.bind(e, t.glProgram);
  }
  finishRenderPass() {
  }
  draw(e) {
    const t = this._renderer, { geometry: i, shader: s, state: o, skipSync: r, topology: a, size: l, start: d, instanceCount: c } = e;
    t.shader.bind(s, r), t.geometry.bind(i, t.shader._activeProgram), o && t.state.set(o), t.geometry.draw(a, l, d, c != null ? c : i.instanceCount);
  }
  destroy() {
    this._renderer = null;
  }
}
KT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "encoder"
};
class YT {
  constructor(e) {
    this._renderer = e;
  }
  contextChange() {
    const e = this._renderer.gl;
    this.maxTextures = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS), this.maxBatchableTextures = CS(this.maxTextures, e);
    const t = this._renderer.context.webGLVersion === 2;
    this.maxUniformBindings = t ? e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
  }
  destroy() {
  }
}
YT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "limits"
};
class aJ {
  constructor() {
    this.width = -1, this.height = -1, this.msaa = !1, this._attachedMipLevel = 0, this._attachedLayer = 0, this.msaaRenderBuffer = [], this.stencilMode = cn.DISABLED, this.stencilReference = 0, this.maskStackIndex = 0;
  }
}
const Yo = [];
Yo[cn.NONE] = void 0;
Yo[cn.DISABLED] = {
  stencilWriteMask: 0,
  stencilReadMask: 0
};
Yo[cn.RENDERING_MASK_ADD] = {
  stencilFront: {
    compare: "equal",
    passOp: "increment-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "increment-clamp"
  }
};
Yo[cn.RENDERING_MASK_REMOVE] = {
  stencilFront: {
    compare: "equal",
    passOp: "decrement-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "decrement-clamp"
  }
};
Yo[cn.MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "equal",
    passOp: "keep"
  },
  stencilBack: {
    compare: "equal",
    passOp: "keep"
  }
};
Yo[cn.INVERSE_MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "not-equal",
    passOp: "keep"
  },
  stencilBack: {
    compare: "not-equal",
    passOp: "keep"
  }
};
class XT {
  constructor(e) {
    this._stencilCache = {
      enabled: !1,
      stencilReference: 0,
      stencilMode: cn.NONE
    }, this._renderer = e, e.renderTarget.onRenderTargetChange.add(this);
  }
  contextChange(e) {
    this._gl = e, this._comparisonFuncMapping = {
      always: e.ALWAYS,
      never: e.NEVER,
      equal: e.EQUAL,
      "not-equal": e.NOTEQUAL,
      less: e.LESS,
      "less-equal": e.LEQUAL,
      greater: e.GREATER,
      "greater-equal": e.GEQUAL
    }, this._stencilOpsMapping = {
      keep: e.KEEP,
      zero: e.ZERO,
      replace: e.REPLACE,
      invert: e.INVERT,
      "increment-clamp": e.INCR,
      "decrement-clamp": e.DECR,
      "increment-wrap": e.INCR_WRAP,
      "decrement-wrap": e.DECR_WRAP
    }, this._activeGpuRenderTarget = null, this.resetState();
  }
  onRenderTargetChange(e) {
    if (this._activeRenderTarget === e) return;
    this._activeRenderTarget = e;
    const t = this._renderer.renderTarget.getGpuRenderTarget(e);
    this._activeGpuRenderTarget = t, this.setStencilMode(t.stencilMode, t.stencilReference);
  }
  resetState() {
    this._stencilCache.enabled = !1, this._stencilCache.stencilMode = cn.NONE, this._stencilCache.stencilReference = 0;
  }
  setStencilMode(e, t) {
    var a;
    const i = (a = this._activeGpuRenderTarget) != null ? a : this._activeGpuRenderTarget = this._renderer.renderTarget.getGpuRenderTarget(this._activeRenderTarget), s = this._gl, o = Yo[e], r = this._stencilCache;
    if (i.stencilMode = e, i.stencilReference = t, e === cn.DISABLED) {
      this._stencilCache.enabled && (this._stencilCache.enabled = !1, s.disable(s.STENCIL_TEST));
      return;
    }
    this._stencilCache.enabled || (this._stencilCache.enabled = !0, s.enable(s.STENCIL_TEST)), (e !== r.stencilMode || r.stencilReference !== t) && (r.stencilMode = e, r.stencilReference = t, s.stencilFunc(this._comparisonFuncMapping[o.stencilBack.compare], t, 255), s.stencilOp(s.KEEP, s.KEEP, this._stencilOpsMapping[o.stencilBack.passOp]));
  }
  destroy() {
    this._renderer.renderTarget.onRenderTargetChange.remove(this), this._renderer = null, this._gl = null, this._activeRenderTarget = null, this._activeGpuRenderTarget = null;
  }
}
XT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "stencil"
};
class JT {
  constructor(e) {
    this._syncFunctionHash = /* @__PURE__ */ Object.create(null), this._adaptor = e, this._systemCheck();
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */
  _systemCheck() {
    if (!cS())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  ensureUniformGroup(e) {
    const t = this.getUniformGroupData(e);
    e.buffer || (e.buffer = new Gi({
      data: new Float32Array(t.layout.size / 4),
      usage: Et.UNIFORM | Et.COPY_DST
    }));
  }
  getUniformGroupData(e) {
    return this._syncFunctionHash[e._signature] || this._initUniformGroup(e);
  }
  _initUniformGroup(e) {
    const t = e._signature;
    let i = this._syncFunctionHash[t];
    if (!i) {
      const s = Object.keys(e.uniformStructures).map((a) => e.uniformStructures[a]), o = this._adaptor.createUboElements(s), r = this._generateUboSync(o.uboElements);
      i = this._syncFunctionHash[t] = {
        layout: o,
        syncFunction: r
      };
    }
    return this._syncFunctionHash[t];
  }
  _generateUboSync(e) {
    return this._adaptor.generateUboSync(e);
  }
  syncUniformGroup(e, t, i) {
    const s = this.getUniformGroupData(e);
    e.buffer || (e.buffer = new Gi({
      data: new Float32Array(s.layout.size / 4),
      usage: Et.UNIFORM | Et.COPY_DST
    }));
    let o = null;
    return t || (t = e.buffer.data, o = e.buffer.dataInt32), i || (i = 0), s.syncFunction(e.uniforms, t, o, i), !0;
  }
  updateUniformGroup(e) {
    if (e.isStatic && !e._dirtyId) return !1;
    e._dirtyId = 0;
    const t = this.syncUniformGroup(e);
    return e.buffer.update(), t;
  }
  destroy() {
    this._syncFunctionHash = null;
  }
}
const ZT = {
  f32: 4,
  i32: 4,
  "vec2<f32>": 8,
  "vec3<f32>": 12,
  "vec4<f32>": 16,
  "vec2<i32>": 8,
  "vec3<i32>": 12,
  "vec4<i32>": 16,
  u32: 4,
  "vec2<u32>": 8,
  "vec3<u32>": 12,
  "vec4<u32>": 16,
  "mat2x2<f32>": 32,
  "mat3x3<f32>": 48,
  "mat4x4<f32>": 64
  // TODO - not essential for now but support these in the future
  // int:      4,
  // ivec2:    8,
  // ivec3:    12,
  // ivec4:    16,
  // uint:     4,
  // uvec2:    8,
  // uvec3:    12,
  // uvec4:    16,
  // bool:     4,
  // bvec2:    8,
  // bvec3:    12,
  // bvec4:    16,
  // mat2:     16 * 2,
  // mat3:     16 * 3,
  // mat4:     16 * 4,
};
function lJ(n) {
  const e = n.map((o) => ({
    data: o,
    offset: 0,
    size: 0
  })), t = 16;
  let i = 0, s = 0;
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    if (i = ZT[r.data.type], !i)
      throw new Error(`Unknown type ${r.data.type}`);
    r.data.size > 1 && (i = Math.max(i, t) * r.data.size);
    const a = i === 12 ? 16 : i;
    r.size = i;
    const l = s % t;
    l > 0 && t - l < a ? s += (t - l) % 16 : s += (i - l % i) % i, r.offset = s, s += i;
  }
  return s = Math.ceil(s / 16) * 16, { uboElements: e, size: s };
}
const Za = [
  // uploading pixi matrix object to mat3
  {
    type: "mat3x3<f32>",
    test: (n) => n.value.a !== void 0,
    ubo: `
            var matrix = uv[name].toArray(true);
            data[offset] = matrix[0];
            data[offset + 1] = matrix[1];
            data[offset + 2] = matrix[2];
            data[offset + 4] = matrix[3];
            data[offset + 5] = matrix[4];
            data[offset + 6] = matrix[5];
            data[offset + 8] = matrix[6];
            data[offset + 9] = matrix[7];
            data[offset + 10] = matrix[8];
        `,
    uniform: `
            gl.uniformMatrix3fv(ud[name].location, false, uv[name].toArray(true));
        `
  },
  // uploading a pixi rectangle as a vec4
  {
    type: "vec4<f32>",
    test: (n) => n.type === "vec4<f32>" && n.size === 1 && n.value.width !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
            data[offset + 2] = v.width;
            data[offset + 3] = v.height;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height) {
                cv[0] = v.x;
                cv[1] = v.y;
                cv[2] = v.width;
                cv[3] = v.height;
                gl.uniform4f(ud[name].location, v.x, v.y, v.width, v.height);
            }
        `
  },
  // uploading a pixi point as a vec2
  {
    type: "vec2<f32>",
    test: (n) => n.type === "vec2<f32>" && n.size === 1 && n.value.x !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y) {
                cv[0] = v.x;
                cv[1] = v.y;
                gl.uniform2f(ud[name].location, v.x, v.y);
            }
        `
  },
  // uploading a pixi color as a vec4
  {
    type: "vec4<f32>",
    test: (n) => n.type === "vec4<f32>" && n.size === 1 && n.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
            data[offset + 3] = v.alpha;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                cv[3] = v.alpha;
                gl.uniform4f(ud[name].location, v.red, v.green, v.blue, v.alpha);
            }
        `
  },
  // uploading a pixi color as a vec3
  {
    type: "vec3<f32>",
    test: (n) => n.type === "vec3<f32>" && n.size === 1 && n.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                gl.uniform3f(ud[name].location, v.red, v.green, v.blue);
            }
        `
  }
];
function QT(n, e, t) {
  const i = [`
        var v = null;
        var v2 = null;
        var t = 0;
        var index = 0;
        var name = null;
        var arrayOffset = null;
    `];
  let s = 0;
  for (let r = 0; r < n.length; r++) {
    const a = n[r], l = a.data.name;
    let d = !1, c = 0;
    for (let u = 0; u < Za.length; u++)
      if (Za[u].test(a.data)) {
        c = a.offset / 4, i.push(
          `name = "${l}";`,
          `offset += ${c - s};`,
          Za[u].ubo
        ), d = !0;
        break;
      }
    if (!d)
      if (a.data.size > 1)
        c = a.offset / 4, i.push(t(a, c - s));
      else {
        const u = e[a.data.type];
        c = a.offset / 4, i.push(
          /* wgsl */
          `
                    v = uv.${l};
                    offset += ${c - s};
                    ${u};
                `
        );
      }
    s = c;
  }
  const o = i.join(`
`);
  return new Function(
    "uv",
    "data",
    "dataInt32",
    "offset",
    o
  );
}
function ma(n, e) {
  return `
        for (let i = 0; i < ${n * e}; i++) {
            data[offset + (((i / ${n})|0) * 4) + (i % ${n})] = v[i];
        }
    `;
}
const eM = {
  f32: `
        data[offset] = v;`,
  i32: `
        dataInt32[offset] = v;`,
  u32: `
        dataInt32[offset] = v;`,
  "vec2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];`,
  "vec3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];`,
  "vec4<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];`,
  "vec2<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];`,
  "vec3<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];`,
  "vec4<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];
        dataInt32[offset + 3] = v[3];`,
  "vec2<u32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];`,
  "vec3<u32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];`,
  "vec4<u32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];
        dataInt32[offset + 3] = v[3];`,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 4] = v[2];
        data[offset + 5] = v[3];`,
  "mat3x3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];
        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];`,
  "mat4x4<f32>": `
        for (let i = 0; i < 16; i++) {
            data[offset + i] = v[i];
        }`,
  "mat3x2<f32>": ma(3, 2),
  "mat4x2<f32>": ma(4, 2),
  "mat2x3<f32>": ma(2, 3),
  "mat4x3<f32>": ma(4, 3),
  "mat2x4<f32>": ma(2, 4),
  "mat3x4<f32>": ma(3, 4)
}, dJ = {
  ...eM,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];
    `
};
function cJ(n, e) {
  const t = Math.max(ZT[n.data.type] / 16, 1), i = n.data.value.length / n.data.size, s = (4 - i % 4) % 4, o = n.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
        v = uv.${n.data.name};
        offset += ${e};

        arrayOffset = offset;

        t = 0;

        for(var i=0; i < ${n.data.size * t}; i++)
        {
            for(var j = 0; j < ${i}; j++)
            {
                ${o}[arrayOffset++] = v[t++];
            }
            ${s !== 0 ? `arrayOffset += ${s};` : ""}
        }
    `;
}
function uJ(n) {
  return QT(
    n,
    eM,
    cJ
  );
}
class tM extends JT {
  constructor() {
    super({
      createUboElements: lJ,
      generateUboSync: uJ
    });
  }
}
tM.extension = {
  type: [Ae.WebGLSystem],
  name: "ubo"
};
class hJ {
  constructor() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new _t(), this._boundFramebuffer = void 0;
  }
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t, e.runners.contextChange.add(this);
  }
  contextChange() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new _t(), this._boundFramebuffer = void 0;
    const e = this._renderer.gl;
    this._drawBuffersCache = [];
    for (let t = 1; t <= 16; t++)
      this._drawBuffersCache[t] = Array.from({ length: t }, (i, s) => e.COLOR_ATTACHMENT0 + s);
  }
  copyToTexture(e, t, i, s, o) {
    const r = this._renderTargetSystem, a = this._renderer, l = r.getGpuRenderTarget(e), d = a.gl;
    return this.finishRenderPass(e), d.bindFramebuffer(d.FRAMEBUFFER, l.resolveTargetFramebuffer), this._boundFramebuffer = l.resolveTargetFramebuffer, a.texture.bind(t, 0), d.copyTexSubImage2D(
      d.TEXTURE_2D,
      0,
      o.x,
      o.y,
      i.x,
      i.y,
      s.width,
      s.height
    ), t;
  }
  copyDepthTexture(e, t, i, s, o) {
    const r = this._renderTargetSystem, a = this._renderer.gl;
    this.finishRenderPass(e);
    const l = r.getRenderTarget(t), d = r.getGpuRenderTarget(e), c = r.getGpuRenderTarget(l);
    a.bindFramebuffer(a.READ_FRAMEBUFFER, d.framebuffer), a.bindFramebuffer(a.DRAW_FRAMEBUFFER, c.framebuffer), this._boundFramebuffer = void 0, a.blitFramebuffer(
      i.x,
      i.y,
      i.x + s.width,
      i.y + s.height,
      o.x,
      o.y,
      o.x + s.width,
      o.y + s.height,
      a.DEPTH_BUFFER_BIT,
      a.NEAREST
    );
  }
  startRenderPass(e, t = !0, i, s, o = 0, r = 0) {
    const l = this._renderTargetSystem.getGpuRenderTarget(e);
    if (r !== 0 && this._renderer.context.webGLVersion < 2)
      throw new Error("[RenderTargetSystem] Rendering to array layers requires WebGL2.");
    if (o > 0) {
      if (l.msaa)
        throw new Error("[RenderTargetSystem] Rendering to mip levels is not supported with MSAA render targets.");
      if (this._renderer.context.webGLVersion < 2)
        throw new Error("[RenderTargetSystem] Rendering to mip levels requires WebGL2.");
    }
    e.colorAttachments.forEach((p) => {
      this._renderer.texture.unbind(p.texture);
    });
    const d = this._renderer.gl;
    this.bindFramebuffer(l.framebuffer), !e.isRoot && e.colorAttachments.length > 0 && (l._attachedMipLevel !== o || l._attachedLayer !== r) && (e.colorAttachments.forEach((p, f) => {
      const y = p.texture, b = this._renderer.texture.getGlSource(y);
      if (b.target === d.TEXTURE_2D) {
        if (r !== 0)
          throw new Error("[RenderTargetSystem] layer must be 0 when rendering to 2D textures in WebGL.");
        d.framebufferTexture2D(
          d.FRAMEBUFFER,
          d.COLOR_ATTACHMENT0 + f,
          d.TEXTURE_2D,
          b.texture,
          o
        );
      } else if (b.target === d.TEXTURE_2D_ARRAY || b.target === d.TEXTURE_3D)
        d.framebufferTextureLayer(
          d.FRAMEBUFFER,
          d.COLOR_ATTACHMENT0 + f,
          b.texture,
          o,
          r
        );
      else if (b.target === d.TEXTURE_CUBE_MAP) {
        if (r < 0 || r > 5)
          throw new Error("[RenderTargetSystem] Cube map layer must be between 0 and 5.");
        d.framebufferTexture2D(
          d.FRAMEBUFFER,
          d.COLOR_ATTACHMENT0 + f,
          d.TEXTURE_CUBE_MAP_POSITIVE_X + r,
          b.texture,
          o
        );
      } else
        throw new Error("[RenderTargetSystem] Unsupported texture target for render-to-layer in WebGL.");
    }), l._attachedMipLevel = o, l._attachedLayer = r), l.framebuffer && (e.depthStencilAttachment ? this._attachDepthStencilTexture(e, o, r) : !l.depthStencilRenderBuffer && (e.stencil || e.depth) && this._initStencil(l)), e.colorAttachments.length > 1 && this._setDrawBuffers(e, d);
    let c = s.y;
    e.isRoot && (c = e.pixelHeight - s.height - s.y);
    const u = this._viewPortCache;
    (u.x !== s.x || u.y !== c || u.width !== s.width || u.height !== s.height) && (u.x = s.x, u.y = c, u.width = s.width, u.height = s.height, d.viewport(
      s.x,
      c,
      s.width,
      s.height
    )), this.clear(e, t, i);
  }
  finishRenderPass(e) {
    const i = this._renderTargetSystem.getGpuRenderTarget(e);
    if (!i.msaa || e.colorAttachments.length === 0) return;
    const s = this._renderer.gl;
    s.bindFramebuffer(s.FRAMEBUFFER, i.resolveTargetFramebuffer), s.bindFramebuffer(s.READ_FRAMEBUFFER, i.framebuffer), s.blitFramebuffer(
      0,
      0,
      i.width,
      i.height,
      0,
      0,
      i.width,
      i.height,
      s.COLOR_BUFFER_BIT,
      s.NEAREST
    ), s.bindFramebuffer(s.FRAMEBUFFER, i.framebuffer), this._boundFramebuffer = i.framebuffer;
  }
  initGpuRenderTarget(e) {
    const i = this._renderer.gl, s = new aJ();
    s._attachedMipLevel = 0, s._attachedLayer = 0;
    const o = e.colorTexture;
    return o instanceof ki ? (this._renderer.context.ensureCanvasSize(o.resource), s.framebuffer = null, s) : (s.width = e.pixelWidth, s.height = e.pixelHeight, e.colorAttachments.length === 0 ? this._initDepth(e, s) : this._initColor(e, s), e.depthStencilAttachment && this._attachDepthStencilTexture(e, 0, 0), i.bindFramebuffer(i.FRAMEBUFFER, null), this._boundFramebuffer = null, s);
  }
  destroyGpuRenderTarget(e) {
    const t = this._renderer.gl;
    e.framebuffer && (t.deleteFramebuffer(e.framebuffer), e.framebuffer = null), e.resolveTargetFramebuffer && (t.deleteFramebuffer(e.resolveTargetFramebuffer), e.resolveTargetFramebuffer = null), e.depthStencilRenderBuffer && (t.deleteRenderbuffer(e.depthStencilRenderBuffer), e.depthStencilRenderBuffer = null), e.msaaRenderBuffer.forEach((i) => {
      t.deleteRenderbuffer(i);
    }), e.msaaRenderBuffer.length = 0;
  }
  clear(e, t, i, s, o = 0, r = 0) {
    if (!t) return;
    if (r !== 0)
      throw new Error("[RenderTargetSystem] Clearing array layers is not supported in WebGL renderer.");
    const a = this._renderTargetSystem;
    if (typeof t == "boolean" && (t = t ? wn.ALL : wn.NONE), e.colorAttachments.length === 0 && (t &= ~wn.COLOR, !t))
      return;
    const l = this._renderer.gl, d = !!(t & wn.DEPTH) && !this._renderer.state.depthMaskEnabled;
    if (t & wn.COLOR) {
      i != null || (i = a.defaultClearColor);
      const c = this._clearColorCache, u = i;
      (c[0] !== u[0] || c[1] !== u[1] || c[2] !== u[2] || c[3] !== u[3]) && (c[0] = u[0], c[1] = u[1], c[2] = u[2], c[3] = u[3], l.clearColor(u[0], u[1], u[2], u[3]));
    }
    d && l.depthMask(!0), l.clear(t), d && l.depthMask(!1);
  }
  resizeGpuRenderTarget(e) {
    if (e.isRoot) return;
    const t = this._renderTargetSystem.getGpuRenderTarget(e);
    t.width = e.pixelWidth, t.height = e.pixelHeight, e.colorAttachments.length > 0 && this._resizeColor(e, t), t.depthStencilRenderBuffer && this._resizeStencil(t), this._boundFramebuffer = void 0;
  }
  _initColor(e, t) {
    const i = this._renderer, s = i.gl, o = s.createFramebuffer();
    if (t.resolveTargetFramebuffer = o, s.bindFramebuffer(s.FRAMEBUFFER, o), e.colorAttachments.forEach((a, l) => {
      const d = a.texture;
      d.antialias && (i.context.supports.msaa ? t.msaa = !0 : at("[RenderTexture] Antialiasing on textures is not supported in WebGL1")), i.texture.bindSource(d, 0);
      const c = i.texture.getGlSource(d), u = c.texture;
      if (c.target === s.TEXTURE_2D)
        s.framebufferTexture2D(
          s.FRAMEBUFFER,
          s.COLOR_ATTACHMENT0 + l,
          s.TEXTURE_2D,
          u,
          0
        );
      else if (c.target === s.TEXTURE_2D_ARRAY || c.target === s.TEXTURE_3D)
        s.framebufferTextureLayer(
          s.FRAMEBUFFER,
          s.COLOR_ATTACHMENT0 + l,
          u,
          0,
          0
        );
      else if (c.target === s.TEXTURE_CUBE_MAP)
        s.framebufferTexture2D(
          s.FRAMEBUFFER,
          s.COLOR_ATTACHMENT0 + l,
          s.TEXTURE_CUBE_MAP_POSITIVE_X,
          u,
          0
        );
      else
        throw new Error("[RenderTargetSystem] Unsupported texture target for framebuffer attachment.");
    }), t.msaa) {
      const a = s.createFramebuffer();
      t.framebuffer = a, s.bindFramebuffer(s.FRAMEBUFFER, a), e.colorAttachments.forEach((l, d) => {
        const c = s.createRenderbuffer();
        t.msaaRenderBuffer[d] = c;
      });
    } else
      t.framebuffer = o;
    this._resizeColor(e, t);
  }
  _initDepth(e, t) {
    const i = this._renderer;
    if (i.context.webGLVersion < 2)
      throw new Error("[RenderTargetSystem] Depth-only render targets require WebGL2.");
    const s = i.gl, o = s.createFramebuffer();
    t.resolveTargetFramebuffer = o, t.framebuffer = o, s.bindFramebuffer(s.FRAMEBUFFER, o), s.drawBuffers([s.NONE]), s.readBuffer(s.NONE);
  }
  _resizeColor(e, t) {
    const i = e.colorAttachments[0].texture;
    if (t._attachedMipLevel = 0, t._attachedLayer = 0, e.colorAttachments.forEach((s, o) => {
      o !== 0 && s.texture.resize(i.width, i.height, i._resolution);
    }), t.msaa) {
      const s = this._renderer, o = s.gl, r = t.framebuffer;
      o.bindFramebuffer(o.FRAMEBUFFER, r), e.colorAttachments.forEach((a, l) => {
        const d = a.texture;
        s.texture.bindSource(d, 0);
        const u = s.texture.getGlSource(d).internalFormat, p = t.msaaRenderBuffer[l];
        o.bindRenderbuffer(
          o.RENDERBUFFER,
          p
        ), o.renderbufferStorageMultisample(
          o.RENDERBUFFER,
          4,
          u,
          d.pixelWidth,
          d.pixelHeight
        ), o.framebufferRenderbuffer(
          o.FRAMEBUFFER,
          o.COLOR_ATTACHMENT0 + l,
          o.RENDERBUFFER,
          p
        );
      });
    }
  }
  _attachDepthStencilTexture(e, t, i) {
    const s = this._renderer, o = s.gl, r = e.depthStencilAttachment.texture, a = s.texture.getGlSource(r), l = a.texture, d = r.format;
    let c;
    d === "depth24plus-stencil8" || d === "depth32float-stencil8" ? c = o.DEPTH_STENCIL_ATTACHMENT : d === "stencil8" ? c = o.STENCIL_ATTACHMENT : c = o.DEPTH_ATTACHMENT, a.target === o.TEXTURE_2D ? o.framebufferTexture2D(
      o.FRAMEBUFFER,
      c,
      o.TEXTURE_2D,
      l,
      t
    ) : a.target === o.TEXTURE_2D_ARRAY || a.target === o.TEXTURE_3D ? o.framebufferTextureLayer(
      o.FRAMEBUFFER,
      c,
      l,
      t,
      i
    ) : a.target === o.TEXTURE_CUBE_MAP && o.framebufferTexture2D(
      o.FRAMEBUFFER,
      c,
      o.TEXTURE_CUBE_MAP_POSITIVE_X + i,
      l,
      t
    );
  }
  _initStencil(e) {
    if (e.framebuffer === null) return;
    const t = this._renderer.gl, i = t.createRenderbuffer();
    e.depthStencilRenderBuffer = i, t.bindRenderbuffer(
      t.RENDERBUFFER,
      i
    ), t.framebufferRenderbuffer(
      t.FRAMEBUFFER,
      t.DEPTH_STENCIL_ATTACHMENT,
      t.RENDERBUFFER,
      i
    ), this._resizeStencil(e);
  }
  _resizeStencil(e) {
    const t = this._renderer.gl;
    t.bindRenderbuffer(
      t.RENDERBUFFER,
      e.depthStencilRenderBuffer
    ), e.msaa ? t.renderbufferStorageMultisample(
      t.RENDERBUFFER,
      4,
      t.DEPTH24_STENCIL8,
      e.width,
      e.height
    ) : t.renderbufferStorage(
      t.RENDERBUFFER,
      this._renderer.context.webGLVersion === 2 ? t.DEPTH24_STENCIL8 : t.DEPTH_STENCIL,
      e.width,
      e.height
    );
  }
  prerender(e) {
    if (e.colorAttachments.length === 0) return;
    const t = e.colorAttachments[0].texture.resource;
    this._renderer.context.multiView && ki.test(t) && this._renderer.context.ensureCanvasSize(t);
  }
  postrender(e) {
    if (!this._renderer.context.multiView || e.colorAttachments.length === 0) return;
    const t = e.colorAttachments[0].texture;
    if (ki.test(t.resource)) {
      const i = this._renderer.context.canvas, s = t;
      s.context2D.drawImage(
        i,
        0,
        s.pixelHeight - i.height
      );
    }
  }
  _setDrawBuffers(e, t) {
    const i = e.colorAttachments.length, s = this._drawBuffersCache[i];
    if (this._renderer.context.webGLVersion === 1) {
      const o = this._renderer.context.extensions.drawBuffers;
      o ? o.drawBuffersWEBGL(s) : at("[RenderTexture] This WebGL1 context does not support rendering to multiple targets");
    } else
      t.drawBuffers(s);
  }
  /**
   * Forget the GL-call caches (framebuffer binding, viewport, clear color) so the next pass
   * re-applies them. Called via the renderer's `resetState` runner when external GL code may
   * have changed state behind our back.
   */
  resetState() {
    this._boundFramebuffer = void 0, this._viewPortCache = new _t(), this._clearColorCache = [0, 0, 0, 0];
  }
  /**
   * Binds a framebuffer to `gl.FRAMEBUFFER`, skipping the call when it is already bound.
   * The single blessed way to bind a framebuffer — keeps {@link _boundFramebuffer} coherent.
   * @param framebuffer - the framebuffer to bind
   * @internal
   */
  bindFramebuffer(e) {
    this._boundFramebuffer !== e && (this._boundFramebuffer = e, this._renderer.gl.bindFramebuffer(this._renderer.gl.FRAMEBUFFER, e));
  }
}
class nM extends ly {
  constructor(e) {
    super(e), this.adaptor = new hJ(), this.adaptor.init(e, this);
  }
  /** Called via the renderer's `resetState` runner when mixing Pixi with external GL code. */
  resetState() {
    this.adaptor.resetState();
  }
}
nM.extension = {
  type: [Ae.WebGLSystem],
  name: "renderTarget"
};
class uy extends di {
  /**
   * Create a new Buffer Resource.
   * @param options - The options for the buffer resource
   * @param options.buffer - The underlying buffer that this resource is using
   * @param options.offset - The offset of the buffer this resource is using.
   * If not provided, then it will use the offset of the buffer.
   * @param options.size - The size of the buffer this resource is using.
   * If not provided, then it will use the size of the buffer.
   */
  constructor({ buffer: e, offset: t, size: i }) {
    super(), this.uid = Lt("buffer"), this._resourceType = "bufferResource", this._resourceId = Lt("resource"), this._bufferResource = !0, this.destroyed = !1, this.buffer = e, this.offset = t | 0, this.size = i, this.buffer.on("change", this.onBufferChange, this);
  }
  /**
   * The GC tracks the underlying buffer, not this resource — a GC stamp here (see
   * BindGroup._touch) must land on the buffer, or the GC collects it while cached
   * bind groups still reference it.
   * @internal
   */
  get _gcLastUsed() {
    var e, t;
    return (t = (e = this.buffer) == null ? void 0 : e._gcLastUsed) != null ? t : -1;
  }
  set _gcLastUsed(e) {
    this.buffer && (this.buffer._gcLastUsed = e);
  }
  onBufferChange() {
    this._resourceId = Lt("resource"), this.emit("change", this);
  }
  /**
   * Destroys this resource. Make sure the underlying buffer is not used anywhere else
   * if you want to destroy it as well, or code will explode
   * @param destroyBuffer - Should the underlying buffer be destroyed as well?
   */
  destroy(e = !1) {
    this.destroyed = !0, e && this.buffer.destroy(), this.emit("change", this), this.buffer = null, this.removeAllListeners();
  }
}
class pJ extends di {
  /**
   * @param source - The texture source to view.
   * @param viewDescriptor - The WebGPU texture view descriptor.
   */
  constructor(e, t) {
    super(), this._resourceType = "textureView", this._resourceId = Lt("resource"), this.source = e, this.viewDescriptor = t, this._onChange = this._onChange.bind(this), this._onDestroy = this._onDestroy.bind(this), this.source.on("change", this._onChange), this.source.on("destroy", this._onDestroy);
  }
  _onChange() {
    this.emit("change", this);
  }
  _onDestroy() {
    this.destroy();
  }
  /** Returns whether the underlying source is destroyed. */
  get destroyed() {
    return this.source.destroyed;
  }
  /** Destroys the view and cleans up event listeners. */
  destroy() {
    this.source && (this.source.off("change", this._onChange), this.source.off("destroy", this._onDestroy)), this.emit("destroy", this), this.removeAllListeners();
  }
}
function fJ(n, e) {
  const t = [], i = [`
        var g = s.groups;
        var sS = r.shader;
        var p = s.glProgram;
        var ugS = r.uniformGroup;
        var resources;
    `];
  let s = !1, o = 0;
  const r = e._getProgramData(n.glProgram);
  for (const l in n.groups) {
    const d = n.groups[l];
    t.push(`
            resources = g[${l}].resources;
        `);
    for (const c in d.resources) {
      const u = d.resources[c];
      if (u instanceof ms)
        if (u.ubo) {
          const p = n._uniformBindMap[l][Number(c)];
          t.push(`
                        sS.bindUniformBlock(
                            resources[${c}],
                            '${p}',
                            ${n.glProgram._uniformBlockData[p].index}
                        );
                    `);
        } else
          t.push(`
                        ugS.updateUniformGroup(resources[${c}], p, sD);
                    `);
      else if (u instanceof uy) {
        const p = n._uniformBindMap[l][Number(c)];
        t.push(`
                    sS.bindUniformBlock(
                        resources[${c}],
                        '${p}',
                        ${n.glProgram._uniformBlockData[p].index}
                    );
                `);
      } else if (u instanceof an || u instanceof pJ) {
        const p = n._uniformBindMap[l][c], f = r.uniformData[p];
        f && (s || (s = !0, i.push(`
                        var tS = r.texture;
                        `)), e._gl.uniform1i(f.location, o), t.push(`
                        tS.bind(resources[${c}], ${o});
                    `), o++);
      }
    }
  }
  const a = [...i, ...t].join(`
`);
  return new Function("r", "s", "sD", a);
}
class mJ {
  /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */
  constructor(e, t) {
    this.program = e, this.uniformData = t, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBlockBindings = {};
  }
  /** Destroys this program. */
  destroy() {
    this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBlockBindings = null, this.program = null;
  }
}
function r2(n, e, t) {
  const i = n.createShader(e);
  return n.shaderSource(i, t), n.compileShader(i), i;
}
function _g(n) {
  const e = new Array(n);
  for (let t = 0; t < e.length; t++)
    e[t] = !1;
  return e;
}
function iM(n, e) {
  switch (n) {
    case "float":
      return 0;
    case "vec2":
      return new Float32Array(2 * e);
    case "vec3":
      return new Float32Array(3 * e);
    case "vec4":
      return new Float32Array(4 * e);
    case "int":
    case "uint":
    case "sampler2D":
    case "sampler2DArray":
    case "sampler3D":
      return 0;
    case "ivec2":
      return new Int32Array(2 * e);
    case "ivec3":
      return new Int32Array(3 * e);
    case "ivec4":
      return new Int32Array(4 * e);
    case "uvec2":
      return new Uint32Array(2 * e);
    case "uvec3":
      return new Uint32Array(3 * e);
    case "uvec4":
      return new Uint32Array(4 * e);
    case "bool":
      return !1;
    case "bvec2":
      return _g(2 * e);
    case "bvec3":
      return _g(3 * e);
    case "bvec4":
      return _g(4 * e);
    case "mat2":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
let ju = null;
const a2 = {
  FLOAT: "float",
  FLOAT_VEC2: "vec2",
  FLOAT_VEC3: "vec3",
  FLOAT_VEC4: "vec4",
  INT: "int",
  INT_VEC2: "ivec2",
  INT_VEC3: "ivec3",
  INT_VEC4: "ivec4",
  UNSIGNED_INT: "uint",
  UNSIGNED_INT_VEC2: "uvec2",
  UNSIGNED_INT_VEC3: "uvec3",
  UNSIGNED_INT_VEC4: "uvec4",
  BOOL: "bool",
  BOOL_VEC2: "bvec2",
  BOOL_VEC3: "bvec3",
  BOOL_VEC4: "bvec4",
  FLOAT_MAT2: "mat2",
  FLOAT_MAT3: "mat3",
  FLOAT_MAT4: "mat4",
  SAMPLER_2D: "sampler2D",
  INT_SAMPLER_2D: "sampler2D",
  UNSIGNED_INT_SAMPLER_2D: "sampler2D",
  SAMPLER_2D_SHADOW: "sampler2DShadow",
  SAMPLER_CUBE: "samplerCube",
  INT_SAMPLER_CUBE: "samplerCube",
  UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
  SAMPLER_CUBE_SHADOW: "samplerCubeShadow",
  SAMPLER_2D_ARRAY: "sampler2DArray",
  INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  SAMPLER_2D_ARRAY_SHADOW: "sampler2DArrayShadow",
  SAMPLER_3D: "sampler3D",
  INT_SAMPLER_3D: "sampler3D",
  UNSIGNED_INT_SAMPLER_3D: "sampler3D"
}, gJ = {
  float: "float32",
  vec2: "float32x2",
  vec3: "float32x3",
  vec4: "float32x4",
  int: "sint32",
  ivec2: "sint32x2",
  ivec3: "sint32x3",
  ivec4: "sint32x4",
  uint: "uint32",
  uvec2: "uint32x2",
  uvec3: "uint32x3",
  uvec4: "uint32x4",
  bool: "uint32",
  bvec2: "uint32x2",
  bvec3: "uint32x3",
  bvec4: "uint32x4"
};
function sM(n, e) {
  if (!ju) {
    const t = Object.keys(a2);
    ju = {};
    for (let i = 0; i < t.length; ++i) {
      const s = t[i];
      ju[n[s]] = a2[s];
    }
  }
  return ju[e];
}
function bJ(n, e) {
  const t = sM(n, e);
  return gJ[t] || "float32";
}
function vJ(n, e, t = !1) {
  const i = {}, s = e.getProgramParameter(n, e.ACTIVE_ATTRIBUTES);
  for (let r = 0; r < s; r++) {
    const a = e.getActiveAttrib(n, r);
    if (a.name.startsWith("gl_"))
      continue;
    const l = bJ(e, a.type);
    i[a.name] = {
      location: 0,
      // set further down..
      format: l,
      stride: kc(l).stride,
      offset: 0,
      instance: !1,
      start: 0
    };
  }
  const o = Object.keys(i);
  if (t) {
    o.sort((r, a) => r > a ? 1 : -1);
    for (let r = 0; r < o.length; r++)
      i[o[r]].location = r, e.bindAttribLocation(n, r, o[r]);
    e.linkProgram(n);
  } else
    for (let r = 0; r < o.length; r++)
      i[o[r]].location = e.getAttribLocation(n, o[r]);
  return i;
}
function yJ(n, e) {
  if (!e.ACTIVE_UNIFORM_BLOCKS) return {};
  const t = {}, i = e.getProgramParameter(n, e.ACTIVE_UNIFORM_BLOCKS);
  for (let s = 0; s < i; s++) {
    const o = e.getActiveUniformBlockName(n, s), r = e.getUniformBlockIndex(n, o), a = e.getActiveUniformBlockParameter(n, s, e.UNIFORM_BLOCK_DATA_SIZE);
    t[o] = {
      name: o,
      index: r,
      size: a
    };
  }
  return t;
}
function xJ(n, e) {
  const t = {}, i = e.getProgramParameter(n, e.ACTIVE_UNIFORMS);
  for (let s = 0; s < i; s++) {
    const o = e.getActiveUniform(n, s), r = o.name.replace(/\[.*?\]$/, ""), a = !!o.name.match(/\[.*?\]$/), l = sM(e, o.type);
    t[r] = {
      name: r,
      index: s,
      type: l,
      size: o.size,
      isArray: a,
      value: iM(l, o.size)
    };
  }
  return t;
}
function l2(n, e) {
  var c;
  const t = n.getShaderSource(e);
  if (t === null) {
    console.error("PixiJS Error: Could not retrieve shader source (WebGL context may be lost).");
    return;
  }
  const i = t.split(`
`).map((u, p) => `${p}: ${u}`), s = (c = n.getShaderInfoLog(e)) != null ? c : "", o = s.split(`
`), r = {}, a = o.map((u) => parseFloat(u.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((u) => u && !r[u] ? (r[u] = !0, !0) : !1), l = [""];
  a.forEach((u) => {
    i[u - 1] = `%c${i[u - 1]}%c`, l.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
  });
  const d = i.join(`
`);
  l[0] = d, console.error(s), console.groupCollapsed("click to view full shader code"), console.warn(...l), console.groupEnd();
}
function wJ(n, e, t, i) {
  n.getProgramParameter(e, n.LINK_STATUS) || (n.getShaderParameter(t, n.COMPILE_STATUS) || l2(n, t), n.getShaderParameter(i, n.COMPILE_STATUS) || l2(n, i), console.error("PixiJS Error: Could not initialize shader."), n.getProgramInfoLog(e) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", n.getProgramInfoLog(e)));
}
function kJ(n, e) {
  const t = r2(n, n.VERTEX_SHADER, e.vertex), i = r2(n, n.FRAGMENT_SHADER, e.fragment), s = n.createProgram();
  n.attachShader(s, t), n.attachShader(s, i);
  const o = e.transformFeedbackVaryings;
  o && (typeof n.transformFeedbackVaryings != "function" ? at("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : n.transformFeedbackVaryings(
    s,
    o.names,
    o.bufferMode === "separate" ? n.SEPARATE_ATTRIBS : n.INTERLEAVED_ATTRIBS
  )), n.linkProgram(s), n.getProgramParameter(s, n.LINK_STATUS) || wJ(n, s, t, i), e._attributeData = vJ(
    s,
    n,
    !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(e.vertex)
  ), e._uniformData = xJ(s, n), e._uniformBlockData = yJ(s, n), n.deleteShader(t), n.deleteShader(i);
  const r = {};
  for (const l in e._uniformData) {
    const d = e._uniformData[l];
    r[l] = {
      location: n.getUniformLocation(s, l),
      value: iM(d.type, d.size)
    };
  }
  return new mJ(s, r);
}
const Hu = {
  textureCount: 0,
  blockIndex: 0
};
class oM {
  constructor(e) {
    this._activeProgram = null, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._renderer = e;
  }
  contextChange(e) {
    this._gl = e, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._activeProgram = null;
  }
  /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param skipSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */
  bind(e, t) {
    if (this._setProgram(e.glProgram), t) return;
    Hu.textureCount = 0, Hu.blockIndex = 0;
    let i = this._shaderSyncFunctions[e.glProgram._key];
    i || (i = this._shaderSyncFunctions[e.glProgram._key] = this._generateShaderSync(e, this)), this._renderer.buffer.nextBindBase(!!e.glProgram.transformFeedbackVaryings), i(this._renderer, e, Hu);
  }
  /**
   * Updates the uniform group.
   * @param uniformGroup - the uniform group to update
   */
  updateUniformGroup(e) {
    this._renderer.uniformGroup.updateUniformGroup(e, this._activeProgram, Hu);
  }
  /**
   * Binds a uniform block to the shader.
   * @param uniformGroup - the uniform group to bind
   * @param name - the name of the uniform block
   * @param index - the index of the uniform block
   */
  bindUniformBlock(e, t, i = 0) {
    const s = this._renderer.buffer, o = this._getProgramData(this._activeProgram), r = e._bufferResource;
    r || this._renderer.ubo.updateUniformGroup(e);
    const a = e.buffer, l = s.updateBuffer(a), d = s.freeLocationForBufferBase(l);
    if (r) {
      const { offset: u, size: p } = e;
      u === 0 && p === a.data.byteLength ? s.bindBufferBase(l, d) : s.bindBufferRange(l, d, u);
    } else s.getLastBindBaseLocation(l) !== d && s.bindBufferBase(l, d);
    const c = this._activeProgram._uniformBlockData[t].index;
    o.uniformBlockBindings[i] !== d && (o.uniformBlockBindings[i] = d, this._renderer.gl.uniformBlockBinding(o.program, c, d));
  }
  _setProgram(e) {
    if (this._activeProgram === e) return;
    this._activeProgram = e;
    const t = this._getProgramData(e);
    this._gl.useProgram(t.program);
  }
  /**
   * @param program - the program to get the data for
   * @internal
   */
  _getProgramData(e) {
    return this._programDataHash[e._key] || this._createProgramData(e);
  }
  _createProgramData(e) {
    const t = e._key;
    return this._programDataHash[t] = kJ(this._gl, e), this._programDataHash[t];
  }
  destroy() {
    for (const e of Object.keys(this._programDataHash))
      this._programDataHash[e].destroy();
    this._programDataHash = null, this._shaderSyncFunctions = null, this._activeProgram = null, this._renderer = null, this._gl = null;
  }
  /**
   * Creates a function that can be executed that will sync the shader as efficiently as possible.
   * Overridden by the unsafe eval package if you don't want eval used in your project.
   * @param shader - the shader to generate the sync function for
   * @param shaderSystem - the shader system to use
   * @returns - the generated sync function
   * @ignore
   */
  _generateShaderSync(e, t) {
    return fJ(e, t);
  }
  resetState() {
    this._activeProgram = null;
  }
}
oM.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "shader"
};
const _J = {
  f32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1f(location, v);
        }`,
  "vec2<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2f(location, v[0], v[1]);
        }`,
  "vec3<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3f(location, v[0], v[1], v[2]);
        }`,
  "vec4<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4f(location, v[0], v[1], v[2], v[3]);
        }`,
  i32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  u32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1ui(location, v);
        }`,
  "vec2<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2ui(location, v[0], v[1]);
        }`,
  "vec3<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3ui(location, v[0], v[1], v[2]);
        }`,
  "vec4<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
        }`,
  bool: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);"
}, SJ = {
  f32: "gl.uniform1fv(location, v);",
  "vec2<f32>": "gl.uniform2fv(location, v);",
  "vec3<f32>": "gl.uniform3fv(location, v);",
  "vec4<f32>": "gl.uniform4fv(location, v);",
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);",
  i32: "gl.uniform1iv(location, v);",
  "vec2<i32>": "gl.uniform2iv(location, v);",
  "vec3<i32>": "gl.uniform3iv(location, v);",
  "vec4<i32>": "gl.uniform4iv(location, v);",
  u32: "gl.uniform1iv(location, v);",
  "vec2<u32>": "gl.uniform2iv(location, v);",
  "vec3<u32>": "gl.uniform3iv(location, v);",
  "vec4<u32>": "gl.uniform4iv(location, v);",
  bool: "gl.uniform1iv(location, v);",
  "vec2<bool>": "gl.uniform2iv(location, v);",
  "vec3<bool>": "gl.uniform3iv(location, v);",
  "vec4<bool>": "gl.uniform4iv(location, v);"
};
function TJ(n, e) {
  const t = [`
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
        var name = null;
    `];
  for (const i in n.uniforms) {
    if (!e[i]) {
      n.uniforms[i] instanceof ms ? n.uniforms[i].ubo ? t.push(`
                        renderer.shader.bindUniformBlock(uv.${i}, "${i}");
                    `) : t.push(`
                        renderer.shader.updateUniformGroup(uv.${i});
                    `) : n.uniforms[i] instanceof uy && t.push(`
                        renderer.shader.bindBufferResource(uv.${i}, "${i}");
                    `);
      continue;
    }
    const s = n.uniformStructures[i];
    let o = !1;
    for (let r = 0; r < Za.length; r++) {
      const a = Za[r];
      if (s.type === a.type && a.test(s)) {
        t.push(`name = "${i}";`, Za[r].uniform), o = !0;
        break;
      }
    }
    if (!o) {
      const a = (s.size === 1 ? _J : SJ)[s.type].replace("location", `ud["${i}"].location`);
      t.push(`
            cu = ud["${i}"];
            cv = cu.value;
            v = uv["${i}"];
            ${a};`);
    }
  }
  return new Function("ud", "uv", "renderer", "syncData", t.join(`
`));
}
class rM {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._cache = {}, this._uniformGroupSyncHash = {}, this._renderer = e, this.gl = null, this._cache = {};
  }
  contextChange(e) {
    this.gl = e;
  }
  /**
   * Uploads the uniforms values to the currently bound shader.
   * @param group - the uniforms values that be applied to the current shader
   * @param program
   * @param syncData
   * @param syncData.textureCount
   */
  updateUniformGroup(e, t, i) {
    const s = this._renderer.shader._getProgramData(t);
    (!e.isStatic || e._dirtyId !== s.uniformDirtyGroups[e.uid]) && (s.uniformDirtyGroups[e.uid] = e._dirtyId, this._getUniformSyncFunction(e, t)(s.uniformData, e.uniforms, this._renderer, i));
  }
  /**
   * Overridable by the pixi.js/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param program
   */
  _getUniformSyncFunction(e, t) {
    var i;
    return ((i = this._uniformGroupSyncHash[e._signature]) == null ? void 0 : i[t._key]) || this._createUniformSyncFunction(e, t);
  }
  _createUniformSyncFunction(e, t) {
    const i = this._uniformGroupSyncHash[e._signature] || (this._uniformGroupSyncHash[e._signature] = {}), s = this._getSignature(e, t._uniformData, "u");
    return this._cache[s] || (this._cache[s] = this._generateUniformsSync(e, t._uniformData)), i[t._key] = this._cache[s], i[t._key];
  }
  _generateUniformsSync(e, t) {
    return TJ(e, t);
  }
  /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */
  _getSignature(e, t, i) {
    const s = e.uniforms, o = [`${i}-`];
    for (const r in s)
      o.push(r), t[r] && o.push(t[r].type);
    return o.join("-");
  }
  /** Destroys this System and removes all its textures. */
  destroy() {
    this._renderer = null, this._cache = null;
  }
}
rM.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "uniformGroup"
};
function MJ(n) {
  const e = {};
  if (e.normal = [n.ONE, n.ONE_MINUS_SRC_ALPHA], e.add = [n.ONE, n.ONE], e.multiply = [n.DST_COLOR, n.ONE_MINUS_SRC_ALPHA, n.ONE, n.ONE_MINUS_SRC_ALPHA], e.screen = [n.ONE, n.ONE_MINUS_SRC_COLOR, n.ONE, n.ONE_MINUS_SRC_ALPHA], e.none = [0, 0], e["normal-npm"] = [n.SRC_ALPHA, n.ONE_MINUS_SRC_ALPHA, n.ONE, n.ONE_MINUS_SRC_ALPHA], e["add-npm"] = [n.SRC_ALPHA, n.ONE, n.ONE, n.ONE], e["screen-npm"] = [n.SRC_ALPHA, n.ONE_MINUS_SRC_COLOR, n.ONE, n.ONE_MINUS_SRC_ALPHA], e.erase = [n.ZERO, n.ONE_MINUS_SRC_ALPHA], !(n instanceof Pt.get().getWebGLRenderingContext()))
    e.min = [n.ONE, n.ONE, n.ONE, n.ONE, n.MIN, n.MIN], e.max = [n.ONE, n.ONE, n.ONE, n.ONE, n.MAX, n.MAX];
  else {
    const i = n.getExtension("EXT_blend_minmax");
    i && (e.min = [n.ONE, n.ONE, n.ONE, n.ONE, i.MIN_EXT, i.MIN_EXT], e.max = [n.ONE, n.ONE, n.ONE, n.ONE, i.MAX_EXT, i.MAX_EXT]);
  }
  return e;
}
const { BLEND: CJ, OFFSET: IJ, CULLING: AJ, DEPTH_TEST: PJ, WINDING: EJ, DEPTH_MASK: d2 } = rS, aM = class Hv {
  constructor(e) {
    this._invertFrontFace = !1, this._renderer = e, this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = "none", this._blendEq = !1, this.map = [], this.map[CJ] = this.setBlend, this.map[IJ] = this.setOffset, this.map[AJ] = this.setCullFace, this.map[PJ] = this.setDepthTest, this.map[EJ] = this.setFrontFace, this.map[d2] = this.setDepthMask, this.checks = [], this.defaultState = Zs.for2d(), e.renderTarget.onRenderTargetChange.add(this);
  }
  onRenderTargetChange(e) {
    this._invertFrontFace = this._renderer.renderTarget.isFrontFaceInverted(e, e.flipY), this._cullFace ? this.setFrontFace(this._frontFace) : this._frontFaceDirty = !0;
  }
  contextChange(e) {
    this.gl = e, this.blendModesMap = MJ(e), this.resetState();
  }
  /**
   * Sets the current state
   * @param {*} state - The state to set.
   */
  set(e) {
    if (e || (e = this.defaultState), this.stateId !== e.data) {
      let t = this.stateId ^ e.data, i = 0;
      for (; t; )
        t & 1 && this.map[i].call(this, !!(e.data & 1 << i)), t >>= 1, i++;
      this.stateId = e.data;
    }
    for (let t = 0; t < this.checks.length; t++)
      this.checks[t](this, e);
  }
  /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */
  forceState(e) {
    e || (e = this.defaultState);
    for (let t = 0; t < this.map.length; t++)
      this.map[t].call(this, !!(e.data & 1 << t));
    for (let t = 0; t < this.checks.length; t++)
      this.checks[t](this, e);
    this.stateId = e.data;
  }
  /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */
  setBlend(e) {
    this._updateCheck(Hv._checkBlendMode, e), this.gl[e ? "enable" : "disable"](this.gl.BLEND);
  }
  /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */
  setOffset(e) {
    this._updateCheck(Hv._checkPolygonOffset, e), this.gl[e ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
  }
  /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */
  setDepthTest(e) {
    this.gl[e ? "enable" : "disable"](this.gl.DEPTH_TEST);
  }
  /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */
  setDepthMask(e) {
    this.gl.depthMask(e);
  }
  /**
   * Whether depth writes are currently enabled on the GL context, as last applied by this
   * system. `gl.clear` is masked by this state, so depth clears must consult it.
   * @internal
   */
  get depthMaskEnabled() {
    return !!(this.stateId & 1 << d2);
  }
  /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */
  setCullFace(e) {
    this._cullFace = e, this.gl[e ? "enable" : "disable"](this.gl.CULL_FACE), this._cullFace && this._frontFaceDirty && this.setFrontFace(this._frontFace);
  }
  /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */
  setFrontFace(e) {
    this._frontFace = e, this._frontFaceDirty = !1;
    const t = this._invertFrontFace ? !e : e;
    this._glFrontFace !== t && (this._glFrontFace = t, this.gl.frontFace(this.gl[t ? "CW" : "CCW"]));
  }
  /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */
  setBlendMode(e) {
    if (this.blendModesMap[e] || (e = "normal"), e === this.blendMode)
      return;
    this.blendMode = e;
    const t = this.blendModesMap[e], i = this.gl;
    t.length === 2 ? i.blendFunc(t[0], t[1]) : i.blendFuncSeparate(t[0], t[1], t[2], t[3]), t.length === 6 ? (this._blendEq = !0, i.blendEquationSeparate(t[4], t[5])) : this._blendEq && (this._blendEq = !1, i.blendEquationSeparate(i.FUNC_ADD, i.FUNC_ADD));
  }
  /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */
  setPolygonOffset(e, t) {
    this.gl.polygonOffset(e, t);
  }
  /** Resets all the logic and disables the VAOs. */
  resetState() {
    this._glFrontFace = !1, this._frontFace = !1, this._cullFace = !1, this._frontFaceDirty = !1, this._invertFrontFace = !1, this.gl.frontFace(this.gl.CCW), this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = "", this.setBlendMode("normal");
  }
  /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */
  _updateCheck(e, t) {
    const i = this.checks.indexOf(e);
    t && i === -1 ? this.checks.push(e) : !t && i !== -1 && this.checks.splice(i, 1);
  }
  /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkBlendMode(e, t) {
    e.setBlendMode(t.blendMode);
  }
  /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkPolygonOffset(e, t) {
    e.setPolygonOffset(1, t.polygonOffset);
  }
  /** @ignore */
  destroy() {
    this.gl = null, this.checks.length = 0, this._renderer = null;
  }
};
aM.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "state"
};
let RJ = aM;
class zJ {
  constructor(e) {
    this.target = Ac.TEXTURE_2D, this._layerInitMask = 0, this.texture = e, this.width = -1, this.height = -1, this.type = Ct.UNSIGNED_BYTE, this.internalFormat = jv.RGBA, this.format = jv.RGBA, this.samplerType = 0;
  }
  destroy() {
  }
}
function lM(n, e, t, i, s) {
  if (n = Math.max(0, n), e = Math.min(e, t * i), n >= e) return 0;
  const o = Math.floor(n / t), r = n - o * t, a = Math.floor(e / t), l = e - a * t;
  if (o === a)
    return s[0].set(r, o, l - r, 1), 1;
  let d = 0, c = o;
  return r > 0 && (s[d++].set(r, o, t - r, 1), c++), a > c && s[d++].set(0, c, t, a - c), l > 0 && s[d++].set(0, a, l, 1), d;
}
const c2 = [new _t(), new _t(), new _t()], $J = {
  id: "buffer",
  upload(n, e, t, i, s, o = !1) {
    const r = s || e.target, a = n.resource;
    if (r === Ac.TEXTURE_3D || r === Ac.TEXTURE_2D_ARRAY) {
      o || e.width !== n.width || e.height !== n.height ? t.texImage3D(
        r,
        0,
        e.internalFormat,
        n.width,
        n.height,
        n.depthOrArrayLayers,
        0,
        e.format,
        e.type,
        a
      ) : t.texSubImage3D(
        r,
        0,
        0,
        0,
        0,
        n.width,
        n.height,
        n.depthOrArrayLayers,
        e.format,
        e.type,
        a
      ), e.width = n.width, e.height = n.height;
      return;
    }
    const l = n.width * n.height, d = o || e.width !== n.width || e.height !== n.height, c = n._updateStart > 0 || n._updateEnd < l;
    if (d)
      t.texImage2D(
        r,
        0,
        e.internalFormat,
        n.width,
        n.height,
        0,
        e.format,
        e.type,
        a
      );
    else if (c) {
      const u = a.length / l, p = lM(
        n._updateStart,
        n._updateEnd,
        n.width,
        n.height,
        c2
      );
      for (let f = 0; f < p; f++) {
        const y = c2[f], b = (y.y * n.width + y.x) * u;
        t.texSubImage2D(
          r,
          0,
          y.x,
          y.y,
          y.width,
          y.height,
          e.format,
          e.type,
          a.subarray(b, b + y.width * y.height * u)
        );
      }
    } else
      t.texSubImage2D(
        r,
        0,
        0,
        0,
        n.width,
        n.height,
        e.format,
        e.type,
        a
      );
    e.width = n.width, e.height = n.height;
  }
}, DJ = {
  "bc1-rgba-unorm": !0,
  "bc1-rgba-unorm-srgb": !0,
  "bc2-rgba-unorm": !0,
  "bc2-rgba-unorm-srgb": !0,
  "bc3-rgba-unorm": !0,
  "bc3-rgba-unorm-srgb": !0,
  "bc4-r-unorm": !0,
  "bc4-r-snorm": !0,
  "bc5-rg-unorm": !0,
  "bc5-rg-snorm": !0,
  "bc6h-rgb-ufloat": !0,
  "bc6h-rgb-float": !0,
  "bc7-rgba-unorm": !0,
  "bc7-rgba-unorm-srgb": !0,
  // ETC2 compressed formats usable if "texture-compression-etc2" is both
  // supported by the device/user agent and enabled in requestDevice.
  "etc2-rgb8unorm": !0,
  "etc2-rgb8unorm-srgb": !0,
  "etc2-rgb8a1unorm": !0,
  "etc2-rgb8a1unorm-srgb": !0,
  "etc2-rgba8unorm": !0,
  "etc2-rgba8unorm-srgb": !0,
  "eac-r11unorm": !0,
  "eac-r11snorm": !0,
  "eac-rg11unorm": !0,
  "eac-rg11snorm": !0,
  // ASTC compressed formats usable if "texture-compression-astc" is both
  // supported by the device/user agent and enabled in requestDevice.
  "astc-4x4-unorm": !0,
  "astc-4x4-unorm-srgb": !0,
  "astc-5x4-unorm": !0,
  "astc-5x4-unorm-srgb": !0,
  "astc-5x5-unorm": !0,
  "astc-5x5-unorm-srgb": !0,
  "astc-6x5-unorm": !0,
  "astc-6x5-unorm-srgb": !0,
  "astc-6x6-unorm": !0,
  "astc-6x6-unorm-srgb": !0,
  "astc-8x5-unorm": !0,
  "astc-8x5-unorm-srgb": !0,
  "astc-8x6-unorm": !0,
  "astc-8x6-unorm-srgb": !0,
  "astc-8x8-unorm": !0,
  "astc-8x8-unorm-srgb": !0,
  "astc-10x5-unorm": !0,
  "astc-10x5-unorm-srgb": !0,
  "astc-10x6-unorm": !0,
  "astc-10x6-unorm-srgb": !0,
  "astc-10x8-unorm": !0,
  "astc-10x8-unorm-srgb": !0,
  "astc-10x10-unorm": !0,
  "astc-10x10-unorm-srgb": !0,
  "astc-12x10-unorm": !0,
  "astc-12x10-unorm-srgb": !0,
  "astc-12x12-unorm": !0,
  "astc-12x12-unorm-srgb": !0
}, OJ = {
  id: "compressed",
  upload(n, e, t, i, s, o) {
    const r = s != null ? s : e.target;
    t.pixelStorei(t.UNPACK_ALIGNMENT, 4);
    let a = n.pixelWidth, l = n.pixelHeight;
    const d = !!DJ[n.format];
    for (let c = 0; c < n.resource.length; c++) {
      const u = n.resource[c];
      d ? t.compressedTexImage2D(
        r,
        c,
        e.internalFormat,
        a,
        l,
        0,
        u
      ) : t.texImage2D(
        r,
        c,
        e.internalFormat,
        a,
        l,
        0,
        e.format,
        e.type,
        u
      ), a = Math.max(a >> 1, 1), l = Math.max(l >> 1, 1);
    }
  }
}, u2 = ["right", "left", "top", "bottom", "front", "back"];
function LJ(n) {
  return {
    id: "cube",
    upload(e, t, i, s) {
      const o = e.faces;
      for (let r = 0; r < u2.length; r++) {
        const a = u2[r], l = o[a];
        if (!l.resource) continue;
        (n[l.uploadMethodId] || n.image).upload(
          l,
          t,
          i,
          s,
          // Use the face target for the current face. cube faces ids go up 1 so
          // GL_TARGETS.TEXTURE_CUBE_MAP_POSITIVE_X + i addresses the i'th face target.
          Ac.TEXTURE_CUBE_MAP_POSITIVE_X + r,
          // Force allocation for the first upload of each face.
          (t._layerInitMask & 1 << r) === 0
        ), t._layerInitMask |= 1 << r;
      }
      t.width = e.pixelWidth, t.height = e.pixelHeight;
    }
  };
}
const dM = {
  id: "image",
  upload(n, e, t, i, s, o = !1) {
    const r = s || e.target, a = n.pixelWidth, l = n.pixelHeight, d = n.resourceWidth, c = n.resourceHeight, u = i === 2, p = o || e.width !== a || e.height !== l, f = d >= a && c >= l, y = n.resource;
    (u ? BJ : FJ)(
      t,
      r,
      e,
      a,
      l,
      d,
      c,
      y,
      p,
      f
    ), e.width = a, e.height = l;
  }
};
function BJ(n, e, t, i, s, o, r, a, l, d) {
  if (!d) {
    l && n.texImage2D(
      e,
      0,
      t.internalFormat,
      i,
      s,
      0,
      t.format,
      t.type,
      null
    ), n.texSubImage2D(
      e,
      0,
      0,
      0,
      o,
      r,
      t.format,
      t.type,
      a
    );
    return;
  }
  if (!l) {
    n.texSubImage2D(
      e,
      0,
      0,
      0,
      t.format,
      t.type,
      a
    );
    return;
  }
  n.texImage2D(
    e,
    0,
    t.internalFormat,
    i,
    s,
    0,
    t.format,
    t.type,
    a
  );
}
function FJ(n, e, t, i, s, o, r, a, l, d) {
  if (!d) {
    l && n.texImage2D(
      e,
      0,
      t.internalFormat,
      i,
      s,
      0,
      t.format,
      t.type,
      null
    ), n.texSubImage2D(
      e,
      0,
      0,
      0,
      t.format,
      t.type,
      a
    );
    return;
  }
  if (!l) {
    n.texSubImage2D(
      e,
      0,
      0,
      0,
      t.format,
      t.type,
      a
    );
    return;
  }
  n.texImage2D(
    e,
    0,
    t.internalFormat,
    t.format,
    t.type,
    a
  );
}
const NJ = lX(), UJ = {
  id: "video",
  upload(n, e, t, i, s, o = NJ) {
    if (!n.isValid) {
      const r = s != null ? s : e.target;
      t.texImage2D(
        r,
        0,
        e.internalFormat,
        1,
        1,
        0,
        e.format,
        e.type,
        null
      );
      return;
    }
    dM.upload(n, e, t, i, s, o);
  }
}, h2 = {
  linear: 9729,
  nearest: 9728
}, GJ = {
  linear: {
    linear: 9987,
    nearest: 9985
  },
  nearest: {
    linear: 9986,
    nearest: 9984
  }
}, Sg = {
  "clamp-to-edge": 33071,
  repeat: 10497,
  "mirror-repeat": 33648
}, jJ = {
  never: 512,
  less: 513,
  equal: 514,
  "less-equal": 515,
  greater: 516,
  "not-equal": 517,
  "greater-equal": 518,
  always: 519
};
function p2(n, e, t, i, s, o, r, a) {
  const l = o;
  if (!a || n.addressModeU !== "repeat" || n.addressModeV !== "repeat" || n.addressModeW !== "repeat") {
    const d = Sg[r ? "clamp-to-edge" : n.addressModeU], c = Sg[r ? "clamp-to-edge" : n.addressModeV], u = Sg[r ? "clamp-to-edge" : n.addressModeW];
    e[s](l, e.TEXTURE_WRAP_S, d), e[s](l, e.TEXTURE_WRAP_T, c), e.TEXTURE_WRAP_R && e[s](l, e.TEXTURE_WRAP_R, u);
  }
  if ((!a || n.magFilter !== "linear") && e[s](l, e.TEXTURE_MAG_FILTER, h2[n.magFilter]), t) {
    if (!a || n.mipmapFilter !== "linear") {
      const d = GJ[n.minFilter][n.mipmapFilter];
      e[s](l, e.TEXTURE_MIN_FILTER, d);
    }
  } else
    e[s](l, e.TEXTURE_MIN_FILTER, h2[n.minFilter]);
  if (i && n.maxAnisotropy > 1) {
    const d = Math.min(n.maxAnisotropy, e.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
    e[s](l, i.TEXTURE_MAX_ANISOTROPY_EXT, d);
  }
  n.compare ? (e[s](l, e.TEXTURE_COMPARE_FUNC, jJ[n.compare]), e[s](l, e.TEXTURE_COMPARE_MODE, e.COMPARE_REF_TO_TEXTURE)) : a || e[s](l, e.TEXTURE_COMPARE_MODE, e.NONE);
}
function HJ(n) {
  return {
    // 8-bit formats
    r8unorm: n.RED,
    r8snorm: n.RED,
    r8uint: n.RED_INTEGER,
    r8sint: n.RED_INTEGER,
    // 16-bit formats
    r16uint: n.RED_INTEGER,
    r16sint: n.RED_INTEGER,
    r16float: n.RED,
    rg8unorm: n.RG,
    rg8snorm: n.RG,
    rg8uint: n.RG_INTEGER,
    rg8sint: n.RG_INTEGER,
    // 32-bit formats
    r32uint: n.RED_INTEGER,
    r32sint: n.RED_INTEGER,
    r32float: n.RED,
    rg16uint: n.RG_INTEGER,
    rg16sint: n.RG_INTEGER,
    rg16float: n.RG,
    rgba8unorm: n.RGBA,
    "rgba8unorm-srgb": n.RGBA,
    // Packed 32-bit formats
    rgba8snorm: n.RGBA,
    rgba8uint: n.RGBA_INTEGER,
    rgba8sint: n.RGBA_INTEGER,
    bgra8unorm: n.RGBA,
    "bgra8unorm-srgb": n.RGBA,
    rgb9e5ufloat: n.RGB,
    rgb10a2unorm: n.RGBA,
    rg11b10ufloat: n.RGB,
    // 64-bit formats
    rg32uint: n.RG_INTEGER,
    rg32sint: n.RG_INTEGER,
    rg32float: n.RG,
    rgba16uint: n.RGBA_INTEGER,
    rgba16sint: n.RGBA_INTEGER,
    rgba16float: n.RGBA,
    // 128-bit formats
    rgba32uint: n.RGBA_INTEGER,
    rgba32sint: n.RGBA_INTEGER,
    rgba32float: n.RGBA,
    // Depth/stencil formats
    stencil8: n.STENCIL_INDEX8,
    depth16unorm: n.DEPTH_COMPONENT,
    depth24plus: n.DEPTH_COMPONENT,
    "depth24plus-stencil8": n.DEPTH_STENCIL,
    depth32float: n.DEPTH_COMPONENT,
    "depth32float-stencil8": n.DEPTH_STENCIL
  };
}
function VJ(n, e) {
  let t = {}, i = n.RGBA;
  return n instanceof Pt.get().getWebGLRenderingContext() ? e.srgb && (t = {
    "rgba8unorm-srgb": e.srgb.SRGB8_ALPHA8_EXT,
    "bgra8unorm-srgb": e.srgb.SRGB8_ALPHA8_EXT
  }) : (t = {
    "rgba8unorm-srgb": n.SRGB8_ALPHA8,
    "bgra8unorm-srgb": n.SRGB8_ALPHA8
  }, i = n.RGBA8), {
    // 8-bit formats
    r8unorm: n.R8,
    r8snorm: n.R8_SNORM,
    r8uint: n.R8UI,
    r8sint: n.R8I,
    // 16-bit formats
    r16uint: n.R16UI,
    r16sint: n.R16I,
    r16float: n.R16F,
    rg8unorm: n.RG8,
    rg8snorm: n.RG8_SNORM,
    rg8uint: n.RG8UI,
    rg8sint: n.RG8I,
    // 32-bit formats
    r32uint: n.R32UI,
    r32sint: n.R32I,
    r32float: n.R32F,
    rg16uint: n.RG16UI,
    rg16sint: n.RG16I,
    rg16float: n.RG16F,
    rgba8unorm: n.RGBA,
    ...t,
    // Packed 32-bit formats
    rgba8snorm: n.RGBA8_SNORM,
    rgba8uint: n.RGBA8UI,
    rgba8sint: n.RGBA8I,
    bgra8unorm: i,
    rgb9e5ufloat: n.RGB9_E5,
    rgb10a2unorm: n.RGB10_A2,
    rg11b10ufloat: n.R11F_G11F_B10F,
    // 64-bit formats
    rg32uint: n.RG32UI,
    rg32sint: n.RG32I,
    rg32float: n.RG32F,
    rgba16uint: n.RGBA16UI,
    rgba16sint: n.RGBA16I,
    rgba16float: n.RGBA16F,
    // 128-bit formats
    rgba32uint: n.RGBA32UI,
    rgba32sint: n.RGBA32I,
    rgba32float: n.RGBA32F,
    // Depth/stencil formats
    stencil8: n.STENCIL_INDEX8,
    depth16unorm: n.DEPTH_COMPONENT16,
    depth24plus: n.DEPTH_COMPONENT24,
    "depth24plus-stencil8": n.DEPTH24_STENCIL8,
    depth32float: n.DEPTH_COMPONENT32F,
    "depth32float-stencil8": n.DEPTH32F_STENCIL8,
    // Compressed formats
    ...e.s3tc ? {
      "bc1-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT5_EXT
    } : {},
    ...e.s3tc_sRGB ? {
      "bc1-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
    } : {},
    ...e.rgtc ? {
      "bc4-r-unorm": e.rgtc.COMPRESSED_RED_RGTC1_EXT,
      "bc4-r-snorm": e.rgtc.COMPRESSED_SIGNED_RED_RGTC1_EXT,
      "bc5-rg-unorm": e.rgtc.COMPRESSED_RED_GREEN_RGTC2_EXT,
      "bc5-rg-snorm": e.rgtc.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT
    } : {},
    ...e.bptc ? {
      "bc6h-rgb-float": e.bptc.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT,
      "bc6h-rgb-ufloat": e.bptc.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT,
      "bc7-rgba-unorm": e.bptc.COMPRESSED_RGBA_BPTC_UNORM_EXT,
      "bc7-rgba-unorm-srgb": e.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
    } : {},
    ...e.etc ? {
      "etc2-rgb8unorm": e.etc.COMPRESSED_RGB8_ETC2,
      "etc2-rgb8unorm-srgb": e.etc.COMPRESSED_SRGB8_ETC2,
      "etc2-rgb8a1unorm": e.etc.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgb8a1unorm-srgb": e.etc.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgba8unorm": e.etc.COMPRESSED_RGBA8_ETC2_EAC,
      "etc2-rgba8unorm-srgb": e.etc.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC,
      "eac-r11unorm": e.etc.COMPRESSED_R11_EAC,
      // 'eac-r11snorm'
      "eac-rg11unorm": e.etc.COMPRESSED_SIGNED_RG11_EAC
      // 'eac-rg11snorm'
    } : {},
    ...e.astc ? {
      "astc-4x4-unorm": e.astc.COMPRESSED_RGBA_ASTC_4x4_KHR,
      "astc-4x4-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR,
      "astc-5x4-unorm": e.astc.COMPRESSED_RGBA_ASTC_5x4_KHR,
      "astc-5x4-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR,
      "astc-5x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_5x5_KHR,
      "astc-5x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR,
      "astc-6x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_6x5_KHR,
      "astc-6x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR,
      "astc-6x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_6x6_KHR,
      "astc-6x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR,
      "astc-8x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x5_KHR,
      "astc-8x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR,
      "astc-8x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x6_KHR,
      "astc-8x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR,
      "astc-8x8-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x8_KHR,
      "astc-8x8-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR,
      "astc-10x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x5_KHR,
      "astc-10x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR,
      "astc-10x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x6_KHR,
      "astc-10x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR,
      "astc-10x8-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x8_KHR,
      "astc-10x8-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR,
      "astc-10x10-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x10_KHR,
      "astc-10x10-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR,
      "astc-12x10-unorm": e.astc.COMPRESSED_RGBA_ASTC_12x10_KHR,
      "astc-12x10-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR,
      "astc-12x12-unorm": e.astc.COMPRESSED_RGBA_ASTC_12x12_KHR,
      "astc-12x12-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR
    } : {}
  };
}
function WJ(n) {
  return {
    // 8-bit formats
    r8unorm: n.UNSIGNED_BYTE,
    r8snorm: n.BYTE,
    r8uint: n.UNSIGNED_BYTE,
    r8sint: n.BYTE,
    // 16-bit formats
    r16uint: n.UNSIGNED_SHORT,
    r16sint: n.SHORT,
    r16float: n.HALF_FLOAT,
    rg8unorm: n.UNSIGNED_BYTE,
    rg8snorm: n.BYTE,
    rg8uint: n.UNSIGNED_BYTE,
    rg8sint: n.BYTE,
    // 32-bit formats
    r32uint: n.UNSIGNED_INT,
    r32sint: n.INT,
    r32float: n.FLOAT,
    rg16uint: n.UNSIGNED_SHORT,
    rg16sint: n.SHORT,
    rg16float: n.HALF_FLOAT,
    rgba8unorm: n.UNSIGNED_BYTE,
    "rgba8unorm-srgb": n.UNSIGNED_BYTE,
    // Packed 32-bit formats
    rgba8snorm: n.BYTE,
    rgba8uint: n.UNSIGNED_BYTE,
    rgba8sint: n.BYTE,
    bgra8unorm: n.UNSIGNED_BYTE,
    "bgra8unorm-srgb": n.UNSIGNED_BYTE,
    rgb9e5ufloat: n.UNSIGNED_INT_5_9_9_9_REV,
    rgb10a2unorm: n.UNSIGNED_INT_2_10_10_10_REV,
    rg11b10ufloat: n.UNSIGNED_INT_10F_11F_11F_REV,
    // 64-bit formats
    rg32uint: n.UNSIGNED_INT,
    rg32sint: n.INT,
    rg32float: n.FLOAT,
    rgba16uint: n.UNSIGNED_SHORT,
    rgba16sint: n.SHORT,
    rgba16float: n.HALF_FLOAT,
    // 128-bit formats
    rgba32uint: n.UNSIGNED_INT,
    rgba32sint: n.INT,
    rgba32float: n.FLOAT,
    // Depth/stencil formats
    stencil8: n.UNSIGNED_BYTE,
    depth16unorm: n.UNSIGNED_SHORT,
    depth24plus: n.UNSIGNED_INT,
    "depth24plus-stencil8": n.UNSIGNED_INT_24_8,
    depth32float: n.FLOAT,
    "depth32float-stencil8": n.FLOAT_32_UNSIGNED_INT_24_8_REV
  };
}
function qJ(n) {
  return {
    "2d": n.TEXTURE_2D,
    cube: n.TEXTURE_CUBE_MAP,
    "1d": null,
    // WebGL2 only
    "3d": (n == null ? void 0 : n.TEXTURE_3D) || null,
    "2d-array": (n == null ? void 0 : n.TEXTURE_2D_ARRAY) || null,
    "cube-array": (n == null ? void 0 : n.TEXTURE_CUBE_MAP_ARRAY) || null
  };
}
const KJ = 4, hy = class cM {
  constructor(e) {
    this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundTextures = [], this._integerUnits = 0, this._activeTextureLocation = -1, this._boundSamplers = /* @__PURE__ */ Object.create(null), this._premultiplyAlpha = !1, this._useSeparateSamplers = !1, this._renderer = e, this._managedTextures = new gs({
      renderer: e,
      type: "resource",
      onUnload: this.onSourceUnload.bind(this),
      name: "glTexture"
    });
    const t = {
      image: dM,
      buffer: $J,
      video: UJ,
      compressed: OJ,
      ...cM.uploadExtensions
    };
    this._uploads = {
      ...t,
      cube: LJ(t)
    };
  }
  /**
   * @deprecated since 8.15.0
   */
  get managedTextures() {
    return Object.values(this._managedTextures.items);
  }
  contextChange(e) {
    this._gl = e, this._mapFormatToInternalFormat || (this._mapFormatToInternalFormat = VJ(e, this._renderer.context.extensions), this._mapFormatToType = WJ(e), this._mapFormatToFormat = HJ(e), this._mapViewDimensionToGlTarget = qJ(e)), this._managedTextures.removeAll(!0), this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundSamplers = /* @__PURE__ */ Object.create(null), this._premultiplyAlpha = !1;
    for (let t = 0; t < 16; t++)
      this.bind(Ze.EMPTY, t);
  }
  /**
   * Initializes a texture source, if it has already been initialized nothing will happen.
   * @param source - The texture source to initialize.
   * @returns The initialized texture source.
   */
  initSource(e) {
    this.bind(e);
  }
  bind(e, t = 0) {
    const i = e.source;
    e ? (this.bindSource(i, t), this._useSeparateSamplers && this._bindSampler(i.style, t)) : (this.bindSource(null, t), this._useSeparateSamplers && this._bindSampler(null, t));
  }
  bindSource(e, t = 0) {
    const i = this._gl;
    if (e._gcLastUsed = this._renderer.gc.now, this._boundTextures[t] !== e) {
      this._setBoundTexture(t, e), this._activateLocation(t), e || (e = Ze.EMPTY.source);
      const s = this.getGlSource(e);
      i.bindTexture(s.target, s.texture);
    }
  }
  /**
   * Binds the empty texture over every integer texture on unit `location` and above
   *
   * WebGL fails a draw when a float sampler's unit holds an integer texture, even if the shader
   * never samples it. Call this after binding a batch's textures when the shader declares more
   * samplers than the batch binds.
   * @param location - The first texture unit to check.
   */
  unbindIntegerTextures(e) {
    if (e >= 32) return;
    let t = this._integerUnits >>> e << e;
    for (; t; ) {
      const i = 31 - Math.clz32(t);
      t &= ~(1 << i), this.bind(Ze.EMPTY, i);
    }
  }
  /**
   * Records the source bound to a unit, keeping `_integerUnits` in step. Every per-unit write to
   * `_boundTextures` goes through here so the two can't drift apart.
   *
   * A unit has a separate binding per target (2D, 2D array, cube), and the batch shaders sample
   * the 2D target, so only a 2D source changes the unit's bit. Anything else, including null,
   * leaves it as it was: a bit left set after the integer texture is gone only costs one extra
   * `bind(Texture.EMPTY)` in `unbindIntegerTextures`, while a cleared bit over an integer texture
   * fails the next batch.
   * @param location - The texture unit.
   * @param source - The source now bound there, or null.
   */
  _setBoundTexture(e, t) {
    this._boundTextures[e] = t, !(e < 0 || e > 31) && (!t || t.viewDimension !== "2d" || (mv(t.format) ? this._integerUnits |= 1 << e : this._integerUnits &= ~(1 << e)));
  }
  _bindSampler(e, t = 0) {
    const i = this._gl;
    if (!e) {
      this._boundSamplers[t] = null, i.bindSampler(t, null);
      return;
    }
    const s = this._getGlSampler(e);
    this._boundSamplers[t] !== s && (this._boundSamplers[t] = s, i.bindSampler(t, s));
  }
  unbind(e) {
    const t = e.source, i = this._boundTextures, s = this._gl;
    for (let o = 0; o < i.length; o++)
      if (i[o] === t) {
        this._activateLocation(o);
        const r = this.getGlSource(t);
        s.bindTexture(r.target, null), this._setBoundTexture(o, null);
      }
  }
  _activateLocation(e) {
    this._activeTextureLocation !== e && (this._activeTextureLocation = e, this._gl.activeTexture(this._gl.TEXTURE0 + e));
  }
  _initSource(e) {
    const t = this._gl, i = new zJ(t.createTexture());
    if (i.type = this._mapFormatToType[e.format], i.internalFormat = this._mapFormatToInternalFormat[e.format], i.format = this._mapFormatToFormat[e.format], i.target = this._mapViewDimensionToGlTarget[e.viewDimension], i.target === null)
      throw new Error(`Unsupported view dimension: ${e.viewDimension} with this webgl version: ${this._renderer.context.webGLVersion}`);
    if (e.autoGenerateMipmaps && (this._renderer.context.supports.nonPowOf2mipmaps || e.isPowerOfTwo)) {
      const o = Math.max(e.width, e.height, e.depth);
      e.mipLevelCount = Math.floor(Math.log2(o)) + 1;
    }
    return e._gpuData[this._renderer.uid] = i, this._managedTextures.add(e) && (e.on("update", this.onSourceUpdate, this), e.on("resize", this.onSourceUpdate, this), e.on("styleChange", this.onStyleChange, this), e.on("updateMipmaps", this.onUpdateMipmaps, this)), this.onSourceUpdate(e), this.updateStyle(e, !1), i;
  }
  onStyleChange(e) {
    this.updateStyle(e, !1);
  }
  updateStyle(e, t) {
    const i = this._gl, s = this.getGlSource(e);
    i.bindTexture(s.target, s.texture), this._setBoundTexture(this._activeTextureLocation, e), p2(
      e.style,
      i,
      e.mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "texParameteri",
      s.target,
      // will force a clamp to edge if the texture is not a power of two
      !this._renderer.context.supports.nonPowOf2wrapping && !e.isPowerOfTwo,
      t
    );
  }
  onSourceUnload(e, t = !1) {
    const i = e._gpuData[this._renderer.uid];
    i && (t || (this.unbind(e), this._gl.deleteTexture(i.texture)), e.off("update", this.onSourceUpdate, this), e.off("resize", this.onSourceUpdate, this), e.off("styleChange", this.onStyleChange, this), e.off("updateMipmaps", this.onUpdateMipmaps, this));
  }
  onSourceUpdate(e) {
    const t = this._gl, i = this.getGlSource(e);
    t.bindTexture(i.target, i.texture), this._setBoundTexture(this._activeTextureLocation, e);
    const s = e.alphaMode === "premultiply-alpha-on-upload" && !mv(e.format) && i.target !== t.TEXTURE_3D && i.target !== t.TEXTURE_2D_ARRAY;
    if (this._premultiplyAlpha !== s && (this._premultiplyAlpha = s, t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, s)), this._uploads[e.uploadMethodId])
      this._uploads[e.uploadMethodId].upload(e, i, t, this._renderer.context.webGLVersion);
    else if (i.target === t.TEXTURE_2D)
      this._initEmptyTexture2D(i, e);
    else if (i.target === t.TEXTURE_2D_ARRAY || i.target === t.TEXTURE_3D)
      this._initEmptyTexture3D(i, e);
    else if (i.target === t.TEXTURE_CUBE_MAP)
      this._initEmptyTextureCube(i, e);
    else
      throw new Error("[GlTextureSystem] Unsupported texture target for empty allocation.");
    this._applyMipRange(i, e), e.autoGenerateMipmaps && e.mipLevelCount > 1 && this.onUpdateMipmaps(e, !1);
  }
  onUpdateMipmaps(e, t = !0) {
    t && this.bindSource(e, 0);
    const i = this.getGlSource(e);
    this._gl.generateMipmap(i.target);
  }
  _initEmptyTexture2D(e, t) {
    const i = this._gl;
    i.texImage2D(
      i.TEXTURE_2D,
      0,
      e.internalFormat,
      t.pixelWidth,
      t.pixelHeight,
      0,
      e.format,
      e.type,
      null
    );
    let s = Math.max(t.pixelWidth >> 1, 1), o = Math.max(t.pixelHeight >> 1, 1);
    for (let r = 1; r < t.mipLevelCount; r++)
      i.texImage2D(
        i.TEXTURE_2D,
        r,
        e.internalFormat,
        s,
        o,
        0,
        e.format,
        e.type,
        null
      ), s = Math.max(s >> 1, 1), o = Math.max(o >> 1, 1);
  }
  /**
   * Allocates a texture with a depth: the layers of a 2D array or the slices of a 3D texture.
   * Layer counts stay the same at every mip level; 3D depth halves like width and height.
   * @param glTexture - The GL texture wrapper.
   * @param source - The texture source describing the size.
   */
  _initEmptyTexture3D(e, t) {
    const i = this._gl, s = e.target === i.TEXTURE_3D;
    let o = t.pixelWidth, r = t.pixelHeight, a = t.depthOrArrayLayers;
    for (let l = 0; l < t.mipLevelCount; l++)
      i.texImage3D(
        e.target,
        l,
        e.internalFormat,
        o,
        r,
        a,
        0,
        e.format,
        e.type,
        null
      ), o = Math.max(o >> 1, 1), r = Math.max(r >> 1, 1), s && (a = Math.max(a >> 1, 1));
  }
  _initEmptyTextureCube(e, t) {
    const i = this._gl, s = 6;
    for (let a = 0; a < s; a++)
      i.texImage2D(
        i.TEXTURE_CUBE_MAP_POSITIVE_X + a,
        0,
        e.internalFormat,
        t.pixelWidth,
        t.pixelHeight,
        0,
        e.format,
        e.type,
        null
      );
    let o = Math.max(t.pixelWidth >> 1, 1), r = Math.max(t.pixelHeight >> 1, 1);
    for (let a = 1; a < t.mipLevelCount; a++) {
      for (let l = 0; l < s; l++)
        i.texImage2D(
          i.TEXTURE_CUBE_MAP_POSITIVE_X + l,
          a,
          e.internalFormat,
          o,
          r,
          0,
          e.format,
          e.type,
          null
        );
      o = Math.max(o >> 1, 1), r = Math.max(r >> 1, 1);
    }
  }
  /**
   * Applies a mip range to the currently-bound texture so WebGL2 considers the texture "mipmap complete"
   * for the declared `mipLevelCount` (especially important for partial mip chains rendered via FBO).
   * @param glTexture - The GL texture wrapper.
   * @param source - The texture source describing mipLevelCount.
   */
  _applyMipRange(e, t) {
    if (this._renderer.context.webGLVersion !== 2 || t.mipLevelCount <= 1) return;
    const i = this._gl, s = Math.max((t.mipLevelCount | 0) - 1, 0);
    i.texParameteri(e.target, i.TEXTURE_BASE_LEVEL, 0), i.texParameteri(e.target, i.TEXTURE_MAX_LEVEL, s);
  }
  _initSampler(e) {
    const t = this._gl, i = this._gl.createSampler();
    return this._glSamplers[e._resourceId] = i, p2(
      e,
      t,
      this._boundTextures[this._activeTextureLocation].mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "samplerParameteri",
      i,
      !1,
      !0
    ), this._glSamplers[e._resourceId];
  }
  _getGlSampler(e) {
    return this._glSamplers[e._resourceId] || this._initSampler(e);
  }
  getGlSource(e) {
    return e._gcLastUsed = this._renderer.gc.now, e._gpuData[this._renderer.uid] || this._initSource(e);
  }
  generateCanvas(e) {
    const { pixels: t, width: i, height: s } = this.getPixels(e), o = Pt.get().createCanvas();
    o.width = i, o.height = s;
    const r = o.getContext("2d");
    if (r) {
      const a = r.createImageData(i, s);
      a.data.set(t), r.putImageData(a, 0, 0);
    }
    return o;
  }
  getPixels(e) {
    const t = e.source.resolution, i = e.frame, s = Math.max(Math.round(i.width * t), 1), o = Math.max(Math.round(i.height * t), 1), r = new Uint8Array(KJ * s * o), a = this._renderer, l = a.renderTarget.getRenderTarget(e), d = a.renderTarget.getGpuRenderTarget(l), c = a.gl;
    return a.renderTarget.adaptor.bindFramebuffer(d.resolveTargetFramebuffer), c.readPixels(
      Math.round(i.x * t),
      Math.round(i.y * t),
      s,
      o,
      c.RGBA,
      c.UNSIGNED_BYTE,
      r
    ), { pixels: new Uint8ClampedArray(r.buffer), width: s, height: o };
  }
  destroy() {
    this._managedTextures.destroy(), this._glSamplers = null, this._boundTextures = null, this._boundSamplers = null, this._mapFormatToInternalFormat = null, this._mapFormatToType = null, this._mapFormatToFormat = null, this._uploads = null, this._renderer = null;
  }
  resetState() {
    const e = this._renderer.limits.maxTextures;
    this._activeTextureLocation = -1, this._boundTextures.fill(null), this._integerUnits = e >= 32 ? -1 : (1 << e) - 1, this._boundSamplers = /* @__PURE__ */ Object.create(null);
    const t = this._gl;
    this._premultiplyAlpha = !1, t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this._premultiplyAlpha);
  }
};
hy.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "texture"
};
hy.uploadExtensions = /* @__PURE__ */ Object.create(null);
let uM = hy;
ct.handleByMap(Ae.TextureUploaderWebGL, uM.uploadExtensions);
class hM {
  contextChange(e) {
    const t = new ms({
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uTransformMatrix: { value: new st(), type: "mat3x3<f32>" },
      uRound: { value: 0, type: "f32" }
    }), i = e.limits.maxBatchableTextures, s = z1({
      name: "graphics",
      bits: [
        $S,
        OS(i),
        dT,
        D1
      ]
    });
    this.shader = new Js({
      glProgram: s,
      resources: {
        localUniforms: t,
        batchSamplers: LS(i)
      }
    });
  }
  execute(e, t) {
    const i = t.context, s = i.customShader || this.shader, o = e.renderer, r = o.graphicsContext, {
      batcher: a,
      instructions: l
    } = r.getContextRenderData(i);
    s.groups[0] = o.globalUniforms.bindGroup, o.state.set(e.state), o.shader.bind(s), o.geometry.bind(a.geometry, s.glProgram);
    const d = l.instructions;
    for (let c = 0; c < l.instructionSize; c++) {
      const u = d[c];
      if (u.size) {
        for (let p = 0; p < u.textures.count; p++)
          o.texture.bind(u.textures.textures[p], p);
        o.texture.unbindIntegerTextures(u.textures.count), o.geometry.draw(u.topology, u.size, u.start);
      }
    }
  }
  destroy() {
    this.shader.destroy(!0), this.shader = null;
  }
}
hM.extension = {
  type: [
    Ae.WebGLPipesAdaptor
  ],
  name: "graphics"
};
class pM {
  init() {
    const e = z1({
      name: "mesh",
      bits: [
        dT,
        uX,
        D1
      ]
    });
    this._shader = new Js({
      glProgram: e,
      resources: {
        uTexture: Ze.EMPTY.source,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new st() }
        }
      }
    });
  }
  execute(e, t) {
    const i = e.renderer;
    let s = t._shader;
    if (s) {
      if (!s.glProgram) {
        at("Mesh shader has no glProgram", t.shader);
        return;
      }
    } else {
      s = this._shader;
      const o = t.texture, r = o.source;
      s.resources.uTexture = r, s.resources.uSampler = r.style, s.resources.textureUniforms.uniforms.uTextureMatrix = o.textureMatrix.mapCoord;
    }
    s.groups[100] = i.globalUniforms.bindGroup, s.groups[101] = e.localUniformsBindGroup, i.encoder.draw({
      geometry: t._geometry,
      shader: s,
      state: t.state
    });
  }
  destroy() {
    this._shader.destroy(!0), this._shader = null;
  }
}
pM.extension = {
  type: [
    Ae.WebGLPipesAdaptor
  ],
  name: "mesh"
};
const YJ = [
  ...ay,
  tM,
  rJ,
  eJ,
  YT,
  jT,
  uM,
  nM,
  VT,
  rM,
  oM,
  KT,
  RJ,
  XT,
  qT
], XJ = [...OT], JJ = [uT, pM, hM], fM = [], mM = [], gM = [], bM = [];
ct.handleByNamedList(Ae.WebGLSystem, fM);
ct.handleByNamedList(Ae.WebGLPipes, mM);
ct.handleByNamedList(Ae.WebGLPipesAdaptor, gM);
ct.handleByNamedList(Ae.WebGLLoader, bM);
ct.add(...YJ, ...XJ, ...JJ);
class ZJ extends Xc {
  constructor() {
    const e = {
      name: "webgl",
      type: Vi.WEBGL,
      systems: fM,
      renderPipes: mM,
      renderPipeAdaptors: gM,
      loaders: bM
    };
    super(e);
  }
}
const QJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGLRenderer: ZJ
}, Symbol.toStringTag, { value: "Module" }));
class eZ {
  constructor(e, t) {
    this.autoGarbageCollect = !0, this._gpuData = null, this.gpuBindGroup = e, this._gcLastUsed = t;
  }
  /**
   * Native bind groups have no destroy; dropping the reference is the whole release. Anything
   * still holding the group (a recorded render bundle, a graphics batch) keeps it alive, and the
   * next immediate-mode bind simply recreates the cache entry.
   */
  unload() {
    this.gpuBindGroup = null;
  }
}
class vM {
  constructor(e) {
    this._hash = /* @__PURE__ */ Object.create(null), this._renderer = e, e.gc.addResourceHash(this, "_hash", "resource"), e.gc.addCollection(this, "_hash", "hash");
  }
  contextChange(e) {
    this._gpu = e, this._hash = /* @__PURE__ */ Object.create(null);
  }
  getBindGroup(e, t, i) {
    const s = `${e._key}:${t._layoutKey << 4 | i}`, o = this._hash[s];
    return o ? (o._gcLastUsed = this._renderer.gc.now, o.gpuBindGroup) : this._createBindGroup(s, e, t, i);
  }
  _createBindGroup(e, t, i, s) {
    var u, p;
    const o = this._gpu.device, r = i.layout[s], a = [], l = this._renderer;
    for (const f in r) {
      const y = (u = t.resources[f]) != null ? u : t.resources[r[f]];
      if (!y || y.destroyed)
        throw new Error(`[BindGroup] the resource bound as '${f}' was destroyed while a shader still uses it. Remove it from the shader before destroying it.`);
      let b;
      if (y._resourceType === "uniformGroup") {
        const w = y;
        l.ubo.updateUniformGroup(w);
        const k = w.buffer;
        b = {
          buffer: l.buffer.getGPUBuffer(k),
          offset: 0,
          size: k.descriptor.size
        };
      } else if (y._resourceType === "buffer") {
        const w = y;
        b = {
          buffer: l.buffer.getGPUBuffer(w),
          offset: 0,
          size: w.descriptor.size
        };
      } else if (y._resourceType === "bufferResource") {
        const w = y;
        b = {
          buffer: l.buffer.getGPUBuffer(w.buffer),
          offset: w.offset,
          size: (p = w.size) != null ? p : w.buffer.descriptor.size
        };
      } else if (y._resourceType === "textureSampler") {
        const w = y;
        b = l.texture.getGpuSampler(w);
      } else if (y._resourceType === "textureSource") {
        const w = y;
        b = l.texture.getTextureView(w);
      } else if (y._resourceType === "textureView") {
        const w = y;
        b = l.texture.getTextureView(w.source, w.viewDescriptor);
      }
      a.push({
        binding: r[f],
        resource: b
      });
    }
    const d = l.shader.getProgramData(i).bindGroups[s], c = o.createBindGroup({
      layout: d,
      entries: a
    });
    return this._hash[e] = new eZ(c, l.gc.now), c;
  }
  destroy() {
    this._hash = null, this._renderer = null;
  }
}
vM.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "bindGroup"
};
class tZ {
  constructor(e) {
    this.gpuBuffer = e;
  }
  destroy() {
    this.gpuBuffer.destroy(), this.gpuBuffer = null;
  }
}
class yM {
  constructor(e) {
    this._renderer = e, this._managedBuffers = new gs({
      renderer: e,
      type: "resource",
      onUnload: this.onBufferUnload.bind(this),
      name: "gpuBuffer"
    });
  }
  contextChange(e) {
    this._gpu = e, this.destroyAll();
  }
  getGPUBuffer(e) {
    var t;
    return e._gcLastUsed = this._renderer.gc.now, ((t = e._gpuData[this._renderer.uid]) == null ? void 0 : t.gpuBuffer) || this.createGPUBuffer(e);
  }
  updateBuffer(e) {
    const t = this.getGPUBuffer(e), i = e.data;
    return e._updateID && i && (e._updateID = 0, this._gpu.device.queue.writeBuffer(
      t,
      e._updateOffset,
      i.buffer,
      i.byteOffset + e._updateOffset,
      // round to the nearest 4 bytes
      (e._updateSize || i.byteLength) + 3 & -4
    )), t;
  }
  /** dispose all WebGL resources of all managed buffers */
  destroyAll() {
    this._managedBuffers.removeAll();
  }
  onBufferUnload(e) {
    e.off("update", this.updateBuffer, this), e.off("change", this.onBufferChange, this);
  }
  createGPUBuffer(e) {
    const t = this._gpu.device.createBuffer(e.descriptor);
    return e._updateID = 0, e.data && (zv(
      e.data.buffer,
      t.getMappedRange(),
      e.data.byteOffset,
      e.data.byteLength
    ), t.unmap()), e._gpuData[this._renderer.uid] = new tZ(t), this._managedBuffers.add(e) && (e.on("update", this.updateBuffer, this), e.on("change", this.onBufferChange, this)), t;
  }
  onBufferChange(e) {
    this._managedBuffers.remove(e), e._updateID = 0, this.createGPUBuffer(e);
  }
  destroy() {
    this._managedBuffers.destroy(), this._renderer = null, this._gpu = null;
  }
}
yM.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "buffer"
};
class nZ {
  constructor({ minUniformOffsetAlignment: e }) {
    this._minUniformOffsetAlignment = 256, this.byteIndex = 0, this._minUniformOffsetAlignment = e, this.data = new Float32Array(65535);
  }
  clear() {
    this.byteIndex = 0;
  }
  addEmptyGroup(e) {
    if (e > this._minUniformOffsetAlignment / 4)
      throw new Error(`UniformBufferBatch: array is too large: ${e * 4}`);
    const t = this.byteIndex;
    let i = t + e * 4;
    if (i = Math.ceil(i / this._minUniformOffsetAlignment) * this._minUniformOffsetAlignment, i > this.data.length * 4)
      throw new Error("UniformBufferBatch: ubo batch got too big");
    return this.byteIndex = i, t;
  }
  addGroup(e) {
    const t = this.addEmptyGroup(e.length);
    for (let i = 0; i < e.length; i++)
      this.data[t / 4 + i] = e[i];
    return t;
  }
  destroy() {
    this.data = null;
  }
}
class xM {
  constructor(e) {
    this._colorMaskCache = 15, this._renderer = e;
  }
  setMask(e) {
    this._colorMaskCache !== e && (this._colorMaskCache = e, this._renderer.pipeline.setColorMask(e));
  }
  destroy() {
    this._renderer = null, this._colorMaskCache = null;
  }
}
xM.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "colorMask"
};
const iZ = /* @__PURE__ */ new Set(["apple", "arm", "qualcomm", "img-tec"]);
class py {
  /**
   * @param {WebGPURenderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    this._renderer = e;
  }
  async init(e) {
    return this._initPromise ? this._initPromise : (this._options = e, this._initPromise = (e.gpu ? Promise.resolve(e.gpu) : this._createDeviceAndAdaptor(e)).then((t) => this._setGpu(t)), this._initPromise);
  }
  _setGpu(e) {
    var t, i;
    this.gpu = e, this.extensions = {
      transientAttachment: typeof GPUTextureUsage.TRANSIENT_ATTACHMENT == "number",
      tileBased: iZ.has((i = (t = e.adapter) == null ? void 0 : t.info) == null ? void 0 : i.vendor)
    }, this._options.gpu || e.device.lost.then(() => this._restoreDevice()).catch((s) => at("WebGPU device was lost and could not be restored", s)), this._renderer.runners.contextChange.emit(this.gpu);
  }
  async _restoreDevice() {
    if (!this._renderer) return;
    const e = await this._createDeviceAndAdaptor(this._options);
    if (!this._renderer) {
      e.device.destroy();
      return;
    }
    this._setGpu(e);
  }
  /**
   * Handle the context change event
   * @param gpu
   */
  contextChange(e) {
    this._renderer.gpu = e;
  }
  /**
   * Helper class to create a WebGL Context
   * @param {object} options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */
  async _createDeviceAndAdaptor(e) {
    const t = await Pt.get().getNavigator().gpu.requestAdapter({
      powerPreference: e.powerPreference,
      forceFallbackAdapter: e.forceFallbackAdapter
    });
    if (!t)
      throw new Error("WebGPU not supported. No GPU adapter was returned by navigator.gpu.requestAdapter().");
    const i = [
      "texture-compression-bc",
      "texture-compression-astc",
      "texture-compression-etc2",
      "indirect-first-instance",
      // more formats for TextureSource `storage`
      "bgra8unorm-storage",
      "texture-formats-tier1"
    ].filter((o) => t.features.has(o)), s = await t.requestDevice({
      requiredFeatures: i,
      requiredLimits: {
        maxSampledTexturesPerShaderStage: t.limits.maxSampledTexturesPerShaderStage,
        maxSamplersPerShaderStage: t.limits.maxSamplersPerShaderStage
      }
    });
    return { adapter: t, device: s };
  }
  destroy() {
    var e, t;
    (e = this._options) != null && e.gpu || (t = this.gpu) == null || t.device.destroy(), this.gpu = null, this.extensions = null, this._renderer = null;
  }
}
py.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "device"
};
py.defaultOptions = {
  /**
   * {@link WebGPUOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * Force the use of the fallback adapter
   * @default false
   */
  forceFallbackAdapter: !1
};
class sZ {
  /**
   * @param gpuBundle - The recorded native render bundle.
   * @param stateKey - The pipeline state key captured when recording began.
   * @param device - The device the bundle was recorded on.
   * @param label - Optional debug label for the bundle.
   */
  constructor(e, t, i, s) {
    this.gpuBundle = e, this.stateKey = t, this.device = i, this.label = s;
  }
}
class wM {
  constructor(e) {
    this._boundBindGroup = /* @__PURE__ */ Object.create(null), this._boundVertexBuffer = /* @__PURE__ */ Object.create(null), this._renderer = e;
    for (let t = 0; t < 16; t++)
      this._boundBindGroup[t] = { bindGroup: null, program: null, key: null };
  }
  renderStart() {
    this.commandFinished = new Promise((e) => {
      this._resolveCommandFinished = e;
    }), this.commandEncoder = this._renderer.gpu.device.createCommandEncoder();
  }
  /**
   * Ends any open pass and begins one on the target's descriptor.
   * @param gpuRenderTarget - the target to render to
   * @returns the begun pass
   */
  beginRenderPass(e) {
    return this.endRenderPass(), this._clearCache(), this._passEncoder = this.commandEncoder.beginRenderPass(e.descriptor), this.renderPassEncoder = this._passEncoder, this._passEncoder;
  }
  endRenderPass() {
    this._passEncoder && this._passEncoder.end(), this.renderPassEncoder = null, this._passEncoder = null;
  }
  /**
   * Begins recording a render bundle. While recording, all draw commands are captured into a
   * {@link GPURenderBundleEncoder} instead of the active render pass. The current render pass
   * encoder is saved and restored when {@link endBundle} is called.
   *
   * Render bundles allow pre-recording of draw commands that can be replayed multiple times
   * via {@link executeBundle}, reducing CPU overhead for repeated draw sequences.
   * @param label - Optional debug label. Names the bundle in GPU captures and in the WebGPU
   * validation errors it can raise when replayed, instead of `(unlabeled)`.
   * @throws If a render bundle is already being recorded.
   */
  beginBundle(e) {
    if (this._passEncoder !== this.renderPassEncoder)
      throw new Error("Cannot begin a new render bundle while one is already being recorded.");
    this._clearCache();
    const t = this._renderer.pipeline, i = t.getBundleDescriptor();
    i.label = e, this._bundleStateKey = t.bundleStateKey, this._bundleLabel = e, this.renderPassEncoder = this._gpu.device.createRenderBundleEncoder(i);
  }
  /**
   * Finishes recording the current render bundle and restores the previous render pass encoder.
   * @returns The recorded {@link RenderBundle}, ready to be executed via {@link executeBundle} and
   * stamped with the pipeline state it baked so {@link isBundleValid} can vet it on later frames.
   */
  endBundle() {
    const e = this.renderPassEncoder;
    if (!e || !("finish" in e))
      throw new Error("endBundle called without an active render bundle.");
    const t = e.finish({ label: this._bundleLabel });
    return this.renderPassEncoder = this._passEncoder, this._clearCache(), new sZ(t, this._bundleStateKey, this._gpu.device, this._bundleLabel);
  }
  /**
   * Checks whether a recorded bundle can still be replayed against the render target that is
   * bound now.
   *
   * A bundle permanently bakes the attachment state it was recorded with — color format(s),
   * color target count, depth/stencil format, sample count — and WebGPU rejects the entire
   * command buffer if any of it differs at execute time. It also bakes the front-face winding of
   * its pipelines, which WebGPU does *not* validate: once the target's {@link RenderTarget.flipY}
   * parity changes, replaying silently renders geometry inside out.
   *
   * Ask before replaying rather than after: only the caller owns the draw commands, so only the
   * caller can re-record. A missing bundle reports `false`, so `!isBundleValid(bundles[i])` reads
   * correctly on the first frame, before anything has been recorded.
   * @param bundle - The bundle to check, as returned by {@link endBundle}.
   * @returns `true` if the bundle is safe to execute right now, `false` if it must be re-recorded.
   */
  isBundleValid(e) {
    return (e == null ? void 0 : e.stateKey) === this._renderer.pipeline.bundleStateKey && e.device === this._gpu.device;
  }
  /**
   * Replays previously recorded render bundles on the current render pass.
   * The bound state cache is cleared since a bundle may set its own pipeline, bind groups, and buffers.
   *
   * Pass a whole run of bundles rather than calling this once per bundle: WebGPU resets the pass
   * state after every call, so N calls cost N cache clears and N trips through the binding layer
   * for exactly the same result.
   *
   * Every bundle must have been recorded against a matching render target — check with
   * {@link isBundleValid} first and re-record if it says no, as Pixi cannot rebuild your draw
   * commands for you.
   * @param bundle - The render bundle to execute, or a run of them to execute in one call.
   */
  executeBundle(e) {
    const t = [];
    if (Array.isArray(e))
      for (let i = 0; i < e.length; i++)
        t[i] = this._getGpuBundle(e[i]);
    else
      t[0] = this._getGpuBundle(e);
    this._clearCache(), this._passEncoder.executeBundles(t);
  }
  /**
   * Unwraps a bundle for {@link executeBundle}, complaining first if it no longer matches the
   * bound render target — the winding half of that mismatch is invisible otherwise, since WebGPU
   * validates attachments but not front-face order.
   * @param bundle - The bundle being executed.
   * @returns The native bundle to hand to `executeBundles`.
   */
  _getGpuBundle(e) {
    var t;
    return this.isBundleValid(e) || at(`Render bundle ${(t = e == null ? void 0 : e.label) != null ? t : "(unlabeled)"} was recorded against a different render target state or on a lost device. Re-record it — replaying it will either be rejected by WebGPU or draw with the wrong winding. Check encoder.isBundleValid(bundle) before executing.`), e.gpuBundle;
  }
  setViewport(e) {
    this._passEncoder.setViewport(e.x, e.y, e.width, e.height, 0, 1);
  }
  /**
   * Sets the stencil reference value for subsequent draws. This is a pass-level command, so it
   * always targets the real render pass — not a bundle encoder, which cannot set stencil state.
   * @param stencilReference - The stencil reference value to use.
   */
  setStencilReference(e) {
    this._passEncoder.setStencilReference(e);
  }
  setPipelineFromGeometryProgramAndState(e, t, i, s, o) {
    const r = this._renderer.pipeline.getPipeline(
      e,
      t,
      i,
      s,
      o
    );
    this.setPipeline(r);
  }
  setPipeline(e) {
    this._boundPipeline !== e && (this._boundPipeline = e, this.renderPassEncoder.setPipeline(e));
  }
  _setVertexBuffer(e, t) {
    this._boundVertexBuffer[e] !== t && (this._boundVertexBuffer[e] = t, this.renderPassEncoder.setVertexBuffer(e, this._renderer.buffer.updateBuffer(t)));
  }
  _setIndexBuffer(e) {
    if (this._boundIndexBuffer === e) return;
    this._boundIndexBuffer = e;
    const t = e.data.BYTES_PER_ELEMENT === 2 ? "uint16" : "uint32";
    this.renderPassEncoder.setIndexBuffer(this._renderer.buffer.updateBuffer(e), t);
  }
  resetBindGroup(e) {
    const t = this._boundBindGroup[e];
    t.bindGroup = null, t.program = null, t.key = null;
  }
  setBindGroup(e, t, i) {
    const s = this._boundBindGroup[e];
    if (s.bindGroup === t && s.program === i && s.key === t._key) return;
    s.bindGroup = t, s.program = i, s.key = t._key, t._touch(this._renderer.gc.now);
    const o = this._renderer.bindGroup.getBindGroup(t, i, e);
    this.renderPassEncoder.setBindGroup(e, o);
  }
  setGeometry(e, t) {
    const i = this._renderer.pipeline.getBufferNamesToBind(e, t);
    for (let s = 0; s < i.length; s++)
      this._setVertexBuffer(s, e.attributes[i[s]].buffer);
    e.indexBuffer && this._setIndexBuffer(e.indexBuffer);
  }
  _setShaderBindGroups(e, t) {
    const i = e.gpuProgram, s = i.layout;
    for (let o = 0; o < s.length; o++) {
      const r = e.groups[o];
      !s[o] || !r || (t || this._syncBindGroup(r), this.setBindGroup(o, r, i));
    }
  }
  _syncBindGroup(e) {
    const t = e.resources, i = e._resourceKeys;
    for (let s = 0; s < i.length; s++) {
      const o = t[i[s]];
      o && o.isUniformGroup && this._renderer.ubo.updateUniformGroup(o);
    }
  }
  draw(e) {
    const { geometry: t, shader: i, state: s, topology: o, size: r, start: a, baseVertex: l, instanceCount: d, skipSync: c, firstInstance: u } = e;
    this.setPipelineFromGeometryProgramAndState(t, i.gpuProgram, s, o, i._overrides), this.setGeometry(t, i.gpuProgram), this._setShaderBindGroups(i, c), t.indexBuffer ? this.renderPassEncoder.drawIndexed(
      r || t.indexCount || t.indexBuffer.data.length,
      d != null ? d : t.instanceCount,
      a || 0,
      l || 0,
      u || 0
    ) : this.renderPassEncoder.draw(
      r || t.vertexCount,
      d != null ? d : t.instanceCount,
      a || 0,
      u || 0
    );
  }
  /**
   * Sets up the pipeline, geometry, and bind groups then issues an indirect draw call.
   * Uses `drawIndexedIndirect` when the geometry has an index buffer, otherwise `drawIndirect`.
   * Draw parameters (vertex count, instance count, etc.) are read from the indirect buffer on the GPU.
   * @param options - The draw options.
   * @param options.geometry - The geometry to draw.
   * @param options.shader - The shader to use.
   * @param options.state - Optional render state (blending, depth, etc.).
   * @param options.topology - Optional primitive topology override.
   * @param options.skipSync - If true, skips syncing uniform groups to their GPU buffers.
   * @param options.indirectBuffer - The GPU buffer containing the indirect draw parameters.
   * @param options.indirectOffset - Byte offset into the indirect buffer.
   */
  drawIndirect(e) {
    const { geometry: t, shader: i, state: s, topology: o, skipSync: r, indirectBuffer: a, indirectOffset: l } = e;
    this.setPipelineFromGeometryProgramAndState(t, i.gpuProgram, s, o, i._overrides), this.setGeometry(t, i.gpuProgram), this._setShaderBindGroups(i, r), t.indexBuffer ? this.renderPassEncoder.drawIndexedIndirect(a, l) : this.renderPassEncoder.drawIndirect(a, l);
  }
  finishRenderPass() {
    this._passEncoder && (this._passEncoder.end(), this.renderPassEncoder = null, this._passEncoder = null);
  }
  postrender() {
    this.finishRenderPass(), this._gpu.device.queue.submit([this.commandEncoder.finish()]), this._resolveCommandFinished(), this.commandEncoder = null;
  }
  _clearCache() {
    for (let e = 0; e < 16; e++) {
      const t = this._boundBindGroup[e];
      t.bindGroup = null, t.program = null, t.key = null, this._boundVertexBuffer[e] = null;
    }
    this._boundIndexBuffer = null, this._boundPipeline = null;
  }
  destroy() {
    this._renderer = null, this._gpu = null, this._boundBindGroup = null, this._boundVertexBuffer = null, this._boundIndexBuffer = null, this._boundPipeline = null, this.renderPassEncoder = null, this._passEncoder = null;
  }
  contextChange(e) {
    this._gpu = e;
  }
}
wM.extension = {
  type: [Ae.WebGPUSystem],
  name: "encoder",
  priority: 1
};
class kM {
  constructor(e) {
    this.supportsOverrideConstants = !1, this._renderer = e;
  }
  contextChange() {
    const e = this._renderer.device.gpu.device;
    this.maxTextures = Math.min(
      e.limits.maxSampledTexturesPerShaderStage,
      e.limits.maxSamplersPerShaderStage
    ), this.maxBatchableTextures = this.maxTextures, this._detectOverrideConstantsSupport(e);
  }
  _detectOverrideConstantsSupport(e) {
    e.pushErrorScope("validation");
    const t = e.createShaderModule({
      code: `override TEST_VALUE: f32 = 0.0;
@compute @workgroup_size(1) fn main() {}`
    });
    e.createComputePipeline({
      layout: "auto",
      compute: {
        module: t,
        entryPoint: "main",
        constants: { TEST_VALUE: 1 }
      }
    }), e.popErrorScope().then((i) => {
      this.supportsOverrideConstants = !i;
    });
  }
  destroy() {
  }
}
kM.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "limits"
};
class _M {
  constructor(e) {
    this._renderer = e, e.renderTarget.onRenderTargetChange.add(this);
  }
  contextChange() {
    this._activeGpuRenderTarget = null;
  }
  onRenderTargetChange(e) {
    const t = this._renderer.renderTarget.getGpuRenderTarget(e);
    this._activeRenderTarget = e, this._activeGpuRenderTarget = t, this.setStencilMode(t.stencilMode, t.stencilReference);
  }
  setStencilMode(e, t) {
    var o;
    const i = (o = this._activeGpuRenderTarget) != null ? o : this._activeGpuRenderTarget = this._renderer.renderTarget.getGpuRenderTarget(this._activeRenderTarget);
    i.stencilMode = e, i.stencilReference = t;
    const s = this._renderer;
    s.pipeline.setStencilMode(e), s.encoder.setStencilReference(t);
  }
  destroy() {
    this._renderer.renderTarget.onRenderTargetChange.remove(this), this._renderer = null, this._activeRenderTarget = null, this._activeGpuRenderTarget = null;
  }
}
_M.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "stencil"
};
const tp = {
  i32: { align: 4, size: 4 },
  u32: { align: 4, size: 4 },
  f32: { align: 4, size: 4 },
  f16: { align: 2, size: 2 },
  "vec2<i32>": { align: 8, size: 8 },
  "vec2<u32>": { align: 8, size: 8 },
  "vec2<f32>": { align: 8, size: 8 },
  "vec2<f16>": { align: 4, size: 4 },
  "vec3<i32>": { align: 16, size: 12 },
  "vec3<u32>": { align: 16, size: 12 },
  "vec3<f32>": { align: 16, size: 12 },
  "vec3<f16>": { align: 8, size: 6 },
  "vec4<i32>": { align: 16, size: 16 },
  "vec4<u32>": { align: 16, size: 16 },
  "vec4<f32>": { align: 16, size: 16 },
  "vec4<f16>": { align: 8, size: 8 },
  "mat2x2<f32>": { align: 8, size: 16 },
  "mat2x2<f16>": { align: 4, size: 8 },
  "mat3x2<f32>": { align: 8, size: 24 },
  "mat3x2<f16>": { align: 4, size: 12 },
  "mat4x2<f32>": { align: 8, size: 32 },
  "mat4x2<f16>": { align: 4, size: 16 },
  "mat2x3<f32>": { align: 16, size: 32 },
  "mat2x3<f16>": { align: 8, size: 16 },
  "mat3x3<f32>": { align: 16, size: 48 },
  "mat3x3<f16>": { align: 8, size: 24 },
  "mat4x3<f32>": { align: 16, size: 64 },
  "mat4x3<f16>": { align: 8, size: 32 },
  "mat2x4<f32>": { align: 16, size: 32 },
  "mat2x4<f16>": { align: 8, size: 16 },
  "mat3x4<f32>": { align: 16, size: 48 },
  "mat3x4<f16>": { align: 8, size: 24 },
  "mat4x4<f32>": { align: 16, size: 64 },
  "mat4x4<f16>": { align: 8, size: 32 }
};
function oZ(n) {
  const e = n.map((i) => ({
    data: i,
    offset: 0,
    size: 0
  }));
  let t = 0;
  for (let i = 0; i < e.length; i++) {
    const s = e[i];
    let o = tp[s.data.type].size;
    const r = tp[s.data.type].align;
    if (!tp[s.data.type])
      throw new Error(`[Pixi.js] WebGPU UniformBuffer: Unknown type ${s.data.type}`);
    s.data.size > 1 && (o = Math.max(o, r) * s.data.size), t = Math.ceil(t / r) * r, s.size = o, s.offset = t, t += o;
  }
  return t = Math.ceil(t / 16) * 16, { uboElements: e, size: t };
}
function rZ(n, e) {
  const { size: t, align: i } = tp[n.data.type], s = (Math.max(t, i) - t) / 4, o = n.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
         v = uv.${n.data.name};
         ${e !== 0 ? `offset += ${e};` : ""}

         arrayOffset = offset;

         t = 0;

         for(var i=0; i < ${n.data.size}; i++)
         {
             for(var j = 0; j < ${t / 4}; j++)
             {
                 ${o}[arrayOffset++] = v[t++];
             }
             ${s !== 0 ? `arrayOffset += ${s};` : ""}
         }
     `;
}
function aZ(n) {
  return QT(
    n,
    dJ,
    rZ
  );
}
class SM extends JT {
  constructor() {
    super({
      createUboElements: oZ,
      generateUboSync: aZ
    });
  }
}
SM.extension = {
  type: [Ae.WebGPUSystem],
  name: "ubo"
};
const no = 128;
class TM {
  constructor(e) {
    this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._buffers = [], this._bindGroups = [], this._bufferResources = [], this._renderer = e, this._batchBuffer = new nZ({ minUniformOffsetAlignment: no });
    const t = 256 / no;
    for (let i = 0; i < t; i++) {
      let s = Et.UNIFORM | Et.COPY_DST;
      i === 0 && (s |= Et.COPY_SRC), this._buffers.push(new Gi({
        data: this._batchBuffer.data,
        usage: s
      }));
    }
  }
  renderEnd() {
    this._uploadBindGroups(), this._resetBindGroups();
  }
  _resetBindGroups() {
    this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._batchBuffer.clear();
  }
  // just works for single bind groups for now
  getUniformBindGroup(e, t) {
    if (!t && this._bindGroupHash[e.uid])
      return this._bindGroupHash[e.uid];
    this._renderer.ubo.ensureUniformGroup(e);
    const i = e.buffer.data, s = this._batchBuffer.addEmptyGroup(i.length);
    return this._renderer.ubo.syncUniformGroup(e, this._batchBuffer.data, s / 4), this._bindGroupHash[e.uid] = this._getBindGroup(s / no), this._bindGroupHash[e.uid];
  }
  getUboResource(e) {
    this._renderer.ubo.updateUniformGroup(e);
    const t = e.buffer.data, i = this._batchBuffer.addGroup(t);
    return this._getBufferResource(i / no);
  }
  getArrayBindGroup(e) {
    const t = this._batchBuffer.addGroup(e);
    return this._getBindGroup(t / no);
  }
  getArrayBufferResource(e) {
    const i = this._batchBuffer.addGroup(e) / no;
    return this._getBufferResource(i);
  }
  _getBufferResource(e) {
    if (!this._bufferResources[e]) {
      const t = this._buffers[e % 2];
      this._bufferResources[e] = new uy({
        buffer: t,
        offset: (e / 2 | 0) * 256,
        size: no
      });
    }
    return this._bufferResources[e];
  }
  _getBindGroup(e) {
    if (!this._bindGroups[e]) {
      const t = new Eo({
        0: this._getBufferResource(e)
      });
      this._bindGroups[e] = t;
    }
    return this._bindGroups[e];
  }
  _uploadBindGroups() {
    const e = this._renderer.buffer, t = this._buffers[0];
    t.update(this._batchBuffer.byteIndex), e.updateBuffer(t);
    const i = this._renderer.gpu.device.createCommandEncoder();
    for (let s = 1; s < this._buffers.length; s++) {
      const o = this._buffers[s];
      i.copyBufferToBuffer(
        e.getGPUBuffer(t),
        no,
        e.getGPUBuffer(o),
        0,
        this._batchBuffer.byteIndex
      );
    }
    this._renderer.gpu.device.queue.submit([i.finish()]);
  }
  destroy() {
    var e;
    for (let t = 0; t < this._bindGroups.length; t++)
      (e = this._bindGroups[t]) == null || e.destroy();
    this._bindGroups = null, this._bindGroupHash = null;
    for (let t = 0; t < this._buffers.length; t++)
      this._buffers[t].destroy();
    this._buffers = null;
    for (let t = 0; t < this._bufferResources.length; t++)
      this._bufferResources[t].destroy();
    this._bufferResources = null, this._batchBuffer.destroy(), this._renderer = null;
  }
}
TM.extension = {
  type: [
    Ae.WebGPUPipes
  ],
  name: "uniformBatch"
};
const f2 = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 2,
  "triangle-list": 3,
  "triangle-strip": 4
}, lZ = new _c({}), dZ = {
  "depth24plus-stencil8": { depth: !0, stencil: !0, index: 1 },
  depth24plus: { depth: !0, stencil: !1, index: 2 },
  depth32float: { depth: !0, stencil: !1, index: 3 },
  "depth32float-stencil8": { depth: !0, stencil: !0, index: 4 },
  depth16unorm: { depth: !0, stencil: !1, index: 5 },
  stencil8: { depth: !1, stencil: !0, index: 6 }
}, m2 = { depth: !1, stencil: !1, index: 0 };
function g2(n, e) {
  for (const [t, i] of Object.entries(e)) {
    const s = new RegExp(
      `override\\s+${t}\\s*:\\s*(\\w+)\\s*(?:=[^;]*)?;`
    );
    n = n.replace(s, (o, r) => {
      let a;
      return r === "u32" ? a = `${Math.trunc(i)}u` : r === "i32" ? a = `${Math.trunc(i)}` : a = Number.isInteger(i) ? `${i}.0` : `${i}`, `const ${t}: ${r} = ${a};`;
    });
  }
  return n;
}
function b2(n, e, t, i, s, o) {
  return n * 35184372088832 + e * 536870912 + o * 16384 + (t << 8) + (i << 3) + s;
}
const v2 = /* @__PURE__ */ Object.create(null);
let cZ = 0;
function y2(n) {
  let e = v2[n];
  return e === void 0 && (e = v2[n] = cZ++), e;
}
function uZ(n, e, t, i, s, o, r, a) {
  return a << 20 | o << 16 | s << 13 | t << 9 | n << 6 | r << 5 | i << 1 | e;
}
function hZ(n, e, t, i, s, o, r) {
  return r << 11 | o << 10 | s << 9 | i << 8 | t << 5 | e << 1 | n;
}
class MM {
  constructor(e) {
    this._moduleCache = /* @__PURE__ */ Object.create(null), this._bufferLayoutsCache = /* @__PURE__ */ Object.create(null), this._bindingNamesCache = /* @__PURE__ */ Object.create(null), this._pipeCache = /* @__PURE__ */ new Map(), this._pipeStateCaches = /* @__PURE__ */ Object.create(null), this._colorMask = 15, this._multisampleCount = 1, this._colorTargetCount = 1, this._colorFormat = "bgra8unorm", this._colorFormatId = y2("bgra8unorm"), this._depthStencilFormat = "depth24plus-stencil8", this._depthStencilFormatData = m2, this._depthReadOnly = !1, this._stencilReadOnly = !1, this._invertFrontFace = !1, this._renderer = e;
  }
  contextChange(e) {
    this._gpu = e, this._moduleCache = /* @__PURE__ */ Object.create(null), this._pipeStateCaches = /* @__PURE__ */ Object.create(null), this.setStencilMode(cn.DISABLED), this._updatePipeHash();
  }
  setMultisampleCount(e) {
    this._multisampleCount !== e && (this._multisampleCount = e, this._updatePipeHash());
  }
  setRenderTarget(e) {
    var i, s, o, r, a, l, d;
    const t = (i = e.colorAttachments[0]) == null ? void 0 : i.texture;
    this._multisampleCount = t != null && t.source.antialias ? 4 : 1, this._colorTargetCount = e.colorAttachments.length, this._colorFormat = (s = t == null ? void 0 : t.format) != null ? s : "bgra8unorm", this._colorFormatId = y2(this._colorFormat), this._depthStencilFormat = (o = e.depthStencilAttachment) == null ? void 0 : o.texture.format, this._depthStencilFormatData = dZ[this._depthStencilFormat] || m2, this._depthReadOnly = (a = (r = e.depthStencilAttachment) == null ? void 0 : r.depthReadOnly) != null ? a : !1, this._stencilReadOnly = (d = (l = e.depthStencilAttachment) == null ? void 0 : l.stencilReadOnly) != null ? d : this._depthReadOnly, this._invertFrontFace = this._renderer.renderTarget.isFrontFaceInverted(e, e.flipY), this._updatePipeHash();
  }
  setColorMask(e) {
    this._colorMask !== e && (this._colorMask = e, this._updatePipeHash());
  }
  setStencilMode(e) {
    this._stencilMode !== e && (this._stencilMode = e, this._stencilState = Yo[e], this._updatePipeHash());
  }
  /**
   * A packed key for everything a render bundle recorded right now would bake into itself: the
   * attachment state WebGPU validates when the bundle is executed (color format(s), color target
   * count, depth/stencil format, sample count, read-only aspects), plus the front-face winding
   * its pipelines capture — which WebGPU does *not* validate.
   *
   * Equal keys mean a bundle recorded then is compatible with, and correct for, the pass now;
   * different keys mean it has to be re-recorded before it is replayed. Comparing the two is
   * what {@link GpuEncoderSystem.isBundleValid} does.
   *
   * `colorMask` and `stencilMode` are deliberately left out, unlike the pipeline cache key: they
   * are ambient draw state a bundle bakes per-pipeline as it records, so their value at execute
   * time says nothing about whether the bundle is still good.
   */
  get bundleStateKey() {
    const e = this._depthStencilFormatData;
    return hZ(
      // normalize the raw sample count (1 or 4 — WebGPU's only renderable counts) to a
      // true single bit, so it cannot spill into the colorTargetCount field above it
      this._multisampleCount === 1 ? 0 : 1,
      this._colorTargetCount,
      e.index,
      // the same two flags getBundleDescriptor sets — keep them in step
      e.depth && this._depthReadOnly ? 1 : 0,
      e.stencil && this._stencilReadOnly ? 1 : 0,
      this._invertFrontFace ? 1 : 0,
      this._colorFormatId
    );
  }
  /**
   * Builds a `GPURenderBundleEncoderDescriptor` that matches the current render target
   * configuration (color formats, sample count, depth/stencil format, and which of its aspects
   * are read-only).
   * Used by {@link GpuEncoderSystem.beginBundle} to create a compatible render bundle encoder.
   * @returns A descriptor for creating a GPURenderBundleEncoder.
   */
  getBundleDescriptor() {
    const e = [];
    for (let s = 0; s < this._colorTargetCount; s++)
      e.push(this._colorFormat);
    const t = {
      colorFormats: e,
      sampleCount: this._multisampleCount
    }, i = this._depthStencilFormatData;
    return (i.depth || i.stencil) && (t.depthStencilFormat = this._depthStencilFormat, i.depth && this._depthReadOnly && (t.depthReadOnly = !0), i.stencil && this._stencilReadOnly && (t.stencilReadOnly = !0)), t;
  }
  setPipeline(e, t, i, s) {
    const o = this.getPipeline(e, t, i);
    s.setPipeline(o);
  }
  /**
   * Generates a key for the pipeline.advanced usage only.
   * @param geometry - The geometry to get the key for
   * @param program - The program to get the key for
   * @param state - The state to get the key for
   * @param topology - The topology to get the key for
   * @param overrides - The overrides to get the key for
   * @returns The key for the pipeline
   */
  getPipelineKey(e, t, i, s, o) {
    return e._layoutKey || (Gv(e, t.attributeData), this._generateBufferKey(e)), b2(
      e._layoutKey,
      t._layoutKey,
      i.data,
      i._blendModeId,
      f2[s],
      o.id
    );
  }
  getPipeline(e, t, i, s, o) {
    e._layoutKey || (Gv(e, t.attributeData), this._generateBufferKey(e)), s || (s = e.topology), o || (o = lZ);
    const r = b2(
      e._layoutKey,
      t._layoutKey,
      i.data,
      i._blendModeId,
      f2[s],
      o.id
    );
    let a = this._pipeCache.get(r);
    return a || (a = this._createPipeline(e, t, i, s, o), this._pipeCache.set(r, a)), a;
  }
  _createPipeline(e, t, i, s, o) {
    const r = this._gpu.device, a = this._createVertexBufferLayouts(e, t), l = this._renderer.state.getColorTargets(i, this._colorTargetCount, this._colorFormat), d = this._stencilMode === cn.RENDERING_MASK_ADD ? 0 : this._colorMask;
    for (let k = 0; k < l.length; k++)
      l[k].writeMask = d;
    const c = this._renderer.shader.getProgramData(t).pipeline, u = Object.keys(o.data).length > 0;
    let p = t.vertex.source, f = t.fragment.source, y;
    u && (this._renderer.limits.supportsOverrideConstants ? y = o.data : (p = g2(p, o.data), f = g2(f, o.data)));
    const b = {
      // TODO later check if its helpful to create..
      // layout,
      vertex: {
        module: this._getModule(p),
        entryPoint: t.vertex.entryPoint,
        constants: y,
        buffers: a
      },
      fragment: {
        module: this._getModule(f),
        entryPoint: t.fragment.entryPoint,
        targets: l,
        constants: y
      },
      primitive: {
        topology: s,
        // Mirror WebGL's split: `gl.cullFace` is left at its `BACK` default, so the back is always
        // the culled side. Taking this from `state.cullMode` instead folds the winding into *which
        // side* is culled — the same triangles survive, but `@builtin(front_facing)` then reports
        // the opposite of `gl_FrontFacing` for clockwise-wound geometry.
        cullMode: i.culling ? "back" : "none",
        // The winding is stated once, here, exactly as `gl.frontFace` does it. `flipY` inverts the
        // projection (see setRenderTarget), so inverting the winding alongside it makes the two
        // cancel and a front face stays a front face. Both flags are part of the pipeline cache key.
        frontFace: i.clockwiseFrontFace !== this._invertFrontFace ? "cw" : "ccw"
      },
      layout: c,
      multisample: {
        count: this._multisampleCount
      },
      // depthStencil,
      label: t.name ? `PIXI Pipeline (${t.name})` : "PIXI Pipeline"
    };
    if (this._depthStencilFormatData.depth || this._depthStencilFormatData.stencil) {
      const k = this._depthStencilFormatData;
      b.depthStencil = {
        ...this._stencilState,
        format: this._depthStencilFormat,
        depthWriteEnabled: k.depth ? i.depthMask && !this._depthReadOnly : !1,
        depthCompare: k.depth && i.depthTest ? "less" : "always"
      };
    }
    return r.createRenderPipeline(b);
  }
  _getModule(e) {
    return this._moduleCache[e] || this._createModule(e);
  }
  _createModule(e) {
    const t = this._gpu.device;
    return this._moduleCache[e] = t.createShaderModule({
      code: e
    }), this._moduleCache[e];
  }
  /**
   * Generates and caches a numeric layout key on the geometry based on its sorted attribute
   * descriptors (offset, format, stride, instancing). Geometries with identical attribute
   * layouts share the same key, enabling pipeline reuse.
   * @param geometry - The geometry to generate a layout key for.
   */
  _generateBufferKey(e) {
    const t = [];
    let i = 0;
    const s = Object.keys(e.attributes).sort();
    for (let r = 0; r < s.length; r++) {
      const a = e.attributes[s[r]];
      t[i++] = a.offset, t[i++] = a.format, t[i++] = a.stride, t[i++] = a.instance;
    }
    const o = t.join("|");
    return e._layoutKey = vl(o, "geometry"), e._layoutKey;
  }
  _generateAttributeLocationsKey(e) {
    const t = [];
    let i = 0;
    const s = Object.keys(e.attributeData).sort();
    for (let r = 0; r < s.length; r++) {
      const a = e.attributeData[s[r]];
      t[i++] = a.location;
    }
    const o = t.join("|");
    return e._attributeLocationsKey = vl(o, "programAttributes"), e._attributeLocationsKey;
  }
  /**
   * Returns the buffer names to bind, one per vertex buffer slot.
   * This is used to bind the correct buffer to the correct location in the shader.
   * @param geometry - The geometry where to get the buffer names
   * @param program - The program where to get the buffer names
   * @returns The buffer names, indexed by vertex buffer slot.
   */
  getBufferNamesToBind(e, t) {
    const i = e._layoutKey << 16 | t._attributeLocationsKey;
    if (this._bindingNamesCache[i]) return this._bindingNamesCache[i];
    const s = this._createVertexBufferLayouts(e, t), o = [], r = t.attributeData;
    for (let a = 0; a < s.length; a++) {
      const d = Object.values(s[a].attributes)[0].shaderLocation;
      for (const c in r)
        if (r[c].location === d) {
          o[a] = c;
          break;
        }
    }
    return this._bindingNamesCache[i] = o, o;
  }
  _createVertexBufferLayouts(e, t) {
    t._attributeLocationsKey || this._generateAttributeLocationsKey(t);
    const i = e._layoutKey << 16 | t._attributeLocationsKey;
    if (this._bufferLayoutsCache[i])
      return this._bufferLayoutsCache[i];
    const s = [];
    return e.buffers.forEach((o) => {
      var l;
      const r = {
        arrayStride: 0,
        stepMode: "vertex",
        attributes: []
      }, a = r.attributes;
      for (const d in t.attributeData) {
        const c = e.attributes[d];
        ((l = c.divisor) != null ? l : 1) !== 1 && at(`Attribute ${d} has an invalid divisor value of '${c.divisor}'. WebGPU only supports a divisor value of 1`), c.buffer === o && (r.arrayStride = c.stride, r.stepMode = c.instance ? "instance" : "vertex", a.push({
          shaderLocation: t.attributeData[d].location,
          offset: c.offset,
          format: c.format
        }));
      }
      a.length && s.push(r);
    }), this._bufferLayoutsCache[i] = s, s;
  }
  _updatePipeHash() {
    var i;
    var e;
    const t = uZ(
      this._stencilMode,
      // normalize the raw sample count (1 or 4 — WebGPU's only renderable counts) to a
      // true single bit, so it cannot spill into the colorTargetCount field above it
      this._multisampleCount === 1 ? 0 : 1,
      this._colorMask,
      this._colorTargetCount,
      this._depthStencilFormatData.index,
      this._colorFormatId,
      this._depthReadOnly ? 1 : 0,
      this._invertFrontFace ? 1 : 0
    );
    this._pipeCache = (i = (e = this._pipeStateCaches)[t]) != null ? i : e[t] = /* @__PURE__ */ new Map();
  }
  destroy() {
    this._bufferLayoutsCache = null, this._pipeCache = null, this._gpu = null, this._renderer = null, this._bindingNamesCache = null, this._pipeStateCaches = null, this._moduleCache = null;
  }
}
MM.extension = {
  type: [Ae.WebGPUSystem],
  name: "pipeline"
};
class pZ {
  constructor(e) {
    this._pipelines = /* @__PURE__ */ Object.create(null), this._modules = /* @__PURE__ */ Object.create(null), this._bindGroups = /* @__PURE__ */ new WeakMap(), this._renderer = e, this._device = e.gpu.device, this._layout = this._device.createBindGroupLayout({
      entries: [{
        binding: 0,
        visibility: GPUShaderStage.FRAGMENT,
        texture: { sampleType: "unfilterable-float" }
      }]
    }), this._pipelineLayout = this._device.createPipelineLayout({ bindGroupLayouts: [this._layout] });
  }
  /**
   * Copies one colour attachment's resolved image into the target's back texture, creating it on first use
   * at the attachment's size and format. Must be recorded outside a render pass.
   * @param commandEncoder - the encoder to record the copy on
   * @param renderTarget - the target being reopened
   * @param index - the colour attachment to copy
   * @param resolved - the attachment's resolved texture
   */
  copy(e, t, i, s) {
    var d;
    var o;
    const r = this._renderer.renderTarget.getGpuRenderTarget(t), a = t.colorAttachments[i].texture;
    (d = (o = r.msaaBackTextures)[i]) != null || (o[i] = new an({
      label: "msaa-back-texture",
      width: a.width,
      height: a.height,
      resolution: a._resolution,
      format: r.msaaTextures[i].format,
      autoGenerateMipmaps: !1,
      // every restore copies into it afresh, so an idle one can be freed and re-created on the next restore
      autoGarbageCollect: !0
    }));
    const l = this._renderer.texture.getGpuSource(r.msaaBackTextures[i]);
    e.copyTextureToTexture(
      { texture: s },
      { texture: l },
      { width: Math.min(s.width, l.width), height: Math.min(s.height, l.height) }
    );
  }
  /**
   * Draws one colour attachment's back texture into the multisampled buffer. Must be the first draw of the
   * pass, before any viewport or scissor is set.
   * @param pass - the pass that was just begun
   * @param renderTarget - the target the pass renders to
   * @param index - the colour attachment to restore, copied by {@link GpuMsaaRestore.copy}
   */
  draw(e, t, i) {
    var c, u, p, f;
    var s;
    const o = this._renderer.renderTarget.getGpuRenderTarget(t), r = this._renderer.texture.getGpuSource(o.msaaBackTextures[i]);
    let a = (u = (c = t.depthStencilAttachment) == null ? void 0 : c.texture.format) != null ? u : "";
    for (const y of t.colorAttachments)
      a += `|${y.texture.format}`;
    const l = (p = (s = this._pipelines)[a]) != null ? p : s[a] = [];
    let d = this._bindGroups.get(r);
    d || (d = this._device.createBindGroup({
      layout: this._layout,
      entries: [{ binding: 0, resource: r.createView() }]
    }), this._bindGroups.set(r, d)), e.setPipeline((f = l[i]) != null ? f : l[i] = this._createPipeline(t, i)), e.setBindGroup(0, d), e.draw(3);
  }
  _getModule(e) {
    var i;
    var t;
    return (i = (t = this._modules)[e]) != null || (t[e] = this._device.createShaderModule({
      label: "msaa-restore",
      code: (
        /* wgsl */
        `
                @group(0) @binding(0) var resolved: texture_2d<f32>;

                @vertex
                fn vertexMain(@builtin(vertex_index) i: u32) -> @builtin(position) vec4<f32> {
                    let pos = array<vec2<f32>, 3>(vec2<f32>(-1.0, -1.0), vec2<f32>(3.0, -1.0), vec2<f32>(-1.0, 3.0));

                    return vec4<f32>(pos[i], 0.0, 1.0);
                }

                @fragment
                fn fragmentMain(@builtin(position) position: vec4<f32>) -> @location(${e}) vec4<f32> {
                    return textureLoad(resolved, vec2<i32>(position.xy), 0);
                }
            `
      )
    })), this._modules[e];
  }
  _createPipeline(e, t) {
    var r;
    const i = (r = e.depthStencilAttachment) == null ? void 0 : r.texture.format;
    let s;
    i && (s = { format: i }, i.includes("depth") && (s.depthWriteEnabled = !1, s.depthCompare = "always"));
    const o = this._getModule(t);
    return this._device.createRenderPipeline({
      label: "msaa-restore",
      layout: this._pipelineLayout,
      vertex: { module: o, entryPoint: "vertexMain" },
      fragment: {
        module: o,
        entryPoint: "fragmentMain",
        // every attachment must be declared to match the pass; only the restored one is written
        targets: e.colorAttachments.map((a, l) => ({
          format: a.texture.format,
          writeMask: l === t ? GPUColorWrite.ALL : 0
        }))
      },
      depthStencil: s,
      multisample: { count: 4 }
    });
  }
}
class fZ {
  constructor() {
    this.contexts = [], this.canvasTextures = [], this.msaaTextures = [], this.transient = !1, this.msaaSamples = 1, this.msaaBackTextures = [], this.stencilMode = cn.DISABLED, this.stencilReference = 0, this.maskStackIndex = 0;
  }
}
const mZ = {
  bgra8unorm: !0,
  rgba8unorm: !0,
  rgba16float: !0
};
function gZ(n) {
  if (mZ[n]) return n;
  const e = navigator.gpu.getPreferredCanvasFormat();
  return at(`[WebGPU] CanvasSource format '${n}' is not a valid GPUCanvasContext format. Falling back to '${e}'. Allowed formats are: bgra8unorm, rgba8unorm, rgba16float.`), e;
}
class bZ {
  constructor() {
    this._activePass = null;
  }
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t, e.runners.contextChange.add(this), e.runners.destroy.add(this);
  }
  /** Drops the restore helper, whose pipelines belong to the old device. The next restore makes a new one. */
  contextChange() {
    this._msaaRestore = null;
  }
  destroy() {
    this._msaaRestore = null;
  }
  copyToTexture(e, t, i, s, o) {
    const r = this._renderer;
    this.finishRenderPass();
    const a = this._getGpuColorTexture(
      e
    ), l = r.texture.getGpuSource(
      t.source
    );
    return r.encoder.commandEncoder.copyTextureToTexture(
      {
        texture: a,
        origin: i
      },
      {
        texture: l,
        origin: o
      },
      s
    ), t;
  }
  copyDepthTexture(e, t, i, s, o) {
    const r = this._renderer;
    this.finishRenderPass();
    const a = e.depthStencilAttachment.texture, l = r.texture.getGpuSource(a), d = r.texture.getGpuSource(t.source), c = r.encoder.commandEncoder === null, u = c ? r.gpu.device.createCommandEncoder() : r.encoder.commandEncoder;
    u.copyTextureToTexture(
      { texture: l, origin: i },
      { texture: d, origin: o },
      { width: s.width, height: s.height }
    ), c && r.gpu.device.queue.submit([u.finish()]);
  }
  startRenderPass(e, t = !0, i, s, o = 0, r = 0) {
    var w, k;
    const l = this._renderTargetSystem.getGpuRenderTarget(e);
    if (r !== 0 && ((w = l.msaaTextures) != null && w.length))
      throw new Error("[RenderTargetSystem] Rendering to array layers is not supported with MSAA render targets.");
    if (o > 0 && ((k = l.msaaTextures) != null && k.length))
      throw new Error("[RenderTargetSystem] Rendering to mip levels is not supported with MSAA render targets.");
    let d = t;
    typeof d == "boolean" && (d = d ? wn.ALL : wn.NONE), (e.stencil || e.depth) && !e.depthStencilAttachment && e.ensureDepthStencilTexture();
    const c = !!e.depthStencilAttachment, u = this._activePass, p = u !== null && u.renderTarget === e && u.mipLevel === o && u.layer === r && u.depthStencil === c && this._renderer.encoder.renderPassEncoder !== null && d === wn.NONE;
    if (this._renderer.pipeline.setRenderTarget(e), p) {
      this._renderer.encoder.setViewport(s);
      return;
    }
    const { descriptor: f, restore: y } = this._buildDescriptor(e, t, i, o, r);
    l.descriptor = f;
    const b = this._renderer.encoder;
    y ? (b.endRenderPass(), this._beginRestoredPass(
      e,
      y,
      b.commandEncoder,
      () => b.beginRenderPass(l)
    )) : b.beginRenderPass(l), b.setViewport(s), this._activePass = { renderTarget: e, mipLevel: o, layer: r, depthStencil: c };
  }
  finishRenderPass() {
    this._renderer.encoder.endRenderPass(), this._activePass = null;
  }
  /**
   * Begins a pass whose MSAA colour must be restored: copies each resolved texture in `restore` into the
   * target's back textures, begins the pass, and draws them back in before anything else (see GpuMsaaRestore).
   * @param renderTarget - the target being reopened
   * @param restore - the colour attachments to restore
   * @param commandEncoder - the encoder to record the copies on, with no pass open
   * @param beginPass - begins the pass on the same encoder
   * @returns the begun pass
   */
  _beginRestoredPass(e, t, i, s) {
    var a;
    const o = (a = this._msaaRestore) != null ? a : this._msaaRestore = new pZ(this._renderer);
    for (const l of t)
      o.copy(i, e, l, this._getGpuColorTexture(e, l));
    const r = s();
    for (const l of t)
      o.draw(r, e, l);
    return r;
  }
  /**
   * returns the gpu texture for a color texture in the render target, the first by default
   * mainly used by the filter manager to copy the texture for blending
   * @param renderTarget
   * @param index - the color attachment to get
   * @returns a gpu texture
   */
  _getGpuColorTexture(e, t = 0) {
    if (e.colorAttachments.length === 0)
      throw new Error("[GpuRenderTargetAdaptor] cannot get gpu color texture from a depth-only render target");
    const i = e.colorAttachments[t].texture;
    return i instanceof ki && i._gpuContext ? i._gpuContext.getCurrentTexture() : this._renderer.texture.getGpuSource(i);
  }
  getDescriptor(e, t, i, s = 0, o = 0) {
    return this._buildDescriptor(e, t, i, s, o).descriptor;
  }
  /**
   * Builds the pass descriptor, along with the MSAA colour attachments it opens with `clear` in place of
   * `load`. Those buffers were discarded, so the pass must restore them before drawing.
   * @param renderTarget - the target to render to
   * @param clear - what to clear
   * @param clearValue - the colour to clear to
   * @param mipLevel - the mip level to render to
   * @param layer - the array layer to render to
   */
  _buildDescriptor(e, t, i, s = 0, o = 0) {
    var p, f, y, b, w, k, S, _;
    let r = null;
    typeof t == "boolean" && (t = t ? wn.ALL : wn.NONE);
    const a = this._renderTargetSystem, l = a.getGpuRenderTarget(e), d = e.colorAttachments.map(
      (x, T) => {
        var W, ee;
        const M = x.texture, z = M instanceof ki ? M._gpuContext : null;
        let P, D, $ = !1;
        if (z) {
          if (o !== 0)
            throw new Error("[RenderTargetSystem] Rendering to array layers is not supported for canvas targets.");
          const N = z.getCurrentTexture();
          $ = l.canvasTextures[T] !== N, l.canvasTextures[T] = N, P = N.createView(x.viewDescriptor);
        } else
          P = this._renderer.texture.getTextureRenderTargetView(
            x.texture,
            s,
            o,
            x.viewDescriptor
          );
        const O = l.msaaTextures[T];
        O && (D = P, P = this._renderer.texture.getTextureView(O));
        let L = x.loadOp;
        t !== void 0 && (L = t & wn.COLOR ? "clear" : "load"), i != null || (i = a.defaultClearColor);
        const Z = !!(O != null && O.transient), J = Z && L !== "clear", re = J && !$;
        J && (L = "clear", re && (r != null ? r : r = []).push(T));
        const F = {
          view: P,
          resolveTarget: D,
          storeOp: Z ? "discard" : (W = x.storeOp) != null ? W : "store",
          loadOp: L
        };
        M.dimension === "3d" && (F.depthSlice = o), J ? F.clearValue = [0, 0, 0, 0] : L === "clear" && (i != null || (i = (ee = x.clearValue) != null ? ee : a.defaultClearColor), F.clearValue = i);
        for (const N in x)
          N !== "texture" && N !== "viewDescriptor" && N !== "clearValue" && N !== "loadOp" && N !== "storeOp" && (F[N] = x[N]);
        return F;
      }
    );
    let c;
    if (e.depthStencilAttachment) {
      this._prepareDepthStencil(e, l);
      const x = e.depthStencilAttachment, T = x.texture.format.includes("stencil"), M = x.texture.format.includes("depth"), z = l.transient ? "discard" : "store", P = l.transient ? "clear" : "load";
      c = {
        view: this._renderer.texture.getTextureRenderTargetView(
          x.texture,
          s,
          o,
          x.viewDescriptor
        )
      };
      const D = (p = x.depthReadOnly) != null ? p : !1, $ = (f = x.stencilReadOnly) != null ? f : D;
      T && !$ ? (c.stencilLoadOp = t & wn.STENCIL ? "clear" : (y = x.stencilLoadOp) != null ? y : P, c.stencilStoreOp = (b = x.stencilStoreOp) != null ? b : z, c.stencilLoadOp === "clear" && (c.stencilClearValue = (w = x.stencilClearValue) != null ? w : 0)) : T && $ && (c.stencilReadOnly = !0), M && !D ? (c.depthLoadOp = t & wn.DEPTH ? "clear" : (k = x.depthLoadOp) != null ? k : P, c.depthStoreOp = (S = x.depthStoreOp) != null ? S : z, c.depthLoadOp === "clear" && (c.depthClearValue = (_ = x.depthClearValue) != null ? _ : 1)) : M && D && (c.depthReadOnly = !0);
      for (const O in x)
        O !== "texture" && O !== "viewDescriptor" && O !== "stencilLoadOp" && O !== "stencilStoreOp" && O !== "stencilClearValue" && O !== "stencilReadOnly" && O !== "depthLoadOp" && O !== "depthStoreOp" && O !== "depthClearValue" && O !== "depthReadOnly" && (c[O] = x[O]);
    }
    return { descriptor: {
      colorAttachments: d,
      depthStencilAttachment: c,
      label: e.label
    }, restore: r };
  }
  clear(e, t = !0, i, s, o = 0, r = 0) {
    if (!t) return;
    const { gpu: a, encoder: l } = this._renderer, d = a.device;
    if (l.commandEncoder === null) {
      const u = d.createCommandEncoder(), { descriptor: p, restore: f } = this._buildDescriptor(e, t, i, o, r), y = () => u.beginRenderPass(p), b = f ? this._beginRestoredPass(e, f, u, y) : y();
      b.setViewport(s.x, s.y, s.width, s.height, 0, 1), b.end();
      const w = u.finish();
      d.queue.submit([w]);
    } else
      this.startRenderPass(e, t, i, s, o, r);
  }
  initGpuRenderTarget(e) {
    var i;
    e.isRoot = !0;
    const t = new fZ();
    return t.transient = !!((i = e.colorTexture) != null && i.antialias) && !!e.colorTexture.transient, e.colorAttachments.forEach((s, o) => {
      var a;
      const r = s.texture;
      if (r instanceof ki) {
        const l = (a = r._gpuContext) != null ? a : r._gpuContext = r.resource.getContext(
          "webgpu"
        ), d = r.transparent ? "premultiplied" : "opaque", c = gZ(r.format);
        try {
          l.configure({
            device: this._renderer.gpu.device,
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
            format: c,
            alphaMode: d,
            ...c === "rgba16float" ? { toneMapping: { mode: "extended" } } : {}
          });
        } catch (u) {
          console.error(u);
        }
        t.contexts[o] = l;
      }
      if (t.msaa = r.source.antialias, r.antialias) {
        const l = new an({
          width: 0,
          height: 0,
          sampleCount: 4,
          // WebGPU requires multisampled textures to have exactly 1 mip level, so this must never
          // inherit TextureSource.defaultOptions.autoGenerateMipmaps
          autoGenerateMipmaps: !1,
          transient: this._renderer.device.extensions.tileBased || t.transient,
          arrayLayerCount: r.arrayLayerCount,
          format: r.format
        });
        t.msaaTextures[o] = l;
      }
    }), t.msaa && (t.msaaSamples = 4), t;
  }
  /**
   * Sets up a depth/stencil texture for an MSAA target before its GPU texture is created: 4 samples, and
   * the transient usage bit when the user marked the target single-pass. Both are fixed at creation, so this
   * runs when a pass descriptor is built, just before the depth/stencil view is first made.
   * @param renderTarget - the target whose depth/stencil texture to set up
   * @param gpuRenderTarget - its backend target
   */
  _prepareDepthStencil(e, t) {
    var s;
    const i = (s = e.depthStencilAttachment) == null ? void 0 : s.texture;
    !i || !t.msaa || (i.sampleCount = 4, i.transient = t.transient);
  }
  destroyGpuRenderTarget(e) {
    e.contexts.forEach((t) => {
      t.unconfigure();
    }), e.msaaTextures.forEach((t) => {
      t.destroy();
    }), e.msaaBackTextures.forEach((t) => {
      t == null || t.destroy();
    }), e.msaaTextures.length = 0, e.msaaBackTextures.length = 0, e.contexts.length = 0;
  }
  ensureDepthStencilTexture(e) {
    this._prepareDepthStencil(e, this._renderTargetSystem.getGpuRenderTarget(e));
  }
  resizeGpuRenderTarget(e) {
    const t = this._renderTargetSystem.getGpuRenderTarget(e);
    t.width = e.width, t.height = e.height, t.msaa && e.colorAttachments.forEach((i, s) => {
      var r, a;
      const o = i.texture;
      (r = t.msaaTextures[s]) == null || r.resize(o.width, o.height, o._resolution), (a = t.msaaBackTextures[s]) == null || a.resize(
        o.width,
        o.height,
        o._resolution
      );
    });
  }
}
class CM extends ly {
  constructor(e) {
    super(e), this.adaptor = new bZ(), this.adaptor.init(e, this);
  }
}
CM.extension = {
  type: [Ae.WebGPUSystem],
  name: "renderTarget"
};
class IM {
  constructor() {
    this._gpuProgramData = /* @__PURE__ */ Object.create(null);
  }
  contextChange(e) {
    this._gpu = e, this._gpuProgramData = /* @__PURE__ */ Object.create(null);
  }
  getProgramData(e) {
    return this._gpuProgramData[e._layoutKey] || this._createGPUProgramData(e);
  }
  _createGPUProgramData(e) {
    const t = this._gpu.device, i = e.gpuLayout.map((o) => t.createBindGroupLayout({ entries: o })), s = { bindGroupLayouts: i };
    return this._gpuProgramData[e._layoutKey] = {
      bindGroups: i,
      pipeline: t.createPipelineLayout(s)
    }, this._gpuProgramData[e._layoutKey];
  }
  destroy() {
    this._gpu = null, this._gpuProgramData = null;
  }
}
IM.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "shader"
};
const ai = {};
ai.normal = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
ai.add = {
  alpha: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  }
};
ai.multiply = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "dst",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
ai.screen = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
ai.overlay = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
ai.none = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "zero",
    operation: "add"
  }
};
ai["normal-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
ai["add-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one",
    operation: "add"
  }
};
ai["screen-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
ai.erase = {
  alpha: {
    srcFactor: "zero",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
ai.min = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  }
};
ai.max = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  }
};
class AM {
  constructor() {
    this.defaultState = new Zs(), this.defaultState.blend = !0;
  }
  contextChange(e) {
    this.gpu = e;
  }
  /**
   * Gets the blend mode data for the current state
   * @param state - The state to get the blend mode from
   * @param count - The number of color targets to create
   * @param format - The texture format of the color attachments (assumed uniform across attachments)
   */
  getColorTargets(e, t, i) {
    const s = e.blend ? ai[e.blendMode] || ai.normal : void 0, o = [];
    for (let r = 0; r < t; r++)
      o[r] = {
        format: i,
        writeMask: 0,
        blend: s
      };
    return o;
  }
  destroy() {
    this.gpu = null;
  }
}
AM.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "state"
};
const x2 = [new _t(), new _t(), new _t()], vZ = {
  type: "image",
  upload(n, e, t, i = 0) {
    const s = n.resource, o = n.pixelWidth | 0, r = n.pixelHeight | 0, a = n.depthOrArrayLayers, l = s.byteLength / (o * r * a);
    if (a > 1) {
      t.device.queue.writeTexture(
        { texture: e, origin: { x: 0, y: 0, z: i } },
        s,
        { offset: 0, rowsPerImage: r, bytesPerRow: o * l },
        { width: o, height: r, depthOrArrayLayers: a }
      );
      return;
    }
    const d = lM(n._updateStart, n._updateEnd, o, r, x2);
    for (let c = 0; c < d; c++) {
      const u = x2[c];
      t.device.queue.writeTexture(
        { texture: e, origin: { x: u.x, y: u.y, z: i } },
        s,
        {
          offset: (u.y * o + u.x) * l,
          rowsPerImage: u.height,
          bytesPerRow: o * l
        },
        {
          width: u.width,
          height: u.height,
          depthOrArrayLayers: 1
        }
      );
    }
  }
}, PM = {
  "bc1-rgba-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "bc2-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc3-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc7-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "etc1-rgb-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "etc2-rgba8unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "astc-4x4-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 }
}, yZ = { blockBytes: 4, blockWidth: 1, blockHeight: 1 }, xZ = {
  type: "compressed",
  upload(n, e, t, i = 0) {
    let s = n.pixelWidth, o = n.pixelHeight;
    const r = PM[n.format] || yZ;
    for (let a = 0; a < n.resource.length; a++) {
      const l = n.resource[a], d = Math.ceil(s / r.blockWidth) * r.blockBytes;
      t.device.queue.writeTexture(
        {
          texture: e,
          mipLevel: a,
          origin: { x: 0, y: 0, z: i }
        },
        l,
        {
          offset: 0,
          bytesPerRow: d
        },
        {
          width: Math.ceil(s / r.blockWidth) * r.blockWidth,
          height: Math.ceil(o / r.blockHeight) * r.blockHeight,
          depthOrArrayLayers: 1
        }
      ), s = Math.max(s >> 1, 1), o = Math.max(o >> 1, 1);
    }
  }
}, w2 = ["right", "left", "top", "bottom", "front", "back"];
function wZ(n) {
  return {
    type: "cube",
    upload(e, t, i) {
      const s = e.faces;
      for (let o = 0; o < w2.length; o++) {
        const r = w2[o], a = s[r];
        (n[a.uploadMethodId] || n.image).upload(a, t, i, o);
      }
    }
  };
}
const EM = {
  type: "image",
  upload(n, e, t, i = 0) {
    const s = n.resource;
    if (!s) return;
    if (globalThis.HTMLImageElement && s instanceof HTMLImageElement) {
      const l = Pt.get().createCanvas(s.width, s.height);
      l.getContext("2d").drawImage(s, 0, 0, s.width, s.height), n.resource = l, at("ImageSource: Image element passed, converting to canvas and replacing resource.");
    }
    const o = Math.min(e.width, n.resourceWidth || n.pixelWidth), r = Math.min(e.height, n.resourceHeight || n.pixelHeight), a = n.alphaMode === "premultiply-alpha-on-upload";
    t.device.queue.copyExternalImageToTexture(
      { source: s },
      { texture: e, origin: { x: 0, y: 0, z: i }, premultipliedAlpha: a },
      {
        width: o,
        height: r
      }
    );
  }
}, kZ = {
  type: "video",
  upload(n, e, t, i) {
    EM.upload(n, e, t, i);
  }
}, k2 = ["rgba8unorm", "rgba16float"], ga = 4;
function RM(n, e) {
  if (!e)
    throw new Error("[Gpu3dMipmapGenerator] generating mipmaps for a 3D texture needs storage: true.");
  if (!k2.includes(n))
    throw new Error(`[Gpu3dMipmapGenerator] format '${n}' can't be downsampled. Use ${k2.join(", ")}.`);
}
class _Z {
  constructor(e) {
    this._pipelines = {}, this._device = e, this._sampler = e.createSampler({
      magFilter: "linear",
      minFilter: "linear"
    });
  }
  _getMipmapPipeline(e) {
    var i;
    var t;
    return (i = (t = this._pipelines)[e]) != null || (t[e] = this._device.createComputePipeline({
      layout: "auto",
      compute: {
        module: this._device.createShaderModule({
          code: (
            /* wgsl */
            `
                        @group(0) @binding(0) var srcSampler : sampler;
                        @group(0) @binding(1) var src : texture_3d<f32>;
                        @group(0) @binding(2) var dst : texture_storage_3d<${e}, write>;

                        @compute @workgroup_size(${ga}, ${ga}, ${ga})
                        fn main(@builtin(global_invocation_id) gid : vec3<u32>) {
                            let dstSize = textureDimensions(dst);

                            if (gid.x >= dstSize.x || gid.y >= dstSize.y || gid.z >= dstSize.z) {
                                return;
                            }

                            // centre of the 2x2x2 footprint in the previous mip. When a dimension is
                            // odd its last texel, row or slice is never sampled, as in the 2D generator
                            let uv = (vec3<f32>(gid) * 2.0 + 1.0) / vec3<f32>(textureDimensions(src));

                            textureStore(dst, gid, textureSampleLevel(src, srcSampler, uv, 0.0));
                        }
                    `
          )
        }),
        entryPoint: "main"
      }
    })), this._pipelines[e];
  }
  /**
   * Fills mip levels 1..n of a 3D texture from level 0.
   * @param texture - a 3D texture with `STORAGE_BINDING` and more than one mip level
   */
  generateMipmap(e) {
    if (e.dimension !== "3d")
      throw new Error("[Gpu3dMipmapGenerator] generateMipmap expects a 3D texture.");
    if (e.mipLevelCount < 2) return;
    RM(e.format, (e.usage & GPUTextureUsage.STORAGE_BINDING) !== 0);
    const t = this._getMipmapPipeline(e.format), i = t.getBindGroupLayout(0), s = this._device.createCommandEncoder({ label: "Gpu3dMipmapGenerator" }), o = s.beginComputePass();
    o.setPipeline(t);
    let r = e.width, a = e.height, l = e.depthOrArrayLayers, d = e.createView({ dimension: "3d", baseMipLevel: 0, mipLevelCount: 1 });
    for (let c = 1; c < e.mipLevelCount; c++) {
      r = Math.max(1, r >> 1), a = Math.max(1, a >> 1), l = Math.max(1, l >> 1);
      const u = e.createView({ dimension: "3d", baseMipLevel: c, mipLevelCount: 1 });
      o.setBindGroup(0, this._device.createBindGroup({
        layout: i,
        entries: [
          { binding: 0, resource: this._sampler },
          { binding: 1, resource: d },
          { binding: 2, resource: u }
        ]
      })), o.dispatchWorkgroups(
        Math.ceil(r / ga),
        Math.ceil(a / ga),
        Math.ceil(l / ga)
      ), d = u;
    }
    o.end(), this._device.queue.submit([s.finish()]);
  }
}
class SZ {
  constructor(e) {
    this._pipelines = {}, this._device = e, this._sampler = e.createSampler({ minFilter: "linear" });
  }
  _getMipmapPipeline(e) {
    let t = this._pipelines[e];
    return t || (this._mipmapShaderModule || (this._mipmapShaderModule = this._device.createShaderModule({
      code: (
        /* wgsl */
        `
                        var<private> pos : array<vec2<f32>, 3> = array<vec2<f32>, 3>(
                        vec2<f32>(-1.0, -1.0), vec2<f32>(-1.0, 3.0), vec2<f32>(3.0, -1.0));

                        struct VertexOutput {
                        @builtin(position) position : vec4<f32>,
                        @location(0) texCoord : vec2<f32>,
                        };

                        @vertex
                        fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
                        var output : VertexOutput;
                        output.texCoord = pos[vertexIndex] * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5);
                        output.position = vec4<f32>(pos[vertexIndex], 0.0, 1.0);
                        return output;
                        }

                        @group(0) @binding(0) var imgSampler : sampler;
                        @group(0) @binding(1) var img : texture_2d<f32>;

                        @fragment
                        fn fragmentMain(@location(0) texCoord : vec2<f32>) -> @location(0) vec4<f32> {
                        return textureSample(img, imgSampler, texCoord);
                        }
                    `
      )
    })), t = this._device.createRenderPipeline({
      layout: "auto",
      vertex: {
        module: this._mipmapShaderModule,
        entryPoint: "vertexMain"
      },
      fragment: {
        module: this._mipmapShaderModule,
        entryPoint: "fragmentMain",
        targets: [{ format: e }]
      }
    }), this._pipelines[e] = t), t;
  }
  /**
   * Generates mipmaps for the given GPUTexture from the data in level 0.
   * @param {module:External.GPUTexture} texture - Texture to generate mipmaps for.
   * @returns {module:External.GPUTexture} - The originally passed texture
   */
  generateMipmap(e) {
    if (e.dimension === "3d")
      throw new Error("[GpuMipmapGenerator] a 3D texture uses Gpu3dMipmapGenerator.");
    if (e.dimension === "1d")
      throw new Error("Generating mipmaps for 1d textures is currently unsupported!");
    const t = this._getMipmapPipeline(e.format);
    let i = e;
    const s = e.depthOrArrayLayers || 1, o = e.usage & GPUTextureUsage.RENDER_ATTACHMENT;
    if (!o) {
      const l = {
        size: {
          width: Math.ceil(e.width / 2),
          height: Math.ceil(e.height / 2),
          depthOrArrayLayers: s
        },
        format: e.format,
        usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.RENDER_ATTACHMENT,
        mipLevelCount: e.mipLevelCount - 1
      };
      i = this._device.createTexture(l);
    }
    const r = this._device.createCommandEncoder({}), a = t.getBindGroupLayout(0);
    for (let l = 0; l < s; ++l) {
      let d = e.createView({
        baseMipLevel: 0,
        mipLevelCount: 1,
        dimension: "2d",
        baseArrayLayer: l,
        arrayLayerCount: 1
      }), c = o ? 1 : 0;
      for (let u = 1; u < e.mipLevelCount; ++u) {
        const p = i.createView({
          baseMipLevel: c++,
          mipLevelCount: 1,
          dimension: "2d",
          baseArrayLayer: l,
          arrayLayerCount: 1
        }), f = r.beginRenderPass({
          colorAttachments: [{
            view: p,
            storeOp: "store",
            loadOp: "clear",
            clearValue: { r: 0, g: 0, b: 0, a: 0 }
          }]
        }), y = this._device.createBindGroup({
          layout: a,
          entries: [{
            binding: 0,
            resource: this._sampler
          }, {
            binding: 1,
            resource: d
          }]
        });
        f.setPipeline(t), f.setBindGroup(0, y), f.draw(3, 1, 0, 0), f.end(), d = p;
      }
    }
    if (!o) {
      const l = {
        width: Math.ceil(e.width / 2),
        height: Math.ceil(e.height / 2),
        depthOrArrayLayers: s
      };
      for (let d = 1; d < e.mipLevelCount; ++d)
        r.copyTextureToTexture({
          texture: i,
          mipLevel: d - 1
        }, {
          texture: e,
          mipLevel: d
        }, l), l.width = Math.ceil(l.width / 2), l.height = Math.ceil(l.height / 2);
    }
    return this._device.queue.submit([r.finish()]), o || i.destroy(), e;
  }
}
class TZ {
  constructor(e) {
    this.textureView = null, this.textureViews = /* @__PURE__ */ Object.create(null), this.gpuTexture = e;
  }
  /** Destroys this GPU data instance. */
  destroy() {
    this.gpuTexture.destroy(), this.textureView = null, this.textureViews = null, this.gpuTexture = null;
  }
}
const MZ = /^(rgba8|bgra8|bc[1237]-rgba-|etc2-rgb8|etc2-rgb8a1|etc2-rgba8|astc-\d+x\d+-)unorm$/;
function CZ(n) {
  return MZ.test(n) ? [`${n}-srgb`] : void 0;
}
function _2(n) {
  return `${n.format || ""}.${n.dimension || ""}.${n.aspect || ""}.${n.baseMipLevel || 0}.${n.mipLevelCount || ""}.${n.baseArrayLayer || 0}.${n.arrayLayerCount || ""}`;
}
const fy = class zM {
  constructor(e) {
    this._gpuSamplers = /* @__PURE__ */ Object.create(null), this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._renderer = e, e.gc.addCollection(this, "_bindGroupHash", "hash"), this._managedTextures = new gs({
      renderer: e,
      type: "resource",
      onUnload: this.onSourceUnload.bind(this),
      name: "gpuTextureSource"
    });
    const t = {
      image: EM,
      buffer: vZ,
      video: kZ,
      compressed: xZ,
      ...zM.uploadExtensions
    };
    this._uploads = {
      ...t,
      cube: wZ(t)
    };
  }
  /**
   * @deprecated since 8.15.0
   */
  get managedTextures() {
    return Object.values(this._managedTextures.items);
  }
  contextChange(e) {
    this._gpu = e, this._managedTextures.removeAll(), this._gpuSamplers = /* @__PURE__ */ Object.create(null), this._mipmapGenerator = null, this._mipmap3dGenerator = null;
  }
  /**
   * Initializes a texture source, if it has already been initialized nothing will happen.
   * @param source - The texture source to initialize.
   * @returns The initialized texture source.
   */
  initSource(e) {
    var t;
    return ((t = e._gpuData[this._renderer.uid]) == null ? void 0 : t.gpuTexture) || this._initSource(e);
  }
  _initSource(e) {
    if (e.autoGenerateMipmaps) {
      e.dimension === "3d" && RM(e.format, e.storage);
      const c = Math.max(e.pixelWidth, e.pixelHeight, e.depth);
      e.mipLevelCount = Math.floor(Math.log2(c)) + 1;
    }
    let t, i;
    e.sampleCount > 1 ? (t = GPUTextureUsage.RENDER_ATTACHMENT, e.transient && this._renderer.device.extensions.transientAttachment && (t |= GPUTextureUsage.TRANSIENT_ATTACHMENT)) : (t = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST, e.uploadMethodId !== "compressed" && (t |= GPUTextureUsage.RENDER_ATTACHMENT, t |= GPUTextureUsage.COPY_SRC), e.storage && (t |= GPUTextureUsage.STORAGE_BINDING), i = CZ(e.format));
    const s = PM[e.format] || { blockWidth: 1, blockHeight: 1 }, o = Math.ceil(e.pixelWidth / s.blockWidth) * s.blockWidth, r = Math.ceil(e.pixelHeight / s.blockHeight) * s.blockHeight, a = {
      label: e.label,
      // WebGPU cube textures are 2D textures with 6 array layers and a cube view.
      size: { width: o, height: r, depthOrArrayLayers: e.depthOrArrayLayers },
      format: e.format,
      viewFormats: i,
      sampleCount: e.sampleCount,
      mipLevelCount: e.mipLevelCount,
      dimension: e.dimension,
      usage: t
    }, l = this._gpu.device.createTexture(a);
    return e._gpuData[this._renderer.uid] = new TZ(l), this._managedTextures.add(e) && (e.on("update", this.onSourceUpdate, this), e.on("resize", this.onSourceResize, this), e.on("updateMipmaps", this.onUpdateMipmaps, this)), this.onSourceUpdate(e), l;
  }
  onSourceUpdate(e) {
    const t = this.getGpuSource(e);
    t && (this._uploads[e.uploadMethodId] && this._uploads[e.uploadMethodId].upload(e, t, this._gpu), e.autoGenerateMipmaps && e.mipLevelCount > 1 && this.onUpdateMipmaps(e));
  }
  onUpdateMipmaps(e) {
    var i, s;
    const t = this.getGpuSource(e);
    if (e.dimension === "3d") {
      (i = this._mipmap3dGenerator) != null || (this._mipmap3dGenerator = new _Z(this._gpu.device)), this._mipmap3dGenerator.generateMipmap(t);
      return;
    }
    (s = this._mipmapGenerator) != null || (this._mipmapGenerator = new SZ(this._gpu.device)), this._mipmapGenerator.generateMipmap(t);
  }
  onSourceUnload(e) {
    e.off("update", this.onSourceUpdate, this), e.off("resize", this.onSourceResize, this), e.off("updateMipmaps", this.onUpdateMipmaps, this);
  }
  onSourceResize(e) {
    e._gcLastUsed = this._renderer.gc.now;
    const t = e._gpuData[this._renderer.uid], i = t == null ? void 0 : t.gpuTexture;
    i ? (i.width !== e.pixelWidth || i.height !== e.pixelHeight) && (t.destroy(), this._bindGroupHash[e.uid] = null, e._gpuData[this._renderer.uid] = null, this.initSource(e)) : this.initSource(e);
  }
  _initSampler(e) {
    return this._gpuSamplers[e._resourceId] = this._gpu.device.createSampler(e), this._gpuSamplers[e._resourceId];
  }
  getGpuSampler(e) {
    return this._gpuSamplers[e._resourceId] || this._initSampler(e);
  }
  getGpuSource(e) {
    var t;
    return e._gcLastUsed = this._renderer.gc.now, ((t = e._gpuData[this._renderer.uid]) == null ? void 0 : t.gpuTexture) || this.initSource(e);
  }
  /**
   * this returns s bind group for a specific texture, the bind group contains
   * - the texture source
   * - the texture style
   * - the texture matrix
   * This is cached so the bind group should only be created once per texture
   * @param texture - the texture you want the bindgroup for
   * @returns the bind group for the texture
   */
  getTextureBindGroup(e) {
    return this._bindGroupHash[e.uid] || this._createTextureBindGroup(e);
  }
  _createTextureBindGroup(e) {
    const t = e.source;
    return this._bindGroupHash[e.uid] = new Eo({
      0: t,
      1: t.style,
      2: new ms({
        uTextureMatrix: { type: "mat3x3<f32>", value: e.textureMatrix.mapCoord }
      })
    }), this._bindGroupHash[e.uid];
  }
  getTextureView(e, t) {
    var i;
    const s = e.source;
    s._gcLastUsed = this._renderer.gc.now;
    let o = s._gpuData[this._renderer.uid];
    o || (this.initSource(s), o = s._gpuData[this._renderer.uid]);
    const r = t ? _2(t) : 0;
    return (i = o.textureViews)[r] || (i[r] = o.gpuTexture.createView({
      dimension: s.viewDimension,
      ...t
    })), o.textureViews[r];
  }
  getTextureRenderTargetView(e, t = 0, i = 0, s) {
    var o;
    const r = e.source;
    r._gcLastUsed = this._renderer.gc.now;
    let a = r._gpuData[this._renderer.uid];
    a || (this.initSource(r), a = r._gpuData[this._renderer.uid]);
    const l = r.dimension === "3d";
    l && (i = 0);
    let d = i * (r.mipLevelCount || 1) + t + 1;
    return s && (d = `${d}.${_2(s)}`), (o = a.textureViews)[d] || (o[d] = a.gpuTexture.createView({
      dimension: l ? "3d" : "2d",
      baseMipLevel: t,
      mipLevelCount: 1,
      baseArrayLayer: i,
      arrayLayerCount: 1,
      ...s
    })), a.textureViews[d];
  }
  generateCanvas(e) {
    const t = this._renderer, i = t.gpu.device.createCommandEncoder(), s = Pt.get().createCanvas();
    s.width = e.source.pixelWidth, s.height = e.source.pixelHeight;
    const o = s.getContext("webgpu");
    return o.configure({
      device: t.gpu.device,
      usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC,
      format: Pt.get().getNavigator().gpu.getPreferredCanvasFormat(),
      alphaMode: "premultiplied"
    }), i.copyTextureToTexture({
      texture: t.texture.getGpuSource(e.source),
      origin: {
        x: 0,
        y: 0
      }
    }, {
      texture: o.getCurrentTexture()
    }, {
      width: s.width,
      height: s.height
    }), t.gpu.device.queue.submit([i.finish()]), s;
  }
  getPixels(e) {
    const t = this.generateCanvas(e), i = xl.getOptimalCanvasAndContext(t.width, t.height), s = i.context;
    s.drawImage(t, 0, 0);
    const { width: o, height: r } = t, a = s.getImageData(0, 0, o, r), l = new Uint8ClampedArray(a.data.buffer);
    return xl.returnCanvasAndContext(i), { pixels: l, width: o, height: r };
  }
  destroy() {
    this._managedTextures.destroy();
    for (const e of Object.keys(this._bindGroupHash)) {
      const t = Number(e), i = this._bindGroupHash[t];
      i == null || i.destroy();
    }
    this._renderer = null, this._gpu = null, this._mipmapGenerator = null, this._mipmap3dGenerator = null, this._gpuSamplers = null, this._bindGroupHash = null;
  }
};
fy.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "texture"
};
fy.uploadExtensions = /* @__PURE__ */ Object.create(null);
let $M = fy;
ct.handleByMap(Ae.TextureUploaderWebGPU, $M.uploadExtensions);
class DM {
  constructor() {
    this._maxTextures = 0;
  }
  contextChange(e) {
    const t = new ms({
      uTransformMatrix: { value: new st(), type: "mat3x3<f32>" },
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uRound: { value: 0, type: "f32" }
    });
    this._maxTextures = e.limits.maxBatchableTextures;
    const i = R1({
      name: "graphics",
      bits: [
        zS,
        DS(this._maxTextures),
        aX,
        $1
      ]
    });
    this.shader = new Js({
      gpuProgram: i,
      resources: {
        // added on the fly!
        localUniforms: t
      }
    });
  }
  execute(e, t) {
    const i = t.context, s = i.customShader || this.shader, o = e.renderer, r = o.graphicsContext, {
      batcher: a,
      instructions: l
    } = r.getContextRenderData(i), d = o.encoder;
    d.setGeometry(a.geometry, s.gpuProgram);
    const c = o.globalUniforms.bindGroup;
    d.setBindGroup(0, c, s.gpuProgram);
    const u = o.renderPipes.uniformBatch.getUniformBindGroup(s.resources.localUniforms, !0);
    d.setBindGroup(2, u, s.gpuProgram);
    const p = l.instructions;
    let f = null;
    for (let y = 0; y < l.instructionSize; y++) {
      const b = p[y];
      if (b.topology !== f && (f = b.topology, d.setPipelineFromGeometryProgramAndState(
        a.geometry,
        s.gpuProgram,
        e.state,
        b.topology,
        s._overrides
      )), s.groups[1] = b.bindGroup, !b.gpuBindGroup) {
        const w = b.textures;
        b.bindGroup = E1(
          w.textures,
          w.count,
          this._maxTextures
        ), b.gpuBindGroup = o.bindGroup.getBindGroup(
          b.bindGroup,
          s.gpuProgram,
          1
        );
      }
      d.setBindGroup(1, b.bindGroup, s.gpuProgram), d.renderPassEncoder.drawIndexed(b.size, 1, b.start);
    }
  }
  destroy() {
    this.shader.destroy(), this.shader = null;
  }
}
DM.extension = {
  type: [
    Ae.WebGPUPipesAdaptor
  ],
  name: "graphics"
};
class OM {
  init() {
    const e = R1({
      name: "mesh",
      bits: [
        Xh,
        cX,
        $1
      ]
    });
    this._shader = new Js({
      gpuProgram: e,
      resources: {
        uTexture: Ze.EMPTY._source,
        uSampler: Ze.EMPTY._source.style,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new st() }
        }
      }
    });
  }
  execute(e, t) {
    const i = e.renderer;
    let s = t._shader;
    if (!s)
      s = this._shader, s.groups[2] = i.texture.getTextureBindGroup(t.texture);
    else if (!s.gpuProgram) {
      at("Mesh shader has no gpuProgram", t.shader);
      return;
    }
    const o = s.gpuProgram;
    if (o.autoAssignGlobalUniforms && (s.groups[0] = i.globalUniforms.bindGroup), o.autoAssignLocalUniforms) {
      const r = e.localUniforms;
      s.groups[1] = i.renderPipes.uniformBatch.getUniformBindGroup(r, !0);
    }
    i.encoder.draw({
      geometry: t._geometry,
      shader: s,
      state: t.state
    });
  }
  destroy() {
    this._shader.destroy(), this._shader = null;
  }
}
OM.extension = {
  type: [
    Ae.WebGPUPipesAdaptor
  ],
  name: "mesh"
};
const IZ = [
  ...ay,
  SM,
  wM,
  py,
  kM,
  yM,
  $M,
  CM,
  IM,
  AM,
  MM,
  xM,
  _M,
  vM
], AZ = [...OT, TM], PZ = [hT, OM, DM], LM = [], BM = [], FM = [], NM = [];
ct.handleByNamedList(Ae.WebGPUSystem, LM);
ct.handleByNamedList(Ae.WebGPUPipes, BM);
ct.handleByNamedList(Ae.WebGPUPipesAdaptor, FM);
ct.handleByNamedList(Ae.WebGPULoader, NM);
ct.add(...IZ, ...AZ, ...PZ);
class EZ extends Xc {
  constructor() {
    const e = {
      name: "webgpu",
      type: Vi.WEBGPU,
      systems: LM,
      renderPipes: BM,
      renderPipeAdaptors: FM,
      loaders: NM
    };
    super(e);
  }
}
const RZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGPURenderer: EZ
}, Symbol.toStringTag, { value: "Module" })), UM = class GM extends oX {
  constructor(...e) {
    var i;
    super({});
    let t = (i = e[0]) != null ? i : {};
    typeof t == "number" && (rt(on, "PlaneGeometry constructor changed please use { width, height, verticesX, verticesY } instead"), t = {
      width: t,
      height: e[1],
      verticesX: e[2],
      verticesY: e[3]
    }), this.build(t);
  }
  /**
   * Refreshes plane coordinates
   * @param options - Options to be applied to plane geometry
   */
  build(e) {
    var u, p, f, y;
    e = { ...GM.defaultOptions, ...e }, this.verticesX = (u = this.verticesX) != null ? u : e.verticesX, this.verticesY = (p = this.verticesY) != null ? p : e.verticesY, this.width = (f = this.width) != null ? f : e.width, this.height = (y = this.height) != null ? y : e.height;
    const t = this.verticesX * this.verticesY, i = [], s = [], o = [], r = this.verticesX - 1, a = this.verticesY - 1, l = this.width / r, d = this.height / a;
    for (let b = 0; b < t; b++) {
      const w = b % this.verticesX, k = b / this.verticesX | 0;
      i.push(w * l, k * d), s.push(w / r, k / a);
    }
    const c = r * a;
    for (let b = 0; b < c; b++) {
      const w = b % r, k = b / r | 0, S = k * this.verticesX + w, _ = k * this.verticesX + w + 1, x = (k + 1) * this.verticesX + w, T = (k + 1) * this.verticesX + w + 1;
      o.push(
        S,
        _,
        x,
        _,
        T,
        x
      );
    }
    this.buffers[0].data = new Float32Array(i), this.buffers[1].data = new Float32Array(s), this.indexBuffer.data = new Uint32Array(o), this.buffers[0].update(), this.buffers[1].update(), this.indexBuffer.update();
  }
};
UM.defaultOptions = {
  width: 100,
  height: 100,
  verticesX: 10,
  verticesY: 10
};
let zZ = UM;
const Tg = [[0, 0], [0, 0], [0, 0]], Mg = [[0, 0], [0, 0], [0, 0]], Cg = [[0, 0], [0, 0], [0, 0]], Ig = [[0, 0], [0, 0], [0, 0]];
function Vu(n, e, t, i, s, o, r) {
  n[0][0] = e, n[0][1] = t, n[1][0] = i, n[1][1] = s, n[2][0] = o, n[2][1] = r;
}
class jM {
  constructor(e) {
    this._renderer = e;
  }
  validateRenderable(e) {
    return !1;
  }
  addRenderable(e, t) {
    this._renderer.renderPipes.batch.break(t), t.add(e);
  }
  updateRenderable(e) {
  }
  execute(e) {
    var ye, fe, ze, He, ce, be;
    const t = this._renderer, i = t.canvasContext, s = i.activeContext;
    s.save();
    const o = e.groupTransform, r = t._roundPixels | e._roundPixels;
    i.setContextTransform(o, r === 1), i.setBlendMode(e.groupBlendMode);
    const a = (fe = (ye = t.globalUniforms.globalUniformData) == null ? void 0 : ye.worldColor) != null ? fe : 4294967295, l = e.groupColorAlpha, d = (a >>> 24 & 255) / 255, c = (l >>> 24 & 255) / 255, u = (He = (ze = t.filter) == null ? void 0 : ze.alphaMultiplier) != null ? He : 1, p = d * c * u;
    if (p <= 0) {
      s.restore();
      return;
    }
    s.globalAlpha = p;
    const f = a & 16777215, y = l & 16777215, b = Wr(Vr(y, f)), w = e.texture, k = yt.getCanvasSource(w);
    if (!k) {
      s.restore();
      return;
    }
    const S = i.smoothProperty, _ = w.source.style.scaleMode !== "nearest";
    s[S] !== _ && (s[S] = _);
    const x = b !== 16777215 || w.rotate !== 0, T = x ? yt.getTintedCanvas({ texture: w }, b) : k, {
      leftWidth: M,
      topHeight: z,
      rightWidth: P,
      bottomHeight: D,
      width: $,
      height: O
    } = e, L = M + P, Z = z + D, J = Math.min(
      L > $ ? $ / L : 1,
      Z > O ? O / Z : 1,
      1
    ), re = M * J, F = P * J, W = z * J, ee = D * J, N = Math.max(0, $ - re - F), te = Math.max(0, O - W - ee), G = e.anchor, q = (be = (ce = w.source._resolution) != null ? ce : w.source.resolution) != null ? be : 1;
    let B = w.frame.x * q, ne = w.frame.y * q;
    const se = -G.x * $, Y = -G.y * O, ie = M * q, De = z * q, xe = P * q, Oe = D * q;
    let Ee = w.frame.width * q, j = w.frame.height * q;
    x && (B = 0, ne = 0, Ee = T.width, j = T.height);
    const V = Ee - ie - xe, Q = j - De - Oe, oe = V > 0 ? B + ie : Math.max(B, Math.min(B + ie, B + Ee - 1)), ue = V > 0 ? V : 1, Ie = Q > 0 ? ne + De : Math.max(ne, Math.min(ne + De, ne + j - 1)), he = Q > 0 ? Q : 1;
    Vu(Tg, B, ie, oe, ue, B + Ee - xe, xe), Vu(Mg, ne, De, Ie, he, ne + j - Oe, Oe), Vu(
      Cg,
      se,
      re,
      se + re,
      N,
      se + $ - F,
      F
    ), Vu(
      Ig,
      Y,
      W,
      Y + W,
      te,
      Y + O - ee,
      ee
    );
    for (let Be = 0; Be < 3; Be++) {
      const Fe = Cg[Be][1];
      if (Fe <= 0) continue;
      const Ke = Tg[Be][0], Qe = Tg[Be][1], ht = Cg[Be][0];
      for (let Le = 0; Le < 3; Le++) {
        const Ne = Ig[Le][1];
        Ne <= 0 || s.drawImage(
          T,
          Ke,
          Mg[Le][0],
          Qe,
          Mg[Le][1],
          ht,
          Ig[Le][0],
          Fe,
          Ne
        );
      }
    }
    s.restore();
  }
  destroy() {
    this._renderer = null;
  }
}
jM.extension = {
  type: [
    Ae.CanvasPipes
  ],
  name: "nineSliceSprite"
};
const HM = class np extends zZ {
  constructor(e = {}) {
    var t, i;
    e = { ...np.defaultOptions, ...e }, super({
      width: e.width,
      height: e.height,
      verticesX: 4,
      verticesY: 4
    }), this._trimX = 0, this._trimY = 0, this._trimWidth = (t = e.originalWidth) != null ? t : np.defaultOptions.originalWidth, this._trimHeight = (i = e.originalHeight) != null ? i : np.defaultOptions.originalHeight, this.update(e);
  }
  /**
   * Updates the NineSliceGeometry with the options.
   * @param options - The options of the NineSliceGeometry.
   */
  update(e) {
    var t, i, s, o, r, a, l, d, c, u, p, f, y, b, w, k, S, _;
    this.width = (t = e.width) != null ? t : this.width, this.height = (i = e.height) != null ? i : this.height, this._originalWidth = (s = e.originalWidth) != null ? s : this._originalWidth, this._originalHeight = (o = e.originalHeight) != null ? o : this._originalHeight, this._leftWidth = (r = e.leftWidth) != null ? r : this._leftWidth, this._rightWidth = (a = e.rightWidth) != null ? a : this._rightWidth, this._topHeight = (l = e.topHeight) != null ? l : this._topHeight, this._bottomHeight = (d = e.bottomHeight) != null ? d : this._bottomHeight, this._anchorX = (c = e.anchor) == null ? void 0 : c.x, this._anchorY = (u = e.anchor) == null ? void 0 : u.y, e.trim !== void 0 ? (this._trimX = (f = (p = e.trim) == null ? void 0 : p.x) != null ? f : 0, this._trimY = (b = (y = e.trim) == null ? void 0 : y.y) != null ? b : 0, this._trimWidth = (k = (w = e.trim) == null ? void 0 : w.width) != null ? k : this._originalWidth, this._trimHeight = (_ = (S = e.trim) == null ? void 0 : S.height) != null ? _ : this._originalHeight) : (this._trimWidth = this._originalWidth, this._trimHeight = this._originalHeight), this.updateUvs(), this.updatePositions();
  }
  /** Updates the positions of the vertices. */
  updatePositions() {
    const e = this.positions, {
      width: t,
      height: i,
      _leftWidth: s,
      _rightWidth: o,
      _topHeight: r,
      _bottomHeight: a,
      _anchorX: l,
      _anchorY: d
    } = this, c = s + o, u = t > c ? 1 : t / c, p = r + a, f = i > p ? 1 : i / p, y = Math.min(u, f), b = l * t, w = d * i;
    e[0] = e[8] = e[16] = e[24] = -b, e[2] = e[10] = e[18] = e[26] = s * y - b, e[4] = e[12] = e[20] = e[28] = t - o * y - b, e[6] = e[14] = e[22] = e[30] = t - b, e[1] = e[3] = e[5] = e[7] = -w, e[9] = e[11] = e[13] = e[15] = r * y - w, e[17] = e[19] = e[21] = e[23] = i - a * y - w, e[25] = e[27] = e[29] = e[31] = i - w, this.getBuffer("aPosition").update();
  }
  /** Updates the UVs of the vertices. */
  updateUvs() {
    const e = this.uvs, t = this._originalWidth, i = this._originalHeight, s = this._trimX / t, o = this._trimY / i, r = (this._trimX + this._trimWidth) / t, a = (this._trimY + this._trimHeight) / i;
    e[0] = e[8] = e[16] = e[24] = s, e[1] = e[3] = e[5] = e[7] = o, e[6] = e[14] = e[22] = e[30] = r, e[25] = e[27] = e[29] = e[31] = a;
    const l = 1 / t, d = 1 / i;
    e[2] = e[10] = e[18] = e[26] = s + l * this._leftWidth, e[9] = e[11] = e[13] = e[15] = o + d * this._topHeight, e[4] = e[12] = e[20] = e[28] = r - l * this._rightWidth, e[17] = e[19] = e[21] = e[23] = a - d * this._bottomHeight, this.getBuffer("aUV").update();
  }
};
HM.defaultOptions = {
  /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  width: 100,
  /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  height: 100,
  /** The width of the left column. */
  leftWidth: 10,
  /** The height of the top row. */
  topHeight: 10,
  /** The width of the right column. */
  rightWidth: 10,
  /** The height of the bottom row. */
  bottomHeight: 10,
  /** The original width of the texture */
  originalWidth: 100,
  /** The original height of the texture */
  originalHeight: 100
};
let wr = HM;
class $Z extends rX {
  constructor() {
    super(), this.geometry = new wr();
  }
  destroy() {
    this.geometry.destroy();
  }
}
class VM {
  constructor(e) {
    this._renderer = e, this._managedSprites = new gs({ renderer: e, type: "renderable", name: "nineSliceSprite" });
  }
  addRenderable(e, t) {
    const i = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, i), this._renderer.renderPipes.batch.addToBatch(i, t);
  }
  updateRenderable(e) {
    const t = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, t), t._batcher.updateElement(t);
  }
  validateRenderable(e) {
    const t = this._getGpuSprite(e);
    return !t._batcher.checkAndUpdateTexture(
      t,
      e._texture
    );
  }
  _updateBatchableSprite(e, t) {
    t.geometry.update(e), t.setTexture(e._texture);
  }
  _getGpuSprite(e) {
    return e._gpuData[this._renderer.uid] || this._initGPUSprite(e);
  }
  _initGPUSprite(e) {
    const t = e._gpuData[this._renderer.uid] = new $Z(), i = t;
    return i.renderable = e, i.transform = e.groupTransform, i.texture = e._texture, i.roundPixels = this._renderer._roundPixels | e._roundPixels, this._managedSprites.add(e), e.didViewUpdate || this._updateBatchableSprite(e, i), t;
  }
  destroy() {
    this._managedSprites.destroy(), this._renderer = null;
  }
}
VM.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes
  ],
  name: "nineSliceSprite"
};
ct.add(jM);
ct.add(VM);
const WM = class qM extends M1 {
  constructor(e) {
    var p, f, y, b, w, k, S, _, x, T;
    e instanceof Ze && (e = { texture: e });
    const {
      width: t,
      height: i,
      anchor: s,
      leftWidth: o,
      rightWidth: r,
      topHeight: a,
      bottomHeight: l,
      texture: d,
      roundPixels: c,
      ...u
    } = e;
    super({
      label: "NineSliceSprite",
      ...u
    }), this.renderPipeId = "nineSliceSprite", this.batched = !0, this._leftWidth = (f = o != null ? o : (p = d == null ? void 0 : d.defaultBorders) == null ? void 0 : p.left) != null ? f : wr.defaultOptions.leftWidth, this._topHeight = (b = a != null ? a : (y = d == null ? void 0 : d.defaultBorders) == null ? void 0 : y.top) != null ? b : wr.defaultOptions.topHeight, this._rightWidth = (k = r != null ? r : (w = d == null ? void 0 : d.defaultBorders) == null ? void 0 : w.right) != null ? k : wr.defaultOptions.rightWidth, this._bottomHeight = (_ = l != null ? l : (S = d == null ? void 0 : d.defaultBorders) == null ? void 0 : S.bottom) != null ? _ : wr.defaultOptions.bottomHeight, this._width = (x = t != null ? t : d.width) != null ? x : wr.defaultOptions.width, this._height = (T = i != null ? i : d.height) != null ? T : wr.defaultOptions.height, this.allowChildren = !1, this.texture = d != null ? d : qM.defaultOptions.texture, this.roundPixels = c != null ? c : !1, this._anchor = new En(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), s ? this.anchor = s : this.texture.defaultAnchor && (this.anchor = this.texture.defaultAnchor);
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /**
   * The width of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The width affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed width
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     width: 200  // Sets initial width
   * });
   *
   * // Adjust width dynamically
   * panel.width = 300;  // Stretches middle sections
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#height} For setting height
   */
  get width() {
    return this._width;
  }
  set width(e) {
    this._width = e, this.onViewUpdate();
  }
  /**
   * The height of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The height affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed height
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     height: 150  // Sets initial height
   * });
   *
   * // Adjust height dynamically
   * panel.height = 200;  // Stretches middle sections
   *
   * // Create responsive UI element
   * const dialog = new NineSliceSprite({
   *     texture: Texture.from('dialog.png'),
   *     topHeight: 30,
   *     bottomHeight: 30,
   *     height: parent.height * 0.5  // 50% of parent height
   * });
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#width} For setting width
   */
  get height() {
    return this._height;
  }
  set height(e) {
    this._height = e, this.onViewUpdate();
  }
  /**
   * Sets the size of the NineSliceSprite to the specified width and height.
   * This method directly modifies the vertices and UV coordinates of the sprite.
   *
   * Using this is more efficient than setting width and height separately as it only triggers one update.
   * @example
   * ```ts
   * // Set to specific dimensions
   * panel.setSize(300, 200); // Width: 300, Height: 200
   *
   * // Set uniform size
   * panel.setSize(200); // Makes a square 200x200
   *
   * // Set size using object
   * panel.setSize({
   *     width: 400,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a Size object with width/height properties
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link NineSliceSprite#width} For setting width only
   * @see {@link NineSliceSprite#height} For setting height only
   */
  setSize(e, t) {
    var i;
    typeof e == "object" && (t = (i = e.height) != null ? i : e.width, e = e.width), this._width = e, this._height = t != null ? t : e, this.onViewUpdate();
  }
  /**
   * Retrieves the size of the NineSliceSprite as a [Size]{@link Size} object.
   * This method is more efficient than getting width and height separately.
   * @example
   * ```ts
   * // Get basic size
   * const size = panel.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * panel.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the NineSliceSprite
   * @see {@link NineSliceSprite#width} For getting just the width
   * @see {@link NineSliceSprite#height} For getting just the height
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   */
  getSize(e) {
    return e || (e = {}), e.width = this._width, e.height = this._height, e;
  }
  /**
   * Width of the left vertical bar (A).
   * Controls the size of the left edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., leftWidth: 20 });
   * sprite.leftWidth = 20; // Set left border width
   * ```
   * @default 10
   */
  get leftWidth() {
    return this._leftWidth;
  }
  set leftWidth(e) {
    this._leftWidth = e, this.onViewUpdate();
  }
  /**
   * Height of the top horizontal bar (C).
   * Controls the size of the top edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., topHeight: 20 });
   * sprite.topHeight = 20; // Set top border height
   * ```
   * @default 10
   */
  get topHeight() {
    return this._topHeight;
  }
  set topHeight(e) {
    this._topHeight = e, this.onViewUpdate();
  }
  /**
   * Width of the right vertical bar (B).
   * Controls the size of the right edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., rightWidth: 20 });
   * sprite.rightWidth = 20; // Set right border width
   * ```
   * @default 10
   */
  get rightWidth() {
    return this._rightWidth;
  }
  set rightWidth(e) {
    this._rightWidth = e, this.onViewUpdate();
  }
  /**
   * Height of the bottom horizontal bar (D).
   * Controls the size of the bottom edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., bottomHeight: 20 });
   * sprite.bottomHeight = 20; // Set bottom border height
   * ```
   * @default 10
   */
  get bottomHeight() {
    return this._bottomHeight;
  }
  set bottomHeight(e) {
    this._bottomHeight = e, this.onViewUpdate();
  }
  /**
   * The texture to use on the NineSliceSprite.
   * ```ts
   * // Create a sprite with a texture
   * const sprite = new NineSliceSprite({
   *     texture: Texture.from('path/to/image.png')
   * });
   * // Update the texture later
   * sprite.texture = Texture.from('path/to/another-image.png');
   * ```
   * @default Texture.EMPTY
   */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    e || (e = Ze.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this._texture = e, this.onViewUpdate());
  }
  /**
   * The original width of the texture before any nine-slice scaling.
   * This is the width of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.width = sprite.originalWidth * 2; // Double the original width
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#width} For the current displayed width
   * @see {@link Texture#width} For direct texture width access
   * @returns The original width of the texture
   */
  get originalWidth() {
    return this._texture.width;
  }
  /**
   * The original height of the texture before any nine-slice scaling.
   * This is the height of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.height = sprite.originalHeight * 2; // Double the original height
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#height} For the current displayed height
   * @see {@link Texture#height} For direct texture height access
   * @returns The original height of the texture
   */
  get originalHeight() {
    return this._texture.height;
  }
  /**
   * The trim rectangle of the underlying texture, or `null` if the texture is not trimmed.
   * This is forwarded to the {@link NineSliceGeometry} so that UV coordinates are clamped
   * to the visible pixel region, preventing transparent atlas padding from bleeding into
   * the rendered sprite corners.
   * @readonly
   * @internal
   */
  get trim() {
    var e;
    return (e = this._texture.trim) != null ? e : null;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * nineSliceSprite.destroy();
   * nineSliceSprite.destroy(true);
   * nineSliceSprite.destroy({ texture: true, textureSource: true });
   */
  destroy(e) {
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const i = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(i);
    }
    this._texture = null;
  }
  /** @private */
  updateBounds() {
    const e = this._bounds, t = this._anchor, i = this._width, s = this._height;
    e.minX = -t._x * i, e.maxX = e.minX + i, e.minY = -t._y * s, e.maxY = e.minY + s;
  }
};
WM.defaultOptions = {
  /** @default Texture.EMPTY */
  texture: Ze.EMPTY
};
let DZ = WM;
ct.add(NV, UV);
function OZ() {
  const n = self;
  function e(s) {
    const o = /^synthetic:\/\/(\d+)\/(\d+)x(\d+)/.exec(s), r = o ? Number(o[1]) : 1, a = o ? Number(o[2]) : 640, l = o ? Number(o[3]) : 480, d = new OffscreenCanvas(a, l), c = d.getContext("2d");
    let u = r * 9301 + 49297;
    const p = () => (u = (u * 9301 + 49297) % 233280, u / 233280), f = Math.floor(p() * 360), y = c.createLinearGradient(0, 0, a, l);
    y.addColorStop(0, "hsl(" + f + ",45%," + (18 + p() * 20) + "%)"), y.addColorStop(1, "hsl(" + (f + 40 + p() * 80) % 360 + ",55%," + (35 + p() * 25) + "%)"), c.fillStyle = y, c.fillRect(0, 0, a, l);
    for (let b = 0; b < 7; b++) {
      c.fillStyle = "hsla(" + (f + p() * 120) % 360 + ",60%," + (40 + p() * 40) + "%," + (0.25 + p() * 0.4) + ")";
      const w = a * (0.1 + p() * 0.4), k = l * (0.1 + p() * 0.6);
      c.fillRect(p() * (a - w), l - k - p() * l * 0.3, w, k);
    }
    return c.fillStyle = "rgba(255,255,255,0.85)", c.font = "600 " + Math.round(l * 0.09) + "px sans-serif", c.fillText("#" + r, a * 0.06, l * 0.9), { canvas: d, w: a, h: l };
  }
  async function t(s) {
    if (s.startsWith("synthetic://")) {
      const d = e(s);
      return { src: d.canvas, sw: d.w, sh: d.h };
    }
    const o = s.startsWith("blob:") || s.startsWith("data:") ? s : s + (s.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1", r = await fetch(o, { mode: "cors", credentials: "omit" });
    if (!r.ok) throw new Error("HTTP " + r.status);
    const a = await r.blob(), l = await createImageBitmap(a);
    return { src: l, sw: l.width, sh: l.height, close: () => l.close() };
  }
  function i(s, o, r) {
    const l = new OffscreenCanvas(1, 1).getContext("2d", { willReadFrequently: !0 });
    l.drawImage(s, 0, 0, o, r, 0, 0, 1, 1);
    const d = l.getImageData(0, 0, 1, 1).data, c = (u) => u.toString(16).padStart(2, "0");
    return "#" + c(d[0]) + c(d[1]) + c(d[2]);
  }
  n.onmessage = async (s) => {
    const o = s.data;
    let r = null;
    try {
      r = await t(o.url);
      const { src: a, sw: l, sh: d } = r, c = Math.max(1, Math.round(o.tw)), u = Math.max(1, Math.round(o.th)), p = c / u, f = l / d;
      let y = 0, b = 0, w = l, k = d;
      f > p ? (w = d * p, y = (l - w) / 2) : (k = l / p, b = (d - k) / 2);
      const S = new OffscreenCanvas(c, u), _ = S.getContext("2d");
      _.imageSmoothingEnabled = !0, _.imageSmoothingQuality = "high";
      const x = Math.min(o.radius, c / 2, u / 2);
      _.save(), _.beginPath(), _.roundRect(0, 0, c, u, x), _.clip();
      let T = a, M = w, z = k, P = y, D = b;
      for (; M > c * 2.5 && z > u * 2.5; ) {
        const L = Math.max(c, Math.round(M / 2)), Z = Math.max(u, Math.round(z / 2)), J = new OffscreenCanvas(L, Z), re = J.getContext("2d");
        re.imageSmoothingEnabled = !0, re.imageSmoothingQuality = "high", re.drawImage(T, P, D, M, z, 0, 0, L, Z), T = J, P = 0, D = 0, M = L, z = Z;
      }
      if (_.drawImage(T, P, D, M, z, 0, 0, c, u), _.restore(), o.border > 0) {
        const L = o.border;
        _.lineWidth = L, _.strokeStyle = "rgba(255,255,255,0.09)", _.beginPath(), _.roundRect(L / 2, L / 2, c - L, u - L, Math.max(0, x - L / 2)), _.stroke(), _.save(), _.beginPath(), _.roundRect(0, 0, c, u, x), _.clip(), _.fillStyle = "rgba(255,255,255,0.07)", _.fillRect(0, L, c, L), _.restore();
      }
      const $ = i(a, l, d), O = S.transferToImageBitmap();
      r.close && r.close(), n.postMessage({ id: o.id, bitmap: O, color: $, sw: l, sh: d }, [O]);
    } catch (a) {
      r && r.close && r.close(), n.postMessage({ id: o.id, error: String(a && a.message || a) });
    }
  };
}
let Ag = null;
function LZ() {
  return typeof Worker != "undefined" && typeof OffscreenCanvas != "undefined" && typeof createImageBitmap != "undefined";
}
function BZ() {
  if (!Ag) {
    const n = "(" + OZ.toString() + ")();";
    Ag = URL.createObjectURL(new Blob([n], { type: "text/javascript" }));
  }
  return new Worker(Ag);
}
var FZ = Object.defineProperty, NZ = (n, e, t) => e in n ? FZ(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, ui = (n, e, t) => NZ(n, typeof e != "symbol" ? e + "" : e, t);
const ip = [64, 128, 256, 512, 1024, 2048], Wu = 64;
function UZ(n) {
  for (const e of ip) if (e >= n / 1.15) return e;
  return ip[ip.length - 1];
}
class GZ {
  constructor(e) {
    if (ui(this, "opts", e), ui(this, "entries", /* @__PURE__ */ new Map()), ui(this, "queue", []), ui(this, "queueDirty", !1), ui(this, "workers", []), ui(this, "idle", []), ui(this, "jobs", /* @__PURE__ */ new Map()), ui(this, "jobSeq", 0), ui(this, "frame", 0), ui(this, "bytes", 0), ui(this, "ready", []), ui(this, "destroyed", !1), ui(this, "evicted", []), LZ()) {
      const t = Math.max(2, Math.min(4, Math.floor((navigator.hardwareConcurrency || 4) / 2)));
      for (let i = 0; i < t; i++) {
        const s = BZ();
        s.onmessage = (o) => this.onResult(s, o.data), this.workers.push(s), this.idle.push(s);
      }
    }
  }
  get totalBytes() {
    return this.bytes;
  }
  get textureCount() {
    let e = 0;
    for (const t of this.entries.values()) e += t.tiers.size;
    return e;
  }
  get pending() {
    return this.jobs.size + this.queue.length;
  }
  /** Register or refresh a card's source. Size changes keep loaded tiers. */
  track(e, t, i, s) {
    const o = this.entries.get(e);
    if (!o) {
      this.entries.set(e, {
        id: e,
        url: t,
        w: i,
        h: s,
        tiers: /* @__PURE__ */ new Map(),
        sw: 0,
        sh: 0,
        want: 0,
        priority: 0,
        inflight: 0,
        failed: 0,
        lastSeen: 0
      });
      return;
    }
    o.url !== t && (this.dropAll(o), o.url = t, o.sw = 0, o.sh = 0, o.failed = 0), o.w = i, o.h = s;
  }
  untrack(e) {
    const t = this.entries.get(e);
    if (!t) return;
    this.dropAll(t), this.entries.delete(e);
    const i = this.queue.indexOf(t);
    i >= 0 && this.queue.splice(i, 1);
  }
  /** Called once per rendered frame. */
  tick() {
    this.frame++;
  }
  /**
   * A card is on screen at `screenPx` device pixels on its long edge. Returns
   * the best rendition already loaded (exact tier, else the nearest), and
   * queues the wanted tier. `settled` false = only fill gaps, don't refine.
   */
  request(e, t, i, s) {
    const o = this.entries.get(e);
    if (!o) return null;
    o.lastSeen = this.frame;
    let r = UZ(t);
    const a = Math.max(o.sw, o.sh);
    if (a) {
      let c = Wu;
      for (const u of ip) u <= a * 1.1 && (c = u);
      r = Math.min(r, Math.max(c, Wu));
    }
    const l = this.best(o, r);
    l && (l.lastUsed = this.frame);
    const d = !l || l.tier * 2 < r;
    if (o.failed < 3 && !o.tiers.has(r) && (s || d)) {
      const c = !l && !s ? Math.min(r, 128) : r;
      o.tiers.has(c) || (o.want = c, o.priority = i, !o.inflight && this.queue.indexOf(o) < 0 && this.queue.push(o), this.queueDirty = !0);
    }
    return l;
  }
  best(e, t) {
    const i = e.tiers.get(t);
    if (i) return i;
    let s = null, o = null;
    for (const r of e.tiers.values())
      r.tier < t && (!s || r.tier > s.tier) && (s = r), r.tier > t && (!o || r.tier < o.tier) && (o = r);
    return o || s;
  }
  /** Start queued loads; call each frame after the visible pass. */
  pump() {
    if (!this.destroyed)
      for (this.queueDirty && (this.queue.sort((e, t) => e.priority - t.priority), this.queueDirty = !1); this.jobs.size < this.opts.maxInFlight && this.queue.length; ) {
        const e = this.queue.shift();
        this.frame - e.lastSeen > 120 || e.tiers.has(e.want) || this.start(e, e.want);
      }
  }
  /**
   * Bitmaps finished since last frame, at most `max` (the upload budget).
   * Ids `cheap` says yes to (no texture upload) have their own budget,
   * `maxCheap`; the rest wait their turn in order.
   */
  drainReady(e, t, i, s = 0) {
    if (!this.ready.length) return [];
    const o = [], r = [];
    let a = 0, l = 0, d = 0;
    for (const c of this.ready)
      i && d < s && i(c.id) ? (d++, o.push(c)) : l < e && (a < t || !l) ? (l++, a += c.tex.bytes, o.push(c)) : r.push(c);
    return this.ready = r, o;
  }
  start(e, t) {
    const i = Math.max(e.w, e.h), s = t / i, o = Math.max(1, Math.round(e.w * s)), r = Math.max(1, Math.round(e.h * s)), a = this.opts.radius * s, l = s >= 0.5 ? Math.max(1, s) : 0, d = ++this.jobSeq;
    e.inflight++, this.jobs.set(d, { entry: e, tier: t, jobId: d });
    const c = { id: d, url: e.url, tw: o, th: r, radius: a, border: l }, u = this.idle.pop();
    u ? u.postMessage(c) : this.workers.length ? this.workers[d % this.workers.length].postMessage(c) : jZ(c).then((p) => this.onResult(null, p));
  }
  onResult(e, t) {
    e && this.idle.indexOf(e) < 0 && this.idle.push(e);
    const i = this.jobs.get(t.id);
    if (this.jobs.delete(t.id), !i || this.destroyed) {
      t.bitmap && t.bitmap.close();
      return;
    }
    const s = i.entry;
    if (s.inflight = Math.max(0, s.inflight - 1), t.error || !t.bitmap) {
      s.failed++, s.failed >= 3 && this.opts.onError ? this.opts.onError(s.id, t.error || "unknown") : s.failed < 3 && setTimeout(() => {
        !this.destroyed && this.entries.get(s.id) === s && !s.tiers.has(i.tier) && (s.want = i.tier, this.queue.indexOf(s) < 0 && this.queue.push(s), this.queueDirty = !0);
      }, 800 * s.failed);
      return;
    }
    if (this.entries.get(s.id) !== s) {
      t.bitmap.close();
      return;
    }
    t.sw && t.sh && (s.sw = t.sw, s.sh = t.sh);
    const o = t.bitmap, r = new xc({
      resource: o,
      alphaMode: "premultiplied-alpha",
      autoGenerateMipmaps: i.tier >= 256,
      scaleMode: "linear"
    }), a = new Ze({ source: r }), l = o.width * o.height * 4 * (i.tier >= 256 ? 1.34 : 1), d = s.tiers.get(i.tier);
    d && this.free(d);
    const c = { tier: i.tier, texture: a, bytes: l, lastUsed: this.frame };
    s.tiers.set(i.tier, c), this.bytes += l, this.ready.push({ id: s.id, tex: c, color: t.color }), s.want !== i.tier && !s.tiers.has(s.want) && this.queue.indexOf(s) < 0 && (this.queue.push(s), this.queueDirty = !0), this.evict();
  }
  /** Free renditions until under budget; returns ids whose shown tier went. */
  evict() {
    if (this.bytes <= this.opts.budgetBytes) return;
    const e = [];
    for (const t of this.entries.values())
      for (const i of t.tiers.values())
        this.frame - i.lastUsed < 2 || e.push({ e: t, t: i });
    e.sort((t, i) => t.t.lastUsed - i.t.lastUsed || (t.t.tier === Wu ? 1 : 0) - (i.t.tier === Wu ? 1 : 0) || i.t.bytes - t.t.bytes);
    for (const t of e) {
      if (this.bytes <= this.opts.budgetBytes * 0.9) break;
      t.e.tiers.delete(t.t.tier), this.evicted.push({ id: t.e.id, tier: t.t.tier, texture: t.t.texture, bytes: t.t.bytes }), this.bytes -= t.t.bytes;
    }
  }
  /** Renditions evicted since the last call. The caller swaps any sprite
   *  still pointing at one, then calls release(). */
  takeEvicted() {
    const e = this.evicted;
    return this.evicted = [], e;
  }
  release(e) {
    e.destroy(!0);
  }
  /** Best loaded rendition for an id, regardless of want. */
  anyFor(e) {
    const t = this.entries.get(e);
    if (!t) return null;
    let i = null;
    for (const s of t.tiers.values()) (!i || s.tier > i.tier) && (i = s);
    return i;
  }
  free(e) {
    this.bytes -= e.bytes, e.texture.destroy(!0);
  }
  dropAll(e) {
    for (const t of e.tiers.values()) this.free(t);
    e.tiers.clear();
  }
  destroy() {
    this.destroyed = !0;
    for (const e of this.workers) e.terminate();
    this.workers.length = 0, this.idle.length = 0;
    for (const e of this.entries.values()) this.dropAll(e);
    this.entries.clear();
    for (const e of this.ready) e.tex.texture.destroy(!0);
    this.ready.length = 0;
    for (const e of this.evicted) e.texture.destroy(!0);
    this.evicted = [];
  }
}
async function jZ(n) {
  try {
    const e = n.url.startsWith("blob:") || n.url.startsWith("data:") ? n.url : n.url + (n.url.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1", t = await fetch(e, { mode: "cors", credentials: "omit" });
    if (!t.ok) throw new Error("HTTP " + t.status);
    const i = await createImageBitmap(await t.blob()), s = document.createElement("canvas");
    s.width = Math.max(1, Math.round(n.tw)), s.height = Math.max(1, Math.round(n.th));
    const o = s.getContext("2d"), r = s.width / s.height;
    let a = i.width, l = i.height, d = 0, c = 0;
    i.width / i.height > r ? (a = i.height * r, d = (i.width - a) / 2) : (l = i.width / r, c = (i.height - l) / 2), o.beginPath(), o.roundRect(0, 0, s.width, s.height, n.radius), o.clip(), o.imageSmoothingQuality = "high", o.drawImage(i, d, c, a, l, 0, 0, s.width, s.height);
    const u = await createImageBitmap(s), p = i.width, f = i.height;
    return i.close(), { id: n.id, bitmap: u, sw: p, sh: f };
  } catch (e) {
    return { id: n.id, error: String(e && e.message || e) };
  }
}
var HZ = Object.defineProperty, VZ = (n, e, t) => e in n ? HZ(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, rd = (n, e, t) => VZ(n, typeof e != "symbol" ? e + "" : e, t);
const Qr = 32, Ms = 1, zr = Qr + Ms * 2, $d = 1024, Wp = Math.floor($d / zr), S2 = Wp * Wp;
function Pg(n) {
  return { x: n % Wp * zr, y: Math.floor(n / Wp) * zr };
}
function WZ(n, e) {
  const t = Math.max(1, n, e);
  return { w: Math.max(1, Math.round(Qr * n / t)), h: Math.max(1, Math.round(Qr * e / t)) };
}
class qZ {
  constructor() {
    rd(this, "pages", []), rd(this, "cells", /* @__PURE__ */ new Map()), rd(this, "free", []), rd(this, "next", 0), rd(this, "blank", null);
  }
  get size() {
    return this.cells.size;
  }
  get pageCount() {
    return this.pages.length;
  }
  /** GPU bytes held (each page also keeps its canvas). */
  get bytes() {
    return this.pages.length * $d * $d * 4 * 1.34;
  }
  has(e) {
    return this.cells.has(e);
  }
  get(e) {
    const t = this.cells.get(e);
    return t ? t.texture : null;
  }
  /** A white cell on the first page: tinted, it is a tiny image's placeholder. */
  get placeholder() {
    if (!this.blank) {
      const e = this.take(), t = this.pages[e.page], i = Pg(e.slot);
      t.ctx.fillStyle = "#fff", t.ctx.fillRect(i.x, i.y, zr, zr), t.dirty = !0, this.blank = new Ze({ source: t.source, frame: new _t(i.x + Ms, i.y + Ms, Qr, Qr) });
    }
    return this.blank;
  }
  /** Draw `image` (any rendition of the picture) into the id's cell; returns its texture. */
  put(e, t, i, s) {
    let o = this.cells.get(e);
    const r = WZ(i, s);
    if (o)
      (o.texture.frame.width !== r.w || o.texture.frame.height !== r.h) && (o.texture.frame.width = r.w, o.texture.frame.height = r.h, o.texture.update());
    else {
      const c = this.take(), u = Pg(c.slot), p = this.pages[c.page];
      o = {
        page: c.page,
        slot: c.slot,
        texture: new Ze({ source: p.source, frame: new _t(u.x + Ms, u.y + Ms, r.w, r.h) })
      }, this.cells.set(e, o);
    }
    const a = this.pages[o.page], l = Pg(o.slot), d = a.ctx;
    return d.clearRect(l.x, l.y, zr, zr), d.drawImage(t, l.x, l.y, r.w + Ms * 2, r.h + Ms * 2), d.drawImage(t, l.x + Ms, l.y + Ms, r.w, r.h), a.dirty = !0, o.texture;
  }
  remove(e) {
    const t = this.cells.get(e);
    t && (this.cells.delete(e), t.texture.destroy(!1), this.free.push({ page: t.page, slot: t.slot }));
  }
  /** Upload the pages drawn into since the last call; once per frame, before rendering. */
  flush() {
    for (const e of this.pages)
      e.dirty && (e.dirty = !1, e.source.update());
  }
  destroy() {
    for (const e of this.cells.values()) e.texture.destroy(!1);
    this.cells.clear(), this.blank && this.blank.destroy(!1), this.blank = null;
    for (const e of this.pages) e.source.destroy();
    this.pages.length = 0, this.free.length = 0, this.next = 0;
  }
  take() {
    const e = this.free.pop();
    if (e) return e;
    const t = Math.floor(this.next / S2), i = this.next % S2;
    return this.next++, t === this.pages.length && this.pages.push(this.newPage()), { page: t, slot: i };
  }
  newPage() {
    const e = document.createElement("canvas");
    e.width = $d, e.height = $d;
    const t = e.getContext("2d");
    t.imageSmoothingEnabled = !0, t.imageSmoothingQuality = "high";
    const i = new ki({
      resource: e,
      scaleMode: "linear",
      // mipmaps keep a 3 px thumbnail from shimmering as the board pans
      autoGenerateMipmaps: !0,
      // a page's pixels live only in this atlas: never let the GPU copy idle out
      autoGarbageCollect: !1
    });
    return { canvas: e, ctx: t, source: i, dirty: !1 };
  }
}
const T2 = /* @__PURE__ */ new Map();
function ba(n, e) {
  const t = Math.round(n / Math.max(1, e) * 20) / 20, i = String(t);
  let s = T2.get(i);
  if (s) return s;
  const o = 128, r = t >= 1 ? o : Math.max(8, Math.round(o * t)), a = t >= 1 ? Math.max(8, Math.round(o / t)) : o, l = document.createElement("canvas");
  l.width = r, l.height = a;
  const d = l.getContext("2d");
  return d.fillStyle = "#fff", d.beginPath(), d.roundRect(0, 0, r, a, Math.max(2, o * 0.038)), d.fill(), s = Ze.from(l), T2.set(i, s), s;
}
let qu = null;
function KZ() {
  if (qu) return qu;
  const n = 60, e = n * 2, t = 64, i = t + e * 2, s = document.createElement("canvas");
  s.width = i, s.height = i;
  const o = s.getContext("2d");
  return o.shadowColor = "rgba(5,8,20,1)", o.shadowBlur = n, o.shadowOffsetX = i * 2, o.fillStyle = "#000", o.beginPath(), o.roundRect(e - i * 2, e, t, t, 12), o.fill(), qu = Ze.from(s), qu;
}
const YZ = 120, KM = "rd-board-colors", XZ = 6e3;
let ad = null, M2 = 0;
function YM() {
  if (ad) return ad;
  ad = /* @__PURE__ */ new Map();
  try {
    const n = localStorage.getItem(KM);
    if (n) for (const [e, t] of JSON.parse(n)) ad.set(e, t);
  } catch {
  }
  return ad;
}
function JZ(n) {
  return YM().get(n);
}
function ZZ(n, e) {
  const t = YM();
  if (t.get(n) !== e) {
    for (t.delete(n), t.set(n, e); t.size > XZ; ) t.delete(t.keys().next().value);
    clearTimeout(M2), M2 = window.setTimeout(() => {
      try {
        localStorage.setItem(KM, JSON.stringify(Array.from(t.entries())));
      } catch {
      }
    }, 2e3);
  }
}
const qp = {
  amethyst: { fill: 10053855, fillA: 0.13, line: 12756204, lineA: 0.22 },
  vista: { fill: 5923309, fillA: 0.13, line: 10725365, lineA: 0.22 },
  sky: { fill: 4044006, fillA: 0.13, line: 10082803, lineA: 0.22 },
  mint: { fill: 3458970, fillA: 0.13, line: 9430473, lineA: 0.22 },
  amber: { fill: 15774794, fillA: 0.13, line: 16241807, lineA: 0.22 },
  rose: { fill: 15489946, fillA: 0.13, line: 16098247, lineA: 0.22 },
  glass: { fill: 16777215, fillA: 0.06, line: 16777215, lineA: 0.1 }
};
function QZ() {
  const n = new un(), e = new Ro();
  return n.addChild(e), { root: n, g: e, thumbs: [] };
}
function Kp() {
  const t = (Tt.w - 28 - 2 - 18) / 4;
  return [0, 1, 2, 3].map((i) => ({ x: 15 + i * (t + 6), y: 63, s: t }));
}
function eQ(n, e, t) {
  const i = e.scale || 1, s = Tt.w, o = Tt.h, r = n.g;
  r.clear(), r.roundRect(0, 0, s, o, 16), r.fill(t ? { color: 16777215, alpha: 1 } : { color: 16777215, alpha: 0.062 }), r.roundRect(0.5, 0.5, s - 1, o - 1, 15.5), r.stroke({ width: 1, color: t ? 1251368 : 16777215, alpha: t ? 0.14 : 0.1 });
  const a = t ? 1251368 : 16777215;
  r.roundRect(15, 15, 36, 36, 12).fill({ color: a, alpha: t ? 0.05 : 0.06 }), r.roundRect(25, 25, 16, 16, 4).fill({ color: t ? 7680723 : 12756204, alpha: 0.55 }), r.roundRect(61, 21, 46, 5, 2.5).fill({ color: a, alpha: t ? 0.3 : 0.22 }), r.roundRect(61, 32, Math.min(130, 30 + (e.name || "").length * 6.4), 9, 4.5).fill({ color: a, alpha: t ? 0.75 : 0.78 }), r.roundRect(s - 15 - 30, 24, 30, 18, 9).fill({ color: a, alpha: t ? 0.06 : 0.05 }), r.roundRect(15, o - 15 - 6, 70, 5, 2.5).fill({ color: a, alpha: t ? 0.25 : 0.2 });
  const l = Kp(), d = (e.thumbs || []).slice(0, 4);
  for (let c = d.length; c < 4; c++) {
    const u = l[c];
    r.roundRect(u.x, u.y, u.s, u.s, 8).stroke({ width: 1, color: a, alpha: 0.1 });
  }
  n.root.position.set(e.x, e.y), n.root.scale.set(i), n.root.zIndex = e.z;
}
function tQ(n, e, t) {
  const i = Kp();
  for (; n.thumbs.length > e; ) n.thumbs.pop().destroy();
  for (; n.thumbs.length < e; ) {
    const s = new ds(Ze.WHITE);
    n.root.addChild(s), n.thumbs.push(s);
  }
  n.thumbs.forEach((s, o) => {
    const r = i[o], a = t(o);
    (s.texture === Ze.WHITE || !s.texture) && (s.texture = a.texture, s.tint = a.tint), s.position.set(r.x, r.y), s.setSize(r.s, r.s);
  });
}
function nQ(n, e, t) {
  const i = e.w || Ua.w, s = e.h || Ua.h, o = n.g;
  o.clear(), o.roundRect(0, 0, i, s, 16), o.fill(t ? { color: 16777215, alpha: 1 } : { color: 10053855, alpha: 0.1 }), o.roundRect(0.5, 0.5, i - 1, s - 1, 15.5), o.stroke({ width: 1, color: t ? 7680723 : 12756204, alpha: t ? 0.3 : 0.24 });
  const r = t ? 1251368 : 16777215;
  o.roundRect(15, 15, 36, 36, 12).fill({ color: r, alpha: t ? 0.05 : 0.06 }), o.roundRect(24, 26, 18, 13, 4).fill({ color: t ? 7680723 : 12756204, alpha: 0.6 }), o.roundRect(61, 21, 40, 5, 2.5).fill({ color: r, alpha: t ? 0.3 : 0.22 }), o.roundRect(61, 32, Math.min(130, 30 + (e.name || "").length * 6.4), 9, 4.5).fill({ color: r, alpha: t ? 0.75 : 0.78 }), o.roundRect(i - 15 - 30, 24, 30, 18, 9).fill({ color: r, alpha: t ? 0.06 : 0.05 }), o.roundRect(15, 68, i - 30, 7, 3.5).fill({ color: r, alpha: t ? 0.4 : 0.32 }), o.roundRect(15, 84, (i - 30) * 0.66, 7, 3.5).fill({ color: r, alpha: t ? 0.4 : 0.32 }), o.roundRect(15, s - 15 - 6, 70, 5, 2.5).fill({ color: r, alpha: t ? 0.25 : 0.2 }), n.root.position.set(e.x, e.y), n.root.scale.set(1), n.root.zIndex = e.z;
}
function iQ(n, e) {
  const t = { color: 15132910, alpha: 1 };
  if (n.type === "tool") return e ? t : { color: 16777215, alpha: 0.09 };
  if (n.type === "chat") return e ? t : { color: 10053855, alpha: 0.16 };
  const i = qp[n.tint] || qp.glass;
  return e && n.tint === "glass" ? t : { color: i.fill, alpha: (e ? i.fillA * 1.4 : i.fillA) + 0.05 };
}
function sQ(n, e, t) {
  const i = n.g, s = qp[e.tint] || qp.glass;
  i.clear(), i.roundRect(0, 0, e.w, e.h, 16), t && e.tint === "glass" ? i.fill({ color: 16777215, alpha: 1 }) : i.fill({ color: s.fill, alpha: t ? s.fillA * 1.4 : s.fillA }), i.roundRect(0.5, 0.5, e.w - 1, e.h - 1, 15.5), i.stroke({ width: 1, color: t && e.tint === "glass" ? 1251368 : s.line, alpha: t ? 0.3 : s.lineA });
  const o = t ? 1251368 : 16777215, r = e.w - 32, a = Math.max(4, Math.floor(r / 7.1)), l = Math.max(0, Math.floor((e.h - 32 - 20) / 19.6));
  let d = 0;
  for (const c of String(e.text || "").split(`
`)) {
    const u = c.trim().length;
    if (!u) {
      d++;
      continue;
    }
    const p = Math.ceil(u / a);
    for (let f = 0; f < p && d < l; f++, d++) {
      const y = f === p - 1 ? u - a * f : a;
      i.roundRect(16, 16 + d * 19.6 + 6, Math.max(10, y / a * r), 7, 3.5).fill({ color: o, alpha: t ? 0.55 : 0.5 });
    }
    if (d >= l) break;
  }
  i.roundRect(16, e.h - 16 - 7, 16, 6, 3).fill({ color: o, alpha: 0.22 }), n.root.position.set(e.x, e.y), n.root.scale.set(1), n.root.zIndex = e.z;
}
var oQ = Object.defineProperty, rQ = (n, e, t) => e in n ? oQ(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, mt = (n, e, t) => rQ(n, typeof e != "symbol" ? e + "" : e, t);
const C2 = 10053855, aQ = 12, I2 = 650, lQ = 0.05, dQ = 0.06;
class cQ {
  constructor(e) {
    mt(this, "app"), mt(this, "camera", { x: 0, y: 0, zoom: 1 }), mt(this, "viewW", 1), mt(this, "viewH", 1), mt(this, "dpr", 1), mt(this, "theme"), mt(this, "opts"), mt(this, "store"), mt(this, "world"), mt(this, "frameLayer"), mt(this, "imageLayer"), mt(this, "shapeLayer"), mt(this, "cardLayer"), mt(this, "screenLayer"), mt(this, "far", !1), mt(this, "simple", !1), mt(this, "rings"), mt(this, "textures"), mt(this, "micro", new qZ()), mt(this, "nodes", /* @__PURE__ */ new Map()), mt(this, "unsub", null), mt(this, "resizeObs", null), mt(this, "raf", 0), mt(this, "paused", !1), mt(this, "ringsDirty", !0), mt(this, "cameraChanged", !0), mt(this, "lastCameraMove", 0), mt(this, "settledPass", !1), mt(this, "tween", null), mt(this, "visibleIds", /* @__PURE__ */ new Set()), mt(this, "lastCull", null), mt(this, "selection", /* @__PURE__ */ new Set()), mt(this, "dragging", !1), mt(this, "hoverId", null), mt(this, "hidden", /* @__PURE__ */ new Set()), mt(this, "enteringUntil", 0), mt(this, "destroyed", !1), mt(this, "frameTimes", []), mt(this, "lastFrameAt", 0), mt(this, "lastRenderMs", 0), mt(this, "statsAt", 0), mt(this, "ready"), this.opts = e, this.store = e.store, this.theme = e.theme || "dark", this.ready = this.init();
  }
  // ------------------------------------------------------------- setup
  async init() {
    const e = this.opts.host;
    this.dpr = Math.min(2, window.devicePixelRatio || 1);
    const t = e.getBoundingClientRect();
    this.viewW = Math.max(1, t.width), this.viewH = Math.max(1, t.height);
    const i = new SS();
    if (await i.init({
      width: this.viewW,
      height: this.viewH,
      resolution: this.dpr,
      autoDensity: !0,
      antialias: !0,
      backgroundAlpha: 0,
      autoStart: !1,
      sharedTicker: !1,
      preference: "webgl",
      powerPreference: "high-performance",
      eventMode: "none"
    }), this.destroyed) {
      i.destroy(!0);
      return;
    }
    this.app = i, i.ticker.stop();
    const s = i.canvas;
    s.className = "bd-canvas", e.appendChild(s), i.stage.eventMode = "none", this.world = new un({ isRenderGroup: !0 }), this.frameLayer = new un(), this.imageLayer = new un(), this.imageLayer.sortableChildren = !0, this.shapeLayer = new un(), this.shapeLayer.sortableChildren = !0, this.frameLayer.sortableChildren = !0, this.cardLayer = new un(), this.cardLayer.sortableChildren = !0, this.cardLayer.visible = this.far, this.world.addChild(this.frameLayer, this.imageLayer, this.shapeLayer, this.cardLayer), this.screenLayer = new un(), this.rings = new Ro(), this.screenLayer.addChild(this.rings), i.stage.addChild(this.world, this.screenLayer);
    const o = (navigator.deviceMemory || 8) <= 4;
    this.textures = new GZ({
      budgetBytes: (o ? 160 : 420) * 1024 * 1024,
      maxInFlight: 10,
      radius: aQ,
      onReady: () => this.requestRender(),
      onError: (r, a) => console.warn("[board] image failed to load", r, a)
    }), this.resizeObs = new ResizeObserver(() => this.resize()), this.resizeObs.observe(e);
    for (const r of this.store.all()) this.addNode(r, !1);
    this.unsub = this.store.subscribe((r) => this.onChange(r)), this.requestRender();
  }
  resize() {
    if (!this.app) return;
    const e = this.opts.host.getBoundingClientRect(), t = Math.max(1, e.width), i = Math.max(1, e.height);
    t === this.viewW && i === this.viewH || (this.viewW = t, this.viewH = i, this.app.renderer.resize(t, i), this.cameraChanged = !0, this.requestRender());
  }
  destroy() {
    this.destroyed = !0, cancelAnimationFrame(this.raf), this.unsub && this.unsub(), this.resizeObs && this.resizeObs.disconnect(), this.textures && this.textures.destroy(), this.micro.destroy(), this.app && this.app.destroy(!0, { children: !0 }), this.nodes.clear();
  }
  // ------------------------------------------------------------ camera
  setCamera(e) {
    this.tween = null, this.applyCamera(e);
  }
  applyCamera(e) {
    const t = No(e.zoom);
    !Number.isFinite(e.x) || !Number.isFinite(e.y) || t === this.camera.zoom && e.x === this.camera.x && e.y === this.camera.y || (this.camera = { x: e.x, y: e.y, zoom: t }, this.cameraChanged = !0, this.ringsDirty = !0, this.lastCameraMove = performance.now(), this.settledPass = !1, this.requestRender());
  }
  /** Glide to a camera with the design's ease-out curve. */
  animateCamera(e, t = 420) {
    const i = { ...e, zoom: No(e.zoom) };
    return t <= 0 || matchMedia("(prefers-reduced-motion: reduce)").matches ? (this.setCamera(i), Promise.resolve()) : (this.tween && this.tween.resolve(), new Promise((s) => {
      this.tween = { from: { ...this.camera }, to: i, start: performance.now(), ms: t, resolve: s }, this.requestRender();
    }));
  }
  get isAnimatingCamera() {
    return !!this.tween;
  }
  /** Where the camera is headed: a glide's end while one is under way, else where it is. */
  get cameraGoal() {
    return this.tween ? this.tween.to : this.camera;
  }
  zoomAt(e, t, i) {
    this.setCamera(sv(this.tween ? this.tween.to : this.camera, e, t, i));
  }
  panBy(e, t) {
    const i = this.camera;
    this.setCamera({ zoom: i.zoom, x: i.x + e, y: i.y + t });
  }
  fitTo(e, t = {}) {
    if (!e) return Promise.resolve();
    const i = zf(e, this.viewW, this.viewH, t.pad == null ? 120 : t.pad, t.maxZoom == null ? 1 : t.maxZoom);
    return this.animateCamera(i, t.animate == null ? 420 : t.animate);
  }
  screenToWorld(e, t) {
    return iv(this.camera, e, t);
  }
  get moving() {
    return !!this.tween || performance.now() - this.lastCameraMove < 160;
  }
  // ------------------------------------------------------------- state
  setTheme(e) {
    if (this.theme !== e) {
      this.theme = e;
      for (const t of this.nodes.values())
        t.kind === "frame" && this.drawFrame(t), t.kind === "image" && !t.loaded && (t.sprite.tint = this.placeholderTint(t.el)), t.kind === "card" && this.drawCard(t);
      this.ringsDirty = !0, this.requestRender();
    }
  }
  setSelection(e) {
    this.selection = new Set(e), this.ringsDirty = !0, this.requestRender();
  }
  /** A drag is moving the selection: a shape's square box steps aside while it moves (IL-100). */
  setDragging(e) {
    e !== this.dragging && (this.dragging = e, this.ringsDirty = !0, this.requestRender());
  }
  /** The hovered image lifts 4px and casts a deeper shadow. */
  setHover(e) {
    if (e === this.hoverId) return;
    const t = this.hoverId ? this.nodes.get(this.hoverId) : null;
    t && t.kind === "image" && (t.liftTarget = 0), this.hoverId = e;
    const i = e ? this.nodes.get(e) : null;
    i && i.kind === "image" && !this.selection.has(e) && (i.liftTarget = 1), this.requestRender();
  }
  /** Hide elements another layer is drawing (e.g. while dragged as DOM). */
  setHidden(e) {
    this.hidden = new Set(e);
    for (const t of this.nodes.values()) this.applyVisibility(t);
    this.requestRender();
  }
  /**
   * Far zoom: the engine draws tool sessions and notes itself (cheap
   * stand-ins) and the DOM layer stands down; near, the reverse.
   */
  setFar(e) {
    this.far !== e && (this.far = e, this.cardLayer.visible = e, this.ringsDirty = !0, this.requestRender());
  }
  get isFar() {
    return this.far;
  }
  /** Play the board's entrance: elements rise in with a short stagger. */
  playEntrance() {
    const e = performance.now(), i = Array.from(this.nodes.values()).sort((o, r) => o.el.y - r.el.y || o.el.x - r.el.x).filter((o) => this.isInView(o.el)), s = Math.min(45, 900 / Math.max(1, i.length));
    i.forEach((o, r) => {
      o.enter = e + r * s;
    }), this.enteringUntil = e + i.length * s + I2, this.requestRender();
  }
  // ------------------------------------------------------------ queries
  /** Topmost GPU-drawn element under a screen point (images, shapes, frames). */
  hitTest(e, t) {
    const i = this.screenToWorld(e, t), s = 10 / this.camera.zoom, o = this.store.index.queryPoint(i.x, i.y, s);
    let r = null, a = -1 / 0;
    for (const l of o) {
      const d = this.store.get(l);
      if (!d || this.hidden.has(l)) continue;
      let c;
      if (d.type === "shape") {
        if (!AF(d, i.x, i.y, Math.max(d.sw / 2 + 2 / this.camera.zoom, 7 / this.camera.zoom))) continue;
        c = 3e9 + d.z;
      } else if (d.type === "image") {
        const u = qe(d);
        if (i.x < u.x || i.y < u.y || i.x > u.x + u.w || i.y > u.y + u.h) continue;
        c = 2e9 + d.z;
      } else if (d.type === "frame") {
        const u = qe(d);
        if (i.x < u.x || i.y < u.y || i.x > u.x + u.w || i.y > u.y + u.h) continue;
        c = 1e9 + d.z;
      } else if (this.far && (d.type === "tool" || d.type === "note" || d.type === "chat")) {
        const u = qe(d);
        if (i.x < u.x || i.y < u.y || i.x > u.x + u.w || i.y > u.y + u.h) continue;
        c = 4e9 + d.z;
      } else
        continue;
      c > a && (a = c, r = d);
    }
    return r;
  }
  isInView(e, t = 0) {
    const i = Xa(this.camera, this.viewW, this.viewH, t), s = qe(e);
    return s.x < i.x + i.w && s.x + s.w > i.x && s.y < i.y + i.h && s.y + s.h > i.y;
  }
  textureStats() {
    return {
      textures: (this.textures ? this.textures.textureCount : 0) + this.micro.pageCount,
      mb: Math.round(((this.textures ? this.textures.totalBytes : 0) + this.micro.bytes) / 1048576),
      pending: this.textures ? this.textures.pending : 0
    };
  }
  // ---------------------------------------------------------- document
  onChange(e) {
    for (const t of e.removed) this.removeNode(t.id);
    for (const t of e.added) this.addNode(t, e.origin !== "load");
    for (const t of e.updated) this.updateNode(t.el, t.after);
    this.ringsDirty = !0, this.lastCull = null, this.requestRender();
  }
  addNode(e, t) {
    if (this.nodes.has(e.id)) return;
    const i = t ? performance.now() : 0;
    if (e.type === "image") {
      const s = new ds(ba(e.w, e.h));
      s.tint = this.placeholderTint(e);
      const o = {
        kind: "image",
        el: e,
        sprite: s,
        shown: null,
        loaded: !1,
        lift: 0,
        liftTarget: 0,
        fade: 1,
        under: null,
        shadow: null,
        visible: !1,
        enter: i,
        tiny: !1
      };
      this.layoutImage(o), this.imageLayer.addChild(s), this.textures.track(e.id, e.src, e.w, e.h), this.nodes.set(e.id, o), this.applyVisibility(o);
    } else if (e.type === "frame") {
      const s = new Ro(), o = { kind: "frame", el: e, g: s, rect: null, visible: !1, enter: i };
      this.drawFrame(o), this.frameLayer.addChild(s), this.nodes.set(e.id, o), this.applyVisibility(o);
    } else if (e.type === "tool" || e.type === "note" || e.type === "chat") {
      const s = QZ(), o = { kind: "card", el: e, proxy: s, thumbShown: [], rect: null, visible: !1, enter: i };
      this.drawCard(o), this.cardLayer.addChild(s.root), this.nodes.set(e.id, o), this.applyVisibility(o);
    } else if (e.type === "shape") {
      const s = new Ro(), o = { kind: "shape", el: e, g: s, visible: !1, enter: i };
      rw(s, e), s.position.set(e.x, e.y), s.zIndex = e.z, this.shapeLayer.addChild(s), this.nodes.set(e.id, o), this.applyVisibility(o);
    }
  }
  updateNode(e, t) {
    const i = this.nodes.get(e.id);
    if (i) {
      if (i.kind === "image") {
        const s = e;
        ("src" in t || "w" in t || "h" in t) && (this.textures.track(s.id, s.src, s.w, s.h), this.micro.remove(s.id), i.tiny && this.enterTiny(i)), ("w" in t || "h" in t) && !i.loaded && !i.tiny && (i.sprite.texture = ba(s.w, s.h)), "color" in t && !i.loaded && (i.sprite.tint = this.placeholderTint(s)), this.layoutImage(i);
      } else if (i.kind === "frame")
        this.drawFrame(i);
      else if (i.kind === "card") {
        if ("thumbs" in t) {
          for (let s = 0; s < 4; s++) this.textures.untrack(this.thumbKey(i.el.id, s));
          i.thumbShown = [];
          for (const s of i.proxy.thumbs) s.texture = Ze.WHITE;
        }
        this.drawCard(i);
      } else
        rw(i.g, i.el), i.g.position.set(i.el.x, i.el.y), i.g.zIndex = i.el.z;
      this.applyVisibility(i);
    }
  }
  removeNode(e) {
    const t = this.nodes.get(e);
    if (t)
      if (this.nodes.delete(e), this.visibleIds.delete(e), t.kind === "image")
        t.sprite.destroy(), t.under && t.under.destroy(), t.shadow && t.shadow.destroy(), this.textures.untrack(e), this.micro.remove(e);
      else if (t.kind === "card") {
        for (let i = 0; i < 4; i++) this.textures.untrack(this.thumbKey(e, i));
        t.proxy.root.destroy({ children: !0 }), t.rect && t.rect.destroy();
      } else
        t.kind === "frame" && t.rect && t.rect.destroy(), t.g.destroy();
  }
  placeholderTint(e) {
    const t = e.color || JZ(e.src);
    if (t && /^#[0-9a-f]{6}$/i.test(t)) {
      const i = parseInt(t.slice(1), 16), s = this.theme === "light" ? 0.92 : 0.82;
      return Math.round((i >> 16 & 255) * s) << 16 | Math.round((i >> 8 & 255) * s) << 8 | Math.round((i & 255) * s);
    }
    return this.theme === "light" ? 14672618 : 1777456;
  }
  layoutImage(e) {
    const t = e.el, i = e.sprite;
    i.position.set(t.x, t.y - 4 * e.lift), i.setSize(t.w, t.h), i.zIndex = t.z, e.under && (e.under.position.copyFrom(i.position), e.under.setSize(t.w, t.h), e.under.zIndex = t.z - 1e-4), e.shadow && this.layoutShadow(e);
  }
  layoutShadow(e) {
    const t = e.shadow, i = e.el, s = 1 + 0.18 * e.lift, o = YZ * s * 0.5;
    t.position.set(i.x - o, i.y - o + 18 + 6 * e.lift - 4 * e.lift), t.setSize(i.w + o * 2, i.h + o * 2), t.alpha = (this.theme === "light" ? 0.22 : 0.3) + 0.14 * e.lift, t.zIndex = i.z - 2e-4;
  }
  thumbKey(e, t) {
    return e + "#t" + t;
  }
  drawCard(e) {
    const t = this.theme === "light";
    if (e.el.type === "tool") {
      const i = e.el;
      eQ(e.proxy, i, t);
      const s = (i.thumbs || []).slice(0, 4), o = Kp()[0].s;
      s.forEach((r, a) => this.textures.track(this.thumbKey(i.id, a), r, o, o)), tQ(e.proxy, s.length, (r) => ({
        texture: ba(1, 1),
        tint: this.placeholderTint({ src: s[r] })
      }));
    } else e.el.type === "chat" ? nQ(e.proxy, e.el, t) : sQ(e.proxy, e.el, t);
    (e.rect || this.simple) && this.layoutRect(e);
  }
  /** A frame's or card's plain-rectangle stand-in (see SIMPLE_IN), made on first use. */
  layoutRect(e) {
    e.rect || (e.rect = new ds(Ze.WHITE), e.rect.visible = !1, (e.kind === "frame" ? this.frameLayer : this.cardLayer).addChild(e.rect));
    const t = this.theme === "light", i = qe(e.el), s = e.kind === "frame" ? { color: 16777215, alpha: t ? 0.62 : 0.03 } : iQ(e.el, t);
    e.rect.position.set(i.x, i.y), e.rect.setSize(i.w, i.h), e.rect.tint = s.color, e.rect.alpha = s.alpha, e.rect.zIndex = e.el.z;
  }
  setSimple(e) {
    this.simple = e;
    for (const t of this.nodes.values())
      t.kind !== "frame" && t.kind !== "card" || (e && this.layoutRect(t), this.applyVisibility(t));
  }
  drawFrame(e) {
    const t = e.el, i = e.g, s = this.theme === "light";
    i.clear(), i.roundRect(0, 0, t.w, t.h, 24), i.fill({ color: 16777215, alpha: s ? 0.62 : 0.022 }), i.roundRect(0.5, 0.5, t.w - 1, t.h - 1, 23.5), i.stroke({ width: 1, color: s ? 1251368 : 16777215, alpha: s ? 0.14 : 0.06 }), i.position.set(t.x, t.y), i.zIndex = t.z, (e.rect || this.simple) && this.layoutRect(e);
  }
  applyVisibility(e) {
    const t = e.visible && !this.hidden.has(e.el.id);
    e.kind === "image" ? (e.sprite.visible = t, e.under && (e.under.visible = t), e.shadow && (e.shadow.visible = t)) : e.kind === "card" ? (e.proxy.root.visible = t && !this.simple, e.rect && (e.rect.visible = t && this.simple)) : e.kind === "frame" ? (e.g.visible = t && !this.simple, e.rect && (e.rect.visible = t && this.simple)) : e.g.visible = t;
  }
  // --------------------------------------------------------- screenshots
  /**
   * The board as it is on screen now, read back from the GPU into a 2D canvas
   * (a feedback report's screenshot). The WebGL canvas is made without
   * preserveDrawingBuffer, which would cost every frame, so a copy of it taken
   * after the browser presents is blank: this renders the stage itself, in
   * this task. Null before the engine is ready or once it's gone.
   */
  snapshot() {
    if (!this.app || this.destroyed) return null;
    this.cameraChanged && (this.world.position.set(this.camera.x, this.camera.y), this.world.scale.set(this.camera.zoom));
    const e = this.app.renderer.extract.canvas({
      target: this.app.stage,
      frame: new _t(0, 0, this.viewW, this.viewH),
      resolution: this.dpr,
      antialias: !0
    });
    return e instanceof HTMLCanvasElement ? e : null;
  }
  /** The last 90 frame intervals (ms), oldest first: a feedback report's frame-time history. */
  frameIntervals() {
    return this.frameTimes.slice();
  }
  /** The GPU as this board's WebGL context names it, for a feedback report; null where the browser won't say. */
  gpu() {
    if (!this.app || this.destroyed || !("gl" in this.app.renderer)) return null;
    const e = this.app.renderer.gl, t = e.getExtension("WEBGL_debug_renderer_info"), i = t ? e.getParameter(t.UNMASKED_RENDERER_WEBGL) : e.getParameter(e.RENDERER);
    return typeof i == "string" ? i : null;
  }
  // ------------------------------------------------------------- frame
  requestRender() {
    !this.raf && !this.destroyed && !this.paused && (this.raf = requestAnimationFrame((e) => this.frame(e)));
  }
  /**
   * Covered (the Studios view is open over the board): draw nothing, not
   * even textures still arriving, until it's uncovered; then carry on.
   */
  setPaused(e) {
    this.paused !== e && (this.paused = e, e ? (this.raf && cancelAnimationFrame(this.raf), this.raf = 0) : this.requestRender());
  }
  frame(e) {
    if (this.raf = 0, this.destroyed || !this.app) return;
    const t = performance.now();
    let i = !1;
    if (this.tween) {
      const r = this.tween, a = Math.min(1, (e - r.start) / r.ms);
      this.applyCamera(_F(r.from, r.to, Cm(a), this.viewW, this.viewH)), a >= 1 ? (this.tween = null, this.applyCamera(r.to), r.resolve()) : i = !0;
    }
    const s = this.moving;
    if (this.cameraChanged) {
      this.world.position.set(this.camera.x, this.camera.y), this.world.scale.set(this.camera.zoom), this.opts.onCamera && this.opts.onCamera(this.camera, s), this.cameraChanged = !1;
      const r = this.camera.zoom < (this.simple ? dQ : lQ);
      r !== this.simple && this.setSimple(r);
    }
    this.cull();
    const o = !s;
    this.updateTextures(o && !this.settledPass), o && (this.settledPass = !0), this.textures.pending && (i = !0), this.animate(e) && (i = !0), this.ringsDirty && this.drawRings(), this.textures.tick(), this.micro.flush(), this.app.render(), s && (i = !0), i && this.requestRender(), this.recordStats(e, performance.now() - t);
  }
  cull() {
    const e = Xa(this.camera, this.viewW, this.viewH, 0), t = this.lastCull;
    if (t && e.x >= t.x && e.y >= t.y && e.x + e.w <= t.x + t.w && e.y + e.h <= t.y + t.h && t.w < e.w * 2.2)
      return;
    const i = e.w * 0.35, s = e.h * 0.35, o = { x: e.x - i, y: e.y - s, w: e.w + i * 2, h: e.h + s * 2 };
    this.lastCull = o;
    const r = this.store.index.query(o), a = /* @__PURE__ */ new Set();
    for (const l of r) this.nodes.has(l) && a.add(l);
    for (const l of this.visibleIds)
      if (!a.has(l)) {
        const d = this.nodes.get(l);
        d && (d.visible = !1, this.applyVisibility(d));
      }
    for (const l of a)
      if (!this.visibleIds.has(l)) {
        const d = this.nodes.get(l);
        d.visible = !0, this.applyVisibility(d);
      }
    this.visibleIds = a;
  }
  updateTextures(e) {
    const t = this.camera.zoom, i = this.dpr, s = (this.viewW / 2 - this.camera.x) / t, o = (this.viewH / 2 - this.camera.y) / t, r = Xa(this.camera, this.viewW, this.viewH, 0), a = !this.moving, l = (d) => {
      const c = this.nodes.get(d);
      return !!c && c.kind === "image" && c.tiny;
    };
    for (const d of this.textures.drainReady(a ? 10 : 5, a ? 12 * 1048576 : 5 * 1048576, l, 64)) {
      const c = d.id.indexOf("#t");
      if (c > 0) {
        const p = this.nodes.get(d.id.slice(0, c)), f = Number(d.id.slice(c + 2));
        p && p.kind === "card" && p.proxy.thumbs[f] && (p.proxy.thumbs[f].texture = d.tex.texture, p.proxy.thumbs[f].tint = 16777215, p.thumbShown[f] = d.tex);
        continue;
      }
      const u = this.nodes.get(d.id);
      u && u.kind === "image" && (d.color && ZZ(u.el.src, d.color), u.tiny ? this.fillCell(u, d.tex) : this.consider(u, d.tex));
    }
    for (const d of this.textures.takeEvicted()) {
      const c = d.id.indexOf("#t");
      if (c > 0) {
        const p = this.nodes.get(d.id.slice(0, c)), f = Number(d.id.slice(c + 2));
        p && p.kind === "card" && p.proxy.thumbs[f] && p.proxy.thumbs[f].texture === d.texture && (p.proxy.thumbs[f].texture = ba(1, 1), p.thumbShown[f] = null), this.textures.release(d.texture);
        continue;
      }
      const u = this.nodes.get(d.id);
      if (u && u.kind === "image" && u.shown && u.shown.texture === d.texture) {
        const p = this.textures.anyFor(d.id);
        p ? this.show(u, p, !1) : this.showPlaceholder(u);
      }
      this.textures.release(d.texture);
    }
    if (this.visibleIds.size) {
      for (const d of this.visibleIds) {
        const c = this.nodes.get(d);
        if (c && c.kind === "card" && this.far && c.el.type === "tool" && t >= 0.08) {
          const S = c.el, _ = Kp()[0].s * (S.scale || 1), x = Math.min(4, (S.thumbs || []).length);
          for (let T = 0; T < x; T++) {
            const M = this.textures.request(this.thumbKey(S.id, T), _ * t * i, 1e12, a || e);
            M && M !== c.thumbShown[T] && c.proxy.thumbs[T] && (c.proxy.thumbs[T].texture = M.texture, c.proxy.thumbs[T].tint = 16777215, c.thumbShown[T] = M);
          }
          continue;
        }
        if (!c || c.kind !== "image") continue;
        const u = c.el;
        if (!(u.x < r.x + r.w && u.x + u.w > r.x && u.y < r.y + r.h && u.y + u.h > r.y)) continue;
        const f = Math.max(u.w, u.h) * t * i, y = u.x + u.w / 2 - s, b = u.y + u.h / 2 - o, w = (y * y + b * b) * t * t - f * f * 0.25;
        if (f <= Qr || c.tiny && f <= Qr * 1.25) {
          if (c.tiny || this.enterTiny(c), !this.micro.has(d)) {
            const S = this.textures.anyFor(d);
            S ? this.fillCell(c, S) : this.textures.request(d, f, w, a || e);
          }
          continue;
        }
        c.tiny && this.leaveTiny(c);
        const k = this.textures.request(d, f, w, a || e);
        k && k !== c.shown && this.consider(c, k);
      }
      this.textures.pump();
    }
  }
  /** Tiny on screen: draw from the shared atlas, its cell or (until that fills) the tinted blank. */
  enterTiny(e) {
    e.under && (e.under.destroy(), e.under = null), e.fade = 1, e.sprite.alpha = 1, e.tiny = !0, e.shown = null;
    const t = this.micro.get(e.el.id);
    e.sprite.texture = t || this.micro.placeholder, e.sprite.tint = t ? 16777215 : this.placeholderTint(e.el), e.loaded = !!t, this.layoutImage(e);
  }
  /** Big enough for its own texture again: the best rendition loaded, else the thumbnail stretched. */
  leaveTiny(e) {
    e.tiny = !1;
    const t = this.textures.anyFor(e.el.id), i = this.micro.get(e.el.id);
    t ? (e.sprite.texture = t.texture, e.shown = t) : i ? e.sprite.texture = i : e.sprite.texture = ba(e.el.w, e.el.h), e.loaded = !!(t || i), e.sprite.tint = e.loaded ? 16777215 : this.placeholderTint(e.el), this.layoutImage(e);
  }
  fillCell(e, t) {
    const i = t.texture.source.resource;
    i && (e.sprite.texture = this.micro.put(e.el.id, i, e.el.w, e.el.h), e.sprite.tint = 16777215, e.loaded = !0, this.layoutImage(e), this.requestRender());
  }
  consider(e, t) {
    if (e.shown !== t) {
      if (e.shown && e.shown.tier > t.tier) {
        const i = Math.max(e.el.w, e.el.h) * this.camera.zoom * this.dpr;
        if (e.shown.tier < i * 4) return;
      }
      this.show(e, t, !e.loaded);
    }
  }
  show(e, t, i) {
    i && !matchMedia("(prefers-reduced-motion: reduce)").matches && (e.under || (e.under = new ds(e.sprite.texture), e.under.tint = e.sprite.tint, this.imageLayer.addChild(e.under)), e.fade = 0, e.sprite.alpha = 0), e.sprite.texture = t.texture, e.sprite.tint = 16777215, e.shown = t, e.loaded = !0, this.layoutImage(e), this.applyVisibility(e), this.requestRender();
  }
  showPlaceholder(e) {
    e.sprite.texture = ba(e.el.w, e.el.h), e.sprite.tint = this.placeholderTint(e.el), e.shown = null, e.loaded = !1, this.layoutImage(e);
  }
  /** Advance per-node animations; true while any is still running. */
  animate(e) {
    let t = !1;
    const i = e < this.enteringUntil;
    for (const s of this.visibleIds) {
      const o = this.nodes.get(s);
      if (o) {
        if (o.kind === "image") {
          let r = !1;
          if (o.lift !== o.liftTarget) {
            const a = o.liftTarget - o.lift;
            o.lift = Math.abs(a) < 0.02 ? o.liftTarget : o.lift + a * 0.28, r = !0, t = !0, o.liftTarget > 0 && !o.shadow && (o.shadow = new DZ({
              texture: KZ(),
              leftWidth: 124,
              rightWidth: 124,
              topHeight: 124,
              bottomHeight: 124
            }), this.imageLayer.addChild(o.shadow)), o.lift === 0 && o.liftTarget === 0 && o.shadow && (o.shadow.destroy(), o.shadow = null);
          }
          o.fade < 1 && (o.fade = Math.min(1, o.fade + 0.09), o.sprite.alpha = Cm(o.fade), o.fade >= 1 && o.under && (o.under.destroy(), o.under = null), t = !0), r && this.layoutImage(o);
        }
        if (i || o.enter) {
          const r = o.enter ? Math.min(1, Math.max(0, (e - o.enter) / I2)) : 1, a = Cm(r), l = o.kind === "image" ? o.sprite : o.kind === "card" ? o.proxy.root : o.g, d = o.kind === "image" ? o.el.y - 4 * o.lift : o.el.y;
          l.y = d + 34 * (1 - a), o.kind === "image" ? o.fade >= 1 && (l.alpha = a) : l.alpha = a, r < 1 ? t = !0 : o.enter = 0;
        }
      }
    }
    return t;
  }
  drawRings() {
    this.ringsDirty = !1;
    const e = this.rings;
    if (e.clear(), !this.selection.size) return;
    const t = this.camera.zoom, i = this.theme === "light";
    for (const s of this.selection) {
      const o = this.nodes.get(s);
      if (!o || o.kind === "card" && !this.far) continue;
      const r = o.el;
      if (this.dragging && r.type === "shape") continue;
      let a = 3, l = 12 * t + 3;
      r.type === "frame" && (l = 24 * t + 3), (r.type === "tool" || r.type === "note" || r.type === "chat") && (l = 16 * t * (r.scale || 1) + 3), r.type === "shape" && (a = r.shape === "line" || r.shape === "arrow" ? 12 : 9, l = 10);
      const d = qe(r), c = d.x * t + this.camera.x - a, u = (d.y - (o.kind === "image" ? 4 * o.lift : 0)) * t + this.camera.y - a, p = d.w * t + a * 2, f = d.h * t + a * 2;
      e.roundRect(c - 2.75, u - 2.75, p + 5.5, f + 5.5, l + 2.75), e.stroke({ width: 4, color: C2, alpha: i ? 0.2 : 0.16 }), e.roundRect(c, u, p, f, l), e.stroke({ width: 1.5, color: C2, alpha: 1 });
    }
  }
  recordStats(e, t) {
    if (this.lastFrameAt) {
      const i = e - this.lastFrameAt;
      i < 250 && this.frameTimes.push(i), this.frameTimes.length > 90 && this.frameTimes.shift();
    }
    this.lastFrameAt = e, this.lastRenderMs = t, !(!this.opts.onStats || e - this.statsAt < 250) && (this.statsAt = e, this.opts.onStats(this.currentStats()));
  }
  /** What the stats readout shows, as of the last frame: a feedback report carries it too. */
  currentStats() {
    const e = this.frameTimes.length ? this.frameTimes.reduce((s, o) => s + o, 0) / this.frameTimes.length : 16.7;
    let t = 0;
    for (const s of this.nodes.values()) s.kind === "image" && t++;
    const i = this.textureStats();
    return {
      fps: Math.round(1e3 / e),
      frameMs: Math.round(this.lastRenderMs * 10) / 10,
      visible: this.visibleIds.size,
      images: t,
      textures: i.textures,
      textureMB: i.mb,
      pending: i.pending
    };
  }
}
function uQ() {
  return /* @__PURE__ */ Xt({
    mode: "select",
    selection: [],
    editingNote: null,
    editingTitle: null,
    marquee: null,
    panning: !1,
    dragging: !1,
    addMenu: !1,
    placeMenu: !1,
    canvasMenu: null,
    finder: null,
    libraryOpen: null,
    shapeKind: "rect",
    shapeArmed: !1,
    shapeMenu: !1,
    shapeStyle: { ...qs },
    styleOpen: !1,
    infoAt: null,
    infoSave: !1,
    infoSession: null,
    histOpen: !0,
    miniOpen: !0,
    miniGoing: !1,
    lightCanvas: !1,
    advOpen: !1,
    ghost: null,
    hoverId: null,
    newThumbs: {},
    recentIds: [],
    pinnedIds: [],
    pinnedModelIds: [],
    cameraViews: [],
    noteTint: "amethyst",
    promptH: null,
    boardMenu: !1,
    ctxMenu: !1,
    keysOpen: !1,
    trashOpen: !1,
    boardHistory: !1,
    chatOpen: null,
    toast: null,
    showStats: !1,
    refTarget: !1,
    eyedropper: null,
    refPulse: null,
    refSession: null,
    refGlow: null,
    studio: null,
    library: { open: !1, sessionId: null, tab: "featured", category: null, query: "", detail: null, levels: [], kind: null, action: null, at: null, editing: null, saveLevels: { board: !0, team: !1 } },
    promptLanded: null,
    promptCardH: 0
  });
}
const hQ = {
  lightCanvas: !1,
  shapeStyle: { ...qs },
  shapeKind: "rect",
  histOpen: !0,
  miniOpen: !0,
  recentIds: [],
  pinnedIds: [],
  pinnedModelIds: [],
  noteTint: "amethyst",
  camera: null,
  promptH: null,
  library: { tab: "featured", category: null },
  pinHintSeen: !1,
  cameraViews: []
}, XM = ["recentIds", "pinnedIds", "camera"], JM = ["lightCanvas", "shapeStyle", "shapeKind", "histOpen", "miniOpen", "noteTint", "promptH", "library", "pinHintSeen", "pinnedModelIds", "cameraViews"], ZM = (n, e) => "rd-board-prefs:" + n + ":" + e, QM = (n) => "rd-board-prefs:" + n;
function pQ(n, e) {
  let t = JSON.parse(JSON.stringify(hQ));
  try {
    const i = JSON.parse(localStorage.getItem(QM(n)) || "{}"), s = JSON.parse(localStorage.getItem(ZM(n, e)) || "{}");
    t = { ...t, ...Yp(i, JM), ...Yp(s, XM) };
  } catch {
  }
  return t;
}
function fQ(n, e, t) {
  try {
    localStorage.setItem(QM(n), JSON.stringify(Yp(t, JM))), localStorage.setItem(ZM(n, e), JSON.stringify(Yp(t, XM)));
  } catch {
  }
}
function Yp(n, e) {
  const t = {};
  if (!n || typeof n != "object") return t;
  for (const i of e) n[i] !== void 0 && (t[i] = n[i]);
  return t;
}
var mQ = Object.defineProperty, gQ = (n, e, t) => e in n ? mQ(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Ku = (n, e, t) => gQ(n, typeof e != "symbol" ? e + "" : e, t);
class bQ {
  constructor() {
    Ku(this, "bySession", /* @__PURE__ */ new Map()), Ku(this, "byId", /* @__PURE__ */ new Map()), Ku(this, "rev", /* @__PURE__ */ We(0)), Ku(this, "listeners", /* @__PURE__ */ new Set());
  }
  list(e) {
    return this.bySession.get(e) || [];
  }
  get(e) {
    return this.byId.get(e);
  }
  get size() {
    return this.byId.size;
  }
  /**
   * Insert or replace, keeping each list newest first. Lists are
   * copy-on-write: a changed session gets a new array, so anything that
   * derives from list() sees the change.
   */
  upsert(e, t = !0) {
    if (!e.length) return;
    const i = /* @__PURE__ */ new Map();
    for (const s of e) {
      const o = this.byId.get(s.id);
      this.byId.set(s.id, s);
      let r = i.get(s.sessionId);
      r || (r = (this.bySession.get(s.sessionId) || []).slice(), i.set(s.sessionId, r));
      const a = o ? r.indexOf(o) : -1;
      a >= 0 ? r[a] = s : r.push(s);
    }
    for (const [s, o] of i)
      o.sort((r, a) => a.createdAt - r.createdAt), this.bySession.set(s, o);
    if (this.rev.value++, os(this.rev), t) for (const s of this.listeners) s(e);
  }
  /**
   * A run's results as they now are: its placeholders give way to its
   * results, or to nothing if it failed. One change for the lot.
   */
  replaceRun(e, t) {
    const i = [];
    for (const s of this.byId.values()) s.runId === e && !t.some((o) => o.id === s.id) && i.push(s.id);
    i.length && this.drop(i), t.length ? this.upsert(t, !1) : i.length && this.bump();
  }
  /** Every result of a run, in its order. */
  ofRun(e) {
    const t = [];
    for (const i of this.byId.values()) i.runId === e && t.push(i);
    return t.sort((i, s) => i.createdAt - s.createdAt);
  }
  drop(e) {
    const t = /* @__PURE__ */ new Set();
    for (const i of e) {
      const s = this.byId.get(i);
      s && (this.byId.delete(i), t.add(s.sessionId));
    }
    for (const i of t) this.bySession.set(i, (this.bySession.get(i) || []).filter((s) => this.byId.has(s.id)));
  }
  bump() {
    this.rev.value++, os(this.rev);
  }
  remove(e) {
    const t = /* @__PURE__ */ new Set();
    for (const i of e) {
      const s = this.byId.get(i);
      s && (this.byId.delete(i), t.add(s.sessionId));
    }
    for (const i of t) this.bySession.set(i, (this.bySession.get(i) || []).filter((s) => this.byId.has(s.id)));
    this.rev.value++, os(this.rev);
  }
  clear() {
    this.bySession.clear(), this.byId.clear(), this.rev.value++, os(this.rev);
  }
  /** Local changes, for the sync adapter to persist. */
  onLocalChange(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
}
const eC = 768;
function Go(n) {
  return new Promise((e, t) => {
    const i = new Image(), s = n.startsWith("data:") || n.startsWith("blob:");
    s || (i.crossOrigin = "anonymous"), i.onload = () => e(i), i.onerror = () => t(new Error("stand-in: picture not read")), i.src = s ? n : n + (n.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1";
  });
}
function jo(n, e) {
  if (typeof document == "undefined") return null;
  const t = document.createElement("canvas");
  t.width = Math.max(1, Math.round(n)), t.height = Math.max(1, Math.round(e));
  const i = t.getContext("2d");
  return i ? { c: t, x: i } : null;
}
function jf(n, e = eC) {
  const t = Math.min(1, e / Math.max(n.naturalWidth, n.naturalHeight));
  return { w: Math.round(n.naturalWidth * t), h: Math.round(n.naturalHeight * t) };
}
function Ds(n, e) {
  const t = n[e];
  return typeof t == "number" && Number.isFinite(t) ? t : null;
}
async function vQ(n) {
  const e = await Go(n), t = jf(e), i = jo(t.w, t.h);
  if (!i) return null;
  i.x.drawImage(e, 0, 0, t.w, t.h);
  const s = jo(t.w, t.h), o = s.x.createRadialGradient(t.w / 2, t.h * 0.55, Math.min(t.w, t.h) * 0.22, t.w / 2, t.h * 0.55, Math.min(t.w, t.h) * 0.46);
  return o.addColorStop(0, "rgba(0,0,0,1)"), o.addColorStop(0.85, "rgba(0,0,0,1)"), o.addColorStop(1, "rgba(0,0,0,0)"), s.x.fillStyle = o, s.x.fillRect(0, 0, t.w, t.h), i.x.globalCompositeOperation = "destination-in", i.x.drawImage(s.c, 0, 0), { url: i.c.toDataURL("image/png"), ...t };
}
async function yQ(n) {
  const e = await Go(n), t = 160, i = Math.max(1, Math.round(t * e.naturalHeight / e.naturalWidth)), s = jo(t, i);
  if (!s) return null;
  s.x.drawImage(e, 0, 0, t, i);
  const o = s.x.getImageData(0, 0, t, i).data, r = 7, a = [];
  for (let w = 0; w < r; w++) {
    const k = Math.floor((w + 0.5) / r * t * i) * 4;
    a.push([o[k], o[k + 1], o[k + 2]]);
  }
  const l = new Uint8Array(t * i);
  for (let w = 0; w < 8; w++) {
    const k = a.map(() => [0, 0, 0, 0]);
    for (let S = 0; S < t * i; S++) {
      const _ = o[S * 4], x = o[S * 4 + 1], T = o[S * 4 + 2];
      let M = 0, z = 1 / 0;
      for (let D = 0; D < r; D++) {
        const $ = (_ - a[D][0]) ** 2 + (x - a[D][1]) ** 2 + (T - a[D][2]) ** 2;
        $ < z && (z = $, M = D);
      }
      l[S] = M;
      const P = k[M];
      P[0] += _, P[1] += x, P[2] += T, P[3]++;
    }
    k.forEach((S, _) => {
      S[3] && (a[_] = [S[0] / S[3], S[1] / S[3], S[2] / S[3]]);
    });
  }
  const d = new Int32Array(t * i).fill(-1), c = [];
  let u = 0;
  const p = [];
  for (let w = 0; w < t * i; w++) {
    if (d[w] >= 0) continue;
    d[w] = u, p.push(w);
    let k = 0;
    for (; p.length; ) {
      const S = p.pop();
      k++;
      const _ = S % t, x = (S - _) / t, T = [_ > 0 ? S - 1 : -1, _ < t - 1 ? S + 1 : -1, x > 0 ? S - t : -1, x < i - 1 ? S + t : -1];
      for (const M of T)
        M < 0 || d[M] >= 0 || l[M] !== l[S] || (d[M] = u, p.push(M));
    }
    c.push(k), u++;
  }
  const f = t * i * 4e-3;
  for (let w = 0; w < 2; w++)
    for (let k = 0; k < t * i; k++) {
      if (c[d[k]] >= f) continue;
      const _ = k % t > 0 ? k - 1 : k + 1 < t * i ? k + 1 : k;
      c[d[_]] >= f && (d[k] = d[_]);
    }
  const y = /* @__PURE__ */ new Map(), b = s.x.createImageData(t, i);
  for (let w = 0; w < t * i; w++) {
    let k = y.get(d[w]);
    k === void 0 && (k = y.size + 1, y.set(d[w], k)), b.data[w * 4] = k & 255, b.data[w * 4 + 1] = k >> 8 & 255, b.data[w * 4 + 2] = 0, b.data[w * 4 + 3] = 255;
  }
  return s.x.putImageData(b, 0, 0), { url: s.c.toDataURL("image/png"), w: t, h: i };
}
async function xQ(n, e) {
  const t = await Go(n), i = jf(t), s = jo(i.w, i.h);
  if (!s) return null;
  if (s.x.drawImage(t, 0, 0, i.w, i.h), !e) return { url: s.c.toDataURL("image/jpeg", 0.88), ...i };
  const o = await Go(e), r = jo(i.w, i.h);
  return r.x.filter = "blur(" + Math.round(Math.max(i.w, i.h) / 22) + "px)", r.x.drawImage(t, -i.w * 0.06, -i.h * 0.06, i.w * 1.12, i.h * 1.12), r.x.filter = "none", r.x.globalCompositeOperation = "destination-in", r.x.filter = "blur(3px)", r.x.drawImage(o, 0, 0, i.w, i.h), s.x.drawImage(r.c, 0, 0), { url: s.c.toDataURL("image/jpeg", 0.88), ...i };
}
async function wQ(n, e) {
  const t = await Go(n), i = Ds(e, "canvasWidth"), s = Ds(e, "canvasHeight");
  if (!i || !s) return null;
  const o = Math.min(1, eC / Math.max(i, s)), r = Math.round(i * o), a = Math.round(s * o), l = jo(r, a);
  if (!l) return null;
  const d = (Ds(e, "imageWidth") || t.naturalWidth) * o, c = (Ds(e, "imageHeight") || t.naturalHeight) * o, u = (Ds(e, "imageX") || 0) * o, p = (Ds(e, "imageY") || 0) * o;
  return l.x.filter = "blur(" + Math.round(Math.max(r, a) / 18) + "px) saturate(1.05)", l.x.drawImage(t, -r * 0.05, -a * 0.05, r * 1.1, a * 1.1), l.x.filter = "none", l.x.drawImage(t, u, p, d, c), { url: l.c.toDataURL("image/jpeg", 0.88), w: r, h: a };
}
async function kQ(n, e) {
  var t, i, s;
  const o = await Go(n), r = jf(o), a = jo(r.w, r.h);
  if (!a) return null;
  const l = (t = Ds(e, "rotate")) != null ? t : 45, d = (i = Ds(e, "vertical")) != null ? i : 0, c = (s = Ds(e, "zoom")) != null ? s : 5, u = (l % 360 + 360) % 360, p = u > 180 ? u - 360 : u, f = Math.abs(p) > 120, y = 1 + (c - 5) * 0.06;
  return a.x.fillStyle = "#20222b", a.x.fillRect(0, 0, r.w, r.h), a.x.save(), a.x.translate(r.w / 2, r.h / 2), a.x.transform(1 - Math.abs(Math.sin(p * Math.PI / 180)) * 0.18, Math.sin(p * Math.PI / 180) * 0.12, 0, 1 - d / 90 * 0.12, 0, 0), a.x.scale(f ? -y : y, y), a.x.drawImage(o, -r.w / 2, -r.h / 2, r.w, r.h), a.x.restore(), { url: a.c.toDataURL("image/jpeg", 0.88), ...r };
}
async function _Q(n, e) {
  const t = await Go(n), i = jf(t), s = jo(i.w, i.h);
  if (!s) return null;
  s.x.drawImage(t, 0, 0, i.w, i.h);
  const o = /golden|warm|tungsten|candle|dusk|night/i.test(e), r = /from the (front )?left/i.test(e), a = s.x.createLinearGradient(r ? 0 : i.w, 0, r ? i.w : 0, i.h * 0.4);
  return a.addColorStop(0, o ? "rgba(255,170,80,0.55)" : "rgba(170,200,255,0.5)"), a.addColorStop(1, "rgba(10,8,30,0.55)"), s.x.globalCompositeOperation = "soft-light", s.x.fillStyle = a, s.x.fillRect(0, 0, i.w, i.h), /night|dusk|dark/i.test(e) && (s.x.globalCompositeOperation = "multiply", s.x.fillStyle = "rgba(40,50,110,0.5)", s.x.fillRect(0, 0, i.w, i.h)), { url: s.c.toDataURL("image/jpeg", 0.88), ...i };
}
let Yu = null;
function SQ() {
  if (Yu === null)
    try {
      Yu = typeof document != "undefined" && !!document.createElement("canvas").getContext("2d");
    } catch {
      Yu = !1;
    }
  return Yu;
}
function TQ(n, e, t) {
  return SQ() ? n === "removebg" || n === "select" || n === "erase" || n === "expand" || n === "camera" || e === "upscale" || /^Relighting only|^Relight image 1/.test(t) : !1;
}
async function MQ(n, e, t, i, s) {
  const o = t[0];
  if (!o || typeof document == "undefined") return null;
  try {
    if (n === "removebg") return await vQ(o);
    if (n === "select") return await yQ(o);
    if (n === "erase") return await xQ(o, typeof i.__mask == "string" ? i.__mask : null);
    if (n === "expand") return await wQ(o, i);
    if (n === "camera") return await kQ(o, i);
    if (e === "upscale") {
      const r = await Go(o);
      return { url: o, w: r.naturalWidth * 2, h: r.naturalHeight * 2 };
    }
    return /^Relighting only|^Relight image 1/.test(s) ? await _Q(o, s) : null;
  } catch (r) {
    return console.warn("[harness] no stand-in for this tool", r), null;
  }
}
var CQ = Object.defineProperty, IQ = (n, e, t) => e in n ? CQ(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Eg = (n, e, t) => IQ(n, typeof e != "symbol" ? e + "" : e, t);
const AQ = {
  "1:1": [1, 1],
  "3:4": [3, 4],
  "4:3": [4, 3],
  "16:9": [16, 9],
  "9:16": [9, 16],
  "2:3": [2, 3],
  "3:2": [3, 2]
};
function my(n, e = 316) {
  const t = n && AQ[n] || [4, 3];
  return t[0] >= t[1] ? { w: e, h: Math.round(e * t[1] / t[0]) } : { w: Math.round(e * t[0] / t[1]), h: e };
}
class PQ {
  /** `pool`: still images; `videoPool`: videos, each a poster and its playable file */
  constructor(e, t = []) {
    Eg(this, "pool", e), Eg(this, "videoPool", t), Eg(this, "cursor", 0);
  }
  run(e, t) {
    const i = kt(), s = e.model.kitId === "video", o = my(e.aspect || (s ? "16:9" : "3:4")), r = Math.max(1, Math.round(parseFloat(String(e.inputs.length || "5s")) || 5)), a = s ? Math.floor(r / 60) + ":" + String(r % 60).padStart(2, "0") : void 0, l = Date.now(), d = [];
    for (let b = 0; b < e.count; b++)
      d.push({
        id: kt(),
        sessionId: e.sessionId,
        status: "pending",
        url: "",
        w: o.w,
        h: o.h,
        prompt: e.prompt,
        model: e.model.name,
        modelId: e.model.id,
        inputs: e.inputs,
        refs: e.refs,
        seed: Math.floor(Math.random() * 1e9),
        author: e.author,
        createdAt: l + b,
        runId: i,
        parents: e.refs.slice(),
        video: s || void 0,
        dur: a
      });
    const c = [];
    let u = !1;
    const p = /\bfail\b/i.test(e.prompt), f = 1300 + Math.random() * 600, y = [];
    if (p)
      c.push(window.setTimeout(() => {
        u || t.onError("The provider rejected this prompt. No tokens were charged.", d);
      }, f));
    else {
      const b = TQ(e.model.boardTool, e.model.kitId, e.prompt);
      d.forEach((w, k) => {
        c.push(window.setTimeout(async () => {
          if (u) return;
          const S = b ? await MQ(e.model.boardTool, e.model.kitId, e.refs, e.inputs, e.prompt) : null;
          if (u) return;
          const _ = !S && s && this.videoPool.length ? this.videoPool[this.cursor++ % this.videoPool.length] : null, x = S ? S.url : _ ? _.poster : this.pool[this.cursor++ % this.pool.length], T = {
            ...w,
            status: "done",
            url: x,
            w: S ? S.w : w.w,
            h: S ? S.h : w.h,
            videoSrc: _ ? _.src : void 0,
            dur: a,
            took: Date.now() - l,
            label: EQ(e.prompt, k)
          };
          y.push(T), t.onResult(T), y.length === d.length && t.onDone(y);
        }, f + k * (260 + Math.random() * 220)));
      });
    }
    return {
      runId: i,
      pending: d,
      cancel: () => {
        u = !0;
        for (const b of c) clearTimeout(b);
      }
    };
  }
}
function EQ(n, e) {
  return (String(n || "result").toLowerCase().replace(/[^a-z0-9 ]+/g, " ").trim().split(/\s+/).slice(0, 4).join("_") || "result").slice(0, 24) + "_v" + String(e + 1).padStart(2, "0");
}
const kr = {
  image: "image",
  video: "video",
  imageEdit: "imageEdit",
  videoEdit: "videoEdit",
  upscale: "upscale",
  // Quoted key: an identifier cannot start with a digit, so this kit is
  // always reached as KIT_TYPE['3d'], unlike its dot-accessed siblings.
  "3d": "3d"
}, Vv = [
  kr.image,
  kr.video,
  kr.imageEdit,
  kr.videoEdit,
  kr.upscale,
  kr["3d"]
], A2 = (n) => typeof n == "string" && Object.prototype.hasOwnProperty.call(kr, n), RQ = "mdi-shape-outline", Rg = "Featured", zg = "Other", tC = (n) => {
  const e = {};
  if (!n || typeof n != "object") return e;
  for (const t of Object.keys(n))
    n[t] && (e[t] = !0);
  return e;
}, zQ = (n, e, t) => {
  if (!n || typeof n != "object") return null;
  const i = n, s = typeof i.label == "string" ? i.label : "", o = typeof i.icon == "string" ? i.icon : "";
  return !s && !o ? null : {
    // Heal a label authored without an id rather than dropping it. The id
    // is an opaque UI key, so a positional fallback is safe and stable
    // for a given stored array.
    id: typeof i.id == "string" && i.id ? i.id : `${t}:${e}`,
    icon: o,
    label: s,
    value: typeof i.value == "number" ? i.value : null,
    type: typeof i.type == "string" ? i.type : void 0,
    tooltip: typeof i.tooltip == "string" ? i.tooltip : void 0
  };
}, $Q = (n) => {
  if (!n || typeof n != "object") return null;
  const e = n, t = typeof e.nodeDefId == "string" ? e.nodeDefId.trim() : "";
  if (!t) return null;
  const i = Array.isArray(e.labels) ? e.labels.map((s, o) => zQ(s, o, t)).filter((s) => s !== null) : [];
  return { nodeDefId: t, tags: tC(e.tags), labels: i };
}, DQ = (n, e) => {
  if (!n || typeof n != "object") return null;
  const t = n, i = A2(t.id) ? t.id : A2(e) ? e : null;
  if (!i) return null;
  const s = Array.isArray(t.tools) ? t.tools.map($Q).filter((o) => o !== null) : [];
  return {
    id: i,
    label: typeof t.label == "string" && t.label ? t.label : i,
    icon: typeof t.icon == "string" && t.icon ? t.icon : RQ,
    description: typeof t.description == "string" ? t.description : "",
    sortOrder: typeof t.sortOrder == "number" ? t.sortOrder : Vv.indexOf(i),
    // STRICT. Anything other than an explicit `true` is a draft, matching
    // the Firestore rule and the non-admin query in web
    // (`where('isPublished', '==', true)`), which cannot match a document
    // where the field is missing or null. Read loosely, a half-authored Kit
    // would read as live here while being unreadable to the very users it
    // claims to be published for.
    isPublished: t.isPublished === !0,
    // `=== undefined` rather than `??`: web's webpack-4 parser lints the
    // symlinked shared dist and cannot parse nullish-coalescing.
    publishedAt: t.publishedAt === void 0 ? null : t.publishedAt,
    // Faithful (`=== true`) rather than strict-inverse, deliberately: a Kit
    // whose `isDeleted` is missing is INVISIBLE to users (see
    // `isKitReadableByUsers`) but must still appear in Manage Kits, because
    // an admin is the only one who can repair it. Reading a missing field
    // as deleted here would hide the broken Kit from the person fixing it.
    isDeleted: t.isDeleted === !0,
    deletedAt: t.deletedAt === void 0 ? null : t.deletedAt,
    defaultNodeDefId: typeof t.defaultNodeDefId == "string" && t.defaultNodeDefId ? t.defaultNodeDefId : null,
    surfaces: t.surfaces && typeof t.surfaces == "object" ? tC(t.surfaces) : null,
    tools: s
  };
}, OQ = (n) => {
  if (!n || typeof n != "object") return !1;
  const e = n;
  return e.isPublished === !0 && e.isDeleted === !1;
}, LQ = (n, e) => {
  if (!e) return !0;
  const t = n.surfaces;
  return !t || !Object.keys(t).length ? !0 : !!t[e];
}, BQ = (n) => {
  const e = [];
  for (const s of n)
    for (const o of Object.keys(s.tags))
      e.includes(o) || e.push(o);
  const t = e.filter((s) => s !== Rg && s !== zg).sort((s, o) => s.localeCompare(o));
  return [
    ...e.includes(Rg) ? [Rg] : [],
    ...t,
    ...e.includes(zg) ? [zg] : []
  ].map((s) => ({ key: s, label: s }));
}, FQ = (n) => {
  const { nodeDefs: e, isBlocked: t, surface: i, includeUnpublished: s } = n, o = DQ(n.kit);
  if (!o || !s && !OQ(n.kit) || !LQ(o, i)) return null;
  const r = {};
  for (const c of e || [])
    c && typeof c.id == "string" && (r[c.id] = c);
  const a = [], l = {};
  for (const c of o.tools) {
    if (l[c.nodeDefId]) continue;
    const u = r[c.nodeDefId];
    u && (!s && (u.isPublished === !1 || u.isDeleted === !0) || t && t(u) || (l[c.nodeDefId] = !0, a.push({
      value: u.id,
      nodeDefId: u.id,
      text: typeof u.title == "string" ? u.title : "",
      description: typeof u.description == "string" ? u.description : "",
      imageUrl: u.imageUrl || null,
      avatar: u.avatar || null,
      newUntil: u.newUntil === void 0 ? null : u.newUntil,
      sortOrder: typeof u.sortOrder == "number" ? u.sortOrder : 0,
      tags: c.tags,
      labels: c.labels,
      nodeDef: u
    })));
  }
  const d = a.some((c) => c.nodeDefId === o.defaultNodeDefId) ? o.defaultNodeDefId : a.length ? a[0].nodeDefId : null;
  return {
    id: o.id,
    label: o.label,
    icon: o.icon,
    description: o.description,
    sortOrder: o.sortOrder,
    tools: a,
    tags: BQ(a),
    defaultNodeDefId: d
  };
}, NQ = (n) => {
  const e = [];
  for (const t of n.kits || []) {
    const i = FQ({ ...n, kit: t });
    i && e.push(i);
  }
  return e.sort((t, i) => t.sortOrder - i.sortOrder || Vv.indexOf(t.id) - Vv.indexOf(i.id));
}, vi = {
  image: "YrM1HzvaCa9i1Y62U05t",
  video: "yAF6gcg8KczjQx4XVBgr",
  threed: "tfGE9ARninUX4Ledph0j",
  upscaling: "ZV5i4keWclGqG7zfUMPw",
  app: "bt7aOyhEugBXpHu80JsX",
  pluginEdit: "TN70c8DUV6X82hM8xM9W",
  pluginLayers: "b1fdfcfIpojbCLpks6JI"
}, nC = [
  { id: "image", name: "Image", icon: "Image", desc: "Create images with AI-powered models", prefer: ["Nano Banana Pro", "Nano Banana 2", "ChatGPT Image 2.0", "ChatGPT Image 1.5", "Seedream V5 Lite", "Flux 2 Pro", "Seedream V5 Pro"] },
  { id: "video", name: "Video", icon: "Video", desc: "Generate dynamic videos and animations", prefer: ["Kling 3.0 Pro", "Veo 3.1 Fast", "Kling 2.6 Pro", "LTX 2.3", "Seedance 2.0", "Hailuo 2"] },
  { id: "threed", name: "3D", icon: "Box", desc: "Generate 3D models from images or prompts", prefer: ["Hunyuan3D 3", "Trellis 2", "Rodin Gen-2", "Meshy v7", "Tripo"] },
  { id: "upscale", name: "Upscale", icon: "Maximize2", desc: "Upscale your images and videos", prefer: ["Topaz Generative Upscale", "SeedVR Upscale", "Magnific Upscale", "AuraSR - True Upscaler", "Topaz Video Upscale"] }
];
function iC(n) {
  const e = n.tags || {};
  return (e[vi.app] || e[vi.pluginEdit] || e[vi.pluginLayers]) && !e[vi.image] && !e[vi.video] ? null : e[vi.upscaling] ? "upscale" : e[vi.threed] ? "threed" : e[vi.video] ? "video" : e[vi.image] ? "image" : null;
}
function UQ(n) {
  const e = n.tags || {};
  return e[vi.app] ? null : e[vi.upscaling] ? "upscale" : e[vi.threed] ? "threed" : e[vi.video] ? "video" : "image";
}
function* sC(n) {
  for (const e of n || [])
    e && (e.__rgroup ? yield* sC(e.fields) : e.__rfield && (yield e));
}
function P2(n, e) {
  return Math.abs(n - e) / Math.max(n, e) < 0.04 ? "Square" : n > e ? "RectangleHorizontal" : "RectangleVertical";
}
function GQ(n) {
  return (n && (n.text && n.text.options || n.radio && n.radio.options || n.image && n.image.options) || []).map((t) => ({ value: t.value, label: String(t.text != null ? t.text : t.value), image: t.imageUrl }));
}
const jQ = [["1:1", 1, 1], ["4:3", 4, 3], ["3:4", 3, 4], ["16:9", 16, 9], ["9:16", 9, 16]];
function HQ(n, e) {
  if (n.adminOnly && !e.isAdmin) return null;
  const t = n.display || {}, i = t.primaryForm, s = {
    key: String(n.fieldDefUuid || n.uuid),
    label: n.label || "",
    required: !!n.required,
    defaultValue: n.defaultValue,
    tooltip: n.tooltip,
    placeholder: n.placeholder,
    raw: n
  }, o = (r) => i === "CHIP" ? "chip" : i === "MAIN_ACTION" ? "reference" : i === "PROMPT" ? "prompt" : r;
  switch (n.type) {
    case "PROMPT":
      return e.firstPrompt ? { ...s, kind: "prompt", placement: "prompt", defaultValue: n.defaultValue && typeof n.defaultValue == "object" ? n.defaultValue.value || "" : n.defaultValue || "" } : { ...s, kind: "text", placement: "advanced" };
    case "NEG_PROMPT":
      return { ...s, kind: "negPrompt", placement: "advanced" };
    case "TEXT":
    case "TEXT_AREA":
      return { ...s, kind: "text", placement: i === "PROMPT" && e.firstPrompt ? "prompt" : "advanced" };
    case "BOOLEAN":
      return i === "CHIP" ? { ...s, kind: "select", placement: "chip", icon: "Settings2", options: [{ value: !0, label: "On" }, { value: !1, label: "Off" }], defaultValue: !!n.defaultValue } : { ...s, kind: "boolean", placement: "advanced", defaultValue: !!n.defaultValue };
    case "SINGLE_SELECT": {
      const r = GQ(t);
      return r.length ? { ...s, kind: "select", placement: o("advanced"), options: r, defaultValue: n.defaultValue != null ? n.defaultValue : r[0].value } : null;
    }
    case "WIDTH_HEIGHT": {
      if (t.select && Array.isArray(t.select.options) && t.select.options.length) {
        const r = t.select.options.map((a) => ({
          value: t.select.format === "wh" ? { width: a.width, height: a.height } : a.value,
          label: a.text || a.value,
          meta: a.width && a.height ? a.width + "×" + a.height : void 0,
          icon: P2(a.width || 1, a.height || 1)
        }));
        return { ...s, kind: "size", placement: i ? o("chip") : "chip", options: r, defaultValue: n.defaultValue != null ? n.defaultValue : r[0].value };
      }
      if (t.sliders) {
        const [r, a] = t.sliders.max || [1024, 1024], [l, d] = t.sliders.min || [256, 256], c = jQ.map(([u, p, f]) => {
          const y = Math.min(r / p, a / f), b = Math.max(l, Math.round(p * y / 64) * 64), w = Math.max(d, Math.round(f * y / 64) * 64);
          return { value: { width: b, height: w }, label: u, meta: b + "×" + w, icon: P2(b, w) };
        });
        return { ...s, kind: "size", placement: "chip", options: c, defaultValue: n.defaultValue || c[0].value };
      }
      return null;
    }
    case "IMG":
      return { ...s, kind: "image", placement: i === "CHIP" || i === "MAIN_ACTION" || e.imageIndex < 3 ? "reference" : "advanced" };
    case "IMGS":
      return { ...s, kind: "images", placement: "reference", maxImages: t.maxImages || 4 };
    case "VIDEO":
    case "ASSET_3D":
      return { ...s, kind: "video", placement: "reference" };
    case "SLIDER":
    case "UPSCALE_FACTOR_SLIDER": {
      if (Array.isArray(t.options) && t.options.length) {
        const r = t.options.map((a) => ({ value: a.value, label: String(a.label) }));
        return { ...s, kind: "select", placement: o("advanced"), icon: "Maximize2", options: r, defaultValue: n.defaultValue != null ? n.defaultValue : r[0].value };
      }
      return { ...s, kind: "slider", placement: o("advanced"), min: t.min, max: t.max, step: t.step || 1 };
    }
    case "CFG":
      return { ...s, kind: "slider", placement: "advanced", min: t.min != null ? t.min : 1, max: t.max != null ? t.max : 20, step: 0.5 };
    case "STEPS":
      return { ...s, kind: "slider", placement: "advanced", min: t.min != null ? t.min : 1, max: t.max != null ? t.max : 50, step: 1 };
    case "SEED":
      return { ...s, kind: "seed", placement: "advanced", defaultValue: n.defaultValue != null ? n.defaultValue : null };
    case "NUM":
      return { ...s, kind: "text", placement: "advanced" };
    case "MODEL_SINGLE_SELECT":
      return { ...s, kind: "model", placement: "chip", icon: "Sparkles", architecture: t.architecture || void 0 };
    default:
      return null;
  }
}
function Jc(n, e, t, i = iC(e)) {
  if (!i) return null;
  const s = [];
  let o = !0, r = 0;
  for (const c of sC(e.fields)) {
    const u = HQ(c, { isAdmin: t, firstPrompt: o, imageIndex: r });
    u && (u.placement === "prompt" && (o = !1), (u.kind === "image" || u.kind === "images") && r++, s.push(u));
  }
  s.sort((c, u) => E2(c) - E2(u));
  const a = e.staticFields && e.staticFields.numResults || { min: 1, max: 1, defaultValue: 1 }, l = Number(e.costPerResult) || 0, d = Array.isArray(e.costPerResultLogics) && e.costPerResultLogics.length > 0;
  return {
    id: n,
    name: e.title || "Tool",
    desc: e.description,
    kitId: i,
    tokensLabel: WQ(l) + (d ? "+" : ""),
    tokensPerResult: d ? void 0 : l / 100,
    time: e.averageGenInSeconds ? qQ(e.averageGenInSeconds) : void 0,
    fields: s,
    numResults: { min: a.min || 1, max: a.max || 1, def: a.defaultValue || 1 },
    raw: { id: n, costPerResult: l, costPerResultLogics: e.costPerResultLogics || [], sortOrder: e.sortOrder || 0, pricingType: e.pricingType, fields: e.fields || [] },
    boardTool: typeof e.boardTool == "string" && e.boardTool ? e.boardTool : void 0
  };
}
function VQ(n, e) {
  const t = [];
  for (const i of n) {
    const s = Jc(i.id, i.data, e, iC(i.data) || "tools");
    s && t.push(s);
  }
  return t;
}
function E2(n) {
  return n.placement === "prompt" ? 0 : n.placement === "reference" ? 1 : n.placement === "chip" ? 2 : 3;
}
function WQ(n) {
  const e = Math.floor(n) / 100;
  return e >= 100 ? String(Math.round(e)) : String(Math.round(e * 10) / 10);
}
function qQ(n) {
  return n < 90 ? Math.round(n) + "s" : Math.round(n / 60) + "m";
}
const KQ = { "3d": "threed" }, YQ = {
  image: "Image",
  video: "Video",
  imageEdit: "Wand2",
  videoEdit: "Clapperboard",
  upscale: "Maximize2",
  "3d": "Box"
};
function XQ(n, e, t) {
  const i = e.map((o) => ({ ...o.data, id: o.id })), s = [];
  for (const o of NQ({ kits: n, nodeDefs: i, surface: "web" })) {
    const r = KQ[o.id] || o.id, a = [];
    for (const c of o.tools) {
      const u = Jc(c.nodeDefId, c.nodeDef, t, r);
      u && (u.kitTags = Object.keys(c.tags), u.labels = c.labels.map((p) => ({ label: p.label, tooltip: p.tooltip, type: p.type })), a.push(u));
    }
    if (!a.length) continue;
    const l = o.tags.map((c) => c.key).filter((c) => a.some((u) => u.kitTags && u.kitTags.includes(c))), d = a.some((c) => c.id === o.defaultNodeDefId) ? o.defaultNodeDefId : a[0].id;
    s.push({ id: r, name: o.label, icon: YQ[o.id] || "Sparkles", desc: o.description, models: a, tags: l, defaultModelId: d });
  }
  return s;
}
const Wv = "Company";
async function oC(n, e, t, i = {}) {
  const s = await n.db.doc("teams/" + e).get(), o = s.exists ? (s.data() || {}).companyId : null;
  if (!o) return [];
  let r = n.db.collection("runnitNodeDefs").where("appType", "==", "RUNNIT").where("type", "==", "COMPANY").where("isDeleted", "==", !1).where("companyIds." + o, "==", !0);
  t.isAdmin || (r = r.where("isPublished", "==", !0));
  const a = await r.get(), l = [];
  for (const d of a.docs) {
    const c = { ...d.data(), id: d.id };
    if (i.isBlocked && i.isBlocked(c)) continue;
    const u = Jc(d.id, c, !!t.isAdmin);
    u && (u.kitTags = [Wv], l.push(u));
  }
  return l;
}
function JQ(n, e) {
  if (!e.length) return n;
  const t = n.kits.map((i) => ({ ...i, models: i.models.slice(), tags: i.tags ? i.tags.slice() : void 0 }));
  for (const i of e) {
    let s = t.find((o) => o.id === i.kitId);
    if (!s) {
      const o = nC.find((r) => r.id === i.kitId);
      if (!o) continue;
      s = { id: o.id, name: o.name, icon: o.icon, desc: o.desc, models: [] }, t.push(s);
    }
    s.models.some((o) => o.id === i.id) || (s.models.push(i), s.tags && !s.tags.includes(Wv) && s.tags.unshift(Wv));
  }
  return Rp(n.source, t, n.all, n.tools || []);
}
function ZQ(n, e, t) {
  const i = /* @__PURE__ */ new Set();
  for (const o of n) for (const r of o.models) i.add(r.id);
  const s = [];
  for (const o of e) {
    if (i.has(o.id) || !o.data || o.data.isPublished !== !0) continue;
    const r = Jc(o.id, o.data, t, UQ(o.data));
    r && !r.boardTool && s.push(r);
  }
  return s;
}
async function QQ(n, e, t = {}) {
  let i = n.db.collection("runnitNodeDefs").where("appType", "==", "RUNNIT").where("type", "==", "CORE").where("isDeleted", "==", !1);
  e.isAdmin || (i = i.where("isPublished", "==", !0));
  const s = n.db.collection("runnitKits").where("isPublished", "==", !0).where("isDeleted", "==", !1), [o, r] = await Promise.all([
    i.get(),
    s.get().catch((f) => (console.warn("[board] v1 kits unavailable, grouping tools by tag", f), { docs: [] }))
  ]), a = t.isBlocked, l = o.docs.map((f) => ({ id: f.id, data: f.data() })).filter((f) => !a || !a({ ...f.data, id: f.id })), d = XQ(r.docs.map((f) => ({ ...f.data(), id: f.id })), l, !!e.isAdmin), c = VQ(l, !!e.isAdmin);
  if (d.length) return Rp("firestore", d, ZQ(d, l, !!e.isAdmin), c);
  const u = /* @__PURE__ */ new Map();
  l.forEach((f) => {
    const y = Jc(f.id, f.data, !!e.isAdmin);
    y && (u.has(y.kitId) || u.set(y.kitId, []), u.get(y.kitId).push(y));
  });
  const p = nC.map((f) => {
    const y = (u.get(f.id) || []).slice().sort((b, w) => {
      const k = f.prefer.indexOf(b.name), S = f.prefer.indexOf(w.name);
      if (k >= 0 || S >= 0) return (k < 0 ? 999 : k) - (S < 0 ? 999 : S);
      const _ = b.raw && b.raw.sortOrder || 0, x = w.raw && w.raw.sortOrder || 0;
      return _ - x || b.name.localeCompare(w.name);
    });
    return { id: f.id, name: f.name, icon: f.icon, desc: f.desc, models: y };
  }).filter((f) => f.models.length);
  return Rp("firestore", p, [], c);
}
var eee = Object.defineProperty, tee = (n, e, t) => e in n ? eee(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Xu = (n, e, t) => tee(n, typeof e != "symbol" ? e + "" : e, t);
function nee(n) {
  return "deleted:" + n;
}
function qv(n) {
  return "edit:" + n;
}
function R2(n) {
  return "marks:" + n;
}
const Qa = { x: 0, y: 0, w: 0, h: 0, z: 0 };
function Cs(n) {
  return n.type === "studio";
}
function iee(n, e) {
  return n === e ? !0 : n && e && typeof n == "object" && typeof e == "object" ? JSON.stringify(n) === JSON.stringify(e) : !1;
}
class see {
  constructor(e, t) {
    Xu(this, "save", e), Xu(this, "who", t), Xu(this, "byId", /* @__PURE__ */ new Map()), Xu(this, "rev", /* @__PURE__ */ We(0));
  }
  bump() {
    this.rev.value++, os(this.rev);
  }
  /** What the board loaded with. */
  load(e) {
    for (const t of e) this.byId.set(t.id, t);
    this.bump();
  }
  /** Someone else changed some (another tab, a teammate). */
  applyRemote(e, t) {
    if (!(!e.length && !t.length)) {
      for (const i of e) this.byId.set(i.id, i);
      for (const i of t) this.byId.delete(i);
      this.bump();
    }
  }
  has(e) {
    return this.byId.has(e);
  }
  get(e) {
    return this.byId.get(e);
  }
  all() {
    return this.rev.value, Array.from(this.byId.values());
  }
  /** A session's records. */
  forSession(e) {
    return this.all().filter((t) => t.sessionId === e);
  }
  /** Add a record, or replace one whole. Unchanged, it writes nothing. */
  put(e) {
    const t = this.byId.get(e.id), i = { updatedAt: Date.now(), updatedBy: this.who() };
    if (!t) {
      const c = { ...e, ...i };
      this.byId.set(e.id, c), this.bump(), this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: [c], updated: [], removed: [] });
      return;
    }
    const s = {}, o = {}, r = t, a = e;
    for (const c of /* @__PURE__ */ new Set([...Object.keys(r), ...Object.keys(a)]))
      c === "updatedAt" || c === "updatedBy" || iee(r[c], a[c]) || (s[c] = r[c], o[c] = a[c]);
    if (!Object.keys(o).length) return;
    const l = { ...e, ...i };
    this.byId.set(e.id, l), this.bump(), Object.assign(o, i);
    const d = { id: e.id, el: l, before: s, after: o };
    this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: [], updated: [d], removed: [] });
  }
  /** Change some of a record's fields. */
  patch(e, t) {
    const i = this.byId.get(e);
    i && this.put({ ...i, ...t });
  }
  /** Into Recently Deleted. */
  remove(e) {
    const t = [];
    for (const i of e) {
      const s = this.byId.get(i);
      s && (this.byId.delete(i), t.push(s));
    }
    t.length && (this.bump(), this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: [], updated: [], removed: t }));
  }
  /** Back from Recently Deleted, as they were. */
  restore(e) {
    const t = e.filter((i) => !this.byId.has(i.id));
    if (t.length) {
      for (const i of t) this.byId.set(i.id, i);
      this.bump(), this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: t, updated: [], removed: [] });
    }
  }
}
function oee(n) {
  if ("nodeRunResult" in n) {
    const t = n.nodeRunResult, i = typeof t.nodeRunId == "string" ? t.nodeRunId : "", s = typeof t.uuid == "string" ? t.uuid : "";
    return i && s ? { kind: "result", nodeRunId: i, resultUuid: s, variant: "file" } : null;
  }
  const e = typeof n.upload.id == "string" ? n.upload.id : "";
  return e ? { kind: "upload", uploadId: e } : null;
}
function Ys(n) {
  return n ? n.fields.filter((e) => e.placement === "reference" && (e.kind === "image" || e.kind === "images")) : [];
}
function bo(n) {
  return Ys(n).reduce((e, t) => e + Gs(t), 0);
}
function ree(n) {
  const e = Ys(n);
  if (e.length < 2) return [];
  const t = [];
  for (const i of e) for (let s = 0; s < Gs(i); s++) t.push(i.label);
  return t;
}
function Xp(n) {
  return bo(n) > 0;
}
function rC(n, e, t) {
  if (e === "prompt") {
    const o = n.kits.find((r) => r.id === t) || n.kits.find((r) => r.id === "image") || n.kits[0];
    return o ? o.models : [];
  }
  const i = /* @__PURE__ */ new Set(), s = [];
  for (const o of n.kits)
    if (o.id === "image")
      for (const r of o.models)
        i.has(r.id) || !Xp(r) || (i.add(r.id), s.push(r));
  return s;
}
function gy(n) {
  return n.fields.find((e) => e.placement === "reference") || null;
}
function Kv(n, e) {
  if (!n) return [];
  const t = gy(n), i = [];
  for (const s of Ys(n)) {
    const o = e.inputs ? e.inputs[s.key] : void 0;
    if (s.kind === "images" && Array.isArray(o)) {
      for (const a of o) typeof a == "string" && a && i.push(a);
      continue;
    }
    const r = s === t ? e.ref : o;
    typeof r == "string" && r && i.push(r);
  }
  return i;
}
function ld(n, e, t) {
  const i = gy(n), s = { ...e.inputs || {} }, o = { ...e.assets || {} };
  let r = i && Ys(n).includes(i) ? null : e.ref || null, a = 0;
  for (const l of Ys(n)) {
    delete s[l.key];
    const d = t.slice(a, a + Gs(l));
    if (a += d.length, !d.length) continue;
    for (const u of d) u.asset && (o[u.url] = u.asset);
    const c = d.map((u) => u.url);
    l === i ? (r = c[0], c.length > 1 && (s[l.key] = c)) : s[l.key] = l.kind === "images" ? c : c[0];
  }
  return { ...e, ref: r, inputs: s, assets: o };
}
function aee(n, e) {
  const t = e.assets || {}, i = [], s = gy(n);
  for (const o of Ys(n)) {
    if (o.kind !== "images") continue;
    const r = e.inputs ? e.inputs[o.key] : void 0, a = Array.isArray(r) ? r : o === s && e.ref ? [e.ref] : [];
    let l = -1;
    a.forEach((d, c) => {
      const u = t[d];
      (!u || "upload" in u) && (l = c);
    }), a.forEach((d, c) => {
      const u = t[d];
      c < l && u && "nodeRunResult" in u && !i.includes(d) && i.push(d);
    });
  }
  return i;
}
const lee = /(?:^|\s)(\d+(?:\.\d+)?)\s*[:x×]\s*(\d+(?:\.\d+)?)$/;
function Jp(n) {
  if (n.value && typeof n.value == "object") {
    const e = n.value, t = Number(e.width), i = Number(e.height);
    if (t > 0 && i > 0) return t / i;
  }
  for (const e of [typeof n.value == "string" ? n.value : "", n.label, n.meta || ""]) {
    const t = lee.exec(String(e).trim());
    if (t && Number(t[2]) > 0) return Number(t[1]) / Number(t[2]);
  }
  return null;
}
const dee = /match|auto|input|original/i;
function by(n) {
  return dee.test(String(n.label) + " " + String(typeof n.value == "string" ? n.value : ""));
}
function vy(n) {
  for (const e of n.fields) {
    if (e.kind === "size") return e;
    if (e.kind !== "select" || !e.options) continue;
    const t = e.options.filter((i) => Jp(i) != null).length;
    if (t >= 2 || t >= 1 && e.options.some(by)) return e;
  }
  return null;
}
function cee(n) {
  if (n.value && typeof n.value == "object") {
    const t = n.value, i = Number(t.width) * Number(t.height);
    if (i > 0) return i;
  }
  const e = /(\d+)\s*[×x]\s*(\d+)/.exec(n.meta || "");
  return e ? Number(e[1]) * Number(e[2]) : null;
}
function uee(n) {
  const e = /^(\d+(?:\.\d+)?K)\b/i.exec(String(n.label).trim());
  return e ? e[1].toUpperCase() : n.meta || String(n.label);
}
function aC(n, e, t) {
  const i = vy(n);
  if (!i || !i.options || !e || !t || i.options.some(by)) return [];
  const s = Math.log(e / t);
  let o = null;
  for (const l of i.options) {
    const d = Jp(l);
    d != null && (o == null || Math.abs(Math.log(d) - s) < Math.abs(Math.log(o) - s)) && (o = d);
  }
  if (o == null) return [];
  const r = o, a = i.options.filter((l) => {
    const d = Jp(l);
    return d != null && Math.abs(Math.log(d) - Math.log(r)) < 1e-6;
  }).map((l) => ({ o: l, px: cee(l) }));
  return a.length < 2 || a.some((l) => l.px == null) ? [] : (a.sort((l, d) => l.px - d.px), a.map(({ o: l }) => ({ label: uee(l), value: l.value, meta: l.meta })));
}
function hee(n, e, t, i = 0) {
  const s = vy(n);
  if (!s || !s.options || !s.options.length || !e || !t) return null;
  const o = s.options.find(by);
  if (o) return { key: s.key, value: o.value };
  const r = aC(n, e, t);
  if (r.length) return { key: s.key, value: r[Math.max(0, Math.min(i, r.length - 1))].value };
  const a = Math.log(e / t);
  let l = s.options[0], d = 1 / 0;
  for (const c of s.options) {
    const u = Jp(c);
    if (u == null) continue;
    const p = Math.abs(Math.log(u) - a);
    p < d && (d = p, l = c);
  }
  return { key: s.key, value: l.value };
}
const sp = { rotate: 45, vertical: 0, zoom: 5 }, Zp = 50, yy = 60;
function pee(n, e) {
  const t = Xs(n), i = Xs(e);
  return t.rotate === i.rotate && t.vertical === i.vertical && t.zoom === i.zoom;
}
function fee(n) {
  if (!n || typeof n != "object") return null;
  const e = n;
  if (typeof e.id != "string" || !e.id || typeof e.name != "string") return null;
  const t = Xs({ rotate: Number(e.rotate), vertical: Number(e.vertical), zoom: Number(e.zoom) });
  return { id: e.id, name: e.name.slice(0, yy), ...t, createdAt: Number(e.createdAt) || 0 };
}
const mee = -30, gee = 90, bee = 0, vee = 10, Yv = [0, 45, 90, 135, 180, 225, 270, 315], yee = ["Front", "Front right", "Right side", "Back right", "Back", "Back left", "Left side", "Front left"], Qp = [
  { at: -30, name: "Low, looking up" },
  { at: 0, name: "Eye level" },
  { at: 30, name: "Slightly above" },
  { at: 60, name: "High above" },
  { at: 90, name: "Overhead" }
], lC = [
  { at: 0, name: "Wide" },
  { at: 5, name: "Medium" },
  { at: 10, name: "Close-up" }
], xee = 0.9, wee = "same scene and subject, same materials, colours and lighting", kee = "different person, changed clothing, distorted face, extra limbs, warped architecture";
function Zc(n) {
  const e = (n % 360 + 360) % 360;
  return Math.round(e * 1e3) / 1e3;
}
function xy(n) {
  const e = Zc(n);
  return e > 180 ? e - 360 : e;
}
function z2(n, e, t) {
  return Math.min(t, Math.max(e, n));
}
function Xs(n) {
  const e = Number.isFinite(n.rotate) ? n.rotate : sp.rotate, t = Number.isFinite(n.vertical) ? n.vertical : sp.vertical, i = Number.isFinite(n.zoom) ? n.zoom : sp.zoom, s = Zc(e);
  return { rotate: s === 360 ? 0 : s, vertical: z2(t, mee, gee), zoom: z2(i, bee, vee) };
}
function _ee(n) {
  return Math.round(Zc(n) / 45) % 8;
}
function wy(n, e, t) {
  let i = n, s = t;
  for (const o of e) {
    const r = Math.abs(o - n);
    r <= s && (s = r, i = o);
  }
  return i;
}
function $2(n, e = 7) {
  const t = wy(Zc(n), [...Yv, 360], e);
  return t === 360 ? 0 : t;
}
function D2(n, e = 6) {
  return wy(n, Qp.map((t) => t.at), e);
}
function See(n, e = 0.6) {
  return wy(n, lC.map((t) => t.at), e);
}
function Tee(n, e) {
  return e.reduce((t, i) => Math.abs(i.at - n) < Math.abs(t.at - n) ? i : t);
}
function Xv(n) {
  return yee[_ee(n)];
}
function Jv(n) {
  return Tee(n, Qp).name;
}
function dC(n) {
  return n <= 3 ? "Wide" : n >= 7 ? "Close-up" : "Medium";
}
function sc(n) {
  const e = Xs(n);
  return Xv(e.rotate) + ", " + Jv(e.vertical).toLowerCase() + ", " + dC(e.zoom).toLowerCase();
}
function cC(n) {
  return Math.abs(xy(n.rotate)) > 90;
}
function Mee(n, e) {
  const t = Xs(n), i = {
    rotate: t.rotate,
    vertical: t.vertical,
    zoom: t.zoom,
    keep: wee,
    avoid: kee,
    loraScale: xee
  };
  return e != null && (i.seed = e), i;
}
const Cee = "/internal/library-prompts", Iee = 40, uC = 100, Aee = 80, Pee = ["me", "board", "team", "company"];
function va(n) {
  return n && n.trim() ? n.trim() : null;
}
function Eee(n) {
  const e = new URLSearchParams(), t = va(n.teamId);
  t && e.set("team_id", t);
  const i = va(n.boardId);
  i && e.set("board_id", i);
  const s = Pee.filter((d) => n.levels.includes(d));
  s.length && e.set("level", s.join(","));
  const o = va(n.category);
  o && e.set("category", o.slice(0, Aee));
  const r = va(n.query);
  r && e.set("q", r.slice(0, g1)), n.kind && e.set("kind", n.kind), n.onlyKind && e.set("only_kind", n.onlyKind), n.onlyAction && e.set("only_action", n.onlyAction), n.mine && e.set("author", "me");
  const a = va(n.toolId);
  a && e.set("tool_id", a);
  const l = va(n.cursor);
  return l && e.set("cursor", l), e.set("limit", String(Math.min(uC, Math.max(1, Math.floor(n.limit) || 1)))), e;
}
function Sn(n) {
  return n !== null && typeof n == "object" && !Array.isArray(n) ? n : null;
}
const It = (n) => typeof n == "string" ? n : "", gi = (n) => typeof n == "number" && Number.isFinite(n) ? n : 0, O2 = (n) => {
  const e = typeof n == "string" ? Date.parse(n) : NaN;
  return Number.isFinite(e) ? e : 0;
};
function Ree(n) {
  const e = Sn(n), t = e ? It(e.id) : "";
  if (!e || !t || !It(e.author_id) || !It(e.prompt)) return null;
  const i = Sn(e.tool) || {}, s = Sn(e.output) || {}, o = Array.isArray(e.inputs) ? e.inputs.map(Sn).filter((a) => !!a && !!It(a.url)).map((a) => ({ label: It(a.label), role: It(a.role), title: It(a.title) || void 0, kind: a.kind === "markup" ? "markup" : "reference", url: It(a.url) })) : [], r = O2(e.created);
  return {
    id: t,
    name: It(e.name) || "Untitled prompt",
    category: It(e.category),
    description: It(e.description),
    prompt: It(e.prompt),
    mode: It(e.mode) || Kc(o.length),
    tags: Array.isArray(e.tags) ? e.tags.filter((a) => typeof a == "string") : [],
    kind: e.kind === "video" ? "video" : "image",
    tool: { nodeDefId: It(i.node_def_id), name: It(i.name) },
    output: { url: It(s.url), w: gi(s.w), h: gi(s.h), thumb: It(s.thumb) || void 0, video: It(s.video) || void 0 },
    inputs: o,
    authorId: It(e.author_id),
    authorName: It(e.author_name),
    boardId: It(e.board_id) || null,
    teamId: It(e.team_id) || null,
    companyId: It(e.company_id) || null,
    values: Sn(e.values),
    // not mirrored: the document has it, and an edit reads the document
    run: null,
    createdAt: r,
    updatedAt: O2(e.updated) || r
  };
}
function zee(n) {
  const e = Sn(n);
  if (!e) return null;
  const t = Sn(e.levels) || {}, i = Sn(e.kinds), s = Array.isArray(e.categories) ? e.categories.map(Sn).filter((l) => !!l && !!It(l.label)).map((l) => ({ label: It(l.label), count: gi(l.count) })) : [], o = Sn(e.actions), r = (l) => {
    const d = Sn(l) || {};
    return { generate: gi(d.generate), edit: gi(d.edit) };
  }, a = Array.isArray(e.groups) ? e.groups.map(Sn).filter((l) => !!l && (l.kind === "image" || l.kind === "video") && (l.action === "generate" || l.action === "edit")).map((l) => ({ kind: l.kind, action: l.action, label: It(l.label), count: gi(l.count) })) : null;
  return {
    total: gi(e.total),
    levels: { me: gi(t.me), board: gi(t.board), team: gi(t.team), company: gi(t.company) },
    // an API from before the Image and Video filter doesn't count them
    ...i ? { kinds: { image: gi(i.image), video: gi(i.video) } } : {},
    // nor one from before Generate and Edit (IL-103)
    ...o ? { actions: { image: r(o.image), video: r(o.video) } } : {},
    categories: s,
    ...a ? { groups: a } : {}
  };
}
function $ee(n) {
  const e = Sn(n);
  if (!e) return null;
  const t = Sn(e.team), i = Sn(e.company);
  return {
    team: t && It(t.id) ? { id: It(t.id), manage: t.manage === !0 } : null,
    company: i && It(i.id) ? { id: It(i.id), name: It(i.name) || null, manage: i.manage === !0 } : null
  };
}
function Dee(n) {
  const e = Sn(n) || {};
  return {
    prompts: Array.isArray(e.data) ? e.data.map(Ree).filter((t) => t !== null) : [],
    nextCursor: It(e.next_cursor) || null,
    hasMore: !!e.has_more,
    counts: zee(e.counts),
    access: $ee(e.access)
  };
}
async function Oee(n) {
  var e;
  try {
    const t = Sn((e = Sn(await n.json())) == null ? void 0 : e.error) || {};
    return {
      code: typeof t.code == "string" ? t.code : void 0,
      message: typeof t.message == "string" ? t.message : void 0
    };
  } catch {
    return {};
  }
}
async function Lee(n, e, t, i = window.fetch.bind(window)) {
  const s = n.replace(/\/$/, "") + Cee + "?" + Eee(t).toString();
  let o;
  try {
    o = await i(s, { method: "GET", headers: { Authorization: "Bearer " + e.idToken, "X-Device-Id": e.deviceId } });
  } catch {
    return { ok: !1, reason: "network" };
  }
  if (!o.ok) {
    const { code: r, message: a } = await Oee(o);
    return { ok: !1, reason: r === "INVALID_CURSOR" ? "stale-cursor" : o.status === 401 ? "unauthorized" : o.status === 403 ? "forbidden" : "failed", ...r ? { code: r } : {}, message: a || "HTTP " + o.status };
  }
  try {
    return { ok: !0, page: Dee(await o.json()) };
  } catch {
    return { ok: !1, reason: "failed", message: "Invalid JSON" };
  }
}
var Bee = Object.defineProperty, Fee = (n, e, t) => e in n ? Bee(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, yn = (n, e, t) => Fee(n, typeof e != "symbol" ? e + "" : e, t);
const Nee = 2e4;
function Uee(n, e) {
  return JSON.stringify(n) === JSON.stringify(e);
}
class Gee {
  constructor(e, t = {}) {
    yn(this, "shelf", e), yn(this, "opts", t), yn(this, "rows", /* @__PURE__ */ We([])), yn(this, "state", /* @__PURE__ */ We("idle")), yn(this, "counts", /* @__PURE__ */ We(null)), yn(this, "access", /* @__PURE__ */ We(null)), yn(this, "hasMore", /* @__PURE__ */ We(!1)), yn(this, "loadingMore", /* @__PURE__ */ We(!1)), yn(this, "ask", null), yn(this, "fetched", []), yn(this, "cursor", null), yn(this, "version", 0), yn(this, "stale", !1), yn(this, "shown", !1), yn(this, "followed", /* @__PURE__ */ new Map()), yn(this, "pinned", /* @__PURE__ */ new Map()), yn(this, "hidden", /* @__PURE__ */ new Map()), yn(this, "lastWrite", 0), yn(this, "lagTimer", null);
  }
  get pageSize() {
    return this.opts.pageSize || Iee;
  }
  /**
   * Ask for the first page, with these filters. The same ask again is
   * answered by what's here, unless it failed, it was refreshed, or a write
   * since needs the mirror's word.
   */
  query(e) {
    return this.ask && Uee(this.ask, e) && !this.stale && (this.state.value === "ready" || this.state.value === "loading") ? Promise.resolve() : (this.ask = e, this.firstPage());
  }
  /** The next ask goes to the API even if it's the same: the panel opened again, and others may have saved since. */
  refresh() {
    this.stale = !0;
  }
  /** The next page, when there is one. */
  async loadMore() {
    const e = this.ask;
    if (!e || !this.cursor || this.loadingMore.value || this.state.value !== "ready") return;
    const t = this.version;
    this.loadingMore.value = !0;
    const i = await this.shelf.list({ ...e, cursor: this.cursor, limit: this.pageSize });
    if (t !== this.version) return;
    if (this.loadingMore.value = !1, !i.ok) {
      if (i.reason === "stale-cursor") return this.firstPage();
      console.warn("[board] more of my prompts unavailable", i);
      return;
    }
    const s = new Set(this.fetched.map((o) => o.id));
    this.fetched = this.fetched.concat(i.page.prompts.filter((o) => !s.has(o.id))), this.cursor = i.page.nextCursor, this.hasMore.value = i.page.hasMore, this.recompute();
  }
  /** While the panel shows the list, each prompt it holds follows its document. */
  setShown(e) {
    this.shown !== e && (this.shown = e, e ? this.follow() : this.unfollowAll());
  }
  /** A prompt saved (no `before`) or edited here: shown at once, first when it fits the filters. */
  pin(e, t) {
    this.pinned.set(e.id, e), this.hidden.delete(e.id), this.counts.value = jm(this.counts.value, t, e, this.boardId()), this.wrote();
  }
  /** A prompt deleted here: gone at once. */
  drop(e) {
    this.hidden.has(e.id) || (this.counts.value = jm(this.counts.value, e, null, this.boardId())), this.hidden.set(e.id, Date.now()), this.pinned.delete(e.id), this.wrote();
  }
  /** A delete undone (or refused): back at once. */
  undrop(e) {
    this.hidden.delete(e.id) && (this.findHeld(e.id) || this.pinned.set(e.id, e), this.counts.value = jm(this.counts.value, null, e, this.boardId()), this.wrote());
  }
  /**
   * A prompt the list holds, as it is now; null when it doesn't, or it's gone.
   * Read through the rows, so a view that shows one (the detail) changes with it.
   */
  get(e) {
    const t = this.rows.value.find((i) => i.id === e);
    return t || (!e || this.hidden.has(e) ? null : this.findHeld(e));
  }
  /** Whether this prompt is as its document says (followed), rather than as the API listed it. */
  isLive(e) {
    const t = this.followed.get(e);
    return !!t && !!t.prompt;
  }
  /** Every prompt the list knows of: for spotting a name or a prompt you have, before the API answers. */
  known() {
    const e = /* @__PURE__ */ new Map();
    for (const t of this.fetched) e.set(t.id, t);
    for (const t of this.pinned.values()) e.set(t.id, t);
    for (const [t, i] of this.followed) i.prompt && e.set(t, i.prompt);
    for (const t of this.hidden.keys()) e.delete(t);
    return Array.from(e.values());
  }
  dispose() {
    this.version++, this.unfollowAll(), this.lagTimer && clearTimeout(this.lagTimer), this.lagTimer = null;
  }
  // ------------------------------------------------------------- inside
  async firstPage() {
    const e = this.ask;
    if (!e) return;
    const t = ++this.version, i = Date.now();
    this.stale = !1, this.loadingMore.value = !1, this.state.value !== "ready" && (this.state.value = "loading");
    const s = await this.shelf.list({ ...e, cursor: null, limit: this.pageSize });
    if (t !== this.version) return;
    if (!s.ok) {
      console.warn("[board] my prompts unavailable", s), this.state.value = "failed";
      return;
    }
    const o = s.page;
    this.fetched = o.prompts, this.cursor = o.nextCursor, this.hasMore.value = o.hasMore, o.counts && (!this.counts.value || i - this.lastWrite >= this.lagMs) && (this.counts.value = o.counts), o.access !== void 0 && (this.access.value = o.access);
    for (const r of o.prompts) this.pinned.delete(r.id);
    for (const [r, a] of this.hidden) i - a >= this.lagMs && this.hidden.delete(r);
    this.state.value = "ready", this.recompute();
  }
  /** The board the list is asked for, whose prompts are "This board"'s. */
  boardId() {
    return this.ask ? this.ask.boardId : null;
  }
  findHeld(e) {
    const t = this.followed.get(e);
    return t && t.prompt ? t.prompt : t && t.prompt === null ? null : this.pinned.get(e) || this.fetched.find((i) => i.id === e) || null;
  }
  recompute() {
    const e = this.ask, t = [], i = /* @__PURE__ */ new Set(), s = (o) => {
      if (i.has(o.id) || this.hidden.has(o.id)) return;
      i.add(o.id);
      const r = this.followed.get(o.id);
      t.push(r && r.prompt ? r.prompt : o);
    };
    if (e) {
      const o = Array.from(this.pinned.values()).sort((r, a) => a.updatedAt - r.updatedAt);
      for (const r of o) {
        const a = this.findHeld(r.id) || r;
        Yj(a, { ...e, limit: this.pageSize }) && s(a);
      }
    }
    for (const o of this.fetched) s(o);
    this.rows.value = t, this.shown && this.follow();
  }
  /** Follow exactly what's shown: start the new ones, stop the ones that went. */
  follow() {
    const e = new Set(this.rows.value.map((t) => t.id));
    for (const [t, i] of this.followed)
      e.has(t) || (i.stop(), this.followed.delete(t));
    for (const t of e) {
      if (this.followed.has(t)) continue;
      const i = { prompt: void 0, failed: !1, stop: () => {
      } };
      this.followed.set(t, i);
      try {
        i.stop = this.shelf.follow(t, (s) => this.heard(t, i, s), (s) => {
          s.code !== "permission-denied" && console.warn("[board] could not follow a saved prompt", t, s), i.failed = !0;
        });
      } catch (s) {
        console.warn("[board] could not follow a saved prompt", t, s), i.failed = !0;
      }
    }
  }
  heard(e, t, i) {
    this.followed.get(e) === t && (t.prompt = i, i || (this.hidden.set(e, Date.now()), this.pinned.delete(e)), this.recompute());
  }
  unfollowAll() {
    for (const e of this.followed.values()) e.stop();
    this.followed.clear();
  }
  /** A write of yours: what's shown changes now, and the list asks again once the mirror has it. */
  wrote() {
    this.lastWrite = Date.now(), this.recompute(), this.lagTimer && clearTimeout(this.lagTimer), this.lagTimer = setTimeout(() => {
      this.lagTimer = null, this.shown ? this.firstPage() : this.stale = !0;
    }, this.lagMs);
  }
  get lagMs() {
    return this.opts.lagMs !== void 0 ? this.opts.lagMs : Nee;
  }
}
var jee = Object.defineProperty, Hee = (n, e, t) => e in n ? jee(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Ri = (n, e, t) => Hee(n, typeof e != "symbol" ? e + "" : e, t);
function _r(n) {
  return "authorId" in n;
}
const Ju = () => Promise.reject(new Error("Saving prompts isn't available here")), Vee = {
  list: () => Promise.resolve({ ok: !0, page: { prompts: [], nextCursor: null, hasMore: !1, counts: { total: 0, levels: { me: 0, board: 0, team: 0, company: 0 }, categories: [] }, access: null } }),
  follow: () => () => {
  },
  save: Ju,
  update: Ju,
  remove: Ju,
  restore: Ju,
  teamName: () => Promise.resolve(null)
};
class Wee {
  constructor(e, t, i = null) {
    Ri(this, "b", e), Ri(this, "source", t), Ri(this, "shelf", i), Ri(this, "featured", /* @__PURE__ */ We(null)), Ri(this, "state", /* @__PURE__ */ We("idle")), Ri(this, "scroll", {}), Ri(this, "loading", null), Ri(this, "myPrompts"), Ri(this, "mine"), Ri(this, "mineState"), Ri(this, "team", /* @__PURE__ */ We(null)), this.myPrompts = new Gee(i || Vee), this.mine = this.myPrompts.rows, this.mineState = this.myPrompts.state;
  }
  /** Saving is offered where prompts can be kept. */
  get canSave() {
    return !!this.shelf;
  }
  dispose() {
    this.myPrompts.dispose();
  }
  /** Read the Featured set, once (again after a failure). */
  load() {
    if (this.loading) return this.loading;
    if (this.state.value === "ready") return Promise.resolve();
    if (!this.source)
      return this.state.value = "ready", Promise.resolve();
    this.state.value = "loading";
    const e = this.source.load().then((t) => {
      this.featured.value = t, this.state.value = "ready";
    }).catch((t) => {
      console.warn("[board] featured prompts unavailable", t), this.state.value = "failed";
    }).then(() => {
      this.loading = null;
    });
    return this.loading = e, e;
  }
  prompt(e) {
    const t = this.featured.value;
    return e && t && t.prompts.find((i) => i.id === e) || null;
  }
  /** A saved prompt My prompts holds, as it is now. */
  myPrompt(e) {
    return this.myPrompts.get(e);
  }
  // -------------------------------------------------------------- my prompts
  /** The team a prompt can be shared with on this board. */
  teamId() {
    return this.b.meta.teamId || this.b.user.teamId || null;
  }
  /** What My prompts asks for: what's yours or shared here, through the panel's filters. */
  mineAsk() {
    const e = this.b.ui.library, t = this.session(e.sessionId);
    return {
      uid: this.b.user.uid,
      boardId: this.b.meta.id,
      teamId: this.teamId(),
      levels: e.levels.slice(),
      category: e.category,
      query: e.query.trim(),
      kind: t ? Ra(t.kitId) : null,
      onlyKind: e.kind,
      onlyAction: e.kind ? e.action : null,
      mine: !1,
      toolId: null
    };
  }
  /** Ask for My prompts as the panel's filters stand (the same ask again is answered by what's here). */
  startMine() {
    this.myPrompts.query(this.mineAsk());
    const e = this.teamId();
    !this.shelf || !e || this.team.value && this.team.value.id === e || (this.team.value = { id: e, name: null }, this.shelf.teamName(e).then((t) => {
      this.team.value && this.team.value.id === e && (this.team.value = { id: e, name: t });
    }));
  }
  /** The categories My prompts uses, most used first: everything you can read here, not just what's loaded. */
  mineCategories() {
    const e = this.myPrompts.counts.value;
    return e ? e.categories.map((t) => t.label) : Vj(this.myPrompts.known());
  }
  /** Your own prompts that hold every word of a search (the API's answer; none when it can't be asked). */
  async yours(e, t = null) {
    if (!this.shelf || !e) return [];
    const i = { ...this.mineAsk(), levels: [], category: null, query: e, kind: null, onlyKind: null, onlyAction: null, mine: !0, toolId: t, cursor: null, limit: uC }, s = await this.shelf.list(i);
    return s.ok ? s.page.prompts : [];
  }
  // ---------------------------------------------------- who manages what (IL-101)
  /** Who manages the shared levels here, as the API said for this board's team; null until it has. */
  access() {
    const e = this.myPrompts.access.value;
    return e && e.team && e.team.id === this.teamId() ? e : null;
  }
  /** You may share with this board's team, and edit or remove what's shared with it: its library is yours to manage, or the company's is. */
  managesTeam() {
    const e = this.access();
    return !!e && !!e.team && (e.team.manage || !!e.company && e.company.manage);
  }
  /** The company prompts can be shared with here: this board's team's. */
  company() {
    const e = this.access();
    return e && e.company ? { id: e.company.id, name: e.company.name } : null;
  }
  /** You may share with the whole company, and edit or remove what's shared in it. */
  managesCompany() {
    const e = this.access();
    return !!e && !!e.company && e.company.manage;
  }
  /** Who may edit or delete a saved prompt here: whoever saved it, and whoever manages a library it's shared with. */
  canEdit(e) {
    if (e.authorId === this.b.user.uid) return !0;
    const t = this.access();
    return t ? e.teamId && t.team && e.teamId === t.team.id && this.managesTeam() ? !0 : !!e.companyId && !!t.company && e.companyId === t.company.id && t.company.manage : !1;
  }
  /**
   * A draft's levels from the save form's toggles (none: Only me). A toggle
   * the form left as it found it (`was`) keeps that level as it was, so
   * editing a prompt filed on another board, or shared with another team or
   * company, doesn't move it here.
   */
  withLevels(e, t, i) {
    const s = this.teamId(), o = this.company(), r = i && t.board === i.levels.board ? i.boardId : t.board ? this.b.meta.id : null, a = i && t.team === i.levels.team ? i.teamId : t.team && s ? s : null, l = i && !!t.company === i.levels.company ? i.companyId : t.company && o ? o.id : null;
    return { ...e, boardId: r, teamId: a, companyId: l };
  }
  /** The save form's toggles for a draft: This board when it's filed on this board, the team or company when it's shared with one. */
  levelsFor(e) {
    return { board: !!e.boardId && e.boardId === this.b.meta.id, team: !!e.teamId, company: !!e.companyId };
  }
  /** What saving a finished result keeps: its prompt, tool, input images, settings and picture. */
  draftForResult(e) {
    const t = e.modelId && this.b.catalog.value.byId.get(e.modelId) || null, i = Hj(e, t, (o) => this.b.assetUrl(o)), s = this.session(e.sessionId);
    return i.name = this.freshName(_w(i.prompt, s ? s.name : null)), this.withLevels(i, this.b.ui.library.saveLevels);
  }
  /** A name none of your saved prompts that My prompts knows of has yet (freshNameFor asks about the rest). */
  freshName(e) {
    return Sw(e, this.myPrompts.known(), this.b.user.uid);
  }
  /** A name none of your saved prompts has: the API names yours that share its words. */
  async freshNameFor(e, t = null) {
    const i = await this.yours(e.trim());
    return Sw(e, i.concat(this.myPrompts.known()), this.b.user.uid, t);
  }
  /** A prompt you saved before with this text and tool: the API names yours that hold its words. */
  async duplicateFor(e, t, i) {
    const s = this.b.user.uid, o = Tw(this.myPrompts.known(), s, e, t, i);
    return o || !e.trim() ? o : Tw(await this.yours(Kj(e), t), s, e, t, i);
  }
  /** What saving a session's current prompt keeps; its latest result from that prompt is the picture. Null with no prompt. */
  draftForSession(e) {
    const t = this.session(e);
    if (!t) return null;
    const i = this.b.promptOf(t.id), s = (i.prompt || "").trim();
    if (!s) return null;
    const { model: o } = this.b.modelFor(t), r = o ? go(o, i, "draft").inputs : null, a = p8(o, r, i.ref ? [i.ref] : [], (d) => this.b.assetUrl(d)), l = this.b.results.list(t.id).find((d) => d.status === "done" && !!d.url && (d.prompt || "").trim() === s) || null;
    return this.withLevels({
      name: this.freshName(_w(s, t.name)),
      category: "",
      description: "",
      prompt: i.prompt || "",
      mode: Kc(a.length),
      tags: [],
      kind: Ra(t.kitId) === "video" ? "video" : "image",
      tool: { nodeDefId: o ? o.id : t.nodeDefId || "", name: o ? o.name : t.model },
      output: l ? { url: l.url, w: l.w, h: l.h, thumb: l.thumb, video: l.videoSrc } : { url: "", w: 0, h: 0 },
      inputs: a,
      boardId: null,
      teamId: null,
      companyId: null,
      values: r,
      run: l && l.runId && l.uuid ? { runId: l.runId, uuid: l.uuid } : null
    }, this.b.ui.library.saveLevels);
  }
  /**
   * A saved prompt as the save form edits it. Until its document has been
   * read, the prompt is as the API listed it, which doesn't carry the run it
   * was saved from: the draft leaves the run out, so saving keeps it.
   */
  draftFor(e) {
    const t = { ...e };
    return delete t.id, delete t.authorId, delete t.authorName, delete t.createdAt, delete t.updatedAt, this.myPrompts.isLive(e.id) || delete t.run, t;
  }
  /**
   * Save (or, with `editingId`, update) a prompt. The levels it went to are
   * where the next save starts. A new one's toast opens it. My prompts shows
   * it at once, as saved.
   */
  async save(e, t) {
    const i = this.b, s = this.shelf;
    if (!s)
      return i.toast("Saving prompts isn't available here.", "error"), null;
    const o = this.levelsFor(e);
    i.ui.library.saveLevels = { board: o.board, team: o.team };
    try {
      if (t) {
        const d = this.myPrompt(t);
        return await s.update(t, e), d && this.myPrompts.pin({ ...d, ...e, updatedAt: Date.now() }, d), i.toast("Saved your changes to " + e.name), t;
      }
      const r = { uid: i.user.uid, name: i.user.name || i.user.email || "You" }, a = await s.save(e, r), l = Date.now();
      return this.myPrompts.pin({ ...e, id: a, authorId: r.uid, authorName: r.name, createdAt: l, updatedAt: l }, null), i.toast("Saved to My prompts: " + e.name, "info", { label: "Open", run: () => this.openMine(a) }), a;
    } catch (r) {
      return console.warn("[board] saving a prompt failed", r), i.toast("The prompt couldn't be saved. Try again.", "error"), null;
    }
  }
  /** Open My prompts (at one of them). */
  openMine(e) {
    const t = this.b;
    t.dismissToast(), t.ui.infoAt = null, t.ui.infoSave = !1;
    const i = t.promptTool.value;
    this.open(i ? i.id : null), t.ui.library.tab = "mine", t.ui.library.detail = e, this.startMine();
  }
  /** Delete a saved prompt (a soft delete): gone at once, and the toast's Undo brings it back. */
  async remove(e) {
    const t = this.b, i = this.shelf;
    if (!(!i || !this.canEdit(e))) {
      t.ui.library.detail === e.id && (t.ui.library.detail = null), this.myPrompts.drop(e);
      try {
        await i.remove(e.id), t.toast("Deleted " + e.name, "info", {
          label: "Undo",
          run: () => {
            t.dismissToast(), this.myPrompts.undrop(e), i.restore(e.id).catch(() => {
              this.myPrompts.drop(e), t.toast("It couldn't be brought back.", "error");
            });
          }
        });
      } catch (s) {
        console.warn("[board] deleting a prompt failed", s), this.myPrompts.undrop(e), t.toast("The prompt couldn't be deleted. Try again.", "error");
      }
    }
  }
  // --------------------------------------------------------------- the panel
  /**
   * Open it over a session's prompt, or over the canvas: from the board menu,
   * the rail, or Start from a prompt in a menu that starts sessions. It opens
   * on All prompts (or the kind `kind` asks for), so a branch left from one
   * session never hides another's prompts. Over the canvas, `at` is where a
   * session it starts goes (a right-click's point).
   */
  open(e, t = {}) {
    const i = this.b.ui;
    i.advOpen = !1, i.boardMenu = !1, i.library.sessionId = e, i.library.at = e ? null : t.at || null, i.library.kind = t.kind || null, i.library.action = null, i.library.category = null, i.library.detail = null, i.library.editing = null, i.library.query = "", i.library.open = !0, this.load(), this.myPrompts.refresh(), this.startMine();
  }
  toggle(e) {
    const t = this.b.ui.library;
    t.open && t.sessionId === e ? this.close() : this.open(e);
  }
  close() {
    this.b.ui.library.open = !1, this.b.ui.library.detail = null, this.b.ui.library.editing = null;
  }
  /** Esc: the detail steps back to the grid, then the panel closes. */
  back() {
    const e = this.b.ui.library;
    e.editing ? e.editing = null : e.detail ? e.detail = null : this.close();
  }
  setTab(e) {
    const t = this.b.ui.library;
    t.tab = e, t.detail = null, t.editing = null, e === "mine" && this.startMine();
  }
  setCategory(e) {
    this.b.ui.library.category = e, this.b.ui.library.detail = null;
  }
  /** Both tabs narrowed to prompts for image sessions or for video ones; null for both. */
  setKind(e) {
    this.setBranch(e, null, null);
  }
  /**
   * The sidebar's branch (IL-103): a kind, what its prompts do (Generate or
   * Edit) and a category under that; each narrower one needs the one before.
   */
  setBranch(e, t = null, i = null) {
    const s = this.b.ui.library;
    s.kind = e, s.action = e ? t : null, s.category = e && t ? i : null, s.detail = null;
  }
  /** Where a tab's grid scroll is kept: it comes back only to the branch it was left in. */
  scrollKey() {
    const e = this.b.ui.library;
    return [e.tab, e.kind || "", e.action || "", e.category || ""].join("|");
  }
  // ------------------------------------------------------- what it will do
  /** The session the panel applies to, if it's still there. */
  session(e) {
    const t = e ? this.b.store.get(e) : null;
    return t && t.type === "tool" ? t : null;
  }
  /**
   * What Use prompt and Remix will do with this prompt here, said before the
   * click: the tool isn't on this board, or isn't in this session's kit.
   */
  toolNote(e, t) {
    const i = this.b.catalog.value, s = Ea(i, e.tool);
    if (!s) {
      const r = this.kitForKind(i, e.kind, this.session(t)), a = r ? ls(r) : null;
      return e.tool.name + " isn't available here. Use prompt keeps your tool" + (a ? "; Remix uses " + a.name + "." : ".");
    }
    const o = this.session(t);
    if (o) {
      const { kit: r } = this.b.modelFor(o);
      if (r && !zp(i, r, s)) return "This session can't run " + s.name + ". Use prompt keeps its tool; Remix starts a new " + (ww(i, s) || { name: "" }).name.toLowerCase() + " session.";
    }
    return "";
  }
  /** Where Remix will put the example: this session (new and empty), or a new one beside it. */
  remixFills(e, t) {
    const i = this.session(t);
    if (!i || !this.b.isUnused(i)) return !1;
    const s = this.remixKit(e, i);
    return !!s && s.id === i.kitId;
  }
  // ---------------------------------------------------------- use prompt
  /**
   * Put the prompt's text in the session, switching it to the prompt's tool
   * when its kit has it. Its images and settings stay; one Undo puts it all
   * back. With no session (opened from the board menu), a new one starts.
   */
  use(e, t) {
    const i = this.b, s = this.session(t);
    if (this.close(), !s) {
      this.startSession(e);
      return;
    }
    const o = { prompt: i.promptOf(s.id).prompt || "", model: s.model, nodeDefId: s.nodeDefId, name: s.name, fresh: i.freshTools.has(s.id) }, r = Ea(i.catalog.value, e.tool), { kit: a, model: l } = i.modelFor(s), d = r && a && (!l || l.id !== r.id) && zp(i.catalog.value, a, r) ? r : null, c = kw(s.name) ? i.uniqueSessionName(e.name, s.id) : null;
    (d || c) && i.patchTool(s.id, { ...d ? { model: d.name, nodeDefId: d.id } : {}, ...c ? { name: c } : {} }), i.setPrompt(s.id, { prompt: e.prompt }), i.landPrompt(s.id);
    const u = c || s.name;
    i.toast(d ? "Prompt added to " + u + ", on " + d.name : "Prompt added to " + u, "info", {
      label: "Undo",
      run: () => this.undoUse(s.id, o)
    });
  }
  undoUse(e, t) {
    const i = this.b, s = this.session(e);
    if (!s) return;
    const o = {};
    s.nodeDefId !== t.nodeDefId && (o.model = t.model, o.nodeDefId = t.nodeDefId), s.name !== t.name && (o.name = t.name), Object.keys(o).length && i.patchTool(e, o), i.setPrompt(e, { prompt: t.prompt }), t.fresh && i.freshTools.add(e), i.landPrompt(e), i.dismissToast();
  }
  // --------------------------------------------------------------- remix
  /** The kit Remix runs the prompt in: its tool's, the session's own first. */
  remixKit(e, t) {
    const i = this.b.catalog.value, s = Ea(i, e.tool);
    return s ? ww(i, s, t ? t.kitId : null) : this.kitForKind(i, e.kind, t);
  }
  /** Without the prompt's tool: the session's kit when it takes this kind of prompt, else the first that does. */
  kitForKind(e, t, i) {
    if (i && Ra(i.kitId) === t) {
      const s = e.kits.find((o) => o.id === i.kitId);
      if (s) return s;
    }
    return e.kits.find((s) => Ra(s.id) === t) || null;
  }
  /**
   * Recreate the example: the tool, the prompt, its input images in order and
   * the output's shape, so Run makes it again. A new, empty session takes it;
   * otherwise a new session starts beside it (a session is one line of work,
   * so one with results is never overwritten).
   */
  remix(e, t) {
    const i = this.b, s = this.session(t), o = i.catalog.value, r = Ea(o, e.tool), a = this.remixKit(e, s), l = r || (a ? ls(a) : null);
    if (this.close(), !a || !l) {
      i.toast("No tool on this board can run this prompt.", "error");
      return;
    }
    let d, c = 0;
    if (_r(e) && e.values && r && r.id === e.tool.nodeDefId) {
      const y = Ap(r, e.values, (b) => i.assetUrl(b));
      if (y.inputs)
        for (const b of r.fields) b.kind === "seed" && delete y.inputs[b.key];
      d = { ...y, prompt: e.prompt, n: 1 };
    } else
      ({ up: d, dropped: c } = Lj(l, e));
    let u, p;
    s && this.remixFills(e, s.id) ? (p = kw(s.name) ? i.uniqueSessionName(e.name, s.id) : s.name, i.patchTool(s.id, { model: l.name, nodeDefId: l.id, ...p !== s.name ? { name: p } : {} }), u = s.id, i.ui.selection = [u]) : (p = i.uniqueSessionName(e.name), u = i.addSession(a, l, p, s ? void 0 : i.ui.library.at || void 0).id), i.setPrompt(u, { prompt: d.prompt, ref: d.ref || null, inputs: d.inputs || {}, assets: d.assets, n: 1 }), i.landPrompt(u), i.track("remix_initiated", { node_def_id: l.id, source: "prompt_library", prompt_id: e.id });
    let f = "";
    r ? c && (f = " " + (c === 1 ? "One of its images doesn't" : c + " of its images don't") + " fit " + l.name + ", so " + (c === 1 ? "it was" : "they were") + " left out.") : f = " " + e.tool.name + " isn't available here, so it uses " + l.name + ".", i.toast("Remix ready in " + p + ". Run makes it again." + f);
  }
  /** Use prompt with no session: a new one, with the prompt's text, where the panel was opened for (a right-click's point). */
  startSession(e) {
    const t = this.b, i = t.catalog.value, s = Ea(i, e.tool), o = this.remixKit(e, null), r = s || (o ? ls(o) : null);
    if (!o || !r) {
      t.toast("No tool on this board can run this prompt.", "error");
      return;
    }
    const a = t.uniqueSessionName(e.name), l = t.addSession(o, r, a, t.ui.library.at || void 0).id;
    t.setPrompt(l, { prompt: e.prompt, n: 1 }), t.landPrompt(l), t.toast("New session ready: " + a);
  }
  // ----------------------------------------------------------- ghost text
  /**
   * The one-liners a new session's empty prompt cycles: its kind's, the edits
   * only once it has an image. Each session starts on its own line.
   */
  ghostLines(e) {
    const t = this.featured.value;
    if (!t) return [];
    const i = this.b.promptOf(e.id), s = (l) => typeof l == "string" && /^(https?:|blob:|data:)/.test(l), o = !!i.ref || Object.values(i.inputs || {}).some((l) => s(l) || Array.isArray(l) && l.some(s)), r = Bj(t.prompts, Ra(e.kitId), o), a = Fj(e.id, r.length);
    return r.slice(a).concat(r.slice(0, a));
  }
}
const qee = [{ key: "smileys", label: "Smileys" }, { key: "people", label: "People" }, { key: "nature", label: "Animals & nature" }, { key: "food", label: "Food & drink" }, { key: "travel", label: "Travel & places" }, { key: "activities", label: "Activities" }, { key: "objects", label: "Objects" }, { key: "symbols", label: "Symbols" }, { key: "flags", label: "Flags" }], Kee = `#smileys
😀|grinning face|cheerful cheery grin happy laugh nice|grinning|1|
😃|grinning face with big eyes|awesome grin happy mouth open smile|smiley|0.6|
😄|grinning face with smiling eyes|eye grin happy laugh lol mouth|smile|0.6|
😁|beaming face with smiling eyes|eye grin grinning happy nice smile|grin|0.6|
😆|grinning squinting face|closed eyes haha hahaha happy laugh|laughing satisfied|0.6|
😅|grinning face with sweat|cold dejected excited mouth nervous open|sweat_smile|0.6|
🤣|rolling on the floor laughing|crying face funny haha happy hehe|rofl|3|
😂|face with tears of joy|crying feels funny haha happy hehe|joy|0.6|
🙂|slightly smiling face|happy smile|slightly_smiling_face|1|
🙃|upside-down face|hehe smile upside-down|upside_down_face|1|
🫠|melting face|disappear dissolve embarrassed haha heat hot|melting_face|14|
🫫|cracking face|breaking crumbling masking resilience reveal tension||18|
😉|winking face|flirt heartbreaker sexy slide tease wink|wink|0.6|
😊|smiling face with smiling eyes|blush eye glad satisfied smile|blush|0.6|
😇|smiling face with halo|angel angelic angels blessed fairy fairytale|innocent|1|
🥰|smiling face with hearts|3 adore crush heart ily love|smiling_face_with_three_hearts|11|
😍|smiling face with heart-eyes|143 bae eye feels heart-eyes hearts|heart_eyes|0.6|
🤩|star-struck|excited eyes face grinning smile starry-eyed|star_struck|5|
😘|face blowing a kiss|adorbs bae flirt heart ily love|kissing_heart|0.6|
😗|kissing face|143 date dating flirt ily kiss|kissing|1|
☺️|smiling face|happy outlined relaxed smile|relaxed|0.6|
😚|kissing face with closed eyes|143 bae blush date dating eye|kissing_closed_eyes|0.6|
😙|kissing face with smiling eyes|143 closed date dating eye flirt|kissing_smiling_eyes|1|
🥲|smiling face with tear|glad grateful happy joy pain proud|smiling_face_with_tear|13|
😋|face savoring food|delicious eat full hungry savor smile|yum|0.6|
😛|face with tongue|awesome cool nice party stuck-out sweet|stuck_out_tongue|1|
😜|winking face with tongue|crazy epic eye funny joke loopy|stuck_out_tongue_winking_eye|0.6|
🤪|zany face|crazy eye eyes goofy large small|zany_face|5|
😝|squinting face with tongue|closed eye eyes gross horrible omg|stuck_out_tongue_closed_eyes|0.6|
🤑|money-mouth face|money-mouth paid|money_mouth_face|1|
🤗|smiling face with open hands|hug hugging|hugs|1|
🤭|face with hand over mouth|giggle giggling oops realization secret shock|hand_over_mouth|5|
🫢|face with open eyes and hand over mouth|amazement awe disbelief embarrass gasp omg|face_with_open_eyes_and_hand_over_mouth|14|
🫣|face with peeking eye|captivated embarrass hide hiding peek peep|face_with_peeking_eye|14|
🤫|shushing face|quiet shh shush|shushing_face|5|
🤔|thinking face|chin consider hmm ponder pondering wondering|thinking|1|
🫡|saluting face|ok good luck ma’am respect salute|saluting_face|14|
🤐|zipper-mouth face|keep quiet secret shut zip zipper-mouth|zipper_mouth_face|1|
🤨|face with raised eyebrow|disapproval disbelief distrust emoji hmm mild|raised_eyebrow|5|
😐|neutral face|awkward blank deadpan expressionless fine jealous|neutral_face|0.7|
😑|expressionless face|awkward dead fine inexpressive jealous meh|expressionless|1|
😶|face without mouth|awkward blank expressionless mouthless mute quiet|no_mouth|1|
🫥|dotted line face|depressed disappear hidden hide introvert invisible|dotted_line_face|14|
😶‍🌫️|face in clouds|absentminded fog head|face_in_clouds|13.1|
😏|smirking face|boss dapper flirt homie kidding leer|smirk|0.6|
😒|unamused face|... bored fine jealous jel jelly|unamused|0.6|
🙄|face with rolling eyes|eyeroll shade ugh whatever|roll_eyes|1|
😬|grimacing face|awk awkward dentist grimace grinning smile|grimacing|1|
😮‍💨|face exhaling|blow blowing exhale exhausted gasp groan|face_exhaling|13.1|
🤥|lying face|liar lie pinocchio|lying_face|3|
🫨|shaking face|crazy daze earthquake omg panic shock|shaking_face|15|
🙂‍↔️|head shaking horizontally|no shake||15.1|
🙂‍↕️|head shaking vertically|nod yes||15.1|
😌|relieved face|calm peace relief zen|relieved|0.6|
😔|pensive face|awful bored dejected died disappointed losing|pensive|0.6|
😪|sleepy face|crying good night sad sleep sleeping|sleepy|0.6|
🤤|drooling face||drooling_face|3|
😴|sleeping face|bed bedtime good goodnight nap night|sleeping|1|
🫩|face with bags under eyes|bored exhausted fatigued late sleepy tired||16|
😷|face with medical mask|cold dentist dermatologist doctor dr germs|mask|0.6|
🤒|face with thermometer|ill sick|face_with_thermometer|1|
🤕|face with head-bandage|head-bandage hurt injury ouch|face_with_head_bandage|1|
🤢|nauseated face|gross nasty sick vomit|nauseated_face|3|
🤮|face vomiting|barf ew gross puke sick spew|vomiting_face|5|
🤧|sneezing face|fever flu gesundheit sick sneeze|sneezing_face|3|
🥵|hot face|dying feverish heat panting red-faced stroke|hot_face|11|
🥶|cold face|blue blue-faced freezing frostbite icicles subzero|cold_face|11|
🥴|woozy face|dizzy drunk eyes intoxicated mouth tipsy|woozy_face|11|
😵|face with crossed-out eyes|crossed-out dead dizzy feels knocked sick|dizzy_face|0.6|
😵‍💫|face with spiral eyes|confused dizzy hypnotized omg smiley trouble|face_with_spiral_eyes|13.1|
🤯|exploding head|blown explode mind mindblown no shocked|exploding_head|5|
🤠|cowboy hat face|cowgirl|cowboy_hat_face|3|
🥳|partying face|bday birthday celebrate celebration excited happy|partying_face|11|
🥸|disguised face|disguise eyebrow glasses incognito moustache mustache|disguised_face|13|
😎|smiling face with sunglasses|awesome beach bright bro chilling cool|sunglasses|1|
🤓|nerd face|brainy clever expert geek gifted glasses|nerd_face|1|
🧐|face with monocle|classy fancy rich stuffy wealthy|monocle_face|5|
😕|confused face|befuddled confusing dunno frown hm meh|confused|1|
🫤|face with diagonal mouth|confused confusion disappointed doubt doubtful frustrated|face_with_diagonal_mouth|14|
😟|worried face|anxious butterflies nerves nervous sad stress|worried|1|
🙁|slightly frowning face|frown sad|slightly_frowning_face|1|
☹️|frowning face|frown sad|frowning_face|0.7|
😮|face with open mouth|believe forgot omg shocked surprised sympathy|open_mouth|1|
😯|hushed face|epic omg stunned surprised whoa woah|hushed|1|
😲|astonished face|cost no omg shocked totally way|astonished|0.6|
😳|flushed face|amazed awkward crazy dazed dead disbelief|flushed|0.6|
🫪|distorted face|anxiety bloated panic shocked surprised vulnerable||17|
🥺|pleading face|begging big eyes mercy not please|pleading_face|11|
🥹|face holding back tears|admiration aww cry embarrassed feelings grateful|face_holding_back_tears|14|
😦|frowning face with open mouth|caught frown guard scared scary surprise|frowning|1|
😧|anguished face|forgot scared scary stressed surprise unhappy|anguished|1|
😨|fearful face|afraid anxious blame fear scared worried|fearful|0.6|
😰|anxious face with sweat|blue cold eek mouth nervous open|cold_sweat|0.6|
😥|sad but relieved face|anxious call close complicated disappointed not|disappointed_relieved|0.6|
😢|crying face|awful cry feels miss sad tear|cry|0.6|
😭|loudly crying face|bawling cry sad sob tear tears|sob|0.6|
😱|face screaming in fear|epic fearful munch scared scream screamer|scream|0.6|
😖|confounded face|annoyed confused cringe distraught feels frustrated|confounded|0.6|
😣|persevering face|concentrate concentration focus headache persevere|persevere|0.6|
😞|disappointed face|awful blame dejected fail losing sad|disappointed|0.6|
😓|downcast face with sweat|close cold feels headache nervous sad|sweat|0.6|
😩|weary face|crying fail feels hungry mad nooo|weary|0.6|
😫|tired face|cost feels nap sad sneeze|tired_face|0.6|
🥱|yawning face|bedtime bored goodnight nap night sleep|yawning_face|12|
😤|face with steam from nose|anger angry feels fume fuming furious|triumph|0.6|
😡|enraged face|anger angry feels mad maddening pouting|pout rage|0.6|
😠|angry face|anger blame feels frustrated mad maddening|angry|0.6|
🤬|face with symbols on mouth|censor cursing cussing mad pissed swearing|cursing_face|5|
😈|smiling face with horns|demon devil evil fairy fairytale fantasy|smiling_imp|1|
👿|angry face with horns|demon devil evil fairy fairytale fantasy|imp|0.6|
💀|skull|body dead death face fairy fairytale|skull|0.6|
☠️|skull and crossbones|bone dead death face monster|skull_and_crossbones|1|
💩|pile of poo|bs comic doo dung face fml|hankey poop|0.6|
🤡|clown face||clown_face|3|
👹|ogre|creature devil face fairy fairytale fantasy|japanese_ogre|0.6|
👺|goblin|angry creature face fairy fairytale fantasy|japanese_goblin|0.6|
👻|ghost|boo creature excited face fairy fairytale|ghost|0.6|
👽|alien|creature extraterrestrial face fairy fairytale fantasy|alien|0.6|
👾|alien monster|creature extraterrestrial face fairy fairytale fantasy|space_invader|0.6|
🤖|robot|face monster|robot|1|
😺|grinning cat|animal face mouth open smile smiling|smiley_cat|0.6|
😸|grinning cat with smiling eyes|animal eye face grin smile|smile_cat|0.6|
😹|cat with tears of joy|animal face laugh laughing lol tear|joy_cat|0.6|
😻|smiling cat with heart-eyes|animal eye face heart-eyes love smile|heart_eyes_cat|0.6|
😼|cat with wry smile|animal face ironic|smirk_cat|0.6|
😽|kissing cat|animal closed eye eyes face kiss|kissing_cat|0.6|
🙀|weary cat|animal face oh surprised|scream_cat|0.6|
😿|crying cat|animal cry face sad tear|crying_cat_face|0.6|
😾|pouting cat|animal face|pouting_cat|0.6|
🙈|see-no-evil monkey|embarrassed face forbidden forgot gesture hide|see_no_evil|0.6|
🙉|hear-no-evil monkey|animal ears face forbidden gesture listen|hear_no_evil|0.6|
🙊|speak-no-evil monkey|animal face forbidden gesture not oops|speak_no_evil|0.6|
💌|love letter|heart mail romance valentine|love_letter|0.6|
💘|heart with arrow|143 adorbs cupid date emotion ily|cupid|0.6|
💝|heart with ribbon|143 anniversary emotion ily kisses valentine|gift_heart|0.6|
💖|sparkling heart|143 emotion excited good ily kisses|sparkling_heart|0.6|
💗|growing heart|143 emotion excited heartpulse ily kisses|heartpulse|0.6|
💓|beating heart|143 cardio emotion heartbeat ily love|heartbeat|0.6|
💞|revolving hearts|143 adorbs anniversary emotion heart|revolving_hearts|0.6|
💕|two hearts|143 anniversary date dating emotion heart|two_hearts|0.6|
💟|heart decoration|143 emotion hearth purple white|heart_decoration|0.6|
❣️|heart exclamation|bang heavy mark punctuation|heavy_heart_exclamation|1|
💔|broken heart|break crushed emotion heartbroken lonely sad|broken_heart|0.6|
❤️‍🔥|heart on fire|burn love lust sacred|heart_on_fire|13.1|
❤️‍🩹|mending heart|healthier improving recovering recuperating well|mending_heart|13.1|
❤️|red heart|emotion love|heart|0.6|
🩷|pink heart|143 adorable cute emotion ily like|pink_heart|15|
🧡|orange heart|143|orange_heart|5|
💛|yellow heart|143 cardiac emotion ily love|yellow_heart|0.6|
💚|green heart|143 emotion ily love romantic|green_heart|0.6|
💙|blue heart|143 emotion ily love romance|blue_heart|0.6|
🩵|light blue heart|143 cute cyan emotion ily like|light_blue_heart|15|
💜|purple heart|143 bestest emotion ily love|purple_heart|0.6|
🤎|brown heart|143|brown_heart|12|
🖤|black heart|evil wicked|black_heart|3|
🩶|grey heart|143 emotion gray ily love silver|grey_heart|15|
🤍|white heart|143|white_heart|12|
💋|kiss mark|dating emotion heart kissing lips romance|kiss|0.6|
💯|hundred points|100 true a+ agree clearly definitely|100|0.6|
💢|anger symbol|angry comic mad upset|anger|0.6|
🫯|fight cloud|argument brawl debate disagreement ruckus wrestle||17|
💥|collision|bomb boom collide comic explode|boom collision|0.6|
💫|dizzy|comic shining shooting star stars|dizzy|0.6|
💦|sweat droplets|comic drip droplet drops splashing squirt|sweat_drops|0.6|
💨|dashing away|cloud comic dash fart fast go|dash|0.6|
🕳️|hole||hole|0.7|
💬|speech balloon|bubble comic dialog message sms talk|speech_balloon|0.6|
👁️‍🗨️|eye in speech bubble|balloon witness|eye_speech_bubble|2|
🗨️|left speech bubble|balloon dialog|left_speech_bubble|2|
🗯️|right anger bubble|angry balloon mad|right_anger_bubble|0.7|
💭|thought balloon|bubble cartoon cloud comic daydream decisions|thought_balloon|1|
💤|ZZZ|comic good goodnight night sleep sleeping|zzz|0.6|
#people
👋|waving hand|bye cya g2g greetings gtg hello|wave|0.6|👋🏻 👋🏼 👋🏽 👋🏾 👋🏿
🤚|raised back of hand|backhand|raised_back_of_hand|3|🤚🏻 🤚🏼 🤚🏽 🤚🏾 🤚🏿
🖐️|hand with fingers splayed|finger raised stop|raised_hand_with_fingers_splayed|0.7|🖐🏻 🖐🏼 🖐🏽 🖐🏾 🖐🏿
✋|raised hand|5 five high stop|hand raised_hand|0.6|✋🏻 ✋🏼 ✋🏽 ✋🏾 ✋🏿
🖖|vulcan salute|finger hand hands|vulcan_salute|1|🖖🏻 🖖🏼 🖖🏽 🖖🏾 🖖🏿
🫱|rightwards hand|handshake hold reach right rightward shake|rightwards_hand|14|🫱🏻 🫱🏼 🫱🏽 🫱🏾 🫱🏿
🫲|leftwards hand|handshake hold left leftward reach shake|leftwards_hand|14|🫲🏻 🫲🏼 🫲🏽 🫲🏾 🫲🏿
🫳|palm down hand|dismiss drop dropped pick shoo up|palm_down_hand|14|🫳🏻 🫳🏼 🫳🏽 🫳🏾 🫳🏿
🫴|palm up hand|beckon catch come hold know lift|palm_up_hand|14|🫴🏻 🫴🏼 🫴🏽 🫴🏾 🫴🏿
🫷|leftwards pushing hand|block five halt high hold leftward|leftwards_pushing_hand|15|🫷🏻 🫷🏼 🫷🏽 🫷🏾 🫷🏿
🫸|rightwards pushing hand|block five halt high hold pause|rightwards_pushing_hand|15|🫸🏻 🫸🏼 🫸🏽 🫸🏾 🫸🏿
👌|OK hand|awesome bet dope fleek fosho got|ok_hand|0.6|👌🏻 👌🏼 👌🏽 👌🏾 👌🏿
🤌|pinched fingers|gesture hand hold huh interrogation patience|pinched_fingers|13|🤌🏻 🤌🏼 🤌🏽 🤌🏾 🤌🏿
🤏|pinching hand|amount bit fingers little small sort|pinching_hand|12|🤏🏻 🤏🏼 🤏🏽 🤏🏾 🤏🏿
✌️|victory hand|peace v|v|0.6|✌🏻 ✌🏼 ✌🏽 ✌🏾 ✌🏿
🤞|crossed fingers|cross finger hand luck|crossed_fingers|3|🤞🏻 🤞🏼 🤞🏽 🤞🏾 🤞🏿
🫰|hand with index finger and thumb crossed|<3 expensive heart love money snap|hand_with_index_finger_and_thumb_crossed|14|🫰🏻 🫰🏼 🫰🏽 🫰🏾 🫰🏿
🤟|love-you gesture|ily fingers hand love-you three|love_you_gesture|5|🤟🏻 🤟🏼 🤟🏽 🤟🏾 🤟🏿
🤘|sign of the horns|finger hand rock-on|metal|1|🤘🏻 🤘🏼 🤘🏽 🤘🏾 🤘🏿
🤙|call me hand|shaka hang loose|call_me_hand|3|🤙🏻 🤙🏼 🤙🏽 🤙🏾 🤙🏿
👈|backhand index pointing left|finger hand point|point_left|0.6|👈🏻 👈🏼 👈🏽 👈🏾 👈🏿
👉|backhand index pointing right|finger hand point|point_right|0.6|👉🏻 👉🏼 👉🏽 👉🏾 👉🏿
👆|backhand index pointing up|finger hand point|point_up_2|0.6|👆🏻 👆🏼 👆🏽 👆🏾 👆🏿
🖕|middle finger|hand|fu middle_finger|1|🖕🏻 🖕🏼 🖕🏽 🖕🏾 🖕🏿
👇|backhand index pointing down|finger hand point|point_down|0.6|👇🏻 👇🏼 👇🏽 👇🏾 👇🏿
☝️|index pointing up|finger hand point this|point_up|0.6|☝🏻 ☝🏼 ☝🏽 ☝🏾 ☝🏿
🫵|index pointing at the viewer|finger hand poke you|index_pointing_at_the_viewer|14|🫵🏻 🫵🏼 🫵🏽 🫵🏾 🫵🏿
👍|thumbs up|+1 good hand like thumb yes|+1 thumbsup|0.6|👍🏻 👍🏼 👍🏽 👍🏾 👍🏿
👎|thumbs down|-1 bad dislike good hand no|-1 thumbsdown|0.6|👎🏻 👎🏼 👎🏽 👎🏾 👎🏿
🫹|leftwards thumb sign|grip left neutral point that this||18|🫹🏻 🫹🏼 🫹🏽 🫹🏾 🫹🏿
🫺|rightwards thumb sign|grip neutral point right that this||18|🫺🏻 🫺🏼 🫺🏽 🫺🏾 🫺🏿
✊|raised fist|clenched hand punch solidarity|fist fist_raised|0.6|✊🏻 ✊🏼 ✊🏽 ✊🏾 ✊🏿
👊|oncoming fist|absolutely agree boom bro bruh bump|facepunch fist_oncoming|0.6|👊🏻 👊🏼 👊🏽 👊🏾 👊🏿
🤛|left-facing fist|left-facing leftwards|fist_left|3|🤛🏻 🤛🏼 🤛🏽 🤛🏾 🤛🏿
🤜|right-facing fist|right-facing rightwards|fist_right|3|🤜🏻 🤜🏼 🤜🏽 🤜🏾 🤜🏿
👏|clapping hands|applause approval awesome clap congrats congratulations|clap|0.6|👏🏻 👏🏼 👏🏽 👏🏾 👏🏿
🙌|raising hands|celebration gesture hand hooray praise raised|raised_hands|0.6|🙌🏻 🙌🏼 🙌🏽 🙌🏾 🙌🏿
🫶|heart hands|<3 love you|heart_hands|14|🫶🏻 🫶🏼 🫶🏽 🫶🏾 🫶🏿
👐|open hands|hand hug jazz swerve|open_hands|0.6|👐🏻 👐🏼 👐🏽 👐🏾 👐🏿
🤲|palms up together|cupped dua hands pray prayer wish|palms_up_together|5|🤲🏻 🤲🏼 🤲🏽 🤲🏾 🤲🏿
🤝|handshake|agreement deal hand meeting shake|handshake|3|🤝🏻 🤝🏼 🤝🏽 🤝🏾 🤝🏿
🙏|folded hands|appreciate ask beg blessed bow cmon|pray|0.6|🙏🏻 🙏🏼 🙏🏽 🙏🏾 🙏🏿
✍️|writing hand|write|writing_hand|0.7|✍🏻 ✍🏼 ✍🏽 ✍🏾 ✍🏿
💅|nail polish|bored care cosmetics done makeup manicure|nail_care|0.6|💅🏻 💅🏼 💅🏽 💅🏾 💅🏿
🤳|selfie|camera phone|selfie|3|🤳🏻 🤳🏼 🤳🏽 🤳🏾 🤳🏿
💪|flexed biceps|arm beast bench bodybuilder bro curls|muscle|0.6|💪🏻 💪🏼 💪🏽 💪🏾 💪🏿
🦾|mechanical arm|accessibility prosthetic|mechanical_arm|12|
🦿|mechanical leg|accessibility prosthetic|mechanical_leg|12|
🦵|leg|bent foot kick knee limb|leg|11|🦵🏻 🦵🏼 🦵🏽 🦵🏾 🦵🏿
🦶|foot|ankle feet kick stomp|foot|11|🦶🏻 🦶🏼 🦶🏽 🦶🏾 🦶🏿
👂|ear|body ears hear hearing listen listening|ear|0.6|👂🏻 👂🏼 👂🏽 👂🏾 👂🏿
🦻|ear with hearing aid|accessibility hard|ear_with_hearing_aid|12|🦻🏻 🦻🏼 🦻🏽 🦻🏾 🦻🏿
👃|nose|body noses nosey odor smell smells|nose|0.6|👃🏻 👃🏼 👃🏽 👃🏾 👃🏿
🧠|brain|intelligent smart|brain|5|
🫀|anatomical heart|beat cardiology heartbeat organ pulse real|anatomical_heart|13|
🫁|lungs|breath breathe exhalation inhalation lung organ|lungs|13|
🦷|tooth|dentist pearly teeth white|tooth|11|
🦴|bone|bones dog skeleton wishbone|bone|11|
👀|eyes|body eye face googly look looking|eyes|0.6|
👁️|eye|1 body one|eye|0.7|
👅|tongue|body lick slurp|tongue|0.6|
👄|mouth|beauty body kiss kissing lips lipstick|lips|0.6|
🫦|biting lip|anxious bite fear flirt flirting kiss|biting_lip|14|
👶|baby|babies children goo infant newborn pregnant|baby|0.6|👶🏻 👶🏼 👶🏽 👶🏾 👶🏿
🧒|child|bright-eyed grandchild kid young younger|child|5|🧒🏻 🧒🏼 🧒🏽 🧒🏾 🧒🏿
👦|boy|bright-eyed child grandson kid son young|boy|0.6|👦🏻 👦🏼 👦🏽 👦🏾 👦🏿
👧|girl|virgo bright-eyed child daughter granddaughter kid|girl|0.6|👧🏻 👧🏼 👧🏽 👧🏾 👧🏿
🧑|person|adult|adult|5|🧑🏻 🧑🏼 🧑🏽 🧑🏾 🧑🏿
👱|person: blond hair|blond-haired human|blond_haired_person|0.6|👱🏻 👱🏼 👱🏽 👱🏾 👱🏿
👨|man|adult bro|man|0.6|👨🏻 👨🏼 👨🏽 👨🏾 👨🏿
🧔|person: beard|bearded whiskers|bearded_person|5|🧔🏻 🧔🏼 🧔🏽 🧔🏾 🧔🏿
🧔‍♂️|man: beard|bearded whiskers|man_beard|13.1|🧔🏻‍♂️ 🧔🏼‍♂️ 🧔🏽‍♂️ 🧔🏾‍♂️ 🧔🏿‍♂️
🧔‍♀️|woman: beard|bearded whiskers|woman_beard|13.1|🧔🏻‍♀️ 🧔🏼‍♀️ 🧔🏽‍♀️ 🧔🏾‍♀️ 🧔🏿‍♀️
👨‍🦰|man: red hair|adult bro red hair|red_haired_man|11|👨🏻‍🦰 👨🏼‍🦰 👨🏽‍🦰 👨🏾‍🦰 👨🏿‍🦰
👨‍🦱|man: curly hair|adult bro curly hair|curly_haired_man|11|👨🏻‍🦱 👨🏼‍🦱 👨🏽‍🦱 👨🏾‍🦱 👨🏿‍🦱
👨‍🦳|man: white hair|adult bro white hair|white_haired_man|11|👨🏻‍🦳 👨🏼‍🦳 👨🏽‍🦳 👨🏾‍🦳 👨🏿‍🦳
👨‍🦲|man: bald|adult bro|bald_man|11|👨🏻‍🦲 👨🏼‍🦲 👨🏽‍🦲 👨🏾‍🦲 👨🏿‍🦲
👩|woman|adult lady|woman|0.6|👩🏻 👩🏼 👩🏽 👩🏾 👩🏿
👩‍🦰|woman: red hair|adult lady red hair|red_haired_woman|11|👩🏻‍🦰 👩🏼‍🦰 👩🏽‍🦰 👩🏾‍🦰 👩🏿‍🦰
🧑‍🦰|person: red hair|adult red hair|person_red_hair|12.1|🧑🏻‍🦰 🧑🏼‍🦰 🧑🏽‍🦰 🧑🏾‍🦰 🧑🏿‍🦰
👩‍🦱|woman: curly hair|adult curly hair lady|curly_haired_woman|11|👩🏻‍🦱 👩🏼‍🦱 👩🏽‍🦱 👩🏾‍🦱 👩🏿‍🦱
🧑‍🦱|person: curly hair|adult curly hair|person_curly_hair|12.1|🧑🏻‍🦱 🧑🏼‍🦱 🧑🏽‍🦱 🧑🏾‍🦱 🧑🏿‍🦱
👩‍🦳|woman: white hair|adult lady white hair|white_haired_woman|11|👩🏻‍🦳 👩🏼‍🦳 👩🏽‍🦳 👩🏾‍🦳 👩🏿‍🦳
🧑‍🦳|person: white hair|adult white hair|person_white_hair|12.1|🧑🏻‍🦳 🧑🏼‍🦳 🧑🏽‍🦳 🧑🏾‍🦳 🧑🏿‍🦳
👩‍🦲|woman: bald|adult lady|bald_woman|11|👩🏻‍🦲 👩🏼‍🦲 👩🏽‍🦲 👩🏾‍🦲 👩🏿‍🦲
🧑‍🦲|person: bald|adult|person_bald|12.1|🧑🏻‍🦲 🧑🏼‍🦲 🧑🏽‍🦲 🧑🏾‍🦲 🧑🏿‍🦲
👱‍♀️|woman: blond hair|blond-haired blonde|blond_haired_woman blonde_woman|4|👱🏻‍♀️ 👱🏼‍♀️ 👱🏽‍♀️ 👱🏾‍♀️ 👱🏿‍♀️
👱‍♂️|man: blond hair|blond-haired|blond_haired_man|4|👱🏻‍♂️ 👱🏼‍♂️ 👱🏽‍♂️ 👱🏾‍♂️ 👱🏿‍♂️
🧓|older person|adult elderly grandparent old wise|older_adult|5|🧓🏻 🧓🏼 🧓🏽 🧓🏾 🧓🏿
👴|old man|adult bald elderly gramps grandfather grandpa|older_man|0.6|👴🏻 👴🏼 👴🏽 👴🏾 👴🏿
👵|old woman|adult elderly grandma grandmother granny lady|older_woman|0.6|👵🏻 👵🏼 👵🏽 👵🏾 👵🏿
🙍|person frowning|annoyed disappointed disgruntled disturbed frown frustrated|frowning_person|0.6|🙍🏻 🙍🏼 🙍🏽 🙍🏾 🙍🏿
🙍‍♂️|man frowning|annoyed disappointed disgruntled disturbed frown frustrated|frowning_man|4|🙍🏻‍♂️ 🙍🏼‍♂️ 🙍🏽‍♂️ 🙍🏾‍♂️ 🙍🏿‍♂️
🙍‍♀️|woman frowning|annoyed disappointed disgruntled disturbed frown frustrated|frowning_woman|4|🙍🏻‍♀️ 🙍🏼‍♀️ 🙍🏽‍♀️ 🙍🏾‍♀️ 🙍🏿‍♀️
🙎|person pouting|disappointed downtrodden frown grimace scowl sulk|pouting_face|0.6|🙎🏻 🙎🏼 🙎🏽 🙎🏾 🙎🏿
🙎‍♂️|man pouting|disappointed downtrodden frown grimace scowl sulk|pouting_man|4|🙎🏻‍♂️ 🙎🏼‍♂️ 🙎🏽‍♂️ 🙎🏾‍♂️ 🙎🏿‍♂️
🙎‍♀️|woman pouting|disappointed downtrodden frown grimace scowl sulk|pouting_woman|4|🙎🏻‍♀️ 🙎🏼‍♀️ 🙎🏽‍♀️ 🙎🏾‍♀️ 🙎🏿‍♀️
🙅|person gesturing NO|forbidden gesture hand not prohibit|no_good|0.6|🙅🏻 🙅🏼 🙅🏽 🙅🏾 🙅🏿
🙅‍♂️|man gesturing NO|forbidden gesture hand not prohibit|ng_man no_good_man|4|🙅🏻‍♂️ 🙅🏼‍♂️ 🙅🏽‍♂️ 🙅🏾‍♂️ 🙅🏿‍♂️
🙅‍♀️|woman gesturing NO|forbidden gesture hand not prohibit|ng_woman no_good_woman|4|🙅🏻‍♀️ 🙅🏼‍♀️ 🙅🏽‍♀️ 🙅🏾‍♀️ 🙅🏿‍♀️
🙆|person gesturing OK|exercise gesture hand omg|ok_person|0.6|🙆🏻 🙆🏼 🙆🏽 🙆🏾 🙆🏿
🙆‍♂️|man gesturing OK|exercise gesture hand omg|ok_man|4|🙆🏻‍♂️ 🙆🏼‍♂️ 🙆🏽‍♂️ 🙆🏾‍♂️ 🙆🏿‍♂️
🙆‍♀️|woman gesturing OK|exercise gesture hand omg|ok_woman|4|🙆🏻‍♀️ 🙆🏼‍♀️ 🙆🏽‍♀️ 🙆🏾‍♀️ 🙆🏿‍♀️
💁|person tipping hand|fetch flick flip gossip sarcasm sarcastic|information_desk_person tipping_hand_person|0.6|💁🏻 💁🏼 💁🏽 💁🏾 💁🏿
💁‍♂️|man tipping hand|fetch flick flip gossip sarcasm sarcastic|sassy_man tipping_hand_man|4|💁🏻‍♂️ 💁🏼‍♂️ 💁🏽‍♂️ 💁🏾‍♂️ 💁🏿‍♂️
💁‍♀️|woman tipping hand|fetch flick flip gossip sarcasm sarcastic|sassy_woman tipping_hand_woman|4|💁🏻‍♀️ 💁🏼‍♀️ 💁🏽‍♀️ 💁🏾‍♀️ 💁🏿‍♀️
🙋|person raising hand|gesture here know me pick question|raising_hand|0.6|🙋🏻 🙋🏼 🙋🏽 🙋🏾 🙋🏿
🙋‍♂️|man raising hand|gesture here know me pick question|raising_hand_man|4|🙋🏻‍♂️ 🙋🏼‍♂️ 🙋🏽‍♂️ 🙋🏾‍♂️ 🙋🏿‍♂️
🙋‍♀️|woman raising hand|gesture here know me pick question|raising_hand_woman|4|🙋🏻‍♀️ 🙋🏼‍♀️ 🙋🏽‍♀️ 🙋🏾‍♀️ 🙋🏿‍♀️
🧏|deaf person|accessibility ear gesture hear|deaf_person|12|🧏🏻 🧏🏼 🧏🏽 🧏🏾 🧏🏿
🧏‍♂️|deaf man|accessibility ear gesture hear|deaf_man|12|🧏🏻‍♂️ 🧏🏼‍♂️ 🧏🏽‍♂️ 🧏🏾‍♂️ 🧏🏿‍♂️
🧏‍♀️|deaf woman|accessibility ear gesture hear|deaf_woman|12|🧏🏻‍♀️ 🧏🏼‍♀️ 🧏🏽‍♀️ 🧏🏾‍♀️ 🧏🏿‍♀️
🙇|person bowing|apology ask beg bow favor forgive|bow|0.6|🙇🏻 🙇🏼 🙇🏽 🙇🏾 🙇🏿
🙇‍♂️|man bowing|apology ask beg bow favor forgive|bowing_man|4|🙇🏻‍♂️ 🙇🏼‍♂️ 🙇🏽‍♂️ 🙇🏾‍♂️ 🙇🏿‍♂️
🙇‍♀️|woman bowing|apology ask beg bow favor forgive|bowing_woman|4|🙇🏻‍♀️ 🙇🏼‍♀️ 🙇🏽‍♀️ 🙇🏾‍♀️ 🙇🏿‍♀️
🤦|person facepalming|again bewilder disbelief exasperation facepalm no|facepalm|3|🤦🏻 🤦🏼 🤦🏽 🤦🏾 🤦🏿
🤦‍♂️|man facepalming|again bewilder disbelief exasperation facepalm no|man_facepalming|4|🤦🏻‍♂️ 🤦🏼‍♂️ 🤦🏽‍♂️ 🤦🏾‍♂️ 🤦🏿‍♂️
🤦‍♀️|woman facepalming|again bewilder disbelief exasperation facepalm no|woman_facepalming|4|🤦🏻‍♀️ 🤦🏼‍♀️ 🤦🏽‍♀️ 🤦🏾‍♀️ 🤦🏿‍♀️
🤷|person shrugging|doubt dunno guess idk ignorance indifference|shrug|3|🤷🏻 🤷🏼 🤷🏽 🤷🏾 🤷🏿
🤷‍♂️|man shrugging|doubt dunno guess idk ignorance indifference|man_shrugging|4|🤷🏻‍♂️ 🤷🏼‍♂️ 🤷🏽‍♂️ 🤷🏾‍♂️ 🤷🏿‍♂️
🤷‍♀️|woman shrugging|doubt dunno guess idk ignorance indifference|woman_shrugging|4|🤷🏻‍♀️ 🤷🏼‍♀️ 🤷🏽‍♀️ 🤷🏾‍♀️ 🤷🏿‍♀️
🧑‍⚕️|health worker|doctor healthcare nurse therapist|health_worker|12.1|🧑🏻‍⚕️ 🧑🏼‍⚕️ 🧑🏽‍⚕️ 🧑🏾‍⚕️ 🧑🏿‍⚕️
👨‍⚕️|man health worker|doctor healthcare nurse therapist|man_health_worker|4|👨🏻‍⚕️ 👨🏼‍⚕️ 👨🏽‍⚕️ 👨🏾‍⚕️ 👨🏿‍⚕️
👩‍⚕️|woman health worker|doctor healthcare nurse therapist|woman_health_worker|4|👩🏻‍⚕️ 👩🏼‍⚕️ 👩🏽‍⚕️ 👩🏾‍⚕️ 👩🏿‍⚕️
🧑‍🎓|student|graduate|student|12.1|🧑🏻‍🎓 🧑🏼‍🎓 🧑🏽‍🎓 🧑🏾‍🎓 🧑🏿‍🎓
👨‍🎓|man student|graduate|man_student|4|👨🏻‍🎓 👨🏼‍🎓 👨🏽‍🎓 👨🏾‍🎓 👨🏿‍🎓
👩‍🎓|woman student|graduate|woman_student|4|👩🏻‍🎓 👩🏼‍🎓 👩🏽‍🎓 👩🏾‍🎓 👩🏿‍🎓
🧑‍🏫|teacher|instructor lecturer professor|teacher|12.1|🧑🏻‍🏫 🧑🏼‍🏫 🧑🏽‍🏫 🧑🏾‍🏫 🧑🏿‍🏫
👨‍🏫|man teacher|instructor lecturer professor|man_teacher|4|👨🏻‍🏫 👨🏼‍🏫 👨🏽‍🏫 👨🏾‍🏫 👨🏿‍🏫
👩‍🏫|woman teacher|instructor lecturer professor|woman_teacher|4|👩🏻‍🏫 👩🏼‍🏫 👩🏽‍🏫 👩🏾‍🏫 👩🏿‍🏫
🧑‍⚖️|judge|justice law scales|judge|12.1|🧑🏻‍⚖️ 🧑🏼‍⚖️ 🧑🏽‍⚖️ 🧑🏾‍⚖️ 🧑🏿‍⚖️
👨‍⚖️|man judge|justice law scales|man_judge|4|👨🏻‍⚖️ 👨🏼‍⚖️ 👨🏽‍⚖️ 👨🏾‍⚖️ 👨🏿‍⚖️
👩‍⚖️|woman judge|justice law scales|woman_judge|4|👩🏻‍⚖️ 👩🏼‍⚖️ 👩🏽‍⚖️ 👩🏾‍⚖️ 👩🏿‍⚖️
🧑‍🌾|farmer|gardener rancher|farmer|12.1|🧑🏻‍🌾 🧑🏼‍🌾 🧑🏽‍🌾 🧑🏾‍🌾 🧑🏿‍🌾
👨‍🌾|man farmer|gardener rancher|man_farmer|4|👨🏻‍🌾 👨🏼‍🌾 👨🏽‍🌾 👨🏾‍🌾 👨🏿‍🌾
👩‍🌾|woman farmer|gardener rancher|woman_farmer|4|👩🏻‍🌾 👩🏼‍🌾 👩🏽‍🌾 👩🏾‍🌾 👩🏿‍🌾
🧑‍🍳|cook|chef|cook|12.1|🧑🏻‍🍳 🧑🏼‍🍳 🧑🏽‍🍳 🧑🏾‍🍳 🧑🏿‍🍳
👨‍🍳|man cook|chef|man_cook|4|👨🏻‍🍳 👨🏼‍🍳 👨🏽‍🍳 👨🏾‍🍳 👨🏿‍🍳
👩‍🍳|woman cook|chef|woman_cook|4|👩🏻‍🍳 👩🏼‍🍳 👩🏽‍🍳 👩🏾‍🍳 👩🏿‍🍳
🧑‍🔧|mechanic|electrician plumber tradesperson|mechanic|12.1|🧑🏻‍🔧 🧑🏼‍🔧 🧑🏽‍🔧 🧑🏾‍🔧 🧑🏿‍🔧
👨‍🔧|man mechanic|electrician plumber tradesperson|man_mechanic|4|👨🏻‍🔧 👨🏼‍🔧 👨🏽‍🔧 👨🏾‍🔧 👨🏿‍🔧
👩‍🔧|woman mechanic|electrician plumber tradesperson|woman_mechanic|4|👩🏻‍🔧 👩🏼‍🔧 👩🏽‍🔧 👩🏾‍🔧 👩🏿‍🔧
🧑‍🏭|factory worker|assembly industrial|factory_worker|12.1|🧑🏻‍🏭 🧑🏼‍🏭 🧑🏽‍🏭 🧑🏾‍🏭 🧑🏿‍🏭
👨‍🏭|man factory worker|assembly industrial|man_factory_worker|4|👨🏻‍🏭 👨🏼‍🏭 👨🏽‍🏭 👨🏾‍🏭 👨🏿‍🏭
👩‍🏭|woman factory worker|assembly industrial|woman_factory_worker|4|👩🏻‍🏭 👩🏼‍🏭 👩🏽‍🏭 👩🏾‍🏭 👩🏿‍🏭
🧑‍💼|office worker|architect business manager white-collar|office_worker|12.1|🧑🏻‍💼 🧑🏼‍💼 🧑🏽‍💼 🧑🏾‍💼 🧑🏿‍💼
👨‍💼|man office worker|architect business manager white-collar|man_office_worker|4|👨🏻‍💼 👨🏼‍💼 👨🏽‍💼 👨🏾‍💼 👨🏿‍💼
👩‍💼|woman office worker|architect business manager white-collar|woman_office_worker|4|👩🏻‍💼 👩🏼‍💼 👩🏽‍💼 👩🏾‍💼 👩🏿‍💼
🧑‍🔬|scientist|biologist chemist engineer mathematician physicist|scientist|12.1|🧑🏻‍🔬 🧑🏼‍🔬 🧑🏽‍🔬 🧑🏾‍🔬 🧑🏿‍🔬
👨‍🔬|man scientist|biologist chemist engineer mathematician physicist|man_scientist|4|👨🏻‍🔬 👨🏼‍🔬 👨🏽‍🔬 👨🏾‍🔬 👨🏿‍🔬
👩‍🔬|woman scientist|biologist chemist engineer mathematician physicist|woman_scientist|4|👩🏻‍🔬 👩🏼‍🔬 👩🏽‍🔬 👩🏾‍🔬 👩🏿‍🔬
🧑‍💻|technologist|coder computer developer inventor software|technologist|12.1|🧑🏻‍💻 🧑🏼‍💻 🧑🏽‍💻 🧑🏾‍💻 🧑🏿‍💻
👨‍💻|man technologist|coder computer developer inventor software|man_technologist|4|👨🏻‍💻 👨🏼‍💻 👨🏽‍💻 👨🏾‍💻 👨🏿‍💻
👩‍💻|woman technologist|coder computer developer inventor software|woman_technologist|4|👩🏻‍💻 👩🏼‍💻 👩🏽‍💻 👩🏾‍💻 👩🏿‍💻
🧑‍🎤|singer|actor entertainer rock rockstar star|singer|12.1|🧑🏻‍🎤 🧑🏼‍🎤 🧑🏽‍🎤 🧑🏾‍🎤 🧑🏿‍🎤
👨‍🎤|man singer|actor entertainer rock rockstar star|man_singer|4|👨🏻‍🎤 👨🏼‍🎤 👨🏽‍🎤 👨🏾‍🎤 👨🏿‍🎤
👩‍🎤|woman singer|actor entertainer rock rockstar star|woman_singer|4|👩🏻‍🎤 👩🏼‍🎤 👩🏽‍🎤 👩🏾‍🎤 👩🏿‍🎤
🧑‍🎨|artist|palette|artist|12.1|🧑🏻‍🎨 🧑🏼‍🎨 🧑🏽‍🎨 🧑🏾‍🎨 🧑🏿‍🎨
👨‍🎨|man artist|palette|man_artist|4|👨🏻‍🎨 👨🏼‍🎨 👨🏽‍🎨 👨🏾‍🎨 👨🏿‍🎨
👩‍🎨|woman artist|palette|woman_artist|4|👩🏻‍🎨 👩🏼‍🎨 👩🏽‍🎨 👩🏾‍🎨 👩🏿‍🎨
🧑‍✈️|pilot|plane|pilot|12.1|🧑🏻‍✈️ 🧑🏼‍✈️ 🧑🏽‍✈️ 🧑🏾‍✈️ 🧑🏿‍✈️
👨‍✈️|man pilot|plane|man_pilot|4|👨🏻‍✈️ 👨🏼‍✈️ 👨🏽‍✈️ 👨🏾‍✈️ 👨🏿‍✈️
👩‍✈️|woman pilot|plane|woman_pilot|4|👩🏻‍✈️ 👩🏼‍✈️ 👩🏽‍✈️ 👩🏾‍✈️ 👩🏿‍✈️
🧑‍🚀|astronaut|rocket space|astronaut|12.1|🧑🏻‍🚀 🧑🏼‍🚀 🧑🏽‍🚀 🧑🏾‍🚀 🧑🏿‍🚀
👨‍🚀|man astronaut|rocket space|man_astronaut|4|👨🏻‍🚀 👨🏼‍🚀 👨🏽‍🚀 👨🏾‍🚀 👨🏿‍🚀
👩‍🚀|woman astronaut|rocket space|woman_astronaut|4|👩🏻‍🚀 👩🏼‍🚀 👩🏽‍🚀 👩🏾‍🚀 👩🏿‍🚀
🧑‍🚒|firefighter|fire firetruck|firefighter|12.1|🧑🏻‍🚒 🧑🏼‍🚒 🧑🏽‍🚒 🧑🏾‍🚒 🧑🏿‍🚒
👨‍🚒|man firefighter|fire firetruck|man_firefighter|4|👨🏻‍🚒 👨🏼‍🚒 👨🏽‍🚒 👨🏾‍🚒 👨🏿‍🚒
👩‍🚒|woman firefighter|fire firetruck|woman_firefighter|4|👩🏻‍🚒 👩🏼‍🚒 👩🏽‍🚒 👩🏾‍🚒 👩🏿‍🚒
👮|police officer|apprehend arrest citation cop law over|cop police_officer|0.6|👮🏻 👮🏼 👮🏽 👮🏾 👮🏿
👮‍♂️|man police officer|apprehend arrest citation cop law over|policeman|4|👮🏻‍♂️ 👮🏼‍♂️ 👮🏽‍♂️ 👮🏾‍♂️ 👮🏿‍♂️
👮‍♀️|woman police officer|apprehend arrest citation cop law over|policewoman|4|👮🏻‍♀️ 👮🏼‍♀️ 👮🏽‍♀️ 👮🏾‍♀️ 👮🏿‍♀️
🕵️|detective|sleuth spy|detective|0.7|🕵🏻 🕵🏼 🕵🏽 🕵🏾 🕵🏿
🕵️‍♂️|man detective|sleuth spy|male_detective|4|🕵🏻‍♂️ 🕵🏼‍♂️ 🕵🏽‍♂️ 🕵🏾‍♂️ 🕵🏿‍♂️
🕵️‍♀️|woman detective|sleuth spy|female_detective|4|🕵🏻‍♀️ 🕵🏼‍♀️ 🕵🏽‍♀️ 🕵🏾‍♀️ 🕵🏿‍♀️
💂|guard|buckingham helmet london palace|guard|0.6|💂🏻 💂🏼 💂🏽 💂🏾 💂🏿
💂‍♂️|man guard|buckingham helmet london palace|guardsman|4|💂🏻‍♂️ 💂🏼‍♂️ 💂🏽‍♂️ 💂🏾‍♂️ 💂🏿‍♂️
💂‍♀️|woman guard|buckingham helmet london palace|guardswoman|4|💂🏻‍♀️ 💂🏼‍♀️ 💂🏽‍♀️ 💂🏾‍♀️ 💂🏿‍♀️
🥷|ninja|assassin fight fighter hidden person secret|ninja|13|🥷🏻 🥷🏼 🥷🏽 🥷🏾 🥷🏿
👷|construction worker|build fix hardhat hat man person|construction_worker|0.6|👷🏻 👷🏼 👷🏽 👷🏾 👷🏿
👷‍♂️|man construction worker|build fix hardhat hat rebuild remodel|construction_worker_man|4|👷🏻‍♂️ 👷🏼‍♂️ 👷🏽‍♂️ 👷🏾‍♂️ 👷🏿‍♂️
👷‍♀️|woman construction worker|build fix hardhat hat man rebuild|construction_worker_woman|4|👷🏻‍♀️ 👷🏼‍♀️ 👷🏽‍♀️ 👷🏾‍♀️ 👷🏿‍♀️
🫅|person with crown|monarch noble regal royal royalty|person_with_crown|14|🫅🏻 🫅🏼 🫅🏽 🫅🏾 🫅🏿
🤴|prince|crown fairy fairytale fantasy king royal|prince|3|🤴🏻 🤴🏼 🤴🏽 🤴🏾 🤴🏿
👸|princess|crown fairy fairytale fantasy queen royal|princess|0.6|👸🏻 👸🏼 👸🏽 👸🏾 👸🏿
👳|person wearing turban||person_with_turban|0.6|👳🏻 👳🏼 👳🏽 👳🏾 👳🏿
👳‍♂️|man wearing turban||man_with_turban|4|👳🏻‍♂️ 👳🏼‍♂️ 👳🏽‍♂️ 👳🏾‍♂️ 👳🏿‍♂️
👳‍♀️|woman wearing turban||woman_with_turban|4|👳🏻‍♀️ 👳🏼‍♀️ 👳🏽‍♀️ 👳🏾‍♀️ 👳🏿‍♀️
👲|person with skullcap|chinese cap gua guapi hat mao|man_with_gua_pi_mao|0.6|👲🏻 👲🏼 👲🏽 👲🏾 👲🏿
🧕|woman with headscarf|bandana head hijab kerchief mantilla tichel|woman_with_headscarf|5|🧕🏻 🧕🏼 🧕🏽 🧕🏾 🧕🏿
🤵|person in tuxedo|formal wedding|person_in_tuxedo|3|🤵🏻 🤵🏼 🤵🏽 🤵🏾 🤵🏿
🤵‍♂️|man in tuxedo|formal groom wedding|man_in_tuxedo|13|🤵🏻‍♂️ 🤵🏼‍♂️ 🤵🏽‍♂️ 🤵🏾‍♂️ 🤵🏿‍♂️
🤵‍♀️|woman in tuxedo|formal wedding|woman_in_tuxedo|13|🤵🏻‍♀️ 🤵🏼‍♀️ 🤵🏽‍♀️ 🤵🏾‍♀️ 🤵🏿‍♀️
👰|person with veil|wedding|person_with_veil|0.6|👰🏻 👰🏼 👰🏽 👰🏾 👰🏿
👰‍♂️|man with veil|wedding|man_with_veil|13|👰🏻‍♂️ 👰🏼‍♂️ 👰🏽‍♂️ 👰🏾‍♂️ 👰🏿‍♂️
👰‍♀️|woman with veil|bride wedding|bride_with_veil woman_with_veil|13|👰🏻‍♀️ 👰🏼‍♀️ 👰🏽‍♀️ 👰🏾‍♀️ 👰🏿‍♀️
🤰|pregnant woman||pregnant_woman|3|🤰🏻 🤰🏼 🤰🏽 🤰🏾 🤰🏿
🫃|pregnant man|belly bloated full overeat|pregnant_man|14|🫃🏻 🫃🏼 🫃🏽 🫃🏾 🫃🏿
🫄|pregnant person|belly bloated full overeat stuffed|pregnant_person|14|🫄🏻 🫄🏼 🫄🏽 🫄🏾 🫄🏿
🤱|breast-feeding|baby mom mother nursing woman|breast_feeding|5|🤱🏻 🤱🏼 🤱🏽 🤱🏾 🤱🏿
👩‍🍼|woman feeding baby|feed mom mother nanny newborn nursing|woman_feeding_baby|13|👩🏻‍🍼 👩🏼‍🍼 👩🏽‍🍼 👩🏾‍🍼 👩🏿‍🍼
👨‍🍼|man feeding baby|dad father feed nanny newborn nursing|man_feeding_baby|13|👨🏻‍🍼 👨🏼‍🍼 👨🏽‍🍼 👨🏾‍🍼 👨🏿‍🍼
🧑‍🍼|person feeding baby|feed nanny newborn nursing parent|person_feeding_baby|13|🧑🏻‍🍼 🧑🏼‍🍼 🧑🏽‍🍼 🧑🏾‍🍼 🧑🏿‍🍼
👼|baby angel|church face fairy fairytale fantasy tale|angel|0.6|👼🏻 👼🏼 👼🏽 👼🏾 👼🏿
🎅|Santa Claus|christmas celebration fairy fantasy father holiday|santa|0.6|🎅🏻 🎅🏼 🎅🏽 🎅🏾 🎅🏿
🤶|Mrs. Claus|christmas mrs celebration fairy fantasy holiday|mrs_claus|3|🤶🏻 🤶🏼 🤶🏽 🤶🏾 🤶🏿
🧑‍🎄|Mx Claus|christmas celebration fairy fantasy holiday merry|mx_claus|13|🧑🏻‍🎄 🧑🏼‍🎄 🧑🏽‍🎄 🧑🏾‍🎄 🧑🏿‍🎄
🦸|superhero|good hero superpower|superhero|11|🦸🏻 🦸🏼 🦸🏽 🦸🏾 🦸🏿
🦸‍♂️|man superhero|good hero superpower|superhero_man|11|🦸🏻‍♂️ 🦸🏼‍♂️ 🦸🏽‍♂️ 🦸🏾‍♂️ 🦸🏿‍♂️
🦸‍♀️|woman superhero|good hero heroine superpower|superhero_woman|11|🦸🏻‍♀️ 🦸🏼‍♀️ 🦸🏽‍♀️ 🦸🏾‍♀️ 🦸🏿‍♀️
🦹|supervillain|bad criminal evil superpower villain|supervillain|11|🦹🏻 🦹🏼 🦹🏽 🦹🏾 🦹🏿
🦹‍♂️|man supervillain|bad criminal evil superpower villain|supervillain_man|11|🦹🏻‍♂️ 🦹🏼‍♂️ 🦹🏽‍♂️ 🦹🏾‍♂️ 🦹🏿‍♂️
🦹‍♀️|woman supervillain|bad criminal evil superpower villain|supervillain_woman|11|🦹🏻‍♀️ 🦹🏼‍♀️ 🦹🏽‍♀️ 🦹🏾‍♀️ 🦹🏿‍♀️
🧙|mage|fantasy magic play sorcerer sorceress sorcery|mage|5|🧙🏻 🧙🏼 🧙🏽 🧙🏾 🧙🏿
🧙‍♂️|man mage|fantasy magic play sorcerer sorceress sorcery|mage_man|5|🧙🏻‍♂️ 🧙🏼‍♂️ 🧙🏽‍♂️ 🧙🏾‍♂️ 🧙🏿‍♂️
🧙‍♀️|woman mage|fantasy magic play sorcerer sorceress sorcery|mage_woman|5|🧙🏻‍♀️ 🧙🏼‍♀️ 🧙🏽‍♀️ 🧙🏾‍♀️ 🧙🏿‍♀️
🧚|fairy|fairytale fantasy myth person pixie tale|fairy|5|🧚🏻 🧚🏼 🧚🏽 🧚🏾 🧚🏿
🧚‍♂️|man fairy|oberon puck fairytale fantasy myth person|fairy_man|5|🧚🏻‍♂️ 🧚🏼‍♂️ 🧚🏽‍♂️ 🧚🏾‍♂️ 🧚🏿‍♂️
🧚‍♀️|woman fairy|titania fairytale fantasy myth person pixie|fairy_woman|5|🧚🏻‍♀️ 🧚🏼‍♀️ 🧚🏽‍♀️ 🧚🏾‍♀️ 🧚🏿‍♀️
🧛|vampire|dracula blood fangs halloween scary supernatural|vampire|5|🧛🏻 🧛🏼 🧛🏽 🧛🏾 🧛🏿
🧛‍♂️|man vampire|blood fangs halloween scary supernatural teeth|vampire_man|5|🧛🏻‍♂️ 🧛🏼‍♂️ 🧛🏽‍♂️ 🧛🏾‍♂️ 🧛🏿‍♂️
🧛‍♀️|woman vampire|blood fangs halloween scary supernatural teeth|vampire_woman|5|🧛🏻‍♀️ 🧛🏼‍♀️ 🧛🏽‍♀️ 🧛🏾‍♀️ 🧛🏿‍♀️
🧜|merperson|creature fairytale folklore ocean sea siren|merperson|5|🧜🏻 🧜🏼 🧜🏽 🧜🏾 🧜🏿
🧜‍♂️|merman|neptune poseidon triton creature fairytale folklore|merman|5|🧜🏻‍♂️ 🧜🏼‍♂️ 🧜🏽‍♂️ 🧜🏾‍♂️ 🧜🏿‍♂️
🧜‍♀️|mermaid|creature fairytale folklore merwoman ocean sea|mermaid|5|🧜🏻‍♀️ 🧜🏼‍♀️ 🧜🏽‍♀️ 🧜🏾‍♀️ 🧜🏿‍♀️
🧝|elf|elves enchantment fantasy folklore magic magical|elf|5|🧝🏻 🧝🏼 🧝🏽 🧝🏾 🧝🏿
🧝‍♂️|man elf|elves enchantment fantasy folklore magic magical|elf_man|5|🧝🏻‍♂️ 🧝🏼‍♂️ 🧝🏽‍♂️ 🧝🏾‍♂️ 🧝🏿‍♂️
🧝‍♀️|woman elf|elves enchantment fantasy folklore magic magical|elf_woman|5|🧝🏻‍♀️ 🧝🏼‍♀️ 🧝🏽‍♀️ 🧝🏾‍♀️ 🧝🏿‍♀️
🧞|genie|djinn fantasy jinn lamp myth rub|genie|5|
🧞‍♂️|man genie|djinn fantasy jinn lamp myth rub|genie_man|5|
🧞‍♀️|woman genie|djinn fantasy jinn lamp myth rub|genie_woman|5|
🧟|zombie|apocalypse dead halloween horror scary undead|zombie|5|
🧟‍♂️|man zombie|apocalypse dead halloween horror scary undead|zombie_man|5|
🧟‍♀️|woman zombie|apocalypse dead halloween horror scary undead|zombie_woman|5|
🧌|troll|fairy fantasy monster tale trolling|troll|14|
🫈|hairy creature|bigfoot cryptid forest giant sasquatch woodwose||17|
💆|person getting massage|face headache relax relaxing salon soothe|massage|0.6|💆🏻 💆🏼 💆🏽 💆🏾 💆🏿
💆‍♂️|man getting massage|face headache relax relaxing salon soothe|massage_man|4|💆🏻‍♂️ 💆🏼‍♂️ 💆🏽‍♂️ 💆🏾‍♂️ 💆🏿‍♂️
💆‍♀️|woman getting massage|face headache relax relaxing salon soothe|massage_woman|4|💆🏻‍♀️ 💆🏼‍♀️ 💆🏽‍♀️ 💆🏾‍♀️ 💆🏿‍♀️
💇|person getting haircut|barber beauty chop cosmetology cut groom|haircut|0.6|💇🏻 💇🏼 💇🏽 💇🏾 💇🏿
💇‍♂️|man getting haircut|barber beauty chop cosmetology cut groom|haircut_man|4|💇🏻‍♂️ 💇🏼‍♂️ 💇🏽‍♂️ 💇🏾‍♂️ 💇🏿‍♂️
💇‍♀️|woman getting haircut|barber beauty chop cosmetology cut groom|haircut_woman|4|💇🏻‍♀️ 💇🏼‍♀️ 💇🏽‍♀️ 💇🏾‍♀️ 💇🏿‍♀️
🚶|person walking|amble gait hike man pace pedestrian|walking|0.6|🚶🏻 🚶🏼 🚶🏽 🚶🏾 🚶🏿
🚶‍♂️|man walking|amble gait hike pace pedestrian stride|walking_man|4|🚶🏻‍♂️ 🚶🏼‍♂️ 🚶🏽‍♂️ 🚶🏾‍♂️ 🚶🏿‍♂️
🚶‍♀️|woman walking|amble gait hike man pace pedestrian|walking_woman|4|🚶🏻‍♀️ 🚶🏼‍♀️ 🚶🏽‍♀️ 🚶🏾‍♀️ 🚶🏿‍♀️
🚶‍➡️|person walking: facing right|amble gait hike man pace pedestrian||15.1|🚶🏻‍➡️ 🚶🏼‍➡️ 🚶🏽‍➡️ 🚶🏾‍➡️ 🚶🏿‍➡️
🚶‍♀️‍➡️|woman walking: facing right|amble gait hike man pace pedestrian||15.1|🚶🏻‍♀️‍➡️ 🚶🏼‍♀️‍➡️ 🚶🏽‍♀️‍➡️ 🚶🏾‍♀️‍➡️ 🚶🏿‍♀️‍➡️
🚶‍♂️‍➡️|man walking: facing right|amble gait hike pace pedestrian stride||15.1|🚶🏻‍♂️‍➡️ 🚶🏼‍♂️‍➡️ 🚶🏽‍♂️‍➡️ 🚶🏾‍♂️‍➡️ 🚶🏿‍♂️‍➡️
🧍|person standing|stand|standing_person|12|🧍🏻 🧍🏼 🧍🏽 🧍🏾 🧍🏿
🧍‍♂️|man standing|stand|standing_man|12|🧍🏻‍♂️ 🧍🏼‍♂️ 🧍🏽‍♂️ 🧍🏾‍♂️ 🧍🏿‍♂️
🧍‍♀️|woman standing|stand|standing_woman|12|🧍🏻‍♀️ 🧍🏼‍♀️ 🧍🏽‍♀️ 🧍🏾‍♀️ 🧍🏿‍♀️
🧎|person kneeling|kneel knees|kneeling_person|12|🧎🏻 🧎🏼 🧎🏽 🧎🏾 🧎🏿
🧎‍♂️|man kneeling|kneel knees|kneeling_man|12|🧎🏻‍♂️ 🧎🏼‍♂️ 🧎🏽‍♂️ 🧎🏾‍♂️ 🧎🏿‍♂️
🧎‍♀️|woman kneeling|kneel knees|kneeling_woman|12|🧎🏻‍♀️ 🧎🏼‍♀️ 🧎🏽‍♀️ 🧎🏾‍♀️ 🧎🏿‍♀️
🧎‍➡️|person kneeling: facing right|kneel knees||15.1|🧎🏻‍➡️ 🧎🏼‍➡️ 🧎🏽‍➡️ 🧎🏾‍➡️ 🧎🏿‍➡️
🧎‍♀️‍➡️|woman kneeling: facing right|kneel knees||15.1|🧎🏻‍♀️‍➡️ 🧎🏼‍♀️‍➡️ 🧎🏽‍♀️‍➡️ 🧎🏾‍♀️‍➡️ 🧎🏿‍♀️‍➡️
🧎‍♂️‍➡️|man kneeling: facing right|kneel knees||15.1|🧎🏻‍♂️‍➡️ 🧎🏼‍♂️‍➡️ 🧎🏽‍♂️‍➡️ 🧎🏾‍♂️‍➡️ 🧎🏿‍♂️‍➡️
🧑‍🦯|person with white cane|accessibility blind probing|person_with_probing_cane|12.1|🧑🏻‍🦯 🧑🏼‍🦯 🧑🏽‍🦯 🧑🏾‍🦯 🧑🏿‍🦯
🧑‍🦯‍➡️|person with white cane: facing right|accessibility blind probing||15.1|🧑🏻‍🦯‍➡️ 🧑🏼‍🦯‍➡️ 🧑🏽‍🦯‍➡️ 🧑🏾‍🦯‍➡️ 🧑🏿‍🦯‍➡️
👨‍🦯|man with white cane|accessibility blind probing|man_with_probing_cane|12|👨🏻‍🦯 👨🏼‍🦯 👨🏽‍🦯 👨🏾‍🦯 👨🏿‍🦯
👨‍🦯‍➡️|man with white cane: facing right|accessibility blind probing||15.1|👨🏻‍🦯‍➡️ 👨🏼‍🦯‍➡️ 👨🏽‍🦯‍➡️ 👨🏾‍🦯‍➡️ 👨🏿‍🦯‍➡️
👩‍🦯|woman with white cane|accessibility blind probing|woman_with_probing_cane|12|👩🏻‍🦯 👩🏼‍🦯 👩🏽‍🦯 👩🏾‍🦯 👩🏿‍🦯
👩‍🦯‍➡️|woman with white cane: facing right|accessibility blind probing||15.1|👩🏻‍🦯‍➡️ 👩🏼‍🦯‍➡️ 👩🏽‍🦯‍➡️ 👩🏾‍🦯‍➡️ 👩🏿‍🦯‍➡️
🧑‍🦼|person in motorized wheelchair|accessibility|person_in_motorized_wheelchair|12.1|🧑🏻‍🦼 🧑🏼‍🦼 🧑🏽‍🦼 🧑🏾‍🦼 🧑🏿‍🦼
🧑‍🦼‍➡️|person in motorized wheelchair: facing right|accessibility||15.1|🧑🏻‍🦼‍➡️ 🧑🏼‍🦼‍➡️ 🧑🏽‍🦼‍➡️ 🧑🏾‍🦼‍➡️ 🧑🏿‍🦼‍➡️
👨‍🦼|man in motorized wheelchair|accessibility|man_in_motorized_wheelchair|12|👨🏻‍🦼 👨🏼‍🦼 👨🏽‍🦼 👨🏾‍🦼 👨🏿‍🦼
👨‍🦼‍➡️|man in motorized wheelchair: facing right|accessibility||15.1|👨🏻‍🦼‍➡️ 👨🏼‍🦼‍➡️ 👨🏽‍🦼‍➡️ 👨🏾‍🦼‍➡️ 👨🏿‍🦼‍➡️
👩‍🦼|woman in motorized wheelchair|accessibility|woman_in_motorized_wheelchair|12|👩🏻‍🦼 👩🏼‍🦼 👩🏽‍🦼 👩🏾‍🦼 👩🏿‍🦼
👩‍🦼‍➡️|woman in motorized wheelchair: facing right|accessibility||15.1|👩🏻‍🦼‍➡️ 👩🏼‍🦼‍➡️ 👩🏽‍🦼‍➡️ 👩🏾‍🦼‍➡️ 👩🏿‍🦼‍➡️
🧑‍🦽|person in manual wheelchair|accessibility|person_in_manual_wheelchair|12.1|🧑🏻‍🦽 🧑🏼‍🦽 🧑🏽‍🦽 🧑🏾‍🦽 🧑🏿‍🦽
🧑‍🦽‍➡️|person in manual wheelchair: facing right|accessibility||15.1|🧑🏻‍🦽‍➡️ 🧑🏼‍🦽‍➡️ 🧑🏽‍🦽‍➡️ 🧑🏾‍🦽‍➡️ 🧑🏿‍🦽‍➡️
👨‍🦽|man in manual wheelchair|accessibility|man_in_manual_wheelchair|12|👨🏻‍🦽 👨🏼‍🦽 👨🏽‍🦽 👨🏾‍🦽 👨🏿‍🦽
👨‍🦽‍➡️|man in manual wheelchair: facing right|accessibility||15.1|👨🏻‍🦽‍➡️ 👨🏼‍🦽‍➡️ 👨🏽‍🦽‍➡️ 👨🏾‍🦽‍➡️ 👨🏿‍🦽‍➡️
👩‍🦽|woman in manual wheelchair|accessibility|woman_in_manual_wheelchair|12|👩🏻‍🦽 👩🏼‍🦽 👩🏽‍🦽 👩🏾‍🦽 👩🏿‍🦽
👩‍🦽‍➡️|woman in manual wheelchair: facing right|accessibility||15.1|👩🏻‍🦽‍➡️ 👩🏼‍🦽‍➡️ 👩🏽‍🦽‍➡️ 👩🏾‍🦽‍➡️ 👩🏿‍🦽‍➡️
🏃|person running|fast hurry marathon move quick race|runner running|0.6|🏃🏻 🏃🏼 🏃🏽 🏃🏾 🏃🏿
🏃‍♂️|man running|fast hurry marathon move quick race|running_man|4|🏃🏻‍♂️ 🏃🏼‍♂️ 🏃🏽‍♂️ 🏃🏾‍♂️ 🏃🏿‍♂️
🏃‍♀️|woman running|fast hurry marathon move quick race|running_woman|4|🏃🏻‍♀️ 🏃🏼‍♀️ 🏃🏽‍♀️ 🏃🏾‍♀️ 🏃🏿‍♀️
🏃‍➡️|person running: facing right|fast hurry marathon move quick race||15.1|🏃🏻‍➡️ 🏃🏼‍➡️ 🏃🏽‍➡️ 🏃🏾‍➡️ 🏃🏿‍➡️
🏃‍♀️‍➡️|woman running: facing right|fast hurry marathon move quick race||15.1|🏃🏻‍♀️‍➡️ 🏃🏼‍♀️‍➡️ 🏃🏽‍♀️‍➡️ 🏃🏾‍♀️‍➡️ 🏃🏿‍♀️‍➡️
🏃‍♂️‍➡️|man running: facing right|fast hurry marathon move quick race||15.1|🏃🏻‍♂️‍➡️ 🏃🏼‍♂️‍➡️ 🏃🏽‍♂️‍➡️ 🏃🏾‍♂️‍➡️ 🏃🏿‍♂️‍➡️
🧑‍🩰|ballet dancer|||17|🧑🏻‍🩰 🧑🏼‍🩰 🧑🏽‍🩰 🧑🏾‍🩰 🧑🏿‍🩰
💃|woman dancing|dance dancer elegant festive flair flamenco|dancer woman_dancing|0.6|💃🏻 💃🏼 💃🏽 💃🏾 💃🏿
🕺|man dancing|dance dancer elegant festive flair flamenco|man_dancing|3|🕺🏻 🕺🏼 🕺🏽 🕺🏾 🕺🏿
🕴️|person in suit levitating|business|business_suit_levitating|0.7|🕴🏻 🕴🏼 🕴🏽 🕴🏾 🕴🏿
👯|people with bunny ears|bestie bff counterpart dancer double ear|dancers|0.6|👯🏻 👯🏼 👯🏽 👯🏾 👯🏿
👯‍♂️|men with bunny ears|bestie bff counterpart dancer double ear|dancing_men|4|👯🏻‍♂️ 👯🏼‍♂️ 👯🏽‍♂️ 👯🏾‍♂️ 👯🏿‍♂️
👯‍♀️|women with bunny ears|bestie bff counterpart dancer double ear|dancing_women|4|👯🏻‍♀️ 👯🏼‍♀️ 👯🏽‍♀️ 👯🏾‍♀️ 👯🏿‍♀️
🧖|person in steamy room|day luxurious pamper relax sauna spa|sauna_person|5|🧖🏻 🧖🏼 🧖🏽 🧖🏾 🧖🏿
🧖‍♂️|man in steamy room|day luxurious pamper relax sauna spa|sauna_man|5|🧖🏻‍♂️ 🧖🏼‍♂️ 🧖🏽‍♂️ 🧖🏾‍♂️ 🧖🏿‍♂️
🧖‍♀️|woman in steamy room|day luxurious pamper relax sauna spa|sauna_woman|5|🧖🏻‍♀️ 🧖🏼‍♀️ 🧖🏽‍♀️ 🧖🏾‍♀️ 🧖🏿‍♀️
🧗|person climbing|climb climber mountain rock scale up|climbing|5|🧗🏻 🧗🏼 🧗🏽 🧗🏾 🧗🏿
🧗‍♂️|man climbing|climb climber mountain rock scale up|climbing_man|5|🧗🏻‍♂️ 🧗🏼‍♂️ 🧗🏽‍♂️ 🧗🏾‍♂️ 🧗🏿‍♂️
🧗‍♀️|woman climbing|climb climber mountain rock scale up|climbing_woman|5|🧗🏻‍♀️ 🧗🏼‍♀️ 🧗🏽‍♀️ 🧗🏾‍♀️ 🧗🏿‍♀️
🤺|person fencing|fencer sword|person_fencing|3|
🏇|horse racing|jockey racehorse riding sport|horse_racing|1|🏇🏻 🏇🏼 🏇🏽 🏇🏾 🏇🏿
⛷️|skier|ski snow|skier|0.7|
🏂|snowboarder|ski snow snowboard sport|snowboarder|0.6|🏂🏻 🏂🏼 🏂🏽 🏂🏾 🏂🏿
🏌️|person golfing|ball birdie caddy driving golf green|golfing|0.7|🏌🏻 🏌🏼 🏌🏽 🏌🏾 🏌🏿
🏌️‍♂️|man golfing|ball birdie caddy driving golf green|golfing_man|4|🏌🏻‍♂️ 🏌🏼‍♂️ 🏌🏽‍♂️ 🏌🏾‍♂️ 🏌🏿‍♂️
🏌️‍♀️|woman golfing|ball birdie caddy driving golf green|golfing_woman|4|🏌🏻‍♀️ 🏌🏼‍♀️ 🏌🏽‍♀️ 🏌🏾‍♀️ 🏌🏿‍♀️
🏄|person surfing|beach ocean sport surf surfer swell|surfer|0.6|🏄🏻 🏄🏼 🏄🏽 🏄🏾 🏄🏿
🏄‍♂️|man surfing|beach ocean sport surf surfer swell|surfing_man|4|🏄🏻‍♂️ 🏄🏼‍♂️ 🏄🏽‍♂️ 🏄🏾‍♂️ 🏄🏿‍♂️
🏄‍♀️|woman surfing|beach ocean person sport surf surfer|surfing_woman|4|🏄🏻‍♀️ 🏄🏼‍♀️ 🏄🏽‍♀️ 🏄🏾‍♀️ 🏄🏿‍♀️
🚣|person rowing boat|canoe cruise fishing lake oar paddle|rowboat|1|🚣🏻 🚣🏼 🚣🏽 🚣🏾 🚣🏿
🚣‍♂️|man rowing boat|canoe cruise fishing lake oar paddle|rowing_man|4|🚣🏻‍♂️ 🚣🏼‍♂️ 🚣🏽‍♂️ 🚣🏾‍♂️ 🚣🏿‍♂️
🚣‍♀️|woman rowing boat|canoe cruise fishing lake oar paddle|rowing_woman|4|🚣🏻‍♀️ 🚣🏼‍♀️ 🚣🏽‍♀️ 🚣🏾‍♀️ 🚣🏿‍♀️
🏊|person swimming|freestyle sport swim swimmer triathlon|swimmer|0.6|🏊🏻 🏊🏼 🏊🏽 🏊🏾 🏊🏿
🏊‍♂️|man swimming|freestyle sport swim swimmer triathlon|swimming_man|4|🏊🏻‍♂️ 🏊🏼‍♂️ 🏊🏽‍♂️ 🏊🏾‍♂️ 🏊🏿‍♂️
🏊‍♀️|woman swimming|freestyle man sport swim swimmer triathlon|swimming_woman|4|🏊🏻‍♀️ 🏊🏼‍♀️ 🏊🏽‍♀️ 🏊🏾‍♀️ 🏊🏿‍♀️
⛹️|person bouncing ball|athletic basketball championship dribble net player|bouncing_ball_person|0.7|⛹🏻 ⛹🏼 ⛹🏽 ⛹🏾 ⛹🏿
⛹️‍♂️|man bouncing ball|athletic basketball championship dribble net player|basketball_man bouncing_ball_man|4|⛹🏻‍♂️ ⛹🏼‍♂️ ⛹🏽‍♂️ ⛹🏾‍♂️ ⛹🏿‍♂️
⛹️‍♀️|woman bouncing ball|athletic basketball championship dribble net player|basketball_woman bouncing_ball_woman|4|⛹🏻‍♀️ ⛹🏼‍♀️ ⛹🏽‍♀️ ⛹🏾‍♀️ ⛹🏿‍♀️
🏋️|person lifting weights|barbell bodybuilder deadlift lifter powerlifting weight|weight_lifting|0.7|🏋🏻 🏋🏼 🏋🏽 🏋🏾 🏋🏿
🏋️‍♂️|man lifting weights|barbell bodybuilder deadlift lifter powerlifting weight|weight_lifting_man|4|🏋🏻‍♂️ 🏋🏼‍♂️ 🏋🏽‍♂️ 🏋🏾‍♂️ 🏋🏿‍♂️
🏋️‍♀️|woman lifting weights|barbell bodybuilder deadlift lifter powerlifting weight|weight_lifting_woman|4|🏋🏻‍♀️ 🏋🏼‍♀️ 🏋🏽‍♀️ 🏋🏾‍♀️ 🏋🏿‍♀️
🚴|person biking|bicycle bicyclist bike cycle cyclist riding|bicyclist|1|🚴🏻 🚴🏼 🚴🏽 🚴🏾 🚴🏿
🚴‍♂️|man biking|bicycle bicyclist bike cycle cyclist riding|biking_man|4|🚴🏻‍♂️ 🚴🏼‍♂️ 🚴🏽‍♂️ 🚴🏾‍♂️ 🚴🏿‍♂️
🚴‍♀️|woman biking|bicycle bicyclist bike cycle cyclist riding|biking_woman|4|🚴🏻‍♀️ 🚴🏼‍♀️ 🚴🏽‍♀️ 🚴🏾‍♀️ 🚴🏿‍♀️
🚵|person mountain biking|bicycle bicyclist bike cycle cyclist riding|mountain_bicyclist|1|🚵🏻 🚵🏼 🚵🏽 🚵🏾 🚵🏿
🚵‍♂️|man mountain biking|bicycle bicyclist bike cycle cyclist riding|mountain_biking_man|4|🚵🏻‍♂️ 🚵🏼‍♂️ 🚵🏽‍♂️ 🚵🏾‍♂️ 🚵🏿‍♂️
🚵‍♀️|woman mountain biking|bicycle bicyclist bike cycle cyclist riding|mountain_biking_woman|4|🚵🏻‍♀️ 🚵🏼‍♀️ 🚵🏽‍♀️ 🚵🏾‍♀️ 🚵🏿‍♀️
🤸|person cartwheeling|active cartwheel excited flip gymnastics happy|cartwheeling|3|🤸🏻 🤸🏼 🤸🏽 🤸🏾 🤸🏿
🤸‍♂️|man cartwheeling|active cartwheel excited flip gymnastics happy|man_cartwheeling|4|🤸🏻‍♂️ 🤸🏼‍♂️ 🤸🏽‍♂️ 🤸🏾‍♂️ 🤸🏿‍♂️
🤸‍♀️|woman cartwheeling|active cartwheel excited flip gymnastics happy|woman_cartwheeling|4|🤸🏻‍♀️ 🤸🏼‍♀️ 🤸🏽‍♀️ 🤸🏾‍♀️ 🤸🏿‍♀️
🤼|people wrestling|combat duel grapple ring tournament wrestle|wrestling|3|🤼🏻 🤼🏼 🤼🏽 🤼🏾 🤼🏿
🤼‍♂️|men wrestling|combat duel grapple ring tournament wrestle|men_wrestling|4|🤼🏻‍♂️ 🤼🏼‍♂️ 🤼🏽‍♂️ 🤼🏾‍♂️ 🤼🏿‍♂️
🤼‍♀️|women wrestling|combat duel grapple ring tournament wrestle|women_wrestling|4|🤼🏻‍♀️ 🤼🏼‍♀️ 🤼🏽‍♀️ 🤼🏾‍♀️ 🤼🏿‍♀️
🤽|person playing water polo|sport swimming waterpolo|water_polo|3|🤽🏻 🤽🏼 🤽🏽 🤽🏾 🤽🏿
🤽‍♂️|man playing water polo|sport swimming waterpolo|man_playing_water_polo|4|🤽🏻‍♂️ 🤽🏼‍♂️ 🤽🏽‍♂️ 🤽🏾‍♂️ 🤽🏿‍♂️
🤽‍♀️|woman playing water polo|sport swimming waterpolo|woman_playing_water_polo|4|🤽🏻‍♀️ 🤽🏼‍♀️ 🤽🏽‍♀️ 🤽🏾‍♀️ 🤽🏿‍♀️
🤾|person playing handball|athletics ball catch chuck hurl lob|handball_person|3|🤾🏻 🤾🏼 🤾🏽 🤾🏾 🤾🏿
🤾‍♂️|man playing handball|athletics ball catch chuck hurl lob|man_playing_handball|4|🤾🏻‍♂️ 🤾🏼‍♂️ 🤾🏽‍♂️ 🤾🏾‍♂️ 🤾🏿‍♂️
🤾‍♀️|woman playing handball|athletics ball catch chuck hurl lob|woman_playing_handball|4|🤾🏻‍♀️ 🤾🏼‍♀️ 🤾🏽‍♀️ 🤾🏾‍♀️ 🤾🏿‍♀️
🤹|person juggling|act balance balancing handle juggle manage|juggling_person|3|🤹🏻 🤹🏼 🤹🏽 🤹🏾 🤹🏿
🤹‍♂️|man juggling|act balance balancing handle juggle manage|man_juggling|4|🤹🏻‍♂️ 🤹🏼‍♂️ 🤹🏽‍♂️ 🤹🏾‍♂️ 🤹🏿‍♂️
🤹‍♀️|woman juggling|act balance balancing handle juggle manage|woman_juggling|4|🤹🏻‍♀️ 🤹🏼‍♀️ 🤹🏽‍♀️ 🤹🏾‍♀️ 🤹🏿‍♀️
🧘|person in lotus position|cross legged legs meditation peace relax|lotus_position|5|🧘🏻 🧘🏼 🧘🏽 🧘🏾 🧘🏿
🧘‍♂️|man in lotus position|cross legged legs meditation peace relax|lotus_position_man|5|🧘🏻‍♂️ 🧘🏼‍♂️ 🧘🏽‍♂️ 🧘🏾‍♂️ 🧘🏿‍♂️
🧘‍♀️|woman in lotus position|cross legged legs meditation peace relax|lotus_position_woman|5|🧘🏻‍♀️ 🧘🏼‍♀️ 🧘🏽‍♀️ 🧘🏾‍♀️ 🧘🏿‍♀️
🛀|person taking bath|bathtub tub|bath|0.6|🛀🏻 🛀🏼 🛀🏽 🛀🏾 🛀🏿
🛌|person in bed|bedtime good goodnight hotel nap night|sleeping_bed|1|🛌🏻 🛌🏼 🛌🏽 🛌🏾 🛌🏿
🧑‍🤝‍🧑|people holding hands|bae bestie bff couple dating flirt|people_holding_hands|12|🧑🏻‍🤝‍🧑🏻 🧑🏼‍🤝‍🧑🏼 🧑🏽‍🤝‍🧑🏽 🧑🏾‍🤝‍🧑🏾 🧑🏿‍🤝‍🧑🏿
👭|women holding hands|bae bestie bff couple dating flirt|two_women_holding_hands|1|👭🏻 👭🏼 👭🏽 👭🏾 👭🏿
👫|woman and man holding hands|bae bestie bff couple dating flirt|couple|0.6|👫🏻 👫🏼 👫🏽 👫🏾 👫🏿
👬|men holding hands|bae bestie bff boys brothers couple|two_men_holding_hands|1|👬🏻 👬🏼 👬🏽 👬🏾 👬🏿
💏|kiss|anniversary babe bae couple date dating|couplekiss|0.6|💏🏻 💏🏼 💏🏽 💏🏾 💏🏿
👩‍❤️‍💋‍👨|kiss: woman, man|anniversary babe bae couple date dating|couplekiss_man_woman|2|👩🏻‍❤️‍💋‍👨🏻 👩🏼‍❤️‍💋‍👨🏼 👩🏽‍❤️‍💋‍👨🏽 👩🏾‍❤️‍💋‍👨🏾 👩🏿‍❤️‍💋‍👨🏿
👨‍❤️‍💋‍👨|kiss: man, man|anniversary babe bae couple date dating|couplekiss_man_man|2|👨🏻‍❤️‍💋‍👨🏻 👨🏼‍❤️‍💋‍👨🏼 👨🏽‍❤️‍💋‍👨🏽 👨🏾‍❤️‍💋‍👨🏾 👨🏿‍❤️‍💋‍👨🏿
👩‍❤️‍💋‍👩|kiss: woman, woman|anniversary babe bae couple date dating|couplekiss_woman_woman|2|👩🏻‍❤️‍💋‍👩🏻 👩🏼‍❤️‍💋‍👩🏼 👩🏽‍❤️‍💋‍👩🏽 👩🏾‍❤️‍💋‍👩🏾 👩🏿‍❤️‍💋‍👩🏿
💑|couple with heart|anniversary babe bae dating kiss love|couple_with_heart|0.6|💑🏻 💑🏼 💑🏽 💑🏾 💑🏿
👩‍❤️‍👨|couple with heart: woman, man|anniversary babe bae dating kiss love|couple_with_heart_woman_man|2|👩🏻‍❤️‍👨🏻 👩🏼‍❤️‍👨🏼 👩🏽‍❤️‍👨🏽 👩🏾‍❤️‍👨🏾 👩🏿‍❤️‍👨🏿
👨‍❤️‍👨|couple with heart: man, man|anniversary babe bae dating kiss love|couple_with_heart_man_man|2|👨🏻‍❤️‍👨🏻 👨🏼‍❤️‍👨🏼 👨🏽‍❤️‍👨🏽 👨🏾‍❤️‍👨🏾 👨🏿‍❤️‍👨🏿
👩‍❤️‍👩|couple with heart: woman, woman|anniversary babe bae dating kiss love|couple_with_heart_woman_woman|2|👩🏻‍❤️‍👩🏻 👩🏼‍❤️‍👩🏼 👩🏽‍❤️‍👩🏽 👩🏾‍❤️‍👩🏾 👩🏿‍❤️‍👩🏿
👨‍👩‍👦|family: man, woman, boy|child|family_man_woman_boy|2|
👨‍👩‍👧|family: man, woman, girl|child|family_man_woman_girl|2|
👨‍👩‍👧‍👦|family: man, woman, girl, boy|child|family_man_woman_girl_boy|2|
👨‍👩‍👦‍👦|family: man, woman, boy, boy|child|family_man_woman_boy_boy|2|
👨‍👩‍👧‍👧|family: man, woman, girl, girl|child|family_man_woman_girl_girl|2|
👨‍👨‍👦|family: man, man, boy|child|family_man_man_boy|2|
👨‍👨‍👧|family: man, man, girl|child|family_man_man_girl|2|
👨‍👨‍👧‍👦|family: man, man, girl, boy|child|family_man_man_girl_boy|2|
👨‍👨‍👦‍👦|family: man, man, boy, boy|child|family_man_man_boy_boy|2|
👨‍👨‍👧‍👧|family: man, man, girl, girl|child|family_man_man_girl_girl|2|
👩‍👩‍👦|family: woman, woman, boy|child|family_woman_woman_boy|2|
👩‍👩‍👧|family: woman, woman, girl|child|family_woman_woman_girl|2|
👩‍👩‍👧‍👦|family: woman, woman, girl, boy|child|family_woman_woman_girl_boy|2|
👩‍👩‍👦‍👦|family: woman, woman, boy, boy|child|family_woman_woman_boy_boy|2|
👩‍👩‍👧‍👧|family: woman, woman, girl, girl|child|family_woman_woman_girl_girl|2|
👨‍👦|family: man, boy|child|family_man_boy|4|
👨‍👦‍👦|family: man, boy, boy|child|family_man_boy_boy|4|
👨‍👧|family: man, girl|child|family_man_girl|4|
👨‍👧‍👦|family: man, girl, boy|child|family_man_girl_boy|4|
👨‍👧‍👧|family: man, girl, girl|child|family_man_girl_girl|4|
👩‍👦|family: woman, boy|child|family_woman_boy|4|
👩‍👦‍👦|family: woman, boy, boy|child|family_woman_boy_boy|4|
👩‍👧|family: woman, girl|child|family_woman_girl|4|
👩‍👧‍👦|family: woman, girl, boy|child|family_woman_girl_boy|4|
👩‍👧‍👧|family: woman, girl, girl|child|family_woman_girl_girl|4|
🗣️|speaking head|face silhouette speak|speaking_head|0.7|
👤|bust in silhouette|mysterious shadow|bust_in_silhouette|0.6|
👥|busts in silhouette|bff bust everyone friend friends people|busts_in_silhouette|1|
🫂|people hugging|comfort embrace farewell friendship goodbye hello|people_hugging|13|
👪|family|child|family|0.6|
🧑‍🧑‍🧒|family: adult, adult, child|||15.1|
🧑‍🧑‍🧒‍🧒|family: adult, adult, child, child|||15.1|
🧑‍🧒|family: adult, child|||15.1|
🧑‍🧒‍🧒|family: adult, child, child|||15.1|
👣|footprints|barefoot clothing footprint omw print walk|footprints|0.6|
🫆|fingerprint|clue crime detective forensics identity mystery||16|
#nature
🐵|monkey face|animal banana|monkey_face|0.6|
🐒|monkey|animal banana|monkey|0.6|
🦍|gorilla|animal|gorilla|3|
🦧|orangutan|animal ape monkey|orangutan|12|
🐶|dog face|adorbs animal pet puppies puppy|dog|0.6|
🐕|dog|animal animals dogs pet|dog2|0.7|
🦮|guide dog|accessibility animal blind|guide_dog|12|
🐕‍🦺|service dog|accessibility animal assistance|service_dog|12|
🐩|poodle|animal dog fluffy|poodle|0.6|
🐺|wolf|animal face|wolf|0.6|
🦊|fox|animal face|fox_face|3|
🦝|raccoon|animal curious sly|raccoon|11|
🐱|cat face|animal kitten kitty pet|cat|0.6|
🐈|cat|animal animals cats kitten pet|cat2|0.7|
🐈‍⬛|black cat|animal feline halloween meow unlucky|black_cat|13|
🦁|lion|leo alpha animal face mane order|lion|1|
🐯|tiger face|animal big cat predator|tiger|0.6|
🐅|tiger|animal big cat predator zoo|tiger2|1|
🐆|leopard|animal big cat predator zoo|leopard|1|
🐴|horse face|animal dressage equine farm horses|horse|0.6|
🫎|moose|alces animal antlers elk mammal|moose|15|
🫏|donkey|animal ass burro hinny mammal mule|donkey|15|
🐎|horse|animal equestrian farm racehorse racing|racehorse|0.6|
🦄|unicorn|face|unicorn|1|
🦓|zebra|animal stripe|zebra|5|
🦌|deer|animal|deer|3|
🦬|bison|animal buffalo herd wisent|bison|13|
🐮|cow face|animal farm milk moo|cow|0.6|
🐂|ox|taurus animal animals bull farm zodiac|ox|1|
🐃|water buffalo|animal zoo|water_buffalo|1|
🐄|cow|animal animals farm milk moo|cow2|1|
🐷|pig face|animal bacon farm pork|pig|0.6|
🐖|pig|animal bacon farm pork sow|pig2|1|
🐗|boar|animal pig|boar|0.6|
🐽|pig nose|animal face farm smell snout|pig_nose|0.6|
🐏|ram|aries animal horns male sheep zodiac|ram|1|
🐑|ewe|animal baa farm female fluffy lamb|sheep|0.6|
🐐|goat|capricorn animal farm milk zodiac|goat|1|
🐪|camel|animal desert dromedary hump one|dromedary_camel|1|
🐫|two-hump camel|animal bactrian desert two-hump|camel|0.6|
🦙|llama|alpaca animal guanaco vicuña wool|llama|11|
🦒|giraffe|animal spots|giraffe|5|
🐘|elephant|animal|elephant|0.6|
🦣|mammoth|animal extinction large tusk wooly|mammoth|13|
🦏|rhinoceros|animal|rhinoceros|3|
🦛|hippopotamus|animal hippo|hippopotamus|11|
🐭|mouse face|animal|mouse|0.6|
🐁|mouse|animal animals|mouse2|1|
🐀|rat|animal|rat|1|
🐹|hamster|animal face pet|hamster|0.6|
🐰|rabbit face|animal bunny pet|rabbit|0.6|
🐇|rabbit|animal bunny pet|rabbit2|1|
🐿️|chipmunk|animal squirrel|chipmunk|0.7|
🦫|beaver|animal dam teeth|beaver|13|
🦔|hedgehog|animal spiny|hedgehog|5|
🦇|bat|animal vampire|bat|3|
🐻|bear|animal face grizzly growl honey|bear|0.6|
🐻‍❄️|polar bear|animal arctic white|polar_bear|13|
🐨|koala|animal australia bear down face marsupial|koala|0.6|
🐼|panda|animal bamboo face|panda_face|0.6|
🦥|sloth|lazy slow|sloth|12|
🦦|otter|animal fishing playful|otter|12|
🦨|skunk|animal stink|skunk|12|
🦘|kangaroo|animal joey jump marsupial|kangaroo|11|
🦡|badger|animal honey pester|badger|11|
🐾|paw prints|feet paws print|feet paw_prints|0.6|
🦃|turkey|bird gobble thanksgiving|turkey|1|
🐔|chicken|animal bird ornithology|chicken|0.6|
🐓|rooster|animal bird ornithology|rooster|1|
🐣|hatching chick|animal baby bird egg|hatching_chick|0.6|
🐤|baby chick|animal bird ornithology|baby_chick|0.6|
🐥|front-facing baby chick|animal bird front-facing newborn ornithology|hatched_chick|0.6|
🐦|bird|animal ornithology|bird|0.6|
🐧|penguin|animal antarctica bird ornithology|penguin|0.6|
🕊️|dove|bird fly ornithology peace|dove|0.7|
🦅|eagle|animal bird ornithology|eagle|3|
🦆|duck|animal bird ornithology|duck|3|
🦢|swan|animal bird cygnet duckling ornithology ugly|swan|11|
🦉|owl|animal bird ornithology wise|owl|3|
🦤|dodo|animal bird extinction large ornithology|dodo|13|
🪶|feather|bird flight light plumage|feather|13|
🦩|flamingo|animal bird flamboyant ornithology tropical|flamingo|12|
🦚|peacock|animal bird colorful ornithology ostentatious peahen|peacock|11|
🦜|parrot|animal bird ornithology pirate talk|parrot|11|
🪽|wing|angelic ascend aviation bird fly flying|wing|15|
🐦‍⬛|black bird|animal beak caw corvid crow ornithology|black_bird|15|
🪿|goose|animal bird duck flock fowl gaggle|goose|15|
🐦‍🔥|phoenix|ascend ascension emerge fantasy firebird glory||15.1|
🐸|frog|animal face|frog|0.6|
🐊|crocodile|animal zoo|crocodile|1|
🐢|turtle|animal terrapin tortoise|turtle|0.6|
🦎|lizard|animal reptile|lizard|3|
🐍|snake|ophiuchus animal bearer serpent zodiac|snake|0.6|
🐲|dragon face|animal fairy fairytale tale|dragon_face|0.6|
🐉|dragon|animal fairy fairytale knights tale|dragon|1|
🦕|sauropod|brachiosaurus brontosaurus dinosaur diplodocus|sauropod|5|
🦖|T-Rex|tyrannosaurus dinosaur|t-rex|5|
🐳|spouting whale|animal beach face ocean|whale|0.6|
🐋|whale|animal beach ocean|whale2|1|
🐬|dolphin|animal beach flipper ocean|dolphin flipper|0.6|
🫍|orca|marine ocean whale||17|
🦭|seal|animal lion ocean sea|seal|13|
🐟|fish|pisces animal dinner fishes fishing zodiac|fish|0.6|
🐠|tropical fish|animal fishes|tropical_fish|0.6|
🐡|blowfish|animal fish|blowfish|0.6|
🦈|shark|animal fish|shark|3|
🐙|octopus|animal creature ocean|octopus|0.6|
🐚|spiral shell|animal beach conch sea|shell|0.6|
🪸|coral|change climate ocean reef sea|coral|14|
🪼|jellyfish|animal aquarium burn invertebrate jelly life|jellyfish|15|
🦀|crab|cancer zodiac|crab|1|
🦞|lobster|animal bisque claws seafood|lobster|11|
🦐|shrimp|food shellfish small|shrimp|3|
🦑|squid|animal food mollusk|squid|3|
🦪|oyster|diving pearl|oyster|12|
🐌|snail|animal escargot garden nature slug|snail|0.6|
🦋|butterfly|insect pretty|butterfly|3|
🫌|monarch butterfly|caterpillar change fragile hope insect metamorphosis||18|
🐛|bug|animal garden insect|bug|0.6|
🐜|ant|animal garden insect|ant|0.6|
🐝|honeybee|animal bee bumblebee honey insect nature|bee honeybee|0.6|
🪲|beetle|animal bug insect|beetle|13|
🐞|lady beetle|animal garden insect ladybird ladybug nature|lady_beetle|0.6|
🦗|cricket|orthoptera animal bug grasshopper insect|cricket|5|
🪳|cockroach|animal insect pest roach|cockroach|13|
🕷️|spider|animal insect|spider|0.7|
🕸️|spider web||spider_web|0.7|
🦂|scorpion|scorpio scorpius zodiac|scorpion|1|
🦟|mosquito|bite disease fever insect malaria pest|mosquito|11|
🪰|fly|animal disease insect maggot pest rotting|fly|13|
🪱|worm|animal annelid earthworm parasite|worm|13|
🦠|microbe|amoeba bacteria science virus|microbe|11|
💐|bouquet|anniversary birthday date flower love plant|bouquet|0.6|
🌸|cherry blossom|flower plant spring springtime|cherry_blossom|0.6|
💮|white flower||white_flower|0.6|
🪷|lotus|buddhism hinduism beauty calm flower peace|lotus|14|
🏵️|rosette|plant|rosette|0.7|
🌹|rose|beauty elegant flower love plant red|rose|0.6|
🥀|wilted flower|dying|wilted_flower|3|
🌺|hibiscus|flower plant|hibiscus|0.6|
🌻|sunflower|flower outdoors plant sun|sunflower|0.6|
🌼|blossom|buttercup dandelion flower plant|blossom|0.6|
🌷|tulip|blossom flower growth plant|tulip|0.6|
🪻|hyacinth|bloom bluebonnet flower indigo lavender lilac|hyacinth|15|
🌱|seedling|plant sapling sprout young|seedling|0.6|
🪴|potted plant|decor grow house nurturing pot|potted_plant|13|
🌲|evergreen tree|christmas forest pine|evergreen_tree|1|
🌳|deciduous tree|forest green habitat shedding|deciduous_tree|1|
🌴|palm tree|beach plant tropical|palm_tree|0.6|
🌵|cactus|desert drought nature plant|cactus|0.6|
🌾|sheaf of rice|ear grain grains plant|ear_of_rice|0.6|
🌿|herb|leaf plant|herb|0.6|
☘️|shamrock|irish plant|shamrock|1|
🍀|four leaf clover|4 four-leaf irish lucky plant|four_leaf_clover|0.6|
🍁|maple leaf|falling|maple_leaf|0.6|
🍂|fallen leaf|autumn fall falling|fallen_leaf|0.6|
🍃|leaf fluttering in wind|blow flutter|leaves|0.6|
🪹|empty nest|branch home nesting|empty_nest|14|
🪺|nest with eggs|bird branch egg nesting|nest_with_eggs|14|
🍄|mushroom|fungus toadstool|mushroom|0.6|
🪾|leafless tree|bare barren branches dead drought trunk||16|
#food
🍇|grapes|dionysus fruit grape|grapes|0.6|
🍈|melon|cantaloupe fruit|melon|0.6|
🍉|watermelon|fruit|watermelon|0.6|
🍊|tangerine|c citrus fruit nectarine orange vitamin|mandarin orange|0.6|
🍋|lemon|citrus fruit sour|lemon|1|
🍋‍🟩|lime|acidity citrus cocktail fruit garnish key||15.1|
🍌|banana|fruit potassium|banana|0.6|
🍍|pineapple|colada fruit pina tropical|pineapple|0.6|
🥭|mango|food fruit tropical|mango|11|
🍎|red apple|diet food fruit health ripe|apple|0.6|
🍏|green apple|fruit|green_apple|0.6|
🍐|pear|fruit|pear|1|
🍑|peach|fruit|peach|0.6|
🍒|cherries|berries cherry fruit red|cherries|0.6|
🍓|strawberry|berry fruit|strawberry|0.6|
🫐|blueberries|berries berry bilberry blue blueberry food|blueberries|13|
🥝|kiwi fruit|food|kiwi_fruit|3|
🍅|tomato|food fruit vegetable|tomato|0.6|
🫒|olive|food|olive|13|
🥥|coconut|colada palm piña|coconut|5|
🥑|avocado|food fruit|avocado|3|
🍆|eggplant|aubergine vegetable|eggplant|0.6|
🥔|potato|food vegetable|potato|3|
🥕|carrot|food vegetable|carrot|3|
🌽|ear of corn|crops farm maize maze|corn|0.6|
🌶️|hot pepper||hot_pepper|0.7|
🫑|bell pepper|capsicum food vegetable|bell_pepper|13|
🥒|cucumber|food pickle vegetable|cucumber|3|
🫝|pickle|brine condiment cucumber ferment gherkin relish||18|
🥬|leafy green|bok burgers cabbage choy kale lettuce|leafy_green|11|
🥦|broccoli|cabbage wild|broccoli|5|
🧄|garlic|flavoring|garlic|12|
🧅|onion|flavoring|onion|12|
🥜|peanuts|food nut peanut vegetable|peanuts|3|
🫘|beans|food kidney legume small|beans|14|
🌰|chestnut|almond plant|chestnut|0.6|
🫚|ginger root|beer health herb natural spice|ginger_root|15|
🫛|pea pod|beans beanstalk edamame legume soybean vegetable|pea_pod|15|
🍄‍🟫|brown mushroom|food fungi fungus nature pizza portobello||15.1|
🫜|root vegetable|beet food garden radish salad turnip||16|
🍞|bread|carbs food grain loaf restaurant toast|bread|0.6|
🥐|croissant|bread breakfast crescent food french roll|croissant|3|
🥖|baguette bread|food french|baguette_bread|3|
🫓|flatbread|arepa bread food gordita lavash naan|flatbread|13|
🥨|pretzel|convoluted twisted|pretzel|5|
🥯|bagel|bakery bread breakfast schmear|bagel|11|
🥞|pancakes|breakfast crêpe food hotcake pancake|pancakes|3|
🧇|waffle|breakfast indecisive iron|waffle|12|
🧀|cheese wedge||cheese|1|
🍖|meat on bone||meat_on_bone|0.6|
🍗|poultry leg|bone chicken drumstick hungry turkey|poultry_leg|0.6|
🥩|cut of meat|chop lambchop porkchop red steak|cut_of_meat|5|
🥓|bacon|breakfast food meat|bacon|3|
🍔|hamburger|burger eat fast food hungry|hamburger|0.6|
🍟|french fries|fast food|fries|0.6|
🍕|pizza|cheese food hungry pepperoni slice|pizza|0.6|
🌭|hot dog|frankfurter hotdog sausage|hotdog|1|
🥪|sandwich|bread|sandwich|5|
🌮|taco|mexican|taco|1|
🌯|burrito|mexican wrap|burrito|1|
🫔|tamale|food mexican pamonha wrapped|tamale|13|
🥙|stuffed flatbread|falafel food gyro kebab|stuffed_flatbread|3|
🧆|falafel|chickpea meatball|falafel|12|
🥚|egg|breakfast food|egg|3|
🍳|cooking|breakfast easy egg fry frying over|fried_egg|0.6|
🥘|shallow pan of food|casserole paella|shallow_pan_of_food|3|
🍲|pot of food|soup stew|stew|0.6|
🫕|fondue|cheese chocolate food melted pot ski|fondue|13|
🥣|bowl with spoon|breakfast cereal congee oatmeal porridge|bowl_with_spoon|5|
🥗|green salad|food|green_salad|3|
🍿|popcorn|corn movie pop|popcorn|1|
🧈|butter|dairy|butter|12|
🧂|salt|condiment flavor mad salty shaker taste|salt|11|
🥫|canned food|can|canned_food|5|
🍱|bento box|food|bento|0.6|
🍘|rice cracker|food|rice_cracker|0.6|
🍙|rice ball|japanese food|rice_ball|0.6|
🍚|cooked rice|food|rice|0.6|
🍛|curry rice|food|curry|0.6|
🍜|steaming bowl|chopsticks food noodle pho ramen soup|ramen|0.6|
🍝|spaghetti|food meatballs pasta restaurant|spaghetti|0.6|
🍠|roasted sweet potato|food|sweet_potato|0.6|
🍢|oden|food kebab restaurant seafood skewer stick|oden|0.6|
🍣|sushi|food|sushi|0.6|
🍤|fried shrimp|prawn tempura|fried_shrimp|0.6|
🍥|fish cake with swirl|food pastry restaurant|fish_cake|0.6|
🥮|moon cake|autumn festival yuèbǐng|moon_cake|11|
🍡|dango|japanese dessert skewer stick sweet|dango|0.6|
🥟|dumpling|empanada gyōza jiaozi pierogi potsticker|dumpling|5|
🥠|fortune cookie|prophecy|fortune_cookie|5|
🥡|takeout box|chopsticks delivery food oyster pail|takeout_box|5|
🍦|soft ice cream|dessert food icecream restaurant serve sweet|icecream|0.6|
🍧|shaved ice|dessert restaurant sweet|shaved_ice|0.6|
🍨|ice cream|dessert food restaurant sweet|ice_cream|0.6|
🍩|doughnut|breakfast dessert donut food sweet|doughnut|0.6|
🍪|cookie|chip chocolate dessert sweet|cookie|0.6|
🎂|birthday cake|bday celebration dessert happy pastry sweet|birthday|0.6|
🍰|shortcake|cake dessert pastry slice sweet|cake|0.6|
🧁|cupcake|bakery dessert sprinkles sugar sweet treat|cupcake|11|
🥧|pie|apple filling fruit meat pastry pumpkin|pie|5|
🍫|chocolate bar|candy dessert halloween sweet tooth|chocolate_bar|0.6|
🍬|candy|cavities dessert halloween restaurant sweet tooth|candy|0.6|
🍭|lollipop|candy dessert food restaurant sweet|lollipop|0.6|
🍮|custard|dessert pudding sweet|custard|0.6|
🍯|honey pot|barrel bear food honeypot jar sweet|honey_pot|0.6|
🍼|baby bottle|babies birth born drink infant milk|baby_bottle|1|
🥛|glass of milk|drink|milk_glass|3|
☕|hot beverage|cafe caffeine chai coffee drink morning|coffee|0.6|
🫖|teapot|brew drink food pot tea|teapot|13|
🍵|teacup without handle|beverage cup drink oolong tea|tea|0.6|
🍶|sake|bar beverage bottle cup drink restaurant|sake|0.6|
🍾|bottle with popping cork|bar drink|champagne|1|
🍷|wine glass|alcohol bar beverage booze club drink|wine_glass|0.6|
🍸|cocktail glass|alcohol bar booze club drink drinking|cocktail|0.6|
🍹|tropical drink|alcohol bar booze club cocktail drinking|tropical_drink|0.6|
🍺|beer mug|alcohol ale bar booze drink drinking|beer|0.6|
🍻|clinking beer mugs|alcohol bar booze bottoms cheers clink|beers|0.6|
🥂|clinking glasses|celebrate clink drink glass|clinking_glasses|3|
🥃|tumbler glass|liquor scotch shot whiskey whisky|tumbler_glass|3|
🫗|pouring liquid|accident drink empty glass oops pour|pouring_liquid|14|
🥤|cup with straw|drink juice malt soda soft water|cup_with_straw|5|
🧋|bubble tea|boba food milk pearl|bubble_tea|13|
🧃|beverage box|juice straw sweet|beverage_box|12|
🧉|mate|drink|mate|12|
🧊|ice|cold cube iceberg|ice_cube|12|
🥢|chopsticks|hashi jeotgarak kuaizi|chopsticks|5|
🍽️|fork and knife with plate|cooking dinner eat|plate_with_cutlery|0.7|
🍴|fork and knife|breakfast breaky cooking cutlery delicious dinner|fork_and_knife|0.6|
🥄|spoon|eat tableware|spoon|3|
🔪|kitchen knife|chef cooking hocho tool weapon|hocho knife|0.6|
🫙|jar|condiment container empty nothing sauce store|jar|14|
🏺|amphora|aquarius cooking drink jug tool weapon|amphora|1|
#travel
🌍|globe showing Europe-Africa|europe-africa earth world|earth_africa|0.7|
🌎|globe showing Americas|earth world|earth_americas|0.7|
🌏|globe showing Asia-Australia|asia-australia earth world|earth_asia|0.6|
🌐|globe with meridians|earth internet web world worldwide|globe_with_meridians|1|
🗺️|world map||world_map|0.7|
🗾|map of Japan||japan|0.6|
🧭|compass|direction magnetic navigation orienteering|compass|11|
🏔️|snow-capped mountain|cold snow-capped|mountain_snow|0.7|
⛰️|mountain||mountain|0.7|
🛘|landslide|avalanche danger disaster earthquake mountain mudslide||17|
🌋|volcano|eruption mountain nature|volcano|0.6|
🗻|mount fuji|mountain nature|mount_fuji|0.6|
🏕️|camping||camping|0.7|
🏖️|beach with umbrella||beach_umbrella|0.7|
🏜️|desert||desert|0.7|
🏝️|desert island||desert_island|0.7|
🏞️|national park||national_park|0.7|
🏟️|stadium||stadium|0.7|
🏛️|classical building||classical_building|0.7|
🏗️|building construction|crane|building_construction|0.7|
🧱|brick|bricks clay mortar wall|bricks|11|
🪨|rock|boulder heavy solid stone tough|rock|13|
🪵|wood|log lumber timber|wood|13|
🛖|hut|home house roundhouse shelter yurt|hut|13|
🏘️|houses|house|houses|0.7|
🏚️|derelict house|home|derelict_house|0.7|
🏠|house|building country heart home ranch settle|house|0.6|
🏡|house with garden|building country heart home ranch settle|house_with_garden|0.6|
🏢|office building|city cubical job|office|0.6|
🏣|Japanese post office|building|post_office|0.6|
🏤|post office|european building|european_post_office|1|
🏥|hospital|building doctor medicine|hospital|0.6|
🏦|bank|building|bank|0.6|
🏨|hotel|building|hotel|0.6|
🏩|love hotel|building|love_hotel|0.6|
🏪|convenience store|24 building hours|convenience_store|0.6|
🏫|school|building|school|0.6|
🏬|department store|building|department_store|0.6|
🏭|factory|building|factory|0.6|
🏯|Japanese castle|building|japanese_castle|0.6|
🏰|castle|european building|european_castle|0.6|
💒|wedding|chapel hitched nuptials romance|wedding|0.6|
🗼|Tokyo tower||tokyo_tower|0.6|
🗽|Statue of Liberty|new ny nyc york|statue_of_liberty|0.6|
⛪|church|christian bless chapel cross religion|church|0.6|
🕌|mosque|muslim islam masjid religion|mosque|1|
🛕|hindu temple||hindu_temple|12|
🕍|synagogue|jew jewish judaism religion temple|synagogue|1|
⛩️|shinto shrine|religion|shinto_shrine|0.7|
🕋|kaaba|muslim hajj islam religion umrah|kaaba|1|
⛲|fountain||fountain|0.6|
⛺|tent|camping|tent|0.6|
🌁|foggy|fog|foggy|0.6|
🌃|night with stars|star|night_with_stars|0.6|
🏙️|cityscape|city|cityscape|0.7|
🌄|sunrise over mountains|morning sun|sunrise_over_mountains|0.6|
🌅|sunrise|morning nature sun|sunrise|0.6|
🌆|cityscape at dusk|building city evening landscape sun sunset|city_sunset|0.6|
🌇|sunset|building dusk sun|city_sunrise|0.6|
🌉|bridge at night||bridge_at_night|0.6|
♨️|hot springs|hotsprings steaming|hotsprings|0.6|
🎠|carousel horse|entertainment|carousel_horse|0.6|
🛝|playground slide|amusement park play playing sliding theme|playground_slide|14|
🎡|ferris wheel|amusement park theme|ferris_wheel|0.6|
🎢|roller coaster|amusement park theme|roller_coaster|0.6|
💈|barber pole|cut fresh haircut shave|barber|0.6|
🎪|circus tent||circus_tent|0.6|
🚂|locomotive|caboose engine railway steam train trains|steam_locomotive|1|
🚃|railway car|electric train tram travel trolleybus|railway_car|0.6|
🚄|high-speed train|high-speed railway shinkansen|bullettrain_side|0.6|
🚅|bullet train|high-speed nose railway shinkansen speed travel|bullettrain_front|0.6|
🚆|train|arrived choo railway|train2|1|
🚇|metro|subway travel|metro|0.6|
🚈|light rail|arrived monorail railway|light_rail|1|
🚉|station|railway train|station|0.6|
🚊|tram|trolleybus|tram|1|
🚝|monorail|vehicle|monorail|1|
🚞|mountain railway|car trip|mountain_railway|1|
🚋|tram car|bus trolley trolleybus|train|1|
🚌|bus|school vehicle|bus|0.6|
🚍|oncoming bus|cars|oncoming_bus|0.7|
🚎|trolleybus|bus tram trolley|trolleybus|1|
🚐|minibus|bus drive van vehicle|minibus|1|
🚑|ambulance|emergency vehicle|ambulance|0.6|
🚒|fire engine|truck|fire_engine|0.6|
🚓|police car|5–0 cops patrol|police_car|0.6|
🚔|oncoming police car||oncoming_police_car|0.7|
🚕|taxi|cab cabbie car drive vehicle yellow|taxi|0.6|
🚖|oncoming taxi|cab cabbie cars drove hail yellow|oncoming_taxi|1|
🚗|automobile|car driving vehicle|car red_car|0.6|
🚘|oncoming automobile|car cars drove vehicle|oncoming_automobile|0.7|
🚙|sport utility vehicle|car drive recreational sportutility|blue_car|0.6|
🛻|pickup truck|automobile car flatbed pick-up transportation|pickup_truck|13|
🚚|delivery truck|car drive vehicle|truck|0.6|
🚛|articulated lorry|car drive move semi truck vehicle|articulated_lorry|1|
🚜|tractor|vehicle|tractor|1|
🏎️|racing car|zoom|racing_car|0.7|
🏍️|motorcycle|racing|motorcycle|0.7|
🛵|motor scooter||motor_scooter|3|
🦽|manual wheelchair|accessibility|manual_wheelchair|12|
🦼|motorized wheelchair|accessibility|motorized_wheelchair|12|
🛺|auto rickshaw|tuk|auto_rickshaw|12|
🚲|bicycle|bike class cycle cycling cyclist gang|bike|0.6|
🛴|kick scooter||kick_scooter|3|
🛹|skateboard|board skate skater wheels|skateboard|11|
🛼|roller skate|blades skates sport|roller_skate|13|
🚏|bus stop|busstop|busstop|0.6|
🛣️|motorway|highway road|motorway|0.7|
🛤️|railway track|train|railway_track|0.7|
🛢️|oil drum||oil_drum|0.7|
⛽|fuel pump|diesel fuelpump gas gasoline station|fuelpump|0.6|
🛞|wheel|car circle tire turn vehicle|wheel|14|
🚨|police car light|alarm alert beacon emergency revolving siren|rotating_light|0.6|
🚥|horizontal traffic light|intersection signal stop stoplight|traffic_light|0.6|
🚦|vertical traffic light|drove intersection signal stop stoplight|vertical_traffic_light|1|
🛑|stop sign|octagonal|stop_sign|3|
🚧|construction|barrier|construction|0.6|
🛙|lighthouse|beacon enlightenment guidance hope light maritime||18|
⚓|anchor|ship tool|anchor|0.6|
🛟|ring buoy|float life lifesaver preserver rescue safety|ring_buoy|14|
⛵|sailboat|boat resort sailing sea yacht|boat sailboat|0.6|
🛶|canoe|boat|canoe|3|
🚤|speedboat|billionaire boat lake luxury millionaire summer|speedboat|0.6|
🛳️|passenger ship||passenger_ship|0.7|
⛴️|ferry|boat passenger|ferry|0.7|
🛥️|motor boat|motorboat|motor_boat|0.7|
🚢|ship|boat passenger travel|ship|0.6|
✈️|airplane|aeroplane fly flying jet plane travel|airplane|0.6|
🛩️|small airplane|aeroplane plane|small_airplane|0.7|
🛫|airplane departure|aeroplane check-in departures plane|flight_departure|1|
🛬|airplane arrival|aeroplane arrivals arriving landing plane|flight_arrival|1|
🪂|parachute|hang-glide parasail skydive|parachute|12|
💺|seat|chair|seat|0.6|
🚁|helicopter|copter roflcopter travel vehicle|helicopter|1|
🚟|suspension railway||suspension_railway|1|
🚠|mountain cableway|cable gondola lift ski|mountain_cableway|1|
🚡|aerial tramway|cable car gondola ropeway|aerial_tramway|1|
🛰️|satellite|space|artificial_satellite|0.7|
🚀|rocket|launch rockets space travel|rocket|0.6|
🛸|flying saucer|ufo aliens extra terrestrial|flying_saucer|5|
🛎️|bellhop bell|hotel|bellhop_bell|0.7|
🧳|luggage|bag packing roller suitcase travel|luggage|11|
⌛|hourglass done|sand time timer|hourglass|0.6|
⏳|hourglass not done|flowing hours sand timer waiting yolo|hourglass_flowing_sand|0.6|
⌚|watch|clock time|watch|0.6|
⏰|alarm clock|hours hrs late time waiting|alarm_clock|0.6|
⏱️|stopwatch|clock time|stopwatch|1|
⏲️|timer clock||timer_clock|1|
🕰️|mantelpiece clock|time|mantelpiece_clock|0.7|
🕛|twelve o’clock|12 12:00 clock time|clock12|0.6|
🕧|twelve-thirty|12 12:30 30 clock time|clock1230|0.7|
🕐|one o’clock|1 1:00 clock time|clock1|0.6|
🕜|one-thirty|1 1:30 30 clock time|clock130|0.7|
🕑|two o’clock|2 2:00 clock time|clock2|0.6|
🕝|two-thirty|2 2:30 30 clock time|clock230|0.7|
🕒|three o’clock|3 3:00 clock time|clock3|0.6|
🕞|three-thirty|3 30 3:30 clock time|clock330|0.7|
🕓|four o’clock|4 4:00 clock time|clock4|0.6|
🕟|four-thirty|30 4 4:30 clock time|clock430|0.7|
🕔|five o’clock|5 5:00 clock time|clock5|0.6|
🕠|five-thirty|30 5 5:30 clock time|clock530|0.7|
🕕|six o’clock|6 6:00 clock time|clock6|0.6|
🕡|six-thirty|30 6 6:30 clock|clock630|0.7|
🕖|seven o’clock|0 7 7:00 clock|clock7|0.6|
🕢|seven-thirty|30 7 7:30 clock|clock730|0.7|
🕗|eight o’clock|8 8:00 clock time|clock8|0.6|
🕣|eight-thirty|30 8 8:30 clock time|clock830|0.7|
🕘|nine o’clock|9 9:00 clock time|clock9|0.6|
🕤|nine-thirty|30 9 9:30 clock time|clock930|0.7|
🕙|ten o’clock|0 10 10:00 clock|clock10|0.6|
🕥|ten-thirty|10 10:30 30 clock time|clock1030|0.7|
🕚|eleven o’clock|11 11:00 clock time|clock11|0.6|
🕦|eleven-thirty|11 11:30 30 clock time|clock1130|0.7|
🌑|new moon|dark space|new_moon|0.6|
🌒|waxing crescent moon|dreams space|waxing_crescent_moon|1|
🌓|first quarter moon|space|first_quarter_moon|0.6|
🌔|waxing gibbous moon|space|moon waxing_gibbous_moon|0.6|
🌕|full moon|space|full_moon|0.6|
🌖|waning gibbous moon|space|waning_gibbous_moon|1|
🌗|last quarter moon|space|last_quarter_moon|1|
🌘|waning crescent moon|space|waning_crescent_moon|1|
🌙|crescent moon|ramadan space|crescent_moon|0.6|
🌚|new moon face|space|new_moon_with_face|1|
🌛|first quarter moon face|space|first_quarter_moon_with_face|0.6|
🌜|last quarter moon face|dreams|last_quarter_moon_with_face|0.7|
🌡️|thermometer|weather|thermometer|0.7|
☀️|sun|bright rays space sunny weather|sunny|0.6|
🌝|full moon face|bright|full_moon_with_face|1|
🌞|sun with face|beach bright day heat shine sunny|sun_with_face|1|
🪐|ringed planet|saturn saturnine|ringed_planet|12|
⭐|star|astronomy medium stars white|star|0.6|
🌟|glowing star|glittery glow night shining sparkle win|star2|0.6|
🌠|shooting star|falling night space|stars|0.6|
🌌|milky way|space|milky_way|0.6|
☁️|cloud|weather|cloud|0.6|
⛅|sun behind cloud|cloudy weather|partly_sunny|0.6|
⛈️|cloud with lightning and rain|thunder thunderstorm|cloud_with_lightning_and_rain|0.7|
🌤️|sun behind small cloud|weather|sun_behind_small_cloud|0.7|
🌥️|sun behind large cloud|weather|sun_behind_large_cloud|0.7|
🌦️|sun behind rain cloud|weather|sun_behind_rain_cloud|0.7|
🌧️|cloud with rain|weather|cloud_with_rain|0.7|
🌨️|cloud with snow|cold weather|cloud_with_snow|0.7|
🌩️|cloud with lightning|weather|cloud_with_lightning|0.7|
🌪️|tornado|cloud weather whirlwind|tornado|0.7|
🌫️|fog|cloud weather|fog|0.7|
🌬️|wind face|blow cloud|wind_face|0.7|
🌀|cyclone|dizzy hurricane twister typhoon weather|cyclone|0.6|
🌈|rainbow|gay genderqueer glbt glbtq lesbian lgbt|rainbow|0.6|
🌂|closed umbrella|clothing rain|closed_umbrella|0.6|
☂️|umbrella|clothing rain|open_umbrella|0.7|
☔|umbrella with rain drops|clothing drop weather|umbrella|0.6|
⛱️|umbrella on ground|rain sun|parasol_on_ground|0.7|
⚡|high voltage|danger electric electricity lightning nature thunder|zap|0.6|
❄️|snowflake|cold snow weather|snowflake|0.6|
☃️|snowman|cold man snow|snowman_with_snow|0.7|
⛄|snowman without snow|cold man|snowman|0.6|
☄️|comet|space|comet|1|
🪋|meteor|apocalypse falling fireball gravity rock space||18|
🔥|fire|af burn flame hot lit litaf|fire|0.6|
💧|droplet|cold comic drop nature sad sweat|droplet|0.6|
🌊|water wave|nature ocean surf surfer surfing|ocean|0.6|
#activities
🎃|jack-o-lantern|celebration halloween pumpkin|jack_o_lantern|0.6|
🎄|Christmas tree|celebration|christmas_tree|0.6|
🎆|fireworks|boom celebration entertainment yolo|fireworks|0.6|
🎇|sparkler|boom celebration fireworks sparkle|sparkler|0.6|
🧨|firecracker|dynamite explosive fire fireworks light pop|firecracker|11|
✨|sparkles|* magic sparkle star|sparkles|0.6|
🎈|balloon|birthday celebrate celebration|balloon|0.6|
🎉|party popper|awesome birthday celebrate celebration excited hooray|tada|0.6|
🎊|confetti ball|celebrate celebration party woohoo|confetti_ball|0.6|
🎋|tanabata tree|japanese banner celebration|tanabata_tree|0.6|
🎍|pine decoration|japanese bamboo celebration plant|bamboo|0.6|
🎎|Japanese dolls|celebration doll festival|dolls|0.6|
🎏|carp streamer|celebration|flags|0.6|
🎐|wind chime|bell celebration|wind_chime|0.6|
🎑|moon viewing ceremony|celebration|rice_scene|0.6|
🧧|red envelope|gift good hóngbāo lai luck money|red_envelope|11|
🎀|ribbon|celebration|ribbon|0.6|
🎁|wrapped gift|birthday bow box celebration christmas present|gift|0.6|
🎗️|reminder ribbon|celebration|reminder_ribbon|0.7|
🎟️|admission tickets|ticket|tickets|0.7|
🎫|ticket|admission stub|ticket|0.6|
🎖️|military medal|award celebration|medal_military|0.7|
🏆|trophy|champion champs prize slay sport victory|trophy|0.6|
🏅|sports medal|award gold winner|medal_sports|1|
🥇|1st place medal|first gold|1st_place_medal|3|
🥈|2nd place medal|second silver|2nd_place_medal|3|
🥉|3rd place medal|bronze third|3rd_place_medal|3|
⚽|soccer ball|football futbol sport|soccer|0.6|
⚾|baseball|ball sport|baseball|0.6|
🥎|softball|ball glove sports underarm|softball|11|
🏀|basketball|ball hoop sport|basketball|0.6|
🏐|volleyball|ball game|volleyball|1|
🏈|american football|ball bowl sport super|football|0.6|
🏉|rugby football|ball sport|rugby_football|1|
🎾|tennis|ball racquet sport|tennis|0.6|
🥏|flying disc|ultimate|flying_disc|11|
🎳|bowling|ball game sport strike|bowling|0.6|
🏏|cricket game|ball bat|cricket_game|1|
🏑|field hockey|ball game stick|field_hockey|1|
🏒|ice hockey|game puck stick|ice_hockey|1|
🥍|lacrosse|ball goal sports stick|lacrosse|11|
🏓|ping pong|ball bat game paddle pingpong table|ping_pong|1|
🏸|badminton|birdie game racquet shuttlecock|badminton|1|
🥊|boxing glove||boxing_glove|3|
🥋|martial arts uniform|judo karate taekwondo|martial_arts_uniform|3|
🥅|goal net||goal_net|3|
⛳|flag in hole|golf sport|golf|0.6|
⛸️|ice skate|skating|ice_skate|0.7|
🎣|fishing pole|entertainment fish sport|fishing_pole_and_fish|0.6|
🤿|diving mask|scuba snorkeling|diving_mask|12|
🎽|running shirt|athletics sash|running_shirt_with_sash|0.6|
🎿|skis|ski snow sport|ski|0.6|
🛷|sled|luge sledge sleigh snow toboggan|sled|5|
🥌|curling stone|game rock|curling_stone|5|
🎯|bullseye|bull dart direct entertainment game hit|dart|0.6|
🪀|yo-yo|fluctuate toy|yo_yo|12|
🪁|kite|fly soar|kite|12|
🔫|water pistol|gun handgun revolver tool weapon|gun|0.6|
🎱|pool 8 ball|8ball billiard eight game|8ball|0.6|
🔮|crystal ball|fairy fairytale fantasy fortune future magic|crystal_ball|0.6|
🪄|magic wand|magician witch wizard|magic_wand|13|
🎮|video game|controller entertainment|video_game|0.6|
🕹️|joystick|game video videogame|joystick|0.7|
🎰|slot machine|casino gamble gambling game slots|slot_machine|0.6|
🎲|game die|dice entertainment|game_die|0.6|
🧩|puzzle piece|clue interlocking jigsaw|jigsaw|11|
🧸|teddy bear|plaything plush stuffed toy|teddy_bear|11|
🪅|piñata|candy celebrate celebration cinco de festive|pinata|13|
🪩|mirror ball|dance disco glitter party|mirror_ball|14|
🪆|nesting dolls|babooshka baboushka babushka doll matryoshka russia|nesting_dolls|13|
♠️|spade suit|card game|spades|0.6|
♥️|heart suit|card emotion game hearts|hearts|0.6|
♦️|diamond suit|card game|diamonds|0.6|
♣️|club suit|card clubs game|clubs|0.6|
♟️|chess pawn|dupe expendable|chess_pawn|11|
🃏|joker|card game wildcard|black_joker|0.6|
🀄|mahjong red dragon|game|mahjong|0.6|
🎴|flower playing cards|japanese card game|flower_playing_cards|0.6|
🎭|performing arts|actor actress art entertainment mask theater|performing_arts|0.6|
🖼️|framed picture|art frame museum painting|framed_picture|0.7|
🎨|artist palette|art artsy arty colorful creative entertainment|art|0.6|
🧵|thread|needle sewing spool string|thread|11|
🪡|sewing needle|embroidery sew stitches sutures tailoring thread|sewing_needle|13|
🧶|yarn|ball crochet knit|yarn|11|
🪢|knot|cord rope tangled tie twine twist|knot|13|
#objects
👓|glasses|clothing eye eyeglasses eyewear|eyeglasses|0.6|
🕶️|sunglasses|dark eye eyewear glasses|dark_sunglasses|0.7|
🥽|goggles|dive eye protection scuba swimming welding|goggles|11|
🥼|lab coat|clothes doctor dr experiment jacket scientist|lab_coat|11|
🦺|safety vest|emergency|safety_vest|12|
👔|necktie|clothing employed serious shirt tie|necktie|0.6|
👕|t-shirt|blue casual clothes clothing collar dressed|shirt tshirt|0.6|
👖|jeans|blue casual clothes clothing denim dressed|jeans|0.6|
🧣|scarf|bundle cold neck up|scarf|5|
🧤|gloves|hand|gloves|5|
🧥|coat|brr bundle cold jacket up|coat|5|
🧦|socks|stocking|socks|5|
👗|dress|clothes clothing dressed fancy shopping|dress|0.6|
👘|kimono|clothing comfortable|kimono|0.6|
🥻|sari|clothing dress|sari|12|
🩱|one-piece swimsuit|bathing one-piece suit|one_piece_swimsuit|12|
🩲|briefs|bathing one-piece suit swimsuit underwear|swim_brief|12|
🩳|shorts|bathing pants suit swimsuit underwear|shorts|12|
👙|bikini|bathing beach clothing pool suit swim|bikini|0.6|
👚|woman’s clothes|blouse clothing collar dress dressed lady|womans_clothes|0.6|
🪭|folding hand fan|clack clap cool cooling dance flirt|folding_hand_fan|15|
👛|purse|clothes clothing coin dress fancy handbag|purse|0.6|
👜|handbag|bag clothes clothing dress lady purse|handbag|0.6|
👝|clutch bag|clothes clothing dress handbag pouch purse|pouch|0.6|
🛍️|shopping bags|bag hotel|shopping|0.7|
🎒|backpack|backpacking bag bookbag education rucksack satchel|school_satchel|0.6|
🩴|thong sandal|beach flip flop sandals shoe thongs|thong_sandal|13|
👞|man’s shoe|brown clothes clothing feet foot kick|mans_shoe shoe|0.6|
👟|running shoe|athletic clothes clothing fast kick shoes|athletic_shoe|0.6|
🥾|hiking boot|backpacking brown camping outdoors shoe|hiking_boot|11|
🥿|flat shoe|ballet comfy flats slip-on slipper|flat_shoe|11|
👠|high-heeled shoe|clothes clothing dress fashion heel heels|high_heel|0.6|
👡|woman’s sandal|clothing shoe woman|sandal|0.6|
🩰|ballet shoes|dance|ballet_shoes|12|
👢|woman’s boot|clothes clothing dress shoe shoes shopping|boot|0.6|
🪮|hair pick|afro comb groom|hair_pick|15|
👑|crown|clothing family king medieval queen royal|crown|0.6|
👒|woman’s hat|clothes clothing garden hats party woman|womans_hat|0.6|
🎩|top hat|clothes clothing fancy formal magic tophat|tophat|0.6|
🎓|graduation cap|celebration clothing education hat scholar|mortar_board|0.6|
🧢|billed cap|baseball bent dad hat|billed_cap|5|
🪖|military helmet|army soldier war warrior|military_helmet|13|
⛑️|rescue worker’s helmet|aid cross face hat|rescue_worker_helmet|0.7|
📿|prayer beads|clothing necklace religion|prayer_beads|1|
💄|lipstick|cosmetics date makeup|lipstick|0.6|
💍|ring|diamond engaged engagement married romance shiny|ring|0.6|
💎|gem stone|diamond engagement jewel money romance wedding|gem|0.6|
🔇|muted speaker|mute quiet silent sound|mute|1|
🔈|speaker low volume|soft sound|speaker|0.7|
🔉|speaker medium volume|sound|sound|1|
🔊|speaker high volume|loud music sound|loud_sound|0.6|
📢|loudspeaker|address communication loud public sound|loudspeaker|0.6|
📣|megaphone|cheering sound|mega|0.6|
📯|postal horn|post|postal_horn|1|
🔔|bell|break church sound|bell|0.6|
🔕|bell with slash|forbidden mute no not prohibited quiet|no_bell|1|
🎼|musical score|music note|musical_score|0.6|
🎵|musical note|music sound|musical_note|0.6|
🎶|musical notes|music note sound|notes|0.6|
🎙️|studio microphone|mic music|studio_microphone|0.7|
🎚️|level slider|music|level_slider|0.7|
🎛️|control knobs|music|control_knobs|0.7|
🎤|microphone|karaoke mic music sing sound|microphone|0.6|
🎧|headphone|earbud sound|headphones|0.6|
📻|radio|entertainment tbt video|radio|0.6|
🎷|saxophone|instrument music sax|saxophone|0.6|
🎺|trumpet|instrument music|trumpet|0.6|
🪊|trombone|brass instrument jazz music sad slide||17|
🪗|accordion|box concertina instrument music squeeze squeezebox|accordion|13|
🎸|guitar|instrument music strat|guitar|0.6|
🎹|musical keyboard|instrument music piano|musical_keyboard|0.6|
🎻|violin|instrument music|violin|0.6|
🪕|banjo|music stringed|banjo|12|
🥁|drum|drumsticks music|drum|3|
🪘|long drum|beat conga instrument rhythm|long_drum|13|
🪇|maracas|cha dance instrument music party percussion|maracas|15|
🪈|flute|band fife flautist instrument marching music|flute|15|
🪉|harp|cupid instrument love music orchestra||16|
📱|mobile phone|cell communication telephone|iphone|0.6|
📲|mobile phone with arrow|build call cell communication receive telephone|calling|0.6|
☎️|telephone|phone|phone telephone|0.6|
📞|telephone receiver|communication phone voip|telephone_receiver|0.6|
📟|pager|communication|pager|0.6|
📠|fax machine|communication|fax|0.6|
🔋|battery||battery|0.6|
🪫|low battery|drained electronic energy power|low_battery|14|
🔌|electric plug|electricity|electric_plug|0.6|
💻|laptop|computer office pc personal|computer|0.6|
🖥️|desktop computer|monitor|desktop_computer|0.7|
🖨️|printer|computer|printer|0.7|
⌨️|keyboard|computer|keyboard|1|
🖱️|computer mouse||computer_mouse|0.7|
🖲️|trackball|computer|trackball|0.7|
💽|computer disk|minidisk optical|minidisc|0.6|
💾|floppy disk|computer|floppy_disk|0.6|
💿|optical disk|cd blu-ray computer dvd|cd|0.6|
📀|dvd|blu-ray cd computer disk optical|dvd|0.6|
🧮|abacus|calculation calculator|abacus|11|
🎥|movie camera|bollywood cinema film hollywood record|movie_camera|0.6|
🎞️|film frames|cinema movie|film_strip|0.7|
📽️|film projector|cinema movie video|film_projector|0.7|
🎬|clapper board|action movie|clapper|0.6|
📺|television|tv video|tv|0.6|
📷|camera|photo selfie snap tbt trip video|camera|0.6|
📸|camera with flash|video|camera_flash|1|
📹|video camera|camcorder tbt|video_camera|0.6|
📼|videocassette|old school tape vcr vhs video|vhs|0.6|
🔍|magnifying glass tilted left|lab left-pointing science search tool|mag|0.6|
🔎|magnifying glass tilted right|contact lab right-pointing science search tool|mag_right|0.6|
🕯️|candle|light|candle|0.7|
💡|light bulb|comic electric idea|bulb|0.6|
🔦|flashlight|electric light tool torch|flashlight|0.6|
🏮|red paper lantern|bar light restaurant|izakaya_lantern lantern|0.6|
🪔|diya lamp|light oil|diya_lamp|12|
📔|notebook with decorative cover|book decorated education school writing|notebook_with_decorative_cover|0.6|
📕|closed book|education|closed_book|0.6|
📖|open book|education fantasy knowledge library novels reading|book open_book|0.6|
📗|green book|education fantasy library reading|green_book|0.6|
📘|blue book|education fantasy library reading|blue_book|0.6|
📙|orange book|education fantasy library reading|orange_book|0.6|
📚|books|book education fantasy knowledge library novels|books|0.6|
📓|notebook||notebook|0.6|
📒|ledger|notebook|ledger|0.6|
📃|page with curl|document paper|page_with_curl|0.6|
📜|scroll|paper|scroll|0.6|
📄|page facing up|document paper|page_facing_up|0.6|
📰|newspaper|communication news paper|newspaper|0.6|
🗞️|rolled-up newspaper|news paper rolled-up|newspaper_roll|0.7|
📑|bookmark tabs|mark marker|bookmark_tabs|0.6|
🔖|bookmark|mark|bookmark|0.6|
🏷️|label|tag|label|0.7|
🪙|coin|dollar euro gold metal money rich|coin|13|
💰|money bag|bank bet billion cash cost dollar|moneybag|0.6|
🪎|treasure chest|gem gold jewels loot money prize||17|
💴|yen banknote|bank bill currency money note|yen|0.6|
💵|dollar banknote|bank bill currency money note|dollar|0.6|
💶|euro banknote|100 bank bill currency money note|euro|1|
💷|pound banknote|bank bill billion cash currency money|pound|1|
💸|money with wings|bank banknote bill billion cash dollar|money_with_wings|0.6|
💳|credit card|bank cash charge money pay|credit_card|0.6|
🧾|receipt|accounting bookkeeping evidence invoice proof|receipt|11|
💹|chart increasing with yen|bank currency graph growth market money|chart|0.6|
✉️|envelope|e-mail email letter|envelope|0.6|
📧|e-mail|email letter|e-mail email|0.6|
📨|incoming envelope|delivering e-mail email letter mail receive|incoming_envelope|0.6|
📩|envelope with arrow|communication down e-mail email letter mail|envelope_with_arrow|0.6|
📤|outbox tray|box email letter mail sent|outbox_tray|0.6|
📥|inbox tray|box email letter mail receive zero|inbox_tray|0.6|
📦|package|box communication delivery parcel shipping|package|0.6|
📫|closed mailbox with raised flag|communication mail postbox|mailbox|0.6|
📪|closed mailbox with lowered flag|mail postbox|mailbox_closed|0.6|
📬|open mailbox with raised flag|mail postbox|mailbox_with_mail|0.7|
📭|open mailbox with lowered flag|mail postbox|mailbox_with_no_mail|0.7|
📮|postbox|mail mailbox|postbox|0.6|
🗳️|ballot box with ballot||ballot_box|0.7|
✏️|pencil||pencil2|0.6|
✒️|black nib|pen|black_nib|0.6|
🖋️|fountain pen||fountain_pen|0.7|
🖊️|pen|ballpoint|pen|0.7|
🖌️|paintbrush|painting|paintbrush|0.7|
🖍️|crayon||crayon|0.7|
📝|memo|communication media notes pencil|memo pencil|0.6|
🪌|eraser|correction delete drawing erase error mistake||18|
💼|briefcase|office|briefcase|0.6|
📁|file folder||file_folder|0.6|
📂|open file folder||open_file_folder|0.6|
🗂️|card index dividers||card_index_dividers|0.7|
📅|calendar|date|date|0.6|
📆|tear-off calendar|tear-off|calendar|0.6|
🗒️|spiral notepad|note pad|spiral_notepad|0.7|
🗓️|spiral calendar|pad|spiral_calendar|0.7|
📇|card index|old rolodex school|card_index|0.6|
📈|chart increasing|data graph growth right trend up|chart_with_upwards_trend|0.6|
📉|chart decreasing|data down downward graph negative trend|chart_with_downwards_trend|0.6|
📊|bar chart|data graph|bar_chart|0.6|
📋|clipboard|do list notes|clipboard|0.6|
📌|pushpin|collage pin|pushpin|0.6|
📍|round pushpin|location map pin|round_pushpin|0.6|
📎|paperclip||paperclip|0.6|
🖇️|linked paperclips|link paperclip|paperclips|0.7|
📏|straight ruler|angle edge math straightedge|straight_ruler|0.6|
📐|triangular ruler|angle math rule set slide triangle|triangular_ruler|0.6|
✂️|scissors|cut cutting paper tool|scissors|0.6|
🗃️|card file box||card_file_box|0.7|
🗄️|file cabinet|filing paper|file_cabinet|0.7|
🗑️|wastebasket|can garbage trash waste|wastebasket|0.7|
🔒|locked|closed lock private|lock|0.6|
🔓|unlocked|cracked lock open unlock|unlock|0.6|
🔏|locked with pen|ink lock nib privacy|lock_with_ink_pen|0.6|
🔐|locked with key|bike closed lock secure|closed_lock_with_key|0.6|
🔑|key|keys lock major password unlock|key|0.6|
🗝️|old key|clue lock|old_key|0.7|
🪍|net with handle|catch collect mesh trap||18|
🔨|hammer|home improvement repairs tool|hammer|0.6|
🪓|axe|ax chop hatchet split wood|axe|12|
⛏️|pick|hammer mining tool|pick|0.7|
⚒️|hammer and pick|tool|hammer_and_pick|1|
🛠️|hammer and wrench|spanner tool|hammer_and_wrench|0.7|
🗡️|dagger|knife weapon|dagger|0.7|
⚔️|crossed swords|weapon|crossed_swords|1|
💣|bomb|boom comic dangerous explosion hot|bomb|0.6|
🪃|boomerang|rebound repercussion weapon|boomerang|13|
🏹|bow and arrow|sagittarius archer archery tool weapon zodiac|bow_and_arrow|1|
🛡️|shield|weapon|shield|0.7|
🪚|carpentry saw|carpenter cut lumber tool trim|carpentry_saw|13|
🔧|wrench|home improvement spanner tool|wrench|0.6|
🪛|screwdriver|flathead handy screw tool|screwdriver|13|
🔩|nut and bolt|home improvement tool|nut_and_bolt|0.6|
⚙️|gear|cog cogwheel tool|gear|1|
🗜️|clamp|compress tool vice|clamp|0.7|
⚖️|balance scale|libra justice scales tool weight zodiac|balance_scale|1|
🦯|white cane|accessibility blind probing|probing_cane|12|
🔗|link|links|link|0.6|
⛓️‍💥|broken chain|break breaking cuffs freedom||15.1|
⛓️|chains|chain|chains|0.7|
🪝|hook|catch crook curve ensnare point selling|hook|13|
🧰|toolbox|box chest mechanic red tool|toolbox|11|
🧲|magnet|attraction horseshoe magnetic negative positive shape|magnet|11|
🪜|ladder|climb rung step|ladder|13|
🪏|shovel|bury dig garden hole plant scoop||16|
⚗️|alembic|chemistry tool|alembic|1|
🧪|test tube|chemist chemistry experiment lab science|test_tube|11|
🧫|petri dish|bacteria biologist biology culture lab|petri_dish|11|
🧬|dna|biologist evolution gene genetics life|dna|11|
🔬|microscope|experiment lab science tool|microscope|1|
🔭|telescope|contact extraterrestrial science tool|telescope|1|
📡|satellite antenna|aliens contact dish science|satellite|0.6|
💉|syringe|doctor flu medicine needle shot sick|syringe|0.6|
🩸|drop of blood|bleed donation injury medicine menstruation|drop_of_blood|12|
💊|pill|doctor drugs medicated medicine pills sick|pill|0.6|
🩹|adhesive bandage||adhesive_bandage|12|
🩼|crutch|aid cane disability help hurt injured|crutch|14|
🩺|stethoscope|doctor heart medicine|stethoscope|12|
🩻|x-ray|bones doctor medical skeleton skull xray|x_ray|14|
🚪|door|back closet front|door|0.6|
🛗|elevator|accessibility hoist lift|elevator|13|
🪞|mirror|makeup reflection reflector speculum|mirror|13|
🪟|window|air frame fresh opening transparent view|window|13|
🛏️|bed|hotel sleep|bed|0.7|
🛋️|couch and lamp|hotel|couch_and_lamp|0.7|
🪑|chair|seat sit|chair|12|
🚽|toilet|bathroom|toilet|0.6|
🪠|plunger|cup force plumber poop suction toilet|plunger|13|
🚿|shower|water|shower|1|
🛁|bathtub|bath|bathtub|1|
🪤|mouse trap|bait cheese lure mousetrap snare|mouse_trap|13|
🪒|razor|sharp shave|razor|12|
🧴|lotion bottle|moisturizer shampoo sunscreen|lotion_bottle|11|
🧷|safety pin|diaper punk rock|safety_pin|11|
🧹|broom|cleaning sweeping witch|broom|11|
🧺|basket|farming laundry picnic|basket|11|
🧻|roll of paper|toilet towels|roll_of_paper|11|
🪣|bucket|cask pail vat|bucket|13|
🧼|soap|bar bathing clean cleaning lather soapdish|soap|11|
🫧|bubbles|bubble burp clean floating pearl soap|bubbles|14|
🪥|toothbrush|bathroom brush clean dental hygiene teeth|toothbrush|13|
🧽|sponge|absorbing cleaning porous soak|sponge|11|
🧯|fire extinguisher|extinguish quench|fire_extinguisher|11|
🛒|shopping cart|trolley|shopping_cart|3|
🚬|cigarette|smoking|smoking|0.6|
⚰️|coffin|dead death vampire|coffin|1|
🪦|headstone|cemetery dead grave graveyard memorial rip|headstone|13|
⚱️|funeral urn|ashes death|funeral_urn|1|
🧿|nazar amulet|bead blue charm evil-eye talisman|nazar_amulet|11|
🪬|hamsa|fatima mary miriam amulet fortune guide|hamsa|14|
🗿|moai|face moyai statue stoneface travel|moyai|0.6|
🪧|placard|card demonstration notice picket plaque protest|placard|13|
🪪|identification card|id credentials document license security|identification_card|14|
#symbols
🏧|ATM sign|automated bank cash money teller|atm|0.6|
🚮|litter in bin sign|litterbin|put_litter_in_its_place|1|
🚰|potable water|drinking|potable_water|1|
♿|wheelchair symbol|access handicap|wheelchair|0.6|
🚹|men’s room|wc bathroom lavatory man restroom toilet|mens|0.6|
🚺|women’s room|wc bathroom lavatory restroom toilet woman|womens|0.6|
🚻|restroom|wc bathroom lavatory toilet|restroom|0.6|
🚼|baby symbol|changing|baby_symbol|0.6|
🚾|water closet|wc bathroom lavatory restroom toilet|wc|0.6|
🛂|passport control||passport_control|1|
🛃|customs|packing|customs|1|
🛄|baggage claim|arrived bags case checked journey packing|baggage_claim|1|
🛅|left luggage|baggage case locker|left_luggage|1|
⚠️|warning|caution|warning|0.6|
🚸|children crossing|child pedestrian traffic|children_crossing|1|
⛔|no entry|do fail forbidden not pass prohibited|no_entry|0.6|
🚫|prohibited|entry forbidden no not smoke|no_entry_sign|0.6|
🚳|no bicycles|bicycle bike forbidden not prohibited|no_bicycles|1|
🚭|no smoking|forbidden not prohibited smoke|no_smoking|0.6|
🚯|no littering|forbidden litter not prohibited|do_not_litter|1|
🚱|non-potable water|dry non-drinking non-potable prohibited|non-potable_water|1|
🚷|no pedestrians|forbidden not pedestrian prohibited|no_pedestrians|1|
📵|no mobile phones|cell forbidden not phone prohibited telephone|no_mobile_phones|1|
🔞|no one under eighteen|18 age forbidden not prohibited restriction|underage|0.6|
☢️|radioactive|sign|radioactive|1|
☣️|biohazard|sign|biohazard|1|
⬆️|up arrow|cardinal direction north|arrow_up|0.6|
↗️|up-right arrow|direction intercardinal northeast up-right|arrow_upper_right|0.6|
➡️|right arrow|cardinal direction east|arrow_right|0.6|
↘️|down-right arrow|direction down-right intercardinal southeast|arrow_lower_right|0.6|
⬇️|down arrow|cardinal direction south|arrow_down|0.6|
↙️|down-left arrow|direction down-left intercardinal southwest|arrow_lower_left|0.6|
⬅️|left arrow|cardinal direction west|arrow_left|0.6|
↖️|up-left arrow|direction intercardinal northwest up-left|arrow_upper_left|0.6|
↕️|up-down arrow|up-down|arrow_up_down|0.6|
↔️|left-right arrow|left-right|left_right_arrow|0.6|
↩️|right arrow curving left||leftwards_arrow_with_hook|0.6|
↪️|left arrow curving right||arrow_right_hook|0.6|
⤴️|right arrow curving up||arrow_heading_up|0.6|
⤵️|right arrow curving down||arrow_heading_down|0.6|
🔃|clockwise vertical arrows|arrow refresh reload|arrows_clockwise|0.6|
🔄|counterclockwise arrows button|again anticlockwise arrow deja refresh rewindershins|arrows_counterclockwise|1|
🔙|BACK arrow||back|0.6|
🔚|END arrow||end|0.6|
🔛|ON! arrow|mark|on|0.6|
🔜|SOON arrow|brb omw|soon|0.6|
🔝|TOP arrow|homie up|top|0.6|
🛐|place of worship|pray religion|place_of_worship|1|
⚛️|atom symbol|atheist|atom_symbol|1|
🕉️|om|hindu religion|om|0.7|
✡️|star of David|jew jewish judaism religion|star_of_david|0.7|
☸️|wheel of dharma|buddhist religion|wheel_of_dharma|0.7|
☯️|yin yang|difficult lives religion tao taoist total|yin_yang|0.7|
✝️|latin cross|christian christ religion|latin_cross|0.7|
☦️|orthodox cross|christian religion|orthodox_cross|1|
☪️|star and crescent|muslim islam ramadan religion|star_and_crescent|0.7|
☮️|peace symbol|healing peaceful|peace_symbol|1|
🕎|menorah|candelabrum candlestick hanukkah jewish judaism religion|menorah|1|
🔯|dotted six-pointed star|fortune jewish judaism six-pointed|six_pointed_star|0.6|
🪯|khanda|deg fateh khalsa sikh sikhism tegh|khanda|15|
♈|Aries|horoscope ram zodiac|aries|0.6|
♉|Taurus|bull horoscope ox zodiac|taurus|0.6|
♊|Gemini|horoscope twins zodiac|gemini|0.6|
♋|Cancer|crab horoscope zodiac|cancer|0.6|
♌|Leo|horoscope lion zodiac|leo|0.6|
♍|Virgo|horoscope zodiac|virgo|0.6|
♎|Libra|balance horoscope justice scales zodiac|libra|0.6|
♏|Scorpio|scorpius horoscope scorpion zodiac|scorpius|0.6|
♐|Sagittarius|archer horoscope zodiac|sagittarius|0.6|
♑|Capricorn|goat horoscope zodiac|capricorn|0.6|
♒|Aquarius|bearer horoscope water zodiac|aquarius|0.6|
♓|Pisces|fish horoscope zodiac|pisces|0.6|
⛎|Ophiuchus|bearer serpent snake zodiac|ophiuchus|0.6|
🔀|shuffle tracks button|arrow crossed|twisted_rightwards_arrows|1|
🔁|repeat button|arrow clockwise|repeat|1|
🔂|repeat single button|arrow clockwise once|repeat_one|1|
▶️|play button|arrow right triangle|arrow_forward|0.6|
⏩|fast-forward button|arrow double fast-forward|fast_forward|0.6|
⏭️|next track button|arrow scene triangle|next_track_button|0.7|
⏯️|play or pause button|arrow right triangle|play_or_pause_button|1|
◀️|reverse button|arrow left triangle|arrow_backward|0.6|
⏪|fast reverse button|arrow double rewind|rewind|0.6|
⏮️|last track button|arrow previous scene triangle|previous_track_button|0.7|
🔼|upwards button|arrow red up|arrow_up_small|0.6|
⏫|fast up button|arrow double|arrow_double_up|0.6|
🔽|downwards button|arrow down red|arrow_down_small|0.6|
⏬|fast down button|arrow double|arrow_double_down|0.6|
⏸️|pause button|bar double vertical|pause_button|0.7|
⏹️|stop button|square|stop_button|0.7|
⏺️|record button|circle|record_button|0.7|
⏏️|eject button||eject_button|1|
🎦|cinema|camera film movie|cinema|0.6|
🔅|dim button|brightness low|low_brightness|1|
🔆|bright button|brightness light|high_brightness|1|
📶|antenna bars|bar cell communication mobile phone signal|signal_strength|0.6|
🛜|wireless|broadband computer connectivity hotspot internet network|wireless|15|
📳|vibration mode|cell communication mobile phone telephone|vibration_mode|0.6|
📴|mobile phone off|cell telephone|mobile_phone_off|0.6|
♀️|female sign|woman|female_sign|4|
♂️|male sign|man|male_sign|4|
⚧️|transgender symbol||transgender_symbol|13|
✖️|multiply|cancel multiplication sign x ×|heavy_multiplication_x|0.6|
➕|plus|+|heavy_plus_sign|0.6|
➖|minus|- heavy math sign −|heavy_minus_sign|0.6|
➗|divide|division heavy math sign ÷|heavy_division_sign|0.6|
🟰|heavy equals sign|answer equal equality math|heavy_equals_sign|14|
♾️|infinity|forever unbounded universal|infinity|11|
‼️|double exclamation mark|! !! bangbang punctuation|bangbang|0.6|
⁉️|exclamation question mark|! !? ? interrobang punctuation|interrobang|0.6|
❓|red question mark|? punctuation|question|0.6|
❔|white question mark|? outlined punctuation|grey_question|0.6|
❕|white exclamation mark|! bang outlined punctuation|grey_exclamation|0.6|
❗|red exclamation mark|! bang punctuation|exclamation heavy_exclamation_mark|0.6|
〰️|wavy dash|punctuation|wavy_dash|0.6|
💱|currency exchange|bank money|currency_exchange|0.6|
💲|heavy dollar sign|billion cash charge currency million money|heavy_dollar_sign|0.6|
⚕️|medical symbol|aesculapius medicine staff|medical_symbol|4|
♻️|recycling symbol|recycle|recycle|0.6|
⚜️|fleur-de-lis|knights|fleur_de_lis|1|
🔱|trident emblem|anchor poseidon ship tool|trident|0.6|
📛|name badge||name_badge|0.6|
🔰|Japanese symbol for beginner|chevron green leaf tool yellow|beginner|0.6|
⭕|hollow red circle|heavy large o|o|0.6|
✅|check mark button|checked checkmark complete completed done fixed|white_check_mark|0.6|
☑️|check box with check|ballot checked done off tick ✓|ballot_box_with_check|0.6|
✔️|check mark|checked checkmark done heavy tick ✓|heavy_check_mark|0.6|
❌|cross mark|cancel multiplication multiply x ×|x|0.6|
❎|cross mark button|multiplication multiply square x ×|negative_squared_cross_mark|0.6|
➰|curly loop|curl|curly_loop|0.6|
➿|double curly loop|curl|loop|1|
〽️|part alternation mark||part_alternation_mark|0.6|
✳️|eight-spoked asterisk|* eight-spoked|eight_spoked_asterisk|0.6|
✴️|eight-pointed star|* eight-pointed|eight_pointed_black_star|0.6|
❇️|sparkle|*|sparkle|0.6|
©️|copyright|c|copyright|0.6|
®️|registered|r|registered|0.6|
™️|trade mark|tm trademark|tm|0.6|
🫟|splatter|drip holi ink liquid mess paint||16|
#️⃣|keycap: #||hash|0.6|
*️⃣|keycap: *||asterisk|2|
0️⃣|keycap: 0|zero|zero|0.6|
1️⃣|keycap: 1|one|one|0.6|
2️⃣|keycap: 2|two|two|0.6|
3️⃣|keycap: 3|three|three|0.6|
4️⃣|keycap: 4|four|four|0.6|
5️⃣|keycap: 5|five|five|0.6|
6️⃣|keycap: 6|six|six|0.6|
7️⃣|keycap: 7|seven|seven|0.6|
8️⃣|keycap: 8|eight|eight|0.6|
9️⃣|keycap: 9|nine|nine|0.6|
🔟|keycap: 10||keycap_ten|0.6|
🔠|input latin uppercase|abcd letters|capital_abcd|0.6|
🔡|input latin lowercase|abcd letters|abcd|0.6|
🔢|input numbers|1234|1234|0.6|
🔣|input symbols|% & ♪ 〒|symbols|0.6|
🔤|input latin letters|abc alphabet|abc|0.6|
🅰️|A button (blood type)|blood type|a|0.6|
🆎|AB button (blood type)|blood type|ab|0.6|
🅱️|B button (blood type)|blood type|b|0.6|
🆑|CL button||cl|0.6|
🆒|COOL button||cool|0.6|
🆓|FREE button||free|0.6|
ℹ️|information|i|information_source|0.6|
🆔|ID button|identity|id|0.6|
Ⓜ️|circled M|circle|m|0.6|
🆕|NEW button||new|0.6|
🆖|NG button||ng|0.6|
🅾️|O button (blood type)|blood type|o2|0.6|
🆗|OK button|okay|ok|0.6|
🅿️|P button|parking|parking|0.6|
🆘|SOS button|help|sos|0.6|
🆙|UP! button|up mark|up|0.6|
🆚|VS button|versus|vs|0.6|
🈁|Japanese “here” button|here katakana|koko|0.6|
🈂️|Japanese “service charge” button|charge katakana service|sa|0.6|
🈷️|Japanese “monthly amount” button|amount ideograph monthly|u6708|0.6|
🈶|Japanese “not free of charge” button|charge ideograph not|u6709|0.6|
🈯|Japanese “reserved” button|ideograph reserved|u6307|0.6|
🉐|Japanese “bargain” button|bargain ideograph|ideograph_advantage|0.6|
🈹|Japanese “discount” button|discount ideograph|u5272|0.6|
🈚|Japanese “free of charge” button|charge free ideograph|u7121|0.6|
🈲|Japanese “prohibited” button|ideograph prohibited|u7981|0.6|
🉑|Japanese “acceptable” button|acceptable ideograph|accept|0.6|
🈸|Japanese “application” button|application ideograph|u7533|0.6|
🈴|Japanese “passing grade” button|grade ideograph passing|u5408|0.6|
🈳|Japanese “vacancy” button|ideograph vacancy|u7a7a|0.6|
㊗️|Japanese “congratulations” button|congratulations ideograph|congratulations|0.6|
㊙️|Japanese “secret” button|ideograph secret|secret|0.6|
🈺|Japanese “open for business” button|business ideograph open|u55b6|0.6|
🈵|Japanese “no vacancy” button|ideograph no vacancy|u6e80|0.6|
🔴|red circle|geometric|red_circle|0.6|
🟠|orange circle||orange_circle|12|
🟡|yellow circle||yellow_circle|12|
🟢|green circle||green_circle|12|
🔵|blue circle|geometric|large_blue_circle|0.6|
🟣|purple circle||purple_circle|12|
🟤|brown circle||brown_circle|12|
⚫|black circle|geometric|black_circle|0.6|
⚪|white circle|geometric|white_circle|0.6|
🟥|red square|card penalty|red_square|12|
🟧|orange square||orange_square|12|
🟨|yellow square|card penalty|yellow_square|12|
🟩|green square||green_square|12|
🟦|blue square||blue_square|12|
🟪|purple square||purple_square|12|
🟫|brown square||brown_square|12|
⬛|black large square|geometric|black_large_square|0.6|
⬜|white large square|geometric|white_large_square|0.6|
◼️|black medium square|geometric|black_medium_square|0.6|
◻️|white medium square|geometric|white_medium_square|0.6|
◾|black medium-small square|geometric medium-small|black_medium_small_square|0.6|
◽|white medium-small square|geometric medium-small|white_medium_small_square|0.6|
▪️|black small square|geometric|black_small_square|0.6|
▫️|white small square|geometric|white_small_square|0.6|
🔶|large orange diamond|geometric|large_orange_diamond|0.6|
🔷|large blue diamond|geometric|large_blue_diamond|0.6|
🔸|small orange diamond|geometric|small_orange_diamond|0.6|
🔹|small blue diamond|geometric|small_blue_diamond|0.6|
🔺|red triangle pointed up|geometric|small_red_triangle|0.6|
🔻|red triangle pointed down|geometric|small_red_triangle_down|0.6|
💠|diamond with a dot|comic geometric|diamond_shape_with_a_dot_inside|0.6|
🔘|radio button|geometric|radio_button|0.6|
🔳|white square button|geometric outlined|white_square_button|0.6|
🔲|black square button|geometric|black_square_button|0.6|
#flags
🏁|chequered flag|checkered finish flags game race racing|checkered_flag|0.6|
🚩|triangular flag|construction golf post|triangular_flag_on_post|0.6|
🎌|crossed flags|japanese celebration cross|crossed_flags|0.6|
🏴|black flag|waving|black_flag|1|
🏳️|white flag|waving|white_flag|0.7|
🏳️‍🌈|rainbow flag|bisexual gay genderqueer glbt glbtq lesbian|rainbow_flag|4|
🏳️‍⚧️|transgender flag|blue light pink white|transgender_flag|13|
🏴‍☠️|pirate flag|jolly roger plunder treasure|pirate_flag|11|
🇦🇨|flag: Ascension Island|ac|ascension_island|2|
🇦🇩|flag: Andorra|ad|andorra|2|
🇦🇪|flag: United Arab Emirates|ae|united_arab_emirates|2|
🇦🇫|flag: Afghanistan|af|afghanistan|2|
🇦🇬|flag: Antigua & Barbuda|ag|antigua_barbuda|2|
🇦🇮|flag: Anguilla|ai|anguilla|2|
🇦🇱|flag: Albania|al|albania|2|
🇦🇲|flag: Armenia|am|armenia|2|
🇦🇴|flag: Angola|ao|angola|2|
🇦🇶|flag: Antarctica|aq|antarctica|2|
🇦🇷|flag: Argentina|ar|argentina|2|
🇦🇸|flag: American Samoa|as|american_samoa|2|
🇦🇹|flag: Austria|at|austria|2|
🇦🇺|flag: Australia|au|australia|2|
🇦🇼|flag: Aruba|aw|aruba|2|
🇦🇽|flag: Åland Islands|ax|aland_islands|2|
🇦🇿|flag: Azerbaijan|az|azerbaijan|2|
🇧🇦|flag: Bosnia & Herzegovina|ba|bosnia_herzegovina|2|
🇧🇧|flag: Barbados|bb|barbados|2|
🇧🇩|flag: Bangladesh|bd|bangladesh|2|
🇧🇪|flag: Belgium|be|belgium|2|
🇧🇫|flag: Burkina Faso|bf|burkina_faso|2|
🇧🇬|flag: Bulgaria|bg|bulgaria|2|
🇧🇭|flag: Bahrain|bh|bahrain|2|
🇧🇮|flag: Burundi|bi|burundi|2|
🇧🇯|flag: Benin|bj|benin|2|
🇧🇱|flag: St. Barthélemy|bl|st_barthelemy|2|
🇧🇲|flag: Bermuda|bm|bermuda|2|
🇧🇳|flag: Brunei|bn|brunei|2|
🇧🇴|flag: Bolivia|bo|bolivia|2|
🇧🇶|flag: Caribbean Netherlands|bq|caribbean_netherlands|2|
🇧🇷|flag: Brazil|br|brazil|2|
🇧🇸|flag: Bahamas|bs|bahamas|2|
🇧🇹|flag: Bhutan|bt|bhutan|2|
🇧🇻|flag: Bouvet Island|bv|bouvet_island|2|
🇧🇼|flag: Botswana|bw|botswana|2|
🇧🇾|flag: Belarus|by|belarus|2|
🇧🇿|flag: Belize|bz|belize|2|
🇨🇦|flag: Canada|ca|canada|2|
🇨🇨|flag: Cocos (Keeling) Islands|cc|cocos_islands|2|
🇨🇩|flag: Congo - Kinshasa|cd|congo_kinshasa|2|
🇨🇫|flag: Central African Republic|cf|central_african_republic|2|
🇨🇬|flag: Congo - Brazzaville|cg|congo_brazzaville|2|
🇨🇭|flag: Switzerland|ch|switzerland|2|
🇨🇮|flag: Côte d’Ivoire|ci|cote_divoire|2|
🇨🇰|flag: Cook Islands|ck|cook_islands|2|
🇨🇱|flag: Chile|cl|chile|2|
🇨🇲|flag: Cameroon|cm|cameroon|2|
🇨🇳|flag: China|cn|cn|0.6|
🇨🇴|flag: Colombia|co|colombia|2|
🇨🇵|flag: Clipperton Island|cp|clipperton_island|2|
🇨🇶|flag: Sark|cq||16|
🇨🇷|flag: Costa Rica|cr|costa_rica|2|
🇨🇺|flag: Cuba|cu|cuba|2|
🇨🇻|flag: Cape Verde|cv|cape_verde|2|
🇨🇼|flag: Curaçao|cw|curacao|2|
🇨🇽|flag: Christmas Island|cx|christmas_island|2|
🇨🇾|flag: Cyprus|cy|cyprus|2|
🇨🇿|flag: Czechia|cz|czech_republic|2|
🇩🇪|flag: Germany|de|de|0.6|
🇩🇬|flag: Diego Garcia|dg|diego_garcia|2|
🇩🇯|flag: Djibouti|dj|djibouti|2|
🇩🇰|flag: Denmark|dk|denmark|2|
🇩🇲|flag: Dominica|dm|dominica|2|
🇩🇴|flag: Dominican Republic|do|dominican_republic|2|
🇩🇿|flag: Algeria|dz|algeria|2|
🇪🇦|flag: Ceuta & Melilla|ea|ceuta_melilla|2|
🇪🇨|flag: Ecuador|ec|ecuador|2|
🇪🇪|flag: Estonia|ee|estonia|2|
🇪🇬|flag: Egypt|eg|egypt|2|
🇪🇭|flag: Western Sahara|eh|western_sahara|2|
🇪🇷|flag: Eritrea|er|eritrea|2|
🇪🇸|flag: Spain|es|es|0.6|
🇪🇹|flag: Ethiopia|et|ethiopia|2|
🇪🇺|flag: European Union|eu|eu european_union|2|
🇫🇮|flag: Finland|fi|finland|2|
🇫🇯|flag: Fiji|fj|fiji|2|
🇫🇰|flag: Falkland Islands|fk|falkland_islands|2|
🇫🇲|flag: Micronesia|fm|micronesia|2|
🇫🇴|flag: Faroe Islands|fo|faroe_islands|2|
🇫🇷|flag: France|fr|fr|0.6|
🇬🇦|flag: Gabon|ga|gabon|2|
🇬🇧|flag: United Kingdom|gb|gb uk|0.6|
🇬🇩|flag: Grenada|gd|grenada|2|
🇬🇪|flag: Georgia|ge|georgia|2|
🇬🇫|flag: French Guiana|gf|french_guiana|2|
🇬🇬|flag: Guernsey|gg|guernsey|2|
🇬🇭|flag: Ghana|gh|ghana|2|
🇬🇮|flag: Gibraltar|gi|gibraltar|2|
🇬🇱|flag: Greenland|gl|greenland|2|
🇬🇲|flag: Gambia|gm|gambia|2|
🇬🇳|flag: Guinea|gn|guinea|2|
🇬🇵|flag: Guadeloupe|gp|guadeloupe|2|
🇬🇶|flag: Equatorial Guinea|gq|equatorial_guinea|2|
🇬🇷|flag: Greece|gr|greece|2|
🇬🇸|flag: South Georgia & South Sandwich Islands|gs|south_georgia_south_sandwich_islands|2|
🇬🇹|flag: Guatemala|gt|guatemala|2|
🇬🇺|flag: Guam|gu|guam|2|
🇬🇼|flag: Guinea-Bissau|gw|guinea_bissau|2|
🇬🇾|flag: Guyana|gy|guyana|2|
🇭🇰|flag: Hong Kong SAR China|hk|hong_kong|2|
🇭🇲|flag: Heard Island & McDonald Islands|hm|heard_mcdonald_islands|2|
🇭🇳|flag: Honduras|hn|honduras|2|
🇭🇷|flag: Croatia|hr|croatia|2|
🇭🇹|flag: Haiti|ht|haiti|2|
🇭🇺|flag: Hungary|hu|hungary|2|
🇮🇨|flag: Canary Islands|ic|canary_islands|2|
🇮🇩|flag: Indonesia|id|indonesia|2|
🇮🇪|flag: Ireland|ie|ireland|2|
🇮🇱|flag: Israel|il|israel|2|
🇮🇲|flag: Isle of Man|im|isle_of_man|2|
🇮🇳|flag: India|in|india|2|
🇮🇴|flag: British Indian Ocean Territory|io|british_indian_ocean_territory|2|
🇮🇶|flag: Iraq|iq|iraq|2|
🇮🇷|flag: Iran|ir|iran|2|
🇮🇸|flag: Iceland|is|iceland|2|
🇮🇹|flag: Italy|it|it|0.6|
🇯🇪|flag: Jersey|je|jersey|2|
🇯🇲|flag: Jamaica|jm|jamaica|2|
🇯🇴|flag: Jordan|jo|jordan|2|
🇯🇵|flag: Japan|jp|jp|0.6|
🇰🇪|flag: Kenya|ke|kenya|2|
🇰🇬|flag: Kyrgyzstan|kg|kyrgyzstan|2|
🇰🇭|flag: Cambodia|kh|cambodia|2|
🇰🇮|flag: Kiribati|ki|kiribati|2|
🇰🇲|flag: Comoros|km|comoros|2|
🇰🇳|flag: St. Kitts & Nevis|kn|st_kitts_nevis|2|
🇰🇵|flag: North Korea|kp|north_korea|2|
🇰🇷|flag: South Korea|kr|kr|0.6|
🇰🇼|flag: Kuwait|kw|kuwait|2|
🇰🇾|flag: Cayman Islands|ky|cayman_islands|2|
🇰🇿|flag: Kazakhstan|kz|kazakhstan|2|
🇱🇦|flag: Laos|la|laos|2|
🇱🇧|flag: Lebanon|lb|lebanon|2|
🇱🇨|flag: St. Lucia|lc|st_lucia|2|
🇱🇮|flag: Liechtenstein|li|liechtenstein|2|
🇱🇰|flag: Sri Lanka|lk|sri_lanka|2|
🇱🇷|flag: Liberia|lr|liberia|2|
🇱🇸|flag: Lesotho|ls|lesotho|2|
🇱🇹|flag: Lithuania|lt|lithuania|2|
🇱🇺|flag: Luxembourg|lu|luxembourg|2|
🇱🇻|flag: Latvia|lv|latvia|2|
🇱🇾|flag: Libya|ly|libya|2|
🇲🇦|flag: Morocco|ma|morocco|2|
🇲🇨|flag: Monaco|mc|monaco|2|
🇲🇩|flag: Moldova|md|moldova|2|
🇲🇪|flag: Montenegro|me|montenegro|2|
🇲🇫|flag: St. Martin|mf|st_martin|2|
🇲🇬|flag: Madagascar|mg|madagascar|2|
🇲🇭|flag: Marshall Islands|mh|marshall_islands|2|
🇲🇰|flag: North Macedonia|mk|macedonia|2|
🇲🇱|flag: Mali|ml|mali|2|
🇲🇲|flag: Myanmar (Burma)|mm|myanmar|2|
🇲🇳|flag: Mongolia|mn|mongolia|2|
🇲🇴|flag: Macao SAR China|mo|macau|2|
🇲🇵|flag: Northern Mariana Islands|mp|northern_mariana_islands|2|
🇲🇶|flag: Martinique|mq|martinique|2|
🇲🇷|flag: Mauritania|mr|mauritania|2|
🇲🇸|flag: Montserrat|ms|montserrat|2|
🇲🇹|flag: Malta|mt|malta|2|
🇲🇺|flag: Mauritius|mu|mauritius|2|
🇲🇻|flag: Maldives|mv|maldives|2|
🇲🇼|flag: Malawi|mw|malawi|2|
🇲🇽|flag: Mexico|mx|mexico|2|
🇲🇾|flag: Malaysia|my|malaysia|2|
🇲🇿|flag: Mozambique|mz|mozambique|2|
🇳🇦|flag: Namibia|na|namibia|2|
🇳🇨|flag: New Caledonia|nc|new_caledonia|2|
🇳🇪|flag: Niger|ne|niger|2|
🇳🇫|flag: Norfolk Island|nf|norfolk_island|2|
🇳🇬|flag: Nigeria|ng|nigeria|2|
🇳🇮|flag: Nicaragua|ni|nicaragua|2|
🇳🇱|flag: Netherlands|nl|netherlands|2|
🇳🇴|flag: Norway|no|norway|2|
🇳🇵|flag: Nepal|np|nepal|2|
🇳🇷|flag: Nauru|nr|nauru|2|
🇳🇺|flag: Niue|nu|niue|2|
🇳🇿|flag: New Zealand|nz|new_zealand|2|
🇴🇲|flag: Oman|om|oman|2|
🇵🇦|flag: Panama|pa|panama|2|
🇵🇪|flag: Peru|pe|peru|2|
🇵🇫|flag: French Polynesia|pf|french_polynesia|2|
🇵🇬|flag: Papua New Guinea|pg|papua_new_guinea|2|
🇵🇭|flag: Philippines|ph|philippines|2|
🇵🇰|flag: Pakistan|pk|pakistan|2|
🇵🇱|flag: Poland|pl|poland|2|
🇵🇲|flag: St. Pierre & Miquelon|pm|st_pierre_miquelon|2|
🇵🇳|flag: Pitcairn Islands|pn|pitcairn_islands|2|
🇵🇷|flag: Puerto Rico|pr|puerto_rico|2|
🇵🇸|flag: Palestinian Territories|ps|palestinian_territories|2|
🇵🇹|flag: Portugal|pt|portugal|2|
🇵🇼|flag: Palau|pw|palau|2|
🇵🇾|flag: Paraguay|py|paraguay|2|
🇶🇦|flag: Qatar|qa|qatar|2|
🇷🇪|flag: Réunion|re|reunion|2|
🇷🇴|flag: Romania|ro|romania|2|
🇷🇸|flag: Serbia|rs|serbia|2|
🇷🇺|flag: Russia|ru|ru|0.6|
🇷🇼|flag: Rwanda|rw|rwanda|2|
🇸🇦|flag: Saudi Arabia|sa|saudi_arabia|2|
🇸🇧|flag: Solomon Islands|sb|solomon_islands|2|
🇸🇨|flag: Seychelles|sc|seychelles|2|
🇸🇩|flag: Sudan|sd|sudan|2|
🇸🇪|flag: Sweden|se|sweden|2|
🇸🇬|flag: Singapore|sg|singapore|2|
🇸🇭|flag: St. Helena, Ascension & Tristan da Cunha|sh|st_helena|2|
🇸🇮|flag: Slovenia|si|slovenia|2|
🇸🇯|flag: Svalbard & Jan Mayen|sj|svalbard_jan_mayen|2|
🇸🇰|flag: Slovakia|sk|slovakia|2|
🇸🇱|flag: Sierra Leone|sl|sierra_leone|2|
🇸🇲|flag: San Marino|sm|san_marino|2|
🇸🇳|flag: Senegal|sn|senegal|2|
🇸🇴|flag: Somalia|so|somalia|2|
🇸🇷|flag: Suriname|sr|suriname|2|
🇸🇸|flag: South Sudan|ss|south_sudan|2|
🇸🇹|flag: São Tomé & Príncipe|st|sao_tome_principe|2|
🇸🇻|flag: El Salvador|sv|el_salvador|2|
🇸🇽|flag: Sint Maarten|sx|sint_maarten|2|
🇸🇾|flag: Syria|sy|syria|2|
🇸🇿|flag: Eswatini|sz|swaziland|2|
🇹🇦|flag: Tristan da Cunha|ta|tristan_da_cunha|2|
🇹🇨|flag: Turks & Caicos Islands|tc|turks_caicos_islands|2|
🇹🇩|flag: Chad|td|chad|2|
🇹🇫|flag: French Southern and Antarctic Lands|tf|french_southern_territories|2|
🇹🇬|flag: Togo|tg|togo|2|
🇹🇭|flag: Thailand|th|thailand|2|
🇹🇯|flag: Tajikistan|tj|tajikistan|2|
🇹🇰|flag: Tokelau|tk|tokelau|2|
🇹🇱|flag: Timor-Leste|tl|timor_leste|2|
🇹🇲|flag: Turkmenistan|tm|turkmenistan|2|
🇹🇳|flag: Tunisia|tn|tunisia|2|
🇹🇴|flag: Tonga|to|tonga|2|
🇹🇷|flag: Türkiye|tr|tr|2|
🇹🇹|flag: Trinidad & Tobago|tt|trinidad_tobago|2|
🇹🇻|flag: Tuvalu|tv|tuvalu|2|
🇹🇼|flag: Taiwan|tw|taiwan|2|
🇹🇿|flag: Tanzania|tz|tanzania|2|
🇺🇦|flag: Ukraine|ua|ukraine|2|
🇺🇬|flag: Uganda|ug|uganda|2|
🇺🇲|flag: U.S. Outlying Islands|um|us_outlying_islands|2|
🇺🇳|flag: United Nations|un|united_nations|4|
🇺🇸|flag: United States|us|us|0.6|
🇺🇾|flag: Uruguay|uy|uruguay|2|
🇺🇿|flag: Uzbekistan|uz|uzbekistan|2|
🇻🇦|flag: Vatican City|va|vatican_city|2|
🇻🇨|flag: St. Vincent & Grenadines|vc|st_vincent_grenadines|2|
🇻🇪|flag: Venezuela|ve|venezuela|2|
🇻🇬|flag: British Virgin Islands|vg|british_virgin_islands|2|
🇻🇮|flag: U.S. Virgin Islands|vi|us_virgin_islands|2|
🇻🇳|flag: Vietnam|vn|vietnam|2|
🇻🇺|flag: Vanuatu|vu|vanuatu|2|
🇼🇫|flag: Wallis & Futuna|wf|wallis_futuna|2|
🇼🇸|flag: Samoa|ws|samoa|2|
🇽🇰|flag: Kosovo|xk|kosovo|2|
🇾🇪|flag: Yemen|ye|yemen|2|
🇾🇹|flag: Mayotte|yt|mayotte|2|
🇿🇦|flag: South Africa|za|south_africa|2|
🇿🇲|flag: Zambia|zm|zambia|2|
🇿🇼|flag: Zimbabwe|zw|zimbabwe|2|
🏴󠁧󠁢󠁥󠁮󠁧󠁿|flag: England|gbeng|england|5|
🏴󠁧󠁢󠁳󠁣󠁴󠁿|flag: Scotland|gbsct|scotland|5|
🏴󠁧󠁢󠁷󠁬󠁳󠁿|flag: Wales|gbwls|wales|5|`, Yee = ["👍", "❤️", "😂", "🎉", "🔥", "👀", "✅", "🙏"], L2 = ["✋", "✋🏻", "✋🏼", "✋🏽", "✋🏾", "✋🏿"];
let Zu = null;
function Ho(n) {
  return n.replace(/️/g, "");
}
function Hf() {
  if (Zu) return Zu;
  const n = [], e = [], t = /* @__PURE__ */ new Map(), i = new Map(qee.map((o) => [o.key, o.label]));
  let s = null;
  for (const o of Kee.split(`
`)) {
    if (o.charAt(0) === "#" && o.indexOf("|") < 0) {
      const f = o.slice(1);
      s = { key: f, label: i.get(f) || f, emoji: [] }, n.push(s);
      continue;
    }
    if (!s) continue;
    const [r, a, l, d, c, u] = o.split("|"), p = { c: r, n: a, k: (a + " " + l).toLowerCase(), s: d ? d.split(" ") : [], v: Number(c) || 0, skins: u ? u.split(" ") : null, g: s.key };
    if (s.emoji.push(p), e.push(p), t.set(Ho(r), p), p.skins) for (const f of p.skins) t.set(Ho(f), p);
  }
  return Zu = { groups: n, all: e, byBase: t }, Zu;
}
const B2 = "rd-board-emoji-version";
let Qu = null;
function hC() {
  if (Qu != null) return Qu;
  if (typeof document == "undefined" || /jsdom/i.test(navigator.userAgent)) return 1 / 0;
  try {
    const e = JSON.parse(localStorage.getItem(B2) || "null");
    if (e && e.ua === navigator.userAgent && typeof e.v == "number") return Qu = e.v;
  } catch {
  }
  const n = Qu = Xee();
  try {
    localStorage.setItem(B2, JSON.stringify({ ua: navigator.userAgent, v: n }));
  } catch {
  }
  return n;
}
function Xee() {
  const n = document.createElement("canvas");
  n.width = n.height = 32;
  const e = n.getContext("2d", { willReadFrequently: !0 });
  if (!e) return 1 / 0;
  e.font = '24px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif', e.textBaseline = "top";
  const t = e.measureText("😀").width;
  if (!t) return 1 / 0;
  const i = /* @__PURE__ */ new Map();
  for (const o of Hf().all) o.v > 12 && !i.has(o.v) && i.set(o.v, o.c);
  let s = 12;
  for (const o of Array.from(i.keys()).sort((r, a) => r - a)) {
    if (!Jee(e, i.get(o), t)) break;
    s = o;
  }
  return s;
}
function Jee(n, e, t) {
  if (n.measureText(e).width > t * 1.5) return !1;
  n.clearRect(0, 0, 32, 32), n.fillText(e, 0, 0);
  const i = n.getImageData(0, 0, 32, 32).data;
  for (let s = 0; s < i.length; s += 4) {
    if (i[s + 3] < 128) continue;
    const o = i[s], r = i[s + 1], a = i[s + 2];
    if (Math.max(o, r, a) - Math.min(o, r, a) > 40) return !0;
  }
  return !1;
}
function Zee() {
  const n = hC();
  return Hf().groups.map((e) => ({ ...e, emoji: e.emoji.filter((t) => t.v <= n) }));
}
function ky(n) {
  return Hf().byBase.get(Ho(n)) || null;
}
function Ha(n, e) {
  return e && n.skins ? n.skins[e - 1] : n.c;
}
function pC(n, e = 120) {
  const t = n.toLowerCase().replace(/^:+|:+$/g, "").trim();
  if (!t) return [];
  const i = t.split(/\s+/), s = hC(), o = [];
  for (const r of Hf().all) {
    if (r.v > s) continue;
    let a = 0, l = !0;
    for (const d of i) {
      const c = Qee(r, d);
      if (!c) {
        l = !1;
        break;
      }
      a += c;
    }
    l && o.push({ e: r, score: a });
  }
  return o.sort((r, a) => a.score - r.score), o.slice(0, e).map((r) => r.e);
}
function Qee(n, e) {
  if (n.s.some((a) => a === e)) return 100;
  const t = n.n.toLowerCase();
  if (t === e) return 90;
  const i = (a) => e.length / Math.max(e.length, a.length), s = n.s.find((a) => a.startsWith(e));
  if (s) return 60 + 20 * i(s);
  if (t.startsWith(e)) return 50 + 20 * i(t);
  const o = t.split(/[\s:,-]+/).find((a) => a.startsWith(e));
  if (o) return 40 + 10 * i(o);
  const r = n.k.split(" ").find((a) => a.startsWith(e));
  return r ? 25 + 10 * i(r) : n.k.includes(e) ? 8 : 0;
}
const _y = "rd-board-emoji-recent", fC = "rd-board-emoji-tone", mC = 24;
function Zv() {
  try {
    const n = JSON.parse(localStorage.getItem(_y) || "[]");
    return Array.isArray(n) ? n.filter((e) => typeof e == "string").slice(0, mC) : [];
  } catch {
    return [];
  }
}
function ef(n) {
  const e = [n, ...Zv().filter((t) => Ho(t) !== Ho(n))].slice(0, mC);
  try {
    localStorage.setItem(_y, JSON.stringify(e));
  } catch {
  }
}
function ete() {
  try {
    localStorage.removeItem(_y);
  } catch {
  }
}
function Qv() {
  try {
    const n = Number(localStorage.getItem(fC));
    return n >= 0 && n <= 5 ? n : 0;
  } catch {
    return 0;
  }
}
function tte(n) {
  try {
    localStorage.setItem(fC, String(n));
  } catch {
  }
}
function nte(n) {
  return Array.from(Ho(n)).map((e) => e.codePointAt(0).toString(16)).join("-");
}
function ite(n) {
  const e = n.split("-").map((i) => String.fromCodePoint(parseInt(i, 16) || 63)).join(""), t = ky(e);
  return t ? Ho(t.c) === e ? t.c : (t.skins || []).find((i) => Ho(i) === e) || e : e;
}
function ste(n) {
  const e = n.trim();
  if (!e || e.length > 40) return !1;
  const i = (typeof Intl != "undefined" && "Segmenter" in Intl ? Array.from(new Intl.Segmenter(void 0, { granularity: "grapheme" }).segment(e)).map((s) => s.segment) : Array.from(e)).filter((s) => s.trim());
  return i.length > 0 && i.length <= 3 && i.every((s) => !!ky(s) || /[\u{1F000}-\u{1FAFF}]/u.test(s));
}
const ote = 280, $g = 5e3;
function eh(n, e, t, i = 0) {
  return n.markedUnread.includes(t) ? !0 : e0(n, e, t, i) > 0;
}
function e0(n, e, t, i = 0) {
  const s = Math.max(n.readBy[t] || 0, i);
  let o = 0;
  for (const r of e) r.authorId !== t && r.createdAt > s && o++;
  return o;
}
function es(n, e) {
  return n.markedUnread.includes(e) ? !0 : n.lastBy !== e && n.lastAt > (n.readBy[e] || 0);
}
function rte(n, e) {
  return n.some((t) => t.mentions.some((i) => i.uid === e));
}
function F2(n, e, t) {
  return n.createdBy === t || e.some((i) => i.authorId === t);
}
function N2(n, e) {
  if (e && n.elementId && e.id === n.elementId) {
    const t = qe(e);
    return { x: t.x + tf(n.ex) * t.w, y: t.y + tf(n.ey) * t.h };
  }
  return { x: n.x, y: n.y };
}
function tf(n) {
  return Number.isFinite(n) ? Math.min(1, Math.max(0, n)) : 0;
}
function Dg(n, e, t) {
  if (!t || t.type === "studio") return { x: n, y: e, elementId: null, ex: 0, ey: 0, label: "", thumb: null };
  const i = qe(t);
  return {
    x: n,
    y: e,
    elementId: t.id,
    ex: i.w ? tf((n - i.x) / i.w) : 0,
    ey: i.h ? tf((e - i.y) / i.h) : 0,
    label: ate(t),
    thumb: t.type === "image" ? t.src || null : t.type === "tool" && (t.thumbs || [])[0] || null
  };
}
function ate(n) {
  switch (n.type) {
    case "image": {
      const e = n;
      return La(e.label || (e.video ? "Video" : "Image"), 80);
    }
    case "note":
      return La(n.text.replace(/\s+/g, " ").trim() || "Note", 80);
    case "tool":
      return La(n.name || "Session", 80);
    case "frame":
      return La(n.title || "Frame", 80);
    case "shape":
      return "Shape";
    case "chat":
      return La(n.name || "Chat", 80);
    default:
      return "";
  }
}
function lte(n) {
  return n ? n.type === "image" ? n.video ? "video" : "image" : n.type === "studio" ? "canvas" : n.type : "canvas";
}
const U2 = /\b(?:https?:\/\/|www\.)[^\s<>"']+[^\s<>"'.,;:!?)\]}]/gi;
function dte(n, e, t) {
  const i = [], s = (d, c) => i.some((u) => d < u.end && c > u.start), o = e.slice().sort((d, c) => c.name.length - d.name.length);
  for (const d of o) {
    if (!d.name) continue;
    const c = "@" + d.name;
    let u = n.indexOf(c);
    for (; u !== -1; ) {
      const p = u + c.length;
      s(u, p) || i.push({ start: u, end: p, part: { kind: "mention", text: c, uid: d.uid, me: d.uid === t } }), u = n.indexOf(c, p);
    }
  }
  U2.lastIndex = 0;
  let r;
  for (; r = U2.exec(n); ) {
    const d = r.index, c = d + r[0].length;
    if (s(d, c)) continue;
    const u = /^https?:/i.test(r[0]) ? r[0] : "https://" + r[0];
    i.push({ start: d, end: c, part: { kind: "link", text: r[0], href: u } });
  }
  i.sort((d, c) => d.start - c.start);
  const a = [];
  let l = 0;
  for (const d of i)
    d.start > l && a.push({ kind: "text", text: n.slice(l, d.start) }), a.push(d.part), l = d.end;
  return l < n.length && a.push({ kind: "text", text: n.slice(l) }), a;
}
const gC = 50;
function Og(n, e) {
  const t = /* @__PURE__ */ new Set(), i = [];
  for (const s of e) {
    if (i.length >= gC) break;
    t.has(s.uid) || !s.name || !n.includes("@" + s.name) || (t.add(s.uid), i.push({ uid: s.uid, name: s.name }));
  }
  return i;
}
function cte(n, e) {
  const t = n.slice(0, e), i = t.lastIndexOf("@");
  if (i === -1 || i > 0 && /[\w.]/.test(t.charAt(i - 1))) return null;
  const s = t.slice(i + 1);
  return s.length > 30 || /[\n@]/.test(s) || /\s{2}/.test(s) ? null : { start: i, query: s };
}
function ute(n, e) {
  const t = /(^|[\s(])(:[a-z0-9_+-]{2,30})$/i.exec(n.slice(0, e));
  return t ? { start: e - t[2].length, query: t[2].slice(1) } : null;
}
function La(n, e) {
  const t = String(n || "");
  return t.length > e ? t.slice(0, e - 1).trimEnd() + "…" : t;
}
function op(n) {
  return { by: n.authorId, byName: n.authorName, text: La(n.text.replace(/\s+/g, " ").trim(), ote) };
}
function hte(n, e) {
  const t = /* @__PURE__ */ new Map();
  let i = 0;
  const s = /* @__PURE__ */ new Map();
  for (const [o, r] of Object.entries(n.reactions || {}))
    if (Array.isArray(r))
      for (const a of r) {
        let l = t.get(a);
        l || (l = { key: a, emoji: ite(a), count: 0, mine: !1, who: [] }, t.set(a, l), s.set(a, i++)), !l.who.includes(o) && (l.who.push(o), l.count++, o === e && (l.mine = !0));
      }
  return Array.from(t.values()).sort((o, r) => r.count - o.count || s.get(o.key) - s.get(r.key));
}
function oc(n) {
  const t = String(n || "").split("@")[0].split("+")[0].split(/[._-]+/).filter(Boolean);
  return t.length ? t.map((i) => i.charAt(0).toUpperCase() + i.slice(1)).join(" ") : n || "Someone";
}
function pte(n, e, t) {
  const i = e.trim().toLowerCase(), s = n.map((o, r) => {
    const a = o.name.toLowerCase(), l = o.email.toLowerCase();
    let d = 0;
    return i ? a.startsWith(i) ? d = 4 : a.split(/\s+/).some((c) => c.startsWith(i)) ? d = 3 : l.startsWith(i) ? d = 2 : (a.includes(i) || l.includes(i)) && (d = 1) : d = 1, { p: o, i: r, score: d && (o.uid === t ? d - 0.5 : d) };
  }).filter((o) => o.score > 0);
  return s.sort((o, r) => r.score - o.score || o.i - r.i), s.map((o) => o.p);
}
const G2 = [
  ["#9968df", "#5a61ed"],
  ["#c750ce", "#9968df"],
  ["#3db4e6", "#5a61ed"],
  ["#34c79a", "#2a8fd6"],
  ["#f2a93b", "#ef5f7a"],
  ["#ef5f7a", "#c750ce"],
  ["#7a86ff", "#3db4e6"],
  ["#5fd0b5", "#9968df"]
];
function fte(n) {
  let e = 0;
  for (let t = 0; t < n.length; t++) e = e * 31 + n.charCodeAt(t) | 0;
  return G2[Math.abs(e) % G2.length];
}
function mte(n, e, t) {
  const i = t.toLowerCase().split(/\s+/).filter(Boolean);
  if (!i.length) return !0;
  const s = [n.anchorLabel, n.createdByName, ...e.map((o) => o.authorName + " " + o.text)].join(" ").toLowerCase();
  return i.every((o) => s.includes(o));
}
var gte = Object.defineProperty, bte = (n, e, t) => e in n ? gte(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, zt = (n, e, t) => bte(n, typeof e != "symbol" ? e + "" : e, t);
const bC = "rd-board-comments", vte = 6500;
function yte() {
  try {
    const n = JSON.parse(localStorage.getItem(bC) || "{}");
    return { showPins: n.showPins !== !1, showResolved: n.showResolved === !0, elsewhereUnread: n.elsewhereUnread !== !1 };
  } catch {
    return { showPins: !0, showResolved: !1, elsewhereUnread: !0 };
  }
}
class xte {
  constructor(e, t) {
    zt(this, "board", e), zt(this, "opts", t), zt(this, "ui"), zt(this, "rev", /* @__PURE__ */ We(0)), zt(this, "loaded", /* @__PURE__ */ We(!1)), zt(this, "failed", /* @__PURE__ */ We(!1)), zt(this, "people", /* @__PURE__ */ We({ people: [], scope: "personal" })), zt(this, "followed", /* @__PURE__ */ We([])), zt(this, "titles", /* @__PURE__ */ We({})), zt(this, "enabled"), zt(this, "pins"), zt(this, "feed"), zt(this, "unreadCount"), zt(this, "elsewhere"), zt(this, "elsewhereUnread"), zt(this, "openCards"), zt(this, "threads", /* @__PURE__ */ new Map()), zt(this, "comments", /* @__PURE__ */ new Map()), zt(this, "byThread", /* @__PURE__ */ new Map()), zt(this, "hidden", /* @__PURE__ */ We(/* @__PURE__ */ new Set())), zt(this, "pending", /* @__PURE__ */ new Map()), zt(this, "since", 0), zt(this, "initial"), zt(this, "unsubs", []), zt(this, "readTimer", 0), zt(this, "goneFor", /* @__PURE__ */ new Set()), zt(this, "marked", /* @__PURE__ */ new Set()), zt(this, "disposed", !1), zt(this, "store"), this.store = t.store, this.enabled = !!t.store, this.initial = t.initial || null;
    const i = yte();
    this.ui = /* @__PURE__ */ Xt({
      armed: !1,
      draft: null,
      openId: null,
      panelOpen: !1,
      tab: "board",
      filter: "all",
      query: "",
      showPins: i.showPins,
      showResolved: i.showResolved,
      elsewhereUnread: i.elsewhereUnread,
      flash: null,
      editingId: null,
      dragging: null
    }), $e(() => [this.ui.showPins, this.ui.showResolved, this.ui.elsewhereUnread], () => {
      try {
        localStorage.setItem(bC, JSON.stringify({ showPins: this.ui.showPins, showResolved: this.ui.showResolved, elsewhereUnread: this.ui.elsewhereUnread }));
      } catch {
      }
    }), $e(() => this.ui.armed, (s) => {
      s && (e.ui.shapeArmed = !1, e.ui.eyedropper = null, e.ui.mode = "select");
    }), $e(() => e.ui.shapeArmed || e.ui.mode === "hand" || !!e.ui.eyedropper, (s) => {
      s && (this.ui.armed = !1);
    }), $e(() => [this.ui.openId, this.rev.value], () => this.readOpenSoon()), $e(() => this.ui.panelOpen, (s) => {
      s && (e.ui.boardHistory = !1);
    }), $e(() => e.ui.boardHistory, (s) => {
      s && (this.ui.panelOpen = !1);
    }), this.pins = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid, r = [];
      for (const a of this.threads.values()) {
        if (s.has(a.id) || this.gone(a)) continue;
        const l = this.ui.openId === a.id;
        if (a.resolvedAt && !this.ui.showResolved && !l) continue;
        const c = (this.ui.dragging && this.ui.dragging.id === a.id ? this.ui.dragging : null) || N2(a, a.elementId ? e.store.get(a.elementId) : null), u = this.commentsOf(a.id);
        r.push({ t: a, x: c.x, y: c.y, unread: !a.resolvedAt && eh(a, u, o, this.since), count: u.length });
      }
      return r.sort((a, l) => a.t.lastAt - l.t.lastAt), r;
    }), this.feed = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid, r = [];
      for (const a of this.threads.values()) {
        if (s.has(a.id) || this.gone(a)) continue;
        const l = this.commentsOf(a.id), d = eh(a, l, o, this.since), c = {
          t: a,
          first: l[0] || null,
          last: l[l.length - 1] || null,
          replies: Math.max(0, l.length - 1),
          fresh: e0(a, l, o, this.since),
          unread: d,
          pinned: a.pinnedBy.includes(o),
          mentionsMe: rte(l, o)
        };
        a.resolvedAt && !this.ui.showResolved || this.ui.filter === "unread" && !d || this.ui.filter === "mentions" && !c.mentionsMe && !(F2(a, l, o) && c.fresh) || this.ui.filter === "mine" && !F2(a, l, o) || this.ui.query && !mte(a, l, this.ui.query) || r.push(c);
      }
      return r.sort((a, l) => Number(l.pinned) - Number(a.pinned) || l.t.lastAt - a.t.lastAt), r;
    }), this.unreadCount = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid;
      let r = 0;
      for (const a of this.threads.values())
        s.has(a.id) || a.resolvedAt || this.gone(a) || eh(a, this.commentsOf(a.id), o, this.since) && r++;
      return r;
    }), this.elsewhere = I(() => {
      const s = e.user.uid, o = this.titles.value, r = /* @__PURE__ */ new Map();
      for (const a of this.followed.value) {
        if (a.boardId === e.meta.id || o[a.boardId] === null || a.deletedAt || this.ui.elsewhereUnread && !es(a, s)) continue;
        let l = r.get(a.boardId);
        l || (l = { boardId: a.boardId, title: o[a.boardId] || a.boardTitle || "Untitled board", items: [] }, r.set(a.boardId, l)), l.items.push(a);
      }
      return Array.from(r.values());
    }), this.elsewhereUnread = I(() => {
      const s = e.user.uid, o = this.titles.value;
      return this.followed.value.filter((r) => r.boardId !== e.meta.id && o[r.boardId] !== null && !r.deletedAt && es(r, s)).length;
    }), this.openCards = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid, r = [];
      for (const a of this.threads.values()) {
        if (s.has(a.id) || this.gone(a)) continue;
        const l = this.ui.openId === a.id;
        !l && (!this.ui.showPins || a.resolvedAt && !this.ui.showResolved) || (l || a.pinnedBy.includes(o)) && r.push(a);
      }
      return r;
    });
  }
  // ---------------------------------------------------------------- loading
  /** Start listening, once the board has loaded (its title and team are known). */
  start() {
    const e = this.store;
    !e || this.disposed || (this.unsubs.push(e.watchBoard({
      threads: (t, i) => {
        for (const s of t) this.threads.set(s.id, s);
        this.markGone(t);
        for (const s of i)
          this.threads.delete(s), this.ui.openId === s && (this.ui.openId = null);
        this.bump(), this.loaded.value || (this.loaded.value = !0, this.openInitial());
      },
      comments: (t, i) => {
        const s = /* @__PURE__ */ new Set();
        for (const o of t) {
          const r = this.comments.get(o.id);
          r && r.threadId !== o.threadId && s.add(r.threadId), this.comments.set(o.id, o), s.add(o.threadId);
        }
        for (const o of i) {
          const r = this.comments.get(o);
          r && s.add(r.threadId), this.comments.delete(o), this.ui.editingId === o && (this.ui.editingId = null);
        }
        for (const o of s) this.reindex(o);
        this.bump();
      },
      error: (t) => {
        console.warn("[board] comments are unavailable", t), this.failed.value = !0, this.loaded.value = !0;
      }
    })), this.unsubs.push(e.watchFollowed((t) => {
      this.followed.value = t, this.fetchTitles(t);
    }, (t) => console.warn("[board] comments on other boards are unavailable", t))), e.checkIn().then((t) => {
      t && !this.disposed && (this.since = t, this.bump());
    }).catch((t) => console.warn("[board] comments: could not check in", t)), this.refreshPeople(), window.setTimeout(() => {
      !this.loaded.value && !this.disposed && (this.loaded.value = !0, this.openInitial());
    }, 4e3));
  }
  refreshPeople() {
    this.store && this.store.people().then((e) => {
      if (this.disposed) return;
      const t = /* @__PURE__ */ new Map();
      for (const s of this.comments.values()) t.set(s.authorId, s.authorName);
      const i = e.people.map((s) => ({ ...s, name: t.get(s.uid) || s.name || oc(s.email) }));
      this.people.value = { ...e, people: i };
    }).catch((e) => console.warn("[board] comments: who can be mentioned is unknown", e));
  }
  fetchTitles(e) {
    if (!this.store) return;
    const t = this.titles.value, i = Array.from(new Set(e.map((s) => s.boardId))).filter((s) => s !== this.board.meta.id && !(s in t));
    i.length && this.store.boardTitles(i).then((s) => {
      this.disposed || (this.titles.value = { ...this.titles.value, ...s });
    }).catch(() => {
    });
  }
  openInitial() {
    const e = this.initial;
    e && (this.initial = null, window.setTimeout(() => {
      this.disposed || (this.threads.has(e) ? this.focus(e) : this.board.toast("That comment was deleted, or it's on a board you can't open.", "error"), this.opts.onShown && this.opts.onShown());
    }, 350));
  }
  reindex(e) {
    const t = [];
    for (const i of this.comments.values()) i.threadId === e && t.push(i);
    t.sort((i, s) => i.createdAt - s.createdAt || (i.id < s.id ? -1 : 1)), t.length ? this.byThread.set(e, t) : this.byThread.delete(e);
  }
  bump() {
    this.rev.value++;
  }
  // ---------------------------------------------------------------- reading
  /** Your name as your comments carry it (an account without one goes by its email's). */
  get myName() {
    const e = this.board.user;
    return e.name || oc(e.email);
  }
  thread(e) {
    return this.rev.value, e && !this.hidden.value.has(e) && this.threads.get(e) || null;
  }
  /** A thread's comments, oldest first, less any deleted here and waiting out their Undo. */
  commentsOf(e) {
    this.rev.value;
    const t = this.byThread.get(e) || [], i = this.hidden.value;
    return i.size ? t.filter((s) => !i.has(s.id)) : t;
  }
  allThreads() {
    this.rev.value;
    const e = this.hidden.value;
    return Array.from(this.threads.values()).filter((t) => !e.has(t.id) && !t.deletedAt);
  }
  isUnread(e) {
    return eh(e, this.commentsOf(e.id), this.board.user.uid, this.since);
  }
  /** A comment that's news to you: someone else's, since you last read its thread (and since you first opened the board). */
  isFresh(e, t) {
    const i = this.board.user.uid;
    return t.authorId !== i && t.createdAt > Math.max(e.readBy[i] || 0, e.boardId === this.board.meta.id ? this.since : 0);
  }
  /** A thread on another board, read whole (Everywhere else's expanded card). */
  commentsElsewhere(e) {
    return this.store ? this.store.threadComments(e.boardId, e.id) : Promise.resolve([]);
  }
  freshIn(e) {
    return e0(e, this.commentsOf(e.id), this.board.user.uid, this.since);
  }
  following(e) {
    return e.followers.includes(this.board.user.uid);
  }
  pinned(e) {
    return e.pinnedBy.includes(this.board.user.uid);
  }
  /** You may delete it: you started it, or it's your board. */
  canDelete(e) {
    const t = this.board.user.uid;
    return e.createdBy === t || this.board.meta.ownerId === t;
  }
  /** You may delete this comment: it's yours, or the thread or the board is. */
  canDeleteComment(e) {
    const t = this.board.user.uid, i = this.threads.get(e.threadId);
    return e.authorId === t || !!i && i.createdBy === t || this.board.meta.ownerId === t;
  }
  /** Where a thread's pin is now (world). */
  pointOf(e) {
    this.board.docRev.value;
    const t = this.ui.dragging;
    return t && t.id === e.id ? { x: t.x, y: t.y } : N2(e, e.elementId ? this.board.store.get(e.elementId) : null);
  }
  /** The element a thread is on, while it's on the board. */
  elementOf(e) {
    return this.board.docRev.value, e.elementId && this.board.store.get(e.elementId) || null;
  }
  /** People who can be mentioned, with anyone who has commented here. */
  mentionable() {
    this.rev.value;
    const e = this.people.value.people.slice(), t = new Set(e.map((i) => i.uid));
    for (const i of this.comments.values())
      t.has(i.authorId) || (t.add(i.authorId), e.push({ uid: i.authorId, name: i.authorName, email: i.authorEmail }));
    return e;
  }
  // ---------------------------------------------------------------- the tool
  arm(e = !this.ui.armed) {
    this.ui.armed = e, e && (this.board.ui.selection = [], this.ui.showPins || (this.ui.showPins = !0));
  }
  /** The topmost element at a world point, notes and sessions first (they sit over the canvas). */
  elementAt(e, t) {
    const i = 2 / Math.max(0.01, this.board.cam.value.zoom);
    let s = null, o = -1 / 0;
    const r = { frames: 1, content: 2, annotations: 3 };
    for (const a of this.board.store.index.queryPoint(e, t, i)) {
      const l = this.board.store.get(a);
      if (!l || l.type === "studio") continue;
      const d = qe(l);
      if (e < d.x - i || t < d.y - i || e > d.x + d.w + i || t > d.y + d.h + i) continue;
      const c = (l.type === "note" || l.type === "tool" ? 4 : r[nv[l.type]]) * 1e9 + l.z;
      c > o && (o = c, s = l);
    }
    return s;
  }
  /** The Comment tool's click: a draft thread there (a draft with words in it stays, and nods). */
  placeAt(e, t) {
    const i = this.board, s = this.ui.draft;
    if (s && s.text.trim()) {
      s.n++;
      return;
    }
    const o = i.screenToWorld(e, t);
    this.ui.openId = null, this.ui.draft = { anchor: Dg(o.x, o.y, this.elementAt(o.x, o.y)), text: "", mentions: [], n: 0 };
  }
  /** A draft on an element, from its toolbar: at its top right corner. */
  draftOn(e) {
    const t = qe(e);
    this.ui.armed = !1, this.ui.openId = null, this.ui.draft = { anchor: Dg(t.x + t.w, t.y, e), text: "", mentions: [], n: 0 };
    const i = this.board.cam.value.zoom, s = this.board.view, o = this.board.worldToClient(t.x + t.w, t.y);
    (o.x < s.left + 40 || o.y < s.top + 30 || o.x > s.left + s.w - 380 || o.y > s.top + s.h - 220) && this.board.jumpTo(t.x + t.w + 170 / i, t.y + 90 / i);
  }
  cancelDraft() {
    this.ui.draft = null;
  }
  /** Post the draft as a new thread. */
  async post(e, t) {
    const i = this.ui.draft, s = this.store, o = e.trim().slice(0, $g);
    if (!i || !s || !o) return !1;
    const r = this.board, a = r.user, l = Og(o, t), d = kt(), c = Date.now(), u = {
      id: kt(),
      threadId: d,
      boardId: r.meta.id,
      authorId: a.uid,
      authorName: this.myName,
      authorEmail: a.email,
      text: o,
      mentions: l,
      createdAt: c,
      editedAt: null,
      reactions: {}
    }, p = i.anchor, f = {
      id: d,
      boardId: r.meta.id,
      teamId: r.meta.teamId || null,
      createdBy: a.uid,
      createdByName: u.authorName,
      createdByEmail: a.email,
      createdAt: c,
      x: p.x,
      y: p.y,
      elementId: p.elementId,
      ex: p.ex,
      ey: p.ey,
      anchorLabel: p.label,
      anchorThumb: p.thumb,
      color: "amethyst",
      resolvedAt: null,
      resolvedBy: null,
      followers: [a.uid, ...l.map((y) => y.uid).filter((y) => y !== a.uid)].slice(0, 300),
      readBy: { [a.uid]: c },
      markedUnread: [],
      pinnedBy: [],
      lastAt: c,
      lastBy: a.uid,
      count: 1,
      preview: op(u),
      boardTitle: r.meta.title
    };
    this.ui.draft = null, this.ui.openId = d;
    try {
      return await s.createThread(f, u), !0;
    } catch (y) {
      return this.fail("Your comment couldn't be posted", y), this.ui.openId = null, this.ui.draft = { anchor: p, text: o, mentions: l, n: 0 }, !1;
    }
  }
  // ---------------------------------------------------------------- threads
  /** Open a thread's card. */
  open(e) {
    this.ui.draft = null, this.ui.editingId = null, this.ui.openId = e;
  }
  close() {
    this.ui.openId = null, this.ui.editingId = null;
  }
  /** Fly to a thread, open it, and draw the eye to its pin. */
  focus(e) {
    const t = this.threads.get(e);
    if (!t) return;
    const i = this.board;
    if (t.deletedAt) {
      i.toast("This comment was deleted along with the item it was on.");
      return;
    }
    if (this.gone(t)) {
      i.toast("The item this comment is on was deleted. Recover it from Recently Deleted to see the comment.");
      return;
    }
    this.ui.draft = null, this.ui.openId = e, this.ui.showPins || (this.ui.showPins = !0);
    const s = this.pointOf(t), o = this.elementOf(t), r = i.cam.value;
    let a = Math.min(1.2, Math.max(r.zoom, 0.7));
    if (o) {
      const u = qe(o), p = Math.min((i.view.w - this.rightInset() - 460) / u.w, (i.view.h - 220) / u.h);
      p > 0 && (a = Math.min(a, Math.max(0.35, p)));
    }
    const l = i.view.w - this.rightInset(), d = Math.max(140, l / 2 - 150), c = i.view.h / 2 - 40;
    i.engine && i.engine.animateCamera({ zoom: a, x: d - s.x * a, y: c - s.y * a }, 460), this.ui.flash = { id: e, n: (this.ui.flash ? this.ui.flash.n : 0) + 1 };
  }
  /** The width the Updates panel (or the history beside the rail) covers on the right. */
  rightInset() {
    return this.ui.panelOpen || this.board.ui.boardHistory ? 412 : 72;
  }
  /** The thread before or after the open one, in the panel's order (or the board's newest first). */
  step(e) {
    const t = this.order();
    if (!t.length) return;
    const i = this.ui.openId ? t.indexOf(this.ui.openId) : -1, s = t[(i + e + t.length) % t.length];
    s && this.focus(s);
  }
  /** Where the open thread is among those you can step through: "2 of 7". */
  position() {
    const e = this.order(), t = this.ui.openId ? e.indexOf(this.ui.openId) : -1;
    return t === -1 ? null : { at: t + 1, of: e.length };
  }
  order() {
    return this.ui.panelOpen && this.ui.tab === "board" ? this.feed.value.map((e) => e.t.id) : this.allThreads().filter((e) => !e.resolvedAt || this.ui.showResolved || e.id === this.ui.openId).sort((e, t) => t.lastAt - e.lastAt).map((e) => e.id);
  }
  async reply(e, t, i) {
    const s = this.threads.get(e), o = this.store, r = t.trim().slice(0, $g);
    if (!s || !o || !r) return !1;
    const a = this.board.user, l = Og(r, i), d = {
      id: kt(),
      threadId: e,
      boardId: s.boardId,
      authorId: a.uid,
      authorName: this.myName,
      authorEmail: a.email,
      text: r,
      mentions: l,
      createdAt: Date.now(),
      editedAt: null,
      reactions: {}
    };
    try {
      return await o.reply(s, d, l.map((c) => c.uid).filter((c) => c !== a.uid)), s.resolvedAt && this.board.toast("Reopened with your reply"), !0;
    } catch (c) {
      return this.fail("Your reply couldn't be posted", c), !1;
    }
  }
  async edit(e, t, i) {
    const s = this.comments.get(e), o = this.store, r = t.trim().slice(0, $g);
    if (!s || !o || !r) return !1;
    if (r === s.text)
      return this.ui.editingId = null, !0;
    const a = Og(r, i), l = new Set(s.mentions.map((f) => f.uid)), d = a.map((f) => f.uid).filter((f) => !l.has(f) && f !== this.board.user.uid), c = this.commentsOf(s.threadId), u = c[c.length - 1], p = { ...s, text: r, mentions: a };
    this.ui.editingId = null;
    try {
      return await o.editComment(p, u && u.id === s.id ? op(p) : null, d), !0;
    } catch (f) {
      return this.fail("Your edit couldn't be saved", f), !1;
    }
  }
  /** Delete one comment; the first one takes its thread with it. Undo for a few seconds. */
  deleteComment(e) {
    const t = this.comments.get(e);
    if (!t) return;
    const i = this.commentsOf(t.threadId);
    if (i[0] && i[0].id === t.id) {
      this.deleteThread(t.threadId);
      return;
    }
    const s = i.filter((r) => r.id !== t.id), o = s[s.length - 1];
    this.ui.editingId = null, this.later(t.id, "Comment deleted", () => {
      this.store && this.store.deleteComment(t, s.length, o ? op(o) : null).catch((r) => this.fail("The comment couldn't be deleted", r));
    });
  }
  /**
   * On something no longer on the board: deleted with it (ADMIN-001), so
   * hidden while it waits in Recently Deleted. Undo or Recover puts the
   * element back, and the thread with it; deleting it for good marks the
   * thread deleted (deleteWith), which hides it everywhere.
   */
  gone(e) {
    return !!e.deletedAt || !!e.elementId && !this.board.store.get(e.elementId);
  }
  /**
   * Elements deleted for good: their threads are marked deleted with them,
   * whoever started them (a soft delete: each stays, with its comments,
   * hidden on this board and in everyone's Everywhere else).
   */
  deleteWith(e) {
    if (!(!this.store || !e.length)) {
      for (const t of e) this.goneFor.add(t);
      this.markGone(Array.from(this.threads.values()));
    }
  }
  /** Mark deleted the threads among these on an item deleted for good this visit, each once. */
  markGone(e) {
    const t = this.store;
    if (!(!t || !this.goneFor.size))
      for (const i of e)
        !i.elementId || !this.goneFor.has(i.elementId) || i.deletedAt || this.marked.has(i.id) || (this.marked.add(i.id), t.markDeleted(i.id).catch((s) => this.fail("The thread couldn't be deleted", s)));
  }
  /** Delete a thread and everything in it. Undo for a few seconds. */
  deleteThread(e) {
    if (!this.threads.get(e)) return;
    this.ui.openId === e && (this.ui.openId = null);
    const i = (this.byThread.get(e) || []).map((s) => s.id);
    this.later(e, "Thread deleted", () => {
      this.store && this.store.deleteThread(e, i).catch((s) => this.fail("The thread couldn't be deleted", s));
    });
  }
  /** Hide something now and send its delete once its Undo has passed (or the page is leaving). */
  later(e, t, i) {
    const s = new Set(this.hidden.value);
    s.add(e), this.hidden.value = s;
    const o = window.setTimeout(() => this.commit(e), vte);
    this.pending.set(e, { timer: o, send: i }), this.board.toast(t, "info", {
      label: "Undo",
      run: () => {
        const r = this.pending.get(e);
        if (!r) return;
        clearTimeout(r.timer), this.pending.delete(e);
        const a = new Set(this.hidden.value);
        a.delete(e), this.hidden.value = a, this.board.dismissToast();
      }
    });
  }
  commit(e) {
    const t = this.pending.get(e);
    t && (clearTimeout(t.timer), this.pending.delete(e), t.send());
  }
  /** Send every delete still waiting (the board is closing). */
  flush() {
    for (const e of Array.from(this.pending.keys())) this.commit(e);
  }
  async react(e, t) {
    const i = this.comments.get(e);
    if (!i || !this.store) return;
    const s = nte(t), o = !(i.reactions[this.board.user.uid] || []).includes(s);
    o && ef(t);
    try {
      await this.store.react(i, s, o);
    } catch (r) {
      this.fail("Your reaction couldn't be saved", r);
    }
  }
  async resolve(e, t) {
    if (!(!this.threads.get(e) || !this.store)) {
      try {
        await this.store.resolve(e, t);
      } catch (s) {
        this.fail(t ? "The thread couldn't be resolved" : "The thread couldn't be reopened", s);
        return;
      }
      t && (this.ui.openId === e && !this.ui.showResolved && (this.ui.openId = null), this.board.toast("Resolved", "info", { label: "Undo", run: () => {
        this.resolve(e, !1), this.board.dismissToast();
      } }));
    }
  }
  setColor(e, t) {
    this.store && this.store.setColor(e, t).catch((i) => this.fail("The colour couldn't be saved", i));
  }
  /** A pin dropped at a world point: on the element there, if any. */
  moveTo(e, t, i) {
    this.store && this.store.move(e, Dg(t, i, this.elementAt(t, i))).catch((s) => this.fail("The comment couldn't be moved", s));
  }
  follow(e, t) {
    this.store && (this.store.follow(e.id, t, e.boardId).catch((i) => this.fail("Couldn't change following", i)), this.board.toast(t ? "Following: replies show in your Updates" : "Unfollowed: you'll hear of it only if you're mentioned"));
  }
  pin(e, t) {
    this.store && (this.store.pin(e, t).catch((i) => this.fail("Couldn't change your pin", i)), t && this.board.toast("Pinned for you: it stays open on the board and first in Updates. Only you see your pins."));
  }
  markRead(e) {
    !this.store || !e.length || this.store.markRead(e.map((t) => ({ id: t.id, boardId: t.boardId }))).catch((t) => this.fail("Couldn't mark it read", t));
  }
  markUnread(e) {
    this.store && (this.ui.openId === e.id && (this.ui.openId = null), this.store.markUnread(e.id, e.boardId).catch((t) => this.fail("Couldn't mark it unread", t)));
  }
  /** Every unread thread on this board, read. */
  markAllRead() {
    this.markRead(this.allThreads().filter((e) => this.isUnread(e)));
  }
  markAllReadElsewhere(e) {
    const t = this.board.user.uid;
    this.markRead(this.followed.value.filter((i) => i.boardId !== this.board.meta.id && (!e || i.boardId === e) && es(i, t)));
  }
  /** The open thread, read once it's been open a moment. */
  readOpenSoon() {
    clearTimeout(this.readTimer);
    const e = this.ui.openId;
    e && (this.readTimer = window.setTimeout(() => {
      const t = this.thread(e);
      t && this.ui.openId === e && this.isUnread(t) && this.markRead([t]);
    }, 600));
  }
  async copyLink(e) {
    const t = this.opts.linkFor ? this.opts.linkFor(e.boardId, e.id) : location.origin + "/board/" + e.boardId + "?comment=" + e.id;
    try {
      await navigator.clipboard.writeText(t), this.board.toast("Link copied: it opens this board at this thread");
    } catch {
      this.board.toast("Couldn't copy the link", "error");
    }
  }
  /** A thread on another board (Everywhere else): open that board there. */
  openElsewhere(e) {
    if (e.boardId === this.board.meta.id) {
      this.focus(e.id);
      return;
    }
    this.opts.openAt && this.opts.openAt(e.boardId, e.id);
  }
  /** A comment's reactions with one emoji tried: the picker remembers it. */
  pick(e) {
    ef(e);
  }
  fail(e, t) {
    console.error("[board] " + e, t), this.board.toast(e + ". Please try again.", "error");
  }
  dispose() {
    this.disposed = !0, this.flush(), clearTimeout(this.readTimer);
    for (const e of this.unsubs) e();
    this.unsubs = [], this.store && this.store.dispose();
  }
}
var wte = Object.defineProperty, kte = (n, e, t) => e in n ? wte(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Ye = (n, e, t) => kte(n, typeof e != "symbol" ? e + "" : e, t);
const _te = 4e3, Ste = 12e4, Tte = 25e3, Mte = 120 * 1e3, Cte = 5e3, wl = { image: "Image", video: "Video", imageEdit: "Wand2", videoEdit: "Clapperboard", threed: "Box", upscale: "Maximize2" }, th = { w: 184, h: 184 }, Ite = 0.32, Ate = 0.36, Pte = 120, nh = { w: 720, h: 480 }, j2 = { w: 300, h: 200 };
let lr = null;
class nf {
  constructor(e) {
    Ye(this, "store", new FV()), Ye(this, "results", new bQ()), Ye(this, "ui", uQ()), Ye(this, "cam", /* @__PURE__ */ We({ x: 0, y: 0, zoom: 1 })), Ye(this, "view", /* @__PURE__ */ Xt({ w: 1, h: 1, left: 0, top: 52 })), Ye(this, "docRev", /* @__PURE__ */ We(0)), Ye(this, "meta", /* @__PURE__ */ Xt({
      id: "",
      title: "",
      /** who made the board: only they can rename it */
      ownerId: "",
      /** the team that owns it (and pays for its runs); null on a personal board */
      teamId: null,
      description: "",
      accessLevel: null
    })), Ye(this, "overlayIds", /* @__PURE__ */ We([])), Ye(this, "moving", /* @__PURE__ */ We(!1)), Ye(this, "far", /* @__PURE__ */ We(!1)), Ye(this, "guides", /* @__PURE__ */ We(null)), Ye(this, "stats", /* @__PURE__ */ We(null)), Ye(this, "loaded", /* @__PURE__ */ We(!1)), Ye(this, "loadError", /* @__PURE__ */ We(null)), Ye(this, "generating", /* @__PURE__ */ Xt({})), Ye(this, "runningSince", /* @__PURE__ */ Xt({})), Ye(this, "saveState"), Ye(this, "promptRev", /* @__PURE__ */ We(0)), Ye(this, "loadErrorKind", /* @__PURE__ */ We(null)), Ye(this, "trashRev", /* @__PURE__ */ We(0)), Ye(this, "recovering", /* @__PURE__ */ new Set()), Ye(this, "trash"), Ye(this, "user"), Ye(this, "catalog"), Ye(this, "companyModels", /* @__PURE__ */ We([])), Ye(this, "engine", null), Ye(this, "worldEl", null), Ye(this, "uploader", null), Ye(this, "onStep", null), Ye(this, "feedback", null), Ye(this, "cameraHooks", /* @__PURE__ */ new Set()), Ye(this, "styledZoom", 0), Ye(this, "opts"), Ye(this, "sync"), Ye(this, "gen"), Ye(this, "elRevs", /* @__PURE__ */ new Map()), Ye(this, "runs", /* @__PURE__ */ M5(/* @__PURE__ */ new Map())), Ye(this, "overlayArea", null), Ye(this, "unsubs", []), Ye(this, "pinsKept", { models: "unknown", sessions: "unknown" }), Ye(this, "viewsKept", "unknown"), Ye(this, "prefs"), Ye(this, "settleTimer", 0), Ye(this, "pasteCount", 0), Ye(this, "disposed", !1), Ye(this, "toastSeq", 0), Ye(this, "toastTimer", 0), Ye(this, "newThumbTimers", /* @__PURE__ */ new Map()), Ye(this, "prompts", /* @__PURE__ */ new Map()), Ye(this, "undecoded", /* @__PURE__ */ new Map()), Ye(this, "forgottenLibrary", []), Ye(this, "inflight", /* @__PURE__ */ new Map()), Ye(this, "started", /* @__PURE__ */ new Map()), Ye(this, "historyCursor", /* @__PURE__ */ new Map()), Ye(this, "boardCursor", null), Ye(this, "knownAssets", /* @__PURE__ */ new Map()), Ye(this, "recordReads", /* @__PURE__ */ new Map()), Ye(this, "readingRecords", /* @__PURE__ */ Xt({})), Ye(this, "studioRecords"), Ye(this, "pinnedImages"), Ye(this, "pinnedUrls"), Ye(this, "studioRuns", /* @__PURE__ */ new Map()), Ye(this, "studioFails", /* @__PURE__ */ new Map()), Ye(this, "promptTool"), Ye(this, "selectedEls"), Ye(this, "promptLibrary"), Ye(this, "comments"), Ye(this, "labels"), Ye(this, "tour", null), Ye(this, "agent"), Ye(this, "freshTools", /* @__PURE__ */ Xt(/* @__PURE__ */ new Set())), Ye(this, "balance", /* @__PURE__ */ We(null)), Ye(this, "teamActive", /* @__PURE__ */ We(null)), Ye(this, "trainedModelsSeen", /* @__PURE__ */ We(null)), this.opts = e, this.sync = e.sync, this.gen = e.gen, this.user = e.user, this.catalog = I(() => JQ(e.catalog.value, this.companyModels.value)), this.saveState = /* @__PURE__ */ We("saved"), this.meta.id = e.boardId, this.prefs = pQ(e.user.uid, e.boardId), this.ui.lightCanvas = this.prefs.lightCanvas, this.ui.shapeStyle = { ...qs, ...this.prefs.shapeStyle }, this.ui.shapeKind = this.prefs.shapeKind, this.ui.histOpen = this.prefs.histOpen, this.ui.miniOpen = this.prefs.miniOpen, this.ui.recentIds = this.prefs.recentIds.slice(), this.ui.pinnedIds = Array.isArray(this.prefs.pinnedIds) ? this.prefs.pinnedIds.filter((i) => typeof i == "string") : [], this.ui.pinnedModelIds = Array.isArray(this.prefs.pinnedModelIds) ? this.prefs.pinnedModelIds.filter((i) => typeof i == "string") : [], this.ui.cameraViews = V2(this.prefs.cameraViews), this.ui.noteTint = this.prefs.noteTint, this.ui.promptH = typeof this.prefs.promptH == "number" ? this.prefs.promptH : null, this.prefs.library && (this.ui.library.tab = this.prefs.library.tab === "mine" ? "mine" : "featured", this.ui.library.category = typeof this.prefs.library.category == "string" ? this.prefs.library.category : null, typeof this.prefs.library.saveBoard == "boolean" && (this.ui.library.saveLevels = { board: this.prefs.library.saveBoard, team: !!this.prefs.library.saveTeam })), this.labels = { team: e.labels && e.labels.team || "Team" }, this.agent = e.agent || null, this.promptLibrary = new Wee(this, e.featured || null, e.myPrompts || null), this.comments = new xte(this, e.comments || { store: null }), this.promptTool = I(() => {
      if (this.docRev.value, this.ui.selection.length !== 1 || this.ui.marquee) return null;
      const i = this.store.get(this.ui.selection[0]);
      return i && i.type === "tool" ? { ...i } : null;
    }), this.selectedEls = I(() => (this.docRev.value, this.ui.selection.map((i) => this.store.get(i)).filter(Boolean))), this.studioRecords = new see((i) => this.sync.commit(i), () => this.user.uid), this.pinnedImages = I(() => {
      this.studioRecords.rev.value;
      const i = /* @__PURE__ */ new Set();
      return this.studioRecords.all().filter((s) => s.role === "pin" && s.createdBy === this.user.uid).reverse().sort((s, o) => o.createdAt - s.createdAt).filter((s) => !i.has(s.url) && !!i.add(s.url));
    }), this.pinnedUrls = I(() => new Set(this.pinnedImages.value.map((i) => i.url))), $e(this.pinnedUrls, () => {
      this.overlayArea = null, this.updateOverlay();
    }), this.trash = I(() => (this.trashRev.value, this.docRev.value, this.loaded.value ? this.sync.trash().filter((i) => !Cs(i.el) || this.recoverableRecord(i.el)) : [])), this.unsubs.push(this.store.subscribe((i) => this.onDocChange(i)));
    const t = () => {
      const i = document.activeElement;
      i && i.blur && i.closest && i.closest(".bd-root") && i.blur(), this.comments.flush(), this.sync.flush().catch(() => {
      });
    };
    window.addEventListener("pagehide", t), this.unsubs.push(() => window.removeEventListener("pagehide", t)), $e(() => this.sync.status.value, (i) => {
      this.saveState.value = i;
    }), $e(() => this.promptTool.value ? this.promptTool.value.id : null, (i) => {
      this.ui.eyedropper && this.ui.eyedropper.sessionId !== i && (this.ui.eyedropper = null);
      const s = this.ui.library;
      s.open && i && s.sessionId !== i ? s.sessionId = i : s.open && !i && s.sessionId && this.promptLibrary.close(), i && (this.ui.recentIds = [i].concat(this.ui.recentIds.filter((o) => o !== i)).slice(0, 200), this.persistPrefs());
    }), $e(() => this.ui.selection.slice(), (i) => {
      this.engine && this.engine.setSelection(i);
    }), $e(() => this.ui.dragging, (i) => {
      this.engine && this.engine.setDragging(i);
    }), $e(() => !!(this.ui.studio || this.ui.infoAt || this.ui.libraryOpen || this.ui.trashOpen), (i) => {
      i && (this.ui.eyedropper = null);
    }), $e(() => this.ui.studio ? this.ui.studio.sessionId : null, (i) => {
      this.opts.onStudio && this.opts.onStudio(i);
    }, { flush: "sync" }), $e(() => (this.docRev.value, !!this.ui.eyedropper && !this.eyedropperField), (i) => {
      i && (this.ui.eyedropper = null);
    }), $e(() => this.ui.lightCanvas, (i) => {
      this.engine && this.engine.setTheme(i ? "light" : "dark"), this.persistPrefs();
    }), $e(() => [this.ui.histOpen, this.ui.miniOpen, this.ui.shapeKind, this.ui.noteTint, this.ui.shapeStyle.stroke, this.ui.shapeStyle.sw, this.ui.promptH, this.ui.library.tab, this.ui.library.category, this.ui.library.saveLevels.board, this.ui.library.saveLevels.team], () => this.persistPrefs());
  }
  // ----------------------------------------------------------- lifecycle
  async load() {
    var e;
    try {
      const t = await this.sync.load();
      if (this.disposed) return;
      this.meta.title = t.meta.title || "Untitled board", this.meta.ownerId = t.meta.ownerId || "", this.meta.teamId = t.meta.teamId || null, this.meta.description = t.meta.description || "", this.meta.accessLevel = t.meta.accessLevel || null, this.opts.onTitle && this.opts.onTitle(this.meta.title), this.results.upsert(t.results, !1);
      const i = [], s = [];
      for (const r of t.elements)
        Cs(r) ? i.push(r) : s.push(r);
      this.studioRecords.load(i), this.store.load(s), this.sweepStudioRecords(), this.sync.watch((r) => this.onRemote(r)), this.unsubs.push(this.results.onLocalChange((r) => this.sync.commitResults(r.filter((a) => a.status !== "pending")))), this.loaded.value = !0, this.startRealtime(), this.comments.start();
      const o = this.opts.initialStudio;
      o && ((e = this.store.get(o)) == null ? void 0 : e.type) === "tool" && this.restoreStudio(o);
    } catch (t) {
      if (this.disposed) return;
      console.error("[board] load failed", t), this.loadError.value = t instanceof Error && t.message || "This board could not be loaded.";
      const i = t && typeof t == "object" && "kind" in t ? String(t.kind) : null;
      this.loadErrorKind.value = i;
    }
  }
  /** Real boards: the board's runs, and your prompts, as they change. */
  startRealtime() {
    const e = this.opts.runs;
    e && e.watchRecent((a, l) => {
      for (const d of a) this.onRun(d);
      for (const d of l) this.onRunGone(d);
    }), this.opts.favorites && this.opts.favorites.start();
    const t = this.opts.pins;
    if (t) {
      for (const a of ["models", "sessions"])
        this.unsubs.push(t.watch(a, (l) => this.pinsFromAccount(a, l), () => {
          this.pinsKept[a] = "off";
        }));
      t.watchViews && this.unsubs.push(t.watchViews((a) => this.viewsFromAccount(a), () => {
        this.viewsKept = "off";
      }));
    }
    const i = this.opts.balance;
    i && this.unsubs.push(i.watch(this.meta.teamId || this.user.uid, (a) => {
      this.balance.value = a;
    }));
    const s = this.opts.teamStatus;
    s && this.meta.teamId && this.unsubs.push(s.watch(this.meta.teamId, (a) => {
      this.teamActive.value = a;
    }));
    const o = this.opts.companyTools;
    o && this.meta.teamId && o(this.meta.teamId).then((a) => {
      this.disposed || (this.companyModels.value = a);
    }).catch((a) => console.warn("[board] company tools unavailable", a));
    const r = this.opts.prompts;
    r && (r.start((a, l) => this.onSavedPrompt(a, l)).catch(() => {
    }), this.unsubs.push($e(this.catalog, () => {
      for (const [a, l] of Array.from(this.undecoded)) this.onSavedPrompt(a, l);
    })));
  }
  /** Called by BoardView once the stage is in the DOM. */
  async attach(e, t) {
    this.worldEl = t;
    const i = e.getBoundingClientRect();
    this.view.w = i.width, this.view.h = i.height, this.view.left = i.left, this.view.top = i.top;
    const s = new cQ({
      host: e,
      store: this.store,
      theme: this.ui.lightCanvas ? "light" : "dark",
      onCamera: (a, l) => this.onCamera(a, l),
      onStats: (a) => {
        this.ui.showStats && (this.stats.value = a);
      }
    });
    if (this.engine = s, await s.ready, this.disposed) return;
    s.setSelection(this.ui.selection), s.setPaused(!!this.ui.studio);
    const o = new ResizeObserver(() => {
      const a = e.getBoundingClientRect();
      this.view.w = a.width, this.view.h = a.height, this.view.left = a.left, this.view.top = a.top, this.overlayArea = null, this.updateOverlay();
    });
    o.observe(e), this.unsubs.push(() => o.disconnect());
    const r = this.opts.initialCamera || this.prefs.camera;
    r && Number.isFinite(r.zoom) ? s.setCamera(r) : this.fit(0), s.playEntrance(), this.updateOverlay();
  }
  dispose() {
    this.disposed = !0;
    for (const e of this.unsubs) e();
    this.unsubs = [];
    for (const e of this.runs.values()) e.cancel();
    this.runs.clear();
    for (const e of this.started.values())
      e.unwatch(), clearTimeout(e.timer);
    this.started.clear(), this.opts.runs && this.opts.runs.dispose(), this.opts.prompts && this.opts.prompts.dispose(), this.opts.favorites && this.opts.favorites.dispose(), this.promptLibrary.dispose(), this.comments.dispose(), clearTimeout(this.settleTimer), clearTimeout(this.toastTimer);
    for (const e of this.newThumbTimers.values()) clearTimeout(e);
    this.persistPrefs(), this.sync.dispose(), this.engine && this.engine.destroy(), this.engine = null;
  }
  // ------------------------------------------------------------ reactivity
  /** A per-element revision ref, for DOM-layer components. */
  rev(e) {
    let t = this.elRevs.get(e);
    return t || (t = /* @__PURE__ */ We(0), this.elRevs.set(e, t)), t;
  }
  releaseRev(e) {
    this.elRevs.delete(e);
  }
  bump(e) {
    const t = this.elRevs.get(e);
    t && (t.value++, os(t));
  }
  onDocChange(e) {
    for (const t of e.added) this.bump(t.id);
    for (const t of e.updated) this.bump(t.id);
    for (const t of e.removed) this.bump(t.id);
    for (const t of e.updated) {
      const i = t.el;
      if (i.type !== "image" || !i.resultId || !("fav" in t.after)) continue;
      const s = this.results.get(i.resultId);
      s && !!s.fav != !!i.fav && this.results.upsert([{ ...s, fav: i.fav || void 0 }], e.origin === "local");
    }
    if (e.removed.length) {
      const t = new Set(e.removed.map((i) => i.id));
      this.ui.selection.some((i) => t.has(i)) && (this.ui.selection = this.ui.selection.filter((i) => !t.has(i))), this.ui.infoAt && t.has(this.ui.infoAt) && (this.ui.infoAt = null), this.ui.editingNote && t.has(this.ui.editingNote) && (this.ui.editingNote = null);
    }
    this.docRev.value++, os(this.docRev), (e.added.length || e.removed.length) && (this.overlayArea = null), this.updateOverlay(), !e.ephemeral && e.origin !== "remote" && e.origin !== "load" && (this.sync.commit(e), (e.added.length || e.removed.length) && this.trashRev.value++);
  }
  onRemote(e) {
    if (e.meta) {
      const r = e.meta;
      if (r.deleted) {
        this.loadError.value = "This board was deleted.", this.loadErrorKind.value = "deleted";
        return;
      }
      r.refused && this.toast(r.refused === "owner" ? "Only the board's owner can change its name and description." : "The board's details couldn't be saved.", "error"), r.title && r.title !== this.meta.title && (this.meta.title = r.title, this.opts.onTitle && this.opts.onTitle(r.title)), r.description !== void 0 && (this.meta.description = r.description || ""), r.accessLevel !== void 0 && (this.meta.accessLevel = r.accessLevel || null);
    }
    e.results && e.results.length && this.results.upsert(e.results, !1), e.trash && (this.trashRev.value++, this.forgetPurged());
    const t = e.upserted.filter(Cs), i = e.removed.filter((r) => this.studioRecords.has(r));
    this.studioRecords.applyRemote(t, i);
    const s = t.length ? e.upserted.filter((r) => !Cs(r)) : e.upserted, o = i.length ? e.removed.filter((r) => !i.includes(r)) : e.removed;
    !s.length && !o.length || this.store.batch("Remote", () => {
      const r = [];
      for (const a of s)
        if (this.store.get(a.id)) {
          if (this.store.inGesture && this.ui.selection.includes(a.id)) continue;
          this.store.update(a.id, a, { origin: "remote", history: !1 });
        } else
          r.push(a);
      r.length && this.store.add(r, { origin: "remote", history: !1 }), o.length && this.store.remove(o, { origin: "remote", history: !1 });
    }, { origin: "remote", history: !1 });
  }
  /**
   * The Studios view's records of a session deleted for good (Recently
   * Deleted's 90 days passed, or by hand elsewhere) go too: nothing can show
   * them again. Only old ones, so a session still arriving from another tab
   * keeps its records.
   */
  sweepStudioRecords() {
    const e = /* @__PURE__ */ new Set();
    for (const s of this.store.all()) s.type === "tool" && e.add(s.id);
    for (const s of this.sync.trash()) s.el.type === "tool" && e.add(s.el.id);
    const t = Date.now(), i = this.studioRecords.all().filter((s) => s.role !== "pin" && !e.has(s.sessionId) && t - (s.updatedAt || s.createdAt || 0) > 600 * 1e3).map((s) => s.id);
    i.length && (this.studioRecords.remove(i), this.sync.purge(i));
  }
  // ---------------------------------------------------------------- camera
  /** Run fn on every camera frame (DOM writes that must not wait for Vue). */
  onCameraFrame(e) {
    return this.cameraHooks.add(e), () => this.cameraHooks.delete(e);
  }
  onCamera(e, t) {
    this.cam.value = e;
    for (const s of this.cameraHooks) s(e);
    this.worldEl && (this.worldEl.style.transform = "translate3d(" + e.x + "px," + e.y + "px,0) scale(" + e.zoom + ")", e.zoom !== this.styledZoom && (this.styledZoom = e.zoom, this.worldEl.style.setProperty("--cv-zoom", String(e.zoom)), this.worldEl.style.setProperty("--cv-inv-zoom", String(1 / e.zoom)))), t !== this.moving.value && (this.moving.value = t);
    const i = this.far.value ? e.zoom < Ate : e.zoom < Ite;
    i !== this.far.value && (this.far.value = i, this.engine && this.engine.setFar(i), this.overlayArea = null), this.updateOverlay(), clearTimeout(this.settleTimer), this.settleTimer = window.setTimeout(() => {
      this.moving.value = !1, this.prefs.camera = { ...this.cam.value }, this.persistPrefs(), this.opts.onCameraSettled && this.opts.onCameraSettled(this.cam.value);
    }, 220);
  }
  /** Recompute which DOM-layer elements should exist, with a margin. */
  updateOverlay() {
    if (!this.engine) return;
    const e = this.cam.value, t = Xa(e, this.view.w, this.view.h, 0), i = this.overlayArea;
    if (i && t.x >= i.x && t.y >= i.y && t.x + t.w <= i.x + i.w && t.y + t.h <= i.y + i.h && i.w < t.w * 2.6) return;
    const s = t.w * 0.5, o = t.h * 0.5, r = { x: t.x - s, y: t.y - o, w: t.w + s * 2, h: t.h + o * 2 };
    this.overlayArea = r;
    const a = [];
    if (this.far.value) {
      const d = Pte / e.zoom;
      for (const c of this.store.index.query(r)) {
        const u = this.store.get(c);
        u && u.type === "frame" && u.w >= d && a.push(c);
      }
      for (const c of [this.ui.editingNote, this.ui.editingTitle]) c && !a.includes(c) && this.store.get(c) && a.push(c);
    } else {
      for (const d of this.store.index.query(r)) {
        const c = this.store.get(d);
        c && (c.type === "note" || c.type === "tool" || c.type === "chat" || c.type === "frame" || c.type === "image" && (c.fav || c.video || this.isPinnedImage(c.src))) && a.push(d);
      }
      for (const d of this.ui.selection) if (!a.includes(d)) {
        const c = this.store.get(d);
        c && (c.type === "note" || c.type === "tool" || c.type === "chat") && a.push(d);
      }
    }
    const l = this.overlayIds.value;
    if (l.length === a.length) {
      const d = new Set(l);
      if (a.every((c) => d.has(c))) return;
    }
    this.overlayIds.value = a;
  }
  screenToWorld(e, t) {
    const i = this.cam.value;
    return { x: (e - this.view.left - i.x) / i.zoom, y: (t - this.view.top - i.y) / i.zoom };
  }
  worldToClient(e, t) {
    const i = this.cam.value;
    return { x: e * i.zoom + i.x + this.view.left, y: t * i.zoom + i.y + this.view.top };
  }
  viewportCentre() {
    const e = this.cam.value;
    return { x: (this.view.w / 2 - e.x) / e.zoom, y: (this.view.h / 2 - e.y) / e.zoom };
  }
  fit(e = 420) {
    if (!this.engine) return;
    const t = this.store.bounds();
    if (!t) {
      this.engine.animateCamera({ zoom: 1, x: this.view.w / 2, y: this.view.h / 2 }, e);
      return;
    }
    this.engine.fitTo(t, { pad: 120, maxZoom: 1, animate: e });
  }
  /** One press of zoom in or out: from where a glide under way is headed, so quick presses step evenly, and stopping at 100% on the way past (CHAT-29). */
  zoomBy(e) {
    if (!this.engine) return;
    const t = this.engine.cameraGoal;
    this.engine.animateCamera(sv(t, this.view.w / 2, this.view.h / 2, xF(t.zoom, e) / t.zoom), 220);
  }
  zoomTo(e) {
    this.engine && this.engine.animateCamera(sv(this.cam.value, this.view.w / 2, this.view.h / 2, e / this.cam.value.zoom), 260);
  }
  jumpTo(e, t, i) {
    this.engine && this.engine.animateCamera(Ga(e, t, i || this.cam.value.zoom, this.view.w, this.view.h), 420);
  }
  /** Open a session from anywhere: centre it, close enough to read (≥ 50%). */
  openSession(e) {
    const t = qe(e);
    this.ui.infoAt = null, this.ui.selection = [e.id], this.jumpTo(t.x + t.w / 2, t.y + t.h / 2, Math.max(this.cam.value.zoom, 0.5));
  }
  /** A tool by its id: in a kit, or one of the tools no kit lists (the Edit side's, IL-073). */
  toolModel(e) {
    const t = this.catalog.value;
    return t.byId.get(e) || (t.tools || []).find((i) => i.id === e) || null;
  }
  /**
   * A session card's Open, its empty slots, or a double-click on it (IL-100;
   * Adam: Open did nothing, and the empty slots should open the tool): the
   * session open and in view, with its results beside it. The board's
   * history, the comments and a chat open in the gallery's place, so they
   * step aside for it.
   */
  showSession(e) {
    this.openSession(e), this.ui.histOpen = !0, this.ui.boardHistory = !1, this.ui.chatOpen = null, this.comments.ui.panelOpen = !1;
  }
  /**
   * A new element lands where you look, at a readable zoom (≥ 100%). One put
   * where you pointed (a right-click, a double-click) stays where it is if it
   * can be read there (≥ 50%) and the chrome doesn't cover it.
   */
  revealNew(e, t = !1) {
    const i = qe(e);
    t && this.inClearView(i, e.type === "tool") || this.jumpTo(i.x + i.w / 2, i.y + i.h / 2, Math.max(this.cam.value.zoom, 1));
  }
  /** All on screen at a readable zoom, clear of the top bar, the session list and the bottom bar (or, for a session, its prompt). */
  inClearView(e, t) {
    const i = this.cam.value;
    if (i.zoom < 0.5) return !1;
    const s = e.x * i.zoom + i.x, o = e.y * i.zoom + i.y;
    return s >= 84 && o >= 64 && s + e.w * i.zoom <= this.view.w - 24 && o + e.h * i.zoom <= this.view.h - (t ? 280 : 96);
  }
  /**
   * Where something placed without a point goes: beside the selection (its
   * right, top-aligned), where there is one (IL-100; Nathan: "if you have a
   * selection and place an image it should place next to that instead of
   * the center of the screen"), else the middle of the view.
   */
  placeNear(e, t) {
    const i = this.ui.selection.filter((o) => !!this.store.get(o)), s = i.length ? this.store.bounds(i) : null;
    return s ? { x: s.x + s.w + 48 + e / 2, y: s.y + t / 2 } : void 0;
  }
  /** The canvas menu's Shape (IL-100): the dock's shape, as a click with it drops one, centred where you pointed. */
  addShape(e) {
    const t = this.ui.shapeKind, i = t === "line" || t === "arrow", s = {
      id: kt(),
      type: "shape",
      shape: t,
      z: 0,
      sc: [0, 0],
      x: Math.round(e.x - 130),
      y: Math.round(i ? e.y : e.y - 85),
      w: 260,
      h: i ? 0 : 170,
      stroke: this.ui.shapeStyle.stroke,
      sw: this.ui.shapeStyle.sw,
      createdBy: this.user.uid
    };
    return s.z = this.store.nextZ(s), this.closeAddMenus(), this.store.add([s]), this.ui.selection = [s.id], this.ui.styleOpen = !0, this.revealNew(s, !0), s.id;
  }
  /**
   * Clear space near the viewport centre (or `near`, a world point): rings
   * 160px apart, a 48px margin around everything already there. Frames
   * don't count — things go in them. `taken`: places already given out that the
   * board doesn't hold yet (several pictures placed at once).
   */
  freeSpot(e, t, i, s = []) {
    const o = i || this.viewportCentre(), r = 48, a = (c, u) => {
      const p = { x: c - r, y: u - r, w: e + r * 2, h: t + r * 2 };
      for (const f of s) if (Id({ x: c, y: u, w: e, h: t }, { x: f.x - 24, y: f.y - 24, w: f.w + 48, h: f.h + 48 })) return !1;
      for (const f of this.store.index.query(p)) {
        const y = this.store.get(f);
        if (!y) continue;
        const b = qe(y);
        if (y.type === "frame") {
          if (!(c >= b.x + 16 && u >= b.y + 16 && c + e <= b.x + b.w - 16 && u + t <= b.y + b.h - 16) && Id(p, b)) return !1;
          continue;
        }
        if (Id(p, b)) return !1;
      }
      return !0;
    }, l = Math.round(o.x - e / 2), d = Math.round(o.y - t / 2);
    if (a(l, d)) return { x: l, y: d };
    for (let c = 1; c <= 14; c++) {
      const u = c * 160, p = 8 * c;
      let f = null;
      for (let y = 0; y < p; y++) {
        const b = y / p * Math.PI * 2, w = Math.round(l + Math.cos(b) * u), k = Math.round(d + Math.sin(b) * u * 0.75);
        if (a(w, k)) {
          f = { x: w, y: k };
          break;
        }
      }
      if (f) return f;
    }
    return { x: l, y: d };
  }
  /** Typing needs a readable zoom: bring a far element close first. */
  editNote(e) {
    const t = this.store.get(e);
    if (t) {
      if (this.ui.selection = [e], this.far.value) {
        const i = qe(t);
        this.jumpTo(i.x + i.w / 2, i.y + i.h / 2, 0.8);
      }
      this.ui.editingNote = e, this.overlayArea = null, this.updateOverlay();
    }
  }
  // ------------------------------------------------------------ selection
  select(e) {
    this.ui.selection = e, this.ui.styleOpen = !1;
  }
  /** Everything on the board, frames too: a move takes each frame with what it holds (CHAT-26). */
  selectAll() {
    this.ui.selection = Array.from(this.store.all()).map((e) => e.id);
  }
  clearSelection() {
    this.ui.selection = [], this.ui.styleOpen = !1;
  }
  // -------------------------------------------------------------- creation
  author() {
    return this.user.initials || "You";
  }
  // ------------------------------------------------------- menus at a point
  /** Right-click on the canvas: its menu, at the pointer, adds things there. */
  openCanvasMenu(e, t) {
    this.closeMenus(), this.ui.canvasMenu = this.pointMenu(e, t);
  }
  /** Double-click on the canvas: the session finder, at the pointer; a session started from it goes there. */
  openFinder(e, t) {
    this.closeMenus(), this.ui.finder = this.pointMenu(e, t);
  }
  pointMenu(e, t) {
    return { x: e, y: t, at: this.screenToWorld(e, t) };
  }
  /** The menus over the board (the add menu, the place menu, the shape menu, the board menu, the menus at a point); not its dialogs. */
  closeMenus() {
    this.ui.placeMenu = !1, this.ui.shapeMenu = !1, this.ui.boardMenu = !1, this.closeAddMenus();
  }
  /** The menus that add to the board: something added closes them. */
  closeAddMenus() {
    this.ui.addMenu = !1, this.ui.canvasMenu = null, this.ui.finder = null;
  }
  /**
   * The add menu opens where the tool rail is, and an open session's prompt
   * takes the rail's place: picking "new session" leaves the current one.
   */
  openAddMenu() {
    this.promptTool.value && (this.ui.selection = []), this.ui.addMenu = !0;
  }
  /**
   * `at`: a world point (a right-click's) the new element is centred on, or
   * as near it as there's room; without one, clear space where you look.
   */
  addElement(e, t) {
    if (e === "tool") {
      this.ui.addMenu ? this.ui.addMenu = !1 : this.openAddMenu();
      return;
    }
    if (this.closeAddMenus(), e === "image-gen") {
      this.newImageSession(t);
      return;
    }
    let i = null;
    if (e !== "image") {
      if (e === "note") {
        const s = this.freeSpot(th.w, th.h, t);
        i = { id: kt(), type: "note", x: s.x, y: s.y, w: th.w, h: th.h, z: 0, tint: this.ui.noteTint, text: "", author: this.author(), grow: !0 };
      } else if (e === "frame") {
        const s = this.freeSpot(nh.w, nh.h, t);
        i = { id: kt(), type: "frame", x: s.x, y: s.y, w: nh.w, h: nh.h, z: 0, title: "New frame" };
      }
      i && (i.z = this.store.nextZ(i, i.type === "frame"), i.createdBy = this.user.uid, this.store.add([i]), this.ui.selection = [i.id], this.revealNew(i, !!t), i.type === "note" && (this.ui.editingNote = i.id), i.type === "frame" && (this.ui.editingTitle = i.id));
    }
  }
  /** Place images (urls) at the viewport centre or a world point. */
  placeImages(e, t) {
    const i = [], s = [];
    let o = 0;
    const r = [];
    for (const a of e) {
      const l = a.w || j2.w, d = a.h || j2.h, c = r[r.length - 1], u = c ? { x: c.x + c.w + 24 + l / 2, y: c.y + d / 2 } : this.placeNear(l, d), p = a.x !== void 0 && a.y !== void 0 ? { x: a.x, y: a.y } : t ? { x: Math.round(t.x - l / 2 + o), y: Math.round(t.y - d / 2 + o) } : this.freeSpot(l, d, u, r);
      r.push({ x: p.x, y: p.y, w: l, h: d });
      const f = {
        id: kt(),
        type: "image",
        x: p.x,
        y: p.y,
        w: l,
        h: d,
        z: 0,
        src: a.url,
        label: a.label || "placed_image",
        resultId: a.resultId,
        sessionId: a.sessionId,
        video: a.video,
        dur: a.dur,
        videoSrc: a.videoSrc,
        previewSrc: a.previewSrc,
        asset: a.asset,
        download: a.download,
        kind: a.kind,
        createdBy: this.user.uid
      };
      f.z = this.store.nextZ(f) + s.length, s.push(f), i.push(f.id), o += 28;
    }
    return s.length && (this.store.add(s), this.ui.selection = i, t || this.revealNew(s[0])), i;
  }
  // ------------------------------------------------------------ your Library
  /** Open your Library over the board: to place pictures on it (the default), or to pick some for something. */
  openLibrary(e = {}) {
    this.ui.placeMenu = !1, this.ui.addMenu = !1, this.ui.libraryOpen = {
      purpose: e.purpose || "place",
      max: e.max || Ete,
      kinds: e.kinds,
      confirmLabel: e.confirmLabel,
      onPick: e.onPick,
      at: e.at,
      n: (this.ui.libraryOpen ? this.ui.libraryOpen.n : 0) + 1
    };
  }
  closeLibrary() {
    this.ui.libraryOpen = null;
  }
  /**
   * Pictures picked in your Library go on the board at a card's size, in the
   * order picked, each with its record (so a run can send it as is).
   */
  placeFromLibrary(e, t) {
    const i = [];
    for (const y of e) {
      this.rememberAsset(y.url, y.asset);
      const b = H2(y.w || 0, y.h || 0);
      i.push({
        url: y.url,
        w: b.w,
        h: b.h,
        label: y.label.slice(0, 60),
        asset: y.asset,
        video: y.video && y.videoSrc ? !0 : void 0,
        videoSrc: y.video ? y.videoSrc : void 0,
        // a 3D model's preview, which keeps its model to download (IL-100)
        kind: y.model3d ? "3d" : void 0,
        download: y.model3d ? y.model3d.url : void 0
      });
    }
    const s = 24, o = Math.max(1, Math.ceil(Math.sqrt(i.length * 1.6))), r = [];
    for (let y = 0; y < i.length; y += o) r.push(i.slice(y, y + o));
    const a = r.map((y) => y.reduce((b, w) => b + (w.w || 0), 0) + s * (y.length - 1)), l = r.map((y) => Math.max(...y.map((b) => b.h || 0))), d = Math.max(0, ...a), c = l.reduce((y, b) => y + b, 0) + s * (r.length - 1), u = this.freeSpot(d, c, t || this.placeNear(d, c));
    let p = u.y;
    r.forEach((y, b) => {
      let w = u.x;
      for (const k of y)
        k.x = w, k.y = p + Math.round((l[b] - (k.h || 0)) / 2), w += (k.w || 0) + s;
      p += l[b] + s;
    });
    const f = this.placeImages(i);
    return f.length && this.toast(f.length === 1 ? "Placed 1 image from your Library" : "Placed " + f.length + " images from your Library"), f;
  }
  /** Tools are concepts, not models: "Image Tool 3" until its first run. */
  nextToolName(e) {
    const t = new RegExp("^" + e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + " Tool (\\d+)$");
    let i = 0;
    const s = (o) => {
      const r = t.exec(o || "");
      r && (i = Math.max(i, Number(r[1])));
    };
    for (const o of this.store.all()) o.type === "tool" && s(o.name);
    for (const o of this.trash.value) o.el.type === "tool" && s(o.el.name);
    return e + " Tool " + (i + 1);
  }
  /** A new session on this kit and model; `at` as addElement has it. */
  pickModel(e, t, i) {
    const s = this.addSession(e, t, void 0, i);
    return this.prompts.set(s.id, { prompt: "", n: t.numResults.def || 1 }), this.bumpPrompt(), this.freshTools.add(s.id), s;
  }
  /** Image Gen: a session on the image kit's default model, or none while there's no catalog. */
  newImageSession(e) {
    const t = this.catalog.value.kits.find((o) => o.id === "image") || this.catalog.value.kits[0], i = t ? ls(t) : null, s = e || this.tour && this.tour.landing && this.tour.landing() || void 0;
    return t && i ? this.pickModel(t, i, s) : null;
  }
  /**
   * A new session in clear space where you're looking (or near `at`), selected
   * and in view. `quiet`: the selection and the view stay as they are (a chat's
   * plan adds sessions to a frame you're already looking at).
   */
  addSession(e, t, i, s, o = {}) {
    const r = Tt, a = this.freeSpot(r.w, r.h, s), l = {
      id: kt(),
      type: "tool",
      x: a.x,
      y: a.y,
      w: r.w,
      h: r.h,
      z: 0,
      name: i || this.nextToolName(e.name),
      kind: e.name,
      kitId: e.id,
      model: t.name,
      nodeDefId: t.id,
      icon: wl[e.id] || e.icon || "Image",
      count: 0,
      thumbs: [],
      createdBy: this.user.uid
    };
    return l.z = this.store.nextZ(l), this.store.add([l]), o.quiet || (this.closeAddMenus(), this.ui.selection = [l.id], this.revealNew(l, !!s)), l;
  }
  /** `name`, or "name 2", "name 3"… when another session has it. */
  uniqueSessionName(e, t) {
    const i = /* @__PURE__ */ new Set();
    for (const o of this.store.all()) o.type === "tool" && o.id !== t && i.add(o.name);
    if (!i.has(e)) return e;
    let s = 2;
    for (; i.has(e + " " + s); ) s++;
    return e + " " + s;
  }
  /** A session that has made nothing yet, and isn't making anything. */
  isUnused(e) {
    return this.results.rev.value, !e.count && !(e.thumbs && e.thumbs.length) && !this.results.list(e.id).length && !this.generating[e.id];
  }
  /** A prompt just landed in this session's card: it glows once. */
  landPrompt(e) {
    this.ui.promptLanded = { id: e, seq: (this.ui.promptLanded ? this.ui.promptLanded.seq : 0) + 1 };
  }
  // ------------------------------------------------------------ mutations
  patch(e, t, i = "Edit") {
    this.store.batch(i, () => this.store.update(e, t));
  }
  patchTool(e, t) {
    this.store.batch("Edit session", () => this.store.update(e, t)), t.nodeDefId !== void 0 && this.persistPrompt(e);
  }
  // ------------------------------------------------------------- prompts
  /**
   * Your prompt in a session. On a real board it's your run draft, so it's
   * yours alone; until you change it, a demo session offers its own.
   */
  promptOf(e) {
    this.promptRev.value;
    const t = this.store.get(e);
    t && t.type === "tool" && this.opts.prompts && this.opts.prompts.follow(e).catch(() => {
    });
    const i = this.prompts.get(e);
    return i || t && t.type === "tool" && t.up || {};
  }
  setPrompt(e, t) {
    const i = { ...this.promptOf(e), ...t };
    t.assets && (i.assets = { ...this.promptOf(e).assets || {}, ...t.assets }), this.prompts.set(e, i), this.bumpPrompt(), t.prompt && this.freshTools.delete(e), this.persistPrompt(e);
  }
  bumpPrompt() {
    this.promptRev.value++, os(this.promptRev);
  }
  /** Save a session's prompt (your run draft), for its current model. */
  persistPrompt(e) {
    const t = this.opts.prompts;
    if (!t) return;
    const i = this.store.get(e);
    if (!i || i.type !== "tool") return;
    const { model: s } = this.modelFor(i);
    if (!s) return;
    const o = this.promptOf(e);
    t.save(e, s.id, go(s, o, "draft").inputs, this.countFor(s, o));
  }
  countFor(e, t) {
    return Math.max(e.numResults.min, Math.min(e.numResults.max, t.n || e.numResults.def || 1));
  }
  /** Your saved prompt for a session arrived (the load, or another tab of yours). */
  onSavedPrompt(e, t) {
    if (!t) return;
    const i = this.catalog.value, s = this.store.get(e), r = i.byId.get(t.nodeDefId) || null || (i.source === "firestore" && s ? this.modelFor(s).model : null);
    if (!r) {
      this.undecoded.set(e, t);
      return;
    }
    this.undecoded.delete(e);
    const a = Ap(r, t.inputs, (l) => this.assetUrl(l));
    t.numResults && (a.n = t.numResults), !BO(this.prompts.get(e), a) && (this.prompts.set(e, a), this.dropForgotten(e), this.bumpPrompt());
  }
  /** Where the board shows a result's or an upload's file. */
  assetUrl(e) {
    const t = BH(e) || "";
    return this.opts.storageUrl ? this.opts.storageUrl(t) : t;
  }
  /** A session's image inputs, in the model's order. */
  refFieldsOf(e) {
    const { model: t } = this.modelFor(e);
    return t ? t.fields.filter((i) => i.placement === "reference") : [];
  }
  /**
   * The pictures in one of a session's image inputs. The first input is the
   * session's own reference (`ref`), the rest live under `inputs` by field
   * key; one that takes several keeps a list there once it holds more than one.
   */
  refImages(e, t) {
    const i = this.store.get(e);
    if (!i || i.type !== "tool") return [];
    const s = this.refFieldsOf(i), o = this.promptOf(e), r = o.inputs ? o.inputs[t] : void 0;
    if (Array.isArray(r)) {
      const l = r.filter((d) => typeof d == "string" && !!d);
      if (l.length) return l;
    }
    const a = !s.length || s[0].key === t ? o.ref : r;
    return typeof a == "string" && a ? [a] : [];
  }
  putRefImages(e, t, i, s) {
    const o = this.store.get(e);
    if (!o || o.type !== "tool") return;
    const r = this.refFieldsOf(o), a = !r.length || r[0].key === t, l = this.promptOf(e), d = i.length > 1 ? i : a ? void 0 : i[0] || null, c = {};
    s && (c.assets = s), a && (c.ref = i[0] || null), (!a || d !== void 0 || l.inputs && l.inputs[t] !== void 0) && (c.inputs = { ...l.inputs || {}, [t]: d }), this.setPrompt(e, c);
  }
  /**
   * Fill one of a session's image inputs, or clear it (null). One that takes
   * several adds the picture to those it holds, up to the model's limit; any
   * other holds just this one. `asset` is the result or upload behind the
   * picture, which a run sends. False when it didn't take (the input is full).
   */
  setRefInput(e, t, i, s) {
    const o = this.store.get(e);
    if (!o || o.type !== "tool") return !1;
    if (!i)
      return this.putRefImages(e, t, []), !0;
    const r = s ? { [i]: s } : void 0, a = this.refFieldsOf(o).find((l) => l.key === t);
    if (a && a.kind === "images") {
      const l = this.refImages(e, t);
      if (l.includes(i)) return !0;
      const d = Gs(a);
      return l.length >= d ? (this.toast("This model takes up to " + d + " images. Remove one to add another."), !1) : (this.putRefImages(e, t, l.concat(i), r), !0);
    }
    return this.putRefImages(e, t, [i], r), !0;
  }
  /** Take one picture out of an image input (the rest stay, in order). */
  removeRefImage(e, t, i) {
    this.putRefImages(e, t, this.refImages(e, t).filter((s) => s !== i));
  }
  /** A picture for a session's reference: its first image input. */
  addReference(e, t, i) {
    const s = this.store.get(e);
    if (!s || s.type !== "tool") return !1;
    const o = this.refFieldsOf(s)[0];
    return this.setRefInput(e, o ? o.key : "", t, i);
  }
  // ---------------------------------------------------------------- the eyedropper
  /**
   * The eyedropper: armed for one of a session's image inputs, a click on an
   * image on the board (or a session card's thumbnail, or a gallery result)
   * puts it there instead of selecting it. Without a key it arms the first
   * input with room for another picture, else the first.
   */
  armEyedropper(e, t) {
    const i = this.store.get(e);
    if (!i || i.type !== "tool") return;
    const s = this.refFieldsOf(i), o = t ? s.find((r) => r.key === t) : s.find((r) => this.refImages(e, r.key).length < Gs(r)) || s[0];
    if (!o) {
      this.toast("This model takes no images.");
      return;
    }
    this.ui.shapeArmed = !1, this.ui.mode = "select", this.ui.addMenu = !1, this.ui.eyedropper = { sessionId: e, key: o.key };
  }
  /** The prompt's eyedropper button (and I): on, or off again. */
  toggleEyedropper(e) {
    this.ui.eyedropper && this.ui.eyedropper.sessionId === e ? this.ui.eyedropper = null : this.armEyedropper(e);
  }
  /** The input the eyedropper fills, while the session still has it. */
  get eyedropperField() {
    const e = this.ui.eyedropper, t = e ? this.store.get(e.sessionId) : void 0;
    return !e || !t || t.type !== "tool" ? null : this.refFieldsOf(t).find((i) => i.key === e.key) || null;
  }
  /** Whether the eyedropper's input takes this picture (a video input takes videos, the rest stills). */
  eyedropperTakes(e) {
    const t = this.eyedropperField;
    return !!t && t.kind === "video" === e;
  }
  /**
   * Put a picture from the board in the eyedropper's input, and put the
   * eyedropper away: one pick per press. A picture of the wrong kind (a video
   * for an image input) is turned away and the eyedropper stays on.
   */
  eyedrop(e, t, i) {
    const s = this.ui.eyedropper, o = this.eyedropperField;
    if (!s || !o) {
      this.ui.eyedropper = null;
      return;
    }
    if (o.kind === "video" !== i) {
      this.toast(o.kind === "video" ? "This input takes a video. Pick a video on the board." : "This input takes images, not videos.");
      return;
    }
    if (this.ui.eyedropper = null, !this.refImages(s.sessionId, s.key).includes(e) && !this.setRefInput(s.sessionId, s.key, e, t)) return;
    const r = (this.ui.refPulse ? this.ui.refPulse.n : 0) + 1;
    this.ui.refPulse = { url: e, n: r }, window.setTimeout(() => {
      this.ui.refPulse && this.ui.refPulse.n === r && (this.ui.refPulse = null);
    }, 900);
  }
  /** An image on the board, through the eyedropper: its record goes with it, for the run. */
  eyedropImage(e) {
    this.eyedrop(e.src, e.asset || this.assetFor(e.src), !!e.video);
  }
  // ---------------------------------------------------------------- Shift-drag to a session
  /**
   * An image on the board, Shift-dragged onto a session (IL-071): its card,
   * its row in the sessions rail, or its open prompt. It goes into the input
   * it was dropped on, else the session's first input that takes it (with
   * room, if one has), with its record for the run. The session opens, and
   * the picture glows softly in its prompt for a few seconds. One already
   * there isn't added twice; it glows again. `reveal` brings a session from
   * elsewhere on the board into view.
   */
  referenceImage(e, t, i = {}) {
    const s = this.store.get(e), o = this.store.get(t);
    if (!s || s.type !== "image" || !o || o.type !== "tool") return !1;
    const r = !!s.video, a = this.refFieldsOf(o), l = (p) => p.kind === "video" === r, d = i.key ? a.find((p) => p.key === i.key) : a.find((p) => l(p) && this.refImages(t, p.key).length < Gs(p)) || a.find(l);
    if (!d)
      return this.toast(a.length ? r ? o.name + " takes images, not videos." : o.name + " takes a video, not images." : o.name + " takes no images."), !1;
    if (!l(d))
      return this.toast(d.kind === "video" ? "This input takes a video, not images." : "This input takes images, not videos."), !1;
    const c = s.src;
    if (!this.refImages(t, d.key).includes(c) && !this.setRefInput(t, d.key, c, s.asset || this.assetFor(c))) return !1;
    i.reveal ? this.openSession(o) : this.ui.selection = [t];
    const u = (this.ui.refGlow ? this.ui.refGlow.n : 0) + 1;
    return this.ui.refGlow = { sessionId: t, url: c, n: u }, window.setTimeout(() => {
      this.ui.refGlow && this.ui.refGlow.n === u && (this.ui.refGlow = null);
    }, Cte), !0;
  }
  /**
   * Upload a file (a drop, a paste, the picker's Upload): to your uploads
   * where the host offers its pipeline, keeping the upload's record so a run
   * can send the picture without uploading it again.
   */
  async uploadFile(e) {
    const t = this.uploader;
    if (!t) throw new Error("Uploads aren't available here.");
    if (t.uploadRecord) {
      const i = await t.uploadRecord(e), s = i.upload ? { upload: i.upload } : null;
      return s && this.knownAssets.set(i.url, s), { url: i.url, asset: s };
    }
    return { url: await t.upload(e), asset: null };
  }
  get hasLibrary() {
    return !!this.opts.library;
  }
  /** Your Library, where the host gives the board one (the harness has a demo one). */
  get libraryShelf() {
    return this.opts.library || null;
  }
  /** A page of your Library: your generations, uploads or favorites, from `q.cursor`, filtered and searched as `q` says. */
  libraryPage(e, t = {}) {
    const i = this.opts.library;
    return i ? e === "generations" ? i.generations(t) : e === "uploads" ? i.uploads(t) : i.favorites(t) : Promise.resolve({ items: [], next: null });
  }
  /**
   * Something deleted from your Library (CHAT-13): the pictures the Studios
   * view brought in from it go too, for good (what they pointed at is
   * deleted, so there's nothing to recover), with their marks; and the
   * sessions' prompts let go of it, or opening a Studios view would bring it
   * back from its queue. Matched by its upload, its result, or its file. The
   * prompts are those of the sessions it was brought into and those already
   * read; reading every session's saved prompt for it would read the board's.
   */
  forgetLibraryItem(e) {
    const t = e.run ? e.run.uuid : null, i = (d, c) => d === e.url ? !0 : c ? e.uploadId && "upload" in c && c.upload.id === e.uploadId ? !0 : !!t && "nodeRunResult" in c && c.nodeRunResult.uuid === t : !1;
    this.forgottenLibrary.push(i);
    const s = this.studioRecords.all().filter((d) => d.role === "ref" && i(d.url, d.asset)), o = /* @__PURE__ */ new Set([...s.map((d) => d.sessionId), ...this.prompts.keys()]);
    for (const d of o) {
      if (!this.store.get(d)) continue;
      const u = this.promptOf(d).assets || {};
      this.dropPictures(d, (p) => i(p, u[p] || this.knownAssets.get(p)));
    }
    if (!s.length) return;
    const r = s.map((d) => d.id), a = this.studioRecords.all().filter((d) => d.role === "marks" && r.includes(d.target)).map((d) => d.id), l = [...r, ...a];
    this.studioRecords.remove(l), this.sync.purge(l), this.trashRev.value++;
  }
  /** A session's prompt without the Library items deleted this visit (forgetLibraryItem), once its saved draft is read. */
  dropForgotten(e) {
    if (!this.forgottenLibrary.length || !this.store.get(e)) return;
    const t = this.promptOf(e).assets || {};
    this.dropPictures(e, (i) => this.forgottenLibrary.some((s) => s(i, t[i] || this.knownAssets.get(i))));
  }
  /** A session's prompt without the pictures `gone` names, in its reference and its picture inputs. */
  dropPictures(e, t) {
    const i = this.promptOf(e), s = (l) => typeof l == "string" && t(l);
    let o = !1;
    const r = i.ref && s(i.ref) ? null : i.ref;
    r !== i.ref && (o = !0);
    const a = {};
    for (const [l, d] of Object.entries(i.inputs || {})) {
      if (s(d)) {
        o = !0;
        continue;
      }
      if (Array.isArray(d) && d.some(s)) {
        o = !0;
        const c = d.filter((u) => !s(u));
        c.length && (a[l] = c);
        continue;
      }
      a[l] = d;
    }
    o && this.setPrompt(e, { ref: r, inputs: a });
  }
  /** Keep a picture's record (a Library pick), so a run sends it without uploading it again. */
  rememberAsset(e, t) {
    this.knownAssets.set(e, t);
  }
  /** The record behind a picture on the board or in a gallery, if it has one. */
  assetFor(e) {
    const t = this.knownAssets.get(e);
    if (t) return t;
    for (const s of this.store.all())
      if (s.type === "image" && s.src === e && s.asset) return s.asset;
    const i = this.resultByUrl(e);
    return i && i.asset || null;
  }
  resultByUrl(e) {
    this.results.rev.value;
    for (const t of this.allResults()) if (t.url === e || t.thumb === e) return t;
    return null;
  }
  allResults() {
    const e = [];
    for (const t of this.store.all()) t.type === "tool" && e.push(...this.results.list(t.id));
    return e;
  }
  /**
   * Into Recently Deleted, sessions too (with their history); a session's run
   * in flight stops. A locked frame and what it holds stay, and say why.
   */
  deleteIds(e) {
    const t = e.filter((r) => !this.isHeld(this.store.get(r))), i = e.filter((r) => qd(this.store.get(r))).length, s = e.length - t.length - i;
    if (i && s ? this.toast("Locked frames and what they hold stay. Unlock the frames to delete them.") : i ? this.toast(i === 1 ? "The locked frame stays. Unlock it to delete it." : "Locked frames stay. Unlock them to delete them.") : s && this.toast(s === 1 ? "It's in a locked frame. Unlock the frame to delete it." : "These are in a locked frame. Unlock the frame to delete them."), !t.length) return;
    const o = t.filter((r) => {
      var a;
      return ((a = this.store.get(r)) == null ? void 0 : a.type) === "tool";
    });
    this.store.batch("Delete", () => this.store.remove(t));
    for (const r of o) {
      const a = this.runs.get(r);
      a && (a.cancel(), this.runs.delete(r), delete this.generating[r]);
    }
    this.ui.selection = this.ui.selection.filter((r) => !t.includes(r));
  }
  duplicateIds(e, t = 28) {
    const i = [], s = /* @__PURE__ */ new Map();
    for (const o of e) {
      const r = this.store.get(o);
      if (!r) continue;
      const a = JSON.parse(JSON.stringify(r));
      if (a.id = kt(), a.x += t, a.y += t, a.type === "frame" && delete a.locked, a.z = this.store.nextZ(a, a.type === "frame") + i.length, a.type === "tool")
        a.name = a.name + " copy", a.count = 0, a.thumbs = [];
      else if (a.type === "chat") {
        const l = a;
        l.name = l.name + " copy", l.messages = (l.messages || []).map((d) => d.plan && d.plan.status === "running" ? { ...d, plan: { ...d.plan, status: "stopped" } } : d);
      }
      s.set(o, a.id), i.push(a);
    }
    return i.length ? (this.store.batch("Duplicate", () => this.store.add(i)), this.ui.selection = i.map((o) => o.id), this.ui.selection) : [];
  }
  /** Swap with the neighbour above / below, within the element's layer. A locked frame keeps its place. */
  reorder(e, t) {
    this.store.batch(t === "forward" ? "Bring forward" : "Send back", () => {
      for (const i of e) {
        const s = this.store.get(i);
        if (!s || qd(s)) continue;
        const o = qe(s), r = this.store.query(o).filter((a) => a.id !== i && Rte(a, s));
        if (t === "forward") {
          const a = r.filter((d) => d.z > s.z).sort((d, c) => d.z - c.z)[0], l = a ? a.z + 0.5 : this.store.nextZ(s);
          this.store.update(i, { z: l });
        } else {
          const a = r.filter((d) => d.z < s.z).sort((d, c) => c.z - d.z)[0], l = a ? a.z - 0.5 : this.store.nextZ(s, !0);
          this.store.update(i, { z: l });
        }
      }
    });
  }
  /**
   * Lines up the selection; a locked frame and what it holds neither move nor count. A
   * frame lines up with what it holds, which goes with it rather than
   * lining up on its own (a selection can hold both since CHAT-26).
   */
  align(e) {
    var t, i;
    const s = this.ui.selection.map((c) => this.store.get(c)).filter((c) => c && !this.isHeld(c)), o = /* @__PURE__ */ new Map();
    for (const c of s) c.type === "frame" && o.set(c.id, this.childrenOf(c));
    const r = new Set(Array.from(o.values()).flat()), a = s.filter((c) => !r.has(c.id));
    if (a.length < 2) return;
    const l = a.map((c) => ({ id: c.id, ...qe(c) })), d = [];
    if (e === "align-left") {
      const c = Math.min(...l.map((u) => u.x));
      l.forEach((u) => d.push([u.id, { x: c }]));
    } else if (e === "align-top") {
      const c = Math.min(...l.map((u) => u.y));
      l.forEach((u) => d.push([u.id, { y: c }]));
    } else if (e === "align-center") {
      const c = l.reduce((u, p) => u + p.y + p.h / 2, 0) / l.length;
      l.forEach((u) => d.push([u.id, { y: Math.round(c - u.h / 2) }]));
    } else {
      const c = l.slice().sort((w, k) => w.x - k.x), u = c[0].x, p = Math.max(...c.map((w) => w.x + w.w)), f = c.reduce((w, k) => w + k.w, 0), y = (p - u - f) / Math.max(1, c.length - 1);
      let b = u;
      c.forEach((w) => {
        d.push([w.id, { x: Math.round(b) }]), b += w.w + y;
      });
    }
    for (const [c, u] of d.slice()) {
      const p = o.get(c), f = this.store.get(c);
      if (!p || !f) continue;
      const y = ((t = u.x) != null ? t : f.x) - f.x, b = ((i = u.y) != null ? i : f.y) - f.y;
      for (const w of p) {
        const k = this.store.get(w);
        k && !this.isHeld(k) && d.push([w, { x: k.x + y, y: k.y + b }]);
      }
    }
    this.store.batch("Align", () => this.store.updateMany(d));
  }
  tint(e) {
    const t = [];
    for (const i of this.ui.selection) {
      const s = this.store.get(i);
      s && s.type === "note" && t.push([i, { tint: e }]);
    }
    t.length && this.store.batch("Tint", () => this.store.updateMany(t)), this.ui.noteTint = e;
  }
  /** Wrap the selection in a frame that hugs it. */
  groupIntoFrame() {
    const e = this.ui.selection.map((o) => this.store.get(o)).filter((o) => o && o.type !== "frame"), t = this.store.bounds(e.map((o) => o.id));
    if (!t) return;
    const i = 48, s = {
      id: kt(),
      type: "frame",
      x: Math.round(t.x - i),
      y: Math.round(t.y - i - 12),
      w: Math.round(t.w + i * 2),
      h: Math.round(t.h + i * 2 + 12),
      z: 0,
      title: "New frame"
    };
    s.z = this.store.nextZ(s, !0), this.store.batch("Group into frame", () => this.store.add([s])), this.ui.selection = [s.id], this.ui.editingTitle = s.id;
  }
  /**
   * Lock the selected frames (IL-070), or unlock them when every one is
   * locked already: one undo step. Only frames lock; with none selected it
   * does nothing.
   */
  toggleLock(e = this.ui.selection) {
    const t = e.map((r) => this.store.get(r)).filter((r) => r && r.type === "frame");
    if (!t.length) return;
    const i = t.some((r) => !r.locked), s = t.length === 1 ? " frame" : " " + t.length + " frames", o = t.map((r) => [r.id, { locked: i ? !0 : void 0 }]);
    this.store.batch((i ? "Lock" : "Unlock") + s, () => this.store.updateMany(o));
  }
  ctxAction(e) {
    const t = this.ui.selection.slice();
    e === "delete" ? this.deleteIds(t) : e === "duplicate" ? this.duplicateIds(t) : e === "copy" ? this.copy(!1) : e === "lock" ? this.toggleLock(t) : e === "rename" ? this.ui.editingTitle = t[0] : e === "style" ? this.ui.styleOpen = !this.ui.styleOpen : e === "info" ? this.ui.infoAt = t[0] : e === "save-prompt" ? (this.ui.infoAt = t[0], this.ui.infoSave = !0) : e === "frame" ? this.groupIntoFrame() : e === "download" ? this.download(t[0]) : e === "reference" ? this.useAsReference(t[0]) : e === "edit" ? this.openStudio({ elementId: t[0] }) : e === "forward" || e === "back" ? this.reorder(t, e) : e.startsWith("tint-") ? this.tint(e.slice(5)) : (e.startsWith("align-") || e === "distribute-h") && this.align(e);
  }
  /** Download a card's file: a video's own file, a 3D model's, named as v1 names results. */
  download(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "image") return;
    const i = t, s = i.download || i.videoSrc || i.src, o = i.resultId ? this.results.get(i.resultId) : void 0, r = (/(\.\w{3,4})(\?|$)/.exec(s.replace(/%2F/gi, "/")) || ["", ".webp"])[1];
    this.saveFile(s, o && o.uuid ? y1(o.prompt, o.uuid, s) : (i.label || "image") + r);
  }
  /**
   * An image goes back to the session that made it (its `sessionId`), as that
   * session's reference, and the session opens. An image no session on the
   * board made (an upload, a drop, one whose session was deleted) goes to the
   * session used last.
   */
  useAsReference(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "image") return;
    const i = t;
    let s = this.toolFor(i);
    if (!s) {
      const r = this.ui.recentIds.find((a) => {
        var l;
        return ((l = this.store.get(a)) == null ? void 0 : l.type) === "tool";
      });
      s = r ? this.store.get(r) : null;
    }
    if (!s) {
      this.toast("Add a tool session first, then use this image as its reference.");
      return;
    }
    const o = this.addReference(s.id, i.src, i.asset || null);
    this.openSession(s), o && this.toast("Added as the reference for " + s.name);
  }
  // ---------------------------------------------------------------- the Studios view
  /**
   * Open the Studios view (plans/board-canvas/studios-view.md) on an image,
   * in its own session as Use as reference finds it (an image no session
   * made goes to the session used last); on a session's result; or on a
   * session alone.
   */
  openStudio(e) {
    let t = e.sessionId || null;
    if (e.resultId) {
      const i = this.results.get(e.resultId);
      i && (t = i.sessionId);
    }
    if (e.elementId) {
      const i = this.store.get(e.elementId);
      if (!i || i.type !== "image") return;
      let s = this.toolFor(i);
      if (!s) {
        const o = this.ui.recentIds.find((r) => {
          var a;
          return ((a = this.store.get(r)) == null ? void 0 : a.type) === "tool";
        });
        s = o ? this.store.get(o) : null;
      }
      if (!s) {
        for (const o of this.store.all())
          if (o.type === "tool") {
            s = o;
            break;
          }
      }
      s || (s = this.newImageSession({ x: i.x + i.w + Tt.w / 2 + 48, y: i.y + Math.min(i.h, Tt.h) / 2 })), t = s ? s.id : null;
    }
    if (!t || !this.store.get(t)) {
      this.toast("Add an image session first, then open it in Studio view.");
      return;
    }
    this.ui.infoAt = null, this.ui.addMenu = !1, this.ui.studio = {
      sessionId: t,
      elementId: e.elementId,
      resultId: e.resultId,
      n: (this.ui.studio ? this.ui.studio.n : 0) + 1
    };
  }
  /**
   * Back in the Studios view a refresh left (CHAT-07), once its session's
   * saved draft is in: the view reads the draft's words and pictures as it
   * opens. Opened before, its queue went without the draft's pictures, and
   * the next picture queued saved over them. A draft still waiting for the
   * catalog to read it holds the view up a few seconds at most.
   */
  restoreStudio(e) {
    const t = () => {
      var s;
      this.disposed || this.ui.studio || ((s = this.store.get(e)) == null ? void 0 : s.type) !== "tool" || this.openStudio({ sessionId: e });
    }, i = this.opts.prompts;
    if (!i) {
      t();
      return;
    }
    i.follow(e).catch(() => {
    }).then(() => this.whenDecoded(e, _te)).then(t);
  }
  /** Once a session's saved draft has been read against the catalog (it waits there for its tool's definition), or `ms` at most. */
  whenDecoded(e, t) {
    return this.undecoded.has(e) ? new Promise((i) => {
      let s = !1;
      const o = () => {
        s || (s = !0, r(), clearTimeout(a), i());
      }, r = $e(() => (this.promptRev.value, this.undecoded.has(e)), (l) => {
        l || o();
      }), a = window.setTimeout(o, t);
    }) : Promise.resolve();
  }
  closeStudio() {
    this.ui.studio = null, this.ui.infoAt = null;
  }
  // ---------------------------------------------------------------- notes
  setNoteText(e, t) {
    const i = this.store.get(e);
    !i || i.text === t || this.patch(e, { text: t }, "Edit note");
  }
  renameFrame(e, t) {
    const i = t.trim() || "Untitled frame";
    this.patch(e, { title: i }, "Rename frame");
  }
  renameTool(e, t) {
    const i = t.trim();
    i && this.patch(e, { name: i }, "Rename session");
  }
  renameBoard(e) {
    const t = e.trim() || "Untitled board";
    t !== this.meta.title && (this.meta.title = t, this.sync.saveMeta({ title: t }), this.opts.onTitle && this.opts.onTitle(t));
  }
  // --------------------------------------------------------------- shapes
  armShape(e) {
    this.ui.eyedropper = null, this.ui.shapeKind = e, this.ui.shapeArmed = !0, this.ui.shapeMenu = !1, this.ui.mode = "select", this.ui.selection = [], this.ui.styleOpen = !1;
  }
  /** Select or Pan (the rail's buttons, V and H): either puts down the shape tool, the eyedropper and the Comment tool (TD-05). */
  setMode(e) {
    this.ui.mode = e, this.ui.shapeArmed = !1, this.ui.eyedropper = null, this.comments.arm(!1);
  }
  /** The last style used becomes the default for the next shape. */
  patchShape(e, t) {
    this.patch(e, t, "Restyle shape"), this.ui.shapeStyle = { ...this.ui.shapeStyle, ...t.stroke ? { stroke: t.stroke } : {}, ...t.sw ? { sw: t.sw } : {} };
  }
  // ----------------------------------------------------------- generation
  modelFor(e) {
    const t = this.catalog.value, i = t.kits.find((a) => a.id === e.kitId) || null, s = i && (i.models.find((a) => !!e.nodeDefId && a.id === e.nodeDefId) || i.models.find((a) => a.name === e.model)) || null;
    if (i && s) return { kit: i, model: s };
    const o = e.nodeDefId && t.byId.get(e.nodeDefId) || t.byName.get(e.model) || null, r = o && ev(t, o, e.kitId) || i || t.kits.find((a) => a.name === e.kind) || t.kits[0] || null;
    return { kit: r, model: o || (r ? ls(r) : null) };
  }
  /** The first run names the tool after the prompt's opening clause. */
  static conceptName(e) {
    const t = String(e || "").split(/[,.;\n]/)[0].trim().replace(/\s+/g, " ");
    if (!t) return null;
    let i = t.split(" ").slice(0, 4).join(" ");
    return i.length > 30 && (i = i.slice(0, 30).replace(/\s\S*$/, "")), i ? i.charAt(0).toUpperCase() + i.slice(1) : null;
  }
  /** Your run in this session is being sent (a moment; then it's in flight like anyone's). */
  submitting(e) {
    return this.promptRev.value, !!this.generating[e] && this.runs.has(e);
  }
  /**
   * Run a session's tool with your prompt. Answers null when the run went,
   * else why it didn't (also told in a toast): a chat's plan reports it.
   */
  generate(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "tool") return "This session is no longer on the board.";
    if (this.runs.has(e)) return "This session is still sending its last run.";
    const { model: i } = this.modelFor(t);
    if (!i)
      return this.toast("No model is available for this session.", "error"), "No model is available for this session.";
    const s = this.promptOf(e), o = Li(i, s, this.countFor(i, s), !!this.user.isAdmin), r = this.accountProblem() || o.problems[0] || this.tokensProblem(o.price);
    if (r)
      return this.toast(Pa(r), "error"), Pa(r);
    if (this.opts.runs)
      return this.generateReal(t, i, s), null;
    const a = { ...s.inputs || {} }, l = this.countFor(i, s), d = s.ref ? [s.ref] : [];
    this.generating[e] = !0, this.freshTools.delete(e), t.error && this.store.update(e, { error: null }, { history: !1 });
    const c = this.gen.run({
      sessionId: e,
      model: i,
      prompt: s.prompt || "",
      inputs: a,
      refs: d,
      count: l,
      aspect: a.aspect || void 0,
      author: this.author()
    }, {
      onResult: (u) => {
        this.results.upsert([u]), this.countStubResult(e, u, s.prompt || "");
      },
      onDone: () => {
        this.runs.delete(e), delete this.generating[e];
      },
      onError: (u, p) => {
        this.runs.delete(e), delete this.generating[e], this.results.remove(p.map((f) => f.id)), this.tellRunError(e, u);
      }
    });
    return this.runs.set(e, c), this.results.upsert(c.pending, !1), null;
  }
  /**
   * A real run: images without a record (a picture on the board that isn't a
   * result or an upload) go to your uploads first, then your prompt is saved
   * as your run draft and runRunnitNode runs it. The run, and its results,
   * arrive with the board's runs.
   */
  async generateReal(e, t, i) {
    const s = e.id, o = this.countFor(t, i), r = { runId: "", pending: [], cancel: () => {
    } };
    this.runs.set(s, r), this.generating[s] = !0, this.freshTools.delete(s), e.error && this.store.update(s, { error: null }, { history: !1 });
    const a = (u) => {
      this.disposed || (this.runs.delete(s), this.settleGenerating(s), this.tellRunError(s, u));
    };
    let l = i, d = go(t, l);
    if (d.pending.length) {
      let u;
      try {
        u = await this.uploadPending(s, d.pending);
      } catch (f) {
        a(f instanceof Error && f.message || "An image couldn't be uploaded, so the run didn't start.");
        return;
      }
      if (this.disposed) return;
      if (l = { ...i, assets: { ...i.assets || {}, ...u } }, d = go(t, l), d.pending.length) {
        a("An image couldn't be uploaded, so the run didn't start.");
        return;
      }
      const p = Li(t, l, o, !!this.user.isAdmin).problems[0];
      if (p) {
        a(Pa(p));
        return;
      }
    }
    if (this.disposed) return;
    const c = this.gen.run({
      sessionId: s,
      model: t,
      prompt: l.prompt || "",
      inputs: { ...l.inputs || {} },
      refs: l.ref ? [l.ref] : [],
      count: o,
      author: this.author(),
      // with the values the tool sets for itself (a video's length, a forced model)
      v1Inputs: Zb(t, d.inputs, l).values
    }, {
      onStarted: (u) => {
        if (this.disposed) return;
        this.runs.delete(s), this.followRun(u, s, o, l.prompt || "");
        const p = t.raw;
        this.track("generation_run", {
          node_def_id: t.id,
          tool_title: t.name,
          app_type: "RUNNIT",
          cost_per_result: p ? p.costPerResult : null,
          runnit_id: this.meta.id,
          is_team_run: !!this.meta.teamId,
          is_first_run: this.firstRunEver()
        });
      },
      onResult: () => {
      },
      onDone: () => {
      },
      onError: (u) => a(u)
    });
    r.cancel = () => c.cancel();
  }
  /**
   * Pictures without a record go to your uploads (as a drop would), so a run
   * can send them. Their records also go into the session's prompt, so the
   * next run doesn't upload them again.
   */
  async uploadPending(e, t) {
    const i = await this.uploadPictures(t);
    return this.disposed || this.setPrompt(e, { assets: i }), i;
  }
  /** Pictures (by URL) into your uploads, for a run to send: each one's record. */
  async uploadPictures(e) {
    if (!this.uploader || !this.uploader.uploadRecord)
      throw new Error("That image can't be sent to a tool from here. Upload it, or use one of your results.");
    const t = {};
    for (const i of e) {
      const s = await fetch(zte(i), { mode: "cors" }).catch(() => null);
      if (!s || !s.ok) throw new Error("An image couldn't be read, so the run didn't start.");
      const o = await s.blob(), r = (o.type.split("/")[1] || "png").replace("jpeg", "jpg"), a = new File([o], "board-reference." + r, { type: o.type || "image/png" }), l = await this.uploader.uploadRecord(a);
      if (!l.upload) throw new Error("An image couldn't be uploaded, so the run didn't start.");
      t[i] = { upload: l.upload };
    }
    return t;
  }
  /** A stub run's result landed: count it on its session card, as countRun counts a real one. */
  countStubResult(e, t, i) {
    const s = this.store.get(e);
    if (!s) return;
    const o = [t.url].concat(s.thumbs || []).slice(0, 6), r = /^(Image|Video|3D|Upscale) Tool \d+$/.test(s.name || "") && nf.conceptName(i);
    this.store.update(e, {
      thumbs: o,
      count: (s.count || 0) + 1,
      lastRunAt: Date.now(),
      ...r ? { name: r } : {}
    }, { history: !1 }), this.ui.newThumbs = { ...this.ui.newThumbs, [e]: Math.min(4, (this.ui.newThumbs[e] || 0) + 1) }, clearTimeout(this.newThumbTimers.get(e)), this.newThumbTimers.set(e, window.setTimeout(() => {
      const a = { ...this.ui.newThumbs };
      delete a[e], this.ui.newThumbs = a;
    }, 1400));
  }
  // ---------------------------------------------------------------- the Studios view's runs
  /**
   * A run from the Studios view (IL-045). Its model may not be the session's
   * and its prompt isn't your session prompt, which stays as it was (on a
   * real board, it goes back into your run draft once the run has taken
   * it). Checked as v1's Run button checks a run. An Edit run records the
   * picture it changed, so its results are that picture's next versions.
   * Answers once the run is on its way, with its id, or with why it isn't.
   */
  async runStudio(e) {
    const t = this.store.get(e.sessionId);
    if (!t || t.type !== "tool") return { error: "This session is no longer on the board." };
    const i = Li(e.model, e.up, e.count, !!this.user.isAdmin), s = this.accountProblem() || i.problems[0] || this.tokensProblem(i.price);
    return s ? { error: Pa(s) } : (this.freshTools.delete(t.id), t.error && this.store.update(t.id, { error: null }, { history: !1 }), this.opts.runs ? this.runStudioReal(t, e) : this.runStudioStub(t, e));
  }
  /** The harness's run: the stub's results, landing on the session card as a real run's do. */
  runStudioStub(e, t) {
    const { model: i, up: s, count: o } = t, r = { ...s.inputs || {} }, a = s.masks ? Object.values(s.masks)[0] : null;
    a && typeof a.boardMask == "string" && (r.__mask = a.boardMask);
    let l = "";
    const d = this.gen.run({
      sessionId: e.id,
      model: i,
      prompt: s.prompt || "",
      inputs: r,
      refs: Kv(i, s),
      count: o,
      aspect: typeof r.aspect == "string" ? r.aspect : void 0,
      author: this.author()
    }, {
      onResult: (c) => {
        this.results.upsert([c]), this.countStubResult(e.id, c, t.words);
      },
      onDone: () => this.markDone(e.id, l),
      onError: (c, u) => {
        this.markDone(e.id, l), this.results.remove(u.map((p) => p.id)), t.onFail && t.onFail(c);
      }
    });
    return l = d.runId, this.results.upsert(d.pending, !1), this.markRunning(e.id, l, Date.now()), this.studioRuns.set(l, t.words), t.edit && this.recordEdit(e.id, l, t.edit), { runId: l };
  }
  /**
   * A real run: pictures without a record go to your uploads first, and so
   * does a generation queued ahead of an upload (an input that takes several
   * sends its uploads first, so the model would get them out of order).
   */
  async runStudioReal(e, t) {
    const { model: i, count: s } = t;
    let o = t.up, r = go(i, o);
    const a = aee(i, o).filter((u) => !r.pending.includes(u)), l = r.pending.concat(a);
    if (l.length) {
      let u;
      try {
        u = await this.uploadPictures(l);
      } catch (f) {
        return { error: f instanceof Error && f.message || "An image couldn't be uploaded, so the run didn't start." };
      }
      if (this.disposed) return { error: "The board was closed, so the run didn't start." };
      if (o = { ...o, assets: { ...o.assets || {}, ...u } }, r = go(i, o), r.pending.length) return { error: "An image couldn't be uploaded, so the run didn't start." };
      const p = Li(i, o, s, !!this.user.isAdmin).problems[0];
      if (p) return { error: Pa(p) };
    }
    const d = this.draftOf(e), c = o.prompt || "";
    return new Promise((u) => {
      let p = !1;
      const f = (b) => {
        p || (p = !0, u(b));
      }, y = window.setTimeout(() => f({ error: "The run is taking a while to start. If it went, its results will appear here." }), Ste);
      this.gen.run({
        sessionId: e.id,
        model: i,
        prompt: c,
        inputs: { ...o.inputs || {} },
        refs: Kv(i, o),
        count: s,
        author: this.author(),
        // with the values the tool sets for itself (a video's length, a forced model)
        v1Inputs: Zb(i, r.inputs, o).values,
        restore: d
      }, {
        onStarted: (b) => {
          if (clearTimeout(y), this.disposed) return;
          this.studioRuns.set(b, t.words), t.onFail && this.studioFails.set(b, t.onFail), t.edit && this.recordEdit(e.id, b, t.edit), this.followRun(b, e.id, s, c);
          const w = i.raw;
          this.track("generation_run", {
            node_def_id: i.id,
            tool_title: i.name,
            app_type: "RUNNIT",
            cost_per_result: w ? w.costPerResult : null,
            runnit_id: this.meta.id,
            is_team_run: !!this.meta.teamId,
            is_first_run: this.firstRunEver()
          }), f({ runId: b });
        },
        onResult: () => {
        },
        onDone: () => {
        },
        onError: (b) => {
          clearTimeout(y), f({ error: b });
        }
      });
    });
  }
  /** Your session prompt as its run draft keeps it: what a Studios view run puts back. */
  draftOf(e) {
    const { model: t } = this.modelFor(e);
    if (!t) return null;
    const i = this.promptOf(e.id);
    return { nodeDefId: t.id, inputs: go(t, i, "draft").inputs, numResults: this.countFor(t, i) };
  }
  /** An Edit run's record: the picture it changed, so its results are that picture's next versions, and what the tool set. */
  recordEdit(e, t, i) {
    this.studioRecords.put({
      ...Qa,
      id: qv(t),
      type: "studio",
      role: "edit",
      sessionId: e,
      runId: t,
      base: i.base,
      studio: i.studio,
      createdAt: Date.now(),
      ...i.settings ? { settings: i.settings } : {},
      ...i.helper ? { helper: !0 } : {},
      ...i.precision ? { precision: i.precision } : {}
    });
  }
  /**
   * An area's mask, as v1's inpainting masks are kept (a runnitMasks record,
   * which a run's picture input carries as its mask): through the host's
   * pipeline, where it has one.
   */
  async uploadMask(e) {
    const t = this.opts.studio && this.opts.studio.uploadMask;
    if (!t) throw new Error("Masks can't be kept from here, so this edit can't run.");
    return t(e);
  }
  /** A real board's runs (runRunnitNode), rather than the harness's stub. */
  get realRuns() {
    return !!this.opts.runs;
  }
  /** Whether marked pictures are flattened by v1's annotation service (real boards), rather than here. */
  get canAnnotate() {
    return !!(this.opts.studio && this.opts.studio.annotate);
  }
  /**
   * A marked picture made one, to send in its place: by v1's annotation
   * service, which scales the overlay to the picture's full size, flattens
   * them and keeps the result in your uploads. A picture without a record
   * goes to your uploads first.
   */
  async flattenPicture(e, t) {
    const i = this.opts.studio && this.opts.studio.annotate;
    if (!i) throw new Error("Annotated pictures can't be sent from here.");
    let s = e.asset;
    const o = !!s && "upload" in s && typeof s.upload.userId == "string" && s.upload.userId !== this.user.uid;
    (!s || o) && (s = (await this.uploadPictures([e.url]))[e.url] || null);
    const r = s ? oee(s) : null;
    if (!r) throw new Error("This picture can't be annotated for a run. Try one of your results or uploads.");
    const l = { upload: await i(r, t) };
    return { url: this.assetUrl(l), asset: l };
  }
  /** The Studios view's 3D: the host's Babylon, when it lends one. */
  get babylon() {
    return this.opts.studio && this.opts.studio.babylon || null;
  }
  /** A 3D model into your Library, where the host can keep one; null where it can't (the harness). */
  upload3d(e) {
    const t = this.opts.studio && this.opts.studio.upload3d;
    return t ? t(e) : null;
  }
  /**
   * Show another picture in a card's place on the canvas (the Studios view's
   * Promote, IL-045): another version of the same image. The card keeps its
   * place and width; its height follows the new picture's shape. One undo step.
   */
  showOnCard(e, t) {
    const i = this.store.get(e);
    if (!i || i.type !== "image" || !t.w || !t.h) return !1;
    const s = Math.max(1, Math.round(i.w * (t.h / t.w))), o = {
      src: t.url,
      h: s,
      tiers: void 0,
      color: void 0,
      label: t.label || i.label,
      resultId: t.resultId || void 0,
      sessionId: t.sessionId || i.sessionId,
      asset: t.asset || void 0,
      fav: t.fav || void 0,
      video: void 0,
      videoSrc: void 0,
      previewSrc: void 0,
      dur: void 0,
      download: void 0,
      kind: void 0
    };
    return this.patch(e, o, "Show another version"), !0;
  }
  /** Follow a run you started until it's over, and tell you how it went. */
  followRun(e, t, i, s) {
    if (this.onStep) {
      const u = this.store.get(t);
      this.onStep("run", "Ran " + (u && u.type === "tool" ? u.model : "a session") + " for " + i + (i === 1 ? " result" : " results"), "run " + e + ", session " + t);
    }
    const o = this.opts.runs;
    if (!o) return;
    const r = Date.now(), a = [];
    for (let u = 0; u < i; u++)
      a.push({
        id: `${e}:p${u}`,
        sessionId: t,
        runId: e,
        status: "pending",
        url: "",
        w: 0,
        h: 0,
        prompt: s,
        model: "",
        createdAt: r + u,
        startedAt: r,
        userId: this.user.uid
      });
    this.results.replaceRun(e, a), this.markRunning(t, e, r);
    const l = window.setTimeout(() => {
      this.settleStart(e, t).catch(() => {
      });
    }, Tte);
    this.started.set(e, { sessionId: t, unwatch: () => {
    }, timer: l, seen: !1 });
    const d = o.watchRun(e, (u) => {
      u && this.onRun(u);
    }), c = this.started.get(e);
    c ? c.unwatch = d : d();
  }
  /**
   * A run answered success but hasn't shown up. runRunnitNode answers success
   * for a few failures it swallows, and a listener can also miss a run that
   * went (a dropped connection), so the server has the last word: a run's
   * charge is written with its document. There, it's followed as usual; not
   * there, it never started and cost nothing. When the server can't be
   * asked, nobody can say yet, and the board's runs bring it if it went.
   */
  async settleStart(e, t) {
    const i = this.opts.runs, s = this.started.get(e);
    if (!i || !s || s.seen) return;
    let o;
    try {
      o = await i.getRun(e, !0);
    } catch {
      o = void 0;
    }
    const r = this.started.get(e);
    if (this.disposed || !r || r.seen) return;
    if (o) {
      this.onRun(o);
      return;
    }
    this.endFollow(e), this.results.replaceRun(e, []), this.markDone(t, e);
    const a = o === null ? "The run didn't start, so nothing was charged. Please try again." : "We couldn't confirm the run started. If it did, its results will appear here, so wait a moment before running it again.";
    this.tellRunError(t, a);
    const l = this.studioFails.get(e);
    l && (this.studioFails.delete(e), l(a));
  }
  endFollow(e) {
    const t = this.started.get(e);
    t && (t.unwatch(), clearTimeout(t.timer), this.started.delete(e));
  }
  /** A run on this board changed: yours, or anyone's on the team. */
  onRun(e) {
    if (this.disposed) return;
    const t = this.started.get(e.id);
    t && !t.seen && (t.seen = !0, clearTimeout(t.timer));
    const i = k8(e, {
      storageUrl: (s) => this.opts.storageUrl ? this.opts.storageUrl(s) : s,
      modelName: (s) => {
        const o = this.toolModel(s);
        return o ? o.name : "Tool";
      },
      authorName: (s, o) => s === this.user.uid ? this.author() : o ? o.split("@")[0] : "Someone else"
    });
    if (this.results.replaceRun(e.id, i), y8(e.state)) {
      this.markRunning(e.nodeId, e.id, e.initAt || Date.now());
      return;
    }
    this.markDone(e.nodeId, e.id), LH(e.state) && this.finishRun(e, i);
  }
  onRunGone(e) {
    if (!this.started.has(e))
      for (const [t, i] of this.inflight) i.has(e) && this.markDone(t, e);
  }
  markRunning(e, t, i) {
    let s = this.inflight.get(e);
    s || (s = /* @__PURE__ */ new Map(), this.inflight.set(e, s)), s.set(t, i), this.generating[e] = !0, this.runningSince[e] = Math.min(...Array.from(s.values()));
  }
  markDone(e, t) {
    const i = this.inflight.get(e);
    i && (i.delete(t), i.size || this.inflight.delete(e)), this.settleGenerating(e);
  }
  settleGenerating(e) {
    const t = this.inflight.get(e);
    t && t.size ? (this.generating[e] = !0, this.runningSince[e] = Math.min(...Array.from(t.values()))) : this.runs.has(e) || (delete this.generating[e], delete this.runningSince[e]);
  }
  /** A run finished: count it on its session card (once), and tell whoever started it how it went. */
  finishRun(e, t) {
    const i = this.started.has(e.id);
    i && this.endFollow(e.id);
    const s = t.filter((a) => a.status === "done"), o = t.filter((a) => a.status === "moderated").length;
    if (i && this.onStep) {
      const a = e.state === "ERROR" ? "A run failed" : "A run finished with " + s.length + (s.length === 1 ? " result" : " results") + (o ? ", " + o + " withheld" : "");
      this.onStep(e.state === "ERROR" ? "error" : "run", a, "run " + e.id + ", state " + e.state + ", model " + e.nodeDefId);
    }
    const r = this.studioFails.get(e.id);
    r && this.studioFails.delete(e.id), i && (e.state === "ERROR" ? (this.tellRunError(e.nodeId, "The run failed, so its tokens are being refunded. Try again, or try another model."), r && r("The run failed, so its tokens are being refunded. Try again, or try another model.")) : o && this.toast((o === 1 ? "A result was" : o + " results were") + " withheld by the safety check.", "error")), s.length && this.countRun(e, s, i);
  }
  /**
   * A run of yours failed: the card says so (the message in its tooltip),
   * and the session's prompt says why. A toast only when that prompt isn't
   * open, so the same news isn't told twice.
   */
  tellRunError(e, t) {
    this.store.update(e, { error: t }, { history: !1 });
    const i = this.promptTool.value;
    (!i || i.id !== e) && this.toast(t, "error");
  }
  /**
   * Fold a finished run into its session card: the newest thumbnails, the
   * count, when it last ran. Whoever ran it does this; anyone does, for a run
   * left uncounted (its runner closed the board before it finished). `ran`
   * keeps one run from being counted twice.
   */
  countRun(e, t, i) {
    const s = this.store.get(e.nodeId) || null;
    if (!s || s.type !== "tool") return;
    const o = s.ran || [];
    if (o.includes(e.id)) return;
    const r = e.doneAt || e.initAt || Date.now(), a = e.userId === this.user.uid;
    if (s.lastRunAt && r < s.lastRunAt - 1e3 && !i || !a && Date.now() - r < Mte) return;
    const l = t.map((u) => u.url).concat(s.thumbs || []).filter((u, p, f) => !!u && f.indexOf(u) === p).slice(0, 6), d = this.studioRuns.has(e.id) ? this.studioRuns.get(e.id) || "" : t[0].prompt || "", c = i && /^(Image|Video|3D|Upscale|Image Edit|Video Edit) Tool \d+$/.test(s.name || "") && nf.conceptName(d);
    this.store.update(e.nodeId, {
      thumbs: l,
      count: (s.count || 0) + t.length,
      lastRunAt: Math.max(s.lastRunAt || 0, r),
      ran: [e.id].concat(o).slice(0, 12),
      error: null,
      ...c ? { name: c } : {}
    }, { history: !1 }), i && (this.ui.newThumbs = { ...this.ui.newThumbs, [e.nodeId]: Math.min(4, t.length) }, clearTimeout(this.newThumbTimers.get(e.nodeId)), this.newThumbTimers.set(e.nodeId, window.setTimeout(() => {
      const u = { ...this.ui.newThumbs };
      delete u[e.nodeId], this.ui.newThumbs = u;
    }, 1400)));
  }
  /**
   * A result deleted from its session's history comes off the session's card:
   * one fewer, and its thumbnail gone, the next newest the board holds taking
   * its place. Only a finished result was ever counted (finishRun).
   */
  uncount(e) {
    const t = this.store.get(e.sessionId) || null;
    if (!t || t.type !== "tool" || e.status !== "done") return;
    const i = (t.thumbs || []).filter((o) => o !== e.url), s = this.results.list(e.sessionId).filter((o) => o.status === "done").map((o) => o.url);
    this.store.update(t.id, {
      count: Math.max(0, (t.count || 0) - 1),
      thumbs: i.concat(s).filter((o, r, a) => !!o && a.indexOf(o) === r).slice(0, 6)
    }, { history: !1 });
  }
  /**
   * A session's whole history is in: its card says what that history holds.
   * The count is a tally kept as runs finish (countRun), so a result deleted
   * somewhere else (the Library, v1, another person) or two runs counted at
   * once leaves it off, and this is where it comes right. Only a complete
   * history can say (a long one pages in as its gallery scrolls), and only for
   * a card that has counted real runs: the demo board's seeded cards keep what
   * they were made with.
   */
  recount(e) {
    const t = this.store.get(e) || null;
    if (!t || t.type !== "tool" || !(t.ran && t.ran.length)) return;
    const i = this.results.list(e).filter((a) => a.status === "done"), s = i.map((a) => a.url).filter((a, l, d) => !!a && d.indexOf(a) === l).slice(0, 6), o = t.thumbs || [];
    if ((t.count || 0) === i.length && o.length === s.length && o.every((a, l) => a === s[l])) return;
    const r = i.map((a) => a.runId).filter((a, l, d) => !!a && d.indexOf(a) === l).slice(0, 12);
    this.store.update(e, { count: i.length, thumbs: s, ran: r }, { history: !1 });
  }
  /** A session's past runs, a page at a time (its gallery asks as it scrolls). */
  async loadHistory(e) {
    const t = this.opts.runs;
    if (!t) return;
    const i = this.historyCursor.get(e);
    if (i === "end") return;
    const s = await t.sessionPage(e, i == null ? null : i).catch((r) => (console.warn("[board] session history unavailable", r), null));
    if (!s || this.disposed) return;
    for (const r of s) this.onRun(r);
    const o = s.length ? s[s.length - 1].initAt : null;
    this.historyCursor.set(e, s.length < 24 || o == null ? "end" : o), this.historyCursor.get(e) === "end" && this.recount(e);
  }
  historyDone(e) {
    return this.historyCursor.get(e) === "end" || !this.opts.runs;
  }
  /**
   * The board's history, a page further back: every session's runs, older
   * than the newest the board follows (watchRecent) and what's been paged.
   */
  async loadBoardHistory() {
    const e = this.opts.runs;
    if (!e || this.boardCursor === "end") return;
    const t = 40, i = await e.boardPage(this.boardCursor, t).catch((o) => (console.warn("[board] the board's history unavailable", o), null));
    if (!i || this.disposed) return;
    for (const o of i) this.onRun(o);
    const s = i.length ? i[i.length - 1].initAt : null;
    this.boardCursor = i.length < t || s == null ? "end" : s;
  }
  boardHistoryDone() {
    return this.boardCursor === "end" || !this.opts.runs;
  }
  /** Remix: a fresh session preloaded with the image's prompt and model. */
  remixFrom(e, t) {
    this.ui.infoAt = null;
    const i = this.catalog.value, s = t && t.modelId && i.byId.get(t.modelId) || null, o = s && ev(i, s) || i.kits.find((p) => p.id === (e.video ? "video" : "image")) || i.kits[0];
    if (!o) return;
    const r = s || t && o.models.find((p) => p.name === t.model) || o.models[0], a = this.freeSpot(Tt.w, Tt.h), l = {
      id: kt(),
      type: "tool",
      x: a.x,
      y: a.y,
      w: Tt.w,
      h: Tt.h,
      z: 0,
      name: this.nextToolName(o.name),
      kind: o.name,
      kitId: o.id,
      model: r.name,
      nodeDefId: r.id,
      icon: wl[o.id] || "Image",
      count: 0,
      thumbs: [],
      createdBy: this.user.uid
    };
    l.z = this.store.nextZ(l), this.store.add([l]), t && t.runId && this.track("remix_initiated", { node_def_id: t.modelId || null, node_run_id: t.runId, source: "canvas_remix" });
    const d = e.asset || t && t.asset || null, c = t && t.inputs && t.modelId === r.id ? r : null, u = c ? Ap(c, t.inputs, (p) => this.assetUrl(p)) : {};
    if (u.inputs)
      for (const p of r.fields) p.kind === "seed" && delete u.inputs[p.key];
    this.setPrompt(l.id, {
      ...u,
      prompt: t ? t.prompt : "",
      ref: e.src,
      n: 1,
      assets: { ...u.assets || {}, ...d ? { [e.src]: d } : {} }
    }), this.ui.selection = [l.id], this.revealNew(l);
  }
  /** Placing from the record drops a copy where you are looking. */
  placeCopy(e) {
    this.ui.infoAt = null;
    const t = this.freeSpot(e.w, e.h), i = { ...JSON.parse(JSON.stringify(e)), id: kt(), x: t.x, y: t.y };
    i.z = this.store.nextZ(i), this.store.add([i]), this.ui.selection = [i.id], this.revealNew(i);
  }
  placeResult(e, t) {
    if (e.status !== "done" || !e.url) return null;
    const i = H2(e.w, e.h);
    return this.placeImages([{
      url: e.url,
      w: i.w,
      h: i.h,
      label: e.label || "result",
      resultId: e.id,
      sessionId: e.sessionId,
      video: e.video,
      dur: e.dur,
      videoSrc: e.videoSrc,
      previewSrc: e.previewSrc,
      asset: e.asset,
      download: e.download,
      kind: e.kind
    }], t)[0] || null;
  }
  /**
   * The record behind a result placed on the board: the board follows only
   * its newest runs (and the galleries' pages), so an older card's run is
   * read when its record is wanted. Null when there's none: deleted from its
   * session's history, or another board's (a pasted card).
   */
  loadRecord(e) {
    const t = this.results.get(e);
    if (t) return Promise.resolve(t);
    const i = this.opts.runs, s = e.split(":")[0];
    if (!i || !s) return Promise.resolve(null);
    let o = this.recordReads.get(s);
    return o || (this.readingRecords[s] = !0, o = i.getRun(s).then((r) => {
      r && r.runnitId === this.meta.id && !r.deletedAt && !this.disposed && this.onRun(r);
    }, (r) => {
      this.recordReads.delete(s), console.warn("[board] a result's record is unavailable", r);
    }).then(() => {
      delete this.readingRecords[s];
    }), this.recordReads.set(s, o)), o.then(() => this.results.get(e) || null);
  }
  /** Whether a result's record is being read (loadRecord). */
  readingRecord(e) {
    return !!this.readingRecords[e.split(":")[0]];
  }
  // ------------------------------------------------------------ recently deleted
  /**
   * Bring elements back from Recently Deleted, where they were (one undo
   * step), unless something has taken their place since: then they go
   * together to the nearest clear spot (CHAT-22). They come back selected.
   */
  recoverDeleted(e) {
    const t = new Map(this.trash.value.map((r) => [r.el.id, r])), i = [], s = [];
    for (const r of e) {
      const a = t.get(r);
      a && (Cs(a.el) ? this.recovering.has(r) || s.push(JSON.parse(JSON.stringify(a.el))) : this.store.get(r) || i.push(JSON.parse(JSON.stringify(a.el))));
    }
    if (!i.length && !s.length) return;
    if (i.length) {
      const r = this.recoverShift(i);
      if (r) for (const a of i)
        a.x += r.x, a.y += r.y;
      this.store.batch("Recover", () => this.store.add(i)), this.ui.selection = i.map((a) => a.id);
    }
    s.length && this.recoverRecords(s);
    const o = i.length + s.length;
    this.toast(o === 1 ? "Recovered 1 item." : "Recovered " + o + " items.");
  }
  /**
   * The Studios view's records Recently Deleted shows (CHAT-14): a deleted
   * result, and a picture brought into a session that's still on the board
   * (deleted with its session, it comes back with it).
   */
  recoverableRecord(e) {
    return e.role === "deleted" ? !0 : e.role === "ref" && !!this.store.get(e.sessionId);
  }
  /**
   * Recovered records: a picture brought in comes back with its marks; a
   * deleted result comes back to its run, and then its marks with it.
   */
  recoverRecords(e) {
    const t = e.filter((i) => i.role === "ref");
    t.length && this.studioRecords.restore([...t, ...this.trashedMarks(t.map((i) => i.id))]);
    for (const i of e) i.role === "deleted" && this.restoreResult(i);
    this.trashRev.value++;
  }
  /** The marks in Recently Deleted drawn on these pictures (StudioItem ids: a reference's, a result's). */
  trashedMarks(e) {
    const t = new Set(e);
    return this.sync.trash().map((i) => i.el).filter((i) => Cs(i) && i.role === "marks" && t.has(i.target));
  }
  /**
   * How far recovered elements move: nowhere while their place is clear,
   * else to freeSpot's nearest clear place for the group's box. Only what
   * sits on the board counts, not frames (things go in them), and a
   * neighbour that merely sits close doesn't move them.
   */
  recoverShift(e) {
    if (!e.filter((r) => r.type !== "frame").map(qe).some((r) => this.store.index.query(r).some((a) => {
      const l = this.store.get(a);
      return !!l && l.type !== "frame" && Id(r, qe(l));
    }))) return null;
    const s = P6(e.map(qe)), o = this.freeSpot(s.w, s.h, { x: s.x + s.w / 2, y: s.y + s.h / 2 });
    return { x: o.x - s.x, y: o.y - s.y };
  }
  /**
   * What was deleted for good elsewhere (another tab's Delete for good, or its
   * 90 days) leaves this tab's Undo too: put back, it would return without the
   * comment threads deleted with it. What Undo would bring back that's neither
   * on the board nor in Recently Deleted any more is gone for good.
   */
  forgetPurged() {
    const e = new Set(this.sync.trash().map((i) => i.el.id)), t = this.store.restorableIds().filter((i) => !e.has(i) && !this.store.get(i));
    t.length && this.store.forget(t);
  }
  /** Delete elements in Recently Deleted for good: they can't be recovered after this. */
  purgeDeleted(e) {
    const t = new Set(this.trash.value.map((l) => l.el.id)), i = e.filter((l) => this.recovering.has(l));
    i.length && this.toast(i.length === 1 ? "That picture is still being recovered." : "Those pictures are still being recovered.");
    const s = e.filter((l) => t.has(l) && !this.recovering.has(l));
    if (!s.length) return;
    const o = s.length, r = new Set(this.trash.value.filter((l) => s.includes(l.el.id) && l.el.type === "tool").map((l) => l.el.id));
    if (r.size) {
      const l = this.studioRecords.all().filter((c) => r.has(c.sessionId)).map((c) => c.id), d = this.sync.trash().filter((c) => Cs(c.el) && r.has(c.el.sessionId)).map((c) => c.el.id);
      this.studioRecords.remove(l), s.push(...l, ...d);
    }
    const a = [];
    for (const l of this.trash.value)
      !s.includes(l.el.id) || !Cs(l.el) || (l.el.role === "ref" ? a.push(l.el.id) : l.el.role === "deleted" && a.push(l.el.result.id));
    a.length && s.push(...this.trashedMarks(a).map((l) => l.id)), this.sync.purge(s), this.store.forget(s), this.comments.deleteWith(s), this.trashRev.value++, this.toast(o === 1 ? "Deleted 1 item for good." : "Deleted " + o + " items for good.");
  }
  // ---------------------------------------------------------------- pinned pictures
  /** Whether you've pinned this picture to the board. */
  isPinnedImage(e) {
    return !!e && this.pinnedUrls.value.has(e);
  }
  /**
   * Pin a picture to the board, or unpin it. Pins are yours, on this board,
   * kept with the board so they follow you to any device. An unpinned one is
   * gone at once (its records wait where deleted records do, never shown).
   */
  togglePinImage(e) {
    if (!e.url) return !1;
    if (this.isPinnedImage(e.url)) {
      const i = this.studioRecords.all().filter((s) => s.role === "pin" && s.createdBy === this.user.uid && s.url === e.url).map((s) => s.id);
      return this.studioRecords.remove(i), !1;
    }
    e.asset && this.rememberAsset(e.url, e.asset);
    const t = {
      ...Qa,
      id: kt(),
      type: "studio",
      role: "pin",
      sessionId: "",
      createdAt: Date.now(),
      createdBy: this.user.uid,
      url: e.url,
      pw: e.w || 4,
      ph: e.h || 3,
      label: (e.label || "Image").slice(0, 80),
      asset: e.asset || null,
      resultId: e.resultId || null,
      fromSession: e.sessionId || null,
      video: !!e.video,
      videoSrc: e.videoSrc || null,
      dur: e.dur || null
    };
    return this.studioRecords.put(t), this.prefs.pinHintSeen || (this.prefs.pinHintSeen = !0, this.persistPrefs(), this.toast(jn.first)), !0;
  }
  /** The placed card for a result, if any. */
  placedFor(e) {
    for (const t of this.store.all()) if (t.type === "image" && t.resultId === e) return t;
    return null;
  }
  /**
   * A star. On a real board it's yours, v1's favorite (the Library lists
   * it), and only your own finished results take one; in the harness it's
   * the card's. The image's result follows along in onDocChange there (so
   * undo and redo do too).
   */
  toggleFav(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "image") return;
    if (this.opts.favorites) {
      const s = t.resultId && this.results.get(t.resultId) || null;
      s ? this.toggleResultFav(s) : t.resultId && this.opts.runs ? this.loadRecord(t.resultId).then((o) => {
        o ? this.toggleResultFav(o) : this.toast("Only generated results can be favorited.");
      }) : this.toast("Only generated results can be favorited.");
      return;
    }
    const i = !t.fav;
    this.patch(e, { fav: i || void 0 }, i ? "Favourite" : "Unfavourite");
  }
  isFav(e, t) {
    const i = this.opts.favorites;
    return i ? (i.uuids.value, !!(e && i.has(e.uuid))) : !!(t && t.fav || e && e.fav);
  }
  /** Whether the star is yours to set: on a real board, your own finished results only (v1's rule). */
  canFav(e, t) {
    const i = this.opts.favorites;
    return i ? !!e && i.canStar(e) : !!(t || e);
  }
  async toggleResultFav(e) {
    const t = this.opts.favorites;
    if (!t) {
      this.results.upsert([{ ...e, fav: !e.fav || void 0 }]);
      return;
    }
    if (!t.canStar(e)) {
      this.toast("Only the person who ran it can favorite a result.");
      return;
    }
    try {
      const i = !t.has(e.uuid);
      await t.set(e, i), i && this.track("result_favorited", this.resultEvent(e));
    } catch (i) {
      console.error("[board] favorite not saved", i), this.toast("The favorite couldn't be saved.", "error");
    }
  }
  /**
   * Why no run can go on this board, whatever its form and price: its team
   * is deactivated. The board and its results stay; new runs don't. Empty
   * when runs can go, and while the team's state is unknown (the server
   * decides then, and says so when it refuses).
   */
  accountProblem() {
    return !this.meta.teamId || this.teamActive.value !== !1 ? "" : "This " + this.labels.team + " is deactivated, so it can't run new generations.";
  }
  /** the board menu offers Take the tour (IL-095) where the host has it */
  get canOpenTour() {
    return !!this.opts.onOpenTour;
  }
  openTour() {
    this.opts.onOpenTour && this.opts.onOpenTour();
  }
  get canGetTokens() {
    return !!this.opts.onGetTokens;
  }
  /** Open the plan of the account that pays for this board, to get more tokens. */
  getTokens() {
    this.opts.onGetTokens && this.opts.onGetTokens(this.meta.teamId || null);
  }
  /** Tell the host's analytics (v1's events and property names), marked as a canvas board's. */
  track(e, t) {
    if (this.opts.track)
      try {
        this.opts.track(e, { ...t, board_type: "CANVAS" });
      } catch (i) {
        console.warn("[board] analytics", i);
      }
  }
  /** A result's identity for analytics, as v1 names it. */
  resultEvent(e) {
    return { result_type: e.kind === "video" ? "VID" : e.kind === "3d" ? "ASSET_3D" : "IMG", node_run_id: e.runId || null, node_def_id: e.modelId || null, runnit_id: this.meta.id };
  }
  /** v1's "first run ever" for analytics: once per person, in this browser. */
  firstRunEver() {
    const e = "rd_has_generated_" + this.user.uid;
    try {
      return window.localStorage.getItem(e) ? !1 : (window.localStorage.setItem(e, "1"), !0);
    } catch {
      return !1;
    }
  }
  /** A result was downloaded (the info view's Download). */
  trackDownload(e) {
    const t = this.resultEvent(e);
    this.track("image_downloaded", { result_type: t.result_type, node_run_id: t.node_run_id, node_def_id: t.node_def_id, bulk: !1 });
  }
  /**
   * Why a run of this price (hundredths) can't go for want of tokens, as
   * v1's Run button says it; empty when it can. Only a personal account is
   * held to its balance here: some teams may run below zero, which only the
   * server knows, and it says so when it refuses.
   */
  tokensProblem(e) {
    const t = this.balance.value;
    return !t || t.team || e == null || e <= t.tokens ? "" : "Not enough tokens: this run costs " + hl(e) + " and you have " + hl(Math.max(0, t.tokens));
  }
  /**
   * Your trained models a model field can use on this board: on a team
   * board yours in the team and its shared ones, else your own. Empty in the
   * harness, which has none.
   */
  async trainedModels() {
    const e = this.opts.models;
    if (!e) return [];
    const t = await e.list(this.meta.teamId || null);
    return this.trainedModelsSeen.value = t, t;
  }
  /** The picture of a model chosen for a field (it carries its avatar, as v1 keeps it): small, and full. */
  modelPicture(e) {
    const t = this.opts.storageUrl, i = e && typeof e == "object" ? e.avatar : null;
    if (!t || !i || typeof i != "object") return null;
    const s = x8(i);
    return { thumb: t(s.thumb), image: t(s.file) };
  }
  /** Whether you can delete a result from its session's history: your own, as v1 allows. */
  canDelete(e) {
    return !!(this.opts.runs && e && e.runId && e.uuid && e.userId === this.user.uid && e.status !== "pending");
  }
  /**
   * Delete a result from its session's history (v1 marks it deleted in its
   * run), and take it off its session's card.
   */
  async deleteResult(e) {
    const t = this.opts.runs;
    if (!t || !e.runId || !e.uuid) return !1;
    try {
      await t.deleteResult(e.runId, e.uuid, this.user.uid);
    } catch (i) {
      return console.error("[board] result not deleted", i), this.toast("That result couldn't be deleted.", "error"), !1;
    }
    return this.ui.infoAt === "result:" + e.id && (this.ui.infoAt = null), this.results.remove([e.id]), this.historyCursor.get(e.sessionId) === "end" ? this.recount(e.sessionId) : this.uncount(e), this.binResult(e), !0;
  }
  /**
   * A deleted result waits in Recently Deleted (CHAT-14): its record is
   * written straight there, with the result as it was, so Recover can take
   * the delete back.
   */
  binResult(e) {
    const t = {
      ...Qa,
      id: nee(e.id),
      type: "studio",
      role: "deleted",
      sessionId: e.sessionId,
      createdAt: Date.now(),
      createdBy: this.user.uid,
      result: JSON.parse(JSON.stringify(e))
    };
    this.studioRecords.put(t), this.studioRecords.remove([t.id]), this.trashRev.value++, this.toast(e.video ? "Video deleted. It waits in Recently Deleted." : "Picture deleted. It waits in Recently Deleted.");
  }
  /** A recovered result: back on its run, in its session's history, and counted. */
  async restoreResult(e) {
    const t = e.result, i = this.opts.runs;
    if (i && this.realRuns && t.runId && t.uuid) {
      this.recovering.add(e.id);
      try {
        await i.restoreResult(t.runId, t.uuid);
      } catch (o) {
        return console.error("[board] result not recovered", o), this.toast("That picture couldn't be recovered.", "error"), !1;
      } finally {
        this.recovering.delete(e.id);
      }
    }
    const s = this.trashedMarks([t.id]);
    return s.length && this.studioRecords.restore(s), this.results.upsert([t]), this.historyCursor.get(t.sessionId) === "end" ? this.recount(t.sessionId) : this.countBack(t), this.sync.purge([e.id]), this.trashRev.value++, !0;
  }
  /** uncount's other way: one more on the session's card, its picture among the thumbnails. */
  countBack(e) {
    const t = this.store.get(e.sessionId) || null;
    if (!t || t.type !== "tool" || e.status !== "done") return;
    const i = (t.thumbs || []).concat(e.url).filter((s, o, r) => !!s && r.indexOf(s) === o).slice(0, 6);
    this.store.update(t.id, { count: (t.count || 0) + 1, thumbs: i }, { history: !1 });
  }
  /**
   * Save a file under a name. The file is fetched first: a download link to
   * another origin (Storage, the CDN) ignores the name it's given.
   */
  async saveFile(e, t) {
    try {
      const i = await fetch(e, { mode: "cors" });
      if (!i.ok) throw new Error("HTTP " + i.status);
      const s = URL.createObjectURL(await i.blob()), o = document.createElement("a");
      o.href = s, o.download = t, document.body.appendChild(o), o.click(), o.remove(), window.setTimeout(() => URL.revokeObjectURL(s), 1e4);
    } catch (i) {
      console.warn("[board] download fell back to opening the file", i), window.open(e, "_blank", "noopener");
    }
  }
  // ------------------------------------------------------------ clipboard
  copy(e = !1) {
    const t = this.ui.selection.map((o) => this.store.get(o)).filter(Boolean);
    if (!t.length) return;
    const i = new Set(t.map((o) => o.id));
    for (const o of t) if (o.type === "frame") for (const r of this.childrenOf(o)) i.add(r);
    const s = Array.from(i).map((o) => this.store.get(o)).filter(Boolean);
    lr = { els: JSON.parse(JSON.stringify(s)), board: this.meta.id }, this.pasteCount = 0;
    try {
      navigator.clipboard.writeText(JSON.stringify({ rdBoard: 1, board: lr.board, els: lr.els })).catch(() => {
      });
    } catch {
    }
    e && this.deleteIds(this.ui.selection.slice());
  }
  /**
   * `fromBoard`: the board the system clipboard's copy came from, where it
   * says. Copied on this board with the originals in view, each paste steps
   * down and right; anything else (another board's, or this board's from out
   * of view) lands in the middle of the view (IL-100: on another board, an
   * empty one above all, it landed where it had been, often out of sight).
   */
  paste(e, t) {
    const i = e || (lr ? lr.els : null);
    if (!i || !i.length) return;
    const s = e ? t : lr ? lr.board : null, o = s == null || s === this.meta.id;
    this.pasteCount++;
    let r = 1 / 0, a = 1 / 0, l = -1 / 0, d = -1 / 0;
    for (const k of i) {
      const S = qe(k);
      r = Math.min(r, S.x), a = Math.min(a, S.y), l = Math.max(l, S.x + S.w), d = Math.max(d, S.y + S.h);
    }
    const c = { x: r, y: a, w: l - r, h: d - a }, u = this.viewportCentre(), p = Math.round(u.x - (c.x + c.w / 2)), f = Math.round(u.y - (c.y + c.h / 2)), y = o && this.engine ? this.engine.isInView({ ...i[0] }) : !1, b = y ? 28 * this.pasteCount : 0, w = i.map((k, S) => {
      const _ = JSON.parse(JSON.stringify(k));
      return _.id = kt(), _.x = y ? k.x + b : k.x + p, _.y = y ? k.y + b : k.y + f, _.type === "frame" && delete _.locked, _.z = this.store.nextZ(_, _.type === "frame") + S, _;
    });
    this.store.batch("Paste", () => this.store.add(w)), this.ui.selection = w.filter((k) => k.type !== "frame" || w.length === 1).map((k) => k.id);
  }
  childrenOf(e) {
    const t = [];
    for (const i of this.store.query(qe(e))) {
      if (i.id === e.id || i.type === "frame") continue;
      const s = qe(i), o = s.x + s.w / 2, r = s.y + s.h / 2;
      o > e.x && o < e.x + e.w && r > e.y && r < e.y + e.h && t.push(i.id);
    }
    return t;
  }
  /** The locked frame something sits in (its centre inside, as childrenOf counts), if any. */
  lockedFrameOf(e) {
    if (e.type === "frame") return null;
    const t = qe(e), i = t.x + t.w / 2, s = t.y + t.h / 2;
    for (const o of this.store.query({ x: i - 1, y: s - 1, w: 2, h: 2 }))
      if (o.type === "frame" && o.locked && i > o.x && i < o.x + o.w && s > o.y && s < o.y + o.h) return o;
    return null;
  }
  /**
   * Stays where it is: a locked frame (IL-070), or what one holds (B31).
   * Held things can still be selected, opened, restacked and commented on;
   * they can't be moved, resized or deleted until the frame is unlocked.
   */
  isHeld(e) {
    return !!e && (qd(e) || !!this.lockedFrameOf(e));
  }
  frameFor(e) {
    const t = qe(e);
    let i = null;
    for (const s of this.store.query(t))
      s.type === "frame" && t.x >= s.x && t.y >= s.y && t.x < s.x + s.w && t.y < s.y + s.h && (!i || s.z > i.z) && (i = s);
    return i;
  }
  /** The session that made an image: its record, else the tool in its frame. */
  toolFor(e) {
    if (e.sessionId) {
      const i = this.store.get(e.sessionId);
      if (i && i.type === "tool") return i;
    }
    const t = this.frameFor(e);
    if (!t) return null;
    for (const i of this.store.query(qe(t)))
      if (i.type === "tool" && i.x >= t.x && i.y >= t.y && i.x < t.x + t.w && i.y < t.y + t.h) return i;
    return null;
  }
  // --------------------------------------------------------------- history
  undo() {
    this.store.undo();
  }
  redo() {
    this.store.redo();
  }
  /** The arrow keys: the selection, a frame with what it holds; a locked frame and what it holds stay. */
  nudge(e, t) {
    const i = this.ui.selection.filter((r) => !this.isHeld(this.store.get(r)));
    if (!i.length) return;
    const s = new Set(i);
    for (const r of i) {
      const a = this.store.get(r);
      if (a && a.type === "frame")
        for (const l of this.childrenOf(a)) this.isHeld(this.store.get(l)) || s.add(l);
    }
    const o = [];
    for (const r of s) {
      const a = this.store.get(r);
      a && o.push([r, { x: a.x + e, y: a.y + t }]);
    }
    this.store.batch("Nudge", () => this.store.updateMany(o));
  }
  // ----------------------------------------------------------------- misc
  toast(e, t = "info", i) {
    const s = ++this.toastSeq;
    this.ui.toast = { id: s, text: e, tone: t, action: i }, clearTimeout(this.toastTimer);
    const o = t === "error" || e.length > 70 ? Math.max(5200, Math.min(1e4, 1800 + e.length * 45)) : i ? 6e3 : 3200;
    this.toastTimer = window.setTimeout(() => {
      this.ui.toast && this.ui.toast.id === s && (this.ui.toast = null);
    }, o);
  }
  dismissToast() {
    clearTimeout(this.toastTimer), this.ui.toast = null;
  }
  persistPrefs() {
    this.prefs.lightCanvas = this.ui.lightCanvas, this.prefs.shapeStyle = { ...this.ui.shapeStyle }, this.prefs.shapeKind = this.ui.shapeKind, this.prefs.histOpen = this.ui.histOpen, this.prefs.miniOpen = this.ui.miniOpen, this.prefs.recentIds = this.ui.recentIds.slice(0, 200), this.prefs.pinnedIds = this.ui.pinnedIds.slice(), this.prefs.pinnedModelIds = this.ui.pinnedModelIds.slice(), this.prefs.cameraViews = this.ui.cameraViews.map((e) => ({ ...e })), this.prefs.noteTint = this.ui.noteTint, this.prefs.promptH = this.ui.promptH, this.prefs.library = { tab: this.ui.library.tab, category: this.ui.library.category, saveBoard: this.ui.library.saveLevels.board, saveTeam: this.ui.library.saveLevels.team }, fQ(this.user.uid, this.meta.id, this.prefs);
  }
  /**
   * The board's sessions as the session lists show them: pinned ones first,
   * in the order pinned (Tyler, 2026-10-14: pinned sessions "stay at the
   * top"), then the most recently touched, then the rest by newest placement.
   */
  recentTools() {
    this.docRev.value;
    const e = [];
    for (const r of this.store.all()) r.type === "tool" && e.push(r);
    const t = new Map(e.map((r) => [r.id, r])), i = this.ui.pinnedIds.filter((r) => t.has(r)).map((r) => t.get(r)), s = this.ui.recentIds.filter((r) => t.has(r) && !this.ui.pinnedIds.includes(r)).map((r) => t.get(r)), o = e.filter((r) => !this.ui.recentIds.includes(r.id) && !this.ui.pinnedIds.includes(r.id)).sort((r, a) => (a.lastRunAt || a.z) - (r.lastRunAt || r.z));
    return i.concat(s, o);
  }
  /** A session pinned to the top of the session lists (yours, on this board). */
  isPinned(e) {
    return this.ui.pinnedIds.includes(e);
  }
  /** Pin a session to the top of the session lists, after those pinned before it; or unpin it. */
  togglePinned(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "tool") return;
    const i = !this.isPinned(e);
    this.ui.pinnedIds = i ? [...this.ui.pinnedIds, e] : this.ui.pinnedIds.filter((s) => s !== e), this.persistPrefs(), this.savePin("sessions", e, i);
  }
  /** A model pinned to the top of the model menus (yours, on every board). */
  isModelPinned(e) {
    return this.ui.pinnedModelIds.includes(e);
  }
  /**
   * Pin a model to the top of the model menus, after those pinned before it;
   * or unpin it. Only a model in the catalog can be pinned; one that has left
   * it can still be unpinned.
   */
  toggleModelPinned(e) {
    const t = !this.isModelPinned(e);
    t && !this.catalog.value.byId.has(e) || (this.ui.pinnedModelIds = t ? [...this.ui.pinnedModelIds, e] : this.ui.pinnedModelIds.filter((i) => i !== e), this.persistPrefs(), this.savePin("models", e, t));
  }
  /**
   * A pin list as your account has it (IL-068), from any device: it replaces
   * this browser's, which keeps a copy for the next open. An account with
   * none saved yet takes this browser's, on its first answer only: later, no
   * list means no pins (a refused first pin comes back that way).
   */
  pinsFromAccount(e, t) {
    const i = this.pinsKept[e] === "unknown";
    this.pinsKept[e] = "yes";
    const s = e === "models" ? this.ui.pinnedModelIds : this.ui.pinnedIds;
    if (t === null && i) {
      s.length && this.opts.pins && this.opts.pins.seed(e, s.slice()).catch((o) => console.warn("[board] your pins could not be saved to your account", o));
      return;
    }
    t === null && (t = []), !(t.length === s.length && t.every((o, r) => o === s[r])) && (e === "models" ? this.ui.pinnedModelIds = t.slice() : this.ui.pinnedIds = t.slice(), this.persistPrefs());
  }
  /** A pin or unpin, sent to your account where it keeps them; a refusal comes back as its pins, undoing this one. */
  savePin(e, t, i) {
    const s = this.opts.pins;
    !s || this.pinsKept[e] === "off" || s.pin(e, t, i).catch((o) => {
      console.warn("[board] pin not saved to your account", o), this.toast(i ? "Your pin couldn't be saved. Please try again." : "Your pin couldn't be removed. Please try again.", "error");
    });
  }
  // ---------------------------------------------------------------- your camera views (IL-077)
  /**
   * Save a camera view from Change camera, by name: yours alone, on every
   * board. The newest goes last. Null when you already keep the most.
   */
  saveCameraView(e, t) {
    if (this.ui.cameraViews.length >= Zp)
      return this.toast("You can keep up to " + Zp + " camera views. Remove one first."), null;
    const i = { id: kt(), name: W2(t) || "Camera view", ...Xs(e), createdAt: Date.now() };
    return this.ui.cameraViews = [...this.ui.cameraViews, i], this.keepViews(), i;
  }
  renameCameraView(e, t) {
    const i = W2(t), s = this.ui.cameraViews.find((o) => o.id === e);
    !s || !i || i === s.name || (this.ui.cameraViews = this.ui.cameraViews.map((o) => o.id === e ? { ...o, name: i } : o), this.keepViews());
  }
  removeCameraView(e) {
    this.ui.cameraViews.some((t) => t.id === e) && (this.ui.cameraViews = this.ui.cameraViews.filter((t) => t.id !== e), this.keepViews());
  }
  /**
   * Your views as your account has them, from any device: they replace this
   * browser's. An account with none yet takes this browser's, on its first
   * answer only, as your pins do.
   */
  viewsFromAccount(e) {
    if (this.viewsKept === "off") return;
    const t = this.viewsKept === "unknown";
    if (this.viewsKept = "yes", e === null && t) {
      this.ui.cameraViews.length && this.opts.pins && this.opts.pins.saveViews && this.opts.pins.saveViews(this.ui.cameraViews.map((s) => ({ ...s }))).catch((s) => {
        console.warn("[board] your camera views could not be saved to your account", s), this.viewsKept = "off";
      });
      return;
    }
    const i = V2(e || []);
    JSON.stringify(i) !== JSON.stringify(this.ui.cameraViews) && (this.ui.cameraViews = i, this.persistPrefs());
  }
  /** Your views, kept here and sent to your account where it keeps them. */
  keepViews() {
    this.persistPrefs();
    const e = this.opts.pins;
    !e || !e.saveViews || this.viewsKept === "off" || e.saveViews(this.ui.cameraViews.map((t) => ({ ...t }))).catch((t) => {
      console.warn("[board] camera views not saved to your account", t), this.toast("Your camera views are kept in this browser only for now.", "error"), this.viewsKept = "off";
    });
  }
  /** A model list as the model menus show it: your pinned models first, in the order pinned, then the rest in their own order. */
  pinnedModelsFirst(e) {
    const t = this.ui.pinnedModelIds;
    if (!t.length) return e;
    const i = e.filter((s) => t.includes(s.id)).sort((s, o) => t.indexOf(s.id) - t.indexOf(o.id));
    return i.length ? i.concat(e.filter((s) => !t.includes(s.id))) : e;
  }
  /** Images in board order, for the info modal's previous / next. */
  imagesInOrder() {
    const e = [];
    for (const t of this.store.all()) t.type === "image" && e.push(t);
    return e.sort((t, i) => t.z - i.z);
  }
  /** World rect of the selection, or null. */
  selectionRect() {
    return this.store.bounds(this.ui.selection);
  }
  zoomAroundPoint(e, t, i) {
    this.engine && this.engine.zoomAt(e - this.view.left, t - this.view.top, i);
  }
  setCamera(e) {
    this.engine && this.engine.setCamera({ ...e, zoom: No(e.zoom) });
  }
}
const Ete = 24;
function H2(n, e, t = 360) {
  return !n || !e ? my("4:3") : n >= e ? { w: t, h: Math.round(t * e / n) } : { w: Math.round(t * n / e), h: t };
}
function Rte(n, e) {
  const t = (i) => i === "note" || i === "tool" || i === "chat" ? "dom" : i;
  return t(n.type) === t(e.type);
}
function zte(n) {
  return /^(blob|data):/.test(n) ? n : n + (n.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1";
}
function V2(n) {
  return Array.isArray(n) ? n.map(fee).filter((e) => !!e).slice(0, Zp) : [];
}
function W2(n) {
  return n.replace(/\s+/g, " ").trim().slice(0, yy);
}
const $te = { class: "rd-head" }, Dte = { class: "rd-mark" }, Ote = { class: "rd-titles" }, Lte = {
  key: 0,
  class: "rd-head-acts"
}, Bte = {
  key: 0,
  class: "rd-empty",
  "data-testid": "trash-empty"
}, Fte = { class: "rd-empty-mark" }, Nte = { class: "rd-group-head" }, Ute = {
  class: "rd-avatar",
  "aria-hidden": "true"
}, Gte = { class: "rd-who" }, jte = ["title"], Hte = { key: 0 }, Vte = { class: "rd-when" }, Wte = ["title"], qte = { class: "rd-group-acts" }, Kte = ["onClick"], Yte = ["onClick", "onBlur"], Xte = ["data-id"], Jte = ["src"], Zte = {
  key: 0,
  class: "rd-play",
  "aria-hidden": "true"
}, Qte = ["src"], ene = {
  key: 0,
  class: "rd-play",
  "aria-hidden": "true"
}, tne = {
  key: 3,
  class: "rd-frame"
}, nne = {
  key: 4,
  class: "rd-shape",
  viewBox: "0 0 100 100",
  "aria-hidden": "true"
}, ine = ["stroke"], sne = ["stroke"], one = ["stroke"], rne = {
  key: 0,
  d: "M58 24 H78 V44"
}, ane = {
  key: 5,
  class: "rd-tool"
}, lne = { class: "rd-item-acts" }, dne = ["onClick"], cne = ["title", "aria-label", "onClick", "onBlur"], une = { class: "rd-item-name" }, hne = ["title"], pne = ["onClick"], fne = 24, mne = /* @__PURE__ */ Re({
  __name: "RecentlyDeleted",
  setup(n) {
    const { board: e } = tt(), t = /* @__PURE__ */ K(null), i = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K([]), o = I(() => {
      const _ = [], x = /* @__PURE__ */ new Map();
      for (const T of e.trash.value) {
        const M = T.deletedAt + ":" + (T.deletedBy || "");
        let z = x.get(M);
        z || (z = { key: M, at: T.deletedAt, email: T.deletedByEmail || "", mine: !!T.deletedBy && T.deletedBy === e.user.uid, items: [], due: T.hardDeleteAt }, x.set(M, z), _.push(z)), z.items.push(T), T.hardDeleteAt < z.due && (z.due = T.hardDeleteAt);
      }
      return _;
    }), r = I(() => e.trash.value.length), a = I(() => e.trash.value.map((_) => _.el.id)), l = {
      rect: { label: "Rectangle", icon: "Square" },
      ellipse: { label: "Ellipse", icon: "Circle" },
      line: { label: "Line", icon: "Slash" },
      arrow: { label: "Arrow", icon: "ArrowUpRight" }
    };
    function d(_) {
      const x = _.el;
      if (!Cs(x)) return null;
      if (x.role === "deleted") {
        const T = x.result;
        return { url: T.thumb || T.url, video: !!T.video, label: T.label || (T.video ? "Video" : "Image") };
      }
      return x.role === "ref" ? { url: x.url, video: !1, label: x.label || "Image" } : null;
    }
    function c(_) {
      const x = _.el, T = d(_);
      return T ? T.video ? { one: "video", many: "videos", icon: "Video" } : { one: "image", many: "images", icon: "Image" } : x.type === "image" ? x.video ? { one: "video", many: "videos", icon: "Video" } : { one: "image", many: "images", icon: "Image" } : x.type === "note" ? { one: "note", many: "notes", icon: "StickyNote" } : x.type === "chat" ? { one: "chat", many: "chats", icon: "MessagesSquare" } : x.type === "frame" ? { one: "frame", many: "frames", icon: "Frame" } : x.type === "shape" ? { one: "shape", many: "shapes", icon: (l[x.shape] || l.rect).icon } : { one: "tool session", many: "tool sessions", icon: wl[x.kitId] || "Image" };
    }
    function u(_) {
      const x = _.el, T = d(_);
      if (T) return T.label;
      if (x.type === "image") return x.label || (x.video ? "Video" : "Image");
      if (x.type === "note") {
        const M = (x.text || "").replace(/\s+/g, " ").trim();
        return M ? M.length > 60 ? M.slice(0, 60) + "…" : M : "Empty note";
      }
      return x.type === "frame" ? x.title || "Frame" : x.type === "chat" ? x.name || "Chat" : x.type === "shape" ? (l[x.shape] || l.rect).label : x.name || "Tool session";
    }
    function p(_) {
      const x = /* @__PURE__ */ new Map();
      for (const T of _.items) {
        const M = c(T), z = x.get(M.one) || { n: 0, one: M.one, many: M.many };
        z.n++, x.set(M.one, z);
      }
      return Array.from(x.values()).map((T) => T.n + " " + (T.n === 1 ? T.one : T.many)).join(", ");
    }
    function f(_) {
      return s.value.includes(_.key) ? _.items : _.items.slice(0, fne);
    }
    function y(_) {
      return new Date(_).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
    function b(_) {
      i.value = null, e.recoverDeleted(_);
    }
    function w(_, x) {
      if (i.value !== _) {
        i.value = _;
        return;
      }
      i.value = null, e.purgeDeleted(x);
    }
    function k() {
      e.ui.trashOpen = !1;
    }
    let S = null;
    return ot(() => {
      S = document.activeElement, t.value && t.value.focus({ preventScroll: !0 });
    }), Ve(() => {
      S && document.contains(S) && S.focus({ preventScroll: !0 });
    }), (_, x) => (g(), v("div", {
      class: "rd",
      "data-testid": "trash",
      onPointerdown: Pe(k, ["self"]),
      onWheel: x[4] || (x[4] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", {
        ref_key: "card",
        ref: t,
        class: "rd-card",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "rd-title",
        tabindex: "-1",
        onPointerdown: x[3] || (x[3] = Pe(() => {
        }, ["stop"]))
      }, [
        h("header", $te, [
          h("span", Dte, [
            C(R, {
              name: "Trash2",
              size: 17
            })
          ]),
          h("div", Ote, [
            x[5] || (x[5] = h("h2", { id: "rd-title" }, "Recently Deleted", -1)),
            h("p", null, "Deleted items stay here for " + A(m(dv)) + " days, then they're deleted for good.", 1)
          ]),
          r.value ? (g(), v("div", Lte, [
            h("button", {
              class: "rd-btn",
              "data-testid": "trash-recover-all",
              onClick: x[0] || (x[0] = (T) => b(a.value))
            }, [
              C(R, {
                name: "RotateCcw",
                size: 13
              }),
              x[6] || (x[6] = X("Recover all ", -1))
            ]),
            h("button", {
              class: U(["rd-btn is-danger", { "is-confirming": i.value === "all" }]),
              "data-testid": "trash-delete-all",
              onClick: x[1] || (x[1] = (T) => w("all", a.value)),
              onBlur: x[2] || (x[2] = (T) => i.value === "all" && (i.value = null))
            }, [
              C(R, {
                name: i.value === "all" ? "Check" : "Trash2",
                size: 13
              }, null, 8, ["name"]),
              X(A(i.value === "all" ? "Delete all for good?" : "Delete all"), 1)
            ], 34)
          ])) : E("", !0),
          h("button", {
            class: "rd-close",
            title: "Close",
            "aria-label": "Close",
            "data-testid": "trash-close",
            onClick: k
          }, [
            C(R, {
              name: "X",
              size: 15
            })
          ])
        ]),
        r.value ? (g(), Ce(Tp, {
          key: 1,
          tag: "div",
          name: "rd-pop",
          class: "rd-groups"
        }, {
          default: et(() => [
            (g(!0), v(H, null, me(o.value, (T) => (g(), v("section", {
              key: T.key,
              class: "rd-group",
              "data-testid": "trash-group"
            }, [
              h("header", Nte, [
                h("span", Ute, A(T.mine && m(e).user.initials ? m(e).user.initials : m(ta)(T.email || "Someone")), 1),
                h("div", Gte, [
                  h("span", {
                    class: "rd-email",
                    title: T.email,
                    "data-testid": "trash-deleted-by"
                  }, [
                    X(A(T.email || "Someone"), 1),
                    T.mine ? (g(), v("em", Hte, "you")) : E("", !0)
                  ], 8, jte),
                  h("span", Vte, "Deleted " + A(m(Cp)(T.at)) + " · " + A(p(T)), 1)
                ]),
                h("span", {
                  class: "rd-left",
                  title: "Deleted for good on " + y(T.due)
                }, [
                  C(R, {
                    name: "Clock",
                    size: 12
                  }),
                  X(A(m(xO)(T.due)), 1)
                ], 8, Wte),
                h("div", qte, [
                  h("button", {
                    class: "rd-btn",
                    "data-testid": "trash-group-recover",
                    onClick: (M) => b(T.items.map((z) => z.el.id))
                  }, [
                    C(R, {
                      name: "RotateCcw",
                      size: 13
                    }),
                    x[8] || (x[8] = X("Recover ", -1))
                  ], 8, Kte),
                  h("button", {
                    class: U(["rd-btn is-danger", { "is-confirming": i.value === T.key }]),
                    "data-testid": "trash-group-delete",
                    onClick: (M) => w(T.key, T.items.map((z) => z.el.id)),
                    onBlur: (M) => i.value === T.key && (i.value = null)
                  }, [
                    C(R, {
                      name: i.value === T.key ? "Check" : "Trash2",
                      size: 13
                    }, null, 8, ["name"]),
                    X(A(i.value === T.key ? "Delete for good?" : "Delete"), 1)
                  ], 42, Yte)
                ])
              ]),
              C(Tp, {
                tag: "div",
                name: "rd-pop",
                class: "rd-grid"
              }, {
                default: et(() => [
                  (g(!0), v(H, null, me(f(T), (M) => (g(), v("div", {
                    key: M.el.id,
                    class: "rd-item",
                    "data-id": M.el.id,
                    "data-testid": "trash-item"
                  }, [
                    h("div", {
                      class: U(["rd-thumb", "is-" + M.el.type])
                    }, [
                      M.el.type === "image" ? (g(), v(H, { key: 0 }, [
                        h("img", {
                          src: m(Wt)(M.el.src),
                          alt: "",
                          loading: "lazy",
                          draggable: "false"
                        }, null, 8, Jte),
                        M.el.video ? (g(), v("span", Zte, [
                          C(R, {
                            name: "Play",
                            size: 14
                          })
                        ])) : E("", !0)
                      ], 64)) : d(M) ? (g(), v(H, { key: 1 }, [
                        h("img", {
                          src: m(Wt)(d(M).url),
                          alt: "",
                          loading: "lazy",
                          draggable: "false"
                        }, null, 8, Qte),
                        d(M).video ? (g(), v("span", ene, [
                          C(R, {
                            name: "Play",
                            size: 14
                          })
                        ])) : E("", !0)
                      ], 64)) : M.el.type === "note" ? (g(), v("div", {
                        key: 2,
                        class: U(["rd-note", "tint-" + M.el.tint])
                      }, [
                        h("span", null, A(M.el.text || ""), 1)
                      ], 2)) : M.el.type === "frame" ? (g(), v("div", tne, [
                        h("span", null, A(M.el.title || "Frame"), 1)
                      ])) : M.el.type === "shape" ? (g(), v("svg", nne, [
                        M.el.shape === "rect" ? (g(), v("rect", {
                          key: 0,
                          x: "18",
                          y: "28",
                          width: "64",
                          height: "44",
                          rx: "5",
                          stroke: M.el.stroke
                        }, null, 8, ine)) : M.el.shape === "ellipse" ? (g(), v("ellipse", {
                          key: 1,
                          cx: "50",
                          cy: "50",
                          rx: "33",
                          ry: "23",
                          stroke: M.el.stroke
                        }, null, 8, sne)) : (g(), v("g", {
                          key: 2,
                          stroke: M.el.stroke
                        }, [
                          x[9] || (x[9] = h("line", {
                            x1: "22",
                            y1: "76",
                            x2: "78",
                            y2: "24"
                          }, null, -1)),
                          M.el.shape === "arrow" ? (g(), v("path", rne)) : E("", !0)
                        ], 8, one))
                      ])) : (g(), v("span", ane, [
                        C(R, {
                          name: c(M).icon,
                          size: 22
                        }, null, 8, ["name"])
                      ])),
                      h("div", lne, [
                        h("button", {
                          title: "Recover",
                          "aria-label": "Recover",
                          "data-testid": "trash-item-recover",
                          onClick: (z) => b([M.el.id])
                        }, [
                          C(R, {
                            name: "RotateCcw",
                            size: 14
                          })
                        ], 8, dne),
                        h("button", {
                          class: U(["is-danger", { "is-confirming": i.value === M.el.id }]),
                          title: i.value === M.el.id ? "Click again to delete it for good" : "Delete for good",
                          "aria-label": i.value === M.el.id ? "Click again to delete it for good" : "Delete for good",
                          "data-testid": "trash-item-delete",
                          onClick: (z) => w(M.el.id, [M.el.id]),
                          onBlur: (z) => i.value === M.el.id && (i.value = null)
                        }, [
                          C(R, {
                            name: i.value === M.el.id ? "Check" : "Trash2",
                            size: 14
                          }, null, 8, ["name"])
                        ], 42, cne)
                      ])
                    ], 2),
                    h("div", une, [
                      C(R, {
                        name: c(M).icon,
                        size: 12
                      }, null, 8, ["name"]),
                      h("span", {
                        title: u(M)
                      }, A(u(M)), 9, hne)
                    ])
                  ], 8, Xte))), 128)),
                  T.items.length > f(T).length ? (g(), v("button", {
                    key: "more",
                    class: "rd-more",
                    "data-testid": "trash-more",
                    onClick: (M) => s.value = s.value.concat(T.key)
                  }, " +" + A(T.items.length - f(T).length) + " more ", 9, pne)) : E("", !0)
                ]),
                _: 2
              }, 1024)
            ]))), 128))
          ]),
          _: 1
        })) : (g(), v("div", Bte, [
          h("span", Fte, [
            C(R, {
              name: "Trash2",
              size: 22
            })
          ]),
          x[7] || (x[7] = h("h3", null, "Nothing deleted lately", -1)),
          h("p", null, "Images, notes, frames and shapes deleted from this board wait here for " + A(m(dv)) + " days, so they can be recovered.", 1)
        ]))
      ], 544)
    ], 32));
  }
}), gne = {
  class: "bd-stats",
  "data-testid": "stats"
}, bne = { key: 1 }, vne = /* @__PURE__ */ Re({
  __name: "StatsOverlay",
  setup(n) {
    const { board: e } = tt(), t = I(() => e.stats.value), i = I(() => e.overlayIds.value.length);
    return (s, o) => (g(), v("div", gne, [
      t.value ? (g(), v(H, { key: 0 }, [
        h("b", {
          class: U({ warn: t.value.fps < 55, bad: t.value.fps < 40 })
        }, A(t.value.fps) + " fps", 3),
        h("span", null, A(t.value.frameMs) + " ms/frame", 1),
        h("span", null, A(m(e).store.size) + " elements · " + A(t.value.images) + " images", 1),
        h("span", null, A(t.value.visible) + " culled-in · " + A(i.value) + " DOM", 1),
        h("span", null, A(t.value.textures) + " textures · " + A(t.value.textureMB) + " MB", 1),
        h("span", null, A(t.value.pending) + " loading", 1)
      ], 64)) : (g(), v("span", bne, "measuring…"))
    ]));
  }
}), yne = ["data-el", "data-ref-session"], xne = { class: "cv-bucket-head" }, wne = { class: "cv-badge" }, kne = { class: "cv-bucket-titles" }, _ne = { class: "cv-bucket-kind" }, Sne = ["title"], Tne = ["value"], Mne = ["title"], Cne = { class: "cv-count" }, Ine = { class: "cv-bucket-thumbs" }, Ane = ["data-testid", "onPointerdown"], Pne = { class: "cv-bucket-foot" }, Ene = ["title"], Rne = { key: 1 }, zne = /* @__PURE__ */ Re({
  __name: "ToolCard",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = tt(), s = ps(() => e.id), o = I(() => t.ui.selection.includes(e.id)), r = I(() => o.value && t.ui.selection.length === 1), a = I(() => (t.docRev.value, t.isHeld(s.value))), l = I(() => !!t.generating[e.id]), d = I(() => t.ui.newThumbs[e.id] || 0), c = I(() => s.value && s.value.scale || 1), u = I(() => s.value ? (s.value.thumbs || []).slice(0, 4) : []), p = I(() => Math.max(0, 4 - u.value.length)), f = Ko(), y = I(() => {
      const O = s.value;
      if (!O) return "";
      if (l.value) {
        const L = t.runningSince[e.id];
        return L ? "Generating… " + n1(f.value - L) : "Generating…";
      }
      return O.lastRunAt ? "Updated " + Jn(O.lastRunAt) : O.count ? "Ready" : "No runs yet";
    }), b = /* @__PURE__ */ K(!1), w = /* @__PURE__ */ K(null);
    function k() {
      b.value = !0, it(() => {
        w.value && (w.value.focus({ preventScroll: !0 }), w.value.select());
      });
    }
    function S(O) {
      if (!b.value) return;
      const L = w.value ? w.value.value : "";
      b.value = !1, O && s.value && t.renameTool(e.id, L);
    }
    function _(O) {
      !s.value || b.value || i.elementDown(t.store.get(e.id), O);
    }
    function x(O) {
      const L = t.store.get(e.id);
      !L || b.value || i.elementDown(L, O, { onClick: () => T() });
    }
    function T() {
      const O = t.store.get(e.id);
      O && O.type === "tool" && t.showSession(O);
    }
    function M(O) {
      O.detail === 0 && T();
    }
    function z(O) {
      const L = O.target;
      b.value || L && L.closest(".cv-thumb, input, textarea") || T();
    }
    function P(O, L) {
      const Z = s.value;
      if (!Z) return;
      L.stopPropagation();
      const J = t.results.list(e.id).find((W) => W.url === O) || null;
      if (t.ui.eyedropper) {
        L.preventDefault(), t.eyedrop(O, J && J.asset || t.assetFor(O), !!(J && J.video));
        return;
      }
      const re = J && J.w ? Math.max(200, Math.min(360, J.w)) : 300, F = J && J.w ? Math.round(re * J.h / J.w) : 200;
      i.dragResultOut({ url: O, w: re, h: F, result: J, sessionId: Z.id, label: J ? J.label : void 0 }, L, {
        slop: 5,
        onClick: () => D(O, J)
      });
    }
    function D(O, L) {
      const Z = L ? t.placedFor(L.id) : null;
      if (L && Z) {
        t.ui.infoSession = L.sessionId, t.ui.infoAt = Z.id;
        return;
      }
      if (L && L.status === "done") {
        t.ui.infoSession = L.sessionId, t.ui.infoAt = "result:" + L.id;
        return;
      }
      const J = t.imagesInOrder().find((re) => re.src === O);
      J && (t.ui.infoAt = J.id);
    }
    function $(O) {
      const L = t.store.get(e.id);
      L && i.resizeDown(L, O);
    }
    return (O, L) => m(s) ? (g(), v("div", {
      key: 0,
      class: U(["cv-el is-tool", { "is-selected": o.value, "is-open": r.value, "cv-enter": n.enter, "is-ref-target": m(t).ui.refSession === n.id }]),
      style: de({
        left: m(s).x + "px",
        top: m(s).y + "px",
        width: m(Tt).w * c.value + "px",
        height: m(Tt).h * c.value + "px",
        zIndex: Math.round(m(s).z) + 10,
        "--d": (n.delay || 0) + "s"
      }),
      "data-el": n.id,
      "data-ref-session": n.id,
      onPointerdown: _,
      onDblclick: Pe(z, ["stop"])
    }, [
      h("div", {
        class: "cv-el-body",
        style: de(c.value !== 1 ? { transform: "scale(" + c.value + ")", transformOrigin: "0 0", width: m(Tt).w + "px", height: m(Tt).h + "px" } : void 0)
      }, [
        h("div", {
          class: U(["cv-bucket style-strip", { "is-busy": l.value }])
        }, [
          h("div", xne, [
            h("span", wne, [
              C(R, {
                name: m(s).icon,
                size: 17
              }, null, 8, ["name"])
            ]),
            h("span", kne, [
              h("span", _ne, [
                X(A(m(s).kind) + " ", 1),
                m(s).model ? (g(), v(H, { key: 0 }, [
                  L[4] || (L[4] = h("span", { class: "cv-bucket-sep" }, "·", -1)),
                  h("span", {
                    class: "cv-bucket-model",
                    title: "Model: " + m(s).model
                  }, A(m(s).model), 9, Sne)
                ], 64)) : E("", !0)
              ]),
              b.value ? (g(), v("input", {
                key: 0,
                ref_key: "nameInput",
                ref: w,
                class: "cv-bucket-name-input",
                value: m(s).name,
                spellcheck: "false",
                onPointerdown: L[0] || (L[0] = Pe(() => {
                }, ["stop"])),
                onKeydown: [
                  L[1] || (L[1] = tn(Pe((Z) => S(!0), ["prevent"]), ["enter"])),
                  L[2] || (L[2] = tn(Pe((Z) => S(!1), ["stop", "prevent"]), ["esc"]))
                ],
                onBlur: L[3] || (L[3] = (Z) => S(!0))
              }, null, 40, Tne)) : (g(), v("div", {
                key: 1,
                class: "cv-bucket-name",
                title: m(s).name,
                onDblclick: Pe(k, ["stop"])
              }, A(m(s).name), 41, Mne))
            ]),
            h("span", Cne, A(m(s).count), 1)
          ]),
          h("div", Ine, [
            l.value ? (g(), v(H, { key: 0 }, [
              (g(!0), v(H, null, me(u.value, (Z, J) => (g(), v("div", {
                key: "s" + J,
                class: "cv-thumb thumb-shimmer",
                style: de({ backgroundImage: 'url("' + m(Wt)(Z) + '")' })
              }, null, 4))), 128)),
              (g(!0), v(H, null, me(p.value, (Z) => (g(), v("div", {
                key: "se" + Z,
                class: "cv-thumb-empty thumb-shimmer"
              }))), 128))
            ], 64)) : (g(), v(H, { key: 1 }, [
              (g(!0), v(H, null, me(u.value, (Z, J) => (g(), v("div", {
                key: m(s).id + "-" + Z + "-" + J,
                class: U(["cv-thumb cv-thumb-pull", { "thumb-new": J < d.value }]),
                style: de({ backgroundImage: 'url("' + m(Wt)(Z) + '")', "--d": J < d.value ? J * 0.07 + "s" : void 0 }),
                title: "Click to view. Drag onto the canvas to place it.",
                "data-testid": "session-thumb-" + J,
                onPointerdown: (re) => P(Z, re)
              }, null, 46, Ane))), 128)),
              (g(!0), v(H, null, me(p.value, (Z) => (g(), v("div", {
                key: "e" + Z,
                class: "cv-thumb-empty is-open",
                title: "Open this session",
                "data-testid": "session-slot",
                onPointerdown: x
              }, null, 32))), 128))
            ], 64))
          ]),
          h("div", Pne, [
            m(s).error && !l.value ? (g(), v("span", {
              key: 0,
              class: "is-error",
              title: m(s).error
            }, [
              C(R, {
                name: "AlertCircle",
                size: 11
              }),
              L[5] || (L[5] = X(" Run failed", -1))
            ], 8, Ene)) : (g(), v("span", Rne, A(y.value), 1)),
            r.value ? E("", !0) : (g(), v("button", {
              key: 2,
              type: "button",
              class: "cv-bucket-open-hint",
              "data-testid": "session-open",
              onPointerdown: x,
              onClick: Pe(M, ["stop"])
            }, [
              L[6] || (L[6] = X("Open ", -1)),
              C(R, {
                name: "ChevronRight",
                size: 11
              })
            ], 32))
          ]),
          L[7] || (L[7] = h("span", { class: "cv-ring" }, null, -1))
        ], 2)
      ], 4),
      r.value && !a.value ? (g(), v("span", {
        key: 0,
        class: "cv-resize",
        title: "Resize",
        onPointerdown: $
      }, null, 32)) : E("", !0)
    ], 46, yne)) : E("", !0);
  }
}), $ne = ["data-el"], Dne = { class: "cv-el-body" }, One = { class: "cv-note-meta" }, Lne = /* @__PURE__ */ Re({
  __name: "NoteCard",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = tt(), s = ps(() => e.id), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ Xt({ above: !1, below: !1 });
    function l() {
      const P = p.value ? o.value : r.value;
      a.above = !!P && P.scrollTop > 0, a.below = !!P && P.scrollTop + P.clientHeight < P.scrollHeight - 1;
    }
    const d = I(() => t.ui.selection.includes(e.id)), c = I(() => d.value && t.ui.selection.length === 1), u = I(() => (t.docRev.value, t.isHeld(s.value))), p = I(() => t.ui.editingNote === e.id);
    let f = "", y = 0, b = 0;
    function w() {
      if (clearTimeout(b), !o.value) return;
      const P = o.value.innerText.replace(/\n$/, ""), D = t.store.get(e.id);
      D && D.text !== P && t.store.update(e.id, { text: P }, { history: !1 });
    }
    function k() {
      clearTimeout(b), b = window.setTimeout(w, 350), S(), l();
    }
    function S() {
      const P = o.value, D = s.value;
      if (!P || !D || !D.grow || u.value) return;
      const $ = P.scrollHeight - P.clientHeight;
      $ > 0 && t.store.update(e.id, { h: D.h + $ }, { history: !1 });
    }
    $e(p, (P) => {
      if (!P) {
        it(l);
        return;
      }
      f = s.value && s.value.text || "", y = s.value && s.value.h || 0, it(() => {
        const D = o.value;
        if (!D) return;
        D.innerText = s.value && s.value.text || "", D.focus({ preventScroll: !0 });
        const $ = document.createRange();
        $.selectNodeContents(D), $.collapse(!1);
        const O = window.getSelection();
        O && (O.removeAllRanges(), O.addRange($)), l();
      });
    }, { immediate: !0 }), $e(() => s.value && [s.value.text, s.value.w, s.value.h], () => it(l)), ot(l);
    function _(P) {
      if (p.value) {
        P.stopPropagation();
        return;
      }
      const D = t.store.get(e.id);
      D && i.elementDown(D, P);
    }
    function x() {
      t.editNote(e.id);
    }
    function T() {
      if (!p.value || !o.value) return;
      w();
      const P = o.value.innerText.replace(/\n$/, "");
      i.commitNote(e.id, P);
      const D = s.value && s.value.h || y, $ = D !== y ? { h: y } : {};
      t.store.recordEdit("Edit note", e.id, { text: f, ...$ }, { text: P, ...D !== y ? { h: D } : {} });
    }
    Ve(() => {
      p.value && w(), clearTimeout(b);
    });
    function M(P) {
      P.key === "Escape" && (P.preventDefault(), P.stopPropagation(), P.target.blur());
    }
    function z(P) {
      const D = t.store.get(e.id);
      D && i.resizeDown(D, P);
    }
    return (P, D) => m(s) ? (g(), v("div", {
      key: 0,
      class: U(["cv-el is-note", { "is-selected": d.value, "cv-enter": n.enter }]),
      style: de({ left: m(s).x + "px", top: m(s).y + "px", width: m(s).w + "px", height: m(s).h + "px", zIndex: Math.round(m(s).z) + 10, "--d": (n.delay || 0) + "s" }),
      "data-el": n.id,
      onPointerdown: _
    }, [
      h("div", Dne, [
        h("div", {
          class: U(["cv-note", ["tint-" + (m(s).tint || "glass"), { "is-editing": p.value, "more-above": a.above, "more-below": a.below }]]),
          onDblclick: Pe(x, ["stop"])
        }, [
          p.value ? (g(), v("div", {
            key: 1,
            ref_key: "textEl",
            ref: o,
            class: "cv-note-text",
            contenteditable: "plaintext-only",
            spellcheck: "false",
            "data-placeholder": "Type a note…",
            onBlur: T,
            onInput: k,
            onKeydown: M,
            onScroll: l,
            onPointerdown: D[0] || (D[0] = Pe(() => {
            }, ["stop"]))
          }, null, 544)) : (g(), v("div", {
            key: 0,
            ref_key: "viewEl",
            ref: r,
            class: "cv-note-text",
            "data-placeholder": "Double-click to write",
            onScroll: l
          }, A(m(s).text), 545)),
          h("div", One, A(m(s).author || "You"), 1),
          D[1] || (D[1] = h("span", { class: "cv-ring" }, null, -1))
        ], 34)
      ]),
      c.value && !p.value && !u.value ? (g(), v("span", {
        key: 0,
        class: "cv-resize",
        title: "Resize",
        onPointerdown: z
      }, null, 32)) : E("", !0)
    ], 46, $ne)) : E("", !0);
  }
}), Bne = ["data-el"], Fne = { class: "cv-el-body" }, Nne = { class: "cv-bucket-head" }, Une = { class: "cv-badge ch-badge" }, Gne = { class: "cv-bucket-titles" }, jne = { class: "cv-bucket-kind" }, Hne = { class: "cv-bucket-model" }, Vne = ["value"], Wne = ["title"], qne = ["title"], Kne = { class: "cv-bucket-foot" }, Yne = {
  key: 0,
  class: "ch-pulse"
}, Xne = {
  key: 0,
  class: "cv-bucket-open-hint"
}, Jne = /* @__PURE__ */ Re({
  __name: "ChatCard",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = tt(), s = fs(t), o = ps(() => e.id), r = I(() => t.ui.selection.includes(e.id)), a = I(() => t.ui.chatOpen === e.id), l = I(() => o.value ? s.contextOf(o.value) : null), d = I(() => l.value ? $6(l.value) : 0), c = I(() => o.value ? t8(o.value) : 0), u = I(() => o.value ? nU(o.value) : null), p = I(() => s.live[e.id] || null), f = I(() => o.value ? iU(o.value) : null), y = Ko(), b = I(() => {
      if (p.value) return { text: p.value.status || "Writing…", busy: !0 };
      const M = f.value;
      if (M && M.status === "running") {
        const D = (M.steps || []).find(($) => $.id === "run" && $.status === "running");
        return { text: D ? D.text : "Running the plan…", busy: !0 };
      }
      if (M && M.status === "proposed") return { text: "Plan ready · " + B6(M.tokens), busy: !1 };
      const z = o.value ? o.value.messages || [] : [], P = z.length ? z[z.length - 1].at : 0;
      return y.value, { text: P ? "Updated " + Jn(P) : l.value ? "No messages yet" : "Not in a frame", busy: !1 };
    }), w = /* @__PURE__ */ K(!1), k = /* @__PURE__ */ K(null);
    function S() {
      w.value = !0, it(() => {
        k.value && (k.value.focus({ preventScroll: !0 }), k.value.select());
      });
    }
    function _(M) {
      if (!w.value) return;
      const z = k.value ? k.value.value.trim() : "";
      w.value = !1, M && z && o.value && z !== o.value.name && t.patch(e.id, { name: z }, "Rename chat");
    }
    function x(M) {
      !o.value || w.value || i.elementDown(t.store.get(e.id), M);
    }
    function T() {
      t.ui.selection = [e.id], t.ui.chatOpen = e.id;
    }
    return (M, z) => m(o) ? (g(), v("div", {
      key: 0,
      class: U(["cv-el is-chat", { "is-selected": r.value, "is-open": a.value, "cv-enter": n.enter }]),
      style: de({ left: m(o).x + "px", top: m(o).y + "px", width: m(o).w + "px", height: m(o).h + "px", zIndex: Math.round(m(o).z) + 10, "--d": (n.delay || 0) + "s" }),
      "data-el": n.id,
      "data-testid": "chat-card",
      onPointerdown: x,
      onDblclick: Pe(T, ["stop"])
    }, [
      h("div", Fne, [
        h("div", {
          class: U(["cv-bucket ch-card", { "is-busy": b.value.busy, "is-live": a.value }])
        }, [
          h("div", Nne, [
            h("span", Une, [
              C(R, {
                name: "MessagesSquare",
                size: 17
              })
            ]),
            h("span", Gne, [
              h("span", jne, [
                z[5] || (z[5] = X(" Chat ", -1)),
                l.value ? (g(), v(H, { key: 0 }, [
                  z[4] || (z[4] = h("span", { class: "cv-bucket-sep" }, "·", -1)),
                  h("span", Hne, A(d.value) + " in context", 1)
                ], 64)) : E("", !0)
              ]),
              w.value ? (g(), v("input", {
                key: 0,
                ref_key: "nameInput",
                ref: k,
                class: "cv-bucket-name-input",
                value: m(o).name,
                spellcheck: "false",
                onPointerdown: z[0] || (z[0] = Pe(() => {
                }, ["stop"])),
                onKeydown: [
                  z[1] || (z[1] = tn(Pe((P) => _(!0), ["prevent"]), ["enter"])),
                  z[2] || (z[2] = tn(Pe((P) => _(!1), ["stop", "prevent"]), ["esc"]))
                ],
                onBlur: z[3] || (z[3] = (P) => _(!0))
              }, null, 40, Vne)) : (g(), v("div", {
                key: 1,
                class: "cv-bucket-name",
                title: m(o).name,
                onDblclick: Pe(S, ["stop"])
              }, A(m(o).name), 41, Wne))
            ]),
            h("span", {
              class: "cv-count",
              title: c.value === 1 ? "1 message" : c.value + " messages"
            }, A(c.value), 9, qne)
          ]),
          h("div", {
            class: U(["ch-card-last", { "is-empty": !u.value }])
          }, [
            u.value ? (g(), v(H, { key: 0 }, [
              h("b", null, A(u.value.who) + ":", 1),
              X(" " + A(u.value.text), 1)
            ], 64)) : (g(), v(H, { key: 1 }, [
              X("Ask about this frame, or have it set up tools here.")
            ], 64))
          ], 2),
          h("div", Kne, [
            h("span", {
              class: U(["ch-card-state", { "is-busy": b.value.busy }])
            }, [
              b.value.busy ? (g(), v("span", Yne)) : E("", !0),
              X(A(b.value.text), 1)
            ], 2),
            a.value ? E("", !0) : (g(), v("span", Xne, [
              z[6] || (z[6] = X("Open ", -1)),
              C(R, {
                name: "ChevronRight",
                size: 11
              })
            ]))
          ]),
          z[7] || (z[7] = h("span", { class: "cv-ring" }, null, -1))
        ], 2)
      ])
    ], 46, Bne)) : E("", !0);
  }
}), Zne = /* @__PURE__ */ Re({
  __name: "FrameGlow",
  props: {
    frameId: {},
    chatId: {}
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = fs(t), s = ps(() => e.frameId), o = I(() => {
      if (i.live[e.chatId]) return !0;
      const r = i.open.value;
      return !!r && (r.messages || []).some((a) => a.plan && a.plan.status === "running");
    });
    return (r, a) => m(s) ? (g(), v("div", {
      key: 0,
      class: U(["cv-frame-glow", { "is-working": o.value }]),
      style: de({ left: m(s).x + "px", top: m(s).y + "px", width: m(s).w + "px", height: m(s).h + "px" }),
      "data-testid": "frame-glow",
      "aria-hidden": "true"
    }, null, 6)) : E("", !0);
  }
}), Qne = ["value"], eie = {
  key: 2,
  class: "cv-frame-name"
}, tie = { class: "cv-frame-count" }, nie = /* @__PURE__ */ Re({
  __name: "FrameTitle",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = tt(), s = ps(() => e.id), o = /* @__PURE__ */ K(null), r = I(() => t.ui.selection.includes(e.id)), a = I(() => t.ui.editingTitle === e.id), l = I(() => {
      t.docRev.value;
      const u = t.store.get(e.id);
      return u ? t.childrenOf(u).length : 0;
    });
    $e(a, (u) => {
      u && it(() => {
        o.value && (o.value.focus({ preventScroll: !0 }), o.value.select());
      });
    }, { immediate: !0 });
    function d(u) {
      if (a.value) return;
      const p = t.store.get(e.id);
      p && i.elementDown(p, u);
    }
    function c(u) {
      if (!a.value) return;
      const p = o.value ? o.value.value : "";
      t.ui.editingTitle = null, u && t.renameFrame(e.id, p);
    }
    return (u, p) => m(s) ? (g(), v("div", {
      key: 0,
      class: U(["cv-el is-frame-title", { "cv-enter": n.enter }]),
      style: de({ left: m(s).x + "px", top: m(s).y + "px", width: m(s).w + "px", height: "0px", zIndex: 5, "--d": (n.delay || 0) + "s" })
    }, [
      h("div", {
        class: U(["cv-frame-title", { "is-selected": r.value, "is-locked": m(s).locked }]),
        onPointerdown: d,
        onDblclick: p[4] || (p[4] = Pe((f) => m(t).ui.editingTitle = n.id, ["stop"]))
      }, [
        m(s).locked ? (g(), Ce(R, {
          key: 0,
          class: "cv-frame-lock",
          name: "Lock",
          size: 11,
          stroke: 2.25,
          "data-testid": "frame-locked"
        })) : E("", !0),
        a.value ? (g(), v("input", {
          key: 1,
          ref_key: "inputEl",
          ref: o,
          class: "cv-frame-title-input",
          value: m(s).title,
          spellcheck: "false",
          onPointerdown: p[0] || (p[0] = Pe(() => {
          }, ["stop"])),
          onKeydown: [
            p[1] || (p[1] = tn(Pe((f) => c(!0), ["prevent"]), ["enter"])),
            p[2] || (p[2] = tn(Pe((f) => c(!1), ["stop", "prevent"]), ["esc"]))
          ],
          onBlur: p[3] || (p[3] = (f) => c(!0))
        }, null, 40, Qne)) : (g(), v("span", eie, A(m(s).title), 1)),
        h("span", tie, A(l.value) + " " + A(l.value === 1 ? "item" : "items"), 1)
      ], 34)
    ], 6)) : E("", !0);
  }
}), iie = {
  key: 0,
  class: "cv-img-vid"
}, sie = {
  key: 1,
  class: "cv-img-fav"
}, oie = ["title"], rie = /* @__PURE__ */ Re({
  __name: "ImageBadges",
  props: {
    id: {}
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = ps(() => e.id), s = I(() => {
      const r = i.value;
      return r ? (t.results.rev.value, t.isFav(r.resultId && t.results.get(r.resultId) || null, r)) : !1;
    }), o = I(() => !!i.value && t.isPinnedImage(i.value.src));
    return (r, a) => m(i) && (m(i).video || s.value || o.value) ? (g(), v("div", {
      key: 0,
      class: "cv-img-badges",
      style: de({
        left: m(i).x + "px",
        top: m(i).y - (m(t).ui.hoverId === n.id ? 4 : 0) + "px",
        width: m(i).w + "px",
        height: m(i).h + "px",
        transition: "top 200ms cubic-bezier(0.16,1,0.3,1)"
      })
    }, [
      m(i).video ? (g(), v("span", iie, [
        C(R, {
          name: "Play",
          size: 9
        }),
        X(" " + A(m(i).dur || "0:05"), 1)
      ])) : E("", !0),
      s.value ? (g(), v("span", sie, [
        C(R, {
          name: "Heart",
          size: 9
        })
      ])) : E("", !0),
      o.value ? (g(), v("span", {
        key: 2,
        class: "cv-img-pin",
        title: m(jn).badge,
        "data-testid": "card-pinned"
      }, [
        C(R, {
          name: "Pin",
          size: 10
        })
      ], 8, oie)) : E("", !0)
    ], 4)) : E("", !0);
  }
}), aie = { class: "cv-img-foot" }, lie = {
  key: 0,
  class: "cv-img-model",
  "data-testid": "image-model"
}, die = { class: "cv-img-label" }, cie = {
  key: 1,
  class: "cv-img-hint",
  "data-testid": "image-ref-hint"
}, uie = { class: "cv-img-actions" }, hie = 280, pie = /* @__PURE__ */ Re({
  __name: "ImageHover",
  props: {
    id: {}
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = ps(() => e.id), s = Ef().shift, o = I(() => !!i.value && !!t.promptTool.value && i.value.w * t.cam.value.zoom >= hie), r = I(() => {
      const l = i.value;
      if (!l || !l.resultId) return "";
      t.results.rev.value;
      const d = t.results.get(l.resultId);
      return d && d.model || "";
    });
    function a(l) {
      l.stopPropagation(), t.deleteIds([e.id]);
    }
    return (l, d) => m(i) ? (g(), v("div", {
      key: 0,
      class: "cv-img-hover",
      style: de({ left: m(i).x + "px", top: m(i).y - 4 + "px", width: m(i).w + "px", height: m(i).h + "px" })
    }, [
      d[2] || (d[2] = h("div", { class: "cv-img-shade" }, null, -1)),
      h("div", aie, [
        r.value ? (g(), v("span", lie, A(r.value), 1)) : E("", !0),
        h("span", die, A(m(i).label), 1),
        o.value ? (g(), v("span", cie, [
          h("kbd", null, A(m(s)), 1),
          d[1] || (d[1] = X("Drag to use as a reference", -1))
        ])) : E("", !0)
      ]),
      h("div", uie, [
        h("button", {
          title: "Remove",
          onPointerdown: d[0] || (d[0] = Pe(() => {
          }, ["stop"])),
          onClick: a
        }, [
          C(R, {
            name: "Trash2",
            size: 13
          })
        ], 32)
      ])
    ], 4)) : E("", !0);
  }
}), fie = { class: "cv-dropper-chip" }, mie = /* @__PURE__ */ Re({
  __name: "DropperRing",
  props: {
    id: {}
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = ps(() => e.id), s = I(() => {
      const r = t.ui.eyedropper;
      return !!r && !!i.value && t.refImages(r.sessionId, r.key).includes(i.value.src);
    }), o = I(() => {
      if (s.value) return "In the prompt";
      const r = t.eyedropperField;
      return r && r.kind === "images" ? "Add to the prompt" : "Use in the prompt";
    });
    return (r, a) => m(i) ? (g(), v("div", {
      key: 0,
      class: U(["cv-dropper-ring", { "is-in": s.value }]),
      style: de({ left: m(i).x + "px", top: m(i).y - 4 + "px", width: m(i).w + "px", height: m(i).h + "px" }),
      "data-testid": "eyedropper-ring"
    }, [
      h("span", fie, [
        C(R, {
          name: s.value ? "Check" : "Pipette",
          size: 11
        }, null, 8, ["name"]),
        X(A(o.value), 1)
      ])
    ], 6)) : E("", !0);
  }
}), gie = ["data-id"], bie = ["src"], vie = { class: "cv-vid-bar" }, yie = /* @__PURE__ */ Re({
  __name: "VideoHover",
  props: {
    id: {},
    active: { type: Boolean },
    light: { type: Boolean }
  },
  setup(n) {
    const e = n, t = ps(() => e.id), i = I(() => {
      const c = t.value;
      return c && (e.light && c.previewSrc || c.videoSrc) || "";
    }), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(!1);
    let a = 0;
    function l() {
      const c = s.value;
      c && o.value && c.duration > 0 && (o.value.style.transform = "scaleX(" + Math.min(1, c.currentTime / c.duration) + ")"), a = requestAnimationFrame(l);
    }
    function d() {
      const c = s.value;
      if (!c) return;
      c.muted = !0;
      const u = c.play();
      u && u.catch(() => {
      });
    }
    return $e(() => e.active, (c) => {
      c && d();
    }), ot(() => {
      const c = s.value;
      c && (typeof c.requestVideoFrameCallback == "function" ? c.requestVideoFrameCallback(() => {
        r.value = !0;
      }) : c.addEventListener("playing", () => {
        r.value = !0;
      }, { once: !0 }), d(), a = requestAnimationFrame(l));
    }), Ve(() => {
      cancelAnimationFrame(a);
      const c = s.value;
      c && (c.pause(), c.removeAttribute("src"), c.load());
    }), (c, u) => m(t) && m(t).videoSrc ? (g(), v("div", {
      key: 0,
      class: U(["cv-vid", { "is-shown": r.value && n.active }]),
      style: de({ left: m(t).x + "px", top: m(t).y - (n.active ? 4 : 0) + "px", width: m(t).w + "px", height: m(t).h + "px" }),
      "data-testid": "hover-video",
      "data-id": n.id
    }, [
      h("video", {
        ref_key: "video",
        ref: s,
        src: i.value,
        muted: "",
        loop: "",
        playsinline: "",
        preload: "auto",
        disablepictureinpicture: ""
      }, null, 8, bie),
      h("div", vie, [
        h("i", {
          ref_key: "bar",
          ref: o
        }, null, 512)
      ])
    ], 14, gie)) : E("", !0);
  }
}), xie = /* @__PURE__ */ Re({
  __name: "GpuHandle",
  props: {
    id: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = tt(), s = ps(() => e.id);
    function o(r) {
      const a = t.store.get(e.id);
      a && i.resizeDown(a, r);
    }
    return (r, a) => m(s) ? (g(), v("div", {
      key: 0,
      class: "cv-el is-handle",
      style: de({ left: m(s).x + "px", top: m(s).y + "px", width: Math.max(0, m(s).w) + "px", height: Math.max(0, m(s).h) + "px", pointerEvents: "none", zIndex: 9999 })
    }, [
      h("span", {
        class: "cv-resize",
        title: "Resize",
        onPointerdown: o
      }, null, 32)
    ], 4)) : E("", !0);
  }
}), wie = 64, kie = 512, _ie = /* @__PURE__ */ Re({
  __name: "WorldLayer",
  setup(n) {
    const { board: e } = tt(), t = fs(e), i = /* @__PURE__ */ K(!0), s = /* @__PURE__ */ new Map();
    {
      const y = e.overlayIds.value.map((w) => e.store.get(w)).filter(Boolean);
      y.sort((w, k) => w.y - k.y || w.x - k.x);
      const b = Math.min(0.045, 0.9 / Math.max(1, y.length));
      y.forEach((w, k) => s.set(w.id, k * b));
    }
    const o = window.setTimeout(() => {
      i.value = !1;
    }, 1700);
    Ve(() => clearTimeout(o));
    const r = I(() => {
      e.docRev.value;
      const y = [], b = [], w = [];
      for (const k of e.overlayIds.value) {
        const S = e.store.get(k);
        S && (S.type === "frame" ? y.push(k) : S.type === "tool" || S.type === "note" || S.type === "chat" ? b.push({ id: k, type: S.type, z: S.z }) : S.type === "image" && w.push(k));
      }
      return b.sort((k, S) => k.z - S.z), { frames: y, cards: b, badges: w };
    }), a = I(() => {
      const y = e.ui.hoverId;
      if (!y || e.ui.dragging || e.ui.eyedropper) return null;
      const b = e.store.get(y);
      return b && b.type === "image" && !e.ui.selection.includes(y) ? y : null;
    }), l = I(() => {
      const y = e.ui.hoverId;
      if (!y || e.ui.dragging || !e.ui.eyedropper) return null;
      const b = e.store.get(y);
      return b && b.type === "image" && e.eyedropperTakes(!!b.video) ? y : null;
    }), d = I(() => {
      e.docRev.value;
      const y = e.ui.hoverId;
      if (!y || e.ui.dragging) return null;
      const b = e.store.get(y);
      if (!b || b.type !== "image") return null;
      const w = b;
      return !w.video || !w.videoSrc ? null : w.w * e.cam.value.zoom >= wie ? y : null;
    }), c = /* @__PURE__ */ We(null);
    let u = 0;
    $e(d, (y) => {
      if (clearTimeout(u), y) {
        const w = c.value;
        if (w && w.id === y) {
          c.value = { ...w, active: !0 };
          return;
        }
        const k = e.store.get(y), S = !!k && Math.max(k.w, k.h) * e.cam.value.zoom <= kie;
        c.value = { id: y, active: !0, light: S };
        return;
      }
      const b = c.value;
      b && (c.value = { ...b, active: !1 }, u = window.setTimeout(() => {
        c.value && !c.value.active && (c.value = null);
      }, 260));
    }, { immediate: !0 }), Ve(() => clearTimeout(u));
    const p = I(() => {
      const y = t.open.value, b = y ? t.frameOf(y) : null;
      return y && b ? { frameId: b.id, chatId: y.id } : null;
    }), f = I(() => {
      if (e.docRev.value, e.ui.selection.length !== 1 || e.ui.dragging) return null;
      const y = e.store.get(e.ui.selection[0]);
      return y && (y.type === "image" || y.type === "frame" || y.type === "shape") && !e.isHeld(y) ? y.id : null;
    });
    return (y, b) => (g(), v(H, null, [
      (g(!0), v(H, null, me(r.value.frames, (w) => (g(), Ce(nie, {
        key: "ft-" + w,
        id: w,
        enter: i.value && m(s).has(w),
        delay: m(s).get(w)
      }, null, 8, ["id", "enter", "delay"]))), 128)),
      p.value ? (g(), Ce(Zne, {
        key: "fg-" + p.value.frameId,
        "frame-id": p.value.frameId,
        "chat-id": p.value.chatId
      }, null, 8, ["frame-id", "chat-id"])) : E("", !0),
      c.value ? (g(), Ce(yie, {
        key: "vh-" + c.value.id,
        id: c.value.id,
        active: c.value.active,
        light: c.value.light
      }, null, 8, ["id", "active", "light"])) : E("", !0),
      (g(!0), v(H, null, me(r.value.badges, (w) => (g(), Ce(rie, {
        key: "ib-" + w,
        id: w
      }, null, 8, ["id"]))), 128)),
      (g(!0), v(H, null, me(r.value.cards, (w) => (g(), v(H, {
        key: w.id
      }, [
        w.type === "tool" ? (g(), Ce(zne, {
          key: 0,
          id: w.id,
          enter: i.value && m(s).has(w.id),
          delay: m(s).get(w.id)
        }, null, 8, ["id", "enter", "delay"])) : w.type === "chat" ? (g(), Ce(Jne, {
          key: 1,
          id: w.id,
          enter: i.value && m(s).has(w.id),
          delay: m(s).get(w.id)
        }, null, 8, ["id", "enter", "delay"])) : (g(), Ce(Lne, {
          key: 2,
          id: w.id,
          enter: i.value && m(s).has(w.id),
          delay: m(s).get(w.id)
        }, null, 8, ["id", "enter", "delay"]))
      ], 64))), 128)),
      a.value ? (g(), Ce(pie, {
        key: "hv-" + a.value,
        id: a.value
      }, null, 8, ["id"])) : E("", !0),
      l.value ? (g(), Ce(mie, {
        key: "dr-" + l.value,
        id: l.value
      }, null, 8, ["id"])) : E("", !0),
      f.value ? (g(), Ce(xie, {
        key: 4,
        id: f.value
      }, null, 8, ["id"])) : E("", !0)
    ], 64));
  }
}), Sie = {
  key: 0,
  class: "cv-guides",
  "aria-hidden": "true",
  "data-testid": "snap-guides"
}, Tie = ["d"], Mie = ["d"], Cie = ["d"], Iie = ["d"], ih = 16, q2 = 4, K2 = 4, io = 4, Aie = /* @__PURE__ */ Re({
  __name: "SnapGuides",
  setup(n) {
    const { board: e } = tt(), t = I(() => {
      const i = e.guides.value;
      if (!i) return null;
      const s = e.cam.value, o = window.devicePixelRatio || 1, r = (p) => Math.round((p - 0.5) * o) / o + 0.5, a = (p) => p * s.zoom + s.x, l = (p) => p * s.zoom + s.y, d = (p) => Math.floor(p / (q2 * 2)) * q2 * 2;
      let c = "";
      for (const p of i.lines)
        if (p.axis === "x") {
          const f = r(a(p.at));
          c += "M" + f + " " + d(l(p.from) - ih) + "V" + (l(p.to) + ih);
        } else {
          const f = r(l(p.at));
          c += "M" + d(a(p.from) - ih) + " " + f + "H" + (a(p.to) + ih);
        }
      let u = "";
      for (const p of i.gaps) {
        const f = (p.axis === "x" ? a(p.from) : l(p.from)) + K2, y = (p.axis === "x" ? a(p.to) : l(p.to)) - K2;
        if (y - f < 4) continue;
        const b = r(f), w = r(y), k = r(p.axis === "x" ? l(p.at) : a(p.at));
        u += p.axis === "x" ? "M" + b + " " + k + "H" + w + "M" + b + " " + (k - io) + "V" + (k + io) + "M" + w + " " + (k - io) + "V" + (k + io) : "M" + k + " " + b + "V" + w + "M" + (k - io) + " " + b + "H" + (k + io) + "M" + (k - io) + " " + w + "H" + (k + io);
      }
      return c || u ? { lines: c, gaps: u } : null;
    });
    return (i, s) => t.value ? (g(), v("svg", Sie, [
      t.value.lines ? (g(), v("path", {
        key: 0,
        class: "cv-guide-halo is-dashed",
        d: t.value.lines
      }, null, 8, Tie)) : E("", !0),
      t.value.gaps ? (g(), v("path", {
        key: 1,
        class: "cv-guide-halo",
        d: t.value.gaps
      }, null, 8, Mie)) : E("", !0),
      t.value.lines ? (g(), v("path", {
        key: 2,
        class: "cv-guide-line",
        d: t.value.lines,
        "data-testid": "snap-lines"
      }, null, 8, Cie)) : E("", !0),
      t.value.gaps ? (g(), v("path", {
        key: 3,
        class: "cv-guide-gap",
        d: t.value.gaps,
        "data-testid": "snap-gaps"
      }, null, 8, Iie)) : E("", !0)
    ])) : E("", !0);
  }
}), Pie = { class: "bd-dropper-mark" }, Eie = { class: "bd-dropper-text" }, Rie = {
  key: 0,
  class: "bd-dropper-count",
  "data-testid": "eyedropper-count"
}, zie = /* @__PURE__ */ Re({
  __name: "EyedropperBanner",
  setup(n) {
    const { board: e } = tt(), t = I(() => {
      e.docRev.value;
      const i = e.ui.eyedropper, s = e.eyedropperField, o = e.promptTool.value;
      if (!i || !s || !o) return null;
      if (s.kind === "images")
        return { text: "Click an image on the board to add it to the prompt", count: e.refImages(i.sessionId, i.key).length + " of " + Gs(s) };
      const r = e.modelFor(o).model, a = !!r && r.fields.filter((d) => d.placement === "reference").length > 1;
      return { text: (s.kind === "video" ? "Click a video on the board to use it" : "Click an image on the board to use it") + (a ? " for the " + s.label.toLowerCase() : ""), count: "" };
    });
    return (i, s) => (g(), Ce(vt, { name: "bd-dropper" }, {
      default: et(() => [
        t.value ? (g(), v("div", {
          key: 0,
          class: "bd-dropper",
          role: "status",
          "data-testid": "eyedropper-banner",
          onPointerdown: s[1] || (s[1] = Pe(() => {
          }, ["stop"]))
        }, [
          h("span", Pie, [
            C(R, {
              name: "Pipette",
              size: 13
            })
          ]),
          h("span", Eie, A(t.value.text), 1),
          t.value.count ? (g(), v("span", Rie, A(t.value.count), 1)) : E("", !0),
          h("button", {
            class: "bd-dropper-done",
            title: "Done (Esc)",
            "data-testid": "eyedropper-done",
            onClick: s[0] || (s[0] = (o) => m(e).ui.eyedropper = null)
          }, "Done")
        ], 32)) : E("", !0)
      ]),
      _: 1
    }));
  }
}), $ie = { class: "up-adv-head" }, Die = ["disabled", "data-testid"], Oie = { class: "up-adv-label" }, Lie = {
  key: 0,
  class: "req"
}, Bie = ["title"], Fie = {
  key: 0,
  class: "up-adv-why"
}, Nie = {
  key: 1,
  class: "up-adv-row"
}, Uie = ["min", "max", "step", "value", "onInput"], Gie = ["min", "max", "step", "value", "onChange"], jie = { class: "up-seg" }, Hie = ["onClick"], Vie = ["onClick"], Wie = ["value", "onChange"], qie = ["aria-pressed", "onClick"], Kie = {
  key: 4,
  class: "up-seg"
}, Yie = ["onClick"], Xie = ["value", "onChange"], Jie = ["value"], Zie = ["value", "placeholder", "onChange"], Qie = ["value", "placeholder", "onChange"], ese = /* @__PURE__ */ Re({
  __name: "AdvancedPanel",
  props: {
    tool: {},
    model: {},
    form: {}
  },
  emits: ["close"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = tt(), o = I(() => t.model.fields.filter((b) => b.placement === "advanced" && b.kind !== "header" && Ar(t.form, b.key).shown)), r = I(() => s.promptOf(t.tool.id));
    function a(b) {
      return Ar(t.form, b.key);
    }
    function l(b) {
      return b.key in t.form.values ? t.form.values[b.key] : Pp(b, r.value);
    }
    function d(b) {
      const w = l(b);
      return w == null ? "" : String(w);
    }
    function c(b, w) {
      s.setPrompt(t.tool.id, { inputs: { ...r.value.inputs || {}, [b]: w } });
    }
    function u() {
      const b = { ...r.value.inputs || {} };
      for (const w of o.value) delete b[w.key];
      s.setPrompt(t.tool.id, { inputs: b });
    }
    function p(b) {
      const w = Number(l(b));
      return Number.isFinite(w) ? w : b.min || 0;
    }
    function f(b, w) {
      const k = Wd(b, w);
      k != null && c(b.key, k);
    }
    function y(b) {
      const w = l(b);
      return w == null || w === "" || w === -1 ? "random" : "custom";
    }
    return (b, w) => (g(), v("aside", {
      class: "up-adv",
      "data-testid": "advanced-panel",
      onPointerdown: w[5] || (w[5] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", $ie, [
        w[6] || (w[6] = h("span", { class: "up-adv-title" }, "Advanced", -1)),
        h("button", {
          class: "cv-iconbtn",
          title: "Reset to model defaults",
          onClick: u
        }, [
          C(R, {
            name: "RotateCcw",
            size: 14
          })
        ]),
        h("button", {
          class: "cv-iconbtn",
          title: "Close",
          onClick: w[0] || (w[0] = (k) => i("close"))
        }, [
          C(R, {
            name: "X",
            size: 14
          })
        ])
      ]),
      (g(!0), v(H, null, me(o.value, (k) => (g(), v("fieldset", {
        key: k.key,
        class: U(["up-adv-field", { "is-locked": a(k).locked }]),
        disabled: a(k).locked,
        "data-testid": "adv-" + k.key
      }, [
        h("div", Oie, [
          X(A(k.label), 1),
          a(k).required ? (g(), v("span", Lie, "*")) : E("", !0),
          k.tooltip ? (g(), v("span", {
            key: 1,
            title: k.tooltip
          }, [
            C(R, {
              name: "HelpCircle",
              size: 12
            })
          ], 8, Bie)) : E("", !0)
        ]),
        a(k).locked ? (g(), v("div", Fie, [
          C(R, {
            name: "Lock",
            size: 11
          }),
          X(A(a(k).why), 1)
        ])) : E("", !0),
        k.kind === "slider" ? (g(), v("div", Nie, [
          h("input", {
            class: "up-range",
            type: "range",
            min: k.min,
            max: k.max,
            step: k.step || 1,
            value: p(k),
            onInput: (S) => f(k, S.target.value)
          }, null, 40, Uie),
          h("input", {
            class: "up-adv-num",
            type: "number",
            min: k.min,
            max: k.max,
            step: k.step || 1,
            value: p(k),
            onChange: (S) => f(k, S.target.value),
            onKeydown: w[1] || (w[1] = Pe(() => {
            }, ["stop"]))
          }, null, 40, Gie)
        ])) : k.kind === "seed" ? (g(), v(H, { key: 2 }, [
          h("div", jie, [
            h("button", {
              class: U({ on: y(k) === "random" }),
              onClick: (S) => c(k.key, null)
            }, "Random", 10, Hie),
            h("button", {
              class: U({ on: y(k) === "custom" }),
              onClick: (S) => y(k) === "random" && c(k.key, Math.floor(Math.random() * 1e9))
            }, "Custom", 10, Vie)
          ]),
          y(k) === "custom" ? (g(), v("input", {
            key: 0,
            class: "up-adv-num is-full",
            value: d(k),
            placeholder: "e.g. 284917",
            inputmode: "numeric",
            onChange: (S) => c(k.key, S.target.value === "" ? null : Number(S.target.value)),
            onKeydown: w[2] || (w[2] = Pe(() => {
            }, ["stop"]))
          }, null, 40, Wie)) : E("", !0)
        ], 64)) : k.kind === "boolean" ? (g(), v("button", {
          key: 3,
          class: U(["up-toggle", { on: !!l(k) }]),
          "aria-pressed": !!l(k),
          onClick: (S) => c(k.key, !l(k))
        }, null, 10, qie)) : (k.kind === "select" || k.kind === "size") && (k.options || []).length <= 6 ? (g(), v("div", Kie, [
          (g(!0), v(H, null, me(k.options || [], (S) => (g(), v("button", {
            key: m(mn)(S.value),
            class: U({ on: m(as)(S.value, l(k)) }),
            onClick: (_) => c(k.key, S.value)
          }, A(S.label), 11, Yie))), 128))
        ])) : k.kind === "select" || k.kind === "size" ? (g(), v("select", {
          key: 5,
          class: "up-adv-num is-full",
          value: m(mn)(l(k)),
          onChange: (S) => {
            var _;
            return c(k.key, (_ = (k.options || []).find((x) => m(mn)(x.value) === S.target.value)) == null ? void 0 : _.value);
          }
        }, [
          (g(!0), v(H, null, me(k.options || [], (S) => (g(), v("option", {
            key: m(mn)(S.value),
            value: m(mn)(S.value)
          }, A(S.label), 9, Jie))), 128))
        ], 40, Xie)) : k.kind === "negPrompt" ? (g(), v("textarea", {
          key: 6,
          class: "up-adv-num is-full",
          value: d(k),
          placeholder: k.placeholder || "What to keep out of the image",
          onChange: (S) => c(k.key, S.target.value),
          onKeydown: w[3] || (w[3] = Pe(() => {
          }, ["stop"]))
        }, null, 40, Zie)) : (g(), v("input", {
          key: 7,
          class: "up-adv-num is-full",
          value: d(k),
          placeholder: k.placeholder,
          onChange: (S) => c(k.key, S.target.value),
          onKeydown: w[4] || (w[4] = Pe(() => {
          }, ["stop"]))
        }, null, 40, Qie))
      ], 10, Die))), 128))
    ], 32));
  }
}), tse = ["aria-label", "onMouseenter"], nse = ["title", "aria-label"], ise = { class: "n" }, sse = { class: "ic" }, Lg = 3, ose = /* @__PURE__ */ Re({
  __name: "InputStack",
  props: {
    inputs: {}
  },
  emits: ["peek"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ K(0), o = /* @__PURE__ */ K(-1), r = I(() => Math.max(0, t.inputs.length - Lg)), a = I(() => r.value - s.value);
    function l(c) {
      o.value = c, i("peek", c >= 0 ? t.inputs[c] : null);
    }
    function d() {
      s.value = s.value >= r.value ? 0 : s.value + 1;
    }
    return (c, u) => (g(), v("div", {
      class: "pl-stack",
      onMouseleave: u[1] || (u[1] = (p) => l(-1)),
      onClick: u[2] || (u[2] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", {
        class: "pl-stack-win",
        style: de({ "--rows": Math.min(Lg, n.inputs.length) })
      }, [
        h("div", {
          class: "pl-stack-reel",
          style: de({ "--off": s.value })
        }, [
          (g(!0), v(H, null, me(n.inputs, (p, f) => (g(), v("span", {
            key: f,
            class: U(["pl-stack-th", { on: o.value === f, "is-markup": p.kind === "markup" }]),
            style: de({ backgroundImage: 'url("' + p.url + '")' }),
            "aria-label": p.label + ": " + p.role,
            "data-testid": "input-thumb",
            onMouseenter: (y) => l(f)
          }, null, 46, tse))), 128))
        ], 4)
      ], 4),
      r.value ? (g(), v("button", {
        key: 0,
        class: U(["pl-stack-more", { "is-end": a.value <= 0 }]),
        title: a.value > 0 ? "Next image" : "Back to the first image",
        "aria-label": a.value > 0 ? "Next image" : "Back to the first image",
        "data-testid": "input-more",
        onClick: Pe(d, ["stop"]),
        onKeydown: u[0] || (u[0] = Pe(() => {
        }, ["stop"]))
      }, [
        h("span", ise, A(a.value > 0 ? "+" + a.value : s.value + Lg + "/" + n.inputs.length), 1),
        h("span", sse, [
          C(R, {
            name: a.value > 0 ? "ChevronDown" : "ChevronsUp",
            size: 13
          }, null, 8, ["name"])
        ])
      ], 42, nse)) : E("", !0)
    ], 32));
  }
}), rse = ["data-prompt-id"], ase = ["src"], lse = ["src"], dse = {
  key: 2,
  class: "pl-tile-words"
}, cse = ["src"], use = ["title"], hse = ["aria-label"], pse = {
  key: 0,
  class: "pl-tile-cap",
  "data-testid": "tile-caption"
}, fse = { class: "pl-tile-meta" }, mse = { class: "pl-tile-name" }, gse = { class: "pl-tile-tool" }, bse = { class: "pl-tile-acts" }, vse = ["title"], yse = /* @__PURE__ */ Re({
  __name: "PromptTile",
  props: {
    prompt: {},
    toolName: {},
    remixHint: {},
    levels: {}
  },
  emits: ["open", "use", "remix"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(!1), a = /* @__PURE__ */ K(null), l = I(() => t.prompt.output.thumb || (t.prompt.output.url ? Wt(t.prompt.output.url) : ""));
    function d() {
      s.value && i("open", s.value.getBoundingClientRect());
    }
    return (c, u) => (g(), v("article", {
      class: U(["pl-tile", { "is-in": o.value || !l.value, "is-peeking": !!a.value, "is-text": !l.value }]),
      "data-prompt-id": n.prompt.id,
      "data-testid": "prompt-tile",
      onMouseenter: u[5] || (u[5] = (p) => r.value = !0),
      onMouseleave: u[6] || (u[6] = (p) => r.value = !1)
    }, [
      h("span", {
        ref_key: "art",
        ref: s,
        class: "pl-tile-art"
      }, [
        l.value ? (g(), v("img", {
          key: 0,
          class: "pl-tile-img",
          src: l.value,
          alt: "",
          loading: "lazy",
          decoding: "async",
          draggable: "false",
          onLoad: u[0] || (u[0] = (p) => o.value = !0),
          onError: u[1] || (u[1] = (p) => o.value = !0)
        }, null, 40, ase)) : E("", !0),
        n.prompt.output.video && r.value ? (g(), v("video", {
          key: 1,
          class: "pl-tile-img is-video",
          src: n.prompt.output.video,
          muted: "",
          loop: "",
          autoplay: "",
          playsinline: ""
        }, null, 8, lse)) : E("", !0),
        l.value ? E("", !0) : (g(), v("span", dse, A(n.prompt.prompt), 1)),
        C(vt, { name: "pl-peek" }, {
          default: et(() => [
            a.value ? (g(), v("img", {
              key: a.value.url,
              class: "pl-tile-img is-peek",
              src: m(Wt)(a.value.url),
              alt: "",
              draggable: "false"
            }, null, 8, cse)) : E("", !0)
          ]),
          _: 1
        })
      ], 512),
      n.levels && n.levels.length ? (g(), v("span", {
        key: 0,
        class: "pl-tile-levels",
        title: n.levels.map((p) => p.label).join(" · "),
        "data-testid": "tile-levels"
      }, [
        (g(!0), v(H, null, me(n.levels, (p) => (g(), Ce(R, {
          key: p.label,
          name: p.icon,
          size: 11
        }, null, 8, ["name"]))), 128))
      ], 8, use)) : E("", !0),
      u[8] || (u[8] = h("span", { class: "pl-tile-shade" }, null, -1)),
      h("button", {
        class: "pl-tile-hit",
        "aria-label": "Open " + n.prompt.name,
        "data-testid": "tile-open",
        onClick: d
      }, null, 8, hse),
      C(vt, { name: "pl-peek" }, {
        default: et(() => [
          a.value ? (g(), v("span", pse, A(a.value.label) + " · " + A(a.value.role), 1)) : E("", !0)
        ]),
        _: 1
      }),
      n.prompt.inputs.length ? (g(), Ce(ose, {
        key: 1,
        inputs: n.prompt.inputs,
        onPeek: u[2] || (u[2] = (p) => a.value = p)
      }, null, 8, ["inputs"])) : E("", !0),
      h("span", fse, [
        h("span", mse, A(n.prompt.name), 1),
        h("span", gse, A(n.toolName), 1),
        h("span", bse, [
          h("button", {
            class: "pl-btn is-light",
            "data-testid": "tile-use",
            onClick: u[3] || (u[3] = (p) => i("use"))
          }, "Use prompt"),
          h("button", {
            class: "pl-btn is-glass",
            title: n.remixHint,
            "data-testid": "tile-remix",
            onClick: u[4] || (u[4] = (p) => i("remix"))
          }, [
            C(R, {
              name: "Repeat",
              size: 12
            }),
            u[7] || (u[7] = X("Remix ", -1))
          ], 8, vse)
        ])
      ])
    ], 42, rse));
  }
}), xse = ["data-prompt-id"], wse = {
  class: "pl-detail-art",
  "data-testid": "detail-art"
}, kse = {
  key: 0,
  class: "pl-cover-text"
}, _se = ["src", "alt"], Sse = {
  class: "pl-detail-cap",
  "data-testid": "detail-caption"
}, Tse = {
  key: 2,
  class: "pl-detail-strip"
}, Mse = ["onMouseenter"], Cse = ["aria-label", "onFocus"], Ise = {
  key: 0,
  class: "pl-detail-more"
}, Ase = { class: "pl-detail-info" }, Pse = { class: "pl-detail-scroll" }, Ese = { class: "pl-detail-top" }, Rse = { class: "pl-crumb" }, zse = { class: "pl-detail-nav" }, $se = ["disabled"], Dse = { class: "pl-detail-count" }, Ose = ["disabled"], Lse = { class: "pl-detail-name" }, Bse = {
  key: 0,
  class: "pl-detail-by",
  "data-testid": "detail-byline"
}, Fse = {
  key: 1,
  class: "pl-detail-desc"
}, Nse = { class: "pl-block" }, Use = { class: "pl-label-row" }, Gse = ["title", "aria-label"], jse = {
  class: "pl-prompt",
  "data-testid": "detail-prompt"
}, Hse = { class: "pl-block" }, Vse = { class: "pl-pills" }, Wse = { class: "pl-pill" }, qse = {
  key: 0,
  class: "pl-pill is-quiet"
}, Kse = {
  key: 0,
  class: "pl-note",
  "data-testid": "detail-note"
}, Yse = {
  key: 2,
  class: "pl-block"
}, Xse = { class: "pl-pills" }, Jse = {
  key: 3,
  class: "pl-block"
}, Zse = { class: "pl-inputs" }, Qse = ["onMouseenter"], eoe = ["title", "aria-label", "onFocus"], toe = { class: "pl-input-n" }, noe = {
  key: 0,
  class: "pl-input-tag"
}, ioe = { class: "pl-detail-foot" }, soe = { class: "pl-detail-acts" }, ooe = ["title"], roe = {
  key: 0,
  class: "pl-acts-own"
}, aoe = ["title", "aria-label"], loe = { key: 0 }, doe = { class: "pl-acts-hint" }, coe = 5, uoe = /* @__PURE__ */ Re({
  __name: "PromptDetail",
  props: {
    prompt: {},
    index: {},
    total: {},
    more: { type: Boolean },
    toolName: {},
    note: {},
    remixHint: {},
    from: {},
    crumb: {},
    byline: {},
    levels: {},
    canEdit: { type: Boolean }
  },
  emits: ["back", "step", "use", "remix", "edit", "delete"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(!!t.from);
    let l = 0;
    const d = I(() => s.value ? s.value.url : t.prompt.output.url), c = /* @__PURE__ */ K(!1);
    function u() {
      if (!c.value) {
        c.value = !0;
        return;
      }
      c.value = !1, i("delete");
    }
    const p = I(() => s.value ? s.value.label + " · " + s.value.role : "Output"), f = I(() => t.prompt.inputs.slice(0, coe)), y = I(() => t.prompt.inputs.length - f.value.length);
    $e(() => t.prompt.id, () => {
      s.value = null, o.value = !1, c.value = !1;
    });
    function b() {
      try {
        navigator.clipboard.writeText(t.prompt.prompt).catch(() => {
        });
      } catch {
      }
      o.value = !0, clearTimeout(l), l = window.setTimeout(() => {
        o.value = !1;
      }, 1400);
    }
    async function w() {
      const k = t.from, S = typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (!k || S) {
        a.value = !1;
        return;
      }
      await it();
      const _ = r.value;
      if (!_) {
        a.value = !1;
        return;
      }
      _.complete || await new Promise((P) => {
        _.addEventListener("load", () => P(), { once: !0 }), _.addEventListener("error", () => P(), { once: !0 });
      });
      const x = _.getBoundingClientRect();
      if (!x.width || !x.height || typeof document.body.animate != "function") {
        a.value = !1;
        return;
      }
      const T = document.createElement("img");
      T.src = _.currentSrc || _.src, T.alt = "", Object.assign(T.style, {
        position: "fixed",
        left: k.left + "px",
        top: k.top + "px",
        width: k.width + "px",
        height: k.height + "px",
        objectFit: "cover",
        borderRadius: "14px",
        zIndex: "2147483000",
        pointerEvents: "none",
        margin: "0",
        boxShadow: "0 30px 80px rgba(2, 4, 12, 0.55)"
      }), document.body.appendChild(T);
      const M = T.animate([
        { left: k.left + "px", top: k.top + "px", width: k.width + "px", height: k.height + "px", borderRadius: "14px" },
        { left: x.left + "px", top: x.top + "px", width: x.width + "px", height: x.height + "px", borderRadius: "12px" }
      ], { duration: 460, easing: "cubic-bezier(0.16, 1, 0.3, 1)", fill: "forwards" }), z = () => {
        a.value = !1, requestAnimationFrame(() => T.remove());
      };
      M.onfinish = z, M.oncancel = z;
    }
    return ot(w), Ve(() => clearTimeout(l)), (k, S) => (g(), v("div", {
      class: "pl-detail",
      "data-testid": "prompt-detail",
      "data-prompt-id": n.prompt.id
    }, [
      h("div", wse, [
        d.value ? (g(), Ce(vt, {
          key: 1,
          name: "pl-peek",
          mode: "out-in"
        }, {
          default: et(() => [
            (g(), v("img", {
              key: d.value,
              ref_key: "artImg",
              ref: r,
              class: U(["pl-detail-img", { "is-landing": a.value }]),
              src: d.value,
              alt: s.value ? s.value.title || s.value.role : n.prompt.name,
              draggable: "false"
            }, null, 10, _se))
          ]),
          _: 1
        })) : (g(), v("span", kse, A(n.prompt.prompt), 1)),
        h("button", {
          class: "pl-back",
          title: "Back to the prompts",
          "aria-label": "Back to the prompts",
          "data-testid": "detail-back",
          onClick: S[0] || (S[0] = (_) => i("back"))
        }, [
          C(R, {
            name: "ArrowLeft",
            size: 15
          })
        ]),
        h("span", Sse, A(p.value), 1),
        n.prompt.inputs.length ? (g(), v("div", Tse, [
          (g(!0), v(H, null, me(f.value, (_, x) => (g(), v("span", {
            key: x,
            class: "pl-th-slot",
            onMouseenter: (T) => s.value = _,
            onMouseleave: S[2] || (S[2] = (T) => s.value = null)
          }, [
            h("button", {
              class: U(["pl-detail-th", { on: s.value === _, "is-markup": _.kind === "markup" }]),
              style: de({ backgroundImage: 'url("' + _.url + '")' }),
              "aria-label": "Show " + _.label + ": " + _.role,
              "data-testid": "detail-thumb",
              onFocus: (T) => s.value = _,
              onBlur: S[1] || (S[1] = (T) => s.value = null)
            }, null, 46, Cse)
          ], 40, Mse))), 128)),
          y.value > 0 ? (g(), v("span", Ise, "+" + A(y.value), 1)) : E("", !0)
        ])) : E("", !0)
      ]),
      h("div", Ase, [
        h("div", Pse, [
          h("div", Ese, [
            h("span", Rse, A(n.crumb), 1),
            h("span", zse, [
              h("button", {
                title: "Previous prompt",
                "aria-label": "Previous prompt",
                disabled: n.total < 2 && !n.more,
                onClick: S[3] || (S[3] = (_) => i("step", -1))
              }, [
                C(R, {
                  name: "ChevronLeft",
                  size: 14
                })
              ], 8, $se),
              h("span", Dse, A(n.index + 1) + " of " + A(n.total) + A(n.more ? "+" : ""), 1),
              h("button", {
                title: "Next prompt",
                "aria-label": "Next prompt",
                disabled: n.total < 2 && !n.more,
                onClick: S[4] || (S[4] = (_) => i("step", 1))
              }, [
                C(R, {
                  name: "ChevronRight",
                  size: 14
                })
              ], 8, Ose)
            ])
          ]),
          h("h3", Lse, A(n.prompt.name), 1),
          n.byline ? (g(), v("p", Bse, A(n.byline), 1)) : E("", !0),
          n.prompt.description ? (g(), v("p", Fse, A(n.prompt.description), 1)) : E("", !0),
          h("section", Nse, [
            h("div", Use, [
              S[11] || (S[11] = h("span", { class: "pl-label" }, "Prompt", -1)),
              h("button", {
                class: "pl-icon-btn",
                title: o.value ? "Copied" : "Copy the prompt",
                "aria-label": o.value ? "Copied" : "Copy the prompt",
                onClick: b
              }, [
                C(R, {
                  name: o.value ? "Check" : "Copy",
                  size: 13
                }, null, 8, ["name"])
              ], 8, Gse)
            ]),
            h("p", jse, A(n.prompt.prompt), 1)
          ]),
          h("section", Hse, [
            S[12] || (S[12] = h("span", { class: "pl-label" }, "Tool", -1)),
            h("div", Vse, [
              h("span", Wse, [
                C(R, {
                  name: "Sparkles",
                  size: 12
                }),
                X(A(n.toolName), 1)
              ]),
              n.prompt.mode ? (g(), v("span", qse, [
                C(R, {
                  name: n.prompt.inputs.length ? "Images" : "Type",
                  size: 12
                }, null, 8, ["name"]),
                X(A(m(zj)(n.prompt.mode)), 1)
              ])) : E("", !0)
            ]),
            n.note ? (g(), v("p", Kse, [
              C(R, {
                name: "Info",
                size: 12
              }),
              X(A(n.note), 1)
            ])) : E("", !0)
          ]),
          n.levels && n.levels.length ? (g(), v("section", Yse, [
            S[13] || (S[13] = h("span", { class: "pl-label" }, "Who can use it", -1)),
            h("div", Xse, [
              (g(!0), v(H, null, me(n.levels, (_) => (g(), v("span", {
                key: _.label,
                class: "pl-pill is-quiet",
                "data-testid": "detail-level"
              }, [
                C(R, {
                  name: _.icon,
                  size: 12
                }, null, 8, ["name"]),
                X(A(_.label), 1)
              ]))), 128))
            ])
          ])) : E("", !0),
          n.prompt.inputs.length ? (g(), v("section", Jse, [
            S[14] || (S[14] = h("span", { class: "pl-label" }, "Input images · hover to preview", -1)),
            h("div", Zse, [
              (g(!0), v(H, null, me(n.prompt.inputs, (_, x) => (g(), v("span", {
                key: x,
                class: "pl-th-slot",
                onMouseenter: (T) => s.value = _,
                onMouseleave: S[6] || (S[6] = (T) => s.value = null)
              }, [
                h("button", {
                  class: U(["pl-input", { on: s.value === _, "is-markup": _.kind === "markup" }]),
                  style: de({ backgroundImage: 'url("' + _.url + '")' }),
                  title: [_.label, _.role, _.title].filter(Boolean).join(" · "),
                  "aria-label": "Show " + _.label + ": " + _.role,
                  "data-testid": "detail-input",
                  onFocus: (T) => s.value = _,
                  onBlur: S[5] || (S[5] = (T) => s.value = null)
                }, [
                  h("span", toe, A(x + 1), 1),
                  _.kind === "markup" ? (g(), v("span", noe, "Markup")) : E("", !0)
                ], 46, eoe)
              ], 40, Qse))), 128))
            ])
          ])) : E("", !0)
        ]),
        h("div", ioe, [
          h("div", soe, [
            h("button", {
              class: "pl-cta",
              "data-testid": "detail-use",
              onClick: S[7] || (S[7] = (_) => i("use"))
            }, "Use prompt"),
            h("button", {
              class: "pl-btn is-glass is-lg",
              title: n.remixHint,
              "data-testid": "detail-remix",
              onClick: S[8] || (S[8] = (_) => i("remix"))
            }, [
              C(R, {
                name: "Repeat",
                size: 13
              }),
              S[15] || (S[15] = X("Remix ", -1))
            ], 8, ooe),
            n.canEdit ? (g(), v("span", roe, [
              h("button", {
                class: "pl-icon-btn is-lg",
                title: "Edit",
                "aria-label": "Edit",
                "data-testid": "detail-edit",
                onClick: S[9] || (S[9] = (_) => i("edit"))
              }, [
                C(R, {
                  name: "Pencil",
                  size: 14
                })
              ]),
              h("button", {
                class: U(["pl-icon-btn is-lg is-danger", { "is-confirming": c.value }]),
                title: c.value ? "Click again to delete it for everyone it is shared with" : "Delete",
                "aria-label": c.value ? "Confirm delete" : "Delete",
                "data-testid": "detail-delete",
                onClick: u,
                onBlur: S[10] || (S[10] = (_) => c.value = !1)
              }, [
                C(R, {
                  name: c.value ? "Check" : "Trash2",
                  size: 14
                }, null, 8, ["name"]),
                c.value ? (g(), v("span", loe, "Delete?")) : E("", !0)
              ], 42, aoe)
            ])) : E("", !0)
          ]),
          h("p", doe, A(n.remixHint), 1)
        ])
      ])
    ], 8, xse));
  }
}), hoe = {
  class: "pl-tabs pl-side-tabs",
  role: "tablist",
  "aria-label": "Prompts"
}, poe = ["aria-selected"], foe = {
  key: 0,
  class: "n"
}, moe = ["aria-selected"], goe = {
  key: 0,
  class: "n"
}, boe = { class: "pl-side-scroll" }, voe = {
  class: "pl-tree",
  "aria-label": "Kinds and categories",
  "data-testid": "library-tree"
}, yoe = ["aria-current"], xoe = { class: "n" }, woe = ["aria-current", "aria-label", "data-testid", "onClick"], koe = { class: "lbl" }, _oe = { class: "n" }, Soe = ["aria-current", "aria-label", "title", "data-testid", "onClick"], Toe = { class: "lbl" }, Moe = { class: "n" }, Coe = {
  key: 0,
  class: "pl-leaves",
  "data-testid": "library-categories"
}, Ioe = ["aria-current", "title", "data-testid", "onClick"], Aoe = { class: "lbl" }, Poe = { class: "n" }, Eoe = {
  key: 0,
  class: "pl-side-sec",
  "aria-label": "Shared with"
}, Roe = ["aria-pressed", "data-testid", "onClick"], zoe = { class: "pl-tick" }, $oe = { class: "lbl" }, Doe = { class: "n" }, Ooe = { class: "pl-content" }, Loe = { class: "pl-head" }, Boe = ["aria-expanded"], Foe = { class: "pl-search" }, Noe = ["placeholder"], Uoe = {
  key: 1,
  class: "pl-kbd"
}, Goe = {
  key: 0,
  class: "pl-scope",
  "data-testid": "library-scope"
}, joe = {
  key: 0,
  class: "pl-scope-crumb"
}, Hoe = { class: "pl-scope-title" }, Voe = ["title"], Woe = {
  key: 1,
  class: "pl-scope-n"
}, qoe = { class: "pl-main" }, Koe = {
  key: 0,
  class: "pl-grid",
  "aria-busy": "true"
}, Yoe = {
  key: 1,
  class: "pl-empty",
  "data-testid": "library-failed"
}, Xoe = {
  key: 2,
  class: "pl-empty",
  "data-testid": "library-unpublished"
}, Joe = { key: 0 }, Zoe = {
  key: 3,
  class: "pl-empty is-roomy",
  "data-testid": "library-mine-off"
}, Qoe = { class: "pl-empty-mark" }, ere = {
  key: 4,
  class: "pl-empty is-roomy",
  "data-testid": "library-mine-empty"
}, tre = { class: "pl-empty-mark" }, nre = {
  key: 5,
  class: "pl-empty is-roomy",
  "data-testid": "library-video-none"
}, ire = { class: "pl-empty-mark" }, sre = { class: "pl-empty-acts" }, ore = {
  key: 6,
  class: "pl-empty",
  "data-testid": "library-no-match"
}, rre = { class: "pl-empty-acts" }, are = {
  key: 0,
  class: "pl-edit",
  "data-testid": "library-edit"
}, lre = { class: "pl-detail-art" }, dre = ["src"], cre = {
  key: 1,
  class: "pl-cover-text"
}, ure = { class: "pl-edit-form" }, hre = 250, pre = 600, vC = /* @__PURE__ */ Re({
  __name: "PromptLibrary",
  props: {
    floating: { type: Boolean }
  },
  setup(n) {
    const { board: e } = tt(), t = e.promptLibrary, i = e.ui.library, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(!1), c = I(() => (e.docRev.value, t.session(i.sessionId))), u = I(() => c.value ? Ra(c.value.kitId) : null), p = I(() => i.tab === "featured"), f = I(() => t.featured.value), y = I(() => p.value ? t.state.value : t.mineState.value), b = I(() => t.mine.value), w = I(() => t.myPrompts.counts.value), k = I(() => w.value ? w.value.total : b.value.length), S = I(() => e.labels.team), _ = I(() => [
      { id: "me", icon: "Lock", label: "Only me" },
      { id: "board", icon: "LayoutGrid", label: "This board" },
      ...t.team.value ? [{ id: "team", icon: "Users", label: Xb(S.value) }] : [],
      // the company's, where the board's team has one (IL-101)
      ...t.company() || x("company") ? [{ id: "company", icon: "Building2", label: "Company" }] : []
    ]);
    function x(Se) {
      return w.value ? w.value.levels[Se] : b.value.filter((Te) => Op(Te, e.meta.id).includes(Se)).length;
    }
    function T(Se) {
      i.levels = i.levels.includes(Se) ? i.levels.filter((Te) => Te !== Se) : i.levels.concat([Se]), i.detail = null;
    }
    const M = I(() => p.value ? f.value ? Pj(f.value.prompts, { category: i.category, query: i.query, kind: u.value, only: i.kind, action: i.action }) : [] : b.value), z = { image: "Image", video: "Video" }, P = { image: "Image", video: "Video" }, D = { generate: "Generate", edit: "Edit" }, $ = { generate: "Sparkles", edit: "Wand2" }, O = {
      image: { generate: "From words alone", edit: "From your image" },
      video: { generate: "From words alone", edit: "From your image or clip" }
    }, L = {
      image: "Generate an image from words, or edit one of yours",
      video: "Generate a clip from words, or bring your image to life",
      "image-generate": "Start from words: a new concept, no image needed",
      "image-edit": "Start from your own image: change it, restyle it or add to it",
      "video-generate": "Start from words: a new clip, no image needed",
      "video-edit": "Start from your image or clip: move the camera, add life or transform it"
    }, Z = I(() => {
      if (p.value) {
        const Te = f.value;
        return Te ? _u(xw(Te.prompts), Te.categories.map((ae) => ae.label)) : _u([]);
      }
      const Se = w.value;
      return Se && Se.groups && Se.actions ? _u(Se.groups, [], Se.actions) : _u(xw(b.value));
    }), J = I(() => {
      const Se = /* @__PURE__ */ new Map();
      if (p.value && f.value) for (const Te of f.value.categories) Se.set(Te.label, { id: Te.id, description: Te.description });
      return Se;
    });
    function re(Se) {
      const Te = J.value.get(Se);
      return Te ? Te.id : Se;
    }
    const F = I(() => {
      const Se = Z.value.kinds.find((ae) => ae.kind === i.kind), Te = Se && Se.actions.find((ae) => ae.action === i.action);
      return Te ? Te.categories : [];
    }), W = I(() => {
      if (!i.kind)
        return { crumb: "", title: "All prompts", hint: p.value ? "Curated by RunDiffusion: each with its tool and the images it was given" : "Prompts you saved, and prompts shared with you here" };
      const Se = z[i.kind];
      if (!i.action) return { crumb: "", title: Se + " prompts", hint: L[i.kind] };
      const Te = L[i.kind + "-" + i.action];
      if (!i.category) return { crumb: Se, title: D[i.action], hint: Te };
      const ae = J.value.get(i.category);
      return { crumb: Se + " · " + D[i.action], title: i.category, hint: ae && ae.description ? ae.description : Te };
    }), ee = I(() => {
      if (!i.query.trim() || y.value !== "ready") return "";
      const Se = M.value.length, Te = !p.value && t.myPrompts.hasMore.value;
      return Se + (Te ? "+" : "") + (Se === 1 && !Te ? " match" : " matches");
    }), N = I(() => ({ image: Z.value.kinds[0].count, video: Z.value.kinds[1].count })), te = I(() => {
      const Se = i.category || (i.kind ? z[i.kind] + (i.action ? " · " + D[i.action] : "") : ""), Te = i.query.trim();
      return Te ? "Nothing " + (Se ? "in " + Se + " " : "") + "matches “" + Te + "”" : Se ? "No prompts in " + Se : "No prompts here";
    }), G = I(() => p.value ? t.prompt(i.detail) : t.myPrompt(i.detail)), q = I(() => G.value ? M.value.findIndex((Se) => Se.id === G.value.id) : -1), B = I(() => f.value ? f.value.prompts.length : 0), ne = I(() => {
      const Se = M.value.length;
      if (p.value) return { n: Se, more: !1 };
      const Te = w.value;
      return Te && !i.query.trim() && !i.category && !i.levels.length && !i.kind ? { n: Math.max(Te.total, Se), more: !1 } : { n: Se, more: t.myPrompts.hasMore.value };
    });
    $e(p, (Se) => t.myPrompts.setShown(!Se), { immediate: !0 });
    let se = null;
    $e(() => [i.tab, i.levels.join(","), i.category, i.kind, i.action, u.value], () => {
      p.value || t.startMine();
    }), $e(() => i.query, () => {
      se && clearTimeout(se), se = setTimeout(() => {
        se = null, p.value || t.startMine();
      }, hre);
    });
    function Y() {
      const Se = s.value;
      p.value || !Se || !t.myPrompts.hasMore.value || Se.scrollTop + Se.clientHeight >= Se.scrollHeight - pre && t.myPrompts.loadMore();
    }
    function ie() {
      ve(), Y();
    }
    $e(() => b.value.length, () => it(Y)), $e(F, (Se) => {
      (p.value ? !f.value : !w.value) || i.category && !Se.some((Te) => Te.label === i.category) && t.setCategory(null);
    });
    function De(Se) {
      const Te = Ea(e.catalog.value, Se.tool);
      return Te ? Te.name : Se.tool.name;
    }
    function xe(Se) {
      if (Se === "company") return { icon: "Building2", label: "Company" };
      if (Se === "team") return { icon: "Users", label: Xb(S.value) };
      const Te = _.value.find((ae) => ae.id === Se);
      return { icon: Te.icon, label: Te.label };
    }
    function Oe(Se) {
      if (!_r(Se)) return;
      const Te = Op(Se, e.meta.id).map(xe);
      return h8(Se, e.meta.id) ? [{ icon: "LayoutGrid", label: "Another board" }].concat(Te) : Te;
    }
    function Ee(Se) {
      return c.value ? t.remixFills(Se, i.sessionId) ? "Remix sets this session up with the prompt, its tool and its images." : "Remix starts a new session beside this one, with the prompt, its tool and its images." : "Remix starts a new session with this prompt, its tool and its images.";
    }
    function j(Se) {
      const Te = z[Se.kind] + " " + D[Jr(Se)].toLowerCase();
      return (_r(Se) ? "My prompts" : "Featured") + " · " + Te + (Se.category ? " · " + Se.category : "");
    }
    function V(Se) {
      return _r(Se) ? "Saved by " + (Se.authorId === e.user.uid ? "you" : Se.authorName || "someone") + (Se.updatedAt ? " · " + i1(Se.updatedAt) : "") : "";
    }
    const Q = I(() => (e.promptRev.value, e.results.rev.value, t.canSave ? t.draftForSession(i.sessionId) : null)), oe = I(() => {
      if (!i.editing) return null;
      if (i.editing === "new") return Q.value;
      const Se = t.myPrompt(i.editing);
      return Se ? t.draftFor(Se) : null;
    }), ue = I(() => oe.value ? oe.value.output.thumb || oe.value.output.url : "");
    function Ie() {
      i.detail = null, i.editing = "new";
    }
    function he(Se) {
      i.editing = null, i.detail = Se;
    }
    function ye(Se) {
      ve(), t.setTab(Se), it(we);
    }
    function fe(Se, Te = null, ae = null) {
      ve(), t.setBranch(Se, Te, ae), d.value = !1, it(we);
    }
    function ze(Se, Te) {
      l.value = Te, i.detail = Se.id;
    }
    function He(Se) {
      const Te = M.value;
      if (!Te.length) return;
      if (!p.value && Se > 0 && q.value === Te.length - 1 && t.myPrompts.hasMore.value) {
        const Me = Te.length;
        t.myPrompts.loadMore().then(() => {
          const Xe = M.value[Me];
          Xe && i.detail === Te[Me - 1].id && (l.value = null, i.detail = Xe.id);
        });
        return;
      }
      const ae = q.value < 0 ? 0 : (q.value + Se + Te.length) % Te.length;
      l.value = null, i.detail = Te[ae].id;
    }
    function ce() {
      const Se = i.detail;
      i.detail = null, it(() => {
        const Te = o.value && Se ? o.value.querySelector('[data-prompt-id="' + Se + '"] .pl-tile-hit') : null;
        Te && Te.focus({ preventScroll: !0 });
      });
    }
    function be() {
      i.query = "", r.value && r.value.focus();
    }
    function Be(Se) {
      _r(Se) && t.remove(Se);
    }
    function Fe(Se) {
      _r(Se) && (i.editing = Se.id);
    }
    $e(() => i.query, () => {
      i.detail = null, s.value && (s.value.scrollTop = 0);
    });
    function Ke(Se) {
      Se.key === "Escape" ? (Se.preventDefault(), Se.stopPropagation(), i.query ? i.query = "" : r.value && r.value.blur()) : Se.key === "ArrowDown" && (Se.preventDefault(), ht(0));
    }
    function Qe() {
      return o.value ? Array.from(o.value.querySelectorAll(".pl-tile-hit")) : [];
    }
    function ht(Se) {
      const Te = Qe();
      if (!Te.length) return;
      const ae = Te[Math.max(0, Math.min(Te.length - 1, Se))];
      ae.focus(), ae.scrollIntoView({ block: "nearest" });
    }
    function Le() {
      const Se = o.value;
      return Se ? Math.max(1, getComputedStyle(Se).gridTemplateColumns.split(" ").filter(Boolean).length) : 1;
    }
    function Ne(Se) {
      if (Se.key !== "ArrowDown" && Se.key !== "ArrowUp") return;
      const Te = a.value ? Array.from(a.value.querySelectorAll(".pl-node")) : [], ae = Te.indexOf(document.activeElement);
      ae < 0 || (Se.preventDefault(), Se.stopPropagation(), Te[Math.max(0, Math.min(Te.length - 1, ae + (Se.key === "ArrowDown" ? 1 : -1)))].focus());
    }
    function le(Se) {
      if (!i.open || i.editing || Se.metaKey || Se.ctrlKey || Se.altKey) return;
      const Te = Se.target;
      if (Te && (Te.tagName === "INPUT" || Te.tagName === "TEXTAREA" || Te.isContentEditable) || Te && Te.closest && Te.closest(".pl-side") && Se.key !== "/") return;
      if (Se.key === "/") {
        Se.preventDefault(), r.value && r.value.focus();
        return;
      }
      if (G.value) {
        (Se.key === "ArrowRight" || Se.key === "ArrowLeft") && (Se.preventDefault(), He(Se.key === "ArrowRight" ? 1 : -1));
        return;
      }
      const ae = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: Le(), ArrowUp: -Le() };
      if (!(Se.key in ae)) return;
      Se.preventDefault();
      const Xe = Qe().indexOf(document.activeElement);
      ht(Xe < 0 ? 0 : Xe + ae[Se.key]);
    }
    function ve() {
      s.value && (t.scroll[t.scrollKey()] = s.value.scrollTop);
    }
    function we() {
      s.value && (s.value.scrollTop = t.scroll[t.scrollKey()] || 0);
    }
    $e(y, (Se) => {
      Se === "ready" && it(we);
    }), ot(() => {
      window.addEventListener("keydown", le), it(we), zL();
    }), Ve(() => {
      window.removeEventListener("keydown", le), ve(), se && clearTimeout(se), t.myPrompts.setShown(!1);
    });
    function je(Se) {
      return _r(Se) && t.canEdit(Se);
    }
    return (Se, Te) => (g(), v("div", {
      class: U(["pl-wrap", { "is-floating": n.floating }]),
      "data-testid": "prompt-library",
      onPointerdown: Te[20] || (Te[20] = Pe(() => {
      }, ["stop"]))
    }, [
      h("button", {
        class: "pl-close",
        title: "Close",
        "aria-label": "Close the prompt library",
        "data-testid": "library-close",
        onClick: Te[0] || (Te[0] = (ae) => m(t).close())
      }, [
        C(R, {
          name: "X",
          size: 15
        })
      ]),
      h("section", {
        class: U(["pl-panel", { "is-side-open": d.value }]),
        role: "dialog",
        "aria-label": "Prompt library"
      }, [
        h("aside", {
          ref_key: "sideEl",
          ref: a,
          class: "pl-side",
          "aria-label": "Browse prompts",
          "data-testid": "library-side",
          onKeydown: Ne
        }, [
          h("div", hoe, [
            h("button", {
              role: "tab",
              "aria-selected": m(i).tab === "featured",
              class: U({ on: m(i).tab === "featured" }),
              "data-testid": "tab-featured",
              onClick: Te[1] || (Te[1] = (ae) => ye("featured"))
            }, [
              Te[21] || (Te[21] = X(" Featured", -1)),
              B.value ? (g(), v("span", foe, A(B.value), 1)) : E("", !0)
            ], 10, poe),
            h("button", {
              role: "tab",
              "aria-selected": m(i).tab === "mine",
              class: U({ on: m(i).tab === "mine" }),
              "data-testid": "tab-mine",
              onClick: Te[2] || (Te[2] = (ae) => ye("mine"))
            }, [
              Te[22] || (Te[22] = X(" My prompts", -1)),
              k.value ? (g(), v("span", goe, A(k.value), 1)) : E("", !0)
            ], 10, moe)
          ]),
          h("div", boe, [
            h("nav", voe, [
              h("button", {
                class: U(["pl-node is-root", { on: !m(i).kind }]),
                "aria-current": m(i).kind ? void 0 : "true",
                "data-testid": "kind-all",
                onClick: Te[3] || (Te[3] = (ae) => fe(null))
              }, [
                C(R, {
                  name: "LayoutGrid",
                  size: 14
                }),
                Te[23] || (Te[23] = h("span", { class: "lbl" }, "All prompts", -1)),
                h("span", xoe, A(Z.value.total), 1)
              ], 10, yoe),
              (g(!0), v(H, null, me(Z.value.kinds, (ae) => (g(), v("div", {
                key: ae.kind,
                class: U(["pl-branch", { "is-in": m(i).kind === ae.kind }])
              }, [
                h("button", {
                  class: U(["pl-node is-kind", { on: m(i).kind === ae.kind && !m(i).action, "is-empty": !ae.count }]),
                  "aria-current": m(i).kind === ae.kind && !m(i).action ? "true" : void 0,
                  "aria-label": z[ae.kind] + " prompts, " + ae.count,
                  "data-testid": "kind-" + ae.kind,
                  onClick: (Me) => fe(ae.kind)
                }, [
                  C(R, {
                    name: P[ae.kind],
                    size: 14
                  }, null, 8, ["name"]),
                  h("span", koe, A(z[ae.kind]), 1),
                  h("span", _oe, A(ae.count), 1)
                ], 10, woe),
                (g(!0), v(H, null, me(ae.actions, (Me) => (g(), v(H, {
                  key: Me.action
                }, [
                  h("button", {
                    class: U(["pl-node is-action", { on: m(i).kind === ae.kind && m(i).action === Me.action && !m(i).category, "is-in": m(i).kind === ae.kind && m(i).action === Me.action, "is-empty": !Me.count }]),
                    "aria-current": m(i).kind === ae.kind && m(i).action === Me.action && !m(i).category ? "true" : void 0,
                    "aria-label": D[Me.action] + " " + (ae.kind === "image" ? "images" : "videos") + ", " + O[ae.kind][Me.action].toLowerCase() + ", " + Me.count,
                    title: L[ae.kind + "-" + Me.action],
                    "data-testid": "action-" + ae.kind + "-" + Me.action,
                    onClick: (Xe) => fe(ae.kind, Me.action)
                  }, [
                    C(R, {
                      name: $[Me.action],
                      size: 13
                    }, null, 8, ["name"]),
                    h("span", Toe, [
                      X(A(D[Me.action]), 1),
                      h("em", null, A(O[ae.kind][Me.action]), 1)
                    ]),
                    h("span", Moe, A(Me.count), 1)
                  ], 10, Soe),
                  m(i).kind === ae.kind && m(i).action === Me.action && Me.categories.length ? (g(), v("div", Coe, [
                    (g(!0), v(H, null, me(Me.categories, (Xe) => {
                      var Rt;
                      return g(), v("button", {
                        key: Xe.label,
                        class: U(["pl-node is-cat", { on: m(i).category === Xe.label }]),
                        "aria-current": m(i).category === Xe.label ? "true" : void 0,
                        title: ((Rt = J.value.get(Xe.label)) == null ? void 0 : Rt.description) || void 0,
                        "data-testid": "category-" + re(Xe.label),
                        onClick: (Hn) => fe(ae.kind, Me.action, Xe.label)
                      }, [
                        h("span", Aoe, A(Xe.label), 1),
                        h("span", Poe, A(Xe.count), 1)
                      ], 10, Ioe);
                    }), 128))
                  ])) : E("", !0)
                ], 64))), 128))
              ], 2))), 128))
            ]),
            p.value ? E("", !0) : (g(), v("section", Eoe, [
              Te[24] || (Te[24] = h("span", { class: "pl-side-label" }, "Shared with", -1)),
              (g(!0), v(H, null, me(_.value, (ae) => (g(), v("button", {
                key: ae.id,
                class: U(["pl-node is-level", { on: m(i).levels.includes(ae.id) }]),
                "aria-pressed": m(i).levels.includes(ae.id),
                "data-testid": "level-filter-" + ae.id,
                onClick: (Me) => T(ae.id)
              }, [
                h("span", zoe, [
                  C(R, {
                    name: "Check",
                    size: 10,
                    stroke: 3
                  })
                ]),
                C(R, {
                  name: ae.icon,
                  size: 13
                }, null, 8, ["name"]),
                h("span", $oe, A(ae.label), 1),
                h("span", Doe, A(x(ae.id)), 1)
              ], 10, Roe))), 128))
            ]))
          ])
        ], 544),
        d.value ? (g(), v("div", {
          key: 0,
          class: "pl-side-scrim",
          onClick: Te[4] || (Te[4] = (ae) => d.value = !1)
        })) : E("", !0),
        h("div", Ooe, [
          h("header", Loe, [
            h("button", {
              class: "pl-icon-btn pl-side-toggle",
              "aria-expanded": d.value,
              title: "Browse by kind and category",
              "aria-label": "Browse by kind and category",
              "data-testid": "library-side-toggle",
              onClick: Te[5] || (Te[5] = (ae) => d.value = !d.value)
            }, [
              C(R, {
                name: "PanelLeft",
                size: 16
              })
            ], 8, Boe),
            h("label", Foe, [
              C(R, {
                name: "Search",
                size: 14
              }),
              xt(h("input", {
                ref_key: "searchEl",
                ref: r,
                "onUpdate:modelValue": Te[6] || (Te[6] = (ae) => m(i).query = ae),
                placeholder: p.value ? "Search featured prompts" : "Search your prompts",
                spellcheck: "false",
                "data-testid": "library-search",
                onKeydown: Ke
              }, null, 40, Noe), [
                [Jt, m(i).query]
              ]),
              m(i).query ? (g(), v("button", {
                key: 0,
                class: "pl-clear",
                title: "Clear the search",
                "aria-label": "Clear the search",
                onClick: be
              }, [
                C(R, {
                  name: "X",
                  size: 12
                })
              ])) : (g(), v("kbd", Uoe, "/"))
            ]),
            !p.value && Q.value && !m(i).editing ? (g(), v("button", {
              key: 0,
              class: "pl-btn is-glass is-lg pl-head-act",
              title: "Save this session's prompt, tool and settings",
              "data-testid": "save-current",
              onClick: Ie
            }, [
              C(R, {
                name: "Plus",
                size: 13
              }),
              Te[25] || (Te[25] = X("Save current prompt ", -1))
            ])) : E("", !0)
          ]),
          !G.value && !m(i).editing ? (g(), v("div", Goe, [
            W.value.crumb ? (g(), v("span", joe, [
              X(A(W.value.crumb), 1),
              C(R, {
                name: "ChevronRight",
                size: 12
              })
            ])) : E("", !0),
            h("b", Hoe, A(W.value.title), 1),
            h("span", {
              class: "pl-scope-hint",
              title: W.value.hint
            }, A(W.value.hint), 9, Voe),
            ee.value ? (g(), v("span", Woe, A(ee.value), 1)) : E("", !0)
          ])) : E("", !0),
          h("div", qoe, [
            h("div", {
              ref_key: "bodyEl",
              ref: s,
              class: U(["pl-body", { "is-covered": !!G.value || !!m(i).editing }]),
              onScrollPassive: ie
            }, [
              y.value === "idle" || y.value === "loading" ? (g(), v("div", Koe, [
                (g(), v(H, null, me(6, (ae) => h("span", {
                  key: ae,
                  class: "pl-tile is-skeleton"
                })), 64))
              ])) : y.value === "failed" ? (g(), v("div", Yoe, [
                C(R, {
                  name: "CloudOff",
                  size: 22
                }),
                h("b", null, A(p.value ? "The Featured prompts couldn't be loaded" : "Your prompts couldn't be loaded"), 1),
                Te[26] || (Te[26] = h("span", null, "Check your connection, then try again.", -1)),
                p.value ? (g(), v("button", {
                  key: 0,
                  class: "pl-btn is-glass is-lg",
                  onClick: Te[7] || (Te[7] = (ae) => m(t).load())
                }, "Try again")) : (g(), v("button", {
                  key: 1,
                  class: "pl-btn is-glass is-lg",
                  "data-testid": "library-mine-retry",
                  onClick: Te[8] || (Te[8] = (ae) => m(t).startMine())
                }, "Try again"))
              ])) : p.value && !B.value ? (g(), v("div", Xoe, [
                C(R, {
                  name: "LayoutTemplate",
                  size: 22
                }),
                Te[27] || (Te[27] = h("b", null, "Featured prompts are in development", -1)),
                m(e).user.isAdmin ? (g(), v("span", Joe, "No Featured set is published here yet.")) : E("", !0)
              ])) : !p.value && !m(t).canSave ? (g(), v("div", Zoe, [
                h("span", Qoe, [
                  C(R, {
                    name: "Bookmark",
                    size: 20
                  })
                ]),
                Te[28] || (Te[28] = h("b", null, "Your own prompts", -1)),
                Te[29] || (Te[29] = h("span", null, "Saving prompts isn't available here.", -1))
              ])) : !p.value && !k.value && !b.value.length ? (g(), v("div", ere, [
                h("span", tre, [
                  C(R, {
                    name: "Bookmark",
                    size: 20
                  })
                ]),
                Te[31] || (Te[31] = h("b", null, "Nothing saved yet", -1)),
                h("span", null, "Save the prompt behind a result you like: select it on the canvas, open its record or hover it in a session's gallery, and choose Save prompt. Keep it for yourself, or share it with this board or your " + A(S.value) + ".", 1),
                Q.value ? (g(), v("button", {
                  key: 0,
                  class: "pl-btn is-glass is-lg",
                  onClick: Ie
                }, [
                  C(R, {
                    name: "Plus",
                    size: 13
                  }),
                  Te[30] || (Te[30] = X("Save current prompt", -1))
                ])) : E("", !0)
              ])) : p.value && m(i).kind === "video" && N.value && !N.value.video ? (g(), v("div", nre, [
                h("span", ire, [
                  C(R, {
                    name: "Video",
                    size: 20
                  })
                ]),
                Te[32] || (Te[32] = h("b", null, "Featured video prompts are in development", -1)),
                Te[33] || (Te[33] = h("span", null, "Prompts you save from a video session are under My prompts.", -1)),
                h("span", sre, [
                  h("button", {
                    class: "pl-btn is-glass",
                    onClick: Te[9] || (Te[9] = (ae) => ye("mine"))
                  }, "My prompts"),
                  h("button", {
                    class: "pl-btn is-glass",
                    onClick: Te[10] || (Te[10] = (ae) => fe(null))
                  }, "All prompts")
                ])
              ])) : M.value.length ? (g(), v("div", {
                key: 7,
                ref_key: "gridEl",
                ref: o,
                class: "pl-grid",
                "data-testid": "library-grid"
              }, [
                (g(!0), v(H, null, me(M.value, (ae) => (g(), Ce(yse, {
                  key: ae.id,
                  prompt: ae,
                  "tool-name": De(ae),
                  "remix-hint": Ee(ae),
                  levels: Oe(ae),
                  onOpen: (Me) => ze(ae, Me),
                  onUse: (Me) => m(t).use(ae, m(i).sessionId),
                  onRemix: (Me) => m(t).remix(ae, m(i).sessionId)
                }, null, 8, ["prompt", "tool-name", "remix-hint", "levels", "onOpen", "onUse", "onRemix"]))), 128))
              ], 512)) : (g(), v("div", ore, [
                C(R, {
                  name: "Search",
                  size: 22
                }),
                h("b", null, A(te.value), 1),
                h("span", rre, [
                  m(i).category ? (g(), v("button", {
                    key: 0,
                    class: "pl-btn is-glass",
                    onClick: Te[11] || (Te[11] = (ae) => fe(m(i).kind, m(i).action))
                  }, "Every category")) : E("", !0),
                  m(i).kind ? (g(), v("button", {
                    key: 1,
                    class: "pl-btn is-glass",
                    onClick: Te[12] || (Te[12] = (ae) => fe(null))
                  }, "All prompts")) : E("", !0),
                  m(i).levels.length ? (g(), v("button", {
                    key: 2,
                    class: "pl-btn is-glass",
                    onClick: Te[13] || (Te[13] = (ae) => m(i).levels = [])
                  }, "Every level")) : E("", !0),
                  m(i).query ? (g(), v("button", {
                    key: 3,
                    class: "pl-btn is-glass",
                    onClick: be
                  }, "Clear the search")) : E("", !0)
                ])
              ]))
            ], 34),
            C(vt, { name: "pl-detail" }, {
              default: et(() => [
                G.value && !m(i).editing ? (g(), Ce(uoe, {
                  key: 0,
                  prompt: G.value,
                  index: q.value < 0 ? 0 : q.value,
                  total: ne.value.n,
                  more: ne.value.more,
                  "tool-name": De(G.value),
                  note: m(t).toolNote(G.value, m(i).sessionId),
                  "remix-hint": Ee(G.value),
                  from: l.value,
                  crumb: j(G.value),
                  byline: V(G.value),
                  levels: Oe(G.value),
                  "can-edit": je(G.value),
                  onBack: ce,
                  onStep: He,
                  onUse: Te[14] || (Te[14] = (ae) => m(t).use(G.value, m(i).sessionId)),
                  onRemix: Te[15] || (Te[15] = (ae) => m(t).remix(G.value, m(i).sessionId)),
                  onEdit: Te[16] || (Te[16] = (ae) => Fe(G.value)),
                  onDelete: Te[17] || (Te[17] = (ae) => Be(G.value))
                }, null, 8, ["prompt", "index", "total", "more", "tool-name", "note", "remix-hint", "from", "crumb", "byline", "levels", "can-edit"])) : E("", !0)
              ]),
              _: 1
            }),
            C(vt, { name: "pl-detail" }, {
              default: et(() => [
                m(i).editing && oe.value ? (g(), v("div", are, [
                  h("div", lre, [
                    ue.value ? (g(), v("img", {
                      key: 0,
                      class: "pl-detail-img",
                      src: ue.value,
                      alt: "",
                      draggable: "false"
                    }, null, 8, dre)) : (g(), v("span", cre, A(oe.value.prompt), 1)),
                    h("button", {
                      class: "pl-back",
                      title: "Back",
                      "aria-label": "Back",
                      onClick: Te[18] || (Te[18] = (ae) => m(i).editing = null)
                    }, [
                      C(R, {
                        name: "ArrowLeft",
                        size: 15
                      })
                    ])
                  ]),
                  h("div", ure, [
                    (g(), Ce(g8, {
                      key: m(i).editing,
                      draft: oe.value,
                      "editing-id": m(i).editing === "new" ? null : m(i).editing,
                      onDone: he,
                      onCancel: Te[19] || (Te[19] = (ae) => m(i).editing = null)
                    }, null, 8, ["draft", "editing-id"]))
                  ])
                ])) : E("", !0)
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ], 34));
  }
}), fre = { class: "up-pop-label" }, mre = ["aria-label"], gre = ["aria-selected", "data-testid", "onClick"], bre = {
  key: 0,
  class: "up-refgrid",
  "data-testid": "ref-pinned"
}, vre = ["title", "onClick"], yre = {
  key: 0,
  class: "up-refgrid"
}, xre = ["title", "onClick"], wre = {
  key: 1,
  class: "up-adv-hint up-refpick-note"
}, kre = {
  key: 0,
  class: "up-refgrid",
  "data-testid": "ref-library"
}, _re = ["title", "onClick"], Sre = {
  key: 1,
  class: "up-adv-hint up-refpick-note"
}, Tre = {
  key: 2,
  class: "up-adv-hint up-refpick-note"
}, Mre = {
  key: 3,
  class: "up-adv-hint up-refpick-note"
}, Cre = { class: "up-pop-main" }, Ire = ["disabled"], Are = { class: "up-pop-main" }, Pre = {
  key: 6,
  class: "up-refpick-tip",
  "data-testid": "ref-tip"
}, Ere = {
  key: 7,
  class: "up-refpick-tip",
  "data-testid": "ref-shift-tip"
}, sf = /* @__PURE__ */ Re({
  __name: "RefPicker",
  props: {
    sessionId: {},
    label: {},
    kind: { default: "image" },
    dropperLabel: { default: "Pick from the board" },
    tip: { default: "" },
    dropper: { type: Boolean, default: !0 }
  },
  emits: ["pick", "dropper", "close"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = tt(), o = /* @__PURE__ */ K(null), r = Ef().shift, a = /* @__PURE__ */ K(!1), l = I(() => t.kind === "video"), d = [
      { id: "pinned", label: "Pinned" },
      { id: "board", label: "This board" },
      ...s.hasLibrary ? [
        { id: "generations", label: "Generations" },
        { id: "uploads", label: "Uploads" },
        { id: "favorites", label: "Favorites" }
      ] : []
    ], c = I(() => s.pinnedImages.value.filter((P) => !!P.video === l.value)), u = /* @__PURE__ */ K(c.value.length ? "pinned" : "board");
    function p(P) {
      P.asset && s.rememberAsset(P.url, P.asset), i("pick", P.url);
    }
    const f = I(() => {
      s.docRev.value, s.results.rev.value;
      const P = /* @__PURE__ */ new Set(), D = [];
      for (const O of s.results.list(t.sessionId))
        O.status !== "done" || !O.url || !!O.video !== l.value || P.has(O.url) || (P.add(O.url), D.push({ url: O.url, label: O.label || "result" }));
      const $ = s.imagesInOrder().slice().reverse();
      for (const O of $)
        if (!(!!O.video !== l.value || P.has(O.src)) && (P.add(O.src), D.push({ url: O.src, label: O.label || "image" }), D.length >= 60))
          break;
      return D;
    }), y = /* @__PURE__ */ Xt({
      generations: { items: [], next: null, loading: !1, loaded: !1, failed: !1 },
      uploads: { items: [], next: null, loading: !1, loaded: !1, failed: !1 },
      favorites: { items: [], next: null, loading: !1, loaded: !1, failed: !1 }
    });
    async function b(P, D = !1) {
      const $ = y[P];
      if (!$.loading) {
        $.loading = !0, $.failed = !1;
        try {
          const O = await s.libraryPage(P, { cursor: D ? $.next : null });
          $.items = D ? $.items.concat(O.items) : O.items, $.next = O.next, $.loaded = !0;
        } catch (O) {
          console.warn("[board] library unavailable", O), $.failed = !0;
        } finally {
          $.loading = !1;
        }
      }
    }
    const w = (P) => P !== "board" && P !== "pinned";
    $e(u, (P) => {
      w(P) && !y[P].loaded && b(P);
    });
    function k() {
      const P = u.value;
      w(P) && b(P, !0);
    }
    const S = I(() => {
      const P = u.value;
      return w(P) ? y[P] : null;
    }), _ = I(() => S.value ? S.value.items.filter((P) => P.video === l.value && !P.moderated) : []), x = I(() => {
      const P = l.value ? "videos" : "images";
      return u.value === "generations" ? "No generated " + P + " yet." : u.value === "uploads" ? "No uploaded " + P + " yet." : "Star a result to keep it here.";
    });
    function T(P) {
      s.rememberAsset(P.url, P.asset), i("pick", P.url);
    }
    function M() {
      s.openLibrary({
        purpose: "pick",
        max: 1,
        kinds: [t.kind],
        onPick: (P) => {
          P[0] && T(P[0]);
        }
      });
    }
    async function z(P) {
      const D = P.target.files;
      if (!(!D || !D.length || !s.uploader)) {
        a.value = !0;
        try {
          const { url: $ } = await s.uploadFile(D[0]);
          i("pick", $);
        } catch ($) {
          const O = $ ? $.userMessage : void 0;
          s.toast(O || "That image could not be uploaded.", "error");
        } finally {
          a.value = !1;
        }
      }
    }
    return (P, D) => (g(), v("div", {
      class: "up-pop up-refpick has-tabs",
      "data-testid": "ref-picker",
      onPointerdown: D[2] || (D[2] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", fre, A(n.label), 1),
      h("div", {
        class: "up-pop-tabs",
        role: "tablist",
        "aria-label": n.label + " sources"
      }, [
        (g(), v(H, null, me(d, ($) => h("button", {
          key: $.id,
          role: "tab",
          "aria-selected": u.value === $.id,
          class: U({ on: u.value === $.id }),
          "data-testid": "ref-tab-" + $.id,
          onClick: (O) => u.value = $.id
        }, A($.label), 11, gre)), 64))
      ], 8, mre),
      u.value === "pinned" ? (g(), v(H, { key: 0 }, [
        c.value.length ? (g(), v("div", bre, [
          (g(!0), v(H, null, me(c.value, ($) => (g(), v("button", {
            key: $.id,
            class: U(["up-refcell", { "is-video": $.video }]),
            title: $.label,
            style: de({ backgroundImage: 'url("' + m(Wt)($.url) + '")' }),
            onClick: (O) => p($)
          }, null, 14, vre))), 128))
        ])) : (g(), Ce(f1, {
          key: 1,
          compact: "",
          kind: n.kind
        }, null, 8, ["kind"]))
      ], 64)) : u.value === "board" ? (g(), v(H, { key: 1 }, [
        f.value.length ? (g(), v("div", yre, [
          (g(!0), v(H, null, me(f.value, ($) => (g(), v("button", {
            key: $.url,
            class: "up-refcell",
            title: $.label,
            style: de({ backgroundImage: 'url("' + m(Wt)($.url) + '")' }),
            onClick: (O) => i("pick", $.url)
          }, null, 12, xre))), 128))
        ])) : (g(), v("div", wre, A(n.kind === "video" ? "No videos on this board yet." : "No images on this board yet."), 1))
      ], 64)) : S.value ? (g(), v(H, { key: 2 }, [
        _.value.length ? (g(), v("div", kre, [
          (g(!0), v(H, null, me(_.value, ($) => (g(), v("button", {
            key: $.id,
            class: U(["up-refcell", { "is-video": $.video }]),
            title: $.label,
            style: de({ backgroundImage: 'url("' + m(Wt)($.url) + '")' }),
            onClick: (O) => T($)
          }, null, 14, _re))), 128))
        ])) : E("", !0),
        S.value.loading ? (g(), v("div", Sre, [...D[3] || (D[3] = [
          h("span", { class: "bd-spinner is-sm" }, null, -1),
          X("Loading", -1)
        ])])) : S.value.failed ? (g(), v("div", Tre, "This couldn't be loaded.")) : _.value.length ? E("", !0) : (g(), v("div", Mre, A(x.value), 1)),
        S.value.next && !S.value.loading ? (g(), v("button", {
          key: 4,
          class: "up-pop-row up-refpick-more",
          onClick: k
        }, [
          C(R, {
            name: "ChevronDown",
            size: 13
          }),
          D[4] || (D[4] = h("span", { class: "up-pop-main" }, "Load more", -1))
        ])) : E("", !0)
      ], 64)) : E("", !0),
      n.dropper ? (g(), v("button", {
        key: 3,
        class: "up-pop-row",
        "data-testid": "ref-pick-from-board",
        onClick: D[0] || (D[0] = ($) => i("dropper"))
      }, [
        C(R, {
          name: "Pipette",
          size: 13
        }),
        h("span", Cre, A(n.dropperLabel), 1)
      ])) : E("", !0),
      m(s).hasLibrary ? (g(), v("button", {
        key: 4,
        class: "up-pop-row",
        "data-testid": "ref-open-library",
        onClick: M
      }, [
        C(R, {
          name: "Library",
          size: 13
        }),
        D[5] || (D[5] = h("span", { class: "up-pop-main" }, "Open your Library", -1))
      ])) : E("", !0),
      m(s).uploader && n.kind !== "video" ? (g(), v("button", {
        key: 5,
        class: "up-pop-row",
        disabled: a.value,
        onClick: D[1] || (D[1] = ($) => o.value && o.value.click())
      }, [
        C(R, {
          name: a.value ? "Loader2" : "Upload",
          size: 13,
          spin: a.value
        }, null, 8, ["name", "spin"]),
        h("span", Are, A(a.value ? "Uploading…" : "Upload an image"), 1)
      ], 8, Ire)) : E("", !0),
      h("input", {
        ref_key: "fileEl",
        ref: o,
        type: "file",
        accept: "image/*",
        style: { display: "none" },
        onChange: z
      }, null, 544),
      n.tip ? (g(), v("div", Pre, [
        C(R, {
          name: "Hand",
          size: 13
        }),
        h("span", null, A(n.tip), 1)
      ])) : (g(), v("div", Ere, [
        h("kbd", null, A(m(r)), 1),
        h("span", null, "Or hold Shift and drag " + A(n.kind === "video" ? "a video" : "an image") + " from the board here, or onto any session.", 1)
      ]))
    ], 32));
  }
}), Rre = { class: "up-pop-label" }, zre = {
  key: 0,
  class: "up-pop-search"
}, $re = { class: "up-modelpick-av is-none" }, Dre = {
  key: 0,
  class: "up-modelpick-group"
}, Ore = ["title", "onClick"], Lre = ["src", "onError"], Bre = {
  key: 1,
  class: "up-modelpick-av"
}, Fre = { class: "up-pop-main" }, Nre = {
  key: 0,
  class: "up-modelpick-desc"
}, Ure = {
  key: 2,
  class: "up-modelpick-note"
}, Gre = {
  key: 3,
  class: "up-modelpick-note"
}, jre = {
  key: 4,
  class: "up-modelpick-note"
}, Hre = {
  key: 5,
  class: "up-modelpick-note"
}, Vre = /* @__PURE__ */ Re({
  __name: "ModelFieldPop",
  props: {
    field: {},
    selectedId: {},
    required: { type: Boolean }
  },
  emits: ["pick"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = tt(), o = /* @__PURE__ */ K(!0), r = /* @__PURE__ */ K(!1), a = /* @__PURE__ */ K(""), l = /* @__PURE__ */ K(s.trainedModelsSeen.value || []);
    ot(async () => {
      try {
        l.value = await s.trainedModels();
      } catch (w) {
        console.warn("[board] trained models unavailable", w), r.value = !0;
      } finally {
        o.value = !1;
      }
    });
    const d = I(() => l.value.filter((w) => !t.field.architecture || w.architecture === t.field.architecture)), c = I(() => {
      const w = a.value.trim().toLowerCase();
      return w ? d.value.filter((k) => k.name.toLowerCase().includes(w) || (k.description || "").toLowerCase().includes(w)) : d.value;
    }), u = I(() => c.value.filter((w) => !w.shared)), p = I(() => c.value.filter((w) => w.shared)), f = I(() => [
      { key: "yours", label: p.value.length ? "Yours" : "", list: u.value },
      { key: "shared", label: "Shared", list: p.value }
    ].filter((w) => w.list.length)), y = I(() => t.field.architecture ? t.field.architecture + " " : "");
    function b(w, k) {
      const S = w.target;
      k.image && S.src !== k.image && (S.src = k.image);
    }
    return (w, k) => (g(), v("div", {
      class: "up-pop is-wide up-modelpick",
      "data-testid": "model-field-pop",
      onPointerdown: k[3] || (k[3] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", Rre, A(n.field.label || "Trained model"), 1),
      d.value.length > 6 ? (g(), v("div", zre, [
        C(R, {
          name: "Search",
          size: 12
        }),
        xt(h("input", {
          "onUpdate:modelValue": k[0] || (k[0] = (S) => a.value = S),
          placeholder: "Search your models",
          onKeydown: k[1] || (k[1] = Pe(() => {
          }, ["stop"]))
        }, null, 544), [
          [Jt, a.value]
        ])
      ])) : E("", !0),
      !n.required && n.selectedId ? (g(), v("button", {
        key: 1,
        class: "up-pop-row",
        "data-testid": "model-field-none",
        onClick: k[2] || (k[2] = (S) => i("pick", null))
      }, [
        h("span", $re, [
          C(R, {
            name: "X",
            size: 13
          })
        ]),
        k[4] || (k[4] = h("span", { class: "up-pop-main" }, "Don't use a trained model", -1))
      ])) : E("", !0),
      (g(!0), v(H, null, me(f.value, (S) => (g(), v(H, {
        key: S.key
      }, [
        S.label ? (g(), v("div", Dre, A(S.label), 1)) : E("", !0),
        (g(!0), v(H, null, me(S.list, (_) => (g(), v("button", {
          key: _.id,
          class: U(["up-pop-row up-modelpick-row", { on: _.id === n.selectedId }]),
          title: _.description || _.name,
          onClick: (x) => i("pick", _.record)
        }, [
          _.thumb ? (g(), v("img", {
            key: 0,
            class: "up-modelpick-av",
            src: _.thumb,
            alt: "",
            draggable: "false",
            onError: (x) => b(x, _)
          }, null, 40, Lre)) : (g(), v("span", Bre, [
            C(R, {
              name: "Sparkles",
              size: 13
            })
          ])),
          h("span", Fre, [
            X(A(_.name) + " ", 1),
            _.description ? (g(), v("span", Nre, A(_.description), 1)) : E("", !0)
          ]),
          _.id === n.selectedId ? (g(), Ce(R, {
            key: 2,
            name: "Check",
            size: 13
          })) : E("", !0)
        ], 10, Ore))), 128))
      ], 64))), 128)),
      o.value && !l.value.length ? (g(), v("div", Ure, [...k[5] || (k[5] = [
        h("span", { class: "bd-spinner is-sm" }, null, -1),
        X("Loading your models", -1)
      ])])) : r.value && !l.value.length ? (g(), v("div", Gre, "Your models couldn't be loaded.")) : !o.value && !d.value.length ? (g(), v("div", jre, " No " + A(y.value) + "models yet. Models you train show up here. ", 1)) : a.value && !c.value.length ? (g(), v("div", Hre, "No models match “" + A(a.value) + "”.", 1)) : E("", !0)
    ], 32));
  }
}), Wre = { class: "media" }, qre = ["poster", "autoplay", "data-slide"], Kre = ["src"], Yre = ["src", "data-slide"], Xre = { class: "tag" }, Jre = { class: "body" }, Zre = { class: "foot" }, Qre = {
  class: "dots",
  role: "tablist",
  "aria-label": "Slides"
}, eae = ["aria-selected", "aria-label", "onClick"], tae = { class: "cta" }, sh = "/img/board/studio-view/", nae = 500, Bg = 3400, Fg = 7e3, iae = /* @__PURE__ */ Re({
  __name: "StudioViewButton",
  emits: ["open"],
  setup(n, { emit: e }) {
    const t = e, { board: i } = tt(), s = [
      { id: "overview", video: !1, title: "Your session, full screen", text: "The picture large, its versions above it, the board's history beside it." },
      { id: "area", video: !0, title: "Change just one area", text: "Paint over it and say what changes. Precision keeps every other pixel." },
      { id: "refs", video: !0, title: "References from history", text: "Pick pictures from history to guide the edit, or drag them in." },
      { id: "camera", video: !0, title: "Move the camera", text: "See the same scene from another angle." },
      { id: "relight", video: !0, title: "Relight it", text: "Golden hour, dusk or night: new light on the same scene." },
      { id: "compare", video: !0, title: "Compare versions", text: "Every result is a version. Split two to see what changed." }
    ], o = typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches, r = /* @__PURE__ */ K(!1), a = /* @__PURE__ */ K(0), l = /* @__PURE__ */ K(Bg / 1e3), d = I(() => s[a.value]);
    let c = 0, u = 0, p = 0;
    function f() {
      clearTimeout(u), !(r.value || i.tour) && (clearTimeout(c), c = window.setTimeout(b, nae));
    }
    function y() {
      clearTimeout(c), clearTimeout(u), u = window.setTimeout(() => {
        r.value = !1, clearTimeout(p);
      }, 160);
    }
    function b() {
      k(), a.value = 0, r.value = !0, S();
    }
    let w = !1;
    function k() {
      if (!w) {
        w = !0;
        for (const z of s) {
          const P = new Image();
          P.src = sh + z.id + ".jpg";
        }
      }
    }
    function S() {
      if (clearTimeout(p), o) return;
      const z = d.value;
      l.value = (z.video ? Fg : Bg) / 1e3, p = window.setTimeout(x, z.video ? Fg : Bg);
    }
    function _(z) {
      a.value = (z + s.length) % s.length, S();
    }
    function x() {
      _(a.value + 1);
    }
    function T(z) {
      const P = z.target;
      Number.isFinite(P.duration) && P.duration > 0 && (l.value = P.duration, clearTimeout(p), p = window.setTimeout(x, Math.min(Fg, P.duration * 1e3 + 600)));
    }
    function M() {
      clearTimeout(c), clearTimeout(p), r.value = !1, t("open");
    }
    return Ve(() => {
      clearTimeout(c), clearTimeout(u), clearTimeout(p);
    }), (z, P) => (g(), v("span", {
      class: "up-studio-wrap",
      onMouseenter: f,
      onMouseleave: y
    }, [
      h("button", {
        class: U(["up-studio", { on: r.value }]),
        "aria-label": "Studio view: open this session full screen",
        "data-testid": "prompt-studio",
        onClick: M,
        onFocus: f,
        onBlur: y
      }, [
        C(R, {
          name: "Expand",
          size: 13
        }),
        P[0] || (P[0] = h("span", null, "Studio", -1))
      ], 34),
      C(vt, { name: "up-studio-pop" }, {
        default: et(() => [
          r.value ? (g(), v("div", {
            key: 0,
            class: "up-studio-pop",
            role: "dialog",
            "aria-label": "Studio view",
            "data-testid": "studio-view-preview",
            onClick: M
          }, [
            h("div", Wre, [
              C(vt, { name: "up-studio-slide" }, {
                default: et(() => [
                  d.value.video ? (g(), v("video", {
                    key: d.value.id,
                    poster: sh + d.value.id + (m(o) ? "-end" : "") + ".jpg",
                    autoplay: !m(o),
                    muted: "",
                    playsinline: "",
                    preload: "auto",
                    disablepictureinpicture: "",
                    "data-slide": d.value.id,
                    onLoadedmetadata: T
                  }, [
                    h("source", {
                      src: sh + d.value.id + ".webm",
                      type: "video/webm"
                    }, null, 8, Kre)
                  ], 40, qre)) : (g(), v("img", {
                    key: d.value.id,
                    src: sh + d.value.id + ".jpg",
                    alt: "",
                    "data-slide": d.value.id,
                    draggable: "false"
                  }, null, 8, Yre))
                ]),
                _: 1
              }),
              h("span", Xre, [
                C(R, {
                  name: "Expand",
                  size: 10
                }),
                P[1] || (P[1] = X(" Studio view", -1))
              ])
            ]),
            h("div", Jre, [
              C(vt, {
                name: "up-studio-words",
                mode: "out-in"
              }, {
                default: et(() => [
                  (g(), v("div", {
                    key: d.value.id,
                    class: "words"
                  }, [
                    h("b", null, A(d.value.title), 1),
                    h("span", null, A(d.value.text), 1)
                  ]))
                ]),
                _: 1
              }),
              h("div", Zre, [
                h("span", Qre, [
                  (g(), v(H, null, me(s, (D, $) => h("button", {
                    key: D.id,
                    role: "tab",
                    "aria-selected": $ === a.value,
                    "aria-label": D.title,
                    class: U({ on: $ === a.value }),
                    style: de($ === a.value ? { "--d": l.value + "s" } : void 0),
                    onClick: Pe((O) => _($), ["stop"])
                  }, [
                    (g(), v("i", {
                      key: a.value + ":" + $
                    }))
                  ], 14, eae)), 64))
                ]),
                h("span", tae, [
                  P[2] || (P[2] = X("Open Studio ", -1)),
                  C(R, {
                    name: "ArrowRight",
                    size: 11
                  })
                ])
              ])
            ])
          ])) : E("", !0)
        ]),
        _: 1
      })
    ], 32));
  }
}), sae = ["aria-expanded", "aria-label", "title", "disabled"], oae = ["data-testid"], rae = { class: "sv-pop-rows" }, aae = ["aria-selected", "data-testid", "onClick"], lae = { class: "nm" }, Sy = /* @__PURE__ */ Re({
  __name: "CountPick",
  props: {
    value: {},
    min: { default: 1 },
    max: {},
    testid: { default: void 0 },
    tall: { type: Boolean, default: !1 }
  },
  emits: ["update"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ K(!1), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = I(() => {
      const w = [];
      for (let k = Math.max(1, t.min); k <= Math.max(t.min, t.max); k++) w.push(k);
      return w;
    }), d = I(() => l.value.length < 2);
    function c(w) {
      s.value = !1, w && it(() => {
        var k;
        return (k = r.value) == null ? void 0 : k.focus({ preventScroll: !0 });
      });
    }
    function u(w) {
      c(!0), w !== t.value && i("update", w);
    }
    function p() {
      return a.value ? [...a.value.querySelectorAll('[role="option"]')] : [];
    }
    function f(w) {
      const k = p(), S = k.indexOf(document.activeElement);
      let _ = -1;
      w.key === "ArrowDown" ? _ = Math.min(k.length - 1, S + 1) : w.key === "ArrowUp" ? _ = Math.max(0, S < 0 ? k.length - 1 : S - 1) : w.key === "Home" ? _ = 0 : w.key === "End" && (_ = k.length - 1), !(_ < 0) && (w.preventDefault(), k[_].focus());
    }
    function y(w) {
      o.value && !o.value.contains(w.target) && c(!1);
    }
    function b(w) {
      w.key === "Escape" && (w.stopPropagation(), w.preventDefault(), c(!0));
    }
    return $e(s, (w) => {
      w ? (window.addEventListener("pointerdown", y, !0), window.addEventListener("keydown", b, !0), it(() => {
        const k = p().find((S) => S.getAttribute("aria-selected") === "true");
        k && k.focus({ preventScroll: !0 });
      })) : (window.removeEventListener("pointerdown", y, !0), window.removeEventListener("keydown", b, !0));
    }), Ve(() => {
      window.removeEventListener("pointerdown", y, !0), window.removeEventListener("keydown", b, !0);
    }), (w, k) => (g(), v("span", {
      ref_key: "wrap",
      ref: o,
      class: "up-count-wrap"
    }, [
      h("button", {
        ref_key: "btn",
        ref: r,
        class: U(["up-count", { on: s.value, "is-tall": n.tall }]),
        "aria-expanded": s.value,
        "aria-haspopup": "listbox",
        "aria-label": "How many to make: " + n.value,
        title: d.value ? "This model makes " + n.value + " a run" : "How many to make",
        disabled: d.value,
        "data-testid": "count-pick",
        onClick: k[0] || (k[0] = (S) => s.value = !s.value)
      }, [
        h("span", {
          class: "n",
          "data-testid": n.testid
        }, A(n.value), 9, oae),
        d.value ? E("", !0) : (g(), Ce(R, {
          key: 0,
          name: "ChevronDown",
          size: 12,
          class: "chev"
        }))
      ], 10, sae),
      s.value ? (g(), v("div", {
        key: 0,
        ref_key: "list",
        ref: a,
        class: "sv-pop is-narrow up-count-pop",
        role: "listbox",
        "aria-label": "How many to make",
        "data-testid": "count-menu",
        onKeydown: f
      }, [
        k[1] || (k[1] = h("div", { class: "sv-pop-title" }, "How many", -1)),
        h("div", rae, [
          (g(!0), v(H, null, me(l.value, (S) => (g(), v("button", {
            key: S,
            class: U(["sv-pop-row", { on: S === n.value }]),
            role: "option",
            "aria-selected": S === n.value,
            "data-testid": "count-" + S,
            onClick: (_) => u(S)
          }, [
            h("span", lae, A(S), 1),
            S === n.value ? (g(), Ce(R, {
              key: 0,
              name: "Check",
              size: 12,
              class: "ck"
            })) : E("", !0)
          ], 10, aae))), 128))
        ])
      ], 544)) : E("", !0)
    ], 512));
  }
}), $r = ":pinned", el = ":all", Vf = ":kit";
function dae(n) {
  return n.tags && n.tags.length >= 2 ? n.tags : [Vf];
}
function cae(n, e) {
  return (e ? [$r] : []).concat([el], n);
}
function uae(n, e = "Models") {
  return n === $r ? "Pinned" : n === el ? "All" : n === Vf ? e : n;
}
function hae(n, e, t, i, s) {
  const o = i.trim().toLowerCase();
  return o ? e.filter((r) => r.name.toLowerCase().includes(o)) : t === $r ? e.filter((r) => s(r.id)) : t === el ? e.slice().sort((r, a) => r.name.localeCompare(a.name, void 0, { sensitivity: "base", numeric: !0 })) : t && t !== Vf ? n.filter((r) => !!r.kitTags && r.kitTags.includes(t)) : n.slice();
}
function pae(n) {
  return n.scrollWidth > n.clientWidth + 1;
}
function Y2(n, e) {
  e && pae(n) ? n.setAttribute("title", e) : n.removeAttribute("title");
}
const Va = {
  mounted(n, e) {
    Y2(n, e.value);
  },
  updated(n, e) {
    e.value !== e.oldValue && Y2(n, e.value);
  }
}, fae = 42, mae = 3200;
function yC(n, e = fae, t = mae) {
  const i = Array.from(n);
  if (!i.length) return [];
  const s = i.map((l, d) => {
    const c = i[d - 1], u = (Math.sin((d + 1) * 12.9898) * 43758.5453 % 1 + 1) % 1;
    return (c === "," || c === "." || c === ":" ? 3.4 : c === " " ? 1.45 : 1) * (0.78 + 0.44 * u);
  }), o = s.reduce((l, d) => l + d, 0), r = Math.min(t, i.length / e * 1e3);
  let a = 0;
  return s.map((l) => (a += l, Math.round(a / o * r)));
}
function gae(n, e, t = yC(n)) {
  const i = Array.from(n);
  let s = 0;
  for (; s < t.length && t[s] <= e; ) s++;
  return i.slice(0, s).join("");
}
function Ty(n) {
  const e = n.board.tour, t = I(() => {
    const l = n.sessionId();
    return e && l ? e.lineFor(n.field, l) : null;
  }), i = I(() => {
    const l = n.sessionId();
    return !!(e && l && e.holds(n.field, l));
  }), s = /* @__PURE__ */ K(!1), o = I(() => t.value && !s.value && !n.value() ? t.value : null);
  let r = 0;
  function a() {
    const l = t.value;
    if (!l || s.value || !e) return;
    s.value = !0, e.typing(n.field, !0);
    const d = yC(l), c = performance.now(), u = () => {
      const p = gae(l, performance.now() - c, d);
      if (p !== n.value() && n.write(p), p.length < Array.from(l).length) {
        r = requestAnimationFrame(u);
        return;
      }
      r = 0, s.value = !1, n.done && n.done(), e.typing(n.field, !1);
    };
    r = requestAnimationFrame(u);
  }
  return e && $e(() => e.tabbed(n.field), (l, d) => {
    l > (d || 0) && o.value && a();
  }), Ve(() => {
    r && cancelAnimationFrame(r), s.value && t.value && e && (n.write(t.value), n.done && n.done(), s.value = !1, e.typing(n.field, !1));
  }), { line: t, ghost: o, held: i, typing: s, typeIn: a };
}
const bae = {
  key: 0,
  class: "up-error",
  role: "alert",
  "data-testid": "prompt-error"
}, vae = ["aria-valuenow"], yae = { class: "up-side" }, xae = ["aria-expanded"], wae = {
  key: 0,
  class: "lib-new",
  "aria-hidden": "true"
}, kae = ["aria-pressed"], _ae = {
  key: 1,
  class: "up-refs",
  "data-testid": "prompt-refs"
}, Sae = ["title", "data-ref-key", "onMouseenter"], Tae = ["aria-label", "onClick"], Mae = {
  key: 0,
  class: "lbl"
}, Cae = {
  key: 0,
  class: "up-drop-wrap"
}, Iae = ["title", "aria-label", "data-ref-key", "onClick"], Aae = {
  key: 0,
  class: "up-drop-wrap"
}, Pae = ["title", "aria-label", "aria-expanded"], Eae = { class: "n" }, Rae = { class: "s" }, zae = { class: "up-moregrid" }, $ae = ["title", "data-ref-key"], Dae = ["onClick"], Oae = ["title", "aria-label", "data-ref-key", "onClick"], Lae = ["title"], Bae = ["value", "placeholder", "readonly"], Fae = ["data-ref-key"], Nae = {
  key: 5,
  class: "up-cue",
  "data-testid": "ghost-cue"
}, Uae = ["src"], Gae = { class: "n" }, jae = { class: "up-foot" }, Hae = { class: "up-chips" }, Vae = { class: "up-chip-wrap up-model-wrap" }, Wae = { class: "nm" }, qae = { class: "up-pop-label" }, Kae = { class: "up-pop-search" }, Yae = ["placeholder", "aria-label"], Xae = ["aria-label"], Jae = ["aria-selected", "data-testid", "onClick"], Zae = ["onClick"], Qae = { class: "up-pop-main" }, ele = ["title"], tle = { class: "up-pop-meta" }, nle = ["title", "aria-label", "aria-pressed", "data-testid", "onClick"], ile = {
  key: 1,
  class: "up-pop-empty"
}, sle = {
  key: 2,
  class: "up-pop-empty",
  "data-testid": "model-search-empty"
}, ole = {
  key: 1,
  class: "up-cost",
  title: "Token cost for this run",
  "data-testid": "run-cost"
}, rle = {
  key: 0,
  class: "up-foot-sep"
}, ale = ["title", "aria-disabled", "data-testid", "onClick"], lle = ["src", "onError"], dle = { class: "t" }, cle = { class: "up-pop-label" }, ule = {
  key: 0,
  class: "up-pop-slider",
  "data-testid": "chip-slider"
}, hle = ["min", "max", "step", "value", "aria-label", "onInput"], ple = ["min", "max", "step", "value", "aria-label", "onChange"], fle = ["onClick"], mle = { class: "up-pop-main" }, gle = {
  key: 1,
  class: "up-pop-meta"
}, ble = ["title", "onClick"], vle = { class: "t" }, yle = { class: "up-pop-label" }, xle = { class: "up-influence-ends" }, wle = ["value", "onInput"], kle = { class: "up-adv-hint" }, _le = ["aria-expanded"], Sle = { class: "up-run-wrap" }, Tle = ["disabled", "title"], Mle = {
  key: 2,
  class: "tip"
}, oh = 3, Cle = 70, Ile = 48, X2 = 200, J2 = 44, Ale = 12, Ple = 84, Ele = 3400, Rle = 320, zle = /* @__PURE__ */ Re({
  __name: "UnifiedPrompt",
  props: {
    tool: {}
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(""), a = I(() => t.modelFor(e.tool)), l = I(() => a.value.model), d = I(() => a.value.kit), c = I(() => l.value ? l.value.fields : []), u = I(() => c.value.find((pe) => pe.placement === "prompt" && (pe.kind === "prompt" || pe.kind === "text")) || null), p = I(() => c.value.filter((pe) => pe.placement === "reference")), f = I(() => p.value.filter(Qe)), y = I(() => f.value.length > oh ? f.value.slice(0, oh - 1) : f.value), b = I(() => f.value.length > oh ? f.value.slice(oh - 1) : []), w = I(() => b.value.filter((pe) => !!le(pe)).length), k = /* @__PURE__ */ K(!1), S = I(() => b.value.find((pe) => pe.key === s.value) || null), _ = I(() => {
      const pe = f.value[0];
      return pe ? "No prompt needed. Drop " + (pe.kind === "video" ? "a video" : "an image") + " here, or pick one from the board." : "No prompt needed for this tool.";
    }), x = I(() => c.value.filter((pe) => pe.placement === "chip" && Qe(pe))), T = I(() => t.promptOf(e.tool.id)), M = /* @__PURE__ */ K(T.value.prompt || "");
    let z = 0;
    $e(() => e.tool.id, (pe) => {
      M.value = t.promptOf(pe).prompt || "";
    }), $e(() => T.value.prompt, (pe) => {
      document.activeElement !== o.value && (M.value = pe || "");
    });
    function P(pe) {
      M.value = pe.target.value, clearTimeout(z), z = window.setTimeout($, 450);
    }
    function D(pe) {
      vn(pe) && (pe.preventDefault(), Qy());
    }
    function $() {
      clearTimeout(z), (T.value.prompt || "") !== M.value && t.setPrompt(e.tool.id, { prompt: M.value });
    }
    const O = Ty({
      board: t,
      field: "session",
      sessionId: () => e.tool.id,
      value: () => M.value,
      write: (pe) => {
        M.value = pe;
      },
      done: () => {
        $(), it(() => {
          const pe = o.value;
          pe && pe.setSelectionRange(pe.value.length, pe.value.length);
        });
      }
    }), L = I(() => O.ghost.value ? Ple : f.value.length ? Ile : Cle), Z = /* @__PURE__ */ K(0), J = /* @__PURE__ */ K(0), re = I(() => Math.max(L.value, Math.min(X2, Z.value - J.value))), F = I(() => t.ui.promptH != null ? t.ui.promptH : re.value), W = /* @__PURE__ */ K(!1), ee = () => Math.max(X2, Math.round(window.innerHeight * 0.5) - 60), N = (pe) => Math.round(Math.max(J2, Math.min(ee(), pe)));
    function te() {
      const pe = o.value;
      if (!pe) return;
      const _e = pe.style.height;
      pe.style.height = "0px", Z.value = pe.scrollHeight, pe.style.height = _e;
    }
    $e(M, () => it(te)), $e(Z, () => {
      J.value = Math.min(J.value, Math.max(0, Z.value - L.value));
    });
    let G = 0;
    const q = new ResizeObserver((pe) => {
      const _e = Math.round(pe[0].contentRect.width);
      if (_e !== G) {
        G = _e;
        const ge = Z.value;
        te(), J.value && (J.value = Math.max(0, J.value + Z.value - ge));
      }
    });
    $e(o, (pe, _e) => {
      _e && q.unobserve(_e), pe && (q.observe(pe), te());
    }), Ve(() => q.disconnect());
    function B(pe) {
      if (pe.button !== 0) return;
      pe.preventDefault();
      const _e = pe.currentTarget;
      _e.setPointerCapture(pe.pointerId);
      const ge = pe.clientY, lt = F.value;
      W.value = !0;
      const ci = (Qo) => {
        se(lt + (ge - Qo.clientY));
      }, Zn = () => {
        W.value = !1, _e.removeEventListener("pointermove", ci), _e.removeEventListener("pointerup", Zn), _e.removeEventListener("pointercancel", Zn), Y();
      };
      _e.addEventListener("pointermove", ci), _e.addEventListener("pointerup", Zn), _e.addEventListener("pointercancel", Zn);
    }
    const ne = (pe) => Math.abs(pe - L.value) <= Ale;
    function se(pe) {
      const _e = N(pe);
      t.ui.promptH = ne(_e) ? L.value : _e;
    }
    function Y() {
      t.ui.promptH == null || !ne(t.ui.promptH) || (t.ui.promptH = null, J.value = Math.max(0, Z.value - L.value));
    }
    function ie() {
      t.ui.promptH = null, J.value = 0, it(te);
    }
    function De(pe) {
      pe.key === "ArrowUp" || pe.key === "ArrowDown" ? (pe.preventDefault(), pe.stopPropagation(), se(F.value + (pe.key === "ArrowUp" ? 20 : -20)), Y()) : pe.key === "Enter" && (pe.preventDefault(), pe.stopPropagation(), ie());
    }
    Ve($);
    const xe = I(() => t.freshTools.has(e.tool.id) && !M.value);
    ot(() => {
      xe.value && it(() => o.value && o.value.focus({ preventScroll: !0 })), xe.value && t.promptLibrary.load();
    });
    const Oe = I(() => t.ui.library.open && t.ui.library.sessionId === e.tool.id);
    function Ee() {
      $(), i.value = null, t.promptLibrary.toggle(e.tool.id);
    }
    function j() {
      Oe.value && t.promptLibrary.close(), t.ui.advOpen = !t.ui.advOpen;
    }
    const V = I(() => xe.value && !!u.value && !i.value && !Oe.value && !t.ui.advOpen), Q = I(() => V.value && !t.tour ? t.promptLibrary.ghostLines(e.tool) : []), oe = /* @__PURE__ */ K(0), ue = I(() => O.ghost.value && u.value ? { id: "tour", text: O.ghost.value, tour: !0 } : Q.value.length ? { ...Q.value[oe.value % Q.value.length], tour: !1 } : null);
    EP((pe) => {
      if (Q.value.length < 2) return;
      const _e = window.setInterval(() => {
        oe.value = (oe.value + 1) % Q.value.length;
      }, Ele);
      pe(() => clearInterval(_e));
    });
    function Ie(pe) {
      !ue.value || pe.shiftKey || ue.value.tour || (pe.preventDefault(), M.value = ue.value.text, $(), it(() => {
        const _e = o.value;
        _e && _e.setSelectionRange(_e.value.length, _e.value.length);
      }));
    }
    const he = /* @__PURE__ */ K(!1);
    let ye = 0;
    $e(() => t.ui.promptLanded && t.ui.promptLanded.id === e.tool.id ? t.ui.promptLanded.seq : 0, (pe) => {
      pe && (he.value = !1, clearTimeout(ye), requestAnimationFrame(() => {
        he.value = !0, ye = window.setTimeout(() => {
          he.value = !1, t.ui.promptLanded && t.ui.promptLanded.id === e.tool.id && (t.ui.promptLanded = null);
        }, 1300);
      }));
    }, { immediate: !0 }), Ve(() => clearTimeout(ye));
    const fe = /* @__PURE__ */ K(null), ze = /* @__PURE__ */ K(0), He = new ResizeObserver((pe) => {
      ze.value = Math.round(pe[0].contentRect.height), t.ui.promptCardH = ze.value;
    });
    $e(fe, (pe, _e) => {
      _e && He.unobserve(_e), pe && He.observe(pe);
    }), Ve(() => {
      He.disconnect(), t.ui.promptCardH = 0;
    });
    function ce(pe) {
      t.setPrompt(e.tool.id, { prompt: M.value, ...pe });
    }
    function be(pe, _e) {
      ce({ inputs: { ...T.value.inputs || {}, [pe]: _e } });
    }
    const Be = I(() => {
      const pe = l.value, _e = T.value.n || (pe ? pe.numResults.def : 1) || 1;
      return pe ? Math.max(pe.numResults.min, Math.min(pe.numResults.max, _e)) : _e;
    }), Fe = I(() => l.value ? Li(l.value, { ...T.value, prompt: M.value }, Be.value, !!t.user.isAdmin) : null), Ke = I(() => {
      const pe = l.value, _e = Fe.value;
      return !!pe && !!_e && pe.fields.some((ge) => ge.placement === "advanced" && ge.kind !== "header" && Ar(_e, ge.key).shown);
    });
    $e(Ke, (pe) => {
      !pe && t.ui.advOpen && (t.ui.advOpen = !1);
    });
    function Qe(pe) {
      return !Fe.value || Ar(Fe.value, pe.key).shown;
    }
    function ht(pe) {
      return !!Fe.value && Ar(Fe.value, pe.key).locked;
    }
    function Le(pe) {
      return Fe.value ? Ar(Fe.value, pe.key).why : "";
    }
    function Ne(pe) {
      const _e = Fe.value;
      return _e && pe.key in _e.values ? _e.values[pe.key] : Pp(pe, T.value);
    }
    $e(() => Fe.value ? Fe.value.autoErrors.join(`
`) : "", (pe, _e) => {
      if (!pe) return;
      const ge = new Set((_e || "").split(`
`));
      for (const lt of pe.split(`
`)) ge.has(lt) || t.toast(lt, "error");
    });
    function le(pe) {
      if (pe === p.value[0]) return T.value.ref || null;
      const _e = T.value.inputs ? T.value.inputs[pe.key] : null;
      return typeof _e == "string" ? _e : null;
    }
    function ve(pe, _e) {
      $(), t.setRefInput(e.tool.id, pe.key, _e, _e ? t.assetFor(_e) : null);
    }
    function we(pe) {
      const _e = T.value.inputs ? T.value.inputs[pe.key] : null;
      return Array.isArray(_e) ? _e.filter((ge) => typeof ge == "string" && !!ge) : [];
    }
    function je(pe) {
      const _e = we(pe);
      if (_e.length) return _e;
      const ge = le(pe);
      return ge ? [ge] : [];
    }
    function Se(pe, _e) {
      return pe.kind === "images" ? "Image " + (_e + 1) : pe.label;
    }
    const Te = I(() => !!t.ui.eyedropper && t.ui.eyedropper.sessionId === e.tool.id);
    function ae(pe) {
      return Te.value && !!t.ui.eyedropper && t.ui.eyedropper.key === pe.key;
    }
    function Me(pe) {
      s.value = null, k.value = !1, t.armEyedropper(e.tool.id, pe.key);
    }
    function Xe(pe) {
      s.value = s.value === pe ? null : pe, s.value && (t.ui.eyedropper = null);
    }
    function Rt(pe) {
      const _e = t.ui.refPulse;
      return _e && _e.url === pe ? _e.n : 0;
    }
    function Hn(pe) {
      const _e = t.ui.refGlow;
      return _e && _e.sessionId === e.tool.id && _e.url === pe ? _e.n : 0;
    }
    function Jo(pe, _e) {
      $(), Zo.value = null, t.removeRefImage(e.tool.id, pe.key, _e);
    }
    const Zo = /* @__PURE__ */ K(null);
    function TA(pe, _e, ge) {
      const lt = fe.value;
      if (!lt) return;
      const ci = ge.currentTarget.getBoundingClientRect(), Zn = lt.getBoundingClientRect(), Qo = Rle / 2;
      Zo.value = { url: pe, label: _e, left: Math.max(Qo, Math.min(Zn.width - Qo, ci.left - Zn.left + ci.width / 2)) };
    }
    const nu = I(() => {
      const pe = Zo.value;
      return !pe || t.ui.dragging || s.value || k.value ? null : f.value.some((_e) => je(_e).includes(pe.url)) ? pe : null;
    }), iu = I(() => t.accountProblem()), MA = I(() => t.labels.team + " deactivated"), Jy = I(() => !iu.value && Fe.value && !Fe.value.problems.length ? t.tokensProblem(Fe.value.price) : ""), Nl = I(() => iu.value || Fe.value && Fe.value.problems[0] || Jy.value || null), CA = I(() => !!Jy.value && t.canGetTokens), bs = I(() => t.submitting(e.tool.id)), Zy = I(() => {
      const pe = l.value;
      return pe ? pe.raw && Fe.value && Fe.value.price != null ? hl(Fe.value.price) : w6(pe, Be.value) : "";
    }), Ul = /* @__PURE__ */ K(!1);
    let sm = 0;
    function IA() {
      Ul.value = !1, clearTimeout(sm), requestAnimationFrame(() => {
        Ul.value = !0, sm = window.setTimeout(() => Ul.value = !1, 1800);
      });
    }
    Ve(() => clearTimeout(sm));
    function Qy() {
      if ($(), !bs.value) {
        if (Nl.value) {
          IA();
          return;
        }
        t.generate(e.tool.id);
      }
    }
    function om(pe) {
      i.value = i.value === pe ? null : pe, r.value = "", i.value === "model" && (Wi.value = AA());
    }
    const Wi = /* @__PURE__ */ K(null);
    function AA() {
      const pe = d.value, _e = l.value;
      if (_e && t.isModelPinned(_e.id)) return $r;
      if (!pe || _e && !pe.models.some((ge) => ge.id === _e.id)) return el;
      if (!pe.tags || pe.tags.length < 2) return Vf;
      if (_e && _e.kitTags) {
        if (_e.kitTags.includes("Featured") && pe.tags.includes("Featured")) return "Featured";
        const ge = _e.kitTags.find((lt) => pe.tags.includes(lt));
        if (ge) return ge;
      }
      return pe.tags.includes("Featured") ? "Featured" : pe.tags[0];
    }
    function rm(pe) {
      const _e = Ne(pe), ge = _e && typeof _e == "object" ? _e.model : null;
      return ge && typeof ge == "object" ? ge : null;
    }
    function am(pe) {
      const _e = pe.kind === "model" ? rm(pe) : null;
      return _e ? t.modelPicture(_e) : null;
    }
    function PA(pe, _e) {
      const ge = am(_e), lt = pe.target;
      ge && lt.src !== ge.image && (lt.src = ge.image);
    }
    function EA(pe, _e) {
      be(pe.key, _e ? { model: _e } : null), i.value = null;
    }
    function RA(pe) {
      return !!Fe.value && Ar(Fe.value, pe.key).required;
    }
    function zA(pe) {
      if (pe.kind === "model") {
        const lt = rm(pe);
        return lt && lt.name || "Trained model";
      }
      const _e = Ne(pe), ge = (pe.options || []).find((lt) => as(lt.value, _e));
      return pe.kind === "size" && ge ? Qb(ge.value) && ge.meta || ge.label : pe.kind === "size" && _e && typeof _e == "object" ? mn(_e).replace("x", "×") : ge ? ge.label : String(_e == null ? pe.label : _e);
    }
    function $A(pe) {
      if (pe.icon) return pe.icon;
      if (pe.kind === "size") {
        const _e = Ne(pe), ge = (pe.options || []).find((lt) => as(lt.value, _e));
        return ge && ge.icon || "RectangleHorizontal";
      }
      return "Settings2";
    }
    const lm = I(() => f.value.filter((pe) => !!(pe.raw && pe.raw.display && pe.raw.display.hasStrength) && !!le(pe)));
    function ex(pe) {
      const _e = T.value.inputs ? T.value.inputs[Ip(pe.key)] : void 0;
      return typeof _e == "number" ? _e : b6;
    }
    function Gl(pe) {
      return 100 - Math.round(ex(pe) * 100);
    }
    function DA(pe, _e) {
      const ge = Math.min(0.95, Math.max(0.05, Number(_e)));
      Number.isFinite(ge) && be(Ip(pe.key), Math.round(ge * 100) / 100);
    }
    function OA(pe) {
      if (ht(pe)) {
        t.toast(Pa(Le(pe)));
        return;
      }
      om(pe.key);
    }
    function LA(pe, _e) {
      be(pe.key, _e.value), i.value = null;
    }
    function tx(pe, _e) {
      return _e.meta && (pe.kind !== "size" || Qb(_e.value)) ? _e.meta : "";
    }
    function nx(pe) {
      const _e = Wd(pe, Ne(pe));
      return _e == null ? Wd(pe, pe.min == null ? 1 : pe.min) || 0 : _e;
    }
    function ix(pe, _e) {
      const ge = Wd(pe, _e);
      ge != null && be(pe.key, ge);
    }
    const BA = I(() => sx.value.filter((pe) => t.isModelPinned(pe.id))), FA = I(() => {
      const pe = d.value;
      if (!pe || !Wi.value) return [];
      const _e = Wi.value === $r || BA.value.length > 0;
      return cae(dae(pe), _e);
    }), NA = I(() => !!r.value.trim() || Wi.value === el), UA = { image: "image", video: "video", threed: "3D", upscale: "upscale" }, su = I(() => d.value ? UA[Ya(d.value.id)] || d.value.name.toLowerCase() : ""), sx = I(() => {
      const pe = d.value, _e = t.catalog.value;
      return pe ? _e.all.filter((ge) => zp(_e, pe, ge)) : [];
    }), dm = I(() => {
      const pe = d.value;
      return pe ? t.pinnedModelsFirst(hae(pe.models, sx.value, Wi.value, r.value, (_e) => t.isModelPinned(_e))) : [];
    });
    function GA(pe) {
      t.patchTool(e.tool.id, { model: pe.name, nodeDefId: pe.id }), i.value = null;
    }
    function ox(pe) {
      const _e = pe.target;
      !_e.closest(".v2-uprompt") && !_e.closest(".lb-backdrop") && (i.value = null, s.value = null, k.value = !1);
    }
    return ot(() => window.addEventListener("pointerdown", ox, !0)), Ve(() => window.removeEventListener("pointerdown", ox, !0)), (pe, _e) => (g(), v("div", {
      class: "v2-uprompt",
      style: de({ "--up-card-h": (ze.value || 150) + "px" }),
      "data-testid": "unified-prompt",
      onPointerdown: _e[21] || (_e[21] = Pe(() => {
      }, ["stop"]))
    }, [
      n.tool.error && !bs.value ? (g(), v("div", bae, [
        C(R, {
          name: "AlertCircle",
          size: 14
        }),
        h("span", null, A(n.tool.error), 1),
        h("button", {
          "aria-label": "Dismiss",
          onClick: _e[0] || (_e[0] = (ge) => m(t).patchTool(n.tool.id, { error: null }))
        }, [
          C(R, {
            name: "X",
            size: 12
          })
        ])
      ])) : E("", !0),
      Oe.value ? (g(), Ce(vC, { key: 1 })) : E("", !0),
      m(t).ui.advOpen && !Oe.value && l.value && Fe.value && Ke.value ? (g(), Ce(ese, {
        key: 2,
        tool: n.tool,
        model: l.value,
        form: Fe.value,
        onClose: _e[1] || (_e[1] = (ge) => m(t).ui.advOpen = !1)
      }, null, 8, ["tool", "model", "form"])) : E("", !0),
      h("div", {
        ref_key: "cardEl",
        ref: fe,
        class: U(["up-card", { "has-refs": f.value.length > 0, "is-fresh": xe.value && !Ul.value, "is-nudge": Ul.value, "is-resizing": W.value, "is-landed": he.value }])
      }, [
        u.value ? (g(), v("div", {
          key: 0,
          class: U(["up-grip", { "is-on": W.value, "is-hand": m(t).ui.promptH != null }]),
          role: "separator",
          "aria-orientation": "horizontal",
          "aria-label": "Prompt height",
          "aria-valuenow": Math.round(F.value),
          "aria-valuemin": J2,
          tabindex: "0",
          title: "Drag to resize. Double-click to fit the text.",
          "data-testid": "prompt-grip",
          onPointerdown: B,
          onDblclick: ie,
          onKeydown: De
        }, [..._e[22] || (_e[22] = [
          h("i", null, null, -1)
        ])], 42, vae)) : E("", !0),
        h("div", yae, [
          u.value ? (g(), Ce(k6, {
            key: 0,
            slides: m(S6),
            media: m(_6),
            tag: "Prompt library",
            "tag-icon": "LayoutTemplate",
            cta: "Open the prompt library",
            placement: "above-start",
            disabled: Oe.value || m(t).ui.advOpen,
            testid: "library-demo",
            onOpen: Ee
          }, {
            default: et(() => [
              h("button", {
                class: U(["up-side-btn", { on: Oe.value, "has-new": !m(vc) }]),
                "aria-label": "Prompt library",
                "aria-expanded": Oe.value,
                "data-testid": "library-button",
                onClick: Ee
              }, [
                C(R, {
                  name: "LayoutTemplate",
                  size: 15
                }),
                m(vc) ? E("", !0) : (g(), v("span", wae))
              ], 10, xae)
            ]),
            _: 1
          }, 8, ["slides", "media", "disabled"])) : E("", !0),
          f.value.length ? (g(), v("button", {
            key: 1,
            class: U(["up-side-btn", { on: Te.value }]),
            title: "Pick from the board (I)",
            "aria-label": "Pick from the board",
            "aria-pressed": Te.value,
            "data-testid": "eyedropper-button",
            onClick: _e[2] || (_e[2] = (ge) => m(t).toggleEyedropper(n.tool.id))
          }, [
            C(R, {
              name: "Pipette",
              size: 15
            })
          ], 10, kae)) : E("", !0)
        ]),
        C(iae, {
          onOpen: _e[3] || (_e[3] = (ge) => m(t).openStudio({ sessionId: n.tool.id }))
        }),
        f.value.length ? (g(), v("div", _ae, [
          (g(!0), v(H, null, me(y.value, (ge) => (g(), v(H, {
            key: ge.key
          }, [
            (g(!0), v(H, null, me(je(ge), (lt, ci) => (g(), v("div", {
              key: ge.key + ":" + lt,
              class: U(["up-ref", { "is-target": m(t).ui.refTarget === ge.key, "is-dropper": ae(ge) && je(ge).length >= m(Gs)(ge) }]),
              style: de({ backgroundImage: 'url("' + m(Wt)(lt) + '")' }),
              title: Se(ge, ci),
              "data-ref-key": ge.key,
              "data-testid": "prompt-ref",
              onMouseenter: (Zn) => TA(lt, Se(ge, ci), Zn),
              onMouseleave: _e[4] || (_e[4] = (Zn) => Zo.value = null)
            }, [
              h("button", {
                title: "Remove",
                "aria-label": "Remove " + Se(ge, ci).toLowerCase(),
                onClick: (Zn) => Jo(ge, lt)
              }, [
                C(R, {
                  name: "X",
                  size: 11
                })
              ], 8, Tae),
              f.value.length > 1 && ci === 0 ? (g(), v("span", Mae, A(ge.label), 1)) : E("", !0),
              Rt(lt) ? (g(), v("span", {
                key: "pulse" + Rt(lt),
                class: "up-ref-pulse",
                "aria-hidden": "true"
              })) : E("", !0),
              Hn(lt) ? (g(), v("span", {
                key: "glow" + Hn(lt),
                class: "up-ref-glow",
                "aria-hidden": "true",
                "data-testid": "prompt-ref-glow"
              })) : E("", !0)
            ], 46, Sae))), 128)),
            je(ge).length < m(Gs)(ge) ? (g(), v("div", Cae, [
              h("button", {
                class: U(["up-drop", { "is-target": m(t).ui.refTarget === ge.key, "is-dropper": ae(ge) }]),
                title: (je(ge).length ? "Add another image" : "Add " + ge.label.toLowerCase()) + ". Or Shift-drag one here from the board.",
                "aria-label": je(ge).length ? "Add another image" : "Add " + ge.label.toLowerCase(),
                "data-ref-key": ge.key,
                onClick: (lt) => Xe(ge.key)
              }, [
                C(R, {
                  name: ge.kind === "video" ? "Video" : "ImagePlus",
                  size: 18
                }, null, 8, ["name"])
              ], 10, Iae),
              s.value === ge.key ? (g(), Ce(sf, {
                key: 0,
                "session-id": n.tool.id,
                label: ge.label,
                kind: ge.kind === "video" ? "video" : "image",
                onPick: (lt) => {
                  ve(ge, lt), s.value = null;
                },
                onDropper: (lt) => Me(ge),
                onClose: _e[5] || (_e[5] = (lt) => s.value = null)
              }, null, 8, ["session-id", "label", "kind", "onPick", "onDropper"])) : E("", !0)
            ])) : E("", !0)
          ], 64))), 128)),
          b.value.length ? (g(), v("div", Aae, [
            h("button", {
              class: U(["up-drop up-more", { on: k.value, "has-some": w.value > 0 }]),
              title: b.value.length + " more image inputs",
              "aria-label": b.value.length + " more image inputs",
              "aria-expanded": k.value,
              "data-testid": "more-refs",
              onClick: _e[6] || (_e[6] = (ge) => {
                k.value = !k.value, s.value = null;
              })
            }, [
              h("span", Eae, "+" + A(b.value.length), 1),
              h("span", Rae, A(w.value ? w.value + " set" : "inputs"), 1)
            ], 10, Pae),
            k.value ? (g(), v("div", {
              key: 0,
              class: "up-pop up-refmore",
              onPointerdown: _e[7] || (_e[7] = Pe(() => {
              }, ["stop"]))
            }, [
              _e[23] || (_e[23] = h("div", { class: "up-pop-label" }, "More inputs", -1)),
              h("div", zae, [
                (g(!0), v(H, null, me(b.value, (ge) => (g(), v("div", {
                  key: ge.key,
                  class: "up-morecell"
                }, [
                  le(ge) ? (g(), v("div", {
                    key: 0,
                    class: U(["up-ref is-sm", { "is-target": m(t).ui.refTarget === ge.key }]),
                    style: de({ backgroundImage: 'url("' + m(Wt)(le(ge) || "") + '")' }),
                    title: ge.label,
                    "data-ref-key": ge.key
                  }, [
                    h("button", {
                      title: "Remove",
                      onClick: (lt) => ve(ge, null)
                    }, [
                      C(R, {
                        name: "X",
                        size: 10
                      })
                    ], 8, Dae),
                    Hn(le(ge) || "") ? (g(), v("span", {
                      key: "glow" + Hn(le(ge) || ""),
                      class: "up-ref-glow",
                      "aria-hidden": "true"
                    })) : E("", !0)
                  ], 14, $ae)) : (g(), v("button", {
                    key: 1,
                    class: U(["up-drop is-sm", { "is-target": m(t).ui.refTarget === ge.key }]),
                    title: "Add " + ge.label.toLowerCase(),
                    "aria-label": "Add " + ge.label.toLowerCase(),
                    "data-ref-key": ge.key,
                    onClick: (lt) => {
                      k.value = !1, Xe(ge.key);
                    }
                  }, [
                    C(R, {
                      name: ge.kind === "video" ? "Video" : "ImagePlus",
                      size: 15
                    }, null, 8, ["name"])
                  ], 10, Oae)),
                  h("span", {
                    class: "lbl",
                    title: ge.label
                  }, A(ge.label), 9, Lae)
                ]))), 128))
              ])
            ], 32)) : E("", !0),
            S.value ? (g(), Ce(sf, {
              key: 1,
              "session-id": n.tool.id,
              label: S.value.label,
              kind: S.value.kind === "video" ? "video" : "image",
              onPick: _e[8] || (_e[8] = (ge) => {
                ve(S.value, ge), s.value = null, k.value = !0;
              }),
              onDropper: _e[9] || (_e[9] = (ge) => Me(S.value)),
              onClose: _e[10] || (_e[10] = (ge) => s.value = null)
            }, null, 8, ["session-id", "label", "kind"])) : E("", !0)
          ])) : E("", !0)
        ])) : E("", !0),
        u.value ? (g(), v("textarea", {
          key: 2,
          ref_key: "textEl",
          ref: o,
          class: U(["up-text", { "is-typing": m(O).typing.value }]),
          style: de({ height: F.value + "px" }),
          value: M.value,
          spellcheck: "false",
          placeholder: ue.value ? "" : u.value.placeholder || "Describe what " + n.tool.name + " should make",
          readonly: m(O).held.value || m(O).typing.value,
          "data-testid": "prompt-text",
          onInput: P,
          onBlur: $,
          onKeydown: [
            tn(D, ["enter"]),
            tn(Ie, ["tab"])
          ]
        }, null, 46, Bae)) : (g(), v("div", {
          key: 3,
          class: U(["up-text up-text-static", { "is-target": !!f.value.length && m(t).ui.refTarget === f.value[0].key }]),
          "data-ref-key": f.value.length ? f.value[0].key : void 0
        }, A(_.value), 11, Fae)),
        C(vt, {
          name: "up-ghost",
          mode: "out-in"
        }, {
          default: et(() => [
            ue.value ? (g(), v("span", {
              key: ue.value.id,
              class: U(["up-ghost", { "is-tour": ue.value.tour }]),
              "aria-hidden": "true",
              "data-testid": "ghost-line"
            }, A(ue.value.text), 3)) : E("", !0)
          ]),
          _: 1
        }),
        ue.value && ue.value.tour ? (g(), v("button", {
          key: 4,
          type: "button",
          tabindex: "-1",
          class: "up-cue is-tour",
          "data-testid": "ghost-cue",
          onClick: _e[11] || (_e[11] = (ge) => m(t).tour && m(t).tour.press && m(t).tour.press("session"))
        }, [..._e[24] || (_e[24] = [
          h("kbd", null, "Tab", -1),
          X(" to write it in", -1)
        ])])) : ue.value ? (g(), v("span", Nae, [..._e[25] || (_e[25] = [
          h("kbd", null, "Tab", -1),
          X(" to use this prompt", -1),
          h("span", { class: "src" }, "Featured", -1)
        ])])) : E("", !0),
        nu.value ? (g(), v("div", {
          key: 6,
          class: "up-ref-peek",
          style: de({ left: nu.value.left + "px" }),
          "aria-hidden": "true",
          "data-testid": "prompt-ref-peek"
        }, [
          h("img", {
            src: m(Wt)(nu.value.url),
            alt: "",
            draggable: "false"
          }, null, 8, Uae),
          h("span", Gae, A(nu.value.label), 1)
        ], 4)) : E("", !0),
        h("div", jae, [
          h("div", Hae, [
            h("span", Vae, [
              h("button", {
                class: U(["up-model", { on: i.value === "model" }]),
                "data-testid": "model-picker",
                onClick: _e[12] || (_e[12] = (ge) => om("model"))
              }, [
                _e[26] || (_e[26] = h("span", { class: "lb" }, "Model", -1)),
                xt((g(), v("span", Wae, [
                  X(A(l.value ? l.value.name : n.tool.model), 1)
                ])), [
                  [m(Va), l.value ? l.value.name : n.tool.model]
                ]),
                C(R, {
                  name: "ChevronDown",
                  size: 12
                })
              ], 2),
              i.value === "model" && d.value ? (g(), v("div", {
                key: 0,
                class: "up-pop is-wide",
                onPointerdown: _e[15] || (_e[15] = Pe(() => {
                }, ["stop"]))
              }, [
                h("div", qae, A(NA.value ? "All " + su.value + " models" : d.value.name + " models"), 1),
                h("div", Kae, [
                  C(R, {
                    name: "Search",
                    size: 12
                  }),
                  xt(h("input", {
                    "onUpdate:modelValue": _e[13] || (_e[13] = (ge) => r.value = ge),
                    placeholder: "Search all " + su.value + " models",
                    "aria-label": "Search all " + su.value + " models",
                    "data-testid": "model-search",
                    onKeydown: _e[14] || (_e[14] = Pe(() => {
                    }, ["stop"]))
                  }, null, 40, Yae), [
                    [Jt, r.value]
                  ])
                ]),
                Wi.value && !r.value.trim() ? (g(), v("div", {
                  key: 0,
                  class: "up-pop-tabs",
                  role: "tablist",
                  "aria-label": d.value.name + " model groups"
                }, [
                  (g(!0), v(H, null, me(FA.value, (ge) => (g(), v("button", {
                    key: ge,
                    role: "tab",
                    "aria-selected": Wi.value === ge,
                    class: U({ on: Wi.value === ge }),
                    "data-testid": ge === m($r) ? "model-tab-pinned" : ge === m(el) ? "model-tab-all" : void 0,
                    onClick: (lt) => Wi.value = ge
                  }, A(m(uae)(ge, d.value.name)), 11, Jae))), 128))
                ], 8, Xae)) : E("", !0),
                (g(!0), v(H, null, me(dm.value, (ge) => (g(), v("div", {
                  key: ge.id,
                  class: U(["up-pop-item", { "is-pinned": m(t).isModelPinned(ge.id) }])
                }, [
                  h("button", {
                    class: U(["up-pop-row", { on: l.value && ge.id === l.value.id }]),
                    onClick: (lt) => GA(ge)
                  }, [
                    ge.avatar ? (g(), v("span", {
                      key: 0,
                      class: "up-pop-avatar",
                      style: de({ backgroundImage: 'url("' + ge.avatar + '")' })
                    }, null, 4)) : E("", !0),
                    xt((g(), v("span", Qae, [
                      X(A(ge.name) + " ", 1),
                      (g(!0), v(H, null, me(ge.labels || [], (lt) => (g(), v("span", {
                        key: lt.label,
                        class: U(["up-pop-badge", { "is-popular": lt.type === "POPULAR" }]),
                        title: lt.tooltip
                      }, A(lt.label), 11, ele))), 128))
                    ])), [
                      [m(Va), ge.name]
                    ]),
                    h("span", tle, [
                      X(A(ge.tokensLabel) + " tk", 1),
                      ge.time ? (g(), v(H, { key: 0 }, [
                        X(" · " + A(ge.time), 1)
                      ], 64)) : E("", !0)
                    ])
                  ], 10, Zae),
                  h("button", {
                    class: U(["up-pop-pin", { on: m(t).isModelPinned(ge.id) }]),
                    title: m(t).isModelPinned(ge.id) ? "Unpin" : "Pin to the top",
                    "aria-label": (m(t).isModelPinned(ge.id) ? "Unpin " : "Pin ") + ge.name,
                    "aria-pressed": m(t).isModelPinned(ge.id),
                    "data-testid": "model-pin-" + ge.id,
                    onClick: Pe((lt) => m(t).toggleModelPinned(ge.id), ["stop"])
                  }, [
                    C(R, {
                      name: "Pin",
                      size: 12
                    })
                  ], 10, nle)
                ], 2))), 128)),
                Wi.value === m($r) && !r.value.trim() && !dm.value.length ? (g(), v("div", ile, "Nothing pinned yet. Pin a model to keep it at the top.")) : E("", !0),
                r.value.trim() && !dm.value.length ? (g(), v("div", sle, "No " + A(su.value) + " model matches “" + A(r.value.trim()) + "”.", 1)) : E("", !0)
              ], 32)) : E("", !0),
              Zy.value ? (g(), v("span", ole, [
                C(R, {
                  name: "Tokens",
                  size: 12
                }),
                X(A(Zy.value), 1)
              ])) : E("", !0)
            ]),
            x.value.length || lm.value.length || Ke.value ? (g(), v("span", rle)) : E("", !0),
            (g(!0), v(H, null, me(x.value, (ge) => {
              var lt, ci, Zn, Qo;
              return g(), v("span", {
                key: ge.key,
                class: "up-chip-wrap"
              }, [
                h("button", {
                  class: U(["up-chip", { on: i.value === ge.key, "is-locked": ht(ge) }]),
                  title: ht(ge) ? ge.label + ": " + Le(ge) : ge.label,
                  "aria-disabled": ht(ge) || void 0,
                  "data-testid": "chip-" + ge.key,
                  onClick: (Cn) => OA(ge)
                }, [
                  am(ge) ? (g(), v("img", {
                    key: 0,
                    class: "av",
                    src: am(ge).thumb,
                    alt: "",
                    draggable: "false",
                    onError: (Cn) => PA(Cn, ge)
                  }, null, 40, lle)) : (g(), Ce(R, {
                    key: 1,
                    name: $A(ge),
                    size: 13
                  }, null, 8, ["name"])),
                  h("span", dle, A(zA(ge)), 1),
                  ht(ge) ? (g(), Ce(R, {
                    key: 2,
                    class: "lk",
                    name: "Lock",
                    size: 10
                  })) : E("", !0)
                ], 10, ale),
                i.value === ge.key && ge.kind === "model" ? (g(), Ce(Vre, {
                  key: 0,
                  field: ge,
                  "selected-id": (rm(ge) || {}).id || null,
                  required: RA(ge),
                  onPick: (Cn) => EA(ge, Cn)
                }, null, 8, ["field", "selected-id", "required", "onPick"])) : i.value === ge.key ? (g(), v("div", {
                  key: 1,
                  class: "up-pop",
                  onPointerdown: _e[17] || (_e[17] = Pe(() => {
                  }, ["stop"]))
                }, [
                  h("div", cle, A(ge.label), 1),
                  ge.kind === "slider" ? (g(), v("div", ule, [
                    h("input", {
                      class: "up-range",
                      type: "range",
                      min: (lt = ge.min) != null ? lt : 1,
                      max: (ci = ge.max) != null ? ci : 30,
                      step: ge.step || 1,
                      value: nx(ge),
                      "aria-label": ge.label,
                      onInput: (Cn) => ix(ge, Cn.target.value)
                    }, null, 40, hle),
                    h("input", {
                      class: "up-adv-num",
                      type: "number",
                      min: (Zn = ge.min) != null ? Zn : 1,
                      max: (Qo = ge.max) != null ? Qo : 30,
                      step: ge.step || 1,
                      value: nx(ge),
                      "aria-label": ge.label,
                      "data-testid": "chip-slider-num",
                      onChange: (Cn) => ix(ge, Cn.target.value),
                      onKeydown: _e[16] || (_e[16] = Pe(() => {
                      }, ["stop"]))
                    }, null, 40, ple)
                  ])) : (g(!0), v(H, { key: 1 }, me(ge.options || [], (Cn) => (g(), v("button", {
                    key: m(mn)(Cn.value),
                    class: U(["up-pop-row", { on: m(as)(Cn.value, Ne(ge)) }]),
                    onClick: (ZPe) => LA(ge, Cn)
                  }, [
                    Cn.icon ? (g(), Ce(R, {
                      key: 0,
                      name: Cn.icon,
                      size: 13
                    }, null, 8, ["name"])) : E("", !0),
                    h("span", mle, A(Cn.label), 1),
                    tx(ge, Cn) ? (g(), v("span", gle, A(tx(ge, Cn)), 1)) : E("", !0)
                  ], 10, fle))), 128))
                ], 32)) : E("", !0)
              ]);
            }), 128)),
            (g(!0), v(H, null, me(lm.value, (ge) => (g(), v("span", {
              key: "influence:" + ge.key,
              class: "up-chip-wrap"
            }, [
              h("button", {
                class: U(["up-chip", { on: i.value === "influence:" + ge.key }]),
                title: "Influence of " + ge.label.toLowerCase() + " against the prompt",
                "data-testid": "influence-chip",
                onClick: (lt) => om("influence:" + ge.key)
              }, [
                C(R, {
                  name: ge.kind === "video" ? "Video" : "Image",
                  size: 13
                }, null, 8, ["name"]),
                h("span", vle, A(ge.kind === "video" ? "Video" : "Image") + " " + A(Gl(ge)) + "%", 1)
              ], 10, ble),
              i.value === "influence:" + ge.key ? (g(), v("div", {
                key: 0,
                class: "up-pop up-influence",
                "data-testid": "influence-pop",
                onPointerdown: _e[18] || (_e[18] = Pe(() => {
                }, ["stop"]))
              }, [
                h("div", yle, "Influence" + A(lm.value.length > 1 ? ": " + ge.label : ""), 1),
                h("div", xle, [
                  h("span", {
                    style: de({ fontSize: 11 + Gl(ge) / 25 + "px" })
                  }, [
                    C(R, {
                      name: ge.kind === "video" ? "Video" : "Image",
                      size: 12
                    }, null, 8, ["name"]),
                    X(A(Gl(ge)) + "%", 1)
                  ], 4),
                  h("span", {
                    style: de({ fontSize: 11 + (100 - Gl(ge)) / 25 + "px" })
                  }, [
                    X(A(100 - Gl(ge)) + "%", 1),
                    C(R, {
                      name: "Type",
                      size: 12
                    })
                  ], 4)
                ]),
                h("input", {
                  class: "up-range",
                  type: "range",
                  min: "0.05",
                  max: "0.95",
                  step: "0.01",
                  value: ex(ge),
                  "aria-label": "Influence",
                  "data-testid": "influence-range",
                  onInput: (lt) => DA(ge, lt.target.value)
                }, null, 40, wle),
                h("div", kle, "How much your " + A(ge.kind === "video" ? "video" : "image") + " shapes the result, against your prompt.", 1)
              ], 32)) : E("", !0)
            ]))), 128)),
            Ke.value ? (g(), v("button", {
              key: 1,
              class: U(["up-cog", { on: m(t).ui.advOpen && !Oe.value }]),
              title: "Advanced settings",
              "aria-label": "Advanced settings",
              "aria-expanded": m(t).ui.advOpen && !Oe.value,
              "data-testid": "advanced-button",
              onClick: j
            }, [
              C(R, {
                name: "Settings",
                size: 15
              })
            ], 10, _le)) : E("", !0)
          ]),
          l.value && l.value.numResults.max > 1 ? (g(), Ce(Sy, {
            key: 0,
            value: Be.value,
            min: l.value.numResults.min,
            max: l.value.numResults.max,
            testid: "run-count",
            onUpdate: _e[19] || (_e[19] = (ge) => ce({ n: ge }))
          }, null, 8, ["value", "min", "max"])) : E("", !0),
          h("span", Sle, [
            CA.value && !bs.value ? (g(), v("button", {
              key: 0,
              class: "up-run is-get",
              "data-testid": "get-tokens",
              onClick: _e[20] || (_e[20] = (ge) => m(t).getTokens())
            }, [
              C(R, {
                name: "Tokens",
                size: 13
              }),
              _e[27] || (_e[27] = X("Get tokens ", -1))
            ])) : (g(), v("button", {
              key: 1,
              class: U(["up-run", { "is-busy": bs.value }]),
              disabled: bs.value || !!Nl.value,
              title: Nl.value || bs.value ? void 0 : "Run (" + m(Tn)(["mod", "enter"]) + ")",
              "data-testid": "run",
              onClick: Qy
            }, [
              bs.value ? (g(), Ce(R, {
                key: 0,
                name: "Loader2",
                size: 14,
                spin: ""
              })) : iu.value ? (g(), Ce(R, {
                key: 1,
                name: "Lock",
                size: 13
              })) : E("", !0),
              X(" " + A(bs.value ? "Running" : iu.value ? MA.value : "Run"), 1)
            ], 10, Tle)),
            Nl.value && !bs.value ? (g(), v("span", Mle, A(Nl.value), 1)) : E("", !0)
          ])
        ])
      ], 2)
    ], 36));
  }
}), Pc = "Arial, Helvetica, sans-serif", Ec = 1.22, $le = 20;
let rh;
function Dle() {
  if (rh === void 0) {
    const n = typeof navigator != "undefined" && /jsdom/i.test(navigator.userAgent);
    try {
      rh = typeof document != "undefined" && !n ? document.createElement("canvas").getContext("2d") : null;
    } catch {
      rh = null;
    }
  }
  return rh;
}
function rp(n, e) {
  const t = Dle();
  return t ? (t.font = "100px " + Pc, t.measureText(n).width * e / 100) : n.length * e * 0.55;
}
function Ole(n, e, t) {
  const i = [];
  for (const s of (n || "").split(`
`)) {
    const o = s.split(/(\s+)/);
    let r = "";
    for (const a of o) {
      if (!a) continue;
      const l = r + a;
      for (rp(l.replace(/\s+$/, ""), e) <= t || !r.trim() ? r = l : (i.push(r.replace(/\s+$/, "")), r = /^\s+$/.test(a) ? "" : a); rp(r, e) > t && r.length > 1; ) {
        let d = r.length - 1;
        for (; d > 1 && rp(r.slice(0, d), e) > t; ) d--;
        i.push(r.slice(0, d)), r = r.slice(d);
      }
    }
    i.push(r.replace(/\s+$/, ""));
  }
  return i.length ? i : [""];
}
function Lle(n, e, t) {
  const i = Ole(n, e, t), s = Math.max(e * 0.6, ...i.map((o) => rp(o, e)));
  return { lines: i, width: Math.min(s, t), height: i.length * e * Ec };
}
function Dr(n) {
  return Math.max(n.w, n.h);
}
function Rc(n, e) {
  return { x: n.x * e.w, y: n.y * e.h };
}
function vo(n, e) {
  return { x: n.x / e.w, y: n.y / e.h };
}
function Qc(n, e) {
  const t = n.size * Dr(e), i = Rc(n.pts[0], e), s = Lle(n.text || "", t, Math.max(t, e.w - i.x));
  return { lines: s.lines, font: t, box: { x: i.x, y: i.y, w: s.width, h: s.height } };
}
function rc(n, e) {
  if (n.kind === "text") return Qc(n, e).box;
  let t = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0;
  for (const r of n.pts) {
    const a = Rc(r, e);
    t = Math.min(t, a.x), i = Math.min(i, a.y), s = Math.max(s, a.x), o = Math.max(o, a.y);
  }
  return { x: t, y: i, w: s - t, h: o - i };
}
function Or(n, e) {
  const t = rc(n, e);
  return { x: t.x + t.w / 2, y: t.y + t.h / 2 };
}
function wo(n, e, t) {
  const i = Math.cos(t), s = Math.sin(t), o = n.x - e.x, r = n.y - e.y;
  return { x: e.x + o * i - r * s, y: e.y + o * s + r * i };
}
function tl(n, e, t) {
  return e.rot ? wo(n, Or(e, t), -e.rot) : n;
}
function dd(n, e, t) {
  const i = t.x - e.x, s = t.y - e.y, o = i * i + s * s || 1, r = Math.max(0, Math.min(1, ((n.x - e.x) * i + (n.y - e.y) * s) / o));
  return Math.hypot(n.x - (e.x + r * i), n.y - (e.y + r * s));
}
function t0(n, e, t) {
  if (n.kind === "text") {
    const l = Qc(n, t).box, d = Math.max(l.x - e.x, 0, e.x - (l.x + l.w)), c = Math.max(l.y - e.y, 0, e.y - (l.y + l.h));
    return Math.hypot(d, c);
  }
  const i = n.pts.map((l) => Rc(l, t));
  if (n.kind === "brush" || n.kind === "arrow") {
    if (i.length === 1) return Math.hypot(e.x - i[0].x, e.y - i[0].y);
    let l = 1 / 0;
    for (let d = 1; d < i.length; d++) l = Math.min(l, dd(e, i[d - 1], i[d]));
    return l;
  }
  const s = rc(n, t);
  if (n.kind === "box") {
    const l = [{ x: s.x, y: s.y }, { x: s.x + s.w, y: s.y }, { x: s.x + s.w, y: s.y + s.h }, { x: s.x, y: s.y + s.h }];
    return Math.min(dd(e, l[0], l[1]), dd(e, l[1], l[2]), dd(e, l[2], l[3]), dd(e, l[3], l[0]));
  }
  const o = s.x + s.w / 2, r = s.y + s.h / 2;
  let a = 1 / 0;
  for (let l = 0; l < 64; l++) {
    const d = l / 64 * Math.PI * 2;
    a = Math.min(a, Math.hypot(e.x - (o + s.w / 2 * Math.cos(d)), e.y - (r + s.h / 2 * Math.sin(d))));
  }
  return a;
}
function Ble(n, e, t, i = 6) {
  const s = tl(e, n, t);
  return n.kind === "text" ? t0(n, s, t) <= i : t0(n, s, t) <= Math.max(i, n.size * Dr(t) / 2 + 4);
}
function xC(n, e, t) {
  const i = (s) => ({ x: s.x + e, y: s.y + t });
  return { ...n, pts: n.pts.map(i), erase: n.erase ? n.erase.map((s) => ({ ...s, pts: s.pts.map(i) })) : void 0 };
}
function Fle(n, e, t, i, s) {
  const o = Or(n, s), r = n.rot ? wo(e, o, -n.rot) : e, a = (p) => {
    const f = Rc(p, s);
    return vo({ x: r.x + (f.x - r.x) * t, y: r.y + (f.y - r.y) * i }, s);
  };
  let l;
  if (n.kind === "text") {
    const p = Math.max(0.05, i), f = Rc(n.pts[0], s);
    l = { ...n, size: n.size * p, pts: [vo({ x: r.x + (f.x - r.x) * p, y: r.y + (f.y - r.y) * p }, s)] };
  } else
    l = { ...n, pts: n.pts.map(a), erase: n.erase ? n.erase.map((p) => ({ ...p, pts: p.pts.map(a) })) : void 0 };
  if (!n.rot) return l;
  const d = Or(l, s), c = wo(r, o, n.rot), u = wo(r, d, n.rot);
  return xC(l, (c.x - u.x) / s.w, (c.y - u.y) / s.h);
}
function Nle(n, e, t, i, s) {
  if (n.kind === "text") return !1;
  const o = tl(e, n, s), r = tl(t, n, s), a = i / 2 + n.size * Dr(s) / 2 + 1, l = Math.max(1, Math.ceil(Math.hypot(r.x - o.x, r.y - o.y) / 3));
  for (let d = 0; d <= l; d++) {
    const c = d / l;
    if (t0(n, { x: o.x + (r.x - o.x) * c, y: o.y + (r.y - o.y) * c }, s) <= a) return !0;
  }
  return !1;
}
function Ule(n, e) {
  return n.x < e.x + e.w && n.x + n.w > e.x && n.y < e.y + e.h && n.y + n.h > e.y;
}
const Ng = 1e3, wC = 0.1;
function n0(n) {
  return n.kind === "text" || n.opacity == null ? 1 : Math.max(wC, Math.min(1, n.opacity));
}
function kC(n, e) {
  const t = Math.round(Ng * (e || 3) / (n || 4));
  return { w: Ng, h: t, long: Math.max(Ng, t) };
}
function ni(n, e) {
  return n * e.w;
}
function ii(n, e) {
  return n * e.h;
}
function of(n, e) {
  if (!n.length) return "";
  if (n.length < 3) return "M" + ni(n[0].x, e) + " " + ii(n[0].y, e) + n.slice(1).map((s) => " L" + ni(s.x, e) + " " + ii(s.y, e)).join("") + (n.length === 1 ? " l0.1 0" : "");
  let t = "M" + ni(n[0].x, e) + " " + ii(n[0].y, e);
  for (let s = 1; s < n.length - 1; s++) {
    const o = (ni(n[s].x, e) + ni(n[s + 1].x, e)) / 2, r = (ii(n[s].y, e) + ii(n[s + 1].y, e)) / 2;
    t += " Q" + ni(n[s].x, e) + " " + ii(n[s].y, e) + " " + o + " " + r;
  }
  const i = n[n.length - 1];
  return t + " L" + ni(i.x, e) + " " + ii(i.y, e);
}
function My(n, e) {
  return Math.max(1.5, n.size * e.long);
}
function _C(n, e) {
  return Math.max(1.5, n * e.long);
}
function i0(n, e) {
  const t = n.pts[0], i = n.pts[n.pts.length - 1], s = ni(t.x, e), o = ii(t.y, e), r = ni(i.x, e), a = ii(i.y, e), l = Math.atan2(a - o, r - s), d = Math.max(0.012 * e.long, My(n, e) * 3.5), c = r - Math.cos(l) * d, u = a - Math.sin(l) * d, p = -Math.sin(l) * (d / 2), f = Math.cos(l) * (d / 2), y = r - Math.cos(l) * (d / 2), b = a - Math.sin(l) * (d / 2);
  return { line: "M" + s + " " + o + " L" + y + " " + b, head: r + "," + a + " " + (c + p) + "," + (u + f) + " " + (c - p) + "," + (u - f) };
}
function Es(n, e) {
  const t = n.pts[0], i = n.pts[n.pts.length - 1];
  return { x: ni(Math.min(t.x, i.x), e), y: ii(Math.min(t.y, i.y), e), width: Math.abs(ni(i.x, e) - ni(t.x, e)), height: Math.abs(ii(i.y, e) - ii(t.y, e)) };
}
function SC(n, e) {
  if (!n.rot) return;
  const t = n.kind === "text" ? Qc(n, e).box : null;
  let i, s;
  if (t)
    i = t.x + t.w / 2, s = t.y + t.h / 2;
  else {
    const o = n.pts.map((a) => ni(a.x, e)), r = n.pts.map((a) => ii(a.y, e));
    i = (Math.min(...o) + Math.max(...o)) / 2, s = (Math.min(...r) + Math.max(...r)) / 2;
  }
  return "rotate(" + n.rot * 180 / Math.PI + " " + i + " " + s + ")";
}
function Sr(n, e) {
  const t = Qc(n, e);
  return { x: t.box.x, y: t.box.y, font: t.font, lines: t.lines };
}
function TC(n, e) {
  return n ? e * Ec : e * (Ec - 1) / 2;
}
function MC(n, e = !1) {
  return (e ? 0.022 : 0.026) * n.long;
}
function Dd(n, e) {
  return { cx: ni(n.x, e), cy: ii(n.y, e) };
}
const Gle = "#7c4dff", jle = "#ffffff";
function ya(n) {
  return n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function nn(n) {
  return String(Math.round(n * 100) / 100);
}
function Hle(n, e, t, i, s) {
  const o = kC(e, t), r = [], a = [];
  n.strokes.forEach((d, c) => {
    const u = "e" + c, p = !!(d.erase && d.erase.length);
    if (p) {
      const S = d.erase.map((_) => '<path d="' + of(_.pts, o) + '" fill="none" stroke="#000" stroke-width="' + nn(_C(_.size, o)) + '" stroke-linecap="round" stroke-linejoin="round"/>').join("");
      a.push('<mask id="' + u + '" maskUnits="userSpaceOnUse" x="' + -o.w + '" y="' + -o.h + '" width="' + o.w * 3 + '" height="' + o.h * 3 + '"><rect x="' + -o.w + '" y="' + -o.h + '" width="' + o.w * 3 + '" height="' + o.h * 3 + '" fill="#fff"/>' + S + "</mask>");
    }
    const f = SC(d, o);
    let y = "";
    if (d.kind === "text") {
      const S = Sr(d, o), _ = S.lines.map((x, T) => '<tspan x="' + nn(S.x) + '" dy="' + nn(TC(T, S.font)) + '">' + ya(x || " ") + "</tspan>").join("");
      y = '<text x="' + nn(S.x) + '" y="' + nn(S.y) + '" font-size="' + nn(S.font) + '" fill="' + ya(d.color) + '" font-family="' + ya(Pc) + '" dominant-baseline="text-before-edge">' + _ + "</text>";
    } else {
      const S = 'fill="none" stroke="' + ya(d.color) + '" stroke-width="' + nn(My(d, o)) + '" stroke-linecap="round" stroke-linejoin="round"';
      if (d.kind === "brush") y = '<path d="' + of(d.pts, o) + '" ' + S + "/>";
      else if (d.kind === "arrow") {
        const _ = i0(d, o);
        y = '<path d="' + _.line + '" ' + S + '/><polygon points="' + _.head + '" fill="' + ya(d.color) + '"/>';
      } else if (d.kind === "box") {
        const _ = Es(d, o);
        y = '<rect x="' + nn(_.x) + '" y="' + nn(_.y) + '" width="' + nn(_.width) + '" height="' + nn(_.height) + '" ' + S + "/>";
      } else if (d.kind === "ellipse") {
        const _ = Es(d, o);
        y = '<ellipse cx="' + nn(_.x + _.width / 2) + '" cy="' + nn(_.y + _.height / 2) + '" rx="' + nn(_.width / 2) + '" ry="' + nn(_.height / 2) + '" ' + S + "/>";
      }
    }
    const b = p ? '<g mask="url(#' + u + ')">' + y + "</g>" : y, w = n0(d), k = w < 1 ? '<g opacity="' + nn(w) + '">' + b + "</g>" : b;
    r.push(f ? '<g transform="' + f + '">' + k + "</g>" : k);
  });
  const l = MC(o);
  return n.pins.forEach((d, c) => {
    const u = Dd(d, o);
    r.push('<circle cx="' + nn(u.cx) + '" cy="' + nn(u.cy) + '" r="' + nn(l) + '" fill="' + Gle + '" stroke="#fff" stroke-width="2.5"/><text x="' + nn(u.cx) + '" y="' + nn(u.cy) + '" font-size="' + nn(l * 1.05) + '" fill="' + jle + '" font-family="' + ya(Pc) + '" font-weight="700" text-anchor="middle" dominant-baseline="central">' + (c + 1) + "</text>");
  }), '<svg xmlns="http://www.w3.org/2000/svg" width="' + i + '" height="' + s + '" viewBox="0 0 ' + o.w + " " + o.h + '" preserveAspectRatio="none">' + (a.length ? "<defs>" + a.join("") + "</defs>" : "") + r.join("") + "</svg>";
}
const Vle = ["viewBox", "preserveAspectRatio"], Wle = ["id", "x", "y", "width", "height"], qle = ["x", "y", "width", "height"], Kle = ["d", "stroke-width"], Yle = ["data-stroke", "transform", "opacity"], Xle = ["mask"], Jle = ["x", "y", "font-size", "fill", "font-family"], Zle = ["x", "dy"], Qle = ["stroke", "stroke-width"], ede = ["d"], tde = ["d"], nde = ["points", "fill"], ide = ["cx", "cy", "rx", "ry"], sde = ["cx", "cy", "r"], ode = ["x", "y", "font-size"], CC = /* @__PURE__ */ Re({
  __name: "MarksSvg",
  props: {
    marks: {},
    w: {},
    h: {},
    live: { default: null },
    small: { type: Boolean, default: !1 },
    hide: { default: () => [] },
    fit: { default: "slice" }
  },
  setup(n) {
    const e = n, t = LP(), i = I(() => kC(e.w, e.h)), s = I(() => {
      const r = e.live ? [...e.marks.strokes, e.live] : e.marks.strokes;
      return e.hide.length ? r.filter((a) => !e.hide.includes(a.id)) : r;
    }), o = I(() => MC(i.value, e.small));
    return (r, a) => (g(), v("svg", {
      class: "sv-marks",
      viewBox: "0 0 " + i.value.w + " " + i.value.h,
      preserveAspectRatio: n.fit === "slice" ? "xMidYMid slice" : "none",
      "aria-hidden": "true"
    }, [
      h("defs", null, [
        (g(!0), v(H, null, me(s.value.filter((l) => l.erase && l.erase.length), (l) => (g(), v("mask", {
          id: m(t) + "-" + l.id,
          key: l.id,
          maskUnits: "userSpaceOnUse",
          x: -i.value.w,
          y: -i.value.h,
          width: i.value.w * 3,
          height: i.value.h * 3
        }, [
          h("rect", {
            x: -i.value.w,
            y: -i.value.h,
            width: i.value.w * 3,
            height: i.value.h * 3,
            fill: "#fff"
          }, null, 8, qle),
          (g(!0), v(H, null, me(l.erase, (d, c) => (g(), v("path", {
            key: c,
            d: m(of)(d.pts, i.value),
            fill: "none",
            stroke: "#000",
            "stroke-width": m(_C)(d.size, i.value),
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Kle))), 128))
        ], 8, Wle))), 128))
      ]),
      (g(!0), v(H, null, me(s.value, (l) => (g(), v("g", {
        key: l.id,
        "data-stroke": l.id,
        class: "sv-stroke",
        transform: m(SC)(l, i.value),
        opacity: m(n0)(l) < 1 ? m(n0)(l) : void 0
      }, [
        h("g", {
          mask: l.erase && l.erase.length ? "url(#" + m(t) + "-" + l.id + ")" : void 0
        }, [
          l.kind === "text" ? (g(), v("text", {
            key: 0,
            x: m(Sr)(l, i.value).x,
            y: m(Sr)(l, i.value).y,
            "font-size": m(Sr)(l, i.value).font,
            fill: l.color,
            "font-family": m(Pc),
            "dominant-baseline": "text-before-edge"
          }, [
            (g(!0), v(H, null, me(m(Sr)(l, i.value).lines, (d, c) => (g(), v("tspan", {
              key: c,
              x: m(Sr)(l, i.value).x,
              dy: m(TC)(c, m(Sr)(l, i.value).font)
            }, A(d || " "), 9, Zle))), 128))
          ], 8, Jle)) : (g(), v("g", {
            key: 1,
            fill: "none",
            stroke: l.color,
            "stroke-width": m(My)(l, i.value),
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            l.kind === "brush" ? (g(), v("path", {
              key: 0,
              d: m(of)(l.pts, i.value)
            }, null, 8, ede)) : l.kind === "arrow" ? (g(), v(H, { key: 1 }, [
              h("path", {
                d: m(i0)(l, i.value).line
              }, null, 8, tde),
              h("polygon", {
                points: m(i0)(l, i.value).head,
                fill: l.color,
                stroke: "none"
              }, null, 8, nde)
            ], 64)) : l.kind === "box" ? (g(), v("rect", a3({
              key: 2,
              ref_for: !0
            }, m(Es)(l, i.value)), null, 16)) : l.kind === "ellipse" ? (g(), v("ellipse", {
              key: 3,
              cx: m(Es)(l, i.value).x + m(Es)(l, i.value).width / 2,
              cy: m(Es)(l, i.value).y + m(Es)(l, i.value).height / 2,
              rx: m(Es)(l, i.value).width / 2,
              ry: m(Es)(l, i.value).height / 2
            }, null, 8, ide)) : E("", !0)
          ], 8, Qle))
        ], 8, Xle)
      ], 8, Yle))), 128)),
      (g(!0), v(H, null, me(n.marks.pins, (l, d) => (g(), v("g", {
        key: l.id,
        class: "sv-pin-mark"
      }, [
        h("circle", {
          cx: m(Dd)(l, i.value).cx,
          cy: m(Dd)(l, i.value).cy,
          r: o.value
        }, null, 8, sde),
        n.small ? E("", !0) : (g(), v("text", {
          key: 0,
          x: m(Dd)(l, i.value).cx,
          y: m(Dd)(l, i.value).cy,
          "font-size": o.value * 1.05,
          "text-anchor": "middle",
          "dominant-baseline": "central"
        }, A(d + 1), 9, ode))
      ]))), 128))
    ], 8, Vle));
  }
});
function IC(n, e) {
  const t = /* @__PURE__ */ new Set([e]);
  let i = e;
  for (; ; ) {
    const s = n(i);
    if (!s || t.has(s)) return i;
    t.add(s), i = s;
  }
}
function rde(n, e, t) {
  if (!t) return [];
  const i = /* @__PURE__ */ new Map(), s = (r) => {
    let a = i.get(r);
    return a === void 0 && (a = IC(e, r), i.set(r, a)), a;
  }, o = s(t);
  return n.filter((r) => s(r.id) === o).sort((r, a) => a.createdAt - r.createdAt);
}
function ade(n, e) {
  const t = /* @__PURE__ */ new Map(), i = n.filter((s) => s.id !== e).sort((s, o) => s.createdAt - o.createdAt);
  return e && n.some((s) => s.id === e) && t.set(e, "Original"), i.forEach((s, o) => t.set(s.id, "v" + (o + 1))), t;
}
function ah(n, e, t) {
  return n.includes(e) ? { queue: n, full: !1 } : n.length >= t ? { queue: n, full: !0 } : { queue: [...n, e], full: !1 };
}
function Z2(n, e) {
  return n.filter((t) => t !== e);
}
function lh(n, e, t) {
  const i = n.filter((s) => s !== e);
  return i.length ? { queue: [e, ...i.slice(1)].slice(0, Math.max(1, t)), full: !1 } : { queue: [e], full: !1 };
}
function lde(n, e) {
  return Math.min(n.length, Math.max(0, e));
}
function dde() {
  const n = [];
  n.push({ x: 0, z: 0, y: 0, w: 64, d: 44, h: 9, rot: 0 }), n.push({ x: 0, z: 0, y: 9, w: 58, d: 38, h: 3, rot: 0 });
  for (let e = 0; e < 15; e++) n.push({ x: -13, z: -2, y: 12 + e * 5.2, w: 17, d: 17, h: 5.2, rot: e * 0.045 });
  for (let e = 0; e < 12; e++) n.push({ x: 14, z: 5, y: 12 + e * 5.2, w: 15, d: 15, h: 5.2, rot: -e * 0.06 });
  return n.push({ x: 0.5, z: 1.5, y: 58, w: 12, d: 5, h: 3.6, rot: 0.12 }), n.push({ x: -52, z: -40, y: 0, w: 26, d: 22, h: 16, rot: 0 }), n.push({ x: 50, z: -38, y: 0, w: 24, d: 26, h: 22, rot: 0 }), n.push({ x: -50, z: 42, y: 0, w: 22, d: 18, h: 11, rot: 0 }), n.push({ x: 54, z: 40, y: 0, w: 20, d: 20, h: 28, rot: 0 }), n.push({ x: 0, z: 0, y: -0.4, w: 180, d: 150, h: 0.4, rot: 0 }), n;
}
function xa(n) {
  return String(Math.round(n * 1e3) / 1e3);
}
function AC() {
  const n = ["# Bonneville Tower massing (sample)", "o massing"];
  let e = 1, t = 1;
  for (const i of dde()) {
    const s = Math.cos(i.rot), o = Math.sin(i.rot), r = (c, u, p) => {
      const f = c * i.w / 2, y = p * i.d / 2;
      return [i.x + f * s - y * o, u, i.z + f * o + y * s];
    }, a = i.y, l = i.y + i.h, d = [
      { pts: [r(-1, l, -1), r(-1, l, 1), r(1, l, 1), r(1, l, -1)], nrm: [0, 1, 0] },
      { pts: [r(-1, a, -1), r(1, a, -1), r(1, a, 1), r(-1, a, 1)], nrm: [0, -1, 0] },
      { pts: [r(-1, a, -1), r(-1, l, -1), r(1, l, -1), r(1, a, -1)], nrm: [o, 0, -s] },
      { pts: [r(1, a, -1), r(1, l, -1), r(1, l, 1), r(1, a, 1)], nrm: [s, 0, o] },
      { pts: [r(1, a, 1), r(1, l, 1), r(-1, l, 1), r(-1, a, 1)], nrm: [-o, 0, s] },
      { pts: [r(-1, a, 1), r(-1, l, 1), r(-1, l, -1), r(-1, a, -1)], nrm: [-s, 0, -o] }
    ];
    for (const c of d) {
      for (const u of c.pts) n.push("v " + xa(u[0]) + " " + xa(u[1]) + " " + xa(u[2]));
      n.push("vn " + xa(c.nrm[0]) + " " + xa(c.nrm[1]) + " " + xa(c.nrm[2])), n.push("f " + [0, 1, 2, 3].map((u) => e + u + "//" + t).join(" ")), e += 4, t += 1;
    }
  }
  return n.join(`
`) + `
`;
}
const cde = 800;
function PC(n, e, t = cde) {
  const i = Math.min(1, t / Math.max(n || 1, e || 1));
  return { w: Math.max(1, Math.round((n || 1) * i)), h: Math.max(1, Math.round((e || 1) * i)) };
}
function EC(n, e) {
  return new Promise((t, i) => {
    const s = new Image();
    e && (s.crossOrigin = "anonymous"), s.onload = () => t(s), s.onerror = () => i(new Error("The picture couldn't be read.")), s.src = n;
  });
}
function ude(n) {
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(n);
}
async function RC(n, e, t, i, s, o) {
  const r = await EC(ude(Hle(e, t, i, s, o)), !1);
  n.drawImage(r, 0, 0, s, o);
}
async function hde(n, e, t) {
  const i = PC(e, t), s = document.createElement("canvas");
  s.width = i.w, s.height = i.h;
  const o = s.getContext("2d");
  if (!o) throw new Error("The annotations couldn't be drawn.");
  return await RC(o, n, e, t, i.w, i.h), s.toDataURL("image/png").split(",")[1] || "";
}
async function pde(n, e, t, i, s = 640) {
  const o = PC(t, i, s), r = document.createElement("canvas");
  r.width = o.w, r.height = o.h;
  const a = r.getContext("2d");
  if (!a) throw new Error("The annotations couldn't be drawn.");
  try {
    const l = await EC(n, !n.startsWith("data:") && !n.startsWith("blob:"));
    a.drawImage(l, 0, 0, o.w, o.h);
  } catch {
    a.fillStyle = "#808080", a.fillRect(0, 0, o.w, o.h);
  }
  return await RC(a, e, t, i, o.w, o.h), r.toDataURL("image/jpeg", 0.85);
}
const Q2 = { prompt: "generate", threed: "generate", edit: "edit" };
function Ug(n) {
  return n !== "prompt" && n !== "threed";
}
const nl = {
  threed: { text: "3D view", icon: "Box" },
  upload: { text: "Brought in", icon: "Upload" },
  board: { text: "From the board", icon: "LayoutGrid" },
  library: { text: "From your Library", icon: "Library" },
  tool: { text: "Made here", icon: "Wand2" }
};
function cd() {
  return { strokes: [], pins: [] };
}
function Od(n) {
  return !!n && (n.strokes.length > 0 || n.pins.length > 0);
}
function zC(n) {
  return !!n && !!n.area && n.area.some((e) => !e.cut);
}
function Gg(n) {
  return Od(n) || zC(n);
}
function fde(n) {
  return n.kind === "object" ? { ...n } : { ...n, pts: n.pts.slice() };
}
function ud(n) {
  const e = {
    strokes: n.strokes.map((t) => ({ ...t, pts: t.pts.slice(), erase: t.erase ? t.erase.map((i) => ({ ...i, pts: i.pts.slice() })) : void 0 })),
    pins: n.pins.map((t) => ({ ...t }))
  };
  return n.area && n.area.length && (e.area = n.area.map(fde)), e;
}
function mde(n, e) {
  return JSON.stringify(n) === JSON.stringify(e);
}
const $C = [
  { id: "upscale", label: "Upscale", icon: "Maximize2", hint: "More pixels and detail, for print and large screens" },
  { id: "resize", label: "Resize", icon: "Crop", hint: "Crop to a shape, or expand past the edges" },
  { id: "background", label: "Background", icon: "Layers", hint: "Remove it, replace it, or adjust it apart from the subject" },
  { id: "adjust", label: "Adjust", icon: "SlidersHorizontal", hint: "Light, colour, grading, grain and rotation, live" },
  { id: "skin", label: "Improve people", icon: "Smile", hint: "Natural skin, light and detail on the people" },
  { id: "camera", label: "Change camera", icon: "Rotate3d", hint: "See the scene from another angle" },
  { id: "relight", label: "Relight", icon: "Lightbulb", hint: "New light: direction, colour and mood" }
];
function Cy(n) {
  return n && $C.find((e) => e.id === n) || null;
}
const jg = {
  edit: "Edit",
  erase: "Erase",
  upscale: "Upscale",
  removebg: "Remove background",
  replacebg: "Replace background",
  expand: "Expand",
  skin: "Improve people",
  camera: "Change camera",
  relight: "Relight",
  select: "Find objects",
  draw: "Draw edit",
  comment: "Annotate edit",
  threed: "3D edit"
}, e_ = {
  removebg: ["w4WjiaPJ8YlnXqalLseS"],
  erase: ["n830hmDOmMafIztf5qZs"],
  upscale: ["n5NO4aX5MGjmfEVg0KdE", "ykyBMjS0ISJeWy9jOqhm", "QCpMJ7Dw9Wa1956Sh6Hw", "QejUMwHU49HRMWwpqhkD", "n4H8sQlLxTc1aeYJxdiv"]
}, gde = {
  removebg: /^remove background$/i,
  erase: /person and object remover|eraser|^erase$/i,
  expand: /^expand$/i,
  camera: /^change camera|multiple angles/i,
  select: /^find objects|select objects/i
}, DC = /^nano banana pro\b/i, bde = [
  "4CJEOIwhf2WhGq2K0eHl",
  // Nano Banana 2.1
  "6BJyvazKHGTilS1yWk76",
  // Nano Banana 2
  "VpkLvmqERLkoU2vBNTJ7",
  // Nano Banana 2 Lite
  "eILT27MJkTwxnVSPQP2x",
  // Nano Banana Pro
  "s9ShIto8LPgdOSImFC39",
  // ChatGPT Image 2.5 Sunburst
  "50XKlkMz7r9kmipyspRQ",
  // ChatGPT Image 2.5 Flare
  "YuklxMGHwrC50w7yjLBm",
  // ChatGPT Image 2.0 (Krea's ChatGPT 2)
  "B9nbLi2HgM7XHeaBoOJD",
  // Seedream V5 Pro
  "zzhnCi7Bow9ekkRXy5pP",
  // Luma UNI-1
  "gYjYjnyvD6hFxcdl1mul",
  // Luma UNI-1 Max
  "UNuq3Ia9Wlos2DWSFrlv",
  // Flux 2 Klein 4B
  "9rnhLVpVce28QPnjYiQ3",
  // ChatGPT Image Edit 1.5 (Krea's ChatGPT 1.5)
  "JcDKjRIyFolGJVEOIgya",
  // Flux 3 Image
  "7XrsYAALFZVLveefN5DL",
  // Flux 2 Pro
  "BfRqukmRHNORna2upyyt",
  // Flux 2 Flex
  "vMzpgBA14pAFuBgU8yby",
  // Flux 2 Max
  "2oYW3kqy1XetTh4PURbF",
  // Qwen Edit 2511 (Krea's Qwen Image Plus)
  "2aIZvnBeZYdY4ldYEdGO",
  // Nano Banana Edit (Krea's Nano Banana)
  "CzrPq1r9zRrEb8hsES2e",
  // Qwen Image Edit
  "bKkjGeP6wjLsl1314ybn",
  // Flux Kontext Pro
  "Wee8kviizptLQp8DkEKn"
  // Flux Kontext Max
];
function kl(n) {
  return !!OC(n);
}
function OC(n) {
  return Ys(n).find((e) => !!(e.raw && e.raw.display && e.raw.display.hasInpainting)) || null;
}
function vde(n) {
  const e = /* @__PURE__ */ new Set(), t = [];
  for (const i of [...n.tools || [], ...n.kits.flatMap((s) => s.models)])
    e.has(i.id) || (e.add(i.id), t.push(i));
  return t;
}
function t_(n) {
  return Ys(n).length > 0 && !n.fields.some((e) => e.kind === "video" && e.placement === "reference");
}
function yde(n, e, t) {
  const i = bde.map((s) => e.find((o) => o.id === s)).filter((s) => !!s && Xp(s) && !kl(s));
  return i.length ? i : rC(n, "edit", t).filter((s) => !kl(s));
}
function xde(n, e, t) {
  if (e === "prompt" || e === "threed") return rC(n, e, t);
  const i = vde(n), s = i.filter((d) => d.boardTool === e);
  if (e === "edit" || e === "replacebg" || e === "skin" || e === "relight") {
    const d = yde(n, i, t), c = d.find((p) => DC.test(p.name)), u = c ? [c, ...d.filter((p) => p !== c)] : d;
    return e === "relight" ? u.slice(0, 1) : u;
  }
  if (e === "upscale") {
    const d = n.kits.find((f) => f.id === "upscale"), c = (d ? d.models : []).filter((f) => t_(f) && Xp(f)), u = (e_.upscale || []).map((f) => i.find((y) => y.id === f)).filter((f) => !!f && t_(f)), p = [];
    for (const f of [...s, ...u, ...c]) p.some((y) => y.id === f.id) || p.push(f);
    return p;
  }
  const o = e_[e] || [], r = gde[e], a = [], l = [...s, ...o.map((d) => i.find((c) => c.id === d)).filter((d) => !!d), ...r ? i.filter((d) => r.test(d.name)) : []];
  for (const d of l)
    !a.some((c) => c.id === d.id) && Xp(d) && a.push(d);
  return e === "erase" ? a.filter(kl).concat(a.filter((d) => !kl(d))) : a;
}
function wde(n, e, t) {
  return n.fields.find((i) => i.raw && i.raw.boardKey === e) || n.fields.find((i) => i.key === e) || t && n.fields.find((i) => t.test(i.label)) || null;
}
function n_(n, e, t = {}) {
  const i = {};
  for (const [s, o] of Object.entries(e)) {
    if (o === void 0) continue;
    const r = wde(n, s, t[s]);
    r && (i[r.key] = o);
  }
  return i;
}
function kde(n, e) {
  const t = [], i = n.trim();
  return e.erase ? t.push(i ? "Remove what is marked in magenta from image 1, and put this in its place, matching the surroundings: " + i : "Remove what is marked in magenta from image 1, and fill the space with what would naturally be behind it, matching the surroundings.") : i && t.push(i), e.guide ? t.push(e.erase ? "Image 2 is image 1 with the area to remove marked in magenta; it is a guide only." : "Image 1 is the image to edit. Image 2 is the same image with the area to change marked in magenta: make the change only inside that area of image 1, and keep the rest of image 1 as it is. Image 2 is a guide only: the result is image 1, with no magenta marking.") : t.push("The area to change is marked in magenta (a tinted wash with an outline): make the change only there, keep the rest of the image as it is, and remove the magenta marking from the result."), t.join(`
`);
}
function _de(n, e) {
  return e <= 1 ? "Image " + n + " is a reference." : "Images " + n + (e === 2 ? " and " : " to ") + (n + e - 1) + " are references.";
}
function Sde(n, e) {
  const t = n.trim().replace(/\.$/, "");
  return "Replace the background of image 1 with " + (e ? "the background in image 2" + (t ? " (" + t + ")" : "") : t || "a clean, natural background that suits the subject") + ". Keep the subject exactly as it is: its shape, edges, colours and the light on it, and its place and size in the frame. Match the new background's perspective and horizon to the camera, and its light to the light on the subject, with natural contact shadows.";
}
const Hg = [
  { id: "faithful", label: "Faithful", hint: "Keeps every feature; refines only the skin" },
  { id: "flexible", label: "Flexible", hint: "A balance of fidelity and polish" },
  { id: "creative", label: "Creative", hint: "Polishes freely; people stay recognisable" }
], Tde = [
  { id: "skin", label: "Natural skin" },
  { id: "everything", label: "Skin, eyes, hair and clothes" },
  { id: "light", label: "Better light on faces" },
  { id: "real", label: "Make them look real" },
  { id: "nomakeup", label: "No makeup" }
];
function Mde() {
  return { version: "faithful", focus: "skin", sharpen: 30, grain: 0 };
}
function Cde(n) {
  const e = ["Retouch the people in image 1 as a high-end photo retoucher would."];
  e.push(n.version === "faithful" ? "Keep each person's identity, features, expression, hair and makeup exactly as they are; refine only the skin." : n.version === "creative" ? "Improve them freely, as a beauty retoucher would, while keeping each person recognisable." : "Keep each person's identity and expression, and polish the skin and details with a light hand.");
  const t = {
    skin: "Give the skin natural texture and pores, even out blotches and blemishes, and remove any plastic, airbrushed look.",
    everything: "Give the skin natural texture and pores, and refine the eyes, hair, teeth and the detail in clothing.",
    light: "Improve the light on the faces: soft, flattering and natural, with gentle shadows.",
    real: "Make the people look like a real photograph of real people: real skin texture, natural imperfections and realistic hair, nothing rendered or doll-like.",
    nomakeup: "Remove all makeup, leaving natural bare skin."
  };
  return e.push(t[n.focus]), n.sharpen >= 60 ? e.push("Render fine detail crisply.") : n.sharpen >= 25 && e.push("Keep detail sharp."), n.grain >= 50 ? e.push("Add visible fine film grain.") : n.grain >= 15 && e.push("Add a subtle, natural photographic grain."), e.push("Keep everything else in the picture as it is: the background, the composition, the colours and the camera angle."), e.join(" ");
}
const Ide = 8192, wa = /* @__PURE__ */ new Map();
function Ade(n) {
  return n.startsWith("blob:") || n.startsWith("data:") ? n : n + (n.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1";
}
function oi(n) {
  let e = wa.get(n);
  if (!e && (e = (async () => {
    const t = await fetch(Ade(n), { mode: "cors", credentials: "omit" });
    if (!t.ok) throw new Error("The picture couldn't be read (" + t.status + ").");
    return createImageBitmap(await t.blob());
  })(), wa.set(n, e), e.catch(() => wa.delete(n)), wa.size > 12)) {
    const t = wa.keys().next().value;
    t !== void 0 && t !== n && wa.delete(t);
  }
  return e;
}
function $n(n, e) {
  const t = document.createElement("canvas");
  return t.width = Math.max(1, Math.round(n)), t.height = Math.max(1, Math.round(e)), t;
}
function Dn(n) {
  const e = n.getContext("2d", { willReadFrequently: !1 });
  if (!e) throw new Error("The browser couldn't draw the picture.");
  return e;
}
function Vg(n, e = !1) {
  return new Promise((t, i) => {
    n.toBlob((s) => s ? t(s) : i(new Error("The picture couldn't be saved.")), e ? "image/png" : "image/jpeg", 0.94);
  });
}
function Wg(n, e) {
  const t = n.type === "image/png" ? "png" : "jpg";
  return new File([n], e.replace(/[^a-z0-9-]+/gi, "-").toLowerCase() + "." + t, { type: n.type });
}
function il(n, e, t = Ide) {
  const i = Math.min(1, t / Math.max(n, e));
  return { w: Math.max(1, Math.round(n * i)), h: Math.max(1, Math.round(e * i)) };
}
function Pde(n, e, t) {
  const i = e.x * n.width, s = e.y * n.height, o = e.w * n.width, r = e.h * n.height, a = il(o, r), l = $n(a.w, a.h), d = Dn(l);
  return d.imageSmoothingQuality = "high", d.drawImage(n, i, s, o, r, 0, 0, a.w, a.h), l;
}
function LC(n) {
  const e = Math.min(1, 256 / Math.max(n.width, n.height)), t = $n(n.width * e, n.height * e), i = Dn(t);
  i.drawImage(n, 0, 0, t.width, t.height);
  const s = i.getImageData(0, 0, t.width, t.height).data;
  for (let o = 3; o < s.length; o += 4) if (s[o] < 250) return !0;
  return !1;
}
function Ede(n, e = 256) {
  const t = Math.min(1, e / Math.max(n.width, n.height)), i = $n(n.width * t, n.height * t), s = Dn(i);
  return s.drawImage(n, 0, 0, i.width, i.height), s.getImageData(0, 0, i.width, i.height).data;
}
function BC(n, e) {
  const t = $n(n.width, n.height), i = Dn(t);
  return e && (i.fillStyle = e, i.fillRect(0, 0, t.width, t.height)), i.drawImage(n, 0, 0), t;
}
function dh() {
  return { target: "background", blur: 0, grayscale: 0, sepia: 0, brightness: 100, contrast: 100, saturation: 100 };
}
function zc(n) {
  return n.blur > 0 || n.grayscale > 0 || n.sepia > 0 || n.brightness !== 100 || n.contrast !== 100 || n.saturation !== 100;
}
function i_(n, e = 1) {
  const t = [];
  return n.blur > 0 && t.push("blur(" + (n.blur * e).toFixed(2) + "px)"), n.grayscale > 0 && t.push("grayscale(" + n.grayscale + "%)"), n.sepia > 0 && t.push("sepia(" + n.sepia + "%)"), n.brightness !== 100 && t.push("brightness(" + n.brightness + "%)"), n.contrast !== 100 && t.push("contrast(" + n.contrast + "%)"), n.saturation !== 100 && t.push("saturate(" + n.saturation + "%)"), t.join(" ") || "none";
}
function FC(n, e, t, i = n.width, s = n.height) {
  const o = i / n.width, r = $n(i, s), a = Dn(r), l = $n(i, s), d = Dn(l);
  return d.drawImage(n, 0, 0, i, s), d.globalCompositeOperation = "destination-in", d.drawImage(e, 0, 0, i, s), t.target === "background" ? (a.filter = i_(t, o), a.drawImage(n, 0, 0, i, s), a.filter = "none", a.drawImage(l, 0, 0)) : (a.drawImage(n, 0, 0, i, s), a.filter = i_(t, o), a.drawImage(l, 0, 0), a.filter = "none"), r;
}
function Rde(n, e, t, i) {
  const s = n.width, o = n.height, r = $n(s, o), a = Dn(r);
  a.drawImage(n, 0, 0);
  const l = $n(s, o), d = Dn(l);
  return d.imageSmoothingQuality = "high", d.drawImage(e, 0, 0, s, o), d.globalCompositeOperation = "destination-in", d.filter = i > 0 ? "blur(" + i.toFixed(1) + "px)" : "none", d.drawImage(t, 0, 0, s, o), d.filter = "none", a.drawImage(l, 0, 0), r;
}
function qg(n, e, t) {
  const i = Math.min(1, e / Math.max(n.width, n.height));
  if (i >= 1) return n.toDataURL(t ? "image/png" : "image/jpeg", 0.9);
  const s = $n(n.width * i, n.height * i), o = Dn(s);
  return o.imageSmoothingQuality = "high", o.drawImage(n, 0, 0, s.width, s.height), s.toDataURL(t ? "image/png" : "image/jpeg", 0.9);
}
const Kg = /* @__PURE__ */ new Map();
function zde(n, e, t, i = "") {
  const s = new Uint16Array(e * t), o = /* @__PURE__ */ new Map();
  let r = 0;
  for (let a = 0, l = 0; a < s.length; a++, l += 4) {
    const d = n[l + 3] >= 128;
    d && n[l + 2] > 0 && r++;
    const c = !d || n[l + 2] > 0 ? 0 : n[l] + n[l + 1] * 256;
    s[a] = c, c && o.set(c, (o.get(c) || 0) + 1);
  }
  return { url: i, w: e, h: t, ids: s, count: o.size, sizes: o, stray: r, masks: /* @__PURE__ */ new Map() };
}
const $de = 2048;
function Dde(n) {
  return n.count > 0 && n.count <= $de && n.stray <= n.w * n.h * 0.01;
}
function rf(n) {
  let e = Kg.get(n);
  return e || (e = oi(n).then((t) => {
    const i = $n(t.width, t.height), s = i.getContext("2d", { willReadFrequently: !0 });
    s.imageSmoothingEnabled = !1, s.drawImage(t, 0, 0);
    const o = zde(s.getImageData(0, 0, i.width, i.height).data, i.width, i.height, n);
    if (!Dde(o)) throw new Error(`not a map of objects (${o.count} objects, ${o.stray} stray pixels)`);
    return o;
  }), Kg.set(n, e), e.catch(() => Kg.delete(n))), e;
}
function s_(n, e, t) {
  const i = Math.min(n.w - 1, Math.max(0, Math.floor(e * n.w))), s = Math.min(n.h - 1, Math.max(0, Math.floor(t * n.h)));
  return n.ids[s * n.w + i] || 0;
}
function NC(n, e) {
  const t = n.masks.get(e);
  if (t) return t;
  const i = $n(n.w, n.h), s = Dn(i), o = s.createImageData(n.w, n.h), r = o.data;
  for (let a = 0, l = 0; a < n.ids.length; a++, l += 4)
    n.ids[a] === e && (r[l] = 255, r[l + 1] = 255, r[l + 2] = 255, r[l + 3] = 255);
  return s.putImageData(o, 0, 0), n.masks.set(e, i), i;
}
function o_(n) {
  return !!n && n.some((e) => !e.cut);
}
function UC(n) {
  return Array.from(new Set(n.filter((e) => e.kind === "object").map((e) => e.map)));
}
function r_(n, e, t, i) {
  n.beginPath(), e.forEach((s, o) => o ? n.lineTo(s.x * t, s.y * i) : n.moveTo(s.x * t, s.y * i));
}
function Ode(n, e, t, i, s) {
  const o = Math.max(t, i);
  n.save(), n.lineCap = "round", n.lineJoin = "round";
  for (const r of e)
    if (n.globalCompositeOperation = r.cut ? "destination-out" : "source-over", n.fillStyle = "#fff", n.strokeStyle = "#fff", r.kind === "brush") {
      const a = Math.max(1, r.size * o);
      if (r.pts.length === 1) {
        n.beginPath(), n.arc(r.pts[0].x * t, r.pts[0].y * i, a / 2, 0, Math.PI * 2), n.fill();
        continue;
      }
      n.lineWidth = a, r_(n, r.pts, t, i), n.stroke();
    } else if (r.kind === "lasso") {
      if (r.pts.length < 3) continue;
      r_(n, r.pts, t, i), n.closePath(), n.fill();
    } else {
      const a = s.get(r.map);
      if (!a) continue;
      n.imageSmoothingEnabled = !0, n.drawImage(NC(a, r.segment), 0, 0, t, i);
    }
  n.restore();
}
function ap(n, e, t, i) {
  const s = $n(e, t);
  return Ode(Dn(s), n, e, t, i), s;
}
const a_ = "#ff2bd6";
function Lde(n, e) {
  const t = n.width, i = n.height, s = $n(t, i), o = Dn(s);
  o.drawImage(n, 0, 0, t, i);
  const r = $n(t, i), a = Dn(r);
  a.drawImage(e, 0, 0, t, i), a.globalCompositeOperation = "source-in", a.fillStyle = a_, a.fillRect(0, 0, t, i), o.globalAlpha = 0.38, o.drawImage(r, 0, 0), o.globalAlpha = 1;
  const l = $n(t, i), d = Dn(l), c = Math.max(2, Math.round(Math.max(t, i) / 300));
  return d.filter = "blur(" + c + "px)", d.drawImage(e, 0, 0, t, i), d.filter = "none", d.globalCompositeOperation = "destination-out", d.drawImage(e, 0, 0, t, i), d.globalCompositeOperation = "source-in", d.fillStyle = a_, d.fillRect(0, 0, t, i), o.drawImage(l, 0, 0), s;
}
const s0 = [
  { id: "free", label: "Free", r: null },
  { id: "original", label: "Original", r: NaN },
  { id: "1:1", label: "1:1", r: 1 },
  { id: "4:5", label: "4:5", r: 4 / 5 },
  { id: "3:4", label: "3:4", r: 3 / 4 },
  { id: "2:3", label: "2:3", r: 2 / 3 },
  { id: "9:16", label: "9:16", r: 9 / 16 },
  { id: "16:9", label: "16:9", r: 16 / 9 },
  { id: "3:2", label: "3:2", r: 3 / 2 },
  { id: "4:3", label: "4:3", r: 4 / 3 },
  { id: "21:9", label: "21:9", r: 21 / 9 },
  { id: "5:4", label: "5:4", r: 5 / 4, more: !0 },
  { id: "2:1", label: "2:1", r: 2, more: !0 },
  { id: "3:1", label: "3:1", r: 3, more: !0 },
  { id: "1:2", label: "1:2", r: 1 / 2, more: !0 },
  { id: "1:3", label: "1:3", r: 1 / 3, more: !0 }
];
function af(n, e, t) {
  const i = s0.find((s) => s.id === n);
  return !i || i.r === null ? null : Number.isNaN(i.r) ? e / t : i.r;
}
const ch = { x: 0, y: 0, w: 1, h: 1 };
function ri(n, e, t) {
  return Math.min(t, Math.max(e, n));
}
function Bde(n, e, t, i = { x: 0.5, y: 0.5 }) {
  const s = e / t, o = n >= s ? 1 : n / s, r = n >= s ? s / n : 1;
  return { x: ri(i.x - o / 2, 0, 1 - o), y: ri(i.y - r / 2, 0, 1 - r), w: o, h: r };
}
function o0(n, e, t) {
  return { w: Math.max(1, Math.round(n.w * e)), h: Math.max(1, Math.round(n.h * t)) };
}
function GC(n, e = 0.02) {
  const t = ri(n.w, e, 1), i = ri(n.h, e, 1);
  return { x: ri(n.x, 0, 1 - t), y: ri(n.y, 0, 1 - i), w: t, h: i };
}
function Fde(n, e, t) {
  return { ...n, x: ri(n.x + e, 0, 1 - n.w), y: ri(n.y + t, 0, 1 - n.h) };
}
function Nde(n, e, t, i, s, o, r, a = 24) {
  const l = a / s, d = a / o;
  let c = n.x, u = n.y, p = n.x + n.w, f = n.y + n.h;
  if (e.includes("w") && (c = ri(c + t, 0, p - l)), e.includes("e") && (p = ri(p + t, c + l, 1)), e.includes("n") && (u = ri(u + i, 0, f - d)), e.includes("s") && (f = ri(f + i, u + d, 1)), r == null) return { x: c, y: u, w: p - c, h: f - u };
  const y = s / (r * o), b = e.length === 2;
  let w = p - c, k = f - u;
  b ? Math.abs(t) * s >= Math.abs(i) * o ? k = w * y : w = k / y : e === "e" || e === "w" ? k = w * y : w = k / y;
  const S = e.includes("w") ? n.x + n.w : e.includes("e") ? 1 - n.x : Math.min(n.x + n.w / 2, 1 - n.x - n.w / 2) * 2, _ = e.includes("n") ? n.y + n.h : e.includes("s") ? 1 - n.y : Math.min(n.y + n.h / 2, 1 - n.y - n.h / 2) * 2;
  w > S && (w = S, k = w * y), k > _ && (k = _, w = k / y), w = Math.max(w, l), k = Math.max(k, d);
  const x = n.x + n.w / 2, T = n.y + n.h / 2, M = e.includes("w") ? n.x + n.w - w : e.includes("e") ? n.x : x - w / 2, z = e.includes("n") ? n.y + n.h - k : e.includes("s") ? n.y : T - k / 2;
  return GC({ x: M, y: z, w, h: k }, 0);
}
function l_(n, e, t, i, s) {
  const o = ri(e / i, 5e-3, 1), r = ri(t / s, 5e-3, 1), a = n.x + n.w / 2, l = n.y + n.h / 2;
  return GC({ x: a - o / 2, y: l - r / 2, w: o, h: r }, 0);
}
function d_(n) {
  return n.x <= 5e-4 && n.y <= 5e-4 && n.w >= 0.999 && n.h >= 0.999;
}
function Ude(n, e) {
  return n !== "free" && n !== "original" ? "Crop " + n : "Crop " + e.w + " × " + e.h;
}
const Gde = 5e3 * 5e3, jde = 0.15;
function jC(n, e) {
  return { cw: n, ch: e, ix: 0, iy: 0, iw: n, ih: e };
}
function c_(n, e, t, i = 1) {
  let s = e * i, o = t * i;
  return s / o < n ? s = o * n : o = s / n, s = Math.round(s), o = Math.round(o), { cw: s, ch: o, ix: Math.round((s - e) / 2), iy: Math.round((o - t) / 2), iw: e, ih: t };
}
function Hde(n) {
  return n.iw * n.ih / Math.max(1, n.cw * n.ch);
}
function r0(n) {
  return n.ix > 0.5 || n.iy > 0.5 || n.ix + n.iw < n.cw - 0.5 || n.iy + n.ih < n.ch - 0.5;
}
function Vde(n) {
  const e = Math.min(1, Math.sqrt(Gde / Math.max(1, n.cw * n.ch)) * 0.999);
  return {
    canvas_size: [Math.round(n.cw * e), Math.round(n.ch * e)],
    original_image_size: [Math.max(1, Math.round(n.iw * e)), Math.max(1, Math.round(n.ih * e))],
    original_image_location: [Math.round(n.ix * e), Math.round(n.iy * e)]
  };
}
function Wde(n, e, t, i = 64) {
  const s = { ...n };
  if (e === "e" && (s.cw = Math.max(i, n.cw + t)), e === "s" && (s.ch = Math.max(i, n.ch + t)), e === "w") {
    const o = Math.max(i, n.cw + t);
    s.ix = n.ix + (o - n.cw), s.cw = o;
  }
  if (e === "n") {
    const o = Math.max(i, n.ch + t);
    s.iy = n.iy + (o - n.ch), s.ch = o;
  }
  return s;
}
function qde(n, e, t) {
  const i = Math.min(n.cw - n.iw * 0.25, Math.max(-n.iw * 0.75, n.ix + e)), s = Math.min(n.ch - n.ih * 0.25, Math.max(-n.ih * 0.75, n.iy + t));
  return { ...n, ix: Math.round(i), iy: Math.round(s) };
}
function Kde(n, e, t, i) {
  const s = Math.max(16, Math.round(e * i)), o = Math.max(16, Math.round(t * i)), r = n.ix + n.iw / 2, a = n.iy + n.ih / 2;
  return { ...n, iw: s, ih: o, ix: Math.round(r - s / 2), iy: Math.round(a - o / 2) };
}
function Yde(n) {
  return { ...n, ix: Math.round((n.cw - n.iw) / 2), iy: Math.round((n.ch - n.ih) / 2) };
}
function Xde(n, e) {
  return n && n !== "free" ? n : Math.round(e.cw) + " × " + Math.round(e.ch);
}
const Wf = [
  { id: "red", label: "Red", hue: 0, color: "#ff4d4d" },
  { id: "orange", label: "Orange", hue: 30, color: "#ff9a3d" },
  { id: "yellow", label: "Yellow", hue: 60, color: "#ffe14d" },
  { id: "green", label: "Green", hue: 120, color: "#4dd26b" },
  { id: "aqua", label: "Aqua", hue: 180, color: "#3dd9d9" },
  { id: "blue", label: "Blue", hue: 225, color: "#4d7bff" },
  { id: "purple", label: "Purple", hue: 275, color: "#a35cff" },
  { id: "magenta", label: "Magenta", hue: 315, color: "#ff4dcf" }
], Jde = [
  { id: "normal", label: "Normal" },
  { id: "multiply", label: "Multiply" },
  { id: "screen", label: "Screen" },
  { id: "overlay", label: "Overlay" },
  { id: "soft-light", label: "Soft light" },
  { id: "color", label: "Colour" }
], Yg = () => ({ hue: 0, amount: 0, lum: 0 });
function lf() {
  const n = {};
  for (const e of Wf) n[e.id] = { hue: 0, sat: 0, lum: 0 };
  return {
    exposure: 0,
    contrast: 0,
    brightness: 0,
    highlights: 0,
    shadows: 0,
    saturation: 0,
    hue: 0,
    temperature: 0,
    tint: 0,
    grade: { shadows: Yg(), midtones: Yg(), highlights: Yg() },
    mixer: n,
    overlay: { color: "#ff8a3d", blend: "soft-light", opacity: 0 },
    grain: { amount: 0, size: 35 },
    straighten: 0,
    quarter: 0,
    flipH: !1,
    flipV: !1,
    match: { to: null, amount: 0, stats: null },
    look: null
  };
}
function Zde(n, e) {
  const t = lf(), i = $c(n);
  return e === "light" && Object.assign(i, { exposure: 0, contrast: 0, brightness: 0, highlights: 0, shadows: 0 }), e === "colour" && Object.assign(i, { saturation: 0, hue: 0, temperature: 0, tint: 0 }), e === "grading" && (i.grade = t.grade), e === "mixer" && (i.mixer = t.mixer), e === "overlay" && (i.overlay = { ...i.overlay, opacity: 0 }), e === "grain" && (i.grain = t.grain), e === "rotate" && Object.assign(i, { straighten: 0, quarter: 0, flipH: !1, flipV: !1 }), e === "match" && (i.match = t.match), i.look = null, i;
}
function $c(n) {
  return JSON.parse(JSON.stringify(n));
}
function sl(n, e) {
  return e === "light" ? !!(n.exposure || n.contrast || n.brightness || n.highlights || n.shadows) : e === "colour" ? !!(n.saturation || n.hue || n.temperature || n.tint) : e === "grading" ? ["shadows", "midtones", "highlights"].some((t) => n.grade[t].amount > 0 || n.grade[t].lum !== 0) : e === "mixer" ? Wf.some((t) => n.mixer[t.id].hue || n.mixer[t.id].sat || n.mixer[t.id].lum) : e === "overlay" ? n.overlay.opacity > 0 : e === "grain" ? n.grain.amount > 0 : e === "rotate" ? !!(n.straighten || n.quarter || n.flipH || n.flipV) : !!n.match.to && n.match.amount > 0 && !!n.match.stats;
}
const a0 = ["light", "colour", "grading", "mixer", "overlay", "grain", "rotate", "match"];
function l0(n) {
  return a0.some((e) => sl(n, e));
}
function Qde(n) {
  return sl(n, "rotate");
}
function Dc(n, e, t) {
  return n.quarter % 2 ? { w: t, h: e } : { w: e, h: t };
}
function ece(n, e, t) {
  const i = Math.abs(n * Math.PI / 180);
  if (i < 1e-6) return 1;
  const s = Math.cos(i), o = Math.sin(i);
  return Math.max((e * s + t * o) / e, (e * o + t * s) / t);
}
const Iy = [
  { id: "vintage", label: "Vintage", set: (n) => {
    Object.assign(n, { saturation: -28, contrast: -12, temperature: 18, shadows: 18 }), n.grade.shadows = { hue: 190, amount: 22, lum: 8 }, n.grade.highlights = { hue: 42, amount: 26, lum: 0 }, n.grain = { amount: 22, size: 40 };
  } },
  { id: "retro-film", label: "Retro film", set: (n) => {
    Object.assign(n, { contrast: 16, saturation: -10, highlights: -14 }), n.grade.shadows = { hue: 215, amount: 30, lum: 0 }, n.grade.highlights = { hue: 35, amount: 24, lum: 0 }, n.grain = { amount: 34, size: 45 };
  } },
  { id: "duotone", label: "Duotone", set: (n) => {
    Object.assign(n, { saturation: -100, contrast: 12 }), n.grade.shadows = { hue: 255, amount: 70, lum: -6 }, n.grade.highlights = { hue: 38, amount: 62, lum: 4 };
  } },
  { id: "vibrant", label: "Vibrant", set: (n) => Object.assign(n, { saturation: 34, contrast: 12, shadows: 8 }) },
  { id: "warm", label: "Warm tone", set: (n) => Object.assign(n, { temperature: 32, tint: 4, saturation: 6 }) },
  { id: "cool-breeze", label: "Cool breeze", set: (n) => Object.assign(n, { temperature: -28, tint: -4, highlights: 10, saturation: -6 }) },
  { id: "red-tint", label: "Red tint", set: (n) => {
    n.overlay = { color: "#ff3b30", blend: "soft-light", opacity: 30 };
  } },
  { id: "cold", label: "Cold tone", set: (n) => Object.assign(n, { temperature: -44, saturation: -18, contrast: 6 }) },
  { id: "mono", label: "Black and white", set: (n) => Object.assign(n, { saturation: -100, contrast: 16 }) },
  { id: "matte", label: "Matte", set: (n) => {
    Object.assign(n, { contrast: -22, shadows: 26, saturation: -12 }), n.grade.shadows = { hue: 220, amount: 10, lum: 10 };
  } }
];
function u_(n, e) {
  const t = Iy.find((s) => s.id === e), i = lf();
  return Object.assign(i, { straighten: n.straighten, quarter: n.quarter, flipH: n.flipH, flipV: n.flipV, match: n.match }), t && t.set(i), i.look = t ? t.id : null, i;
}
function tce(n) {
  const e = Iy.find((t) => t.id === n.look);
  return e ? "Adjust · " + e.label : sl(n, "match") && a0.filter((t) => sl(n, t)).length === 1 ? "Match colours" : Qde(n) && a0.filter((t) => sl(n, t)).length === 1 ? n.straighten ? "Straighten" : "Rotate" : "Adjust";
}
function Xg(n) {
  return n <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
}
function nce(n, e, t) {
  const i = Xg(n), s = Xg(e), o = Xg(t);
  let r = (i * 0.4124 + s * 0.3576 + o * 0.1805) / 0.95047, a = i * 0.2126 + s * 0.7152 + o * 0.0722, l = (i * 0.0193 + s * 0.1192 + o * 0.9505) / 1.08883;
  const d = (c) => c > 8856e-6 ? Math.cbrt(c) : 7.787 * c + 16 / 116;
  return r = d(r), a = d(a), l = d(l), [116 * a - 16, 500 * (r - a), 200 * (a - l)];
}
function ice(n) {
  let e = 0;
  const t = [0, 0, 0], i = [0, 0, 0];
  for (let r = 0; r < n.length; r += 4) {
    if (n[r + 3] < 128) continue;
    const a = n[r] / 255, l = n[r + 1] / 255, d = n[r + 2] / 255, c = Math.max(a, l, d), u = Math.min(a, l, d);
    if (c < 0.02 || u > 0.985) continue;
    const p = nce(a, l, d);
    for (let f = 0; f < 3; f++)
      t[f] += p[f], i[f] += p[f] * p[f];
    e++;
  }
  if (!e) return { mean: [50, 0, 0], std: [1, 1, 1] };
  const s = t.map((r) => r / e), o = i.map((r, a) => Math.sqrt(Math.max(1e-6, r / e - s[a] * s[a])));
  return { mean: s, std: o };
}
function sce(n, e) {
  const t = [0, 1, 2].map((s) => Math.max(0.5, Math.min(2, e.std[s] / Math.max(1e-3, n.std[s])))), i = [0, 1, 2].map((s) => e.mean[s] - n.mean[s] * t[s]);
  return { scale: t, shift: i };
}
var oce = Object.defineProperty, rce = (n, e, t) => e in n ? oce(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, dr = (n, e, t) => rce(n, typeof e != "symbol" ? e + "" : e, t);
const ace = `#version 300 es
in vec2 aPos;
out vec2 vUv;
void main() {
	vUv = aPos * 0.5 + 0.5;
	gl_Position = vec4(aPos, 0.0, 1.0);
}`, lce = `#version 300 es
precision highp float;
in vec2 vUv;
out vec4 outColor;
uniform sampler2D uImg;
uniform vec2 uSrc;
uniform vec2 uOut;
uniform float uQuarter;
uniform vec2 uFlip;
uniform float uTurn;
uniform float uTurnScale;
uniform float uExposure;
uniform float uContrast;
uniform float uBrightness;
uniform float uHighlights;
uniform float uShadows;
uniform float uSaturation;
uniform float uHue;
uniform float uTemperature;
uniform float uTint;
uniform vec3 uGradeS;
uniform vec3 uGradeM;
uniform vec3 uGradeH;
uniform vec3 uGradeLum;
uniform vec3 uMixer[8];
uniform float uMixerHue[8];
uniform float uMixerOn;
uniform vec3 uOverlay;
uniform float uOverlayOpacity;
uniform int uBlend;
uniform float uGrain;
uniform float uGrainSize;
uniform float uSeed;
uniform vec3 uMatchScale;
uniform vec3 uMatchShift;
uniform float uMatch;
uniform float uShowOriginal;

float luma(vec3 c) { return dot(c, vec3(0.2126, 0.7152, 0.0722)); }

vec3 toLinear(vec3 c) {
	return mix(c / 12.92, pow((c + 0.055) / 1.055, vec3(2.4)), step(0.04045, c));
}
vec3 toSrgb(vec3 c) {
	c = max(c, 0.0);
	return mix(c * 12.92, 1.055 * pow(c, vec3(1.0 / 2.4)) - 0.055, step(0.0031308, c));
}

vec3 rgb2hsl(vec3 c) {
	float mx = max(c.r, max(c.g, c.b));
	float mn = min(c.r, min(c.g, c.b));
	float l = (mx + mn) * 0.5;
	float d = mx - mn;
	if (d < 1e-5) return vec3(0.0, 0.0, l);
	float s = d / (1.0 - abs(2.0 * l - 1.0) + 1e-5);
	float h;
	if (mx == c.r) h = mod((c.g - c.b) / d, 6.0);
	else if (mx == c.g) h = (c.b - c.r) / d + 2.0;
	else h = (c.r - c.g) / d + 4.0;
	return vec3(h / 6.0, clamp(s, 0.0, 1.0), l);
}
vec3 hsl2rgb(vec3 hsl) {
	vec3 rgb = clamp(abs(mod(hsl.x * 6.0 + vec3(0.0, 4.0, 2.0), 6.0) - 3.0) - 1.0, 0.0, 1.0);
	float C = (1.0 - abs(2.0 * hsl.z - 1.0)) * hsl.y;
	return (rgb - 0.5) * C + hsl.z;
}

vec3 rgb2lab(vec3 c) {
	vec3 l = toLinear(c);
	vec3 xyz = vec3(
		dot(l, vec3(0.4124, 0.3576, 0.1805)) / 0.95047,
		dot(l, vec3(0.2126, 0.7152, 0.0722)),
		dot(l, vec3(0.0193, 0.1192, 0.9505)) / 1.08883);
	vec3 f = mix(7.787 * xyz + 16.0 / 116.0, pow(xyz, vec3(1.0 / 3.0)), step(0.008856, xyz));
	return vec3(116.0 * f.y - 16.0, 500.0 * (f.x - f.y), 200.0 * (f.y - f.z));
}
vec3 lab2rgb(vec3 lab) {
	float fy = (lab.x + 16.0) / 116.0;
	float fx = fy + lab.y / 500.0;
	float fz = fy - lab.z / 200.0;
	vec3 f = vec3(fx, fy, fz);
	vec3 f3 = f * f * f;
	vec3 xyz = mix((f - 16.0 / 116.0) / 7.787, f3, step(0.008856, f3));
	xyz *= vec3(0.95047, 1.0, 1.08883);
	vec3 l = vec3(
		dot(xyz, vec3(3.2406, -1.5372, -0.4986)),
		dot(xyz, vec3(-0.9689, 1.8758, 0.0415)),
		dot(xyz, vec3(0.0557, -0.2040, 1.0570)));
	return toSrgb(l);
}

float hash(vec2 p) {
	p = fract(p * vec2(123.34, 456.21) + uSeed);
	p += dot(p, p + 45.32);
	return fract(p.x * p.y);
}

vec3 blend(vec3 base, vec3 top, int mode) {
	if (mode == 1) return base * top;
	if (mode == 2) return 1.0 - (1.0 - base) * (1.0 - top);
	if (mode == 3) return mix(2.0 * base * top, 1.0 - 2.0 * (1.0 - base) * (1.0 - top), step(0.5, base));
	if (mode == 4) return (1.0 - 2.0 * top) * base * base + 2.0 * top * base;
	if (mode == 5) {
		vec3 h = rgb2hsl(top);
		return hsl2rgb(vec3(h.x, h.y, rgb2hsl(base).z));
	}
	return top;
}

void main() {
	// where this output pixel comes from, in the source's pixels with y down as on screen:
	// undo the flip, the quarter turns (clockwise), then the straighten (clockwise)
	vec2 p = (vUv - 0.5) * uOut;
	p.y = -p.y;
	if (uFlip.x > 0.5) p.x = -p.x;
	if (uFlip.y > 0.5) p.y = -p.y;
	for (int i = 0; i < 3; i++) {
		if (float(i) < uQuarter) p = vec2(p.y, -p.x);
	}
	float cs = cos(uTurn);
	float sn = sin(uTurn);
	p = vec2(p.x * cs + p.y * sn, -p.x * sn + p.y * cs) / uTurnScale;
	vec2 uv = p / uSrc + 0.5;
	// the texture's first row is the picture's top (uploads aren't flipped: an ImageBitmap ignores the flag)
	vec4 src = texture(uImg, uv);
	vec3 c = src.rgb;
	if (uShowOriginal > 0.5) {
		outColor = vec4(c, src.a);
		return;
	}

	// exposure and white balance, in linear light
	vec3 lin = toLinear(c) * exp2(uExposure * 2.0);
	vec3 wb = vec3(1.0 + uTemperature * 0.22, 1.0 - uTint * 0.14, 1.0 - uTemperature * 0.22);
	wb /= max(1e-3, dot(wb, vec3(0.2126, 0.7152, 0.0722)));
	lin *= wb;
	c = toSrgb(lin);

	// highlights and shadows: lift or hold each end of the tones, keeping the colour
	float L = luma(c);
	float ws = pow(1.0 - smoothstep(0.0, 0.62, L), 2.0);
	float wh = pow(smoothstep(0.38, 1.0, L), 2.0);
	float L2 = L;
	L2 += uShadows * ws * 0.5 * (uShadows > 0.0 ? (1.0 - L) : L);
	L2 += uHighlights * wh * 0.5 * (uHighlights > 0.0 ? (1.0 - L) : L);
	c *= L2 / max(L, 1e-4);

	// brightness (the midtones), then contrast about the middle grey
	c = pow(max(c, 0.0), vec3(exp2(-uBrightness * 0.75)));
	float k = uContrast >= 0.0 ? 1.0 + uContrast * 1.1 : 1.0 + uContrast * 0.75;
	c = (c - 0.5) * k + 0.5;

	// colour grading: a tint and a brightness for the shadows, midtones and highlights
	L = clamp(luma(c), 0.0, 1.0);
	float gs = pow(1.0 - L, 2.0);
	float gh = L * L;
	float gm = max(0.0, 1.0 - gs - gh);
	c += uGradeS * gs + uGradeM * gm + uGradeH * gh;
	c += uGradeLum.x * gs + uGradeLum.y * gm + uGradeLum.z * gh;

	// the colour mixer: each hue band's own hue, saturation and luminance
	if (uMixerOn > 0.5) {
		vec3 hsl = rgb2hsl(clamp(c, 0.0, 1.0));
		float hue = hsl.x * 360.0;
		vec3 acc = vec3(0.0);
		float wsum = 0.0;
		for (int i = 0; i < 8; i++) {
			float d = abs(mod(hue - uMixerHue[i] + 180.0, 360.0) - 180.0);
			float w = max(0.0, 1.0 - d / 45.0);
			w = w * w * (3.0 - 2.0 * w);
			acc += uMixer[i] * w;
			wsum += w;
		}
		acc /= max(1.0, wsum);
		float chroma = smoothstep(0.02, 0.25, hsl.y);
		hsl.x = fract(hsl.x + acc.x * chroma / 12.0 + 1.0);
		hsl.y = clamp(hsl.y * (1.0 + acc.y * chroma), 0.0, 1.0);
		hsl.z = clamp(hsl.z + acc.z * 0.22 * chroma * hsl.y, 0.0, 1.0);
		c = hsl2rgb(hsl);
	}

	// hue, then saturation
	if (abs(uHue) > 1e-4) {
		vec3 hsl = rgb2hsl(clamp(c, 0.0, 1.0));
		hsl.x = fract(hsl.x + uHue / 360.0 + 1.0);
		c = hsl2rgb(hsl);
	}
	L = luma(c);
	c = mix(vec3(L), c, 1.0 + uSaturation);

	// match colours: another version's colour, carried over in Lab
	if (uMatch > 0.0) {
		vec3 lab = rgb2lab(clamp(c, 0.0, 1.0));
		vec3 moved = lab * uMatchScale + uMatchShift;
		c = mix(c, lab2rgb(moved), uMatch);
	}

	c = clamp(c, 0.0, 1.0);
	if (uOverlayOpacity > 0.0) c = mix(c, clamp(blend(c, uOverlay, uBlend), 0.0, 1.0), uOverlayOpacity);
	if (uGrain > 0.0) {
		vec2 cell = floor(gl_FragCoord.xy / max(1.0, uGrainSize));
		float n = hash(cell) - 0.5;
		float midtones = 1.0 - pow(abs(luma(c) - 0.5) * 2.0, 2.0);
		c += n * uGrain * (0.35 + 0.65 * midtones);
	}
	outColor = vec4(clamp(c, 0.0, 1.0), src.a);
}`, dce = { normal: 0, multiply: 1, screen: 2, overlay: 3, "soft-light": 4, color: 5 };
function cce(n) {
  const e = /^#?([0-9a-f]{6})$/i.exec(n.trim()), t = e ? parseInt(e[1], 16) : 0;
  return [(t >> 16 & 255) / 255, (t >> 8 & 255) / 255, (t & 255) / 255];
}
function Jg(n, e) {
  const t = (n % 360 + 360) % 360 / 60, i = 1 - Math.abs(t % 2 - 1), [s, o, r] = t < 1 ? [1, i, 0] : t < 2 ? [i, 1, 0] : t < 3 ? [0, 1, i] : t < 4 ? [0, i, 1] : t < 5 ? [i, 0, 1] : [1, 0, i], a = 0.2126 * s + 0.7152 * o + 0.0722 * r, l = e / 100 * 0.32;
  return [(s - a) * l, (o - a) * l, (r - a) * l];
}
class HC {
  constructor(e) {
    dr(this, "canvas", e), dr(this, "gl"), dr(this, "prog"), dr(this, "tex"), dr(this, "loc", /* @__PURE__ */ new Map()), dr(this, "src", { w: 1, h: 1 }), dr(this, "seed", Math.random());
    const t = e.getContext("webgl2", { premultipliedAlpha: !1, preserveDrawingBuffer: !0, antialias: !1 });
    if (!t) throw new Error("This browser can't adjust pictures (it has no WebGL 2).");
    this.gl = t;
    const i = this.shader(t.VERTEX_SHADER, ace), s = this.shader(t.FRAGMENT_SHADER, lce), o = t.createProgram();
    if (t.attachShader(o, i), t.attachShader(o, s), t.linkProgram(o), !t.getProgramParameter(o, t.LINK_STATUS)) throw new Error("Adjust's shader didn't link: " + t.getProgramInfoLog(o));
    this.prog = o, t.useProgram(o);
    const r = t.createBuffer();
    t.bindBuffer(t.ARRAY_BUFFER, r), t.bufferData(t.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), t.STATIC_DRAW);
    const a = t.getAttribLocation(o, "aPos");
    t.enableVertexAttribArray(a), t.vertexAttribPointer(a, 2, t.FLOAT, !1, 0, 0), this.tex = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.tex), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE);
  }
  shader(e, t) {
    const i = this.gl, s = i.createShader(e);
    if (i.shaderSource(s, t), i.compileShader(s), !i.getShaderParameter(s, i.COMPILE_STATUS)) throw new Error("Adjust's shader didn't compile: " + i.getShaderInfoLog(s));
    return s;
  }
  u(e) {
    return this.loc.has(e) || this.loc.set(e, this.gl.getUniformLocation(this.prog, e)), this.loc.get(e) || null;
  }
  /** The picture to adjust. */
  setImage(e, t, i) {
    const s = this.gl;
    s.bindTexture(s.TEXTURE_2D, this.tex), s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, !1), s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, s.RGBA, s.UNSIGNED_BYTE, e), this.src = { w: t, h: i };
  }
  /** The biggest picture this browser's graphics take. */
  maxSize() {
    return this.gl.getParameter(this.gl.MAX_TEXTURE_SIZE);
  }
  /**
   * Draw the picture adjusted, `w` by `h` (the output's shape: a quarter turn
   * swaps them). `grainScale` keeps grain the same size on the picture
   * whatever size it's drawn at (the preview is smaller than the bake).
   */
  render(e, t, i, s = {}) {
    const o = this.gl;
    this.canvas.width !== t && (this.canvas.width = t), this.canvas.height !== i && (this.canvas.height = i), o.viewport(0, 0, t, i), o.useProgram(this.prog);
    const r = (f, y) => o.uniform1f(this.u(f), y);
    o.uniform1i(this.u("uImg"), 0), o.uniform2f(this.u("uSrc"), this.src.w, this.src.h);
    const a = e.quarter % 2 ? [this.src.h, this.src.w] : [this.src.w, this.src.h];
    o.uniform2f(this.u("uOut"), a[0], a[1]), r("uQuarter", e.quarter), o.uniform2f(this.u("uFlip"), e.flipH ? 1 : 0, e.flipV ? 1 : 0), r("uTurn", e.straighten * Math.PI / 180), r("uTurnScale", ece(e.straighten, this.src.w, this.src.h)), r("uExposure", e.exposure / 100), r("uContrast", e.contrast / 100), r("uBrightness", e.brightness / 100), r("uHighlights", e.highlights / 100), r("uShadows", e.shadows / 100), r("uSaturation", e.saturation / 100), r("uHue", e.hue), r("uTemperature", e.temperature / 100), r("uTint", e.tint / 100), o.uniform3fv(this.u("uGradeS"), Jg(e.grade.shadows.hue, e.grade.shadows.amount)), o.uniform3fv(this.u("uGradeM"), Jg(e.grade.midtones.hue, e.grade.midtones.amount)), o.uniform3fv(this.u("uGradeH"), Jg(e.grade.highlights.hue, e.grade.highlights.amount)), o.uniform3f(this.u("uGradeLum"), e.grade.shadows.lum / 100 * 0.22, e.grade.midtones.lum / 100 * 0.22, e.grade.highlights.lum / 100 * 0.22);
    const l = [], d = [];
    let c = 0;
    for (const f of Wf) {
      const y = e.mixer[f.id];
      l.push(y.hue / 100, y.sat / 100, y.lum / 100), d.push(f.hue), (y.hue || y.sat || y.lum) && (c = 1);
    }
    o.uniform3fv(this.u("uMixer"), new Float32Array(l)), o.uniform1fv(this.u("uMixerHue"), new Float32Array(d)), r("uMixerOn", c), o.uniform3fv(this.u("uOverlay"), cce(e.overlay.color)), r("uOverlayOpacity", e.overlay.opacity / 100), o.uniform1i(this.u("uBlend"), dce[e.overlay.blend] || 0), r("uGrain", e.grain.amount / 100 * 0.22), r("uGrainSize", (1 + e.grain.size / 100 * 3) * (s.grainScale || 1)), r("uSeed", this.seed);
    const u = s.transfer, p = e.match;
    r("uMatch", u && p.to && p.stats ? p.amount / 100 : 0), o.uniform3fv(this.u("uMatchScale"), u ? u.scale : [1, 1, 1]), o.uniform3fv(this.u("uMatchShift"), u ? u.shift : [0, 0, 0]), r("uShowOriginal", s.original ? 1 : 0), o.activeTexture(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, this.tex), o.drawArrays(o.TRIANGLE_STRIP, 0, 4);
  }
  dispose() {
    const e = this.gl.getExtension("WEBGL_lose_context");
    e && e.loseContext();
  }
}
const h_ = 3, VC = [
  { kelvin: 1900, name: "Candlelight", color: "#ff9329" },
  { kelvin: 2800, name: "Golden", color: "#ffad5e" },
  { kelvin: 3200, name: "Tungsten", color: "#ffb46b" },
  { kelvin: 4300, name: "Warm white", color: "#ffd4a6" },
  { kelvin: 5600, name: "Daylight", color: "#fff4e5" },
  { kelvin: 6500, name: "Overcast", color: "#f2f5ff" },
  { kelvin: 8e3, name: "Blue hour", color: "#c9d9ff" }
], uce = ["#ff2bd6", "#2be4ff", "#ff3d3d", "#ff8a3d", "#ffd23d", "#3dff8a", "#3d7bff", "#9b5cff"], hce = [
  { id: "top", label: "Top", rotate: 0, elevation: 90 },
  { id: "front", label: "Front", rotate: 0, elevation: 0 },
  { id: "right", label: "Right", rotate: 90, elevation: 0 },
  { id: "left", label: "Left", rotate: -90, elevation: 0 },
  { id: "back", label: "Back", rotate: 180, elevation: 0 },
  { id: "bottom", label: "Bottom", rotate: 0, elevation: -90 }
];
let p_ = 0;
function pce() {
  return p_++, "l" + Date.now().toString(36) + p_;
}
function Ay(n) {
  var e, t, i;
  return {
    id: n.id || pce(),
    rotate: (e = n.rotate) != null ? e : -45,
    elevation: (t = n.elevation) != null ? t : 45,
    intensity: (i = n.intensity) != null ? i : 7,
    color: n.color || "#fff4e5",
    kelvin: n.kelvin === void 0 ? n.color ? null : 5600 : n.kelvin
  };
}
const d0 = [
  {
    id: "golden-hour",
    label: "Golden hour",
    swatch: ["#ffad5e", "#3b2a4a"],
    softness: "soft",
    lights: [{ rotate: -45, elevation: 0, intensity: 7, color: "#ffad5e", kelvin: 2800 }],
    words: "Golden hour: a low warm sun casting long soft shadows, with a warm glow in the air."
  },
  {
    id: "dusk-interiors",
    label: "Dusk, interiors lit",
    swatch: ["#ffcf8a", "#24345e"],
    softness: "soft",
    arch: !0,
    lights: [{ rotate: 0, elevation: 45, intensity: 3, color: "#c9d9ff", kelvin: 8e3 }],
    words: "Dusk at blue hour: a deep blue sky with a last warm glow at the horizon; every interior is lit with warm light that glows through the windows; exterior surfaces are lit softly by the sky."
  },
  {
    id: "night-facade",
    label: "Night, facade lit",
    swatch: ["#ffd9a0", "#0d1226"],
    softness: "hard",
    arch: !0,
    lights: [{ rotate: 0, elevation: -45, intensity: 6, color: "#ffd4a6", kelvin: 4300 }],
    words: "Night: a dark sky; the facade is washed by warm architectural uplights from the ground, with soft pools of light and deep shadows above them; windows glow faintly."
  },
  {
    id: "overcast",
    label: "Overcast",
    swatch: ["#f2f5ff", "#6b7280"],
    softness: "soft",
    arch: !0,
    lights: [{ rotate: 0, elevation: 45, intensity: 5, color: "#f2f5ff", kelvin: 6500 }],
    words: "Overcast sky: diffuse light from above with no hard shadows and soft, low contrast."
  },
  {
    id: "midday-sun",
    label: "Midday sun",
    swatch: ["#fff4e5", "#38506b"],
    softness: "hard",
    arch: !0,
    lights: [{ rotate: 45, elevation: 90, intensity: 9, color: "#fff4e5", kelvin: 5600 }],
    words: "Midday sun: bright, high sunlight with short, crisp shadows and a clear blue sky."
  },
  {
    id: "softbox",
    label: "Studio softbox",
    swatch: ["#ffffff", "#4b5563"],
    softness: "soft",
    lights: [
      { rotate: -45, elevation: 45, intensity: 7, color: "#fff4e5", kelvin: 5600 },
      { rotate: 90, elevation: 0, intensity: 3, color: "#fff4e5", kelvin: 5600 }
    ],
    words: "A large studio softbox as the key light with a gentle fill: clean, even, flattering light with soft shadow edges."
  },
  {
    id: "rim",
    label: "Rim light",
    swatch: ["#eef3ff", "#111827"],
    softness: "hard",
    lights: [{ rotate: 135, elevation: 0, intensity: 8, color: "#f2f5ff", kelvin: 6500 }],
    words: "The front of the subject stays dim, lit only by faint ambient light."
  },
  {
    id: "neon",
    label: "Neon",
    swatch: ["#ff2bd6", "#2be4ff"],
    softness: "soft",
    lights: [
      { rotate: -90, elevation: 0, intensity: 7, color: "#ff2bd6", kelvin: null },
      { rotate: 90, elevation: 0, intensity: 7, color: "#2be4ff", kelvin: null }
    ],
    words: "The rest of the scene is dark."
  },
  {
    id: "three-point",
    label: "Key, fill and rim",
    swatch: ["#ffb46b", "#5fd8ff"],
    softness: "hard",
    lights: [
      { rotate: 45, elevation: 45, intensity: 8, color: "#ffb46b", kelvin: 3200 },
      { rotate: -90, elevation: 0, intensity: 3, color: "#5fd8ff", kelvin: null },
      { rotate: 135, elevation: 0, intensity: 6, color: "#ff8a3d", kelvin: null }
    ],
    words: ""
  }
];
function Py(n) {
  return n && d0.find((e) => e.id === n) || null;
}
function fce(n, e = "relight") {
  return { mode: e, softness: n.softness, look: n.id, lights: n.lights.map((t) => Ay({ ...t })) };
}
function WC() {
  return { mode: "relight", softness: "soft", look: null, lights: [Ay({ rotate: -45, elevation: 45, intensity: 7, color: "#ffb46b", kelvin: 3200 })] };
}
function qC(n) {
  const e = Py(n.look);
  return !e || e.lights.length !== n.lights.length || e.softness !== n.softness ? !1 : e.lights.every((t, i) => {
    const s = n.lights[i];
    return s.rotate === t.rotate && s.elevation === t.elevation && s.intensity === t.intensity && s.color.toLowerCase() === t.color.toLowerCase();
  });
}
function _l(n) {
  const e = (n % 360 + 360) % 360;
  return e > 180 ? e - 360 : e;
}
function ac(n) {
  const e = _l(Math.round(_l(n) / 45) * 45);
  return e === -180 ? 180 : e;
}
function f_(n) {
  return Math.max(-90, Math.min(90, Math.round(n / 45) * 45));
}
const KC = {
  0: "from the front (the camera's side)",
  45: "from the front right of the frame",
  90: "from the right side of the frame",
  135: "from behind on the right",
  180: "from directly behind",
  "-45": "from the front left of the frame",
  "-90": "from the left side of the frame",
  "-135": "from behind on the left"
}, m_ = [[-90, "from below"], [-45, "low, from below the subject"], [0, "at subject height"], [45, "high, about 45° above"], [90, "from directly overhead"]];
function g_(n, e) {
  return e.reduce((t, i) => Math.abs(i[0] - n) < Math.abs(t[0] - n) ? i : t)[1];
}
const Ey = (n) => Math.abs(_l(n.rotate)) >= 135, qf = (n) => n.elevation >= 75, Kf = (n) => n.elevation <= -75, mce = (n) => n <= 2 ? "faint" : n <= 4 ? "soft" : n <= 6 ? "moderate" : n <= 8 ? "strong" : "very strong";
function YC(n) {
  const e = /^#?([0-9a-f]{6})$/i.exec(n.trim()), t = e ? parseInt(e[1], 16) : 16777215;
  return [t >> 16 & 255, t >> 8 & 255, t & 255];
}
function gce(n) {
  const [e, t, i] = YC(n).map((c) => c / 255), s = Math.max(e, t, i), o = Math.min(e, t, i), r = (s + o) / 2, a = s - o;
  if (a < 1e-6) return { h: 0, s: 0, l: r };
  const l = a / (1 - Math.abs(2 * r - 1));
  let d = s === e ? (t - i) / a % 6 : s === t ? (i - e) / a + 2 : (e - t) / a + 4;
  return d = (d * 60 + 360) % 360, { h: d, s: l, l: r };
}
const b_ = [
  [0, "red"],
  [14, "red-orange"],
  [30, "orange"],
  [45, "amber"],
  [56, "yellow"],
  [80, "lime green"],
  [120, "green"],
  [160, "teal"],
  [185, "cyan"],
  [205, "sky blue"],
  [225, "blue"],
  [250, "indigo"],
  [272, "violet"],
  [290, "purple"],
  [312, "magenta"],
  [335, "pink"],
  [360, "red"]
];
function XC(n) {
  if (n.kelvin) {
    const s = VC.find((a) => a.kelvin === n.kelvin), o = s ? s.name.toLowerCase() : "white";
    return (o === "daylight" ? "daylight" : o === "tungsten" ? "warm tungsten" : o === "overcast" ? "cool overcast" : o === "blue hour" ? "cool blue-hour" : o) + " (about " + n.kelvin + " K)";
  }
  const e = gce(n.color);
  if (e.s < 0.18) return e.l > 0.5 ? "white" : "grey";
  let t = b_[0][1], i = 999;
  for (const [s, o] of b_) {
    const r = Math.abs(s - e.h);
    r < i && (i = r, t = o);
  }
  return (e.s < 0.45 ? "soft " : "") + t;
}
function bce(n, e) {
  const t = n.intensity / e.intensity;
  return t <= 0.45 ? "about a third as bright" : t <= 0.75 ? "about two thirds as bright" : t < 0.95 ? "a little dimmer" : t > 1.3 ? "brighter" : "as bright";
}
function df(n) {
  const e = _l(n.rotate) * Math.PI / 180, t = n.elevation * Math.PI / 180;
  return { x: Math.sin(e) * Math.cos(t), y: -Math.sin(t) };
}
function vce(n) {
  if (qf(n)) return "Tops of surfaces are lit; the sides fall into shade.";
  if (Kf(n)) return "Undersides are lit from below; upper surfaces fall into shadow.";
  if (Ey(n)) return "The side facing the camera falls into shadow.";
  const e = df(n);
  return e.x > 0.3 ? "Surfaces facing the right of the frame are lit; surfaces facing the left of the frame fall into shadow." : e.x < -0.3 ? "Surfaces facing the left of the frame are lit; surfaces facing the right of the frame fall into shadow." : "The side facing the camera is lit evenly.";
}
function yce(n) {
  if (qf(n)) return "Shadows fall straight down.";
  if (Kf(n)) return "Shadows are cast upward.";
  if (Ey(n)) return "Shadows fall toward the camera.";
  const e = df(n);
  if (Math.hypot(e.x, e.y) < 0.3) return "Shadows fall behind the subject, mostly out of view.";
  const t = [];
  return e.x > 0.3 && t.push("toward the left of the frame"), e.x < -0.3 && t.push("toward the right of the frame"), e.y < -0.3 && t.push("down"), "Shadows fall " + t.join(" and ") + ".";
}
function JC(n, e) {
  const t = n[e];
  return e === 0 || !t ? "Key" : Ey(t) ? "Rim" : t.intensity < n[0].intensity ? "Fill" : "Second";
}
function xce(n) {
  const e = /* @__PURE__ */ new Map();
  return n.map((t, i) => {
    const s = JC(n, i), o = (e.get(s) || 0) + 1;
    return e.set(s, o), o > 1 ? s + " " + o : s;
  });
}
const wce = "Relighting only: keep the people, pose, expression, composition, camera angle, materials and object colours; change only the light, shadows, highlights and colour cast.";
function kce(n) {
  if (n.mode === "transfer") return _ce();
  const e = n.lights.length ? n.lights : WC().lights, t = e[0], i = n.softness === "hard" ? "hard, with crisp shadow edges" : "soft and diffused", s = [wce];
  e.forEach((r, a) => {
    const l = JC(e, a) + " light", d = a === 0 ? mce(r.intensity) + ", " + i : bce(r, t), c = qf(r) || Kf(r) ? g_(r.elevation, m_) : KC[String(ac(r.rotate))] + ", " + g_(r.elevation, m_), u = l === "Rim light" ? ", outlining the edges" : "";
    s.push(l + ": " + XC(r) + " light " + c + u + ", " + d + ".");
  }), s.push(vce(t)), s.push(yce(t));
  const o = Py(n.look);
  return o && o.words && qC(n) && s.push(o.words), s.join(" ");
}
function _ce() {
  return "Relight image 1 with the lighting of image 2: its direction, colour, softness and contrast. Keep everything in image 1 as it is: the people, pose, composition, camera angle, materials and object colours. Use image 2 only for its light, not for anything in it.";
}
function Sce(n) {
  if (n.mode === "transfer") return "Light transfer";
  const e = Py(n.look);
  if (e && qC(n)) return e.label;
  const t = n.lights[0];
  if (!t) return "Relight";
  const i = qf(t) ? "from above" : Kf(t) ? "from below" : KC[String(ac(t.rotate))].replace(" (the camera's side)", "").replace(" of the frame", "");
  return (n.lights.length > 1 ? n.lights.length + " lights, " : "") + XC(t).replace(/ \(about \d+ K\)/, "") + " key " + i;
}
function Tce(n, e) {
  const t = new Uint8ClampedArray(e * e * 4), i = n.lights.map((r) => {
    const a = _l(r.rotate) * Math.PI / 180, l = r.elevation * Math.PI / 180, [d, c, u] = YC(r.color);
    return { x: Math.sin(a) * Math.cos(l), y: Math.sin(l), z: Math.cos(a) * Math.cos(l), r: d / 255, g: c / 255, b: u / 255, k: r.intensity / 7 };
  }), s = n.softness === "soft" ? 0.45 : 0.08, o = e / 2 - 1;
  for (let r = 0; r < e; r++)
    for (let a = 0; a < e; a++) {
      const l = (a + 0.5 - e / 2) / o, d = -(r + 0.5 - e / 2) / o, c = l * l + d * d, u = (r * e + a) * 4;
      if (c > 1) continue;
      const p = Math.sqrt(1 - c);
      let f = 0.06, y = 0.06, b = 0.075;
      for (const k of i) {
        const S = l * k.x + d * k.y + p * k.z, _ = Math.max(0, (S + s) / (1 + s)), x = n.softness === "hard" ? Math.pow(Math.max(0, S), 24) * 0.35 : Math.pow(Math.max(0, S), 8) * 0.12;
        f += (_ * 0.85 + x) * k.r * k.k, y += (_ * 0.85 + x) * k.g * k.k, b += (_ * 0.85 + x) * k.b * k.k;
      }
      const w = Math.min(1, (1 - Math.sqrt(c)) * o * 0.9);
      t[u] = Math.min(255, Math.pow(f, 1 / 2.2) * 255), t[u + 1] = Math.min(255, Math.pow(y, 1 / 2.2) * 255), t[u + 2] = Math.min(255, Math.pow(b, 1 / 2.2) * 255), t[u + 3] = Math.round(255 * w);
    }
  return t;
}
function Zg(n) {
  const e = _l(n.rotate) * Math.PI / 180, t = n.elevation * Math.PI / 180, i = Math.sin(e) * Math.cos(t), s = Math.sin(t), o = Math.cos(e) * Math.cos(t), r = 0.43;
  return { x: 0.5 + i * r, y: 0.5 - s * r, front: o >= -0.05 };
}
var Mce = Object.defineProperty, Cce = (n, e, t) => e in n ? Mce(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Qg = (n, e, t) => Cce(n, typeof e != "symbol" ? e + "" : e, t);
const v_ = ["#ffffff", "#f4f1ea", "#d9d9de", "#8a8f99", "#16141f", "#e9d5c4", "#f6c9c9", "#cfe3f5", "#cdebd5", "#ffe9a8"], eb = /* @__PURE__ */ new Map();
function y_(n) {
  let e = eb.get(n);
  return e || (e = oi(n).then((t) => ice(Ede(t))), eb.set(n, e), e.catch(() => eb.delete(n))), e;
}
class Ice {
  constructor(e, t) {
    Qg(this, "studio", e), Qg(this, "board", t), Qg(this, "t"), this.t = /* @__PURE__ */ Xt({
      open: null,
      guard: null,
      busy: null,
      resize: { mode: "crop", ratio: "free", crop: { ...ch }, frame: null, frameRatio: "16:9", words: "", for: null },
      background: { mode: "remove", fill: void 0, words: "", refId: null, layer: dh(), for: null },
      adjust: { a: lf(), group: "light", original: !1, source: null, for: null },
      skin: Mde(),
      camera: { set: { ...sp }, seed: null, lock: !0 },
      relight: { rig: WC(), selected: null, refId: null },
      compare: null
    });
  }
  get stage() {
    return this.studio.stage.value;
  }
  // ---------------------------------------------------------------- one tool at a time
  /** Open a tool (the bar shows it, active); open again, or Close, and the bar is back. */
  open(e) {
    this.t.open === e || this.held() || this.leave(() => {
      this.t.open = e, this.t.compare = null, this.studio.finishEditing(), this.ready(e);
    });
  }
  /** Back to the bar, through the question if the tool has a change not yet made. */
  close(e) {
    if (!this.t.open) {
      e && e();
      return;
    }
    this.held() || this.leave(() => {
      this.t.open = null, e && e();
    });
  }
  /**
   * Leave the open tool, then do `then`: at once when nothing's pending, else
   * once you've chosen to apply or discard. True when it went at once.
   */
  leave(e) {
    const t = this.t.open;
    return this.held() ? !1 : !t || !this.pending(t) ? (t && this.reset(t), e(), !0) : (this.t.guard = { tool: t, then: e }, !1);
  }
  /** The question answered: apply the change (it becomes a version), or discard it; then what was asked for. */
  async answer(e) {
    const t = this.t.guard;
    t && (this.t.guard = null, !(e && !await this.apply(t.tool)) && (this.reset(t.tool), t.then && t.then()));
  }
  /** Stay in the tool (Escape on the question). */
  stay() {
    this.t.guard = null;
  }
  /** Whether a tool has a change showing on the stage that isn't a version yet. */
  pending(e = this.t.open) {
    const t = this.stage;
    if (!e || !t) return !1;
    if (e === "resize") {
      const i = this.t.resize;
      return i.for !== t.id ? !1 : i.mode === "crop" ? !d_(i.crop) : !!i.frame && r0(i.frame);
    }
    if (e === "background") {
      const i = this.t.background;
      return i.for !== t.id ? !1 : i.mode === "remove" ? i.fill !== void 0 && this.isCutout(t) : i.mode === "adjust" ? zc(i.layer) : !1;
    }
    if (e === "adjust") {
      const i = this.t.adjust;
      if (i.for !== t.id) return !1;
      const s = t.made && t.made.tool === "adjust" && t.made.settings ? t.made.settings.adjust : void 0;
      return s ? JSON.stringify(x_(s)) !== JSON.stringify(x_(i.a)) : l0(i.a);
    }
    return !1;
  }
  /** A tool's stage state as it starts, for the picture on the stage. */
  ready(e) {
    const t = this.stage;
    if (t) {
      if (e === "resize") {
        const i = this.t.resize;
        i.for !== t.id && (i.for = t.id, i.crop = { ...ch }, i.ratio = "free", i.frame = null);
      }
      if (e === "background") {
        const i = this.t.background;
        i.for !== t.id && (i.for = t.id, i.fill = void 0, i.layer = { ...dh(), target: i.layer.target });
      }
      e === "adjust" && this.readyAdjust();
    }
  }
  /** A tool's change dropped: the stage shows the picture as it is. */
  reset(e) {
    if (this.t.busy) return;
    const t = this.stage;
    e === "resize" && (this.t.resize.crop = { ...ch }, this.t.resize.ratio = "free", this.t.resize.frame = null, this.t.resize.frameRatio = "free", this.t.resize.for = t ? t.id : null), e === "background" && (this.t.background.fill = void 0, this.t.background.layer = { ...dh(), target: this.t.background.layer.target }, this.t.background.for = t ? t.id : null), e === "adjust" && (this.t.adjust.for = null, this.readyAdjust());
  }
  /** The picture on the stage changed: a tool's stage state is for the old one. */
  stageChanged() {
    const e = this.t.open;
    this.t.compare = this.t.compare && this.stage && this.t.compare.with !== this.stage.id ? this.t.compare : null, e && this.ready(e);
  }
  /** Apply the open tool's change: its version is made and takes the stage. */
  async apply(e = this.t.open) {
    return e ? e === "resize" ? this.t.resize.mode === "crop" ? this.applyCrop() : this.runTool("expand") : e === "background" ? this.t.background.mode === "adjust" ? this.applyLayers() : this.applyFill() : e === "adjust" ? this.applyAdjust() : !1 : !1;
  }
  // ---------------------------------------------------------------- Crop
  setRatio(e) {
    if (this.t.busy) return;
    const t = this.stage, i = this.t.resize;
    if (i.ratio = e, !t) return;
    i.for = t.id;
    const s = af(e, t.w, t.h);
    if (s == null) return;
    const o = i.crop;
    i.crop = Bde(s, t.w, t.h, { x: o.x + o.w / 2, y: o.y + o.h / 2 });
  }
  setCrop(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.resize.crop = e, t && (this.t.resize.for = t.id);
  }
  /** The crop's size in the picture's pixels. */
  cropPixels() {
    const e = this.stage;
    return e ? o0(this.t.resize.crop, e.w, e.h) : { w: 0, h: 0 };
  }
  async applyCrop() {
    const e = this.stage, t = this.t.resize;
    if (!e || d_(t.crop)) return !1;
    const i = { ...t.crop }, s = t.ratio;
    return this.bake("Cropping", async () => {
      const o = await oi(e.url), r = Pde(o, i), a = o0(i, e.w, e.h);
      return this.studio.addVersion(r, { tool: "crop", label: Ude(s, a), settings: { crop: i, ratio: s } }, e);
    }, () => {
      t.crop = { ...ch }, t.ratio = "free";
    });
  }
  // ---------------------------------------------------------------- Expand (Bria)
  setFrameRatio(e) {
    if (this.t.busy) return;
    const t = this.stage, i = this.t.resize;
    if (i.frameRatio = e, !t) return;
    i.for = t.id;
    const s = af(e, t.w, t.h);
    i.frame = s == null ? i.frame || c_(t.w / t.h, t.w, t.h, 1.25) : c_(s, t.w, t.h, 1.06);
  }
  setFrame(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.resize.frame = e, t && (this.t.resize.for = t.id);
  }
  frame() {
    const e = this.stage;
    return e ? this.t.resize.frame || jC(e.w, e.h) : null;
  }
  // ---------------------------------------------------------------- Background
  /** Whether the picture is a cut-out (Remove background's result, or anything see-through). */
  isCutout(e) {
    if (!e) return !1;
    if (e.made && (e.made.tool === "removebg" || e.made.settings && e.made.settings.cutout)) return !0;
    const t = e.runId ? this.board.studioRecords.get("edit:" + e.runId) : void 0;
    return !!t && t.role === "edit" && t.studio === "removebg";
  }
  /** The cut-out a background adjustment needs: the stage picture's own Remove background result, if there is one. */
  cutoutFor(e) {
    return e ? this.isCutout(e) ? e : this.studio.items.value.find((t) => t.parentId === e.id && t.status === "done" && this.isCutout(t)) || null : null;
  }
  setFill(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.background.fill = e, t && (this.t.background.for = t.id);
  }
  async applyFill() {
    const e = this.stage, t = this.t.background.fill;
    return !e || t === void 0 || !this.isCutout(e) ? !1 : this.bake("Filling the background", async () => {
      const i = await oi(e.url), s = BC(i, t), o = t ? "Background filled" : "Background see-through";
      return this.studio.addVersion(s, { tool: "background", label: o, settings: { fill: t, cutout: !t } }, e, { alpha: !t });
    }, () => {
      this.t.background.fill = void 0;
    });
  }
  setLayer(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.background.layer = { ...this.t.background.layer, ...e }, t && (this.t.background.for = t.id);
  }
  async applyLayers() {
    const e = this.stage, t = this.cutoutFor(e), i = this.t.background.layer;
    if (!e || !t || !zc(i)) return !1;
    const s = t === e ? e.parentId && this.studio.items.value.find((o) => o.id === e.parentId) || null : e;
    return s ? this.bake("Adjusting the " + (i.target === "background" ? "background" : "subject"), async () => {
      const [o, r] = await Promise.all([oi(s.url), oi(t.url)]), a = il(o.width, o.height), l = FC(o, r, i, a.w, a.h);
      return this.studio.addVersion(l, { tool: "layers", label: i.target === "background" ? "Background adjusted" : "Subject adjusted", settings: { layer: { ...i } } }, s);
    }, () => {
      this.t.background.layer = { ...dh(), target: i.target };
    }) : !1;
  }
  // ---------------------------------------------------------------- Adjust
  /** Adjust as it opens on the stage picture: an Adjust version reopens with its settings, drawn from its own original. */
  readyAdjust() {
    const e = this.stage, t = this.t.adjust;
    if (!e || t.for === e.id) return;
    t.for = e.id;
    const i = e.made && e.made.tool === "adjust" && e.made.settings ? e.made.settings.adjust : void 0, s = i && e.parentId ? this.studio.items.value.find((o) => o.id === e.parentId && o.status === "done") : null;
    i && s ? (t.a = $c(i), t.source = s.id) : (t.a = lf(), t.source = e.id);
  }
  /** The picture Adjust draws from. */
  adjustSource() {
    const e = this.t.adjust.source;
    return e && this.studio.items.value.find((t) => t.id === e) || this.stage;
  }
  setAdjust(e) {
    this.t.busy || (this.t.adjust.a = e);
  }
  /** Match colours to another version: its colour read, then carried onto this one as you set how much. */
  async matchTo(e) {
    if (this.t.busy) return;
    const t = this.t.adjust.a;
    if (!e) {
      this.t.adjust.a = { ...t, match: { to: null, amount: 0, stats: null }, look: null };
      return;
    }
    const i = this.studio.items.value.find((s) => s.id === e);
    if (i)
      try {
        const s = await y_(i.url);
        this.t.adjust.a = { ...this.t.adjust.a, match: { to: e, amount: this.t.adjust.a.match.amount || 80, stats: s } };
      } catch (s) {
        console.warn("[board] that version's colour couldn't be read", s), this.studio.say("That version's colour couldn't be read");
      }
  }
  /** How Match colours moves this picture's colour, for the shader (null when it isn't matched). */
  async transfer(e = this.t.adjust.a, t = this.adjustSource()) {
    if (!e.match.to || !e.match.stats || !t) return null;
    try {
      return sce(await y_(t.url), e.match.stats);
    } catch {
      return null;
    }
  }
  async applyAdjust() {
    const e = this.adjustSource(), t = $c(this.t.adjust.a);
    return !e || !l0(t) ? !1 : this.bake("Applying your adjustments", async () => {
      const i = await oi(e.url), s = new HC(document.createElement("canvas"));
      try {
        const o = il(i.width, i.height, Math.min(8192, s.maxSize())), r = Dc(t, o.w, o.h);
        s.setImage(i, i.width, i.height), s.render(t, r.w, r.h, { transfer: await this.transfer(t, e), grainScale: r.w / Math.max(1, Dc(t, i.width, i.height).w) });
        const a = $n(r.w, r.h);
        return Dn(a).drawImage(s.canvas, 0, 0), this.studio.addVersion(a, { tool: "adjust", label: tce(t), settings: { adjust: t } }, e, { alpha: LC(i) });
      } finally {
        s.dispose();
      }
    }, () => {
      this.t.adjust.for = null;
    });
  }
  // ---------------------------------------------------------------- shared
  /**
   * While a tool's version is being made, nothing else moves (IL-100; Adam:
   * changing exposure or resize while one applied raced it): it says so, and
   * the tools, their settings and the stage wait for it.
   */
  held() {
    const e = this.t.busy;
    return e ? (this.studio.say("One moment: " + e.charAt(0).toLowerCase() + e.slice(1)), !0) : !1;
  }
  /** Make a tool's version: one at a time, said in the bar while it's made. */
  async bake(e, t, i) {
    if (this.t.busy) return !1;
    this.t.busy = e, this.studio.s.baking = e;
    try {
      return await t() ? (i(), !0) : !1;
    } catch (s) {
      return console.warn("[board] a tool's version couldn't be made", s), this.studio.say(s instanceof Error && /read|draw|saved|uploaded/i.test(s.message) ? s.message.replace(/\.$/, "") : "That couldn't be made. Please try again"), !1;
    } finally {
      this.t.busy = null, this.studio.s.baking = null;
    }
  }
  // ---------------------------------------------------------------- the model tools' runs
  /** A reference picture a tool sends as image 2 (Replace background's, Light transfer's). */
  refItem(e) {
    return e && this.studio.items.value.find((t) => t.id === e && t.status === "done") || null;
  }
  /** A model tool's run, as its plan: the stage picture, the tool's settings as its model's inputs, its words. */
  plan(e) {
    const t = this.stage, i = this.studio.modelOf(e);
    if (!t || t.status !== "done" || !i) return null;
    const s = { w: t.w, h: t.h }, o = { kind: e, model: i, words: "", count: this.studio.countOf(e), base: t.id }, r = { kind: "item", item: t, marks: !1 };
    if (e === "upscale")
      return { ...o, pics: [r], compiled: "", inputs: this.studio.editInputs(e, i, null), settings: { label: Ece(i, this.studio.valueOfKey(e, "scale")) } };
    if (e === "removebg")
      return { ...o, count: 1, pics: [r], compiled: "", inputs: this.studio.editInputs(e, i, null), settings: { label: "" } };
    if (e === "replacebg") {
      const a = this.refItem(this.t.background.refId), l = this.t.background.words;
      return {
        ...o,
        words: l,
        pics: a ? [r, { kind: "item", item: a, marks: !1 }] : [r],
        compiled: Sde(l, !!a),
        inputs: this.studio.editInputs(e, i, s),
        settings: { label: Pce(l) || (a ? "from a picture" : "") }
      };
    }
    if (e === "skin")
      return { ...o, pics: [r], compiled: Cde(this.t.skin), inputs: this.studio.editInputs(e, i, s), settings: { label: "", skin: { ...this.t.skin } } };
    if (e === "expand") {
      const a = this.frame();
      if (!a) return null;
      const l = Vde(a), d = this.t.resize.words, c = {
        canvasWidth: l.canvas_size[0],
        canvasHeight: l.canvas_size[1],
        imageWidth: l.original_image_size[0],
        imageHeight: l.original_image_size[1],
        imageX: l.original_image_location[0],
        imageY: l.original_image_location[1]
      }, u = { ...this.studio.editInputs(e, i, null), ...n_(i, c) };
      return {
        ...o,
        count: 1,
        words: d,
        pics: [r],
        compiled: d.trim(),
        inputs: u,
        settings: { label: Xde(this.t.resize.frameRatio, a), frame: { ...a } }
      };
    }
    if (e === "camera") {
      const a = this.t.camera, l = Xs(a.set), d = Mee(l, a.lock ? this.seed() : null), c = { ...this.studio.editInputs(e, i, null), ...n_(i, d, { rotate: /rotate|horizontal/i, vertical: /vertical/i, zoom: /zoom/i }) };
      return {
        ...o,
        count: this.studio.countOf(e),
        pics: [r],
        compiled: "",
        inputs: c,
        settings: { label: sc(l), camera: l }
      };
    }
    if (e === "relight") {
      const a = this.t.relight, l = a.rig.mode === "transfer" ? this.refItem(a.refId) : null;
      return {
        ...o,
        pics: l ? [r, { kind: "item", item: l, marks: !1 }] : [r],
        compiled: kce(a.rig),
        inputs: this.studio.editInputs(e, i, s),
        settings: { label: Sce(a.rig), rig: JSON.parse(JSON.stringify(a.rig)) }
      };
    }
    return null;
  }
  /** What stops a tool's run before its model's own checks. */
  problem(e, t = !1) {
    const i = this.stage;
    if (!i || i.status !== "done") return "Pick an image first";
    if (!this.studio.modelOf(e)) return (Ace[e] || "This") + " isn't available here yet";
    if (e === "replacebg" && !t && !this.t.background.words.trim() && !this.refItem(this.t.background.refId)) return "Say what background you want, or pick a picture of it";
    if (e === "expand") {
      const s = this.frame();
      if (!s || !r0(s)) return "Drag the frame past the picture, or pick a shape";
    }
    return e === "relight" && this.t.relight.rig.mode === "transfer" && !this.refItem(this.t.relight.refId) ? "Pick the picture whose light to copy" : null;
  }
  /** Send a model tool's run: with the prompt it puts together, or your own full prompt instead (IL-076). */
  async runTool(e, t = null) {
    const i = this.problem(e, t != null);
    if (i)
      return this.studio.say(i), !1;
    const s = this.plan(e);
    if (!s) return !1;
    const o = this.t.resize.frame, r = this.t.resize.words, a = await this.studio.run(t != null ? { ...s, compiled: t } : s);
    return a && e === "expand" && (this.t.resize.frame === o && (this.t.resize.frame = null), this.t.resize.words === r && (this.t.resize.words = "")), a;
  }
  /** Change camera's seed, kept while you nudge the sliders so a small move doesn't reshuffle the picture. */
  seed() {
    return this.t.camera.seed == null && (this.t.camera.seed = Math.floor(Math.random() * 2147483646) + 1), this.t.camera.seed;
  }
  setCamera(e) {
    this.t.camera.set = Xs({ ...this.t.camera.set, ...e });
  }
  // ---------------------------------------------------------------- Compare
  /** Compare the stage picture with another version: Split (a slider) or Toggle. */
  compare(e, t = this.t.compare ? this.t.compare.mode : "split") {
    const i = this.stage;
    if (!e || !i || e === i.id) {
      this.t.compare = null;
      return;
    }
    this.t.compare = { with: e, mode: t, at: this.t.compare ? this.t.compare.at : 0.5, other: !1 };
  }
  /** What Compare starts against: the version the stage picture was made from, else its original. */
  compareDefault() {
    const e = this.stage;
    if (!e) return null;
    if (e.parentId && this.studio.items.value.some((i) => i.id === e.parentId && i.status === "done")) return e.parentId;
    const t = this.studio.rootId.value;
    return t && t !== e.id ? t : null;
  }
  dispose() {
    this.t.guard = null;
  }
}
const Ace = {
  upscale: "Upscaling",
  removebg: "Removing backgrounds",
  replacebg: "Replacing backgrounds",
  expand: "Expand",
  skin: "Improve people",
  camera: "Change camera",
  relight: "Relight",
  erase: "Erase",
  select: "Picking objects"
};
function x_(n) {
  const e = $c(n);
  return e.look = null, e.match = { ...e.match, stats: null }, e;
}
function Pce(n) {
  const e = n.trim().split(/\s+/).filter(Boolean);
  return e.slice(0, 5).join(" ") + (e.length > 5 ? "…" : "");
}
function Ece(n, e) {
  const t = typeof e == "number" ? e : typeof e == "string" ? parseFloat(e) : NaN;
  return Number.isFinite(t) ? t + "×" : n.name;
}
var Rce = Object.defineProperty, zce = (n, e, t) => e in n ? Rce(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, bt = (n, e, t) => zce(n, typeof e != "symbol" ? e + "" : e, t);
const c0 = ["#ff3d6e", "#ffc93c", "#36d6ff", "#ffffff", "#16141f"], $ce = 0.5, ZC = ["threed", "edit", "erase", "upscale", "removebg", "replacebg", "expand", "skin", "camera", "relight", "select"], w_ = 700, tb = 1024, Dce = 1400, QC = (n) => "rd-board-studio:" + n, eI = "Your edited prompt runs instead: use Run with this prompt, or reset it";
class Oce {
  constructor(e, t) {
    bt(this, "board", e), bt(this, "sessionId", t), bt(this, "s"), bt(this, "items"), bt(this, "boardItems"), bt(this, "historySessions"), bt(this, "side"), bt(this, "video"), bt(this, "genMode"), bt(this, "stage"), bt(this, "family"), bt(this, "rootId"), bt(this, "names"), bt(this, "shown"), bt(this, "queueItems"), bt(this, "editRefItems"), bt(this, "dockModel"), bt(this, "limit"), bt(this, "session"), bt(this, "models3d"), bt(this, "model3d"), bt(this, "card"), bt(this, "tools"), bt(this, "parentOf"), bt(this, "undo", /* @__PURE__ */ new Map()), bt(this, "redo", /* @__PURE__ */ new Map()), bt(this, "newText", null), bt(this, "textBefore", ""), bt(this, "newPin", null), bt(this, "pinBefore", ""), bt(this, "noteTimer", 0), bt(this, "promptTimer", 0), bt(this, "promptBase", ""), bt(this, "keeping", []), bt(this, "dirty", /* @__PURE__ */ new Set()), bt(this, "marksTimer", 0), bt(this, "awaiting", /* @__PURE__ */ new Map()), bt(this, "flat", /* @__PURE__ */ new Map()), bt(this, "files", /* @__PURE__ */ new Map()), bt(this, "scope", L0(!0));
    const i = Uce(e.user.uid), s = {};
    for (const a of ZC) s[a] = i[a] || { modelId: "", count: 1, inputs: {} };
    this.s = /* @__PURE__ */ Xt({
      studio: "prompt",
      last: { generate: "prompt", edit: "edit" },
      modes: s,
      bar: "edit",
      areaTool: "brush",
      areaCut: !1,
      areaSize: 48,
      precision: !0,
      objects: {},
      baking: null,
      finishing: [],
      stageId: null,
      queue: [],
      editRefs: [],
      dropper: !1,
      refPulse: null,
      fullOpen: {},
      fullEdits: {},
      sessions: [],
      pinned: !1,
      columns: s8(e.user.uid),
      histShut: Gce(e.user.uid),
      peekId: null,
      cardId: null,
      marks: {},
      asks: {},
      tool: "brush",
      color: c0[0],
      opacity: $ce,
      size: 5,
      selection: [],
      editingText: null,
      editingPin: null,
      histRev: 0,
      prompt: e.promptOf(t).prompt || "",
      sending: 0,
      ghosts: [],
      three: { model: null, cam: null, backdrop: "studio", aspect: "16:9", loading: !1, keeping: null, error: null },
      note: null
    }), this.session = I(() => {
      e.docRev.value;
      const a = e.store.get(t);
      return a && a.type === "tool" ? a : null;
    }), this.video = I(() => {
      const a = this.session.value;
      return !!a && (a.kitId === "video" || a.kitId === "videoEdit");
    });
    const o = I(() => e.studioRecords.forSession(t)), r = I(() => o.value.filter((a) => a.role === "ref"));
    this.models3d = I(() => o.value.filter((a) => a.role === "model").sort((a, l) => a.createdAt - l.createdAt)), this.model3d = I(() => this.models3d.value.find((a) => a.id === this.s.three.model) || null), this.parentOf = (a) => {
      const l = this.s.ghosts.find((f) => f.id === a);
      if (l) return l.parentId;
      const d = e.studioRecords.get(a);
      if (d && d.role === "ref") return d.base && d.base !== a ? d.base : null;
      const c = e.results.get(a), u = c ? c.runId : a.includes(":") ? a.split(":")[0] : null;
      if (!u) return null;
      const p = e.studioRecords.get(qv(u));
      return p && p.role === "edit" && p.base !== a ? p.base : null;
    }, this.items = I(() => {
      e.results.rev.value, e.studioRecords.rev.value;
      const a = this.hidden(e.studioRecords.forSession(t)), l = e.results.list(t).filter((c) => __(c, a)).map((c) => this.genItem(c)), d = r.value.map((c) => k_(c));
      return [...this.s.ghosts, ...l, ...d].sort((c, u) => u.createdAt - c.createdAt);
    }), this.boardItems = I(() => {
      e.results.rev.value, e.docRev.value;
      const a = this.items.value.filter((d) => !(d.kind === "ref" && d.how === "board")), l = this.hidden(e.studioRecords.all());
      for (const d of e.store.all())
        if (!(d.type !== "tool" || d.id === t))
          for (const c of e.results.list(d.id))
            __(c, l) && a.push({ ...this.genItem(c), parentId: null, sessionId: d.id });
      return a.sort((d, c) => c.createdAt - d.createdAt);
    }), this.historySessions = I(() => {
      const a = /* @__PURE__ */ new Map();
      for (const u of this.boardItems.value) {
        const p = u.sessionId || t;
        a.set(p, (a.get(p) || 0) + 1);
      }
      const l = e.recentTools(), d = l.find((u) => u.id === t), c = l.filter((u) => u.id !== t && (a.has(u.id) || e.isPinned(u.id)));
      return [...d ? [d] : [], ...c].map((u) => ({
        id: u.id,
        name: u.name,
        icon: u.icon || "Image",
        count: a.get(u.id) || 0,
        here: u.id === t,
        pinned: e.isPinned(u.id)
      }));
    }), this.side = I(() => Q2[this.s.studio]), this.genMode = I(() => this.side.value === "generate" ? this.s.studio : this.s.last.generate), this.stage = I(() => this.items.value.find((a) => a.id === this.s.stageId) || null), this.family = I(() => rde(this.items.value, this.parentOf, this.s.stageId)), this.rootId = I(() => this.s.stageId ? IC(this.parentOf, this.s.stageId) : null), this.names = I(() => ade(this.family.value, this.rootId.value)), this.shown = I(() => {
      if (this.s.pinned) return this.pinnedItems();
      const a = this.pickedSessions();
      return a.length ? this.boardItems.value.filter((l) => a.includes(l.sessionId || t)) : this.boardItems.value;
    }), this.queueItems = I(() => {
      const a = new Map(this.items.value.map((l) => [l.id, l]));
      return this.s.queue.map((l) => a.get(l)).filter((l) => !!l);
    }), this.editRefItems = I(() => {
      const a = new Map(this.items.value.map((l) => [l.id, l]));
      return this.s.editRefs.map((l) => a.get(l)).filter((l) => !!l && l.status === "done");
    }), this.dockModel = I(() => this.modelOf(this.genMode.value)), this.limit = I(() => bo(this.dockModel.value)), this.card = I(() => (e.docRev.value, this.cardFor(this.family.value))), this.promptBase = this.s.prompt, this.tools = new Ice(this, e), this.scope.run(() => {
      $e(() => e.studioRecords.rev.value, () => this.readMarks(), { immediate: !0 }), $e(() => e.results.rev.value, () => this.landResults()), $e(() => this.s.modes, () => Hce(e.user.uid, this.s.modes), { deep: !0 }), $e(() => this.s.stageId, () => this.dropStaleEdits()), $e(() => e.promptOf(t).prompt || "", (a) => {
        const l = this.s.prompt === this.promptBase;
        this.promptBase = a, l && (this.s.prompt = a);
      }), $e(() => this.s.dropper && (this.side.value !== "edit" || !!this.tools.t.open || !this.takesRefs()), (a) => {
        a && (this.s.dropper = !1);
      });
    });
  }
  /**
   * Results no one should see as pictures: a helper run's (Select's map of a
   * picture's objects), one a Precision version stands in for, and one being
   * finished here (IL-073). Run ids are kept as "run:" and the id.
   */
  hidden(e) {
    const t = new Set(this.s.finishing);
    for (const i of e)
      i.role === "edit" && i.helper && t.add("run:" + i.runId), i.role === "ref" && i.made && i.made.from && t.add(i.made.from);
    return t;
  }
  genItem(e) {
    return {
      id: e.id,
      kind: "gen",
      url: e.url,
      w: e.w || 4,
      h: e.h || 3,
      createdAt: e.createdAt,
      parentId: this.parentOf(e.id),
      label: this.labelOf(e),
      status: e.status === "done" ? "done" : e.status === "pending" ? "pending" : "failed",
      result: e,
      asset: e.asset || null,
      runId: e.runId
    };
  }
  /**
   * A result's name here: what its person wrote (a Studios view run's prompt
   * is their words, then lines for the model, which aren't a name), else
   * what kind of run it was.
   */
  labelOf(e) {
    const t = e.runId ? this.board.studioRecords.get(qv(e.runId)) : void 0, i = t && t.role === "edit" ? t : null;
    if (i && !["edit", "draw", "comment", "threed"].includes(i.studio)) {
      const o = jg[i.studio] || "Edit", r = i.settings && typeof i.settings.label == "string" ? i.settings.label : "";
      return r ? o + " · " + r : o;
    }
    const s = Fce(e.prompt || "");
    return s ? sb(s, 7) : i ? jg[i.studio] || "Edit" : e.prompt && /^Image 1 is the image to edit/.test(e.prompt) ? "From image 1" : e.label || e.model || "Generation";
  }
  // ---------------------------------------------------------------- entering
  /**
   * Open on an image (Edit: it goes on the stage, ready to mark up, and is
   * queued as image 1 for the Generate side; its versions run under the
   * stage) or on the session alone (Generate, Prompt).
   */
  enter(e) {
    this.loadQueue(), this.s.prompt = this.board.promptOf(this.sessionId).prompt || "", this.promptBase = this.s.prompt;
    const t = e ? this.itemFor(e) : null;
    this.s.cardId = e && e.elementId ? e.elementId : null, t ? (this.s.stageId = t.id, this.limit.value && this.setQueue(lh(this.s.queue, t.id, this.limit.value).queue), this.s.studio = this.video.value ? "prompt" : this.s.last.edit) : (this.s.stageId = null, this.s.studio = "prompt", this.s.last.generate = "prompt"), this.s.editingPin = null, this.s.editingText = null, this.s.selection = [];
  }
  /** The item for a board image or a result; an image no session made comes in as a reference. */
  itemFor(e) {
    const t = this.items.value;
    if (e.resultId) return t.find((l) => l.id === e.resultId) || null;
    if (!e.elementId) return null;
    const i = this.board.store.get(e.elementId);
    if (!i || i.type !== "image") return null;
    if (i.resultId) {
      const l = t.find((d) => d.id === i.resultId);
      if (l) return l;
    }
    const s = t.find((l) => l.url === i.src);
    if (s) return s;
    const o = i.asset || this.board.assetFor(i.src), r = Pl(o), a = this.addRef({
      how: "board",
      url: i.src,
      w: r ? r.width : i.w,
      h: r ? r.height : i.h,
      label: i.label || "Board image",
      asset: o,
      source: i.resultId || null
    });
    return r || this.measureRef(a.id, i.src), a;
  }
  /** A reference whose record holds no size takes its picture's own, once it loads (IL-100). */
  measureRef(e, t) {
    hh(t).then((i) => {
      if (i.w === 4 && i.h === 3) return;
      const s = this.board.studioRecords.get(e);
      s && s.role === "ref" && (s.pw !== i.w || s.ph !== i.h) && this.board.studioRecords.patch(e, { pw: i.w, ph: i.h });
    });
  }
  // ---------------------------------------------------------------- models and settings
  /** The models a studio offers, from the board's catalog. */
  modelsFor(e) {
    const t = this.session.value;
    return xde(this.board.catalog.value, e, t ? t.kitId : null);
  }
  /** A studio's model: Prompt's is the session's; the others keep their own. */
  modelOf(e) {
    if (e === "prompt") {
      const s = this.session.value;
      return s ? this.board.modelFor(s).model : null;
    }
    const t = this.modelsFor(e), i = this.s.modes[e].modelId;
    return t.find((s) => s.id === i) || t.find((s) => DC.test(s.name)) || t[0] || null;
  }
  setModel(e, t) {
    if (e === "prompt") {
      this.board.patchTool(this.sessionId, { model: t.name, nodeDefId: t.id });
      return;
    }
    const i = this.s.modes[e];
    i.modelId !== t.id && (this.s.modes[e] = { modelId: t.id, count: i.count, inputs: {} });
  }
  /** How many a studio makes, within what its model allows. */
  countOf(e) {
    const t = this.modelOf(e), i = e === "prompt" ? this.board.promptOf(this.sessionId).n || (t ? t.numResults.def : 1) || 1 : this.s.modes[e].count;
    return t ? Math.max(t.numResults.min, Math.min(t.numResults.max, i)) : i;
  }
  setCount(e, t) {
    const i = this.modelOf(e), s = i ? Math.max(i.numResults.min, Math.min(Math.min(i.numResults.max, 8), t)) : Math.max(1, Math.min(4, t));
    e === "prompt" ? this.board.setPrompt(this.sessionId, { n: s }) : this.s.modes[e].count = s;
  }
  /** The most a studio's count goes to. */
  maxCount(e) {
    const t = this.modelOf(e);
    return t ? Math.min(t.numResults.max, 8) : 4;
  }
  /** The least it goes to: its model's least. */
  minCount(e) {
    const t = this.modelOf(e);
    return t ? Math.max(1, t.numResults.min) : 1;
  }
  /** A studio's values for its model's inputs: Prompt's are your session prompt's. */
  inputsOf(e) {
    return e === "prompt" ? { ...this.board.promptOf(this.sessionId).inputs || {} } : { ...this.s.modes[e].inputs };
  }
  /** The chips a studio shows under its words: its model's chip inputs. */
  chipsOf(e) {
    const t = this.modelOf(e);
    return t ? t.fields.filter((i) => i.placement === "chip" && i.kind !== "model") : [];
  }
  /** The chips that can be changed here (a choice, a switch or a slider), less any the run sets itself. */
  shownChips(e, t = []) {
    return this.chipsOf(e).filter((i) => !t.includes(i.key) && (i.kind === "boolean" || i.kind === "slider" || !!(i.options && i.options.length)));
  }
  /** A chip's value as the run will send it: an Edit studio's and 3D's shape follow their picture's unless you chose one. */
  valueOf(e, t) {
    const i = this.modelOf(e);
    return !i || e === "prompt" ? Pp(t, { inputs: this.inputsOf(e) }) : Pp(t, { inputs: this.editInputs(e, i, this.shapeSource(e)) });
  }
  setInput(e, t, i) {
    if (e === "prompt") {
      const s = this.board.promptOf(this.sessionId);
      this.board.setPrompt(this.sessionId, { inputs: { ...s.inputs || {}, [t]: i } });
      return;
    }
    this.s.modes[e] = { ...this.s.modes[e], inputs: { ...this.s.modes[e].inputs, [t]: i } };
  }
  // ---------------------------------------------------------------- studios
  needsImage(e) {
    return e === "edit";
  }
  canUse(e) {
    if (this.video.value && e !== "prompt") return !1;
    if (!this.needsImage(e)) return !0;
    const t = this.stage.value;
    return !!t && t.status === "done";
  }
  setStudio(e) {
    this.canUse(e) && (this.finishEditing(), this.s.studio = e, this.s.last[Q2[e]] = e, this.s.selection = [], e === "threed" && !this.s.three.model && this.models3d.value.length && (this.s.three.model = this.models3d.value[this.models3d.value.length - 1].id));
  }
  /** Generate or Edit: back to the studio last open there. Edit needs a picture. */
  setSide(e) {
    if (this.side.value !== e) {
      if (e === "edit" && this.video.value) {
        this.say("Edit changes pictures: this session makes videos");
        return;
      }
      if (e === "edit" && !this.toEdit()) {
        this.say("Make an image or bring one in first, then edit it");
        return;
      }
      this.setStudio(this.s.last[e]);
    }
  }
  /** There's something to edit: a finished picture in history. */
  canEdit() {
    return this.items.value.some((e) => e.status === "done");
  }
  /** The stage's picture, or else the newest finished one, put on the stage. */
  toEdit() {
    const e = this.stage.value;
    if (e && e.status === "done") return !0;
    const t = this.items.value.find((i) => i.status === "done");
    return t ? (this.show(t.id), !0) : !1;
  }
  // ---------------------------------------------------------------- the stage and history
  /** Any item: this session's, or another session's on the board. */
  itemById(e) {
    return this.items.value.find((t) => t.id === e) || this.boardItems.value.find((t) => t.id === e) || null;
  }
  /**
   * An item as this session has it: its own, or another session's (the Board
   * view) brought in as a reference, once, to stage, queue, mark up or edit.
   */
  bringIn(e) {
    if (e.startsWith("pin:")) return this.bringInPin(e.slice(4));
    const t = this.items.value.find((o) => o.id === e);
    if (t) return t;
    const i = this.boardItems.value.find((o) => o.id === e);
    if (!i || i.status !== "done") return null;
    const s = this.items.value.find((o) => o.kind === "ref" && o.how === "board" && o.source === e);
    return s || this.addRef({ how: "board", url: i.url, w: i.w, h: i.h, label: i.label, asset: i.asset || null, source: e });
  }
  /**
   * The result behind an item: a run's own, or the one another session's
   * picture brought in here came from (a video plays on the stage as itself,
   * not as its poster, CHAT-31). Null for an upload, a capture, a version
   * made here.
   */
  resultOf(e) {
    return e.result ? e.result : e.kind !== "ref" || !e.source ? null : (this.board.results.rev.value, this.board.results.get(e.source) || null);
  }
  /**
   * Your pinned pictures, as history's Pinned view shows them: a result the
   * board has as itself, one already brought in here as that, and any other
   * as a stand-in that comes in (bringInPin) when it's used.
   */
  pinnedItems() {
    const e = new Map(this.boardItems.value.map((i) => [i.id, i])), t = this.items.value.filter((i) => i.kind === "ref");
    return this.board.pinnedImages.value.map((i) => {
      const s = i.resultId && e.get(i.resultId) || t.find((o) => o.url === i.url);
      return s || {
        id: "pin:" + i.id,
        kind: "ref",
        how: "board",
        pin: !0,
        url: i.url,
        w: i.pw,
        h: i.ph,
        createdAt: i.createdAt,
        parentId: null,
        label: i.label,
        status: "done",
        asset: i.asset || null,
        source: i.resultId || i.url,
        sessionId: i.fromSession || void 0
      };
    });
  }
  /** A pinned picture brought into this session: as a reference from the board, once. */
  bringInPin(e) {
    const t = this.board.studioRecords.get(e);
    if (!t || t.role !== "pin") return null;
    const i = t.resultId || t.url, s = this.items.value.find((o) => o.kind === "ref" && (o.source === i || o.url === t.url));
    if (s) return s;
    if (t.resultId) {
      const o = this.items.value.find((r) => r.id === t.resultId);
      if (o) return o;
    }
    return this.addRef({ how: "board", url: t.url, w: t.pw, h: t.ph, label: t.label, asset: t.asset || null, source: i });
  }
  /** A picture brought into this session, saved on the board as a reference; the item it is here. */
  addRef(e, t = Date.now()) {
    e.how !== "board" && this.reveal();
    const i = {
      ...Qa,
      id: kt(),
      type: "studio",
      role: "ref",
      sessionId: this.sessionId,
      createdAt: t,
      how: e.how,
      url: e.url,
      pw: e.w || 4,
      ph: e.h || 3,
      label: e.label,
      asset: e.asset || null,
      source: e.source || null,
      model: e.model || null,
      camera: e.camera || null,
      shot: e.shot || null,
      ...e.base ? { base: e.base } : {},
      ...e.made ? { made: e.made } : {}
    };
    return this.board.studioRecords.put(i), k_(i);
  }
  /**
   * The name of the session an item came from. A picture brought in from the
   * board names the session whose result it copies, and none when no session
   * made it (an upload dropped on the canvas): its record is this session's.
   */
  sessionName(e) {
    var t;
    const i = e.sessionId || (e.kind === "ref" && e.how === "board" ? e.source && ((t = this.board.results.get(e.source)) == null ? void 0 : t.sessionId) || null : this.sessionId), s = i ? this.board.store.get(i) : void 0;
    return s && s.type === "tool" ? s.name : "";
  }
  /**
   * Put an item on the stage (another session's comes in first). An Edit
   * tool with a change on the stage that isn't a version yet asks first
   * (IL-073): apply it, or discard it.
   */
  show(e) {
    if (this.tools && this.s.stageId !== e && this.tools.held()) return;
    if (this.tools && this.tools.t.open && this.tools.pending() && this.s.stageId !== e) {
      this.tools.leave(() => {
        const i = this.tools.t.open;
        this.show(e), i && (this.tools.t.open = i);
      });
      return;
    }
    const t = this.bringIn(e);
    t && (this.finishEditing(), this.s.stageId = t.id, this.s.selection = [], this.s.studio === "threed" && (this.s.studio = "prompt", this.s.last.generate = "prompt"));
  }
  // ---------------------------------------------------------------- history: the board's, by session
  /** The sessions history is narrowed to, of those it lists; none is every session. */
  pickedSessions() {
    const e = this.historySessions.value;
    return this.s.sessions.filter((t) => e.some((i) => i.id === t));
  }
  /** Whether history shows every session on the board. */
  allSessions() {
    const e = this.pickedSessions();
    return !e.length || e.length === this.historySessions.value.length;
  }
  /** Add a session to the ones history shows, or take it out (the last one out is every session again). */
  toggleSession(e) {
    const t = this.pickedSessions();
    this.s.sessions = t.includes(e) ? t.filter((i) => i !== e) : [...t, e];
  }
  /** History shows this session alone; or every session, with none named. */
  onlySession(e) {
    this.s.sessions = e ? [e] : [];
  }
  /** What you make or bring in here always shows in history, whatever sessions it was narrowed to. */
  reveal() {
    const e = this.pickedSessions();
    e.length && !e.includes(this.sessionId) && (this.s.sessions = [...e, this.sessionId]);
  }
  /** History's columns, remembered for the next visit and the next board. */
  setColumns(e) {
    const t = r8(e);
    t !== this.s.columns && (this.s.columns = t, o8(this.board.user.uid, t));
  }
  // ---------------------------------------------------------------- the queue (your session prompt's pictures)
  /**
   * The session prompt's pictures, as this session's items, and then what's
   * queued beyond the model's limit (kept here, not in the prompt). A result
   * not read yet is read; a picture from elsewhere comes in as a reference.
   */
  loadQueue() {
    const e = this.modelOf("prompt"), t = this.board.promptOf(this.sessionId), i = [];
    for (const o of Kv(e, t)) {
      const r = t.assets && t.assets[o] || this.board.assetFor(o), a = this.items.value.find((c) => c.url === o || c.result && c.result.thumb === o);
      if (a) {
        i.includes(a.id) || i.push(a.id);
        continue;
      }
      const l = r && "nodeRunResult" in r ? Nce(r) : null;
      if (l) {
        i.push(l), this.board.loadRecord(l).then((c) => {
          if (c && c.sessionId === this.sessionId) return;
          const u = this.s.queue.indexOf(l);
          if (u < 0) return;
          const p = this.bringInResult(l, o, r, c), f = this.s.queue.slice();
          f[u] = p.id, this.s.queue = f;
        }).catch(() => {
        });
        continue;
      }
      const d = this.addRef({ how: "board", url: o, w: 4, h: 3, label: "Reference", asset: r });
      i.push(d.id);
    }
    const s = this.s.queue.filter((o) => !i.includes(o) && this.items.value.some((r) => r.id === o));
    this.s.queue = i.concat(s);
  }
  /** Another session's result (or one that's gone) in your prompt: a reference here, once. */
  bringInResult(e, t, i, s) {
    const o = this.items.value.find((r) => r.kind === "ref" && r.source === e);
    return o || this.addRef({ how: "board", url: t, w: s ? s.w : 4, h: s ? s.h : 3, label: s && (s.label || s.prompt) || "Reference", asset: i, source: e });
  }
  /** A new queue: the model's share of it goes into your session prompt. */
  setQueue(e) {
    this.s.queue = e;
    const t = this.modelOf("prompt");
    if (!t || !bo(t)) return;
    const i = new Map(this.items.value.map((r) => [r.id, r])), s = e.slice(0, bo(t)).map((r) => i.get(r)).filter((r) => !!r).map((r) => ({ url: r.url, asset: r.asset || this.board.assetFor(r.url) })), o = ld(t, this.board.promptOf(this.sessionId), s);
    this.board.setPrompt(this.sessionId, { ref: o.ref, inputs: o.inputs, assets: o.assets });
  }
  /** Its place in the queue (1 first), or 0; another session's item counts by its copy here. */
  queued(e) {
    const t = this.s.queue.indexOf(e);
    if (t >= 0) return t + 1;
    const i = this.items.value.find((s) => s.kind === "ref" && s.source === e);
    return i ? this.s.queue.indexOf(i.id) + 1 : 0;
  }
  /** What each slot is, where the dock's model has several image inputs (a start and an end frame). */
  slotName(e) {
    return ree(this.dockModel.value)[e] || "";
  }
  add(e) {
    if (!this.limit.value) {
      this.say(this.modelName(this.genMode.value) + " takes no images");
      return;
    }
    const t = ah(this.s.queue, e, this.limit.value);
    t.full && this.say(this.modelName(this.genMode.value) + " takes " + this.limit.value + ": remove one first"), this.setQueue(t.queue);
  }
  remove(e) {
    this.setQueue(Z2(this.s.queue, e));
  }
  toggleQueued(e) {
    if (!this.queued(e) && this.refuseVideo(e)) return;
    const t = this.bringIn(e);
    t && (this.queued(t.id) ? this.remove(t.id) : this.add(t.id));
  }
  /** The result goes into slot 1, in place of the image its run edited. */
  continueFrom(e) {
    if (!this.limit.value) {
      this.say(this.modelName(this.genMode.value) + " takes no images");
      return;
    }
    const t = this.bringIn(e);
    t && (this.setQueue(lh(this.s.queue, t.id, this.limit.value).queue), this.show(t.id), this.say("Next run starts from this"));
  }
  move(e, t) {
    const i = this.s.queue.filter((s) => s !== e);
    i.splice(Math.max(0, Math.min(t, i.length)), 0, e), this.setQueue(i);
  }
  /**
   * Pictures picked in your Library (from anywhere): references here, queued
   * as far as the model takes them, the first on the stage. Each starts a
   * history of its own; history shows the session, where they join
   * everything else.
   */
  addFromLibrary(e) {
    const t = [], i = Date.now();
    if (e.forEach((l, d) => {
      const c = this.items.value.find((u) => u.kind === "ref" && u.how === "library" && u.source === l.id || u.url === l.url);
      if (c) {
        t.push(c);
        return;
      }
      l.asset && this.board.rememberAsset(l.url, l.asset), t.push(this.addRef({
        how: "library",
        url: l.url,
        w: l.w || 4,
        h: l.h || 3,
        label: sb(l.prompt || l.label || "From your Library", 6),
        asset: l.asset || null,
        source: l.id
      }, i + d));
    }), !t.length) return;
    let s = 0, o = this.s.queue;
    if (this.limit.value) {
      for (const l of t) {
        const d = ah(o, l.id, this.limit.value);
        !d.full && d.queue !== o && s++, o = d.queue;
      }
      this.setQueue(o);
    }
    this.show(t[0].id);
    const r = t.length, a = this.modelName(this.genMode.value);
    this.limit.value ? s < r ? this.say(s ? s + " queued, the rest are in history: " + a + " takes " + this.limit.value : "The queue is full: " + (r === 1 ? "it's" : "they're") + " in history") : this.say(r === 1 ? "Brought in and queued" : "Brought in " + r + ", queued") : this.say(a + " takes no images: " + (r === 1 ? "it's" : "they're") + " in history");
  }
  /** An image from your computer: into your uploads (made a picture any browser shows), a reference here, queued. */
  async addUpload(e) {
    const t = await this.upload(e);
    t && (this.add(t.id), this.s.stageId || this.show(t.id));
  }
  /** An image from your computer on the Edit side: into your uploads, and one of the edit's references. */
  async addUploadRef(e) {
    const t = await this.upload(e);
    t && this.addEditRef(t.id);
  }
  /** A file into your uploads, as a picture brought into this session. */
  async upload(e) {
    const t = e.name.replace(/\.[a-z0-9]+$/i, "").slice(0, 40) || "Upload";
    let i, s;
    try {
      s = this.board.realRuns ? await this.board.uploadFile(e) : { url: await S_(e, tb), asset: null }, i = await hh(s.url);
    } catch (o) {
      return this.say(uh(o, e.name)), null;
    }
    return this.addRef({ how: "upload", url: s.url, w: i.w, h: i.h, label: t, asset: s.asset });
  }
  // ---------------------------------------------------------------- marks (Draw and Annotate)
  //
  // Each picture has its own marks, and they go with it when it's sent. They
  // stay editable shapes (v1 baked them into the picture), and are saved on
  // the board with the picture, for next time and for teammates.
  /** A picture's marks. */
  marksOf(e) {
    return e && this.s.marks[e.id] || cd();
  }
  /** The stage's marks, as Draw and Annotate edit them. */
  working() {
    return this.marksOf(this.stage.value);
  }
  /** The picture has marks or notes on it (they'll go with it when it's sent). */
  marked(e) {
    return Od(this.s.marks[e]);
  }
  canUndo() {
    return this.s.histRev, !!this.s.stageId && !!(this.undo.get(this.s.stageId) || []).length;
  }
  canRedo() {
    return this.s.histRev, !!this.s.stageId && !!(this.redo.get(this.s.stageId) || []).length;
  }
  /** One undo step, before a change. */
  remember(e) {
    const t = this.undo.get(e) || [];
    t.push(ud(this.s.marks[e] || cd())), t.length > 100 && t.shift(), this.undo.set(e, t), this.redo.delete(e), this.s.histRev++;
  }
  /** Set a picture's marks, to be saved on the board after a pause. */
  putMarks(e, t) {
    const i = { ...this.s.marks };
    t && Gg(t) ? i[e] = t : delete i[e], this.s.marks = i, this.changed(e);
  }
  /** Change the stage's marks: one undo step, unless `step` is false (the moves inside a gesture). */
  editMarks(e, t = !0) {
    const i = this.s.stageId;
    if (!i) return;
    t && this.remember(i);
    const s = this.marksOf(this.stage.value);
    this.putMarks(i, e({ strokes: s.strokes.slice(), pins: s.pins.slice(), ...s.area ? { area: s.area.slice() } : {} }));
  }
  /** A drag that changes marks as it goes: one undo step for all of it. */
  beginGesture() {
    this.s.stageId && this.remember(this.s.stageId);
  }
  /** The gesture changed nothing after all: its undo step goes too. */
  dropGesture() {
    const e = this.s.stageId ? this.undo.get(this.s.stageId) : null;
    e && e.length && (e.pop(), this.s.histRev++);
  }
  addStroke(e) {
    this.editMarks((t) => ({ ...t, strokes: [...t.strokes, e] }));
  }
  /** Change some marks: one undo step, unless `step` is false (inside a gesture). */
  updateStrokes(e, t, i = !0) {
    const s = new Set(e);
    this.editMarks((o) => ({ ...o, strokes: o.strokes.map((r) => s.has(r.id) ? t(r) : r) }), i);
  }
  deleteStrokes(e) {
    if (!e.length) return;
    const t = new Set(e);
    this.editMarks((i) => ({ ...i, strokes: i.strokes.filter((s) => !t.has(s.id)) })), this.s.selection = this.s.selection.filter((i) => !t.has(i)), this.s.editingText && t.has(this.s.editingText) && (this.s.editingText = null);
  }
  /** The colour for new marks; it also recolours the selection, or the block being written (as v1 did). */
  setColor(e) {
    this.s.color = e;
    const t = this.s.editingText ? [this.s.editingText] : this.s.tool === "move" ? this.s.selection : [];
    t.length && this.updateStrokes(t, (i) => ({ ...i, color: e }), !this.s.editingText);
  }
  /**
   * How solid new marks are (IL-079), and the selected ones with them (not
   * text: it stays solid). `step` false while a slider drags, after a
   * beginGesture, so the drag is one undo step.
   */
  setOpacity(e, t = !0) {
    const i = Math.round(Math.max(wC, Math.min(1, e)) * 100) / 100;
    if (this.s.opacity = i, this.s.tool !== "move") return;
    const s = this.working().strokes.filter((o) => this.s.selection.includes(o.id) && o.kind !== "text").map((o) => o.id);
    s.length && this.updateStrokes(s, (o) => ({ ...o, opacity: i }), t);
  }
  select(e) {
    this.s.selection = e;
  }
  /** Drop selected or edited marks that undo took away. */
  pruneSelection() {
    const e = new Set(this.working().strokes.map((i) => i.id));
    this.s.selection = this.s.selection.filter((i) => e.has(i)), this.s.editingText && !e.has(this.s.editingText) && (this.s.editingText = null);
    const t = new Set(this.working().pins.map((i) => i.id));
    this.s.editingPin && !t.has(this.s.editingPin) && (this.s.editingPin = null);
  }
  // ------ text blocks (Draw)
  /** A new block at `p`, open for writing. It and its first words are one undo step. */
  addText(e, t) {
    this.s.editingText && this.commitText(this.s.editingText);
    const i = { id: kt(), kind: "text", color: this.s.color, size: t, pts: [e], text: "" };
    return this.addStroke(i), this.s.selection = [], this.s.editingText = i.id, this.newText = i.id, this.textBefore = "", i;
  }
  /** Open a block for writing again: this edit is one undo step. */
  editText(e) {
    if (this.s.editingText === e) return;
    this.s.editingText && this.commitText(this.s.editingText);
    const t = this.working().strokes.find((i) => i.id === e);
    !t || t.kind !== "text" || (this.beginGesture(), this.s.editingText = e, this.s.selection = [], this.newText = null, this.textBefore = t.text || "");
  }
  setText(e, t) {
    this.updateStrokes([e], (i) => ({ ...i, text: t }), !1);
  }
  /** Leaving a block. An empty new one never happened; an emptied old one is removed (undo brings it back). */
  commitText(e) {
    this.s.editingText === e && (this.s.editingText = null);
    const t = this.working().strokes.find((o) => o.id === e), i = this.newText === e;
    if (this.newText = null, !t) return;
    const s = (t.text || "").replace(/\s+$/, "");
    if (!s.trim()) {
      i ? this.revertStep() : this.editMarks((o) => ({ ...o, strokes: o.strokes.filter((r) => r.id !== e) }), !1);
      return;
    }
    s !== t.text && this.setText(e, s), !i && s === this.textBefore && this.dropGesture();
  }
  // ------ pins (Annotate)
  addPin(e, t) {
    if (!this.s.stageId) return null;
    this.s.editingPin && this.commitPin(this.s.editingPin);
    const i = { id: kt(), x: e, y: t, text: "" };
    return this.editMarks((s) => ({ ...s, pins: [...s.pins, i] })), this.s.editingPin = i.id, this.newPin = i.id, this.pinBefore = "", i;
  }
  /** Open a pin's text: this edit is one undo step. */
  editPin(e) {
    if (this.s.editingPin === e) return;
    this.s.editingPin && this.commitPin(this.s.editingPin);
    const t = this.working().pins.find((i) => i.id === e);
    t && (this.beginGesture(), this.s.editingPin = e, this.newPin = null, this.pinBefore = t.text);
  }
  /** A pin dragged: `step` true on its first move, so the whole drag is one undo step. */
  movePin(e, t, i, s = !1) {
    this.editMarks((o) => ({ ...o, pins: o.pins.map((r) => r.id === e ? { ...r, x: t, y: i } : r) }), s);
  }
  setPinText(e, t) {
    this.editMarks((i) => ({ ...i, pins: i.pins.map((s) => s.id === e ? { ...s, text: t } : s) }), !1);
  }
  removePin(e) {
    this.editMarks((t) => ({ ...t, pins: t.pins.filter((i) => i.id !== e) })), this.s.editingPin === e && (this.s.editingPin = null), this.newPin === e && (this.newPin = null);
  }
  /** Leaving a pin's text. An empty new pin never happened; an emptied old one is removed. */
  commitPin(e) {
    this.s.editingPin === e && (this.s.editingPin = null);
    const t = this.newPin === e;
    this.newPin = null;
    const i = this.working().pins.find((s) => s.id === e);
    if (i) {
      if (!i.text.trim()) {
        t ? this.revertStep() : this.editMarks((s) => ({ ...s, pins: s.pins.filter((o) => o.id !== e) }), !1);
        return;
      }
      !t && i.text === this.pinBefore && this.dropGesture();
    }
  }
  // ------ undo, redo, clear
  /** Take the last step back as if it never happened: nothing to redo. */
  revertStep() {
    const e = this.s.stageId, t = e ? (this.undo.get(e) || []).pop() : void 0;
    !e || !t || (this.putMarks(e, t), this.s.histRev++, this.pruneSelection());
  }
  undoMark() {
    const e = this.s.stageId;
    if (!e) return;
    const t = (this.undo.get(e) || []).pop();
    if (!t) return;
    const i = this.redo.get(e) || [];
    i.push(ud(this.working())), this.redo.set(e, i), this.putMarks(e, t), this.s.histRev++, this.pruneSelection();
  }
  redoMark() {
    const e = this.s.stageId;
    if (!e) return;
    const t = (this.redo.get(e) || []).pop();
    if (!t) return;
    const i = this.undo.get(e) || [];
    i.push(ud(this.working())), this.undo.set(e, i), this.putMarks(e, t), this.s.histRev++, this.pruneSelection();
  }
  /** Clear all: every mark and note on the picture, as v1's Clear did (one undo step); its area stays. */
  clearMarks() {
    Od(this.working()) && (this.finishEditing(), this.editMarks((e) => ({ ...cd(), ...e.area ? { area: e.area } : {} })), this.s.selection = []);
  }
  // ------ the area (the bar's Edit and Erase modes)
  /** The stage picture's selected area, as its steps. */
  area() {
    return this.working().area || [];
  }
  /** Whether the stage picture has an area selected. */
  hasArea() {
    return zC(this.working());
  }
  /** One more step of the area (a brush stroke, a lasso, an object): one undo step. */
  addAreaOp(e) {
    this.editMarks((t) => ({ ...t, area: [...t.area || [], e] }));
  }
  /** The area cleared (one undo step). */
  clearArea() {
    this.area().length && this.editMarks((e) => ({ strokes: e.strokes, pins: e.pins }));
  }
  /** The bar's mode: Edit (words, and an area to keep the change in), Erase, or Annotate (marks and notes). */
  setBar(e) {
    this.s.bar !== e && (this.finishEditing(), this.s.bar = e, this.s.selection = []);
  }
  /** Close whatever is being written. */
  finishEditing() {
    this.s.editingText && this.commitText(this.s.editingText), this.s.editingPin && this.commitPin(this.s.editingPin);
  }
  // ------ kept on the board
  /** A picture's marks or words changed here: saved after a pause. */
  changed(e) {
    this.dirty.add(e), clearTimeout(this.marksTimer), this.marksTimer = window.setTimeout(() => this.saveMarks(), w_);
  }
  /** Save what changed: each picture's marks and words in its one record, or none when it has neither. */
  saveMarks() {
    clearTimeout(this.marksTimer);
    const e = this.s.editingText || this.s.editingPin ? this.s.stageId : null;
    for (const t of Array.from(this.dirty)) {
      if (t === e) continue;
      this.dirty.delete(t);
      const i = this.s.marks[t], s = (this.s.asks[t] || "").trim() ? this.s.asks[t] : "", o = R2(t), r = this.board.studioRecords.get(o);
      if (!Gg(i) && !s) {
        r && this.board.studioRecords.remove([o]);
        continue;
      }
      const a = {
        ...Qa,
        id: o,
        type: "studio",
        role: "marks",
        sessionId: this.sessionId,
        target: t,
        marks: i ? ud(i) : cd(),
        ask: s,
        createdAt: r ? r.createdAt : Date.now()
      };
      this.board.studioRecords.put(a);
    }
    this.dirty.size && (this.marksTimer = window.setTimeout(() => this.saveMarks(), w_));
  }
  /** Marks and words saved on the board, for every picture you aren't changing here. */
  readMarks() {
    const e = {}, t = {};
    for (const a of this.board.studioRecords.forSession(this.sessionId))
      a.role === "marks" && (Gg(a.marks) && (e[a.target] = a.marks), a.ask && (t[a.target] = a.ask));
    const i = { ...this.s.marks }, s = { ...this.s.asks };
    let o = !1;
    const r = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t), ...Object.keys(this.s.marks), ...Object.keys(this.s.asks)]);
    for (const a of r) {
      if (this.dirty.has(a)) continue;
      const l = e[a], d = this.s.marks[a];
      l && (!d || !mde(l, d)) ? (i[a] = ud(l), o = !0) : !l && d && (delete i[a], o = !0), (t[a] || "") !== (this.s.asks[a] || "") && (t[a] ? s[a] = t[a] : delete s[a], o = !0);
    }
    o && (this.s.marks = i, this.s.asks = s, this.pruneSelection());
  }
  // ---------------------------------------------------------------- 3D
  /** A model file from your computer: kept in your Library where the host can, and shown. */
  async addModelFile(e) {
    const t = (e.name.split(".").pop() || "").toLowerCase();
    if (!["glb", "gltf", "obj", "stl"].includes(t)) {
      this.say(e.name + " isn't a model the 3D studio reads: use .glb, .gltf, .obj or .stl");
      return;
    }
    this.s.three.loading = !0, this.s.three.error = null;
    let i = "", s = null;
    const o = this.board.upload3d(e);
    try {
      if (o) {
        this.keeping.push(e.name), this.s.three.keeping = e.name;
        const a = await o;
        i = a.url, s = a.upload ? { upload: a.upload } : null;
      } else
        i = URL.createObjectURL(e);
    } catch (a) {
      this.keeping.length <= 1 && (this.s.three.loading = !1), this.say(uh(a, e.name));
      return;
    } finally {
      o && (this.keeping.splice(this.keeping.indexOf(e.name), 1), this.s.three.keeping = this.keeping.length ? this.keeping[this.keeping.length - 1] : null);
    }
    const r = this.addModel({ name: e.name, url: i, ext: t, asset: s });
    this.files.set(r.id, e);
  }
  /** A 3D model picked in your Library. */
  addModelFromLibrary(e) {
    if (!e.model3d) return;
    const t = this.models3d.value.find((i) => i.url === e.model3d.url);
    if (t) {
      this.useModel(t.id);
      return;
    }
    this.addModel({ name: e.label || "Model", url: e.model3d.url, ext: e.model3d.ext, asset: e.asset || null });
  }
  /** Bonneville Tower's massing, built in the viewer: a model to try the studio with. */
  addSample() {
    const e = this.models3d.value.find((t) => t.url === ib);
    if (e) {
      this.s.three.model = e.id;
      return;
    }
    this.addModel({ name: "Bonneville massing", url: ib, ext: "obj", asset: null });
  }
  addModel(e) {
    const t = {
      ...Qa,
      id: kt(),
      type: "studio",
      role: "model",
      sessionId: this.sessionId,
      createdAt: Date.now(),
      name: e.name,
      url: e.url,
      ext: e.ext,
      asset: e.asset,
      cameras: []
    };
    return this.board.studioRecords.put(t), this.s.three.model = t.id, this.s.three.cam = null, t;
  }
  /** The model's file, for the viewer: picked this visit, or read from where it's kept. */
  async modelFile(e) {
    const t = this.files.get(e.id);
    if (t) return t;
    if (e.url === ib) return new Blob([AC()], { type: "text/plain" });
    const i = await fetch(e.url, { mode: "cors" }).catch(() => null);
    if (!i || !i.ok) throw new Error("This model's file couldn't be read. Bring it in again.");
    return i.blob();
  }
  useModel(e) {
    this.s.three.model !== e && (this.s.three.model = e, this.s.three.cam = null, this.s.three.error = null);
  }
  saveCamera() {
    const e = this.model3d.value, t = this.s.three.cam;
    if (!e || !t) return null;
    const i = { id: kt(), name: "View " + (e.cameras.length + 1), cam: { ...t } };
    return this.board.studioRecords.patch(e.id, { cameras: [...e.cameras, i] }), i;
  }
  renameCamera(e, t) {
    const i = this.model3d.value;
    i && this.board.studioRecords.patch(i.id, { cameras: i.cameras.map((s) => s.id === e ? { ...s, name: t.trim() || s.name } : s) });
  }
  removeCamera(e) {
    const t = this.model3d.value;
    t && this.board.studioRecords.patch(t.id, { cameras: t.cameras.filter((i) => i.id !== e) });
  }
  /** A captured view's shape, width over height (the viewfinder's). */
  captureRatio() {
    const [e, t] = this.s.three.aspect.split(":").map(Number);
    return e > 0 && t > 0 ? e / t : 1;
  }
  /**
   * A 3D view captured as a picture: kept with your uploads, in history (a
   * history of its own), on the stage, and in the queue (at the end, or as
   * image 1 when it's what the run will start from). The same frame captured
   * a moment ago is used again rather than captured twice.
   */
  async captureView(e, t = !1) {
    const i = this.model3d.value, s = this.s.three.cam;
    if (!i || !s) return null;
    const o = JSON.stringify({ m: i.id, cam: u0(s), b: this.s.three.backdrop, a: this.s.three.aspect }), r = this.items.value.find((p) => p.kind === "ref" && p.how === "threed" && p.shot === o);
    if (r)
      return t ? this.setQueue(lh(this.s.queue, r.id, this.limit.value).queue) : this.queued(r.id) || this.setQueue(ah(this.s.queue, r.id, this.limit.value).queue), this.s.stageId = r.id, this.say("Using this view, already captured" + (this.queued(r.id) ? " as image " + this.queued(r.id) : "")), r;
    const a = new File([e.blob], "view.png", { type: "image/png" });
    let l;
    try {
      l = this.board.realRuns ? await this.board.uploadFile(a) : { url: await S_(a, tb), asset: null };
    } catch (p) {
      return this.say(uh(p, "The view")), null;
    }
    const d = i.cameras.find((p) => Lce(p.cam, s)) || null, c = this.items.value.filter((p) => p.kind === "ref" && p.how === "threed").length + 1, u = this.addRef({
      how: "threed",
      url: l.url,
      w: e.w,
      h: e.h,
      label: d ? d.name : "View " + c,
      asset: l.asset,
      model: i.id,
      camera: d || { id: kt(), name: "View " + c, cam: { ...s } },
      shot: o
    });
    if (!this.limit.value)
      this.say("Captured. " + this.modelName(this.genMode.value) + " takes no images");
    else {
      const p = t ? lh(this.s.queue, u.id, this.limit.value) : ah(this.s.queue, u.id, this.limit.value);
      this.setQueue(p.queue), this.say(p.full ? "Captured. The queue is full" : "Captured as image " + (p.queue.indexOf(u.id) + 1));
    }
    return this.s.stageId = u.id, u;
  }
  // ---------------------------------------------------------------- what's sent
  /** The prompt the model gets: your words, then which image is which, then the notes by image and marker. */
  compileFor(e, t) {
    const i = [], s = t.trim();
    return s && i.push(s), e.length && i.push(e.length === 1 ? "Image 1 is the image to edit." : "Image 1 is the image to edit; the others are references."), i.push(...this.notesFor(e.map((o, r) => ({ it: o, n: r + 1 })))), i.join(`
`);
  }
  /** What to follow on the pictures sent, then each note by marker: `n` is the image each is sent as (a guide copy can come between). */
  notesFor(e) {
    const t = [], i = e.length === 1, s = e.some(({ it: a }) => this.marksOf(a).pins.some((l) => l.text.trim())), o = e.some(({ it: a }) => this.marksOf(a).strokes.length > 0), r = i ? "image" : "images";
    if (s || o) {
      const a = s && o ? "the numbered annotations and the annotations drawn on the " + r : s ? "the numbered annotations on the " + r : "the annotations drawn on the " + r;
      t.push("Follow " + a + ", then remove every annotation from the result.");
    }
    for (const { it: a, n: l } of e)
      this.marksOf(a).pins.forEach((d, c) => {
        d.text.trim() && t.push((i ? "Annotation " : "Image " + l + ", annotation ") + (c + 1) + ": " + d.text.trim());
      });
    return t;
  }
  /** The queue's images the dock's model takes, image 1 first. */
  sentFromQueue() {
    return this.queueItems.value.slice(0, lde(this.s.queue, this.limit.value)).filter((e) => e.status === "done");
  }
  /** What goes with the queue's images: per image, how many marks and notes. */
  sending() {
    return this.sentFromQueue().map((e, t) => ({ image: t + 1, ...this.carried(e) })).filter((e) => e.marks || e.comments);
  }
  /** A picture's marks and notes, counted. */
  carried(e) {
    const t = this.marksOf(e);
    return { marks: t.strokes.length, comments: t.pins.filter((i) => i.text.trim()).length };
  }
  // ------ the Edit side's runs, in one shape (IL-073)
  /** What the bar sends: Erase on an eraser where the board has one, else an edit. */
  barKind() {
    if (this.s.bar !== "erase") return "edit";
    const e = this.modelOf("erase");
    return e && kl(e) ? "erase" : "edit";
  }
  /** The bar's run, by its mode: words and the area (Edit), the area alone (Erase), marks and notes (Annotate). */
  barPlan() {
    const e = this.stage.value;
    if (!e || e.status !== "done") return null;
    const t = this.askOf(e.id), i = this.s.bar === "annotate" ? [] : this.area(), s = o_(i);
    if (this.s.bar === "erase") {
      const b = this.modelOf("erase");
      if (b && kl(b)) {
        const w = OC(b);
        return {
          kind: "erase",
          model: b,
          pics: [{ kind: "item", item: e, marks: !1 }],
          words: "",
          compiled: "",
          inputs: this.editInputs("erase", b, { w: e.w, h: e.h }),
          count: this.countOf("erase"),
          base: e.id,
          mask: s ? { field: w.key, make: () => this.areaCanvas(e, i) } : null,
          settings: { label: "" }
        };
      }
    }
    const o = this.modelOf("edit");
    if (!o) return null;
    const r = this.s.bar === "erase", a = this.editInputs("edit", o, { w: e.w, h: e.h }), l = r ? 1 : this.countOf("edit"), d = this.sentRefs(), c = d.map((b) => ({ kind: "item", item: b, marks: !0 }));
    if (!s)
      return {
        kind: "edit",
        model: o,
        pics: [{ kind: "item", item: e, marks: !0 }, ...c],
        words: t,
        compiled: this.compileFor([e, ...d], t),
        inputs: a,
        count: l,
        base: e.id
      };
    const u = bo(o) >= 2, p = u ? [{ kind: "item", item: e, marks: !0 }, { kind: "made", name: "area", make: () => this.guideCanvas(e, i) }, ...c] : [{ kind: "made", name: "area", make: () => this.guideCanvas(e, i) }], f = [kde(t, { erase: r, guide: u })];
    u && (f.push(...this.notesFor([{ it: e, n: 1 }, ...d.map((b, w) => ({ it: b, n: w + 3 }))])), d.length && f.push(_de(3, d.length)));
    const y = r || this.s.precision;
    return {
      kind: r ? "erase" : "edit",
      model: o,
      pics: p,
      words: r ? "" : t,
      compiled: f.join(`
`),
      inputs: a,
      count: l,
      base: e.id,
      precision: y ? { area: i.map((b) => ({ ...b })) } : null,
      settings: r ? { label: "" } : null
    };
  }
  // ------ the full prompt (IL-076): what a run puts together, to see and change
  /** The prompt a run puts together, as its model gets it: your words, then which picture is which, then the notes. */
  fullPromptOf(e) {
    if (e === "prompt" || e === "threed") return this.compileFor(this.sentFromQueue(), this.s.prompt);
    const t = this.planFor(e);
    return t ? t.compiled : "";
  }
  /** Your change to a run's full prompt, while it holds: for the picture it was written on (the dock's for the session). */
  fullEdit(e) {
    const t = this.s.fullEdits[e];
    return t && t.on === this.fullScope(e) ? t.text : null;
  }
  /** Whether the prompt the run puts together has changed since you began changing yours. */
  fullDrifted(e) {
    const t = this.s.fullEdits[e];
    return !!t && t.on === this.fullScope(e) && t.from !== this.fullPromptOf(e);
  }
  /** Change a run's full prompt; back to just what the run puts together, it's yours no longer. */
  setFullEdit(e, t) {
    const i = this.fullPromptOf(e), s = this.s.fullEdits[e], o = { ...this.s.fullEdits };
    t === i ? delete o[e] : o[e] = { text: t, on: this.fullScope(e), from: s && s.on === this.fullScope(e) ? s.from : i }, this.s.fullEdits = o;
  }
  /** Back to the prompt the run puts together. */
  resetFullEdit(e) {
    if (!this.s.fullEdits[e]) return;
    const t = { ...this.s.fullEdits };
    delete t[e], this.s.fullEdits = t;
  }
  setFullOpen(e, t) {
    this.s.fullOpen = { ...this.s.fullOpen, [e]: t };
  }
  /** Your full prompt runs instead of the run's own: it's open, and you've changed it. Then the run's own button rests. */
  fullTakesOver(e) {
    return !!this.s.fullOpen[e] && this.fullEdit(e) != null;
  }
  /** What stops a run with your own full prompt: none written, what a tool needs besides words (Expand's frame), then the model's checks. */
  fullProblem(e, t) {
    if (!t.trim()) return "Write the prompt first";
    const i = this.stage.value;
    if (Ug(e) && (!i || i.status !== "done")) return "Pick an image to edit first";
    if (e !== "edit" && e !== "erase" && Ug(e)) {
      const s = this.tools.problem(e, !0);
      if (s) return s;
    }
    return this.checkOf(e, t).problem;
  }
  fullScope(e) {
    return e === "prompt" || e === "threed" ? null : this.s.stageId;
  }
  /** A change written for another picture than the one on the stage goes. */
  dropStaleEdits() {
    const e = { ...this.s.fullEdits };
    let t = !1;
    for (const i of Object.keys(e)) {
      const s = e[i];
      s && s.on !== this.fullScope(i) && (delete e[i], t = !0);
    }
    t && (this.s.fullEdits = e);
  }
  // ------ the bar's references (IL-075)
  /** Whether the bar's run takes references: an edit on a model that reads more than one picture (the eraser reads one, and a mask). */
  takesRefs() {
    if (this.barKind() === "erase") return !1;
    const e = this.modelOf("edit");
    return !!e && bo(e) >= 2;
  }
  /** How many references the bar's run sends: its model's pictures, less the one it edits and an area's guide copy. */
  refRoom() {
    const e = this.modelOf("edit");
    if (!e || !this.takesRefs()) return 0;
    const t = this.s.bar !== "annotate" && o_(this.area());
    return Math.max(0, bo(e) - 1 - (t ? 1 : 0));
  }
  /** The references the bar's run sends: as many as its model has room for, never the picture on the stage itself. */
  sentRefs() {
    const e = this.stage.value;
    return this.editRefItems.value.filter((t) => !e || t.id !== e.id).slice(0, this.refRoom());
  }
  /** Whether a reference goes with the next run (one past the model's room, or on the stage, waits). */
  refSent(e) {
    return this.sentRefs().some((t) => t.id === e);
  }
  /**
   * A picture as one of the edit's references: from history (another
   * session's comes in first), a version, the slot's picker or an upload.
   * One already there isn't added twice; its tile pulses instead.
   */
  addEditRef(e) {
    const t = this.bringIn(e);
    if (!t || t.status !== "done") return "none";
    const i = this.stage.value;
    if (i && t.id === i.id)
      return this.say("That's the picture you're editing"), "stage";
    if (this.s.editRefs.includes(t.id))
      return this.pulseRef(t.id), "have";
    if (!this.takesRefs())
      return this.say(this.refsRefused()), "none";
    const s = this.refRoom();
    return this.editRefItems.value.filter((r) => !i || r.id !== i.id).length >= s ? (this.say(s ? this.modelName("edit") + " takes " + s + (s === 1 ? " reference" : " references") + " here: remove one first" : "No room for a reference while an area is selected"), "full") : (this.s.editRefs = [...this.s.editRefs, t.id], this.pulseRef(t.id), "added");
  }
  /**
   * A picture by its address, from the slot's picker (a pinned picture, the
   * board's, your Library's, an upload): the one here already, else brought in.
   */
  async addEditRefUrl(e) {
    const t = this.items.value.find((o) => o.url === e && o.status === "done") || this.boardItems.value.find((o) => o.url === e && o.status === "done");
    if (t) return this.addEditRef(t.id) === "added";
    const i = await Promise.race([hh(e), new Promise((o) => window.setTimeout(() => o({ w: 4, h: 3 }), 2500))]), s = this.addRef({ how: this.howPicked(e), url: e, w: i.w, h: i.h, label: "Reference", asset: this.board.assetFor(e) });
    return this.addEditRef(s.id) === "added";
  }
  /**
   * How a picture picked by its address came in: from the board when it's
   * there (a picture on it, or one you've pinned), which history leaves to
   * where it is; else as its record says, an upload or a Library generation,
   * which history shows, as nothing else does.
   */
  howPicked(e) {
    if (this.board.isPinnedImage(e)) return "board";
    for (const i of this.board.store.all()) if (i.type === "image" && i.src === e) return "board";
    const t = this.board.assetFor(e);
    return t && "nodeRunResult" in t ? "library" : "upload";
  }
  /**
   * A picture dropped on Generate's queue, from history or a version
   * (CHAT-06), as the Edit bar takes one: brought in, and queued.
   */
  queueItem(e) {
    if (this.refuseVideo(e)) return;
    const t = this.bringIn(e);
    t && !this.queued(t.id) && this.add(t.id);
  }
  /**
   * The queue holds pictures (a Video Edit model's video is the one on the
   * session's card): a video dragged onto it, or added from its preview, is
   * turned away, rather than sent as an image input.
   */
  refuseVideo(e) {
    const t = this.items.value.find((s) => s.id === e) || this.boardItems.value.find((s) => s.id === e), i = t ? this.resultOf(t) : null;
    return !i || !(i.video || i.kind === "video") ? !1 : (this.say("The queue takes pictures, not videos"), !0);
  }
  /** A picture by its address, from the queue's picker (a pinned picture, the board's, your Library's, an upload): queued. */
  async queueUrl(e) {
    const t = this.items.value.find((o) => o.url === e && o.status === "done") || this.boardItems.value.find((o) => o.url === e && o.status === "done");
    if (t) {
      this.queueItem(t.id);
      return;
    }
    const i = await Promise.race([hh(e), new Promise((o) => window.setTimeout(() => o({ w: 4, h: 3 }), 2500))]), s = this.addRef({ how: this.howPicked(e), url: e, w: i.w, h: i.h, label: "Reference", asset: this.board.assetFor(e) });
    this.queued(s.id) || this.add(s.id);
  }
  removeEditRef(e) {
    this.s.editRefs = this.s.editRefs.filter((t) => t !== e);
  }
  /** Why the bar takes no references right now. */
  refsRefused() {
    return this.barKind() === "erase" ? "Erase takes no references" : this.modelName("edit") + " takes one picture: the one you're editing";
  }
  pulseRef(e) {
    const t = (this.s.refPulse ? this.s.refPulse.n : 0) + 1;
    this.s.refPulse = { id: e, n: t }, window.setTimeout(() => {
      this.s.refPulse && this.s.refPulse.n === t && (this.s.refPulse = null);
    }, 900);
  }
  /** The bar's eyedropper, on or off: on, a click on a picture in history (or a version) makes it a reference. */
  setDropper(e) {
    if (e && !this.takesRefs()) {
      this.say(this.refsRefused());
      return;
    }
    this.s.dropper = e, e && this.s.histShut && this.setHistShut(!1);
  }
  /** Fold history down to a slim rail (the stage takes the room), or bring it back; remembered for next time. */
  setHistShut(e) {
    this.s.histShut !== e && (this.s.histShut = e, jce(this.board.user.uid, e));
  }
  /** A pick with the eyedropper: the picture becomes a reference and the eyedropper goes (it stays for another try on the picture being edited). */
  dropperPick(e) {
    this.addEditRef(e) !== "stage" && (this.s.dropper = !1);
  }
  /** What stops the bar's run before the model's own checks: nothing to send yet, or no area to erase. */
  barProblem() {
    const e = this.stage.value;
    if (!e || e.status !== "done") return "Pick an image to edit first";
    const t = this.askOf(e.id).trim(), i = Od(this.marksOf(e));
    return this.s.bar === "erase" ? this.hasArea() ? null : "Paint over what should go first" : this.s.bar === "edit" && this.hasArea() && !t ? "Say what to change in the area" : !t && !i ? this.s.bar === "annotate" ? "Annotate the image, or say what to change" : "Say what to change, or select an area" : null;
  }
  /** A run's plan: the bar's or a tool's. */
  planFor(e) {
    return e === "edit" || e === "erase" ? this.barPlan() : this.tools.plan(e);
  }
  /** A plan's prompt state before anything is made or uploaded: stand-ins for what's still to make. */
  previewOf(e) {
    const t = e.pics.map((s, o) => s.kind === "item" ? { url: s.item.url, asset: s.item.asset || null } : { url: "made:" + o + ":" + s.name, asset: null }), i = ld(e.model, { prompt: e.compiled, ...nb(e.ref), inputs: e.inputs, n: e.count }, t);
    return e.mask ? { ...i, masks: { [e.mask.field]: { boardMask: "pending" } } } : i;
  }
  /** The area as a mask the picture's size (capped), white where it is. */
  async areaCanvas(e, t) {
    const i = il(e.w, e.h, 4096);
    return ap(t, i.w, i.h, await this.mapsFor(t));
  }
  /** The picture with the area marked in magenta, for a model that reads pictures, not masks. */
  async guideCanvas(e, t) {
    const i = await oi(e.url), s = il(i.width, i.height, 2048);
    return Lde(i, ap(t, s.w, s.h, await this.mapsFor(t)));
  }
  /** The segment maps an area's picked objects come from, read. */
  async mapsFor(e) {
    const t = /* @__PURE__ */ new Map();
    for (const i of UC(e)) t.set(i, await rf(i));
    return t;
  }
  modelName(e) {
    const t = this.modelOf(e);
    return t ? t.name : "This model";
  }
  /** A run's words, pictures and settings as the model's form has them (before marks are flattened and masks made). */
  previewUp(e, t = null) {
    if (Ug(e)) {
      const a = this.planFor(e);
      if (a) return { model: a.model, count: a.count, up: this.previewOf(t != null ? { ...a, compiled: t } : a) };
      const l = this.modelOf(e);
      if (!l) return null;
      const d = this.countOf(e), c = this.stage.value, u = c ? [{ url: c.url, asset: c.asset || null }] : [];
      return { model: l, count: d, up: ld(l, { prompt: "", inputs: this.editInputs(e, l, c ? { w: c.w, h: c.h } : null), n: d }, u) };
    }
    const i = this.modelOf(e);
    if (!i) return null;
    const s = this.countOf(e), o = this.sentFromQueue(), r = o.map((a) => ({ url: a.url, asset: a.asset || null }));
    return { model: i, count: s, up: ld(i, { prompt: t != null ? t : this.compileFor(o, this.s.prompt), ...nb(this.ownRef(e, i)), inputs: this.inputsOf(e), n: s }, r) };
  }
  /**
   * The sizes an Edit run can be made at, keeping its picture's shape
   * (TD-10): Nano Banana Pro's 1K, 2K and 4K. The bar hides the shape chip,
   * so this is where the size is chosen.
   */
  tiersOf(e) {
    const t = this.modelOf(e), i = e === "prompt" ? null : this.shapeSource(e);
    return t && i ? aC(t, i.w, i.h) : [];
  }
  tierOf(e) {
    return e === "prompt" ? 0 : this.s.modes[e].tier || 0;
  }
  setTier(e, t) {
    e !== "prompt" && (this.s.modes[e] = { ...this.s.modes[e], tier: t });
  }
  /** A model's settings that aren't chips (the bar's More settings, TD-10): what ModelFields lays out under More. */
  advancedOf(e) {
    const t = this.modelOf(e);
    return t ? t.fields.filter((i) => i.placement === "advanced" && i.kind !== "seed" && i.kind !== "header" && i.kind !== "model" && i.kind !== "video") : [];
  }
  /** The shape a studio's result keeps: an Edit studio's picture's, 3D's frame's. */
  shapeSource(e) {
    if (e === "threed") return { w: Math.round(1e3 * this.captureRatio()), h: 1e3 };
    const t = this.stage.value;
    return t ? { w: t.w, h: t.h } : null;
  }
  /** A field's value by what it is (the tools read their model's scale this way). */
  valueOfKey(e, t) {
    const i = this.modelOf(e);
    if (!i) return;
    const s = i.fields.find((o) => o.raw && o.raw.boardKey === t || o.key === t || o.label.toLowerCase().includes(t));
    return s ? this.valueOf(e, s) : void 0;
  }
  /** An Edit run's or 3D's inputs: its own, with the shape kept to its picture's (at the size you chose) unless you chose one. */
  editInputs(e, t, i) {
    const s = this.inputsOf(e), o = i ? hee(t, i.w, i.h, this.tierOf(e)) : null;
    return o && s[o.key] === void 0 && (s[o.key] = o.value), s;
  }
  /** What stops a studio's run, in v1's words; null when it can go. */
  problemOf(e) {
    return this.checkOf(e).problem;
  }
  /** What stops a studio's run, and whether it's only the tokens it costs (Run then offers to get more, as the board's does). */
  checkOf(e, t = null) {
    const i = this.previewUp(e, t);
    if (!i) return { problem: "No model is available for this.", tokens: !1 };
    const s = Li(i.model, i.up, i.count, !!this.board.user.isAdmin);
    if (s.problems[0]) return { problem: s.problems[0], tokens: !1 };
    const o = this.board.tokensProblem(s.price);
    return { problem: o || null, tokens: !!o };
  }
  /** A studio's run's cost, as the board writes tokens. */
  priceOf(e) {
    const t = this.previewUp(e);
    if (!t) return "";
    const i = Li(t.model, t.up, t.count, !!this.board.user.isAdmin);
    return i.price != null ? hl(i.price) : w6(t.model, t.count);
  }
  // ------ what you ask an Edit studio to change, kept with the picture
  askOf(e) {
    return e && this.s.asks[e] || "";
  }
  setAsk(e, t) {
    const i = { ...this.s.asks };
    t ? i[e] = t : delete i[e], this.s.asks = i, this.changed(e);
  }
  // ------ the dock's words: your session prompt's
  setPrompt(e) {
    this.s.prompt = e, clearTimeout(this.promptTimer), this.promptTimer = window.setTimeout(() => this.commitPrompt(), 450);
  }
  commitPrompt() {
    clearTimeout(this.promptTimer), this.s.prompt !== this.promptBase && (this.promptBase = this.s.prompt, (this.board.promptOf(this.sessionId).prompt || "") !== this.s.prompt && this.board.setPrompt(this.sessionId, { prompt: this.s.prompt }));
  }
  // ------ runs
  /** Runs of yours in flight from here: being got ready, or sent and not all back. */
  busy() {
    return this.s.sending > 0 || this.items.value.some((e) => e.status === "pending" && !!e.runId && this.awaiting.has(e.runId));
  }
  /**
   * The dock's run (the Generate side): the queue, image 1 first, and the
   * words, on the open studio's model. Generate makes new images, each the
   * start of a history of its own; history shows the session.
   */
  async generate(e = null) {
    this.commitPrompt(), this.finishEditing();
    const t = this.genMode.value, i = this.modelOf(t);
    if (!i)
      return this.say("No model is available for this session"), !1;
    const s = this.sentFromQueue(), o = this.s.prompt, r = t === "threed" ? this.editInputs(t, i, s[0] ? { w: s[0].w, h: s[0].h } : this.shapeSource(t)) : this.inputsOf(t);
    return this.run({
      kind: t,
      model: i,
      pics: s.map((a) => ({ kind: "item", item: a, marks: !0 })),
      words: o,
      compiled: e != null ? e : this.compileFor(s, o),
      inputs: r,
      count: this.countOf(t),
      base: null,
      ref: this.ownRef(t, i)
    });
  }
  /**
   * Your session's own first input, sent as it is, where Prompt's model's
   * first input isn't a picture (a Video Edit model's video: the queue holds
   * pictures, so the video is the one set on the session's card), with its
   * record, so a run sends it as it is. Null otherwise: the queue's pictures
   * fill a picture input.
   */
  ownRef(e, t) {
    if (e !== "prompt") return null;
    const i = t.fields.find((o) => o.placement === "reference");
    if (!i || Ys(t).includes(i)) return null;
    const s = this.board.promptOf(this.sessionId);
    return s.ref ? { url: s.ref, asset: s.assets && s.assets[s.ref] || this.board.assetFor(s.ref) } : null;
  }
  /**
   * The bar's run (IL-073): the picture on the stage, by the bar's mode (its
   * words and area, its area to erase, its marks and notes), on the bar's
   * model. Its results are the picture's next versions, in its history; the
   * first takes the stage. Your own full prompt (IL-076) goes instead of the
   * one the bar puts together, and is all it needs to go.
   */
  async generateEdit(e = null) {
    const t = this.stage.value;
    if (!t || t.status !== "done")
      return this.say("Pick an image to edit first"), !1;
    this.finishEditing();
    const i = e != null ? null : this.barProblem();
    if (i)
      return this.say(i), !1;
    const s = this.barPlan();
    return s ? this.run(e != null ? { ...s, compiled: e } : s) : (this.say("No model is available for this"), !1);
  }
  /**
   * Get a run ready and send it: stand-ins in history at once, marked
   * pictures flattened, pictures and a mask made here uploaded, then the
   * board's run path. Its first result takes the stage when it lands, unless
   * you've moved on; a Precision edit's is put back inside its area first.
   */
  async run(e) {
    const t = Li(e.model, this.previewOf(e), e.count, !!this.board.user.isAdmin), i = t.problems[0] || this.board.tokensProblem(t.price);
    if (i)
      return this.say(i.replace(/\.$/, "")), !1;
    this.reveal();
    const s = Date.now(), o = [], r = e.base && this.items.value.find((d) => d.id === e.base) || null;
    if (!e.helper) {
      const d = sb(e.words, 5) || e.settings && typeof e.settings.label == "string" && e.settings.label || jg[e.kind] || "New image";
      for (let c = 0; c < e.count; c++)
        o.push({
          id: "sending:" + kt(),
          kind: "gen",
          url: "",
          w: r ? r.w : 4,
          h: r ? r.h : 3,
          createdAt: s + c,
          parentId: e.base,
          label: d,
          status: "pending"
        });
    }
    this.s.ghosts = [...o, ...this.s.ghosts], this.s.sending++;
    const a = this.s.stageId, l = this.draftOf(a);
    try {
      const d = [];
      for (const p of e.pics) d.push(p.kind === "item" ? await this.pictureToSend(p.item, p.marks) : await this.madeToSend(await p.make(), p.name));
      let c = ld(e.model, { prompt: e.compiled, ...nb(e.ref), inputs: e.inputs, n: e.count }, d);
      e.mask && (c = { ...c, masks: { [e.mask.field]: await this.maskToSend(await e.mask.make()) } });
      const u = await this.board.runStudio({
        sessionId: this.sessionId,
        model: e.model,
        up: c,
        count: e.count,
        words: e.words,
        edit: e.base ? { base: e.base, studio: e.kind, settings: e.settings || null, helper: !!e.helper, precision: e.precision || null } : null,
        onFail: (p) => {
          e.helper && e.base && this.objectsFailed(e.base), this.say(p);
        }
      });
      return "error" in u ? (this.say(u.error.replace(/\.$/, "")), !1) : (this.awaiting.set(u.runId, { stageWas: a, base: e.base, helper: !!e.helper, precision: e.precision || null, finished: /* @__PURE__ */ new Set(), draft: l }), !0);
    } catch (d) {
      return this.say(d instanceof Error && d.message.replace(/\.$/, "") || "The run couldn't start. Please try again"), !1;
    } finally {
      this.s.sending = Math.max(0, this.s.sending - 1);
      const d = new Set(o.map((c) => c.id));
      this.s.ghosts = this.s.ghosts.filter((c) => !d.has(c.id));
    }
  }
  /**
   * A picture as a run sends it: as it is, or with its marks flattened in (by
   * v1's annotation service on a real board, by the browser in the harness).
   */
  async pictureToSend(e, t = !0) {
    const i = e.asset || this.board.assetFor(e.url), s = this.s.marks[e.id];
    if (!t || !Od(s)) return { url: e.url, asset: i };
    const o = { strokes: s.strokes, pins: s.pins }, r = e.id + ":" + JSON.stringify(o), a = this.flat.get(r);
    if (a) return a;
    let l;
    if (this.board.canAnnotate) {
      const d = await this.board.flattenPicture({ url: e.url, asset: i }, await hde(o, e.w, e.h));
      l = { url: d.url, asset: d.asset };
    } else
      l = { url: await pde(e.url, o, e.w, e.h), asset: null };
    return this.flat.set(r, l), l;
  }
  /** A picture made for a run (the area's guide): into your uploads on a real board, a small copy in the harness. */
  async madeToSend(e, t) {
    if (!this.board.realRuns) return { url: qg(e, tb, !1), asset: null };
    const i = await this.board.uploadFile(Wg(await Vg(e, !1), "board-" + t));
    return { url: i.url, asset: i.asset };
  }
  /** An area's mask for a run: kept as one of your masks on a real board (v1's inpainting masks), a stand-in in the harness. */
  async maskToSend(e) {
    return this.board.realRuns ? this.board.uploadMask(Wg(await Vg(e, !0), "board-mask")) : { boardMask: qg(e, 512, !0) };
  }
  /**
   * Runs sent from here: the first result takes the stage, unless you've
   * moved on or are writing. A helper run's result is the picture's objects;
   * a Precision edit's results are put back inside the area first.
   */
  landResults() {
    for (const [e, t] of Array.from(this.awaiting)) {
      const i = this.board.results.ofRun(e), s = i.filter((a) => a.status === "done" && !!a.url).sort((a, l) => a.createdAt - l.createdAt), o = i.some((a) => a.status === "pending");
      if (!s.length) {
        o || (this.awaiting.delete(e), t.helper && t.base && this.objectsFailed(t.base));
        continue;
      }
      if (t.helper) {
        this.awaiting.delete(e), t.base && this.objectsFound(t.base, s[0].url, e);
        continue;
      }
      if (t.precision) {
        for (const a of s)
          t.finished.has(a.id) || (t.finished.add(a.id), this.finishPrecision(a, t, t.finished.size === 1));
        o || this.awaiting.delete(e);
        continue;
      }
      this.awaiting.delete(e), !(this.s.editingText || this.s.editingPin || this.s.stageId !== t.stageWas || this.startedSince(t)) && (this.s.stageId = s[0].id, this.s.selection = []);
    }
  }
  /** A picture's words and marks (its area among them), to tell later whether they've changed. */
  draftOf(e) {
    if (!e) return "";
    const t = Object.values(this.s.fullEdits).filter((i) => !!i && i.on === e).map((i) => i.text);
    return JSON.stringify([this.s.asks[e] || "", this.s.marks[e] || null, t]);
  }
  /**
   * Whether you've started something on the picture a run went from since
   * it went: a tool's change not applied yet, or new words, marks or an
   * area. Its result then waits in history rather than take the stage (and
   * a tool's change isn't dropped without asking, as show() would ask).
   */
  startedSince(e) {
    return !!this.tools && this.tools.pending() || this.draftOf(e.stageWas) !== e.draft;
  }
  /**
   * A Precision edit's result put back inside its area, every other pixel
   * the original's, as a version of its own that stands in for the result
   * (which history then hides). If it can't be, the result shows as it came.
   */
  async finishPrecision(e, t, i) {
    const s = t.base ? this.items.value.find((a) => a.id === t.base) : null;
    if (!s || !t.precision) return;
    this.s.finishing = [...this.s.finishing, e.id];
    const o = { id: "finishing:" + e.id, kind: "gen", url: "", w: s.w, h: s.h, createdAt: e.createdAt, parentId: s.id, label: "Precision", status: "pending" };
    this.s.ghosts = [o, ...this.s.ghosts];
    const r = this.s.stageId;
    try {
      const [a, l] = await Promise.all([oi(s.url), oi(e.url)]), d = il(a.width, a.height), c = ap(t.precision.area, d.w, d.h, await this.mapsFor(t.precision.area)), u = Rde(a, l, c, Math.max(2, Math.max(d.w, d.h) * 6e-3)), p = await this.addVersion(u, { tool: "precision", label: "Precision", from: e.id }, s, { stage: !1, name: this.labelOf(e), at: e.createdAt }), f = this.s.stageId !== r && this.s.stageId !== t.stageWas;
      p && i && !f && !this.s.editingText && !this.s.editingPin && !this.startedSince(t) && (this.s.stageId = p.id);
    } catch (a) {
      console.warn("[board] a Precision edit couldn't be put back inside its area", a), this.say("The edit couldn't be kept to its area, so it shows as it came back"), i && this.s.stageId === t.stageWas && !this.startedSince(t) && (this.s.stageId = e.id);
    } finally {
      this.s.finishing = this.s.finishing.filter((a) => a !== e.id), this.s.ghosts = this.s.ghosts.filter((a) => a.id !== o.id);
    }
  }
  /**
   * A version made here by a tool (IL-073): kept in your uploads on a real
   * board (a small copy in the harness), a reference whose parent is the
   * picture it was made from, with how it was made. It takes the stage.
   */
  async addVersion(e, t, i, s = {}) {
    const o = s.alpha != null ? s.alpha : LC(e);
    let r;
    try {
      r = this.board.realRuns ? await this.board.uploadFile(Wg(await Vg(e, o), "board-" + t.tool)) : { url: qg(e, Dce, o), asset: null };
    } catch (l) {
      return this.say(uh(l, "The new version")), null;
    }
    const a = this.addRef({ how: "tool", url: r.url, w: e.width, h: e.height, label: s.name || t.label, asset: r.asset, base: i.id, made: t }, s.at);
    return s.stage !== !1 && (this.finishEditing(), this.s.stageId = a.id, this.s.selection = []), a;
  }
  // ------ a picture's objects (Select)
  /** The stage picture's objects: found already (here, or by an earlier visit's run), being found, or not yet. */
  objectsOf(e) {
    if (!e) return null;
    const t = this.s.objects[e];
    if (t) return t;
    this.board.results.rev.value;
    for (const i of this.board.studioRecords.forSession(this.sessionId)) {
      if (i.role !== "edit" || !i.helper || i.base !== e) continue;
      const s = this.board.results.ofRun(i.runId).find((o) => o.status === "done" && !!o.url);
      if (s) return { status: "ready", url: s.url, runId: i.runId };
    }
    return null;
  }
  /** Find the stage picture's objects, once: a run of the segmentation model, whose result is never shown. */
  async findObjects() {
    const e = this.stage.value;
    if (!e || e.status !== "done") return !1;
    const t = this.objectsOf(e.id);
    if (t && t.status !== "failed") return t.status === "ready";
    const i = this.modelOf("select");
    if (!i)
      return this.say("Picking objects isn't available here yet: paint or draw round the area instead"), !1;
    this.s.objects = { ...this.s.objects, [e.id]: { status: "finding" } };
    const s = await this.run({
      kind: "select",
      model: i,
      pics: [{ kind: "item", item: e, marks: !1 }],
      words: "",
      compiled: "",
      inputs: this.inputsOf("select"),
      count: 1,
      base: e.id,
      helper: !0,
      settings: { label: "Objects" }
    });
    return s || this.objectsFailed(e.id), s;
  }
  objectsFound(e, t, i) {
    this.s.objects = { ...this.s.objects, [e]: { status: "ready", url: t, runId: i } }, rf(t).catch((s) => {
      console.warn("[board] the picture's objects couldn't be read", s), this.objectsFailed(e);
    });
  }
  /** The picture's objects couldn't be found, or their map couldn't be read: Select offers to try again. */
  objectsFailed(e) {
    this.s.objects = { ...this.s.objects, [e]: { status: "failed" } };
  }
  // ---------------------------------------------------------------- Promote: which version the canvas shows
  /** A card on the canvas showing a picture from this history: the one you came in from first. */
  cardFor(e) {
    if (!e.length) return null;
    const t = (s) => e.some((o) => this.cardShows(s, o)), i = this.s.cardId ? this.board.store.get(this.s.cardId) : void 0;
    if (i && i.type === "image" && t(i)) return i;
    for (const s of this.board.store.all()) if (s.type === "image" && t(s)) return s;
    return null;
  }
  /** Whether a card shows this picture: its result, or the same picture (a reference copies another's). */
  cardShows(e, t) {
    return e.resultId && (e.resultId === t.id || e.resultId === t.source) ? !0 : !e.resultId && !!t.url && e.src === t.url;
  }
  /** The picture the card on the canvas shows now, if it's one of the stage's history. */
  onCard(e) {
    this.board.docRev.value;
    const t = this.card.value, i = this.items.value.find((s) => s.id === e);
    return !!t && !!i && this.cardShows(t, i);
  }
  /** Show this version on the canvas, in the card's place (Tyler, 2026-10-13). */
  promote(e) {
    const t = this.card.value, i = this.items.value.find((a) => a.id === e);
    if (!t || !i || i.status !== "done" || this.cardShows(t, i)) return;
    const s = i.kind === "gen" ? i.id : i.how === "board" && i.source ? i.source : null, o = s ? this.board.results.get(s) : void 0;
    this.board.showOnCard(t.id, {
      url: i.url,
      w: i.w,
      h: i.h,
      label: i.label,
      resultId: s,
      sessionId: i.kind === "gen" ? this.sessionId : t.sessionId || null,
      asset: i.asset || null,
      fav: o ? !!o.fav : !1
    }) && this.say((this.names.value.get(e) || "This version") + " is on the board now");
  }
  // ---------------------------------------------------------------- info and the board
  /** The board's info view, over the Studios view, for a generation (this session's, or another's on the board). */
  openInfo(e) {
    const t = this.itemById(e);
    if (!t || t.kind !== "gen" || t.status !== "done") return !1;
    const i = this.board.placedFor(e);
    return this.board.ui.infoSession = t.sessionId || this.sessionId, this.board.ui.infoAt = i ? i.id : "result:" + e, !0;
  }
  placeOnBoard(e) {
    const t = this.itemById(e);
    if (!(!t || t.status !== "done")) {
      if (t.kind === "gen" && t.result) {
        if (this.board.placedFor(e)) {
          this.say("Already on the board");
          return;
        }
        this.board.placeResult(t.result);
      } else {
        const s = 360 / Math.max(t.w, t.h);
        this.board.placeImages([{ url: t.url, w: Math.round(t.w * s), h: Math.round(t.h * s), label: t.label, asset: t.asset || void 0 }]);
      }
      this.say("Placed on the board");
    }
  }
  /** References, and your own results (a real board lets you delete only yours, as v1 does). */
  canDelete(e) {
    const t = this.items.value.find((i) => i.id === e);
    return !t || t.status === "pending" ? !1 : t.kind === "ref" ? !0 : !!t.result && (this.board.canDelete(t.result) || !this.board.realRuns);
  }
  async deleteItem(e) {
    const t = this.items.value.find((s) => s.id === e);
    if (!t || !this.canDelete(e)) return;
    if (t.kind === "ref")
      this.board.studioRecords.remove([e]), this.board.trashRev.value++, this.board.toast("Picture deleted. It waits in Recently Deleted.");
    else if (t.result)
      if (this.board.realRuns) {
        if (!await this.board.deleteResult(t.result)) return;
      } else
        this.board.results.remove([e]), this.board.binResult(t.result);
    const i = R2(e);
    if (this.board.studioRecords.has(i) && this.board.studioRecords.remove([i]), this.s.queue.includes(e) && this.setQueue(Z2(this.s.queue, e)), this.s.stageId === e) {
      const s = this.family.value.find((o) => o.id !== e && o.status === "done");
      this.s.stageId = s ? s.id : null;
    }
  }
  say(e) {
    clearTimeout(this.noteTimer), this.s.note = { id: Date.now(), text: e }, this.noteTimer = window.setTimeout(() => {
      this.s.note = null;
    }, 3200);
  }
  /** Leaving: what's typed and drawn is saved. */
  leave() {
    this.s.dropper = !1, this.finishEditing(), this.commitPrompt(), this.saveMarks();
  }
  dispose() {
    this.leave(), this.tools.dispose(), this.scope.stop(), clearTimeout(this.noteTimer), clearTimeout(this.promptTimer), clearTimeout(this.marksTimer);
  }
}
function nb(n) {
  return n ? { ref: n.url, assets: n.asset ? { [n.url]: n.asset } : {} } : {};
}
const ib = "sample:bonneville-massing";
function k_(n) {
  return {
    id: n.id,
    kind: "ref",
    how: n.how,
    url: n.url,
    w: n.pw || 4,
    h: n.ph || 3,
    createdAt: n.createdAt,
    parentId: n.base || null,
    label: n.label,
    status: "done",
    source: n.source || void 0,
    asset: n.asset || null,
    camera: n.camera || null,
    shot: n.shot || void 0,
    modelId: n.model || void 0,
    made: n.made || null
  };
}
function __(n, e) {
  return n.status === "moderated" || n.status === "done" && !n.url ? !1 : !e.has(n.id) && !(n.runId && e.has("run:" + n.runId));
}
function Lce(n, e) {
  return JSON.stringify(u0(n)) === JSON.stringify(u0(e));
}
function u0(n) {
  const e = (i) => Math.round(i * 100) / 100, t = (i) => Number((i || 0).toPrecision(3));
  return { yaw: e(n.yaw), pitch: e(n.pitch), dist: t(n.dist), tx: t(n.tx), ty: t(n.ty), tz: t(n.tz), ox: t(n.ox), oy: t(n.oy) };
}
const Bce = [
  /^Image 1 is the image to edit/,
  /^Follow (the numbered markers|the marks drawn)/,
  /^Marker \d+:/,
  /^Image \d+, marker \d+:/,
  // today's wording (IL-100); the lines above read results made before it
  /^Follow (the numbered annotations|the annotations drawn)/,
  /^Annotation \d+:/,
  /^Image \d+, annotation \d+:/,
  /^The area to change is marked/,
  /^Remove what is marked in magenta/,
  /^Image 2 is image 1 with the area/
];
function Fce(n) {
  return n.split(`
`).filter((e) => e.trim() && !Bce.some((t) => t.test(e.trim()))).join(" ").trim();
}
function sb(n, e) {
  const t = n.trim().split(/\s+/).filter(Boolean);
  return t.slice(0, e).join(" ") + (t.length > e ? "…" : "");
}
function uh(n, e) {
  return (n && typeof n == "object" && "userMessage" in n ? String(n.userMessage || "") : "") || e + " couldn't be uploaded";
}
function hh(n) {
  return new Promise((e) => {
    const t = new Image();
    t.onload = () => e({ w: t.naturalWidth || 4, h: t.naturalHeight || 3 }), t.onerror = () => e({ w: 4, h: 3 }), t.src = n;
  });
}
function Nce(n) {
  if (!("nodeRunResult" in n)) return null;
  const e = n.nodeRunResult;
  return typeof e.nodeRunId == "string" && typeof e.uuid == "string" ? e.nodeRunId + ":" + e.uuid : null;
}
function S_(n, e) {
  return new Promise((t, i) => {
    const s = URL.createObjectURL(n), o = new Image();
    o.onload = () => {
      const r = Math.min(1, e / Math.max(o.naturalWidth, o.naturalHeight)), a = document.createElement("canvas");
      a.width = Math.max(1, Math.round(o.naturalWidth * r)), a.height = Math.max(1, Math.round(o.naturalHeight * r));
      const l = a.getContext("2d");
      if (URL.revokeObjectURL(s), !l) {
        i(new Error(n.name + " couldn't be read as an image"));
        return;
      }
      l.fillStyle = "#ffffff", l.fillRect(0, 0, a.width, a.height), l.drawImage(o, 0, 0, a.width, a.height), t(a.toDataURL("image/jpeg", 0.86));
    }, o.onerror = () => {
      URL.revokeObjectURL(s), i(new Error(n.name + " couldn't be read as an image"));
    }, o.src = s;
  });
}
function Uce(n) {
  try {
    const e = JSON.parse(localStorage.getItem(QC(n)) || "{}");
    !e.edit && e.draw && (e.edit = e.draw);
    const t = {};
    for (const i of ZC) {
      const s = e[i];
      if (!s || typeof s.modelId != "string") continue;
      t[i] = { modelId: s.modelId, count: Number(s.count) || 1, inputs: s.inputs && typeof s.inputs == "object" ? s.inputs : {} };
      const o = Number(s.tier);
      Number.isInteger(o) && o > 0 && (t[i].tier = o);
    }
    return t;
  } catch {
    return {};
  }
}
const h0 = (n) => "rd-board-studio-hist:" + n;
function Gce(n) {
  try {
    return localStorage.getItem(h0(n)) === "shut";
  } catch {
    return !1;
  }
}
function jce(n, e) {
  try {
    e ? localStorage.setItem(h0(n), "shut") : localStorage.removeItem(h0(n));
  } catch {
  }
}
function Hce(n, e) {
  try {
    localStorage.setItem(QC(n), JSON.stringify(e));
  } catch {
  }
}
const T_ = /* @__PURE__ */ new WeakMap();
function p0(n, e) {
  let t = T_.get(n);
  t || (t = /* @__PURE__ */ new Map(), T_.set(n, t));
  let i = t.get(e);
  return i || (i = new Oce(n, e), t.set(e, i)), i;
}
function Vce() {
  return kt();
}
const tI = /* @__PURE__ */ Symbol("studio");
function Wce(n) {
  $5(tI, { studio: n });
}
function ft() {
  const n = Tf(tI);
  if (!n) throw new Error("useStudio() outside the Studios view");
  return n.studio;
}
const qce = ["value"], Kce = /* @__PURE__ */ Re({
  __name: "DrawLayer",
  props: {
    w: {},
    h: {}
  },
  emits: ["live"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = ft(), o = s.s, r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(!1), c = /* @__PURE__ */ K(null), u = I(() => ({ w: t.w, h: t.h })), p = I(() => s.working().strokes);
    let f = null;
    function y(F) {
      const W = r.value.getBoundingClientRect();
      return { x: (F.clientX - W.left) * (t.w / (W.width || t.w)), y: (F.clientY - W.top) * (t.h / (W.height || t.h)) };
    }
    function b(F) {
      return { x: Math.min(t.w, Math.max(0, F.x)), y: Math.min(t.h, Math.max(0, F.y)) };
    }
    function w(F, W = !1) {
      const ee = p.value;
      for (let N = ee.length - 1; N >= 0; N--) {
        const te = ee[N];
        if (!(W && te.kind !== "text") && Ble(te, F, u.value))
          return te;
      }
      return null;
    }
    function k(F) {
      const W = rc(F, u.value);
      if (!F.rot) return W;
      const ee = Or(F, u.value), N = [{ x: W.x, y: W.y }, { x: W.x + W.w, y: W.y }, { x: W.x + W.w, y: W.y + W.h }, { x: W.x, y: W.y + W.h }].map((q) => wo(q, ee, F.rot)), te = N.map((q) => q.x), G = N.map((q) => q.y);
      return { x: Math.min(...te), y: Math.min(...G), w: Math.max(...te) - Math.min(...te), h: Math.max(...G) - Math.min(...G) };
    }
    function S() {
      const F = document.activeElement;
      F && F !== a.value && /^(INPUT|TEXTAREA|BUTTON|SELECT)$/.test(F.tagName) && F.blur();
    }
    function _(F) {
      if (F.button !== 0 || !r.value) return;
      S();
      const W = y(F);
      o.editingText && s.commitText(o.editingText), F.preventDefault(), r.value.setPointerCapture(F.pointerId);
      const ee = o.tool;
      if (ee === "move") {
        x(F, W);
        return;
      }
      if (ee === "text") {
        const G = w(W, !0);
        if (G) {
          s.editText(G.id);
          return;
        }
        const q = Math.min(W.x, Math.max(0, t.w - 50)), B = Math.min(W.y, Math.max(0, t.h - 50));
        s.addText(vo({ x: q, y: B }, u.value), Math.max($le, o.size) / Dr(u.value));
        return;
      }
      if (ee === "eraser") {
        s.beginGesture(), f = { kind: "erase", start: W, last: W, moved: !1, trails: /* @__PURE__ */ new Map() }, D(W);
        return;
      }
      if (ee === "note") return;
      const N = vo(b(W), u.value), te = { id: Vce(), kind: ee, color: o.color, size: o.size / Dr(u.value), pts: ee === "brush" ? [N] : [N, N], opacity: o.opacity };
      f = { kind: "draw", stroke: te }, i("live", te);
    }
    function x(F, W) {
      const ee = F.target.dataset.handle, N = o.selection.length === 1 && p.value.find((G) => G.id === o.selection[0]) || null;
      if (N && ee) {
        if (s.beginGesture(), ee === "turn") {
          const G = Or(N, u.value);
          f = { kind: "turn", orig: N, centre: G, a0: Math.atan2(W.y - G.y, W.x - G.x) };
        } else {
          const G = rc(N, u.value), B = {
            nw: { x: G.x + G.w, y: G.y + G.h },
            ne: { x: G.x, y: G.y + G.h },
            se: { x: G.x, y: G.y },
            sw: { x: G.x + G.w, y: G.y }
          }[ee], ne = N.rot ? wo(B, Or(N, u.value), N.rot) : B;
          f = { kind: "resize", orig: N, anchor: ne, box: G, even: N.kind === "text" };
        }
        return;
      }
      const te = w(W);
      if (te) {
        if (F.shiftKey) {
          s.select(o.selection.includes(te.id) ? o.selection.filter((q) => q !== te.id) : [...o.selection, te.id]);
          return;
        }
        o.selection.includes(te.id) || s.select([te.id]), s.beginGesture();
        const G = /* @__PURE__ */ new Map();
        for (const q of p.value) o.selection.includes(q.id) && G.set(q.id, q);
        f = { kind: "move", start: W, orig: G, moved: !1 };
        return;
      }
      f = { kind: "marquee", start: W, before: F.shiftKey ? o.selection.slice() : [] }, F.shiftKey || s.select([]), c.value = { x: W.x, y: W.y, w: 0, h: 0 };
    }
    function T(F) {
      const W = y(F);
      if ((o.tool === "brush" || o.tool === "eraser") && (l.value = W), !f) {
        d.value = o.tool === "move" && !!w(W);
        return;
      }
      if (!r.value || !r.value.hasPointerCapture(F.pointerId)) return;
      const ee = f;
      if (ee.kind === "draw") {
        const N = vo(b(W), u.value), te = ee.stroke;
        if (te.kind === "brush") {
          const G = te.pts[te.pts.length - 1];
          if (Math.hypot((N.x - G.x) * t.w, (N.y - G.y) * t.h) < 2) return;
          ee.stroke = { ...te, pts: [...te.pts, N] };
        } else
          ee.stroke = { ...te, pts: [te.pts[0], N] };
        i("live", ee.stroke);
      } else if (ee.kind === "erase")
        D(W);
      else if (ee.kind === "move") {
        if (!ee.moved && Math.hypot(W.x - ee.start.x, W.y - ee.start.y) < 2) return;
        ee.moved = !0;
        const N = (W.x - ee.start.x) / t.w, te = (W.y - ee.start.y) / t.h;
        s.updateStrokes(Array.from(ee.orig.keys()), (G) => xC(ee.orig.get(G.id) || G, N, te), !1);
      } else if (ee.kind === "resize") {
        const N = ee.orig, te = Or(N, u.value), G = N.rot ? wo(W, te, -N.rot) : W, q = N.rot ? wo(ee.anchor, te, -N.rot) : ee.anchor;
        let B = Math.abs(G.x - q.x) / Math.max(1, ee.box.w), ne = Math.abs(G.y - q.y) / Math.max(1, ee.box.h);
        if (ee.even || F.shiftKey) {
          const se = Math.max(B, ne);
          B = se, ne = se;
        }
        s.updateStrokes([N.id], () => Fle(N, ee.anchor, Math.max(0.05, B), Math.max(0.05, ne), u.value), !1);
      } else if (ee.kind === "turn") {
        let N = (ee.orig.rot || 0) + Math.atan2(W.y - ee.centre.y, W.x - ee.centre.x) - ee.a0;
        F.shiftKey && (N = Math.round(N / (Math.PI / 12)) * (Math.PI / 12)), s.updateStrokes([ee.orig.id], (te) => ({ ...te, rot: N }), !1);
      } else if (ee.kind === "marquee") {
        const N = { x: Math.min(ee.start.x, W.x), y: Math.min(ee.start.y, W.y), w: Math.abs(W.x - ee.start.x), h: Math.abs(W.y - ee.start.y) };
        c.value = N;
        const te = p.value.filter((G) => Ule(k(G), N)).map((G) => G.id);
        s.select(Array.from(/* @__PURE__ */ new Set([...ee.before, ...te])));
      }
    }
    function M(F) {
      r.value && r.value.hasPointerCapture(F.pointerId) && r.value.releasePointerCapture(F.pointerId);
      const W = f;
      if (f = null, c.value = null, i("live", null), !!W)
        if (W.kind === "draw") {
          const ee = W.stroke, N = ee.pts[0], te = ee.pts[ee.pts.length - 1], G = Math.hypot((te.x - N.x) * t.w, (te.y - N.y) * t.h);
          if (ee.kind !== "brush" && G < 4) return;
          s.addStroke(ee);
        } else if (W.kind === "erase") {
          if (!W.moved) {
            const ee = w(W.start, !0);
            if (ee) {
              s.dropGesture(), s.deleteStrokes([ee.id]);
              return;
            }
          }
          W.trails.size || s.dropGesture();
        } else W.kind === "move" && !W.moved && s.dropGesture();
    }
    function z() {
      l.value = null, d.value = !1;
    }
    function P(F) {
      if (o.tool !== "move") return;
      const W = w(y(F), !0);
      W && s.editText(W.id);
    }
    function D(F) {
      const W = f;
      if (!W || W.kind !== "erase") return;
      Math.hypot(F.x - W.start.x, F.y - W.start.y) > 4 && (W.moved = !0);
      const ee = W.last;
      W.last = F;
      const N = o.size, te = u.value;
      let G = !1;
      for (const B of p.value) {
        const ne = W.trails.get(B.id);
        ne ? (ne.trail.pts.push(vo(tl(F, B, te), te)), G = !0) : Nle(B, ee, F, N, te) && (W.trails.set(B.id, {
          before: B.erase || [],
          trail: { pts: [vo(tl(ee, B, te), te), vo(tl(F, B, te), te)], size: N / Dr(te) }
        }), G = !0);
      }
      if (!G) return;
      const q = W.trails;
      s.updateStrokes(Array.from(q.keys()), (B) => {
        const ne = q.get(B.id);
        return { ...B, erase: [...ne.before, { size: ne.trail.size, pts: ne.trail.pts.slice() }] };
      }, !1);
    }
    const $ = (F) => F.kind === "text" ? 5 : F.size * Dr(u.value) / 2 + 5, O = I(() => {
      if (o.tool !== "move") return [];
      const F = new Set(o.selection);
      return p.value.filter((W) => F.has(W.id)).map((W) => {
        const ee = rc(W, u.value), N = $(W);
        return { id: W.id, left: ee.x - N, top: ee.y - N, width: ee.w + N * 2, height: ee.h + N * 2, rot: W.rot || 0 };
      });
    }), L = I(() => p.value.find((F) => F.id === o.editingText && F.kind === "text") || null), Z = I(() => {
      const F = L.value;
      if (!F) return null;
      const W = Qc(F, u.value), ee = Math.max(W.font, t.w - W.box.x);
      return {
        left: W.box.x + "px",
        top: W.box.y + "px",
        width: Math.min(ee, W.box.w + W.font * 0.7) + "px",
        height: Math.max(W.box.h, W.font * Ec) + "px",
        fontSize: W.font + "px",
        lineHeight: String(Ec),
        fontFamily: Pc,
        color: F.color,
        transform: F.rot ? "rotate(" + F.rot + "rad)" : void 0
      };
    });
    $e(() => o.editingText, (F) => {
      F && it(() => {
        a.value && (a.value.focus(), a.value.select());
      });
    });
    function J(F) {
      var W;
      F.key === "Enter" && (F.metaKey || F.ctrlKey) && (F.preventDefault(), (W = a.value) == null || W.blur());
    }
    function re() {
      o.editingText && s.commitText(o.editingText);
    }
    return (F, W) => (g(), v("div", {
      ref_key: "layer",
      ref: r,
      class: U(["sv-layer is-draw", ["tool-" + m(o).tool, { "is-over": d.value }]]),
      "data-testid": "studio-draw-layer",
      onPointerdown: _,
      onPointermove: T,
      onPointerup: M,
      onPointercancel: M,
      onPointerleave: z,
      onDblclick: P
    }, [
      (g(!0), v(H, null, me(O.value, (ee) => (g(), v("div", {
        key: ee.id,
        class: "sv-sel",
        style: de({ left: ee.left + "px", top: ee.top + "px", width: ee.width + "px", height: ee.height + "px", transform: ee.rot ? "rotate(" + ee.rot + "rad)" : void 0 })
      }, [
        O.value.length === 1 ? (g(), v(H, { key: 0 }, [
          W[2] || (W[2] = Af('<i class="h nw" data-handle="nw"></i><i class="h ne" data-handle="ne"></i><i class="h se" data-handle="se"></i><i class="h sw" data-handle="sw"></i><i class="stem"></i><i class="h turn" data-handle="turn" title="Turn (Shift snaps)"></i>', 6))
        ], 64)) : E("", !0)
      ], 4))), 128)),
      c.value ? (g(), v("div", {
        key: 0,
        class: "sv-marquee",
        style: de({ left: c.value.x + "px", top: c.value.y + "px", width: c.value.w + "px", height: c.value.h + "px" })
      }, null, 4)) : E("", !0),
      l.value && (m(o).tool === "brush" || m(o).tool === "eraser") ? (g(), v("span", {
        key: 1,
        class: U(["sv-ring", { "is-eraser": m(o).tool === "eraser" }]),
        style: de({ left: l.value.x + "px", top: l.value.y + "px", width: Math.max(4, m(o).size) + "px", height: Math.max(4, m(o).size) + "px" })
      }, null, 6)) : E("", !0),
      L.value && Z.value ? (g(), v("textarea", {
        key: 2,
        ref_key: "editor",
        ref: a,
        class: "sv-text-editor",
        style: de(Z.value),
        value: L.value.text,
        placeholder: "Text",
        spellcheck: "false",
        "data-testid": "studio-text-editor",
        onInput: W[0] || (W[0] = (ee) => m(s).setText(L.value.id, ee.target.value)),
        onKeydown: J,
        onBlur: re,
        onPointerdown: W[1] || (W[1] = Pe(() => {
        }, ["stop"]))
      }, null, 44, qce)) : E("", !0)
    ], 34));
  }
}), Yce = ["title", "data-testid", "onPointerdown"], Xce = { class: "sv-pin-editor-head" }, Jce = { class: "n" }, Zce = ["value"], Qce = { class: "sv-pin-editor-foot" }, eue = /* @__PURE__ */ Re({
  __name: "PinLayer",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, t = ft(), i = t.s, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = I(() => t.working().pins), a = I(() => r.value.find((w) => w.id === i.editingPin) || null);
    $e(() => i.editingPin, (w) => {
      w && it(() => o.value && o.value.focus());
    });
    function l(w) {
      const k = s.value.getBoundingClientRect();
      return { x: Math.min(1, Math.max(0, (w.clientX - k.left) / k.width)), y: Math.min(1, Math.max(0, (w.clientY - k.top) / k.height)) };
    }
    function d(w) {
      if (w.button !== 0) return;
      if (w.preventDefault(), i.editingPin) {
        t.commitPin(i.editingPin);
        return;
      }
      const k = l(w);
      t.addPin(k.x, k.y);
    }
    let c = null;
    function u(w, k) {
      k.stopPropagation(), k.button === 0 && (k.currentTarget.setPointerCapture(k.pointerId), c = { id: w, x0: k.clientX, y0: k.clientY, moved: !1 });
    }
    function p(w) {
      if (!c || !c.moved && Math.hypot(w.clientX - c.x0, w.clientY - c.y0) < 4) return;
      const k = !c.moved;
      c.moved = !0;
      const S = l(w);
      t.movePin(c.id, S.x, S.y, k);
    }
    function f(w) {
      const k = c;
      c = null, w.currentTarget.releasePointerCapture(w.pointerId), k && !k.moved && t.editPin(k.id);
    }
    function y(w, k) {
      w.key === "Enter" && !w.shiftKey ? (w.preventDefault(), t.commitPin(k)) : w.key === "Escape" && (w.preventDefault(), w.stopPropagation(), t.commitPin(k));
    }
    const b = I(() => {
      const w = a.value;
      if (!w) return null;
      const k = w.x * e.w, S = w.y * e.h;
      return { left: k > e.w - 280 ? k - 262 : k + 22, top: Math.min(Math.max(S - 22, -8), e.h - 120) };
    });
    return (w, k) => (g(), v("div", {
      ref_key: "layer",
      ref: s,
      class: "sv-layer is-comment",
      "data-testid": "studio-pin-layer",
      onPointerdown: Pe(d, ["self"])
    }, [
      (g(!0), v(H, null, me(r.value, (S, _) => (g(), v("button", {
        key: S.id,
        class: U(["sv-pin", { "is-on": m(i).editingPin === S.id, "is-empty": !S.text.trim() }]),
        style: de({ left: S.x * 100 + "%", top: S.y * 100 + "%" }),
        title: S.text || "New note",
        "data-testid": "studio-pin-" + (_ + 1),
        onPointerdown: (x) => u(S.id, x),
        onPointermove: p,
        onPointerup: f
      }, A(_ + 1), 47, Yce))), 128)),
      a.value && b.value ? (g(), v("div", {
        key: 0,
        class: "sv-pin-editor",
        style: de({ left: b.value.left + "px", top: b.value.top + "px" }),
        onPointerdown: k[4] || (k[4] = Pe(() => {
        }, ["stop"]))
      }, [
        h("div", Xce, [
          h("span", Jce, A(r.value.indexOf(a.value) + 1), 1),
          k[5] || (k[5] = h("span", { class: "t" }, "Note for the model", -1)),
          h("button", {
            class: "x",
            title: "Delete this note",
            onClick: k[0] || (k[0] = (S) => m(t).removePin(a.value.id))
          }, [
            C(R, {
              name: "Trash2",
              size: 12
            })
          ])
        ]),
        h("textarea", {
          ref_key: "editor",
          ref: o,
          value: a.value.text,
          rows: "2",
          spellcheck: "false",
          placeholder: "What should change here?",
          "data-testid": "studio-pin-text",
          onInput: k[1] || (k[1] = (S) => m(t).setPinText(a.value.id, S.target.value)),
          onKeydown: k[2] || (k[2] = (S) => y(S, a.value.id))
        }, null, 40, Zce),
        h("div", Qce, [
          k[6] || (k[6] = h("span", null, "Enter to save", -1)),
          h("button", {
            class: "sv-mini-btn",
            onClick: k[3] || (k[3] = (S) => m(t).commitPin(a.value.id))
          }, "Done")
        ])
      ], 36)) : E("", !0)
    ], 544));
  }
}), M_ = 1400, tue = 3e-3, nue = 1, C_ = 4096, I_ = {
  studio: [0.925, 0.918, 0.902, 1],
  clear: [0, 0, 0, 0],
  night: [0.055, 0.06, 0.09, 1]
};
function iue(n, e) {
  const t = Math.PI * 2;
  let i = (e - n) % t;
  return i > Math.PI && (i -= t), i < -Math.PI && (i += t), n + i;
}
function sue(n) {
  return n < 0.5 ? 4 * n * n * n : 1 - Math.pow(-2 * n + 2, 3) / 2;
}
function oue(n, e, t) {
  const i = (s, o) => s + (o - s) * t;
  return {
    yaw: i(n.yaw, iue(n.yaw, e.yaw)),
    pitch: i(n.pitch, e.pitch),
    dist: i(n.dist, e.dist),
    tx: i(n.tx, e.tx),
    ty: i(n.ty, e.ty),
    tz: i(n.tz, e.tz),
    ox: i(n.ox || 0, e.ox || 0),
    oy: i(n.oy || 0, e.oy || 0)
  };
}
async function rue(n, e) {
  const t = new n.Engine(e, !0, { preserveDrawingBuffer: !0, stencil: !0 }, !0), i = new n.Scene(t), s = new n.ArcRotateCamera("studio-camera", Math.PI / 2, Math.PI / 2.5, 3, n.Vector3.Zero(), i);
  s.attachControl(e, !0), s.angularSensibilityX = M_, s.angularSensibilityY = M_, s.wheelDeltaPercentage = tue, s.inertia = 0.6, s.panningInertia = 0.6, s.lowerRadiusLimit = 0.01, s.minZ = 0.01, s.lowerBetaLimit = 0.02, s.upperBetaLimit = Math.PI - 0.02;
  const o = new n.HemisphericLight("studio-hemi", new n.Vector3(0, 1, 0), i);
  o.intensity = 0.75, o.groundColor = new n.Color3(0.32, 0.31, 0.34);
  const r = new n.DirectionalLight("studio-sun", new n.Vector3(-0.55, -1, -0.35), i);
  r.intensity = 0.75;
  let a = [], l = { yaw: Math.PI / 2, pitch: Math.PI / 2.5, dist: 3, tx: 0, ty: 0, tz: 0, ox: 0, oy: 0 }, d = null;
  const c = /* @__PURE__ */ new Set();
  let u = 0;
  const p = () => ({
    yaw: s.alpha,
    pitch: s.beta,
    dist: s.radius,
    tx: s.target.x,
    ty: s.target.y,
    tz: s.target.z,
    ox: s.targetScreenOffset.x,
    oy: s.targetScreenOffset.y
  }), f = (L) => {
    s.alpha = L.yaw, s.beta = L.pitch, s.radius = L.dist, s.setTarget(new n.Vector3(L.tx, L.ty, L.tz)), s.alpha = L.yaw, s.beta = L.pitch, s.radius = L.dist, s.targetScreenOffset.set(L.ox || 0, L.oy || 0);
  }, y = () => {
    u || (u = requestAnimationFrame(() => {
      u = 0;
      const L = p();
      for (const Z of c) Z(L);
    }));
  };
  s.onViewMatrixChangedObservable.add(y);
  const b = () => (s.radius > 0 ? s.radius : 1) * Math.tan((s.fov > 0 ? s.fov : 0.8) / 2), w = () => {
    const L = b() * nue, Z = s.targetScreenOffset, J = Math.hypot(Z.x, Z.y);
    J > L && J > 0 && Z.set(Z.x * L / J, Z.y * L / J);
  };
  s.panningSensibility = 1200, s.panningAxis = new n.Vector3(0, 0, 0);
  let k = null;
  const S = (L) => L.button === 2 || L.button === 0 && (L.ctrlKey || L.shiftKey), _ = (L) => {
    S(L) && (k = { x: L.clientX, y: L.clientY }, d = null);
  }, x = (L) => {
    if (!k) return;
    if (L.buttons === 0) {
      k = null;
      return;
    }
    const Z = 2 * b() / Math.max(1, e.clientHeight), J = s.targetScreenOffset;
    J.set(J.x + (L.clientX - k.x) * Z, J.y - (L.clientY - k.y) * Z), k = { x: L.clientX, y: L.clientY }, w(), y();
  }, T = () => {
    k = null;
  }, M = (L) => L.preventDefault();
  e.addEventListener("pointerdown", _), e.addEventListener("pointermove", x), e.addEventListener("pointerup", T), e.addEventListener("pointercancel", T), e.addEventListener("contextmenu", M);
  const z = i.onBeforeRenderObservable.add(() => {
    if (d) {
      const L = Math.min(1, (performance.now() - d.t0) / d.ms);
      f(oue(d.from, d.to, sue(L))), L >= 1 && (d = null);
    }
    w();
  }), P = new ResizeObserver(() => t.resize());
  P.observe(e), t.runRenderLoop(() => i.render());
  let D = "studio";
  const $ = (L) => {
    D = L;
    const Z = I_[L];
    i.clearColor = new n.Color4(Z[0], Z[1], Z[2], Z[3]);
  };
  $("studio");
  const O = () => {
    let L = null, Z = null;
    for (const F of i.meshes) {
      if (!F.getTotalVertices()) continue;
      F.computeWorldMatrix(!0);
      const W = F.getBoundingInfo().boundingBox;
      L = L ? n.Vector3.Minimize(L, W.minimumWorld) : W.minimumWorld.clone(), Z = Z ? n.Vector3.Maximize(Z, W.maximumWorld) : W.maximumWorld.clone();
    }
    if (!L || !Z) return l;
    const re = (Math.max(Z.x - L.x, Z.y - L.y, Z.z - L.z) || 2) * 1.5;
    return s.lowerRadiusLimit = re * 0.08, s.upperRadiusLimit = re * 10, s.minZ = re * 2e-3, s.maxZ = re * 60, {
      yaw: Math.PI / 2 + 0.75,
      pitch: 1.2,
      dist: re,
      tx: (L.x + Z.x) / 2,
      ty: (L.y + Z.y) / 2,
      tz: (L.z + Z.z) / 2,
      ox: 0,
      oy: 0
    };
  };
  return {
    async load(L, Z) {
      const J = L instanceof File ? L : new File([L], "model." + Z), re = await n.SceneLoader.ImportMeshAsync("", "", J, i, null, "." + Z.replace(/^\./, ""));
      for (const W of a) W.dispose();
      a = re.meshes;
      const F = new n.StandardMaterial("studio-clay", i);
      F.diffuseColor = new n.Color3(0.8, 0.77, 0.73), F.specularColor = new n.Color3(0.08, 0.08, 0.08), F.backFaceCulling = !1;
      for (const W of re.meshes) !W.material && W.getTotalVertices() && (W.material = F);
      l = O(), d = null, f(l);
    },
    camera: p,
    setCamera(L) {
      d = null, f(L);
    },
    fly(L, Z = 460) {
      d = { from: p(), to: L, t0: performance.now(), ms: Z };
    },
    home: () => ({ ...l }),
    setBackdrop: $,
    async capture(L, Z, J) {
      const re = Math.max(1, e.clientWidth), F = Math.max(1, e.clientHeight);
      let W = Math.max(Z / L.w, J / L.h);
      W = Math.min(W, C_ / re, C_ / F);
      const ee = Math.round(re * W), N = Math.round(F * W), te = await new Promise((ne) => {
        n.CreateScreenshotUsingRenderTarget(t, s, { width: ee, height: N, precision: 1 }, (se) => ne(se), "image/png", 1, !0);
      }), G = await new Promise((ne, se) => {
        const Y = new Image();
        Y.onload = () => ne(Y), Y.onerror = () => se(new Error("The view couldn't be captured.")), Y.src = te;
      }), q = document.createElement("canvas");
      q.width = Z, q.height = J;
      const B = q.getContext("2d");
      if (!B) throw new Error("The view couldn't be captured.");
      if (D !== "clear") {
        const ne = I_[D];
        B.fillStyle = "rgb(" + Math.round(ne[0] * 255) + "," + Math.round(ne[1] * 255) + "," + Math.round(ne[2] * 255) + ")", B.fillRect(0, 0, Z, J);
      }
      return B.drawImage(G, L.x * W, L.y * W, L.w * W, L.h * W, 0, 0, Z, J), new Promise((ne, se) => q.toBlob((Y) => Y ? ne(Y) : se(new Error("The view couldn't be captured.")), "image/png"));
    },
    onCamera(L) {
      return c.add(L), () => c.delete(L);
    },
    dispose() {
      cancelAnimationFrame(u), c.clear(), P.disconnect(), i.onBeforeRenderObservable.remove(z), e.removeEventListener("pointerdown", _), e.removeEventListener("pointermove", x), e.removeEventListener("pointerup", T), e.removeEventListener("pointercancel", T), e.removeEventListener("contextmenu", M);
      try {
        t.stopRenderLoop(), t.dispose();
      } catch {
      }
    }
  };
}
const aue = { class: "sv-finder-tag" }, lue = {
  key: 1,
  class: "sv-model-state",
  "data-testid": "studio-3d-loading"
}, due = {
  key: 2,
  class: "sv-model-state is-error",
  "data-testid": "studio-3d-error"
}, cue = {
  class: "sv-seg is-text is-small is-dark",
  role: "radiogroup",
  "aria-label": "Frame"
}, uue = ["aria-checked", "title", "data-testid", "onClick"], hue = {
  class: "sv-seg is-text is-small is-dark",
  role: "radiogroup",
  "aria-label": "Backdrop"
}, pue = ["aria-checked", "onClick"], fue = /* @__PURE__ */ Re({
  __name: "ModelView",
  setup(n, { expose: e }) {
    const t = ft(), { board: i } = tt(), s = t.s, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K({ w: 800, h: 600 }), l = /* @__PURE__ */ K(!1), d = [
      { id: "studio", label: "Studio" },
      { id: "clear", label: "Clear" },
      { id: "night", label: "Night" }
    ], c = ["1:1", "4:3", "3:4", "16:9", "9:16"];
    let u = null, p = null, f = null, y = !1;
    const b = I(() => {
      const M = t.captureRatio(), z = a.value.w - 48, P = a.value.h - 48, D = Math.min(z, P * M), $ = D / M;
      return { w: D, h: $, left: (a.value.w - D) / 2, top: (a.value.h - $) / 2 };
    });
    function w(M) {
      const z = M instanceof Error ? M.message : "";
      return z && /couldn't|isn't|unavailable/i.test(z) ? z : "This file couldn't be read as a 3D model. Try a .glb, or an .obj or .stl.";
    }
    async function k(M) {
      if (!(!u || !M || f === M.id)) {
        f = M.id, s.three.loading = !0, s.three.error = null;
        try {
          const z = await t.modelFile(M);
          if (y || f !== M.id || !u || (await u.load(z, M.ext), y || f !== M.id || !u)) return;
          s.three.cam = u.camera();
        } catch (z) {
          console.warn("[board] 3D model not shown", z), f === M.id && (s.three.error = w(z), f = null);
        } finally {
          y || (s.three.loading = !1);
        }
      }
    }
    let S = null;
    ot(async () => {
      o.value && (S = new ResizeObserver(() => {
        if (!o.value) return;
        const z = o.value.getBoundingClientRect();
        a.value = { w: Math.max(200, z.width), h: Math.max(160, z.height) };
      }), S.observe(o.value));
      const M = i.babylon;
      if (!M || !r.value) {
        s.three.error = "3D isn't available here.";
        return;
      }
      s.three.loading = !0;
      try {
        const z = await M();
        if (y || !r.value) return;
        u = await rue(z, r.value);
      } catch (z) {
        console.error("[board] 3D unavailable", z), s.three.error = "3D couldn't start in this browser.", s.three.loading = !1;
        return;
      }
      if (y) {
        u.dispose(), u = null;
        return;
      }
      u.setBackdrop(s.three.backdrop), p = u.onCamera((z) => {
        s.three.cam = z;
      }), l.value = !0, s.three.loading = !1, await k(t.model3d.value);
    }), $e(() => t.model3d.value ? t.model3d.value.id : null, () => k(t.model3d.value)), $e(() => s.three.backdrop, (M) => {
      u && u.setBackdrop(M);
    }), Ve(() => {
      y = !0, S && S.disconnect(), p && p(), u && u.dispose(), u = null;
    });
    function _(M) {
      u && u.fly(M);
    }
    function x() {
      u && u.fly(u.home());
    }
    async function T() {
      if (!u || !l.value || s.three.loading || s.three.error) return null;
      const M = b.value, z = t.captureRatio(), P = z >= 1 ? 1024 : Math.round(1024 * z), D = z >= 1 ? Math.round(1024 / z) : 1024;
      return { blob: await u.capture({ x: M.left, y: M.top, w: M.w, h: M.h }, P, D), w: P, h: D };
    }
    return e({ fly: _, capture: T, home: x }), (M, z) => (g(), v("div", {
      ref_key: "box",
      ref: o,
      class: U(["sv-model", { "is-clear": m(s).three.backdrop === "clear", "is-night": m(s).three.backdrop === "night" }]),
      "data-testid": "studio-model-view"
    }, [
      h("canvas", {
        ref_key: "canvas",
        ref: r,
        class: "sv-model-canvas",
        onDblclick: x
      }, null, 544),
      l.value && !m(s).three.error ? (g(), v("div", {
        key: 0,
        class: "sv-finder",
        style: de({ left: b.value.left + "px", top: b.value.top + "px", width: b.value.w + "px", height: b.value.h + "px" }),
        "aria-hidden": "true"
      }, [
        z[1] || (z[1] = h("i", { class: "tl" }, null, -1)),
        z[2] || (z[2] = h("i", { class: "tr" }, null, -1)),
        z[3] || (z[3] = h("i", { class: "bl" }, null, -1)),
        z[4] || (z[4] = h("i", { class: "br" }, null, -1)),
        h("span", aue, A(m(s).three.aspect), 1)
      ], 4)) : E("", !0),
      m(s).three.loading || m(s).three.keeping ? (g(), v("div", lue, [
        z[5] || (z[5] = h("span", { class: "sv-making" }, null, -1)),
        X(" " + A(m(s).three.keeping ? "Keeping " + m(s).three.keeping + " in your Library, then opening it" : "Opening the model"), 1)
      ])) : m(s).three.error ? (g(), v("div", due, [
        C(R, {
          name: "AlertCircle",
          size: 15
        }),
        X(" " + A(m(s).three.error), 1)
      ])) : E("", !0),
      h("div", {
        class: "sv-model-tools",
        onPointerdown: z[0] || (z[0] = Pe(() => {
        }, ["stop"]))
      }, [
        h("div", cue, [
          (g(), v(H, null, me(c, (P) => h("button", {
            key: P,
            class: U({ on: m(s).three.aspect === P }),
            role: "radio",
            "aria-checked": m(s).three.aspect === P,
            title: "Capture a " + P + " frame",
            "data-testid": "studio-3d-aspect-" + P.replace(":", "x"),
            onClick: (D) => m(s).three.aspect = P
          }, A(P), 11, uue)), 64))
        ]),
        h("div", hue, [
          (g(), v(H, null, me(d, (P) => h("button", {
            key: P.id,
            class: U({ on: m(s).three.backdrop === P.id }),
            role: "radio",
            "aria-checked": m(s).three.backdrop === P.id,
            onClick: (D) => m(s).three.backdrop = P.id
          }, A(P.label), 11, pue)), 64))
        ]),
        h("button", {
          class: "sv-model-btn",
          title: "Back to the framed view (double-click the model)",
          onClick: x
        }, [
          C(R, {
            name: "RotateCcw",
            size: 13
          })
        ])
      ], 32)
    ], 2));
  }
}), mue = ["viewBox"], gue = ["d"], bue = {
  key: 0,
  class: "tk"
}, vue = /* @__PURE__ */ Re({
  __name: "AreaLayer",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, t = ft(), i = t.s, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(!1), c = /* @__PURE__ */ K(0), u = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ K(null), f = I(() => t.area()), y = I(() => i.bar === "erase"), b = I(() => i.areaCut !== d.value), w = I(() => t.objectsOf(i.stageId)), k = I(() => Math.max(e.w, e.h)), S = I(() => y.value ? [255, 92, 110] : [168, 118, 255]);
    $e(() => w.value && w.value.status === "ready" ? w.value.url : null, async (F) => {
      if (p.value = null, c.value = 0, !F) return;
      const W = i.stageId;
      try {
        const ee = await rf(F);
        u.set(F, ee), p.value = ee;
      } catch {
        p.value = null, W && t.objectsFailed(W);
      }
    }, { immediate: !0 });
    let _ = 0;
    function x() {
      cancelAnimationFrame(_), _ = requestAnimationFrame(T);
    }
    async function T() {
      const F = o.value;
      if (!F) return;
      const W = Math.min(2, window.devicePixelRatio || 1), ee = Math.max(1, Math.round(e.w * W)), N = Math.max(1, Math.round(e.h * W));
      (F.width !== ee || F.height !== N) && (F.width = ee, F.height = N);
      const te = l.value ? [...f.value, M(l.value)] : f.value;
      for (const De of UC(te))
        if (!u.has(De))
          try {
            u.set(De, await rf(De));
          } catch {
          }
      const G = F.getContext("2d");
      if (G.clearRect(0, 0, ee, N), !te.length) return;
      const q = ap(te, ee, N, u), [B, ne, se] = S.value;
      G.save(), G.drawImage(q, 0, 0), G.globalCompositeOperation = "source-in", G.fillStyle = "rgba(" + B + "," + ne + "," + se + ",0.4)", G.fillRect(0, 0, ee, N), G.restore();
      const Y = document.createElement("canvas");
      Y.width = ee, Y.height = N;
      const ie = Y.getContext("2d");
      ie.filter = "blur(" + 1.6 * W + "px)", ie.drawImage(q, 0, 0), ie.filter = "none", ie.globalCompositeOperation = "destination-out", ie.drawImage(q, 0, 0), ie.globalCompositeOperation = "source-in", ie.fillStyle = "rgba(255,255,255,0.95)", ie.fillRect(0, 0, ee, N), G.drawImage(Y, 0, 0);
    }
    function M(F) {
      return F.kind === "brush" ? { kind: "brush", pts: F.pts, size: i.areaSize / k.value, cut: F.cut } : { kind: "lasso", pts: F.pts, cut: F.cut };
    }
    $e([f, () => e.w, () => e.h, y], x, { deep: !0 }), ot(x);
    function z() {
      const F = r.value;
      if (!F) return;
      const W = Math.min(2, window.devicePixelRatio || 1);
      F.width = Math.max(1, Math.round(e.w * W)), F.height = Math.max(1, Math.round(e.h * W));
      const ee = F.getContext("2d");
      if (ee.clearRect(0, 0, F.width, F.height), !p.value || !c.value) return;
      const N = NC(p.value, c.value), te = F.width, G = F.height;
      ee.drawImage(N, 0, 0, te, G), ee.globalCompositeOperation = "source-in", ee.fillStyle = b.value ? "rgba(255, 92, 110, 0.3)" : "rgba(190, 150, 255, 0.34)", ee.fillRect(0, 0, te, G);
      const q = document.createElement("canvas");
      q.width = te, q.height = G;
      const B = q.getContext("2d");
      B.filter = "blur(2px)", B.drawImage(N, 0, 0, te, G), B.filter = "none", B.globalCompositeOperation = "destination-out", B.drawImage(N, 0, 0, te, G), B.globalCompositeOperation = "source-in", B.fillStyle = "#fff", B.fillRect(0, 0, te, G), ee.globalCompositeOperation = "source-over", ee.drawImage(q, 0, 0);
    }
    $e(c, z);
    function P(F) {
      const W = s.value.getBoundingClientRect();
      return { x: (F.clientX - W.left) * (e.w / (W.width || e.w)), y: (F.clientY - W.top) * (e.h / (W.height || e.h)) };
    }
    function D(F) {
      return { x: Math.min(1, Math.max(0, F.x / e.w)), y: Math.min(1, Math.max(0, F.y / e.h)) };
    }
    function $(F) {
      if (F.button !== 0 || !s.value) return;
      const W = document.activeElement;
      W && /^(INPUT|TEXTAREA|BUTTON|SELECT)$/.test(W.tagName) && W.blur(), d.value = F.altKey;
      const ee = D(P(F));
      if (i.areaTool === "object") {
        if (!p.value) return;
        const N = s_(p.value, ee.x, ee.y);
        N && t.addAreaOp({ kind: "object", map: p.value.url, segment: N, cut: b.value });
        return;
      }
      F.preventDefault(), s.value.setPointerCapture(F.pointerId), l.value = { kind: i.areaTool === "lasso" ? "lasso" : "brush", pts: [ee], cut: b.value }, x();
    }
    function O(F) {
      const W = P(F);
      if (d.value = F.altKey, i.areaTool === "brush" && (a.value = W), i.areaTool === "object" && p.value) {
        const G = D(W), q = s_(p.value, G.x, G.y);
        q !== c.value && (c.value = q);
      }
      const ee = l.value;
      if (!ee || !s.value || !s.value.hasPointerCapture(F.pointerId)) return;
      const N = D(W), te = ee.pts[ee.pts.length - 1];
      Math.hypot((N.x - te.x) * e.w, (N.y - te.y) * e.h) < (ee.kind === "brush" ? 2 : 3) || (ee.pts = [...ee.pts, N], x());
    }
    function L(F) {
      s.value && s.value.hasPointerCapture(F.pointerId) && s.value.releasePointerCapture(F.pointerId);
      const W = l.value;
      if (l.value = null, !!W) {
        if (W.kind === "lasso" && W.pts.length < 3) {
          x();
          return;
        }
        t.addAreaOp(M(W));
      }
    }
    function Z() {
      a.value = null, c.value = 0;
    }
    function J(F) {
      d.value = F.altKey;
    }
    ot(() => {
      window.addEventListener("keydown", J), window.addEventListener("keyup", J);
    }), Ve(() => {
      cancelAnimationFrame(_), window.removeEventListener("keydown", J), window.removeEventListener("keyup", J);
    });
    const re = I(() => {
      const F = l.value;
      return !F || F.kind !== "lasso" ? "" : F.pts.map((W, ee) => (ee ? "L" : "M") + (W.x * e.w).toFixed(1) + " " + (W.y * e.h).toFixed(1)).join(" ");
    });
    return (F, W) => (g(), v("div", {
      ref_key: "layer",
      ref: s,
      class: U(["sv-layer ed-area-layer", ["tool-" + m(i).areaTool, { "is-cut": b.value, "is-erase": y.value, "is-picking": m(i).areaTool === "object" && !!p.value, "is-over": !!c.value }]]),
      "data-testid": "studio-area-layer",
      onPointerdown: $,
      onPointermove: O,
      onPointerup: L,
      onPointercancel: L,
      onPointerleave: Z
    }, [
      h("canvas", {
        ref_key: "paint",
        ref: o,
        class: "ed-area-paint",
        style: de({ width: n.w + "px", height: n.h + "px" })
      }, null, 4),
      m(i).areaTool === "object" ? (g(), v("canvas", {
        key: 0,
        ref_key: "hoverCanvas",
        ref: r,
        class: "ed-area-hover",
        style: de({ width: n.w + "px", height: n.h + "px" })
      }, null, 4)) : E("", !0),
      re.value ? (g(), v("svg", {
        key: 1,
        class: "ed-area-lasso",
        viewBox: "0 0 " + n.w + " " + n.h,
        style: de({ width: n.w + "px", height: n.h + "px" })
      }, [
        h("path", { d: re.value }, null, 8, gue)
      ], 12, mue)) : E("", !0),
      a.value && m(i).areaTool === "brush" ? (g(), v("span", {
        key: 2,
        class: U(["sv-ring ed-area-ring", { "is-eraser": b.value }]),
        style: de({ left: a.value.x + "px", top: a.value.y + "px", width: Math.max(4, m(i).areaSize) + "px", height: Math.max(4, m(i).areaSize) + "px" })
      }, null, 6)) : E("", !0),
      C(vt, { name: "ed-fade" }, {
        default: et(() => [
          m(i).areaTool === "object" && (!w.value || w.value.status !== "ready" || !p.value) ? (g(), v("div", {
            key: 0,
            class: "ed-area-find",
            onPointerdown: W[1] || (W[1] = Pe(() => {
            }, ["stop"]))
          }, [
            w.value && w.value.status === "finding" ? (g(), v(H, { key: 0 }, [
              C(R, {
                name: "Loader2",
                size: 13,
                spin: ""
              }),
              W[2] || (W[2] = X(" Finding the objects in this picture", -1))
            ], 64)) : w.value && w.value.status === "ready" ? (g(), v(H, { key: 1 }, [
              C(R, {
                name: "Loader2",
                size: 13,
                spin: ""
              }),
              W[3] || (W[3] = X(" Reading the objects", -1))
            ], 64)) : (g(), v("button", {
              key: 2,
              class: "ed-area-find-btn",
              "data-testid": "studio-find-objects",
              onClick: W[0] || (W[0] = (ee) => m(t).findObjects())
            }, [
              C(R, {
                name: "MousePointerClick",
                size: 13
              }),
              X(" " + A(w.value && w.value.status === "failed" ? "The objects couldn't be found. Try again" : "Find the objects in this picture") + " ", 1),
              m(t).modelOf("select") ? (g(), v("span", bue, [
                C(R, {
                  name: "Tokens",
                  size: 10
                }),
                X(" " + A(m(t).priceOf("select")), 1)
              ])) : E("", !0)
            ]))
          ], 32)) : E("", !0)
        ]),
        _: 1
      })
    ], 34));
  }
}), yue = ["data-handle", "onPointerdown"], xue = { class: "ed-crop-size" }, wue = /* @__PURE__ */ Re({
  __name: "CropOverlay",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, t = ft(), i = t.tools, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = I(() => i.t.resize.crop), a = I(() => ({ left: r.value.x * e.w, top: r.value.y * e.h, width: r.value.w * e.w, height: r.value.h * e.h })), l = I(() => {
      const y = t.stage.value;
      return y ? o0(r.value, y.w, y.h) : { w: 0, h: 0 };
    }), d = ["nw", "n", "ne", "e", "se", "s", "sw", "w"];
    let c = null;
    function u(y, b) {
      if (b.button !== 0 || !s.value) return;
      b.preventDefault(), b.stopPropagation(), b.currentTarget.setPointerCapture(b.pointerId);
      const w = t.stage.value, k = w ? af(i.t.resize.ratio, w.w, w.h) : null;
      c = { kind: y, x0: b.clientX, y0: b.clientY, start: { ...r.value }, ratio: k }, o.value = !0;
    }
    function p(y) {
      var b;
      if (!c) return;
      const w = t.stage.value;
      if (!w) return;
      const k = (y.clientX - c.x0) / e.w, S = (y.clientY - c.y0) / e.h;
      if (c.kind === "move") {
        i.setCrop(Fde(c.start, k, S));
        return;
      }
      const _ = (b = c.ratio) != null ? b : y.shiftKey ? c.start.w * w.w / (c.start.h * w.h) : null;
      i.setCrop(Nde(c.start, c.kind, k, S, w.w, w.h, _, 16));
    }
    function f(y) {
      const b = y.currentTarget;
      b.hasPointerCapture(y.pointerId) && b.releasePointerCapture(y.pointerId), c = null, o.value = !1;
    }
    return (y, b) => (g(), v("div", {
      ref_key: "layer",
      ref: s,
      class: U(["sv-layer ed-crop", { "is-active": o.value }]),
      "data-testid": "studio-crop-frame"
    }, [
      h("i", {
        class: "shade",
        style: de({ left: 0, top: 0, width: n.w + "px", height: a.value.top + "px" })
      }, null, 4),
      h("i", {
        class: "shade",
        style: de({ left: 0, top: a.value.top + a.value.height + "px", width: n.w + "px", height: Math.max(0, n.h - a.value.top - a.value.height) + "px" })
      }, null, 4),
      h("i", {
        class: "shade",
        style: de({ left: 0, top: a.value.top + "px", width: a.value.left + "px", height: a.value.height + "px" })
      }, null, 4),
      h("i", {
        class: "shade",
        style: de({ left: a.value.left + a.value.width + "px", top: a.value.top + "px", width: Math.max(0, n.w - a.value.left - a.value.width) + "px", height: a.value.height + "px" })
      }, null, 4),
      h("div", {
        class: "ed-crop-box",
        style: de({ left: a.value.left + "px", top: a.value.top + "px", width: a.value.width + "px", height: a.value.height + "px" }),
        onPointerdown: b[0] || (b[0] = (w) => u("move", w)),
        onPointermove: p,
        onPointerup: f,
        onPointercancel: f
      }, [
        b[1] || (b[1] = h("i", { class: "third v1" }, null, -1)),
        b[2] || (b[2] = h("i", { class: "third v2" }, null, -1)),
        b[3] || (b[3] = h("i", { class: "third h1" }, null, -1)),
        b[4] || (b[4] = h("i", { class: "third h2" }, null, -1)),
        (g(), v(H, null, me(d, (w) => h("span", {
          key: w,
          class: U(["ed-crop-h", "h-" + w]),
          "data-handle": w,
          onPointerdown: (k) => u(w, k),
          onPointermove: p,
          onPointerup: f,
          onPointercancel: f
        }, null, 42, yue)), 64)),
        h("span", xue, A(l.value.w) + " × " + A(l.value.h), 1)
      ], 36)
    ], 2));
  }
}), kue = ["src"], _ue = ["data-handle", "onPointerdown"], Sue = { class: "ed-crop-size" }, A_ = 32, Tue = /* @__PURE__ */ Re({
  __name: "ExpandStage",
  props: {
    room: {}
  },
  setup(n) {
    const e = n, t = ft(), i = t.tools, s = I(() => t.stage.value), o = I(() => i.frame()), r = /* @__PURE__ */ K(!1), a = I(() => {
      const f = o.value;
      if (!f) return null;
      const y = Math.max(80, e.room.w - A_ * 2), b = Math.max(80, e.room.h - A_ * 2), w = Math.min(y / f.cw, b / f.ch), k = Math.round(f.cw * w), S = Math.round(f.ch * w);
      return { k: w, w: k, h: S, left: Math.round((e.room.w - k) / 2), top: Math.round((e.room.h - S) / 2) };
    }), l = I(() => {
      const f = o.value, y = a.value;
      return !f || !y ? null : { left: f.ix * y.k, top: f.iy * y.k, width: f.iw * y.k, height: f.ih * y.k };
    });
    let d = null;
    function c(f, y) {
      y.button !== 0 || !o.value || !a.value || (y.preventDefault(), y.stopPropagation(), y.currentTarget.setPointerCapture(y.pointerId), d = { kind: f, x0: y.clientX, y0: y.clientY, start: { ...o.value }, k: a.value.k }, r.value = !0);
    }
    function u(f) {
      if (!d) return;
      const y = (f.clientX - d.x0) / d.k, b = (f.clientY - d.y0) / d.k;
      if (d.kind === "pic") {
        i.setFrame(qde(d.start, y, b));
        return;
      }
      const w = d.kind === "e" ? y : d.kind === "w" ? -y : d.kind === "s" ? b : -b;
      let k = Wde(d.start, d.kind, Math.round(w));
      d.kind === "e" && (k = { ...k, cw: Math.max(k.cw, k.ix + k.iw * 0.5) }), d.kind === "s" && (k = { ...k, ch: Math.max(k.ch, k.iy + k.ih * 0.5) }), i.t.resize.frameRatio = "free", i.setFrame(k);
    }
    function p(f) {
      const y = f.currentTarget;
      y.hasPointerCapture(f.pointerId) && y.releasePointerCapture(f.pointerId), d = null, r.value = !1;
    }
    return (f, y) => s.value && a.value && l.value && o.value ? (g(), v("div", {
      key: 0,
      class: U(["ed-expand", { "is-active": r.value }]),
      style: de({ left: a.value.left + "px", top: a.value.top + "px", width: a.value.w + "px", height: a.value.h + "px" }),
      "data-testid": "studio-expand-frame"
    }, [
      y[2] || (y[2] = h("div", { class: "ed-expand-room" }, null, -1)),
      h("div", {
        class: "ed-expand-pic",
        style: de({ left: l.value.left + "px", top: l.value.top + "px", width: l.value.width + "px", height: l.value.height + "px" }),
        onPointerdown: y[0] || (y[0] = (b) => c("pic", b)),
        onPointermove: u,
        onPointerup: p,
        onPointercancel: p
      }, [
        h("img", {
          src: s.value.url,
          alt: "",
          draggable: "false"
        }, null, 8, kue)
      ], 36),
      (g(), v(H, null, me(["n", "s", "e", "w"], (b) => h("span", {
        key: b,
        class: U(["ed-expand-h", "h-" + b]),
        "data-handle": b,
        onPointerdown: (w) => c(b, w),
        onPointermove: u,
        onPointerup: p,
        onPointercancel: p
      }, [...y[1] || (y[1] = [
        h("i", null, null, -1)
      ])], 42, _ue)), 64)),
      h("span", Sue, A(Math.round(o.value.cw)) + " × " + A(Math.round(o.value.ch)), 1)
    ], 6)) : E("", !0);
  }
}), Mue = {
  key: 0,
  class: "ed-stage-note"
}, Cue = /* @__PURE__ */ Re({
  __name: "AdjustCanvas",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, i = ft().tools, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(!1);
    let a = null, l = "", d = { w: 1, h: 1 }, c = null, u = 0;
    const p = I(() => i.adjustSource());
    async function f() {
      const b = p.value;
      if (!(!b || !a) && b.url !== l) {
        l = b.url, o.value = !1;
        try {
          const w = await oi(b.url);
          if (!a || l !== b.url) return;
          a.setImage(w, w.width, w.height), d = { w: w.width, h: w.height }, o.value = !0, y();
        } catch (w) {
          console.warn("[board] Adjust couldn't read the picture", w), r.value = !0;
        }
      }
    }
    function y() {
      cancelAnimationFrame(u), u = requestAnimationFrame(() => {
        if (!a || !o.value) return;
        const b = i.t.adjust.a, w = Math.min(2, window.devicePixelRatio || 1), k = Dc(b, e.w, e.h), S = Math.max(1, Math.round(k.w * w)), _ = Math.max(1, Math.round(k.h * w)), x = Dc(b, d.w, d.h);
        a.render(b, S, _, { transfer: c, original: i.t.adjust.original, grainScale: S / Math.max(1, x.w) });
      });
    }
    return ot(() => {
      if (s.value) {
        try {
          a = new HC(s.value);
        } catch (b) {
          console.warn("[board] Adjust has no WebGL 2 here", b), r.value = !0;
          return;
        }
        f();
      }
    }), Ve(() => {
      cancelAnimationFrame(u), a && a.dispose(), a = null;
    }), $e(p, () => {
      f();
    }), $e(() => [i.t.adjust.a, i.t.adjust.original, e.w, e.h], y, { deep: !0 }), $e(() => [i.t.adjust.a.match.to, i.t.adjust.a.match.stats, p.value && p.value.url], async () => {
      c = await i.transfer(), y();
    }, { immediate: !0 }), (b, w) => (g(), v(H, null, [
      h("canvas", {
        ref_key: "el",
        ref: s,
        class: U(["ed-adjust-canvas", { "is-ready": o.value }]),
        style: de({ width: n.w + "px", height: n.h + "px" }),
        "data-testid": "studio-adjust-preview"
      }, null, 6),
      r.value ? (g(), v("span", Mue, "This picture can't be adjusted live here")) : E("", !0)
    ], 64));
  }
}), Iue = /* @__PURE__ */ Re({
  __name: "LayersPreview",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, t = ft(), i = t.tools, s = /* @__PURE__ */ K(null);
    let o = 0;
    const r = I(() => i.t.background), a = I(() => t.stage.value), l = I(() => i.cutoutFor(a.value)), d = I(() => {
      const f = a.value, y = l.value;
      return !f || !y ? null : y === f ? t.items.value.find((b) => b.id === f.parentId) || null : f;
    }), c = I(() => r.value.mode === "remove" ? r.value.fill !== void 0 && i.isCutout(a.value) : r.value.mode === "adjust" && !!l.value && !!d.value && zc(r.value.layer));
    async function u() {
      var f;
      const y = s.value;
      if (!y || !c.value) return;
      const b = Math.min(2, window.devicePixelRatio || 1), w = Math.max(1, Math.round(e.w * b)), k = Math.max(1, Math.round(e.h * b));
      try {
        let S;
        if (r.value.mode === "remove") {
          const x = await oi(a.value.url), T = $n(w, k);
          Dn(T).drawImage(x, 0, 0, w, k), S = BC(T, (f = r.value.fill) != null ? f : null);
        } else {
          const [x, T] = await Promise.all([oi(d.value.url), oi(l.value.url)]);
          S = FC(x, T, r.value.layer, w, k);
        }
        y.width = w, y.height = k;
        const _ = Dn(y);
        _.clearRect(0, 0, w, k), _.drawImage(S, 0, 0);
      } catch (S) {
        console.warn("[board] the background preview couldn't be drawn", S);
      }
    }
    function p() {
      cancelAnimationFrame(o), o = requestAnimationFrame(() => {
        u();
      });
    }
    return ot(p), Ve(() => cancelAnimationFrame(o)), $e(() => [r.value.fill, r.value.layer, r.value.mode, e.w, e.h, a.value && a.value.url, c.value], p, { deep: !0 }), (f, y) => (g(), Ce(vt, { name: "ed-fade" }, {
      default: et(() => [
        xt(h("canvas", {
          ref_key: "el",
          ref: s,
          class: U(["ed-layers-canvas", { "is-clear": r.value.mode === "remove" && r.value.fill === null }]),
          style: de({ width: n.w + "px", height: n.h + "px" }),
          "data-testid": "studio-background-preview"
        }, null, 6), [
          [qb, c.value]
        ])
      ]),
      _: 1
    }));
  }
}), Aue = ["src"], Pue = { class: "ed-compare-tag is-left" }, Eue = { class: "ed-compare-tag is-right" }, Rue = {
  key: 1,
  class: "ed-compare-tag is-left"
}, zue = /* @__PURE__ */ Re({
  __name: "CompareOverlay",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = ft(), t = e.tools, i = I(() => t.t.compare), s = I(() => i.value && e.items.value.find((f) => f.id === i.value.with) || null), o = I(() => s.value ? e.names.value.get(s.value.id) || s.value.label : ""), r = I(() => e.stage.value ? e.names.value.get(e.stage.value.id) || "This" : ""), a = /* @__PURE__ */ K(null);
    let l = !1;
    function d(f) {
      if (!a.value || !t.t.compare) return;
      const y = a.value.getBoundingClientRect();
      t.t.compare.at = Math.min(1, Math.max(0, (f.clientX - y.left) / y.width));
    }
    function c(f) {
      if (!(f.button !== 0 || !i.value)) {
        if (f.stopPropagation(), i.value.mode === "toggle") {
          t.t.compare.other = !0;
          return;
        }
        l = !0, f.currentTarget.setPointerCapture(f.pointerId), d(f);
      }
    }
    function u(f) {
      l && d(f);
    }
    function p() {
      l = !1, t.t.compare && (t.t.compare.other = !1);
    }
    return (f, y) => i.value && s.value ? (g(), v("div", {
      key: 0,
      ref_key: "layer",
      ref: a,
      class: U(["sv-layer ed-compare", "is-" + i.value.mode]),
      "data-testid": "studio-compare-view",
      onPointerdown: c,
      onPointermove: u,
      onPointerup: p,
      onPointercancel: p,
      onPointerleave: p
    }, [
      h("div", {
        class: "ed-compare-other",
        style: de(i.value.mode === "split" ? { clipPath: "inset(0 " + (100 - i.value.at * 100) + "% 0 0)" } : { opacity: i.value.other ? 1 : 0 })
      }, [
        h("img", {
          src: s.value.url,
          alt: "",
          draggable: "false"
        }, null, 8, Aue)
      ], 4),
      i.value.mode === "split" ? (g(), v(H, { key: 0 }, [
        h("i", {
          class: "ed-compare-line",
          style: de({ left: i.value.at * 100 + "%" })
        }, [
          h("span", null, [
            C(R, {
              name: "ChevronLeft",
              size: 12
            }),
            C(R, {
              name: "ChevronRight",
              size: 12
            })
          ])
        ], 4),
        h("span", Pue, A(o.value), 1),
        h("span", Eue, A(r.value), 1)
      ], 64)) : (g(), v("span", Rue, A(i.value.other ? o.value : r.value) + " · press and hold to see " + A(i.value.other ? r.value : o.value), 1))
    ], 34)) : E("", !0);
  }
}), $ue = {
  key: 0,
  class: "ed-cam-stage",
  "data-testid": "studio-camera-preview"
}, Due = { class: "ed-cam-view" }, Oue = ["src"], Lue = { class: "ed-cam-hud" }, Bue = /* @__PURE__ */ Re({
  __name: "CameraPreview",
  props: {
    room: {}
  },
  setup(n) {
    const e = n, t = ft(), i = I(() => t.stage.value), s = I(() => Xs(t.tools.t.camera.set)), o = I(() => {
      const d = i.value;
      if (!d) return null;
      const u = Math.min(e.room.w * 0.42, e.room.h * 0.5) / Math.max(d.w, d.h), p = Math.round(d.w * u), f = Math.round(d.h * u);
      return { w: p, h: f, d: Math.round(Math.min(p, f) * 0.55) };
    }), r = I(() => {
      const d = s.value;
      return { transform: "scale(" + (0.8 + d.zoom / 10 * 0.45).toFixed(3) + ") rotateX(" + (-d.vertical * 0.72).toFixed(1) + "deg) rotateY(" + (-xy(d.rotate)).toFixed(1) + "deg)" };
    }), a = I(() => i.value ? 'url("' + i.value.url + '")' : "none");
    function l(d, c, u, p) {
      const f = o.value;
      return {
        width: d + "px",
        height: c + "px",
        left: (f.w - d) / 2 + "px",
        top: (f.h - c) / 2 + "px",
        transform: u,
        backgroundImage: a.value,
        backgroundPosition: p,
        backgroundSize: f.w + "px " + f.h + "px"
      };
    }
    return (d, c) => i.value && o.value ? (g(), v("div", $ue, [
      h("div", Due, [
        h("div", {
          class: "ed-cam-scene",
          style: de({ ...r.value, top: o.value.h / 2 + "px" })
        }, [
          c[1] || (c[1] = h("div", { class: "ed-cam-floor" }, null, -1)),
          h("div", {
            class: "ed-cam-box",
            style: de({ width: o.value.w + "px", height: o.value.h + "px", marginLeft: -o.value.w / 2 + "px", marginTop: -o.value.h + "px" })
          }, [
            h("img", {
              class: "ed-cam-face is-front",
              src: i.value.url,
              alt: "",
              draggable: "false",
              style: de({ transform: "translateZ(" + o.value.d / 2 + "px)" })
            }, null, 12, Oue),
            h("i", {
              class: "ed-cam-face is-side",
              style: de(l(o.value.d, o.value.h, "rotateY(90deg) translateZ(" + o.value.w / 2 + "px)", "right center"))
            }, null, 4),
            h("i", {
              class: "ed-cam-face is-side",
              style: de(l(o.value.d, o.value.h, "rotateY(-90deg) translateZ(" + o.value.w / 2 + "px)", "left center"))
            }, null, 4),
            h("i", {
              class: "ed-cam-face is-side is-top",
              style: de(l(o.value.w, o.value.d, "rotateX(90deg) translateZ(" + o.value.h / 2 + "px)", "center top"))
            }, null, 4),
            h("i", {
              class: "ed-cam-face is-back",
              style: de(l(o.value.w, o.value.h, "rotateY(180deg) translateZ(" + o.value.d / 2 + "px)", "center"))
            }, [...c[0] || (c[0] = [
              h("span", null, "Not in the picture: invented", -1)
            ])], 4)
          ], 4)
        ], 4)
      ]),
      h("div", Lue, [
        h("b", null, A(m(sc)(s.value)), 1),
        h("span", null, "A preview of the move. The model draws the new view" + A(m(cC)(s.value) ? ", inventing what the picture doesn't show" : "") + ".", 1)
      ])
    ])) : E("", !0);
  }
}), Fue = {
  key: 0,
  class: "ed-relight-preview",
  "data-testid": "studio-relight-preview"
}, Nue = /* @__PURE__ */ Re({
  __name: "RelightPreview",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = ft(), t = I(() => e.tools.t.relight.rig);
    function i(a) {
      const l = df(a), d = (a.rotate % 360 + 360) % 360, c = d >= 135 && d <= 225, u = Math.min(0.85, 0.25 + a.intensity * 0.06);
      if (c)
        return "radial-gradient(ellipse 70% 80% at 50% 50%, transparent 55%, " + a.color + " 100%)";
      const p = 50 + l.x * 62, f = 50 + l.y * 62;
      return "radial-gradient(circle at " + p.toFixed(0) + "% " + f.toFixed(0) + "%, " + a.color + " 0%, " + s(a.color, u * 0.55) + " 26%, transparent " + (t.value.softness === "soft" ? 78 : 58) + "%)";
    }
    function s(a, l) {
      const d = /^#?([0-9a-f]{6})$/i.exec(a), c = d ? parseInt(d[1], 16) : 16777215;
      return "rgba(" + (c >> 16 & 255) + "," + (c >> 8 & 255) + "," + (c & 255) + "," + l.toFixed(2) + ")";
    }
    const o = I(() => t.value.lights[0] || null), r = I(() => {
      const a = o.value;
      if (!a) return "";
      const l = df(a);
      return Math.hypot(l.x, l.y) < 0.25 ? "" : "radial-gradient(circle at " + (50 - l.x * 70).toFixed(0) + "% " + (50 - l.y * 70).toFixed(0) + "%, rgba(4,3,12,0.5), transparent 70%)";
    });
    return (a, l) => t.value.mode === "relight" ? (g(), v("div", Fue, [
      r.value ? (g(), v("i", {
        key: 0,
        class: "shade",
        style: de({ background: r.value })
      }, null, 4)) : E("", !0),
      (g(!0), v(H, null, me(t.value.lights, (d) => (g(), v("i", {
        key: d.id,
        class: "wash",
        style: de({ background: i(d), opacity: Math.min(0.9, 0.3 + d.intensity * 0.05) })
      }, null, 4))), 128)),
      l[0] || (l[0] = h("span", { class: "ed-stage-note" }, "A hint of the light. The model relights the picture.", -1))
    ])) : E("", !0);
  }
}), Uue = ["aria-label"], Gue = { class: "ed-guard-card" }, jue = { class: "ic" }, Hue = { class: "tx" }, Vue = { class: "acts" }, Wue = /* @__PURE__ */ Re({
  __name: "GuardAsk",
  setup(n) {
    const e = ft(), t = e.tools, i = I(() => t.t.guard), s = I(() => i.value ? Cy(i.value.tool) : null), o = I(() => {
      const l = i.value ? i.value.tool : null;
      return l === "resize" ? t.t.resize.mode === "crop" ? "your crop" : "the expanded frame" : l === "background" ? t.t.background.mode === "adjust" ? "your background adjustments" : "the new background" : l === "adjust" ? "your adjustments" : "your changes";
    }), r = I(() => (i.value ? i.value.tool : null) === "resize" && t.t.resize.mode === "expand" ? "Expand (" + e.priceOf("expand") + ")" : "Apply");
    function a(l) {
      i.value && (l.key === "Escape" ? (l.preventDefault(), l.stopImmediatePropagation(), t.stay()) : l.key === "Enter" && (l.preventDefault(), l.stopImmediatePropagation(), t.answer(!0)));
    }
    return ot(() => window.addEventListener("keydown", a, !0)), Ve(() => window.removeEventListener("keydown", a, !0)), (l, d) => (g(), Ce(vt, { name: "ed-guard" }, {
      default: et(() => [
        i.value && s.value ? (g(), v("div", {
          key: 0,
          class: "ed-guard",
          role: "alertdialog",
          "aria-modal": "true",
          "aria-label": "Apply " + o.value + "?",
          "data-testid": "studio-tool-guard",
          onPointerdown: d[2] || (d[2] = Pe((c) => m(t).stay(), ["self"]))
        }, [
          h("div", Gue, [
            h("span", jue, [
              C(R, {
                name: s.value.icon,
                size: 16
              }, null, 8, ["name"])
            ]),
            h("div", Hue, [
              h("b", null, "Apply " + A(o.value) + "?", 1),
              h("span", null, A(s.value.label) + " has a change that isn't a version yet. Apply makes it one; Discard leaves the picture as it was.", 1)
            ]),
            h("div", Vue, [
              h("button", {
                class: "sv-btn",
                "data-testid": "studio-tool-discard",
                onClick: d[0] || (d[0] = (c) => m(t).answer(!1))
              }, "Discard"),
              h("button", {
                class: "sv-btn is-primary",
                "data-testid": "studio-tool-apply",
                onClick: d[1] || (d[1] = (c) => m(t).answer(!0))
              }, A(r.value), 1)
            ])
          ])
        ], 40, Uue)) : E("", !0)
      ]),
      _: 1
    }));
  }
}), que = ["disabled", "title"], Kue = ["aria-expanded", "aria-label"], Yue = ["disabled", "title"], Xue = {
  key: 0,
  class: "sv-pop sv-zoom-pop",
  role: "menu",
  "aria-label": "Zoom",
  "data-testid": "studio-zoom-menu"
}, Jue = ["disabled"], Zue = ["disabled"], Que = ["disabled"], ehe = /* @__PURE__ */ Re({
  __name: "StageZoom",
  props: {
    share: {},
    fitted: { type: Boolean },
    atMin: { type: Boolean },
    atMax: { type: Boolean }
  },
  emits: ["step", "fit", "actual"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ K(!1), o = /* @__PURE__ */ K(null), r = I(() => Math.round(t.share * 100) + "%"), a = {
      in: Tn(["mod", "+"]),
      out: Tn(["mod", "-"]),
      actual: Tn(["mod", "0"]),
      fit: "D"
    };
    function l(p) {
      s.value = !1, p === "in" ? i("step", 1) : p === "out" ? i("step", -1) : i(p === "actual" ? "actual" : "fit");
    }
    function d(p) {
      o.value && !o.value.contains(p.target) && (s.value = !1);
    }
    function c(p) {
      p.key === "Escape" && (p.stopPropagation(), p.preventDefault(), s.value = !1);
    }
    function u() {
      window.removeEventListener("pointerdown", d, !0), window.removeEventListener("keydown", c, !0);
    }
    return $e(s, (p) => {
      if (!p) {
        u();
        return;
      }
      window.addEventListener("pointerdown", d, !0), window.addEventListener("keydown", c, !0);
    }), Ve(u), (p, f) => (g(), v("span", {
      ref_key: "wrap",
      ref: o,
      class: "sv-zoom",
      "data-testid": "studio-zoom",
      onPointerdown: f[7] || (f[7] = Pe(() => {
      }, ["stop"]))
    }, [
      h("button", {
        class: "sv-zoom-btn",
        disabled: n.atMin,
        title: "Zoom out (" + a.out + ")",
        "aria-label": "Zoom out",
        "data-testid": "studio-zoom-out",
        onClick: f[0] || (f[0] = (y) => i("step", -1))
      }, [
        C(R, {
          name: "Minus",
          size: 12
        })
      ], 8, que),
      h("button", {
        class: U(["sv-zoom-pct", { on: s.value }]),
        "aria-haspopup": "menu",
        "aria-expanded": s.value,
        "aria-label": "Zoom: " + r.value,
        "data-testid": "studio-zoom-pct",
        onClick: f[1] || (f[1] = (y) => s.value = !s.value)
      }, [
        X(A(r.value), 1),
        C(R, {
          name: "ChevronDown",
          size: 11,
          class: "chev"
        })
      ], 10, Kue),
      h("button", {
        class: "sv-zoom-btn",
        disabled: n.atMax,
        title: "Zoom in (" + a.in + ")",
        "aria-label": "Zoom in",
        "data-testid": "studio-zoom-in",
        onClick: f[2] || (f[2] = (y) => i("step", 1))
      }, [
        C(R, {
          name: "Plus",
          size: 12
        })
      ], 8, Yue),
      s.value ? (g(), v("div", Xue, [
        h("button", {
          class: "sv-pop-row",
          role: "menuitem",
          disabled: n.atMax,
          "data-testid": "studio-zoom-menu-in",
          onClick: f[3] || (f[3] = (y) => l("in"))
        }, [
          f[8] || (f[8] = h("span", { class: "nm" }, "Zoom in", -1)),
          h("kbd", null, A(a.in), 1)
        ], 8, Jue),
        h("button", {
          class: "sv-pop-row",
          role: "menuitem",
          disabled: n.atMin,
          "data-testid": "studio-zoom-menu-out",
          onClick: f[4] || (f[4] = (y) => l("out"))
        }, [
          f[9] || (f[9] = h("span", { class: "nm" }, "Zoom out", -1)),
          h("kbd", null, A(a.out), 1)
        ], 8, Zue),
        h("button", {
          class: "sv-pop-row",
          role: "menuitem",
          "data-testid": "studio-zoom-menu-actual",
          onClick: f[5] || (f[5] = (y) => l("actual"))
        }, [
          f[10] || (f[10] = h("span", { class: "nm" }, "Zoom to 100%", -1)),
          h("kbd", null, A(a.actual), 1)
        ]),
        h("button", {
          class: "sv-pop-row",
          role: "menuitem",
          disabled: n.fitted,
          "data-testid": "studio-zoom-menu-fit",
          onClick: f[6] || (f[6] = (y) => l("fit"))
        }, [
          f[11] || (f[11] = h("span", { class: "nm" }, "Zoom to fit", -1)),
          h("kbd", null, A(a.fit), 1)
        ], 8, Que)
      ])) : E("", !0)
    ], 544));
  }
}), ph = { k: 1, cx: 0.5, cy: 0.5 }, cr = [0.1, 0.125, 0.25, 1 / 3, 0.5, 2 / 3, 1, 1.5, 2, 3, 4, 6, 8], the = 8, nhe = 0.25;
function P_(n) {
  return Math.abs(n.k - 1) < 1e-4 && Math.abs(n.cx - 0.5) < 1e-4 && Math.abs(n.cy - 0.5) < 1e-4;
}
function nI(n, e) {
  const t = n.w * e.k, i = n.h * e.k;
  return { left: n.left + n.w / 2 - e.cx * t, top: n.top + n.h / 2 - e.cy * i, w: t, h: i };
}
function ihe(n, e) {
  const t = Math.max(n.left, e.left), i = Math.max(n.top, e.top), s = Math.min(n.left + n.w, e.left + e.w), o = Math.min(n.top + n.h, e.top + e.h);
  return { left: t, top: i, w: Math.max(0, s - t), h: Math.max(0, o - i) };
}
function E_(n, e, t) {
  const i = (s, o, r, a, l) => {
    if (o <= l) return 0.5;
    const d = (r - a) / o, c = (r + o - a - l) / o;
    return Math.min(c, Math.max(d, s));
  };
  return {
    k: n.k,
    cx: i(n.cx, e.w * n.k, e.left + e.w / 2, t.left, t.w),
    cy: i(n.cy, e.h * n.k, e.top + e.h / 2, t.top, t.h)
  };
}
function she(n, e, t, i, s) {
  const o = nI(s, n), r = (t - o.left) / o.w, a = (i - o.top) / o.h;
  return { k: e, cx: (s.left + s.w / 2 - t) / (s.w * e) + r, cy: (s.top + s.h / 2 - i) / (s.h * e) + a };
}
function R_(n, e, t, i) {
  return { k: n.k, cx: n.cx - e / (i.w * n.k), cy: n.cy - t / (i.h * n.k) };
}
function ohe(n, e, t) {
  return e * n / Math.max(1, t);
}
function f0(n, e, t) {
  return n * Math.max(1, t) / Math.max(1, e);
}
function rhe(n, e) {
  return { min: nhe, max: Math.max(1, f0(the, n, e)) };
}
function ahe(n, e) {
  if (e > 0) {
    const t = cr.find((i) => i > n * 1.01);
    return t == null ? cr[cr.length - 1] : t;
  }
  for (let t = cr.length - 1; t >= 0; t--) if (cr[t] < n * 0.99) return cr[t];
  return cr[0];
}
function lhe(n) {
  return Math.exp(-Math.max(-60, Math.min(60, n)) / 100);
}
const dhe = {
  key: 1,
  class: "sv-invite",
  "data-testid": "studio-3d-empty"
}, che = { class: "sv-invite-mark" }, uhe = {
  key: 0,
  class: "sv-model-state is-inline",
  "data-testid": "studio-3d-keeping"
}, hhe = {
  key: 1,
  class: "sv-invite-acts"
}, phe = { class: "sv-pic-clip" }, fhe = ["src", "poster"], mhe = ["src"], ghe = {
  key: 0,
  class: "sv-pic-unsaved is-marks",
  title: "Its annotations go with it when it's sent"
}, bhe = {
  key: 3,
  class: "sv-promote is-done",
  "data-testid": "studio-stage-on-board",
  title: "This is the version the board shows"
}, vhe = {
  key: 4,
  class: "ed-stage-tools"
}, yhe = ["aria-pressed", "title"], xhe = {
  key: 0,
  class: "sv-seg is-small is-dark"
}, whe = {
  key: 0,
  class: "ed-baking"
}, khe = {
  key: 5,
  class: "sv-invite is-making"
}, _he = {
  key: 6,
  class: "sv-invite",
  "data-testid": "studio-edit-empty"
}, She = { class: "sv-invite-mark" }, The = { class: "sv-invite-acts" }, Mhe = {
  key: 7,
  class: "sv-invite",
  "data-testid": "studio-empty"
}, Che = { class: "sv-invite-mark" }, Ihe = { class: "sv-invite-acts" }, Ahe = {
  key: 8,
  class: "sv-invite",
  "data-testid": "studio-empty"
}, Phe = { class: "sv-invite-mark" }, Ehe = { class: "sv-invite-acts" }, hd = 8, Rhe = /* @__PURE__ */ Re({
  __name: "Stage",
  emits: ["upload", "upload-model", "library-model"],
  setup(n, { expose: e, emit: t }) {
    const i = t, s = ft(), { board: o } = tt(), r = s.s, a = s.tools, l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K({ w: 800, h: 600 }), c = /* @__PURE__ */ K(null), u = /* @__PURE__ */ K(""), p = /* @__PURE__ */ K(null), f = I(() => s.stage.value), y = I(() => {
      const ae = f.value && s.resultOf(f.value);
      return ae && ae.video && ae.videoSrc || null;
    }), b = I(() => s.side.value === "edit"), w = I(() => b.value ? a.t.open : null), k = I(() => w.value === "resize" && a.t.resize.mode === "expand"), S = I(() => w.value === "adjust"), _ = I(() => w.value === "camera"), x = I(() => {
      const ae = f.value;
      if (!ae) return null;
      if (S.value) {
        const Me = a.adjustSource() || ae;
        return Dc(a.t.adjust.a, Me.w, Me.h);
      }
      return { w: ae.w, h: ae.h };
    }), T = I(() => {
      const ae = x.value;
      if (!ae) return null;
      const Me = 32, Xe = Math.max(80, d.value.w - Me * 2), Rt = Math.max(80, d.value.h - Me * 2), Hn = Math.min(Xe / ae.w, Rt / ae.h), Jo = Math.round(ae.w * Hn), Zo = Math.round(ae.h * Hn);
      return { w: Jo, h: Zo, left: Math.round((d.value.w - Jo) / 2), top: Math.round((d.value.h - Zo) / 2) };
    }), M = /* @__PURE__ */ K({ ...ph }), z = /* @__PURE__ */ K(null), P = /* @__PURE__ */ K(!1);
    let D = 0;
    const $ = I(() => !!f.value && f.value.status === "done" && !!T.value && r.studio !== "threed" && !k.value && !_.value && w.value !== "resize"), O = I(() => ({ left: hd, top: hd, w: Math.max(1, d.value.w - hd * 2), h: Math.max(1, d.value.h - hd * 2) })), L = I(() => $.value ? M.value : ph), Z = I(() => !P_(L.value)), J = I(() => T.value ? nI(T.value, L.value) : null), re = I(() => J.value ? Z.value ? ihe(J.value, O.value) : J.value : null), F = I(() => {
      const ae = x.value, Me = f.value;
      if (!ae) return 1;
      const Xe = z.value;
      return Xe && Me && Me.w ? Xe.w * (ae.w / Me.w) : ae.w;
    }), W = I(() => T.value ? ohe(L.value.k, T.value.w, F.value) : 1), ee = I(() => T.value ? rhe(T.value.w, F.value) : { min: 1, max: 1 }), N = I(() => Z.value && !!re.value && re.value.top < hd + 30), te = I(() => {
      const ae = re.value;
      return ae ? { left: ae.left + "px", top: ae.top + "px", width: ae.w + "px", height: ae.h + "px" } : {};
    }), G = I(() => {
      const ae = J.value, Me = re.value, Xe = T.value;
      if (!Z.value || !ae || !Me || !Xe) return {};
      const Rt = L.value.k;
      return { left: ae.left - Me.left + "px", top: ae.top - Me.top + "px", width: Xe.w + "px", height: Xe.h + "px", transform: "scale(" + Rt + ")", "--zoom": String(Rt) };
    });
    function q(ae, Me = !1) {
      const Xe = T.value;
      Xe && (M.value = E_(ae, Xe, O.value), P.value = Me, clearTimeout(D), Me && (D = window.setTimeout(() => {
        P.value = !1;
      }, 280)));
    }
    function B(ae, Me = null, Xe = !0) {
      const Rt = T.value;
      if (!Rt || !$.value) return;
      const Hn = Math.min(ee.value.max, Math.max(ee.value.min, ae)), Jo = Me || { x: O.value.left + O.value.w / 2, y: O.value.top + O.value.h / 2 };
      q(she(M.value, Hn, Jo.x, Jo.y, Rt), Xe);
    }
    function ne(ae) {
      const Me = T.value;
      Me && B(f0(ahe(W.value, ae), Me.w, F.value));
    }
    function se() {
      $.value && q({ ...ph }, !0);
    }
    function Y() {
      const ae = T.value;
      ae && B(f0(1, ae.w, F.value));
    }
    function ie(ae, Me) {
      if (!$.value) return !1;
      const Xe = vn(ae);
      if (Xe && (ae.key === "=" || ae.key === "+")) ne(1);
      else if (Xe && (ae.key === "-" || ae.key === "_")) ne(-1);
      else if (Xe && ae.key === "0") Y();
      else if (!Xe && !Me && !ae.altKey && !ae.shiftKey && ae.key.toLowerCase() === "d") se();
      else return !1;
      return !0;
    }
    function De(ae) {
      const Me = T.value, Xe = J.value;
      if (!$.value || !Me || !Xe || !l.value) return;
      const Rt = l.value.getBoundingClientRect(), Hn = ae.deltaMode === 1 ? 16 : ae.deltaMode === 2 ? Rt.height : 1;
      if (ae.ctrlKey || ae.metaKey) {
        ae.preventDefault(), B(M.value.k * lhe(ae.deltaY * Hn), { x: ae.clientX - Rt.left, y: ae.clientY - Rt.top }, !1);
        return;
      }
      Xe.w <= O.value.w + 0.5 && Xe.h <= O.value.h + 0.5 || (ae.preventDefault(), q(R_(M.value, -ae.deltaX * Hn, -ae.deltaY * Hn, Me)));
    }
    const xe = /* @__PURE__ */ K(!1), Oe = /* @__PURE__ */ K(!1);
    let Ee = null;
    function j(ae) {
      const Me = ae;
      return !!Me && (Me.tagName === "INPUT" || Me.tagName === "TEXTAREA" || Me.isContentEditable);
    }
    function V(ae) {
      ae.code !== "Space" || j(ae.target) || !$.value || (ae.preventDefault(), xe.value = !0);
    }
    function Q(ae) {
      ae.code === "Space" && (xe.value && ae.preventDefault(), xe.value = !1);
    }
    function oe() {
      xe.value = !1;
    }
    function ue(ae) {
      !$.value || !l.value || !(xe.value && ae.button === 0) && ae.button !== 1 || (ae.preventDefault(), ae.stopPropagation(), l.value.setPointerCapture(ae.pointerId), Ee = { id: ae.pointerId, x: ae.clientX, y: ae.clientY }, Oe.value = !0);
    }
    function Ie(ae) {
      const Me = T.value;
      !Ee || Ee.id !== ae.pointerId || !Me || (q(R_(M.value, ae.clientX - Ee.x, ae.clientY - Ee.y, Me)), Ee = { id: Ee.id, x: ae.clientX, y: ae.clientY });
    }
    function he(ae) {
      !Ee || Ee.id !== ae.pointerId || (l.value && l.value.hasPointerCapture(ae.pointerId) && l.value.releasePointerCapture(ae.pointerId), Ee = null, Oe.value = !1);
    }
    function ye(ae) {
      const Me = ae.target;
      f.value && (u.value = f.value.url), Me.naturalWidth && (z.value = { w: Me.naturalWidth, h: Me.naturalHeight });
    }
    function fe(ae) {
      const Me = ae.target;
      f.value && (u.value = f.value.url), Me.videoWidth && (z.value = { w: Me.videoWidth, h: Me.videoHeight });
    }
    let ze = 0;
    $e(() => f.value && f.value.status === "done" ? x.value : null, (ae) => {
      if (!ae) return;
      const Me = ae.h ? ae.w / ae.h : 0;
      (!ze || !Me || Math.abs(Me - ze) / ze > 0.04) && (M.value = { ...ph }), ze = Me;
    }, { immediate: !0 }), $e(() => f.value ? f.value.url : null, () => {
      z.value = null;
    });
    let He = 0;
    $e([T, O, ee], () => {
      const ae = T.value;
      if (!ae) return;
      const Me = He;
      if (He = ae.w, P_(M.value)) return;
      const Xe = Me && Me !== ae.w ? M.value.k * (Me / ae.w) : M.value.k, Rt = Math.min(ee.value.max, Math.max(ee.value.min, Xe));
      M.value = E_({ ...M.value, k: Rt }, ae, O.value);
    });
    const ce = I(() => b.value && !w.value && r.bar === "annotate"), be = I(() => ce.value && r.tool === "note"), Be = I(() => b.value && !w.value && r.bar !== "annotate"), Fe = I(() => {
      const ae = s.marksOf(f.value);
      return w.value ? { strokes: [], pins: [] } : be.value ? { strokes: ae.strokes, pins: [] } : { strokes: ae.strokes, pins: ae.pins };
    }), Ke = I(() => r.editingText ? [r.editingText] : []), Qe = I(() => {
      const ae = f.value;
      if (!ae) return "";
      const Me = s.names.value.get(ae.id), Xe = ae.parentId ? s.names.value.get(ae.parentId) : null, Rt = Me ? Me + (Xe && Me !== "Original" ? " · from " + Xe : "") : "";
      return ae.kind === "gen" ? Rt || "Generation" : ae.how === "tool" ? [Rt, ae.made ? ae.made.label : ""].filter(Boolean).join(" · ") || "Version" : "Reference · " + (nl[ae.how || "upload"].text + (ae.how === "board" && s.sessionName(ae) ? " (" + s.sessionName(ae) + ")" : "")) + (Rt ? " · " + Rt : "");
    }), ht = I(() => {
      const ae = f.value;
      return !!ae && ae.status === "done" && !b.value && !y.value && s.limit.value > 0 && r.queue[0] !== ae.id;
    }), Le = I(() => {
      const ae = f.value;
      return ae ? s.names.value.get(ae.id) || "this" : "";
    }), Ne = I(() => s.card.value), le = I(() => !!f.value && s.onCard(f.value.id)), ve = I(() => !!Ne.value && !!f.value && f.value.status === "done" && !le.value), we = I(() => a.compareDefault()), je = I(() => !!a.t.compare);
    function Se() {
      a.t.compare ? a.compare(null) : a.compare(we.value);
    }
    $e(() => r.stageId, () => a.stageChanged());
    let Te = null;
    return ot(() => {
      l.value && (Te = new ResizeObserver((ae) => {
        const Me = ae[ae.length - 1].contentRect;
        d.value = { w: Me.width, h: Me.height };
      }), Te.observe(l.value));
    }), ot(() => {
      window.addEventListener("keydown", V), window.addEventListener("keyup", Q), window.addEventListener("blur", oe);
    }), Ve(() => {
      Te && Te.disconnect(), clearTimeout(D), window.removeEventListener("keydown", V), window.removeEventListener("keyup", Q), window.removeEventListener("blur", oe);
    }), e({ model: p, zoomKey: ie }), (ae, Me) => (g(), v("div", {
      ref_key: "area",
      ref: l,
      class: U(["sv-stage", { "is-threed": m(r).studio === "threed", ["tool-" + w.value]: !!w.value, "is-space": xe.value && $.value, "is-panning": Oe.value }]),
      "data-testid": "studio-stage",
      onWheel: De,
      onPointerdownCapture: ue,
      onPointermove: Ie,
      onPointerup: he,
      onPointercancel: he
    }, [
      m(r).studio === "threed" && m(s).model3d.value ? (g(), Ce(fue, {
        key: 0,
        ref_key: "model",
        ref: p
      }, null, 512)) : m(r).studio === "threed" ? (g(), v("div", dhe, [
        h("span", che, [
          C(R, {
            name: "Box",
            size: 20
          })
        ]),
        Me[16] || (Me[16] = h("b", null, "Start from a 3D model", -1)),
        Me[17] || (Me[17] = h("span", { class: "sub" }, "Bring in a .glb, .gltf, .obj or .stl, find the view you want, and generate from it. Models you bring in stay with the session, and so do the views you save.", -1)),
        m(r).three.keeping ? (g(), v("div", uhe, [
          Me[12] || (Me[12] = h("span", { class: "sv-making" }, null, -1)),
          X(" Keeping " + A(m(r).three.keeping) + " in your Library, then opening it", 1)
        ])) : (g(), v("div", hhe, [
          h("button", {
            class: "sv-btn is-primary",
            "data-testid": "studio-3d-upload",
            onClick: Me[0] || (Me[0] = (Xe) => i("upload-model"))
          }, [
            C(R, {
              name: "Upload",
              size: 14
            }),
            Me[13] || (Me[13] = X(" From your computer", -1))
          ]),
          m(o).hasLibrary ? (g(), v("button", {
            key: 0,
            class: "sv-btn",
            "data-testid": "studio-3d-library",
            onClick: Me[1] || (Me[1] = (Xe) => i("library-model"))
          }, [
            C(R, {
              name: "Library",
              size: 14
            }),
            Me[14] || (Me[14] = X(" From your Library", -1))
          ])) : E("", !0),
          h("button", {
            class: "sv-btn",
            "data-testid": "studio-3d-sample",
            onClick: Me[2] || (Me[2] = (Xe) => m(s).addSample())
          }, [
            C(R, {
              name: "Building2",
              size: 14
            }),
            Me[15] || (Me[15] = X(" Try the sample", -1))
          ])
        ]))
      ])) : f.value && k.value ? (g(), Ce(Tue, {
        key: 2,
        room: d.value
      }, null, 8, ["room"])) : f.value && _.value ? (g(), Ce(Bue, {
        key: 3,
        room: d.value
      }, null, 8, ["room"])) : f.value && T.value && re.value ? (g(), v("div", {
        key: 4,
        class: U(["sv-pic", { "is-loading": f.value.status === "pending" || u.value !== f.value.url, "is-editing": b.value && !w.value, "is-failed": f.value.status === "failed", "is-tool": !!w.value, "is-cutout": m(s).tools.isCutout(f.value), "is-viewed": Z.value, "is-tag-inside": N.value, "is-gliding": P.value }]),
        style: de(te.value)
      }, [
        h("div", phe, [
          h("div", {
            class: "sv-pic-view",
            style: de(G.value),
            "data-testid": "studio-pic-view"
          }, [
            y.value ? (g(), v("video", {
              key: y.value,
              src: y.value,
              poster: f.value.url || void 0,
              controls: "",
              loop: "",
              playsinline: "",
              preload: "metadata",
              "data-testid": "studio-stage-video",
              onLoadedmetadata: fe
            }, null, 40, fhe)) : f.value.url ? (g(), v("img", {
              key: f.value.url,
              src: f.value.url,
              alt: "",
              draggable: "false",
              onLoad: ye
            }, null, 40, mhe)) : E("", !0),
            S.value ? (g(), Ce(Cue, {
              key: 2,
              w: T.value.w,
              h: T.value.h
            }, null, 8, ["w", "h"])) : E("", !0),
            w.value === "background" ? (g(), Ce(Iue, {
              key: 3,
              w: T.value.w,
              h: T.value.h
            }, null, 8, ["w", "h"])) : E("", !0),
            w.value === "relight" ? (g(), Ce(Nue, {
              key: 4,
              w: T.value.w,
              h: T.value.h
            }, null, 8, ["w", "h"])) : E("", !0),
            C(CC, {
              marks: Fe.value,
              w: f.value.w,
              h: f.value.h,
              live: c.value,
              hide: Ke.value,
              fit: "none"
            }, null, 8, ["marks", "w", "h", "live", "hide"]),
            Be.value && !je.value ? (g(), Ce(vue, {
              key: 5,
              w: T.value.w,
              h: T.value.h
            }, null, 8, ["w", "h"])) : ce.value && !be.value && !je.value ? (g(), Ce(Kce, {
              key: 6,
              w: T.value.w,
              h: T.value.h,
              onLive: Me[3] || (Me[3] = (Xe) => c.value = Xe)
            }, null, 8, ["w", "h"])) : be.value && !je.value ? (g(), Ce(eue, {
              key: 7,
              w: T.value.w,
              h: T.value.h
            }, null, 8, ["w", "h"])) : E("", !0),
            w.value === "resize" && !je.value ? (g(), Ce(wue, {
              key: 8,
              w: T.value.w,
              h: T.value.h
            }, null, 8, ["w", "h"])) : E("", !0),
            je.value ? (g(), Ce(zue, {
              key: 9,
              w: T.value.w,
              h: T.value.h
            }, null, 8, ["w", "h"])) : E("", !0)
          ], 4)
        ]),
        h("span", {
          class: U(["sv-pic-tag", { "is-ref": f.value.kind === "ref" && f.value.how !== "tool" }])
        }, A(Qe.value), 3),
        !b.value && m(s).marked(f.value.id) ? (g(), v("span", ghe, [
          C(R, {
            name: "Pencil",
            size: 11
          }),
          Me[18] || (Me[18] = X(" Annotated", -1))
        ])) : E("", !0),
        ht.value ? (g(), v("button", {
          key: 1,
          class: "sv-continue",
          "data-testid": "studio-stage-continue",
          title: "Make this image 1, the one the next run edits",
          onClick: Me[4] || (Me[4] = (Xe) => m(s).continueFrom(f.value.id))
        }, [
          C(R, {
            name: "CornerDownLeft",
            size: 13
          }),
          X(" Continue from " + A(Le.value), 1)
        ])) : E("", !0),
        ve.value ? (g(), v("button", {
          key: 2,
          class: "sv-promote",
          "data-testid": "studio-stage-promote",
          title: "The board shows another version of this picture: show this one there instead",
          onClick: Me[5] || (Me[5] = (Xe) => m(s).promote(f.value.id))
        }, [
          C(R, {
            name: "Replace",
            size: 13
          }),
          Me[19] || (Me[19] = X(" Show on the board ", -1))
        ])) : Ne.value && le.value ? (g(), v("span", bhe, [
          C(R, {
            name: "LayoutGrid",
            size: 12
          }),
          Me[20] || (Me[20] = X(" On the board", -1))
        ])) : E("", !0),
        $.value || b.value && f.value.status === "done" && (we.value || je.value) ? (g(), v("div", vhe, [
          b.value && f.value.status === "done" && (we.value || je.value) ? (g(), v(H, { key: 0 }, [
            h("button", {
              class: U(["ed-stage-btn", { on: je.value }]),
              "aria-pressed": je.value,
              title: je.value ? "Stop comparing" : "Compare with the version it came from",
              "data-testid": "studio-compare",
              onClick: Se
            }, [
              C(R, {
                name: "Columns2",
                size: 13
              }),
              Me[21] || (Me[21] = X(" Compare ", -1))
            ], 10, yhe),
            je.value && m(a).t.compare ? (g(), v("span", xhe, [
              h("button", {
                class: U({ on: m(a).t.compare.mode === "split" }),
                onClick: Me[6] || (Me[6] = (Xe) => m(a).t.compare.mode = "split")
              }, "Split", 2),
              h("button", {
                class: U({ on: m(a).t.compare.mode === "toggle" }),
                onClick: Me[7] || (Me[7] = (Xe) => m(a).t.compare.mode = "toggle")
              }, "Toggle", 2)
            ])) : E("", !0)
          ], 64)) : E("", !0),
          $.value ? (g(), Ce(ehe, {
            key: 1,
            share: W.value,
            fitted: !Z.value,
            "at-min": L.value.k <= ee.value.min + 1e-4,
            "at-max": L.value.k >= ee.value.max - 1e-4,
            onStep: ne,
            onFit: se,
            onActual: Y
          }, null, 8, ["share", "fitted", "at-min", "at-max"])) : E("", !0)
        ])) : E("", !0),
        C(vt, { name: "ed-fade" }, {
          default: et(() => [
            m(r).baking ? (g(), v("div", whe, [
              C(R, {
                name: "Loader2",
                size: 14,
                spin: ""
              }),
              X(" " + A(m(r).baking), 1)
            ])) : E("", !0)
          ]),
          _: 1
        })
      ], 6)) : m(s).busy() ? (g(), v("div", khe, [
        Me[22] || (Me[22] = h("span", { class: "sv-making" }, null, -1)),
        h("b", null, A(m(s).video.value ? "Making your video" : "Making your image"), 1),
        m(o).runningSince[m(s).sessionId] ? (g(), Ce(Nf, {
          key: 0,
          class: "sv-making-time",
          since: m(o).runningSince[m(s).sessionId]
        }, null, 8, ["since"])) : E("", !0)
      ])) : b.value ? (g(), v("div", _he, [
        h("span", She, [
          C(R, {
            name: "Pencil",
            size: 20
          })
        ]),
        Me[24] || (Me[24] = h("b", null, "Pick an image to edit", -1)),
        Me[25] || (Me[25] = h("span", { class: "sub" }, "Choose one from history on the right, or bring in your own.", -1)),
        h("div", The, [
          h("button", {
            class: "sv-btn",
            onClick: Me[8] || (Me[8] = (Xe) => i("upload"))
          }, [
            C(R, {
              name: "Upload",
              size: 14
            }),
            Me[23] || (Me[23] = X(" Bring in an image", -1))
          ])
        ])
      ])) : m(s).video.value ? (g(), v("div", Mhe, [
        h("span", Che, [
          C(R, {
            name: "Video",
            size: 20
          })
        ]),
        Me[27] || (Me[27] = h("b", null, "Describe a new video", -1)),
        Me[28] || (Me[28] = h("span", { class: "sub" }, "Write a prompt below. To start the video from a picture, pick one from history or bring in your own.", -1)),
        h("div", Ihe, [
          h("button", {
            class: "sv-btn",
            onClick: Me[9] || (Me[9] = (Xe) => i("upload"))
          }, [
            C(R, {
              name: "Upload",
              size: 14
            }),
            Me[26] || (Me[26] = X(" Bring in a picture", -1))
          ])
        ])
      ])) : (g(), v("div", Ahe, [
        h("span", Phe, [
          C(R, {
            name: "Sparkles",
            size: 20
          })
        ]),
        Me[31] || (Me[31] = h("b", null, "Describe a new image", -1)),
        Me[32] || (Me[32] = h("span", { class: "sub" }, "Write a prompt below. To change an image instead, pick one from history, start from a 3D model, or bring in your own.", -1)),
        h("div", Ehe, [
          h("button", {
            class: "sv-btn",
            onClick: Me[10] || (Me[10] = (Xe) => m(s).setStudio("threed"))
          }, [
            C(R, {
              name: "Box",
              size: 14
            }),
            Me[29] || (Me[29] = X(" Start from 3D", -1))
          ]),
          h("button", {
            class: "sv-btn",
            onClick: Me[11] || (Me[11] = (Xe) => i("upload"))
          }, [
            C(R, {
              name: "Upload",
              size: 14
            }),
            Me[30] || (Me[30] = X(" Bring in an image", -1))
          ])
        ])
      ])),
      C(Wue)
    ], 34));
  }
}), zhe = { class: "sv-art" }, $he = ["src"], Dhe = {
  key: 2,
  class: "sv-art-play",
  "aria-hidden": "true"
}, us = /* @__PURE__ */ Re({
  __name: "ItemArt",
  props: {
    item: {},
    full: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, t = ft(), i = I(() => t.marksOf(e.item)), s = I(() => e.item.url.startsWith("data:") || e.item.url.startsWith("blob:") || e.full ? e.item.url : Wt(e.item.url)), o = I(() => {
      const r = t.resultOf(e.item);
      return !!(r && r.video);
    });
    return (r, a) => (g(), v("span", zhe, [
      n.item.url ? (g(), v("img", {
        key: 0,
        src: s.value,
        alt: "",
        draggable: "false",
        loading: "lazy"
      }, null, 8, $he)) : E("", !0),
      i.value.strokes.length || i.value.pins.length ? (g(), Ce(CC, {
        key: 1,
        marks: i.value,
        w: n.item.w,
        h: n.item.h,
        small: ""
      }, null, 8, ["marks", "w", "h"])) : E("", !0),
      o.value ? (g(), v("span", Dhe, [
        C(R, {
          name: "Play",
          size: 10
        })
      ])) : E("", !0)
    ]));
  }
}), Ry = "application/x-rd-studio-item", Lr = /* @__PURE__ */ K(null);
function iI(n, e, t) {
  n.dataTransfer && (n.dataTransfer.effectAllowed = "copy", n.dataTransfer.setData(Ry, e), t && n.dataTransfer.setDragImage(t, t.offsetWidth / 2, t.offsetHeight / 2), Lr.value = e);
}
function Sl() {
  Lr.value = null;
}
function sI(n) {
  return !!n.dataTransfer && Array.from(n.dataTransfer.types).includes(Ry);
}
function oI(n) {
  return n.dataTransfer && n.dataTransfer.getData(Ry) || null;
}
const Ohe = { class: "sv-queue-label" }, Lhe = { class: "sv-queue-slots" }, Bhe = ["title", "data-testid", "onDragstart", "onDrop", "onClick", "onMouseenter"], Fhe = { class: "n" }, Nhe = {
  key: 0,
  class: "m",
  title: "Its annotations and notes go with it"
}, Uhe = ["title", "onClick"], Ghe = {
  key: 2,
  class: "sv-slot-add-wrap"
}, jhe = ["aria-expanded"], Hhe = {
  key: 3,
  class: "sv-queue-empty"
}, Vhe = { class: "n" }, z_ = 6, Whe = 230, qhe = 260, Khe = /* @__PURE__ */ Re({
  __name: "QueueRow",
  setup(n) {
    const e = ft(), t = e.s, i = /* @__PURE__ */ K(!1), s = I(() => e.queueItems.value), o = I(() => i.value ? s.value : s.value.slice(0, z_)), r = I(() => s.value.length - o.value.length), a = I(() => e.limit.value), l = I(() => e.modelName(e.genMode.value)), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(null), u = /* @__PURE__ */ K(null);
    function p(z, P) {
      const D = s.value.find((F) => F.id === z);
      if (!D || !c.value || d.value) return;
      const $ = Math.min(Whe / D.w, qhe / D.h), O = Math.round(D.w * $), L = Math.round(D.h * $), Z = P.currentTarget.getBoundingClientRect(), J = c.value.getBoundingClientRect(), re = Math.max(0, Math.min(J.width - O, Z.left - J.left + Z.width / 2 - O / 2));
      u.value = { id: z, left: re, w: O, h: L };
    }
    const f = I(() => u.value && s.value.find((z) => z.id === u.value.id) || null);
    function y(z, P) {
      d.value = z, u.value = null, P.dataTransfer && (P.dataTransfer.effectAllowed = "move", P.dataTransfer.setData("text/plain", z));
    }
    function b(z) {
      d.value && e.move(d.value, z), d.value = null;
    }
    const w = /* @__PURE__ */ K(!1), k = I(() => !!Lr.value && !!a.value);
    function S(z) {
      !sI(z) || !a.value || (z.preventDefault(), z.dataTransfer && (z.dataTransfer.dropEffect = "copy"), w.value = !0);
    }
    function _(z) {
      const P = z.relatedTarget;
      (!P || !z.currentTarget.contains(P)) && (w.value = !1);
    }
    function x(z) {
      const P = oI(z);
      w.value = !1, Sl(), !(!P || !a.value) && (z.preventDefault(), e.queueItem(P));
    }
    const T = /* @__PURE__ */ K(!1);
    async function M(z) {
      T.value = !1, await e.queueUrl(z);
    }
    return (z, P) => (g(), v("div", {
      ref_key: "row",
      ref: c,
      class: U(["sv-queue", { "is-empty": !s.value.length, "no-images": !a.value, "is-over": w.value, "is-air": k.value && !w.value }]),
      "data-testid": "studio-queue",
      onDragover: S,
      onDragleave: _,
      onDrop: x
    }, [
      h("span", Ohe, A(m(e).video.value ? "Next video starts from" : "Next image uses"), 1),
      h("div", Lhe, [
        (g(!0), v(H, null, me(o.value, (D, $) => (g(), v("div", {
          key: D.id,
          class: U(["sv-slot", { "is-base": $ === 0, "is-unsent": $ >= a.value, "is-stage": m(t).stageId === D.id, "is-ref": D.kind === "ref" }]),
          title: (m(e).slotName($) ? m(e).slotName($) + ": image " + ($ + 1) : $ === 0 ? "Image 1: the one it starts from" : "Image " + ($ + 1) + ": a reference") + ($ >= a.value ? " (not sent: " + l.value + " takes " + a.value + ")" : ""),
          draggable: "true",
          "data-testid": "studio-slot-" + ($ + 1),
          onDragstart: (O) => y(D.id, O),
          onDragover: P[0] || (P[0] = Pe(() => {
          }, ["prevent"])),
          onDrop: Pe((O) => b($), ["prevent"]),
          onClick: (O) => m(e).show(D.id),
          onMouseenter: (O) => p(D.id, O),
          onMouseleave: P[1] || (P[1] = (O) => u.value = null)
        }, [
          C(us, { item: D }, null, 8, ["item"]),
          h("span", Fhe, A($ + 1), 1),
          m(e).marked(D.id) ? (g(), v("span", Nhe, [
            C(R, {
              name: "Pencil",
              size: 8
            })
          ])) : E("", !0),
          h("button", {
            class: "x",
            title: "Take image " + ($ + 1) + " out",
            onClick: Pe((O) => m(e).remove(D.id), ["stop"])
          }, [
            C(R, {
              name: "X",
              size: 10
            })
          ], 8, Uhe)
        ], 42, Bhe))), 128)),
        r.value > 0 ? (g(), v("button", {
          key: 0,
          class: "sv-slot-more",
          onClick: P[2] || (P[2] = (D) => i.value = !0)
        }, "+" + A(r.value), 1)) : E("", !0),
        i.value && s.value.length > z_ ? (g(), v("button", {
          key: 1,
          class: "sv-slot-more",
          title: "Fewer",
          onClick: P[3] || (P[3] = (D) => i.value = !1)
        }, [
          C(R, {
            name: "ChevronLeft",
            size: 12
          })
        ])) : E("", !0),
        a.value ? (g(), v("div", Ghe, [
          h("button", {
            class: "sv-slot-add",
            title: "Add an image: your pinned pictures, the board's, your Library, or an upload",
            "aria-label": "Add an image",
            "aria-expanded": T.value,
            "data-testid": "studio-queue-add",
            onClick: P[4] || (P[4] = (D) => T.value = !T.value)
          }, [
            C(R, {
              name: "Plus",
              size: 14
            })
          ], 8, jhe),
          T.value ? (g(), Ce(sf, {
            key: 0,
            "session-id": m(e).sessionId,
            label: "Image",
            dropper: !1,
            tip: "Or drag a picture here from history.",
            onPick: M,
            onClose: P[5] || (P[5] = (D) => T.value = !1)
          }, null, 8, ["session-id"])) : E("", !0)
        ])) : E("", !0),
        s.value.length ? E("", !0) : (g(), v("span", Hhe, A(a.value ? "Nothing yet: your words alone make a new " + (m(e).video.value ? "video." : "image.") : l.value + " works from words alone; pick another model to send images."), 1))
      ]),
      u.value && f.value ? (g(), v("div", {
        key: 0,
        class: "sv-slot-peek",
        style: de({ left: u.value.left + "px", width: u.value.w + "px", height: u.value.h + "px" }),
        "aria-hidden": "true"
      }, [
        C(us, {
          item: f.value,
          full: ""
        }, null, 8, ["item"]),
        h("span", Vhe, A(m(e).slotName(m(e).queued(f.value.id) - 1) || "Image " + m(e).queued(f.value.id)), 1)
      ], 4)) : E("", !0),
      h("span", {
        class: U(["sv-queue-count", { "is-over": s.value.length > a.value }])
      }, [
        a.value ? (g(), v(H, { key: 0 }, [
          X(A(Math.min(s.value.length, a.value)) + " of " + A(a.value), 1)
        ], 64)) : (g(), v(H, { key: 1 }, [
          X("No images")
        ], 64))
      ], 2)
    ], 34));
  }
}), Yhe = ["aria-expanded", "disabled", "title"], Xhe = { class: "nm" }, Jhe = ["aria-expanded", "disabled"], Zhe = { class: "nm" }, Qhe = ["aria-expanded", "disabled", "title"], epe = { class: "nm" }, tpe = {
  key: 0,
  class: "tk"
}, npe = {
  key: 0,
  class: "sv-pop-search"
}, ipe = { class: "sv-pop-rows" }, spe = ["aria-selected", "onClick"], ope = { class: "nm" }, rpe = { class: "mt" }, ape = { class: "tk" }, lpe = ["title", "aria-label", "aria-pressed", "data-testid", "onClick"], dpe = {
  key: 0,
  class: "sv-pop-empty"
}, cpe = {
  key: 1,
  class: "sv-pop-foot"
}, zy = /* @__PURE__ */ Re({
  __name: "ModelPicker",
  props: {
    mode: {},
    variant: { default: "chip" }
  },
  setup(n) {
    const e = n, t = ft(), { board: i } = tt(), s = /* @__PURE__ */ K(!1), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(""), a = /* @__PURE__ */ K(null), l = I(() => t.modelsFor(e.mode)), d = I(() => {
      const S = r.value.trim().toLowerCase();
      return i.pinnedModelsFirst(S ? l.value.filter((_) => _.name.toLowerCase().includes(S)) : l.value);
    }), c = I(() => t.modelOf(e.mode)), u = I(() => l.value.length > 7);
    function p(S) {
      const _ = bo(S);
      return _ ? "up to " + _ + (_ === 1 ? " image" : " images") : "words only";
    }
    function f(S) {
      return S.tokensLabel || (S.tokensPerResult != null ? String(S.tokensPerResult) : "");
    }
    function y(S) {
      t.setModel(e.mode, S), s.value = !1;
    }
    function b() {
      s.value = !s.value, r.value = "", s.value && u.value && it(() => a.value && a.value.focus());
    }
    function w(S) {
      o.value && !o.value.contains(S.target) && (s.value = !1);
    }
    $e(s, (S) => {
      S ? window.addEventListener("pointerdown", w, !0) : window.removeEventListener("pointerdown", w, !0);
    }), Ve(() => window.removeEventListener("pointerdown", w, !0));
    function k(S) {
      S.key === "Escape" ? (S.stopPropagation(), s.value = !1) : S.key === "Enter" && d.value.length && (S.preventDefault(), y(d.value[0]));
    }
    return (S, _) => (g(), v("div", {
      ref_key: "wrap",
      ref: o,
      class: U(["sv-pop-wrap", { "is-row": n.variant === "row" }]),
      onKeydown: k
    }, [
      n.variant === "flat" ? (g(), v("button", {
        key: 0,
        class: U(["up-model", { on: s.value }]),
        "aria-expanded": s.value,
        disabled: !l.value.length,
        title: c.value && c.value.time ? "About " + c.value.time + " a run" : void 0,
        "data-testid": "studio-model",
        onClick: b
      }, [
        _[2] || (_[2] = h("span", { class: "lb" }, "Model", -1)),
        xt((g(), v("span", Xhe, [
          X(A(c.value ? c.value.name : "None available"), 1)
        ])), [
          [m(Va), c.value ? c.value.name : null]
        ]),
        C(R, {
          name: "ChevronDown",
          size: 12
        })
      ], 10, Yhe)) : n.variant === "chip" ? (g(), v("button", {
        key: 1,
        class: U(["sv-chip is-model", { on: s.value }]),
        "aria-expanded": s.value,
        disabled: !l.value.length,
        "data-testid": "studio-model",
        onClick: b
      }, [
        _[3] || (_[3] = h("span", { class: "lb" }, "Model", -1)),
        xt((g(), v("span", Zhe, [
          X(A(c.value ? c.value.name : "None available"), 1)
        ])), [
          [m(Va), c.value ? c.value.name : null]
        ]),
        C(R, {
          name: "ChevronDown",
          size: 12
        })
      ], 10, Jhe)) : (g(), v("button", {
        key: 2,
        class: U(["sv-model-row", { on: s.value }]),
        "aria-expanded": s.value,
        disabled: !l.value.length,
        title: c.value ? "Model: " + c.value.name + (c.value.time ? " (about " + c.value.time + " a run)" : "") : "No model takes a picture here",
        "data-testid": "studio-edit-model",
        onClick: b
      }, [
        C(R, {
          name: "Cpu",
          size: 14
        }),
        xt((g(), v("span", epe, [
          X(A(c.value ? c.value.name : "None available"), 1)
        ])), [
          [m(Va), c.value ? c.value.name : null]
        ]),
        c.value ? (g(), v("span", tpe, [
          C(R, {
            name: "Tokens",
            size: 11
          }),
          X(" " + A(m(t).priceOf(n.mode)), 1)
        ])) : E("", !0),
        C(R, {
          class: "chev",
          name: s.value ? "ChevronUp" : "ChevronDown",
          size: 13
        }, null, 8, ["name"])
      ], 10, Qhe)),
      s.value ? (g(), v("div", {
        key: 3,
        class: U(n.variant === "row" ? "sv-model-list" : "sv-pop"),
        role: "listbox",
        "aria-label": "Models for this studio"
      }, [
        u.value ? (g(), v("label", npe, [
          C(R, {
            name: "Search",
            size: 12
          }),
          xt(h("input", {
            ref_key: "searchEl",
            ref: a,
            "onUpdate:modelValue": _[0] || (_[0] = (x) => r.value = x),
            placeholder: "Find a model",
            spellcheck: "false",
            "data-testid": "studio-model-search"
          }, null, 512), [
            [Jt, r.value]
          ])
        ])) : E("", !0),
        h("div", ipe, [
          (g(!0), v(H, null, me(d.value, (x) => (g(), v("div", {
            key: x.id,
            class: "sv-pop-item"
          }, [
            h("button", {
              class: U(["sv-pop-row", { on: !!c.value && x.id === c.value.id }]),
              role: "option",
              "aria-selected": !!c.value && x.id === c.value.id,
              onClick: (T) => y(x)
            }, [
              xt((g(), v("span", ope, [
                X(A(x.name), 1)
              ])), [
                [m(Va), x.name]
              ]),
              h("span", rpe, A(p(x)), 1),
              h("span", ape, [
                C(R, {
                  name: "Tokens",
                  size: 11
                }),
                X(" " + A(f(x)), 1)
              ])
            ], 10, spe),
            h("button", {
              class: U(["sv-pop-pin", { on: m(i).isModelPinned(x.id) }]),
              title: m(i).isModelPinned(x.id) ? "Unpin" : "Pin to the top",
              "aria-label": (m(i).isModelPinned(x.id) ? "Unpin " : "Pin ") + x.name,
              "aria-pressed": m(i).isModelPinned(x.id),
              "data-testid": "studio-model-pin-" + x.id,
              onKeydown: _[1] || (_[1] = tn(Pe(() => {
              }, ["stop"]), ["enter"])),
              onClick: Pe((T) => m(i).toggleModelPinned(x.id), ["stop"])
            }, [
              C(R, {
                name: "Pin",
                size: 12
              })
            ], 42, lpe)
          ]))), 128)),
          d.value.length ? E("", !0) : (g(), v("div", dpe, A(l.value.length ? "No model by that name" : "No model here takes a picture"), 1))
        ]),
        n.mode === "prompt" ? (g(), v("p", cpe, "Changes the session's model, as its prompt box does.")) : E("", !0)
      ], 2)) : E("", !0)
    ], 34));
  }
}), upe = ["title", "data-testid", "onClick"], hpe = {
  key: 0,
  class: "t"
}, ppe = ["aria-label"], fpe = { class: "sv-pop-title" }, mpe = {
  key: 0,
  class: "sv-pop-slider"
}, gpe = ["min", "max", "step", "value", "onInput"], bpe = {
  key: 1,
  class: "sv-pop-rows"
}, vpe = ["aria-selected", "onClick"], ype = { class: "nm" }, xpe = {
  key: 1,
  class: "mt"
}, wpe = /* @__PURE__ */ Re({
  __name: "FieldChips",
  props: {
    mode: {},
    upward: { type: Boolean, default: !0 },
    hide: { default: () => [] },
    pills: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, t = ft(), i = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = I(() => t.shownChips(e.mode, e.hide));
    function r(b) {
      return t.valueOf(e.mode, b);
    }
    function a(b) {
      const w = r(b);
      return (b.options || []).find((k) => as(k.value, w)) || null;
    }
    function l(b) {
      if (b.kind === "boolean") return b.label;
      const w = r(b), k = a(b);
      return b.kind === "size" && k || k ? k.label : w == null || w === "" ? b.label : String(w);
    }
    function d(b) {
      if (b.icon) return b.icon;
      if (b.kind === "size") {
        const w = a(b);
        return w && w.icon || "RectangleHorizontal";
      }
      return b.kind === "boolean" ? r(b) ? "SquareCheck" : "Square" : "Settings2";
    }
    function c(b) {
      if (b.kind === "boolean") {
        t.setInput(e.mode, b.key, !r(b));
        return;
      }
      i.value = i.value === b.key ? null : b.key;
    }
    function u(b, w) {
      t.setInput(e.mode, b.key, w.value), i.value = null;
    }
    function p(b, w) {
      const k = Wd(b, w);
      k != null && t.setInput(e.mode, b.key, k);
    }
    function f(b, w) {
      return w.meta && (b.kind !== "size" || Qb(w.value)) ? w.meta : "";
    }
    function y(b) {
      s.value && !s.value.contains(b.target) && (i.value = null);
    }
    return $e(i, (b) => {
      b ? window.addEventListener("pointerdown", y, !0) : window.removeEventListener("pointerdown", y, !0);
    }), Ve(() => window.removeEventListener("pointerdown", y, !0)), (b, w) => o.value.length ? (g(), v("div", {
      key: 0,
      ref_key: "wrap",
      ref: s,
      class: U(["sv-fields", { "is-pills": n.pills }]),
      "data-testid": "studio-fields"
    }, [
      (g(!0), v(H, null, me(o.value, (k) => {
        var S, _, x, T, M, z;
        return g(), v("div", {
          key: k.key,
          class: "sv-pop-wrap"
        }, [
          h("button", {
            class: U([n.pills ? "up-chip" : "sv-chip", { on: i.value === k.key || k.kind === "boolean" && !!r(k) }]),
            title: k.tooltip || k.label,
            "data-testid": "studio-field-" + k.key,
            onClick: (P) => c(k)
          }, [
            C(R, {
              name: d(k),
              size: n.pills ? 13 : 12
            }, null, 8, ["name", "size"]),
            n.pills ? (g(), v("span", hpe, A(l(k)), 1)) : (g(), v(H, { key: 1 }, [
              X(A(l(k)), 1)
            ], 64))
          ], 10, upe),
          i.value === k.key ? (g(), v("div", {
            key: 0,
            class: U(["sv-pop is-narrow", { "is-down": !n.upward }]),
            role: "listbox",
            "aria-label": k.label,
            onKeydown: w[0] || (w[0] = tn(Pe((P) => i.value = null, ["stop"]), ["esc"]))
          }, [
            h("div", fpe, A(k.label), 1),
            k.kind === "slider" ? (g(), v("label", mpe, [
              h("input", {
                type: "range",
                min: (S = k.min) != null ? S : 0,
                max: (_ = k.max) != null ? _ : 100,
                step: (x = k.step) != null ? x : 1,
                value: Number((M = (T = r(k)) != null ? T : k.defaultValue) != null ? M : 0),
                onInput: (P) => p(k, P.target.value)
              }, null, 40, gpe),
              h("b", null, A((z = r(k)) != null ? z : k.defaultValue), 1)
            ])) : (g(), v("div", bpe, [
              (g(!0), v(H, null, me(k.options, (P) => (g(), v("button", {
                key: String(P.label),
                class: U(["sv-pop-row", { on: m(as)(P.value, r(k)) }]),
                role: "option",
                "aria-selected": m(as)(P.value, r(k)),
                onClick: (D) => u(k, P)
              }, [
                P.icon ? (g(), Ce(R, {
                  key: 0,
                  name: P.icon,
                  size: 12
                }, null, 8, ["name"])) : E("", !0),
                h("span", ype, A(P.label), 1),
                f(k, P) ? (g(), v("span", xpe, A(f(k, P)), 1)) : E("", !0)
              ], 10, vpe))), 128))
            ]))
          ], 42, ppe)) : E("", !0)
        ]);
      }), 128))
    ], 2)) : E("", !0);
  }
}), kpe = { class: "up-chips" }, _pe = { class: "up-chip-wrap up-model-wrap" }, Spe = ["title"], Tpe = { class: "nm" }, Mpe = ["title"], Cpe = { class: "up-run-wrap" }, Ipe = ["disabled", "title", "data-testid"], Ape = {
  key: 2,
  class: "tip",
  "data-testid": "studio-run-tip"
}, rI = /* @__PURE__ */ Re({
  __name: "PromptFoot",
  props: {
    kind: {},
    own: { default: null },
    resting: { type: Boolean, default: !1 },
    unchecked: { type: Boolean, default: !1 },
    fixed: { type: Boolean, default: !1 },
    fixedTitle: { default: "" },
    most: { default: null },
    hide: { default: () => [] },
    label: { default: null },
    runTestid: { default: "studio-run" },
    countTestid: { default: "studio-count" }
  },
  emits: ["run"],
  setup(n, { expose: e, emit: t }) {
    const i = n, s = t, o = ft(), r = o.s, { board: a } = tt(), l = /* @__PURE__ */ K(null), d = I(() => o.modelOf(i.kind)), c = I(() => i.unchecked ? { problem: null, tokens: !1 } : o.checkOf(i.kind)), u = I(() => i.resting ? eI : i.own || c.value.problem || (d.value ? null : "No model is available for this")), p = I(() => !i.own && c.value.tokens && a.canGetTokens), f = I(() => d.value ? o.priceOf(i.kind) : ""), y = I(() => o.countOf(i.kind)), b = I(() => i.most != null ? Math.min(i.most, o.maxCount(i.kind)) : o.maxCount(i.kind)), w = I(() => o.shownChips(i.kind, i.hide).length > 0), k = I(() => r.sending > 0);
    let S = 0;
    function _() {
      const T = l.value ? l.value.closest(".sv-dock") : null;
      T && (T.classList.remove("is-nudge"), T.offsetWidth, T.classList.add("is-nudge"), clearTimeout(S), S = window.setTimeout(() => T.classList.remove("is-nudge"), 1800));
    }
    Ve(() => clearTimeout(S));
    function x() {
      if (!k.value) {
        if (u.value || p.value) {
          _();
          return;
        }
        s("run");
      }
    }
    return e({ tryRun: x }), (T, M) => (g(), v("div", {
      ref_key: "root",
      ref: l,
      class: "up-foot sv-pfoot",
      "data-testid": "studio-foot"
    }, [
      h("div", kpe, [
        h("span", _pe, [
          n.fixed ? (g(), v("span", {
            key: 0,
            class: "up-model is-fixed",
            title: n.fixedTitle || void 0,
            "data-testid": "studio-model-fixed"
          }, [
            M[2] || (M[2] = h("span", { class: "lb" }, "Model", -1)),
            h("span", Tpe, A(d.value ? d.value.name : "None"), 1)
          ], 8, Spe)) : (g(), Ce(zy, {
            key: 1,
            mode: n.kind,
            variant: "flat"
          }, null, 8, ["mode"])),
          f.value ? (g(), v("span", {
            key: 2,
            class: "up-cost",
            title: "Token cost for this run" + (d.value && d.value.time ? ", about " + d.value.time : ""),
            "data-testid": "studio-cost"
          }, [
            C(R, {
              name: "Tokens",
              size: 12
            }),
            X(A(f.value), 1)
          ], 8, Mpe)) : E("", !0)
        ]),
        w.value ? (g(), v(H, { key: 0 }, [
          M[3] || (M[3] = h("span", { class: "up-foot-sep" }, null, -1)),
          C(wpe, {
            mode: n.kind,
            hide: n.hide,
            pills: ""
          }, null, 8, ["mode", "hide"])
        ], 64)) : E("", !0),
        Ws(T.$slots, "chips")
      ]),
      Ws(T.$slots, "aside"),
      b.value > 1 ? (g(), Ce(Sy, {
        key: 0,
        value: y.value,
        min: m(o).minCount(n.kind),
        max: b.value,
        testid: n.countTestid,
        onUpdate: M[0] || (M[0] = (z) => m(o).setCount(n.kind, z))
      }, null, 8, ["value", "min", "max", "testid"])) : E("", !0),
      h("span", Cpe, [
        p.value && !k.value ? (g(), v("button", {
          key: 0,
          class: "up-run is-get",
          "data-testid": "studio-get-tokens",
          onClick: M[1] || (M[1] = (z) => m(a).getTokens())
        }, [
          C(R, {
            name: "Tokens",
            size: 13
          }),
          M[4] || (M[4] = X("Get tokens ", -1))
        ])) : (g(), v("button", {
          key: 1,
          class: U(["up-run", { "is-busy": k.value }]),
          disabled: k.value || !!u.value,
          title: n.resting ? u.value || void 0 : u.value || k.value ? void 0 : "Run (" + m(Tn)(["mod", "enter"]) + ")",
          "data-testid": n.runTestid,
          onClick: x
        }, [
          k.value ? (g(), Ce(R, {
            key: 0,
            name: "Loader2",
            size: 14,
            spin: ""
          })) : E("", !0),
          X(" " + A(k.value ? "Running" : n.label || "Run"), 1)
        ], 10, Ipe)),
        (u.value || p.value) && !k.value && !n.resting ? (g(), v("span", Ape, A(u.value), 1)) : E("", !0)
      ])
    ], 512));
  }
}), Ppe = { class: "sv-fp-head" }, Epe = {
  key: 0,
  class: "sv-fp-tag",
  "data-testid": "studio-full-prompt-edited"
}, Rpe = ["value"], zpe = { class: "sv-fp-foot" }, $pe = {
  class: "sv-fp-note",
  "data-testid": "studio-full-prompt-note"
}, Dpe = { class: "up-run-wrap" }, Ope = ["disabled", "title"], Lpe = {
  key: 0,
  class: "tip"
}, $y = /* @__PURE__ */ Re({
  __name: "FullPrompt",
  props: {
    kind: {}
  },
  emits: ["run"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = ft(), o = /* @__PURE__ */ K(null), r = I(() => s.fullEdit(t.kind)), a = I(() => r.value != null), l = I(() => r.value != null ? r.value : s.fullPromptOf(t.kind)), d = I(() => s.s.sending > 0), c = I(() => a.value ? s.fullProblem(t.kind, l.value) : null), u = I(() => a.value && s.fullDrifted(t.kind));
    function p() {
      const w = o.value;
      w && (w.style.height = "0px", w.style.height = Math.min(180, Math.max(54, w.scrollHeight)) + "px");
    }
    $e(l, () => it(p)), ot(p);
    function f(w) {
      s.setFullEdit(t.kind, w.target.value);
    }
    function y() {
      !a.value || c.value || d.value || i("run", l.value);
    }
    function b(w) {
      w.key === "Enter" && vn(w) && (w.preventDefault(), y());
    }
    return (w, k) => (g(), v("div", {
      class: U(["sv-fp", { "is-edited": a.value }]),
      "data-testid": "studio-full-prompt"
    }, [
      h("div", Ppe, [
        k[2] || (k[2] = h("span", { class: "t" }, "Full prompt", -1)),
        C(vt, { name: "sv-fp-tag" }, {
          default: et(() => [
            a.value ? (g(), v("span", Epe, "Edited")) : E("", !0)
          ]),
          _: 1
        }),
        k[3] || (k[3] = h("span", { class: "sv-grow" }, null, -1)),
        a.value ? (g(), v("button", {
          key: 0,
          class: "sv-fp-reset",
          title: "Back to the prompt put together from your words",
          "data-testid": "studio-full-prompt-reset",
          onClick: k[0] || (k[0] = (S) => m(s).resetFullEdit(n.kind))
        }, [
          C(R, {
            name: "RotateCcw",
            size: 11
          }),
          k[1] || (k[1] = X(" Reset ", -1))
        ])) : E("", !0)
      ]),
      h("textarea", {
        ref_key: "el",
        ref: o,
        class: "sv-fp-text",
        value: l.value,
        spellcheck: "false",
        "aria-label": "Full prompt",
        "data-testid": "studio-full-prompt-text",
        onInput: f,
        onKeydown: b
      }, null, 40, Rpe),
      h("div", zpe, [
        h("span", $pe, [
          u.value ? (g(), v(H, { key: 0 }, [
            X("Your words changed since: reset to start again from them")
          ], 64)) : a.value ? (g(), v(H, { key: 1 }, [
            X("Runs instead of the prompt put together from your words")
          ], 64)) : (g(), v(H, { key: 2 }, [
            X("What the model gets. Change it to run your own")
          ], 64))
        ]),
        h("span", Dpe, [
          h("button", {
            class: U(["up-run sv-fp-run", { "is-busy": d.value && a.value }]),
            disabled: !a.value || !!c.value || d.value,
            title: a.value ? void 0 : "Change the prompt to run it",
            "data-testid": "studio-full-prompt-run",
            onClick: y
          }, [
            d.value && a.value ? (g(), Ce(R, {
              key: 0,
              name: "Loader2",
              size: 13,
              spin: ""
            })) : E("", !0),
            X(" " + A(d.value && a.value ? "Running" : "Run with this prompt"), 1)
          ], 10, Ope),
          a.value && c.value && !d.value ? (g(), v("span", Lpe, A(c.value), 1)) : E("", !0)
        ])
      ])
    ], 2));
  }
}), Bpe = ["aria-expanded", "title"], Fpe = {
  key: 0,
  class: "dot",
  "aria-hidden": "true"
}, Dy = /* @__PURE__ */ Re({
  __name: "FullPromptToggle",
  props: {
    kind: {}
  },
  setup(n) {
    const e = n, t = ft(), i = I(() => !!t.s.fullOpen[e.kind]), s = I(() => t.fullEdit(e.kind) != null), o = I(() => i.value || s.value || !!t.fullPromptOf(e.kind).trim()), r = I(() => i.value ? "Hide the full prompt" : s.value ? "Your edited prompt: open it to run it" : "See the whole prompt the model gets, and change it");
    return (a, l) => o.value ? (g(), v("button", {
      key: 0,
      class: U(["sv-fp-link", { on: i.value, "is-edited": s.value }]),
      "aria-expanded": i.value,
      title: r.value,
      "data-testid": "studio-full-prompt-toggle",
      onClick: l[0] || (l[0] = (d) => m(t).setFullOpen(n.kind, !i.value))
    }, [
      l[1] || (l[1] = h("span", null, "Full prompt", -1)),
      s.value ? (g(), v("span", Fpe)) : E("", !0),
      C(R, {
        name: "ChevronDown",
        size: 12,
        class: "chev"
      })
    ], 10, Bpe)) : E("", !0);
  }
}), Npe = {
  key: 0,
  class: "ed-collapse"
}, Tl = /* @__PURE__ */ Re({
  __name: "Collapse",
  props: {
    open: { type: Boolean }
  },
  setup(n) {
    const e = () => typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function t(r, a) {
      let l = !1;
      const d = () => {
        l || (l = !0, r.removeEventListener("transitionend", c), a());
      }, c = (u) => {
        u.target === r && u.propertyName === "height" && d();
      };
      r.addEventListener("transitionend", c), window.setTimeout(d, 520);
    }
    function i(r, a) {
      const l = r;
      if (e()) {
        a();
        return;
      }
      l.style.clipPath = "inset(0)", l.style.height = "0px", l.style.opacity = "0", l.offsetHeight, l.style.height = l.scrollHeight + "px", l.style.opacity = "1", t(l, a);
    }
    function s(r) {
      const a = r;
      a.style.height = "", a.style.opacity = "", a.style.clipPath = "";
    }
    function o(r, a) {
      const l = r;
      if (e()) {
        a();
        return;
      }
      l.style.clipPath = "inset(0)", l.style.height = l.scrollHeight + "px", l.offsetHeight, l.style.height = "0px", l.style.opacity = "0", t(l, a);
    }
    return (r, a) => (g(), Ce(vt, {
      css: !1,
      onEnter: i,
      onAfterEnter: s,
      onLeave: o
    }, {
      default: et(() => [
        n.open ? (g(), v("div", Npe, [
          Ws(r.$slots, "default")
        ])) : E("", !0)
      ]),
      _: 3
    }));
  }
}), Upe = {
  class: "sv-describe",
  "data-testid": "studio-composer"
}, Gpe = ["value", "placeholder"], jpe = ["title"], Hpe = /* @__PURE__ */ Re({
  __name: "Composer",
  props: {
    before: { type: [Function, null], default: null },
    label: { default: null }
  },
  setup(n) {
    const e = n, t = ft(), i = t.s, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = I(() => t.genMode.value), a = I(() => t.sending()), l = I(() => t.queueItems.value.length > 0 && t.limit.value > 0), d = I(() => Math.max(0, Math.min(t.queueItems.value.length, t.limit.value) - 1)), c = I(() => r.value === "threed" && !!e.before), u = I(() => t.fullTakesOver(r.value)), p = I(() => !!i.fullOpen[r.value] && (!!t.fullPromptOf(r.value).trim() || t.fullEdit(r.value) != null));
    function f(x, T) {
      return x + " " + T + (x === 1 ? "" : "s");
    }
    const y = I(() => a.value.map((x) => {
      const T = [x.marks ? f(x.marks, "annotation") : "", x.comments ? f(x.comments, "note") : ""].filter(Boolean);
      return "Image " + x.image + ": " + T.join(", ");
    }).join(" · ")), b = I(() => {
      if (a.value.length) {
        const x = a.value.reduce((z, P) => z + P.marks, 0), T = a.value.reduce((z, P) => z + P.comments, 0);
        return { icon: "Pencil", text: [x ? f(x, "annotation") : "", T ? f(T, "note") : ""].filter(Boolean).join(", ") + (x + T === 1 ? " goes with it" : " go with them"), title: "Goes with it: " + y.value };
      }
      return l.value ? { icon: "Images", text: d.value ? "From image 1, with " + d.value + " more" : "From image 1", title: "Starts from image 1" + (d.value ? ", with " + d.value + " more as references" : "") } : null;
    }), w = I(() => t.video.value ? l.value ? d.value ? "Describe the video to make from these pictures" : "Describe the video to make from image 1" : "Describe a new video" : l.value ? a.value.length ? "Anything to add? Their annotations and notes go with them" : d.value ? "Describe what to make from these images" : "Describe what to make from image 1" : "Describe a new image");
    function k() {
      const x = s.value;
      x && (x.style.height = "0px", x.style.height = Math.min(160, Math.max(48, x.scrollHeight)) + "px");
    }
    $e(() => i.prompt, () => it(k)), ot(() => {
      k(), i.studio === "prompt" && s.value && s.value.focus();
    });
    async function S(x = null) {
      i.sending || e.before && !await e.before() || await t.generate(x);
    }
    function _(x) {
      x.key === "Enter" && vn(x) && (x.preventDefault(), o.value && o.value.tryRun());
    }
    return (x, T) => (g(), v("div", Upe, [
      h("textarea", {
        ref_key: "text",
        ref: s,
        value: m(i).prompt,
        class: "up-text sv-describe-text",
        rows: "1",
        spellcheck: "false",
        placeholder: w.value,
        "data-testid": "studio-prompt",
        onInput: T[0] || (T[0] = (M) => {
          m(t).setPrompt(M.target.value), k();
        }),
        onBlur: T[1] || (T[1] = (M) => m(t).commitPrompt()),
        onKeydown: _
      }, null, 40, Gpe),
      C(Tl, { open: p.value }, {
        default: et(() => [
          C($y, {
            kind: r.value,
            onRun: S
          }, null, 8, ["kind"])
        ]),
        _: 1
      }, 8, ["open"]),
      C(rI, {
        ref_key: "foot",
        ref: o,
        kind: r.value,
        resting: u.value,
        unchecked: c.value,
        label: n.label,
        "run-testid": "studio-generate",
        "count-testid": "studio-count",
        onRun: T[2] || (T[2] = (M) => S())
      }, V5({
        aside: et(() => [
          C(Dy, { kind: r.value }, null, 8, ["kind"])
        ]),
        _: 2
      }, [
        b.value ? {
          name: "chips",
          fn: et(() => [
            T[3] || (T[3] = h("span", { class: "up-foot-sep" }, null, -1)),
            h("span", {
              class: "up-note",
              title: b.value.title,
              "data-testid": "studio-sending"
            }, [
              C(R, {
                name: b.value.icon,
                size: 12
              }, null, 8, ["name"]),
              X(A(b.value.text), 1)
            ], 8, jpe)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["kind", "resting", "unchecked", "label"])
    ]));
  }
}), Yf = /* @__PURE__ */ Re({
  __name: "Radio",
  props: {
    on: { type: Boolean }
  },
  setup(n) {
    return (e, t) => (g(), v("span", {
      class: U(["ed-radio", { on: n.on }]),
      "aria-hidden": "true"
    }, [...t[0] || (t[0] = [
      h("i", null, null, -1)
    ])], 2));
  }
}), Vpe = /* @__PURE__ */ Re({
  __name: "AutoHeight",
  setup(n) {
    const e = /* @__PURE__ */ K(null), t = /* @__PURE__ */ K(null), i = /* @__PURE__ */ K(!1);
    let s = null, o = 0;
    function r() {
      if (!e.value) return;
      const a = e.value.offsetHeight;
      t.value != null && Math.abs(a - t.value) > 0.5 && (i.value = !0, clearTimeout(o), o = window.setTimeout(() => {
        i.value = !1;
      }, 380)), t.value = a;
    }
    return ot(() => {
      r(), e.value && (s = new ResizeObserver(r), s.observe(e.value));
    }), Ve(() => {
      s && s.disconnect(), clearTimeout(o);
    }), (a, l) => (g(), v("div", {
      class: U(["ed-autoh", { "is-moving": i.value }]),
      style: de({ height: t.value != null ? t.value + "px" : "auto" })
    }, [
      h("div", {
        ref_key: "inner",
        ref: e,
        class: "ed-autoh-in"
      }, [
        Ws(a.$slots, "default")
      ], 512)
    ], 6));
  }
}), Wpe = {
  class: "ed-tools-inline",
  "data-testid": "studio-area-tools"
}, qpe = {
  class: "sv-seg is-small ed-seg-icons",
  role: "radiogroup",
  "aria-label": "Select the area with"
}, Kpe = ["aria-checked", "title", "aria-label", "data-testid", "onClick"], Ype = ["aria-pressed", "title"], Xpe = ["title"], Jpe = ["disabled", "title"], Zpe = ["disabled", "title"], Qpe = ["disabled"], efe = /* @__PURE__ */ Re({
  __name: "AreaTools",
  setup(n) {
    const e = ft(), t = e.s, i = [
      { id: "brush", icon: "Paintbrush", label: "Brush", key: "B", hint: "Paint over what should change" },
      { id: "lasso", icon: "LassoSelect", label: "Lasso", key: "L", hint: "Draw round what should change" },
      { id: "object", icon: "MousePointerClick", label: "Pick an object", key: "S", hint: "Click a thing in the picture to take it all" }
    ], s = Tn(["alt"]), o = I(() => e.area().length > 0);
    function r(a) {
      t.areaTool = a;
    }
    return (a, l) => (g(), v("div", Wpe, [
      h("div", qpe, [
        (g(), v(H, null, me(i, (d) => h("button", {
          key: d.id,
          role: "radio",
          "aria-checked": m(t).areaTool === d.id,
          class: U({ on: m(t).areaTool === d.id }),
          title: d.label + " (" + d.key + `)
` + d.hint,
          "aria-label": d.label,
          "data-testid": "studio-area-" + d.id,
          onClick: (c) => r(d.id)
        }, [
          C(R, {
            name: d.icon,
            size: 14
          }, null, 8, ["name"])
        ], 10, Kpe)), 64))
      ]),
      h("button", {
        class: U(["ed-icon-chip", { on: m(t).areaCut }]),
        "aria-pressed": m(t).areaCut,
        title: `Take away from the area
Or hold ` + m(s) + " as you paint",
        "data-testid": "studio-area-cut",
        onClick: l[0] || (l[0] = (d) => m(t).areaCut = !m(t).areaCut)
      }, [
        C(R, {
          name: "Minus",
          size: 13
        })
      ], 10, Ype),
      m(t).areaTool === "brush" ? (g(), v("label", {
        key: 0,
        class: "ed-size",
        title: "Brush size: " + m(t).areaSize + `
[ and ] change it`
      }, [
        h("i", {
          style: de({ width: Math.max(4, Math.min(18, m(t).areaSize / 6)) + "px", height: Math.max(4, Math.min(18, m(t).areaSize / 6)) + "px" })
        }, null, 4),
        xt(h("input", {
          "onUpdate:modelValue": l[1] || (l[1] = (d) => m(t).areaSize = d),
          type: "range",
          min: "6",
          max: "200",
          step: "1",
          "aria-label": "Brush size",
          "data-testid": "studio-area-size"
        }, null, 512), [
          [
            Jt,
            m(t).areaSize,
            void 0,
            { number: !0 }
          ]
        ])
      ], 8, Xpe)) : E("", !0),
      l[5] || (l[5] = h("span", { class: "ed-mini-sep" }, null, -1)),
      h("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canUndo(),
        title: "Undo (" + m(Tn)(["mod", "Z"]) + ")",
        "aria-label": "Undo",
        onClick: l[2] || (l[2] = (d) => m(e).undoMark())
      }, [
        C(R, {
          name: "Undo2",
          size: 13
        })
      ], 8, Jpe),
      h("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canRedo(),
        title: "Redo (" + m(Tn)(m(l1)()) + ")",
        "aria-label": "Redo",
        onClick: l[3] || (l[3] = (d) => m(e).redoMark())
      }, [
        C(R, {
          name: "Redo2",
          size: 13
        })
      ], 8, Zpe),
      h("button", {
        class: "ed-icon-chip",
        disabled: !o.value,
        title: "Clear the area",
        "aria-label": "Clear the area",
        "data-testid": "studio-area-clear",
        onClick: l[4] || (l[4] = (d) => m(e).clearArea())
      }, [
        C(R, {
          name: "Trash2",
          size: 13
        })
      ], 8, Qpe)
    ]));
  }
}), tfe = { class: "sv-pop-wrap" }, nfe = ["aria-expanded", "title"], ife = {
  key: 0,
  class: "sv-pop ed-mark-pop",
  role: "radiogroup",
  "aria-label": "Annotate with"
}, sfe = ["aria-checked", "data-testid", "onClick"], ofe = { class: "nm" }, rfe = ["value"], afe = ["disabled"], lfe = { class: "sv-pop-wrap" }, dfe = ["title"], cfe = { class: "ed-swatch-row" }, ufe = ["title", "onClick"], hfe = ["value"], pfe = ["title"], ffe = ["value", "disabled"], mfe = { "data-testid": "studio-opacity-value" }, gfe = ["disabled", "title"], bfe = ["disabled", "title"], vfe = /* @__PURE__ */ Re({
  __name: "MarkTools",
  setup(n) {
    const e = ft(), t = e.s, i = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = [
      { id: "move", icon: "MousePointer2", label: "Move", key: "V", hint: "Select annotations to move, resize or turn them" },
      { id: "brush", icon: "Brush", label: "Pencil", key: "B", hint: "Draw on the picture to show where" },
      { id: "text", icon: "Type", label: "Text", key: "T", hint: "Write a label on the picture" },
      { id: "box", icon: "Square", label: "Box", key: "R", hint: "Box an area" },
      { id: "ellipse", icon: "Circle", label: "Ellipse", key: "O", hint: "Circle an area" },
      { id: "arrow", icon: "ArrowUpRight", label: "Arrow", key: "A", hint: "Point at something" },
      { id: "eraser", icon: "Eraser", label: "Eraser", key: "E", hint: "Rub out parts of your annotations" },
      { id: "note", icon: "MapPin", label: "Note", key: "N", hint: "Pin a numbered note where something should change" }
    ], r = I(() => o.find((S) => S.id === t.tool) || o[1]), a = I(() => !c0.includes(t.color)), l = I(() => t.tool === "text"), d = I(() => Math.round(t.opacity * 100));
    let c = !1;
    function u() {
      c = !0, t.tool === "move" && t.selection.length && e.beginGesture();
    }
    function p(S) {
      e.setOpacity(Number(S.target.value) / 100, !c);
    }
    function f() {
      c = !1;
    }
    const y = I(() => {
      const S = e.working();
      return S.strokes.length > 0 || S.pins.length > 0;
    });
    function b(S) {
      e.finishEditing(), t.tool = S, S !== "move" && e.select([]), i.value = null;
    }
    function w(S) {
      !Number.isFinite(S) || S <= 0 || (t.size = Math.max(1, Math.min(80, Math.round(S))));
    }
    function k(S) {
      s.value && !s.value.contains(S.target) && (i.value = null);
    }
    return $e(i, (S) => {
      S ? window.addEventListener("pointerdown", k, !0) : window.removeEventListener("pointerdown", k, !0);
    }), Ve(() => window.removeEventListener("pointerdown", k, !0)), (S, _) => (g(), v("div", {
      ref_key: "wrap",
      ref: s,
      class: "ed-tools-inline",
      "data-testid": "studio-mark-tools",
      onKeydown: _[8] || (_[8] = tn(Pe((x) => i.value = null, ["stop"]), ["esc"]))
    }, [
      h("div", tfe, [
        h("button", {
          class: U(["sv-chip ed-tool-chip", { on: i.value === "tool" }]),
          "aria-expanded": i.value === "tool",
          title: r.value.label + " (" + r.value.key + `)
` + r.value.hint,
          "data-testid": "studio-mark-tool",
          onClick: _[0] || (_[0] = (x) => i.value = i.value === "tool" ? null : "tool")
        }, [
          C(R, {
            name: r.value.icon,
            size: 13
          }, null, 8, ["name"]),
          h("span", null, A(r.value.label), 1),
          C(R, {
            name: "ChevronUp",
            size: 11,
            class: "chev"
          })
        ], 10, nfe),
        i.value === "tool" ? (g(), v("div", ife, [
          (g(), v(H, null, me(o, (x) => h("button", {
            key: x.id,
            class: U(["ed-mark-row", { on: m(t).tool === x.id }]),
            role: "radio",
            "aria-checked": m(t).tool === x.id,
            "data-testid": "studio-tool-" + x.id,
            onClick: (T) => b(x.id)
          }, [
            C(R, {
              name: x.icon,
              size: 14
            }, null, 8, ["name"]),
            h("span", ofe, A(x.label), 1),
            h("kbd", null, A(x.key), 1)
          ], 10, sfe)), 64)),
          h("div", {
            class: U(["ed-mark-size", { "is-off": m(t).tool === "move" || m(t).tool === "text" || m(t).tool === "note" }])
          }, [
            _[9] || (_[9] = h("span", null, "Size", -1)),
            h("input", {
              value: m(t).size,
              type: "range",
              min: "1",
              max: "80",
              step: "1",
              "aria-label": "Size",
              onInput: _[1] || (_[1] = (x) => w(+x.target.value))
            }, null, 40, rfe),
            h("b", null, A(m(t).size), 1)
          ], 2),
          h("button", {
            class: "ed-mark-clear",
            disabled: !y.value,
            "data-testid": "studio-clear",
            onClick: _[2] || (_[2] = (x) => {
              m(e).clearMarks(), i.value = null;
            })
          }, [
            C(R, {
              name: "Trash2",
              size: 12
            }),
            _[10] || (_[10] = X(" Clear annotations and notes", -1))
          ], 8, afe)
        ])) : E("", !0)
      ]),
      h("div", lfe, [
        h("button", {
          class: U(["sv-color ed-color", { on: i.value === "colour" }]),
          style: de({ "--c": m(t).color, "--o": l.value ? 1 : m(t).opacity }),
          title: "Colour" + (l.value ? "" : ", " + d.value + "% opacity"),
          "aria-label": "Colour and opacity",
          "data-testid": "studio-color",
          onClick: _[3] || (_[3] = (x) => i.value = i.value === "colour" ? null : "colour")
        }, [..._[11] || (_[11] = [
          h("i", null, null, -1)
        ])], 14, dfe),
        i.value === "colour" ? (g(), v("div", {
          key: 0,
          class: "sv-pop is-colors ed-colour-pop",
          "data-testid": "studio-colour-pop",
          onPointerdown: _[5] || (_[5] = Pe(() => {
          }, ["stop"]))
        }, [
          h("div", cfe, [
            (g(!0), v(H, null, me(m(c0), (x) => (g(), v("button", {
              key: x,
              class: U(["sw", { on: m(t).color === x }]),
              style: de({ "--c": x }),
              title: x,
              onClick: (T) => m(e).setColor(x)
            }, null, 14, ufe))), 128)),
            h("label", {
              class: U(["sw is-any", { on: a.value }]),
              style: de(a.value ? { "--c": m(t).color } : void 0),
              title: "Any colour"
            }, [
              h("input", {
                type: "color",
                value: m(t).color,
                onInput: _[4] || (_[4] = (x) => m(e).setColor(x.target.value))
              }, null, 40, hfe)
            ], 6)
          ]),
          h("label", {
            class: U(["ed-opacity", { "is-off": l.value }]),
            title: l.value ? "Text stays solid, so it reads clearly" : "How see-through new annotations are"
          }, [
            _[12] || (_[12] = h("span", { class: "lb" }, "Opacity", -1)),
            h("input", {
              class: "ed-opacity-range",
              type: "range",
              min: "10",
              max: "100",
              step: "5",
              value: d.value,
              disabled: l.value,
              style: de({ "--c": m(t).color }),
              "aria-label": "Opacity",
              "data-testid": "studio-opacity",
              onPointerdown: u,
              onInput: p,
              onChange: f
            }, null, 44, ffe),
            h("b", mfe, A(l.value ? 100 : d.value) + "%", 1)
          ], 10, pfe)
        ], 32)) : E("", !0)
      ]),
      _[13] || (_[13] = h("span", { class: "ed-mini-sep" }, null, -1)),
      h("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canUndo(),
        title: "Undo (" + m(Tn)(["mod", "Z"]) + ")",
        "aria-label": "Undo",
        "data-testid": "studio-undo",
        onClick: _[6] || (_[6] = (x) => m(e).undoMark())
      }, [
        C(R, {
          name: "Undo2",
          size: 13
        })
      ], 8, gfe),
      h("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canRedo(),
        title: "Redo (" + m(Tn)(m(l1)()) + ")",
        "aria-label": "Redo",
        "data-testid": "studio-redo",
        onClick: _[7] || (_[7] = (x) => m(e).redoMark())
      }, [
        C(R, {
          name: "Redo2",
          size: 13
        })
      ], 8, bfe)
    ], 544));
  }
}), yfe = ["title", "onMouseenter"], xfe = ["aria-label", "onClick"], wfe = {
  key: 0,
  class: "up-drop-wrap"
}, kfe = ["aria-expanded"], _fe = { class: "n" }, $_ = 320, Sfe = /* @__PURE__ */ Re({
  __name: "EditRefs",
  props: {
    over: { type: Boolean }
  },
  setup(n) {
    const e = n, t = ft(), i = t.s, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = I(() => t.editRefItems.value), a = I(() => t.refRoom()), l = I(() => r.value.filter((D) => D.id !== i.stageId)), d = I(() => l.value.length < a.value), c = I(() => t.modelName("edit")), u = I(() => i.bar !== "annotate" && t.hasArea() ? 3 : 2), p = I(() => !!Lr.value && !r.value.some((D) => D.id === Lr.value));
    function f(D) {
      return t.refSent(D.id);
    }
    function y(D) {
      return D.id === i.stageId ? "On the stage: it's the picture being edited, so it isn't sent as a reference" : f(D) ? "Image " + b(D) + ": a reference" : "Waits: " + c.value + " takes " + a.value + (a.value === 1 ? " reference" : " references") + " here";
    }
    function b(D) {
      return u.value + l.value.findIndex(($) => $.id === D.id);
    }
    function w(D) {
      const $ = i.refPulse;
      return $ && $.id === D ? $.n : 0;
    }
    function k(D) {
      x.value = null, t.removeEditRef(D.id);
    }
    async function S(D) {
      o.value = !1, await t.addEditRefUrl(D);
    }
    function _() {
      o.value = !1, t.setDropper(!0);
    }
    const x = /* @__PURE__ */ We(null);
    function T(D, $) {
      const O = s.value ? s.value.closest(".ed-card") : null;
      if (!O || Lr.value) return;
      const L = Math.min($_ / D.w, $_ / D.h), Z = Math.round(D.w * L), J = Math.round(D.h * L), re = $.currentTarget.getBoundingClientRect(), F = O.getBoundingClientRect();
      x.value = { it: D, w: Z, h: J, left: Math.max(Z / 2, Math.min(F.width - Z / 2, re.left - F.left + re.width / 2)) };
    }
    const M = I(() => {
      const D = x.value;
      return D && !o.value && !Lr.value && r.value.some(($) => $.id === D.it.id) ? D : null;
    });
    function z(D) {
      const $ = D.target;
      s.value && !s.value.contains($) && !$.closest(".lb-backdrop") && (o.value = !1);
    }
    function P(D) {
      D.key === "Escape" && (D.stopPropagation(), D.preventDefault(), o.value = !1);
    }
    return $e(o, (D) => {
      D ? (window.addEventListener("pointerdown", z, !0), window.addEventListener("keydown", P, !0)) : (window.removeEventListener("pointerdown", z, !0), window.removeEventListener("keydown", P, !0));
    }), Ve(() => {
      window.removeEventListener("pointerdown", z, !0), window.removeEventListener("keydown", P, !0);
    }), (D, $) => (g(), v("div", {
      ref_key: "wrap",
      ref: s,
      class: "up-refs ed-refs",
      "data-testid": "studio-edit-refs"
    }, [
      C(Tp, { name: "ed-ref" }, {
        default: et(() => [
          (g(!0), v(H, null, me(r.value, (O) => (g(), v("div", {
            key: O.id,
            class: U(["up-ref ed-ref", { "is-unsent": !f(O) }]),
            title: y(O),
            "data-testid": "studio-edit-ref",
            onMouseenter: (L) => T(O, L),
            onMouseleave: $[0] || ($[0] = (L) => x.value = null)
          }, [
            C(us, { item: O }, null, 8, ["item"]),
            h("button", {
              title: "Remove",
              "aria-label": "Remove " + (O.label || "reference"),
              "data-testid": "studio-edit-ref-remove",
              onClick: (L) => k(O)
            }, [
              C(R, {
                name: "X",
                size: 11
              })
            ], 8, xfe),
            w(O.id) ? (g(), v("span", {
              key: "pulse" + w(O.id),
              class: "up-ref-pulse",
              "aria-hidden": "true"
            })) : E("", !0)
          ], 42, yfe))), 128))
        ]),
        _: 1
      }),
      d.value ? (g(), v("div", wfe, [
        h("button", {
          class: U(["up-drop", { "is-target": e.over, "is-dropper": m(i).dropper, "is-air": p.value && !e.over }]),
          title: "Add a reference. Or drag one onto the bar from history.",
          "aria-label": "Add a reference",
          "aria-expanded": o.value,
          "data-testid": "studio-edit-ref-add",
          onClick: $[1] || ($[1] = (O) => {
            o.value = !o.value, m(t).setDropper(!1);
          })
        }, [
          C(R, {
            name: "ImagePlus",
            size: 18
          })
        ], 10, kfe),
        o.value ? (g(), Ce(sf, {
          key: 0,
          "session-id": m(t).sessionId,
          label: "Reference",
          "dropper-label": "Pick from history",
          tip: "Or drag a picture onto the bar from history, or from your computer.",
          onPick: S,
          onDropper: _,
          onClose: $[2] || ($[2] = (O) => o.value = !1)
        }, null, 8, ["session-id"])) : E("", !0)
      ])) : E("", !0),
      r.value.length ? E("", !0) : (g(), v("span", {
        key: 1,
        class: U(["ed-refs-hint", { "is-air": (p.value || e.over) && a.value > 0 }])
      }, A(a.value ? p.value || e.over ? "Drop it here to send it with the edit" : "References: drag pictures here from history, or pick them with the eyedropper" : "No room for references while an area is selected: " + c.value + " takes two pictures"), 3)),
      M.value ? (g(), v("div", {
        key: 2,
        class: "up-ref-peek ed-ref-peek",
        style: de({ left: M.value.left + "px", width: M.value.w + "px", height: M.value.h + "px" }),
        "aria-hidden": "true",
        "data-testid": "studio-edit-ref-peek"
      }, [
        C(us, {
          item: M.value.it,
          full: ""
        }, null, 8, ["item"]),
        h("span", _fe, A(M.value.it.id === m(i).stageId ? "On the stage" : f(M.value.it) ? "Image " + b(M.value.it) : "Waits"), 1)
      ], 4)) : E("", !0)
    ], 512));
  }
}), Tfe = ["aria-expanded", "title"], Mfe = { class: "t" }, Cfe = {
  key: 0,
  class: "sv-pop ed-keep-pop",
  role: "radiogroup",
  "aria-label": "How the area is kept"
}, Ife = { class: "sv-pop-rows" }, Afe = ["aria-checked", "data-testid", "onClick"], Pfe = { class: "tx" }, Efe = { class: "nm" }, Rfe = { class: "hint" }, zfe = /* @__PURE__ */ Re({
  __name: "AreaKeep",
  setup(n) {
    const t = ft().s, i = /* @__PURE__ */ K(!1), s = /* @__PURE__ */ K(null), o = [
      { precise: !0, label: "Precision", hint: "Only the area changes: every other pixel is kept", testid: "studio-precision" },
      { precise: !1, label: "Creative", hint: "The area changes most, and the rest may change a little to match", testid: "studio-creative" }
    ];
    function r(c) {
      t.precision = c, i.value = !1;
    }
    function a(c) {
      s.value && !s.value.contains(c.target) && (i.value = !1);
    }
    function l(c) {
      c.key === "Escape" && (c.stopPropagation(), c.preventDefault(), i.value = !1);
    }
    function d() {
      window.removeEventListener("pointerdown", a, !0), window.removeEventListener("keydown", l, !0);
    }
    return $e(i, (c) => {
      if (!c) {
        d();
        return;
      }
      window.addEventListener("pointerdown", a, !0), window.addEventListener("keydown", l, !0);
    }), Ve(d), (c, u) => (g(), v("div", {
      ref_key: "wrap",
      ref: s,
      class: "sv-pop-wrap"
    }, [
      h("button", {
        class: U(["up-chip ed-keep", { on: i.value }]),
        "aria-expanded": i.value,
        title: "The area you selected: " + (m(t).precision ? o[0].hint : o[1].hint),
        "data-testid": "studio-area-keep",
        onClick: u[0] || (u[0] = (p) => i.value = !i.value)
      }, [
        C(R, {
          name: "SquareDashed",
          size: 13
        }),
        h("span", Mfe, A(m(t).precision ? "Precision" : "Creative"), 1)
      ], 10, Tfe),
      i.value ? (g(), v("div", Cfe, [
        u[1] || (u[1] = h("div", { class: "sv-pop-title" }, "The area you selected", -1)),
        h("div", Ife, [
          (g(), v(H, null, me(o, (p) => h("button", {
            key: p.label,
            class: U(["sv-pop-row ed-keep-row", { on: m(t).precision === p.precise }]),
            role: "radio",
            "aria-checked": m(t).precision === p.precise,
            "data-testid": p.testid,
            onClick: (f) => r(p.precise)
          }, [
            h("span", Pfe, [
              h("span", Efe, A(p.label), 1),
              h("span", Rfe, A(p.hint), 1)
            ]),
            m(t).precision === p.precise ? (g(), Ce(R, {
              key: 0,
              name: "Check",
              size: 12,
              class: "ck"
            })) : E("", !0)
          ], 10, Afe)), 64))
        ])
      ])) : E("", !0)
    ], 512));
  }
}), $fe = ["title", "aria-expanded"], Dfe = { class: "t" }, Ofe = { class: "sv-pop-rows" }, Lfe = ["aria-selected", "data-testid", "onClick"], Bfe = { class: "nm" }, Ffe = {
  key: 0,
  class: "mt"
}, Nfe = /* @__PURE__ */ Re({
  __name: "EditSize",
  props: {
    kind: {}
  },
  setup(n) {
    const e = n, t = ft(), i = I(() => t.tiersOf(e.kind)), s = I(() => Math.min(t.tierOf(e.kind), Math.max(0, i.value.length - 1))), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(null);
    function a(d) {
      t.setTier(e.kind, d), o.value = !1;
    }
    function l(d) {
      r.value && !r.value.contains(d.target) && (o.value = !1);
    }
    return ot(() => window.addEventListener("pointerdown", l, !0)), Ve(() => window.removeEventListener("pointerdown", l, !0)), (d, c) => i.value.length > 1 ? (g(), v("div", {
      key: 0,
      ref_key: "wrap",
      ref: r,
      class: "sv-pop-wrap"
    }, [
      h("button", {
        class: U(["up-chip", { on: o.value }]),
        title: "Size: " + (i.value[s.value].meta || i.value[s.value].label) + ". The picture keeps its shape.",
        "aria-expanded": o.value,
        "data-testid": "studio-edit-size",
        onClick: c[0] || (c[0] = (u) => o.value = !o.value)
      }, [
        C(R, {
          name: "Maximize2",
          size: 13
        }),
        h("span", Dfe, A(i.value[s.value].label), 1)
      ], 10, $fe),
      o.value ? (g(), v("div", {
        key: 0,
        class: "sv-pop is-narrow",
        role: "listbox",
        "aria-label": "Size",
        onKeydown: c[1] || (c[1] = tn(Pe((u) => o.value = !1, ["stop"]), ["esc"]))
      }, [
        c[2] || (c[2] = h("div", { class: "sv-pop-title" }, "Size", -1)),
        h("div", Ofe, [
          (g(!0), v(H, null, me(i.value, (u, p) => (g(), v("button", {
            key: u.label,
            class: U(["sv-pop-row", { on: p === s.value }]),
            role: "option",
            "aria-selected": p === s.value,
            "data-testid": "studio-edit-size-" + p,
            onClick: (f) => a(p)
          }, [
            h("span", Bfe, A(u.label), 1),
            u.meta ? (g(), v("span", Ffe, A(u.meta), 1)) : E("", !0)
          ], 10, Lfe))), 128))
        ])
      ], 32)) : E("", !0)
    ], 512)) : E("", !0);
  }
}), Ufe = { class: "ed-slider-head" }, Gfe = { class: "lb" }, jfe = ["title"], Hfe = { class: "ed-slider-track" }, Vfe = ["min", "max", "step", "value", "disabled", "aria-label", "data-testid"], St = /* @__PURE__ */ Re({
  __name: "Slider",
  props: {
    label: {},
    modelValue: {},
    min: {},
    max: {},
    step: { default: 1 },
    start: { default: 0 },
    format: { type: [Function, null], default: null },
    ticks: { default: () => [] },
    testid: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "commit"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = I(() => t.min < 0 && t.max > 0), o = I(() => Math.max(1e-9, t.max - t.min)), r = (p) => (Math.min(t.max, Math.max(t.min, p)) - t.min) / o.value, a = I(() => {
      const p = s.value ? r(0) : 0, f = r(t.modelValue);
      return { left: Math.min(p, f) * 100 + "%", width: Math.abs(f - p) * 100 + "%" };
    }), l = I(() => {
      if (t.format) return t.format(t.modelValue);
      const p = Math.round(t.modelValue * 100) / 100;
      return s.value && p > 0 ? "+" + p : String(p);
    }), d = I(() => Math.abs(t.modelValue - t.start) > 1e-9);
    function c(p) {
      i("update:modelValue", Number(p.target.value));
    }
    function u() {
      t.disabled || (i("update:modelValue", t.start), i("commit", t.start));
    }
    return (p, f) => (g(), v("label", {
      class: U(["ed-slider", { "is-changed": d.value, "is-off": n.disabled }]),
      onDblclick: u
    }, [
      h("span", Ufe, [
        h("span", Gfe, A(n.label), 1),
        h("span", {
          class: "v",
          title: d.value ? "Double-click to reset" : ""
        }, A(l.value), 9, jfe)
      ]),
      h("span", Hfe, [
        f[1] || (f[1] = h("span", { class: "rail" }, null, -1)),
        h("span", {
          class: "fill",
          style: de(a.value)
        }, null, 4),
        (g(!0), v(H, null, me(n.ticks, (y) => (g(), v("i", {
          key: y,
          class: U(["tick", { on: Math.abs(y - n.modelValue) < 1e-6 }]),
          style: de({ left: r(y) * 100 + "%" })
        }, null, 6))), 128)),
        h("input", {
          type: "range",
          min: n.min,
          max: n.max,
          step: n.step,
          value: n.modelValue,
          disabled: n.disabled,
          "aria-label": n.label,
          "data-testid": n.testid,
          onInput: c,
          onChange: f[0] || (f[0] = (y) => i("commit", Number(y.target.value)))
        }, null, 40, Vfe)
      ])
    ], 34));
  }
}), Wfe = ["data-testid"], qfe = {
  key: 0,
  class: "ed-field"
}, Kfe = { class: "ed-field-lb" }, Yfe = ["aria-label"], Xfe = ["aria-checked", "onClick"], Jfe = {
  key: 1,
  class: "ed-field"
}, Zfe = { class: "ed-field-lb" }, Qfe = { class: "ed-select" }, eme = ["value", "onChange"], tme = ["value"], nme = {
  key: 3,
  class: "ed-field"
}, ime = { class: "ed-field-lb" }, sme = ["value", "placeholder", "onInput"], ome = ["aria-expanded"], rme = {
  key: 1,
  class: "ed-fields-more"
}, ame = {
  key: 1,
  class: "ed-switch"
}, lme = ["checked", "onChange"], dme = {
  key: 2,
  class: "ed-field"
}, cme = { class: "ed-field-lb" }, ume = { class: "ed-select" }, hme = ["value", "onChange"], pme = ["value"], fme = {
  key: 3,
  class: "ed-field"
}, mme = { class: "ed-field-lb" }, gme = ["value", "placeholder", "onInput"], aI = /* @__PURE__ */ Re({
  __name: "ModelFields",
  props: {
    kind: {},
    skip: { default: () => [] },
    part: { default: "all" }
  },
  setup(n) {
    const e = n, t = ft(), i = /* @__PURE__ */ K(!1), s = I(() => t.modelOf(e.kind)), o = I(() => {
      const f = s.value;
      return f ? f.fields.filter((y) => y.placement !== "reference" && y.kind !== "seed" && y.kind !== "header" && y.kind !== "model" && y.kind !== "video" && !e.skip.includes(y.key) && !e.skip.includes(y.label)) : [];
    }), r = I(() => e.part === "more" ? [] : o.value.filter((f) => f.placement === "chip" || f.placement === "prompt")), a = I(() => o.value.filter((f) => f.placement === "advanced"));
    function l(f) {
      return t.valueOf(e.kind, f);
    }
    function d(f, y) {
      t.setInput(e.kind, f.key, y);
    }
    function c(f) {
      const y = l(f), b = typeof y == "number" ? y : Number(y);
      return Number.isFinite(b) ? b : Number(f.defaultValue) || 0;
    }
    function u(f) {
      return f.replace(/\s*\(optional\)\s*/i, "").replace(/\s*\(must be [^)]*\)\s*/i, "");
    }
    function p(f) {
      return f.replace(/_n_/g, " and ").replace(/_/g, " ").replace(/^\w/, (y) => y.toUpperCase());
    }
    return (f, y) => (n.part === "more" ? a.value.length : o.value.length) ? (g(), v("div", {
      key: 0,
      class: "ed-fields",
      "data-testid": n.part === "more" ? "studio-edit-more" : void 0
    }, [
      (g(!0), v(H, null, me(r.value, (b) => {
        var w, k, S, _;
        return g(), v(H, {
          key: b.key
        }, [
          (b.kind === "select" || b.kind === "size") && b.options && b.options.length <= 5 ? (g(), v("div", qfe, [
            h("span", Kfe, A(u(b.label)), 1),
            h("div", {
              class: "sv-seg is-small ed-pills",
              role: "radiogroup",
              "aria-label": b.label
            }, [
              (g(!0), v(H, null, me(b.options, (x) => (g(), v("button", {
                key: String(x.label),
                role: "radio",
                "aria-checked": m(as)(x.value, l(b)),
                class: U({ on: m(as)(x.value, l(b)) }),
                onClick: (T) => d(b, x.value)
              }, A(/^\d+$/.test(String(x.label)) ? x.label + "×" : p(String(x.label))), 11, Xfe))), 128))
            ], 8, Yfe)
          ])) : b.kind === "select" && b.options ? (g(), v("label", Jfe, [
            h("span", Zfe, A(u(b.label)), 1),
            h("span", Qfe, [
              h("select", {
                value: JSON.stringify(l(b)),
                onChange: (x) => d(b, JSON.parse(x.target.value))
              }, [
                (g(!0), v(H, null, me(b.options, (x) => (g(), v("option", {
                  key: String(x.label),
                  value: JSON.stringify(x.value)
                }, A(p(String(x.label))), 9, tme))), 128))
              ], 40, eme),
              C(R, {
                name: "ChevronDown",
                size: 12
              })
            ])
          ])) : b.kind === "slider" ? (g(), Ce(St, {
            key: 2,
            label: u(b.label),
            "model-value": c(b),
            min: (w = b.min) != null ? w : 0,
            max: (k = b.max) != null ? k : 100,
            step: (S = b.step) != null ? S : 1,
            start: Number(b.defaultValue) || 0,
            "onUpdate:modelValue": (x) => d(b, x)
          }, null, 8, ["label", "model-value", "min", "max", "step", "start", "onUpdate:modelValue"])) : b.kind === "prompt" || b.kind === "text" ? (g(), v("label", nme, [
            h("span", ime, A(u(b.label)), 1),
            h("textarea", {
              class: "ed-text",
              rows: "2",
              value: String((_ = l(b)) != null ? _ : ""),
              placeholder: b.placeholder || "Optional",
              spellcheck: "false",
              onInput: (x) => d(b, x.target.value)
            }, null, 40, sme)
          ])) : E("", !0)
        ], 64);
      }), 128)),
      a.value.length && n.part !== "more" ? (g(), v("button", {
        key: 0,
        class: U(["ed-more", { on: i.value }]),
        "aria-expanded": i.value,
        onClick: y[0] || (y[0] = (b) => i.value = !i.value)
      }, [
        C(R, {
          name: "Settings2",
          size: 12
        }),
        X(" " + A(i.value ? "Fewer settings" : "More settings") + " ", 1),
        C(R, {
          name: i.value ? "ChevronUp" : "ChevronDown",
          size: 12
        }, null, 8, ["name"])
      ], 10, ome)) : E("", !0),
      i.value || n.part === "more" ? (g(), v("div", rme, [
        (g(!0), v(H, null, me(a.value, (b) => {
          var w, k, S, _;
          return g(), v(H, {
            key: b.key
          }, [
            b.kind === "slider" ? (g(), Ce(St, {
              key: 0,
              label: u(b.label),
              "model-value": c(b),
              min: (w = b.min) != null ? w : 0,
              max: (k = b.max) != null ? k : 100,
              step: (S = b.step) != null ? S : 1,
              start: Number(b.defaultValue) || 0,
              "onUpdate:modelValue": (x) => d(b, x)
            }, null, 8, ["label", "model-value", "min", "max", "step", "start", "onUpdate:modelValue"])) : b.kind === "boolean" ? (g(), v("label", ame, [
              h("input", {
                type: "checkbox",
                checked: !!l(b),
                onChange: (x) => d(b, x.target.checked)
              }, null, 40, lme),
              y[1] || (y[1] = h("i", null, null, -1)),
              h("span", null, A(u(b.label)), 1)
            ])) : (b.kind === "select" || b.kind === "size") && b.options ? (g(), v("label", dme, [
              h("span", cme, A(u(b.label)), 1),
              h("span", ume, [
                h("select", {
                  value: JSON.stringify(l(b)),
                  onChange: (x) => d(b, JSON.parse(x.target.value))
                }, [
                  (g(!0), v(H, null, me(b.options, (x) => (g(), v("option", {
                    key: String(x.label),
                    value: JSON.stringify(x.value)
                  }, A(p(String(x.label))), 9, pme))), 128))
                ], 40, hme),
                C(R, {
                  name: "ChevronDown",
                  size: 12
                })
              ])
            ])) : b.kind === "prompt" || b.kind === "text" || b.kind === "negPrompt" ? (g(), v("label", fme, [
              h("span", mme, A(u(b.label)), 1),
              h("textarea", {
                class: "ed-text",
                rows: "2",
                value: String((_ = l(b)) != null ? _ : ""),
                placeholder: b.placeholder || "Optional",
                spellcheck: "false",
                onInput: (x) => d(b, x.target.value)
              }, null, 40, gme)
            ])) : E("", !0)
          ], 64);
        }), 128))
      ])) : E("", !0)
    ], 8, Wfe)) : E("", !0);
  }
}), bme = {
  key: "tool",
  class: "ed-bar-tool",
  "data-testid": "studio-edit-bar-tool"
}, vme = { class: "ic" }, yme = { class: "st" }, xme = ["disabled"], wme = {
  key: "bar",
  class: "ed-bar-main ed-card"
}, kme = { class: "up-side ed-side" }, _me = ["disabled", "title", "aria-pressed"], Sme = { class: "ed-col" }, Tme = ["placeholder", "disabled", "readonly"], Mme = { class: "ed-bar-modes" }, Cme = {
  class: "ed-modes",
  role: "radiogroup",
  "aria-label": "Mode"
}, Ime = ["aria-checked", "title", "data-testid", "onClick"], Ame = ["aria-expanded"], Pme = {
  key: 1,
  class: "up-note",
  title: "Your annotations and notes on the picture go with the edit (N to change them)",
  "data-testid": "studio-edit-sending"
}, Eme = 48, Rme = 160, zme = /* @__PURE__ */ Re({
  __name: "EditBar",
  setup(n) {
    const e = ft(), t = e.s, i = e.tools, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = [
      { id: "edit", label: "Edit", key: "M", tip: "Say what to change; select an area to keep the change inside it" },
      { id: "erase", label: "Erase", key: "X", tip: "Paint over what should go; no words needed" },
      { id: "annotate", label: "Annotate", key: "N", tip: "Draw, label and pin notes to show the model what to change" }
    ], a = I(() => Cy(i.t.open)), l = I(() => e.stage.value), d = I(() => !!l.value && l.value.status === "done"), c = I(() => e.barKind()), u = I(() => t.bar === "erase"), p = I(() => c.value === "erase"), f = I(() => e.takesRefs()), y = I({
      get: () => e.askOf(t.stageId),
      set: (B) => {
        t.stageId && e.setAsk(t.stageId, B);
      }
    }), b = I(() => t.bar !== "annotate" && e.hasArea()), w = I(() => e.carried(l.value)), k = I(() => {
      const B = w.value;
      return [B.marks ? B.marks + (B.marks === 1 ? " annotation" : " annotations") : "", B.comments ? B.comments + (B.comments === 1 ? " note" : " notes") : ""].filter(Boolean).join(", ");
    }), S = I(() => k.value && t.bar !== "annotate" && !p.value ? k.value + (w.value.marks + w.value.comments === 1 ? " goes with it" : " go with it") : ""), _ = I(() => b.value && !u.value), x = I(() => e.modelOf(c.value)), T = I(() => e.fullTakesOver(c.value)), M = I(() => d.value ? e.barProblem() : "Pick an image to edit first"), z = I(() => !!t.fullOpen[c.value] && (!!e.fullPromptOf(c.value).trim() || e.fullEdit(c.value) != null)), P = /* @__PURE__ */ K(!1), D = I(() => !p.value && e.advancedOf(c.value).length > 0), $ = tt().board, O = Ty({
      board: $,
      field: "edit",
      sessionId: () => e.sessionId,
      value: () => y.value,
      write: (B) => {
        y.value = B;
      }
    }), L = I(() => O.ghost.value ? O.ghost.value : u.value ? p.value ? "Erase takes no words: paint over what should go" : "Paint over what should go, and say what belongs there instead (optional)" : t.bar === "annotate" ? k.value ? "Anything else to change? The annotations and notes go with it" : "Annotate the picture, or say what to change" : b.value ? "Say what to change in the area" : "Say what to change, or select an area on the picture to keep the change there"), Z = I(() => {
      const B = x.value, ne = B ? vy(B) : null;
      return ne ? [ne.key] : [];
    }), J = I(() => f.value ? "Pick a reference from history (I)" : u.value ? "Erase takes no references" : "This model takes one picture: the one you're editing");
    function re() {
      const B = s.value;
      B && (B.style.height = "0px", B.style.height = Math.min(Rme, Math.max(Eme, B.scrollHeight)) + "px");
    }
    $e(y, () => it(re)), $e(a, (B) => {
      B || it(re);
    }), ot(re);
    function F() {
      t.sending || e.generateEdit();
    }
    function W(B) {
      t.sending || e.generateEdit(B);
    }
    function ee(B) {
      B.key === "Enter" && vn(B) && (B.preventDefault(), o.value && o.value.tryRun());
    }
    const N = /* @__PURE__ */ K(!1);
    function te(B) {
      a.value || !sI(B) || (B.preventDefault(), B.dataTransfer && (B.dataTransfer.dropEffect = f.value ? "copy" : "none"), N.value = f.value);
    }
    function G(B) {
      const ne = B.relatedTarget;
      (!ne || !B.currentTarget.contains(ne)) && (N.value = !1);
    }
    function q(B) {
      const ne = oI(B);
      N.value = !1, Sl(), !(!ne || a.value) && (B.preventDefault(), B.stopPropagation(), e.addEditRef(ne));
    }
    return (B, ne) => (g(), v("div", {
      class: U(["sv-dock ed-bar", { "is-tool": !!a.value, "is-over": N.value }]),
      "data-testid": "studio-edit-bar",
      onDragover: te,
      onDragleave: G,
      onDrop: q
    }, [
      C(vt, { name: "sv-note" }, {
        default: et(() => [
          m(t).note ? (g(), v("div", {
            key: m(t).note.id,
            class: "sv-note",
            role: "status"
          }, A(m(t).note.text), 1)) : E("", !0)
        ]),
        _: 1
      }),
      C(Vpe, null, {
        default: et(() => [
          C(vt, { name: "ed-swap" }, {
            default: et(() => [
              a.value ? (g(), v("div", bme, [
                h("span", vme, [
                  C(R, {
                    name: a.value.icon,
                    size: 15
                  }, null, 8, ["name"])
                ]),
                h("b", null, A(a.value.label), 1),
                ne[6] || (ne[6] = h("span", { class: "dot" }, "·", -1)),
                h("span", yme, [
                  m(i).t.busy ? (g(), v(H, { key: 0 }, [
                    C(R, {
                      name: "Loader2",
                      size: 12,
                      spin: ""
                    }),
                    X(" " + A(m(i).t.busy), 1)
                  ], 64)) : m(i).pending() ? (g(), v(H, { key: 1 }, [
                    X("Not applied yet")
                  ], 64)) : (g(), v(H, { key: 2 }, [
                    X(A(a.value.hint), 1)
                  ], 64))
                ]),
                ne[7] || (ne[7] = h("span", { class: "grow" }, null, -1)),
                h("button", {
                  class: "ed-bar-close",
                  "data-testid": "studio-tool-close",
                  title: "Back to the bar (Esc)",
                  disabled: !!m(i).t.busy,
                  onClick: ne[0] || (ne[0] = (se) => m(i).close())
                }, [
                  ne[5] || (ne[5] = X(" Close ", -1)),
                  C(R, {
                    name: "X",
                    size: 13
                  })
                ], 8, xme)
              ])) : (g(), v("div", wme, [
                h("div", kme, [
                  h("button", {
                    class: U(["up-side-btn", { on: m(t).dropper }]),
                    disabled: !f.value,
                    title: J.value,
                    "aria-label": "Pick a reference from history",
                    "aria-pressed": m(t).dropper,
                    "data-testid": "studio-eyedropper",
                    onClick: ne[1] || (ne[1] = (se) => m(e).setDropper(!m(t).dropper))
                  }, [
                    C(R, {
                      name: "Pipette",
                      size: 15
                    })
                  ], 10, _me)
                ]),
                h("div", Sme, [
                  C(vt, { name: "ed-fold" }, {
                    default: et(() => [
                      f.value ? (g(), Ce(Sfe, {
                        key: 0,
                        over: N.value
                      }, null, 8, ["over"])) : E("", !0)
                    ]),
                    _: 1
                  }),
                  xt(h("textarea", {
                    ref_key: "text",
                    ref: s,
                    "onUpdate:modelValue": ne[2] || (ne[2] = (se) => y.value = se),
                    class: U(["up-text ed-words", { "is-tour-ghost": !!m(O).ghost.value, "is-typing": m(O).typing.value }]),
                    spellcheck: "false",
                    placeholder: L.value,
                    disabled: !d.value || p.value,
                    readonly: m(O).held.value || m(O).typing.value,
                    "data-testid": "studio-edit-prompt",
                    onInput: re,
                    onKeydown: ee
                  }, null, 42, Tme), [
                    [Jt, y.value]
                  ]),
                  m(O).ghost.value ? (g(), v("button", {
                    key: 0,
                    type: "button",
                    tabindex: "-1",
                    class: "up-cue is-tour ed-tour-cue",
                    "data-testid": "studio-ghost-cue",
                    onClick: ne[3] || (ne[3] = (se) => m($).tour && m($).tour.press && m($).tour.press("edit"))
                  }, [...ne[8] || (ne[8] = [
                    h("kbd", null, "Tab", -1),
                    X(" to write it in", -1)
                  ])])) : E("", !0),
                  h("div", Mme, [
                    h("div", Cme, [
                      (g(), v(H, null, me(r, (se) => h("button", {
                        key: se.id,
                        class: U(["ed-mode", { on: m(t).bar === se.id }]),
                        role: "radio",
                        "aria-checked": m(t).bar === se.id,
                        title: se.label + " (" + se.key + `)
` + se.tip,
                        "data-testid": "studio-mode-" + se.id,
                        onClick: (Y) => m(e).setBar(se.id)
                      }, [
                        C(Yf, {
                          on: m(t).bar === se.id
                        }, null, 8, ["on"]),
                        h("span", null, A(se.label), 1)
                      ], 10, Ime)), 64))
                    ]),
                    ne[9] || (ne[9] = h("span", { class: "sv-sep" }, null, -1)),
                    C(vt, {
                      name: "ed-fade",
                      mode: "out-in"
                    }, {
                      default: et(() => [
                        m(t).bar === "annotate" ? (g(), Ce(vfe, { key: "marks" })) : (g(), Ce(efe, { key: "area" }))
                      ]),
                      _: 1
                    })
                  ]),
                  C(Tl, { open: z.value }, {
                    default: et(() => [
                      C($y, {
                        kind: c.value,
                        onRun: W
                      }, null, 8, ["kind"])
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  C(Tl, {
                    open: P.value && D.value
                  }, {
                    default: et(() => [
                      C(aI, {
                        kind: c.value,
                        part: "more"
                      }, null, 8, ["kind"])
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  C(rI, {
                    ref_key: "foot",
                    ref: o,
                    kind: c.value,
                    own: M.value,
                    resting: T.value,
                    fixed: p.value,
                    "fixed-title": x.value ? x.value.name + " removes what you paint and fills in behind it" : "",
                    most: u.value ? 1 : null,
                    hide: Z.value,
                    "run-testid": "studio-edit-generate",
                    "count-testid": "studio-edit-count",
                    onRun: F
                  }, {
                    chips: et(() => [
                      p.value ? E("", !0) : (g(), Ce(Nfe, {
                        key: 0,
                        kind: c.value
                      }, null, 8, ["kind"])),
                      D.value ? (g(), v("button", {
                        key: 1,
                        class: U(["up-chip", { on: P.value }]),
                        "aria-expanded": P.value,
                        title: "More settings",
                        "data-testid": "studio-edit-more-toggle",
                        onClick: ne[4] || (ne[4] = (se) => P.value = !P.value)
                      }, [
                        C(R, {
                          name: "Settings2",
                          size: 13
                        }),
                        ne[10] || (ne[10] = h("span", { class: "t" }, "More", -1))
                      ], 10, Ame)) : E("", !0),
                      _.value || S.value ? (g(), v(H, { key: 2 }, [
                        ne[11] || (ne[11] = h("span", { class: "up-foot-sep" }, null, -1)),
                        _.value ? (g(), Ce(zfe, { key: 0 })) : E("", !0),
                        S.value ? (g(), v("span", Pme, [
                          C(R, {
                            name: "Pencil",
                            size: 12
                          }),
                          X(A(S.value), 1)
                        ])) : E("", !0)
                      ], 64)) : E("", !0)
                    ]),
                    aside: et(() => [
                      C(Dy, { kind: c.value }, null, 8, ["kind"])
                    ]),
                    _: 1
                  }, 8, ["kind", "own", "resting", "fixed", "fixed-title", "most", "hide"])
                ])
              ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 34));
  }
}), $me = { class: "ed-panel" }, Dme = { class: "ed-hint" }, Ome = /* @__PURE__ */ Re({
  __name: "PromptPanel",
  setup(n) {
    const t = ft().s;
    return (i, s) => (g(), v("div", $me, [
      h("p", Dme, [
        m(t).bar === "erase" ? (g(), v(H, { key: 0 }, [
          X("Paint over what should go and press Erase. The rest of the picture stays as it is.")
        ], 64)) : m(t).bar === "annotate" ? (g(), v(H, { key: 1 }, [
          X("Draw, label and pin numbered notes on the picture; they go to the model with your words, and come out of the result.")
        ], 64)) : (g(), v(H, { key: 2 }, [
          X("Say what to change in the bar below. Select an area on the picture to keep the change inside it: Precision keeps every other pixel.")
        ], 64))
      ]),
      s[0] || (s[0] = h("div", { class: "ed-keys" }, [
        h("span", null, [
          h("kbd", null, "M"),
          X(" Edit")
        ]),
        h("span", null, [
          h("kbd", null, "X"),
          X(" Erase")
        ]),
        h("span", null, [
          h("kbd", null, "N"),
          X(" Annotate")
        ])
      ], -1))
    ]));
  }
}), Lme = { class: "ed-go" }, Bme = ["title"], Fme = { class: "tx" }, Nme = { class: "nm" }, Ume = {
  key: 0,
  class: "why"
}, Gme = {
  key: 3,
  class: "ed-model-none"
}, jme = { class: "ed-go-row" }, Hme = ["disabled", "title", "data-testid"], Vme = { class: "lb" }, Wme = {
  key: 4,
  class: "ed-go-cost"
}, qme = {
  key: 5,
  class: "sv-problem is-inline"
}, Kme = {
  key: 6,
  class: "ed-go-full"
}, zo = /* @__PURE__ */ Re({
  __name: "ToolGo",
  props: {
    kind: {},
    label: {},
    icon: { default: "Sparkles" },
    picker: { type: Boolean, default: !1 },
    why: { default: "" },
    many: { type: Boolean, default: !0 },
    showModel: { type: Boolean, default: !0 },
    testid: { default: void 0 }
  },
  setup(n) {
    const e = n, t = ft(), i = t.s, s = t.tools, o = I(() => t.modelsFor(e.kind)), r = I(() => t.modelOf(e.kind)), a = I(() => t.countOf(e.kind)), l = I(() => e.many ? t.maxCount(e.kind) : 1), d = I(() => r.value ? t.priceOf(e.kind) : ""), c = I(() => t.fullTakesOver(e.kind)), u = I(() => c.value ? eI : s.problem(e.kind)), p = I(() => u.value || (r.value ? t.problemOf(e.kind) : null)), f = I(() => !!i.fullOpen[e.kind] && (!!t.fullPromptOf(e.kind).trim() || t.fullEdit(e.kind) != null));
    function y() {
      i.sending || c.value || s.runTool(e.kind);
    }
    function b(w) {
      i.sending || s.runTool(e.kind, w);
    }
    return (w, k) => (g(), v("div", Lme, [
      n.showModel ? n.picker && o.value.length > 1 ? (g(), Ce(zy, {
        key: 1,
        mode: n.kind,
        variant: "row"
      }, null, 8, ["mode"])) : r.value ? (g(), v("div", {
        key: 2,
        class: "ed-model-fixed",
        title: n.why || r.value.name
      }, [
        C(R, {
          name: "Cpu",
          size: 13
        }),
        h("span", Fme, [
          h("span", Nme, A(r.value.name), 1),
          n.why ? (g(), v("span", Ume, A(n.why), 1)) : E("", !0)
        ])
      ], 8, Bme)) : (g(), v("div", Gme, [
        C(R, {
          name: "CloudOff",
          size: 13
        }),
        k[1] || (k[1] = X(" Not available on this board yet", -1))
      ])) : (g(), v(H, { key: 0 }, [], 64)),
      h("div", jme, [
        l.value > 1 ? (g(), Ce(Sy, {
          key: 0,
          value: a.value,
          min: m(t).minCount(n.kind),
          max: l.value,
          tall: "",
          onUpdate: k[0] || (k[0] = (S) => m(t).setCount(n.kind, S))
        }, null, 8, ["value", "min", "max"])) : E("", !0),
        h("button", {
          class: U(["sv-go ed-go-btn", { "is-busy": m(i).sending > 0, "is-blocked": !!p.value }]),
          disabled: !r.value || c.value,
          title: p.value || "",
          "data-testid": n.testid || "studio-tool-run-" + n.kind,
          onClick: y
        }, [
          C(R, {
            name: m(i).sending ? "Loader2" : n.icon,
            size: 14,
            spin: m(i).sending > 0
          }, null, 8, ["name", "spin"]),
          h("span", Vme, A(m(i).sending ? "Sending" : n.label), 1)
        ], 10, Hme)
      ]),
      r.value && d.value ? (g(), v("div", Wme, [
        C(R, {
          name: "Tokens",
          size: 11
        }),
        X(" " + A(d.value), 1),
        r.value.time ? (g(), v(H, { key: 0 }, [
          X(" · about " + A(r.value.time), 1)
        ], 64)) : E("", !0)
      ])) : E("", !0),
      p.value && !c.value ? (g(), v("div", qme, [
        C(R, {
          name: "AlertCircle",
          size: 12
        }),
        X(" " + A(p.value.replace(/\.$/, "")), 1)
      ])) : E("", !0),
      r.value ? (g(), v("div", Kme, [
        C(Dy, { kind: n.kind }, null, 8, ["kind"])
      ])) : E("", !0),
      C(Tl, { open: f.value }, {
        default: et(() => [
          C($y, {
            kind: n.kind,
            class: "is-tool",
            onRun: b
          }, null, 8, ["kind"])
        ]),
        _: 1
      }, 8, ["open"])
    ]));
  }
}), Yme = { class: "ed-panel" }, Xme = {
  key: 1,
  class: "ed-info",
  "data-testid": "studio-upscale-size"
}, Jme = /* @__PURE__ */ Re({
  __name: "UpscalePanel",
  setup(n) {
    const e = ft(), t = I(() => e.stage.value), i = I(() => {
      var r;
      const a = (r = e.valueOfKey("upscale", "scale")) != null ? r : e.valueOfKey("upscale", "factor"), l = typeof a == "number" ? a : typeof a == "string" ? parseFloat(a) : NaN;
      return Number.isFinite(l) && l > 0 ? l : null;
    }), s = I(() => {
      const r = t.value;
      if (!r || !i.value) return "";
      const a = Pl(r.asset), l = a ? a.width : r.w, d = a ? a.height : r.h;
      return Math.round(l * i.value).toLocaleString() + " × " + Math.round(d * i.value).toLocaleString();
    }), o = I(() => e.modelsFor("upscale"));
    return (r, a) => (g(), v("div", Yme, [
      a[1] || (a[1] = h("p", { class: "ed-hint" }, "More pixels and finer detail. Each upscaler has its own look; its settings follow.", -1)),
      o.value.length > 1 ? (g(), Ce(zy, {
        key: 0,
        mode: "upscale",
        variant: "row"
      })) : E("", !0),
      C(aI, { kind: "upscale" }),
      s.value ? (g(), v("div", Xme, [
        a[0] || (a[0] = h("span", null, "Final size", -1)),
        h("b", null, A(s.value), 1)
      ])) : E("", !0),
      C(zo, {
        kind: "upscale",
        label: "Upscale",
        icon: "Maximize2",
        many: !1,
        "show-model": o.value.length <= 1
      }, null, 8, ["show-model"])
    ]));
  }
}), Zme = { class: "ed-panel" }, Qme = ["aria-selected"], ege = ["aria-selected"], tge = {
  class: "ed-ratios",
  role: "radiogroup",
  "aria-label": "Shape"
}, nge = ["aria-checked", "data-testid", "onClick"], ige = ["aria-expanded"], sge = { class: "ed-wh" }, oge = ["value"], rge = ["aria-pressed", "title"], age = ["value"], lge = { class: "ed-acts is-foot" }, dge = ["disabled"], cge = ["disabled"], uge = {
  class: "ed-ratios",
  role: "radiogroup",
  "aria-label": "Frame shape"
}, hge = ["aria-checked", "data-testid", "onClick"], pge = ["aria-expanded"], fge = {
  key: 0,
  class: "ed-info"
}, mge = {
  key: 1,
  class: "sv-warn"
}, gge = { class: "ed-field" }, bge = { class: "ed-acts is-tight" }, vge = ["disabled"], yge = ["disabled"], xge = /* @__PURE__ */ Re({
  __name: "ResizePanel",
  setup(n) {
    const e = ft(), t = e.tools, i = I(() => t.t.resize), s = I(() => e.stage.value), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(!0), a = I(() => s0.filter((_) => !_.more || o.value || _.id === i.value.ratio)), l = I(() => s0.filter((_) => _.id !== "original" && (!_.more || o.value || _.id === i.value.frameRatio))), d = I(() => t.cropPixels()), c = I(() => t.frame()), u = I(() => {
      const _ = s.value, x = c.value;
      return _ && x ? Math.round(x.iw / _.w * 100) : 100;
    }), p = I(() => !!c.value && Hde(c.value) < jde);
    function f(_) {
      const x = s.value, T = af(_, x ? x.w : 4, x ? x.h : 3), M = T == null ? 1.25 : T;
      return M >= 1 ? { w: 22, h: Math.max(6, Math.round(22 / M)) } : { w: Math.max(6, Math.round(22 * M)), h: 22 };
    }
    function y(_) {
      i.value.mode !== _ && t.leave(() => {
        t.t.resize.mode = _, t.t.open = "resize";
      });
    }
    function b(_) {
      const x = s.value;
      if (!x || !Number.isFinite(_) || _ < 8) return;
      const T = r.value ? _ / Math.max(1, d.value.w) : 1;
      t.setCrop(l_(i.value.crop, _, r.value ? d.value.h * T : d.value.h, x.w, x.h)), r.value || (t.t.resize.ratio = "free");
    }
    function w(_) {
      const x = s.value;
      if (!x || !Number.isFinite(_) || _ < 8) return;
      const T = r.value ? _ / Math.max(1, d.value.h) : 1;
      t.setCrop(l_(i.value.crop, r.value ? d.value.w * T : d.value.w, _, x.w, x.h)), r.value || (t.t.resize.ratio = "free");
    }
    function k(_) {
      const x = s.value, T = c.value;
      !x || !T || t.setFrame(Kde(T, x.w, x.h, _ / 100));
    }
    function S() {
      const _ = s.value;
      _ && (t.t.resize.frame = null, t.t.resize.frameRatio = "free", t.setFrame(jC(_.w, _.h)));
    }
    return (_, x) => (g(), v("div", Zme, [
      h("div", {
        class: "sv-seg is-text ed-tabs ed-slide",
        role: "tablist",
        "aria-label": "Crop or expand",
        style: de({ "--i": i.value.mode === "expand" ? 1 : 0, "--n": 2 })
      }, [
        h("button", {
          role: "tab",
          "aria-selected": i.value.mode === "crop",
          class: U({ on: i.value.mode === "crop" }),
          "data-testid": "studio-resize-crop",
          onClick: x[0] || (x[0] = (T) => y("crop"))
        }, [
          C(R, {
            name: "Crop",
            size: 13
          }),
          x[11] || (x[11] = X(" Crop", -1))
        ], 10, Qme),
        h("button", {
          role: "tab",
          "aria-selected": i.value.mode === "expand",
          class: U({ on: i.value.mode === "expand" }),
          "data-testid": "studio-resize-expand",
          onClick: x[1] || (x[1] = (T) => y("expand"))
        }, [
          C(R, {
            name: "Expand",
            size: 13
          }),
          x[12] || (x[12] = X(" Expand", -1))
        ], 10, ege)
      ], 4),
      i.value.mode === "crop" ? (g(), v(H, { key: 0 }, [
        x[16] || (x[16] = h("p", { class: "ed-hint" }, "Drag the frame's edges and corners on the picture, or pick a shape. The crop is made at full size.", -1)),
        h("div", tge, [
          (g(!0), v(H, null, me(a.value, (T) => (g(), v("button", {
            key: T.id,
            role: "radio",
            "aria-checked": i.value.ratio === T.id,
            class: U(["ed-ratio", { on: i.value.ratio === T.id }]),
            "data-testid": "studio-crop-ratio-" + T.id,
            onClick: (M) => m(t).setRatio(T.id)
          }, [
            h("i", {
              class: U({ free: T.id === "free" }),
              style: de({ width: f(T.id).w + "px", height: f(T.id).h + "px" })
            }, null, 6),
            h("span", null, A(T.label), 1)
          ], 10, nge))), 128)),
          h("button", {
            class: "ed-ratio is-more",
            "aria-expanded": o.value,
            onClick: x[2] || (x[2] = (T) => o.value = !o.value)
          }, [
            C(R, {
              name: o.value ? "ChevronUp" : "Ellipsis",
              size: 14
            }, null, 8, ["name"]),
            h("span", null, A(o.value ? "Fewer" : "More"), 1)
          ], 8, ige)
        ]),
        h("div", sge, [
          h("label", null, [
            x[13] || (x[13] = h("span", null, "W", -1)),
            h("input", {
              type: "number",
              min: "8",
              value: d.value.w,
              "data-testid": "studio-crop-w",
              onChange: x[3] || (x[3] = (T) => b(+T.target.value))
            }, null, 40, oge)
          ]),
          h("button", {
            class: U(["ed-lock", { on: r.value }]),
            "aria-pressed": r.value,
            title: r.value ? "Keep the shape" : "Width and height apart",
            onClick: x[4] || (x[4] = (T) => r.value = !r.value)
          }, [
            C(R, {
              name: r.value ? "Lock" : "LockOpen",
              size: 12
            }, null, 8, ["name"])
          ], 10, rge),
          h("label", null, [
            x[14] || (x[14] = h("span", null, "H", -1)),
            h("input", {
              type: "number",
              min: "8",
              value: d.value.h,
              "data-testid": "studio-crop-h",
              onChange: x[5] || (x[5] = (T) => w(+T.target.value))
            }, null, 40, age)
          ]),
          x[15] || (x[15] = h("span", { class: "u" }, "px", -1))
        ]),
        h("div", lge, [
          h("button", {
            class: "sv-btn",
            disabled: !m(t).pending("resize"),
            onClick: x[6] || (x[6] = (T) => m(t).reset("resize"))
          }, "Reset", 8, dge),
          h("button", {
            class: "sv-btn is-primary ed-apply",
            disabled: !m(t).pending("resize") || !!m(t).t.busy,
            "data-testid": "studio-crop-apply",
            onClick: x[7] || (x[7] = (T) => m(t).apply("resize"))
          }, [
            C(R, {
              name: m(t).t.busy ? "Loader2" : "Crop",
              size: 14,
              spin: !!m(t).t.busy
            }, null, 8, ["name", "spin"]),
            X(" " + A(m(t).t.busy ? "Cropping" : "Crop"), 1)
          ], 8, cge)
        ])
      ], 64)) : (g(), v(H, { key: 1 }, [
        x[21] || (x[21] = h("p", { class: "ed-hint" }, "Pull the frame past the picture's edges on the stage, or pick a shape; drag the picture to place it. The new area is painted to match.", -1)),
        h("div", uge, [
          (g(!0), v(H, null, me(l.value, (T) => (g(), v("button", {
            key: T.id,
            role: "radio",
            "aria-checked": i.value.frameRatio === T.id,
            class: U(["ed-ratio", { on: i.value.frameRatio === T.id }]),
            "data-testid": "studio-expand-ratio-" + T.id,
            onClick: (M) => m(t).setFrameRatio(T.id)
          }, [
            h("i", {
              class: U({ free: T.id === "free" }),
              style: de({ width: f(T.id).w + "px", height: f(T.id).h + "px" })
            }, null, 6),
            h("span", null, A(T.label), 1)
          ], 10, hge))), 128)),
          h("button", {
            class: "ed-ratio is-more",
            "aria-expanded": o.value,
            onClick: x[8] || (x[8] = (T) => o.value = !o.value)
          }, [
            C(R, {
              name: o.value ? "ChevronUp" : "Ellipsis",
              size: 14
            }, null, 8, ["name"]),
            h("span", null, A(o.value ? "Fewer" : "More"), 1)
          ], 8, pge)
        ]),
        C(St, {
          label: "Picture size",
          "model-value": u.value,
          min: 30,
          max: 100,
          start: 100,
          format: (T) => T + "%",
          "onUpdate:modelValue": k
        }, null, 8, ["model-value", "format"]),
        c.value ? (g(), v("div", fge, [
          x[17] || (x[17] = h("span", null, "New size", -1)),
          h("b", null, A(Math.round(c.value.cw)) + " × " + A(Math.round(c.value.ch)), 1)
        ])) : E("", !0),
        p.value ? (g(), v("div", mge, [
          C(R, {
            name: "AlertCircle",
            size: 12
          }),
          x[18] || (x[18] = h("span", null, "The picture is small in this frame; the expand is best when it covers at least a sixth.", -1))
        ])) : E("", !0),
        h("label", gge, [
          x[19] || (x[19] = h("span", { class: "ed-field-lb" }, "What to add (optional)", -1)),
          xt(h("textarea", {
            "onUpdate:modelValue": x[9] || (x[9] = (T) => m(t).t.resize.words = T),
            class: "ed-text",
            rows: "2",
            placeholder: "More sky, the street continuing, the lawn and planting",
            spellcheck: "false",
            "data-testid": "studio-expand-words"
          }, null, 512), [
            [Jt, m(t).t.resize.words]
          ])
        ]),
        h("div", bge, [
          h("button", {
            class: "sv-btn",
            disabled: !c.value || !m(r0)(c.value),
            onClick: S
          }, "Reset", 8, vge),
          h("button", {
            class: "sv-btn",
            disabled: !c.value,
            title: "Centre the picture in the frame",
            onClick: x[10] || (x[10] = (T) => c.value && m(t).setFrame(m(Yde)(c.value)))
          }, [
            C(R, {
              name: "LocateFixed",
              size: 13
            }),
            x[20] || (x[20] = X(" Centre", -1))
          ], 8, yge)
        ]),
        C(zo, {
          kind: "expand",
          label: "Expand",
          icon: "Expand",
          many: !1,
          why: "Bria Expand paints the new area to match",
          picker: ""
        })
      ], 64))
    ]));
  }
}), wge = { class: "ed-refpick" }, kge = { class: "ed-field-lb" }, _ge = ["aria-label"], Sge = ["aria-checked", "title", "onClick"], Tge = {
  key: 1,
  class: "ed-hint is-quiet"
}, lI = /* @__PURE__ */ Re({
  __name: "RefPick",
  props: {
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = ft(), o = I(() => s.items.value.filter((a) => a.status === "done" && a.id !== s.s.stageId).slice(0, 12));
    function r(a) {
      i("update:modelValue", t.modelValue === a ? null : a);
    }
    return (a, l) => (g(), v("div", wge, [
      h("span", kge, A(n.label), 1),
      o.value.length ? (g(), v("div", {
        key: 0,
        class: "ed-refpick-row",
        role: "radiogroup",
        "aria-label": n.label
      }, [
        (g(!0), v(H, null, me(o.value, (d) => (g(), v("button", {
          key: d.id,
          class: U(["ed-refpick-cell", { on: n.modelValue === d.id }]),
          role: "radio",
          "aria-checked": n.modelValue === d.id,
          title: d.label,
          "data-testid": "studio-refpick",
          onClick: (c) => r(d.id)
        }, [
          C(us, { item: d }, null, 8, ["item"])
        ], 10, Sge))), 128))
      ], 8, _ge)) : (g(), v("span", Tge, "Bring a picture into history first (drop one on the view)."))
    ]));
  }
}), Mge = { class: "ed-panel" }, Cge = ["aria-selected"], Ige = ["aria-selected"], Age = ["aria-selected"], Pge = {
  class: "ed-fills",
  role: "radiogroup",
  "aria-label": "Fill"
}, Ege = ["aria-checked"], Rge = ["aria-checked", "title", "data-testid", "onClick"], zge = ["value"], $ge = { class: "ed-acts is-foot" }, Dge = ["disabled"], Oge = ["disabled"], Lge = { class: "ed-field" }, Bge = ["aria-checked"], Fge = ["aria-checked"], Nge = { class: "ed-acts is-foot" }, Uge = ["disabled"], Gge = ["disabled"], jge = /* @__PURE__ */ Re({
  __name: "BackgroundPanel",
  setup(n) {
    const e = ft(), t = e.tools, i = I(() => t.t.background), s = I(() => e.stage.value), o = I(() => t.isCutout(s.value)), r = I(() => t.cutoutFor(s.value)), a = I(() => typeof i.value.fill == "string" && !v_.includes(i.value.fill));
    function l(d) {
      i.value.mode !== d && t.leave(() => {
        t.t.background.mode = d, t.t.open = "background";
      });
    }
    return (d, c) => (g(), v("div", Mge, [
      h("div", {
        class: "sv-seg is-text ed-tabs is-three ed-slide",
        role: "tablist",
        "aria-label": "Background",
        style: de({ "--i": ["remove", "replace", "adjust"].indexOf(i.value.mode), "--n": 3 })
      }, [
        h("button", {
          role: "tab",
          "aria-selected": i.value.mode === "remove",
          class: U({ on: i.value.mode === "remove" }),
          "data-testid": "studio-bg-remove",
          onClick: c[0] || (c[0] = (u) => l("remove"))
        }, "Remove", 10, Cge),
        h("button", {
          role: "tab",
          "aria-selected": i.value.mode === "replace",
          class: U({ on: i.value.mode === "replace" }),
          "data-testid": "studio-bg-replace",
          onClick: c[1] || (c[1] = (u) => l("replace"))
        }, "Replace", 10, Ige),
        h("button", {
          role: "tab",
          "aria-selected": i.value.mode === "adjust",
          class: U({ on: i.value.mode === "adjust" }),
          "data-testid": "studio-bg-adjust",
          onClick: c[2] || (c[2] = (u) => l("adjust"))
        }, "Adjust", 10, Age)
      ], 4),
      i.value.mode === "remove" ? (g(), v(H, { key: 0 }, [
        o.value ? (g(), v(H, { key: 1 }, [
          c[20] || (c[20] = h("p", { class: "ed-hint" }, "The background is clear. Fill it, or keep it see-through.", -1)),
          h("div", Pge, [
            h("button", {
              class: U(["ed-fill is-clear", { on: i.value.fill === null }]),
              role: "radio",
              "aria-checked": i.value.fill === null,
              title: "See-through",
              "data-testid": "studio-fill-clear",
              onClick: c[3] || (c[3] = (u) => m(t).setFill(null))
            }, null, 10, Ege),
            (g(!0), v(H, null, me(m(v_), (u) => (g(), v("button", {
              key: u,
              class: U(["ed-fill", { on: i.value.fill === u }]),
              role: "radio",
              "aria-checked": i.value.fill === u,
              style: de({ "--c": u }),
              title: u,
              "data-testid": "studio-fill-" + u.slice(1),
              onClick: (p) => m(t).setFill(u)
            }, null, 14, Rge))), 128)),
            h("label", {
              class: U(["ed-fill is-any", { on: a.value }]),
              style: de(a.value ? { "--c": i.value.fill } : void 0),
              title: "Any colour"
            }, [
              h("input", {
                type: "color",
                value: typeof i.value.fill == "string" ? i.value.fill : "#ffffff",
                onInput: c[4] || (c[4] = (u) => m(t).setFill(u.target.value))
              }, null, 40, zge)
            ], 6)
          ]),
          h("div", $ge, [
            h("button", {
              class: "sv-btn",
              disabled: i.value.fill === void 0,
              onClick: c[5] || (c[5] = (u) => m(t).setFill(void 0))
            }, "Reset", 8, Dge),
            h("button", {
              class: "sv-btn is-primary ed-apply",
              disabled: i.value.fill === void 0 || !!m(t).t.busy,
              "data-testid": "studio-fill-apply",
              onClick: c[6] || (c[6] = (u) => m(t).apply("background"))
            }, [
              C(R, {
                name: m(t).t.busy ? "Loader2" : "PaintBucket",
                size: 14,
                spin: !!m(t).t.busy
              }, null, 8, ["name", "spin"]),
              X(" " + A(m(t).t.busy ? "Filling" : "Fill"), 1)
            ], 8, Oge)
          ])
        ], 64)) : (g(), v(H, { key: 0 }, [
          c[19] || (c[19] = h("p", { class: "ed-hint" }, "Cuts the subject out, leaving the background see-through. Then fill it with a colour, or keep it clear.", -1)),
          C(zo, {
            kind: "removebg",
            label: "Remove background",
            icon: "Scan",
            many: !1,
            why: "Clean edges, hair and fine detail included"
          })
        ], 64))
      ], 64)) : i.value.mode === "replace" ? (g(), v(H, { key: 1 }, [
        c[22] || (c[22] = h("p", { class: "ed-hint" }, "Describe what should be behind the subject, or pick a picture of it. The subject stays exactly as it is.", -1)),
        h("label", Lge, [
          c[21] || (c[21] = h("span", { class: "ed-field-lb" }, "The new background", -1)),
          xt(h("textarea", {
            "onUpdate:modelValue": c[7] || (c[7] = (u) => m(t).t.background.words = u),
            class: "ed-text",
            rows: "3",
            placeholder: "A clear sky with soft clouds over a quiet street",
            spellcheck: "false",
            "data-testid": "studio-replace-words"
          }, null, 512), [
            [Jt, m(t).t.background.words]
          ])
        ]),
        C(lI, {
          modelValue: m(t).t.background.refId,
          "onUpdate:modelValue": c[8] || (c[8] = (u) => m(t).t.background.refId = u),
          label: "A picture of it (optional)"
        }, null, 8, ["modelValue"]),
        C(zo, {
          kind: "replacebg",
          label: "Replace",
          icon: "Replace",
          picker: ""
        })
      ], 64)) : (g(), v(H, { key: 2 }, [
        r.value ? (g(), v(H, { key: 1 }, [
          h("div", {
            class: "sv-seg is-small ed-pills ed-slide",
            role: "radiogroup",
            "aria-label": "Adjust",
            style: de({ "--i": i.value.layer.target === "subject" ? 1 : 0, "--n": 2 })
          }, [
            h("button", {
              role: "radio",
              "aria-checked": i.value.layer.target === "background",
              class: U({ on: i.value.layer.target === "background" }),
              onClick: c[9] || (c[9] = (u) => m(t).setLayer({ target: "background" }))
            }, "Background", 10, Bge),
            h("button", {
              role: "radio",
              "aria-checked": i.value.layer.target === "subject",
              class: U({ on: i.value.layer.target === "subject" }),
              onClick: c[10] || (c[10] = (u) => m(t).setLayer({ target: "subject" }))
            }, "Subject", 10, Fge)
          ], 4),
          C(St, {
            label: "Blur",
            "model-value": i.value.layer.blur,
            min: 0,
            max: 40,
            start: 0,
            format: (u) => u + " px",
            testid: "studio-layer-blur",
            "onUpdate:modelValue": c[11] || (c[11] = (u) => m(t).setLayer({ blur: u }))
          }, null, 8, ["model-value", "format"]),
          C(St, {
            label: "Grayscale",
            "model-value": i.value.layer.grayscale,
            min: 0,
            max: 100,
            start: 0,
            "onUpdate:modelValue": c[12] || (c[12] = (u) => m(t).setLayer({ grayscale: u }))
          }, null, 8, ["model-value"]),
          C(St, {
            label: "Sepia",
            "model-value": i.value.layer.sepia,
            min: 0,
            max: 100,
            start: 0,
            "onUpdate:modelValue": c[13] || (c[13] = (u) => m(t).setLayer({ sepia: u }))
          }, null, 8, ["model-value"]),
          C(St, {
            label: "Brightness",
            "model-value": i.value.layer.brightness,
            min: 0,
            max: 200,
            start: 100,
            format: (u) => (u - 100 > 0 ? "+" : "") + (u - 100),
            "onUpdate:modelValue": c[14] || (c[14] = (u) => m(t).setLayer({ brightness: u }))
          }, null, 8, ["model-value", "format"]),
          C(St, {
            label: "Contrast",
            "model-value": i.value.layer.contrast,
            min: 0,
            max: 200,
            start: 100,
            format: (u) => (u - 100 > 0 ? "+" : "") + (u - 100),
            "onUpdate:modelValue": c[15] || (c[15] = (u) => m(t).setLayer({ contrast: u }))
          }, null, 8, ["model-value", "format"]),
          C(St, {
            label: "Saturation",
            "model-value": i.value.layer.saturation,
            min: 0,
            max: 200,
            start: 100,
            format: (u) => (u - 100 > 0 ? "+" : "") + (u - 100),
            "onUpdate:modelValue": c[16] || (c[16] = (u) => m(t).setLayer({ saturation: u }))
          }, null, 8, ["model-value", "format"]),
          h("div", Nge, [
            h("button", {
              class: "sv-btn",
              disabled: !m(zc)(i.value.layer),
              onClick: c[17] || (c[17] = (u) => m(t).reset("background"))
            }, "Reset", 8, Uge),
            h("button", {
              class: "sv-btn is-primary ed-apply",
              disabled: !m(zc)(i.value.layer) || !!m(t).t.busy,
              "data-testid": "studio-layer-apply",
              onClick: c[18] || (c[18] = (u) => m(t).apply("background"))
            }, [
              C(R, {
                name: m(t).t.busy ? "Loader2" : "Check",
                size: 14,
                spin: !!m(t).t.busy
              }, null, 8, ["name", "spin"]),
              X(" " + A(m(t).t.busy ? "Applying" : "Apply"), 1)
            ], 8, Gge)
          ])
        ], 64)) : (g(), v(H, { key: 0 }, [
          c[23] || (c[23] = h("p", { class: "ed-hint" }, "Adjusting the background apart from the subject needs a cut-out first: Remove background makes one.", -1)),
          C(zo, {
            kind: "removebg",
            label: "Remove background",
            icon: "Scan",
            many: !1,
            why: "Its cut-out tells the subject from the background"
          })
        ], 64))
      ], 64))
    ]));
  }
}), Hge = { class: "ed-wheel" }, Vge = ["aria-label", "aria-valuenow", "aria-valuetext"], Wge = { class: "ed-wheel-lb" }, qge = ["value", "aria-label"], ob = 30, rb = /* @__PURE__ */ Re({
  __name: "ColorWheel",
  props: {
    label: {},
    wheel: {}
  },
  emits: ["change"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ K(null), o = I(() => {
      const d = (t.wheel.hue - 90) * Math.PI / 180, c = t.wheel.amount / 100 * ob;
      return { left: ob + Math.cos(d) * c + "px", top: ob + Math.sin(d) * c + "px" };
    });
    function r(d) {
      if (!s.value) return;
      const c = s.value.getBoundingClientRect(), u = d.clientX - c.left - c.width / 2, p = d.clientY - c.top - c.height / 2, f = Math.round(Math.min(1, Math.hypot(u, p) / (c.width / 2)) * 100), y = Math.round((Math.atan2(p, u) * 180 / Math.PI + 90 + 360) % 360);
      i("change", { ...t.wheel, hue: y, amount: f });
    }
    function a(d) {
      d.button === 0 && (d.currentTarget.setPointerCapture(d.pointerId), r(d));
    }
    function l(d) {
      d.currentTarget.hasPointerCapture(d.pointerId) && r(d);
    }
    return (d, c) => (g(), v("div", Hge, [
      h("div", {
        ref_key: "el",
        ref: s,
        class: "ed-wheel-disc",
        role: "slider",
        "aria-label": n.label + " tint",
        "aria-valuenow": n.wheel.amount,
        "aria-valuetext": n.wheel.amount ? n.wheel.hue + "°, " + n.wheel.amount + "%" : "none",
        tabindex: "0",
        onPointerdown: a,
        onPointermove: l,
        onDblclick: c[0] || (c[0] = (u) => i("change", { ...n.wheel, amount: 0 }))
      }, [
        h("i", {
          class: U(["ed-wheel-dot", { on: n.wheel.amount > 0 }]),
          style: de(o.value)
        }, null, 6)
      ], 40, Vge),
      h("span", Wge, A(n.label), 1),
      h("input", {
        class: "ed-wheel-lum",
        type: "range",
        min: "-100",
        max: "100",
        value: n.wheel.lum,
        "aria-label": n.label + " brightness",
        onInput: c[1] || (c[1] = (u) => i("change", { ...n.wheel, lum: Number(u.target.value) })),
        onDblclick: c[2] || (c[2] = (u) => i("change", { ...n.wheel, lum: 0 }))
      }, null, 40, qge)
    ]));
  }
}), Kge = { class: "ed-panel ed-adjust" }, Yge = { class: "ed-groups" }, Xge = { class: "ed-group-head" }, Jge = ["aria-expanded", "data-testid", "onClick"], Zge = { class: "t" }, Qge = {
  key: 0,
  class: "ed-changed"
}, ebe = ["title", "onClick"], tbe = { class: "ed-group-body" }, nbe = {
  key: 2,
  class: "ed-looks",
  role: "radiogroup",
  "aria-label": "Looks"
}, ibe = ["aria-checked", "data-testid", "onClick"], sbe = { class: "sw" }, obe = { class: "nm" }, rbe = {
  key: 3,
  class: "ed-wheels"
}, abe = {
  class: "ed-bands",
  role: "radiogroup",
  "aria-label": "Colour"
}, lbe = ["aria-checked", "title", "onClick"], dbe = {
  class: "ed-refpick-row",
  role: "radiogroup",
  "aria-label": "Match to"
}, cbe = ["aria-checked", "title", "onClick"], ube = { class: "tag" }, hbe = { class: "ed-overlay-row" }, pbe = ["value"], fbe = { class: "ed-select" }, mbe = ["value"], gbe = ["value"], bbe = { class: "ed-turns" }, vbe = { class: "ed-acts is-foot" }, ybe = ["disabled"], xbe = ["disabled"], wbe = ["disabled"], kbe = /* @__PURE__ */ Re({
  __name: "AdjustPanel",
  setup(n) {
    const e = ft(), t = e.tools, i = I(() => t.t.adjust), s = I(() => i.value.a), o = /* @__PURE__ */ K("red"), r = [
      { id: "light", label: "Light", icon: "Sun" },
      { id: "colour", label: "Colour", icon: "Palette" },
      { id: "looks", label: "Looks", icon: "Sparkle" },
      { id: "grading", label: "Colour grading", icon: "Contrast" },
      { id: "mixer", label: "Colour mixer", icon: "Rainbow" },
      { id: "match", label: "Match colours", icon: "Droplet" },
      { id: "overlay", label: "Overlay", icon: "Blend" },
      { id: "grain", label: "Grain", icon: "Film" },
      { id: "rotate", label: "Rotate", icon: "RotateCw" }
    ], a = I(() => i.value.group);
    function l(k) {
      t.t.adjust.group = i.value.group === k ? null : k;
    }
    function d(k) {
      const S = $c(s.value);
      k(S), S.look = null, t.setAdjust(S);
    }
    function c(k) {
      return k === "looks" ? !!s.value.look : sl(s.value, k);
    }
    function u(k) {
      if (k === "looks") {
        t.setAdjust(u_(s.value, ""));
        return;
      }
      t.setAdjust(Zde(s.value, k));
    }
    const p = (k) => k > 0 ? "+" + k : String(k), f = (k) => (k > 0 ? "+" : "") + k + "°", y = I(() => {
      const k = e.family.value.filter((_) => _.status === "done" && _.id !== e.s.stageId), S = e.items.value.filter((_) => _.status === "done" && _.id !== e.s.stageId && !k.some((x) => x.id === _.id));
      return [...k, ...S].slice(0, 12);
    });
    function b(k) {
      return e.names.value.get(k) || "Picture";
    }
    const w = I(() => l0(s.value));
    return (k, S) => (g(), v("div", Kge, [
      h("div", Yge, [
        (g(), v(H, null, me(r, (_) => h("section", {
          key: _.id,
          class: U(["ed-group", { on: a.value === _.id, "is-changed": c(_.id) }])
        }, [
          h("div", Xge, [
            h("button", {
              class: "ed-group-btn",
              "aria-expanded": a.value === _.id,
              "data-testid": "studio-adjust-group-" + _.id,
              onClick: (x) => l(_.id)
            }, [
              C(R, {
                name: _.icon,
                size: 13,
                class: "ic"
              }, null, 8, ["name"]),
              h("span", Zge, A(_.label), 1),
              c(_.id) ? (g(), v("i", Qge)) : E("", !0),
              C(R, {
                name: a.value === _.id ? "ChevronUp" : "ChevronDown",
                size: 12,
                class: "chev"
              }, null, 8, ["name"])
            ], 8, Jge),
            c(_.id) ? (g(), v("button", {
              key: 0,
              class: "ed-group-reset",
              title: "Reset " + _.label.toLowerCase(),
              onClick: (x) => u(_.id)
            }, [
              C(R, {
                name: "RotateCcw",
                size: 11
              })
            ], 8, ebe)) : E("", !0)
          ]),
          C(Tl, {
            open: a.value === _.id
          }, {
            default: et(() => [
              h("div", tbe, [
                _.id === "light" ? (g(), v(H, { key: 0 }, [
                  C(St, {
                    label: "Exposure",
                    "model-value": s.value.exposure,
                    min: -100,
                    max: 100,
                    format: p,
                    testid: "studio-adjust-exposure",
                    "onUpdate:modelValue": S[0] || (S[0] = (x) => d((T) => T.exposure = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Contrast",
                    "model-value": s.value.contrast,
                    min: -100,
                    max: 100,
                    format: p,
                    testid: "studio-adjust-contrast",
                    "onUpdate:modelValue": S[1] || (S[1] = (x) => d((T) => T.contrast = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Brightness",
                    "model-value": s.value.brightness,
                    min: -100,
                    max: 100,
                    format: p,
                    "onUpdate:modelValue": S[2] || (S[2] = (x) => d((T) => T.brightness = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Highlights",
                    "model-value": s.value.highlights,
                    min: -100,
                    max: 100,
                    format: p,
                    "onUpdate:modelValue": S[3] || (S[3] = (x) => d((T) => T.highlights = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Shadows",
                    "model-value": s.value.shadows,
                    min: -100,
                    max: 100,
                    format: p,
                    "onUpdate:modelValue": S[4] || (S[4] = (x) => d((T) => T.shadows = x))
                  }, null, 8, ["model-value"])
                ], 64)) : _.id === "colour" ? (g(), v(H, { key: 1 }, [
                  C(St, {
                    label: "Saturation",
                    "model-value": s.value.saturation,
                    min: -100,
                    max: 100,
                    format: p,
                    testid: "studio-adjust-saturation",
                    "onUpdate:modelValue": S[5] || (S[5] = (x) => d((T) => T.saturation = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Hue",
                    "model-value": s.value.hue,
                    min: -180,
                    max: 180,
                    format: f,
                    "onUpdate:modelValue": S[6] || (S[6] = (x) => d((T) => T.hue = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Temperature",
                    "model-value": s.value.temperature,
                    min: -100,
                    max: 100,
                    format: p,
                    testid: "studio-adjust-temperature",
                    "onUpdate:modelValue": S[7] || (S[7] = (x) => d((T) => T.temperature = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Tint",
                    "model-value": s.value.tint,
                    min: -100,
                    max: 100,
                    format: p,
                    "onUpdate:modelValue": S[8] || (S[8] = (x) => d((T) => T.tint = x))
                  }, null, 8, ["model-value"])
                ], 64)) : _.id === "looks" ? (g(), v("div", nbe, [
                  (g(!0), v(H, null, me(m(Iy), (x) => (g(), v("button", {
                    key: x.id,
                    class: U(["ed-look", ["look-" + x.id, { on: s.value.look === x.id }]]),
                    role: "radio",
                    "aria-checked": s.value.look === x.id,
                    "data-testid": "studio-look-" + x.id,
                    onClick: (T) => m(t).setAdjust(m(u_)(s.value, s.value.look === x.id ? "" : x.id))
                  }, [
                    h("span", sbe, [
                      m(e).stage.value ? (g(), Ce(us, {
                        key: 0,
                        item: m(e).stage.value
                      }, null, 8, ["item"])) : E("", !0)
                    ]),
                    h("span", obe, A(x.label), 1)
                  ], 10, ibe))), 128))
                ])) : _.id === "grading" ? (g(), v("div", rbe, [
                  C(rb, {
                    label: "Shadows",
                    wheel: s.value.grade.shadows,
                    onChange: S[9] || (S[9] = (x) => d((T) => T.grade.shadows = x))
                  }, null, 8, ["wheel"]),
                  C(rb, {
                    label: "Midtones",
                    wheel: s.value.grade.midtones,
                    onChange: S[10] || (S[10] = (x) => d((T) => T.grade.midtones = x))
                  }, null, 8, ["wheel"]),
                  C(rb, {
                    label: "Highlights",
                    wheel: s.value.grade.highlights,
                    onChange: S[11] || (S[11] = (x) => d((T) => T.grade.highlights = x))
                  }, null, 8, ["wheel"])
                ])) : _.id === "mixer" ? (g(), v(H, { key: 4 }, [
                  h("div", abe, [
                    (g(!0), v(H, null, me(m(Wf), (x) => (g(), v("button", {
                      key: x.id,
                      class: U(["ed-band", { on: o.value === x.id, "is-changed": s.value.mixer[x.id].hue || s.value.mixer[x.id].sat || s.value.mixer[x.id].lum }]),
                      style: de({ "--c": x.color }),
                      role: "radio",
                      "aria-checked": o.value === x.id,
                      title: x.label,
                      onClick: (T) => o.value = x.id
                    }, null, 14, lbe))), 128))
                  ]),
                  C(St, {
                    label: "Hue",
                    "model-value": s.value.mixer[o.value].hue,
                    min: -100,
                    max: 100,
                    format: p,
                    "onUpdate:modelValue": S[12] || (S[12] = (x) => d((T) => T.mixer[o.value].hue = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Saturation",
                    "model-value": s.value.mixer[o.value].sat,
                    min: -100,
                    max: 100,
                    format: p,
                    "onUpdate:modelValue": S[13] || (S[13] = (x) => d((T) => T.mixer[o.value].sat = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Luminance",
                    "model-value": s.value.mixer[o.value].lum,
                    min: -100,
                    max: 100,
                    format: p,
                    "onUpdate:modelValue": S[14] || (S[14] = (x) => d((T) => T.mixer[o.value].lum = x))
                  }, null, 8, ["model-value"])
                ], 64)) : _.id === "match" ? (g(), v(H, { key: 5 }, [
                  S[33] || (S[33] = h("p", { class: "ed-hint" }, "Carry another version's colour onto this one: for a cast that crept in over repeated edits, match it to the original.", -1)),
                  h("div", dbe, [
                    (g(!0), v(H, null, me(y.value, (x) => (g(), v("button", {
                      key: x.id,
                      class: U(["ed-refpick-cell", { on: s.value.match.to === x.id }]),
                      role: "radio",
                      "aria-checked": s.value.match.to === x.id,
                      title: "Match to " + b(x.id),
                      "data-testid": "studio-match-to",
                      onClick: (T) => m(t).matchTo(s.value.match.to === x.id ? null : x.id)
                    }, [
                      C(us, { item: x }, null, 8, ["item"]),
                      h("span", ube, A(b(x.id)), 1)
                    ], 10, cbe))), 128))
                  ]),
                  C(St, {
                    label: "Amount",
                    "model-value": s.value.match.amount,
                    min: 0,
                    max: 100,
                    start: 0,
                    disabled: !s.value.match.to,
                    format: (x) => x + "%",
                    "onUpdate:modelValue": S[15] || (S[15] = (x) => d((T) => T.match.amount = x))
                  }, null, 8, ["model-value", "disabled", "format"])
                ], 64)) : _.id === "overlay" ? (g(), v(H, { key: 6 }, [
                  h("div", hbe, [
                    h("label", {
                      class: "sv-color ed-color",
                      style: de({ "--c": s.value.overlay.color }),
                      title: "Overlay colour"
                    }, [
                      S[34] || (S[34] = h("i", null, null, -1)),
                      h("input", {
                        type: "color",
                        value: s.value.overlay.color,
                        onInput: S[16] || (S[16] = (x) => d((T) => T.overlay.color = x.target.value))
                      }, null, 40, pbe)
                    ], 4),
                    h("span", fbe, [
                      h("select", {
                        value: s.value.overlay.blend,
                        "aria-label": "Blend",
                        onChange: S[17] || (S[17] = (x) => d((T) => T.overlay.blend = x.target.value))
                      }, [
                        (g(!0), v(H, null, me(m(Jde), (x) => (g(), v("option", {
                          key: x.id,
                          value: x.id
                        }, A(x.label), 9, gbe))), 128))
                      ], 40, mbe),
                      C(R, {
                        name: "ChevronDown",
                        size: 12
                      })
                    ])
                  ]),
                  C(St, {
                    label: "Opacity",
                    "model-value": s.value.overlay.opacity,
                    min: 0,
                    max: 100,
                    start: 0,
                    format: (x) => x + "%",
                    "onUpdate:modelValue": S[18] || (S[18] = (x) => d((T) => T.overlay.opacity = x))
                  }, null, 8, ["model-value", "format"])
                ], 64)) : _.id === "grain" ? (g(), v(H, { key: 7 }, [
                  C(St, {
                    label: "Amount",
                    "model-value": s.value.grain.amount,
                    min: 0,
                    max: 100,
                    start: 0,
                    "onUpdate:modelValue": S[19] || (S[19] = (x) => d((T) => T.grain.amount = x))
                  }, null, 8, ["model-value"]),
                  C(St, {
                    label: "Size",
                    "model-value": s.value.grain.size,
                    min: 0,
                    max: 100,
                    start: 35,
                    "onUpdate:modelValue": S[20] || (S[20] = (x) => d((T) => T.grain.size = x))
                  }, null, 8, ["model-value"])
                ], 64)) : _.id === "rotate" ? (g(), v(H, { key: 8 }, [
                  C(St, {
                    label: "Straighten",
                    "model-value": s.value.straighten,
                    min: -45,
                    max: 45,
                    step: 0.5,
                    format: f,
                    testid: "studio-adjust-straighten",
                    "onUpdate:modelValue": S[21] || (S[21] = (x) => d((T) => T.straighten = x))
                  }, null, 8, ["model-value"]),
                  h("div", bbe, [
                    h("button", {
                      class: "sv-btn",
                      title: "Turn left",
                      "data-testid": "studio-adjust-turn-left",
                      onClick: S[22] || (S[22] = (x) => d((T) => T.quarter = (T.quarter + 3) % 4))
                    }, [
                      C(R, {
                        name: "RotateCcw",
                        size: 14
                      })
                    ]),
                    h("button", {
                      class: "sv-btn",
                      title: "Turn right",
                      "data-testid": "studio-adjust-turn-right",
                      onClick: S[23] || (S[23] = (x) => d((T) => T.quarter = (T.quarter + 1) % 4))
                    }, [
                      C(R, {
                        name: "RotateCw",
                        size: 14
                      })
                    ]),
                    h("button", {
                      class: U(["sv-btn", { "is-on": s.value.flipH }]),
                      title: "Flip left to right",
                      onClick: S[24] || (S[24] = (x) => d((T) => T.flipH = !T.flipH))
                    }, [
                      C(R, {
                        name: "FlipHorizontal2",
                        size: 14
                      })
                    ], 2),
                    h("button", {
                      class: U(["sv-btn", { "is-on": s.value.flipV }]),
                      title: "Flip top to bottom",
                      onClick: S[25] || (S[25] = (x) => d((T) => T.flipV = !T.flipV))
                    }, [
                      C(R, {
                        name: "FlipVertical2",
                        size: 14
                      })
                    ], 2)
                  ])
                ], 64)) : E("", !0)
              ])
            ]),
            _: 2
          }, 1032, ["open"])
        ], 2)), 64))
      ]),
      h("div", vbe, [
        h("button", {
          class: "sv-btn ed-square ed-hold",
          disabled: !w.value,
          title: "Hold to see the picture as it was",
          "aria-label": "Hold to see the original",
          "data-testid": "studio-adjust-original",
          onPointerdown: S[26] || (S[26] = (_) => m(t).t.adjust.original = !0),
          onPointerup: S[27] || (S[27] = (_) => m(t).t.adjust.original = !1),
          onPointerleave: S[28] || (S[28] = (_) => m(t).t.adjust.original = !1),
          onKeydown: S[29] || (S[29] = tn(Pe((_) => m(t).t.adjust.original = !0, ["prevent"]), ["space"])),
          onKeyup: S[30] || (S[30] = tn(Pe((_) => m(t).t.adjust.original = !1, ["prevent"]), ["space"]))
        }, [
          C(R, {
            name: "Eye",
            size: 14
          })
        ], 40, ybe),
        h("button", {
          class: "sv-btn ed-square",
          disabled: !w.value,
          title: "Reset all",
          "aria-label": "Reset all",
          "data-testid": "studio-adjust-reset",
          onClick: S[31] || (S[31] = (_) => m(t).reset("adjust"))
        }, [
          C(R, {
            name: "RotateCcw",
            size: 14
          })
        ], 8, xbe),
        h("button", {
          class: "sv-btn is-primary ed-apply",
          disabled: !m(t).pending("adjust") || !!m(t).t.busy,
          "data-testid": "studio-adjust-apply",
          onClick: S[32] || (S[32] = (_) => m(t).apply("adjust"))
        }, [
          C(R, {
            name: m(t).t.busy ? "Loader2" : "Check",
            size: 14,
            spin: !!m(t).t.busy
          }, null, 8, ["name", "spin"]),
          X(" " + A(m(t).t.busy ? "Applying" : "Apply"), 1)
        ], 8, wbe)
      ])
    ]));
  }
}), _be = { class: "ed-panel" }, Sbe = ["aria-checked", "title", "onClick"], Tbe = {
  class: "ed-radios",
  role: "radiogroup",
  "aria-label": "Improve"
}, Mbe = ["aria-checked", "onClick"], Cbe = /* @__PURE__ */ Re({
  __name: "SkinPanel",
  setup(n) {
    const e = ft(), t = I(() => e.tools.t.skin);
    return (i, s) => (g(), v("div", _be, [
      h("div", {
        class: "sv-seg is-small ed-pills ed-slide",
        role: "radiogroup",
        "aria-label": "How faithful",
        style: de({ "--i": Math.max(0, m(Hg).findIndex((o) => o.id === t.value.version)), "--n": m(Hg).length })
      }, [
        (g(!0), v(H, null, me(m(Hg), (o) => (g(), v("button", {
          key: o.id,
          role: "radio",
          "aria-checked": t.value.version === o.id,
          class: U({ on: t.value.version === o.id }),
          title: o.hint,
          onClick: (r) => m(e).tools.t.skin.version = o.id
        }, A(o.label), 11, Sbe))), 128))
      ], 4),
      h("div", Tbe, [
        (g(!0), v(H, null, me(m(Tde), (o) => (g(), v("button", {
          key: o.id,
          class: U(["ed-radio-row", { on: t.value.focus === o.id }]),
          role: "radio",
          "aria-checked": t.value.focus === o.id,
          onClick: (r) => m(e).tools.t.skin.focus = o.id
        }, [
          C(Yf, {
            on: t.value.focus === o.id
          }, null, 8, ["on"]),
          s[2] || (s[2] = X()),
          h("span", null, A(o.label), 1)
        ], 10, Mbe))), 128))
      ]),
      C(St, {
        label: "Sharpen",
        "model-value": t.value.sharpen,
        min: 0,
        max: 100,
        start: 30,
        "onUpdate:modelValue": s[0] || (s[0] = (o) => m(e).tools.t.skin.sharpen = o)
      }, null, 8, ["model-value"]),
      C(St, {
        label: "Grain",
        "model-value": t.value.grain,
        min: 0,
        max: 100,
        start: 0,
        "onUpdate:modelValue": s[1] || (s[1] = (o) => m(e).tools.t.skin.grain = o)
      }, null, 8, ["model-value"]),
      C(zo, {
        kind: "skin",
        label: "Improve",
        icon: "Smile",
        picker: ""
      })
    ]));
  }
}), Ibe = { class: "ed-panel ed-camera" }, Abe = ["aria-valuenow", "aria-valuetext"], Pbe = ["rx", "ry"], Ebe = ["cx", "cy"], Rbe = ["d"], zbe = ["x", "y"], $be = ["x2", "y2"], Dbe = ["transform"], Obe = ["aria-valuenow", "aria-valuetext"], Lbe = ["d"], Bbe = ["x2"], Fbe = ["cx", "cy"], Nbe = ["x", "y"], Ube = ["y1", "x2", "y2"], Gbe = ["transform"], jbe = {
  class: "ed-camera-name",
  "data-testid": "studio-camera-name"
}, Hbe = {
  class: "ed-views",
  "data-testid": "studio-camera-views"
}, Vbe = { class: "ed-views-head" }, Wbe = {
  class: "ed-views-only",
  title: "Your saved views are yours alone, on every board and picture"
}, qbe = ["maxlength", "onKeydown"], Kbe = ["title", "aria-pressed", "onClick", "onDblclick"], Ybe = { class: "nm" }, Xbe = ["title", "aria-label", "onClick"], Jbe = ["disabled", "title"], Zbe = {
  key: 0,
  class: "ed-views-empty"
}, Qbe = {
  key: 0,
  class: "sv-warn ed-camera-warn"
}, eve = { class: "ed-seed" }, tve = { class: "ed-switch" }, nve = ["disabled"], fh = 78, pd = 30, ur = 92, hr = 52, fd = 46, ka = 22, _a = 60, ive = /* @__PURE__ */ Re({
  __name: "CameraPanel",
  setup(n) {
    const e = ft(), { board: t } = tt(), i = e.tools, s = I(() => i.t.camera), o = I(() => s.value.set), r = I(() => t.ui.cameraViews), a = I(() => r.value.find((G) => pee(G, o.value)) || null), l = I(() => r.value.length >= Zp), d = I(() => a.value ? "This view is saved as " + a.value.name : l.value ? "You keep the most views there can be: remove one first" : "Save this view, to come back to it on any board"), c = /* @__PURE__ */ K(null), u = /* @__PURE__ */ K(""), p = /* @__PURE__ */ K(null);
    function f(G) {
      c.value || i.setCamera({ rotate: G.rotate, vertical: G.vertical, zoom: G.zoom });
    }
    function y() {
      const G = t.saveCameraView(o.value, sc(o.value));
      G && b(G);
    }
    function b(G) {
      c.value = G.id, u.value = G.name, it(() => {
        const q = p.value && p.value[0];
        q && (q.focus(), q.select());
      });
    }
    function w() {
      c.value && (t.renameCameraView(c.value, u.value), c.value = null);
    }
    function k() {
      c.value = null;
    }
    function S(G, q = 1) {
      const B = G * Math.PI / 180;
      return { x: ur + Math.sin(B) * fh * q, y: hr + Math.cos(B) * pd * q };
    }
    const _ = I(() => 1.12 - o.value.zoom / 10 * 0.42), x = I(() => S(o.value.rotate, _.value)), T = I(() => Math.cos(o.value.rotate * Math.PI / 180) < 0);
    function M(G) {
      const q = G * Math.PI / 180;
      return { x: ka + Math.cos(q) * fd, y: _a - Math.sin(q) * fd };
    }
    const z = I(() => {
      const G = M(-30), q = M(90);
      return "M " + G.x + " " + G.y + " A " + fd + " " + fd + " 0 0 0 " + q.x + " " + q.y;
    }), P = I(() => M(o.value.vertical)), D = /* @__PURE__ */ K(null), $ = /* @__PURE__ */ K(null);
    let O = null;
    function L(G, q) {
      const B = G.getBoundingClientRect(), ne = G.viewBox.baseVal;
      return { x: (q.clientX - B.left) / B.width * ne.width, y: (q.clientY - B.top) / B.height * ne.height };
    }
    function Z(G) {
      if (!D.value) return;
      const q = L(D.value, G), B = Math.atan2((q.x - ur) / fh, (q.y - hr) / pd) * 180 / Math.PI;
      i.setCamera({ rotate: G.shiftKey ? Math.round(Zc(B)) : $2(B) });
    }
    function J(G) {
      if (!$.value) return;
      const q = L($.value, G), B = Math.atan2(_a - q.y, q.x - ka) * 180 / Math.PI, ne = Math.max(-30, Math.min(90, B));
      i.setCamera({ vertical: G.shiftKey ? Math.round(ne) : D2(ne) });
    }
    function re(G, q) {
      q.button === 0 && (O = G, q.currentTarget.setPointerCapture(q.pointerId), G === "ring" ? Z(q) : J(q));
    }
    function F(G) {
      O === "ring" ? Z(G) : O === "arc" && J(G);
    }
    function W() {
      O = null;
    }
    const ee = (G) => {
      const q = xy(G);
      return (q === 0 ? "0°" : q > 0 ? q + "° right" : -q + "° left") + " · " + Xv(G);
    }, N = (G) => (G > 0 ? "+" : "") + G + "° · " + Jv(G), te = (G) => dC(G);
    return (G, q) => (g(), v("div", Ibe, [
      h("div", {
        class: "ed-orbit",
        onPointermove: F,
        onPointerup: W,
        onPointercancel: W
      }, [
        (g(), v("svg", {
          ref_key: "ring",
          ref: D,
          class: "ed-orbit-ring",
          viewBox: "0 0 184 104",
          role: "slider",
          "aria-label": "Rotate around the scene",
          "aria-valuenow": o.value.rotate,
          "aria-valuetext": m(Xv)(o.value.rotate),
          tabindex: "0",
          "data-testid": "studio-camera-ring",
          onPointerdown: q[0] || (q[0] = (B) => re("ring", B))
        }, [
          h("ellipse", {
            cx: ur,
            cy: hr,
            rx: fh,
            ry: pd,
            class: "track"
          }),
          h("ellipse", {
            cx: ur,
            cy: hr,
            rx: fh * 0.7,
            ry: pd * 0.7,
            class: "track is-inner"
          }, null, 8, Pbe),
          (g(!0), v(H, null, me(m(Yv), (B) => (g(), v("g", { key: B }, [
            h("circle", {
              cx: S(B).x,
              cy: S(B).y,
              r: "2.2",
              class: U(["stop", { on: B === o.value.rotate }])
            }, null, 10, Ebe)
          ]))), 128)),
          h("path", {
            d: "M " + (ur - 5) + " " + (hr + pd + 9) + " l 5 -6 l 5 6 z",
            class: "origin"
          }, null, 8, Rbe),
          h("rect", {
            x: ur - 16,
            y: hr - 3,
            width: "32",
            height: "6",
            rx: "1.5",
            class: "card"
          }, null, 8, zbe),
          h("line", {
            x1: ur,
            y1: hr,
            x2: x.value.x,
            y2: x.value.y,
            class: U(["ray", { "is-behind": T.value }])
          }, null, 10, $be),
          h("g", {
            class: "cam",
            transform: "translate(" + x.value.x + " " + x.value.y + ")"
          }, [...q[8] || (q[8] = [
            h("circle", {
              r: "9",
              class: "halo"
            }, null, -1),
            h("circle", {
              r: "5.5",
              class: "dot"
            }, null, -1)
          ])], 8, Dbe)
        ], 40, Abe)),
        (g(), v("svg", {
          ref_key: "arc",
          ref: $,
          class: "ed-orbit-arc",
          viewBox: "0 0 84 96",
          role: "slider",
          "aria-label": "Camera height",
          "aria-valuenow": o.value.vertical,
          "aria-valuetext": m(Jv)(o.value.vertical),
          tabindex: "0",
          "data-testid": "studio-camera-arc",
          onPointerdown: q[1] || (q[1] = (B) => re("arc", B))
        }, [
          h("path", {
            d: z.value,
            class: "track"
          }, null, 8, Lbe),
          h("line", {
            x1: ka,
            y1: _a,
            x2: ka + fd + 6,
            y2: _a,
            class: "ground"
          }, null, 8, Bbe),
          (g(!0), v(H, null, me(m(Qp), (B) => (g(), v("circle", {
            key: B.at,
            cx: M(B.at).x,
            cy: M(B.at).y,
            r: "2",
            class: U(["stop", { on: B.at === o.value.vertical }])
          }, null, 10, Fbe))), 128)),
          h("rect", {
            x: ka - 3,
            y: _a - 16,
            width: "6",
            height: "16",
            rx: "1.5",
            class: "card"
          }, null, 8, Nbe),
          h("line", {
            x1: ka,
            y1: _a - 8,
            x2: P.value.x,
            y2: P.value.y,
            class: "ray"
          }, null, 8, Ube),
          h("g", {
            class: "cam",
            transform: "translate(" + P.value.x + " " + P.value.y + ")"
          }, [...q[9] || (q[9] = [
            h("circle", {
              r: "8",
              class: "halo"
            }, null, -1),
            h("circle", {
              r: "5",
              class: "dot"
            }, null, -1)
          ])], 8, Gbe)
        ], 40, Obe))
      ], 32),
      h("div", jbe, A(a.value ? a.value.name : m(sc)(o.value)), 1),
      h("section", Hbe, [
        h("div", Vbe, [
          q[11] || (q[11] = h("span", { class: "t" }, "Your cameras", -1)),
          h("span", Wbe, [
            C(R, {
              name: "Lock",
              size: 9
            }),
            q[10] || (q[10] = X(" Only you", -1))
          ])
        ]),
        C(Tp, {
          name: "ed-view",
          tag: "div",
          class: "ed-views-list"
        }, {
          default: et(() => [
            (g(!0), v(H, null, me(r.value, (B) => (g(), v("div", {
              key: B.id,
              class: U(["ed-view", { on: !!a.value && a.value.id === B.id, "is-naming": c.value === B.id }])
            }, [
              c.value === B.id ? xt((g(), v("input", {
                key: 0,
                ref_for: !0,
                ref_key: "nameEl",
                ref: p,
                "onUpdate:modelValue": q[2] || (q[2] = (ne) => u.value = ne),
                class: "ed-view-input",
                maxlength: m(yy),
                spellcheck: "false",
                "aria-label": "The view's name",
                "data-testid": "studio-camera-view-name",
                onKeydown: [
                  tn(Pe(w, ["prevent"]), ["enter"]),
                  tn(Pe(k, ["stop", "prevent"]), ["esc"])
                ],
                onBlur: w
              }, null, 40, qbe)), [
                [Jt, u.value]
              ]) : (g(), v("button", {
                key: 1,
                class: "ed-view-chip",
                title: m(sc)(B) + ". Double-click to rename it",
                "aria-pressed": !!a.value && a.value.id === B.id,
                "data-testid": "studio-camera-view",
                onClick: (ne) => f(B),
                onDblclick: (ne) => b(B)
              }, [
                C(R, {
                  name: "Camera",
                  size: 11
                }),
                h("span", Ybe, A(B.name), 1)
              ], 40, Kbe)),
              c.value !== B.id ? (g(), v("button", {
                key: 2,
                class: "ed-view-x",
                title: "Remove " + B.name,
                "aria-label": "Remove " + B.name,
                "data-testid": "studio-camera-view-remove",
                onClick: (ne) => m(t).removeCameraView(B.id)
              }, [
                C(R, {
                  name: "X",
                  size: 10
                })
              ], 8, Xbe)) : E("", !0)
            ], 2))), 128)),
            h("button", {
              key: "save",
              class: U(["ed-views-save", { "is-saved": !!a.value }]),
              disabled: !!a.value || l.value,
              title: d.value,
              "data-testid": "studio-camera-save",
              onClick: y
            }, [
              C(R, {
                name: a.value ? "Check" : "Plus",
                size: 12
              }, null, 8, ["name"]),
              X(" " + A(a.value ? "Saved" : "Save view"), 1)
            ], 10, Jbe)
          ]),
          _: 1
        }),
        r.value.length ? E("", !0) : (g(), v("p", Zbe, "Save a view to come back to it, on any board and any picture."))
      ]),
      C(St, {
        label: "Rotate",
        "model-value": o.value.rotate,
        min: 0,
        max: 359,
        ticks: m(Yv),
        format: ee,
        testid: "studio-camera-rotate",
        "onUpdate:modelValue": q[3] || (q[3] = (B) => m(i).setCamera({ rotate: m($2)(B, 4) }))
      }, null, 8, ["model-value", "ticks"]),
      C(St, {
        label: "Vertical",
        "model-value": o.value.vertical,
        min: -30,
        max: 90,
        ticks: m(Qp).map((B) => B.at),
        format: N,
        testid: "studio-camera-vertical",
        "onUpdate:modelValue": q[4] || (q[4] = (B) => m(i).setCamera({ vertical: m(D2)(B, 4) }))
      }, null, 8, ["model-value", "ticks"]),
      C(St, {
        label: "Zoom",
        "model-value": o.value.zoom,
        min: 0,
        max: 10,
        step: 0.5,
        start: 5,
        ticks: m(lC).map((B) => B.at),
        format: te,
        testid: "studio-camera-zoom",
        "onUpdate:modelValue": q[5] || (q[5] = (B) => m(i).setCamera({ zoom: m(See)(B, 0.4) }))
      }, null, 8, ["model-value", "ticks"]),
      C(vt, { name: "ed-fade" }, {
        default: et(() => [
          m(cC)(o.value) ? (g(), v("div", Qbe, [
            C(R, {
              name: "AlertCircle",
              size: 12
            }),
            q[12] || (q[12] = h("span", null, "Past a side view, the sides the picture doesn't show are invented.", -1))
          ])) : E("", !0)
        ]),
        _: 1
      }),
      h("div", eve, [
        h("label", tve, [
          xt(h("input", {
            "onUpdate:modelValue": q[6] || (q[6] = (B) => m(i).t.camera.lock = B),
            type: "checkbox",
            "data-testid": "studio-camera-seed-lock"
          }, null, 512), [
            [Na, m(i).t.camera.lock]
          ]),
          q[13] || (q[13] = h("i", null, null, -1)),
          q[14] || (q[14] = h("span", { title: "The same seed while you nudge the sliders, so a small move doesn't reshuffle the picture" }, "Keep the seed", -1))
        ]),
        h("button", {
          class: "ed-icon-chip",
          title: "A new seed",
          "aria-label": "A new seed",
          disabled: !s.value.lock,
          onClick: q[7] || (q[7] = (B) => {
            m(i).t.camera.seed = null, m(i).seed();
          })
        }, [
          C(R, {
            name: "Dice5",
            size: 13
          })
        ], 8, nve)
      ]),
      C(zo, {
        kind: "camera",
        label: "Change camera",
        icon: "Rotate3d",
        why: "Trained on exactly these three settings",
        many: !0
      })
    ]));
  }
}), sve = { class: "ed-panel ed-relight" }, ove = ["aria-selected"], rve = ["aria-selected"], ave = {
  class: "ed-looks is-light",
  role: "radiogroup",
  "aria-label": "Looks"
}, lve = ["aria-checked", "title", "data-testid", "onClick"], dve = { class: "ed-rig" }, cve = ["title", "onClick"], uve = { class: "ed-lights" }, hve = ["data-testid", "onClick"], pve = { class: "nm" }, fve = ["aria-label", "onClick"], mve = {
  class: "ed-quick",
  role: "group",
  "aria-label": "Quick positions"
}, gve = ["onClick"], bve = { class: "ed-field" }, vve = {
  class: "ed-whites",
  role: "radiogroup",
  "aria-label": "White light"
}, yve = ["aria-checked", "title", "onClick"], xve = {
  class: "ed-gels",
  role: "radiogroup",
  "aria-label": "Coloured light"
}, wve = ["aria-checked", "title", "onClick"], kve = {
  class: "ed-gel is-any",
  title: "Any colour"
}, _ve = ["value"], Sve = ["aria-checked"], Tve = ["aria-checked"], md = 132, Mve = /* @__PURE__ */ Re({
  __name: "RelightPanel",
  setup(n) {
    const t = ft().tools, i = I(() => t.t.relight), s = I(() => i.value.rig), o = I(() => s.value.lights.find((S) => S.id === i.value.selected) || s.value.lights[0] || null), r = /* @__PURE__ */ K(null);
    function a() {
      const S = r.value;
      if (!S) return;
      const _ = Math.min(2, window.devicePixelRatio || 1), x = Math.round(md * _);
      S.width !== x && (S.width = x, S.height = x);
      const T = S.getContext("2d");
      if (!T) return;
      const M = T.createImageData(x, x);
      M.data.set(Tce(s.value, x)), T.putImageData(M, 0, 0);
    }
    ot(a), $e(s, a, { deep: !0 });
    function l(S) {
      const _ = o.value;
      if (!_) return;
      const x = s.value.lights.map((T) => {
        if (T.id !== _.id) return T;
        const M = { ...T };
        return S(M), M;
      });
      t.t.relight.rig = { ...s.value, lights: x, look: s.value.look };
    }
    function d(S) {
      t.t.relight.rig = { ...s.value, mode: S };
    }
    function c(S) {
      const _ = d0.find((x) => x.id === S);
      _ && (t.t.relight.rig = fce(_, s.value.mode), t.t.relight.selected = t.t.relight.rig.lights[0].id);
    }
    function u() {
      var S;
      if (s.value.lights.length >= h_) return;
      const _ = s.value.lights.map((M) => M.rotate), x = (S = [90, -90, 135, 0].find((M) => !_.includes(M))) != null ? S : 135, T = Ay({ rotate: x, elevation: 0, intensity: 4, color: "#fff4e5", kelvin: 5600 });
      t.t.relight.rig = { ...s.value, lights: [...s.value.lights, T] }, t.t.relight.selected = T.id;
    }
    function p(S) {
      if (s.value.lights.length <= 1) return;
      const _ = s.value.lights.filter((x) => x.id !== S);
      t.t.relight.rig = { ...s.value, lights: _ }, i.value.selected === S && (t.t.relight.selected = _[0].id);
    }
    const f = (S) => {
      const _ = ac(S);
      return _ === 0 ? "Front" : _ === 180 ? "Behind" : Math.abs(_) === 90 ? _ > 0 ? "Right" : "Left" : (Math.abs(_) > 90 ? "Behind " : "Front ") + (_ > 0 ? "right" : "left");
    }, y = (S) => S >= 75 ? "Overhead" : S <= -75 ? "Below" : S > 0 ? "High, " + S + "°" : S < 0 ? "Low, " + S + "°" : "Level", b = (S) => String(S), w = I(() => xce(s.value.lights));
    function k(S) {
      return w.value[S] || "Light " + (S + 1);
    }
    return (S, _) => (g(), v("div", sve, [
      h("div", {
        class: "sv-seg is-text ed-tabs ed-slide",
        role: "tablist",
        "aria-label": "Relight",
        style: de({ "--i": s.value.mode === "transfer" ? 1 : 0, "--n": 2 })
      }, [
        h("button", {
          role: "tab",
          "aria-selected": s.value.mode === "relight",
          class: U({ on: s.value.mode === "relight" }),
          "data-testid": "studio-relight-mode-relight",
          onClick: _[0] || (_[0] = (x) => d("relight"))
        }, "Relight", 10, ove),
        h("button", {
          role: "tab",
          "aria-selected": s.value.mode === "transfer",
          class: U({ on: s.value.mode === "transfer" }),
          "data-testid": "studio-relight-mode-transfer",
          onClick: _[1] || (_[1] = (x) => d("transfer"))
        }, "Light transfer", 10, rve)
      ], 4),
      s.value.mode === "relight" ? (g(), v(H, { key: 0 }, [
        h("div", ave, [
          (g(!0), v(H, null, me(m(d0), (x) => (g(), v("button", {
            key: x.id,
            class: U(["ed-light-look", { on: s.value.look === x.id }]),
            role: "radio",
            "aria-checked": s.value.look === x.id,
            title: x.words || x.label,
            "data-testid": "studio-relight-look-" + x.id,
            onClick: (T) => c(x.id)
          }, [
            h("i", {
              style: de({ background: "radial-gradient(circle at 32% 30%, " + x.swatch[0] + ", " + x.swatch[1] + " 72%)" })
            }, null, 4),
            h("span", null, A(x.label), 1)
          ], 10, lve))), 128))
        ]),
        h("div", dve, [
          h("div", {
            class: "ed-sphere",
            style: de({ width: md + "px", height: md + "px" })
          }, [
            h("canvas", {
              ref_key: "sphere",
              ref: r,
              style: de({ width: md + "px", height: md + "px" })
            }, null, 4),
            (g(!0), v(H, null, me(s.value.lights, (x, T) => (g(), v("button", {
              key: x.id,
              class: U(["ed-sphere-light", { on: o.value && o.value.id === x.id, "is-behind": !m(Zg)(x).front }]),
              style: de({ left: m(Zg)(x).x * 100 + "%", top: m(Zg)(x).y * 100 + "%", "--c": x.color }),
              title: k(T),
              onClick: (M) => m(t).t.relight.selected = x.id
            }, A(T + 1), 15, cve))), 128))
          ], 4),
          h("div", uve, [
            (g(!0), v(H, null, me(s.value.lights, (x, T) => (g(), v("button", {
              key: x.id,
              class: U(["ed-light-chip", { on: o.value && o.value.id === x.id }]),
              style: de({ "--c": x.color }),
              "data-testid": "studio-relight-light-" + T,
              onClick: (M) => m(t).t.relight.selected = x.id
            }, [
              _[9] || (_[9] = h("i", null, null, -1)),
              h("span", pve, A(k(T)), 1),
              s.value.lights.length > 1 ? (g(), v("span", {
                key: 0,
                class: "x",
                role: "button",
                "aria-label": "Remove " + k(T),
                onClick: Pe((M) => p(x.id), ["stop"])
              }, [
                C(R, {
                  name: "X",
                  size: 10
                })
              ], 8, fve)) : E("", !0)
            ], 14, hve))), 128)),
            s.value.lights.length < m(h_) ? (g(), v("button", {
              key: 0,
              class: "ed-light-chip is-add",
              "data-testid": "studio-relight-add",
              onClick: u
            }, [
              C(R, {
                name: "Plus",
                size: 11
              }),
              _[10] || (_[10] = X(" Light", -1))
            ])) : E("", !0)
          ])
        ]),
        o.value ? (g(), v(H, { key: 0 }, [
          h("div", mve, [
            (g(!0), v(H, null, me(m(hce), (x) => (g(), v("button", {
              key: x.id,
              class: U(["ed-quick-btn", { on: m(ac)(o.value.rotate) === x.rotate && m(f_)(o.value.elevation) === x.elevation }]),
              onClick: (T) => {
                l((M) => {
                  M.rotate = x.rotate, M.elevation = x.elevation;
                });
              }
            }, A(x.label), 11, gve))), 128))
          ]),
          C(St, {
            label: "Around",
            "model-value": o.value.rotate,
            min: -135,
            max: 180,
            step: 45,
            ticks: [-135, -90, -45, 0, 45, 90, 135, 180],
            format: f,
            testid: "studio-relight-rotate",
            "onUpdate:modelValue": _[2] || (_[2] = (x) => l((T) => T.rotate = m(ac)(x)))
          }, null, 8, ["model-value"]),
          C(St, {
            label: "Height",
            "model-value": o.value.elevation,
            min: -90,
            max: 90,
            step: 45,
            ticks: [-90, -45, 0, 45, 90],
            format: y,
            testid: "studio-relight-elevation",
            "onUpdate:modelValue": _[3] || (_[3] = (x) => l((T) => T.elevation = m(f_)(x)))
          }, null, 8, ["model-value"]),
          C(St, {
            label: "Intensity",
            "model-value": o.value.intensity,
            min: 1,
            max: 10,
            start: 7,
            format: b,
            testid: "studio-relight-intensity",
            "onUpdate:modelValue": _[4] || (_[4] = (x) => l((T) => T.intensity = x))
          }, null, 8, ["model-value"]),
          h("div", bve, [
            _[12] || (_[12] = h("span", { class: "ed-field-lb" }, "Colour", -1)),
            h("div", vve, [
              (g(!0), v(H, null, me(m(VC), (x) => (g(), v("button", {
                key: x.kelvin,
                class: U(["ed-white", { on: o.value.kelvin === x.kelvin }]),
                style: de({ "--c": x.color }),
                role: "radio",
                "aria-checked": o.value.kelvin === x.kelvin,
                title: x.name + ", about " + x.kelvin + " K",
                onClick: (T) => {
                  l((M) => {
                    M.color = x.color, M.kelvin = x.kelvin;
                  });
                }
              }, [
                _[11] || (_[11] = h("i", null, null, -1)),
                h("span", null, A(x.kelvin / 1e3) + "k", 1)
              ], 14, yve))), 128))
            ]),
            h("div", xve, [
              (g(!0), v(H, null, me(m(uce), (x) => (g(), v("button", {
                key: x,
                class: U(["ed-gel", { on: !o.value.kelvin && o.value.color.toLowerCase() === x }]),
                style: de({ "--c": x }),
                role: "radio",
                "aria-checked": !o.value.kelvin && o.value.color.toLowerCase() === x,
                title: x,
                onClick: (T) => {
                  l((M) => {
                    M.color = x, M.kelvin = null;
                  });
                }
              }, null, 14, wve))), 128)),
              h("label", kve, [
                h("input", {
                  type: "color",
                  value: o.value.color,
                  onInput: _[5] || (_[5] = (x) => {
                    l((T) => {
                      T.color = x.target.value, T.kelvin = null;
                    });
                  })
                }, null, 40, _ve)
              ])
            ])
          ])
        ], 64)) : E("", !0),
        h("div", {
          class: "sv-seg is-small ed-pills ed-slide",
          role: "radiogroup",
          "aria-label": "Softness",
          style: de({ "--i": s.value.softness === "hard" ? 1 : 0, "--n": 2 })
        }, [
          h("button", {
            role: "radio",
            "aria-checked": s.value.softness === "soft",
            class: U({ on: s.value.softness === "soft" }),
            onClick: _[6] || (_[6] = (x) => m(t).t.relight.rig = { ...s.value, softness: "soft" })
          }, "Soft", 10, Sve),
          h("button", {
            role: "radio",
            "aria-checked": s.value.softness === "hard",
            class: U({ on: s.value.softness === "hard" }),
            onClick: _[7] || (_[7] = (x) => m(t).t.relight.rig = { ...s.value, softness: "hard" })
          }, "Hard", 10, Tve)
        ], 4)
      ], 64)) : (g(), v(H, { key: 1 }, [
        _[13] || (_[13] = h("p", { class: "ed-hint" }, "Copies another picture's light (its direction, colour and softness) onto this one, keeping everything else.", -1)),
        C(lI, {
          modelValue: m(t).t.relight.refId,
          "onUpdate:modelValue": _[8] || (_[8] = (x) => m(t).t.relight.refId = x),
          label: "The light to copy"
        }, null, 8, ["modelValue"])
      ], 64)),
      C(zo, {
        kind: "relight",
        label: s.value.mode === "transfer" ? "Transfer light" : "Relight",
        icon: "Lightbulb",
        why: s.value.mode === "transfer" ? "Copies the light of the picture you pick: it kept pictures truest in our relighting tests" : "Your lights, described in words: it kept pictures truest in our relighting tests"
      }, null, 8, ["label", "why"])
    ]));
  }
}), Cve = ["data-tool"], Ive = ["aria-checked", "disabled", "title", "data-testid", "onClick"], Ave = { class: "lbl" }, Pve = {
  key: 0,
  class: "ed-pending",
  title: "Not applied yet"
}, Eve = ["inert", "aria-busy", "data-testid"], Rve = /* @__PURE__ */ Re({
  __name: "ToolList",
  setup(n) {
    const e = ft(), t = e.tools, i = t.t, s = [
      { id: null, label: "Prompt", icon: "Wand2", hint: "Say what to change in the bar below, select an area, or annotate the picture" },
      ...$C
    ], o = {
      prompt: Ome,
      upscale: Jme,
      resize: xge,
      background: jge,
      adjust: kbe,
      skin: Cbe,
      camera: ive,
      relight: Mve
    }, r = I(() => !!e.stage.value && e.stage.value.status === "done");
    function a(p) {
      p === null ? t.close() : t.open(p);
    }
    const l = /* @__PURE__ */ K(null), d = () => typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let c = 0;
    $e(() => [i.open, i.resize.mode, i.background.mode, i.relight.rig.mode], ([p]) => {
      clearTimeout(c), c = window.setTimeout(() => u(p || "prompt"), d() ? 0 : 360);
    });
    function u(p) {
      const f = l.value && l.value.querySelector('[data-tool="' + p + '"]'), y = f && f.closest(".sv-studios");
      if (!f || !y) return;
      if (p === "prompt") {
        y.scrollTop > 0 && y.scrollTo({ top: 0, behavior: d() ? "auto" : "smooth" });
        return;
      }
      const b = y.getBoundingClientRect(), w = f.getBoundingClientRect(), k = w.top - b.top - 10, S = k < 0 ? k : w.bottom > b.bottom ? Math.min(w.bottom - b.bottom, k) : 0;
      Math.abs(S) > 1 && y.scrollBy({ top: S, behavior: d() ? "auto" : "smooth" });
    }
    return Ve(() => clearTimeout(c)), (p, f) => (g(), v("div", {
      ref_key: "root",
      ref: l,
      class: "ed-tools",
      role: "radiogroup",
      "aria-label": "Edit with",
      "data-testid": "studio-edit-tools"
    }, [
      (g(), v(H, null, me(s, (y) => h("section", {
        key: y.id || "prompt",
        "data-tool": y.id || "prompt",
        class: U(["ed-tool", { on: m(i).open === y.id, "is-pending": !!y.id && m(i).open === y.id && m(t).pending(y.id) }])
      }, [
        h("button", {
          class: "ed-tool-head",
          role: "radio",
          "aria-checked": m(i).open === y.id,
          disabled: !r.value && !!y.id || !!m(i).busy && m(i).open !== y.id,
          title: y.hint,
          "data-testid": "studio-edit-tool-" + (y.id || "prompt"),
          onClick: (b) => a(y.id)
        }, [
          C(Yf, {
            on: m(i).open === y.id
          }, null, 8, ["on"]),
          C(R, {
            name: y.icon,
            size: 15,
            class: "ic"
          }, null, 8, ["name"]),
          h("span", Ave, A(y.label), 1),
          y.id && m(i).open === y.id && m(t).pending(y.id) ? (g(), v("span", Pve)) : E("", !0)
        ], 8, Ive),
        C(Tl, {
          open: m(i).open === y.id
        }, {
          default: et(() => [
            h("div", {
              class: U(["ed-tool-body", { "is-held": !!m(i).busy }]),
              inert: !!m(i).busy || void 0,
              "aria-busy": !!m(i).busy || void 0,
              "data-testid": "studio-edit-panel-" + (y.id || "prompt")
            }, [
              (g(), Ce(Yr(o[y.id || "prompt"])))
            ], 10, Eve)
          ]),
          _: 2
        }, 1032, ["open"])
      ], 10, Cve)), 64))
    ], 512));
  }
}), zve = {
  class: "sv-tools",
  "data-testid": "studio-tools-threed"
}, $ve = {
  class: "sv-views",
  "data-testid": "studio-models"
}, Dve = ["title", "onClick"], Ove = { class: "sv-views-adds" }, Lve = {
  class: "sv-views",
  "data-testid": "studio-cameras"
}, Bve = ["value", "onKeydown", "onBlur"], Fve = ["title", "onClick", "onDblclick"], Nve = ["title", "onClick"], Uve = ["disabled"], Gve = ["disabled"], jve = /* @__PURE__ */ Re({
  __name: "ThreeDTools",
  props: {
    fly: { type: Function },
    capture: { type: Function }
  },
  emits: ["upload-model", "library-model"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = ft(), { board: o } = tt(), r = s.s, a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(!1);
    function c() {
      const y = s.saveCamera();
      y && s.say("Saved " + y.name + " with this model");
    }
    function u(y) {
      a.value = y, it(() => {
        const b = l.value && l.value[0];
        b && (b.focus(), b.select());
      });
    }
    function p(y, b) {
      a.value === y && (s.renameCamera(y, b.target.value), a.value = null);
    }
    async function f() {
      if (!d.value) {
        d.value = !0;
        try {
          await t.capture();
        } finally {
          d.value = !1;
        }
      }
    }
    return (y, b) => (g(), v("div", zve, [
      m(s).model3d.value ? (g(), v(H, { key: 0 }, [
        b[10] || (b[10] = h("p", { class: "sv-tools-hint" }, "Drag to orbit, right-drag or Shift-drag to move the view, scroll to zoom. Frame it in the viewfinder.", -1)),
        b[11] || (b[11] = h("div", { class: "sv-tools-label" }, "Models", -1)),
        h("ul", $ve, [
          (g(!0), v(H, null, me(m(s).models3d.value, (w) => (g(), v("li", {
            key: w.id
          }, [
            h("button", {
              class: U(["go", { on: w.id === m(r).three.model }]),
              title: "Show " + w.name,
              onClick: (k) => m(s).useModel(w.id)
            }, [
              C(R, {
                name: "Box",
                size: 12
              }),
              X(" " + A(w.name), 1)
            ], 10, Dve)
          ]))), 128)),
          h("li", Ove, [
            h("button", {
              class: "go is-add",
              title: "A model from your computer",
              "data-testid": "studio-3d-add",
              onClick: b[0] || (b[0] = (w) => i("upload-model"))
            }, [
              C(R, {
                name: "Upload",
                size: 12
              }),
              b[6] || (b[6] = X(" Computer", -1))
            ]),
            m(o).hasLibrary ? (g(), v("button", {
              key: 0,
              class: "go is-add",
              title: "A model from your Library",
              onClick: b[1] || (b[1] = (w) => i("library-model"))
            }, [
              C(R, {
                name: "Library",
                size: 12
              }),
              b[7] || (b[7] = X(" Library", -1))
            ])) : E("", !0)
          ])
        ]),
        b[12] || (b[12] = h("div", { class: "sv-tools-label" }, "Saved views", -1)),
        h("ul", Lve, [
          (g(!0), v(H, null, me(m(s).model3d.value.cameras, (w) => (g(), v("li", {
            key: w.id
          }, [
            a.value === w.id ? (g(), v("input", {
              key: 0,
              ref_for: !0,
              ref_key: "nameEl",
              ref: l,
              class: "sv-view-input",
              value: w.name,
              spellcheck: "false",
              onKeydown: [
                tn(Pe((k) => p(w.id, k), ["prevent"]), ["enter"]),
                b[2] || (b[2] = tn(Pe((k) => a.value = null, ["stop", "prevent"]), ["esc"]))
              ],
              onBlur: (k) => p(w.id, k)
            }, null, 40, Bve)) : (g(), v(H, { key: 1 }, [
              h("button", {
                class: "go",
                title: "Fly to " + w.name + " (double-click to rename)",
                onClick: (k) => n.fly(w.cam),
                onDblclick: (k) => u(w.id)
              }, [
                C(R, {
                  name: "Camera",
                  size: 12
                }),
                X(" " + A(w.name), 1)
              ], 40, Fve),
              h("button", {
                class: "x",
                title: "Forget " + w.name,
                onClick: (k) => m(s).removeCamera(w.id)
              }, [
                C(R, {
                  name: "X",
                  size: 11
                })
              ], 8, Nve)
            ], 64))
          ]))), 128)),
          h("li", null, [
            h("button", {
              class: "go is-add",
              "data-testid": "studio-save-camera",
              title: "Save this view to come back to",
              disabled: !m(r).three.cam,
              onClick: c
            }, [
              C(R, {
                name: "Plus",
                size: 12
              }),
              b[8] || (b[8] = X(" Save this view", -1))
            ], 8, Uve)
          ])
        ]),
        h("button", {
          class: "sv-btn is-wide",
          disabled: d.value || m(r).three.loading || !!m(r).three.error,
          "data-testid": "studio-capture",
          title: "Adds this frame to history and the queue, to draw on, annotate or send",
          onClick: f
        }, [
          C(R, {
            name: d.value ? "Loader2" : "Camera",
            size: 14,
            spin: d.value
          }, null, 8, ["name", "spin"]),
          b[9] || (b[9] = X(" Capture view ", -1))
        ], 8, Gve)
      ], 64)) : (g(), v(H, { key: 1 }, [
        b[16] || (b[16] = h("p", { class: "sv-tools-hint" }, "Bring in a model to find your view. Views you save stay with the model.", -1)),
        h("button", {
          class: "sv-btn is-wide",
          onClick: b[3] || (b[3] = (w) => i("upload-model"))
        }, [
          C(R, {
            name: "Upload",
            size: 14
          }),
          b[13] || (b[13] = X(" From your computer", -1))
        ]),
        m(o).hasLibrary ? (g(), v("button", {
          key: 0,
          class: "sv-btn is-wide",
          onClick: b[4] || (b[4] = (w) => i("library-model"))
        }, [
          C(R, {
            name: "Library",
            size: 14
          }),
          b[14] || (b[14] = X(" From your Library", -1))
        ])) : E("", !0),
        h("button", {
          class: "sv-btn is-wide",
          onClick: b[5] || (b[5] = (w) => m(s).addSample())
        }, [
          C(R, {
            name: "Building2",
            size: 14
          }),
          b[15] || (b[15] = X(" Try the sample", -1))
        ])
      ], 64))
    ]));
  }
}), Hve = {
  class: "sv-hist-pop",
  "data-testid": "studio-history-preview"
}, Vve = ["title"], Wve = { class: "cap" }, qve = { class: "n" }, Kve = { class: "m" }, Yve = { class: "sv-hist-acts" }, Xve = ["aria-pressed"], Jve = { class: "tip" }, Zve = { class: "tip" }, Qve = { class: "tip" }, e0e = { class: "tip" }, dI = /* @__PURE__ */ Re({
  __name: "HistoryPreview",
  props: {
    item: {}
  },
  emits: ["done"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = ft(), { board: o } = tt(), r = /* @__PURE__ */ K(!1);
    $e(() => t.item.id, () => {
      r.value = !1;
    });
    const a = I(() => t.item), l = I(() => s.side.value === "generate"), d = I(() => !!a.value.sessionId && a.value.sessionId !== s.sessionId && a.value.kind === "gen"), c = I(() => !!s.card.value && !s.onCard(a.value.id) && s.family.value.some((z) => z.id === a.value.id)), u = I(() => {
      const z = s.names.value.get(a.value.id), P = a.value.parentId ? s.items.value.find((O) => O.id === a.value.parentId) : null, D = P ? "from " + (s.names.value.get(P.id) || P.label) : "";
      return [a.value.pin ? a.value.label : a.value.kind === "ref" && !p.value ? nl[a.value.how || "upload"].text : z || a.value.label, D].filter(Boolean).join(" · ");
    }), p = I(() => a.value.kind === "ref" && a.value.how === "tool" && !!a.value.made), f = I(() => a.value.pin ? "Pinned" : p.value ? nl.tool.text + " · " + Jn(a.value.createdAt) : a.value.kind === "ref" ? "Reference" : (d.value ? s.sessionName(a.value) + " · " : "") + Jn(a.value.createdAt)), y = I(() => d.value ? "Bring it in from " + s.sessionName(a.value) : s.side.value === "edit" ? "Edit this one" : "Show it on the stage"), b = I(() => o.isPinnedImage(a.value.url));
    function w() {
      const z = a.value, P = z.result;
      o.togglePinImage({
        url: z.url,
        w: z.w,
        h: z.h,
        label: z.label,
        asset: z.asset || null,
        resultId: P ? P.id : null,
        sessionId: z.sessionId || (P ? P.sessionId : s.sessionId),
        video: !!(P && P.video),
        videoSrc: P && P.videoSrc || null,
        dur: P && P.dur || null
      });
    }
    const k = I(() => s.editRefItems.value.find((z) => z.id === a.value.id || !!z.source && z.source === a.value.id) || null), S = I(() => !l.value && s.takesRefs() && a.value.status === "done" && a.value.id !== s.s.stageId);
    function _() {
      k.value ? s.removeEditRef(k.value.id) : s.addEditRef(a.value.id);
    }
    function x(z) {
      z(), i("done");
    }
    function T() {
      a.value.status === "done" && s.show(a.value.id);
    }
    function M() {
      if (!r.value) {
        r.value = !0;
        return;
      }
      x(() => s.deleteItem(a.value.id));
    }
    return (z, P) => (g(), v("div", Hve, [
      h("button", {
        class: "art",
        title: y.value,
        onClick: P[0] || (P[0] = (D) => x(T))
      }, [
        C(us, {
          item: a.value,
          full: ""
        }, null, 8, ["item"])
      ], 8, Vve),
      h("span", Wve, [
        h("span", qve, A(u.value), 1),
        h("span", Kve, A(f.value), 1)
      ]),
      h("span", Yve, [
        h("button", {
          class: U(["is-pin", { on: b.value }]),
          "aria-pressed": b.value,
          "data-testid": "studio-pin",
          onClick: Pe(w, ["stop"])
        }, [
          C(R, {
            name: "Pin",
            size: 13
          }),
          h("span", Jve, A(b.value ? m(jn).unpin : m(jn).pin), 1)
        ], 10, Xve),
        l.value ? (g(), v(H, { key: 0 }, [
          h("button", {
            class: U({ on: m(s).queued(a.value.id) > 0 }),
            "data-testid": "studio-queue-toggle",
            onClick: P[1] || (P[1] = Pe((D) => m(s).toggleQueued(a.value.id), ["stop"]))
          }, [
            C(R, {
              name: m(s).queued(a.value.id) ? "Check" : "Plus",
              size: 13
            }, null, 8, ["name"]),
            h("span", Zve, A(m(s).queued(a.value.id) ? "In the queue as image " + m(s).queued(a.value.id) + ": take it out" : "Add to the queue"), 1)
          ], 2),
          h("button", {
            "data-testid": "studio-continue",
            onClick: P[2] || (P[2] = Pe((D) => x(() => m(s).continueFrom(a.value.id)), ["stop"]))
          }, [
            C(R, {
              name: "CornerDownLeft",
              size: 13
            }),
            P[6] || (P[6] = h("span", { class: "tip" }, "Continue from this: it becomes image 1", -1))
          ])
        ], 64)) : E("", !0),
        S.value ? (g(), v("button", {
          key: 1,
          class: U({ on: !!k.value }),
          "data-testid": "studio-ref-toggle",
          onClick: Pe(_, ["stop"])
        }, [
          C(R, {
            name: k.value ? "Check" : "ImagePlus",
            size: 13
          }, null, 8, ["name"]),
          h("span", Qve, A(k.value ? "A reference for the edit: take it out" : "Add as a reference"), 1)
        ], 2)) : E("", !0),
        c.value ? (g(), v("button", {
          key: 2,
          class: "is-promote",
          "data-testid": "studio-promote",
          onClick: P[3] || (P[3] = Pe((D) => x(() => m(s).promote(a.value.id)), ["stop"]))
        }, [
          C(R, {
            name: "Replace",
            size: 13
          }),
          P[7] || (P[7] = h("span", { class: "tip" }, "Show this version on the board, in place of the one there", -1))
        ])) : E("", !0),
        a.value.kind === "gen" ? (g(), v("button", {
          key: 3,
          onClick: P[4] || (P[4] = Pe((D) => x(() => m(s).openInfo(a.value.id)), ["stop"]))
        }, [
          C(R, {
            name: "Info",
            size: 13
          }),
          P[8] || (P[8] = h("span", { class: "tip" }, "Info", -1))
        ])) : E("", !0),
        h("button", {
          onClick: P[5] || (P[5] = Pe((D) => x(() => m(s).placeOnBoard(a.value.id)), ["stop"]))
        }, [
          C(R, {
            name: "ArrowDownToLine",
            size: 13
          }),
          P[9] || (P[9] = h("span", { class: "tip" }, "Place on the board", -1))
        ]),
        m(s).canDelete(a.value.id) ? (g(), v("button", {
          key: 4,
          class: U(["is-danger", { "is-armed": r.value }]),
          "data-testid": "studio-delete",
          onClick: Pe(M, ["stop"])
        }, [
          C(R, {
            name: "Trash2",
            size: 13
          }),
          h("span", e0e, A(r.value ? "Click again to delete it" : "Delete"), 1)
        ], 2)) : E("", !0)
      ])
    ]));
  }
}), t0e = ["inert"], n0e = { class: "sv-hist-head" }, i0e = { class: "t" }, s0e = {
  class: "n",
  "data-testid": "studio-history-count"
}, o0e = ["data-testid", "draggable", "onMouseenter", "onClick", "onDragstart"], r0e = { class: "frame" }, a0e = {
  key: 1,
  class: "sv-cell-fail"
}, l0e = ["title"], d0e = ["title"], c0e = {
  key: 2,
  class: "sv-cell-marks",
  title: "Annotated: its annotations go with it when it's sent"
}, u0e = {
  key: 3,
  class: "sv-cell-card",
  title: "The version the board shows",
  "data-testid": "studio-on-board"
}, h0e = ["title"], p0e = { class: "sv-cell-cap" }, f0e = {
  key: 1,
  class: "sv-hist-empty"
}, m0e = 300, g0e = 380, b0e = 60, v0e = 260, y0e = /* @__PURE__ */ Re({
  __name: "History",
  setup(n) {
    const e = ft(), { board: t } = tt(), i = e.s, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null);
    let r = 0;
    const a = I(() => e.shown.value), l = I(() => e.historySessions.value), d = I(() => e.pickedSessions()), c = I(() => e.allSessions()), u = I(() => p1(e)), p = I(() => (c.value ? l.value.length : d.value.length) > 1), f = I(() => e.side.value === "generate"), y = I(() => e.card.value);
    function b(J) {
      const re = e.stage.value;
      return !!re && (re.id === J.id || re.source === J.id);
    }
    function w(J) {
      return J.kind === "ref" && J.how === "tool" && !!J.made;
    }
    function k(J) {
      return J.status === "pending" ? "Making…" : J.status === "failed" ? "Failed" : i.pinned ? e.sessionName(J) || J.label : J.kind === "ref" && !w(J) ? nl[J.how || "upload"].text : p.value && e.sessionName(J) || Jn(J.createdAt);
    }
    function S() {
      t.openLibrary({
        purpose: "pick",
        max: 24,
        kinds: ["image"],
        confirmLabel: "Bring into the studio",
        onPick: (J) => e.addFromLibrary(J)
      });
    }
    function _(J) {
      J.status === "done" && (i.dropper ? e.dropperPick(J.id) : e.show(J.id));
    }
    function x(J) {
      return b(J) ? "Being edited" : e.editRefItems.value.some((re) => re.id === J.id || re.source === J.id) ? "A reference" : "Add as a reference";
    }
    function T(J, re) {
      if (J.status !== "done") {
        re.preventDefault();
        return;
      }
      P();
      const F = re.currentTarget.querySelector(".frame");
      iI(re, J.id, F);
    }
    const M = () => {
      clearTimeout(r), clearTimeout(D);
    }, z = (J) => {
      J && ($ = { x: J.clientX, y: J.clientY }), clearTimeout(r), clearTimeout(D), r = window.setTimeout(() => {
        o.value = null;
      }, 180);
    }, P = () => {
      clearTimeout(r), clearTimeout(D), o.value = null;
    };
    $e(() => o.value && o.value.it.id, (J, re) => {
      J ? i.peekId = J : i.peekId === re && (i.peekId = null);
    }), Ve(() => {
      clearTimeout(r), clearTimeout(D), o.value && i.peekId === o.value.it.id && (i.peekId = null);
    });
    let D = 0, $ = null;
    const O = /* @__PURE__ */ K(!1);
    let L = 0;
    $e(() => i.histShut, (J) => {
      P(), O.value = !0, clearTimeout(L), L = window.setTimeout(() => {
        O.value = !1;
      }, 380), J && i.dropper && e.setDropper(!1);
    }), Ve(() => clearTimeout(L));
    function Z(J, re) {
      if (M(), J.status !== "done" || !s.value || i.dropper) {
        o.value = null;
        return;
      }
      const F = re.currentTarget.getBoundingClientRect(), W = s.value.getBoundingClientRect(), ee = Math.min(m0e / J.w, g0e / J.h), N = Math.round(J.w * ee), te = Math.round(J.h * ee), G = Math.min(Math.max(b0e + 8 - W.top, F.top - W.top + F.height / 2 - te / 2), window.innerHeight - 8 - te - W.top), q = { it: J, top: G, w: N, h: te }, B = o.value, ne = $ ? re.clientX - $.x : 0, se = $ ? re.clientY - $.y : 0;
      if (B && B.it.id !== J.id && ne < 0 && -ne >= Math.abs(se)) {
        D = window.setTimeout(() => {
          o.value = q;
        }, v0e);
        return;
      }
      o.value = q;
    }
    return (J, re) => (g(), v("aside", {
      ref_key: "rail",
      ref: s,
      class: U(["sv-hist", ["cols-" + m(i).columns, { "is-dropper": m(i).dropper, "is-shut": m(i).histShut, "is-moving": O.value }]]),
      "data-testid": "studio-history",
      onMouseleave: z
    }, [
      h("div", {
        class: "sv-hist-body",
        inert: m(i).histShut || void 0
      }, [
        h("div", n0e, [
          h("span", i0e, A(m(i).pinned ? "Pinned" : "History"), 1),
          h("span", s0e, A(a.value.length), 1),
          re[4] || (re[4] = h("span", { class: "sv-grow" }, null, -1)),
          m(t).hasLibrary ? (g(), v("button", {
            key: 0,
            class: "sv-hist-lib",
            title: "Find a picture anywhere: your Library",
            "data-testid": "studio-open-library",
            onClick: S
          }, [
            C(R, {
              name: "Library",
              size: 14
            })
          ])) : E("", !0),
          C(l8, {
            columns: m(i).columns,
            testid: "studio-cols",
            onSet: re[0] || (re[0] = (F) => m(e).setColumns(F))
          }, null, 8, ["columns"]),
          h("button", {
            class: "sv-hist-lib sv-hist-fold",
            title: "Hide history, for more room",
            "aria-label": "Hide history",
            "data-testid": "studio-history-hide",
            onClick: re[1] || (re[1] = (F) => m(e).setHistShut(!0))
          }, [
            C(R, {
              name: "PanelRightClose",
              size: 14
            })
          ])
        ]),
        C(d8, {
          filter: m(e),
          tid: "studio",
          pinned: m(i).pinned,
          "pin-count": m(t).pinnedImages.value.length,
          onPinned: re[2] || (re[2] = (F) => m(i).pinned = F)
        }, null, 8, ["filter", "pinned", "pin-count"]),
        h("div", {
          class: "sv-hist-grid",
          style: de({ "--cols": m(i).columns }),
          onScroll: P
        }, [
          (g(!0), v(H, null, me(a.value, (F) => (g(), v("div", {
            key: F.id,
            class: U(["sv-cell", {
              "is-ref": F.kind === "ref",
              "is-stage": b(F),
              "is-pending": F.status === "pending",
              "is-failed": F.status === "failed",
              "is-queued": f.value && m(e).queued(F.id) > 0,
              "is-card": !!y.value && m(e).onCard(F.id),
              "is-new": Date.now() - F.createdAt < 4e3,
              "is-on": o.value && o.value.it.id === F.id
            }]),
            "data-testid": "studio-item-" + F.kind,
            draggable: F.status === "done",
            onMouseenter: (W) => Z(F, W),
            onMouseleave: z,
            onClick: (W) => _(F),
            onDragstart: (W) => T(F, W),
            onDragend: re[3] || (re[3] = //@ts-ignore
            (...W) => m(Sl) && m(Sl)(...W))
          }, [
            h("span", r0e, [
              F.status === "done" ? (g(), Ce(us, {
                key: 0,
                item: F
              }, null, 8, ["item"])) : F.status === "failed" ? (g(), v("span", a0e, [
                C(R, {
                  name: "AlertCircle",
                  size: 16
                })
              ])) : F.status === "pending" ? (g(), Ce(Nf, {
                key: 2,
                class: "sv-cell-time",
                since: F.result && F.result.startedAt || F.createdAt
              }, null, 8, ["since"])) : E("", !0)
            ]),
            F.kind === "ref" ? (g(), v("span", {
              key: 0,
              class: "sv-cell-how",
              title: w(F) ? F.made.label : m(nl)[F.how || "upload"].text
            }, [
              C(R, {
                name: m(nl)[F.how || "upload"].icon,
                size: 10
              }, null, 8, ["name"])
            ], 8, l0e)) : E("", !0),
            f.value && m(e).queued(F.id) ? (g(), v("span", {
              key: 1,
              class: "sv-cell-q",
              title: "Image " + m(e).queued(F.id) + " in the queue"
            }, A(m(e).queued(F.id)), 9, d0e)) : E("", !0),
            m(e).marked(F.id) ? (g(), v("span", c0e, [
              C(R, {
                name: "Pencil",
                size: 9
              })
            ])) : E("", !0),
            y.value && m(e).onCard(F.id) ? (g(), v("span", u0e, [
              C(R, {
                name: "LayoutGrid",
                size: 9
              }),
              re[5] || (re[5] = h("span", { class: "tx" }, "On the board", -1))
            ])) : E("", !0),
            !m(i).pinned && F.status === "done" && m(t).isPinnedImage(F.url) ? (g(), v("span", {
              key: 4,
              class: "sv-cell-pin",
              title: m(jn).badge
            }, [
              C(R, {
                name: "Pin",
                size: 10
              })
            ], 8, h0e)) : E("", !0),
            h("span", p0e, A(k(F)), 1),
            m(i).dropper && F.status === "done" ? (g(), v("span", {
              key: 5,
              class: U(["sv-cell-drop", { "is-in": x(F) !== "Add as a reference" }]),
              "aria-hidden": "true"
            }, [
              C(R, {
                name: x(F) === "Add as a reference" ? "Pipette" : "Check",
                size: 11
              }, null, 8, ["name"]),
              X(A(x(F)), 1)
            ], 2)) : E("", !0)
          ], 42, o0e))), 128)),
          m(i).pinned && !a.value.length ? (g(), Ce(f1, { key: 0 })) : a.value.length ? E("", !0) : (g(), v("div", f0e, A(c.value ? "What you make on this board, and the images you bring in, collect here." : "Nothing from " + u.value + " yet."), 1))
        ], 36)
      ], 8, t0e),
      o.value ? (g(), Ce(dI, {
        key: 0,
        item: o.value.it,
        style: de({ top: o.value.top + "px", width: o.value.w + "px", height: o.value.h + "px" }),
        onMouseenter: M,
        onMouseleave: z,
        onDone: P
      }, null, 8, ["item", "style"])) : E("", !0)
    ], 34));
  }
}), x0e = ["aria-label", "aria-current", "draggable", "onMouseenter", "onClick", "onDragstart"], w0e = {
  key: 1,
  class: "sv-ver-fail"
}, k0e = {
  key: 3,
  class: "sv-ver-marks"
}, _0e = {
  key: 4,
  class: "sv-ver-card",
  title: "The version the board shows",
  "data-testid": "studio-version-on-board"
}, ab = 54, S0e = 300, T0e = 380, M0e = /* @__PURE__ */ Re({
  __name: "Versions",
  setup(n) {
    const e = ft(), t = e.s, i = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null);
    let r = 0;
    const a = I(() => [...e.family.value].reverse()), l = I(() => t.studio !== "threed" && a.value.length > 1), d = I(() => e.card.value);
    function c(_) {
      return Math.round(Math.max(ab * 0.66, Math.min(ab * 1.8, ab * _.w / _.h)));
    }
    function u(_) {
      return t.stageId === _.id;
    }
    function p(_) {
      const x = e.names.value.get(_.id) || _.label;
      return _.status === "pending" ? x + ", being made" : _.status === "failed" ? x + ", failed" : x;
    }
    function f(_) {
      _.status === "done" && (t.dropper ? e.dropperPick(_.id) : e.show(_.id));
    }
    function y(_, x) {
      if (_.status !== "done" || e.side.value !== "edit") {
        x.preventDefault();
        return;
      }
      k(), iI(x, _.id, x.currentTarget);
    }
    $e(() => [t.stageId, a.value.length, l.value], async () => {
      await it();
      const _ = s.value, x = _ && _.querySelector(".sv-ver.is-stage");
      if (!_ || !x) return;
      const T = x.offsetLeft - 8, M = x.offsetLeft + x.offsetWidth + 8;
      T < _.scrollLeft ? _.scrollTo({ left: T, behavior: "smooth" }) : M > _.scrollLeft + _.clientWidth && _.scrollTo({ left: M - _.clientWidth, behavior: "smooth" });
    });
    const b = () => clearTimeout(r), w = () => {
      clearTimeout(r), r = window.setTimeout(() => {
        o.value = null;
      }, 180);
    }, k = () => {
      clearTimeout(r), o.value = null;
    };
    $e(() => o.value && o.value.it.id, (_, x) => {
      _ ? t.peekId = _ : t.peekId === x && (t.peekId = null);
    }), Ve(() => {
      clearTimeout(r), o.value && t.peekId === o.value.it.id && (t.peekId = null);
    }), $e(l, (_) => {
      _ || k();
    });
    function S(_, x) {
      if (b(), _.status !== "done" || !i.value || t.dropper) {
        o.value = null;
        return;
      }
      const T = x.currentTarget.getBoundingClientRect(), M = i.value.getBoundingClientRect(), z = i.value.parentElement ? i.value.parentElement.querySelector(".sv-dock") : null, P = z ? z.getBoundingClientRect().top - 12 : window.innerHeight - 24, D = Math.max(120, P - M.bottom - 8), $ = Math.min(S0e / _.w, T0e / _.h, D / _.h), O = Math.round(_.w * $), L = Math.round(_.h * $), Z = Math.max(8, Math.min(M.width - O - 8, T.left - M.left + T.width / 2 - O / 2));
      o.value = { it: _, left: Z, w: O, h: L };
    }
    return (_, x) => l.value ? (g(), v("div", {
      key: 0,
      ref_key: "root",
      ref: i,
      class: U(["sv-vers", { "is-dropper": m(t).dropper }]),
      "data-testid": "studio-versions",
      onMouseleave: w
    }, [
      h("div", {
        ref_key: "row",
        ref: s,
        class: "sv-vers-row",
        role: "group",
        "aria-label": "Versions of this picture",
        onScroll: k
      }, [
        (g(!0), v(H, null, me(a.value, (T) => (g(), v("button", {
          key: T.id,
          class: U(["sv-ver", {
            "is-stage": u(T),
            "is-pending": T.status === "pending",
            "is-failed": T.status === "failed",
            "is-card": !!d.value && m(e).onCard(T.id),
            "is-new": Date.now() - T.createdAt < 4e3,
            "is-on": o.value && o.value.it.id === T.id
          }]),
          style: de({ width: c(T) + "px" }),
          "aria-label": p(T),
          "aria-current": u(T) ? "true" : void 0,
          "data-testid": "studio-version",
          draggable: m(e).side.value === "edit" && T.status === "done",
          onMouseenter: (M) => S(T, M),
          onMouseleave: w,
          onClick: (M) => f(T),
          onDragstart: (M) => y(T, M),
          onDragend: x[0] || (x[0] = //@ts-ignore
          (...M) => m(Sl) && m(Sl)(...M))
        }, [
          T.status === "done" ? (g(), Ce(us, {
            key: 0,
            item: T
          }, null, 8, ["item"])) : T.status === "failed" ? (g(), v("span", w0e, [
            C(R, {
              name: "AlertCircle",
              size: 15
            })
          ])) : T.status === "pending" ? (g(), Ce(Nf, {
            key: 2,
            class: "sv-cell-time",
            since: T.result && T.result.startedAt || T.createdAt
          }, null, 8, ["since"])) : E("", !0),
          m(e).marked(T.id) ? (g(), v("span", k0e)) : E("", !0),
          d.value && m(e).onCard(T.id) ? (g(), v("span", _0e, [
            C(R, {
              name: "LayoutGrid",
              size: 10
            })
          ])) : E("", !0)
        ], 46, x0e))), 128))
      ], 544),
      o.value ? (g(), Ce(dI, {
        key: 0,
        item: o.value.it,
        style: de({ left: o.value.left + "px", width: o.value.w + "px", height: o.value.h + "px" }),
        onMouseenter: b,
        onMouseleave: w,
        onDone: k
      }, null, 8, ["item", "style"])) : E("", !0)
    ], 34)) : E("", !0);
  }
}), C0e = 700;
function Oy(n = () => !0) {
  const e = /* @__PURE__ */ K(!1);
  let t = 0, i = !1;
  const s = () => {
    clearTimeout(t), e.value = !1;
  }, o = (d) => i || !d.dataTransfer || !Array.from(d.dataTransfer.types).includes("Files") || !n() ? !1 : (e.value = !0, clearTimeout(t), t = window.setTimeout(s, C0e), !0), r = (d) => {
    const c = d.currentTarget;
    if (!c) return s();
    const u = d.relatedTarget;
    if (u) {
      c.contains(u) || s();
      return;
    }
    const p = c.getBoundingClientRect(), f = d.clientX, y = d.clientY;
    (f === 0 && y === 0 || f <= p.left || f >= p.right - 1 || y <= p.top || y >= p.bottom - 1) && s();
  }, a = () => {
    i = !0;
  }, l = () => {
    i = !1, s();
  };
  return ot(() => {
    window.addEventListener("dragstart", a, !0), window.addEventListener("dragend", l, !0), window.addEventListener("drop", l, !0), window.addEventListener("blur", s);
  }), Ve(() => {
    clearTimeout(t), window.removeEventListener("dragstart", a, !0), window.removeEventListener("dragend", l, !0), window.removeEventListener("drop", l, !0), window.removeEventListener("blur", s);
  }), { active: e, over: o, leave: r, stop: s };
}
const I0e = {
  class: "sv-ambient",
  "aria-hidden": "true"
}, A0e = { class: "sv-top" }, P0e = { class: "sv-title" }, E0e = { class: "eyebrow" }, R0e = ["title"], z0e = ["title"], $0e = { class: "ic" }, D0e = {
  key: 1,
  class: "sv-pos",
  "data-testid": "studio-position"
}, O0e = { class: "n" }, L0e = {
  class: "sv-studios",
  "aria-label": "Studios"
}, B0e = ["aria-selected", "disabled", "title", "data-testid", "onClick"], F0e = {
  key: "generate",
  class: "sv-modes ed-tools",
  role: "radiogroup",
  "aria-label": "Generate with"
}, N0e = ["title", "aria-checked", "data-testid", "onClick"], U0e = { class: "lbl" }, G0e = ["data-testid"], j0e = {
  key: 1,
  class: "sv-tools-hint"
}, H0e = {
  key: 2,
  class: "sv-tools-hint"
}, V0e = { class: "sv-main" }, W0e = {
  key: 0,
  class: "bd-dropper sv-dropper",
  role: "status",
  "data-testid": "studio-dropper-banner"
}, q0e = { class: "bd-dropper-mark" }, K0e = {
  class: "bd-dropper-count",
  "data-testid": "studio-dropper-count"
}, Y0e = {
  key: 0,
  class: "sv-dock"
}, X0e = {
  key: 0,
  class: "sv-dropping"
}, J0e = /* @__PURE__ */ Re({
  __name: "StudiosView",
  setup(n) {
    const { board: e } = tt(), t = e.ui.studio, i = p0(e, t.sessionId);
    Wce(i);
    const s = i.s, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null);
    $e(() => e.ui.studio && e.ui.studio.n, () => {
      const xe = e.ui.studio;
      !xe || xe.sessionId !== i.sessionId || i.enter(xe.elementId || xe.resultId ? { elementId: xe.elementId, resultId: xe.resultId } : null);
    }, { immediate: !0 });
    const l = [
      { id: "prompt", label: "Prompt", icon: "Wand2", side: "generate", tip: "Say what you want: a new image, or one from the images you queue" },
      { id: "threed", label: "3D", icon: "Box", side: "generate", tip: "Find a view of a 3D model and generate from it" },
      { id: "edit", label: "Edit", icon: "Pencil", side: "edit", tip: "Change the image on the stage" }
    ], d = { edit: "Edit", erase: "Erase", annotate: "Annotate" }, c = [
      { id: "generate", label: "Generate", icon: "Sparkles" },
      { id: "edit", label: "Edit", icon: "Pencil" }
    ], u = I(() => i.session.value), p = I(() => i.stage.value), f = I(() => s.studio === "threed" ? i.model3d.value ? i.model3d.value.name : "3D model" : p.value ? p.value.label : i.video.value ? "New video" : "New image"), y = I(() => {
      const xe = p.value;
      if (!xe || s.studio === "threed") return "";
      const Oe = i.names.value.get(xe.id), Ee = i.family.value.length;
      return Oe ? Oe + (Ee > 1 ? " of " + Ee : "") : "";
    }), b = I(() => {
      if (s.studio !== "edit") return l.find((Oe) => Oe.id === s.studio).label;
      const xe = Cy(i.tools.t.open);
      return xe ? xe.label : d[s.bar];
    }), w = I(() => i.side.value), k = I(() => c.find((xe) => xe.id === w.value).label), S = I(() => i.video.value ? c.filter((xe) => xe.id === "generate") : c), _ = I(() => l.filter((xe) => xe.side === w.value && (!i.video.value || xe.id === "prompt"))), x = I(() => i.video.value ? "Say what you want: a new video, or one that starts from the pictures you queue" : l[0].tip);
    function T(xe) {
      if (!i.canUse(xe)) {
        i.say("Pick an image to edit: one from history, or make one");
        return;
      }
      i.setStudio(xe);
    }
    function M(xe) {
      xe !== w.value && (xe === "generate" ? i.tools.close(() => i.setSide(xe)) : i.setSide(xe));
    }
    function z() {
      i.tools.close(() => {
        i.leave(), e.closeStudio();
      });
    }
    function P() {
      const xe = u.value;
      i.tools.close(() => {
        i.leave(), e.closeStudio(), xe && e.openSession(xe);
      });
    }
    function D() {
      r.value && r.value.click();
    }
    function $() {
      a.value && a.value.click();
    }
    function O(xe) {
      const Oe = xe.target, Ee = Array.from(Oe.files || []);
      Oe.value = "";
      for (const j of Ee) i.addUpload(j);
    }
    function L(xe) {
      const Oe = xe.target, Ee = (Oe.files || [])[0];
      Oe.value = "", Ee && i.addModelFile(Ee);
    }
    function Z() {
      e.openLibrary({
        purpose: "pick",
        max: 1,
        kinds: ["3d"],
        confirmLabel: "Use this model",
        onPick: (xe) => {
          xe[0] && i.addModelFromLibrary(xe[0]);
        }
      });
    }
    const J = I(() => o.value && o.value.model || null), re = (xe) => {
      J.value && J.value.fly(xe);
    };
    async function F(xe = !1) {
      const Oe = J.value;
      if (!Oe) return !1;
      let Ee;
      try {
        Ee = await Oe.capture();
      } catch (j) {
        return console.warn("[board] view not captured", j), i.say("The view couldn't be captured"), !1;
      }
      return Ee ? !!await i.captureView(Ee, xe) : !1;
    }
    const W = () => F(!1), ee = I(() => s.studio === "threed" && i.model3d.value ? () => F(!0) : null), N = I(() => {
      const xe = i.refRoom(), Oe = i.editRefItems.value.filter((Ee) => Ee.id !== s.stageId).length;
      return Math.min(Oe, xe) + " of " + xe;
    });
    function te(xe) {
      if (e.ui.libraryOpen) return;
      const Oe = xe.target, Ee = !!Oe && (Oe.tagName === "INPUT" || Oe.tagName === "TEXTAREA" || Oe.isContentEditable);
      if (xe.key === "Escape") {
        if (i.tools.t.guard) return;
        e.ui.infoAt ? e.ui.infoAt = null : s.dropper ? i.setDropper(!1) : s.editingPin ? i.commitPin(s.editingPin) : Ee ? Oe.blur() : w.value === "edit" && s.bar === "annotate" && s.selection.length ? i.select([]) : i.tools.t.compare ? i.tools.compare(null) : i.tools.t.open ? i.tools.close() : z(), xe.preventDefault();
        return;
      }
      if (!e.ui.infoAt && !i.tools.t.guard && o.value && o.value.zoomKey(xe, Ee)) {
        xe.preventDefault();
        return;
      }
      if (e.ui.infoAt || Ee || i.tools.t.guard) return;
      const j = w.value === "edit", V = xe.key.toLowerCase();
      if (j && vn(xe) && (V === "y" || V === "z" && xe.shiftKey)) {
        xe.preventDefault(), i.redoMark();
        return;
      }
      if (j && vn(xe) && V === "z") {
        xe.preventDefault(), i.undoMark();
        return;
      }
      if ((xe.key === "Delete" || xe.key === "Backspace") && !vn(xe) && !xe.altKey && !i.tools.t.open && !(j && s.bar === "annotate" && s.selection.length)) {
        const oe = s.peekId || s.stageId;
        if (oe && i.canDelete(oe)) {
          xe.preventDefault(), i.deleteItem(oe);
          return;
        }
      }
      if (!j || i.tools.t.open || vn(xe) || xe.altKey) return;
      if (V === "m" || V === "x" || V === "n" && s.bar !== "annotate") {
        xe.preventDefault(), i.setBar(V === "m" ? "edit" : V === "x" ? "erase" : "annotate");
        return;
      }
      if (V === "i") {
        xe.preventDefault(), i.setDropper(!s.dropper);
        return;
      }
      if (s.bar !== "annotate") {
        const oe = { b: "brush", l: "lasso", s: "object" }[V];
        if (oe) {
          s.areaTool = oe;
          return;
        }
        if (xe.key === "[" || xe.key === "]") {
          s.areaSize = Math.max(6, Math.min(200, Math.round(s.areaSize * (xe.key === "]" ? 1.2 : 1 / 1.2))));
          return;
        }
        return;
      }
      if ((xe.key === "Delete" || xe.key === "Backspace") && s.selection.length) {
        xe.preventDefault(), i.deleteStrokes(s.selection.slice());
        return;
      }
      const Q = { v: "move", b: "brush", t: "text", r: "box", o: "ellipse", a: "arrow", e: "eraser", n: "note" }[V];
      Q && (i.finishEditing(), s.tool = Q, Q !== "move" && i.select([]));
    }
    const { active: G, over: q, leave: B, stop: ne } = Oy();
    function se(xe) {
      q(xe) && (xe.preventDefault(), xe.stopPropagation());
    }
    function Y(xe) {
      if (ne(), !!xe.dataTransfer) {
        xe.preventDefault(), xe.stopPropagation();
        for (const Oe of Array.from(xe.dataTransfer.files || []).filter((Ee) => Ee.type.startsWith("image/")).slice(0, 14)) ie(Oe);
      }
    }
    function ie(xe) {
      w.value === "edit" ? i.addUploadRef(xe) : i.addUpload(xe);
    }
    function De(xe) {
      if (e.ui.libraryOpen) return;
      const Oe = xe.target;
      if (Oe && (Oe.tagName === "INPUT" || Oe.tagName === "TEXTAREA")) return;
      const Ee = Array.from(xe.clipboardData && xe.clipboardData.files || []).filter((j) => j.type.startsWith("image/"));
      if (Ee.length) {
        xe.preventDefault();
        for (const j of Ee) ie(j);
      }
    }
    return ot(() => {
      window.addEventListener("keydown", te), window.addEventListener("paste", De);
    }), Ve(() => {
      window.removeEventListener("keydown", te), window.removeEventListener("paste", De);
    }), (xe, Oe) => (g(), v("div", {
      class: U(["sv-root", ["in-" + m(s).studio, "side-" + w.value, { "is-dropper": m(s).dropper, "hist-shut": m(s).histShut }]]),
      "data-testid": "studios-view",
      onPointerdown: Oe[3] || (Oe[3] = Pe((Ee) => m(s).editingPin && m(i).commitPin(m(s).editingPin), ["self"])),
      onDragover: se,
      onDragleave: Oe[4] || (Oe[4] = //@ts-ignore
      (...Ee) => m(B) && m(B)(...Ee)),
      onDrop: Y
    }, [
      h("div", I0e, [
        p.value && p.value.url && m(s).studio !== "threed" ? (g(), v("span", {
          key: p.value.url,
          style: de({ backgroundImage: 'url("' + p.value.url + '")' })
        }, null, 4)) : E("", !0)
      ]),
      h("header", A0e, [
        h("button", {
          class: "sv-back",
          title: "Back to the board (Esc)",
          "data-testid": "studio-back",
          onClick: z
        }, [
          C(R, {
            name: "ArrowLeft",
            size: 15
          })
        ]),
        h("div", P0e, [
          h("span", E0e, [
            X(A(k.value), 1),
            b.value !== k.value ? (g(), v(H, { key: 0 }, [
              X(" · " + A(b.value), 1)
            ], 64)) : E("", !0)
          ]),
          h("span", {
            class: "name",
            title: f.value
          }, A(f.value), 9, R0e)
        ]),
        u.value ? (g(), v("button", {
          key: 0,
          type: "button",
          class: "sv-session",
          title: "Back to the board, on " + u.value.name,
          "data-testid": "studio-session",
          onClick: P
        }, [
          Oe[5] || (Oe[5] = h("span", { class: "lb" }, "Session", -1)),
          h("span", $0e, [
            C(R, {
              name: u.value.icon || "Image",
              size: 12
            }, null, 8, ["name"])
          ]),
          h("b", null, A(u.value.name), 1)
        ], 8, z0e)) : E("", !0),
        Oe[7] || (Oe[7] = h("span", { class: "sv-grow" }, null, -1)),
        y.value ? (g(), v("span", D0e, A(y.value), 1)) : E("", !0),
        p.value && p.value.kind === "gen" && p.value.status === "done" && m(s).studio !== "threed" ? (g(), v("button", {
          key: 2,
          class: "sv-top-btn",
          title: "Info",
          onClick: Oe[0] || (Oe[0] = (Ee) => m(i).openInfo(p.value.id))
        }, [
          C(R, {
            name: "Info",
            size: 14
          }),
          Oe[6] || (Oe[6] = X(" Info", -1))
        ])) : E("", !0),
        C(vt, { name: "sv-hist-show" }, {
          default: et(() => [
            m(s).histShut ? (g(), v("button", {
              key: 0,
              class: "sv-top-btn sv-hist-show",
              title: "Show history",
              "aria-label": "Show history",
              "data-testid": "studio-history-show",
              onClick: Oe[1] || (Oe[1] = (Ee) => m(i).setHistShut(!1))
            }, [
              C(R, {
                name: "PanelRightOpen",
                size: 14
              }),
              h("span", null, A(m(s).pinned ? "Pinned" : "History"), 1),
              h("span", O0e, A(m(i).shown.value.length), 1)
            ])) : E("", !0)
          ]),
          _: 1
        }),
        h("button", {
          class: "sv-close",
          title: "Close (Esc)",
          "data-testid": "studio-close",
          onClick: z
        }, [
          C(R, {
            name: "X",
            size: 16
          })
        ])
      ]),
      h("nav", L0e, [
        h("div", {
          class: "sv-seg is-text sv-sides ed-slide",
          role: "tablist",
          "aria-label": "Generate or edit",
          style: de({ "--i": Math.max(0, S.value.findIndex((Ee) => Ee.id === w.value)), "--n": S.value.length })
        }, [
          (g(!0), v(H, null, me(S.value, (Ee) => (g(), v("button", {
            key: Ee.id,
            role: "tab",
            "aria-selected": w.value === Ee.id,
            class: U({ on: w.value === Ee.id }),
            disabled: Ee.id === "edit" && w.value !== "edit" && !m(i).canEdit(),
            title: Ee.id === "edit" ? "Change an image: say what to change, select an area, annotate it, or use a tool" : m(i).video.value ? "Make videos: from a prompt, and the pictures they start from" : "Make images: from a prompt, or a 3D view",
            "data-testid": "studio-side-" + Ee.id,
            onClick: (j) => M(Ee.id)
          }, [
            C(R, {
              name: Ee.icon,
              size: 13
            }, null, 8, ["name"]),
            X(" " + A(Ee.label), 1)
          ], 10, B0e))), 128))
        ], 4),
        C(vt, {
          name: "ed-side",
          mode: "out-in"
        }, {
          default: et(() => [
            w.value === "edit" ? (g(), Ce(Rve, { key: "edit" })) : (g(), v("div", F0e, [
              (g(!0), v(H, null, me(_.value, (Ee) => (g(), v("section", {
                key: Ee.id,
                class: U(["ed-tool", { on: m(s).studio === Ee.id }])
              }, [
                h("button", {
                  class: "ed-tool-head",
                  role: "radio",
                  title: Ee.id === "prompt" ? x.value : Ee.tip,
                  "aria-checked": m(s).studio === Ee.id,
                  "data-testid": "studio-pick-" + Ee.id,
                  onClick: (j) => T(Ee.id)
                }, [
                  C(Yf, {
                    on: m(s).studio === Ee.id
                  }, null, 8, ["on"]),
                  C(R, {
                    name: Ee.icon,
                    size: 15,
                    class: "ic"
                  }, null, 8, ["name"]),
                  h("span", U0e, A(Ee.label), 1)
                ], 8, N0e),
                m(s).studio === Ee.id ? (g(), v("div", {
                  key: 0,
                  class: "ed-tool-body is-plain",
                  "data-testid": "studio-panel-" + Ee.id
                }, [
                  Ee.id === "threed" ? (g(), Ce(jve, {
                    key: 0,
                    fly: re,
                    capture: W,
                    onUploadModel: $,
                    onLibraryModel: Z
                  })) : m(i).video.value ? (g(), v("p", j0e, "Say what you want in the box below. Queue pictures there for the video to start from, image 1 first.")) : (g(), v("p", H0e, "Say what you want in the box below. Queue images there to start from them, image 1 first; their annotations and notes go with them."))
                ], 8, G0e)) : E("", !0)
              ], 2))), 128))
            ]))
          ]),
          _: 1
        })
      ]),
      h("main", V0e, [
        C(vt, { name: "bd-dropper" }, {
          default: et(() => [
            m(s).dropper ? (g(), v("div", W0e, [
              h("span", q0e, [
                C(R, {
                  name: "Pipette",
                  size: 13
                })
              ]),
              Oe[8] || (Oe[8] = h("span", { class: "bd-dropper-text" }, "Click a picture in history to send it with the edit", -1)),
              h("span", K0e, A(N.value), 1),
              h("button", {
                class: "bd-dropper-done",
                title: "Done (Esc)",
                "data-testid": "studio-dropper-done",
                onClick: Oe[2] || (Oe[2] = (Ee) => m(i).setDropper(!1))
              }, "Done")
            ])) : E("", !0)
          ]),
          _: 1
        }),
        C(M0e),
        C(Rhe, {
          ref_key: "stageRef",
          ref: o,
          onUpload: D,
          onUploadModel: $,
          onLibraryModel: Z
        }, null, 512),
        w.value === "generate" ? (g(), v("div", Y0e, [
          C(vt, { name: "sv-note" }, {
            default: et(() => [
              m(s).note ? (g(), v("div", {
                key: m(s).note.id,
                class: "sv-note",
                role: "status"
              }, A(m(s).note.text), 1)) : E("", !0)
            ]),
            _: 1
          }),
          C(Khe),
          C(Hpe, {
            before: ee.value,
            label: ee.value ? "Run from view" : null
          }, null, 8, ["before", "label"])
        ])) : (g(), Ce(zme, { key: 1 }))
      ]),
      C(y0e),
      m(G) ? (g(), v("div", X0e, [
        h("div", null, [
          C(R, {
            name: "ImagePlus",
            size: 18
          }),
          X(" " + A(w.value === "edit" ? "Drop images to send them with the edit" : "Drop images to add them to the queue"), 1)
        ])
      ])) : E("", !0),
      h("input", {
        ref_key: "imageInput",
        ref: r,
        type: "file",
        accept: "image/*",
        multiple: "",
        style: { display: "none" },
        onChange: O
      }, null, 544),
      h("input", {
        ref_key: "modelInput",
        ref: a,
        type: "file",
        accept: ".glb,.gltf,.obj,.stl",
        style: { display: "none" },
        onChange: L
      }, null, 544)
    ], 34));
  }
}), Z0e = ["disabled"], Q0e = ["disabled"], e1e = { class: "lb-peek-shell" }, t1e = { class: "lb-peek-stage" }, n1e = {
  key: 0,
  class: "lb-peek-withheld"
}, i1e = { class: "lb-empty-mark is-warn" }, s1e = ["src", "poster"], o1e = ["src"], r1e = { class: "lb-peek-side" }, a1e = { class: "lb-peek-top" }, l1e = { class: "n" }, d1e = ["title", "aria-pressed"], c1e = ["title", "aria-pressed"], u1e = ["title"], h1e = {
  key: 0,
  class: "lb-peek-confirm"
}, p1e = { class: "lb-peek-block" }, f1e = { class: "lb-peek-head" }, m1e = { class: "lb-peek-prompt" }, g1e = { class: "lb-peek-specs" }, b1e = { key: 0 }, v1e = { key: 1 }, y1e = { key: 2 }, x1e = {
  key: 0,
  class: "lb-peek-acts"
}, w1e = ["disabled"], k1e = /* @__PURE__ */ Re({
  __name: "LibraryPeek",
  props: {
    lib: {},
    item: {},
    placing: { type: Boolean },
    single: { type: Boolean },
    model: {}
  },
  emits: ["close", "pick", "star", "remove"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = tt(), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(""), a = /* @__PURE__ */ K(!1), l = I(() => t.lib.shown.value), d = I(() => l.value.findIndex((x) => x.id === t.item.id)), c = I(() => t.lib.order(t.item.id)), u = I(() => t.item.w && t.item.h ? t.item.w + " × " + t.item.h : ""), p = I(() => t.lib.faved(t.item)), f = I(() => s.isPinnedImage(t.item.url));
    $e(() => t.item.id, () => {
      a.value = !1;
    });
    function y(x) {
      const T = l.value.length;
      T < 2 || d.value < 0 || (t.lib.s.peek = l.value[(d.value + x + T) % T]);
    }
    async function b() {
      if (t.item.prompt)
        try {
          await navigator.clipboard.writeText(t.item.prompt), o.value = !0, window.setTimeout(() => {
            o.value = !1;
          }, 1400);
        } catch {
        }
    }
    function w() {
      const x = t.item, T = x.video && x.videoSrc ? x.videoSrc : x.url, M = (/(\.\w{3,4})(\?|$)/.exec(T.replace(/%2F/gi, "/")) || ["", x.video ? ".mp4" : ".webp"])[1], z = x.run ? y1(x.prompt || "", x.run.uuid, T) : x.label.replace(/\.[a-z0-9]+$/i, "") + M;
      s.saveFile(T, z);
    }
    function k() {
      if (!a.value) {
        a.value = !0;
        return;
      }
      a.value = !1, i("remove", t.item);
    }
    function S() {
      s.placeFromLibrary([t.item]), s.closeLibrary();
    }
    function _(x) {
      const T = x.target;
      T && (T.tagName === "INPUT" || T.tagName === "TEXTAREA") || (x.key === "ArrowLeft" ? (x.preventDefault(), y(-1)) : x.key === "ArrowRight" && (x.preventDefault(), y(1)));
    }
    return ot(() => window.addEventListener("keydown", _)), Ve(() => window.removeEventListener("keydown", _)), (x, T) => (g(), v("div", {
      class: "lb-peek",
      "data-testid": "library-peek",
      onPointerdown: T[8] || (T[8] = Pe((M) => i("close"), ["self"]))
    }, [
      h("button", {
        class: "lb-peek-nav at-left",
        title: "Previous (←)",
        disabled: l.value.length < 2,
        onClick: T[0] || (T[0] = (M) => y(-1))
      }, [
        C(R, {
          name: "ChevronLeft",
          size: 20
        })
      ], 8, Z0e),
      h("button", {
        class: "lb-peek-nav at-right",
        title: "Next (→)",
        disabled: l.value.length < 2,
        onClick: T[1] || (T[1] = (M) => y(1))
      }, [
        C(R, {
          name: "ChevronRight",
          size: 20
        })
      ], 8, Q0e),
      h("div", e1e, [
        h("div", t1e, [
          n.item.moderated ? (g(), v("div", n1e, [
            h("span", i1e, [
              C(R, {
                name: "EyeOff",
                size: 20
              })
            ]),
            T[9] || (T[9] = h("b", null, "Moderated by RunDiffusion", -1)),
            T[10] || (T[10] = h("span", null, "This image was flagged by our moderation system. This can happen because of NSFW, copyright, gore, or other related reasons. This system is currently a work in progress, please have patience as we work to improve it.", -1))
          ])) : n.item.video && n.item.videoSrc ? (g(), v("video", {
            key: n.item.videoSrc,
            class: "lb-peek-art",
            src: n.item.videoSrc,
            poster: n.item.url,
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            controls: "",
            controlslist: "nodownload noplaybackrate",
            disablepictureinpicture: ""
          }, null, 8, s1e)) : (g(), v("img", {
            key: n.item.url,
            class: U(["lb-peek-art", { "is-loading": r.value !== n.item.url }]),
            src: n.item.url,
            alt: "",
            draggable: "false",
            onLoad: T[2] || (T[2] = (M) => r.value = n.item.url)
          }, null, 42, o1e))
        ]),
        h("aside", r1e, [
          h("div", a1e, [
            h("span", l1e, [
              C(R, {
                name: "Images",
                size: 13
              }),
              X(" " + A(d.value >= 0 ? d.value + 1 : "–") + " of " + A(l.value.length), 1)
            ]),
            T[11] || (T[11] = h("span", { class: "lb-grow" }, null, -1)),
            n.item.moderated ? E("", !0) : (g(), v("button", {
              key: 0,
              class: U(["lb-peek-act lb-peek-pin", { on: f.value }]),
              title: f.value ? m(jn).unpin : m(jn).pin,
              "aria-pressed": f.value,
              "data-testid": "library-peek-pin",
              onClick: T[3] || (T[3] = (M) => m(s).togglePinImage(m(PF)(n.item)))
            }, [
              C(R, {
                name: "Pin",
                size: 14
              })
            ], 10, d1e)),
            n.lib.canStar(n.item) ? (g(), v("button", {
              key: 1,
              class: U(["lb-peek-act lb-peek-star", { on: p.value }]),
              title: p.value ? "Remove from your favorites" : "Add to your favorites",
              "aria-pressed": p.value,
              "data-testid": "library-peek-star",
              onClick: T[4] || (T[4] = (M) => i("star", n.item))
            }, [
              C(R, {
                name: "Heart",
                size: 14
              })
            ], 10, c1e)) : E("", !0),
            n.item.moderated ? E("", !0) : (g(), v("button", {
              key: 2,
              class: "lb-peek-act",
              title: "Download",
              "data-testid": "library-peek-download",
              onClick: w
            }, [
              C(R, {
                name: "Download",
                size: 14
              })
            ])),
            n.lib.canRemove(n.item) ? (g(), v("button", {
              key: 3,
              class: U(["lb-peek-act is-danger", { "is-confirming": a.value }]),
              title: a.value ? "Click again to delete it for good" : n.item.uploadId ? "Delete this upload" : "Delete this generation",
              "data-testid": "library-peek-delete",
              onClick: k,
              onBlur: T[5] || (T[5] = (M) => a.value = !1)
            }, [
              C(R, {
                name: a.value ? "Check" : "Trash2",
                size: 14
              }, null, 8, ["name"]),
              a.value ? (g(), v("span", h1e, "Delete?")) : E("", !0)
            ], 42, u1e)) : E("", !0),
            h("button", {
              class: "lb-peek-act",
              title: "Back to your Library (Esc)",
              "data-testid": "library-peek-close",
              onClick: T[6] || (T[6] = (M) => i("close"))
            }, [
              C(R, {
                name: "X",
                size: 15
              })
            ])
          ]),
          h("div", p1e, [
            h("div", f1e, [
              h("span", null, [
                C(R, {
                  name: "MessageSquare",
                  size: 13
                }),
                X(" " + A(n.item.prompt ? "Prompt" : "Name"), 1)
              ]),
              n.item.prompt ? (g(), v("button", {
                key: 0,
                title: "Copy the prompt",
                onClick: b
              }, [
                C(R, {
                  name: o.value ? "Check" : "Clipboard",
                  size: 13
                }, null, 8, ["name"])
              ])) : E("", !0)
            ]),
            h("p", m1e, A(n.item.prompt || n.item.label), 1)
          ]),
          h("dl", g1e, [
            n.model ? (g(), v("div", b1e, [
              T[12] || (T[12] = h("dt", null, "Model", -1)),
              h("dd", null, A(n.model), 1)
            ])) : E("", !0),
            n.item.createdAt ? (g(), v("div", v1e, [
              h("dt", null, A(n.item.uploadId ? "Uploaded" : "Made"), 1),
              h("dd", null, A(m(i1)(n.item.createdAt)), 1)
            ])) : E("", !0),
            u.value ? (g(), v("div", y1e, [
              T[13] || (T[13] = h("dt", null, "Size", -1)),
              h("dd", null, A(u.value), 1)
            ])) : E("", !0),
            h("div", null, [
              T[14] || (T[14] = h("dt", null, "Kind", -1)),
              h("dd", null, A(n.item.uploadId ? "Upload" : n.item.video ? "Video" : "Image") + A(p.value ? ", a favorite" : ""), 1)
            ])
          ]),
          T[16] || (T[16] = h("span", { class: "lb-grow" }, null, -1)),
          n.item.moderated ? E("", !0) : (g(), v("div", x1e, [
            h("button", {
              class: U(["lb-btn", c.value ? "is-picked" : ""]),
              disabled: !n.lib.allowed(n.item) || !c.value && n.lib.full() && !n.single,
              "data-testid": "library-peek-pick",
              onClick: T[7] || (T[7] = (M) => i("pick", n.item))
            }, [
              C(R, {
                name: c.value ? "Check" : "Plus",
                size: 14
              }, null, 8, ["name"]),
              X(" " + A(n.single ? "Use this one" : c.value ? "Picked (" + c.value + ")" : "Pick"), 1)
            ], 10, w1e),
            n.placing ? (g(), v("button", {
              key: 0,
              class: "lb-btn is-primary",
              "data-testid": "library-peek-place",
              onClick: S
            }, [
              C(R, {
                name: "ArrowDownToLine",
                size: 14
              }),
              T[15] || (T[15] = X(" Place on board ", -1))
            ])) : E("", !0)
          ]))
        ])
      ])
    ], 32));
  }
}), _1e = ["data-lb-own-keys"], S1e = ["aria-expanded", "data-testid"], T1e = { class: "t" }, M1e = {
  key: 1,
  class: "bd-spinner is-sm"
}, C1e = {
  key: 0,
  class: "lb-select-pop",
  role: "listbox"
}, I1e = {
  key: 0,
  class: "lb-select-search"
}, A1e = { class: "lb-select-rows" }, P1e = ["aria-selected", "onMouseenter", "onClick"], E1e = { class: "t" }, R1e = {
  key: 0,
  class: "lb-select-none"
}, mh = /* @__PURE__ */ Re({
  __name: "LibrarySelect",
  props: {
    modelValue: { default: void 0 },
    options: {},
    anyText: {},
    icon: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    testid: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ K(!1), o = /* @__PURE__ */ K(""), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(0), d = I(() => t.options.find((k) => k.value === t.modelValue) || null), c = I(() => t.options.length > 8), u = I(() => {
      const k = o.value.trim().toLowerCase();
      return k ? t.options.filter((S) => S.text.toLowerCase().includes(k)) : t.options;
    }), p = I(() => [null, ...u.value]);
    function f() {
      s.value = !s.value;
    }
    function y(k) {
      i("update:modelValue", k ? k.value : void 0), s.value = !1;
    }
    function b(k) {
      s.value && (k.key === "Escape" ? (k.preventDefault(), k.stopPropagation(), s.value = !1) : k.key === "ArrowDown" ? (k.preventDefault(), l.value = Math.min(p.value.length - 1, l.value + 1)) : k.key === "ArrowUp" ? (k.preventDefault(), l.value = Math.max(0, l.value - 1)) : k.key === "Enter" && (k.preventDefault(), y(p.value[l.value])));
    }
    function w(k) {
      r.value && !r.value.contains(k.target) && (s.value = !1);
    }
    return $e(s, (k) => {
      o.value = "", l.value = Math.max(0, p.value.findIndex((S) => (S ? S.value : void 0) === t.modelValue)), k ? (window.addEventListener("pointerdown", w, !0), it(() => {
        a.value && a.value.focus();
      })) : window.removeEventListener("pointerdown", w, !0);
    }), $e(o, () => {
      l.value = 0;
    }), Ve(() => window.removeEventListener("pointerdown", w, !0)), (k, S) => (g(), v("div", {
      ref_key: "root",
      ref: r,
      class: "lb-select-wrap",
      "data-lb-own-keys": s.value ? "" : void 0,
      onKeydown: b
    }, [
      h("button", {
        class: U(["lb-select-btn", { on: s.value, "is-set": !!d.value }]),
        "aria-expanded": s.value,
        "data-testid": n.testid,
        onClick: f
      }, [
        n.icon ? (g(), Ce(R, {
          key: 0,
          name: n.icon,
          size: 13
        }, null, 8, ["name"])) : E("", !0),
        h("span", T1e, A(d.value ? d.value.text : n.anyText), 1),
        n.loading ? (g(), v("span", M1e)) : (g(), Ce(R, {
          key: 2,
          name: "ChevronDown",
          size: 13,
          class: "chev"
        }))
      ], 10, S1e),
      s.value ? (g(), v("div", C1e, [
        c.value ? (g(), v("label", I1e, [
          C(R, {
            name: "Search",
            size: 13
          }),
          xt(h("input", {
            ref_key: "searchEl",
            ref: a,
            "onUpdate:modelValue": S[0] || (S[0] = (_) => o.value = _),
            type: "text",
            spellcheck: "false",
            placeholder: "Find",
            "aria-label": "Find in the list"
          }, null, 512), [
            [Jt, o.value]
          ])
        ])) : E("", !0),
        h("div", A1e, [
          (g(!0), v(H, null, me(p.value, (_, x) => (g(), v("button", {
            key: _ ? _.value : "(any)",
            class: U(["lb-select-row", { on: (_ ? _.value : void 0) === n.modelValue, "is-active": x === l.value, "is-any": !_ }]),
            role: "option",
            "aria-selected": (_ ? _.value : void 0) === n.modelValue,
            onMouseenter: (T) => l.value = x,
            onClick: (T) => y(_)
          }, [
            h("span", E1e, A(_ ? _.text : n.anyText), 1),
            (_ ? _.value : void 0) === n.modelValue ? (g(), Ce(R, {
              key: 0,
              name: "Check",
              size: 13
            })) : E("", !0)
          ], 42, P1e))), 128)),
          u.value.length ? E("", !0) : (g(), v("div", R1e, "Nothing matches “" + A(o.value.trim()) + "”", 1))
        ])
      ])) : E("", !0)
    ], 40, _1e));
  }
});
function z1e(n) {
  return n.model3d ? "3d" : n.video ? "video" : "image";
}
const D_ = { image: ["picture", "pictures"], video: ["video", "videos"], "3d": ["3D model", "3D models"] };
function $1e(n, e, t) {
  if (t) return "Pick pictures to place on the board";
  const [i, s] = n.length === 1 ? D_[n[0]] : D_.image;
  return e === 1 ? "Pick a " + i : "Pick up to " + e + " " + s;
}
const D1e = 2, cI = [
  { value: "1:1", text: "1:1 (Square)" },
  { value: "16:9", text: "16:9 (Landscape)" },
  { value: "2:1", text: "2:1" },
  { value: "3:2", text: "3:2" },
  { value: "4:3", text: "4:3" },
  { value: "21:9", text: "21:9 (Ultrawide)" },
  { value: "9:16", text: "9:16 (Portrait)" },
  { value: "2:3", text: "2:3" },
  { value: "3:4", text: "3:4" },
  { value: "OTHER", text: "Other" }
], uI = [
  { value: "1K", text: "1K (~1024px)" },
  { value: "2K", text: "2K (~2048px)" },
  { value: "4K+", text: "4K+ (4096px and up)" }
];
function Xf(n) {
  const e = (n || "").trim();
  return e.length >= D1e ? e : "";
}
function hI(n) {
  return cf(n) > 0;
}
function cf(n) {
  if (!n) return 0;
  let e = 0;
  for (const t of ["aspect", "resolution", "tool", "family", "media", "board"]) n[t] && e++;
  return (n.from || n.to) && e++, n.favorited && e++, e;
}
const Br = 24;
function O1e(n, e = {}) {
  const t = e.filters || {}, i = typeof e.cursor == "string" ? e.cursor : null, s = { limit: Br };
  return i && (s.cursor = i), n === "favorites" ? (s.favorites = !0, s) : (s.filters = {
    aspectRatioFilter: t.aspect || null,
    resolutionFilter: t.resolution || null,
    toolFilter: t.tool || null,
    modelFamilyTagFilter: t.family || null,
    mediaTagFilter: t.media || null,
    dateFromFilter: t.from || null,
    dateToFilter: t.to || null,
    favoriteFilter: t.favorited ? "favorited" : null,
    // a search answers in one page: never sent with a cursor
    searchFilter: i ? null : Xf(e.search) || null
  }, t.board && (s.runnitId = t.board), s);
}
function L1e(n) {
  switch (n.code) {
    case "ACCOUNT_NOT_MEMBER":
      return "You are not a member of the selected team account";
    case "EMAIL_NOT_VERIFIED":
      return "Verify your email in the web app before filtering team generations";
    case "ANONYMOUS_NOT_ALLOWED":
      return "Sign in with your account to filter generations";
    case "ACCOUNT_NOT_FOUND":
      return "That team account no longer exists";
    case "PERMISSION_DENIED":
      return "You do not have permission to view these generations";
  }
  return n.reason === "unauthorized" ? "Your session expired, please sign in again" : n.reason === "forbidden" ? "You do not have permission to view these generations" : "Could not load filtered generations, please try again";
}
function m0(n, e, t) {
  const i = { storageUrl: e.storageUrl, modelName: e.modelName, authorName: () => "" }, s = [];
  for (const o of k8(n, i)) {
    if (!o.asset || o.status !== "done" && o.status !== "moderated") continue;
    const r = o.asset.nodeRunResult;
    if (r && r.type === "MODEL") continue;
    const a = r && r.file && typeof r.file.name == "string" ? r.file.name : "", l = (/\.([a-z0-9]+)$/i.exec(a) || ["", "glb"])[1].toLowerCase(), d = (t || o.prompt || "").trim();
    s.push({
      id: o.id,
      url: o.url,
      thumb: o.thumb,
      w: o.w,
      h: o.h,
      video: o.kind === "video",
      videoSrc: o.videoSrc,
      model3d: o.kind === "3d" && o.download ? { url: o.download, ext: l } : void 0,
      label: d || o.model || "Generation",
      prompt: d,
      model: o.model || void 0,
      createdAt: o.createdAt,
      moderated: o.status === "moderated" || void 0,
      mine: n.userId === e.uid,
      run: {
        id: n.id,
        uuid: o.uuid || "",
        nodeDefId: n.nodeDefId,
        nodeId: n.nodeId,
        runnitId: n.runnitId,
        type: r && typeof r.type == "string" ? r.type : o.kind === "video" ? "VID" : "IMG"
      },
      asset: o.asset
    });
  }
  return s;
}
function B1e(n, e, t) {
  const i = [];
  for (const s of n) {
    const o = {
      id: s.id,
      runnitId: s.board_id || "",
      nodeId: s.node_id || "",
      nodeDefId: s.tool_id || "",
      userId: s.user_id || "",
      teamId: s.team_id,
      email: s.email || void 0,
      state: "DONE",
      initAt: s.init_at ? Date.parse(s.init_at) : void 0,
      doneAt: s.done_at ? Date.parse(s.done_at) : void 0,
      results: s.results || []
    }, r = (a) => e[a] && e[a].title || t.modelName(a);
    i.push(...m0(o, { ...t, modelName: r }, s.prompt));
  }
  return i;
}
const F1e = {
  class: "lb-filters",
  "data-testid": "library-filters",
  "aria-label": "Filters"
}, N1e = { class: "lb-filters-grid" }, U1e = { class: "lb-field is-wide" }, G1e = { class: "lb-chips" }, j1e = ["title", "data-testid", "onClick"], H1e = { class: "lb-field" }, V1e = { class: "lb-chips" }, W1e = ["title", "onClick"], q1e = { class: "lb-field" }, K1e = { class: "lb-chips" }, Y1e = { class: "lb-field" }, X1e = { class: "lb-field" }, J1e = { class: "lb-field" }, Z1e = { class: "lb-field" }, Q1e = { class: "lb-field is-dates" }, eye = { class: "lb-dates" }, tye = ["value", "max"], nye = ["value", "min"], iye = { class: "lb-filters-foot" }, sye = { class: "lb-filters-count" }, oye = ["disabled"], rye = /* @__PURE__ */ Re({
  __name: "LibraryFilters",
  props: {
    lib: {},
    options: {},
    loading: { type: Boolean }
  },
  setup(n) {
    const e = n, t = e.lib.s, i = I(() => cf(t.draft)), s = I(() => JSON.stringify(o(t.draft)) !== JSON.stringify(o(t.filters)));
    function o(d) {
      const c = {};
      for (const [u, p] of Object.entries(d)) p && (c[u] = p);
      return c;
    }
    function r(d, c) {
      t.draft = { ...t.draft, [d]: c };
    }
    function a(d) {
      const c = /^(\d+):(\d+)$/.exec(d);
      if (!c) return { width: "12px", height: "12px" };
      const u = Number(c[1]) / Number(c[2]), p = 15;
      return u >= 1 ? { width: p + "px", height: Math.max(5, Math.round(p / u)) + "px" } : { width: Math.max(5, Math.round(p * u)) + "px", height: p + "px" };
    }
    function l() {
      e.lib.applyFilters({});
    }
    return (d, c) => (g(), v("section", F1e, [
      h("div", N1e, [
        h("div", U1e, [
          c[13] || (c[13] = h("span", { class: "lb-field-label" }, "Aspect ratio", -1)),
          h("div", G1e, [
            h("button", {
              class: U(["lb-chip", { on: !m(t).draft.aspect }]),
              onClick: c[0] || (c[0] = (u) => r("aspect", void 0))
            }, "Any", 2),
            (g(!0), v(H, null, me(m(cI), (u) => (g(), v("button", {
              key: u.value,
              class: U(["lb-chip", { on: m(t).draft.aspect === u.value }]),
              title: u.text,
              "data-testid": "library-aspect-" + u.value,
              onClick: (p) => r("aspect", m(t).draft.aspect === u.value ? void 0 : u.value)
            }, [
              h("i", {
                class: U(["glyph", { "is-other": u.value === "OTHER" }]),
                style: de(a(u.value))
              }, null, 6),
              X(" " + A(u.value === "OTHER" ? "Other" : u.value), 1)
            ], 10, j1e))), 128))
          ])
        ]),
        h("div", H1e, [
          c[14] || (c[14] = h("span", { class: "lb-field-label" }, "Resolution", -1)),
          h("div", V1e, [
            h("button", {
              class: U(["lb-chip", { on: !m(t).draft.resolution }]),
              onClick: c[1] || (c[1] = (u) => r("resolution", void 0))
            }, "Any", 2),
            (g(!0), v(H, null, me(m(uI), (u) => (g(), v("button", {
              key: u.value,
              class: U(["lb-chip", { on: m(t).draft.resolution === u.value }]),
              title: u.text,
              onClick: (p) => r("resolution", m(t).draft.resolution === u.value ? void 0 : u.value)
            }, A(u.value), 11, W1e))), 128))
          ])
        ]),
        h("div", q1e, [
          c[16] || (c[16] = h("span", { class: "lb-field-label" }, "Show", -1)),
          h("div", K1e, [
            h("button", {
              class: U(["lb-chip", { on: !m(t).draft.favorited }]),
              onClick: c[2] || (c[2] = (u) => r("favorited", void 0))
            }, "All", 2),
            h("button", {
              class: U(["lb-chip", { on: !!m(t).draft.favorited }]),
              "data-testid": "library-only-favorites",
              onClick: c[3] || (c[3] = (u) => r("favorited", !0))
            }, [
              C(R, {
                name: "Heart",
                size: 12
              }),
              c[15] || (c[15] = X(" Favorited", -1))
            ], 2)
          ])
        ]),
        h("div", Y1e, [
          c[17] || (c[17] = h("span", { class: "lb-field-label" }, "Tool", -1)),
          C(mh, {
            "model-value": m(t).draft.tool,
            options: n.options ? n.options.tools : [],
            "any-text": "Any tool",
            icon: "Wand2",
            loading: n.loading && !n.options,
            testid: "library-filter-tool",
            "onUpdate:modelValue": c[4] || (c[4] = (u) => r("tool", u))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        h("div", X1e, [
          c[18] || (c[18] = h("span", { class: "lb-field-label" }, "Model family", -1)),
          C(mh, {
            "model-value": m(t).draft.family,
            options: n.options ? n.options.families : [],
            "any-text": "Any family",
            icon: "Layers",
            loading: n.loading && !n.options,
            "onUpdate:modelValue": c[5] || (c[5] = (u) => r("family", u))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        h("div", J1e, [
          c[19] || (c[19] = h("span", { class: "lb-field-label" }, "Media", -1)),
          C(mh, {
            "model-value": m(t).draft.media,
            options: n.options ? n.options.media : [],
            "any-text": "Any media",
            icon: "Images",
            loading: n.loading && !n.options,
            "onUpdate:modelValue": c[6] || (c[6] = (u) => r("media", u))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        h("div", Z1e, [
          c[20] || (c[20] = h("span", { class: "lb-field-label" }, "Board", -1)),
          C(mh, {
            "model-value": m(t).draft.board,
            options: n.options ? n.options.boards : [],
            "any-text": "Any board",
            icon: "LayoutGrid",
            loading: n.loading && !n.options,
            "onUpdate:modelValue": c[7] || (c[7] = (u) => r("board", u))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        h("div", Q1e, [
          c[22] || (c[22] = h("span", { class: "lb-field-label" }, "Made between", -1)),
          h("div", eye, [
            h("input", {
              value: m(t).draft.from || "",
              type: "date",
              max: m(t).draft.to || void 0,
              "aria-label": "From",
              "data-testid": "library-from",
              onInput: c[8] || (c[8] = (u) => r("from", u.target.value || void 0))
            }, null, 40, tye),
            c[21] || (c[21] = h("span", { class: "to" }, "to", -1)),
            h("input", {
              value: m(t).draft.to || "",
              type: "date",
              min: m(t).draft.from || void 0,
              "aria-label": "To",
              "data-testid": "library-to",
              onInput: c[9] || (c[9] = (u) => r("to", u.target.value || void 0))
            }, null, 40, nye),
            m(t).draft.from || m(t).draft.to ? (g(), v("button", {
              key: 0,
              class: "lb-dates-x",
              title: "Clear the dates",
              onClick: c[10] || (c[10] = (u) => m(t).draft = { ...m(t).draft, from: void 0, to: void 0 })
            }, [
              C(R, {
                name: "X",
                size: 11
              })
            ])) : E("", !0)
          ])
        ])
      ]),
      h("footer", iye, [
        h("span", sye, A(i.value ? i.value + (i.value === 1 ? " filter" : " filters") : "No filters"), 1),
        i.value || n.lib.filtersOn() ? (g(), v("button", {
          key: 0,
          class: "lb-link",
          "data-testid": "library-filters-clear",
          onClick: l
        }, [
          C(R, {
            name: "RotateCcw",
            size: 12
          }),
          c[23] || (c[23] = X(" Clear all", -1))
        ])) : E("", !0),
        c[25] || (c[25] = h("span", { class: "lb-grow" }, null, -1)),
        h("button", {
          class: "lb-btn is-ghost",
          onClick: c[11] || (c[11] = (u) => n.lib.cancelFilters())
        }, "Cancel"),
        h("button", {
          class: "lb-btn is-primary",
          disabled: !s.value,
          "data-testid": "library-filters-apply",
          onClick: c[12] || (c[12] = (u) => n.lib.applyFilters())
        }, [
          C(R, {
            name: "Check",
            size: 14
          }),
          c[24] || (c[24] = X(" Apply filters", -1))
        ], 8, oye)
      ])
    ]));
  }
}), aye = ["data-testid"], lye = {
  key: 0,
  class: "hill b"
}, dye = { class: "le-spark" }, cye = { class: "le-prompt" }, uye = { class: "le-drop" }, hye = { class: "le-check" }, pye = { class: "le-burst" }, fye = { class: "le-heart" }, mye = {
  key: 0,
  class: "le-lens"
}, lb = /* @__PURE__ */ Re({
  __name: "LibraryEmptyArt",
  props: {
    kind: {}
  },
  setup(n) {
    return (e, t) => (g(), v("div", {
      class: U(["le", "is-" + n.kind]),
      "aria-hidden": "true",
      "data-testid": "library-empty-art-" + n.kind
    }, [
      t[9] || (t[9] = h("i", { class: "le-glow" }, null, -1)),
      n.kind === "generations" ? (g(), v(H, { key: 0 }, [
        (g(), v(H, null, me(3, (i) => h("i", {
          key: i,
          class: U(["le-pic", "p" + i])
        }, [
          t[0] || (t[0] = h("i", { class: "sun" }, null, -1)),
          t[1] || (t[1] = h("i", { class: "hill" }, null, -1)),
          i === 2 ? (g(), v("i", lye)) : E("", !0)
        ], 2)), 64)),
        h("i", dye, [
          C(R, {
            name: "Sparkles",
            size: 12
          })
        ]),
        h("i", cye, [
          C(R, {
            name: "Sparkles",
            size: 11
          }),
          t[2] || (t[2] = h("i", { class: "t1" }, null, -1)),
          t[3] || (t[3] = h("i", { class: "t2" }, null, -1)),
          t[4] || (t[4] = h("i", { class: "run" }, null, -1))
        ])
      ], 64)) : n.kind === "uploads" ? (g(), v(H, { key: 1 }, [
        h("i", uye, [
          C(R, {
            name: "Upload",
            size: 14
          })
        ]),
        t[5] || (t[5] = h("i", { class: "le-pic u" }, [
          h("i", { class: "sun" }),
          h("i", { class: "hill" }),
          h("i", { class: "hill b" })
        ], -1)),
        h("i", hye, [
          C(R, {
            name: "Check",
            size: 11
          })
        ])
      ], 64)) : n.kind === "favorites" ? (g(), v(H, { key: 2 }, [
        t[6] || (t[6] = Af('<i class="le-pic f1"><i class="sun"></i><i class="hill"></i></i><i class="le-pic f3"><i class="sun"></i><i class="hill"></i></i><i class="le-pic f2"><i class="sun"></i><i class="hill"></i><i class="hill b"></i></i>', 3)),
        h("i", pye, [
          (g(), v(H, null, me(6, (i) => h("i", {
            key: i,
            class: U("b" + i)
          }, null, 2)), 64))
        ]),
        h("i", fye, [
          C(R, {
            name: "Heart",
            size: 12
          })
        ])
      ], 64)) : (g(), v(H, { key: 3 }, [
        (g(), v(H, null, me(3, (i) => h("i", {
          key: i,
          class: U(["le-ghost", "g" + i])
        }, null, 2)), 64)),
        n.kind === "search" ? (g(), v("i", mye)) : (g(), v(H, { key: 1 }, [
          t[7] || (t[7] = h("i", { class: "le-track t1" }, [
            h("i", { class: "knob" })
          ], -1)),
          t[8] || (t[8] = h("i", { class: "le-track t2" }, [
            h("i", { class: "knob" })
          ], -1))
        ], 64))
      ], 64))
    ], 10, aye));
  }
});
var gye = Object.defineProperty, bye = (n, e, t) => e in n ? gye(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Sa = (n, e, t) => bye(n, typeof e != "symbol" ? e + "" : e, t);
const vye = [
  { id: "generations", label: "Your generations", icon: "Images" },
  { id: "uploads", label: "Uploads", icon: "Upload" },
  { id: "favorites", label: "Favorites", icon: "Heart" }
], pI = 1, fI = 12;
function yye(n) {
  return n >= 1300 ? 6 : n >= 1e3 ? 5 : n >= 760 ? 4 : n >= 480 ? 3 : 2;
}
const mI = "rd-board-library";
function xye() {
  try {
    const n = localStorage.getItem(mI);
    return n ? JSON.parse(n) : {};
  } catch {
    return {};
  }
}
function O_(n) {
  try {
    localStorage.setItem(mI, JSON.stringify(n));
  } catch {
  }
}
const wye = { search: !1, filters: !1, star: !1, remove: !1 };
function kye(n) {
  return /* @__PURE__ */ Xt({
    tab: "generations",
    /** what's typed in the search box */
    searchText: "",
    /** the search in force (two characters or more) */
    search: "",
    /** the filters in force, and the panel's copy being edited */
    filters: {},
    draft: {},
    filtersOpen: !1,
    layout: n.layout || "grid",
    /** chosen columns; 0 until you choose (the view's width decides) */
    columns: n.columns || 0,
    /** picking: a click picks rather than looks */
    selecting: !0,
    /** picked items, in the order picked */
    picked: [],
    /** the item open large, if any */
    peek: null,
    /** starred results (item ids), as far as known */
    favs: /* @__PURE__ */ new Set(),
    /** uploads under way */
    uploading: [],
    tabs: {
      generations: cb(),
      uploads: cb(),
      favorites: cb()
    }
  });
}
class _ye {
  constructor(e, t, i = ["image", "video"]) {
    Sa(this, "shelf", e), Sa(this, "max", t), Sa(this, "kinds", i), Sa(this, "s"), Sa(this, "shown"), Sa(this, "features"), this.features = e ? e.features : wye, this.s = kye(xye()), this.shown = I(() => this.s.tabs[this.s.tab].items);
  }
  /** Can this be picked here: a finished picture of a kind wanted? */
  allowed(e) {
    return !e.moderated && this.kinds.includes(z1e(e));
  }
  tab() {
    return this.s.tabs[this.s.tab];
  }
  /** The query for a tab: Your generations carries the filters and search in force. */
  query(e, t = null) {
    return e !== "generations" ? { cursor: t } : { cursor: t, filters: { ...this.s.filters }, search: this.s.search || void 0 };
  }
  /** Another tab: as in v1, it starts without filters or search. */
  setTab(e) {
    this.s.tab !== e && (this.s.tab = e, this.s.peek = null, this.s.filtersOpen = !1, (this.s.search || cf(this.s.filters)) && (this.s.search = "", this.s.searchText = "", this.s.filters = {}, this.reset("generations")), this.s.tabs[e].loaded || this.load(e));
  }
  /** Start a tab over (its query changed). */
  reset(e) {
    const t = this.s.tabs[e];
    t.items = [], t.next = null, t.loaded = !1, t.failed = !1, t.latched = !1, t.error = "", t.loading = !1, t.version++;
  }
  /** The tab's first page, or (more) its next one. */
  async load(e = this.s.tab, t = !1) {
    const i = this.s.tabs[e];
    if (!this.shelf || i.loading || t && (i.next === null || i.latched)) return;
    const s = i.version;
    i.loading = !0, i.failed = !1;
    try {
      const o = this.query(e, t ? i.next : null), r = await (e === "generations" ? this.shelf.generations(o) : e === "uploads" ? this.shelf.uploads(o) : this.shelf.favorites(o));
      if (i.version !== s) return;
      const a = new Set(t ? i.items.map((d) => d.id) : []), l = r.items.filter((d) => !a.has(d.id));
      for (const d of l) d.fav && this.s.favs.add(d.id);
      i.items = t ? i.items.concat(l) : l, i.next = r.next, i.loaded = !0;
    } catch (o) {
      if (i.version !== s) return;
      console.warn("[board] your Library could not be loaded", o), i.failed = !0, i.latched = t, i.error = db(o);
    } finally {
      i.version === s && (i.loading = !1);
    }
  }
  /** Ask again after a page failed. */
  retry() {
    const e = this.tab();
    e.latched = !1, this.load(this.s.tab, e.loaded);
  }
  /** Which of your results are starred, to mark them on every tab. */
  async loadFavs() {
    if (!(!this.shelf || !this.shelf.favoriteKeys))
      try {
        for (const e of await this.shelf.favoriteKeys()) this.s.favs.add(e);
      } catch (e) {
        console.warn("[board] your favorites could not be read", e);
      }
  }
  // ------------------------------------------------------------ search and filters
  /** The words in the box, in force (the box waits for a pause, or Enter). */
  commitSearch() {
    const e = Xf(this.s.searchText);
    e !== this.s.search && (this.s.search = e, this.s.tab !== "generations" && (this.s.tab = "generations"), this.reset("generations"), this.load("generations"));
  }
  clearSearch() {
    this.s.searchText = "", this.commitSearch();
  }
  openFilters() {
    this.s.draft = { ...this.s.filters }, this.s.filtersOpen = !0;
  }
  /** The panel's Cancel: back to what's in force. */
  cancelFilters() {
    this.s.draft = { ...this.s.filters }, this.s.filtersOpen = !1;
  }
  /** Apply filters (the panel's draft, or these): Your generations starts over with them; the search stays. */
  applyFilters(e = this.s.draft) {
    const t = {};
    for (const [i, s] of Object.entries(e))
      s && (t[i] = s);
    this.s.filters = t, this.s.draft = { ...t }, this.s.filtersOpen = !1, this.s.tab !== "generations" && (this.s.tab = "generations"), this.reset("generations"), this.load("generations");
  }
  /** One filter off (a chip's ×). */
  dropFilter(e) {
    const t = { ...this.s.filters };
    e === "dates" ? (delete t.from, delete t.to) : delete t[e], this.applyFilters(t);
  }
  filtersOn() {
    return cf(this.s.filters);
  }
  // ------------------------------------------------------------ layout
  setLayout(e) {
    this.s.layout = e, O_({ layout: e, columns: this.s.columns || void 0 });
  }
  setColumns(e) {
    this.s.columns = Math.max(pI, Math.min(fI, Math.round(e))), O_({ layout: this.s.layout, columns: this.s.columns });
  }
  // ------------------------------------------------------------ picking
  /** Its place in the picks (1 first), or 0. */
  order(e) {
    return this.s.picked.findIndex((t) => t.id === e) + 1;
  }
  /** Pick or unpick; false when it can't be picked here, or the picks are full. */
  toggle(e) {
    return this.order(e.id) ? (this.s.picked = this.s.picked.filter((t) => t.id !== e.id), !0) : !this.allowed(e) || this.s.picked.length >= this.max ? !1 : (this.s.picked = [...this.s.picked, e], !0);
  }
  /** Pick every shown picture that can be, up to the limit, after what's already picked. */
  pickAll() {
    let e = 0;
    for (const t of this.shown.value) {
      if (this.s.picked.length >= this.max) break;
      this.order(t.id) || !this.allowed(t) || (this.s.picked = [...this.s.picked, t], e++);
    }
    return e;
  }
  clear() {
    this.s.picked = [];
  }
  full() {
    return this.s.picked.length >= this.max;
  }
  // ------------------------------------------------------------ stars, deletes, uploads
  faved(e) {
    return this.s.favs.has(e.id);
  }
  /** Can you star it: one of your finished generations, where the Library can star. */
  canStar(e) {
    return !!this.shelf && !!this.shelf.setFavorite && this.features.star && !!e.run && !!e.mine && !e.moderated;
  }
  /** Star or unstar, shown at once; undone, with the reason, if it's refused. */
  async star(e, t) {
    if (!this.canStar(e)) return null;
    const i = this.faved(e);
    this.markFav(e, t);
    try {
      return await this.shelf.setFavorite(e, t), null;
    } catch (s) {
      return this.markFav(e, i), db(s) || "Could not change the favorite, please try again";
    }
  }
  markFav(e, t) {
    const i = new Set(this.s.favs);
    t ? i.add(e.id) : i.delete(e.id), this.s.favs = i;
    const s = this.s.tabs.favorites;
    t && s.loaded && !s.items.some((o) => o.id === e.id) && (s.items = [{ ...e, fav: !0 }, ...s.items]), t || (s.items = s.items.filter((o) => o.id !== e.id));
  }
  canRemove(e) {
    return !!this.shelf && !!this.shelf.remove && this.features.remove && !!e.mine;
  }
  /** Delete it: gone from every tab and the picks at once; back, with the reason, if it's refused. */
  async remove(e) {
    if (!this.canRemove(e)) return null;
    const t = Object.keys(this.s.tabs).map((s) => [s, this.s.tabs[s].items]), i = this.s.picked;
    for (const s of Object.keys(this.s.tabs)) this.s.tabs[s].items = this.s.tabs[s].items.filter((o) => o.id !== e.id);
    this.s.picked = this.s.picked.filter((s) => s.id !== e.id), this.s.peek && this.s.peek.id === e.id && (this.s.peek = null);
    try {
      return await this.shelf.remove(e), null;
    } catch (s) {
      for (const [o, r] of t) this.s.tabs[o].items = r;
      return this.s.picked = i, db(s) || "Issues deleting image, please try again";
    }
  }
  uploadStarted(e, t) {
    this.s.uploading = [...this.s.uploading, { id: e, name: t }];
  }
  /** An upload landed: first in Uploads, and picked if there's room. */
  uploadDone(e, t) {
    if (this.s.uploading = this.s.uploading.filter((s) => s.id !== e), !t) return;
    const i = this.s.tabs.uploads;
    i.items = [t, ...i.items.filter((s) => s.id !== t.id)], this.s.selecting && !this.order(t.id) && this.allowed(t) && !this.full() && (this.s.picked = [...this.s.picked, t]);
  }
}
function db(n) {
  const e = n && typeof n == "object" ? n.userMessage : void 0;
  return typeof e == "string" ? e : "";
}
function cb() {
  return { items: [], next: null, loading: !1, loaded: !1, failed: !1, error: "", latched: !1, version: 0 };
}
const Sye = {
  class: "lb-shell",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "Your Library"
}, Tye = { class: "lb-head" }, Mye = { class: "lb-row is-top" }, Cye = { class: "lb-mark" }, Iye = { class: "lb-title" }, Aye = {
  key: 0,
  class: "bd-spinner is-sm"
}, Pye = { key: 2 }, Eye = {
  key: 1,
  class: "lb-grow"
}, Rye = { class: "lb-row is-bar" }, zye = {
  class: "lb-tabs",
  role: "tablist",
  "aria-label": "Library"
}, $ye = ["aria-selected", "data-testid", "onClick"], Dye = ["aria-expanded", "title"], Oye = {
  key: 0,
  class: "n"
}, Lye = {
  class: "lb-seg",
  role: "radiogroup",
  "aria-label": "Layout"
}, Bye = ["aria-checked", "title", "data-testid", "onClick"], Fye = {
  key: 1,
  class: "lb-cols",
  title: "Number of columns"
}, Nye = ["disabled"], Uye = { "data-testid": "library-cols" }, Gye = ["disabled"], jye = ["aria-pressed", "title"], Hye = {
  key: 1,
  class: "lb-applied",
  "data-testid": "library-applied"
}, Vye = {
  key: 0,
  class: "lb-applied-chip is-search"
}, Wye = ["title", "onClick"], qye = {
  key: 2,
  class: "lb-applied-note"
}, Kye = {
  key: 1,
  class: "lb-empty",
  "data-testid": "library-failed"
}, Yye = { class: "lb-empty-mark is-warn" }, Xye = {
  key: 2,
  class: "lb-empty",
  "data-testid": "library-no-match"
}, Jye = {
  key: 3,
  class: "lb-empty",
  "data-testid": "library-no-match"
}, Zye = {
  key: 4,
  class: "lb-empty",
  "data-testid": "library-empty"
}, Qye = {
  key: 0,
  class: "lb-empty-hint"
}, exe = { class: "key" }, txe = { class: "ic" }, nxe = { class: "lb-frame" }, ixe = { class: "lb-uploading" }, sxe = ["title", "onClick", "onDblclick"], oxe = { class: "lb-frame" }, rxe = {
  key: 0,
  class: "lb-withheld"
}, axe = ["src"], lxe = { class: "lb-info" }, dxe = { class: "p" }, cxe = {
  key: 0,
  class: "m"
}, uxe = {
  key: 0,
  class: "lb-row-text"
}, hxe = { class: "p" }, pxe = { class: "m" }, fxe = {
  key: 1,
  class: "lb-badge is-video"
}, mxe = {
  key: 2,
  class: "lb-badge is-3d"
}, gxe = ["title", "aria-pressed", "onClick"], bxe = {
  key: 4,
  class: "lb-star on is-still"
}, vxe = ["aria-label", "aria-pressed", "onClick"], yxe = { key: 0 }, xxe = ["onClick"], wxe = {
  key: 6,
  class: "lb-more"
}, kxe = {
  key: 7,
  class: "lb-more is-failed",
  "data-testid": "library-more-failed"
}, _xe = {
  key: 8,
  class: "lb-more"
}, Sxe = {
  key: 9,
  class: "lb-end"
}, Txe = {
  key: 0,
  class: "lb-tray",
  "data-testid": "library-tray"
}, Mxe = { class: "lb-tray-picks" }, Cxe = { class: "lb-tray-count" }, Ixe = ["disabled"], Axe = {
  key: 2,
  class: "lb-dropping"
}, zi = 12, Ta = 108, Pxe = /* @__PURE__ */ Re({
  __name: "LibraryView",
  setup(n) {
    const { board: e } = tt(), t = e.ui.libraryOpen, i = t.kinds || (t.purpose === "place" ? ["image", "video", "3d"] : ["image", "video"]), s = new _ye(e.libraryShelf, t.max, i), o = s.s, r = t.purpose === "place", a = t.max === 1, l = !!e.uploader, d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(null), u = /* @__PURE__ */ K(null), p = /* @__PURE__ */ K(1100), f = /* @__PURE__ */ K(700), y = /* @__PURE__ */ K(0), b = /* @__PURE__ */ K(null), { active: w, over: k, leave: S, stop: _ } = Oy(() => l), x = /* @__PURE__ */ K(null), T = /* @__PURE__ */ K(!1);
    let M = 0;
    const z = [
      { id: "grid", label: "Grid", icon: "Grid3x3" },
      { id: "masonry", label: "Masonry", icon: "LayoutDashboard" },
      { id: "list", label: "Details", icon: "Rows3" }
    ], P = I(() => o.tabs[o.tab]), D = I(() => s.shown.value), $ = I(() => o.layout === "list" ? 1 : o.columns || yye(p.value)), O = I(() => Math.floor((p.value - zi * ($.value - 1)) / $.value)), L = I(() => a || o.selecting), Z = I(() => {
      const le = [];
      if (o.tab === "uploads" && l) {
        le.push({ kind: "upload", key: "(upload)" });
        for (const ve of o.uploading) le.push({ kind: "uploading", name: ve.name, key: "up-" + ve.id });
      }
      for (const ve of D.value) le.push({ kind: "item", it: ve, key: ve.id });
      return le;
    }), J = I(() => {
      const le = $.value, ve = O.value, we = [];
      if (o.layout === "list")
        return Z.value.forEach((Se, Te) => we.push({ e: Se, x: 0, y: Te * (Ta + 8), w: p.value, h: Ta })), { cells: we, height: Z.value.length ? Z.value.length * (Ta + 8) - 8 : 0 };
      if (o.layout === "grid") {
        Z.value.forEach((Te, ae) => we.push({ e: Te, x: ae % le * (ve + zi), y: Math.floor(ae / le) * (ve + zi), w: ve, h: ve }));
        const Se = Math.ceil(Z.value.length / le);
        return { cells: we, height: Se ? Se * (ve + zi) - zi : 0 };
      }
      const je = new Array(le).fill(0);
      for (const Se of Z.value) {
        let Te = 0;
        for (let Rt = 1; Rt < le; Rt++) je[Rt] < je[Te] - 1 && (Te = Rt);
        const ae = Se.kind === "item" ? Se.it : null, Me = ae && ae.w && ae.h ? ae.h / ae.w : 1, Xe = Math.round(ve * Math.max(0.45, Math.min(2.2, Me)));
        we.push({ e: Se, x: Te * (ve + zi), y: je[Te], w: ve, h: Xe }), je[Te] += Xe + zi;
      }
      return { cells: we, height: Math.max(0, ...je) - zi };
    }), re = I(() => {
      const le = y.value - 900, ve = y.value + f.value + 900;
      return J.value.cells.filter((we) => we.y + we.h >= le && we.y <= ve);
    }), F = I(() => !!o.search), W = I(() => !P.value.loaded && !P.value.failed), ee = I(() => P.value.loaded && !Z.value.length && !P.value.loading), N = I(() => o.tab === "generations" && (F.value || s.filtersOn() > 0)), te = I(() => {
      const le = o.picked.length;
      return t.confirmLabel ? t.confirmLabel : r ? le === 1 ? "Place on board" : "Place " + (le || "") + " on board" : le === 1 ? "Use image" : "Use " + (le || "") + " images";
    }), G = {
      generations: { title: "No generations yet", sub: "Everything you make, in any session on any board, collects here." },
      uploads: { title: "No uploads yet", sub: "Images you bring in collect here." },
      favorites: { title: "No favorites yet", sub: "Tap the heart on any of your generations to add it to your favorites." }
    }, q = I(() => {
      const le = /* @__PURE__ */ new Map();
      for (const ve of e.catalog.value.kits) for (const we of ve.models) le.set(we.id, we.name);
      return le;
    });
    function B(le) {
      return le.model || le.run && q.value.get(le.run.nodeDefId) || "";
    }
    function ne(le) {
      return [B(le), le.createdAt ? Jn(le.createdAt) : ""].filter(Boolean).join(" · ");
    }
    function se(le) {
      return le.thumb || Wt(le.url);
    }
    const Y = I(() => x.value && x.value.tools.length ? x.value.tools : Array.from(q.value.entries()).map(([le, ve]) => ({ value: le, text: ve })).sort((le, ve) => le.text.localeCompare(ve.text))), ie = I(() => x.value ? { ...x.value, tools: Y.value } : null), De = I(() => {
      const le = o.filters, ve = x.value, we = (Se, Te) => {
        var ae;
        return Se && ((ae = Se.find((Me) => Me.value === Te)) == null ? void 0 : ae.text) || Te;
      }, je = [];
      return le.favorited && je.push({ key: "favorited", label: "Favorited" }), le.aspect && je.push({ key: "aspect", label: we(cI, le.aspect) }), le.resolution && je.push({ key: "resolution", label: we(uI, le.resolution) }), le.tool && je.push({ key: "tool", label: we(Y.value, le.tool) }), le.family && je.push({ key: "family", label: we(ve == null ? void 0 : ve.families, le.family) }), le.media && je.push({ key: "media", label: we(ve == null ? void 0 : ve.media, le.media) }), le.board && je.push({ key: "board", label: we(ve == null ? void 0 : ve.boards, le.board) }), (le.from || le.to) && je.push({ key: "dates", label: (le.from ? xe(le.from) : "…") + " → " + (le.to ? xe(le.to) : "…") }), je;
    });
    function xe(le) {
      const [ve, we, je] = le.split("-").map(Number);
      return new Date(ve, we - 1, je).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
    function Oe(le, ve) {
      clearTimeout(M), b.value = { id: Date.now(), text: le, tone: ve }, M = window.setTimeout(() => {
        b.value = null;
      }, ve ? 5e3 : 2400);
    }
    function Ee() {
      e.closeLibrary();
    }
    function j(le) {
      o.tab !== le && (s.setTab(le), V());
    }
    function V() {
      d.value && (d.value.scrollTop = 0), y.value = 0;
    }
    function Q(le, ve) {
      if (le.moderated || !L.value || ve.altKey) {
        o.peek = le;
        return;
      }
      oe(le);
    }
    function oe(le) {
      if (!le.moderated) {
        if (!s.allowed(le)) {
          const ve = i, we = { image: "images", video: "videos", "3d": "3D models" };
          Oe(ve.length === 1 ? "Only " + we[ve[0]] + " can be used here" : (le.model3d ? "3D models" : le.video ? "Videos" : "Images") + " can't be used here");
          return;
        }
        if (a) {
          s.s.picked = [le], ue();
          return;
        }
        s.toggle(le) || Oe("You can pick " + t.max + (t.max === 1 ? " picture" : " pictures") + " at most: unpick one first");
      }
    }
    function ue() {
      const le = o.picked.slice();
      le.length && (r ? e.placeFromLibrary(le, t.at) : t.onPick && t.onPick(le), Ee());
    }
    async function Ie(le) {
      const ve = await s.star(le, !s.faved(le));
      ve && Oe(ve, "error");
    }
    async function he(le) {
      const ve = await s.remove(le);
      if (ve) {
        Oe(ve, "error");
        return;
      }
      e.forgetLibraryItem(le), Oe(le.uploadId ? "Upload deleted" : "Generation deleted");
    }
    function ye() {
      if (o.filtersOpen) {
        s.cancelFilters();
        return;
      }
      s.openFilters(), fe();
    }
    async function fe() {
      const le = e.libraryShelf;
      if (!(x.value || T.value)) {
        if (!le || !le.filterOptions) {
          x.value = { tools: [], families: [], media: [], boards: [] };
          return;
        }
        T.value = !0;
        try {
          x.value = await le.filterOptions(e.meta.teamId);
        } catch (ve) {
          console.warn("[board] the Library's filter options are unavailable", ve), x.value = { tools: [], families: [], media: [], boards: [] };
        } finally {
          T.value = !1;
        }
      }
    }
    function ze(le) {
      s.setColumns($.value + le);
    }
    function He(le) {
      return new Promise((ve) => {
        const we = new Image();
        we.onload = () => ve({ w: we.naturalWidth || 4, h: we.naturalHeight || 3 }), we.onerror = () => ve({ w: 4, h: 3 }), we.src = le;
      });
    }
    async function ce(le) {
      const ve = le.filter((we) => we.type.startsWith("image/")).slice(0, 24);
      !ve.length || !l || (o.tab !== "uploads" && j("uploads"), await Promise.all(ve.map(async (we) => {
        const je = kt();
        s.uploadStarted(je, we.name);
        try {
          const Se = URL.createObjectURL(we), Te = await He(Se), ae = await e.uploadFile(we);
          ae.url !== Se && URL.revokeObjectURL(Se);
          const Me = ae.asset && "upload" in ae.asset ? ae.asset.upload : null;
          s.uploadDone(je, {
            id: "upload:" + (Me && Me.id ? Me.id : je),
            url: ae.url,
            w: Te.w,
            h: Te.h,
            video: !1,
            label: we.name,
            createdAt: Date.now(),
            mine: !0,
            uploadId: Me && Me.id ? Me.id : void 0,
            asset: ae.asset || { upload: { name: we.name } }
          });
        } catch (Se) {
          s.uploadDone(je, null);
          const Te = Se ? Se.userMessage : void 0;
          Oe(Te || we.name + " could not be uploaded.", "error");
        }
      })));
    }
    function be(le) {
      const ve = le.target, we = Array.from(ve.files || []);
      ve.value = "", ce(we);
    }
    function Be(le) {
      k(le) && le.preventDefault();
    }
    function Fe(le) {
      _(), !(!le.dataTransfer || !l) && (le.preventDefault(), ce(Array.from(le.dataTransfer.files || [])));
    }
    let Ke = null;
    function Qe() {
      if (!d.value) return;
      const le = getComputedStyle(d.value), ve = parseFloat(le.paddingLeft) + parseFloat(le.paddingRight);
      p.value = Math.max(280, d.value.clientWidth - ve), f.value = d.value.clientHeight;
    }
    function ht() {
      const le = d.value;
      le && (y.value = le.scrollTop, le.scrollHeight - le.scrollTop - le.clientHeight < 700 && s.load(o.tab, !0));
    }
    let Le = 0;
    $e(() => o.searchText, () => {
      clearTimeout(Le), Le = window.setTimeout(() => {
        s.commitSearch(), V();
      }, 300);
    }), $e(() => o.filters, V), $e(() => [J.value.height, P.value.loading], () => {
      it(() => {
        const le = P.value;
        d.value && !le.loading && le.loaded && le.next !== null && !le.latched && J.value.height < f.value + 400 && s.load(o.tab, !0);
      });
    });
    function Ne(le) {
      const ve = le.target;
      if (ve && ve.closest && ve.closest("[data-lb-own-keys]")) return;
      const we = !!ve && (ve.tagName === "INPUT" || ve.tagName === "TEXTAREA");
      if (le.key === "Escape") {
        le.preventDefault(), le.stopPropagation(), o.peek ? o.peek = null : o.filtersOpen ? s.cancelFilters() : we && o.searchText ? s.clearSearch() : we ? ve.blur() : Ee();
        return;
      }
      if (!o.peek) {
        if (le.key === "Enter" && we && ve === c.value) {
          le.preventDefault(), clearTimeout(Le), s.commitSearch();
          return;
        }
        if (le.key === "/" && !we && c.value) {
          le.preventDefault(), c.value.focus();
          return;
        }
        we || (le.key === "Enter" && o.picked.length && !a ? (le.preventDefault(), ue()) : vn(le) && le.key.toLowerCase() === "a" && L.value && !a && (le.preventDefault(), !s.pickAll() && s.full() && Oe("That's as many as you can pick")));
      }
    }
    return ot(() => {
      s.load("generations"), s.loadFavs(), Qe(), d.value && (Ke = new ResizeObserver(Qe), Ke.observe(d.value)), window.addEventListener("keydown", Ne, !0), it(() => {
        c.value && c.value.focus({ preventScroll: !0 });
      });
    }), Ve(() => {
      Ke && Ke.disconnect(), window.removeEventListener("keydown", Ne, !0), clearTimeout(M), clearTimeout(Le);
    }), (le, ve) => (g(), v("div", {
      class: "lb-backdrop",
      "data-testid": "library",
      onPointerdown: Pe(Ee, ["self"]),
      onDragover: Be,
      onDragleave: ve[16] || (ve[16] = //@ts-ignore
      (...we) => m(S) && m(S)(...we)),
      onDrop: Fe
    }, [
      h("div", Sye, [
        h("header", Tye, [
          ve[21] || (ve[21] = h("span", {
            class: "lb-glow",
            "aria-hidden": "true"
          }, null, -1)),
          h("div", Mye, [
            h("span", Cye, [
              C(R, {
                name: "Library",
                size: 17
              })
            ]),
            h("div", Iye, [
              ve[17] || (ve[17] = h("b", null, "Library", -1)),
              h("span", null, A(m($1e)(m(i), m(t).max, r)), 1)
            ]),
            m(s).features.search ? (g(), v("label", {
              key: 0,
              class: U(["lb-search", { "has-words": !!m(o).searchText }])
            }, [
              C(R, {
                name: "Search",
                size: 15
              }),
              xt(h("input", {
                ref_key: "searchEl",
                ref: c,
                "onUpdate:modelValue": ve[0] || (ve[0] = (we) => m(o).searchText = we),
                type: "text",
                spellcheck: "false",
                placeholder: "Search your Library",
                "aria-label": "Search your Library",
                "data-testid": "library-search"
              }, null, 512), [
                [Jt, m(o).searchText]
              ]),
              F.value && P.value.loading ? (g(), v("span", Aye)) : E("", !0),
              m(o).searchText ? (g(), v("button", {
                key: 1,
                class: "lb-search-clear",
                title: "Clear",
                onClick: ve[1] || (ve[1] = (we) => m(s).clearSearch())
              }, [
                C(R, {
                  name: "X",
                  size: 12
                })
              ])) : (g(), v("kbd", Pye, "/"))
            ], 2)) : (g(), v("span", Eye)),
            h("button", {
              class: "lb-close",
              title: "Close (Esc)",
              "data-testid": "library-close",
              onClick: Ee
            }, [
              C(R, {
                name: "X",
                size: 16
              })
            ])
          ]),
          h("div", Rye, [
            h("nav", zye, [
              (g(!0), v(H, null, me(m(vye), (we) => (g(), v("button", {
                key: we.id,
                role: "tab",
                "aria-selected": m(o).tab === we.id,
                class: U({ on: m(o).tab === we.id }),
                "data-testid": "library-tab-" + we.id,
                onClick: (je) => j(we.id)
              }, [
                C(R, {
                  name: we.icon,
                  size: 14
                }, null, 8, ["name"]),
                X(" " + A(we.label), 1)
              ], 10, $ye))), 128))
            ]),
            ve[20] || (ve[20] = h("span", { class: "lb-grow" }, null, -1)),
            m(s).features.filters && m(o).tab === "generations" ? (g(), v("button", {
              key: 0,
              class: U(["lb-tool", { on: m(o).filtersOpen, "is-set": m(s).filtersOn() > 0 }]),
              "aria-expanded": m(o).filtersOpen,
              title: m(o).filtersOpen ? "Hide filters" : "Show filters",
              "data-testid": "library-filter-toggle",
              onClick: ye
            }, [
              C(R, {
                name: "SlidersHorizontal",
                size: 14
              }),
              ve[18] || (ve[18] = X(" Filters ", -1)),
              m(s).filtersOn() ? (g(), v("span", Oye, A(m(s).filtersOn()), 1)) : E("", !0)
            ], 10, Dye)) : E("", !0),
            h("div", Lye, [
              (g(), v(H, null, me(z, (we) => h("button", {
                key: we.id,
                role: "radio",
                "aria-checked": m(o).layout === we.id,
                class: U({ on: m(o).layout === we.id }),
                title: we.label,
                "data-testid": "library-layout-" + we.id,
                onClick: (je) => m(s).setLayout(we.id)
              }, [
                C(R, {
                  name: we.icon,
                  size: 14
                }, null, 8, ["name"])
              ], 10, Bye)), 64))
            ]),
            m(o).layout !== "list" ? (g(), v("div", Fye, [
              h("button", {
                disabled: $.value <= m(pI),
                "aria-label": "Fewer columns",
                "data-testid": "library-cols-less",
                onClick: ve[2] || (ve[2] = (we) => ze(-1))
              }, [
                C(R, {
                  name: "Minus",
                  size: 12
                })
              ], 8, Nye),
              h("span", Uye, [
                h("b", null, A($.value), 1),
                C(R, {
                  name: "Columns3",
                  size: 12
                })
              ]),
              h("button", {
                disabled: $.value >= m(fI),
                "aria-label": "More columns",
                "data-testid": "library-cols-more",
                onClick: ve[3] || (ve[3] = (we) => ze(1))
              }, [
                C(R, {
                  name: "Plus",
                  size: 12
                })
              ], 8, Gye)
            ])) : E("", !0),
            a ? E("", !0) : (g(), v("button", {
              key: 2,
              class: U(["lb-select", { on: m(o).selecting }]),
              "aria-pressed": m(o).selecting,
              title: m(o).selecting ? "Selection mode: a click picks. Turn off to look at pictures large" : "Turn on selection mode to pick pictures",
              "data-testid": "library-selecting",
              onClick: ve[4] || (ve[4] = (we) => m(o).selecting = !m(o).selecting)
            }, [...ve[19] || (ve[19] = [
              h("span", { class: "sw" }, [
                h("i")
              ], -1),
              X(" Select ", -1)
            ])], 10, jye))
          ])
        ]),
        m(o).filtersOpen ? (g(), Ce(rye, {
          key: 0,
          lib: m(s),
          options: ie.value,
          loading: T.value
        }, null, 8, ["lib", "options", "loading"])) : N.value ? (g(), v("div", Hye, [
          F.value ? (g(), v("span", Vye, [
            C(R, {
              name: "Search",
              size: 12
            }),
            X(" “" + A(m(o).search) + "” ", 1),
            h("button", {
              title: "Clear the search",
              onClick: ve[5] || (ve[5] = (we) => m(s).clearSearch())
            }, [
              C(R, {
                name: "X",
                size: 11
              })
            ])
          ])) : E("", !0),
          (g(!0), v(H, null, me(De.value, (we) => (g(), v("span", {
            key: we.key,
            class: "lb-applied-chip"
          }, [
            X(A(we.label) + " ", 1),
            h("button", {
              title: "Remove " + we.label,
              onClick: (je) => m(s).dropFilter(we.key)
            }, [
              C(R, {
                name: "X",
                size: 11
              })
            ], 8, Wye)
          ]))), 128)),
          De.value.length ? (g(), v("button", {
            key: 1,
            class: "lb-link",
            onClick: ve[6] || (ve[6] = (we) => m(s).applyFilters({}))
          }, "Clear filters")) : E("", !0),
          ve[22] || (ve[22] = h("span", { class: "lb-grow" }, null, -1)),
          F.value ? (g(), v("span", qye, "Best matches first")) : E("", !0)
        ])) : E("", !0),
        h("main", {
          ref_key: "body",
          ref: d,
          class: U(["lb-body", "is-" + m(o).layout]),
          "data-testid": "library-body",
          onScroll: ht
        }, [
          W.value ? (g(), v("div", {
            key: 0,
            class: "lb-wall",
            style: de({ height: (m(o).layout === "list" ? 6 * (Ta + 8) : Math.ceil(18 / $.value) * (O.value + zi)) + "px" })
          }, [
            (g(!0), v(H, null, me(m(o).layout === "list" ? 6 : Math.min(18, $.value * 3), (we) => (g(), v("span", {
              key: we,
              class: "lb-skel",
              style: de(m(o).layout === "list" ? { left: "0px", top: (we - 1) * (Ta + 8) + "px", width: p.value + "px", height: Ta + "px", animationDelay: we % 6 * 70 + "ms" } : { left: (we - 1) % $.value * (O.value + zi) + "px", top: Math.floor((we - 1) / $.value) * (O.value + zi) + "px", width: O.value + "px", height: O.value + "px", animationDelay: we % 6 * 70 + "ms" })
            }, null, 4))), 128))
          ], 4)) : P.value.failed && !P.value.loaded ? (g(), v("div", Kye, [
            h("span", Yye, [
              C(R, {
                name: "AlertCircle",
                size: 20
              })
            ]),
            ve[24] || (ve[24] = h("b", null, "Your Library couldn't be loaded", -1)),
            h("span", null, A(P.value.error || "Check your connection, then try again."), 1),
            h("button", {
              class: "lb-btn",
              onClick: ve[7] || (ve[7] = (we) => m(s).retry())
            }, [
              C(R, {
                name: "RotateCcw",
                size: 14
              }),
              ve[23] || (ve[23] = X(" Try again", -1))
            ])
          ])) : ee.value && F.value ? (g(), v("div", Xye, [
            C(lb, { kind: "search" }),
            ve[25] || (ve[25] = h("b", null, "No results match your search.", -1)),
            h("span", null, "Try other words" + A(m(s).filtersOn() ? ", or fewer filters" : "") + ".", 1),
            h("button", {
              class: "lb-btn",
              onClick: ve[8] || (ve[8] = (we) => m(s).clearSearch())
            }, "Clear search")
          ])) : ee.value && N.value ? (g(), v("div", Jye, [
            C(lb, { kind: "filters" }),
            ve[26] || (ve[26] = h("b", null, "Nothing matches these filters", -1)),
            ve[27] || (ve[27] = h("span", null, "Loosen one, or clear them all.", -1)),
            h("button", {
              class: "lb-btn",
              onClick: ve[9] || (ve[9] = (we) => m(s).applyFilters({}))
            }, "Clear filters")
          ])) : ee.value ? (g(), v("div", Zye, [
            C(lb, {
              kind: m(o).tab
            }, null, 8, ["kind"]),
            h("b", null, A(G[m(o).tab].title), 1),
            h("span", null, A(G[m(o).tab].sub), 1),
            m(o).tab === "favorites" ? (g(), v("span", Qye, [
              ve[28] || (ve[28] = X("Look for ", -1)),
              h("span", exe, [
                C(R, {
                  name: "Heart",
                  size: 11
                })
              ]),
              ve[29] || (ve[29] = X(" on any generation", -1))
            ])) : E("", !0)
          ])) : (g(), v("div", {
            key: 5,
            class: "lb-wall",
            style: de({ height: J.value.height + "px" })
          }, [
            (g(!0), v(H, null, me(re.value, (we) => (g(), v(H, {
              key: we.e.key
            }, [
              we.e.kind === "upload" ? (g(), v("button", {
                key: 0,
                class: U(["lb-upload-tile", { "is-list": m(o).layout === "list" }]),
                style: de({ left: we.x + "px", top: we.y + "px", width: we.w + "px", height: we.h + "px" }),
                "data-testid": "library-upload",
                onClick: ve[10] || (ve[10] = (je) => u.value && u.value.click())
              }, [
                h("span", txe, [
                  C(R, {
                    name: "Upload",
                    size: 18
                  })
                ]),
                ve[30] || (ve[30] = h("b", null, "Upload images", -1)),
                ve[31] || (ve[31] = h("span", null, "or drop them here", -1))
              ], 6)) : we.e.kind === "uploading" ? (g(), v("div", {
                key: 1,
                class: U(["lb-cell is-uploading", { "is-list": m(o).layout === "list" }]),
                style: de({ left: we.x + "px", top: we.y + "px", width: we.w + "px", height: we.h + "px" })
              }, [
                h("span", nxe, [
                  h("span", ixe, [
                    ve[32] || (ve[32] = h("span", { class: "bd-spinner is-sm" }, null, -1)),
                    X(" " + A(we.e.name), 1)
                  ])
                ])
              ], 6)) : (g(), v("div", {
                key: 2,
                class: U(["lb-cell", {
                  "is-list": m(o).layout === "list",
                  "is-picked": m(s).order(we.e.it.id) > 0,
                  "is-off": L.value && !we.e.it.moderated && (!m(s).allowed(we.e.it) || m(s).full() && !m(s).order(we.e.it.id) && !a),
                  "is-selecting": L.value,
                  "is-moderated": !!we.e.it.moderated
                }]),
                style: de({ left: we.x + "px", top: we.y + "px", width: we.w + "px", height: we.h + "px" }),
                title: we.e.it.moderated ? "Moderated by RunDiffusion" : we.e.it.prompt || we.e.it.label,
                "data-testid": "library-item",
                onClick: (je) => Q(we.e.it, je),
                onDblclick: (je) => m(o).peek = we.e.it
              }, [
                h("span", oxe, [
                  we.e.it.moderated ? (g(), v("span", rxe, [
                    C(R, {
                      name: "EyeOff",
                      size: 16
                    }),
                    ve[33] || (ve[33] = h("b", null, "Moderated", -1))
                  ])) : (g(), v("img", {
                    key: 1,
                    src: se(we.e.it),
                    alt: "",
                    loading: "lazy",
                    draggable: "false",
                    onLoad: ve[11] || (ve[11] = (je) => je.target.classList.add("is-in"))
                  }, null, 40, axe)),
                  m(o).layout !== "list" ? (g(), v(H, { key: 2 }, [
                    ve[34] || (ve[34] = h("span", {
                      class: "lb-shade",
                      "aria-hidden": "true"
                    }, null, -1)),
                    h("span", lxe, [
                      h("span", dxe, A(we.e.it.prompt || we.e.it.label), 1),
                      ne(we.e.it) ? (g(), v("span", cxe, A(ne(we.e.it)), 1)) : E("", !0)
                    ])
                  ], 64)) : E("", !0)
                ]),
                m(o).layout === "list" ? (g(), v("span", uxe, [
                  h("span", hxe, A(we.e.it.moderated ? "Moderated by RunDiffusion" : we.e.it.prompt || we.e.it.label), 1),
                  h("span", pxe, [
                    B(we.e.it) ? (g(), v(H, { key: 0 }, [
                      X(A(B(we.e.it)) + " · ", 1)
                    ], 64)) : E("", !0),
                    X(A(we.e.it.createdAt ? m(Jn)(we.e.it.createdAt) : ""), 1),
                    we.e.it.w && we.e.it.h ? (g(), v(H, { key: 1 }, [
                      X(" · " + A(we.e.it.w) + " × " + A(we.e.it.h), 1)
                    ], 64)) : E("", !0)
                  ])
                ])) : E("", !0),
                we.e.it.video ? (g(), v("span", fxe, [
                  C(R, {
                    name: "Play",
                    size: 9
                  }),
                  ve[35] || (ve[35] = X(" Video", -1))
                ])) : we.e.it.model3d ? (g(), v("span", mxe, [
                  C(R, {
                    name: "Box",
                    size: 9
                  }),
                  ve[36] || (ve[36] = X(" 3D", -1))
                ])) : E("", !0),
                m(s).canStar(we.e.it) ? (g(), v("button", {
                  key: 3,
                  class: U(["lb-star", { on: m(s).faved(we.e.it) }]),
                  title: m(s).faved(we.e.it) ? "Remove from your favorites" : "Add to your favorites",
                  "aria-pressed": m(s).faved(we.e.it),
                  "data-testid": "library-star",
                  onClick: Pe((je) => Ie(we.e.it), ["stop"])
                }, [
                  C(R, {
                    name: "Heart",
                    size: 13
                  })
                ], 10, gxe)) : m(s).faved(we.e.it) ? (g(), v("span", bxe, [
                  C(R, {
                    name: "Heart",
                    size: 13
                  })
                ])) : E("", !0),
                L.value && !we.e.it.moderated ? (g(), v("button", {
                  key: 5,
                  class: U(["lb-check", { on: m(s).order(we.e.it.id) > 0, "is-single": a }]),
                  "aria-label": m(s).order(we.e.it.id) ? "Unpick" : "Pick",
                  "aria-pressed": m(s).order(we.e.it.id) > 0,
                  onClick: Pe((je) => oe(we.e.it), ["stop"])
                }, [
                  m(s).order(we.e.it.id) ? (g(), v("span", yxe, A(m(s).order(we.e.it.id)), 1)) : (g(), Ce(R, {
                    key: 1,
                    name: a ? "Check" : "Plus",
                    size: 13
                  }, null, 8, ["name"]))
                ], 10, vxe)) : we.e.it.moderated ? E("", !0) : (g(), v("button", {
                  key: 6,
                  class: "lb-look",
                  title: "Look at it large",
                  onClick: Pe((je) => m(o).peek = we.e.it, ["stop"])
                }, [
                  C(R, {
                    name: "Maximize2",
                    size: 12
                  })
                ], 8, xxe))
              ], 46, sxe))
            ], 64))), 128))
          ], 4)),
          P.value.loaded && P.value.loading ? (g(), v("div", wxe, [...ve[37] || (ve[37] = [
            h("span", { class: "bd-spinner is-sm" }, null, -1),
            X(" Loading more", -1)
          ])])) : P.value.loaded && P.value.failed ? (g(), v("div", kxe, [
            X(A(P.value.error || "Couldn't load more") + " ", 1),
            h("button", {
              class: "lb-link",
              onClick: ve[12] || (ve[12] = (we) => m(s).retry())
            }, "Try again")
          ])) : P.value.loaded && P.value.next !== null ? (g(), v("div", _xe, [
            h("button", {
              class: "lb-btn",
              "data-testid": "library-more",
              onClick: ve[13] || (ve[13] = (we) => m(s).load(m(o).tab, !0))
            }, "Load more")
          ])) : P.value.loaded && D.value.length > $.value * 2 ? (g(), v("div", Sxe, "That's everything" + A(N.value ? " that matches" : ""), 1)) : E("", !0)
        ], 34),
        C(vt, { name: "lb-tray" }, {
          default: et(() => [
            L.value && !a ? (g(), v("footer", Txe, [
              h("div", Mxe, [
                (g(!0), v(H, null, me(m(o).picked.slice(-5), (we, je) => (g(), v("span", {
                  key: we.id,
                  class: "lb-tray-thumb",
                  style: de({ backgroundImage: 'url("' + se(we) + '")', zIndex: je })
                }, null, 4))), 128)),
                h("span", Cxe, [
                  h("b", null, A(m(o).picked.length), 1),
                  X(" of " + A(m(t).max) + " picked ", 1)
                ])
              ]),
              m(o).picked.length ? (g(), v("button", {
                key: 0,
                class: "lb-tray-clear",
                "data-testid": "library-clear",
                onClick: ve[14] || (ve[14] = (we) => m(s).clear())
              }, "Clear")) : E("", !0),
              ve[38] || (ve[38] = h("span", { class: "lb-grow" }, null, -1)),
              h("button", {
                class: "lb-btn is-ghost",
                "data-testid": "library-cancel",
                onClick: Ee
              }, "Cancel"),
              h("button", {
                class: "lb-btn is-primary",
                disabled: !m(o).picked.length,
                "data-testid": "library-confirm",
                onClick: ue
              }, [
                C(R, {
                  name: r ? "ArrowDownToLine" : "Check",
                  size: 14
                }, null, 8, ["name"]),
                X(" " + A(te.value), 1)
              ], 8, Ixe)
            ])) : E("", !0)
          ]),
          _: 1
        }),
        C(vt, { name: "lb-note" }, {
          default: et(() => [
            b.value ? (g(), v("div", {
              key: b.value.id,
              class: U(["lb-note", { "is-error": b.value.tone === "error" }]),
              role: "status"
            }, A(b.value.text), 3)) : E("", !0)
          ]),
          _: 1
        }),
        m(w) ? (g(), v("div", Axe, [
          h("div", null, [
            C(R, {
              name: "Upload",
              size: 18
            }),
            ve[39] || (ve[39] = X(" Drop images to upload them to your Library", -1))
          ])
        ])) : E("", !0),
        m(o).peek ? (g(), Ce(k1e, {
          key: 3,
          lib: m(s),
          item: m(o).peek,
          placing: r,
          single: a,
          model: B(m(o).peek),
          onClose: ve[15] || (ve[15] = (we) => m(o).peek = null),
          onPick: oe,
          onStar: Ie,
          onRemove: he
        }, null, 8, ["lib", "item", "model"])) : E("", !0),
        h("input", {
          ref_key: "fileEl",
          ref: u,
          type: "file",
          accept: "image/*",
          multiple: "",
          style: { display: "none" },
          onChange: be
        }, null, 544)
      ])
    ], 32));
  }
}), Exe = {
  image: ["image", "images"],
  frame: ["frame", "frames"],
  note: ["note", "notes"],
  shape: ["shape", "shapes"],
  tool: ["session", "sessions"],
  studio: ["studio record", "studio records"],
  chat: ["chat", "chats"]
}, Rxe = ["image", "tool", "note", "frame", "shape", "chat", "studio"], zxe = /* @__PURE__ */ new Set(["Add", "Edit", "Delete", "Remote"]);
function gI(n) {
  const e = [];
  for (const t of Rxe) {
    const i = n[t] || 0;
    i && e.push(i + " " + Exe[t][i === 1 ? 0 : 1]);
  }
  return e.join(", ") || "nothing";
}
function $xe(n) {
  if (n.ephemeral || n.origin === "load") return null;
  const e = /* @__PURE__ */ new Map();
  for (const a of n.added) e.set(a.id, a.type);
  for (const a of n.updated) e.set(a.id, a.el.type);
  for (const a of n.removed) e.set(a.id, a.type);
  if (!e.size) return null;
  const t = {};
  for (const a of e.values()) t[a] = (t[a] || 0) + 1;
  const i = gI(t), s = Array.from(e.keys()), o = s.slice(0, 6).join(", ") + (s.length > 6 ? " and " + (s.length - 6) + " more" : "");
  if (n.origin === "remote") return { kind: "remote", label: "Someone else's edit: " + i, detail: o };
  let r = n.label;
  return (!r || zxe.has(r)) && (r = n.removed.length && !n.added.length && !n.updated.length ? "Delete" : n.added.length && !n.updated.length && !n.removed.length ? "Add" : "Edit"), { kind: "edit", label: r + ": " + i, detail: o };
}
const bI = [
  ["the board menu", (n) => n.ui.boardMenu],
  ["Keyboard Shortcuts", (n) => n.ui.keysOpen],
  ["Recently Deleted", (n) => n.ui.trashOpen],
  ["the board's history", (n) => n.ui.boardHistory],
  ["image info", (n) => !!n.ui.infoAt],
  ["the Studios view", (n) => !!n.ui.studio],
  ["your Library", (n) => !!n.ui.libraryOpen],
  ["the prompt library", (n) => n.ui.library.open],
  ["the add menu", (n) => n.ui.addMenu],
  ["the place image menu", (n) => n.ui.placeMenu],
  ["the canvas menu", (n) => !!n.ui.canvasMenu],
  ["the session finder", (n) => !!n.ui.finder],
  ["the eyedropper", (n) => !!n.ui.eyedropper]
];
function vI(n) {
  return bI.filter(([, e]) => e(n)).map(([e]) => e);
}
function Dxe(n) {
  const e = {};
  for (const t of n.ui.selection) {
    const i = n.store.get(t);
    i && (e[i.type] = (e[i.type] || 0) + 1);
  }
  return gI(e);
}
const L_ = {
  error: "Saving failed; the board is retrying",
  offline: "The board went offline; changes are kept here"
};
function Oxe(n, e) {
  const t = [];
  let i = 0, s = 0;
  n.record("board", "Opened a board", e.meta.id), t.push(e.store.subscribe((o) => {
    const r = $xe(o);
    r && n.record(r.kind, r.label, r.detail);
  })), t.push($e(() => e.loaded.value, (o) => {
    o && n.record("board", 'Loaded "' + e.meta.title + '": ' + e.store.size + " elements");
  })), t.push($e(() => e.loadError.value, (o) => {
    o && n.record("error", "The board didn't open: " + o);
  })), e.onStep = (o, r, a) => n.record(o, r, a), t.push($e(() => e.ui.mode, (o) => n.record("tool", o === "hand" ? "Chose the Hand tool" : "Chose the Select tool"))), t.push($e(() => e.ui.shapeArmed ? e.ui.shapeKind : null, (o) => {
    o && n.record("tool", "Chose the " + o + " tool");
  })), t.push($e(() => e.ui.selection.slice(), () => {
    clearTimeout(i), i = window.setTimeout(() => {
      n.record("select", e.ui.selection.length ? "Selected " + Dxe(e) : "Cleared the selection", e.ui.selection.slice(0, 6).join(", ") || void 0);
    }, 450);
  }));
  for (const [o, r] of bI)
    t.push($e(() => r(e), (a) => n.record("panel", (a ? "Opened " : "Closed ") + o)));
  return t.push($e(() => e.ui.toast ? e.ui.toast.id : 0, () => {
    const o = e.ui.toast;
    o && n.record(o.tone === "error" ? "error" : "toast", 'The board said: "' + o.text + '"');
  })), t.push($e(() => e.saveState.value, (o, r) => {
    L_[o] ? n.record("save", L_[o]) : o === "saved" && (r === "error" || r === "offline") && n.record("save", "Saved again");
  })), t.push(e.onCameraFrame((o) => {
    clearTimeout(s), s = window.setTimeout(() => {
      n.record("view", "Moved the view (" + Math.round(o.zoom * 100) + "%)", "x " + Math.round(o.x) + ", y " + Math.round(o.y));
    }, 700);
  })), () => {
    for (const o of t) o();
    clearTimeout(i), clearTimeout(s), e.onStep && (e.onStep = null), n.record("board", "Left the board", e.meta.id);
  };
}
const yI = "[modern-screenshot]", Ml = typeof window != "undefined", Lxe = Ml && "Worker" in window;
var e5;
const Ly = Ml ? (e5 = window.navigator) == null ? void 0 : e5.userAgent : "", xI = Ly.includes("Chrome"), uf = Ly.includes("AppleWebKit") && !xI, By = Ly.includes("Firefox"), Bxe = (n) => n && "__CONTEXT__" in n, Fxe = (n) => n.constructor.name === "CSSFontFaceRule", Nxe = (n) => n.constructor.name === "CSSImportRule", Uxe = (n) => n.constructor.name === "CSSLayerBlockRule", hs = (n) => n.nodeType === 1, eu = (n) => typeof n.className == "object", wI = (n) => n.tagName === "image", Gxe = (n) => n.tagName === "use", Oc = (n) => hs(n) && typeof n.style != "undefined" && !eu(n), jxe = (n) => n.nodeType === 8, Hxe = (n) => n.nodeType === 3, Cl = (n) => n.tagName === "IMG", Jf = (n) => n.tagName === "VIDEO", Vxe = (n) => n.tagName === "CANVAS", Wxe = (n) => n.tagName === "TEXTAREA", qxe = (n) => n.tagName === "INPUT", Kxe = (n) => n.tagName === "STYLE", Yxe = (n) => n.tagName === "SCRIPT", Xxe = (n) => n.tagName === "SELECT", Jxe = (n) => n.tagName === "SLOT", Zxe = (n) => n.tagName === "IFRAME", Qxe = (...n) => console.warn(yI, ...n);
function ewe(n) {
  var t;
  const e = (t = n == null ? void 0 : n.createElement) == null ? void 0 : t.call(n, "canvas");
  return e && (e.height = e.width = 1), !!e && "toDataURL" in e && !!e.toDataURL("image/webp").includes("image/webp");
}
const g0 = (n) => n.startsWith("data:");
function kI(n, e) {
  if (n.match(/^[a-z]+:\/\//i))
    return n;
  if (Ml && n.match(/^\/\//))
    return window.location.protocol + n;
  if (n.match(/^[a-z]+:/i) || !Ml)
    return n;
  const t = Zf().implementation.createHTMLDocument(), i = t.createElement("base"), s = t.createElement("a");
  return t.head.appendChild(i), t.body.appendChild(s), e && (i.href = e), s.href = n, s.href;
}
function Zf(n) {
  var e;
  return (e = n && hs(n) ? n == null ? void 0 : n.ownerDocument : n) != null ? e : window.document;
}
const Qf = "http://www.w3.org/2000/svg";
function twe(n, e, t) {
  const i = Zf(t).createElementNS(Qf, "svg");
  return i.setAttributeNS(null, "width", n.toString()), i.setAttributeNS(null, "height", e.toString()), i.setAttributeNS(null, "viewBox", `0 0 ${n} ${e}`), i;
}
function nwe(n, e) {
  let t = new XMLSerializer().serializeToString(n);
  return e && (t = t.replace(/[\u0000-\u0008\v\f\u000E-\u001F\uD800-\uDFFF\uFFFE\uFFFF]/gu, "")), `data:image/svg+xml;charset=utf-8,${encodeURIComponent(t)}`;
}
function iwe(n, e) {
  return new Promise((t, i) => {
    const s = new FileReader();
    s.onload = () => t(s.result), s.onerror = () => i(s.error), s.onabort = () => i(new Error(`Failed read blob to ${e}`)), s.readAsDataURL(n);
  });
}
const swe = (n) => iwe(n, "dataUrl");
function ol(n, e) {
  const t = Zf(e).createElement("img");
  return t.decoding = "sync", t.loading = "eager", t.src = n, t;
}
function Lc(n, e) {
  return new Promise((t) => {
    const { timeout: i, ownerDocument: s, onError: o, onWarn: r } = e != null ? e : {}, a = typeof n == "string" ? ol(n, Zf(s)) : n;
    let l = null, d = null;
    function c() {
      t(a), l && clearTimeout(l), d == null || d();
    }
    if (i && (l = setTimeout(c, i)), Jf(a)) {
      const u = a.currentSrc || a.src;
      if (!u)
        return a.poster ? Lc(a.poster, e).then(t) : c();
      if (a.readyState >= 2)
        return c();
      const p = c, f = (y) => {
        r == null || r(
          "Failed video load",
          u,
          y
        ), o == null || o(y), c();
      };
      d = () => {
        a.removeEventListener("loadeddata", p), a.removeEventListener("error", f);
      }, a.addEventListener("loadeddata", p, { once: !0 }), a.addEventListener("error", f, { once: !0 });
    } else {
      const u = wI(a) ? a.href.baseVal : a.currentSrc || a.src;
      if (!u)
        return c();
      const p = async () => {
        if (Cl(a) && "decode" in a)
          try {
            await a.decode();
          } catch (y) {
            r == null || r(
              "Failed to decode image, trying to render anyway",
              a.dataset.originalSrc || u,
              y
            );
          }
        c();
      }, f = (y) => {
        r == null || r(
          "Failed image load",
          a.dataset.originalSrc || u,
          y
        ), c();
      };
      if (Cl(a) && a.complete)
        return p();
      d = () => {
        a.removeEventListener("load", p), a.removeEventListener("error", f);
      }, a.addEventListener("load", p, { once: !0 }), a.addEventListener("error", f, { once: !0 });
    }
  });
}
async function owe(n, e) {
  Oc(n) && (Cl(n) || Jf(n) ? await Lc(n, e) : await Promise.all(
    ["img", "video"].flatMap((t) => Array.from(n.querySelectorAll(t)).map((i) => Lc(i, e)))
  ));
}
const _I = /* @__PURE__ */ (function() {
  let e = 0;
  const t = () => `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
  return () => (e += 1, `u${t()}${e}`);
})();
function SI(n) {
  return n == null ? void 0 : n.split(",").map((e) => e.trim().replace(/"|'/g, "").toLowerCase()).filter(Boolean);
}
let B_ = 0;
function rwe(n) {
  const e = `${yI}[#${B_}]`;
  return B_++, {
    // eslint-disable-next-line no-console
    time: (t) => n && console.time(`${e} ${t}`),
    // eslint-disable-next-line no-console
    timeEnd: (t) => n && console.timeEnd(`${e} ${t}`),
    warn: (...t) => n && Qxe(...t)
  };
}
function awe(n) {
  return {
    cache: n ? "no-cache" : "force-cache"
  };
}
async function TI(n, e) {
  return Bxe(n) ? n : lwe(n, { ...e, autoDestruct: !0 });
}
async function lwe(n, e) {
  var f, y, b, w, k;
  const { scale: t = 1, workerUrl: i, workerNumber: s = 1 } = e || {}, o = !!(e != null && e.debug), r = (f = e == null ? void 0 : e.features) != null ? f : !0, a = (y = n.ownerDocument) != null ? y : Ml ? window.document : void 0, l = (w = (b = n.ownerDocument) == null ? void 0 : b.defaultView) != null ? w : Ml ? window : void 0, d = /* @__PURE__ */ new Map(), c = {
    // Options
    width: 0,
    height: 0,
    quality: 1,
    type: "image/png",
    scale: t,
    backgroundColor: null,
    style: null,
    filter: null,
    maximumCanvasSize: 0,
    timeout: 3e4,
    progress: null,
    debug: o,
    fetch: {
      requestInit: awe((k = e == null ? void 0 : e.fetch) == null ? void 0 : k.bypassingCache),
      placeholderImage: "data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      bypassingCache: !1,
      ...e == null ? void 0 : e.fetch
    },
    fetchFn: null,
    font: {},
    drawImageInterval: 100,
    workerUrl: null,
    workerNumber: s,
    onCloneEachNode: null,
    onCloneNode: null,
    onEmbedNode: null,
    onCreateForeignObjectSvg: null,
    includeStyleProperties: null,
    autoDestruct: !1,
    ...e,
    // InternalContext
    __CONTEXT__: !0,
    log: rwe(o),
    node: n,
    ownerDocument: a,
    ownerWindow: l,
    dpi: t === 1 ? null : 96 * t,
    svgStyleElement: MI(a),
    svgDefsElement: a == null ? void 0 : a.createElementNS(Qf, "defs"),
    svgStyles: /* @__PURE__ */ new Map(),
    defaultComputedStyles: /* @__PURE__ */ new Map(),
    workers: [
      ...Array.from({
        length: Lxe && i && s ? s : 0
      })
    ].map(() => {
      try {
        const S = new Worker(i);
        return S.onmessage = async (_) => {
          var M, z, P, D;
          const { url: x, result: T } = _.data;
          T ? (z = (M = d.get(x)) == null ? void 0 : M.resolve) == null || z.call(M, T) : (D = (P = d.get(x)) == null ? void 0 : P.reject) == null || D.call(P, new Error(`Error receiving message from worker: ${x}`));
        }, S.onmessageerror = (_) => {
          var T, M;
          const { url: x } = _.data;
          (M = (T = d.get(x)) == null ? void 0 : T.reject) == null || M.call(T, new Error(`Error receiving message from worker: ${x}`));
        }, S;
      } catch (S) {
        return c.log.warn("Failed to new Worker", S), null;
      }
    }).filter(Boolean),
    fontFamilies: /* @__PURE__ */ new Map(),
    fontCssTexts: /* @__PURE__ */ new Map(),
    acceptOfImage: `${[
      ewe(a) && "image/webp",
      "image/svg+xml",
      "image/*",
      "*/*"
    ].filter(Boolean).join(",")};q=0.8`,
    requests: d,
    drawImageCount: 0,
    tasks: [],
    features: r,
    isEnable: (S) => {
      var _, x;
      return S === "restoreScrollPosition" ? typeof r == "boolean" ? !1 : (_ = r[S]) != null ? _ : !1 : typeof r == "boolean" ? r : (x = r[S]) != null ? x : !0;
    },
    shadowRoots: []
  };
  c.log.time("wait until load"), await owe(n, { timeout: c.timeout, onWarn: c.log.warn }), c.log.timeEnd("wait until load");
  const { width: u, height: p } = dwe(n, c);
  return c.width = u, c.height = p, c;
}
function MI(n) {
  if (!n)
    return;
  const e = n.createElement("style"), t = e.ownerDocument.createTextNode(`
.______background-clip--text {
  background-clip: text;
  -webkit-background-clip: text;
}
`);
  return e.appendChild(t), e;
}
function dwe(n, e) {
  let { width: t, height: i } = e;
  if (hs(n) && (!t || !i)) {
    const s = n.getBoundingClientRect();
    t = t || s.width || Number(n.getAttribute("width")) || 0, i = i || s.height || Number(n.getAttribute("height")) || 0;
  }
  return { width: t, height: i };
}
async function cwe(n, e) {
  const {
    log: t,
    timeout: i,
    drawImageCount: s,
    drawImageInterval: o
  } = e;
  t.time("image to canvas");
  const r = await Lc(n, { timeout: i, onWarn: e.log.warn }), { canvas: a, context2d: l } = uwe(n.ownerDocument, e), d = () => {
    try {
      l == null || l.drawImage(r, 0, 0, a.width, a.height);
    } catch (c) {
      e.log.warn("Failed to drawImage", c);
    }
  };
  if (d(), e.isEnable("fixSvgXmlDecode"))
    for (let c = 0; c < s; c++)
      await new Promise((u) => {
        setTimeout(() => {
          l == null || l.clearRect(0, 0, a.width, a.height), d(), u();
        }, c + o);
      });
  return e.drawImageCount = 0, t.timeEnd("image to canvas"), a;
}
function uwe(n, e) {
  const { width: t, height: i, scale: s, backgroundColor: o, maximumCanvasSize: r } = e, a = n.createElement("canvas");
  a.width = Math.floor(t * s), a.height = Math.floor(i * s), a.style.width = `${t}px`, a.style.height = `${i}px`, r && (a.width > r || a.height > r) && (a.width > r && a.height > r ? a.width > a.height ? (a.height *= r / a.width, a.width = r) : (a.width *= r / a.height, a.height = r) : a.width > r ? (a.height *= r / a.width, a.width = r) : (a.width *= r / a.height, a.height = r));
  const l = a.getContext("2d");
  return l && o && (l.fillStyle = o, l.fillRect(0, 0, a.width, a.height)), { canvas: a, context2d: l };
}
function CI(n, e) {
  if (n.ownerDocument)
    try {
      const o = n.toDataURL();
      if (o !== "data:,")
        return ol(o, n.ownerDocument);
    } catch (o) {
      e.log.warn("Failed to clone canvas", o);
    }
  const t = n.cloneNode(!1), i = n.getContext("2d"), s = t.getContext("2d");
  try {
    return i && s && s.putImageData(
      i.getImageData(0, 0, n.width, n.height),
      0,
      0
    ), t;
  } catch (o) {
    e.log.warn("Failed to clone canvas", o);
  }
  return t;
}
function hwe(n, e) {
  var t;
  try {
    if ((t = n == null ? void 0 : n.contentDocument) != null && t.documentElement)
      return Fy(n.contentDocument.documentElement, e);
  } catch (i) {
    e.log.warn("Failed to clone iframe", i);
  }
  return n.cloneNode(!1);
}
function pwe(n) {
  const e = n.cloneNode(!1);
  return n.currentSrc && n.currentSrc !== n.src && (e.src = n.currentSrc, e.srcset = ""), e.loading === "lazy" && (e.loading = "eager"), e;
}
async function fwe(n, e) {
  if (n.ownerDocument && !n.currentSrc && n.poster)
    return ol(n.poster, n.ownerDocument);
  const t = n.cloneNode(!1);
  t.crossOrigin = "anonymous", n.currentSrc && n.currentSrc !== n.src && (t.src = n.currentSrc);
  const i = t.ownerDocument;
  if (i) {
    let s = !0;
    if (await Lc(t, { onError: () => s = !1, onWarn: e.log.warn }), !s)
      return n.poster ? ol(n.poster, n.ownerDocument) : t;
    t.currentTime = n.currentTime, await new Promise((r) => {
      t.addEventListener("seeked", r, { once: !0 });
    });
    const o = i.createElement("canvas");
    o.width = n.offsetWidth, o.height = n.offsetHeight;
    try {
      const r = o.getContext("2d");
      r && r.drawImage(t, 0, 0, o.width, o.height);
    } catch (r) {
      return e.log.warn("Failed to clone video", r), n.poster ? ol(n.poster, n.ownerDocument) : t;
    }
    return CI(o, e);
  }
  return t;
}
function mwe(n, e) {
  return Vxe(n) ? CI(n, e) : Zxe(n) ? hwe(n, e) : Cl(n) ? pwe(n) : Jf(n) ? fwe(n, e) : n.cloneNode(!1);
}
function gwe(n) {
  let e = n.sandbox;
  if (!e) {
    const { ownerDocument: t } = n;
    try {
      t && (e = t.createElement("iframe"), e.id = `__SANDBOX__${_I()}`, e.width = "0", e.height = "0", e.style.visibility = "hidden", e.style.position = "fixed", t.body.appendChild(e), e.srcdoc = '<!DOCTYPE html><meta charset="UTF-8"><title></title><body>', n.sandbox = e);
    } catch (i) {
      n.log.warn("Failed to getSandBox", i);
    }
  }
  return e;
}
const bwe = [
  "width",
  "height",
  "-webkit-text-fill-color"
], vwe = [
  "stroke",
  "fill"
];
function II(n, e, t) {
  const { defaultComputedStyles: i } = t, s = n.nodeName.toLowerCase(), o = eu(n) && s !== "svg", r = o ? vwe.map((b) => [b, n.getAttribute(b)]).filter(([, b]) => b !== null) : [], a = [
    o && "svg",
    s,
    r.map((b, w) => `${b}=${w}`).join(","),
    e
  ].filter(Boolean).join(":");
  if (i.has(a))
    return i.get(a);
  const l = gwe(t), d = l == null ? void 0 : l.contentWindow;
  if (!d)
    return /* @__PURE__ */ new Map();
  const c = d == null ? void 0 : d.document;
  let u, p;
  o ? (u = c.createElementNS(Qf, "svg"), p = u.ownerDocument.createElementNS(u.namespaceURI, s), r.forEach(([b, w]) => {
    p.setAttributeNS(null, b, w);
  }), u.appendChild(p)) : u = p = c.createElement(s), p.textContent = " ", c.body.appendChild(u);
  const f = d.getComputedStyle(p, e), y = /* @__PURE__ */ new Map();
  for (let b = f.length, w = 0; w < b; w++) {
    const k = f.item(w);
    bwe.includes(k) || y.set(k, f.getPropertyValue(k));
  }
  return c.body.removeChild(u), i.set(a, y), y;
}
function AI(n, e, t) {
  var a;
  const i = /* @__PURE__ */ new Map(), s = [], o = /* @__PURE__ */ new Map();
  if (t)
    for (const l of t)
      r(l);
  else
    for (let l = n.length, d = 0; d < l; d++) {
      const c = n.item(d);
      r(c);
    }
  for (let l = s.length, d = 0; d < l; d++)
    (a = o.get(s[d])) == null || a.forEach((c, u) => i.set(u, c));
  function r(l) {
    const d = n.getPropertyValue(l), c = n.getPropertyPriority(l), u = l.lastIndexOf("-"), p = u > -1 ? l.substring(0, u) : void 0;
    if (p) {
      let f = o.get(p);
      f || (f = /* @__PURE__ */ new Map(), o.set(p, f)), f.set(l, [d, c]);
    }
    e.get(l) === d && !c || (p ? s.push(p) : i.set(l, [d, c]));
  }
  return i;
}
function ywe(n, e, t, i) {
  var u, p, f, y;
  const { ownerWindow: s, includeStyleProperties: o, currentParentNodeStyle: r } = i, a = e.style, l = s.getComputedStyle(n), d = II(n, null, i);
  r == null || r.forEach((b, w) => {
    d.delete(w);
  });
  const c = AI(l, d, o);
  c.delete("transition-property"), c.delete("all"), c.delete("d"), c.delete("content"), t && (c.delete("position"), c.delete("margin-top"), c.delete("margin-right"), c.delete("margin-bottom"), c.delete("margin-left"), c.delete("margin-block-start"), c.delete("margin-block-end"), c.delete("margin-inline-start"), c.delete("margin-inline-end"), c.set("box-sizing", ["border-box", ""])), ((u = c.get("background-clip")) == null ? void 0 : u[0]) === "text" && e.classList.add("______background-clip--text"), xI && (c.has("font-kerning") || c.set("font-kerning", ["normal", ""]), (((p = c.get("overflow-x")) == null ? void 0 : p[0]) === "hidden" || ((f = c.get("overflow-y")) == null ? void 0 : f[0]) === "hidden") && ((y = c.get("text-overflow")) == null ? void 0 : y[0]) === "ellipsis" && n.scrollWidth === n.clientWidth && c.set("text-overflow", ["clip", ""]));
  for (let b = a.length, w = 0; w < b; w++)
    a.removeProperty(a.item(w));
  return c.forEach(([b, w], k) => {
    a.setProperty(k, b, w);
  }), c;
}
function xwe(n, e) {
  (Wxe(n) || qxe(n) || Xxe(n)) && e.setAttribute("value", n.value);
}
const wwe = [
  "::before",
  "::after"
  // '::placeholder', TODO
], kwe = [
  "::-webkit-scrollbar",
  "::-webkit-scrollbar-button",
  // '::-webkit-scrollbar:horizontal', TODO
  "::-webkit-scrollbar-thumb",
  "::-webkit-scrollbar-track",
  "::-webkit-scrollbar-track-piece",
  // '::-webkit-scrollbar:vertical', TODO
  "::-webkit-scrollbar-corner",
  "::-webkit-resizer"
];
function _we(n, e, t, i, s) {
  const { ownerWindow: o, svgStyleElement: r, svgStyles: a, currentNodeStyle: l } = i;
  if (!r || !o)
    return;
  function d(c) {
    var _;
    const u = o.getComputedStyle(n, c);
    let p = u.getPropertyValue("content");
    if (!p || p === "none")
      return;
    s == null || s(p), p = p.replace(/(')|(")|(counter\(.+\))/g, "");
    const f = [_I()], y = II(n, c, i);
    l == null || l.forEach((x, T) => {
      y.delete(T);
    });
    const b = AI(u, y, i.includeStyleProperties);
    b.delete("content"), b.delete("-webkit-locale"), ((_ = b.get("background-clip")) == null ? void 0 : _[0]) === "text" && e.classList.add("______background-clip--text");
    const w = [
      `content: '${p}';`
    ];
    if (b.forEach(([x, T], M) => {
      w.push(`${M}: ${x}${T ? " !important" : ""};`);
    }), w.length === 1)
      return;
    try {
      e.className = [e.className, ...f].join(" ");
    } catch (x) {
      i.log.warn("Failed to copyPseudoClass", x);
      return;
    }
    const k = w.join(`
  `);
    let S = a.get(k);
    S || (S = [], a.set(k, S)), S.push(`.${f[0]}${c}`);
  }
  wwe.forEach(d), t && kwe.forEach(d);
}
const F_ = /* @__PURE__ */ new Set([
  "symbol"
  // test/fixtures/svg.symbol.html
]);
async function N_(n, e, t, i, s) {
  if (hs(t) && (Kxe(t) || Yxe(t)) || i.filter && !i.filter(t))
    return;
  F_.has(e.nodeName) || F_.has(t.nodeName) ? i.currentParentNodeStyle = void 0 : i.currentParentNodeStyle = i.currentNodeStyle;
  const o = await Fy(t, i, !1, s);
  i.isEnable("restoreScrollPosition") && Swe(n, o), e.appendChild(o);
}
async function U_(n, e, t, i) {
  var o;
  let s = n.firstChild;
  hs(n) && n.shadowRoot && (s = (o = n.shadowRoot) == null ? void 0 : o.firstChild, t.shadowRoots.push(n.shadowRoot));
  for (let r = s; r; r = r.nextSibling)
    if (!jxe(r))
      if (hs(r) && Jxe(r) && typeof r.assignedNodes == "function") {
        const a = r.assignedNodes();
        for (let l = 0; l < a.length; l++)
          await N_(n, e, a[l], t, i);
      } else
        await N_(n, e, r, t, i);
}
function Swe(n, e) {
  if (!Oc(n) || !Oc(e))
    return;
  const { scrollTop: t, scrollLeft: i } = n;
  if (!t && !i)
    return;
  const { transform: s } = e.style, o = new DOMMatrix(s), { a: r, b: a, c: l, d } = o;
  o.a = 1, o.b = 0, o.c = 0, o.d = 1, o.translateSelf(-i, -t), o.a = r, o.b = a, o.c = l, o.d = d, e.style.transform = o.toString();
}
function Twe(n, e) {
  const { backgroundColor: t, width: i, height: s, style: o } = e, r = n.style;
  if (t && r.setProperty("background-color", t, "important"), i && r.setProperty("width", `${i}px`, "important"), s && r.setProperty("height", `${s}px`, "important"), o)
    for (const a in o) r[a] = o[a];
}
const Mwe = /^[\w-:]+$/;
async function Fy(n, e, t = !1, i) {
  var d, c, u, p;
  const { ownerDocument: s, ownerWindow: o, fontFamilies: r, onCloneEachNode: a } = e;
  if (s && Hxe(n))
    return i && /\S/.test(n.data) && i(n.data), s.createTextNode(n.data);
  if (s && o && hs(n) && (Oc(n) || eu(n))) {
    const f = await mwe(n, e);
    if (e.isEnable("removeAbnormalAttributes")) {
      const _ = f.getAttributeNames();
      for (let x = _.length, T = 0; T < x; T++) {
        const M = _[T];
        Mwe.test(M) || f.removeAttribute(M);
      }
    }
    const y = e.currentNodeStyle = ywe(n, f, t, e);
    t && Twe(f, e);
    let b = !1;
    if (e.isEnable("copyScrollbar")) {
      const _ = [
        (d = y.get("overflow-x")) == null ? void 0 : d[0],
        (c = y.get("overflow-y")) == null ? void 0 : c[0]
      ];
      b = _.includes("scroll") || (_.includes("auto") || _.includes("overlay")) && (n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth);
    }
    const w = (u = y.get("text-transform")) == null ? void 0 : u[0], k = SI((p = y.get("font-family")) == null ? void 0 : p[0]), S = k ? (_) => {
      w === "uppercase" ? _ = _.toUpperCase() : w === "lowercase" ? _ = _.toLowerCase() : w === "capitalize" && (_ = _[0].toUpperCase() + _.substring(1)), k.forEach((x) => {
        let T = r.get(x);
        T || r.set(x, T = /* @__PURE__ */ new Set()), _.split("").forEach((M) => T.add(M));
      });
    } : void 0;
    return _we(
      n,
      f,
      b,
      e,
      S
    ), xwe(n, f), Jf(n) || await U_(
      n,
      f,
      e,
      S
    ), await (a == null ? void 0 : a(f)), f;
  }
  const l = n.cloneNode(!1);
  return await U_(n, l, e), await (a == null ? void 0 : a(l)), l;
}
function Cwe(n) {
  if (n.ownerDocument = void 0, n.ownerWindow = void 0, n.svgStyleElement = void 0, n.svgDefsElement = void 0, n.svgStyles.clear(), n.defaultComputedStyles.clear(), n.sandbox) {
    try {
      n.sandbox.remove();
    } catch (e) {
      n.log.warn("Failed to destroyContext", e);
    }
    n.sandbox = void 0;
  }
  n.workers = [], n.fontFamilies.clear(), n.fontCssTexts.clear(), n.requests.clear(), n.tasks = [], n.shadowRoots = [];
}
function Iwe(n) {
  const { url: e, timeout: t, responseType: i, ...s } = n, o = new AbortController(), r = t ? setTimeout(() => o.abort(), t) : void 0;
  return fetch(e, { signal: o.signal, ...s }).then((a) => {
    if (!a.ok)
      throw new Error("Failed fetch, not 2xx response", { cause: a });
    switch (i) {
      case "arrayBuffer":
        return a.arrayBuffer();
      case "dataUrl":
        return a.blob().then(swe);
      default:
        return a.text();
    }
  }).finally(() => clearTimeout(r));
}
function Bc(n, e) {
  const { url: t, requestType: i = "text", responseType: s = "text", imageDom: o } = e;
  let r = t;
  const {
    timeout: a,
    acceptOfImage: l,
    requests: d,
    fetchFn: c,
    fetch: {
      requestInit: u,
      bypassingCache: p,
      placeholderImage: f
    },
    font: y,
    workers: b,
    fontFamilies: w
  } = n;
  i === "image" && (uf || By) && n.drawImageCount++;
  let k = d.get(t);
  if (!k) {
    p && p instanceof RegExp && p.test(r) && (r += (/\?/.test(r) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime());
    const S = i.startsWith("font") && y && y.minify, _ = /* @__PURE__ */ new Set();
    S && i.split(";")[1].split(",").forEach((z) => {
      w.has(z) && w.get(z).forEach((P) => _.add(P));
    });
    const x = S && _.size, T = {
      url: r,
      timeout: a,
      responseType: x ? "arrayBuffer" : s,
      headers: i === "image" ? { accept: l } : void 0,
      ...u
    };
    k = {
      type: i,
      resolve: void 0,
      reject: void 0,
      response: null
    }, k.response = (async () => {
      if (c && i === "image") {
        const M = await c(t);
        if (M)
          return M;
      }
      return !uf && t.startsWith("http") && b.length ? new Promise((M, z) => {
        b[d.size & b.length - 1].postMessage({ rawUrl: t, ...T }), k.resolve = M, k.reject = z;
      }) : Iwe(T);
    })().catch((M) => {
      if (d.delete(t), i === "image" && f)
        return n.log.warn("Failed to fetch image base64, trying to use placeholder image", r), typeof f == "string" ? f : f(o);
      throw M;
    }), d.set(t, k);
  }
  return k.response;
}
async function PI(n, e, t, i) {
  if (!EI(n))
    return n;
  for (const [s, o] of Awe(n, e))
    try {
      const r = await Bc(
        t,
        {
          url: o,
          requestType: i ? "image" : "text",
          responseType: "dataUrl"
        }
      );
      n = n.replace(Pwe(s), `$1${r}$3`);
    } catch (r) {
      t.log.warn("Failed to fetch css data url", s, r);
    }
  return n;
}
function EI(n) {
  return /url\((['"]?)([^'"]+?)\1\)/.test(n);
}
const RI = /url\((['"]?)([^'"]+?)\1\)/g;
function Awe(n, e) {
  const t = [];
  return n.replace(RI, (i, s, o) => (t.push([o, kI(o, e)]), i)), t.filter(([i]) => !g0(i));
}
function Pwe(n) {
  const e = n.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
  return new RegExp(`(url\\(['"]?)(${e})(['"]?\\))`, "g");
}
const Ewe = [
  "background-image",
  "border-image-source",
  "-webkit-border-image",
  "-webkit-mask-image",
  "list-style-image"
];
function Rwe(n, e) {
  return Ewe.map((t) => {
    const i = n.getPropertyValue(t);
    return !i || i === "none" ? null : ((uf || By) && e.drawImageCount++, PI(i, null, e, !0).then((s) => {
      !s || i === s || n.setProperty(
        t,
        s,
        n.getPropertyPriority(t)
      );
    }));
  }).filter(Boolean);
}
function zwe(n, e) {
  if (Cl(n)) {
    const t = n.currentSrc || n.src;
    if (!g0(t))
      return [
        Bc(e, {
          url: t,
          imageDom: n,
          requestType: "image",
          responseType: "dataUrl"
        }).then((i) => {
          i && (n.srcset = "", n.dataset.originalSrc = t, n.src = i || "");
        })
      ];
    (uf || By) && e.drawImageCount++;
  } else if (eu(n) && !g0(n.href.baseVal)) {
    const t = n.href.baseVal;
    return [
      Bc(e, {
        url: t,
        imageDom: n,
        requestType: "image",
        responseType: "dataUrl"
      }).then((i) => {
        i && (n.dataset.originalSrc = t, n.href.baseVal = i || "");
      })
    ];
  }
  return [];
}
function $we(n, e) {
  var a;
  const { ownerDocument: t, svgDefsElement: i } = e, s = (a = n.getAttribute("href")) != null ? a : n.getAttribute("xlink:href");
  if (!s)
    return [];
  const [o, r] = s.split("#");
  if (r) {
    const l = `#${r}`, d = e.shadowRoots.reduce(
      (c, u) => c != null ? c : u.querySelector(`svg ${l}`),
      t == null ? void 0 : t.querySelector(`svg ${l}`)
    );
    if (o && n.setAttribute("href", l), i != null && i.querySelector(l))
      return [];
    if (d)
      return i == null || i.appendChild(d.cloneNode(!0)), [];
    if (o)
      return [
        Bc(e, {
          url: o,
          responseType: "text"
        }).then((c) => {
          i == null || i.insertAdjacentHTML("beforeend", c);
        })
      ];
  }
  return [];
}
function zI(n, e) {
  const { tasks: t } = e;
  hs(n) && ((Cl(n) || wI(n)) && t.push(...zwe(n, e)), Gxe(n) && t.push(...$we(n, e))), Oc(n) && t.push(...Rwe(n.style, e)), n.childNodes.forEach((i) => {
    zI(i, e);
  });
}
async function Dwe(n, e) {
  const {
    ownerDocument: t,
    svgStyleElement: i,
    fontFamilies: s,
    fontCssTexts: o,
    tasks: r,
    font: a
  } = e;
  if (!(!t || !i || !s.size))
    if (a && a.cssText) {
      const l = j_(a.cssText, e);
      i.appendChild(t.createTextNode(`${l}
`));
    } else {
      const l = Array.from(t.styleSheets).filter((f) => {
        try {
          return "cssRules" in f && !!f.cssRules.length;
        } catch (y) {
          return e.log.warn(`Error while reading CSS rules from ${f.href}`, y), !1;
        }
      }), d = t.implementation.createHTMLDocument(""), c = d.createElement("style");
      d.head.appendChild(c);
      const u = c.sheet;
      await Promise.all(
        l.flatMap((f) => Array.from(f.cssRules).map(async (y) => {
          if (Nxe(y)) {
            const b = y.href;
            let w = "";
            try {
              w = await Bc(e, {
                url: b,
                requestType: "text",
                responseType: "text"
              });
            } catch (S) {
              e.log.warn(`Error fetch remote css import from ${b}`, S);
            }
            const k = w.replace(
              RI,
              (S, _, x) => S.replace(x, kI(x, b))
            );
            for (const S of Lwe(k))
              try {
                u.insertRule(S, u.cssRules.length);
              } catch (_) {
                e.log.warn("Error inserting rule from remote css import", { rule: S, error: _ });
              }
          }
        }))
      ), u.cssRules.length && l.push(u);
      const p = [];
      l.forEach((f) => {
        b0(f.cssRules, p);
      }), p.filter((f) => {
        var y;
        return Fxe(f) && EI(f.style.getPropertyValue("src")) && ((y = SI(f.style.getPropertyValue("font-family"))) == null ? void 0 : y.some((b) => s.has(b)));
      }).forEach((f) => {
        const y = f, b = o.get(y.cssText);
        b ? i.appendChild(t.createTextNode(`${b}
`)) : r.push(
          PI(
            y.cssText,
            y.parentStyleSheet ? y.parentStyleSheet.href : null,
            e
          ).then((w) => {
            w = j_(w, e), o.set(y.cssText, w), i.appendChild(t.createTextNode(`${w}
`));
          })
        );
      });
    }
}
const Owe = /(\/\*[\s\S]*?\*\/)/g, G_ = /((@.*?keyframes [\s\S]*?){([\s\S]*?}\s*?)})/gi;
function Lwe(n) {
  if (n == null)
    return [];
  const e = [];
  let t = n.replace(Owe, "");
  for (; ; ) {
    const o = G_.exec(t);
    if (!o)
      break;
    e.push(o[0]);
  }
  t = t.replace(G_, "");
  const i = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi, s = new RegExp(
    // eslint-disable-next-line
    "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})",
    "gi"
  );
  for (; ; ) {
    let o = i.exec(t);
    if (o)
      s.lastIndex = i.lastIndex;
    else if (o = s.exec(t), o)
      i.lastIndex = s.lastIndex;
    else
      break;
    e.push(o[0]);
  }
  return e;
}
const Bwe = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g, Fwe = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function j_(n, e) {
  const { font: t } = e, i = t ? t == null ? void 0 : t.preferredFormat : void 0;
  return i ? n.replace(Fwe, (s) => {
    for (; ; ) {
      const [o, , r] = Bwe.exec(s) || [];
      if (!r)
        return "";
      if (r === i)
        return `src: ${o};`;
    }
  }) : n;
}
function b0(n, e = []) {
  for (const t of Array.from(n))
    Uxe(t) ? e.push(...b0(t.cssRules)) : "cssRules" in t ? b0(t.cssRules, e) : e.push(t);
  return e;
}
const Nwe = /\bx?link:?href\s*=\s*["'](?!data:)[^"']+["']/i;
function Uwe(n) {
  return Nwe.test(n.innerHTML);
}
async function Gwe(n, e) {
  const t = await TI(n, e);
  if (hs(t.node) && eu(t.node) && !Uwe(t.node))
    return t.node;
  const {
    ownerDocument: i,
    log: s,
    tasks: o,
    svgStyleElement: r,
    svgDefsElement: a,
    svgStyles: l,
    font: d,
    progress: c,
    autoDestruct: u,
    onCloneNode: p,
    onEmbedNode: f,
    onCreateForeignObjectSvg: y
  } = t;
  s.time("clone node");
  const b = await Fy(t.node, t, !0);
  if (r && i) {
    let x = "";
    l.forEach((T, M) => {
      x += `${T.join(`,
`)} {
  ${M}
}
`;
    }), r.appendChild(i.createTextNode(x));
  }
  s.timeEnd("clone node"), await (p == null ? void 0 : p(b)), d !== !1 && hs(b) && (s.time("embed web font"), await Dwe(b, t), s.timeEnd("embed web font")), s.time("embed node"), zI(b, t);
  const w = o.length;
  let k = 0;
  const S = async () => {
    for (; ; ) {
      const x = o.pop();
      if (!x)
        break;
      try {
        await x;
      } catch (T) {
        t.log.warn("Failed to run task", T);
      }
      c == null || c(++k, w);
    }
  };
  c == null || c(k, w), await Promise.all([...Array.from({ length: 4 })].map(S)), s.timeEnd("embed node"), await (f == null ? void 0 : f(b));
  const _ = jwe(b, t);
  return a && _.insertBefore(a, _.children[0]), r && _.insertBefore(r, _.children[0]), u && Cwe(t), await (y == null ? void 0 : y(_)), _;
}
function jwe(n, e) {
  const { width: t, height: i } = e, s = twe(t, i, n.ownerDocument), o = s.ownerDocument.createElementNS(s.namespaceURI, "foreignObject");
  return o.setAttributeNS(null, "x", "0%"), o.setAttributeNS(null, "y", "0%"), o.setAttributeNS(null, "width", "100%"), o.setAttributeNS(null, "height", "100%"), o.append(n), s.appendChild(o), s;
}
async function Hwe(n, e) {
  var r;
  const t = await TI(n, e), i = await Gwe(t), s = nwe(i, t.isEnable("removeControlCharacter"));
  t.autoDestruct || (t.svgStyleElement = MI(t.ownerDocument), t.svgDefsElement = (r = t.ownerDocument) == null ? void 0 : r.createElementNS(Qf, "defs"), t.svgStyles.clear());
  const o = ol(s, i.ownerDocument);
  return await cwe(o, t);
}
const $I = 2560, Vwe = 3.5 * 1024 * 1024;
function Wwe(n) {
  return n instanceof Element ? n.hasAttribute("data-feedback-skip") ? !1 : !(n.tagName === "CANVAS" && n.classList.contains("bd-canvas")) : !0;
}
const v0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
function qwe(n) {
  return new Promise((e, t) => {
    const i = new FileReader();
    i.onload = () => e(String(i.result || "")), i.onerror = () => t(i.error || new Error("The picture couldn't be read")), i.readAsDataURL(n);
  });
}
async function Kwe(n) {
  if (!/^https?:/i.test(n)) return !1;
  try {
    if (new URL(n, location.href).origin === location.origin) return !1;
    const e = await fetch(n + (n.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1", { mode: "cors", credentials: "omit" });
    return e.ok ? await qwe(await e.blob()) : v0;
  } catch {
    return v0;
  }
}
function Ywe(n) {
  const e = [];
  return n.querySelectorAll("img").forEach((t) => {
    t.loading !== "lazy" || t.complete || (t.loading = "eager", e.push(t));
  }), () => {
    for (const t of e) t.loading = "lazy";
  };
}
function H_(n, e, t) {
  return new Promise((i) => n.toBlob(i, e, t));
}
function Xwe(n, e) {
  const t = document.createElement("canvas");
  t.width = Math.max(1, Math.round(n.width * e)), t.height = Math.max(1, Math.round(n.height * e));
  const i = t.getContext("2d");
  return i && i.drawImage(n, 0, 0, t.width, t.height), t;
}
async function DI(n) {
  let e = n;
  for (let t = 0; t < 4; t++) {
    let i = await H_(e, "image/webp", 0.86);
    if ((!i || i.type !== "image/webp") && (i = await H_(e, "image/jpeg", 0.88)), i && (i.size <= Vwe || t === 3)) {
      const s = i.type === "image/webp" ? "image/webp" : i.type === "image/png" ? "image/png" : "image/jpeg";
      return { blob: i, type: s, w: e.width, h: e.height };
    }
    e = Xwe(e, 0.75);
  }
  throw new Error("The screenshot couldn't be encoded");
}
async function Jwe(n, e, t) {
  const i = Date.now(), s = e ? e.snapshot() : null, o = n.querySelector("canvas.bd-canvas");
  if (s && o && o.parentElement) {
    const a = o.getBoundingClientRect();
    s.setAttribute("data-feedback-frame", ""), s.style.cssText = "position:absolute;left:0;top:0;width:" + a.width + "px;height:" + a.height + "px;pointer-events:none", o.parentElement.appendChild(s);
  }
  const r = Ywe(n);
  try {
    const a = n.getBoundingClientRect(), l = Math.min(2, window.devicePixelRatio || 1), d = Math.min(l, $I / Math.max(1, a.width, a.height)), c = await Hwe(n, {
      scale: d,
      filter: Wwe,
      timeout: 1e4,
      fetchFn: Kwe,
      fetch: { placeholderImage: v0 }
    }), u = await DI(c);
    return { ...u, url: URL.createObjectURL(u.blob), at: i, from: "board", ...t };
  } finally {
    r(), s && s.parentElement && s.parentElement.removeChild(s);
  }
}
const Zwe = 40 * 1024 * 1024;
function OI(n) {
  return /^image\//i.test(n.type);
}
async function Qwe(n) {
  if (typeof createImageBitmap == "function")
    try {
      const t = await createImageBitmap(n);
      return { pic: t, w: t.width, h: t.height, release: () => t.close() };
    } catch {
    }
  const e = URL.createObjectURL(n);
  try {
    const t = new Image();
    return t.src = e, await t.decode(), { pic: t, w: t.naturalWidth, h: t.naturalHeight, release: () => URL.revokeObjectURL(e) };
  } catch (t) {
    throw URL.revokeObjectURL(e), t;
  }
}
async function eke(n, e) {
  if (n.size > Zwe) throw new Error("The picture is too large to add");
  const t = Date.now(), i = await Qwe(n);
  try {
    if (!i.w || !i.h) throw new Error("The picture has no pixels");
    const s = Math.min(1, $I / Math.max(i.w, i.h)), o = document.createElement("canvas");
    o.width = Math.max(1, Math.round(i.w * s)), o.height = Math.max(1, Math.round(i.h * s));
    const r = o.getContext("2d");
    if (!r) throw new Error("No 2D canvas to draw the picture on");
    r.drawImage(i.pic, 0, 0, o.width, o.height);
    const a = await DI(o);
    return { ...a, url: URL.createObjectURL(a.blob), at: t, from: e, camera: null, selection: [], panels: [] };
  } finally {
    i.release();
  }
}
const V_ = 9 * 1024 * 1024, W_ = 4e3, LI = 50;
class BI extends Error {
  constructor() {
    super("This report is too large to send. Remove a screenshot and try again."), this.name = "ReportTooLarge";
  }
}
function tke(n) {
  return new Promise((e, t) => {
    const i = new FileReader();
    i.onload = () => {
      const s = String(i.result || "");
      e(s.slice(s.indexOf(",") + 1));
    }, i.onerror = () => t(i.error || new Error("The file couldn't be read")), i.readAsDataURL(n);
  });
}
function q_(n) {
  let e = "";
  for (let t = 0; t < n.length; t += 32768) e += String.fromCharCode.apply(null, Array.from(n.subarray(t, t + 32768)));
  return btoa(e);
}
async function K_(n) {
  const e = JSON.stringify(n), t = typeof CompressionStream != "undefined" ? new Response(e).body : null;
  if (t) {
    const i = await new Response(t.pipeThrough(new CompressionStream("gzip"))).arrayBuffer();
    return { data: q_(new Uint8Array(i)), gzip: !0 };
  }
  return { data: q_(new TextEncoder().encode(e)), gzip: !1 };
}
function FI(n) {
  let e;
  return (e = n.match(/Edg\/(\d+)/)) ? "Edge " + e[1] : (e = n.match(/Firefox\/(\d+)/)) ? "Firefox " + e[1] : (e = n.match(/Chrome\/(\d+)/)) ? "Chrome " + e[1] : (e = n.match(/Version\/(\d+(?:\.\d+)?).*Safari/)) ? "Safari " + e[1] : "Unknown browser";
}
function NI(n, e) {
  return /iPad|iPhone/.test(n) ? "iOS or iPadOS" : /Mac OS X/.test(n) ? e > 1 ? "iPadOS" : "macOS" : /Windows/.test(n) ? "Windows" : /Android/.test(n) ? "Android" : /CrOS/.test(n) ? "ChromeOS" : /Linux/.test(n) ? "Linux" : "Unknown";
}
function UI(n) {
  const e = navigator;
  return {
    browser: FI(e.userAgent),
    os: NI(e.userAgent, e.maxTouchPoints || 0),
    dpr: window.devicePixelRatio || 1,
    viewport: { w: window.innerWidth, h: window.innerHeight },
    gpu: n,
    memoryGb: typeof e.deviceMemory == "number" ? e.deviceMemory : null
  };
}
function nke(n) {
  const e = navigator;
  return {
    userAgent: e.userAgent,
    language: e.language,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen: { w: screen.width, h: screen.height },
    window: { w: window.innerWidth, h: window.innerHeight },
    dpr: window.devicePixelRatio || 1,
    memoryGb: typeof e.deviceMemory == "number" ? e.deviceMemory : null,
    cores: e.hardwareConcurrency || null,
    online: e.onLine,
    connection: e.connection && e.connection.effectiveType ? e.connection.effectiveType : null,
    gpu: n
  };
}
function GI(n) {
  const e = {};
  for (const i of n.store.all()) e[i.type] = (e[i.type] || 0) + 1;
  const t = n.cam.value;
  return {
    board: { id: n.meta.id, title: n.meta.title, teamId: n.meta.teamId, accessLevel: n.meta.accessLevel, size: n.store.size, counts: e },
    camera: { x: Math.round(t.x), y: Math.round(t.y), zoom: Math.round(t.zoom * 1e3) / 1e3 },
    view: { w: Math.round(n.view.w), h: Math.round(n.view.h) },
    selection: n.ui.selection.slice(0, LI),
    tool: n.ui.shapeArmed ? n.ui.shapeKind : n.ui.mode,
    openPanels: vI(n),
    undo: n.store.undoLabels().slice(-12),
    saveState: n.saveState.value,
    running: Object.keys(n.generating),
    loaded: n.loaded.value,
    loadError: n.loadError.value,
    engine: n.engine ? n.engine.currentStats() : null
  };
}
async function ike(n, e) {
  const { board: t, recorder: i } = e, s = t.engine ? t.engine.gpu() : null, o = n.include.steps ? i.list() : [], r = n.include.errors ? i.errors() : [], a = await Promise.all(n.shots.map(async (y) => ({
    contentType: y.type,
    data: await tke(y.blob),
    w: y.w,
    h: y.h,
    at: y.at,
    from: y.from,
    camera: y.camera,
    selection: y.selection.slice(0, LI),
    panels: y.panels.slice(0, 20)
  }))), l = t.engine, d = (y) => ({
    v: 1,
    createdAt: Date.now(),
    build: e.build,
    steps: o,
    errors: r,
    frames: l ? { intervalsMs: l.frameIntervals().map((b) => Math.round(b * 10) / 10), stats: l.currentStats() } : null,
    state: n.include.state ? GI(t) : null,
    snapshot: n.include.state ? y ? { elements: Array.from(t.store.all()) } : { dropped: "The board was too large to send with this report.", size: t.store.size } : null,
    device: n.include.device ? nke(s) : null
  }), c = a.reduce((y, b) => y + b.data.length, 0);
  let p = n.include.steps || n.include.errors || n.include.state || n.include.device ? await K_(d(!0)) : null;
  if (p && c + p.data.length > V_ && n.include.state && (p = await K_(d(!1))), c + (p ? p.data.length : 0) > V_) throw new BI();
  const f = n.include.device ? UI(s) : { browser: FI(navigator.userAgent), os: NI(navigator.userAgent, navigator.maxTouchPoints || 0), dpr: window.devicePixelRatio || 1, viewport: { w: window.innerWidth, h: window.innerHeight }, gpu: null, memoryGb: null };
  return {
    kind: n.kind,
    happened: n.happened.trim().slice(0, W_),
    expected: n.expected.trim().slice(0, W_),
    source: n.source,
    board: { id: t.meta.id, title: t.meta.title },
    teamId: t.meta.teamId,
    shots: a,
    bundle: p,
    counts: { steps: o.length, errors: r.length },
    build: e.build,
    env: f
  };
}
var ske = Object.defineProperty, oke = (n, e, t) => e in n ? ske(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Ma = (n, e, t) => oke(n, typeof e != "symbol" ? e + "" : e, t);
const rl = 6, ub = "Six screenshots is the most a report holds.", rke = { upload: "from your computer", paste: "pasted", drop: "dropped in" };
function hb() {
  return {
    kind: "bug",
    happened: "",
    expected: "",
    source: "button",
    include: { steps: !0, state: !0, errors: !0, device: !0 },
    shots: [],
    active: 0,
    capturing: !1,
    sending: !1,
    error: null
  };
}
class ake {
  constructor(e) {
    Ma(this, "state", /* @__PURE__ */ Xt({ mode: "closed", flash: 0, ...hb() })), Ma(this, "recorder"), Ma(this, "board"), Ma(this, "sink"), Ma(this, "build"), Ma(this, "disposed", !1), this.board = e.board, this.recorder = e.recorder, this.sink = e.sink, this.build = e.build;
  }
  get hasDraft() {
    const e = this.state;
    return e.shots.length > 0 || !!e.happened.trim() || !!e.expected.trim();
  }
  get canSend() {
    return !!this.state.happened.trim() && !this.state.sending && !this.state.capturing;
  }
  /**
   * Feedback asked for. Stepped aside, it takes the next screenshot. With a
   * draft waiting, the button and the menu reopen it as it was, and the key
   * adds the view it caught. Otherwise a new report starts with a screenshot.
   */
  async start(e) {
    const t = this.state;
    if (!(this.disposed || t.mode === "open" || t.capturing || t.sending)) {
      if (t.mode === "aside") {
        await this.capture();
        return;
      }
      if (this.hasDraft && e !== "key") {
        this.open("Reopened the draft report");
        return;
      }
      this.hasDraft || (t.source = e), e !== "key" && (this.board.ui.boardMenu = !1, await it()), await this.capture(), this.open("Opened Send Feedback (" + (e === "key" ? "the ` key" : e === "menu" ? "the board menu" : "the Feedback button") + ")");
    }
  }
  open(e) {
    this.board.ui.boardMenu = !1, this.state.mode = "open", this.recorder.record("panel", e);
  }
  /** "Add screenshot": the reporter steps aside while the tester sets up the next view. */
  stepAside() {
    this.state.shots.length >= rl || (this.state.mode = "aside", this.recorder.record("panel", "Stepped aside to set up another screenshot"));
  }
  /** Back to the reporter from stepping aside. */
  resume() {
    this.state.mode === "aside" && this.open("Back to the report");
  }
  /** Close the reporter; the draft waits on the Feedback button. */
  close() {
    this.state.mode !== "closed" && (this.state.mode = "closed", this.recorder.record("panel", this.hasDraft ? "Closed Send Feedback, draft kept" : "Closed Send Feedback"));
  }
  discard() {
    this.releaseShots();
    const e = this.state.flash;
    Object.assign(this.state, { mode: "closed", flash: e }, hb()), this.recorder.record("panel", "Discarded a draft report");
  }
  removeShot(e) {
    const t = this.state, i = t.shots[e];
    i && (URL.revokeObjectURL(i.url), t.shots.splice(e, 1), t.active >= t.shots.length ? t.active = Math.max(0, t.shots.length - 1) : t.active > e && t.active--, this.recorder.record("shot", "Removed screenshot " + (e + 1)));
  }
  /** Take a screenshot of the board as it is now. */
  async capture() {
    const e = this.state;
    if (e.capturing) return !1;
    if (e.shots.length >= rl)
      return this.board.toast(ub), !1;
    const t = this.board.worldEl ? this.board.worldEl.closest(".bd-root") : null;
    if (!(t instanceof HTMLElement)) return !1;
    e.capturing = !0, e.error = null, e.flash++;
    try {
      const i = this.board.cam.value, s = await Jwe(t, this.board.engine, {
        camera: { x: Math.round(i.x), y: Math.round(i.y), zoom: Math.round(i.zoom * 1e3) / 1e3 },
        selection: this.board.ui.selection.slice(),
        panels: vI(this.board)
      });
      return this.disposed ? (URL.revokeObjectURL(s.url), !1) : (e.shots.push(Nb(s)), e.active = e.shots.length - 1, this.recorder.record("shot", "Took screenshot " + e.shots.length, s.w + " × " + s.h), !0);
    } catch (i) {
      return console.warn("[board] the feedback screenshot failed", i), e.error = "The screenshot couldn't be taken. You can still send your report.", !1;
    } finally {
      e.capturing = !1;
    }
  }
  /**
   * Pictures from their computer (chosen, pasted or dropped in), as many as
   * the report has room for. Anything else is left out, and why is said.
   * Resolves to how many were added.
   */
  async addFiles(e, t) {
    const i = this.state;
    if (this.disposed || i.capturing || i.sending || !e.length) return 0;
    const s = e.filter(OI);
    if (!s.length)
      return i.error = "Only pictures can be added as screenshots.", 0;
    const o = rl - i.shots.length;
    if (o <= 0)
      return i.error = ub, 0;
    i.capturing = !0, i.error = null;
    let r = 0, a = 0;
    try {
      for (const l of s.slice(0, o))
        try {
          const d = await eke(l, t);
          if (this.disposed)
            return URL.revokeObjectURL(d.url), r;
          i.shots.push(Nb(d)), i.active = i.shots.length - 1, r++, this.recorder.record("shot", "Added screenshot " + i.shots.length + " (" + rke[t] + ")", d.w + " × " + d.h);
        } catch (d) {
          console.warn("[board] a picture couldn't be added to the feedback report", d), a++;
        }
    } finally {
      i.capturing = !1;
    }
    return a ? i.error = (a === 1 ? "A picture" : a + " pictures") + " couldn't be read. Try a PNG or JPEG under 40 MB." : s.length > o ? i.error = ub + " " + (s.length - o) + " " + (s.length - o === 1 ? "picture wasn't" : "pictures weren't") + " added." : s.length < e.length && (i.error = "Only pictures can be added as screenshots."), r;
  }
  async send() {
    const e = this.state;
    if (this.canSend) {
      e.sending = !0, e.error = null;
      try {
        const t = await ike(
          { kind: e.kind, happened: e.happened, expected: e.expected, source: e.source, include: { ...e.include }, shots: e.shots.slice() },
          { board: this.board, recorder: this.recorder, build: this.build }
        ), i = await this.sink.submit(t);
        if (this.disposed) return;
        if (!i.success) {
          e.error = i.message;
          return;
        }
        this.recorder.record("panel", "Sent report " + i.number), this.releaseShots();
        const s = e.flash;
        Object.assign(e, { mode: "closed", flash: s }, hb()), this.board.toast("Thanks. Report " + i.number + " is with RunDiffusion.");
      } catch (t) {
        console.warn("[board] the feedback report couldn't be sent", t), e.error = t instanceof BI ? t.message : "Your report couldn't be sent. Check your connection and try again.";
      } finally {
        e.sending = !1;
      }
    }
  }
  releaseShots() {
    for (const e of this.state.shots) URL.revokeObjectURL(e.url);
  }
  dispose() {
    this.disposed = !0, this.releaseShots();
  }
}
const lke = { class: "fb-head" }, dke = { class: "fb-mark" }, cke = { class: "fb-body" }, uke = {
  class: "fb-shots",
  "aria-label": "Screenshots"
}, hke = {
  class: "fb-preview",
  "data-testid": "feedback-preview"
}, pke = ["src", "alt"], fke = {
  key: 1,
  class: "fb-preview-note"
}, mke = {
  key: 2,
  class: "fb-preview-note"
}, gke = {
  key: 3,
  class: "fb-drop",
  "data-testid": "feedback-drop"
}, bke = { class: "fb-strip" }, vke = ["aria-label", "aria-pressed", "onClick"], yke = ["src"], xke = { class: "fb-thumb-n" }, wke = ["title", "aria-label", "onClick"], kke = ["disabled", "title"], _ke = ["disabled", "title"], Ske = {
  key: 0,
  class: "fb-tip"
}, Tke = {
  class: "fb-form",
  "aria-label": "Your report"
}, Mke = {
  class: "fb-seg",
  role: "radiogroup",
  "aria-label": "What kind of feedback"
}, Cke = ["aria-checked", "data-testid", "onClick"], Ike = { class: "fb-field" }, Ake = { class: "fb-label" }, Pke = ["placeholder"], Eke = { class: "fb-field" }, Rke = { class: "fb-label" }, zke = ["placeholder"], $ke = {
  class: "fb-inc-box",
  "data-testid": "feedback-includes"
}, Dke = { class: "fb-inc" }, Oke = { class: "fb-inc-what is-fixed" }, Lke = { class: "fb-inc" }, Bke = { class: "fb-inc-what" }, Fke = ["aria-expanded"], Nke = {
  key: 0,
  class: "fb-peek",
  "data-testid": "feedback-peek"
}, Uke = { class: "fb-inc" }, Gke = { class: "fb-inc-what" }, jke = ["aria-expanded"], Hke = {
  key: 1,
  class: "fb-peek"
}, Vke = {
  key: 2,
  class: "fb-inc"
}, Wke = { class: "fb-inc-what" }, qke = ["aria-expanded"], Kke = {
  key: 3,
  class: "fb-inc"
}, Yke = { class: "fb-inc-what is-fixed" }, Xke = {
  key: 4,
  class: "fb-peek"
}, Jke = { class: "fb-inc" }, Zke = { class: "fb-inc-what" }, Qke = ["aria-expanded"], e2e = {
  key: 5,
  class: "fb-peek"
}, t2e = { class: "fb-foot" }, n2e = {
  key: 0,
  class: "fb-error",
  role: "alert",
  "data-testid": "feedback-error"
}, i2e = {
  class: "fb-keys",
  "aria-hidden": "true"
}, s2e = ["disabled", "title"], o2e = /* @__PURE__ */ Re({
  __name: "FeedbackDialog",
  props: {
    feedback: {}
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = e.feedback, s = i.state, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(!1), d = /* @__PURE__ */ K(!1), c = /* @__PURE__ */ K(null), u = /* @__PURE__ */ K(0), p = [
      { id: "bug", label: "Bug", icon: "Bug", q1: "What happened?", p1: "I dragged two images into the frame and one jumped back.", q2: "What did you expect?", p2: "Both stay where I dropped them." },
      { id: "confusing", label: "Confusing", icon: "CircleHelp", q1: "What were you trying to do?", p1: "Start a new image session from a note.", q2: "What got in the way?", p2: "I couldn't find where sessions start." },
      { id: "idea", label: "Idea", icon: "Lightbulb", q1: "What would you like?", p1: "Let me keep the prompt open while I pan.", q2: "What would it help you do?", p2: "Compare results without losing my settings." }
    ], f = I(() => p.find((te) => te.id === s.kind) || p[0]), y = I(() => s.shots[s.active] || null), b = I(() => (u.value, i.recorder.list())), w = I(() => b.value.filter((te) => te.kind === "error" || te.kind === "warn")), k = I(() => (t.docRev.value, t.store.size)), S = I(() => UI(t.engine ? t.engine.gpu() : null)), _ = I(() => s.shots.length ? s.shots.length + (s.shots.length === 1 ? " screenshot" : " screenshots") : "No screenshots"), x = Tn(["mod", "enter"]), T = Tn(["mod", "V"]), M = I(() => s.shots.length >= rl);
    function z(te) {
      return new Date(te).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", second: "2-digit" });
    }
    function P(te) {
      return te.slice().reverse().map((G) => z(G.at) + "  " + G.label + (G.detail ? "  (" + G.detail + ")" : "")).join(`
`) || "Nothing yet.";
    }
    const D = I(() => (u.value, c.value === "steps" ? P(b.value) : c.value === "errors" ? P(w.value) : c.value === "state" ? JSON.stringify(GI(t), null, 2) : c.value === "device" ? JSON.stringify(S.value, null, 2) : ""));
    function $(te) {
      u.value++, c.value = c.value === te ? null : te;
    }
    function O(te) {
      if (te.stopPropagation(), te.key === "Escape") {
        te.preventDefault(), d.value ? d.value = !1 : i.close();
        return;
      }
      te.key === "Enter" && vn(te) && (te.preventDefault(), i.send());
    }
    function L() {
      a.value && a.value.click();
    }
    function Z() {
      const te = a.value;
      if (!te) return;
      const G = Array.from(te.files || []);
      te.value = "", G.length && i.addFiles(G, "upload");
    }
    function J(te) {
      const G = te.clipboardData ? Array.from(te.clipboardData.files || []) : [];
      G.some(OI) && (te.preventDefault(), te.stopImmediatePropagation(), i.addFiles(G, "paste"));
    }
    function re(te) {
      return !!te.dataTransfer && Array.from(te.dataTransfer.types || []).indexOf("Files") >= 0;
    }
    function F(te) {
      re(te) && (te.preventDefault(), te.dataTransfer && (te.dataTransfer.dropEffect = "copy"), l.value = !0);
    }
    function W(te) {
      const G = te.relatedTarget;
      (!(G instanceof Node) || !(te.currentTarget instanceof Node) || !te.currentTarget.contains(G)) && (l.value = !1);
    }
    function ee(te) {
      l.value = !1, !(!re(te) || !te.dataTransfer) && (te.preventDefault(), i.addFiles(Array.from(te.dataTransfer.files || []), "drop"));
    }
    let N = null;
    return ot(() => {
      N = document.activeElement, window.addEventListener("keydown", O, !0), window.addEventListener("paste", J, !0), it(() => {
        r.value && !s.happened ? r.value.focus({ preventScroll: !0 }) : o.value && o.value.focus({ preventScroll: !0 });
      });
    }), Ve(() => {
      window.removeEventListener("keydown", O, !0), window.removeEventListener("paste", J, !0), N && document.contains(N) && N.focus({ preventScroll: !0 });
    }), (te, G) => (g(), v("div", {
      class: "fb",
      "data-testid": "feedback",
      "data-feedback-skip": "",
      "data-lb-own-keys": "",
      onPointerdown: G[17] || (G[17] = Pe((q) => m(i).close(), ["self"])),
      onWheel: G[18] || (G[18] = Pe(() => {
      }, ["stop"])),
      onDragover: F,
      onDragleave: W,
      onDrop: ee
    }, [
      h("div", {
        ref_key: "card",
        ref: o,
        class: U(["fb-card", { "is-dropping": l.value }]),
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "fb-title",
        tabindex: "-1",
        onPointerdown: G[16] || (G[16] = Pe(() => {
        }, ["stop"]))
      }, [
        h("header", lke, [
          h("span", dke, [
            C(R, {
              name: "MessageSquareWarning",
              size: 17
            })
          ]),
          G[19] || (G[19] = h("div", { class: "fb-titles" }, [
            h("h2", { id: "fb-title" }, "Send feedback"),
            h("p", null, "Your screenshots and your recent steps on this board go with it. You can check everything before you send.")
          ], -1)),
          h("button", {
            class: "fb-close",
            title: "Close (your draft is kept)",
            "aria-label": "Close (your draft is kept)",
            "data-testid": "feedback-close",
            onClick: G[0] || (G[0] = (q) => m(i).close())
          }, [
            C(R, {
              name: "X",
              size: 15
            })
          ])
        ]),
        h("div", cke, [
          h("section", uke, [
            h("div", hke, [
              y.value ? (g(), v("img", {
                key: 0,
                src: y.value.url,
                alt: "Screenshot " + (m(s).active + 1),
                "data-testid": "feedback-preview-image"
              }, null, 8, pke)) : m(s).capturing ? (g(), v("span", fke, [
                C(R, {
                  name: "Loader2",
                  size: 14,
                  spin: ""
                }),
                G[20] || (G[20] = X("Adding the screenshot…", -1))
              ])) : (g(), v("span", mke, "No screenshots. Add one, or send without.")),
              l.value ? (g(), v("div", gke, [
                C(R, {
                  name: "Upload",
                  size: 20
                }),
                h("span", null, A(M.value ? "Six screenshots is the most a report holds" : "Drop to add it as a screenshot"), 1)
              ])) : E("", !0)
            ]),
            h("div", bke, [
              (g(!0), v(H, null, me(m(s).shots, (q, B) => (g(), v("div", {
                key: q.url,
                class: U(["fb-thumb", { on: B === m(s).active }]),
                "data-testid": "feedback-thumb"
              }, [
                h("button", {
                  class: "fb-thumb-pick",
                  "aria-label": "Show screenshot " + (B + 1),
                  "aria-pressed": B === m(s).active,
                  onClick: (ne) => m(s).active = B
                }, [
                  h("img", {
                    src: q.url,
                    alt: ""
                  }, null, 8, yke)
                ], 8, vke),
                h("span", xke, A(B + 1), 1),
                h("button", {
                  class: "fb-thumb-x",
                  title: "Remove screenshot " + (B + 1),
                  "aria-label": "Remove screenshot " + (B + 1),
                  "data-testid": "feedback-remove-shot",
                  onClick: (ne) => m(i).removeShot(B)
                }, [
                  C(R, {
                    name: "X",
                    size: 11
                  })
                ], 8, wke)
              ], 2))), 128)),
              h("button", {
                class: "fb-add",
                disabled: M.value || m(s).capturing,
                title: M.value ? "Six screenshots is the most a report holds" : "Set up another view on the board, then capture it",
                "data-testid": "feedback-add-shot",
                onClick: G[1] || (G[1] = (q) => m(i).stepAside())
              }, [
                C(R, {
                  name: "Camera",
                  size: 15
                }),
                G[21] || (G[21] = X("Capture board ", -1))
              ], 8, kke),
              h("button", {
                class: "fb-add",
                disabled: M.value || m(s).capturing,
                title: M.value ? "Six screenshots is the most a report holds" : "Add a picture from your computer",
                "data-testid": "feedback-upload",
                onClick: L
              }, [
                C(R, {
                  name: "Upload",
                  size: 15
                }),
                G[22] || (G[22] = X("Upload image ", -1))
              ], 8, _ke),
              h("input", {
                ref_key: "fileEl",
                ref: a,
                type: "file",
                accept: "image/*",
                multiple: "",
                hidden: "",
                "data-testid": "feedback-upload-input",
                onChange: Z
              }, null, 544)
            ]),
            M.value ? E("", !0) : (g(), v("p", Ske, "You can also paste a picture (" + A(m(T)) + ") or drop one here.", 1))
          ]),
          h("section", Tke, [
            h("div", Mke, [
              (g(), v(H, null, me(p, (q) => h("button", {
                key: q.id,
                role: "radio",
                "aria-checked": m(s).kind === q.id,
                class: U({ "is-on": m(s).kind === q.id }),
                "data-testid": "feedback-kind-" + q.id,
                onClick: (B) => m(s).kind = q.id
              }, [
                C(R, {
                  name: q.icon,
                  size: 13
                }, null, 8, ["name"]),
                X(A(q.label), 1)
              ], 10, Cke)), 64))
            ]),
            h("label", Ike, [
              h("span", Ake, A(f.value.q1), 1),
              xt(h("textarea", {
                ref_key: "happenedEl",
                ref: r,
                "onUpdate:modelValue": G[2] || (G[2] = (q) => m(s).happened = q),
                class: "fb-text",
                placeholder: f.value.p1,
                maxlength: "4000",
                "data-testid": "feedback-happened"
              }, null, 8, Pke), [
                [Jt, m(s).happened]
              ])
            ]),
            h("label", Eke, [
              h("span", Rke, A(f.value.q2), 1),
              xt(h("textarea", {
                "onUpdate:modelValue": G[3] || (G[3] = (q) => m(s).expected = q),
                class: "fb-text is-short",
                placeholder: f.value.p2,
                maxlength: "4000",
                "data-testid": "feedback-expected"
              }, null, 8, zke), [
                [Jt, m(s).expected]
              ])
            ]),
            h("div", $ke, [
              G[29] || (G[29] = h("div", { class: "fb-inc-h" }, "Sent with your report", -1)),
              h("div", Dke, [
                h("span", Oke, [
                  C(R, {
                    name: "Check",
                    size: 13
                  }),
                  h("span", null, [
                    X(A(_.value), 1),
                    G[23] || (G[23] = h("small", null, "Remove any in the strip", -1))
                  ])
                ])
              ]),
              h("div", Lke, [
                h("label", Bke, [
                  xt(h("input", {
                    "onUpdate:modelValue": G[4] || (G[4] = (q) => m(s).include.steps = q),
                    type: "checkbox",
                    "data-testid": "feedback-include-steps"
                  }, null, 512), [
                    [Na, m(s).include.steps]
                  ]),
                  h("span", null, [
                    X("Your last " + A(b.value.length) + " steps on this board", 1),
                    G[24] || (G[24] = h("small", null, "What you moved, ran and opened, with times", -1))
                  ])
                ]),
                h("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "steps",
                  "data-testid": "feedback-view-steps",
                  onClick: G[5] || (G[5] = (q) => $("steps"))
                }, A(c.value === "steps" ? "Hide" : "View"), 9, Fke)
              ]),
              c.value === "steps" ? (g(), v("pre", Nke, A(D.value), 1)) : E("", !0),
              h("div", Uke, [
                h("label", Gke, [
                  xt(h("input", {
                    "onUpdate:modelValue": G[6] || (G[6] = (q) => m(s).include.state = q),
                    type: "checkbox",
                    "data-testid": "feedback-include-state"
                  }, null, 512), [
                    [Na, m(s).include.state]
                  ]),
                  h("span", null, [
                    G[25] || (G[25] = X("The board as it is now", -1)),
                    h("small", null, A(k.value) + " " + A(k.value === 1 ? "element" : "elements") + ", the view and your selection", 1)
                  ])
                ]),
                h("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "state",
                  onClick: G[7] || (G[7] = (q) => $("state"))
                }, A(c.value === "state" ? "Hide" : "View"), 9, jke)
              ]),
              c.value === "state" ? (g(), v("pre", Hke, A(D.value), 1)) : E("", !0),
              w.value.length ? (g(), v("div", Vke, [
                h("label", Wke, [
                  xt(h("input", {
                    "onUpdate:modelValue": G[8] || (G[8] = (q) => m(s).include.errors = q),
                    type: "checkbox",
                    "data-testid": "feedback-include-errors"
                  }, null, 512), [
                    [Na, m(s).include.errors]
                  ]),
                  h("span", null, [
                    X(A(w.value.length) + " " + A(w.value.length === 1 ? "error or warning" : "errors and warnings"), 1),
                    G[26] || (G[26] = h("small", null, "What the board logged while you worked", -1))
                  ])
                ]),
                h("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "errors",
                  onClick: G[9] || (G[9] = (q) => $("errors"))
                }, A(c.value === "errors" ? "Hide" : "View"), 9, qke)
              ])) : (g(), v("div", Kke, [
                h("span", Yke, [
                  C(R, {
                    name: "Check",
                    size: 13
                  }),
                  G[27] || (G[27] = h("span", null, "No errors seen", -1))
                ])
              ])),
              c.value === "errors" ? (g(), v("pre", Xke, A(D.value), 1)) : E("", !0),
              h("div", Jke, [
                h("label", Zke, [
                  xt(h("input", {
                    "onUpdate:modelValue": G[10] || (G[10] = (q) => m(s).include.device = q),
                    type: "checkbox",
                    "data-testid": "feedback-include-device"
                  }, null, 512), [
                    [Na, m(s).include.device]
                  ]),
                  h("span", null, [
                    G[28] || (G[28] = X("Browser, device and app version", -1)),
                    h("small", null, A(S.value.browser) + " on " + A(S.value.os), 1)
                  ])
                ]),
                h("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "device",
                  onClick: G[11] || (G[11] = (q) => $("device"))
                }, A(c.value === "device" ? "Hide" : "View"), 9, Qke)
              ]),
              c.value === "device" ? (g(), v("pre", e2e, A(D.value), 1)) : E("", !0)
            ])
          ])
        ]),
        h("footer", t2e, [
          d.value ? (g(), v(H, { key: 0 }, [
            G[30] || (G[30] = h("span", { class: "fb-confirm" }, "Discard this report and its screenshots?", -1)),
            h("button", {
              class: "bd-btn is-ghost",
              "data-testid": "feedback-discard-keep",
              onClick: G[12] || (G[12] = (q) => d.value = !1)
            }, "Keep it"),
            h("button", {
              class: "bd-btn",
              "data-testid": "feedback-discard-confirm",
              onClick: G[13] || (G[13] = (q) => m(i).discard())
            }, "Discard")
          ], 64)) : (g(), v(H, { key: 1 }, [
            G[31] || (G[31] = h("span", { class: "fb-note" }, "Only RunDiffusion staff can see reports.", -1)),
            m(s).error ? (g(), v("span", n2e, A(m(s).error), 1)) : E("", !0),
            h("button", {
              class: "bd-btn is-ghost",
              "data-testid": "feedback-discard",
              onClick: G[14] || (G[14] = (q) => d.value = !0)
            }, "Discard"),
            h("span", i2e, A(m(x)), 1),
            h("button", {
              class: "bd-btn",
              disabled: !m(i).canSend,
              title: m(i).canSend ? "Send report (" + m(x) + ")" : "Write a line about it first",
              "data-testid": "feedback-send",
              onClick: G[15] || (G[15] = (q) => m(i).send())
            }, [
              C(R, {
                name: m(s).sending ? "Loader2" : "Send",
                size: 14,
                spin: m(s).sending
              }, null, 8, ["name", "spin"]),
              X(A(m(s).sending ? "Sending…" : "Send report"), 1)
            ], 8, s2e)
          ], 64))
        ])
      ], 34)
    ], 32));
  }
}), r2e = {
  class: "fb-aside",
  role: "status",
  "data-testid": "feedback-aside",
  "data-feedback-skip": "",
  "data-feedback-bar": ""
}, a2e = { class: "fb-aside-mark" }, l2e = { class: "fb-aside-text" }, d2e = {
  class: "fb-aside-count",
  "data-testid": "feedback-aside-count"
}, c2e = ["disabled"], u2e = /* @__PURE__ */ Re({
  __name: "FeedbackShotBar",
  props: {
    feedback: {}
  },
  setup(n) {
    const e = n, t = e.feedback.state, i = I(() => t.shots.length >= rl);
    return (s, o) => (g(), v("div", r2e, [
      h("span", a2e, [
        C(R, {
          name: "Camera",
          size: 13
        })
      ]),
      h("span", l2e, A(i.value ? "Six screenshots is the most a report holds" : "Set up the next screenshot, then capture it"), 1),
      h("span", d2e, A(m(t).shots.length) + " of " + A(m(rl)), 1),
      h("button", {
        class: "fb-aside-btn is-cta",
        disabled: i.value || m(t).capturing,
        title: "Capture (`)",
        "data-testid": "feedback-capture",
        onClick: o[0] || (o[0] = (r) => e.feedback.capture())
      }, [
        C(R, {
          name: "Camera",
          size: 12
        }),
        o[2] || (o[2] = X("Capture ", -1))
      ], 8, c2e),
      h("button", {
        class: "fb-aside-btn",
        title: "Back to your report (Esc)",
        "data-testid": "feedback-aside-done",
        onClick: o[1] || (o[1] = (r) => e.feedback.resume())
      }, "Done")
    ]));
  }
}), Vo = /* @__PURE__ */ Re({
  __name: "Avatar",
  props: {
    uid: {},
    name: {},
    size: { default: 26 }
  },
  setup(n) {
    const e = n, t = I(() => {
      const [s, o] = fte(e.uid || e.name);
      return {
        width: e.size + "px",
        height: e.size + "px",
        fontSize: Math.round(e.size * 0.38) + "px",
        background: "linear-gradient(140deg, " + s + ", " + o + ")"
      };
    }), i = I(() => ta(e.name || "?").slice(0, 2));
    return (s, o) => (g(), v("span", {
      class: "cm-avatar",
      style: de(t.value),
      "aria-hidden": "true"
    }, A(i.value), 5));
  }
}), h2e = ["href"], Fc = /* @__PURE__ */ Re({
  __name: "CommentText",
  props: {
    text: {},
    mentions: {},
    me: {},
    clamp: {}
  },
  setup(n) {
    const e = n, t = I(() => dte(e.text, e.mentions, e.me)), i = I(() => !e.clamp && ste(e.text));
    return (s, o) => (g(), v("span", {
      class: U(["cm-text", { "is-big": i.value, "is-clamped": !!n.clamp }]),
      style: de(n.clamp ? { "-webkit-line-clamp": String(n.clamp) } : void 0)
    }, [
      (g(!0), v(H, null, me(t.value, (r, a) => (g(), v(H, { key: a }, [
        r.kind === "mention" ? (g(), v("span", {
          key: 0,
          class: U(["cm-mention", { "is-me": r.me }])
        }, A(r.text), 3)) : r.kind === "link" ? (g(), v("a", {
          key: 1,
          class: "cm-link",
          href: r.href,
          target: "_blank",
          rel: "noopener noreferrer",
          onPointerdown: o[0] || (o[0] = Pe(() => {
          }, ["stop"])),
          onClick: o[1] || (o[1] = Pe(() => {
          }, ["stop"]))
        }, A(r.text), 41, h2e)) : (g(), v(H, { key: 2 }, [
          X(A(r.text), 1)
        ], 64))
      ], 64))), 128))
    ], 6));
  }
}), Fs = [
  { id: "amethyst", label: "Amethyst", hex: "#9968df" },
  { id: "vista", label: "Vista", hex: "#6b72f0" },
  { id: "sky", label: "Sky", hex: "#3db4e6" },
  { id: "mint", label: "Mint", hex: "#34c79a" },
  { id: "amber", label: "Amber", hex: "#f2a93b" },
  { id: "rose", label: "Rose", hex: "#ef5f7a" }
];
function p2e(n) {
  return typeof n == "string" && Fs.some((e) => e.id === n);
}
const f2e = ["aria-label", "data-thread", "onPointerdown", "onMouseenter"], m2e = { class: "cm-pin-face" }, g2e = {
  key: 0,
  class: "cm-pin-check"
}, b2e = {
  key: 0,
  class: "cm-pin-count"
}, v2e = {
  key: 1,
  class: "cm-pin-dot",
  "data-testid": "comment-pin-unread"
}, y2e = {
  key: 0,
  class: "cm-peek",
  "data-testid": "comment-peek"
}, x2e = { class: "cm-peek-head" }, w2e = {
  key: 0,
  class: "cm-peek-foot"
}, k2e = {
  class: "cm-pin is-draft",
  "data-testid": "comment-draft-pin"
}, _2e = { class: "cm-pin-face" }, S2e = /* @__PURE__ */ Re({
  __name: "CommentPins",
  setup(n) {
    const { board: e } = tt(), t = e.comments, i = e.user.uid, s = Ko(), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ We(null);
    let a = 0;
    const l = I(() => t.ui.showPins ? t.pins.value : t.pins.value.filter((_) => _.t.id === t.ui.openId)), d = (_) => (Fs.find((x) => x.id === _) || Fs[0]).hex, c = I(() => t.ui.flash ? t.ui.flash.id + ":" + t.ui.flash.n : "");
    function u(_) {
      return t.commentsOf(_.t.id)[0] || null;
    }
    function p(_) {
      clearTimeout(a), a = window.setTimeout(() => {
        r.value = _;
      }, 220);
    }
    function f() {
      clearTimeout(a), r.value = null;
    }
    Ve(() => clearTimeout(a));
    function y(_, x) {
      if (x.button !== 0) return;
      x.stopPropagation(), x.preventDefault(), f();
      const T = { x: x.clientX, y: x.clientY };
      let M = !1;
      const z = (D) => {
        if (!M && Math.hypot(D.clientX - T.x, D.clientY - T.y) < 4) return;
        M = !0;
        const $ = e.screenToWorld(D.clientX, D.clientY);
        t.ui.dragging = { id: _.t.id, x: $.x, y: $.y };
      }, P = (D) => {
        window.removeEventListener("pointermove", z), window.removeEventListener("pointerup", P), window.removeEventListener("pointercancel", P);
        const $ = t.ui.dragging;
        if (M && $) {
          t.moveTo(_.t.id, $.x, $.y), window.setTimeout(() => {
            t.ui.dragging && t.ui.dragging.id === _.t.id && (t.ui.dragging = null);
          }, 400);
          return;
        }
        t.ui.dragging = null, D.type !== "pointercancel" && (t.ui.openId === _.t.id ? t.close() : t.open(_.t.id));
      };
      window.addEventListener("pointermove", z), window.addEventListener("pointerup", P), window.addEventListener("pointercancel", P);
    }
    let b = null;
    function w(_) {
      return _ instanceof Element && !!_.closest(".cm-pin, .cm-card, .cm-emoji, .cm-menu, .cm-peek");
    }
    function k(_) {
      if (!(_.button !== 0 || w(_.target))) {
        if (t.ui.armed) {
          if (b && b.classList.contains("is-hand")) return;
          _.preventDefault(), _.stopPropagation(), t.placeAt(_.clientX, _.clientY);
          return;
        }
        t.ui.openId && t.close(), t.ui.draft && !t.ui.draft.text.trim() && t.cancelDraft();
      }
    }
    ot(() => {
      b = o.value ? o.value.closest(".cv-stage") : null, b && b.addEventListener("pointerdown", k, !0);
    }), Ve(() => {
      b && (b.removeEventListener("pointerdown", k, !0), b.classList.remove("is-commenting"));
    }), $e(() => t.ui.armed, (_) => {
      b && b.classList.toggle("is-commenting", _);
    }, { flush: "post" });
    const S = I(() => t.ui.draft);
    return (_, x) => (g(), v("div", {
      ref_key: "root",
      ref: o,
      class: U(["cm-pins", { "is-armed": m(t).ui.armed }])
    }, [
      (g(!0), v(H, null, me(l.value, (T) => (g(), v("div", {
        key: T.t.id,
        class: U(["cm-pin-at", { "is-open": m(t).ui.openId === T.t.id, "is-resolved": !!T.t.resolvedAt, "is-dragging": !!m(t).ui.dragging && m(t).ui.dragging.id === T.t.id }]),
        style: de({ left: T.x + "px", top: T.y + "px", "--thread": d(T.t.color) })
      }, [
        (g(), v("button", {
          key: c.value.startsWith(T.t.id + ":") ? c.value : T.t.id,
          class: U(["cm-pin", { "is-unread": T.unread, "is-flash": c.value.startsWith(T.t.id + ":") }]),
          "aria-label": "Comment by " + T.t.createdByName + (T.unread ? ", unread" : ""),
          "data-thread": T.t.id,
          "data-testid": "comment-pin",
          onPointerdown: (M) => y(T, M),
          onMouseenter: (M) => p(T.t.id),
          onMouseleave: f
        }, [
          h("span", m2e, [
            T.t.resolvedAt ? (g(), v("span", g2e, [
              C(R, {
                name: "Check",
                size: 15,
                stroke: 3
              })
            ])) : (g(), Ce(Vo, {
              key: 1,
              uid: T.t.createdBy,
              name: T.t.createdByName,
              size: 26
            }, null, 8, ["uid", "name"]))
          ]),
          T.count > 1 ? (g(), v("span", b2e, A(T.count > 99 ? "99+" : T.count), 1)) : E("", !0),
          T.unread ? (g(), v("span", v2e)) : E("", !0)
        ], 42, f2e)),
        r.value === T.t.id && m(t).ui.openId !== T.t.id && u(T) ? (g(), v("div", y2e, [
          h("div", x2e, [
            h("b", null, A(u(T).authorName), 1),
            h("span", null, A(m(Jn)(T.t.lastAt, m(s))), 1)
          ]),
          C(Fc, {
            text: u(T).text,
            mentions: u(T).mentions,
            me: m(i),
            clamp: 3
          }, null, 8, ["text", "mentions", "me"]),
          T.count > 1 ? (g(), v("div", w2e, [
            X(A(T.count - 1 === 1 ? "1 reply" : T.count - 1 + " replies"), 1),
            m(t).freshIn(T.t) ? (g(), v(H, { key: 0 }, [
              x[0] || (x[0] = X(" · ", -1)),
              h("em", null, A(m(t).freshIn(T.t)) + " new", 1)
            ], 64)) : E("", !0)
          ])) : E("", !0)
        ])) : E("", !0)
      ], 6))), 128)),
      S.value ? (g(), v("div", {
        key: 0,
        class: "cm-pin-at is-draft",
        style: de({ left: S.value.anchor.x + "px", top: S.value.anchor.y + "px" })
      }, [
        h("span", k2e, [
          h("span", _2e, [
            C(Vo, {
              uid: m(i),
              name: m(t).myName,
              size: 26
            }, null, 8, ["uid", "name"])
          ])
        ])
      ], 4)) : E("", !0)
    ], 2));
  }
}), T2e = { class: "cm-emoji-head" }, M2e = { class: "cm-emoji-search" }, C2e = ["aria-label", "onClick"], I2e = {
  key: 0,
  class: "cm-emoji-quick",
  "data-testid": "emoji-quick"
}, A2e = ["onClick"], P2e = {
  key: 1,
  class: "cm-emoji-tabs",
  "aria-label": "Categories"
}, E2e = ["title", "aria-label", "onClick"], R2e = {
  key: 0,
  class: "cm-emoji-grid"
}, z2e = ["aria-label", "onMouseenter", "onClick"], $2e = {
  key: 1,
  class: "cm-emoji-none"
}, D2e = {
  key: 0,
  class: "cm-emoji-sec",
  "data-group": "recent"
}, O2e = { class: "cm-emoji-grid" }, L2e = ["aria-label", "onMouseenter", "onClick"], B2e = ["data-group"], F2e = { class: "cm-emoji-label" }, N2e = { class: "cm-emoji-grid" }, U2e = ["aria-label", "onMouseenter", "onClick"], G2e = { class: "cm-emoji-foot" }, j2e = { class: "cm-emoji-big" }, H2e = { class: "cm-emoji-name" }, V2e = { class: "cm-emoji-code" }, W2e = {
  key: 1,
  class: "cm-emoji-hint"
}, pb = 340, Y_ = 392, X_ = 8, jI = /* @__PURE__ */ Re({
  __name: "EmojiPicker",
  props: {
    at: {},
    mode: { default: "insert" }
  },
  emits: ["pick", "close"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(""), l = /* @__PURE__ */ K(Qv()), d = /* @__PURE__ */ K(!1), c = /* @__PURE__ */ We(Zv()), u = /* @__PURE__ */ We(null), p = /* @__PURE__ */ K(Zv().length ? "recent" : "smileys"), f = Zee(), y = I(() => a.value.trim() ? pC(a.value, 160) : null), b = I(() => c.value.map((O) => ({ c: O, e: ky(O) })).filter((O) => !!O.e)), w = I(() => [
      ...b.value.length ? [{ key: "recent", label: "Recent", icon: "Clock" }] : [],
      ...f.map((O) => ({ key: O.key, label: O.label, icon: k[O.key] || "Smile" }))
    ]), k = {
      smileys: "Smile",
      people: "Hand",
      nature: "Leaf",
      food: "Coffee",
      travel: "Plane",
      activities: "Trophy",
      objects: "Lightbulb",
      symbols: "Heart",
      flags: "Flag"
    }, S = I(() => {
      const O = t.at, L = window.innerWidth, Z = window.innerHeight;
      let J = O.y + O.h + X_;
      J + Y_ > Z - 8 && (J = Math.max(8, O.y - X_ - Y_));
      let re = O.x + O.w - pb;
      return re < 8 && (re = Math.min(O.x, L - pb - 8)), { left: Math.max(8, Math.min(re, L - pb - 8)) + "px", top: J + "px" };
    });
    function _(O) {
      const L = typeof O == "string" ? O : Ha(O, l.value);
      i("pick", L);
    }
    function x(O) {
      l.value = O, tte(O), d.value = !1;
    }
    function T() {
      ete(), c.value = [], p.value === "recent" && (p.value = f[0].key);
    }
    function M(O) {
      a.value = "", it(() => {
        const L = o.value && o.value.querySelector('[data-group="' + O + '"]');
        L && o.value && o.value.scrollTo({ top: L.offsetTop - 4, behavior: "smooth" }), p.value = O;
      });
    }
    function z() {
      const O = o.value;
      if (!O || y.value) return;
      const L = O.querySelectorAll("[data-group]");
      let Z = p.value;
      for (const J of Array.from(L)) J.offsetTop - 24 <= O.scrollTop && (Z = J.dataset.group || Z);
      p.value = Z;
    }
    function P(O) {
      if (O.key === "Escape")
        O.preventDefault(), O.stopPropagation(), i("close");
      else if (O.key === "Enter") {
        O.preventDefault(), O.stopPropagation();
        const L = y.value;
        L && L[0] && _(L[0]);
      }
    }
    function D(O) {
      const L = O.target;
      s.value && L && s.value.contains(L) || i("close");
    }
    ot(() => {
      window.setTimeout(() => window.addEventListener("pointerdown", D, !0), 0), it(() => {
        r.value && r.value.focus({ preventScroll: !0 });
      });
    }), Ve(() => window.removeEventListener("pointerdown", D, !0));
    function $(O) {
      return O.s.length ? ":" + O.s[0] + ":" : "";
    }
    return (O, L) => (g(), v("div", {
      ref_key: "root",
      ref: s,
      class: U(["cm-emoji", "is-" + n.mode]),
      style: de(S.value),
      role: "dialog",
      "aria-label": "Emoji",
      "data-testid": "emoji-picker",
      onPointerdown: L[4] || (L[4] = Pe(() => {
      }, ["stop"])),
      onWheel: L[5] || (L[5] = Pe(() => {
      }, ["stop"])),
      onKeydown: P
    }, [
      h("div", T2e, [
        h("label", M2e, [
          C(R, {
            name: "Search",
            size: 13
          }),
          xt(h("input", {
            ref_key: "search",
            ref: r,
            "onUpdate:modelValue": L[0] || (L[0] = (Z) => a.value = Z),
            type: "text",
            placeholder: "Search emoji",
            spellcheck: "false",
            "data-testid": "emoji-search"
          }, null, 512), [
            [Jt, a.value]
          ]),
          a.value ? (g(), v("button", {
            key: 0,
            class: "cm-emoji-clear",
            title: "Clear",
            onClick: L[1] || (L[1] = (Z) => a.value = "")
          }, [
            C(R, {
              name: "X",
              size: 12
            })
          ])) : E("", !0)
        ]),
        h("div", {
          class: U(["cm-emoji-tone", { open: d.value }])
        }, [
          d.value ? (g(!0), v(H, { key: 1 }, me(m(L2), (Z, J) => (g(), v("button", {
            key: Z,
            class: U(["cm-emoji-tonebtn", { on: J === l.value }]),
            "aria-label": J ? "Skin tone " + J : "Default skin tone",
            onClick: (re) => x(J)
          }, A(Z), 11, C2e))), 128)) : (g(), v("button", {
            key: 0,
            class: "cm-emoji-tonebtn",
            title: "Skin tone",
            "data-testid": "emoji-tone",
            onClick: L[2] || (L[2] = (Z) => d.value = !0)
          }, A(m(L2)[l.value]), 1))
        ], 2)
      ]),
      n.mode === "react" && !a.value ? (g(), v("div", I2e, [
        (g(!0), v(H, null, me(m(Yee), (Z) => (g(), v("button", {
          key: Z,
          class: "cm-emo is-quick",
          onClick: (J) => _(Z)
        }, A(Z), 9, A2e))), 128))
      ])) : E("", !0),
      a.value ? E("", !0) : (g(), v("nav", P2e, [
        (g(!0), v(H, null, me(w.value, (Z) => (g(), v("button", {
          key: Z.key,
          class: U({ on: p.value === Z.key }),
          title: Z.label,
          "aria-label": Z.label,
          onClick: (J) => M(Z.key)
        }, [
          C(R, {
            name: Z.icon,
            size: 15
          }, null, 8, ["name"])
        ], 10, E2e))), 128))
      ])),
      h("div", {
        ref_key: "body",
        ref: o,
        class: "cm-emoji-body",
        onScrollPassive: z,
        onMouseleave: L[3] || (L[3] = (Z) => u.value = null)
      }, [
        y.value ? (g(), v(H, { key: 0 }, [
          y.value.length ? (g(), v("div", R2e, [
            (g(!0), v(H, null, me(y.value, (Z) => (g(), v("button", {
              key: Z.c,
              class: "cm-emo",
              "aria-label": Z.n,
              onMouseenter: (J) => u.value = Z,
              onClick: (J) => _(Z)
            }, A(m(Ha)(Z, l.value)), 41, z2e))), 128))
          ])) : (g(), v("div", $2e, "No emoji for “" + A(a.value) + "”", 1))
        ], 64)) : (g(), v(H, { key: 1 }, [
          b.value.length ? (g(), v("section", D2e, [
            h("div", { class: "cm-emoji-label" }, [
              L[6] || (L[6] = X("Recent", -1)),
              h("button", {
                class: "cm-emoji-clearrecent",
                onClick: T
              }, "Clear")
            ]),
            h("div", O2e, [
              (g(!0), v(H, null, me(b.value, (Z) => (g(), v("button", {
                key: "r" + Z.c,
                class: "cm-emo",
                "aria-label": Z.e.n,
                onMouseenter: (J) => u.value = Z.e,
                onClick: (J) => _(Z.c)
              }, A(Z.c), 41, L2e))), 128))
            ])
          ])) : E("", !0),
          (g(!0), v(H, null, me(m(f), (Z) => (g(), v("section", {
            key: Z.key,
            class: "cm-emoji-sec",
            "data-group": Z.key
          }, [
            h("div", F2e, A(Z.label), 1),
            h("div", N2e, [
              (g(!0), v(H, null, me(Z.emoji, (J) => (g(), v("button", {
                key: J.c,
                class: "cm-emo",
                "aria-label": J.n,
                onMouseenter: (re) => u.value = J,
                onClick: (re) => _(J)
              }, A(m(Ha)(J, l.value)), 41, U2e))), 128))
            ])
          ], 8, B2e))), 128))
        ], 64))
      ], 544),
      h("div", G2e, [
        u.value ? (g(), v(H, { key: 0 }, [
          h("span", j2e, A(m(Ha)(u.value, l.value)), 1),
          h("span", H2e, A(u.value.n), 1),
          h("span", V2e, A($(u.value)), 1)
        ], 64)) : (g(), v("span", W2e, A(n.mode === "react" ? "React with any emoji" : "Type : and a name in a comment for emoji too"), 1))
      ])
    ], 38));
  }
}), q2e = ["placeholder", "data-testid"], K2e = { class: "cm-compose-tools" }, Y2e = ["data-testid"], X2e = ["disabled", "data-testid"], J2e = ["data-testid"], Z2e = ["disabled", "data-testid"], Q2e = ["aria-selected", "onMouseenter", "onClick"], e_e = { class: "cm-menu-text" }, t_e = { key: 0 }, n_e = { class: "cm-menu-group" }, i_e = { class: "cm-menu-text" }, s_e = { class: "cm-menu-emoji" }, o_e = { class: "cm-menu-text" }, r_e = { key: 0 }, a_e = {
  key: 1,
  class: "cm-menu-alone"
}, y0 = /* @__PURE__ */ Re({
  __name: "Composer",
  props: {
    people: {},
    me: {},
    placeholder: { default: "Add a comment" },
    text: { default: "" },
    mentions: { default: () => [] },
    autofocus: { type: Boolean, default: !1 },
    group: { default: null },
    editing: { type: Boolean, default: !1 },
    alone: { default: null },
    testid: { default: "composer" }
  },
  emits: ["submit", "cancel", "edit-last", "change"],
  setup(n, { expose: e, emit: t }) {
    const i = n, s = t, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(i.text), d = /* @__PURE__ */ We(i.mentions.slice()), c = /* @__PURE__ */ K(0), u = /* @__PURE__ */ K(0), p = /* @__PURE__ */ We(null), f = /* @__PURE__ */ K(!1), y = /* @__PURE__ */ K(!1);
    let b = 0;
    function w() {
      y.value = !1, clearTimeout(b), requestAnimationFrame(() => {
        y.value = !0, b = window.setTimeout(() => {
          y.value = !1;
        }, 450);
      });
    }
    const k = I(() => l.value.trim().length > 0), S = I(() => {
      const N = cte(l.value, c.value);
      if (!N) return null;
      const te = l.value;
      return d.value.some((G) => te.startsWith("@" + G.name, N.start) && c.value > N.start + G.name.length) ? null : N;
    }), _ = I(() => S.value ? null : ute(l.value, c.value)), x = /* @__PURE__ */ K(-1), T = I(() => {
      const N = S.value;
      if (N && N.start !== x.value) {
        const G = i.alone ? i.people.filter((Y) => Y.uid !== i.me) : i.people, q = pte(G, N.query, i.me).slice(0, 7).map((Y) => ({ kind: "person", p: Y })), B = i.people.filter((Y) => Y.uid !== i.me), ne = i.group;
        return ne && B.length > 1 && B.length < gC && (!N.query || ne.toLowerCase().startsWith(N.query.toLowerCase()) || "everyone".startsWith(N.query.toLowerCase())) ? [{ kind: "group", label: ne, count: B.length }, ...q] : q;
      }
      const te = _.value;
      return te && te.start !== x.value ? pC(te.query, 6).map((G) => ({ kind: "emoji", e: G })) : [];
    }), M = I(() => T.value.length > 0 || !!S.value && S.value.start !== x.value && !!i.alone);
    $e(T, () => {
      u.value = 0;
    }), $e(M, (N) => {
      if (!N || !r.value) return;
      const te = r.value.getBoundingClientRect();
      f.value = window.innerHeight - te.bottom < 300 && te.top > window.innerHeight - te.bottom;
    });
    function z(N) {
      if (N.kind === "emoji") {
        const G = _.value;
        if (!G) return;
        const q = Ha(N.e, Qv());
        ef(q), P(G.start, c.value, q + " ");
        return;
      }
      const te = S.value;
      if (te) {
        if (N.kind === "group") {
          const G = i.people.filter((q) => q.uid !== i.me);
          d.value = [...d.value, ...G.map((q) => ({ uid: q.uid, name: N.label }))], P(te.start, c.value, "@" + N.label + " ");
          return;
        }
        d.value = [...d.value.filter((G) => G.uid !== N.p.uid), { uid: N.p.uid, name: N.p.name }], P(te.start, c.value, "@" + N.p.name + " ");
      }
    }
    function P(N, te, G) {
      const q = l.value;
      l.value = q.slice(0, N) + G + q.slice(te);
      const B = N + G.length;
      it(() => {
        const ne = o.value;
        ne && (ne.focus({ preventScroll: !0 }), ne.setSelectionRange(B, B), c.value = B, O());
      });
    }
    function D(N) {
      const te = o.value, G = te ? te.selectionStart : l.value.length, q = te ? te.selectionEnd : G;
      P(G, q, N);
    }
    function $() {
      const N = o.value, te = N ? N.selectionStart : l.value.length, G = l.value.slice(0, te);
      D(G && !/\s$/.test(G) ? " @" : "@");
    }
    function O() {
      const N = o.value;
      N && (N.style.height = "auto", N.style.height = Math.min(N.scrollHeight, 168) + "px");
    }
    function L() {
      const N = o.value;
      N && (c.value = N.selectionStart), O(), s("change", { text: l.value, mentions: d.value });
    }
    function Z() {
      if (!k.value) {
        w();
        return;
      }
      s("submit", { text: l.value, mentions: d.value });
    }
    function J() {
      l.value = "", d.value = [], it(O);
    }
    function re(N) {
      if (M.value && T.value.length) {
        if (N.key === "ArrowDown" || N.key === "ArrowUp") {
          N.preventDefault();
          const te = T.value.length;
          u.value = (u.value + (N.key === "ArrowDown" ? 1 : -1) + te) % te;
          return;
        }
        if (N.key === "Enter" || N.key === "Tab") {
          N.preventDefault(), N.stopPropagation(), z(T.value[u.value]);
          return;
        }
      }
      if (N.key === "Escape") {
        if (N.preventDefault(), N.stopPropagation(), M.value) {
          const te = S.value || _.value;
          x.value = te ? te.start : -1;
          return;
        }
        s("cancel");
        return;
      }
      if (N.key === "Enter" && (!N.shiftKey || vn(N))) {
        N.preventDefault(), N.stopPropagation(), Z();
        return;
      }
      N.key === "ArrowUp" && !l.value && !i.editing && (N.preventDefault(), s("edit-last"));
    }
    function F() {
      const N = a.value;
      if (!N) return;
      const te = N.getBoundingClientRect();
      p.value = p.value ? null : { x: te.left, y: te.top, w: te.width, h: te.height };
    }
    function W(N) {
      ef(N), p.value = null, D(N);
    }
    function ee() {
      const N = o.value;
      if (!N) return;
      N.focus({ preventScroll: !0 });
      const te = l.value.length;
      N.setSelectionRange(te, te), c.value = te;
    }
    return $e(() => i.text, (N) => {
      N !== l.value && (l.value = N, it(O));
    }), ot(() => {
      O(), i.autofocus && it(ee);
    }), Ve(() => clearTimeout(b)), e({ reset: J, focus: ee, nod: w }), (N, te) => (g(), v("div", {
      ref_key: "wrap",
      ref: r,
      class: U(["cm-compose", { "is-editing": n.editing, "can-send": k.value, "is-nod": y.value }]),
      onPointerdown: te[4] || (te[4] = Pe(() => {
      }, ["stop"]))
    }, [
      xt(h("textarea", {
        ref_key: "box",
        ref: o,
        "onUpdate:modelValue": te[0] || (te[0] = (G) => l.value = G),
        class: "cm-compose-box",
        rows: "1",
        placeholder: n.placeholder,
        maxlength: "5000",
        spellcheck: "true",
        "data-testid": n.testid + "-input",
        onInput: L,
        onClick: L,
        onKeyup: L,
        onKeydown: re
      }, null, 40, q2e), [
        [Jt, l.value]
      ]),
      h("div", K2e, [
        n.editing ? (g(), v(H, { key: 0 }, [
          h("button", {
            class: "cm-btn is-ghost is-sm",
            "data-testid": n.testid + "-cancel",
            onClick: te[1] || (te[1] = (G) => s("cancel"))
          }, "Cancel", 8, Y2e),
          h("button", {
            class: "cm-btn is-sm",
            disabled: !k.value,
            "data-testid": n.testid + "-save",
            onClick: Z
          }, "Save", 8, X2e)
        ], 64)) : (g(), v(H, { key: 1 }, [
          h("button", {
            class: "cm-tool",
            title: "Mention someone (@)",
            "aria-label": "Mention someone",
            onClick: $
          }, [
            C(R, {
              name: "AtSign",
              size: 14
            })
          ]),
          h("button", {
            ref_key: "emojiBtn",
            ref: a,
            class: U(["cm-tool", { on: !!p.value }]),
            title: "Emoji",
            "aria-label": "Emoji",
            "data-testid": n.testid + "-emoji",
            onClick: F
          }, [
            C(R, {
              name: "Smile",
              size: 14
            })
          ], 10, J2e),
          h("button", {
            class: "cm-send",
            disabled: !k.value,
            title: "Send (Enter)",
            "aria-label": "Send",
            "data-testid": n.testid + "-send",
            onClick: Z
          }, [
            C(R, {
              name: "ArrowUp",
              size: 14,
              stroke: 2.4
            })
          ], 8, Z2e)
        ], 64))
      ]),
      M.value ? (g(), v("div", {
        key: 0,
        class: U(["cm-menu", { "is-up": f.value }]),
        role: "listbox",
        "data-testid": "mention-menu",
        onPointerdown: te[2] || (te[2] = Pe(() => {
        }, ["stop", "prevent"]))
      }, [
        T.value.length ? (g(!0), v(H, { key: 0 }, me(T.value, (G, q) => (g(), v("button", {
          key: G.kind === "person" ? G.p.uid : G.kind === "emoji" ? G.e.c : "group",
          class: U(["cm-menu-row", { on: q === u.value, "is-emoji": G.kind === "emoji" }]),
          role: "option",
          "aria-selected": q === u.value,
          onMouseenter: (B) => u.value = q,
          onClick: (B) => z(G)
        }, [
          G.kind === "person" ? (g(), v(H, { key: 0 }, [
            C(Vo, {
              uid: G.p.uid,
              name: G.p.name,
              size: 24
            }, null, 8, ["uid", "name"]),
            h("span", e_e, [
              h("b", null, [
                X(A(G.p.name), 1),
                G.p.uid === n.me ? (g(), v("i", t_e, " (you)")) : E("", !0)
              ]),
              h("small", null, A(G.p.email), 1)
            ])
          ], 64)) : G.kind === "group" ? (g(), v(H, { key: 1 }, [
            h("span", n_e, [
              C(R, {
                name: "Users",
                size: 13
              })
            ]),
            h("span", i_e, [
              h("b", null, A(G.label), 1),
              h("small", null, "Everyone who can see this board (" + A(G.count) + ")", 1)
            ])
          ], 64)) : (g(), v(H, { key: 2 }, [
            h("span", s_e, A(m(Ha)(G.e, m(Qv)())), 1),
            h("span", o_e, [
              h("b", null, A(G.e.n), 1),
              G.e.s.length ? (g(), v("small", r_e, ":" + A(G.e.s[0]) + ":", 1)) : E("", !0)
            ])
          ], 64))
        ], 42, Q2e))), 128)) : (g(), v("div", a_e, A(n.alone), 1))
      ], 34)) : E("", !0),
      (g(), Ce(L5, {
        defer: "",
        to: ".cm-portal"
      }, [
        p.value ? (g(), Ce(jI, {
          key: 0,
          at: p.value,
          mode: "insert",
          onPick: W,
          onClose: te[3] || (te[3] = (G) => p.value = null)
        }, null, 8, ["at"])) : E("", !0)
      ]))
    ], 34));
  }
}), l_e = ["data-comment"], d_e = { class: "cm-row-main" }, c_e = { class: "cm-row-head" }, u_e = { class: "cm-row-name" }, h_e = ["title"], p_e = ["title"], f_e = {
  key: 2,
  class: "cm-reactions"
}, m_e = ["title", "onClick"], g_e = { class: "e" }, b_e = { class: "n" }, v_e = {
  key: 0,
  class: "cm-row-acts"
}, y_e = ["title", "aria-label"], x_e = /* @__PURE__ */ Re({
  __name: "CommentRow",
  props: {
    c: {},
    first: { type: Boolean }
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = t.comments, s = t.user.uid, o = Ko(), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ We(null), l = I(() => hte(e.c, s)), d = I(() => e.c.authorId === s), c = I(() => i.ui.editingId === e.c.id), u = I(() => {
      if (!e.first) return i.canDeleteComment(e.c);
      const S = i.thread(e.c.threadId);
      return !!S && i.canDelete(S);
    }), p = I(() => Jn(e.c.createdAt, o.value)), f = I(() => {
      const S = /* @__PURE__ */ new Map();
      for (const _ of i.mentionable()) S.set(_.uid, _.name);
      return S;
    });
    function y(S) {
      const _ = S.map((x) => x === s ? "You" : f.value.get(x) || "Someone");
      return _.length <= 3 ? _.join(", ") : _.slice(0, 3).join(", ") + " and " + (_.length - 3) + " more";
    }
    function b(S) {
      const _ = S || r.value;
      if (!_) return;
      const x = _.getBoundingClientRect();
      a.value = { x: x.left, y: x.top, w: x.width, h: x.height };
    }
    function w(S) {
      a.value = null, i.react(e.c.id, S);
    }
    function k() {
      e.first ? i.deleteThread(e.c.threadId) : i.deleteComment(e.c.id);
    }
    return (S, _) => (g(), v("div", {
      class: U(["cm-row", { "is-editing": c.value, "is-mine": d.value }]),
      "data-comment": n.c.id,
      "data-testid": "comment"
    }, [
      C(Vo, {
        uid: n.c.authorId,
        name: n.c.authorName,
        size: 28
      }, null, 8, ["uid", "name"]),
      h("div", d_e, [
        h("div", c_e, [
          h("b", u_e, A(d.value ? n.c.authorName || "You" : n.c.authorName), 1),
          h("span", {
            class: "cm-row-time",
            title: m(Cp)(n.c.createdAt)
          }, A(p.value), 9, h_e),
          n.c.editedAt ? (g(), v("span", {
            key: 0,
            class: "cm-row-edited",
            title: "Edited " + m(Cp)(n.c.editedAt)
          }, "edited", 8, p_e)) : E("", !0)
        ]),
        c.value ? (g(), Ce(y0, {
          key: 0,
          people: m(i).mentionable(),
          me: m(s),
          text: n.c.text,
          mentions: n.c.mentions,
          editing: "",
          autofocus: "",
          testid: "edit",
          onSubmit: _[0] || (_[0] = (x) => m(i).edit(n.c.id, x.text, x.mentions)),
          onCancel: _[1] || (_[1] = (x) => m(i).ui.editingId = null)
        }, null, 8, ["people", "me", "text", "mentions"])) : (g(), Ce(Fc, {
          key: 1,
          class: "cm-row-text",
          text: n.c.text,
          mentions: n.c.mentions,
          me: m(s)
        }, null, 8, ["text", "mentions", "me"])),
        l.value.length && !c.value ? (g(), v("div", f_e, [
          (g(!0), v(H, null, me(l.value, (x) => (g(), v("button", {
            key: x.key,
            class: U(["cm-chip", { mine: x.mine }]),
            title: y(x.who) + " reacted with " + x.emoji,
            "data-testid": "reaction",
            onClick: (T) => w(x.emoji)
          }, [
            h("span", g_e, A(x.emoji), 1),
            h("span", b_e, A(x.count), 1)
          ], 10, m_e))), 128)),
          h("button", {
            class: "cm-chip is-add",
            title: "Add a reaction",
            "aria-label": "Add a reaction",
            onClick: _[2] || (_[2] = (x) => b(x.currentTarget))
          }, [
            C(R, {
              name: "SmilePlus",
              size: 13
            })
          ])
        ])) : E("", !0)
      ]),
      c.value ? E("", !0) : (g(), v("div", v_e, [
        h("button", {
          ref_key: "reactBtn",
          ref: r,
          title: "React",
          "aria-label": "React",
          "data-testid": "comment-react",
          onClick: _[3] || (_[3] = (x) => b())
        }, [
          C(R, {
            name: "SmilePlus",
            size: 14
          })
        ], 512),
        d.value ? (g(), v("button", {
          key: 0,
          title: "Edit",
          "aria-label": "Edit",
          "data-testid": "comment-edit",
          onClick: _[4] || (_[4] = (x) => m(i).ui.editingId = n.c.id)
        }, [
          C(R, {
            name: "Pencil",
            size: 13
          })
        ])) : E("", !0),
        u.value ? (g(), v("button", {
          key: 1,
          title: n.first ? "Delete thread" : "Delete",
          "aria-label": n.first ? "Delete thread" : "Delete",
          "data-testid": "comment-delete",
          onClick: k
        }, [
          C(R, {
            name: "Trash2",
            size: 13
          })
        ], 8, y_e)) : E("", !0)
      ])),
      (g(), Ce(L5, {
        defer: "",
        to: ".cm-portal"
      }, [
        a.value ? (g(), Ce(jI, {
          key: 0,
          at: a.value,
          mode: "react",
          onPick: w,
          onClose: _[5] || (_[5] = (x) => a.value = null)
        }, null, 8, ["at"])) : E("", !0)
      ]))
    ], 10, l_e));
  }
}), w_e = ["data-thread", "data-testid"], k_e = { class: "cm-draft-head" }, __e = ["title"], S_e = { class: "cm-card-head" }, T_e = {
  class: "cm-dots",
  role: "radiogroup",
  "aria-label": "Thread colour"
}, M_e = ["aria-checked", "title", "aria-label", "onClick"], C_e = ["title", "aria-label", "aria-pressed"], I_e = ["title"], A_e = { class: "cm-card-menu-wrap" }, P_e = ["aria-expanded"], E_e = {
  key: 0,
  class: "cm-card-menu",
  role: "menu",
  "data-testid": "thread-menu-list"
}, R_e = { key: 0 }, z_e = ["title", "aria-label"], $_e = {
  key: 0,
  class: "cm-strip"
}, D_e = ["title"], O_e = {
  key: 1,
  class: "cm-resolved-note"
}, L_e = {
  key: 2,
  class: "cm-nav"
}, B_e = {
  class: "cm-nav-n",
  "data-testid": "thread-position"
}, F_e = { class: "cm-reply" }, N_e = /* @__PURE__ */ new Map(), J_ = /* @__PURE__ */ Re({
  __name: "ThreadCard",
  props: {
    id: {},
    draft: { type: Boolean }
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = t.comments, s = t.user.uid, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(!1), d = /* @__PURE__ */ We({ w: 340, h: 200 }), c = I(() => e.draft ? null : i.thread(e.id)), u = I(() => c.value ? i.commentsOf(c.value.id) : []), p = I(() => !e.draft && i.ui.openId === e.id), f = I(() => !!c.value && i.pinned(c.value)), y = I(() => !!c.value && i.following(c.value)), b = I(() => !!c.value && i.isUnread(c.value)), w = I(() => p.value ? i.position() : null), k = I(() => c.value && Fs.find((Y) => Y.id === c.value.color) || Fs[0]), S = I(() => i.mentionable()), _ = I(() => i.people.value.scope), x = I(() => _.value === "team" || _.value === "restricted" ? t.labels.team : null), T = I(() => _.value === "personal" ? "Only you can see this personal board, so there's no one to mention." : _.value === "private" ? "Only its owner can see this private board. Share it from Access Settings to mention others." : null), M = I(() => {
      const Y = c.value, ie = e.draft && i.ui.draft ? i.ui.draft.anchor : null, De = Y ? Y.anchorLabel : ie ? ie.label : "", xe = Y ? i.elementOf(Y) : ie && ie.elementId ? t.store.get(ie.elementId) : null;
      if (!De && !xe) return null;
      const Oe = lte(xe);
      return { label: De || "Canvas", icon: { image: "Image", video: "Video", note: "StickyNote", tool: "LayoutGrid", frame: "Frame", shape: "Square", chat: "MessagesSquare", canvas: "MapPin" }[Oe] };
    }), z = 34, P = 14, D = 62, $ = 76;
    function O() {
      if (e.draft) {
        const ie = i.ui.draft;
        return ie ? { x: ie.anchor.x, y: ie.anchor.y } : null;
      }
      const Y = c.value;
      return Y ? i.pointOf(Y) : null;
    }
    function L() {
      const Y = o.value, ie = O();
      if (!Y || !ie) return;
      const De = t.worldToClient(ie.x, ie.y), xe = window.innerWidth, Oe = window.innerHeight, { w: Ee, h: j } = d.value, V = xe - i.rightInset();
      let Q = De.x + 34 + P;
      Q + Ee > V - 8 && (Q = De.x - P - Ee), Q = Math.max(8, Math.min(Q, V - Ee - 8));
      let oe = De.y - z - 6;
      oe = Math.max(D, Math.min(oe, Oe - j - $));
      const ue = De.x < -60 || De.y < 0 || De.x > xe + 60 || De.y > Oe + 60;
      Y.style.transform = "translate3d(" + Math.round(Q) + "px," + Math.round(oe) + "px,0)", Y.classList.toggle("is-away", ue);
    }
    let Z = null, J = null;
    ot(() => {
      Z = t.onCameraFrame(() => L()), o.value && typeof ResizeObserver != "undefined" && (J = new ResizeObserver(() => {
        o.value && (d.value = { w: o.value.offsetWidth, h: o.value.offsetHeight }, L());
      }), J.observe(o.value)), L(), re(!1), window.addEventListener("resize", L);
    }), Ve(() => {
      Z && Z(), J && J.disconnect(), window.removeEventListener("resize", L);
    }), $e(() => [t.docRev.value, i.ui.panelOpen, t.ui.boardHistory, i.ui.draft && i.ui.draft.anchor, i.ui.dragging], () => it(L));
    function re(Y = !0) {
      it(() => {
        const ie = r.value;
        ie && ie.scrollTo({ top: ie.scrollHeight, behavior: Y ? "smooth" : "auto" });
      });
    }
    $e(() => u.value.length, (Y, ie) => {
      Y > (ie || 0) && re();
    });
    const F = N_e, W = I(() => e.id ? F.get(e.id) || { text: "", mentions: [] } : { text: "", mentions: [] });
    async function ee(Y) {
      if (e.draft) {
        await i.post(Y.text, Y.mentions);
        return;
      }
      if (!e.id) return;
      await i.reply(e.id, Y.text, Y.mentions) && (F.delete(e.id), a.value && a.value.reset());
    }
    function N(Y) {
      if (e.draft) {
        const ie = i.ui.draft;
        ie && (ie.text = Y.text, ie.mentions = Y.mentions);
        return;
      }
      e.id && F.set(e.id, Y);
    }
    function te() {
      e.draft ? i.cancelDraft() : i.close();
    }
    function G() {
      const Y = u.value.filter((De) => De.authorId === s), ie = Y[Y.length - 1];
      ie && (i.ui.editingId = ie.id);
    }
    $e(() => e.draft && i.ui.draft ? i.ui.draft.n : 0, (Y) => {
      Y && a.value && a.value.nod();
    });
    function q(Y) {
      l.value = !1, Y();
    }
    function B() {
      const Y = c.value;
      Y && (p.value ? i.close() : i.pin(Y.id, !1));
    }
    function ne(Y) {
      l.value && o.value && !Y.target.closest(".cm-card-menu-wrap") && (l.value = !1);
    }
    function se(Y) {
      Y.key !== "Escape" || !l.value || (Y.preventDefault(), Y.stopPropagation(), l.value = !1);
    }
    return ot(() => {
      window.addEventListener("pointerdown", ne, !0), window.addEventListener("keydown", se, !0);
    }), Ve(() => {
      window.removeEventListener("pointerdown", ne, !0), window.removeEventListener("keydown", se, !0);
    }), (Y, ie) => (g(), v("div", {
      ref_key: "el",
      ref: o,
      class: U(["cm-card", { "is-draft": n.draft, "is-open": p.value, "is-pinned": f.value && !p.value, "is-resolved": c.value && !!c.value.resolvedAt }]),
      style: de({ "--thread": k.value.hex }),
      "data-thread": n.draft ? "draft" : n.id,
      "data-testid": n.draft ? "comment-draft" : "comment-thread",
      onPointerdown: ie[10] || (ie[10] = Pe(() => {
      }, ["stop"])),
      onWheel: ie[11] || (ie[11] = Pe(() => {
      }, ["stop"])),
      onContextmenu: ie[12] || (ie[12] = Pe(() => {
      }, ["stop"]))
    }, [
      n.draft ? (g(), v(H, { key: 0 }, [
        h("div", k_e, [
          C(Vo, {
            uid: m(s),
            name: m(i).myName,
            size: 26
          }, null, 8, ["uid", "name"]),
          ie[13] || (ie[13] = h("span", { class: "cm-draft-title" }, "New comment", -1)),
          M.value ? (g(), v("span", {
            key: 0,
            class: "cm-on is-inline",
            title: "On " + M.value.label
          }, [
            C(R, {
              name: M.value.icon,
              size: 11
            }, null, 8, ["name"]),
            X(A(M.value.label), 1)
          ], 8, __e)) : E("", !0),
          h("button", {
            class: "cm-icon",
            title: "Discard (Esc)",
            "aria-label": "Discard",
            onClick: te
          }, [
            C(R, {
              name: "X",
              size: 14
            })
          ])
        ]),
        C(y0, {
          ref_key: "composer",
          ref: a,
          people: S.value,
          me: m(s),
          text: m(i).ui.draft ? m(i).ui.draft.text : "",
          mentions: m(i).ui.draft ? m(i).ui.draft.mentions : [],
          group: x.value,
          alone: T.value,
          placeholder: "Add a comment. Use @ to mention.",
          autofocus: "",
          testid: "draft",
          onSubmit: ee,
          onChange: N,
          onCancel: te
        }, null, 8, ["people", "me", "text", "mentions", "group", "alone"])
      ], 64)) : c.value ? (g(), v(H, { key: 1 }, [
        h("div", S_e, [
          h("div", T_e, [
            (g(!0), v(H, null, me(m(Fs), (De) => (g(), v("button", {
              key: De.id,
              class: U(["cm-dot", { on: c.value.color === De.id }]),
              style: de({ "--c": De.hex }),
              role: "radio",
              "aria-checked": c.value.color === De.id,
              title: De.label,
              "aria-label": De.label,
              onClick: (xe) => m(i).setColor(c.value.id, De.id)
            }, null, 14, M_e))), 128))
          ]),
          ie[19] || (ie[19] = h("span", { class: "cm-grow" }, null, -1)),
          h("button", {
            class: U(["cm-icon", { on: y.value }]),
            title: y.value ? "Following: replies show in your Updates. Click to unfollow" : "Follow: hear about replies in your Updates",
            "aria-label": y.value ? "Unfollow" : "Follow",
            "aria-pressed": y.value,
            "data-testid": "thread-follow",
            onClick: ie[0] || (ie[0] = (De) => m(i).follow(c.value, !y.value))
          }, [
            C(R, {
              name: y.value ? "Bell" : "BellOff",
              size: 14
            }, null, 8, ["name"])
          ], 10, C_e),
          h("button", {
            class: U(["cm-resolve", { on: !!c.value.resolvedAt }]),
            title: c.value.resolvedAt ? "Reopen" : "Resolve",
            "data-testid": "thread-resolve",
            onClick: ie[1] || (ie[1] = (De) => m(i).resolve(c.value.id, !c.value.resolvedAt))
          }, [
            C(R, {
              name: "CircleCheck",
              size: 14
            }),
            h("span", null, A(c.value.resolvedAt ? "Resolved" : "Resolve"), 1)
          ], 10, I_e),
          h("div", A_e, [
            h("button", {
              class: U(["cm-icon", { on: l.value }]),
              title: "More",
              "aria-label": "More",
              "aria-haspopup": "menu",
              "aria-expanded": l.value,
              "data-testid": "thread-menu",
              onClick: ie[2] || (ie[2] = (De) => l.value = !l.value)
            }, [
              C(R, {
                name: "Ellipsis",
                size: 15
              })
            ], 10, P_e),
            l.value ? (g(), v("div", E_e, [
              b.value ? (g(), v("button", {
                key: 0,
                role: "menuitem",
                "data-testid": "thread-mark-read",
                onClick: ie[3] || (ie[3] = (De) => q(() => m(i).markRead([c.value])))
              }, [
                C(R, {
                  name: "CheckCheck",
                  size: 14
                }),
                ie[14] || (ie[14] = X("Mark as read", -1))
              ])) : (g(), v("button", {
                key: 1,
                role: "menuitem",
                "data-testid": "thread-mark-unread",
                onClick: ie[4] || (ie[4] = (De) => q(() => m(i).markUnread(c.value)))
              }, [
                C(R, {
                  name: "MessageSquareDot",
                  size: 14
                }),
                ie[15] || (ie[15] = X("Mark as unread", -1))
              ])),
              h("button", {
                role: "menuitem",
                "data-testid": "thread-pin",
                onClick: ie[5] || (ie[5] = (De) => q(() => m(i).pin(c.value.id, !f.value)))
              }, [
                C(R, {
                  name: f.value ? "PinOff" : "Pin",
                  size: 14
                }, null, 8, ["name"]),
                X(A(f.value ? "Unpin" : "Pin for yourself") + " ", 1),
                f.value ? E("", !0) : (g(), v("small", R_e, "Keeps it open on the board"))
              ]),
              h("button", {
                role: "menuitem",
                "data-testid": "thread-copy-link",
                onClick: ie[6] || (ie[6] = (De) => q(() => m(i).copyLink(c.value)))
              }, [
                C(R, {
                  name: "Link2",
                  size: 14
                }),
                ie[16] || (ie[16] = X("Copy link", -1))
              ]),
              m(i).canDelete(c.value) ? (g(), v(H, { key: 2 }, [
                ie[18] || (ie[18] = h("span", { class: "cm-card-menu-sep" }, null, -1)),
                h("button", {
                  role: "menuitem",
                  class: "is-danger",
                  "data-testid": "thread-delete",
                  onClick: ie[7] || (ie[7] = (De) => q(() => m(i).deleteThread(c.value.id)))
                }, [
                  C(R, {
                    name: "Trash2",
                    size: 14
                  }),
                  ie[17] || (ie[17] = X("Delete thread", -1))
                ])
              ], 64)) : E("", !0)
            ])) : E("", !0)
          ]),
          h("button", {
            class: "cm-icon",
            title: p.value ? "Close (Esc)" : "Unpin",
            "aria-label": p.value ? "Close" : "Unpin",
            "data-testid": "thread-close",
            onClick: B
          }, [
            C(R, {
              name: p.value ? "X" : "PinOff",
              size: 14
            }, null, 8, ["name"])
          ], 8, z_e)
        ]),
        M.value || c.value.resolvedAt || w.value && w.value.of > 1 ? (g(), v("div", $_e, [
          M.value ? (g(), v("span", {
            key: 0,
            class: "cm-on",
            title: "On " + M.value.label
          }, [
            C(R, {
              name: M.value.icon,
              size: 11
            }, null, 8, ["name"]),
            X(A(M.value.label), 1)
          ], 8, D_e)) : E("", !0),
          c.value.resolvedAt ? (g(), v("span", O_e, [
            C(R, {
              name: "CircleCheck",
              size: 11
            }),
            ie[20] || (ie[20] = X("Resolved", -1))
          ])) : E("", !0),
          ie[21] || (ie[21] = h("span", { class: "cm-grow" }, null, -1)),
          w.value && w.value.of > 1 ? (g(), v("div", L_e, [
            h("button", {
              class: "cm-icon",
              title: "Previous thread",
              "aria-label": "Previous thread",
              "data-testid": "thread-prev",
              onClick: ie[8] || (ie[8] = (De) => m(i).step(-1))
            }, [
              C(R, {
                name: "ChevronLeft",
                size: 14
              })
            ]),
            h("span", B_e, A(w.value.at) + " of " + A(w.value.of), 1),
            h("button", {
              class: "cm-icon",
              title: "Next thread",
              "aria-label": "Next thread",
              "data-testid": "thread-next",
              onClick: ie[9] || (ie[9] = (De) => m(i).step(1))
            }, [
              C(R, {
                name: "ChevronRight",
                size: 14
              })
            ])
          ])) : E("", !0)
        ])) : E("", !0),
        h("div", {
          ref_key: "list",
          ref: r,
          class: "cm-list"
        }, [
          (g(!0), v(H, null, me(u.value, (De, xe) => (g(), Ce(x_e, {
            key: De.id,
            c: De,
            first: xe === 0
          }, null, 8, ["c", "first"]))), 128))
        ], 512),
        h("div", F_e, [
          (g(), Ce(y0, {
            ref_key: "composer",
            ref: a,
            key: "r" + c.value.id,
            people: S.value,
            me: m(s),
            text: W.value.text,
            mentions: W.value.mentions,
            group: x.value,
            alone: T.value,
            placeholder: c.value.resolvedAt ? "Reply to reopen" : "Reply",
            autofocus: p.value,
            testid: "reply",
            onSubmit: ee,
            onChange: N,
            onCancel: te,
            onEditLast: G
          }, null, 8, ["people", "me", "text", "mentions", "group", "alone", "placeholder", "autofocus"]))
        ])
      ], 64)) : E("", !0)
    ], 46, w_e));
  }
}), U_e = { class: "cm-reply-main" }, G_e = { class: "cm-reply-head" }, j_e = ["title"], H_e = { key: 0 }, Z_ = /* @__PURE__ */ Re({
  __name: "ReplyRow",
  props: {
    c: {},
    me: {},
    now: {},
    fresh: { type: Boolean, default: !1 },
    clamp: { default: 4 }
  },
  setup(n) {
    return (e, t) => (g(), v("div", {
      class: U(["cm-reply-row", { "is-new": n.fresh }]),
      "data-testid": "comments-reply"
    }, [
      C(Vo, {
        uid: n.c.authorId,
        name: n.c.authorName,
        size: 20
      }, null, 8, ["uid", "name"]),
      h("div", U_e, [
        h("div", G_e, [
          h("b", null, A(n.c.authorName), 1),
          h("span", {
            title: m(Cp)(n.c.createdAt)
          }, A(m(Jn)(n.c.createdAt, n.now)), 9, j_e),
          n.fresh ? (g(), v("i", H_e, "new")) : E("", !0)
        ]),
        C(Fc, {
          class: "cm-reply-text",
          text: n.c.text,
          mentions: n.c.mentions,
          me: n.me,
          clamp: n.clamp
        }, null, 8, ["text", "mentions", "me", "clamp"])
      ])
    ], 2));
  }
}), V_e = { class: "cm-panel-head" }, W_e = { class: "cm-panel-settings-wrap" }, q_e = {
  key: 0,
  class: "cm-card-menu is-settings",
  role: "menu",
  "data-testid": "comments-settings-menu"
}, K_e = ["aria-checked"], Y_e = ["aria-checked"], X_e = ["disabled"], J_e = {
  class: "cm-tabs",
  role: "tablist"
}, Z_e = ["aria-selected"], Q_e = {
  key: 0,
  class: "cm-count"
}, e4e = ["aria-selected"], t4e = {
  key: 0,
  class: "cm-count"
}, n4e = { class: "cm-tools" }, i4e = { class: "cm-search" }, s4e = {
  class: "cm-chips",
  role: "radiogroup",
  "aria-label": "Show"
}, o4e = ["aria-checked", "data-testid", "onClick"], r4e = {
  key: 0,
  class: "n"
}, a4e = {
  class: "cm-feed",
  "data-testid": "comments-feed"
}, l4e = {
  key: 0,
  class: "cm-feed-empty"
}, d4e = {
  key: 1,
  class: "cm-feed-empty"
}, c4e = { class: "cm-empty-mark is-error" }, u4e = {
  key: 2,
  class: "cm-feed-empty",
  "data-testid": "comments-empty"
}, h4e = { class: "cm-empty-mark" }, p4e = {
  key: 3,
  class: "cm-feed-empty"
}, f4e = { class: "cm-empty-mark" }, m4e = {
  key: 0,
  class: "cm-feed-label"
}, g4e = {
  key: 0,
  class: "cm-feed-label"
}, b4e = ["data-thread", "onClick", "onKeydown"], v4e = {
  key: 0,
  class: "cm-item-dot",
  "aria-label": "Unread"
}, y4e = { class: "cm-item-main" }, x4e = { class: "cm-item-head" }, w4e = { class: "cm-item-time" }, k4e = {
  key: 1,
  class: "cm-item-on"
}, _4e = { class: "cm-item-on-label" }, S4e = {
  key: 2,
  class: "cm-replies"
}, T4e = ["onClick"], M4e = {
  key: 3,
  class: "cm-item-foot"
}, C4e = { class: "cm-item-resolved" }, I4e = ["title", "aria-label", "onClick"], A4e = ["title", "aria-label", "onClick"], P4e = { class: "cm-item-menu-wrap" }, E4e = ["onClick"], R4e = ["onClick"], z4e = ["onClick"], $4e = ["onClick"], D4e = ["onClick"], O4e = { class: "cm-tools is-elsewhere" }, L4e = {
  class: "cm-chips",
  role: "radiogroup",
  "aria-label": "Show"
}, B4e = ["aria-checked"], F4e = {
  key: 0,
  class: "n"
}, N4e = ["aria-checked"], U4e = ["disabled"], G4e = {
  class: "cm-feed",
  "data-testid": "elsewhere-feed"
}, j4e = {
  key: 0,
  class: "cm-feed-empty"
}, H4e = { class: "cm-empty-mark" }, V4e = { class: "cm-board-head" }, W4e = { class: "cm-board-title" }, q4e = { class: "cm-board-n" }, K4e = ["onClick"], Y4e = ["onClick", "onKeydown"], X4e = {
  key: 0,
  class: "cm-item-dot",
  "aria-label": "Unread"
}, J4e = { class: "cm-item-main" }, Z4e = { class: "cm-item-head" }, Q4e = { class: "cm-item-time" }, e5e = {
  key: 1,
  class: "cm-replies is-all",
  "data-testid": "elsewhere-thread"
}, t5e = {
  key: 0,
  class: "bd-spinner is-sm"
}, n5e = {
  key: 1,
  class: "cm-replies-failed"
}, i5e = { class: "cm-item-foot" }, s5e = {
  key: 0,
  class: "cm-item-resolved"
}, o5e = ["onClick"], r5e = { class: "cm-item-open" }, a5e = ["title", "aria-label", "onClick"], l5e = ["onClick"], d5e = /* @__PURE__ */ Re({
  __name: "UpdatesPanel",
  setup(n) {
    const { board: e } = tt(), t = e.comments, i = e.user.uid, s = Ko(), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = [
      { id: "all", label: "All" },
      { id: "unread", label: "Unread" },
      { id: "mentions", label: "Mentions" },
      { id: "mine", label: "Yours" }
    ], d = I(() => t.feed.value), c = I(() => d.value.filter((ee) => ee.pinned)), u = I(() => d.value.filter((ee) => !ee.pinned)), p = I(() => t.allThreads().filter((ee) => !ee.resolvedAt || t.ui.showResolved).length), f = (ee) => (Fs.find((N) => N.id === ee) || Fs[0]).hex;
    function y(ee) {
      r.value = null, t.focus(ee.t.id);
    }
    const b = /* @__PURE__ */ K(!1);
    function w(ee, N) {
      if (r.value === ee) {
        r.value = null;
        return;
      }
      const te = N.currentTarget.getBoundingClientRect(), G = N.currentTarget.closest(".cm-feed"), q = G ? G.getBoundingClientRect().bottom : window.innerHeight;
      b.value = q - te.bottom < 200, r.value = ee;
    }
    function k(ee) {
      r.value = null, o.value = !1, ee();
    }
    function S() {
      t.ui.panelOpen = !1;
    }
    function _() {
      S(), t.arm(!0);
    }
    const x = I(() => {
      if (t.ui.query) return { title: "No matches", sub: "Nothing on this board says “" + t.ui.query + "”." };
      switch (t.ui.filter) {
        case "unread":
          return { title: "You're all caught up", sub: "Nothing unread on this board." };
        case "mentions":
          return { title: "No mentions", sub: "When someone @mentions you, or replies where you've commented, it shows here." };
        case "mine":
          return { title: "Nothing of yours yet", sub: "Threads you start or reply to show here." };
        default:
          return null;
      }
    }), T = /* @__PURE__ */ K(/* @__PURE__ */ new Set());
    function M(ee) {
      const N = new Set(T.value);
      N.has(ee) ? N.delete(ee) : N.add(ee), T.value = N;
    }
    function z(ee) {
      return t.commentsOf(ee.t.id).slice(1);
    }
    function P(ee) {
      const N = z(ee);
      return T.value.has(ee.t.id) ? N : N.slice(-1);
    }
    function D(ee) {
      return z(ee).slice(0, -1).filter((N) => t.isFresh(ee.t, N)).length;
    }
    const $ = I(() => t.elsewhere.value), O = /* @__PURE__ */ We({});
    function L(ee) {
      const N = O.value[ee.id];
      return N && N.at === ee.lastAt ? N : null;
    }
    async function Z(ee) {
      if (M(ee.id), !T.value.has(ee.id) || L(ee)) return;
      const N = ee.lastAt;
      O.value = { ...O.value, [ee.id]: { at: N, list: null } };
      try {
        const te = await t.commentsElsewhere(ee);
        O.value = { ...O.value, [ee.id]: { at: N, list: te } };
      } catch (te) {
        console.warn("[board] comments: a thread on another board couldn't be read", te), O.value = { ...O.value, [ee.id]: { at: N, list: [], failed: !0 } };
      }
    }
    function J(ee) {
      r.value = null, t.openElsewhere(ee);
    }
    function re(ee) {
      const N = ee.target;
      o.value && !N.closest(".cm-panel-settings-wrap") && (o.value = !1), r.value && !N.closest(".cm-item-menu-wrap") && (r.value = null);
    }
    function F(ee) {
      ee.key !== "Escape" || !o.value && !r.value || (ee.preventDefault(), ee.stopPropagation(), o.value = !1, r.value = null);
    }
    function W(ee) {
      ee.key === "/" && document.activeElement !== a.value && !ee.target.closest("textarea, input") && (ee.preventDefault(), a.value && a.value.focus());
    }
    return ot(() => {
      window.addEventListener("pointerdown", re, !0), window.addEventListener("keydown", W), window.addEventListener("keydown", F, !0), t.refreshPeople();
    }), Ve(() => {
      window.removeEventListener("pointerdown", re, !0), window.removeEventListener("keydown", W), window.removeEventListener("keydown", F, !0);
    }), (ee, N) => (g(), v("aside", {
      class: "cm-panel",
      "aria-label": "Comments",
      "data-testid": "comments-panel",
      onPointerdown: N[13] || (N[13] = Pe(() => {
      }, ["stop"])),
      onWheel: N[14] || (N[14] = Pe(() => {
      }, ["stop"]))
    }, [
      h("div", V_e, [
        N[20] || (N[20] = h("span", { class: "cm-panel-title" }, "Comments", -1)),
        N[21] || (N[21] = h("span", { class: "cm-grow" }, null, -1)),
        h("button", {
          class: "cm-icon",
          title: "Comment (C)",
          "aria-label": "Add a comment",
          "data-testid": "comments-add",
          onClick: _
        }, [
          C(R, {
            name: "MessageCirclePlus",
            size: 15
          })
        ]),
        h("div", W_e, [
          h("button", {
            class: U(["cm-icon", { on: o.value }]),
            title: "Settings",
            "aria-label": "Settings",
            "data-testid": "comments-settings",
            onClick: N[0] || (N[0] = (te) => o.value = !o.value)
          }, [
            C(R, {
              name: "SlidersHorizontal",
              size: 15
            })
          ], 2),
          o.value ? (g(), v("div", q_e, [
            h("button", {
              role: "menuitemcheckbox",
              "aria-checked": m(t).ui.showPins,
              "data-testid": "comments-show-pins",
              onClick: N[1] || (N[1] = (te) => m(t).ui.showPins = !m(t).ui.showPins)
            }, [
              C(R, {
                name: m(t).ui.showPins ? "Eye" : "EyeOff",
                size: 14
              }, null, 8, ["name"]),
              N[15] || (N[15] = X("Comments on the board ", -1)),
              h("span", {
                class: U(["cm-switch", { on: m(t).ui.showPins }])
              }, null, 2),
              N[16] || (N[16] = h("kbd", null, "⇧C", -1))
            ], 8, K_e),
            h("button", {
              role: "menuitemcheckbox",
              "aria-checked": m(t).ui.showResolved,
              "data-testid": "comments-show-resolved",
              onClick: N[2] || (N[2] = (te) => m(t).ui.showResolved = !m(t).ui.showResolved)
            }, [
              C(R, {
                name: "CircleCheck",
                size: 14
              }),
              N[17] || (N[17] = X("Resolved threads ", -1)),
              h("span", {
                class: U(["cm-switch", { on: m(t).ui.showResolved }])
              }, null, 2)
            ], 8, Y_e),
            N[19] || (N[19] = h("span", { class: "cm-card-menu-sep" }, null, -1)),
            h("button", {
              role: "menuitem",
              disabled: !m(t).unreadCount.value,
              "data-testid": "comments-mark-all",
              onClick: N[3] || (N[3] = (te) => k(() => m(t).markAllRead()))
            }, [
              C(R, {
                name: "CheckCheck",
                size: 14
              }),
              N[18] || (N[18] = X("Mark all as read", -1))
            ], 8, X_e)
          ])) : E("", !0)
        ]),
        h("button", {
          class: "cm-icon",
          title: "Close (Esc)",
          "aria-label": "Close comments",
          "data-testid": "comments-close",
          onClick: S
        }, [
          C(R, {
            name: "X",
            size: 15
          })
        ])
      ]),
      h("div", J_e, [
        h("button", {
          role: "tab",
          "aria-selected": m(t).ui.tab === "board",
          class: U({ on: m(t).ui.tab === "board" }),
          "data-testid": "comments-tab-board",
          onClick: N[4] || (N[4] = (te) => m(t).ui.tab = "board")
        }, [
          N[22] || (N[22] = X(" This board", -1)),
          m(t).unreadCount.value ? (g(), v("span", Q_e, A(m(t).unreadCount.value), 1)) : E("", !0)
        ], 10, Z_e),
        h("button", {
          role: "tab",
          "aria-selected": m(t).ui.tab === "elsewhere",
          class: U({ on: m(t).ui.tab === "elsewhere" }),
          "data-testid": "comments-tab-elsewhere",
          onClick: N[5] || (N[5] = (te) => m(t).ui.tab = "elsewhere")
        }, [
          N[23] || (N[23] = X(" Everywhere else", -1)),
          m(t).elsewhereUnread.value ? (g(), v("span", t4e, A(m(t).elsewhereUnread.value), 1)) : E("", !0)
        ], 10, e4e)
      ]),
      m(t).ui.tab === "board" ? (g(), v(H, { key: 0 }, [
        h("div", n4e, [
          h("label", i4e, [
            C(R, {
              name: "Search",
              size: 13
            }),
            xt(h("input", {
              ref_key: "search",
              ref: a,
              "onUpdate:modelValue": N[6] || (N[6] = (te) => m(t).ui.query = te),
              type: "text",
              placeholder: "Search comments",
              spellcheck: "false",
              "data-testid": "comments-search"
            }, null, 512), [
              [Jt, m(t).ui.query]
            ]),
            m(t).ui.query ? (g(), v("button", {
              key: 0,
              class: "cm-search-clear",
              "aria-label": "Clear the search",
              onClick: N[7] || (N[7] = (te) => m(t).ui.query = "")
            }, [
              C(R, {
                name: "X",
                size: 12
              })
            ])) : E("", !0)
          ]),
          h("div", s4e, [
            (g(), v(H, null, me(l, (te) => h("button", {
              key: te.id,
              class: U(["cm-fchip", { on: m(t).ui.filter === te.id }]),
              role: "radio",
              "aria-checked": m(t).ui.filter === te.id,
              "data-testid": "comments-filter-" + te.id,
              onClick: (G) => m(t).ui.filter = te.id
            }, [
              X(A(te.label), 1),
              te.id === "unread" && m(t).unreadCount.value ? (g(), v("span", r4e, A(m(t).unreadCount.value), 1)) : E("", !0)
            ], 10, o4e)), 64))
          ])
        ]),
        h("div", a4e, [
          m(t).loaded.value ? m(t).failed.value ? (g(), v("div", d4e, [
            h("span", c4e, [
              C(R, {
                name: "CloudOff",
                size: 18
              })
            ]),
            N[25] || (N[25] = h("b", null, "Comments are unavailable", -1)),
            N[26] || (N[26] = h("span", null, "They couldn't be loaded on this board. Please reload the page.", -1))
          ])) : p.value ? !d.value.length && x.value ? (g(), v("div", p4e, [
            h("span", f4e, [
              C(R, {
                name: m(t).ui.filter === "unread" && !m(t).ui.query ? "CheckCheck" : "Search",
                size: 18
              }, null, 8, ["name"])
            ]),
            h("b", null, A(x.value.title), 1),
            h("span", null, A(x.value.sub), 1)
          ])) : (g(), v(H, { key: 4 }, [
            c.value.length ? (g(), v("div", m4e, [
              C(R, {
                name: "Pin",
                size: 11
              }),
              N[30] || (N[30] = X("Pinned for you", -1))
            ])) : E("", !0),
            (g(!0), v(H, null, me([c.value, u.value], (te, G) => (g(), v(H, { key: G }, [
              G === 1 && c.value.length && u.value.length ? (g(), v("div", g4e, "Recent activity")) : E("", !0),
              (g(!0), v(H, null, me(te, (q) => (g(), v("div", {
                key: q.t.id,
                class: U(["cm-item", { "is-unread": q.unread, "is-open": m(t).ui.openId === q.t.id, "is-resolved": !!q.t.resolvedAt }]),
                style: de({ "--thread": f(q.t.color) }),
                role: "button",
                tabindex: "0",
                "data-thread": q.t.id,
                "data-testid": "comments-item",
                onClick: (B) => y(q),
                onKeydown: tn((B) => y(q), ["enter"])
              }, [
                q.unread ? (g(), v("span", v4e)) : E("", !0),
                C(Vo, {
                  uid: q.t.createdBy,
                  name: q.t.createdByName,
                  size: 28
                }, null, 8, ["uid", "name"]),
                h("div", y4e, [
                  h("div", x4e, [
                    h("b", null, A(q.first ? q.first.authorName : q.t.createdByName), 1),
                    h("span", w4e, A(m(Jn)(q.first ? q.first.createdAt : q.t.createdAt, m(s))), 1)
                  ]),
                  q.first ? (g(), Ce(Fc, {
                    key: 0,
                    class: "cm-item-text",
                    text: q.first.text,
                    mentions: q.first.mentions,
                    me: m(i),
                    clamp: 3
                  }, null, 8, ["text", "mentions", "me"])) : E("", !0),
                  q.t.anchorLabel || q.t.anchorThumb ? (g(), v("div", k4e, [
                    q.t.anchorThumb ? (g(), v("span", {
                      key: 0,
                      class: "cm-item-thumb",
                      style: de({ backgroundImage: 'url("' + m(Wt)(q.t.anchorThumb) + '")' })
                    }, null, 4)) : E("", !0),
                    h("span", _4e, A(q.t.anchorLabel || "Canvas"), 1)
                  ])) : E("", !0),
                  q.replies ? (g(), v("div", S4e, [
                    q.replies > 1 ? (g(), v("button", {
                      key: 0,
                      class: U(["cm-replies-more", { "is-new": !T.value.has(q.t.id) && D(q) }]),
                      "data-testid": "comments-replies-toggle",
                      onClick: Pe((B) => M(q.t.id), ["stop"])
                    }, [
                      T.value.has(q.t.id) ? (g(), v(H, { key: 0 }, [
                        X("Hide earlier replies")
                      ], 64)) : (g(), v(H, { key: 1 }, [
                        X("Show " + A(q.replies - 1) + " earlier " + A(q.replies - 1 === 1 ? "reply" : "replies"), 1),
                        D(q) ? (g(), v(H, { key: 0 }, [
                          X(" · " + A(D(q)) + " new", 1)
                        ], 64)) : E("", !0)
                      ], 64))
                    ], 10, T4e)) : E("", !0),
                    (g(!0), v(H, null, me(P(q), (B) => (g(), Ce(Z_, {
                      key: B.id,
                      c: B,
                      me: m(i),
                      now: m(s),
                      fresh: m(t).isFresh(q.t, B)
                    }, null, 8, ["c", "me", "now", "fresh"]))), 128))
                  ])) : E("", !0),
                  q.t.resolvedAt ? (g(), v("div", M4e, [
                    h("span", C4e, [
                      C(R, {
                        name: "CircleCheck",
                        size: 11
                      }),
                      N[31] || (N[31] = X("Resolved", -1))
                    ])
                  ])) : E("", !0)
                ]),
                h("div", {
                  class: "cm-item-acts",
                  onClick: N[8] || (N[8] = Pe(() => {
                  }, ["stop"]))
                }, [
                  h("button", {
                    class: U(["is-resolve", { on: !!q.t.resolvedAt }]),
                    title: q.t.resolvedAt ? "Reopen" : "Resolve",
                    "aria-label": q.t.resolvedAt ? "Reopen" : "Resolve",
                    "data-testid": "comments-item-resolve",
                    onClick: (B) => m(t).resolve(q.t.id, !q.t.resolvedAt)
                  }, [
                    C(R, {
                      name: "CircleCheck",
                      size: 14
                    })
                  ], 10, I4e),
                  h("button", {
                    title: q.unread ? "Mark as read" : "Mark as unread",
                    "aria-label": q.unread ? "Mark as read" : "Mark as unread",
                    "data-testid": "comments-item-read",
                    onClick: (B) => q.unread ? m(t).markRead([q.t]) : m(t).markUnread(q.t)
                  }, [
                    C(R, {
                      name: q.unread ? "CheckCheck" : "MessageSquareDot",
                      size: 14
                    }, null, 8, ["name"])
                  ], 8, A4e),
                  h("div", P4e, [
                    h("button", {
                      title: "More",
                      "aria-label": "More",
                      class: U({ on: r.value === q.t.id }),
                      "data-testid": "comments-item-more",
                      onClick: (B) => w(q.t.id, B)
                    }, [
                      C(R, {
                        name: "Ellipsis",
                        size: 14
                      })
                    ], 10, E4e),
                    r.value === q.t.id ? (g(), v("div", {
                      key: 0,
                      class: U(["cm-card-menu is-item", { "is-up": b.value }]),
                      role: "menu",
                      "data-testid": "comments-item-menu"
                    }, [
                      h("button", {
                        role: "menuitem",
                        onClick: (B) => k(() => m(t).follow(q.t, !m(t).following(q.t)))
                      }, [
                        C(R, {
                          name: m(t).following(q.t) ? "BellOff" : "Bell",
                          size: 14
                        }, null, 8, ["name"]),
                        X(A(m(t).following(q.t) ? "Unfollow" : "Follow"), 1)
                      ], 8, R4e),
                      h("button", {
                        role: "menuitem",
                        onClick: (B) => k(() => m(t).pin(q.t.id, !q.pinned))
                      }, [
                        C(R, {
                          name: q.pinned ? "PinOff" : "Pin",
                          size: 14
                        }, null, 8, ["name"]),
                        X(A(q.pinned ? "Unpin" : "Pin for yourself"), 1)
                      ], 8, z4e),
                      h("button", {
                        role: "menuitem",
                        onClick: (B) => k(() => m(t).copyLink(q.t))
                      }, [
                        C(R, {
                          name: "Link2",
                          size: 14
                        }),
                        N[32] || (N[32] = X("Copy link", -1))
                      ], 8, $4e),
                      m(t).canDelete(q.t) ? (g(), v(H, { key: 0 }, [
                        N[34] || (N[34] = h("span", { class: "cm-card-menu-sep" }, null, -1)),
                        h("button", {
                          role: "menuitem",
                          class: "is-danger",
                          onClick: (B) => k(() => m(t).deleteThread(q.t.id))
                        }, [
                          C(R, {
                            name: "Trash2",
                            size: 14
                          }),
                          N[33] || (N[33] = X("Delete thread", -1))
                        ], 8, D4e)
                      ], 64)) : E("", !0)
                    ], 2)) : E("", !0)
                  ])
                ])
              ], 46, b4e))), 128))
            ], 64))), 128))
          ], 64)) : (g(), v("div", u4e, [
            h("span", h4e, [
              C(R, {
                name: "MessageCircle",
                size: 18
              })
            ]),
            N[28] || (N[28] = h("b", null, "No comments yet", -1)),
            N[29] || (N[29] = h("span", null, [
              X("Press "),
              h("kbd", null, "C"),
              X(", then click anything on the board (or anywhere on it) to start a thread.")
            ], -1)),
            h("button", {
              class: "cm-btn",
              onClick: _
            }, [
              C(R, {
                name: "MessageCirclePlus",
                size: 14
              }),
              N[27] || (N[27] = X("Add a comment", -1))
            ])
          ])) : (g(), v("div", l4e, [...N[24] || (N[24] = [
            h("span", { class: "bd-spinner is-sm" }, null, -1)
          ])]))
        ])
      ], 64)) : (g(), v(H, { key: 1 }, [
        h("div", O4e, [
          h("div", L4e, [
            h("button", {
              class: U(["cm-fchip", { on: m(t).ui.elsewhereUnread }]),
              role: "radio",
              "aria-checked": m(t).ui.elsewhereUnread,
              "data-testid": "elsewhere-unread",
              onClick: N[9] || (N[9] = (te) => m(t).ui.elsewhereUnread = !0)
            }, [
              N[35] || (N[35] = X(" Unread", -1)),
              m(t).elsewhereUnread.value ? (g(), v("span", F4e, A(m(t).elsewhereUnread.value), 1)) : E("", !0)
            ], 10, B4e),
            h("button", {
              class: U(["cm-fchip", { on: !m(t).ui.elsewhereUnread }]),
              role: "radio",
              "aria-checked": !m(t).ui.elsewhereUnread,
              "data-testid": "elsewhere-all",
              onClick: N[10] || (N[10] = (te) => m(t).ui.elsewhereUnread = !1)
            }, "All", 10, N4e)
          ]),
          N[36] || (N[36] = h("span", { class: "cm-grow" }, null, -1)),
          h("button", {
            class: "cm-linkbtn",
            disabled: !m(t).elsewhereUnread.value,
            "data-testid": "elsewhere-mark-all",
            onClick: N[11] || (N[11] = (te) => m(t).markAllReadElsewhere())
          }, "Mark all as read", 8, U4e)
        ]),
        h("div", G4e, [
          $.value.length ? E("", !0) : (g(), v("div", j4e, [
            h("span", H4e, [
              C(R, {
                name: "Inbox",
                size: 18
              })
            ]),
            h("b", null, A(m(t).ui.elsewhereUnread ? "Nothing new elsewhere" : "Nothing to follow yet"), 1),
            N[37] || (N[37] = h("span", null, "Threads you start, reply to or are mentioned in on your other boards show here.", -1))
          ])),
          (g(!0), v(H, null, me($.value, (te) => (g(), v("section", {
            key: te.boardId,
            class: "cm-board-group",
            "data-testid": "elsewhere-board"
          }, [
            h("div", V4e, [
              C(R, {
                name: "LayoutDashboard",
                size: 12
              }),
              h("span", W4e, A(te.title), 1),
              h("span", q4e, A(te.items.length), 1),
              N[38] || (N[38] = h("span", { class: "cm-grow" }, null, -1)),
              te.items.some((G) => m(es)(G, m(i))) ? (g(), v("button", {
                key: 0,
                class: "cm-linkbtn is-sm",
                title: "Mark this board's as read",
                onClick: (G) => m(t).markAllReadElsewhere(te.boardId)
              }, "Mark read", 8, K4e)) : E("", !0)
            ]),
            (g(!0), v(H, null, me(te.items, (G) => (g(), v("div", {
              key: G.id,
              class: U(["cm-item is-elsewhere", { "is-unread": m(es)(G, m(i)), "is-resolved": !!G.resolvedAt }]),
              style: de({ "--thread": f(G.color) }),
              role: "button",
              tabindex: "0",
              "data-testid": "elsewhere-item",
              onClick: (q) => J(G),
              onKeydown: tn((q) => J(G), ["enter"])
            }, [
              m(es)(G, m(i)) ? (g(), v("span", X4e)) : E("", !0),
              C(Vo, {
                uid: G.preview ? G.preview.by : G.createdBy,
                name: G.preview ? G.preview.byName : G.createdByName,
                size: 28
              }, null, 8, ["uid", "name"]),
              h("div", J4e, [
                h("div", Z4e, [
                  h("b", null, A(G.preview ? G.preview.byName : G.createdByName), 1),
                  h("span", Q4e, A(m(Jn)(G.lastAt, m(s))), 1)
                ]),
                G.preview && !T.value.has(G.id) ? (g(), Ce(Fc, {
                  key: 0,
                  class: "cm-item-text",
                  text: G.preview.text,
                  mentions: [{ uid: m(i), name: m(t).myName }],
                  me: m(i),
                  clamp: 3
                }, null, 8, ["text", "mentions", "me"])) : E("", !0),
                T.value.has(G.id) ? (g(), v("div", e5e, [
                  L(G) && !L(G).list ? (g(), v("span", t5e)) : L(G) && L(G).failed ? (g(), v("span", n5e, "This thread couldn't be read. Open it on its board.")) : L(G) ? (g(!0), v(H, { key: 2 }, me(L(G).list, (q) => (g(), Ce(Z_, {
                    key: q.id,
                    c: q,
                    me: m(i),
                    now: m(s),
                    fresh: m(t).isFresh(G, q)
                  }, null, 8, ["c", "me", "now", "fresh"]))), 128)) : E("", !0)
                ])) : E("", !0),
                h("div", i5e, [
                  G.resolvedAt ? (g(), v("span", s5e, [
                    C(R, {
                      name: "CircleCheck",
                      size: 11
                    }),
                    N[39] || (N[39] = X("Resolved", -1))
                  ])) : E("", !0),
                  G.count > 1 ? (g(), v("button", {
                    key: 1,
                    class: "cm-replies-more",
                    "data-testid": "elsewhere-thread-toggle",
                    onClick: Pe((q) => Z(G), ["stop"])
                  }, A(T.value.has(G.id) ? "Show only the newest" : "Show all " + G.count + " comments"), 9, o5e)) : E("", !0),
                  h("span", r5e, [
                    N[40] || (N[40] = X("Open", -1)),
                    C(R, {
                      name: "ArrowUpRight",
                      size: 11
                    })
                  ])
                ])
              ]),
              h("div", {
                class: "cm-item-acts",
                onClick: N[12] || (N[12] = Pe(() => {
                }, ["stop"]))
              }, [
                h("button", {
                  title: m(es)(G, m(i)) ? "Mark as read" : "Mark as unread",
                  "aria-label": m(es)(G, m(i)) ? "Mark as read" : "Mark as unread",
                  onClick: (q) => m(es)(G, m(i)) ? m(t).markRead([G]) : m(t).markUnread(G)
                }, [
                  C(R, {
                    name: m(es)(G, m(i)) ? "CheckCheck" : "MessageSquareDot",
                    size: 14
                  }, null, 8, ["name"])
                ], 8, a5e),
                h("button", {
                  title: "Unfollow",
                  "aria-label": "Unfollow",
                  onClick: (q) => m(t).follow(G, !1)
                }, [
                  C(R, {
                    name: "BellOff",
                    size: 14
                  })
                ], 8, l5e)
              ])
            ], 46, Y4e))), 128))
          ]))), 128))
        ])
      ], 64))
    ], 32));
  }
}), c5e = { key: 0 }, u5e = { key: 0 }, h5e = { key: 0 }, p5e = { key: 1 }, f5e = { key: 0 }, m5e = { key: 2 }, g5e = { key: 0 }, fb = /* @__PURE__ */ Re({
  __name: "ChatText",
  props: {
    text: {},
    caret: { type: Boolean }
  },
  setup(n) {
    const e = n;
    function t(s) {
      const o = [], r = s.split(/(\*\*[^*]+\*\*)/g);
      for (const a of r)
        a && (/^\*\*[^*]+\*\*$/.test(a) ? o.push({ bold: !0, text: a.slice(2, -2) }) : o.push({ bold: !1, text: a }));
      return o;
    }
    const i = I(() => {
      const s = [];
      for (const o of String(e.text || "").split(/\n{2,}/)) {
        const r = o.split(`
`).filter((l) => l.trim() !== "");
        if (!r.length) continue;
        let a = null;
        for (const l of r) {
          const d = /^\s*[-•]\s+(.*)$/.exec(l), c = /^\s*\d+[.)]\s+(.*)$/.exec(l);
          if (d || c) {
            const u = d ? "ul" : "ol";
            (!a || a.kind !== u) && (a = { kind: u, items: [] }, s.push(a)), a.items.push(t((d || c)[1]));
          } else
            (!a || a.kind !== "p") && (a = { kind: "p", lines: [] }, s.push(a)), a.lines.push(t(l));
        }
      }
      return s;
    });
    return (s, o) => (g(), v("div", {
      class: U(["ch-text", { "has-caret": n.caret }])
    }, [
      (g(!0), v(H, null, me(i.value, (r, a) => (g(), v(H, { key: a }, [
        r.kind === "p" ? (g(), v("p", c5e, [
          (g(!0), v(H, null, me(r.lines, (l, d) => (g(), v(H, { key: d }, [
            d ? (g(), v("br", u5e)) : E("", !0),
            (g(!0), v(H, null, me(l, (c, u) => (g(), v(H, { key: u }, [
              c.bold ? (g(), v("b", h5e, A(c.text), 1)) : (g(), v(H, { key: 1 }, [
                X(A(c.text), 1)
              ], 64))
            ], 64))), 128))
          ], 64))), 128))
        ])) : r.kind === "ul" ? (g(), v("ul", p5e, [
          (g(!0), v(H, null, me(r.items, (l, d) => (g(), v("li", { key: d }, [
            (g(!0), v(H, null, me(l, (c, u) => (g(), v(H, { key: u }, [
              c.bold ? (g(), v("b", f5e, A(c.text), 1)) : (g(), v(H, { key: 1 }, [
                X(A(c.text), 1)
              ], 64))
            ], 64))), 128))
          ]))), 128))
        ])) : (g(), v("ol", m5e, [
          (g(!0), v(H, null, me(r.items, (l, d) => (g(), v("li", { key: d }, [
            (g(!0), v(H, null, me(l, (c, u) => (g(), v(H, { key: u }, [
              c.bold ? (g(), v("b", g5e, A(c.text), 1)) : (g(), v(H, { key: 1 }, [
                X(A(c.text), 1)
              ], 64))
            ], 64))), 128))
          ]))), 128))
        ]))
      ], 64))), 128))
    ], 2));
  }
}), b5e = { class: "ch-plan-head" }, v5e = { class: "ch-plan-mark" }, y5e = { class: "ch-plan-titles" }, x5e = { class: "ch-plan-eyebrow" }, w5e = {
  key: 0,
  class: "dot"
}, k5e = { class: "ch-plan-title" }, _5e = { class: "ch-plan-est" }, S5e = ["title"], T5e = {
  key: 0,
  class: "ch-plan-time"
}, M5e = {
  key: 0,
  class: "ch-plan-summary"
}, C5e = { class: "ch-sessions" }, I5e = { class: "ch-session-icon" }, A5e = { class: "ch-session-main" }, P5e = { class: "ch-session-name" }, E5e = { class: "n" }, R5e = {
  key: 0,
  class: "ch-tag",
  title: "A session already in the frame"
}, z5e = {
  key: 1,
  class: "ch-tag is-new",
  title: "The plan adds this session to the frame"
}, $5e = { class: "ch-session-meta" }, D5e = { class: "tk" }, O5e = {
  key: 0,
  class: "ch-session-settings"
}, L5e = {
  key: 1,
  class: "ch-session-why"
}, B5e = ["title", "onClick"], F5e = ["title"], N5e = {
  key: 1,
  class: "ch-actions",
  "data-testid": "plan-steps"
}, U5e = { class: "ch-action-icon" }, G5e = { class: "ch-action-main" }, j5e = { class: "ch-action-text" }, H5e = {
  key: 0,
  class: "ch-action-detail"
}, V5e = {
  key: 2,
  class: "ch-plan-foot"
}, W5e = { class: "ch-plan-breakdown" }, q5e = ["disabled"], K5e = ["disabled"], Y5e = {
  key: 3,
  class: "ch-plan-foot is-running"
}, X5e = { class: "ch-plan-breakdown" }, J5e = { class: "ch-plan-breakdown" }, Q_ = /* @__PURE__ */ Re({
  __name: "PlanCard",
  props: {
    plan: {},
    chatId: {},
    preview: { type: Boolean }
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = fs(t), s = I(() => ZF(e.plan)), o = I(() => e.plan.status === "proposed"), r = I(() => e.plan.status === "running"), a = I(() => r.value && i.isRunningHere(e.plan.id)), l = I(() => {
      const _ = e.plan, x = _.status === "proposed" ? "Proposed plan" : _.status === "running" ? "Running plan" : "Plan", T = s.value;
      return [x, T.sessions === 1 ? "1 session" : T.sessions + " sessions", T.runs === 1 ? "1 run" : T.runs + " runs"];
    }), d = I(() => {
      const _ = s.value;
      return (_.results === 1 ? "1 image" : _.results + " images") + (e.plan.secs ? " · about " + aw(e.plan.secs) : "");
    });
    function c(_) {
      const x = [];
      for (const T of _.runs) for (const M of T.images || []) x.push(M.url);
      return x;
    }
    function u(_) {
      return wl[_.kitId] || "Image";
    }
    const p = /* @__PURE__ */ K({});
    function f(_) {
      p.value = { ...p.value, [_]: !p.value[_] };
    }
    function y(_) {
      return _ === "done" ? "CircleCheck" : _ === "failed" ? "CircleAlert" : _ === "running" ? "Loader2" : "Circle";
    }
    function b() {
      e.preview || i.runPlan(e.chatId, e.plan.id);
    }
    function w() {
      i.cancelPlan(e.chatId, e.plan.id);
    }
    function k() {
      const _ = i.chat(e.chatId), x = _ ? i.frameOf(_) : null;
      x && i.showFrame(x, !0);
      const T = e.plan.sessions.map((M) => M.toolId || M.addedId).filter((M) => !!M && !!t.store.get(M));
      T.length > 1 && t.select(T);
    }
    const S = I(() => {
      const _ = e.plan, x = s.value;
      return _.status === "done" ? "Done: " + (_.results === 1 ? "1 result" : (_.results || 0) + " results") + (_.ranBy ? " · run by " + _.ranBy : "") : _.status === "cancelled" ? _.error || "Cancelled. Nothing was spent." : _.status === "failed" ? "Stopped: " + (_.error || "something went wrong") : _.status === "stopped" ? "Stopped: " + (_.error || "it didn't finish") + (_.results ? " (" + _.results + " of " + x.results + " results made it)" : "") : "";
    });
    return (_, x) => (g(), v("div", {
      class: U(["ch-plan", ["is-" + n.plan.status, { "is-preview": n.preview }]]),
      "data-testid": "plan-card"
    }, [
      h("div", b5e, [
        h("span", v5e, [
          C(R, {
            name: "Route",
            size: 13
          })
        ]),
        h("span", y5e, [
          h("span", x5e, [
            (g(!0), v(H, null, me(l.value, (T, M) => (g(), v(H, { key: M }, [
              M ? (g(), v("span", w5e, "·")) : E("", !0),
              X(A(T), 1)
            ], 64))), 128))
          ]),
          h("span", k5e, A(n.plan.title), 1)
        ]),
        h("span", _5e, [
          h("span", {
            class: U(["ch-plan-cost", { "is-estimate": o.value }]),
            title: o.value ? "Estimated from each tool's price rules, before anything runs" : "Estimated cost",
            "data-testid": "plan-cost"
          }, [
            C(R, {
              name: "Tokens",
              size: 11
            }),
            X(A(m(Kd)(n.plan.tokens)), 1)
          ], 10, S5e),
          n.plan.secs ? (g(), v("span", T5e, [
            C(R, {
              name: "Clock",
              size: 9
            }),
            X("~" + A(m(aw)(n.plan.secs)), 1)
          ])) : E("", !0)
        ])
      ]),
      n.plan.summary ? (g(), v("div", M5e, A(n.plan.summary), 1)) : E("", !0),
      h("div", C5e, [
        (g(!0), v(H, null, me(n.plan.sessions, (T) => (g(), v("div", {
          key: T.key,
          class: "ch-session"
        }, [
          h("span", I5e, [
            C(R, {
              name: u(T),
              size: 13
            }, null, 8, ["name"])
          ]),
          h("span", A5e, [
            h("span", P5e, [
              h("span", E5e, A(T.name), 1),
              T.toolId ? (g(), v("span", R5e, "In frame")) : (g(), v("span", z5e, "New"))
            ]),
            h("span", $5e, [
              T.model !== T.name ? (g(), v(H, { key: 0 }, [
                X(A(T.model), 1),
                x[0] || (x[0] = h("span", { class: "sep" }, "·", -1))
              ], 64)) : E("", !0),
              X(A(T.runs.length === 1 ? "1 run" : T.runs.length + " runs"), 1),
              x[1] || (x[1] = h("span", { class: "sep" }, "·", -1)),
              X(A(T.n === 1 ? "1 result" : T.n + " results") + A(T.runs.length > 1 ? " each" : ""), 1),
              x[2] || (x[2] = h("span", { class: "sep" }, "·", -1)),
              h("span", D5e, [
                C(R, {
                  name: "Tokens",
                  size: 9
                }),
                X(A(m(Kd)(T.tokens)), 1)
              ])
            ]),
            T.settings ? (g(), v("span", O5e, A(T.settings), 1)) : E("", !0),
            T.why && o.value ? (g(), v("span", L5e, [
              C(R, {
                name: "CornerDownRight",
                size: 10
              }),
              X(A(T.why), 1)
            ])) : E("", !0),
            h("button", {
              class: U(["ch-session-prompt", { "is-open": p.value[T.key] }]),
              title: p.value[T.key] ? "Show less" : "Show the whole prompt",
              onClick: (M) => f(T.key)
            }, "“" + A(T.prompt) + "”", 11, B5e),
            c(T).length ? (g(), v("span", {
              key: 2,
              class: "ch-session-inputs",
              title: c(T).length === 1 ? "The image this run takes" : "One image per run"
            }, [
              (g(!0), v(H, null, me(c(T).slice(0, 8), (M, z) => (g(), v("span", {
                key: z,
                class: "th",
                style: de({ backgroundImage: 'url("' + m(Wt)(M) + '")' })
              }, null, 4))), 128))
            ], 8, F5e)) : E("", !0)
          ])
        ]))), 128))
      ]),
      n.plan.steps && n.plan.steps.length ? (g(), v("div", N5e, [
        (g(!0), v(H, null, me(n.plan.steps, (T) => (g(), v("div", {
          key: T.id,
          class: U(["ch-action", "is-" + T.status])
        }, [
          h("span", U5e, [
            C(R, {
              name: y(T.status),
              size: 12,
              spin: T.status === "running"
            }, null, 8, ["name", "spin"])
          ]),
          h("span", G5e, [
            h("span", j5e, A(T.text), 1),
            T.detail ? (g(), v("span", H5e, A(T.detail), 1)) : E("", !0)
          ])
        ], 2))), 128))
      ])) : E("", !0),
      o.value ? (g(), v("div", V5e, [
        h("span", W5e, A(d.value), 1),
        h("button", {
          class: "ch-plan-cancel",
          disabled: n.preview,
          "data-testid": "plan-cancel",
          onClick: w
        }, "Cancel", 8, q5e),
        h("button", {
          class: "ch-plan-run",
          disabled: n.preview,
          "data-testid": "plan-run",
          onClick: b
        }, [
          C(R, {
            name: "Play",
            size: 12
          }),
          x[3] || (x[3] = X("Run plan", -1)),
          x[4] || (x[4] = h("span", { class: "sep" }, "·", -1)),
          C(R, {
            name: "Tokens",
            size: 11
          }),
          X(A(m(Kd)(n.plan.tokens)), 1)
        ], 8, K5e)
      ])) : r.value ? (g(), v("div", Y5e, [
        C(R, {
          name: "Loader2",
          size: 12,
          spin: ""
        }),
        h("span", X5e, "Running" + A(n.plan.ranBy ? " · run by " + n.plan.ranBy : ""), 1),
        a.value ? (g(), v("button", {
          key: 0,
          class: "ch-plan-cancel",
          title: "Stop before the next step; runs already sent still finish",
          onClick: w
        }, "Stop")) : E("", !0)
      ])) : (g(), v("div", {
        key: 4,
        class: U(["ch-plan-foot", "is-" + n.plan.status])
      }, [
        C(R, {
          name: n.plan.status === "done" ? "CircleCheck" : n.plan.status === "cancelled" ? "CircleX" : "CircleAlert",
          size: 12
        }, null, 8, ["name"]),
        h("span", J5e, A(S.value), 1),
        n.plan.status === "done" || n.plan.results && n.plan.status !== "cancelled" ? (g(), v("button", {
          key: 0,
          class: "ch-plan-show",
          onClick: k
        }, [
          C(R, {
            name: "Focus",
            size: 12
          }),
          x[5] || (x[5] = X("Show on board", -1))
        ])) : E("", !0)
      ], 2))
    ], 2));
  }
}), Z5e = {
  class: "ch-picks",
  "data-testid": "chat-picks"
}, Q5e = { class: "ch-pick-main" }, e3e = { class: "ch-pick-top" }, t3e = { class: "ch-pick-name" }, n3e = {
  key: 0,
  class: "ch-pick-price",
  title: "Tokens a result at its default settings"
}, i3e = { class: "ch-pick-why" }, s3e = {
  key: 0,
  class: "ch-pick-kit"
}, o3e = ["disabled", "title", "onClick"], e4 = /* @__PURE__ */ Re({
  __name: "ToolPicks",
  props: {
    picks: {},
    chatId: {},
    preview: { type: Boolean }
  },
  setup(n) {
    const e = n, { board: t } = tt(), i = fs(t), s = I(() => {
      const r = new z6(t.catalog.value, !!t.user.isAdmin);
      return e.picks.map((a) => {
        const l = r.get(a.modelId), d = l ? r.price(l, { prompt: "x", n: 1 }, 1) : null, c = l ? r.kitFor(l, "generate") : null;
        return {
          ...a,
          on: !!l,
          avatar: l && l.model.avatar ? l.model.avatar : "",
          icon: c && wl[c.id] || "Image",
          kit: c ? c.name : "",
          price: d == null ? "" : Kd(d) + (l && l.model.tokensLabel.includes("+") ? "+" : "")
        };
      });
    });
    function o(r) {
      e.preview || i.addTool(e.chatId, r);
    }
    return (r, a) => (g(), v("div", Z5e, [
      (g(!0), v(H, null, me(s.value, (l) => (g(), v("div", {
        key: l.modelId,
        class: U(["ch-pick", { "is-off": !l.on }])
      }, [
        h("span", {
          class: "ch-pick-pic",
          style: de(l.avatar ? { backgroundImage: 'url("' + l.avatar + '")' } : void 0)
        }, [
          l.avatar ? E("", !0) : (g(), Ce(R, {
            key: 0,
            name: l.icon,
            size: 14
          }, null, 8, ["name"]))
        ], 4),
        h("div", Q5e, [
          h("div", e3e, [
            h("span", t3e, A(l.name), 1),
            l.price ? (g(), v("span", n3e, A(l.price), 1)) : E("", !0)
          ]),
          h("div", i3e, A(l.why), 1),
          l.kit ? (g(), v("div", s3e, A(l.kit), 1)) : E("", !0)
        ]),
        l.on ? (g(), v("button", {
          key: 0,
          class: "ch-pick-try",
          disabled: n.preview,
          title: "Add a " + l.name + " session to this frame, ready for a prompt",
          "data-testid": "chat-pick-try",
          onClick: (d) => o(l.modelId)
        }, [
          C(R, {
            name: "Plus",
            size: 11
          }),
          a[0] || (a[0] = X("Try it", -1))
        ], 8, o3e)) : E("", !0)
      ], 2))), 128))
    ]));
  }
}), r3e = {
  class: "ch-ideas",
  "data-testid": "chat-ideas"
}, a3e = ["disabled", "title", "onClick"], l3e = { class: "ch-idea-n" }, d3e = { class: "ch-idea-main" }, c3e = { class: "ch-idea-title" }, u3e = { class: "ch-idea-pitch" }, h3e = {
  key: 0,
  class: "ch-idea-tool"
}, t4 = /* @__PURE__ */ Re({
  __name: "IdeaCards",
  props: {
    ideas: {},
    preview: { type: Boolean }
  },
  emits: ["pick"],
  setup(n, { emit: e }) {
    const t = n, i = e;
    function s(o) {
      t.preview || i("pick", `Let's go with "` + o.title + '": ' + o.pitch + (o.tool ? " Use " + o.tool + "." : "") + " Make a plan for it.");
    }
    return (o, r) => (g(), v("div", r3e, [
      (g(!0), v(H, null, me(n.ideas, (a, l) => (g(), v("button", {
        key: a.title,
        class: "ch-idea",
        disabled: n.preview,
        title: "Plan “" + a.title + "”",
        onClick: (d) => s(a)
      }, [
        h("span", l3e, A(l + 1), 1),
        h("span", d3e, [
          h("span", c3e, A(a.title), 1),
          h("span", u3e, A(a.pitch), 1),
          a.tool ? (g(), v("span", h3e, [
            C(R, {
              name: "Sparkles",
              size: 10
            }),
            X(A(a.tool), 1)
          ])) : E("", !0)
        ]),
        C(R, {
          class: "ch-idea-go",
          name: "ChevronRight",
          size: 13
        })
      ], 8, a3e))), 128))
    ]));
  }
}), p3e = { class: "ch-head" }, f3e = { class: "ch-head-mark" }, m3e = { class: "ch-head-titles ch-switch" }, g3e = ["title", "aria-expanded"], b3e = { class: "t" }, v3e = {
  key: 0,
  class: "ch-switch-menu",
  role: "menu"
}, y3e = ["onClick"], x3e = { class: "m" }, w3e = { class: "n" }, k3e = { class: "f" }, _3e = { class: "c" }, S3e = { class: "ch-head-sub" }, T3e = ["title"], M3e = {
  class: "ch-head-n",
  "data-testid": "chat-in-context"
}, C3e = {
  key: 0,
  class: "ch-context",
  "data-testid": "chat-context"
}, I3e = ["title", "onClick"], A3e = {
  key: 0,
  class: "ch-ctxchip is-empty"
}, P3e = {
  key: 1,
  class: "ch-context is-none"
}, E3e = {
  key: 0,
  class: "ch-intro"
}, R3e = { class: "ch-intro-mark" }, z3e = { class: "ch-intro-title" }, $3e = {
  key: 0,
  class: "ch-chips is-start"
}, D3e = ["onClick"], O3e = { class: "ch-msg-meta" }, L3e = { class: "ch-bubble" }, B3e = {
  key: 1,
  class: "ch-msg is-agent"
}, F3e = { class: "ch-ai-mark" }, N3e = { class: "ch-ai-body" }, U3e = ["title"], G3e = {
  key: 5,
  class: "ch-chips",
  "data-testid": "chat-chips"
}, j3e = ["onClick"], H3e = {
  key: 1,
  class: "ch-msg is-agent is-live",
  "data-testid": "chat-live"
}, V3e = { class: "ch-ai-mark is-busy" }, W3e = { class: "ch-ai-body" }, q3e = {
  key: 1,
  class: "ch-status"
}, K3e = {
  key: 2,
  class: "ch-plan is-skeleton"
}, Y3e = { class: "ch-composer" }, X3e = ["placeholder", "disabled", "readonly", "maxlength"], J3e = { class: "ch-comp-foot" }, Z3e = {
  key: 0,
  class: "ch-model"
}, Q3e = ["aria-expanded", "title"], e6e = { class: "t" }, t6e = {
  key: 0,
  class: "ch-model-menu",
  role: "menu"
}, n6e = ["aria-checked", "data-testid", "onClick"], i6e = { class: "m" }, s6e = { class: "n" }, o6e = { class: "f" }, r6e = ["aria-checked"], a6e = {
  key: 1,
  class: "ch-model-note"
}, l6e = ["title"], d6e = ["disabled"], c6e = /* @__PURE__ */ Re({
  __name: "ChatPanel",
  setup(n) {
    const { board: e } = tt(), t = fs(e), i = t.open, s = I(() => i.value ? t.frameOf(i.value) : null), o = I(() => i.value ? t.contextOf(i.value) : null), r = I(() => o.value ? $6(o.value) : 0), a = I(() => i.value ? i.value.messages || [] : []), l = I(() => i.value && t.live[i.value.id] || null), d = Ko(), c = I(() => {
      const he = o.value;
      if (!he) return [];
      const ye = [];
      return he.images.length && ye.push({
        key: "images",
        icon: "Image",
        label: he.images.length === 1 ? "1 image" : he.images.length + " images",
        ids: he.images.map((fe) => fe.id),
        title: he.images.map((fe, ze) => "Image " + (ze + 1) + (fe.model ? ": " + fe.model : "") + (fe.prompt ? ", “" + fe.prompt.slice(0, 60) + (fe.prompt.length > 60 ? "…" : "") + "”" : "")).join(`
`)
      }), he.sessions.length && ye.push({
        key: "sessions",
        icon: wl[he.sessions[0].kitId] || "Image",
        label: he.sessions.length === 1 ? "1 session" : he.sessions.length + " sessions",
        ids: he.sessions.map((fe) => fe.id),
        title: he.sessions.map((fe) => fe.name + " (" + fe.model + ")").join(`
`)
      }), he.notes.length && ye.push({
        key: "notes",
        icon: "StickyNote",
        label: he.notes.length === 1 ? "1 note" : he.notes.length + " notes",
        ids: he.notes.map((fe) => fe.id),
        title: `Notes are standing instructions:
` + he.notes.map((fe) => "“" + fe.text.slice(0, 80) + "”").join(`
`)
      }), ye;
    });
    function u(he) {
      const ye = he.filter((fe) => !!e.store.get(fe));
      ye.length && e.select(ye);
    }
    const p = I(() => {
      const he = o.value;
      if (!he) return [];
      const ye = [];
      return he.images.length && ye.push({ label: "Make these night scenes", send: "Please change " + (he.images.length === 1 ? "this image" : "all " + he.images.length + " of these images") + " to a nighttime scene with ChatGPT Image 2.5. Use recommended settings." }), he.sessions.length && ye.push({ label: "Run a new prompt through these", send: "Now try: a glass pavilion in a pine forest at dawn" }), ye.push({ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }), he.images.length || ye.push({ label: "Make 4 concept images", send: "Make 4 concept images of a timber pavilion on a lake at dusk" }), ye.push({ label: "Prompting tips", send: "How should I prompt Ideogram for signage text?" }), ye.slice(0, 4);
    }), f = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ K(""), b = /* @__PURE__ */ K(null), w = /* @__PURE__ */ K(null), k = Ty({
      board: e,
      field: "chat",
      sessionId: () => i.value ? i.value.id : null,
      value: () => y.value,
      write: (he) => {
        y.value = he, it(te);
      }
    }), S = I(() => k.ghost.value || VF(o.value)), _ = I(() => t.brain.value), x = I(() => t.agentStatus.value), T = I(() => x.value && x.value.ready && x.value.models || []), M = I(() => !t.guided && (t.canSimulate || T.value.length > 0)), z = t.showCosts, P = /* @__PURE__ */ K(!1), D = I(() => {
      const he = T.value.find((ye) => ye.id === _.value);
      return he ? he.label : _.value === yi ? "Simulated" : x.value ? "Unavailable" : "Connecting…";
    }), $ = I(() => {
      const he = x.value;
      return he ? he.ready ? "" : he.reason || "No model is set up here." : t.asksAgent ? "Checking which models can answer…" : "";
    });
    function O(he) {
      P.value = !1, t.setBrain(he);
    }
    function L(he) {
      return he >= 1e3 ? (Math.round(he / 100) / 10).toLocaleString("en-US") + "K" : String(he);
    }
    function Z(he) {
      return he == null ? "" : "≈" + (he < 10 ? Math.round(he * 10) / 10 : Math.round(he)).toLocaleString("en-US");
    }
    function J(he) {
      return "$" + he.input + " / $" + he.output + " per 1M";
    }
    const re = I(() => i.value && i.value.spend || null), F = I(() => {
      const he = re.value;
      return !z || !he || !he.turns ? "" : "This chat " + Nm(he.usd) + " at the API · " + Z(he.credits) + " tokens · " + he.turns + (he.turns === 1 ? " answer" : " answers");
    }), W = I(() => {
      if (!z) return;
      const he = re.value;
      if (!he) return KF;
      const ye = Object.entries(he.byModel).map(([He, ce]) => He + ": " + Nm(ce.usd) + " over " + ce.turns + (ce.turns === 1 ? " answer" : " answers")), fe = i.value, ze = fe ? t.usage[fe.id] : null;
      return ze && ye.push("Last answer: " + Math.round(ze.ms / 100) / 10 + "s, " + L(ze.input) + " tokens in (" + L(ze.cached) + " cached), " + L(ze.output) + " out"), ye.push("Tokens are RunDiffusion tokens at $0.0006 each: an estimate, nothing is charged."), ye.join(`
`);
    }), ee = I(() => F.value || "nothing runs until Run plan"), N = I(() => !!y.value.trim() && !!s.value && !l.value);
    $e(() => i.value ? i.value.id : null, (he, ye) => {
      ye && f.set(ye, y.value), y.value = he && f.get(he) || "", it(() => {
        te(), Oe(!0), b.value && b.value.focus({ preventScroll: !0 });
      });
    }, { immediate: !0 });
    function te() {
      const he = b.value;
      he && (he.style.height = "auto", he.style.height = Math.min(160, Math.max(44, he.scrollHeight)) + "px");
    }
    function G(he) {
      const ye = i.value, fe = (he != null ? he : y.value).trim();
      !ye || !fe || l.value || !s.value || (he == null && (y.value = "", it(te)), t.send(ye.id, fe), it(() => Oe(!0)));
    }
    function q(he) {
      G(he.send || he.label);
    }
    function B(he) {
      he.key === "Enter" && !he.shiftKey && !he.isComposing && (he.preventDefault(), G());
    }
    const ne = I(() => {
      for (let he = a.value.length - 1; he >= 0; he--) if (a.value[he].role === "agent") return a.value[he].id;
      return null;
    }), se = I(() => a.value.length > 0 && a.value[a.value.length - 1].role === "agent");
    function Y(he) {
      return he.role === "user" && he.authorId === e.user.uid;
    }
    function ie(he) {
      return d.value, Jn(he);
    }
    let De = !0;
    function xe() {
      const he = w.value;
      he && (De = he.scrollTop + he.clientHeight > he.scrollHeight - 60);
    }
    function Oe(he = !1) {
      const ye = w.value;
      !ye || !he && !De || (ye.scrollTop = ye.scrollHeight);
    }
    $e(() => [a.value.length, l.value ? l.value.text.length : -1, l.value && l.value.plan ? 1 : 0, l.value ? l.value.status : ""], () => it(() => Oe())), $e(() => JSON.stringify(a.value.map((he) => he.plan ? (he.plan.steps || []).length + he.plan.status : "")), () => it(() => Oe()));
    function Ee() {
      t.close();
    }
    const j = /* @__PURE__ */ K(!1), V = I(() => (e.docRev.value, t.allChats().map((he) => {
      const ye = t.frameOf(he);
      return { id: he.id, name: he.name, frame: ye ? ye.title : "Not in a frame", n: t8(he) };
    })));
    function Q(he) {
      j.value = !1, e.ui.selection = [he], e.ui.chatOpen = he;
    }
    function oe(he) {
      const ye = he.target;
      j.value && ye && !ye.closest(".ch-switch") && (j.value = !1), P.value && ye && !ye.closest(".ch-model") && (P.value = !1);
    }
    window.addEventListener("pointerdown", oe, !0), Ve(() => window.removeEventListener("pointerdown", oe, !0));
    function ue() {
      s.value && t.showFrame(s.value, !0);
    }
    function Ie(he) {
      if (he.key === "Escape") {
        he.stopPropagation();
        const ye = document.activeElement;
        ye && ye.tagName === "TEXTAREA" ? ye.blur() : Ee();
      }
    }
    return ot(() => it(() => Oe(!0))), Ve(() => {
      i.value && f.set(i.value.id, y.value);
    }), (he, ye) => m(i) ? (g(), v("aside", {
      key: 0,
      class: "ch-panel",
      "data-testid": "chat-panel",
      onPointerdown: ye[6] || (ye[6] = Pe(() => {
      }, ["stop"])),
      onKeydown: Ie
    }, [
      h("header", p3e, [
        h("span", f3e, [
          C(R, {
            name: "MessagesSquare",
            size: 15
          })
        ]),
        h("div", m3e, [
          h("button", {
            class: U(["ch-head-name", { "has-more": V.value.length > 1 }]),
            title: V.value.length > 1 ? "Switch to another chat on this board" : m(i).name,
            "aria-expanded": j.value,
            "data-testid": "chat-switch",
            onClick: ye[0] || (ye[0] = (fe) => V.value.length > 1 && (j.value = !j.value))
          }, [
            h("span", b3e, A(m(i).name), 1),
            V.value.length > 1 ? (g(), Ce(R, {
              key: 0,
              name: "ChevronDown",
              size: 12
            })) : E("", !0)
          ], 10, g3e),
          j.value ? (g(), v("div", v3e, [
            ye[7] || (ye[7] = h("div", { class: "ch-switch-eyebrow" }, "Chats on this board", -1)),
            (g(!0), v(H, null, me(V.value, (fe) => (g(), v("button", {
              key: fe.id,
              class: U(["ch-switch-row", { on: fe.id === m(i).id }]),
              role: "menuitem",
              onClick: (ze) => Q(fe.id)
            }, [
              C(R, {
                name: "MessagesSquare",
                size: 13
              }),
              h("span", x3e, [
                h("span", w3e, A(fe.name), 1),
                h("span", k3e, A(fe.frame), 1)
              ]),
              h("span", _3e, A(fe.n), 1)
            ], 10, y3e))), 128))
          ])) : E("", !0),
          h("div", S3e, [
            s.value ? (g(), v(H, { key: 0 }, [
              h("span", {
                class: "ch-head-frame",
                title: s.value.title
              }, "in " + A(s.value.title), 9, T3e),
              ye[8] || (ye[8] = h("span", { class: "dot" }, "·", -1)),
              h("span", M3e, A(r.value) + " in context", 1)
            ], 64)) : (g(), v(H, { key: 1 }, [
              X("Not in a frame")
            ], 64))
          ])
        ]),
        h("button", {
          class: "ch-iconbtn",
          title: "Show the frame",
          "aria-label": "Show the frame",
          onClick: ue
        }, [
          C(R, {
            name: "Focus",
            size: 14
          })
        ]),
        h("button", {
          class: "ch-iconbtn",
          title: "Close (Esc)",
          "aria-label": "Close the chat",
          "data-testid": "chat-close",
          onClick: Ee
        }, [
          C(R, {
            name: "X",
            size: 15
          })
        ])
      ]),
      s.value ? (g(), v("div", C3e, [
        (g(!0), v(H, null, me(c.value, (fe) => (g(), v("button", {
          key: fe.key,
          class: "ch-ctxchip",
          title: fe.title + `

Click to select them on the board.`,
          onClick: (ze) => u(fe.ids)
        }, [
          C(R, {
            name: fe.icon,
            size: 11
          }, null, 8, ["name"]),
          X(A(fe.label), 1)
        ], 8, I3e))), 128)),
        c.value.length ? E("", !0) : (g(), v("span", A3e, [
          C(R, {
            name: "Frame",
            size: 11
          }),
          ye[9] || (ye[9] = X("Empty frame", -1))
        ]))
      ])) : (g(), v("div", P3e, "Move this chat into a frame: everything in the frame becomes its context.")),
      h("div", {
        ref_key: "scroller",
        ref: w,
        class: "ch-scroll",
        onScrollPassive: xe
      }, [
        !a.value.length && !l.value ? (g(), v("div", E3e, [
          h("span", R3e, [
            C(R, {
              name: "Sparkles",
              size: 16
            })
          ]),
          h("div", z3e, A(s.value ? r.value ? "Ask about “" + s.value.title + "”" : "What should we build in “" + s.value.title + "”?" : "This chat isn't in a frame"), 1),
          ye[10] || (ye[10] = h("div", { class: "ch-intro-sub" }, " Everything in this frame is my context. I can set up tool sessions here and run them for you, always with a priced plan you approve first. ", -1)),
          s.value && !m(t).guided ? (g(), v("div", $3e, [
            (g(!0), v(H, null, me(p.value, (fe) => (g(), v("button", {
              key: fe.label,
              class: "ch-chip",
              onClick: (ze) => q(fe)
            }, A(fe.label), 9, D3e))), 128))
          ])) : E("", !0)
        ])) : E("", !0),
        (g(!0), v(H, null, me(a.value, (fe) => (g(), v(H, {
          key: fe.id
        }, [
          fe.role === "user" ? (g(), v("div", {
            key: 0,
            class: U(["ch-msg is-user", { "is-theirs": !Y(fe) }])
          }, [
            h("div", O3e, [
              X(A(Y(fe) ? "You" : fe.author), 1),
              ye[11] || (ye[11] = h("span", { class: "dot" }, "·", -1)),
              X(A(ie(fe.at)), 1)
            ]),
            h("div", L3e, [
              C(fb, {
                text: fe.text
              }, null, 8, ["text"])
            ])
          ], 2)) : (g(), v("div", B3e, [
            h("span", F3e, [
              C(R, {
                name: "Sparkles",
                size: 12
              })
            ]),
            h("div", N3e, [
              fe.text ? (g(), Ce(fb, {
                key: 0,
                class: "ch-ai-text",
                text: fe.text
              }, null, 8, ["text"])) : E("", !0),
              fe.plan ? (g(), Ce(Q_, {
                key: 1,
                plan: fe.plan,
                "chat-id": m(i).id
              }, null, 8, ["plan", "chat-id"])) : E("", !0),
              fe.picks && fe.picks.length ? (g(), Ce(e4, {
                key: 2,
                picks: fe.picks,
                "chat-id": m(i).id
              }, null, 8, ["picks", "chat-id"])) : E("", !0),
              fe.ideas && fe.ideas.length ? (g(), Ce(t4, {
                key: 3,
                ideas: fe.ideas,
                preview: !!l.value,
                onPick: G
              }, null, 8, ["ideas", "preview"])) : E("", !0),
              m(z) && fe.usage ? (g(), v("div", {
                key: 4,
                class: "ch-msg-cost",
                title: L(fe.usage.input) + " tokens in (" + L(fe.usage.cached) + " cached), " + L(fe.usage.output) + " out"
              }, [
                X(A(fe.usage.model), 1),
                ye[13] || (ye[13] = h("span", { class: "dot" }, "·", -1)),
                X(A(fe.usage.usd == null ? "price unknown" : m(Nm)(fe.usage.usd)), 1),
                fe.usage.credits != null ? (g(), v(H, { key: 0 }, [
                  ye[12] || (ye[12] = h("span", { class: "dot" }, "·", -1)),
                  C(R, {
                    name: "Tokens",
                    size: 10
                  }),
                  X(A(Z(fe.usage.credits)), 1)
                ], 64)) : E("", !0),
                ye[14] || (ye[14] = h("span", { class: "dot" }, "·", -1)),
                X(A(Math.round(fe.usage.ms / 100) / 10) + "s ", 1)
              ], 8, U3e)) : E("", !0),
              fe.chips && fe.chips.length && fe.id === ne.value && se.value && !l.value && (!fe.plan || fe.plan.status === "proposed") ? (g(), v("div", G3e, [
                (g(!0), v(H, null, me(fe.chips, (ze) => (g(), v("button", {
                  key: ze.label,
                  class: "ch-chip",
                  onClick: (He) => q(ze)
                }, A(ze.label), 9, j3e))), 128))
              ])) : E("", !0)
            ])
          ]))
        ], 64))), 128)),
        l.value ? (g(), v("div", H3e, [
          h("span", V3e, [
            C(R, {
              name: "Sparkles",
              size: 12
            })
          ]),
          h("div", W3e, [
            l.value.text ? (g(), Ce(fb, {
              key: 0,
              class: "ch-ai-text",
              text: m(n8)(l.value.text),
              caret: ""
            }, null, 8, ["text"])) : E("", !0),
            l.value.status ? (g(), v("div", q3e, A(l.value.status), 1)) : E("", !0),
            l.value.status === "Pricing the plan…" ? (g(), v("div", K3e, [...ye[15] || (ye[15] = [
              h("div", { class: "sk sk-a" }, null, -1),
              h("div", { class: "sk sk-b" }, null, -1),
              h("div", { class: "sk sk-c" }, null, -1)
            ])])) : E("", !0),
            l.value.plan ? (g(), Ce(Q_, {
              key: 3,
              plan: l.value.plan,
              "chat-id": m(i).id,
              preview: ""
            }, null, 8, ["plan", "chat-id"])) : E("", !0),
            l.value.picks.length ? (g(), Ce(e4, {
              key: 4,
              picks: l.value.picks,
              "chat-id": m(i).id,
              preview: ""
            }, null, 8, ["picks", "chat-id"])) : E("", !0),
            l.value.ideas.length ? (g(), Ce(t4, {
              key: 5,
              ideas: l.value.ideas,
              preview: ""
            }, null, 8, ["ideas"])) : E("", !0)
          ])
        ])) : E("", !0)
      ], 544),
      h("footer", Y3e, [
        h("div", {
          class: U(["ch-comp-box", { "is-off": !s.value }])
        }, [
          xt(h("textarea", {
            ref_key: "inputEl",
            ref: b,
            "onUpdate:modelValue": ye[1] || (ye[1] = (fe) => y.value = fe),
            class: U(["ch-comp-input", { "is-tour-ghost": !!m(k).ghost.value, "is-typing": m(k).typing.value }]),
            placeholder: S.value,
            disabled: !s.value,
            readonly: m(k).held.value || m(k).typing.value,
            maxlength: m(cv),
            rows: "1",
            spellcheck: "true",
            "data-testid": "chat-input",
            onKeydown: B,
            onInput: te
          }, null, 42, X3e), [
            [Jt, y.value]
          ]),
          m(k).ghost.value ? (g(), v("button", {
            key: 0,
            type: "button",
            tabindex: "-1",
            class: "up-cue is-tour ch-tour-cue",
            "data-testid": "chat-ghost-cue",
            onClick: ye[2] || (ye[2] = (fe) => m(e).tour && m(e).tour.press && m(e).tour.press("chat"))
          }, [...ye[16] || (ye[16] = [
            h("kbd", null, "Tab", -1),
            X(" to write it in", -1)
          ])])) : E("", !0),
          h("div", J3e, [
            M.value ? (g(), v("div", Z3e, [
              h("button", {
                class: U(["ch-model-btn", { "is-sim": _.value === m(yi) }]),
                "aria-expanded": P.value,
                title: $.value || "Who answers",
                "data-testid": "chat-model",
                onClick: ye[3] || (ye[3] = (fe) => P.value = !P.value)
              }, [
                C(R, {
                  name: _.value === m(yi) ? "Route" : "Sparkles",
                  size: 11
                }, null, 8, ["name"]),
                h("span", e6e, A(D.value), 1),
                C(R, {
                  name: "ChevronUp",
                  size: 11
                })
              ], 10, Q3e),
              P.value ? (g(), v("div", t6e, [
                ye[18] || (ye[18] = h("div", { class: "ch-switch-eyebrow" }, "Who answers", -1)),
                (g(!0), v(H, null, me(T.value, (fe) => (g(), v("button", {
                  key: fe.id,
                  class: U(["ch-model-row", { on: fe.id === _.value }]),
                  role: "menuitemradio",
                  "aria-checked": fe.id === _.value,
                  "data-testid": "chat-model-" + fe.id,
                  onClick: (ze) => O(fe.id)
                }, [
                  h("span", i6e, [
                    h("span", s6e, A(fe.label), 1),
                    h("span", o6e, [
                      X(A(fe.route) + " · " + A(fe.effort) + " reasoning", 1),
                      m(z) && fe.price ? (g(), v(H, { key: 0 }, [
                        X(" · " + A(J(fe.price)), 1)
                      ], 64)) : E("", !0)
                    ])
                  ]),
                  fe.id === _.value ? (g(), Ce(R, {
                    key: 0,
                    name: "Check",
                    size: 12
                  })) : E("", !0)
                ], 10, n6e))), 128)),
                m(t).canSimulate ? (g(), v("button", {
                  key: 0,
                  class: U(["ch-model-row", { on: _.value === m(yi) }]),
                  role: "menuitemradio",
                  "aria-checked": _.value === m(yi),
                  "data-testid": "chat-model-simulated",
                  onClick: ye[4] || (ye[4] = (fe) => O(m(yi)))
                }, [
                  ye[17] || (ye[17] = h("span", { class: "m" }, [
                    h("span", { class: "n" }, "Simulated"),
                    h("span", { class: "f" }, "Scripted answers, no model")
                  ], -1)),
                  _.value === m(yi) ? (g(), Ce(R, {
                    key: 0,
                    name: "Check",
                    size: 12
                  })) : E("", !0)
                ], 10, r6e)) : E("", !0),
                $.value ? (g(), v("div", a6e, A($.value), 1)) : E("", !0)
              ])) : E("", !0)
            ])) : E("", !0),
            h("span", {
              class: "ch-comp-hint",
              title: W.value,
              "data-testid": "chat-spend"
            }, A(ee.value), 9, l6e),
            h("button", {
              class: "ch-send",
              disabled: !N.value,
              title: "Send (Enter)",
              "aria-label": "Send",
              "data-testid": "chat-send",
              onClick: ye[5] || (ye[5] = (fe) => G())
            }, [
              C(R, {
                name: "ArrowUp",
                size: 15
              })
            ], 8, d6e)
          ])
        ], 2)
      ])
    ], 32)) : E("", !0);
  }
}), u6e = 4, Tr = 0.01, h6e = 24, qt = (n, e) => e === "x" ? n.x : n.y, Bt = (n, e) => e === "x" ? n.x + n.w : n.y + n.h, Ny = (n) => n === "x" ? "y" : "x";
function HI(n, e, t) {
  const i = Ny(t);
  return qt(n, i) < Bt(e, i) && qt(e, i) < Bt(n, i);
}
function n4(n, e, t) {
  const i = i4(n, e, "x", t), s = i4(n, e, "y", t);
  return { dx: i === null ? 0 : i, dy: s === null ? 0 : s, x: i !== null, y: s !== null };
}
function i4(n, e, t, i) {
  let s = null;
  const o = (d) => {
    Math.abs(d) <= i && (s === null || Math.abs(d) < Math.abs(s)) && (s = d);
  }, r = qt(n, t), a = Bt(n, t), l = (r + a) / 2;
  for (const d of e) {
    const c = qt(d, t), u = Bt(d, t);
    o(c - r), o(u - r), o(c - a), o(u - a), o((c + u) / 2 - l);
  }
  for (const d of p6e(n, e, t)) o(d);
  return s;
}
function VI(n, e, t, i) {
  const s = [];
  let o = null, r = null;
  const a = qt(n, t), l = Bt(n, t);
  for (const d of e)
    HI(d, n, t) && (s.push(d), Bt(d, t) <= a + i ? (!o || Bt(d, t) > Bt(o, t)) && (o = d) : qt(d, t) >= l - i && (!r || qt(d, t) < qt(r, t)) && (r = d));
  return { row: s, before: o, after: r };
}
function WI(n, e) {
  if (n.length < 2) return [];
  const t = n.slice().sort((s, o) => Bt(s, e) - Bt(o, e)), i = [];
  for (const s of n) {
    const o = qt(s, e);
    let r = 0, a = t.length;
    for (; r < a; ) {
      const c = r + a >> 1;
      Bt(t[c], e) <= o ? r = c + 1 : a = c;
    }
    if (r === 0) continue;
    const l = t[r - 1], d = o - Bt(l, e);
    d > 0 && HI(l, s, e) && i.push({ p: l, q: s, size: d });
  }
  return i;
}
function p6e(n, e, t) {
  const { row: i, before: s, after: o } = VI(n, e, t, 0);
  if (!s && !o) return [];
  const r = qt(n, t), a = Bt(n, t), l = [];
  s && o && qt(o, t) - Bt(s, t) >= a - r && l.push((Bt(s, t) + qt(o, t)) / 2 - (r + a) / 2);
  for (const d of WI(i, t))
    s && l.push(Bt(s, t) + d.size - r), o && l.push(qt(o, t) - d.size - a);
  return l;
}
function s4(n, e) {
  return {
    lines: hf(n, e, "x", !0).concat(hf(n, e, "y", !0)),
    gaps: o4(n, e, "x").concat(o4(n, e, "y")).slice(0, h6e)
  };
}
function hf(n, e, t, i) {
  const s = Ny(t), o = qt(n, t), r = Bt(n, t), a = (o + r) / 2, l = [o, a, r], d = [null, null, null], c = (f, y) => Math.abs(f - y) <= Tr, u = (f, y) => {
    const b = d[f] || [qt(n, s), Bt(n, s)];
    b[0] = Math.min(b[0], qt(y, s)), b[1] = Math.max(b[1], Bt(y, s)), d[f] = b;
  };
  for (const f of e) {
    const y = qt(f, t), b = Bt(f, t);
    let w = !1;
    i && (c(o, y) || c(o, b)) && (u(0, f), w = !0), (c(r, y) || c(r, b)) && (u(2, f), w = !0), i && !w && c(a, (y + b) / 2) && u(1, f);
  }
  const p = [];
  return d.forEach((f, y) => {
    if (!f) return;
    const b = p.find((w) => c(w.at, l[y]));
    b ? (b.from = Math.min(b.from, f[0]), b.to = Math.max(b.to, f[1])) : p.push({ axis: t, at: l[y], from: f[0], to: f[1] });
  }), p;
}
function o4(n, e, t) {
  const { row: i, before: s, after: o } = VI(n, e, t, Tr);
  if (!s && !o) return [];
  const r = s ? qt(n, t) - Bt(s, t) : 0, a = o ? qt(o, t) - Bt(n, t) : 0, l = (f, y) => Math.abs(f - y) <= Tr, d = [], c = (f, y) => d.push({ axis: t, from: Bt(f, t), to: qt(y, t), at: f6e(f, y, t) });
  let u = r > Tr && a > Tr && l(r, a), p = u;
  for (const f of WI(i, t))
    r > Tr && l(f.size, r) ? (u = !0, c(f.p, f.q)) : a > Tr && l(f.size, a) && (p = !0, c(f.p, f.q));
  return u && s && c(s, n), p && o && c(n, o), d;
}
function f6e(n, e, t) {
  const i = Ny(t), s = Math.max(qt(n, i), qt(e, i)), o = Math.min(Bt(n, i), Bt(e, i));
  return s <= o ? (s + o) / 2 : (qt(n, i) + Bt(n, i) + qt(e, i) + Bt(e, i)) / 4;
}
function m6e(n, e, t) {
  const i = r4(n.x + n.w, e, "x", t), s = r4(n.y + n.h, e, "y", t);
  return { dx: i === null ? 0 : i, dy: s === null ? 0 : s, x: i !== null, y: s !== null };
}
function r4(n, e, t, i) {
  let s = null;
  const o = (r) => {
    Math.abs(r) <= i && (s === null || Math.abs(r) < Math.abs(s)) && (s = r);
  };
  for (const r of e)
    o(qt(r, t) - n), o(Bt(r, t) - n);
  return s;
}
function g6e(n, e) {
  return { lines: hf(n, e, "x", !1).concat(hf(n, e, "y", !1)), gaps: [] };
}
var b6e = Object.defineProperty, v6e = (n, e, t) => e in n ? b6e(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, xi = (n, e, t) => v6e(n, typeof e != "symbol" ? e + "" : e, t);
const mb = 4;
function x0(n) {
  const e = n || document.activeElement;
  if (!e) return !1;
  const t = e.tagName;
  return t === "TEXTAREA" || t === "INPUT" || t === "SELECT" || !!e.isContentEditable;
}
function gh() {
  const n = document.activeElement;
  n && n.blur && x0(n) && n.blur();
}
function so(n) {
  return Math.round(n * 1e3) / 1e3;
}
function a4(n, e, t) {
  return { x: n.x + e, y: n.y + t, w: n.w, h: n.h };
}
function l4(n) {
  return n.x && (!n.y || Math.abs(n.dx) <= Math.abs(n.dy)) ? "x" : n.y ? "y" : null;
}
class gb {
  constructor(e, t, i, s) {
    xi(this, "b", e), xi(this, "exclude", t), xi(this, "free"), xi(this, "cam", null), xi(this, "rects", []), xi(this, "onKey"), this.free = vn(i), this.onKey = (o) => {
      vn(o) !== this.free && (this.free = !this.free, s());
    }, window.addEventListener("keydown", this.onKey), window.addEventListener("keyup", this.onKey);
  }
  /** The command key, as a pointer event has it. */
  pointer(e) {
    this.free = vn(e);
  }
  /** How near counts, in world units at this zoom. */
  get tol() {
    return u6e / this.b.cam.value.zoom;
  }
  /** What is in view, less what moves; read again whenever the camera moves. */
  targets() {
    const e = this.b.cam.value;
    if (e !== this.cam) {
      this.cam = e, this.rects = [];
      for (const t of this.b.store.query(Xa(e, this.b.view.w, this.b.view.h)))
        this.exclude.has(t.id) || this.rects.push(qe(t));
    }
    return this.rects;
  }
  show(e) {
    const t = e && (e.lines.length || e.gaps.length) ? e : null;
    (t || this.b.guides.value) && (this.b.guides.value = t);
  }
  end() {
    window.removeEventListener("keydown", this.onKey), window.removeEventListener("keyup", this.onKey), this.b.guides.value = null;
  }
}
function pr(n) {
  let e = null, t = 0;
  return {
    call(i) {
      e = i, t || (t = requestAnimationFrame(() => {
        t = 0, e && n(e);
      }));
    },
    flush() {
      t && cancelAnimationFrame(t), t = 0, e && n(e);
    },
    cancel() {
      t && cancelAnimationFrame(t), t = 0;
    }
  };
}
class y6e {
  constructor(e) {
    xi(this, "b", e), xi(this, "spaceDown", !1), xi(this, "stage", null), xi(this, "cleanups", []), xi(this, "hoverRaf", 0), xi(this, "lastPointer", { x: 0, y: 0 }), xi(this, "lastShift", !1);
  }
  attach(e) {
    this.stage = e;
    const t = (d) => this.onWheel(d);
    e.addEventListener("wheel", t, { passive: !1 });
    const i = (d) => this.onHover(d);
    e.addEventListener("pointermove", i);
    const s = () => this.setHover(null);
    e.addEventListener("pointerleave", s);
    const o = (d) => this.onKeyDown(d), r = (d) => this.onKeyUp(d);
    window.addEventListener("keydown", o), window.addEventListener("keyup", r);
    const a = () => {
      this.spaceDown = !1;
    };
    window.addEventListener("blur", a);
    const l = (d) => d.preventDefault();
    e.addEventListener("gesturestart", l), e.addEventListener("gesturechange", l), this.cleanups.push(() => {
      e.removeEventListener("wheel", t), e.removeEventListener("pointermove", i), e.removeEventListener("pointerleave", s), window.removeEventListener("keydown", o), window.removeEventListener("keyup", r), window.removeEventListener("blur", a), e.removeEventListener("gesturestart", l), e.removeEventListener("gesturechange", l);
    });
  }
  detach() {
    for (const e of this.cleanups) e();
    this.cleanups = [], cancelAnimationFrame(this.hoverRaf);
  }
  get spacePan() {
    return this.spaceDown;
  }
  // ------------------------------------------------------------- wheel
  onWheel(e) {
    if (!e.ctrlKey && !vn(e) && this.noteScrolls(e)) return;
    e.preventDefault();
    const t = this.b;
    if (!t.engine) return;
    (t.ui.canvasMenu || t.ui.finder) && (t.ui.canvasMenu = null, t.ui.finder = null);
    const i = e.clientX - t.view.left, s = e.clientY - t.view.top, o = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? t.view.h : 1, r = e.deltaX * o, a = e.deltaY * o;
    if (e.ctrlKey || vn(e)) {
      const l = e.ctrlKey && !e.metaKey && e.deltaMode === 0 && Math.abs(a) < 50;
      t.engine.zoomAt(i, s, Math.exp(l ? -a * 0.012 : -Math.max(-60, Math.min(60, a)) * 4e-3));
      return;
    }
    e.shiftKey && r === 0 ? t.engine.panBy(-a, 0) : t.engine.panBy(-r, -a);
  }
  /** The wheel is over the text of a selected (or open) note that can still scroll its way. */
  noteScrolls(e) {
    const t = e.target instanceof Element ? e.target.closest(".cv-note-text") : null, i = t && t.closest("[data-el]");
    if (!t || !i) return !1;
    const s = i.dataset.el;
    return !this.b.ui.selection.includes(s) && this.b.ui.editingNote !== s ? !1 : e.deltaY > 0 ? t.scrollTop + t.clientHeight < t.scrollHeight - 1 : e.deltaY < 0 ? t.scrollTop > 0 : !1;
  }
  // ------------------------------------------------------------- hover
  onHover(e) {
    this.lastPointer = { x: e.clientX, y: e.clientY }, this.lastShift = e.shiftKey, !(e.buttons || !this.b.engine) && (this.hoverRaf || (this.hoverRaf = requestAnimationFrame(() => {
      this.hoverRaf = 0;
      const t = this.b;
      if (!t.engine || t.ui.marquee || t.ui.dragging) return;
      const i = document.elementFromPoint(this.lastPointer.x, this.lastPointer.y), o = i && !i.classList.contains("bd-canvas") && !i.closest(".cv-img-hover") && i !== this.stage ? null : t.engine.hitTest(this.lastPointer.x - t.view.left, this.lastPointer.y - t.view.top);
      if (this.setHover(o && o.type === "image" ? o.id : null), this.stage) {
        const r = o && !t.isHeld(o) && (o.type === "image" || o.type === "frame" || o.type === "shape"), a = !!o && o.type === "image" && this.lastShift;
        this.stage.style.cursor = t.ui.eyedropper || t.comments.ui.armed ? "" : t.ui.shapeArmed ? "crosshair" : t.ui.mode === "hand" || this.spaceDown ? "" : a ? "copy" : r ? "grab" : "";
      }
    })));
  }
  setHover(e) {
    const t = this.b;
    t.ui.hoverId !== e && (t.ui.hoverId = e, t.engine && t.engine.setHover(e));
  }
  // ------------------------------------------------------------- stage
  /** pointerdown that reached the stage itself (not a DOM element). */
  stageDown(e) {
    const t = this.b;
    if (!t.engine) return;
    const i = e.button === 1 || e.button === 0 && (t.ui.mode === "hand" || this.spaceDown);
    if (t.ui.addMenu = !1, t.ui.shapeMenu = !1, t.ui.canvasMenu = null, t.ui.finder = null, i) {
      e.preventDefault(), this.beginPan(e, { clickClears: e.button === 0 });
      return;
    }
    if (e.button !== 0) return;
    if (t.ui.styleOpen = !1, gh(), t.ui.eyedropper) {
      e.preventDefault();
      const o = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
      o && o.type === "image" ? t.eyedropImage(o) : this.beginPan(e);
      return;
    }
    if (t.ui.shapeArmed) {
      e.preventDefault(), this.beginShape(e);
      return;
    }
    const s = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
    if (s) {
      this.elementDown(s, e);
      return;
    }
    this.beginMarquee(e);
  }
  stageDoubleClick(e) {
    const t = this.b;
    if (!t.engine || t.ui.eyedropper) return;
    const i = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
    i && i.type === "image" ? (t.ui.selection = [i.id], t.ui.infoAt = i.id) : i && i.type === "frame" ? (t.ui.selection = [i.id], t.engine.fitTo(qe(i), { pad: 72, maxZoom: 1, animate: 460 })) : i && i.type === "note" ? t.editNote(i.id) : i && i.type === "tool" ? t.openSession(i) : i && i.type === "chat" ? (t.ui.selection = [i.id], t.ui.chatOpen = i.id) : !i && this.onCanvas(e.target) && t.ui.mode === "select" && !this.spaceDown && !t.ui.shapeArmed && t.openFinder(e.clientX, e.clientY);
  }
  /**
   * Right-click (Ctrl-click on a Mac, a long press on touch) on the empty
   * canvas or inside a frame: the canvas menu, which adds things there.
   * Elsewhere on the board the browser's own menu stays off and none shows.
   */
  stageContextMenu(e) {
    e.preventDefault();
    const t = this.b;
    if (!t.engine || t.ui.eyedropper || t.ui.shapeArmed || t.ui.panning || t.ui.dragging || !this.onCanvas(e.target)) return;
    const i = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
    i && i.type !== "frame" || (gh(), t.openCanvasMenu(e.clientX, e.clientY));
  }
  /** The pointer is on the canvas itself, not on a card, a note or a frame's title drawn over it. */
  onCanvas(e) {
    return e === this.stage || e instanceof HTMLElement && e.classList.contains("bd-canvas");
  }
  /**
   * `clickClears`: a press that never moves is a click, which on the empty
   * canvas lets go of the selection, as it does without the hand (IL-100;
   * Blake: with the hand, a drawn shape's box took a second click, after
   * switching back, to go).
   */
  beginPan(e, t = {}) {
    const i = this.b;
    i.ui.panning = !0;
    const s = { x: e.clientX, y: e.clientY };
    let o = { x: e.clientX, y: e.clientY }, r = !1;
    const a = pr((d) => {
      i.engine && (!r && Math.hypot(d.clientX - s.x, d.clientY - s.y) > mb && (r = !0), i.engine.panBy(d.clientX - o.x, d.clientY - o.y), o = { x: d.clientX, y: d.clientY });
    }), l = (d) => {
      a.flush(), i.ui.panning = !1, t.clickClears && !r && d.type === "pointerup" && i.engine && !i.engine.hitTest(d.clientX - i.view.left, d.clientY - i.view.top) && (i.ui.selection = []), window.removeEventListener("pointermove", a.call), window.removeEventListener("pointerup", l), window.removeEventListener("pointercancel", l);
    };
    window.addEventListener("pointermove", a.call), window.addEventListener("pointerup", l), window.addEventListener("pointercancel", l);
  }
  /**
   * A drag on the empty canvas selects what it touches. Started on a locked
   * frame (IL-070), or on what one holds (B31), which a drag can't move,
   * it's the same drag; a press that never moves is a click on it instead,
   * and selects it (then `onClick`, a session card's Open).
   */
  beginMarquee(e, t = null, i) {
    const s = this.b, o = e.clientX - s.view.left, r = e.clientY - s.view.top, a = e.shiftKey, l = a ? s.ui.selection.slice() : [];
    !a && !t && (s.ui.selection = []), s.ui.editingNote = null, s.ui.editingTitle = null;
    let d = !1;
    const c = pr((p) => {
      const f = p.clientX - s.view.left, y = p.clientY - s.view.top;
      if (!d && Math.hypot(f - o, y - r) < 3) return;
      d = !0, s.ui.marquee = { x0: o, y0: r, x1: f, y1: y };
      const b = s.cam.value, w = (Math.min(o, f) - b.x) / b.zoom, k = (Math.min(r, y) - b.y) / b.zoom, S = (Math.max(o, f) - b.x) / b.zoom, _ = (Math.max(r, y) - b.y) / b.zoom, x = s.store.query({ x: w, y: k, w: S - w, h: _ - k }).filter((M) => M.type !== "frame" || M.x >= w && M.y >= k && M.x + M.w <= S && M.y + M.h <= _).map((M) => M.id), T = a ? Array.from(new Set(l.concat(x))) : x;
      (T.length !== s.ui.selection.length || T.some((M, z) => M !== s.ui.selection[z])) && (s.ui.selection = T);
    }), u = () => {
      if (c.flush(), s.ui.marquee = null, window.removeEventListener("pointermove", c.call), window.removeEventListener("pointerup", u), window.removeEventListener("pointercancel", u), t && !d) {
        const p = t.id;
        s.ui.selection = a ? l.includes(p) ? l.filter((f) => f !== p) : l.concat([p]) : [p], i && !a && i();
      }
    };
    window.addEventListener("pointermove", c.call), window.addEventListener("pointerup", u), window.addEventListener("pointercancel", u);
  }
  // ----------------------------------------------------------- elements
  /** pointerdown on an element (DOM or GPU). Click selects; drag moves. */
  /** `onClick`: a press that never became a drag, after it selects (a session card's Open, IL-100) */
  elementDown(e, t, i = {}) {
    const s = this.b;
    if (t.button === 1 || s.ui.mode === "hand" || this.spaceDown) {
      t.preventDefault(), t.stopPropagation(), this.beginPan(t);
      return;
    }
    if (t.button !== 0) return;
    if (t.stopPropagation(), s.ui.eyedropper) {
      t.preventDefault(), e.type === "image" ? s.eyedropImage(e) : this.beginPan(t);
      return;
    }
    if (s.ui.addMenu = !1, s.ui.editingNote === e.id) return;
    if (gh(), qd(e)) {
      this.beginMarquee(t, e);
      return;
    }
    if (t.shiftKey && e.type === "image") {
      this.beginReferenceDrag(e, t);
      return;
    }
    if (s.isHeld(e)) {
      this.beginMarquee(t, e, i.onClick);
      return;
    }
    const o = s.ui.selection.includes(e.id) ? s.ui.selection.filter((S) => !s.isHeld(s.store.get(S))) : [e.id], r = new Set(o);
    for (const S of o) {
      const _ = s.store.get(S);
      if (_ && _.type === "frame")
        for (const x of s.childrenOf(_)) s.isHeld(s.store.get(x)) || r.add(x);
    }
    const a = /* @__PURE__ */ new Map();
    for (const S of r) {
      const _ = s.store.get(S);
      _ && a.set(S, { x: _.x, y: _.y });
    }
    const l = s.store.bounds(o), d = { x: t.clientX, y: t.clientY };
    let c = !1, u = null;
    const p = e.type === "image" && s.promptTool.value ? this.promptRect() : null;
    let f = !p;
    const y = new gb(s, r, t, () => {
      c && u && b.call(u);
    }), b = pr((S) => {
      const _ = s.cam.value.zoom;
      if (c && !f && p && S.clientX >= p.left && S.clientX <= p.right && S.clientY >= p.top && S.clientY <= p.bottom && (f = !0, s.toast("Hold Shift as you drag to use an image as a reference.")), !c && Math.hypot(S.clientX - d.x, S.clientY - d.y) > mb && (c = !0, s.ui.selection.includes(e.id) || (s.ui.selection = [e.id]), s.ui.dragging = !0, s.ui.styleOpen = !1, s.store.beginGesture(r.size > 1 ? "Move " + r.size + " items" : "Move"), this.setHover(null)), !c) return;
      const x = (S.clientX - d.x) / _, T = (S.clientY - d.y) / _;
      let M = Math.round(x), z = Math.round(T), P = null;
      if (l && !y.free) {
        const $ = y.targets(), O = n4(a4(l, x, T), $, y.tol);
        O.x && (M = so(x + O.dx)), O.y && (z = so(T + O.dy)), (O.x || O.y) && (P = s4(a4(l, M, z), $));
      }
      const D = [];
      for (const [$, O] of a) D.push([$, { x: O.x + M, y: O.y + z }]);
      s.store.updateMany(D), y.show(P);
    }), w = (S) => {
      u = S, y.pointer(S), b.call(S);
    }, k = (S) => {
      if (b.flush(), y.end(), window.removeEventListener("pointermove", w), window.removeEventListener("pointerup", k), window.removeEventListener("pointercancel", k), c) {
        s.store.endGesture(), s.ui.dragging = !1;
        return;
      }
      S.shiftKey ? s.ui.selection = s.ui.selection.includes(e.id) ? s.ui.selection.filter((_) => _ !== e.id) : s.ui.selection.concat([e.id]) : (s.ui.selection = [e.id], i.onClick && i.onClick());
    };
    window.addEventListener("pointermove", w), window.addEventListener("pointerup", k), window.addEventListener("pointercancel", k);
  }
  /**
   * Shift-drag an image (IL-071): a small copy of it follows the pointer, and
   * dropped on a session (its card, its row in the sessions rail, or the open
   * prompt and its image slots) the picture becomes that session's reference
   * and the session opens. The image itself stays where it is. Without a
   * drag it's Shift-click: in or out of the selection.
   */
  beginReferenceDrag(e, t) {
    const i = this.b, s = { x: t.clientX, y: t.clientY };
    let o = !1, r = null;
    const a = pr((d) => {
      if (!o) {
        if (Math.hypot(d.clientX - s.x, d.clientY - s.y) <= mb) return;
        o = !0, i.ui.dragging = !0, this.setHover(null);
      }
      r = this.refDropAt(d.clientX, d.clientY);
      const c = r && r.key ? r.key : !1, u = r && !r.key ? r.sessionId : null;
      i.ui.refTarget !== c && (i.ui.refTarget = c), i.ui.refSession !== u && (i.ui.refSession = u), i.ui.ghost = { x: d.clientX, y: d.clientY, url: e.src, ref: !!r };
    }), l = (d) => {
      if (a.flush(), window.removeEventListener("pointermove", a.call), window.removeEventListener("pointerup", l), window.removeEventListener("pointercancel", l), i.ui.ghost = null, i.ui.refTarget = !1, i.ui.refSession = null, i.ui.dragging = !1, !o) {
        i.ui.selection = i.ui.selection.includes(e.id) ? i.ui.selection.filter((u) => u !== e.id) : i.ui.selection.concat([e.id]);
        return;
      }
      if (d.type === "pointercancel") return;
      const c = r;
      c ? i.referenceImage(e.id, c.sessionId, { key: c.key, reveal: c.reveal }) : i.toast("Drop it on a session, or on the open prompt, to use it as a reference.");
    };
    window.addEventListener("pointermove", a.call), window.addEventListener("pointerup", l), window.addEventListener("pointercancel", l);
  }
  /**
   * What a Shift-dragged image would go to at a client point: an image slot
   * in the open prompt, the open prompt, a session's row in the rail (from
   * elsewhere on the board, so it's brought into view), or a session's card
   * (drawn by the engine when far out).
   */
  refDropAt(e, t) {
    const i = this.b, s = document.elementFromPoint(e, t);
    if (!s) return null;
    const o = i.promptTool.value, r = s.closest("[data-ref-key]");
    if (o && r) return { sessionId: o.id, key: r.getAttribute("data-ref-key") || void 0 };
    if (o && s.closest(".v2-uprompt")) return { sessionId: o.id };
    const a = s.closest("[data-ref-session]");
    if (a) return { sessionId: a.getAttribute("data-ref-session"), reveal: a.hasAttribute("data-ref-reveal") };
    if (this.onCanvas(s) && i.engine) {
      const l = i.engine.hitTest(e - i.view.left, t - i.view.top);
      if (l && l.type === "tool") return { sessionId: l.id };
    }
    return null;
  }
  /** Where the open prompt is on screen, if it is. */
  promptRect() {
    const e = document.querySelector(".v2-uprompt");
    return e ? e.getBoundingClientRect() : null;
  }
  /**
   * The bottom-right handle of a single selection. The edges it moves (the
   * right and the bottom) snap to the edges of what is on screen; a card
   * that keeps its proportions snaps whichever of the two is nearer.
   */
  resizeDown(e, t) {
    const i = this.b;
    if (t.button !== 0 || i.isHeld(e)) return;
    t.stopPropagation(), t.preventDefault(), gh();
    const s = { x: t.clientX, y: t.clientY }, o = qe(e);
    i.store.beginGesture("Resize"), i.ui.dragging = !0;
    let r = null;
    const a = new gb(i, /* @__PURE__ */ new Set([e.id]), t, () => {
      r && l.call(r);
    }), l = pr((u) => {
      const p = i.cam.value.zoom, f = (u.clientX - s.x) / p, y = (u.clientY - s.y) / p, b = a.free ? null : a.targets(), w = (S, _) => m6e({ x: o.x, y: o.y, w: S, h: _ }, b || [], a.tol);
      if (e.type === "tool") {
        let S = (o.w + f) / Tt.w;
        const _ = b ? w(Tt.w * S, Tt.h * S) : null, x = _ && l4(_);
        _ && x === "x" ? S = (Tt.w * S + _.dx) / Tt.w : _ && x === "y" && (S = (Tt.h * S + _.dy) / Tt.h), S = Math.max(0.7, Math.min(2.6, S)), i.store.update(e.id, { scale: x ? Math.round(S * 1e4) / 1e4 : Math.round(S * 100) / 100 });
      } else if (e.type === "image") {
        const S = o.h / o.w, _ = o.w + (u.shiftKey || Math.abs(f) > Math.abs(y / S) ? f : y / S);
        let x = Math.round(_), T = Math.round(x * S);
        const M = b ? w(_, _ * S) : null, z = M && l4(M);
        M && z === "x" ? (x = so(_ + M.dx), T = Math.round(x * S)) : M && z === "y" && (T = so(_ * S + M.dy), x = Math.round(T / S)), x < 120 && (x = 120, T = Math.round(x * S)), i.store.update(e.id, { w: x, h: T });
      } else {
        const S = e.type === "shape" && (e.shape === "line" || e.shape === "arrow"), _ = e.type === "shape" ? S ? 0 : 12 : e.type === "frame" ? 200 : 140, x = e.type === "shape" ? S ? 0 : 12 : e.type === "frame" ? 160 : 120;
        let T = o.w + f, M = o.h + y;
        const z = b ? w(T, M) : null;
        T = z && z.x ? so(T + z.dx) : Math.round(T), M = z && z.y ? so(M + z.dy) : Math.round(M);
        const P = e.type === "note" ? { grow: void 0 } : {};
        i.store.update(e.id, { w: Math.max(_, T), h: Math.max(x, M), ...P });
      }
      const k = i.store.get(e.id);
      a.show(b && k ? g6e(qe(k), b) : null);
    }), d = (u) => {
      r = u, a.pointer(u), l.call(u);
    }, c = () => {
      l.flush(), a.end(), window.removeEventListener("pointermove", d), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", c), i.store.endGesture(), i.ui.dragging = !1;
    };
    window.addEventListener("pointermove", d), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", c);
  }
  // ------------------------------------------------------------- shapes
  /** Drag draws; a plain click drops a readable default. Shift constrains. */
  beginShape(e) {
    const t = this.b, i = t.ui.shapeKind, s = t.screenToWorld(e.clientX, e.clientY), o = kt();
    t.ui.shapeArmed = !1, t.store.beginGesture("Draw " + i);
    const r = {
      id: o,
      type: "shape",
      shape: i,
      x: Math.round(s.x),
      y: Math.round(s.y),
      w: 0,
      h: 0,
      z: 0,
      sc: [0, 0],
      stroke: t.ui.shapeStyle.stroke,
      sw: t.ui.shapeStyle.sw,
      createdBy: t.user.uid
    };
    r.z = t.store.nextZ(r), t.store.add([r]), t.ui.selection = [o], t.ui.dragging = !0;
    let a = !1;
    const l = pr((c) => {
      const u = t.screenToWorld(c.clientX, c.clientY);
      let p = u.x - s.x, f = u.y - s.y;
      if (c.shiftKey)
        if (i === "rect" || i === "ellipse") {
          const y = Math.max(Math.abs(p), Math.abs(f));
          p = (p < 0 ? -1 : 1) * y, f = (f < 0 ? -1 : 1) * y;
        } else {
          const y = Math.round(Math.atan2(f, p) / (Math.PI / 4)) * (Math.PI / 4), b = Math.hypot(p, f);
          p = Math.cos(y) * b, f = Math.sin(y) * b;
        }
      (Math.abs(p) * t.cam.value.zoom > 4 || Math.abs(f) * t.cam.value.zoom > 4) && (a = !0), t.store.update(o, {
        x: Math.round(Math.min(s.x, s.x + p)),
        y: Math.round(Math.min(s.y, s.y + f)),
        w: Math.round(Math.abs(p)),
        h: Math.round(Math.abs(f)),
        sc: [p < 0 ? 1 : 0, f < 0 ? 1 : 0]
      });
    }), d = () => {
      if (l.flush(), window.removeEventListener("pointermove", l.call), window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", d), !a) {
        const c = i === "line" || i === "arrow";
        t.store.update(o, c ? { x: Math.round(s.x - 130), y: Math.round(s.y), w: 260, h: 0, sc: [0, 0] } : { x: Math.round(s.x - 130), y: Math.round(s.y - 85), w: 260, h: 170 });
      }
      t.store.endGesture(), t.ui.dragging = !1, t.ui.styleOpen = !0;
    };
    window.addEventListener("pointermove", l.call), window.addEventListener("pointerup", d), window.addEventListener("pointercancel", d);
  }
  // ------------------------------------------------------- drag-outs
  /**
   * Pull a result out of a tool card or the gallery. Over the canvas it
   * becomes a card that follows the pointer; over the prompt's reference
   * slot it becomes the reference. A short drag is a click.
   */
  dragResultOut(e, t, i = {}) {
    const s = this.b;
    if (t.button !== 0) return;
    t.preventDefault(), t.stopPropagation();
    const o = { x: t.clientX, y: t.clientY }, r = i.slop || 6;
    let a = !1, l = null;
    const d = e.w || 300, c = e.h || 200, u = (x) => {
      const T = document.elementFromPoint(x.clientX, x.clientY), M = T ? T.closest("[data-ref-key]") : null;
      return M && M.getAttribute("data-ref-key") || !1;
    }, p = (x) => {
      const T = document.elementFromPoint(x.clientX, x.clientY);
      return !T || T.closest(".v2-hist, .v2-uprompt, .rs, .cv-topbar, .v2-railwrap, .cv-corner, .cv-addmenu, .v2-info") ? !1 : !!T.closest(".cv-stage");
    }, f = /* @__PURE__ */ new Set();
    let y = null;
    const b = new gb(s, f, t, () => {
      l && y && k.call(y);
    }), w = (x) => {
      const T = { x: x.x - d / 2, y: x.y - c / 2, w: d, h: c };
      let M = Math.round(T.x), z = Math.round(T.y), P = null;
      if (!b.free) {
        const D = b.targets(), $ = n4(T, D, b.tol);
        $.x && (M = so(T.x + $.dx)), $.y && (z = so(T.y + $.dy)), ($.x || $.y) && (P = s4({ x: M, y: z, w: d, h: c }, D));
      }
      return { x: M, y: z, guides: P };
    }, k = pr((x) => {
      if (!a && Math.hypot(x.clientX - o.x, x.clientY - o.y) > r && (a = !0, s.ui.dragging = !0), !!a)
        if (p(x)) {
          const T = s.screenToWorld(x.clientX, x.clientY);
          if (l) {
            const M = w(T);
            s.store.update(l, { x: M.x, y: M.y }), b.show(M.guides);
          } else {
            s.store.beginGesture("Place result");
            const M = e.result || null, z = {
              id: kt(),
              type: "image",
              x: 0,
              y: 0,
              w: d,
              h: c,
              z: 0,
              src: e.url,
              label: e.label || M && M.label || "result",
              resultId: M ? M.id : void 0,
              sessionId: e.sessionId || M && M.sessionId || void 0,
              video: M ? M.video : void 0,
              dur: M ? M.dur : void 0,
              videoSrc: M ? M.videoSrc : void 0,
              previewSrc: M ? M.previewSrc : void 0,
              asset: M ? M.asset : void 0,
              download: M ? M.download : void 0,
              kind: M ? M.kind : void 0,
              createdBy: s.user.uid
            };
            f.add(z.id);
            const P = w(T);
            z.x = P.x, z.y = P.y, z.z = s.store.nextZ(z), l = z.id, s.ui.ghost = null, s.ui.refTarget = !1, s.store.add([z]), i.keepSelection || (s.ui.selection = [z.id]), b.show(P.guides);
          }
        } else {
          l && (s.store.cancelGesture(), l = null), b.show(null);
          const T = u(x);
          s.ui.refTarget = T, s.ui.ghost = { x: x.clientX, y: x.clientY, url: e.url, ref: !!T };
        }
    }), S = (x) => {
      y = x, b.pointer(x), k.call(x);
    }, _ = (x) => {
      k.flush(), b.end(), window.removeEventListener("pointermove", S), window.removeEventListener("pointerup", _), window.removeEventListener("pointercancel", _);
      const T = a && !l && u(x);
      if (s.ui.ghost = null, s.ui.refTarget = !1, s.ui.dragging = !1, l && s.store.endGesture(), i.keepSelection && (s.ui.selection = [i.keepSelection]), T) {
        const M = s.promptTool.value;
        M && s.setRefInput(M.id, T, e.url, e.result && e.result.asset || s.assetFor(e.url));
        return;
      }
      !a && i.onClick && i.onClick();
    };
    window.addEventListener("pointermove", S), window.addEventListener("pointerup", _), window.addEventListener("pointercancel", _);
  }
  // ----------------------------------------------------------- keyboard
  onKeyUp(e) {
    e.code === "Space" && (this.spaceDown = !1, this.stage && this.stage.classList.remove("is-hand"));
  }
  onKeyDown(e) {
    const t = this.b, i = t.feedback;
    if (i && i.state.mode === "open") return;
    const s = x0(e.target), o = vn(e);
    if (i && !s && e.code === "Backquote" && !o && !e.shiftKey && !e.altKey) {
      e.preventDefault(), i.start("key");
      return;
    }
    if (t.ui.studio || t.ui.libraryOpen) return;
    if (e.key === "Escape") {
      if (i && i.state.mode === "aside") {
        e.preventDefault(), i.resume();
        return;
      }
      this.escape(e, s);
      return;
    }
    if (s || t.ui.trashOpen) return;
    if (e.key === "?" && !o) {
      e.preventDefault(), t.ui.boardMenu = !1, t.ui.keysOpen = !t.ui.keysOpen;
      return;
    }
    if (t.ui.keysOpen || t.ui.infoAt || t.ui.library.open && !o) return;
    if (e.code === "Space") {
      !this.spaceDown && this.stage && this.stage.classList.add("is-hand"), this.spaceDown = !0, e.preventDefault();
      return;
    }
    const r = e.key.toLowerCase();
    if (o) {
      r === "z" ? (e.preventDefault(), e.shiftKey ? t.redo() : t.undo()) : r === "y" ? (e.preventDefault(), t.redo()) : r === "d" ? (e.preventDefault(), t.duplicateIds(t.ui.selection.slice())) : r === "l" && e.shiftKey ? t.ui.selection.some((l) => {
        var d;
        return ((d = t.store.get(l)) == null ? void 0 : d.type) === "frame";
      }) && (e.preventDefault(), t.toggleLock()) : r === "a" ? (e.preventDefault(), t.selectAll()) : r === "c" ? t.ui.selection.length && (e.preventDefault(), t.copy(!1)) : r === "x" ? t.ui.selection.length && (e.preventDefault(), t.copy(!0)) : r === "0" ? (e.preventDefault(), t.zoomTo(1)) : r === "=" || r === "+" ? (e.preventDefault(), t.zoomBy(1.25)) : r === "-" && (e.preventDefault(), t.zoomBy(1 / 1.25));
      return;
    }
    if (e.altKey || rL(e)) return;
    const a = (l) => {
      e.preventDefault(), l();
    };
    switch (r) {
      case "v":
        a(() => t.setMode("select"));
        break;
      case "h":
        a(() => t.setMode("hand"));
        break;
      case "i": {
        const l = t.promptTool.value;
        l && a(() => t.toggleEyedropper(l.id));
        break;
      }
      case "c":
        if (!t.comments.enabled) break;
        e.shiftKey ? a(() => {
          const l = !t.comments.ui.showPins;
          t.comments.ui.showPins = l, t.toast(l ? "Comments shown on the board" : "Comments hidden. Shift+C shows them again");
        }) : a(() => t.comments.arm());
        break;
      case "m":
        a(() => t.armShape("rect"));
        break;
      case "l":
        a(() => t.armShape("ellipse"));
        break;
      case "n":
        a(() => t.addElement("note"));
        break;
      case "f":
        a(() => t.addElement("frame"));
        break;
      case "=":
      case "+":
        a(() => t.zoomBy(1.2));
        break;
      case "-":
      case "_":
        a(() => t.zoomBy(1 / 1.2));
        break;
      case "1":
      case "!":
        a(() => t.fit());
        break;
      case "0":
      case ")":
        a(() => t.zoomTo(1));
        break;
      case "delete":
      case "backspace":
        t.ui.selection.length && (e.preventDefault(), t.deleteIds(t.ui.selection.slice()));
        break;
      case "arrowleft":
      case "arrowright":
      case "arrowup":
      case "arrowdown": {
        if (!t.ui.selection.length) return;
        e.preventDefault();
        const l = e.shiftKey ? 10 : 1;
        t.nudge(r === "arrowleft" ? -l : r === "arrowright" ? l : 0, r === "arrowup" ? -l : r === "arrowdown" ? l : 0);
        break;
      }
      case "enter": {
        const l = t.ui.selection.length === 1 ? t.store.get(t.ui.selection[0]) : null;
        l && l.type === "note" ? (e.preventDefault(), t.editNote(l.id)) : l && l.type === "chat" ? (e.preventDefault(), t.ui.chatOpen = l.id) : l && l.type === "image" && (e.preventDefault(), t.ui.infoAt = l.id);
        break;
      }
      default:
        (e.code === "Backslash" || e.key === "\\" || e.key === "|") && a(() => t.armShape(e.shiftKey || e.key === "|" ? "arrow" : "line"));
    }
  }
  /** Esc closes the top layer only: menus, popovers, modal, then selection. */
  escape(e, t) {
    const i = this.b, s = i.ui;
    if (t) {
      document.activeElement.blur(), s.editingNote && (s.editingNote = null), s.editingTitle && (s.editingTitle = null);
      return;
    }
    const o = i.comments;
    s.boardMenu ? s.boardMenu = !1 : s.ctxMenu ? s.ctxMenu = !1 : s.canvasMenu ? s.canvasMenu = null : s.finder ? s.finder = null : s.trashOpen ? s.trashOpen = !1 : s.keysOpen ? s.keysOpen = !1 : s.addMenu ? s.addMenu = !1 : s.placeMenu ? s.placeMenu = !1 : s.shapeMenu ? s.shapeMenu = !1 : s.shapeArmed ? s.shapeArmed = !1 : o.ui.draft ? o.cancelDraft() : o.ui.editingId ? o.ui.editingId = null : o.ui.openId ? o.close() : o.ui.armed ? o.ui.armed = !1 : s.eyedropper ? s.eyedropper = null : s.styleOpen ? s.styleOpen = !1 : s.infoAt && s.infoSave ? s.infoSave = !1 : s.infoAt ? s.infoAt = null : s.library.open ? i.promptLibrary.back() : s.boardHistory ? s.boardHistory = !1 : o.ui.panelOpen ? o.ui.panelOpen = !1 : s.chatOpen ? s.chatOpen = null : s.advOpen ? s.advOpen = !1 : s.selection.length ? s.selection = [] : s.mode === "hand" && (s.mode = "select"), e.preventDefault();
  }
  /** Paste from the system clipboard: board elements, or image files. */
  onPaste(e, t) {
    if (x0(e.target)) return;
    const i = this.b;
    if (i.ui.trashOpen || i.ui.studio || i.ui.libraryOpen) return;
    const s = e.clipboardData;
    if (!s) return;
    const o = Array.from(s.files || []).filter((a) => a.type.startsWith("image/"));
    if (o.length) {
      e.preventDefault(), t(o, i.viewportCentre());
      return;
    }
    const r = s.getData("text/plain");
    if (r && r.startsWith('{"rdBoard"'))
      try {
        const a = JSON.parse(r);
        if (a && Array.isArray(a.els)) {
          e.preventDefault(), i.paste(a.els, typeof a.board == "string" ? a.board : null);
          return;
        }
      } catch {
      }
    e.preventDefault(), i.paste();
  }
  /**
   * Leaving a note: its text stays, and so does the note when it has none
   * (Tyler, 2026-10-27: a note placed and left blank stays put, as Miro's
   * do; Delete removes it).
   */
  commitNote(e, t) {
    const i = this.b, s = i.store.get(e);
    i.ui.editingNote = null, s && s.text !== t && i.store.update(e, { text: t }, { history: !1 });
  }
}
const x6e = {
  key: 0,
  class: "bd-empty",
  "data-testid": "empty-board"
}, w6e = { class: "bd-empty-mark" }, k6e = { class: "bd-empty-actions" }, _6e = {
  key: 0,
  class: "cm-cards"
}, S6e = {
  key: 2,
  class: "pl-float"
}, T6e = {
  key: 19,
  class: "bd-drop"
}, M6e = { class: "bd-drop-card" }, C6e = { class: "bd-toast-text" }, I6e = /* @__PURE__ */ Re({
  __name: "BoardView",
  props: {
    board: {},
    onHome: { type: Function },
    onIndex: { type: Function }
  },
  setup(n) {
    const e = n, t = jP(), i = e.board, s = new y6e(i);
    gO({ board: i, input: s });
    const o = fs(i), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ We(!1), { active: u, over: p, leave: f, stop: y } = Oy(), b = i.ui, w = i.comments, k = i.promptTool, S = I(() => (i.results.rev.value, k.value ? i.results.list(k.value.id) : [])), _ = I(() => !!o.open.value), x = I(() => !!k.value && S.value.length > 0 && b.histOpen && !b.boardHistory && !w.ui.panelOpen && !_.value), T = I(() => b.boardHistory || w.ui.panelOpen), M = I(() => ({
      "hist-rail": x.value,
      "board-hist": T.value,
      "chat-open": _.value,
      "light-canvas": b.lightCanvas,
      "is-studio": !!b.studio
    })), z = I(() => i.overlayIds.value.length > 120), P = i.feedback, D = I(() => !!P && P.state.mode === "open");
    function $(q) {
      const B = q.target;
      P && B instanceof Element && B.closest("[data-feedback-bar]") && q.stopImmediatePropagation();
    }
    window.addEventListener("pointerdown", $, !0), Ve(() => window.removeEventListener("pointerdown", $, !0)), $e(() => !!b.studio, (q) => {
      i.engine && i.engine.setPaused(q);
    });
    const O = I(() => (i.docRev.value, i.store.size === 0));
    ot(async () => {
      await it(), !(!r.value || !a.value || !l.value) && (s.attach(r.value), await i.attach(a.value, l.value), c.value = !0, window.addEventListener("paste", J));
    }), Ve(() => {
      dU(i), s.detach(), window.removeEventListener("paste", J);
    });
    function L(q) {
      const B = q.currentTarget;
      (B.scrollTop || B.scrollLeft) && (B.scrollTop = 0, B.scrollLeft = 0);
    }
    function Z(q) {
      s.stageDown(q);
    }
    function J(q) {
      D.value || s.onPaste(q, (B, ne) => N(B, ne));
    }
    let re;
    function F(q) {
      re = q, d.value && d.value.click();
    }
    async function W(q) {
      const B = Array.from(q.target.files || []);
      q.target.value = "";
      const ne = re;
      re = void 0, B.length && await N(B, ne);
    }
    function ee(q) {
      return new Promise((B) => {
        const ne = new Image();
        ne.onload = () => B({ w: ne.naturalWidth || 4, h: ne.naturalHeight || 3 }), ne.onerror = () => B({ w: 4, h: 3 }), ne.src = q;
      });
    }
    async function N(q, B) {
      const ne = q.filter((ie) => ie.type.startsWith("image/")).slice(0, 24);
      if (!ne.length) return;
      const se = i.uploader;
      i.toast(ne.length === 1 ? "Placing image…" : "Placing " + ne.length + " images…");
      const Y = [];
      for (const ie of ne) {
        const De = URL.createObjectURL(ie), xe = await ee(De);
        let Oe = De, Ee;
        if (se)
          try {
            const Q = await i.uploadFile(ie);
            Oe = Q.url, Ee = Q.asset || void 0, URL.revokeObjectURL(De);
          } catch (Q) {
            console.error("[board] upload failed", Q);
            const oe = Q ? Q.userMessage : void 0;
            i.toast(oe || ie.name + " could not be uploaded.", "error"), URL.revokeObjectURL(De);
            continue;
          }
        const V = 360 / Math.max(xe.w, xe.h);
        Y.push({ url: Oe, w: Math.round(xe.w * V), h: Math.round(xe.h * V), label: ie.name.replace(/\.[a-z0-9]+$/i, "").slice(0, 40), asset: Ee });
      }
      Y.length && i.placeImages(Y, B);
    }
    function te(q) {
      D.value || !p(q) || q.preventDefault();
    }
    function G(q) {
      if (y(), D.value || !q.dataTransfer) return;
      const B = Array.from(q.dataTransfer.files || []);
      B.length && (q.preventDefault(), N(B, i.screenToWorld(q.clientX, q.clientY)));
    }
    return (q, B) => (g(), v("div", {
      class: U(["cv-root v2-root p1-root bd-root", M.value]),
      style: de(m(b).promptCardH ? { "--up-card-h": m(b).promptCardH + "px" } : void 0),
      "data-screen-label": "Phase 1 - Boards V2",
      onDragover: te,
      onDragleave: B[10] || (B[10] = //@ts-ignore
      (...ne) => m(f) && m(f)(...ne)),
      onDrop: G
    }, [
      C(vO),
      h("div", {
        ref_key: "stage",
        ref: r,
        class: U(["cv-stage v2-stage", { "is-hand": m(b).mode === "hand", "is-panning": m(b).panning, "is-draw": m(b).shapeArmed, "is-dropper": !!m(b).eyedropper }]),
        "data-testid": "stage",
        onPointerdown: Z,
        onDblclick: B[0] || (B[0] = (ne) => m(s).stageDoubleClick(ne)),
        onContextmenu: B[1] || (B[1] = (ne) => m(s).stageContextMenu(ne)),
        onScroll: L
      }, [
        h("div", {
          ref_key: "canvasHost",
          ref: a,
          class: "bd-canvas-host"
        }, null, 512),
        h("div", {
          ref_key: "world",
          ref: l,
          class: U(["cv-world", { "is-moving": m(i).moving.value, "is-crowded": z.value, "is-far": m(i).far.value }])
        }, [
          c.value ? (g(), Ce(_ie, { key: 0 })) : E("", !0),
          c.value && m(w).enabled ? (g(), Ce(S2e, { key: 1 })) : E("", !0)
        ], 2),
        m(b).marquee ? (g(), v("div", {
          key: 0,
          class: "cv-marquee",
          style: de({
            left: Math.min(m(b).marquee.x0, m(b).marquee.x1) + "px",
            top: Math.min(m(b).marquee.y0, m(b).marquee.y1) + "px",
            width: Math.abs(m(b).marquee.x1 - m(b).marquee.x0) + "px",
            height: Math.abs(m(b).marquee.y1 - m(b).marquee.y0) + "px"
          })
        }, null, 4)) : E("", !0),
        C(Aie)
      ], 34),
      C(vt, { name: "bd-empty" }, {
        default: et(() => [
          c.value && O.value && !m(b).addMenu && !m(b).finder && !m(b).shapeArmed ? (g(), v("div", x6e, [
            h("div", {
              class: "bd-empty-card",
              onPointerdown: B[5] || (B[5] = Pe(() => {
              }, ["stop"]))
            }, [
              h("span", w6e, [
                C(R, {
                  name: "Sparkles",
                  size: 18
                })
              ]),
              B[14] || (B[14] = h("b", null, "A blank board", -1)),
              B[15] || (B[15] = h("span", { class: "bd-empty-sub" }, "Start an image session, drop images anywhere, or jot a note.", -1)),
              h("div", k6e, [
                h("button", {
                  class: "bd-btn",
                  onClick: B[2] || (B[2] = (ne) => m(i).addElement("image-gen"))
                }, [
                  C(R, {
                    name: "ImagePlus",
                    size: 14
                  }),
                  B[11] || (B[11] = X(" Image Gen", -1))
                ]),
                h("button", {
                  class: "bd-btn is-ghost",
                  onClick: B[3] || (B[3] = (ne) => F())
                }, [
                  C(R, {
                    name: "Upload",
                    size: 14
                  }),
                  B[12] || (B[12] = X(" Add images", -1))
                ]),
                m(i).hasLibrary ? (g(), v("button", {
                  key: 0,
                  class: "bd-btn is-ghost",
                  "data-testid": "empty-library",
                  onClick: B[4] || (B[4] = (ne) => m(i).openLibrary())
                }, [
                  C(R, {
                    name: "Library",
                    size: 14
                  }),
                  B[13] || (B[13] = X(" From your Library", -1))
                ])) : E("", !0)
              ]),
              B[16] || (B[16] = h("div", { class: "bd-empty-keys" }, [
                h("kbd", null, "N"),
                X(" note "),
                h("kbd", null, "F"),
                X(" frame "),
                h("kbd", null, "M"),
                X(" shape "),
                h("kbd", null, "V"),
                X(" select")
              ], -1))
            ], 32)
          ])) : E("", !0)
        ]),
        _: 1
      }),
      c.value && m(w).enabled ? (g(), v("div", _6e, [
        (g(!0), v(H, null, me(m(w).openCards.value, (ne) => (g(), Ce(J_, {
          id: ne.id,
          key: ne.id
        }, null, 8, ["id"]))), 128)),
        m(w).ui.draft ? (g(), Ce(J_, {
          id: null,
          key: "draft",
          draft: ""
        })) : E("", !0)
      ])) : E("", !0),
      C(sL, {
        "on-home": e.onHome,
        "on-index": e.onIndex
      }, null, 8, ["on-home", "on-index"]),
      C(zie),
      C(jL, {
        away: !!m(k),
        "on-image": () => F()
      }, null, 8, ["away", "on-image"]),
      C(pB),
      m(k) ? (g(), Ce(zle, {
        key: m(k).id,
        tool: m(k)
      }, null, 8, ["tool"])) : E("", !0),
      m(b).library.open && !m(b).library.sessionId ? (g(), v("div", S6e, [
        C(vC, { floating: "" })
      ])) : E("", !0),
      m(b).addMenu ? (g(), Ce(IB, { key: 3 })) : E("", !0),
      m(b).canvasMenu ? (g(), Ce(jB, {
        key: "cm" + m(b).canvasMenu.x + "," + m(b).canvasMenu.y,
        menu: m(b).canvasMenu,
        "on-image": F
      }, null, 8, ["menu"])) : E("", !0),
      m(b).finder ? (g(), Ce(gF, {
        key: "sf" + m(b).finder.x + "," + m(b).finder.y,
        menu: m(b).finder
      }, null, 8, ["menu"])) : E("", !0),
      h("div", {
        class: U(["cv-corner", { "is-away": x.value || T.value || _.value }])
      }, [
        m(b).miniOpen ? (g(), Ce(SF, { key: 0 })) : E("", !0),
        C(CF)
      ], 2),
      C(gG),
      m(b).boardHistory ? (g(), Ce(Mj, { key: 6 })) : E("", !0),
      m(w).enabled && m(w).ui.panelOpen && !m(b).boardHistory ? (g(), Ce(d5e, { key: 7 })) : E("", !0),
      _.value && !m(b).boardHistory ? (g(), Ce(c6e, { key: 8 })) : E("", !0),
      x.value && m(k) ? (g(), Ce(nG, {
        key: "h" + m(k).id,
        tool: m(k)
      }, null, 8, ["tool"])) : E("", !0),
      m(k) && S.value.length && !m(b).histOpen && !T.value && !_.value ? (g(), v("button", {
        key: 10,
        class: "v2-hist-open",
        title: "Show the gallery",
        onPointerdown: B[6] || (B[6] = Pe(() => {
        }, ["stop"])),
        onClick: B[7] || (B[7] = (ne) => m(b).histOpen = !0)
      }, [
        C(R, {
          name: "PanelRightOpen",
          size: 14
        }),
        h("span", null, A(S.value.length), 1)
      ], 32)) : E("", !0),
      C(TU),
      C(OU),
      m(b).studio ? (g(), Ce(J0e, {
        key: m(b).studio.sessionId
      })) : E("", !0),
      m(b).infoAt ? (g(), Ce(kV, { key: 12 })) : E("", !0),
      m(b).keysOpen ? (g(), Ce(RV, { key: 13 })) : E("", !0),
      m(b).trashOpen ? (g(), Ce(mne, { key: 14 })) : E("", !0),
      m(b).libraryOpen ? (g(), Ce(Pxe, {
        key: m(b).libraryOpen.n
      })) : E("", !0),
      C(vt, { name: "fb-aside" }, {
        default: et(() => [
          m(P) && m(P).state.mode === "aside" ? (g(), Ce(u2e, {
            key: 0,
            feedback: m(P)
          }, null, 8, ["feedback"])) : E("", !0)
        ]),
        _: 1
      }),
      m(P) && m(P).state.mode === "open" ? (g(), Ce(o2e, {
        key: 16,
        feedback: m(P)
      }, null, 8, ["feedback"])) : E("", !0),
      m(P) && m(P).state.flash ? (g(), v("div", {
        key: "fb-flash" + m(P).state.flash,
        class: "fb-flash",
        "data-feedback-skip": ""
      })) : E("", !0),
      m(b).ghost ? (g(), v("div", {
        key: 18,
        class: U(["tl-ghost", { "is-ref": m(b).ghost.ref }]),
        style: de({ left: m(b).ghost.x + "px", top: m(b).ghost.y + "px", backgroundImage: 'url("' + m(b).ghost.url + '")' })
      }, null, 6)) : E("", !0),
      m(u) ? (g(), v("div", T6e, [
        h("div", M6e, [
          C(R, {
            name: "ImagePlus",
            size: 20
          }),
          B[17] || (B[17] = X(" Drop images to place them on the board", -1))
        ])
      ])) : E("", !0),
      C(vt, { name: "bd-toast" }, {
        default: et(() => [
          m(b).toast ? (g(), v("div", {
            key: m(b).toast.id,
            class: U(["bd-toast", { "is-error": m(b).toast.tone === "error", "has-action": !!m(b).toast.action, "is-long": m(b).toast.text.length > 70 }]),
            role: "status",
            "data-testid": "toast"
          }, [
            C(R, {
              name: m(b).toast.tone === "error" ? "AlertCircle" : "Check",
              size: 13
            }, null, 8, ["name"]),
            h("span", C6e, A(m(b).toast.text), 1),
            m(b).toast.action ? (g(), v("button", {
              key: 0,
              class: "bd-toast-act",
              "data-testid": "toast-action",
              onPointerdown: B[8] || (B[8] = Pe(() => {
              }, ["stop"])),
              onClick: B[9] || (B[9] = (ne) => m(b).toast.action.run())
            }, A(m(b).toast.action.label), 33)) : E("", !0)
          ], 2)) : E("", !0)
        ]),
        _: 1
      }),
      Ws(q.$slots, "hud"),
      m(b).showStats && !m(t).hud ? (g(), Ce(vne, { key: 20 })) : E("", !0),
      h("input", {
        ref_key: "fileEl",
        ref: d,
        type: "file",
        accept: "image/*",
        multiple: "",
        style: { display: "none" },
        onChange: W
      }, null, 544),
      B[18] || (B[18] = h("div", { class: "cm-portal" }, null, -1))
    ], 38));
  }
}), Ll = "1 33 239 173", ea = [
  {
    d: "M160.973 91.1044H105.586C103.271 91.1044 101.134 89.8671 99.9766 87.8597L74.5215 43.7307C72.0284 39.4055 75.1448 33.9999 80.1311 33.9999H135.518C137.833 33.9999 139.97 35.2372 141.128 37.2447L166.579 81.3772C169.072 85.7024 165.956 91.108 160.97 91.108L160.973 91.1044Z",
    fill: "#CC5FD1",
    origin: "50% 17.1%",
    axis: [0.87, 0.49],
    out: [0, -1]
  },
  {
    d: "M150.485 148.213H205.872C208.187 148.213 210.324 146.975 211.481 144.968L236.933 100.835C239.426 96.5102 236.31 91.1046 231.323 91.1046H175.936C173.621 91.1046 171.484 92.3419 170.327 94.3494L144.875 138.482C142.382 142.807 145.498 148.213 150.485 148.213Z",
    fill: "#9A6ADF",
    origin: "79.5% 50.1%",
    axis: [0.87, -0.49],
    out: [1, 0]
  },
  {
    d: "M160.974 205.317H105.587C103.271 205.317 101.134 204.079 99.9769 202.072L74.5254 157.939C72.0323 153.614 75.1487 148.209 80.135 148.209H135.522C137.837 148.209 139.974 149.446 141.132 151.453L166.583 195.586C169.076 199.911 165.96 205.317 160.974 205.317Z",
    fill: "#B0B3F6",
    origin: "50% 83.1%",
    axis: [0.87, 0.49],
    out: [0, 1]
  },
  {
    d: "M40.7394 200.572L67.1953 151.857C68.2994 149.821 68.2389 147.35 67.0279 145.371L40.4581 101.905C37.8545 97.6479 31.6216 97.8048 29.2389 102.194L2.78656 150.909C1.68245 152.945 1.74299 155.416 2.95395 157.395L29.5238 200.86C32.1274 205.118 38.3603 204.961 40.743 200.572H40.7394Z",
    fill: "#A691DF",
    origin: "14.2% 68%",
    axis: [0, 1],
    out: [-0.94, 0.34]
  }
], qI = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='${Ll}'>${ea.map((n) => `<path d='${n.d}'/>`).join("")}</svg>`
)}")`;
function A6e(n, e) {
  return {
    "--i": String(e),
    "--ox": n.origin.split(" ")[0],
    "--oy": n.origin.split(" ")[1],
    "--ax": String(n.axis[0]),
    "--ay": String(n.axis[1]),
    "--dx": String(n.out[0]),
    "--dy": String(n.out[1])
  };
}
const P6e = 800;
function E6e() {
  var n;
  const e = performance.now(), t = (n = window.__rdMarkLoaderClock) != null ? n : window.__rdMarkLoaderClock = { epoch: e, live: 0, lastSeen: -1 / 0 };
  return t.live === 0 && e - t.lastSeen > P6e && (t.epoch = e), t.live++, Math.round(e - t.epoch);
}
function R6e() {
  const n = window.__rdMarkLoaderClock;
  n && (n.live = Math.max(0, n.live - 1), n.lastSeen = performance.now());
}
const z6e = { class: "bd-ml-mark" }, $6e = ["viewBox"], D6e = ["d", "fill"], KI = /* @__PURE__ */ Re({
  __name: "MarkLoader",
  props: {
    size: { default: 72 }
  },
  setup(n) {
    const e = n, t = E6e();
    return Ve(R6e), (i, s) => (g(), v("div", {
      class: "bd-mark-loader",
      role: "status",
      "aria-label": "Loading",
      style: de({ "--ml-size": `${e.size}px`, "--ml-offset": `${m(t)}ms`, "--ml-mask": m(qI) })
    }, [
      s[1] || (s[1] = h("div", { class: "bd-ml-glow" }, null, -1)),
      h("div", z6e, [
        (g(!0), v(H, null, me(m(ea), (o, r) => (g(), v("svg", {
          key: r,
          class: "bd-ml-facet",
          viewBox: m(Ll),
          style: de(m(A6e)(o, r)),
          "aria-hidden": "true",
          focusable: "false"
        }, [
          h("path", {
            d: o.d,
            fill: o.fill
          }, null, 8, D6e)
        ], 12, $6e))), 128)),
        s[0] || (s[0] = h("div", { class: "bd-ml-sheen" }, null, -1))
      ])
    ], 4));
  }
}), Ld = [
  { id: "pan", label: "Pan, whole board", hint: "All of it in view", about: "A trackpad pan at the overview, with every object on screen" },
  { id: "zoom", label: "Pinch zoom", hint: "In close and back", about: "Pinch from the overview about 45 times closer and back out, through every level of detail" },
  { id: "pan-near", label: "Pan at 60%", hint: "Images stream in", about: "A steady trackpad pan across copies at 60%, loading images as they come into view" },
  { id: "fly", label: "Fly-through", hint: "Dives and glides", about: "Camera glides: dives into a copy, a long glide across, pull-backs to the overview; reports how long the images take to sharpen after landing" }
];
class Uy extends Error {
  constructor() {
    super("Benchmark stopped");
  }
}
const bb = 4e3;
function bh(n, e) {
  const t = n.slice().sort((r, a) => r - a), i = (r) => t.length ? t[Math.min(t.length - 1, Math.floor(r * t.length))] : 0, s = i(0.95), o = n.filter((r) => r > e * 3).length;
  return {
    p50: i(0.5),
    p95: s,
    max: t.length ? t[t.length - 1] : 0,
    slow: o,
    n: n.length,
    vsync: e,
    pass: t.length > 0 && s <= e * 1.5 + 1 && o === 0
  };
}
function YI(n = 30) {
  return new Promise((e) => {
    const t = [];
    let i = 0;
    const s = (o) => {
      if (i && t.push(o - i), i = o, t.length < n) {
        requestAnimationFrame(s);
        return;
      }
      t.sort((r, a) => r - a), e(t[Math.floor(t.length / 2)]);
    };
    requestAnimationFrame(s);
  });
}
const w0 = (n) => new Promise((e) => setTimeout(e, n));
function lp(n) {
  if (n.cancelled && n.cancelled()) throw new Uy();
}
function O6e(n) {
  const e = n.worldEl && n.worldEl.closest('[data-testid="stage"]');
  if (!e) throw new Error("The board is not on screen");
  return e;
}
async function XI(n, e = 6e3, t) {
  const i = performance.now();
  for (await w0(300); performance.now() - i < e && (t && lp(t), !(!n.engine || n.engine.textureStats().pending === 0)); )
    await w0(50);
  return performance.now() - i;
}
function vh(n) {
  const e = n.store.bounds() || { x: 0, y: 0, w: n.view.w, h: n.view.h };
  return zf(e, n.view.w, n.view.h, 120, 1);
}
function yh(n, e) {
  let t = null;
  for (const s of n.store.all()) {
    if (s.type !== "frame") continue;
    const o = qe(s);
    o.x < e.x || o.y < e.y || o.x + o.w > e.x + e.w || o.y + o.h > e.y + e.h || (!t || o.w * o.h > t.w * t.h) && (t = o);
  }
  const i = t || e;
  return { x: i.x + i.w / 2, y: i.y + i.h / 2 };
}
function vb(n, e, t) {
  return new Promise((i, s) => {
    const o = [];
    let r = 0, a = 0;
    const l = (d) => {
      if (n.cancelled && n.cancelled()) {
        s(new Uy());
        return;
      }
      r || (r = d), a && o.push(d - a), a = d;
      const c = d - r;
      if (n.onProgress && n.onProgress(Math.min(1, c / e)), c >= e) {
        i(o);
        return;
      }
      t(c), requestAnimationFrame(l);
    };
    requestAnimationFrame(l);
  });
}
function L6e(n) {
  return new Promise((e, t) => {
    const i = [];
    let s = !1, o = null;
    n.then(() => {
      s = !0;
    }, (l) => {
      o = l, s = !0;
    });
    let r = 0;
    const a = (l) => {
      if (r && i.push(l - r), r = l, s) {
        o ? t(o) : e(i);
        return;
      }
      requestAnimationFrame(a);
    };
    requestAnimationFrame(a);
  });
}
function yb(n, e) {
  const t = n.getBoundingClientRect();
  n.dispatchEvent(new WheelEvent("wheel", {
    deltaMode: 0,
    clientX: t.left + t.width / 2,
    clientY: t.top + t.height / 2,
    bubbles: !0,
    cancelable: !0,
    ...e
  }));
}
async function xb(n, e, t) {
  n.onPhase && n.onPhase("warm"), n.onProgress && n.onProgress(0), n.board.setCamera(e), await XI(n.board, t, n);
}
async function B6e(n, e) {
  const { board: t, layout: i } = e;
  if (!t.engine) throw new Error("The board is still loading");
  const s = O6e(t), o = t.view.w, r = t.view.h, a = i.tiles[Math.floor(i.rows / 2) * i.cols + Math.floor(i.cols / 2)] || i.tiles[0];
  if (n === "pan" || n === "zoom")
    await xb(e, vh(t), 8e3);
  else if (n === "pan-near") {
    const T = yh(t, a);
    await xb(e, Ga(T.x, T.y, 0.6, o, r), 5e3);
  } else
    await xb(e, vh(t), 8e3);
  lp(e);
  const l = await YI();
  lp(e), e.onPhase && e.onPhase("measure");
  const d = l / (1e3 / 60);
  if (n === "pan") {
    const T = await vb(e, bb, (M) => {
      const z = M / 16.666666666666668;
      yb(s, { deltaX: 12 * d * Math.cos(z / 17), deltaY: 9 * d * Math.cos(z / 23) });
    });
    return bh(T, l);
  }
  if (n === "pan-near") {
    const T = await vb(e, bb, (M) => {
      const z = M / 16.666666666666668;
      yb(s, { deltaX: d * (26 + 8 * Math.sin(z / 13)), deltaY: 14 * d * Math.cos(z / 23) });
    });
    return bh(T, l);
  }
  if (n === "zoom") {
    const T = await vb(e, bb, (M) => {
      const z = M / 16.666666666666668;
      yb(s, { deltaY: -8 * d * Math.sin(z / 20), ctrlKey: !0 });
    });
    return bh(T, l);
  }
  const c = t.engine, u = i.tiles[Math.min(i.tiles.indexOf(a) + 2, i.tiles.length - 1)], p = i.tiles[i.tiles.length - 1], f = yh(t, a), y = yh(t, u), b = yh(t, p), w = [
    { cam: zf(a, o, r, 60, 1), ms: 1400 },
    { cam: Ga(f.x, f.y, 0.6, o, r), ms: 900, sharp: !0 },
    { cam: Ga(y.x, y.y, 0.6, o, r), ms: 2200 },
    { cam: vh(t), ms: 1400 },
    { cam: Ga(b.x, b.y, 1, o, r), ms: 1700, sharp: !0 },
    { cam: vh(t), ms: 1400 }
  ], k = w.reduce((T, M) => T + M.ms, 0);
  let S = 0;
  const _ = (async () => {
    let T = 0;
    for (const M of w) {
      lp(e);
      const z = performance.now(), P = window.setInterval(() => {
        e.onProgress && e.onProgress(Math.min(1, (T + Math.min(M.ms, performance.now() - z)) / k));
      }, 100);
      try {
        await c.animateCamera(M.cam, M.ms);
      } finally {
        clearInterval(P);
      }
      T += M.ms, M.sharp ? S = Math.max(S, await XI(t, 5e3, e)) : await w0(250);
    }
  })(), x = await L6e(_);
  return e.onProgress && e.onProgress(1), { ...bh(x, l), sharpMs: S };
}
const F6e = [1e3, 4500, 1e4, 2e4], N6e = 4500, U6e = 5e4;
function d4(n) {
  const e = Math.round(Number(n));
  return !Number.isFinite(e) || e <= 0 ? N6e : Math.min(U6e, e);
}
const c4 = (n) => Math.round(n).toLocaleString("en-US"), xh = (n) => (Math.round(n * 10) / 10).toFixed(1);
function G6e(n) {
  const e = (l) => {
    const d = n.match(l);
    return d ? d[1] : null;
  };
  let t = "Browser";
  const i = e(/Edg\/(\d+)/), s = e(/Chrome\/(\d+)/), o = e(/Firefox\/(\d+)/), r = e(/Version\/(\d+(?:\.\d+)?).*Safari/);
  i ? t = "Edge " + i : s ? t = "Chrome " + s : o ? t = "Firefox " + o : r && (t = "Safari " + r);
  let a = "";
  return /Mac OS X/.test(n) ? a = "macOS" : /Windows/.test(n) ? a = "Windows" : /Android/.test(n) ? a = "Android" : /iPhone|iPad/.test(n) ? a = "iOS" : /Linux/.test(n) && (a = "Linux"), a ? t + " on " + a : t;
}
function JI(n) {
  return n.pass ? "Smooth" : "Dropped frames";
}
function j6e(n, e, t) {
  const i = (l, d) => l.length >= d ? l + " " : l + " ".repeat(d - l.length), s = [], o = t.getFullYear() + "-" + String(t.getMonth() + 1).padStart(2, "0") + "-" + String(t.getDate()).padStart(2, "0") + " " + String(t.getHours()).padStart(2, "0") + ":" + String(t.getMinutes()).padStart(2, "0");
  s.push("Boards stress test, " + o);
  let r = 0;
  for (const l of n) for (const d of Object.values(l.results)) d && d.vsync && (r = d.vsync);
  const a = [G6e(e.userAgent), e.viewport.w + "×" + e.viewport.h + " at " + e.dpr + "x"];
  r && a.push(Math.round(1e3 / r) + " Hz display (" + xh(r) + " ms frames)"), e.cores && a.push(e.cores + " cores"), e.memoryGB && a.push(e.memoryGB + " GB memory"), s.push(a.join(" · "));
  for (const l of n) {
    const d = Ld.filter((c) => l.results[c.id]);
    if (d.length) {
      s.push(""), s.push(c4(l.images) + " images · " + c4(l.objects) + " objects · " + l.copies + " copies (" + l.cols + " × " + l.rows + ")");
      for (const c of d) {
        const u = l.results[c.id];
        let p = "  " + i(c.label, 19) + i("p50 " + xh(u.p50), 10) + i("p95 " + xh(u.p95), 10) + i("max " + xh(u.max), 11) + i(u.slow + " slow", 8) + JI(u);
        u.sharpMs != null && (p += ", sharp in " + (u.sharpMs / 1e3).toFixed(1) + " s"), s.push(p);
      }
    }
  }
  return s.push(""), s.push("Frame times in ms. Smooth: p95 within 1.5 display frames and no frame past 3."), s.join(`
`);
}
const H6e = { class: "sx-head" }, V6e = { class: "sx-mark" }, W6e = { class: "sx-title" }, q6e = { key: 0 }, K6e = { key: 1 }, Y6e = ["title"], X6e = { class: "sx-pinned" }, J6e = {
  class: "sx-graph",
  title: "Frame times, newest on the right. The line is the budget: 1.5 display frames."
}, Z6e = { class: "sx-graph-label" }, Q6e = { class: "sx-live" }, e8e = { title: "CPU time of the last frame the board drew" }, t8e = { title: "Elements inside the view" }, n8e = { title: "Notes, sessions and labels mounted as DOM" }, i8e = { title: "GPU memory held by image textures (budget 420 MB)" }, s8e = { title: "Image renditions queued or decoding" }, o8e = { title: "JavaScript heap in use (Chrome only)" }, r8e = {
  class: "sx-tabs",
  role: "tablist"
}, a8e = ["aria-selected"], l8e = ["aria-selected"], d8e = {
  key: 0,
  class: "sx-dot"
}, c8e = {
  key: 1,
  class: "sx-tab-n"
}, u8e = { class: "sx-body" }, h8e = {
  key: 0,
  class: "sx-pane"
}, p8e = {
  class: "sx-seg",
  role: "radiogroup",
  "aria-label": "Board size"
}, f8e = ["aria-checked", "disabled", "data-testid", "onClick"], m8e = {
  class: "sx-counts",
  "data-testid": "stress-counts"
}, g8e = { class: "sx-big" }, b8e = {
  class: "is-grad",
  "data-testid": "stress-images"
}, v8e = { class: "sx-big" }, y8e = { "data-testid": "stress-objects" }, x8e = { key: 0 }, w8e = { class: "sx-row" }, k8e = ["disabled"], _8e = ["disabled"], S8e = ["disabled"], T8e = ["disabled"], M8e = {
  key: 1,
  class: "sx-pane"
}, C8e = { class: "sx-bench" }, I8e = ["data-testid"], A8e = ["title"], P8e = {
  key: 0,
  class: "sx-phase"
}, E8e = {
  key: 2,
  class: "sx-hint"
}, R8e = ["disabled", "title", "aria-label", "onClick"], z8e = {
  key: 0,
  class: "sx-bench-res",
  "data-testid": "stress-result"
}, $8e = {
  key: 1,
  class: "sx-progress"
}, D8e = { class: "sx-note" }, O8e = { class: "sx-actions" }, L8e = ["disabled"], B8e = ["disabled"], ws = 120, F8e = /* @__PURE__ */ Re({
  __name: "StressPanel",
  props: {
    board: {},
    stress: {}
  },
  setup(n) {
    const e = n, t = e.board, i = e.stress, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = i.collapsed, a = i.tab, l = (j) => j.toLocaleString("en-US"), d = I(() => {
      t.docRev.value, t.results.rev.value;
      const j = { image: 0, video: 0, tool: 0, note: 0, frame: 0, shape: 0, chat: 0 };
      for (const V of t.store.all())
        V.type === "image" ? (j.image++, V.video && j.video++) : V.type in j && j[V.type]++;
      return { ...j, objects: t.store.size, results: t.results.size };
    }), c = I(() => i.layout.value), u = new Float32Array(ws);
    let p = 0, f = 0, y = 0, b = 0, w = 0, k = null;
    const S = /* @__PURE__ */ We(1e3 / 60), _ = /* @__PURE__ */ We(0), x = /* @__PURE__ */ Xt({ frameMs: 0, visible: 0, dom: 0, textureMB: 0, pending: 0, heapMB: 0 }), T = I(() => {
      const j = 1e3 / S.value;
      return _.value ? _.value < j * 0.6 ? "is-bad" : _.value < j * 0.9 ? "is-warn" : "" : "";
    });
    function M() {
      const j = o.value;
      if (!j) return;
      const V = j.getBoundingClientRect();
      if (V.width < 2) return;
      const Q = Math.min(2, window.devicePixelRatio || 1);
      j.width = Math.round(V.width * Q), j.height = Math.round(V.height * Q), k = j.getContext("2d");
    }
    function z() {
      const j = o.value;
      if (!j || !k || r.value) return;
      const V = j.width, Q = j.height, oe = S.value, ue = oe * 4;
      k.clearRect(0, 0, V, Q), k.fillStyle = "rgba(255, 255, 255, 0.12)", k.fillRect(0, Math.round(Q - oe * 1.5 / ue * Q), V, 1);
      const Ie = V / ws, he = Ie > 3 ? 1 : 0;
      for (let ye = 0; ye < f; ye++) {
        const fe = u[(p - f + ye + ws) % ws], ze = Math.max(2, Math.min(Q, fe / ue * Q));
        k.fillStyle = fe > oe * 3 ? "#ff5c7a" : fe > oe * 1.5 + 1 ? "#ffb347" : "rgba(55, 211, 153, 0.85)", k.fillRect((ws - f + ye) * Ie, Q - ze, Ie - he, ze);
      }
    }
    function P(j) {
      y && j - y < 1e3 && (u[p] = j - y, p = (p + 1) % ws, f = Math.min(ws, f + 1), z()), y = j, b = requestAnimationFrame(P);
    }
    function D() {
      if (f) {
        const Q = Math.min(f, 60);
        let oe = 0;
        for (let ue = 1; ue <= Q; ue++) oe += u[(p - ue + ws) % ws];
        _.value = Math.round(1e3 / (oe / Q));
      }
      const j = t.stats.value;
      if (j && (x.frameMs = j.frameMs, x.visible = j.visible), t.engine) {
        const Q = t.engine.textureStats();
        x.textureMB = Q.mb, x.pending = Q.pending;
      }
      x.dom = t.overlayIds.value.length;
      const V = performance.memory;
      V && (x.heapMB = Math.round(V.usedJSHeapSize / 1048576));
    }
    const $ = /* @__PURE__ */ We(null);
    function O(j) {
      N.value || j === i.images.value || ($.value = j, requestAnimationFrame(() => setTimeout(() => i.rebuild(j), 30)));
    }
    function L(j) {
      t.zoomTo(j);
    }
    function Z() {
      const j = c.value.tiles;
      if (!t.engine || !j.length) return;
      const V = j[Math.floor(Math.random() * j.length)];
      let Q = V;
      for (const oe of t.store.all()) {
        if (oe.type !== "frame") continue;
        const ue = qe(oe);
        ue.x >= V.x && ue.y >= V.y && ue.x + ue.w <= V.x + V.w && ue.y + ue.h <= V.y + V.h && (Q === V || ue.w * ue.h > Q.w * Q.h) && (Q = ue);
      }
      t.engine.animateCamera(Ga(Q.x + Q.w / 2, Q.y + Q.h / 2, 0.6, t.view.w, t.view.h), 900);
    }
    const J = i.reports.get(i.images.value), re = /* @__PURE__ */ Xt(J ? { ...J.results } : {}), F = /* @__PURE__ */ We(null), W = /* @__PURE__ */ We("warm"), ee = /* @__PURE__ */ We(!1), N = I(() => !!F.value || $.value != null), te = I(() => Ld.filter((j) => re[j.id]).length), G = I(() => te.value > 0 || Array.from(i.reports.values()).some((j) => Object.keys(j.results).length > 0));
    let q = !1;
    function B(j) {
      s.value && s.value.style.setProperty("--sx-p", String(j));
    }
    function ne(j, V) {
      re[j] = V;
      const Q = i.images.value, oe = c.value, ue = i.reports.get(Q) || {
        images: d.value.image,
        objects: d.value.objects,
        copies: oe.copies,
        cols: oe.cols,
        rows: oe.rows,
        results: {}
      };
      ue.results[j] = V, i.reports.set(Q, ue);
    }
    async function se(j) {
      if (!N.value) {
        q = !1;
        for (const V of j) {
          F.value = V, W.value = "warm", B(0);
          try {
            const Q = await B6e(V, {
              board: t,
              layout: c.value,
              onProgress: B,
              onPhase: (oe) => {
                W.value = oe;
              },
              cancelled: () => q
            });
            ne(V, Q);
          } catch (Q) {
            Q instanceof Uy || t.toast(Q.message || "The benchmark stopped", "error");
            break;
          }
        }
        F.value = null, B(0);
      }
    }
    function Y() {
      q = !0;
    }
    function ie(j) {
      j.key === "Escape" && F.value && Y();
    }
    function De(j) {
      const V = (oe) => (Math.round(oe * 10) / 10).toFixed(1);
      let Q = "p95 " + V(j.p95) + " · max " + V(j.max) + " ms · " + j.slow + " slow";
      return j.sharpMs != null && (Q += " · sharp " + (j.sharpMs / 1e3).toFixed(1) + " s"), Q;
    }
    function xe() {
      const j = navigator;
      return {
        userAgent: j.userAgent,
        dpr: window.devicePixelRatio || 1,
        viewport: { w: window.innerWidth, h: window.innerHeight },
        cores: j.hardwareConcurrency || void 0,
        memoryGB: j.deviceMemory
      };
    }
    async function Oe() {
      const j = j6e(Array.from(i.reports.values()).sort((V, Q) => V.images - Q.images), xe(), /* @__PURE__ */ new Date());
      try {
        await navigator.clipboard.writeText(j), ee.value = !0, setTimeout(() => {
          ee.value = !1;
        }, 1800);
      } catch {
        t.toast("Couldn't copy the report. The browser blocked clipboard access.", "error");
      }
    }
    function Ee() {
      r.value = !r.value, r.value || requestAnimationFrame(M);
    }
    return ot(() => {
      M(), b = requestAnimationFrame(P), w = window.setInterval(D, 250), window.addEventListener("keydown", ie), window.addEventListener("resize", M), YI().then((j) => {
        S.value = j;
      });
    }), Ve(() => {
      q = !0, cancelAnimationFrame(b), clearInterval(w), window.removeEventListener("keydown", ie), window.removeEventListener("resize", M);
    }), (j, V) => (g(), v("div", {
      ref_key: "root",
      ref: s,
      class: U(["sx", { "is-collapsed": m(r), "is-busy": N.value }]),
      "data-testid": "stress-panel",
      onPointerdown: V[6] || (V[6] = Pe(() => {
      }, ["stop"])),
      onWheel: V[7] || (V[7] = Pe(() => {
      }, ["stop"]))
    }, [
      h("header", H6e, [
        h("span", V6e, [
          C(R, {
            name: "Gauge",
            size: 15
          })
        ]),
        h("div", W6e, [
          V[8] || (V[8] = h("b", null, "Stress test", -1)),
          m(r) ? (g(), v("span", q6e, A(l(d.value.image)) + " images", 1)) : (g(), v("span", K6e, "Demo board × " + A(c.value.copies), 1))
        ]),
        h("span", {
          class: U(["sx-fps", T.value]),
          title: "Frames per second, from the browser's frame clock",
          "data-testid": "stress-fps"
        }, A(_.value || "–") + " fps", 3),
        h("button", {
          class: "sx-icon",
          title: m(r) ? "Expand the panel" : "Collapse the panel",
          onClick: Ee
        }, [
          C(R, {
            name: m(r) ? "ChevronDown" : "ChevronUp",
            size: 14
          }, null, 8, ["name"])
        ], 8, Y6e)
      ]),
      xt(h("div", X6e, [
        h("div", J6e, [
          h("canvas", {
            ref_key: "graph",
            ref: o,
            "aria-hidden": "true"
          }, null, 512),
          h("span", Z6e, A((Math.round(S.value * 10) / 10).toFixed(1)) + " ms frames", 1)
        ]),
        h("div", Q6e, [
          h("div", e8e, [
            h("b", null, A(x.frameMs.toFixed(1)), 1),
            V[9] || (V[9] = h("span", null, "ms to draw", -1))
          ]),
          h("div", t8e, [
            h("b", null, A(l(x.visible)), 1),
            V[10] || (V[10] = h("span", null, "in view", -1))
          ]),
          h("div", n8e, [
            h("b", null, A(l(x.dom)), 1),
            V[11] || (V[11] = h("span", null, "DOM cards", -1))
          ]),
          h("div", i8e, [
            h("b", null, A(l(x.textureMB)), 1),
            V[12] || (V[12] = h("span", null, "MB textures", -1))
          ]),
          h("div", s8e, [
            h("b", null, A(l(x.pending)), 1),
            V[13] || (V[13] = h("span", null, "loading", -1))
          ]),
          h("div", o8e, [
            h("b", null, A(x.heapMB ? l(x.heapMB) : "–"), 1),
            V[14] || (V[14] = h("span", null, "MB JS heap", -1))
          ])
        ]),
        h("div", r8e, [
          h("button", {
            role: "tab",
            "aria-selected": m(a) === "board",
            class: U({ "is-on": m(a) === "board" }),
            "data-testid": "stress-tab-board",
            onClick: V[0] || (V[0] = (Q) => a.value = "board")
          }, "Board", 10, a8e),
          h("button", {
            role: "tab",
            "aria-selected": m(a) === "bench",
            class: U({ "is-on": m(a) === "bench" }),
            "data-testid": "stress-tab-bench",
            onClick: V[1] || (V[1] = (Q) => a.value = "bench")
          }, [
            V[15] || (V[15] = X(" Benchmarks ", -1)),
            F.value ? (g(), v("span", d8e)) : te.value ? (g(), v("span", c8e, A(te.value) + "/" + A(m(Ld).length), 1)) : E("", !0)
          ], 10, l8e)
        ])
      ], 512), [
        [qb, !m(r)]
      ]),
      xt(h("div", u8e, [
        m(a) === "board" ? (g(), v("section", h8e, [
          V[26] || (V[26] = h("h4", null, [
            X("Board size "),
            h("span", null, "images, at least")
          ], -1)),
          h("div", p8e, [
            (g(!0), v(H, null, me(m(F6e), (Q) => (g(), v("button", {
              key: Q,
              role: "radio",
              "aria-checked": Q === m(i).images.value,
              class: U({ "is-on": Q === m(i).images.value }),
              disabled: N.value && $.value !== Q,
              "data-testid": "stress-size-" + Q,
              onClick: (oe) => O(Q)
            }, [
              $.value === Q ? (g(), Ce(R, {
                key: 0,
                name: "Loader2",
                size: 12,
                spin: ""
              })) : E("", !0),
              X(" " + A(l(Q)), 1)
            ], 10, f8e))), 128))
          ]),
          h("div", m8e, [
            h("div", g8e, [
              h("b", b8e, A(l(d.value.image)), 1),
              V[16] || (V[16] = h("span", null, "images", -1))
            ]),
            h("div", v8e, [
              h("b", y8e, A(l(d.value.objects)), 1),
              h("span", null, "objects, " + A(c.value.cols) + " × " + A(c.value.rows) + " copies", 1)
            ]),
            h("dl", null, [
              h("div", null, [
                V[17] || (V[17] = h("dt", null, "Sessions", -1)),
                h("dd", null, A(l(d.value.tool)), 1)
              ]),
              h("div", null, [
                V[18] || (V[18] = h("dt", null, "Notes", -1)),
                h("dd", null, A(l(d.value.note)), 1)
              ]),
              d.value.chat ? (g(), v("div", x8e, [
                V[19] || (V[19] = h("dt", null, "Chats", -1)),
                h("dd", null, A(l(d.value.chat)), 1)
              ])) : E("", !0),
              h("div", null, [
                V[20] || (V[20] = h("dt", null, "Frames", -1)),
                h("dd", null, A(l(d.value.frame)), 1)
              ]),
              h("div", null, [
                V[21] || (V[21] = h("dt", null, "Shapes", -1)),
                h("dd", null, A(l(d.value.shape)), 1)
              ]),
              h("div", null, [
                V[22] || (V[22] = h("dt", null, "Videos", -1)),
                h("dd", null, A(l(d.value.video)), 1)
              ]),
              h("div", null, [
                V[23] || (V[23] = h("dt", null, "Results", -1)),
                h("dd", null, A(l(d.value.results)), 1)
              ])
            ])
          ]),
          V[27] || (V[27] = h("h4", { class: "sx-h-gap" }, "Camera", -1)),
          h("div", w8e, [
            h("button", {
              class: "sx-chip",
              disabled: N.value,
              title: "See the whole board",
              onClick: V[2] || (V[2] = (Q) => m(t).fit())
            }, [
              C(R, {
                name: "Scan",
                size: 13
              }),
              V[24] || (V[24] = X("Fit all", -1))
            ], 8, k8e),
            h("button", {
              class: "sx-chip",
              disabled: N.value,
              title: "Zoom to 60%",
              onClick: V[3] || (V[3] = (Q) => L(0.6))
            }, "60%", 8, _8e),
            h("button", {
              class: "sx-chip",
              disabled: N.value,
              title: "Zoom to 100%",
              onClick: V[4] || (V[4] = (Q) => L(1))
            }, "100%", 8, S8e),
            h("button", {
              class: "sx-chip",
              disabled: N.value,
              title: "Fly to a random copy",
              onClick: Z
            }, [
              C(R, {
                name: "LocateFixed",
                size: 13
              }),
              V[25] || (V[25] = X("Random", -1))
            ], 8, T8e)
          ])
        ])) : (g(), v("section", M8e, [
          h("ul", C8e, [
            (g(!0), v(H, null, me(m(Ld), (Q) => (g(), v("li", {
              key: Q.id,
              class: U({ "is-running": F.value === Q.id }),
              "data-testid": "stress-bench-" + Q.id
            }, [
              h("div", {
                class: "sx-bench-name",
                title: Q.about
              }, [
                h("b", null, A(Q.label), 1),
                F.value === Q.id ? (g(), v("span", P8e, A(W.value === "warm" ? "Loading the start" + (x.pending ? ", " + l(x.pending) + " to go" : "") : "Measuring"), 1)) : re[Q.id] ? (g(), v("span", {
                  key: 1,
                  class: U(["sx-pill", re[Q.id].pass ? "is-ok" : "is-bad"]),
                  "data-testid": "stress-verdict"
                }, A(m(JI)(re[Q.id])), 3)) : (g(), v("span", E8e, A(Q.hint), 1))
              ], 8, A8e),
              h("button", {
                class: "sx-play",
                disabled: N.value,
                title: "Run " + Q.label.toLowerCase(),
                "aria-label": "Run " + Q.label.toLowerCase(),
                onClick: (oe) => se([Q.id])
              }, [
                F.value === Q.id ? (g(), Ce(R, {
                  key: 0,
                  name: "Loader2",
                  size: 13,
                  spin: ""
                })) : (g(), Ce(R, {
                  key: 1,
                  name: "Play",
                  size: 12
                }))
              ], 8, R8e),
              re[Q.id] && F.value !== Q.id ? (g(), v("div", z8e, A(De(re[Q.id])), 1)) : E("", !0),
              F.value === Q.id ? (g(), v("div", $8e)) : E("", !0)
            ], 10, I8e))), 128))
          ]),
          h("p", D8e, A(F.value ? "Hands off the canvas while it runs. Esc stops it." : "Smooth: p95 under 1.5 frames, none over 3."), 1),
          h("div", O8e, [
            F.value ? (g(), v("button", {
              key: 0,
              class: "bd-btn is-ghost",
              "data-testid": "stress-stop",
              onClick: Y
            }, [
              C(R, {
                name: "Square",
                size: 12
              }),
              V[28] || (V[28] = X("Stop", -1))
            ])) : (g(), v("button", {
              key: 1,
              class: "bd-btn",
              disabled: N.value,
              "data-testid": "stress-run-all",
              onClick: V[5] || (V[5] = (Q) => se(m(Ld).map((oe) => oe.id)))
            }, [
              C(R, {
                name: "Play",
                size: 12
              }),
              V[29] || (V[29] = X("Run all", -1))
            ], 8, L8e)),
            h("button", {
              class: "bd-btn is-ghost",
              disabled: !G.value,
              "data-testid": "stress-copy",
              onClick: Oe
            }, [
              C(R, {
                name: ee.value ? "Check" : "Copy",
                size: 13
              }, null, 8, ["name"]),
              X(A(ee.value ? "Copied" : "Copy report"), 1)
            ], 8, B8e)
          ])
        ]))
      ], 512), [
        [qb, !m(r)]
      ])
    ], 34));
  }
}), N8e = {
  key: 0,
  class: "cv-root bd-root"
}, U8e = { class: "bd-center" }, G8e = {
  class: "bd-error-card",
  "data-testid": "board-error"
}, j8e = { style: { "margin-bottom": "16px" } }, H8e = { class: "bd-error-actions" }, V8e = {
  key: 0,
  class: "bd-root bd-splash",
  "data-testid": "board-opening"
}, ZI = /* @__PURE__ */ Re({
  __name: "BoardApp",
  props: {
    env: {}
  },
  setup(n) {
    const t = n.env, i = /* @__PURE__ */ We(null);
    let s = null;
    function o() {
      s && s(), s = null;
      const l = i.value;
      l && (l.feedback && l.feedback.dispose(), l.dispose(), i.value = null, t.onController && t.onController(null));
    }
    function r(l) {
      if (o(), !l) return;
      const d = t.servicesFor ? t.servicesFor(l) : null;
      let c = null;
      const u = () => c ? { title: c.meta.title, teamId: c.meta.teamId, ownerId: c.meta.ownerId, accessLevel: c.meta.accessLevel } : { title: "", teamId: null, ownerId: "", accessLevel: null }, p = t.commentsFor ? t.commentsFor(l, u) : null, f = t.initialComment || null;
      t.initialComment = null;
      const y = new nf({
        boardId: l,
        sync: t.directory.open(l),
        user: t.user,
        catalog: t.catalog,
        gen: d ? d.gen : t.gen,
        runs: d ? d.runs : null,
        prompts: d ? d.prompts : null,
        favorites: d ? d.favorites : null,
        pins: d ? d.pins : null,
        models: d ? d.models : null,
        balance: d ? d.balance : null,
        teamStatus: d ? d.teamStatus : null,
        library: d ? d.library : t.library || null,
        companyTools: d ? d.companyTools : null,
        featured: d ? d.featured : t.featured || null,
        myPrompts: d ? d.myPrompts : t.myPrompts || null,
        labels: t.labels,
        onGetTokens: t.getTokens,
        onOpenTour: t.openTour ? () => t.openTour(l) : void 0,
        track: t.track,
        storageUrl: t.storageUrl,
        studio: { ...t.studio || {}, ...d ? { annotate: d.annotate } : {} },
        initialCamera: t.initialCamera,
        onCameraSettled: t.onCameraSettled,
        initialStudio: t.initialStudio,
        onStudio: t.onStudio,
        onTitle: t.onTitle,
        comments: p ? {
          store: p,
          linkFor: t.commentLink,
          openAt: (w, k) => {
            t.initialComment = k, t.openBoard(w);
          },
          initial: f,
          onShown: t.clearCommentLink
        } : null,
        agent: t.agent || null
      });
      c = y, y.uploader = t.uploaderFor ? t.uploaderFor(l) : null;
      const b = t.feedback;
      b && (y.feedback = new ake({ board: y, recorder: b.recorder, sink: b.sink, build: b.build }), s = Oxe(b.recorder, y)), y.ui.showStats = t1, i.value = y, t.onController && t.onController(y), y.load(), t.initialCamera = null, t.initialStudio = null;
    }
    $e(() => t.ready.value ? t.boardId.value : void 0, (l) => {
      l !== void 0 && r(l);
    }, { immediate: !0 }), Ve(() => {
      i.value ? o() : t.onController && t.onController(null);
    });
    const a = I(() => !t.ready.value || !!i.value && !i.value.loadError.value && !i.value.loaded.value);
    return (l, d) => (g(), v(H, null, [
      m(t).ready.value && i.value ? (g(), v(H, { key: 0 }, [
        i.value.loadError.value ? (g(), v("div", N8e, [
          h("div", U8e, [
            h("div", G8e, [
              h("b", null, A(i.value.loadErrorKind.value === "not-canvas" ? "This board opens in Boards" : "This board couldn't be opened"), 1),
              h("div", j8e, A(i.value.loadError.value), 1),
              h("div", H8e, [
                i.value.loadErrorKind.value === "not-canvas" && m(t).openRunnit ? (g(), v("button", {
                  key: 0,
                  class: "bd-btn",
                  "data-testid": "open-in-boards",
                  onClick: d[0] || (d[0] = (c) => m(t).openRunnit(i.value.meta.id))
                }, " Open in Boards ")) : E("", !0),
                h("button", {
                  class: "bd-btn is-ghost",
                  onClick: d[1] || (d[1] = (c) => m(t).openBoard(null))
                }, "Back to boards")
              ])
            ])
          ])
        ])) : i.value.loaded.value ? (g(), Ce(I6e, {
          key: i.value.meta.id,
          board: i.value,
          "on-home": m(t).home,
          "on-index": () => m(t).openBoard(null)
        }, V5({ _: 2 }, [
          m(t).stress ? {
            name: "hud",
            fn: et(() => [
              C(F8e, {
                board: i.value,
                stress: m(t).stress
              }, null, 8, ["board", "stress"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["board", "on-home", "on-index"])) : E("", !0)
      ], 64)) : E("", !0),
      C(vt, { name: "bd-splash" }, {
        default: et(() => [
          a.value ? (g(), v("div", V8e, [
            C(KI)
          ])) : E("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), W8e = '.bd-root{--steel-pink-300: #812686;--steel-pink-500: #c750ce;--amethyst-300: #5722a2;--amethyst-400: #7532d3;--amethyst-500: #9968df;--amethyst-600: #ae86e5;--amethyst-700: #c2a4ec;--amethyst-800: #d6c2f2;--vista-blue-300: #1822dc;--vista-blue-400: #5a61ed;--vista-blue-500: #a3a7f5;--vista-blue-600: #b6b9f7;--bg-deep: #04030c;--bg-base: #070910;--bg-raised: #0b0d14;--bg-surface: #121521;--bg-overlay: rgba(4, 3, 12, .86);--hairline: rgba(255, 255, 255, .1);--hairline-soft: rgba(255, 255, 255, .06);--inset-highlight: inset 0 1px 0 rgba(255, 255, 255, .08);--fg-1: #ffffff;--fg-2: rgba(255, 255, 255, .72);--fg-3: rgba(255, 255, 255, .58);--fg-4: rgba(255, 255, 255, .38);--fg-5: rgba(255, 255, 255, .25);--success: #37d399;--warning: #ffb347;--danger: #ff5c7a;--grad-cta: linear-gradient(90deg, var(--amethyst-500) 0%, #8f72ff 50%, var(--vista-blue-400) 100%);--grad-glass: linear-gradient(180deg, rgba(255, 255, 255, .09), rgba(255, 255, 255, .03));--grad-purple-pink: linear-gradient(90deg, var(--steel-pink-500), var(--amethyst-500), var(--vista-blue-500));--shadow-card: 0 18px 60px rgba(5, 8, 20, .28);--shadow-deep: 0 30px 100px rgba(2, 6, 23, .55);--radius-xs: 6px;--radius-sm: 10px;--radius-md: 16px;--radius-lg: 24px;--radius-pill: 999px;--font-sans: "SpaceGrotesk", "Space Grotesk", system-ui, -apple-system, "Segoe UI", sans-serif;--ease-out-soft: cubic-bezier(.16, 1, .3, 1);--dur-fast: .2s;--dur-med: .3s;--dur-slow: .5s}.bd-root,.bd-root *,.bd-root *:before,.bd-root *:after{box-sizing:border-box;background-repeat:repeat}.bd-root{font-family:var(--font-sans);font-size:14px;line-height:normal;color:var(--fg-2);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility}.bd-root button,.bd-root input,.bd-root textarea{font-family:var(--font-sans);letter-spacing:inherit}:where(.bd-root) button,:where(.bd-root) input,:where(.bd-root) textarea{margin:0}.bd-root button{-webkit-tap-highlight-color:transparent}.bd-root button:focus{outline:none}.bd-root button:focus-visible{outline:2px solid rgba(163,167,245,.7);outline-offset:2px}.bd-root p{margin:0}', q8e = `.cv-root{--cv-accent: var(--amethyst-500);--cv-accent-strong: var(--amethyst-400);--cv-accent-soft: rgba(153, 104, 223, .4);--cv-accent-tint: rgba(153, 104, 223, .14);--cv-accent-text: var(--amethyst-700);--cv-guide: var(--amethyst-600);--cv-guide-halo: rgba(4, 3, 12, .35);--cv-glass-a: 1;--cv-blur: 24px;--cv-atmo: 1;--cv-zoom: 1;--cv-inv-zoom: 1;position:fixed;inset:0;overflow:hidden;overflow:clip;background:var(--bg-deep);user-select:none;-webkit-user-select:none;touch-action:none;overscroll-behavior:none;z-index:200}.licon{display:inline-flex;align-items:center;justify-content:center;line-height:0;flex:none}.licon svg{display:block}.licon-spin svg{animation:cvSpin .9s linear infinite}@keyframes cvSpin{to{transform:rotate(360deg)}}.cv-atmo{position:absolute;inset:0;pointer-events:none}.cv-atmo-glow{position:absolute;inset:0;background:radial-gradient(56% 42% at 50% -6%,rgba(255,255,255,.075),transparent 60%),linear-gradient(115deg,#9968df21,#04030c00 30%,#a3a7f51a 68%,#04030c00 90%);opacity:var(--cv-atmo)}.cv-atmo-orb-a,.cv-atmo-orb-b{position:absolute;width:560px;height:560px;border-radius:50%;filter:blur(160px);opacity:calc(.16 * var(--cv-atmo));transform:translateZ(0)}.cv-atmo-orb-a{left:-220px;top:-180px;background:var(--amethyst-500)}.cv-atmo-orb-b{right:-200px;top:-120px;background:var(--vista-blue-400);opacity:calc(.11 * var(--cv-atmo))}.cv-grid{position:absolute;inset:0;pointer-events:none;background-image:radial-gradient(rgba(255,255,255,.85) 1px,transparent 1.4px);opacity:calc(.06 * var(--cv-atmo))}.cv-stage{position:absolute;inset:0;overflow:hidden;overflow:clip;cursor:default;outline:none}.cv-stage.is-hand{cursor:grab}.cv-stage.is-dropper{--dropper-cursor: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke-linecap='round' stroke-linejoin='round'><g stroke='%23070910' stroke-width='4'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g><g stroke='white' stroke-width='2'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g></svg>") 2 22, crosshair;cursor:var(--dropper-cursor)}.cv-stage.is-dropper .cv-el,.cv-stage.is-dropper .cv-el *{cursor:grab}.cv-stage.is-dropper .cv-el .cv-thumb-pull{cursor:var(--dropper-cursor)}.cv-stage.is-panning,.cv-stage.is-panning *{cursor:grabbing!important}.bd-canvas{position:absolute;left:0;top:0;display:block}.cv-world{position:absolute;left:0;top:0;width:0;height:0;transform-origin:0 0;pointer-events:none}.cv-world.is-moving{will-change:transform}.cv-el{position:absolute;pointer-events:auto}.cv-el-body{position:relative;width:100%;height:100%;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft)}.cv-el.is-dragging .cv-el-body{transition:none}@media(prefers-reduced-motion:no-preference){.cv-el.cv-enter{animation:cvEnter .65s var(--ease-out-soft) both;animation-delay:var(--d, 0s)}@keyframes cvEnter{0%{opacity:0;transform:translateY(34px)}to{opacity:1;transform:translateY(0)}}}.cv-ring{position:absolute;inset:calc(-3px * var(--cv-inv-zoom));border-radius:inherit;pointer-events:none;border:calc(1.5px * var(--cv-inv-zoom)) solid var(--cv-accent);box-shadow:0 0 0 calc(4px * var(--cv-inv-zoom)) var(--cv-accent-tint);opacity:0;transition:opacity var(--dur-fast)}.is-selected>.cv-el-body>*>.cv-ring,.is-selected .cv-bucket>.cv-ring,.is-selected .cv-note>.cv-ring{opacity:1}.cv-bucket{width:100%;border-radius:var(--radius-md);background:linear-gradient(180deg,rgba(255,255,255,calc(.09 * var(--cv-glass-a))),rgba(255,255,255,calc(.03 * var(--cv-glass-a))));border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card);backdrop-filter:blur(var(--cv-blur));-webkit-backdrop-filter:blur(var(--cv-blur));padding:14px;cursor:pointer;position:relative;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft)}.cv-world.is-moving .cv-bucket,.cv-world.is-crowded .cv-bucket{backdrop-filter:none;-webkit-backdrop-filter:none}.cv-el:hover .cv-bucket{transform:translateY(-4px);box-shadow:var(--inset-highlight),0 24px 70px #05081461}.cv-el.is-dragging .cv-bucket,.cv-el.is-open .cv-bucket{transform:none}.cv-bucket .cv-ring{border-radius:var(--radius-md)}.cv-el.is-ref-target .cv-bucket{box-shadow:var(--inset-highlight),0 0 0 1px var(--cv-accent-soft),0 18px 54px #9968df4d}.cv-el.is-ref-target .cv-bucket>.cv-ring{opacity:1}.cv-bucket-head{display:flex;align-items:center;gap:10px}.cv-badge{width:36px;height:36px;flex:none;border-radius:12px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;display:flex;align-items:center;justify-content:center;color:var(--cv-accent-text)}.cv-bucket-titles{min-width:0;flex:1}.cv-bucket-kind{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;display:flex;align-items:baseline;min-width:0}.cv-bucket-sep{margin:0 6px;color:var(--fg-5);letter-spacing:0}.cv-bucket-model{min-width:0;overflow:hidden;text-overflow:ellipsis;font-size:10px;font-weight:500;text-transform:none;letter-spacing:.01em;color:var(--fg-5)}.cv-bucket-name{font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:1px}.cv-bucket-name-input{width:100%;font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;background:#ffffff0f;border:1px solid var(--cv-accent-soft);border-radius:6px;padding:0 5px;margin:0 0 0 -6px;outline:none;height:21px;user-select:text;-webkit-user-select:text}.cv-count{flex:none;font-size:11px;font-weight:600;color:var(--fg-3);background:#ffffff0d;border:1px solid var(--hairline-soft);border-radius:var(--radius-pill);padding:3px 9px;font-variant-numeric:tabular-nums}.cv-bucket-thumbs{display:flex;gap:6px;margin-top:12px}.cv-bucket-thumbs .cv-thumb{flex:1;aspect-ratio:1}.cv-bucket-thumbs .cv-thumb-empty{flex:1;aspect-ratio:1;border-radius:8px;border:1px dashed rgba(255,255,255,.1);background:#ffffff05}.cv-thumb{border-radius:8px;min-width:0;border:1px solid rgba(255,255,255,.07);box-shadow:inset 0 1px #ffffff0f;background-color:#ffffff0a;background-size:cover;background-position:center}.cv-thumb-pull{cursor:grab;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast),border-color var(--dur-fast)}.cv-thumb-pull:hover{transform:translateY(-2px) scale(1.03);box-shadow:inset 0 1px #ffffff1a,0 10px 26px #05081473;border-color:var(--cv-accent-soft)}.cv-thumb-pull:active{cursor:grabbing}@media(prefers-reduced-motion:no-preference){.cv-thumb.thumb-new{animation:thumbIn .55s var(--ease-out-soft) both;animation-delay:var(--d, 0s)}@keyframes thumbIn{0%{opacity:0;transform:scale(.82)}to{opacity:1;transform:scale(1)}}}.cv-thumb.thumb-shimmer,.cv-thumb-empty.thumb-shimmer{position:relative;overflow:hidden}.cv-thumb.thumb-shimmer:after,.cv-thumb-empty.thumb-shimmer:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}@keyframes shimmer{0%{transform:translate(-100%)}to{transform:translate(100%)}}.cv-bucket-foot{display:flex;align-items:center;justify-content:space-between;margin-top:11px;font-size:11px;color:var(--fg-4)}.cv-bucket-foot .is-error{color:#ff8aa0;display:inline-flex;align-items:center;gap:5px}.cv-bucket-open-hint{display:inline-flex;align-items:center;gap:5px;margin:-3px -6px;padding:3px 6px;border:0;border-radius:7px;background:transparent;color:var(--fg-4);font:inherit;cursor:pointer;opacity:0;transition:opacity var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.cv-el:hover .cv-bucket-open-hint{opacity:1}.cv-bucket-open-hint:hover,.cv-bucket-open-hint:focus-visible{color:var(--fg-1);background:#ffffff12;opacity:1}.cv-thumb-empty.is-open{cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.cv-thumb-empty.is-open:hover{background:#ffffff0d;border-color:#ffffff29}.cv-note{width:100%;height:100%;border-radius:var(--radius-md);padding:16px;display:flex;flex-direction:column;backdrop-filter:blur(var(--cv-blur));-webkit-backdrop-filter:blur(var(--cv-blur));cursor:grab;position:relative;box-shadow:inset 0 1px #ffffff1a,var(--shadow-card);transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft)}.cv-world.is-moving .cv-note,.cv-world.is-crowded .cv-note{backdrop-filter:none;-webkit-backdrop-filter:none}.cv-el.is-dragging .cv-note{cursor:grabbing}.cv-el:hover .cv-note{transform:translateY(-4px)}.cv-el.is-dragging .cv-note,.cv-el.is-selected .cv-note,.cv-note.is-editing{transform:none}.cv-note .cv-ring{border-radius:var(--radius-md)}.cv-note.tint-amethyst{background:linear-gradient(180deg,#9968df2b,#9968df14);border:1px solid rgba(194,164,236,.22)}.cv-note.tint-vista{background:linear-gradient(180deg,#5a61ed2b,#5a61ed14);border:1px solid rgba(163,167,245,.22)}.cv-note.tint-sky{background:linear-gradient(180deg,#3db4e62b,#3db4e614);border:1px solid rgba(153,217,243,.22)}.cv-note.tint-mint{background:linear-gradient(180deg,#34c79a2b,#34c79a14);border:1px solid rgba(143,229,201,.22)}.cv-note.tint-amber{background:linear-gradient(180deg,#f0b44a2b,#f0b44a14);border:1px solid rgba(247,212,143,.22)}.cv-note.tint-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14);border:1px solid rgba(245,163,199,.22)}.cv-note.tint-glass{background:var(--grad-glass);border:1px solid var(--hairline)}.cv-note-text{flex:1;min-height:0;font-size:13.5px;line-height:1.45;color:#ffffffdb;letter-spacing:-.005em;outline:none;overflow-x:hidden;overflow-y:auto;word-wrap:break-word;white-space:pre-wrap;scrollbar-width:none;overscroll-behavior:contain}.cv-note-text::-webkit-scrollbar{display:none}.cv-note.more-below .cv-note-text{-webkit-mask-image:linear-gradient(180deg,#000 calc(100% - 28px),transparent);mask-image:linear-gradient(180deg,#000 calc(100% - 28px),transparent)}.cv-note.more-above .cv-note-text{-webkit-mask-image:linear-gradient(0deg,#000 calc(100% - 28px),transparent);mask-image:linear-gradient(0deg,#000 calc(100% - 28px),transparent)}.cv-note.more-above.more-below .cv-note-text{-webkit-mask-image:linear-gradient(180deg,transparent,#000 28px,#000 calc(100% - 28px),transparent);mask-image:linear-gradient(180deg,transparent,#000 28px,#000 calc(100% - 28px),transparent)}.cv-note.is-editing .cv-note-text{cursor:text;user-select:text;-webkit-user-select:text}.cv-note-meta{font-size:10px;color:#ffffff61;font-weight:600;letter-spacing:.16em;text-transform:uppercase;margin-top:8px}.cv-frame-title{position:absolute;left:0;bottom:0;padding:0 0 9px 4px;max-width:calc(100% * var(--cv-zoom));transform:scale(var(--cv-inv-zoom));transform-origin:0 100%;display:flex;align-items:center;gap:10px;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;cursor:grab;outline:none;pointer-events:auto}.cv-frame-title .cv-frame-name{min-width:0;overflow:hidden;text-overflow:ellipsis}.cv-frame-title .cv-frame-count{flex:none}.cv-world.is-far .cv-frame-count{display:none}.cv-world.is-far .cv-frame-title{left:8px;padding:3px 8px 3px 9px;font-size:9.5px;letter-spacing:.18em;color:var(--fg-2);max-width:calc(100% * var(--cv-zoom) - 16px);transform:scale(var(--cv-inv-zoom)) translateY(50%);background:#0d0c1ae0;border:1px solid rgba(255,255,255,.09);border-radius:7px;box-shadow:0 4px 14px #00000059}.light-canvas .cv-world.is-far .cv-frame-title{background:#fffffff0;border-color:#1318281a;color:#131828b3;box-shadow:0 4px 14px #13182814}.cv-frame-title .cv-frame-count{letter-spacing:.06em;color:var(--fg-5);text-transform:none;font-weight:500}.cv-frame-title.is-selected{color:var(--cv-accent-text)}.cv-frame-title.is-locked{cursor:default}.cv-frame-title .cv-frame-lock{flex:none;display:inline-flex;margin-right:-4px;color:var(--fg-3)}.cv-frame-title.is-selected .cv-frame-lock{color:inherit}.cv-frame-title-input{font:inherit;letter-spacing:.22em;text-transform:uppercase;color:var(--fg-1);background:#ffffff0f;border:1px solid var(--cv-accent-soft);border-radius:6px;padding:1px 6px;margin:-2px 0 0 -7px;outline:none;min-width:120px;user-select:text;-webkit-user-select:text}.cv-resize{position:absolute;right:calc(-6px * var(--cv-inv-zoom));bottom:calc(-6px * var(--cv-inv-zoom));width:calc(15px * var(--cv-inv-zoom));height:calc(15px * var(--cv-inv-zoom));border-radius:calc(5px * var(--cv-inv-zoom));background:var(--cv-accent);border:calc(2px * var(--cv-inv-zoom)) solid var(--bg-deep);box-shadow:0 0 0 calc(3px * var(--cv-inv-zoom)) var(--cv-accent-tint);cursor:nwse-resize;z-index:7;pointer-events:auto;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-resize:hover{transform:scale(1.15)}.cv-marquee{position:absolute;pointer-events:none;border:1px solid var(--cv-accent-soft);background:var(--cv-accent-tint);border-radius:4px}.cv-guides{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;overflow:visible}.cv-guides path{fill:none;stroke-width:1px}.cv-guide-line{stroke:var(--cv-guide);stroke-dasharray:4 4}.cv-guide-gap{stroke:var(--cv-guide)}.cv-guide-halo{stroke:var(--cv-guide-halo);stroke-width:3px!important}.cv-guide-halo.is-dashed{stroke-dasharray:4 4}.cv-vid{position:absolute;pointer-events:none;border-radius:12px;overflow:hidden;opacity:0;transition:opacity .22s var(--ease-out-soft),top .2s var(--ease-out-soft)}.cv-vid.is-shown{opacity:1}.cv-vid video{display:block;width:100%;height:100%;object-fit:cover}.cv-vid-bar{position:absolute;left:0;right:0;bottom:0;height:calc(2px * var(--cv-inv-zoom));background:#ffffff29}.cv-vid-bar i{display:block;height:100%;transform-origin:0 50%;transform:scaleX(0);background:linear-gradient(90deg,var(--amethyst-600),var(--vista-blue-500))}.cv-dropper-ring{position:absolute;pointer-events:none;border-radius:12px;box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) var(--amethyst-500),0 0 0 calc(6px * var(--cv-inv-zoom)) #9968df38;animation:cvFade var(--dur-fast) ease both}.cv-dropper-ring.is-in{box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) #ffffff8c}.cv-dropper-chip{position:absolute;left:0;top:0;transform-origin:0 0;transform:translate(calc(8px * var(--cv-inv-zoom)),calc(8px * var(--cv-inv-zoom))) scale(var(--cv-inv-zoom));display:inline-flex;align-items:center;gap:5px;padding:3px 9px 3px 7px;border-radius:999px;background:#04030ccc;color:#fff;font-size:11px;font-weight:600;white-space:nowrap;box-shadow:0 4px 14px #02040c73}.cv-img-hover{position:absolute;pointer-events:none;border-radius:12px;overflow:hidden;transition:transform var(--dur-fast) var(--ease-out-soft)}.cv-img-shade{position:absolute;left:0;right:0;bottom:0;height:46%;background:linear-gradient(180deg,#04030c00,#04030c8c);pointer-events:none;animation:cvFade var(--dur-fast) ease both}.cv-img-foot{position:absolute;left:12px;bottom:9px;right:9px;display:flex;align-items:center;gap:8px;pointer-events:none}.cv-img-label{flex:1;min-width:0;font-size:11px;font-weight:500;color:#ffffffc7;letter-spacing:.01em;pointer-events:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;animation:cvFade var(--dur-fast) ease both}.cv-img-model{flex:none;max-width:60%;padding:2px 8px;border-radius:var(--radius-pill);background:#0c0e1894;border:1px solid rgba(255,255,255,.12);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);font-size:10.5px;font-weight:600;color:#ffffffe6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;animation:cvFade var(--dur-fast) ease both}.cv-img-actions{position:absolute;top:8px;right:8px;display:flex;gap:4px;pointer-events:auto;animation:cvFade var(--dur-fast) ease both}@keyframes cvFade{0%{opacity:0}to{opacity:1}}.cv-img-hint{--s: var(--cv-inv-zoom);flex:none;display:inline-flex;align-items:center;gap:calc(6px * var(--s));padding:calc(3px * var(--s)) calc(9px * var(--s)) calc(3px * var(--s)) calc(3px * var(--s));border-radius:var(--radius-pill);background:#0c0e189e;border:calc(1px * var(--s)) solid rgba(255,255,255,.1);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);font-size:calc(10.5px * var(--s));font-weight:500;color:#fffc;white-space:nowrap;animation:cvFade .3s ease .7s both}.cv-img-hint kbd{display:inline-flex;align-items:center;justify-content:center;min-width:calc(18px * var(--s));height:calc(17px * var(--s));padding:0 calc(5px * var(--s));border-radius:999px;background:#ffffff1f;color:#fff;font-family:var(--font-sans);font-size:calc(10px * var(--s));font-weight:600;line-height:1}.cv-img-actions button{width:26px;height:26px;border:1px solid rgba(255,255,255,.1);border-radius:8px;background:#0c0e189e;backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);color:#ffffffb8;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:background var(--dur-fast),color var(--dur-fast)}.cv-img-actions button:hover{background:#141624d9;color:#fff}.cv-img-badges{position:absolute;pointer-events:none}.cv-img-vid{position:absolute;left:10px;top:10px;display:inline-flex;align-items:center;gap:5px;padding:4px 9px;border-radius:var(--radius-pill);background:#04030c94;border:1px solid rgba(255,255,255,.12);font-size:10px;font-weight:600;color:#ffffffd1;font-variant-numeric:tabular-nums}.cv-img-fav{position:absolute;top:8px;left:8px;width:20px;height:20px;display:inline-flex;align-items:center;justify-content:center;border-radius:999px;background:#04030c9e;color:#ef5f7a}.cv-img-vid+.cv-img-fav{left:auto;right:8px}.cv-img-fav svg{fill:currentColor}.cv-img-missing{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:6px;color:var(--fg-4);font-size:11px;pointer-events:none}.cv-topbar{position:absolute;top:0;left:0;right:0;height:60px;z-index:48;display:flex;align-items:center;gap:16px;padding:0 18px;background:#0709109e;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border-bottom:1px solid var(--hairline-soft)}.cv-topbar-left{display:flex;align-items:center;gap:12px;flex:1;min-width:0}.cv-topbar-right{display:flex;align-items:center;gap:14px;flex:1;justify-content:flex-end}.cv-mark{width:34px;height:30px;border-radius:9px;flex:none;display:flex;align-items:center;justify-content:center;background:none;border:0;cursor:pointer;padding:0;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-med)}.cv-mark svg{display:block;width:28px;height:auto}.cv-mark:hover{transform:scale(1.06);filter:drop-shadow(0 4px 12px rgba(153,104,223,.45))}.cv-mark:focus-visible{outline:none;box-shadow:0 0 0 1px #04030ca6,0 0 0 3px #a3a7f58c}.cv-crumb{font-size:12.5px;color:var(--fg-4);white-space:nowrap;background:none;border:0;padding:0;cursor:pointer;transition:color var(--dur-fast)}.cv-crumb:hover{color:var(--fg-2)}.cv-crumb-sep{color:var(--fg-5);margin:0 -4px}.cv-board-title{font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;padding:3px 6px;margin:0 -6px;border-radius:7px;cursor:text;transition:background var(--dur-fast)}.cv-board-title:hover{background:#ffffff0d}.cv-board-title-input{font:inherit;font-size:13.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1);background:#ffffff0f;border:1px solid var(--cv-accent-soft);border-radius:7px;padding:3px 6px;margin:0 -6px;outline:none;min-width:220px;user-select:text;-webkit-user-select:text}.cv-tokens{display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff08;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;white-space:nowrap;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cv-tokens .licon{color:var(--fg-4)}.cv-tokens.is-link{cursor:pointer}.cv-tokens.is-link:hover{background:#ffffff12;color:var(--fg-1)}.cv-tokens.is-empty{color:#ffb38a;border-color:#ff8c5a59}.cv-tokens.is-empty .licon{color:#ffb38a}.cv-save-state{display:inline-flex;align-items:center;gap:6px;font-size:11px;color:var(--fg-5);white-space:nowrap;transition:color var(--dur-med)}.cv-save-state .dot{width:6px;height:6px;border-radius:50%;background:var(--fg-5);transition:background var(--dur-med)}.cv-save-state.is-saving .dot{background:var(--warning);animation:syPulse 1.1s ease-in-out infinite}.cv-save-state.is-error{color:#ff8aa0}.cv-save-state.is-error .dot{background:var(--danger)}@keyframes syPulse{0%,to{opacity:1}50%{opacity:.35}}.cv-tool{width:32px;height:32px;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;position:relative;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.cv-tool:hover{background:#ffffff12;color:var(--fg-1)}.cv-tool.on{background:var(--cv-accent-tint);color:var(--cv-accent-text)}.cv-tool .tip{position:absolute;bottom:calc(100% + 10px);left:50%;transform:translate(-50%) translateY(4px);background:#0b0d14eb;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 10px;border-radius:8px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-tool:hover .tip{opacity:1;transform:translate(-50%) translateY(0);transition-delay:.26s}.cv-tool .key{color:var(--fg-5);margin-left:6px}.cv-iconbtn{width:30px;height:30px;flex:none;display:inline-flex;align-items:center;justify-content:center;border-radius:9px;border:1px solid transparent;background:transparent;color:var(--fg-4);cursor:pointer;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.cv-iconbtn:hover{background:#ffffff12;color:var(--fg-1)}.cv-corner{position:absolute;right:18px;bottom:22px;z-index:40;display:flex;flex-direction:column;align-items:flex-end;gap:10px;transition:opacity var(--dur-med) var(--ease-out-soft),transform var(--dur-med) var(--ease-out-soft)}.cv-corner.is-away .cv-minimap{display:none}.cv-corner.is-away .cv-zoomhud{flex-direction:column;padding:4px;animation:upIn var(--dur-med) var(--ease-out-soft) both}.cv-corner.is-away .cv-zoomhud button{width:28px}.cv-corner.is-away .cv-zoomhud .pct{min-width:0;padding:0;font-size:10px;letter-spacing:-.02em}.cv-corner.is-away .cv-zoomhud .sep{width:16px;height:1px;margin:3px 0}.cv-minimap{width:188px;height:124px;border-radius:14px;overflow:hidden;background:#0b0d14b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);position:relative;cursor:pointer;transform-origin:50% 50%;animation:upIn var(--dur-med) var(--ease-out-soft) both}.cv-minimap canvas{position:absolute;left:0;top:0;width:188px;height:124px;pointer-events:none}.cv-minimap .mm-view{position:absolute;border:1.5px solid var(--cv-accent);border-radius:3px;background:var(--cv-accent-tint);cursor:grab;pointer-events:none}.cv-minimap.is-going{animation:none;pointer-events:none;will-change:transform,opacity;transition:transform .46s cubic-bezier(.4,0,.2,1),opacity .46s cubic-bezier(.4,0,.2,1) .06s,border-radius .46s var(--ease-out-soft)}.mm-hide{position:absolute;top:6px;right:6px;z-index:2;width:20px;height:20px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid rgba(255,255,255,.1);border-radius:6px;background:#04030cb8;color:var(--fg-3);cursor:pointer;opacity:0;transform:translateY(-3px);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),color var(--dur-fast),background var(--dur-fast)}.cv-minimap:hover .mm-hide,.mm-hide:focus-visible{opacity:1;transform:none}.mm-hide:hover{background:#04030ceb;color:#fff}.cv-minimap.is-going .mm-hide{opacity:0}.cv-zoomhud{display:flex;align-items:center;gap:2px;padding:5px;border-radius:var(--radius-sm);background:#121521b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px)}.cv-zoomhud button{height:28px;min-width:28px;border:0;border-radius:7px;padding:0;background:transparent;color:var(--fg-3);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-zoomhud button:hover{background:#ffffff12;color:var(--fg-1)}.cv-zoomhud .pct{padding:0 6px;min-width:46px}.cv-zoomhud .sep{width:1px;height:16px;margin:0 3px;background:var(--hairline-soft);flex:none}.cv-zoomhud .mm-slot:disabled{cursor:default}.cv-zoomhud .mm-slot.is-landing{animation:mmLand .5s cubic-bezier(.16,1,.3,1) .26s both}@keyframes mmLand{0%{transform:scale(.5);color:var(--fg-4)}45%{transform:scale(1.18);color:var(--cv-accent-soft)}to{transform:none;color:var(--fg-3)}}.cv-ctxbar{position:absolute;z-index:45;display:flex;align-items:center;gap:2px;padding:5px;border-radius:12px;background:#121521d1;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);white-space:nowrap}@media(prefers-reduced-motion:no-preference){.cv-ctxbar{animation:ctxIn .3s var(--ease-out-soft) both}@keyframes ctxIn{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}}.cv-ctxbar .sep{width:1px;height:18px;background:var(--hairline-soft);margin:0 4px;flex:none}.cv-ctxbar button{width:30px;height:30px;border:0;border-radius:8px;padding:0;background:transparent;color:var(--fg-3);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;position:relative;transition:background var(--dur-fast),color var(--dur-fast)}.cv-ctxbar button:hover{background:#ffffff14;color:var(--fg-1)}.cv-ctxbar button.danger:hover{background:#ff5c7a24;color:var(--danger)}.cv-ctxbar .swatch{width:14px;height:14px;border-radius:5px;border:1px solid rgba(255,255,255,.25);transition:box-shadow var(--dur-fast)}.cv-ctxbar button.is-swatch{width:26px}.cv-ctxbar button.is-swatch.on .swatch{box-shadow:0 0 0 2px var(--bg-deep),0 0 0 3.5px #ffffffbf}.cv-ctxbar .swatch.tint-amethyst{background:#9968df8c}.cv-ctxbar .swatch.tint-vista{background:#5a61ed99}.cv-ctxbar .swatch.tint-sky{background:#3db4e68c}.cv-ctxbar .swatch.tint-mint{background:#34c79a8c}.cv-ctxbar .swatch.tint-amber{background:#f0b44a8c}.cv-ctxbar .swatch.tint-rose{background:#ec5b9a8c}.cv-ctxbar .swatch.tint-glass{background:#ffffff2e}.cv-ctxbar .tip{position:absolute;bottom:calc(100% + 9px);left:50%;transform:translate(-50%) translateY(4px);background:#0b0d14f0;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 9px;border-radius:8px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-ctxbar button:hover .tip{opacity:1;transform:translate(-50%) translateY(0);transition-delay:.26s}.cv-ctx-edit{display:inline-flex;align-items:center;gap:6px;width:auto!important;height:30px;padding:0 11px!important;border:0;border-radius:8px;background:var(--cv-accent-tint)!important;color:var(--fg-1)!important;font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.cv-ctx-edit:hover{background:#9968df4d!important}.cv-ctx-edit .swatch{width:12px;height:12px;border-radius:4px;border:1px solid rgba(255,255,255,.3)}.cv-ctx-info{display:inline-flex;align-items:center;gap:6px;width:auto!important;height:30px;padding:0 11px!important;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.cv-ctx-info:hover{background:#ffffff14;color:var(--fg-1)}.cv-ctx-info.is-locked{color:var(--fg-2)}.cv-ctxbar button.is-more.on{background:#ffffff14;color:var(--fg-1)}.cv-addmenu{position:absolute;left:50%;bottom:88px;transform:translate(-50%);width:312px;z-index:46;border-radius:var(--radius-md);background:#121521d9;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%);overflow:hidden}.am-view{will-change:transform,opacity}@media(prefers-reduced-motion:no-preference){.am-view.fwd{animation:amFwd .3s var(--ease-out-soft) both}.am-view.back{animation:amBack .3s var(--ease-out-soft) both}@keyframes amFwd{0%{opacity:0;transform:translate(28px)}to{opacity:1;transform:none}}@keyframes amBack{0%{opacity:0;transform:translate(-28px)}to{opacity:1;transform:none}}}.am-search{display:flex;align-items:center;gap:8px;margin:2px 12px 4px;padding:0 6px 0 11px;height:34px;border-radius:var(--radius-sm);background:#ffffff0b;border:1px solid var(--hairline-soft);box-shadow:inset 0 1px #ffffff0d;color:var(--fg-4);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.am-search:focus-within{border-color:var(--cv-accent-soft);box-shadow:0 0 0 3px var(--cv-accent-tint)}.am-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;font-family:var(--font-sans);font-size:12.5px;color:var(--fg-1);user-select:text;-webkit-user-select:text}.am-search input::placeholder{color:var(--fg-4)}.am-none{padding:14px 10px 12px;font-size:12px;color:var(--fg-4)}.am-rows{padding:4px 6px 8px;max-height:348px;overflow-y:auto}.am-rows::-webkit-scrollbar{width:8px}.am-rows::-webkit-scrollbar-thumb{background:#ffffff1a;border-radius:4px;border:2px solid transparent;background-clip:content-box}.am-eyebrow{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-5);padding:10px 10px 5px}.am-row{display:flex;align-items:center;gap:11px;width:100%;text-align:left;border:0;background:transparent;padding:8px 9px;border-radius:10px;cursor:pointer;transition:background var(--dur-fast)}.am-row:hover,.am-row.is-active{background:#ffffff0f}.am-row .cv-badge{width:32px;height:32px;border-radius:10px}.am-eyebrow.is-apart{margin:6px 4px 0;padding:12px 6px 5px;border-top:1px solid var(--hairline-soft)}.cv-badge.is-prompts{background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff}.am-main{flex:1;min-width:0}.am-name{font-size:13px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.am-sub{font-size:11px;color:var(--fg-4);margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.am-go{color:var(--fg-5);flex:none;transition:color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.am-row:hover .am-go{color:var(--fg-2);transform:translate(1px)}.am-searchrow{display:flex;align-items:center;gap:6px;padding:12px 10px 8px 12px}.am-searchrow .am-search{flex:1;min-width:0;margin:0}.am-close{flex:none;width:30px;height:30px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-4);cursor:pointer;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.am-close:hover{background:#ffffff14;color:var(--fg-1)}`, K8e = '.v2-root{--cv-fav: #ef5f7a;--chat-w: 80px;--set-w: 0px}.v2-root .cv-topbar{height:52px;padding:0 16px;gap:14px}.v2-root .cv-topbar-left{gap:11px}.v2-root .cv-topbar-right{gap:12px}.v2-root .cv-mark{width:31px;height:27px;border-radius:8px}.v2-root .cv-mark svg{width:25px}.v2-root .cv-crumb{font-size:12px}.v2-root .cv-board-title{font-size:13.5px}.v2-root.light-canvas{background:#f4f5f7}.v2-root.light-canvas .cv-topbar{background:#070910f0}.v2-root.light-canvas .rs,.v2-root.light-canvas .bd-siderail,.v2-root.light-canvas .v2-rail,.v2-root.light-canvas .cv-zoomhud{background:#121521f0}.v2-root.light-canvas .cv-atmo-glow,.v2-root.light-canvas .cv-atmo-orb-a,.v2-root.light-canvas .cv-atmo-orb-b{opacity:0}.v2-root.light-canvas .cv-grid{background-image:radial-gradient(rgba(12,16,30,.85) 1px,transparent 1.4px);opacity:calc(.14 * var(--cv-atmo))}.v2-root.light-canvas{--lc-ink: #131828;--lc-ink-2: rgba(19, 24, 40, .74);--lc-ink-3: rgba(19, 24, 40, .56);--lc-line: rgba(19, 24, 40, .14);--cv-guide: var(--amethyst-400);--cv-guide-halo: rgba(255, 255, 255, .55)}.v2-root.light-canvas .cv-frame-title{color:var(--lc-ink-2)}.v2-root.light-canvas .cv-frame-title .cv-frame-count{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-frame-title.is-selected{color:var(--amethyst-400)}.v2-root.light-canvas .cv-frame-title-input{color:var(--lc-ink);background:#fff;border-color:#7532d373;box-shadow:0 1px 2px #13182814}.v2-root.light-canvas .cv-frame-title .cv-frame-lock{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-frame-title.is-selected .cv-frame-lock{color:inherit}.v2-root.light-canvas .cv-minimap{background:#f4f5f7f5;border-color:var(--lc-line);box-shadow:0 1px 2px #13182814,0 18px 40px #1318281f}.v2-root.light-canvas .mm-hide{background:#fff;border-color:var(--lc-line);color:var(--lc-ink-2)}.v2-root.light-canvas .mm-hide:hover{background:#fff;color:var(--lc-ink)}.v2-root.light-canvas .cv-bucket{background:#fff;border-color:var(--lc-line);box-shadow:0 1px 2px #13182814,0 18px 40px #1318281a;backdrop-filter:none;-webkit-backdrop-filter:none}.v2-root.light-canvas .cv-el:hover .cv-bucket{box-shadow:0 1px 2px #13182814,0 26px 60px #13182829}.v2-root.light-canvas .cv-bucket-name{color:var(--lc-ink)}.v2-root.light-canvas .cv-bucket-kind,.v2-root.light-canvas .cv-bucket-foot{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-bucket-model,.v2-root.light-canvas .cv-bucket-sep{color:#1318286b}.v2-root.light-canvas .cv-count{color:var(--lc-ink-2);background:#1318280f;border-color:var(--lc-line)}.v2-root.light-canvas .cv-badge{background:#1318280d;box-shadow:inset 0 1px #fffc;color:var(--amethyst-400)}.v2-root.light-canvas .cv-thumb{border-color:#13182814}.v2-root.light-canvas .cv-thumb-empty{border-color:#13182824;background:#13182808}.v2-root.light-canvas .cv-note{box-shadow:0 1px 2px #13182814,0 16px 36px #1318281f;backdrop-filter:none;-webkit-backdrop-filter:none}.v2-root.light-canvas .cv-note.tint-glass{background:#fff;border-color:var(--lc-line)}.v2-root.light-canvas .cv-note.tint-amethyst{background:linear-gradient(180deg,#9968df33,#9968df1a);border-color:#9968df52}.v2-root.light-canvas .cv-note.tint-vista{background:linear-gradient(180deg,#5a61ed2e,#5a61ed17);border-color:#5a61ed4d}.v2-root.light-canvas .cv-note.tint-sky{background:linear-gradient(180deg,#3db4e633,#3db4e61a);border-color:#3db4e657}.v2-root.light-canvas .cv-note.tint-mint{background:linear-gradient(180deg,#34c79a33,#34c79a1a);border-color:#34c79a57}.v2-root.light-canvas .cv-note.tint-amber{background:linear-gradient(180deg,#f0b44a42,#f0b44a21);border-color:#d696285c}.v2-root.light-canvas .cv-note.tint-rose{background:linear-gradient(180deg,#ec5b9a2e,#ec5b9a17);border-color:#ec5b9a52}.v2-root.light-canvas .cv-note-text{color:var(--lc-ink)}.v2-root.light-canvas .cv-note-meta{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-img-label{color:#fff;text-shadow:0 1px 6px rgba(4,3,12,.85)}.v2-root.light-canvas .cv-marquee{border-color:#7532d38c;background:#7532d31a}.v2-stage{left:0!important;top:52px!important;right:var(--set-w)!important}.v2-root .cv-corner{right:calc(18px + var(--set-w))}.v2-railwrap{position:absolute;left:var(--chat-w);right:var(--set-w);bottom:22px;z-index:41;pointer-events:none;display:flex;align-items:center;justify-content:center;gap:10px;transition:left var(--dur-med) var(--ease-out-soft),right var(--dur-med) var(--ease-out-soft),opacity var(--dur-med) var(--ease-out-soft),transform var(--dur-med) var(--ease-out-soft)}.v2-railwrap>*{pointer-events:auto}.v2-railwrap.is-away{opacity:0;transform:translateY(18px)}.v2-railwrap.is-away>*{pointer-events:none}.v2-addtool{height:32px;flex:none;position:relative;display:inline-flex;align-items:stretch;border-radius:9px;overflow:hidden;background:var(--grad-cta);color:#fff;box-shadow:0 5px 14px #745aff47,inset 0 1px #ffffff2e;transition:box-shadow var(--dur-med)}.v2-addtool.on{box-shadow:0 5px 14px #745aff47,inset 0 1px #ffffff38,0 0 0 3px var(--cv-accent-tint)}.v2-addtool>button{border:0;background:transparent;color:inherit;cursor:pointer;display:inline-flex;align-items:center;font-family:var(--font-sans);transition:background var(--dur-fast)}.v2-addtool>button:hover{background:#ffffff24}.v2-addtool .main{gap:6px;padding:0 9px 0 10px;font-size:12px;font-weight:600;letter-spacing:-.01em}.v2-addtool .chev{padding:0 7px;box-shadow:inset 1px 0 #ffffff38}.v2-addtool .chev .licon{transition:transform var(--dur-med) var(--ease-out-soft)}.v2-addtool.on .chev .licon{transform:rotate(180deg)}.v2-rail{position:relative;display:flex;flex-direction:row;align-items:center;gap:2px;padding:5px;border-radius:13px;background:#121521b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}.v2-rail .sep{width:1px;height:18px;background:var(--hairline-soft);margin:auto 4px}.cv-addmenu.at-rail{left:calc(var(--chat-w) + (100vw - var(--chat-w) - var(--set-w)) / 2);right:auto;top:auto;bottom:74px;transform:translate(-50%)}@media(prefers-reduced-motion:no-preference){.cv-addmenu.at-rail{animation:amInRail .35s var(--ease-out-soft) both}@keyframes amInRail{0%{opacity:0;transform:translate(-50%) translateY(12px)}to{opacity:1;transform:translate(-50%) translateY(0)}}}.v2-uprompt{position:absolute;left:var(--chat-w);right:var(--set-w);bottom:20px;z-index:70;pointer-events:none;display:flex;flex-direction:column;align-items:center;animation:upIn var(--dur-med) var(--ease-out-soft) both;transition:left var(--dur-med) var(--ease-out-soft),right var(--dur-med) var(--ease-out-soft)}.v2-uprompt>*{pointer-events:auto}.v2-root.hist-rail .v2-uprompt{right:calc(var(--set-w) + 368px)}.v2-root.board-hist .v2-uprompt{right:calc(var(--set-w) + 398px)}@keyframes upIn{0%{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}.up-card{position:relative;z-index:5;width:min(720px,100%);display:grid;grid-template-columns:30px minmax(0,1fr);gap:10px 12px;padding:11px 12px;border-radius:18px;border:1px solid rgba(255,255,255,.055);background:#0b0d15fb;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0b,0 2px 8px #02040c66,0 30px 80px #02040c9e;transition:box-shadow var(--dur-med) var(--ease-out-soft),border-color var(--dur-med)}.up-card:focus-within{border-color:#ffffff17}.up-card.is-fresh{animation:upFresh 2.2s var(--ease-out-soft) infinite}@keyframes upFresh{0%,to{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #9968df73,0 0 0 4px #9968df1a,0 30px 80px #02040c9e}50%{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #9968dfbf,0 0 0 7px #9968df29,0 30px 80px #02040c9e}}@media(prefers-reduced-motion:reduce){.up-card.is-fresh{animation:none;box-shadow:0 0 0 1px #9968df99,0 30px 80px #02040c9e}}.up-card.is-nudge{animation:upNudge .42s var(--ease-out-soft)}.up-card.is-nudge .up-run-wrap .tip{opacity:1}@keyframes upNudge{0%,to{translate:0 0}20%{translate:-6px 0}40%{translate:5px 0}60%{translate:-3px 0}80%{translate:2px 0}}@media(prefers-reduced-motion:reduce){.up-card.is-nudge{animation:none}}.up-side{grid-column:1;grid-row:1 / span 2;display:flex;flex-direction:column;align-items:center;gap:7px}.up-card.has-refs .up-side{grid-row:1 / span 3}.up-card.has-refs .up-text,.up-card.has-refs .up-ghost,.up-card.has-refs .up-cue{grid-row:2}.up-card.has-refs .up-foot{grid-row:3}.up-side-btn{width:30px;height:30px;flex:none;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-4);cursor:pointer;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.up-side-btn:hover{background:#ffffff0f;color:var(--fg-2)}.up-side-btn.on{background:var(--cv-accent-tint);color:var(--cv-accent-soft)}.up-side-btn .badge{position:absolute;margin:-18px 0 0 18px;min-width:14px;height:14px;padding:0 4px;border-radius:999px;background:var(--cv-accent);color:#fff;font-size:9px;font-weight:700;line-height:14px}.up-text{grid-column:2;grid-row:1;width:100%;min-height:70px;resize:none;overflow-y:auto;box-sizing:border-box;border:0;background:transparent;padding:4px 0 0;color:var(--fg-1);font-family:var(--font-sans);font-size:13.5px;line-height:1.55;letter-spacing:-.005em;outline:none;text-wrap:pretty;user-select:text;-webkit-user-select:text}textarea.up-text{min-height:0}.up-text::placeholder{color:var(--fg-4)}.up-grip{position:absolute;top:-9px;left:12px;z-index:3;width:30px;height:18px;display:flex;align-items:center;justify-content:center;cursor:ns-resize;touch-action:none;outline:none}.up-grip i{display:block;width:22px;height:4px;border-radius:999px;background:#ffffff29;box-shadow:0 0 0 1px #04030ca6;transition:background var(--dur-fast),width var(--dur-fast) var(--ease-out-soft)}.up-card:hover .up-grip i{background:#ffffff4d}.up-grip:hover i,.up-grip.is-on i,.up-grip:focus-visible i{width:28px;background:#ffffffa6}.up-grip:focus-visible i{box-shadow:0 0 0 1px #04030ca6,0 0 0 3px #a3a7f58c}.up-card.is-resizing,.up-card.is-resizing *{cursor:ns-resize!important;user-select:none}.up-text::-webkit-scrollbar{width:6px}.up-text::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.up-drop{width:56px;height:56px;flex:none;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px dashed rgba(255,255,255,.2);border-radius:12px;background:#ffffff08;color:var(--fg-4);cursor:pointer;transition:border-color var(--dur-fast),color var(--dur-fast),background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.up-drop:hover,.up-drop.is-target{border-color:var(--cv-accent-soft);color:var(--cv-accent-soft);background:var(--cv-accent-tint)}.up-drop.is-target{transform:scale(1.06);border-style:solid}.up-refs{grid-column:2;grid-row:1;display:flex;flex-wrap:wrap;gap:6px;align-items:flex-start}.up-ref{position:relative;width:56px;height:56px;border-radius:12px;flex:none;background-size:cover;background-position:center;background-color:#ffffff0d;box-shadow:inset 0 0 0 1px #ffffff1f;animation:refIn .32s var(--ease-out-soft) both}@keyframes refIn{0%{opacity:0;transform:scale(.85)}to{opacity:1;transform:none}}.up-ref.is-target{box-shadow:inset 0 0 0 2px var(--cv-accent-text)}.up-ref button{position:absolute;top:-6px;right:-6px;width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:#0b0d15f0;color:var(--fg-3);cursor:pointer;box-shadow:0 4px 12px #02040c99;transition:color var(--dur-fast);opacity:0}.up-ref:hover button,.up-ref button:focus-visible{opacity:1}.up-ref button:hover{color:#fff}.up-ref .lbl{position:absolute;left:4px;right:4px;bottom:4px;padding:1px 5px;border-radius:6px;background:#04030cb3;color:var(--fg-2);font-size:8.5px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.up-drop.is-dropper{border-style:solid;border-color:var(--cv-accent-soft);color:var(--cv-accent-text);background:var(--cv-accent-tint)}.up-ref.is-dropper{box-shadow:inset 0 0 0 2px var(--cv-accent-soft)}.up-ref-pulse{position:absolute;inset:0;border-radius:inherit;pointer-events:none;animation:upPulse .9s var(--ease-out-soft) both}@keyframes upPulse{0%{box-shadow:inset 0 0 0 2px #ffffffe6,0 0 #9968df99}to{box-shadow:inset 0 0 0 2px #fff0,0 0 0 10px #9968df00}}@media(prefers-reduced-motion:reduce){.up-ref-pulse{animation:none}}.up-ref-glow{position:absolute;inset:0;border-radius:inherit;pointer-events:none;animation:upGlowBreathe 1.25s ease-in-out infinite alternate,upGlowLife 5s linear both}@keyframes upGlowBreathe{0%{box-shadow:inset 0 0 0 1.5px #c4a2ff80,0 0 6px 1px #9968df33}to{box-shadow:inset 0 0 0 1.5px #c4a2ffd9,0 0 18px 4px #9968df6b}}@keyframes upGlowLife{0%{opacity:0}8%{opacity:1}76%{opacity:1}to{opacity:0}}@media(prefers-reduced-motion:reduce){.up-ref-glow{animation:upGlowLife 5s linear both;box-shadow:inset 0 0 0 1.5px #c4a2ffb3,0 0 10px 2px #9968df4d}}.up-ref-peek{position:absolute;bottom:calc(100% + 12px);z-index:8;transform:translate(-50%);border-radius:12px;overflow:hidden;pointer-events:none;background:#ffffff0a;box-shadow:0 0 0 1px #ffffff24,0 24px 60px #02040cb8;animation:upPeek .18s var(--ease-out-soft) both}.up-ref-peek img{display:block;max-width:320px;max-height:320px}.up-ref-peek .n{position:absolute;left:8px;top:8px;padding:2px 8px;border-radius:999px;background:#04030cb3;color:#fff;font-size:10.5px;font-weight:600}@keyframes upPeek{0%{opacity:0;transform:translate(-50%) translateY(6px) scale(.96)}to{opacity:1;transform:translate(-50%)}}@media(prefers-reduced-motion:reduce){.up-ref-peek{animation:none}}.up-foot{grid-column:2;grid-row:2;display:flex;align-items:flex-end;gap:7px;min-width:0}.up-chips{display:flex;align-items:center;gap:6px;row-gap:6px;flex:1;min-width:0;overflow:visible;flex-wrap:wrap}.up-chip-wrap{position:relative;display:inline-flex;min-width:0}.up-chip{display:inline-flex;align-items:center;gap:6px;max-width:190px;height:30px;padding:0 11px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff0d;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.up-chip:hover{background:#ffffff17;color:var(--fg-1)}.up-chip.on{border-color:var(--cv-accent-soft);color:var(--fg-1);background:var(--cv-accent-tint)}.up-chip .licon{flex:none;color:var(--fg-4)}.up-chip.on .licon{color:var(--cv-accent-soft)}.up-chip .t{min-width:0;overflow:hidden;text-overflow:ellipsis}.up-cog{flex:none;width:24px;height:30px;padding:0;border:0;background:none;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;color:var(--fg-4);transition:color var(--dur-fast)}.up-cog:hover,.up-cog.on{color:var(--fg-1)}.up-chip.is-locked{cursor:default;background:#ffffff06;border-style:dashed;color:var(--fg-4)}.up-chip.is-locked:hover{background:#ffffff0a;color:var(--fg-3)}.up-chip .lk{flex:none;margin-left:-2px;color:var(--fg-4);opacity:.8}.up-count-wrap{position:relative;flex:none;display:inline-flex}.up-count{display:inline-flex;align-items:center;gap:3px;height:30px;padding:0 6px 0 9px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);cursor:pointer;font-family:var(--font-sans);font-size:12px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast)}.up-count:hover:not(:disabled),.up-count.on{background:#ffffff0d;color:var(--fg-1)}.up-count .chev{color:var(--fg-4);opacity:.85;transition:transform .22s var(--ease-out-soft),color var(--dur-fast)}.up-count:hover .chev,.up-count.on .chev{color:var(--fg-2)}.up-count.on .chev{transform:rotate(180deg)}.up-count:disabled{cursor:default;color:var(--fg-3)}.up-count:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:1px}.up-count.is-tall{height:40px;padding:0 9px 0 12px;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff08}.up-count.is-tall:hover:not(:disabled),.up-count.is-tall.on{background:#ffffff0f}.up-count-pop .sv-pop-row{font-variant-numeric:tabular-nums}.up-count-pop .sv-pop-row:focus-visible{outline:none;background:#ffffff0f;color:var(--fg-1)}.up-count-pop .ck{margin-left:auto;color:var(--cv-accent-text)}@media(prefers-reduced-motion:reduce){.up-count .chev{transition:none}}.up-run{flex:none;height:30px;padding:0 17px;display:inline-flex;align-items:center;gap:7px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:12.5px;font-weight:600;letter-spacing:-.01em;cursor:pointer;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e;transition:filter var(--dur-fast),box-shadow var(--dur-med),transform var(--dur-fast) var(--ease-out-soft);position:relative}.up-run:hover{filter:brightness(1.08);box-shadow:0 9px 24px #745aff61,inset 0 1px #ffffff38}.up-run:active:not(:disabled){transform:scale(.97)}.up-run:disabled{cursor:default;filter:none;background:#ffffff12;color:var(--fg-4);box-shadow:none}.up-run:disabled:hover{filter:none;box-shadow:none}.up-run:disabled.is-busy{background:var(--grad-cta);color:#fff;opacity:.72}.up-run.is-get{background:linear-gradient(135deg,#ff9a6b,#f2668b);box-shadow:0 6px 18px #f2668b47,inset 0 1px #fff3}.up-run.is-get .licon{color:#fff}.up-run-wrap .tip{position:absolute;bottom:calc(100% + 9px);right:0;width:max-content;max-width:300px;background:#0b0d14f0;border:1px solid var(--hairline-soft);line-height:1.4;text-align:left;color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 9px;border-radius:8px;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.up-run-wrap{position:relative;display:inline-flex}.up-run-wrap:hover .tip{opacity:1}.up-cost{flex:none;display:inline-flex;align-items:baseline;gap:4px;margin-left:1px;white-space:nowrap;color:var(--fg-4);font-size:11px;font-weight:500;font-variant-numeric:tabular-nums}.up-cost .licon{color:var(--fg-5);align-self:center}.up-note{flex:none;display:inline-flex;align-items:center;gap:5px;height:30px;white-space:nowrap;color:var(--fg-4);font-size:11px;font-weight:500}.up-note .licon{color:var(--fg-5)}.up-model-wrap{min-width:0;flex:0 1 auto;align-items:baseline}.up-model{display:inline-flex;align-items:baseline;gap:7px;min-width:0;max-width:240px;height:30px;padding:0 8px;margin-left:-6px;border:0;border-radius:8px;background:transparent;color:var(--fg-1);font-family:var(--font-sans);cursor:pointer;line-height:30px;transition:background var(--dur-fast)}.up-model:hover,.up-model.on{background:#ffffff0d}.up-model .lb{flex:none;font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.up-model .nm{min-width:0;font-size:12.5px;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.up-model .licon{flex:none;align-self:center;color:var(--fg-4)}.up-foot-sep{flex:none;width:1px;height:18px;margin:0 3px;background:var(--hairline-soft)}.up-pop{position:absolute;bottom:calc(100% + 8px);left:0;min-width:190px;z-index:6;display:flex;flex-direction:column;gap:2px;padding:7px;border:1px solid var(--hairline);border-radius:14px;background:#11131ef5;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);box-shadow:var(--inset-highlight),var(--shadow-deep);animation:upIn var(--dur-fast) var(--ease-out-soft) both;max-height:min(420px,60vh);overflow-y:auto}.up-pop::-webkit-scrollbar{width:6px}.up-pop::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.up-pop.is-wide{min-width:320px}.up-pop-label{padding:3px 6px 6px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.2em;color:var(--fg-4)}.up-pop-search{display:flex;align-items:center;gap:7px;margin:0 2px 6px;height:30px;padding:0 9px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0a;color:var(--fg-4)}.up-pop-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-size:12px;user-select:text;-webkit-user-select:text}.up-pop-row{display:flex;align-items:center;gap:8px;width:100%;padding:7px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast);flex:none}.up-pop-row:hover{background:#ffffff12;color:var(--fg-1)}.up-pop-row.on{background:var(--cv-accent-tint);color:var(--fg-1)}.up-pop-main{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.up-pop-meta{flex:none;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.up-pop-slider{display:flex;align-items:center;gap:10px;min-width:220px;padding:2px 6px 6px}.up-pop-slider .up-adv-num{flex:none;width:58px}.up-pop-avatar{width:24px;height:24px;flex:none;border-radius:7px;background-size:cover;background-position:center;background-color:#ffffff0f}.up-pop-item{position:relative;flex:none}.up-pop-item .up-pop-row{padding-right:38px}.up-pop-item:hover .up-pop-row{background:#ffffff12;color:var(--fg-1)}.up-pop-item:hover .up-pop-row.on{background:var(--cv-accent-tint)}.up-pop-pin{position:absolute;right:5px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.up-pop-item:hover .up-pop-pin,.up-pop-pin.on,.up-pop-pin:focus-visible{opacity:1}.up-pop-pin:hover{background:#ffffff17;color:#fff}.up-pop-pin.on{color:var(--cv-accent-text)}.up-pop-pin.on svg{fill:currentColor}.up-pop-empty{padding:10px 8px 12px;font-size:12px;line-height:1.45;color:var(--fg-4)}.up-modelpick{width:320px}.up-modelpick-row{padding-top:6px;padding-bottom:6px}.up-modelpick-av{width:32px;height:32px;flex:none;display:inline-flex;align-items:center;justify-content:center;border-radius:8px;object-fit:cover;background:#ffffff0f;color:var(--fg-4)}.up-modelpick-av.is-none{background:transparent;border:1px dashed var(--hairline)}.up-modelpick-desc{display:block;margin-top:1px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;font-weight:400;color:var(--fg-4)}.up-modelpick-group{padding:8px 6px 4px;font-size:10px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-5)}.up-modelpick-note{display:flex;align-items:center;gap:8px;padding:8px 8px 10px;font-size:12px;line-height:1.45;color:var(--fg-4)}.up-influence{width:260px;gap:8px;padding:9px 12px 12px}.up-influence .up-pop-label{padding:3px 0 2px}.up-influence-ends{display:flex;align-items:flex-end;justify-content:space-between;height:22px;color:var(--fg-2);font-weight:600;font-variant-numeric:tabular-nums}.up-influence-ends span{display:inline-flex;align-items:center;gap:5px;transition:font-size var(--dur-fast)}.up-influence-ends .licon{color:var(--fg-4)}.up-influence .up-range{width:100%;margin:4px 0 2px}.up-chip .av{width:20px;height:20px;flex:none;margin-left:-6px;border-radius:50%;object-fit:cover;box-shadow:0 0 0 1px #ffffff14}.up-pop-tabs{display:flex;flex-wrap:wrap;gap:4px;margin:0 2px 6px;flex:none}.up-pop-tabs button{flex:none;height:24px;padding:0 9px;border-radius:999px;border:1px solid var(--hairline-soft);background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.up-pop-tabs button:hover{color:var(--fg-1);background:#ffffff0d}.up-pop-tabs button.on{color:var(--fg-1);background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.up-pop-badge{display:inline-flex;align-items:center;height:16px;padding:0 6px;margin-left:6px;border-radius:999px;vertical-align:1px;font-size:9.5px;font-weight:600;letter-spacing:.02em;color:var(--fg-3);background:#ffffff12}.up-pop-badge.is-popular{color:#ffb38a;background:#ff8c5a24}.up-adv{position:relative;width:min(360px,100%);margin-bottom:10px;z-index:4;display:flex;flex-direction:column;gap:16px;padding:16px;border:1px solid rgba(255,255,255,.055);border-radius:18px;background:#0b0d15fb;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0b,0 2px 8px #02040c66,0 30px 80px #02040c9e;animation:upIn var(--dur-med) var(--ease-out-soft) both;max-height:calc(100vh - 290px);overflow-y:auto}.up-adv::-webkit-scrollbar{width:6px}.up-adv::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.up-adv-head{display:flex;align-items:center;gap:6px}.up-adv-title{flex:1;font-size:14px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.up-adv-field{display:flex;flex-direction:column;gap:9px;min-width:0;margin:0;padding:0;border:0}.up-adv-field.is-locked>:not(.up-adv-label):not(.up-adv-why){opacity:.45;pointer-events:none}.up-adv-why{display:flex;align-items:flex-start;gap:6px;margin-top:-3px;font-size:11px;line-height:1.45;color:var(--fg-4)}.up-adv-why .licon{flex:none;margin-top:2px}.up-adv-label{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:500;color:var(--fg-2)}.up-adv-label .licon{color:var(--fg-4)}.up-adv-label .req{color:var(--cv-accent-text)}.up-adv-hint{font-size:11px;line-height:1.45;color:var(--fg-4)}.up-adv-row{display:flex;align-items:center;gap:10px}.up-range{flex:1;min-width:0;height:4px;-webkit-appearance:none;appearance:none;border-radius:999px;background:#ffffff1f;outline:none}.up-range::-webkit-slider-thumb{-webkit-appearance:none;width:13px;height:13px;border-radius:50%;background:#fff;box-shadow:0 2px 6px #02061780;cursor:pointer}.up-range::-moz-range-thumb{width:13px;height:13px;border:0;border-radius:50%;background:#fff;cursor:pointer}.up-adv-num{width:64px;flex:none;height:30px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;text-align:center;outline:none;font-variant-numeric:tabular-nums;user-select:text;-webkit-user-select:text}.up-adv-num.is-full{width:100%;text-align:left;padding:0 10px}.up-adv-num:focus{border-color:var(--cv-accent-soft)}textarea.up-adv-num{height:auto;min-height:62px;padding:8px 10px;line-height:1.5;resize:vertical;text-align:left}.up-seg{display:inline-flex;flex-wrap:wrap;gap:2px;padding:2px;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff08;align-self:flex-start}.up-seg button{height:26px;padding:0 12px;border:1px solid transparent;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.up-seg button:hover{color:var(--fg-1)}.up-seg button.on{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:var(--fg-1)}.up-toggle{position:relative;width:32px;height:18px;border-radius:999px;border:0;padding:0;cursor:pointer;background:#ffffff24;transition:background var(--dur-fast)}.up-toggle:after{content:"";position:absolute;left:2px;top:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 2px 6px #02061766;transition:transform var(--dur-fast) var(--ease-out-soft)}.up-toggle.on{background:var(--cv-accent)}.up-toggle.on:after{transform:translate(14px)}.up-error{display:flex;align-items:flex-start;gap:8px;width:min(720px,100%);margin-bottom:8px;padding:9px 12px;border-radius:12px;font-size:12px;line-height:1.45;background:#ff5c7a1a;border:1px solid rgba(255,92,122,.28);color:#ffb3c1;animation:upIn var(--dur-med) var(--ease-out-soft) both}.up-error .licon{margin-top:1px}.up-error button{margin-left:auto;border:0;background:transparent;color:inherit;cursor:pointer;padding:0;opacity:.7}.up-error button:hover{opacity:1}.v2-hist{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:300px;display:flex;flex-direction:column;padding:12px;border-radius:18px;background:#0b0d15f7;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 28px 80px #02040c99;pointer-events:auto;animation:histIn .26s var(--ease-out-soft) both}@keyframes histIn{0%{opacity:0;transform:translate(16px)}to{opacity:1;transform:none}}.v2-hist-head{flex:none;display:flex;align-items:center;gap:8px;margin-bottom:6px}.v2-hist-head .n{flex:none;padding:2px 7px;border-radius:999px;background:#ffffff0f;color:var(--fg-2);font-size:10px;font-weight:600;font-variant-numeric:tabular-nums}.v2-hist-head .t{min-width:0;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-hist-close{margin-left:auto;flex:none;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:8px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-hist-close:hover{background:#ffffff17;color:var(--fg-1)}.v2-hist-hint{flex:none;margin-bottom:9px;font-size:10px;line-height:1.4;color:var(--fg-5)}.v2-hist-open{position:absolute;z-index:46;top:66px;right:68px;display:inline-flex;align-items:center;gap:6px;height:32px;padding:0 11px;border-radius:11px;border:1px solid var(--hairline);background:#0b0d15f0;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);box-shadow:var(--inset-highlight),0 18px 44px #02040c80;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;animation:histIn .26s var(--ease-out-soft) both}.v2-hist-open:hover{background:#161926f5;color:#fff}.v2-hist-grid{flex:1;min-height:0;overflow-y:auto;padding-right:2px;position:relative;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.v2-hist-grid::-webkit-scrollbar{width:5px}.v2-hist-grid::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.v2-hist-item{position:absolute}.v2-hist-item .shot{position:absolute;inset:0;padding:0;border:0;border-radius:10px;background:transparent;cursor:pointer;outline:none}.v2-hist-item .art{position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff12;transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft);background-color:#ffffff0a;background-size:cover;background-position:center}.v2-hist-item:hover .art{transform:translateY(-2px);box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft),0 12px 28px #02040c80}.v2-hist-item.is-on .art{box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.v2-hist-item.is-new .art{animation:thumbIn .55s var(--ease-out-soft) both}.v2-hist-item.is-pending .art{overflow:hidden}.v2-hist-item.is-pending .art:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.v2-hist-item.is-failed .art{display:flex;align-items:center;justify-content:center;color:#ff8aa0;background:#ff5c7a14;box-shadow:inset 0 0 0 1px #ff5c7a40}.v2-hist-acts{position:absolute;right:10px;bottom:10px;z-index:3;display:flex;align-items:center;gap:6px}.v2-hist-acts button{height:28px;border:1px solid rgba(255,255,255,.18);border-radius:999px;background:#04030cb8;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);color:#fff;font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast);position:relative}.v2-hist-acts .find{width:28px;display:inline-flex;align-items:center;justify-content:center;padding:0}.v2-hist-acts button:hover{background:var(--cv-accent);border-color:transparent}.v2-hist-acts .tip{position:absolute;bottom:calc(100% + 8px);left:50%;transform:translate(-50%);background:#0b0d14f0;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:10.5px;font-weight:500;padding:4px 8px;border-radius:7px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.v2-hist-acts button:hover .tip{opacity:1}.v2-hist-pop{position:absolute;right:calc(100% + 12px);z-index:6;border-radius:14px;pointer-events:auto;box-shadow:0 28px 70px #02040cc2;animation:histPop .22s var(--ease-out-soft) both}@keyframes histPop{0%{opacity:0;transform:translate(10px) scale(.94)}to{opacity:1;transform:none}}.v2-hist-pop:after{content:"";position:absolute;right:-14px;top:0;bottom:0;width:14px}.v2-hist-pop .art{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;cursor:pointer;border-radius:14px;box-shadow:inset 0 0 0 1px #ffffff1f;background-color:#ffffff0a;background-size:cover;background-position:center}.v2-hist-pop .art-vid{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:14px;pointer-events:none;opacity:0;transition:opacity .22s var(--ease-out-soft)}.v2-hist-pop .art-vid.is-shown{opacity:1}.v2-hist-pop .cap{position:absolute;left:0;right:0;bottom:0;display:flex;align-items:center;gap:8px;padding:30px 112px 15px 13px;pointer-events:none;border-radius:0 0 14px 14px;background:linear-gradient(180deg,#04030c00,#04030ce0 64%)}.v2-hist-pop .cap .n{flex:1;min-width:0;font-size:11.5px;font-weight:600;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-hist-pop .cap .m{flex:none;display:inline-flex;align-items:center;gap:4px;font-size:10.5px;font-weight:600;color:#ffffffb8}.v2-hist-vid,.v2-hist-fav{position:absolute;top:5px;display:inline-flex;align-items:center;gap:2px;height:14px;padding:0 5px;border-radius:999px;background:#04030cb3;font-size:7.5px;font-weight:700;letter-spacing:.02em}.v2-hist-vid{right:5px;color:#fff}.v2-hist-fav{left:5px;padding:0 4px;color:var(--cv-fav)}.v2-hist-fav svg{fill:currentColor}.v2-hist-empty{padding:30px 12px;text-align:center;font-size:11.5px;line-height:1.5;color:var(--fg-4)}.v2-hist-time{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:1;font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums;letter-spacing:.02em;color:#ffffff9e;pointer-events:none}.v2-hist-item.is-withheld .art{display:flex;align-items:center;justify-content:center;background:radial-gradient(120% 90% at 30% 20%,#9968df38,#ffffff08 70%);box-shadow:inset 0 0 0 1px #ffffff14}.v2-hist-withheld{display:inline-flex;flex-direction:column;align-items:center;gap:5px;font-size:9.5px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:var(--fg-4)}.v2-hist-more{display:flex;justify-content:center;padding:10px 0 14px}.tl-ghost{position:fixed;z-index:95;pointer-events:none;width:132px;height:92px;border-radius:10px;background-size:cover;background-position:center;background-color:#ffffff0f;border:1px solid rgba(255,255,255,.22);box-shadow:0 24px 60px #02061799;opacity:.9;transform:translate(-50%,-50%) rotate(-2deg);transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.tl-ghost.is-ref{box-shadow:0 0 0 2px var(--cv-accent-text),0 18px 44px #02040c99;transform:translate(-50%,-50%) rotate(0) scale(.86)}.v2-info{position:fixed;inset:0;z-index:90;display:flex;align-items:center;justify-content:center;padding:28px 64px;background:#04030cc7;backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);animation:infoIn .22s var(--ease-out-soft) both}@keyframes infoIn{0%{opacity:0}to{opacity:1}}.v2-info-shell{display:grid;grid-template-columns:minmax(0,1fr) 372px;gap:26px;width:min(1440px,100%);height:min(88vh,960px);animation:infoShell .32s var(--ease-out-soft) both}@keyframes infoShell{0%{opacity:0;transform:translateY(10px) scale(.99)}to{opacity:1;transform:none}}.v2-info-stage{position:relative;min-width:0;display:flex;align-items:center;justify-content:center;border-radius:18px;background:#ffffff08;border:1px solid var(--hairline-soft);overflow:hidden}.v2-info-art{display:block;border-radius:12px;object-fit:cover;box-shadow:0 30px 100px #0206178c;transition:transform .25s var(--ease-out-soft),opacity .3s ease;max-width:none}.v2-info-art.is-loading{opacity:0}.v2-info-play{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:60px;height:60px;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:0;cursor:pointer;background:#04030c99;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#fff;transition:transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast)}.v2-info-play:hover{transform:translate(-50%,-50%) scale(1.06);background:#04030cbf}span.v2-info-play{cursor:default;pointer-events:none}.v2-info-art.is-video{background:#000}.v2-info-zoom{position:absolute;left:50%;bottom:16px;transform:translate(-50%);display:flex;align-items:center;gap:2px;padding:4px;border-radius:999px;background:#04030c9e;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid rgba(255,255,255,.1);color:#fffc}.v2-info-zoom button,.v2-info-zoom span{width:28px;height:26px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:999px;background:transparent;color:inherit;cursor:pointer}.v2-info-zoom button:hover{background:#ffffff1a;color:#fff}.v2-info-zoom span{color:#ffffff80;cursor:default;width:auto;padding:0 6px;font-size:11px;font-weight:600;font-variant-numeric:tabular-nums}.v2-info-nav{position:absolute;top:50%;transform:translateY(-50%);width:42px;height:42px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:transparent;color:#fff9;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-info-nav:hover{background:#ffffff14;color:#fff}.v2-info-nav:disabled{opacity:.25;cursor:default}.v2-info-nav.at-left{left:12px}.v2-info-nav.at-right{right:12px}.v2-info-side{min-width:0;display:flex;flex-direction:column;gap:14px;overflow-y:auto}.v2-info-side::-webkit-scrollbar{width:6px}.v2-info-side::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.v2-info-top{flex:none;display:flex;align-items:center;gap:9px}.v2-info-mail{flex:1;min-width:0;font-size:12.5px;font-weight:500;color:var(--fg-2);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-act{flex:none;width:30px;height:30px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:50%;background:#ffffff0d;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-info-act:hover{background:#ffffff1c;color:#fff}.v2-info-act.is-danger:hover{color:#ff8aa0}.v2-info-act.is-confirming{width:auto;padding:0 11px 0 9px;gap:5px;border-radius:999px;color:#fff;background:#ff5c7a38;border-color:#ff5c7a73}.v2-info-confirm{font-size:11.5px;font-weight:600}.v2-info-avatar{width:26px;height:26px;border-radius:50%;flex:none;display:flex;align-items:center;justify-content:center;font-size:9.5px;font-weight:700;color:#fff;letter-spacing:.02em;background:var(--grad-cta)}.v2-info-card{flex:none;display:flex;flex-direction:column;gap:14px;padding:14px;border-radius:20px;background:linear-gradient(180deg,#ffffff12,#ffffff06);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card)}.v2-info-card.is-record{flex:0 1 auto;min-height:0}.v2-info-scroll{flex:0 1 auto;min-height:0;display:flex;flex-direction:column;gap:14px;overflow-y:auto;margin:0 -6px;padding:0 6px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.v2-info-scroll.is-more{-webkit-mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent);mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent)}.v2-info-acts{flex:none;display:flex;flex-direction:column;gap:14px}.v2-info-strip{display:flex;align-items:center;gap:10px}.v2-info-strip .n{display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:600;color:var(--fg-3);font-variant-numeric:tabular-nums}.v2-info-strip .when{flex:1;font-size:11.5px;color:var(--fg-3);font-variant-numeric:tabular-nums;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-star{flex:none;width:26px;height:26px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.v2-info-star:hover{color:var(--fg-2);background:#ffffff0f}.v2-info-star.on{color:var(--cv-fav)}.v2-info-star.on svg{fill:currentColor}.v2-info-star:active{transform:scale(.88)}.v2-info-star.is-pin+.v2-info-star{margin-left:-6px}.v2-info-star.is-pin.on{color:var(--cv-accent-text)}.v2-info-block{border-radius:14px;background:#04030c57;border:1px solid var(--hairline-soft);padding:12px}.v2-info-block-head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:9px}.v2-info-block-head span{display:inline-flex;align-items:center;gap:7px;font-size:11.5px;font-weight:600;color:var(--fg-2);min-width:0}.v2-info-block-head span .licon{color:var(--cv-accent-text)}.v2-info-block-head i{font-style:normal;font-weight:500;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:170px}.v2-info-block-head button{width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer}.v2-info-block-head button:hover{background:#ffffff12;color:var(--fg-1)}.v2-info-prompt{margin:0;font-size:12px;line-height:1.65;color:var(--fg-2);max-height:260px;overflow-y:auto;text-wrap:pretty;user-select:text;-webkit-user-select:text}.v2-info-prompt.is-reading{color:var(--fg-3);animation:infoReading 1.2s ease-in-out infinite alternate}.v2-info-prompt.is-none{color:var(--fg-3)}@keyframes infoReading{0%{opacity:.55}to{opacity:1}}@media(prefers-reduced-motion:reduce){.v2-info-prompt.is-reading{animation:none}}.v2-info-specs{display:grid;grid-template-columns:1fr 1fr;gap:14px 12px;padding:0 2px}.v2-info-specs>div{min-width:0}.v2-info-specs span{display:block;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4);margin-bottom:5px}.v2-info-specs b{display:block;font-size:12px;font-weight:500;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-specs b.none{color:var(--fg-5);font-style:italic}.v2-info-specs em{display:block;width:46px;height:32px;border-radius:7px;background-size:cover;background-position:center;border:1px solid var(--hairline-soft)}.v2-info-tool{display:flex;align-items:center;gap:11px;padding:10px;border-radius:14px;background:#04030c57;border:1px solid var(--hairline-soft);width:100%;text-align:left;font-family:var(--font-sans);cursor:default}button.v2-info-tool{cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}button.v2-info-tool:hover{background:#ffffff0d;border-color:var(--hairline)}.v2-info-tool .thumb{flex:none;width:38px;height:38px;border-radius:10px;background-size:cover;background-position:center;background-color:#ffffff0d}.v2-info-tool .body{min-width:0;flex:1}.v2-info-tool em{display:block;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.16em;color:var(--fg-4);font-style:normal}.v2-info-tool b{display:block;margin-top:3px;font-size:13px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-tool .go{flex:none;color:var(--fg-4)}.v2-info-place{display:inline-flex;align-items:center;justify-content:center;gap:9px;height:46px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:14px;font-weight:600;cursor:pointer;box-shadow:0 18px 44px #745aff52;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.v2-info-place:hover{transform:translateY(-1px);filter:brightness(1.06)}.v2-info-remix{display:inline-flex;align-items:center;justify-content:center;gap:9px;height:38px;border-radius:999px;background:#ffffff0f;border:1px solid var(--hairline-soft);color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-info-remix:hover{background:#ffffff1a;color:var(--fg-1)}.v2-stage.is-draw,.v2-stage.is-draw *{cursor:crosshair!important}.v2-shapetool{position:relative;display:inline-flex;align-items:center}.v2-shapetool .face{position:relative;width:36px}.v2-shapetool .face>.licon:first-child{transform:translate(-2px)}.v2-shapetool .caret{position:absolute;right:4px;bottom:6px;display:inline-flex;color:var(--fg-5);transition:color var(--dur-fast),transform var(--dur-med) var(--ease-out-soft)}.v2-shapetool .face:hover .caret{color:var(--fg-3)}.v2-shapetool.is-open .face{background:#ffffff12;color:var(--fg-1)}.v2-shapetool.is-open .caret{color:var(--fg-2);transform:rotate(180deg)}.v2-shapetool.on .face{background:var(--cv-accent-tint);color:var(--cv-accent-text)}.v2-shapetool.on .caret{color:var(--cv-accent-text);opacity:.7}.v2-shapetool.is-open .tip{display:none}.v2-shapemenu{position:absolute;bottom:calc(100% + 12px);left:50%;transform:translate(-50%);width:218px;padding:8px;z-index:60;border-radius:var(--radius-md);background:#0e101af0;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}@media(prefers-reduced-motion:no-preference){.v2-shapemenu{animation:shpIn .24s var(--ease-out-soft) both}@keyframes shpIn{0%{opacity:0;transform:translate(-50%) translateY(8px)}to{opacity:1;transform:translate(-50%) translateY(0)}}}.v2-shapemenu .hd{font-size:10.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5);padding:4px 8px 8px}.v2-shapemenu .row{display:flex;align-items:center;gap:9px;width:100%;height:34px;padding:0 9px 0 4px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:13px;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-shapemenu .row:hover{background:#ffffff12;color:var(--fg-1)}.v2-shapemenu .row.on{color:var(--fg-1)}.v2-shapemenu .row .tick{width:18px;display:inline-flex;justify-content:center;color:var(--cv-accent-text)}.v2-shapemenu .row .lb{flex:1;text-align:left}.v2-shapemenu .row .k{color:var(--fg-5);font-size:11.5px;letter-spacing:.04em}.v2-stylebar{position:absolute;z-index:46;padding:10px 12px 12px;border-radius:var(--radius-md);background:#0e101af0;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}@media(prefers-reduced-motion:no-preference){.v2-stylebar{animation:ctxIn .26s var(--ease-out-soft) both}}.v2-stylebar .hd{display:flex;align-items:center;justify-content:space-between;font-size:10.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5);margin-bottom:9px}.v2-stylebar .hd .x{width:22px;height:22px;border:0;padding:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center}.v2-stylebar .hd .x:hover{background:#ffffff14;color:var(--fg-1)}.v2-stylebar .sw-grid{display:grid;grid-template-columns:repeat(9,1fr);gap:6px}.v2-stylebar .sw{width:100%;aspect-ratio:1;padding:2px;border:1px solid transparent;border-radius:8px;background:#ffffff0d;cursor:pointer;display:flex;transition:border-color var(--dur-fast),background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.v2-stylebar .sw span{flex:1;border-radius:5px;box-shadow:inset 0 0 0 1px #ffffff24}.v2-stylebar .sw:hover{background:#ffffff1f;transform:scale(1.08)}.v2-stylebar .sw.on{border-color:var(--cv-accent-text);background:var(--cv-accent-tint)}.v2-stylebar .wrow{display:flex;align-items:center;gap:10px;margin-top:13px}.v2-stylebar .wrow .lb{font-size:12px;color:var(--fg-3);flex:none}.v2-stylebar input[type=range]{flex:1;min-width:0;-webkit-appearance:none;appearance:none;height:3px;border-radius:999px;background:#ffffff29;outline:none}.v2-stylebar input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:14px;height:14px;border-radius:50%;background:var(--fg-1);border:0;cursor:pointer;box-shadow:0 2px 6px #02040c80}.v2-stylebar input[type=range]::-moz-range-thumb{width:14px;height:14px;border-radius:50%;background:var(--fg-1);border:0;cursor:pointer}.v2-stylebar .num{flex:none;display:flex;align-items:stretch;height:28px;border:1px solid var(--hairline-soft);border-radius:8px;overflow:hidden;background:#ffffff0a}.v2-stylebar .num>span{display:inline-flex;align-items:center;justify-content:center;width:32px;font-size:12.5px;font-variant-numeric:tabular-nums;color:var(--fg-1)}.v2-stylebar .num .stp{display:flex;flex-direction:column;border-left:1px solid var(--hairline-soft)}.v2-stylebar .num .stp button{flex:1;width:20px;border:0;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;padding:0}.v2-stylebar .num .stp button:hover{background:#ffffff1a;color:var(--fg-1)}.v2-stylebar .prev{margin-top:11px;border-radius:9px;background:#ffffff0a;padding:6px 0;display:flex;align-items:center;overflow:hidden}.rs{position:absolute;left:14px;bottom:22px;z-index:44;display:flex;flex-direction:column;width:58px;max-height:calc(100vh - 230px);overflow:hidden;border-radius:14px;background:#121521b8;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);font-family:var(--font-sans);transition:width .42s cubic-bezier(.16,1,.3,1)}.rs.is-open{width:336px}.rs-head{display:flex;align-items:center;gap:7px;height:0;padding:0 12px;opacity:0;overflow:hidden;transition:height .36s cubic-bezier(.16,1,.3,1),padding .36s,opacity .2s}.rs.is-open .rs-head{height:32px;padding-top:6px;opacity:1}.rs-eyebrow{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap}.rs-count{font-size:10px;font-weight:600;color:var(--fg-3);padding:1px 6px;border-radius:999px;background:#ffffff0f;font-variant-numeric:tabular-nums}.rs-list{display:flex;flex-direction:column;gap:2px;padding:5px 5px 0;max-height:200px;overflow:hidden;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent;transition:max-height .42s cubic-bezier(.16,1,.3,1)}.rs.is-open .rs-list{flex:none;height:200px;max-height:200px;overflow-y:auto;overscroll-behavior:contain}.rs-list::-webkit-scrollbar{width:5px}.rs-list::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.rs-head,.rs-more{flex-shrink:0}.rs-row{position:relative;display:flex;align-items:center;gap:11px;flex:none;width:324px;padding:5px;border:0;border-radius:11px;background:transparent;color:inherit;cursor:pointer;font-family:var(--font-sans);transition:background var(--dur-fast)}.rs-row:hover{background:#ffffff12}.rs-row.on{background:var(--cv-accent-tint)}.rs-row.on .rs-shot{box-shadow:0 0 0 2px var(--cv-accent-text)}.rs-row.is-ref-target,.rs-item:hover .rs-row.is-ref-target{background:var(--cv-accent-tint);box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.rs-item{position:relative;flex:none}.rs-item:hover .rs-row{background:#ffffff12}.rs-item:hover .rs-row.on{background:var(--cv-accent-tint)}.rs.is-open .rs-row{padding-right:38px}.rs-pin{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.rs.is-open .rs-pin{pointer-events:auto}.rs.is-open .rs-item:hover .rs-pin,.rs.is-open .rs-pin.on,.rs.is-open .rs-pin:focus-visible{opacity:1}.rs-pin:hover{background:#ffffff17;color:#fff}.rs-pin.on{color:var(--cv-accent-text)}.rs-pin.on svg{fill:currentColor}.rs-shot .pin{position:absolute;left:-4px;top:-4px;width:15px;height:15px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:var(--cv-accent);color:#fff;box-shadow:0 0 0 2px #121521f2;transition:opacity .18s}.rs-shot .pin svg{fill:currentColor}.rs.is-open .rs-shot .pin{opacity:0}.rs-shot{position:relative;flex:none;display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:10px;background-color:#ffffff0f;background-size:cover;background-position:center;color:var(--fg-3);box-shadow:inset 0 0 0 1px #ffffff1a;transition:box-shadow var(--dur-fast)}.rs-shot .k{position:absolute;right:-3px;bottom:-3px;width:15px;height:15px;border-radius:5px;display:flex;align-items:center;justify-content:center;background:#090b13f0;color:var(--fg-2);box-shadow:0 0 0 1px var(--hairline)}.rs-shot .busy{position:absolute;inset:0;border-radius:10px;overflow:hidden}.rs-shot .busy:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.18) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.rs-meta{min-width:0;flex:1;display:flex;flex-direction:column;gap:2px;text-align:left;opacity:0;transition:opacity .18s}.rs-n{flex:none;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums;padding-right:4px;opacity:0;transition:opacity .18s}.rs.is-open .rs-meta,.rs.is-open .rs-n{opacity:1;transition-delay:.08s}.rs-name{font-size:12.5px;font-weight:500;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rs-sub{display:flex;align-items:baseline;gap:5px;min-width:0;font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rs-sub .kind{font-size:9px;font-weight:600;letter-spacing:.16em;text-transform:uppercase}.rs-sub .sep{color:var(--fg-5)}.rs-more{align-self:flex-start;margin:3px 0 7px 9px;width:38px;text-align:center;font-size:10.5px;font-weight:600;color:var(--fg-3)}.rs-tools{flex:none;display:flex;flex-direction:column;gap:8px;width:324px;max-height:0;padding:0 6px;overflow:hidden;opacity:0;pointer-events:none;transition:max-height .36s cubic-bezier(.16,1,.3,1),padding .36s,opacity .2s}.rs.is-open .rs-tools{max-height:110px;padding:6px 6px 4px;opacity:1;pointer-events:auto;transition-delay:0s,0s,.06s}.v2-dock-search{flex:none;display:flex;align-items:center;gap:8px;height:34px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff0a;color:var(--fg-4);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.v2-dock-search:focus-within{border-color:var(--cv-accent-soft);box-shadow:0 0 0 3px var(--cv-accent-tint)}.v2-dock-search input{flex:1;min-width:0;border:0;background:transparent;outline:none;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;user-select:text;-webkit-user-select:text}.v2-dock-search input::placeholder{color:var(--fg-5)}.v2-dock-filters{flex:none;display:flex;flex-wrap:nowrap;gap:5px}.v2-fchip{flex:none;height:26px;padding:0 11px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff09;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.v2-fchip:hover{background:#ffffff14;color:var(--fg-1)}.v2-fchip.on{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff}.rs-filters{gap:4px;overflow-x:auto;scrollbar-width:none}.rs-filters::-webkit-scrollbar{display:none}.rs-filters .v2-fchip{padding:0 9px}.rs-none{width:314px;padding:18px 8px;text-align:center;font-size:12px;color:var(--fg-4)}.rs-pad{flex:none;height:5px}.rs.is-open .rs-pad{height:6px}.rs-empty-body{display:flex;align-items:center;gap:11px;width:324px;padding:9px 9px 0}.rs-empty.is-open .rs-empty-body{padding:5px 9px 0}.rs-empty-slot{flex:none;width:38px;height:38px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px dashed rgba(255,255,255,.22);border-radius:10px;background:#ffffff08;color:var(--fg-3);cursor:pointer;transition:border-color var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.rs-empty-slot:hover{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:var(--cv-accent-text)}.rs-empty-txt{min-width:0;flex:1;display:flex;flex-direction:column;gap:3px;opacity:0;transition:opacity .18s}.rs-empty.is-open .rs-empty-txt{opacity:1;transition-delay:.08s}.rs-empty-txt .t{font-size:12.5px;font-weight:500;color:var(--fg-1);white-space:nowrap}.rs-empty-txt .s{font-size:11px;line-height:1.45;color:var(--fg-4);text-wrap:pretty}.rs-empty-kinds{display:flex;gap:5px;width:324px;max-height:0;padding:0 6px;overflow:hidden;opacity:0;transition:max-height .36s cubic-bezier(.16,1,.3,1),padding .36s,opacity .2s}.rs-empty.is-open .rs-empty-kinds{max-height:40px;padding:10px 6px 0;opacity:1}.rs-empty-kind{display:inline-flex;align-items:center;gap:4px;height:24px;padding:0 8px;border-radius:999px;background:#ffffff0d;color:var(--fg-3);font-size:10.5px;white-space:nowrap}.rs-empty-cta{flex:none;display:flex;align-items:center;justify-content:center;gap:6px;width:288px;height:0;margin:0 6px;padding:0;border:0;border-radius:10px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:600;white-space:nowrap;cursor:pointer;opacity:0;pointer-events:none;overflow:hidden;transition:opacity .18s,height .3s,margin .3s,transform var(--dur-fast)}.rs-empty.is-open .rs-empty-cta{height:34px;margin:10px 6px 0;opacity:1;pointer-events:auto}.rs-empty-cta:hover{transform:translateY(-1px)}.rs-empty .rs-pad{height:9px}.rs-empty.is-open .rs-pad{height:6px}.v2-placewrap{position:relative;display:inline-flex}.v2-placemenu{position:absolute;left:50%;bottom:calc(100% + 14px);transform:translate(-50%);z-index:46;width:292px;padding:6px;border-radius:var(--radius-md);background:#121521e6;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%)}.v2-placemenu .am-row .cv-badge{color:var(--fg-2)}.v2-placemenu .am-row .cv-badge.is-lib{background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff}.v2-placemenu .am-name,.v2-placemenu .am-sub{display:block}.v2-placemenu-enter-active,.v2-placemenu-leave-active{transition:opacity .18s var(--ease-out-soft),transform .18s var(--ease-out-soft)}.v2-placemenu-enter-from,.v2-placemenu-leave-to{opacity:0;transform:translate(-50%) translateY(6px) scale(.98)}.bd-pointmenu{position:absolute;left:0;top:0;z-index:72;border-radius:var(--radius-md);font-family:var(--font-sans);outline:none;background:#121521e0;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%);transform-origin:var(--pm-origin, top left)}@media(prefers-reduced-motion:no-preference){.bd-pointmenu{animation:pmIn .16s var(--ease-out-soft) both}@keyframes pmIn{0%{opacity:0;transform:scale(.96)}to{opacity:1;transform:none}}}.v2-root.light-canvas .bd-pointmenu{background:#121521f0}.bd-pointmenu kbd{flex:none;display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:5px;border:1px solid var(--hairline);background:#ffffff0a;font-family:var(--font-sans);font-size:10px;font-weight:600;line-height:1;color:var(--fg-3)}.bd-canvasmenu{width:212px;padding:5px}.bd-pm-eyebrow{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-5);padding:7px 8px 5px}.bd-pm-row{display:flex;align-items:center;gap:10px;width:100%;height:32px;padding:0 7px 0 4px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);cursor:pointer;outline:none;font-family:var(--font-sans);font-size:12.5px;font-weight:500;letter-spacing:-.01em;text-align:left;transition:background var(--dur-fast),color var(--dur-fast)}.bd-pm-row:hover,.bd-pm-row:focus{background:#ffffff12;color:var(--fg-1)}.bd-pm-row .lbl{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bd-pm-add{flex:none;display:inline-flex;color:var(--cv-accent-text);opacity:0;transform:translate(-3px);transition:opacity var(--dur-fast),transform var(--dur-fast)}.bd-pm-row:hover .bd-pm-add,.bd-pm-row:focus .bd-pm-add{opacity:1;transform:none}.bd-pm-ic{flex:none;width:24px;height:24px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;color:var(--cv-accent-text)}.bd-pm-ic.is-plain{color:var(--fg-2)}.bd-pm-ic.is-prompts{background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff}.bd-pm-sep{height:1px;margin:5px 6px;background:var(--hairline-soft)}.bd-ctxmenu{width:224px;padding:5px}.bd-pm-ic.is-bare{width:20px;background:none;box-shadow:none}.bd-pm-row:disabled{cursor:default;color:var(--fg-5);background:transparent}.bd-pm-row:disabled .bd-pm-ic,.bd-pm-row:disabled kbd{opacity:.45}.bd-pm-row.is-danger:not(:disabled):hover,.bd-pm-row.is-danger:not(:disabled):focus{background:#ff5c7a24;color:var(--danger)}.bd-pm-row.is-danger:not(:disabled):hover .bd-pm-ic,.bd-pm-row.is-danger:not(:disabled):focus .bd-pm-ic{color:var(--danger)}.bd-finder{width:380px;display:flex;flex-direction:column;overflow:hidden}.sf-searchrow{flex:none;padding:10px 8px 8px 10px}.sf-filters{padding:0 10px 4px;gap:4px;overflow-x:auto;scrollbar-width:none}.sf-filters::-webkit-scrollbar{display:none}.sf-filters .v2-fchip{padding:0 10px}.sf-body{flex:1;min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:0 6px 6px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sf-body::-webkit-scrollbar{width:5px}.sf-body::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.sf-eyebrow{display:flex;align-items:center;gap:7px;padding:12px 6px 6px;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-5)}.sf-eyebrow .n{font-size:10px;letter-spacing:0;color:var(--fg-3);padding:1px 6px;border-radius:999px;background:#ffffff0f;font-variant-numeric:tabular-nums}.sf-kits{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:5px;padding:0 2px}.sf-kit,.sf-prompts{display:flex;align-items:center;gap:8px;min-width:0;height:40px;padding:0 8px 0 7px;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff08;color:var(--fg-1);cursor:pointer;text-align:left;font-family:var(--font-sans);font-size:12px;font-weight:600;letter-spacing:-.01em;transition:background var(--dur-fast),border-color var(--dur-fast)}.sf-kit .nm{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sf-kit.is-active,.sf-prompts.is-active{background:#ffffff12;border-color:var(--cv-accent-soft)}.sf-kit-ic{position:relative;transition:background var(--dur-fast)}.sf-add{position:absolute;right:-5px;bottom:-5px;width:14px;height:14px;border-radius:5px;display:flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:0 0 0 1.5px #0a0c14f2,0 2px 6px #745aff59;opacity:0;transform:scale(.4);transition:opacity .14s ease,transform .22s var(--ease-out-soft)}.sf-kit:hover .sf-add,.sf-kit.is-active .sf-add{opacity:1;transform:none}.sf-kit:hover .sf-kit-ic,.sf-kit.is-active .sf-kit-ic{background:var(--cv-accent-tint)}@media(prefers-reduced-motion:reduce){.sf-add{transition:none}}.sf-prompts{width:calc(100% - 4px);margin:0 2px}.sf-prompts .nm{flex:none;white-space:nowrap}.sf-prompts .sub{min-width:0;font-size:11px;font-weight:500;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sf-item{position:relative}.sf-row{display:flex;align-items:center;gap:11px;width:100%;padding:5px 40px 5px 5px;border:0;border-radius:11px;background:transparent;color:inherit;cursor:pointer;text-align:left;font-family:var(--font-sans);transition:background var(--dur-fast)}.sf-item.is-active .sf-row{background:#ffffff12}.sf-meta{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.sf-n{flex:none;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.sf-pin{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sf-item:hover .sf-pin,.sf-item.is-active .sf-pin,.sf-pin.on{opacity:1}.sf-pin:hover{background:#ffffff17;color:#fff}.sf-pin.on{color:var(--cv-accent-text)}.sf-pin.on svg{fill:currentColor}.sf-none{padding:22px 8px;text-align:center;font-size:12px;color:var(--fg-4)}.sf-foot{flex:none;display:flex;align-items:center;gap:14px;height:34px;padding:0 12px;border-top:1px solid var(--hairline-soft);font-size:11px;color:var(--fg-4)}.sf-foot>span{display:inline-flex;align-items:center;gap:3px}.sf-foot kbd{margin-right:3px}.bd-siderail{position:absolute;z-index:46;top:66px;right:14px;display:flex;flex-direction:column;gap:2px;padding:4px;border-radius:13px;background:#121521b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}.bd-siderail-btn{position:relative;width:36px;height:36px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.bd-siderail-btn:hover{background:#ffffff14;color:var(--fg-1)}.bd-siderail-btn.on{background:var(--cv-accent-tint);color:#fff;box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.bd-siderail-btn .badge{position:absolute;left:-5px;top:-5px;min-width:16px;height:16px;padding:0 4px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent);color:#fff;font-size:9.5px;font-weight:700;line-height:1;font-variant-numeric:tabular-nums;box-shadow:0 0 0 2px #121521f2;pointer-events:none}.bd-siderail-btn .tip{position:absolute;right:calc(100% + 12px);top:50%;transform:translateY(-50%) translate(4px);background:#0b0d14eb;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 10px;border-radius:8px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.bd-siderail-btn:hover .tip{opacity:1;transform:translateY(-50%);transition-delay:.26s}.bd-siderail-btn.on .tip{display:none}.bd-boardhist.sv-hist{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:330px;margin:0;background:#0b0d15f7;border-color:var(--hairline);animation:histIn .26s var(--ease-out-soft) both}.bd-boardhist .sv-hist-head .t,.bd-boardhist .sv-hist-head .n{display:revert}.bd-boardhist-close{flex:none;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.bd-boardhist-close:hover{background:#ffffff14;color:var(--fg-1)}.bd-boardhist .sv-cell{touch-action:none}.bd-boardhist-vid{position:absolute;left:6px;top:6px;z-index:2;display:inline-flex;align-items:center;gap:3px;height:16px;padding:0 5px;border-radius:5px;background:#04030cb8;color:#fff;font-size:9.5px;font-weight:600;font-variant-numeric:tabular-nums;pointer-events:none}.bd-boardhist.cols-4 .bd-boardhist-vid,.bd-boardhist.cols-5 .bd-boardhist-vid{left:4px;top:4px;padding:0 3px;font-size:0;gap:0}.bd-boardhist-play{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:14px;pointer-events:none}.sv-hist-filterrow{flex:none;display:flex;align-items:center;gap:6px;margin:10px 0 8px}.sv-hist-filterrow .sv-hist-filter{flex:1;min-width:0;margin:0}.sv-hist-filter.is-resting .sv-hist-filter-btn{cursor:default;color:var(--fg-2)}.sv-hist-filter.is-resting .sv-hist-filter-btn:hover{background:#ffffff0d}.sv-hist-filter.is-resting .sv-hist-filter-btn .chev{opacity:.35}.sv-hist-pinned{flex:none;display:inline-flex;align-items:center;justify-content:center;gap:5px;min-width:32px;height:32px;padding:0 9px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0d;color:var(--fg-3);cursor:pointer;font-family:var(--font-sans);font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-hist-pinned:hover{background:#ffffff17;color:var(--fg-1)}.sv-hist-pinned.on{background:#9968df2e;border-color:#9968df80;color:#fff}.sv-hist-pinned.on svg{fill:currentColor}.sv-hist-pinned .ct{color:inherit;opacity:.8}.sv-cell-pin,.v2-hist-pin,.cv-img-pin{display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:var(--cv-accent);color:#fff;box-shadow:0 0 0 1.5px #090b13d9;pointer-events:none}.sv-cell-pin svg,.v2-hist-pin svg,.cv-img-pin svg{fill:currentColor}.sv-cell-pin{position:absolute;right:6px;top:6px;z-index:2;width:18px;height:18px}.sv-hist.cols-4 .sv-cell-pin,.sv-hist.cols-5 .sv-cell-pin{right:4px;top:4px;width:14px;height:14px}.sv-hist.cols-4 .sv-cell-pin svg,.sv-hist.cols-5 .sv-cell-pin svg{width:8px;height:8px}.v2-hist-pin{position:absolute;right:5px;bottom:5px;z-index:2;width:16px;height:16px}.cv-img-pin{position:absolute;top:8px;right:8px;width:20px;height:20px}.cv-img-vid+.cv-img-fav:has(+.cv-img-pin){right:34px}.sv-hist-acts button.is-pin.on{background:var(--amethyst-400);border-color:transparent}.sv-hist-acts button.is-pin.on svg,.v2-hist-acts button.is-pin.on svg{fill:currentColor}.v2-hist-acts button.is-pin.on{background:var(--amethyst-400);border-color:transparent;color:#fff}.pe{grid-column:1 / -1;display:flex;flex-direction:column;align-items:center;text-align:center;padding:22px 14px 18px}.pe-art{position:relative;width:184px;height:112px;margin-bottom:14px}.pe-glow{position:absolute;left:50%;top:54%;width:170px;height:110px;translate:-50% -50%;border-radius:50%;background:radial-gradient(closest-side,rgba(153,104,223,.32),rgba(90,97,237,.12) 60%,transparent);filter:blur(6px)}.pe-card{position:absolute;width:60px;height:46px;border-radius:9px;overflow:hidden;box-shadow:inset 0 0 0 1px #ffffff2e,0 12px 26px #02040c8c}.pe-card.c1{left:28px;top:40px;rotate:-12deg;background:linear-gradient(160deg,#2d2160,#7532d3 58%,#c750ce)}.pe-card.c3{left:96px;top:40px;rotate:11deg;background:linear-gradient(165deg,#3a2240,#c750ce 52%,#ffb38a)}.pe-card.c2{left:62px;top:26px;rotate:-2deg;z-index:2;background:linear-gradient(175deg,#1d3a6e,#5a61ed 55%,#9ad0ff)}.pe-card .sun{position:absolute;right:10px;top:8px;width:10px;height:10px;border-radius:50%;background:#ffffffd1;box-shadow:0 0 10px #fff9}.pe-card .hill{position:absolute;left:-10px;right:-6px;bottom:-18px;height:30px;border-radius:50%;background:#090b1e8c}.pe-card .hill.b{left:26px;right:-30px;bottom:-20px;background:#090b1e59}.pe-pin{position:absolute;left:81px;top:15px;z-index:4;width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent);color:#fff;box-shadow:0 0 0 2px #0b0d15f2,0 6px 14px #02040c99}.pe-pin svg{fill:currentColor}.pe-ring{position:absolute;left:81px;top:15px;z-index:3;width:22px;height:22px;border-radius:50%;box-shadow:0 0 0 2px #c4a7ffe6;opacity:0}@media(prefers-reduced-motion:no-preference){.pe-card.c1{animation:peFloat 4.8s ease-in-out infinite}.pe-card.c3{animation:peFloat 4.8s ease-in-out -1.6s infinite}.pe-card.c2{animation:peSettle 4.8s var(--ease-out-soft) infinite}.pe-pin{animation:peDrop 4.8s var(--ease-out-soft) infinite}.pe-ring{animation:peRing 4.8s ease-out infinite}.pe-glow{animation:peGlow 4.8s ease-in-out infinite}@keyframes peFloat{0%,to{translate:0 0}50%{translate:0 -4px}}@keyframes peSettle{0%,26%{translate:0 -3px;scale:1}31%{translate:0 1px;scale:.97}40%,to{translate:0 0;scale:1}}@keyframes peDrop{0%{opacity:0;translate:0 -34px;rotate:-30deg;scale:1}12%{opacity:1}27%{translate:0 0;rotate:0deg;scale:1}31%{scale:.84}38%{scale:1}82%{opacity:1;translate:0 0;rotate:0deg}94%,to{opacity:0;translate:0 -8px;rotate:8deg}}@keyframes peRing{0%,29%{opacity:0;scale:.5}32%{opacity:.9;scale:.6}62%,to{opacity:0;scale:2.6}}@keyframes peGlow{0%,to{opacity:.75}35%{opacity:1}}}.pe-title{font-size:14px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.pe-body{margin:7px 0 0;max-width:270px;font-size:12px;line-height:1.55;color:var(--fg-3)}.pe-note{margin:0;max-width:292px;font-size:11px;line-height:1.5;color:var(--fg-4)}.pe-note:before{content:"";display:block;width:32px;height:1px;margin:16px auto 14px;background:var(--hairline)}.pe-hint{display:inline-flex;align-items:center;gap:6px;margin-top:14px;padding:4px 12px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;font-size:11px;color:var(--fg-3)}.pe-key{width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--cv-accent-text)}.pe-key svg{fill:currentColor}.cv-ctxbar button.is-pin.on{color:var(--cv-accent-text);background:var(--cv-accent-tint)}.cv-ctxbar button.is-pin.on svg{fill:currentColor}.pe.is-compact{padding:2px 12px 6px}.pe.is-compact .pe-art{scale:.8;margin:-10px 0 -6px}.pe.is-compact .pe-private{margin-bottom:7px}.pe.is-compact .pe-title{font-size:13px}.pe.is-compact .pe-body{margin-top:4px;max-width:290px;font-size:11.5px}.pe.is-compact .pe-hint{margin-top:11px}.sv-hist-private,.pe-private{flex:none;display:inline-flex;align-items:center;gap:4px;height:18px;padding:0 7px;border-radius:999px;background:#9968df24;color:#c4a7ff;font-size:10px;font-weight:600;letter-spacing:.01em;white-space:nowrap}.pe-private{margin-bottom:9px;height:20px;padding:0 9px;font-size:10.5px}.up-studio-wrap{position:absolute;top:10px;right:12px;z-index:7;display:inline-flex}.up-studio{position:relative;isolation:isolate;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 12px 0 10px;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#ffffff0a;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;font-weight:600;letter-spacing:-.005em;cursor:pointer;transition:color var(--dur-fast),box-shadow var(--dur-med),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.up-studio:before{content:"";position:absolute;inset:-1px;z-index:-1;border-radius:inherit;opacity:0;background:linear-gradient(135deg,#9968df5c,#5a61ed3d);transition:opacity var(--dur-fast)}.up-studio:hover,.up-studio.on,.up-studio:focus-visible{color:#fff;border-color:#c4a2ffcc;box-shadow:inset 0 1px #fff3,0 6px 22px #7532d373;outline:none}.up-studio:hover:before,.up-studio.on:before,.up-studio:focus-visible:before{opacity:1}.up-studio:active{transform:scale(.97)}.up-studio .licon{color:var(--fg-4);transition:color var(--dur-fast)}.up-studio:hover .licon,.up-studio.on .licon,.up-studio:focus-visible .licon{color:#e6dbff}.up-card.has-refs .up-refs{padding-right:96px}.up-card:not(.has-refs) .up-text{padding-right:96px}.up-studio-pop{position:absolute;right:-6px;bottom:calc(100% + 10px);width:480px;border-radius:18px;overflow:hidden;cursor:pointer;background:#0f101a;border:1px solid rgba(255,255,255,.09);box-shadow:0 0 0 1px #9968df29,0 28px 70px #02040cb8,0 10px 24px #02040c73;transform-origin:calc(100% - 44px) 100%}.up-studio-pop-enter-active{transition:opacity .22s ease,transform .32s var(--ease-out-soft)}.up-studio-pop-leave-active{transition:opacity .14s ease,transform .16s ease}.up-studio-pop-enter-from,.up-studio-pop-leave-to{opacity:0;transform:translateY(8px) scale(.95)}.up-studio-pop .media{position:relative;aspect-ratio:16 / 9;background:#07080e;overflow:hidden}.up-studio-pop .media>video,.up-studio-pop .media>img{position:absolute;inset:0;display:block;width:100%;height:100%;object-fit:cover}.up-studio-pop .media>img{animation:upStudioDrift 4.2s ease-out both}@keyframes upStudioDrift{0%{transform:scale(1.06)}to{transform:scale(1)}}.up-studio-slide-enter-active,.up-studio-slide-leave-active{transition:opacity .45s ease}.up-studio-slide-enter-from,.up-studio-slide-leave-to{opacity:0}.up-studio-pop .media:after{content:"";position:absolute;left:0;right:0;bottom:0;height:48px;pointer-events:none;background:linear-gradient(180deg,transparent,rgba(15,16,26,.6))}.up-studio-pop .tag{position:absolute;left:12px;top:12px;z-index:1;display:inline-flex;align-items:center;gap:6px;padding:4px 10px 4px 8px;border-radius:999px;background:#04030c9e;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase}.up-studio-pop .tag .licon{color:#d9c6ff}.up-studio-pop .body{display:flex;flex-direction:column;gap:12px;padding:14px 18px 15px}.up-studio-pop .words{display:flex;flex-direction:column;gap:4px;height:62px;overflow:hidden}.up-studio-pop .words b{font-size:15px;font-weight:650;letter-spacing:-.01em;color:#fff}.up-studio-pop .words span{font-size:12.5px;line-height:1.45;color:var(--fg-3)}.up-studio-words-enter-active{transition:opacity .26s ease,transform .32s var(--ease-out-soft)}.up-studio-words-leave-active{transition:opacity .12s ease}.up-studio-words-enter-from{opacity:0;transform:translateY(4px)}.up-studio-words-leave-to{opacity:0}.up-studio-pop .foot{display:flex;align-items:center;justify-content:space-between}.up-studio-pop .dots{display:inline-flex;align-items:center;gap:5px}.up-studio-pop .dots button{position:relative;width:7px;height:7px;padding:0;border:0;border-radius:999px;overflow:hidden;cursor:pointer;background:#ffffff38;transition:width .32s var(--ease-out-soft),background var(--dur-fast)}.up-studio-pop .dots button:hover{background:#fff6}.up-studio-pop .dots button.on{width:26px;background:#ffffff29}.up-studio-pop .dots button.on i{position:absolute;inset:0;border-radius:inherit;transform-origin:0 50%;background:linear-gradient(90deg,var(--amethyst-500),#8b8ff5);animation:upStudioFill var(--d, 3.4s) linear both}@keyframes upStudioFill{0%{transform:scaleX(0)}to{transform:scaleX(1)}}.up-studio-pop .cta{display:inline-flex;align-items:center;gap:5px;font-size:12px;font-weight:600;color:var(--cv-accent-text);transition:gap var(--dur-fast)}.up-studio-pop:hover .cta{gap:7px;color:#fff}@media(prefers-reduced-motion:reduce){.up-studio-pop-enter-active,.up-studio-pop-leave-active,.up-studio-slide-enter-active,.up-studio-slide-leave-active,.up-studio-words-enter-active,.up-studio-words-leave-active{transition:none}.up-studio-pop .media>img{animation:none}.up-studio-pop .dots button.on i{animation:none;transform:none}}', Y8e = '.bd-canvas-host{position:absolute;inset:0}.cv-el.is-tool .cv-el-body{height:100%}.cv-el.is-tool .cv-bucket{height:100%;display:flex;flex-direction:column}.cv-el.is-tool .cv-bucket-foot{margin-top:auto}.cv-bucket.is-busy .cv-badge{color:#fff;background:var(--cv-accent-tint)}.cv-el.is-frame-title{pointer-events:none}.cv-el.is-frame-title .cv-frame-title{pointer-events:auto}.cv-note-text:empty:before{content:attr(data-placeholder);color:#ffffff57}.v2-root.light-canvas .cv-note-text:empty:before{color:var(--lc-ink-3)}.up-drop-wrap{position:relative;display:inline-flex}.up-text-static{display:flex;align-items:center;color:var(--fg-4);font-size:13px;line-height:1.5;min-height:70px;padding:4px 10px 0;margin:0 -10px;border-radius:12px;border:1px dashed transparent;transition:border-color var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.up-text-static.is-target{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:var(--fg-2)}.up-card.has-refs .up-text-static{min-height:48px}.up-refpick{min-width:300px;width:300px}.up-refpick.has-tabs{width:404px}.up-pop.up-refpick{max-height:min(460px,64vh)}.up-refpick-note{display:flex;align-items:center;gap:8px;padding:4px 6px 8px}.up-refpick-more{justify-content:center}.up-refpick-tip{display:flex;align-items:center;gap:9px;margin:6px 0 0;padding:9px 8px 3px;border-top:1px solid var(--hairline-soft);font-size:11px;line-height:1.45;color:var(--fg-4)}.up-refpick-tip kbd{flex:none;display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 5px;border-radius:6px;border:1px solid var(--hairline);background:#ffffff0d;font-family:var(--font-sans);font-size:11px;font-weight:600;line-height:1;color:var(--cv-accent-text)}.up-refpick-more .up-pop-main{flex:none}.up-refcell.is-video{position:relative}.up-refcell.is-video:after{content:"";position:absolute;right:5px;bottom:5px;width:0;height:0;border-left:7px solid rgba(255,255,255,.9);border-top:4.5px solid transparent;border-bottom:4.5px solid transparent;filter:drop-shadow(0 1px 2px rgba(0,0,0,.6))}.up-drop.up-more{flex-direction:column;gap:1px;border-style:solid;border-color:var(--hairline)}.up-drop.up-more .n{font-size:15px;font-weight:600;color:var(--fg-2);letter-spacing:-.01em}.up-drop.up-more .s{font-size:9px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--fg-4)}.up-drop.up-more.has-some .s{color:var(--cv-accent-text)}.up-drop.up-more.on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint)}.up-refmore{width:276px;min-width:0}.up-moregrid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px 8px;padding:2px 4px 4px}.up-morecell{display:flex;flex-direction:column;align-items:center;gap:5px;min-width:0}.up-morecell .lbl{max-width:100%;font-size:9.5px;font-weight:500;color:var(--fg-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.up-drop.is-sm,.up-ref.is-sm{width:52px;height:52px;border-radius:11px}.up-refgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;padding:2px 2px 8px;max-height:230px;overflow-y:auto}.up-refpick .up-refgrid{margin-bottom:6px}.up-refcell{aspect-ratio:1;border:0;padding:0;border-radius:8px;cursor:pointer;background-color:#ffffff0d;background-size:cover;background-position:center;box-shadow:inset 0 0 0 1px #ffffff14;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.up-refcell:hover{transform:translateY(-1px);box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft),0 8px 20px #02040c80}.bd-drop{position:absolute;inset:52px 0 0;z-index:95;pointer-events:none;display:flex;align-items:center;justify-content:center;background:#9968df0f;box-shadow:inset 0 0 0 2px #9968df73;animation:cvFade var(--dur-fast) ease both}.bd-drop-card{display:inline-flex;align-items:center;gap:10px;padding:14px 20px;border-radius:16px;background:#0b0d15eb;border:1px solid var(--hairline);color:var(--fg-1);font-size:13px;font-weight:600;box-shadow:var(--shadow-deep)}.bd-empty{position:absolute;inset:52px 0 0;z-index:40;pointer-events:none;display:flex;align-items:center;justify-content:center;padding-bottom:60px}.bd-empty-card{pointer-events:none;width:fit-content;min-width:min(380px,calc(100vw - 32px));max-width:calc(100vw - 32px);display:flex;flex-direction:column;align-items:center;text-align:center;gap:8px;padding:26px 26px 20px;border-radius:22px;background:linear-gradient(180deg,#ffffff12,#ffffff06);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 30px 80px #02040c8c;backdrop-filter:blur(24px) saturate(120%);-webkit-backdrop-filter:blur(24px) saturate(120%);font-family:var(--font-sans)}.bd-empty-mark{width:42px;height:42px;border-radius:14px;margin-bottom:6px;display:flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:0 12px 30px #745aff59}.bd-empty-card b{font-size:16px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.bd-empty-sub{font-size:12.5px;line-height:1.5;color:var(--fg-3);max-width:280px}.bd-empty-actions{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-top:10px}.bd-empty-actions button{pointer-events:auto}.bd-empty-keys{margin-top:12px;font-size:11px;color:var(--fg-4);display:flex;align-items:center;gap:5px;flex-wrap:wrap;justify-content:center}.bd-empty-keys kbd{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 4px;margin-left:6px;border-radius:5px;border:1px solid var(--hairline);background:#ffffff0d;font-family:var(--font-sans);font-size:10px;font-weight:600;color:var(--fg-2)}.bd-empty-keys kbd:first-child{margin-left:0}.bd-empty-enter-active{transition:opacity .5s var(--ease-out-soft) .25s,transform .5s var(--ease-out-soft) .25s}.bd-empty-leave-active{transition:opacity .18s ease,transform .18s ease}.bd-empty-enter-from{opacity:0;transform:translateY(8px) scale(.985)}.bd-empty-leave-to{opacity:0;transform:scale(.985)}.light-canvas .bd-empty-card{background:#ffffffeb;border-color:#1318281a;box-shadow:0 1px 2px #13182814,0 24px 60px #1318281f}.light-canvas .bd-empty-card b{color:#131828}.light-canvas .bd-empty-sub,.light-canvas .bd-empty-keys{color:#13182899}.light-canvas .bd-empty-keys kbd{color:#131828bf;background:#1318280a;border-color:#13182824}@media(prefers-reduced-motion:reduce){.bd-empty-enter-active,.bd-empty-leave-active{transition:opacity .2s ease}.bd-empty-enter-from,.bd-empty-leave-to{transform:none}}.bd-toast{position:absolute;left:50%;bottom:186px;z-index:96;transform:translate(-50%);display:inline-flex;align-items:center;gap:8px;max-width:min(560px,calc(100vw - 32px));padding:9px 14px;border-radius:999px;background:#11131ef5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 18px 44px #02040c8c;color:var(--fg-1);font-size:12px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.bd-toast .licon{color:var(--success)}.bd-toast.is-error{border-color:#ff5c7a59}.bd-toast.is-error .licon{color:var(--danger)}.bd-toast.is-error{white-space:normal;align-items:flex-start;border-radius:14px;max-width:min(460px,calc(100vw - 32px));line-height:1.45;text-align:left}.bd-toast.is-error .licon{margin-top:2px}.bd-toast-enter-active{transition:opacity .3s var(--ease-out-soft),transform .3s var(--ease-out-soft)}.bd-toast-leave-active{transition:opacity .2s ease,transform .2s ease}.bd-toast-enter-from,.bd-toast-leave-to{opacity:0;transform:translate(-50%) translateY(8px)}.bd-dropper{position:absolute;left:50%;top:72px;z-index:60;transform:translate(-50%);display:inline-flex;align-items:center;gap:10px;max-width:min(620px,calc(100vw - 32px));padding:5px 5px 5px 6px;border-radius:999px;background:#11131ef5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 18px 44px #02040c8c;color:var(--fg-1);font-size:12.5px;font-weight:500;white-space:nowrap}.bd-dropper-mark{flex:none;width:26px;height:26px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--cv-accent-text)}.bd-dropper-text{min-width:0;overflow:hidden;text-overflow:ellipsis}.bd-dropper-count{flex:none;color:var(--fg-4);font-variant-numeric:tabular-nums}.bd-dropper-done{flex:none;height:26px;padding:0 12px;border:0;border-radius:999px;cursor:pointer;background:#ffffff14;color:var(--fg-1);font:inherit;font-weight:600;transition:background var(--dur-fast)}.bd-dropper-done:hover{background:#ffffff24}.bd-dropper-enter-active{transition:opacity .25s var(--ease-out-soft),transform .25s var(--ease-out-soft)}.bd-dropper-leave-active{transition:opacity .18s ease,transform .18s ease}.bd-dropper-enter-from,.bd-dropper-leave-to{opacity:0;transform:translate(-50%) translateY(-6px)}.bd-stats{position:absolute;left:82px;top:62px;z-index:97;display:flex;flex-direction:column;gap:2px;padding:8px 10px;border-radius:10px;background:#04030cd1;border:1px solid var(--hairline-soft);font-family:ui-monospace,SF Mono,Menlo,monospace;font-size:10.5px;color:var(--fg-3);pointer-events:none;font-variant-numeric:tabular-nums}.bd-stats b{color:var(--success);font-size:12px}.bd-stats b.warn{color:var(--warning)}.bd-stats b.bad{color:var(--danger)}.sx{--sx-mono: ui-monospace, "SF Mono", Menlo, monospace;position:absolute;left:14px;top:66px;z-index:45;width:304px;max-width:calc(100vw - 28px);max-height:max(300px,calc(100% - 336px));display:flex;flex-direction:column;border-radius:18px;background:#0b0d15e6;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 28px 80px #02040c99;font-family:var(--font-sans);color:var(--fg-2);animation:sxIn .34s var(--ease-out-soft) both}@keyframes sxIn{0%{opacity:0;transform:translateY(-6px) scale(.985)}to{opacity:1;transform:none}}.sx:before{content:"";position:absolute;left:22px;right:22px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.55),rgba(153,104,223,.7),rgba(90,97,237,.55),transparent)}.sx.is-collapsed{width:auto}.sx-head{flex:none;display:flex;align-items:center;gap:10px;padding:11px 11px 11px 12px}.sx-mark{flex:none;width:30px;height:30px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 8px 20px #745aff52}.sx-title{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.sx-title b{font-size:13px;font-weight:600;color:var(--fg-1);letter-spacing:.005em}.sx-title span{font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sx-fps{flex:none;min-width:58px;text-align:center;padding:4px 9px;border-radius:999px;font:600 11.5px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--success);background:#37d3991a;border:1px solid rgba(55,211,153,.22);transition:color var(--dur-fast),background var(--dur-fast),border-color var(--dur-fast)}.sx-fps.is-warn{color:var(--warning);background:#ffb3471a;border-color:#ffb34742}.sx-fps.is-bad{color:var(--danger);background:#ff5c7a1a;border-color:#ff5c7a47}.sx-icon{flex:none;width:26px;height:26px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:8px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sx-icon:hover{background:#ffffff17;color:var(--fg-1)}.sx-pinned{flex:none;display:flex;flex-direction:column;gap:6px;padding:0 12px}.sx-body{min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:12px}.sx-body::-webkit-scrollbar{width:8px}.sx-body::-webkit-scrollbar-thumb{background:#ffffff14;border-radius:4px;border:2px solid transparent;background-clip:content-box}.sx-pane{animation:sxPane .24s var(--ease-out-soft) both}@keyframes sxPane{0%{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}.sx-graph{position:relative;flex:none;height:44px;border-radius:11px;overflow:hidden;background:linear-gradient(180deg,#ffffff04,#ffffff0a);border:1px solid var(--hairline-soft)}.sx-graph canvas{display:block;width:100%;height:100%}.sx-graph-label{position:absolute;left:8px;top:5px;font:500 9.5px var(--sx-mono);color:var(--fg-5);pointer-events:none}.sx-live{display:grid;grid-template-columns:repeat(3,1fr);gap:5px}.sx-live>div{display:flex;flex-direction:column;gap:1px;padding:6px 9px;border-radius:9px;background:#ffffff09}.sx-live b{font:600 12px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--fg-1)}.sx-live span{font-size:9.5px;color:var(--fg-4);white-space:nowrap}.sx-tabs{display:flex;gap:18px;margin-top:4px;padding:0 2px;border-bottom:1px solid var(--hairline-soft)}.sx-tabs button{position:relative;height:32px;display:inline-flex;align-items:center;gap:6px;padding:0;border:0;background:transparent;color:var(--fg-4);cursor:pointer;font-size:12px;font-weight:600;transition:color var(--dur-fast)}.sx-tabs button:hover{color:var(--fg-2)}.sx-tabs button.is-on{color:var(--fg-1)}.sx-tabs button:after{content:"";position:absolute;left:0;right:0;bottom:-1px;height:2px;border-radius:2px;background:var(--grad-cta);transform:scaleX(0);transition:transform var(--dur-med) var(--ease-out-soft)}.sx-tabs button.is-on:after{transform:scaleX(1)}.sx-tab-n{padding:1px 6px;border-radius:999px;background:#ffffff12;color:var(--fg-3);font-size:9.5px;font-variant-numeric:tabular-nums}.sx-dot{width:6px;height:6px;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 8px var(--amethyst-500);animation:sxPulse 1s ease-in-out infinite}@keyframes sxPulse{50%{opacity:.35}}.sx h4{display:flex;align-items:baseline;justify-content:space-between;gap:8px;margin:0 0 8px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.sx h4 span{font-size:10.5px;font-weight:500;letter-spacing:0;text-transform:none;color:var(--fg-5)}.sx h4.sx-h-gap{margin-top:14px}.sx-seg{display:grid;grid-template-columns:repeat(4,1fr);gap:2px;padding:3px;border-radius:12px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.sx-seg button{height:28px;display:inline-flex;align-items:center;justify-content:center;gap:5px;padding:0;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.sx-seg button:hover:not(:disabled):not(.is-on){color:var(--fg-1);background:#ffffff0d}.sx-seg button.is-on{color:#fff;cursor:default;background:linear-gradient(180deg,#9968df75,#5a61ed57);box-shadow:inset 0 1px #ffffff29,0 6px 16px #745aff42}.sx-seg button:disabled:not(.is-on){opacity:.45;cursor:default}.sx-counts{display:grid;grid-template-columns:1fr 1fr;gap:9px 12px;margin-top:11px}.sx-big{display:flex;flex-direction:column;gap:1px}.sx-big b{font-size:22px;font-weight:600;line-height:1.1;color:var(--fg-1);font-variant-numeric:tabular-nums;letter-spacing:-.01em}.sx-big b.is-grad{background:var(--grad-purple-pink);-webkit-background-clip:text;background-clip:text;color:transparent}.sx-big span{font-size:11px;color:var(--fg-4)}.sx-counts dl{grid-column:1 / -1;display:grid;grid-template-columns:1fr 1fr 1fr;gap:5px 14px;margin:0;padding-top:9px;border-top:1px solid var(--hairline-soft)}.sx-counts dl>div{display:flex;flex-direction:column;gap:1px}.sx-counts dt{font-size:10px;color:var(--fg-4)}.sx-counts dd{margin:0;font:500 11.5px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--fg-2)}.sx-note{margin:10px 2px 0;font-size:10.5px;line-height:1.45;color:var(--fg-5)}.sx-row{display:grid;grid-template-columns:1.1fr .8fr .8fr 1.1fr;gap:6px}.sx-chip{height:30px;display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:0 8px;white-space:nowrap;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);cursor:pointer;font-size:11.5px;font-weight:600;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sx-chip:hover:not(:disabled){background:#ffffff14;border-color:var(--hairline);color:#fff}.sx-chip:disabled{opacity:.45;cursor:default}.sx-bench{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:6px}.sx-bench li{position:relative;overflow:hidden;display:grid;grid-template-columns:1fr auto;align-items:center;gap:2px 10px;padding:7px 7px 7px 12px;border-radius:12px;background:#ffffff08;border:1px solid var(--hairline-soft);transition:border-color var(--dur-med),background var(--dur-med)}.sx-bench li.is-running{border-color:#9968df6b;background:#9968df12}.sx-bench-name{min-width:0;display:flex;align-items:center;gap:8px}.sx-bench-name b{flex:none;font-size:12px;font-weight:600;color:var(--fg-1)}.sx-hint{min-width:0;font-size:10.5px;color:var(--fg-5);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sx-play{width:28px;height:28px;display:inline-flex;align-items:center;justify-content:center;padding:0;border-radius:10px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast),box-shadow var(--dur-fast)}.sx-play:hover:not(:disabled){background:var(--grad-cta);border-color:transparent;color:#fff;box-shadow:0 6px 16px #745aff4d}.sx-play:disabled{opacity:.45;cursor:default}.sx-bench li.is-running .sx-play{opacity:1;color:var(--amethyst-700)}.sx-bench-res{grid-column:1 / -1;padding-bottom:2px;font:500 10.5px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--fg-3);animation:sxRes .3s var(--ease-out-soft) both}@keyframes sxRes{0%{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:none}}.sx-phase{min-width:0;font-size:10.5px;color:var(--amethyst-700);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sx-pill{flex:none;padding:2px 8px;border-radius:999px;font-family:var(--font-sans);font-size:10px;font-weight:600}.sx-pill.is-ok{color:var(--success);background:#37d3991f}.sx-pill.is-bad{color:var(--danger);background:#ff5c7a1f}.sx-progress{position:absolute;left:0;right:0;bottom:0;height:2px;transform-origin:0 50%;transform:scaleX(var(--sx-p, 0));background:var(--grad-purple-pink);box-shadow:0 0 10px #9968dfcc}.sx-actions{display:flex;gap:8px;margin-top:10px}.sx-actions .bd-btn{flex:1;height:34px;padding:0 12px;gap:7px}.sx-actions .bd-btn:disabled{opacity:.45;cursor:default;transform:none;filter:none}.bd-center{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:14px;color:var(--fg-3);font-size:13px;z-index:30}.bd-spinner{width:26px;height:26px;border-radius:50%;border:2px solid rgba(255,255,255,.12);border-top-color:var(--amethyst-500);animation:cvSpin .8s linear infinite}.bd-spinner.is-sm{width:16px;height:16px}.bd-splash{position:fixed;inset:0;z-index:210;display:flex;align-items:center;justify-content:center;background:var(--bg-deep)}.bd-splash-leave-active{transition:opacity .5s cubic-bezier(.4,0,.2,1);pointer-events:none}.bd-splash-leave-to{opacity:0}.bd-mark-loader{--ml-size: 72px;--ml-cycle: 3.6s;--ml-step: .12s;--ml-offset: 0ms;position:relative;flex:none;width:var(--ml-size);aspect-ratio:239 / 173;isolation:isolate}.bd-ml-glow{position:absolute;inset:-70% -55%;pointer-events:none;opacity:0;background:radial-gradient(closest-side,rgba(153,104,223,.2),rgba(153,104,223,.06) 55%,transparent 100%);animation:bdMlGlow var(--ml-cycle) ease-in-out calc(0ms - var(--ml-offset)) infinite}.bd-ml-mark{position:absolute;inset:0;perspective:calc(var(--ml-size) * 3);animation:bdMlBreathe var(--ml-cycle) ease-in-out calc(0ms - var(--ml-offset)) infinite}.bd-ml-facet{position:absolute;inset:0;width:100%;height:100%;overflow:visible;transform-origin:var(--ox) var(--oy);animation:bdMlFacet var(--ml-cycle) linear calc(var(--i) * var(--ml-step) - var(--ml-offset)) infinite both;will-change:transform,opacity,filter}.bd-ml-sheen{position:absolute;inset:0;pointer-events:none;opacity:0;-webkit-mask:var(--ml-mask) center / 100% 100% no-repeat;mask:var(--ml-mask) center / 100% 100% no-repeat;background-image:linear-gradient(105deg,transparent 38%,rgba(255,255,255,.8) 50%,transparent 62%);background-size:320% 100%;background-repeat:no-repeat;mix-blend-mode:screen;animation:bdMlSheen var(--ml-cycle) linear calc(0ms - var(--ml-offset)) infinite}@keyframes bdMlFacet{0%{opacity:0;filter:brightness(.35);transform:translate(calc(var(--dx) * var(--ml-size) * .09),calc(var(--dy) * var(--ml-size) * .09)) rotate3d(var(--ax),var(--ay),0,88deg) scale(.84);animation-timing-function:cubic-bezier(.16,1,.3,1)}5%{opacity:1}21%{opacity:1;filter:brightness(1);transform:translate(0) rotate3d(var(--ax),var(--ay),0,0) scale(1)}67%{opacity:1;filter:brightness(1);transform:translate(0) rotate3d(var(--ax),var(--ay),0,0) scale(1);animation-timing-function:cubic-bezier(.55,0,.75,.2)}80%{opacity:1}83%,to{opacity:0;filter:brightness(.3);transform:translate(calc(var(--dx) * var(--ml-size) * -.05),calc(var(--dy) * var(--ml-size) * -.05)) rotate3d(var(--ax),var(--ay),0,-88deg) scale(.9)}}@keyframes bdMlBreathe{0%,28%{transform:scale(1)}50%{transform:scale(1.035)}72%,to{transform:scale(1)}}@keyframes bdMlGlow{0%,18%{opacity:0}42%,58%{opacity:1}82%,to{opacity:0}}@keyframes bdMlSheen{0%,34%{opacity:0;background-position:100% 0}37%,55%{opacity:1}58%,to{opacity:0;background-position:0% 0}}@keyframes bdMlPulse{0%,to{opacity:.55}50%{opacity:1}}@media(prefers-reduced-motion:reduce){.bd-ml-glow,.bd-ml-facet,.bd-ml-sheen{animation:none}.bd-ml-mark{animation:bdMlPulse 1.8s ease-in-out infinite}}.bd-error-card{width:360px;padding:24px;border-radius:18px;text-align:center;background:#121521d9;border:1px solid var(--hairline);box-shadow:var(--shadow-deep)}.bd-error-actions{display:flex;justify-content:center;gap:10px;flex-wrap:wrap}.bd-error-card b{display:block;color:var(--fg-1);font-size:15px;margin-bottom:6px}.bd-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:36px;padding:0 18px;white-space:nowrap;flex-shrink:0;border:0;border-radius:999px;cursor:pointer;font-family:var(--font-sans);font-size:12.5px;font-weight:600;background:var(--grad-cta);color:#fff;box-shadow:0 10px 28px #745aff47;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.bd-btn:hover{transform:translateY(-1px);filter:brightness(1.06)}.bd-btn.is-ghost{background:#ffffff0f;border:1px solid var(--hairline);color:var(--fg-1);box-shadow:none}.bd-btn.is-ghost:hover{background:#ffffff1a}.cv-topbar-btn{width:30px;height:30px;flex:none;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:9px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.cv-topbar-btn:hover{background:#ffffff12;color:var(--fg-1)}.cv-topbar-btn.on{background:var(--cv-accent-tint, rgba(153, 104, 223, .16));color:var(--fg-1)}.cv-board-menu-wrap{position:relative;display:inline-flex}.cv-board-menu-wrap .cv-topbar-btn{position:relative}.cv-topbar-dot{position:absolute;top:5px;right:6px;width:6px;height:6px;border-radius:50%;background:var(--amethyst-700, #c2a4ec);box-shadow:0 0 0 2px #070910e6}.cv-board-menu{position:absolute;top:calc(100% + 10px);right:-4px;z-index:50;width:300px;display:flex;flex-direction:column;gap:2px;padding:6px;border:1px solid var(--hairline);border-radius:16px;background:radial-gradient(130% 100% at 100% 100%,rgba(153,104,223,.34),transparent 72%),#11131ef5;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);box-shadow:var(--inset-highlight),var(--shadow-deep);animation:cvMenuIn var(--dur-fast) var(--ease-out-soft) both}@keyframes cvMenuIn{0%{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}.cv-board-menu-item{display:flex;align-items:flex-start;gap:12px;width:100%;padding:10px 12px;text-align:left;border:0;border-radius:11px;background:transparent;color:var(--fg-2);cursor:pointer;font-family:var(--font-sans);transition:background var(--dur-fast),color var(--dur-fast)}.cv-board-menu-item:hover,.cv-board-menu-item:focus-visible{background:#ffffff12;color:var(--fg-1);outline:none}.cv-board-menu-item>.licon{margin-top:1px;color:var(--fg-3)}.cv-board-menu-item:hover>.licon{color:var(--fg-1)}.cv-board-menu-text{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.cv-board-menu-title{font-size:13.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.cv-board-menu-desc{font-size:11.5px;line-height:1.4;color:var(--fg-4)}.cv-board-menu-count,.cv-board-menu-kbd{flex:none;min-width:20px;height:20px;padding:0 6px;margin-top:1px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;font-family:var(--font-sans);font-size:11px;font-weight:600;line-height:1;font-variant-numeric:tabular-nums}.cv-board-menu-count{background:var(--cv-accent-tint, rgba(153, 104, 223, .16));color:var(--fg-1)}.cv-board-menu-kbd{border:1px solid var(--hairline);background:#ffffff0a;color:var(--fg-3)}.ks{position:absolute;inset:0;z-index:120;display:flex;align-items:center;justify-content:center;padding:24px;background:#04030c85;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:ksFade .2s ease both}@keyframes ksFade{0%{opacity:0}to{opacity:1}}.ks-card{position:relative;width:min(940px,100%);max-height:100%;overflow-y:auto;outline:none;padding:30px 36px 34px;border-radius:24px;background:#0b0d15f5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb8;font-family:var(--font-sans);animation:ksIn .34s var(--ease-out-soft) both}@keyframes ksIn{0%{opacity:0;transform:translateY(10px) scale(.985)}to{opacity:1;transform:none}}.ks-card:before{content:"";position:absolute;left:32px;right:32px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.5),rgba(153,104,223,.7),rgba(90,97,237,.5),transparent)}.ks-card::-webkit-scrollbar{width:8px}.ks-card::-webkit-scrollbar-thumb{background:#ffffff14;border-radius:4px;border:2px solid transparent;background-clip:content-box}.ks-head{display:flex;align-items:center;gap:14px;margin-bottom:30px}.ks-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 10px 26px #745aff52}.ks-titles{flex:1;min-width:0}.ks-titles h2{margin:0;font-size:18px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ks-titles p{margin:4px 0 0;font-size:12.5px;color:var(--fg-4)}.ks-os{display:inline-flex;align-items:center;height:20px;padding:0 8px;margin-left:10px;vertical-align:2px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0d;font-size:10.5px;font-weight:600;letter-spacing:.04em;color:var(--fg-3)}.ks-close{margin-left:auto;align-self:flex-start;flex:none;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ks-close:hover{background:#ffffff17;color:var(--fg-1)}.ks-grid{display:grid;gap:30px 44px;align-items:start;grid-template-columns:repeat(3,minmax(0,1fr));grid-template-areas:"tools view edit" "tools board edit"}@media(max-width:920px){.ks-grid{grid-template-columns:repeat(2,minmax(0,1fr));grid-template-areas:"tools edit" "view board"}}@media(max-width:620px){.ks-card{padding:24px 22px 26px}.ks-grid{grid-template-columns:minmax(0,1fr);grid-template-areas:"tools" "view" "edit" "board"}}.ks-group h3{margin:0 0 8px;padding-bottom:11px;border-bottom:1px solid var(--hairline-soft);font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.ks-group ul{list-style:none;margin:0;padding:0;display:flex;flex-direction:column}.ks-group li{display:flex;align-items:center;justify-content:space-between;gap:16px;min-height:36px;padding:3px 0}.ks-label{min-width:0;display:flex;flex-direction:column;gap:2px;font-size:13px;color:var(--fg-2)}.ks-label small{font-size:11px;color:var(--fg-5)}.ks-keys{flex:none;display:inline-flex;align-items:center;gap:4px}.ks-key{min-width:24px;height:24px;padding:0 7px;display:inline-flex;align-items:center;justify-content:center;border-radius:7px;font-family:var(--font-sans);font-size:12px;font-weight:500;line-height:1;color:var(--fg-1);background:linear-gradient(180deg,#ffffff1a,#ffffff0b);border:1px solid rgba(255,255,255,.1);border-bottom-color:#ffffff0d;box-shadow:inset 0 1px #ffffff12,0 1px #00000073}.ks-key.is-word{padding:0 9px;font-size:11px;color:var(--fg-2)}.ks-key.is-inline{min-width:20px;height:20px;padding:0 6px;margin:0 2px;font-size:11px;vertical-align:1px}.rd{position:absolute;inset:0;z-index:92;display:flex;align-items:center;justify-content:center;padding:24px;background:#04030c85;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:ksFade .2s ease both}.rd-card{position:relative;width:min(980px,100%);max-height:min(780px,100%);outline:none;display:flex;flex-direction:column;border-radius:24px;background:#0b0d15f5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb8;font-family:var(--font-sans);animation:ksIn .34s var(--ease-out-soft) both}.rd-card:before{content:"";position:absolute;left:32px;right:32px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.5),rgba(153,104,223,.7),rgba(90,97,237,.5),transparent)}.rd-head{flex:none;display:flex;align-items:center;gap:14px;padding:28px 32px 22px;border-bottom:1px solid var(--hairline-soft)}.rd-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 10px 26px #745aff52}.rd-titles{flex:1;min-width:0}.rd-titles h2{margin:0;font-size:18px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.rd-titles p{margin:4px 0 0;font-size:12.5px;color:var(--fg-4)}.rd-head-acts{flex:none;display:flex;gap:8px}.rd-close{flex:none;align-self:flex-start;width:32px;height:32px;padding:0;margin-left:4px;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.rd-close:hover{background:#ffffff17;color:var(--fg-1)}.rd-btn{height:30px;padding:0 11px;display:inline-flex;align-items:center;gap:6px;white-space:nowrap;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0d;font-family:var(--font-sans);font-size:12px;font-weight:500;line-height:1;color:var(--fg-2);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.rd-btn:hover{background:#ffffff1a;color:var(--fg-1)}.rd-btn.is-danger:hover{color:var(--danger);border-color:#ff5c7a59;background:#ff5c7a14}.rd-btn.is-confirming,.rd-btn.is-confirming:hover{color:#fff;background:#ff5c7ae0;border-color:transparent}.rd-groups{flex:1;min-height:0;overflow-y:auto;padding:0 32px 32px}.rd-groups::-webkit-scrollbar{width:8px}.rd-groups::-webkit-scrollbar-thumb{background:#ffffff14;border-radius:4px;border:2px solid transparent;background-clip:content-box}.rd-group{padding:22px 0 6px}.rd-group+.rd-group{border-top:1px solid var(--hairline-soft)}.rd-group-head{display:flex;align-items:center;gap:12px;margin-bottom:14px}.rd-avatar{flex:none;width:30px;height:30px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:10.5px;font-weight:600;letter-spacing:.02em;color:#fff;background:linear-gradient(135deg,var(--amethyst-500),var(--vista-blue-400));box-shadow:inset 0 1px #ffffff38}.rd-who{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.rd-email{font-size:13px;font-weight:500;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-email em{font-style:normal;margin-left:8px;padding:1px 6px;vertical-align:1px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0f;font-size:10px;font-weight:600;color:var(--fg-3)}.rd-when{font-size:11.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-left{flex:none;display:inline-flex;align-items:center;gap:5px;margin-right:4px;font-size:11.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.rd-group-acts{flex:none;display:flex;gap:6px}.rd-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(128px,1fr));gap:14px}.rd-item{position:relative;min-width:0;display:flex;flex-direction:column;gap:7px}.rd-thumb{position:relative;aspect-ratio:1 / 1;overflow:hidden;display:flex;align-items:center;justify-content:center;border-radius:12px;border:1px solid var(--hairline-soft);background:#ffffff09}.rd-thumb img{width:100%;height:100%;object-fit:cover;display:block}.rd-play{position:absolute;left:8px;bottom:8px;width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:#08091099;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}.rd-note{position:absolute;inset:10px;padding:9px 10px;border-radius:9px;overflow:hidden}.rd-note span{overflow:hidden;font-size:10.5px;line-height:1.45;color:var(--fg-2);white-space:pre-wrap;word-break:break-word;display:-webkit-box;-webkit-line-clamp:6;-webkit-box-orient:vertical}.rd-note.tint-amethyst{background:linear-gradient(180deg,#9968df2b,#9968df14);border:1px solid rgba(194,164,236,.22)}.rd-note.tint-vista{background:linear-gradient(180deg,#5a61ed2b,#5a61ed14);border:1px solid rgba(163,167,245,.22)}.rd-note.tint-sky{background:linear-gradient(180deg,#3db4e62b,#3db4e614);border:1px solid rgba(153,217,243,.22)}.rd-note.tint-mint{background:linear-gradient(180deg,#34c79a2b,#34c79a14);border:1px solid rgba(143,229,201,.22)}.rd-note.tint-amber{background:linear-gradient(180deg,#f0b44a2b,#f0b44a14);border:1px solid rgba(247,212,143,.22)}.rd-note.tint-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14);border:1px solid rgba(245,163,199,.22)}.rd-note.tint-glass{background:var(--grad-glass);border:1px solid var(--hairline)}.rd-frame{position:absolute;inset:18px 14px;padding:8px;display:flex;align-items:flex-start;border-radius:8px;border:1.5px dashed rgba(255,255,255,.26)}.rd-frame span{min-width:0;font-size:10.5px;font-weight:600;color:var(--fg-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-shape{width:72%;height:72%;fill:none;stroke-width:4;stroke-linecap:round;stroke-linejoin:round}.rd-tool{color:var(--fg-3);display:inline-flex}.rd-item-acts{position:absolute;top:7px;right:7px;display:flex;gap:5px;opacity:0;transform:translateY(-3px);transition:opacity var(--dur-fast),transform var(--dur-fast)}.rd-item:hover .rd-item-acts,.rd-item:focus-within .rd-item-acts{opacity:1;transform:none}.rd-item-acts button{width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:8px;border:1px solid rgba(255,255,255,.12);background:#0a0b13cc;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:var(--fg-1);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.rd-item-acts button:hover{background:#1e2030f0}.rd-item-acts button.is-danger:hover{color:var(--danger)}.rd-item-acts button.is-confirming,.rd-item-acts button.is-confirming:hover{background:#ff5c7aeb;border-color:transparent;color:#fff}.rd-item-name{min-width:0;display:flex;align-items:center;gap:6px;font-size:11.5px;color:var(--fg-3)}.rd-item-name>:first-child{flex:none;color:var(--fg-4)}.rd-item-name span{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-more{aspect-ratio:1 / 1;border-radius:12px;border:1px dashed var(--hairline);background:transparent;font-family:var(--font-sans);font-size:12px;font-weight:500;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.rd-more:hover{color:var(--fg-1);background:#ffffff0a}.rd-empty{padding:64px 32px 76px;display:flex;flex-direction:column;align-items:center;text-align:center}.rd-empty-mark{width:52px;height:52px;margin-bottom:16px;border-radius:16px;display:inline-flex;align-items:center;justify-content:center;color:var(--fg-3);background:#ffffff0a;border:1px solid var(--hairline-soft)}.rd-empty h3{margin:0;font-size:15px;font-weight:600;color:var(--fg-1)}.rd-empty p{margin:6px 0 0;max-width:380px;font-size:12.5px;line-height:1.55;color:var(--fg-4)}.rd-pop-leave-active{transition:opacity .18s ease,transform .18s ease}.rd-pop-leave-to{opacity:0;transform:scale(.94)}@media(max-width:720px){.rd{padding:12px}.rd-head{flex-wrap:wrap;padding:22px 20px 18px}.rd-head-acts{order:3;width:100%}.rd-groups{padding:0 20px 24px}.rd-group-head{flex-wrap:wrap;row-gap:10px}.rd-who{flex-basis:calc(100% - 42px)}.rd-left{margin-left:42px}.rd-group-acts{margin-left:auto}.rd-grid{grid-template-columns:repeat(auto-fill,minmax(96px,1fr));gap:10px}.rd-note span{-webkit-line-clamp:3}}@media(prefers-reduced-motion:reduce){.rd,.rd-card{animation:none}.rd-pop-leave-active{transition:none}}', X8e = '.sv-root{position:absolute;inset:0;z-index:88;overflow:hidden;--hist-w: 340px;--hist-col: var(--hist-w);display:grid;grid-template-columns:290px minmax(0,1fr) var(--hist-col);grid-template-rows:60px minmax(0,1fr);transition:grid-template-columns .34s var(--ease-out-soft);background:var(--bg-deep);color:var(--fg-2);animation:svIn .3s var(--ease-out-soft) both}@keyframes svIn{0%{opacity:0;transform:scale(.985)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.sv-root{animation:none}}.sv-ambient{position:absolute;inset:0;pointer-events:none;overflow:hidden}.sv-ambient span{position:absolute;inset:-12%;background-size:cover;background-position:center;filter:blur(90px) saturate(1.35);opacity:.2;animation:svAmbient .9s ease both}@keyframes svAmbient{0%{opacity:0}to{opacity:.2}}.sv-ambient:after{content:"";position:absolute;inset:0;background:radial-gradient(ellipse 70% 60% at 50% 45%,#04030c26,#04030cb8 70%,#04030cf0)}.sv-top{grid-column:1 / -1;grid-row:1;position:relative;z-index:3;display:flex;align-items:center;gap:12px;padding:0 14px;border-bottom:1px solid var(--hairline-soft);background:#0709108c;backdrop-filter:blur(22px);-webkit-backdrop-filter:blur(22px)}.sv-back,.sv-close{flex:none;width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff09;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-back:hover,.sv-close:hover{background:#ffffff14;color:var(--fg-1);border-color:var(--hairline)}.sv-close{border-color:transparent;background:transparent}.sv-title{display:flex;flex-direction:column;min-width:0;gap:2px}.sv-title .eyebrow{font-size:9.5px;font-weight:600;letter-spacing:.22em;text-transform:uppercase;color:var(--fg-4)}.sv-title .name{font-size:14.5px;font-weight:600;color:var(--fg-1);max-width:340px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;letter-spacing:-.005em}.sv-session{flex:none;display:inline-flex;align-items:center;gap:8px;height:32px;padding:0 13px 0 11px;margin-left:6px;border-radius:999px;border:1px solid rgba(153,104,223,.32);background:#9968df14;font:inherit;color:inherit;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-session:hover{background:#9968df29;border-color:#9968df8c}.sv-session:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:2px}.sv-session .lb{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4)}.sv-session .ic{width:20px;height:20px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff14;color:var(--amethyst-700)}.sv-session b{font-size:12.5px;font-weight:600;color:var(--fg-1);white-space:nowrap}.sv-pos{font-size:12px;color:var(--fg-4);font-variant-numeric:tabular-nums;white-space:nowrap}.sv-top-btn{display:inline-flex;align-items:center;gap:6px;height:32px;padding:0 12px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-size:12px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-top-btn:hover{background:#ffffff14;color:var(--fg-1)}.sv-grow{flex:1;min-width:0}.sv-studios{grid-column:1;grid-row:2;position:relative;z-index:2;min-height:0;display:flex;flex-direction:column;margin:14px 0 14px 14px;padding:10px;border-radius:18px;background:#0b0d15e6;border:1px solid var(--hairline-soft);backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:var(--inset-highlight),0 28px 80px #02040c8c;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sv-studios::-webkit-scrollbar{width:5px}.sv-studios::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.sv-seg.sv-sides{flex:none;display:flex;width:100%;padding:3px;border-radius:12px}.sv-seg.sv-sides button{flex:1;height:34px;font-size:12.5px;font-weight:600;border-radius:9px}.sv-seg.sv-sides button.on{background:#9968df38;color:#fff;box-shadow:inset 0 0 0 1px #9968df5c,inset 0 1px #ffffff14}.sv-seg.sv-sides button.on .licon{color:var(--amethyst-700)}.sv-modes{display:flex;flex-direction:column;margin-top:8px}.sv-mode+.sv-mode{border-top:1px solid var(--hairline-soft)}.sv-mode-head{display:flex;align-items:center;gap:11px;width:100%;height:48px;padding:0 8px;border:0;border-radius:10px;background:transparent;color:var(--fg-2);font-size:13.5px;font-weight:500;cursor:pointer;text-align:left;transition:background var(--dur-fast),color var(--dur-fast)}.sv-mode-head .licon{color:var(--fg-4);transition:color var(--dur-fast)}.sv-mode-head .chev{margin-left:auto;color:var(--fg-5)}.sv-mode-head:hover{color:var(--fg-1)}.sv-mode-head:hover .licon{color:var(--fg-2)}.sv-mode.on .sv-mode-head{color:var(--fg-1);cursor:default}.sv-mode.on .sv-mode-head .licon:first-child{color:var(--amethyst-600)}.sv-mode.on .sv-mode-head .chev{color:var(--fg-3)}.sv-mode.is-locked:not(.on) .sv-mode-head{opacity:.4}.sv-mode-body{display:flex;flex-direction:column;gap:14px;padding:0 4px 14px;animation:svPop .22s var(--ease-out-soft) both}.sv-main{grid-column:2;grid-row:2;position:relative;z-index:1;display:flex;flex-direction:column;min-width:0;min-height:0}.sv-stage{position:relative;flex:1;min-height:0}.sv-pic{position:absolute;border-radius:12px;background:#ffffff08;box-shadow:0 0 0 1px #ffffff0f,0 30px 90px #0206179e;transition:left .28s var(--ease-out-soft),top .28s var(--ease-out-soft),width .28s var(--ease-out-soft),height .28s var(--ease-out-soft);animation:svPic .36s var(--ease-out-soft) both}@keyframes svPic{0%{opacity:0;transform:scale(.985)}to{opacity:1;transform:none}}.sv-pic img{display:block;width:100%;height:100%;object-fit:cover;border-radius:12px;user-select:none;-webkit-user-drag:none;transition:opacity .3s ease}.sv-art-play{position:absolute;left:5px;bottom:5px;width:18px;height:18px;border-radius:50%;display:grid;place-items:center;color:#fff;background:#080a129e;pointer-events:none}.sv-pic video{display:block;width:100%;height:100%;object-fit:contain;border-radius:12px;background:#000}.sv-pic.is-loading img{opacity:0}.sv-pic.is-loading{overflow:hidden}.sv-pic.is-loading:after{content:"";position:absolute;inset:0;border-radius:12px;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.07) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.sv-pic.is-editing{box-shadow:0 0 0 1px #9968df73,0 0 0 5px #9968df14,0 30px 90px #0206179e}.sv-pic-tag,.sv-pic-unsaved{position:absolute;top:-27px;display:inline-flex;align-items:center;gap:6px;height:22px;padding:0 10px;white-space:nowrap;border-radius:999px;font-size:11px;font-weight:600;pointer-events:none;background:#04030c9e;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);border:1px solid rgba(255,255,255,.12);color:var(--fg-1)}.sv-pic-tag{left:0;max-width:70%;overflow:hidden;text-overflow:ellipsis}.sv-pic-tag.is-ref{border-color:#a3a7f573;color:var(--vista-blue-600)}.sv-pic-unsaved{right:0;border-color:#ffb34766;color:#ffd08a}.sv-marks{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible}.sv-pin-mark circle{fill:#7c4dff;stroke:#fff;stroke-width:2.5}.sv-pin-mark text{fill:#fff;font-family:var(--font-sans);font-weight:700}.sv-layer{position:absolute;inset:0;touch-action:none;border-radius:12px}.sv-layer.is-draw{cursor:crosshair}.sv-layer.is-draw.tool-eraser{cursor:cell}.sv-layer.is-comment{cursor:copy}.sv-pin{position:absolute;z-index:2;transform:translate(-50%,-50%);width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:2.5px solid #fff;background:#7c4dff;color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:700;box-shadow:0 6px 18px #04030c80;cursor:grab;transition:box-shadow var(--dur-fast),transform var(--dur-fast);animation:svPinIn .28s var(--ease-out-soft) both}@keyframes svPinIn{0%{transform:translate(-50%,-50%) scale(.4);opacity:0}to{transform:translate(-50%,-50%);opacity:1}}.sv-pin:hover{transform:translate(-50%,-50%) scale(1.08)}.sv-pin:active{cursor:grabbing}.sv-pin.is-on{box-shadow:0 0 0 4px #7c4dff59,0 6px 18px #04030c80}.sv-pin.is-empty{background:#7c4dff8c}.sv-pin-editor{position:absolute;z-index:4;width:250px;padding:10px;border-radius:14px;background:#0d0f18f7;border:1px solid var(--hairline);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:svPop .2s var(--ease-out-soft) both;cursor:default}@keyframes svPop{0%{opacity:0;transform:translateY(4px) scale(.98)}to{opacity:1;transform:none}}.sv-pin-editor-head{display:flex;align-items:center;gap:8px;margin-bottom:8px}.sv-pin-editor-head .n{width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#7c4dff;color:#fff;font-size:10.5px;font-weight:700}.sv-pin-editor-head .t{font-size:11px;font-weight:600;color:var(--fg-3)}.sv-pin-editor-head .x{margin-left:auto;width:24px;height:24px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer}.sv-pin-editor-head .x:hover{background:#ff5c7a1f;color:#ff8aa0}.sv-pin-editor textarea{display:block;width:100%;min-height:52px;resize:none;padding:8px 9px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-size:13px;line-height:1.45;outline:none}.sv-pin-editor textarea:focus{border-color:#9968df80}.sv-pin-editor-foot{display:flex;align-items:center;justify-content:space-between;margin-top:8px;font-size:10.5px;color:var(--fg-5)}.sv-mini-btn{height:26px;padding:0 12px;border:0;border-radius:8px;background:#9968df38;color:var(--amethyst-800);font-size:11.5px;font-weight:600;cursor:pointer}.sv-mini-btn:hover{background:#9968df57;color:#fff}.sv-invite{position:absolute;left:50%;top:48%;transform:translate(-50%,-50%);width:min(440px,calc(100% - 40px));display:flex;flex-direction:column;align-items:center;gap:10px;text-align:center;animation:svInvite .4s var(--ease-out-soft) both}@keyframes svInvite{0%{opacity:0;transform:translate(-50%,-46%)}to{opacity:1;transform:translate(-50%,-50%)}}.sv-invite b{font-size:18px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.sv-invite .sub{font-size:13px;line-height:1.55;color:var(--fg-3);max-width:380px}.sv-invite-mark{width:46px;height:46px;border-radius:14px;display:inline-flex;align-items:center;justify-content:center;margin-bottom:4px;background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff;box-shadow:inset 0 1px #ffffff2e,0 14px 40px #7532d34d}.sv-invite-acts{display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;justify-content:center}.sv-invite.is-making{gap:14px}.sv-making-time{margin-top:-6px;font-size:13px;font-weight:600;font-variant-numeric:tabular-nums;color:var(--fg-3)}.sv-making{width:34px;height:34px;border-radius:50%;border:2.5px solid rgba(255,255,255,.12);border-top-color:var(--amethyst-600);animation:cvSpin .9s linear infinite}.sv-model{position:absolute;inset:16px 16px 8px;border-radius:16px;overflow:hidden;background:#e4e1dc;box-shadow:0 0 0 1px #ffffff0f,0 30px 90px #0206178c}.sv-model.is-clear{background-color:#2a2c36;background-image:conic-gradient(rgba(255,255,255,.07) 25%,transparent 0 50%,rgba(255,255,255,.07) 0 75%,transparent 0);background-size:22px 22px}.sv-model canvas{display:block;cursor:grab;touch-action:none}.sv-model.is-dragging canvas{cursor:grabbing}.sv-finder{position:absolute;pointer-events:none;box-shadow:0 0 0 9999px #04030c4d;border-radius:4px}.sv-finder i{position:absolute;width:18px;height:18px;border:2px solid rgba(255,255,255,.92)}.sv-finder .tl{left:-2px;top:-2px;border-right:0;border-bottom:0;border-radius:4px 0 0}.sv-finder .tr{right:-2px;top:-2px;border-left:0;border-bottom:0;border-radius:0 4px 0 0}.sv-finder .bl{left:-2px;bottom:-2px;border-right:0;border-top:0;border-radius:0 0 0 4px}.sv-finder .br{right:-2px;bottom:-2px;border-left:0;border-top:0;border-radius:0 0 4px}.sv-finder-tag{position:absolute;right:8px;top:8px;padding:2px 8px;border-radius:999px;background:#04030c8c;color:#fff;font-size:10.5px;font-weight:600}.sv-dock{position:relative;z-index:6;flex:none;width:min(880px,calc(100% - 40px));margin:6px auto 18px;padding:10px 12px 12px;border-radius:18px;border:1px solid rgba(255,255,255,.06);background:#0b0d15f0;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0b,0 2px 8px #02040c66,0 30px 80px #02040c9e}.sv-note{position:absolute;left:50%;bottom:calc(100% + 10px);transform:translate(-50%);z-index:3;display:inline-flex;align-items:center;height:30px;padding:0 14px;border-radius:999px;white-space:nowrap;background:#11131ef5;border:1px solid var(--hairline);color:var(--fg-1);font-size:12px;font-weight:500;box-shadow:0 14px 40px #02040c80}.sv-note-enter-active,.sv-note-leave-active{transition:opacity .22s var(--ease-out-soft),transform .22s var(--ease-out-soft)}.sv-note-enter-from,.sv-note-leave-to{opacity:0;transform:translate(-50%,6px)}.sv-queue{display:flex;align-items:center;gap:12px;padding:2px 2px 10px;margin-bottom:10px;border-bottom:1px solid var(--hairline-soft);min-height:58px}.sv-queue-label{flex:none;font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap}.sv-queue-slots{flex:1;min-width:0;display:flex;align-items:center;gap:9px;padding:5px 0 0 5px}.sv-slot{position:relative;flex:none;width:44px;height:44px;border-radius:10px;cursor:pointer;background:#ffffff0a;box-shadow:inset 0 0 0 1px #ffffff1a;transition:transform var(--dur-fast) var(--ease-out-soft),opacity var(--dur-fast);animation:svSlot .32s var(--ease-out-soft) backwards}@keyframes svSlot{0%{opacity:0;transform:scale(.7)}to{opacity:1;transform:none}}.sv-slot:hover{transform:translateY(-2px)}.sv-slot .sv-art{border-radius:10px}.sv-slot:after{content:"";position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff1f;pointer-events:none}.sv-slot.is-ref:after{box-shadow:inset 0 0 0 1.5px #a3a7f599}.sv-slot.is-base:after{box-shadow:inset 0 0 0 2px var(--amethyst-500)}.sv-slot.is-stage{outline:2px solid rgba(255,255,255,.85);outline-offset:2px}.sv-slot.is-unsent{opacity:.38}.sv-slot.is-unsent:after{box-shadow:inset 0 0 0 1px #ffffff4d;border:1px dashed rgba(255,255,255,.5)}.sv-slot .n{position:absolute;left:-6px;top:-6px;z-index:2;min-width:18px;height:18px;padding:0 4px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--amethyst-400);color:#fff;font-size:10px;font-weight:700;box-shadow:0 0 0 2px #0b0d15}.sv-slot.is-base .n{background:linear-gradient(135deg,var(--amethyst-500),var(--vista-blue-400))}.sv-slot .x{position:absolute;right:-6px;top:-6px;z-index:2;width:18px;height:18px;padding:0;border-radius:50%;border:0;display:inline-flex;align-items:center;justify-content:center;background:#2a2d3b;color:var(--fg-2);cursor:pointer;box-shadow:0 0 0 2px #0b0d15;opacity:0;transition:opacity var(--dur-fast)}.sv-slot:hover .x{opacity:1}.sv-slot .x:hover{background:#ff5c7a;color:#fff}.sv-slot-add,.sv-slot-more{flex:none;width:44px;height:44px;padding:0;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;border:1px dashed rgba(255,255,255,.18);background:transparent;color:var(--fg-4);font-size:12px;font-weight:600;cursor:pointer;transition:border-color var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.sv-slot-more{border-style:solid;background:#ffffff0a;color:var(--fg-2)}.sv-slot-add:hover,.sv-slot-more:hover{border-color:var(--cv-accent-soft);color:var(--amethyst-700);background:var(--cv-accent-tint)}.sv-queue-empty{font-size:12px;color:var(--fg-4);margin-left:4px}.sv-slot-add-wrap{position:relative;display:inline-flex}.sv-slot-add-wrap>.up-pop{left:0;right:auto;bottom:calc(100% + 10px);top:auto}.sv-queue{border-radius:14px;transition:background var(--dur-fast),box-shadow var(--dur-fast)}.sv-queue.is-air .sv-slot-add{border-color:var(--cv-accent-soft);color:var(--amethyst-700)}.sv-queue.is-over{background:var(--cv-accent-tint);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.sv-queue-count{flex:none;font-size:11.5px;font-weight:600;color:var(--fg-3);font-variant-numeric:tabular-nums}.sv-queue-count.is-over{color:#ffd08a}.sv-art{position:absolute;inset:0;display:block;overflow:hidden;border-radius:inherit}.sv-art img{display:block;width:100%;height:100%;object-fit:cover;user-select:none;-webkit-user-drag:none}.sv-bar{display:flex;align-items:center;gap:10px;min-height:36px}.sv-studio-bar{display:flex;flex-direction:column;gap:8px}.sv-bar-top{min-height:44px;display:flex;align-items:center;padding:0 4px}.sv-bar-top .sv-hint b{color:var(--fg-1);font-weight:600}.sv-chip.is-placeholder{cursor:default;color:var(--fg-5);background:transparent;border-style:dashed}.sv-chip.is-placeholder:hover{background:transparent;color:var(--fg-5)}.sv-pinchips{display:flex;align-items:center;gap:6px;min-width:0;overflow-x:auto;scrollbar-width:none}.sv-pinchips::-webkit-scrollbar{display:none}.sv-pinchip{flex:none;display:inline-flex;align-items:center;gap:7px;height:32px;max-width:220px;padding:0 11px 0 5px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);font-size:12px;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.sv-pinchip:hover{background:#ffffff14;color:var(--fg-1)}.sv-pinchip .n{flex:none;width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#7c4dff;color:#fff;font-size:11px;font-weight:700}.sv-pinchip .t{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-pinchip.on{border-color:#7c4dff99;background:#7c4dff24;color:var(--fg-1)}.sv-pinchip.is-empty .t{color:var(--fg-4)}.sv-pinchips-empty{font-size:12px;color:var(--fg-5);padding-left:4px}.sv-hint{display:inline-flex;align-items:center;gap:8px;min-width:0;font-size:12.5px;color:var(--fg-3)}.sv-hint .licon{color:var(--amethyst-600);flex:none}.sv-sep{flex:none;width:1px;height:20px;background:var(--hairline-soft);margin:0 2px}.sv-seg{display:inline-flex;align-items:center;gap:2px;padding:3px;border-radius:11px;background:#ffffff09;border:1px solid var(--hairline-soft)}.sv-seg button{height:30px;min-width:32px;padding:0 8px;display:inline-flex;align-items:center;justify-content:center;gap:6px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-size:12px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-seg button:hover:not(:disabled){color:var(--fg-1);background:#ffffff0d}.sv-seg button.on{background:#ffffff1a;color:var(--fg-1);box-shadow:inset 0 1px #ffffff0f}.sv-seg button:disabled{opacity:.4;cursor:default}.sv-seg.is-text button{padding:0 11px}.sv-seg.is-small{padding:2px;border-radius:9px}.sv-seg.is-small button{height:24px;font-size:11px;padding:0 9px;border-radius:7px}.sv-swatches{display:inline-flex;align-items:center;gap:7px;padding:0 2px;transition:opacity var(--dur-fast)}.sv-swatches.is-off,.sv-size.is-off{opacity:.35;pointer-events:none}.sv-swatches .sw{width:20px;height:20px;padding:0;border-radius:50%;border:0;cursor:pointer;background:var(--c);box-shadow:inset 0 0 0 1.5px #ffffff38;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-swatches .sw:hover{transform:scale(1.12)}.sv-swatches .sw.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.sv-size{display:inline-flex;align-items:center;gap:9px;transition:opacity var(--dur-fast)}.sv-size i{flex:none;display:inline-block;border-radius:50%;box-shadow:0 0 0 1px #fff3}.sv-size input{width:88px;accent-color:var(--amethyst-500)}.sv-icon-btn{flex:none;width:34px;height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff09;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-icon-btn:hover:not(:disabled){background:#ffffff14;color:var(--fg-1)}.sv-icon-btn:disabled{opacity:.35;cursor:default}.sv-go{flex:none;display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 16px;border:0;border-radius:11px;background:var(--grad-cta);color:#fff;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff38;transition:filter var(--dur-fast),box-shadow var(--dur-fast),transform var(--dur-fast)}.sv-go:hover:not(:disabled){filter:brightness(1.08);box-shadow:0 9px 24px #745aff66,inset 0 1px #ffffff38}.sv-go:active:not(:disabled){transform:scale(.97)}.sv-go:disabled{background:#ffffff12;color:var(--fg-4);box-shadow:none;cursor:default}.sv-go.is-busy{opacity:.85}.sv-btn{display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 15px;border-radius:11px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-1);font-size:13px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-btn:hover{background:#ffffff17;border-color:#ffffff29}.sv-btn.is-primary{border-color:transparent;background:var(--grad-cta);box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff38}.sv-btn.is-primary:hover{filter:brightness(1.08)}.sv-chip{flex:none;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 11px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);font-size:12px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-chip:hover{background:#ffffff14;color:var(--fg-1)}.sv-chip.on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:var(--fg-1)}.sv-chip .licon{color:var(--fg-4)}.sv-chip.is-model .lb{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.sv-chip.is-model .nm{font-size:12.5px;color:var(--fg-1)}.sv-chip.is-dashed{border-style:dashed;border-color:#fff3;background:transparent;color:var(--fg-3)}.sv-chip.is-dashed:hover{border-color:var(--cv-accent-soft);color:var(--amethyst-700);background:var(--cv-accent-tint)}.sv-chip.is-file .nm{max-width:170px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--fg-1)}.sv-cost{flex:none;display:inline-flex;align-items:center;gap:5px;font-size:11.5px;color:var(--fg-4);white-space:nowrap}.sv-pop-wrap{position:relative;flex:none;display:inline-flex}.sv-pop{position:absolute;left:0;bottom:calc(100% + 8px);z-index:10;min-width:290px;padding:6px;border-radius:13px;background:#0d0f18fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:svPop .18s var(--ease-out-soft) both}.sv-pop.is-narrow{min-width:110px}.sv-pop-row{display:flex;align-items:center;gap:10px;width:100%;height:34px;padding:0 10px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);font-size:12.5px;text-align:left;cursor:pointer}.sv-pop-row:hover{background:#ffffff0f;color:var(--fg-1)}.sv-pop-row.on{background:var(--cv-accent-tint);color:var(--fg-1)}.sv-pop-row .nm{font-weight:500}.sv-pop-row .mt{margin-left:auto;font-size:11px;color:var(--fg-4);white-space:nowrap}.sv-pop-row .tk{display:inline-flex;align-items:center;gap:4px;font-size:11px;color:var(--fg-3);min-width:44px;justify-content:flex-end}.sv-describe{display:flex;flex-direction:column;gap:8px}.sv-lines{display:flex;flex-direction:column;gap:6px;max-height:128px;overflow-y:auto;padding:8px 10px;border-radius:12px;background:#ffffff08;border:1px solid var(--hairline-soft)}.sv-lines.is-quiet{padding:6px 10px}.sv-lines-head{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:11px;color:var(--fg-3)}.sv-lines-head>span{display:inline-flex;align-items:center;gap:6px}.sv-lines-head .licon{color:var(--amethyst-600)}.sv-line{display:flex;align-items:baseline;gap:9px;font-size:12.5px;color:var(--fg-1);line-height:1.45}.sv-line .tag{flex:none;display:inline-flex;align-items:center;gap:2px;padding:1px 7px;border-radius:999px;background:#7c4dff33;color:var(--amethyst-800);font-size:10.5px;font-weight:700;font-variant-numeric:tabular-nums}.sv-line .tag i{font-style:normal;opacity:.6}.sv-warn{display:flex;align-items:center;gap:8px;padding:7px 10px;border-radius:10px;font-size:12px;color:#ffd08a;background:#ffb34714;border:1px solid rgba(255,179,71,.22)}.sv-warn span{flex:1;min-width:0}.sv-link{flex:none;padding:0;border:0;background:transparent;color:var(--amethyst-700);font-size:11.5px;font-weight:600;cursor:pointer}.sv-link:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}.sv-prompt{display:block;width:100%;min-height:44px;max-height:150px;resize:none;padding:6px 4px;border:0;outline:none;background:transparent;color:var(--fg-1);font-size:15px;line-height:1.5;overflow-y:auto}.sv-prompt::placeholder{color:var(--fg-4)}.sv-foot{display:flex;align-items:center;gap:8px}.sv-foot .sv-go{margin-left:auto}.sv-cams{display:flex;align-items:center;gap:6px;min-width:0;overflow-x:auto;scrollbar-width:none}.sv-cams::-webkit-scrollbar{display:none}.sv-cam{flex:none;display:inline-flex;align-items:center;height:32px;border-radius:10px;border:1px solid rgba(163,167,245,.3);background:#5a61ed1a;overflow:hidden}.sv-cam button{height:100%;border:0;background:transparent;color:var(--fg-1);cursor:pointer;display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:500}.sv-cam .go{padding:0 6px 0 10px}.sv-cam .go .licon{color:var(--vista-blue-500)}.sv-cam .x{padding:0 8px 0 4px;color:var(--fg-4)}.sv-cam .go:hover{background:#5a61ed29}.sv-cam .x:hover{color:#ff8aa0}.sv-cam-input{flex:none;width:120px;height:32px;padding:0 10px;border-radius:10px;border:1px solid rgba(163,167,245,.6);background:#5a61ed24;color:var(--fg-1);font-size:12px;outline:none}.sv-hist{grid-column:3;grid-row:2;position:relative;z-index:2;min-height:0;margin:14px 14px 14px 0;display:flex;flex-direction:column;padding:12px;border-radius:18px;background:#0b0d15e6;border:1px solid var(--hairline-soft);backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:var(--inset-highlight),0 28px 80px #02040c8c}.sv-hist-head{flex:none;display:flex;align-items:center;gap:8px}.sv-hist-head .t{font-size:10px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.sv-hist-head .n{padding:2px 7px;border-radius:999px;background:#ffffff0f;color:var(--fg-2);font-size:10px;font-weight:600;font-variant-numeric:tabular-nums}.sv-hist-cols{flex:none;display:inline-flex;align-items:center;gap:8px;height:30px;padding:0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-4);transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.sv-hist-cols:hover,.sv-hist-cols:focus-within{background:#ffffff0f;color:var(--fg-2)}.sv-hist-cols .licon{flex:none}.sv-hist-cols-track{position:relative;flex:none;width:66px;height:18px}.sv-hist-cols-track .rail,.sv-hist-cols-track .fill{position:absolute;top:50%;height:3px;margin-top:-1.5px;border-radius:999px;pointer-events:none}.sv-hist-cols-track .rail{left:6px;right:6px;background:#ffffff24}.sv-hist-cols-track .fill{left:6px;background:var(--amethyst-500);transition:width var(--dur-fast) var(--ease-out-soft)}.sv-hist-cols-track i{position:absolute;top:50%;width:3px;height:3px;margin:-1.5px 0 0 -1.5px;border-radius:50%;background:#ffffff4d;pointer-events:none}.sv-hist-cols-track i.on{background:#ffffffd9}.sv-hist-cols-track input{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;-webkit-appearance:none;appearance:none;background:transparent;cursor:pointer;outline:none}.sv-hist-cols-track input::-webkit-slider-runnable-track{height:18px;background:transparent;border:0}.sv-hist-cols-track input::-moz-range-track{height:18px;background:transparent;border:0}.sv-hist-cols-track input::-webkit-slider-thumb{-webkit-appearance:none;width:12px;height:12px;margin-top:3px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c8c;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-hist-cols-track input::-moz-range-thumb{width:12px;height:12px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c8c}.sv-hist-cols-track input:hover::-webkit-slider-thumb,.sv-hist-cols-track input:active::-webkit-slider-thumb{transform:scale(1.15)}.sv-hist-cols-track input:focus-visible::-webkit-slider-thumb{box-shadow:0 0 0 3px var(--cv-accent-soft),0 1px 4px #02040c8c}.sv-hist-cols-track input:focus-visible::-moz-range-thumb{box-shadow:0 0 0 3px var(--cv-accent-soft)}.sv-hist-grid{--cols: 2;flex:1;min-height:0;overflow-y:auto;display:grid;grid-template-columns:repeat(var(--cols),minmax(0,1fr));gap:10px;align-content:start;padding:6px 2px 2px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sv-hist.cols-3 .sv-hist-grid{gap:8px}.sv-hist.cols-4 .sv-hist-grid,.sv-hist.cols-5 .sv-hist-grid{gap:6px}.sv-hist-grid::-webkit-scrollbar{width:5px}.sv-hist-grid::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.sv-hist-empty{grid-column:1 / -1;padding:18px 8px;font-size:12px;line-height:1.5;color:var(--fg-4);text-align:center}.sv-cell{position:relative;flex:none;aspect-ratio:4 / 3;cursor:pointer}.sv-cell.is-new{animation:svCellIn .45s var(--ease-out-soft) backwards}@keyframes svCellIn{0%{opacity:0;transform:scale(.86)}to{opacity:1;transform:none}}.sv-cell .frame{position:absolute;inset:0;border-radius:10px;overflow:hidden;background:#ffffff0a;box-shadow:inset 0 0 0 1px #ffffff12;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-cell .frame:after{content:"";position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff14;pointer-events:none;transition:box-shadow var(--dur-fast)}.sv-cell:hover .frame,.sv-cell.is-on .frame{transform:translateY(-2px);box-shadow:0 12px 28px #02040c80}.sv-cell:hover .frame:after,.sv-cell.is-on .frame:after{box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.sv-cell.is-ref .frame:after{box-shadow:inset 0 0 0 1.5px #a3a7f58c}.sv-cell.is-stage .frame:after{box-shadow:inset 0 0 0 2px #ffffffe6}.sv-cell.is-pending .frame:before{content:"";position:absolute;inset:0;z-index:1;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.sv-cell-time{position:absolute;left:50%;top:50%;z-index:2;transform:translate(-50%,-50%);font-size:11px;font-weight:600;font-variant-numeric:tabular-nums;letter-spacing:.02em;color:#ffffffa8;pointer-events:none}.sv-cell.is-failed .frame{display:flex;align-items:center;justify-content:center;background:#ff5c7a14;box-shadow:inset 0 0 0 1px #ff5c7a40}.sv-cell-fail{color:#ff8aa0;display:inline-flex}.sv-cell-how{position:absolute;left:6px;top:6px;z-index:2;width:20px;height:20px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:#5a61ede6;color:#fff;box-shadow:0 2px 8px #04030c66}.sv-cell-q{position:absolute;right:6px;top:6px;z-index:2;min-width:20px;height:20px;padding:0 5px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--amethyst-400);color:#fff;font-size:10.5px;font-weight:700;box-shadow:0 2px 8px #04030c66}.sv-cell-dot{position:absolute;right:8px;bottom:8px;z-index:2;width:8px;height:8px;border-radius:50%;background:#ffb347;box-shadow:0 0 0 2px #0b0d15e6}.sv-cell-cap{position:absolute;left:6px;bottom:6px;z-index:2;max-width:calc(100% - 12px);padding:2px 7px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:var(--fg-2);font-size:10.5px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:opacity var(--dur-fast)}.sv-hist.cols-3 .sv-cell-cap,.sv-hist.cols-4 .sv-cell-cap,.sv-hist.cols-5 .sv-cell-cap{display:none}.sv-hist:not(.cols-1) .sv-cell-card{padding:0;width:18px;justify-content:center}.sv-hist:not(.cols-1) .sv-cell-card .tx{display:none}.sv-hist.cols-4 .sv-cell .frame,.sv-hist.cols-5 .sv-cell .frame,.sv-hist.cols-4 .sv-cell .frame:after,.sv-hist.cols-5 .sv-cell .frame:after{border-radius:8px}.sv-hist.cols-4 .sv-cell-how,.sv-hist.cols-5 .sv-cell-how{left:4px;top:4px;width:16px;height:16px;border-radius:5px}.sv-hist.cols-4 .sv-cell-q,.sv-hist.cols-5 .sv-cell-q{right:4px;top:4px;min-width:16px;height:16px;padding:0 4px;font-size:9.5px}.sv-hist.cols-4 .sv-cell-marks,.sv-hist.cols-5 .sv-cell-marks{right:4px;bottom:4px;width:14px;height:14px}.sv-hist.cols-4 .sv-cell-marks .licon,.sv-hist.cols-5 .sv-cell-marks .licon{display:none}.sv-hist.cols-4 .sv-cell-card,.sv-hist.cols-5 .sv-cell-card{right:4px;bottom:4px;width:16px;height:16px}.sv-hist-pop{position:absolute;z-index:6;border-radius:14px;pointer-events:auto;box-shadow:0 28px 70px #02040cc2}.sv-hist .sv-hist-pop{right:calc(100% + 12px);animation:svHistPop .22s var(--ease-out-soft) both}@keyframes svHistPop{0%{opacity:0;transform:translate(10px) scale(.94)}to{opacity:1;transform:none}}.sv-hist .sv-hist-pop:after{content:"";position:absolute;right:-26px;top:0;bottom:0;width:26px}.sv-hist-pop .art{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;border-radius:14px;overflow:hidden;cursor:pointer;background:#ffffff0a;box-shadow:inset 0 0 0 1px #ffffff1f}.sv-hist-pop .art .sv-art{border-radius:14px}.sv-hist-pop .cap{position:absolute;left:0;right:0;bottom:0;display:flex;flex-direction:column;gap:2px;padding:34px 13px 12px;pointer-events:none;border-radius:0 0 14px 14px;background:linear-gradient(180deg,#04030c00,#04030ce0 64%)}.sv-hist-pop .cap .n{min-width:0;font-size:12px;font-weight:600;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sv-hist-pop .cap .m{font-size:10.5px;font-weight:500;color:#ffffffa8}.sv-hist-acts{position:absolute;right:10px;top:10px;z-index:3;display:flex;align-items:center;gap:6px}.sv-hist-acts button{position:relative;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.18);border-radius:999px;background:#04030cb8;color:#fff;cursor:pointer;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-hist-acts button:hover{background:var(--cv-accent);border-color:transparent}.sv-hist-acts button.on{background:var(--amethyst-400);border-color:transparent}.sv-hist-acts button.is-danger:hover,.sv-hist-acts button.is-armed{background:#e5486a;border-color:transparent}.sv-hist-acts .tip{position:absolute;top:calc(100% + 8px);right:-4px;z-index:2;background:#0b0d14f5;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:10.5px;font-weight:500;padding:4px 8px;border-radius:7px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.sv-hist-acts button:hover .tip,.sv-hist-acts button.is-armed .tip{opacity:1}.sv-dropping{position:absolute;inset:0;z-index:20;display:flex;align-items:center;justify-content:center;background:#04030c8c;pointer-events:none}.sv-dropping>div{display:inline-flex;align-items:center;gap:10px;padding:14px 20px;border-radius:14px;border:1.5px dashed rgba(153,104,223,.7);background:#0d0f18eb;color:var(--fg-1);font-size:13.5px}@media(max-width:900px){.sv-session .lb,.sv-queue-label,.sv-cost,.sv-pos{display:none}.sv-bar,.sv-foot{flex-wrap:wrap;row-gap:8px}.sv-bar .sv-go{margin-left:auto}.sv-hist{margin-right:10px;padding:10px}.sv-title .name{max-width:180px}.sv-dock{width:calc(100% - 20px);margin-bottom:10px}.sv-size input{width:64px}}.sv-continue{position:absolute;left:50%;bottom:14px;transform:translate(-50%);z-index:3;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 14px;border-radius:999px;white-space:nowrap;border:1px solid rgba(255,255,255,.2);background:#04030ca8;color:#fff;font-size:12px;font-weight:600;cursor:pointer;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);box-shadow:0 10px 30px #02040c73;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft);animation:svContIn .24s var(--ease-out-soft) backwards}@keyframes svContIn{0%{opacity:0;transform:translate(-50%,6px)}to{opacity:1;transform:translate(-50%)}}.sv-continue:hover{background:var(--cv-accent);border-color:transparent;transform:translate(-50%) translateY(-1px)}.bd-root.is-studio .cv-stage{visibility:hidden;transition:visibility 0s linear .32s}.sv-model-tools{position:absolute;right:14px;bottom:14px;display:flex;align-items:center;gap:6px}.sv-seg.is-dark{background:#04030c8c;border-color:#ffffff1f;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px)}.sv-seg.is-dark button{color:#ffffffb8}.sv-seg.is-dark button.on{background:#ffffff2e;color:#fff}.sv-model-btn{width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:9px;border:1px solid rgba(255,255,255,.12);background:#04030c8c;color:#fffc;cursor:pointer;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);transition:background var(--dur-fast)}.sv-model-btn:hover{background:#04030cbf;color:#fff}.sv-layer.is-draw.tool-move{cursor:default}.sv-layer.is-draw.tool-move.is-over{cursor:move}.sv-layer.is-draw.tool-text{cursor:text}.sv-layer.is-draw.tool-brush,.sv-layer.is-draw.tool-eraser{cursor:none}.sv-sel{position:absolute;z-index:2;pointer-events:none;border:1.5px dashed rgba(255,255,255,.95);border-radius:3px;box-shadow:0 0 0 1px #04030c73}.sv-sel .h{position:absolute;width:11px;height:11px;border-radius:3px;pointer-events:auto;background:#fff;box-shadow:0 0 0 1.5px #7c4dff,0 2px 6px #04030c66}.sv-sel .nw{left:-6px;top:-6px;cursor:nwse-resize}.sv-sel .ne{right:-6px;top:-6px;cursor:nesw-resize}.sv-sel .se{right:-6px;bottom:-6px;cursor:nwse-resize}.sv-sel .sw{left:-6px;bottom:-6px;cursor:nesw-resize}.sv-sel .stem{position:absolute;left:50%;top:-22px;width:1.5px;height:16px;margin-left:-.75px;background:#ffffffe6}.sv-sel .turn{left:50%;top:-30px;margin-left:-6px;width:12px;height:12px;border-radius:50%;cursor:grab}.sv-marquee{position:absolute;z-index:2;pointer-events:none;border:1px solid rgba(153,104,223,.9);background:#7c4dff1f;border-radius:2px}.sv-ring{position:absolute;z-index:3;pointer-events:none;transform:translate(-50%,-50%);border-radius:50%;border:1.5px solid #fff;box-shadow:0 0 0 1px #04030c8c,inset 0 0 0 1px #04030c59}.sv-ring.is-eraser{border-style:dashed;background:#ffffff1f}.sv-text-editor{position:absolute;z-index:4;margin:0;padding:0;border:0;outline:1px dashed rgba(255,255,255,.85);outline-offset:3px;background:transparent;resize:none;overflow:hidden;white-space:pre-wrap;word-break:normal;overflow-wrap:anywhere;font-weight:400;letter-spacing:normal;transform-origin:center;caret-color:currentColor;text-shadow:none}.sv-text-editor::placeholder{color:currentColor;opacity:.45}.sv-color{flex:none;width:34px;height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;cursor:pointer;transition:background var(--dur-fast)}.sv-color i{width:18px;height:18px;border-radius:50%;background:var(--c);box-shadow:inset 0 0 0 1.5px #ffffff4d}.sv-color:hover,.sv-color.on{background:#ffffff14}.sv-pop.is-colors{min-width:0;display:flex;align-items:center;gap:8px;padding:9px 10px}.sv-pop.is-colors .sw{position:relative;width:22px;height:22px;padding:0;border-radius:50%;border:0;cursor:pointer;background:var(--c);box-shadow:inset 0 0 0 1.5px #ffffff38;transition:transform var(--dur-fast) var(--ease-out-soft)}.sv-pop.is-colors .sw:hover{transform:scale(1.12)}.sv-pop.is-colors .sw.on{box-shadow:0 0 0 2px #0d0f18,0 0 0 4px #ffffffd9}.sv-pop.is-colors .sw.is-any{background:conic-gradient(#ff3d6e,#ffc93c,#4ade80,#36d6ff,#7c4dff,#ff3d6e);overflow:hidden}.sv-pop.is-colors .sw.is-any.on{background:var(--c)}.sv-pop.is-colors .sw.is-any input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.sv-size .num{width:42px;height:28px;padding:0 6px;border-radius:8px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-size:12px;font-variant-numeric:tabular-nums;text-align:center;outline:none;-moz-appearance:textfield}.sv-size .num::-webkit-inner-spin-button,.sv-size .num::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.sv-size .num:focus{border-color:#9968df80}.sv-size i.is-eraser{border:1.5px dashed rgba(255,255,255,.6)}.sv-size input[type=range]{width:84px}.sv-tools{display:flex;flex-direction:column;gap:10px}.sv-tools-hint{margin:0;font-size:11.5px;line-height:1.5;color:var(--fg-3)}.sv-tools-empty{margin:0;font-size:11.5px;color:var(--fg-5)}.sv-tools-label{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-5);margin-bottom:-4px}.sv-tools-row{display:flex;align-items:center;gap:8px}.sv-tools-row.is-hist{gap:6px}.sv-toolgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:4px}.sv-toolgrid button{height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-toolgrid button:hover{background:#ffffff0f;color:var(--fg-1)}.sv-toolgrid button.on{background:#9968df33;color:#fff;box-shadow:inset 0 0 0 1px #9968df59}.sv-tools .sv-size{flex:1;min-width:0;gap:6px}.sv-tools .sv-size input[type=range]{flex:1;min-width:0;width:auto}.sv-tools .sv-size .num{width:38px}.sv-icon-btn.is-text{width:auto;padding:0 10px;gap:6px;font-size:12px;margin-left:auto}.sv-pop.is-below{top:calc(100% + 8px);bottom:auto}.sv-comments{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:4px;max-height:300px;overflow-y:auto}.sv-comments li{display:flex;align-items:flex-start;gap:2px;border-radius:9px;transition:background var(--dur-fast)}.sv-comments li:hover,.sv-comments li.on{background:#7c4dff1f}.sv-comments .go{flex:1;min-width:0;display:flex;align-items:flex-start;gap:8px;padding:6px 4px 6px 6px;border:0;background:transparent;color:var(--fg-1);text-align:left;cursor:pointer;font-size:12px;line-height:1.4}.sv-comments .n{flex:none;width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#7c4dff;color:#fff;font-size:10.5px;font-weight:700}.sv-comments .t{min-width:0;padding-top:1px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.sv-comments .t.is-empty{color:var(--fg-4)}.sv-comments .x{flex:none;width:24px;height:24px;margin:4px 4px 0 0;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-5);cursor:pointer;opacity:0;transition:opacity var(--dur-fast)}.sv-comments li:hover .x{opacity:1}.sv-comments .x:hover{color:#ff8aa0;background:#ff5c7a1f}.sv-file{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-size:12px;cursor:pointer;text-align:left}.sv-file span{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-file .licon{color:var(--fg-4)}.sv-file:hover{background:#ffffff14}.sv-views{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:3px}.sv-views li{display:flex;align-items:center;border-radius:9px;transition:background var(--dur-fast)}.sv-views li:hover{background:#5a61ed1f}.sv-views .go{flex:1;min-width:0;display:flex;align-items:center;gap:8px;height:30px;padding:0 8px;border:0;background:transparent;color:var(--fg-1);font-size:12px;cursor:pointer;text-align:left}.sv-views .go .licon{color:var(--vista-blue-500)}.sv-views .go.is-add{color:var(--fg-3)}.sv-views .go.is-add .licon{color:var(--fg-4)}.sv-views .x{width:24px;height:24px;margin-right:3px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-5);cursor:pointer}.sv-views .x:hover{color:#ff8aa0;background:#ff5c7a1f}.sv-view-input{width:100%;height:30px;padding:0 8px;border-radius:8px;border:1px solid rgba(163,167,245,.6);background:#5a61ed24;color:var(--fg-1);font-size:12px;outline:none}.sv-btn.is-wide{width:100%;justify-content:center;height:34px;font-size:12.5px}.sv-cell-marks,.sv-slot .m{position:absolute;z-index:2;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:#ff3d6e;color:#fff;box-shadow:0 0 0 2px #0b0d15e6}.sv-cell-marks{right:6px;bottom:6px;width:18px;height:18px}.sv-slot .m{right:-5px;bottom:-5px;width:16px;height:16px}.sv-pic-unsaved.is-marks{border-color:#ff3d6e66;color:#ff9db5}@media(max-width:1180px){.sv-root{--hist-w: 284px;grid-template-columns:266px minmax(0,1fr) var(--hist-col)}.sv-hist-head .t,.sv-hist-head .n,.sv-chip.is-model .lb{display:none}}@media(max-width:900px){.sv-root{--hist-w: 184px;grid-template-columns:240px minmax(0,1fr) var(--hist-col)}.sv-hist-head{gap:6px}.sv-hist-head .sv-hist-cols{padding:0 8px}.sv-hist-head .sv-hist-cols .licon{display:none}}.sv-pop-wrap.is-row{display:flex;flex-direction:column;gap:6px;width:100%}.sv-model-row{display:flex;align-items:center;gap:9px;width:100%;height:40px;padding:0 12px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-1);font-size:12.5px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-model-row:hover,.sv-model-row.on{background:#ffffff12}.sv-model-row.on{border-color:var(--cv-accent-soft)}.sv-model-row .licon{flex:none;color:var(--fg-4)}.sv-model-row .nm{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-model-row .tk{flex:none;display:inline-flex;align-items:center;gap:4px;font-size:11.5px;color:var(--fg-3);font-variant-numeric:tabular-nums}.sv-model-row .tk .licon{color:inherit}.sv-model-list{display:flex;flex-direction:column;gap:2px;padding:4px;border-radius:11px;border:1px solid var(--hairline-soft);background:#090a1099;animation:svPop .18s var(--ease-out-soft) both}.sv-model-list .sv-pop-row{display:grid;grid-template-columns:minmax(0,1fr) auto;grid-template-rows:auto auto;align-items:center;row-gap:1px;height:auto;padding:7px 10px}.sv-model-list .sv-pop-row .nm{grid-column:1;grid-row:1;font-size:12.5px}.sv-model-list .sv-pop-row .mt{grid-column:1;grid-row:2;margin-left:0;font-size:10.5px}.sv-model-list .sv-pop-row .tk{grid-column:2;grid-row:1 / span 2}.sv-pop-item{position:relative}.sv-pop-item .sv-pop-row{padding-right:40px}.sv-pop-item:hover .sv-pop-row{background:#ffffff0f;color:var(--fg-1)}.sv-pop-item:hover .sv-pop-row.on{background:var(--cv-accent-tint)}.sv-pop-pin{position:absolute;right:6px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sv-pop-item:hover .sv-pop-pin,.sv-pop-pin.on,.sv-pop-pin:focus-visible{opacity:1}.sv-pop-pin:hover{background:#ffffff17;color:#fff}.sv-pop-pin.on{color:var(--cv-accent-text)}.sv-pop-pin.on svg{fill:currentColor}.sv-queue{position:relative}.sv-slot-peek{position:absolute;bottom:calc(100% + 24px);z-index:8;border-radius:12px;overflow:hidden;pointer-events:none;background:#ffffff0a;box-shadow:0 0 0 1px #ffffff24,0 24px 60px #02040cb8;animation:svPeek .18s var(--ease-out-soft) both}@keyframes svPeek{0%{opacity:0;transform:translateY(6px) scale(.96)}to{opacity:1;transform:none}}.sv-slot-peek .sv-art{border-radius:12px}.sv-slot-peek .n{position:absolute;left:8px;top:8px;z-index:2;padding:2px 8px;border-radius:999px;background:#04030cb3;color:#fff;font-size:10.5px;font-weight:600}.sv-note.is-floating{bottom:22px}.sv-root.side-edit .sv-stage{margin-bottom:6px}.sv-hist-lib{flex:none;width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff09;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-hist-lib:hover{background:#9968df29;border-color:#9968df66;color:#fff}.sv-hist-filter{position:relative;flex:none;margin:10px 0 8px}.sv-hist-filter-btn{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 9px 0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0d;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-hist-filter-btn .licon{flex:none;color:var(--fg-4)}.sv-hist-filter-btn .licon:first-child{color:var(--amethyst-600)}.sv-hist-filter-btn .lb{flex:1;min-width:0;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-hist-filter-btn .chev{transition:transform var(--dur-med) var(--ease-out-soft)}.sv-hist-filter-btn:hover,.sv-hist-filter-btn.on{background:#ffffff17}.sv-hist-filter-btn.on{border-color:#9968df73}.sv-hist-filter-btn.on .chev{transform:rotate(180deg)}.sv-hist-filter-btn.is-narrowed{border-color:#9968df61;background:#9968df1f}.sv-hist-filter-pop{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:12;padding:5px;border-radius:13px;background:#0d0f18fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:svPop .18s var(--ease-out-soft) both}.sv-hist-opts{max-height:320px;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sv-hist-opt-sep{height:1px;margin:4px 6px;background:var(--hairline-soft)}.sv-hist-opt-line{position:relative;display:flex;align-items:center;border-radius:9px;transition:background var(--dur-fast)}.sv-hist-opt-line:hover{background:#ffffff0f}.sv-hist-opt{flex:1;min-width:0;display:flex;align-items:center;gap:9px;width:100%;margin:0;padding:7px 9px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-hist-opt.is-all:hover{background:#ffffff0f}.sv-hist-opt:hover,.sv-hist-opt.on{color:#fff}.sv-hist-filter-pop .ck{flex:none;width:16px;height:16px;border-radius:5px;display:inline-flex;align-items:center;justify-content:center;box-shadow:inset 0 0 0 1.5px #ffffff3d;color:#fff;transition:background var(--dur-fast),box-shadow var(--dur-fast)}.sv-hist-opt.on .ck{background:var(--amethyst-400);box-shadow:none}.sv-hist-filter-pop .ic{flex:none;width:20px;height:20px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff12;color:var(--amethyst-700)}.sv-hist-filter-pop .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.sv-hist-filter-pop .tx b{font-size:12.5px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-hist-filter-pop .tx small{font-size:10.5px;color:var(--fg-4);line-height:1.35}.sv-hist-filter-pop .ct{flex:none;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.sv-hist-opt-line .sv-hist-opt{padding-right:40px}.sv-hist-opt-acts{position:absolute;right:6px;top:50%;transform:translateY(-50%);display:flex;align-items:center;gap:4px}.sv-hist-only{height:24px;padding:0 9px;border-radius:7px;border:1px solid var(--hairline);background:#161824fa;color:var(--fg-2);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sv-hist-opt-line:hover .sv-hist-only,.sv-hist-only:focus-visible{opacity:1}.sv-hist-only:hover{background:var(--cv-accent);border-color:transparent;color:#fff}.sv-hist-opt-line:hover .ct{visibility:hidden}.sv-hist-pin{width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sv-hist-opt-line:hover .sv-hist-pin,.sv-hist-pin.on,.sv-hist-pin:focus-visible{opacity:1}.sv-hist-pin:hover{background:#ffffff17;color:#fff}.sv-hist-pin.on{color:var(--amethyst-700)}.sv-hist-pin.on svg{fill:currentColor}.sv-hist-opt-label{padding:8px 10px 4px;font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5)}.sv-hist-opt-none{padding:14px 10px;font-size:12px;color:var(--fg-4);text-align:center}.sv-hist-search{display:flex;align-items:center;gap:8px;height:34px;margin:0 0 4px;padding:0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-4);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.sv-hist-search:focus-within{border-color:#9968df80;box-shadow:0 0 0 3px #9968df1f}.sv-hist-search input{flex:1;min-width:0;height:100%;margin:0;padding:0;border:0;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;outline:none}.sv-hist-search input::placeholder{color:var(--fg-5)}.sv-hist-search .x{flex:none;width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:6px;background:#ffffff0f;color:var(--fg-3);cursor:pointer}.sv-hist-search .x:hover{background:#ffffff1f;color:#fff}.sv-vers{position:relative;z-index:3;flex:none;display:flex;justify-content:flex-start;padding:10px 20px 0;animation:svVersIn .32s var(--ease-out-soft) both}@keyframes svVersIn{0%{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:none}}.sv-vers-row{position:relative;display:flex;align-items:center;gap:10px;max-width:100%;padding:6px 4px;overflow-x:auto;overflow-y:hidden;scrollbar-width:none}.sv-vers-row::-webkit-scrollbar{display:none}.sv-ver{position:relative;flex:none;height:54px;padding:0;border:0;border-radius:10px;cursor:pointer;background:#ffffff0d;opacity:.62;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-ver .sv-art,.sv-ver .sv-art img{border-radius:10px}.sv-ver:after{content:"";position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff1a;pointer-events:none;transition:box-shadow var(--dur-fast)}.sv-ver:hover,.sv-ver.is-on{opacity:1;transform:translateY(-2px);box-shadow:0 10px 24px #02040c8c}.sv-ver:hover:after,.sv-ver.is-on:after{box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.sv-ver:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:2px;opacity:1}.sv-ver.is-stage{opacity:1}.sv-ver.is-stage:after{box-shadow:inset 0 0 0 2px #ffffffeb}.sv-ver.is-card:not(.is-stage):after{box-shadow:inset 0 0 0 1.5px #34d399b3}.sv-ver.is-new{animation:svCellIn .45s var(--ease-out-soft) backwards}.sv-ver.is-pending{opacity:1;overflow:hidden}.sv-ver.is-pending:before{content:"";position:absolute;inset:0;border-radius:10px;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.14) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.sv-ver.is-failed{display:inline-flex;align-items:center;justify-content:center;background:#ff5c7a1a}.sv-ver.is-failed:after{box-shadow:inset 0 0 0 1px #ff5c7a4d}.sv-ver-fail{color:#ff8aa0;display:inline-flex}.sv-ver-marks{position:absolute;left:5px;bottom:5px;z-index:2;width:9px;height:9px;border-radius:50%;background:#ff3d6e;box-shadow:0 0 0 1.5px #0b0d15e6}.sv-ver-card{position:absolute;right:-5px;top:-5px;z-index:2;width:18px;height:18px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#10916a;color:#e8fff4;box-shadow:0 0 0 2px var(--bg-deep)}.sv-vers .sv-hist-pop{top:calc(100% - 2px);bottom:auto;transform-origin:50% 0;animation:svVersPop .22s var(--ease-out-soft) both}@keyframes svVersPop{0%{opacity:0;transform:translateY(-8px) scale(.94)}to{opacity:1;transform:none}}.sv-vers .sv-hist-pop:after{content:"";position:absolute;left:0;right:0;bottom:100%;height:6px}.sv-pop-search{display:flex;align-items:center;gap:7px;height:32px;margin:0 0 4px;padding:0 9px;border-radius:8px;background:#ffffff0a;border:1px solid var(--hairline-soft);color:var(--fg-4)}.sv-pop-search input{flex:1;min-width:0;height:100%;border:0;background:transparent;color:var(--fg-1);font-size:12.5px;outline:none}.sv-pop-rows{max-height:300px;overflow-y:auto}.sv-model-list .sv-pop-rows{max-height:260px}.sv-pop-empty{padding:10px;font-size:12px;color:var(--fg-4)}.sv-pop-foot{margin:6px 4px 2px;font-size:10.5px;line-height:1.4;color:var(--fg-5)}.sv-pop-title{padding:4px 10px 6px;font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5)}.sv-pop.is-down{bottom:auto;top:calc(100% + 6px)}.sv-pop-slider{display:flex;align-items:center;gap:10px;padding:4px 10px 8px;min-width:200px}.sv-pop-slider input{flex:1;accent-color:var(--amethyst-500)}.sv-pop-slider b{min-width:28px;text-align:right;font-size:12px;color:var(--fg-1);font-variant-numeric:tabular-nums}.sv-fields{display:flex;align-items:center;flex-wrap:wrap;gap:6px}.sv-problem{display:flex;align-items:center;gap:6px;margin-top:8px;font-size:11.5px;color:#ffcf8a}.sv-problem.is-inline{margin-top:0}.sv-problem .licon{flex:none}.sv-go.is-blocked:not(.is-busy){filter:saturate(.6)}.sv-promote{position:absolute;right:12px;bottom:14px;z-index:3;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 14px;border-radius:999px;white-space:nowrap;border:1px solid rgba(255,255,255,.2);background:#04030ca8;color:#fff;font-size:12px;font-weight:600;cursor:pointer;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);box-shadow:0 10px 30px #02040c73;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft);animation:svPop .24s var(--ease-out-soft) backwards}.sv-promote:hover{background:var(--cv-accent);border-color:transparent;transform:translateY(-1px)}.sv-promote.is-done{cursor:default;height:28px;padding:0 11px;font-size:11px;font-weight:600;color:#b9f3d0;border-color:#34d39959}.sv-promote.is-done:hover{background:#04030ca8;border-color:#34d39959;transform:none}.sv-cell-card{position:absolute;right:6px;bottom:6px;z-index:2;display:inline-flex;align-items:center;gap:4px;height:18px;padding:0 7px;border-radius:999px;background:#107052e0;color:#e8fff4;font-size:9.5px;font-weight:700;letter-spacing:.02em;box-shadow:0 2px 8px #04030c66}.sv-cell.is-card .frame:after{box-shadow:inset 0 0 0 1.5px #34d399b3}.sv-cell.is-card.is-stage .frame:after{box-shadow:inset 0 0 0 2px #ffffffe6}.sv-hist-acts button.is-promote:hover{background:#10916a}.sv-model-canvas{position:absolute;inset:0;width:100%;height:100%;display:block;outline:none;cursor:grab;touch-action:none}.sv-model-canvas:active{cursor:grabbing}.sv-model.is-night{background:#0e0f17}.sv-model-state{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2;display:inline-flex;align-items:center;gap:10px;padding:10px 16px;border-radius:12px;background:#04030cb8;color:#fff;font-size:12.5px;font-weight:500;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);max-width:min(420px,80%);text-align:left}.sv-model-state .sv-making{width:18px;height:18px;border-width:2px}.sv-model-state.is-error{color:#ffd0d8}.sv-model-state.is-inline{position:static;transform:none;margin-top:8px}.sv-model-tools{flex-wrap:wrap;justify-content:flex-end;max-width:calc(100% - 28px)}.sv-views .go.on{color:#fff;background:#5a61ed33;border-radius:9px}.sv-views-adds{gap:4px}.sv-views-adds:hover{background:transparent}.sv-views-adds .go{flex:1;border-radius:9px}.sv-views-adds .go:hover{background:#5a61ed1f}.sv-views .go:disabled{opacity:.45;cursor:default}.sv-foot{flex-wrap:wrap;row-gap:8px}.sv-foot .sv-fields{flex:0 1 auto}.sv-hist.cols-1 .sv-cell.is-card .sv-cell-marks{right:108px}.sv-hist:not(.cols-1) .sv-cell.is-card .sv-cell-marks{right:28px}.sv-hist.cols-4 .sv-cell.is-card .sv-cell-marks,.sv-hist.cols-5 .sv-cell.is-card .sv-cell-marks{right:23px}.sv-pop-rows .sv-pop-row .nm{flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-pop-rows .sv-pop-row .mt,.sv-pop-rows .sv-pop-row .tk{flex:none;white-space:nowrap}.sv-pop:has(.sv-pop-search),.sv-pop:has(.sv-pop-foot){min-width:360px}', J8e = `.ed-radio{position:relative;flex:none;width:16px;height:16px;border-radius:50%;box-shadow:inset 0 0 0 1.5px #ffffff42;transition:box-shadow .22s var(--ease-out-soft),background .22s var(--ease-out-soft)}.ed-radio i{position:absolute;left:50%;top:50%;width:8px;height:8px;margin:-4px 0 0 -4px;border-radius:50%;background:#fff;transform:scale(0);opacity:0;transition:transform .3s cubic-bezier(.34,1.56,.64,1),opacity .18s ease}.ed-radio.on{box-shadow:inset 0 0 0 1.5px var(--amethyst-500),0 0 0 3px #9968df29;background:#9968df38}.ed-radio.on i{transform:scale(1);opacity:1;background:linear-gradient(135deg,#fff,var(--amethyst-800))}*:hover>.ed-radio:not(.on){box-shadow:inset 0 0 0 1.5px #ffffff73}@media(prefers-reduced-motion:reduce){.ed-radio,.ed-radio i{transition:none}}.ed-collapse{transition:height .34s var(--ease-out-soft),opacity .26s ease}.ed-autoh{position:relative;transition:height .34s var(--ease-out-soft)}.ed-autoh.is-moving{overflow:hidden}.ed-autoh-in{position:relative}.ed-autoh.is-moving>.ed-autoh-in{position:absolute;left:0;right:0;bottom:0}.ed-swap-enter-active{transition:opacity .22s ease .07s,transform .3s var(--ease-out-soft) .04s}.ed-swap-leave-active{position:absolute;left:0;right:0;bottom:0;pointer-events:none;transition:opacity .12s ease}.ed-swap-enter-from{opacity:0;transform:translateY(6px)}.ed-swap-leave-to{opacity:0}.ed-fade-enter-active,.ed-fade-leave-active{transition:opacity .2s ease}.ed-fade-enter-from,.ed-fade-leave-to{opacity:0}.ed-side-enter-active,.ed-side-leave-active{transition:opacity .18s ease,transform .24s var(--ease-out-soft)}.ed-side-enter-from{opacity:0;transform:translate(-6px)}.ed-side-leave-to{opacity:0;transform:translate(6px)}.ed-slide{position:relative;isolation:isolate;--p: 3px;--g: 2px;--r: 8px}.ed-slide:before{content:"";position:absolute;z-index:-1;top:var(--p);bottom:var(--p);width:calc((100% - 2 * var(--p) - (var(--n) - 1) * var(--g)) / var(--n));left:calc(var(--p) + var(--i) * ((100% - 2 * var(--p) - (var(--n) - 1) * var(--g)) / var(--n) + var(--g)));border-radius:var(--r);background:#9968df38;box-shadow:inset 0 0 0 1px #9968df5c,inset 0 1px #ffffff14;transition:left .32s var(--ease-out-soft)}.sv-seg.ed-slide>button{position:relative}.sv-seg.ed-slide>button.on,.sv-seg.ed-slide>button.on:hover{background:transparent;box-shadow:none;color:#fff}.sv-seg.ed-slide.sv-sides{--r: 9px}.sv-seg.ed-slide.is-small{--p: 2px;--r: 7px;display:inline-grid;grid-template-columns:repeat(var(--n),minmax(0,1fr))}@media(prefers-reduced-motion:reduce){.ed-collapse,.ed-autoh,.ed-swap-enter-active,.ed-swap-leave-active,.ed-side-enter-active,.ed-side-leave-active,.ed-slide:before{transition:none}}kbd{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:5px;background:#ffffff12;box-shadow:inset 0 -1px #ffffff0f,inset 0 0 0 1px #ffffff14;color:var(--fg-3);font-family:var(--font-sans);font-size:10px;font-weight:600}.ed-tools{display:flex;flex-direction:column;margin-top:8px;gap:2px}.ed-tool{border-radius:12px;transition:background .24s ease,box-shadow .24s ease}.ed-tool.on{background:#ffffff06;box-shadow:inset 0 0 0 1px #ffffff0d}.ed-tool-head{display:flex;align-items:center;gap:11px;width:100%;height:44px;padding:0 10px;border:0;border-radius:11px;background:transparent;color:var(--fg-2);font-size:13.5px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-tool-head .ic{color:var(--fg-4);transition:color var(--dur-fast),transform .3s var(--ease-out-soft)}.ed-tool-head .lbl{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-tool-head:hover:not(:disabled){color:var(--fg-1);background:#ffffff0a}.ed-tool-head:hover:not(:disabled) .ic{color:var(--fg-2)}.ed-tool-head:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:-2px}.ed-tool-head:disabled{opacity:.38;cursor:default}.ed-tool.on .ed-tool-head{color:#fff;cursor:default}.ed-tool.on .ed-tool-head .ic{color:var(--amethyst-600);transform:scale(1.06)}.ed-pending{flex:none;width:7px;height:7px;border-radius:50%;background:#ffb347;box-shadow:0 0 0 3px #ffb34729;animation:edPulse 1.8s ease-in-out infinite}@keyframes edPulse{0%,to{box-shadow:0 0 0 3px #ffb34729}50%{box-shadow:0 0 0 5px #ffb3470f}}.ed-tool-body{padding:2px 8px 14px}.ed-tool-body.is-plain{padding:0 10px 12px 37px;animation:svPop .22s var(--ease-out-soft) both}.ed-tools .ed-tool+.ed-tool:not(.on):not(:has(+.on)){position:relative}.ed-panel{display:flex;flex-direction:column;gap:12px}.ed-hint{margin:0;font-size:11.5px;line-height:1.5;color:var(--fg-3)}.ed-hint.is-quiet{color:var(--fg-5)}.ed-keys{display:flex;flex-wrap:wrap;gap:10px;font-size:11px;color:var(--fg-4)}.ed-keys span{display:inline-flex;align-items:center;gap:5px}.ed-info{display:flex;align-items:baseline;justify-content:space-between;gap:10px;padding:8px 10px;border-radius:10px;background:#ffffff08;border:1px solid var(--hairline-soft);font-size:11.5px;color:var(--fg-3)}.ed-info b{font-size:12px;font-weight:600;color:var(--fg-1);font-variant-numeric:tabular-nums}.ed-tabs{display:flex;width:100%}.ed-tabs button{flex:1;height:30px;font-size:12px;font-weight:600}.ed-tabs button.on{background:#9968df33;color:#fff;box-shadow:inset 0 0 0 1px #9968df52}.ed-acts{display:flex;align-items:center;gap:8px}.ed-acts .sv-btn{height:34px;padding:0 12px;font-size:12.5px}.ed-acts .ed-apply{flex:1;justify-content:center}.ed-acts .ed-square{flex:none;width:34px;padding:0;justify-content:center}.ed-acts.is-foot,.ed-go{position:sticky;bottom:-10px;z-index:3;margin:0 -8px -14px;padding:12px 8px 14px;background:#0b0d15}.ed-acts.is-foot:after,.ed-go:after{content:"";position:absolute;left:0;right:0;bottom:100%;height:18px;pointer-events:none;background:linear-gradient(180deg,#0b0d1500,#0b0d15)}.ed-go{padding-top:14px}.ed-go:before{content:"";position:absolute;left:8px;right:8px;top:4px;height:1px;background:var(--hairline-soft)}.ed-acts.is-tight .sv-btn{flex:1;justify-content:center}.sv-btn:disabled{opacity:.4;cursor:default;filter:none}.sv-btn.is-primary:disabled{background:#ffffff12;box-shadow:none;color:var(--fg-4)}.sv-btn.is-on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:#fff}.ed-slider{display:flex;flex-direction:column;gap:6px;cursor:default}.ed-slider-head{display:flex;align-items:baseline;justify-content:space-between;gap:8px}.ed-slider-head .lb{font-size:11.5px;color:var(--fg-3);transition:color var(--dur-fast)}.ed-slider-head .v{font-size:11px;font-weight:600;color:var(--fg-4);font-variant-numeric:tabular-nums;transition:color var(--dur-fast)}.ed-slider.is-changed .ed-slider-head .lb{color:var(--fg-1)}.ed-slider.is-changed .ed-slider-head .v{color:var(--amethyst-700)}.ed-slider.is-off{opacity:.4}.ed-slider-track{position:relative;height:16px}.ed-slider-track .rail,.ed-slider-track .fill{position:absolute;top:50%;height:3px;margin-top:-1.5px;border-radius:999px;pointer-events:none}.ed-slider-track .rail{left:0;right:0;background:#ffffff1f}.ed-slider-track .fill{background:linear-gradient(90deg,var(--amethyst-500),#8f72ff);transition:left .08s linear,width .08s linear}.ed-slider-track .tick{position:absolute;top:50%;width:3px;height:3px;margin:-1.5px 0 0 -1.5px;border-radius:50%;background:#ffffff52;pointer-events:none;transition:background var(--dur-fast),transform var(--dur-fast)}.ed-slider-track .tick.on{background:#fff;transform:scale(1.4)}.ed-slider-track input{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;-webkit-appearance:none;appearance:none;background:transparent;cursor:pointer;outline:none}.ed-slider-track input::-webkit-slider-runnable-track{height:16px;background:transparent;border:0}.ed-slider-track input::-moz-range-track{height:16px;background:transparent;border:0}.ed-slider-track input::-webkit-slider-thumb{-webkit-appearance:none;width:13px;height:13px;margin-top:1.5px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c99,0 0 #9968df66;transition:transform .18s var(--ease-out-soft),box-shadow .18s ease}.ed-slider-track input::-moz-range-thumb{width:13px;height:13px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c99}.ed-slider-track input:hover::-webkit-slider-thumb{transform:scale(1.12)}.ed-slider-track input:active::-webkit-slider-thumb{transform:scale(1.2);box-shadow:0 1px 4px #02040c99,0 0 0 5px #9968df40}.ed-slider-track input:focus-visible::-webkit-slider-thumb{box-shadow:0 0 0 3px var(--cv-accent-soft),0 1px 4px #02040c8c}.ed-slider-track input:disabled{cursor:default}.ed-fields,.ed-fields-more{display:flex;flex-direction:column;gap:12px}.ed-fields-more{animation:svPop .2s var(--ease-out-soft) both}.ed-field{display:flex;flex-direction:column;gap:6px}.ed-field-lb{font-size:11.5px;color:var(--fg-3)}.ed-pills{display:flex;width:100%;flex-wrap:wrap}.ed-pills button{flex:1 1 auto;height:26px;font-size:11.5px;padding:0 8px}.ed-pills button.on{background:#9968df38;color:#fff;box-shadow:inset 0 0 0 1px #9968df5c}.ed-select{position:relative;display:flex;align-items:center}.ed-select select{width:100%;height:32px;padding:0 30px 0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;-webkit-appearance:none;appearance:none;cursor:pointer;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast)}.ed-select select:hover{background:#ffffff12}.ed-select select:focus{border-color:#9968df80}.ed-select select option{background:#14151f;color:var(--fg-1)}.ed-select .licon{position:absolute;right:10px;pointer-events:none;color:var(--fg-4)}.ed-text{display:block;width:100%;min-height:54px;max-height:140px;resize:vertical;padding:8px 10px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;line-height:1.45;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast)}.ed-text::placeholder{color:var(--fg-5)}.ed-text:focus{border-color:#9968df80;background:#ffffff0d}.ed-more{align-self:flex-start;display:inline-flex;align-items:center;gap:6px;height:26px;padding:0 9px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-more:hover,.ed-more.on{background:#ffffff0d;color:var(--fg-1)}.ed-switch{display:flex;align-items:center;gap:10px;font-size:12px;color:var(--fg-2);cursor:pointer;user-select:none}.ed-switch input{position:absolute;opacity:0;width:0;height:0}.ed-switch i{position:relative;flex:none;width:30px;height:18px;border-radius:999px;background:#ffffff24;transition:background .2s ease}.ed-switch i:after{content:"";position:absolute;left:2px;top:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 3px #02040c80;transition:transform .25s var(--ease-out-soft)}.ed-switch input:checked+i{background:var(--amethyst-500)}.ed-switch input:checked+i:after{transform:translate(12px)}.ed-switch input:focus-visible+i{box-shadow:0 0 0 3px var(--cv-accent-soft)}.ed-radios{display:flex;flex-direction:column;gap:2px}.ed-radio-row{display:flex;align-items:center;gap:10px;height:32px;padding:0 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-radio-row:hover{background:#ffffff0d;color:var(--fg-1)}.ed-radio-row.on{color:#fff}.ed-go{display:flex;flex-direction:column;gap:9px}.ed-model-fixed,.ed-model-none{display:flex;align-items:center;gap:9px;min-height:32px;padding:0 2px;font-size:12px;color:var(--fg-2)}.ed-model-fixed .licon{flex:none;color:var(--fg-4)}.ed-model-fixed .tx{min-width:0;display:flex;flex-direction:column;gap:1px}.ed-model-fixed .nm{font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ed-model-fixed .why{font-size:10.5px;line-height:1.35;color:var(--fg-4)}.ed-model-none{color:var(--fg-4)}.ed-go-row{display:flex;align-items:center;gap:8px;container:edgo / inline-size}@container edgo (max-width: 228px){.ed-go-btn .licon{display:none}}@media(max-height:820px){.ed-model-fixed .why{display:none}.ed-go{gap:7px}}.ed-go-btn{flex:1;min-width:0;justify-content:center;height:40px;padding:0 12px;gap:7px}.ed-go-btn .lb{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-go-cost{display:flex;align-items:center;justify-content:center;gap:5px;margin-top:-3px;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.ed-bar{transition:border-color .3s ease,background .3s ease,box-shadow .3s ease}.ed-bar.is-tool{border-color:#9968df57;background:#100e1cf2;box-shadow:inset 0 1px #ffffff0b,0 0 0 4px #9968df0f,0 30px 80px #02040c9e}.ed-bar-tool{display:flex;align-items:center;gap:10px;height:40px;padding:0 2px 0 4px}.ed-bar-tool .ic{flex:none;width:30px;height:30px;border-radius:9px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df73,#5a61ed52);color:#fff;box-shadow:inset 0 1px #ffffff2e,0 6px 16px #7532d34d}.ed-bar-tool b{font-size:13.5px;font-weight:600;color:#fff;white-space:nowrap}.ed-bar-tool .dot{color:var(--fg-5)}.ed-bar-tool .st{min-width:0;display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--fg-3);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-bar-tool .grow{flex:1}.ed-bar-close{flex:none;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 12px 0 14px;border-radius:10px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.ed-bar-close:hover{background:#ffffff1a;border-color:#ffffff2e}.ed-bar-main{display:flex;flex-direction:column}.ed-bar-main .sv-prompt:disabled{opacity:.55;cursor:default}.ed-bar{container:edbar / inline-size}@container edbar (max-width: 600px){.ed-bar-modes>.sv-sep{display:none}}.ed-grow{flex:1 1 0;min-width:4px}.ed-modes{flex:none;display:inline-flex;align-items:center;gap:2px;padding:3px;border-radius:11px;background:#ffffff08;border:1px solid var(--hairline-soft)}.ed-mode{display:inline-flex;align-items:center;gap:7px;height:28px;padding:0 10px 0 7px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;font-weight:500;cursor:pointer;transition:background .2s ease,color .2s ease}.ed-mode .ed-radio{width:14px;height:14px}.ed-mode .ed-radio i{width:6px;height:6px;margin:-3px 0 0 -3px}.ed-mode:hover{color:var(--fg-1);background:#ffffff0a}.ed-mode.on{color:#fff;background:#9968df29}.ed-mode:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:1px}.sv-chip.is-fixed{cursor:default}.sv-chip.is-fixed:hover{background:#ffffff0a;color:var(--fg-2)}.ed-tools-inline{flex:none;display:inline-flex;align-items:center;gap:4px}.ed-seg-icons button{width:30px;min-width:30px;height:26px;padding:0}.ed-seg-icons button.on{background:#9968df3d;color:#fff;box-shadow:inset 0 0 0 1px #9968df61}.ed-icon-chip{flex:none;width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid transparent;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.ed-icon-chip:hover:not(:disabled){background:#ffffff12;color:var(--fg-1)}.ed-icon-chip.on{border-color:#ff5c7a6b;background:#ff5c7a1f;color:#ff9db0}.ed-icon-chip:disabled{opacity:.3;cursor:default}.ed-mini-sep{flex:none;width:1px;height:16px;margin:0 2px;background:var(--hairline-soft)}.ed-size{display:inline-flex;align-items:center;gap:7px;padding:0 4px 0 6px}.ed-size i{flex:none;display:inline-block;border-radius:50%;background:#ffffff8c;box-shadow:0 0 0 1px #fff3;transition:width .12s ease,height .12s ease}.ed-size input{width:64px;accent-color:var(--amethyst-500)}.ed-tool-chip{height:30px;padding:0 9px;gap:6px}.ed-tool-chip .chev{color:var(--fg-4);transition:transform var(--dur-fast)}.ed-tool-chip.on .chev{transform:rotate(180deg)}.ed-color{width:30px;height:30px;border-radius:9px;position:relative;overflow:hidden}.ed-color input[type=color]{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.ed-mark-pop{min-width:228px;padding:6px;display:grid;grid-template-columns:1fr 1fr;gap:2px}.ed-mark-row{display:flex;align-items:center;gap:9px;height:32px;padding:0 8px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-mark-row .nm{flex:1}.ed-mark-row:hover{background:#ffffff0f;color:var(--fg-1)}.ed-mark-row.on{background:var(--cv-accent-tint);color:#fff}.ed-mark-row.on kbd{background:#9968df4d;color:#fff}.ed-mark-size{grid-column:1 / -1;display:flex;align-items:center;gap:9px;padding:8px 8px 4px;margin-top:4px;border-top:1px solid var(--hairline-soft);font-size:11.5px;color:var(--fg-3);transition:opacity var(--dur-fast)}.ed-mark-size input{flex:1;accent-color:var(--amethyst-500)}.ed-mark-size b{min-width:20px;text-align:right;font-size:11.5px;color:var(--fg-1);font-variant-numeric:tabular-nums}.ed-mark-size.is-off{opacity:.35;pointer-events:none}.ed-mark-clear{grid-column:1 / -1;display:flex;align-items:center;gap:7px;height:30px;padding:0 8px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;cursor:pointer}.ed-mark-clear:hover:not(:disabled){background:#ff5c7a1a;color:#ff9db0}.ed-mark-clear:disabled{opacity:.35;cursor:default}.ed-guard{position:absolute;inset:0;z-index:30;display:flex;align-items:flex-end;justify-content:center;padding-bottom:26px;background:#04030c52;backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px)}.ed-guard-card{display:flex;align-items:center;gap:14px;width:min(560px,calc(100% - 40px));padding:14px 14px 14px 16px;border-radius:16px;background:#10111cfa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 30px 80px #02040cb3}.ed-guard-card .ic{flex:none;width:34px;height:34px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:#ffb34724;color:#ffc670}.ed-guard-card .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ed-guard-card .tx b{font-size:13.5px;font-weight:600;color:#fff}.ed-guard-card .tx span{font-size:11.5px;line-height:1.45;color:var(--fg-3)}.ed-guard-card .acts{flex:none;display:flex;gap:8px}.ed-guard-card .acts .sv-btn{height:34px;padding:0 14px;font-size:12.5px}.ed-guard-enter-active,.ed-guard-leave-active{transition:opacity .2s ease}.ed-guard-enter-active .ed-guard-card,.ed-guard-leave-active .ed-guard-card{transition:transform .3s var(--ease-out-soft),opacity .2s ease}.ed-guard-enter-from,.ed-guard-leave-to{opacity:0}.ed-guard-enter-from .ed-guard-card{transform:translateY(12px) scale(.98)}.ed-guard-leave-to .ed-guard-card{transform:translateY(6px)}.ed-ratios{display:grid;grid-template-columns:repeat(4,1fr);gap:4px}.ed-ratio{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;height:56px;padding:0;border:1px solid transparent;border-radius:10px;background:#ffffff08;color:var(--fg-3);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast),transform .2s var(--ease-out-soft)}.ed-ratio i{display:block;border-radius:3px;box-shadow:inset 0 0 0 1.5px currentColor;opacity:.85;transition:width .3s var(--ease-out-soft),height .3s var(--ease-out-soft)}.ed-ratio i.free{box-shadow:none;border:1.5px dashed currentColor}.ed-ratio:hover{background:#ffffff12;color:var(--fg-1)}.ed-ratio:active{transform:scale(.97)}.ed-ratio.on{border-color:#9968df80;background:#9968df29;color:#fff}.ed-ratio.is-more{color:var(--fg-4)}.ed-wh{display:flex;align-items:center;gap:6px}.ed-wh label{flex:1;min-width:0;display:flex;align-items:center;gap:6px;height:32px;padding:0 8px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff09;transition:border-color var(--dur-fast)}.ed-wh label:focus-within{border-color:#9968df80}.ed-wh label span{font-size:10.5px;font-weight:700;color:var(--fg-5)}.ed-wh input{flex:1;min-width:0;width:100%;border:0;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;font-variant-numeric:tabular-nums;outline:none;-moz-appearance:textfield}.ed-wh input::-webkit-inner-spin-button,.ed-wh input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.ed-wh .u{font-size:10.5px;color:var(--fg-5)}.ed-lock{flex:none;width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-lock:hover{background:#ffffff12;color:var(--fg-1)}.ed-lock.on{color:var(--amethyst-700)}.ed-crop{pointer-events:none;border-radius:12px;overflow:hidden}.ed-crop .shade{position:absolute;background:#04030c94;pointer-events:none;transition:background .24s ease}.ed-crop.is-active .shade{background:#04030ca8}.ed-crop-box{position:absolute;pointer-events:auto;cursor:move;box-shadow:inset 0 0 0 1.5px #ffffffeb,0 0 0 1px #04030c66;animation:edCropIn .34s var(--ease-out-soft) both}@keyframes edCropIn{0%{opacity:0;transform:scale(1.02)}to{opacity:1;transform:none}}.ed-crop-box .third{position:absolute;background:#ffffff5c;opacity:0;transition:opacity .2s ease;pointer-events:none}.ed-crop.is-active .ed-crop-box .third{opacity:1}.ed-crop-box .third.v1{left:33.333%;top:0;bottom:0;width:1px}.ed-crop-box .third.v2{left:66.666%;top:0;bottom:0;width:1px}.ed-crop-box .third.h1{top:33.333%;left:0;right:0;height:1px}.ed-crop-box .third.h2{top:66.666%;left:0;right:0;height:1px}.ed-crop-h{position:absolute;z-index:2;width:22px;height:22px;margin:-11px 0 0 -11px;pointer-events:auto}.ed-crop-h:after{content:"";position:absolute;left:50%;top:50%;width:11px;height:11px;margin:-5.5px 0 0 -5.5px;border-radius:3px;background:#fff;box-shadow:0 0 0 1.5px var(--amethyst-400),0 2px 6px #04030c73;transition:transform .18s var(--ease-out-soft)}.ed-crop-h:hover:after{transform:scale(1.25)}.ed-crop-h.h-n,.ed-crop-h.h-s{left:50%;cursor:ns-resize}.ed-crop-h.h-e,.ed-crop-h.h-w{top:50%;cursor:ew-resize}.ed-crop-h.h-n:after,.ed-crop-h.h-s:after{width:22px;height:6px;margin:-3px 0 0 -11px;border-radius:3px}.ed-crop-h.h-e:after,.ed-crop-h.h-w:after{width:6px;height:22px;margin:-11px 0 0 -3px;border-radius:3px}.ed-crop-h.h-nw{left:0;top:0;cursor:nwse-resize}.ed-crop-h.h-ne{left:100%;top:0;cursor:nesw-resize}.ed-crop-h.h-se{left:100%;top:100%;cursor:nwse-resize}.ed-crop-h.h-sw{left:0;top:100%;cursor:nesw-resize}.ed-crop-h.h-n{top:0}.ed-crop-h.h-s{top:100%}.ed-crop-h.h-e{left:100%}.ed-crop-h.h-w{left:0}.ed-crop-size{position:absolute;left:50%;bottom:10px;transform:translate(-50%);padding:3px 9px;border-radius:999px;white-space:nowrap;pointer-events:none;background:#04030cb8;color:#fff;font-size:11px;font-weight:600;font-variant-numeric:tabular-nums;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px)}.ed-expand{position:absolute;border-radius:12px;animation:svPic .36s var(--ease-out-soft) both;transition:left .28s var(--ease-out-soft),top .28s var(--ease-out-soft),width .28s var(--ease-out-soft),height .28s var(--ease-out-soft)}.ed-expand-room{position:absolute;inset:0;border-radius:12px;border:1.5px dashed rgba(199,166,255,.55);background-color:#9968df0d;background-image:radial-gradient(rgba(255,255,255,.11) 1px,transparent 1.4px);background-size:14px 14px;background-repeat:repeat}.ed-expand-pic{position:absolute;cursor:move;border-radius:4px;overflow:hidden;box-shadow:0 0 0 1.5px #ffffffe6,0 18px 50px #0206178c}.ed-expand.is-active .ed-expand-pic{transition:none}.ed-expand-pic img{display:block;width:100%;height:100%;object-fit:fill;user-select:none;-webkit-user-drag:none}.ed-expand-h{position:absolute;z-index:2;display:flex;align-items:center;justify-content:center}.ed-expand-h i{display:block;border-radius:3px;background:#fff;box-shadow:0 0 0 1.5px var(--amethyst-400),0 2px 6px #04030c73;transition:transform .18s var(--ease-out-soft)}.ed-expand-h:hover i{transform:scale(1.2)}.ed-expand-h.h-n,.ed-expand-h.h-s{left:0;right:0;height:22px;cursor:ns-resize}.ed-expand-h.h-n{top:-11px}.ed-expand-h.h-s{bottom:-11px}.ed-expand-h.h-n i,.ed-expand-h.h-s i{width:28px;height:6px}.ed-expand-h.h-e,.ed-expand-h.h-w{top:0;bottom:0;width:22px;cursor:ew-resize}.ed-expand-h.h-e{right:-11px}.ed-expand-h.h-w{left:-11px}.ed-expand-h.h-e i,.ed-expand-h.h-w i{width:6px;height:28px}.ed-tabs.is-three button{padding:0 6px}.ed-fills{display:grid;grid-template-columns:repeat(6,1fr);gap:7px}.ed-fill{position:relative;aspect-ratio:1;padding:0;border:0;border-radius:9px;cursor:pointer;background:var(--c);box-shadow:inset 0 0 0 1px #ffffff29;transition:transform .2s var(--ease-out-soft),box-shadow var(--dur-fast)}.ed-fill:hover{transform:scale(1.07)}.ed-fill.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.ed-fill.is-clear{background-color:#2a2c36;background-image:conic-gradient(rgba(255,255,255,.22) 25%,transparent 0 50%,rgba(255,255,255,.22) 0 75%,transparent 0);background-size:10px 10px;background-repeat:repeat}.ed-fill.is-any{background:conic-gradient(#ff3d6e,#ffc93c,#4ade80,#36d6ff,#7c4dff,#ff3d6e);overflow:hidden}.ed-fill.is-any.on{background:var(--c)}.ed-fill.is-any input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.sv-pic.is-cutout{background-color:#2a2c36;background-image:conic-gradient(rgba(255,255,255,.07) 25%,transparent 0 50%,rgba(255,255,255,.07) 0 75%,transparent 0);background-size:22px 22px;background-repeat:repeat}.ed-layers-canvas{position:absolute;inset:0;border-radius:12px;pointer-events:none}.ed-refpick{display:flex;flex-direction:column;gap:6px}.ed-refpick-row{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}.ed-refpick-cell{position:relative;aspect-ratio:1;padding:0;border:0;border-radius:9px;overflow:hidden;cursor:pointer;background:#ffffff0a;opacity:.72;transition:opacity var(--dur-fast),transform .2s var(--ease-out-soft),box-shadow var(--dur-fast)}.ed-refpick-cell:after{content:"";position:absolute;inset:0;border-radius:9px;box-shadow:inset 0 0 0 1px #ffffff1a;pointer-events:none;transition:box-shadow var(--dur-fast)}.ed-refpick-cell:hover{opacity:1;transform:translateY(-1px)}.ed-refpick-cell.on{opacity:1}.ed-refpick-cell.on:after{box-shadow:inset 0 0 0 2px var(--amethyst-500)}.ed-refpick-cell .tag{position:absolute;left:4px;bottom:4px;z-index:2;padding:1px 5px;border-radius:999px;background:#04030cb8;color:#fff;font-size:9.5px;font-weight:600}.ed-groups{display:flex;flex-direction:column;gap:2px;margin:0 -4px}.ed-group{border-radius:10px;transition:background .24s ease}.ed-group.on{background:#ffffff06}.ed-group-head{display:flex;align-items:center}.ed-group-btn{flex:1;min-width:0;display:flex;align-items:center;gap:9px;height:34px;padding:0 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-group-btn .ic{color:var(--fg-4);transition:color var(--dur-fast)}.ed-group-btn .t{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ed-group-btn .chev{color:var(--fg-5)}.ed-group-btn:hover{background:#ffffff0a;color:var(--fg-1)}.ed-group.on .ed-group-btn{color:#fff}.ed-group.on .ed-group-btn .ic,.ed-group.is-changed .ed-group-btn .ic{color:var(--amethyst-600)}.ed-changed{flex:none;width:6px;height:6px;border-radius:50%;background:var(--amethyst-500);box-shadow:0 0 0 3px #9968df2e}.ed-group-reset{flex:none;width:26px;height:26px;margin-right:4px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-group-reset:hover{background:#ffffff12;color:#fff}.ed-group-body{display:flex;flex-direction:column;gap:12px;padding:4px 8px 12px}.ed-looks{display:grid;grid-template-columns:repeat(2,1fr);gap:6px}.ed-look{display:flex;flex-direction:column;gap:5px;padding:4px;border:1px solid transparent;border-radius:10px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-look .sw{position:relative;display:block;height:46px;border-radius:7px;overflow:hidden;background:#ffffff0d}.ed-look:hover{background:#ffffff0d;color:var(--fg-1)}.ed-look.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-look .nm{padding:0 2px 2px;text-align:left}.ed-look.look-vintage .sw{filter:sepia(.35) saturate(.75) contrast(.92) brightness(1.04)}.ed-look.look-retro-film .sw{filter:contrast(1.12) saturate(.88) hue-rotate(-8deg) sepia(.12)}.ed-look.look-duotone .sw{filter:grayscale(1) sepia(.6) hue-rotate(220deg) saturate(1.6) contrast(1.05)}.ed-look.look-vibrant .sw{filter:saturate(1.45) contrast(1.08)}.ed-look.look-warm .sw{filter:sepia(.22) saturate(1.15) hue-rotate(-6deg)}.ed-look.look-cool-breeze .sw{filter:hue-rotate(12deg) saturate(.9) brightness(1.05)}.ed-look.look-red-tint .sw{filter:sepia(.3) hue-rotate(-30deg) saturate(1.4)}.ed-look.look-cold .sw{filter:hue-rotate(18deg) saturate(.75) contrast(1.04)}.ed-look.look-mono .sw{filter:grayscale(1) contrast(1.15)}.ed-look.look-matte .sw{filter:contrast(.8) brightness(1.08) saturate(.85)}.ed-wheels{display:grid;grid-template-columns:repeat(3,1fr);gap:6px}.ed-wheel{display:flex;flex-direction:column;align-items:center;gap:6px}.ed-wheel-disc{position:relative;width:60px;height:60px;border-radius:50%;cursor:crosshair;touch-action:none;outline:none;background:radial-gradient(circle,gray,#80808000 72%),conic-gradient(from 0deg,#ff4d4d,#ffd24d,#4dff6a,#4dffff,#4d6aff,#d24dff,#ff4d4d);box-shadow:inset 0 0 0 1px #ffffff24,0 4px 14px #02040c66}.ed-wheel-disc:focus-visible{box-shadow:0 0 0 3px var(--cv-accent-soft)}.ed-wheel-dot{position:absolute;width:12px;height:12px;margin:-6px 0 0 -6px;border-radius:50%;background:#fff9;box-shadow:0 0 0 2px #04030c99;pointer-events:none;transition:left .06s linear,top .06s linear}.ed-wheel-dot.on{background:#fff}.ed-wheel-lb{font-size:10.5px;font-weight:600;color:var(--fg-3)}.ed-wheel-lum{width:60px;accent-color:var(--amethyst-500)}.ed-bands{display:flex;justify-content:space-between;gap:4px}.ed-band{position:relative;width:22px;height:22px;padding:0;border:0;border-radius:50%;background:var(--c);cursor:pointer;box-shadow:inset 0 0 0 1px #fff3;transition:transform .2s var(--ease-out-soft),box-shadow var(--dur-fast)}.ed-band:hover{transform:scale(1.1)}.ed-band.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.ed-band.is-changed:after{content:"";position:absolute;right:-2px;top:-2px;width:7px;height:7px;border-radius:50%;background:#fff;box-shadow:0 0 0 2px #0b0d15}.ed-overlay-row{display:flex;align-items:center;gap:8px}.ed-overlay-row .ed-select{flex:1}.ed-turns{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}.ed-turns .sv-btn{justify-content:center;height:32px;padding:0}.ed-hold{user-select:none}.ed-hold:active{background:#ffffff24}.ed-adjust-canvas{position:absolute;inset:0;border-radius:12px;pointer-events:none;opacity:0;transition:opacity .2s ease}.ed-adjust-canvas.is-ready{opacity:1}.ed-stage-note{position:absolute;left:50%;bottom:12px;transform:translate(-50%);z-index:3;padding:4px 10px;border-radius:999px;white-space:nowrap;pointer-events:none;background:#04030ca8;color:#ffffffd1;font-size:11px;font-weight:500;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px)}.ed-area-layer{cursor:crosshair}.ed-area-layer.tool-brush{cursor:none}.ed-area-layer.tool-object{cursor:default}.ed-area-layer.tool-object.is-over{cursor:pointer}.ed-area-paint,.ed-area-hover,.ed-area-lasso{position:absolute;inset:0;border-radius:12px;pointer-events:none}.ed-area-paint{animation:edAreaBreathe 2.6s ease-in-out infinite}@keyframes edAreaBreathe{0%,to{opacity:1}50%{opacity:.86}}@media(prefers-reduced-motion:reduce){.ed-area-paint{animation:none}}.ed-area-hover{transition:opacity .12s ease}.ed-area-lasso path{fill:#a876ff29;stroke:#fff;stroke-width:1.5;stroke-dasharray:5 4;animation:edAnts .6s linear infinite}.ed-area-layer.is-cut .ed-area-lasso path{fill:#ff5c6e1f}@keyframes edAnts{to{stroke-dashoffset:-9}}.ed-area-ring{border-color:#fff;background:#a876ff24}.ed-area-layer.is-erase .ed-area-ring{background:#ff5c6e29}.ed-area-ring.is-eraser{border-style:dashed;background:#ffffff0f}.ed-area-find{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:4;display:inline-flex;align-items:center;gap:8px;padding:8px 14px;border-radius:999px;background:#04030cc7;color:#fff;font-size:12px;font-weight:500;white-space:nowrap;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);box-shadow:0 14px 40px #02040c80}.ed-area-find-btn{display:inline-flex;align-items:center;gap:8px;padding:0;border:0;background:transparent;color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.ed-area-find-btn .tk{display:inline-flex;align-items:center;gap:3px;padding:2px 7px;border-radius:999px;background:#ffffff24;font-size:11px}.ed-area-find:has(.ed-area-find-btn):hover{background:#7532d3e0}.ed-stage-tools{position:absolute;left:12px;bottom:14px;z-index:5;display:flex;align-items:center;gap:6px;animation:svPop .24s var(--ease-out-soft) backwards}.ed-stage-btn{display:inline-flex;align-items:center;gap:7px;height:30px;padding:0 12px;border-radius:999px;white-space:nowrap;border:1px solid rgba(255,255,255,.2);background:#04030ca8;color:#fff;font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);transition:background var(--dur-fast),border-color var(--dur-fast)}.ed-stage-btn:hover{background:#04030cd1}.ed-stage-btn.on{background:var(--cv-accent);border-color:transparent}.ed-compare{z-index:3;cursor:ew-resize}.ed-compare.is-toggle{cursor:pointer}.ed-compare-other{position:absolute;inset:0;border-radius:12px;overflow:hidden;transition:opacity .18s ease}.ed-compare.is-split .ed-compare-other{transition:none}.ed-compare-other img{display:block;width:100%;height:100%;object-fit:cover;user-select:none;-webkit-user-drag:none}.ed-compare-line{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;background:#fff;box-shadow:0 0 0 1px #04030c59,0 0 18px #04030c66;pointer-events:none}.ed-compare-line span{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:30px;height:30px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#fff;color:#1a1530;box-shadow:0 4px 14px #04030c80}.ed-compare-line span .licon{margin:0 -3px}.ed-compare-tag{position:absolute;top:10px;z-index:2;padding:3px 9px;border-radius:999px;background:#04030cb3;color:#fff;font-size:11px;font-weight:600;pointer-events:none}.ed-compare-tag.is-left{left:10px}.ed-compare-tag.is-right{right:10px}.ed-baking{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:6;display:inline-flex;align-items:center;gap:9px;padding:9px 16px;border-radius:999px;background:#04030ccc;color:#fff;font-size:12.5px;font-weight:500;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);box-shadow:0 14px 40px #02040c80}.sv-pic.is-tool{box-shadow:0 0 0 1px #ffffff14,0 30px 90px #0206179e}.ed-orbit{display:grid;grid-template-columns:minmax(0,1fr) 76px;gap:6px;align-items:center;padding:6px 4px 2px;border-radius:12px;background:radial-gradient(ellipse at 50% 60%,#9968df1a,#ffffff04 70%);border:1px solid var(--hairline-soft)}.ed-orbit svg{display:block;width:100%;height:auto;touch-action:none;cursor:grab;overflow:visible;outline:none}.ed-orbit svg:active{cursor:grabbing}.ed-orbit svg:focus-visible{filter:drop-shadow(0 0 4px rgba(153,104,223,.6))}.ed-orbit .track{fill:none;stroke:#fff3;stroke-width:1.2}.ed-orbit .track.is-inner{stroke:#ffffff12;stroke-dasharray:2 3}.ed-orbit .ground{stroke:#ffffff24;stroke-width:1}.ed-orbit .stop{fill:#ffffff59;transition:fill .2s ease,r .2s ease}.ed-orbit .stop.on{fill:#fff}.ed-orbit .origin{fill:#ffffff47}.ed-orbit .card{fill:#c7a6ff8c;stroke:#fff9;stroke-width:.8}.ed-orbit .ray{stroke:#c7a6ff8c;stroke-width:1;stroke-dasharray:2 2.5}.ed-orbit .ray.is-behind{stroke:#ffb34799}.ed-orbit .cam{transition:transform .18s var(--ease-out-soft)}.ed-orbit .cam .halo{fill:#9968df38}.ed-orbit .cam .dot{fill:#fff;stroke:var(--amethyst-400);stroke-width:2}.ed-camera-name{margin-top:-4px;text-align:center;font-size:12.5px;font-weight:600;color:#fff;letter-spacing:-.005em}.ed-seed{display:flex;align-items:center;justify-content:space-between;gap:8px}.ed-cam-stage{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;animation:svPic .36s var(--ease-out-soft) both}.ed-cam-view{position:relative;flex:1;width:100%;display:flex;align-items:center;justify-content:center;perspective:1500px;perspective-origin:50% 40%;overflow:hidden}.ed-cam-scene{position:relative;width:0;height:0;transform-style:preserve-3d;transition:transform .5s var(--ease-out-soft)}.ed-cam-floor{position:absolute;left:-480px;top:-480px;width:960px;height:960px;transform:rotateX(90deg);border-radius:50%;background:radial-gradient(circle,rgba(153,104,223,.16),transparent 62%),repeating-linear-gradient(0deg,rgba(255,255,255,.07) 0 1px,transparent 1px 48px),repeating-linear-gradient(90deg,rgba(255,255,255,.07) 0 1px,transparent 1px 48px);-webkit-mask-image:radial-gradient(circle,#000 30%,transparent 68%);mask-image:radial-gradient(circle,#000 30%,transparent 68%)}.ed-cam-box{position:absolute;left:0;top:0;transform-style:preserve-3d}.ed-cam-face{position:absolute;display:block;backface-visibility:hidden;-webkit-backface-visibility:hidden}.ed-cam-face.is-front{left:0;top:0;width:100%;height:100%;object-fit:cover;border-radius:3px;box-shadow:0 0 0 1px #ffffff24}.ed-cam-face.is-side{background-repeat:no-repeat;filter:blur(1.2px) brightness(.5) saturate(.7)}.ed-cam-face.is-side:after,.ed-cam-face.is-back:after{content:"";position:absolute;inset:0;background-image:linear-gradient(#16122661,#16122661),repeating-linear-gradient(45deg,rgba(255,255,255,.08) 0 2px,transparent 2px 9px);background-repeat:repeat;box-shadow:inset 0 0 0 1px #ffb34761}.ed-cam-face.is-top{filter:blur(1.2px) brightness(.62) saturate(.7)}.ed-cam-face.is-back{display:flex;align-items:center;justify-content:center;filter:none;background-image:none!important;background-color:#1a162cf5}.ed-cam-face.is-back span{position:relative;z-index:1;padding:4px 10px;border-radius:999px;background:#ffb34724;color:#ffd08a;font-size:11px;font-weight:600;transform:scaleX(-1) scaleX(-1)}.ed-cam-hud{flex:none;display:flex;flex-direction:column;align-items:center;gap:3px;padding:10px 0 18px;text-align:center}.ed-cam-hud b{font-size:14px;font-weight:600;color:#fff}.ed-cam-hud span{font-size:11.5px;color:var(--fg-3)}@media(prefers-reduced-motion:reduce){.ed-cam-scene{transition:none}}.ed-looks.is-light{grid-template-columns:repeat(3,1fr);gap:4px}.ed-light-look{display:flex;flex-direction:column;align-items:center;gap:5px;padding:7px 2px 6px;border:1px solid transparent;border-radius:10px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:10px;font-weight:600;line-height:1.2;text-align:center;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-light-look i{width:26px;height:26px;border-radius:50%;box-shadow:inset 0 0 0 1px #ffffff2e,0 4px 12px #02040c73;transition:transform .25s var(--ease-out-soft)}.ed-light-look:hover{background:#ffffff0d;color:var(--fg-1)}.ed-light-look:hover i{transform:scale(1.08)}.ed-light-look.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-rig{display:flex;align-items:center;gap:12px}.ed-sphere{position:relative;flex:none;border-radius:50%}.ed-sphere canvas{display:block;border-radius:50%}.ed-sphere-light{position:absolute;z-index:2;width:20px;height:20px;margin:-10px 0 0 -10px;padding:0;border:2px solid #fff;border-radius:50%;background:var(--c);color:#16141f;font-family:var(--font-sans);font-size:10px;font-weight:800;cursor:pointer;box-shadow:0 0 0 1px #04030c80,0 0 14px var(--c);transition:left .3s var(--ease-out-soft),top .3s var(--ease-out-soft),transform .2s var(--ease-out-soft),opacity .2s ease}.ed-sphere-light.is-behind{opacity:.45;border-style:dashed}.ed-sphere-light.on{transform:scale(1.18);box-shadow:0 0 0 2px var(--amethyst-400),0 0 18px var(--c)}.ed-lights{flex:1;min-width:0;display:flex;flex-direction:column;gap:4px}.ed-light-chip{display:flex;align-items:center;gap:8px;height:28px;padding:0 6px 0 8px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff08;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:600;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-light-chip{white-space:nowrap}.ed-light-chip .nm{min-width:0;overflow:hidden;text-overflow:ellipsis}.ed-light-chip i{flex:none;width:10px;height:10px;border-radius:50%;background:var(--c);box-shadow:0 0 8px var(--c)}.ed-light-chip .x{margin-left:auto;width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;color:var(--fg-4)}.ed-light-chip .x:hover{background:#ff5c7a24;color:#ff9db0}.ed-light-chip:hover{background:#ffffff0f;color:var(--fg-1)}.ed-light-chip.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-light-chip.is-add{border-style:dashed;color:var(--fg-4);justify-content:center}.ed-quick{display:grid;grid-template-columns:repeat(6,1fr);gap:3px}.ed-quick-btn{height:26px;padding:0;border:0;border-radius:7px;background:#ffffff0a;color:var(--fg-3);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-quick-btn:hover{background:#ffffff14;color:var(--fg-1)}.ed-quick-btn.on{background:#9968df3d;color:#fff}.ed-whites{display:grid;grid-template-columns:repeat(7,1fr);gap:3px}.ed-white{display:flex;flex-direction:column;align-items:center;gap:3px;padding:4px 0;border:1px solid transparent;border-radius:8px;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:9px;font-weight:600;cursor:pointer}.ed-white i{width:16px;height:16px;border-radius:50%;background:var(--c);box-shadow:inset 0 0 0 1px #ffffff40}.ed-white:hover{background:#ffffff0d;color:var(--fg-1)}.ed-white.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-gels{display:flex;align-items:center;gap:6px;margin-top:4px}.ed-gel{position:relative;width:20px;height:20px;padding:0;border:0;border-radius:50%;background:var(--c);cursor:pointer;box-shadow:inset 0 0 0 1px #ffffff38;transition:transform .2s var(--ease-out-soft)}.ed-gel:hover{transform:scale(1.12)}.ed-gel.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.ed-gel.is-any{background:conic-gradient(#ff3d6e,#ffc93c,#4ade80,#36d6ff,#7c4dff,#ff3d6e);overflow:hidden}.ed-gel.is-any input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.ed-relight-preview{position:absolute;inset:0;border-radius:12px;overflow:hidden;pointer-events:none}.ed-relight-preview .wash,.ed-relight-preview .shade{position:absolute;inset:0;transition:opacity .4s ease,background .4s ease}.ed-relight-preview .wash{mix-blend-mode:overlay}.ed-relight-preview .shade{mix-blend-mode:multiply}@media(max-width:1180px){.ed-mode{padding:0 8px 0 6px}.ed-size input{width:48px}}.sv-warn .licon{flex:none}.ed-panel .sv-warn{align-items:flex-start;line-height:1.45;font-size:11.5px}.ed-panel .sv-warn .licon{margin-top:2px}.ed-card{position:relative;display:flex;flex-direction:row;align-items:stretch;gap:12px;padding:1px 0 0}.ed-side{flex:none;width:30px;padding-top:1px}.up-side-btn:disabled{opacity:.35;cursor:default;background:transparent;color:var(--fg-4)}.ed-col{flex:1;min-width:0;display:flex;flex-direction:column;gap:10px}.ed-words,.sv-describe-text{display:block;height:48px;max-height:160px}.ed-words:disabled{opacity:.55;cursor:default}.ed-bar-modes{display:flex;align-items:center;gap:6px;row-gap:6px;min-width:0;flex-wrap:wrap}.ed-keep .licon{color:#c7a6ff}.ed-keep-pop{min-width:0;width:280px}.ed-keep-row{height:auto;align-items:flex-start;gap:10px;padding:8px 10px}.ed-keep-row .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.ed-keep-row .nm{color:var(--fg-1)}.ed-keep-row .hint{font-size:11px;line-height:1.4;color:var(--fg-4);white-space:normal}.ed-keep-row .ck{flex:none;margin-top:2px;color:var(--cv-accent-text)}.ed-refs{align-items:center;min-height:56px}.ed-ref{overflow:visible}.ed-ref .sv-art{border-radius:12px}.ed-ref:after{content:"";position:absolute;inset:0;border-radius:inherit;box-shadow:inset 0 0 0 1px #ffffff1f;pointer-events:none}.ed-ref button{z-index:2}.ed-ref .up-ref-pulse{z-index:1}.ed-ref .sv-art{transition:opacity var(--dur-fast)}.ed-ref.is-unsent .sv-art{opacity:.38}.ed-ref.is-unsent:after{box-shadow:none;border:1px dashed rgba(255,255,255,.4)}.ed-ref-leave-active{transition:opacity .16s ease,transform .16s ease}.ed-ref-leave-to{opacity:0;transform:scale(.85)}.ed-ref-move{transition:transform .26s var(--ease-out-soft)}.ed-refs-hint{margin-left:6px;font-size:11.5px;line-height:1.4;color:var(--fg-4);transition:color var(--dur-fast)}.ed-refs-hint.is-air{color:var(--cv-accent-text)}.up-drop.is-air{border-color:#9968df99;color:var(--cv-accent-soft);animation:edAir .9s ease-in-out infinite alternate}@keyframes edAir{0%{background:#9968df0a}to{background:#9968df29}}.ed-bar.is-over{border-color:#9968df80;box-shadow:inset 0 1px #ffffff0b,0 0 0 4px #9968df1a,0 30px 80px #02040c9e}.ed-ref-peek{z-index:12}.ed-fold-enter-active,.ed-fold-leave-active{transition:opacity .2s ease,transform .24s var(--ease-out-soft)}.ed-fold-enter-from,.ed-fold-leave-to{opacity:0;transform:translateY(4px)}.ed-fold-leave-active{position:absolute}.up-model.is-fixed{cursor:default}.up-model.is-fixed:hover{background:transparent}.sv-pfoot{width:100%;container:pfoot / inline-size;flex-wrap:wrap;row-gap:8px}@container pfoot (max-width: 520px){.sv-pfoot .up-foot-sep{display:none}.sv-pfoot>.up-chips{flex-basis:100%}.sv-pfoot>.up-chips+*{margin-left:auto}}.sv-describe .sv-pfoot{margin-top:2px}.sv-dock.is-nudge{animation:upNudge .42s var(--ease-out-soft)}.sv-dock.is-nudge .up-run-wrap .tip{opacity:1}.sv-root.is-dropper{--dropper-cursor: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke-linecap='round' stroke-linejoin='round'><g stroke='%23070910' stroke-width='4'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g><g stroke='white' stroke-width='2'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g></svg>") 2 22, crosshair}.sv-hist.is-dropper .sv-cell,.sv-vers.is-dropper .sv-ver{cursor:var(--dropper-cursor)}.sv-hist.is-dropper .sv-cell:hover .frame{transform:translateY(-2px);box-shadow:0 0 0 2px var(--amethyst-500),0 0 0 6px #9968df38,0 12px 28px #02040c80}.sv-vers.is-dropper .sv-ver:hover{box-shadow:0 0 0 2px var(--amethyst-500),0 0 0 6px #9968df38}.sv-cell-drop{position:absolute;left:7px;top:7px;z-index:4;display:inline-flex;align-items:center;gap:5px;padding:3px 9px 3px 7px;border-radius:999px;background:#04030cd1;color:#fff;font-size:11px;font-weight:600;white-space:nowrap;box-shadow:0 4px 14px #02040c73;opacity:0;transform:translateY(-3px);pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.sv-cell-drop .licon{color:var(--cv-accent-text)}.sv-cell-drop.is-in{color:var(--fg-2)}.sv-cell-drop.is-in .licon{color:var(--fg-3)}.sv-hist.is-dropper .sv-cell:hover .sv-cell-drop{opacity:1;transform:none}.bd-dropper.sv-dropper{top:10px;z-index:30}.sv-main:has(.sv-vers) .bd-dropper.sv-dropper{top:92px}@media(prefers-reduced-motion:reduce){.up-drop.is-air{animation:none;background:#9968df1f}.sv-dock.is-nudge{animation:none}.ed-fold-enter-active,.ed-fold-leave-active,.ed-ref-leave-active,.ed-ref-move{transition:none}}.sv-fp-link{flex:none;display:inline-flex;align-items:center;gap:4px;height:30px;padding:0 7px;margin-right:1px;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;font-family:var(--font-sans);font-size:11px;font-weight:500;white-space:nowrap;transition:color var(--dur-fast),background var(--dur-fast)}.sv-fp-link:hover{color:var(--fg-2);background:#ffffff0a}.sv-fp-link.on{color:var(--fg-2)}.sv-fp-link .chev{color:inherit;opacity:.7;transition:transform .22s var(--ease-out-soft)}.sv-fp-link.on .chev{transform:rotate(180deg)}.sv-fp-link .dot{width:5px;height:5px;border-radius:50%;background:var(--amethyst-500);box-shadow:0 0 0 2px #9968df2e}.ed-go-full{display:flex;justify-content:center;margin:-4px 0 -6px}.ed-go-full .sv-fp-link{height:24px}.sv-fp{display:flex;flex-direction:column;gap:6px;padding:8px 10px 9px;border-radius:12px;background:#ffffff06;border:1px solid var(--hairline-soft);transition:border-color .24s ease,background .24s ease}.sv-fp.is-edited{border-color:#9968df5c;background:#9968df0e}.sv-fp-head{display:flex;align-items:center;gap:8px;min-height:22px}.sv-fp-head .t{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5)}.sv-fp-tag{padding:1px 7px;border-radius:999px;background:#9968df2e;color:var(--amethyst-800);font-size:10px;font-weight:600;letter-spacing:.02em}.sv-fp-tag-enter-active,.sv-fp-tag-leave-active{transition:opacity .18s ease,transform .2s var(--ease-out-soft)}.sv-fp-tag-enter-from,.sv-fp-tag-leave-to{opacity:0;transform:scale(.85)}.sv-fp-reset{display:inline-flex;align-items:center;gap:4px;height:22px;padding:0 7px;border:0;border-radius:7px;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:11px;font-weight:500;cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast)}.sv-fp-reset:hover{color:var(--fg-1);background:#ffffff0f}.sv-fp-text{display:block;width:100%;min-height:54px;max-height:180px;resize:none;padding:1px 0;border:0;outline:none;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;line-height:1.55;overflow-y:auto;white-space:pre-wrap;user-select:text;-webkit-user-select:text;transition:color var(--dur-fast)}.sv-fp-text:focus,.sv-fp.is-edited .sv-fp-text{color:var(--fg-1)}.sv-fp-text::-webkit-scrollbar{width:6px}.sv-fp-text::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.sv-fp-foot{display:flex;align-items:center;gap:10px}.sv-fp-note{flex:1;min-width:0;font-size:11px;line-height:1.4;color:var(--fg-5)}.sv-fp.is-edited .sv-fp-note{color:var(--fg-4)}.sv-fp-run{height:26px;padding:0 13px;font-size:11.5px}.sv-fp.is-tool{margin:6px 0 0}.sv-fp.is-tool .sv-fp-text{max-height:140px}.sv-fp.is-tool .sv-fp-foot{flex-direction:column;align-items:stretch;gap:8px}.sv-fp.is-tool .up-run-wrap,.sv-fp.is-tool .sv-fp-run{width:100%;justify-content:center}@media(prefers-reduced-motion:reduce){.sv-fp-link .chev,.sv-fp,.sv-fp-tag-enter-active,.sv-fp-tag-leave-active{transition:none}}.ed-views{display:flex;flex-direction:column;gap:8px;padding:9px 10px 10px;border-radius:12px;background:#ffffff06;border:1px solid var(--hairline-soft)}.ed-views-head{display:flex;align-items:center;gap:7px;min-height:24px}.ed-views-head .t{white-space:nowrap;font-size:9.5px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.ed-views-only{flex:none;display:inline-flex;align-items:center;gap:3px;padding:1px 6px;border-radius:999px;white-space:nowrap;background:#9968df1f;color:var(--amethyst-800);font-size:9.5px;font-weight:600}.ed-views-save{display:inline-flex;align-items:center;gap:5px;height:28px;padding:0 11px;border-radius:999px;white-space:nowrap;border:1px dashed rgba(255,255,255,.2);background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-views-save:hover:not(:disabled){background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff}.ed-views-save:disabled{cursor:default;color:var(--fg-5)}.ed-views-save.is-saved{border-style:solid;border-color:transparent;color:var(--fg-4);padding:0 6px}.ed-views-list{display:flex;flex-wrap:wrap;gap:6px}.ed-view{position:relative;display:inline-flex;max-width:100%}.ed-view-chip{display:inline-flex;align-items:center;gap:6px;max-width:100%;height:28px;padding:0 22px 0 9px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:500;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-view-chip .licon{flex:none;color:var(--fg-4)}.ed-view-chip .nm{min-width:0;overflow:hidden;text-overflow:ellipsis}.ed-view-chip:hover{background:#ffffff14;color:var(--fg-1)}.ed-view.on .ed-view-chip{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:#fff}.ed-view.on .ed-view-chip .licon{color:var(--cv-accent-text)}.ed-view-x{position:absolute;right:4px;top:50%;width:18px;height:18px;margin-top:-9px;padding:0;border:0;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:transparent;color:var(--fg-5);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.ed-view:hover .ed-view-x,.ed-view-x:focus-visible{opacity:1}.ed-view-x:hover{background:#ff5c7a29;color:#ff9db0}.ed-view-input{height:28px;width:180px;max-width:100%;padding:0 10px;border-radius:999px;border:1px solid var(--cv-accent-soft);background:#9968df14;color:#fff;font-family:var(--font-sans);font-size:11.5px;outline:none;box-shadow:0 0 0 3px #9968df24}.ed-views-empty{margin:0;font-size:11px;line-height:1.45;color:var(--fg-5)}.ed-view-enter-active{transition:opacity .22s ease,transform .26s var(--ease-out-soft)}.ed-view-leave-active{transition:opacity .16s ease,transform .16s ease}.ed-view-enter-from,.ed-view-leave-to{opacity:0;transform:scale(.85)}.ed-view-move{transition:transform .24s var(--ease-out-soft)}@media(prefers-reduced-motion:reduce){.ed-view-enter-active,.ed-view-leave-active,.ed-view-move{transition:none}}.sv-root.hist-shut{--hist-col: 0px}.sv-hist-body{flex:1;min-height:0;display:flex;flex-direction:column;gap:inherit;transition:opacity .22s ease}.sv-hist.is-shut,.sv-hist.is-moving{overflow:hidden}.sv-hist.is-shut .sv-hist-body,.sv-hist.is-moving .sv-hist-body{flex:none;align-self:flex-end;width:calc(var(--hist-w) - 40px);height:100%}.sv-hist.is-shut .sv-hist-body{opacity:0;pointer-events:none}.sv-hist-fold{margin-left:-2px}.sv-hist.is-shut{padding:0;visibility:hidden;transition:visibility 0s linear .34s}.sv-hist-show .n{padding:1px 7px;border-radius:999px;background:#ffffff12;color:var(--fg-2);font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums}.sv-hist-show-enter-active{transition:opacity .22s ease .12s,transform .28s var(--ease-out-soft) .12s}.sv-hist-show-leave-active{transition:opacity .12s ease}.sv-hist-show-enter-from{opacity:0;transform:translate(10px)}.sv-hist-show-leave-to{opacity:0}@media(prefers-reduced-motion:reduce){.sv-root,.sv-hist.is-shut,.sv-hist-body,.sv-hist-show-enter-active,.sv-hist-show-leave-active{transition:none}}.ed-color i{position:relative;overflow:hidden;background:transparent;box-shadow:none}.ed-color i:before{content:"";position:absolute;inset:0;border-radius:inherit;background:conic-gradient(#ffffff57 25%,#ffffff14 0 50%,#ffffff57 0 75%,#ffffff14 0) 0 0 / 8px 8px}.ed-color i:after{content:"";position:absolute;inset:0;border-radius:inherit;background:var(--c);opacity:var(--o, 1);box-shadow:inset 0 0 0 1.5px #ffffff4d;transition:opacity var(--dur-fast)}.sv-pop.ed-colour-pop{flex-direction:column;align-items:stretch;gap:10px;padding:10px 12px 11px}.ed-swatch-row{display:flex;align-items:center;gap:8px}.ed-opacity{display:flex;align-items:center;gap:10px}.ed-opacity .lb{flex:none;font-size:9.5px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.ed-opacity b{flex:none;min-width:34px;text-align:right;font-size:11.5px;font-weight:600;color:var(--fg-1);font-variant-numeric:tabular-nums}.ed-opacity.is-off{opacity:.45}.ed-opacity-range{-webkit-appearance:none;appearance:none;flex:1;min-width:96px;height:10px;margin:0;border-radius:999px;cursor:pointer;background:linear-gradient(90deg,transparent,var(--c)),conic-gradient(#ffffff42 25%,#ffffff0f 0 50%,#ffffff42 0 75%,#ffffff0f 0) 0 0 / 8px 8px;box-shadow:inset 0 0 0 1px #ffffff24}.ed-opacity-range:disabled{cursor:default}.ed-opacity-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:16px;height:16px;border-radius:50%;background:#fff;box-shadow:0 0 0 2px #0d0f18e6,0 2px 6px #0006;cursor:grab}.ed-opacity-range:active::-webkit-slider-thumb{cursor:grabbing}.ed-opacity-range:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:3px}.sv-pic-clip{position:absolute;inset:0;border-radius:inherit}.sv-pic.is-viewed .sv-pic-clip{overflow:hidden}.sv-pic-view{position:absolute;left:0;top:0;width:100%;height:100%;transform-origin:0 0;--zoom: 1}.sv-pic.is-viewed{transition:none}.sv-pic.is-gliding,.sv-pic.is-gliding .sv-pic-view{transition:left .24s var(--ease-out-soft),top .24s var(--ease-out-soft),width .24s var(--ease-out-soft),height .24s var(--ease-out-soft),transform .24s var(--ease-out-soft)}.sv-pic-view img,.sv-pic-view video,.sv-pic-view .sv-layer,.sv-pic-view .ed-compare-other{border-radius:calc(12px / var(--zoom))}.sv-pic.is-tag-inside .sv-pic-tag,.sv-pic.is-tag-inside .sv-pic-unsaved{top:10px;z-index:6}.sv-pic.is-tag-inside .sv-pic-tag{left:10px}.sv-pic.is-tag-inside .sv-pic-unsaved{right:10px}.sv-pic.is-viewed .sv-pin,.sv-pic.is-viewed .sv-pin-editor,.sv-pic.is-viewed .ed-compare-line span,.sv-pic.is-viewed .ed-compare-tag.is-left,.sv-pic.is-viewed .ed-area-find{transform-origin:0 0;scale:calc(1 / var(--zoom))}.sv-pic.is-viewed .ed-compare-tag.is-right{transform-origin:100% 0;scale:calc(1 / var(--zoom))}.sv-pic.is-viewed .ed-compare-line{width:calc(2px / var(--zoom));margin-left:calc(-1px / var(--zoom))}.sv-stage.is-space,.sv-stage.is-space *{cursor:grab!important}.sv-stage.is-panning,.sv-stage.is-panning *{cursor:grabbing!important}.sv-zoom{position:relative;display:inline-flex;align-items:center;gap:1px;height:30px;padding:0 3px;border-radius:999px;border:1px solid rgba(255,255,255,.2);background:#04030ca8;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px)}.sv-zoom-btn,.sv-zoom-pct{display:inline-flex;align-items:center;justify-content:center;height:24px;padding:0;border:0;border-radius:999px;background:transparent;color:#fff;font-family:var(--font-sans);cursor:pointer;transition:background var(--dur-fast)}.sv-zoom-btn{width:24px;color:var(--fg-2)}.sv-zoom-btn:hover:not(:disabled),.sv-zoom-pct:hover,.sv-zoom-pct.on{background:#ffffff1f;color:#fff}.sv-zoom-btn:disabled{opacity:.35;cursor:default}.sv-zoom-pct{gap:2px;min-width:52px;padding:0 4px 0 7px;font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums}.sv-zoom-pct .chev{color:var(--fg-3);transition:transform .2s var(--ease-out-soft)}.sv-zoom-pct.on .chev{transform:rotate(180deg)}.sv-pop.sv-zoom-pop{min-width:0;width:208px;left:-4px}.sv-zoom-pop .sv-pop-row{justify-content:space-between;white-space:nowrap}.sv-zoom-pop .sv-pop-row:disabled{opacity:.4;cursor:default}.sv-zoom-pop .sv-pop-row:disabled:hover{background:transparent}.sv-zoom-pop kbd{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;border:1px solid rgba(255,255,255,.1);background:#ffffff0f;color:var(--fg-3);font-family:var(--font-sans);font-size:10.5px;font-weight:600}@media(prefers-reduced-motion:reduce){.sv-pic.is-gliding,.sv-pic.is-gliding .sv-pic-view{transition:none}}.ed-tool-body.is-held{opacity:.55;transition:opacity var(--dur-fast)}`, Z8e = '.lb-backdrop{position:fixed;inset:0;z-index:92;display:flex;align-items:center;justify-content:center;padding:26px 34px;background:#04030cb8;backdrop-filter:blur(16px) saturate(110%);-webkit-backdrop-filter:blur(16px) saturate(110%);animation:lbFade .22s var(--ease-out-soft) both}@keyframes lbFade{0%{opacity:0}to{opacity:1}}.lb-shell{position:relative;display:flex;flex-direction:column;width:min(1520px,100%);height:min(940px,100%);border-radius:24px;overflow:hidden;color:var(--fg-2);background:linear-gradient(180deg,#10121ef7,#090a11fa);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb3,0 0 0 1px #0006;animation:lbIn .34s var(--ease-out-soft) both}@keyframes lbIn{0%{opacity:0;transform:translateY(12px) scale(.985)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.lb-backdrop,.lb-shell{animation:none}}.lb-head{position:relative;flex:none;padding:18px 22px 0;border-bottom:1px solid var(--hairline-soft)}.lb-glow{position:absolute;inset:0 0 auto;height:190px;pointer-events:none;opacity:.9;background:radial-gradient(60% 120% at 6% -20%,rgba(153,104,223,.3),transparent 62%),radial-gradient(40% 90% at 70% -40%,rgba(90,97,237,.2),transparent 70%),radial-gradient(30% 80% at 98% -30%,rgba(199,80,206,.12),transparent 70%)}.lb-row{position:relative;display:flex;align-items:center;gap:12px}.lb-row.is-top{padding-bottom:16px}.lb-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df6b,#5a61ed4d);color:#fff;box-shadow:inset 0 1px #fff3,0 10px 30px #7532d359}.lb-title{display:flex;flex-direction:column;gap:1px;min-width:0;margin-right:8px}.lb-title b{font-size:18px;font-weight:600;color:var(--fg-1);letter-spacing:-.015em}.lb-title span{font-size:12px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lb-search{flex:1;max-width:560px;margin-left:auto;height:42px;display:flex;align-items:center;gap:10px;padding:0 8px 0 14px;border-radius:13px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-4);box-shadow:inset 0 1px #ffffff0d;cursor:text;transition:border-color var(--dur-fast),box-shadow var(--dur-fast),background var(--dur-fast)}.lb-search:focus-within{border-color:#9968df8c;background:#ffffff12;box-shadow:0 0 0 4px #9968df24;color:var(--amethyst-700)}.lb-search input{flex:1;min-width:0;height:100%;border:0;outline:none;background:transparent;font-family:var(--font-sans);font-size:14px;color:var(--fg-1);user-select:text;-webkit-user-select:text}.lb-search input::placeholder{color:var(--fg-4)}.lb-search kbd{flex:none;min-width:22px;height:22px;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;border:1px solid var(--hairline);background:#ffffff0a;color:var(--fg-4);font-family:var(--font-sans);font-size:11px}.lb-search-clear{flex:none;width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:#ffffff14;color:var(--fg-2);cursor:pointer}.lb-search-clear:hover{background:#ffffff24;color:#fff}.lb-close{flex:none;width:38px;height:38px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid transparent;border-radius:12px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.lb-close:hover{background:#ffffff12;border-color:var(--hairline-soft);color:#fff}.lb-row.is-bar{gap:10px}.lb-tabs{display:flex;align-items:flex-end;gap:4px;align-self:stretch}.lb-tabs button{position:relative;display:inline-flex;align-items:center;gap:8px;height:44px;padding:0 14px;border:0;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:13px;font-weight:600;letter-spacing:.01em;cursor:pointer;transition:color var(--dur-fast)}.lb-tabs button .licon{color:var(--fg-4);transition:color var(--dur-fast)}.lb-tabs button:hover{color:var(--fg-1)}.lb-tabs button:after{content:"";position:absolute;left:12px;right:12px;bottom:-1px;height:2px;border-radius:2px;background:var(--grad-cta);opacity:0;transform:scaleX(.6);transition:opacity var(--dur-fast),transform var(--dur-med) var(--ease-out-soft)}.lb-tabs button.on{color:#fff}.lb-tabs button.on .licon{color:var(--amethyst-600)}.lb-tabs button.on:after{opacity:1;transform:none}.lb-grow{flex:1;min-width:0}.lb-seg{display:inline-flex;align-items:center;gap:2px;padding:3px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09}.lb-seg button{min-width:30px;height:28px;padding:0 7px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:11px;font-weight:700;letter-spacing:.04em;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-seg button:hover{color:var(--fg-1);background:#ffffff0d}.lb-seg button.on{background:#ffffff1c;color:#fff;box-shadow:inset 0 1px #ffffff12}.lb-select{display:inline-flex;align-items:center;gap:9px;height:36px;padding:0 13px 0 9px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-select:hover{background:#ffffff12;color:#fff}.lb-select .sw{position:relative;width:30px;height:18px;border-radius:999px;background:#ffffff24;transition:background var(--dur-med)}.lb-select .sw i{position:absolute;left:2px;top:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 4px #0006;transition:transform var(--dur-med) var(--ease-out-soft)}.lb-select.on{border-color:#9968df73;background:#9968df24;color:#fff}.lb-select.on .sw{background:var(--grad-cta)}.lb-select.on .sw i{transform:translate(12px)}.lb-row.is-bar .lb-seg,.lb-row.is-bar .lb-select{margin-bottom:6px}.lb-body{position:relative;flex:1;min-height:0;overflow-y:auto;padding:18px 22px 110px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.16) transparent}.lb-body::-webkit-scrollbar{width:8px}.lb-body::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px;border:2px solid transparent;background-clip:content-box}.lb-wall{position:relative}.lb-cell{position:absolute;border-radius:12px;cursor:zoom-in;animation:lbCell .4s var(--ease-out-soft) backwards}.lb-cell.is-selecting{cursor:pointer}@keyframes lbCell{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.lb-frame{position:absolute;inset:0;overflow:hidden;border-radius:12px;background:#ffffff0a;transition:transform .26s var(--ease-out-soft),box-shadow var(--dur-fast)}.lb-frame img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transform:scale(1.02);transition:opacity .35s ease,transform .6s var(--ease-out-soft);user-select:none;-webkit-user-drag:none}.lb-frame img.is-in{opacity:1;transform:none}.lb-frame:after{content:"";position:absolute;inset:0;border-radius:12px;box-shadow:inset 0 0 0 1px #ffffff12;pointer-events:none;transition:box-shadow var(--dur-fast)}.lb-cell:hover .lb-frame{transform:translateY(-2px);box-shadow:0 16px 40px #02040c8c}.lb-cell:hover .lb-frame:after{box-shadow:inset 0 0 0 1.5px #c2a4ec80}.lb-shade{position:absolute;inset:0;border-radius:12px;pointer-events:none;opacity:0;background:linear-gradient(180deg,#04030c6b,#04030c00 26% 52%,#04030cdb);transition:opacity var(--dur-fast)}.lb-cell:hover .lb-shade,.lb-cell.is-picked .lb-shade{opacity:1}.lb-info{position:absolute;left:12px;right:12px;bottom:10px;display:flex;flex-direction:column;gap:3px;pointer-events:none;opacity:0;transform:translateY(4px);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.lb-cell:hover .lb-info{opacity:1;transform:none}.lb-info .p{font-size:12px;line-height:1.35;color:#fff;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.lb-info .m{font-size:10.5px;font-weight:500;color:#ffffff9e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lb-badge{position:absolute;top:9px;left:9px;display:inline-flex;align-items:center;gap:4px;height:20px;padding:0 7px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10px;font-weight:600;pointer-events:none}.lb-badge.is-fav{left:auto;right:44px;padding:0 6px;color:var(--cv-fav, #ff6b8b)}.lb-badge.is-fav svg{fill:currentColor}.lb-cell:not(.is-selecting) .lb-badge.is-fav{right:9px}.lb-check,.lb-look{position:absolute;top:8px;right:8px;z-index:2;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:1.5px solid rgba(255,255,255,.75);background:#04030c6b;color:#fff;cursor:pointer;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);font-family:var(--font-sans);font-size:12px;font-weight:700;transition:transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast),border-color var(--dur-fast),opacity var(--dur-fast)}.lb-check{opacity:.85}.lb-cell:hover .lb-check{opacity:1;transform:scale(1.06)}.lb-check.on{opacity:1;border-color:transparent;background:var(--grad-cta);box-shadow:0 4px 14px #745aff80}.lb-look{opacity:0;border-color:#ffffff4d}.lb-cell:hover .lb-look{opacity:1}.lb-look:hover{background:#04030cb3}.lb-cell.is-picked .lb-frame{transform:scale(.94)}.lb-cell.is-picked .lb-frame:after{box-shadow:inset 0 0 0 2.5px var(--amethyst-500)}.lb-cell.is-picked:hover .lb-frame{transform:scale(.94) translateY(-2px)}.lb-cell.is-off{cursor:not-allowed}.lb-cell.is-off .lb-frame{opacity:.35;filter:saturate(.6)}.lb-cell.is-off .lb-check{opacity:.35}.lb-skel{position:absolute;border-radius:12px;overflow:hidden;background:#ffffff0b;animation:lbSkel 1.4s ease-in-out infinite}@keyframes lbSkel{0%,to{opacity:.55}50%{opacity:1}}.lb-more,.lb-end{display:flex;align-items:center;justify-content:center;gap:10px;padding:22px 0 6px;font-size:12px;color:var(--fg-4)}.lb-end{color:var(--fg-5)}.lb-empty{box-sizing:border-box;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;max-width:400px;min-height:100%;margin:0 auto;padding-bottom:4vh;text-align:center;animation:lbEmptyIn .4s var(--ease-out-soft) both}@keyframes lbEmptyIn{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.lb-empty b{font-size:17px;font-weight:600;color:var(--fg-1)}.lb-empty>span{font-size:13px;line-height:1.55;color:var(--fg-3);text-wrap:balance}.lb-empty .lb-empty-hint{display:inline-flex;align-items:center;gap:6px;margin-top:8px;padding:4px 12px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;font-size:11.5px;color:var(--fg-3)}.lb-empty-hint .key{width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#ff5b8a29;color:#ff8aa8}.lb-empty-hint .key svg{fill:currentColor}.le{position:relative;flex:none;width:200px;height:118px;margin-bottom:10px}.le svg{display:block}.le-glow{position:absolute;left:50%;top:52%;width:190px;height:116px;translate:-50% -50%;border-radius:50%;background:radial-gradient(closest-side,rgba(153,104,223,.3),rgba(90,97,237,.11) 60%,transparent);filter:blur(6px)}.le-pic{position:absolute;width:54px;height:42px;border-radius:9px;overflow:hidden;box-shadow:inset 0 0 0 1px #ffffff2e,0 12px 26px #02040c8c}.le-pic .sun{position:absolute;right:9px;top:7px;width:9px;height:9px;border-radius:50%;background:#ffffffd1;box-shadow:0 0 10px #fff9}.le-pic .hill{position:absolute;left:-10px;right:-6px;bottom:-17px;height:28px;border-radius:50%;background:#090b1e8c}.le-pic .hill.b{left:24px;right:-28px;bottom:-19px;background:#090b1e59}.le-pic.p1,.le-pic.f1{background:linear-gradient(160deg,#2d2160,#7532d3 58%,#c750ce)}.le-pic.p2,.le-pic.f2,.le-pic.u{background:linear-gradient(175deg,#1d3a6e,#5a61ed 55%,#9ad0ff)}.le-pic.p3,.le-pic.f3{background:linear-gradient(165deg,#3a2240,#c750ce 52%,#ffb38a)}.le-pic.p1{left:24px;top:14px;rotate:-7deg}.le-pic.p2{left:73px;top:8px;z-index:2}.le-pic.p3{left:122px;top:14px;rotate:7deg}.le-spark{position:absolute;left:170px;top:0;color:#e2d4ff;filter:drop-shadow(0 0 6px rgba(196,167,255,.8))}.le-prompt{position:absolute;left:28px;top:78px;z-index:3;box-sizing:border-box;width:144px;height:26px;padding:0 5px 0 9px;display:flex;align-items:center;gap:6px;border-radius:13px;color:#c4a7ff;background:#10121ef0;border:1px solid rgba(255,255,255,.12);box-shadow:0 10px 24px #02040c80}.le-prompt .t1,.le-prompt .t2{height:5px;border-radius:3px;transform-origin:0 50%}.le-prompt .t1{width:54px;background:#ffffff57}.le-prompt .t2{width:26px;background:#ffffff2e}.le-prompt .run{margin-left:auto;width:16px;height:16px;border-radius:50%;background:var(--grad-cta, #8b5cf6)}.le-drop{position:absolute;left:46px;top:40px;box-sizing:border-box;width:108px;height:66px;border-radius:12px;display:flex;align-items:center;justify-content:center;color:#c4a7ff8c;border:1.5px dashed rgba(194,164,236,.38);background:#9968df0f}.le-pic.u{left:73px;top:52px;z-index:2}.le-check{position:absolute;left:144px;top:30px;z-index:3;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#34c79a;color:#fff;box-shadow:0 0 0 2px #0b0d15f2,0 6px 14px #02040c99}.le-pic.f1{left:30px;top:38px;rotate:-10deg}.le-pic.f3{left:116px;top:38px;rotate:10deg}.le-pic.f2{left:73px;top:24px;z-index:2;rotate:-1deg}.le-heart{position:absolute;left:113px;top:14px;z-index:4;width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#ff5b8a;color:#fff;box-shadow:0 0 0 2px #0b0d15f2,0 6px 14px #02040c99}.le-heart svg{fill:currentColor}.le-burst{position:absolute;left:124px;top:25px;z-index:3;width:0;height:0}.le-burst i{position:absolute;left:-2px;top:-2px;width:4px;height:4px;border-radius:50%;background:#ff9ab6;opacity:0}.le-burst .b1{--bx: 0px;--by: -18px}.le-burst .b2{--bx: 16px;--by: -9px}.le-burst .b3{--bx: 16px;--by: 9px}.le-burst .b4{--bx: 0px;--by: 18px}.le-burst .b5{--bx: -16px;--by: 9px}.le-burst .b6{--bx: -16px;--by: -9px}.le-ghost{position:absolute;box-sizing:border-box;width:54px;height:42px;border-radius:9px;border:1.5px dashed rgba(255,255,255,.18);background:#ffffff06}.le-ghost.g1{left:24px;top:30px;rotate:-6deg}.le-ghost.g2{left:73px;top:24px}.le-ghost.g3{left:122px;top:30px;rotate:6deg}.le-lens{position:absolute;left:85px;top:28px;z-index:2;box-sizing:border-box;width:30px;height:30px;border-radius:50%;border:2.5px solid rgba(214,200,255,.92);background:#9968df24;box-shadow:0 8px 20px #02040c80}.le-lens:after{content:"";position:absolute;left:22px;top:25px;width:12px;height:3.5px;border-radius:2px;background:#d6c8ffeb;rotate:45deg}.le-track{position:absolute;left:50px;width:100px;height:3px;border-radius:2px;background:#ffffff24}.le-track.t1{top:84px}.le-track.t2{top:98px}.le-track .knob{position:absolute;top:-5px;box-sizing:border-box;width:13px;height:13px;border-radius:50%;background:#fff;border:2.5px solid #9968df;box-shadow:0 3px 8px #02040c8c}.le-track.t1 .knob{left:20px}.le-track.t2 .knob{left:68px}@media(prefers-reduced-motion:no-preference){.le-glow{animation:leGlow 6s ease-in-out infinite}@keyframes leGlow{0%,to{opacity:.7}45%{opacity:1}}.is-generations .le-prompt .t1{animation:leType1 6s ease-out infinite}.is-generations .le-prompt .t2{animation:leType2 6s ease-out infinite}.is-generations .le-prompt .run{animation:leRun 6s ease-out infinite}.le-pic.p1{animation:leLand1 6s var(--ease-out-soft) infinite}.le-pic.p2{animation:leLand2 6s var(--ease-out-soft) infinite}.le-pic.p3{animation:leLand3 6s var(--ease-out-soft) infinite}.le-spark{animation:leSpark 6s ease-out infinite}@keyframes leType1{0%{transform:scaleX(0);opacity:1}14%,86%{transform:scaleX(1);opacity:1}95%,to{transform:scaleX(1);opacity:0}}@keyframes leType2{0%,10%{transform:scaleX(0);opacity:1}22%,86%{transform:scaleX(1);opacity:1}95%,to{transform:scaleX(1);opacity:0}}@keyframes leRun{0%,24%{scale:1;box-shadow:0 0 #c2a4ecb3}27%{scale:.8}36%{scale:1;box-shadow:0 0 0 8px #c2a4ec00}to{scale:1;box-shadow:0 0 #c2a4ec00}}@keyframes leLand1{0%,30%{opacity:0;translate:0 14px;scale:.7}38%{opacity:1;translate:0 -2px;scale:1.04}44%,86%{opacity:1;translate:0 0;scale:1}95%,to{opacity:0;translate:0 -6px;scale:1}}@keyframes leLand2{0%,35%{opacity:0;translate:0 14px;scale:.7}43%{opacity:1;translate:0 -2px;scale:1.04}49%,86%{opacity:1;translate:0 0;scale:1}95%,to{opacity:0;translate:0 -6px;scale:1}}@keyframes leLand3{0%,40%{opacity:0;translate:0 14px;scale:.7}48%{opacity:1;translate:0 -2px;scale:1.04}54%,86%{opacity:1;translate:0 0;scale:1}95%,to{opacity:0;translate:0 -6px;scale:1}}@keyframes leSpark{0%,52%{opacity:0;scale:.4;rotate:-25deg}60%{opacity:1;scale:1.2;rotate:0deg}66%,82%{opacity:1;scale:1;rotate:0deg}92%,to{opacity:0;scale:.6;rotate:10deg}}.le-pic.u{animation:leDropIn 5.6s var(--ease-out-soft) infinite}.le-drop{animation:leZone 5.6s ease-in-out infinite}.le-check{animation:leCheck 5.6s var(--ease-out-soft) infinite}@keyframes leDropIn{0%{opacity:0;translate:28px -60px;rotate:14deg;scale:1}10%{opacity:1}34%{translate:0 0;rotate:0deg;scale:1}39%{scale:.93}45%,86%{opacity:1;translate:0 0;rotate:0deg;scale:1}95%,to{opacity:0;translate:0 0;rotate:0deg;scale:.96}}@keyframes leZone{0%,16%,52%,to{border-color:#c2a4ec61;background-color:#9968df0f}26%,38%{border-color:#c2a4ece6;background-color:#9968df29}}@keyframes leCheck{0%,42%{opacity:0;scale:.3}50%{opacity:1;scale:1.2}56%,86%{opacity:1;scale:1}95%,to{opacity:0;scale:.8}}.le-heart{animation:leHeart 5.2s var(--ease-out-soft) infinite}.le-burst i{animation:leBurst 5.2s ease-out infinite}.le-pic.f2{animation:leLift 5.2s var(--ease-out-soft) infinite}.le-pic.f1{animation:leFloat 5.2s ease-in-out infinite}.le-pic.f3{animation:leFloat 5.2s ease-in-out -1.7s infinite}@keyframes leHeart{0%,20%{opacity:0;scale:.2}28%{opacity:1;scale:1.32}34%{scale:.9}40%,86%{opacity:1;scale:1}95%,to{opacity:0;scale:.7}}@keyframes leBurst{0%,26%{opacity:0;translate:0 0;scale:1}29%{opacity:1}46%,to{opacity:0;translate:var(--bx) var(--by);scale:.4}}@keyframes leLift{0%,26%{translate:0 0}34%,86%{translate:0 -3px}96%,to{translate:0 0}}@keyframes leFloat{0%,to{translate:0 0}50%{translate:0 -4px}}.le-lens{animation:leSweep 4.4s ease-in-out infinite}.is-filters .le-ghost{animation:leDim 4.4s ease-in-out infinite}.le-track.t1 .knob{animation:leKnob1 4.4s ease-in-out infinite}.le-track.t2 .knob{animation:leKnob2 4.4s ease-in-out infinite}@keyframes leSweep{0%,to{translate:-54px 6px;rotate:-8deg}50%{translate:54px 2px;rotate:8deg}}@keyframes leDim{0%,to{opacity:1}50%{opacity:.3}}@keyframes leKnob1{0%,to{translate:0 0}50%{translate:48px 0}}@keyframes leKnob2{0%,to{translate:0 0}50%{translate:-48px 0}}}.lb-empty .lb-btn{margin-top:8px}.lb-empty-mark{width:48px;height:48px;border-radius:15px;margin-bottom:6px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df4d,#5a61ed33);color:#fff;box-shadow:inset 0 1px #ffffff29,0 14px 40px #7532d347}.lb-empty-mark.is-warn{background:#ff5c7a24;color:#ff8aa0;box-shadow:none}.lb-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:40px;padding:0 16px;border-radius:12px;border:1px solid var(--hairline);background:#ffffff0f;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),filter var(--dur-fast),transform var(--dur-fast)}.lb-btn:hover:not(:disabled){background:#ffffff1a;border-color:#ffffff29}.lb-btn:active:not(:disabled){transform:scale(.98)}.lb-btn:disabled{opacity:.45;cursor:default}.lb-btn.is-ghost{border-color:transparent;background:transparent;color:var(--fg-2)}.lb-btn.is-ghost:hover{background:#ffffff0f;color:#fff}.lb-btn.is-primary{border-color:transparent;background:var(--grad-cta);color:#fff;box-shadow:0 8px 24px #745aff59,inset 0 1px #ffffff38}.lb-btn.is-primary:hover:not(:disabled){filter:brightness(1.08);background:var(--grad-cta)}.lb-btn.is-primary:disabled{background:#ffffff12;box-shadow:none;color:var(--fg-4);opacity:1}.lb-btn.is-picked{border-color:#9968df80;background:#9968df2e}.lb-tray{position:absolute;left:50%;bottom:22px;z-index:5;transform:translate(-50%);display:flex;align-items:center;gap:12px;width:min(720px,calc(100% - 44px));padding:10px 10px 10px 14px;border-radius:18px;background:#0e101af0;border:1px solid var(--hairline);backdrop-filter:blur(26px) saturate(120%);-webkit-backdrop-filter:blur(26px) saturate(120%);box-shadow:var(--inset-highlight),0 24px 70px #02040cb3}.lb-tray-enter-active,.lb-tray-leave-active{transition:opacity .24s var(--ease-out-soft),transform .24s var(--ease-out-soft)}.lb-tray-enter-from,.lb-tray-leave-to{opacity:0;transform:translate(-50%) translateY(14px)}.lb-tray-picks{display:flex;align-items:center;min-width:0}.lb-tray-thumb{position:relative;flex:none;width:34px;height:34px;margin-right:-10px;border-radius:9px;background-size:cover;background-position:center;box-shadow:0 0 0 2px #0e101a,0 4px 12px #0006;animation:lbThumb .26s var(--ease-out-soft) backwards}@keyframes lbThumb{0%{opacity:0;transform:scale(.6) translateY(6px)}to{opacity:1;transform:none}}.lb-tray-count{margin-left:22px;font-size:13px;color:var(--fg-3);white-space:nowrap}.lb-tray-picks .lb-tray-count:first-child{margin-left:2px}.lb-tray-count b{font-size:15px;font-weight:700;color:#fff;font-variant-numeric:tabular-nums}.lb-tray-clear{flex:none;padding:0 4px;border:0;background:transparent;color:var(--amethyst-700);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.lb-tray-clear:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}.lb-note{position:absolute;left:50%;bottom:96px;z-index:6;transform:translate(-50%);display:inline-flex;align-items:center;height:32px;padding:0 14px;border-radius:999px;white-space:nowrap;background:#11131ef7;border:1px solid var(--hairline);color:var(--fg-1);font-size:12.5px;font-weight:500;box-shadow:0 14px 40px #02040c80}.lb-note-enter-active,.lb-note-leave-active{transition:opacity .2s var(--ease-out-soft),transform .2s var(--ease-out-soft)}.lb-note-enter-from,.lb-note-leave-to{opacity:0;transform:translate(-50%,6px)}.lb-peek{position:absolute;inset:0;z-index:8;display:flex;align-items:center;justify-content:center;padding:26px 70px;background:#06060ee6;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);animation:lbFade .2s var(--ease-out-soft) both}.lb-peek-shell{display:grid;grid-template-columns:minmax(0,1fr) 340px;gap:22px;width:100%;height:100%;animation:lbIn .3s var(--ease-out-soft) both}.lb-peek-stage{position:relative;min-width:0;display:flex;align-items:center;justify-content:center;border-radius:18px;background:#ffffff06;border:1px solid var(--hairline-soft);overflow:hidden}.lb-peek-art{display:block;max-width:calc(100% - 36px);max-height:calc(100% - 36px);border-radius:12px;box-shadow:0 30px 100px #02061799;transition:opacity .3s ease}.lb-peek-art.is-loading{opacity:0}.lb-peek-nav{position:absolute;top:50%;z-index:2;width:44px;height:44px;margin-top:-22px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-peek-nav:hover:not(:disabled){background:#ffffff1f;color:#fff}.lb-peek-nav:disabled{opacity:.3;cursor:default}.lb-peek-nav.at-left{left:14px}.lb-peek-nav.at-right{right:14px}.lb-peek-side{display:flex;flex-direction:column;gap:16px;min-width:0;padding:18px;border-radius:18px;background:#ffffff09;border:1px solid var(--hairline-soft);overflow-y:auto}.lb-peek-top{display:flex;align-items:center;gap:8px}.lb-peek-top .n{display:inline-flex;align-items:center;gap:7px;font-size:12px;color:var(--fg-3);font-variant-numeric:tabular-nums}.lb-peek-x{margin-left:auto;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:10px;background:#ffffff0d;color:var(--fg-2);cursor:pointer}.lb-peek-x:hover{background:#ffffff1a;color:#fff}.lb-peek-block{display:flex;flex-direction:column;gap:8px}.lb-peek-head{display:flex;align-items:center;justify-content:space-between;font-size:11px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.lb-peek-head span{display:inline-flex;align-items:center;gap:7px}.lb-peek-head button{width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer}.lb-peek-head button:hover{background:#ffffff12;color:#fff}.lb-peek-prompt{margin:0;max-height:260px;overflow-y:auto;font-size:13.5px;line-height:1.6;color:var(--fg-1);white-space:pre-wrap;overflow-wrap:anywhere}.lb-peek-specs{margin:0;display:flex;flex-direction:column;gap:1px;border-radius:12px;overflow:hidden;border:1px solid var(--hairline-soft)}.lb-peek-specs div{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 12px;background:#ffffff06}.lb-peek-specs dt{font-size:12px;color:var(--fg-4)}.lb-peek-specs dd{margin:0;font-size:12.5px;color:var(--fg-1);text-align:right;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lb-peek-acts{display:flex;flex-direction:column;gap:8px}.lb-peek-acts .lb-btn{width:100%}@media(max-width:980px){.lb-backdrop{padding:12px}.lb-title span{display:none}.lb-row.is-bar{flex-wrap:wrap}.lb-tabs button{padding:0 10px}.lb-peek{padding:16px}.lb-peek-shell{grid-template-columns:1fr;grid-template-rows:minmax(0,1fr) auto}.lb-peek-nav{display:none}}.lb-tool{display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 12px;margin-bottom:6px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-tool .licon{color:var(--fg-4);transition:color var(--dur-fast)}.lb-tool:hover{background:#ffffff12;color:#fff}.lb-tool.on,.lb-tool.is-set{border-color:#9968df73;background:#9968df24;color:#fff}.lb-tool.on .licon,.lb-tool.is-set .licon{color:var(--amethyst-700)}.lb-tool .n{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:10.5px;font-weight:700;font-variant-numeric:tabular-nums}.lb-cols{display:inline-flex;align-items:center;gap:2px;height:36px;padding:3px;margin-bottom:6px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09}.lb-cols button{width:26px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-cols button:hover:not(:disabled){background:#ffffff12;color:#fff}.lb-cols button:disabled{opacity:.3;cursor:default}.lb-cols span{display:inline-flex;align-items:center;gap:5px;min-width:38px;justify-content:center;color:var(--fg-4)}.lb-cols span b{font-size:12.5px;font-weight:700;color:#fff;font-variant-numeric:tabular-nums}.lb-link{display:inline-flex;align-items:center;gap:6px;padding:0;border:0;background:transparent;color:var(--amethyst-700);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.lb-link:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}.lb-filters{position:relative;z-index:4;flex:none;padding:16px 22px 14px;border-bottom:1px solid var(--hairline-soft);background:linear-gradient(180deg,#9968df0f,#ffffff04);animation:lbDrop .26s var(--ease-out-soft) both}@keyframes lbDrop{0%{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:none}}.lb-filters-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(212px,1fr));gap:14px 16px}.lb-field{display:flex;flex-direction:column;gap:7px;min-width:0}.lb-field.is-wide{grid-column:1 / -1}.lb-field.is-dates{grid-column:span 2}.lb-field.is-dates .lb-dates input{max-width:190px}.lb-field-label{font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.lb-chips{display:flex;flex-wrap:wrap;gap:6px}.lb-chip{display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 11px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-chip:hover{background:#ffffff12;color:#fff}.lb-chip.on{border-color:#9968df8c;background:#9968df33;color:#fff}.lb-chip .licon{color:var(--fg-4)}.lb-chip.on .licon{color:#ff8fb0}.lb-chip .glyph{flex:none;display:inline-block;border-radius:2.5px;border:1.5px solid currentColor;opacity:.75}.lb-chip .glyph.is-other{border-style:dashed}.lb-dates{display:flex;align-items:center;gap:6px}.lb-dates input{flex:1;min-width:0;height:36px;padding:0 9px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;color-scheme:dark;outline:none}.lb-dates input:focus{border-color:#9968df8c}.lb-dates .to{font-size:11.5px;color:var(--fg-4)}.lb-dates-x{flex:none;width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:#ffffff0f;color:var(--fg-3);cursor:pointer}.lb-dates-x:hover{background:#ffffff1f;color:#fff}.lb-filters-foot{display:flex;align-items:center;gap:12px;margin-top:16px;padding-top:14px;border-top:1px solid var(--hairline-soft)}.lb-filters-count{font-size:12px;color:var(--fg-4)}.lb-filters-foot .lb-btn{height:36px}.lb-select-wrap{position:relative;min-width:0}.lb-select-btn{display:flex;align-items:center;gap:8px;width:100%;height:36px;padding:0 10px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-3);font-family:var(--font-sans);font-size:12.5px;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-select-btn .licon{flex:none;color:var(--fg-4)}.lb-select-btn .t{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lb-select-btn:hover,.lb-select-btn.on{background:#ffffff12;color:#fff}.lb-select-btn.on{border-color:#9968df80}.lb-select-btn.is-set{color:#fff;border-color:#9968df73;background:#9968df1f}.lb-select-btn.is-set .licon:first-child{color:var(--amethyst-700)}.lb-select-pop{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:20;min-width:220px;padding:6px;border-radius:13px;background:#0d0f18fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:lbDrop .18s var(--ease-out-soft) both}.lb-select-search{display:flex;align-items:center;gap:8px;height:32px;padding:0 9px;margin-bottom:4px;border-radius:9px;background:#ffffff0d;color:var(--fg-4)}.lb-select-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px}.lb-select-rows{max-height:260px;overflow-y:auto;scrollbar-width:thin}.lb-select-row{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 9px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;text-align:left;cursor:pointer}.lb-select-row .t{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lb-select-row.is-active{background:#ffffff0f;color:#fff}.lb-select-row.on{color:#fff}.lb-select-row.on .licon{color:var(--amethyst-600)}.lb-select-row.is-any{color:var(--fg-4)}.lb-select-none{padding:10px 9px;font-size:12px;color:var(--fg-4)}.lb-applied{flex:none;display:flex;align-items:center;flex-wrap:wrap;gap:8px;padding:12px 22px 0}.lb-applied-chip{display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 4px 0 11px;border-radius:999px;border:1px solid rgba(153,104,223,.4);background:#9968df1f;color:#fff;font-size:12px;font-weight:600;animation:lbThumb .24s var(--ease-out-soft) backwards}.lb-applied-chip.is-search .licon{color:var(--amethyst-700)}.lb-applied-chip button{width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:#ffffff1a;color:var(--fg-2);cursor:pointer}.lb-applied-chip button:hover{background:#fff3;color:#fff}.lb-applied-note{font-size:11.5px;color:var(--fg-4)}.lb-star{position:absolute;top:8px;right:42px;z-index:2;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:0;background:#04030c80;color:#fff;cursor:pointer;opacity:0;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast)}.lb-cell:hover .lb-star,.lb-star.on{opacity:1}.lb-star:hover{transform:scale(1.08);background:#04030cb8}.lb-star.on{color:#ff6b8b}.lb-star.on svg{fill:currentColor}.lb-star.is-still{cursor:default}.lb-cell:not(.is-selecting) .lb-star{right:42px}.lb-cell.is-moderated{cursor:help}.lb-withheld{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;color:var(--fg-4);background:radial-gradient(120% 90% at 30% 20%,#9968df38,#ffffff08 70%)}.lb-withheld b{font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}.lb-cell.is-list{display:flex;align-items:center;gap:16px;padding:8px 120px 8px 8px;border-radius:14px;background:#ffffff06;border:1px solid var(--hairline-soft);transition:background var(--dur-fast),border-color var(--dur-fast)}.lb-cell.is-list:hover{background:#ffffff0d}.lb-cell.is-list .lb-frame{position:relative;inset:auto;flex:none;width:92px;height:92px;border-radius:10px}.lb-cell.is-list:hover .lb-frame{transform:none;box-shadow:none}.lb-cell.is-list.is-picked{border-color:#9968df99;background:#9968df1a}.lb-cell.is-list.is-picked .lb-frame{transform:none}.lb-row-text{flex:1;min-width:0;display:flex;flex-direction:column;gap:6px}.lb-row-text .p{font-size:13px;line-height:1.45;color:var(--fg-1);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.lb-row-text .m{font-size:11.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lb-cell.is-list .lb-check,.lb-cell.is-list .lb-look{top:50%;right:16px;margin-top:-14px}.lb-cell.is-list .lb-star{top:50%;right:54px;margin-top:-14px}.lb-cell.is-list .lb-badge{top:14px;left:14px}.lb-upload-tile{position:absolute;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:10px;border-radius:12px;border:1.5px dashed rgba(194,164,236,.4);background:#9968df0f;color:var(--fg-2);font-family:var(--font-sans);cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.lb-upload-tile:hover{background:#9968df21;border-color:#c2a4ecb3;transform:translateY(-2px)}.lb-upload-tile .ic{width:40px;height:40px;margin-bottom:4px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df66,#5a61ed4d);color:#fff}.lb-upload-tile b{font-size:13px;font-weight:600;color:#fff}.lb-upload-tile span{font-size:11.5px;color:var(--fg-4)}.lb-upload-tile.is-list{flex-direction:row;gap:14px;justify-content:flex-start;padding:0 18px}.lb-upload-tile.is-list .ic{margin:0}.lb-cell.is-uploading{cursor:progress}.lb-uploading{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;gap:8px;padding:10px;font-size:11.5px;color:var(--fg-3);text-align:center;overflow:hidden}.lb-cell.is-uploading .lb-frame:before{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.08) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.lb-dropping{position:absolute;inset:0;z-index:9;display:flex;align-items:center;justify-content:center;background:#04030c99;pointer-events:none;animation:lbFade .16s ease both}.lb-dropping>div{display:inline-flex;align-items:center;gap:10px;padding:16px 22px;border-radius:16px;border:1.5px dashed rgba(194,164,236,.75);background:#0d0f18f0;color:#fff;font-size:14px;font-weight:500}.lb-more.is-failed{color:#ff9db5}.lb-note.is-error{border-color:#ff5c7a66;color:#ffb3c1}.lb-peek-act{flex:none;height:32px;min-width:32px;padding:0 8px;display:inline-flex;align-items:center;justify-content:center;gap:6px;border:0;border-radius:10px;background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-peek-act:hover{background:#ffffff1a;color:#fff}.lb-peek-act.lb-peek-star.on{color:#ff6b8b}.lb-peek-act.lb-peek-star.on svg{fill:currentColor}.lb-peek-act.lb-peek-pin.on{color:#c4a7ff;background:#9968df29}.lb-peek-act.lb-peek-pin.on svg{fill:currentColor}.lb-peek-act.is-danger:hover,.lb-peek-act.is-confirming{background:#ff5c7a29;color:#ff9db5}.lb-peek-withheld{display:flex;flex-direction:column;align-items:center;gap:10px;max-width:420px;padding:24px;text-align:center}.lb-peek-withheld b{font-size:16px;color:#fff}.lb-peek-withheld span{font-size:13px;line-height:1.6;color:var(--fg-3)}.lb-badge.is-3d{color:#b9c1ff}', Q8e = '.pl-wrap{position:relative;z-index:6;width:min(1200px,calc(100% - 16px));margin-bottom:12px;animation:plRise .46s var(--ease-out-soft) both}@keyframes plRise{0%{opacity:0;transform:translateY(18px) scale(.985)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.pl-wrap{animation:none}}.pl-float{position:absolute;left:var(--chat-w);right:var(--set-w);top:52px;bottom:84px;z-index:72;display:flex;align-items:center;justify-content:center;pointer-events:none}.pl-float>.pl-wrap{pointer-events:auto;margin-bottom:0}.pl-panel{position:relative;display:flex;overflow:hidden;height:clamp(340px,calc(100vh - 52px - var(--up-card-h, 150px) - 84px),740px);border:1px solid rgba(255,255,255,.06);border-radius:22px;background:radial-gradient(120% 70% at 50% -18%,rgba(153,104,223,.11),transparent 62%),#0a0c14fb;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 40px 110px #02040cad;container:pl-panel / inline-size}.pl-wrap.is-floating .pl-panel{height:clamp(360px,calc(100vh - 184px),760px)}.pl-close{position:absolute;top:-12px;right:-12px;z-index:3;width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.1);border-radius:50%;background:#141723f7;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);color:var(--fg-2);cursor:pointer;box-shadow:0 6px 18px #02040c8c;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-close:hover{background:#222638fa;color:#fff;transform:rotate(90deg)}.pl-side{flex:none;width:248px;min-height:0;box-sizing:border-box;display:flex;flex-direction:column;padding:14px 8px 12px 12px;border-right:1px solid rgba(255,255,255,.05);background:#ffffff04}.pl-side-tabs{display:flex;width:100%;box-sizing:border-box}.pl-tabs.pl-side-tabs button{flex:1 1 0;min-width:0;justify-content:center;gap:6px;padding:0 6px;white-space:nowrap}.pl-side-scroll{flex:1;min-height:0;overflow-y:auto;margin-top:12px;padding-right:4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.1) transparent}.pl-tree{display:flex;flex-direction:column;gap:1px}.pl-node{position:relative;display:flex;align-items:center;gap:9px;width:100%;min-height:32px;box-sizing:border-box;padding:0 10px;border:0;border-radius:9px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12.5px;font-weight:500;text-align:left;cursor:pointer;outline:none;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.pl-node>.licon{flex:none;color:var(--fg-4);transition:color var(--dur-fast)}.pl-node .lbl{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-node .n{flex:none;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-node:hover{background:#ffffff0b;color:var(--fg-1)}.pl-node:focus-visible{box-shadow:inset 0 0 0 1.5px var(--vista-blue-500)}.pl-node.on{background:var(--cv-accent-tint);color:var(--fg-1);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.pl-node.on>.licon,.pl-node.is-in>.licon{color:var(--cv-accent-text)}.pl-node.is-empty:not(.on) .lbl,.pl-node.is-empty:not(.on)>.licon{opacity:.5}.pl-node.is-root{margin-bottom:4px}.pl-node.is-kind{margin-top:8px;color:var(--fg-2);font-weight:600}.pl-branch.is-in>.pl-node.is-kind{color:var(--fg-1)}.pl-node.is-action{min-height:40px;padding:5px 10px 5px 30px}.pl-node.is-action .lbl{display:flex;flex-direction:column;gap:1px;line-height:1.3}.pl-node.is-action em{font-style:normal;font-size:10.5px;font-weight:500;color:var(--fg-4);overflow:hidden;text-overflow:ellipsis}.pl-node.is-action.on em{color:var(--fg-3)}.pl-leaves{position:relative;display:flex;flex-direction:column;gap:1px;margin:1px 0 3px}.pl-leaves:before{content:"";position:absolute;left:36px;top:4px;bottom:4px;width:1px;background:#ffffff14}@media(prefers-reduced-motion:no-preference){.pl-leaves{animation:plLeaves .32s var(--ease-out-soft) both}}@keyframes plLeaves{0%{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}.pl-node.is-cat{min-height:29px;padding:5px 10px 5px 46px;font-size:12px;line-height:1.35}.pl-node.is-cat .lbl{white-space:normal;text-wrap:pretty}.pl-side-sec{display:flex;flex-direction:column;gap:1px;margin-top:14px;padding-top:12px;border-top:1px solid var(--hairline-soft)}.pl-side-label{padding:0 10px 6px;font-size:10px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4)}.pl-node.is-level.on{background:transparent;box-shadow:none}.pl-node.is-level.on:hover{background:#ffffff0b}.pl-tick{flex:none;width:14px;height:14px;display:inline-flex;align-items:center;justify-content:center;border-radius:4px;box-shadow:inset 0 0 0 1.5px #ffffff38;color:transparent;transition:background var(--dur-fast),box-shadow var(--dur-fast),color var(--dur-fast)}.pl-node.is-level.on .pl-tick{background:var(--cv-accent);box-shadow:none;color:#fff}.pl-head .pl-side-toggle,.pl-side-scrim{display:none}@container pl-panel (max-width: 700px){.pl-side{position:absolute;z-index:6;top:0;bottom:0;left:0;width:248px;background:#0c0e16fe;box-shadow:18px 0 50px #02040c8c;transform:translate(-104%);visibility:hidden;transition:transform .32s var(--ease-out-soft),visibility 0s linear .32s}.pl-panel.is-side-open .pl-side{transform:none;visibility:visible;transition:transform .32s var(--ease-out-soft)}.pl-head .pl-side-toggle{display:inline-flex;flex:none;width:36px;height:36px;border-radius:11px}.pl-side-scrim{display:block;position:absolute;inset:0;z-index:5;background:#04050a73}}.pl-content{position:relative;flex:1;min-width:0;min-height:0;display:flex;flex-direction:column;container-type:inline-size}.pl-head{display:flex;align-items:center;gap:10px;padding:14px 16px 10px;flex:none}.pl-tabs{display:inline-flex;gap:2px;padding:3px;border-radius:12px;background:#ffffff0a;flex:none}.pl-tabs button{height:30px;padding:0 13px;display:inline-flex;align-items:center;gap:7px;border:0;border-radius:9px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12.5px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-tabs button:hover{color:var(--fg-1)}.pl-tabs button.on{background:#ffffff17;color:var(--fg-1);box-shadow:var(--inset-highlight)}.pl-tabs .n{font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-search{flex:1;min-width:0;height:36px;padding:0 8px 0 12px;display:flex;align-items:center;gap:9px;border:1px solid transparent;border-radius:11px;background:#ffffff0b;color:var(--fg-4);transition:border-color var(--dur-fast),background var(--dur-fast)}.pl-search:focus-within{border-color:var(--cv-accent-soft);background:#ffffff0f}.pl-search.is-off{opacity:.5}.pl-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;font-weight:500;user-select:text;-webkit-user-select:text}.pl-search input::placeholder{color:var(--fg-4)}.pl-clear{width:22px;height:22px;flex:none;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:#ffffff0f;color:var(--fg-3);cursor:pointer}.pl-clear:hover{background:#ffffff1f;color:#fff}.pl-kbd{flex:none;min-width:20px;height:20px;padding:0 6px;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;background:#ffffff0f;color:var(--fg-4);font-family:var(--font-sans);font-size:10.5px}.pl-scope{flex:none;display:flex;align-items:center;gap:8px;min-width:0;padding:0 16px 12px}.pl-scope-crumb{flex:none;display:inline-flex;align-items:center;gap:3px;font-size:12.5px;color:var(--fg-4);white-space:nowrap}.pl-scope-title{flex:none;max-width:50%;font-size:13.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-scope-hint{flex:1;min-width:0;font-size:12px;color:var(--fg-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-scope-n{flex:none;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-chip{flex:none;height:28px;padding:0 12px;border:1px solid var(--hairline-soft);border-radius:999px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:600;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.pl-chip:hover{color:var(--fg-1);background:#ffffff0d}.pl-chip.on{color:var(--fg-1);background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.pl-main{position:relative;flex:1;min-height:0}.pl-body{position:absolute;inset:0;overflow-y:auto;padding:2px 16px 16px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.pl-body::-webkit-scrollbar{width:6px}.pl-body::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.pl-body.is-covered{visibility:hidden}.pl-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}@container (max-width: 640px){.pl-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}@container (max-width: 400px){.pl-grid{grid-template-columns:minmax(0,1fr)}}.pl-tile{position:relative;aspect-ratio:4 / 3;border-radius:15px;overflow:hidden;isolation:isolate;background:#0c0e17;box-shadow:inset 0 0 0 1px #ffffff0f;transition:transform .35s var(--ease-out-soft),box-shadow .35s var(--ease-out-soft)}@media(prefers-reduced-motion:no-preference){.pl-tile{animation:plTileIn .5s var(--ease-out-soft) both}.pl-tile:nth-child(2){animation-delay:.03s}.pl-tile:nth-child(3){animation-delay:.06s}.pl-tile:nth-child(4){animation-delay:.09s}.pl-tile:nth-child(5){animation-delay:.12s}.pl-tile:nth-child(6){animation-delay:.15s}}@keyframes plTileIn{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}.pl-tile:hover,.pl-tile:focus-within{transform:translateY(-3px);box-shadow:inset 0 0 0 1px #ffffff26,0 18px 44px #02040c8c}.pl-tile-art{position:absolute;inset:0;overflow:hidden}.pl-tile-art:before,.pl-tile.is-skeleton:before{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.05) 50%,transparent 80%);animation:shimmer 1.4s linear infinite}.pl-tile.is-in .pl-tile-art:before{display:none}.pl-tile.is-skeleton{animation:none}.pl-tile-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;opacity:0;transform:scale(1.04);transition:opacity .5s var(--ease-out-soft),transform .9s var(--ease-out-soft)}.pl-tile.is-in .pl-tile-img{opacity:1;transform:none}.pl-tile:hover .pl-tile-img:not(.is-peek){transform:scale(1.035)}.pl-tile-img.is-peek,.pl-tile-img.is-video{z-index:1;opacity:1;transform:none}.pl-tile-shade{position:absolute;inset:0;z-index:2;pointer-events:none;background:linear-gradient(180deg,#04030c00 46%,#04030cd6)}.pl-tile-shade:after{content:"";position:absolute;inset:0;opacity:0;background:linear-gradient(180deg,#04030c00 20%,#04030c99);transition:opacity .55s var(--ease-out-soft)}.pl-tile:hover .pl-tile-shade:after,.pl-tile:focus-within .pl-tile-shade:after{opacity:1}.pl-tile-hit{position:absolute;inset:0;z-index:3;padding:0;border:0;border-radius:inherit;background:transparent;cursor:pointer;outline:none}.pl-tile-hit:focus-visible{box-shadow:inset 0 0 0 2px var(--vista-blue-500)}.pl-tile-meta{position:absolute;left:12px;right:12px;bottom:11px;z-index:4;display:flex;flex-direction:column;gap:2px;pointer-events:none;transform:translateY(40px);transition:transform .6s var(--ease-out-soft)}.pl-tile:hover .pl-tile-meta,.pl-tile:focus-within .pl-tile-meta{transform:none}.pl-tile-name{font-size:13.5px;font-weight:600;letter-spacing:-.01em;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-shadow:0 1px 12px rgba(4,3,12,.5)}.pl-tile-tool{font-size:11px;color:#ffffff9e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-tile-acts{display:flex;gap:6px;margin-top:9px;opacity:0;pointer-events:auto;transition:opacity .45s var(--ease-out-soft)}.pl-tile:hover .pl-tile-acts,.pl-tile:focus-within .pl-tile-acts{opacity:1}.pl-tile-cap{position:absolute;top:10px;left:58px;z-index:5;max-width:calc(100% - 68px);width:max-content;padding:3px 9px;border-radius:999px;background:#04030cbd;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.pl-stack{position:absolute;top:10px;left:10px;z-index:5;display:flex;flex-direction:column;gap:5px}.pl-stack-win{height:calc(var(--rows) * 42px - 4px);width:42px;margin:-2px;padding:2px;overflow:hidden;border-radius:11px;box-sizing:content-box}.pl-stack-reel{display:flex;flex-direction:column;gap:4px;transform:translateY(calc(var(--off) * -42px));transition:transform .42s var(--ease-out-soft)}.pl-stack-th{width:38px;height:38px;flex:none;border-radius:9px;background-size:cover;background-position:center;background-color:#ffffff0f;cursor:pointer;box-shadow:0 0 0 1.5px #ffffffd1,0 6px 14px #04030c80;transition:box-shadow var(--dur-fast)}.pl-stack-th.is-markup{box-shadow:0 0 0 1.5px var(--amethyst-700),0 6px 14px #04030c80}.pl-stack-th.on{box-shadow:0 0 0 2px var(--vista-blue-500),0 8px 18px #04030c99}.pl-stack-more{position:relative;width:38px;height:20px;padding:0;overflow:hidden;border:0;border-radius:7px;background:#04030cc2;color:#fff;font-family:var(--font-sans);font-size:10px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-stack-more .n,.pl-stack-more .ic{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;transition:opacity .2s var(--ease-out-soft),transform .2s var(--ease-out-soft)}.pl-stack-more .ic{opacity:0;transform:translateY(-4px)}.pl-tile:hover .pl-stack-more .n{opacity:0;transform:translateY(4px)}.pl-tile:hover .pl-stack-more .ic{opacity:1;transform:none}.pl-stack-more:hover{background:#fffffff0;color:#0b0d14}.pl-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:28px;padding:0 12px;border:0;border-radius:999px;font-family:var(--font-sans);font-size:11.5px;font-weight:600;letter-spacing:-.005em;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-btn:active{transform:scale(.97)}.pl-btn.is-light{background:#fffffff0;color:#0b0d14}.pl-btn.is-light:hover{background:#fff}.pl-btn.is-glass{background:#ffffff1a;color:var(--fg-1);box-shadow:inset 0 0 0 1px #ffffff24;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px)}.pl-btn.is-glass:hover{background:#ffffff2b}.pl-btn.is-lg{height:38px;padding:0 16px;border-radius:12px;font-size:12.5px}.pl-cta{height:38px;padding:0 22px;border:0;border-radius:12px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:13px;font-weight:600;cursor:pointer;box-shadow:0 14px 34px #745aff4d;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.pl-cta:hover{transform:translateY(-1px);box-shadow:0 18px 42px #745aff66}.pl-cta:active{transform:scale(.98)}.pl-icon-btn{width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-icon-btn:hover{background:#ffffff12;color:var(--fg-1)}.pl-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;min-height:100%;padding:32px 24px;box-sizing:border-box;text-align:center;color:var(--fg-3);font-size:12.5px;line-height:1.55;text-wrap:pretty}.pl-empty>.licon{color:var(--fg-4);margin-bottom:4px}.pl-empty b{color:var(--fg-1);font-size:14px;font-weight:600;letter-spacing:-.01em}.pl-empty>span{max-width:380px}.pl-empty .pl-btn{margin-top:8px}.pl-empty-acts{display:flex;gap:8px}.pl-empty-mark{width:44px;height:44px;margin-bottom:6px;display:inline-flex;align-items:center;justify-content:center;border-radius:14px;background:var(--cv-accent-tint);color:var(--cv-accent-text);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.pl-detail{position:absolute;inset:0;z-index:2;display:grid;grid-template-columns:minmax(0,1.12fr) minmax(0,1fr);gap:16px;padding:2px 16px 14px}@container (max-width: 600px){.pl-detail{grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(150px,40%) minmax(0,1fr);gap:12px}}.pl-detail-enter-active{transition:opacity .3s var(--ease-out-soft)}.pl-detail-leave-active{transition:opacity .16s ease}.pl-detail-enter-from,.pl-detail-leave-to{opacity:0}.pl-detail-art{position:relative;min-height:0;border-radius:16px;overflow:hidden;display:flex;align-items:center;justify-content:center;background:radial-gradient(90% 70% at 50% 40%,rgba(153,104,223,.07),transparent 70%),#07080f;box-shadow:inset 0 0 0 1px #ffffff0d}.pl-detail-img{display:block;max-width:calc(100% - 28px);max-height:calc(100% - 28px);width:auto;height:auto;border-radius:12px;box-shadow:0 22px 60px #02040c8c}.pl-detail-img.is-landing{opacity:0}.pl-peek-enter-active{transition:opacity .2s var(--ease-out-soft)}.pl-peek-leave-active{transition:opacity .12s ease}.pl-peek-enter-from,.pl-peek-leave-to{opacity:0}.pl-back{position:absolute;top:12px;left:12px;z-index:2;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:10px;background:#04030c9e;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#fff;cursor:pointer;box-shadow:inset 0 0 0 1px #ffffff1f;transition:background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-back:hover{background:#04030cd6;transform:translate(-2px)}.pl-detail-cap{position:absolute;top:14px;right:14px;z-index:2;max-width:70%;padding:4px 11px;border-radius:999px;background:#04030cb8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#ffffffd9;font-size:11px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.pl-detail-strip{position:absolute;left:14px;bottom:14px;z-index:2;display:flex;gap:7px}.pl-th-slot{display:flex;flex:none}.pl-detail-th{width:52px;height:52px;padding:0;border:0;border-radius:11px;cursor:pointer;background-size:cover;background-position:center;background-color:#ffffff0f;box-shadow:0 0 0 1.5px #fffc,0 8px 18px #04030c8c;transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-detail-th:hover,.pl-detail-th.on{transform:translateY(-2px);box-shadow:0 0 0 2px var(--vista-blue-500),0 10px 22px #04030c99}.pl-detail-th.is-markup{box-shadow:0 0 0 1.5px var(--amethyst-700),0 8px 18px #04030c8c}.pl-detail-more{height:52px;min-width:40px;padding:0 8px;display:inline-flex;align-items:center;justify-content:center;border-radius:11px;background:#04030cbd;color:#fff;font-size:11px;font-weight:600}.pl-detail-info{position:relative;display:flex;flex-direction:column;min-height:0}.pl-detail-scroll{flex:1;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:16px;padding:6px 6px 16px 2px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.pl-detail-foot{flex:none;display:flex;flex-direction:column;gap:8px;padding-top:14px;border-top:1px solid var(--hairline-soft)}@media(prefers-reduced-motion:no-preference){.pl-detail-info{animation:plInfoIn .5s var(--ease-out-soft) .08s both}@keyframes plInfoIn{0%{opacity:0;transform:translate(14px)}to{opacity:1;transform:none}}}.pl-detail-top{display:flex;align-items:center;gap:10px}.pl-crumb{flex:1;min-width:0;font-size:10px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-detail-nav{display:inline-flex;align-items:center;gap:2px;flex:none}.pl-detail-nav button{width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-detail-nav button:hover:not(:disabled){background:#ffffff12;color:#fff}.pl-detail-nav button:disabled{opacity:.3;cursor:default}.pl-detail-count{min-width:56px;text-align:center;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-detail-name{margin:-6px 0 0;font-size:19px;font-weight:600;letter-spacing:-.02em;line-height:1.2;color:var(--fg-1)}.pl-detail-desc{margin:-8px 0 0;font-size:12.5px;line-height:1.6;color:var(--fg-3);text-wrap:pretty}.pl-block{display:flex;flex-direction:column;gap:8px}.pl-label-row{display:flex;align-items:center;justify-content:space-between;margin:-4px 0}.pl-label{font-size:10px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4)}.pl-prompt{margin:0;padding:12px 14px;max-height:220px;overflow-y:auto;border-radius:12px;background:#ffffff09;box-shadow:inset 0 0 0 1px #ffffff0d;color:var(--fg-2);font-size:12.5px;line-height:1.6;white-space:pre-wrap;text-wrap:pretty;user-select:text;-webkit-user-select:text;scrollbar-width:thin}.pl-pills{display:flex;flex-wrap:wrap;gap:6px}.pl-pill{display:inline-flex;align-items:center;gap:7px;height:28px;padding:0 11px 0 9px;border-radius:999px;background:#ffffff0e;color:var(--fg-2);font-size:12px;font-weight:500}.pl-pill .licon{color:var(--cv-accent-text)}.pl-pill.is-quiet{background:#ffffff08;color:var(--fg-3)}.pl-pill.is-quiet .licon{color:var(--fg-4)}.pl-note{display:flex;align-items:flex-start;gap:7px;margin:0;padding:9px 11px;border-radius:10px;background:#ffb34712;box-shadow:inset 0 0 0 1px #ffb34729;color:#ffdcaadb;font-size:11.5px;line-height:1.5}.pl-note .licon{margin-top:2px;color:var(--warning);flex:none}.pl-inputs{display:flex;flex-wrap:wrap;gap:7px}.pl-input{position:relative;width:62px;height:62px;padding:0;overflow:hidden;border:0;border-radius:11px;cursor:pointer;background-size:cover;background-position:center;background-color:#ffffff0d;box-shadow:inset 0 0 0 1px #ffffff17;transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-input:hover,.pl-input.on{transform:translateY(-2px);box-shadow:0 0 0 2px var(--vista-blue-500)}.pl-input.is-markup{box-shadow:inset 0 0 0 1.5px var(--amethyst-700)}.pl-input-n{position:absolute;top:4px;left:4px;min-width:16px;height:16px;padding:0 4px;border-radius:5px;display:flex;align-items:center;justify-content:center;background:#04030cbd;color:#fff;font-size:9.5px;font-weight:600}.pl-input-tag{position:absolute;left:0;right:0;bottom:0;padding:3px 0;background:#04030cc2;color:#fff;font-size:8.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;text-align:center}.pl-detail-acts{display:flex;align-items:center;gap:8px}.pl-acts-hint{margin:0;font-size:11px;color:var(--fg-4);line-height:1.5}.up-ghost{grid-column:2;grid-row:1;align-self:start;min-width:0;padding-top:4px;font-family:var(--font-sans);font-size:13.5px;line-height:1.55;letter-spacing:-.005em;color:var(--fg-4);pointer-events:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.up-ghost-enter-active{transition:opacity .45s var(--ease-out-soft),transform .45s var(--ease-out-soft)}.up-ghost-leave-active{transition:opacity .22s ease}.up-ghost-enter-from{opacity:0;transform:translateY(5px)}.up-ghost-leave-to{opacity:0}.up-cue{grid-column:2;grid-row:1;align-self:end;justify-self:start;margin-bottom:2px;display:inline-flex;align-items:center;gap:6px;padding:2px 9px 2px 4px;border-radius:999px;background:var(--cv-accent-tint);color:var(--cv-accent-text);font-size:10.5px;letter-spacing:.01em;pointer-events:none;animation:upIn .4s var(--ease-out-soft) .15s both}.up-cue kbd{font-family:var(--font-sans);font-size:9.5px;padding:1px 6px;border-radius:5px;background:#ffffff24;color:var(--fg-1)}.up-cue .src{color:var(--fg-4)}.up-card.is-landed{animation:upLanded 1.2s var(--ease-out-soft)}@keyframes upLanded{0%{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #a3a7f5e6,0 0 42px #745aff73,0 30px 80px #02040c9e}to{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #a3a7f500,0 0 #745aff00,0 30px 80px #02040c9e}}@media(prefers-reduced-motion:reduce){.up-card.is-landed{animation:none}}.bd-toast{bottom:max(186px,calc(var(--up-card-h, 0px) + 44px))}.bd-toast.has-action{pointer-events:auto;padding-right:6px}.bd-toast-text{min-width:0;overflow:hidden;text-overflow:ellipsis}.bd-toast.is-long{white-space:normal;border-radius:14px;max-width:min(520px,calc(100vw - 32px));line-height:1.45}.bd-toast.is-long .bd-toast-text{overflow:visible}.bd-toast-act{flex:none;margin-left:4px;height:24px;padding:0 11px;border:0;border-radius:999px;background:#ffffff1c;color:#fff;font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast)}.bd-toast-act:hover{background:#fff3}.lib-new{position:absolute;top:3px;right:3px;width:7px;height:7px;border-radius:50%;pointer-events:none;background:var(--cv-accent-soft);box-shadow:0 0 0 2px #0e101af2,0 0 10px #9968dfbf}.up-side-btn.has-new{position:relative}.pl-head-act{flex:none;height:36px;border-radius:11px}.pl-chip .n{font-size:10px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-tile-levels{position:absolute;top:10px;right:10px;z-index:5;display:inline-flex;align-items:center;gap:5px;height:22px;padding:0 8px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#ffffffd1}.pl-tile-words,.pl-cover-text{position:absolute;inset:0;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;padding:18px 18px 64px;box-sizing:border-box;background:radial-gradient(120% 90% at 0% 0%,rgba(153,104,223,.22),transparent 60%),radial-gradient(90% 80% at 100% 100%,rgba(90,97,237,.18),transparent 60%),#0d0f1a;color:#ffffffdb;font-size:15px;font-weight:500;line-height:1.45;letter-spacing:-.01em;-webkit-line-clamp:6}.pl-cover-text{position:relative;inset:auto;width:calc(100% - 28px);height:calc(100% - 28px);border-radius:12px;padding:28px;font-size:18px;-webkit-line-clamp:12}.pl-detail-by{margin:-10px 0 0;font-size:11.5px;color:var(--fg-4)}.pl-acts-own{margin-left:auto;display:inline-flex;gap:4px}.pl-icon-btn.is-lg{width:auto;min-width:38px;height:38px;padding:0 10px;gap:6px;border-radius:12px;font-family:var(--font-sans);font-size:12px;font-weight:600}.pl-icon-btn.is-danger:hover,.pl-icon-btn.is-danger.is-confirming{background:#ff5c7a24;color:var(--danger)}.pl-icon-btn.is-danger.is-confirming{box-shadow:inset 0 0 0 1px #ff5c7a66}.pl-edit{position:absolute;inset:0;z-index:3;display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:16px;padding:2px 16px 14px}@container (max-width: 600px){.pl-edit{grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(140px,32%) minmax(0,1fr);gap:12px}}.pl-edit-form{min-height:0;display:flex;flex-direction:column;padding:4px 2px}.ps{flex:0 1 auto;min-height:0;display:flex;flex-direction:column;gap:16px}.ps-body{flex:0 1 auto;min-height:0;display:flex;flex-direction:column;gap:16px;overflow-y:auto;margin:0 -6px;padding:0 6px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.ps-body.is-more{-webkit-mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent);mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent)}.ps-head{display:flex;align-items:center;gap:11px}.ps-mark{flex:none;width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border-radius:11px;background:var(--cv-accent-tint);color:var(--cv-accent-text);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.ps-title{display:flex;flex-direction:column;gap:2px;min-width:0}.ps-title b{font-size:14.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ps-title em{font-style:normal;font-size:11.5px;color:var(--fg-4)}.ps-field{display:flex;flex-direction:column;gap:8px;min-width:0}.ps-input{width:100%;box-sizing:border-box;height:38px;padding:0 12px;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;font-weight:500;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast);user-select:text;-webkit-user-select:text}.ps-input:focus{border-color:var(--cv-accent-soft);background:#ffffff0f}.ps-input::placeholder{color:var(--fg-4)}.ps-input.is-chip{width:150px;height:28px;border-radius:999px;font-size:11.5px}.ps-text{height:auto;min-height:96px;padding:10px 12px;resize:vertical;line-height:1.55;font-size:12.5px}.ps-hint{font-size:11px;color:var(--fg-4)}.ps-hint.is-bad{color:var(--danger)}.ps-audience{display:flex;align-items:center;gap:7px;margin:0;font-size:12px;color:var(--fg-2)}.ps-audience .licon{color:var(--cv-accent-text)}.ps-levels{display:flex;flex-direction:column;gap:6px}.ps-level{display:flex;align-items:center;gap:11px;width:100%;padding:10px 12px;text-align:left;cursor:pointer;border:1px solid var(--hairline-soft);border-radius:12px;background:#ffffff06;color:var(--fg-2);font-family:var(--font-sans);transition:background var(--dur-fast),border-color var(--dur-fast)}.ps-level:hover{background:#ffffff0d}.ps-level.on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint)}.ps-level>.licon{flex:none;color:var(--fg-4)}.ps-level.on>.licon{color:var(--cv-accent-text)}.ps-level-text{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.ps-level-text b{font-size:12.5px;font-weight:600;color:var(--fg-1)}.ps-level-text em{font-style:normal;font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ps-switch{position:relative;flex:none;width:30px;height:18px;border-radius:999px;background:#ffffff1f;transition:background var(--dur-fast)}.ps-switch:after{content:"";position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c66;transition:transform var(--dur-med) var(--ease-out-soft)}.ps-level.on .ps-switch{background:var(--cv-accent)}.ps-level.on .ps-switch:after{transform:translate(12px)}.ps-level.is-off{cursor:default;opacity:.5}.ps-level.is-off:hover{background:#ffffff06}.ps-level.is-off:disabled{opacity:.62}.ps-level.is-off .ps-level-text em{white-space:normal}.ps-cats{display:flex;flex-wrap:wrap;align-items:center;gap:6px}.ps-check{display:flex;align-items:center;gap:9px;font-size:12px;color:var(--fg-2);cursor:pointer}.ps-check input{accent-color:var(--cv-accent);width:15px;height:15px;margin:0}.ps-thumbs{display:inline-flex;margin-left:4px}.ps-thumbs span{width:26px;height:26px;margin-left:-6px;border-radius:8px;background-size:cover;background-position:center;box-shadow:0 0 0 1.5px #0b0d15}.ps-thumbs span:first-child{margin-left:0}.ps-dup{display:flex;flex-wrap:wrap;align-items:center;gap:6px 8px;margin:0;padding:10px 12px;border-radius:11px;background:#a3a7f514;box-shadow:inset 0 0 0 1px #a3a7f533;color:var(--fg-2);font-size:12px}.ps-dup .licon{color:var(--vista-blue-500)}.ps-link{padding:0;border:0;background:none;color:var(--vista-blue-500);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;text-decoration:underline;text-underline-offset:3px}.ps-foot{flex:none;display:flex;gap:8px}.pl-cta:disabled{opacity:.45;cursor:default;box-shadow:none;transform:none}.v2-info-pair{display:grid;grid-template-columns:1fr 1fr;gap:8px}.v2-info-pair>:last-child:nth-child(odd){grid-column:1 / -1}.v2-info-card.is-form{flex:0 1 auto;min-height:0;padding:16px;overflow:hidden}.v2-info-card.is-form>.ps{animation:infoForm .32s var(--ease-out-soft) both}@keyframes infoForm{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.v2-info-card.is-form>.ps{animation:none}}', eSe = '.dp-wrap{position:relative;display:inline-flex}.dp-pop{position:absolute;z-index:60;bottom:calc(100% + 14px);width:480px;cursor:pointer}.dp-wrap.is-above .dp-pop{left:50%;transform:translate(-50%)}.dp-wrap.is-above-start .dp-pop{left:-8px}.dp-pop:after{content:"";position:absolute;left:0;right:0;top:100%;height:16px}.dp-card{overflow:hidden;border-radius:18px;border:1px solid rgba(255,255,255,.08);background:radial-gradient(120% 70% at 50% -18%,rgba(153,104,223,.1),transparent 62%),#0a0c14f9;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 40px 110px #02040cad;transition:border-color var(--dur-fast)}.dp-pop:hover .dp-card{border-color:#c4a2ff57}.dp-media{position:relative;aspect-ratio:16 / 9;overflow:hidden;background:#07080d}.dp-media img,.dp-media video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;user-select:none;-webkit-user-select:none}.dp-tag{position:absolute;top:10px;left:10px;z-index:2;display:inline-flex;align-items:center;gap:5px;height:22px;padding:0 9px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#fff;font-family:var(--font-sans);font-size:10.5px;font-weight:600;letter-spacing:.01em}.dp-body{padding:13px 16px 14px;font-family:var(--font-sans)}.dp-words b{display:block;font-size:14px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.dp-words span{display:block;margin-top:3px;min-height:2.9em;font-size:12px;line-height:1.45;color:var(--fg-3)}.dp-foot{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:11px}.dp-dots{display:inline-flex;align-items:center;gap:5px}.dp-dots button{width:16px;height:4px;padding:0;border:0;border-radius:999px;overflow:hidden;background:#ffffff24;cursor:pointer;transition:width var(--dur-med) var(--ease-out-soft),background var(--dur-fast)}.dp-dots button:hover{background:#ffffff3d}.dp-dots button.on{width:30px}.dp-dots button i{display:block;width:0;height:100%;border-radius:inherit;background:var(--cv-accent-soft)}.dp-dots button.on i{animation:dpFill var(--d, 3.4s) linear forwards}@keyframes dpFill{to{width:100%}}.dp-cta{display:inline-flex;align-items:center;gap:3px;font-size:11.5px;font-weight:600;color:var(--cv-accent-text);white-space:nowrap}.dp-pop-enter-active,.dp-pop-leave-active{transition:opacity .22s var(--ease-out-soft),translate .22s var(--ease-out-soft),scale .22s var(--ease-out-soft)}.dp-pop-enter-from,.dp-pop-leave-to{opacity:0;translate:0 8px;scale:.98}.dp-slide-enter-active,.dp-slide-leave-active{transition:opacity .45s ease}.dp-slide-enter-from,.dp-slide-leave-to{opacity:0}.dp-words-enter-active,.dp-words-leave-active{transition:opacity .18s ease,translate .18s ease}.dp-words-enter-from{opacity:0;translate:0 4px}.dp-words-leave-to{opacity:0}@media(prefers-reduced-motion:reduce){.dp-pop-enter-active,.dp-pop-leave-active,.dp-slide-enter-active,.dp-slide-leave-active,.dp-words-enter-active,.dp-words-leave-active{transition:none}.dp-dots button.on i{animation:none;width:100%}}', tSe = '.cv-feedback{position:relative;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff08;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cv-feedback .licon{color:var(--fg-4);transition:color var(--dur-fast)}.cv-feedback:hover{background:#ffffff12;color:var(--fg-1)}.cv-feedback:hover .licon{color:var(--fg-2)}.cv-feedback-dot{position:absolute;top:-2px;right:-2px;width:7px;height:7px;border-radius:50%;background:var(--amethyst-700, #c2a4ec);box-shadow:0 0 0 2px #070910e6}.fb-flash{position:absolute;inset:0;z-index:130;pointer-events:none;background:#fff;opacity:0;animation:fbFlash .36s ease-out both}@keyframes fbFlash{0%{opacity:.38}to{opacity:0}}@media(prefers-reduced-motion:reduce){.fb-flash{animation:none}}.fb{position:absolute;inset:0;z-index:120;display:flex;align-items:center;justify-content:center;padding:24px;background:#04030c85;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:ksFade .2s ease both}.fb-card{position:relative;width:min(1060px,100%);height:min(720px,100%);outline:none;display:flex;flex-direction:column;border-radius:24px;background:#0b0d15f5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb8;font-family:var(--font-sans);animation:ksIn .34s var(--ease-out-soft) both}.fb-card:before{content:"";position:absolute;left:32px;right:32px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.5),rgba(153,104,223,.7),rgba(90,97,237,.5),transparent)}.fb-head{flex:none;display:flex;align-items:center;gap:14px;padding:24px 30px 18px}.fb-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 10px 26px #745aff52}.fb-titles{flex:1;min-width:0}.fb-titles h2{margin:0;font-size:18px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.fb-titles p{margin:4px 0 0;font-size:12.5px;color:var(--fg-4)}.fb-close{margin-left:auto;align-self:flex-start;flex:none;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.fb-close:hover{background:#ffffff17;color:var(--fg-1)}.fb-body{flex:1;min-height:0;display:grid;grid-template-columns:minmax(0,1fr) 344px;gap:24px;padding:0 30px}.fb-shots{min-width:0;min-height:0;display:flex;flex-direction:column;gap:12px}.fb-preview{position:relative;flex:1;min-height:0;display:flex;align-items:center;justify-content:center;overflow:hidden;border-radius:16px;border:1px solid var(--hairline-soft);background:var(--bg-deep)}.fb-preview img{display:block;max-width:100%;max-height:100%;object-fit:contain}.fb-preview-note{display:inline-flex;align-items:center;gap:8px;padding:0 24px;text-align:center;font-size:12.5px;color:var(--fg-4)}.fb-strip{flex:none;display:flex;align-items:center;gap:8px;overflow-x:auto;padding:2px 2px 4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.fb-thumb{position:relative;flex:none;width:104px;height:64px;border-radius:10px}.fb-thumb-pick{width:100%;height:100%;padding:0;overflow:hidden;cursor:pointer;border:1.5px solid var(--hairline-soft);border-radius:10px;background:var(--bg-deep);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.fb-thumb-pick img{display:block;width:100%;height:100%;object-fit:cover}.fb-thumb.on .fb-thumb-pick{border-color:var(--cv-accent);box-shadow:0 0 0 3px var(--cv-accent-tint)}.fb-thumb-n{position:absolute;left:5px;top:5px;min-width:18px;height:18px;padding:0 5px;pointer-events:none;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;background:#04030cc7;color:var(--fg-1);font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums}.fb-thumb-x{position:absolute;right:4px;top:4px;width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;opacity:0;border:0;border-radius:50%;background:#04030cd9;color:var(--fg-1);cursor:pointer;transition:opacity var(--dur-fast)}.fb-thumb:hover .fb-thumb-x,.fb-thumb:focus-within .fb-thumb-x{opacity:1}.fb-add{flex:none;width:128px;height:64px;padding:0 8px;display:inline-flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;border:1.5px dashed rgba(255,255,255,.18);border-radius:10px;background:transparent;color:var(--fg-3);font-size:11.5px;font-weight:600;cursor:pointer;transition:border-color var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.fb-add:hover:not(:disabled){border-color:var(--cv-accent-soft);color:var(--fg-1);background:#ffffff08}.fb-add:disabled{opacity:.45;cursor:default}.fb-tip{flex:none;margin:-4px 2px 0;font-size:11.5px;color:var(--fg-4)}.fb-card.is-dropping{border-color:var(--cv-accent-soft);box-shadow:var(--inset-highlight),0 0 0 3px var(--cv-accent-tint),0 40px 120px #02040cb8}.fb-drop{position:absolute;inset:0;pointer-events:none;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;border:1.5px dashed var(--cv-accent-soft);border-radius:inherit;background:#0b0d15db;color:var(--fg-1);font-size:13px;font-weight:600}.fb-form{min-width:0;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:14px;margin:0 -6px;padding:0 6px 4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.fb-seg{flex:none;display:grid;grid-template-columns:repeat(3,1fr);gap:2px;padding:3px;border-radius:12px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.fb-seg button{height:30px;display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:0;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;font-size:12px;font-weight:600;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.fb-seg button:hover:not(.is-on){color:var(--fg-1);background:#ffffff0d}.fb-seg button.is-on{color:#fff;cursor:default;background:linear-gradient(180deg,#9968df75,#5a61ed57);box-shadow:inset 0 1px #ffffff29,0 6px 16px #745aff42}.fb-field{flex:none;display:flex;flex-direction:column;gap:8px;min-width:0}.fb-label{font-size:12px;font-weight:600;color:var(--fg-2)}.fb-text{width:100%;box-sizing:border-box;min-height:84px;padding:10px 12px;resize:vertical;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;line-height:1.55;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast);user-select:text;-webkit-user-select:text}.fb-text.is-short{min-height:58px}.fb-text:focus{border-color:var(--cv-accent-soft);background:#ffffff0f}.fb-text::placeholder{color:var(--fg-4)}.fb-inc-box{flex:none;padding:4px 12px 6px;border:1px solid var(--hairline-soft);border-radius:14px;background:#ffffff05}.fb-inc-h{padding:8px 0 6px;font-size:10px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.fb-inc{display:flex;align-items:flex-start;gap:10px;padding:7px 0;border-top:1px solid var(--hairline-soft)}.fb-inc-what{flex:1;min-width:0;display:flex;align-items:flex-start;gap:9px;font-size:12.5px;color:var(--fg-2);cursor:pointer}.fb-inc-what.is-fixed{cursor:default}.fb-inc-what input{flex:none;width:15px;height:15px;margin:1px 0 0;accent-color:var(--cv-accent)}.fb-inc-what .licon{flex:none;width:15px;color:var(--success)}.fb-inc-what small{display:block;margin-top:2px;font-size:11px;color:var(--fg-4)}.fb-view{flex:none;padding:0;border:0;background:none;cursor:pointer;color:var(--vista-blue-500);font-family:var(--font-sans);font-size:11.5px;font-weight:600}.fb-view:hover{text-decoration:underline;text-underline-offset:3px}.fb-peek{margin:0 0 8px 24px;max-height:168px;overflow:auto;padding:8px 10px;border-radius:10px;border:1px solid var(--hairline-soft);background:var(--bg-deep);font:11px/1.55 ui-monospace,SF Mono,Menlo,monospace;color:var(--fg-3);white-space:pre-wrap;overflow-wrap:anywhere;user-select:text;-webkit-user-select:text}.fb-foot{flex:none;display:flex;align-items:center;gap:10px;padding:18px 30px 24px}.fb-note{margin-right:auto;font-size:11.5px;color:var(--fg-4)}.fb-error{max-width:420px;font-size:12px;color:#ff8aa0}.fb-keys{font-size:11px;color:var(--fg-5);font-variant-numeric:tabular-nums}.fb-foot .bd-btn:disabled{opacity:.45;cursor:default;transform:none;filter:none}.fb-confirm{margin-right:auto;display:inline-flex;align-items:center;gap:10px;font-size:12.5px;color:var(--fg-2)}@media(max-width:860px){.fb-card{height:100%}.fb-body{grid-template-columns:minmax(0,1fr);overflow-y:auto}.fb-preview{flex:none;height:240px}.fb-form{overflow:visible}}.fb-aside{position:absolute;left:50%;top:72px;z-index:150;transform:translate(-50%);display:inline-flex;align-items:center;gap:10px;max-width:min(640px,calc(100vw - 32px));padding:5px 5px 5px 6px;border-radius:999px;background:#11131ef5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 18px 44px #02040c8c;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;font-weight:500;white-space:nowrap}.fb-aside-mark{flex:none;width:26px;height:26px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--cv-accent-text)}.fb-aside-text{min-width:0;overflow:hidden;text-overflow:ellipsis}.fb-aside-count{flex:none;color:var(--fg-4);font-variant-numeric:tabular-nums}.fb-aside-btn{flex:none;height:26px;padding:0 12px;border:0;border-radius:999px;cursor:pointer;display:inline-flex;align-items:center;gap:6px;background:#ffffff14;color:var(--fg-1);font:inherit;font-weight:600;transition:background var(--dur-fast),filter var(--dur-fast)}.fb-aside-btn:hover:not(:disabled){background:#ffffff24}.fb-aside-btn.is-cta{background:var(--grad-cta)}.fb-aside-btn.is-cta:hover:not(:disabled){filter:brightness(1.08)}.fb-aside-btn:disabled{opacity:.5;cursor:default}.fb-aside-enter-active{transition:opacity .25s var(--ease-out-soft),transform .25s var(--ease-out-soft)}.fb-aside-leave-active{transition:opacity .18s ease,transform .18s ease}.fb-aside-enter-from,.fb-aside-leave-to{opacity:0;transform:translate(-50%) translateY(-6px)}', nSe = `.cv-root{--cm-unread: #d36be0;--cm-unread-glow: rgba(211, 107, 224, .45);--cm-card-bg: rgba(14, 16, 26, .97);--cm-raise: rgba(255, 255, 255, .05)}.cm-avatar{flex:none;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;color:#fff;font-weight:700;letter-spacing:.02em;line-height:1;box-shadow:inset 0 0 0 1px #ffffff2e,inset 0 1px #ffffff40;text-shadow:0 1px 2px rgba(10,6,30,.35);user-select:none}.cm-text{white-space:pre-wrap;word-wrap:break-word;overflow-wrap:anywhere}.cm-text.is-clamped{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.cm-text.is-big{font-size:30px;line-height:1.15;letter-spacing:.04em}.cm-mention{color:var(--amethyst-700);font-weight:600;border-radius:5px;padding:0 2px;margin:0 -1px;background:#9968df24}.cm-mention.is-me{color:#fff;background:linear-gradient(90deg,#c750ce6b,#9968df6b)}.cm-link{color:var(--vista-blue-500);text-decoration:underline;text-decoration-color:#a3a7f566;text-underline-offset:2px;word-break:break-all}.cm-link:hover{color:#fff;text-decoration-color:currentColor}.cv-stage.is-commenting,.cv-stage.is-commenting .cv-el,.cv-stage.is-commenting .cv-el *,.cv-stage.is-commenting .cv-frame-title{cursor:url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'><path d='M3 25V14a10 10 0 1 1 10 10z' fill='%239968df' stroke='white' stroke-width='2' stroke-linejoin='round'/><path d='M13 9.5v8M9 13.5h8' stroke='white' stroke-width='2.2' stroke-linecap='round'/></svg>") 3 25,crosshair}.cm-pins{position:absolute;left:0;top:0;width:0;height:0;z-index:1000000;pointer-events:none}.cm-pin-at{position:absolute;width:0;height:0}.cm-pin-at.is-open,.cm-pin-at:hover{z-index:2}.cm-pin{position:absolute;left:0;bottom:0;width:36px;height:36px;padding:3px;margin:0;transform-origin:0 100%;transform:scale(var(--cv-inv-zoom));border:0;border-radius:18px 18px 18px 4px;background:var(--thread, var(--amethyst-500));box-shadow:0 0 0 1.5px #ffffffeb,0 8px 22px #02040e80,0 2px 5px #02040e59;cursor:pointer;pointer-events:auto;touch-action:none;transition:box-shadow var(--dur-fast),filter var(--dur-fast);animation:cmPinIn .42s cubic-bezier(.34,1.56,.64,1) both}@keyframes cmPinIn{0%{opacity:0;scale:.3}to{opacity:1;scale:1}}.cm-pin-face{width:30px;height:30px;border-radius:15px 15px 15px 2px;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#0b0d14;transition:transform var(--dur-fast) var(--ease-out-soft)}.cm-pin-face .cm-avatar{width:30px!important;height:30px!important;border-radius:0;box-shadow:none;font-size:11px!important}.cm-pin:hover{filter:brightness(1.08);box-shadow:0 0 0 1.5px #fff,0 12px 28px #02040e8c,0 0 0 6px color-mix(in srgb,var(--thread) 26%,transparent)}.cm-pin:hover .cm-pin-face{transform:scale(1.04)}.cm-pin-at.is-open .cm-pin{box-shadow:0 0 0 2px #fff,0 0 0 7px color-mix(in srgb,var(--thread) 38%,transparent),0 12px 30px #02040e99}.cm-pin-at.is-dragging .cm-pin{cursor:grabbing;filter:brightness(1.1);box-shadow:0 0 0 2px #fff,0 20px 40px #02040e99;animation:none}.cm-pin-at.is-resolved .cm-pin{opacity:.86}.cm-pin-check{display:flex;align-items:center;justify-content:center;width:100%;height:100%;color:#fff;background:var(--thread)}.cm-pin-count{position:absolute;right:-9px;bottom:-5px;min-width:18px;height:18px;padding:0 5px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:#0b0d14;color:#fff;font-size:10px;font-weight:700;font-variant-numeric:tabular-nums;line-height:1;box-shadow:0 0 0 1.5px var(--thread),0 3px 8px #0006}.cm-pin-dot{position:absolute;right:-3px;top:-3px;width:12px;height:12px;border-radius:50%;background:var(--cm-unread);box-shadow:0 0 0 2px #fff,0 0 12px var(--cm-unread-glow)}.cm-pin-dot:after{content:"";position:absolute;inset:-2px;border-radius:50%;border:2px solid var(--cm-unread);animation:cmPulse 1.8s var(--ease-out-soft) infinite}@keyframes cmPulse{0%{opacity:.85;transform:scale(1)}to{opacity:0;transform:scale(2.4)}}.cm-pin.is-flash{animation:cmPinFlash .9s cubic-bezier(.34,1.56,.64,1) both}@keyframes cmPinFlash{0%{scale:1;rotate:0deg}30%{scale:1.28;rotate:-4deg}60%{scale:.94;rotate:2deg}to{scale:1;rotate:0deg}}.cm-pin.is-flash:before{content:"";position:absolute;inset:-4px;border-radius:inherit;border:2px solid var(--thread);animation:cmRipple .9s var(--ease-out-soft) both;pointer-events:none}@keyframes cmRipple{0%{opacity:.9;transform:scale(1)}to{opacity:0;transform:scale(2)}}.cm-pin.is-draft{cursor:default;pointer-events:none;background:transparent;padding:1px;border:2px dashed rgba(255,255,255,.85);box-shadow:0 8px 22px #02040e80;animation:cmPinIn .42s cubic-bezier(.34,1.56,.64,1) both,cmDraft 1.6s ease-in-out .42s infinite}.cm-pin.is-draft .cm-pin-face{width:30px;height:30px}@keyframes cmDraft{50%{box-shadow:0 0 0 6px #9968df47,0 8px 22px #02040e80}}.cm-peek{position:absolute;left:0;bottom:0;width:260px;padding:11px 13px 12px;transform-origin:0 100%;transform:scale(var(--cv-inv-zoom)) translate(46px,6px);border-radius:14px;background:var(--cm-card-bg);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 20px 50px #02040e99;color:var(--fg-2);font-size:12.5px;line-height:1.45;pointer-events:none;animation:cmPeekIn var(--dur-fast) var(--ease-out-soft) both}@keyframes cmPeekIn{0%{opacity:0;margin-left:-6px}to{opacity:1;margin-left:0}}.cm-peek-head{display:flex;align-items:baseline;gap:8px;margin-bottom:4px}.cm-peek-head b{color:var(--fg-1);font-size:12.5px;font-weight:600}.cm-peek-head span{font-size:11px;color:var(--fg-4)}.cm-peek-foot{margin-top:7px;font-size:11px;color:var(--fg-4)}.cm-peek-foot em{font-style:normal;color:var(--cm-unread);font-weight:600}.cm-cards{position:absolute;inset:0;z-index:44;pointer-events:none;overflow:hidden}.cm-card{position:absolute;left:0;top:0;width:344px;max-height:calc(100vh - 140px);display:flex;flex-direction:column;pointer-events:auto;border-radius:18px;background:var(--cm-card-bg);border:1px solid var(--hairline);backdrop-filter:blur(28px) saturate(120%);-webkit-backdrop-filter:blur(28px) saturate(120%);box-shadow:var(--inset-highlight),0 0 0 1px #00000040,0 30px 80px #02040e9e;color:var(--fg-2);font-size:13px;user-select:text;-webkit-user-select:text;animation:cmCardIn .28s var(--ease-out-soft) both}.cm-card:before{content:"";position:absolute;left:16px;right:16px;top:-1px;height:2px;border-radius:0 0 2px 2px;background:linear-gradient(90deg,transparent,var(--thread),transparent);opacity:.85;pointer-events:none}@keyframes cmCardIn{0%{opacity:0;scale:.96}to{opacity:1;scale:1}}.cm-card.is-away{visibility:hidden}.cm-card.is-pinned{box-shadow:var(--inset-highlight),0 0 0 1px color-mix(in srgb,var(--thread) 40%,transparent),0 24px 60px #02040e80}.cm-card-head{flex:none;display:flex;align-items:center;gap:4px;padding:9px 9px 7px 12px}.cm-grow{flex:1}.cm-icon{flex:none;position:relative;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.cm-icon:hover{background:#ffffff14;color:var(--fg-1)}.cm-icon.on{color:var(--amethyst-700)}.cm-nav{flex:none;display:inline-flex;align-items:center;gap:0;margin:-2px -4px -2px 0;padding:0 2px;border-radius:9px;background:#ffffff0a}.cm-nav .cm-icon{width:22px;height:22px}.cm-nav-n{min-width:40px;text-align:center;font-size:11px;font-weight:600;color:var(--fg-3);font-variant-numeric:tabular-nums;white-space:nowrap}.cm-dots{display:inline-flex;align-items:center;gap:3px}.cm-dot{width:18px;height:18px;padding:0;border:0;border-radius:50%;background:transparent;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;position:relative}.cm-dot:after{content:"";width:10px;height:10px;border-radius:50%;background:var(--c);transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.cm-dot:hover:after{transform:scale(1.25)}.cm-dot.on:after{box-shadow:0 0 0 2px var(--cm-card-bg),0 0 0 3.5px var(--c)}.cm-resolve{flex:none;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 10px 0 8px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff0a;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cm-resolve:hover{background:#37d3991f;border-color:#37d39966;color:#fff}.cm-resolve:hover .licon{color:var(--success)}.cm-resolve.on{background:#37d39929;border-color:#37d39973;color:#c9f5e4}.cm-resolve.on .licon{color:var(--success);animation:cmTick .5s cubic-bezier(.34,1.56,.64,1)}@keyframes cmTick{0%{transform:scale(.4) rotate(-30deg)}to{transform:none}}.cm-card-menu-wrap{position:relative;display:inline-flex}.cm-card-menu{position:absolute;right:-4px;top:calc(100% + 6px);z-index:5;min-width:220px;display:flex;flex-direction:column;padding:5px;border:1px solid var(--hairline);border-radius:13px;background:#131521fa;box-shadow:var(--inset-highlight),0 20px 50px #02040e99;animation:cvMenuIn var(--dur-fast) var(--ease-out-soft) both}.cm-card-menu>button{display:flex;align-items:center;flex-wrap:wrap;column-gap:10px;width:100%;padding:8px 10px;text-align:left;border:0;border-radius:8px;background:transparent;color:var(--fg-1);cursor:pointer;font-family:var(--font-sans);font-size:12.5px;font-weight:500;white-space:nowrap}.cm-card-menu>button small{flex-basis:100%;padding-left:24px;font-size:11px;color:var(--fg-4);font-weight:400}.cm-card-menu>button .licon{color:var(--fg-3)}.cm-card-menu>button:hover:not(:disabled){background:#ffffff12}.cm-card-menu>button:hover .licon{color:var(--fg-1)}.cm-card-menu>button:disabled{opacity:.4;cursor:default}.cm-card-menu>button.is-danger{color:#ff9eb0}.cm-card-menu>button.is-danger .licon{color:#ff7f98}.cm-card-menu>button.is-danger:hover{background:#ff5c7a1f}.cm-card-menu-sep{height:1px;margin:4px 6px;background:var(--hairline-soft)}.cm-card-menu kbd{margin-left:6px;padding:1px 5px;border-radius:5px;border:1px solid var(--hairline);font-family:var(--font-sans);font-size:10.5px;color:var(--fg-4)}.cm-switch{position:relative;margin-left:auto;width:28px;height:16px;border-radius:999px;background:#ffffff24;transition:background var(--dur-fast)}.cm-switch:after{content:"";position:absolute;left:2px;top:2px;width:12px;height:12px;border-radius:50%;background:#fff;box-shadow:0 1px 4px #0006;transition:transform var(--dur-fast) var(--ease-out-soft)}.cm-switch.on{background:var(--cv-accent)}.cm-switch.on:after{transform:translate(12px)}.cm-strip{flex:none;display:flex;align-items:center;gap:8px;min-height:22px;padding:0 14px 8px}.cm-on{min-width:0;display:inline-flex;align-items:center;gap:5px;max-width:100%;height:20px;padding:0 8px 0 6px;border-radius:6px;background:#ffffff0d;color:var(--fg-3);font-size:11px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-on.is-inline{flex:0 1 auto;margin-left:2px}.cm-resolved-note{display:inline-flex;align-items:center;gap:4px;font-size:11px;font-weight:600;color:var(--success)}.cm-list{flex:1 1 auto;min-height:0;max-height:380px;overflow-y:auto;padding:2px 6px 4px;border-top:1px solid var(--hairline-soft);scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.cm-reply{flex:none;padding:8px 10px 10px;border-top:1px solid var(--hairline-soft)}.cm-card.is-resolved .cm-list{opacity:.8}.cm-draft-head{display:flex;align-items:center;gap:9px;padding:10px 9px 8px 12px}.cm-draft-title{font-size:13px;font-weight:600;color:var(--fg-1);white-space:nowrap}.cm-card.is-draft{width:336px}.cm-card.is-draft .cm-compose{margin:0 10px 10px}.cm-row{position:relative;display:flex;gap:10px;padding:10px 8px;border-radius:12px;animation:cmRowIn .32s var(--ease-out-soft) both;transition:background var(--dur-fast)}@keyframes cmRowIn{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.cm-row:hover{background:#ffffff09}.cm-row-main{flex:1;min-width:0}.cm-row-head{display:flex;align-items:baseline;gap:7px;margin-bottom:3px;padding-right:64px}.cm-row.is-editing .cm-row-head{padding-right:0}.cm-row-name{color:var(--fg-1);font-size:12.5px;font-weight:600;letter-spacing:-.005em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-row-time{flex:none;font-size:11px;color:var(--fg-4);white-space:nowrap}.cm-row-edited{flex:none;font-size:10.5px;color:var(--fg-5);font-style:italic}.cm-row-text{display:block;color:#ffffffdb;font-size:13px;line-height:1.5}.cm-row-acts{position:absolute;right:6px;top:6px;display:flex;gap:1px;padding:2px;border-radius:9px;background:#181b29fa;border:1px solid var(--hairline);box-shadow:0 6px 16px #0006;opacity:0;transform:translateY(2px);pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cm-row:hover .cm-row-acts,.cm-row:focus-within .cm-row-acts{opacity:1;transform:none;pointer-events:auto}.cm-row-acts button{width:26px;height:24px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-3);cursor:pointer}.cm-row-acts button:hover{background:#ffffff17;color:var(--fg-1)}.cm-reactions{display:flex;flex-wrap:wrap;gap:5px;margin-top:7px}.cm-chip{display:inline-flex;align-items:center;gap:5px;height:24px;padding:0 8px 0 6px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff0a;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cm-chip .e{font-size:14px;line-height:1}.cm-chip .n{font-variant-numeric:tabular-nums}.cm-chip:hover{background:#ffffff14;border-color:#ffffff2e;transform:translateY(-1px)}.cm-chip:active{transform:scale(.94)}.cm-chip.mine{background:#9968df33;border-color:#ae86e599;color:#fff}.cm-chip.is-add{padding:0 7px;color:var(--fg-4);opacity:0}.cm-row:hover .cm-chip.is-add{opacity:1}.cm-compose{position:relative;display:flex;align-items:flex-end;gap:6px;padding:6px 6px 6px 12px;border:1px solid var(--hairline);border-radius:14px;background:#ffffff0b;transition:border-color var(--dur-fast),background var(--dur-fast),box-shadow var(--dur-fast)}.cm-compose:focus-within{border-color:var(--cv-accent-soft);background:#ffffff0f;box-shadow:0 0 0 3px #9968df1f}.cm-compose.is-nod{animation:cmNod .42s cubic-bezier(.36,.07,.19,.97) both}@keyframes cmNod{20%,60%{transform:translate(-5px)}40%,80%{transform:translate(5px)}}.cm-compose-box{flex:1;min-width:0;min-height:22px;max-height:168px;padding:4px 0;resize:none;overflow-y:auto;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;line-height:1.45;user-select:text;-webkit-user-select:text}.cm-compose-box::placeholder{color:var(--fg-4)}.cm-compose-tools{flex:none;display:flex;align-items:center;gap:2px}.cm-tool{width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.cm-tool:hover,.cm-tool.on{background:#ffffff14;color:var(--fg-1)}.cm-send{width:28px;height:28px;padding:0;margin-left:2px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:#ffffff14;color:var(--fg-4);cursor:default;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.cm-compose.can-send .cm-send{background:var(--grad-cta);color:#fff;cursor:pointer;box-shadow:0 6px 16px #785ae673}.cm-compose.can-send .cm-send:hover{transform:translateY(-1px)}.cm-compose.can-send .cm-send:active{transform:scale(.92)}.cm-compose.is-editing{flex-direction:column;align-items:stretch;padding:6px 6px 6px 10px;margin-top:2px}.cm-compose.is-editing .cm-compose-tools{justify-content:flex-end;gap:6px}.cm-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:32px;padding:0 14px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;cursor:pointer;font-family:var(--font-sans);font-size:12.5px;font-weight:600;box-shadow:0 8px 20px #785ae659;transition:transform var(--dur-fast) var(--ease-out-soft),opacity var(--dur-fast)}.cm-btn:hover{transform:translateY(-1px)}.cm-btn:disabled{opacity:.4;cursor:default;transform:none}.cm-btn.is-sm{height:26px;padding:0 12px;font-size:12px}.cm-btn.is-ghost{background:#ffffff0f;color:var(--fg-2);box-shadow:none;border:1px solid var(--hairline)}.cm-btn.is-ghost:hover{background:#ffffff1a;color:#fff}.cm-portal{position:absolute;inset:0;z-index:140;pointer-events:none}.cm-portal>*{pointer-events:auto}.cm-menu{position:absolute;left:-1px;right:-1px;top:calc(100% + 6px);z-index:10;min-width:260px;max-height:300px;overflow-y:auto;padding:5px;border:1px solid var(--hairline);border-radius:13px;background:#131521fa;box-shadow:var(--inset-highlight),0 24px 60px #02040ea6;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);animation:cvMenuIn var(--dur-fast) var(--ease-out-soft) both}.cm-menu.is-up{top:auto;bottom:calc(100% + 6px)}.cm-menu-row{display:flex;align-items:center;gap:10px;width:100%;padding:6px 8px;text-align:left;border:0;border-radius:9px;background:transparent;color:var(--fg-1);cursor:pointer;font-family:var(--font-sans)}.cm-menu-row.on{background:#9968df2e}.cm-menu-text{min-width:0;display:flex;flex-direction:column;gap:1px}.cm-menu-text b{font-size:12.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-menu-text b i{font-style:normal;font-weight:500;color:var(--fg-4)}.cm-menu-text small{font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-menu-group{width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#ffffff14;color:var(--fg-2);flex:none}.cm-menu-emoji{width:24px;text-align:center;font-size:18px;line-height:1;flex:none}.cm-menu-alone{padding:10px;font-size:12px;line-height:1.45;color:var(--fg-3);max-width:300px}.cm-emoji{position:absolute;width:340px;height:392px;display:flex;flex-direction:column;border:1px solid var(--hairline);border-radius:16px;background:#11131efb;box-shadow:var(--inset-highlight),0 30px 80px #02040eb3;backdrop-filter:blur(28px);-webkit-backdrop-filter:blur(28px);animation:cmCardIn .22s var(--ease-out-soft) both;overflow:hidden;user-select:none}.cm-emoji-head{flex:none;display:flex;align-items:center;gap:6px;padding:10px 10px 6px}.cm-emoji-search{flex:1;min-width:0;display:flex;align-items:center;gap:7px;height:32px;padding:0 8px 0 10px;border:1px solid var(--hairline);border-radius:10px;background:#ffffff0d;color:var(--fg-4)}.cm-emoji-search:focus-within{border-color:var(--cv-accent-soft);color:var(--fg-2)}.cm-emoji-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;user-select:text;-webkit-user-select:text}.cm-emoji-search input::placeholder{color:var(--fg-4)}.cm-emoji-clear{width:20px;height:20px;padding:0;border:0;border-radius:6px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center}.cm-emoji-clear:hover{color:var(--fg-1);background:#ffffff14}.cm-emoji-tone{flex:none;display:flex;gap:1px;padding:2px;border-radius:10px}.cm-emoji-tone.open{background:#ffffff0d}.cm-emoji-tonebtn{width:28px;height:28px;padding:0;border:0;border-radius:8px;background:transparent;font-size:17px;line-height:1;cursor:pointer}.cm-emoji-tonebtn:hover,.cm-emoji-tonebtn.on{background:#ffffff1a}.cm-emoji-quick{flex:none;display:flex;justify-content:space-between;padding:2px 10px 6px}.cm-emo{width:36px;height:36px;padding:0;border:0;border-radius:9px;background:transparent;cursor:pointer;font-size:22px;line-height:1;font-family:"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif;transition:background var(--dur-fast),transform .12s var(--ease-out-soft)}.cm-emo:hover{background:#ffffff1a;transform:scale(1.14)}.cm-emo:active{transform:scale(.9)}.cm-emo.is-quick{width:36px;height:36px;font-size:22px;background:#ffffff0a}.cm-emoji-tabs{flex:none;display:flex;justify-content:space-between;padding:0 8px 4px;border-bottom:1px solid var(--hairline-soft)}.cm-emoji-tabs button{position:relative;width:32px;height:30px;padding:0;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:color var(--dur-fast),background var(--dur-fast)}.cm-emoji-tabs button:hover{color:var(--fg-1);background:#ffffff0f}.cm-emoji-tabs button.on{color:#fff}.cm-emoji-tabs button.on:after{content:"";position:absolute;left:8px;right:8px;bottom:-5px;height:2px;border-radius:2px;background:var(--grad-purple-pink)}.cm-emoji-body{flex:1;min-height:0;overflow-y:auto;padding:4px 8px 6px;scroll-behavior:auto;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.cm-emoji-sec{content-visibility:auto;contain-intrinsic-size:auto 360px}.cm-emoji-label{position:sticky;top:-4px;z-index:1;display:flex;align-items:center;justify-content:space-between;padding:8px 4px 4px;background:#11131efb;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.cm-emoji-clearrecent{border:0;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:10.5px;font-weight:600;letter-spacing:0;text-transform:none;cursor:pointer;padding:0 2px}.cm-emoji-clearrecent:hover{color:var(--fg-1)}.cm-emoji-grid{display:grid;grid-template-columns:repeat(8,36px);justify-content:space-between;row-gap:1px}.cm-emoji-none{padding:40px 12px;text-align:center;font-size:12.5px;color:var(--fg-4)}.cm-emoji-foot{flex:none;display:flex;align-items:center;gap:9px;height:44px;padding:0 12px;border-top:1px solid var(--hairline-soft);background:#ffffff05}.cm-emoji-big{font-size:24px;line-height:1}.cm-emoji-name{flex:1;min-width:0;font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-emoji-name:first-letter{text-transform:uppercase}.cm-emoji-code{flex:none;font-size:11px;color:var(--fg-4)}.cm-emoji-hint{font-size:11.5px;color:var(--fg-4)}.cm-panel{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:340px;display:flex;flex-direction:column;border-radius:18px;background:#0b0d15f7;border:1px solid var(--hairline);backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:var(--inset-highlight),0 28px 80px #02040c99;animation:histIn .26s var(--ease-out-soft) both;user-select:none}.cm-panel-head{flex:none;display:flex;align-items:center;gap:2px;padding:12px 10px 6px 16px}.cm-panel-title{font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.cm-panel-settings-wrap{position:relative;display:inline-flex}.cm-card-menu.is-settings{width:268px}.cm-card-menu.is-settings>button{flex-wrap:nowrap}.cm-tabs{flex:none;display:grid;grid-template-columns:1fr 1fr;gap:2px;margin:4px 12px 8px;padding:3px;border-radius:11px;background:#ffffff0b;border:1px solid var(--hairline-soft)}.cm-tabs button{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:30px;padding:0 8px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;font-family:var(--font-sans);font-size:12px;font-weight:600;white-space:nowrap;transition:background var(--dur-fast),color var(--dur-fast)}.cm-tabs button:hover{color:var(--fg-1)}.cm-tabs button.on{background:#ffffff17;color:#fff;box-shadow:var(--inset-highlight),0 2px 8px #00000040}.cm-count{min-width:17px;height:17px;padding:0 5px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--cm-unread);color:#fff;font-size:10px;font-weight:700;font-variant-numeric:tabular-nums;box-shadow:0 0 10px var(--cm-unread-glow)}.cm-tools{flex:none;display:flex;flex-direction:column;gap:8px;padding:0 12px 10px;border-bottom:1px solid var(--hairline-soft)}.cm-tools.is-elsewhere{flex-direction:row;align-items:center}.cm-search{display:flex;align-items:center;gap:7px;height:32px;padding:0 8px 0 10px;border:1px solid var(--hairline);border-radius:10px;background:#ffffff0a;color:var(--fg-4);transition:border-color var(--dur-fast)}.cm-search:focus-within{border-color:var(--cv-accent-soft);color:var(--fg-2)}.cm-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;user-select:text;-webkit-user-select:text}.cm-search input::placeholder{color:var(--fg-4)}.cm-search-clear{width:20px;height:20px;padding:0;border:0;border-radius:6px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center}.cm-search-clear:hover{color:var(--fg-1);background:#ffffff14}.cm-chips{display:flex;gap:5px;flex-wrap:wrap}.cm-fchip{display:inline-flex;align-items:center;gap:5px;height:26px;padding:0 10px;border:1px solid var(--hairline);border-radius:999px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cm-fchip:hover{color:var(--fg-1);border-color:#fff3}.cm-fchip.on{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff}.cm-fchip .n{font-size:10px;color:var(--cm-unread);font-variant-numeric:tabular-nums}.cm-fchip.on .n{color:#f3c8f7}.cm-linkbtn{border:0;background:transparent;padding:0;color:var(--amethyst-700);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;white-space:nowrap}.cm-linkbtn:hover:not(:disabled){color:#fff}.cm-linkbtn:disabled{color:var(--fg-5);cursor:default}.cm-linkbtn.is-sm{font-size:11px}.cm-feed{flex:1;min-height:0;overflow-y:auto;padding:8px 8px 12px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.cm-feed-label{display:flex;align-items:center;gap:6px;padding:6px 8px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.cm-feed-empty{display:flex;flex-direction:column;align-items:center;gap:8px;padding:46px 22px;text-align:center;font-size:12.5px;line-height:1.5;color:var(--fg-4)}.cm-feed-empty b{font-size:13.5px;color:var(--fg-1);font-weight:600}.cm-feed-empty kbd{padding:1px 6px;border-radius:5px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:11px}.cm-feed-empty .cm-btn{margin-top:8px}.cm-empty-mark{width:42px;height:42px;border-radius:14px;display:inline-flex;align-items:center;justify-content:center;margin-bottom:4px;background:linear-gradient(140deg,#9968df47,#5a61ed33);color:#fff;box-shadow:inset 0 0 0 1px #ffffff1f,0 10px 30px #785ae640}.cm-empty-mark.is-error{background:#ff5c7a24;color:#ff9eb0}.cm-item{position:relative;display:flex;gap:10px;padding:11px 10px 11px 14px;margin-bottom:4px;border-radius:13px;border:1px solid transparent;cursor:pointer;outline:none;transition:background var(--dur-fast),border-color var(--dur-fast)}.cm-item:before{content:"";position:absolute;left:4px;top:14px;bottom:14px;width:3px;border-radius:3px;background:var(--thread);opacity:.55}.cm-item:hover,.cm-item:focus-visible{background:#ffffff0d;border-color:var(--hairline-soft)}.cm-item.is-open{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.cm-item.is-unread{background:#d36be00f}.cm-item.is-unread:hover{background:#d36be01a}.cm-item.is-resolved{opacity:.62}.cm-item.is-resolved:hover{opacity:.9}.cm-item-dot{position:absolute;left:-1px;top:18px;width:8px;height:8px;border-radius:50%;z-index:1;background:var(--cm-unread);box-shadow:0 0 0 2px #0b0d15f7,0 0 10px var(--cm-unread-glow)}.cm-item-main{flex:1;min-width:0}.cm-item-head{display:flex;align-items:baseline;gap:8px;margin-bottom:3px}.cm-item-head b{min-width:0;color:var(--fg-1);font-size:12.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-item-time{margin-left:auto;flex:none;font-size:11px;color:var(--fg-4);white-space:nowrap;transition:opacity var(--dur-fast)}.cm-item-text{color:var(--fg-2);font-size:12.5px;line-height:1.45}.cm-item.is-unread .cm-item-text{color:#ffffffe6}.cm-item-on{display:flex;align-items:center;gap:6px;margin-top:7px;min-width:0}.cm-item-thumb{flex:none;width:22px;height:22px;border-radius:6px;background-size:cover;background-position:center;background-repeat:no-repeat;box-shadow:inset 0 0 0 1px #ffffff1f}.cm-item-on-label{min-width:0;font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-item-foot{display:flex;align-items:center;gap:10px;margin-top:7px;font-size:11px;color:var(--fg-4)}.cm-item-foot>span{display:inline-flex;align-items:center;gap:4px}.cm-replies{display:flex;flex-direction:column;align-items:stretch;gap:8px;margin-top:9px;padding-left:11px;border-left:2px solid rgba(255,255,255,.08)}.cm-replies.is-all{gap:9px}.cm-replies-more{align-self:flex-start;padding:0;border:0;background:transparent;cursor:pointer;color:var(--amethyst-700);font-family:var(--font-sans);font-size:11.5px;font-weight:600;transition:color var(--dur-fast)}.cm-replies-more:hover{color:#fff}.cm-replies-more.is-new{color:var(--cm-unread)}.cm-replies-failed{font-size:11.5px;color:var(--fg-4)}.cm-reply-row{position:relative;display:flex;gap:8px}.cm-reply-row.is-new:before{content:"";position:absolute;left:-16px;top:7px;width:6px;height:6px;border-radius:50%;background:var(--cm-unread);box-shadow:0 0 0 2px #0b0d15f7,0 0 8px var(--cm-unread-glow)}.cm-reply-main{flex:1;min-width:0}.cm-reply-head{display:flex;align-items:baseline;gap:6px;margin-bottom:1px;min-width:0}.cm-reply-head b{min-width:0;font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-reply-head span{flex:none;font-size:10.5px;color:var(--fg-4)}.cm-reply-head i{flex:none;font-style:normal;font-size:9.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--cm-unread)}.cm-reply-text{display:block;font-size:12px;line-height:1.45;color:var(--fg-2)}.cm-item.is-unread .cm-reply-row.is-new .cm-reply-text{color:#ffffffe0}.cm-item-resolved{color:var(--success);font-weight:600}.cm-item-open{margin-left:auto;color:var(--fg-4);opacity:0;transition:opacity var(--dur-fast)}.cm-item:hover .cm-item-open{opacity:1;color:var(--amethyst-700)}.cm-item-acts{position:absolute;right:8px;top:5px;display:flex;gap:1px;padding:2px;border-radius:9px;background:#181b29fa;border:1px solid var(--hairline);box-shadow:0 6px 16px #0006;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.cm-item:hover .cm-item-acts,.cm-item:focus-within .cm-item-acts{opacity:1;pointer-events:auto}.cm-item:hover .cm-item-time{opacity:0}.cm-item-acts>button,.cm-item-menu-wrap>button{width:26px;height:22px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-3);cursor:pointer}.cm-item-acts>button:hover,.cm-item-acts>button.on,.cm-item-menu-wrap>button:hover,.cm-item-menu-wrap>button.on{background:#ffffff17;color:var(--fg-1)}.cm-item-acts>button.is-resolve.on .licon{color:var(--success)}.cm-item-menu-wrap{position:relative;display:inline-flex}.cm-card-menu.is-item{right:-6px;min-width:200px}.cm-card-menu.is-item.is-up{top:auto;bottom:calc(100% + 6px)}.cm-board-group{margin-bottom:10px}.cm-board-head{display:flex;align-items:center;gap:7px;padding:8px 8px 6px;color:var(--fg-3)}.cm-board-title{min-width:0;font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-board-n{flex:none;padding:1px 6px;border-radius:999px;background:#ffffff0f;font-size:10px;font-weight:600;color:var(--fg-3)}.bd-siderail-btn .badge.is-unread{background:var(--cm-unread);box-shadow:0 0 0 2px #121521f2,0 0 12px var(--cm-unread-glow)}.cm-rail-dot{position:absolute;right:6px;top:6px;width:8px;height:8px;border-radius:50%;background:var(--cm-unread);box-shadow:0 0 0 2px #121521f2;pointer-events:none}.v2-root.light-canvas .cm-pin{box-shadow:0 0 0 1.5px #fff,0 8px 22px #13182840,0 2px 5px #13182833}@media(prefers-reduced-motion:reduce){.cm-pin,.cm-card,.cm-row,.cm-peek,.cm-emoji,.cm-pin-dot:after{animation:none!important}}`, iSe = '.cv-el.is-chat .cv-el-body{height:100%}.cv-el.is-chat .cv-bucket{height:100%;display:flex;flex-direction:column}.cv-el.is-chat .cv-bucket-foot{margin-top:auto}.ch-card{background:linear-gradient(180deg,rgba(153,104,223,calc(.17 * var(--cv-glass-a))),rgba(153,104,223,calc(.06 * var(--cv-glass-a))));border-color:#c2a4ec38}.ch-card.is-live{border-color:#c2a4ec8c;box-shadow:var(--inset-highlight),0 0 0 calc(3px * var(--cv-inv-zoom)) #9968df29,var(--shadow-card)}.ch-badge{background:linear-gradient(135deg,#9968df8c,#5a61ed6b);color:#fff;box-shadow:inset 0 1px #ffffff2e}.ch-card .cv-bucket-model{color:var(--amethyst-700);opacity:.8}.ch-card-last{margin-top:12px;font-size:12px;line-height:1.45;color:var(--fg-2);display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;word-break:break-word}.ch-card-last b{color:var(--fg-1);font-weight:600}.ch-card-last.is-empty{color:var(--fg-4)}.ch-card-state{display:inline-flex;align-items:center;gap:6px;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-card-state.is-busy{color:var(--amethyst-700);font-weight:600}.ch-pulse{width:6px;height:6px;flex:none;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 #ae86e599}@media(prefers-reduced-motion:no-preference){.ch-pulse{animation:chPulse 1.4s var(--ease-out-soft) infinite}@keyframes chPulse{0%{box-shadow:0 0 #ae86e599}70%{box-shadow:0 0 0 7px #ae86e500}to{box-shadow:0 0 #ae86e500}}}.v2-root.light-canvas .ch-card{background:#fff;border-color:#7532d342}.v2-root.light-canvas .ch-card-last{color:var(--lc-ink-2)}.v2-root.light-canvas .ch-card-last b{color:var(--lc-ink)}.v2-root.light-canvas .ch-card-state.is-busy,.v2-root.light-canvas .ch-card .cv-bucket-model{color:var(--amethyst-400)}.cv-frame-glow{position:absolute;pointer-events:none;z-index:3;border-radius:24px;box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) #c2a4ecd9,0 0 0 calc(6px * var(--cv-inv-zoom)) #9968df29,0 0 calc(70px * var(--cv-inv-zoom)) calc(6px * var(--cv-inv-zoom)) #8f72ff47}@media(prefers-reduced-motion:no-preference){.cv-frame-glow{animation:chGlowIn .5s var(--ease-out-soft) both}.cv-frame-glow.is-working{animation:chGlowIn .5s var(--ease-out-soft) both,chBreathe 2.2s ease-in-out .5s infinite}@keyframes chGlowIn{0%{opacity:0}to{opacity:1}}@keyframes chBreathe{0%,to{opacity:1}50%{opacity:.55}}}.v2-root.light-canvas .cv-frame-glow{box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) #7532d3bf,0 0 0 calc(6px * var(--cv-inv-zoom)) #9968df29,0 0 calc(60px * var(--cv-inv-zoom)) calc(4px * var(--cv-inv-zoom)) #7532d32e}.v2-root.chat-open .v2-uprompt{right:calc(var(--set-w) + 464px)}.cv-ctxbar .cv-ctx-info.is-chat .licon{color:var(--amethyst-700)}.ch-panel{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:380px;display:flex;flex-direction:column;overflow:hidden;background:#090b13f0;backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%);border:1px solid var(--hairline);border-radius:20px;box-shadow:var(--inset-highlight),var(--shadow-deep);pointer-events:auto;animation:histIn .26s var(--ease-out-soft) both;font-family:var(--font-sans)}.ch-head{flex:none;display:flex;align-items:center;gap:10px;padding:13px 12px 11px 14px;border-bottom:1px solid var(--hairline-soft)}.ch-head-mark{width:30px;height:30px;flex:none;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:inset 0 1px #fff3,0 6px 18px #745aff4d}.ch-head-titles{flex:1;min-width:0}.ch-head-name{display:inline-flex;align-items:center;gap:4px;max-width:100%;padding:0;border:0;background:transparent;cursor:default;font-family:var(--font-sans);font-size:14px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ch-head-name .t{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-head-name.has-more{cursor:pointer}.ch-head-name.has-more .licon{color:var(--fg-4);transition:color var(--dur-fast)}.ch-head-name.has-more:hover .licon{color:var(--fg-1)}.ch-switch{position:relative}.ch-switch-menu{position:absolute;left:-6px;top:calc(100% + 8px);z-index:5;width:280px;max-height:320px;overflow-y:auto;display:flex;flex-direction:column;gap:2px;padding:6px;border-radius:14px;background:#121217fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 70px #02040cb3;animation:histIn .18s var(--ease-out-soft) both}.ch-switch-eyebrow{padding:4px 8px 6px;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.18em;color:var(--fg-5)}.ch-switch-row{display:flex;align-items:center;gap:9px;width:100%;padding:7px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);text-align:left;cursor:pointer;transition:background var(--dur-fast)}.ch-switch-row:hover{background:#ffffff0f}.ch-switch-row.on{background:var(--cv-accent-tint)}.ch-switch-row>.licon{flex:none;color:var(--amethyst-700)}.ch-switch-row .m{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.ch-switch-row .n{font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-switch-row .f{font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-switch-row .c{flex:none;font-size:10px;font-weight:600;color:var(--fg-4);background:#ffffff0f;border-radius:999px;padding:2px 7px;font-variant-numeric:tabular-nums}.ch-head-sub{display:flex;align-items:center;gap:5px;margin-top:2px;font-size:11px;color:var(--fg-4);min-width:0}.ch-head-frame{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--fg-3)}.ch-head-sub .dot{color:var(--fg-5)}.ch-head-n{flex:none;color:var(--amethyst-700);font-weight:600}.ch-iconbtn{flex:none;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0a;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ch-iconbtn:hover{background:#ffffff17;color:var(--fg-1)}.ch-context{flex:none;display:flex;flex-wrap:wrap;gap:5px;padding:9px 14px 10px;border-bottom:1px solid var(--hairline-soft)}.ch-context.is-none{font-size:11px;line-height:1.45;color:var(--fg-4)}.ch-ctxchip{display:inline-flex;align-items:center;gap:5px;height:24px;padding:0 9px;border-radius:999px;border:1px solid rgba(194,164,236,.22);background:#9968df1a;color:var(--amethyst-800);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ch-ctxchip:hover{background:#9968df33;border-color:var(--cv-accent-soft);color:#fff}.ch-ctxchip .licon{color:var(--amethyst-700)}.ch-ctxchip.is-empty{cursor:default;border-color:var(--hairline-soft);background:#ffffff0a;color:var(--fg-4)}.ch-ctxchip.is-empty .licon{color:var(--fg-5)}.ch-scroll{flex:1;min-height:0;overflow-y:auto;padding:16px 14px 6px;overscroll-behavior:contain}.ch-scroll::-webkit-scrollbar{width:8px}.ch-scroll::-webkit-scrollbar-thumb{background:#ffffff17;border-radius:4px;border:2px solid transparent;background-clip:content-box}.ch-intro{display:flex;flex-direction:column;align-items:center;text-align:center;gap:8px;padding:22px 8px 10px}.ch-intro-mark{width:36px;height:36px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:0 10px 26px #745aff4d}.ch-intro-title{margin-top:4px;font-size:15px;font-weight:600;letter-spacing:-.015em;color:var(--fg-1);text-wrap:balance}.ch-intro-sub{font-size:12px;line-height:1.5;color:var(--fg-4);text-wrap:pretty;max-width:300px}.ch-msg{margin-bottom:16px}@media(prefers-reduced-motion:no-preference){.ch-msg{animation:chMsgIn .45s var(--ease-out-soft) both}@keyframes chMsgIn{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}}.ch-msg.is-user{display:flex;flex-direction:column;align-items:flex-end}.ch-msg-meta{display:flex;align-items:center;gap:5px;margin:0 4px 4px;font-size:10px;font-weight:500;color:var(--fg-5)}.ch-msg.is-theirs .ch-msg-meta{color:var(--fg-4)}.ch-bubble{max-width:88%;border-radius:16px 16px 6px;background:linear-gradient(180deg,#ffffff16,#ffffff09);border:1px solid var(--hairline);box-shadow:inset 0 1px #ffffff12;padding:10px 13px;font-size:13px;line-height:1.5;color:#ffffffe0;word-break:break-word}.ch-msg.is-theirs .ch-bubble{background:linear-gradient(180deg,#5a61ed29,#5a61ed12);border-color:#a3a7f538}.ch-msg.is-agent{display:flex;gap:10px}.ch-ai-mark{width:24px;height:24px;flex:none;border-radius:8px;margin-top:1px;background:var(--grad-cta);display:flex;align-items:center;justify-content:center;color:#fff}@media(prefers-reduced-motion:no-preference){.ch-ai-mark.is-busy{animation:chBreathe 1.6s ease-in-out infinite}}.ch-ai-body{flex:1;min-width:0}.ch-ai-text{font-size:12.5px;line-height:1.55;color:var(--fg-2)}.ch-text{word-break:break-word;text-wrap:pretty}.ch-text p{margin:0 0 8px}.ch-text>:last-child{margin-bottom:0}.ch-text ul,.ch-text ol{margin:2px 0 8px;padding-left:18px}.ch-text li{margin:3px 0;padding-left:2px}.ch-text li::marker{color:var(--fg-5)}.ch-text b{color:var(--fg-1);font-weight:600}.ch-text.has-caret>:last-child:after{content:"";display:inline-block;width:7px;height:13px;margin-left:2px;vertical-align:-2px;border-radius:2px;background:var(--amethyst-600)}@media(prefers-reduced-motion:no-preference){.ch-text.has-caret>:last-child:after{animation:chCaret .9s steps(2,start) infinite}@keyframes chCaret{to{visibility:hidden}}}.ch-status{margin-top:2px;font-size:11.5px;font-weight:500;color:var(--fg-4);position:relative;width:fit-content;overflow:hidden}.ch-status:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(9,11,19,.75) 50%,transparent 80%);animation:shimmer 1.6s linear infinite}.ch-ai-text+.ch-status{margin-top:8px}.ch-chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}.ch-chips.is-start{justify-content:center;margin-top:8px}.ch-chip{display:inline-flex;align-items:center;gap:5px;max-width:100%;padding:5px 10px;border-radius:999px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:11px;font-weight:600;line-height:1.3;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.ch-chip:hover{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff;transform:translateY(-1px)}.ch-plan{margin-top:10px;border-radius:16px;overflow:hidden;background:#ffffff08;border:1px solid var(--hairline-soft);box-shadow:inset 0 1px #ffffff0d}.ch-ai-text+.ch-plan{margin-top:12px}.ch-plan.is-proposed,.ch-plan.is-running{border-color:#c2a4ec38;background:#9968df0e}.ch-plan.is-cancelled{opacity:.62}.ch-plan-head{display:flex;align-items:flex-start;gap:9px;padding:11px 12px 0}.ch-plan-mark{width:22px;height:22px;flex:none;border-radius:7px;margin-top:1px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;display:inline-flex;align-items:center;justify-content:center;color:var(--amethyst-700)}.ch-plan-titles{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ch-plan-eyebrow{display:flex;align-items:center;flex-wrap:wrap;gap:3px 5px;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.ch-plan-eyebrow .dot{color:var(--fg-5);letter-spacing:0}.ch-plan-title{font-size:13px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ch-plan-est{flex:none;display:flex;flex-direction:column;align-items:flex-end;gap:4px}.ch-plan-cost{display:inline-flex;align-items:center;gap:4px;font-size:10.5px;font-weight:700;color:var(--fg-2);background:#ffffff0f;border-radius:999px;padding:3px 9px;font-variant-numeric:tabular-nums;white-space:nowrap}.ch-plan-cost.is-estimate{color:var(--amethyst-700);background:var(--cv-accent-tint)}.ch-plan-time{display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:600;color:var(--fg-4);font-variant-numeric:tabular-nums;white-space:nowrap;padding-right:2px}.ch-plan-summary{margin:8px 12px 6px;font-size:12px;line-height:1.5;color:var(--fg-2);text-wrap:pretty}.ch-sessions{display:flex;flex-direction:column;gap:2px;padding:2px 6px 4px}.ch-session{display:flex;align-items:flex-start;gap:9px;padding:8px;border-radius:11px;border:1px solid transparent}.ch-session+.ch-session{border-top-color:var(--hairline-soft);border-radius:0 0 11px 11px}.ch-session-icon{width:24px;height:24px;flex:none;border-radius:8px;margin-top:1px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff0f;color:var(--amethyst-700)}.ch-session-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ch-session-name{display:flex;align-items:center;gap:6px;min-width:0}.ch-session-name .n{min-width:0;font-size:12.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-tag{flex:none;font-size:8.5px;font-weight:700;text-transform:uppercase;letter-spacing:.12em;color:var(--fg-4);background:#ffffff12;border-radius:999px;padding:2px 6px}.ch-tag.is-new{color:var(--amethyst-700);background:var(--cv-accent-tint)}.ch-session-meta{display:flex;align-items:center;flex-wrap:wrap;gap:2px 5px;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.ch-session-meta .sep{color:var(--fg-5)}.ch-session-meta .tk{display:inline-flex;align-items:center;gap:3px;color:var(--fg-3);font-weight:600}.ch-session-settings{font-size:10.5px;color:var(--fg-3)}.ch-session-why{display:flex;align-items:flex-start;gap:5px;font-size:10.5px;line-height:1.4;color:var(--fg-4)}.ch-session-why .licon{flex:none;margin-top:1px;color:var(--fg-5)}.ch-session-prompt{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;margin-top:3px;padding:7px 9px;border-radius:9px;text-align:left;cursor:pointer;border:1px solid var(--hairline-soft);background:#0000002e;font-family:var(--font-sans);font-size:11px;line-height:1.45;color:var(--fg-2);font-style:italic;transition:border-color var(--dur-fast),background var(--dur-fast)}.ch-session-prompt:hover{border-color:var(--hairline);background:#00000042}.ch-session-prompt.is-open{display:block;-webkit-line-clamp:unset}.ch-session-inputs{display:flex;flex-wrap:wrap;gap:4px;margin-top:4px}.ch-session-inputs .th{width:30px;height:30px;border-radius:6px;background-size:cover;background-position:center;background-color:#ffffff0d;border:1px solid rgba(255,255,255,.08)}.ch-actions{display:flex;flex-direction:column;gap:1px;margin:4px 12px 2px;padding:8px 10px;border-radius:11px;background:#00000029;border:1px solid var(--hairline-soft)}.ch-action{display:flex;align-items:flex-start;gap:8px;padding:3px 0;font-size:11.5px;line-height:1.4;color:var(--fg-3)}@media(prefers-reduced-motion:no-preference){.ch-action{animation:chMsgIn .35s var(--ease-out-soft) both}}.ch-action-icon{flex:none;display:inline-flex;margin-top:1px;color:var(--fg-5)}.ch-action.is-done .ch-action-icon{color:var(--success)}.ch-action.is-done{color:var(--fg-2)}.ch-action.is-running .ch-action-icon,.ch-action.is-running{color:var(--amethyst-700)}.ch-action.is-running{font-weight:600}.ch-action.is-failed .ch-action-icon,.ch-action.is-failed{color:#ff8aa0}.ch-action-main{min-width:0;display:flex;flex-direction:column;gap:1px}.ch-action-detail{font-size:10.5px;font-weight:500;color:var(--fg-4)}.ch-action.is-failed .ch-action-detail{color:#ffb3c1}.ch-plan-foot{display:flex;align-items:center;gap:8px;margin-top:8px;padding:10px 12px;border-top:1px solid var(--hairline-soft);font-size:10.5px;color:var(--fg-4)}.ch-plan-foot.is-running{color:var(--amethyst-700);font-weight:600}.ch-plan-foot.is-done{color:var(--success);font-weight:600}.ch-plan-foot.is-failed,.ch-plan-foot.is-stopped{color:#ff8aa0;font-weight:600}.ch-plan-breakdown{flex:1;min-width:0;line-height:1.4}.ch-plan-run{flex:none;display:inline-flex;align-items:center;gap:6px;height:30px;padding:0 13px;border:0;border-radius:9px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;box-shadow:0 10px 26px #745aff42,inset 0 1px #ffffff2e;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.ch-plan-run .sep{opacity:.6;margin:0 1px}.ch-plan-run:hover:not(:disabled){transform:translateY(-1px);filter:brightness(1.08)}.ch-plan-run:disabled{opacity:.7;cursor:default}.ch-plan-cancel,.ch-plan-show{flex:none;display:inline-flex;align-items:center;gap:5px;height:28px;padding:0 11px;border-radius:9px;background:#ffffff0e;border:1px solid var(--hairline);color:var(--fg-2);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),color var(--dur-fast)}.ch-plan-cancel:hover:not(:disabled),.ch-plan-show:hover{background:#ffffff1a;color:var(--fg-1)}.ch-plan-cancel:disabled{opacity:.5;cursor:default}.ch-plan.is-skeleton{padding:12px;display:flex;flex-direction:column;gap:8px}.ch-plan .sk{height:11px;border-radius:5px;background:#ffffff12;position:relative;overflow:hidden}.ch-plan .sk-a{width:76%}.ch-plan .sk-b{width:92%}.ch-plan .sk-c{width:58%}.ch-plan .sk:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.ch-composer{flex:none;padding:10px 12px 12px;border-top:1px solid var(--hairline-soft)}.ch-comp-box{border-radius:var(--radius-md);background:#1e1e23bf;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 20px 40px #0206173d;padding:10px 10px 8px 12px;transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.ch-comp-box:focus-within{border-color:var(--cv-accent-soft);box-shadow:var(--inset-highlight),0 0 0 3px var(--cv-accent-tint)}.ch-comp-box.is-off{opacity:.6}.ch-comp-input{display:block;width:100%;min-height:44px;max-height:160px;resize:none;border:0;outline:none;background:transparent;padding:0;font-family:var(--font-sans);font-size:13px;line-height:1.5;color:var(--fg-1);user-select:text;-webkit-user-select:text}.ch-comp-input::placeholder{color:var(--fg-4)}.ch-comp-foot{display:flex;align-items:center;gap:10px;margin-top:6px}.ch-comp-hint{flex:1;min-width:0;font-size:10px;color:var(--fg-5);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model{position:relative;flex:none}.ch-model-btn{display:inline-flex;align-items:center;gap:5px;max-width:170px;height:24px;padding:0 8px 0 9px;border:1px solid var(--cv-accent-soft);border-radius:999px;background:var(--cv-accent-tint);color:#fff;font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ch-model-btn .t{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model-btn.is-sim{border-color:var(--hairline-soft);background:#ffffff0d;color:var(--fg-3)}.ch-model-btn:hover{border-color:var(--cv-accent-soft);color:#fff}.ch-model-menu{position:absolute;left:-4px;bottom:calc(100% + 10px);z-index:6;width:250px;display:flex;flex-direction:column;gap:2px;padding:6px;border-radius:14px;background:#121217fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 70px #02040cb3;animation:histIn .18s var(--ease-out-soft) both}.ch-model-row{display:flex;align-items:center;gap:9px;width:100%;padding:7px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);text-align:left;cursor:pointer;transition:background var(--dur-fast)}.ch-model-row:hover{background:#ffffff0f}.ch-model-row.on{background:var(--cv-accent-tint)}.ch-model-row>.licon{flex:none;color:var(--amethyst-700)}.ch-model-row .m{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.ch-model-row .n{font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model-row .f{font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model-note{padding:6px 8px 4px;font-size:10.5px;line-height:1.45;color:var(--fg-4);text-wrap:pretty}.ch-send{flex:none;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:var(--grad-cta);color:#fff;cursor:pointer;box-shadow:0 8px 22px #745aff4d,inset 0 1px #fff3;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.ch-send:hover:not(:disabled){transform:translateY(-1px);filter:brightness(1.08)}.ch-send:disabled{cursor:default;background:#ffffff14;color:var(--fg-5);box-shadow:none}.ch-picks{display:flex;flex-direction:column;gap:6px;margin-top:10px}.ch-ai-text+.ch-picks{margin-top:12px}.ch-pick{display:flex;align-items:flex-start;gap:10px;padding:9px 10px;border-radius:14px;background:#ffffff08;border:1px solid var(--hairline-soft);box-shadow:inset 0 1px #ffffff0d}.ch-pick.is-off{opacity:.55}.ch-pick-pic{flex:none;width:34px;height:34px;border-radius:10px;margin-top:1px;background:#ffffff0f center / cover no-repeat;box-shadow:inset 0 0 0 1px #ffffff14;display:inline-flex;align-items:center;justify-content:center;color:var(--amethyst-700)}.ch-pick-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.ch-pick-top{display:flex;align-items:baseline;gap:6px;min-width:0}.ch-pick-name{min-width:0;font-size:12.5px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-pick-price{flex:none;margin-left:auto;font-size:10px;font-weight:700;color:var(--fg-2);background:#ffffff0f;border-radius:999px;padding:2px 7px;font-variant-numeric:tabular-nums;white-space:nowrap}.ch-pick-why{font-size:11.5px;line-height:1.45;color:var(--fg-3);text-wrap:pretty}.ch-pick-kit{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-5);margin-top:1px}.ch-pick-try{flex:none;align-self:center;display:inline-flex;align-items:center;gap:4px;height:26px;padding:0 10px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.ch-pick-try:hover:not(:disabled){background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff;transform:translateY(-1px)}.ch-pick-try:disabled{opacity:.5;cursor:default}.ch-ideas{display:flex;flex-direction:column;gap:6px;margin-top:10px}.ch-ai-text+.ch-ideas{margin-top:12px}.ch-idea{display:flex;align-items:flex-start;gap:10px;width:100%;padding:10px 10px 10px 11px;border-radius:14px;background:#ffffff08;border:1px solid var(--hairline-soft);color:var(--fg-2);box-shadow:inset 0 1px #ffffff0d;font-family:var(--font-sans);text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.ch-idea:hover:not(:disabled){background:#9968df14;border-color:#c2a4ec47;transform:translateY(-1px)}.ch-idea:disabled{cursor:default}.ch-idea-n{flex:none;width:20px;height:20px;margin-top:1px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--amethyst-700);font-size:10.5px;font-weight:700;font-variant-numeric:tabular-nums}.ch-idea-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ch-idea-title{font-size:12.5px;font-weight:600;color:var(--fg-1)}.ch-idea-pitch{font-size:11.5px;line-height:1.45;color:var(--fg-3);text-wrap:pretty}.ch-idea-tool{display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:600;color:var(--amethyst-700);margin-top:1px}.ch-idea-go{flex:none;align-self:center;color:var(--fg-5)}.ch-idea:hover:not(:disabled) .ch-idea-go{color:var(--fg-2)}.ch-msg-cost{display:flex;align-items:center;gap:4px;margin-top:8px;font-size:10px;font-weight:500;color:var(--fg-4);font-variant-numeric:tabular-nums}.ch-msg-cost .dot{color:var(--fg-5);opacity:.7}.ch-msg-cost .licon{opacity:.8}', sSe = `
/* while a board is open the host's emulator banner would sit on the rail */
body.bd-open .firebase-emulator-warning { display: none !important; }
`;
let wh = 0, oo = null;
function QI() {
  return wh++, oo || (oo = document.createElement("style"), oo.setAttribute("data-rd-board", ""), oo.textContent = [W8e, q8e, K8e, Y8e, X8e, J8e, Z8e, Q8e, eSe, tSe, nSe, iSe, kO, sSe].join(`
`), document.head.appendChild(oo)), () => {
    wh = Math.max(0, wh - 1), !wh && oo && (oo.remove(), oo = null);
  };
}
const oSe = ".bd-root.bd-tip{position:fixed;left:0;top:0;z-index:2147483600;pointer-events:none;display:flex;flex-direction:column;gap:3px;width:max-content;max-width:280px;padding:6px 10px 7px;border-radius:9px;background:#131520fa;border:1px solid rgba(255,255,255,.11);box-shadow:inset 0 1px #ffffff0b,0 12px 32px #02040c8c,0 2px 8px #02040c66;color:var(--fg-1);font-size:12px;font-weight:500;line-height:1.35;letter-spacing:-.005em;text-align:left;white-space:normal;overflow-wrap:anywhere;opacity:0;transform:translateY(3px);transition:opacity .12s ease,transform .16s var(--ease-out-soft)}.bd-root.bd-tip.is-below{transform:translateY(-3px)}.bd-root.bd-tip.on{opacity:1;transform:none}.bd-root.bd-tip.is-now{transition:none}.bd-tip .ln{display:flex;align-items:center;gap:10px}.bd-tip .tx{flex:1 1 auto;min-width:0}.bd-tip .keys{flex:none;display:inline-flex;gap:3px;margin-right:-3px}.bd-tip kbd{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;border:1px solid rgba(255,255,255,.1);background:#ffffff12;box-shadow:inset 0 -1px #0000004d;color:var(--fg-2);font-family:var(--font-sans);font-size:10.5px;font-weight:600;line-height:1}.bd-tip .hint{font-size:11.5px;font-weight:400;line-height:1.4;color:var(--fg-3)}@media(prefers-reduced-motion:reduce){.bd-root.bd-tip,.bd-root.bd-tip.is-below{transition:none;transform:none}}", rSe = 260, aSe = 400, wb = 8, gd = 8, pf = "bd-tip", kb = "(?:Esc|Enter|Del|Space|Tab|↵|⌫|[←→↑↓\\[\\]/\\\\,.=+\\-?])", lSe = new RegExp("^(?:[A-Z]|" + kb + "|[⌘⇧⌥⌃]+(?:[A-Z0-9]|" + kb + ")|(?:(?:Ctrl|Alt|Shift|Cmd)\\+)+(?:[A-Z0-9]|" + kb + "))$");
function eA(n) {
  const [e, ...t] = n.split(`
`), i = e.trim(), s = /^(.*\S)\s+\(([^()]+)\)$/.exec(i), o = s ? s[2].trim() : "", r = s && lSe.test(o) ? dSe(o) : [];
  return { label: r.length ? s[1] : i, keys: r, hint: t.map((a) => a.trim()).filter(Boolean).join(" ") };
}
function dSe(n) {
  const e = /^((?:(?:Ctrl|Alt|Shift|Cmd)\+)+)(.+)$/.exec(n);
  if (e) return [...e[1].split("+").filter(Boolean), e[2]];
  const t = /^([⌘⇧⌥⌃]*)(.+)$/u.exec(n);
  return t ? [...Array.from(t[1]), t[2]] : [n];
}
let kh = 0, fr = null, Ln = null, bn = null, Gy = "pointer", em = !1, al = !1, jy = -1 / 0, ff = 0, k0 = 0, lc = null;
const Wo = /* @__PURE__ */ new WeakMap(), _0 = /* @__PURE__ */ new WeakSet();
function tA(n) {
  const e = n instanceof Element ? n : null, t = e ? e.closest("[title]") : null;
  return !t || !t.closest(".bd-root") || t === Ln || !Wo.has(t) && !(t.getAttribute("title") || "").trim() ? null : t;
}
function cSe(n) {
  const e = Wo.get(n);
  if (e != null) return e;
  const t = n.getAttribute("title");
  return !t || !t.trim() ? null : (Wo.set(n, t), n.setAttribute("title", ""), !n.hasAttribute("aria-label") && !n.hasAttribute("aria-labelledby") && !(n.textContent || "").trim() && (n.setAttribute("aria-label", eA(t).label), _0.add(n)), t);
}
function uSe(n) {
  const e = Wo.get(n);
  Wo.delete(n), e != null && n.getAttribute("title") === "" && n.setAttribute("title", e), _0.has(n) && (n.removeAttribute("aria-label"), _0.delete(n));
  const t = (n.getAttribute("aria-describedby") || "").split(/\s+/).filter((i) => i && i !== pf);
  t.length ? n.setAttribute("aria-describedby", t.join(" ")) : n.removeAttribute("aria-describedby");
}
function hSe() {
  if (!bn) return;
  const n = bn.getAttribute("title");
  if (n !== "") {
    if (n == null) {
      Wo.delete(bn), Hy();
      return;
    }
    Wo.set(bn, n), bn.setAttribute("title", ""), al && S0(!0);
  }
}
function nA(n, e) {
  cSe(n) != null && (bn = n, Gy = e, em = !1, lc = new MutationObserver(hSe), lc.observe(n, { attributes: !0, attributeFilter: ["title"] }), clearTimeout(ff), performance.now() - jy < aSe ? S0(!0) : ff = window.setTimeout(() => S0(!1), rSe));
}
function Bl() {
  clearTimeout(ff), lc && lc.disconnect(), lc = null;
  const n = bn;
  bn = null, em = !1, Hy(), n && uSe(n);
}
function pSe() {
  return Ln && Ln.isConnected || (Ln = document.createElement("div"), Ln.className = "bd-root bd-tip", Ln.id = pf, Ln.setAttribute("role", "tooltip"), Ln.setAttribute("data-testid", "board-tip"), document.body.appendChild(Ln)), Ln;
}
function fSe(n, e) {
  n.replaceChildren();
  const t = document.createElement("span");
  t.className = "ln";
  const i = document.createElement("span");
  if (i.className = "tx", i.textContent = e.label, t.appendChild(i), e.keys.length) {
    const s = document.createElement("span");
    s.className = "keys";
    for (const o of e.keys) {
      const r = document.createElement("kbd");
      r.textContent = o, s.appendChild(r);
    }
    t.appendChild(s);
  }
  if (n.appendChild(t), e.hint) {
    const s = document.createElement("span");
    s.className = "hint", s.textContent = e.hint, n.appendChild(s);
  }
}
function mSe(n, e) {
  const t = e.getBoundingClientRect(), i = n.offsetWidth, s = n.offsetHeight;
  let o = t.top - wb - s, r = !1;
  o < gd && (o = t.bottom + wb, r = !0, o + s > window.innerHeight - gd && (o = Math.max(gd, t.top - wb - s), r = !1));
  const a = Math.max(gd, Math.min(window.innerWidth - gd - i, t.left + t.width / 2 - i / 2));
  n.classList.toggle("is-below", r), n.style.left = Math.round(a) + "px", n.style.top = Math.round(o) + "px";
}
function S0(n) {
  const e = bn, t = e ? Wo.get(e) : null;
  if (!e || !t || em || !e.isConnected || e.querySelector(".tip")) return;
  const i = pSe();
  fSe(i, eA(t)), i.classList.toggle("is-now", n || al), al || i.classList.remove("on"), mSe(i, e), i.offsetWidth, i.classList.add("on"), al = !0, jy = performance.now();
  const s = (e.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
  s.includes(pf) || e.setAttribute("aria-describedby", [...s, pf].join(" ")), clearInterval(k0), k0 = window.setInterval(() => {
    (!bn || !bn.isConnected) && Bl();
  }, 250);
}
function Hy() {
  clearTimeout(ff), clearInterval(k0), al && (jy = performance.now()), al = !1, Ln && Ln.classList.remove("on");
}
function u4(n) {
  if (n.pointerType === "touch") return;
  const e = tA(n.target);
  e !== bn && (bn && Bl(), e && !n.buttons && nA(e, "pointer"));
}
function h4(n) {
  bn && Gy === "pointer" && !n.relatedTarget && Bl();
}
function Qi() {
  bn && (em = !0, Hy());
}
function p4(n) {
  n.key === "Escape" && Qi();
}
function f4(n) {
  const e = n.target;
  bn && (e === document || e instanceof Node && e.contains(bn)) && Qi();
}
function m4(n) {
  const e = n.target;
  if (!(e instanceof HTMLElement) || !e.matches(":focus-visible")) return;
  const t = tA(e);
  !t || t === bn || (bn && Bl(), nA(t, "focus"));
}
function g4() {
  bn && Gy === "focus" && Bl();
}
function iA() {
  if (typeof document == "undefined") return () => {
  };
  kh++, kh === 1 && (fr = document.createElement("style"), fr.setAttribute("data-rd-board-tips", ""), fr.textContent = oSe, document.head.appendChild(fr), document.addEventListener("pointerover", u4, !0), document.addEventListener("pointerout", h4, !0), document.addEventListener("pointerdown", Qi, !0), document.addEventListener("keydown", p4, !0), document.addEventListener("focusin", m4, !0), document.addEventListener("focusout", g4, !0), window.addEventListener("scroll", f4, !0), window.addEventListener("wheel", Qi, { capture: !0, passive: !0 }), window.addEventListener("blur", Qi), window.addEventListener("resize", Qi));
  let n = !1;
  return () => {
    n || (n = !0, kh--, !(kh > 0) && (Bl(), document.removeEventListener("pointerover", u4, !0), document.removeEventListener("pointerout", h4, !0), document.removeEventListener("pointerdown", Qi, !0), document.removeEventListener("keydown", p4, !0), document.removeEventListener("focusin", m4, !0), document.removeEventListener("focusout", g4, !0), window.removeEventListener("scroll", f4, !0), window.removeEventListener("wheel", Qi, !0), window.removeEventListener("blur", Qi), window.removeEventListener("resize", Qi), Ln && Ln.remove(), Ln = null, fr && fr.remove(), fr = null));
  };
}
const gSe = [
  { value: "1:1", label: "1:1", meta: "1024×1024", icon: "Square" },
  { value: "3:4", label: "3:4", meta: "896×1152", icon: "RectangleVertical" },
  { value: "4:3", label: "4:3", meta: "1152×896", icon: "RectangleHorizontal" },
  { value: "16:9", label: "16:9", meta: "1344×768", icon: "RectangleHorizontal" },
  { value: "9:16", label: "9:16", meta: "768×1344", icon: "RectangleVertical" }
], bSe = ["2s", "4s", "6s", "10s"].map((n) => ({ value: n, label: n })), b4 = {
  "Nano Banana Pro": 14,
  "Nano Banana 2": 14,
  "ChatGPT Image 2": 16,
  "GPT Image 1.5": 16,
  "Seedream 5 Lite": 10,
  "Flux 2 Pro": 0
};
function v4(n, e = "") {
  const t = { key: "prompt", kind: "prompt", label: "Prompt", placement: "prompt", required: !0, defaultValue: "" }, i = { key: "aspect", kind: "size", label: "Output size", placement: "chip", defaultValue: "3:4", options: gSe }, s = { key: "seed", kind: "seed", label: "Seed", placement: "advanced", defaultValue: null, tooltip: "The same seed with the same prompt and settings repeats a result." };
  if (n === "video")
    return [
      t,
      { key: "startFrame", kind: "image", label: "Start frame", placement: "reference" },
      { ...i, defaultValue: "16:9" },
      { key: "length", kind: "select", label: "Length", placement: "chip", icon: "Clock", defaultValue: "4s", options: bSe },
      s
    ];
  if (n === "threed")
    return [
      { ...t, required: !1, placeholder: "Optional: describe the object" },
      { key: "source", kind: "image", label: "Source image", placement: "reference", required: !0 },
      { key: "texture", kind: "boolean", label: "Bake textures", placement: "advanced", defaultValue: !0 },
      s
    ];
  if (n === "upscale" && /video/i.test(e))
    return [
      { key: "video", kind: "video", label: "Video to upscale", placement: "reference", required: !0 },
      { key: "factor", kind: "select", label: "Scale", placement: "chip", icon: "Maximize2", defaultValue: "2x", options: [{ value: "2x", label: "2×" }, { value: "4x", label: "4×" }] }
    ];
  if (n === "upscale")
    return [
      { key: "image", kind: "image", label: "Image to upscale", placement: "reference", required: !0 },
      {
        key: "factor",
        kind: "select",
        label: "Scale",
        placement: "chip",
        icon: "Maximize2",
        defaultValue: "2x",
        options: [{ value: "2x", label: "2×" }, { value: "4x", label: "4×" }]
      },
      { key: "creativity", kind: "slider", label: "Creativity", placement: "advanced", min: 0, max: 10, step: 1, defaultValue: 3, tooltip: "How much new detail the upscaler may invent." }
    ];
  const o = e in b4 ? b4[e] : 4;
  return [
    t,
    ...o ? [{ key: "images", kind: "images", label: "Images", placement: "reference", maxImages: o }] : [],
    i,
    { key: "steps", kind: "slider", label: "Steps (Quality)", placement: "advanced", min: 1, max: 50, step: 1, defaultValue: 4, tooltip: "More steps take longer and add detail." },
    s
  ];
}
function vSe() {
  return {
    id: "demo:threed:Hunyuan 3D Pro",
    name: "Hunyuan 3D Pro",
    desc: "One object from up to six views",
    kitId: "threed",
    tokensLabel: "813",
    tokensPerResult: 813,
    time: "2m",
    fields: [
      { key: "prompt", kind: "prompt", label: "Prompt", placement: "prompt", required: !1, defaultValue: "", placeholder: "Optional: describe the object" },
      ...["Front", "Back", "Left", "Right", "Top", "Bottom"].map((e, t) => ({ key: "view" + e, kind: "image", label: e + " view", placement: "reference", required: t === 0 })),
      { key: "seed", kind: "seed", label: "Seed", placement: "advanced", defaultValue: null }
    ],
    numResults: { min: 1, max: 1, def: 1 }
  };
}
const ySe = [
  { kitId: "image", name: "Qwen Image", tokens: 43, time: "10s" },
  { kitId: "image", name: "Recraft v4 Pro", tokens: 698, time: "25s" },
  { kitId: "video", name: "Veo 3.1 Fast", tokens: 233, time: "1m" },
  { kitId: "video", name: "Luma Ray 2", tokens: 1164, time: "2m" }
];
function $i(n) {
  const { display: e, ...t } = n;
  return { ...t, raw: { boardKey: n.key, display: e || {} } };
}
function bd(n, e, t, i, s, o, r = 1) {
  return {
    id: "demo:tools:" + n,
    name: e,
    kitId: "tools",
    tokensLabel: String(i),
    tokensPerResult: i,
    time: s,
    fields: o,
    numResults: { min: 1, max: r, def: 1 },
    boardTool: t
  };
}
function xSe() {
  const n = (t = "Image") => $i({ key: "image", kind: "image", label: t, placement: "reference", required: !0 }), e = (t, i) => $i({ key: t, kind: "slider", label: i, placement: "advanced", min: 0, max: 5e3, step: 1 });
  return [
    bd("removebg", "Remove Background", "removebg", 9, "6s", [n("Image to cut out")]),
    bd("erase", "Person and Object Remover", "erase", 93, "11s", [$i({ key: "image", kind: "image", label: "Image to remove items from", placement: "reference", required: !0, display: { hasInpainting: !0, inpaintingRequired: !0 } })]),
    bd("expand", "Expand", "expand", 93, "15s", [
      n("Image to expand"),
      $i({ key: "prompt", kind: "prompt", label: "What to add", placement: "prompt", required: !1, defaultValue: "" }),
      e("canvasWidth", "Canvas width"),
      e("canvasHeight", "Canvas height"),
      e("imageWidth", "Image width"),
      e("imageHeight", "Image height"),
      e("imageX", "Image left"),
      e("imageY", "Image top")
    ]),
    bd("camera", "Change Camera", "camera", 76, "18s", [
      n("Image to see from another angle"),
      $i({ key: "rotate", kind: "slider", label: "Rotate", placement: "advanced", min: 0, max: 360, step: 1, defaultValue: 45 }),
      $i({ key: "vertical", kind: "slider", label: "Vertical", placement: "advanced", min: -30, max: 90, step: 1, defaultValue: 0 }),
      $i({ key: "zoom", kind: "slider", label: "Zoom", placement: "advanced", min: 0, max: 10, step: 0.5, defaultValue: 5 }),
      $i({ key: "keep", kind: "text", label: "Keep", placement: "advanced", defaultValue: "" }),
      $i({ key: "avoid", kind: "negPrompt", label: "Avoid", placement: "advanced", defaultValue: "" }),
      $i({ key: "loraScale", kind: "slider", label: "LoRA scale", placement: "advanced", min: 0, max: 4, step: 0.1, defaultValue: 0.9 }),
      $i({ key: "seed", kind: "seed", label: "Seed", placement: "advanced", defaultValue: null })
    ], 4),
    bd("select", "Find Objects", "select", 11, "4s", [n("Image to find the objects in")])
  ];
}
function wSe() {
  const n = (e) => e.map((t) => ({ value: t, label: t }));
  return {
    id: "demo:upscale:Magnific Upscaler",
    name: "Magnific Upscaler",
    kitId: "upscale",
    tokensLabel: "282+",
    time: "45s",
    numResults: { min: 1, max: 1, def: 1 },
    fields: [
      { key: "image", kind: "image", label: "Image", placement: "reference", required: !0 },
      { key: "scale", kind: "select", label: "Scale Factor", placement: "chip", icon: "Maximize2", defaultValue: 2, options: [2, 4, 8, 16].map((e) => ({ value: e, label: String(e) })) },
      { key: "optimized", kind: "select", label: "Optimized For", placement: "chip", defaultValue: "standard", options: n(["standard", "soft_portraits", "hard_portraits", "art_n_illustration", "videogame_assets", "nature_n_landscapes", "films_n_photography", "3d_renders", "science_fiction_n_horror"]) },
      { key: "prompt", kind: "text", label: "Prompt (Optional)", placement: "advanced", defaultValue: "" },
      { key: "creativity", kind: "slider", label: "Creativity", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "hdr", kind: "slider", label: "HDR", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "resemblance", kind: "slider", label: "Resemblance", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "fractality", kind: "slider", label: "Fractality", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "engine", kind: "select", label: "Engine", placement: "advanced", defaultValue: "automatic", options: n(["automatic", "magnific_illusio", "magnific_sharpy", "magnific_sparkle"]) }
    ]
  };
}
function sA() {
  const n = Hr.kits.map((t) => ({
    id: t.id,
    name: t.name,
    icon: t.icon,
    desc: t.desc,
    models: t.models.map((i) => ({
      id: "demo:" + t.id + ":" + i.name,
      name: i.name,
      desc: i.desc,
      kitId: t.id,
      tokensLabel: String(i.tokens),
      tokensPerResult: /^\d+$/.test(String(i.tokens)) ? Number(i.tokens) : void 0,
      time: i.time,
      fields: v4(t.id, i.name),
      numResults: { min: 1, max: 8, def: 1 }
    })).concat(t.id === "threed" ? [vSe()] : t.id === "upscale" ? [wSe()] : [])
  })), e = ySe.map((t) => ({
    id: "demo:" + t.kitId + ":" + t.name,
    name: t.name,
    kitId: t.kitId,
    tokensLabel: String(t.tokens),
    tokensPerResult: t.tokens,
    time: t.time,
    fields: v4(t.kitId, t.name),
    numResults: { min: 1, max: 4, def: 1 }
  }));
  return Rp("demo", n, e, xSe());
}
var kSe = Object.defineProperty, _Se = (n, e, t) => e in n ? kSe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Fr = (n, e, t) => _Se(n, typeof e != "symbol" ? e + "" : e, t);
class Vy {
  constructor(e = null, t = null) {
    if (Fr(this, "persistKey", e), Fr(this, "user", t), Fr(this, "boards", /* @__PURE__ */ new Map()), e)
      try {
        const i = localStorage.getItem(e);
        if (i) {
          const s = JSON.parse(i);
          for (const [o, r] of Object.entries(s)) this.boards.set(o, r);
        }
      } catch {
      }
  }
  save() {
    if (this.persistKey)
      try {
        const e = {};
        for (const [t, i] of this.boards)
          t.startsWith("stress-") || (e[t] = i);
        localStorage.setItem(this.persistKey, JSON.stringify(e));
      } catch {
      }
  }
  async list() {
    return Array.from(this.boards.values()).map((e) => ({ ...e.meta })).sort((e, t) => (t.updatedAt || 0) - (e.updatedAt || 0));
  }
  /** `id`: the harness gives a board the boards list made the list's own id */
  async create(e, t = "blank", i = kt()) {
    const s = Date.now(), o = t === "demo" ? Rl() : null, r = {
      meta: { id: i, title: o ? o.title : e, createdAt: s, updatedAt: s },
      elements: {},
      results: {}
    };
    if (o) {
      for (const a of o.elements) r.elements[a.id] = a;
      for (const a of o.results) r.results[a.id] = a;
    }
    return this.boards.set(i, r), this.save(), { ...r.meta };
  }
  /** Benchmark boards: regenerated every time, never persisted. */
  ensureStress(e, t) {
    const i = "stress-" + e + (t ? "-syn" : "");
    return this.boards.has(i) || this.addSeeded(i, OH(e, t)), i;
  }
  /** The demo board tiled to at least `minImages` images (the stress page). */
  ensureTiledDemo(e) {
    const t = "stress-demo-" + e;
    return this.boards.has(t) || this.addSeeded(t, DH(e)), t;
  }
  /** A board made from a seed under the id given (the stress page's, the tour's practice board). */
  addSeeded(e, t) {
    const i = { meta: { id: e, title: t.title, createdAt: Date.now(), updatedAt: Date.now() }, elements: {}, results: {} };
    for (const s of t.elements) i.elements[s.id] = s;
    for (const s of t.results) i.results[s.id] = s;
    this.boards.set(e, i);
  }
  async rename(e, t) {
    const i = this.boards.get(e);
    i && (i.meta.title = t, i.meta.updatedAt = Date.now(), this.save());
  }
  async remove(e) {
    this.boards.delete(e), this.save();
  }
  open(e) {
    return new SSe(this, e);
  }
  board(e) {
    return this.boards.get(e);
  }
}
class SSe {
  constructor(e, t) {
    Fr(this, "dir", e), Fr(this, "id", t), Fr(this, "status", /* @__PURE__ */ K("saved")), Fr(this, "saveTimer", 0);
  }
  async load() {
    const e = this.dir.board(this.id);
    if (!e) throw new Error("Board not found");
    return {
      meta: JSON.parse(JSON.stringify(e.meta)),
      elements: Object.values(e.elements).map((t) => JSON.parse(JSON.stringify(t))),
      results: Object.values(e.results).map((t) => JSON.parse(JSON.stringify(t)))
    };
  }
  watch(e) {
  }
  commit(e) {
    const t = this.dir.board(this.id);
    if (!t) return;
    const i = Date.now(), s = this.dir.user;
    for (const o of e.added)
      t.elements[o.id] = JSON.parse(JSON.stringify(o)), t.trash && delete t.trash[o.id];
    for (const o of e.updated) t.elements[o.id] = JSON.parse(JSON.stringify(o.el));
    for (const o of e.removed)
      delete t.elements[o.id], t.trash || (t.trash = {}), t.trash[o.id] = {
        el: JSON.parse(JSON.stringify(o)),
        deletedAt: i,
        hardDeleteAt: i + u1,
        deletedBy: s ? s.uid : void 0,
        deletedByEmail: s ? s.email : void 0
      };
    t.meta.updatedAt = i, this.schedule();
  }
  trash() {
    const e = this.dir.board(this.id);
    if (!e || !e.trash) return [];
    const t = Date.now();
    return Object.values(e.trash).filter((i) => i.hardDeleteAt > t).map((i) => JSON.parse(JSON.stringify(i))).sort((i, s) => s.deletedAt - i.deletedAt);
  }
  purge(e) {
    const t = this.dir.board(this.id);
    if (!(!t || !t.trash)) {
      for (const i of e) delete t.trash[i];
      this.schedule();
    }
  }
  commitResults(e) {
    const t = this.dir.board(this.id);
    if (t) {
      for (const i of e) t.results[i.id] = JSON.parse(JSON.stringify(i));
      this.schedule();
    }
  }
  saveMeta(e) {
    const t = this.dir.board(this.id);
    t && (Object.assign(t.meta, JSON.parse(JSON.stringify(e)), { updatedAt: Date.now() }), this.schedule());
  }
  schedule() {
    this.status.value = "saving", clearTimeout(this.saveTimer), this.saveTimer = window.setTimeout(() => {
      this.dir.save(), this.status.value = "saved";
    }, 500);
  }
  async flush() {
    clearTimeout(this.saveTimer), this.dir.save(), this.status.value = "saved";
  }
  dispose() {
    this.flush();
  }
}
var TSe = Object.defineProperty, MSe = (n, e, t) => e in n ? TSe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, _h = (n, e, t) => MSe(n, typeof e != "symbol" ? e + "" : e, t);
const oA = 260, ro = (n, e = oA) => new Promise((t) => setTimeout(() => t(n), e)), CSe = [{ value: "demo-board", text: "Bonneville Tower" }, { value: "demo-old", text: "Depot Yards (v1 board)" }], y4 = [
  [/nano banana/i, "fam-gemini", "Nano Banana"],
  [/gpt|chatgpt/i, "fam-openai", "GPT Image"],
  [/seedream/i, "fam-seedream", "Seedream"],
  [/kling/i, "fam-kling", "Kling"],
  [/flux/i, "fam-flux", "Flux"]
], ISe = [["1:1", 1], ["16:9", 16 / 9], ["2:1", 2], ["3:2", 1.5], ["4:3", 4 / 3], ["21:9", 21 / 9], ["9:16", 9 / 16], ["2:3", 2 / 3], ["3:4", 0.75]];
function ASe(n = 1, e = 1) {
  const t = n / e;
  let i = "OTHER", s = 0.06;
  for (const [o, r] of ISe) {
    const a = Math.abs(Math.log(t / r));
    a < s && (s = a, i = o);
  }
  return i;
}
function PSe(n = 0) {
  const e = new Date(n);
  return e.getFullYear() + "-" + String(e.getMonth() + 1).padStart(2, "0") + "-" + String(e.getDate()).padStart(2, "0");
}
function ESe(n, e) {
  const t = e.trim().toLowerCase();
  if (!t) return !0;
  const i = [n.prompt, n.label, n.model].filter(Boolean).join(" ").toLowerCase();
  return t.split(/\s+/).every((s) => i.includes(s));
}
class RSe {
  constructor() {
    _h(this, "features", { search: !0, filters: !0, star: !0, remove: !0 }), _h(this, "gens"), _h(this, "ups"), _h(this, "facets", /* @__PURE__ */ new Map());
    const e = Rl(), t = /* @__PURE__ */ new Set(), i = [];
    e.results.forEach((a, l) => {
      if (!a.url || t.has(a.url)) return;
      t.add(a.url);
      const d = "demo:" + a.id;
      i.push({
        id: d,
        url: a.url,
        w: a.w,
        h: a.h,
        video: !!a.video,
        videoSrc: a.videoSrc,
        label: a.prompt || a.label || "Generation",
        prompt: a.prompt || "",
        model: a.model,
        createdAt: a.createdAt,
        fav: !!a.fav,
        mine: !0,
        run: { id: "demo-run-" + a.id, uuid: a.id, nodeDefId: a.model || "", nodeId: a.sessionId, runnitId: "demo-board", type: a.video ? "VID" : "IMG" },
        asset: { nodeRunResult: { url: a.url, uuid: a.id } }
      });
      const c = y4.find(([u]) => u.test(a.model || ""));
      this.facets.set(d, {
        aspect: ASe(a.w, a.h),
        // the demo's renders are all small: give them a spread to filter by
        resolution: l % 7 === 0 ? "4K+" : l % 3 === 0 ? "2K" : "1K",
        tool: a.model || "",
        family: c ? c[1] : "",
        media: a.video ? "media-video" : "media-image",
        board: l % 5 === 4 ? "demo-old" : "demo-board",
        day: PSe(a.createdAt)
      });
    }), this.gens = i.sort((a, l) => (l.createdAt || 0) - (a.createdAt || 0));
    const s = [];
    let o = Date.UTC(2026, 8, 14, 18, 0);
    for (const a of e.elements) {
      if (a.type !== "image") continue;
      const l = a;
      l.video || !/site|existing|reference|sketch|plan|photo|material/i.test(l.label || "") || s.some((d) => d.url === l.src) || s.push({
        id: "demo-upload:" + l.id,
        url: l.src,
        w: l.w,
        h: l.h,
        video: !1,
        label: (l.label || "upload") + ".jpg",
        createdAt: o -= 5.5 * 3600 * 1e3,
        mine: !0,
        uploadId: l.id,
        asset: { upload: { id: l.id, name: (l.label || "upload") + ".jpg" } }
      });
    }
    const r = e.elements.find((a) => a.type === "image" && /massing|white card|model/i.test(a.label || ""));
    r && s.unshift({
      id: "demo-upload:massing-obj",
      url: r.src,
      w: r.w,
      h: r.h,
      video: !1,
      label: "bonneville-massing.obj",
      createdAt: Date.UTC(2026, 8, 15, 9, 0),
      mine: !0,
      uploadId: "massing-obj",
      asset: { upload: { id: "massing-obj", name: "bonneville-massing.obj", type: "ASSET_3D" } },
      model3d: { url: "data:text/plain;base64," + btoa(AC()), ext: "obj" }
    }), this.ups = s;
  }
  filtered(e) {
    if (!hI(e)) return this.gens;
    const t = e;
    return this.gens.filter((i) => {
      const s = this.facets.get(i.id);
      return !(!s || t.aspect && s.aspect !== t.aspect || t.resolution && s.resolution !== t.resolution || t.tool && s.tool !== t.tool || t.family && s.family !== t.family || t.media && s.media !== t.media || t.board && s.board !== t.board || t.favorited && !i.fav || t.from && s.day < t.from || t.to && s.day > t.to);
    });
  }
  page(e, t) {
    const i = typeof t == "string" && Number(t) || 0, s = e.slice(i, i + Br).map((r) => ({ ...r })), o = i + Br;
    return { items: s, next: o < e.length ? String(o) : null };
  }
  generations(e = {}) {
    const t = Xf(e.search), i = this.filtered(e.filters);
    return t ? ro({ items: i.filter((s) => ESe(s, t)).slice(0, 200).map((s) => ({ ...s })), next: null }, oA + 240) : ro(this.page(i, e.cursor));
  }
  uploads(e = {}) {
    return ro(this.page(this.ups, e.cursor));
  }
  favorites(e = {}) {
    return ro(this.page(this.gens.filter((t) => t.fav), e.cursor));
  }
  favoriteKeys() {
    return ro(this.gens.filter((e) => e.fav).map((e) => e.id), 120);
  }
  filterOptions() {
    const e = y4.filter(([, i]) => this.gens.some((s) => {
      var o;
      return ((o = this.facets.get(s.id)) == null ? void 0 : o.family) === i;
    })).map(([, i, s]) => ({ value: i, text: s })), t = Array.from(new Set(this.gens.map((i) => i.model).filter((i) => !!i))).sort().map((i) => ({ value: i, text: i }));
    return ro({
      tools: t,
      families: e,
      media: [{ value: "media-image", text: "Image" }, { value: "media-video", text: "Video" }],
      boards: CSe
    }, 180);
  }
  setFavorite(e, t) {
    const i = this.gens.find((s) => s.id === e.id);
    return i && (i.fav = t), ro(void 0, 120);
  }
  remove(e) {
    return this.gens = this.gens.filter((t) => t.id !== e.id), this.ups = this.ups.filter((t) => t.id !== e.id), ro(void 0, 160);
  }
  /** The harness's uploads land in its Library too. */
  addUpload(e) {
    this.ups = [e, ...this.ups.filter((t) => t.id !== e.id)];
  }
}
var zSe = Object.defineProperty, $Se = (n, e, t) => e in n ? zSe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, x4 = (n, e, t) => $Se(n, typeof e != "symbol" ? e + "" : e, t);
const DSe = 200, w4 = 300, OSe = /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
function k4(n) {
  return n.length > w4 ? n.slice(0, w4 - 1) + "…" : n;
}
function _4(n) {
  if (n instanceof Error) {
    const e = n.stack ? n.stack.split(`
`).slice(1, 3).map((t) => t.trim()).join(" ") : "";
    return n.name + ": " + n.message + (e ? " (" + e + ")" : "");
  }
  if (typeof n == "string") return n;
  if (n && typeof n == "object")
    try {
      return JSON.stringify(n);
    } catch {
      return String(n);
    }
  return String(n);
}
class LSe {
  constructor() {
    x4(this, "steps", []), x4(this, "released", []);
  }
  record(e, t, i) {
    const s = { at: Date.now(), kind: e, label: k4(t) };
    i && (s.detail = k4(i)), this.steps.push(s), this.steps.length > DSe && this.steps.shift();
  }
  /** Every step kept, oldest first (a copy). */
  list() {
    return this.steps.slice();
  }
  errors() {
    return this.steps.filter((e) => e.kind === "error" || e.kind === "warn");
  }
  /**
   * Keep the page's console errors and warnings, and anything thrown or
   * rejected that nobody caught. The console still prints them as before.
   */
  captureConsole() {
    for (const i of ["error", "warn"]) {
      const s = console[i], o = this, r = function(...a) {
        try {
          o.record(i, a.map(_4).join(" "));
        } catch {
        }
        return s.apply(this, a);
      };
      console[i] = r, this.released.push(() => {
        console[i] === r && (console[i] = s);
      });
    }
    const e = (i) => {
      OSe.test(i.message || "") || this.record("error", "Uncaught: " + (i.message || "an error"), i.filename ? i.filename + ":" + i.lineno : void 0);
    }, t = (i) => this.record("error", "Unhandled rejection: " + _4(i.reason));
    window.addEventListener("error", e), window.addEventListener("unhandledrejection", t), this.released.push(() => {
      window.removeEventListener("error", e), window.removeEventListener("unhandledrejection", t);
    });
  }
  dispose() {
    for (const e of this.released) e();
    this.released = [], this.steps = [];
  }
}
var BSe = Object.defineProperty, FSe = (n, e, t) => e in n ? BSe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, _b = (n, e, t) => FSe(n, typeof e != "symbol" ? e + "" : e, t);
class NSe {
  constructor() {
    _b(this, "sent", []), _b(this, "fail", null), _b(this, "next", 1);
  }
  async submit(e) {
    return this.fail ? { success: !1, message: this.fail } : (this.sent.push(e), { success: !0, id: "memory-" + this.sent.length, number: this.next++ });
  }
}
const USe = 12e4;
function GSe(n) {
  return !!n && typeof n == "object" && typeof n.success == "boolean";
}
function jSe(n) {
  return {
    async submit(e) {
      const t = await n.functions.httpsCallable("submitBoardFeedback", { timeout: USe })(e);
      return GSe(t.data) ? t.data : { success: !1, message: "Your report couldn't be sent. Try again in a moment." };
    }
  };
}
var HSe = Object.defineProperty, VSe = (n, e, t) => e in n ? HSe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, vd = (n, e, t) => VSe(n, typeof e != "symbol" ? e + "" : e, t);
let Sb = 0;
function Ca() {
  return Sb = Math.max(Date.now(), Sb + 1), Sb;
}
class WSe {
  constructor(e) {
    vd(this, "opts", e), vd(this, "db"), vd(this, "me"), vd(this, "boardId"), vd(this, "unsubs", []), this.db = e.db, this.me = e.me, this.boardId = e.boardId;
  }
  watchBoard(e) {
    const t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
    let s = !0;
    const o = () => {
      const d = this.db.data, c = [], u = /* @__PURE__ */ new Set();
      for (const w of Object.values(d.threads))
        w.boardId === this.boardId && (u.add(w.id), t.get(w.id) !== w && (t.set(w.id, w), c.push(w)));
      const p = Array.from(t.keys()).filter((w) => !u.has(w));
      for (const w of p) t.delete(w);
      const f = [], y = /* @__PURE__ */ new Set();
      for (const w of Object.values(d.comments))
        w.boardId === this.boardId && (y.add(w.id), i.get(w.id) !== w && (i.set(w.id, w), f.push(w)));
      const b = Array.from(i.keys()).filter((w) => !y.has(w));
      for (const w of b) i.delete(w);
      (s || c.length || p.length) && e.threads(c, p), (f.length || b.length) && e.comments(f, b), s = !1;
    };
    let r = !0;
    queueMicrotask(() => {
      r && o();
    });
    const a = this.db.subscribe(o), l = () => {
      r = !1, a();
    };
    return this.unsubs.push(l), l;
  }
  watchFollowed(e) {
    const t = () => {
      const r = Object.values(this.db.data.threads).filter((a) => a.followers.includes(this.me.uid)).sort((a, l) => l.lastAt - a.lastAt).slice(0, 60);
      e(r);
    };
    let i = !0;
    queueMicrotask(() => {
      i && t();
    });
    const s = this.db.subscribe(t), o = () => {
      i = !1, s();
    };
    return this.unsubs.push(o), o;
  }
  async people() {
    const e = this.opts.people || [];
    return e.length ? { people: [this.me, ...e], scope: "team" } : { people: [this.me], scope: "personal" };
  }
  async checkIn() {
    const e = this.db.data.seen[this.boardId] || {};
    return e[this.me.uid] ? e[this.me.uid] : (this.db.write((t) => {
      t.seen[this.boardId] = { ...t.seen[this.boardId] || {}, [this.me.uid]: 1 }, t.titles[this.boardId] = this.opts.board().title;
    }), 1);
  }
  async createThread(e, t) {
    const i = Ca();
    this.db.write((s) => {
      s.threads[e.id] = { ...e, createdAt: i, lastAt: i, readBy: { ...e.readBy, [this.me.uid]: i } }, s.comments[t.id] = { ...t, createdAt: i }, s.titles[this.boardId] = e.boardTitle;
    });
  }
  async reply(e, t, i) {
    const s = Ca();
    this.db.write((o) => {
      o.comments[t.id] = { ...t, createdAt: s };
      const r = o.threads[e.id];
      r && (o.threads[e.id] = {
        ...r,
        lastAt: s,
        lastBy: t.authorId,
        count: r.count + 1,
        preview: op(t),
        followers: yd(r.followers, [t.authorId, ...i]),
        readBy: { ...r.readBy, [t.authorId]: s },
        markedUnread: r.markedUnread.filter((a) => a !== t.authorId),
        resolvedAt: null,
        resolvedBy: null
      });
    });
  }
  async editComment(e, t, i) {
    const s = Ca();
    this.db.write((o) => {
      const r = o.comments[e.id];
      if (!r) return;
      o.comments[e.id] = { ...r, text: e.text, mentions: e.mentions, editedAt: s };
      const a = o.threads[e.threadId];
      a && (o.threads[e.threadId] = { ...a, preview: t || a.preview, followers: yd(a.followers, i) });
    });
  }
  async deleteComment(e, t, i) {
    this.db.write((s) => {
      delete s.comments[e.id];
      const o = s.threads[e.threadId];
      o && (s.threads[e.threadId] = { ...o, count: t, preview: i });
    });
  }
  async deleteThread(e, t) {
    this.db.write((i) => {
      delete i.threads[e];
      for (const s of t) delete i.comments[s];
    });
  }
  async markDeleted(e) {
    this.db.patchThread(e, (t) => t.deletedAt ? t : { ...t, deletedAt: Ca(), deletedBy: this.me.uid });
  }
  async react(e, t, i) {
    const s = this.me.uid;
    this.db.write((o) => {
      const r = o.comments[e.id];
      if (!r) return;
      const a = (r.reactions[s] || []).filter((l) => l !== t);
      i && a.push(t), o.comments[e.id] = { ...r, reactions: { ...r.reactions, [s]: a } };
    });
  }
  async resolve(e, t) {
    this.db.patchThread(e, (i) => ({ ...i, resolvedAt: t ? Ca() : null, resolvedBy: t ? this.me.uid : null }));
  }
  async setColor(e, t) {
    this.db.patchThread(e, (i) => ({ ...i, color: t }));
  }
  async move(e, t) {
    this.db.patchThread(e, (i) => ({ ...i, x: t.x, y: t.y, elementId: t.elementId, ex: t.ex, ey: t.ey, anchorLabel: t.label, anchorThumb: t.thumb }));
  }
  async follow(e, t) {
    const i = this.me.uid;
    this.db.patchThread(e, (s) => ({ ...s, followers: t ? yd(s.followers, [i]) : s.followers.filter((o) => o !== i) }));
  }
  async pin(e, t) {
    const i = this.me.uid;
    this.db.patchThread(e, (s) => ({ ...s, pinnedBy: t ? yd(s.pinnedBy, [i]) : s.pinnedBy.filter((o) => o !== i) }));
  }
  async markRead(e) {
    const t = this.me.uid, i = Ca();
    this.db.write((s) => {
      for (const { id: o } of e) {
        const r = s.threads[o];
        r && (s.threads[o] = { ...r, readBy: { ...r.readBy, [t]: i }, markedUnread: r.markedUnread.filter((a) => a !== t) });
      }
    });
  }
  async markUnread(e) {
    const t = this.me.uid;
    this.db.patchThread(e, (i) => ({ ...i, markedUnread: yd(i.markedUnread, [t]) }));
  }
  async threadComments(e, t) {
    return Object.values(this.db.data.comments).filter((i) => i.boardId === e && i.threadId === t).sort((i, s) => i.createdAt - s.createdAt);
  }
  async boardTitles(e) {
    const t = {};
    for (const i of e) this.db.data.titles[i] && (t[i] = this.db.data.titles[i]);
    return t;
  }
  dispose() {
    for (const e of this.unsubs) e();
    this.unsubs = [];
  }
}
function yd(n, e) {
  const t = n.slice();
  for (const i of e) i && !t.includes(i) && t.push(i);
  return t;
}
const qSe = 8e-4;
function KSe(n, e) {
  const t = n.pad == null ? 8 : n.pad, i = t + (n.padTop || 0);
  let s = null;
  if (n.el) {
    const o = n.el(), r = o ? o.getBoundingClientRect() : null;
    r && (r.width || r.height) && (s = { x: r.left, y: r.top, w: r.width, h: r.height });
  } else if (n.box)
    s = n.box();
  else if (n.world && e) {
    const o = n.world();
    if (o) {
      const r = e.worldToClient(o.x, o.y), a = e.cam.value.zoom;
      s = { x: r.x, y: r.y, w: o.w * a, h: o.h * a };
    }
  }
  return s ? { x: s.x - t, y: s.y - i, w: s.w + t * 2, h: s.h + t + i } : null;
}
function YSe(n, e, t) {
  const i = /* @__PURE__ */ We([]), s = /* @__PURE__ */ We([]);
  let o = 0, r = 0;
  const a = /* @__PURE__ */ new Map();
  function l(d) {
    const c = r ? Math.min(0.1, (d - r) / 1e3) : 1;
    r = d;
    const u = t ? 1 : 1 - Math.pow(qSe, c), p = /* @__PURE__ */ new Map(), f = [];
    for (const b of n.value) {
      const w = KSe(b, e.value);
      w && (p.set(b.key, { ...w, r: b.radius == null ? 14 : b.radius, drop: b.drop, look: b.look, ring: b.ring }), f.push({ key: b.key, x: Math.round(w.x), y: Math.round(w.y), w: Math.round(w.w), h: Math.round(w.h) }));
    }
    let y = !1;
    for (const [b, w] of p) {
      let k = a.get(b);
      if (!k) {
        const P = a.size ? [...a.values()][0] : null;
        k = P && !t ? { key: b, x: P.x, y: P.y, w: P.w, h: P.h, r: P.r, open: P.open, drop: w.drop, look: w.look, ring: w.ring } : { key: b, x: w.x + w.w / 2, y: w.y + w.h / 2, w: 0, h: 0, r: w.r, open: t ? 1 : 0, drop: w.drop, look: w.look, ring: w.ring }, a.set(b, k), y = !0;
      }
      const S = k.x + (w.x - k.x) * u, _ = k.y + (w.y - k.y) * u, x = k.w + (w.w - k.w) * u, T = k.h + (w.h - k.h) * u, M = k.r + (Math.min(w.r, w.w / 2, w.h / 2) - k.r) * u, z = k.open + (1 - k.open) * u;
      Math.abs(S - k.x) + Math.abs(_ - k.y) + Math.abs(x - k.w) + Math.abs(T - k.h) + Math.abs(z - k.open) > 0.05 && (y = !0), Object.assign(k, { x: S, y: _, w: x, h: T, r: M, open: z, drop: w.drop, look: w.look, ring: w.ring });
    }
    for (const [b, w] of a) {
      if (p.has(b)) continue;
      y = !0;
      const k = w.x + w.w / 2, S = w.y + w.h / 2;
      w.w += (0 - w.w) * u, w.h += (0 - w.h) * u, w.x = k - w.w / 2, w.y = S - w.h / 2, w.open += (0 - w.open) * u, (w.w < 1 || w.h < 1 || t) && a.delete(b);
    }
    y && (i.value = [...a.values()].map((b) => ({ ...b }))), JSON.stringify(f) !== JSON.stringify(s.value) && (s.value = f), o = requestAnimationFrame(l);
  }
  return ot(() => {
    o = requestAnimationFrame(l);
  }), Ve(() => {
    o && cancelAnimationFrame(o);
  }), { holes: i, exact: s };
}
const Nc = 76, $o = 16, Sh = 18, Th = { above: "below", below: "above", left: "right", right: "left" };
function Tb(n, e, t, i) {
  switch (n) {
    case "above":
      return { x: e.x + e.w / 2 - t.w / 2, y: e.y - t.h - Sh };
    case "below":
      return { x: e.x + e.w / 2 - t.w / 2, y: e.y + e.h + Sh };
    case "left":
      return { x: e.x - t.w - Sh, y: e.y + e.h / 2 - t.h / 2 };
    case "right":
      return { x: e.x + e.w + Sh, y: e.y + e.h / 2 - t.h / 2 };
    case "right-edge":
      return { x: i.w - t.w - 24, y: e.y + e.h / 2 - t.h / 2 };
    case "left-edge":
      return { x: 24, y: e.y + e.h / 2 - t.h / 2 };
    case "top-right":
      return { x: i.w - t.w - 24, y: Nc + 6 };
    case "bottom-left":
      return { x: 24, y: i.h - t.h - $o };
    case "bottom-right":
      return { x: i.w - t.w - 24, y: i.h - t.h - $o };
    case "bottom-center":
      return { x: i.w / 2 - t.w / 2, y: i.h - t.h - 108 };
    default:
      return { x: i.w / 2 - t.w / 2, y: i.h / 2 - t.h / 2 };
  }
}
function XSe(n, e, t) {
  return n.x >= $o && n.y >= Nc && n.x + e.w <= t.w - $o && n.y + e.h <= t.h - $o;
}
const Mb = (n, e, t) => ({
  x: Math.max($o, Math.min(t.w - e.w - $o, n.x)),
  y: Math.max(Nc, Math.min(t.h - e.h - $o, n.y))
});
function JSe(n, e) {
  return n.x < e.x + e.w && e.x < n.x + n.w && n.y < e.y + e.h && e.y < n.y + n.h;
}
const ZSe = ["below", "above", "right", "left", "bottom-left", "bottom-right", "top-right", "right-edge", "left-edge"];
function QSe(n, e, t, i, s = []) {
  if (!e && !(n === "top-right" || n === "bottom-center")) return { ...Mb(Tb("center", { x: 0, y: 0, w: 0, h: 0 }, t, i), t, i), side: "center" };
  const r = e || { x: 0, y: 0, w: 0, h: 0 }, a = [n];
  if (Th[n] && a.push(Th[n]), e)
    for (const c of ZSe) a.includes(c) || a.push(c);
  const l = e ? [...s, e] : s, d = (c) => !l.some((u) => JSe({ x: c.x, y: c.y, w: t.w, h: t.h }, u));
  for (const c of a) {
    const u = Tb(c, r, t, i), p = c === n || c === Th[n] ? Mb(u, t, i) : u;
    if ((c === n || c === Th[n] || XSe(p, t, i)) && d(p)) return { ...p, side: c };
  }
  return { ...Mb(Tb(n, r, t, i), t, i), side: n };
}
function S4(n) {
  if (!n.length) return null;
  const e = Math.min(...n.map((o) => o.x)), t = Math.min(...n.map((o) => o.y)), i = Math.max(...n.map((o) => o.x + o.w)), s = Math.max(...n.map((o) => o.y + o.h));
  return { x: e, y: t, w: i - e, h: s - t };
}
const Fn = { w: 1180, h: 620, bar: 44, shown: 540 }, rA = { w: Fn.w, h: Fn.h - Fn.bar }, mf = { x: rA.w / 2, y: 217 }, T0 = Fn.shown - Fn.bar - 16, Ns = { w: 600, h: 138, x: (rA.w - 600) / 2, y: T0 - 138 }, ko = { x: Ns.x + 54, y: Ns.y + 12, w: 44, h: 44 }, Bd = { x: Ns.x + Ns.w - 12 - 62, y: Ns.y + Ns.h - 12 - 30, w: 62, h: 30 }, dp = "https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-", Kt = (n) => dp + n + "-400w.webp", ut = {
  whiteCard: Kt("e05-option-a-white-card-model-c61989"),
  golden: Kt("t03-autumn-golden-hour-3768d6"),
  dusk: Kt("t07-alpenglow-dusk-1d0baa"),
  blueHour: Kt("t04-winter-blue-hour-50f063"),
  night: Kt("t06-night-facade-lighting-69ccb0"),
  aerial: Kt("s01-existing-site-aerial-f3aa4c"),
  depot: Kt("s02-existing-depot-street-7c94e0"),
  creek: Kt("s03-existing-buried-creek-channel-160598"),
  sketchCanyon: Kt("e02-option-b-sketch-canyon-374663"),
  sketchSalt: Kt("e03-option-c-sketch-salt-11df63"),
  sketchShore: Kt("e01-option-a-sketch-shoreline-c101a0"),
  whiteCardSet: Kt("e04-white-card-options-a-b-c-1713cd"),
  lobbyModel: Kt("i01-lobby-white-model-d9fd93"),
  optionB: Kt("e06-option-b-render-parked-80d4c0"),
  optionC: Kt("e07-option-c-render-parked-e0c191"),
  watercolor: Kt("e08-option-a-watercolor-db5917"),
  openCrown: Kt("e10-hero-v2-open-crown-4a3b4d"),
  terraces: Kt("e12-hero-v3-deeper-terraces-1c4ede"),
  brickPodium: Kt("e15-hero-v4-brick-podium-11449d"),
  lobby: Kt("i02-lobby-v1-geometry-materials-ef49f9"),
  lobbyBright: Kt("i06-lobby-v4-competition-brightening-34918a"),
  masterplan: Kt("l02-watercolor-masterplan-6b0e55"),
  creekWalk: Kt("l04-creek-walk-marketing-hero-92d17d"),
  gardens: Kt("l08-daytime-gardens-with-people-8fb7f2"),
  dollyIn: dp + "v02-hero-dolly-in-88196408-poster-400w.webp",
  dayToNight: dp + "v03-aerial-day-to-night-time-lapse-744df3b5-poster-400w.webp",
  skyLounge: dp + "v06-sky-lounge-sunset-time-lapse-a0a91aee-poster-400w.webp"
}, ao = { w: 252, h: 160 }, ks = [0, 1304, 2608], _s = [0, 470, 1e3], Ss = 1164, aA = [
  { title: "Site photos", x: ks[0], y: _s[0], w: Ss, h: 300 },
  { title: "Massing sketches", x: ks[1], y: _s[0], w: Ss, h: 300 },
  { title: "White card models", x: ks[2], y: _s[0], w: Ss, h: 300 },
  { title: "Direction renders", x: ks[0], y: _s[1], w: Ss, h: 330 },
  { title: "Hero options", x: ks[1], y: _s[1], w: Ss, h: 330 },
  { title: "Facade iterations", x: ks[2], y: _s[1], w: Ss, h: 330 },
  { title: "Lobby", x: ks[0], y: _s[2], w: Ss, h: 300 },
  { title: "Bench Gardens", x: ks[1], y: _s[2], w: Ss, h: 300 },
  { title: "Motion", x: ks[2], y: _s[2], w: Ss, h: 300 }
], lA = aA[4], ll = { id: "white-card", src: ut.whiteCard, x: 1608, y: 500, w: 150, h: 200 }, _o = [
  { id: "golden", src: ut.golden, x: 1798, y: 500, w: 150, h: 200 },
  { id: "dusk", src: ut.dusk, x: 1962, y: 500, w: 150, h: 200 },
  { id: "blue-hour", src: ut.blueHour, x: 2126, y: 500, w: 150, h: 200 },
  { id: "night", src: ut.night, x: 2290, y: 500, w: 150, h: 200 }
], dA = [
  { id: "aerial", src: ut.aerial, x: 304, y: 30, w: 260, h: 146 },
  { id: "depot", src: ut.depot, x: 578, y: 30, w: 260, h: 146 },
  { id: "creek", src: ut.creek, x: 852, y: 30, w: 260, h: 146 },
  { id: "sketch-canyon", src: ut.sketchCanyon, x: 1332, y: 30, w: 180, h: 240 },
  { id: "sketch-salt", src: ut.sketchSalt, x: 1526, y: 30, w: 180, h: 240 },
  { id: "sketch-shore", src: ut.sketchShore, x: 1720, y: 30, w: 180, h: 240 },
  { id: "white-card-set", src: ut.whiteCardSet, x: 2912, y: 30, w: 400, h: 225 },
  { id: "lobby-model", src: ut.lobbyModel, x: 3326, y: 30, w: 400, h: 225 },
  { id: "option-b", src: ut.optionB, x: 304, y: 500, w: 200, h: 267 },
  { id: "option-c", src: ut.optionC, x: 518, y: 500, w: 200, h: 267 },
  { id: "watercolor", src: ut.watercolor, x: 732, y: 500, w: 200, h: 267 },
  ll,
  { id: "open-crown", src: ut.openCrown, x: 2636, y: 500, w: 200, h: 267 },
  { id: "terraces", src: ut.terraces, x: 2850, y: 500, w: 200, h: 267 },
  { id: "brick-podium", src: ut.brickPodium, x: 3064, y: 500, w: 200, h: 267 },
  { id: "lobby", src: ut.lobby, x: 304, y: 1030, w: 316, h: 236 },
  { id: "lobby-bright", src: ut.lobbyBright, x: 634, y: 1030, w: 316, h: 236 },
  { id: "masterplan", src: ut.masterplan, x: 1332, y: 1030, w: 316, h: 237 },
  { id: "creek-walk", src: ut.creekWalk, x: 1662, y: 1030, w: 400, h: 225 },
  { id: "gardens", src: ut.gardens, x: 2076, y: 1030, w: 364, h: 205 },
  { id: "dolly-in", src: ut.dollyIn, x: 2912, y: 1030, w: 180, h: 240, video: !0 },
  { id: "day-to-night", src: ut.dayToNight, x: 3106, y: 1030, w: 300, h: 169, video: !0 },
  { id: "sky-lounge", src: ut.skyLounge, x: 3420, y: 1030, w: 300, h: 169, video: !0 }
], Wn = { id: "hero", kind: "Image", model: "Nano Banana Pro", name: "Hero options", x: 1332, y: 500, thumbs: [], foot: "No runs yet" }, cA = [
  { id: "site", kind: "Image", model: "Nano Banana Pro", name: "Site photos", x: 28, y: 30, thumbs: [ut.aerial, ut.depot, ut.creek], foot: "Updated Sep 2" },
  { id: "sketch", kind: "Image", model: "Nano Banana 2", name: "Sketch options", x: 1928, y: 30, thumbs: [ut.sketchCanyon, ut.sketchSalt, ut.sketchShore], foot: "Updated Sep 4" },
  { id: "white", kind: "Image", model: "Seedream 5 Lite", name: "White card", x: 2636, y: 30, thumbs: [ut.whiteCardSet, ut.lobbyModel], foot: "Updated Sep 5" },
  { id: "directions", kind: "Image", model: "Nano Banana 2", name: "Directions", x: 28, y: 500, thumbs: [ut.optionB, ut.optionC, ut.watercolor], foot: "Updated Sep 6" },
  Wn,
  { id: "facade", kind: "Image", model: "Nano Banana Pro", name: "Facade", x: 3292, y: 500, thumbs: [ut.openCrown, ut.terraces, ut.brickPodium], foot: "Updated Sep 9" },
  { id: "lobby", kind: "Image", model: "Nano Banana 2", name: "Lobby", x: 28, y: 1030, thumbs: [ut.lobby, ut.lobbyBright], foot: "Updated Sep 11" },
  { id: "motion", kind: "Video", model: "Kling 2.6 Pro", name: "Hero dolly-in", x: 2636, y: 1030, thumbs: [ut.dollyIn, ut.dayToNight, ut.skyLounge], foot: "Updated Sep 12" }
], Mh = { id: "cover", text: "Golden hour for the cover. Client review Thursday.", by: "MT", tint: "amethyst", x: 1332, y: 676, w: 252, h: 96 }, uA = [
  { id: "creek", text: "Option B reads best from the creek.", by: "KB", tint: "amber", x: 2194, y: 30, w: 246, h: 120 },
  { id: "canyon", text: "Canyon for the competition entry.", by: "JR", tint: "rose", x: 946, y: 500, w: 190, h: 120 },
  { id: "podium", text: "Brick podium is the keeper.", by: "MT", tint: "mint", x: 3292, y: 676, w: 252, h: 96 }
], M0 = "Photoreal, at golden hour, dusk, blue hour and night";
function C0(n) {
  const e = (t, i) => t >= n.x && t < n.x + n.w && i >= n.y && i < n.y + n.h;
  return dA.filter((t) => e(t.x, t.y)).length + cA.filter((t) => e(t.x, t.y)).length + uA.filter((t) => e(t.x, t.y)).length;
}
const Ch = { x: 1886, y: 650 }, eTe = 0.6;
function tTe(n, e = 0) {
  const t = n.x + (n.w || 0) / 2, i = n.y + (n.h || 0) / 2, s = Math.hypot(Ch.x, Ch.y), o = eTe * Math.pow(Math.min(1, Math.hypot(t - Ch.x, i - Ch.y) / s), 0.85) - e;
  return Math.max(0, Math.round(o * 1e3) / 1e3);
}
const Fd = { fx: 1886, fy: 628, z: 0.29 }, cp = { fx: 1886, fy: 653, z: 0.9 };
function nTe(n, e, t) {
  return { x: mf.x + (e - n.fx) * n.z, y: mf.y + (t - n.fy) * n.z };
}
function I0(n, e, t) {
  return { fx: n.fx + (e.fx - n.fx) * t, fy: n.fy + (e.fy - n.fy) * t, z: n.z * Math.pow(e.z / n.z, t) };
}
function So(n, e, t, i) {
  const s = 3 * n, o = 3 * (t - n) - s, r = 1 - s - o, a = 3 * e, l = 3 * (i - e) - a, d = 1 - a - l, c = (f) => ((r * f + o) * f + s) * f, u = (f) => ((d * f + l) * f + a) * f, p = (f) => (3 * r * f + 2 * o) * f + s;
  return (f) => {
    if (f <= 0) return 0;
    if (f >= 1) return 1;
    let y = f;
    for (let k = 0; k < 8; k++) {
      const S = c(y) - f;
      if (Math.abs(S) < 1e-6) return u(y);
      const _ = p(y);
      if (Math.abs(_) < 1e-6) break;
      y -= S / _;
    }
    let b = 0, w = 1;
    y = f;
    for (let k = 0; k < 30; k++) {
      const S = c(y);
      if (Math.abs(S - f) < 1e-6) break;
      S < f ? b = y : w = y, y = (b + w) / 2;
    }
    return u(y);
  };
}
const Je = {
  /** the camera's dive: slow away, slow to rest */
  dive: So(0.65, 0, 0.3, 1),
  /** the pull back: it eases away, then settles over a long tail */
  settle: So(0.5, 0, 0.12, 1),
  /** the pointer: quick to start, gentle to arrive */
  move: So(0.4, 0, 0.2, 1),
  /** the board's --ease-out-soft: things arriving */
  out: So(0.16, 1, 0.3, 1),
  linear: (n) => n,
  sine: (n) => 0.5 - 0.5 * Math.cos(Math.PI * n)
}, Uc = (n) => n < 0 ? 0 : n > 1 ? 1 : n;
function Ue(n, e, t, i = Je.linear) {
  return i(Uc((n - e) / (t - e)));
}
function iTe(n) {
  const t = n - 1;
  return 1 + t * t * ((1.9 + 1) * t + 1.9);
}
const up = 30, Ge = {
  zoomIn: [1.2, 3.8],
  cursorIn: [3.9, 4.2],
  toSession: [4, 4.7],
  clickSession: 4.75,
  promptOpen: [4.8, 5.3],
  toWhiteCard: [5.45, 6.05],
  /** Shift goes down: the keycap shows beside the pointer */
  shift: 6.05,
  /** the press on the model: its copy lifts */
  press: 6.2,
  drag: [6.25, 7.05],
  drop: 7.1,
  type: [7.4, 9.4],
  toRun: [9.5, 10],
  run: 10.05,
  land: 11.95,
  toHeart: [12.65, 13.25],
  heart: 13.35,
  note: 14.05,
  toEmpty: [14.85, 15.45],
  deselect: 15.5,
  promptClose: [15.55, 16],
  cursorOut: [15.75, 16.15],
  zoomOut: [16.05, 19.65],
  sheen: [21.2, 23.9],
  /** the run's additions leave, while the board is small, ready for the next loop */
  reset: [28.2, 29.2]
}, T4 = 14.75;
function sTe(n) {
  return n < Ge.zoomIn[0] ? Fd : n < Ge.zoomIn[1] ? I0(Fd, cp, Ue(n, Ge.zoomIn[0], Ge.zoomIn[1], Je.dive)) : n < Ge.zoomOut[0] ? cp : n < Ge.zoomOut[1] ? I0(cp, Fd, Ue(n, Ge.zoomOut[0], Ge.zoomOut[1], Je.settle)) : Fd;
}
function Cb(n, e) {
  return nTe(cp, n, e);
}
const pi = {
  start: { x: 760, y: 262 },
  session: Cb(Wn.x + 132, Wn.y + 50),
  whiteCard: Cb(ll.x + 78, ll.y + 112),
  slot: { x: ko.x + ko.w / 2 + 2, y: ko.y + ko.h / 2 + 2 },
  run: { x: Bd.x + Bd.w / 2 + 4, y: Bd.y + Bd.h / 2 + 3 },
  heart: Cb(_o[0].x + 17, _o[0].y + 17),
  // clear canvas, below Hero options and right of the prompt
  empty: { x: 968, y: 398 }
}, oTe = [
  { at: Ge.toSession, from: pi.start, to: pi.session, arc: 0.12 },
  { at: Ge.toWhiteCard, from: pi.session, to: pi.whiteCard, arc: -0.1 },
  { at: Ge.drag, from: pi.whiteCard, to: pi.slot, arc: 0.16 },
  { at: Ge.toRun, from: pi.slot, to: pi.run, arc: -0.08 },
  { at: Ge.toHeart, from: pi.run, to: pi.heart, arc: 0.1 },
  { at: Ge.toEmpty, from: pi.heart, to: pi.empty, arc: -0.12 }
];
function Ib(n) {
  let e = pi.start;
  for (const t of oTe) {
    if (n < t.at[0]) return e;
    if (n < t.at[1]) {
      const i = Ue(n, t.at[0], t.at[1], Je.move), s = t.to.x - t.from.x, o = t.to.y - t.from.y, r = Math.sin(Math.PI * i) * t.arc;
      return { x: t.from.x + s * i - o * r, y: t.from.y + o * i + s * r };
    }
    e = t.to;
  }
  return e;
}
const hA = [Ge.clickSession, Ge.run, Ge.heart, Ge.deselect], M4 = (() => {
  const n = Array.from(M0, (s, o) => {
    const r = M0[o - 1], a = (Math.sin(o * 12.9898) * 43758.5453 % 1 + 1) % 1;
    return (r === "," ? 3.2 : r === " " ? 1.5 : 1) * (0.82 + 0.36 * a);
  }), e = n.reduce((s, o) => s + o, 0), t = Ge.type[1] - Ge.type[0];
  let i = 0;
  return n.map((s) => (i += s, Ge.type[0] + i / e * t));
})();
function rTe(n) {
  if (n < Ge.type[0] || n >= Ge.reset[1]) return 0;
  let e = 0;
  for (; e < M4.length && M4[e] <= n; ) e++;
  return e;
}
function aTe(n, e, t, i) {
  return n < e || n > t ? 0 : Math.min(Uc((n - e) / i), Uc((t - n) / i));
}
function lTe(n) {
  for (const e of hA) if (n >= e - 0.02 && n < e + 0.14) return 1;
  return n >= Ge.press && n < Ge.drop ? 1 : 0;
}
function Ih(n) {
  const e = (n % up + up) % up, t = sTe(e), i = 1 - Ue(e, Ge.reset[0], Ge.reset[1], Je.sine), s = e >= Ge.land && e < Ge.reset[1], o = Ib(e), r = Math.min(Ue(e, Ge.cursorIn[0], Ge.cursorIn[1], Je.sine), 1 - Ue(e, Ge.cursorOut[0], Ge.cursorOut[1], Je.sine));
  let a = { x: o.x, y: o.y, shown: 0, size: 0 };
  for (const L of hA)
    if (e >= L && e < L + 0.5) {
      const Z = (e - L) / 0.5;
      a = { x: Ib(L).x, y: Ib(L).y, shown: 0.42 * (1 - Z), size: 0.45 + 0.75 * Je.out(Z) };
    }
  const l = Ue(e, Ge.press, Ge.press + 0.2, Je.out), d = Ue(e, Ge.drop, Ge.drop + 0.18, Je.sine), c = Ue(e, Ge.drag[1] - 0.3, Ge.drag[1], Je.sine), u = {
    x: o.x,
    y: o.y,
    shown: e >= Ge.press && e < Ge.drop + 0.18 ? l * (1 - d) : 0,
    tilt: -7 * (1 - c),
    ring: c
  }, p = Ue(e, Ge.promptOpen[0], Ge.promptOpen[1], Je.out) * (1 - Ue(e, Ge.promptClose[0], Ge.promptClose[1], Je.sine)), f = rTe(e), y = e >= Ge.type[0] && e < Ge.type[1] + 0.05, b = (L) => Math.floor((e - L) / 0.53) % 2 === 0 ? 1 : 0;
  let w = 0;
  p > 0.5 && e < Ge.run && (w = y ? 1 : b(e < Ge.type[0] ? Ge.promptOpen[1] : Ge.type[1]));
  const k = e >= Ge.drop && e < Ge.promptClose[1] ? Ue(e, Ge.drop, Ge.drop + 0.55, Je.out) : 0, S = e - Ge.drop, _ = k > 0 && S < 5 ? Math.min(Uc(S / 0.6), Uc((5 - S) / 1)) * (0.55 + 0.45 * Math.sin(S / 2.5 * Math.PI * 2 - Math.PI / 2)) : 0, x = e >= Ge.promptClose[1] ? 0 : Ue(e, Ge.type[0], Ge.type[0] + 0.25, Je.sine), T = e >= Ge.run - 0.02 && e < Ge.run + 0.14 ? 1 : 0, M = e >= Ge.run && e < Ge.land, z = Ue(e, Ge.clickSession, Ge.clickSession + 0.18) * (1 - Ue(e, Ge.deselect, Ge.deselect + 0.18));
  let P = Wn.foot;
  M ? P = "Generating… 0:0" + Math.floor(e - Ge.run) : s && e < Ge.reset[0] && (P = "Updated just now");
  const D = (L) => s ? Ue(e, Ge.land + L * 0.08, Ge.land + L * 0.08 + 0.65, Je.out) * i : 0, $ = _o.map((L, Z) => D(Z)), O = e >= Ge.note && e < Ge.reset[1];
  return {
    cam: t,
    pointer: { x: o.x, y: o.y, shown: r, pressed: lTe(e), shift: aTe(e, Ge.shift, Ge.drop + 0.3, 0.15) },
    ripple: a,
    ghost: u,
    dock: 1 - p,
    prompt: p,
    refIn: k,
    refGlow: _,
    typed: f,
    caret: w,
    runLit: x,
    runPressed: T,
    runBusy: M,
    sessionSelected: z,
    sessionFoot: P,
    sessionThumbs: $,
    sessionCount: s ? 4 : 0,
    shimmer: M,
    results: $,
    heart: e >= Ge.heart && e < Ge.reset[1] ? iTe(Ue(e, Ge.heart, Ge.heart + 0.38)) * i : 0,
    note: O ? Ue(e, Ge.note, Ge.note + 0.65, Je.out) * i : 0,
    frameItems: C0(lA) + (s && e < Ge.reset[0] ? _o.length : 0) + (O && e < Ge.reset[0] ? 1 : 0),
    sheen: e >= Ge.sheen[0] && e < Ge.sheen[1] ? Ue(e, Ge.sheen[0], Ge.sheen[1], Je.sine) : -1
  };
}
const Wy = [
  { id: "board", label: "Board" },
  { id: "session", label: "Sessions" },
  { id: "generate", label: "Generate" },
  { id: "studio", label: "Studio view" },
  { id: "edit", label: "Edit" },
  { id: "chat", label: "Chat" },
  { id: "finish", label: "Finish" }
], pA = "Bonneville Tower", dTe = "Client review Thursday: a hero render from Depot Street. Planted terraces, the mountains behind.", cTe = "MT", C4 = "Bonneville Tower from Depot Street, planted timber terraces, a glass crown, the Wasatch behind, photoreal", I4 = "Make it night, with warm light in every window", A4 = 4, uTe = "https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-", Bi = (n) => uTe + n + "-800w.webp", tu = [
  { id: "site-aerial", src: Bi("s01-existing-site-aerial-f3aa4c"), label: "Site aerial" },
  { id: "site-depot", src: Bi("s02-existing-depot-street-7c94e0"), label: "Depot Street today" },
  { id: "site-creek", src: Bi("s03-existing-buried-creek-channel-160598"), label: "Buried creek channel" }
], qy = [
  { src: Bi("t03-autumn-golden-hour-3768d6"), label: "Golden hour" },
  { src: Bi("t01-spring-noon-3be8a4"), label: "Spring noon" },
  { src: Bi("t07-alpenglow-dusk-1d0baa"), label: "Alpenglow" },
  { src: Bi("e12-hero-v3-deeper-terraces-1c4ede"), label: "Deeper terraces" }
], Nd = { src: Bi("t06-night-facade-lighting-69ccb0"), label: "Night, windows lit" }, Ah = { w: 300, h: 402 }, hTe = "Show the finished tower in each of these site photos: planted terraces, a glass crown", fA = "Nano Banana Pro", Ia = {
  title: "The finished tower, from each site photo",
  session: "Site photos, finished",
  prompt: "This site with the tower finished, from the same viewpoint: planted timber terraces, a glass crown, green streets, the buried creek opened up as a park. Photorealistic architectural photograph.",
  why: "It keeps each photo's viewpoint and light, so every view lines up with the site",
  /** the runs' shape: the site photos' own */
  size: "16:9"
}, pTe = "I can see three site photos in this frame: the aerial, Depot Street today and the buried creek channel. I'll give each one to " + fA + " with the tower you described, one run per photo, so you see it finished from every viewpoint.", fTe = "Done: three views, set out in the frame under the session. From Depot Street the tower sits just out of the photo, so that one shows the planted street instead. Open the session to change its prompt or run it again.", A0 = {
  "site-aerial": { src: Bi("s06-masterplan-aerial-55b63e"), label: "Aerial, finished" },
  "site-depot": { src: Bi("l09-greener-depot-street-a56204"), label: "Depot Street, finished" },
  "site-creek": { src: Bi("l04-creek-walk-marketing-hero-92d17d"), label: "Creek walk, finished" }
}, ts = [
  {
    id: "welcome",
    chapter: "board",
    eyebrow: "Welcome to Boards",
    title: "Every project, on one board",
    body: "A board is an endless canvas for a project: the images, the AI sessions that make them, and the notes around them, side by side. Let's make your first image together. It takes about three minutes.",
    kind: "continue",
    demo: "board",
    place: "center"
  },
  {
    id: "look",
    chapter: "board",
    title: "Here's your brief",
    body: "This practice board holds the site photos for " + pA + " and a note from the client. Let's make the render they asked for. Nothing here is saved, and nothing costs tokens.",
    kind: "continue",
    place: "below"
  },
  {
    id: "add-session",
    hint: "Use the glowing Image Gen button, in the bar at the bottom",
    chapter: "session",
    title: "Start a tool session",
    body: "A session is an AI tool that lives on your board. It keeps its model, your prompt and every image it makes, all in one place.",
    task: "Click **Image Gen** to add one",
    kind: "click",
    demo: "session",
    place: "above"
  },
  {
    id: "open-session",
    hint: "Click the session card that's lit up",
    chapter: "session",
    title: "Open it to write a prompt",
    body: "Your session is on the board, beside the brief. Click any session to open its prompt, and click the canvas to put it away.",
    task: "Click the session",
    kind: "click",
    demo: "open",
    place: "right"
  },
  {
    id: "tab-prompt",
    hint: "Press the Tab key on your keyboard",
    chapter: "generate",
    title: "Write the prompt with Tab",
    body: "Say what to make: the subject, where it stands, the light. We've drafted this one from the brief.",
    task: "Press **Tab** to write it in",
    kind: "tab",
    demo: "prompt",
    place: "above"
  },
  {
    id: "run",
    hint: "Click Run, at the prompt's bottom right",
    chapter: "generate",
    title: "Run it",
    body: "Run sends your prompt to the model. This session makes four images at a time, so you can pick the best.",
    task: "Click **Run**",
    kind: "run",
    demo: "run",
    place: "above",
    waiting: { title: "Making your images", body: "A real run takes about half a minute. This practice one is quicker." },
    landed: { title: "Your four images are in", body: "Four takes on the brief, each in its own light." }
  },
  {
    id: "results",
    chapter: "generate",
    title: "Four options, kept in the session",
    body: "Each image lands in its session: on the card, and in the gallery on the right. Open the session any time to find them again.",
    kind: "continue",
    // the run's own demonstration carries on (it shows just this), so the card holds still as the words change
    demo: "run",
    place: "left"
  },
  {
    id: "drag",
    hint: "Hold a picture in the gallery, then drag it onto the board",
    chapter: "generate",
    title: "Put one on the board",
    body: "Drag a picture out of the gallery to lay it out on the board, beside the session it came from. The session keeps every image either way.",
    task: "Drag an image onto the board",
    kind: "drag",
    demo: "drag",
    place: "left"
  },
  {
    id: "studio-open",
    hint: "Click Studio, at the prompt's top right",
    chapter: "studio",
    title: "Studio view: the session, full screen",
    body: "Studio view gives a session the whole screen: the picture large, its versions above it, and every editing tool beside it.",
    task: "Click **Studio**",
    kind: "click",
    demo: "studio",
    place: "above"
  },
  {
    id: "edit-side",
    hint: "Click Edit, at the top left",
    chapter: "edit",
    title: "Switch to Edit",
    body: "Generate makes new images from words. Edit changes the picture on stage and keeps the rest of it as it is.",
    task: "Click **Edit**",
    kind: "click",
    demo: "edit",
    place: "top-right"
  },
  {
    id: "edit-tab",
    hint: "Press the Tab key on your keyboard",
    chapter: "edit",
    title: "Say what changes",
    body: "Plain words are enough. To change just one part, paint over it first, and everything outside it stays exactly as it was.",
    task: "Press **Tab** to write it in",
    kind: "tab",
    place: "top-right"
  },
  {
    id: "edit-run",
    hint: "Click Run, under the picture",
    chapter: "edit",
    title: "Run the edit",
    body: "The edit becomes a new version of the picture, and the one you started from is kept.",
    task: "Click **Run**",
    kind: "run",
    place: "top-right",
    waiting: { title: "Making the new version", body: "Same building, same view. Only what you asked for changes." },
    landed: { title: "Your new version is in", body: "Night, with warm light in every window, as you asked." }
  },
  {
    id: "edit-result",
    chapter: "edit",
    title: "Same building, new light",
    body: "Every edit is a version you can step through above the picture, or split two to compare. Relight, Change camera and Upscale wait in the list on the left.",
    kind: "continue",
    place: "top-right"
  },
  {
    id: "chat-open",
    hint: "Click Chat, on the bar over the Site photos frame",
    chapter: "chat",
    // the tour closes Studio view on the way here (TourController), so this says it did
    note: { did: "We closed Studio view for you", how: "To close it yourself, press **Esc** or click the back arrow at its top left." },
    title: "Hand a chat the work",
    body: "A chat lives in a frame, and everything in the frame is what it works with: here, the three site photos. Say what you need, and it sets up the sessions and runs them for you.",
    task: "Click **Chat** on the frame",
    kind: "click",
    demo: "chat",
    place: "right"
  },
  {
    id: "chat-tab",
    hint: "Press the Tab key on your keyboard",
    chapter: "chat",
    title: "Ask in plain words",
    body: "Say it the way you'd ask a colleague. It sees the photos, so you only say what you want from them.",
    task: "Press **Tab** to write it in",
    kind: "tab",
    place: "left"
  },
  {
    id: "chat-send",
    hint: "Press Enter, or click the arrow under the message",
    chapter: "chat",
    title: "Send it",
    body: "It reads the frame first, then answers with a plan.",
    task: "Press **Enter** to send it",
    kind: "run",
    place: "left",
    waiting: { title: "Reading the frame", body: "It looks at each photo, then works out the session, its prompt and what it costs." },
    landed: { title: "Here's its plan", body: "One session and a run per photo, with what it would cost. Nothing has run yet." }
  },
  {
    id: "chat-run",
    hint: "Click Run plan, at the bottom of the plan",
    chapter: "chat",
    title: "Nothing runs until you say so",
    body: "A plan shows its sessions, the prompt it wrote and the cost before anything is spent. One click runs the lot.",
    task: "Click **Run plan**",
    kind: "run",
    place: "left",
    waiting: { title: "Working in the frame", body: "It adds the session, gives it each photo in turn and runs it. Watch the frame." },
    landed: { title: "Every photo, finished", body: "A new picture from each viewpoint, set out in the frame under the session that made it." }
  },
  {
    id: "chat-result",
    chapter: "chat",
    title: "Its work is yours to change",
    body: "What the chat made is an ordinary session in the frame: open it to change the prompt or run it again. Anyone on the board can open the chat and carry on.",
    kind: "continue",
    place: "left"
  },
  {
    id: "organize",
    chapter: "finish",
    title: "Keep the whole project together",
    body: "Frames group the work, notes keep decisions beside it, and comments start a conversation right on the board. Press F for a frame and N for a note.",
    kind: "continue",
    demo: "organize",
    place: "bottom-center"
  },
  {
    id: "finale",
    chapter: "finish",
    title: "You're ready",
    body: "",
    kind: "continue",
    place: "center"
  }
];
function tm(n) {
  const e = ts.find((t) => t.id === n);
  if (!e) throw new Error("No tour step " + n);
  return e;
}
function mTe(n) {
  return Wy.findIndex((e) => e.id === n);
}
function Ky(n) {
  const e = (n.title || "").trim();
  return !e || /^untitled board$/i.test(e) ? "your new board" : e;
}
function gTe(n, e) {
  return n === "first-board" && e ? "Before you start on " + Ky(e) + ", a three-minute tour of how a board works. You'll make an image, edit it, hand a chat some work, and see where everything goes. Nothing here is saved, and nothing costs tokens." : n === "replay" ? "Everything a board does, in about three minutes. You'll make an image, edit it, hand a chat some work, and see where it all goes. Nothing here is saved, and nothing costs tokens." : tm("welcome").body;
}
function bTe(n) {
  return n === "replay" ? "Start" : "Start the tour";
}
function vTe(n, e) {
  if (n === "first-board" && e) {
    const t = Ky(e);
    return "That's the heart of Boards: sessions on the canvas, Tab to write a prompt, Studio view to edit, and a chat to do the legwork. " + t.charAt(0).toUpperCase() + t.slice(1) + " is ready for you.";
  }
  return n === "replay" ? "That's the tour: sessions on the canvas, Tab to write a prompt, Studio view to edit, and a chat to do the legwork. Your boards are right where you left them." : "That's the heart of Boards: sessions on the canvas, Tab to write a prompt, Studio view to edit, and a chat to do the legwork. Your first board is one click away.";
}
const yTe = [
  "Sessions live on your board",
  "Tab writes a prompt",
  "Every image stays in its session",
  "Studio view edits in place",
  "A chat works with its frame"
];
function xTe(n, e) {
  if (n === "new-account") return { label: "Create my first board", exit: "create-board" };
  if (e) {
    const t = Ky(e) === "your new board";
    return n === "first-board" ? { label: t ? "Open my board" : "Open " + e.title, exit: "open-board" } : { label: t ? "Back to my board" : "Back to " + e.title, exit: "open-board" };
  }
  return { label: "Done", exit: "leave" };
}
function P4(n) {
  const e = [], t = /\*\*([^*]+)\*\*/g;
  let i = 0, s;
  for (; s = t.exec(n); )
    s.index > i && e.push({ text: n.slice(i, s.index), strong: !1 }), e.push({ text: s[1], strong: !0 }), i = s.index + s[0].length;
  return i < n.length && e.push({ text: n.slice(i), strong: !1 }), e;
}
const lo = { w: 640, h: 360 }, E4 = (n) => n < 0 ? 0 : n > 1 ? 1 : n, qr = (n) => ({ x: n.x + n.w / 2, y: n.y + n.h / 2 });
function Do(n, e, t, i = 0.3, s = 0.3) {
  return n < e || n > t ? 0 : Math.min(E4((n - e) / i), E4((t - n) / s));
}
function Xo(n, e, t, i, s, o = []) {
  let r = e, a = e, l = !1;
  for (const u of t) {
    if (n < u.at[0]) {
      a = r, l = !0;
      break;
    }
    if (n < u.at[1]) {
      const p = Ue(n, u.at[0], u.at[1], Je.move), f = u.to.x - r.x, y = u.to.y - r.y, b = Math.sin(Math.PI * p) * (u.arc == null ? 0.1 : u.arc);
      a = { x: r.x + f * p - y * b, y: r.y + y * p + f * b }, l = !0;
      break;
    }
    r = u.to;
  }
  l || (a = r);
  let d = { x: a.x, y: a.y, shown: 0, size: 0 };
  for (const u of i)
    if (n >= u && n < u + 0.5) {
      const p = (n - u) / 0.5, f = Xo(u, e, t, [], s);
      d = { x: f.x, y: f.y, shown: 0.5 * (1 - p), size: 0.45 + 0.8 * Je.out(p) };
    }
  const c = i.some((u) => n >= u - 0.03 && n < u + 0.14) || o.some(([u, p]) => n >= u && n < p);
  return { x: a.x, y: a.y, shown: Do(n, s[0], s[1], 0.3, 0.35), pressed: c, ring: d };
}
const Pi = { w: 252, h: 160 }, Gn = qy.map((n) => n.src.replace("-800w.webp", "-400w.webp")), gf = Nd.src.replace("-800w.webp", "-400w.webp"), Gc = "Bonneville Tower from Depot Street, planted terraces, photoreal", R4 = "Make it night, warm light in every window";
function nm(n, e, t, i) {
  if (e <= t) return "";
  if (e >= i) return n;
  const s = Array.from(n), o = s.map((c, u) => s[u - 1] === "," ? 3 : s[u - 1] === " " ? 1.4 : 1), r = o.reduce((c, u) => c + u, 0), a = (e - t) / (i - t) * r;
  let l = 0, d = 0;
  for (; d < s.length && l + o[d] <= a; ) l += o[d++];
  return s.slice(0, d).join("");
}
const Is = {
  loop: 7,
  still: 4.8,
  dock: { x: 150, y: 298, w: 340, h: 46 },
  /** the dock's Image Gen button */
  add: { x: 155, y: 303, w: 118, h: 34 },
  card: { x: 194, y: 58, w: Pi.w, h: Pi.h },
  tags: ["Its model", "Your prompt", "Every image it makes"],
  T: { cursorIn: [0.35, 6.3], toAdd: [0.6, 1.55], click: 1.7, land: [1.85, 2.5], tags: [2.7, 3, 3.3], reset: [6.2, 6.85] }
};
function wTe(n) {
  const e = Is, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ue(t, e.T.reset[0], e.T.reset[1], Je.sine), s = Ue(t, e.T.land[0], e.T.land[1], Je.out) * i;
  return {
    pointer: Xo(t, { x: 560, y: 210 }, [{ at: e.T.toAdd, to: qr(e.add), arc: -0.12 }], [e.T.click], e.T.cursorIn),
    addLit: Do(t, e.T.click - 0.05, e.T.click + 0.55, 0.05, 0.4),
    card: s,
    selected: Ue(t, e.T.land[1] - 0.1, e.T.land[1] + 0.2) * i,
    tags: e.T.tags.map((o) => Ue(t, o, o + 0.45, Je.out) * i)
  };
}
const Ba = {
  loop: 6.4,
  still: 3.4,
  card: { x: 194, y: 40, w: Pi.w, h: Pi.h },
  prompt: { x: 70, y: 218, w: 500, h: 124 },
  dock: { x: 150, y: 298, w: 340, h: 46 },
  empty: { x: 96, y: 128 },
  T: { cursorIn: [0.3, 5.9], toCard: [0.5, 1.3], click: 1.45, open: [1.55, 2.05], toEmpty: [3.6, 4.3], away: 4.45, close: [4.55, 5] }
};
function kTe(n) {
  const e = Ba, t = (n % e.loop + e.loop) % e.loop, i = Ue(t, e.T.open[0], e.T.open[1], Je.out) * (1 - Ue(t, e.T.close[0], e.T.close[1], Je.sine));
  return {
    pointer: Xo(t, { x: 560, y: 150 }, [
      { at: e.T.toCard, to: { x: e.card.x + 128, y: e.card.y + 52 }, arc: 0.1 },
      { at: e.T.toEmpty, to: e.empty, arc: -0.1 }
    ], [e.T.click, e.T.away], e.T.cursorIn),
    selected: Ue(t, e.T.click, e.T.click + 0.18) * (1 - Ue(t, e.T.away, e.T.away + 0.18)),
    prompt: i
  };
}
const po = {
  loop: 7.2,
  still: 5.2,
  prompt: { x: 40, y: 40, w: 560, h: 156 },
  key: { x: 272, y: 240, w: 96, h: 56 },
  T: { fadeIn: 0.35, keyIn: [0.4, 0.8], press: [1.45, 1.7], type: [1.75, 4.3], run: 4.4, keyOut: [5.6, 6], reset: [6.4, 7] }
}, _Te = { ghost: 1, typed: "", caret: 0, cue: 1, key: 0, keyDown: !1, runLit: 0, fade: 0 };
function STe(n) {
  const e = po, t = (n % e.loop + e.loop) % e.loop, i = Math.min(Ue(t, 0, e.T.fadeIn, Je.sine), 1 - Ue(t, e.T.reset[0], e.T.reset[1], Je.sine));
  if (i <= 0) return { ..._Te };
  const s = t < e.T.reset[0] ? nm(Gc, t, e.T.type[0], e.T.type[1]) : Gc, o = t >= e.T.type[0] && t < e.T.type[1], r = Math.floor(t / 0.53) % 2 === 0 ? 1 : 0;
  return {
    ghost: t < e.T.type[0] ? 1 : 0,
    typed: t >= e.T.reset[1] ? "" : s,
    caret: o ? 1 : t < e.T.reset[0] ? r : 0,
    cue: t < e.T.type[0] ? 1 - Ue(t, e.T.press[0], e.T.type[0]) : 0,
    key: Do(t, e.T.keyIn[0], e.T.keyOut[1], 0.4, 0.4),
    keyDown: t >= e.T.press[0] && t < e.T.press[1],
    runLit: Ue(t, e.T.run, e.T.run + 0.3) * i,
    fade: i
  };
}
const Fa = {
  loop: 8.2,
  still: 5.6,
  card: { x: 36, y: 36, w: Pi.w, h: Pi.h },
  prompt: { x: 30, y: 226, w: 400, h: 116 },
  run: { x: 356, y: 300, w: 62, h: 30 },
  gallery: { x: 452, y: 14, w: 174, h: 332 },
  T: { cursorIn: [0.3, 2.2], toRun: [0.5, 1.2], click: 1.35, busy: [1.4, 3.3], land: 3.3, gallery: [4, 4.7], reset: [7.4, 8.1] }
};
function TTe(n) {
  const e = Fa, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ue(t, e.T.reset[0], e.T.reset[1], Je.sine), s = t >= e.T.busy[0] && t < e.T.busy[1], o = Gn.map((r, a) => t >= e.T.land ? Ue(t, e.T.land + a * 0.14, e.T.land + a * 0.14 + 0.5, Je.out) * i : 0);
  return {
    pointer: Xo(t, { x: 560, y: 250 }, [{ at: e.T.toRun, to: qr(e.run), arc: 0.12 }], [e.T.click], e.T.cursorIn),
    busy: s,
    seconds: s ? Math.floor(t - e.T.busy[0]) : 0,
    thumbs: o,
    count: t >= e.T.land && t < e.T.reset[0] ? Gn.length : 0,
    gallery: Ue(t, e.T.gallery[0], e.T.gallery[1], Je.out) * i,
    foot: s ? "Generating… 0:0" + Math.floor(t - e.T.busy[0] + 1) : t >= e.T.land && t < e.T.reset[0] ? "Updated just now" : "No runs yet",
    runPressed: t >= e.T.click - 0.03 && t < e.T.click + 0.14
  };
}
const fi = {
  loop: 7,
  still: 3.4,
  card: { x: 36, y: 36, w: Pi.w, h: Pi.h },
  gallery: { x: 452, y: 14, w: 174, h: 332 },
  /** the gallery's first picture */
  pick: { x: 462, y: 54, w: 73, h: 98 },
  /** where it lands on the board */
  drop: { x: 316, y: 26, w: 116, h: 156 },
  T: { cursorIn: [0.3, 5], toPick: [0.5, 1.2], press: 1.38, drag: [1.5, 2.65], drop: 2.75, reset: [6.2, 6.8] }
};
function MTe(n) {
  const e = fi, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ue(t, e.T.reset[0], e.T.reset[1], Je.sine), s = { x: e.drop.x + 40, y: e.drop.y + 54 }, o = Xo(t, { x: 560, y: 300 }, [
    { at: e.T.toPick, to: { x: e.pick.x + 30, y: e.pick.y + 40 }, arc: 0.1 },
    { at: e.T.drag, to: s, arc: -0.18 }
  ], [], e.T.cursorIn, [[e.T.press, e.T.drop]]), r = Ue(t, e.T.press, e.T.press + 0.2, Je.out), a = Ue(t, e.T.drop, e.T.drop + 0.16, Je.sine), l = Ue(t, e.T.drag[1] - 0.35, e.T.drag[1], Je.sine);
  return {
    pointer: o,
    ghost: { x: o.x, y: o.y, shown: t >= e.T.press && t < e.T.drop + 0.16 ? r * (1 - a) : 0, tilt: -8 * (1 - l) },
    placed: t >= e.T.drop ? Ue(t, e.T.drop, e.T.drop + 0.45, Je.out) * i : 0,
    slot: Do(t, e.T.press + 0.1, e.T.drop + 0.1, 0.25, 0.2)
  };
}
const As = {
  loop: 8,
  still: 4.2,
  card: { x: 194, y: 34, w: Pi.w, h: Pi.h },
  prompt: { x: 70, y: 214, w: 500, h: 128 },
  pill: { x: 482, y: 224, w: 76, h: 26 },
  T: { cursorIn: [0.3, 1.9], toPill: [0.5, 1.3], hover: 1.3, click: 1.7, open: [1.85, 2.6], close: [6.5, 7.1], reset: [7.1, 7.6] }
};
function CTe(n) {
  const e = As, t = (n % e.loop + e.loop) % e.loop, i = Ue(t, e.T.open[0], e.T.open[1], Je.dive) * (1 - Ue(t, e.T.close[0], e.T.close[1], Je.sine));
  return {
    pointer: Xo(t, { x: 600, y: 120 }, [{ at: e.T.toPill, to: qr(e.pill), arc: 0.14 }], [e.T.click], e.T.cursorIn),
    pillLit: Do(t, e.T.hover, e.T.open[1], 0.2, 0.2),
    open: i,
    parts: Ue(t, e.T.open[1] - 0.1, e.T.open[1] + 0.6, Je.out) * (1 - Ue(t, e.T.close[0], e.T.close[0] + 0.3))
  };
}
const fo = {
  loop: 9.4,
  still: 7.2,
  stage: { x: 222, y: 30, w: 196, h: 262 },
  bar: { x: 162, y: 302, w: 316, h: 44 },
  run: { x: 416, y: 310, w: 54, h: 28 },
  /** the painted area: over the tower's middle floors */
  stroke: "M262 128 C 300 120, 336 122, 378 130 M262 150 C 300 142, 340 146, 380 152 M264 172 C 302 166, 338 168, 378 174",
  T: { cursorIn: [0.3, 4.9], toPaint: [0.5, 1], paint: [1.05, 2.4], type: [2.6, 4], toRun: [4, 4.5], click: 4.62, busy: [4.7, 5.6], wipe: [5.6, 6.5], version: 6.5, reset: [8.6, 9.2] }
};
function ITe(n) {
  const e = fo, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ue(t, e.T.reset[0], e.T.reset[1], Je.sine), s = Xo(t, { x: 560, y: 200 }, [
    { at: e.T.toPaint, to: { x: 262, y: 128 }, arc: 0.08 },
    { at: [e.T.paint[0], e.T.paint[0] + 0.45], to: { x: 378, y: 130 }, arc: -0.03 },
    { at: [e.T.paint[0] + 0.45, e.T.paint[0] + 0.9], to: { x: 262, y: 150 }, arc: 0.02 },
    { at: [e.T.paint[0] + 0.9, e.T.paint[1]], to: { x: 378, y: 172 }, arc: -0.02 },
    { at: e.T.toRun, to: qr(e.run), arc: 0.1 }
  ], [e.T.click], e.T.cursorIn, [[e.T.paint[0], e.T.paint[1]]]), o = t >= e.T.reset[1] ? "" : t < e.T.reset[0] ? nm(R4, t, e.T.type[0], e.T.type[1]) : R4;
  return {
    pointer: s,
    brush: t >= e.T.toPaint[1] - 0.1 && t < e.T.paint[1] + 0.15,
    // the area goes once the new version is in
    painted: t < e.T.wipe[1] ? Ue(t, e.T.paint[0], e.T.paint[1]) : 0,
    area: (1 - Ue(t, e.T.wipe[0], e.T.wipe[1])) * (t >= e.T.paint[0] ? 1 : 0),
    typed: o,
    busy: t >= e.T.busy[0] && t < e.T.busy[1],
    wipe: Ue(t, e.T.wipe[0], e.T.wipe[1], Je.dive) * i,
    versions: t >= e.T.version && t < e.T.reset[0] ? 2 : 1
  };
}
const ATe = tu.map((n) => n.src.replace("-800w.webp", "-400w.webp")), PTe = tu.map((n) => A0[n.id].src.replace("-800w.webp", "-400w.webp")), mA = "Show the finished tower in each of these photos", An = {
  loop: 11.8,
  still: 9.8,
  frame: { x: 24, y: 50, w: 372, h: 286 },
  /** where a click on the frame's title lands */
  title: { x: 62, y: 38 },
  photos: [
    { x: 40, y: 72, w: 108, h: 61 },
    { x: 156, y: 72, w: 108, h: 61 },
    { x: 272, y: 72, w: 108, h: 61 }
  ],
  /** each photo's finished view lands under it */
  finished: [
    { x: 40, y: 145, w: 108, h: 61 },
    { x: 156, y: 145, w: 108, h: 61 },
    { x: 272, y: 145, w: 108, h: 61 }
  ],
  /** the chat's card, in the frame */
  card: { x: 40, y: 222, w: 132, h: 96 },
  /** the frame's bar, and its Chat button */
  bar: { x: 150, y: 4, w: 118, h: 30 },
  chat: { x: 155, y: 9, w: 56, h: 20 },
  /** the chat panel, docked on the right, and what's in it (in the stage's pixels) */
  panel: { x: 412, y: 10, w: 216, h: 340 },
  bubble: { x: 452, y: 58, w: 168, h: 34 },
  answer: { x: 420, y: 104, w: 200, h: 30 },
  plan: { x: 440, y: 142, w: 180, h: 92 },
  run: { x: 538, y: 204, w: 76, h: 22 },
  composer: { x: 420, y: 284, w: 200, h: 58 },
  send: { x: 592, y: 314, w: 22, h: 22 },
  T: {
    cursorIn: [0.3, 9.6],
    toTitle: [0.5, 1.15],
    select: 1.3,
    toChat: [1.6, 2.2],
    open: 2.35,
    panel: [2.45, 2.95],
    card: [2.6, 3],
    type: [3.2, 4.5],
    toSend: [4.4, 4.95],
    send: 5.1,
    bubble: [5.15, 5.45],
    think: [5.45, 5.95],
    answer: [5.95, 6.5],
    plan: [6.55, 6.95],
    toRun: [7, 7.6],
    run: 7.75,
    busy: [7.8, 8.5],
    land: [8.5, 8.8, 9.1],
    reset: [10.8, 11.4]
  }
};
function ETe(n) {
  const e = An, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ue(t, e.T.reset[0], e.T.reset[1], Je.sine), s = t >= e.T.send, o = Ue(t, e.T.panel[0], e.T.panel[1], Je.out) * i;
  return {
    pointer: Xo(t, { x: 560, y: 210 }, [
      { at: e.T.toTitle, to: e.title, arc: -0.1 },
      { at: e.T.toChat, to: qr(e.chat), arc: 0.12 },
      { at: e.T.toSend, to: qr(e.send), arc: -0.08 },
      { at: e.T.toRun, to: qr(e.run), arc: 0.1 }
    ], [e.T.select, e.T.open, e.T.send, e.T.run], e.T.cursorIn),
    // the frame selected shows its bar; both go as the chat opens (its glow takes over)
    selected: Ue(t, e.T.select, e.T.select + 0.18) * (1 - Ue(t, e.T.panel[0], e.T.panel[1])),
    bar: Ue(t, e.T.select, e.T.select + 0.2) * (1 - Ue(t, e.T.panel[0], e.T.panel[1])),
    chatLit: Do(t, e.T.open - 0.05, e.T.open + 0.4, 0.05, 0.3),
    panel: o,
    glow: o * (1 - Ue(t, e.T.reset[0] - 0.4, e.T.reset[0])),
    card: Ue(t, e.T.card[0], e.T.card[1], Je.out) * i,
    typed: s || t >= e.T.reset[0] ? "" : nm(mA, t, e.T.type[0], e.T.type[1]),
    sendLit: t >= e.T.type[1] && !s ? 1 : Do(t, e.T.send - 0.05, e.T.send + 0.3, 0.05, 0.25),
    bubble: Ue(t, e.T.bubble[0], e.T.bubble[1], Je.out) * i,
    thinking: t >= e.T.think[0] && t < e.T.think[1],
    answer: Ue(t, e.T.answer[0], e.T.answer[1]) * i,
    plan: Ue(t, e.T.plan[0], e.T.plan[1], Je.out) * i,
    runLit: Do(t, e.T.run - 0.05, e.T.run + 0.4, 0.05, 0.3),
    busy: t >= e.T.busy[0] && t < e.T.busy[1],
    done: t >= e.T.busy[1] && t < e.T.reset[0],
    finished: e.T.land.map((r) => Ue(t, r, r + 0.45, Je.out) * i)
  };
}
const xn = {
  loop: 9,
  still: 5.2,
  frame: { x: 40, y: 46, w: 420, h: 214 },
  card: { x: 60, y: 92, w: Pi.w, h: Pi.h },
  pics: [
    { x: 332, y: 86, w: 54, h: 72 },
    { x: 392, y: 86, w: 54, h: 72 },
    { x: 332, y: 166, w: 54, h: 72 }
  ],
  note: { x: 486, y: 70, w: 128, h: 100 },
  pin: { x: 380, y: 92 },
  /** the frame's title, the note's words and the comment's, as the demo writes them */
  title: "Hero options",
  noteText: "Night version for the cover.",
  comment: "This one. Ship it.",
  T: { draw: [0.6, 1.8], title: [1.9, 2.5], note: [2.8, 3.4], pin: [3.8, 4.2], bubble: [4.2, 4.8], zoom: [5.6, 7], reset: [8.4, 9] }
};
function RTe(n) {
  const e = xn, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ue(t, e.T.reset[0], e.T.reset[1], Je.sine);
  return {
    frame: Ue(t, e.T.draw[0], e.T.draw[1], Je.move) * i,
    title: t >= e.T.reset[0] ? "" : nm(e.title, t, e.T.title[0], e.T.title[1]),
    note: Ue(t, e.T.note[0], e.T.note[1], Je.out) * i,
    pin: Ue(t, e.T.pin[0], e.T.pin[1], Je.out) * i,
    bubble: Ue(t, e.T.bubble[0], e.T.bubble[1], Je.out) * i,
    zoom: 1 - 0.18 * Ue(t, e.T.zoom[0], e.T.zoom[1], Je.settle) * i
  };
}
function Yy() {
  return typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function Qs(n, e) {
  const t = /* @__PURE__ */ K(null), i = /* @__PURE__ */ We(0), s = /* @__PURE__ */ K(0.55), o = /* @__PURE__ */ K({ x: 0, y: 0 }), r = Yy();
  let a = 0, l = 0, d = !1, c = null;
  function u() {
    const k = t.value;
    if (!k || !k.clientWidth) return;
    const S = k.clientWidth, _ = k.clientHeight || S * lo.h / lo.w, x = Math.min(S / lo.w, _ / lo.h);
    s.value = x, o.value = { x: (S - lo.w * x) / 2, y: (_ - lo.h * x) / 2 };
  }
  function p(k) {
    l || (l = k - i.value * 1e3), document.hidden ? l = k - i.value * 1e3 : i.value = (k - l) / 1e3 % n, a = requestAnimationFrame(p);
  }
  function f() {
    a || r || d || (l = 0, a = requestAnimationFrame(p));
  }
  function y() {
    a && cancelAnimationFrame(a), a = 0;
  }
  ot(() => {
    u(), typeof ResizeObserver != "undefined" && t.value && (c = new ResizeObserver(u), c.observe(t.value)), r ? i.value = e : f();
  }), Ve(() => {
    y(), c && c.disconnect();
  });
  const b = I(() => ({
    width: lo.w + "px",
    height: lo.h + "px",
    transform: "translate(" + o.value.x.toFixed(2) + "px, " + o.value.y.toFixed(2) + "px) scale(" + s.value.toFixed(5) + ")"
  }));
  return { root: t, bind: (k) => {
    t.value = k || null;
  }, t: i, scale: s, stageStyle: b, reduced: r };
}
const Dt = (n) => n.toFixed(2), dt = (n) => n.toFixed(3), zTe = {
  class: "ob-head",
  "data-tour-ui": "",
  "data-testid": "tour-header"
}, $Te = { class: "ob-head-left" }, DTe = ["viewBox"], OTe = ["d", "fill"], LTe = {
  class: "ob-chapters",
  "aria-label": "Tour progress"
}, BTe = ["aria-current", "data-chapter"], FTe = { class: "n" }, NTe = { class: "l" }, UTe = { class: "ob-head-right" }, GTe = /* @__PURE__ */ Re({
  __name: "TourHeader",
  props: {
    tour: {}
  },
  setup(n) {
    const e = n, t = I(() => mTe(e.tour.step.value.chapter)), i = I(() => e.tour.phase.value === "finished"), s = I(() => e.tour.reason === "replay" ? "Exit tour" : "Skip tour");
    return (o, r) => (g(), v("header", zTe, [
      h("div", $Te, [
        (g(), v("svg", {
          class: "ob-head-mark",
          viewBox: m(Ll),
          width: "25",
          height: "18",
          "aria-hidden": "true"
        }, [
          (g(!0), v(H, null, me(m(ea), (a) => (g(), v("path", {
            key: a.d,
            d: a.d,
            fill: a.fill
          }, null, 8, OTe))), 128))
        ], 8, DTe)),
        r[1] || (r[1] = h("span", { class: "ob-head-name" }, [
          X("Boards"),
          h("span", { class: "sep" }, "/"),
          h("b", null, "Getting started")
        ], -1))
      ]),
      h("ol", LTe, [
        (g(!0), v(H, null, me(m(Wy), (a, l) => (g(), v("li", {
          key: a.id,
          class: U({ on: l === t.value && !i.value, done: l < t.value || i.value }),
          "aria-current": l === t.value ? "step" : void 0,
          "data-chapter": a.id
        }, [
          h("span", FTe, [
            l < t.value || i.value ? (g(), Ce(R, {
              key: 0,
              name: "Check",
              size: 10,
              stroke: 3
            })) : (g(), v(H, { key: 1 }, [
              X(A(l + 1), 1)
            ], 64))
          ]),
          h("span", NTe, A(a.label), 1)
        ], 10, BTe))), 128))
      ]),
      h("div", UTe, [
        n.tour.canSkip && !i.value ? (g(), v("button", {
          key: 0,
          class: "ob-skip",
          "data-testid": "tour-skip",
          onClick: r[0] || (r[0] = (a) => n.tour.skip())
        }, A(s.value), 1)) : E("", !0)
      ])
    ]));
  }
}), jTe = {
  key: 0,
  class: "ob-d-brush"
}, HTe = {
  key: 1,
  class: "arrow",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, ia = /* @__PURE__ */ Re({
  __name: "DemoPointer",
  props: {
    p: {},
    brush: { type: Boolean }
  },
  setup(n) {
    const e = n, t = I(() => ({
      opacity: dt(e.p.ring.shown),
      transform: "translate(" + Dt(e.p.ring.x) + "px, " + Dt(e.p.ring.y) + "px) scale(" + dt(e.p.ring.size) + ")"
    })), i = I(() => ({ opacity: dt(e.p.shown), transform: "translate(" + Dt(e.p.x) + "px, " + Dt(e.p.y) + "px)" }));
    return (s, o) => (g(), v(H, null, [
      h("span", {
        class: "bl-hd-ripple",
        style: de(t.value)
      }, null, 4),
      h("span", {
        class: U(["bl-hd-pointer ob-d-pointer", { "is-pressed": n.p.pressed, "is-brush": n.brush }]),
        style: de(i.value)
      }, [
        n.brush ? (g(), v("span", jTe)) : (g(), v("svg", HTe, [...o[0] || (o[0] = [
          h("path", {
            d: "M4 2.5v15.2l3.9-3.7 2.6 6 2.7-1.2-2.6-5.9h5.4z",
            fill: "#fff",
            stroke: "#0b0d14",
            "stroke-width": "1.3",
            "stroke-linejoin": "round"
          }, null, -1)
        ])])),
        Ws(s.$slots, "default")
      ], 6)
    ], 64));
  }
}), VTe = { class: "bl-hd-session-head" }, WTe = { class: "bl-hd-badge" }, qTe = { class: "bl-hd-session-titles" }, KTe = { class: "kind" }, YTe = { class: "model" }, XTe = { class: "name" }, JTe = { class: "bl-hd-count" }, ZTe = ["src"], QTe = { class: "bl-hd-foot" }, Fl = /* @__PURE__ */ Re({
  __name: "DemoCard",
  props: {
    box: {},
    name: { default: "Image Tool 1" },
    model: { default: "Nano Banana Pro" },
    thumbs: { default: () => [] },
    shown: { default: void 0 },
    count: { default: 0 },
    foot: { default: "No runs yet" },
    selected: { default: 0 },
    busy: { type: Boolean, default: !1 }
  },
  setup(n) {
    return (e, t) => (g(), v("div", {
      class: "bl-hd-session ob-d-card",
      style: de({ left: n.box.x + "px", top: n.box.y + "px", width: n.box.w + "px", height: n.box.h + "px" })
    }, [
      h("span", {
        class: "bl-hd-ring",
        style: de({ opacity: m(dt)(n.selected) })
      }, null, 4),
      h("div", VTe, [
        h("span", WTe, [
          C(R, {
            name: "Image",
            size: 17
          })
        ]),
        h("span", qTe, [
          h("span", KTe, [
            t[0] || (t[0] = X("Image", -1)),
            t[1] || (t[1] = h("span", { class: "sep" }, "·", -1)),
            h("span", YTe, A(n.model), 1)
          ]),
          h("span", XTe, A(n.name), 1)
        ]),
        h("span", JTe, A(n.count), 1)
      ]),
      h("div", {
        class: U(["bl-hd-thumbs", { "is-busy": n.busy }])
      }, [
        (g(), v(H, null, me(4, (i) => h("span", {
          key: i,
          class: "bl-hd-thumb is-empty"
        }, [
          n.thumbs[i - 1] ? (g(), v("img", {
            key: 0,
            src: n.thumbs[i - 1],
            alt: "",
            draggable: "false",
            class: "is-in",
            style: de(n.shown ? { opacity: m(dt)(n.shown[i - 1] || 0), transform: "scale(" + m(dt)(0.82 + 0.18 * (n.shown[i - 1] || 0)) + ")" } : void 0)
          }, null, 12, ZTe)) : E("", !0)
        ])), 64))
      ], 2),
      h("div", QTe, A(n.foot), 1)
    ], 4));
  }
}), eMe = { class: "main" }, tMe = { class: "chev" }, nMe = { class: "bl-hd-rail" }, iMe = { class: "is-on" }, gA = /* @__PURE__ */ Re({
  __name: "DemoDock",
  props: {
    box: {},
    lit: { default: 0 },
    shown: { default: 1 }
  },
  setup(n) {
    return (e, t) => (g(), v("div", {
      class: "bl-hd-dock ob-d-dock",
      style: de({ left: n.box.x + "px", top: n.box.y + "px", width: n.box.w + "px", opacity: m(dt)(n.shown), transform: "translateY(" + m(Dt)((1 - n.shown) * 10) + "px)" })
    }, [
      h("span", {
        class: U(["bl-hd-add", { "is-lit": n.lit > 0.3 }])
      }, [
        h("span", eMe, [
          C(R, {
            name: "ImagePlus",
            size: 15
          }),
          t[0] || (t[0] = X("Image Gen", -1))
        ]),
        h("span", tMe, [
          C(R, {
            name: "ChevronDown",
            size: 13
          })
        ])
      ], 2),
      h("span", nMe, [
        h("i", iMe, [
          C(R, {
            name: "MousePointer2",
            size: 15
          })
        ]),
        h("i", null, [
          C(R, {
            name: "Hand",
            size: 15
          })
        ]),
        t[1] || (t[1] = h("b", null, null, -1)),
        h("i", null, [
          C(R, {
            name: "Image",
            size: 15
          })
        ]),
        h("i", null, [
          C(R, {
            name: "StickyNote",
            size: 15
          })
        ]),
        h("i", null, [
          C(R, {
            name: "Frame",
            size: 15
          })
        ])
      ])
    ], 4));
  }
}), sMe = /* @__PURE__ */ Re({
  __name: "DemoSession",
  setup(n) {
    const { bind: e, t, stageStyle: i } = Qs(Is.loop, Is.still), s = I(() => wTe(t.value));
    return (o, r) => (g(), v("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "session"
    }, [
      h("div", {
        class: "ob-demo-stage",
        style: de(m(i))
      }, [
        r[1] || (r[1] = h("div", { class: "ob-demo-canvas" }, null, -1)),
        h("div", {
          class: "ob-d-land",
          style: de({ opacity: m(dt)(s.value.card), transform: "translateY(" + m(Dt)((1 - s.value.card) * -18) + "px) scale(" + m(dt)(0.9 + 0.1 * s.value.card) + ")" })
        }, [
          C(Fl, {
            box: m(Is).card,
            selected: s.value.selected
          }, null, 8, ["box", "selected"])
        ], 4),
        (g(!0), v(H, null, me(m(Is).tags, (a, l) => (g(), v("span", {
          key: a,
          class: "ob-d-tag",
          style: de({ left: m(Is).card.x + m(Is).card.w + 22 + "px", top: m(Is).card.y + 20 + l * 44 + "px", opacity: m(dt)(s.value.tags[l]), transform: "translateX(" + m(Dt)((1 - s.value.tags[l]) * -10) + "px)" })
        }, [
          r[0] || (r[0] = h("i", null, null, -1)),
          X(A(a), 1)
        ], 4))), 128)),
        C(gA, {
          box: m(Is).dock,
          lit: s.value.addLit
        }, null, 8, ["box", "lit"]),
        C(ia, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), oMe = { class: "bl-hd-prompt-side" }, rMe = { class: "ob-d-words" }, aMe = {
  key: 0,
  class: "ph"
}, lMe = { class: "typed" }, dMe = { class: "bl-hd-prompt-foot" }, cMe = { class: "chip" }, uMe = { class: "chip" }, hMe = { class: "step" }, im = /* @__PURE__ */ Re({
  __name: "DemoPrompt",
  props: {
    box: {},
    typed: { default: "" },
    ghost: { default: "" },
    ghostShown: { default: 0 },
    cue: { default: 0 },
    caret: { default: 0 },
    placeholder: { default: "Describe what Image Tool 1 should make" },
    runLit: { default: 0 },
    runPressed: { type: Boolean, default: !1 },
    runBusy: { type: Boolean, default: !1 },
    studio: { type: Boolean, default: !0 },
    studioLit: { default: 0 },
    shown: { default: 1 }
  },
  setup(n) {
    return (e, t) => (g(), v("div", {
      class: "bl-hd-prompt ob-d-prompt",
      style: de({
        left: n.box.x + "px",
        top: n.box.y + "px",
        width: n.box.w + "px",
        height: n.box.h + "px",
        opacity: m(dt)(n.shown),
        visibility: n.shown > 1e-3 ? "visible" : "hidden",
        transform: "translateY(" + m(Dt)((1 - n.shown) * 16) + "px)"
      })
    }, [
      h("span", oMe, [
        h("i", null, [
          C(R, {
            name: "LayoutTemplate",
            size: 15
          })
        ]),
        h("i", null, [
          C(R, {
            name: "Pipette",
            size: 15
          })
        ])
      ]),
      n.studio ? (g(), v("span", {
        key: 0,
        class: U(["ob-d-pill", { "is-lit": n.studioLit > 0.5 }])
      }, [
        C(R, {
          name: "Expand",
          size: 12
        }),
        t[0] || (t[0] = X("Studio", -1))
      ], 2)) : E("", !0),
      h("span", rMe, [
        !n.typed && !n.ghost ? (g(), v("span", aMe, A(n.placeholder), 1)) : E("", !0),
        n.ghost && !n.typed ? (g(), v("span", {
          key: 1,
          class: "ghost",
          style: de({ opacity: m(dt)(n.ghostShown) })
        }, A(n.ghost), 5)) : E("", !0),
        h("span", lMe, A(n.typed), 1),
        h("span", {
          class: "caret",
          style: de({ opacity: m(dt)(n.caret) })
        }, null, 4)
      ]),
      n.cue > 0.01 ? (g(), v("span", {
        key: 1,
        class: "ob-d-cue",
        style: de({ opacity: m(dt)(n.cue) })
      }, [...t[1] || (t[1] = [
        h("kbd", null, "Tab", -1),
        X(" to write it in", -1)
      ])], 4)) : E("", !0),
      h("span", dMe, [
        h("span", cMe, [
          t[2] || (t[2] = h("small", null, "Model", -1)),
          t[3] || (t[3] = X("Nano Banana Pro", -1)),
          C(R, {
            name: "ChevronDown",
            size: 12
          })
        ]),
        h("span", uMe, [
          C(R, {
            name: "RectangleVertical",
            size: 12
          }),
          t[4] || (t[4] = X("896×1152", -1))
        ]),
        t[6] || (t[6] = h("span", { class: "sp" }, null, -1)),
        h("span", hMe, [
          C(R, {
            name: "Minus",
            size: 11
          }),
          t[5] || (t[5] = h("b", null, "4", -1)),
          C(R, {
            name: "Plus",
            size: 11
          })
        ]),
        h("span", {
          class: U(["run", { "is-lit": n.runLit > 0.5, "is-pressed": n.runPressed, "is-busy": n.runBusy }]),
          style: { width: "62px" }
        }, A(n.runBusy ? "Running" : "Run"), 3)
      ])
    ], 4));
  }
}), pMe = /* @__PURE__ */ Re({
  __name: "DemoOpen",
  setup(n) {
    const { bind: e, t, stageStyle: i } = Qs(Ba.loop, Ba.still), s = I(() => kTe(t.value));
    return (o, r) => (g(), v("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "open"
    }, [
      h("div", {
        class: "ob-demo-stage",
        style: de(m(i))
      }, [
        r[0] || (r[0] = h("div", { class: "ob-demo-canvas" }, null, -1)),
        C(Fl, {
          box: m(Ba).card,
          selected: s.value.selected
        }, null, 8, ["box", "selected"]),
        C(gA, {
          box: m(Ba).dock,
          shown: 1 - s.value.prompt
        }, null, 8, ["box", "shown"]),
        C(im, {
          box: m(Ba).prompt,
          shown: s.value.prompt,
          caret: s.value.prompt > 0.9 ? 1 : 0,
          studio: !1
        }, null, 8, ["box", "shown", "caret"]),
        C(ia, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), fMe = /* @__PURE__ */ Re({
  __name: "DemoPromptTab",
  setup(n) {
    const { bind: e, t, stageStyle: i } = Qs(po.loop, po.still), s = I(() => STe(t.value));
    return (o, r) => (g(), v("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "prompt"
    }, [
      h("div", {
        class: "ob-demo-stage",
        style: de(m(i))
      }, [
        r[1] || (r[1] = h("div", { class: "ob-demo-canvas" }, null, -1)),
        h("div", {
          style: de({ opacity: m(dt)(s.value.fade) })
        }, [
          C(im, {
            box: m(po).prompt,
            class: "is-big",
            typed: s.value.typed,
            ghost: m(Gc),
            "ghost-shown": s.value.ghost,
            cue: s.value.cue,
            caret: s.value.caret,
            "run-lit": s.value.runLit,
            studio: !1
          }, null, 8, ["box", "typed", "ghost", "ghost-shown", "cue", "caret", "run-lit"])
        ], 4),
        h("span", {
          class: U(["ob-d-keycap", { "is-down": s.value.keyDown }]),
          style: de({ left: m(po).key.x + "px", top: m(po).key.y + "px", width: m(po).key.w + "px", height: m(po).key.h + "px", opacity: m(dt)(s.value.key), transform: "translateY(" + m(Dt)((1 - s.value.key) * 8) + "px)" })
        }, [...r[0] || (r[0] = [
          h("span", null, "Tab", -1),
          h("i", null, "⇥", -1)
        ])], 6)
      ], 4)
    ], 512));
  }
}), mMe = { class: "grid" }, gMe = ["src"], bA = /* @__PURE__ */ Re({
  __name: "DemoGallery",
  props: {
    box: {},
    shown: { default: 1 },
    lifted: { default: -1 }
  },
  setup(n) {
    return (e, t) => (g(), v("div", {
      class: "ob-d-gallery",
      style: de({ left: n.box.x + "px", top: n.box.y + "px", width: n.box.w + "px", height: n.box.h + "px", opacity: m(dt)(n.shown), transform: "translateX(" + m(Dt)((1 - n.shown) * 60) + "px)" })
    }, [
      t[0] || (t[0] = h("div", { class: "head" }, [
        h("b", null, "4"),
        X(" Image Tool 1")
      ], -1)),
      h("div", mMe, [
        (g(!0), v(H, null, me(m(Gn), (i, s) => (g(), v("span", {
          key: i,
          class: U(["cell", { "is-lifted": s === n.lifted }])
        }, [
          h("img", {
            src: i,
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, gMe)
        ], 2))), 128))
      ])
    ], 4));
  }
}), bMe = /* @__PURE__ */ Re({
  __name: "DemoRun",
  setup(n) {
    const { bind: e, t, stageStyle: i } = Qs(Fa.loop, Fa.still), s = I(() => TTe(t.value));
    return (o, r) => (g(), v("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "run"
    }, [
      h("div", {
        class: "ob-demo-stage",
        style: de(m(i))
      }, [
        r[0] || (r[0] = h("div", { class: "ob-demo-canvas" }, null, -1)),
        C(Fl, {
          box: m(Fa).card,
          thumbs: m(Gn),
          shown: s.value.thumbs,
          count: s.value.count,
          foot: s.value.foot,
          busy: s.value.busy,
          selected: 1
        }, null, 8, ["box", "thumbs", "shown", "count", "foot", "busy"]),
        C(im, {
          box: m(Fa).prompt,
          typed: m(Gc),
          "run-lit": 1,
          "run-pressed": s.value.runPressed,
          "run-busy": s.value.busy,
          studio: !1
        }, null, 8, ["box", "typed", "run-pressed", "run-busy"]),
        C(bA, {
          box: m(Fa).gallery,
          shown: s.value.gallery
        }, null, 8, ["box", "shown"]),
        C(ia, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), vMe = ["src"], yMe = ["src"], xMe = /* @__PURE__ */ Re({
  __name: "DemoDrag",
  setup(n) {
    const { bind: e, t, stageStyle: i } = Qs(fi.loop, fi.still), s = I(() => MTe(t.value));
    return (o, r) => (g(), v("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "drag"
    }, [
      h("div", {
        class: "ob-demo-stage",
        style: de(m(i))
      }, [
        r[0] || (r[0] = h("div", { class: "ob-demo-canvas" }, null, -1)),
        C(Fl, {
          box: m(fi).card,
          thumbs: m(Gn),
          count: 4,
          foot: "Updated just now",
          selected: 1
        }, null, 8, ["box", "thumbs"]),
        h("span", {
          class: "ob-d-slot",
          style: de({ left: m(fi).drop.x + "px", top: m(fi).drop.y + "px", width: m(fi).drop.w + "px", height: m(fi).drop.h + "px", opacity: m(dt)(s.value.slot) })
        }, null, 4),
        h("div", {
          class: "bl-hd-pic ob-d-placed",
          style: de({ left: m(fi).drop.x + "px", top: m(fi).drop.y + "px", width: m(fi).drop.w + "px", height: m(fi).drop.h + "px", opacity: m(dt)(s.value.placed), transform: "scale(" + m(dt)(1.05 - 0.05 * s.value.placed) + ")" })
        }, [
          h("img", {
            src: m(Gn)[0],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, vMe)
        ], 4),
        C(bA, {
          box: m(fi).gallery,
          lifted: s.value.ghost.shown > 0.05 ? 0 : -1
        }, null, 8, ["box", "lifted"]),
        h("span", {
          class: "bl-hd-ghost ob-d-ghost",
          style: de({ opacity: m(dt)(s.value.ghost.shown), transform: "translate(" + m(Dt)(s.value.ghost.x - 26) + "px, " + m(Dt)(s.value.ghost.y - 30) + "px) rotate(" + m(Dt)(s.value.ghost.tilt) + "deg)" })
        }, [
          h("img", {
            src: m(Gn)[0],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, yMe)
        ], 4),
        C(ia, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), wMe = { class: "back" }, kMe = { class: "crumb" }, _Me = { class: "chip" }, SMe = { class: "x" }, TMe = { class: "tabs" }, MMe = { class: "v on" }, CMe = ["src"], IMe = {
  key: 0,
  class: "v is-new"
}, AMe = ["src"], PMe = ["src"], EMe = ["src"], RMe = ["src"], vA = /* @__PURE__ */ Re({
  __name: "DemoStudioView",
  props: {
    side: { default: "generate" },
    parts: { default: 1 },
    wipe: { default: -1 },
    versions: { default: 1 },
    busy: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = [
      { icon: "Wand2", label: "Prompt" },
      { icon: "Sparkles", label: "Upscale" },
      { icon: "Lightbulb", label: "Relight" },
      { icon: "Camera", label: "Change camera" },
      { icon: "Layers", label: "Background" }
    ];
    return (t, i) => (g(), v("div", {
      class: U(["ob-d-studio", "is-" + n.side])
    }, [
      h("div", {
        class: "top",
        style: de({ opacity: m(dt)(n.parts) })
      }, [
        h("span", wMe, [
          C(R, {
            name: "ArrowLeft",
            size: 13
          })
        ]),
        h("span", kMe, [
          h("small", null, A(n.side === "edit" ? "Edit" : "Generate"), 1),
          i[0] || (i[0] = X("Image Tool 1", -1))
        ]),
        h("span", _Me, [
          C(R, {
            name: "Image",
            size: 11
          }),
          i[1] || (i[1] = X("Session", -1))
        ]),
        h("span", SMe, [
          C(R, {
            name: "X",
            size: 13
          })
        ])
      ], 4),
      h("div", {
        class: "tools",
        style: de({ opacity: m(dt)(n.parts), transform: "translateX(" + m(Dt)((1 - n.parts) * -14) + "px)" })
      }, [
        h("div", TMe, [
          h("span", {
            class: U({ on: n.side === "generate" })
          }, "Generate", 2),
          h("span", {
            class: U({ on: n.side === "edit" })
          }, "Edit", 2)
        ]),
        (g(), v(H, null, me(e, (s, o) => h("div", {
          key: s.label,
          class: U(["row", { on: o === 0 }])
        }, [
          C(R, {
            name: s.icon,
            size: 12
          }, null, 8, ["name"]),
          X(A(s.label), 1)
        ], 2)), 64))
      ], 4),
      h("div", {
        class: "versions",
        style: de({ opacity: m(dt)(n.parts) })
      }, [
        h("span", MMe, [
          h("img", {
            src: m(Gn)[0],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, CMe)
        ]),
        n.versions > 1 ? (g(), v("span", IMe, [
          h("img", {
            src: m(gf),
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, AMe)
        ])) : E("", !0)
      ], 4),
      h("div", {
        class: U(["stage", { "is-busy": n.busy }]),
        style: de({ opacity: m(dt)(n.parts), transform: "scale(" + m(dt)(0.94 + 0.06 * n.parts) + ")" })
      }, [
        h("img", {
          src: m(Gn)[0],
          alt: "",
          draggable: "false",
          class: "is-in"
        }, null, 8, PMe),
        n.wipe >= 0 ? (g(), v("img", {
          key: 0,
          src: m(gf),
          alt: "",
          draggable: "false",
          class: "is-in night",
          style: de({ clipPath: "inset(0 " + m(Dt)((1 - n.wipe) * 100) + "% 0 0)" })
        }, null, 12, EMe)) : E("", !0),
        n.wipe > 0 && n.wipe < 1 ? (g(), v("span", {
          key: 1,
          class: "seam",
          style: de({ left: m(Dt)(n.wipe * 100) + "%" })
        }, null, 4)) : E("", !0),
        Ws(t.$slots, "stage")
      ], 6),
      h("div", {
        class: "hist",
        style: de({ opacity: m(dt)(n.parts), transform: "translateX(" + m(Dt)((1 - n.parts) * 14) + "px)" })
      }, [
        (g(!0), v(H, null, me(m(Gn), (s) => (g(), v("span", {
          key: s,
          class: "h"
        }, [
          h("img", {
            src: s,
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, RMe)
        ]))), 128))
      ], 4),
      Ws(t.$slots, "default")
    ], 2));
  }
}), zMe = /* @__PURE__ */ Re({
  __name: "DemoStudio",
  setup(n) {
    const { bind: e, t, stageStyle: i } = Qs(As.loop, As.still), s = I(() => CTe(t.value)), o = As.pill.x + As.pill.w / 2 + "px " + (As.pill.y + As.pill.h / 2) + "px";
    return (r, a) => (g(), v("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "studio"
    }, [
      h("div", {
        class: "ob-demo-stage",
        style: de(m(i))
      }, [
        a[0] || (a[0] = h("div", { class: "ob-demo-canvas" }, null, -1)),
        C(Fl, {
          box: m(As).card,
          thumbs: m(Gn),
          count: 4,
          foot: "Updated just now",
          selected: 1
        }, null, 8, ["box", "thumbs"]),
        C(im, {
          box: m(As).prompt,
          typed: m(Gc),
          "run-lit": 1,
          "studio-lit": s.value.pillLit
        }, null, 8, ["box", "typed", "studio-lit"]),
        h("div", {
          class: "ob-d-studio-wrap",
          style: de({ opacity: m(dt)(Math.min(1, s.value.open * 1.6)), transform: "scale(" + m(dt)(0.12 + 0.88 * s.value.open) + ")", transformOrigin: o, visibility: s.value.open > 1e-3 ? "visible" : "hidden", borderRadius: m(Dt)(28 * (1 - s.value.open) + 4) + "px" })
        }, [
          C(vA, {
            parts: s.value.parts
          }, null, 8, ["parts"])
        ], 4),
        C(ia, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), $Me = ["d", "stroke-dashoffset"], DMe = { class: "words" }, OMe = {
  key: 0,
  class: "ph"
}, LMe = { class: "typed" }, z4 = 420, BMe = /* @__PURE__ */ Re({
  __name: "DemoEdit",
  setup(n) {
    const { bind: e, t, stageStyle: i } = Qs(fo.loop, fo.still), s = I(() => ITe(t.value));
    return (o, r) => (g(), v("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "edit"
    }, [
      h("div", {
        class: "ob-demo-stage",
        style: de(m(i))
      }, [
        r[0] || (r[0] = h("div", { class: "ob-demo-canvas" }, null, -1)),
        C(vA, {
          side: "edit",
          wipe: s.value.wipe > 0 ? s.value.wipe : -1,
          versions: s.value.versions,
          busy: s.value.busy
        }, null, 8, ["wipe", "versions", "busy"]),
        (g(), v("svg", {
          class: "ob-d-paint",
          viewBox: "0 0 640 360",
          width: "640",
          height: "360",
          style: de({ opacity: m(dt)(s.value.area) })
        }, [
          h("path", {
            d: m(fo).stroke,
            fill: "none",
            stroke: "rgba(174, 134, 229, 0.62)",
            "stroke-width": "16",
            "stroke-linecap": "round",
            "stroke-dasharray": z4,
            "stroke-dashoffset": z4 * (1 - s.value.painted)
          }, null, 8, $Me)
        ], 4)),
        h("div", {
          class: "ob-d-editbar",
          style: de({ left: m(fo).bar.x + "px", top: m(fo).bar.y + "px", width: m(fo).bar.w + "px", height: m(fo).bar.h + "px" })
        }, [
          h("span", DMe, [
            s.value.typed ? E("", !0) : (g(), v("span", OMe, "Say what to change")),
            h("span", LMe, A(s.value.typed), 1)
          ]),
          h("span", {
            class: U(["run", { "is-lit": !!s.value.typed, "is-busy": s.value.busy }])
          }, A(s.value.busy ? "Running" : "Run"), 3)
        ], 4),
        C(ia, {
          p: s.value.pointer,
          brush: s.value.brush
        }, null, 8, ["p", "brush"])
      ], 4)
    ], 512));
  }
}), FMe = ["src"], NMe = ["src"], UMe = { class: "head" }, GMe = { class: "mark" }, jMe = { class: "head" }, HMe = { class: "mark" }, VMe = { class: "lines" }, WMe = { class: "eyebrow" }, qMe = { class: "sess" }, KMe = { class: "words" }, YMe = {
  key: 0,
  class: "ph"
}, XMe = { class: "typed" }, JMe = /* @__PURE__ */ Re({
  __name: "DemoChat",
  setup(n) {
    const { bind: e, t, stageStyle: i } = Qs(An.loop, An.still), s = I(() => ETe(t.value)), o = (a) => ({ left: a.x + "px", top: a.y + "px", width: a.w + "px", height: a.h + "px" }), r = (a) => o({ x: a.x - An.panel.x, y: a.y - An.panel.y, w: a.w, h: a.h });
    return (a, l) => (g(), v("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "chat"
    }, [
      h("div", {
        class: "ob-demo-stage",
        style: de(m(i))
      }, [
        l[11] || (l[11] = h("div", { class: "ob-demo-canvas" }, null, -1)),
        h("div", {
          class: "ob-d-frame is-drawn ob-d-chatframe",
          style: de({ ...o(m(An).frame), "--glow": m(dt)(s.value.glow), "--sel": m(dt)(s.value.selected) })
        }, [...l[0] || (l[0] = [
          h("span", { class: "title" }, "Site photos", -1)
        ])], 4),
        (g(!0), v(H, null, me(m(An).photos, (d, c) => (g(), v("div", {
          key: "p" + c,
          class: "bl-hd-pic",
          style: de(o(d))
        }, [
          h("img", {
            src: m(ATe)[c],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, FMe)
        ], 4))), 128)),
        (g(!0), v(H, null, me(m(An).finished, (d, c) => (g(), v("div", {
          key: "f" + c,
          class: "bl-hd-pic ob-d-finished",
          style: de({ ...o(d), opacity: m(dt)(s.value.finished[c]), transform: "translateY(" + m(Dt)((1 - s.value.finished[c]) * 10) + "px) scale(" + m(dt)(0.94 + 0.06 * s.value.finished[c]) + ")" })
        }, [
          h("img", {
            src: m(PTe)[c],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, NMe)
        ], 4))), 128)),
        h("div", {
          class: "ob-d-chatcard",
          style: de({ ...o(m(An).card), opacity: m(dt)(s.value.card), transform: "scale(" + m(dt)(0.9 + 0.1 * s.value.card) + ")" })
        }, [
          h("span", UMe, [
            h("span", GMe, [
              C(R, {
                name: "MessagesSquare",
                size: 11
              })
            ]),
            l[1] || (l[1] = h("span", { class: "n" }, "Chat 1", -1))
          ]),
          l[2] || (l[2] = h("span", { class: "line" }, null, -1)),
          l[3] || (l[3] = h("span", { class: "line is-short" }, null, -1))
        ], 4),
        h("div", {
          class: "ob-d-ctxbar",
          style: de({ ...o(m(An).bar), opacity: m(dt)(s.value.bar) })
        }, [
          h("span", {
            class: U(["chat", { "is-lit": s.value.chatLit > 0.01 }])
          }, [
            C(R, {
              name: "MessageSquarePlus",
              size: 10
            }),
            l[4] || (l[4] = X("Chat", -1))
          ], 2),
          l[5] || (l[5] = h("span", { class: "ic" }, null, -1)),
          l[6] || (l[6] = h("span", { class: "ic" }, null, -1)),
          l[7] || (l[7] = h("span", { class: "ic" }, null, -1))
        ], 4),
        h("div", {
          class: "ob-d-chat",
          style: de({ ...o(m(An).panel), opacity: m(dt)(s.value.panel), transform: "translateX(" + m(Dt)((1 - s.value.panel) * 44) + "px)" })
        }, [
          h("div", jMe, [
            h("span", HMe, [
              C(R, {
                name: "MessagesSquare",
                size: 11
              })
            ]),
            l[8] || (l[8] = h("span", { class: "t" }, [
              h("b", null, "Chat 1"),
              h("small", null, "in Site photos · 3 in context")
            ], -1))
          ]),
          h("div", {
            class: "bubble",
            style: de({ ...r(m(An).bubble), opacity: m(dt)(s.value.bubble), transform: "translateY(" + m(Dt)((1 - s.value.bubble) * 10) + "px)" })
          }, A(m(mA)), 5),
          h("div", {
            class: "answer",
            style: de(r(m(An).answer))
          }, [
            h("span", {
              class: U(["ai", { "is-busy": s.value.thinking }]),
              style: de({ opacity: m(dt)(s.value.thinking || s.value.answer > 0 ? 1 : 0) })
            }, [
              C(R, {
                name: "Sparkles",
                size: 9
              })
            ], 6),
            h("span", VMe, [
              h("i", {
                style: de({ width: m(Dt)(100 * Math.min(1, s.value.answer * 1.6)) + "%" })
              }, null, 4),
              h("i", {
                style: de({ width: m(Dt)(72 * Math.max(0, s.value.answer * 1.6 - 0.6)) + "%" })
              }, null, 4)
            ])
          ], 4),
          h("div", {
            class: "plan",
            style: de({ ...r(m(An).plan), opacity: m(dt)(s.value.plan), transform: "translateY(" + m(Dt)((1 - s.value.plan) * 8) + "px)" })
          }, [
            h("span", WMe, A(s.value.busy || s.value.done ? "Plan" : "Proposed plan") + " · 3 runs", 1),
            l[10] || (l[10] = h("span", { class: "ttl" }, "The finished tower", -1)),
            h("span", qMe, [
              C(R, {
                name: "Image",
                size: 10
              }),
              l[9] || (l[9] = X("Nano Banana Pro · 3 photos", -1))
            ])
          ], 4),
          h("span", {
            class: U(["run", { "is-lit": s.value.runLit > 0.01, "is-busy": s.value.busy, "is-done": s.value.done }]),
            style: de({ ...r(m(An).run), opacity: m(dt)(s.value.plan) })
          }, [
            C(R, {
              name: s.value.done ? "CircleCheck" : "Play",
              size: 9
            }, null, 8, ["name"]),
            X(A(s.value.done ? "Done" : s.value.busy ? "Running" : "Run plan"), 1)
          ], 6),
          h("div", {
            class: "composer",
            style: de(r(m(An).composer))
          }, [
            h("span", KMe, [
              s.value.typed ? E("", !0) : (g(), v("span", YMe, "Ask about these 3 images…")),
              h("span", XMe, A(s.value.typed), 1)
            ])
          ], 4),
          h("span", {
            class: U(["send", { "is-lit": s.value.sendLit > 0.01 }]),
            style: de(r(m(An).send))
          }, [
            C(R, {
              name: "ArrowUp",
              size: 11
            })
          ], 6)
        ], 4),
        C(ia, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), ZMe = {
  key: 0,
  class: "title"
}, QMe = ["src"], eCe = { class: "text" }, tCe = /* @__PURE__ */ Re({
  __name: "DemoOrganize",
  setup(n) {
    const { bind: e, t, stageStyle: i } = Qs(xn.loop, xn.still), s = I(() => RTe(t.value)), o = [Gn[0], gf, Gn[2]];
    return (r, a) => (g(), v("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "organize"
    }, [
      h("div", {
        class: "ob-demo-stage",
        style: de(m(i))
      }, [
        a[1] || (a[1] = h("div", { class: "ob-demo-canvas" }, null, -1)),
        h("div", {
          class: "ob-d-world",
          style: de({ transform: "scale(" + m(dt)(s.value.zoom) + ")" })
        }, [
          h("div", {
            class: U(["ob-d-frame", { "is-drawn": s.value.frame >= 1 }]),
            style: de({ left: m(xn).frame.x + "px", top: m(xn).frame.y + "px", width: m(Dt)(m(xn).frame.w * s.value.frame) + "px", height: m(Dt)(m(xn).frame.h * s.value.frame) + "px", opacity: s.value.frame > 0.01 ? 1 : 0 })
          }, [
            s.value.title ? (g(), v("span", ZMe, A(s.value.title), 1)) : E("", !0)
          ], 6),
          C(Fl, {
            box: m(xn).card,
            thumbs: [m(Gn)[0], m(gf), m(Gn)[2], m(Gn)[3]],
            count: 5,
            foot: "Updated just now"
          }, null, 8, ["box", "thumbs"]),
          (g(!0), v(H, null, me(m(xn).pics, (l, d) => (g(), v("div", {
            key: d,
            class: "bl-hd-pic",
            style: de({ left: l.x + "px", top: l.y + "px", width: l.w + "px", height: l.h + "px" })
          }, [
            h("img", {
              src: o[d],
              alt: "",
              draggable: "false",
              class: "is-in"
            }, null, 8, QMe)
          ], 4))), 128)),
          h("div", {
            class: "bl-hd-note is-amber ob-d-note",
            style: de({ left: m(xn).note.x + "px", top: m(xn).note.y + "px", width: m(xn).note.w + "px", height: m(xn).note.h + "px", opacity: m(dt)(s.value.note), transform: "translateY(" + m(Dt)((1 - s.value.note) * -16) + "px) rotate(" + m(Dt)((1 - s.value.note) * -4) + "deg)" })
          }, [
            h("span", eCe, A(m(xn).noteText), 1),
            a[0] || (a[0] = h("span", { class: "meta" }, "MT", -1))
          ], 4),
          h("span", {
            class: "ob-d-pin",
            style: de({ left: m(xn).pin.x + "px", top: m(xn).pin.y + "px", opacity: m(dt)(s.value.pin), transform: "scale(" + m(dt)(0.4 + 0.6 * s.value.pin) + ")" })
          }, "JR", 4),
          h("span", {
            class: "ob-d-bubble",
            style: de({ left: m(xn).pin.x + 30 + "px", top: m(xn).pin.y - 6 + "px", opacity: m(dt)(s.value.bubble), transform: "translateX(" + m(Dt)((1 - s.value.bubble) * -8) + "px)" })
          }, A(m(xn).comment), 5)
        ], 4)
      ], 4)
    ], 512));
  }
}), nCe = ["aria-label", "data-step"], iCe = { class: "ob-tag" }, sCe = { class: "ob-body" }, oCe = { class: "ob-words-stack" }, rCe = {
  key: 0,
  class: "ob-note",
  "data-testid": "tour-note"
}, aCe = { class: "ob-tick" }, lCe = { class: "ob-note-words" }, dCe = {
  key: 0,
  class: "ob-key"
}, cCe = { class: "ob-title" }, uCe = { class: "ob-text" }, hCe = { class: "ob-tick" }, pCe = { class: "ob-task-words" }, fCe = {
  key: 0,
  class: "ob-key"
}, mCe = {
  key: 1,
  class: "ob-chip"
}, gCe = { class: "ob-foot" }, bCe = ["aria-label"], vCe = ["disabled"], yCe = /* @__PURE__ */ Re({
  __name: "CoachCard",
  props: {
    tour: {},
    x: {},
    y: {},
    wide: { type: Boolean },
    short: { type: Boolean }
  },
  emits: ["size"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = {
      session: sMe,
      open: pMe,
      prompt: fMe,
      run: bMe,
      drag: xMe,
      studio: zMe,
      edit: BMe,
      chat: JMe,
      organize: tCe
    }, o = { board: "LayoutDashboard", session: "Image", generate: "Sparkles", studio: "Expand", edit: "Wand2", chat: "MessagesSquare", finish: "Check" }, r = I(() => t.tour.step.value), a = I(() => t.tour.phase.value), l = I(() => t.tour.waiting.value), d = I(() => r.value.demo && s[r.value.demo] || null), c = I(() => Wy.find((P) => P.id === r.value.chapter)), u = I(() => ts.filter((P) => P.chapter === r.value.chapter && P.id !== "finale")), p = I(() => u.value.findIndex((P) => P.id === r.value.id)), f = I(() => {
      const P = r.value;
      return a.value === "success" && P.landed ? { key: "landed", ...P.landed } : l.value && P.waiting ? { key: "wait", ...P.waiting } : { key: "step", title: P.title, body: P.body };
    }), y = I(() => f.value.title), b = I(() => f.value.body), w = I(() => r.value.task ? P4(r.value.task) : []), k = /* @__PURE__ */ new Set(["Tab", "Esc", "Enter"]), S = I(() => r.value.kind === "run" && !w.value.some((P) => P.strong && k.has(P.text))), _ = I(() => r.value.note ? P4(r.value.note.how) : []), x = dn(["mod", "enter"]), T = /* @__PURE__ */ K(0);
    $e(() => t.tour.nudges.value, () => {
      T.value++;
    });
    const M = /* @__PURE__ */ K(null);
    let z = null;
    return $e(M, (P, D) => {
      z && D && z.unobserve(D), P && (z || (z = new ResizeObserver(() => {
        M.value && i("size", { w: M.value.offsetWidth, h: M.value.offsetHeight });
      })), z.observe(P), i("size", { w: P.offsetWidth, h: P.offsetHeight }));
    }), (P, D) => (g(), v("div", {
      ref_key: "card",
      ref: M,
      class: U(["ob-card", { "has-demo": !!d.value, "is-wide": n.wide, "is-short": n.short && !!d.value, "is-entering": a.value === "enter", "is-done": a.value === "success", "is-waiting": l.value }]),
      style: de({ transform: "translate3d(" + Math.round(n.x) + "px, " + Math.round(n.y) + "px, 0)" }),
      role: "dialog",
      "aria-live": "polite",
      "aria-label": r.value.title,
      "data-tour-ui": "",
      "data-testid": "tour-card",
      "data-step": r.value.id
    }, [
      C(vt, {
        name: "ob-media",
        mode: "out-in"
      }, {
        default: et(() => [
          d.value ? (g(), v("div", {
            key: r.value.demo,
            class: "ob-media"
          }, [
            (g(), Ce(Yr(d.value))),
            h("span", iCe, [
              C(R, {
                name: o[c.value.id] || "Sparkles",
                size: 10
              }, null, 8, ["name"]),
              X(A(c.value.label), 1)
            ])
          ])) : E("", !0)
        ]),
        _: 1
      }),
      h("div", sCe, [
        h("div", oCe, [
          C(vt, { name: "ob-words" }, {
            default: et(() => [
              (g(), v("div", {
                key: r.value.id + ":" + f.value.key,
                class: "ob-words"
              }, [
                r.value.note ? (g(), v("div", rCe, [
                  h("span", aCe, [
                    C(R, {
                      name: "Check",
                      size: 11,
                      stroke: 3
                    })
                  ]),
                  h("span", lCe, [
                    h("b", null, A(r.value.note.did), 1),
                    h("span", null, [
                      (g(!0), v(H, null, me(_.value, ($, O) => (g(), v(H, { key: O }, [
                        $.strong ? (g(), v("kbd", dCe, A($.text), 1)) : (g(), v(H, { key: 1 }, [
                          X(A($.text), 1)
                        ], 64))
                      ], 64))), 128))
                    ])
                  ])
                ])) : E("", !0),
                h("b", cCe, A(y.value), 1),
                h("span", uCe, A(b.value), 1)
              ]))
            ]),
            _: 1
          })
        ]),
        r.value.kind !== "continue" ? (g(), v("div", {
          key: "task" + T.value,
          class: U(["ob-task", { "is-shaking": T.value > 0 && a.value === "task" }]),
          "data-testid": "tour-task"
        }, [
          a.value === "success" ? (g(), v(H, { key: 0 }, [
            h("span", hCe, [
              C(R, {
                name: "Check",
                size: 12,
                stroke: 3
              })
            ]),
            D[1] || (D[1] = h("span", null, "Nice", -1))
          ], 64)) : l.value ? (g(), v(H, { key: 1 }, [
            D[2] || (D[2] = h("span", { class: "ob-spin" }, null, -1)),
            D[3] || (D[3] = h("span", null, "Working on it", -1))
          ], 64)) : (g(), v(H, { key: 2 }, [
            D[5] || (D[5] = h("span", { class: "ob-dot" }, null, -1)),
            h("span", pCe, [
              (g(!0), v(H, null, me(w.value, ($, O) => (g(), v(H, { key: O }, [
                $.strong && m(k).has($.text) ? (g(), v("kbd", fCe, A($.text), 1)) : $.strong ? (g(), v("span", mCe, A($.text), 1)) : (g(), v(H, { key: 2 }, [
                  X(A($.text), 1)
                ], 64))
              ], 64))), 128)),
              S.value ? (g(), v(H, { key: 0 }, [
                D[4] || (D[4] = X(" or press ", -1)),
                (g(!0), v(H, null, me(m(x), ($) => (g(), v("kbd", {
                  key: $,
                  class: "ob-key"
                }, A($), 1))), 128))
              ], 64)) : E("", !0)
            ])
          ], 64))
        ], 2)) : E("", !0),
        n.tour.nudgeHint.value && a.value === "task" && r.value.kind !== "continue" ? (g(), v("div", {
          key: "hint" + T.value,
          class: "ob-hint",
          "data-testid": "tour-hint"
        }, A(n.tour.nudgeHint.value), 1)) : E("", !0),
        h("div", gCe, [
          h("span", {
            class: "ob-steps",
            "aria-label": "Step " + (p.value + 1) + " of " + u.value.length + " in " + c.value.label
          }, [
            (g(!0), v(H, null, me(u.value, ($, O) => (g(), v("i", {
              key: $.id,
              class: U({ on: O === p.value, done: O < p.value || O === p.value && a.value === "success" })
            }, null, 2))), 128))
          ], 8, bCe),
          r.value.kind === "continue" ? (g(), v("button", {
            key: 0,
            class: "ob-btn",
            disabled: a.value !== "task",
            "data-testid": "tour-continue",
            onClick: D[0] || (D[0] = ($) => n.tour.next())
          }, [...D[6] || (D[6] = [
            X(" Continue", -1),
            h("kbd", { class: "ob-key is-on-btn" }, "↵", -1)
          ])], 8, vCe)) : E("", !0)
        ])
      ])
    ], 14, nCe));
  }
}), xCe = {
  class: "licon",
  "aria-hidden": "true",
  style: { display: "inline-flex", flex: "none" }
}, Zt = /* @__PURE__ */ Re({
  __name: "LIcon",
  props: {
    name: {},
    size: { default: 16 },
    stroke: { default: 2 }
  },
  setup(n) {
    const e = {
      ArrowDown: T9,
      ArrowUp: _3,
      ArrowUpDown: P9,
      ArrowUpRight: k3,
      Check: S3,
      ChevronDown: T3,
      ChevronLeft: M3,
      ChevronRight: C3,
      CircleAlert: Kb,
      CircleCheck: I3,
      Copy: P3,
      Download: E3,
      Ellipsis: R3,
      ExternalLink: z3,
      Globe: D3,
      Image: F3,
      LayoutGrid: N3,
      Lock: j3,
      Minus: V3,
      Pencil: q3,
      Plus: X3,
      RefreshCw: O7,
      Search: Z3,
      ShieldCheck: fD,
      SlidersHorizontal: e6,
      Sparkles: Yb,
      StickyNote: n6,
      Table2: OD,
      Trash2: i6,
      UserRound: rO,
      Users: o6,
      Wand2: a6,
      X: l6,
      // Edit and Access Settings
      ArrowRight: w3,
      CircleMinus: gR,
      CircleX: A3,
      Link: h$,
      LoaderCircle: G3,
      UserCheck: tO,
      UserPlus: s6,
      UserRoundCog: sO,
      // the hero's demo window
      Frame: $3,
      Hand: O3,
      Heart: L3,
      ImagePlus: B3,
      LayoutTemplate: U3,
      Maximize2: H3,
      MousePointer2: W3,
      Pause: m7,
      Pipette: K3,
      Play: Y3,
      RectangleVertical: J3,
      Settings: Q3,
      Square: t6,
      Video: r6,
      // the hero's Take the tour (IL-095), and its minimize (IL-108)
      CirclePlay: vR,
      Minimize2: j$
    }, t = n, i = I(() => e[t.name] || Yb);
    return (s, o) => (g(), v("span", xCe, [
      (g(), Ce(Yr(i.value), {
        size: n.size,
        "stroke-width": n.stroke
      }, null, 8, ["size", "stroke-width"]))
    ]));
  }
});
function wCe() {
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return !1;
  }
}
function kCe() {
  const n = /* @__PURE__ */ K(wCe());
  let e = null;
  const t = () => {
    n.value = !!e && e.matches;
  };
  return ot(() => {
    try {
      e = window.matchMedia("(prefers-reduced-motion: reduce)"), e.addEventListener("change", t);
    } catch {
      e = null;
    }
  }), Ve(() => {
    e && e.removeEventListener("change", t);
  }), n;
}
const _Ce = ["viewBox"], SCe = ["d", "fill"], TCe = { class: "bl-hd-canvas" }, MCe = { class: "bl-hd-ftitle" }, CCe = { key: 1 }, ICe = { class: "bl-hd-flabel" }, ACe = ["src", "fetchpriority"], PCe = {
  key: 0,
  class: "bl-hd-play"
}, ECe = ["src"], RCe = { class: "bl-hd-session-head" }, zCe = { class: "bl-hd-badge" }, $Ce = { class: "bl-hd-session-titles" }, DCe = { class: "kind" }, OCe = { class: "model" }, LCe = { class: "name" }, BCe = { class: "bl-hd-count" }, FCe = { class: "bl-hd-thumbs" }, NCe = ["src"], UCe = { class: "bl-hd-foot" }, GCe = { class: "bl-hd-session-head" }, jCe = { class: "bl-hd-badge" }, HCe = { class: "bl-hd-session-titles" }, VCe = { class: "kind" }, WCe = { class: "model" }, qCe = { class: "name" }, KCe = ["src"], YCe = { class: "text" }, XCe = { class: "meta" }, JCe = { class: "text" }, ZCe = { class: "meta" }, QCe = { class: "bl-hd-add" }, eIe = { class: "main" }, tIe = { class: "chev" }, nIe = { class: "bl-hd-rail" }, iIe = { class: "is-on" }, sIe = { class: "bl-hd-prompt-side" }, oIe = ["src"], rIe = { class: "bl-hd-prompt-text" }, aIe = { class: "bl-hd-prompt-foot" }, lIe = { class: "chip" }, dIe = { class: "chip" }, cIe = { class: "cog" }, uIe = { class: "step" }, hIe = ["src"], yA = /* @__PURE__ */ Re({
  __name: "HeroDemo",
  props: {
    paused: { type: Boolean },
    opening: { type: Boolean }
  },
  setup(n, { expose: e }) {
    const t = n, i = kCe(), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(null), u = /* @__PURE__ */ K(null), p = /* @__PURE__ */ K(null), f = /* @__PURE__ */ K(null), y = /* @__PURE__ */ K(null), b = /* @__PURE__ */ K(null), w = /* @__PURE__ */ K(null), k = /* @__PURE__ */ K(null), S = /* @__PURE__ */ K(null), _ = /* @__PURE__ */ K(null), x = /* @__PURE__ */ K(null), T = /* @__PURE__ */ K(null), M = /* @__PURE__ */ K(null), z = /* @__PURE__ */ K(null), P = /* @__PURE__ */ K(null), D = /* @__PURE__ */ K(null), $ = /* @__PURE__ */ K(null), O = /* @__PURE__ */ K(null), L = /* @__PURE__ */ K(null), Z = /* @__PURE__ */ K(null), J = [], re = [];
    let F = null, W = null;
    const ee = (Le) => {
      F = Le;
    }, N = (Le) => {
      W = Le;
    }, te = cA.filter((Le) => Le !== Wn), G = dA;
    function q(Le) {
      const Ne = { left: Le.x + "px", top: Le.y + "px" };
      return Le.w && (Ne.width = Le.w + "px"), Le.h && (Ne.height = Le.h + "px"), Ne;
    }
    function B(Le) {
      return Le + (Le === 1 ? " item" : " items");
    }
    function ne(Le) {
      const Ne = Le.target;
      Ne.classList.remove("is-broken"), Ne.classList.add("is-in");
    }
    function se(Le) {
      const Ne = Le.target;
      Ne.classList.add("is-broken"), !(Ne.dataset.retried || !Qe) && (Ne.dataset.retried = "1", window.setTimeout(() => {
        Qe && (Ne.src = Ne.src + (Ne.src.includes("?") ? "&" : "?") + "retry=1");
      }, 2e3));
    }
    const Y = /* @__PURE__ */ new WeakMap();
    function ie(Le, Ne, le) {
      if (!Le) return;
      let ve = Y.get(Le);
      ve || Y.set(Le, ve = {}), ve[Ne] !== le && (ve[Ne] = le, Le.style.setProperty(Ne, le));
    }
    function De(Le, Ne) {
      Le && Le.textContent !== Ne && (Le.textContent = Ne);
    }
    function xe(Le, Ne, le) {
      Le && Le.classList.contains(Ne) !== le && Le.classList.toggle(Ne, le);
    }
    const Oe = (Le) => Le.toFixed(2), Ee = (Le) => Le.toFixed(3);
    function j(Le, Ne = !1) {
      const { cam: le } = Le;
      ie(a.value, "transform", `translate(${Oe(mf.x - le.fx * le.z)}px, ${Oe(mf.y - le.fy * le.z)}px) scale(${le.z.toFixed(4)})`), ie(a.value, "--z", Ee(le.z)), ie(a.value, "--iz", Ee(1 / le.z)), De(d.value, Math.round(le.z * 100) + "%"), ie(c.value, "opacity", Ee(Le.dock)), ie(c.value, "transform", `translate(-50%, ${Oe((1 - Le.dock) * 10)}px)`), ie(u.value, "opacity", Ee(Le.prompt)), ie(u.value, "transform", `translateY(${Oe((1 - Le.prompt) * 14)}px)`), ie(u.value, "visibility", Le.prompt > 1e-3 ? "visible" : "hidden"), ie(p.value, "opacity", Le.typed ? "0" : "1"), De(f.value, M0.slice(0, Le.typed)), ie(y.value, "opacity", String(Ne ? 0 : Le.caret)), ie(w.value, "opacity", Ee(Le.refIn)), ie(w.value, "transform", `scale(${Ee(0.82 + 0.18 * Le.refIn)})`), ie(k.value, "opacity", Ee(Le.refGlow)), xe(b.value, "is-target", Le.ghost.ring > 0.5 && Le.ghost.shown > 0 && !Le.refIn), xe(S.value, "is-lit", Le.runLit > 0.5), xe(S.value, "is-pressed", Le.runPressed > 0), xe(S.value, "is-busy", Le.runBusy), ie(_.value, "opacity", Ee(Le.sessionSelected)), De(x.value, Le.sessionFoot), ie(T.value, "opacity", Le.sessionCount ? "1" : "0"), xe(M.value, "is-busy", Le.shimmer), Le.sessionThumbs.forEach((je, Se) => {
        ie(re[Se], "opacity", Ee(je)), ie(re[Se], "transform", `scale(${Ee(0.82 + 0.18 * je)})`);
      }), Le.results.forEach((je, Se) => {
        ie(J[Se], "opacity", Ee(je)), ie(J[Se], "transform", `translateY(${Oe((1 - je) * 34)}px)`);
      }), ie(W, "opacity", Le.heart > 0 ? "1" : "0"), ie(W, "transform", `scale(${Ee(Le.heart)})`), ie(z.value, "opacity", Ee(Le.note)), ie(z.value, "transform", `translateY(${Oe((1 - Le.note) * 34)}px)`), De(F, B(Le.frameItems));
      const ve = Le.pointer;
      ie(P.value, "opacity", Ne ? "0" : Ee(ve.shown)), ie(P.value, "transform", `translate(${Oe(ve.x)}px, ${Oe(ve.y)}px)`), xe(P.value, "is-pressed", ve.pressed > 0), ie(D.value, "opacity", Ee(ve.shift)), ie(L.value, "opacity", Ne ? "0" : Ee(Le.ripple.shown)), ie(L.value, "transform", `translate(${Oe(Le.ripple.x)}px, ${Oe(Le.ripple.y)}px) scale(${Ee(Le.ripple.size)})`);
      const we = Le.ghost;
      ie($.value, "opacity", Ne ? "0" : Ee(we.shown)), ie($.value, "transform", `translate(${Oe(we.x + 12)}px, ${Oe(we.y + 14)}px) rotate(${Oe(we.tilt)}deg) scale(${Ee(0.86 + 0.14 * we.shown)})`), ie(O.value, "opacity", Ee(we.ring)), ie(Z.value, "opacity", Le.sheen < 0 ? "0" : Ee(Math.sin(Math.PI * Le.sheen))), ie(Z.value, "transform", `translateX(${Oe(-100 + 270 * Math.max(0, Le.sheen))}%)`);
    }
    let V = 0, Q = 0, oe = 0, ue = !1, Ie = !1;
    function he() {
      return !i.value && ue && Ie && !0 && !t.paused && !t.opening && !document.hidden;
    }
    function ye(Le) {
      const Ne = Ih(0);
      j({ ...Ne, cam: Le.cam, dock: Ne.dock * Le.chrome }, !0), ie(s.value, "--build", Ee(Le.build)), ie(r.value, "opacity", Ee(Le.chrome)), ie(l.value, "opacity", Ee(Le.chrome));
      const le = Le.glint || { pic: 0, session: 0, note: 0, frame: 0 };
      ie(s.value, "--g-pic", Ee(le.pic)), ie(s.value, "--g-session", Ee(le.session)), ie(s.value, "--g-note", Ee(le.note)), ie(s.value, "--g-frame", Ee(le.frame));
    }
    e({ paintOpening: ye });
    const fe = (Le, Ne = 0) => ({ "--d": String(tTe(Le, Ne)) });
    function ze(Le) {
      Q = (Le - oe) / 1e3 % up, j(Ih(Q)), V = requestAnimationFrame(ze);
    }
    function He() {
      if (he()) {
        V || (oe = performance.now() - Q * 1e3, V = requestAnimationFrame(ze));
        return;
      }
      V && (cancelAnimationFrame(V), V = 0), i.value && j(Ih(T4), !0);
    }
    $e(() => t.paused, He), $e(i, He);
    function ce() {
      const Le = s.value;
      Le && o.value && ie(o.value, "transform", `scale(${(Le.clientWidth / Fn.w).toFixed(5)})`);
    }
    function be() {
      const Le = Array.from(s.value ? s.value.querySelectorAll("img") : []), Ne = Promise.allSettled(Le.map((le) => le.decode ? le.decode() : Promise.resolve()));
      return Promise.race([Ne.then(() => {
      }), new Promise((le) => window.setTimeout(le, 4500))]);
    }
    let Be = null, Fe = null;
    const Ke = () => He();
    let Qe = !0;
    ot(() => {
      ce(), typeof ResizeObserver != "undefined" && s.value && (Fe = new ResizeObserver(ce), Fe.observe(s.value)), j(Ih(i.value ? T4 : 0), i.value), typeof IntersectionObserver != "undefined" && s.value ? (Be = new IntersectionObserver((Le) => {
        ue = Le.some((Ne) => Ne.isIntersecting), He();
      }, { threshold: 0.08 }), Be.observe(s.value)) : ue = !0, document.addEventListener("visibilitychange", Ke), be().then(() => {
        Qe && (Ie = !0, He());
      });
    }), Ve(() => {
      Qe = !1, V && cancelAnimationFrame(V), V = 0, Be && Be.disconnect(), Fe && Fe.disconnect(), document.removeEventListener("visibilitychange", Ke);
    });
    const ht = (Le) => "is-" + Le.tint;
    return (Le, Ne) => (g(), v("div", {
      ref_key: "root",
      ref: s,
      class: U(["bl-hd", { "is-opening": n.opening }]),
      "aria-hidden": "true",
      "data-testid": "hero-demo"
    }, [
      h("div", {
        ref_key: "win",
        ref: o,
        class: "bl-hd-win",
        style: de({ width: m(Fn).w + "px", height: m(Fn).h + "px" })
      }, [
        h("div", {
          ref_key: "bar",
          ref: r,
          class: "bl-hd-bar"
        }, [
          Ne[0] || (Ne[0] = h("span", { class: "bl-hd-lights" }, [
            h("i"),
            h("i"),
            h("i")
          ], -1)),
          (g(), v("svg", {
            class: "bl-hd-mark",
            viewBox: m(Ll),
            width: "25",
            height: "18"
          }, [
            (g(!0), v(H, null, me(m(ea), (le) => (g(), v("path", {
              key: le.d,
              d: le.d,
              fill: le.fill
            }, null, 8, SCe))), 128))
          ], 8, _Ce)),
          Ne[1] || (Ne[1] = h("span", { class: "bl-hd-crumbs" }, [
            X("Boards "),
            h("span", { class: "sep" }, "/"),
            X(),
            h("b", null, "Bonneville Tower")
          ], -1)),
          Ne[2] || (Ne[2] = h("span", { class: "bl-hd-saved" }, [
            h("i"),
            X("Saved")
          ], -1)),
          Ne[3] || (Ne[3] = h("span", { class: "bl-hd-kebab" }, [
            h("i"),
            h("i"),
            h("i")
          ], -1))
        ], 512),
        h("div", TCe, [
          h("div", {
            ref_key: "world",
            ref: a,
            class: "bl-hd-world"
          }, [
            Ne[6] || (Ne[6] = h("div", { class: "bl-hd-dots is-fine" }, null, -1)),
            Ne[7] || (Ne[7] = h("div", { class: "bl-hd-dots is-coarse" }, null, -1)),
            (g(!0), v(H, null, me(m(aA), (le) => (g(), v("div", {
              key: le.title,
              class: "bl-hd-frame",
              style: de({ ...q(le), ...fe(le, 0.06) })
            }, [
              h("span", MCe, [
                X(A(le.title) + " ", 1),
                le === m(lA) ? (g(), v("small", {
                  key: 0,
                  ref_for: !0,
                  ref: ee
                }, A(B(m(C0)(le))), 513)) : (g(), v("small", CCe, A(B(m(C0)(le))), 1))
              ]),
              h("span", ICe, A(le.title), 1)
            ], 4))), 128)),
            (g(!0), v(H, null, me(m(G), (le) => (g(), v("div", {
              key: le.id,
              class: U(["bl-hd-pic", { "is-video": le.video }]),
              style: de({ ...q(le), ...fe(le) })
            }, [
              h("img", {
                src: le.src,
                alt: "",
                decoding: "async",
                fetchpriority: le === m(ll) ? "high" : "low",
                onLoad: ne,
                onError: se
              }, null, 40, ACe),
              le.video ? (g(), v("span", PCe, [
                C(Zt, {
                  name: "Play",
                  size: 11,
                  stroke: 2.4
                })
              ])) : E("", !0)
            ], 6))), 128)),
            (g(!0), v(H, null, me(m(_o), (le, ve) => (g(), v("div", {
              key: le.id,
              ref_for: !0,
              ref: (we) => {
                we && (J[ve] = we);
              },
              class: U(["bl-hd-pic is-result", { "is-first": ve === 0 }]),
              style: de(q(le))
            }, [
              h("img", {
                src: le.src,
                alt: "",
                decoding: "async",
                onLoad: ne,
                onError: se
              }, null, 40, ECe),
              ve === 0 ? (g(), v("span", {
                key: 0,
                ref_for: !0,
                ref: N,
                class: "bl-hd-heart"
              }, [
                C(Zt, {
                  name: "Heart",
                  size: 10,
                  stroke: 2.6
                })
              ], 512)) : E("", !0)
            ], 6))), 128)),
            (g(!0), v(H, null, me(m(te), (le) => (g(), v("div", {
              key: le.id,
              class: "bl-hd-session",
              style: de({ ...q({ x: le.x, y: le.y, w: m(ao).w, h: m(ao).h }), ...fe({ x: le.x, y: le.y, w: m(ao).w, h: m(ao).h }) })
            }, [
              h("div", RCe, [
                h("span", zCe, [
                  C(Zt, {
                    name: le.kind,
                    size: 17
                  }, null, 8, ["name"])
                ]),
                h("span", $Ce, [
                  h("span", DCe, [
                    X(A(le.kind), 1),
                    Ne[4] || (Ne[4] = h("span", { class: "sep" }, "·", -1)),
                    h("span", OCe, A(le.model), 1)
                  ]),
                  h("span", LCe, A(le.name), 1)
                ]),
                h("span", BCe, A(le.thumbs.length), 1)
              ]),
              h("div", FCe, [
                (g(), v(H, null, me(4, (ve) => h("span", {
                  key: ve,
                  class: U(["bl-hd-thumb", { "is-empty": !le.thumbs[ve - 1] }])
                }, [
                  le.thumbs[ve - 1] ? (g(), v("img", {
                    key: 0,
                    src: le.thumbs[ve - 1],
                    alt: "",
                    decoding: "async",
                    fetchpriority: "low",
                    onLoad: ne,
                    onError: se
                  }, null, 40, NCe)) : E("", !0)
                ], 2)), 64))
              ]),
              h("div", UCe, A(le.foot), 1)
            ], 4))), 128)),
            h("div", {
              class: "bl-hd-session is-hero",
              style: de({ ...q({ x: m(Wn).x, y: m(Wn).y, w: m(ao).w, h: m(ao).h }), ...fe({ x: m(Wn).x, y: m(Wn).y, w: m(ao).w, h: m(ao).h }) })
            }, [
              h("span", {
                ref_key: "ring",
                ref: _,
                class: "bl-hd-ring"
              }, null, 512),
              h("div", GCe, [
                h("span", jCe, [
                  C(Zt, {
                    name: "Image",
                    size: 17
                  })
                ]),
                h("span", HCe, [
                  h("span", VCe, [
                    X(A(m(Wn).kind), 1),
                    Ne[5] || (Ne[5] = h("span", { class: "sep" }, "·", -1)),
                    h("span", WCe, A(m(Wn).model), 1)
                  ]),
                  h("span", qCe, A(m(Wn).name), 1)
                ]),
                h("span", {
                  ref_key: "count",
                  ref: T,
                  class: "bl-hd-count"
                }, A(m(_o).length), 513)
              ]),
              h("div", {
                ref_key: "thumbsRow",
                ref: M,
                class: "bl-hd-thumbs"
              }, [
                (g(!0), v(H, null, me(m(_o), (le, ve) => (g(), v("span", {
                  key: le.id,
                  class: "bl-hd-thumb is-empty"
                }, [
                  h("img", {
                    ref_for: !0,
                    ref: (we) => {
                      we && (re[ve] = we);
                    },
                    src: le.src,
                    alt: "",
                    decoding: "async",
                    class: "is-in",
                    onLoad: ne,
                    onError: se
                  }, null, 40, KCe)
                ]))), 128))
              ], 512),
              h("div", {
                ref_key: "foot",
                ref: x,
                class: "bl-hd-foot"
              }, A(m(Wn).foot), 513)
            ], 4),
            (g(!0), v(H, null, me(m(uA), (le) => (g(), v("div", {
              key: le.id,
              class: U(["bl-hd-note", ht(le)]),
              style: de({ ...q(le), ...fe(le) })
            }, [
              h("span", YCe, A(le.text), 1),
              h("span", XCe, A(le.by), 1)
            ], 6))), 128)),
            h("div", {
              ref_key: "note",
              ref: z,
              class: U(["bl-hd-note", ht(m(Mh))]),
              style: de(q(m(Mh)))
            }, [
              h("span", JCe, A(m(Mh).text), 1),
              h("span", ZCe, A(m(Mh).by), 1)
            ], 6)
          ], 512),
          h("div", {
            ref_key: "dock",
            ref: c,
            class: "bl-hd-dock",
            style: de({ top: m(T0) - 46 + "px" })
          }, [
            h("span", QCe, [
              h("span", eIe, [
                C(Zt, {
                  name: "ImagePlus",
                  size: 15
                }),
                Ne[8] || (Ne[8] = X("Image Gen", -1))
              ]),
              h("span", tIe, [
                C(Zt, {
                  name: "ChevronDown",
                  size: 13
                })
              ])
            ]),
            h("span", nIe, [
              h("i", iIe, [
                C(Zt, {
                  name: "MousePointer2",
                  size: 15
                })
              ]),
              h("i", null, [
                C(Zt, {
                  name: "Hand",
                  size: 15
                })
              ]),
              Ne[9] || (Ne[9] = h("b", null, null, -1)),
              h("i", null, [
                C(Zt, {
                  name: "Image",
                  size: 15
                })
              ]),
              h("i", null, [
                C(Zt, {
                  name: "StickyNote",
                  size: 15
                })
              ]),
              h("i", null, [
                C(Zt, {
                  name: "Frame",
                  size: 15
                })
              ]),
              h("i", null, [
                C(Zt, {
                  name: "Square",
                  size: 15
                })
              ])
            ])
          ], 4),
          h("div", {
            ref_key: "prompt",
            ref: u,
            class: "bl-hd-prompt",
            style: de(q(m(Ns)))
          }, [
            h("span", sIe, [
              h("i", null, [
                C(Zt, {
                  name: "LayoutTemplate",
                  size: 15
                })
              ]),
              h("i", null, [
                C(Zt, {
                  name: "Pipette",
                  size: 15
                })
              ]),
              h("i", null, [
                C(Zt, {
                  name: "Maximize2",
                  size: 14
                })
              ])
            ]),
            h("span", {
              ref_key: "slot",
              ref: b,
              class: "bl-hd-slot",
              style: de({ left: m(ko).x - m(Ns).x + "px", top: m(ko).y - m(Ns).y + "px", width: m(ko).w + "px", height: m(ko).h + "px" })
            }, [
              C(Zt, {
                name: "ImagePlus",
                size: 17
              }),
              h("span", {
                ref_key: "refGlow",
                ref: k,
                class: "glow"
              }, null, 512),
              h("img", {
                ref_key: "refThumb",
                ref: w,
                src: m(ll).src,
                alt: "",
                decoding: "async",
                class: "is-in",
                onError: se
              }, null, 40, oIe)
            ], 4),
            h("span", rIe, [
              h("span", {
                ref_key: "placeholder",
                ref: p,
                class: "ph"
              }, "Describe what " + A(m(Wn).name) + " should make", 513),
              h("span", {
                ref_key: "typedEl",
                ref: f,
                class: "typed"
              }, null, 512),
              h("span", {
                ref_key: "caret",
                ref: y,
                class: "caret"
              }, null, 512)
            ]),
            h("span", aIe, [
              h("span", lIe, [
                Ne[10] || (Ne[10] = h("small", null, "Model", -1)),
                X(A(m(Wn).model), 1),
                C(Zt, {
                  name: "ChevronDown",
                  size: 12
                })
              ]),
              h("span", dIe, [
                C(Zt, {
                  name: "RectangleVertical",
                  size: 12
                }),
                Ne[11] || (Ne[11] = X("896×1152", -1))
              ]),
              h("span", cIe, [
                C(Zt, {
                  name: "Settings",
                  size: 14
                })
              ]),
              Ne[12] || (Ne[12] = h("span", { class: "sp" }, null, -1)),
              h("span", uIe, [
                C(Zt, {
                  name: "Minus",
                  size: 11
                }),
                h("b", null, A(m(_o).length), 1),
                C(Zt, {
                  name: "Plus",
                  size: 11
                })
              ]),
              h("span", {
                ref_key: "run",
                ref: S,
                class: "run",
                style: de({ width: m(Bd).w + "px" })
              }, "Run", 4)
            ])
          ], 4),
          h("span", {
            ref_key: "zoomPill",
            ref: l,
            class: "bl-hd-zoom",
            style: de({ top: m(T0) - 34 + "px" })
          }, [
            C(Zt, {
              name: "Minus",
              size: 12
            }),
            h("span", {
              ref_key: "zoomText",
              ref: d,
              class: "pct"
            }, "29%", 512),
            C(Zt, {
              name: "Plus",
              size: 12
            })
          ], 4),
          h("span", {
            ref_key: "ghost",
            ref: $,
            class: "bl-hd-ghost"
          }, [
            h("img", {
              src: m(ll).src,
              alt: "",
              class: "is-in",
              onError: se
            }, null, 40, hIe),
            h("span", {
              ref_key: "ghostRing",
              ref: O,
              class: "ring"
            }, null, 512)
          ], 512),
          h("span", {
            ref_key: "ripple",
            ref: L,
            class: "bl-hd-ripple"
          }, null, 512),
          h("span", {
            ref_key: "pointer",
            ref: P,
            class: "bl-hd-pointer"
          }, [
            Ne[13] || (Ne[13] = h("svg", {
              class: "arrow",
              width: "22",
              height: "22",
              viewBox: "0 0 22 22"
            }, [
              h("path", {
                d: "M4 2.5v15.2l3.9-3.7 2.6 6 2.7-1.2-2.6-5.9h5.4z",
                fill: "#fff",
                stroke: "#0b0d14",
                "stroke-width": "1.3",
                "stroke-linejoin": "round"
              })
            ], -1)),
            h("span", {
              ref_key: "shiftKey",
              ref: D,
              class: "bl-hd-key"
            }, "⇧ Shift", 512)
          ], 512)
        ]),
        h("span", {
          ref_key: "sheen",
          ref: Z,
          class: "bl-hd-sheen"
        }, null, 512)
      ], 4)
    ], 2));
  }
}), pIe = ["aria-label"], fIe = { class: "ob-welcome-media" }, mIe = { class: "ob-welcome-body" }, gIe = { class: "ob-eyebrow" }, bIe = { class: "ob-welcome-title" }, vIe = { class: "ob-welcome-text" }, yIe = { class: "ob-welcome-actions" }, xIe = ["disabled"], wIe = /* @__PURE__ */ Re({
  __name: "WelcomeCard",
  props: {
    tour: {}
  },
  setup(n) {
    const e = n, t = tm("welcome"), i = I(() => gTe(e.tour.reason, e.tour.boardRef)), s = I(() => e.tour.phase.value === "task");
    return (o, r) => (g(), v("div", {
      class: U(["ob-welcome", { "is-intro": !!n.tour.intro.value }]),
      role: "dialog",
      "aria-label": m(t).title,
      "data-tour-ui": "",
      "data-testid": "tour-welcome"
    }, [
      h("div", fIe, [
        C(yA, {
          paused: !!n.tour.intro.value
        }, null, 8, ["paused"]),
        r[1] || (r[1] = h("span", { class: "ob-welcome-fade" }, null, -1))
      ]),
      h("div", mIe, [
        h("span", gIe, A(m(t).eyebrow), 1),
        h("h1", bIe, A(m(t).title), 1),
        h("p", vIe, A(i.value), 1),
        h("div", yIe, [
          h("button", {
            class: "ob-btn is-big",
            disabled: !s.value,
            "data-testid": "tour-start",
            onClick: r[0] || (r[0] = (a) => n.tour.next())
          }, [
            X(A(m(bTe)(n.tour.reason)), 1),
            C(R, {
              name: "ArrowRight",
              size: 15,
              stroke: 2.4
            })
          ], 8, xIe),
          r[2] || (r[2] = h("span", { class: "ob-or" }, [
            X("or press "),
            h("kbd", { class: "ob-key" }, "↵")
          ], -1))
        ])
      ])
    ], 10, pIe));
  }
}), kIe = ["aria-label"], _Ie = {
  class: "ob-finale-mark",
  "aria-hidden": "true"
}, SIe = ["viewBox"], TIe = ["d", "fill"], MIe = { class: "ob-finale-title" }, CIe = { class: "ob-finale-text" }, IIe = { class: "ob-learned" }, AIe = { class: "ob-tick" }, PIe = {
  key: 0,
  class: "ob-finale-error",
  role: "alert"
}, EIe = { class: "ob-finale-actions" }, RIe = ["disabled"], zIe = ["disabled"], $Ie = /* @__PURE__ */ Re({
  __name: "TourFinale",
  props: {
    tour: {},
    busy: { type: Boolean },
    error: {}
  },
  setup(n) {
    const e = n, t = tm("finale"), i = I(() => vTe(e.tour.reason, e.tour.boardRef)), s = I(() => xTe(e.tour.reason, e.tour.boardRef)), o = I(() => e.busy ? s.value.exit === "create-board" ? "Creating your board…" : "Opening…" : s.value.label), r = /* @__PURE__ */ K(null);
    return ot(() => {
      window.setTimeout(() => {
        r.value && r.value.focus({ preventScroll: !0 });
      }, 700);
    }), (a, l) => (g(), v("div", {
      class: "ob-finale",
      role: "dialog",
      "aria-label": m(t).title,
      "data-tour-ui": "",
      "data-testid": "tour-finale"
    }, [
      h("div", _Ie, [
        l[2] || (l[2] = h("span", { class: "halo" }, null, -1)),
        (g(), v("svg", {
          viewBox: m(Ll),
          width: "64",
          height: "46"
        }, [
          (g(!0), v(H, null, me(m(ea), (d, c) => (g(), v("path", {
            key: d.d,
            d: d.d,
            fill: d.fill,
            style: de({ "--i": c })
          }, null, 12, TIe))), 128))
        ], 8, SIe))
      ]),
      h("h1", MIe, A(m(t).title), 1),
      h("p", CIe, A(i.value), 1),
      h("ul", IIe, [
        (g(!0), v(H, null, me(m(yTe), (d, c) => (g(), v("li", {
          key: d,
          style: de({ "--i": c })
        }, [
          h("span", AIe, [
            C(R, {
              name: "Check",
              size: 11,
              stroke: 3
            })
          ]),
          X(A(d), 1)
        ], 4))), 128))
      ]),
      n.error ? (g(), v("p", PIe, A(n.error), 1)) : E("", !0),
      h("div", EIe, [
        h("button", {
          ref_key: "primary",
          ref: r,
          class: "ob-btn is-big",
          disabled: n.busy,
          "data-testid": "tour-finish",
          onClick: l[0] || (l[0] = (d) => n.tour.finish(s.value.exit))
        }, [
          X(A(o.value), 1),
          n.busy ? E("", !0) : (g(), Ce(R, {
            key: 0,
            name: "ArrowRight",
            size: 15,
            stroke: 2.4
          }))
        ], 8, RIe),
        h("button", {
          class: "ob-link",
          disabled: n.busy,
          "data-testid": "tour-again",
          onClick: l[1] || (l[1] = (d) => n.tour.again())
        }, [
          C(R, {
            name: "RotateCcw",
            size: 13
          }),
          l[3] || (l[3] = X("Take the tour again", -1))
        ], 8, zIe)
      ])
    ], 8, kIe));
  }
}), jc = 6.4, gt = {
  /** the loader that held while the board opened gives way */
  loader: [0, 0.45],
  /** the light behind the mark */
  glow: [0.1, 1.2],
  /** the mark's facets turn in, each a step after the last, where the loader was (the middle of the window) */
  facets: { at: 0.2, each: 0.78, step: 0.12 },
  /** the light passes over the mark */
  sheen: [1.35, 2.05],
  /** the mark rises from the middle to make room for the line */
  rise: [1.2, 2.05],
  /** the mark's slow breath while it holds */
  breathe: [1.1, 3.6],
  /** the line rises, a word a step after the last */
  words: { at: 1.45, each: 0.75, step: 0.13 },
  /** the board's canvas fades up behind the words */
  stage: [2.2, 2.8],
  /** the board builds itself, from the middle out */
  build: [2.3, 4.25],
  /** the row naming what a board holds comes in under the line */
  row: [2.9, 3.15],
  /** the camera draws back the whole time the board shows, ending on the card's first frame */
  pull: [2.2, 6.1],
  /** the shade behind the words while they're over the board */
  scrim: [2.3, 2.9],
  /** the view shrinks into the card's window */
  land: [4.8, 6.1],
  /** the dark lifts off the practice board */
  lift: [4.95, 6.05],
  /** the window's bar, the dock and the zoom come in as it lands */
  chrome: [5.5, 6.05],
  /** the card comes up round it */
  card: [5.3, 6.2],
  /** the big mark hands over to the window bar's own */
  markOut: [5.8, 6.1],
  /** landed: the card's own window (the same picture) shows under the opening's, which fades off it */
  handover: [6.1, 6.35],
  /** Skip intro: there while the opening is full screen */
  skip: [0.8, 1.4]
}, P0 = [
  { key: "pic", label: "Images", at: 3.15 },
  { key: "session", label: "AI sessions", at: 3.5 },
  { key: "note", label: "Notes", at: 3.85 },
  { key: "frame", label: "Frames", at: 4.2 }
], DIe = 0.6, OIe = { fx: 1886, fy: 640, z: 0.6 }, LIe = So(0.7, 0, 0.2, 1), BIe = So(0.33, 0, 0.15, 1), FIe = So(0.16, 1, 0.3, 1), NIe = So(0.65, 0, 0.35, 1);
function UIe(n) {
  return n.split(" ").filter(Boolean);
}
function GIe(n, e = 5) {
  const t = Math.max(0, Math.min(jc, n)), i = gt.facets, s = gt.words, o = Ue(t, gt.land[0], gt.land[1], LIe), r = (a) => 1 - Ue(t, gt.land[0], gt.land[0] + a, Je.sine);
  return {
    t,
    backdrop: 1 - Ue(t, gt.lift[0], gt.lift[1], Je.sine),
    loader: 1 - Ue(t, gt.loader[0], gt.loader[1], Je.sine),
    glow: Ue(t, gt.glow[0], gt.glow[1], Je.sine) * r(0.8),
    facets: [0, 1, 2, 3].map((a) => Ue(t, i.at + a * i.step, i.at + a * i.step + i.each)),
    sheen: t < gt.sheen[0] || t > gt.sheen[1] ? -1 : Ue(t, gt.sheen[0], gt.sheen[1]),
    breathe: 1 + 0.03 * Math.sin(Math.PI * Ue(t, gt.breathe[0], gt.breathe[1])),
    rise: Ue(t, gt.rise[0], gt.rise[1], NIe),
    mark: 1 - Ue(t, gt.markOut[0], gt.markOut[1], Je.sine),
    words: Array.from({ length: e }, (a, l) => Ue(t, s.at + l * s.step, s.at + l * s.step + s.each, Je.out)),
    stage: Ue(t, gt.stage[0], gt.stage[1], Je.sine) * (1 - Ue(t, gt.handover[0], gt.handover[1], Je.sine)),
    build: Ue(t, gt.build[0], gt.build[1]),
    row: Ue(t, gt.row[0], gt.row[1], Je.sine) * r(0.35),
    named: P0.map((a) => Ue(t, a.at, a.at + 0.25, Je.out)),
    lit: P0.map((a) => Math.sin(Math.PI * Ue(t, a.at, a.at + DIe))),
    media: t >= gt.handover[0] ? 1 : 0,
    cam: I0(OIe, Fd, Ue(t, gt.pull[0], gt.pull[1], BIe)),
    scrim: Ue(t, gt.scrim[0], gt.scrim[1], Je.sine) * r(0.7),
    land: o,
    chrome: Ue(t, gt.chrome[0], gt.chrome[1], Je.sine),
    card: Ue(t, gt.card[0], gt.card[1], Je.out),
    skip: Ue(t, gt.skip[0], gt.skip[1], Je.sine) * r(0.3),
    done: n >= jc
  };
}
function jIe(n, e, t) {
  const i = FIe(Math.max(0, Math.min(1, e))), s = 1 - i, o = t * 0.09 * s;
  return {
    opacity: Math.min(1, Math.max(0, e) / 0.24),
    brightness: 0.35 + 0.65 * i,
    transform: `translate(${(n.out[0] * o).toFixed(2)}px, ${(n.out[1] * o).toFixed(2)}px) rotate3d(${n.axis[0]}, ${n.axis[1]}, 0, ${(88 * s).toFixed(2)}deg) scale(${(0.84 + 0.16 * i).toFixed(4)})`
  };
}
function $4(n) {
  const e = Fn.h - Fn.bar, t = Math.max(n.w, n.h * Fn.w / e), i = t / Fn.w;
  return { x: (n.w - t) / 2, y: (n.h - e * i) / 2 - Fn.bar * i, w: t, h: Fn.h * i };
}
function D4(n) {
  return { x: n.x, y: n.y, w: n.w, h: n.w * Fn.h / Fn.w };
}
function HIe(n, e) {
  return { x: (n.x - e.x) / e.w, y: (n.y - e.y) / e.w, w: n.w / e.w, h: n.h / e.w };
}
function VIe(n, e) {
  return { x: e.x + n.x * e.w, y: e.y + n.y * e.w, w: n.w * e.w, h: n.h * e.w };
}
function O4(n, e, t) {
  return { x: n.x + (e.x - n.x) * t, y: n.y + (e.y - n.y) * t, w: n.w + (e.w - n.w) * t, h: n.h + (e.h - n.h) * t };
}
function L4(n, e, t) {
  const i = 1 + (e.w / n.w - 1) * t;
  return `translate(${((e.x - n.x) * t).toFixed(2)}px, ${((e.y - n.y) * t).toFixed(2)}px) scale(${i.toFixed(4)})`;
}
const WIe = {
  class: "ob-intro-center",
  "aria-hidden": "true"
}, qIe = ["viewBox"], KIe = ["d", "fill"], YIe = {
  key: 0,
  class: "sep"
}, XIe = /* @__PURE__ */ Re({
  __name: "TourIntro",
  props: {
    tour: {}
  },
  setup(n) {
    const t = n.tour, i = UIe(tm("welcome").title), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(null), u = /* @__PURE__ */ K(null), p = /* @__PURE__ */ K(null), f = /* @__PURE__ */ K(null), y = /* @__PURE__ */ K(null), b = /* @__PURE__ */ K(null), w = /* @__PURE__ */ K(null), k = /* @__PURE__ */ K(null), S = /* @__PURE__ */ K(null), _ = [], x = [], T = [];
    let M = null;
    const z = /* @__PURE__ */ new WeakMap();
    function P(se, Y, ie) {
      if (!se) return;
      let De = z.get(se);
      De || z.set(se, De = {}), De[Y] !== ie && (De[Y] = ie, se.style.setProperty(Y, ie));
    }
    const D = (se) => se.toFixed(2), $ = (se) => se.toFixed(3);
    function O(se, Y) {
      P(se, "left", D(Y.x) + "px"), P(se, "top", D(Y.y) + "px"), P(se, "width", D(Y.w) + "px"), P(se, "height", D(Y.h) + "px");
    }
    function L(se) {
      if (!se) return null;
      const Y = se.getBoundingClientRect();
      return { x: Y.left, y: Y.top, w: Y.width, h: Y.height };
    }
    let Z = null, J = null, re = 120;
    function F() {
      const se = p.value, Y = b.value;
      if (!se || !Y) return;
      const ie = [se.style.transform, Y.style.transform];
      se.style.transform = "none", Y.style.transform = "none";
      const De = L(se), xe = L(Y);
      se.style.transform = ie[0], Y.style.transform = ie[1], De && xe && (Z = { mark: De, title: xe }, re = De.w);
    }
    function W() {
      const se = M ? M.querySelector(".ob-welcome") : null, Y = L(se && se.querySelector(".ob-welcome-media")), ie = L(se && se.querySelector(".ob-welcome-title")), De = L(se && se.querySelector(".ob-welcome-media .bl-hd-mark"));
      J = se && Y && ie && De ? { media: Y, title: ie, mark: HIe(De, D4(Y)), radius: parseFloat(getComputedStyle(se).borderTopLeftRadius) || 0 } : null;
    }
    function ee(se) {
      const Y = GIe(se, i.length), ie = { w: window.innerWidth, h: window.innerHeight };
      P(o.value, "opacity", $(Y.backdrop)), P(r.value, "opacity", $(Y.loader)), P(r.value, "transform", `scale(${$(1 + 0.35 * (1 - Y.loader))})`), P(u.value, "opacity", $(Y.glow)), P(u.value, "transform", `translate(-50%, -50%) scale(${$(0.55 + 0.45 * Y.glow)})`), ea.forEach((V, Q) => {
        const oe = jIe(V, Y.facets[Q], re);
        P(_[Q], "opacity", $(oe.opacity)), P(_[Q], "transform", oe.transform), P(_[Q], "filter", `brightness(${$(oe.brightness)})`);
      }), P(y.value, "opacity", Y.sheen < 0 ? "0" : $(Math.sin(Math.PI * Y.sheen))), P(y.value, "background-position", `${D(100 - 100 * Math.max(0, Y.sheen))}% 0`), P(f.value, "transform", `scale(${$(Y.breathe)})`), Y.words.forEach((V, Q) => {
        P(x[Q], "opacity", $(V)), P(x[Q], "transform", `translateY(${D((1 - V) * 28)}px)`), P(x[Q], "filter", V >= 1 ? "none" : `blur(${D((1 - V) * 12)}px)`);
      }), P(w.value, "opacity", $(Y.row)), Y.named.forEach((V, Q) => {
        P(T[Q], "opacity", $(V * (0.5 + 0.5 * Y.lit[Q]))), P(T[Q], "transform", `translateY(${D((1 - V) * 8)}px)`), P(T[Q], "color", Y.lit[Q] > 0.5 ? "#fff" : "");
      }), Y.land > 0 && !J && (F(), W());
      const De = { x: 0, y: 0, w: ie.w, h: ie.h }, xe = J ? O4(De, J.media, Y.land) : De, Oe = J ? O4($4(ie), D4(J.media), Y.land) : $4(ie);
      P(a.value, "opacity", $(Y.stage)), O(a.value, xe);
      const Ee = D((J ? J.radius : 0) * Y.land), j = D(14 * Math.sin(Math.PI * Y.land));
      if (P(a.value, "border-radius", `${Ee}px ${Ee}px ${j}px ${j}px`), P(a.value, "box-shadow", `0 40px 120px rgba(0, 0, 0, ${$(0.65 * Math.sin(Math.PI * Y.land))})`), O(l.value, { x: Oe.x - xe.x, y: Oe.y - xe.y, w: Oe.w, h: Oe.h }), P(d.value, "opacity", $(Y.card)), P(c.value, "opacity", $(Y.scrim)), S.value) {
        const [V, Q, oe, ue] = Y.lit;
        S.value.paintOpening({ build: Y.build, cam: Y.cam, chrome: Y.chrome, glint: { pic: V, session: Q, note: oe, frame: ue } });
      }
      if (Z && J && Y.land > 0)
        P(p.value, "transform", L4(Z.mark, VIe(J.mark, Oe), Y.land)), P(b.value, "transform", L4(Z.title, J.title, Y.land));
      else {
        const V = Z ? ie.h / 2 - (Z.mark.y + Z.mark.h / 2) : 0;
        P(p.value, "transform", Y.rise >= 1 ? "none" : `translateY(${D((1 - Y.rise) * V)}px)`), P(b.value, "transform", "none");
      }
      P(p.value, "opacity", $(Y.mark)), P(b.value, "--ts", $(1 - Y.land)), P(k.value, "opacity", $(Y.skip)), P(k.value, "visibility", Y.skip > 0.01 ? "visible" : "hidden"), P(M, "--ob-intro-card", $(Y.card)), P(M, "--ob-intro-media", String(Y.media));
    }
    let N = 0, te = 0, G = 0;
    function q(se) {
      const Y = G ? Math.min(0.1, (se - G) / 1e3) : 0;
      if (G = se, te = Math.min(jc, te + Y), ee(te), te >= jc) {
        N = 0, t.introDone();
        return;
      }
      N = requestAnimationFrame(q);
    }
    function B() {
      N || (G = 0, N = requestAnimationFrame(q));
    }
    $e(() => t.intro.value, (se) => {
      se === "playing" && B();
    }, { immediate: !0 });
    const ne = () => {
      F(), J && W(), ee(te);
    };
    return ot(() => {
      M = s.value ? s.value.closest(".ob-layer") : null, F(), ee(te), window.addEventListener("resize", ne);
    }), Ve(() => {
      N && cancelAnimationFrame(N), N = 0, window.removeEventListener("resize", ne), M && (M.style.removeProperty("--ob-intro-card"), M.style.removeProperty("--ob-intro-media"));
    }), (se, Y) => (g(), v("div", {
      ref_key: "root",
      ref: s,
      class: "ob-intro",
      "data-tour-ui": "",
      "data-testid": "tour-intro",
      onWheel: Y[1] || (Y[1] = Pe(() => {
      }, ["prevent"])),
      onContextmenu: Y[2] || (Y[2] = Pe(() => {
      }, ["prevent"]))
    }, [
      h("div", {
        ref_key: "dark",
        ref: o,
        class: "ob-intro-dark"
      }, null, 512),
      h("div", {
        ref_key: "loader",
        ref: r,
        class: "ob-intro-loader"
      }, [
        C(KI)
      ], 512),
      h("div", {
        ref_key: "stage",
        ref: a,
        class: "ob-intro-stage",
        "aria-hidden": "true"
      }, [
        h("div", {
          ref_key: "win",
          ref: l,
          class: "ob-intro-win"
        }, [
          C(yA, {
            ref_key: "hero",
            ref: S,
            paused: !0,
            opening: ""
          }, null, 512)
        ], 512),
        h("span", {
          ref_key: "fade",
          ref: d,
          class: "ob-welcome-fade"
        }, null, 512),
        h("div", {
          ref_key: "scrim",
          ref: c,
          class: "ob-intro-scrim"
        }, null, 512)
      ], 512),
      h("div", WIe, [
        h("div", {
          ref_key: "mark",
          ref: p,
          class: "ob-intro-mark"
        }, [
          h("div", {
            ref_key: "glow",
            ref: u,
            class: "ob-intro-glow"
          }, null, 512),
          h("div", {
            ref_key: "markIn",
            ref: f,
            class: "ob-intro-mark-in",
            style: de({ "--mask": m(qI) })
          }, [
            (g(!0), v(H, null, me(m(ea), (ie, De) => (g(), v("svg", {
              key: De,
              ref_for: !0,
              ref: (xe) => {
                xe && (_[De] = xe);
              },
              class: "ob-intro-facet",
              viewBox: m(Ll),
              style: de({ transformOrigin: ie.origin }),
              focusable: "false"
            }, [
              h("path", {
                d: ie.d,
                fill: ie.fill
              }, null, 8, KIe)
            ], 12, qIe))), 128)),
            h("div", {
              ref_key: "sheen",
              ref: y,
              class: "ob-intro-sheen"
            }, null, 512)
          ], 4)
        ], 512),
        h("div", {
          ref_key: "title",
          ref: b,
          class: "ob-intro-title"
        }, [
          (g(!0), v(H, null, me(m(i), (ie, De) => (g(), v("span", {
            key: De,
            ref_for: !0,
            ref: (xe) => {
              xe && (x[De] = xe);
            },
            class: "ob-intro-word"
          }, A(ie + (De < m(i).length - 1 ? " " : "")), 1))), 128))
        ], 512),
        h("div", {
          ref_key: "row",
          ref: w,
          class: "ob-intro-row"
        }, [
          (g(!0), v(H, null, me(m(P0), (ie, De) => (g(), v("span", {
            key: ie.key,
            ref_for: !0,
            ref: (xe) => {
              xe && (T[De] = xe);
            },
            class: "ob-intro-aspect"
          }, [
            De > 0 ? (g(), v("i", YIe)) : E("", !0),
            X(A(ie.label), 1)
          ]))), 128))
        ], 512)
      ]),
      h("button", {
        ref_key: "skipBtn",
        ref: k,
        class: "ob-intro-skip",
        "data-testid": "tour-intro-skip",
        onClick: Y[0] || (Y[0] = (ie) => m(t).skipIntro())
      }, [...Y[3] || (Y[3] = [
        X(" Skip intro", -1),
        h("kbd", { class: "ob-key" }, "Esc", -1)
      ])], 512)
    ], 544));
  }
}), Ab = ["#9968df", "#c750ce", "#a3a7f5", "#5a61ed", "#d6c2f2", "#ffd27a"], JIe = 1500, ZIe = 2.4, QIe = 420;
function Pb(n, e = Math.random) {
  const t = n.count == null ? 120 : n.count, i = n.angle == null ? -Math.PI / 2 : n.angle, s = n.spread == null ? Math.PI / 2.2 : n.spread, o = n.power == null ? 1250 : n.power, r = [];
  for (let a = 0; a < t; a++) {
    const l = i + (e() - 0.5) * s, d = o * (0.45 + e() * 0.55);
    r.push({
      x: n.x,
      y: n.y,
      vx: Math.cos(l) * d,
      vy: Math.sin(l) * d,
      rot: e() * Math.PI * 2,
      vr: (e() - 0.5) * 14,
      flip: e() * Math.PI * 2,
      vf: 6 + e() * 10,
      w: 6 + e() * 6,
      h: 3 + e() * 4,
      color: Ab[Math.floor(e() * Ab.length) % Ab.length],
      life: 1,
      span: 1.9 + e() * 0.8
    });
  }
  return r;
}
function eAe(n, e) {
  const t = Math.max(0, 1 - ZIe * e), i = [];
  for (const s of n)
    s.vx *= t, s.vy = Math.min(QIe, (s.vy + JIe * e) * t), s.x += s.vx * e, s.y += s.vy * e, s.rot += s.vr * e, s.flip += s.vf * e, s.life -= e / s.span, s.life > 0 && i.push(s);
  return i;
}
function tAe(n) {
  return Math.max(0, Math.min(1, n.life * 3));
}
const nAe = ["data-bursts"], iAe = /* @__PURE__ */ Re({
  __name: "TourConfetti",
  props: {
    tour: {},
    reduced: { type: Boolean },
    origin: {}
  },
  setup(n) {
    const e = n, t = /* @__PURE__ */ new Set(["run", "chat-run"]), i = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(0);
    let o = [], r = 0, a = 0;
    function l(c) {
      const u = i.value;
      if (!u) {
        r = 0;
        return;
      }
      const p = Math.min(0.05, a ? (c - a) / 1e3 : 0.016);
      a = c, o = eAe(o, p);
      const f = window.devicePixelRatio || 1, y = window.innerWidth, b = window.innerHeight;
      (u.width !== Math.round(y * f) || u.height !== Math.round(b * f)) && (u.width = Math.round(y * f), u.height = Math.round(b * f));
      const w = u.getContext("2d");
      if (!w) {
        r = 0;
        return;
      }
      w.setTransform(f, 0, 0, f, 0, 0), w.clearRect(0, 0, y, b);
      for (const k of o)
        w.save(), w.globalAlpha = tAe(k), w.translate(k.x, k.y), w.rotate(k.rot), w.scale(Math.cos(k.flip), 1), w.fillStyle = k.color, w.fillRect(-k.w / 2, -k.h / 2, k.w, k.h), w.restore();
      o.length ? r = requestAnimationFrame(l) : (r = 0, a = 0, w.clearRect(0, 0, y, b));
    }
    function d(c) {
      s.value++, !e.reduced && (o = o.concat(c), r || (r = requestAnimationFrame(l)));
    }
    return $e(
      () => [e.tour.step.value.id, e.tour.phase.value],
      ([c, u], p) => {
        const [f, y] = p || ["", ""];
        if (u === "success" && y !== "success" && t.has(c)) {
          const b = e.origin || { x: window.innerWidth / 2, y: window.innerHeight * 0.55 };
          d(Pb({ x: b.x, y: b.y, count: 110, power: 1100 }));
        } else if (c === "finale" && f !== "finale") {
          const b = window.innerHeight, w = window.innerWidth;
          d([
            ...Pb({ x: w * 0.04, y: b * 0.96, angle: -Math.PI / 2 + 0.5, spread: Math.PI / 4, power: 1500, count: 90 }),
            ...Pb({ x: w * 0.96, y: b * 0.96, angle: -Math.PI / 2 - 0.5, spread: Math.PI / 4, power: 1500, count: 90 })
          ]);
        }
      }
    ), Ve(() => {
      r && cancelAnimationFrame(r);
    }), (c, u) => (g(), v("canvas", {
      ref_key: "canvas",
      ref: i,
      class: "ob-confetti",
      "aria-hidden": "true",
      "data-testid": "tour-confetti",
      "data-bursts": s.value
    }, null, 8, nAe));
  }
}), sAe = ["data-step", "data-phase"], oAe = ["width", "height", "viewBox"], rAe = ["width", "height"], aAe = ["width", "height"], lAe = ["x", "y", "width", "height", "rx", "fill-opacity"], dAe = ["width", "height"], cAe = ["width", "height"], uAe = ["d"], hAe = ["cx", "cy"], pAe = /* @__PURE__ */ Re({
  __name: "TourLayer",
  props: {
    tour: {},
    busy: { type: Boolean },
    error: {}
  },
  setup(n) {
    const t = n.tour, i = Yy(), { holes: s, exact: o } = YSe(t.targets, t.board, i), r = /* @__PURE__ */ K({ w: window.innerWidth, h: window.innerHeight }), a = () => {
      r.value = { w: window.innerWidth, h: window.innerHeight };
    };
    ot(() => window.addEventListener("resize", a)), Ve(() => window.removeEventListener("resize", a));
    const l = I(() => t.step.value), d = I(() => l.value.id), c = I(() => d.value === "welcome" || d.value === "finale"), u = I(() => d.value === "welcome" ? 0.5 : d.value === "finale" ? 0.46 : d.value === "organize" ? 0.18 : 0.32), p = /* @__PURE__ */ K({ w: 380, h: 420 }), f = I(() => t.cardPlace.value), y = I(() => {
      const P = f.value.anchor;
      if (P) return o.value.find(($) => $.key === P) || null;
      const D = t.targets.value.filter(($) => !$.look).map(($) => $.key);
      return S4(o.value.filter(($) => D.includes($.key)));
    }), b = I(() => f.value.place === "center" ? [] : o.value.map((P) => ({ x: P.x, y: P.y, w: P.w, h: P.h }))), w = I(() => QSe(f.value.place, f.value.place === "center" ? null : y.value, p.value, r.value, b.value)), k = I(() => f.value.place === "center" || f.value.place === "bottom-center"), S = I(() => f.value.place === "bottom-center" || r.value.h < 820 && f.value.place !== "top-right" && f.value.place !== "center"), _ = I(() => t.phase.value === "success"), x = I(() => {
      const P = S4(o.value);
      return P ? { x: P.x + P.w / 2, y: P.y + P.h / 2 } : null;
    }), T = /* @__PURE__ */ K(0);
    $e(() => t.nudges.value, () => {
      T.value++;
    });
    const M = I(() => {
      if (d.value !== "drag" || t.phase.value === "success") return null;
      const P = o.value.find((J) => J.key === "pick"), D = o.value.find((J) => J.key === "slot");
      if (!P || !D) return null;
      const $ = { x: P.x + P.w / 2, y: P.y + P.h / 2 }, O = { x: D.x + D.w * 0.62, y: D.y + D.h * 0.42 }, L = Math.min(160, Math.abs($.x - O.x) * 0.35 + 40), Z = { x: ($.x + O.x) / 2, y: Math.min($.y, O.y) - L };
      return { d: "M" + $.x + " " + $.y + " Q " + Z.x + " " + Z.y + " " + O.x + " " + O.y, to: O };
    }), z = (P) => ({
      left: P.x + "px",
      top: P.y + "px",
      width: P.w + "px",
      height: P.h + "px",
      borderRadius: P.r + "px"
    });
    return (P, D) => (g(), v("div", {
      class: U(["bd-root ob-layer", { "is-own": c.value, "is-reduced": m(i) }]),
      "data-testid": "tour",
      "data-step": d.value,
      "data-phase": m(t).phase.value
    }, [
      (g(), v("svg", {
        class: "ob-dim",
        width: r.value.w,
        height: r.value.h,
        viewBox: "0 0 " + r.value.w + " " + r.value.h,
        "aria-hidden": "true"
      }, [
        h("defs", null, [
          h("mask", {
            id: "ob-holes",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: r.value.w,
            height: r.value.h
          }, [
            h("rect", {
              x: "0",
              y: "0",
              width: r.value.w,
              height: r.value.h,
              fill: "#fff"
            }, null, 8, aAe),
            (g(!0), v(H, null, me(m(s), ($) => (g(), v("rect", {
              key: $.key,
              x: $.x,
              y: $.y,
              width: Math.max(0, $.w),
              height: Math.max(0, $.h),
              rx: Math.max(0, $.r),
              fill: "#000",
              "fill-opacity": $.look && !$.ring ? 0.55 : 1
            }, null, 8, lAe))), 128))
          ], 8, rAe)
        ]),
        h("rect", {
          class: "ob-dim-fill",
          x: "0",
          y: "0",
          width: r.value.w,
          height: r.value.h,
          mask: "url(#ob-holes)",
          style: de({ opacity: u.value })
        }, null, 12, dAe)
      ], 8, oAe)),
      (g(!0), v(H, null, me(m(s), ($) => (g(), v(H, {
        key: "ring:" + $.key
      }, [
        $.drop ? (g(), v("div", {
          key: 0,
          class: U(["ob-slot", { "is-done": _.value }]),
          style: de({ ...z($), opacity: $.open }),
          "data-testid": "tour-drop"
        }, [
          h("span", null, A($.drop), 1)
        ], 6)) : !$.look || $.ring ? (g(), v("div", {
          key: "r" + T.value,
          class: U(["ob-ring", { "is-done": _.value, "is-nudged": T.value > 0 }]),
          style: de({ ...z($), opacity: $.open }),
          "data-testid": "tour-ring"
        }, null, 6)) : E("", !0)
      ], 64))), 128)),
      M.value ? (g(), v("svg", {
        key: 0,
        class: "ob-arc",
        width: r.value.w,
        height: r.value.h,
        "aria-hidden": "true"
      }, [
        h("path", {
          d: M.value.d
        }, null, 8, uAe),
        h("circle", {
          cx: M.value.to.x,
          cy: M.value.to.y,
          r: "4"
        }, null, 8, hAe)
      ], 8, cAe)) : E("", !0),
      C(GTe, { tour: m(t) }, null, 8, ["tour"]),
      C(vt, { name: "ob-own" }, {
        default: et(() => [
          d.value === "welcome" ? (g(), Ce(wIe, {
            key: 0,
            tour: m(t)
          }, null, 8, ["tour"])) : d.value === "finale" ? (g(), Ce($Ie, {
            key: 1,
            tour: m(t),
            busy: n.busy,
            error: n.error
          }, null, 8, ["tour", "busy", "error"])) : E("", !0)
        ]),
        _: 1
      }),
      C(vt, { name: "ob-card" }, {
        default: et(() => [
          c.value ? E("", !0) : (g(), Ce(yCe, {
            key: 0,
            tour: m(t),
            x: w.value.x,
            y: w.value.y,
            wide: k.value,
            short: S.value,
            onSize: D[0] || (D[0] = ($) => p.value = $)
          }, null, 8, ["tour", "x", "y", "wide", "short"]))
        ]),
        _: 1
      }),
      C(iAe, {
        tour: m(t),
        reduced: m(i),
        origin: x.value
      }, null, 8, ["tour", "reduced", "origin"]),
      C(vt, { name: "ob-intro" }, {
        default: et(() => [
          m(t).intro.value ? (g(), Ce(XIe, {
            key: 0,
            tour: m(t)
          }, null, 8, ["tour"])) : E("", !0)
        ]),
        _: 1
      })
    ], 10, sAe));
  }
}), fAe = /* @__PURE__ */ Re({
  __name: "OnboardingApp",
  props: {
    env: {},
    tour: {},
    busy: {},
    error: {}
  },
  setup(n) {
    return (e, t) => (g(), v(H, null, [
      C(ZI, { env: n.env }, null, 8, ["env"]),
      C(pAe, {
        tour: n.tour,
        busy: n.busy.value,
        error: n.error.value
      }, null, 8, ["tour", "busy", "error"])
    ], 64));
  }
});
var mAe = Object.defineProperty, gAe = (n, e, t) => e in n ? mAe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Ph = (n, e, t) => gAe(n, typeof e != "symbol" ? e + "" : e, t);
const bAe = (n) => new Promise((e) => window.setTimeout(e, n)), vAe = "There are no photos in this frame for me to work with. Move this chat back into the Site photos frame, and ask again.";
function yAe(n) {
  const e = n.catalog.search(fA)[0], t = n.context.images.filter((s) => !s.video && !s.kind);
  if (!e || !t.length) return null;
  const i = e.model.fields.find((s) => s.kind === "size" && (s.options || []).some((o) => o.value === Ia.size));
  return {
    title: Ia.title,
    place: !0,
    sessions: [{
      name: Ia.session,
      modelId: e.id,
      job: "generate",
      prompt: Ia.prompt,
      n: 1,
      runs: t.map((s) => ({ imageIds: [s.id] })),
      ...i ? { settings: { [i.label]: Ia.size } } : {},
      why: Ia.why
    }]
  };
}
class xAe {
  constructor(e = {}) {
    Ph(this, "id", "tour"), Ph(this, "label", "Assistant"), Ph(this, "pace"), Ph(this, "sleep"), this.pace = e.pace == null ? 1 : e.pace, this.sleep = e.sleep || bAe;
  }
  wait(e) {
    return this.pace > 0 ? this.sleep(e * this.pace) : Promise.resolve();
  }
  async *say(e, t) {
    for (const i of Y6(e)) {
      if (t.aborted) return;
      yield { type: "text", delta: i }, await this.wait(26);
    }
  }
  // Its status lines hold long enough to read (IL-100): a first-timer is
  // reading the card beside the chat as well, and at a model's own pace
  // (1.1 s, 0.5 s) they went by unread.
  async *turn(e, t) {
    if (e.input.kind === "plan-ended") {
      yield { type: "status", text: "Looking at what it made…" }, await this.wait(1500), yield* this.say(fTe, t);
      return;
    }
    if (yield { type: "status", text: "Reading the frame…" }, await this.wait(2e3), t.aborted) return;
    const i = yAe(e);
    if (!i) {
      yield* this.say(vAe, t);
      return;
    }
    yield* this.say(pTe, t), !t.aborted && (yield { type: "status", text: "Pricing the plan…" }, await this.wait(1300), !t.aborted && (yield { type: "plan", plan: i }));
  }
}
const dc = { w: 316, h: 176 }, bf = 28, xA = 96, wA = (n) => "tour-" + n;
function wAe(n) {
  const e = tu.find((t) => wA(t.id) === n);
  return e ? e.id : null;
}
const Ti = {
  id: "tour-site",
  type: "frame",
  title: "Site photos",
  z: 0,
  x: 0,
  y: 0,
  w: bf + tu.length * (dc.w + bf),
  h: xA + dc.h + 40
}, To = {
  id: "tour-brief",
  type: "note",
  tint: "amber",
  text: dTe,
  author: cTe,
  z: 1,
  x: Ti.x + Ti.w + 48,
  y: 64,
  w: 236,
  h: 196
}, Eb = {
  x: To.x + To.w + 64 + Tt.w / 2,
  y: To.y + To.h / 2
};
function kAe() {
  const n = tu.map((e, t) => ({
    id: wA(e.id),
    type: "image",
    src: e.src,
    label: e.label,
    z: 2 + t,
    x: Ti.x + bf + t * (dc.w + bf),
    y: Ti.y + xA,
    w: dc.w,
    h: dc.h
  }));
  return { title: pA, elements: [Ti, To, ...n], results: [] };
}
var _Ae = Object.defineProperty, SAe = (n, e, t) => e in n ? _Ae(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Mt = (n, e, t) => SAe(n, typeof e != "symbol" ? e + "" : e, t);
const kA = { enter: 520, success: 780, fly: 900, intro: jc * 1e3, chatRun: 2400 };
function TAe(n, e) {
  const t = (n.title + " " + n.body).split(/\s+/).filter(Boolean).length, i = Math.min(4600, t * 230) * (e / kA.success);
  return Math.round(Math.max(e * 1.8, i));
}
const MAe = /* @__PURE__ */ new Set(["contextmenu", "dblclick", "auxclick"]), CAe = /* @__PURE__ */ new Set(["Shift", "Meta", "Control", "Alt", "CapsLock", "Fn", "OS", "Hyper", "Super"]), ti = (n) => () => document.querySelector(n), B4 = '[data-testid="studio-stage"] .sv-pic', IAe = {
  session: '.up-card [data-testid="prompt-text"]',
  edit: '[data-testid="studio-edit-prompt"]',
  chat: '[data-testid="chat-input"]'
};
class AAe {
  constructor(e) {
    Mt(this, "reason"), Mt(this, "canSkip"), Mt(this, "boardRef"), Mt(this, "step", /* @__PURE__ */ We(ts[0])), Mt(this, "index", /* @__PURE__ */ We(0)), Mt(this, "phase", /* @__PURE__ */ We("enter")), Mt(this, "nudges", /* @__PURE__ */ We(0)), Mt(this, "nudgeHint", /* @__PURE__ */ We("")), Mt(this, "toolId", /* @__PURE__ */ We(null)), Mt(this, "placedId", /* @__PURE__ */ We(null)), Mt(this, "chatId", /* @__PURE__ */ We(null)), Mt(this, "asked", /* @__PURE__ */ We(!1)), Mt(this, "typingField", /* @__PURE__ */ We(null)), Mt(this, "board", /* @__PURE__ */ We(null)), Mt(this, "intro", /* @__PURE__ */ We(null)), Mt(this, "hooks"), Mt(this, "opts"), Mt(this, "timing"), Mt(this, "tabs", /* @__PURE__ */ Xt({ session: 0, edit: 0, chat: 0 })), Mt(this, "timers", []), Mt(this, "stops", []), Mt(this, "stepStops", []), Mt(this, "started", !1), Mt(this, "disposed", !1), Mt(this, "listening", !1), Mt(this, "rt", {}), Mt(this, "boardTick", /* @__PURE__ */ We(0)), Mt(this, "waiting", I(() => (this.step.value, this.boardTick.value, this.phase.value === "task" && !!this.rt.waiting && this.rt.waiting()))), Mt(this, "targets", I(() => (this.step.value, this.board.value, this.toolId.value, this.placedId.value, this.phase.value, this.waiting.value, this.rt.targets ? this.rt.targets() : []))), Mt(this, "cardPlace", I(() => (this.step.value, this.phase.value, this.waiting.value, this.rt.card ? this.rt.card() : { place: this.step.value.place }))), Mt(this, "onKey", (i) => {
      if (CAe.has(i.key) || PAe(i) || !this.inScope(i.target)) return;
      if (this.intro.value) {
        i.preventDefault(), i.stopImmediatePropagation(), !i.repeat && (i.key === "Escape" || i.key === "Enter" || i.key === " ") && this.skipIntro();
        return;
      }
      const s = i.target, o = !!(s && s.closest && s.closest("[data-tour-ui]")), r = this.step.value;
      if (o && (i.key === "Enter" || i.key === " " || i.key === "Tab" && r.kind !== "tab")) return;
      const a = this.phase.value === "task" && this.rt.key ? this.rt.key(i) : void 0;
      if (a !== "pass" && (i.preventDefault(), i.stopImmediatePropagation(), !(a === "handled" || i.repeat))) {
        if (this.phase.value === "task" && r.kind === "continue" && i.key === "Enter") {
          this.next();
          return;
        }
        this.phase.value === "task" && this.nudge(U4(r));
      }
    }), Mt(this, "onPointer", (i) => {
      const s = i.target;
      this.inScope(s) && (s && s.closest && s.closest("[data-tour-ui]") || i.type !== "wheel" && !MAe.has(i.type) && this.phase.value === "task" && this.rt.hands && this.inTargets(s, i) || (i.cancelable && i.preventDefault(), i.stopImmediatePropagation(), i.type === "pointerdown" && this.phase.value === "task" && this.step.value.kind !== "continue" && this.nudge(U4(this.step.value))));
    }), this.opts = e, this.reason = e.reason, this.canSkip = e.canSkip, this.boardRef = e.board, this.timing = { ...kA, ...e.reducedMotion ? { fly: 0, enter: 200, intro: 0 } : {}, ...e.timing || {} }, this.intro.value = this.timing.intro > 0 ? "waiting" : null;
    const t = this;
    this.hooks = {
      chat: e.chat || new xAe(),
      lineFor(i, s) {
        const o = t.step.value.id;
        return i === "chat" ? s === t.chatId.value && o === "chat-tab" ? hTe : null : s !== t.toolId.value ? null : i === "session" ? o === "tab-prompt" ? C4 : null : o === "edit-tab" ? I4 : null;
      },
      holds(i, s) {
        return i === "chat" ? s === t.chatId.value && t.index.value >= N4("chat-tab") : s !== t.toolId.value ? !1 : t.index.value >= N4(i === "session" ? "tab-prompt" : "edit-tab");
      },
      tabbed(i) {
        return t.tabs[i];
      },
      typing(i, s) {
        t.typingField.value = s ? i : null, i === "chat" && !s && (t.asked.value = !0);
      },
      landing() {
        return t.step.value.id === "add-session" ? { ...Eb } : null;
      },
      press(i) {
        const s = t.step.value.id;
        t.phase.value !== "task" || t.typingField.value === i || (i === "session" && s === "tab-prompt" || i === "edit" && s === "edit-tab" || i === "chat" && s === "chat-tab") && t.tabs[i]++;
      }
    };
  }
  /** the tour began: its practice board opened and is drawing */
  get isStarted() {
    return this.started;
  }
  // ---------------------------------------------------------------- the board
  /** The practice board's controller, as it opens (and again, if the tour starts over on a new one). */
  attach(e) {
    for (const t of this.stops) t();
    this.stops = [], this.board.value = e, e && (e.tour = this.hooks, this.stops.push($e(() => e.results.rev.value, () => {
      this.boardTick.value++;
    })), this.stops.push($e(() => e.loaded.value, (t) => {
      if (!t || this.started) return;
      const i = () => {
        if (!(this.disposed || this.started || this.board.value !== e)) {
          if (!e.engine) {
            requestAnimationFrame(i);
            return;
          }
          this.started = !0, this.listen(), this.opts.onProgress && this.opts.onProgress({ status: "started", step: ts[0].id }), this.go(0);
        }
      };
      i();
    }, { immediate: !0 })));
  }
  /** Back to the welcome, on a fresh board (the finale's Take the tour again). */
  reset() {
    this.clearStep(), this.started = !1, this.toolId.value = null, this.placedId.value = null, this.chatId.value = null, this.asked.value = !1, this.typingField.value = null, this.tabs.session = 0, this.tabs.edit = 0, this.tabs.chat = 0, this.index.value = 0, this.step.value = ts[0], this.phase.value = "enter";
  }
  dispose() {
    this.disposed = !0, this.clearStep();
    for (const t of this.stops) t();
    this.stops = [], this.unlisten();
    const e = this.board.value;
    e && e.tour === this.hooks && (e.tour = null);
  }
  // ---------------------------------------------------------------- playing
  go(e) {
    if (this.disposed) return;
    this.clearStep();
    const t = ts[Math.max(0, Math.min(ts.length - 1, e))];
    if (this.index.value = ts.indexOf(t), this.step.value = t, this.nudgeHint.value = "", this.rt = this.runtime(t.id), this.phase.value = "enter", this.rt.enter && this.rt.enter(), t.id === "finale" && this.opts.onProgress && this.opts.onProgress({ status: "completed", step: t.id }), t.id === "welcome" && this.intro.value === "waiting") {
      this.intro.value = "playing", this.later(() => this.introDone(), this.timing.intro + 4e3);
      return;
    }
    t.id !== "welcome" && (this.intro.value = null), this.later(() => this.arrive(), this.timing.enter);
  }
  /** The step has arrived: it takes input, and watches the board for being done. */
  arrive() {
    const e = this.step.value;
    this.phase.value = e.id === "finale" ? "finished" : "task";
    const t = this.rt;
    t.done && this.stepStops.push($e(() => (this.boardTick.value, t.done()), (i) => {
      i && this.phase.value === "task" && this.succeed();
    }, { immediate: !0 })), t.watchStray && t.watchStray();
  }
  /** The opening has played (or was skipped): the welcome takes over. */
  introDone() {
    this.intro.value === "playing" && (this.intro.value = null, this.step.value.id === "welcome" && this.phase.value === "enter" && this.arrive());
  }
  /** Skip intro (its button, Esc, Enter or Space) while it plays. */
  skipIntro() {
    this.introDone();
  }
  /** The step is done: a beat, then the next (long enough to read, when a run has landed and says so). */
  succeed() {
    if (this.phase.value !== "task") return;
    this.rt.onDone && this.rt.onDone(), this.phase.value = "success";
    const e = this.index.value, t = this.step.value.landed;
    this.later(() => {
      this.index.value === e && this.go(e + 1);
    }, t ? TAe(t, this.timing.success) : this.timing.success);
  }
  /** The harness and tests: straight to a step (its board readied as the step readies it). */
  goTo(e) {
    const t = ts.findIndex((i) => i.id === e);
    t >= 0 && this.go(t);
  }
  /** Continue (the button, or Enter), on a step that only says something. */
  next() {
    this.phase.value !== "task" || this.step.value.kind !== "continue" || this.go(this.index.value + 1);
  }
  /** Skip (or Exit): only where it's offered. */
  skip() {
    !this.canSkip || this.disposed || (this.opts.onProgress && this.opts.onProgress({ status: "skipped", step: this.step.value.id }), this.opts.onExit("skip"));
  }
  /** The finale's way out. */
  finish(e) {
    this.phase.value === "finished" && this.opts.onExit(e);
  }
  /** The finale's Take the tour again. */
  again() {
    this.phase.value === "finished" && this.opts.restart && this.opts.restart();
  }
  clearStep() {
    for (const e of this.timers) clearTimeout(e);
    this.timers = [];
    for (const e of this.stepStops) e();
    this.stepStops = [], this.rt = {};
  }
  later(e, t) {
    this.timers.push(window.setTimeout(e, t));
  }
  nudge(e = "") {
    this.nudgeHint.value = e, this.nudges.value++;
  }
  // ---------------------------------------------------------------- the steps
  tool() {
    const e = this.board.value, t = this.toolId.value, i = e && t ? e.store.get(t) : null;
    return i && i.type === "tool" ? i : null;
  }
  studio() {
    const e = this.board.value, t = this.toolId.value;
    return e && t ? p0(e, t) : null;
  }
  results() {
    const e = this.board.value, t = this.toolId.value;
    return !e || !t ? [] : (this.boardTick.value, e.results.list(t));
  }
  runtime(e) {
    const t = this.board.value;
    switch (e) {
      case "welcome":
        return {
          enter: () => {
            t.clearSelection(), this.flyTo(hp([Ti, To]), { zoom: 0.62, ax: 0.5, ay: 0.46 });
          }
        };
      case "look":
        return {
          enter: () => {
            t.clearSelection(), this.flyTo(hp([Ti, To]), { fit: 0.84, maxZoom: 0.95, ax: 0.5, ay: 0.4 });
          },
          targets: () => [
            { key: "site", world: () => this.rectOf(Ti.id), pad: 10, padTop: 40, radius: 18 },
            { key: "brief", world: () => this.rectOf(To.id), pad: 10, radius: 18 }
          ]
        };
      case "add-session":
        return {
          enter: () => {
            t.clearSelection(), this.flyTo({ x: Eb.x - 1, y: Eb.y - 1, w: 2, h: 2 }, { zoom: 0.8, ax: 0.68, ay: 0.28 });
          },
          targets: () => [{ key: "image-gen", el: ti('[data-testid="image-gen"]'), pad: 6, radius: 14 }],
          hands: !0,
          done: () => !!this.addedTool(),
          onDone: () => {
            const i = this.addedTool();
            i && this.adopt(i);
          }
        };
      case "open-session":
        return {
          enter: () => {
            const i = this.tool();
            i && this.flyTo(qe(i), { zoom: 1.12, ax: 0.3, ay: 0.34 });
          },
          targets: () => [{ key: "session", el: () => this.sessionCard(), pad: 8, radius: 22 }],
          hands: !0,
          done: () => !!t.promptTool.value && t.promptTool.value.id === this.toolId.value
        };
      case "tab-prompt":
        return {
          enter: () => {
            this.keepOpen(), this.focusField("session");
          },
          targets: () => [{ key: "prompt", box: () => Eh('.up-card [data-testid="prompt-text"]', '.up-card [data-testid="ghost-cue"]'), pad: 12, radius: 14 }],
          hands: !0,
          done: () => {
            t.promptRev.value;
            const i = this.toolId.value;
            return !!i && t.promptOf(i).prompt === C4 && this.typingField.value !== "session";
          },
          key: (i) => this.tabKey(i, "session")
        };
      case "run":
        return {
          enter: () => {
            this.keepOpen(), this.opts.gen.planned || this.opts.gen.plan(qy);
          },
          // once it runs, the light moves to where the images land, and stays there as they
          // land (the success beat), so nothing jumps back to Run before the next step
          targets: () => this.results().length > 0 ? [
            { key: "session", el: () => this.sessionCard(), pad: 8, radius: 22, look: !0, ring: !0 },
            { key: "gallery", box: () => this.galleryBox(), pad: 6, radius: 16, look: !0 }
          ] : [{ key: "run", el: ti('[data-testid="run"]'), pad: 6, radius: 14 }],
          hands: !0,
          waiting: () => this.results().some((i) => i.status === "pending"),
          done: () => this.results().filter((i) => i.status === "done").length >= A4,
          key: (i) => this.runKey(i, '[data-testid="run"]'),
          card: () => this.results().length > 0 ? { place: "right", anchor: "session" } : { place: "above" }
        };
      case "results":
        return {
          enter: () => {
            this.keepOpen(), t.ui.histOpen = !0;
          },
          targets: () => [
            { key: "session", el: () => this.sessionCard(), pad: 8, radius: 22 },
            { key: "gallery", box: () => this.galleryBox(), pad: 6, radius: 16 }
          ],
          card: () => ({ place: "right", anchor: "session" })
        };
      case "drag":
        return {
          enter: () => {
            this.keepOpen(), t.ui.histOpen = !0;
          },
          targets: () => [
            { key: "gallery", box: () => this.galleryBox(), pad: 6, radius: 16 },
            { key: "pick", el: ti('[data-testid="results-gallery"] .shot'), pad: 0, radius: 10, look: !0 },
            { key: "slot", world: () => this.dropSlot(), pad: 0, radius: 16, drop: "Drop it here", look: !0 },
            // the session the picture came from, beside where it goes; its pictures drag out
            // as the gallery's do (CHAT-03: lit, and saying so as you hovered, but they stuck)
            { key: "session", el: () => this.sessionCard(), pad: 8, radius: 22, look: !0, takes: ".cv-thumb-pull" }
          ],
          card: () => ({ place: "below", anchor: "slot" }),
          hands: !0,
          // dropped, not just carried over the board (the board makes the picture as the drag
          // crosses the canvas, and takes it back if it's carried off again)
          done: () => !!this.placedImage() && !t.ui.dragging,
          onDone: () => {
            const i = this.placedImage();
            i && (this.placedId.value = i.id);
          },
          watchStray: () => {
            this.stepStops.push($e(() => t.ui.infoAt, (i) => {
              i && (t.ui.infoAt = null, this.nudge("Hold the picture, then drag it onto the board"));
            }));
          }
        };
      case "studio-open":
        return {
          enter: () => {
            this.keepOpen();
          },
          targets: () => [{ key: "studio", el: ti(".up-studio-wrap"), pad: 6, radius: 999 }],
          hands: !0,
          done: () => !!t.ui.studio && t.ui.studio.sessionId === this.toolId.value
        };
      case "edit-side":
        return {
          enter: () => {
            const i = this.studio(), s = this.placedResultId();
            i && s && this.later(() => i.show(s), 60);
          },
          targets: () => [{ key: "edit", el: ti('[data-testid="studio-side-edit"]'), pad: 5, radius: 12 }],
          hands: !0,
          done: () => {
            const i = this.studio();
            return !!i && i.side.value === "edit";
          }
        };
      case "edit-tab":
        return {
          enter: () => this.focusField("edit"),
          targets: () => [{ key: "words", box: () => Eh('[data-testid="studio-edit-prompt"]', '[data-testid="studio-ghost-cue"]'), pad: 10, radius: 14 }],
          hands: !0,
          done: () => {
            const i = this.studio();
            return !!i && i.askOf(i.s.stageId) === I4 && this.typingField.value !== "edit";
          },
          key: (i) => this.tabKey(i, "edit")
        };
      case "edit-run":
        return {
          enter: () => {
            this.opts.gen.planned || this.opts.gen.plan([Nd]);
          },
          // once it runs, the light moves to the picture, where the new version arrives, and
          // stays there as it lands
          targets: () => this.results().some((i) => i.status === "pending" || i.url === Nd.src) ? [{ key: "stage", el: ti(B4), pad: 10, padTop: 32, radius: 16, look: !0, ring: !0 }] : [{ key: "run", el: ti('[data-testid="studio-edit-generate"]'), pad: 6, radius: 14 }],
          hands: !0,
          waiting: () => this.results().some((i) => i.status === "pending"),
          done: () => this.results().some((i) => i.status === "done" && i.url === Nd.src),
          key: (i) => this.runKey(i, '[data-testid="studio-edit-generate"]')
        };
      case "edit-result":
        return {
          enter: () => {
            const i = this.studio(), s = this.results().find((o) => o.status === "done" && o.url === Nd.src);
            i && s && i.s.stageId !== s.id && i.show(s.id);
          },
          targets: () => [
            // the picture (and its tag), not the whole stage round it, as while the edit ran: the card keeps its
            // corner from the run, with no flight across the window
            { key: "stage", el: ti(B4), pad: 10, padTop: 32, radius: 16 },
            // the versions themselves, not their whole bar
            { key: "versions", box: () => E0(Array.from(document.querySelectorAll('[data-testid="studio-version"]'))), pad: 6, radius: 14 }
          ]
        };
      case "chat-open":
        return {
          enter: () => {
            this.closeStudio(), t.ui.histOpen = !1, t.select([Ti.id]), this.flyTo(this.rectOf(Ti.id), { fitW: 0.42, fitH: 0.5, maxZoom: 0.58, ax: 0.28, ay: 0.42 });
          },
          targets: () => [
            { key: "chat", el: ti('[data-testid="ctx-chat"]'), pad: 6, radius: 12 },
            { key: "site", world: () => this.rectOf(Ti.id), pad: 10, padTop: 40, radius: 18, look: !0 }
          ],
          hands: !0,
          done: () => !!this.openChat(),
          onDone: () => {
            const i = this.openChat();
            i && (this.chatId.value = i.id);
          },
          card: () => ({ place: "right", anchor: "site" })
        };
      case "chat-tab":
        return {
          enter: () => this.focusField("chat"),
          targets: () => [{ key: "ask", box: () => Eh('[data-testid="chat-input"]', '[data-testid="chat-ghost-cue"]'), pad: 10, radius: 14 }],
          hands: !0,
          done: () => this.asked.value && this.typingField.value !== "chat",
          key: (i) => this.tabKey(i, "chat")
        };
      case "chat-send":
        return {
          // once it's sent, the light moves to where the answer arrives, and stays there as the plan lands;
          // till then the card keeps clear of the message it asks you to send
          targets: () => this.sent() ? [{ key: "answer", el: ti('[data-testid="chat-panel"] .ch-scroll'), pad: 0, radius: 14, look: !0, ring: !0 }] : [
            { key: "send", el: ti('[data-testid="chat-send"]'), pad: 6, radius: 999 },
            { key: "ask", box: () => Eh('[data-testid="chat-input"]', '[data-testid="chat-send"]'), pad: 10, radius: 14, look: !0 }
          ],
          hands: !0,
          waiting: () => this.chatBusy(),
          done: () => !!this.chatPlan("proposed"),
          key: (i) => this.sendKey(i),
          card: () => ({ place: "left", anchor: this.sent() ? "answer" : "ask" })
        };
      case "chat-run":
        return {
          enter: () => this.planChatRuns(),
          // once it runs, the light moves to the frame, where the work lands, and to the plan's rows ticking
          targets: () => this.chatPlan("started") ? [
            { key: "frame", world: () => this.rectOf(Ti.id), pad: 10, padTop: 40, radius: 18, look: !0, ring: !0 },
            { key: "steps", el: ti('[data-testid="chat-panel"] [data-testid="plan-steps"]'), pad: 6, radius: 12, look: !0 }
          ] : [
            { key: "plan-run", el: ti('[data-testid="chat-panel"] [data-testid="plan-run"]'), pad: 6, radius: 12 },
            // the whole plan shows, and the card keeps off it (its prompt, its cost, Cancel)
            { key: "plan", el: ti('[data-testid="chat-panel"] [data-testid="plan-card"]'), pad: 4, radius: 14, look: !0 }
          ],
          hands: !0,
          waiting: () => !!this.chatPlan("started") && !this.chatSettled(),
          // the plan has run and the chat has said how it went
          done: () => this.chatSettled(),
          key: (i) => this.runKey(i, '[data-testid="chat-panel"] [data-testid="plan-run"]'),
          card: () => ({ place: "left", anchor: this.chatPlan("started") ? "steps" : "plan" })
        };
      case "chat-result":
        return {
          targets: () => [{ key: "made", world: () => this.chatWork(), pad: 12, radius: 18 }],
          card: () => ({ place: "left", anchor: "made" })
        };
      case "organize":
        return {
          enter: () => {
            this.closeStudio(), t.ui.chatOpen = null, t.clearSelection(), t.ui.histOpen = !1;
            const i = t.store.bounds(), s = Math.max(160, t.view.h - Nc - 320);
            i && this.flyTo(i, { fitW: 0.84, fitH: s / t.view.h, maxZoom: 0.9, ax: 0.5, ay: (Nc + 6 + s / 2) / t.view.h });
          },
          targets: () => [{ key: "board", world: () => t.store.bounds(), pad: 26, radius: 24, look: !0 }]
        };
      case "finale":
        return {
          enter: () => {
            t.clearSelection();
            const i = t.store.bounds();
            i && this.flyTo(i, { fit: 0.7, maxZoom: 0.9, ax: 0.5, ay: 0.5 });
          }
        };
    }
    return {};
  }
  /** The session Image Gen added (the board holds no other). */
  addedTool() {
    const e = this.board.value;
    if (!e) return null;
    e.docRev.value;
    for (const t of e.store.all()) if (t.type === "tool") return t;
    return null;
  }
  /** The session the tour had you add, set to make four, waiting closed on the board. */
  adopt(e) {
    const t = this.board.value;
    this.toolId.value = e.id, t.setPrompt(e.id, { n: A4 }), t.clearSelection();
  }
  /** The session's prompt stays up while the steps need it. */
  keepOpen() {
    const e = this.board.value, t = this.toolId.value;
    !e || !t || (!e.promptTool.value || e.promptTool.value.id !== t) && e.select([t]);
  }
  sessionCard() {
    const e = this.toolId.value;
    return e ? document.querySelector('[data-el="' + e + '"] .cv-bucket') || document.querySelector('[data-el="' + e + '"]') : null;
  }
  rectOf(e) {
    const t = this.board.value, i = t ? t.store.get(e) : null;
    return i ? qe(i) : null;
  }
  /** The gallery's pictures and its head, as one box (not the empty panel below them). */
  galleryBox() {
    const e = document.querySelector('[data-testid="results-gallery"]');
    if (!e) return null;
    const t = Array.from(e.querySelectorAll(".v2-hist-head, .v2-hist-item"));
    return E0(t.length ? t : [e]);
  }
  /** Where the drag step suggests the picture goes: right of the session. */
  dropSlot() {
    const e = this.tool();
    if (!e) return null;
    const t = 236;
    return { x: e.x + e.w + 56, y: e.y + e.h / 2 - t * Ah.h / Ah.w / 2, w: t, h: Math.round(t * Ah.h / Ah.w) };
  }
  /** A picture on the board placed from the session's gallery. */
  placedImage() {
    const e = this.board.value, t = this.toolId.value;
    if (!e || !t) return null;
    e.docRev.value;
    const i = new Set(this.results().map((s) => s.id));
    for (const s of e.store.all()) {
      if (s.type !== "image") continue;
      const o = s;
      if (o.sessionId === t || o.resultId && i.has(o.resultId)) return o;
    }
    return null;
  }
  placedResultId() {
    const e = this.board.value, t = this.placedId.value, i = e && t ? e.store.get(t) : void 0;
    if (i && i.resultId) return i.resultId;
    const s = this.results().find((o) => o.status === "done");
    return s ? s.id : null;
  }
  focusField(e) {
    this.later(() => {
      const t = document.querySelector(IAe[e]);
      t && document.activeElement !== t && t.focus({ preventScroll: !0 });
    }, 80);
  }
  /** Done with Studio view: closed, as its back arrow closes it. */
  closeStudio() {
    const e = this.board.value;
    !e || !e.ui.studio || (p0(e, e.ui.studio.sessionId).leave(), e.closeStudio());
  }
  /** The chat open in the panel (Chat on the frame made it). */
  openChat() {
    const e = this.board.value;
    if (!e) return null;
    e.docRev.value;
    const t = e.ui.chatOpen, i = t ? e.store.get(t) : void 0;
    return i && i.type === "chat" ? i : null;
  }
  /** The chat you started, as it stands. */
  chat() {
    const e = this.board.value, t = this.chatId.value;
    if (!e || !t) return null;
    e.docRev.value;
    const i = e.store.get(t);
    return i && i.type === "chat" ? i : null;
  }
  /** Your message is in the chat. */
  sent() {
    const e = this.chat();
    return !!e && (e.messages || []).some((t) => t.role === "user");
  }
  /** The chat is answering. */
  chatBusy() {
    const e = this.board.value, t = this.chatId.value;
    return !!e && !!t && fs(e).busy(t);
  }
  /** Its plan: waiting for Run plan (`proposed`), or run, running or done (`started`). */
  chatPlan(e) {
    const t = this.chat(), i = t && t.messages || [];
    for (let s = i.length - 1; s >= 0; s--) {
      const o = i[s].plan;
      if (o && (e === "proposed" ? o.status === "proposed" : o.status !== "proposed" && o.status !== "cancelled")) return o;
    }
    return null;
  }
  /** The plan has run, and the chat has said how it went. */
  chatSettled() {
    const e = this.chatPlan("started");
    return !!e && e.status === "done" && !this.chatBusy();
  }
  /** Each of the plan's runs lands its photo's finished view, in the plan's order. */
  planChatRuns() {
    const e = this.chatPlan("proposed"), t = this.opts.gen;
    if (!(!e || t.planned))
      for (const i of e.sessions)
        for (const s of i.runs) {
          const o = s.images && s.images.length ? wAe(s.images[0].id) : null, r = o && A0[o] || Object.values(A0)[0];
          t.plan([r], { first: this.timing.chatRun });
        }
  }
  /** What the chat's plan made: its session, and the pictures set out under it. */
  chatWork() {
    const e = this.board.value, t = this.chatPlan("started");
    if (!e || !t) return null;
    e.docRev.value;
    const i = new Set(t.sessions.map((o) => o.toolId || o.addedId).filter((o) => !!o)), s = [];
    for (const o of e.store.all())
      (i.has(o.id) || o.type === "image" && o.sessionId && i.has(o.sessionId)) && s.push(qe(o));
    return s.length ? hp(s) : null;
  }
  /** Enter sends the chat's message (as the composer's own Enter does), wherever the focus is. */
  sendKey(e) {
    if (!(e.key !== "Enter" || e.shiftKey || e.altKey)) {
      if (!e.repeat) {
        const t = document.querySelector('[data-testid="chat-send"]');
        t && !t.disabled && t.click();
      }
      return "handled";
    }
  }
  tabKey(e, t) {
    if (e.key === "Tab")
      return e.shiftKey || e.metaKey || e.ctrlKey || e.altKey || !e.repeat && this.typingField.value !== t && (this.focusField(t), this.tabs[t]++), "handled";
  }
  runKey(e, t) {
    if (!(e.key !== "Enter" || !vn(e))) {
      if (!e.repeat) {
        const i = document.querySelector(t);
        i && !i.disabled && i.click();
      }
      return "handled";
    }
  }
  // ---------------------------------------------------------------- the camera
  /**
   * Fly so a place on the board sits at (ax, ay) of the view (fractions),
   * at `zoom`, or zoomed to fill `fit` of the view (no closer than maxZoom).
   */
  flyTo(e, t) {
    const i = this.board.value;
    if (!i || !i.engine || !e) return;
    const s = i.view.w, o = i.view.h;
    let r = t.zoom || 1;
    const a = t.fitW || t.fit, l = t.fitH || t.fit;
    a && l && (r = Math.min(t.maxZoom || 1, s * a / Math.max(1, e.w), o * l / Math.max(1, e.h)));
    const d = { zoom: r, x: s * t.ax - (e.x + e.w / 2) * r, y: o * t.ay - (e.y + e.h / 2) * r };
    this.timing.fly ? i.engine.animateCamera(d, this.timing.fly) : i.setCamera(d);
  }
  // ---------------------------------------------------------------- holding the board still
  listen() {
    if (!this.listening) {
      this.listening = !0, window.addEventListener("keydown", this.onKey, !0);
      for (const e of F4) window.addEventListener(e, this.onPointer, { capture: !0, passive: !1 });
    }
  }
  unlisten() {
    if (this.listening) {
      this.listening = !1, window.removeEventListener("keydown", this.onKey, !0);
      for (const e of F4) window.removeEventListener(e, this.onPointer, { capture: !0 });
    }
  }
  /** Inside the tour's part of the page (the page itself counts: a key pressed with nothing focused). */
  inScope(e) {
    const t = this.opts.scope ? this.opts.scope() : null;
    return !t || !(e instanceof Node) ? !0 : e === document.body || e === document.documentElement || e === document || t.contains(e);
  }
  /** Inside a lit control that takes clicks: in its element, or (a box of several) within its bounds. */
  inTargets(e, t) {
    if (!e) return !1;
    const i = EAe(t);
    for (const s of this.targets.value) {
      if (s.look) {
        const o = s.takes, r = o && s.el ? s.el() : null, a = r && o ? e.closest(o) : null;
        if (r && a && r.contains(a)) return !0;
        continue;
      }
      if (s.el) {
        const o = s.el();
        if (o && (o === e || o.contains(e))) return !0;
      } else if (s.box && i) {
        const o = s.box();
        if (o && i.x >= o.x && i.x <= o.x + o.w && i.y >= o.y && i.y <= o.y + o.h) return !0;
      }
    }
    return !1;
  }
}
const F4 = ["pointerdown", "mousedown", "click", "dblclick", "auxclick", "contextmenu", "wheel", "touchstart", "dragstart"];
function PAe(n) {
  if (/^F\d{1,2}$/.test(n.key)) return !0;
  if (!n.metaKey && !n.ctrlKey) return !1;
  if (n.altKey) return !0;
  const e = n.key.toLowerCase();
  return ["r", "t", "w", "n", "q", "p", "f"].includes(e) || e === "l" && !n.shiftKey;
}
function N4(n) {
  return ts.findIndex((e) => e.id === n);
}
function hp(n) {
  const e = Math.min(...n.map((o) => o.x)), t = Math.min(...n.map((o) => o.y)), i = Math.max(...n.map((o) => o.x + o.w)), s = Math.max(...n.map((o) => o.y + o.h));
  return { x: e, y: t, w: i - e, h: s - t };
}
function U4(n) {
  return n.hint || "";
}
function EAe(n) {
  const e = n;
  if (typeof e.clientX == "number") return { x: e.clientX, y: e.clientY };
  const t = n.touches && n.touches[0];
  return t ? { x: t.clientX, y: t.clientY } : null;
}
function E0(n) {
  const e = n.map((t) => t.getBoundingClientRect()).filter((t) => t.width || t.height);
  return e.length ? hp(e.map((t) => ({ x: t.left, y: t.top, w: t.width, h: t.height }))) : null;
}
function Eh(...n) {
  return E0(n.map((e) => document.querySelector(e)).filter((e) => !!e));
}
var RAe = Object.defineProperty, zAe = (n, e, t) => e in n ? RAe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Rh = (n, e, t) => zAe(n, typeof e != "symbol" ? e + "" : e, t);
const $Ae = { first: 2600, gap: 420 };
class DAe {
  constructor(e, t = $Ae) {
    Rh(this, "fallback", e), Rh(this, "timing", t), Rh(this, "queue", []), Rh(this, "runs", 0);
  }
  /** What the next run makes (several plans wait their turn), and, when it isn't the usual, how soon it lands. */
  plan(e, t = {}) {
    this.queue.push({ pictures: e, timing: { ...this.timing, ...t } });
  }
  /** Forget every plan (the tour starting over). */
  reset() {
    this.queue.length = 0, this.runs = 0;
  }
  /** Plans not yet used. */
  get planned() {
    return this.queue.length;
  }
  run(e, t) {
    this.runs++;
    const i = kt(), s = this.queue.shift(), o = s ? s.pictures : this.fallback, r = s ? s.timing : this.timing, a = my(e.aspect || "3:4"), l = Date.now(), d = [];
    for (let f = 0; f < e.count; f++)
      d.push({
        id: kt(),
        sessionId: e.sessionId,
        status: "pending",
        url: "",
        w: a.w,
        h: a.h,
        prompt: e.prompt,
        model: e.model.name,
        modelId: e.model.id,
        inputs: e.inputs,
        refs: e.refs,
        seed: 1e3 + f,
        author: e.author,
        createdAt: l + f,
        runId: i,
        parents: e.refs.slice()
      });
    const c = [];
    let u = !1;
    const p = [];
    return d.forEach((f, y) => {
      c.push(window.setTimeout(() => {
        if (u) return;
        const b = o[y % o.length], w = { ...f, status: "done", url: b.src, label: b.label };
        p.push(w), t.onResult(w), p.length === d.length && t.onDone(p);
      }, r.first + y * r.gap));
    }), {
      runId: i,
      pending: d,
      cancel: () => {
        u = !0;
        for (const f of c) clearTimeout(f);
      }
    };
  }
}
const OAe = '.bl-hero{--stage-w: min(80%, 940px);position:relative;display:flex;flex-direction:column;align-items:center;margin:0 0 44px;border-radius:28px;background:var(--bg-deep);border:1px solid transparent;box-shadow:0 40px 120px #00000073;text-align:center}.bl-hero:before{content:"";position:absolute;inset:-1px;z-index:1;padding:1px;border-radius:inherit;background:linear-gradient(180deg,#d6c8f24d,#ffffff17 34%,#ffffff0d 70%,#ffffff12);-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0);pointer-events:none}.bl-hero-clip{position:absolute;inset:0;border-radius:inherit;overflow:hidden;container-type:inline-size;pointer-events:none}.bl-hero-atmo{position:absolute;inset:0;background:radial-gradient(64% 44% at 50% -10%,rgba(255,255,255,.05),transparent 66%)}.bl-hero-light{position:absolute;inset:0}.bl-hero-lit{position:absolute;inset:0;-webkit-mask-image:var(--bl-survey, linear-gradient(transparent, transparent)),radial-gradient(64% 80% at 50% 42%,transparent 58%,#000 100%);-webkit-mask-size:3200px 1500px,100% 100%;-webkit-mask-position:50% calc(-1 * var(--bl-top, 0px)),0 0;-webkit-mask-repeat:no-repeat,no-repeat;-webkit-mask-composite:source-in;mask-image:var(--bl-survey, linear-gradient(transparent, transparent)),radial-gradient(64% 80% at 50% 42%,transparent 58%,#000 100%);mask-size:3200px 1500px,100% 100%;mask-position:50% calc(-1 * var(--bl-top, 0px)),0 0;mask-repeat:no-repeat,no-repeat;mask-composite:intersect}.bl-hero .glow{position:absolute;aspect-ratio:1;border-radius:50%;animation:bl-glow-drift calc(26s + var(--i) * 4.3s) ease-in-out calc(var(--i) * -5.1s) infinite alternate,bl-glow-breathe calc(12s + var(--i) * 2.2s) ease-in-out calc(var(--i) * -3.7s) infinite;animation-play-state:paused}.bl-hero-light .glow{filter:blur(40px)}.bl-hero.is-live .glow{animation-play-state:running}@keyframes bl-glow-drift{0%{transform:translate(0) scale(1)}50%{transform:translate(1.5cqw,9cqw) scale(1.08)}to{transform:translate(-1cqw,-5cqw) scale(.95)}}@keyframes bl-glow-breathe{0%,to{opacity:.6}50%{opacity:1}}.bl-hero-stage{position:absolute;left:50%;bottom:0;width:var(--stage-w);aspect-ratio:1180 / 540;transform:translate(-50%)}.bl-hero-stage:before{content:"";position:absolute;left:6%;right:6%;top:-14%;height:50%;border-radius:50%;background:radial-gradient(50% 50% at 50% 50%,rgba(170,160,225,.13),rgba(150,156,230,.04) 55%,transparent 75%);filter:blur(40px)}.bl-hero-room{flex:none;width:var(--stage-w);aspect-ratio:1180 / 540;margin-top:34px}.bl-hero-top{position:absolute;left:18px;top:18px;z-index:4;display:flex;text-align:left}.bl-hero-copy{position:relative;z-index:2;max-width:880px;padding:50px 24px 0}.bl-title{font-size:clamp(36px,4vw,54px);line-height:1.03;letter-spacing:-.045em;font-weight:500!important;color:#fff;background:linear-gradient(180deg,#fff 35%,#ffffffbd);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}.bl-title em{font-style:normal;background:linear-gradient(100deg,#efe6ff 0%,var(--amethyst-700) 48%,var(--vista-blue-500) 100%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}.bl-sub{max-width:820px;margin:14px auto 0!important;font-size:15.5px;line-height:1.55;color:#ffffff8f;text-wrap:balance}.bl-hero-actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:12px;margin-top:24px}.bl-hero-pause{position:absolute;right:16px;bottom:16px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border-radius:999px;border:1px solid rgba(255,255,255,.12);background:#12121a9e;color:#ffffffc7;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-pause:hover{background:#282836cc;color:#fff;border-color:#fff3}.bl-hero-pause:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero-corner{position:absolute;right:18px;top:18px;z-index:4;display:flex;align-items:center;gap:8px}.bl-hero-tour{display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 13px 0 10px;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#12121a80;color:#ffffffb8;font:500 12.5px var(--font-sans);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-tour .licon{color:var(--amethyst-700)}.bl-hero-tour:hover{background:#282836c7;color:#fff;border-color:#fff3}.bl-hero-tour:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero-round{display:inline-flex;flex:none;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#12121a80;color:#ffffffb8;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-round:hover{background:#282836c7;color:#fff;border-color:#fff3}.bl-hero-round:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero.is-min{flex-direction:row;align-items:stretch;margin:0 0 26px;border-radius:0;background:none;border-color:transparent;box-shadow:none;text-align:left}.bl-hero.is-min:before{display:none}.bl-hero.is-min .bl-hero-copy{display:flex;flex:1;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:18px 32px;max-width:none;padding:8px 0 0;animation:bl-head-in .3s var(--ease-out-soft)}.bl-hero.is-min .bl-hero-text{flex:1 1 360px;min-width:0}.bl-hero.is-min .bl-title{font-size:clamp(28px,2.4vw,34px);letter-spacing:-.04em}.bl-hero.is-min .bl-sub{max-width:560px;margin:8px 0 0!important;font-size:14px;text-wrap:pretty}.bl-hero.is-min .bl-hero-actions{flex:none;justify-content:flex-end;gap:10px;margin-top:0}.bl-hero.is-min .bl-hero-tour{height:38px;padding:0 14px 0 12px}.bl-hero.is-min .bl-hero-round{width:38px;height:38px}@keyframes bl-head-in{0%{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}.bl-hd{position:absolute;inset:0;pointer-events:none}.bl-hd-win{position:absolute;left:0;top:0;transform-origin:0 0;border-radius:16px;overflow:hidden;background:#070910;box-shadow:0 0 0 1px #ffffff1f,0 -8px 40px #00000080,0 50px 140px #000000e6;font-family:var(--font-sans);color:var(--fg-2);text-align:left;user-select:none;-webkit-user-select:none;contain:layout paint}.bl-hd-win:after{content:"";position:absolute;inset:0;z-index:9;border-radius:inherit;box-shadow:inset 0 1px #ffffff1a;pointer-events:none}.bl-hd img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .6s var(--ease-out-soft)}.bl-hd img.is-in{opacity:1}.bl-hd img.is-broken{visibility:hidden}.bl-hd-bar{position:absolute;left:0;right:0;top:0;z-index:3;display:flex;align-items:center;gap:12px;height:44px;padding:0 16px;background:linear-gradient(180deg,#10121b,#0b0d14);border-bottom:1px solid rgba(255,255,255,.06)}.bl-hd-lights{display:inline-flex;gap:8px;margin-right:12px}.bl-hd-lights i{width:12px;height:12px;border-radius:50%;background:#ff5f57;box-shadow:inset 0 0 0 .5px #0000004d}.bl-hd-lights i:nth-child(2){background:#febc2e}.bl-hd-lights i:nth-child(3){background:#28c840}.bl-hd-mark{flex:none}.bl-hd-crumbs{font-size:13px;color:var(--fg-4);letter-spacing:-.005em;white-space:nowrap}.bl-hd-crumbs .sep{margin:0 5px;color:var(--fg-5)}.bl-hd-crumbs b{color:var(--fg-1);font-weight:600}.bl-hd-saved{margin-left:auto;display:inline-flex;align-items:center;gap:6px;font-size:11.5px;color:var(--fg-4)}.bl-hd-saved i{width:6px;height:6px;border-radius:50%;background:#ffffff47}.bl-hd-kebab{display:inline-flex;flex-direction:column;gap:2.5px;padding:0 8px 0 14px}.bl-hd-kebab i{width:3px;height:3px;border-radius:50%;background:var(--fg-4)}.bl-hd-canvas{position:absolute;inset:44px 0 0;overflow:hidden;background:radial-gradient(55% 75% at 16% 0%,rgba(117,50,211,.17),transparent 70%),radial-gradient(45% 60% at 90% 10%,rgba(90,97,237,.1),transparent 70%),#070910}.bl-hd-world{position:absolute;left:0;top:0;width:0;height:0;transform-origin:0 0}.bl-hd-dots{position:absolute;left:-900px;top:-800px;width:5600px;height:3400px}.bl-hd-dots.is-fine{background-image:radial-gradient(circle,rgba(255,255,255,.14) 1.2px,transparent 1.7px);background-size:26px 26px;opacity:clamp(0,calc((var(--z, 1) - .4) * 4),1)}.bl-hd-dots.is-coarse{background-image:radial-gradient(circle,rgba(255,255,255,.12) 3.4px,transparent 4.6px);background-size:104px 104px;opacity:clamp(0,calc((.66 - var(--z, 1)) * 4),1)}.bl-hd-frame{position:absolute;border-radius:22px;background:#ffffff06;border:1.5px solid rgba(255,255,255,.065)}.bl-hd-ftitle{position:absolute;left:4px;bottom:calc(100% + 10px);white-space:nowrap;font-size:11.5px;font-weight:600;letter-spacing:.26em;text-transform:uppercase;color:#ffffff94;opacity:clamp(0,calc((var(--z, 1) - .42) * 5),1)}.bl-hd-ftitle small{margin-left:8px;font-size:11.5px;font-weight:500;letter-spacing:.02em;text-transform:none;color:#ffffff4d}.bl-hd-flabel{position:absolute;left:0;bottom:100%;transform-origin:0 100%;transform:scale(var(--iz, 1)) translateY(-6px);white-space:nowrap;padding:3px 7px;border-radius:6px;background:#0c0e16eb;border:1px solid rgba(255,255,255,.1);font-size:8.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:#ffffffb8;opacity:clamp(0,calc((.5 - var(--z, 1)) * 5),1)}.bl-hd-pic{position:absolute;border-radius:9px;overflow:hidden;background:#ffffff0b;box-shadow:0 14px 40px #02040c73,inset 0 0 0 1px #ffffff0d}.bl-hd-pic.is-result{opacity:0}.bl-hd-pic.is-video img{animation:bl-hd-drift 9s ease-in-out infinite alternate;animation-play-state:paused}.bl-hero.is-live .bl-hd-pic.is-video img{animation-play-state:running}@keyframes bl-hd-drift{0%{transform:scale(1)}to{transform:scale(1.09) translate(-2%,-1.5%)}}.bl-hd-play,.bl-hd-heart{position:absolute;left:9px;top:9px;display:flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#080a129e;box-shadow:inset 0 0 0 1px #ffffff2e;color:#fff}.bl-hd-play .licon svg{fill:currentColor}.bl-hd-heart{color:#ff6b8b;opacity:0}.bl-hd-heart .licon svg{fill:currentColor}.bl-hd-session{position:absolute;border-radius:16px;padding:14px;background:linear-gradient(180deg,#ffffff13,#ffffff08),#0c0e17;border:1px solid rgba(255,255,255,.1);box-shadow:inset 0 1px #ffffff14,0 18px 60px #05081459}.bl-hd-session-head{display:flex;align-items:center;gap:10px}.bl-hd-badge{display:flex;flex:none;align-items:center;justify-content:center;width:36px;height:36px;border-radius:12px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;color:var(--amethyst-700)}.bl-hd-session-titles{display:flex;flex:1;flex-direction:column;min-width:0}.bl-hd-session-titles .kind{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;overflow:hidden}.bl-hd-session-titles .sep{margin:0 6px;color:var(--fg-5);letter-spacing:0}.bl-hd-session-titles .model{font-size:10px;font-weight:500;text-transform:none;letter-spacing:.01em;color:var(--fg-5)}.bl-hd-session-titles .name{margin-top:1px;font-size:14.5px;font-weight:600;color:#fff;letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bl-hd-count{flex:none;padding:3px 9px;border-radius:999px;background:#ffffff0d;border:1px solid rgba(255,255,255,.06);font-size:11px;font-weight:600;color:var(--fg-3)}.bl-hd-thumbs{display:flex;gap:6px;margin-top:12px}.bl-hd-thumb{position:relative;flex:1;aspect-ratio:1;border-radius:8px;overflow:hidden;border:1px solid rgba(255,255,255,.07);background:#ffffff0a}.bl-hd-thumb.is-empty{border:1px dashed rgba(255,255,255,.1);background:#ffffff05}.is-hero .bl-hd-thumb img{transition:none}.bl-hd-thumbs.is-busy .bl-hd-thumb:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:bl-hd-shimmer 1.2s linear infinite}@keyframes bl-hd-shimmer{0%{transform:translate(-100%)}to{transform:translate(100%)}}.bl-hd-foot{margin-top:11px;font-size:11px;color:var(--fg-4);white-space:nowrap}.bl-hd-ring{position:absolute;inset:-4px;border-radius:19px;border:1.7px solid var(--amethyst-500);box-shadow:0 0 0 4.5px #9968df33;opacity:0}.bl-hd-note{position:absolute;display:flex;flex-direction:column;padding:16px;border-radius:16px;box-shadow:inset 0 1px #ffffff1a,0 18px 60px #0508144d}.bl-hd-note .text{flex:1;font-size:13.5px;line-height:1.45;color:#ffffffdb;letter-spacing:-.005em}.bl-hd-note .meta{margin-top:8px;font-size:10px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:#ffffff61}.bl-hd-note.is-amethyst{background:linear-gradient(180deg,#9968df33,#9968df17),#0b0b16;border:1px solid rgba(194,164,236,.24)}.bl-hd-note.is-amber{background:linear-gradient(180deg,#f0b44a2e,#f0b44a14),#0d0b0c;border:1px solid rgba(247,212,143,.22)}.bl-hd-note.is-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14),#0d0a12;border:1px solid rgba(245,163,199,.22)}.bl-hd-note.is-mint{background:linear-gradient(180deg,#34c79a29,#34c79a12),#080d10;border:1px solid rgba(143,229,201,.2)}.bl-hd.is-opening .bl-hd-frame,.bl-hd.is-opening .bl-hd-pic:not(.is-result),.bl-hd.is-opening .bl-hd-session,.bl-hd.is-opening .bl-hd-note{--p: clamp(0, calc((var(--build, 0) - var(--d, 0)) * 2.5), 1);--q: calc(1 - var(--p));opacity:var(--p);transform:translate3d(0,calc(var(--q) * var(--q) * 56px),0) scale(calc(1 - .1 * var(--q) * var(--q)));filter:blur(calc(var(--q) * var(--q) * 16px))}.bl-hd.is-opening .bl-hd-frame:after,.bl-hd.is-opening .bl-hd-pic:not(.is-result):after,.bl-hd.is-opening .bl-hd-session:after,.bl-hd.is-opening .bl-hd-note:after{content:"";position:absolute;inset:calc(-3px * var(--iz, 1));border-radius:inherit;pointer-events:none;box-shadow:0 0 0 calc(1.5px * var(--iz, 1)) #decefaeb,0 0 calc(26px * var(--iz, 1)) calc(4px * var(--iz, 1)) #9968df80;opacity:0}.bl-hd.is-opening .bl-hd-pic:not(.is-result):after{inset:0;z-index:1;box-shadow:inset 0 0 0 calc(2.5px * var(--iz, 1)) #decefaf2,inset 0 0 calc(38px * var(--iz, 1)) #9968dfb3;opacity:var(--g-pic, 0)}.bl-hd.is-opening .bl-hd-session:after{opacity:var(--g-session, 0)}.bl-hd.is-opening .bl-hd-note:after{opacity:var(--g-note, 0)}.bl-hd.is-opening .bl-hd-frame:after{opacity:var(--g-frame, 0)}.bl-hd-dock{position:absolute;left:50%;z-index:2;display:flex;align-items:center;gap:6px;padding:5px;border-radius:15px;background:#121521e6;border:1px solid var(--hairline);box-shadow:inset 0 1px #ffffff14,0 30px 80px #0206178c}.bl-hd-add{display:inline-flex;height:34px;border-radius:10px;overflow:hidden;background:var(--grad-cta);color:#fff;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e}.bl-hd-add .main{display:inline-flex;align-items:center;gap:6px;padding:0 10px;font-size:12px;font-weight:600;letter-spacing:-.01em}.bl-hd-add .chev{display:inline-flex;align-items:center;padding:0 7px;box-shadow:inset 1px 0 #ffffff38}.bl-hd-rail{display:inline-flex;align-items:center;gap:2px}.bl-hd-rail i{display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:9px;color:var(--fg-3)}.bl-hd-rail i.is-on{background:#9968df29;color:#fff}.bl-hd-rail b{width:1px;height:18px;margin:0 4px;background:var(--hairline-soft)}.bl-hd-prompt{position:absolute;z-index:2;border-radius:18px;border:1px solid rgba(255,255,255,.075);background:#0b0d15fb;box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 30px 80px #02040c9e;visibility:hidden}.bl-hd-prompt-side{position:absolute;left:12px;top:12px;display:flex;flex-direction:column;gap:7px}.bl-hd-prompt-side i{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:9px;color:var(--fg-4)}.bl-hd-slot{position:absolute;display:flex;align-items:center;justify-content:center;border-radius:10px;border:1px dashed rgba(255,255,255,.16);background:#ffffff05;color:var(--fg-4)}.bl-hd-slot.is-target{border:1px solid rgba(194,164,236,.7);background:#9968df24;color:var(--amethyst-700)}.bl-hd-slot img{position:absolute;inset:-1px;width:calc(100% + 2px);height:calc(100% + 2px);border-radius:10px;transition:none}.bl-hd-slot .glow{position:absolute;inset:-4px;z-index:1;border-radius:13px;box-shadow:0 0 0 1.5px #c2a4ecd9,0 0 22px 4px #9968df6b;opacity:0}.bl-hd-prompt-text{position:absolute;left:54px;right:18px;top:66px;height:22px;white-space:nowrap;font-size:15px;line-height:22px;letter-spacing:-.005em;color:#fff}.bl-hd-prompt-text .ph{position:absolute;left:0;top:0;color:var(--fg-4)}.bl-hd-prompt-text .caret{display:inline-block;width:1.5px;height:18px;margin-left:1px;vertical-align:-3px;border-radius:1px;background:var(--amethyst-700)}.bl-hd-prompt-foot{position:absolute;left:54px;right:12px;bottom:12px;display:flex;align-items:center;gap:7px}.bl-hd-prompt-foot .chip{display:inline-flex;align-items:center;gap:6px;height:30px;padding:0 11px;border-radius:999px;background:#ffffff0d;border:1px solid rgba(255,255,255,.06);font-size:12px;color:var(--fg-2);white-space:nowrap}.bl-hd-prompt-foot .chip small{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.bl-hd-prompt-foot .chip .licon{color:var(--fg-4)}.bl-hd-prompt-foot .cog{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;color:var(--fg-4)}.bl-hd-prompt-foot .sp{flex:1}.bl-hd-prompt-foot .step{display:inline-flex;align-items:center;gap:10px;height:30px;padding:0 11px;border-radius:999px;border:1px solid rgba(255,255,255,.08);color:var(--fg-4);font-size:12.5px}.bl-hd-prompt-foot .step b{color:#fff;font-weight:600}.bl-hd-prompt-foot .run{position:relative;isolation:isolate;display:inline-flex;align-items:center;justify-content:center;height:30px;border-radius:999px;background:#ffffff12;font-size:12.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-4);transition:color .3s,box-shadow .3s,transform .12s var(--ease-out-soft),opacity .2s}.bl-hd-prompt-foot .run:before{content:"";position:absolute;inset:0;z-index:-1;border-radius:inherit;background:var(--grad-cta);opacity:0;transition:opacity .3s}.bl-hd-prompt-foot .run.is-lit{color:#fff;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e}.bl-hd-prompt-foot .run.is-lit:before{opacity:1}.bl-hd-prompt-foot .run.is-pressed{transform:scale(.95)}.bl-hd-prompt-foot .run.is-busy{opacity:.72}.bl-hd-zoom{position:absolute;right:16px;z-index:2;display:inline-flex;align-items:center;gap:10px;height:34px;padding:0 11px;border-radius:12px;background:#121521e6;border:1px solid var(--hairline);color:var(--fg-4);font-size:12px}.bl-hd-zoom .pct{min-width:30px;text-align:center;color:var(--fg-2);font-variant-numeric:tabular-nums}.bl-hd-ghost{position:absolute;left:0;top:0;z-index:5;width:54px;height:72px;border-radius:8px;opacity:0;transform-origin:0 0;box-shadow:0 16px 40px #0000008c}.bl-hd-ghost img{border-radius:8px}.bl-hd-ghost .ring{position:absolute;inset:-3px;border-radius:10px;box-shadow:0 0 0 1.5px var(--amethyst-700),0 0 18px #9968df80;opacity:0}.bl-hd-ripple{position:absolute;left:-18px;top:-18px;z-index:6;width:36px;height:36px;border-radius:50%;border:1.5px solid rgba(255,255,255,.9);opacity:0}.bl-hd-pointer{position:absolute;left:0;top:0;z-index:7;opacity:0}.bl-hd-pointer .arrow{display:block;margin:-3px 0 0 -4px;filter:drop-shadow(0 3px 6px rgba(0,0,0,.45));transform-origin:4px 3px;transition:transform .09s ease-out}.bl-hd-pointer.is-pressed .arrow{transform:scale(.86)}.bl-hd-key{position:absolute;left:16px;top:-26px;padding:3px 7px;border-radius:6px;background:#f5f5faf5;box-shadow:0 1px #00000040,0 6px 16px #00000059;font-size:11px;font-weight:600;white-space:nowrap;color:#11131c;opacity:0}.bl-hd-sheen{position:absolute;top:-10%;bottom:-10%;left:0;z-index:8;width:60%;opacity:0;pointer-events:none;background:linear-gradient(105deg,transparent 25%,rgba(255,255,255,.1) 50%,transparent 75%);mix-blend-mode:screen}@media(max-width:900px){.bl-hero{--stage-w: 92%;margin:0 0 30px;border-radius:22px}.bl-hero-pause{top:14px;right:14px;bottom:auto}.bl-hero-corner{top:14px;right:56px}.bl-hero-copy{padding-top:54px}.bl-sub{font-size:14.5px}}@media(max-width:600px){.bl-hero-stage,.bl-hero-room{display:none}.bl-hero-copy{padding:52px 18px 34px}.bl-hero.is-min{margin-bottom:18px}.bl-hero.is-min .bl-hero-copy{padding:4px 0 0}.bl-hero.is-min .bl-hero-actions{flex:1 1 100%;justify-content:flex-start}}', LAe = '.ob-layer{position:fixed;inset:0;z-index:2147483000;pointer-events:none;color:var(--fg-2)}.ob-layer [data-tour-ui]{pointer-events:auto}.ob-dim{position:absolute;inset:0}.ob-confetti{position:absolute;inset:0;width:100%;height:100%;z-index:30;pointer-events:none}.ob-dim-fill{fill:#04030c;transition:opacity .7s var(--ease-out-soft)}.ob-ring{position:absolute;box-shadow:0 0 0 1.5px #d6c2f2f2,0 0 0 5px #9968df38,0 0 34px 6px #9968df52;animation:obBreathe 2.4s ease-in-out infinite}.ob-ring:after{content:"";position:absolute;inset:-2px;border-radius:inherit;box-shadow:0 0 0 1.5px #d6c2f2b3;animation:obRipple 2.4s var(--ease-out-soft) infinite}@keyframes obBreathe{0%,to{box-shadow:0 0 0 1.5px #d6c2f2f2,0 0 0 5px #9968df33,0 0 30px 4px #9968df42}50%{box-shadow:0 0 0 1.5px #e8dcff,0 0 0 7px #9968df47,0 0 46px 10px #9968df66}}@keyframes obRipple{0%{inset:-2px;opacity:.9}70%,to{inset:-16px;opacity:0}}.ob-ring.is-nudged{animation:obCall .6s var(--ease-out-soft),obBreathe 2.4s ease-in-out .6s infinite}@keyframes obCall{0%{box-shadow:0 0 0 1.5px #fff,0 0 0 12px #9968df59,0 0 60px 16px #9968df8c}to{box-shadow:0 0 0 1.5px #d6c2f2f2,0 0 0 5px #9968df33,0 0 30px 4px #9968df42}}.ob-ring.is-done{animation:obDone .75s var(--ease-out-soft) forwards}.ob-ring.is-done:after{animation:none;opacity:0}@keyframes obDone{0%{box-shadow:0 0 0 1.5px #fff,0 0 0 5px #37d39959,0 0 40px 8px #37d39966}to{box-shadow:0 0 0 1.5px #37d39900,0 0 0 18px #37d39900,0 0 60px 16px #37d39900}}.ob-slot{position:absolute;display:flex;align-items:center;justify-content:center;border:1.5px dashed rgba(214,194,242,.75);background:#9968df12;animation:obSlot 1.8s ease-in-out infinite}.ob-slot span{padding:6px 12px;border-radius:999px;background:#04030cb8;color:#fff;font-size:12px;font-weight:600;letter-spacing:-.005em;white-space:nowrap}.ob-slot.is-done{animation:none;border-color:#37d399cc}@keyframes obSlot{0%,to{background:#9968df0d}50%{background:#9968df24}}.ob-arc{position:absolute;inset:0;overflow:visible}.ob-arc path{fill:none;stroke:#d6c2f2d9;stroke-width:2;stroke-linecap:round;stroke-dasharray:.5 9;animation:obMarch .8s linear infinite;filter:drop-shadow(0 0 4px rgba(153,104,223,.8))}.ob-arc circle{fill:#fff;filter:drop-shadow(0 0 6px rgba(153,104,223,.9))}@keyframes obMarch{to{stroke-dashoffset:-9.5}}.ob-head{position:absolute;left:0;right:0;top:0;height:60px;display:grid;grid-template-columns:1fr auto 1fr;align-items:center;padding:0 18px;background:#070910f0;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border-bottom:1px solid var(--hairline-soft)}.ob-head-left{display:flex;align-items:center;gap:12px;min-width:0}.ob-head-mark{flex:none}.ob-head-name{font-size:13px;color:var(--fg-4);white-space:nowrap}.ob-head-name .sep{margin:0 6px;color:var(--fg-5)}.ob-head-name b{color:var(--fg-1);font-weight:600}.ob-chapters{display:flex;align-items:center;gap:4px;margin:0;padding:0;list-style:none}.ob-chapters li{display:flex;align-items:center;gap:7px;height:30px;padding:0 11px 0 5px;border-radius:999px;color:var(--fg-4);font-size:12px;font-weight:500;white-space:nowrap;transition:background .4s var(--ease-out-soft),color .4s}.ob-chapters li+li:before{content:"";width:14px;height:1px;margin:0 4px 0 -6px;background:var(--hairline)}.ob-chapters .n{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;border:1px solid var(--hairline);font-size:10.5px;font-weight:600;color:var(--fg-4);font-variant-numeric:tabular-nums;transition:background .4s,border-color .4s,color .4s}.ob-chapters li.on{background:#9968df24;color:#fff}.ob-chapters li.on .n{border-color:transparent;background:var(--grad-cta);color:#fff;box-shadow:0 0 14px #9968df8c}.ob-chapters li.done{color:var(--fg-3)}.ob-chapters li.done .n{border-color:#c2a4ec66;background:#9968df33;color:var(--amethyst-800)}.ob-head-right{display:flex;justify-content:flex-end}.ob-skip{height:32px;padding:0 14px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff08;color:var(--fg-3);font:500 12.5px var(--font-sans);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ob-skip:hover{background:#ffffff14;color:#fff}.ob-card{position:absolute;left:0;top:0;width:372px;border-radius:20px;overflow:hidden;background:#0f101a;border:1px solid rgba(255,255,255,.09);box-shadow:0 0 0 1px #9968df29,0 34px 90px #02040cb8,0 10px 26px #02040c73;transition:transform .7s var(--ease-out-soft);will-change:transform}.ob-card.is-wide{width:min(560px,calc(100vw - 32px))}.ob-card.is-short,.ob-card.is-short.is-wide{display:flex;align-items:stretch;width:min(600px,calc(100vw - 32px))}.ob-card.is-short .ob-media{flex:none;width:236px;aspect-ratio:auto;min-height:150px;border-bottom:0;border-right:1px solid var(--hairline-soft)}.ob-card.is-short .ob-body{flex:1;min-width:0;gap:10px;padding:14px 16px}.ob-card.is-short .ob-title{font-size:15.5px}.ob-card.is-short .ob-text{font-size:12.5px}.ob-card-enter-active{transition:opacity .4s ease,transform .7s var(--ease-out-soft)}.ob-card-leave-active{transition:opacity .2s ease}.ob-card-enter-from,.ob-card-leave-to{opacity:0}.ob-media{position:relative;aspect-ratio:16 / 9;overflow:hidden;background:#070910;border-bottom:1px solid var(--hairline-soft)}.ob-media:after{content:"";position:absolute;left:0;right:0;bottom:0;height:40px;pointer-events:none;background:linear-gradient(180deg,transparent,rgba(15,16,26,.5))}.ob-media-enter-active{transition:opacity .35s ease}.ob-media-leave-active{transition:opacity .18s ease}.ob-media-enter-from,.ob-media-leave-to{opacity:0}.ob-tag{position:absolute;left:12px;top:12px;z-index:3;display:inline-flex;align-items:center;gap:6px;padding:4px 10px 4px 8px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase}.ob-tag .licon{color:#d9c6ff}.ob-body{display:flex;flex-direction:column;gap:12px;padding:16px 18px}.ob-words-stack{display:grid}.ob-words-stack>.ob-words{grid-area:1 / 1;min-width:0}.ob-words{display:flex;flex-direction:column;gap:6px}.ob-words-enter-active{transition:opacity .32s ease .06s,transform .42s var(--ease-out-soft) .06s}.ob-words-leave-active{transition:opacity .18s ease}.ob-words-enter-from{opacity:0;transform:translateY(6px)}.ob-words-leave-to{opacity:0}.ob-title{font-size:16.5px;font-weight:650;letter-spacing:-.015em;color:#fff;line-height:1.3}.ob-text{font-size:13px;line-height:1.55;color:var(--fg-3);text-wrap:pretty}.ob-card.is-wide .ob-title{font-size:19px}.ob-card.is-wide .ob-text{font-size:14px}.ob-note{display:flex;align-items:flex-start;gap:10px;margin-bottom:6px;padding:9px 12px;border-radius:12px;background:linear-gradient(180deg,#37d39921,#37d3990d);border:1px solid rgba(55,211,153,.3);font-size:12.5px;line-height:1.45;color:var(--fg-3)}.ob-note .ob-tick{width:18px;height:18px;margin-top:1px;animation-delay:.2s;animation-fill-mode:both}.ob-note-words{display:flex;flex-direction:column;gap:3px;min-width:0}.ob-note-words b{color:#fff;font-size:13px;font-weight:600}.ob-note .ob-key{min-width:0;height:18px;padding:0 5px;font-size:10.5px;box-shadow:0 1.5px #8e8ea6,0 3px 8px #0000004d}.ob-task{display:flex;align-items:center;gap:10px;min-height:42px;padding:8px 12px;border-radius:12px;background:linear-gradient(180deg,#9968df24,#9968df14);border:1px solid rgba(194,164,236,.22);color:#fff;font-size:13px;font-weight:500;line-height:1.4;transition:background .4s,border-color .4s}.ob-task-words{display:inline}.ob-task.is-shaking{animation:obShake .42s var(--ease-out-soft)}@keyframes obShake{0%,to{transform:translate(0)}20%{transform:translate(-5px)}45%{transform:translate(4px)}70%{transform:translate(-2px)}}.ob-dot{flex:none;width:8px;height:8px;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 #ae86e599;animation:obDot 1.6s ease-out infinite}@keyframes obDot{0%{box-shadow:0 0 #ae86e599}to{box-shadow:0 0 0 9px #ae86e500}}.ob-chip{display:inline-flex;align-items:center;height:22px;margin:0 2px;padding:0 9px;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:12px;font-weight:600;vertical-align:1px;box-shadow:0 4px 12px #745aff4d}.ob-key{display:inline-flex;align-items:center;justify-content:center;min-width:24px;height:22px;margin:0 2px;padding:0 7px;border-radius:6px;background:linear-gradient(180deg,#fdfdff,#e4e4ee);color:#11131c;font:650 11.5px var(--font-sans);vertical-align:1px;box-shadow:0 2px #8e8ea6,0 4px 10px #00000059}.ob-key+.ob-key{margin-left:3px}.ob-key.is-on-btn{min-width:0;height:18px;margin-left:8px;padding:0 5px;font-size:11px;background:#ffffff38;color:#fff;box-shadow:none}.ob-card.is-done .ob-task{background:linear-gradient(180deg,#37d39929,#37d39914);border-color:#37d39959}.ob-tick{display:inline-flex;align-items:center;justify-content:center;flex:none;width:20px;height:20px;border-radius:50%;background:var(--success);color:#04130d;animation:obTick .42s var(--ease-out-soft)}@keyframes obTick{0%{transform:scale(.4);opacity:0}to{transform:scale(1);opacity:1}}.ob-spin{flex:none;width:15px;height:15px;border-radius:50%;border:2px solid rgba(255,255,255,.16);border-top-color:var(--amethyst-700);animation:obSpin .8s linear infinite}@keyframes obSpin{to{transform:rotate(360deg)}}.ob-hint{margin-top:-4px;font-size:12px;color:var(--amethyst-800);animation:obHint .35s var(--ease-out-soft)}@keyframes obHint{0%{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:none}}.ob-foot{display:flex;align-items:center;justify-content:space-between;min-height:22px}.ob-steps{display:inline-flex;align-items:center;gap:5px}.ob-steps i{width:6px;height:6px;border-radius:999px;background:#ffffff29;transition:width .4s var(--ease-out-soft),background .4s}.ob-steps i.on{width:20px;background:#c2a4ec99}.ob-steps i.done{background:var(--amethyst-500)}.ob-steps i.on.done{background:var(--success)}.ob-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:36px;padding:0 16px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;font:600 13px var(--font-sans);letter-spacing:-.01em;cursor:pointer;box-shadow:0 8px 22px #745aff52,inset 0 1px #fff3;transition:transform .15s var(--ease-out-soft),box-shadow var(--dur-fast),filter var(--dur-fast),opacity var(--dur-fast)}.ob-btn:hover{filter:brightness(1.08);box-shadow:0 10px 28px #745aff73,inset 0 1px #ffffff3d}.ob-btn:active{transform:scale(.97)}.ob-btn:disabled{opacity:.55;cursor:default;filter:none}.ob-btn:focus-visible,.ob-link:focus-visible,.ob-skip:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:3px}.ob-btn.is-big{height:46px;padding:0 24px;font-size:14.5px}.ob-link{display:inline-flex;align-items:center;gap:7px;padding:6px 10px;border:0;border-radius:999px;background:transparent;color:var(--fg-3);font:500 13px var(--font-sans);cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast)}.ob-link:hover{color:#fff;background:#ffffff0d}.ob-link:disabled{opacity:.5;cursor:default}.ob-welcome,.ob-finale{position:absolute;left:50%;top:calc(50% + 30px);transform:translate(-50%,-50%);border-radius:26px;background:#070810;box-shadow:0 0 0 1px #ffffff14,0 0 0 1px #9968df24,0 50px 140px #000000b3}.ob-welcome{width:min(760px,calc(100vw - 32px));max-height:calc(100vh - 92px);overflow:hidden;display:flex;flex-direction:column}.ob-welcome:before,.ob-finale:before{content:"";position:absolute;inset:-1px;z-index:2;padding:1px;border-radius:inherit;background:linear-gradient(180deg,#d6c8f257,#ffffff14 34%,#ffffff0a 70%,#ffffff0f);-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0);pointer-events:none}.ob-welcome-media{position:relative;flex:none;aspect-ratio:1180 / 540;overflow:hidden;background:#04030c}.ob-welcome-media .bl-hd-win{border-radius:0}.ob-welcome-fade{position:absolute;left:0;right:0;bottom:0;height:90px;z-index:9;background:linear-gradient(180deg,#07081000,#070810);pointer-events:none}.ob-welcome-body{position:relative;z-index:10;display:flex;flex-direction:column;align-items:flex-start;gap:10px;margin-top:-28px;padding:0 36px 32px}.ob-eyebrow{font-size:11px;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--amethyst-700)}.ob-welcome-title,.ob-finale-title{margin:0;font-size:30px;font-weight:650;line-height:1.15;letter-spacing:-.025em;color:#fff}.ob-welcome-text{max-width:600px;margin:2px 0 8px;font-size:15px;line-height:1.6;color:var(--fg-3);text-wrap:pretty}.ob-welcome-actions{display:flex;align-items:center;gap:16px}.ob-or{font-size:12.5px;color:var(--fg-4)}.ob-own-enter-active{transition:opacity .5s ease,transform .7s var(--ease-out-soft)}.ob-own-leave-active{transition:opacity .3s ease,transform .4s ease}.ob-own-enter-from{opacity:0;transform:translate(-50%,calc(-50% + 18px)) scale(.98)}.ob-own-leave-to{opacity:0;transform:translate(-50%,calc(-50% - 10px)) scale(.985)}.ob-welcome.is-intro{opacity:var(--ob-intro-card, 0)}.ob-welcome.is-intro .ob-welcome-media{opacity:var(--ob-intro-media, 0)}.ob-welcome.is-intro .ob-welcome-title{visibility:hidden}.ob-intro{position:absolute;inset:0;z-index:40;overflow:hidden;cursor:default;user-select:none;-webkit-user-select:none}.ob-intro-leave-active{transition:opacity .32s ease}.ob-intro-leave-to{opacity:0}.ob-intro-dark{position:absolute;inset:0;background:var(--bg-deep)}.ob-intro-loader{position:absolute;inset:0;display:flex;align-items:center;justify-content:center}.ob-intro-stage{position:absolute;left:0;top:0;overflow:hidden;opacity:0;background:#070910;isolation:isolate}.ob-intro-win{position:absolute}.ob-intro-win .bl-hd-win{border-radius:0}.ob-intro-stage .ob-welcome-fade{opacity:0}.ob-intro-scrim{position:absolute;inset:0;pointer-events:none;opacity:0;background:radial-gradient(ellipse 52% 48% at 50% 50%,#04030ce0,#04030c99 58%,#04030c42)}.ob-intro-center{position:absolute;inset:0;z-index:2;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:clamp(22px,3.6vh,40px);padding-bottom:6vh;pointer-events:none}.ob-intro-mark{position:relative;flex:none;width:clamp(84px,9.5vw,148px);aspect-ratio:239 / 173;transform-origin:0 0}.ob-intro-glow{position:absolute;left:50%;top:50%;width:560%;aspect-ratio:1;border-radius:50%;opacity:0;pointer-events:none;background:radial-gradient(closest-side,rgba(153,104,223,.3),rgba(90,97,237,.1) 52%,transparent 100%)}.ob-intro-mark-in{position:absolute;inset:0;perspective:calc(clamp(84px,9.5vw,148px)*3)}.ob-intro-facet{position:absolute;inset:0;width:100%;height:100%;overflow:visible;opacity:0;will-change:transform,opacity,filter}.ob-intro-sheen{position:absolute;inset:0;opacity:0;pointer-events:none;-webkit-mask:var(--mask) center / 100% 100% no-repeat;mask:var(--mask) center / 100% 100% no-repeat;background-image:linear-gradient(105deg,transparent 38%,rgba(255,255,255,.85) 50%,transparent 62%);background-size:320% 100%;background-repeat:no-repeat;mix-blend-mode:screen}.ob-intro-title{position:relative;flex:none;white-space:nowrap;font-size:clamp(32px,4.6vw,66px);font-weight:650;line-height:1.15;letter-spacing:-.025em;color:#fff;transform-origin:0 0;text-shadow:0 2px 34px rgba(4,3,12,calc(.9 * var(--ts, 1)))}.ob-intro-word{display:inline-block;opacity:0}.ob-intro-row{display:flex;align-items:center;margin-top:calc(-1*clamp(8px,1.6vh,18px));opacity:0;white-space:nowrap;font-size:clamp(11px,.95vw,13.5px);font-weight:600;letter-spacing:.26em;text-transform:uppercase}.ob-intro-aspect{display:inline-flex;align-items:center;opacity:0;color:#cbb8f2;transition:color .25s ease}.ob-intro-aspect .sep{width:4px;height:4px;margin:0 1.1em 0 .9em;border-radius:50%;background:#cbb8f280}.ob-intro-skip{position:absolute;right:22px;bottom:20px;z-index:3;display:inline-flex;align-items:center;gap:9px;height:34px;padding:0 10px 0 14px;border:1px solid rgba(255,255,255,.1);border-radius:999px;background:#ffffff0a;color:var(--fg-3);font:500 12.5px var(--font-sans);cursor:pointer;opacity:0;visibility:hidden;transition:color var(--dur-fast),background var(--dur-fast)}.ob-intro-skip:hover{color:#fff;background:#ffffff14}.ob-intro-skip .ob-key{min-width:0;height:18px;margin:0;padding:0 5px;font-size:10.5px;box-shadow:0 1.5px #8e8ea6}.ob-finale{width:min(540px,calc(100vw - 32px));display:flex;flex-direction:column;align-items:center;padding:40px 40px 32px;text-align:center}.ob-finale-mark{position:relative;display:flex;align-items:center;justify-content:center;width:96px;height:96px;margin-bottom:18px}.ob-finale-mark .halo{position:absolute;inset:0;border-radius:50%;background:radial-gradient(circle,rgba(153,104,223,.42),rgba(90,97,237,.12) 55%,transparent 72%);animation:obHalo 3.2s ease-in-out infinite}@keyframes obHalo{0%,to{transform:scale(.92);opacity:.75}50%{transform:scale(1.12);opacity:1}}.ob-finale-mark svg{position:relative;overflow:visible}.ob-finale-mark path{transform-box:fill-box;transform-origin:50% 50%;animation:obFacet .7s var(--ease-out-soft) both;animation-delay:calc(.12s + var(--i) * .09s)}@keyframes obFacet{0%{opacity:0;transform:scale(.4) rotate(-30deg)}to{opacity:1;transform:none}}.ob-finale .ob-finale-text{max-width:420px;margin:12px 0 26px;font-size:14.5px;line-height:1.6;color:var(--fg-3);text-wrap:pretty}.ob-learned{display:grid;grid-template-columns:1fr 1fr;gap:8px 10px;width:100%;margin:0 0 26px;padding:0;list-style:none;text-align:left}.ob-learned li{display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:12px;background:#ffffff09;border:1px solid var(--hairline-soft);font-size:12.5px;color:var(--fg-2);animation:obLearned .55s var(--ease-out-soft) both;animation-delay:calc(.5s + var(--i) * .14s)}.ob-learned .ob-tick{width:18px;height:18px;animation:obTick .42s var(--ease-out-soft) both;animation-delay:calc(.62s + var(--i) * .14s)}.ob-learned li:last-child:nth-child(odd){grid-column:1 / -1}@keyframes obLearned{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}.ob-finale .ob-finale-error{margin:-12px 0 16px;font-size:12.5px;color:var(--danger)}.ob-finale-actions{display:flex;flex-direction:column;align-items:center;gap:10px}.bd-root .up-ghost.is-tour{white-space:normal;overflow:visible;color:var(--fg-3)}.bd-root .up-cue.is-tour{border:0;font-family:var(--font-sans);pointer-events:auto;cursor:pointer;animation:upIn .4s var(--ease-out-soft) .15s both,obCue 2.2s ease-in-out .6s infinite}.bd-root .up-cue.is-tour:hover{background:#9968df3d}@keyframes obCue{0%,to{box-shadow:0 0 #9968df00}50%{box-shadow:0 0 0 4px #9968df2e}}.bd-root .up-text.is-typing{caret-color:var(--amethyst-700);text-shadow:0 0 16px rgba(194,164,236,.45)}.bd-root .ed-words.is-tour-ghost::placeholder{color:var(--fg-3)}.bd-root .ed-tour-cue{position:static;align-self:flex-start;margin:2px 0 4px}.bd-root .ch-comp-input.is-tour-ghost::placeholder{color:var(--fg-3)}.bd-root .ch-comp-input.is-typing{caret-color:var(--amethyst-700);text-shadow:0 0 16px rgba(194,164,236,.45)}.bd-root .ch-tour-cue{position:static;display:inline-flex;margin:2px 0}.ob-demo{position:absolute;inset:0;overflow:hidden;pointer-events:none}.ob-demo-stage{position:absolute;left:0;top:0;transform-origin:0 0}.ob-demo-canvas{position:absolute;inset:0;background:radial-gradient(60% 80% at 14% 0%,rgba(117,50,211,.18),transparent 70%),radial-gradient(50% 60% at 92% 8%,rgba(90,97,237,.11),transparent 70%),#070910}.ob-demo-canvas:before{content:"";position:absolute;inset:0;background-image:radial-gradient(circle,rgba(255,255,255,.075) 1px,transparent 1.4px);background-size:22px 22px;background-position:11px 11px;background-repeat:repeat}.ob-demo .bl-hd-session{position:absolute}.ob-d-land{position:absolute;inset:0;transform-origin:320px 138px}.ob-d-tag{position:absolute;display:inline-flex;align-items:center;gap:8px;height:28px;padding:0 12px 0 9px;border-radius:999px;background:#121521f0;border:1px solid var(--hairline);color:var(--fg-1);font-size:12.5px;font-weight:500;white-space:nowrap;box-shadow:0 10px 24px #02040c73}.ob-d-tag:before{content:"";position:absolute;left:-20px;top:50%;width:18px;height:1px;background:linear-gradient(90deg,transparent,rgba(194,164,236,.6))}.ob-d-tag i{width:7px;height:7px;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 8px var(--amethyst-500)}.ob-demo .bl-hd-add{transition:box-shadow .25s ease,filter .25s ease}.ob-demo .bl-hd-add.is-lit{filter:brightness(1.15);box-shadow:0 0 0 3px #d6c2f280,0 10px 30px #745aff99}.ob-d-dock{transform:none}.ob-d-prompt{transform-origin:50% 100%}.ob-d-words{position:absolute;left:54px;right:92px;top:16px;font-size:15px;line-height:22px;letter-spacing:-.005em;color:#fff;white-space:normal}.ob-d-prompt.is-big .ob-d-words{right:22px;top:20px;font-size:17px;line-height:26px}.ob-d-words .ph{color:var(--fg-4)}.ob-d-words .ghost{position:absolute;left:0;top:0;right:0;color:var(--fg-4)}.ob-d-words .caret{display:inline-block;width:1.5px;height:18px;margin-left:1px;vertical-align:-3px;border-radius:1px;background:var(--amethyst-700)}.ob-d-prompt.is-big .ob-d-words .caret{height:21px}.ob-d-words .typed{text-shadow:0 0 14px rgba(194,164,236,.35)}.ob-d-cue{position:absolute;left:54px;top:78px;display:inline-flex;align-items:center;gap:6px;padding:3px 10px 3px 4px;border-radius:999px;background:#9968df29;color:var(--amethyst-800);font-size:11.5px}.ob-d-cue kbd{padding:1px 7px;border-radius:5px;background:#ffffff29;color:#fff;font:600 10.5px var(--font-sans)}.ob-d-pill{position:absolute;top:10px;right:12px;display:inline-flex;align-items:center;gap:5px;height:26px;padding:0 11px 0 9px;border-radius:999px;background:#9968df29;border:1px solid rgba(194,164,236,.3);color:#e9dcff;font-size:11.5px;font-weight:600;transition:background .25s,box-shadow .25s}.ob-d-pill.is-lit{background:#9968df57;box-shadow:0 0 0 3px #9968df38,0 0 20px #9968df80}.ob-d-keycap{position:absolute;display:flex;align-items:flex-end;justify-content:space-between;padding:0 12px 8px;border-radius:11px;background:linear-gradient(180deg,#fdfdff,#e5e5ee);color:#11131c;font-size:15px;font-weight:650;box-shadow:0 5px #8e8ea6,0 14px 30px #00000080;transition:transform .1s ease-out,box-shadow .1s ease-out}.ob-d-keycap i{font-style:normal;font-size:18px;line-height:1;color:#4a4c5e}.ob-d-keycap.is-down{box-shadow:0 1px #8e8ea6,0 6px 14px #00000073,0 0 0 4px #9968df73;margin-top:4px}.ob-d-gallery{position:absolute;padding:10px;border-radius:14px;background:#0b0d15f7;border:1px solid var(--hairline);box-shadow:0 24px 60px #02040c99}.ob-d-gallery .head{display:flex;align-items:center;gap:7px;height:30px;font-size:10.5px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--fg-4)}.ob-d-gallery .head b{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;border-radius:999px;background:#ffffff14;color:#fff;font-size:10px;letter-spacing:0}.ob-d-gallery .grid{display:grid;grid-template-columns:1fr 1fr;gap:6px}.ob-d-gallery .cell{aspect-ratio:3 / 4;border-radius:8px;overflow:hidden;background:#ffffff0a;transition:opacity .2s}.ob-d-gallery .cell.is-lifted{opacity:.35}.ob-d-slot{position:absolute;border:1.5px dashed rgba(214,194,242,.7);border-radius:12px;background:#9968df1a}.ob-d-placed{position:absolute;border-radius:10px;overflow:hidden;box-shadow:0 22px 50px #0000008c,0 0 0 1px #ffffff14}.ob-d-ghost{width:52px;height:70px}.ob-d-pointer .ob-d-brush{display:block;width:18px;height:18px;margin:-9px 0 0 -9px;border-radius:50%;border:2px solid #fff;background:#ae86e540;box-shadow:0 0 0 1px #0006,0 2px 8px #0006}.ob-d-studio-wrap{position:absolute;inset:0;z-index:4;overflow:hidden;box-shadow:0 30px 80px #0009}.ob-d-studio{position:absolute;inset:0;background:#090b12}.ob-d-studio .top{position:absolute;left:0;right:0;top:0;height:26px;display:flex;align-items:center;gap:9px;padding:0 10px;border-bottom:1px solid var(--hairline-soft);color:var(--fg-3);font-size:10.5px}.ob-d-studio .top .back,.ob-d-studio .top .x{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:6px;background:#ffffff0d}.ob-d-studio .top .x{margin-left:auto}.ob-d-studio .top .crumb{color:#fff;font-weight:600}.ob-d-studio .top .crumb small{margin-right:6px;font-size:8px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.ob-d-studio .top .chip{display:inline-flex;align-items:center;gap:4px;height:16px;padding:0 7px;border-radius:999px;border:1px solid rgba(194,164,236,.3);color:var(--amethyst-800);font-size:9px}.ob-d-studio .tools,.ob-d-studio .hist{position:absolute;top:34px;width:132px;height:316px;padding:8px;border-radius:12px;background:#121521d9;border:1px solid var(--hairline-soft)}.ob-d-studio .tools{left:10px}.ob-d-studio .hist{left:498px;display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:min-content;gap:5px}.ob-d-studio .tabs{display:flex;padding:3px;margin-bottom:6px;border-radius:9px;background:#ffffff0a}.ob-d-studio .tabs span{flex:1;padding:5px 0;border-radius:7px;text-align:center;font-size:10.5px;font-weight:600;color:var(--fg-3)}.ob-d-studio .tabs span.on{background:#9968df4d;color:#fff}.ob-d-studio .row{display:flex;align-items:center;gap:7px;margin-top:3px;padding:7px 8px;border-radius:8px;font-size:10.5px;color:var(--fg-3)}.ob-d-studio .row.on{background:#ffffff0d;color:#fff}.ob-d-studio .row .licon{color:var(--fg-4)}.ob-d-studio .row.on .licon{color:var(--amethyst-700)}.ob-d-studio .versions{position:absolute;left:230px;top:38px;z-index:3;display:flex;gap:5px}.ob-d-studio .versions .v{width:24px;height:32px;border-radius:5px;overflow:hidden;border:1.5px solid rgba(255,255,255,.18);box-shadow:0 4px 10px #00000080}.ob-d-studio .versions .v.is-new{border-color:var(--amethyst-600);animation:obTick .4s var(--ease-out-soft)}.ob-d-studio .stage{position:absolute;left:222px;top:30px;width:196px;height:262px;border-radius:12px;overflow:hidden;box-shadow:0 20px 50px #0000008c,0 0 0 1px #ffffff12;transform-origin:50% 50%}.ob-d-studio .stage img{position:absolute;inset:0}.ob-d-studio .stage .seam{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;background:#fff;box-shadow:0 0 14px 3px #c2a4ecd9}.ob-d-studio .stage.is-busy:after{content:"";position:absolute;inset:0;background:linear-gradient(105deg,transparent 30%,rgba(255,255,255,.18) 50%,transparent 70%);background-size:250% 100%;animation:obShimmer 1.1s linear infinite}@keyframes obShimmer{0%{background-position:120% 0}to{background-position:-120% 0}}.ob-d-studio .hist .h{aspect-ratio:3 / 4;border-radius:6px;overflow:hidden}.ob-d-paint{position:absolute;left:0;top:0;z-index:3;overflow:visible;mix-blend-mode:screen}.ob-d-editbar{position:absolute;z-index:3;display:flex;align-items:center;gap:8px;padding:0 8px 0 14px;border-radius:14px;background:#0b0d15fa;border:1px solid var(--hairline);box-shadow:0 20px 50px #02040c99}.ob-d-editbar .words{flex:1;min-width:0;font-size:12px;color:#fff;white-space:nowrap;overflow:hidden}.ob-d-editbar .ph{color:var(--fg-4)}.ob-d-editbar .run{display:inline-flex;align-items:center;justify-content:center;width:54px;height:28px;border-radius:999px;background:#ffffff12;color:var(--fg-4);font-size:11.5px;font-weight:600;transition:background .3s,color .3s}.ob-d-editbar .run.is-lit{background:var(--grad-cta);color:#fff;box-shadow:0 6px 16px #745aff59}.ob-d-editbar .run.is-busy{opacity:.75}.ob-d-world{position:absolute;inset:0;transform-origin:320px 170px}.ob-d-frame{position:absolute;border:1px solid rgba(255,255,255,.16);border-radius:14px;background:#ffffff06}.ob-d-frame:not(.is-drawn){border-style:dashed;border-color:#d6c2f2bf;background:#9968df0f}.ob-d-frame .title{position:absolute;left:2px;top:-24px;font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--fg-2);white-space:nowrap}.ob-d-note{z-index:2}.ob-d-note .text{font-size:12.5px}.ob-d-pin{position:absolute;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;margin:-28px 0 0;border-radius:50% 50% 50% 4px;background:linear-gradient(135deg,#e07bb3,#9968df);color:#fff;font-size:10px;font-weight:700;box-shadow:0 0 0 2px #070910,0 8px 20px #00000073;transform-origin:0 100%}.ob-d-bubble{position:absolute;z-index:3;margin-top:-28px;padding:6px 11px;border-radius:10px 10px 10px 3px;background:#121521f7;border:1px solid var(--hairline);color:#fff;font-size:11.5px;white-space:nowrap;box-shadow:0 10px 26px #00000073}.ob-d-chatframe{box-shadow:0 0 0 calc(2px * var(--sel, 0)) rgba(174,134,229,calc(.9 * var(--sel, 0))),0 0 0 calc(1.5px * var(--glow, 0)) rgba(194,164,236,calc(.85 * var(--glow, 0))),0 0 calc(26px * var(--glow, 0)) rgba(153,104,223,calc(.55 * var(--glow, 0)))}.ob-d-finished{z-index:1;box-shadow:0 14px 40px #02040c73,0 0 0 1px #c2a4ec59}.ob-d-chatcard{position:absolute;display:flex;flex-direction:column;gap:7px;padding:9px 10px;border-radius:11px;background:#121521f0;border:1px solid rgba(194,164,236,.4);box-shadow:0 12px 30px #00000073;transform-origin:0 0}.ob-d-chatcard .head{display:flex;align-items:center;gap:6px;font-size:10.5px;font-weight:600;color:#fff}.ob-d-chatcard .line{height:5px;border-radius:3px;background:#ffffff1a}.ob-d-chatcard .line.is-short{width:62%}.ob-d-chatcard .mark,.ob-d-chat .head .mark{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:6px;background:var(--grad-cta);color:#fff}.ob-d-ctxbar{position:absolute;z-index:3;display:flex;align-items:center;gap:6px;padding:0 5px;border-radius:10px;background:#0e101af7;border:1px solid var(--hairline);box-shadow:0 10px 26px #00000073}.ob-d-ctxbar .chat{display:inline-flex;align-items:center;justify-content:center;gap:4px;width:56px;height:20px;border-radius:6px;color:#fff;font-size:10px;font-weight:600;transition:background .2s}.ob-d-ctxbar .chat.is-lit{background:#9968df61;box-shadow:0 0 0 3px #9968df38}.ob-d-ctxbar .ic{width:14px;height:14px;border-radius:4px;background:#ffffff14}.ob-d-chat{position:absolute;z-index:2;border-radius:14px;background:#0b0d15fa;border:1px solid var(--hairline);box-shadow:0 24px 60px #02040c99}.ob-d-chat>*{position:absolute}.ob-d-chat .head{left:0;right:0;top:0;display:flex;align-items:center;gap:8px;height:38px;padding:0 10px;border-bottom:1px solid var(--hairline-soft)}.ob-d-chat .head .t{display:flex;flex-direction:column;line-height:1.25}.ob-d-chat .head b{font-size:10.5px;color:#fff}.ob-d-chat .head small{font-size:8.5px;color:var(--fg-4)}.ob-d-chat .bubble{box-sizing:border-box;padding:6px 9px;border-radius:11px 11px 3px;background:#9968df4d;color:#fff;font-size:9.5px;line-height:1.35}.ob-d-chat .answer{display:flex;gap:7px}.ob-d-chat .answer .ai{display:inline-flex;align-items:center;justify-content:center;flex:none;width:16px;height:16px;border-radius:50%;background:#9968df52;color:var(--amethyst-800)}.ob-d-chat .answer .ai.is-busy{animation:obCue 1s ease-in-out infinite}.ob-d-chat .answer .lines{flex:1;display:flex;flex-direction:column;gap:6px;padding-top:3px}.ob-d-chat .answer .lines i{display:block;height:5px;border-radius:3px;background:#ffffff29}.ob-d-chat .plan{box-sizing:border-box;display:flex;flex-direction:column;gap:4px;padding:9px 10px;border-radius:11px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.ob-d-chat .plan .eyebrow{font-size:7.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.ob-d-chat .plan .ttl{font-size:11px;font-weight:600;color:#fff}.ob-d-chat .plan .sess{display:inline-flex;align-items:center;gap:5px;font-size:9px;color:var(--fg-3)}.ob-d-chat .run{z-index:1;display:inline-flex;align-items:center;justify-content:center;gap:4px;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:9.5px;font-weight:600;box-shadow:0 6px 16px #745aff59;transition:box-shadow .25s,background .3s}.ob-d-chat .run.is-lit{box-shadow:0 0 0 3px #d6c2f280,0 8px 22px #745aff99}.ob-d-chat .run.is-busy{opacity:.8}.ob-d-chat .run.is-done{background:#2ecc8a2e;color:#7fe3b4;box-shadow:none}.ob-d-chat .composer{box-sizing:border-box;padding:8px 34px 8px 10px;border-radius:11px;background:#ffffff09;border:1px solid var(--hairline-soft)}.ob-d-chat .composer .words{display:block;font-size:9.5px;line-height:1.4;color:#fff}.ob-d-chat .composer .ph{color:var(--fg-4)}.ob-d-chat .composer .typed{text-shadow:0 0 14px rgba(194,164,236,.35)}.ob-d-chat .send{display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:#ffffff14;color:var(--fg-4);transition:background .25s,color .25s}.ob-d-chat .send.is-lit{background:var(--grad-cta);color:#fff;box-shadow:0 4px 12px #745aff73}@media(max-width:900px){.ob-chapters li .l{display:none}.ob-chapters li.on .l{display:inline}.ob-head-name{display:none}}@media(max-width:640px){.ob-card{width:calc(100vw - 32px)}.ob-welcome-title,.ob-finale-title{font-size:24px}.ob-welcome-body{padding:0 22px 24px}.ob-learned{grid-template-columns:1fr}}@media(prefers-reduced-motion:reduce){.ob-ring,.ob-ring:after,.ob-slot,.ob-arc path,.ob-dot,.ob-finale-mark .halo,.ob-finale-mark path,.ob-learned li,.ob-learned .ob-tick,.bd-root .up-cue.is-tour{animation:none}.ob-card,.ob-own-enter-active,.ob-own-leave-active,.ob-card-enter-active,.ob-card-leave-active,.ob-media-enter-active,.ob-media-leave-active,.ob-words-enter-active,.ob-words-leave-active{transition:none}}';
let zh = 0, co = null;
function BAe() {
  return zh++, co || (co = document.createElement("style"), co.setAttribute("data-rd-board-tour", ""), co.textContent = [OAe, LAe].join(`
`), document.head.appendChild(co)), () => {
    zh = Math.max(0, zh - 1), !zh && co && (co.remove(), co = null);
  };
}
const FAe = 25e3;
function eEe(n, e) {
  const t = QI(), i = BAe(), s = iA(), o = e.user || { uid: "local", name: "You", email: "" }, r = { ...o, initials: ta(o.name || o.email || "You") }, a = new Vy(null, { uid: r.uid, email: r.email }), l = new DAe(qy);
  let d = 0;
  const c = () => {
    const T = "tour-practice-" + Date.now().toString(36) + "-" + ++d;
    return a.addSeeded(T, kAe()), T;
  }, u = /* @__PURE__ */ K(c()), p = /* @__PURE__ */ K(!1), f = /* @__PURE__ */ K(""), y = new AAe({
    reason: e.reason,
    canSkip: e.canSkip || e.reason === "replay",
    board: e.board || null,
    gen: l,
    onProgress: e.onProgress,
    onExit: (T) => {
      p.value || (p.value = !0, f.value = "", Promise.resolve().then(() => e.onExit(T)).catch((M) => {
        p.value = !1, f.value = M instanceof Error && M.message || "Something went wrong. Please try again.";
      }));
    },
    restart: () => {
      const T = u.value;
      y.reset(), l.reset(), u.value = c(), T && a.remove(T);
    },
    reducedMotion: Yy(),
    timing: e.timing,
    // a host's own dialogs, outside the tour's element, keep their clicks and keys
    scope: () => n
  }), b = {
    directory: a,
    user: r,
    catalog: /* @__PURE__ */ We(sA()),
    gen: l,
    boardId: u,
    ready: /* @__PURE__ */ K(!0),
    onController: (T) => {
      y.attach(T), e.onController && e.onController(T, y);
    },
    // the tour's bar covers the board's: nothing leaves through it
    openBoard: () => {
    },
    home: () => {
    },
    library: null,
    labels: e.labels
  };
  let w = !1;
  const k = (T) => {
    w || y.isStarted || (w = !0, console.error("[tour] the practice board did not open:", T), Promise.resolve().then(() => e.onExit("failed")).catch((M) => console.error("[tour]", M)));
  }, S = window.setTimeout(() => k("it took too long"), e.startWithin || FAe), _ = $e(() => y.board.value && y.board.value.loadError.value, (T) => {
    T && k(T);
  }), x = x3(fAe, { env: b, tour: y, busy: p, error: f });
  return x.config.errorHandler = (T) => console.error("[tour]", T), x.mount(n), document.body.classList.add("bd-open"), {
    unmount() {
      clearTimeout(S), _(), y.dispose(), x.unmount(), document.body.classList.remove("bd-open"), s(), i(), t();
    }
  };
}
var NAe = { version: "0.1.0", commit: "e9447c637" };
function UAe(n) {
  if (!n) return null;
  const e = Number(n.x), t = Number(n.y), i = Number(n.z);
  return !Number.isFinite(e) || !Number.isFinite(t) || !Number.isFinite(i) || i <= 0 ? null : { x: e, y: t, zoom: i };
}
function GAe(n, e) {
  const t = QI(), i = iA(), s = e.user || { uid: "local", name: "You", email: "" }, o = { ...s, initials: ta(s.name || s.email || "You") }, r = /* @__PURE__ */ K(e.boardId), a = /* @__PURE__ */ We(sA()), l = b8(), d = new PQ(l, zH());
  let c, u, p, f, y = null;
  const b = /* @__PURE__ */ K(!0);
  if (e.directory)
    c = e.directory;
  else if (e.firebase) {
    const P = e.firebase, D = Promise.resolve().then(() => Xy), $ = [];
    let O = null, L = null;
    b.value = !1, D.then((J) => {
      L = J, O = new J.RunnitCanvasDirectory(P, o);
      for (const re of $) re(O);
      b.value = !0, y = () => {
        J.loadToolCatalog(P, o, { isBlocked: e.isToolBlocked }).then((re) => {
          re && re.kits.length && (a.value = re);
        }).catch((re) => console.warn("[board] live tool catalog unavailable, using the demo catalog", re));
      }, y();
    });
    const Z = () => O ? Promise.resolve(O) : new Promise((J) => $.push(J));
    c = {
      list: () => Z().then((J) => J.list()),
      create: (J, re) => Z().then((F) => F.create(J, re)),
      rename: (J, re) => Z().then((F) => F.rename(J, re)),
      open: (J) => {
        if (O) return O.open(J);
        throw new Error("Board storage is still starting");
      }
    }, p = (J) => L ? L.boardServices(P, o, J, { isBlocked: e.isToolBlocked }) : null, f = (J, re) => L ? L.commentStore(P, o, J, re) : null, u = () => ({
      upload: (J) => D.then((re) => re.uploadFile(P, o, J)).then((re) => re.url),
      uploadRecord: (J) => D.then((re) => re.uploadFile(P, o, J))
    });
  } else
    c = new Vy(null, { uid: o.uid, email: o.email });
  const w = e.comments;
  !f && w && (f = (P, D) => new WSe({ db: w.db, me: { uid: o.uid, name: o.name, email: o.email }, boardId: P, board: D, people: w.people }));
  const k = (P) => {
    const D = e.stress;
    if (D) {
      D.rebuild(P || D.images.value);
      return;
    }
    const $ = P ? "?images=" + P : "";
    e.navigate ? e.navigate("/board/stress" + $) : location.assign("/stress.html" + $);
  }, S = e.feedback || {};
  let _ = null;
  S.enabled !== !1 && !e.stress && (_ = new LSe(), _.captureConsole());
  const x = S.sink || (e.firebase ? jSe(e.firebase) : new NSe()), T = e.stress ? "in memory (the stress page, never saved)" : e.backend ? e.backend : e.firebase ? "Firebase project " + (e.firebase.db.app.options.projectId || "unknown") : e.directory ? "this browser (the harness)" : "in memory", M = {
    directory: c,
    user: o,
    catalog: a,
    gen: d,
    boardId: r,
    ready: b,
    onController: e.onController,
    openBoard: (P) => {
      e.openBoard ? e.openBoard(P) : r.value = P;
    },
    home: () => {
      e.navigate && e.navigate("/runnit/home");
    },
    uploaderFor: u || (() => ({
      // harness: the image lives as long as the page
      upload: (P) => Promise.resolve(URL.createObjectURL(P))
    })),
    servicesFor: p,
    studio: {
      babylon: e.babylon,
      upload3d: e.firebase && e.firebase.upload3d ? e.firebase.upload3d : void 0,
      uploadMask: e.firebase && e.firebase.uploadMask ? e.firebase.uploadMask : void 0
    },
    // without real services (the harness, tests), a Library of the demo's pictures
    library: e.firebase ? null : new RSe(),
    storageUrl: e.firebase ? e.firebase.storageUrl : void 0,
    openRunnit: (P) => {
      e.navigate && e.navigate("/runnit/" + P);
    },
    getTokens: e.getTokens,
    openTour: e.openTour,
    track: e.track,
    initialCamera: UAe(e.initialQuery),
    onCameraSettled: (P) => {
      e.replaceQuery && e.replaceQuery({ x: String(Math.round(P.x)), y: String(Math.round(P.y)), z: String(Math.round(P.zoom * 1e3) / 1e3) });
    },
    // ?studio= keeps the Studios view's session, so a refresh comes back to it (CHAT-07)
    initialStudio: e.initialQuery && typeof e.initialQuery.studio == "string" ? e.initialQuery.studio : null,
    onStudio: (P) => {
      e.replaceQuery && e.replaceQuery({ studio: P || void 0 });
    },
    onTitle: (P) => {
      e.onTitle ? e.onTitle(P) : document.title = P + " | RunDiffusion";
    },
    showStats: t1,
    openStress: k,
    backend: T,
    stress: e.stress,
    featured: e.featuredPrompts ? { load: e.featuredPrompts } : void 0,
    myPrompts: e.promptShelf,
    labels: e.labels,
    feedback: _ ? { recorder: _, sink: x, build: NAe } : void 0,
    commentsFor: f,
    commentLink: e.commentLink || ((P, D) => location.origin + "/board/" + P + "?comment=" + encodeURIComponent(D)),
    initialComment: e.initialQuery && typeof e.initialQuery.comment == "string" ? e.initialQuery.comment : null,
    clearCommentLink: () => {
      e.replaceQuery && e.replaceQuery({ comment: void 0 });
    },
    agent: e.agent || null
  }, z = x3(ZI, { env: M });
  return z.config.errorHandler = (P) => console.error("[board]", P), z.mount(n), document.body.classList.add("bd-open"), {
    setBoardId(P) {
      r.value !== P && (r.value = P);
    },
    refreshTools() {
      y && y();
    },
    unmount() {
      z.unmount(), _ && _.dispose(), document.body.classList.remove("bd-open"), i(), t();
    }
  };
}
async function tEe(n, e, t) {
  const i = await Promise.resolve().then(() => Xy), s = { ...e, initials: ta(e.name || e.email || "You") };
  return (await new i.RunnitCanvasDirectory(n, s).create(t, "blank")).id;
}
async function nEe(n, e, t = {}) {
  const i = await Promise.resolve().then(() => Xy), s = { ...e, initials: ta(e.name || e.email || "You") }, o = new i.RunnitCanvasDirectory(n, s);
  if (!t.fresh) {
    const a = await o.findOwn("Bonneville Tower");
    if (a) return a.id;
  }
  return (await o.create("Bonneville Tower", "demo")).id;
}
function iEe(n, e = {}) {
  const t = new Vy(null), i = /* @__PURE__ */ K(d4(e.images));
  let s = t.ensureTiledDemo(i.value), o = null;
  const r = {
    images: i,
    layout: /* @__PURE__ */ We(Iw(i.value)),
    collapsed: /* @__PURE__ */ K(!1),
    tab: /* @__PURE__ */ K("board"),
    reports: /* @__PURE__ */ new Map(),
    rebuild(a) {
      const l = d4(a);
      if (l === i.value || !o) return;
      const d = s;
      s = t.ensureTiledDemo(l), i.value = l, r.layout.value = Iw(l), o.setBoardId(s), t.remove(d), e.onImages && e.onImages(l);
    }
  };
  return o = GAe(n, {
    boardId: s,
    directory: t,
    user: e.user,
    navigate: e.navigate,
    onController: e.onController,
    openBoard: (a) => {
      a && o ? o.setBoardId(a) : !a && e.onIndex && e.onIndex();
    },
    showStats: !0,
    stress: r
  }), o;
}
ct.add(aq);
ct.mixin(un, lq);
ct.add(JS);
ct.add(ZS);
ct.mixin(un, GY);
ct.add(iT, tT);
ct.add(nT);
const jAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), HAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var VAe = Object.defineProperty, WAe = (n, e, t) => e in n ? VAe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Vt = (n, e, t) => WAe(n, typeof e != "symbol" ? e + "" : e, t);
const R0 = 450, qAe = 500, pp = "CANVAS";
class $h extends Error {
  constructor(e, t, i) {
    super(e), Vt(this, "kind", t), Vt(this, "runnitType", i);
  }
}
function z0(n, e) {
  return {
    id: n,
    title: e.title || "Untitled board",
    ownerId: e.userId,
    teamId: e.teamId || null,
    description: e.description || "",
    accessLevel: e.accessLevel || null,
    createdAt: hn(e.createdAt)
  };
}
class KAe {
  constructor(e, t) {
    Vt(this, "fb", e), Vt(this, "user", t);
  }
  /** Your personal canvas boards, and your team's: the Dev chip's links to your demo boards (the real list is src/list). */
  async list() {
    const e = this.fb.db.collection("runnits"), t = [
      e.where("userId", "==", this.user.uid).where("type", "==", pp).where("deletedAt", "==", null).where("teamId", "==", null)
    ];
    this.user.teamId && t.push(e.where("teamId", "==", this.user.teamId).where("type", "==", pp).where("deletedAt", "==", null));
    const i = await Promise.all(t.map((o) => o.limit(200).get())), s = [];
    for (const o of i)
      for (const r of o.docs) s.push(z0(r.id, r.data()));
    return s.sort((o, r) => (r.createdAt || 0) - (o.createdAt || 0));
  }
  /**
   * Your own board by this title in the account you're working in (the
   * newest), or null: the admins' demo board reopens rather than coming again
   * every time (IL-100).
   */
  async findOwn(e) {
    const t = this.user.teamId || null;
    return (await this.list()).filter((s) => s.ownerId === this.user.uid && (s.teamId || null) === t && s.title === e)[0] || null;
  }
  /** A canvas board in the team you're working in (or a personal one), as v1's create path writes a runnit. */
  async create(e, t = "blank") {
    const i = this.fb.FieldValue, s = t === "demo" ? Rl() : null, o = this.user.teamId || null, r = {
      createdAt: i.serverTimestamp(),
      deletedAt: null,
      userId: this.user.uid,
      teamId: o,
      type: pp,
      accessLevel: "PRIVATE",
      title: s ? s.title : e,
      description: "",
      avatarId: null,
      avatar: null
    }, a = await this.fb.db.collection("runnits").add(r);
    return s && await YAe(this.fb, this.user, a, s.elements), { id: a.id, title: r.title, ownerId: this.user.uid, teamId: o, createdAt: Date.now() };
  }
  async rename(e, t) {
    await this.fb.db.collection("runnits").doc(e).update({ title: t });
  }
  open(e) {
    return new XAe(this.fb, this.user, e);
  }
}
async function YAe(n, e, t, i) {
  const s = new e8(), o = t.collection("runnitCanvasElements"), r = Date.now(), a = /* @__PURE__ */ new Map();
  for (const c of i) {
    const u = Kh(c, e.uid, r), p = s.place(c.id, fl(u), () => o.doc().id);
    a.has(p) || a.set(p, {}), a.get(p)[c.id] = u;
  }
  let l = n.db.batch(), d = 0;
  for (const [c, u] of a)
    l.set(o.doc(c), { v: X6, elements: u, updatedBy: e.uid, updatedAt: n.FieldValue.serverTimestamp() }), ++d >= R0 && (await l.commit(), l = n.db.batch(), d = 0);
  d && await l.commit();
}
class XAe {
  constructor(e, t, i) {
    Vt(this, "fb", e), Vt(this, "user", t), Vt(this, "boardId", i), Vt(this, "status", /* @__PURE__ */ K("saved")), Vt(this, "index", new e8()), Vt(this, "known", /* @__PURE__ */ new Map()), Vt(this, "idsIn", /* @__PURE__ */ new Map()), Vt(this, "serverBuckets", /* @__PURE__ */ new Set()), Vt(this, "latest", /* @__PURE__ */ new Map()), Vt(this, "hints", /* @__PURE__ */ new Map()), Vt(this, "queue", /* @__PURE__ */ new Map()), Vt(this, "onRemote", null), Vt(this, "unsubs", []), Vt(this, "timer", 0), Vt(this, "flushing", null), Vt(this, "retry", 0), Vt(this, "loaded", !1), Vt(this, "disposed", !1), Vt(this, "abortLoad", null), Vt(this, "meta", null), Vt(this, "onlineHandler", () => this.updateOnline()), window.addEventListener("online", this.onlineHandler), window.addEventListener("offline", this.onlineHandler), this.updateOnline();
  }
  runnitRef() {
    return this.fb.db.collection("runnits").doc(this.boardId);
  }
  bucketRef(e) {
    return this.runnitRef().collection("runnitCanvasElements").doc(e);
  }
  updateOnline() {
    navigator.onLine ? this.status.value === "offline" && (this.status.value = this.queue.size ? "saving" : "saved") : this.status.value = "offline";
  }
  async load() {
    let e;
    try {
      e = await this.runnitRef().get();
    } catch (s) {
      throw Po(s) === "permission-denied" ? new $h("This board doesn't exist, or you don't have access to it.", "missing") : s;
    }
    if (this.disposed) throw new Error("The board was closed while it loaded.");
    if (!e.exists) throw new $h("This board doesn't exist, or you don't have access to it.", "missing");
    const t = e.data();
    if (t.type !== pp) throw new $h("It was made in Boards, before canvas boards, and it opens there.", "not-canvas", t.type);
    if (t.deletedAt) throw new $h("This board was deleted.", "deleted");
    this.meta = z0(this.boardId, t);
    const i = await new Promise((s, o) => {
      this.abortLoad = o;
      const r = this.runnitRef().collection("runnitCanvasElements").onSnapshot(
        (a) => {
          this.loaded ? this.nextSnapshot(a) : (this.loaded = !0, s(this.firstSnapshot(a)));
        },
        (a) => {
          console.error("[board] contents listener failed", a), this.loaded ? this.status.value = "error" : o(a);
        }
      );
      this.keep(r);
    });
    return this.abortLoad = null, this.keep(this.runnitRef().onSnapshot((s) => {
      if (!this.onRemote || s.metadata.hasPendingWrites || !s.exists) return;
      const o = s.data();
      this.meta = z0(this.boardId, o), this.onRemote({ upserted: [], removed: [], meta: { ...this.meta, deleted: !!o.deletedAt } });
    }, () => {
    })), { meta: { ...this.meta }, elements: i, results: RH(i) };
  }
  firstSnapshot(e) {
    const t = [];
    for (const i of e.docs) {
      const s = this.readBucket(i);
      t.push(...pw(this.known, this.idsOf(i.id), s).upserted);
    }
    return t;
  }
  nextSnapshot(e) {
    if (!this.onRemote) return;
    const t = [], i = [];
    let s = !1;
    const o = new Set(this.queue.keys());
    for (const r of e.docChanges()) {
      if (r.doc.metadata.hasPendingWrites) continue;
      const a = r.type === "removed" ? {} : this.readBucket(r.doc), l = pw(this.known, this.idsOf(r.doc.id), a, o);
      t.push(...l.upserted), i.push(...l.removed), l.trash && (s = !0);
    }
    (t.length || i.length || s) && this.onRemote({ upserted: t, removed: i, trash: s || void 0 });
  }
  readBucket(e) {
    const t = e.data(), i = t.elements || {};
    return this.serverBuckets.add(e.id), this.latest.set(e.id, i), this.hints.set(e.id, hn(t.hardDeleteAt) || null), this.index.setBucket(e.id, i), i;
  }
  idsOf(e) {
    let t = this.idsIn.get(e);
    return t || (t = /* @__PURE__ */ new Set(), this.idsIn.set(e, t)), t;
  }
  watch(e) {
    this.onRemote = e;
  }
  enqueue(e, t, i) {
    const s = this.queue.get(e);
    this.queue.set(e, { op: xu(s ? s.op : void 0, t), full: i || (s ? s.full : null) });
  }
  commit(e) {
    const t = Date.now(), i = this.user.uid;
    for (const s of e.added) {
      const o = Kh(s, i, t);
      this.index.place(s.id, fl(o), () => this.newBucketId()), this.enqueue(s.id, { kind: "put", data: o }, s);
    }
    for (const s of e.updated) {
      const o = {};
      for (const [r, a] of Object.entries(s.after)) o[r] = a === void 0 ? void 0 : $p(a);
      o.updatedBy = i, o.updatedAt = t, this.enqueue(s.id, { kind: "patch", fields: o }, s.el);
    }
    for (const s of e.removed)
      this.enqueue(s.id, { kind: "patch", fields: YN(i, this.user.email, t) }, s);
    this.schedule();
  }
  /** An element as the server will have it once the queue is saved. */
  pending(e) {
    const t = this.known.get(e), i = this.queue.get(e);
    if (!i) return t;
    let s = i.op;
    return s.kind === "patch" && !t && i.full && (s = xu({ kind: "put", data: Kh(i.full, this.user.uid, Date.now()) }, s)), Fm(t, s);
  }
  trash() {
    const e = Date.now(), t = [], i = new Set(this.known.keys());
    for (const s of this.queue.keys()) i.add(s);
    for (const s of i) {
      const o = JN(s, this.pending(s), e);
      o && t.push(o);
    }
    return t.sort((s, o) => o.deletedAt - s.deletedAt);
  }
  purge(e) {
    for (const t of e)
      this.index.bucketOf(t) && this.enqueue(t, { kind: "delete" }, null);
    this.schedule();
  }
  commitResults() {
  }
  saveMeta(e) {
    const t = {};
    e.title !== void 0 && (t.title = e.title), e.description !== void 0 && (t.description = e.description), Object.keys(t).length && this.runnitRef().update(t).catch((i) => {
      console.error("[board] board details not saved", i), this.onRemote && this.meta && this.onRemote({ upserted: [], removed: [], meta: { ...this.meta, refused: Po(i) === "permission-denied" ? "owner" : "error" } });
    });
  }
  newBucketId() {
    return this.runnitRef().collection("runnitCanvasElements").doc().id;
  }
  schedule() {
    this.status.value !== "offline" && (this.status.value = "saving"), clearTimeout(this.timer), this.timer = window.setTimeout(() => {
      this.flush().catch(() => {
      });
    }, qAe);
  }
  async flush() {
    if (clearTimeout(this.timer), this.flushing && (await this.flushing, !this.queue.size))
      return;
    if (!this.queue.size) {
      this.status.value === "saving" && (this.status.value = "saved");
      return;
    }
    const e = this.queue;
    return this.queue = /* @__PURE__ */ new Map(), this.flushing = this.write(e).then(() => {
      this.retry = 0, !this.queue.size && navigator.onLine && (this.status.value = "saved");
    }).catch((t) => {
      if (Po(t) === "permission-denied") {
        console.error("[board] save refused", t), this.status.value = "error";
        return;
      }
      console.error("[board] save failed, retrying", t);
      for (const [i, s] of e) {
        const o = this.queue.get(i);
        this.queue.set(i, o ? { op: xu(s.op, o.op), full: o.full || s.full } : s);
      }
      this.status.value = navigator.onLine ? "error" : "offline", this.retry = Math.min(6, this.retry + 1), this.disposed || (clearTimeout(this.timer), this.timer = window.setTimeout(() => {
        this.flush().catch(() => {
        });
      }, 1e3 * 2 ** this.retry));
    }).finally(() => {
      this.flushing = null;
    }), this.flushing;
  }
  /** One batch: per bucket, one set (a new bucket) or one field-level update. */
  async write(e) {
    const t = this.fb.FieldValue, i = this.fb.FieldPath, s = Date.now(), o = /* @__PURE__ */ new Map();
    for (const [d, c] of e) {
      let u = c.op;
      const p = this.index.bucketOf(d) || this.index.place(d, u.kind === "put" ? fl(u.data) : 400, () => this.newBucketId());
      if (u.kind === "patch" && (!this.known.has(d) || !this.serverBuckets.has(p))) {
        if (!c.full) continue;
        u = xu({ kind: "put", data: Kh(c.full, this.user.uid, s) }, u);
      }
      o.has(p) || o.set(p, []), o.get(p).push([d, u]);
    }
    const r = [], a = [];
    for (const [d, c] of o) {
      const u = this.bucketRef(d);
      if (!this.serverBuckets.has(d)) {
        const k = {};
        for (const [_, x] of c) x.kind === "put" && (k[_] = x.data);
        if (!Object.keys(k).length) continue;
        const S = Q6(k);
        r.push((_) => _.set(u, {
          v: X6,
          elements: k,
          ...S != null ? { hardDeleteAt: new Date(S) } : {},
          updatedBy: this.user.uid,
          updatedAt: t.serverTimestamp(),
          _created: t.serverTimestamp()
        }, { merge: !0 })), a.push(d);
        continue;
      }
      const p = [];
      for (const [k, S] of c)
        if (S.kind === "put") p.push(new i("elements", k), S.data);
        else if (S.kind === "delete") p.push(new i("elements", k), t.delete());
        else for (const [_, x] of Object.entries(S.fields)) p.push(new i("elements", k, _), x === void 0 ? t.delete() : x);
      const f = this.hintFor(d, c);
      f != null && p.push("hardDeleteAt", new Date(f)), p.push("updatedBy", this.user.uid, "updatedAt", t.serverTimestamp());
      const [y, b, ...w] = p;
      r.push((k) => k.update(u, y, b, ...w));
    }
    const l = /* @__PURE__ */ new Map();
    for (const d of o.values())
      for (const [c, u] of d) {
        l.set(c, this.known.get(c));
        const p = Fm(this.known.get(c), u);
        p ? this.known.set(c, p) : this.known.delete(c);
      }
    try {
      for (let d = 0; d < r.length; d += R0) {
        const c = this.fb.db.batch();
        for (const u of r.slice(d, d + R0)) u(c);
        await c.commit();
      }
    } catch (d) {
      for (const [c, u] of l)
        u ? this.known.set(c, u) : this.known.delete(c);
      throw d;
    }
    for (const d of a) this.serverBuckets.add(d);
  }
  /** The bucket's hardDeleteAt for a write (buckets.ts hintForWrite); `known` is still the state before it. */
  hintFor(e, t) {
    const i = t.map(([s, o]) => {
      const r = this.known.get(s);
      return [r, Fm(r, o)];
    });
    return XN(this.hints.get(e) || null, i, this.latest.get(e) || {});
  }
  /** Keep a listener until dispose; one set up after it (closed mid-load) stops at once. */
  keep(e) {
    this.disposed ? e() : this.unsubs.push(e);
  }
  dispose() {
    this.disposed = !0, window.removeEventListener("online", this.onlineHandler), window.removeEventListener("offline", this.onlineHandler), this.flush().catch(() => {
    });
    for (const e of this.unsubs) e();
    this.unsubs = [], this.onRemote = null, this.abortLoad && this.abortLoad(new Error("The board was closed while it loaded.")), this.abortLoad = null;
  }
}
var JAe = Object.defineProperty, ZAe = (n, e, t) => e in n ? JAe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Rb = (n, e, t) => ZAe(n, typeof e != "symbol" ? e + "" : e, t);
const QAe = 60;
function Nr(n, e) {
  const t = e.staticInputs || {};
  return {
    id: n,
    runnitId: String(e.runnitId || ""),
    nodeId: String(e.nodeId || ""),
    nodeDefId: String(e.nodeDefId || ""),
    userId: String(e.userId || ""),
    teamId: e.teamId || null,
    email: typeof e.email == "string" ? e.email : void 0,
    state: e.state || "INIT",
    initAt: hn(e.initAt) || hn(e.createdAt),
    doneAt: hn(e.doneAt),
    inputs: e.inputs || {},
    staticInputs: { numResults: typeof t.numResults == "number" ? t.numResults : void 0 },
    fields: Array.isArray(e.fields) ? e.fields : void 0,
    results: Array.isArray(e.results) ? e.results : void 0,
    tokensCharged: Dh(e.tokensCharged),
    freeTokensCharged: Dh(e.freeTokensCharged),
    tokensReturned: Dh(e.tokensReturned),
    freeTokensReturned: Dh(e.freeTokensReturned),
    deletedAt: e.deletedAt || null
  };
}
function Dh(n) {
  return typeof n == "number" ? n : void 0;
}
async function _A(n, e, t = !1) {
  try {
    const i = n.db.collection("runnitNodeRuns").doc(e), s = await (t ? i.get({ source: "server" }) : i.get());
    return s.exists ? Nr(s.id, s.data({ serverTimestamps: "estimate" }) || {}) : null;
  } catch (i) {
    if (Po(i) === "permission-denied" || Po(i) === "not-found") return null;
    throw i;
  }
}
class ePe {
  constructor(e, t) {
    Rb(this, "fb", e), Rb(this, "boardId", t), Rb(this, "unsubs", []);
  }
  col() {
    return this.fb.db.collection("runnitNodeRuns");
  }
  /** The board's newest runs, live. `changed` is what this snapshot brought. */
  watchRecent(e, t) {
    const i = this.col().where("runnitId", "==", this.boardId).where("deletedAt", "==", null).orderBy("initAt", "desc").limit(QAe).onSnapshot((s) => {
      const o = [], r = [];
      for (const a of s.docChanges())
        a.type === "removed" ? r.push(a.doc.id) : o.push(Nr(a.doc.id, a.doc.data({ serverTimestamps: "estimate" })));
      (o.length || r.length) && e(o, r);
    }, (s) => {
      console.warn("[board] the board's runs are unavailable", s), t && t(s);
    });
    this.unsubs.push(i);
  }
  /**
   * A page of the whole board's runs, newest first, for the board's history;
   * `before` is the last page's oldest initAt. watchRecent's query, paged, so
   * it needs no index of its own.
   */
  async boardPage(e, t = 40) {
    let i = this.col().where("runnitId", "==", this.boardId).where("deletedAt", "==", null).orderBy("initAt", "desc");
    return e != null && (i = i.startAfter(new Date(e))), (await i.limit(t).get()).docs.map((o) => Nr(o.id, o.data({ serverTimestamps: "estimate" })));
  }
  /** A page of one session's runs, newest first; `before` is the last page's oldest initAt. */
  async sessionPage(e, t, i = 24) {
    let s = this.col().where("runnitId", "==", this.boardId).where("nodeId", "==", e).where("deletedAt", "==", null).orderBy("initAt", "desc");
    return t != null && (s = s.startAfter(new Date(t))), (await s.limit(i).get()).docs.map((r) => Nr(r.id, r.data({ serverTimestamps: "estimate" })));
  }
  /** One run, read once (see readRun). */
  getRun(e, t = !1) {
    return _A(this.fb, e, t);
  }
  /** Follow one run (one you just started) until it's over. */
  watchRun(e, t) {
    const i = this.col().doc(e).onSnapshot((s) => {
      t(s.exists ? Nr(s.id, s.data({ serverTimestamps: "estimate" }) || {}) : null);
    }, () => t(null));
    return this.unsubs.push(i), () => {
      i(), this.unsubs = this.unsubs.filter((s) => s !== i);
    };
  }
  /**
   * Delete one result from its session's history, as v1 does: the result
   * is marked deleted inside its run, and the run too once all of its are.
   * The rules let its runner (or a team admin who manages generations) do it.
   */
  async deleteResult(e, t, i) {
    const s = this.col().doc(e);
    await this.fb.db.runTransaction(async (o) => {
      const r = await o.get(s);
      if (!r.exists) return;
      const a = (r.data() || {}).results || [], l = /* @__PURE__ */ new Date(), d = a.map((u) => u.uuid === t && !u.deletedAt ? { ...u, deletedAt: l, deletedByUserId: i } : u), c = d.every((u) => !!u.deletedAt);
      o.update(s, {
        results: d,
        ...c ? { deletedAt: l, deletedByUserId: i } : {}
      });
    });
  }
  /**
   * deleteResult taken back (Recently Deleted's Recover, CHAT-14): the
   * result's delete stamps go, and the run's too when the delete had taken
   * its last result. The same fields deleteResult writes, which the run's
   * owner may write either way. The run's deletedAt goes back to null rather
   * than away: every query of runs asks for deletedAt == null, which a run
   * without the field doesn't match, so it would be in no history at all.
   */
  async restoreResult(e, t) {
    const i = this.col().doc(e), s = this.fb.FieldValue;
    await this.fb.db.runTransaction(async (o) => {
      const r = await o.get(i);
      if (!r.exists) throw new Error("run " + e + " is gone");
      const a = r.data() || {}, d = (a.results || []).map((c) => {
        if (c.uuid !== t || !c.deletedAt) return c;
        const u = { ...c };
        return delete u.deletedAt, delete u.deletedByUserId, u;
      });
      o.update(i, {
        results: d,
        ...a.deletedAt ? { deletedAt: null, deletedByUserId: s.delete() } : {}
      });
    });
  }
  dispose() {
    for (const e of this.unsubs) e();
    this.unsubs = [];
  }
}
var tPe = Object.defineProperty, nPe = (n, e, t) => e in n ? tPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, In = (n, e, t) => nPe(n, typeof e != "symbol" ? e + "" : e, t);
function iPe(n, e) {
  return !n || !e ? n !== e : n.id !== e.id || n.nodeDefId !== e.nodeDefId || n.numResults !== e.numResults || JSON.stringify(n.inputs) !== JSON.stringify(e.inputs);
}
const sPe = 800, oPe = 8e3;
class rPe {
  constructor(e, t, i) {
    In(this, "fb", e), In(this, "uid", t), In(this, "boardId", i), In(this, "all", /* @__PURE__ */ new Map()), In(this, "current", /* @__PURE__ */ new Map()), In(this, "consumed", /* @__PURE__ */ new Set()), In(this, "submitting", /* @__PURE__ */ new Set()), In(this, "awaiting", /* @__PURE__ */ new Map()), In(this, "pending", /* @__PURE__ */ new Map()), In(this, "restoring", /* @__PURE__ */ new Map()), In(this, "runNode", /* @__PURE__ */ new Map()), In(this, "writing", /* @__PURE__ */ new Map()), In(this, "onChange", null), In(this, "followed", /* @__PURE__ */ new Map()), In(this, "listening", /* @__PURE__ */ new Map()), In(this, "timer", 0), In(this, "disposed", !1);
  }
  /**
   * Where your drafts go as they arrive. Nothing is read yet: a session's are
   * read when it's followed (opened, saved or run), so a board with many
   * sessions reads only the few you use.
   */
  start(e) {
    this.onChange = e;
    for (const [t, i] of this.current) e(t, i);
    return Promise.resolve();
  }
  /**
   * Follow your drafts in one session, live, so another tab's edit shows here.
   * Resolves once its first snapshot is in, so a save or a run knows which
   * draft is the session's before it writes.
   */
  follow(e) {
    let t = this.followed.get(e);
    return t || (t = new Promise((i) => {
      const s = { unsub: () => {
      }, settled: !1 }, o = () => {
        s.settled || (s.settled = !0, i(), this.disposed && s.unsub());
      };
      s.unsub = this.fb.db.collection("runnitNodeRunDrafts").where("userId", "==", this.uid).where("runnitId", "==", this.boardId).where("nodeId", "==", e).where("deletedAt", "==", null).onSnapshot((r) => {
        this.read(r, !s.settled), o();
      }, (r) => {
        console.warn("[board] drafts unavailable", r), o();
      }), this.listening.set(e, s);
    }), this.followed.set(e, t), t);
  }
  read(e, t) {
    const i = /* @__PURE__ */ new Set();
    for (const s of e.docChanges()) {
      const o = s.doc.data({ serverTimestamps: "estimate" }), r = String(o.nodeId || "");
      if (!r) continue;
      if (i.add(r), s.type === "removed") {
        this.all.delete(s.doc.id);
        continue;
      }
      if (o.state && o.state !== "DRAFT") {
        this.all.delete(s.doc.id);
        continue;
      }
      const a = o.staticInputs || {};
      this.all.set(s.doc.id, {
        id: s.doc.id,
        nodeId: r,
        nodeDefId: String(o.nodeDefId || ""),
        draftAt: hn(o.draftAt) || hn(o.createdAt) || 0,
        inputs: o.inputs || {},
        numResults: typeof a.numResults == "number" ? a.numResults : void 0
      });
    }
    for (const s of i) {
      const o = this.current.get(s), r = this.newest(s);
      r ? (this.current.set(s, r), o && o.id !== r.id && this.awaiting.delete(s)) : this.current.delete(s), !(this.pending.has(s) || this.restoring.has(s)) && this.onChange && (t || iPe(o, r)) && this.onChange(s, r);
    }
  }
  newest(e) {
    let t = null;
    for (const i of this.all.values())
      i.nodeId !== e || this.consumed.has(i.id) || (!t || i.draftAt > t.draftAt) && (t = i);
    return t;
  }
  get(e) {
    return this.current.get(e) || null;
  }
  /** Keep a session's prompt (debounced). */
  save(e, t, i, s) {
    this.pending.set(e, { nodeDefId: t, inputs: i, numResults: s }), this.later(sPe);
  }
  later(e) {
    clearTimeout(this.timer), this.disposed || (this.timer = window.setTimeout(() => {
      this.flush().catch(() => {
      });
    }, e));
  }
  /**
   * Whether a session's saves wait: a run is on its way with its draft, or
   * took it and the draft it leaves in its place hasn't arrived yet.
   */
  holding(e, t) {
    const i = this.current.get(e);
    if (i && this.submitting.has(i.id)) return !0;
    const s = this.awaiting.get(e);
    return !!(s && s > t && !i);
  }
  async flush() {
    clearTimeout(this.timer);
    const e = Date.now();
    let t = !1;
    const i = [];
    for (const [s, o] of Array.from(this.pending)) {
      if (this.holding(s, e)) {
        t = !0;
        continue;
      }
      this.pending.delete(s), i.push(this.queue(s, () => this.saveNow(s, o)).catch((r) => console.warn("[board] prompt not kept", r)));
    }
    await Promise.all(i), t && this.later(1e3);
  }
  /** A save's turn came: unless a run took the draft while it waited, in which case it waits again. */
  async saveNow(e, t) {
    if (await this.follow(e), this.holding(e, Date.now())) {
      this.pending.has(e) || this.pending.set(e, t), this.later(1e3);
      return;
    }
    await this.write(e, t);
  }
  /** Run a session's writes one after another, whatever became of the one before. */
  queue(e, t) {
    const s = (this.writing.get(e) || Promise.resolve()).then(t, t), o = s.catch(() => {
    });
    return this.writing.set(e, o), o.then(() => {
      this.writing.get(e) === o && this.writing.delete(e);
    }), s;
  }
  /**
   * Write a session's prompt now and give the draft id a run takes. Saves
   * leave that draft alone until the run settles: markConsumed when it went,
   * release when it didn't.
   */
  prepare(e, t, i, s, o = null) {
    return this.pending.delete(e), o && this.restoring.set(e, o), this.queue(e, async () => {
      await this.follow(e);
      let r;
      try {
        r = await this.write(e, { nodeDefId: t, inputs: i, numResults: s });
      } catch (a) {
        throw this.restoring.delete(e), a;
      }
      return this.submitting.add(r), this.runNode.set(r, e), r;
    });
  }
  /** The run didn't go: its draft is the session's again, and saves held for it go now. */
  release(e) {
    const t = this.submitting.delete(e), i = this.runNode.get(e);
    this.runNode.delete(e), i && this.putBack(i), t && this.pending.size && this.later(0);
  }
  /**
   * A run that wasn't the session's prompt is done with its draft: the prompt
   * goes back into it (or into the one a run leaves), unless something typed
   * since is waiting to be saved, which is newer and wins.
   */
  putBack(e) {
    const t = this.restoring.get(e);
    t && (this.restoring.delete(e), this.pending.has(e) || this.pending.set(e, t), this.later(0));
  }
  /** A run took this draft: later saves wait for the one the server leaves in its place. */
  markConsumed(e) {
    this.submitting.delete(e), this.consumed.add(e);
    const t = this.all.get(e), i = t && t.nodeId || this.runNode.get(e);
    if (this.runNode.delete(e), !i) return;
    this.awaiting.set(i, Date.now() + oPe);
    const s = this.newest(i);
    s ? this.current.set(i, s) : this.current.delete(i), this.putBack(i);
  }
  /** Write to the session's draft, or start one. Only ever in the session's queue. */
  async write(e, t) {
    const i = this.current.get(e), s = this.fb.db.collection("runnitNodeRunDrafts"), o = this.fb.db.collection("runnitNodeDefs").doc(t.nodeDefId);
    if (i && !this.consumed.has(i.id) && !this.submitting.has(i.id))
      try {
        return await s.doc(i.id).update({
          inputs: t.inputs,
          staticInputs: { numResults: t.numResults },
          ...i.nodeDefId !== t.nodeDefId ? { nodeDefId: t.nodeDefId, nodeDef: o } : {}
        }), this.all.set(i.id, { ...i, nodeDefId: t.nodeDefId, inputs: t.inputs, numResults: t.numResults }), this.current.set(e, this.all.get(i.id)), i.id;
      } catch (d) {
        if (Po(d) !== "permission-denied" && Po(d) !== "not-found") throw d;
        this.consumed.add(i.id);
      }
    const r = this.fb.FieldValue, a = await s.add({
      createdAt: r.serverTimestamp(),
      deletedAt: null,
      draftAt: r.serverTimestamp(),
      userId: this.uid,
      runnitId: this.boardId,
      nodeId: e,
      nodeDefId: t.nodeDefId,
      nodeDef: o,
      mode: "MANUAL",
      state: "DRAFT",
      inputs: t.inputs,
      staticInputs: { numResults: t.numResults }
    }), l = { id: a.id, nodeId: e, nodeDefId: t.nodeDefId, draftAt: Date.now(), inputs: t.inputs, numResults: t.numResults };
    return this.all.set(a.id, l), this.current.set(e, l), this.awaiting.delete(e), a.id;
  }
  dispose() {
    this.disposed = !0, this.flush().catch(() => {
    });
    for (const e of this.listening.values()) e.settled && e.unsub();
    this.onChange = null;
  }
}
var aPe = Object.defineProperty, lPe = (n, e, t) => e in n ? aPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, xd = (n, e, t) => lPe(n, typeof e != "symbol" ? e + "" : e, t);
class dPe {
  constructor(e, t, i) {
    xd(this, "fb", e), xd(this, "uid", t), xd(this, "boardId", i), xd(this, "uuids", /* @__PURE__ */ We(/* @__PURE__ */ new Set())), xd(this, "unsub", null);
  }
  start() {
    this.unsub = this.fb.db.collection("resultFavorites").where("userId", "==", this.uid).where("runnitId", "==", this.boardId).onSnapshot((e) => {
      const t = /* @__PURE__ */ new Set();
      for (const i of e.docs) {
        const s = i.data().nodeRunResultUuid;
        s && t.add(s);
      }
      this.uuids.value = t, os(this.uuids);
    }, (e) => console.warn("[board] favorites unavailable", e));
  }
  has(e) {
    return !!e && this.uuids.value.has(e);
  }
  /** A result can be starred by whoever ran it, once it's finished. */
  canStar(e) {
    return !!e.uuid && !!e.runId && e.status === "done" && e.userId === this.uid;
  }
  async set(e, t) {
    if (!this.canStar(e)) return;
    const i = this.fb.db.collection("resultFavorites").doc(this.uid + "_" + e.uuid), s = new Set(this.uuids.value);
    if (t ? s.add(e.uuid) : s.delete(e.uuid), this.uuids.value = s, os(this.uuids), !t) {
      await i.delete();
      return;
    }
    await i.set({
      createdAt: this.fb.FieldValue.serverTimestamp(),
      userId: this.uid,
      nodeRunId: e.runId,
      nodeRunResultUuid: e.uuid,
      nodeDefId: e.modelId || "",
      nodeId: e.sessionId,
      runnitId: this.boardId,
      resultType: e.video ? "VID" : e.kind === "3d" ? "ASSET_3D" : e.kind === "layers" ? "LAYERS" : "IMG"
    });
  }
  dispose() {
    this.unsub && this.unsub(), this.unsub = null;
  }
}
var cPe = Object.defineProperty, uPe = (n, e, t) => e in n ? cPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Oh = (n, e, t) => uPe(n, typeof e != "symbol" ? e + "" : e, t);
const zb = { models: "pinnedModelIds", sessions: "pinnedSessionIds" };
class hPe {
  constructor(e, t, i) {
    Oh(this, "fb", e), Oh(this, "uid", t), Oh(this, "boardId", i), Oh(this, "there", /* @__PURE__ */ new Map());
  }
  docId(e) {
    return e === "models" ? "global" : this.boardId;
  }
  ref(e) {
    return this.fb.db.doc("users/" + this.uid + "/boardPrefs/" + this.docId(e));
  }
  /**
   * A merge into the doc, naming its `_created` when this write makes it.
   * Before any snapshot has said whether it's there, a read does; when that
   * fails too, `_created` is left alone rather than reset.
   */
  async merge(e, t) {
    const i = this.docId(e);
    let s = this.there.get(i);
    s === void 0 && (s = await this.ref(e).get().then((o) => o.exists, () => !0)), this.there.set(i, !0);
    try {
      await this.ref(e).set(s ? t : { ...t, _created: this.fb.FieldValue.serverTimestamp() }, { merge: !0 });
    } catch (o) {
      throw s || this.there.delete(i), o;
    }
  }
  watch(e, t, i) {
    return this.ref(e).onSnapshot((s) => {
      this.there.set(this.docId(e), s.exists);
      const o = s.exists ? (s.data() || {})[zb[e]] : void 0;
      t(Array.isArray(o) ? o.filter((r) => typeof r == "string") : null);
    }, (s) => {
      console.warn("[board] your pins are kept in this browser only", s), i();
    });
  }
  pin(e, t, i) {
    const s = this.fb.FieldValue;
    return this.merge(e, { [zb[e]]: i ? s.arrayUnion(t) : s.arrayRemove(t) });
  }
  seed(e, t) {
    return this.merge(e, { [zb[e]]: t });
  }
  watchViews(e, t) {
    return this.ref("models").onSnapshot((i) => {
      this.there.set(this.docId("models"), i.exists);
      const s = i.exists ? (i.data() || {}).cameraViews : void 0;
      e(Array.isArray(s) ? s : null);
    }, (i) => {
      console.warn("[board] your camera views are kept in this browser only", i), t();
    });
  }
  saveViews(e) {
    return this.merge("models", { cameraViews: e });
  }
}
var pPe = Object.defineProperty, fPe = (n, e, t) => e in n ? pPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, $b = (n, e, t) => fPe(n, typeof e != "symbol" ? e + "" : e, t);
class mPe {
  constructor(e, t) {
    $b(this, "fb", e), $b(this, "uid", t), $b(this, "avatars", /* @__PURE__ */ new Map());
  }
  /** Newest first: yours, then the team's shared ones. */
  async list(e) {
    const t = this.fb.db.collection("models"), i = e ? [
      t.where("teamId", "==", e).where("accessLevel", "==", "PRIVATE").where("isDeleted", "==", !1).where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(1e3),
      t.where("teamId", "==", e).where("accessLevel", "==", "SHARED").where("isDeleted", "==", !1).orderBy("createdAt", "desc").limit(1e3)
    ] : [
      t.where("userId", "==", this.uid).where("teamId", "==", null).where("accessLevel", "==", "PRIVATE").where("isDeleted", "==", !1).orderBy("createdAt", "desc").limit(100)
    ], s = await Promise.all(i.map((a) => a.get())), o = [];
    return s.forEach((a, l) => a.docs.forEach((d) => o.push({ doc: d, shared: !!e && l === 1 }))), (await Promise.all(o.map(({ doc: a, shared: l }) => this.toModel(a, l)))).filter((a) => !!a);
  }
  async toModel(e, t) {
    const i = e.data();
    if (!i.file) return null;
    const s = i.avatarId ? await this.avatar(i.avatarId) : null, o = { ...i, id: e.id };
    s && (o.avatar = s);
    const r = s ? x8(s) : null, a = this.fb.storageUrl;
    return {
      id: e.id,
      name: i.name || "Untitled model",
      description: i.description || void 0,
      architecture: i.architecture || void 0,
      shared: t,
      thumb: r && a ? a(r.thumb) : void 0,
      image: r && a ? a(r.file) : void 0,
      record: o
    };
  }
  avatar(e) {
    let t = this.avatars.get(e);
    return t || (t = this.fb.db.doc("avatars/" + e).get().then((i) => i.exists ? { ...i.data(), id: e } : null).catch(() => null), this.avatars.set(e, t)), t;
  }
}
var gPe = Object.defineProperty, bPe = (n, e, t) => e in n ? gPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, G4 = (n, e, t) => bPe(n, typeof e != "symbol" ? e + "" : e, t);
function j4(n, e) {
  let t = typeof n[e] == "number" ? n[e] : 0;
  const i = e + "_delta_";
  for (const s of Object.keys(n))
    s.startsWith(i) && typeof n[s] == "number" && (t += n[s]);
  return t;
}
function vPe(n, e) {
  const t = j4(n, "runnitTokens"), i = n.type === "USER" && e ? j4(n, "freeRunnitTokens") : 0;
  return t + i;
}
class yPe {
  constructor(e, t) {
    G4(this, "fb", e), G4(this, "freemiumPassport", t);
  }
  /** Follow an account (a team id, or your uid); null while it can't be read. */
  watch(e, t) {
    return this.fb.db.doc("balanceAccounts/" + e).onSnapshot((i) => {
      if (!i.exists) {
        t(null);
        return;
      }
      const s = i.data() || {};
      t({ tokens: vPe(s, this.freemiumPassport), team: s.type === "TEAM" });
    }, (i) => {
      console.warn("[board] balance unavailable", i), t(null);
    });
  }
}
var xPe = Object.defineProperty, wPe = (n, e, t) => e in n ? xPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, kPe = (n, e, t) => wPe(n, e + "", t);
class _Pe {
  constructor(e) {
    kPe(this, "fb", e);
  }
  /** Follow a team: whether it's active (no isActive counts as not), or null while it can't be read. */
  watch(e, t) {
    return this.fb.db.doc("teams/" + e).onSnapshot((i) => {
      if (!i.exists) {
        t(null);
        return;
      }
      const s = i.data() || {};
      t(s.isActive === !0);
    }, (i) => {
      console.warn("[board] team status unavailable", i), t(null);
    });
  }
}
var SPe = Object.defineProperty, TPe = (n, e, t) => e in n ? SPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Lh = (n, e, t) => TPe(n, typeof e != "symbol" ? e + "" : e, t);
const MPe = 48, CPe = 1e3, Bh = 200;
function wd(n, e) {
  const t = new Error(n);
  return t.userMessage = n, t.cause = e, t;
}
class IPe {
  constructor(e, t, i = {}) {
    Lh(this, "fb", e), Lh(this, "uid", t), Lh(this, "features"), Lh(this, "api"), this.api = e.library || null, this.features = { search: !!this.api && !!i.isAdmin, filters: !!this.api, star: !0, remove: !0 };
  }
  url(e) {
    return this.fb.storageUrl ? this.fb.storageUrl(e) : "";
  }
  ctx() {
    return { uid: this.uid, storageUrl: (e) => this.url(e), modelName: () => "" };
  }
  /** Your finished generations, from any board, a page at a time; filtered or searched through the API. */
  async generations(e = {}) {
    if (this.api && (hI(e.filters) || Xf(e.search) || typeof e.cursor == "string")) return this.fromApi("generations", e);
    let t = this.fb.db.collection("runnitNodeRuns").where("deletedAt", "==", null).where("state", "==", "DONE").where("templateOriginalData", "==", null).where("userId", "==", this.uid).orderBy("initAt", "desc");
    typeof e.cursor == "number" && (t = t.startAfter(new Date(e.cursor)));
    const s = (await t.limit(Br).get()).docs.map((a) => Nr(a.id, a.data())), o = [];
    for (const a of s) o.push(...m0(a, this.ctx()));
    const r = s[s.length - 1];
    return { items: o, next: s.length === Br && r && r.initAt ? r.initAt : null };
  }
  /** Your uploads, newest first, a page at a time. */
  async uploads(e = {}) {
    let t = this.fb.db.collection("runnitUploads").where("deletedAt", "==", null).where("userId", "==", this.uid).orderBy("createdAt", "desc");
    typeof e.cursor == "number" && (t = t.startAfter(new Date(e.cursor)));
    const i = await t.limit(Br).get(), s = [];
    let o = null;
    for (const r of i.docs) {
      const a = { ...r.data(), id: r.id };
      if (o = hn(a.createdAt) || o, !a.name || a.type && a.type !== "IMG" && a.type !== "VID" && a.type !== "ASSET_3D") continue;
      const l = v1(a), d = a.type === "VID", c = a.type === "ASSET_3D", u = l.replace(/[^/]+$/, (p) => "thumbs/" + p.replace(/\.[^/.]+$/, "_512x512.webp"));
      s.push({
        id: "upload:" + r.id,
        // a video shows its first frame, as results do, and a 3D model its preview
        url: this.url(d || c ? u : l),
        thumb: this.url(u),
        w: a.width,
        h: a.height,
        video: d,
        videoSrc: d ? this.url(l) : void 0,
        label: a.name,
        createdAt: hn(a.createdAt),
        mine: a.userId === this.uid,
        uploadId: r.id,
        asset: { upload: a },
        model3d: c ? { url: this.url(l), ext: (/\.([a-z0-9]+)$/i.exec(a.name) || ["", "glb"])[1].toLowerCase() } : void 0
      });
    }
    return { items: s, next: i.docs.length === Br ? o : null };
  }
  /** What you've starred, most recently first: through the API (paged), or each favorite's run. */
  async favorites(e = {}) {
    if (this.api) return this.fromApi("favorites", e);
    const i = (await this.fb.db.collection("resultFavorites").where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(MPe).get()).docs.map((a) => a.data()).filter((a) => !!a.nodeRunId && !!a.nodeRunResultUuid), s = Array.from(new Set(i.map((a) => a.nodeRunId))), o = /* @__PURE__ */ new Map();
    await Promise.all(s.map(async (a) => {
      const l = await this.fb.db.doc("runnitNodeRuns/" + a).get().catch(() => null);
      l && l.exists && o.set(a, Nr(a, l.data() || {}));
    }));
    const r = [];
    for (const a of i) {
      const l = o.get(a.nodeRunId);
      if (!l) continue;
      const d = m0(l, this.ctx()).find((c) => c.id === l.id + ":" + a.nodeRunResultUuid);
      d && r.push({ ...d, fav: !0 });
    }
    return { items: r, next: null };
  }
  async fromApi(e, t) {
    const i = await this.api(O1e(e, t));
    if (!i.ok) throw wd(L1e(i), i);
    const s = B1e(i.page.data, i.page.nodeDefs || {}, this.ctx());
    if (e === "favorites") for (const o of s) o.fav = !0;
    return { items: s, next: i.page.hasMore ? i.page.nextCursor : null };
  }
  /** The results you've starred, as Library item ids (run:result), to mark them anywhere. */
  async favoriteKeys() {
    const e = await this.fb.db.collection("resultFavorites").where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(CPe).get(), t = [];
    for (const i of e.docs) {
      const s = i.data();
      s.nodeRunId && s.nodeRunResultUuid && t.push(s.nodeRunId + ":" + s.nodeRunResultUuid);
    }
    return t;
  }
  /**
   * What the filters pick from: the tools' Model family and Media tags, and
   * the boards you can read (v1's board reads, canvas boards too). Tools come
   * from the board's own catalog.
   */
  async filterOptions(e = null) {
    const [t, i] = await Promise.all([this.tags(), this.boards(e)]);
    return { tools: [], families: t.families, media: t.media, boards: i };
  }
  async tags() {
    try {
      const t = (await this.fb.db.collection("runnitNodeDefTags").where("isDeleted", "==", !1).get()).docs.map((s) => ({ id: s.id, ...s.data() })).sort((s, o) => (s.sortOrder || 0) - (o.sortOrder || 0) || (s.label || "").localeCompare(o.label || "")), i = (s) => t.filter((o) => o.type === s && o.label).map((o) => ({ value: o.id, text: o.label }));
      return { families: i("MODEL_FAMILY"), media: i("MEDIA") };
    } catch (e) {
      return console.warn("[board] the Library's tool tags are unavailable", e), { families: [], media: [] };
    }
  }
  /** v1's board reads (libraryBoards.ts), for v1's boards and canvas boards alike; deduped, by title. */
  async boards(e) {
    const t = () => this.fb.db.collection("runnits"), i = [];
    for (const o of ["WORKFLOW", "CANVAS"])
      i.push(t().where("userId", "==", this.uid).where("teamId", "==", null).where("deletedAt", "==", null).where("type", "==", o).orderBy("createdAt", "desc").limit(Bh)), e && (i.push(t().where("teamId", "==", e).where("accessLevel", "==", "PRIVATE").where("deletedAt", "==", null).where("type", "==", o).where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(Bh)), i.push(t().where("teamId", "==", e).where("accessLevel", "==", "RESTRICTED").where("deletedAt", "==", null).where("type", "==", o).where(`userIds.${this.uid}`, "==", !0).limit(Bh)), i.push(t().where("teamId", "==", e).where("accessLevel", "==", "SHARED").where("deletedAt", "==", null).where("type", "==", o).orderBy("createdAt", "desc").limit(Bh)));
    const s = /* @__PURE__ */ new Map();
    return await Promise.all(i.map(async (o) => {
      try {
        const r = await o.get();
        for (const a of r.docs)
          s.has(a.id) || s.set(a.id, { value: a.id, text: a.data().title || "Untitled board" });
      } catch (r) {
        console.warn("[board] a board list for the Library is unavailable", r);
      }
    })), Array.from(s.values()).sort((o, r) => o.text.localeCompare(r.text));
  }
  /** Star or unstar one of your finished generations (resultFavorites/{uid}_{result}, as v1 writes it). */
  async setFavorite(e, t) {
    if (!e.run || !e.mine || e.moderated) throw wd("Only your own generations can be starred");
    const i = this.fb.db.collection("resultFavorites").doc(this.uid + "_" + e.run.uuid);
    try {
      if (!t) {
        await i.delete();
        return;
      }
      await i.set({
        createdAt: this.fb.FieldValue.serverTimestamp(),
        userId: this.uid,
        nodeRunId: e.run.id,
        nodeRunResultUuid: e.run.uuid,
        nodeDefId: e.run.nodeDefId || null,
        nodeId: e.run.nodeId || null,
        runnitId: e.run.runnitId || null,
        resultType: e.run.type || (e.video ? "VID" : "IMG")
      });
    } catch (s) {
      throw wd(t ? "Could not favorite it, please try again" : "Could not unfavorite it, please try again", s);
    }
  }
  /** Delete one of your generations or uploads (stamped, as v1 deletes them). */
  async remove(e) {
    if (!e.mine) throw wd("Only your own pictures can be deleted");
    try {
      if (e.uploadId) {
        await this.fb.db.collection("runnitUploads").doc(e.uploadId).update({ deletedAt: /* @__PURE__ */ new Date(), deletedByUserId: this.uid });
        return;
      }
      if (!e.run) return;
      const t = e.run.id, i = e.run.uuid, s = this.fb.db.collection("runnitNodeRuns").doc(t);
      await this.fb.db.runTransaction(async (o) => {
        const r = await o.get(s);
        if (!r.exists) return;
        const a = (r.data() || {}).results || [], l = /* @__PURE__ */ new Date(), d = a.map((u) => u.uuid === i && !u.deletedAt ? { ...u, deletedAt: l, deletedByUserId: this.uid } : u), c = d.every((u) => !!u.deletedAt);
        o.update(s, { results: d, ...c ? { deletedAt: l, deletedByUserId: this.uid } : {} });
      });
    } catch (t) {
      throw wd("Issues deleting image, please try again", t);
    }
  }
}
var APe = Object.defineProperty, PPe = (n, e, t) => e in n ? APe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, H4 = (n, e, t) => PPe(n, typeof e != "symbol" ? e + "" : e, t);
function EPe(n, e = Date.now()) {
  const t = typeof n == "string" ? Date.parse(n) : typeof n == "number" ? n : NaN;
  if (!Number.isFinite(t)) return "";
  const i = new Date(t), s = i.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).toLowerCase();
  return i.toDateString() === new Date(e).toDateString() ? s : s + " on " + i.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
function RPe(n) {
  if (!n) return "The run couldn't start. Please try again.";
  if (n.message === "TOKEN_COOLDOWN_ACTIVE") {
    const e = EPe(n.resetAt);
    return "The spending limit for runs here has been reached for now. It resets " + (e ? "at " + e : "soon") + "; ask an admin if you need more.";
  }
  return n.message ? n.message : "The run couldn't start. Please try again.";
}
function zPe(n) {
  const e = n && typeof n == "object" && "code" in n ? String(n.code) : "";
  return e.endsWith("deadline-exceeded") ? "The run took too long to start. Please try again." : e.endsWith("unavailable") ? "The run couldn't start. Check your connection and try again." : "The run couldn't start. Please try again.";
}
class $Pe {
  constructor(e, t) {
    H4(this, "fb", e), H4(this, "drafts", t);
  }
  run(e, t) {
    let i = !1;
    const s = { runId: "", pending: [], cancel: () => {
      i = !0;
    } }, o = e.v1Inputs || {};
    return (async () => {
      let r;
      try {
        r = await this.drafts.prepare(e.sessionId, e.model.id, o, e.count, e.restore || null);
      } catch (c) {
        console.error("[board] run draft not written", c), i || t.onError("The run couldn't start: your prompt wasn't saved. Please try again.", []);
        return;
      }
      let a = null, l = !1, d = null;
      try {
        const u = await this.fb.functions.httpsCallable("runRunnitNode")({
          nodeRunId: r,
          nodeDefId: e.model.id,
          inputValues: o,
          staticInputValues: { numResults: e.count }
        });
        a = u && u.data || null;
      } catch (c) {
        l = !0, d = c;
      }
      if (l) {
        if (console.error("[board] runRunnitNode failed", d), !await this.ranAnyway(r)) {
          this.drafts.release(r), i || t.onError(zPe(d), []);
          return;
        }
      } else if (!a || !a.success) {
        this.drafts.release(r), i || t.onError(RPe(a), []);
        return;
      }
      this.drafts.markConsumed(r), s.runId = r, !i && t.onStarted && t.onStarted(r);
    })(), s;
  }
  /** Whether a run whose call failed went through all the same; no, when nobody can say. */
  async ranAnyway(e) {
    try {
      return !!await _A(this.fb, e, !0);
    } catch {
      return !1;
    }
  }
}
var DPe = Object.defineProperty, OPe = (n, e, t) => e in n ? DPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, V4 = (n, e, t) => OPe(n, typeof e != "symbol" ? e + "" : e, t);
const LPe = "featuredPrompts";
class BPe {
  constructor(e) {
    V4(this, "fb", e), V4(this, "pending", null);
  }
  load() {
    if (!this.pending) {
      const e = this.fb.db.collection(LPe).doc("current").get().then(
        (t) => t.exists ? Aj(t.data()) : null,
        // rules that don't know the collection yet (not deployed) refuse the read:
        // that's no set published, not a connection to try again
        (t) => {
          if (t && t.code === "permission-denied") return null;
          throw t;
        }
      );
      e.catch(() => {
        this.pending === e && (this.pending = null);
      }), this.pending = e;
    }
    return this.pending;
  }
}
const W4 = /* @__PURE__ */ new WeakMap();
function FPe(n) {
  let e = W4.get(n);
  return e || (e = new BPe(n), W4.set(n, e)), e;
}
var NPe = Object.defineProperty, UPe = (n, e, t) => e in n ? NPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Fh = (n, e, t) => UPe(n, typeof e != "symbol" ? e + "" : e, t);
const kd = "libraryPrompts";
function q4(n) {
  return JSON.parse(JSON.stringify(n));
}
class GPe {
  constructor(e, t = e.api || null, i) {
    Fh(this, "fb", e), Fh(this, "api", t), Fh(this, "fetchImpl", i), Fh(this, "teams", /* @__PURE__ */ new Map());
  }
  async list(e) {
    const t = this.api;
    if (!t) return { ok: !1, reason: "failed", message: "The web app's API isn't available here" };
    let i;
    try {
      i = await t.credentials();
    } catch (o) {
      return console.warn("[board] my prompts: no API credentials", o), { ok: !1, reason: "failed" };
    }
    if (!i) return { ok: !1, reason: "unauthorized" };
    const s = await Lee(t.baseUrl, i, e, this.fetchImpl);
    return !s.ok && s.code && t.onRejected && t.onRejected(s.code), s;
  }
  follow(e, t, i) {
    return this.fb.db.collection(kd).doc(e).onSnapshot(
      // a save of yours shows at once, its server times estimated until they land
      (s) => t(s.exists ? Nj(s.id, s.data({ serverTimestamps: "estimate" })) : null),
      (s) => {
        i && i(s);
      }
    );
  }
  async save(e, t) {
    const i = this.fb.FieldValue.serverTimestamp();
    return (await this.fb.db.collection(kd).add({ ...q4(e), v: 1, authorId: t.uid, authorName: t.name, createdAt: i, updatedAt: i, deletedAt: null })).id;
  }
  async update(e, t) {
    await this.fb.db.collection(kd).doc(e).update({ ...q4(t), updatedAt: this.fb.FieldValue.serverTimestamp() });
  }
  async remove(e) {
    await this.fb.db.collection(kd).doc(e).update({ deletedAt: this.fb.FieldValue.serverTimestamp() });
  }
  async restore(e) {
    await this.fb.db.collection(kd).doc(e).update({ deletedAt: null });
  }
  teamName(e) {
    let t = this.teams.get(e);
    return t || (t = this.fb.db.collection("teams").doc(e).get().then((i) => {
      const s = i.exists ? i.data() : void 0;
      return s && typeof s.name == "string" ? s.name : null;
    }).catch(() => null), this.teams.set(e, t)), t;
  }
}
const K4 = /* @__PURE__ */ new WeakMap();
function jPe(n) {
  let e = K4.get(n);
  return e || (e = new GPe(n), K4.set(n, e)), e;
}
var HPe = Object.defineProperty, VPe = (n, e, t) => e in n ? HPe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, _d = (n, e, t) => VPe(n, typeof e != "symbol" ? e + "" : e, t);
const WPe = 24 * 3600 * 1e3, Nh = 450;
function Qt(n, e = "") {
  return typeof n == "string" ? n : e;
}
function fp(n) {
  return Array.isArray(n) ? n.filter((e) => typeof e == "string") : [];
}
function Sd(n, e = 0) {
  return typeof n == "number" && Number.isFinite(n) ? n : e;
}
function qPe(n) {
  if (!n || typeof n != "object") return null;
  const e = n;
  return { by: Qt(e.by), byName: Qt(e.byName), text: Qt(e.text) };
}
function Y4(n, e) {
  var t, i;
  const s = {};
  if (e.readBy && typeof e.readBy == "object")
    for (const [r, a] of Object.entries(e.readBy)) {
      const l = hn(a);
      l != null && (s[r] = l);
    }
  const o = hn(e.createdAt) || Date.now();
  return {
    id: n,
    boardId: Qt(e.boardId),
    teamId: typeof e.teamId == "string" ? e.teamId : null,
    createdBy: Qt(e.createdBy),
    createdByName: Qt(e.createdByName),
    createdByEmail: Qt(e.createdByEmail),
    createdAt: o,
    x: Sd(e.x),
    y: Sd(e.y),
    elementId: typeof e.elementId == "string" ? e.elementId : null,
    ex: Sd(e.ex),
    ey: Sd(e.ey),
    anchorLabel: Qt(e.anchorLabel),
    anchorThumb: typeof e.anchorThumb == "string" ? e.anchorThumb : null,
    color: p2e(e.color) ? e.color : "amethyst",
    resolvedAt: (t = hn(e.resolvedAt)) != null ? t : null,
    resolvedBy: typeof e.resolvedBy == "string" ? e.resolvedBy : null,
    followers: fp(e.followers),
    readBy: s,
    markedUnread: fp(e.markedUnread),
    pinnedBy: fp(e.pinnedBy),
    lastAt: hn(e.lastAt) || o,
    lastBy: Qt(e.lastBy),
    count: Sd(e.count, 1),
    preview: qPe(e.preview),
    boardTitle: Qt(e.boardTitle),
    deletedAt: (i = hn(e.deletedAt)) != null ? i : null,
    deletedBy: typeof e.deletedBy == "string" ? e.deletedBy : null
  };
}
function X4(n, e) {
  var t;
  const i = [];
  if (Array.isArray(e.mentions))
    for (const o of e.mentions)
      o && typeof o == "object" && typeof o.uid == "string" && i.push({ uid: o.uid, name: Qt(o.name) });
  const s = {};
  if (e.reactions && typeof e.reactions == "object")
    for (const [o, r] of Object.entries(e.reactions)) {
      const a = fp(r);
      a.length && (s[o] = a);
    }
  return {
    id: n,
    threadId: Qt(e.threadId),
    boardId: Qt(e.boardId),
    authorId: Qt(e.authorId),
    authorName: Qt(e.authorName),
    authorEmail: Qt(e.authorEmail),
    text: Qt(e.text),
    mentions: i,
    createdAt: hn(e.createdAt) || Date.now(),
    editedAt: (t = hn(e.editedAt)) != null ? t : null,
    reactions: s
  };
}
const Uh = (n) => n.data({ serverTimestamps: "estimate" }) || {}, J4 = 60, Z4 = 480;
class KPe {
  constructor(e, t, i, s) {
    _d(this, "fb", e), _d(this, "user", t), _d(this, "boardId", i), _d(this, "board", s), _d(this, "unsubs", []);
  }
  get runnit() {
    return this.fb.db.collection("runnits").doc(this.boardId);
  }
  threadRef(e, t = this.boardId) {
    return this.fb.db.collection("runnits").doc(t).collection("runnitCanvasThreads").doc(e);
  }
  commentRef(e) {
    return this.runnit.collection("runnitCanvasComments").doc(e);
  }
  watchBoard(e) {
    const t = this.runnit.collection("runnitCanvasThreads").onSnapshot((o) => {
      const r = [], a = [];
      for (const l of o.docChanges())
        l.type === "removed" ? a.push(l.doc.id) : r.push(Y4(l.doc.id, Uh(l.doc)));
      (r.length || a.length || !o.docChanges().length) && e.threads(r, a);
    }, (o) => e.error(o)), i = this.runnit.collection("runnitCanvasComments").onSnapshot((o) => {
      const r = [], a = [];
      for (const l of o.docChanges())
        l.type === "removed" ? a.push(l.doc.id) : r.push(X4(l.doc.id, Uh(l.doc)));
      (r.length || a.length) && e.comments(r, a);
    }, (o) => e.error(o)), s = () => {
      t(), i();
    };
    return this.unsubs.push(s), s;
  }
  watchFollowed(e, t) {
    let i = J4, s = () => {
    }, o = !1;
    const r = () => {
      s(), s = this.fb.db.collectionGroup("runnitCanvasThreads").where("followers", "array-contains", this.user.uid).orderBy("lastAt", "desc").limit(i).onSnapshot((l) => {
        if (o) return;
        const d = l.docs.map((u) => Y4(u.id, Uh(u))).filter((u) => !!u.boardId);
        if (d.filter((u) => !u.deletedAt).length < J4 && l.docs.length >= i && i < Z4) {
          i = Math.min(Z4, i * 2), r();
          return;
        }
        e(d);
      }, (l) => t(l));
    };
    r();
    const a = () => {
      o = !0, s();
    };
    return this.unsubs.push(a), a;
  }
  async people() {
    const e = this.board(), t = { uid: this.user.uid, name: this.user.name || oc(this.user.email), email: this.user.email };
    if (!e.teamId) return { people: [t], scope: "personal" };
    const i = /* @__PURE__ */ new Map();
    try {
      const l = await this.runnit.collection("runnitCanvasPeople").limit(500).get();
      for (const d of l.docs) {
        const c = d.data();
        i.set(d.id, { uid: d.id, name: Qt(c.name), email: Qt(c.email) });
      }
    } catch (l) {
      console.warn("[board] comments: the board's people couldn't be read", l);
    }
    const s = e.accessLevel || "PRIVATE";
    let o = null;
    if (s === "PRIVATE" && (o = /* @__PURE__ */ new Set([e.ownerId])), s === "RESTRICTED") {
      o = /* @__PURE__ */ new Set([e.ownerId]);
      try {
        const d = ((await this.runnit.get()).data() || {}).userIds;
        if (d && typeof d == "object")
          for (const [c, u] of Object.entries(d)) u && o.add(c);
      } catch (l) {
        console.warn("[board] comments: the board's access couldn't be read", l);
      }
    }
    const r = /* @__PURE__ */ new Map();
    r.set(t.uid, t);
    try {
      const l = await this.fb.db.collection("teams").doc(e.teamId).collection("teamMembers").where("isAccepted", "==", !0).limit(500).get();
      for (const d of l.docs) {
        const c = d.data(), u = Qt(c.userId), p = Qt(c.email, d.id);
        if (!u || r.has(u) || o && !o.has(u)) continue;
        const f = i.get(u);
        r.set(u, { uid: u, email: p, name: f && f.name || oc(p) });
      }
    } catch (l) {
      console.warn("[board] comments: the team's members couldn't be read", l);
      for (const d of i.values()) !r.has(d.uid) && (!o || o.has(d.uid)) && r.set(d.uid, d);
    }
    const a = s === "SHARED" ? "team" : s === "RESTRICTED" ? "restricted" : "private";
    return { people: Array.from(r.values()), scope: a };
  }
  async checkIn() {
    const e = this.runnit.collection("runnitCanvasPeople").doc(this.user.uid), t = this.fb.FieldValue, i = this.user.name || oc(this.user.email);
    let s = await e.get();
    if (!s.exists)
      try {
        return await e.set({ uid: this.user.uid, name: i, email: this.user.email, firstSeenAt: t.serverTimestamp(), seenAt: t.serverTimestamp() }), Date.now();
      } catch (a) {
        if (s = await e.get(), !s.exists) throw a;
      }
    const o = s.data() || {}, r = hn(o.seenAt) || 0;
    return (Qt(o.name) !== i || Qt(o.email) !== this.user.email || Date.now() - r > WPe) && e.update({ name: i, email: this.user.email, seenAt: t.serverTimestamp() }).catch((a) => console.warn("[board] comments: check-in not saved", a)), hn(o.firstSeenAt) || null;
  }
  async createThread(e, t) {
    const s = this.fb.FieldValue.serverTimestamp(), o = this.fb.db.batch();
    o.set(this.threadRef(e.id), {
      v: 1,
      boardId: e.boardId,
      teamId: e.teamId,
      createdBy: e.createdBy,
      createdByName: e.createdByName,
      createdByEmail: e.createdByEmail,
      createdAt: s,
      x: e.x,
      y: e.y,
      elementId: e.elementId,
      ex: e.ex,
      ey: e.ey,
      anchorLabel: e.anchorLabel.slice(0, 120),
      anchorThumb: e.anchorThumb && e.anchorThumb.length <= 1e3 ? e.anchorThumb : null,
      color: e.color,
      resolvedAt: null,
      resolvedBy: null,
      followers: e.followers,
      readBy: { [this.user.uid]: s },
      markedUnread: [],
      pinnedBy: [],
      lastAt: s,
      lastBy: e.lastBy,
      count: 1,
      preview: e.preview,
      boardTitle: e.boardTitle.slice(0, 200)
    }), o.set(this.commentRef(t.id), this.commentDoc(t)), await o.commit();
  }
  commentDoc(e) {
    return {
      v: 1,
      threadId: e.threadId,
      boardId: e.boardId,
      authorId: e.authorId,
      authorName: e.authorName,
      authorEmail: e.authorEmail,
      text: e.text,
      mentions: e.mentions.map((t) => ({ uid: t.uid, name: t.name })),
      createdAt: this.fb.FieldValue.serverTimestamp(),
      editedAt: null,
      reactions: {}
    };
  }
  async reply(e, t, i) {
    const s = this.fb.FieldValue, o = this.fb.db.batch();
    o.set(this.commentRef(t.id), this.commentDoc(t));
    const r = {
      lastAt: s.serverTimestamp(),
      lastBy: this.user.uid,
      count: s.increment(1),
      preview: { by: t.authorId, byName: t.authorName, text: t.text.replace(/\s+/g, " ").trim().slice(0, 280) },
      followers: s.arrayUnion(this.user.uid, ...i),
      ["readBy." + this.user.uid]: s.serverTimestamp(),
      markedUnread: s.arrayRemove(this.user.uid)
    };
    e.resolvedAt && (r.resolvedAt = null, r.resolvedBy = null), o.update(this.threadRef(e.id), r), await o.commit();
  }
  async editComment(e, t, i) {
    const s = this.fb.FieldValue, o = this.fb.db.batch();
    o.update(this.commentRef(e.id), { text: e.text, mentions: e.mentions.map((a) => ({ uid: a.uid, name: a.name })), editedAt: s.serverTimestamp() });
    const r = {};
    t && (r.preview = t), i.length && (r.followers = s.arrayUnion(...i)), Object.keys(r).length && o.update(this.threadRef(e.threadId), r), await o.commit();
  }
  async deleteComment(e, t, i) {
    const s = this.fb.db.batch();
    s.delete(this.commentRef(e.id)), s.update(this.threadRef(e.threadId), { count: Math.max(1, t), preview: i }), await s.commit();
  }
  async deleteThread(e, t) {
    const i = t.slice();
    for (; i.length > Nh; ) {
      const o = this.fb.db.batch();
      for (const r of i.splice(0, Nh)) o.delete(this.commentRef(r));
      await o.commit();
    }
    const s = this.fb.db.batch();
    for (const o of i) s.delete(this.commentRef(o));
    s.delete(this.threadRef(e)), await s.commit();
  }
  async markDeleted(e) {
    await this.threadRef(e).update({ deletedAt: this.fb.FieldValue.serverTimestamp(), deletedBy: this.user.uid });
  }
  async react(e, t, i) {
    const s = this.fb.FieldValue;
    await this.commentRef(e.id).update({ ["reactions." + this.user.uid]: i ? s.arrayUnion(t) : s.arrayRemove(t) });
  }
  async resolve(e, t) {
    const i = this.fb.FieldValue;
    await this.threadRef(e).update(t ? { resolvedAt: i.serverTimestamp(), resolvedBy: this.user.uid } : { resolvedAt: null, resolvedBy: null });
  }
  async setColor(e, t) {
    await this.threadRef(e).update({ color: t });
  }
  async move(e, t) {
    await this.threadRef(e).update({
      x: t.x,
      y: t.y,
      elementId: t.elementId,
      ex: t.ex,
      ey: t.ey,
      anchorLabel: t.label.slice(0, 120),
      anchorThumb: t.thumb && t.thumb.length <= 1e3 ? t.thumb : null
    });
  }
  async follow(e, t, i) {
    const s = this.fb.FieldValue;
    await this.threadRef(e, i).update({ followers: t ? s.arrayUnion(this.user.uid) : s.arrayRemove(this.user.uid) });
  }
  async pin(e, t) {
    const i = this.fb.FieldValue;
    await this.threadRef(e).update({ pinnedBy: t ? i.arrayUnion(this.user.uid) : i.arrayRemove(this.user.uid) });
  }
  async markRead(e) {
    const t = this.fb.FieldValue, i = /* @__PURE__ */ new Map();
    for (const s of e) {
      const o = s.boardId || this.boardId;
      i.set(o, [...i.get(o) || [], s.id]);
    }
    await Promise.all(Array.from(i.entries()).map(async ([s, o]) => {
      for (let r = 0; r < o.length; r += Nh) {
        const a = this.fb.db.batch();
        for (const l of o.slice(r, r + Nh))
          a.update(this.threadRef(l, s), { ["readBy." + this.user.uid]: t.serverTimestamp(), markedUnread: t.arrayRemove(this.user.uid) });
        await a.commit();
      }
    }));
  }
  async markUnread(e, t) {
    await this.threadRef(e, t).update({ markedUnread: this.fb.FieldValue.arrayUnion(this.user.uid) });
  }
  async threadComments(e, t) {
    return (await this.fb.db.collection("runnits").doc(e).collection("runnitCanvasComments").where("threadId", "==", t).limit(300).get()).docs.map((s) => X4(s.id, Uh(s))).sort((s, o) => s.createdAt - o.createdAt);
  }
  async boardTitles(e) {
    const t = {};
    return await Promise.all(e.map(async (i) => {
      try {
        const s = await this.fb.db.collection("runnits").doc(i).get(), o = s.exists ? s.data() || {} : null;
        t[i] = !o || o.deletedAt ? null : typeof o.title == "string" && o.title ? o.title : "Untitled board";
      } catch (s) {
        Po(s) === "permission-denied" && (t[i] = null);
      }
    })), t;
  }
  dispose() {
    for (const e of this.unsubs) e();
    this.unsubs = [];
  }
}
function SA(n) {
  return async (e, t) => {
    const s = await n.functions.httpsCallable("saveAnnotatedImage", { timeout: 25e4 })({ source: e, overlayPngBase64: t }), o = s && s.data || null;
    if (!o || !o.upload)
      throw new Error(o && o.error && o.error.message || "Your marks couldn't be added to the picture. Please try again.");
    const { createdAtMs: r, ...a } = o.upload;
    return { ...a, createdAt: typeof r == "number" ? new Date(r) : /* @__PURE__ */ new Date() };
  };
}
function YPe(n, e, t, i = {}) {
  const s = new rPe(n, e.uid, t);
  return {
    runs: new ePe(n, t),
    prompts: s,
    favorites: new dPe(n, e.uid, t),
    pins: new hPe(n, e.uid, t),
    models: new mPe(n, e.uid),
    balance: new yPe(n, !!e.freemiumPassport),
    teamStatus: new _Pe(n),
    library: new IPe(n, e.uid, { isAdmin: e.isAdmin }),
    companyTools: (o) => oC(n, o, e, { isBlocked: i.isBlocked }),
    gen: new $Pe(n, s),
    annotate: SA(n),
    featured: FPe(n),
    myPrompts: jPe(n)
  };
}
function XPe(n, e, t, i) {
  return new KPe(n, e, t, i);
}
async function JPe(n, e, t) {
  if (n.upload) return n.upload(t);
  const i = (t.name.split(".").pop() || "png").toLowerCase().replace(/[^a-z0-9]/g, "") || "png", s = n.storage.ref("runnitUploads/users/" + e.uid + "/uploads/board-" + kt() + "." + i);
  return await s.put(t, { contentType: t.type || "image/png" }), { url: await s.getDownloadURL() };
}
const Xy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RunnitCanvasDirectory: KAe,
  annotateWith: SA,
  boardServices: YPe,
  commentStore: XPe,
  loadCompanyTools: oC,
  loadToolCatalog: QQ,
  uploadFile: JPe
}, Symbol.toStringTag, { value: "Module" }));
export {
  tEe as createCanvasBoard,
  nEe as createDemoBoard,
  GAe as mountBoard,
  eEe as mountOnboarding,
  iEe as mountStressBoard
};
